webpackJsonp([1],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _cookie = __webpack_require__(651);
	
	var _cookie2 = _interopRequireDefault(_cookie);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _iso = __webpack_require__(713);
	
	var _iso2 = _interopRequireDefault(_iso);
	
	var _lodash = __webpack_require__(16);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactIntl = __webpack_require__(3);
	
	var _en = __webpack_require__(3051);
	
	var _en2 = _interopRequireDefault(_en);
	
	var _es = __webpack_require__(3052);
	
	var _es2 = _interopRequireDefault(_es);
	
	var _fr = __webpack_require__(3054);
	
	var _fr2 = _interopRequireDefault(_fr);
	
	var _ja = __webpack_require__(3055);
	
	var _ja2 = _interopRequireDefault(_ja);
	
	var _ru = __webpack_require__(3056);
	
	var _ru2 = _interopRequireDefault(_ru);
	
	var _zh = __webpack_require__(3058);
	
	var _zh2 = _interopRequireDefault(_zh);
	
	var _fil = __webpack_require__(3053);
	
	var _fil2 = _interopRequireDefault(_fil);
	
	var _vi = __webpack_require__(3057);
	
	var _vi2 = _interopRequireDefault(_vi);
	
	var _reactRedux = __webpack_require__(14);
	
	var _reactRouter = __webpack_require__(17);
	
	var _redux = __webpack_require__(18);
	
	var _reduxImmutablejs = __webpack_require__(168);
	
	var _reduxObservable = __webpack_require__(3130);
	
	var _reduxThunk = __webpack_require__(3131);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _superagent = __webpack_require__(270);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _when = __webpack_require__(271);
	
	var _when2 = _interopRequireDefault(_when);
	
	var _node = __webpack_require__(3473);
	
	var _node2 = _interopRequireDefault(_node);
	
	var _AppActions = __webpack_require__(377);
	
	var _AppActions2 = _interopRequireDefault(_AppActions);
	
	var _ApiClient = __webpack_require__(1598);
	
	var _ApiClient2 = _interopRequireDefault(_ApiClient);
	
	var _airbrakeMiddleware = __webpack_require__(2163);
	
	var _airbrakeMiddleware2 = _interopRequireDefault(_airbrakeMiddleware);
	
	var _apiRequestMiddleware = __webpack_require__(2165);
	
	var _apiRequestMiddleware2 = _interopRequireDefault(_apiRequestMiddleware);
	
	var _authMiddleware = __webpack_require__(2166);
	
	var _authMiddleware2 = _interopRequireDefault(_authMiddleware);
	
	var _redirectMiddleware = __webpack_require__(2168);
	
	var _redirectMiddleware2 = _interopRequireDefault(_redirectMiddleware);
	
	var _transitionMiddleware = __webpack_require__(2169);
	
	var _transitionMiddleware2 = _interopRequireDefault(_transitionMiddleware);
	
	var _gaMiddleware = __webpack_require__(2167);
	
	var _gaMiddleware2 = _interopRequireDefault(_gaMiddleware);
	
	var _analyticsMiddleware = __webpack_require__(2164);
	
	var _analyticsMiddleware2 = _interopRequireDefault(_analyticsMiddleware);
	
	var _Routes = __webpack_require__(2170);
	
	var _Routes2 = _interopRequireDefault(_Routes);
	
	var _utilsConsole = __webpack_require__(1561);
	
	var _utilsConsole2 = _interopRequireDefault(_utilsConsole);
	
	var _utilsAirbrake = __webpack_require__(1560);
	
	var _utilsAirbrake2 = _interopRequireDefault(_utilsAirbrake);
	
	var _utilsRouting = __webpack_require__(1567);
	
	var _utilsRouting2 = _interopRequireDefault(_utilsRouting);
	
	var _utilsGoogleAnalytics = __webpack_require__(231);
	
	var _utilsGoogleAnalytics2 = _interopRequireDefault(_utilsGoogleAnalytics);
	
	var _ErrorActions = __webpack_require__(1579);
	
	var _ErrorActions2 = _interopRequireDefault(_ErrorActions);
	
	var _LibrarySelector = __webpack_require__(33);
	
	var _AuthSelector = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /* eslint-disable import/first */
	/* eslint-disable global-require */
	
	
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(104);
	var ReactDOMServer = __webpack_require__(3048);
	var Helmet = __webpack_require__(899);
	
	if (!global.Intl) global.Intl = __webpack_require__(2810);
	
	var BOOTSTRAP_DATA_WHITE_LIST = ['airbrakeConfig', 'apiGatewayURLForClient', 'discloseErrors', 'enableReduxDevTools', 'gaTrackingId', 'gtmContainerId', 'gtmContainerAuth', 'gtmContainerPreview', 'head', 'libraryDomain', 'reduxStoreData', 'routeName'];
	
	var whitelist = function whitelist(obj) {
	  return _lodash2.default.pick.apply(_lodash2.default, [obj].concat(BOOTSTRAP_DATA_WHITE_LIST));
	};
	
	/**
	 * @param  {object} initialState - initial state (@see redux.createStore(), second argument)
	 * @param  {object} apiClient - we inject the httpClient for easier mocking
	 *                            plus easily changing http library on client and server.
	 *                            (note - this will change with webpack build)
	 * @param  {boolean} enableWebpackHMR - whether to enable hot module reloading (@see config)
	 *
	 * @return {object} - redux stored with all the initial data loaded
	 */
	function createReduxStore(initialState, apiClient) {
	  var enableWebpackHMR = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	  var enableReduxDevTools = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	  var errorService = arguments[4];
	
	  var rootEpic = function rootEpic() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _reduxObservable.combineEpics.apply(undefined, _toConsumableArray(_lodash2.default.values(__webpack_require__(640)))).apply(undefined, args.concat([apiClient]));
	  };
	  var epicMiddleware = (0, _reduxObservable.createEpicMiddleware)(rootEpic);
	  var middleware = [_authMiddleware2.default, (0, _apiRequestMiddleware2.default)(apiClient), epicMiddleware, _redirectMiddleware2.default, _reduxThunk2.default.withExtraArgument(apiClient), _transitionMiddleware2.default, (0, _airbrakeMiddleware2.default)(errorService), (0, _gaMiddleware2.default)(_utilsGoogleAnalytics2.default), (0, _analyticsMiddleware2.default)()];
	  var combinedReducers = (0, _reduxImmutablejs.combineReducers)(__webpack_require__(644).default);
	  var lastCreatedStore = (0, _redux.createStore)(combinedReducers, initialState, (0, _redux.compose)(_redux.applyMiddleware.apply(undefined, _toConsumableArray(_lodash2.default.compact(middleware))), enableReduxDevTools && window.devToolsExtension ? window.devToolsExtension() : function (f) {
	    return f;
	  }));
	
	  if (enableWebpackHMR && module.hot) {
	    module.hot.accept('./reducers', function () {
	      combinedReducers = (0, _reduxImmutablejs.combineReducers)(__webpack_require__(644).default);
	      rootEpic = _reduxObservable.combineEpics.apply(undefined, _toConsumableArray(_lodash2.default.values(__webpack_require__(640))));
	      lastCreatedStore.replaceReducer(combinedReducers);
	      epicMiddleware.replaceEpic(rootEpic);
	    });
	  }
	
	  return lastCreatedStore;
	}
	
	/**
	 * Initializes a handler for uncaught errors (browser only).
	 * @private
	 * @param {object}  isoState - The deserialized iso-state object
	 * @param {boolean} isoState.discloseErrors
	 * @param {object}  isoState.airbrakeConfig
	 */
	function clientHandleErrors(errorService, reduxStore) {
	  global.onerror = function (message, fileName, lineNumber, columnNumber, error) {
	    var err = error || { error: { message: message, fileName: fileName, lineNumber: lineNumber, columnNumber: columnNumber } };
	    errorService.notify(err).catch(function (e) {
	      return console.error(e);
	    }) // eslint-disable-line no-console
	    .then(function (notice) {
	      reduxStore.dispatch(_ErrorActions2.default.storeInternalError(notice));
	    }); // eslint-disable-line no-console
	  };
	}
	
	/**
	 * Renders React on client. This needs to be called first time when React gets mounted on browser.
	 *
	 * @return {undefined}
	 */
	function renderOnClient() {
	  function logPageView() {
	    _utilsGoogleAnalytics2.default.pageView('' + window.location.pathname + window.location.search);
	  }
	
	  var rootElement = document.getElementById('react_root');
	
	  _iso2.default.bootstrap(function (clientHydrationData) {
	    // Note: isoState comes from <div class="___iso-state___"> in index.html.
	    // See iso.add() and BOOTSTRAP_DATA_WHITE_LIST.
	    var apiGatewayURLForClient = clientHydrationData.apiGatewayURLForClient,
	        enableWebpackHMR = clientHydrationData.enableWebpackHMR,
	        libraryDomain = clientHydrationData.libraryDomain,
	        reduxStoreData = clientHydrationData.reduxStoreData,
	        enableReduxDevTools = clientHydrationData.enableReduxDevTools,
	        gaTrackingId = clientHydrationData.gaTrackingId,
	        airbrakeConfig = clientHydrationData.airbrakeConfig;
	
	
	    var errorService = airbrakeConfig.enabled ? new _utilsAirbrake2.default(airbrakeConfig) : new _utilsConsole2.default();
	
	    var apiClient = new _ApiClient2.default(libraryDomain, apiGatewayURLForClient, _superagent2.default);
	    var reduxStore = createReduxStore(_immutable2.default.fromJS(reduxStoreData), apiClient, enableWebpackHMR, enableReduxDevTools, errorService);
	
	    clientHandleErrors(errorService, reduxStore);
	
	    reduxStore.dispatch(_AppActions2.default.fetchCookies());
	
	    (0, _reactIntl.addLocaleData)([].concat(_toConsumableArray(_en2.default), _toConsumableArray(_fr2.default), _toConsumableArray(_es2.default), _toConsumableArray(_ja2.default), _toConsumableArray(_ru2.default), _toConsumableArray(_zh2.default), _toConsumableArray(_fil2.default), _toConsumableArray(_vi2.default)));
	
	    // Creates and initialize GA tracking
	    var currentLibrary = (0, _LibrarySelector.currentLibrarySelector)(reduxStore.getState());
	    _utilsGoogleAnalytics2.default.initialize(gaTrackingId, currentLibrary.toJS(), reduxStoreData.localization.currentLanguage);
	
	    ReactDOM.render(
	    /* eslint-disable react/jsx-filename-extension */
	    React.createElement(
	      _reactRedux.Provider,
	      { store: reduxStore },
	      React.createElement(_reactRouter.Router, {
	        history: _reactRouter.browserHistory,
	        routes: (0, _Routes2.default)(reduxStoreData.app.basePath),
	        onUpdate: logPageView })
	    ), rootElement);
	    /* eslint-enable react/jsx-filename-extension */
	  });
	}
	
	/**
	 * Renders React on server. This can be disabled by passing disableSSR to be true.
	 *
	 * @param  {object} httpClientForServer - http client like superagent which works on server
	 * @param  {boolean} disableSSR - check if the SSR is switched off
	 * @param  {object} bootstrapData - This is the data we will need to send down to client.
	 * @param  {Function} callback - This is the express callback hook which gets on success or errorService
	 *                    //TODO need to make it more express way callback
	 * @return {[type]}
	 */
	function renderOnServer(_ref) {
	  var disableSSR = _ref.disableSSR,
	      bootstrapData = _ref.bootstrapData;
	
	  var apiClient = void 0;
	  var reduxStore = void 0;
	
	  return _when2.default.resolve().then(function () {
	    var apiGatewayURLForServer = bootstrapData.apiGatewayURLForServer,
	        currentUrl = bootstrapData.currentUrl,
	        enableWebpackHMR = bootstrapData.enableWebpackHMR,
	        libraryDomain = bootstrapData.libraryDomain,
	        requestHeaders = bootstrapData.requestHeaders;
	
	
	    var appConfig = _lodash2.default.pick(bootstrapData, ['featureFlags', 'basePath', 'allowFeatureFlagEditing', 'appVersion', 'coreAssets', 'localBranch', 'mobileApp']);
	
	    // Create the store and dispatch an inital set of config properties to it
	    apiClient = new _ApiClient2.default(libraryDomain, apiGatewayURLForServer, _superagent2.default, requestHeaders);
	    reduxStore = createReduxStore(_immutable2.default.Map(), apiClient, enableWebpackHMR);
	
	    reduxStore.dispatch(_AppActions2.default.loadAppConfig(appConfig));
	    reduxStore.dispatch(_AppActions2.default.loadCookies(_cookie2.default.parse(requestHeaders.cookie || '')));
	
	    return _node2.default.call(_reactRouter.match, { routes: (0, _Routes2.default)(appConfig.basePath), location: currentUrl });
	  }).then(function (_ref2) {
	    var _ref3 = _slicedToArray(_ref2, 2),
	        redirectLocation = _ref3[0],
	        renderProps = _ref3[1];
	
	    return (// eslint-disable-line no-unused-vars
	      _utilsRouting2.default.fetchDataForCurrentRoute(renderProps, reduxStore, apiClient).then(function () {
	        var isFrbr = reduxStore.getState().getIn(['search', 'catalogSearch', 'frbr']);
	        var routePaths = _lodash2.default.compact(_lodash2.default.map(renderProps.routes, 'path'));
	        var routeName = isFrbr ? ['frbr'].concat(routePaths) : routePaths;
	        var router = renderProps.router;
	
	        var currentUser = (0, _AuthSelector.currentUserSelector)(reduxStore.getState());
	        var currentAccount = (0, _AuthSelector.currentAccountSelector)(reduxStore.getState());
	
	        var anyRouteRequiresAuthentication = _lodash2.default.some(renderProps.components, function (component) {
	          return component.requiresAuthentication;
	        });
	        var anyRouteRequiresAccount = _lodash2.default.some(renderProps.components, function (component) {
	          return component.requiresAccount;
	        });
	
	        if (anyRouteRequiresAuthentication && !currentUser || anyRouteRequiresAccount && !currentAccount) {
	          return {
	            redirect: currentUser ? '/user_dashboard' : '/user/login?destination=' + encodeURIComponent('' + router.location.pathname + router.location.search)
	          };
	        }
	
	        var rootComponentHTML = disableSSR ? '<div></div>' : ReactDOMServer.renderToString(React.createElement(
	          _reactRedux.Provider,
	          { store: reduxStore },
	          React.createElement(_reactRouter.RouterContext, renderProps)
	        ));
	
	        var clientHydrationData = whitelist(_extends({}, bootstrapData, {
	          head: Helmet.rewind(),
	          routeName: routeName,
	          reduxStoreData: reduxStore.getState().toJS()
	        }));
	
	        return {
	          clientHydrationData: clientHydrationData,
	          rootComponentHTML: new _iso2.default().add(rootComponentHTML, clientHydrationData).render()
	        };
	      })
	    );
	  });
	}
	
	var application = {
	  renderOnClient: renderOnClient,
	  renderOnServer: renderOnServer
	};
	
	if (true) {
	  window.onpageshow = function handleSafariBFCache(event) {
	    if (event.persisted && typeof window.parentIFrame === 'undefined') {
	      window.location.href += '&reload=true';
	    }
	  };
	
	  application.renderOnClient();
	}
	
	exports.default = application;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(173)(module)))

/***/ },
/* 1 */,
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BcReactComponent = __webpack_require__(1030);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BcReactComponent).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * Copyright 2016, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var allLocaleData = _interopDefault(__webpack_require__(3478));
	var IntlMessageFormat = _interopDefault(__webpack_require__(710));
	var IntlRelativeFormat = _interopDefault(__webpack_require__(2804));
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var invariant = _interopDefault(__webpack_require__(54));
	var memoizeIntlConstructor = _interopDefault(__webpack_require__(2794));
	
	var babelHelpers = {};
	babelHelpers.typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj;
	};
	
	babelHelpers.classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	babelHelpers.createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	babelHelpers.defineProperty = function (obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};
	
	babelHelpers.extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	babelHelpers.inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	babelHelpers.objectWithoutProperties = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};
	
	babelHelpers.possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	babelHelpers.toConsumableArray = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
	
	    return arr2;
	  } else {
	    return Array.from(arr);
	  }
	};
	
	babelHelpers;
	
	// GENERATED FILE
	var defaultLocaleData = { "locale": "en", "pluralRuleFunction": function pluralRuleFunction(n, ord) {
	    var s = String(n).split("."),
	        v0 = !s[1],
	        t0 = Number(s[0]) == n,
	        n10 = t0 && s[0].slice(-1),
	        n100 = t0 && s[0].slice(-2);if (ord) return n10 == 1 && n100 != 11 ? "one" : n10 == 2 && n100 != 12 ? "two" : n10 == 3 && n100 != 13 ? "few" : "other";return n == 1 && v0 ? "one" : "other";
	  }, "fields": { "year": { "displayName": "year", "relative": { "0": "this year", "1": "next year", "-1": "last year" }, "relativeTime": { "future": { "one": "in {0} year", "other": "in {0} years" }, "past": { "one": "{0} year ago", "other": "{0} years ago" } } }, "month": { "displayName": "month", "relative": { "0": "this month", "1": "next month", "-1": "last month" }, "relativeTime": { "future": { "one": "in {0} month", "other": "in {0} months" }, "past": { "one": "{0} month ago", "other": "{0} months ago" } } }, "day": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "hour": { "displayName": "hour", "relativeTime": { "future": { "one": "in {0} hour", "other": "in {0} hours" }, "past": { "one": "{0} hour ago", "other": "{0} hours ago" } } }, "minute": { "displayName": "minute", "relativeTime": { "future": { "one": "in {0} minute", "other": "in {0} minutes" }, "past": { "one": "{0} minute ago", "other": "{0} minutes ago" } } }, "second": { "displayName": "second", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} second", "other": "in {0} seconds" }, "past": { "one": "{0} second ago", "other": "{0} seconds ago" } } } } };
	
	function addLocaleData() {
	    var data = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
	
	    var locales = Array.isArray(data) ? data : [data];
	
	    locales.forEach(function (localeData) {
	        if (localeData && localeData.locale) {
	            IntlMessageFormat.__addLocaleData(localeData);
	            IntlRelativeFormat.__addLocaleData(localeData);
	        }
	    });
	}
	
	function hasLocaleData(locale) {
	    var localeParts = (locale || '').split('-');
	
	    while (localeParts.length > 0) {
	        if (hasIMFAndIRFLocaleData(localeParts.join('-'))) {
	            return true;
	        }
	
	        localeParts.pop();
	    }
	
	    return false;
	}
	
	function hasIMFAndIRFLocaleData(locale) {
	    var normalizedLocale = locale && locale.toLowerCase();
	
	    return !!(IntlMessageFormat.__localeData__[normalizedLocale] && IntlRelativeFormat.__localeData__[normalizedLocale]);
	}
	
	var bool = React.PropTypes.bool;
	var number = React.PropTypes.number;
	var string = React.PropTypes.string;
	var func = React.PropTypes.func;
	var object = React.PropTypes.object;
	var oneOf = React.PropTypes.oneOf;
	var shape = React.PropTypes.shape;
	
	
	var intlConfigPropTypes = {
	    locale: string,
	    formats: object,
	    messages: object,
	
	    defaultLocale: string,
	    defaultFormats: object
	};
	
	var intlFormatPropTypes = {
	    formatDate: func.isRequired,
	    formatTime: func.isRequired,
	    formatRelative: func.isRequired,
	    formatNumber: func.isRequired,
	    formatPlural: func.isRequired,
	    formatMessage: func.isRequired,
	    formatHTMLMessage: func.isRequired
	};
	
	var intlShape = shape(babelHelpers['extends']({}, intlConfigPropTypes, intlFormatPropTypes, {
	    formatters: object,
	    now: func.isRequired
	}));
	
	var messageDescriptorPropTypes = {
	    id: string.isRequired,
	    description: string,
	    defaultMessage: string
	};
	
	var dateTimeFormatPropTypes = {
	    localeMatcher: oneOf(['best fit', 'lookup']),
	    formatMatcher: oneOf(['basic', 'best fit']),
	
	    timeZone: string,
	    hour12: bool,
	
	    weekday: oneOf(['narrow', 'short', 'long']),
	    era: oneOf(['narrow', 'short', 'long']),
	    year: oneOf(['numeric', '2-digit']),
	    month: oneOf(['numeric', '2-digit', 'narrow', 'short', 'long']),
	    day: oneOf(['numeric', '2-digit']),
	    hour: oneOf(['numeric', '2-digit']),
	    minute: oneOf(['numeric', '2-digit']),
	    second: oneOf(['numeric', '2-digit']),
	    timeZoneName: oneOf(['short', 'long'])
	};
	
	var numberFormatPropTypes = {
	    localeMatcher: oneOf(['best fit', 'lookup']),
	
	    style: oneOf(['decimal', 'currency', 'percent']),
	    currency: string,
	    currencyDisplay: oneOf(['symbol', 'code', 'name']),
	    useGrouping: bool,
	
	    minimumIntegerDigits: number,
	    minimumFractionDigits: number,
	    maximumFractionDigits: number,
	    minimumSignificantDigits: number,
	    maximumSignificantDigits: number
	};
	
	var relativeFormatPropTypes = {
	    style: oneOf(['best fit', 'numeric']),
	    units: oneOf(['second', 'minute', 'hour', 'day', 'month', 'year'])
	};
	
	var pluralFormatPropTypes = {
	    style: oneOf(['cardinal', 'ordinal'])
	};
	
	var intlConfigPropNames = Object.keys(intlConfigPropTypes);
	
	var ESCAPED_CHARS = {
	    '&': '&amp;',
	    '>': '&gt;',
	    '<': '&lt;',
	    '"': '&quot;',
	    '\'': '&#x27;'
	};
	
	var UNSAFE_CHARS_REGEX = /[&><"']/g;
	
	function escape(str) {
	    return ('' + str).replace(UNSAFE_CHARS_REGEX, function (match) {
	        return ESCAPED_CHARS[match];
	    });
	}
	
	function filterProps(props, whitelist) {
	    var defaults = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
	
	    return whitelist.reduce(function (filtered, name) {
	        if (props.hasOwnProperty(name)) {
	            filtered[name] = props[name];
	        } else if (defaults.hasOwnProperty(name)) {
	            filtered[name] = defaults[name];
	        }
	
	        return filtered;
	    }, {});
	}
	
	function invariantIntlContext() {
	    var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var intl = _ref.intl;
	
	    invariant(intl, '[React Intl] Could not find required `intl` object. ' + '<IntlProvider> needs to exist in the component ancestry.');
	}
	
	function shallowEquals(objA, objB) {
	    if (objA === objB) {
	        return true;
	    }
	
	    if ((typeof objA === 'undefined' ? 'undefined' : babelHelpers['typeof'](objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : babelHelpers['typeof'](objB)) !== 'object' || objB === null) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if (keysA.length !== keysB.length) {
	        return false;
	    }
	
	    // Test for A's keys different from B.
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	    for (var i = 0; i < keysA.length; i++) {
	        if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	            return false;
	        }
	    }
	
	    return true;
	}
	
	function shouldIntlComponentUpdate(_ref2, nextProps, nextState) {
	    var props = _ref2.props;
	    var state = _ref2.state;
	    var _ref2$context = _ref2.context;
	    var context = _ref2$context === undefined ? {} : _ref2$context;
	    var nextContext = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	    var _context$intl = context.intl;
	    var intl = _context$intl === undefined ? {} : _context$intl;
	    var _nextContext$intl = nextContext.intl;
	    var nextIntl = _nextContext$intl === undefined ? {} : _nextContext$intl;
	
	
	    return !shallowEquals(nextProps, props) || !shallowEquals(nextState, state) || !(nextIntl === intl || shallowEquals(filterProps(nextIntl, intlConfigPropNames), filterProps(intl, intlConfigPropNames)));
	}
	
	function getDisplayName(Component) {
	    return Component.displayName || Component.name || 'Component';
	}
	
	function injectIntl(WrappedComponent) {
	    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	    var _options$intlPropName = options.intlPropName;
	    var intlPropName = _options$intlPropName === undefined ? 'intl' : _options$intlPropName;
	    var _options$withRef = options.withRef;
	    var withRef = _options$withRef === undefined ? false : _options$withRef;
	
	    var InjectIntl = function (_Component) {
	        babelHelpers.inherits(InjectIntl, _Component);
	
	        function InjectIntl(props, context) {
	            babelHelpers.classCallCheck(this, InjectIntl);
	
	            var _this = babelHelpers.possibleConstructorReturn(this, Object.getPrototypeOf(InjectIntl).call(this, props, context));
	
	            invariantIntlContext(context);
	            return _this;
	        }
	
	        babelHelpers.createClass(InjectIntl, [{
	            key: 'getWrappedInstance',
	            value: function getWrappedInstance() {
	                invariant(withRef, '[React Intl] To access the wrapped instance, ' + 'the `{withRef: true}` option must be set when calling: ' + '`injectIntl()`');
	
	                return this.refs.wrappedInstance;
	            }
	        }, {
	            key: 'render',
	            value: function render() {
	                return React__default.createElement(WrappedComponent, babelHelpers['extends']({}, this.props, babelHelpers.defineProperty({}, intlPropName, this.context.intl), {
	                    ref: withRef ? 'wrappedInstance' : null
	                }));
	            }
	        }]);
	        return InjectIntl;
	    }(React.Component);
	
	    InjectIntl.displayName = 'InjectIntl(' + getDisplayName(WrappedComponent) + ')';
	
	    InjectIntl.contextTypes = {
	        intl: intlShape
	    };
	
	    InjectIntl.WrappedComponent = WrappedComponent;
	
	    return InjectIntl;
	}
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	function defineMessages(messageDescriptors) {
	  // This simply returns what's passed-in because it's meant to be a hook for
	  // babel-plugin-react-intl.
	  return messageDescriptors;
	}
	
	function resolveLocale(locales) {
	    // IntlMessageFormat#_resolveLocale() does not depend on `this`.
	    return IntlMessageFormat.prototype._resolveLocale(locales);
	}
	
	function findPluralFunction(locale) {
	    // IntlMessageFormat#_findPluralFunction() does not depend on `this`.
	    return IntlMessageFormat.prototype._findPluralRuleFunction(locale);
	}
	
	var IntlPluralFormat = function IntlPluralFormat(locales) {
	    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	    babelHelpers.classCallCheck(this, IntlPluralFormat);
	
	    var useOrdinal = options.style === 'ordinal';
	    var pluralFn = findPluralFunction(resolveLocale(locales));
	
	    this.format = function (value) {
	        return pluralFn(value, useOrdinal);
	    };
	};
	
	var DATE_TIME_FORMAT_OPTIONS = Object.keys(dateTimeFormatPropTypes);
	var NUMBER_FORMAT_OPTIONS = Object.keys(numberFormatPropTypes);
	var RELATIVE_FORMAT_OPTIONS = Object.keys(relativeFormatPropTypes);
	var PLURAL_FORMAT_OPTIONS = Object.keys(pluralFormatPropTypes);
	
	var RELATIVE_FORMAT_THRESHOLDS = {
	    second: 60, // seconds to minute
	    minute: 60, // minutes to hour
	    hour: 24, // hours to day
	    day: 30, // days to month
	    month: 12 };
	
	// months to year
	function updateRelativeFormatThresholds(newThresholds) {
	    var thresholds = IntlRelativeFormat.thresholds;
	    thresholds.second = newThresholds.second;
	    thresholds.minute = newThresholds.minute;
	    thresholds.hour = newThresholds.hour;
	    thresholds.day = newThresholds.day;
	    thresholds.month = newThresholds.month;
	}
	
	function getNamedFormat(formats, type, name) {
	    var format = formats && formats[type] && formats[type][name];
	    if (format) {
	        return format;
	    }
	
	    if (false) {
	        console.error('[React Intl] No ' + type + ' format named: ' + name);
	    }
	}
	
	function formatDate(config, state, value) {
	    var options = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	    var locale = config.locale;
	    var formats = config.formats;
	    var format = options.format;
	
	
	    var date = new Date(value);
	    var defaults = format && getNamedFormat(formats, 'date', format);
	    var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults);
	
	    try {
	        return state.getDateTimeFormat(locale, filteredOptions).format(date);
	    } catch (e) {
	        if (false) {
	            console.error('[React Intl] Error formatting date.\n' + e);
	        }
	    }
	
	    return String(date);
	}
	
	function formatTime(config, state, value) {
	    var options = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	    var locale = config.locale;
	    var formats = config.formats;
	    var format = options.format;
	
	
	    var date = new Date(value);
	    var defaults = format && getNamedFormat(formats, 'time', format);
	    var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults);
	
	    // When no formatting options have been specified, default to outputting a
	    // time; e.g.: "9:42 AM".
	    if (Object.keys(filteredOptions).length === 0) {
	        filteredOptions = {
	            hour: 'numeric',
	            minute: 'numeric'
	        };
	    }
	
	    try {
	        return state.getDateTimeFormat(locale, filteredOptions).format(date);
	    } catch (e) {
	        if (false) {
	            console.error('[React Intl] Error formatting time.\n' + e);
	        }
	    }
	
	    return String(date);
	}
	
	function formatRelative(config, state, value) {
	    var options = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	    var locale = config.locale;
	    var formats = config.formats;
	    var format = options.format;
	
	
	    var date = new Date(value);
	    var now = new Date(options.now);
	    var defaults = format && getNamedFormat(formats, 'relative', format);
	    var filteredOptions = filterProps(options, RELATIVE_FORMAT_OPTIONS, defaults);
	
	    // Capture the current threshold values, then temporarily override them with
	    // specific values just for this render.
	    var oldThresholds = babelHelpers['extends']({}, IntlRelativeFormat.thresholds);
	    updateRelativeFormatThresholds(RELATIVE_FORMAT_THRESHOLDS);
	
	    try {
	        return state.getRelativeFormat(locale, filteredOptions).format(date, {
	            now: isFinite(now) ? now : state.now()
	        });
	    } catch (e) {
	        if (false) {
	            console.error('[React Intl] Error formatting relative time.\n' + e);
	        }
	    } finally {
	        updateRelativeFormatThresholds(oldThresholds);
	    }
	
	    return String(date);
	}
	
	function formatNumber(config, state, value) {
	    var options = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	    var locale = config.locale;
	    var formats = config.formats;
	    var format = options.format;
	
	
	    var defaults = format && getNamedFormat(formats, 'number', format);
	    var filteredOptions = filterProps(options, NUMBER_FORMAT_OPTIONS, defaults);
	
	    try {
	        return state.getNumberFormat(locale, filteredOptions).format(value);
	    } catch (e) {
	        if (false) {
	            console.error('[React Intl] Error formatting number.\n' + e);
	        }
	    }
	
	    return String(value);
	}
	
	function formatPlural(config, state, value) {
	    var options = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	    var locale = config.locale;
	
	
	    var filteredOptions = filterProps(options, PLURAL_FORMAT_OPTIONS);
	
	    try {
	        return state.getPluralFormat(locale, filteredOptions).format(value);
	    } catch (e) {
	        if (false) {
	            console.error('[React Intl] Error formatting plural.\n' + e);
	        }
	    }
	
	    return 'other';
	}
	
	function formatMessage(config, state) {
	    var messageDescriptor = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
	    var values = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	    var locale = config.locale;
	    var formats = config.formats;
	    var messages = config.messages;
	    var defaultLocale = config.defaultLocale;
	    var defaultFormats = config.defaultFormats;
	    var id = messageDescriptor.id;
	    var defaultMessage = messageDescriptor.defaultMessage;
	
	    // `id` is a required field of a Message Descriptor.
	
	    invariant(id, '[React Intl] An `id` must be provided to format a message.');
	
	    var message = messages && messages[id];
	    var hasValues = Object.keys(values).length > 0;
	
	    // Avoid expensive message formatting for simple messages without values. In
	    // development messages will always be formatted in case of missing values.
	    if (!hasValues && ("production") === 'production') {
	        return message || defaultMessage || id;
	    }
	
	    var formattedMessage = void 0;
	
	    if (message) {
	        try {
	            var formatter = state.getMessageFormat(message, locale, formats);
	
	            formattedMessage = formatter.format(values);
	        } catch (e) {
	            if (false) {
	                console.error('[React Intl] Error formatting message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : '') + ('\n' + e));
	            }
	        }
	    } else {
	        if (false) {
	            // This prevents warnings from littering the console in development
	            // when no `messages` are passed into the <IntlProvider> for the
	            // default locale, and a default message is in the source.
	            if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) {
	
	                console.error('[React Intl] Missing message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : ''));
	            }
	        }
	    }
	
	    if (!formattedMessage && defaultMessage) {
	        try {
	            var _formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats);
	
	            formattedMessage = _formatter.format(values);
	        } catch (e) {
	            if (false) {
	                console.error('[React Intl] Error formatting the default message for: "' + id + '"' + ('\n' + e));
	            }
	        }
	    }
	
	    if (!formattedMessage) {
	        if (false) {
	            console.error('[React Intl] Cannot format message: "' + id + '", ' + ('using message ' + (message || defaultMessage ? 'source' : 'id') + ' as fallback.'));
	        }
	    }
	
	    return formattedMessage || message || defaultMessage || id;
	}
	
	function formatHTMLMessage(config, state, messageDescriptor) {
	    var rawValues = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	
	    // Process all the values before they are used when formatting the ICU
	    // Message string. Since the formatted message might be injected via
	    // `innerHTML`, all String-based values need to be HTML-escaped.
	    var escapedValues = Object.keys(rawValues).reduce(function (escaped, name) {
	        var value = rawValues[name];
	        escaped[name] = typeof value === 'string' ? escape(value) : value;
	        return escaped;
	    }, {});
	
	    return formatMessage(config, state, messageDescriptor, escapedValues);
	}
	
	var format = Object.freeze({
	    formatDate: formatDate,
	    formatTime: formatTime,
	    formatRelative: formatRelative,
	    formatNumber: formatNumber,
	    formatPlural: formatPlural,
	    formatMessage: formatMessage,
	    formatHTMLMessage: formatHTMLMessage
	});
	
	var intlConfigPropNames$1 = Object.keys(intlConfigPropTypes);
	var intlFormatPropNames = Object.keys(intlFormatPropTypes);
	
	// These are not a static property on the `IntlProvider` class so the intl
	// config values can be inherited from an <IntlProvider> ancestor.
	var defaultProps = {
	    formats: {},
	    messages: {},
	
	    defaultLocale: 'en',
	    defaultFormats: {}
	};
	
	var IntlProvider = function (_Component) {
	    babelHelpers.inherits(IntlProvider, _Component);
	
	    function IntlProvider(props, context) {
	        babelHelpers.classCallCheck(this, IntlProvider);
	
	        var _this = babelHelpers.possibleConstructorReturn(this, Object.getPrototypeOf(IntlProvider).call(this, props, context));
	
	        invariant(typeof Intl !== 'undefined', '[React Intl] The `Intl` APIs must be available in the runtime, ' + 'and do not appear to be built-in. An `Intl` polyfill should be loaded.\n' + 'See: http://formatjs.io/guides/runtime-environments/');
	
	        var intlContext = context.intl;
	
	        // Used to stabilize time when performing an initial rendering so that
	        // all relative times use the same reference "now" time.
	
	        var initialNow = void 0;
	        if (isFinite(props.initialNow)) {
	            initialNow = Number(props.initialNow);
	        } else {
	            // When an `initialNow` isn't provided via `props`, look to see an
	            // <IntlProvider> exists in the ancestry and call its `now()`
	            // function to propagate its value for "now".
	            initialNow = intlContext ? intlContext.now() : Date.now();
	        }
	
	        // Creating `Intl*` formatters is expensive. If there's a parent
	        // `<IntlProvider>`, then its formatters will be used. Otherwise, this
	        // memoize the `Intl*` constructors and cache them for the lifecycle of
	        // this IntlProvider instance.
	
	        var _ref = intlContext || {};
	
	        var _ref$formatters = _ref.formatters;
	        var formatters = _ref$formatters === undefined ? {
	            getDateTimeFormat: memoizeIntlConstructor(Intl.DateTimeFormat),
	            getNumberFormat: memoizeIntlConstructor(Intl.NumberFormat),
	            getMessageFormat: memoizeIntlConstructor(IntlMessageFormat),
	            getRelativeFormat: memoizeIntlConstructor(IntlRelativeFormat),
	            getPluralFormat: memoizeIntlConstructor(IntlPluralFormat)
	        } : _ref$formatters;
	
	
	        _this.state = babelHelpers['extends']({}, formatters, {
	
	            // Wrapper to provide stable "now" time for initial render.
	            now: function now() {
	                return _this._didDisplay ? Date.now() : initialNow;
	            }
	        });
	        return _this;
	    }
	
	    babelHelpers.createClass(IntlProvider, [{
	        key: 'getConfig',
	        value: function getConfig() {
	            var intlContext = this.context.intl;
	
	            // Build a whitelisted config object from `props`, defaults, and
	            // `context.intl`, if an <IntlProvider> exists in the ancestry.
	
	            var config = filterProps(this.props, intlConfigPropNames$1, intlContext);
	
	            // Apply default props. This must be applied last after the props have
	            // been resolved and inherited from any <IntlProvider> in the ancestry.
	            // This matches how React resolves `defaultProps`.
	            for (var propName in defaultProps) {
	                if (config[propName] === undefined) {
	                    config[propName] = defaultProps[propName];
	                }
	            }
	
	            if (!hasLocaleData(config.locale)) {
	                var _config = config;
	                var locale = _config.locale;
	                var defaultLocale = _config.defaultLocale;
	                var defaultFormats = _config.defaultFormats;
	
	
	                if (false) {
	                    console.error('[React Intl] Missing locale data for locale: "' + locale + '". ' + ('Using default locale: "' + defaultLocale + '" as fallback.'));
	                }
	
	                // Since there's no registered locale data for `locale`, this will
	                // fallback to the `defaultLocale` to make sure things can render.
	                // The `messages` are overridden to the `defaultProps` empty object
	                // to maintain referential equality across re-renders. It's assumed
	                // each <FormattedMessage> contains a `defaultMessage` prop.
	                config = babelHelpers['extends']({}, config, {
	                    locale: defaultLocale,
	                    formats: defaultFormats,
	                    messages: defaultProps.messages
	                });
	            }
	
	            return config;
	        }
	    }, {
	        key: 'getBoundFormatFns',
	        value: function getBoundFormatFns(config, state) {
	            return intlFormatPropNames.reduce(function (boundFormatFns, name) {
	                boundFormatFns[name] = format[name].bind(null, config, state);
	                return boundFormatFns;
	            }, {});
	        }
	    }, {
	        key: 'getChildContext',
	        value: function getChildContext() {
	            var config = this.getConfig();
	
	            // Bind intl factories and current config to the format functions.
	            var boundFormatFns = this.getBoundFormatFns(config, this.state);
	
	            var _state = this.state;
	            var now = _state.now;
	            var formatters = babelHelpers.objectWithoutProperties(_state, ['now']);
	
	
	            return {
	                intl: babelHelpers['extends']({}, config, boundFormatFns, {
	                    formatters: formatters,
	                    now: now
	                })
	            };
	        }
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate() {
	            for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	                next[_key] = arguments[_key];
	            }
	
	            return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this._didDisplay = true;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return React.Children.only(this.props.children);
	        }
	    }]);
	    return IntlProvider;
	}(React.Component);
	
	IntlProvider.displayName = 'IntlProvider';
	
	IntlProvider.contextTypes = {
	    intl: intlShape
	};
	
	IntlProvider.childContextTypes = {
	    intl: intlShape.isRequired
	};
	
	IntlProvider.propTypes = babelHelpers['extends']({}, intlConfigPropTypes, {
	    children: React.PropTypes.element.isRequired,
	    initialNow: React.PropTypes.any
	});
	
	var FormattedDate = function (_Component) {
	    babelHelpers.inherits(FormattedDate, _Component);
	
	    function FormattedDate(props, context) {
	        babelHelpers.classCallCheck(this, FormattedDate);
	
	        var _this = babelHelpers.possibleConstructorReturn(this, Object.getPrototypeOf(FormattedDate).call(this, props, context));
	
	        invariantIntlContext(context);
	        return _this;
	    }
	
	    babelHelpers.createClass(FormattedDate, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate() {
	            for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	                next[_key] = arguments[_key];
	            }
	
	            return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var formatDate = this.context.intl.formatDate;
	            var _props = this.props;
	            var value = _props.value;
	            var children = _props.children;
	
	
	            var formattedDate = formatDate(value, this.props);
	
	            if (typeof children === 'function') {
	                return children(formattedDate);
	            }
	
	            return React__default.createElement(
	                'span',
	                null,
	                formattedDate
	            );
	        }
	    }]);
	    return FormattedDate;
	}(React.Component);
	
	FormattedDate.displayName = 'FormattedDate';
	
	FormattedDate.contextTypes = {
	    intl: intlShape
	};
	
	FormattedDate.propTypes = babelHelpers['extends']({}, dateTimeFormatPropTypes, {
	    value: React.PropTypes.any.isRequired,
	    format: React.PropTypes.string,
	    children: React.PropTypes.func
	});
	
	var FormattedTime = function (_Component) {
	    babelHelpers.inherits(FormattedTime, _Component);
	
	    function FormattedTime(props, context) {
	        babelHelpers.classCallCheck(this, FormattedTime);
	
	        var _this = babelHelpers.possibleConstructorReturn(this, Object.getPrototypeOf(FormattedTime).call(this, props, context));
	
	        invariantIntlContext(context);
	        return _this;
	    }
	
	    babelHelpers.createClass(FormattedTime, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate() {
	            for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	                next[_key] = arguments[_key];
	            }
	
	            return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var formatTime = this.context.intl.formatTime;
	            var _props = this.props;
	            var value = _props.value;
	            var children = _props.children;
	
	
	            var formattedTime = formatTime(value, this.props);
	
	            if (typeof children === 'function') {
	                return children(formattedTime);
	            }
	
	            return React__default.createElement(
	                'span',
	                null,
	                formattedTime
	            );
	        }
	    }]);
	    return FormattedTime;
	}(React.Component);
	
	FormattedTime.displayName = 'FormattedTime';
	
	FormattedTime.contextTypes = {
	    intl: intlShape
	};
	
	FormattedTime.propTypes = babelHelpers['extends']({}, dateTimeFormatPropTypes, {
	    value: React.PropTypes.any.isRequired,
	    format: React.PropTypes.string,
	    children: React.PropTypes.func
	});
	
	var SECOND = 1000;
	var MINUTE = 1000 * 60;
	var HOUR = 1000 * 60 * 60;
	var DAY = 1000 * 60 * 60 * 24;
	
	// The maximum timer delay value is a 32-bit signed integer.
	// See: https://mdn.io/setTimeout
	var MAX_TIMER_DELAY = 2147483647;
	
	function selectUnits(delta) {
	    var absDelta = Math.abs(delta);
	
	    if (absDelta < MINUTE) {
	        return 'second';
	    }
	
	    if (absDelta < HOUR) {
	        return 'minute';
	    }
	
	    if (absDelta < DAY) {
	        return 'hour';
	    }
	
	    // The maximum scheduled delay will be measured in days since the maximum
	    // timer delay is less than the number of milliseconds in 25 days.
	    return 'day';
	}
	
	function getUnitDelay(units) {
	    switch (units) {
	        case 'second':
	            return SECOND;
	        case 'minute':
	            return MINUTE;
	        case 'hour':
	            return HOUR;
	        case 'day':
	            return DAY;
	        default:
	            return MAX_TIMER_DELAY;
	    }
	}
	
	var FormattedRelative = function (_Component) {
	    babelHelpers.inherits(FormattedRelative, _Component);
	
	    function FormattedRelative(props, context) {
	        babelHelpers.classCallCheck(this, FormattedRelative);
	
	        var _this = babelHelpers.possibleConstructorReturn(this, Object.getPrototypeOf(FormattedRelative).call(this, props, context));
	
	        invariantIntlContext(context);
	
	        var now = isFinite(props.initialNow) ? Number(props.initialNow) : context.intl.now();
	
	        // `now` is stored as state so that `render()` remains a function of
	        // props + state, instead of accessing `Date.now()` inside `render()`.
	        _this.state = { now: now };
	        return _this;
	    }
	
	    babelHelpers.createClass(FormattedRelative, [{
	        key: 'scheduleNextUpdate',
	        value: function scheduleNextUpdate(props, state) {
	            var _this2 = this;
	
	            var updateInterval = props.updateInterval;
	
	            // If the `updateInterval` is falsy, including `0`, then auto updates
	            // have been turned off, so we bail and skip scheduling an update.
	
	            if (!updateInterval) {
	                return;
	            }
	
	            var time = new Date(props.value).getTime();
	            var delta = time - state.now;
	            var units = props.units || selectUnits(delta);
	
	            var unitDelay = getUnitDelay(units);
	            var unitRemainder = Math.abs(delta % unitDelay);
	
	            // We want the largest possible timer delay which will still display
	            // accurate information while reducing unnecessary re-renders. The delay
	            // should be until the next "interesting" moment, like a tick from
	            // "1 minute ago" to "2 minutes ago" when the delta is 120,000ms.
	            var delay = delta < 0 ? Math.max(updateInterval, unitDelay - unitRemainder) : Math.max(updateInterval, unitRemainder);
	
	            clearTimeout(this._timer);
	
	            this._timer = setTimeout(function () {
	                _this2.setState({ now: _this2.context.intl.now() });
	            }, delay);
	        }
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate() {
	            for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	                next[_key] = arguments[_key];
	            }
	
	            return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	        }
	    }, {
	        key: 'componentWillUpdate',
	        value: function componentWillUpdate(nextProps, nextState) {
	            this.scheduleNextUpdate(nextProps, nextState);
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.scheduleNextUpdate(this.props, this.state);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            clearTimeout(this._timer);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var formatRelative = this.context.intl.formatRelative;
	            var _props = this.props;
	            var value = _props.value;
	            var children = _props.children;
	
	
	            var formattedRelative = formatRelative(value, babelHelpers['extends']({}, this.props, this.state));
	
	            if (typeof children === 'function') {
	                return children(formattedRelative);
	            }
	
	            return React__default.createElement(
	                'span',
	                null,
	                formattedRelative
	            );
	        }
	    }]);
	    return FormattedRelative;
	}(React.Component);
	
	FormattedRelative.displayName = 'FormattedRelative';
	
	FormattedRelative.contextTypes = {
	    intl: intlShape
	};
	
	FormattedRelative.propTypes = babelHelpers['extends']({}, relativeFormatPropTypes, {
	    value: React.PropTypes.any.isRequired,
	    format: React.PropTypes.string,
	    updateInterval: React.PropTypes.number,
	    initialNow: React.PropTypes.any,
	    children: React.PropTypes.func
	});
	
	FormattedRelative.defaultProps = {
	    updateInterval: 1000 * 10
	};
	
	var FormattedNumber = function (_Component) {
	    babelHelpers.inherits(FormattedNumber, _Component);
	
	    function FormattedNumber(props, context) {
	        babelHelpers.classCallCheck(this, FormattedNumber);
	
	        var _this = babelHelpers.possibleConstructorReturn(this, Object.getPrototypeOf(FormattedNumber).call(this, props, context));
	
	        invariantIntlContext(context);
	        return _this;
	    }
	
	    babelHelpers.createClass(FormattedNumber, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate() {
	            for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	                next[_key] = arguments[_key];
	            }
	
	            return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var formatNumber = this.context.intl.formatNumber;
	            var _props = this.props;
	            var value = _props.value;
	            var children = _props.children;
	
	
	            var formattedNumber = formatNumber(value, this.props);
	
	            if (typeof children === 'function') {
	                return children(formattedNumber);
	            }
	
	            return React__default.createElement(
	                'span',
	                null,
	                formattedNumber
	            );
	        }
	    }]);
	    return FormattedNumber;
	}(React.Component);
	
	FormattedNumber.displayName = 'FormattedNumber';
	
	FormattedNumber.contextTypes = {
	    intl: intlShape
	};
	
	FormattedNumber.propTypes = babelHelpers['extends']({}, numberFormatPropTypes, {
	    value: React.PropTypes.any.isRequired,
	    format: React.PropTypes.string,
	    children: React.PropTypes.func
	});
	
	var FormattedPlural = function (_Component) {
	    babelHelpers.inherits(FormattedPlural, _Component);
	
	    function FormattedPlural(props, context) {
	        babelHelpers.classCallCheck(this, FormattedPlural);
	
	        var _this = babelHelpers.possibleConstructorReturn(this, Object.getPrototypeOf(FormattedPlural).call(this, props, context));
	
	        invariantIntlContext(context);
	        return _this;
	    }
	
	    babelHelpers.createClass(FormattedPlural, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate() {
	            for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	                next[_key] = arguments[_key];
	            }
	
	            return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var formatPlural = this.context.intl.formatPlural;
	            var _props = this.props;
	            var value = _props.value;
	            var other = _props.other;
	            var children = _props.children;
	
	
	            var pluralCategory = formatPlural(value, this.props);
	            var formattedPlural = this.props[pluralCategory] || other;
	
	            if (typeof children === 'function') {
	                return children(formattedPlural);
	            }
	
	            return React__default.createElement(
	                'span',
	                null,
	                formattedPlural
	            );
	        }
	    }]);
	    return FormattedPlural;
	}(React.Component);
	
	FormattedPlural.displayName = 'FormattedPlural';
	
	FormattedPlural.contextTypes = {
	    intl: intlShape
	};
	
	FormattedPlural.propTypes = babelHelpers['extends']({}, pluralFormatPropTypes, {
	    value: React.PropTypes.any.isRequired,
	
	    other: React.PropTypes.node.isRequired,
	    zero: React.PropTypes.node,
	    one: React.PropTypes.node,
	    two: React.PropTypes.node,
	    few: React.PropTypes.node,
	    many: React.PropTypes.node,
	
	    children: React.PropTypes.func
	});
	
	FormattedPlural.defaultProps = {
	    style: 'cardinal'
	};
	
	var FormattedMessage = function (_Component) {
	    babelHelpers.inherits(FormattedMessage, _Component);
	
	    function FormattedMessage(props, context) {
	        babelHelpers.classCallCheck(this, FormattedMessage);
	
	        var _this = babelHelpers.possibleConstructorReturn(this, Object.getPrototypeOf(FormattedMessage).call(this, props, context));
	
	        invariantIntlContext(context);
	        return _this;
	    }
	
	    babelHelpers.createClass(FormattedMessage, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps) {
	            var values = this.props.values;
	            var nextValues = nextProps.values;
	
	
	            if (!shallowEquals(nextValues, values)) {
	                return true;
	            }
	
	            // Since `values` has already been checked, we know they're not
	            // different, so the current `values` are carried over so the shallow
	            // equals comparison on the other props isn't affected by the `values`.
	            var nextPropsToCheck = babelHelpers['extends']({}, nextProps, {
	                values: values
	            });
	
	            for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	                next[_key - 1] = arguments[_key];
	            }
	
	            return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var formatMessage = this.context.intl.formatMessage;
	            var _props = this.props;
	            var id = _props.id;
	            var description = _props.description;
	            var defaultMessage = _props.defaultMessage;
	            var values = _props.values;
	            var tagName = _props.tagName;
	            var children = _props.children;
	
	
	            var tokenDelimiter = void 0;
	            var tokenizedValues = void 0;
	            var elements = void 0;
	
	            var hasValues = values && Object.keys(values).length > 0;
	            if (hasValues) {
	                (function () {
	                    // Creates a token with a random UID that should not be guessable or
	                    // conflict with other parts of the `message` string.
	                    var uid = Math.floor(Math.random() * 0x10000000000).toString(16);
	
	                    var generateToken = function () {
	                        var counter = 0;
	                        return function () {
	                            return 'ELEMENT-' + uid + '-' + (counter += 1);
	                        };
	                    }();
	
	                    // Splitting with a delimiter to support IE8. When using a regex
	                    // with a capture group IE8 does not include the capture group in
	                    // the resulting array.
	                    tokenDelimiter = '@__' + uid + '__@';
	                    tokenizedValues = {};
	                    elements = {};
	
	                    // Iterates over the `props` to keep track of any React Element
	                    // values so they can be represented by the `token` as a placeholder
	                    // when the `message` is formatted. This allows the formatted
	                    // message to then be broken-up into parts with references to the
	                    // React Elements inserted back in.
	                    Object.keys(values).forEach(function (name) {
	                        var value = values[name];
	
	                        if (React.isValidElement(value)) {
	                            var token = generateToken();
	                            tokenizedValues[name] = tokenDelimiter + token + tokenDelimiter;
	                            elements[token] = value;
	                        } else {
	                            tokenizedValues[name] = value;
	                        }
	                    });
	                })();
	            }
	
	            var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
	            var formattedMessage = formatMessage(descriptor, tokenizedValues || values);
	
	            var nodes = void 0;
	
	            var hasElements = elements && Object.keys(elements).length > 0;
	            if (hasElements) {
	                // Split the message into parts so the React Element values captured
	                // above can be inserted back into the rendered message. This
	                // approach allows messages to render with React Elements while
	                // keeping React's virtual diffing working properly.
	                nodes = formattedMessage.split(tokenDelimiter).filter(function (part) {
	                    return !!part;
	                }).map(function (part) {
	                    return elements[part] || part;
	                });
	            } else {
	                nodes = [formattedMessage];
	            }
	
	            if (typeof children === 'function') {
	                return children.apply(undefined, babelHelpers.toConsumableArray(nodes));
	            }
	
	            return React.createElement.apply(undefined, [tagName, null].concat(babelHelpers.toConsumableArray(nodes)));
	        }
	    }]);
	    return FormattedMessage;
	}(React.Component);
	
	FormattedMessage.displayName = 'FormattedMessage';
	
	FormattedMessage.contextTypes = {
	    intl: intlShape
	};
	
	FormattedMessage.propTypes = babelHelpers['extends']({}, messageDescriptorPropTypes, {
	    values: React.PropTypes.object,
	    tagName: React.PropTypes.string,
	    children: React.PropTypes.func
	});
	
	FormattedMessage.defaultProps = {
	    values: {},
	    tagName: 'span'
	};
	
	var FormattedHTMLMessage = function (_Component) {
	    babelHelpers.inherits(FormattedHTMLMessage, _Component);
	
	    function FormattedHTMLMessage(props, context) {
	        babelHelpers.classCallCheck(this, FormattedHTMLMessage);
	
	        var _this = babelHelpers.possibleConstructorReturn(this, Object.getPrototypeOf(FormattedHTMLMessage).call(this, props, context));
	
	        invariantIntlContext(context);
	        return _this;
	    }
	
	    babelHelpers.createClass(FormattedHTMLMessage, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps) {
	            var values = this.props.values;
	            var nextValues = nextProps.values;
	
	
	            if (!shallowEquals(nextValues, values)) {
	                return true;
	            }
	
	            // Since `values` has already been checked, we know they're not
	            // different, so the current `values` are carried over so the shallow
	            // equals comparison on the other props isn't affected by the `values`.
	            var nextPropsToCheck = babelHelpers['extends']({}, nextProps, {
	                values: values
	            });
	
	            for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	                next[_key - 1] = arguments[_key];
	            }
	
	            return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var formatHTMLMessage = this.context.intl.formatHTMLMessage;
	            var _props = this.props;
	            var id = _props.id;
	            var description = _props.description;
	            var defaultMessage = _props.defaultMessage;
	            var rawValues = _props.values;
	            var tagName = _props.tagName;
	            var children = _props.children;
	
	
	            var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
	            var formattedHTMLMessage = formatHTMLMessage(descriptor, rawValues);
	
	            if (typeof children === 'function') {
	                return children(formattedHTMLMessage);
	            }
	
	            // Since the message presumably has HTML in it, we need to set
	            // `innerHTML` in order for it to be rendered and not escaped by React.
	            // To be safe, all string prop values were escaped when formatting the
	            // message. It is assumed that the message is not UGC, and came from the
	            // developer making it more like a template.
	            //
	            // Note: There's a perf impact of using this component since there's no
	            // way for React to do its virtual DOM diffing.
	            return React.createElement(tagName, {
	                dangerouslySetInnerHTML: {
	                    __html: formattedHTMLMessage
	                }
	            });
	        }
	    }]);
	    return FormattedHTMLMessage;
	}(React.Component);
	
	FormattedHTMLMessage.displayName = 'FormattedHTMLMessage';
	
	FormattedHTMLMessage.contextTypes = {
	    intl: intlShape
	};
	
	FormattedHTMLMessage.propTypes = babelHelpers['extends']({}, messageDescriptorPropTypes, {
	    values: React.PropTypes.object,
	    tagName: React.PropTypes.string,
	    children: React.PropTypes.func
	});
	
	FormattedHTMLMessage.defaultProps = {
	    values: {},
	    tagName: 'span'
	};
	
	addLocaleData(defaultLocaleData);
	
	addLocaleData(allLocaleData);
	
	exports.addLocaleData = addLocaleData;
	exports.intlShape = intlShape;
	exports.injectIntl = injectIntl;
	exports.defineMessages = defineMessages;
	exports.IntlProvider = IntlProvider;
	exports.FormattedDate = FormattedDate;
	exports.FormattedTime = FormattedTime;
	exports.FormattedRelative = FormattedRelative;
	exports.FormattedNumber = FormattedNumber;
	exports.FormattedPlural = FormattedPlural;
	exports.FormattedMessage = FormattedMessage;
	exports.FormattedHTMLMessage = FormattedHTMLMessage;

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * This is a straight rip-off of the React.js ReactPropTypes.js proptype validators,
	 * modified to make it possible to validate Immutable.js data.
	 *     ImmutableTypes.listOf is patterned after React.PropTypes.arrayOf, but for Immutable.List
	 *     ImmutableTypes.shape  is based on React.PropTypes.shape, but for any Immutable.Iterable
	 */
	"use strict";
	
	var Immutable = __webpack_require__(7);
	
	var ANONYMOUS = "<<anonymous>>";
	
	var ImmutablePropTypes = {
	  listOf: createListOfTypeChecker,
	  mapOf: createMapOfTypeChecker,
	  orderedMapOf: createOrderedMapOfTypeChecker,
	  setOf: createSetOfTypeChecker,
	  orderedSetOf: createOrderedSetOfTypeChecker,
	  stackOf: createStackOfTypeChecker,
	  iterableOf: createIterableOfTypeChecker,
	  recordOf: createRecordOfTypeChecker,
	  shape: createShapeChecker,
	  contains: createShapeChecker,
	  mapContains: createMapContainsChecker,
	  // Primitive Types
	  list: createImmutableTypeChecker("List", Immutable.List.isList),
	  map: createImmutableTypeChecker("Map", Immutable.Map.isMap),
	  orderedMap: createImmutableTypeChecker("OrderedMap", Immutable.OrderedMap.isOrderedMap),
	  set: createImmutableTypeChecker("Set", Immutable.Set.isSet),
	  orderedSet: createImmutableTypeChecker("OrderedSet", Immutable.OrderedSet.isOrderedSet),
	  stack: createImmutableTypeChecker("Stack", Immutable.Stack.isStack),
	  seq: createImmutableTypeChecker("Seq", Immutable.Seq.isSeq),
	  record: createImmutableTypeChecker("Record", function (isRecord) {
	    return isRecord instanceof Immutable.Record;
	  }),
	  iterable: createImmutableTypeChecker("Iterable", Immutable.Iterable.isIterable)
	};
	
	function getPropType(propValue) {
	  var propType = typeof propValue;
	  if (Array.isArray(propValue)) {
	    return "array";
	  }
	  if (propValue instanceof RegExp) {
	    // Old webkits (at least until Android 4.0) return 'function' rather than
	    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	    // passes PropTypes.object.
	    return "object";
	  }
	  if (propValue instanceof Immutable.Iterable) {
	    return "Immutable." + propValue.toSource().split(" ")[0];
	  }
	  return propType;
	}
	
	function createChainableTypeChecker(validate) {
	  function checkType(isRequired, props, propName, componentName, location, propFullName) {
	    for (var _len = arguments.length, rest = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
	      rest[_key - 6] = arguments[_key];
	    }
	
	    propFullName = propFullName || propName;
	    componentName = componentName || ANONYMOUS;
	    if (props[propName] == null) {
	      var locationName = location;
	      if (isRequired) {
	        return new Error("Required " + locationName + " `" + propFullName + "` was not specified in " + ("`" + componentName + "`."));
	      }
	    } else {
	      return validate.apply(undefined, [props, propName, componentName, location, propFullName].concat(rest));
	    }
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}
	
	function createImmutableTypeChecker(immutableClassName, immutableClassTypeValidator) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    if (!immutableClassTypeValidator(propValue)) {
	      var propType = getPropType(propValue);
	      return new Error("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `" + immutableClassName + "`."));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createIterableTypeChecker(typeChecker, immutableClassName, immutableClassTypeValidator) {
	
	  function validate(props, propName, componentName, location, propFullName) {
	    for (var _len = arguments.length, rest = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
	      rest[_key - 5] = arguments[_key];
	    }
	
	    var propValue = props[propName];
	    if (!immutableClassTypeValidator(propValue)) {
	      var locationName = location;
	      var propType = getPropType(propValue);
	      return new Error("Invalid " + locationName + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an Immutable.js " + immutableClassName + "."));
	    }
	
	    if (typeof typeChecker !== "function") {
	      return new Error("Invalid typeChecker supplied to `" + componentName + "` " + ("for propType `" + propFullName + "`, expected a function."));
	    }
	
	    var propValues = propValue.toArray();
	    for (var i = 0, len = propValues.length; i < len; i++) {
	      var error = typeChecker.apply(undefined, [propValues, i, componentName, location, "" + propFullName + "[" + i + "]"].concat(rest));
	      if (error instanceof Error) {
	        return error;
	      }
	    }
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createKeysTypeChecker(typeChecker) {
	
	  function validate(props, propName, componentName, location, propFullName) {
	    for (var _len = arguments.length, rest = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
	      rest[_key - 5] = arguments[_key];
	    }
	
	    var propValue = props[propName];
	    if (typeof typeChecker !== "function") {
	      return new Error("Invalid keysTypeChecker (optional second argument) supplied to `" + componentName + "` " + ("for propType `" + propFullName + "`, expected a function."));
	    }
	
	    var keys = propValue.keySeq().toArray();
	    for (var i = 0, len = keys.length; i < len; i++) {
	      var error = typeChecker.apply(undefined, [keys, i, componentName, location, "" + propFullName + " -> key(" + keys[i] + ")"].concat(rest));
	      if (error instanceof Error) {
	        return error;
	      }
	    }
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createListOfTypeChecker(typeChecker) {
	  return createIterableTypeChecker(typeChecker, "List", Immutable.List.isList);
	}
	
	function createMapOfTypeCheckerFactory(valuesTypeChecker, keysTypeChecker, immutableClassName, immutableClassTypeValidator) {
	  function validate() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return createIterableTypeChecker(valuesTypeChecker, immutableClassName, immutableClassTypeValidator).apply(undefined, args) || keysTypeChecker && createKeysTypeChecker(keysTypeChecker).apply(undefined, args);
	  }
	
	  return createChainableTypeChecker(validate);
	}
	
	function createMapOfTypeChecker(valuesTypeChecker, keysTypeChecker) {
	  return createMapOfTypeCheckerFactory(valuesTypeChecker, keysTypeChecker, "Map", Immutable.Map.isMap);
	}
	
	function createOrderedMapOfTypeChecker(valuesTypeChecker, keysTypeChecker) {
	  return createMapOfTypeCheckerFactory(valuesTypeChecker, keysTypeChecker, "OrderedMap", Immutable.OrderedMap.isOrderedMap);
	}
	
	function createSetOfTypeChecker(typeChecker) {
	  return createIterableTypeChecker(typeChecker, "Set", Immutable.Set.isSet);
	}
	
	function createOrderedSetOfTypeChecker(typeChecker) {
	  return createIterableTypeChecker(typeChecker, "OrderedSet", Immutable.OrderedSet.isOrderedSet);
	}
	
	function createStackOfTypeChecker(typeChecker) {
	  return createIterableTypeChecker(typeChecker, "Stack", Immutable.Stack.isStack);
	}
	
	function createIterableOfTypeChecker(typeChecker) {
	  return createIterableTypeChecker(typeChecker, "Iterable", Immutable.Iterable.isIterable);
	}
	
	function createRecordOfTypeChecker(recordKeys) {
	  function validate(props, propName, componentName, location, propFullName) {
	    for (var _len = arguments.length, rest = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
	      rest[_key - 5] = arguments[_key];
	    }
	
	    var propValue = props[propName];
	    if (!(propValue instanceof Immutable.Record)) {
	      var propType = getPropType(propValue);
	      var locationName = location;
	      return new Error("Invalid " + locationName + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected an Immutable.js Record."));
	    }
	    for (var key in recordKeys) {
	      var checker = recordKeys[key];
	      if (!checker) {
	        continue;
	      }
	      var mutablePropValue = propValue.toObject();
	      var error = checker.apply(undefined, [mutablePropValue, key, componentName, location, "" + propFullName + "." + key].concat(rest));
	      if (error) {
	        return error;
	      }
	    }
	  }
	  return createChainableTypeChecker(validate);
	}
	
	// there is some irony in the fact that shapeTypes is a standard hash and not an immutable collection
	function createShapeTypeChecker(shapeTypes) {
	  var immutableClassName = arguments[1] === undefined ? "Iterable" : arguments[1];
	  var immutableClassTypeValidator = arguments[2] === undefined ? Immutable.Iterable.isIterable : arguments[2];
	
	  function validate(props, propName, componentName, location, propFullName) {
	    for (var _len = arguments.length, rest = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
	      rest[_key - 5] = arguments[_key];
	    }
	
	    var propValue = props[propName];
	    if (!immutableClassTypeValidator(propValue)) {
	      var propType = getPropType(propValue);
	      var locationName = location;
	      return new Error("Invalid " + locationName + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected an Immutable.js " + immutableClassName + "."));
	    }
	    var mutablePropValue = propValue.toObject();
	    for (var key in shapeTypes) {
	      var checker = shapeTypes[key];
	      if (!checker) {
	        continue;
	      }
	      var error = checker.apply(undefined, [mutablePropValue, key, componentName, location, "" + propFullName + "." + key].concat(rest));
	      if (error) {
	        return error;
	      }
	    }
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createShapeChecker(shapeTypes) {
	  return createShapeTypeChecker(shapeTypes);
	}
	
	function createMapContainsChecker(shapeTypes) {
	  return createShapeTypeChecker(shapeTypes, "Map", Immutable.Map.isMap);
	}
	
	module.exports = ImmutablePropTypes;

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _filterShape = __webpack_require__(528);
	
	Object.defineProperty(exports, 'filterShape', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_filterShape).default;
	  }
	});
	
	var _searchFieldShape = __webpack_require__(1381);
	
	Object.defineProperty(exports, 'searchFieldShape', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_searchFieldShape).default;
	  }
	});
	
	var _shelfItemShape = __webpack_require__(1382);
	
	Object.defineProperty(exports, 'shelfItemShape', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_shelfItemShape).default;
	  }
	});
	
	var _listShape = __webpack_require__(1379);
	
	Object.defineProperty(exports, 'listShape', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_listShape).default;
	  }
	});
	
	var _listItemShape = __webpack_require__(1378);
	
	Object.defineProperty(exports, 'listItemShape', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_listItemShape).default;
	  }
	});
	
	var _availabilityShape = __webpack_require__(1370);
	
	Object.defineProperty(exports, 'availabilityShape', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_availabilityShape).default;
	  }
	});
	
	var _featuredContentShape = __webpack_require__(1374);
	
	Object.defineProperty(exports, 'featuredContentShape', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_featuredContentShape).default;
	  }
	});
	
	var _shelfShape = __webpack_require__(1383);
	
	Object.defineProperty(exports, 'shelfShape', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_shelfShape).default;
	  }
	});
	
	var _userIdentityShape = __webpack_require__(534);
	
	Object.defineProperty(exports, 'userIdentityShape', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_userIdentityShape).default;
	  }
	});
	
	var _bibBriefShape = __webpack_require__(526);
	
	Object.defineProperty(exports, 'bibBriefShape', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_bibBriefShape).default;
	  }
	});
	
	var _bibShape = __webpack_require__(274);
	
	Object.defineProperty(exports, 'bibShape', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_bibShape).default;
	  }
	});
	
	var _checkedOutItemShape = __webpack_require__(1372);
	
	Object.defineProperty(exports, 'checkedOutItemShape', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_checkedOutItemShape).default;
	  }
	});
	
	var _borrowingQuotaShape = __webpack_require__(1371);
	
	Object.defineProperty(exports, 'borrowingQuotaShape', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_borrowingQuotaShape).default;
	  }
	});
	
	var _holdItemShape = __webpack_require__(1376);
	
	Object.defineProperty(exports, 'holdItemShape', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_holdItemShape).default;
	  }
	});
	
	var _branchShape = __webpack_require__(527);
	
	Object.defineProperty(exports, 'branchShape', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_branchShape).default;
	  }
	});
	
	var _singleClickHoldsSettingsShape = __webpack_require__(532);
	
	Object.defineProperty(exports, 'singleClickHoldsSettingsShape', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_singleClickHoldsSettingsShape).default;
	  }
	});
	
	var _IconShape = __webpack_require__(1367);
	
	Object.defineProperty(exports, 'iconShape', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_IconShape).default;
	  }
	});
	
	var _CarouselSettingShape = __webpack_require__(1366);
	
	Object.defineProperty(exports, 'carouselSettingShape', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CarouselSettingShape).default;
	  }
	});
	
	var _childrenShape = __webpack_require__(1373);
	
	Object.defineProperty(exports, 'childrenShape', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_childrenShape).default;
	  }
	});
	
	var _libraryShape = __webpack_require__(1377);
	
	Object.defineProperty(exports, 'libraryShape', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_libraryShape).default;
	  }
	});
	
	var _siteShape = __webpack_require__(533);
	
	Object.defineProperty(exports, 'siteShape', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_siteShape).default;
	  }
	});
	
	var _accountShape = __webpack_require__(1368);
	
	Object.defineProperty(exports, 'accountShape', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_accountShape).default;
	  }
	});
	
	var _messagingShape = __webpack_require__(1380);
	
	Object.defineProperty(exports, 'messagingShape', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_messagingShape).default;
	  }
	});
	
	var _jacketShape = __webpack_require__(529);
	
	Object.defineProperty(exports, 'jacketShape', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_jacketShape).default;
	  }
	});
	
	var _ugcCommentShape = __webpack_require__(1385);
	
	Object.defineProperty(exports, 'ugcCommentShape', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ugcCommentShape).default;
	  }
	});
	
	var _ugcQuotationShape = __webpack_require__(1388);
	
	Object.defineProperty(exports, 'ugcQuotationShape', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ugcQuotationShape).default;
	  }
	});
	
	var _ugcRatingShape = __webpack_require__(1389);
	
	Object.defineProperty(exports, 'ugcRatingShape', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ugcRatingShape).default;
	  }
	});
	
	var _ugcTagShape = __webpack_require__(1391);
	
	Object.defineProperty(exports, 'ugcTagShape', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ugcTagShape).default;
	  }
	});
	
	var _ugcVideoShape = __webpack_require__(1392);
	
	Object.defineProperty(exports, 'ugcVideoShape', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ugcVideoShape).default;
	  }
	});
	
	var _paginationShape = __webpack_require__(530);
	
	Object.defineProperty(exports, 'paginationShape', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_paginationShape).default;
	  }
	});
	
	var _fieldErrorsShape = __webpack_require__(1375);
	
	Object.defineProperty(exports, 'fieldErrorsShape', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_fieldErrorsShape).default;
	  }
	});
	
	var _ugcIOwnThisShape = __webpack_require__(1386);
	
	Object.defineProperty(exports, 'ugcIOwnThisShape', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ugcIOwnThisShape).default;
	  }
	});
	
	var _ugcSimilarTitlesShape = __webpack_require__(1390);
	
	Object.defineProperty(exports, 'ugcSimilarTitlesShape', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ugcSimilarTitlesShape).default;
	  }
	});
	
	var _ugcPrivateNoteShape = __webpack_require__(1387);
	
	Object.defineProperty(exports, 'ugcPrivateNoteShape', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ugcPrivateNoteShape).default;
	  }
	});
	
	var _addTitleResultShape = __webpack_require__(1369);
	
	Object.defineProperty(exports, 'addTitleResultShape', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_addTitleResultShape).default;
	  }
	});
	
	var _searchQueryShape = __webpack_require__(531);
	
	Object.defineProperty(exports, 'searchQueryShape', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_searchQueryShape).default;
	  }
	});
	
	var _truncateOptionsShape = __webpack_require__(1384);
	
	Object.defineProperty(exports, 'truncateOptionsShape', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_truncateOptionsShape).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.QuestionMarkSquared = exports.Flashlight = undefined;
	exports.QuestionMarkCircled = exports.InterlibraryLoans = exports.Envelope = exports.Cart = exports.CalendarFull = exports.Heart = exports.Plane = exports.Sort = exports.Abacus = exports.Personal = exports.RightArrowCircledOutline = exports.CloudDownload = exports.MessagesIcon = exports.HoldsIcon = exports.Fees = exports.CheckedOutIcon = exports.BorrowingHistoryIcon = exports.Ellipsis = exports.Card = exports.CalendarWarning = exports.List = exports.ExternalArrow = exports.Bars = exports.Resume = exports.Angle = exports.Institution = exports.Redo = exports.Chevron = exports.Link = exports.Bullseye = exports.Truck = exports.MinusCircled = exports.PauseCircled = exports.Location = exports.PushPin = exports.RSS = exports.Warning = exports.Video = exports.Unlock = exports.TextFile = exports.Tag = exports.Summary = exports.StarHalf = exports.StarFull = exports.StarEmpty = exports.Spinner = exports.Shelves = exports.ShelfItem = exports.SexualContent = exports.Search = exports.Remove = exports.Quotation = exports.Printer = exports.Plus = exports.PencilEdit = exports.Pencil = exports.PaperPlane = exports.OffensiveLanguage = exports.NewTab = exports.More = exports.Minus = exports.Lock = exports.ListView = exports.Laptop = exports.JacketView = exports.Info = exports.IconWithBackground = exports.GroupedView = exports.GraphicViolence = exports.FrighteningScenes = exports.RightArrowCircled = exports.Flag = exports.Film = exports.Filter = exports.Failure = exports.Eye = exports.Dots = exports.Cross = exports.ContentAdvisory = exports.Comment = exports.CogAlternate = exports.Cog = exports.Clock = exports.CheckmarkCircle = exports.Checkmark = exports.Carets = exports.Cancel = exports.CalendarEmpty = exports.Books = exports.CompactDisc = exports.Newspaper = exports.GameController = exports.VideoCamera = exports.MusicalNote = exports.Headphones = exports.Device = exports.Book = exports.AccessibleFormat = exports.Attention = exports.Arrows = undefined;
	
	var _Arrows = __webpack_require__(1095);
	
	Object.defineProperty(exports, 'Arrows', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Arrows).default;
	  }
	});
	
	var _Attention = __webpack_require__(1114);
	
	Object.defineProperty(exports, 'Attention', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Attention).default;
	  }
	});
	
	var _AccessibleFormat = __webpack_require__(1086);
	
	Object.defineProperty(exports, 'AccessibleFormat', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AccessibleFormat).default;
	  }
	});
	
	var _Book = __webpack_require__(1118);
	
	Object.defineProperty(exports, 'Book', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Book).default;
	  }
	});
	
	var _Device = __webpack_require__(1169);
	
	Object.defineProperty(exports, 'Device', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Device).default;
	  }
	});
	
	var _Headphones = __webpack_require__(1202);
	
	Object.defineProperty(exports, 'Headphones', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Headphones).default;
	  }
	});
	
	var _MusicalNote = __webpack_require__(1238);
	
	Object.defineProperty(exports, 'MusicalNote', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MusicalNote).default;
	  }
	});
	
	var _VideoCamera = __webpack_require__(1314);
	
	Object.defineProperty(exports, 'VideoCamera', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_VideoCamera).default;
	  }
	});
	
	var _GameController = __webpack_require__(1196);
	
	Object.defineProperty(exports, 'GameController', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GameController).default;
	  }
	});
	
	var _Newspaper = __webpack_require__(1242);
	
	Object.defineProperty(exports, 'Newspaper', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Newspaper).default;
	  }
	});
	
	var _CompactDisc = __webpack_require__(1163);
	
	Object.defineProperty(exports, 'CompactDisc', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CompactDisc).default;
	  }
	});
	
	var _Books = __webpack_require__(1120);
	
	Object.defineProperty(exports, 'Books', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Books).default;
	  }
	});
	
	var _CalendarEmpty = __webpack_require__(1126);
	
	Object.defineProperty(exports, 'CalendarEmpty', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CalendarEmpty).default;
	  }
	});
	
	var _Cancel = __webpack_require__(1132);
	
	Object.defineProperty(exports, 'Cancel', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Cancel).default;
	  }
	});
	
	var _Carets = __webpack_require__(1139);
	
	Object.defineProperty(exports, 'Carets', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Carets).default;
	  }
	});
	
	var _Checkmark = __webpack_require__(1145);
	
	Object.defineProperty(exports, 'Checkmark', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Checkmark).default;
	  }
	});
	
	var _CheckmarkCircle = __webpack_require__(1147);
	
	Object.defineProperty(exports, 'CheckmarkCircle', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CheckmarkCircle).default;
	  }
	});
	
	var _Clock = __webpack_require__(1153);
	
	Object.defineProperty(exports, 'Clock', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Clock).default;
	  }
	});
	
	var _Cog = __webpack_require__(1157);
	
	Object.defineProperty(exports, 'Cog', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Cog).default;
	  }
	});
	
	var _CogAlternate = __webpack_require__(1159);
	
	Object.defineProperty(exports, 'CogAlternate', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CogAlternate).default;
	  }
	});
	
	var _Comment = __webpack_require__(1161);
	
	Object.defineProperty(exports, 'Comment', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Comment).default;
	  }
	});
	
	var _ContentAdvisory = __webpack_require__(1165);
	
	Object.defineProperty(exports, 'ContentAdvisory', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ContentAdvisory).default;
	  }
	});
	
	var _Cross = __webpack_require__(1167);
	
	Object.defineProperty(exports, 'Cross', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Cross).default;
	  }
	});
	
	var _Dots = __webpack_require__(1172);
	
	Object.defineProperty(exports, 'Dots', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Dots).default;
	  }
	});
	
	var _Eye = __webpack_require__(1180);
	
	Object.defineProperty(exports, 'Eye', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Eye).default;
	  }
	});
	
	var _Failure = __webpack_require__(1182);
	
	Object.defineProperty(exports, 'Failure', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Failure).default;
	  }
	});
	
	var _Filter = __webpack_require__(1188);
	
	Object.defineProperty(exports, 'Filter', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Filter).default;
	  }
	});
	
	var _Film = __webpack_require__(1186);
	
	Object.defineProperty(exports, 'Film', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Film).default;
	  }
	});
	
	var _Flag = __webpack_require__(1190);
	
	Object.defineProperty(exports, 'Flag', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Flag).default;
	  }
	});
	
	var _RightArrowCircled = __webpack_require__(1278);
	
	Object.defineProperty(exports, 'RightArrowCircled', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RightArrowCircled).default;
	  }
	});
	
	var _FrighteningScenes = __webpack_require__(1194);
	
	Object.defineProperty(exports, 'FrighteningScenes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FrighteningScenes).default;
	  }
	});
	
	var _GraphicViolence = __webpack_require__(1198);
	
	Object.defineProperty(exports, 'GraphicViolence', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GraphicViolence).default;
	  }
	});
	
	var _GroupedView = __webpack_require__(1200);
	
	Object.defineProperty(exports, 'GroupedView', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GroupedView).default;
	  }
	});
	
	var _IconWithBackground = __webpack_require__(1208);
	
	Object.defineProperty(exports, 'IconWithBackground', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_IconWithBackground).default;
	  }
	});
	
	var _Info = __webpack_require__(1210);
	
	Object.defineProperty(exports, 'Info', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Info).default;
	  }
	});
	
	var _JacketView = __webpack_require__(1216);
	
	Object.defineProperty(exports, 'JacketView', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_JacketView).default;
	  }
	});
	
	var _Laptop = __webpack_require__(1218);
	
	Object.defineProperty(exports, 'Laptop', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Laptop).default;
	  }
	});
	
	var _ListView = __webpack_require__(1224);
	
	Object.defineProperty(exports, 'ListView', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ListView).default;
	  }
	});
	
	var _Lock = __webpack_require__(1228);
	
	Object.defineProperty(exports, 'Lock', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Lock).default;
	  }
	});
	
	var _Minus = __webpack_require__(1232);
	
	Object.defineProperty(exports, 'Minus', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Minus).default;
	  }
	});
	
	var _More = __webpack_require__(1236);
	
	Object.defineProperty(exports, 'More', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_More).default;
	  }
	});
	
	var _NewTab = __webpack_require__(1240);
	
	Object.defineProperty(exports, 'NewTab', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_NewTab).default;
	  }
	});
	
	var _OffensiveLanguage = __webpack_require__(1244);
	
	Object.defineProperty(exports, 'OffensiveLanguage', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_OffensiveLanguage).default;
	  }
	});
	
	var _PaperPlane = __webpack_require__(1246);
	
	Object.defineProperty(exports, 'PaperPlane', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PaperPlane).default;
	  }
	});
	
	var _Pencil = __webpack_require__(1250);
	
	Object.defineProperty(exports, 'Pencil', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Pencil).default;
	  }
	});
	
	var _PencilEdit = __webpack_require__(1252);
	
	Object.defineProperty(exports, 'PencilEdit', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PencilEdit).default;
	  }
	});
	
	var _Plus = __webpack_require__(1258);
	
	Object.defineProperty(exports, 'Plus', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Plus).default;
	  }
	});
	
	var _Printer = __webpack_require__(1260);
	
	Object.defineProperty(exports, 'Printer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Printer).default;
	  }
	});
	
	var _Quotation = __webpack_require__(1268);
	
	Object.defineProperty(exports, 'Quotation', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Quotation).default;
	  }
	});
	
	var _Remove = __webpack_require__(1274);
	
	Object.defineProperty(exports, 'Remove', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Remove).default;
	  }
	});
	
	var _Search = __webpack_require__(1282);
	
	Object.defineProperty(exports, 'Search', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Search).default;
	  }
	});
	
	var _SexualContent = __webpack_require__(1284);
	
	Object.defineProperty(exports, 'SexualContent', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SexualContent).default;
	  }
	});
	
	var _ShelfItem = __webpack_require__(1286);
	
	Object.defineProperty(exports, 'ShelfItem', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ShelfItem).default;
	  }
	});
	
	var _Shelves = __webpack_require__(1288);
	
	Object.defineProperty(exports, 'Shelves', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Shelves).default;
	  }
	});
	
	var _Spinner = __webpack_require__(1294);
	
	Object.defineProperty(exports, 'Spinner', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Spinner).default;
	  }
	});
	
	var _StarEmpty = __webpack_require__(1296);
	
	Object.defineProperty(exports, 'StarEmpty', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_StarEmpty).default;
	  }
	});
	
	var _StarFull = __webpack_require__(1298);
	
	Object.defineProperty(exports, 'StarFull', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_StarFull).default;
	  }
	});
	
	var _StarHalf = __webpack_require__(1300);
	
	Object.defineProperty(exports, 'StarHalf', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_StarHalf).default;
	  }
	});
	
	var _Summary = __webpack_require__(1302);
	
	Object.defineProperty(exports, 'Summary', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Summary).default;
	  }
	});
	
	var _Tag = __webpack_require__(1304);
	
	Object.defineProperty(exports, 'Tag', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Tag).default;
	  }
	});
	
	var _TextFile = __webpack_require__(1306);
	
	Object.defineProperty(exports, 'TextFile', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TextFile).default;
	  }
	});
	
	var _Unlock = __webpack_require__(1310);
	
	Object.defineProperty(exports, 'Unlock', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Unlock).default;
	  }
	});
	
	var _Video = __webpack_require__(1312);
	
	Object.defineProperty(exports, 'Video', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Video).default;
	  }
	});
	
	var _Warning = __webpack_require__(1316);
	
	Object.defineProperty(exports, 'Warning', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Warning).default;
	  }
	});
	
	var _RSS = __webpack_require__(1270);
	
	Object.defineProperty(exports, 'RSS', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RSS).default;
	  }
	});
	
	var _PushPin = __webpack_require__(1262);
	
	Object.defineProperty(exports, 'PushPin', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PushPin).default;
	  }
	});
	
	var _Location = __webpack_require__(1226);
	
	Object.defineProperty(exports, 'Location', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Location).default;
	  }
	});
	
	var _PauseCircled = __webpack_require__(1248);
	
	Object.defineProperty(exports, 'PauseCircled', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PauseCircled).default;
	  }
	});
	
	var _MinusCircled = __webpack_require__(1234);
	
	Object.defineProperty(exports, 'MinusCircled', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MinusCircled).default;
	  }
	});
	
	var _Truck = __webpack_require__(1308);
	
	Object.defineProperty(exports, 'Truck', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Truck).default;
	  }
	});
	
	var _Bullseye = __webpack_require__(1124);
	
	Object.defineProperty(exports, 'Bullseye', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Bullseye).default;
	  }
	});
	
	var _Link = __webpack_require__(1220);
	
	Object.defineProperty(exports, 'Link', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Link).default;
	  }
	});
	
	var _Chevron = __webpack_require__(1151);
	
	Object.defineProperty(exports, 'Chevron', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Chevron).default;
	  }
	});
	
	var _Redo = __webpack_require__(1272);
	
	Object.defineProperty(exports, 'Redo', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Redo).default;
	  }
	});
	
	var _Institution = __webpack_require__(1212);
	
	Object.defineProperty(exports, 'Institution', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Institution).default;
	  }
	});
	
	var _Angle = __webpack_require__(1089);
	
	Object.defineProperty(exports, 'Angle', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Angle).default;
	  }
	});
	
	var _Resume = __webpack_require__(1276);
	
	Object.defineProperty(exports, 'Resume', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Resume).default;
	  }
	});
	
	var _Bars = __webpack_require__(1116);
	
	Object.defineProperty(exports, 'Bars', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Bars).default;
	  }
	});
	
	var _ExternalArrow = __webpack_require__(1178);
	
	Object.defineProperty(exports, 'ExternalArrow', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ExternalArrow).default;
	  }
	});
	
	var _List = __webpack_require__(1222);
	
	Object.defineProperty(exports, 'List', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_List).default;
	  }
	});
	
	var _CalendarWarning = __webpack_require__(1130);
	
	Object.defineProperty(exports, 'CalendarWarning', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CalendarWarning).default;
	  }
	});
	
	var _Card = __webpack_require__(1134);
	
	Object.defineProperty(exports, 'Card', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Card).default;
	  }
	});
	
	var _Ellipsis = __webpack_require__(1174);
	
	Object.defineProperty(exports, 'Ellipsis', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Ellipsis).default;
	  }
	});
	
	var _BorrowingHistoryIcon = __webpack_require__(1122);
	
	Object.defineProperty(exports, 'BorrowingHistoryIcon', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BorrowingHistoryIcon).default;
	  }
	});
	
	var _CheckedOutIcon = __webpack_require__(1143);
	
	Object.defineProperty(exports, 'CheckedOutIcon', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CheckedOutIcon).default;
	  }
	});
	
	var _Fees = __webpack_require__(1184);
	
	Object.defineProperty(exports, 'Fees', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Fees).default;
	  }
	});
	
	var _HoldsIcon = __webpack_require__(1206);
	
	Object.defineProperty(exports, 'HoldsIcon', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_HoldsIcon).default;
	  }
	});
	
	var _MessagesIcon = __webpack_require__(1230);
	
	Object.defineProperty(exports, 'MessagesIcon', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MessagesIcon).default;
	  }
	});
	
	var _CloudDownload = __webpack_require__(1155);
	
	Object.defineProperty(exports, 'CloudDownload', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CloudDownload).default;
	  }
	});
	
	var _RightArrowCircledOutline = __webpack_require__(1280);
	
	Object.defineProperty(exports, 'RightArrowCircledOutline', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RightArrowCircledOutline).default;
	  }
	});
	
	var _Personal = __webpack_require__(1254);
	
	Object.defineProperty(exports, 'Personal', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Personal).default;
	  }
	});
	
	var _Abacus = __webpack_require__(1084);
	
	Object.defineProperty(exports, 'Abacus', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Abacus).default;
	  }
	});
	
	var _Sort = __webpack_require__(1292);
	
	Object.defineProperty(exports, 'Sort', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Sort).default;
	  }
	});
	
	var _Plane = __webpack_require__(1256);
	
	Object.defineProperty(exports, 'Plane', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Plane).default;
	  }
	});
	
	var _Heart = __webpack_require__(1204);
	
	Object.defineProperty(exports, 'Heart', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Heart).default;
	  }
	});
	
	var _CalendarFull = __webpack_require__(1128);
	
	Object.defineProperty(exports, 'CalendarFull', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CalendarFull).default;
	  }
	});
	
	var _Cart = __webpack_require__(1141);
	
	Object.defineProperty(exports, 'Cart', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Cart).default;
	  }
	});
	
	var _Envelope = __webpack_require__(1176);
	
	Object.defineProperty(exports, 'Envelope', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Envelope).default;
	  }
	});
	
	var _InterlibraryLoans = __webpack_require__(1214);
	
	Object.defineProperty(exports, 'InterlibraryLoans', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_InterlibraryLoans).default;
	  }
	});
	
	var _QuestionMarkCircled = __webpack_require__(1264);
	
	Object.defineProperty(exports, 'QuestionMarkCircled', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_QuestionMarkCircled).default;
	  }
	});
	
	var _Flashlight = __webpack_require__(1192);
	
	Object.defineProperty(exports, 'Flashlight', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Flashlight).default;
	  }
	});
	
	var _QuestionMarkSquared = __webpack_require__(1266);
	
	Object.defineProperty(exports, 'QuestionMarkSquared', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_QuestionMarkSquared).default;
	  }
	});
	
	__webpack_require__(2686);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _button = __webpack_require__(82);
	
	Object.defineProperty(exports, 'Button', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_button).default;
	  }
	});
	
	var _default = __webpack_require__(1037);
	
	Object.defineProperty(exports, 'DefaultButton', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_default).default;
	  }
	});
	
	var _ghost = __webpack_require__(516);
	
	Object.defineProperty(exports, 'GhostButton', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ghost).default;
	  }
	});
	
	var _highlight = __webpack_require__(1040);
	
	Object.defineProperty(exports, 'HighlightButton', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_highlight).default;
	  }
	});
	
	var _primary = __webpack_require__(1046);
	
	Object.defineProperty(exports, 'PrimaryButton', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_primary).default;
	  }
	});
	
	var _remove = __webpack_require__(1048);
	
	Object.defineProperty(exports, 'RemoveButton', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_remove).default;
	  }
	});
	
	var _secondary = __webpack_require__(1050);
	
	Object.defineProperty(exports, 'SecondaryButton', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_secondary).default;
	  }
	});
	
	var _text = __webpack_require__(1052);
	
	Object.defineProperty(exports, 'TextButton', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_text).default;
	  }
	});
	
	var _transactional = __webpack_require__(1054);
	
	Object.defineProperty(exports, 'TransactionalButton', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_transactional).default;
	  }
	});
	
	var _blueCaretArrow = __webpack_require__(1032);
	
	Object.defineProperty(exports, 'BlueCaretArrowButton', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_blueCaretArrow).default;
	  }
	});
	
	var _primaryGhostButton = __webpack_require__(1044);
	
	Object.defineProperty(exports, 'PrimaryGhostButton', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_primaryGhostButton).default;
	  }
	});
	
	var _blueTextButton = __webpack_require__(1034);
	
	Object.defineProperty(exports, 'BlueTextButton', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_blueTextButton).default;
	  }
	});
	
	var _icon = __webpack_require__(1042);
	
	Object.defineProperty(exports, 'IconButton', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_icon).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ScreenReaderMessage = __webpack_require__(1342);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ScreenReaderMessage).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createReduxConstants = undefined;
	
	var _isPlainObject = __webpack_require__(256);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _keys = __webpack_require__(163);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _curry = __webpack_require__(2930);
	
	var _curry2 = _interopRequireDefault(_curry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Creates constants to be used for Redux Actions
	 *
	 * @param {string} namespace The name of the reducer / action namespace
	 * @param {object} obj The constants to be namespaced
	 * @returns {object}
	 */
	/* eslint-disable import/prefer-default-export */
	var createReduxConstants = exports.createReduxConstants = (0, _curry2.default)(function (namespace, obj) {
	  if (typeof namespace !== 'string') {
	    throw new Error('createReduxConstants must pass the namespace as the first argument');
	  }
	
	  var ret = {};
	  if (!(0, _isPlainObject2.default)(obj)) {
	    throw new Error('createReduxConstants must be passed an Object as the second argument.');
	  }
	  (0, _keys2.default)(obj).forEach(function (key) {
	    ret[key] = namespace + '/' + key;
	  });
	
	  return ret;
	});

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getAccountsByLibraryId = exports.currentAccountSelector = exports.currentUserSelector = undefined;
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reselect = __webpack_require__(34);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var currentUserIdSelector = function currentUserIdSelector(state) {
	  return state.getIn(['auth', 'currentUserId']);
	};
	var usersSelector = function usersSelector(state) {
	  return state.getIn(['entities', 'users'], _immutable2.default.Map());
	};
	var accountsSelector = function accountsSelector(state) {
	  return state.getIn(['entities', 'accounts'], _immutable2.default.Map());
	};
	var libraryIdSelector = function libraryIdSelector(state) {
	  return state.getIn(['library', 'id']);
	};
	
	var currentUserSelector = exports.currentUserSelector = (0, _reselect.createSelector)(currentUserIdSelector, usersSelector, function (currentUserId, users) {
	  return users.find(function (user) {
	    return user.get('id') === currentUserId;
	  });
	});
	
	var currentAccountSelector = exports.currentAccountSelector = (0, _reselect.createSelector)(currentUserSelector, accountsSelector, libraryIdSelector, function (user, accounts, libId) {
	  return user && accounts.find(function (value) {
	    return user.get('accounts').includes(value.get('id')) && value.get('libId') === libId;
	  });
	});
	
	var getAccountsByLibraryId = exports.getAccountsByLibraryId = (0, _reselect.createSelector)([accountsSelector], function (accounts) {
	  return accounts.toList().groupBy(function (account) {
	    return account.get('libId');
	  }).map(function (accountsList) {
	    return accountsList.first();
	  });
	});
	
	exports.default = {
	  currentUserSelector: currentUserSelector,
	  currentAccountSelector: currentAccountSelector,
	  getAccountsByLibraryId: getAccountsByLibraryId
	};

/***/ },
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(2957)();
	}


/***/ },
/* 28 */,
/* 29 */,
/* 30 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var DISPLAY_FORMAT = exports.DISPLAY_FORMAT = 'L';
	var ISO_FORMAT = exports.ISO_FORMAT = 'YYYY-MM-DD';
	var ISO_MONTH_FORMAT = exports.ISO_MONTH_FORMAT = 'YYYY-MM';
	
	var START_DATE = exports.START_DATE = 'startDate';
	var END_DATE = exports.END_DATE = 'endDate';
	
	var HORIZONTAL_ORIENTATION = exports.HORIZONTAL_ORIENTATION = 'horizontal';
	var VERTICAL_ORIENTATION = exports.VERTICAL_ORIENTATION = 'vertical';
	var VERTICAL_SCROLLABLE = exports.VERTICAL_SCROLLABLE = 'verticalScrollable';
	
	var ICON_BEFORE_POSITION = exports.ICON_BEFORE_POSITION = 'before';
	var ICON_AFTER_POSITION = exports.ICON_AFTER_POSITION = 'after';
	
	var INFO_POSITION_TOP = exports.INFO_POSITION_TOP = 'top';
	var INFO_POSITION_BOTTOM = exports.INFO_POSITION_BOTTOM = 'bottom';
	var INFO_POSITION_BEFORE = exports.INFO_POSITION_BEFORE = 'before';
	var INFO_POSITION_AFTER = exports.INFO_POSITION_AFTER = 'after';
	
	var ANCHOR_LEFT = exports.ANCHOR_LEFT = 'left';
	var ANCHOR_RIGHT = exports.ANCHOR_RIGHT = 'right';
	
	var OPEN_DOWN = exports.OPEN_DOWN = 'down';
	var OPEN_UP = exports.OPEN_UP = 'up';
	
	var DAY_SIZE = exports.DAY_SIZE = 39;
	var BLOCKED_MODIFIER = exports.BLOCKED_MODIFIER = 'blocked';
	var WEEKDAYS = exports.WEEKDAYS = [0, 1, 2, 3, 4, 5, 6];
	
	var FANG_WIDTH_PX = exports.FANG_WIDTH_PX = 20;
	var FANG_HEIGHT_PX = exports.FANG_HEIGHT_PX = 10;
	var DEFAULT_VERTICAL_SPACING = exports.DEFAULT_VERTICAL_SPACING = 22;
	
	var MODIFIER_KEY_NAMES = exports.MODIFIER_KEY_NAMES = new Set(['Shift', 'Control', 'Alt', 'Meta']);

/***/ },
/* 31 */,
/* 32 */
225,
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getLinkedLibrariesById = exports.sortedPickupBranchSelector = exports.currentSiteSelector = exports.currentLibrarySelector = undefined;
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reselect = __webpack_require__(34);
	
	var _AuthSelector = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var currentLibrarySelector = exports.currentLibrarySelector = function currentLibrarySelector(state) {
	  return state.getIn(['entities', 'libraries', state.getIn(['library', 'id'], '').toString()], _immutable2.default.Map());
	};
	var currentSiteSelector = exports.currentSiteSelector = function currentSiteSelector(state) {
	  return state.getIn(['entities', 'sites', currentLibrarySelector(state).get('siteId')], _immutable2.default.Map());
	};
	
	var sortedPickupBranchSelector = exports.sortedPickupBranchSelector = (0, _reselect.createSelector)(currentLibrarySelector, _AuthSelector.currentAccountSelector, function (library, account) {
	  var branches = library.get('branches', _immutable2.default.List());
	  var preferredBranches = account ? account.get('preferredLocations') : _immutable2.default.List();
	
	  return branches.sortBy(function (branch) {
	    var branchPreference = preferredBranches.indexOf(branch.code);
	    return branchPreference >= 0 ? branchPreference : branches.length;
	  });
	});
	
	var getLinkedLibrariesById = exports.getLinkedLibrariesById = (0, _reselect.createSelector)([currentLibrarySelector, _AuthSelector.getAccountsByLibraryId], function (library, accountsByLibraryId) {
	  return library.get('linkableLibraries', _immutable2.default.List()).filter(function (linkableLibrary) {
	    return accountsByLibraryId.has(linkableLibrary.get('libraryId'));
	  }).groupBy(function (linkableLibrary) {
	    return linkableLibrary.get('libraryId');
	  }).map(function (libraryList) {
	    return libraryList.first();
	  });
	});

/***/ },
/* 34 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.defaultMemoize = defaultMemoize;
	exports.createSelectorCreator = createSelectorCreator;
	exports.createStructuredSelector = createStructuredSelector;
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function defaultEqualityCheck(a, b) {
	  return a === b;
	}
	
	function defaultMemoize(func) {
	  var equalityCheck = arguments.length <= 1 || arguments[1] === undefined ? defaultEqualityCheck : arguments[1];
	
	  var lastArgs = null;
	  var lastResult = null;
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    if (lastArgs === null || lastArgs.length !== args.length || !args.every(function (value, index) {
	      return equalityCheck(value, lastArgs[index]);
	    })) {
	      lastResult = func.apply(undefined, args);
	    }
	    lastArgs = args;
	    return lastResult;
	  };
	}
	
	function getDependencies(funcs) {
	  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
	
	  if (!dependencies.every(function (dep) {
	    return typeof dep === 'function';
	  })) {
	    var dependencyTypes = dependencies.map(function (dep) {
	      return typeof dep;
	    }).join(', ');
	    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
	  }
	
	  return dependencies;
	}
	
	function createSelectorCreator(memoize) {
	  for (var _len2 = arguments.length, memoizeOptions = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	    memoizeOptions[_key2 - 1] = arguments[_key2];
	  }
	
	  return function () {
	    for (var _len3 = arguments.length, funcs = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      funcs[_key3] = arguments[_key3];
	    }
	
	    var recomputations = 0;
	    var resultFunc = funcs.pop();
	    var dependencies = getDependencies(funcs);
	
	    var memoizedResultFunc = memoize.apply(undefined, [function () {
	      recomputations++;
	      return resultFunc.apply(undefined, arguments);
	    }].concat(memoizeOptions));
	
	    var selector = function selector(state, props) {
	      for (var _len4 = arguments.length, args = Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
	        args[_key4 - 2] = arguments[_key4];
	      }
	
	      var params = dependencies.map(function (dependency) {
	        return dependency.apply(undefined, [state, props].concat(args));
	      });
	      return memoizedResultFunc.apply(undefined, _toConsumableArray(params));
	    };
	
	    selector.resultFunc = resultFunc;
	    selector.recomputations = function () {
	      return recomputations;
	    };
	    selector.resetRecomputations = function () {
	      return recomputations = 0;
	    };
	    return selector;
	  };
	}
	
	var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);
	
	function createStructuredSelector(selectors) {
	  var selectorCreator = arguments.length <= 1 || arguments[1] === undefined ? createSelector : arguments[1];
	
	  if (typeof selectors !== 'object') {
	    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
	  }
	  var objectKeys = Object.keys(selectors);
	  return selectorCreator(objectKeys.map(function (key) {
	    return selectors[key];
	  }), function () {
	    for (var _len5 = arguments.length, values = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	      values[_key5] = arguments[_key5];
	    }
	
	    return values.reduce(function (composition, value, index) {
	      composition[objectKeys[index]] = value;
	      return composition;
	    }, {});
	  });
	}

/***/ },
/* 35 */,
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _alert = __webpack_require__(175);
	
	Object.defineProperty(exports, 'Alert', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_alert).default;
	  }
	});
	
	var _dismiss = __webpack_require__(515);
	
	Object.defineProperty(exports, 'AlertDismiss', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_dismiss).default;
	  }
	});
	
	var _failure = __webpack_require__(1017);
	
	Object.defineProperty(exports, 'AlertFailure', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_failure).default;
	  }
	});
	
	var _info = __webpack_require__(1019);
	
	Object.defineProperty(exports, 'AlertInfo', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_info).default;
	  }
	});
	
	var _success = __webpack_require__(1023);
	
	Object.defineProperty(exports, 'AlertSuccess', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_success).default;
	  }
	});
	
	var _warning = __webpack_require__(1025);
	
	Object.defineProperty(exports, 'AlertWarning', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_warning).default;
	  }
	});
	
	var _neutral = __webpack_require__(1021);
	
	Object.defineProperty(exports, 'AlertNeutral', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_neutral).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _dropdown = __webpack_require__(1077);
	
	Object.defineProperty(exports, 'Dropdown', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_dropdown).default;
	  }
	});
	
	var _dropdownMenu = __webpack_require__(362);
	
	Object.defineProperty(exports, 'DropdownMenu', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_dropdownMenu).default;
	  }
	});
	Object.defineProperty(exports, 'DropdownMenuItem', {
	  enumerable: true,
	  get: function get() {
	    return _dropdownMenu.DropdownMenuItem;
	  }
	});
	Object.defineProperty(exports, 'DropdownMenuHeader', {
	  enumerable: true,
	  get: function get() {
	    return _dropdownMenu.DropdownMenuHeader;
	  }
	});
	Object.defineProperty(exports, 'DropdownMenuDivider', {
	  enumerable: true,
	  get: function get() {
	    return _dropdownMenu.DropdownMenuDivider;
	  }
	});
	
	var _dropdownTrigger = __webpack_require__(519);
	
	Object.defineProperty(exports, 'DropdownTrigger', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_dropdownTrigger).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	module.exports =  true ? __webpack_require__(1573) : require('./build');
	
	//# sourceMappingURL=index.js.map

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.WORKFLOW_VIEWS = exports.SUMMARY_ORDER = exports.SHELF_NAMES = exports.IMPORT_STATUSES = exports.SHELF_IMPORT_NOTICE_ID = undefined;
	
	var _utilsRedux = __webpack_require__(20);
	
	var SHELF_IMPORT_NOTICE_ID = exports.SHELF_IMPORT_NOTICE_ID = 'shelf_import_notice';
	
	var IMPORT_STATUSES = exports.IMPORT_STATUSES = {
	  DONE: 'done',
	  SUBMITTED: 'submitted',
	  FAILED: 'failed'
	};
	
	var SHELF_NAMES = exports.SHELF_NAMES = {
	  COMPLETED: 'completed',
	  IN_PROGRESS: 'in_progress',
	  FOR_LATER: 'for_later'
	};
	
	var SUMMARY_ORDER = exports.SUMMARY_ORDER = [SHELF_NAMES.COMPLETED, SHELF_NAMES.IN_PROGRESS, SHELF_NAMES.FOR_LATER];
	
	var WORKFLOW_VIEWS = exports.WORKFLOW_VIEWS = (0, _utilsRedux.createReduxConstants)('WORKFLOW_VIEWS', {
	  ADDED_TO_COMPLETED_SHELF: null,
	  ADDED_TO_IN_PROGRESS_SHELF: null,
	  ADDED_TO_FOR_LATER_SHELF: null,
	  EXISTS_ON_SHELF: null
	});
	
	exports.default = (0, _utilsRedux.createReduxConstants)('SHELF', {
	  SHELF_SEARCH_REQUEST: null,
	  SHELF_SEARCH_SUCCESS: null,
	  SHELF_SEARCH_FAILURE: null,
	  FETCH_FILTERS_REQUEST: null,
	  FETCH_FILTERS_SUCCESS: null,
	  FETCH_FILTERS_FAILURE: null,
	  ADD_TO_SHELF_REQUEST: null,
	  ADD_TO_SHELF_SUCCESS: null,
	  ADD_TO_SHELF_FAILURE: null,
	  REMOVE_FROM_SHELF_REQUEST: null,
	  REMOVE_FROM_SHELF_SUCCESS: null,
	  REMOVE_FROM_SHELF_FAILURE: null,
	  UPDATE_SHELF_ITEM_REQUEST: null,
	  UPDATE_SHELF_ITEM_SUCCESS: null,
	  UPDATE_SHELF_ITEM_FAILURE: null,
	  SHOW_POST_ADD_TO_SHELF_VIEW: null,
	  IMPORT_ILS_BIBS_REQUEST: null,
	  IMPORT_ILS_BIBS_SUCCESS: null,
	  IMPORT_ILS_BIBS_FAILURE: null
	});

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(32);
	
	var DOMProperty = __webpack_require__(217);
	var ReactDOMComponentFlags = __webpack_require__(877);
	
	var invariant = __webpack_require__(19);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (childNode.nodeType === 1 && childNode.getAttribute(ATTR_NAME) === String(childID) || childNode.nodeType === 8 && childNode.nodeValue === ' react-text: ' + childID + ' ' || childNode.nodeType === 8 && childNode.nodeValue === ' react-empty: ' + childID + ' ') {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FullScreenOverlay = __webpack_require__(1078);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FullScreenOverlay).default;
	  }
	});
	Object.defineProperty(exports, 'FullScreenOverlay', {
	  enumerable: true,
	  get: function get() {
	    return _FullScreenOverlay.FullScreenOverlay;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BibBrief = __webpack_require__(1470);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BibBrief).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var calendarLabel = 'Calendar';
	var closeDatePicker = 'Close';
	var focusStartDate = 'Interact with the calendar and add the check-in date for your trip.';
	var clearDate = 'Clear Date';
	var clearDates = 'Clear Dates';
	var jumpToPrevMonth = 'Move backward to switch to the previous month.';
	var jumpToNextMonth = 'Move forward to switch to the next month.';
	var keyboardShortcuts = 'Keyboard Shortcuts';
	var showKeyboardShortcutsPanel = 'Open the keyboard shortcuts panel.';
	var hideKeyboardShortcutsPanel = 'Close the shortcuts panel.';
	var openThisPanel = 'Open this panel.';
	var enterKey = 'Enter key';
	var leftArrowRightArrow = 'Right and left arrow keys';
	var upArrowDownArrow = 'up and down arrow keys';
	var pageUpPageDown = 'page up and page down keys';
	var homeEnd = 'Home and end keys';
	var escape = 'Escape key';
	var questionMark = 'Question mark';
	var selectFocusedDate = 'Select the date in focus.';
	var moveFocusByOneDay = 'Move backward (left) and forward (right) by one day.';
	var moveFocusByOneWeek = 'Move backward (up) and forward (down) by one week.';
	var moveFocusByOneMonth = 'Switch months.';
	var moveFocustoStartAndEndOfWeek = 'Go to the first or last day of a week.';
	var returnFocusToInput = 'Return to the date input field.';
	var keyboardNavigationInstructions = 'Press the down arrow key to interact with the calendar and\n  select a date. Press the question mark key to get the keyboard shortcuts for changing dates.';
	
	var chooseAvailableStartDate = function chooseAvailableStartDate(_ref) {
	  var date = _ref.date;
	  return 'Choose ' + String(date) + ' as your check-in date. It\'s available.';
	};
	var chooseAvailableEndDate = function chooseAvailableEndDate(_ref2) {
	  var date = _ref2.date;
	  return 'Choose ' + String(date) + ' as your check-out date. It\'s available.';
	};
	var chooseAvailableDate = function chooseAvailableDate(_ref3) {
	  var date = _ref3.date;
	  return date;
	};
	var dateIsUnavailable = function dateIsUnavailable(_ref4) {
	  var date = _ref4.date;
	  return 'Not available. ' + String(date);
	};
	var dateIsSelected = function dateIsSelected(_ref5) {
	  var date = _ref5.date;
	  return 'Selected. ' + String(date);
	};
	
	exports['default'] = {
	  calendarLabel: calendarLabel,
	  closeDatePicker: closeDatePicker,
	  focusStartDate: focusStartDate,
	  clearDate: clearDate,
	  clearDates: clearDates,
	  jumpToPrevMonth: jumpToPrevMonth,
	  jumpToNextMonth: jumpToNextMonth,
	  keyboardShortcuts: keyboardShortcuts,
	  showKeyboardShortcutsPanel: showKeyboardShortcutsPanel,
	  hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
	  openThisPanel: openThisPanel,
	  enterKey: enterKey,
	  leftArrowRightArrow: leftArrowRightArrow,
	  upArrowDownArrow: upArrowDownArrow,
	  pageUpPageDown: pageUpPageDown,
	  homeEnd: homeEnd,
	  escape: escape,
	  questionMark: questionMark,
	  selectFocusedDate: selectFocusedDate,
	  moveFocusByOneDay: moveFocusByOneDay,
	  moveFocusByOneWeek: moveFocusByOneWeek,
	  moveFocusByOneMonth: moveFocusByOneMonth,
	  moveFocustoStartAndEndOfWeek: moveFocustoStartAndEndOfWeek,
	  returnFocusToInput: returnFocusToInput,
	  keyboardNavigationInstructions: keyboardNavigationInstructions,
	
	  chooseAvailableStartDate: chooseAvailableStartDate,
	  chooseAvailableEndDate: chooseAvailableEndDate,
	  dateIsUnavailable: dateIsUnavailable,
	  dateIsSelected: dateIsSelected
	};
	var DateRangePickerPhrases = exports.DateRangePickerPhrases = {
	  calendarLabel: calendarLabel,
	  closeDatePicker: closeDatePicker,
	  clearDates: clearDates,
	  focusStartDate: focusStartDate,
	  jumpToPrevMonth: jumpToPrevMonth,
	  jumpToNextMonth: jumpToNextMonth,
	  keyboardShortcuts: keyboardShortcuts,
	  showKeyboardShortcutsPanel: showKeyboardShortcutsPanel,
	  hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
	  openThisPanel: openThisPanel,
	  enterKey: enterKey,
	  leftArrowRightArrow: leftArrowRightArrow,
	  upArrowDownArrow: upArrowDownArrow,
	  pageUpPageDown: pageUpPageDown,
	  homeEnd: homeEnd,
	  escape: escape,
	  questionMark: questionMark,
	  selectFocusedDate: selectFocusedDate,
	  moveFocusByOneDay: moveFocusByOneDay,
	  moveFocusByOneWeek: moveFocusByOneWeek,
	  moveFocusByOneMonth: moveFocusByOneMonth,
	  moveFocustoStartAndEndOfWeek: moveFocustoStartAndEndOfWeek,
	  returnFocusToInput: returnFocusToInput,
	  keyboardNavigationInstructions: keyboardNavigationInstructions,
	  chooseAvailableStartDate: chooseAvailableStartDate,
	  chooseAvailableEndDate: chooseAvailableEndDate,
	  dateIsUnavailable: dateIsUnavailable,
	  dateIsSelected: dateIsSelected
	};
	
	var DateRangePickerInputPhrases = exports.DateRangePickerInputPhrases = {
	  focusStartDate: focusStartDate,
	  clearDates: clearDates,
	  keyboardNavigationInstructions: keyboardNavigationInstructions
	};
	
	var SingleDatePickerPhrases = exports.SingleDatePickerPhrases = {
	  calendarLabel: calendarLabel,
	  closeDatePicker: closeDatePicker,
	  clearDate: clearDate,
	  jumpToPrevMonth: jumpToPrevMonth,
	  jumpToNextMonth: jumpToNextMonth,
	  keyboardShortcuts: keyboardShortcuts,
	  showKeyboardShortcutsPanel: showKeyboardShortcutsPanel,
	  hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
	  openThisPanel: openThisPanel,
	  enterKey: enterKey,
	  leftArrowRightArrow: leftArrowRightArrow,
	  upArrowDownArrow: upArrowDownArrow,
	  pageUpPageDown: pageUpPageDown,
	  homeEnd: homeEnd,
	  escape: escape,
	  questionMark: questionMark,
	  selectFocusedDate: selectFocusedDate,
	  moveFocusByOneDay: moveFocusByOneDay,
	  moveFocusByOneWeek: moveFocusByOneWeek,
	  moveFocusByOneMonth: moveFocusByOneMonth,
	  moveFocustoStartAndEndOfWeek: moveFocustoStartAndEndOfWeek,
	  returnFocusToInput: returnFocusToInput,
	  keyboardNavigationInstructions: keyboardNavigationInstructions,
	  chooseAvailableDate: chooseAvailableDate,
	  dateIsUnavailable: dateIsUnavailable,
	  dateIsSelected: dateIsSelected
	};
	
	var SingleDatePickerInputPhrases = exports.SingleDatePickerInputPhrases = {
	  clearDate: clearDate,
	  keyboardNavigationInstructions: keyboardNavigationInstructions
	};
	
	var DayPickerPhrases = exports.DayPickerPhrases = {
	  calendarLabel: calendarLabel,
	  jumpToPrevMonth: jumpToPrevMonth,
	  jumpToNextMonth: jumpToNextMonth,
	  keyboardShortcuts: keyboardShortcuts,
	  showKeyboardShortcutsPanel: showKeyboardShortcutsPanel,
	  hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
	  openThisPanel: openThisPanel,
	  enterKey: enterKey,
	  leftArrowRightArrow: leftArrowRightArrow,
	  upArrowDownArrow: upArrowDownArrow,
	  pageUpPageDown: pageUpPageDown,
	  homeEnd: homeEnd,
	  escape: escape,
	  questionMark: questionMark,
	  selectFocusedDate: selectFocusedDate,
	  moveFocusByOneDay: moveFocusByOneDay,
	  moveFocusByOneWeek: moveFocusByOneWeek,
	  moveFocusByOneMonth: moveFocusByOneMonth,
	  moveFocustoStartAndEndOfWeek: moveFocustoStartAndEndOfWeek,
	  returnFocusToInput: returnFocusToInput,
	  chooseAvailableStartDate: chooseAvailableStartDate,
	  chooseAvailableEndDate: chooseAvailableEndDate,
	  chooseAvailableDate: chooseAvailableDate,
	  dateIsUnavailable: dateIsUnavailable,
	  dateIsSelected: dateIsSelected
	};
	
	var DayPickerKeyboardShortcutsPhrases = exports.DayPickerKeyboardShortcutsPhrases = {
	  keyboardShortcuts: keyboardShortcuts,
	  showKeyboardShortcutsPanel: showKeyboardShortcutsPanel,
	  hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
	  openThisPanel: openThisPanel,
	  enterKey: enterKey,
	  leftArrowRightArrow: leftArrowRightArrow,
	  upArrowDownArrow: upArrowDownArrow,
	  pageUpPageDown: pageUpPageDown,
	  homeEnd: homeEnd,
	  escape: escape,
	  questionMark: questionMark,
	  selectFocusedDate: selectFocusedDate,
	  moveFocusByOneDay: moveFocusByOneDay,
	  moveFocusByOneWeek: moveFocusByOneWeek,
	  moveFocusByOneMonth: moveFocusByOneMonth,
	  moveFocustoStartAndEndOfWeek: moveFocustoStartAndEndOfWeek,
	  returnFocusToInput: returnFocusToInput
	};
	
	var DayPickerNavigationPhrases = exports.DayPickerNavigationPhrases = {
	  jumpToPrevMonth: jumpToPrevMonth,
	  jumpToNextMonth: jumpToNextMonth
	};
	
	var CalendarDayPhrases = exports.CalendarDayPhrases = {
	  chooseAvailableDate: chooseAvailableDate,
	  dateIsUnavailable: dateIsUnavailable,
	  dateIsSelected: dateIsSelected
	};

/***/ },
/* 51 */,
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DocumentHeadContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(899);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactIntl = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(14);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _LibrarySelector = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  pageTitle: _react.PropTypes.string,
	  intl: _reactIntl.intlShape.isRequired,
	  libraryFullName: _react.PropTypes.string.isRequired,
	  twitterHandle: _react.PropTypes.string
	};
	
	var DocumentHeadContainer = exports.DocumentHeadContainer = function (_BcReactComponent) {
	  _inherits(DocumentHeadContainer, _BcReactComponent);
	
	  function DocumentHeadContainer() {
	    _classCallCheck(this, DocumentHeadContainer);
	
	    return _possibleConstructorReturn(this, (DocumentHeadContainer.__proto__ || Object.getPrototypeOf(DocumentHeadContainer)).apply(this, arguments));
	  }
	
	  _createClass(DocumentHeadContainer, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          intl = _props.intl,
	          libraryFullName = _props.libraryFullName,
	          twitterHandle = _props.twitterHandle;
	
	      var title = intl.formatMessage({ id: 'pageTitleTemplate' }, { libraryName: libraryFullName, pageTitle: this.props.pageTitle });
	      var meta = [{ property: 'og:title', content: title }, { property: 'twitter:title', content: title }, { property: 'og:site_name', content: libraryFullName }, { charset: 'utf-8' }, { name: 'viewport', content: 'width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=1' }].concat(_toConsumableArray(twitterHandle ? [{ property: 'twitter:creator', content: '@' + twitterHandle }] : []));
	      return _react2.default.createElement(_reactHelmet2.default, {
	        title: title,
	        defaultTitle: intl.formatMessage({ id: 'defaultPageTitle' }, { libraryName: libraryFullName }),
	        meta: meta });
	    }
	  }]);
	
	  return DocumentHeadContainer;
	}(_baseBcReactComponent2.default);
	
	DocumentHeadContainer.propTypes = propTypes;
	
	function mapStateToProps(state) {
	  var library = (0, _LibrarySelector.currentLibrarySelector)(state);
	  return {
	    libraryFullName: library.get('fullName'),
	    currentLanguage: state.getIn(['localization', 'currentLanguage']),
	    twitterHandle: library.get('twitterHandle')
	  };
	}
	
	exports.default = (0, _reactIntl.injectIntl)((0, _reactRedux.connect)(mapStateToProps)(DocumentHeadContainer));

/***/ },
/* 53 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 54 */,
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// modified from https://github.com/es-shims/es6-shim
	var keys = __webpack_require__(844);
	var canBeObject = function (obj) {
		return typeof obj !== 'undefined' && obj !== null;
	};
	
	var assignShim = function assign(target, source1) {
		if (!canBeObject(target)) { throw new TypeError('target must be an object'); }
		var objTarget = Object(target);
		var s, source, i, props;
		for (s = 1; s < arguments.length; ++s) {
			source = Object(arguments[s]);
			props = keys(source);
			for (i = 0; i < props.length; ++i) {
				objTarget[props[i]] = source[props[i]];
			}
		}
		return objTarget;
	};
	
	assignShim.shim = function shimObjectAssign() {
		if (!Object.assign) {
			Object.assign = assignShim;
		}
		return Object.assign || assignShim;
	};
	
	module.exports = assignShim;
	


/***/ },
/* 56 */,
/* 57 */,
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Checkbox = __webpack_require__(1057);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Checkbox).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isVisibleInViewPort = isVisibleInViewPort;
	exports.getCookie = getCookie;
	exports.setCookie = setCookie;
	exports.isCurrentUrl = isCurrentUrl;
	exports.getTextFromPasteEvent = getTextFromPasteEvent;
	exports.fixedEncodeURIComponent = fixedEncodeURIComponent;
	exports.getScrollTop = getScrollTop;
	exports.openPopUpWindow = openPopUpWindow;
	
	var _cookie = __webpack_require__(651);
	
	function isVisibleInViewPort(el) {
	  var rect = el.getBoundingClientRect();
	  return rect.top >= 0 || rect.bottom >= 0;
	}
	
	/**
	 * Gets the value of the cookie at `key`.
	 * @param  {string} key
	 * @return {string}
	 */
	function getCookie(key) {
	  if (!document) return undefined;
	  return (0, _cookie.parse)(document.cookie)[key];
	}
	
	/**
	 * Sets a document cookie with the given args.
	 * @see https://github.com/jshttp/cookie#serialize
	 *
	 * @param {string} key
	 * @param {string} val
	 * @param {object} opts
	 */
	function setCookie(key, val, opts) {
	  if (!document) return;
	  document.cookie = (0, _cookie.serialize)(key, '' + val, opts);
	}
	
	var urlWithoutHash = function urlWithoutHash(url) {
	  var hashIndex = url.lastIndexOf('#');
	  return url.substring(0, hashIndex >= 0 ? hashIndex : url.length);
	};
	
	/**
	 * Checks if the URL is the same as the browser's current URL
	 *
	 * @param {string} url
	 */
	function isCurrentUrl(url) {
	  return urlWithoutHash(url) === urlWithoutHash(window.location.href);
	}
	
	function getTextFromPasteEvent(e) {
	  if (e.clipboardData) {
	    try {
	      return e.clipboardData.getData('text/plain');
	    } catch (err) {
	      // IE11 does not support "text/plain", but does support "text".
	      return e.clipboardData.getData('text');
	    }
	  }
	
	  return null;
	}
	
	/**
	 * Encodes additional special characters in the string value passed
	 *
	 * @param {string} str
	 * Resource: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURIComponent
	 */
	
	function fixedEncodeURIComponent(str) {
	  return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16);
	  });
	}
	
	function getScrollTop() {
	  if (window && document) {
	    // See http://stackoverflow.com/questions/28633221/document-body-scrolltop-firefox-returns-0-only-js
	    return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
	  }
	
	  return 0;
	}
	
	/**
	 * Opens a new pop up window when called.
	 *
	 * @param {object} { url, target, width, height }
	 *
	 */
	
	function openPopUpWindow(_ref) {
	  var url = _ref.url,
	      _ref$target = _ref.target,
	      target = _ref$target === undefined ? '_blank' : _ref$target,
	      width = _ref.width,
	      height = _ref.height;
	
	  var windowFeatures = {
	    resizable: 1,
	    status: 0,
	    toolbar: 0,
	    scrollbars: 1,
	    location: 0,
	    menubar: 0,
	    width: width,
	    height: height
	  };
	
	  windowFeatures = Object.keys(windowFeatures).map(function (attribute) {
	    return attribute + '=' + windowFeatures[attribute];
	  }).join(',');
	
	  window.open(url, target, windowFeatures);
	}

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ShortFormattedDate = __webpack_require__(1974);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ShortFormattedDate).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 61 */,
/* 62 */,
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = getPhrasePropTypes;
	
	var _object = __webpack_require__(55);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _propTypes = __webpack_require__(27);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function getPhrasePropTypes(defaultPhrases) {
	  return Object.keys(defaultPhrases).reduce(function (phrases, key) {
	    return (0, _object2['default'])({}, phrases, _defineProperty({}, key, _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].func, _propTypes2['default'].node])));
	  }, {});
	}

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _generic = __webpack_require__(368);
	
	Object.defineProperty(exports, 'Generic', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_generic).default;
	  }
	});
	
	var _genericForm = __webpack_require__(1492);
	
	Object.defineProperty(exports, 'GenericForm', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_genericForm).default;
	  }
	});
	
	var _toastMessage = __webpack_require__(1495);
	
	Object.defineProperty(exports, 'ToastMessage', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_toastMessage).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 65 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ },
/* 66 */,
/* 67 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.composeAnalytics = composeAnalytics;
	exports.composeEvent = composeEvent;
	function composeAnalytics(events) {
	  return {
	    events: events
	  };
	}
	
	function composeEvent(name, payload) {
	  return {
	    event: name,
	    payload: payload
	  };
	}
	
	exports.default = {
	  composeAnalytics: composeAnalytics,
	  composeEvent: composeEvent
	};

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _reactRedux = __webpack_require__(14);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _MessagingActions = __webpack_require__(181);
	
	var _MessagingActions2 = _interopRequireDefault(_MessagingActions);
	
	var _MessagingSelector = __webpack_require__(399);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function MessagingContainer(_ref) {
	  var messaging = _ref.messaging,
	      id = _ref.id,
	      dispatch = _ref.dispatch,
	      children = _ref.children;
	
	  if (messaging && messaging.get('message')) {
	    return children({
	      message: messaging.get('message'),
	      fieldErrors: messaging.get('fieldErrors'),
	      duration: messaging.get('duration'),
	      failureDuration: messaging.get('failureDuration'),
	      values: messaging.get('values'),
	      clearMessages: function clearMessages() {
	        return dispatch(_MessagingActions2.default.clearMessages(id));
	      }
	    }, dispatch);
	  }
	
	  return null;
	}
	
	MessagingContainer.propTypes = {
	  id: _react.PropTypes.string.isRequired,
	  messaging: _bcPropTypes.messagingShape,
	  dispatch: _react.PropTypes.func.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  var id = ownProps.id;
	
	  var messaging = (0, _MessagingSelector.getMessaging)(state).get(id);
	  return { id: id, messaging: messaging };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(MessagingContainer);

/***/ },
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.withStylesPropTypes = exports.css = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.withStyles = withStyles;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(27);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _hoistNonReactStatics = __webpack_require__(446);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _deepmerge = __webpack_require__(2434);
	
	var _deepmerge2 = _interopRequireDefault(_deepmerge);
	
	var _constants = __webpack_require__(3105);
	
	var _brcast = __webpack_require__(3106);
	
	var _brcast2 = _interopRequireDefault(_brcast);
	
	var _ThemedStyleSheet = __webpack_require__(918);
	
	var _ThemedStyleSheet2 = _interopRequireDefault(_ThemedStyleSheet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// Add some named exports to assist in upgrading and for convenience
	var css = exports.css = _ThemedStyleSheet2['default'].resolveLTR;
	var withStylesPropTypes = exports.withStylesPropTypes = {
	  styles: _propTypes2['default'].object.isRequired, // eslint-disable-line react/forbid-prop-types
	  theme: _propTypes2['default'].object.isRequired, // eslint-disable-line react/forbid-prop-types
	  css: _propTypes2['default'].func.isRequired
	};
	
	var EMPTY_STYLES = {};
	var EMPTY_STYLES_FN = function EMPTY_STYLES_FN() {
	  return EMPTY_STYLES;
	};
	
	function baseClass(pureComponent) {
	  if (pureComponent) {
	    if (!_react2['default'].PureComponent) {
	      throw new ReferenceError('withStyles() pureComponent option requires React 15.3.0 or later');
	    }
	
	    return _react2['default'].PureComponent;
	  }
	
	  return _react2['default'].Component;
	}
	
	var contextTypes = _defineProperty({}, _constants.CHANNEL, _brcast2['default']);
	
	var defaultDirection = _constants.DIRECTIONS.LTR;
	
	function withStyles(styleFn) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$stylesPropName = _ref.stylesPropName,
	      stylesPropName = _ref$stylesPropName === undefined ? 'styles' : _ref$stylesPropName,
	      _ref$themePropName = _ref.themePropName,
	      themePropName = _ref$themePropName === undefined ? 'theme' : _ref$themePropName,
	      _ref$cssPropName = _ref.cssPropName,
	      cssPropName = _ref$cssPropName === undefined ? 'css' : _ref$cssPropName,
	      _ref$flushBefore = _ref.flushBefore,
	      flushBefore = _ref$flushBefore === undefined ? false : _ref$flushBefore,
	      _ref$pureComponent = _ref.pureComponent,
	      pureComponent = _ref$pureComponent === undefined ? false : _ref$pureComponent;
	
	  var styleDefLTR = void 0;
	  var styleDefRTL = void 0;
	  var currentThemeLTR = void 0;
	  var currentThemeRTL = void 0;
	  var BaseClass = baseClass(pureComponent);
	
	  function getResolveMethod(direction) {
	    return direction === _constants.DIRECTIONS.LTR ? _ThemedStyleSheet2['default'].resolveLTR : _ThemedStyleSheet2['default'].resolveRTL;
	  }
	
	  function getCurrentTheme(direction) {
	    return direction === _constants.DIRECTIONS.LTR ? currentThemeLTR : currentThemeRTL;
	  }
	
	  function getStyleDef(direction, wrappedComponentName) {
	    var currentTheme = getCurrentTheme(direction);
	    var styleDef = direction === _constants.DIRECTIONS.LTR ? styleDefLTR : styleDefRTL;
	
	    var registeredTheme = _ThemedStyleSheet2['default'].get();
	
	    // Return the existing styles if they've already been defined
	    // and if the theme used to create them corresponds to the theme
	    // registered with ThemedStyleSheet
	    if (styleDef && currentTheme === registeredTheme) {
	      return styleDef;
	    }
	
	    if (false) {
	      performance.mark('react-with-styles.createStyles.start');
	    }
	
	    var isRTL = direction === _constants.DIRECTIONS.RTL;
	
	    if (isRTL) {
	      styleDefRTL = styleFn ? _ThemedStyleSheet2['default'].createRTL(styleFn) : EMPTY_STYLES_FN;
	
	      currentThemeRTL = registeredTheme;
	      styleDef = styleDefRTL;
	    } else {
	      styleDefLTR = styleFn ? _ThemedStyleSheet2['default'].createLTR(styleFn) : EMPTY_STYLES_FN;
	
	      currentThemeLTR = registeredTheme;
	      styleDef = styleDefLTR;
	    }
	
	    if (false) {
	      performance.mark('react-with-styles.createStyles.end');
	
	      performance.measure('\uD83D\uDC69\u200D\uD83C\uDFA8 withStyles(' + String(wrappedComponentName) + ') [create styles]', 'react-with-styles.createStyles.start', 'react-with-styles.createStyles.end');
	    }
	
	    return styleDef;
	  }
	
	  function getState(direction, wrappedComponentName) {
	    return {
	      resolveMethod: getResolveMethod(direction),
	      styleDef: getStyleDef(direction, wrappedComponentName)
	    };
	  }
	
	  return function () {
	    function withStylesHOC(WrappedComponent) {
	      var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	
	      // NOTE: Use a class here so components are ref-able if need be:
	      // eslint-disable-next-line react/prefer-stateless-function
	
	      var WithStyles = function (_BaseClass) {
	        _inherits(WithStyles, _BaseClass);
	
	        function WithStyles(props, context) {
	          _classCallCheck(this, WithStyles);
	
	          var _this = _possibleConstructorReturn(this, (WithStyles.__proto__ || Object.getPrototypeOf(WithStyles)).call(this, props, context));
	
	          var direction = _this.context[_constants.CHANNEL] ? _this.context[_constants.CHANNEL].getState() : defaultDirection;
	
	          _this.state = getState(direction, wrappedComponentName);
	          return _this;
	        }
	
	        _createClass(WithStyles, [{
	          key: 'componentDidMount',
	          value: function () {
	            function componentDidMount() {
	              var _this2 = this;
	
	              if (this.context[_constants.CHANNEL]) {
	                // subscribe to future direction changes
	                this.channelUnsubscribe = this.context[_constants.CHANNEL].subscribe(function (direction) {
	                  _this2.setState(getState(direction, wrappedComponentName));
	                });
	              }
	            }
	
	            return componentDidMount;
	          }()
	        }, {
	          key: 'componentWillUnmount',
	          value: function () {
	            function componentWillUnmount() {
	              if (this.channelUnsubscribe) {
	                this.channelUnsubscribe();
	              }
	            }
	
	            return componentWillUnmount;
	          }()
	        }, {
	          key: 'render',
	          value: function () {
	            function render() {
	              var _ref2;
	
	              // As some components will depend on previous styles in
	              // the component tree, we provide the option of flushing the
	              // buffered styles (i.e. to a style tag) **before** the rendering
	              // cycle begins.
	              //
	              // The interfaces provide the optional "flush" method which
	              // is run in turn by ThemedStyleSheet.flush.
	              if (flushBefore) {
	                _ThemedStyleSheet2['default'].flush();
	              }
	
	              var _state = this.state,
	                  resolveMethod = _state.resolveMethod,
	                  styleDef = _state.styleDef;
	
	
	              return _react2['default'].createElement(WrappedComponent, _extends({}, this.props, (_ref2 = {}, _defineProperty(_ref2, themePropName, _ThemedStyleSheet2['default'].get()), _defineProperty(_ref2, stylesPropName, styleDef()), _defineProperty(_ref2, cssPropName, resolveMethod), _ref2)));
	            }
	
	            return render;
	          }()
	        }]);
	
	        return WithStyles;
	      }(BaseClass);
	
	      WithStyles.WrappedComponent = WrappedComponent;
	      WithStyles.displayName = 'withStyles(' + String(wrappedComponentName) + ')';
	      WithStyles.contextTypes = contextTypes;
	      if (WrappedComponent.propTypes) {
	        WithStyles.propTypes = (0, _deepmerge2['default'])({}, WrappedComponent.propTypes);
	        delete WithStyles.propTypes[stylesPropName];
	        delete WithStyles.propTypes[themePropName];
	        delete WithStyles.propTypes[cssPropName];
	      }
	      if (WrappedComponent.defaultProps) {
	        WithStyles.defaultProps = (0, _deepmerge2['default'])({}, WrappedComponent.defaultProps);
	      }
	
	      return (0, _hoistNonReactStatics2['default'])(WithStyles, WrappedComponent);
	    }
	
	    return withStylesHOC;
	  }();
	}

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.STATUS_TYPES = exports.GLOBAL_MESSAGING_ID = undefined;
	
	var _keymirror = __webpack_require__(325);
	
	var _keymirror2 = _interopRequireDefault(_keymirror);
	
	var _utilsRedux = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GLOBAL_MESSAGING_ID = exports.GLOBAL_MESSAGING_ID = 'global-messaging-id';
	
	var STATUS_TYPES = exports.STATUS_TYPES = (0, _keymirror2.default)({
	  Success: null,
	  Failure: null,
	  Neutral: null
	});
	
	exports.default = (0, _utilsRedux.createReduxConstants)('MESSAGING', {
	  CLEAR_MESSAGING: null
	});

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BATCH_ACTIONS = exports.BATCH_CANCEL_HOLD_WORKFLOW = exports.SAVED_SEARCH_WORKFLOW = exports.BATCH_ADDED_TO_SHELF_WORKFLOW = exports.ADDED_TO_SHELF_WORKFLOW = exports.ITEM_TRANSACTION_WORKFLOW = undefined;
	
	var _utilsRedux = __webpack_require__(20);
	
	var ITEM_TRANSACTION_WORKFLOW = exports.ITEM_TRANSACTION_WORKFLOW = 'ITEM_TRANSACTION_WORKFLOW';
	var ADDED_TO_SHELF_WORKFLOW = exports.ADDED_TO_SHELF_WORKFLOW = 'ADDED_TO_SHELF_WORKFLOW';
	var BATCH_ADDED_TO_SHELF_WORKFLOW = exports.BATCH_ADDED_TO_SHELF_WORKFLOW = 'BATCH_ADDED_TO_SHELF_WORKFLOW';
	var SAVED_SEARCH_WORKFLOW = exports.SAVED_SEARCH_WORKFLOW = 'SAVED_SEARCH_WORKFLOW';
	var BATCH_CANCEL_HOLD_WORKFLOW = exports.BATCH_CANCEL_HOLD_WORKFLOW = 'BATCH_CANCEL_HOLD_WORKFLOW';
	
	var BATCH_ACTIONS = exports.BATCH_ACTIONS = 'BATCH_ACTIONS';
	
	exports.default = (0, _utilsRedux.createReduxConstants)('WORKFLOW', {
	  UPDATE_WORKFLOW: null
	});

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getShelfTransactions = exports.getImportResult = exports.getShelvesSummary = exports.getShelvesForCurrentUser = exports.getRequestedShelf = exports.getShelfOwner = exports.getActiveShelfFilters = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _reselect = __webpack_require__(34);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _AuthSelector = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapAppliedFilters = function mapAppliedFilters(field) {
	  return [field.get('id'), field.get('fieldFilters').filter(function (filter) {
	    return filter.get('applied') === true;
	  })];
	};
	var filterAppliedFilters = function filterAppliedFilters(_ref) {
	  var _ref2 = _slicedToArray(_ref, 2),
	      fieldId = _ref2[0],
	      appliedFilters = _ref2[1];
	
	  return fieldId && !appliedFilters.isEmpty();
	};
	var getShelfSearch = function getShelfSearch(state) {
	  return state.getIn(['shelves', 'shelfSearch'], _immutable2.default.Map());
	};
	var usersSelector = function usersSelector(state) {
	  return state.getIn(['entities', 'users'], _immutable2.default.Map());
	};
	var getShelves = function getShelves(state) {
	  return state.getIn(['entities', 'shelves'], _immutable2.default.Map());
	};
	var importResultState = function importResultState(state) {
	  return state.getIn(['shelves', 'importResult'], _immutable2.default.Map());
	};
	var shelfTransactionsState = function shelfTransactionsState(state) {
	  return state.getIn(['shelves', 'shelfTransactions'], _immutable2.default.Map());
	};
	
	var getActiveShelfFilters = exports.getActiveShelfFilters = (0, _reselect.createSelector)([getShelfSearch], function (shelfSearch) {
	  return _immutable2.default.Map(shelfSearch.getIn(['shelf', 'facets']).map(mapAppliedFilters).filter(filterAppliedFilters));
	});
	
	var getShelfOwner = exports.getShelfOwner = (0, _reselect.createSelector)([getShelfSearch, usersSelector], function (shelfSearch, users) {
	  return users.find(function (user) {
	    return user.get('id') === shelfSearch.getIn(['shelf', 'userId']);
	  }) || _immutable2.default.Map();
	});
	
	var getRequestedShelf = exports.getRequestedShelf = (0, _reselect.createSelector)([getShelfSearch, getShelves], function (shelfSearch, shelvesByUserId) {
	  var shelfItems = shelvesByUserId.get('' + shelfSearch.getIn(['shelf', 'userId']));
	  return shelfSearch.get('shelf', _immutable2.default.Map()).withMutations(function (newShelf) {
	    var mappedItems = newShelf.get('items', _immutable2.default.List()).map(function (id) {
	      return shelfItems.get('' + id);
	    });
	    return newShelf.set('items', mappedItems.filter(function (item) {
	      return !!item;
	    }));
	  });
	});
	
	var getShelvesForCurrentUser = exports.getShelvesForCurrentUser = (0, _reselect.createSelector)([getShelves, _AuthSelector.currentUserSelector], function (shelvesByUserId, user) {
	  var shelves = user && user.get('id') ? shelvesByUserId.get('' + user.get('id'), _immutable2.default.Map()) : _immutable2.default.Map();
	  return _immutable2.default.Map(shelves.toList().map(function (item) {
	    return [item.get('metadataId'), item];
	  }));
	});
	
	var getShelvesSummary = exports.getShelvesSummary = (0, _reselect.createSelector)([getShelfSearch], function (shelfSearch) {
	  return shelfSearch.get('summary', _immutable2.default.Map());
	});
	
	var getImportResult = exports.getImportResult = (0, _reselect.createSelector)([importResultState], function (importResult) {
	  return importResult;
	});
	
	var getShelfTransactions = exports.getShelfTransactions = (0, _reselect.createSelector)([shelfTransactionsState], function (shelfTransactions) {
	  return shelfTransactions;
	});
	
	exports.default = {
	  getActiveShelfFilters: getActiveShelfFilters,
	  getRequestedShelf: getRequestedShelf,
	  getShelfOwner: getShelfOwner,
	  getShelvesSummary: getShelvesSummary,
	  getShelvesForCurrentUser: getShelvesForCurrentUser,
	  getImportResult: getImportResult,
	  getShelfTransactions: getShelfTransactions
	};

/***/ },
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Button = __webpack_require__(1035);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Button).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _inlineOverlay = __webpack_require__(1325);
	
	Object.defineProperty(exports, 'InlineOverlay', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_inlineOverlay).default;
	  }
	});
	
	var _inlineOverlayBody = __webpack_require__(1318);
	
	Object.defineProperty(exports, 'InlineOverlayBody', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_inlineOverlayBody).default;
	  }
	});
	
	var _inlineOverlayCloseButton = __webpack_require__(521);
	
	Object.defineProperty(exports, 'InlineOverlayCloseButton', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_inlineOverlayCloseButton).default;
	  }
	});
	
	var _inlineOverlayFooter = __webpack_require__(1321);
	
	Object.defineProperty(exports, 'InlineOverlayFooter', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_inlineOverlayFooter).default;
	  }
	});
	
	var _inlineOverlayHeader = __webpack_require__(1323);
	
	Object.defineProperty(exports, 'InlineOverlayHeader', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_inlineOverlayHeader).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(32),
	    _assign = __webpack_require__(29);
	
	var CallbackQueue = __webpack_require__(874);
	var PooledClass = __webpack_require__(166);
	var ReactFeatureFlags = __webpack_require__(883);
	var ReactReconciler = __webpack_require__(167);
	var Transaction = __webpack_require__(345);
	
	var invariant = __webpack_require__(19);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ },
/* 90 */,
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _placeholder = __webpack_require__(1348);
	
	Object.defineProperty(exports, 'Placeholder', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_placeholder).default;
	  }
	});
	
	var _table = __webpack_require__(1356);
	
	Object.defineProperty(exports, 'Table', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_table).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Pagination = __webpack_require__(1443);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Pagination).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _JacketCover = __webpack_require__(1489);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_JacketCover).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ProgressBar = __webpack_require__(1504);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ProgressBar).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getFocusableElement = getFocusableElement;
	exports.getNextFocusableElement = getNextFocusableElement;
	exports.setFocusWithinElement = setFocusWithinElement;
	exports.getActiveElement = getActiveElement;
	
	var _reactDom = __webpack_require__(104);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HEADINGS_SELECTOR = 'h1, h2, h3, h4, h5, h6';
	var FOCUSABLE_SELECTOR = 'a[href], area[href], input:not([disabled]):not([type=hidden]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), object, embed, [tabindex="0"], [tabindex="-1"], [contenteditable], audio[controls], video[controls], summary';
	
	function isMatchingElement(element, selector) {
	  var matches = element.matches || element.msMatchesSelector || element.webkitMatchesSelector;
	  return matches.call(element, selector);
	}
	
	function isVisibleElement(element) {
	  return element.offsetParent && window.getComputedStyle(element).visibility !== 'hidden';
	}
	
	function isFocusable(element) {
	  return isMatchingElement(element, FOCUSABLE_SELECTOR);
	}
	
	function isFocusableAndVisibleElement(element) {
	  return isFocusable(element) && isVisibleElement(element);
	}
	
	/**
	 * Returns the given element or component if it's "focusable" and "visible", otherwise returns the first "focusable"
	 * and visible element within it. See the FOCUSABLE_SELECTOR for what's considered a focusable element.
	 * @param {HTMLElement|ReactComponent} elementOrComponent
	 * @return {HTMLElement}
	 */
	function getFocusableElement(elementOrComponent) {
	  var element = _reactDom2.default.findDOMNode(elementOrComponent); // eslint-disable-line react/no-find-dom-node
	
	  if (isFocusableAndVisibleElement(element)) {
	    return element;
	  }
	
	  var allFocusableElements = element.querySelectorAll(FOCUSABLE_SELECTOR);
	  return [].find.call(allFocusableElements, function (focusableElement) {
	    return isVisibleElement(focusableElement);
	  });
	}
	
	/**
	 * Gets the first "focusable" and "visible" element which appears in the DOM after the given element or component.
	 * @param {HTMLElement|ReactComponent} elementOrComponent
	 * @return {HTMLElement}
	 */
	function getNextFocusableElement(elementOrComponent) {
	  var element = _reactDom2.default.findDOMNode(elementOrComponent); // eslint-disable-line react/no-find-dom-node
	
	  if (element.nextElementSibling) {
	    var focusableElement = getFocusableElement(element.nextElementSibling);
	    return focusableElement || getNextFocusableElement(element.nextElementSibling);
	  } else if (element.parentElement) {
	    return getNextFocusableElement(element.parentElement);
	  }
	
	  return undefined;
	}
	
	/**
	 * Sets focus on the first "focusable" element within the given element.
	 * NOTE: Heading elements are considered "focusable" and are prefered over any other focusable elements within the given element.
	 * To override this priority use a "data-focusable" attribute on the element or any descendant that you want to recieve focus instead.
	 * NOTE: If you already know that your element is natively focusable and visible, then just call .focus() on it. Using this helper will not work.
	 * @param {HTMLElement|ReactComponent} elementOrComponent
	 */
	function setFocusWithinElement(elementOrComponent) {
	  var element = _reactDom2.default.findDOMNode(elementOrComponent); // eslint-disable-line react/no-find-dom-node
	
	  // Try setting focus on [data-focusable] and headings first, regardless whether it's focusable or not.
	  var preferredElement = element.querySelector('[data-focusable]') || element.querySelector(HEADINGS_SELECTOR);
	  if (preferredElement && isVisibleElement(preferredElement)) {
	    if (!isFocusable(preferredElement)) {
	      preferredElement.setAttribute('tabindex', -1);
	    }
	    return preferredElement.focus();
	  }
	
	  // Try focusing on the first "focusable" element within it.
	  var focusableElement = getFocusableElement(elementOrComponent);
	  if (focusableElement) {
	    return focusableElement.focus();
	  }
	
	  return undefined;
	}
	
	/**
	 * Handles retrieving activeElement correctly from document; created to handle ie11 inside of an iframe
	 * modified from: https://gist.github.com/Alex1990/046a6553dc83e22dd6f4
	 * @param {HTMLDocument} document
	 * @return {HTMLElement}
	 */
	function getActiveElement(document) {
	  var activeElement = void 0;
	
	  try {
	    activeElement = document.activeElement;
	    if (!activeElement || !activeElement.nodeName) {
	      activeElement = document.body;
	    }
	  } catch (error) {
	    activeElement = document.body;
	  }
	
	  return activeElement;
	}

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getIconForFormat = getIconForFormat;
	exports.getDigitalFormatTypeString = getDigitalFormatTypeString;
	exports.getDefaultImage = getDefaultImage;
	var iconMap = {
	  AB: 'icon icon-headphones',
	  ACCESSIBLE_FORMATS: 'icon icon-font',
	  AUDIOBOOKS_SPOKEN_WORD: 'icon icon-headphones',
	  BK: 'icon icon-book-open',
	  BLURAY: 'icon icon-cd',
	  BOARD_BK: 'icon icon-book-open',
	  BOOK_CD: 'icon icon-headphones',
	  BOOK_PCD: 'icon icon-book-open',
	  BOOKS: 'icon icon-book-open',
	  CDROM: 'icon icon-cd',
	  CS: 'icon icon-headphones',
	  DVD: 'icon icon-cd',
	  EBOOK: 'icon icon-tablet',
	  DEVICE: 'icon icon-tablet',
	  FILM: 'icon icon-videocam',
	  GAMES_INTERACTIVE_MEDIA: 'icon icon-gamepad',
	  GRAPHIC_NOVEL: 'icon icon-book-open',
	  JOURNALS_MAGAZINES: 'icon icon-newspaper',
	  LPRINT: 'icon icon-font',
	  MN: 'icon icon-music',
	  MOVIES_TV_VIDEO: 'icon icon-videocam',
	  MP3_CD: 'icon icon-headphones',
	  MUSIC_CD: 'icon icon-music',
	  MUSIC_CS: 'icon icon-music',
	  MUSIC_MP3_CD: 'icon icon-music',
	  MUSIC_SOUND: 'icon icon-music',
	  MUSIC_DOWNLOAD: 'icon icon-music',
	  MUSIC_ONLINE: 'icon icon-music',
	  LP: 'icon icon-music',
	  NEWSPAPER: 'icon icon-newspaper',
	  MAG: 'icon icon-newspaper',
	  EJ: 'icon icon-newspaper',
	  OTHER: 'icon icon-plus',
	  PAPERBACK: 'icon icon-book-open',
	  PLAYAWAY_AUDIOBOOK: 'icon icon-headphones',
	  PLAYAWAY_MUSIC: 'icon icon-music',
	  VC: 'icon icon-videocam',
	  VIDEO_GAME: 'icon icon-gamepad',
	  VIDEO_ONLINE: 'icon icon-videocam',
	  BR: 'icon icon-font',
	  ATLAS: 'icon icon-book-open',
	  PASS: 'icon icon-book-open',
	  SPOKEN_CD: 'icon icon-headphones',
	  VIDEO_DOWNLOAD: 'icon icon-videocam'
	};
	
	function getIconForFormat(format) {
	  if (iconMap[format]) {
	    return iconMap[format];
	  }
	  return 'icon icon-plus';
	}
	
	function getDigitalFormatTypeString(formatName) {
	  switch (formatName) {
	    case 'VIDEO':
	    case 'STREAMING_VIDEO':
	      return 'video';
	    case 'MUSIC':
	    case 'MUSIC_ONLINE':
	      return 'music';
	    case 'OVERDRIVE_MP3_AUDIOBOOK':
	    case 'OVERDRIVE_WMA_AUDIOBOOK':
	      return 'audiobook';
	    case 'OVERDRIVE_MEDIA_DO':
	      return 'media_do';
	    default:
	      return 'ebook';
	  }
	}
	
	/* istanbul ignore next */
	/* eslint-disable global-require */
	function getDefaultImage(format) {
	  // Dynamic requires are to be avoided in webpack because webpack will
	  // include the whole directory recursively since it can't figure out what needs
	  // to be included at compile time.
	  //
	  // The fix for this is to create a context for the require and pass the regex
	  // for the files to require.
	
	  // However require.context doesn't work on server side need to upgrade WebpackIsomorphicTools.
	  // For now we will hardcode the URLs and created CORE-34581.
	  // TODO: CORE-34581 - Upgrade WebpackIsomorphicTools so we don't have to hardcode image URLs
	
	  switch (format) {
	    case 'AB':
	      return __webpack_require__(3423);
	    case 'BK':
	    case 'BOARD_BK':
	    case 'BOOK_CLUB_KIT':
	    case 'BOOK_PCD':
	    case 'GRAPHIC_NOVEL':
	    case 'PAPERBACK':
	      return __webpack_require__(3426);
	    case 'RESTRICTED_BOOK_CD':
	    case 'SPOKEN_CD':
	    case 'TB':
	    case 'DAISY':
	      return __webpack_require__(968);
	    case 'RESTRICTED_BOOK_CS':
	    case 'CS':
	      return __webpack_require__(3422);
	    case 'EBOOK':
	      return __webpack_require__(3424);
	    case 'LPRINT':
	      return __webpack_require__(3425);
	    case 'FILM':
	    case 'NONSTANDARD_VIDEO':
	      return __webpack_require__(3434);
	    case 'BLURAY':
	    case 'DVD':
	      return __webpack_require__(3431);
	    case 'VC':
	      return __webpack_require__(3432);
	    case 'VIDEO_DOWNLOAD':
	    case 'VIDEO_ONLINE':
	      return __webpack_require__(3433);
	    case 'MP3_CD':
	    case 'BOOK_CD':
	      return __webpack_require__(968);
	    case 'CDROM':
	    case 'VIDEO_GAME':
	      return __webpack_require__(3428);
	    case 'COMIC_BK':
	    case 'MAG':
	    case 'NEWSPAPER':
	      return __webpack_require__(3430);
	    case 'EJ':
	      return __webpack_require__(3429);
	    case 'WEBSITE':
	      return __webpack_require__(3441);
	    case 'LP':
	      return __webpack_require__(3438);
	    case 'MN':
	    case 'MANUSCRIPT_MUSIC':
	      return __webpack_require__(3437);
	    case 'MUSIC_CD':
	      return __webpack_require__(3435);
	    case 'MUSIC_ONLINE':
	    case 'MUSIC_DOWNLOAD':
	      return __webpack_require__(3436);
	    case 'DEVICE':
	    case 'PLAYAWAY_AUDIOBOOK':
	    case 'PLAYAWAY_MUSIC':
	    case 'PRELOADED_EBOOK':
	    case 'PRELOADED_VIDEO_PLAYER':
	      return __webpack_require__(3427);
	    case 'ONLINE_IMAGE':
	      return __webpack_require__(3440);
	    default:
	      return __webpack_require__(3439);
	  }
	}
	/* eslint-enable global-require */
	
	exports.default = {
	  getIconForFormat: getIconForFormat,
	  getDigitalFormatTypeString: getDigitalFormatTypeString,
	  getDefaultImage: getDefaultImage
	};

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getAuthorLink = exports.metadataIdFixer = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _lodash = __webpack_require__(16);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var metadataIdFixer = exports.metadataIdFixer = function metadataIdFixer(id) {
	  if (!id) {
	    throw new Error('metadataIdFixer requires a metadataId');
	  }
	
	  // Support Legacy Bib IDs
	  if (id.match(/^\d+$/)) {
	    return id;
	  }
	
	  var _id$split = id.split(/[SC]/g),
	      _id$split2 = _slicedToArray(_id$split, 3),
	      _blank = _id$split2[0],
	      sourceLibId = _id$split2[1],
	      bibId = _id$split2[2]; // eslint-disable-line no-unused-vars
	
	
	  var paddedSourceLibId = _lodash2.default.padStart(sourceLibId, 3, '0');
	
	  return '' + bibId + paddedSourceLibId;
	};
	
	var getAuthorLink = exports.getAuthorLink = function getAuthorLink(author) {
	  return '/search?q=' + encodeURIComponent(author) + '&search_category=author&t=author';
	};
	
	// TODO: get rid of the default export.  named exports only in utils/helper files
	exports.default = {
	  metadataIdFixer: metadataIdFixer,
	  getAuthorLink: getAuthorLink
	};

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.WORKFLOW_VIEWS = exports.HOLD_DATE_FORMAT = undefined;
	
	var _keymirror = __webpack_require__(325);
	
	var _keymirror2 = _interopRequireDefault(_keymirror);
	
	var _utilsRedux = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HOLD_DATE_FORMAT = exports.HOLD_DATE_FORMAT = 'YYYY-MM-DD';
	
	var WORKFLOW_VIEWS = exports.WORKFLOW_VIEWS = (0, _keymirror2.default)({
	  PHYSICAL_HOLD: null,
	  DIGITAL_HOLD: null,
	  DIGITAL_CHECKOUT: null,
	  DIGITAL_MISSING_FORMAT: null,
	  CANCEL_HOLD: null,
	  ITEM_LEVEL_HOLD: null,
	  PAUSE_HOLD: null
	});
	
	exports.default = (0, _utilsRedux.createReduxConstants)('HOLDS', {
	  PLACE_HOLD_REQUEST: null,
	  PLACE_HOLD_SUCCESS: null,
	  PLACE_HOLD_FAILURE: null,
	  CANCEL_HOLD_REQUEST: null,
	  CANCEL_HOLD_SUCCESS: null,
	  CANCEL_HOLD_FAILURE: null,
	  FETCH_ITEM_GROUPS_REQUEST: null,
	  FETCH_ITEM_GROUPS_SUCCESS: null,
	  FETCH_ITEM_GROUPS_FAILURE: null,
	  UPDATE_PICKUP_LOCATION: null,
	  FETCH_HOLDS_REQUEST: null,
	  FETCH_HOLDS_SUCCESS: null,
	  FETCH_HOLDS_FAILURE: null,
	  FETCH_CANCELLED_HOLDS_REQUEST: null,
	  FETCH_CANCELLED_HOLDS_SUCCESS: null,
	  FETCH_CANCELLED_HOLDS_FAILURE: null,
	  FETCH_EXPIRED_HOLDS_REQUEST: null,
	  FETCH_EXPIRED_HOLDS_SUCCESS: null,
	  FETCH_EXPIRED_HOLDS_FAILURE: null,
	  UPDATE_SINGLE_CLICK_HOLDS_REQUEST: null,
	  UPDATE_SINGLE_CLICK_HOLDS_SUCCESS: null,
	  UPDATE_SINGLE_CLICK_HOLDS_FAILURE: null,
	  UPDATE_PAUSE_HOLDS_DATE_REQUEST: null,
	  UPDATE_PAUSE_HOLDS_DATE_SUCCESS: null,
	  UPDATE_PAUSE_HOLDS_DATE_FAILURE: null,
	  UPDATE_PAUSE_HOLDS_REQUEST: null,
	  UPDATE_PAUSE_HOLDS_SUCCESS: null,
	  UPDATE_PAUSE_HOLDS_FAILURE: null,
	  UPDATE_RESUME_HOLDS_REQUEST: null,
	  UPDATE_RESUME_HOLDS_SUCCESS: null,
	  UPDATE_RESUME_HOLDS_FAILURE: null,
	  UPDATE_PICKUP_LOCATION_REQUEST: null,
	  UPDATE_PICKUP_LOCATION_SUCCESS: null,
	  UPDATE_PICKUP_LOCATION_FAILURE: null,
	  UPDATE_HOLDS_EXPIRY_REQUEST: null,
	  UPDATE_HOLDS_EXPIRY_SUCCESS: null,
	  UPDATE_HOLDS_EXPIRY_FAILURE: null
	});

/***/ },
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(876);


/***/ },
/* 105 */,
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SimpleUGCForm = __webpack_require__(1537);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SimpleUGCForm).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _lodash = __webpack_require__(16);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _gaEventTemplates = __webpack_require__(363);
	
	var _ShelfApi = __webpack_require__(1620);
	
	var _ShelfApi2 = _interopRequireDefault(_ShelfApi);
	
	var _ShelfConstants = __webpack_require__(43);
	
	var _ShelfConstants2 = _interopRequireDefault(_ShelfConstants);
	
	var _composeMessaging = __webpack_require__(189);
	
	var _composeMessaging2 = _interopRequireDefault(_composeMessaging);
	
	var _composeGlobalSuccessMessaging = __webpack_require__(245);
	
	var _composeGlobalSuccessMessaging2 = _interopRequireDefault(_composeGlobalSuccessMessaging);
	
	var _composeGlobalFailureMessaging = __webpack_require__(244);
	
	var _composeGlobalFailureMessaging2 = _interopRequireDefault(_composeGlobalFailureMessaging);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function shelfItemPrivacyStatus(response, store) {
	  var isShelfItemPrivate = _lodash2.default.values(response.entities.shelves[store.getState().getIn(['auth', 'currentUserId'])]).map(function (shelfItem) {
	    return shelfItem.privateItem;
	  })[0];
	
	  return isShelfItemPrivate && isShelfItemPrivate ? 'private' : 'public';
	}
	
	function searchUserShelf(shelfName, userId, query) {
	  return {
	    types: [_ShelfConstants2.default.SHELF_SEARCH_REQUEST, _ShelfConstants2.default.SHELF_SEARCH_SUCCESS, _ShelfConstants2.default.SHELF_SEARCH_FAILURE],
	    apiRequest: function apiRequest(state, client) {
	      return _ShelfApi2.default.searchUserShelf(_extends({
	        shelfName: shelfName,
	        userId: userId
	      }, query), client);
	    }
	  };
	}
	
	function fetchAdditionalFilters(shelfName, userId, fieldId, query) {
	  return {
	    types: [_ShelfConstants2.default.FETCH_FILTERS_REQUEST, _ShelfConstants2.default.FETCH_FILTERS_SUCCESS, _ShelfConstants2.default.FETCH_FILTERS_FAILURE],
	    apiRequest: function apiRequest(state, client) {
	      return _ShelfApi2.default.fetchAdditionalFilters(_extends({
	        shelfName: shelfName,
	        userId: userId,
	        fieldId: fieldId
	      }, query), client);
	    }
	  };
	}
	
	function importILSBibs(shelfName, accountId) {
	  return {
	    types: [_ShelfConstants2.default.IMPORT_ILS_BIBS_REQUEST, _ShelfConstants2.default.IMPORT_ILS_BIBS_SUCCESS, _ShelfConstants2.default.IMPORT_ILS_BIBS_FAILURE],
	    middlewareData: {
	      authRequired: true
	    },
	    apiRequest: function apiRequest(state, client) {
	      return _ShelfApi2.default.importILSBibs(shelfName, accountId, client);
	    }
	  };
	}
	
	// TODO SHEL-191: Eventually remove isBatch conditional and always pass shelfItem in array and remove ShelfApi.updateShelfItem
	function updateShelfItems(_ref) {
	  var shelfName = _ref.shelfName,
	      newShelfName = _ref.newShelfName,
	      shelfItemIds = _ref.shelfItemIds,
	      metadataIds = _ref.metadataIds,
	      postSuccess = _ref.postSuccess,
	      _ref$isBatch = _ref.isBatch,
	      isBatch = _ref$isBatch === undefined ? false : _ref$isBatch,
	      fieldsToUpdate = _objectWithoutProperties(_ref, ['shelfName', 'newShelfName', 'shelfItemIds', 'metadataIds', 'postSuccess', 'isBatch']);
	
	  return {
	    isBatch: isBatch,
	    metadataIds: metadataIds,
	    postSuccess: postSuccess,
	    fields: fieldsToUpdate,
	    types: [_ShelfConstants2.default.UPDATE_SHELF_ITEM_REQUEST, _ShelfConstants2.default.UPDATE_SHELF_ITEM_SUCCESS, _ShelfConstants2.default.UPDATE_SHELF_ITEM_FAILURE],
	    middlewareData: {
	      authRequired: true
	    },
	    apiRequest: function apiRequest(state, client) {
	      if (isBatch) {
	        return _ShelfApi2.default.updateShelfItems({
	          shelfName: shelfName,
	          newShelfName: newShelfName,
	          metadataIds: metadataIds,
	          shelfItemIds: shelfItemIds,
	          privateItem: fieldsToUpdate.privateItem
	        }, client);
	      }
	
	      return _ShelfApi2.default.updateShelfItem(_extends({
	        shelfName: shelfName,
	        shelf: newShelfName,
	        shelfItemId: shelfItemIds[0],
	        userId: state.getIn(['auth', 'currentUserId'])
	      }, fieldsToUpdate), client);
	    },
	    apiSuccess: function apiSuccess() {
	      return {
	        messaging: isBatch ? (0, _composeGlobalSuccessMessaging2.default)('message_successful_batch_move_shelves') : null
	      };
	    }
	  };
	}
	
	function removeShelfItems(_ref2) {
	  var shelfName = _ref2.shelfName,
	      shelfItemIds = _ref2.shelfItemIds,
	      metadataIds = _ref2.metadataIds,
	      workflowId = _ref2.workflowId,
	      postSuccess = _ref2.postSuccess,
	      _ref2$isBatch = _ref2.isBatch,
	      isBatch = _ref2$isBatch === undefined ? false : _ref2$isBatch;
	
	  return {
	    isBatch: isBatch,
	    workflowId: workflowId,
	    metadataIds: metadataIds,
	    postSuccess: postSuccess,
	    types: [_ShelfConstants2.default.REMOVE_FROM_SHELF_REQUEST, _ShelfConstants2.default.REMOVE_FROM_SHELF_SUCCESS, _ShelfConstants2.default.REMOVE_FROM_SHELF_FAILURE],
	    middlewareData: {
	      authRequired: true
	    },
	    apiRequest: function apiRequest(state, client) {
	      return _ShelfApi2.default.removeFromShelf({
	        shelfName: shelfName,
	        shelfItemIds: shelfItemIds,
	        metadataIds: metadataIds,
	        userId: state.getIn(['auth', 'currentUserId'])
	      }, client);
	    },
	    apiSuccess: function apiSuccess(response, store) {
	      return {
	        deletedEntities: shelfItemIds.map(function (itemId) {
	          return 'shelves.' + store.getState().getIn(['auth', 'currentUserId']) + '.' + itemId;
	        }),
	        messaging: isBatch ? (0, _composeGlobalSuccessMessaging2.default)('message_successful_batch_remove_shelves') : (0, _composeMessaging2.default)('SHELF', metadataIds[0], 'REMOVE', {
	          values: { shelf: shelfName }
	        })
	      };
	    },
	    apiFailure: function apiFailure(_ref3) {
	      var error = _ref3.error;
	      return {
	        messaging: isBatch ? (0, _composeGlobalFailureMessaging2.default)(error) : null
	      };
	    }
	  };
	}
	
	/**
	 * Adds ONE bib to the specified shelf
	 * @param {String} metadataId Bib to add
	 * @param {String} shelfToAdd Name of the shelf to add to
	 */
	function addToShelf(metadataId, shelfToAdd) {
	  var postSuccess = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {
	    return null;
	  };
	
	  return {
	    metadataIds: [metadataId],
	    postSuccess: postSuccess,
	    types: [_ShelfConstants2.default.ADD_TO_SHELF_REQUEST, _ShelfConstants2.default.ADD_TO_SHELF_SUCCESS, _ShelfConstants2.default.ADD_TO_SHELF_FAILURE],
	    middlewareData: {
	      authRequired: true,
	      gaEvent: (0, _gaEventTemplates.addToShelf)(shelfToAdd)
	    },
	    apiRequest: function apiRequest(state, client) {
	      return _ShelfApi2.default.addToShelf({
	        metadataIds: [metadataId], shelfName: shelfToAdd, userId: state.getIn(['auth', 'currentUserId'])
	      }, client);
	    }
	  };
	}
	
	/**
	 * Adds multiple bibs to the specified shelf
	 * @param {String} metadataId Bib to add
	 * @param {String} shelfName Name of the shelf to add to
	 */
	function batchAddToShelf(_ref4) {
	  var metadataIds = _ref4.metadataIds,
	      shelfName = _ref4.shelfName;
	
	  return {
	    isBatch: true,
	    metadataIds: metadataIds,
	    types: [_ShelfConstants2.default.ADD_TO_SHELF_REQUEST, _ShelfConstants2.default.ADD_TO_SHELF_SUCCESS, _ShelfConstants2.default.ADD_TO_SHELF_FAILURE],
	    middlewareData: {
	      authRequired: true,
	      gaEvent: (0, _gaEventTemplates.addToShelf)(shelfName)
	    },
	    apiRequest: function apiRequest(state, client) {
	      return _ShelfApi2.default.addToShelf({
	        metadataIds: metadataIds,
	        shelfName: shelfName,
	        userId: state.getIn(['auth', 'currentUserId'])
	      }, client);
	    },
	    apiSuccess: function apiSuccess(response, store) {
	      return {
	        messaging: (0, _composeGlobalSuccessMessaging2.default)('message_successful_batch_add_to_shelf_' + shelfName + '_' + shelfItemPrivacyStatus(response, store))
	      };
	    }
	  };
	}
	
	/**
	 * Displays the post-add to shelf view for an existing shelf item
	 * @param {String}
	 */
	function showPostAddToShelfView(metadataId, shelf, workflowId) {
	  return {
	    id: metadataId,
	    workflowId: workflowId,
	    type: _ShelfConstants2.default.SHOW_POST_ADD_TO_SHELF_VIEW,
	    payload: {
	      id: metadataId,
	      existsOnShelf: true
	    },
	    shelf: shelf
	  };
	}
	
	exports.default = {
	  addToShelf: addToShelf,
	  batchAddToShelf: batchAddToShelf,
	  updateShelfItems: updateShelfItems,
	  removeShelfItems: removeShelfItems,
	  searchUserShelf: searchUserShelf,
	  importILSBibs: importILSBibs,
	  fetchAdditionalFilters: fetchAdditionalFilters,
	  showPostAddToShelfView: showPostAddToShelfView
	};

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _reactRouter = __webpack_require__(17);
	
	var _utilsRails = __webpack_require__(1566);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _isEqual = __webpack_require__(162);
	
	var _isEqual2 = _interopRequireDefault(_isEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * This is a list of url patterns to ignore when updating the rails "back to" link.
	 * We shouldn't need to add anything to this. Pages can opt out of updating backTo links
	 * by not defining getBackToTitleKey().
	 */
	var BACK_TO_BLACKLIST = ['/availability/'];
	
	var shouldUpdateBackTo = function shouldUpdateBackTo(url) {
	  var matchedItems = BACK_TO_BLACKLIST.filter(function (blacklistedItem) {
	    return url.indexOf(blacklistedItem) !== -1;
	  });
	
	  return matchedItems.length === 0;
	};
	
	/**
	 * This is a base class for page-level containers (containers that correspond to routes).
	 *
	 * If you extend this class and override react life cycle methods like
	 * componentDidMount remember to call super.componentDidMount(), etc.
	 */
	
	var BasePageContainer = function (_BcReactComponent) {
	  _inherits(BasePageContainer, _BcReactComponent);
	
	  function BasePageContainer() {
	    _classCallCheck(this, BasePageContainer);
	
	    return _possibleConstructorReturn(this, (BasePageContainer.__proto__ || Object.getPrototypeOf(BasePageContainer)).apply(this, arguments));
	  }
	
	  _createClass(BasePageContainer, [{
	    key: 'updateBackTo',
	    value: function updateBackTo(url) {
	      var getBackToTitleKey = this.getBackToTitleKey ? this.getBackToTitleKey.bind(this) : this.constructor.getBackToTitleKey;
	      var title = getBackToTitleKey && getBackToTitleKey();
	      if (title && url && shouldUpdateBackTo(url)) {
	        (0, _utilsRails.setBackTo)({ title: title, url: url });
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.updateBackTo(window.location.href);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var location = this.props.location;
	
	
	      if (!(0, _isEqual2.default)(location, prevProps.location)) {
	        this.updateBackTo(window.location.href);
	      }
	    }
	  }]);
	
	  return BasePageContainer;
	}(_baseBcReactComponent2.default);
	
	BasePageContainer.propTypes = {
	  router: _reactRouter.routerShape
	};
	
	exports.default = BasePageContainer;

/***/ },
/* 109 */,
/* 110 */,
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(29);
	
	var PooledClass = __webpack_require__(166);
	
	var emptyFunction = __webpack_require__(80);
	var warning = __webpack_require__(26);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	    } else if (typeof event.returnValue !== 'unknown') {
	      // eslint-disable-line valid-typeof
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // eslint-disable-line valid-typeof
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re adding a new property in the synthetic event object. ' + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, 'This synthetic event is reused for performance reasons. If you\'re seeing this, ' + 'you\'re %s `%s` on a released/nullified synthetic event. %s. ' + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	var moment = __webpack_require__(9);
	var momentValidationWrapper = __webpack_require__(3060);
	var core = __webpack_require__(3059);
	
	moment.createFromInputFallback = function(config) {
	  config._d = new Date(config._i);
	};
	
	module.exports = {
	
	  momentObj : core.createMomentChecker(
	    'object',
	    function(obj) {
	      return typeof obj === 'object';
	    },
	    function isValid(value) {
	      return momentValidationWrapper.isValidMoment(value);
	    },
	    'Moment'
	  ),
	
	  momentString : core.createMomentChecker(
	    'string',
	    function(str) {
	      return typeof str === 'string';
	    },
	    function isValid(value) {
	      return momentValidationWrapper.isValidMoment(moment(value));
	    },
	    'Moment'
	  ),
	
	  momentDurationObj : core.createMomentChecker(
	    'object',
	    function(obj) {
	      return typeof obj === 'object';
	    },
	    function isValid(value) {
	      return moment.isDuration(value);
	    },
	    'Duration'
	  ),
	
	};


/***/ },
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AccessibleTextArea = __webpack_require__(1012);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AccessibleTextArea).default;
	  }
	});
	Object.defineProperty(exports, 'AccessibleTextArea', {
	  enumerable: true,
	  get: function get() {
	    return _AccessibleTextArea.AccessibleTextArea;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _layout = __webpack_require__(1062);
	
	Object.defineProperty(exports, 'Layout', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_layout).default;
	  }
	});
	
	var _mainContent = __webpack_require__(1064);
	
	Object.defineProperty(exports, 'MainContent', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_mainContent).default;
	  }
	});
	
	var _sidebar = __webpack_require__(1066);
	
	Object.defineProperty(exports, 'Sidebar', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_sidebar).default;
	  }
	});
	
	var _toggle = __webpack_require__(1070);
	
	Object.defineProperty(exports, 'Toggle', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_toggle).default;
	  }
	});
	
	var _stickyToggleButton = __webpack_require__(1068);
	
	Object.defineProperty(exports, 'StickyToggleButton', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_stickyToggleButton).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 119 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* eslint-disable import/prefer-default-export */
	var UGC_CONTENT_TYPES = exports.UGC_CONTENT_TYPES = {
	  COMMENT: 'comment',
	  TAGS: 'tags',
	  QUOTATIONS: 'quotations',
	  VIDEO: 'video',
	  SUMMARY: 'summary',
	  SIMILAR_TITLES: 'similar_titles',
	  AGE_SUITABILITY: 'age_suitability',
	  CONTENT_ADVISORIES: 'content_advisories',
	  PRIVATE_NOTE: 'private_note'
	};
	
	exports.default = {
	  UGC_CONTENT_TYPES: UGC_CONTENT_TYPES
	};

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _printButton = __webpack_require__(1445);
	
	Object.defineProperty(exports, 'PrintButton', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_printButton).default;
	  }
	});
	
	var _printButtonsToolbar = __webpack_require__(1447);
	
	Object.defineProperty(exports, 'PrintButtonsToolbar', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_printButtonsToolbar).default;
	  }
	});
	
	var _printLoadNextButton = __webpack_require__(1449);
	
	Object.defineProperty(exports, 'PrintLoadNextButton', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_printLoadNextButton).default;
	  }
	});
	
	var _printTable = __webpack_require__(1451);
	
	Object.defineProperty(exports, 'PrintTable', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_printTable).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.videoUtils = undefined;
	
	var _video = __webpack_require__(1568);
	
	Object.defineProperty(exports, 'videoUtils', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_video).default;
	  }
	});
	exports.supportsUGCContentType = supportsUGCContentType;
	
	var _constantsUgc = __webpack_require__(119);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Normalizes ugc types to match UGC_CONTENT_TYPES
	function normalizeContentType(type) {
	  var normalizeMap = {
	    quotation: _constantsUgc.UGC_CONTENT_TYPES.QUOTATIONS,
	    private_notes: _constantsUgc.UGC_CONTENT_TYPES.PRIVATE_NOTE
	  };
	
	  return normalizeMap[type] || type;
	}
	
	/**
	 * Determines whether a library supports the given UGC content type.
	 * @param {string} type
	 * @param {object} library
	 * @param {string} localBranch
	 * @return {boolean}
	 */
	function supportsUGCContentType(type, library) {
	  var localBranch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	
	  var supportedTypes = library.get('ugcContentTypes').map(normalizeContentType);
	  if (supportedTypes.indexOf(type) > -1) {
	    switch (type) {
	      case _constantsUgc.UGC_CONTENT_TYPES.VIDEO:
	        {
	          // Most libraries block access to third party sites (eg. youtube) on their terminals, so users can't watch videos.
	          // Unless the library allows watching videos on terminals.
	          return library.get('localBranchEnableVideos') || !localBranch;
	        }
	
	      default:
	        return true;
	    }
	  }
	
	  return false;
	}

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AvailabilityApi = __webpack_require__(1600);
	
	var _AvailabilityApi2 = _interopRequireDefault(_AvailabilityApi);
	
	var _AvailabilityDetailConstants = __webpack_require__(612);
	
	var _AvailabilityDetailConstants2 = _interopRequireDefault(_AvailabilityDetailConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getAvailability(id) {
	  return {
	    types: [_AvailabilityDetailConstants2.default.AVAILABILITY_DETAIL_REQUEST, _AvailabilityDetailConstants2.default.AVAILABILITY_DETAIL_SUCCESS, _AvailabilityDetailConstants2.default.AVAILABILITY_DETAIL_ERROR],
	    apiRequest: function apiRequest(state, client) {
	      return _AvailabilityApi2.default.fetchResults(id, state.getIn(['localization', 'currentLanguage'], ''), client);
	    }
	  };
	}
	
	function getDigitalAvailability(id) {
	  return {
	    types: [_AvailabilityDetailConstants2.default.DIGITAL_AVAILABILITY_REQUEST, _AvailabilityDetailConstants2.default.DIGITAL_AVAILABILITY_SUCCESS, _AvailabilityDetailConstants2.default.DIGITAL_AVAILABILITY_ERROR],
	    apiRequest: function apiRequest(state, client) {
	      return _AvailabilityApi2.default.fetchResults(id, state.getIn(['localization', 'currentLanguage'], ''), client);
	    }
	  };
	}
	
	function getHoldingsProbes(id) {
	  return {
	    types: [_AvailabilityDetailConstants2.default.HOLDINGS_PROBE_REQUEST, _AvailabilityDetailConstants2.default.HOLDINGS_PROBE_SUCCESS, _AvailabilityDetailConstants2.default.HOLDINGS_PROBE_ERROR],
	    apiRequest: function apiRequest(state, client) {
	      return _AvailabilityApi2.default.fetchHoldingsProbes(id, client);
	    }
	  };
	}
	
	exports.default = {
	  getAvailability: getAvailability,
	  getDigitalAvailability: getDigitalAvailability,
	  getHoldingsProbes: getHoldingsProbes
	};

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _WorkflowConstants = __webpack_require__(74);
	
	var _WorkflowConstants2 = _interopRequireDefault(_WorkflowConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function updateWorkflow(workflowId, workflow, view) {
	  var authRequired = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
	  var accountRequired = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
	  return {
	    type: _WorkflowConstants2.default.UPDATE_WORKFLOW,
	    payload: {
	      id: workflowId,
	      workflow: workflow,
	      view: view
	    },
	    middlewareData: {
	      authRequired: authRequired,
	      accountRequired: accountRequired
	    }
	  };
	}
	
	exports.default = {
	  updateWorkflow: updateWorkflow
	};

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BorrowingHeader = __webpack_require__(1804);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BorrowingHeader).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SEARCH_VIEW_COOKIE_NAME = undefined;
	
	var _utilsRedux = __webpack_require__(20);
	
	var SEARCH_VIEW_COOKIE_NAME = exports.SEARCH_VIEW_COOKIE_NAME = 'searchViewOption';
	
	exports.default = (0, _utilsRedux.createReduxConstants)('SEARCH', {
	  ADD_TITLE_SEARCH_FAILURE: null,
	  ADD_TITLE_SEARCH_REQUEST: null,
	  ADD_TITLE_SEARCH_SUCCESS: null,
	  EXPAND_FIELD_FAILURE: null,
	  EXPAND_FIELD_REQUEST: null,
	  EXPAND_FIELD_SUCCESS: null,
	  SEARCH_FAILURE: null,
	  SEARCH_PROBE_FAILURE: null,
	  SEARCH_PROBE_REQUEST: null,
	  SEARCH_PROBE_SUCCESS: null,
	  SEARCH_REQUEST: null,
	  SEARCH_SUCCESS: null,
	  GROUP_SEARCH_SUMMARY_REQUEST: null,
	  GROUP_SEARCH_SUMMARY_SUCCESS: null,
	  GROUP_SEARCH_SUMMARY_FAILURE: null,
	  TOGGLE_EXPANDED_FIELD_FAILURE: null,
	  TOGGLE_SEARCH_VIEW: null,
	  TOGGLE_SHOW_GROUPINGS: null
	});

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.HelpLinkContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(14);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _sharedHelpLink = __webpack_require__(1486);
	
	var _sharedHelpLink2 = _interopRequireDefault(_sharedHelpLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HelpLinkContainer = exports.HelpLinkContainer = function (_BcReactComponent) {
	  _inherits(HelpLinkContainer, _BcReactComponent);
	
	  function HelpLinkContainer() {
	    _classCallCheck(this, HelpLinkContainer);
	
	    return _possibleConstructorReturn(this, (HelpLinkContainer.__proto__ || Object.getPrototypeOf(HelpLinkContainer)).apply(this, arguments));
	  }
	
	  _createClass(HelpLinkContainer, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          page = _props.page,
	          currentLanguage = _props.currentLanguage,
	          showIcon = _props.showIcon,
	          children = _props.children;
	
	
	      return _react2.default.createElement(
	        _sharedHelpLink2.default,
	        { className: className, page: page, currentLanguage: currentLanguage, showIcon: showIcon },
	        children
	      );
	    }
	  }]);
	
	  return HelpLinkContainer;
	}(_baseBcReactComponent2.default);
	
	HelpLinkContainer.propTypes = {
	  className: _react.PropTypes.string,
	  page: _react.PropTypes.string.isRequired,
	  currentLanguage: _react.PropTypes.string,
	  showIcon: _react2.default.PropTypes.bool
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    currentLanguage: state.getIn(['localization', 'currentLanguage'])
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(HelpLinkContainer);

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getExpiredHolds = exports.getCancelledHolds = exports.getPagination = exports.getInactiveHoldData = exports.getHoldsStatus = exports.getHoldsTransactions = exports.getHoldsForStatus = exports.getDataForStatus = exports.getInactiveHoldCountsByStatus = exports.getCountsByStatus = exports.getHoldsQuotas = exports.getPresentStatuses = exports.getMaterialTypeCounts = exports.getSelectedStatus = exports.getHoldsUnfilteredByMaterialType = exports.getCurrentHolds = exports.getILSQuotas = exports.getActiveHolds = exports.getHoldsWithBibsById = exports.getActiveHoldsByMetadataId = undefined;
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reselect = __webpack_require__(34);
	
	var _lodash = __webpack_require__(16);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _BorrowingSelector = __webpack_require__(300);
	
	var _ShelfSelector = __webpack_require__(75);
	
	var _utilsBorrowing = __webpack_require__(230);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var statusFilter = function statusFilter(state, props) {
	  return _lodash2.default.get(props, 'router.params.status');
	};
	
	var holdsById = function holdsById(state) {
	  return state.getIn(['entities', 'holds']);
	};
	var currentHoldIds = function currentHoldIds(state) {
	  return state.getIn(['borrowing', 'holds', 'items'], _immutable2.default.List());
	};
	
	var bibsById = function bibsById(state) {
	  return state.getIn(['entities', 'bibs'], _immutable2.default.Map());
	};
	var holdsSummary = function holdsSummary(state) {
	  return (0, _BorrowingSelector.getSummary)(state, 'holds');
	};
	var inactiveHoldsSummary = function inactiveHoldsSummary(state) {
	  return (0, _BorrowingSelector.getSummary)(state, 'inactiveHolds');
	};
	var holdsTransactions = function holdsTransactions(state) {
	  return state.getIn(['borrowing', 'holds', 'holdsTransactions'], _immutable2.default.Map());
	};
	var holdsStatus = function holdsStatus(state) {
	  return state.getIn(['borrowing', 'holds'], _immutable2.default.Map());
	};
	var pagination = function pagination(state) {
	  return state.getIn(['borrowing', 'holds', 'pagination'], _immutable2.default.Map());
	};
	
	var getQuotas = function getQuotas(state) {
	  return (0, _BorrowingSelector.getSummary)(state, 'holds').get('quotas', _immutable2.default.Map());
	};
	
	var holdIsActive = function holdIsActive(hold) {
	  return !['CANCELLED', 'EXPIRED'].includes(hold.get('status'));
	};
	
	var getActiveHoldsByMetadataId = exports.getActiveHoldsByMetadataId = (0, _reselect.createSelector)([holdsById], function (allHoldsById) {
	  return allHoldsById.filter(holdIsActive).groupBy(function (hold) {
	    return hold.get('metadataId');
	  });
	});
	
	var getHoldsWithBibsById = exports.getHoldsWithBibsById = (0, _reselect.createSelector)([holdsById, bibsById], function (holds, bibs) {
	  return holds.map(function (hold) {
	    return hold && hold.set('bib', bibs.get(hold.get('metadataId')));
	  });
	});
	
	var getActiveHolds = exports.getActiveHolds = (0, _reselect.createSelector)([holdsById], function (holds) {
	  return holds.filter(function (hold) {
	    return holdIsActive(hold);
	  });
	});
	
	var getILSQuotas = exports.getILSQuotas = (0, _reselect.createSelector)([getQuotas], function (quotas) {
	  return quotas.valueSeq().toArray().filter(function (x) {
	    return x.get('type') === 'ILS';
	  })[0];
	});
	
	var getCurrentHolds = exports.getCurrentHolds = (0, _reselect.createSelector)([currentHoldIds, getHoldsWithBibsById, bibsById, _ShelfSelector.getShelvesForCurrentUser], function (holdIds, holdsWithBibs, bibs, shelfItems) {
	  return holdIds.map(function (holdId) {
	    return holdsWithBibs.get(holdId);
	  }).filter(function (hold) {
	    return !!hold;
	  }).map(function (hold) {
	    var isAlreadyOnShelf = shelfItems.some(function (item) {
	      return item.get('metadataId') === hold.get('metadataId');
	    });
	
	    var canAddToShelf = !isAlreadyOnShelf && hold.get('bib');
	
	    var actions = canAddToShelf ? hold.get('actions', _immutable2.default.List()).push('addToShelf') : hold.get('actions');
	
	    return hold.set('actions', actions);
	  }).toList();
	});
	
	var getHoldsUnfilteredByMaterialType = exports.getHoldsUnfilteredByMaterialType = (0, _reselect.createSelector)([holdsById, statusFilter], function (holds, selectedStatus) {
	  return holds.filter(function (hold) {
	    return (0, _utilsBorrowing.itemMatchesStatusFilter)(hold, selectedStatus);
	  }).toList();
	});
	
	var getSelectedStatus = exports.getSelectedStatus = (0, _reselect.createSelector)([statusFilter], function (status) {
	  return status ? status.toUpperCase() : status;
	});
	
	var getMaterialTypeCounts = exports.getMaterialTypeCounts = (0, _reselect.createSelector)([holdsSummary, statusFilter], function (summary, currentStatus) {
	  return (0, _utilsBorrowing.getMaterialTypeCountsForStatus)(summary, currentStatus);
	});
	
	var getPresentStatuses = exports.getPresentStatuses = (0, _reselect.createSelector)([holdsSummary], function (summary) {
	  return (0, _utilsBorrowing.getPresentStatusesFromSummary)(summary);
	});
	
	var getHoldsQuotas = exports.getHoldsQuotas = (0, _reselect.createSelector)([holdsSummary], function (summary) {
	  return summary.get('quotas', _immutable2.default.List());
	});
	
	var getCountsByStatus = exports.getCountsByStatus = (0, _reselect.createSelector)([holdsSummary], function (summary) {
	  return (0, _utilsBorrowing.getCountsByStatusFromSummary)(summary);
	});
	
	var getInactiveHoldCountsByStatus = exports.getInactiveHoldCountsByStatus = (0, _reselect.createSelector)([inactiveHoldsSummary], function (summary) {
	  return (0, _utilsBorrowing.getCountsByStatusFromSummary)(summary);
	});
	
	var getDataForStatus = exports.getDataForStatus = function getDataForStatus(state, status) {
	  return state.getIn(['borrowing', 'holds', status], _immutable2.default.Map());
	};
	
	var getHoldsForStatus = exports.getHoldsForStatus = (0, _reselect.createSelector)([holdsById, bibsById, getDataForStatus], function (holds, bibs, holdsData) {
	  return holdsData.get('holds', _immutable2.default.List()).map(function (id) {
	    return holds.get(id);
	  }).filter(function (hold) {
	    return hold;
	  }).map(function (hold) {
	    return hold.set('bib', bibs.get(hold.get('metadataId')));
	  });
	});
	
	var getHoldsTransactions = exports.getHoldsTransactions = (0, _reselect.createSelector)([holdsTransactions], function (transactions) {
	  return transactions;
	});
	
	var getHoldsStatus = exports.getHoldsStatus = (0, _reselect.createSelector)([holdsStatus], function (status) {
	  return status;
	});
	
	var inactiveHoldData = function inactiveHoldData(state) {
	  return state.getIn(['borrowing', 'inactiveHolds'], _immutable2.default.Map());
	};
	
	var getInactiveHoldsByStatus = function getInactiveHoldsByStatus(status) {
	  return (0, _reselect.createSelector)([holdsById, inactiveHoldData], function (holds, inactiveHolds) {
	    return inactiveHolds.getIn([status, 'holdIds'], _immutable2.default.List()).map(function (holdId) {
	      return holds.get(holdId);
	    });
	  });
	};
	
	var getInactiveHoldData = exports.getInactiveHoldData = (0, _reselect.createSelector)([inactiveHoldData], function (data) {
	  return data;
	});
	
	var getPagination = exports.getPagination = (0, _reselect.createSelector)([pagination], function (page) {
	  return page;
	});
	
	var getCancelledHolds = exports.getCancelledHolds = getInactiveHoldsByStatus('cancelled');
	var getExpiredHolds = exports.getExpiredHolds = getInactiveHoldsByStatus('expired');
	
	exports.default = {
	  getActiveHoldsByMetadataId: getActiveHoldsByMetadataId,
	  getHoldsWithBibsById: getHoldsWithBibsById,
	  getCurrentHolds: getCurrentHolds,
	  getHoldsUnfilteredByMaterialType: getHoldsUnfilteredByMaterialType,
	  getSelectedStatus: getSelectedStatus,
	  getMaterialTypeCounts: getMaterialTypeCounts,
	  getPresentStatuses: getPresentStatuses,
	  getHoldsQuotas: getHoldsQuotas,
	  getCountsByStatus: getCountsByStatus,
	  getDataForStatus: getDataForStatus,
	  getHoldsForStatus: getHoldsForStatus,
	  getActiveHolds: getActiveHolds,
	  getPagination: getPagination,
	  getHoldsTransactions: getHoldsTransactions,
	  getHoldsStatus: getHoldsStatus,
	  getInactiveHoldData: getInactiveHoldData,
	  getCancelledHolds: getCancelledHolds,
	  getExpiredHolds: getExpiredHolds
	};

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getSingularUGCForCurrentUser = exports.getUGCListForCurrentUser = exports.getUGCByBibs = exports.getSingularUGCByUsers = exports.getUGCListByUsers = exports.getUGCByType = undefined;
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reselect = __webpack_require__(34);
	
	var _AuthSelector = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var byUserId = function byUserId(content) {
	  return content.get('userId');
	};
	var byMetadataId = function byMetadataId(content) {
	  return content.get('metadataId');
	};
	var byId = function byId(content) {
	  return content.get('id');
	};
	
	var getUGCByTypeFromState = function getUGCByTypeFromState(ugcType) {
	  return function (state) {
	    return state.getIn(['entities', 'ugc', ugcType], _immutable2.default.Map());
	  };
	};
	
	/*
	 * Exports
	 */
	var getUGCByType = exports.getUGCByType = function getUGCByType(ugcType) {
	  return (0, _reselect.createSelector)([getUGCByTypeFromState(ugcType)], function (ugc) {
	    return ugc;
	  });
	};
	
	var getUGCListByUsers = exports.getUGCListByUsers = function getUGCListByUsers(ugcType) {
	  return (0, _reselect.createSelector)([getUGCByType(ugcType)], function (ugc) {
	    return ugc.groupBy(byUserId).map(function (groupedUGC) {
	      return groupedUGC.toList().sortBy(byId).groupBy(byMetadataId);
	    });
	  });
	};
	
	var getSingularUGCByUsers = exports.getSingularUGCByUsers = function getSingularUGCByUsers(ugcType) {
	  return (0, _reselect.createSelector)([getUGCListByUsers(ugcType)], function (ugcListByUser) {
	    return ugcListByUser.map(function (ugcListByMetadataId) {
	      return ugcListByMetadataId.map(function (ugcList) {
	        return ugcList.first();
	      });
	    });
	  });
	};
	
	var getUGCByBibs = exports.getUGCByBibs = function getUGCByBibs(ugcType) {
	  return (0, _reselect.createSelector)([getUGCByType(ugcType)], function (ugc) {
	    return ugc.groupBy(byMetadataId).map(function (groupedUGC) {
	      return groupedUGC.toList().sortBy(byId);
	    });
	  });
	};
	
	var getUGCListForCurrentUser = exports.getUGCListForCurrentUser = function getUGCListForCurrentUser(ugcType) {
	  return (0, _reselect.createSelector)([getUGCListByUsers(ugcType), _AuthSelector.currentUserSelector], function (ugc, user) {
	    return user && user.get('id') ? ugc.get(user.get('id'), _immutable2.default.Map()) : _immutable2.default.Map();
	  });
	};
	
	var getSingularUGCForCurrentUser = exports.getSingularUGCForCurrentUser = function getSingularUGCForCurrentUser(ugcType) {
	  return (0, _reselect.createSelector)([getSingularUGCByUsers(ugcType), _AuthSelector.currentUserSelector], function (ugc, user) {
	    return user && user.get('id') ? ugc.get(user.get('id'), _immutable2.default.Map()) : _immutable2.default.Map();
	  });
	};
	
	exports.default = {
	  getUGCByType: getUGCByType,
	  getUGCListByUsers: getUGCListByUsers,
	  getUGCByBibs: getUGCByBibs,
	  getUGCListForCurrentUser: getUGCListForCurrentUser
	};

/***/ },
/* 129 */
25,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Loader = __webpack_require__(1332);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Loader).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _expandButton = __webpack_require__(275);
	
	Object.defineProperty(exports, 'ExpandButton', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_expandButton).default;
	  }
	});
	
	var _expandableText = __webpack_require__(1413);
	
	Object.defineProperty(exports, 'ExpandableText', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_expandableText).default;
	  }
	});
	
	var _expandableList = __webpack_require__(1409);
	
	Object.defineProperty(exports, 'ExpandableList', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_expandableList).default;
	  }
	});
	
	var _expandablePanel = __webpack_require__(1411);
	
	Object.defineProperty(exports, 'ExpandablePanel', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_expandablePanel).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _NotFound = __webpack_require__(1433);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_NotFound).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Rating = __webpack_require__(1457);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Rating).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 142 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.sendAnalyticsEvents = sendAnalyticsEvents;
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	// this eslint disable can be removed when another module is exported from this file
	/* eslint-disable import/prefer-default-export */
	
	/**
	 * @definition updates missing paramaters from event payload with values of undefined
	 * @param {Object} payload
	 * @example
	 * old payload: {action: 'add', label: 'new'}
	 * new payload: {action: 'remove' }
	 * returns: {action: 'remove', label: undefined}
	 */
	function transformPayload(payload) {
	  var newPayload = _extends({}, payload);
	  var latestBCEvent = [].concat(_toConsumableArray(window.dataLayer)).reverse().find(function (event) {
	    return event.payload;
	  });
	
	  // compares the latestBCEvent payload keys to the upcoming event's payload keys
	  if (latestBCEvent) {
	    Object.keys(latestBCEvent.payload).forEach(function (key) {
	      // if a key is missing on the upcoming payload, define it as undefined; this prevents the new payload from using the old payload values
	      if (!Object.prototype.hasOwnProperty.call(newPayload, key)) {
	        newPayload[key] = undefined;
	      }
	    });
	  }
	  return newPayload;
	}
	
	/**
	 * @definition pushes current analytic event to data layer for tracking
	 * @param {Array} analytics holds events array which holds objects with following shape: { event, payload }
	 */
	function sendAnalyticsEvents(analytics) {
	  if (analytics && analytics.events) {
	    analytics.events.forEach(function (event) {
	      if (event.event) {
	        if (window.dataLayer && typeof window.dataLayer.push === 'function') {
	          window.dataLayer.push({
	            event: event.event,
	            payload: transformPayload(event.payload)
	          });
	        }
	      }
	    });
	  }
	}

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.placeHold = placeHold;
	exports.placeItemHold = placeItemHold;
	exports.cancelHold = cancelHold;
	exports.startPlaceHold = startPlaceHold;
	exports.startCancelHold = startCancelHold;
	exports.getItemGroups = getItemGroups;
	exports.updatePickupLocation = updatePickupLocation;
	exports.savePickupLocation = savePickupLocation;
	exports.fetchHolds = fetchHolds;
	exports.fetchExpiredHolds = fetchExpiredHolds;
	exports.fetchCancelledHolds = fetchCancelledHolds;
	exports.updateHoldsPauseEndDate = updateHoldsPauseEndDate;
	exports.pauseOrResumeHolds = pauseOrResumeHolds;
	exports.updateHoldsExpiryDate = updateHoldsExpiryDate;
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _moment = __webpack_require__(9);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _values2 = __webpack_require__(760);
	
	var _values3 = _interopRequireDefault(_values2);
	
	var _HoldApi = __webpack_require__(1607);
	
	var _HoldApi2 = _interopRequireDefault(_HoldApi);
	
	var _BibConstants = __webpack_require__(241);
	
	var _AuthConstants = __webpack_require__(293);
	
	var _AuthConstants2 = _interopRequireDefault(_AuthConstants);
	
	var _HoldsConstants = __webpack_require__(98);
	
	var _HoldsConstants2 = _interopRequireDefault(_HoldsConstants);
	
	var _ShelfActions = __webpack_require__(107);
	
	var _ShelfActions2 = _interopRequireDefault(_ShelfActions);
	
	var _WorkflowConstants = __webpack_require__(74);
	
	var _AuthSelector = __webpack_require__(21);
	
	var _LibrarySelector = __webpack_require__(33);
	
	var _WorkflowActions = __webpack_require__(123);
	
	var _WorkflowActions2 = _interopRequireDefault(_WorkflowActions);
	
	var _composeSuccessMessaging = __webpack_require__(190);
	
	var _composeSuccessMessaging2 = _interopRequireDefault(_composeSuccessMessaging);
	
	var _composeGlobalSuccessMessaging = __webpack_require__(245);
	
	var _composeGlobalSuccessMessaging2 = _interopRequireDefault(_composeGlobalSuccessMessaging);
	
	var _composeGlobalFailureMessaging = __webpack_require__(244);
	
	var _composeGlobalFailureMessaging2 = _interopRequireDefault(_composeGlobalFailureMessaging);
	
	var _composeFailureMessaging = __webpack_require__(299);
	
	var _composeFailureMessaging2 = _interopRequireDefault(_composeFailureMessaging);
	
	var _BibSelector = __webpack_require__(398);
	
	var _composeMessagingForBatchAction = __webpack_require__(641);
	
	var _composeMessagingForBatchAction2 = _interopRequireDefault(_composeMessagingForBatchAction);
	
	var _composeMessaging = __webpack_require__(189);
	
	var _composeMessaging2 = _interopRequireDefault(_composeMessaging);
	
	var _MessagingConstants = __webpack_require__(73);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function shouldUseSingleClickHolds(singleClickHoldsSettings, materialType, itemLevelHold, isValidLocation) {
	  return singleClickHoldsSettings && singleClickHoldsSettings.get('enabled') && materialType === _BibConstants.MATERIAL_TYPE_PHYSICAL && !itemLevelHold && isValidLocation;
	}
	
	function isValidSingleClickHoldsLocation(branches, branchCode) {
	  var singleClickHoldsCheck = branches && branches.filter(function (branch) {
	    return branch.get('code') === branchCode;
	  });
	  return singleClickHoldsCheck && singleClickHoldsCheck.size > 0;
	}
	
	function placeHoldApiSuccess(messagingId, response, store) {
	  var successCount = response.successCount;
	
	  var values = { count: successCount, position: 0 };
	  var holds = (0, _values3.default)(response.entities.holds) || [];
	  var firstHold = holds[0];
	  if (firstHold) {
	    var bibs = (0, _BibSelector.getBibsByMetadataId)(store.getState());
	    var title = bibs.getIn([firstHold.metadataId, 'briefInfo', 'title'], '');
	    var position = firstHold.holdsPosition || 0;
	    values = _extends({}, values, { position: position, title: title });
	  }
	
	  var messageId = 'message_item_holds_placed_no_position';
	  if (successCount === 1) {
	    messageId = values.position > 0 ? 'message_item_hold_placed' : 'message_item_hold_placed_no_position';
	  }
	
	  return {
	    messaging: messagingId ? (0, _composeSuccessMessaging2.default)(messagingId, messageId, { values: values }) : (0, _composeGlobalSuccessMessaging2.default)(messageId, { values: values })
	  };
	}
	
	function placeHold(_ref) {
	  var workflowId = _ref.workflowId,
	      messagingId = _ref.messagingId,
	      accountId = _ref.accountId,
	      metadataId = _ref.metadataId,
	      materialType = _ref.materialType,
	      _ref$enableSingleClic = _ref.enableSingleClickHolds,
	      enableSingleClickHolds = _ref$enableSingleClic === undefined ? false : _ref$enableSingleClic,
	      materialParams = _ref.materialParams;
	
	  return {
	    workflowId: workflowId,
	    messagingId: messagingId,
	    payload: {
	      id: metadataId,
	      selectedBranch: materialParams.branchId
	    },
	    middlewareData: {
	      accountRequired: true
	    },
	    types: [_HoldsConstants2.default.PLACE_HOLD_REQUEST, _HoldsConstants2.default.PLACE_HOLD_SUCCESS, _HoldsConstants2.default.PLACE_HOLD_FAILURE],
	    apiRequest: function apiRequest(state, apiClient) {
	      return _HoldApi2.default.placeHold({
	        metadataId: metadataId,
	        materialType: materialType,
	        accountId: accountId,
	        enableSingleClickHolds: enableSingleClickHolds,
	        materialParams: materialParams
	      }, apiClient);
	    },
	    apiSuccess: function apiSuccess(response, store) {
	      return placeHoldApiSuccess(messagingId, response, store);
	    },
	    apiFailure: function apiFailure(_ref2) {
	      var error = _ref2.error;
	
	      // Special case for when the library doesn't own the digital bib.
	      // TODO: This was an old logic migrated from the api-gateway. Investigate whether we still need it or if it should be solved differently.
	      if (error && error.classification === 'HoldNotAllowed') {
	        return {
	          entities: {
	            bibs: _defineProperty({}, metadataId, {
	              availability: {
	                status: 'RESOURCE_NOT_FOUND',
	                localisedStatus: 'RESOURCE_NOT_FOUND'
	              }
	            })
	          }
	        };
	      }
	
	      return {};
	    }
	  };
	}
	
	/**
	 * Place an Item Level Hold on one or more items of a Bib
	 *
	 * @param {String} metadataId metadataId of the bib
	 * @param {Array<String>} itemIds itemIds to place hold on
	 * @param {String} branchId branch to place the hold at
	 */
	function placeItemHold(_ref3) {
	  var metadataId = _ref3.metadataId,
	      itemIds = _ref3.itemIds,
	      branchId = _ref3.branchId,
	      messagingId = _ref3.messagingId,
	      workflowId = _ref3.workflowId;
	
	  return {
	    messagingId: messagingId,
	    workflowId: workflowId,
	    payload: {
	      id: metadataId
	    },
	    middlewareData: {
	      accountRequired: true
	    },
	    types: [_HoldsConstants2.default.PLACE_HOLD_REQUEST, _HoldsConstants2.default.PLACE_HOLD_SUCCESS, _HoldsConstants2.default.PLACE_HOLD_FAILURE],
	    apiRequest: function apiRequest(state, apiClient) {
	      return _HoldApi2.default.placeHold({
	        metadataId: metadataId,
	        accountId: (0, _AuthSelector.currentAccountSelector)(state).get('id'),
	        materialType: _BibConstants.MATERIAL_TYPE_PHYSICAL,
	        materialParams: {
	          branchId: branchId,
	          errorMessageLocale: state.getIn(['localization', 'currentLanguage']),
	          itemIds: itemIds
	        }
	      }, apiClient);
	    },
	    apiSuccess: function apiSuccess(response, store) {
	      return placeHoldApiSuccess(messagingId, response, store);
	    }
	  };
	}
	
	function cancelHold(_ref4) {
	  var accountId = _ref4.accountId,
	      metadataIds = _ref4.metadataIds,
	      holdIds = _ref4.holdIds,
	      shelfState = _ref4.shelfState,
	      messagingId = _ref4.messagingId,
	      workflowId = _ref4.workflowId,
	      _ref4$isBatch = _ref4.isBatch,
	      isBatch = _ref4$isBatch === undefined ? false : _ref4$isBatch;
	
	  return {
	    workflowId: workflowId,
	    messagingId: messagingId,
	    isBatch: isBatch,
	    holdIds: holdIds,
	    middlewareData: {
	      accountRequired: true
	    },
	    types: [_HoldsConstants2.default.CANCEL_HOLD_REQUEST, _HoldsConstants2.default.CANCEL_HOLD_SUCCESS, _HoldsConstants2.default.CANCEL_HOLD_FAILURE],
	    apiRequest: function apiRequest(state, apiClient) {
	      return _HoldApi2.default.cancelHold({ accountId: accountId, holdIds: holdIds, metadataIds: metadataIds }, apiClient);
	    },
	    apiSuccess: function apiSuccess(_ref5) {
	      var failures = _ref5.failures;
	      return {
	        deletedEntities: holdIds.map(function (id) {
	          return 'holds.' + id;
	        }),
	        messaging: messagingId ? (0, _composeSuccessMessaging2.default)(messagingId, 'message_successful_cancel_holds') : (0, _composeMessagingForBatchAction2.default)({
	          total: holdIds.length,
	          failures: failures,
	          successId: 'message_successful_cancel_holds',
	          mixedId: 'message_mixed_cancel_holds',
	          failureId: 'message_failure_cancel_holds_one_or_more'
	        })
	      };
	    },
	
	    apiFailure: function apiFailure(response) {
	      var messaging = void 0;
	
	      if (holdIds.length > 1) {
	        messaging = (0, _composeMessaging2.default)(_MessagingConstants.STATUS_TYPES.Failure, messagingId || _MessagingConstants.GLOBAL_MESSAGING_ID, 'message_failure_cancel_holds_one_or_more');
	      } else {
	        messaging = messagingId ? (0, _composeFailureMessaging2.default)(messagingId, response.error) : (0, _composeGlobalFailureMessaging2.default)(response.error);
	      }
	
	      return { messaging: messaging };
	    },
	
	    postSuccess: function postSuccess() {
	      if (shelfState && shelfState.toAdd) {
	        return isBatch || metadataIds.length > 1 ? _ShelfActions2.default.batchAddToShelf({
	          metadataIds: metadataIds,
	          shelfName: shelfState.name
	        }) : _ShelfActions2.default.addToShelf(metadataIds[0], shelfState.name);
	      }
	      return function () {};
	    }
	  };
	}
	
	function startPlaceHold(workflowId, metadataId, messagingId) {
	  var determineHoldFlow = function determineHoldFlow(dispatch, getState) {
	    var state = getState();
	    var auth = state.get('auth');
	
	    if (!auth.get('currentUserId')) {
	      return dispatch({ type: _AuthConstants2.default.OPEN_LOGIN_OVERLAY, payload: { postLoginAction: determineHoldFlow } });
	    }
	
	    var account = (0, _AuthSelector.currentAccountSelector)(state);
	    var library = (0, _LibrarySelector.currentLibrarySelector)(state);
	    var policy = state.getIn(['entities', 'bibs', metadataId, 'policy']);
	    var materialType = policy.get('materialType');
	    var itemLevelHold = policy.get('itemLevelHoldableItems') && policy.getIn(['materialPolicy', 'itemLevelHoldsPredetermined']);
	    var singleClickHoldsSettings = account ? account.get('singleClickHoldsSettings', _immutable2.default.Map()) : _immutable2.default.Map();
	    var accountId = account && account.get('id');
	    var currentLocale = state.getIn(['localization', 'currentLanguage'], 'en-US');
	    var requiresExpiryDate = library.get('requiresHoldExpiryDate', false);
	    var branches = (0, _LibrarySelector.sortedPickupBranchSelector)(state);
	
	    if (shouldUseSingleClickHolds(singleClickHoldsSettings, materialType, itemLevelHold, isValidSingleClickHoldsLocation(branches, singleClickHoldsSettings.get('branchId')))) {
	      return dispatch(placeHold({
	        workflowId: workflowId,
	        accountId: accountId,
	        metadataId: metadataId,
	        messagingId: messagingId,
	        materialType: materialType,
	        enableSingleClickHolds: false,
	        materialParams: {
	          branchId: singleClickHoldsSettings.get('branchId'),
	          expiryDate: requiresExpiryDate ? (0, _moment2.default)().add(singleClickHoldsSettings.get('holdsDurationExpiration'), 's').format(_HoldsConstants.HOLD_DATE_FORMAT) : null,
	          errorMessageLocale: currentLocale
	        }
	      }));
	    }
	
	    var physicalHoldWorkflowView = itemLevelHold ? _HoldsConstants.WORKFLOW_VIEWS.ITEM_LEVEL_HOLD : _HoldsConstants.WORKFLOW_VIEWS.PHYSICAL_HOLD;
	
	    return dispatch(_WorkflowActions2.default.updateWorkflow(workflowId, _WorkflowConstants.ITEM_TRANSACTION_WORKFLOW, _immutable2.default.Map({
	      metadataId: metadataId,
	      messagingId: messagingId,
	      step: materialType === _BibConstants.MATERIAL_TYPE_PHYSICAL ? physicalHoldWorkflowView : _HoldsConstants.WORKFLOW_VIEWS.DIGITAL_HOLD
	    }), true, true));
	  };
	
	  return determineHoldFlow;
	}
	
	function startCancelHold(workflowId, metadataId, messagingId) {
	  return _WorkflowActions2.default.updateWorkflow(workflowId, _WorkflowConstants.ITEM_TRANSACTION_WORKFLOW, _immutable2.default.Map({
	    metadataId: metadataId,
	    step: _HoldsConstants.WORKFLOW_VIEWS.CANCEL_HOLD,
	    messagingId: messagingId
	  }), true, true);
	}
	
	/**
	 * Fetches the Item Groupings for the Hold
	 * @param {String} metadataId
	 */
	function getItemGroups(metadataId) {
	  return {
	    payload: {
	      id: metadataId
	    },
	    types: [_HoldsConstants2.default.FETCH_ITEM_GROUPS_REQUEST, _HoldsConstants2.default.FETCH_ITEM_GROUPS_SUCCESS, _HoldsConstants2.default.FETCH_ITEM_GROUPS_FAILURE],
	    apiRequest: function apiRequest(state, apiClient) {
	      return _HoldApi2.default.fetchItemGroups(metadataId, apiClient);
	    }
	  };
	}
	
	function updatePickupLocation(metadataId, pickupLocation) {
	  return {
	    payload: {
	      id: metadataId,
	      pickupLocation: pickupLocation
	    },
	    type: _HoldsConstants2.default.UPDATE_PICKUP_LOCATION
	  };
	}
	
	function savePickupLocation(_ref6) {
	  var holdId = _ref6.holdId,
	      accountId = _ref6.accountId,
	      branch = _ref6.branch;
	
	  return {
	    holdId: holdId,
	    branch: branch,
	    middlewareData: {
	      accountRequired: true
	    },
	    types: [_HoldsConstants2.default.UPDATE_PICKUP_LOCATION_REQUEST, _HoldsConstants2.default.UPDATE_PICKUP_LOCATION_SUCCESS, _HoldsConstants2.default.UPDATE_PICKUP_LOCATION_FAILURE],
	    apiRequest: function apiRequest(state, client) {
	      return _HoldApi2.default.updateHolds({
	        holdIds: [holdId],
	        accountId: accountId,
	        location: branch.get('code')
	      }, client);
	    },
	    apiSuccess: function apiSuccess() {
	      return {
	        messaging: (0, _composeGlobalSuccessMessaging2.default)('message_successful_update_pickup_location', { values: { location: branch.get('name') } })
	      };
	    }
	  };
	}
	
	function fetchHolds(_ref7) {
	  var accountId = _ref7.accountId,
	      _ref7$size = _ref7.size,
	      size = _ref7$size === undefined ? 25 : _ref7$size,
	      status = _ref7.status,
	      _ref7$page = _ref7.page,
	      page = _ref7$page === undefined ? 1 : _ref7$page,
	      _ref7$sort = _ref7.sort,
	      sort = _ref7$sort === undefined ? 'status' : _ref7$sort,
	      materialType = _ref7.materialType;
	
	  return {
	    types: [_HoldsConstants2.default.FETCH_HOLDS_REQUEST, _HoldsConstants2.default.FETCH_HOLDS_SUCCESS, _HoldsConstants2.default.FETCH_HOLDS_FAILURE],
	    middlewareData: {
	      accountRequired: true
	    },
	    apiRequest: function apiRequest(state, apiClient) {
	      return _HoldApi2.default.getHolds({
	        accountId: accountId,
	        size: size,
	        status: status && status.toUpperCase(),
	        page: page,
	        sort: sort,
	        materialType: materialType
	      }, apiClient);
	    }
	  };
	}
	
	function fetchExpiredHolds(_ref8) {
	  var accountId = _ref8.accountId,
	      _ref8$page = _ref8.page,
	      page = _ref8$page === undefined ? 1 : _ref8$page,
	      _ref8$size = _ref8.size,
	      size = _ref8$size === undefined ? 25 : _ref8$size;
	
	  return {
	    types: [_HoldsConstants2.default.FETCH_EXPIRED_HOLDS_REQUEST, _HoldsConstants2.default.FETCH_EXPIRED_HOLDS_SUCCESS, _HoldsConstants2.default.FETCH_EXPIRED_HOLDS_FAILURE],
	    middlewareData: {
	      accountRequired: true
	    },
	    apiRequest: function apiRequest(state, apiClient) {
	      return _HoldApi2.default.getHolds({ accountId: accountId, status: 'EXPIRED', page: page, size: size }, apiClient);
	    }
	  };
	}
	
	function fetchCancelledHolds(_ref9) {
	  var accountId = _ref9.accountId,
	      _ref9$page = _ref9.page,
	      page = _ref9$page === undefined ? 1 : _ref9$page,
	      _ref9$size = _ref9.size,
	      size = _ref9$size === undefined ? 25 : _ref9$size;
	
	  return {
	    types: [_HoldsConstants2.default.FETCH_CANCELLED_HOLDS_REQUEST, _HoldsConstants2.default.FETCH_CANCELLED_HOLDS_SUCCESS, _HoldsConstants2.default.FETCH_CANCELLED_HOLDS_FAILURE],
	    middlewareData: {
	      accountRequired: true
	    },
	    apiRequest: function apiRequest(state, apiClient) {
	      return _HoldApi2.default.getHolds({ accountId: accountId, status: 'CANCELLED', page: page, size: size }, apiClient);
	    }
	  };
	}
	
	var getFirstFailure = function getFirstFailure(response) {
	  var failures = response.failures || [];
	  if (failures.length > 0) {
	    return failures[0].errorResponseDTO || {};
	  }
	
	  return null;
	};
	
	var getMessageForUpdateHolds = function getMessageForUpdateHolds(response, successMessage) {
	  var failure = getFirstFailure(response);
	
	  return failure ? (0, _composeGlobalFailureMessaging2.default)(failure) : successMessage;
	};
	
	function updateHoldsPauseEndDate(_ref10) {
	  var accountId = _ref10.accountId,
	      holdIds = _ref10.holdIds,
	      workflowId = _ref10.workflowId,
	      endDate = _ref10.endDate,
	      formattedEndDate = _ref10.formattedEndDate;
	
	  return {
	    holdIds: holdIds,
	    workflowId: workflowId,
	    middlewareData: {
	      accountRequired: true
	    },
	    types: [_HoldsConstants2.default.UPDATE_PAUSE_HOLDS_DATE_REQUEST, _HoldsConstants2.default.UPDATE_PAUSE_HOLDS_DATE_SUCCESS, _HoldsConstants2.default.UPDATE_PAUSE_HOLDS_DATE_FAILURE],
	    apiRequest: function apiRequest(state, client) {
	      return _HoldApi2.default.updateHolds({
	        holdIds: holdIds,
	        accountId: accountId,
	        suspended: {
	          status: true,
	          endDate: endDate
	        }
	      }, client);
	    },
	    apiSuccess: function apiSuccess(_ref11) {
	      var failures = _ref11.failures;
	
	      var messaging = (0, _composeMessagingForBatchAction2.default)({
	        total: holdIds.length,
	        failures: failures,
	        successId: 'message_successful_update_pause_end_date',
	        mixedId: 'message_mixed_update_date',
	        failureId: 'message_failure_update_date',
	        values: { date: formattedEndDate }
	      });
	
	      return {
	        messaging: messaging
	      };
	    },
	    apiFailure: function apiFailure() {
	      return {
	        messaging: (0, _composeMessaging2.default)(_MessagingConstants.STATUS_TYPES.Failure, _MessagingConstants.GLOBAL_MESSAGING_ID, 'message_failure_update_date', { values: { count: holdIds.length } })
	      };
	    }
	  };
	}
	
	function pauseOrResumeHolds(_ref12) {
	  var accountId = _ref12.accountId,
	      holdIds = _ref12.holdIds,
	      workflowId = _ref12.workflowId,
	      suspended = _ref12.suspended;
	
	  return {
	    holdIds: holdIds,
	    workflowId: workflowId,
	    suspended: suspended,
	    middlewareData: {
	      accountRequired: true
	    },
	    types: [_HoldsConstants2.default.UPDATE_PAUSE_HOLDS_REQUEST, _HoldsConstants2.default.UPDATE_PAUSE_HOLDS_SUCCESS, _HoldsConstants2.default.UPDATE_PAUSE_HOLDS_FAILURE],
	    apiRequest: function apiRequest(state, client) {
	      return _HoldApi2.default.updateHolds({
	        holdIds: holdIds,
	        accountId: accountId,
	        suspended: suspended
	      }, client);
	    },
	    apiSuccess: function apiSuccess(_ref13) {
	      var failures = _ref13.failures;
	
	      var action = suspended.status === true ? 'pause' : 'resume';
	      var messaging = (0, _composeMessagingForBatchAction2.default)({
	        total: holdIds.length,
	        failures: failures,
	        successId: 'message_successful_' + action + '_holds',
	        mixedId: 'message_mixed_' + action + '_holds',
	        failureId: 'message_failure_' + action + '_holds'
	      });
	
	      return {
	        messaging: messaging
	      };
	    }
	  };
	}
	
	function updateHoldsExpiryDate(_ref14) {
	  var accountId = _ref14.accountId,
	      holdIds = _ref14.holdIds,
	      workflowId = _ref14.workflowId,
	      expiryDate = _ref14.expiryDate,
	      formattedExpiryDate = _ref14.formattedExpiryDate;
	
	  return {
	    holdIds: holdIds,
	    workflowId: workflowId,
	    middlewareData: {
	      accountRequired: true
	    },
	    types: [_HoldsConstants2.default.UPDATE_HOLDS_EXPIRY_REQUEST, _HoldsConstants2.default.UPDATE_HOLDS_EXPIRY_SUCCESS, _HoldsConstants2.default.UPDATE_HOLDS_EXPIRY_FAILURE],
	    apiRequest: function apiRequest(state, client) {
	      return _HoldApi2.default.updateHolds({
	        holdIds: holdIds,
	        accountId: accountId,
	        expiryDate: expiryDate
	      }, client);
	    },
	    apiSuccess: function apiSuccess(response) {
	      var successMessage = (0, _composeGlobalSuccessMessaging2.default)('message_successful_update_expiry_date', { values: { date: formattedExpiryDate } });
	
	      return {
	        messaging: getMessageForUpdateHolds(response, successMessage)
	      };
	    }
	  };
	}
	
	exports.default = {
	  placeHold: placeHold,
	  placeItemHold: placeItemHold,
	  cancelHold: cancelHold,
	  startPlaceHold: startPlaceHold,
	  startCancelHold: startCancelHold,
	  getItemGroups: getItemGroups,
	  updatePickupLocation: updatePickupLocation,
	  fetchHolds: fetchHolds,
	  fetchExpiredHolds: fetchExpiredHolds,
	  fetchCancelledHolds: fetchCancelledHolds,
	  updateHoldsPauseEndDate: updateHoldsPauseEndDate,
	  pauseOrResumeHolds: pauseOrResumeHolds,
	  updateHoldsExpiryDate: updateHoldsExpiryDate
	};

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _lodash = __webpack_require__(16);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(9);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _utilsBrowser = __webpack_require__(59);
	
	var _SearchApi = __webpack_require__(1619);
	
	var _SearchApi2 = _interopRequireDefault(_SearchApi);
	
	var _SearchConstants = __webpack_require__(125);
	
	var _SearchConstants2 = _interopRequireDefault(_SearchConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GROUPING_COOKIE = 'catalog_search_show_groupings';
	
	// Actions /////////
	
	function performSearch(query) {
	  return {
	    types: [_SearchConstants2.default.SEARCH_REQUEST, _SearchConstants2.default.SEARCH_SUCCESS, _SearchConstants2.default.SEARCH_FAILURE],
	    apiRequest: function apiRequest(state, apiClient) {
	      return _SearchApi2.default.fetchResults(query, apiClient);
	    }
	  };
	}
	
	function addTitleSearch(searchQuery) {
	  return {
	    searchQuery: searchQuery,
	    types: [_SearchConstants2.default.ADD_TITLE_SEARCH_REQUEST, _SearchConstants2.default.ADD_TITLE_SEARCH_SUCCESS, _SearchConstants2.default.ADD_TITLE_SEARCH_FAILURE],
	    apiRequest: function apiRequest(state, apiClient) {
	      return _SearchApi2.default.fetchResults(_extends({}, searchQuery, { view: 'medium' }), apiClient);
	    }
	  };
	}
	
	function getSearchProbes(query, searchType) {
	  return {
	    types: [_SearchConstants2.default.SEARCH_PROBE_REQUEST, _SearchConstants2.default.SEARCH_PROBE_SUCCESS, _SearchConstants2.default.SEARCH_PROBE_FAILURE],
	    apiRequest: function apiRequest(state, client) {
	      return _SearchApi2.default.fetchSearchProbes(query, searchType, client);
	    }
	  };
	}
	
	function expandField(fieldId, query) {
	  return {
	    types: [_SearchConstants2.default.EXPAND_FIELD_REQUEST, _SearchConstants2.default.EXPAND_FIELD_SUCCESS, _SearchConstants2.default.EXPAND_FIELD_FAILURE],
	    apiRequest: function apiRequest(state, apiClient) {
	      return _SearchApi2.default.fetchAdditionalFilters(query, fieldId, apiClient);
	    }
	  };
	}
	
	function toggleSearchView(view) {
	  var expires = (0, _moment2.default)().add(10, 'years').toDate();
	  (0, _utilsBrowser.setCookie)(_SearchConstants.SEARCH_VIEW_COOKIE_NAME, view, { expires: expires });
	  return {
	    type: _SearchConstants2.default.TOGGLE_SEARCH_VIEW,
	    view: view
	  };
	}
	
	function toggleShowGroupings(newState) {
	  (0, _utilsBrowser.setCookie)(GROUPING_COOKIE, newState || '');
	  return {
	    type: _SearchConstants2.default.TOGGLE_SHOW_GROUPINGS
	  };
	}
	
	function receiveSearchResults(response) {
	  return {
	    type: _SearchConstants2.default.SEARCH_SUCCESS,
	    payload: response.body
	  };
	}
	
	function searchRequestFailed(payload) {
	  return {
	    type: _SearchConstants2.default.SEARCH_FAILURE,
	    payload: _extends({
	      id: null,
	      status: _lodash2.default.get(payload, 'status')
	    }, _lodash2.default.get(payload, 'response.body'))
	  };
	}
	
	function getGroupSearchSummaries(metadataIds) {
	  return {
	    types: [_SearchConstants2.default.GROUP_SEARCH_SUMMARY_REQUEST, _SearchConstants2.default.GROUP_SEARCH_SUMMARY_SUCCESS, _SearchConstants2.default.GROUP_SEARCH_SUMMARY_FAILURE],
	    apiRequest: function apiRequest(state, apiClient) {
	      return _SearchApi2.default.fetchGroupSearchSummaries(metadataIds, state.getIn(['library', 'libraryId']), apiClient);
	    }
	  };
	}
	
	exports.default = {
	  expandField: expandField,
	  getGroupSearchSummaries: getGroupSearchSummaries,
	  getSearchProbes: getSearchProbes,
	  addTitleSearch: addTitleSearch,
	  receiveSearchResults: receiveSearchResults,
	  searchRequestFailed: searchRequestFailed,
	  toggleSearchView: toggleSearchView,
	  toggleShowGroupings: toggleShowGroupings,
	  performSearch: performSearch
	};

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ItemList = __webpack_require__(1945);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ItemList).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AddToShelfButtonContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(14);
	
	var _redux = __webpack_require__(18);
	
	var _ShelfActions = __webpack_require__(107);
	
	var _ShelfActions2 = _interopRequireDefault(_ShelfActions);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _sharedOnShelfButton = __webpack_require__(1497);
	
	var _sharedOnShelfButton2 = _interopRequireDefault(_sharedOnShelfButton);
	
	var _utilsGoogleAnalytics = __webpack_require__(231);
	
	var _utilsGoogleAnalytics2 = _interopRequireDefault(_utilsGoogleAnalytics);
	
	var _AddToShelfComboButton = __webpack_require__(583);
	
	var _AddToShelfComboButton2 = _interopRequireDefault(_AddToShelfComboButton);
	
	var _ShelfSelector = __webpack_require__(75);
	
	var _ShelfConstants = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AddToShelfButtonContainer = exports.AddToShelfButtonContainer = function (_BcReactComponent) {
	  _inherits(AddToShelfButtonContainer, _BcReactComponent);
	
	  function AddToShelfButtonContainer(props) {
	    _classCallCheck(this, AddToShelfButtonContainer);
	
	    var _this = _possibleConstructorReturn(this, (AddToShelfButtonContainer.__proto__ || Object.getPrototypeOf(AddToShelfButtonContainer)).call(this, props));
	
	    _this.bindAll('handleShelfAdd', 'handleClickOnMyShelf');
	    return _this;
	  }
	
	  _createClass(AddToShelfButtonContainer, [{
	    key: 'handleShelfAdd',
	    value: function handleShelfAdd(newShelf) {
	      AddToShelfButtonContainer.trackShelfAdd(newShelf);
	      this.props.shelfActions.addToShelf(this.props.metadataId, newShelf);
	    }
	  }, {
	    key: 'handleClickOnMyShelf',
	    value: function handleClickOnMyShelf() {
	      var _props = this.props,
	          metadataId = _props.metadataId,
	          workflowId = _props.workflowId;
	
	      var shelf = this.props.currentShelfItem.get('shelf');
	      this.props.shelfActions.showPostAddToShelfView(metadataId, shelf, workflowId || metadataId);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          currentShelfItem = _props2.currentShelfItem,
	          isAdding = _props2.isAdding,
	          bibBrief = _props2.bibBrief,
	          disabled = _props2.disabled;
	
	      if (!currentShelfItem) {
	        return _react2.default.createElement(_AddToShelfComboButton2.default, {
	          primaryShelfAction: this.props.primaryShelfAction,
	          disabled: disabled,
	          isLoading: isAdding,
	          bibBrief: bibBrief,
	          handleClick: this.handleShelfAdd });
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_sharedOnShelfButton2.default, {
	          disabled: disabled,
	          shelfItem: currentShelfItem,
	          bibBrief: bibBrief,
	          handleClick: this.handleClickOnMyShelf })
	      );
	    }
	  }], [{
	    key: 'trackShelfAdd',
	    value: function trackShelfAdd(shelf) {
	      _utilsGoogleAnalytics2.default.event({
	        eventCategory: 'NERF Search',
	        eventAction: 'Add To ' + (shelf || _ShelfConstants.SHELF_NAMES.FOR_LATER) + ' Shelf'
	      });
	    }
	  }]);
	
	  return AddToShelfButtonContainer;
	}(_baseBcReactComponent2.default);
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  var metadataId = ownProps.metadataId;
	
	  var currentShelfItem = (0, _ShelfSelector.getShelvesForCurrentUser)(state).get(metadataId);
	  var isAdding = (0, _ShelfSelector.getShelfTransactions)(state).getIn([metadataId, 'isAdding']);
	  var bibBrief = state.getIn(['entities', 'bibs', metadataId, 'briefInfo']);
	  return { currentShelfItem: currentShelfItem, isAdding: isAdding, bibBrief: bibBrief };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    shelfActions: (0, _redux.bindActionCreators)(_ShelfActions2.default, dispatch)
	  };
	};
	
	AddToShelfButtonContainer.propTypes = {
	  currentShelfItem: _reactImmutableProptypes2.default.map,
	  metadataId: _react.PropTypes.string.isRequired,
	  workflowId: _react.PropTypes.string,
	  isAdding: _react.PropTypes.bool,
	  disabled: _react.PropTypes.bool,
	  shelfActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  primaryShelfAction: _react.PropTypes.string
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIntl.injectIntl)(AddToShelfButtonContainer));

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(14);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    featureFlags: state.getIn(['app', 'featureFlags'])
	  };
	};
	
	var FeatureFlagContainer = function (_React$Component) {
	  _inherits(FeatureFlagContainer, _React$Component);
	
	  function FeatureFlagContainer() {
	    _classCallCheck(this, FeatureFlagContainer);
	
	    return _possibleConstructorReturn(this, (FeatureFlagContainer.__proto__ || Object.getPrototypeOf(FeatureFlagContainer)).apply(this, arguments));
	  }
	
	  _createClass(FeatureFlagContainer, [{
	    key: 'render',
	    value: function render() {
	      return this.props.children(this.props.featureFlags);
	    }
	  }]);
	
	  return FeatureFlagContainer;
	}(_react2.default.Component);
	
	FeatureFlagContainer.propTypes = {
	  children: _react.PropTypes.func.isRequired,
	  featureFlags: _reactImmutableProptypes2.default.mapOf(_react.PropTypes.bool, _react.PropTypes.string)
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(FeatureFlagContainer);

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = updateSearchQuery;
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _formatFiltersForQuery = __webpack_require__(397);
	
	var _formatFiltersForQuery2 = _interopRequireDefault(_formatFiltersForQuery);
	
	var _removeFiltersFromQuery = __webpack_require__(2107);
	
	var _removeFiltersFromQuery2 = _interopRequireDefault(_removeFiltersFromQuery);
	
	var _FacetConstants = __webpack_require__(187);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function isFilter(param) {
	  return param.indexOf(_FacetConstants.FILTER_PREFIX) === 0;
	}
	
	/**
	 * Returns the query object for a new search
	 * @param {object} currentQuery the current location.query object
	 * @param {object} activeFilters currently active filters
	 * @param {object} updates changes to apply to the query
	 */
	function updateSearchQuery(_ref) {
	  var currentQuery = _ref.currentQuery,
	      activeFilters = _ref.activeFilters,
	      updates = _objectWithoutProperties(_ref, ['currentQuery', 'activeFilters']);
	
	  var updatedQuery = _extends({}, (0, _removeFiltersFromQuery2.default)(currentQuery), (0, _formatFiltersForQuery2.default)(activeFilters || _immutable2.default.Map()), updates);
	
	  // Clear locked if there are no filters applied anymore
	  var params = Object.keys(updatedQuery).filter(function (param) {
	    return !!updatedQuery[param];
	  });
	  if (!params.some(isFilter)) {
	    updatedQuery.locked = undefined;
	  }
	
	  return updatedQuery;
	}

/***/ },
/* 149 */
76,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(2841),
	    getValue = __webpack_require__(2883);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(455);
	
	/**
	 * Performs a deep comparison between two values to determine if they are
	 * equivalent.
	 *
	 * **Note:** This method supports comparing arrays, array buffers, booleans,
	 * date objects, error objects, maps, numbers, `Object` objects, regexes,
	 * sets, strings, symbols, and typed arrays. `Object` objects are compared
	 * by their own, not inherited, enumerable properties. Functions and DOM
	 * nodes are compared by strict equality, i.e. `===`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.isEqual(object, other);
	 * // => true
	 *
	 * object === other;
	 * // => false
	 */
	function isEqual(value, other) {
	  return baseIsEqual(value, other);
	}
	
	module.exports = isEqual;


/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(720),
	    baseKeys = __webpack_require__(725),
	    isArrayLike = __webpack_require__(209);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ },
/* 164 */,
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(27);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _constants = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _propTypes2['default'].oneOf(_constants.WEEKDAYS);

/***/ },
/* 166 */
[3530, 32],
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(3021);
	var ReactInstrumentation = __webpack_require__(81);
	
	var warning = __webpack_require__(26);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID // 0 in production and for roots
	  ) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactReconciler;

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _utilsCombineReducers = __webpack_require__(3126);
	
	var _utilsCombineReducers2 = _interopRequireDefault(_utilsCombineReducers);
	
	var _utilsCreateReducer = __webpack_require__(3127);
	
	var _utilsCreateReducer2 = _interopRequireDefault(_utilsCreateReducer);
	
	exports.combineReducers = _utilsCombineReducers2['default'];
	exports.createReducer = _utilsCreateReducer2['default'];

/***/ },
/* 169 */,
/* 170 */,
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	var lowerCase = __webpack_require__(257)
	
	var NON_WORD_REGEXP = __webpack_require__(3411)
	var CAMEL_CASE_REGEXP = __webpack_require__(3410)
	var TRAILING_DIGIT_REGEXP = __webpack_require__(3412)
	
	/**
	 * Sentence case a string.
	 *
	 * @param  {String} str
	 * @param  {String} locale
	 * @param  {String} replacement
	 * @return {String}
	 */
	module.exports = function (str, locale, replacement) {
	  if (str == null) {
	    return ''
	  }
	
	  replacement = replacement || ' '
	
	  function replace (match, index, string) {
	    if (index === 0 || index === (string.length - match.length)) {
	      return ''
	    }
	
	    return replacement
	  }
	
	  str = String(str)
	    // Support camel case ("camelCase" -> "camel Case").
	    .replace(CAMEL_CASE_REGEXP, '$1 $2')
	    // Support digit groups ("test2012" -> "test 2012").
	    .replace(TRAILING_DIGIT_REGEXP, '$1 $2')
	    // Remove all non-word characters and replace with a single space.
	    .replace(NON_WORD_REGEXP, replace)
	
	  // Lower case the entire string.
	  return lowerCase(str, locale)
	}


/***/ },
/* 172 */
/***/ function(module, exports) {

	/**
	 * Special language-specific overrides.
	 *
	 * Source: ftp://ftp.unicode.org/Public/UCD/latest/ucd/SpecialCasing.txt
	 *
	 * @type {Object}
	 */
	var LANGUAGES = {
	  tr: {
	    regexp: /[\u0069]/g,
	    map: {
	      '\u0069': '\u0130'
	    }
	  },
	  az: {
	    regexp: /[\u0069]/g,
	    map: {
	      '\u0069': '\u0130'
	    }
	  },
	  lt: {
	    regexp: /[\u0069\u006A\u012F]\u0307|\u0069\u0307[\u0300\u0301\u0303]/g,
	    map: {
	      '\u0069\u0307': '\u0049',
	      '\u006A\u0307': '\u004A',
	      '\u012F\u0307': '\u012E',
	      '\u0069\u0307\u0300': '\u00CC',
	      '\u0069\u0307\u0301': '\u00CD',
	      '\u0069\u0307\u0303': '\u0128'
	    }
	  }
	}
	
	/**
	 * Upper case a string.
	 *
	 * @param  {String} str
	 * @return {String}
	 */
	module.exports = function (str, locale) {
	  var lang = LANGUAGES[locale]
	
	  str = str == null ? '' : String(str)
	
	  if (lang) {
	    str = str.replace(lang.regexp, function (m) { return lang.map[m] })
	  }
	
	  return str.toUpperCase()
	}


/***/ },
/* 173 */,
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _availabilityEventComposer = __webpack_require__(989);
	
	Object.defineProperty(exports, 'availabilityEventComposer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_availabilityEventComposer).default;
	  }
	});
	
	var _bibFormatChooser = __webpack_require__(990);
	
	Object.defineProperty(exports, 'bibFormatChooser', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_bibFormatChooser).default;
	  }
	});
	
	var _commentsEventComposer = __webpack_require__(992);
	
	Object.defineProperty(exports, 'commentsEventComposer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_commentsEventComposer).default;
	  }
	});
	
	var _ratingsEventComposer = __webpack_require__(996);
	
	Object.defineProperty(exports, 'ratingsEventComposer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ratingsEventComposer).default;
	  }
	});
	
	var _tagsEventComposer = __webpack_require__(999);
	
	Object.defineProperty(exports, 'tagsEventComposer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_tagsEventComposer).default;
	  }
	});
	
	var _shelvesEventComposer = __webpack_require__(513);
	
	Object.defineProperty(exports, 'shelvesEventComposer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_shelvesEventComposer).default;
	  }
	});
	
	var _holdsEventComposer = __webpack_require__(993);
	
	Object.defineProperty(exports, 'holdsEventComposer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_holdsEventComposer).default;
	  }
	});
	
	var _checkoutsEventComposer = __webpack_require__(991);
	
	Object.defineProperty(exports, 'checkoutsEventComposer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_checkoutsEventComposer).default;
	  }
	});
	
	var _quotationsEventComposer = __webpack_require__(995);
	
	Object.defineProperty(exports, 'quotationsEventComposer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_quotationsEventComposer).default;
	  }
	});
	
	var _searchEventComposer = __webpack_require__(997);
	
	Object.defineProperty(exports, 'searchEventComposer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_searchEventComposer).default;
	  }
	});
	
	var _videosEventComposer = __webpack_require__(1000);
	
	Object.defineProperty(exports, 'videosEventComposer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_videosEventComposer).default;
	  }
	});
	
	var _iOwnThisEventComposer = __webpack_require__(994);
	
	Object.defineProperty(exports, 'iOwnThisEventComposer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_iOwnThisEventComposer).default;
	  }
	});
	
	var _similarTitlesEventComposer = __webpack_require__(998);
	
	Object.defineProperty(exports, 'similarTitlesEventComposer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_similarTitlesEventComposer).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Alert = __webpack_require__(1014);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Alert).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Icon = __webpack_require__(1082);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Icon).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FormatIndicator = __webpack_require__(1416);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FormatIndicator).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _LoginLink = __webpack_require__(1524);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_LoginLink).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 179 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var localizedFields = ['FORMAT', 'STATUS', 'BRANCH', 'PRIMARY_LANGUAGE', 'LANGUAGE', 'FICTION_TYPE', 'CIRC', 'TECHNICAL_DIFFICULTY', 'UGC_RATING', 'NEWLY_ACQUIRED', 'AUDIENCE', 'ON_ORDER'];
	
	var conjunctiveFields = ['NEWLY_ACQUIRED', 'FICTION_TYPE', 'GEO_HEADINGS', 'GENRE_HEADINGS', 'TOPIC_HEADINGS', 'AUTHOR', 'PUBLISHED_DATE', 'UGC_RATING', 'TECHNICAL_DIFFICULTY', 'TAG_GENRE', 'TAG_TONE', 'TAG_ABOUT', 'TAG_PERSONAL'];
	
	var isConjunctiveField = exports.isConjunctiveField = function isConjunctiveField(fieldId) {
	  return conjunctiveFields.indexOf(fieldId) >= 0;
	};
	
	var getLabel = exports.getLabel = function getLabel(intl, id, value) {
	  var singleBranch = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	  if (id === 'STATUS' && value === '_anywhere_' && singleBranch) {
	    // Override for single branch libraries
	    return intl.formatMessage({ id: 'STATUS.field' });
	  }
	
	  if (localizedFields.indexOf(id) === -1) {
	    return value;
	  }
	
	  if (id === 'PRIMARY_LANGUAGE') {
	    return intl.formatMessage({ id: 'LANGUAGE.' + value.toLowerCase(), defaultMessage: value }) || value;
	  }
	
	  return intl.formatMessage({ id: id + '.' + value.toLowerCase(), defaultMessage: value }) || value;
	};

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchSummaries = fetchSummaries;
	
	var _BorrowingConstants = __webpack_require__(294);
	
	var _BorrowingConstants2 = _interopRequireDefault(_BorrowingConstants);
	
	var _BorrowingApi = __webpack_require__(1601);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function fetchSummaries(_ref) {
	  var accountId = _ref.accountId;
	
	  return {
	    types: [_BorrowingConstants2.default.FETCH_SUMMARIES_REQUEST, _BorrowingConstants2.default.FETCH_SUMMARIES_SUCCESS, _BorrowingConstants2.default.FETCH_SUMMARIES_FAILURE],
	    middlewareData: {
	      accountRequired: true
	    },
	    apiRequest: function apiRequest(state, apiClient) {
	      return (0, _BorrowingApi.getBorrowingSummaries)(apiClient, { accountId: accountId });
	    }
	  };
	}
	
	exports.default = {
	  fetchSummaries: fetchSummaries
	};

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _MessagingConstants = __webpack_require__(73);
	
	var _MessagingConstants2 = _interopRequireDefault(_MessagingConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function clearMessages(ids) {
	  return {
	    type: _MessagingConstants2.default.CLEAR_MESSAGING,
	    messagingIds: Array.isArray(ids) ? ids : [ids]
	  };
	}
	
	function clearGlobalMessage() {
	  return {
	    type: _MessagingConstants2.default.CLEAR_MESSAGING,
	    messagingIds: [_MessagingConstants.GLOBAL_MESSAGING_ID]
	  };
	}
	
	exports.default = {
	  clearMessages: clearMessages,
	  clearGlobalMessage: clearGlobalMessage
	};

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BorrowingStatus = __webpack_require__(1813);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BorrowingStatus).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SidebarCompactTitle = __webpack_require__(1836);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SidebarCompactTitle).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DisplayHeading = __webpack_require__(1981);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DisplayHeading).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DisplayWrapper = __webpack_require__(1982);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DisplayWrapper).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utilsRedux = __webpack_require__(20);
	
	exports.default = (0, _utilsRedux.createReduxConstants)('APP', {
	  FETCH_COOKIES: null,
	  LOAD_APP_CONFIG: null,
	  LOAD_COOKIES: null,
	  SHOW_ERROR_PAGE: null,
	  UPDATE_FEATURE_FLAG_REQUEST: null,
	  UPDATE_FEATURE_FLAG_SUCCESS: null,
	  UPDATE_FEATURE_FLAG_FAILURE: null
	});

/***/ },
/* 187 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var FILTER_SEPARATOR = exports.FILTER_SEPARATOR = '|';
	var FILTER_PREFIX = exports.FILTER_PREFIX = 'f_';
	
	var FIELD_ORDER = exports.FIELD_ORDER = ['IS_PRIVATE', 'I_OWN_THIS', 'SEARCH_SCOPE', 'STATUS', 'FORMAT', 'NEWLY_ACQUIRED', 'CIRC', 'FICTION_TYPE', 'AUDIENCE', 'GENRE_HEADINGS', 'TOPIC_HEADINGS', 'GEO_HEADINGS', 'AUTHOR', 'LANGUAGES', 'PUBLISHED_DATE', 'UGC_RATING', 'TAGS', 'TECHNICAL_DIFFICULTY'];
	
	var FORMAT_GROUP_ORDER = exports.FORMAT_GROUP_ORDER = ['BOOKS', 'AUDIOBOOKS_SPOKEN_WORD', 'MOVIES_TV_VIDEO', 'MUSIC_SOUND', 'GAMES_INTERACTIVE_MEDIA', 'JOURNALS_MAGAZINES', 'ACCESSIBLE_FORMATS', 'OTHER'];

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _injectLibrary = __webpack_require__(396);
	
	var _injectLibrary2 = _interopRequireDefault(_injectLibrary);
	
	var _sharedFormatInfo = __webpack_require__(367);
	
	var _sharedFormatInfo2 = _interopRequireDefault(_sharedFormatInfo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapLibraryToProps = function mapLibraryToProps(_ref, ownProps) {
	  var library = _ref.library;
	  return {
	    showEdition: !library.get('onlyShowEditionsForCDROMAndVideoGames') || ['CDROM', 'VIDEO_GAME'].includes(ownProps.item.getIn(['briefInfo', 'format'])),
	    showCallNumber: typeof ownProps.showCallNumber !== 'undefined' ? ownProps.showCallNumber : library.get('showCallNumber') && (library.get('showCallNumberForDigital') || ownProps.item.getIn(['policy', 'materialType']) === 'PHYSICAL') && (!library.get('hideCallNumberForHigherSearchScope') || ownProps.searchScopeIsCurrent)
	  };
	};
	
	exports.default = (0, _injectLibrary2.default)(mapLibraryToProps)(_sharedFormatInfo2.default);

/***/ },
/* 189 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = composeMessaging;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function composeMessaging(messageType, messagingId, messageId) {
	  var opts = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	  var _opts$defaultMessage = opts.defaultMessage,
	      defaultMessage = _opts$defaultMessage === undefined ? '' : _opts$defaultMessage,
	      _opts$values = opts.values,
	      values = _opts$values === undefined ? {} : _opts$values,
	      rest = _objectWithoutProperties(opts, ['defaultMessage', 'values']);
	
	  return _defineProperty({}, messagingId, _extends({
	    message: {
	      type: messageType,
	      id: messageId,
	      defaultMessage: defaultMessage,
	      values: values
	    }
	  }, rest));
	}

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = composeSuccessMessaging;
	
	var _composeMessaging = __webpack_require__(189);
	
	var _composeMessaging2 = _interopRequireDefault(_composeMessaging);
	
	var _MessagingConstants = __webpack_require__(73);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function composeSuccessMessaging(messagingId, messageId) {
	  var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  return (0, _composeMessaging2.default)(_MessagingConstants.STATUS_TYPES.Success, messagingId, messageId, opts);
	}

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getRenewFailures = exports.getFailuresByAction = exports.getCheckedoutStatus = exports.getCheckoutTransactions = exports.getSelectedStatus = exports.getCheckedoutQuotas = exports.getPresentStatuses = exports.getMaterialTypeCounts = exports.getPagination = exports.getCountsByStatus = exports.getCurrentCheckouts = exports.getCheckoutsByMetadataId = undefined;
	
	var _lodash = __webpack_require__(16);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reselect = __webpack_require__(34);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _utilsBorrowing = __webpack_require__(230);
	
	var _BorrowingSelector = __webpack_require__(300);
	
	var _ShelfSelector = __webpack_require__(75);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var checkedoutSummary = function checkedoutSummary(state) {
	  return (0, _BorrowingSelector.getSummary)(state, 'checkedout');
	};
	var statusFilter = function statusFilter(state, props) {
	  return _lodash2.default.get(props, 'router.params.status');
	};
	var pagination = function pagination(state) {
	  return state.getIn(['borrowing', 'checkedout', 'pagination'], _immutable2.default.Map());
	};
	
	var allCheckouts = function allCheckouts(state) {
	  return state.getIn(['entities', 'checkouts'], _immutable2.default.Map());
	};
	var bibsById = function bibsById(state) {
	  return state.getIn(['entities', 'bibs'], _immutable2.default.Map());
	};
	var checkoutTransactions = function checkoutTransactions(state) {
	  return state.getIn(['borrowing', 'checkedout', 'checkoutTransactions'], _immutable2.default.Map());
	};
	var checkedoutStatus = function checkedoutStatus(state) {
	  return state.getIn(['borrowing', 'checkedout'], _immutable2.default.Map());
	};
	var failuresByAction = function failuresByAction(state) {
	  return state.getIn(['borrowing', 'checkedout', 'failures'], _immutable2.default.Map());
	};
	var currentItemIds = function currentItemIds(state) {
	  return state.getIn(['borrowing', 'checkedout', 'items'], _immutable2.default.List());
	};
	
	var getCheckoutsByMetadataId = exports.getCheckoutsByMetadataId = (0, _reselect.createSelector)([allCheckouts], function (checkoutsById) {
	  return checkoutsById.groupBy(function (checkout) {
	    return checkout.get('metadataId');
	  });
	});
	
	var getCurrentCheckouts = exports.getCurrentCheckouts = (0, _reselect.createSelector)([currentItemIds, allCheckouts, bibsById, _ShelfSelector.getShelvesForCurrentUser], function (checkoutIds, checkoutsById, bibs, shelfItems) {
	  return checkoutIds.map(function (id) {
	    return checkoutsById.get(id);
	  }).filter(function (checkout) {
	    return !!checkout;
	  }).map(function (checkout) {
	    return checkout.set('bib', bibs.get(checkout.get('metadataId')));
	  }).map(function (checkout) {
	    var isAlreadyOnShelf = shelfItems.some(function (item) {
	      return item.get('metadataId') === checkout.get('metadataId');
	    });
	
	    var canAddToShelf = checkout.get('bib') && !isAlreadyOnShelf;
	
	    var actions = canAddToShelf ? checkout.get('actions', _immutable2.default.List()).push('addToShelf') : checkout.get('actions');
	
	    return checkout.set('actions', actions);
	  }).toList();
	});
	
	var getCountsByStatus = exports.getCountsByStatus = (0, _reselect.createSelector)([checkedoutSummary], function (summary) {
	  return (0, _utilsBorrowing.getCountsByStatusFromSummary)(summary);
	});
	
	var getPagination = exports.getPagination = (0, _reselect.createSelector)([pagination], function (page) {
	  return page;
	});
	
	var getMaterialTypeCounts = exports.getMaterialTypeCounts = (0, _reselect.createSelector)([checkedoutSummary, statusFilter], function (summary, currentStatus) {
	  return (0, _utilsBorrowing.getMaterialTypeCountsForStatus)(summary, currentStatus);
	});
	
	var getPresentStatuses = exports.getPresentStatuses = (0, _reselect.createSelector)([checkedoutSummary], function (summary) {
	  return (0, _utilsBorrowing.getPresentStatusesFromSummary)(summary);
	});
	
	var getCheckedoutQuotas = exports.getCheckedoutQuotas = (0, _reselect.createSelector)([checkedoutSummary], function (summary) {
	  return summary.get('quotas', _immutable2.default.List());
	});
	
	var getSelectedStatus = exports.getSelectedStatus = (0, _reselect.createSelector)([statusFilter], function (status) {
	  return status ? status.toUpperCase() : status;
	});
	
	var getCheckoutTransactions = exports.getCheckoutTransactions = (0, _reselect.createSelector)([checkoutTransactions], function (transactions) {
	  return transactions;
	});
	
	var getCheckedoutStatus = exports.getCheckedoutStatus = (0, _reselect.createSelector)([checkedoutStatus], function (status) {
	  return status;
	});
	
	var getFailuresByAction = exports.getFailuresByAction = (0, _reselect.createSelector)([failuresByAction], function (failures) {
	  return failures;
	});
	
	var getRenewFailures = exports.getRenewFailures = (0, _reselect.createSelector)([failuresByAction, bibsById, allCheckouts], function (failures, bibs, checkouts) {
	  return failures.get('renew', _immutable2.default.List()).map(function (failure) {
	    return failure.set('checkout', checkouts.get(failure.get('id')));
	  }).map(function (failure) {
	    return failure.set('bib', bibs.get(failure.getIn(['checkout', 'metadataId'])));
	  });
	});
	
	exports.default = {
	  getMaterialTypeCounts: getMaterialTypeCounts,
	  getPresentStatuses: getPresentStatuses,
	  getCheckedoutQuotas: getCheckedoutQuotas,
	  getSelectedStatus: getSelectedStatus,
	  getCheckoutsByMetadataId: getCheckoutsByMetadataId,
	  getPagination: getPagination,
	  getCheckoutTransactions: getCheckoutTransactions,
	  getCheckedoutStatus: getCheckedoutStatus,
	  getFailuresByAction: getFailuresByAction,
	  getRenewFailures: getRenewFailures,
	  getCurrentCheckouts: getCurrentCheckouts,
	  getCountsByStatus: getCountsByStatus
	};

/***/ },
/* 192 */
85,
/* 193 */
[3489, 303],
/* 194 */
[3492, 196, 305, 193],
/* 195 */
31,
/* 196 */
[3501, 247, 655, 412, 193],
/* 197 */
[3515, 2210, 402],
/* 198 */
[3521, 410, 306, 129],
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */
/***/ function(module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = isTouchDevice;
	function isTouchDevice() {
	  return !!(typeof window !== 'undefined' && ('ontouchstart' in window || window.DocumentTouch && typeof document !== 'undefined' && document instanceof window.DocumentTouch)) || !!(typeof navigator !== 'undefined' && (navigator.maxTouchPoints || navigator.msMaxTouchPoints));
	}
	module.exports = exports['default'];

/***/ },
/* 206 */,
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(65),
	    isKey = __webpack_require__(464),
	    stringToPath = __webpack_require__(2926),
	    toString = __webpack_require__(759);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(337);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(751),
	    isLength = __webpack_require__(469);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @providesModule shallowCompare
	 */
	
	'use strict';
	
	var shallowEqual = __webpack_require__(252);
	
	/**
	 * Does a shallow comparison for props and state.
	 * See ReactComponentWithPureRenderMixin
	 * See also https://facebook.github.io/react/docs/shallow-compare.html
	 */
	function shallowCompare(instance, nextProps, nextState) {
	  return (
	    !shallowEqual(instance.props, nextProps) ||
	    !shallowEqual(instance.state, nextState)
	  );
	}
	
	module.exports = shallowCompare;


/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(27);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _constants = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _propTypes2['default'].oneOf([_constants.OPEN_DOWN, _constants.OPEN_UP]);

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(27);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _constants = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _propTypes2['default'].oneOf([_constants.HORIZONTAL_ORIENTATION, _constants.VERTICAL_ORIENTATION, _constants.VERTICAL_SCROLLABLE]);

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = isInclusivelyAfterDay;
	
	var _moment = __webpack_require__(9);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _isBeforeDay = __webpack_require__(263);
	
	var _isBeforeDay2 = _interopRequireDefault(_isBeforeDay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function isInclusivelyAfterDay(a, b) {
	  if (!_moment2['default'].isMoment(a) || !_moment2['default'].isMoment(b)) return false;
	  return !(0, _isBeforeDay2['default'])(a, b);
	}

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = isSameDay;
	
	var _moment = __webpack_require__(9);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function isSameDay(a, b) {
	  if (!_moment2['default'].isMoment(a) || !_moment2['default'].isMoment(b)) return false;
	  // Compare least significant, most likely to change units first
	  // Moment's isSame clones moment inputs and is a tad slow
	  return a.date() === b.date() && a.month() === b.month() && a.year() === b.year();
	}

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = toMomentObject;
	
	var _moment = __webpack_require__(9);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _constants = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function toMomentObject(dateString, customFormat) {
	  var dateFormats = customFormat ? [customFormat, _constants.DISPLAY_FORMAT, _constants.ISO_FORMAT] : [_constants.DISPLAY_FORMAT, _constants.ISO_FORMAT];
	
	  var date = (0, _moment2['default'])(dateString, dateFormats, true);
	  return date.isValid() ? date.hour(12) : null;
	}

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(477);
	var setInnerHTML = __webpack_require__(347);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(485);
	var setTextContent = __webpack_require__(897);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(32);
	
	var invariant = __webpack_require__(19);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(32);
	
	var EventPluginRegistry = __webpack_require__(478);
	var EventPluginUtils = __webpack_require__(342);
	var ReactErrorUtils = __webpack_require__(482);
	
	var accumulateInto = __webpack_require__(891);
	var forEachAccumulated = __webpack_require__(892);
	var invariant = __webpack_require__(19);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	
	};
	
	module.exports = EventPluginHub;

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(218);
	var EventPluginUtils = __webpack_require__(342);
	
	var accumulateInto = __webpack_require__(891);
	var forEachAccumulated = __webpack_require__(892);
	var warning = __webpack_require__(26);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ },
/* 220 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	
	};
	
	module.exports = ReactInstanceMap;

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(111);
	
	var getEventTarget = __webpack_require__(488);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ },
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BibBlock = __webpack_require__(1001);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BibBlock).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ManageFocus = __webpack_require__(1010);
	
	var _ManageFocus2 = _interopRequireDefault(_ManageFocus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ManageFocus2.default; /*
	                                          * Exports
	                                          */

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AccessibleTextField = __webpack_require__(1013);
	
	var _AccessibleTextField2 = _interopRequireDefault(_AccessibleTextField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _AccessibleTextField2.default; /*
	                                                  * Exports
	                                                  */

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SimpleUGCDisplay = __webpack_require__(1536);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SimpleUGCDisplay).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.itemMatchesStatusFilter = exports.itemMatchesMaterialTypeFilter = exports.getCountsByStatusFromSummary = exports.getTotalCountFromSummary = exports.getTotalFromMaterialTypeCounts = exports.getMaterialTypeCountsForStatus = exports.getTotalMaterialTypeCounts = exports.getPresentStatusesFromSummary = undefined;
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getPresentStatusesFromSummary = exports.getPresentStatusesFromSummary = function getPresentStatusesFromSummary(borrowingSummary) {
	  return borrowingSummary.get('status', _immutable2.default.Map()).filter(function (materialTypeCounts) {
	    return materialTypeCounts.get('DIGITAL', 0) > 0 || materialTypeCounts.get('PHYSICAL', 0) > 0;
	  }).keySeq().toList();
	};
	
	var getTotalMaterialTypeCounts = exports.getTotalMaterialTypeCounts = function getTotalMaterialTypeCounts(borrowingSummary) {
	  return borrowingSummary.get('status', _immutable2.default.Map()).reduce(function (totalCount, countForStatus) {
	    return totalCount.set('PHYSICAL', totalCount.get('PHYSICAL', 0) + countForStatus.get('PHYSICAL', 0)).set('DIGITAL', totalCount.get('DIGITAL', 0) + countForStatus.get('DIGITAL', 0));
	  }, _immutable2.default.Map().asMutable()).asImmutable();
	};
	
	var getMaterialTypeCountsForStatus = exports.getMaterialTypeCountsForStatus = function getMaterialTypeCountsForStatus(borrowingSummary, status) {
	  if (status) {
	    return borrowingSummary.getIn(['status', status.toUpperCase()], _immutable2.default.Map({
	      PHYSICAL: 0,
	      DIGITAL: 0
	    }));
	  }
	
	  return getTotalMaterialTypeCounts(borrowingSummary);
	};
	
	var getTotalFromMaterialTypeCounts = exports.getTotalFromMaterialTypeCounts = function getTotalFromMaterialTypeCounts(countsByMaterialType) {
	  return countsByMaterialType.get('DIGITAL', 0) + countsByMaterialType.get('PHYSICAL', 0);
	};
	
	var getTotalCountFromSummary = exports.getTotalCountFromSummary = function getTotalCountFromSummary(borrowingSummary) {
	  return borrowingSummary.get('status', _immutable2.default.Map()).reduce(function (acc, countsByMaterialType) {
	    return acc + getTotalFromMaterialTypeCounts(countsByMaterialType);
	  }, 0);
	};
	
	var getCountsByStatusFromSummary = exports.getCountsByStatusFromSummary = function getCountsByStatusFromSummary(borrowingSummary) {
	  return borrowingSummary.get('status', _immutable2.default.Map()).map(function (countsByMaterialType) {
	    return getTotalFromMaterialTypeCounts(countsByMaterialType);
	  });
	};
	
	var itemMatchesMaterialTypeFilter = exports.itemMatchesMaterialTypeFilter = function itemMatchesMaterialTypeFilter(item, materialType) {
	  return !materialType || materialType.toUpperCase() === item.getIn(['bib', 'policy', 'materialType']);
	};
	
	var itemMatchesStatusFilter = exports.itemMatchesStatusFilter = function itemMatchesStatusFilter(item, status) {
	  return !status || status.toUpperCase() === item.get('status').toUpperCase();
	};

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(16);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _urlParse = __webpack_require__(969);
	
	var _urlParse2 = _interopRequireDefault(_urlParse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	  Code modifed from ReactGA (https://github.com/react-ga/react-ga) to allow for
	  multiple GA trackers.
	 **/
	
	/**
	 * create():
	 * Creates trackers and pulls down analytics.js if it is not already in the
	 * window namespace.
	 * @param options {object} Fields object for creating a tracker
	 */
	function create(options) {
	  if (window && !window.ga) {
	    // https://developers.google.com/analytics/devguides/collection/analyticsjs/
	    /* eslint-disable */
	    (function (i, s, o, g, r, a, m) {
	      i['GoogleAnalyticsObject'] = r;
	      i[r] = i[r] || function () {
	        (i[r].q = i[r].q || []).push(arguments);
	      }, i[r].l = 1 * new Date();
	      a = s.createElement(o), m = s.getElementsByTagName(o)[0];
	      a.async = 1;
	      a.src = g;
	      m.parentNode.insertBefore(a, m);
	    })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');
	    /* eslint-enable */
	  }
	
	  window.ga('create', options);
	}
	
	/**
	 * ga:
	 * Safe passthrough wrapper for window.ga
	 */
	function ga() {
	  if (window && window.ga) {
	    return window.ga;
	  }
	
	  return undefined;
	}
	
	function sendPageviewToTrackers(path) {
	  // There may be trackers from the Core header in GA's namespace. Filter out
	  // any trackers that are NOT NERF-specific.
	  var trackers = window.ga.getAll().filter(function (tracker) {
	    var regex = /^bcNERF/;
	    var name = tracker.get('name');
	    return regex.test(name);
	  });
	
	  return _lodash2.default.each(trackers, function (tracker) {
	    tracker.send('pageview', path);
	  });
	}
	
	/**
	 * pageView():
	 * Send a page view event to GA for the provided path
	 * @param path {string} Path to track
	 */
	function pageView(path) {
	  if (!window || !window.ga) {
	    return false;
	  }
	
	  window.ga('set', { page: path });
	  // GA may not be fully instantiated yet. Put the command in the command queue
	  // if necessary
	  if (!window.ga.getAll) {
	    return window.ga(function () {
	      sendPageviewToTrackers(path);
	    });
	  }
	
	  return sendPageviewToTrackers(path);
	}
	
	/**
	 * event():
	 * Send an event object to GA
	 * @param event {object} Event object to send to GA
	 * @param sendToLibrary {boolean} send to library's tracker
	 */
	function event(eventObj) {
	  var sendToLibrary = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var trackers = ['bcNERFTracker', sendToLibrary ? 'bcNERFLibraryTracker' : null];
	  if (!window || !window.ga) {
	    return false;
	  }
	
	  trackers.filter(function (tracker) {
	    return !!tracker;
	  }).forEach(function (tracker) {
	    window.ga(tracker + '.send', 'event', eventObj);
	  });
	
	  return true;
	}
	
	function getGACrossDomainNames(library) {
	  var domains = [];
	
	  if (library.gaCrossDomainEnabled) {
	    if (library.gaCrossDomainNames) {
	      domains = library.gaCrossDomainNames;
	    }
	
	    if (library.cmsEnabled && library.cmsUrl) {
	      var parsed = new _urlParse2.default(library.cmsUrl);
	      if (parsed.host) {
	        domains.push(parsed.host);
	      }
	    }
	  }
	
	  return domains;
	}
	
	function initialize(gaTrackingId, library, currentLanguage) {
	  if (gaTrackingId) {
	    create({
	      trackingId: gaTrackingId,
	      cookieDomain: 'auto',
	      name: 'bcNERFTracker'
	    });
	
	    ga()('bcNERFTracker.set', 'language', currentLanguage);
	    ga()('bcNERFTracker.set', 'transport', 'beacon');
	  }
	
	  if (library && library.externalGaId) {
	    create({
	      trackingId: library.externalGaId,
	      name: 'bcNERFLibraryTracker',
	      cookieDomain: library.gaDomainName,
	      allowLinker: library.gaCrossDomainEnabled
	    });
	
	    ga()('bcNERFLibraryTracker.set', 'language', currentLanguage);
	    ga()('bcNERFLibraryTracker.set', 'transport', 'beacon');
	
	    var gaAutolinkDomains = getGACrossDomainNames(library);
	
	    if (gaAutolinkDomains.length) {
	      /* Cross domain tracking */
	      ga()('bcNERFLibraryTracker.require', 'linker');
	      ga()('bcNERFLibraryTracker.linker:autoLink', gaAutolinkDomains);
	    }
	  }
	}
	
	exports.default = {
	  create: create,
	  ga: ga,
	  pageView: pageView,
	  event: event,
	  getGACrossDomainNames: getGACrossDomainNames,
	  initialize: initialize
	};

/***/ },
/* 232 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var MATERIAL_TYPE_DIGITAL = exports.MATERIAL_TYPE_DIGITAL = 'DIGITAL';
	
	var itemTransactionConstants = exports.itemTransactionConstants = {
	  REQUEST_ITEM_BUTTON: 'REQUEST_ITEM_BUTTON',
	  CANCEL_HOLD_BUTTON: 'CANCEL_HOLD_BUTTON',
	  DIGITAL_READING_LINKS: 'DIGITAL_READING_LINKS'
	};
	
	var itemTransactionStatus = exports.itemTransactionStatus = function itemTransactionStatus(hold, materialType, hasItemLevelHoldableItems, checkout) {
	  var isDigitalHoldReady = hold && hold.get('status') === 'READY_FOR_PICKUP' && materialType === MATERIAL_TYPE_DIGITAL;
	  var isDigitalCheckout = checkout && materialType === MATERIAL_TYPE_DIGITAL;
	  var hasItemLevelHold = hold && hold.get('itemId');
	
	  // Show the cancel hold button if the item has an existing hold that is not item level,
	  // even if the bib is marked as having item level holdable items.
	  //
	  // This is necessary because if the ILS does not support predetermined item level holds
	  // a bib with item level holdable items may or may not be item level holdable.
	  var canPlaceItemLevelHolds = hasItemLevelHoldableItems && (!hold || hasItemLevelHold);
	
	  if (hold && !isDigitalHoldReady && !canPlaceItemLevelHolds) {
	    return itemTransactionConstants.CANCEL_HOLD_BUTTON;
	  } else if (isDigitalCheckout && !hasItemLevelHoldableItems) {
	    return itemTransactionConstants.DIGITAL_READING_LINKS;
	  }
	
	  return itemTransactionConstants.REQUEST_ITEM_BUTTON;
	};
	
	var allItemsUnavailable = exports.allItemsUnavailable = function allItemsUnavailable(manifestations) {
	  return (
	    // Since manifestations are sorted by availability, if the first item is unavailable they all are.
	    ['UNAVAILABLE'].includes(manifestations.first().getIn(['availability', 'status']))
	  );
	};
	
	/**
	 * Returns a bib jacket cover alt text information as (bibTile - author(s))
	 *
	 * @param {list} authors
	 */
	var bibJacketCoverAltText = exports.bibJacketCoverAltText = function bibJacketCoverAltText(bibTitle, authors) {
	  if (typeof authors !== 'undefined') {
	    var authorResult = authors.size > 1 ? authors.join(', ') : authors.join();
	    return '' + bibTitle + (authorResult ? ' - ' : '') + authorResult;
	  }
	  return bibTitle;
	};

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.localizeFromKey = localizeFromKey;
	exports.mapLocaleForMoment = mapLocaleForMoment;
	
	var _lodash = __webpack_require__(16);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * This will localize the string if the localKey is provided.
	 * @param  {[type]} obj                Object which contains localKey option
	 * @param  {[type]} intl               Intl helper to get the localize message
	 * @param  {[type]} nonLocalizeTextKey This is the key which contains non-localize string coming from backend
	 *                                     its used in the absence of localKey
	 * @return {[type]}                    Localize string
	 */
	function localizeFromKey(obj, intl) {
	  var nonLocalizeTextKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'text';
	
	  return _lodash2.default.has(obj, 'localeKey') ? intl.formatMessage({ id: obj.localeKey, defaultMessage: nonLocalizeTextKey }) : obj[nonLocalizeTextKey];
	}
	
	/**
	 * This will map current locale string that is compatible with Moment JS/
	 * @param  {[type]} locale             Current locale string
	 * @return {[type]}                    Moment JS compatible locale string
	 */
	
	function mapLocaleForMoment(locale) {
	  var localMap = {
	    'fil-PH': 'tl-PH'
	  };
	  return localMap[locale] || locale;
	}
	
	exports.default = {
	  localizeFromKey: localizeFromKey,
	  mapLocaleForMoment: mapLocaleForMoment
	};

/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.allowFreeText = allowFreeText;
	
	var _constantsUser = __webpack_require__(1406);
	
	/**
	 * Determines whether a user is allowed to add free text or not.
	 * @param {userIdentityShape} user
	 * @return {boolean}
	 */
	/* eslint-disable import/prefer-default-export */
	function allowFreeText(user) {
	  return !!(user && user.get('permissions')) && user.get('permissions').indexOf(_constantsUser.PERMISSIONS.UGC_FREE_TEXT) > -1;
	}

/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BorrowingEmptyContentPanel = __webpack_require__(1803);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BorrowingEmptyContentPanel).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BorrowingList = __webpack_require__(1807);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BorrowingList).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ItemField = __webpack_require__(570);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ItemField).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BatchActionLink = __webpack_require__(1905);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BatchActionLink).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BibListItem = __webpack_require__(1912);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BibListItem).default;
	  }
	});
	Object.defineProperty(exports, 'BibListItem', {
	  enumerable: true,
	  get: function get() {
	    return _BibListItem.BibListItem;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DisplayActions = __webpack_require__(1980);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DisplayActions).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 241 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var MATERIAL_TYPE_PHYSICAL = exports.MATERIAL_TYPE_PHYSICAL = 'PHYSICAL';
	var MATERIAL_TYPE_DIGITAL = exports.MATERIAL_TYPE_DIGITAL = 'DIGITAL';
	
	exports.default = {
	  MATERIAL_TYPE_DIGITAL: MATERIAL_TYPE_DIGITAL,
	  MATERIAL_TYPE_PHYSICAL: MATERIAL_TYPE_PHYSICAL
	};

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TAG_TYPES = undefined;
	
	var _utilsRedux = __webpack_require__(20);
	
	var TAG_TYPES = exports.TAG_TYPES = {
	  GENRE: 'genre',
	  PERSONAL: 'personal',
	  MOOD: 'mood',
	  SUBJECT: 'subject'
	};
	
	exports.default = (0, _utilsRedux.createReduxConstants)('TAGS', {
	  ADD_TAG_REQUEST: null,
	  ADD_TAG_SUCCESS: null,
	  ADD_TAG_FAILURE: null,
	  REMOVE_TAG_REQUEST: null,
	  REMOVE_TAG_SUCCESS: null,
	  REMOVE_TAG_FAILURE: null
	});

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(16);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(14);
	
	var _redux = __webpack_require__(18);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _WorkflowActions = __webpack_require__(123);
	
	var _WorkflowActions2 = _interopRequireDefault(_WorkflowActions);
	
	var _WorkflowConstants = __webpack_require__(74);
	
	var _ItemTransactionWorkflowContainer = __webpack_require__(2078);
	
	var _ItemTransactionWorkflowContainer2 = _interopRequireDefault(_ItemTransactionWorkflowContainer);
	
	var _AddedToShelfWorkflowContainer = __webpack_require__(2058);
	
	var _AddedToShelfWorkflowContainer2 = _interopRequireDefault(_AddedToShelfWorkflowContainer);
	
	var _SaveSearchContainer = __webpack_require__(2085);
	
	var _SaveSearchContainer2 = _interopRequireDefault(_SaveSearchContainer);
	
	var _BatchAddedToShelfWorkflow = __webpack_require__(1800);
	
	var _BatchAddedToShelfWorkflow2 = _interopRequireDefault(_BatchAddedToShelfWorkflow);
	
	var _BatchCancelHoldWorkflowContainer = __webpack_require__(2062);
	
	var _BatchCancelHoldWorkflowContainer2 = _interopRequireDefault(_BatchCancelHoldWorkflowContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function WorkflowContainer(props) {
	  var _this = this;
	
	  var currentWorkflowName = props.workflow && props.workflow.get('name');
	  var boundWorkflowActions = _lodash2.default.mapValues(props.actions, function (action) {
	    return action.bind(_this, props.id);
	  });
	  var workflowComponent = null;
	  var closeWorkflow = function closeWorkflow() {
	    return boundWorkflowActions.updateWorkflow(null);
	  };
	  switch (currentWorkflowName) {
	    case _WorkflowConstants.ITEM_TRANSACTION_WORKFLOW:
	      workflowComponent = _react2.default.createElement(_ItemTransactionWorkflowContainer2.default, {
	        workflowId: props.id,
	        metadataId: props.workflow.getIn(['view', 'metadataId']),
	        messagingId: props.workflow.getIn(['view', 'messagingId']),
	        holdsId: props.workflow.getIn(['view', 'holdsId']),
	        closeWorkflow: closeWorkflow,
	        view: props.workflow.getIn(['view', 'step']) });
	      break;
	    case _WorkflowConstants.ADDED_TO_SHELF_WORKFLOW:
	      workflowComponent = _react2.default.createElement(_AddedToShelfWorkflowContainer2.default, { id: props.id, metadataId: props.workflow.get('metadataId'), closeWorkflow: closeWorkflow, view: props.workflow.get('view') });
	      break;
	    case _WorkflowConstants.SAVED_SEARCH_WORKFLOW:
	      workflowComponent = _react2.default.createElement(_SaveSearchContainer2.default, { closeWorkflow: closeWorkflow });
	      break;
	    case _WorkflowConstants.BATCH_ADDED_TO_SHELF_WORKFLOW:
	      workflowComponent = _react2.default.createElement(_BatchAddedToShelfWorkflow2.default, {
	        workflowId: props.id,
	        closeWorkflow: closeWorkflow,
	        shelfName: props.workflow.getIn(['view', 'shelfName']) });
	      break;
	    case _WorkflowConstants.BATCH_CANCEL_HOLD_WORKFLOW:
	      workflowComponent = _react2.default.createElement(_BatchCancelHoldWorkflowContainer2.default, {
	        workflowId: props.id,
	        closeWorkflow: closeWorkflow,
	        holdIds: props.workflow.get('view') });
	      break;
	    default:
	      workflowComponent = null;
	      break;
	  }
	
	  return props.children(workflowComponent, boundWorkflowActions);
	}
	
	WorkflowContainer.displayName = 'WorkflowContainer';
	WorkflowContainer.propTypes = {
	  id: _react.PropTypes.string,
	  workflow: _reactImmutableProptypes2.default.mapContains({
	    name: _react.PropTypes.string,
	    view: _react.PropTypes.any
	  }),
	  actions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  children: _react.PropTypes.func.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  var id = ownProps.id;
	  return {
	    workflow: state.getIn(['ui', 'workflow', id]),
	    id: id
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    actions: (0, _redux.bindActionCreators)(_WorkflowActions2.default, dispatch)
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(WorkflowContainer);

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = composeGlobalFailureMessaging;
	
	var _composeFailureMessaging = __webpack_require__(299);
	
	var _composeFailureMessaging2 = _interopRequireDefault(_composeFailureMessaging);
	
	var _MessagingConstants = __webpack_require__(73);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function composeGlobalFailureMessaging(error) {
	  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  return (0, _composeFailureMessaging2.default)(_MessagingConstants.GLOBAL_MESSAGING_ID, error, opts);
	}

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = composeGlobalSuccessMessaging;
	
	var _composeSuccessMessaging = __webpack_require__(190);
	
	var _composeSuccessMessaging2 = _interopRequireDefault(_composeSuccessMessaging);
	
	var _MessagingConstants = __webpack_require__(73);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function composeGlobalSuccessMessaging(messageId) {
	  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  return (0, _composeSuccessMessaging2.default)(_MessagingConstants.GLOBAL_MESSAGING_ID, messageId, opts);
	}

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getRatingsTransactions = exports.getCurrentUserRatings = exports.getRatingsByBibs = exports.getRatingsByUsers = exports.getRatings = undefined;
	
	var _reselect = __webpack_require__(34);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _UGCBaseSelector = __webpack_require__(128);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getTransactions = function getTransactions(state) {
	  return state.getIn(['ugc', 'ratingsTransactions'], _immutable2.default.Map());
	};
	
	var getRatings = exports.getRatings = (0, _UGCBaseSelector.getUGCByType)('ratings');
	var getRatingsByUsers = exports.getRatingsByUsers = (0, _UGCBaseSelector.getSingularUGCByUsers)('ratings');
	var getRatingsByBibs = exports.getRatingsByBibs = (0, _UGCBaseSelector.getUGCByBibs)('ratings');
	var getCurrentUserRatings = exports.getCurrentUserRatings = (0, _UGCBaseSelector.getSingularUGCForCurrentUser)('ratings');
	var getRatingsTransactions = exports.getRatingsTransactions = (0, _reselect.createSelector)([getTransactions], function (transactions) {
	  return transactions;
	});
	
	exports.default = {
	  getRatings: getRatings,
	  getRatingsByUsers: getRatingsByUsers,
	  getRatingsByBibs: getRatingsByBibs,
	  getCurrentUserRatings: getCurrentUserRatings,
	  getRatingsTransactions: getRatingsTransactions
	};

/***/ },
/* 247 */
[3486, 195],
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var keys = __webpack_require__(844);
	var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
	
	var toStr = Object.prototype.toString;
	var concat = Array.prototype.concat;
	var origDefineProperty = Object.defineProperty;
	
	var isFunction = function (fn) {
		return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
	};
	
	var arePropertyDescriptorsSupported = function () {
		var obj = {};
		try {
			origDefineProperty(obj, 'x', { enumerable: false, value: obj });
			// eslint-disable-next-line no-unused-vars, no-restricted-syntax
			for (var _ in obj) { // jscs:ignore disallowUnusedVariables
				return false;
			}
			return obj.x === obj;
		} catch (e) { /* this is IE 8. */
			return false;
		}
	};
	var supportsDescriptors = origDefineProperty && arePropertyDescriptorsSupported();
	
	var defineProperty = function (object, name, value, predicate) {
		if (name in object && (!isFunction(predicate) || !predicate())) {
			return;
		}
		if (supportsDescriptors) {
			origDefineProperty(object, name, {
				configurable: true,
				enumerable: false,
				value: value,
				writable: true
			});
		} else {
			object[name] = value;
		}
	};
	
	var defineProperties = function (object, map) {
		var predicates = arguments.length > 2 ? arguments[2] : {};
		var props = keys(map);
		if (hasSymbols) {
			props = concat.call(props, Object.getOwnPropertySymbols(map));
		}
		for (var i = 0; i < props.length; i += 1) {
			defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
		}
	};
	
	defineProperties.supportsDescriptors = !!supportsDescriptors;
	
	module.exports = defineProperties;


/***/ },
/* 252 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(2779);
	
	module.exports = Function.prototype.bind || implementation;


/***/ },
/* 254 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(454),
	    baseAssignValue = __webpack_require__(722);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ },
/* 256 */,
/* 257 */
/***/ function(module, exports) {

	/**
	 * Special language-specific overrides.
	 *
	 * Source: ftp://ftp.unicode.org/Public/UCD/latest/ucd/SpecialCasing.txt
	 *
	 * @type {Object}
	 */
	var LANGUAGES = {
	  tr: {
	    regexp: /\u0130|\u0049|\u0049\u0307/g,
	    map: {
	      '\u0130': '\u0069',
	      '\u0049': '\u0131',
	      '\u0049\u0307': '\u0069'
	    }
	  },
	  az: {
	    regexp: /[\u0130]/g,
	    map: {
	      '\u0130': '\u0069',
	      '\u0049': '\u0131',
	      '\u0049\u0307': '\u0069'
	    }
	  },
	  lt: {
	    regexp: /[\u0049\u004A\u012E\u00CC\u00CD\u0128]/g,
	    map: {
	      '\u0049': '\u0069\u0307',
	      '\u004A': '\u006A\u0307',
	      '\u012E': '\u012F\u0307',
	      '\u00CC': '\u0069\u0307\u0300',
	      '\u00CD': '\u0069\u0307\u0301',
	      '\u0128': '\u0069\u0307\u0303'
	    }
	  }
	}
	
	/**
	 * Lowercase a string.
	 *
	 * @param  {String} str
	 * @return {String}
	 */
	module.exports = function (str, locale) {
	  var lang = LANGUAGES[locale]
	
	  str = str == null ? '' : String(str)
	
	  if (lang) {
	    str = str.replace(lang.regexp, function (m) { return lang.map[m] })
	  }
	
	  return str.toLowerCase()
	}


/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(3113);

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var CloseButton = function () {
	  function CloseButton(props) {
	    return _react2['default'].createElement(
	      'svg',
	      props,
	      _react2['default'].createElement('path', {
	        fillRule: 'evenodd',
	        d: 'M11.53.47a.75.75 0 0 0-1.061 0l-4.47 4.47L1.529.47A.75.75 0 1 0 .468 1.531l4.47 4.47-4.47 4.47a.75.75 0 1 0 1.061 1.061l4.47-4.47 4.47 4.47a.75.75 0 1 0 1.061-1.061l-4.47-4.47 4.47-4.47a.75.75 0 0 0 0-1.061z'
	      })
	    );
	  }
	
	  return CloseButton;
	}();
	
	CloseButton.defaultProps = {
	  viewBox: '0 0 12 12'
	};
	exports['default'] = CloseButton;

/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(27);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _constants = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _propTypes2['default'].oneOf([_constants.INFO_POSITION_TOP, _constants.INFO_POSITION_BOTTOM, _constants.INFO_POSITION_BEFORE, _constants.INFO_POSITION_AFTER]);

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(27);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _constants = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _propTypes2['default'].oneOf([_constants.ICON_BEFORE_POSITION, _constants.ICON_AFTER_POSITION]);

/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = isAfterDay;
	
	var _moment = __webpack_require__(9);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _isBeforeDay = __webpack_require__(263);
	
	var _isBeforeDay2 = _interopRequireDefault(_isBeforeDay);
	
	var _isSameDay = __webpack_require__(214);
	
	var _isSameDay2 = _interopRequireDefault(_isSameDay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function isAfterDay(a, b) {
	  if (!_moment2['default'].isMoment(a) || !_moment2['default'].isMoment(b)) return false;
	  return !(0, _isBeforeDay2['default'])(a, b) && !(0, _isSameDay2['default'])(a, b);
	}

/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = isBeforeDay;
	
	var _moment = __webpack_require__(9);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function isBeforeDay(a, b) {
	  if (!_moment2['default'].isMoment(a) || !_moment2['default'].isMoment(b)) return false;
	
	  var aYear = a.year();
	  var aMonth = a.month();
	
	  var bYear = b.year();
	  var bMonth = b.month();
	
	  var isSameYear = aYear === bYear;
	  var isSameMonth = aMonth === bMonth;
	
	  if (isSameYear && isSameMonth) return a.date() < b.date();
	  if (isSameYear) return aMonth < bMonth;
	  return aYear < bYear;
	}

/***/ },
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AcessibleDatePicker = __webpack_require__(1009);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AcessibleDatePicker).default;
	  }
	});
	Object.defineProperty(exports, 'AcessibleDatePicker', {
	  enumerable: true,
	  get: function get() {
	    return _AcessibleDatePicker.AcessibleDatePicker;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ClearableTextField = __webpack_require__(1058);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ClearableTextField).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.policyShape = exports.materialPolicyShape = exports.availabilityShape = undefined;
	
	var _react = __webpack_require__(1);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _bibBriefShape = __webpack_require__(526);
	
	var _bibBriefShape2 = _interopRequireDefault(_bibBriefShape);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var availabilityShape = exports.availabilityShape = _reactImmutableProptypes2.default.mapContains({
	  availabilityLocationType: _react.PropTypes.string,
	  availableCopies: _react.PropTypes.number,
	  bibType: _react.PropTypes.string,
	  circulationType: _react.PropTypes.string,
	  eresourceDescription: _react.PropTypes.string,
	  eresourceUrl: _react.PropTypes.string,
	  heldCopies: _react.PropTypes.number,
	  libraryUseOnly: _react.PropTypes.bool,
	  localisedStatus: _react.PropTypes.string,
	  metadataId: _react.PropTypes.string,
	  singleBranch: _react.PropTypes.bool,
	  status: _react.PropTypes.string,
	  totalCopies: _react.PropTypes.number
	});
	
	var materialPolicyShape = exports.materialPolicyShape = _reactImmutableProptypes2.default.mapContains({
	  externalAPI: _react.PropTypes.bool,
	  healthy: _react.PropTypes.bool,
	  helpUrl: _react.PropTypes.string,
	  itemLevelHoldsPredetermined: _react.PropTypes.bool,
	  quickStartUrl: _react.PropTypes.string,
	  requiresDuration: _react.PropTypes.bool,
	  requiresEmailDuringHold: _react.PropTypes.bool,
	  requiresFormatDuringCheckout: _react.PropTypes.bool,
	  requiresFormatDuringHold: _react.PropTypes.bool,
	  showFormatDuringCheckout: _react.PropTypes.bool,
	  showFormatDuringHold: _react.PropTypes.bool,
	  showQuickstartLink: _react.PropTypes.bool,
	  supportAutoCheckout: _react.PropTypes.bool,
	  supportsBatchVolumeHolds: _react.PropTypes.bool,
	  supportsDownload: _react.PropTypes.bool,
	  supportsFastAvailability: _react.PropTypes.bool,
	  supportsReadNow: _react.PropTypes.bool,
	  supportsSuspendHold: _react.PropTypes.bool
	});
	
	var policyShape = exports.policyShape = _reactImmutableProptypes2.default.mapContains({
	  holdable: _react.PropTypes.bool,
	  itemLevelHoldableItems: _react.PropTypes.bool,
	  materialPolicy: materialPolicyShape,
	  materialType: _react.PropTypes.string,
	  provider: _react.PropTypes.string
	});
	
	exports.default = _reactImmutableProptypes2.default.mapContains({
	  availability: availabilityShape,
	  briefInfo: _bibBriefShape2.default,
	  id: _react.PropTypes.string,
	  policy: policyShape
	});

/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ExpandButton = __webpack_require__(1407);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ExpandButton).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PrivacyToggle = __webpack_require__(1535);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PrivacyToggle).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SimpleUGCPermalink = __webpack_require__(1538);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SimpleUGCPermalink).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _contentAdvisoryTypePicker = __webpack_require__(551);
	
	Object.defineProperty(exports, 'ContentAdvisoryTypePicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_contentAdvisoryTypePicker).default;
	  }
	});
	
	var _inlineCommentEditor = __webpack_require__(1515);
	
	Object.defineProperty(exports, 'InlineCommentEditor', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_inlineCommentEditor).default;
	  }
	});
	
	var _inlineContentAdvisoryEditor = __webpack_require__(1517);
	
	Object.defineProperty(exports, 'InlineContentAdvisoryEditor', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_inlineContentAdvisoryEditor).default;
	  }
	});
	
	var _inlineQuotationEditor = __webpack_require__(1519);
	
	Object.defineProperty(exports, 'InlineQuotationEditor', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_inlineQuotationEditor).default;
	  }
	});
	
	var _inlineSummaryEditor = __webpack_require__(1521);
	
	Object.defineProperty(exports, 'InlineSummaryEditor', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_inlineSummaryEditor).default;
	  }
	});
	
	var _inlineVideoEditor = __webpack_require__(1523);
	
	Object.defineProperty(exports, 'InlineVideoEditor', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_inlineVideoEditor).default;
	  }
	});
	
	var _loginLink = __webpack_require__(178);
	
	Object.defineProperty(exports, 'LoginLink', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_loginLink).default;
	  }
	});
	
	var _primaryCommentEditor = __webpack_require__(1526);
	
	Object.defineProperty(exports, 'PrimaryCommentEditor', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_primaryCommentEditor).default;
	  }
	});
	
	var _primaryContentAdvisoryEditor = __webpack_require__(1528);
	
	Object.defineProperty(exports, 'PrimaryContentAdvisoryEditor', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_primaryContentAdvisoryEditor).default;
	  }
	});
	
	var _primaryQuotationEditor = __webpack_require__(1530);
	
	Object.defineProperty(exports, 'PrimaryQuotationEditor', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_primaryQuotationEditor).default;
	  }
	});
	
	var _primarySummaryEditor = __webpack_require__(1532);
	
	Object.defineProperty(exports, 'PrimarySummaryEditor', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_primarySummaryEditor).default;
	  }
	});
	
	var _primaryVideoEditor = __webpack_require__(1534);
	
	Object.defineProperty(exports, 'PrimaryVideoEditor', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_primaryVideoEditor).default;
	  }
	});
	
	var _privacyToggle = __webpack_require__(276);
	
	Object.defineProperty(exports, 'PrivacyToggle', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_privacyToggle).default;
	  }
	});
	
	var _simpleUgcDisplay = __webpack_require__(229);
	
	Object.defineProperty(exports, 'SimpleUGCDisplay', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_simpleUgcDisplay).default;
	  }
	});
	
	var _simpleUgcForm = __webpack_require__(106);
	
	Object.defineProperty(exports, 'SimpleUGCForm', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_simpleUgcForm).default;
	  }
	});
	
	var _simpleUgcPermalink = __webpack_require__(277);
	
	Object.defineProperty(exports, 'SimpleUGCPermalink', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_simpleUgcPermalink).default;
	  }
	});
	
	var _videoEmbedCodeField = __webpack_require__(552);
	
	Object.defineProperty(exports, 'VideoEmbedCodeField', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_videoEmbedCodeField).default;
	  }
	});
	
	var _videoForm = __webpack_require__(370);
	
	Object.defineProperty(exports, 'VideoForm', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_videoForm).default;
	  }
	});
	
	var _videoPreview = __webpack_require__(371);
	
	Object.defineProperty(exports, 'VideoPreview', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_videoPreview).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.digitalCheckout = digitalCheckout;
	exports.fetchDigitalFormats = fetchDigitalFormats;
	exports.digitalCheckIn = digitalCheckIn;
	exports.fetchCheckouts = fetchCheckouts;
	exports.startDigitalMissingFormatSelection = startDigitalMissingFormatSelection;
	exports.startDigitalCheckout = startDigitalCheckout;
	exports.lockInFormat = lockInFormat;
	exports.showMore = showMore;
	exports.renew = renew;
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _CheckoutApi = __webpack_require__(1602);
	
	var _CheckoutApi2 = _interopRequireDefault(_CheckoutApi);
	
	var _CheckoutConstants = __webpack_require__(295);
	
	var _CheckoutConstants2 = _interopRequireDefault(_CheckoutConstants);
	
	var _HoldsConstants = __webpack_require__(98);
	
	var _WorkflowConstants = __webpack_require__(74);
	
	var _WorkflowActions = __webpack_require__(123);
	
	var _WorkflowActions2 = _interopRequireDefault(_WorkflowActions);
	
	var _composeSuccessMessaging = __webpack_require__(190);
	
	var _composeSuccessMessaging2 = _interopRequireDefault(_composeSuccessMessaging);
	
	var _composeGlobalSuccessMessaging = __webpack_require__(245);
	
	var _composeGlobalSuccessMessaging2 = _interopRequireDefault(_composeGlobalSuccessMessaging);
	
	var _composeMessagingForBatchAction = __webpack_require__(641);
	
	var _composeMessagingForBatchAction2 = _interopRequireDefault(_composeMessagingForBatchAction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function digitalCheckout(_ref) {
	  var accountId = _ref.accountId,
	      metadataId = _ref.metadataId,
	      messagingId = _ref.messagingId,
	      workflowId = _ref.workflowId,
	      title = _ref.title,
	      _ref$format = _ref.format,
	      format = _ref$format === undefined ? null : _ref$format,
	      _ref$duration = _ref.duration,
	      duration = _ref$duration === undefined ? null : _ref$duration,
	      holdId = _ref.holdId,
	      postSuccess = _ref.postSuccess;
	
	  return {
	    workflowId: workflowId || metadataId,
	    postSuccess: postSuccess,
	    messagingId: messagingId,
	    payload: {
	      id: metadataId
	    },
	    types: [_CheckoutConstants2.default.DIGITAL_CHECKOUT_REQUEST, _CheckoutConstants2.default.DIGITAL_CHECKOUT_SUCCESS, _CheckoutConstants2.default.DIGITAL_CHECKOUT_FAILURE],
	    middlewareData: {
	      accountRequired: true
	    },
	    apiRequest: function apiRequest(state, client) {
	      return _CheckoutApi2.default.digitalCheckout({ metadataId: metadataId, accountId: accountId, format: format && format.get('name'), duration: duration }, client);
	    },
	    apiSuccess: function apiSuccess() {
	      return {
	        deletedEntities: holdId && ['holds.' + holdId],
	        messaging: messagingId ? (0, _composeSuccessMessaging2.default)(messagingId, 'message_digital_item_checkout', { values: { title: title } }) : (0, _composeGlobalSuccessMessaging2.default)('message_digital_item_checkout', { values: { title: title } })
	      };
	    }
	  };
	}
	
	function fetchDigitalFormats(metadataId) {
	  return {
	    payload: {
	      id: metadataId
	    },
	    types: [_CheckoutConstants2.default.DIGITAL_FORMATS_REQUEST, _CheckoutConstants2.default.DIGITAL_FORMATS_SUCCESS, _CheckoutConstants2.default.DIGITAL_FORMATS_FAILURE],
	    apiRequest: function apiRequest(state, client) {
	      return _CheckoutApi2.default.fetchDigitalFormats({ libraryId: state.getIn(['library', 'id']), metadataId: metadataId }, client);
	    }
	  };
	}
	
	function digitalCheckIn(_ref2) {
	  var accountId = _ref2.accountId,
	      metadataId = _ref2.metadataId,
	      messagingId = _ref2.messagingId,
	      checkoutId = _ref2.checkoutId;
	
	  return {
	    checkoutId: checkoutId,
	    messagingId: messagingId,
	    payload: {
	      id: metadataId
	    },
	    types: [_CheckoutConstants2.default.DIGITAL_CHECK_IN_REQUEST, _CheckoutConstants2.default.DIGITAL_CHECK_IN_SUCCESS, _CheckoutConstants2.default.DIGITAL_CHECK_IN_FAILURE],
	    middlewareData: {
	      accountRequired: true
	    },
	    apiRequest: function apiRequest(state, client) {
	      return _CheckoutApi2.default.checkInDigitalBib({ metadataId: metadataId, accountId: accountId, checkoutId: checkoutId }, client);
	    },
	    apiSuccess: function apiSuccess() {
	      return {
	        deletedEntities: ['checkouts.' + checkoutId],
	        messaging: messagingId ? (0, _composeSuccessMessaging2.default)(messagingId, 'message_digital_early_return_successful') : (0, _composeGlobalSuccessMessaging2.default)('message_digital_early_return_successful')
	      };
	    }
	  };
	}
	
	function fetchCheckouts(_ref3) {
	  var accountId = _ref3.accountId,
	      _ref3$size = _ref3.size,
	      size = _ref3$size === undefined ? 25 : _ref3$size,
	      status = _ref3.status,
	      _ref3$page = _ref3.page,
	      page = _ref3$page === undefined ? 1 : _ref3$page,
	      _ref3$sort = _ref3.sort,
	      sort = _ref3$sort === undefined ? 'status' : _ref3$sort,
	      materialType = _ref3.materialType;
	
	  return {
	    types: [_CheckoutConstants2.default.FETCH_CHECKOUTS_REQUEST, _CheckoutConstants2.default.FETCH_CHECKOUTS_SUCCESS, _CheckoutConstants2.default.FETCH_CHECKOUTS_FAILURE],
	    middlewareData: {
	      accountRequired: true
	    },
	    apiRequest: function apiRequest(state, apiClient) {
	      return _CheckoutApi2.default.getCheckouts({
	        accountId: accountId,
	        size: size,
	        status: status && status.toUpperCase(),
	        page: page,
	        sort: sort,
	        materialType: materialType
	      }, apiClient);
	    }
	  };
	}
	
	function startDigitalMissingFormatSelection(workflowId, metadataId, messagingId) {
	  return _WorkflowActions2.default.updateWorkflow(workflowId, _WorkflowConstants.ITEM_TRANSACTION_WORKFLOW, _immutable2.default.Map({
	    metadataId: metadataId,
	    messagingId: messagingId,
	    step: _HoldsConstants.WORKFLOW_VIEWS.DIGITAL_MISSING_FORMAT
	  }), true, true);
	}
	
	function startDigitalCheckout(workflowId, metadataId, messagingId) {
	  return _WorkflowActions2.default.updateWorkflow(workflowId, _WorkflowConstants.ITEM_TRANSACTION_WORKFLOW, _immutable2.default.Map({
	    metadataId: metadataId,
	    messagingId: messagingId,
	    step: _HoldsConstants.WORKFLOW_VIEWS.DIGITAL_CHECKOUT
	  }), true, true);
	}
	
	function lockInFormat(_ref4) {
	  var accountId = _ref4.accountId,
	      checkoutId = _ref4.checkoutId,
	      format = _ref4.format,
	      messagingId = _ref4.messagingId,
	      metadataId = _ref4.metadataId,
	      workflowId = _ref4.workflowId;
	
	  return {
	    workflowId: workflowId,
	    messagingId: messagingId,
	    payload: {
	      id: metadataId
	    },
	    types: [_CheckoutConstants2.default.DIGITAL_FORMAT_LOCK_REQUEST, _CheckoutConstants2.default.DIGITAL_FORMAT_LOCK_SUCCESS, _CheckoutConstants2.default.DIGITAL_FORMAT_LOCK_FAILURE],
	    middlewareData: {
	      accountRequired: true
	    },
	    apiRequest: function apiRequest(state, client) {
	      return _CheckoutApi2.default.lockInDigitalFormat({ metadataId: metadataId, accountId: accountId, checkoutId: checkoutId, format: format }, client);
	    },
	    apiSuccess: function apiSuccess(response) {
	      var _ref5 = response || {},
	          entities = _ref5.entities;
	
	      var _ref6 = entities || {},
	          checkouts = _ref6.checkouts;
	
	      var checkout = checkouts[checkoutId] || {};
	      var values = { download_url: checkout.downloadUrl };
	
	      return {
	        messaging: messagingId ? (0, _composeSuccessMessaging2.default)(messagingId, 'message_digital_item_download_after_format', { values: values }) : (0, _composeGlobalSuccessMessaging2.default)('message_digital_item_download_after_format', { values: values })
	      };
	    }
	  };
	}
	
	function showMore() {
	  return {
	    type: _CheckoutConstants2.default.SHOW_MORE
	  };
	}
	
	var getRenewMessaging = function getRenewMessaging(_ref7) {
	  var checkoutIds = _ref7.checkoutIds,
	      response = _ref7.response,
	      moreDetails = _ref7.moreDetails;
	  var failures = response.failures;
	
	  return (0, _composeMessagingForBatchAction2.default)({
	    total: checkoutIds.length,
	    failures: failures,
	    successId: 'message_successful_renew',
	    mixedId: 'message_mixed_renew',
	    failureId: 'message_failure_renew',
	    values: { moreDetails: moreDetails },
	    useFormattedMessage: true
	  });
	};
	
	function renew(_ref8) {
	  var accountId = _ref8.accountId,
	      checkoutIds = _ref8.checkoutIds,
	      moreDetails = _ref8.moreDetails;
	
	  return {
	    types: [_CheckoutConstants2.default.RENEW_REQUEST, _CheckoutConstants2.default.RENEW_SUCCESS, _CheckoutConstants2.default.RENEW_FAILURE],
	    checkoutIds: checkoutIds,
	    apiRequest: function apiRequest(state, client) {
	      return _CheckoutApi2.default.renewCheckouts({
	        accountId: accountId,
	        checkoutIds: checkoutIds
	      }, client);
	    },
	    apiSuccess: function apiSuccess(response) {
	      return {
	        messaging: getRenewMessaging({ checkoutIds: checkoutIds, response: response, moreDetails: moreDetails })
	      };
	    }
	  };
	}

/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _RatingsApi = __webpack_require__(1615);
	
	var _RatingsApi2 = _interopRequireDefault(_RatingsApi);
	
	var _RatingsConstants = __webpack_require__(628);
	
	var _RatingsConstants2 = _interopRequireDefault(_RatingsConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Gets the item rating for ONE bib
	 * @param {String}  metadataId Bib to retrieve rating for
	 */
	function getItemRatings(metadataIds) {
	  return {
	    metadataIds: metadataIds,
	    types: [_RatingsConstants2.default.GET_ITEM_RATING_REQUEST, _RatingsConstants2.default.GET_ITEM_RATING_SUCCESS, _RatingsConstants2.default.GET_ITEM_RATING_FAILURE],
	    middlewareData: {
	      authRequired: true
	    },
	    apiRequest: function apiRequest(state, client) {
	      return _RatingsApi2.default.getItemRatings({
	        metadataIds: metadataIds,
	        userId: state.getIn(['auth', 'currentUserId'])
	      }, client);
	    }
	  };
	}
	
	/**
	 * Rates ONE bib
	 * @param {String}  metadataId Bib to rate
	 * @param {Integer} rating Rating value, from 0 to 100
	 */
	function rateItem(metadataId, rating) {
	  return {
	    metadataIds: [metadataId],
	    types: [_RatingsConstants2.default.RATE_ITEM_REQUEST, _RatingsConstants2.default.RATE_ITEM_SUCCESS, _RatingsConstants2.default.RATE_ITEM_FAILURE],
	    middlewareData: {
	      authRequired: true
	    },
	    apiRequest: function apiRequest(state, client) {
	      return _RatingsApi2.default.rateItem({
	        metadataId: metadataId,
	        rating: rating,
	        userId: state.getIn(['auth', 'currentUserId'])
	      }, client);
	    }
	  };
	}
	
	/**
	 * Changes the rating of ONE bib
	 * @param {String}  metadataId Bib to rate
	 * @param {Integer} rating Rating value, from 0 to 100
	 */
	function changeItemRating(metadataId, rating) {
	  return {
	    metadataIds: [metadataId],
	    types: [_RatingsConstants2.default.CHANGE_ITEM_RATING_REQUEST, _RatingsConstants2.default.CHANGE_ITEM_RATING_SUCCESS, _RatingsConstants2.default.CHANGE_ITEM_RATING_FAILURE],
	    middlewareData: {
	      authRequired: true
	    },
	    apiRequest: function apiRequest(state, client) {
	      return _RatingsApi2.default.changeItemRating({
	        metadataId: metadataId,
	        rating: rating,
	        userId: state.getIn(['auth', 'currentUserId'])
	      }, client);
	    }
	  };
	}
	
	/**
	 * Removes the rating for ONE bib
	 * @param {String}  metadataId Bib with rating to remove
	 */
	function removeItemRating(metadataId, ratingId) {
	  return {
	    metadataIds: [metadataId],
	    types: [_RatingsConstants2.default.REMOVE_ITEM_RATING_REQUEST, _RatingsConstants2.default.REMOVE_ITEM_RATING_SUCCESS, _RatingsConstants2.default.REMOVE_ITEM_RATING_FAILURE],
	    middlewareData: {
	      authRequired: true
	    },
	    apiRequest: function apiRequest(state, client) {
	      return _RatingsApi2.default.removeItemRating({
	        metadataId: metadataId,
	        userId: state.getIn(['auth', 'currentUserId'])
	      }, client);
	    },
	    apiSuccess: function apiSuccess() {
	      return {
	        deletedEntities: ['ugc.ratings.' + ratingId]
	      };
	    }
	  };
	}
	
	exports.default = {
	  getItemRatings: getItemRatings,
	  rateItem: rateItem,
	  changeItemRating: changeItemRating,
	  removeItemRating: removeItemRating
	};

/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CheckedOutStatusIcon = __webpack_require__(1665);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CheckedOutStatusIcon).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _HoldStatusIcon = __webpack_require__(1715);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_HoldStatusIcon).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _RecentlyReturnedTitle = __webpack_require__(1795);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RecentlyReturnedTitle).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BorrowingBibBrief = __webpack_require__(1802);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BorrowingBibBrief).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BorrowingUtilityBar = __webpack_require__(1817);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BorrowingUtilityBar).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DollarAmount = __webpack_require__(1819);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DollarAmount).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _has = __webpack_require__(2932);
	
	var _has2 = _interopRequireDefault(_has);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	var _utilsBrowser = __webpack_require__(59);
	
	var _baseIcons = __webpack_require__(10);
	
	__webpack_require__(2547);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getLocalizationKey(searchType) {
	  switch (searchType) {
	    case 'title':
	      return 'external_search_link_title';
	    case 'author':
	      return 'external_search_link_author';
	    case 'subject':
	      return 'external_search_link_subject';
	    case 'keyword':
	    case 'catalogue':
	    case 'smart':
	      return 'external_search_link_keyword';
	    default:
	      return '';
	  }
	}
	
	function screenReaderMessage(linkText) {
	  return _react2.default.createElement(
	    _baseScreenReaderMessage2.default,
	    null,
	    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ada_opens_a_new_tab', values: { linkText: linkText } })
	  );
	}
	
	function getfindOutMoreAdditionalLink(intl) {
	  return (0, _has2.default)(intl.messages, 'find_out_more_additional_link') ? intl.formatMessage({ id: 'find_out_more_additional_link' }) : null;
	}
	
	function getExternalSearchUrl(intl, query, backlink, searchType) {
	  return (0, _has2.default)(intl.messages, getLocalizationKey(searchType)) ? intl.formatHTMLMessage({
	    defaultMessage: '',
	    id: getLocalizationKey(searchType)
	  }, {
	    q: (0, _utilsBrowser.fixedEncodeURIComponent)(query),
	    backlink: backlink
	  }) : null;
	}
	
	function formattedExternalSearch(intl, url, linkText) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'cp-external-search-link' },
	    _react2.default.createElement(
	      'div',
	      { className: 'external-search-name' },
	      linkText
	    ),
	    _react2.default.createElement(
	      'a',
	      {
	        href: url,
	        className: 'external-search-link',
	        target: '_blank',
	        rel: 'noopener noreferrer' },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'search_link_text' }),
	      screenReaderMessage(linkText),
	      _react2.default.createElement(_baseIcons.Angle.Right, null)
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'additional-link' },
	      getfindOutMoreAdditionalLink(intl) && _react2.default.createElement(
	        'a',
	        {
	          href: getfindOutMoreAdditionalLink(intl),
	          className: 'find_out_more_additional_link',
	          target: '_blank',
	          rel: 'noopener noreferrer' },
	        _react2.default.createElement(
	          'span',
	          { 'aria-hidden': true },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'find_out_more_link' })
	        ),
	        screenReaderMessage(_react2.default.createElement(_reactIntl.FormattedMessage, { id: 'find_out_more_link' }))
	      )
	    )
	  );
	}
	
	function externalSearchLinkOnly(url, linkText) {
	  return _react2.default.createElement(
	    'a',
	    {
	      href: url,
	      className: 'cp-external-search-link',
	      target: '_blank',
	      rel: 'noopener noreferrer' },
	    _react2.default.createElement(
	      'span',
	      { 'aria-hidden': true },
	      linkText
	    ),
	    screenReaderMessage(linkText),
	    _react2.default.createElement(_baseIcons.Angle.Right, null)
	  );
	}
	
	function ExternalSearchLink(_ref) {
	  var intl = _ref.intl,
	      query = _ref.query,
	      searchType = _ref.searchType,
	      formatted = _ref.formatted;
	
	  var url = getExternalSearchUrl(intl, query,  true ? window.location.href : '', searchType);
	
	  var linkText = _react2.default.createElement(
	    'span',
	    null,
	    _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'external_search_link_line1', defaultMessage: '' }),
	    '\xA0',
	    intl.messages.external_search_link_line2 ? _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'external_search_link_line2', defaultMessage: '' }) : null,
	    '\xA0'
	  );
	
	  if (!url) {
	    return null;
	  }
	
	  return formatted ? formattedExternalSearch(intl, url, linkText) : externalSearchLinkOnly(url, linkText);
	}
	
	ExternalSearchLink.defaultProps = {
	  formatted: false
	};
	
	ExternalSearchLink.propTypes = {
	  query: _react.PropTypes.string.isRequired,
	  searchType: _react.PropTypes.string.isRequired,
	  formatted: _react.PropTypes.bool,
	  intl: _reactIntl.intlShape
	};
	
	ExternalSearchLink.displayName = 'ExternalSearchLink';
	
	exports.default = (0, _reactIntl.injectIntl)(ExternalSearchLink);

/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BatchActionsListItem = __webpack_require__(1909);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BatchActionsListItem).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ItemFormat = __webpack_require__(1944);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ItemFormat).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DigitalFormats = __webpack_require__(1957);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DigitalFormats).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cancelHoldShelfPrompt = __webpack_require__(595);
	
	Object.defineProperty(exports, 'CancelHoldShelfPrompt', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_cancelHoldShelfPrompt).default;
	  }
	});
	
	var _cancelHoldWorkflowView = __webpack_require__(1949);
	
	Object.defineProperty(exports, 'SingleCancelHoldWorkflowView', {
	  enumerable: true,
	  get: function get() {
	    return _cancelHoldWorkflowView.SingleCancelHoldWorkflowView;
	  }
	});
	Object.defineProperty(exports, 'BatchCancelHoldWorkflowView', {
	  enumerable: true,
	  get: function get() {
	    return _cancelHoldWorkflowView.BatchCancelHoldWorkflowView;
	  }
	});
	
	var _checkedOutReadingLinks = __webpack_require__(1951);
	
	Object.defineProperty(exports, 'CheckedOutReadingLinks', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_checkedOutReadingLinks).default;
	  }
	});
	
	var _digitalCheckoutWorkflowView = __webpack_require__(1955);
	
	Object.defineProperty(exports, 'DigitalCheckoutWorkflowView', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_digitalCheckoutWorkflowView).default;
	  }
	});
	
	var _digitalDurations = __webpack_require__(597);
	
	Object.defineProperty(exports, 'DigitalDurations', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_digitalDurations).default;
	  }
	});
	
	var _digitalFormats = __webpack_require__(290);
	
	Object.defineProperty(exports, 'DigitalFormats', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_digitalFormats).default;
	  }
	});
	
	var _digitalHoldsWorkflowView = __webpack_require__(1959);
	
	Object.defineProperty(exports, 'DigitalHoldsWorkflowView', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_digitalHoldsWorkflowView).default;
	  }
	});
	
	var _digitalMissingFormatWorkflowView = __webpack_require__(1961);
	
	Object.defineProperty(exports, 'DigitalMissingFormatWorkflowView', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_digitalMissingFormatWorkflowView).default;
	  }
	});
	
	var _digitalNotificationEmail = __webpack_require__(598);
	
	Object.defineProperty(exports, 'DigitalNotificationEmail', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_digitalNotificationEmail).default;
	  }
	});
	
	var _itemLevelHoldsWorkflowView = __webpack_require__(1964);
	
	Object.defineProperty(exports, 'ItemLevelHoldsWorkflowView', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_itemLevelHoldsWorkflowView).default;
	  }
	});
	
	var _physicalHoldsWorkflowView = __webpack_require__(1966);
	
	Object.defineProperty(exports, 'PhysicalHoldsWorkflowView', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_physicalHoldsWorkflowView).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BaseUGCEditor = __webpack_require__(1992);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BaseUGCEditor).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utilsRedux = __webpack_require__(20);
	
	exports.default = (0, _utilsRedux.createReduxConstants)('AUTH', {
	  AUTH_LOGIN_REQUEST: null,
	  AUTH_LOGIN_SUCCESS: null,
	  AUTH_LOGIN_ERROR: null,
	  AUTH_LOGOUT: null,
	  AUTH_LOAD_USER_REQUEST: null,
	  AUTH_LOAD_USER_SUCCESS: null,
	  AUTH_LOAD_USER_FAILURE: null,
	  OPEN_LOGIN_OVERLAY: null,
	  CLOSE_LOGIN_OVERLAY: null,
	  REQUIRES_LIBRARY_ACCOUNT: null
	});

/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utilsRedux = __webpack_require__(20);
	
	exports.default = (0, _utilsRedux.createReduxConstants)('BORROWING', {
	  FETCH_SUMMARIES_REQUEST: null,
	  FETCH_SUMMARIES_SUCCESS: null,
	  FETCH_SUMMARIES_FAILURE: null
	});

/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utilsRedux = __webpack_require__(20);
	
	exports.default = (0, _utilsRedux.createReduxConstants)('CHECKOUT', {
	  DIGITAL_CHECKOUT_REQUEST: null,
	  DIGITAL_CHECKOUT_SUCCESS: null,
	  DIGITAL_CHECKOUT_FAILURE: null,
	  DIGITAL_FORMATS_REQUEST: null,
	  DIGITAL_FORMATS_SUCCESS: null,
	  DIGITAL_FORMATS_FAILURE: null,
	  DIGITAL_CHECK_IN_REQUEST: null,
	  DIGITAL_CHECK_IN_SUCCESS: null,
	  DIGITAL_CHECK_IN_FAILURE: null,
	  DIGITAL_FORMAT_LOCK_REQUEST: null,
	  DIGITAL_FORMAT_LOCK_SUCCESS: null,
	  DIGITAL_FORMAT_LOCK_FAILURE: null,
	  FETCH_CHECKOUTS_REQUEST: null,
	  FETCH_CHECKOUTS_SUCCESS: null,
	  FETCH_CHECKOUTS_FAILURE: null,
	  RENEW_REQUEST: null,
	  RENEW_SUCCESS: null,
	  RENEW_FAILURE: null,
	  SHOW_MORE: null
	});

/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utilsRedux = __webpack_require__(20);
	
	exports.default = (0, _utilsRedux.createReduxConstants)('LIBRARY', {
	  LIBRARY_REQUEST: null,
	  LIBRARY_SUCCESS: null,
	  LIBRARY_FAILURE: null
	});

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ItemTransactionButtonContainer = ItemTransactionButtonContainer;
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(14);
	
	var _redux = __webpack_require__(18);
	
	var _cancelHoldButton = __webpack_require__(1396);
	
	var _cancelHoldButton2 = _interopRequireDefault(_cancelHoldButton);
	
	var _RequestItemButton = __webpack_require__(1973);
	
	var _RequestItemButton2 = _interopRequireDefault(_RequestItemButton);
	
	var _ItemTransactions = __webpack_require__(291);
	
	var _BibConstants = __webpack_require__(241);
	
	var _CheckoutActions = __webpack_require__(279);
	
	var CheckoutActions = _interopRequireWildcard(_CheckoutActions);
	
	var _HoldActions = __webpack_require__(143);
	
	var HoldActions = _interopRequireWildcard(_HoldActions);
	
	var _AuthSelector = __webpack_require__(21);
	
	var _HoldsSelector = __webpack_require__(127);
	
	var _CheckoutSelector = __webpack_require__(191);
	
	var _utilsItem = __webpack_require__(232);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ItemTransactionButtonContainer(props) {
	  var holdable = props.holdable,
	      hold = props.hold,
	      isLoading = props.isLoading,
	      id = props.id,
	      holdActions = props.holdActions,
	      checkoutActions = props.checkoutActions,
	      availableForCheckout = props.availableForCheckout,
	      checkout = props.checkout,
	      materialType = props.materialType,
	      materialPolicy = props.materialPolicy,
	      accountId = props.accountId,
	      format = props.format,
	      title = props.title,
	      authors = props.authors,
	      hasItemLevelHoldableItems = props.hasItemLevelHoldableItems,
	      titleNotOwned = props.titleNotOwned,
	      workflowId = props.workflowId,
	      messagingId = props.messagingId;
	
	
	  var element = void 0;
	  var isDigitalHoldReady = hold && hold.get('status') === 'READY_FOR_PICKUP' && materialType === _BibConstants.MATERIAL_TYPE_DIGITAL;
	
	  if (!holdable) {
	    return null;
	  }
	
	  var status = (0, _utilsItem.itemTransactionStatus)(hold, materialType, hasItemLevelHoldableItems, checkout);
	
	  switch (status) {
	    case _utilsItem.itemTransactionConstants.CANCEL_HOLD_BUTTON:
	      element = _react2.default.createElement(_cancelHoldButton2.default, { metadataId: id, cancelHold: function cancelHold() {
	          return holdActions.startCancelHold(workflowId || id, id, messagingId);
	        }, isLoading: isLoading });
	      break;
	    case _utilsItem.itemTransactionConstants.DIGITAL_READING_LINKS:
	      element = _react2.default.createElement(_ItemTransactions.CheckedOutReadingLinks, {
	        checkInEnabled: checkout.get('checkInEnabled'),
	        downloadable: checkout.get('downloadable'),
	        format: checkout.get('format'),
	        downloadUrl: checkout.get('downloadUrl'),
	        thirdPartyReaderUrl: checkout.get('thirdPartyReaderUrl'),
	        policy: materialPolicy,
	        metadataId: id,
	        messagingId: messagingId,
	        checkoutId: checkout.get('checkoutId'),
	        accountId: accountId,
	        checkIn: checkoutActions.digitalCheckIn,
	        startDigitalMissingFormatSelection: function startDigitalMissingFormatSelection() {
	          return checkoutActions.startDigitalMissingFormatSelection(workflowId || id, id, messagingId);
	        } });
	      break;
	    case _utilsItem.itemTransactionConstants.REQUEST_ITEM_BUTTON:
	    default:
	      element = _react2.default.createElement(_RequestItemButton2.default, {
	        metadataId: id,
	        handleHoldClick: function handleHoldClick() {
	          return holdActions.startPlaceHold(workflowId || id, id, messagingId);
	        },
	        isLoading: isLoading,
	        availableForCheckout: availableForCheckout || isDigitalHoldReady,
	        materialType: materialType,
	        handleCheckoutClick: function handleCheckoutClick() {
	          return checkoutActions.startDigitalCheckout(workflowId || id, id, messagingId);
	        },
	        format: format,
	        title: title,
	        treatAsItemLevelHold: hasItemLevelHoldableItems && materialPolicy.get('itemLevelHoldsPredetermined'),
	        authors: authors,
	        serviceAvailable: materialPolicy.get('healthy'),
	        titleNotOwned: titleNotOwned });
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'item-transaction-button-wrap' },
	    element
	  );
	}
	
	ItemTransactionButtonContainer.propTypes = {
	  hold: _reactImmutableProptypes2.default.mapContains({
	    id: _react.PropTypes.string,
	    status: _react.PropTypes.string
	  }),
	  workflowId: _react.PropTypes.string,
	  messagingId: _react.PropTypes.string,
	  holdable: _react.PropTypes.bool,
	  isLoading: _react.PropTypes.bool,
	  holdActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  checkoutActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  materialPolicy: _reactImmutableProptypes2.default.map,
	  materialType: _react.PropTypes.string,
	  checkout: _reactImmutableProptypes2.default.mapContains({
	    id: _react.PropTypes.string
	  }),
	  accountId: _react.PropTypes.number,
	  availableForCheckout: _react.PropTypes.bool,
	  id: _react.PropTypes.string.isRequired,
	  format: _react.PropTypes.string.isRequired,
	  title: _react.PropTypes.string.isRequired,
	  authors: _reactImmutableProptypes2.default.listOf(_react2.default.PropTypes.string),
	  hasItemLevelHoldableItems: _react.PropTypes.bool,
	  titleNotOwned: _react.PropTypes.bool
	};
	
	ItemTransactionButtonContainer.displayName = 'ItemTransactionButtonContainer';
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  var account = (0, _AuthSelector.currentAccountSelector)(state, ownProps);
	  var briefInfo = state.getIn(['entities', 'bibs', ownProps.id, 'briefInfo']);
	  var policy = state.getIn(['entities', 'bibs', ownProps.id, 'policy'], _immutable2.default.Map());
	  var holds = (0, _HoldsSelector.getActiveHoldsByMetadataId)(state).get(ownProps.id, _immutable2.default.List());
	  var availabilityStatus = state.getIn(['entities', 'bibs', ownProps.id, 'availability', 'status']);
	  var checkouts = (0, _CheckoutSelector.getCheckoutsByMetadataId)(state).get(ownProps.id, _immutable2.default.List());
	
	  return {
	    accountId: account && account.get('id'),
	    hold: holds.size === 1 ? holds.first() : null,
	    holdable: state.getIn(['entities', 'bibs', ownProps.id, 'policy', 'holdable'], false),
	    isLoading: state.getIn(['ui', 'itemTransactions', ownProps.id, 'isLoading'], false),
	    checkout: checkouts.first(),
	    availableForCheckout: availabilityStatus === 'AVAILABLE',
	    materialType: state.getIn(['entities', 'bibs', ownProps.id, 'policy', 'materialType']),
	    materialPolicy: policy.get('materialPolicy', _immutable2.default.Map()),
	    format: briefInfo.get('format'),
	    title: briefInfo.get('title'),
	    authors: briefInfo.get('authors'),
	    hasItemLevelHoldableItems: policy.get('itemLevelHoldableItems'),
	    titleNotOwned: availabilityStatus === 'RESOURCE_NOT_FOUND'
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    holdActions: (0, _redux.bindActionCreators)(HoldActions, dispatch),
	    checkoutActions: (0, _redux.bindActionCreators)(CheckoutActions, dispatch)
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ItemTransactionButtonContainer);

/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BatchActionsListContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(14);
	
	var _redux = __webpack_require__(18);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _MessagingActions = __webpack_require__(181);
	
	var _MessagingActions2 = _interopRequireDefault(_MessagingActions);
	
	var _MessagingSelector = __webpack_require__(399);
	
	var _BatchActionsList = __webpack_require__(1908);
	
	var _BatchActionsList2 = _interopRequireDefault(_BatchActionsList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BatchActionsListContainer = exports.BatchActionsListContainer = function (_BcReactComponent) {
	  _inherits(BatchActionsListContainer, _BcReactComponent);
	
	  function BatchActionsListContainer() {
	    _classCallCheck(this, BatchActionsListContainer);
	
	    return _possibleConstructorReturn(this, (BatchActionsListContainer.__proto__ || Object.getPrototypeOf(BatchActionsListContainer)).apply(this, arguments));
	  }
	
	  _createClass(BatchActionsListContainer, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _BatchActionsList2.default,
	        {
	          actionIsLoading: this.props.actionIsLoading,
	          list: this.props.list,
	          pageNumber: this.props.pageNumber,
	          pageLimit: this.props.pageLimit,
	          totalItems: this.props.totalItems,
	          globalMessaging: this.props.globalMessaging,
	          renderActionsMenu: this.props.renderActionsMenu,
	          messagingActions: this.props.messagingActions },
	        this.props.children
	      );
	    }
	  }]);
	
	  return BatchActionsListContainer;
	}(_baseBcReactComponent2.default);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    globalMessaging: (0, _MessagingSelector.getGlobalMessaging)(state)
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    messagingActions: (0, _redux.bindActionCreators)(_MessagingActions2.default, dispatch)
	  };
	};
	
	BatchActionsListContainer.propTypes = {
	  actionIsLoading: _react.PropTypes.bool,
	  list: _reactImmutableProptypes2.default.list.isRequired,
	  pageNumber: _react.PropTypes.number,
	  pageLimit: _react.PropTypes.number,
	  totalItems: _react.PropTypes.number.isRequired,
	  renderActionsMenu: _react.PropTypes.func.isRequired,
	  globalMessaging: _reactImmutableProptypes2.default.map,
	  children: _react.PropTypes.func.isRequired,
	  messagingActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(BatchActionsListContainer);

/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = composeFailureMessaging;
	
	var _composeMessaging = __webpack_require__(189);
	
	var _composeMessaging2 = _interopRequireDefault(_composeMessaging);
	
	var _MessagingConstants = __webpack_require__(73);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IGNORED_CLASSIFICATIONS = ['HoldIsItemLevel'];
	
	// Error types where it is acceptable to display the error message directly
	var MESSAGE_CLASSIFICATION_WHITELIST = ['ILSException', 'RenewFailed', 'DigitalBadRequestException'];
	
	var isIgnoredClassification = function isIgnoredClassification(classification) {
	  return IGNORED_CLASSIFICATIONS.indexOf(classification) !== -1;
	};
	
	var shouldUseMessage = function shouldUseMessage(classification) {
	  return MESSAGE_CLASSIFICATION_WHITELIST.indexOf(classification) !== -1;
	};
	
	function composeFailureMessaging(messagingId) {
	  var err = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var _err$message = err.message,
	      message = _err$message === undefined ? '' : _err$message,
	      _err$classification = err.classification,
	      classification = _err$classification === undefined ? '' : _err$classification;
	
	
	  if (isIgnoredClassification(classification)) {
	    return {};
	  }
	
	  var emptyILSMessage = classification === 'ILSException' && message.length === 0;
	  var messageId = emptyILSMessage ? 'errors.ServiceException' : 'errors.' + classification;
	  var defaultMessage = shouldUseMessage(classification) ? message : '';
	
	  return (0, _composeMessaging2.default)(_MessagingConstants.STATUS_TYPES.Failure, messagingId, messageId, _extends({ defaultMessage: defaultMessage }, opts));
	}

/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getBorrowingHistorySummary = exports.getSummary = undefined;
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reselect = __webpack_require__(34);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var summaryFromState = function summaryFromState(state, type) {
	  return state.getIn(['borrowing', 'borrowing', 'summaries', type], _immutable2.default.Map());
	};
	
	var borrowingHistorySummaryFromState = function borrowingHistorySummaryFromState(state) {
	  return state.getIn(['borrowing', 'borrowingHistory', 'summaries', 'totalElements'], -1);
	};
	
	var getSummary = exports.getSummary = (0, _reselect.createSelector)([summaryFromState], function (summary) {
	  return summary;
	});
	
	var getBorrowingHistorySummary = exports.getBorrowingHistorySummary = (0, _reselect.createSelector)([borrowingHistorySummaryFromState], function (summary) {
	  return summary;
	});
	
	exports.default = {
	  getSummary: getSummary,
	  getBorrowingHistorySummary: getBorrowingHistorySummary
	};

/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EVENT_HANDLERS_KEY = undefined;
	exports.addEventListener = addEventListener;
	exports.removeEventListener = removeEventListener;
	
	var _normalizeEventOptions = __webpack_require__(2198);
	
	var _normalizeEventOptions2 = _interopRequireDefault(_normalizeEventOptions);
	
	var _TargetEventHandlers = __webpack_require__(2194);
	
	var _TargetEventHandlers2 = _interopRequireDefault(_TargetEventHandlers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// Export to make testing possible.
	var EVENT_HANDLERS_KEY = exports.EVENT_HANDLERS_KEY = '__consolidated_events_handlers__';
	
	function addEventListener(target, eventName, listener, options) {
	  if (!target[EVENT_HANDLERS_KEY]) {
	    // eslint-disable-next-line no-param-reassign
	    target[EVENT_HANDLERS_KEY] = new _TargetEventHandlers2['default'](target);
	  }
	  var normalizedEventOptions = (0, _normalizeEventOptions2['default'])(options);
	  return target[EVENT_HANDLERS_KEY].add(eventName, listener, normalizedEventOptions);
	}
	
	// Deprecated
	function removeEventListener(unsubscribeFn) {
	  unsubscribeFn();
	}

/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(129);
	var core = __webpack_require__(192);
	var ctx = __webpack_require__(653);
	var hide = __webpack_require__(194);
	var has = __webpack_require__(149);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ },
/* 303 */
28,
/* 304 */
/***/ function(module, exports) {

	module.exports = true;


/***/ },
/* 305 */
155,
/* 306 */
159,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(253);
	
	module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ },
/* 323 */,
/* 324 */,
/* 325 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 */
	
	"use strict";
	
	/**
	 * Constructs an enumeration with keys equal to their value.
	 *
	 * For example:
	 *
	 *   var COLORS = keyMirror({blue: null, red: null});
	 *   var myColor = COLORS.blue;
	 *   var isColorValid = !!COLORS[myColor];
	 *
	 * The last line could not be performed if the values of the generated enum were
	 * not equal to their keys.
	 *
	 *   Input:  {key1: val1, key2: val2}
	 *   Output: {key1: key1, key2: key2}
	 *
	 * @param {object} obj
	 * @return {object}
	 */
	var keyMirror = function(obj) {
	  var ret = {};
	  var key;
	  if (!(obj instanceof Object && !Array.isArray(obj))) {
	    throw new Error('keyMirror(...): Argument must be an object.');
	  }
	  for (key in obj) {
	    if (!obj.hasOwnProperty(key)) {
	      continue;
	    }
	    ret[key] = key;
	  }
	  return ret;
	};
	
	module.exports = keyMirror;


/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(2898),
	    listCacheDelete = __webpack_require__(2899),
	    listCacheGet = __webpack_require__(2900),
	    listCacheHas = __webpack_require__(2901),
	    listCacheSet = __webpack_require__(2902);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(467);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(88);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	module.exports = baseCreate;


/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(207),
	    toKey = __webpack_require__(208);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(328),
	    isObject = __webpack_require__(88);
	
	/**
	 * Creates a function that produces an instance of `Ctor` regardless of
	 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	 *
	 * @private
	 * @param {Function} Ctor The constructor to wrap.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createCtor(Ctor) {
	  return function() {
	    // Use a `switch` statement to work with class constructors. See
	    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	    // for more details.
	    var args = arguments;
	    switch (args.length) {
	      case 0: return new Ctor;
	      case 1: return new Ctor(args[0]);
	      case 2: return new Ctor(args[0], args[1]);
	      case 3: return new Ctor(args[0], args[1], args[2]);
	      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	    }
	    var thisBinding = baseCreate(Ctor.prototype),
	        result = Ctor.apply(thisBinding, args);
	
	    // Mimic the constructor's `return` behavior.
	    // See https://es5.github.io/#x13.2.2 for more details.
	    return isObject(result) ? result : thisBinding;
	  };
	}
	
	module.exports = createCtor;


/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(2895);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ },
/* 332 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ },
/* 333 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(161);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(2837),
	    isObjectLike = __webpack_require__(134);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(62),
	    stubFalse = __webpack_require__(2945);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(173)(module)))

/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(160),
	    isObjectLike = __webpack_require__(134);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(27);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _consolidatedEvents = __webpack_require__(301);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import { forbidExtraProps } from 'airbnb-prop-types'; // TODO: add to propTypes; semver-major
	
	
	var propTypes = {
	  children: _propTypes2['default'].node,
	  onOutsideClick: _propTypes2['default'].func
	};
	
	var defaultProps = {
	  children: _react2['default'].createElement('span', null),
	  onOutsideClick: function () {
	    function onOutsideClick() {}
	
	    return onOutsideClick;
	  }()
	};
	
	var OutsideClickHandler = function (_React$Component) {
	  _inherits(OutsideClickHandler, _React$Component);
	
	  function OutsideClickHandler() {
	    var _ref;
	
	    _classCallCheck(this, OutsideClickHandler);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = _possibleConstructorReturn(this, (_ref = OutsideClickHandler.__proto__ || Object.getPrototypeOf(OutsideClickHandler)).call.apply(_ref, [this].concat(args)));
	
	    _this.onOutsideClick = _this.onOutsideClick.bind(_this);
	    _this.setChildNodeRef = _this.setChildNodeRef.bind(_this);
	    return _this;
	  }
	
	  _createClass(OutsideClickHandler, [{
	    key: 'componentDidMount',
	    value: function () {
	      function componentDidMount() {
	        // `capture` flag is set to true so that a `stopPropagation` in the children
	        // will not prevent all outside click handlers from firing - maja
	        this.removeEventListener = (0, _consolidatedEvents.addEventListener)(document, 'click', this.onOutsideClick, { capture: true });
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentWillUnmount',
	    value: function () {
	      function componentWillUnmount() {
	        if (this.removeEventListener) {
	          this.removeEventListener();
	        }
	      }
	
	      return componentWillUnmount;
	    }()
	  }, {
	    key: 'onOutsideClick',
	    value: function () {
	      function onOutsideClick(e) {
	        var onOutsideClick = this.props.onOutsideClick;
	        var childNode = this.childNode;
	
	        var isDescendantOfRoot = childNode && childNode.contains(e.target);
	        if (!isDescendantOfRoot) {
	          onOutsideClick(e);
	        }
	      }
	
	      return onOutsideClick;
	    }()
	  }, {
	    key: 'setChildNodeRef',
	    value: function () {
	      function setChildNodeRef(ref) {
	        this.childNode = ref;
	      }
	
	      return setChildNodeRef;
	    }()
	  }, {
	    key: 'render',
	    value: function () {
	      function render() {
	        return _react2['default'].createElement(
	          'div',
	          { ref: this.setChildNodeRef },
	          this.props.children
	        );
	      }
	
	      return render;
	    }()
	  }]);
	
	  return OutsideClickHandler;
	}(_react2['default'].Component);
	
	exports['default'] = OutsideClickHandler;
	
	
	OutsideClickHandler.propTypes = propTypes;
	OutsideClickHandler.defaultProps = defaultProps;

/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(27);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _constants = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].oneOf([_constants.START_DATE, _constants.END_DATE])]);

/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = toISODateString;
	
	var _moment = __webpack_require__(9);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _toMomentObject = __webpack_require__(215);
	
	var _toMomentObject2 = _interopRequireDefault(_toMomentObject);
	
	var _constants = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function toISODateString(date, currentFormat) {
	  var dateObj = _moment2['default'].isMoment(date) ? date : (0, _toMomentObject2['default'])(date, currentFormat);
	  if (!dateObj) return null;
	
	  return dateObj.format(_constants.ISO_FORMAT);
	}

/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = toISOMonthString;
	
	var _moment = __webpack_require__(9);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _toMomentObject = __webpack_require__(215);
	
	var _toMomentObject2 = _interopRequireDefault(_toMomentObject);
	
	var _constants = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function toISOMonthString(date, currentFormat) {
	  var dateObj = _moment2['default'].isMoment(date) ? date : (0, _toMomentObject2['default'])(date, currentFormat);
	  if (!dateObj) return null;
	
	  return dateObj.format(_constants.ISO_MONTH_FORMAT);
	}

/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(32);
	
	var ReactErrorUtils = __webpack_require__(482);
	
	var invariant = __webpack_require__(19);
	var warning = __webpack_require__(26);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(29);
	
	var EventPluginRegistry = __webpack_require__(478);
	var ReactEventEmitterMixin = __webpack_require__(3014);
	var ViewportMetrics = __webpack_require__(484);
	
	var getVendorPrefixedEventName = __webpack_require__(895);
	var isEventSupported = __webpack_require__(490);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(221);
	var ViewportMetrics = __webpack_require__(484);
	
	var getEventModifierState = __webpack_require__(487);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(32);
	
	var invariant = __webpack_require__(19);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ },
/* 346 */
/***/ function(module, exports) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(53);
	var DOMNamespaces = __webpack_require__(477);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(485);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xFEFF) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ },
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _addTitle = __webpack_require__(974);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_addTitle).default;
	  }
	});
	Object.defineProperty(exports, 'AddTitle', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_addTitle).default;
	  }
	});
	
	var _catalogueResults = __webpack_require__(982);
	
	Object.defineProperty(exports, 'CatalogueResults', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_catalogueResults).default;
	  }
	});
	
	var _catalogueResultItemButton = __webpack_require__(978);
	
	Object.defineProperty(exports, 'CatalogueResultItemButton', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_catalogueResultItemButton).default;
	  }
	});
	
	var _catalogueResultItemAlert = __webpack_require__(976);
	
	Object.defineProperty(exports, 'CatalogueResultItemAlert', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_catalogueResultItemAlert).default;
	  }
	});
	
	var _webResults = __webpack_require__(988);
	
	Object.defineProperty(exports, 'WebResults', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_webResults).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AvailabilityStatus = __webpack_require__(1008);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AvailabilityStatus).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DropdownMenu = __webpack_require__(1071);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DropdownMenu).default;
	  }
	});
	
	var _DropdownMenuDivider = __webpack_require__(1072);
	
	Object.defineProperty(exports, 'DropdownMenuDivider', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DropdownMenuDivider).default;
	  }
	});
	
	var _DropdownMenuHeader = __webpack_require__(1073);
	
	Object.defineProperty(exports, 'DropdownMenuHeader', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DropdownMenuHeader).default;
	  }
	});
	
	var _DropdownMenuItem = __webpack_require__(1074);
	
	Object.defineProperty(exports, 'DropdownMenuItem', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DropdownMenuItem).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _addToShelf = __webpack_require__(1417);
	
	Object.defineProperty(exports, 'addToShelf', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_addToShelf).default;
	  }
	});
	
	var _toggleDrawer = __webpack_require__(1419);
	
	Object.defineProperty(exports, 'toggleDrawer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_toggleDrawer).default;
	  }
	});
	
	var _openStackMap = __webpack_require__(1418);
	
	Object.defineProperty(exports, 'openStackMap', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_openStackMap).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _HoldCounts = __webpack_require__(1420);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_HoldCounts).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BibScreenReaderDescription = __webpack_require__(1471);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BibScreenReaderDescription).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FieldErrorWrapper = __webpack_require__(1483);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FieldErrorWrapper).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FormatInfo = __webpack_require__(1484);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FormatInfo).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Generic = __webpack_require__(1493);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Generic).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PublicationDate = __webpack_require__(1505);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PublicationDate).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _VideoForm = __webpack_require__(1540);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_VideoForm).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _VideoPreview = __webpack_require__(1541);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_VideoPreview).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SortDropDown = __webpack_require__(1542);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SortDropDown).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isMobileAppRequest = exports.createQueryString = exports.jsonp = exports.superagentToObservable = undefined;
	
	var _lodash = __webpack_require__(16);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _rxjs = __webpack_require__(169);
	
	var _superagentJsonp = __webpack_require__(3416);
	
	var _superagentJsonp2 = _interopRequireDefault(_superagentJsonp);
	
	var _superagent = __webpack_require__(270);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var superagentToObservable = exports.superagentToObservable = function superagentToObservable(request) {
	  var abortOnUnsubscribe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	  return _rxjs.Observable.create(function (observer) {
	    request.end(function (err, response) {
	      if (err) {
	        observer.error(err);
	      }
	      if (response) {
	        observer.next(response);
	        observer.complete();
	      }
	    });
	
	    if (abortOnUnsubscribe) {
	      return function () {
	        return request.abort();
	      };
	    }
	
	    return null;
	  });
	};
	
	/**
	 * Makes a JSONP request and returns an observable
	 * @param {string} url - url for the JSONP request (must end with callback=)
	 * @return {Observable}
	 */
	var jsonp = exports.jsonp = function jsonp(url) {
	  return superagentToObservable(_superagent2.default.get(url).use((0, _superagentJsonp2.default)({ timeout: 10000 })), false);
	};
	
	var createQueryString = exports.createQueryString = function createQueryString(obj) {
	  return _lodash2.default.map(obj, function (value, key) {
	    return key + '=' + encodeURIComponent(value);
	  }).join('&');
	};
	
	var MOBILE_APP_NAME = 'BiblioApp';
	
	/**
	 * Returns true if the request is from the mobile app.
	 *
	 * @param {object} request headers
	 * @return {boolean}
	 */
	var isMobileAppRequest = exports.isMobileAppRequest = function isMobileAppRequest() {
	  var headers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var possibleValues = [headers['x-requested-with'], headers['user-agent']];
	
	  var valuesContainingAppName = possibleValues.filter(function (value) {
	    return (value || '').indexOf(MOBILE_APP_NAME) !== -1;
	  });
	
	  return valuesContainingAppName.length > 0;
	};
	
	exports.default = {
	  superagentToObservable: superagentToObservable,
	  jsonp: jsonp,
	  createQueryString: createQueryString,
	  isMobileAppRequest: isMobileAppRequest
	};

/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.shallowEquals = shallowEquals;
	exports.isEmpty = isEmpty;
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _lodash = __webpack_require__(16);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var is = _immutable2.default.is.bind(_immutable2.default);
	
	/* Implementation of shallowEquals that supports ImmutableJS structures */
	function shallowEquals(a, b) {
	  if (a === b || is(a, b)) {
	    return true;
	  }
	
	  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) !== 'object' || a === null || (typeof b === 'undefined' ? 'undefined' : _typeof(b)) !== 'object' || b === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(a);
	  var keysB = Object.keys(b);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
	  // eslint-disable-next-line no-restricted-syntax
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = keysA[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var key = _step.value;
	
	      if (!bHasOwnProperty(key) || !is(a[key], b[key])) {
	        return false;
	      }
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return true;
	}
	
	/* isEmpty that supports both native arrays/objects and Immutable iterables (lists, maps, etc) */
	function isEmpty(obj) {
	  if (_immutable2.default.Iterable.isIterable(obj)) {
	    return obj.isEmpty();
	  }
	
	  return _lodash2.default.isEmpty(obj);
	}

/***/ },
/* 375 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var chunk = exports.chunk = function chunk(str) {
	  var chunkSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
	
	  var results = [];
	  var i = void 0;
	  var len = void 0;
	
	  for (i = 0, len = str.length; i < len; i += chunkSize) {
	    results.push(str.substr(i, chunkSize));
	  }
	
	  return results;
	};
	
	var truncate = exports.truncate = function truncate(str, userOptions) {
	  var defaultOptions = {
	    desiredLength: 20,
	    softTruncate: true,
	    showEllipsis: true
	  };
	
	  var options = Object.assign({}, defaultOptions, userOptions);
	
	  var desiredLength = options.desiredLength,
	      softTruncate = options.softTruncate,
	      showEllipsis = options.showEllipsis;
	
	
	  if (str.length <= desiredLength) {
	    return str;
	  }
	
	  var trimmedString = str.substr(0, desiredLength);
	  if (softTruncate && trimmedString.lastIndexOf(' ') > 0) {
	    trimmedString = trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(' ')));
	  }
	  return '' + trimmedString + (showEllipsis ? '\u2026' : '');
	};
	
	var softHyphenate = exports.softHyphenate = function softHyphenate(str) {
	  var minLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
	  var chunkSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5;
	
	  var words = str.split(' ');
	  return words.map(function (word) {
	    if (word.length >= minLength) {
	      return chunk(word, chunkSize).join('\xAD');
	    }
	    return word;
	  }).join(' ');
	};

/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.AboveTheFoldOnlyServerRender = undefined;
	
	var _aboveTheFoldOnlyServerRender = __webpack_require__(1572);
	
	var _aboveTheFoldOnlyServerRender2 = _interopRequireDefault(_aboveTheFoldOnlyServerRender);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _aboveTheFoldOnlyServerRender2.default;
	exports.AboveTheFoldOnlyServerRender = _aboveTheFoldOnlyServerRender2.default;

/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AppConstants = __webpack_require__(186);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	var _FeatureFlagApi = __webpack_require__(1604);
	
	var _FeatureFlagApi2 = _interopRequireDefault(_FeatureFlagApi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FETCH_COOKIES = _AppConstants2.default.FETCH_COOKIES,
	    LOAD_APP_CONFIG = _AppConstants2.default.LOAD_APP_CONFIG,
	    LOAD_COOKIES = _AppConstants2.default.LOAD_COOKIES,
	    SHOW_ERROR_PAGE = _AppConstants2.default.SHOW_ERROR_PAGE,
	    UPDATE_FEATURE_FLAG_REQUEST = _AppConstants2.default.UPDATE_FEATURE_FLAG_REQUEST,
	    UPDATE_FEATURE_FLAG_SUCCESS = _AppConstants2.default.UPDATE_FEATURE_FLAG_SUCCESS,
	    UPDATE_FEATURE_FLAG_FAILURE = _AppConstants2.default.UPDATE_FEATURE_FLAG_FAILURE;
	
	
	function loadAppConfig(appConfig) {
	  return {
	    appConfig: appConfig,
	    type: LOAD_APP_CONFIG
	  };
	}
	
	/**
	 * Tell the reducers to load the given `cookies` as if they came from the
	 * user agent's cookies. Used for initializing a server-rendered redux store.
	 * @param  {object} cookies
	 * @return {object]}
	 */
	function loadCookies() {
	  var cookies = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return {
	    cookies: cookies,
	    type: LOAD_COOKIES
	  };
	}
	
	/**
	 * Tell the reducers to fetch their cookies from the user-agent.
	 * @return {object]}
	 */
	function fetchCookies() {
	  return {
	    type: FETCH_COOKIES
	  };
	}
	
	function showErrorPage() {
	  return {
	    type: SHOW_ERROR_PAGE
	  };
	}
	
	function updateFeatureFlag(flag, value) {
	  return {
	    types: [UPDATE_FEATURE_FLAG_REQUEST, UPDATE_FEATURE_FLAG_SUCCESS, UPDATE_FEATURE_FLAG_FAILURE],
	    payload: {
	      flag: flag,
	      enabled: value
	    },
	    apiRequest: function apiRequest(state, _apiRequest) {
	      return _FeatureFlagApi2.default.updateFlag(flag, value, _apiRequest);
	    }
	  };
	}
	
	exports.default = {
	  fetchCookies: fetchCookies,
	  loadAppConfig: loadAppConfig,
	  loadCookies: loadCookies,
	  showErrorPage: showErrorPage,
	  updateFeatureFlag: updateFeatureFlag
	};

/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AuthApi = __webpack_require__(1599);
	
	var _AuthApi2 = _interopRequireDefault(_AuthApi);
	
	var _AuthConstants = __webpack_require__(293);
	
	var _AuthConstants2 = _interopRequireDefault(_AuthConstants);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @desc post message with current login status
	 * @param {boolean} status defines if user is logged in or not
	 */
	function _postLoginStatus(status) {
	  if (typeof window.parentIFrame !== 'undefined') {
	    var postMessagePayload = {
	      userLoggedIn: status,
	      name: window.name
	    };
	
	    window.parentIFrame.sendMessage(postMessagePayload, '*');
	  }
	}
	
	function loadUser() {
	  return {
	    types: [_AuthConstants2.default.AUTH_LOAD_USER_REQUEST, _AuthConstants2.default.AUTH_LOAD_USER_SUCCESS, _AuthConstants2.default.AUTH_LOAD_USER_FAILURE],
	    apiRequest: function apiRequest(state, client) {
	      return _AuthApi2.default.loadUser(client);
	    }
	  };
	}
	
	function login(username, pin) {
	  return {
	    types: [_AuthConstants2.default.AUTH_LOGIN_REQUEST, _AuthConstants2.default.AUTH_LOGIN_SUCCESS, _AuthConstants2.default.AUTH_LOGIN_ERROR],
	    apiRequest: function apiRequest(state, client) {
	      return _AuthApi2.default.login(username, pin, client);
	    },
	    postSuccess: function postSuccess(state) {
	      var postLoginAction = state.getIn(['auth', 'postLoginAction']);
	      _postLoginStatus(true);
	
	      if (_immutable2.default.Iterable.isIterable(postLoginAction)) {
	        return postLoginAction.toJS();
	      }
	      return postLoginAction;
	    }
	  };
	}
	
	function logout() {
	  _postLoginStatus(false);
	
	  return {
	    type: _AuthConstants2.default.AUTH_LOGOUT
	  };
	}
	
	function closeLoginOverlay() {
	  return {
	    type: _AuthConstants2.default.CLOSE_LOGIN_OVERLAY
	  };
	}
	
	exports.default = {
	  login: login,
	  logout: logout,
	  loadUser: loadUser,
	  closeLoginOverlay: closeLoginOverlay
	};

/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _gaEventTemplates = __webpack_require__(363);
	
	var _DrawerConstants = __webpack_require__(614);
	
	var _DrawerConstants2 = _interopRequireDefault(_DrawerConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function toggle() {
	  return {
	    type: _DrawerConstants2.default.TOGGLE,
	    gaEvent: (0, _gaEventTemplates.toggleDrawer)()
	  };
	}
	
	exports.default = {
	  toggle: toggle
	};

/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GroupSearchFeedbackConstants = __webpack_require__(619);
	
	var _GroupSearchFeedbackConstants2 = _interopRequireDefault(_GroupSearchFeedbackConstants);
	
	var _FeedbackApi = __webpack_require__(381);
	
	var _FeedbackApi2 = _interopRequireDefault(_FeedbackApi);
	
	var _composeSuccessMessaging = __webpack_require__(190);
	
	var _composeSuccessMessaging2 = _interopRequireDefault(_composeSuccessMessaging);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function startGroupSearchFeedback(bib) {
	  return {
	    type: _GroupSearchFeedbackConstants2.default.OPEN_FEEDBACK_OVERLAY,
	    payload: {
	      metadataId: bib.get('id'),
	      groupSearchSummary: bib.get('groupSearchSummary'),
	      searchUrl: window.location.href
	    }
	  };
	}
	
	function closeOverlay() {
	  return {
	    type: _GroupSearchFeedbackConstants2.default.CLOSE_FEEDBACK_OVERLAY
	  };
	}
	
	function updateShouldMatch(shouldMatch) {
	  return {
	    type: _GroupSearchFeedbackConstants2.default.CHOOSE_SHOULD_MATCH,
	    payload: shouldMatch
	  };
	}
	
	function selectMatchingBib(bib) {
	  return {
	    type: _GroupSearchFeedbackConstants2.default.SELECT_MATCHING_BIB,
	    payload: {
	      metadataId: bib.get('id'),
	      groupSearchSummary: bib.get('groupSearchSummary')
	    }
	  };
	}
	
	function changeMatchingBib() {
	  return {
	    type: _GroupSearchFeedbackConstants2.default.CHANGE_MATCHING_BIB
	  };
	}
	
	function submitFeedback(_ref) {
	  var messagingId = _ref.messagingId,
	      notes = _ref.notes;
	
	  return {
	    types: [_GroupSearchFeedbackConstants2.default.SUBMIT_FEEDBACK_REQUEST, _GroupSearchFeedbackConstants2.default.SUBMIT_FEEDBACK_SUCCESS, _GroupSearchFeedbackConstants2.default.SUBMIT_FEEDBACK_FAILURE],
	    payload: {
	      notes: notes
	    },
	    apiRequest: function apiRequest(state, apiClient) {
	      var shouldMatch = state.getIn(['ui', 'groupSearchFeedback', 'shouldMatch']);
	      var metadataId1 = state.getIn(['ui', 'groupSearchFeedback', 'metadataId1']);
	      var metadataId2 = state.getIn(['ui', 'groupSearchFeedback', 'metadataId2']);
	      var groupSearchSummary2 = state.getIn(['ui', 'groupSearchFeedback', 'groupSearchSummary2']);
	
	      if (!shouldMatch) {
	        // Find a manifestation of the current item and use it as metadataId2
	        metadataId2 = state.getIn(['search', 'catalogSearch', 'results']).find(function (group) {
	          return group.includes(metadataId1);
	        }).filter(function (id) {
	          return id !== metadataId1;
	        }).first();
	
	        groupSearchSummary2 = state.getIn(['entities', 'bibs', metadataId2, 'groupSearchSummary']);
	      }
	
	      return _FeedbackApi2.default.submitGroupSearchFeedback({
	        notes: notes,
	        metadataId1: metadataId1,
	        metadataId2: metadataId2,
	        groupSearchSummary1: state.getIn(['ui', 'groupSearchFeedback', 'groupSearchSummary1']),
	        groupSearchSummary2: groupSearchSummary2,
	        shouldMatch: state.getIn(['ui', 'groupSearchFeedback', 'shouldMatch']),
	        searchUrl: state.getIn(['ui', 'groupSearchFeedback', 'searchUrl'])
	      }, apiClient);
	    },
	    apiSuccess: function apiSuccess() {
	      return {
	        messaging: (0, _composeSuccessMessaging2.default)(messagingId, 'message_feedback_confirmed')
	      };
	    }
	  };
	}
	
	exports.default = {
	  startGroupSearchFeedback: startGroupSearchFeedback,
	  closeOverlay: closeOverlay,
	  updateShouldMatch: updateShouldMatch,
	  selectMatchingBib: selectMatchingBib,
	  changeMatchingBib: changeMatchingBib,
	  submitFeedback: submitFeedback
	};

/***/ },
/* 381 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['/libraries/', '/feedback'], ['/libraries/', '/feedback']),
	    _templateObject2 = _taggedTemplateLiteral(['/libraries/', '/feedback/groupsearch'], ['/libraries/', '/feedback/groupsearch']);
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	function submitFeedback(feedbackData, apiClient) {
	  var route = apiClient.route(_templateObject, ':librarySubdomain');
	  return apiClient.post(route, feedbackData);
	}
	
	function submitGroupSearchFeedback(feedbackData, apiClient) {
	  var route = apiClient.route(_templateObject2, ':librarySubdomain');
	  return apiClient.post(route, feedbackData);
	}
	
	exports.default = {
	  submitFeedback: submitFeedback,
	  submitGroupSearchFeedback: submitGroupSearchFeedback
	};

/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AddToShelfBatchActions = __webpack_require__(1798);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AddToShelfBatchActions).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BorrowingBatchActionsOverlay = __webpack_require__(1801);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BorrowingBatchActionsOverlay).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BorrowingStatusIcon = __webpack_require__(1814);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BorrowingStatusIcon).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _StatusSidebarLink = __webpack_require__(1844);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_StatusSidebarLink).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DidYouMean = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _reactRouter = __webpack_require__(17);
	
	var _updateSearchQuery = __webpack_require__(148);
	
	var _updateSearchQuery2 = _interopRequireDefault(_updateSearchQuery);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _utilsAnalytics = __webpack_require__(142);
	
	var _analyticsEventComposers = __webpack_require__(174);
	
	__webpack_require__(2545);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DidYouMean = exports.DidYouMean = function (_BcReactComponent) {
	  _inherits(DidYouMean, _BcReactComponent);
	
	  function DidYouMean(props) {
	    _classCallCheck(this, DidYouMean);
	
	    var _this = _possibleConstructorReturn(this, (DidYouMean.__proto__ || Object.getPrototypeOf(DidYouMean)).call(this, props));
	
	    _this.bindAll('handleClick');
	    return _this;
	  }
	
	  _createClass(DidYouMean, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.querySuggestion && this.props.handleDidYouMeanImpression) {
	        this.props.handleDidYouMeanImpression();
	      }
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(e) {
	      e.preventDefault();
	      var _props = this.props,
	          router = _props.router,
	          location = _props.location;
	
	      (0, _utilsAnalytics.sendAnalyticsEvents)(_analyticsEventComposers.searchEventComposer.composeDidYouMeanClickEvent({ query: location.query.query, suggestion: this.props.querySuggestion }));
	
	      var query = (0, _updateSearchQuery2.default)({
	        currentQuery: location.query,
	        query: this.props.querySuggestion,
	        pagination_page: undefined
	      });
	
	      router.push(_extends({}, location, { query: query }));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          querySuggestion = _props2.querySuggestion,
	          resultCount = _props2.resultCount;
	
	      if (!querySuggestion) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-did-you-mean' },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'form_label_did_you_mean', values: { querySuggestion: _react2.default.createElement(
	              'strong',
	              null,
	              querySuggestion
	            ) } }),
	        '\xA0',
	        _react2.default.createElement(
	          'a',
	          { className: 'did-you-mean-suggestion-link', href: '#dym', onClick: this.handleClick },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'form_label_did_you_mean_view_results', values: { resultCount: resultCount } })
	        )
	      );
	    }
	  }]);
	
	  return DidYouMean;
	}(_baseBcReactComponent2.default);
	
	DidYouMean.displayName = 'DidYouMean';
	
	DidYouMean.propTypes = {
	  querySuggestion: _react.PropTypes.string,
	  resultCount: _react.PropTypes.number,
	  handleDidYouMeanImpression: _react.PropTypes.func,
	  router: _reactRouter.routerShape
	};
	
	exports.default = (0, _reactRouter.withRouter)(DidYouMean);

/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AddTitle = __webpack_require__(1897);
	
	Object.defineProperty(exports, 'AddTitle', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AddTitle).default;
	  }
	});
	
	var _AddTitleOverlay = __webpack_require__(582);
	
	Object.defineProperty(exports, 'AddTitleOverlay', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AddTitleOverlay).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BatchAddToShelfButton = __webpack_require__(1911);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BatchAddToShelfButton).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SimpleField = __webpack_require__(1939);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SimpleField).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AddButton = __webpack_require__(1977);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AddButton).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _QuotationUGCEditor = __webpack_require__(1995);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_QuotationUGCEditor).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TextUGCEditor = __webpack_require__(1998);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TextUGCEditor).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FORMATS_WHITELIST = undefined;
	
	var _utilsRedux = __webpack_require__(20);
	
	exports.default = (0, _utilsRedux.createReduxConstants)('RECOMMENDATIONS', {
	  RECOMMENDATION_REQUEST: null,
	  RECOMMENDATION_SUCCESS: null,
	  RECOMMENDATION_ERROR: null
	});
	var FORMATS_WHITELIST = exports.FORMATS_WHITELIST = ['BK', 'GRAPHIC_NOVEL'];

/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utilsRedux = __webpack_require__(20);
	
	exports.default = (0, _utilsRedux.createReduxConstants)('SAVED_SEARCH', {
	  SAVE_REQUEST: null,
	  SAVE_SUCCESS: null,
	  SAVE_FAILURE: null,
	  CHOOSE_NEW_NAME: null
	});

/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.JacketCoverContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(14);
	
	var _ListPresentationSelector = __webpack_require__(645);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _sharedJacketCover = __webpack_require__(93);
	
	var _sharedJacketCover2 = _interopRequireDefault(_sharedJacketCover);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var JacketCoverContainer = exports.JacketCoverContainer = function (_BcReactComponent) {
	  _inherits(JacketCoverContainer, _BcReactComponent);
	
	  function JacketCoverContainer() {
	    _classCallCheck(this, JacketCoverContainer);
	
	    return _possibleConstructorReturn(this, (JacketCoverContainer.__proto__ || Object.getPrototypeOf(JacketCoverContainer)).apply(this, arguments));
	  }
	
	  _createClass(JacketCoverContainer, [{
	    key: 'render',
	    value: function render() {
	      return this.props.currentView !== 'small' ? _react2.default.createElement(_sharedJacketCover2.default, this.props) : null;
	    }
	  }]);
	
	  return JacketCoverContainer;
	}(_baseBcReactComponent2.default);
	
	JacketCoverContainer.propTypes = {
	  currentView: _react.PropTypes.string,
	  format: _react.PropTypes.string,
	  src: _react.PropTypes.oneOfType([_react.PropTypes.string, _bcPropTypes.jacketShape]),
	  size: _react.PropTypes.string,
	  responsive: _react.PropTypes.bool,
	  testId: _react.PropTypes.string
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    currentView: (0, _ListPresentationSelector.getCurrentView)(state)
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(JacketCoverContainer);

/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(14);
	
	var _LibrarySelector = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// By default, we pass the whole library as a prop
	var defaultMapLibraryToProps = function defaultMapLibraryToProps(library, site, ownProps) {
	  return { library: library, site: site };
	}; // eslint-disable-line no-unused-vars
	
	/**
	 * Usage:
	 *        injectLibrary()(ComposedComponent)
	 *          passes "library" as a prop to the ComposedComponent
	 *
	 *        injectLibrary((library) => ({ name: library.get('name')}))(ComposedComponent)
	 *          passes "name" as a prop to ComposedComponent.
	 *          "name" will be the value of library.get('name')
	 */
	var injectLibrary = function injectLibrary() {
	  var mapLibraryToProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultMapLibraryToProps;
	  return function (ComposedComponent) {
	    function LibraryWrapper(props) {
	      return _react2.default.createElement(ComposedComponent, props);
	    }
	
	    LibraryWrapper.displayName = 'LibraryWrapper(' + ComposedComponent.displayName + ')';
	
	    return (0, _reactRedux.connect)(function (state, ownProps) {
	      return mapLibraryToProps({ library: (0, _LibrarySelector.currentLibrarySelector)(state), site: (0, _LibrarySelector.currentSiteSelector)(state) }, ownProps);
	    })(LibraryWrapper);
	  };
	};
	
	exports.default = injectLibrary;

/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = formatFiltersForQuery;
	
	var _formatFilterForQuery = __webpack_require__(642);
	
	var _formatFilterForQuery2 = _interopRequireDefault(_formatFilterForQuery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function formatFiltersForQuery(activeFilters) {
	  return activeFilters.reduce(function (filterQueryParams, filtersForField, fieldId) {
	    return _extends({}, filterQueryParams, (0, _formatFilterForQuery2.default)(fieldId, filtersForField));
	  }, {});
	}

/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getBibsByMetadataId = undefined;
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reselect = __webpack_require__(34);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var bibsById = function bibsById(state) {
	  return state.getIn(['entities', 'bibs'], _immutable2.default.Map());
	};
	
	var getBibsByMetadataId = exports.getBibsByMetadataId = (0, _reselect.createSelector)([bibsById], function (bibs) {
	  return bibs;
	});
	
	exports.default = {
	  getBibsByMetadataId: getBibsByMetadataId
	};

/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getGlobalMessaging = exports.getMessaging = undefined;
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reselect = __webpack_require__(34);
	
	var _MessagingConstants = __webpack_require__(73);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getMessagingFromState = function getMessagingFromState(state) {
	  return state.getIn(['ui', 'messaging'], _immutable2.default.Map());
	};
	
	var getMessaging = exports.getMessaging = (0, _reselect.createSelector)([getMessagingFromState], function (messaging) {
	  return messaging;
	});
	
	var getGlobalMessaging = exports.getGlobalMessaging = (0, _reselect.createSelector)([getMessaging], function (messaging) {
	  return messaging.get(_MessagingConstants.GLOBAL_MESSAGING_ID);
	});
	
	exports.default = {
	  getMessaging: getMessaging,
	  getGlobalMessaging: getGlobalMessaging
	};

/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getAddTitleResult = exports.searchResultBibSelector = exports.probeResults = undefined;
	
	var _reselect = __webpack_require__(34);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var allBibs = function allBibs(state) {
	  return state.getIn(['entities', 'bibs']);
	};
	var searchResultIds = function searchResultIds(state) {
	  return state.getIn(['search', 'catalogSearch', 'results']);
	};
	var addTitleFromState = function addTitleFromState(state) {
	  return state.getIn(['search', 'addTitle']);
	};
	var probeResults = exports.probeResults = function probeResults(state) {
	  return state.getIn(['search', 'catalogSearch', 'probes']);
	};
	
	/**
	 * [searchResultBibSelector selects bib entites corresponding to values in the search result object]
	 * @return selector
	 */
	var searchResultBibSelector = exports.searchResultBibSelector = (0, _reselect.createSelector)(searchResultIds, allBibs, function (results, bibs) {
	  return results.map(function (result) {
	    return {
	      representative: bibs.get(result.get('representative')),
	      manifestations: result.get('manifestations').map(function (i) {
	        return bibs.get(i);
	      })
	    };
	  });
	});
	
	/**
	 * @description builds results for addTitle search; items is a list of corresponding bibs
	 * @return selector
	 */
	var getAddTitleResult = exports.getAddTitleResult = (0, _reselect.createSelector)(allBibs, addTitleFromState, function (bibs, addTitle) {
	  return _immutable2.default.Map({
	    searchQuery: addTitle.get('searchQuery'),
	    isFetching: addTitle.get('isFetching'),
	    zeroResults: addTitle.get('zeroResults'),
	    pagination: addTitle.get('pagination'),
	    items: addTitle.get('results').flatMap(function (result) {
	      return result.get('manifestations').map(function (i) {
	        return bibs.get(i);
	      });
	    })
	  });
	});

/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getRequestedUser = undefined;
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reselect = __webpack_require__(34);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var usersSelector = function usersSelector(state) {
	  return state.getIn(['entities', 'users'], _immutable2.default.Map());
	};
	var getRequestedUserFromState = function getRequestedUserFromState(state) {
	  return state.get('user');
	};
	
	var getRequestedUser = exports.getRequestedUser = (0, _reselect.createSelector)([getRequestedUserFromState, usersSelector], function (requestedUser, users) {
	  return requestedUser && requestedUser.get('id') ? users.find(function (user) {
	    return user.get('id') === requestedUser.get('id');
	  }) : undefined;
	});
	
	exports.default = {
	  getRequestedUser: getRequestedUser
	};

/***/ },
/* 402 */
100,
/* 403 */
419,
/* 404 */
199,
/* 405 */
[3500, 247, 2215, 403, 409, 654, 2209],
/* 406 */
[3508, 660, 403],
/* 407 */
250,
/* 408 */
[3510, 196, 149, 198],
/* 409 */
[3511, 410, 306],
/* 410 */
[3512, 192, 129, 304],
/* 411 */
102,
/* 412 */
[3518, 195],
/* 413 */
[3519, 129, 192, 304, 414, 196],
/* 414 */
[3520, 198],
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	var bind = __webpack_require__(253);
	var has = bind.call(Function.call, Object.prototype.hasOwnProperty);
	
	var $assign = Object.assign;
	
	module.exports = function assign(target, source) {
		if ($assign) {
			return $assign(target, source);
		}
	
		for (var key in source) {
			if (has(source, key)) {
				target[key] = source[key];
			}
		}
		return target;
	};


/***/ },
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */
/***/ function(module, exports) {

	'use strict';
	
	var fnToStr = Function.prototype.toString;
	
	var constructorRegex = /^\s*class\b/;
	var isES6ClassFn = function isES6ClassFunction(value) {
		try {
			var fnStr = fnToStr.call(value);
			return constructorRegex.test(fnStr);
		} catch (e) {
			return false; // not a function
		}
	};
	
	var tryFunctionObject = function tryFunctionToStr(value) {
		try {
			if (isES6ClassFn(value)) { return false; }
			fnToStr.call(value);
			return true;
		} catch (e) {
			return false;
		}
	};
	var toStr = Object.prototype.toString;
	var fnClass = '[object Function]';
	var genClass = '[object GeneratorFunction]';
	var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
	
	module.exports = function isCallable(value) {
		if (!value) { return false; }
		if (typeof value !== 'function' && typeof value !== 'object') { return false; }
		if (typeof value === 'function' && !value.prototype) { return true; }
		if (hasToStringTag) { return tryFunctionObject(value); }
		if (isES6ClassFn(value)) { return false; }
		var strClass = toStr.call(value);
		return strClass === fnClass || strClass === genClass;
	};


/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(328),
	    baseLodash = __webpack_require__(457);
	
	/** Used as references for the maximum length and index of an array. */
	var MAX_ARRAY_LENGTH = 4294967295;
	
	/**
	 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	 *
	 * @private
	 * @constructor
	 * @param {*} value The value to wrap.
	 */
	function LazyWrapper(value) {
	  this.__wrapped__ = value;
	  this.__actions__ = [];
	  this.__dir__ = 1;
	  this.__filtered__ = false;
	  this.__iteratees__ = [];
	  this.__takeCount__ = MAX_ARRAY_LENGTH;
	  this.__views__ = [];
	}
	
	// Ensure `LazyWrapper` is an instance of `baseLodash`.
	LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	LazyWrapper.prototype.constructor = LazyWrapper;
	
	module.exports = LazyWrapper;


/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(161),
	    root = __webpack_require__(62);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(2903),
	    mapCacheDelete = __webpack_require__(2904),
	    mapCacheGet = __webpack_require__(2905),
	    mapCacheHas = __webpack_require__(2906),
	    mapCacheSet = __webpack_require__(2907);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(326),
	    stackClear = __webpack_require__(2920),
	    stackDelete = __webpack_require__(2921),
	    stackGet = __webpack_require__(2922),
	    stackHas = __webpack_require__(2923),
	    stackSet = __webpack_require__(2924);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ },
/* 452 */
/***/ function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ },
/* 453 */
/***/ function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(722),
	    eq = __webpack_require__(467);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignValue;


/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(2838),
	    isObjectLike = __webpack_require__(134);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(2845),
	    baseMatchesProperty = __webpack_require__(2846),
	    identity = __webpack_require__(468),
	    isArray = __webpack_require__(65),
	    property = __webpack_require__(2944);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ },
/* 457 */
/***/ function(module, exports) {

	/**
	 * The function whose prototype chain sequence wrappers inherit from.
	 *
	 * @private
	 */
	function baseLodash() {
	  // No operation performed.
	}
	
	module.exports = baseLodash;


/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	var Uint8Array = __webpack_require__(717);
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	module.exports = cloneArrayBuffer;


/***/ },
/* 459 */
/***/ function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(723),
	    getSymbolsIn = __webpack_require__(737),
	    keysIn = __webpack_require__(752);
	
	/**
	 * Creates an array of own and inherited enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeysIn(object) {
	  return baseGetAllKeys(object, keysIn, getSymbolsIn);
	}
	
	module.exports = getAllKeysIn;


/***/ },
/* 461 */,
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(2824),
	    stubArray = __webpack_require__(755);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(2817),
	    Map = __webpack_require__(449),
	    Promise = __webpack_require__(2819),
	    Set = __webpack_require__(2820),
	    WeakMap = __webpack_require__(718),
	    baseGetTag = __webpack_require__(160),
	    toSource = __webpack_require__(749);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(65),
	    isSymbol = __webpack_require__(337);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ },
/* 465 */
/***/ function(module, exports) {

	/** Used as the internal argument placeholder. */
	var PLACEHOLDER = '__lodash_placeholder__';
	
	/**
	 * Replaces all `placeholder` elements in `array` with an internal placeholder
	 * and returns an array of their indexes.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {*} placeholder The placeholder to replace.
	 * @returns {Array} Returns the new array of placeholder indexes.
	 */
	function replaceHolders(array, placeholder) {
	  var index = -1,
	      length = array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (value === placeholder || value === PLACEHOLDER) {
	      array[index] = PLACEHOLDER;
	      result[resIndex++] = index;
	    }
	  }
	  return result;
	}
	
	module.exports = replaceHolders;


/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(88),
	    now = __webpack_require__(2941),
	    toNumber = __webpack_require__(758);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	module.exports = debounce;


/***/ },
/* 467 */
/***/ function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ },
/* 468 */
/***/ function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ },
/* 469 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(2842),
	    baseUnary = __webpack_require__(2855),
	    nodeUtil = __webpack_require__(2912);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PureCalendarDay = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _object = __webpack_require__(55);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(27);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactAddonsShallowCompare = __webpack_require__(210);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _reactMomentProptypes = __webpack_require__(112);
	
	var _reactMomentProptypes2 = _interopRequireDefault(_reactMomentProptypes);
	
	var _airbnbPropTypes = __webpack_require__(42);
	
	var _reactWithStyles = __webpack_require__(72);
	
	var _moment = __webpack_require__(9);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _defaultPhrases = __webpack_require__(50);
	
	var _getPhrasePropTypes = __webpack_require__(63);
	
	var _getPhrasePropTypes2 = _interopRequireDefault(_getPhrasePropTypes);
	
	var _getCalendarDaySettings = __webpack_require__(867);
	
	var _getCalendarDaySettings2 = _interopRequireDefault(_getCalendarDaySettings);
	
	var _constants = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)((0, _object2['default'])({}, _reactWithStyles.withStylesPropTypes, {
	  day: _reactMomentProptypes2['default'].momentObj,
	  daySize: _airbnbPropTypes.nonNegativeInteger,
	  isOutsideDay: _propTypes2['default'].bool,
	  modifiers: _propTypes2['default'].instanceOf(Set),
	  isFocused: _propTypes2['default'].bool,
	  tabIndex: _propTypes2['default'].oneOf([0, -1]),
	  onDayClick: _propTypes2['default'].func,
	  onDayMouseEnter: _propTypes2['default'].func,
	  onDayMouseLeave: _propTypes2['default'].func,
	  renderDayContents: _propTypes2['default'].func,
	  ariaLabelFormat: _propTypes2['default'].string,
	
	  // internationalization
	  phrases: _propTypes2['default'].shape((0, _getPhrasePropTypes2['default'])(_defaultPhrases.CalendarDayPhrases))
	}));
	
	var defaultProps = {
	  day: (0, _moment2['default'])(),
	  daySize: _constants.DAY_SIZE,
	  isOutsideDay: false,
	  modifiers: new Set(),
	  isFocused: false,
	  tabIndex: -1,
	  onDayClick: function () {
	    function onDayClick() {}
	
	    return onDayClick;
	  }(),
	  onDayMouseEnter: function () {
	    function onDayMouseEnter() {}
	
	    return onDayMouseEnter;
	  }(),
	  onDayMouseLeave: function () {
	    function onDayMouseLeave() {}
	
	    return onDayMouseLeave;
	  }(),
	
	  renderDayContents: null,
	  ariaLabelFormat: 'dddd, LL',
	
	  // internationalization
	  phrases: _defaultPhrases.CalendarDayPhrases
	};
	
	var CalendarDay = function (_React$Component) {
	  _inherits(CalendarDay, _React$Component);
	
	  function CalendarDay() {
	    var _ref;
	
	    _classCallCheck(this, CalendarDay);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = _possibleConstructorReturn(this, (_ref = CalendarDay.__proto__ || Object.getPrototypeOf(CalendarDay)).call.apply(_ref, [this].concat(args)));
	
	    _this.setButtonRef = _this.setButtonRef.bind(_this);
	    return _this;
	  }
	
	  _createClass(CalendarDay, [{
	    key: 'shouldComponentUpdate',
	    value: function () {
	      function shouldComponentUpdate(nextProps, nextState) {
	        return (0, _reactAddonsShallowCompare2['default'])(this, nextProps, nextState);
	      }
	
	      return shouldComponentUpdate;
	    }()
	  }, {
	    key: 'componentDidUpdate',
	    value: function () {
	      function componentDidUpdate(prevProps) {
	        var _props = this.props,
	            isFocused = _props.isFocused,
	            tabIndex = _props.tabIndex;
	
	        if (tabIndex === 0) {
	          if (isFocused || tabIndex !== prevProps.tabIndex) {
	            this.buttonRef.focus();
	          }
	        }
	      }
	
	      return componentDidUpdate;
	    }()
	  }, {
	    key: 'onDayClick',
	    value: function () {
	      function onDayClick(day, e) {
	        var onDayClick = this.props.onDayClick;
	
	        onDayClick(day, e);
	      }
	
	      return onDayClick;
	    }()
	  }, {
	    key: 'onDayMouseEnter',
	    value: function () {
	      function onDayMouseEnter(day, e) {
	        var onDayMouseEnter = this.props.onDayMouseEnter;
	
	        onDayMouseEnter(day, e);
	      }
	
	      return onDayMouseEnter;
	    }()
	  }, {
	    key: 'onDayMouseLeave',
	    value: function () {
	      function onDayMouseLeave(day, e) {
	        var onDayMouseLeave = this.props.onDayMouseLeave;
	
	        onDayMouseLeave(day, e);
	      }
	
	      return onDayMouseLeave;
	    }()
	  }, {
	    key: 'onKeyDown',
	    value: function () {
	      function onKeyDown(day, e) {
	        var onDayClick = this.props.onDayClick;
	        var key = e.key;
	
	        if (key === 'Enter' || key === ' ') {
	          onDayClick(day, e);
	        }
	      }
	
	      return onKeyDown;
	    }()
	  }, {
	    key: 'setButtonRef',
	    value: function () {
	      function setButtonRef(ref) {
	        this.buttonRef = ref;
	      }
	
	      return setButtonRef;
	    }()
	  }, {
	    key: 'render',
	    value: function () {
	      function render() {
	        var _this2 = this;
	
	        var _props2 = this.props,
	            day = _props2.day,
	            ariaLabelFormat = _props2.ariaLabelFormat,
	            daySize = _props2.daySize,
	            isOutsideDay = _props2.isOutsideDay,
	            modifiers = _props2.modifiers,
	            renderDayContents = _props2.renderDayContents,
	            tabIndex = _props2.tabIndex,
	            styles = _props2.styles,
	            phrases = _props2.phrases;
	
	
	        if (!day) return _react2['default'].createElement('td', null);
	
	        var _getCalendarDaySettin = (0, _getCalendarDaySettings2['default'])(day, ariaLabelFormat, daySize, modifiers, phrases),
	            daySizeStyles = _getCalendarDaySettin.daySizeStyles,
	            useDefaultCursor = _getCalendarDaySettin.useDefaultCursor,
	            selected = _getCalendarDaySettin.selected,
	            hoveredSpan = _getCalendarDaySettin.hoveredSpan,
	            isOutsideRange = _getCalendarDaySettin.isOutsideRange,
	            ariaLabel = _getCalendarDaySettin.ariaLabel;
	
	        return _react2['default'].createElement(
	          'td',
	          _extends({}, (0, _reactWithStyles.css)(styles.CalendarDay, useDefaultCursor && styles.CalendarDay__defaultCursor, styles.CalendarDay__default, isOutsideDay && styles.CalendarDay__outside, modifiers.has('today') && styles.CalendarDay__today, modifiers.has('first-day-of-week') && styles.CalendarDay__firstDayOfWeek, modifiers.has('last-day-of-week') && styles.CalendarDay__lastDayOfWeek, modifiers.has('hovered-offset') && styles.CalendarDay__hovered_offset, modifiers.has('highlighted-calendar') && styles.CalendarDay__highlighted_calendar, modifiers.has('blocked-minimum-nights') && styles.CalendarDay__blocked_minimum_nights, modifiers.has('blocked-calendar') && styles.CalendarDay__blocked_calendar, hoveredSpan && styles.CalendarDay__hovered_span, modifiers.has('selected-span') && styles.CalendarDay__selected_span, modifiers.has('last-in-range') && styles.CalendarDay__last_in_range, modifiers.has('selected-start') && styles.CalendarDay__selected_start, modifiers.has('selected-end') && styles.CalendarDay__selected_end, selected && styles.CalendarDay__selected, isOutsideRange && styles.CalendarDay__blocked_out_of_range, daySizeStyles), {
	            role: 'button' // eslint-disable-line jsx-a11y/no-noninteractive-element-to-interactive-role
	            , ref: this.setButtonRef,
	            'aria-label': ariaLabel,
	            onMouseEnter: function () {
	              function onMouseEnter(e) {
	                _this2.onDayMouseEnter(day, e);
	              }
	
	              return onMouseEnter;
	            }(),
	            onMouseLeave: function () {
	              function onMouseLeave(e) {
	                _this2.onDayMouseLeave(day, e);
	              }
	
	              return onMouseLeave;
	            }(),
	            onMouseUp: function () {
	              function onMouseUp(e) {
	                e.currentTarget.blur();
	              }
	
	              return onMouseUp;
	            }(),
	            onClick: function () {
	              function onClick(e) {
	                _this2.onDayClick(day, e);
	              }
	
	              return onClick;
	            }(),
	            onKeyDown: function () {
	              function onKeyDown(e) {
	                _this2.onKeyDown(day, e);
	              }
	
	              return onKeyDown;
	            }(),
	            tabIndex: tabIndex
	          }),
	          renderDayContents ? renderDayContents(day, modifiers) : day.format('D')
	        );
	      }
	
	      return render;
	    }()
	  }]);
	
	  return CalendarDay;
	}(_react2['default'].Component);
	
	CalendarDay.propTypes = propTypes;
	CalendarDay.defaultProps = defaultProps;
	
	exports.PureCalendarDay = CalendarDay;
	exports['default'] = (0, _reactWithStyles.withStyles)(function (_ref2) {
	  var _ref2$reactDates = _ref2.reactDates,
	      color = _ref2$reactDates.color,
	      font = _ref2$reactDates.font;
	  return {
	    CalendarDay: {
	      boxSizing: 'border-box',
	      cursor: 'pointer',
	      fontSize: font.size,
	      textAlign: 'center',
	
	      ':active': {
	        outline: 0
	      }
	    },
	
	    CalendarDay__defaultCursor: {
	      cursor: 'default'
	    },
	
	    CalendarDay__default: {
	      border: '1px solid ' + String(color.core.borderLight),
	      color: color.text,
	      background: color.background,
	
	      ':hover': {
	        background: color.core.borderLight,
	        border: '1px double ' + String(color.core.borderLight),
	        color: 'inherit'
	      }
	    },
	
	    CalendarDay__hovered_offset: {
	      background: color.core.borderBright,
	      border: '1px double ' + String(color.core.borderLight),
	      color: 'inherit'
	    },
	
	    CalendarDay__outside: {
	      border: 0,
	
	      background: color.outside.backgroundColor,
	      color: color.outside.color
	    },
	
	    CalendarDay__blocked_minimum_nights: {
	      background: color.minimumNights.backgroundColor,
	      border: '1px solid ' + String(color.minimumNights.borderColor),
	      color: color.minimumNights.color,
	
	      ':hover': {
	        background: color.minimumNights.backgroundColor_hover,
	        color: color.minimumNights.color_active
	      },
	
	      ':active': {
	        background: color.minimumNights.backgroundColor_active,
	        color: color.minimumNights.color_active
	      }
	    },
	
	    CalendarDay__highlighted_calendar: {
	      background: color.highlighted.backgroundColor,
	      color: color.highlighted.color,
	
	      ':hover': {
	        background: color.highlighted.backgroundColor_hover,
	        color: color.highlighted.color_active
	      },
	
	      ':active': {
	        background: color.highlighted.backgroundColor_active,
	        color: color.highlighted.color_active
	      }
	    },
	
	    CalendarDay__selected_span: {
	      background: color.selectedSpan.backgroundColor,
	      border: '1px solid ' + String(color.selectedSpan.borderColor),
	      color: color.selectedSpan.color,
	
	      ':hover': {
	        background: color.selectedSpan.backgroundColor_hover,
	        border: '1px solid ' + String(color.selectedSpan.borderColor),
	        color: color.selectedSpan.color_active
	      },
	
	      ':active': {
	        background: color.selectedSpan.backgroundColor_active,
	        border: '1px solid ' + String(color.selectedSpan.borderColor),
	        color: color.selectedSpan.color_active
	      }
	    },
	
	    CalendarDay__last_in_range: {
	      borderRight: color.core.primary
	    },
	
	    CalendarDay__selected: {
	      background: color.selected.backgroundColor,
	      border: '1px solid ' + String(color.selected.borderColor),
	      color: color.selected.color,
	
	      ':hover': {
	        background: color.selected.backgroundColor_hover,
	        border: '1px solid ' + String(color.selected.borderColor),
	        color: color.selected.color_active
	      },
	
	      ':active': {
	        background: color.selected.backgroundColor_active,
	        border: '1px solid ' + String(color.selected.borderColor),
	        color: color.selected.color_active
	      }
	    },
	
	    CalendarDay__hovered_span: {
	      background: color.hoveredSpan.backgroundColor,
	      border: '1px solid ' + String(color.hoveredSpan.borderColor),
	      color: color.hoveredSpan.color,
	
	      ':hover': {
	        background: color.hoveredSpan.backgroundColor_hover,
	        border: '1px solid ' + String(color.hoveredSpan.borderColor),
	        color: color.hoveredSpan.color_active
	      },
	
	      ':active': {
	        background: color.hoveredSpan.backgroundColor_active,
	        border: '1px solid ' + String(color.hoveredSpan.borderColor),
	        color: color.hoveredSpan.color_active
	      }
	    },
	
	    CalendarDay__blocked_calendar: {
	      background: color.blocked_calendar.backgroundColor,
	      border: '1px solid ' + String(color.blocked_calendar.borderColor),
	      color: color.blocked_calendar.color,
	
	      ':hover': {
	        background: color.blocked_calendar.backgroundColor_hover,
	        border: '1px solid ' + String(color.blocked_calendar.borderColor),
	        color: color.blocked_calendar.color_active
	      },
	
	      ':active': {
	        background: color.blocked_calendar.backgroundColor_active,
	        border: '1px solid ' + String(color.blocked_calendar.borderColor),
	        color: color.blocked_calendar.color_active
	      }
	    },
	
	    CalendarDay__blocked_out_of_range: {
	      background: color.blocked_out_of_range.backgroundColor,
	      border: '1px solid ' + String(color.blocked_out_of_range.borderColor),
	      color: color.blocked_out_of_range.color,
	
	      ':hover': {
	        background: color.blocked_out_of_range.backgroundColor_hover,
	        border: '1px solid ' + String(color.blocked_out_of_range.borderColor),
	        color: color.blocked_out_of_range.color_active
	      },
	
	      ':active': {
	        background: color.blocked_out_of_range.backgroundColor_active,
	        border: '1px solid ' + String(color.blocked_out_of_range.borderColor),
	        color: color.blocked_out_of_range.color_active
	      }
	    },
	
	    CalendarDay__selected_start: {},
	    CalendarDay__selected_end: {},
	    CalendarDay__today: {},
	    CalendarDay__firstDayOfWeek: {},
	    CalendarDay__lastDayOfWeek: {}
	  };
	})(CalendarDay);

/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PureDayPicker = exports.defaultProps = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _object = __webpack_require__(55);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(27);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactAddonsShallowCompare = __webpack_require__(210);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _airbnbPropTypes = __webpack_require__(42);
	
	var _reactWithStyles = __webpack_require__(72);
	
	var _moment = __webpack_require__(9);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _throttle = __webpack_require__(756);
	
	var _throttle2 = _interopRequireDefault(_throttle);
	
	var _isTouchDevice = __webpack_require__(205);
	
	var _isTouchDevice2 = _interopRequireDefault(_isTouchDevice);
	
	var _defaultPhrases = __webpack_require__(50);
	
	var _getPhrasePropTypes = __webpack_require__(63);
	
	var _getPhrasePropTypes2 = _interopRequireDefault(_getPhrasePropTypes);
	
	var _OutsideClickHandler = __webpack_require__(338);
	
	var _OutsideClickHandler2 = _interopRequireDefault(_OutsideClickHandler);
	
	var _CalendarMonthGrid = __webpack_require__(850);
	
	var _CalendarMonthGrid2 = _interopRequireDefault(_CalendarMonthGrid);
	
	var _DayPickerNavigation = __webpack_require__(2974);
	
	var _DayPickerNavigation2 = _interopRequireDefault(_DayPickerNavigation);
	
	var _DayPickerKeyboardShortcuts = __webpack_require__(2973);
	
	var _DayPickerKeyboardShortcuts2 = _interopRequireDefault(_DayPickerKeyboardShortcuts);
	
	var _getCalendarMonthWidth = __webpack_require__(868);
	
	var _getCalendarMonthWidth2 = _interopRequireDefault(_getCalendarMonthWidth);
	
	var _calculateDimension = __webpack_require__(865);
	
	var _calculateDimension2 = _interopRequireDefault(_calculateDimension);
	
	var _getActiveElement = __webpack_require__(2979);
	
	var _getActiveElement2 = _interopRequireDefault(_getActiveElement);
	
	var _isDayVisible = __webpack_require__(474);
	
	var _isDayVisible2 = _interopRequireDefault(_isDayVisible);
	
	var _ScrollableOrientationShape = __webpack_require__(212);
	
	var _ScrollableOrientationShape2 = _interopRequireDefault(_ScrollableOrientationShape);
	
	var _DayOfWeekShape = __webpack_require__(165);
	
	var _DayOfWeekShape2 = _interopRequireDefault(_DayOfWeekShape);
	
	var _CalendarInfoPositionShape = __webpack_require__(260);
	
	var _CalendarInfoPositionShape2 = _interopRequireDefault(_CalendarInfoPositionShape);
	
	var _constants = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MONTH_PADDING = 23;
	var DAY_PICKER_PADDING = 9;
	var PREV_TRANSITION = 'prev';
	var NEXT_TRANSITION = 'next';
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)((0, _object2['default'])({}, _reactWithStyles.withStylesPropTypes, {
	
	  // calendar presentation props
	  enableOutsideDays: _propTypes2['default'].bool,
	  numberOfMonths: _propTypes2['default'].number,
	  orientation: _ScrollableOrientationShape2['default'],
	  withPortal: _propTypes2['default'].bool,
	  onOutsideClick: _propTypes2['default'].func,
	  hidden: _propTypes2['default'].bool,
	  initialVisibleMonth: _propTypes2['default'].func,
	  firstDayOfWeek: _DayOfWeekShape2['default'],
	  renderCalendarInfo: _propTypes2['default'].func,
	  calendarInfoPosition: _CalendarInfoPositionShape2['default'],
	  hideKeyboardShortcutsPanel: _propTypes2['default'].bool,
	  daySize: _airbnbPropTypes.nonNegativeInteger,
	  isRTL: _propTypes2['default'].bool,
	  verticalHeight: _airbnbPropTypes.nonNegativeInteger,
	  noBorder: _propTypes2['default'].bool,
	  transitionDuration: _airbnbPropTypes.nonNegativeInteger,
	  verticalBorderSpacing: _airbnbPropTypes.nonNegativeInteger,
	
	  // navigation props
	  navPrev: _propTypes2['default'].node,
	  navNext: _propTypes2['default'].node,
	  noNavButtons: _propTypes2['default'].bool,
	  onPrevMonthClick: _propTypes2['default'].func,
	  onNextMonthClick: _propTypes2['default'].func,
	  onMultiplyScrollableMonths: _propTypes2['default'].func, // VERTICAL_SCROLLABLE daypickers only
	
	  // month props
	  renderMonth: _propTypes2['default'].func,
	
	  // day props
	  modifiers: _propTypes2['default'].object,
	  renderCalendarDay: _propTypes2['default'].func,
	  renderDayContents: _propTypes2['default'].func,
	  onDayClick: _propTypes2['default'].func,
	  onDayMouseEnter: _propTypes2['default'].func,
	  onDayMouseLeave: _propTypes2['default'].func,
	
	  // accessibility props
	  isFocused: _propTypes2['default'].bool,
	  getFirstFocusableDay: _propTypes2['default'].func,
	  onBlur: _propTypes2['default'].func,
	  showKeyboardShortcuts: _propTypes2['default'].bool,
	
	  // internationalization
	  monthFormat: _propTypes2['default'].string,
	  weekDayFormat: _propTypes2['default'].string,
	  phrases: _propTypes2['default'].shape((0, _getPhrasePropTypes2['default'])(_defaultPhrases.DayPickerPhrases)),
	  dayAriaLabelFormat: _propTypes2['default'].string
	}));
	
	var defaultProps = exports.defaultProps = {
	  // calendar presentation props
	  enableOutsideDays: false,
	  numberOfMonths: 2,
	  orientation: _constants.HORIZONTAL_ORIENTATION,
	  withPortal: false,
	  onOutsideClick: function () {
	    function onOutsideClick() {}
	
	    return onOutsideClick;
	  }(),
	
	  hidden: false,
	  initialVisibleMonth: function () {
	    function initialVisibleMonth() {
	      return (0, _moment2['default'])();
	    }
	
	    return initialVisibleMonth;
	  }(),
	  firstDayOfWeek: null,
	  renderCalendarInfo: null,
	  calendarInfoPosition: _constants.INFO_POSITION_BOTTOM,
	  hideKeyboardShortcutsPanel: false,
	  daySize: _constants.DAY_SIZE,
	  isRTL: false,
	  verticalHeight: null,
	  noBorder: false,
	  transitionDuration: undefined,
	  verticalBorderSpacing: undefined,
	
	  // navigation props
	  navPrev: null,
	  navNext: null,
	  noNavButtons: false,
	  onPrevMonthClick: function () {
	    function onPrevMonthClick() {}
	
	    return onPrevMonthClick;
	  }(),
	  onNextMonthClick: function () {
	    function onNextMonthClick() {}
	
	    return onNextMonthClick;
	  }(),
	  onMultiplyScrollableMonths: function () {
	    function onMultiplyScrollableMonths() {}
	
	    return onMultiplyScrollableMonths;
	  }(),
	
	
	  // month props
	  renderMonth: null,
	
	  // day props
	  modifiers: {},
	  renderCalendarDay: undefined,
	  renderDayContents: null,
	  onDayClick: function () {
	    function onDayClick() {}
	
	    return onDayClick;
	  }(),
	  onDayMouseEnter: function () {
	    function onDayMouseEnter() {}
	
	    return onDayMouseEnter;
	  }(),
	  onDayMouseLeave: function () {
	    function onDayMouseLeave() {}
	
	    return onDayMouseLeave;
	  }(),
	
	
	  // accessibility props
	  isFocused: false,
	  getFirstFocusableDay: null,
	  onBlur: function () {
	    function onBlur() {}
	
	    return onBlur;
	  }(),
	
	  showKeyboardShortcuts: false,
	
	  // internationalization
	  monthFormat: 'MMMM YYYY',
	  weekDayFormat: 'dd',
	  phrases: _defaultPhrases.DayPickerPhrases,
	  dayAriaLabelFormat: undefined
	};
	
	var DayPicker = function (_React$Component) {
	  _inherits(DayPicker, _React$Component);
	
	  function DayPicker(props) {
	    _classCallCheck(this, DayPicker);
	
	    var _this = _possibleConstructorReturn(this, (DayPicker.__proto__ || Object.getPrototypeOf(DayPicker)).call(this, props));
	
	    var currentMonth = props.hidden ? (0, _moment2['default'])() : props.initialVisibleMonth();
	
	    var focusedDate = currentMonth.clone().startOf('month');
	    if (props.getFirstFocusableDay) {
	      focusedDate = props.getFirstFocusableDay(currentMonth);
	    }
	
	    var translationValue = props.isRTL && _this.isHorizontal() ? -(0, _getCalendarMonthWidth2['default'])(props.daySize) : 0;
	
	    _this.hasSetInitialVisibleMonth = !props.hidden;
	    _this.state = {
	      currentMonth: currentMonth,
	      monthTransition: null,
	      translationValue: translationValue,
	      scrollableMonthMultiple: 1,
	      calendarMonthWidth: (0, _getCalendarMonthWidth2['default'])(props.daySize),
	      focusedDate: !props.hidden || props.isFocused ? focusedDate : null,
	      nextFocusedDate: null,
	      showKeyboardShortcuts: props.showKeyboardShortcuts,
	      onKeyboardShortcutsPanelClose: function () {
	        function onKeyboardShortcutsPanelClose() {}
	
	        return onKeyboardShortcutsPanelClose;
	      }(),
	
	      isTouchDevice: (0, _isTouchDevice2['default'])(),
	      withMouseInteractions: true,
	      hasSetHeight: false,
	      calendarInfoWidth: 0
	    };
	
	    _this.calendarMonthHeights = [];
	    _this.calendarMonthGridHeight = 0;
	    _this.setCalendarInfoWidthTimeout = null;
	
	    _this.onKeyDown = _this.onKeyDown.bind(_this);
	    _this.throttledKeyDown = (0, _throttle2['default'])(_this.onFinalKeyDown, 200, { trailing: false });
	    _this.onPrevMonthClick = _this.onPrevMonthClick.bind(_this);
	    _this.onNextMonthClick = _this.onNextMonthClick.bind(_this);
	    _this.multiplyScrollableMonths = _this.multiplyScrollableMonths.bind(_this);
	    _this.updateStateAfterMonthTransition = _this.updateStateAfterMonthTransition.bind(_this);
	
	    _this.openKeyboardShortcutsPanel = _this.openKeyboardShortcutsPanel.bind(_this);
	    _this.closeKeyboardShortcutsPanel = _this.closeKeyboardShortcutsPanel.bind(_this);
	
	    _this.setCalendarInfoRef = _this.setCalendarInfoRef.bind(_this);
	    _this.setContainerRef = _this.setContainerRef.bind(_this);
	    _this.setTransitionContainerRef = _this.setTransitionContainerRef.bind(_this);
	    _this.setCalendarMonthHeights = _this.setCalendarMonthHeights.bind(_this);
	    return _this;
	  }
	
	  _createClass(DayPicker, [{
	    key: 'componentDidMount',
	    value: function () {
	      function componentDidMount() {
	        if (this.calendarInfo) {
	          this.setState({
	            isTouchDevice: (0, _isTouchDevice2['default'])(),
	            calendarInfoWidth: (0, _calculateDimension2['default'])(this.calendarInfo, 'width', true, true)
	          });
	        } else {
	          this.setState({ isTouchDevice: (0, _isTouchDevice2['default'])() });
	        }
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function () {
	      function componentWillReceiveProps(nextProps) {
	        var hidden = nextProps.hidden,
	            isFocused = nextProps.isFocused,
	            showKeyboardShortcuts = nextProps.showKeyboardShortcuts,
	            onBlur = nextProps.onBlur;
	        var currentMonth = this.state.currentMonth;
	
	
	        if (!hidden) {
	          if (!this.hasSetInitialVisibleMonth) {
	            this.hasSetInitialVisibleMonth = true;
	            this.setState({
	              currentMonth: nextProps.initialVisibleMonth()
	            });
	          }
	        }
	
	        if (nextProps.daySize !== this.props.daySize) {
	          this.setState({
	            calendarMonthWidth: (0, _getCalendarMonthWidth2['default'])(nextProps.daySize)
	          });
	        }
	
	        if (isFocused !== this.props.isFocused) {
	          if (isFocused) {
	            var focusedDate = this.getFocusedDay(currentMonth);
	
	            var onKeyboardShortcutsPanelClose = this.state.onKeyboardShortcutsPanelClose;
	
	            if (nextProps.showKeyboardShortcuts) {
	              // the ? shortcut came from the input and we should return input there once it is close
	              onKeyboardShortcutsPanelClose = onBlur;
	            }
	
	            this.setState({
	              showKeyboardShortcuts: showKeyboardShortcuts,
	              onKeyboardShortcutsPanelClose: onKeyboardShortcutsPanelClose,
	              focusedDate: focusedDate,
	              withMouseInteractions: false
	            });
	          } else {
	            this.setState({ focusedDate: null });
	          }
	        }
	      }
	
	      return componentWillReceiveProps;
	    }()
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function () {
	      function shouldComponentUpdate(nextProps, nextState) {
	        return (0, _reactAddonsShallowCompare2['default'])(this, nextProps, nextState);
	      }
	
	      return shouldComponentUpdate;
	    }()
	  }, {
	    key: 'componentWillUpdate',
	    value: function () {
	      function componentWillUpdate() {
	        var _this2 = this;
	
	        var transitionDuration = this.props.transitionDuration;
	        // Calculating the dimensions trigger a DOM repaint which
	        // breaks the CSS transition.
	        // The setTimeout will wait until the transition ends.
	
	        if (this.calendarInfo) {
	          var calendarInfoWidth = this.state.calendarInfoWidth;
	
	          this.setCalendarInfoWidthTimeout = setTimeout(function () {
	            var calendarInfoPanelWidth = (0, _calculateDimension2['default'])(_this2.calendarInfo, 'width', true, true);
	            if (calendarInfoWidth !== calendarInfoPanelWidth) {
	              _this2.setState({
	                calendarInfoWidth: calendarInfoPanelWidth
	              });
	            }
	          }, transitionDuration);
	        }
	      }
	
	      return componentWillUpdate;
	    }()
	  }, {
	    key: 'componentDidUpdate',
	    value: function () {
	      function componentDidUpdate(prevProps) {
	        var isFocused = this.props.isFocused;
	        var focusedDate = this.state.focusedDate;
	
	
	        if (!prevProps.isFocused && isFocused && !focusedDate) {
	          this.container.focus();
	        }
	      }
	
	      return componentDidUpdate;
	    }()
	  }, {
	    key: 'componentWillUnmount',
	    value: function () {
	      function componentWillUnmount() {
	        clearTimeout(this.setCalendarInfoWidthTimeout);
	      }
	
	      return componentWillUnmount;
	    }()
	  }, {
	    key: 'onKeyDown',
	    value: function () {
	      function onKeyDown(e) {
	        e.stopPropagation();
	        if (!_constants.MODIFIER_KEY_NAMES.has(e.key)) {
	          this.throttledKeyDown(e);
	        }
	      }
	
	      return onKeyDown;
	    }()
	  }, {
	    key: 'onFinalKeyDown',
	    value: function () {
	      function onFinalKeyDown(e) {
	        this.setState({ withMouseInteractions: false });
	
	        var _props = this.props,
	            onBlur = _props.onBlur,
	            isRTL = _props.isRTL;
	        var _state = this.state,
	            focusedDate = _state.focusedDate,
	            showKeyboardShortcuts = _state.showKeyboardShortcuts;
	
	        if (!focusedDate) return;
	
	        var newFocusedDate = focusedDate.clone();
	
	        var didTransitionMonth = false;
	
	        // focus might be anywhere when the keyboard shortcuts panel is opened so we want to
	        // return it to wherever it was before when the panel was opened
	        var activeElement = (0, _getActiveElement2['default'])();
	        var onKeyboardShortcutsPanelClose = function () {
	          function onKeyboardShortcutsPanelClose() {
	            if (activeElement) activeElement.focus();
	          }
	
	          return onKeyboardShortcutsPanelClose;
	        }();
	
	        switch (e.key) {
	          case 'ArrowUp':
	            e.preventDefault();
	            newFocusedDate.subtract(1, 'week');
	            didTransitionMonth = this.maybeTransitionPrevMonth(newFocusedDate);
	            break;
	          case 'ArrowLeft':
	            e.preventDefault();
	            if (isRTL) {
	              newFocusedDate.add(1, 'day');
	            } else {
	              newFocusedDate.subtract(1, 'day');
	            }
	            didTransitionMonth = this.maybeTransitionPrevMonth(newFocusedDate);
	            break;
	          case 'Home':
	            e.preventDefault();
	            newFocusedDate.startOf('week');
	            didTransitionMonth = this.maybeTransitionPrevMonth(newFocusedDate);
	            break;
	          case 'PageUp':
	            e.preventDefault();
	            newFocusedDate.subtract(1, 'month');
	            didTransitionMonth = this.maybeTransitionPrevMonth(newFocusedDate);
	            break;
	
	          case 'ArrowDown':
	            e.preventDefault();
	            newFocusedDate.add(1, 'week');
	            didTransitionMonth = this.maybeTransitionNextMonth(newFocusedDate);
	            break;
	          case 'ArrowRight':
	            e.preventDefault();
	            if (isRTL) {
	              newFocusedDate.subtract(1, 'day');
	            } else {
	              newFocusedDate.add(1, 'day');
	            }
	            didTransitionMonth = this.maybeTransitionNextMonth(newFocusedDate);
	            break;
	          case 'End':
	            e.preventDefault();
	            newFocusedDate.endOf('week');
	            didTransitionMonth = this.maybeTransitionNextMonth(newFocusedDate);
	            break;
	          case 'PageDown':
	            e.preventDefault();
	            newFocusedDate.add(1, 'month');
	            didTransitionMonth = this.maybeTransitionNextMonth(newFocusedDate);
	            break;
	
	          case '?':
	            this.openKeyboardShortcutsPanel(onKeyboardShortcutsPanelClose);
	            break;
	
	          case 'Escape':
	            if (showKeyboardShortcuts) {
	              this.closeKeyboardShortcutsPanel();
	            } else {
	              onBlur();
	            }
	            break;
	
	          default:
	            break;
	        }
	
	        // If there was a month transition, do not update the focused date until the transition has
	        // completed. Otherwise, attempting to focus on a DOM node may interrupt the CSS animation. If
	        // didTransitionMonth is true, the focusedDate gets updated in #updateStateAfterMonthTransition
	        if (!didTransitionMonth) {
	          this.setState({
	            focusedDate: newFocusedDate
	          });
	        }
	      }
	
	      return onFinalKeyDown;
	    }()
	  }, {
	    key: 'onPrevMonthClick',
	    value: function () {
	      function onPrevMonthClick(nextFocusedDate, e) {
	        var _props2 = this.props,
	            numberOfMonths = _props2.numberOfMonths,
	            isRTL = _props2.isRTL;
	        var calendarMonthWidth = this.state.calendarMonthWidth;
	
	
	        if (e) e.preventDefault();
	
	        var translationValue = this.isVertical() ? this.calendarMonthHeights[0] : calendarMonthWidth;
	
	        if (this.isHorizontal()) {
	          if (isRTL) {
	            translationValue = -2 * calendarMonthWidth;
	          }
	
	          var newMonthHeight = Math.max.apply(Math, [0].concat(_toConsumableArray(this.calendarMonthHeights.slice(0, numberOfMonths))));
	          this.adjustDayPickerHeight(newMonthHeight);
	        }
	
	        this.setState({
	          monthTransition: PREV_TRANSITION,
	          translationValue: translationValue,
	          focusedDate: null,
	          nextFocusedDate: nextFocusedDate
	        });
	      }
	
	      return onPrevMonthClick;
	    }()
	  }, {
	    key: 'onNextMonthClick',
	    value: function () {
	      function onNextMonthClick(nextFocusedDate, e) {
	        var isRTL = this.props.isRTL;
	        var calendarMonthWidth = this.state.calendarMonthWidth;
	
	
	        if (e) e.preventDefault();
	
	        var translationValue = this.isVertical() ? -this.calendarMonthHeights[1] : -calendarMonthWidth;
	
	        if (this.isHorizontal()) {
	          if (isRTL) {
	            translationValue = 0;
	          }
	          var newMonthHeight = Math.max.apply(Math, [0].concat(_toConsumableArray(this.calendarMonthHeights.slice(2))));
	          this.adjustDayPickerHeight(newMonthHeight);
	        }
	
	        this.setState({
	          monthTransition: NEXT_TRANSITION,
	          translationValue: translationValue,
	          focusedDate: null,
	          nextFocusedDate: nextFocusedDate
	        });
	      }
	
	      return onNextMonthClick;
	    }()
	  }, {
	    key: 'getFirstVisibleIndex',
	    value: function () {
	      function getFirstVisibleIndex() {
	        var orientation = this.props.orientation;
	        var monthTransition = this.state.monthTransition;
	
	
	        if (orientation === _constants.VERTICAL_SCROLLABLE) return 0;
	
	        var firstVisibleMonthIndex = 1;
	        if (monthTransition === PREV_TRANSITION) {
	          firstVisibleMonthIndex -= 1;
	        } else if (monthTransition === NEXT_TRANSITION) {
	          firstVisibleMonthIndex += 1;
	        }
	
	        return firstVisibleMonthIndex;
	      }
	
	      return getFirstVisibleIndex;
	    }()
	  }, {
	    key: 'getFocusedDay',
	    value: function () {
	      function getFocusedDay(newMonth) {
	        var _props3 = this.props,
	            getFirstFocusableDay = _props3.getFirstFocusableDay,
	            numberOfMonths = _props3.numberOfMonths;
	
	
	        var focusedDate = void 0;
	        if (getFirstFocusableDay) {
	          focusedDate = getFirstFocusableDay(newMonth);
	        }
	
	        if (newMonth && (!focusedDate || !(0, _isDayVisible2['default'])(focusedDate, newMonth, numberOfMonths))) {
	          focusedDate = newMonth.clone().startOf('month');
	        }
	
	        return focusedDate;
	      }
	
	      return getFocusedDay;
	    }()
	  }, {
	    key: 'setCalendarMonthHeights',
	    value: function () {
	      function setCalendarMonthHeights(calendarMonthHeights) {
	        var numberOfMonths = this.props.numberOfMonths;
	
	        var firstVisibleMonthIndex = this.getFirstVisibleIndex();
	        var lastVisibleMonthIndex = firstVisibleMonthIndex + numberOfMonths;
	
	        this.calendarMonthHeights = calendarMonthHeights;
	        var visibleCalendarMonthHeights = calendarMonthHeights.filter(function (_, i) {
	          return i >= firstVisibleMonthIndex && i < lastVisibleMonthIndex;
	        });
	        this.calendarMonthGridHeight = Math.max.apply(Math, [0].concat(_toConsumableArray(visibleCalendarMonthHeights))) + MONTH_PADDING;
	        this.setState({ hasSetHeight: true });
	      }
	
	      return setCalendarMonthHeights;
	    }()
	  }, {
	    key: 'setContainerRef',
	    value: function () {
	      function setContainerRef(ref) {
	        this.container = ref;
	      }
	
	      return setContainerRef;
	    }()
	  }, {
	    key: 'setCalendarInfoRef',
	    value: function () {
	      function setCalendarInfoRef(ref) {
	        this.calendarInfo = ref;
	      }
	
	      return setCalendarInfoRef;
	    }()
	  }, {
	    key: 'setTransitionContainerRef',
	    value: function () {
	      function setTransitionContainerRef(ref) {
	        this.transitionContainer = ref;
	      }
	
	      return setTransitionContainerRef;
	    }()
	  }, {
	    key: 'maybeTransitionNextMonth',
	    value: function () {
	      function maybeTransitionNextMonth(newFocusedDate) {
	        var numberOfMonths = this.props.numberOfMonths;
	        var _state2 = this.state,
	            currentMonth = _state2.currentMonth,
	            focusedDate = _state2.focusedDate;
	
	
	        var newFocusedDateMonth = newFocusedDate.month();
	        var focusedDateMonth = focusedDate.month();
	        var isNewFocusedDateVisible = (0, _isDayVisible2['default'])(newFocusedDate, currentMonth, numberOfMonths);
	        if (newFocusedDateMonth !== focusedDateMonth && !isNewFocusedDateVisible) {
	          this.onNextMonthClick(newFocusedDate);
	          return true;
	        }
	
	        return false;
	      }
	
	      return maybeTransitionNextMonth;
	    }()
	  }, {
	    key: 'maybeTransitionPrevMonth',
	    value: function () {
	      function maybeTransitionPrevMonth(newFocusedDate) {
	        var numberOfMonths = this.props.numberOfMonths;
	        var _state3 = this.state,
	            currentMonth = _state3.currentMonth,
	            focusedDate = _state3.focusedDate;
	
	
	        var newFocusedDateMonth = newFocusedDate.month();
	        var focusedDateMonth = focusedDate.month();
	        var isNewFocusedDateVisible = (0, _isDayVisible2['default'])(newFocusedDate, currentMonth, numberOfMonths);
	        if (newFocusedDateMonth !== focusedDateMonth && !isNewFocusedDateVisible) {
	          this.onPrevMonthClick(newFocusedDate);
	          return true;
	        }
	
	        return false;
	      }
	
	      return maybeTransitionPrevMonth;
	    }()
	  }, {
	    key: 'multiplyScrollableMonths',
	    value: function () {
	      function multiplyScrollableMonths(e) {
	        var onMultiplyScrollableMonths = this.props.onMultiplyScrollableMonths;
	
	        if (e) e.preventDefault();
	
	        if (onMultiplyScrollableMonths) onMultiplyScrollableMonths(e);
	
	        this.setState({
	          scrollableMonthMultiple: this.state.scrollableMonthMultiple + 1
	        });
	      }
	
	      return multiplyScrollableMonths;
	    }()
	  }, {
	    key: 'isHorizontal',
	    value: function () {
	      function isHorizontal() {
	        var orientation = this.props.orientation;
	
	        return orientation === _constants.HORIZONTAL_ORIENTATION;
	      }
	
	      return isHorizontal;
	    }()
	  }, {
	    key: 'isVertical',
	    value: function () {
	      function isVertical() {
	        var orientation = this.props.orientation;
	
	        return orientation === _constants.VERTICAL_ORIENTATION || orientation === _constants.VERTICAL_SCROLLABLE;
	      }
	
	      return isVertical;
	    }()
	  }, {
	    key: 'updateStateAfterMonthTransition',
	    value: function () {
	      function updateStateAfterMonthTransition() {
	        var _this3 = this;
	
	        var _props4 = this.props,
	            onPrevMonthClick = _props4.onPrevMonthClick,
	            onNextMonthClick = _props4.onNextMonthClick,
	            isRTL = _props4.isRTL;
	        var _state4 = this.state,
	            currentMonth = _state4.currentMonth,
	            monthTransition = _state4.monthTransition,
	            focusedDate = _state4.focusedDate,
	            nextFocusedDate = _state4.nextFocusedDate,
	            withMouseInteractions = _state4.withMouseInteractions,
	            calendarMonthWidth = _state4.calendarMonthWidth;
	
	
	        if (!monthTransition) return;
	
	        var newMonth = currentMonth.clone();
	        if (monthTransition === PREV_TRANSITION) {
	          if (onPrevMonthClick) onPrevMonthClick();
	          newMonth.subtract(1, 'month');
	        } else if (monthTransition === NEXT_TRANSITION) {
	          if (onNextMonthClick) onNextMonthClick();
	          newMonth.add(1, 'month');
	        }
	
	        var newFocusedDate = null;
	        if (nextFocusedDate) {
	          newFocusedDate = nextFocusedDate;
	        } else if (!focusedDate && !withMouseInteractions) {
	          newFocusedDate = this.getFocusedDay(newMonth);
	        }
	
	        this.setState({
	          currentMonth: newMonth,
	          monthTransition: null,
	          translationValue: isRTL && this.isHorizontal() ? -calendarMonthWidth : 0,
	          nextFocusedDate: null,
	          focusedDate: newFocusedDate
	        }, function () {
	          // we don't want to focus on the relevant calendar day after a month transition
	          // if the user is navigating around using a mouse
	          if (withMouseInteractions) {
	            var activeElement = (0, _getActiveElement2['default'])();
	            if (activeElement && activeElement !== document.body && _this3.container.contains(activeElement)) {
	              activeElement.blur();
	            }
	          }
	        });
	      }
	
	      return updateStateAfterMonthTransition;
	    }()
	  }, {
	    key: 'adjustDayPickerHeight',
	    value: function () {
	      function adjustDayPickerHeight(newMonthHeight) {
	        var monthHeight = newMonthHeight + MONTH_PADDING;
	        if (monthHeight !== this.calendarMonthGridHeight) {
	          this.calendarMonthGridHeight = monthHeight;
	          this.transitionContainer.style.height = String(monthHeight) + 'px';
	        }
	      }
	
	      return adjustDayPickerHeight;
	    }()
	  }, {
	    key: 'openKeyboardShortcutsPanel',
	    value: function () {
	      function openKeyboardShortcutsPanel(onCloseCallBack) {
	        this.setState({
	          showKeyboardShortcuts: true,
	          onKeyboardShortcutsPanelClose: onCloseCallBack
	        });
	      }
	
	      return openKeyboardShortcutsPanel;
	    }()
	  }, {
	    key: 'closeKeyboardShortcutsPanel',
	    value: function () {
	      function closeKeyboardShortcutsPanel() {
	        var onKeyboardShortcutsPanelClose = this.state.onKeyboardShortcutsPanelClose;
	
	
	        if (onKeyboardShortcutsPanelClose) {
	          onKeyboardShortcutsPanelClose();
	        }
	
	        this.setState({
	          onKeyboardShortcutsPanelClose: null,
	          showKeyboardShortcuts: false
	        });
	      }
	
	      return closeKeyboardShortcutsPanel;
	    }()
	  }, {
	    key: 'renderNavigation',
	    value: function () {
	      function renderNavigation() {
	        var _this4 = this;
	
	        var _props5 = this.props,
	            navPrev = _props5.navPrev,
	            navNext = _props5.navNext,
	            noNavButtons = _props5.noNavButtons,
	            orientation = _props5.orientation,
	            phrases = _props5.phrases,
	            isRTL = _props5.isRTL;
	
	
	        if (noNavButtons) {
	          return null;
	        }
	
	        var onNextMonthClick = void 0;
	        if (orientation === _constants.VERTICAL_SCROLLABLE) {
	          onNextMonthClick = this.multiplyScrollableMonths;
	        } else {
	          onNextMonthClick = function () {
	            function onNextMonthClick(e) {
	              _this4.onNextMonthClick(null, e);
	            }
	
	            return onNextMonthClick;
	          }();
	        }
	
	        return _react2['default'].createElement(_DayPickerNavigation2['default'], {
	          onPrevMonthClick: function () {
	            function onPrevMonthClick(e) {
	              _this4.onPrevMonthClick(null, e);
	            }
	
	            return onPrevMonthClick;
	          }(),
	          onNextMonthClick: onNextMonthClick,
	          navPrev: navPrev,
	          navNext: navNext,
	          orientation: orientation,
	          phrases: phrases,
	          isRTL: isRTL
	        });
	      }
	
	      return renderNavigation;
	    }()
	  }, {
	    key: 'renderWeekHeader',
	    value: function () {
	      function renderWeekHeader(index) {
	        var _props6 = this.props,
	            daySize = _props6.daySize,
	            orientation = _props6.orientation,
	            weekDayFormat = _props6.weekDayFormat,
	            styles = _props6.styles;
	        var calendarMonthWidth = this.state.calendarMonthWidth;
	
	        var verticalScrollable = orientation === _constants.VERTICAL_SCROLLABLE;
	        var horizontalStyle = {
	          left: index * calendarMonthWidth
	        };
	        var verticalStyle = {
	          marginLeft: -calendarMonthWidth / 2
	        };
	
	        var weekHeaderStyle = {}; // no styles applied to the vertical-scrollable orientation
	        if (this.isHorizontal()) {
	          weekHeaderStyle = horizontalStyle;
	        } else if (this.isVertical() && !verticalScrollable) {
	          weekHeaderStyle = verticalStyle;
	        }
	
	        var firstDayOfWeek = this.props.firstDayOfWeek;
	
	        if (firstDayOfWeek == null) {
	          firstDayOfWeek = _moment2['default'].localeData().firstDayOfWeek();
	        }
	
	        var header = [];
	        for (var i = 0; i < 7; i += 1) {
	          header.push(_react2['default'].createElement(
	            'li',
	            _extends({ key: i }, (0, _reactWithStyles.css)(styles.DayPicker_weekHeader_li, { width: daySize })),
	            _react2['default'].createElement(
	              'small',
	              null,
	              (0, _moment2['default'])().day((i + firstDayOfWeek) % 7).format(weekDayFormat)
	            )
	          ));
	        }
	
	        return _react2['default'].createElement(
	          'div',
	          _extends({}, (0, _reactWithStyles.css)(styles.DayPicker_weekHeader, this.isVertical() && styles.DayPicker_weekHeader__vertical, verticalScrollable && styles.DayPicker_weekHeader__verticalScrollable, weekHeaderStyle), {
	            key: 'week-' + String(index)
	          }),
	          _react2['default'].createElement(
	            'ul',
	            (0, _reactWithStyles.css)(styles.DayPicker_weekHeader_ul),
	            header
	          )
	        );
	      }
	
	      return renderWeekHeader;
	    }()
	  }, {
	    key: 'render',
	    value: function () {
	      function render() {
	        var _this5 = this;
	
	        var _state5 = this.state,
	            calendarMonthWidth = _state5.calendarMonthWidth,
	            currentMonth = _state5.currentMonth,
	            monthTransition = _state5.monthTransition,
	            translationValue = _state5.translationValue,
	            scrollableMonthMultiple = _state5.scrollableMonthMultiple,
	            focusedDate = _state5.focusedDate,
	            showKeyboardShortcuts = _state5.showKeyboardShortcuts,
	            isTouch = _state5.isTouchDevice,
	            hasSetHeight = _state5.hasSetHeight,
	            calendarInfoWidth = _state5.calendarInfoWidth;
	        var _props7 = this.props,
	            enableOutsideDays = _props7.enableOutsideDays,
	            numberOfMonths = _props7.numberOfMonths,
	            orientation = _props7.orientation,
	            modifiers = _props7.modifiers,
	            withPortal = _props7.withPortal,
	            onDayClick = _props7.onDayClick,
	            onDayMouseEnter = _props7.onDayMouseEnter,
	            onDayMouseLeave = _props7.onDayMouseLeave,
	            firstDayOfWeek = _props7.firstDayOfWeek,
	            renderMonth = _props7.renderMonth,
	            renderCalendarDay = _props7.renderCalendarDay,
	            renderDayContents = _props7.renderDayContents,
	            renderCalendarInfo = _props7.renderCalendarInfo,
	            calendarInfoPosition = _props7.calendarInfoPosition,
	            hideKeyboardShortcutsPanel = _props7.hideKeyboardShortcutsPanel,
	            onOutsideClick = _props7.onOutsideClick,
	            monthFormat = _props7.monthFormat,
	            daySize = _props7.daySize,
	            isFocused = _props7.isFocused,
	            isRTL = _props7.isRTL,
	            styles = _props7.styles,
	            phrases = _props7.phrases,
	            verticalHeight = _props7.verticalHeight,
	            dayAriaLabelFormat = _props7.dayAriaLabelFormat,
	            noBorder = _props7.noBorder,
	            transitionDuration = _props7.transitionDuration,
	            verticalBorderSpacing = _props7.verticalBorderSpacing;
	
	
	        var isHorizontal = this.isHorizontal();
	
	        var numOfWeekHeaders = this.isVertical() ? 1 : numberOfMonths;
	        var weekHeaders = [];
	        for (var i = 0; i < numOfWeekHeaders; i += 1) {
	          weekHeaders.push(this.renderWeekHeader(i));
	        }
	
	        var verticalScrollable = orientation === _constants.VERTICAL_SCROLLABLE;
	        var height = void 0;
	        if (isHorizontal) {
	          height = this.calendarMonthGridHeight;
	        } else if (this.isVertical() && !verticalScrollable && !withPortal) {
	          // If the user doesn't set a desired height,
	          // we default back to this kind of made-up value that generally looks good
	          height = verticalHeight || 1.75 * calendarMonthWidth;
	        }
	
	        var isCalendarMonthGridAnimating = monthTransition !== null;
	        var transformType = this.isVertical() ? 'translateY' : 'translateX';
	        var transformValue = transformType + '(' + String(translationValue) + 'px)';
	
	        var shouldFocusDate = !isCalendarMonthGridAnimating && isFocused;
	
	        var keyboardShortcutButtonLocation = _DayPickerKeyboardShortcuts.BOTTOM_RIGHT;
	        if (this.isVertical()) {
	          keyboardShortcutButtonLocation = withPortal ? _DayPickerKeyboardShortcuts.TOP_LEFT : _DayPickerKeyboardShortcuts.TOP_RIGHT;
	        }
	
	        var isHorizontalAndAnimating = isHorizontal && isCalendarMonthGridAnimating;
	
	        var calendarInfoPositionTop = calendarInfoPosition === _constants.INFO_POSITION_TOP;
	        var calendarInfoPositionBottom = calendarInfoPosition === _constants.INFO_POSITION_BOTTOM;
	        var calendarInfoPositionBefore = calendarInfoPosition === _constants.INFO_POSITION_BEFORE;
	        var calendarInfoPositionAfter = calendarInfoPosition === _constants.INFO_POSITION_AFTER;
	        var calendarInfoIsInline = calendarInfoPositionBefore || calendarInfoPositionAfter;
	
	        var calendarInfo = renderCalendarInfo && _react2['default'].createElement(
	          'div',
	          _extends({
	            ref: this.setCalendarInfoRef
	          }, (0, _reactWithStyles.css)(calendarInfoIsInline && styles.DayPicker_calendarInfo__horizontal)),
	          renderCalendarInfo()
	        );
	
	        var calendarInfoPanelWidth = renderCalendarInfo && calendarInfoIsInline ? calendarInfoWidth : 0;
	
	        var firstVisibleMonthIndex = this.getFirstVisibleIndex();
	        var wrapperHorizontalWidth = calendarMonthWidth * numberOfMonths + 2 * DAY_PICKER_PADDING;
	        // Adding `1px` because of whitespace between 2 inline-block
	        var fullHorizontalWidth = wrapperHorizontalWidth + calendarInfoPanelWidth + 1;
	
	        var transitionContainerStyle = {
	          width: isHorizontal && wrapperHorizontalWidth,
	          height: height
	        };
	
	        var dayPickerWrapperStyle = {
	          width: isHorizontal && wrapperHorizontalWidth
	        };
	
	        var dayPickerStyle = {
	          width: isHorizontal && fullHorizontalWidth,
	
	          // These values are to center the datepicker (approximately) on the page
	          marginLeft: isHorizontal && withPortal ? -fullHorizontalWidth / 2 : null,
	          marginTop: isHorizontal && withPortal ? -calendarMonthWidth / 2 : null
	        };
	
	        return _react2['default'].createElement(
	          'div',
	          _extends({
	            role: 'application',
	            'aria-label': phrases.calendarLabel
	          }, (0, _reactWithStyles.css)(styles.DayPicker, isHorizontal && styles.DayPicker__horizontal, verticalScrollable && styles.DayPicker__verticalScrollable, isHorizontal && withPortal && styles.DayPicker_portal__horizontal, this.isVertical() && withPortal && styles.DayPicker_portal__vertical, dayPickerStyle, !hasSetHeight && styles.DayPicker__hidden, !noBorder && styles.DayPicker__withBorder)),
	          _react2['default'].createElement(
	            _OutsideClickHandler2['default'],
	            { onOutsideClick: onOutsideClick },
	            (calendarInfoPositionTop || calendarInfoPositionBefore) && calendarInfo,
	            _react2['default'].createElement(
	              'div',
	              (0, _reactWithStyles.css)(dayPickerWrapperStyle, calendarInfoIsInline && isHorizontal && styles.DayPicker_wrapper__horizontal),
	              _react2['default'].createElement(
	                'div',
	                _extends({}, (0, _reactWithStyles.css)(styles.DayPicker_weekHeaders, isHorizontal && styles.DayPicker_weekHeaders__horizontal), {
	                  'aria-hidden': 'true',
	                  role: 'presentation'
	                }),
	                weekHeaders
	              ),
	              _react2['default'].createElement(
	                'div',
	                _extends({}, (0, _reactWithStyles.css)(styles.DayPicker_focusRegion), {
	                  ref: this.setContainerRef,
	                  onClick: function () {
	                    function onClick(e) {
	                      e.stopPropagation();
	                    }
	
	                    return onClick;
	                  }(),
	                  onKeyDown: this.onKeyDown,
	                  onMouseUp: function () {
	                    function onMouseUp() {
	                      _this5.setState({ withMouseInteractions: true });
	                    }
	
	                    return onMouseUp;
	                  }(),
	                  role: 'region',
	                  tabIndex: -1
	                }),
	                !verticalScrollable && this.renderNavigation(),
	                _react2['default'].createElement(
	                  'div',
	                  _extends({}, (0, _reactWithStyles.css)(styles.DayPicker_transitionContainer, isHorizontalAndAnimating && styles.DayPicker_transitionContainer__horizontal, this.isVertical() && styles.DayPicker_transitionContainer__vertical, verticalScrollable && styles.DayPicker_transitionContainer__verticalScrollable, transitionContainerStyle), {
	                    ref: this.setTransitionContainerRef
	                  }),
	                  _react2['default'].createElement(_CalendarMonthGrid2['default'], {
	                    setCalendarMonthHeights: this.setCalendarMonthHeights,
	                    transformValue: transformValue,
	                    enableOutsideDays: enableOutsideDays,
	                    firstVisibleMonthIndex: firstVisibleMonthIndex,
	                    initialMonth: currentMonth,
	                    isAnimating: isCalendarMonthGridAnimating,
	                    modifiers: modifiers,
	                    orientation: orientation,
	                    numberOfMonths: numberOfMonths * scrollableMonthMultiple,
	                    onDayClick: onDayClick,
	                    onDayMouseEnter: onDayMouseEnter,
	                    onDayMouseLeave: onDayMouseLeave,
	                    renderMonth: renderMonth,
	                    renderCalendarDay: renderCalendarDay,
	                    renderDayContents: renderDayContents,
	                    onMonthTransitionEnd: this.updateStateAfterMonthTransition,
	                    monthFormat: monthFormat,
	                    daySize: daySize,
	                    firstDayOfWeek: firstDayOfWeek,
	                    isFocused: shouldFocusDate,
	                    focusedDate: focusedDate,
	                    phrases: phrases,
	                    isRTL: isRTL,
	                    dayAriaLabelFormat: dayAriaLabelFormat,
	                    transitionDuration: transitionDuration,
	                    verticalBorderSpacing: verticalBorderSpacing
	                  }),
	                  verticalScrollable && this.renderNavigation()
	                ),
	                !isTouch && !hideKeyboardShortcutsPanel && _react2['default'].createElement(_DayPickerKeyboardShortcuts2['default'], {
	                  block: this.isVertical() && !withPortal,
	                  buttonLocation: keyboardShortcutButtonLocation,
	                  showKeyboardShortcutsPanel: showKeyboardShortcuts,
	                  openKeyboardShortcutsPanel: this.openKeyboardShortcutsPanel,
	                  closeKeyboardShortcutsPanel: this.closeKeyboardShortcutsPanel,
	                  phrases: phrases
	                })
	              )
	            ),
	            (calendarInfoPositionBottom || calendarInfoPositionAfter) && calendarInfo
	          )
	        );
	      }
	
	      return render;
	    }()
	  }]);
	
	  return DayPicker;
	}(_react2['default'].Component);
	
	DayPicker.propTypes = propTypes;
	DayPicker.defaultProps = defaultProps;
	
	exports.PureDayPicker = DayPicker;
	exports['default'] = (0, _reactWithStyles.withStyles)(function (_ref) {
	  var _ref$reactDates = _ref.reactDates,
	      color = _ref$reactDates.color,
	      font = _ref$reactDates.font,
	      zIndex = _ref$reactDates.zIndex;
	  return {
	    DayPicker: {
	      background: color.background,
	      position: 'relative',
	      textAlign: 'left'
	    },
	
	    DayPicker__horizontal: {
	      background: color.background
	    },
	
	    DayPicker__verticalScrollable: {
	      height: '100%'
	    },
	
	    DayPicker__hidden: {
	      visibility: 'hidden'
	    },
	
	    DayPicker__withBorder: {
	      boxShadow: '0 2px 6px rgba(0, 0, 0, 0.05), 0 0 0 1px rgba(0, 0, 0, 0.07)',
	      borderRadius: 3
	    },
	
	    DayPicker_portal__horizontal: {
	      boxShadow: 'none',
	      position: 'absolute',
	      left: '50%',
	      top: '50%'
	    },
	
	    DayPicker_portal__vertical: {
	      position: 'initial'
	    },
	
	    DayPicker_focusRegion: {
	      outline: 'none'
	    },
	
	    DayPicker_calendarInfo__horizontal: {
	      display: 'inline-block',
	      verticalAlign: 'top'
	    },
	
	    DayPicker_wrapper__horizontal: {
	      display: 'inline-block',
	      verticalAlign: 'top'
	    },
	
	    DayPicker_weekHeaders: {
	      position: 'relative'
	    },
	
	    DayPicker_weekHeaders__horizontal: {
	      marginLeft: 9
	    },
	
	    DayPicker_weekHeader: {
	      color: color.placeholderText,
	      position: 'absolute',
	      top: 62,
	      zIndex: zIndex + 2,
	      padding: '0 13px',
	      textAlign: 'left'
	    },
	
	    DayPicker_weekHeader__vertical: {
	      left: '50%'
	    },
	
	    DayPicker_weekHeader__verticalScrollable: {
	      top: 0,
	      display: 'table-row',
	      borderBottom: '1px solid ' + String(color.core.border),
	      background: color.background,
	      marginLeft: 0,
	      left: 0,
	      width: '100%',
	      textAlign: 'center'
	    },
	
	    DayPicker_weekHeader_ul: {
	      listStyle: 'none',
	      margin: '1px 0',
	      paddingLeft: 0,
	      paddingRight: 0,
	      fontSize: font.size
	    },
	
	    DayPicker_weekHeader_li: {
	      display: 'inline-block',
	      textAlign: 'center'
	    },
	
	    DayPicker_transitionContainer: {
	      position: 'relative',
	      overflow: 'hidden',
	      borderRadius: 3
	    },
	
	    DayPicker_transitionContainer__horizontal: {
	      transition: 'height 0.2s ease-in-out'
	    },
	
	    DayPicker_transitionContainer__vertical: {
	      width: '100%'
	    },
	
	    DayPicker_transitionContainer__verticalScrollable: {
	      paddingTop: 20,
	      height: '100%',
	      position: 'absolute',
	      top: 0,
	      bottom: 0,
	      right: 0,
	      left: 0,
	      overflowY: 'scroll'
	    }
	  };
	})(DayPicker);

/***/ },
/* 473 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = getInputHeight;
	/* eslint-disable camelcase */
	
	function getPadding(vertical, top, bottom) {
	  var isTopDefined = typeof top === 'number';
	  var isBottomDefined = typeof bottom === 'number';
	  var isVerticalDefined = typeof vertical === 'number';
	
	  if (isTopDefined && isBottomDefined) {
	    return top + bottom;
	  }
	
	  if (isTopDefined && isVerticalDefined) {
	    return top + vertical;
	  }
	
	  if (isTopDefined) {
	    return top;
	  }
	
	  if (isBottomDefined && isVerticalDefined) {
	    return bottom + vertical;
	  }
	
	  if (isBottomDefined) {
	    return bottom;
	  }
	
	  if (isVerticalDefined) {
	    return 2 * vertical;
	  }
	
	  return 0;
	}
	
	function getInputHeight(_ref, small) {
	  var _ref$font$input = _ref.font.input,
	      lineHeight = _ref$font$input.lineHeight,
	      lineHeight_small = _ref$font$input.lineHeight_small,
	      _ref$spacing = _ref.spacing,
	      inputPadding = _ref$spacing.inputPadding,
	      displayTextPaddingVertical = _ref$spacing.displayTextPaddingVertical,
	      displayTextPaddingTop = _ref$spacing.displayTextPaddingTop,
	      displayTextPaddingBottom = _ref$spacing.displayTextPaddingBottom,
	      displayTextPaddingVertical_small = _ref$spacing.displayTextPaddingVertical_small,
	      displayTextPaddingTop_small = _ref$spacing.displayTextPaddingTop_small,
	      displayTextPaddingBottom_small = _ref$spacing.displayTextPaddingBottom_small;
	
	  var calcLineHeight = small ? lineHeight_small : lineHeight;
	
	  var padding = small ? getPadding(displayTextPaddingVertical_small, displayTextPaddingTop_small, displayTextPaddingBottom_small) : getPadding(displayTextPaddingVertical, displayTextPaddingTop, displayTextPaddingBottom);
	
	  return parseInt(calcLineHeight, 10) + 2 * inputPadding + padding;
	}

/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = isDayVisible;
	
	var _isBeforeDay = __webpack_require__(263);
	
	var _isBeforeDay2 = _interopRequireDefault(_isBeforeDay);
	
	var _isAfterDay = __webpack_require__(262);
	
	var _isAfterDay2 = _interopRequireDefault(_isAfterDay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function isDayVisible(day, month, numberOfMonths, enableOutsideDays) {
	  var firstDayOfFirstMonth = month.clone().startOf('month');
	  if (enableOutsideDays) firstDayOfFirstMonth = firstDayOfFirstMonth.startOf('week');
	  if ((0, _isBeforeDay2['default'])(day, firstDayOfFirstMonth)) return false;
	
	  var lastDayOfLastMonth = month.clone().add(numberOfMonths - 1, 'months').endOf('month');
	  if (enableOutsideDays) lastDayOfLastMonth = lastDayOfLastMonth.endOf('week');
	  return !(0, _isAfterDay2['default'])(day, lastDayOfLastMonth);
	}

/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = toLocalizedDateString;
	
	var _moment = __webpack_require__(9);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _toMomentObject = __webpack_require__(215);
	
	var _toMomentObject2 = _interopRequireDefault(_toMomentObject);
	
	var _constants = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function toLocalizedDateString(date, currentFormat) {
	  var dateObj = _moment2['default'].isMoment(date) ? date : (0, _toMomentObject2['default'])(date, currentFormat);
	  if (!dateObj) return null;
	
	  return dateObj.format(_constants.DISPLAY_FORMAT);
	}

/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(216);
	var Danger = __webpack_require__(2993);
	var ReactDOMComponentTree = __webpack_require__(44);
	var ReactInstrumentation = __webpack_require__(81);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(485);
	var setInnerHTML = __webpack_require__(347);
	var setTextContent = __webpack_require__(897);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: { toIndex: update.toIndex, content: update.content.toString() }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	
	};
	
	module.exports = DOMChildrenOperations;

/***/ },
/* 477 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(32);
	
	var invariant = __webpack_require__(19);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = EventPluginRegistry;

/***/ },
/* 479 */
919,
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(32);
	
	var React = __webpack_require__(105);
	var ReactPropTypesSecret = __webpack_require__(3019);
	
	var invariant = __webpack_require__(19);
	var warning = __webpack_require__(26);
	
	var hasReadOnlyValue = {
	  'button': true,
	  'checkbox': true,
	  'image': true,
	  'hidden': true,
	  'radio': true,
	  'reset': true,
	  'submit': true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: React.PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(32);
	
	var invariant = __webpack_require__(19);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	
	};
	
	module.exports = ReactComponentEnvironment;

/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = func.bind(null, a);
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      // $FlowFixMe https://github.com/facebook/flow/issues/2336
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(32);
	
	var ReactCurrentOwner = __webpack_require__(113);
	var ReactInstanceMap = __webpack_require__(220);
	var ReactInstrumentation = __webpack_require__(81);
	var ReactUpdates = __webpack_require__(89);
	
	var invariant = __webpack_require__(19);
	var warning = __webpack_require__(26);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + 'within `render` or another component\'s constructor). Render methods ' + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	
	};
	
	module.exports = ReactUpdateQueue;

/***/ },
/* 484 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	
	};
	
	module.exports = ViewportMetrics;

/***/ },
/* 485 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ },
/* 486 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ },
/* 487 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  'Alt': 'altKey',
	  'Control': 'ctrlKey',
	  'Meta': 'metaKey',
	  'Shift': 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ },
/* 488 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(32),
	    _assign = __webpack_require__(29);
	
	var ReactCompositeComponent = __webpack_require__(3001);
	var ReactEmptyComponent = __webpack_require__(882);
	var ReactHostComponent = __webpack_require__(884);
	
	var getNextDebugID = __webpack_require__(3044);
	var invariant = __webpack_require__(19);
	var warning = __webpack_require__(26);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    !(element && (typeof element.type === 'function' || typeof element.type === 'string')) ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', element.type == null ? element.type : typeof element.type, getDeclarationErrorAddendum(element._owner)) : _prodInvariant('130', element.type == null ? element.type : typeof element.type, getDeclarationErrorAddendum(element._owner)) : void 0;
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	module.exports = instantiateReactComponent;

/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(53);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ },
/* 491 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(29);
	
	var emptyFunction = __webpack_require__(80);
	var warning = __webpack_require__(26);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	
	      case 'pre':
	      case 'listing':
	
	      case 'table':
	
	      case 'hr':
	
	      case 'xmp':
	
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = ' Make sure you don\'t have any extra whitespace between tags on ' + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ },
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(225);
	
	var ReactCurrentOwner = __webpack_require__(113);
	
	var invariant = __webpack_require__(19);
	var warning = __webpack_require__(26);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty)
	  // Strip regex characters so we can use it for regex
	  .replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  // Remove hasOwnProperty from the template to make it generic
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs
	};
	
	module.exports = ReactComponentTreeHook;

/***/ },
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */
/***/ function(module, exports) {

	module.exports = function(el) {
	  var basicTabbables = [];
	  var orderedTabbables = [];
	
	  // A node is "available" if
	  // - it's computed style
	  var isUnavailable = createIsUnavailable();
	
	  var candidateSelectors = [
	    'input',
	    'select',
	    'a[href]',
	    'textarea',
	    'button',
	    '[tabindex]',
	  ];
	
	  var candidates = el.querySelectorAll(candidateSelectors);
	
	  var candidate, candidateIndex;
	  for (var i = 0, l = candidates.length; i < l; i++) {
	    candidate = candidates[i];
	    candidateIndex = candidate.tabIndex;
	
	    if (
	      candidateIndex < 0
	      || (candidate.tagName === 'INPUT' && candidate.type === 'hidden')
	      || candidate.disabled
	      || isUnavailable(candidate)
	    ) {
	      continue;
	    }
	
	    if (candidateIndex === 0) {
	      basicTabbables.push(candidate);
	    } else {
	      orderedTabbables.push({
	        tabIndex: candidateIndex,
	        node: candidate,
	      });
	    }
	  }
	
	  var tabbableNodes = orderedTabbables
	    .sort(function(a, b) {
	      return a.tabIndex - b.tabIndex;
	    })
	    .map(function(a) {
	      return a.node
	    });
	
	  Array.prototype.push.apply(tabbableNodes, basicTabbables);
	
	  return tabbableNodes;
	}
	
	function createIsUnavailable() {
	  // Node cache must be refreshed on every check, in case
	  // the content of the element has changed
	  var isOffCache = [];
	
	  // "off" means `display: none;`, as opposed to "hidden",
	  // which means `visibility: hidden;`. getComputedStyle
	  // accurately reflects visiblity in context but not
	  // "off" state, so we need to recursively check parents.
	
	  function isOff(node, nodeComputedStyle) {
	    if (node === document.documentElement) return false;
	
	    // Find the cached node (Array.prototype.find not available in IE9)
	    for (var i = 0, length = isOffCache.length; i < length; i++) {
	      if (isOffCache[i][0] === node) return isOffCache[i][1];
	    }
	
	    nodeComputedStyle = nodeComputedStyle || window.getComputedStyle(node);
	
	    var result = false;
	
	    if (nodeComputedStyle.display === 'none') {
	      result = true;
	    } else if (node.parentNode) {
	      result = isOff(node.parentNode);
	    }
	
	    isOffCache.push([node, result]);
	
	    return result;
	  }
	
	  return function isUnavailable(node) {
	    if (node === document.documentElement) return false;
	
	    var computedStyle = window.getComputedStyle(node);
	
	    if (isOff(node, computedStyle)) return true;
	
	    return computedStyle.visibility === 'hidden';
	  }
	}


/***/ },
/* 508 */,
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BibItemInfo = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _formatIndicator = __webpack_require__(177);
	
	var _formatIndicator2 = _interopRequireDefault(_formatIndicator);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _sharedBibBrief = __webpack_require__(46);
	
	var _sharedBibBrief2 = _interopRequireDefault(_sharedBibBrief);
	
	var _availabilityBibBlock = __webpack_require__(226);
	
	var _availabilityBibBlock2 = _interopRequireDefault(_availabilityBibBlock);
	
	__webpack_require__(2645);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BibItemInfo = exports.BibItemInfo = function (_BcReactComponent) {
	  _inherits(BibItemInfo, _BcReactComponent);
	
	  function BibItemInfo(props) {
	    _classCallCheck(this, BibItemInfo);
	
	    var _this = _possibleConstructorReturn(this, (BibItemInfo.__proto__ || Object.getPrototypeOf(BibItemInfo)).call(this, props));
	
	    _this.bindAll('renderPubYear', 'renderAvailability', 'focusOnTitle');
	    return _this;
	  }
	
	  _createClass(BibItemInfo, [{
	    key: 'renderPubYear',
	    value: function renderPubYear() {
	      var bib = this.props.bib;
	
	      var briefInfo = bib.get('briefInfo');
	      if (briefInfo.get('publicationDate')) {
	        return _react2.default.createElement(
	          'span',
	          { className: 'pub-year' },
	          briefInfo.get('format') ? ' - ' : '',
	          briefInfo.get('publicationDate')
	        );
	      }
	
	      return _react2.default.createElement('noop', null);
	    }
	  }, {
	    key: 'focusOnTitle',
	    value: function focusOnTitle() {
	      if (this._bibBrief) {
	        this._bibBrief.focusOnTitle();
	      }
	    }
	  }, {
	    key: 'renderAvailability',
	    value: function renderAvailability() {
	      var bib = this.props.bib;
	
	      var availability = bib.get('availability');
	
	      if (availability && this.props.showAvailability) {
	        return _react2.default.createElement(_availabilityBibBlock2.default, {
	          bib: bib,
	          availabilityStatus: availability,
	          availabilityDetailActions: this.props.availabilityDetailActions,
	          showAvailabilityLink: false });
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var bib = this.props.bib;
	
	      var classes = this.props.compact ? 'compact' : '';
	      var briefInfo = bib.get('briefInfo');
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'cp-catalogue-results-bib-item-info ' + classes,
	          'data-test-item-bib-id': briefInfo.get('id') },
	        _react2.default.createElement(
	          _sharedBibBrief2.default,
	          {
	            ref: function ref(el) {
	              return _this2._bibBrief = el;
	            },
	            bib: briefInfo,
	            renderTitleAsLink: false,
	            renderAuthorsAsLink: false,
	            titleTag: 'h3' },
	          _react2.default.createElement(
	            'div',
	            { className: 'format-and-year' },
	            _react2.default.createElement(_formatIndicator2.default, { format: briefInfo.get('format').toUpperCase() }),
	            this.renderPubYear()
	          )
	        ),
	        this.renderAvailability()
	      );
	    }
	  }]);
	
	  return BibItemInfo;
	}(_baseBcReactComponent2.default);
	
	BibItemInfo.propTypes = {
	  bib: _bcPropTypes.bibShape.isRequired,
	  showAvailability: _react.PropTypes.bool,
	  compact: _react.PropTypes.bool,
	  availabilityDetailActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired
	};
	
	exports.default = BibItemInfo;

/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ItemAnnotationInput = __webpack_require__(983);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ItemAnnotationInput).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _URLInput = __webpack_require__(984);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_URLInput).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _WebItemTitleInput = __webpack_require__(985);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_WebItemTitleInput).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SHELF_ACTION_TOGGLE_PRIVACY = exports.SHELF_ACTION_MOVE = exports.SHELF_ACTION_REMOVE = exports.SHELF_ACTION_ADD = exports.SHELF_GTM_CATEGORY = exports.TOGGLE_PRIVACY_SHELF_EVENT = exports.MOVE_TO_SHELF_EVENT = exports.REMOVE_FROM_SHELF_EVENT = exports.ADD_TO_SHELF_EVENT = undefined;
	exports.composeShelfEvent = composeShelfEvent;
	exports.composeAddToShelfEvent = composeAddToShelfEvent;
	exports.composeRemoveFromShelfEvent = composeRemoveFromShelfEvent;
	exports.composeUpdateShelfEvent = composeUpdateShelfEvent;
	
	var _compose = __webpack_require__(67);
	
	var ADD_TO_SHELF_EVENT = exports.ADD_TO_SHELF_EVENT = 'bc.addToShelf';
	var REMOVE_FROM_SHELF_EVENT = exports.REMOVE_FROM_SHELF_EVENT = 'bc.removeFromShelf';
	var MOVE_TO_SHELF_EVENT = exports.MOVE_TO_SHELF_EVENT = 'bc.moveToShelf';
	var TOGGLE_PRIVACY_SHELF_EVENT = exports.TOGGLE_PRIVACY_SHELF_EVENT = 'bc.togglePrivacy';
	var SHELF_GTM_CATEGORY = exports.SHELF_GTM_CATEGORY = 'v2-shelves';
	var SHELF_ACTION_ADD = exports.SHELF_ACTION_ADD = 'v2-add';
	var SHELF_ACTION_REMOVE = exports.SHELF_ACTION_REMOVE = 'v2-remove';
	var SHELF_ACTION_MOVE = exports.SHELF_ACTION_MOVE = 'v2-move';
	var SHELF_ACTION_TOGGLE_PRIVACY = exports.SHELF_ACTION_TOGGLE_PRIVACY = 'v2-toggle-privacy';
	
	function composeShelfEvent(eventName, metadataIds, shelfName, action) {
	  return (0, _compose.composeEvent)(eventName, {
	    gtmValue: metadataIds.length,
	    gtmLabel: shelfName,
	    gtmCategory: SHELF_GTM_CATEGORY,
	    gtmAction: action,
	    metadataIds: metadataIds
	  });
	}
	
	function composeAddToShelfEvent(metadataIds, shelfName) {
	  return (0, _compose.composeAnalytics)([composeShelfEvent(ADD_TO_SHELF_EVENT, metadataIds, shelfName, SHELF_ACTION_ADD)]);
	}
	
	function composeRemoveFromShelfEvent(metadataIds, shelfName) {
	  return (0, _compose.composeAnalytics)([composeShelfEvent(REMOVE_FROM_SHELF_EVENT, metadataIds, shelfName, SHELF_ACTION_REMOVE)]);
	}
	
	function composeUpdateShelfEvent(metadataIds, fromShelfName, toShelfName, toPrivateItem) {
	  var events = [];
	
	  if (fromShelfName && toShelfName && fromShelfName !== toShelfName) {
	    events.push(composeShelfEvent(MOVE_TO_SHELF_EVENT, metadataIds, toShelfName, SHELF_ACTION_MOVE));
	  }
	
	  if (toPrivateItem !== undefined && toPrivateItem !== null) {
	    var label = toPrivateItem ? 'private' : 'public';
	    events.push(composeShelfEvent(TOGGLE_PRIVACY_SHELF_EVENT, metadataIds, label, SHELF_ACTION_TOGGLE_PRIVACY));
	  }
	
	  return (0, _compose.composeAnalytics)(events);
	}
	
	exports.default = {
	  ADD_TO_SHELF_EVENT: ADD_TO_SHELF_EVENT,
	  REMOVE_FROM_SHELF_EVENT: REMOVE_FROM_SHELF_EVENT,
	  MOVE_TO_SHELF_EVENT: MOVE_TO_SHELF_EVENT,
	  TOGGLE_PRIVACY_SHELF_EVENT: TOGGLE_PRIVACY_SHELF_EVENT,
	  SHELF_GTM_CATEGORY: SHELF_GTM_CATEGORY,
	  SHELF_ACTION_ADD: SHELF_ACTION_ADD,
	  SHELF_ACTION_REMOVE: SHELF_ACTION_REMOVE,
	  SHELF_ACTION_MOVE: SHELF_ACTION_MOVE,
	  SHELF_ACTION_TOGGLE_PRIVACY: SHELF_ACTION_TOGGLE_PRIVACY,
	  composeShelfEvent: composeShelfEvent,
	  composeAddToShelfEvent: composeAddToShelfEvent,
	  composeRemoveFromShelfEvent: composeRemoveFromShelfEvent,
	  composeUpdateShelfEvent: composeUpdateShelfEvent
	};

/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AccessiblePopOver = __webpack_require__(1011);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AccessiblePopOver).default;
	  }
	});
	Object.defineProperty(exports, 'AccessiblePopOver', {
	  enumerable: true,
	  get: function get() {
	    return _AccessiblePopOver.AccessiblePopOver;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AlertDismiss = __webpack_require__(1015);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AlertDismiss).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GhostButton = __webpack_require__(1038);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GhostButton).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ByAuthorBlock = __webpack_require__(1055);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ByAuthorBlock).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CharacterCount = __webpack_require__(1056);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CharacterCount).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DropdownTrigger = __webpack_require__(1075);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DropdownTrigger).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Swipeable = __webpack_require__(1079);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Swipeable).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _InlineOverlayCloseButton = __webpack_require__(1319);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_InlineOverlayCloseButton).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PinchHandler = __webpack_require__(1337);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PinchHandler).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PopupManager = __webpack_require__(1339);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PopupManager).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TabContent = __webpack_require__(1357);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TabContent).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _tabs = __webpack_require__(1359);
	
	Object.defineProperty(exports, 'Tabs', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_tabs).default;
	  }
	});
	
	var _tabContent = __webpack_require__(524);
	
	Object.defineProperty(exports, 'TabContent', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_tabContent).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ratingShape = exports.seriesShape = undefined;
	
	var _react = __webpack_require__(1);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _jacketShape = __webpack_require__(529);
	
	var _jacketShape2 = _interopRequireDefault(_jacketShape);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var seriesShape = exports.seriesShape = _reactImmutableProptypes2.default.mapContains({
	  name: _react.PropTypes.string,
	  sortName: _react.PropTypes.string,
	  volume: _react.PropTypes.string,
	  volumeNumber: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number])
	});
	
	var ratingShape = exports.ratingShape = _reactImmutableProptypes2.default.mapContains({
	  averageRating: _react.PropTypes.number,
	  totalCount: _react.PropTypes.number
	});
	
	exports.default = _reactImmutableProptypes2.default.mapContains({
	  authors: _reactImmutableProptypes2.default.listOf(_react.PropTypes.string),
	  callNumber: _react.PropTypes.string,
	  consumptionFormat: _react.PropTypes.string,
	  description: _react.PropTypes.string,
	  edition: _react.PropTypes.string,
	  format: _react.PropTypes.string,
	  id: _react.PropTypes.string,
	  isbns: _reactImmutableProptypes2.default.listOf(_react.PropTypes.string),
	  jacket: _jacketShape2.default,
	  metadataId: _react.PropTypes.string,
	  multiscriptAuthor: _react.PropTypes.string,
	  multiscriptTitle: _react.PropTypes.string,
	  primaryLanguage: _react.PropTypes.string,
	  publicationDate: _react.PropTypes.string,
	  rating: ratingShape,
	  series: _reactImmutableProptypes2.default.listOf(seriesShape),
	  subtitle: _react.PropTypes.string,
	  superFormats: _reactImmutableProptypes2.default.listOf(_react.PropTypes.string),
	  title: _react.PropTypes.string
	});

/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _reactImmutableProptypes2.default.mapContains({
	  code: _react.PropTypes.string,
	  name: _react.PropTypes.string
	});

/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var filterShape = _react.PropTypes.shape({
	  value: _react.PropTypes.string,
	  count: _react.PropTypes.number,
	  label: _react.PropTypes.string
	});
	
	exports.default = filterShape;

/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _reactImmutableProptypes2.default.mapContains({
	  large: _react.PropTypes.string,
	  local_url: _react.PropTypes.string,
	  medium: _react.PropTypes.string,
	  small: _react.PropTypes.string,
	  type: _react.PropTypes.string
	});

/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _reactImmutableProptypes2.default.contains({
	  count: _react.PropTypes.number,
	  limit: _react.PropTypes.number,
	  page: _react.PropTypes.number,
	  pages: _react.PropTypes.number
	});

/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var searchQueryShape = _reactImmutableProptypes2.default.contains({
	  pagination_page: _react.PropTypes.number,
	  query: _react.PropTypes.string,
	  searchType: _react.PropTypes.string
	});
	
	exports.default = searchQueryShape;

/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _reactImmutableProptypes2.default.mapContains({
	  branchId: _react.PropTypes.string,
	  enabled: _react.PropTypes.bool,
	  holdsDurationExpiration: _react.PropTypes.number
	});

/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var siteShape = _reactImmutableProptypes2.default.contains({
	  siteId: _react.PropTypes.string,
	  libraryId: _react.PropTypes.number,
	  shortName: _react.PropTypes.string,
	  longName: _react.PropTypes.string,
	  logo: _react.PropTypes.string,
	  domain: _react.PropTypes.string
	});
	
	exports.default = siteShape;

/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userIdentityShape = _reactImmutableProptypes2.default.contains({
	  name: _react.PropTypes.string.isRequired,
	  id: _react.PropTypes.number.isRequired,
	  active: _react.PropTypes.bool.isRequired,
	  avatar: _react.PropTypes.string,
	  homeLibrary: _react.PropTypes.string.isRequired,
	  homeLibrarySubdomain: _react.PropTypes.string.isRequired,
	  homeLibraryFullName: _react.PropTypes.string.isRequired,
	  homePatron: _react.PropTypes.bool.isRequired,
	  staff: _react.PropTypes.bool.isRequired,
	  loggedIn: _react.PropTypes.bool,
	  staffTakeover: _react.PropTypes.bool,
	  accounts: _reactImmutableProptypes2.default.listOf(_react.PropTypes.number),
	  roles: _reactImmutableProptypes2.default.listOf(_react.PropTypes.string),
	  permissions: _reactImmutableProptypes2.default.listOf(_react.PropTypes.string)
	});
	
	exports.default = userIdentityShape;

/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseIcons = __webpack_require__(10);
	
	var _baseButtons = __webpack_require__(12);
	
	var _PageDescription = __webpack_require__(536);
	
	var _PageDescription2 = _interopRequireDefault(_PageDescription);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ArrowButton = function (_BcReactComponent) {
	  _inherits(ArrowButton, _BcReactComponent);
	
	  function ArrowButton() {
	    _classCallCheck(this, ArrowButton);
	
	    return _possibleConstructorReturn(this, (ArrowButton.__proto__ || Object.getPrototypeOf(ArrowButton)).apply(this, arguments));
	  }
	
	  _createClass(ArrowButton, [{
	    key: 'focus',
	    value: function focus() {
	      this._button.focus();
	    }
	  }, {
	    key: 'getTargetPage',
	    value: function getTargetPage() {
	      return this.props.direction === 'left' ? this.props.currentPage - 1 : this.props.currentPage + 1;
	    }
	  }, {
	    key: 'renderArrow',
	    value: function renderArrow() {
	      return this.props.direction === 'left' ? _react2.default.createElement(_baseIcons.Chevron.Left, null) : _react2.default.createElement(_baseIcons.Chevron.Right, null);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          className = _props.className,
	          disabled = _props.disabled,
	          handleClick = _props.handleClick,
	          pageSize = _props.pageSize,
	          numberOfItems = _props.numberOfItems,
	          direction = _props.direction,
	          props = _objectWithoutProperties(_props, ['className', 'disabled', 'handleClick', 'pageSize', 'numberOfItems', 'direction']);
	
	      return _react2.default.createElement(
	        _baseButtons.Button,
	        _extends({}, props, {
	          ref: function ref(el) {
	            return _this2._button = el;
	          },
	          className: 'cp-arrow-button ' + className + ' cp-arrow-button-' + direction,
	          disabled: disabled,
	          handleClick: handleClick }),
	        _react2.default.createElement(_PageDescription2.default, {
	          page: this.getTargetPage(),
	          pageSize: pageSize,
	          numberOfItems: numberOfItems }),
	        this.renderArrow()
	      );
	    }
	  }]);
	
	  return ArrowButton;
	}(_baseBcReactComponent2.default);
	
	exports.default = ArrowButton;
	
	
	ArrowButton.propTypes = {
	  currentPage: _react.PropTypes.number,
	  className: _react.PropTypes.string,
	  pageSize: _react.PropTypes.number,
	  numberOfItems: _react.PropTypes.number,
	  direction: _react.PropTypes.string,
	  disabled: _react.PropTypes.bool,
	  handleClick: _react.PropTypes.func
	};

/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _lodash = __webpack_require__(16);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PageDescription = function (_BcReactComponent) {
	  _inherits(PageDescription, _BcReactComponent);
	
	  function PageDescription() {
	    _classCallCheck(this, PageDescription);
	
	    return _possibleConstructorReturn(this, (PageDescription.__proto__ || Object.getPrototypeOf(PageDescription)).apply(this, arguments));
	  }
	
	  _createClass(PageDescription, [{
	    key: 'getPageStart',
	    value: function getPageStart() {
	      var _props = this.props,
	          page = _props.page,
	          pageSize = _props.pageSize,
	          numberOfItems = _props.numberOfItems;
	
	      var index = page * pageSize + 1;
	      return _lodash2.default.clamp(index, 1, numberOfItems);
	    }
	  }, {
	    key: 'getPageEnd',
	    value: function getPageEnd() {
	      var _props2 = this.props,
	          page = _props2.page,
	          pageSize = _props2.pageSize,
	          numberOfItems = _props2.numberOfItems;
	
	      var index = (page + 1) * pageSize;
	      return _lodash2.default.clamp(index, 1, numberOfItems);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _reactIntl.FormattedMessage,
	        {
	          id: 'carousel_view_items',
	          values: { start: this.getPageStart(), end: this.getPageEnd() } },
	        function (message) {
	          return _react2.default.createElement(
	            _baseScreenReaderMessage2.default,
	            { className: 'cp-page-description' },
	            message
	          );
	        }
	      );
	    }
	  }]);
	
	  return PageDescription;
	}(_baseBcReactComponent2.default);
	
	exports.default = PageDescription;
	
	
	PageDescription.propTypes = {
	  page: _react.PropTypes.number,
	  pageSize: _react.PropTypes.number,
	  numberOfItems: _react.PropTypes.number
	};

/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _MessageWithFallback = __webpack_require__(1425);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MessageWithFallback).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _LoginForm = __webpack_require__(1426);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_LoginForm).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _login = __webpack_require__(1430);
	
	Object.defineProperty(exports, 'Login', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_login).default;
	  }
	});
	
	var _loginOverlay = __webpack_require__(1428);
	
	Object.defineProperty(exports, 'LoginOverlay', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_loginOverlay).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SearchProbe = __webpack_require__(1456);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SearchProbe).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _holdingsProbe = __webpack_require__(1453);
	
	Object.defineProperty(exports, 'HoldingsProbe', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_holdingsProbe).default;
	  }
	});
	
	var _searchProbe = __webpack_require__(540);
	
	Object.defineProperty(exports, 'SearchProbe', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_searchProbe).default;
	  }
	});
	
	var _searchProbeList = __webpack_require__(1455);
	
	Object.defineProperty(exports, 'SearchProbeList', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_searchProbeList).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DuplicateSavedSearch = __webpack_require__(1464);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DuplicateSavedSearch).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _NewSavedSearch = __webpack_require__(1465);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_NewSavedSearch).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SearchBar = __webpack_require__(1469);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SearchBar).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _EResourceLink = __webpack_require__(1482);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_EResourceLink).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _LibraryLogo = __webpack_require__(1490);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_LibraryLogo).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PickupBranchSelect = __webpack_require__(1498);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PickupBranchSelect).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ProbeLogo = __webpack_require__(1503);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ProbeLogo).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ScreenReaderItemInfo = __webpack_require__(1506);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ScreenReaderItemInfo).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _sharedScreenReaderItemInfo = __webpack_require__(549);
	
	var _sharedScreenReaderItemInfo2 = _interopRequireDefault(_sharedScreenReaderItemInfo);
	
	var _utilsString = __webpack_require__(375);
	
	var _reactIntl = __webpack_require__(3);
	
	__webpack_require__(2744);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BibTextSlide = function BibTextSlide(_ref) {
	  var item = _ref.item;
	
	  var renderAuthorLinks = function renderAuthorLinks(bib) {
	    if (bib.authors && bib.authors.length > 0) {
	      var authorLinks = bib.authors.map(_utilsString.truncate)[0];
	      return _react2.default.createElement(
	        _reactIntl.FormattedMessage,
	        { id: 'by_authors', values: { authorLinks: authorLinks } },
	        function (message) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'authors' },
	            message
	          );
	        }
	      );
	    }
	    return null;
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'cp-bib-text-slide' },
	    _react2.default.createElement(_sharedScreenReaderItemInfo2.default, item),
	    _react2.default.createElement(
	      'div',
	      { className: 'inner-box', 'aria-hidden': true },
	      _react2.default.createElement(
	        'div',
	        { className: 'title' },
	        (0, _utilsString.truncate)(item.title)
	      ),
	      item.subTitle && _react2.default.createElement(
	        'div',
	        { className: 'subtitle' },
	        (0, _utilsString.truncate)(item.subTitle)
	      ),
	      renderAuthorLinks(item)
	    )
	  );
	};
	
	BibTextSlide.propTypes = {
	  item: _react.PropTypes.shape({
	    format: _react.PropTypes.string,
	    subTitle: _react.PropTypes.string,
	    title: _react.PropTypes.string.isRequired,
	    authors: _react.PropTypes.arrayOf(_react.PropTypes.string)
	  }).isRequired
	};
	
	exports.default = BibTextSlide;

/***/ },
/* 551 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ContentAdvisoryTypePicker = __webpack_require__(1513);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ContentAdvisoryTypePicker).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _VideoEmbedCodeField = __webpack_require__(1539);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_VideoEmbedCodeField).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 553 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ZoomableMapDisplay = __webpack_require__(1545);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ZoomableMapDisplay).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var ES = __webpack_require__(2443);
	
	var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || (Math.pow(2, 53) - 1);
	
	// eslint-disable-next-line max-params, max-statements
	var FlattenIntoArray = function FlattenIntoArray(target, source, sourceLen, start, depth) {
		var targetIndex = start;
		var sourceIndex = 0;
	
		/*
		var mapperFunction;
		if (arguments.length > 5) {
			mapperFunction = arguments[5];
		}
		*/
	
		while (sourceIndex < sourceLen) {
			var P = ES.ToString(sourceIndex);
			var exists = ES.HasProperty(source, P);
			if (exists) {
				var element = ES.Get(source, P);
				/*
				if (typeof mapperFunction !== 'undefined') {
					if (arguments.length <= 6) {
						throw new TypeError('Assertion failed: thisArg is required when mapperFunction is provided');
					}
					element = ES.Call(mapperFunction, arguments[6], [element, sourceIndex, source]);
				}
				*/
				var shouldFlatten = false;
				if (depth > 0) {
					shouldFlatten = ES.IsArray(element);
				}
				if (shouldFlatten) {
					var elementLen = ES.ToLength(ES.Get(element, 'length'));
					targetIndex = FlattenIntoArray(target, element, elementLen, targetIndex, depth - 1);
				} else {
					if (targetIndex >= MAX_SAFE_INTEGER) {
						throw new TypeError('index too large');
					}
					ES.CreateDataPropertyOrThrow(target, ES.ToString(targetIndex), element);
					targetIndex += 1;
				}
			}
			sourceIndex += 1;
		}
	
		return targetIndex;
	};
	
	module.exports = function flat() {
		var O = ES.ToObject(this);
		var sourceLen = ES.ToLength(ES.Get(O, 'length'));
	
		var depthNum = 1;
		if (arguments.length > 0 && typeof arguments[0] !== 'undefined') {
			depthNum = ES.ToInteger(arguments[0]);
		}
	
		var A = ES.ArraySpeciesCreate(O, 0);
		FlattenIntoArray(A, O, sourceLen, 0, depthNum);
		return A;
	};


/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(554);
	
	module.exports = function getPolyfill() {
		return Array.prototype.flat || implementation;
	};


/***/ },
/* 556 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.updateSingleClickHoldsSettings = updateSingleClickHoldsSettings;
	exports.updateBorrowingHistorySetting = updateBorrowingHistorySetting;
	
	var _AccountApi = __webpack_require__(1596);
	
	var _AccountApi2 = _interopRequireDefault(_AccountApi);
	
	var _AccountConstants = __webpack_require__(2054);
	
	var _AccountConstants2 = _interopRequireDefault(_AccountConstants);
	
	var _composeGlobalSuccessMessaging = __webpack_require__(245);
	
	var _composeGlobalSuccessMessaging2 = _interopRequireDefault(_composeGlobalSuccessMessaging);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function updateSingleClickHoldsSettings(accountId, enabled, branchId) {
	  return {
	    types: [_AccountConstants2.default.UPDATE_SINGLE_CLICK_HOLDS_REQUEST, _AccountConstants2.default.UPDATE_SINGLE_CLICK_HOLDS_SUCCESS, _AccountConstants2.default.UPDATE_SINGLE_CLICK_HOLDS_FAILURE],
	    middlewareData: {
	      accountRequired: true
	    },
	    apiRequest: function apiRequest(state, apiClient) {
	      return _AccountApi2.default.updateSingleClickHoldsSettings(accountId, enabled, branchId, apiClient);
	    }
	  };
	}
	
	function updateBorrowingHistorySetting(accountId, enabled) {
	  return {
	    types: [_AccountConstants2.default.UPDATE_BORROWING_HISTORY_REQUEST, _AccountConstants2.default.UPDATE_BORROWING_HISTORY_SUCCESS, _AccountConstants2.default.UPDATE_BORROWING_HISTORY_FAILURE],
	    middlewareData: {
	      accountRequired: true
	    },
	    apiRequest: function apiRequest(state, apiClient) {
	      return _AccountApi2.default.updateBorrowingHistorySetting(accountId, enabled, apiClient);
	    },
	    apiSuccess: function apiSuccess() {
	      return {
	        messaging: (0, _composeGlobalSuccessMessaging2.default)('message_successful_enable_borrowing_history')
	      };
	    }
	  };
	}
	exports.default = {
	  updateSingleClickHoldsSettings: updateSingleClickHoldsSettings,
	  updateBorrowingHistorySetting: updateBorrowingHistorySetting
	};

/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ListPresentationConstants = __webpack_require__(622);
	
	var _ListPresentationConstants2 = _interopRequireDefault(_ListPresentationConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function toggleListView(view) {
	  return {
	    type: _ListPresentationConstants2.default.TOGGLE_LIST_VIEW,
	    payload: {
	      view: view
	    }
	  };
	}
	
	exports.default = {
	  toggleListView: toggleListView
	};

/***/ },
/* 558 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchMessages = fetchMessages;
	
	var _MessagesApi = __webpack_require__(1611);
	
	var _MessagesApi2 = _interopRequireDefault(_MessagesApi);
	
	var _MessagesConstants = __webpack_require__(623);
	
	var _MessagesConstants2 = _interopRequireDefault(_MessagesConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function fetchMessages(_ref) {
	  var accountId = _ref.accountId;
	
	  return {
	    types: [_MessagesConstants2.default.FETCH_MESSAGES_REQUEST, _MessagesConstants2.default.FETCH_MESSAGES_SUCCESS, _MessagesConstants2.default.FETCH_MESSAGES_FAILURE],
	    middlewareData: {
	      accountRequired: (true)
	    },
	    apiRequest: function apiRequest(state, apiClient) {
	      return _MessagesApi2.default.getMessages({ accountId: accountId }, apiClient);
	    }
	  };
	}
	
	exports.default = {
	  fetchMessages: fetchMessages
	};

/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _NoticeConstants = __webpack_require__(624);
	
	var _NoticeConstants2 = _interopRequireDefault(_NoticeConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function dismissNotice(noticeId) {
	  return {
	    type: _NoticeConstants2.default.DISMISS_NOTICE,
	    noticeId: noticeId.toString()
	  };
	}
	
	exports.default = {
	  dismissNotice: dismissNotice
	};

/***/ },
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchReturnHistory = fetchReturnHistory;
	
	var _RecentlyReturnedApi = __webpack_require__(1616);
	
	var _RecentlyReturnedApi2 = _interopRequireDefault(_RecentlyReturnedApi);
	
	var _RecentlyReturnedConstants = __webpack_require__(629);
	
	var _RecentlyReturnedConstants2 = _interopRequireDefault(_RecentlyReturnedConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function fetchReturnHistory(query) {
	  return {
	    types: [_RecentlyReturnedConstants2.default.FETCH_RETURN_HISTORY_REQUEST, _RecentlyReturnedConstants2.default.FETCH_RETURN_HISTORY_SUCCESS, _RecentlyReturnedConstants2.default.FETCH_RETURN_HISTORY_FAILURE],
	    middlewareData: {
	      accountRequired: (true)
	    },
	    apiRequest: function apiRequest(state, apiClient) {
	      return _RecentlyReturnedApi2.default.getRecentlyReturned(apiClient, query);
	    }
	  };
	}
	
	exports.default = {
	  fetchReturnHistory: fetchReturnHistory
	};

/***/ },
/* 561 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _RecommendationApi = __webpack_require__(1617);
	
	var _RecommendationApi2 = _interopRequireDefault(_RecommendationApi);
	
	var _RecommendationConstants = __webpack_require__(393);
	
	var _RecommendationConstants2 = _interopRequireDefault(_RecommendationConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getRecommendations(id) {
	  return {
	    id: id,
	    types: [_RecommendationConstants2.default.RECOMMENDATION_REQUEST, _RecommendationConstants2.default.RECOMMENDATION_SUCCESS, _RecommendationConstants2.default.RECOMMENDATION_ERROR],
	    apiRequest: function apiRequest(state, client) {
	      return _RecommendationApi2.default.fetchRecommendations(id, client);
	    }
	  };
	}
	
	exports.default = {
	  getRecommendations: getRecommendations
	};

/***/ },
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _gaEventTemplates = __webpack_require__(363);
	
	var _StackMapApi = __webpack_require__(1622);
	
	var _StackMapApi2 = _interopRequireDefault(_StackMapApi);
	
	var _StackMapConstants = __webpack_require__(632);
	
	var _StackMapConstants2 = _interopRequireDefault(_StackMapConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function openStackMap(stackMap, item) {
	  return {
	    types: [_StackMapConstants2.default.REQUEST, _StackMapConstants2.default.SUCCESS, _StackMapConstants2.default.FAILURE],
	    middlewareData: {
	      gaEvent: (0, _gaEventTemplates.openStackMap)(item.get('callNumber'))
	    },
	    apiRequest: function apiRequest() {
	      return _StackMapApi2.default.fetchMap(stackMap.get('domain'), {
	        location: item.get('collection'),
	        callno: item.get('callNumber'),
	        library: item.getIn(['branch', 'name'])
	      });
	    }
	  };
	}
	
	function closeStackMap() {
	  return {
	    type: _StackMapConstants2.default.CLOSE
	  };
	}
	
	exports.default = {
	  openStackMap: openStackMap,
	  closeStackMap: closeStackMap
	};

/***/ },
/* 563 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(9);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _FeatureFlagContainer = __webpack_require__(147);
	
	var _FeatureFlagContainer2 = _interopRequireDefault(_FeatureFlagContainer);
	
	__webpack_require__(2455);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InternalError = function (_BCReactComponent) {
	  _inherits(InternalError, _BCReactComponent);
	
	  function InternalError() {
	    _classCallCheck(this, InternalError);
	
	    return _possibleConstructorReturn(this, (InternalError.__proto__ || Object.getPrototypeOf(InternalError)).apply(this, arguments));
	  }
	
	  _createClass(InternalError, [{
	    key: 'renderAppVersion',
	    value: function renderAppVersion() {
	      var appVersion = this.props.appVersion;
	
	
	      if (!appVersion) {
	        return '';
	      }
	
	      return _react2.default.createElement(
	        'span',
	        { 'data-test-id': 'app-version' },
	        'NERF: ',
	        appVersion,
	        _react2.default.createElement('br', null)
	      );
	    }
	  }, {
	    key: 'renderErrorId',
	    value: function renderErrorId() {
	      var errorId = this.props.errorId;
	
	
	      if (!errorId) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'span',
	        { 'data-test-id': 'error-id' },
	        'Error ID: ',
	        errorId,
	        _react2.default.createElement('br', null)
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var timestamp = (0, _moment2.default)().format('YYYY/MM/DD HH:mm');
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-internal-error' },
	        _react2.default.createElement(
	          'div',
	          { className: 'main-error-content' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'title' },
	            'We\u2019re very sorry!'
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'description' },
	            'Something on our end isn\u2019t working properly. ',
	            _react2.default.createElement('br', null),
	            'We\u2019re working hard to fix the problem.'
	          ),
	          _react2.default.createElement('hr', null),
	          _react2.default.createElement(
	            'h2',
	            null,
	            'In the meantime, you can\u2026'
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'description' },
	            _react2.default.createElement(
	              'a',
	              { href: '/dashboard' },
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'browse_library_catalogue' }),
	              '\xA0\xBB'
	            )
	          )
	        ),
	        _react2.default.createElement('hr', null),
	        _react2.default.createElement(
	          'div',
	          { className: 'error-ids' },
	          this.renderErrorId(),
	          this.renderAppVersion(),
	          timestamp,
	          _react2.default.createElement(
	            _FeatureFlagContainer2.default,
	            null,
	            function (flags) {
	              return flags.get('fiveHundredPageError') ? _react2.default.createElement(
	                'button',
	                { onClick: InternalError.throwAnError() },
	                'Throw an error'
	              ) : null;
	            }
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'report-problem' },
	          _react2.default.createElement(
	            'h2',
	            null,
	            'To report this problem\u2026'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Take a screenshot of this window and share it with your library.'
	          )
	        )
	      );
	    }
	  }], [{
	    key: 'throwAnError',
	    value: function throwAnError() {
	      try {
	        /* eslint-disable no-undef */
	        nonExistentTestVariable = 3;
	      } catch (err) {
	        throw err;
	      }
	    }
	  }]);
	
	  return InternalError;
	}(_baseBcReactComponent2.default);
	
	InternalError.displayName = 'InternalError';
	
	InternalError.propTypes = {
	  appVersion: _react.PropTypes.string,
	  errorId: _react.PropTypes.string
	};
	
	exports.default = InternalError;

/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _NextDueDate = __webpack_require__(1678);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_NextDueDate).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Capsule = __webpack_require__(1685);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Capsule).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _HoldsPauseDateSelect = __webpack_require__(1732);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_HoldsPauseDateSelect).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 567 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _RecentlyReturnedEmptyContentPanel = __webpack_require__(1780);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RecentlyReturnedEmptyContentPanel).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 568 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BorrowingQuotas = __webpack_require__(1812);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BorrowingQuotas).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BorrowingUtilityBarTitle = __webpack_require__(1818);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BorrowingUtilityBarTitle).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ItemField;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * This component handles displaying a colon seperated name value pair.
	 *
	 * Since this is a very general component, styles should not be added here.
	 * Instead, they should be added to components that wrap this one.
	 */
	function ItemField(_ref) {
	  var name = _ref.name,
	      value = _ref.value,
	      className = _ref.className;
	
	  if (!value) {
	    return null;
	  }
	
	  var classNames = (0, _classnames2.default)('cp-item-field', className);
	
	  return _react2.default.createElement(
	    'div',
	    { className: classNames },
	    _react2.default.createElement(_reactIntl.FormattedMessage, {
	      id: 'labeled_value',
	      values: {
	        name: _react2.default.createElement(
	          'span',
	          { className: 'field-name' },
	          name
	        ),
	        value: _react2.default.createElement(
	          'span',
	          { className: 'field-value' },
	          value
	        )
	      } })
	  );
	}
	
	ItemField.propTypes = {
	  name: _bcPropTypes.childrenShape,
	  value: _bcPropTypes.childrenShape,
	  className: _react.PropTypes.string
	};

/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _MaterialTypeFilterLinks = __webpack_require__(1820);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MaterialTypeFilterLinks).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AllSidebarLink = __webpack_require__(1827);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AllSidebarLink).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SidebarLink = __webpack_require__(1837);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SidebarLink).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ActiveFilters = __webpack_require__(1854);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ActiveFilters).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _reactRouter = __webpack_require__(17);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _analyticsEventComposers = __webpack_require__(174);
	
	var _utilsAnalytics = __webpack_require__(142);
	
	var _injectLibrary = __webpack_require__(396);
	
	var _injectLibrary2 = _interopRequireDefault(_injectLibrary);
	
	var _updateSearchQuery = __webpack_require__(148);
	
	var _updateSearchQuery2 = _interopRequireDefault(_updateSearchQuery);
	
	__webpack_require__(2538);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BroadenSearchLink = function (_BcReactComponent) {
	  _inherits(BroadenSearchLink, _BcReactComponent);
	
	  function BroadenSearchLink(props) {
	    _classCallCheck(this, BroadenSearchLink);
	
	    var _this = _possibleConstructorReturn(this, (BroadenSearchLink.__proto__ || Object.getPrototypeOf(BroadenSearchLink)).call(this, props));
	
	    _this.bindAll('handleBroadenClick');
	    return _this;
	  }
	
	  _createClass(BroadenSearchLink, [{
	    key: 'getSearchURL',
	    value: function getSearchURL(query) {
	      var location = this.props.router.location;
	
	
	      var newQuery = (0, _updateSearchQuery2.default)(_extends({
	        currentQuery: location.query,
	        pagination_page: undefined,
	        lastSearchScope: location.query.searchScope
	      }, query));
	
	      return _extends({}, location, { query: newQuery });
	    }
	  }, {
	    key: 'handleBroadenClick',
	    value: function handleBroadenClick(e) {
	      var _props = this.props,
	          isBroadened = _props.isBroadened,
	          query = _props.query,
	          searchType = _props.searchType,
	          broadenedSearchType = _props.broadenedSearchType,
	          router = _props.router;
	
	      var lastSearchScope = router.location.query.lastSearchScope;
	
	      e.preventDefault();
	
	      if (searchType !== 'keyword') {
	        var href = this.getSearchURL({
	          searchType: 'keyword',
	          searchScope: isBroadened && lastSearchScope
	        });
	        return this.props.router.push(href);
	      }
	
	      if (broadenedSearchType && !isBroadened) {
	        var newScope = this.getBroadenedScope();
	        (0, _utilsAnalytics.sendAnalyticsEvents)(_analyticsEventComposers.searchEventComposer.composeBroadenSearchEvent({
	          query: query,
	          searchType: broadenedSearchType
	        }));
	
	        var _href = this.getSearchURL({ searchType: broadenedSearchType, searchScope: newScope });
	        return this.props.router.push(_href);
	      }
	
	      return null;
	    }
	  }, {
	    key: 'getBroadenedScope',
	    value: function getBroadenedScope() {
	      var scopes = this.props.scopes;
	      return scopes && scopes.first() && scopes.first().get('scopeId');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          isBroadened = _props2.isBroadened,
	          broadenedSearchType = _props2.broadenedSearchType,
	          searchType = _props2.searchType,
	          query = _props2.query;
	
	
	      var label = searchType !== 'keyword' ? 'form_label_expand_to_keyword' : 'empty_broaden_your_search';
	
	      var validSearchType = !['keyword', 'bl'].includes(searchType);
	      var canBroaden = broadenedSearchType && !isBroadened;
	      if (validSearchType || isBroadened || canBroaden) {
	        return _react2.default.createElement(
	          _reactIntl.FormattedMessage,
	          { id: label, values: { query: query } },
	          function (message) {
	            return _react2.default.createElement(
	              'a',
	              {
	                href: '#broaden-search',
	                onClick: _this2.handleBroadenClick,
	                className: 'cp-broaden-search-link' },
	              message
	            );
	          }
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return BroadenSearchLink;
	}(_baseBcReactComponent2.default);
	
	BroadenSearchLink.displayName = 'BroadenSearchLink';
	
	BroadenSearchLink.propTypes = {
	  broadenedSearchType: _react.PropTypes.string,
	  isBroadened: _react.PropTypes.bool,
	  router: _reactRouter.routerShape,
	  query: _react.PropTypes.string,
	  searchType: _react.PropTypes.string,
	  scopes: _reactImmutableProptypes2.default.list
	};
	
	exports.default = (0, _reactRouter.withRouter)((0, _injectLibrary2.default)(function (_ref) {
	  var site = _ref.site;
	  return {
	    scopes: site.get('scopes')
	  };
	})(BroadenSearchLink));

/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ChatWidgetButton = __webpack_require__(1857);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ChatWidgetButton).default;
	  }
	});
	Object.defineProperty(exports, 'ChatWidgetButton', {
	  enumerable: true,
	  get: function get() {
	    return _ChatWidgetButton.ChatWidgetButton;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DidNotFind = __webpack_require__(1858);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DidNotFind).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _MobileSearchBox = __webpack_require__(1875);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MobileSearchBox).default;
	  }
	});
	Object.defineProperty(exports, 'MobileSearchBox', {
	  enumerable: true,
	  get: function get() {
	    return _MobileSearchBox.MobileSearchBox;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = RSSButton;
	
	var _lodash = __webpack_require__(16);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	var _baseIcons = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RSS_WINDOW_NAME = 'RSSWindow';
	var RSS_WINDOW_OPTIONS = (0, _lodash2.default)({
	  resizable: 1,
	  status: 0,
	  toolbar: 0,
	  scrollbars: 1,
	  location: 0,
	  menubar: 0
	}).map(function (value, key) {
	  return key + '=' + value;
	}).value().join(',');
	
	function RSSButton(_ref) {
	  var url = _ref.url;
	
	  var onClick = function onClick(e) {
	    e.preventDefault();
	    window.open(url, RSS_WINDOW_NAME, RSS_WINDOW_OPTIONS);
	  };
	
	  return _react2.default.createElement(
	    'a',
	    { href: url, className: 'btn btn-link cp-rss-button', onClick: onClick },
	    _react2.default.createElement(_baseIcons.RSS, null),
	    _react2.default.createElement(
	      _baseScreenReaderMessage2.default,
	      null,
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ada_rss_button' })
	    )
	  );
	}
	
	RSSButton.propTypes = {
	  url: _react.PropTypes.string.isRequired
	};

/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SearchTitle = __webpack_require__(1890);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SearchTitle).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SearchTitleDeprecated = __webpack_require__(1891);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SearchTitleDeprecated).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AddTitleOverlay = AddTitleOverlay;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseFullScreenOverlay = __webpack_require__(45);
	
	var _baseFullScreenOverlay2 = _interopRequireDefault(_baseFullScreenOverlay);
	
	var _bcPropTypes = __webpack_require__(5);
	
	__webpack_require__(2560);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// this Component is used to add styling to the AddTitle component
	function AddTitleOverlay(props) {
	  return _react2.default.createElement(
	    _baseFullScreenOverlay2.default,
	    { open: props.open, handleClose: props.handleClose, handleFocusOnRestore: props.handleFocusOnRestore, disableHistoryControls: true, className: 'cp-add-title-overlay' },
	    props.children
	  );
	}
	
	AddTitleOverlay.propTypes = {
	  open: _react.PropTypes.bool.isRequired,
	  handleClose: _react.PropTypes.func.isRequired,
	  children: _bcPropTypes.childrenShape,
	  handleFocusOnRestore: _react.PropTypes.func
	};
	
	exports.default = AddTitleOverlay;

/***/ },
/* 583 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AddToShelfComboButton = __webpack_require__(1898);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AddToShelfComboButton).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = BatchActionButton;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseButtons = __webpack_require__(12);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(2564);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function BatchActionButton(_ref) {
	  var className = _ref.className,
	      handleClick = _ref.handleClick,
	      selectedItemCount = _ref.selectedItemCount,
	      children = _ref.children;
	
	  return _react2.default.createElement(
	    _baseButtons.PrimaryButton,
	    {
	      className: (0, _classnames2.default)('cp-batch-action-button', className),
	      handleClick: handleClick,
	      disabled: selectedItemCount === 0 },
	    children,
	    selectedItemCount > 0 ? ' (' + selectedItemCount + ')' : ''
	  );
	}
	
	BatchActionButton.propTypes = {
	  className: _react.PropTypes.string,
	  handleClick: _react.PropTypes.func,
	  selectedItemCount: _react.PropTypes.number,
	  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node]).isRequired
	};

/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BatchActionsControls = __webpack_require__(1906);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BatchActionsControls).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BatchActionsToolbar = __webpack_require__(1910);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BatchActionsToolbar).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BranchDropdown = __webpack_require__(1913);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BranchDropdown).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _EmptyContentPanel = __webpack_require__(1924);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_EmptyContentPanel).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ActiveFilterToken = __webpack_require__(1925);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ActiveFilterToken).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CheckboxFilter = __webpack_require__(1928);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CheckboxFilter).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ExpandFilterLink = __webpack_require__(1929);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ExpandFilterLink).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FacetDrawerToggle = __webpack_require__(1932);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FacetDrawerToggle).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FieldList = __webpack_require__(1933);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FieldList).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _LinkFilter = __webpack_require__(1938);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_LinkFilter).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CancelHoldShelfPrompt = __webpack_require__(1946);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CancelHoldShelfPrompt).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BaseCancelHoldWorkflowView = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseInlineOverlay = __webpack_require__(83);
	
	var _baseButtons = __webpack_require__(12);
	
	var _baseIcons = __webpack_require__(10);
	
	var _sharedBibBrief = __webpack_require__(46);
	
	var _sharedBibBrief2 = _interopRequireDefault(_sharedBibBrief);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _sharedMessages = __webpack_require__(64);
	
	var _ShelfConstants = __webpack_require__(43);
	
	var _MessagingContainer = __webpack_require__(68);
	
	var _MessagingContainer2 = _interopRequireDefault(_MessagingContainer);
	
	var _cancelHoldShelfPrompt = __webpack_require__(595);
	
	var _cancelHoldShelfPrompt2 = _interopRequireDefault(_cancelHoldShelfPrompt);
	
	__webpack_require__(2593);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BaseCancelHoldWorkflowView = exports.BaseCancelHoldWorkflowView = function (_BcReactComponent) {
	  _inherits(BaseCancelHoldWorkflowView, _BcReactComponent);
	
	  function BaseCancelHoldWorkflowView(props) {
	    _classCallCheck(this, BaseCancelHoldWorkflowView);
	
	    var _this = _possibleConstructorReturn(this, (BaseCancelHoldWorkflowView.__proto__ || Object.getPrototypeOf(BaseCancelHoldWorkflowView)).call(this, props));
	
	    _this.state = {
	      shelfState: {
	        toAdd: false,
	        name: _ShelfConstants.SHELF_NAMES.FOR_LATER
	      }
	    };
	    _this.bindAll('handleShelfPromptChange', 'handleCancelHold');
	    return _this;
	  }
	
	  _createClass(BaseCancelHoldWorkflowView, [{
	    key: 'handleShelfPromptChange',
	    value: function handleShelfPromptChange(newShelfState) {
	      this.setState({
	        shelfState: _extends({}, this.state.shelfState, newShelfState)
	      });
	    }
	  }, {
	    key: 'handleCancelHold',
	    value: function handleCancelHold() {
	      var shelfState = this.state.shelfState;
	
	      this.props.handleClose();
	      this.props.handleCancelHold({ shelfState: shelfState });
	    }
	  }, {
	    key: 'renderShelfPrompt',
	    value: function renderShelfPrompt() {
	      if (this.props.showShelfPrompt && !this.props.done) {
	        return _react2.default.createElement(_cancelHoldShelfPrompt2.default, _extends({ handleChange: this.handleShelfPromptChange }, this.state.shelfState));
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderTitle',
	    value: function renderTitle() {
	      var holdIds = this.props.holdIds;
	
	
	      if (holdIds.size === 1) {
	        return _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'cancel_confirmation_hold_title' }),
	          '...'
	        );
	      }
	
	      return _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'cancel_confirmation_hold_batch_title', values: { count: holdIds.size } });
	    }
	  }, {
	    key: 'renderBibInfo',
	    value: function renderBibInfo() {
	      var _props = this.props,
	          bibs = _props.bibs,
	          holdIds = _props.holdIds;
	
	      var bib = bibs.first();
	      var showBrief = holdIds.size === 1 && bib;
	
	      return showBrief && _react2.default.createElement(_sharedBibBrief2.default, {
	        bib: bib,
	        titleTag: 'h3',
	        renderTitleAsLink: false,
	        renderAuthorsAsLink: false });
	    }
	  }, {
	    key: 'renderFooter',
	    value: function renderFooter() {
	      var _props2 = this.props,
	          isLoading = _props2.isLoading,
	          done = _props2.done;
	
	      return !done && _react2.default.createElement(
	        _baseInlineOverlay.InlineOverlayFooter,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-12' },
	          _react2.default.createElement(
	            _baseButtons.PrimaryButton,
	            { className: 'pull-right', isLoading: isLoading, handleClick: this.handleCancelHold, 'data-test-id': 'confirm-cancel-hold' },
	            _react2.default.createElement(_baseIcons.Checkmark, { color: '#FFF' }),
	            ' ',
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'cancel_confirmation_hold_button_yes' })
	          ),
	          _react2.default.createElement(
	            _baseInlineOverlay.InlineOverlayCloseButton,
	            { className: 'btn btn-link pull-right' },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_nevermind_close' })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          handleClose = _props3.handleClose,
	          testId = _props3.testId;
	
	      return _react2.default.createElement(
	        _baseInlineOverlay.InlineOverlay,
	        { handleClose: handleClose, 'data-test-id': testId },
	        _react2.default.createElement(
	          _baseInlineOverlay.InlineOverlayHeader,
	          null,
	          this.renderTitle()
	        ),
	        _react2.default.createElement(
	          _baseInlineOverlay.InlineOverlayBody,
	          { className: 'cp-base-cancel-hold-workflow-view' },
	          _react2.default.createElement(
	            _MessagingContainer2.default,
	            { id: this.props.messagingId },
	            function (messageOptions) {
	              return _react2.default.createElement(_sharedMessages.GenericForm, _extends({}, messageOptions, { duration: false }));
	            }
	          ),
	          this.renderBibInfo(),
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'your_position_will_be_lost' }),
	          this.renderShelfPrompt()
	        ),
	        this.renderFooter()
	      );
	    }
	  }]);
	
	  return BaseCancelHoldWorkflowView;
	}(_baseBcReactComponent2.default);
	
	BaseCancelHoldWorkflowView.propTypes = {
	  handleCancelHold: _react.PropTypes.func.isRequired,
	  handleClose: _react.PropTypes.func.isRequired,
	  accountId: _react.PropTypes.number.isRequired,
	  holdIds: _reactImmutableProptypes2.default.listOf(_react.PropTypes.string),
	  isLoading: _react.PropTypes.bool,
	  done: _react.PropTypes.bool,
	  showShelfPrompt: _react.PropTypes.bool,
	  bibs: _reactImmutableProptypes2.default.listOf(_bcPropTypes.bibShape).isRequired,
	  testId: _react.PropTypes.string,
	  messagingId: _react.PropTypes.string
	};
	
	BaseCancelHoldWorkflowView.defaultProps = {
	  showShelfPrompt: true
	};
	
	exports.default = BaseCancelHoldWorkflowView;

/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DigitalDurations = __webpack_require__(1956);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DigitalDurations).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DigitalNotificationEmail = __webpack_require__(1962);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DigitalNotificationEmail).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ItemLevelHoldsWorkflowTitle;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _reactIntl = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var anyItemGroupsHaveCopy = function anyItemGroupsHaveCopy(itemGroups) {
	  return !itemGroups.filter(function (item) {
	    return item.get('copy', false);
	  }).isEmpty();
	};
	
	var anyItemGroupsHaveVolume = function anyItemGroupsHaveVolume(itemGroups) {
	  return !itemGroups.filter(function (item) {
	    return item.get('volume', false);
	  }).isEmpty();
	};
	
	var getLocalizationForTitle = function getLocalizationForTitle(itemGroups) {
	  var someHaveCopy = anyItemGroupsHaveCopy(itemGroups);
	  var someHaveVolume = anyItemGroupsHaveVolume(itemGroups);
	
	  if (someHaveCopy && !someHaveVolume) {
	    return 'section_title_copy_for_title';
	  } else if (someHaveVolume && !someHaveCopy) {
	    return 'section_title_volume_for_title';
	  }
	
	  // If there is a mix of copies and volumes, or no items have either, just say "item"
	  return 'section_title_item_for_title';
	};
	
	function ItemLevelHoldsWorkflowTitle(_ref) {
	  var itemGroups = _ref.itemGroups,
	      bibTitle = _ref.bibTitle;
	
	  return _react2.default.createElement(
	    'h2',
	    { className: 'cp-item-level-holds-workflow-title' },
	    _react2.default.createElement(_reactIntl.FormattedMessage, {
	      id: getLocalizationForTitle(itemGroups),
	      values: { title: bibTitle } })
	  );
	}
	
	ItemLevelHoldsWorkflowTitle.propTypes = {
	  itemGroups: _reactImmutableProptypes2.default.list,
	  bibTitle: _react.PropTypes.string
	};

/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ShelfMessage = __webpack_require__(1969);
	
	Object.defineProperty(exports, 'ShelfMessage', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ShelfMessage).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Panel = __webpack_require__(1971);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Panel).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TagDisplay = __webpack_require__(1991);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TagDisplay).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CommentUGCEditor = __webpack_require__(1993);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CommentUGCEditor).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PrivateNoteUGCEditor = __webpack_require__(1994);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PrivateNoteUGCEditor).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SimilarTitlesUGCEditor = __webpack_require__(1996);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SimilarTitlesUGCEditor).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TagsUGCEditor = __webpack_require__(1997);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TagsUGCEditor).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _VideoUGCEditor = __webpack_require__(1999);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_VideoUGCEditor).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _VideoPlayback = __webpack_require__(2002);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_VideoPlayback).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _UtilityBar = __webpack_require__(2003);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_UtilityBar).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 610 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ShelfAddTitleButton = __webpack_require__(2008);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ShelfAddTitleButton).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utilsRedux = __webpack_require__(20);
	
	exports.default = (0, _utilsRedux.createReduxConstants)('ANALYTICS', {
	  FETCH_DATALAYER_REQUEST: null,
	  FETCH_DATALAYER_SUCCESS: null,
	  FETCH_DATALAYER_FAILURE: null
	});

/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utilsRedux = __webpack_require__(20);
	
	exports.default = (0, _utilsRedux.createReduxConstants)('AVAILABILITY', {
	  AVAILABILITY_DETAIL_REQUEST: null,
	  AVAILABILITY_DETAIL_SUCCESS: null,
	  AVAILABILITY_DETAIL_ERROR: null,
	
	  DIGITAL_AVAILABILITY_REQUEST: null,
	  DIGITAL_AVAILABILITY_SUCCESS: null,
	  DIGITAL_AVAILABILITY_ERROR: null,
	
	  HOLDINGS_PROBE_REQUEST: null,
	  HOLDINGS_PROBE_SUCCESS: null,
	  HOLDINGS_PROBE_ERROR: null
	});

/***/ },
/* 613 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utilsRedux = __webpack_require__(20);
	
	exports.default = (0, _utilsRedux.createReduxConstants)('COMMENTS', {
	  ADD_COMMENT_REQUEST: null,
	  ADD_COMMENT_SUCCESS: null,
	  ADD_COMMENT_FAILURE: null,
	  UPDATE_COMMENT_REQUEST: null,
	  UPDATE_COMMENT_SUCCESS: null,
	  UPDATE_COMMENT_FAILURE: null,
	  REMOVE_COMMENT_REQUEST: null,
	  REMOVE_COMMENT_SUCCESS: null,
	  REMOVE_COMMENT_FAILURE: null
	});

/***/ },
/* 614 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utilsRedux = __webpack_require__(20);
	
	exports.default = (0, _utilsRedux.createReduxConstants)('DRAWER', {
	  TOGGLE: null
	});

/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utilsRedux = __webpack_require__(20);
	
	exports.default = (0, _utilsRedux.createReduxConstants)('ERROR', {
	  STORE_INTERNAL_ERROR: null
	});

/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utilsRedux = __webpack_require__(20);
	
	exports.default = (0, _utilsRedux.createReduxConstants)('FEATURED_CONTENT', {
	  FEATURED_CONTENT_REQUEST: null,
	  FEATURED_CONTENT_SUCCESS: null,
	  FEATURED_CONTENT_FAILURE: null
	});

/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utilsRedux = __webpack_require__(20);
	
	exports.default = (0, _utilsRedux.createReduxConstants)('FEEDBACK', {
	  EXPAND_FEEDBACK: null,
	  COLLAPSE_FEEDBACK: null,
	  UPDATE_CATEGORY: null,
	
	  SUBMIT_FEEDBACK_REQUEST: null,
	  SUBMIT_FEEDBACK_SUCCESS: null,
	  SUBMIT_FEEDBACK_FAILURE: null
	});

/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utilsRedux = __webpack_require__(20);
	
	exports.default = (0, _utilsRedux.createReduxConstants)('FINES', {
	  FETCH_FINES_REQUEST: null,
	  FETCH_FINES_SUCCESS: null,
	  FETCH_FINES_FAILURE: null,
	  FETCH_FINES_PAYMENT_FORM_REQUEST: null,
	  FETCH_FINES_PAYMENT_FORM_FAILURE: null,
	  FETCH_FINES_PAYMENT_FORM_SUCCESS: null,
	  EMPTY_FINES_PAYMENT: null,
	  UPDATE_PAGE_REQUEST: null,
	  UPDATE_PAGE_SUCCESS: null,
	  UPDATE_PAGE_FAILURE: null
	});

/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utilsRedux = __webpack_require__(20);
	
	exports.default = (0, _utilsRedux.createReduxConstants)('GROUP_SEARCH_FEEDBACK', {
	  OPEN_FEEDBACK_OVERLAY: null,
	  CLOSE_FEEDBACK_OVERLAY: null,
	
	  CHOOSE_SHOULD_MATCH: null,
	
	  SELECT_MATCHING_BIB: null,
	  CHANGE_MATCHING_BIB: null,
	
	  SUBMIT_FEEDBACK_REQUEST: null,
	  SUBMIT_FEEDBACK_SUCCESS: null,
	  SUBMIT_FEEDBACK_FAILURE: null
	});

/***/ },
/* 620 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utilsRedux = __webpack_require__(20);
	
	exports.default = (0, _utilsRedux.createReduxConstants)('I_OWN_THIS_SETTINGS', {
	  CREATE_I_OWN_THIS_SETTING_REQUEST: null,
	  CREATE_I_OWN_THIS_SETTING_SUCCESS: null,
	  CREATE_I_OWN_THIS_SETTING_FAILURE: null,
	  REMOVE_I_OWN_THIS_SETTING_REQUEST: null,
	  REMOVE_I_OWN_THIS_SETTING_SUCCESS: null,
	  REMOVE_I_OWN_THIS_SETTING_FAILURE: null
	});

/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utilsRedux = __webpack_require__(20);
	
	exports.default = (0, _utilsRedux.createReduxConstants)('ILL', {
	  FETCH_ILL_REQUEST: null,
	  FETCH_ILL_SUCCESS: null,
	  FETCH_ILL_FAILURE: null
	});

/***/ },
/* 622 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utilsRedux = __webpack_require__(20);
	
	exports.default = (0, _utilsRedux.createReduxConstants)('LIST_PRESENTATION', {
	  TOGGLE_LIST_VIEW: null
	});

/***/ },
/* 623 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utilsRedux = __webpack_require__(20);
	
	exports.default = (0, _utilsRedux.createReduxConstants)('MESSAGES', {
	  FETCH_MESSAGES_REQUEST: null,
	  FETCH_MESSAGES_SUCCESS: null,
	  FETCH_MESSAGES_FAILURE: null
	});

/***/ },
/* 624 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.HIDDEN_NOTICES_COOKIE = undefined;
	
	var _utilsRedux = __webpack_require__(20);
	
	var HIDDEN_NOTICES_COOKIE = exports.HIDDEN_NOTICES_COOKIE = 'hidden_notices';
	
	exports.default = (0, _utilsRedux.createReduxConstants)('NOTICE', {
	  DISMISS_NOTICE: null
	});

/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.OPT_IN_BUNDLES = undefined;
	
	var _utilsRedux = __webpack_require__(20);
	
	// bundle -> [array, of, feature, flags]
	var OPT_IN_BUNDLES = exports.OPT_IN_BUNDLES = {
	  nerf_search: ['nerf_search']
	};
	
	exports.default = (0, _utilsRedux.createReduxConstants)('OPT_IN', {
	  TOGGLE_OPT_IN_FEEDBACK_FORM: null,
	  DISMISS_OPT_IN: null,
	  CLOSE_FEEDBACK_SUCCESS: null,
	  SUBMIT_OPT_IN_FEEDBACK_REQUEST: null,
	  SUBMIT_OPT_IN_FEEDBACK_SUCCESS: null,
	  SUBMIT_OPT_IN_FEEDBACK_FAILURE: null,
	  OPT_IN_REQUEST: null,
	  OPT_IN_SUCCESS: null,
	  OPT_IN_FAILURE: null,
	  OPT_OUT_REQUEST: null,
	  OPT_OUT_SUCCESS: null,
	  OPT_OUT_FAILURE: null
	});

/***/ },
/* 626 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utilsRedux = __webpack_require__(20);
	
	exports.default = (0, _utilsRedux.createReduxConstants)('PRIVATE_NOTES', {
	  ADD_PRIVATE_NOTES_REQUEST: null,
	  ADD_PRIVATE_NOTES_SUCCESS: null,
	  ADD_PRIVATE_NOTES_FAILURE: null,
	  UPDATE_PRIVATE_NOTES_REQUEST: null,
	  UPDATE_PRIVATE_NOTES_SUCCESS: null,
	  UPDATE_PRIVATE_NOTES_FAILURE: null,
	  REMOVE_PRIVATE_NOTES_REQUEST: null,
	  REMOVE_PRIVATE_NOTES_SUCCESS: null,
	  REMOVE_PRIVATE_NOTES_FAILURE: null
	});

/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utilsRedux = __webpack_require__(20);
	
	exports.default = (0, _utilsRedux.createReduxConstants)('QUOTATIONS', {
	  ADD_QUOTATION_REQUEST: null,
	  ADD_QUOTATION_SUCCESS: null,
	  ADD_QUOTATION_FAILURE: null,
	  UPDATE_QUOTATION_REQUEST: null,
	  UPDATE_QUOTATION_SUCCESS: null,
	  UPDATE_QUOTATION_FAILURE: null,
	  REMOVE_QUOTATION_REQUEST: null,
	  REMOVE_QUOTATION_SUCCESS: null,
	  REMOVE_QUOTATION_FAILURE: null
	});

/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utilsRedux = __webpack_require__(20);
	
	exports.default = (0, _utilsRedux.createReduxConstants)('RATINGS', {
	  GET_ITEM_RATING_REQUEST: null,
	  GET_ITEM_RATING_SUCCESS: null,
	  GET_ITEM_RATING_FAILURE: null,
	  RATE_ITEM_REQUEST: null,
	  RATE_ITEM_SUCCESS: null,
	  RATE_ITEM_FAILURE: null,
	  CHANGE_ITEM_RATING_REQUEST: null,
	  CHANGE_ITEM_RATING_SUCCESS: null,
	  CHANGE_ITEM_RATING_FAILURE: null,
	  REMOVE_ITEM_RATING_REQUEST: null,
	  REMOVE_ITEM_RATING_SUCCESS: null,
	  REMOVE_ITEM_RATING_FAILURE: null
	});

/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utilsRedux = __webpack_require__(20);
	
	exports.default = (0, _utilsRedux.createReduxConstants)('RETURN_HISTORY', {
	  FETCH_RETURN_HISTORY_REQUEST: null,
	  FETCH_RETURN_HISTORY_SUCCESS: null,
	  FETCH_RETURN_HISTORY_FAILURE: null
	});

/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utilsRedux = __webpack_require__(20);
	
	exports.default = (0, _utilsRedux.createReduxConstants)('ROUTER', {
	  LOCATION_CHANGED: null,
	  ROUTER_TRANSITION: null
	});

/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utilsRedux = __webpack_require__(20);
	
	exports.default = (0, _utilsRedux.createReduxConstants)('SIMILAR_TITLES', {
	  ADD_SIMILAR_TITLES_REQUEST: null,
	  ADD_SIMILAR_TITLES_SUCCESS: null,
	  ADD_SIMILAR_TITLES_FAILURE: null,
	  REMOVE_SIMILAR_TITLES_REQUEST: null,
	  REMOVE_SIMILAR_TITLES_SUCCESS: null,
	  REMOVE_SIMILAR_TITLES_FAILURE: null
	});

/***/ },
/* 632 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utilsRedux = __webpack_require__(20);
	
	exports.default = (0, _utilsRedux.createReduxConstants)('STACK_MAP', {
	  REQUEST: null,
	  SUCCESS: null,
	  FAILURE: null,
	  CLOSE: null
	});

/***/ },
/* 633 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utilsRedux = __webpack_require__(20);
	
	exports.default = (0, _utilsRedux.createReduxConstants)('USER', {
	  FETCH_USER_REQUEST: null,
	  FETCH_USER_SUCCESS: null,
	  FETCH_USER_ERROR: null
	});

/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utilsRedux = __webpack_require__(20);
	
	exports.default = (0, _utilsRedux.createReduxConstants)('VIDEOS', {
	  ADD_VIDEO_REQUEST: null,
	  ADD_VIDEO_SUCCESS: null,
	  ADD_VIDEO_FAILURE: null,
	  UPDATE_VIDEO_REQUEST: null,
	  UPDATE_VIDEO_SUCCESS: null,
	  UPDATE_VIDEO_FAILURE: null,
	  REMOVE_VIDEO_REQUEST: null,
	  REMOVE_VIDEO_SUCCESS: null,
	  REMOVE_VIDEO_FAILURE: null
	});

/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AccountSwitcherContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(14);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _LibrarySelector = __webpack_require__(33);
	
	var _AccountSwitcher = __webpack_require__(1826);
	
	var _AccountSwitcher2 = _interopRequireDefault(_AccountSwitcher);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AccountSwitcherContainer = exports.AccountSwitcherContainer = function (_BcReactComponent) {
	  _inherits(AccountSwitcherContainer, _BcReactComponent);
	
	  function AccountSwitcherContainer() {
	    _classCallCheck(this, AccountSwitcherContainer);
	
	    return _possibleConstructorReturn(this, (AccountSwitcherContainer.__proto__ || Object.getPrototypeOf(AccountSwitcherContainer)).apply(this, arguments));
	  }
	
	  _createClass(AccountSwitcherContainer, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_AccountSwitcher2.default, { linkedLibrariesById: this.props.linkedLibrariesById });
	    }
	  }]);
	
	  return AccountSwitcherContainer;
	}(_baseBcReactComponent2.default);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    linkedLibrariesById: (0, _LibrarySelector.getLinkedLibrariesById)(state)
	  };
	};
	
	AccountSwitcherContainer.propTypes = {
	  linkedLibrariesById: _reactImmutableProptypes2.default.mapOf(_bcPropTypes.siteShape)
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(AccountSwitcherContainer);

/***/ },
/* 636 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(14);
	
	var _redux = __webpack_require__(18);
	
	var _login = __webpack_require__(539);
	
	var _AuthActions = __webpack_require__(378);
	
	var _AuthActions2 = _interopRequireDefault(_AuthActions);
	
	var _LibrarySelector = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoginOverlayContainer = function LoginOverlayContainer(_ref) {
	  var authActions = _ref.authActions,
	      loginOverlayOpen = _ref.loginOverlayOpen,
	      loginErrorMessage = _ref.loginErrorMessage,
	      loading = _ref.loading,
	      numericPasswordRequired = _ref.numericPasswordRequired,
	      getCardLink = _ref.getCardLink;
	  return _react2.default.createElement(_login.LoginOverlay, {
	    loginOverlayOpen: loginOverlayOpen,
	    login: authActions.login,
	    loginErrorMessage: loginErrorMessage,
	    handleClose: authActions.closeLoginOverlay,
	    loading: loading,
	    numericPasswordRequired: numericPasswordRequired,
	    getCardLink: getCardLink });
	};
	
	LoginOverlayContainer.propTypes = {
	  authActions: _react.PropTypes.shape({
	    login: _react.PropTypes.func,
	    logout: _react.PropTypes.func,
	    loadUser: _react.PropTypes.func,
	    closeLoginOverlay: _react.PropTypes.func
	  }),
	  loginErrorMessage: _react.PropTypes.string,
	  loginOverlayOpen: _react.PropTypes.bool,
	  loading: _react.PropTypes.bool,
	  numericPasswordRequired: _react.PropTypes.bool,
	  getCardLink: _react.PropTypes.string
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    authActions: (0, _redux.bindActionCreators)(_AuthActions2.default, dispatch)
	  };
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    loginErrorMessage: state.getIn(['auth', 'loginErrorMessage']),
	    loginOverlayOpen: state.getIn(['auth', 'loginOverlayOpen']),
	    loading: state.getIn(['auth', 'loading']),
	    numericPasswordRequired: (0, _LibrarySelector.currentLibrarySelector)(state).get('numericPasswordRequired'),
	    getCardLink: (0, _LibrarySelector.currentLibrarySelector)(state).get('getCardLink') || ''
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(LoginOverlayContainer);

/***/ },
/* 637 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.OptInContainer = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(14);
	
	var _redux = __webpack_require__(18);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _optIn = __webpack_require__(1442);
	
	var _optIn2 = _interopRequireDefault(_optIn);
	
	var _OptInActions = __webpack_require__(1586);
	
	var _OptInActions2 = _interopRequireDefault(_OptInActions);
	
	var _AuthSelector = __webpack_require__(21);
	
	var _PropTypes = __webpack_require__(90);
	
	var _PropTypes2 = _interopRequireDefault(_PropTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  bundleName: _react.PropTypes.string.isRequired,
	  feedbackCategory: _react.PropTypes.string.isRequired,
	  location: _react.PropTypes.shape(_PropTypes2.default),
	  optedIn: _react.PropTypes.bool,
	  optInActions: _react.PropTypes.object.isRequired,
	  allowOptOut: _react.PropTypes.bool,
	  allowDismiss: _react.PropTypes.bool,
	  showAdditionalMessage: _react.PropTypes.bool,
	  user: _react.PropTypes.object // TODO: Create bc user shape proptype.
	};
	
	var OptInContainer = exports.OptInContainer = function (_BcReactComponent) {
	  _inherits(OptInContainer, _BcReactComponent);
	
	  function OptInContainer() {
	    _classCallCheck(this, OptInContainer);
	
	    return _possibleConstructorReturn(this, (OptInContainer.__proto__ || Object.getPrototypeOf(OptInContainer)).apply(this, arguments));
	  }
	
	  _createClass(OptInContainer, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          bundleName = _props.bundleName,
	          feedbackCategory = _props.feedbackCategory,
	          location = _props.location,
	          optedIn = _props.optedIn,
	          optInActions = _props.optInActions,
	          optInBanner = _props.optInBanner,
	          publicBeta = _props.publicBeta,
	          user = _props.user,
	          showAdditionalMessage = _props.showAdditionalMessage,
	          allowOptOut = _props.allowOptOut,
	          allowDismiss = _props.allowDismiss;
	
	
	      if (!user && !publicBeta) {
	        return null;
	      }
	
	      return _react2.default.createElement(_optIn2.default, _extends({
	        feedbackCategory: feedbackCategory,
	        actions: optInActions,
	        bundle: bundleName,
	        allowOptOut: allowOptOut,
	        allowDismiss: allowDismiss,
	        optedIn: optedIn,
	        showAdditionalMessage: showAdditionalMessage,
	        location: location
	      }, optInBanner));
	    }
	  }]);
	
	  return OptInContainer;
	}(_baseBcReactComponent2.default);
	
	OptInContainer.propTypes = propTypes;
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  var user = (0, _AuthSelector.currentUserSelector)(state);
	  return {
	    user: user,
	    optedIn: !!state.getIn(['entities', 'optIn', ownProps.bundleName]) || ownProps.optedIn,
	    optInBanner: state.getIn(['optIn', ownProps.bundleName], _immutable2.default.Map()).toObject(),
	    feedbackCategory: ownProps.feedbackCategory || ownProps.bundleName,
	    publicBeta: ownProps.bundleName === 'nerf_search' && state.getIn(['app', 'featureFlags', 'nerfSearchPublicBeta'])
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    optInActions: (0, _redux.bindActionCreators)(_OptInActions2.default, dispatch)
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(OptInContainer);

/***/ },
/* 638 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SearchProbeContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(14);
	
	var _reactRouter = __webpack_require__(17);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _redux = __webpack_require__(18);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _probes = __webpack_require__(541);
	
	var _SearchActions = __webpack_require__(144);
	
	var _SearchActions2 = _interopRequireDefault(_SearchActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SearchProbeContainer = exports.SearchProbeContainer = function (_BcReactComponent) {
	  _inherits(SearchProbeContainer, _BcReactComponent);
	
	  function SearchProbeContainer() {
	    _classCallCheck(this, SearchProbeContainer);
	
	    return _possibleConstructorReturn(this, (SearchProbeContainer.__proto__ || Object.getPrototypeOf(SearchProbeContainer)).apply(this, arguments));
	  }
	
	  _createClass(SearchProbeContainer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getSearchProbes(this.props.location.query);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var query = this.props.location.query;
	      var nextQuery = nextProps.location.query;
	
	      if (query.query !== nextQuery.query || query.searchType !== nextQuery.searchType) {
	        this.getSearchProbes(nextQuery);
	      }
	    }
	  }, {
	    key: 'getSearchProbes',
	    value: function getSearchProbes(query) {
	      this.props.searchActions.getSearchProbes(query.query, query.searchType);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var probes = this.props.probes;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-search-probes' },
	        _react2.default.createElement(_probes.SearchProbeList, { probes: probes })
	      );
	    }
	  }]);
	
	  return SearchProbeContainer;
	}(_baseBcReactComponent2.default);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    probes: state.getIn(['search', 'catalogSearch', 'probes'])
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    searchActions: (0, _redux.bindActionCreators)(_SearchActions2.default, dispatch)
	  };
	};
	
	SearchProbeContainer.propTypes = {
	  probes: _reactImmutableProptypes2.default.map,
	  searchType: _react.PropTypes.string,
	  getSearchProbes: _react.PropTypes.func.isRequired,
	  searchActions: _react.PropTypes.objectOf(_react.PropTypes.func),
	  router: _reactRouter.routerShape
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactRouter.withRouter)(SearchProbeContainer));

/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AddTitleContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(14);
	
	var _redux = __webpack_require__(18);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _AddTitle = __webpack_require__(387);
	
	var _SearchSelector = __webpack_require__(400);
	
	var _SearchActions = __webpack_require__(144);
	
	var _SearchActions2 = _interopRequireDefault(_SearchActions);
	
	var _AvailabilityDetailActions = __webpack_require__(122);
	
	var _AvailabilityDetailActions2 = _interopRequireDefault(_AvailabilityDetailActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AddTitleContainer = exports.AddTitleContainer = function (_BcReactComponent) {
	  _inherits(AddTitleContainer, _BcReactComponent);
	
	  function AddTitleContainer() {
	    _classCallCheck(this, AddTitleContainer);
	
	    return _possibleConstructorReturn(this, (AddTitleContainer.__proto__ || Object.getPrototypeOf(AddTitleContainer)).apply(this, arguments));
	  }
	
	  _createClass(AddTitleContainer, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          addTitleResult = _props.addTitleResult,
	          searchActions = _props.searchActions,
	          availabilityDetailActions = _props.availabilityDetailActions,
	          isUpdatingResultItem = _props.isUpdatingResultItem,
	          isWrappedInForm = _props.isWrappedInForm;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_AddTitle.AddTitle, {
	          isUpdatingResultItem: isUpdatingResultItem,
	          searchActions: searchActions,
	          availabilityDetailActions: availabilityDetailActions,
	          searchQuery: addTitleResult.get('searchQuery'),
	          pagination: addTitleResult.get('pagination'),
	          zeroResults: addTitleResult.get('zeroResults'),
	          results: addTitleResult.get('items'),
	          isFetching: addTitleResult.get('isFetching'),
	          handleClose: this.props.handleClose,
	          renderAddOn: this.props.renderAddOn,
	          addRowClassNames: this.props.addRowClassNames,
	          isWrappedInForm: isWrappedInForm })
	      );
	    }
	  }]);
	
	  return AddTitleContainer;
	}(_baseBcReactComponent2.default);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    addTitleResult: (0, _SearchSelector.getAddTitleResult)(state)
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    searchActions: (0, _redux.bindActionCreators)(_SearchActions2.default, dispatch),
	    availabilityDetailActions: (0, _redux.bindActionCreators)(_AvailabilityDetailActions2.default, dispatch)
	  };
	};
	
	AddTitleContainer.propTypes = {
	  searchActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  availabilityDetailActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  addTitleResult: _bcPropTypes.addTitleResultShape.isRequired,
	  handleClose: _react.PropTypes.func.isRequired,
	  addRowClassNames: _react.PropTypes.func,
	  renderAddOn: _react.PropTypes.func,
	  isUpdatingResultItem: _react.PropTypes.bool,
	  isWrappedInForm: _react.PropTypes.bool
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AddTitleContainer);

/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _itemLevelHoldExceptionEpic = __webpack_require__(2106);
	
	Object.defineProperty(exports, 'itemLevelHoldExceptionEpic', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_itemLevelHoldExceptionEpic).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 641 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = composeMessagingForBatchAction;
	
	var _composeGlobalSuccessMessaging = __webpack_require__(245);
	
	var _composeGlobalSuccessMessaging2 = _interopRequireDefault(_composeGlobalSuccessMessaging);
	
	var _composeGlobalFailureMessaging = __webpack_require__(244);
	
	var _composeGlobalFailureMessaging2 = _interopRequireDefault(_composeGlobalFailureMessaging);
	
	var _composeGlobalNeutralMessaging = __webpack_require__(2108);
	
	var _composeGlobalNeutralMessaging2 = _interopRequireDefault(_composeGlobalNeutralMessaging);
	
	var _composeMessaging = __webpack_require__(189);
	
	var _composeMessaging2 = _interopRequireDefault(_composeMessaging);
	
	var _MessagingConstants = __webpack_require__(73);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function composeMessagingForBatchAction(_ref) {
	  var total = _ref.total,
	      failures = _ref.failures,
	      successId = _ref.successId,
	      mixedId = _ref.mixedId,
	      failureId = _ref.failureId,
	      values = _ref.values,
	      _ref$useFormattedMess = _ref.useFormattedMessage,
	      useFormattedMessage = _ref$useFormattedMess === undefined ? false : _ref$useFormattedMess;
	
	  if (failures && failures.length > 0) {
	    var successCount = total - failures.length;
	    var failureCount = failures.length;
	
	    // If there was only one item and it failed, show the error directly
	    if (failureCount === 1 && successCount === 0) {
	      return (0, _composeGlobalFailureMessaging2.default)(failures[0].errorResponseDTO, { values: values, useFormattedMessage: useFormattedMessage });
	    }
	
	    var failureMessage = (0, _composeMessaging2.default)(_MessagingConstants.STATUS_TYPES.Failure, _MessagingConstants.GLOBAL_MESSAGING_ID, failureId, { values: _extends({}, values, { count: failureCount }), useFormattedMessage: useFormattedMessage });
	
	    var neutralMessage = (0, _composeGlobalNeutralMessaging2.default)(mixedId, { values: _extends({}, values, { successCount: successCount, failureCount: failureCount }), useFormattedMessage: useFormattedMessage });
	
	    return successCount === 0 ? failureMessage : neutralMessage;
	  }
	
	  return (0, _composeGlobalSuccessMessaging2.default)(successId, { values: values, useFormattedMessage: useFormattedMessage });
	}

/***/ },
/* 642 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatFilterForQuery;
	
	var _FacetConstants = __webpack_require__(187);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function formatFilterForQuery(fieldId, activeFiltersForField) {
	  var key = '' + _FacetConstants.FILTER_PREFIX + fieldId;
	  var value = activeFiltersForField.map(function (filter) {
	    return filter.get('value');
	  }).join(_FacetConstants.FILTER_SEPARATOR);
	  return _defineProperty({}, key, value);
	}

/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getToggledFilter;
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _FacetConstants = __webpack_require__(187);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function getToggledFilter(fieldId, currentFilter, activeFilters) {
	  var queryField = '' + _FacetConstants.FILTER_PREFIX + fieldId;
	  var filterValue = currentFilter.get('value');
	  var activeValues = activeFilters.get(fieldId, _immutable2.default.List()).map(function (f) {
	    return f.get('value');
	  });
	  var newValues = activeValues.includes(filterValue) ? activeValues.filter(function (val) {
	    return val !== filterValue;
	  }) : activeValues.push(filterValue);
	
	  return _defineProperty({}, queryField, newValues.size > 0 ? newValues.join(_FacetConstants.FILTER_SEPARATOR) : undefined);
	}

/***/ },
/* 644 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _AppReducer = __webpack_require__(2111);
	
	var _AppReducer2 = _interopRequireDefault(_AppReducer);
	
	var _AnalyticsReducer = __webpack_require__(2110);
	
	var _AnalyticsReducer2 = _interopRequireDefault(_AnalyticsReducer);
	
	var _AuthReducer = __webpack_require__(2112);
	
	var _AuthReducer2 = _interopRequireDefault(_AuthReducer);
	
	var _AvailabilityDetailReducer = __webpack_require__(2113);
	
	var _AvailabilityDetailReducer2 = _interopRequireDefault(_AvailabilityDetailReducer);
	
	var _DrawerReducer = __webpack_require__(2114);
	
	var _DrawerReducer2 = _interopRequireDefault(_DrawerReducer);
	
	var _InternalErrorReducer = __webpack_require__(2115);
	
	var _InternalErrorReducer2 = _interopRequireDefault(_InternalErrorReducer);
	
	var _LibraryReducer = __webpack_require__(2116);
	
	var _LibraryReducer2 = _interopRequireDefault(_LibraryReducer);
	
	var _LocalizationReducer = __webpack_require__(2117);
	
	var _LocalizationReducer2 = _interopRequireDefault(_LocalizationReducer);
	
	var _OptInReducer = __webpack_require__(2118);
	
	var _OptInReducer2 = _interopRequireDefault(_OptInReducer);
	
	var _RecommendationReducer = __webpack_require__(2119);
	
	var _RecommendationReducer2 = _interopRequireDefault(_RecommendationReducer);
	
	var _search = __webpack_require__(2136);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _shelves = __webpack_require__(2140);
	
	var _shelves2 = _interopRequireDefault(_shelves);
	
	var _ugc = __webpack_require__(2149);
	
	var _ugc2 = _interopRequireDefault(_ugc);
	
	var _TemplatesReducer = __webpack_require__(2120);
	
	var _TemplatesReducer2 = _interopRequireDefault(_TemplatesReducer);
	
	var _UserReducer = __webpack_require__(2121);
	
	var _UserReducer2 = _interopRequireDefault(_UserReducer);
	
	var _borrowing = __webpack_require__(2129);
	
	var _borrowing2 = _interopRequireDefault(_borrowing);
	
	var _ui = __webpack_require__(2162);
	
	var _ui2 = _interopRequireDefault(_ui);
	
	var _entities = __webpack_require__(2131);
	
	var _entities2 = _interopRequireDefault(_entities);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _immutable2.default.Map({
	  app: _AppReducer2.default,
	  availabilityDetail: _AvailabilityDetailReducer2.default,
	  auth: _AuthReducer2.default,
	  analytics: _AnalyticsReducer2.default,
	  drawer: _DrawerReducer2.default,
	  library: _LibraryReducer2.default,
	  localization: _LocalizationReducer2.default,
	  recommendation: _RecommendationReducer2.default,
	  entities: _entities2.default,
	  templates: _TemplatesReducer2.default,
	  search: _search2.default,
	  shelves: _shelves2.default,
	  optIn: _OptInReducer2.default,
	  internalError: _InternalErrorReducer2.default,
	  ui: _ui2.default,
	  user: _UserReducer2.default,
	  borrowing: _borrowing2.default,
	  ugc: _ugc2.default
	});

/***/ },
/* 645 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getCurrentView = undefined;
	
	var _reselect = __webpack_require__(34);
	
	var getCurrentViewFromState = function getCurrentViewFromState(state) {
	  return state.getIn(['ui', 'listPresentation', 'view']);
	};
	
	var getCurrentView = exports.getCurrentView = (0, _reselect.createSelector)(getCurrentViewFromState, function (currentView) {
	  return currentView;
	});
	
	exports.default = {
	  getCurrentView: getCurrentView
	};

/***/ },
/* 646 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getHiddenNotices = undefined;
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reselect = __webpack_require__(34);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getLocalBranch = function getLocalBranch(state) {
	  return state.getIn(['app', 'localBranch']);
	};
	var hiddenNotices = function hiddenNotices(state) {
	  return state.getIn(['ui', 'notices', 'hidden'], _immutable2.default.Set());
	};
	
	var getHiddenNotices = exports.getHiddenNotices = (0, _reselect.createSelector)([hiddenNotices, getLocalBranch], function (hidden, localBranch) {
	  return localBranch ? _immutable2.default.Set() : _immutable2.default.Set(hidden);
	});
	
	exports.default = {
	  getHiddenNotices: getHiddenNotices
	};

/***/ },
/* 647 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getRecentlyReturnedWithBibs = exports.getBorrowingHistoryData = undefined;
	
	var _reselect = __webpack_require__(34);
	
	var _ShelfSelector = __webpack_require__(75);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var borrowingHistory = function borrowingHistory(state) {
	  return state.getIn(['borrowing', 'borrowingHistory'], _immutable2.default.Map());
	};
	var currentItemIds = function currentItemIds(state) {
	  return state.getIn(['borrowing', 'borrowingHistory', 'results'], _immutable2.default.List());
	};
	var allRecentlyReturned = function allRecentlyReturned(state) {
	  return state.getIn(['entities', 'borrowingHistory'], _immutable2.default.Map());
	};
	var allBibs = function allBibs(state) {
	  return state.getIn(['entities', 'bibs'], _immutable2.default.Map());
	};
	
	var getBorrowingHistoryData = exports.getBorrowingHistoryData = (0, _reselect.createSelector)([borrowingHistory], function (data) {
	  return data;
	});
	
	var getRecentlyReturnedWithBibs = exports.getRecentlyReturnedWithBibs = (0, _reselect.createSelector)(currentItemIds, allRecentlyReturned, allBibs, _ShelfSelector.getShelvesForCurrentUser, function (itemIds, itemsById, bibs, shelfItems) {
	  var recentReturns = itemIds.map(function (id) {
	    return itemsById.get(id);
	  }).filter(function (item) {
	    return !!item;
	  }).map(function (recentReturn) {
	    return recentReturn.set('bib', bibs.get(recentReturn.get('metadataId')));
	  }).map(function (recentReturn) {
	    var isAlreadyOnShelf = shelfItems.some(function (item) {
	      return item.get('metadataId') === recentReturn.get('metadataId');
	    });
	
	    var canAddToShelf = recentReturn.get('bib') && !isAlreadyOnShelf;
	
	    var actions = canAddToShelf ? recentReturn.get('actions', _immutable2.default.List()).push('addToShelf') : recentReturn.get('actions');
	
	    return recentReturn.set('actions', actions);
	  }).toList();
	
	  return recentReturns;
	});
	
	exports.default = {
	  getRecentlyReturnedWithBibs: getRecentlyReturnedWithBibs,
	  getBorrowingHistoryData: getBorrowingHistoryData
	};

/***/ },
/* 648 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.currentSiteScopes = exports.allSites = undefined;
	
	var _reselect = __webpack_require__(34);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _LibrarySelector = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var allSites = exports.allSites = function allSites(state) {
	  return state.getIn(['entities', 'sites']);
	};
	
	var currentSiteScopes = exports.currentSiteScopes = (0, _reselect.createSelector)(_LibrarySelector.currentLibrarySelector, allSites, function (library, sites) {
	  return sites.getIn([library.get('siteId').toString(), 'scopes'], _immutable2.default.List.of(_immutable2.default.Map()));
	});

/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(2187);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(2186);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ },
/* 650 */
/***/ function(module, exports, __webpack_require__) {

	var upperCase = __webpack_require__(172)
	var sentenceCase = __webpack_require__(171)
	
	/**
	 * Camel case a string.
	 *
	 * @param  {String} string
	 * @param  {String} [locale]
	 * @return {String}
	 */
	module.exports = function (string, locale, mergeNumbers) {
	  var result = sentenceCase(string, locale)
	
	  // Replace periods between numeric entities with an underscore.
	  if (!mergeNumbers) {
	    result = result.replace(/(\d) (?=\d)/g, '$1_')
	  }
	
	  // Replace spaces between words with an upper cased character.
	  return result.replace(/ (.)/g, function (m, $1) {
	    return upperCase($1, locale)
	  })
	}


/***/ },
/* 651 */
/***/ function(module, exports) {

	/*!
	 * cookie
	 * Copyright(c) 2012-2014 Roman Shtylman
	 * Copyright(c) 2015 Douglas Christopher Wilson
	 * MIT Licensed
	 */
	
	/**
	 * Module exports.
	 * @public
	 */
	
	exports.parse = parse;
	exports.serialize = serialize;
	
	/**
	 * Module variables.
	 * @private
	 */
	
	var decode = decodeURIComponent;
	var encode = encodeURIComponent;
	var pairSplitRegExp = /; */;
	
	/**
	 * RegExp to match field-content in RFC 7230 sec 3.2
	 *
	 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
	 * field-vchar   = VCHAR / obs-text
	 * obs-text      = %x80-FF
	 */
	
	var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
	
	/**
	 * Parse a cookie header.
	 *
	 * Parse the given cookie header string into an object
	 * The object has the various cookies as keys(names) => values
	 *
	 * @param {string} str
	 * @param {object} [options]
	 * @return {object}
	 * @public
	 */
	
	function parse(str, options) {
	  if (typeof str !== 'string') {
	    throw new TypeError('argument str must be a string');
	  }
	
	  var obj = {}
	  var opt = options || {};
	  var pairs = str.split(pairSplitRegExp);
	  var dec = opt.decode || decode;
	
	  pairs.forEach(function(pair) {
	    var eq_idx = pair.indexOf('=')
	
	    // skip things that don't look like key=value
	    if (eq_idx < 0) {
	      return;
	    }
	
	    var key = pair.substr(0, eq_idx).trim()
	    var val = pair.substr(++eq_idx, pair.length).trim();
	
	    // quoted values
	    if ('"' == val[0]) {
	      val = val.slice(1, -1);
	    }
	
	    // only assign once
	    if (undefined == obj[key]) {
	      obj[key] = tryDecode(val, dec);
	    }
	  });
	
	  return obj;
	}
	
	/**
	 * Serialize data into a cookie header.
	 *
	 * Serialize the a name value pair into a cookie string suitable for
	 * http headers. An optional options object specified cookie parameters.
	 *
	 * serialize('foo', 'bar', { httpOnly: true })
	 *   => "foo=bar; httpOnly"
	 *
	 * @param {string} name
	 * @param {string} val
	 * @param {object} [options]
	 * @return {string}
	 * @public
	 */
	
	function serialize(name, val, options) {
	  var opt = options || {};
	  var enc = opt.encode || encode;
	
	  if (!fieldContentRegExp.test(name)) {
	    throw new TypeError('argument name is invalid');
	  }
	
	  var value = enc(val);
	
	  if (value && !fieldContentRegExp.test(value)) {
	    throw new TypeError('argument val is invalid');
	  }
	
	  var pairs = [name + '=' + value];
	
	  if (null != opt.maxAge) {
	    var maxAge = opt.maxAge - 0;
	    if (isNaN(maxAge)) throw new Error('maxAge should be a Number');
	    pairs.push('Max-Age=' + Math.floor(maxAge));
	  }
	
	  if (opt.domain) {
	    if (!fieldContentRegExp.test(opt.domain)) {
	      throw new TypeError('option domain is invalid');
	    }
	
	    pairs.push('Domain=' + opt.domain);
	  }
	
	  if (opt.path) {
	    if (!fieldContentRegExp.test(opt.path)) {
	      throw new TypeError('option path is invalid');
	    }
	
	    pairs.push('Path=' + opt.path);
	  }
	
	  if (opt.expires) pairs.push('Expires=' + opt.expires.toUTCString());
	  if (opt.httpOnly) pairs.push('HttpOnly');
	  if (opt.secure) pairs.push('Secure');
	  if (opt.firstPartyOnly) pairs.push('First-Party-Only');
	
	  return pairs.join('; ');
	}
	
	/**
	 * Try decoding a string using a decoding function.
	 *
	 * @param {string} str
	 * @param {function} decode
	 * @private
	 */
	
	function tryDecode(str, decode) {
	  try {
	    return decode(str);
	  } catch (e) {
	    return str;
	  }
	}


/***/ },
/* 652 */
84,
/* 653 */
[3488, 2205],
/* 654 */
[3490, 195, 129],
/* 655 */
[3494, 193, 303, 654],
/* 656 */
[3498, 304, 302, 661, 194, 404, 2212, 408, 2217, 198],
/* 657 */
[3503, 407, 305, 197, 412, 149, 655, 193],
/* 658 */
[3505, 660, 403],
/* 659 */
315,
/* 660 */
[3507, 149, 197, 2207, 409],
/* 661 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(194);


/***/ },
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */
/***/ function(module, exports) {

	/**
	 * Helper function for iterating over a collection
	 *
	 * @param collection
	 * @param fn
	 */
	function each(collection, fn) {
	    var i      = 0,
	        length = collection.length,
	        cont;
	
	    for(i; i < length; i++) {
	        cont = fn(collection[i], i);
	        if(cont === false) {
	            break; //allow early exit
	        }
	    }
	}
	
	/**
	 * Helper function for determining whether target object is an array
	 *
	 * @param target the object under test
	 * @return {Boolean} true if array, false otherwise
	 */
	function isArray(target) {
	    return Object.prototype.toString.apply(target) === '[object Array]';
	}
	
	/**
	 * Helper function for determining whether target object is a function
	 *
	 * @param target the object under test
	 * @return {Boolean} true if function, false otherwise
	 */
	function isFunction(target) {
	    return typeof target === 'function';
	}
	
	module.exports = {
	    isFunction : isFunction,
	    isArray : isArray,
	    each : each
	};


/***/ },
/* 697 */
/***/ function(module, exports) {

	'use strict';
	
	/* globals
		Set,
		Map,
		WeakSet,
		WeakMap,
	
		Promise,
	
		Symbol,
		Proxy,
	
		Atomics,
		SharedArrayBuffer,
	
		ArrayBuffer,
		DataView,
		Uint8Array,
		Float32Array,
		Float64Array,
		Int8Array,
		Int16Array,
		Int32Array,
		Uint8ClampedArray,
		Uint16Array,
		Uint32Array,
	*/
	
	var undefined; // eslint-disable-line no-shadow-restricted-names
	
	var ThrowTypeError = Object.getOwnPropertyDescriptor
		? (function () { return Object.getOwnPropertyDescriptor(arguments, 'callee').get; }())
		: function () { throw new TypeError(); };
	
	var hasSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol';
	
	var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto
	
	var generator; // = function * () {};
	var generatorFunction = generator ? getProto(generator) : undefined;
	var asyncFn; // async function() {};
	var asyncFunction = asyncFn ? asyncFn.constructor : undefined;
	var asyncGen; // async function * () {};
	var asyncGenFunction = asyncGen ? getProto(asyncGen) : undefined;
	var asyncGenIterator = asyncGen ? asyncGen() : undefined;
	
	var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);
	
	var INTRINSICS = {
		'$ %Array%': Array,
		'$ %ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
		'$ %ArrayBufferPrototype%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer.prototype,
		'$ %ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
		'$ %ArrayPrototype%': Array.prototype,
		'$ %ArrayProto_entries%': Array.prototype.entries,
		'$ %ArrayProto_forEach%': Array.prototype.forEach,
		'$ %ArrayProto_keys%': Array.prototype.keys,
		'$ %ArrayProto_values%': Array.prototype.values,
		'$ %AsyncFromSyncIteratorPrototype%': undefined,
		'$ %AsyncFunction%': asyncFunction,
		'$ %AsyncFunctionPrototype%': asyncFunction ? asyncFunction.prototype : undefined,
		'$ %AsyncGenerator%': asyncGen ? getProto(asyncGenIterator) : undefined,
		'$ %AsyncGeneratorFunction%': asyncGenFunction,
		'$ %AsyncGeneratorPrototype%': asyncGenFunction ? asyncGenFunction.prototype : undefined,
		'$ %AsyncIteratorPrototype%': asyncGenIterator && hasSymbols && Symbol.asyncIterator ? asyncGenIterator[Symbol.asyncIterator]() : undefined,
		'$ %Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
		'$ %Boolean%': Boolean,
		'$ %BooleanPrototype%': Boolean.prototype,
		'$ %DataView%': typeof DataView === 'undefined' ? undefined : DataView,
		'$ %DataViewPrototype%': typeof DataView === 'undefined' ? undefined : DataView.prototype,
		'$ %Date%': Date,
		'$ %DatePrototype%': Date.prototype,
		'$ %decodeURI%': decodeURI,
		'$ %decodeURIComponent%': decodeURIComponent,
		'$ %encodeURI%': encodeURI,
		'$ %encodeURIComponent%': encodeURIComponent,
		'$ %Error%': Error,
		'$ %ErrorPrototype%': Error.prototype,
		'$ %eval%': eval, // eslint-disable-line no-eval
		'$ %EvalError%': EvalError,
		'$ %EvalErrorPrototype%': EvalError.prototype,
		'$ %Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
		'$ %Float32ArrayPrototype%': typeof Float32Array === 'undefined' ? undefined : Float32Array.prototype,
		'$ %Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
		'$ %Float64ArrayPrototype%': typeof Float64Array === 'undefined' ? undefined : Float64Array.prototype,
		'$ %Function%': Function,
		'$ %FunctionPrototype%': Function.prototype,
		'$ %Generator%': generator ? getProto(generator()) : undefined,
		'$ %GeneratorFunction%': generatorFunction,
		'$ %GeneratorPrototype%': generatorFunction ? generatorFunction.prototype : undefined,
		'$ %Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
		'$ %Int8ArrayPrototype%': typeof Int8Array === 'undefined' ? undefined : Int8Array.prototype,
		'$ %Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
		'$ %Int16ArrayPrototype%': typeof Int16Array === 'undefined' ? undefined : Int8Array.prototype,
		'$ %Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
		'$ %Int32ArrayPrototype%': typeof Int32Array === 'undefined' ? undefined : Int32Array.prototype,
		'$ %isFinite%': isFinite,
		'$ %isNaN%': isNaN,
		'$ %IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
		'$ %JSON%': JSON,
		'$ %JSONParse%': JSON.parse,
		'$ %Map%': typeof Map === 'undefined' ? undefined : Map,
		'$ %MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
		'$ %MapPrototype%': typeof Map === 'undefined' ? undefined : Map.prototype,
		'$ %Math%': Math,
		'$ %Number%': Number,
		'$ %NumberPrototype%': Number.prototype,
		'$ %Object%': Object,
		'$ %ObjectPrototype%': Object.prototype,
		'$ %ObjProto_toString%': Object.prototype.toString,
		'$ %ObjProto_valueOf%': Object.prototype.valueOf,
		'$ %parseFloat%': parseFloat,
		'$ %parseInt%': parseInt,
		'$ %Promise%': typeof Promise === 'undefined' ? undefined : Promise,
		'$ %PromisePrototype%': typeof Promise === 'undefined' ? undefined : Promise.prototype,
		'$ %PromiseProto_then%': typeof Promise === 'undefined' ? undefined : Promise.prototype.then,
		'$ %Promise_all%': typeof Promise === 'undefined' ? undefined : Promise.all,
		'$ %Promise_reject%': typeof Promise === 'undefined' ? undefined : Promise.reject,
		'$ %Promise_resolve%': typeof Promise === 'undefined' ? undefined : Promise.resolve,
		'$ %Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
		'$ %RangeError%': RangeError,
		'$ %RangeErrorPrototype%': RangeError.prototype,
		'$ %ReferenceError%': ReferenceError,
		'$ %ReferenceErrorPrototype%': ReferenceError.prototype,
		'$ %Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
		'$ %RegExp%': RegExp,
		'$ %RegExpPrototype%': RegExp.prototype,
		'$ %Set%': typeof Set === 'undefined' ? undefined : Set,
		'$ %SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
		'$ %SetPrototype%': typeof Set === 'undefined' ? undefined : Set.prototype,
		'$ %SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
		'$ %SharedArrayBufferPrototype%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer.prototype,
		'$ %String%': String,
		'$ %StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
		'$ %StringPrototype%': String.prototype,
		'$ %Symbol%': hasSymbols ? Symbol : undefined,
		'$ %SymbolPrototype%': hasSymbols ? Symbol.prototype : undefined,
		'$ %SyntaxError%': SyntaxError,
		'$ %SyntaxErrorPrototype%': SyntaxError.prototype,
		'$ %ThrowTypeError%': ThrowTypeError,
		'$ %TypedArray%': TypedArray,
		'$ %TypedArrayPrototype%': TypedArray ? TypedArray.prototype : undefined,
		'$ %TypeError%': TypeError,
		'$ %TypeErrorPrototype%': TypeError.prototype,
		'$ %Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
		'$ %Uint8ArrayPrototype%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array.prototype,
		'$ %Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
		'$ %Uint8ClampedArrayPrototype%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray.prototype,
		'$ %Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
		'$ %Uint16ArrayPrototype%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array.prototype,
		'$ %Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
		'$ %Uint32ArrayPrototype%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array.prototype,
		'$ %URIError%': URIError,
		'$ %URIErrorPrototype%': URIError.prototype,
		'$ %WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
		'$ %WeakMapPrototype%': typeof WeakMap === 'undefined' ? undefined : WeakMap.prototype,
		'$ %WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
		'$ %WeakSetPrototype%': typeof WeakSet === 'undefined' ? undefined : WeakSet.prototype
	};
	
	module.exports = function GetIntrinsic(name, allowMissing) {
		if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
			throw new TypeError('"allowMissing" argument must be a boolean');
		}
	
		var key = '$ ' + name;
		if (!(key in INTRINSICS)) {
			throw new SyntaxError('intrinsic ' + name + ' does not exist!');
		}
	
		// istanbul ignore if // hopefully this is impossible to test :-)
		if (typeof INTRINSICS[key] === 'undefined' && !allowMissing) {
			throw new TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}
		return INTRINSICS[key];
	};


/***/ },
/* 698 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var ES2015 = __webpack_require__(2442);
	var assign = __webpack_require__(441);
	
	var ES2016 = assign(assign({}, ES2015), {
		// https://github.com/tc39/ecma262/pull/60
		SameValueNonNumber: function SameValueNonNumber(x, y) {
			if (typeof x === 'number' || typeof x !== typeof y) {
				throw new TypeError('SameValueNonNumber requires two non-number values of the same type.');
			}
			return this.SameValue(x, y);
		}
	});
	
	module.exports = ES2016;


/***/ },
/* 699 */
/***/ function(module, exports) {

	var $isNaN = Number.isNaN || function (a) { return a !== a; };
	
	module.exports = Number.isFinite || function (x) { return typeof x === 'number' && !$isNaN(x) && x !== Infinity && x !== -Infinity; };


/***/ },
/* 700 */
/***/ function(module, exports) {

	module.exports = Number.isNaN || function isNaN(a) {
		return a !== a;
	};


/***/ },
/* 701 */
/***/ function(module, exports) {

	module.exports = function mod(number, modulo) {
		var remain = number % modulo;
		return Math.floor(remain >= 0 ? remain : remain + modulo);
	};


/***/ },
/* 702 */
/***/ function(module, exports) {

	module.exports = function sign(number) {
		return number >= 0 ? 1 : -1;
	};


/***/ },
/* 703 */
/***/ function(module, exports) {

	module.exports = function isPrimitive(value) {
		return value === null || (typeof value !== 'function' && typeof value !== 'object');
	};


/***/ },
/* 704 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(80);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ },
/* 705 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 706 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node:true */
	
	'use strict';
	
	var IntlMessageFormat = __webpack_require__(2803)['default'];
	
	// Add all locale data to `IntlMessageFormat`. This module will be ignored when
	// bundling for the browser with Browserify/Webpack.
	__webpack_require__(3476);
	
	// Re-export `IntlMessageFormat` as the CommonJS default exports with all the
	// locale data registered, and with English set as the default locale. Define
	// the `default` prop for use with other compiled ES6 Modules.
	exports = module.exports = IntlMessageFormat;
	exports['default'] = exports;


/***/ },
/* 711 */
/***/ function(module, exports) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	exports.extend = extend;
	var hop = Object.prototype.hasOwnProperty;
	
	function extend(obj) {
	    var sources = Array.prototype.slice.call(arguments, 1),
	        i, len, source, key;
	
	    for (i = 0, len = sources.length; i < len; i += 1) {
	        source = sources[i];
	        if (!source) { continue; }
	
	        for (key in source) {
	            if (hop.call(source, key)) {
	                obj[key] = source[key];
	            }
	        }
	    }
	
	    return obj;
	}
	exports.hop = hop;
	
	//# sourceMappingURL=utils.js.map

/***/ },
/* 712 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var toStr = Object.prototype.toString;
	var hasSymbols = __webpack_require__(2782)();
	
	if (hasSymbols) {
		var symToStr = Symbol.prototype.toString;
		var symStringRegex = /^Symbol\(.*\)$/;
		var isSymbolObject = function isRealSymbolObject(value) {
			if (typeof value.valueOf() !== 'symbol') {
				return false;
			}
			return symStringRegex.test(symToStr.call(value));
		};
	
		module.exports = function isSymbol(value) {
			if (typeof value === 'symbol') {
				return true;
			}
			if (toStr.call(value) !== '[object Symbol]') {
				return false;
			}
			try {
				return isSymbolObject(value);
			} catch (e) {
				return false;
			}
		};
	} else {
	
		module.exports = function isSymbol(value) {
			// this environment does not support Symbols.
			return false && value;
		};
	}


/***/ },
/* 713 */,
/* 714 */
/***/ function(module, exports) {

	module.exports = {
		"CATEGORIES": {
			"CARDS_NEWS": "v2-cards-news",
			"CARDS_CUSTOM": "v2-cards-custom",
			"CARDS_ONLINE_RESOURCE": "v2-cards-online-resource",
			"CARDS_BLOG": "v2-cards-blog",
			"CARDS_LIST": "v2-cards-list",
			"CARDS_EVENT": "v2-cards-event",
			"CARDS_COMMENT": "v2-cards-comment",
			"CARDS_QUOTE": "v2-cards-quote",
			"CARDS_POLL": "v2-cards-poll",
			"CARDS_TWITTER": "v2-cards-twitter",
			"CARDS_INSTAGRAM": "v2-cards-instagram",
			"CAROUSELS": "v2-carousels",
			"ACTIVITY_FEEDS": "v2-feeds-activity",
			"NOTIFICATION_FEEDS": "v2-feeds-notification",
			"COMMUNITY_FEEDS": "v2-feeds-community",
			"CONTENT_FEEDS": "v2-feeds-content",
			"HERO_BLOCK": "v2-hero",
			"NAVIGATION": "v2-navigation",
			"WEB_TAXONOMIES": "v2-web-taxonomies",
			"PAGE_INTERACTIONS": "v2-page-interactions",
			"HOLDS": "v2-holds",
			"DIGITAL_HOLDS": "v2-holds-digital",
			"SHELVES": "v2-shelves",
			"RATINGS": "v2-ccc-ratings",
			"COMMENTS": "v2-ccc-comments",
			"TAGS": "v2-ccc-tags",
			"QUOTATIONS": "v2-ccc-quotations",
			"VIDEOS": "v2-ccc-videos",
			"SIMILAR_TITLES": "v2-ccc-similar-titles",
			"AVAILABILITY": "v2-availability",
			"CHECKOUTS": "v2-checkouts",
			"SEARCH": "v2-search",
			"SEARCH_RESULTS": "v2-search-results",
			"BROADEN_SEARCH": "v2-search-broaden",
			"EMPTY_SEARCH_RESULTS": "v2-search-empty",
			"LISTS": "v2-lists",
			"FEATURE_IN_CATALOG": "v2-feature-in-catalog",
			"WHILE_YOU_WAIT": "v2-while-you-wait",
			"FEES": "v2-fees",
			"PATRON_PREFERENCES": "v2-patron-preferences",
			"BIB_FORMAT_CHOOSER": "v2-bib-format-chooser"
		},
		"ACTIONS": {
			"CLICK_TITLE": "v2-title-click",
			"CLICK_IMAGE": "v2-image-click",
			"PLAY_VIDEO": "v2-video-play",
			"CLICK_LINK": "v2-link-click",
			"OUTBOUND_LINK_CLICK": "v2-outbound-link-click",
			"PAGE_SCROLL": "v2-scroll",
			"SUBMIT_FORM": "v2-submit",
			"INTERACT_WITH_CONTAINER": "v2-container-interaction",
			"VIEW": "v2-view",
			"DOWNLOAD_A_FILE": "v2-file-download",
			"ADD_CONTENT": "v2-add",
			"EDIT_ITEM": "v2-edit",
			"REMOVE_CONTENT": "v2-remove",
			"MOVE_CONTENT": "v2-move",
			"ADD_ITEM_TO_CONTENT": "v2-add-item",
			"REMOVE_ITEM_FROM_CONTENT": "v2-remove-item",
			"TOGGLE_OPTION": "v2-toggle",
			"TOGGLE_PRIVACY": "v2-toggle-privacy",
			"TOGGLE_VISIBILITY": "v2-toggle-visibility",
			"TOGGLE_OWNERSHIP": "v2-toggle-i-own-this",
			"LIKE_ITEM": "v2-like",
			"DISLIKE_ITEM": "v2-dislike",
			"PAY_FINE": "v2-pay",
			"RENEW_ITEM": "v2-renew",
			"PLACE_HOLD": "v2-place",
			"CANCEL_HOLD": "v2-cancel",
			"PAUSE_HOLD": "v2-pause",
			"RESUME_HOLD": "v2-resume"
		},
		"LABELS": {
			"CONTAINER_TITLE": "title",
			"CONTAINER_FWD_ARROW": "forward-arrow",
			"CONTAINER_BWD_ARROW": "backward-arrow",
			"CONTAINER_DOT_INDICATORS": "dot-indicators",
			"CONTAINER_FWD_SWIPE": "forward-swipe",
			"CONTAINER_BWD_SWIPE": "backward-swipe",
			"CONTAINER_EXPAND": "expand",
			"CONTAINER_COLLAPSE": "collapse",
			"CONTAINER_NEXT_PAGE": "next-page",
			"CONTAINER_PREV_PAGE": "previous-page",
			"CONTAINER_TAB": "tab",
			"CONTAINER_PAGE": "page-{}",
			"CONTAINER_VIEW_ALL": "all-results",
			"CONTAINER_READ_MORE": "read-more",
			"BIB_TITLE": "bib-title",
			"BIB_COVER": "bib-cover",
			"BIB_AUTHOR": "bib-author",
			"REPORT_THIS": "report-this",
			"TAKE_THE_POLL": "take-the-poll",
			"SKIP_TO_RESULTS": "skip-to-results"
		},
		"EVENTS": {
			"OPT_IN": "bc.userOptIn",
			"OPT_OUT": "bc.userOptOut",
			"BROADEN_SEARCH": "bc.broadenSearch",
			"SEARCH_RESULTS": "bc.searchResults",
			"DYM_SEARCH_RESULT_IMPRESSION": "bc.dymSearchResultImpression",
			"DYM_SEARCH_RESULT_CLICK": "bc.dymSearchResultClick",
			"EMPTY_SEARCH_RESULT": "bc.emptySearchResult",
			"PLACE_HOLD": "bc.placeHold",
			"CANCEL_HOLD": "bc.cancelHold",
			"PAUSE_HOLD": "bc.pauseHold",
			"RESUME_HOLD": "bc.resumeHold",
			"ADD_TO_SHELF": "bc.addToShelf",
			"REMOVE_FROM_SHELF": "bc.removeFromShelf",
			"MOVE_TO_SHELF": "bc.moveToShelf",
			"ADD_RATING": "bc.addRating",
			"EDI_TRATING": "bc.editRating",
			"REMOVE_RATING": "bc.removeRating",
			"ADD_COMMENT": "bc.addComment",
			"EDIT_COMMENT": "bc.editComment",
			"REMOVE_COMMENT": "bc.removeComment",
			"ADD_TAG": "bc.addTag",
			"REMOVE_TAG": "bc.removeTag",
			"ADD_VIDEO": "bc.addVideo",
			"REMOVE_VIDEO": "bc.removeVideo",
			"EDIT_VIDEO": "bc.editVideo",
			"CHECK_AVAILABILITY": "bc.checkAvailability",
			"FORMAT_CHOOSER_SELECTION": "bc.bibFormatChooserSelection",
			"RENEWCHECKOUT": "bc.renewCheckout",
			"TOGGLE_I_OWN_THIS": "bc.toggleIOwnThis",
			"TOGGLE_PRIVACY": "bc.togglePrivacy",
			"ADD_QUOTATION": "bc.addQuotation",
			"EDIT_QUOTATION": "bc.editQuotation",
			"REMOVE_QUOTATION": "bc.removeQuotation",
			"ADD_SIMILAR_TITLE": "bc.addSimilarTitle",
			"REMOVE_SIMILAR_TITLE": "bc.removeSimilarTitle",
			"CARD_CLICK": "bc.cardClick",
			"FORM_SUBMISSION": "bc.formSubmission",
			"FILE_DOWNLOAD": "bc.fileDownload",
			"OUTBOUND_LINK": "bc.outboundLinkClick"
		},
		"CUSTOM_DIMENSIONS": {
			"DIMENSION_MAP": {
				"LIBRARY_ID": "bc.libraryId",
				"SITE_ID": "bc.siteId",
				"BIBLIOWEB_LIBRARY": "bc.cmsEnabled",
				"CONTAINER_NAME": "payload.gtmContainerName",
				"CONTENT_TYPE": "payload.gtmContentType",
				"CONTENT_CREATOR": "payload.gtmContentCreator",
				"CREATOR_TYPE": "payload.gtmCreatorType",
				"CARD_TITLE": "payload.gtmCardTitle"
			},
			"CONTENT_TYPES": {
				"LIST": "list",
				"EVENT": "event",
				"BLOG": "blog",
				"NEWS": "news",
				"FAQ": "faq",
				"TWITTER": "tweet",
				"INSTAGRAM": "instagram",
				"POLL": "poll",
				"ONLINE_RESOURCE": "online-resource",
				"VIDEO": "video",
				"BIB": "bib",
				"COMMENT": "comment",
				"QUOTE": "quote",
				"BIB_TAG": "bib-tag",
				"SUMMARY": "summary",
				"FORM": "form"
			},
			"CREATOR_TYPES": {
				"LIBRARY_STAFF": "library-staff",
				"LIBRARY_PATRON": "library-patron",
				"EXTERNAL_STAFF": "external-staff",
				"EXTERNAL_PATRON": "external-patron",
				"BARCODELESS_USER": "barcodeless-user"
			}
		}
	};

/***/ },
/* 715 */
/***/ function(module, exports, __webpack_require__) {

	var camel2hyphen = __webpack_require__(3415);
	
	var isDimension = function (feature) {
	  var re = /[height|width]$/;
	  return re.test(feature);
	};
	
	var obj2mq = function (obj) {
	  var mq = '';
	  var features = Object.keys(obj);
	  features.forEach(function (feature, index) {
	    var value = obj[feature];
	    feature = camel2hyphen(feature);
	    // Add px to dimension features
	    if (isDimension(feature) && typeof value === 'number') {
	      value = value + 'px';
	    }
	    if (value === true) {
	      mq += feature;
	    } else if (value === false) {
	      mq += 'not ' + feature;
	    } else {
	      mq += '(' + feature + ': ' + value + ')';
	    }
	    if (index < features.length-1) {
	      mq += ' and '
	    }
	  });
	  return mq;
	};
	
	var json2mq = function (query) {
	  var mq = '';
	  if (typeof query === 'string') {
	    return query;
	  }
	  // Handling array of media queries
	  if (query instanceof Array) {
	    query.forEach(function (q, index) {
	      mq += obj2mq(q);
	      if (index < query.length-1) {
	        mq += ', '
	      }
	    });
	    return mq;
	  }
	  // Handling single media query
	  return obj2mq(query);
	};
	
	module.exports = json2mq;

/***/ },
/* 716 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(328),
	    baseLodash = __webpack_require__(457);
	
	/**
	 * The base constructor for creating `lodash` wrapper objects.
	 *
	 * @private
	 * @param {*} value The value to wrap.
	 * @param {boolean} [chainAll] Enable explicit method chain sequences.
	 */
	function LodashWrapper(value, chainAll) {
	  this.__wrapped__ = value;
	  this.__actions__ = [];
	  this.__chain__ = !!chainAll;
	  this.__index__ = 0;
	  this.__values__ = undefined;
	}
	
	LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	LodashWrapper.prototype.constructor = LodashWrapper;
	
	module.exports = LodashWrapper;


/***/ },
/* 717 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(62);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ },
/* 718 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(161),
	    root = __webpack_require__(62);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ },
/* 719 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ },
/* 720 */
/***/ function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(2853),
	    isArguments = __webpack_require__(335),
	    isArray = __webpack_require__(65),
	    isBuffer = __webpack_require__(336),
	    isIndex = __webpack_require__(332),
	    isTypedArray = __webpack_require__(470);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ },
/* 721 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayReduce;


/***/ },
/* 722 */
/***/ function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(731);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ },
/* 723 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(453),
	    isArray = __webpack_require__(65);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ },
/* 724 */
/***/ function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(2831),
	    baseIsNaN = __webpack_require__(2840),
	    strictIndexOf = __webpack_require__(2925);
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  return value === value
	    ? strictIndexOf(array, value, fromIndex)
	    : baseFindIndex(array, baseIsNaN, fromIndex);
	}
	
	module.exports = baseIndexOf;


/***/ },
/* 725 */
/***/ function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(333),
	    nativeKeys = __webpack_require__(2910);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ },
/* 726 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(468),
	    metaMap = __webpack_require__(742);
	
	/**
	 * The base implementation of `setData` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to associate metadata with.
	 * @param {*} data The metadata.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetData = !metaMap ? identity : function(func, data) {
	  metaMap.set(func, data);
	  return func;
	};
	
	module.exports = baseSetData;


/***/ },
/* 727 */
/***/ function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates an array that is the composition of partially applied arguments,
	 * placeholders, and provided arguments into a single array of arguments.
	 *
	 * @private
	 * @param {Array} args The provided arguments.
	 * @param {Array} partials The arguments to prepend to those provided.
	 * @param {Array} holders The `partials` placeholder indexes.
	 * @params {boolean} [isCurried] Specify composing for a curried function.
	 * @returns {Array} Returns the new array of composed arguments.
	 */
	function composeArgs(args, partials, holders, isCurried) {
	  var argsIndex = -1,
	      argsLength = args.length,
	      holdersLength = holders.length,
	      leftIndex = -1,
	      leftLength = partials.length,
	      rangeLength = nativeMax(argsLength - holdersLength, 0),
	      result = Array(leftLength + rangeLength),
	      isUncurried = !isCurried;
	
	  while (++leftIndex < leftLength) {
	    result[leftIndex] = partials[leftIndex];
	  }
	  while (++argsIndex < holdersLength) {
	    if (isUncurried || argsIndex < argsLength) {
	      result[holders[argsIndex]] = args[argsIndex];
	    }
	  }
	  while (rangeLength--) {
	    result[leftIndex++] = args[argsIndex++];
	  }
	  return result;
	}
	
	module.exports = composeArgs;


/***/ },
/* 728 */
/***/ function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * This function is like `composeArgs` except that the arguments composition
	 * is tailored for `_.partialRight`.
	 *
	 * @private
	 * @param {Array} args The provided arguments.
	 * @param {Array} partials The arguments to append to those provided.
	 * @param {Array} holders The `partials` placeholder indexes.
	 * @params {boolean} [isCurried] Specify composing for a curried function.
	 * @returns {Array} Returns the new array of composed arguments.
	 */
	function composeArgsRight(args, partials, holders, isCurried) {
	  var argsIndex = -1,
	      argsLength = args.length,
	      holdersIndex = -1,
	      holdersLength = holders.length,
	      rightIndex = -1,
	      rightLength = partials.length,
	      rangeLength = nativeMax(argsLength - holdersLength, 0),
	      result = Array(rangeLength + rightLength),
	      isUncurried = !isCurried;
	
	  while (++argsIndex < rangeLength) {
	    result[argsIndex] = args[argsIndex];
	  }
	  var offset = argsIndex;
	  while (++rightIndex < rightLength) {
	    result[offset + rightIndex] = partials[rightIndex];
	  }
	  while (++holdersIndex < holdersLength) {
	    if (isUncurried || argsIndex < argsLength) {
	      result[offset + holders[holdersIndex]] = args[argsIndex++];
	    }
	  }
	  return result;
	}
	
	module.exports = composeArgsRight;


/***/ },
/* 729 */
/***/ function(module, exports, __webpack_require__) {

	var composeArgs = __webpack_require__(727),
	    composeArgsRight = __webpack_require__(728),
	    countHolders = __webpack_require__(2869),
	    createCtor = __webpack_require__(330),
	    createRecurry = __webpack_require__(730),
	    getHolder = __webpack_require__(736),
	    reorder = __webpack_require__(2917),
	    replaceHolders = __webpack_require__(465),
	    root = __webpack_require__(62);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_CURRY_RIGHT_FLAG = 16,
	    WRAP_ARY_FLAG = 128,
	    WRAP_FLIP_FLAG = 512;
	
	/**
	 * Creates a function that wraps `func` to invoke it with optional `this`
	 * binding of `thisArg`, partial application, and currying.
	 *
	 * @private
	 * @param {Function|string} func The function or method name to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to prepend to those provided to
	 *  the new function.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [partialsRight] The arguments to append to those provided
	 *  to the new function.
	 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	  var isAry = bitmask & WRAP_ARY_FLAG,
	      isBind = bitmask & WRAP_BIND_FLAG,
	      isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	      isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	      isFlip = bitmask & WRAP_FLIP_FLAG,
	      Ctor = isBindKey ? undefined : createCtor(func);
	
	  function wrapper() {
	    var length = arguments.length,
	        args = Array(length),
	        index = length;
	
	    while (index--) {
	      args[index] = arguments[index];
	    }
	    if (isCurried) {
	      var placeholder = getHolder(wrapper),
	          holdersCount = countHolders(args, placeholder);
	    }
	    if (partials) {
	      args = composeArgs(args, partials, holders, isCurried);
	    }
	    if (partialsRight) {
	      args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	    }
	    length -= holdersCount;
	    if (isCurried && length < arity) {
	      var newHolders = replaceHolders(args, placeholder);
	      return createRecurry(
	        func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	        args, newHolders, argPos, ary, arity - length
	      );
	    }
	    var thisBinding = isBind ? thisArg : this,
	        fn = isBindKey ? thisBinding[func] : func;
	
	    length = args.length;
	    if (argPos) {
	      args = reorder(args, argPos);
	    } else if (isFlip && length > 1) {
	      args.reverse();
	    }
	    if (isAry && ary < length) {
	      args.length = ary;
	    }
	    if (this && this !== root && this instanceof wrapper) {
	      fn = Ctor || createCtor(fn);
	    }
	    return fn.apply(thisBinding, args);
	  }
	  return wrapper;
	}
	
	module.exports = createHybrid;


/***/ },
/* 730 */
/***/ function(module, exports, __webpack_require__) {

	var isLaziable = __webpack_require__(2896),
	    setData = __webpack_require__(744),
	    setWrapToString = __webpack_require__(747);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_BOUND_FLAG = 4,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_PARTIAL_FLAG = 32,
	    WRAP_PARTIAL_RIGHT_FLAG = 64;
	
	/**
	 * Creates a function that wraps `func` to continue currying.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {Function} wrapFunc The function to create the `func` wrapper.
	 * @param {*} placeholder The placeholder value.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to prepend to those provided to
	 *  the new function.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	  var isCurry = bitmask & WRAP_CURRY_FLAG,
	      newHolders = isCurry ? holders : undefined,
	      newHoldersRight = isCurry ? undefined : holders,
	      newPartials = isCurry ? partials : undefined,
	      newPartialsRight = isCurry ? undefined : partials;
	
	  bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	  bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	  if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	    bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	  }
	  var newData = [
	    func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	    newHoldersRight, argPos, ary, arity
	  ];
	
	  var result = wrapFunc.apply(undefined, newData);
	  if (isLaziable(func)) {
	    setData(result, newData);
	  }
	  result.placeholder = placeholder;
	  return setWrapToString(result, func, bitmask);
	}
	
	module.exports = createRecurry;


/***/ },
/* 731 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(161);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ },
/* 732 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(2821),
	    arraySome = __webpack_require__(2826),
	    cacheHas = __webpack_require__(2858);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ },
/* 733 */,
/* 734 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(723),
	    getSymbols = __webpack_require__(462),
	    keys = __webpack_require__(163);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ },
/* 735 */
/***/ function(module, exports, __webpack_require__) {

	var metaMap = __webpack_require__(742),
	    noop = __webpack_require__(2940);
	
	/**
	 * Gets metadata for `func`.
	 *
	 * @private
	 * @param {Function} func The function to query.
	 * @returns {*} Returns the metadata for `func`.
	 */
	var getData = !metaMap ? noop : function(func) {
	  return metaMap.get(func);
	};
	
	module.exports = getData;


/***/ },
/* 736 */
/***/ function(module, exports) {

	/**
	 * Gets the argument placeholder value for `func`.
	 *
	 * @private
	 * @param {Function} func The function to inspect.
	 * @returns {*} Returns the placeholder value.
	 */
	function getHolder(func) {
	  var object = func;
	  return object.placeholder;
	}
	
	module.exports = getHolder;


/***/ },
/* 737 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(453),
	    getPrototype = __webpack_require__(461),
	    getSymbols = __webpack_require__(462),
	    stubArray = __webpack_require__(755);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own and inherited enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	  var result = [];
	  while (object) {
	    arrayPush(result, getSymbols(object));
	    object = getPrototype(object);
	  }
	  return result;
	};
	
	module.exports = getSymbolsIn;


/***/ },
/* 738 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(207),
	    isArguments = __webpack_require__(335),
	    isArray = __webpack_require__(65),
	    isIndex = __webpack_require__(332),
	    isLength = __webpack_require__(469),
	    toKey = __webpack_require__(208);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ },
/* 739 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(88);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ },
/* 740 */
/***/ function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ },
/* 741 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ },
/* 742 */
/***/ function(module, exports, __webpack_require__) {

	var WeakMap = __webpack_require__(718);
	
	/** Used to store function metadata. */
	var metaMap = WeakMap && new WeakMap;
	
	module.exports = metaMap;


/***/ },
/* 743 */,
/* 744 */
/***/ function(module, exports, __webpack_require__) {

	var baseSetData = __webpack_require__(726),
	    shortOut = __webpack_require__(748);
	
	/**
	 * Sets metadata for `func`.
	 *
	 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	 * period of time, it will trip its breaker and transition to an identity
	 * function to avoid garbage collection pauses in V8. See
	 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	 * for more details.
	 *
	 * @private
	 * @param {Function} func The function to associate metadata with.
	 * @param {*} data The metadata.
	 * @returns {Function} Returns `func`.
	 */
	var setData = shortOut(baseSetData);
	
	module.exports = setData;


/***/ },
/* 745 */
/***/ function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ },
/* 746 */
/***/ function(module, exports, __webpack_require__) {

	var baseSetToString = __webpack_require__(2851),
	    shortOut = __webpack_require__(748);
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ },
/* 747 */
/***/ function(module, exports, __webpack_require__) {

	var getWrapDetails = __webpack_require__(2884),
	    insertWrapDetails = __webpack_require__(2893),
	    setToString = __webpack_require__(746),
	    updateWrapDetails = __webpack_require__(2927);
	
	/**
	 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	 * with wrapper details in a comment at the top of the source body.
	 *
	 * @private
	 * @param {Function} wrapper The function to modify.
	 * @param {Function} reference The reference function.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @returns {Function} Returns `wrapper`.
	 */
	function setWrapToString(wrapper, reference, bitmask) {
	  var source = (reference + '');
	  return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	}
	
	module.exports = setWrapToString;


/***/ },
/* 748 */
/***/ function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ },
/* 749 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ },
/* 750 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(329);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ },
/* 751 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(160),
	    isObject = __webpack_require__(88);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 752 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(720),
	    baseKeysIn = __webpack_require__(2843),
	    isArrayLike = __webpack_require__(209);
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	module.exports = keysIn;


/***/ },
/* 753 */
/***/ function(module, exports) {

	/**
	 * Gets the last element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {*} Returns the last element of `array`.
	 * @example
	 *
	 * _.last([1, 2, 3]);
	 * // => 3
	 */
	function last(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? array[length - 1] : undefined;
	}
	
	module.exports = last;


/***/ },
/* 754 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(254),
	    baseClone = __webpack_require__(2829),
	    baseUnset = __webpack_require__(2856),
	    castPath = __webpack_require__(207),
	    copyObject = __webpack_require__(255),
	    customOmitClone = __webpack_require__(2876),
	    flatRest = __webpack_require__(2879),
	    getAllKeysIn = __webpack_require__(460);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/**
	 * The opposite of `_.pick`; this method creates an object composed of the
	 * own and inherited enumerable property paths of `object` that are not omitted.
	 *
	 * **Note:** This method is considerably slower than `_.pick`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {...(string|string[])} [paths] The property paths to omit.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.omit(object, ['a', 'c']);
	 * // => { 'b': '2' }
	 */
	var omit = flatRest(function(object, paths) {
	  var result = {};
	  if (object == null) {
	    return result;
	  }
	  var isDeep = false;
	  paths = arrayMap(paths, function(path) {
	    path = castPath(path, object);
	    isDeep || (isDeep = path.length > 1);
	    return path;
	  });
	  copyObject(object, getAllKeysIn(object), result);
	  if (isDeep) {
	    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	  }
	  var length = paths.length;
	  while (length--) {
	    baseUnset(result, paths[length]);
	  }
	  return result;
	});
	
	module.exports = omit;


/***/ },
/* 755 */
/***/ function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ },
/* 756 */
/***/ function(module, exports, __webpack_require__) {

	var debounce = __webpack_require__(466),
	    isObject = __webpack_require__(88);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed `func` invocations and a `flush` method to
	 * immediately invoke them. Provide `options` to indicate whether `func`
	 * should be invoked on the leading and/or trailing edge of the `wait`
	 * timeout. The `func` is invoked with the last arguments provided to the
	 * throttled function. Subsequent calls to the throttled function return the
	 * result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the throttled function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=true]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // Avoid excessively updating the position while scrolling.
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	 * jQuery(element).on('click', throttled);
	 *
	 * // Cancel the trailing throttled invocation.
	 * jQuery(window).on('popstate', throttled.cancel);
	 */
	function throttle(func, wait, options) {
	  var leading = true,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if (isObject(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return debounce(func, wait, {
	    'leading': leading,
	    'maxWait': wait,
	    'trailing': trailing
	  });
	}
	
	module.exports = throttle;


/***/ },
/* 757 */
/***/ function(module, exports, __webpack_require__) {

	var toFinite = __webpack_require__(2946);
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	module.exports = toInteger;


/***/ },
/* 758 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(88),
	    isSymbol = __webpack_require__(337);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ },
/* 759 */
/***/ function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(2854);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ },
/* 760 */
/***/ function(module, exports, __webpack_require__) {

	var baseValues = __webpack_require__(2857),
	    keys = __webpack_require__(163);
	
	/**
	 * Creates an array of the own enumerable string keyed property values of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property values.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.values(new Foo);
	 * // => [1, 2] (iteration order is not guaranteed)
	 *
	 * _.values('hi');
	 * // => ['h', 'i']
	 */
	function values(object) {
	  return object == null ? [] : baseValues(object, keys(object));
	}
	
	module.exports = values;


/***/ },
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// modified from https://github.com/es-shims/es5-shim
	var has = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	var slice = Array.prototype.slice;
	var isArgs = __webpack_require__(2951);
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
	var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
	var dontEnums = [
		'toString',
		'toLocaleString',
		'valueOf',
		'hasOwnProperty',
		'isPrototypeOf',
		'propertyIsEnumerable',
		'constructor'
	];
	var equalsConstructorPrototype = function (o) {
		var ctor = o.constructor;
		return ctor && ctor.prototype === o;
	};
	var excludedKeys = {
		$applicationCache: true,
		$console: true,
		$external: true,
		$frame: true,
		$frameElement: true,
		$frames: true,
		$innerHeight: true,
		$innerWidth: true,
		$outerHeight: true,
		$outerWidth: true,
		$pageXOffset: true,
		$pageYOffset: true,
		$parent: true,
		$scrollLeft: true,
		$scrollTop: true,
		$scrollX: true,
		$scrollY: true,
		$self: true,
		$webkitIndexedDB: true,
		$webkitStorageInfo: true,
		$window: true
	};
	var hasAutomationEqualityBug = (function () {
		/* global window */
		if (typeof window === 'undefined') { return false; }
		for (var k in window) {
			try {
				if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
					try {
						equalsConstructorPrototype(window[k]);
					} catch (e) {
						return true;
					}
				}
			} catch (e) {
				return true;
			}
		}
		return false;
	}());
	var equalsConstructorPrototypeIfNotBuggy = function (o) {
		/* global window */
		if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
			return equalsConstructorPrototype(o);
		}
		try {
			return equalsConstructorPrototype(o);
		} catch (e) {
			return false;
		}
	};
	
	var keysShim = function keys(object) {
		var isObject = object !== null && typeof object === 'object';
		var isFunction = toStr.call(object) === '[object Function]';
		var isArguments = isArgs(object);
		var isString = isObject && toStr.call(object) === '[object String]';
		var theKeys = [];
	
		if (!isObject && !isFunction && !isArguments) {
			throw new TypeError('Object.keys called on a non-object');
		}
	
		var skipProto = hasProtoEnumBug && isFunction;
		if (isString && object.length > 0 && !has.call(object, 0)) {
			for (var i = 0; i < object.length; ++i) {
				theKeys.push(String(i));
			}
		}
	
		if (isArguments && object.length > 0) {
			for (var j = 0; j < object.length; ++j) {
				theKeys.push(String(j));
			}
		} else {
			for (var name in object) {
				if (!(skipProto && name === 'prototype') && has.call(object, name)) {
					theKeys.push(String(name));
				}
			}
		}
	
		if (hasDontEnumBug) {
			var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);
	
			for (var k = 0; k < dontEnums.length; ++k) {
				if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
					theKeys.push(dontEnums[k]);
				}
			}
		}
		return theKeys;
	};
	
	keysShim.shim = function shimObjectKeys() {
		if (Object.keys) {
			var keysWorksWithArguments = (function () {
				// Safari 5.0 bug
				return (Object.keys(arguments) || '').length === 2;
			}(1, 2));
			if (!keysWorksWithArguments) {
				var originalKeys = Object.keys;
				Object.keys = function keys(object) { // eslint-disable-line func-name-matching
					if (isArgs(object)) {
						return originalKeys(slice.call(object));
					} else {
						return originalKeys(object);
					}
				};
			}
		} else {
			Object.keys = keysShim;
		}
		return Object.keys || keysShim;
	};
	
	module.exports = keysShim;


/***/ },
/* 845 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var ES = __webpack_require__(2445);
	var has = __webpack_require__(322);
	var bind = __webpack_require__(253);
	var isEnumerable = bind.call(Function.call, Object.prototype.propertyIsEnumerable);
	
	module.exports = function values(O) {
		var obj = ES.RequireObjectCoercible(O);
		var vals = [];
		for (var key in obj) {
			if (has(obj, key) && isEnumerable(obj, key)) {
				vals.push(obj[key]);
			}
		}
		return vals;
	};


/***/ },
/* 846 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(251);
	
	var implementation = __webpack_require__(845);
	var getPolyfill = __webpack_require__(847);
	var shim = __webpack_require__(2952);
	
	var polyfill = getPolyfill();
	
	define(polyfill, {
		getPolyfill: getPolyfill,
		implementation: implementation,
		shim: shim
	});
	
	module.exports = polyfill;


/***/ },
/* 847 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(845);
	
	module.exports = function getPolyfill() {
		return typeof Object.values === 'function' ? Object.values : implementation;
	};


/***/ },
/* 848 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var CalendarIcon = function () {
	  function CalendarIcon(props) {
	    return _react2['default'].createElement(
	      'svg',
	      props,
	      _react2['default'].createElement('path', {
	        d: 'M107.2 1392.9h241.1v-241.1H107.2v241.1zm294.7 0h267.9v-241.1H401.9v241.1zm-294.7-294.7h241.1V830.4H107.2v267.8zm294.7 0h267.9V830.4H401.9v267.8zM107.2 776.8h241.1V535.7H107.2v241.1zm616.2 616.1h267.9v-241.1H723.4v241.1zM401.9 776.8h267.9V535.7H401.9v241.1zm642.9 616.1H1286v-241.1h-241.1v241.1zm-321.4-294.7h267.9V830.4H723.4v267.8zM428.7 375V133.9c0-7.3-2.7-13.5-8-18.8-5.3-5.3-11.6-8-18.8-8h-53.6c-7.3 0-13.5 2.7-18.8 8-5.3 5.3-8 11.6-8 18.8V375c0 7.3 2.7 13.5 8 18.8 5.3 5.3 11.6 8 18.8 8h53.6c7.3 0 13.5-2.7 18.8-8 5.3-5.3 8-11.5 8-18.8zm616.1 723.2H1286V830.4h-241.1v267.8zM723.4 776.8h267.9V535.7H723.4v241.1zm321.4 0H1286V535.7h-241.1v241.1zm26.8-401.8V133.9c0-7.3-2.7-13.5-8-18.8-5.3-5.3-11.6-8-18.8-8h-53.6c-7.3 0-13.5 2.7-18.8 8-5.3 5.3-8 11.6-8 18.8V375c0 7.3 2.7 13.5 8 18.8 5.3 5.3 11.6 8 18.8 8h53.6c7.3 0 13.5-2.7 18.8-8 5.4-5.3 8-11.5 8-18.8zm321.5-53.6v1071.4c0 29-10.6 54.1-31.8 75.3-21.2 21.2-46.3 31.8-75.3 31.8H107.2c-29 0-54.1-10.6-75.3-31.8C10.6 1447 0 1421.9 0 1392.9V321.4c0-29 10.6-54.1 31.8-75.3s46.3-31.8 75.3-31.8h107.2v-80.4c0-36.8 13.1-68.4 39.3-94.6S311.4 0 348.3 0h53.6c36.8 0 68.4 13.1 94.6 39.3 26.2 26.2 39.3 57.8 39.3 94.6v80.4h321.5v-80.4c0-36.8 13.1-68.4 39.3-94.6C922.9 13.1 954.4 0 991.3 0h53.6c36.8 0 68.4 13.1 94.6 39.3s39.3 57.8 39.3 94.6v80.4H1286c29 0 54.1 10.6 75.3 31.8 21.2 21.2 31.8 46.3 31.8 75.3z'
	      })
	    );
	  }
	
	  return CalendarIcon;
	}();
	
	CalendarIcon.defaultProps = {
	  xmlns: 'http://www.w3.org/2000/svg',
	  viewBox: '0 0 1393.1 1500'
	};
	exports['default'] = CalendarIcon;

/***/ },
/* 849 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _object = __webpack_require__(55);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(27);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactAddonsShallowCompare = __webpack_require__(210);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _reactMomentProptypes = __webpack_require__(112);
	
	var _reactMomentProptypes2 = _interopRequireDefault(_reactMomentProptypes);
	
	var _airbnbPropTypes = __webpack_require__(42);
	
	var _reactWithStyles = __webpack_require__(72);
	
	var _moment = __webpack_require__(9);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _defaultPhrases = __webpack_require__(50);
	
	var _getPhrasePropTypes = __webpack_require__(63);
	
	var _getPhrasePropTypes2 = _interopRequireDefault(_getPhrasePropTypes);
	
	var _CalendarWeek = __webpack_require__(2968);
	
	var _CalendarWeek2 = _interopRequireDefault(_CalendarWeek);
	
	var _CalendarDay = __webpack_require__(471);
	
	var _CalendarDay2 = _interopRequireDefault(_CalendarDay);
	
	var _calculateDimension = __webpack_require__(865);
	
	var _calculateDimension2 = _interopRequireDefault(_calculateDimension);
	
	var _getCalendarMonthWeeks = __webpack_require__(2980);
	
	var _getCalendarMonthWeeks2 = _interopRequireDefault(_getCalendarMonthWeeks);
	
	var _isSameDay = __webpack_require__(214);
	
	var _isSameDay2 = _interopRequireDefault(_isSameDay);
	
	var _toISODateString = __webpack_require__(340);
	
	var _toISODateString2 = _interopRequireDefault(_toISODateString);
	
	var _ScrollableOrientationShape = __webpack_require__(212);
	
	var _ScrollableOrientationShape2 = _interopRequireDefault(_ScrollableOrientationShape);
	
	var _DayOfWeekShape = __webpack_require__(165);
	
	var _DayOfWeekShape2 = _interopRequireDefault(_DayOfWeekShape);
	
	var _constants = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/no-array-index-key: 0 */
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)((0, _object2['default'])({}, _reactWithStyles.withStylesPropTypes, {
	  month: _reactMomentProptypes2['default'].momentObj,
	  isVisible: _propTypes2['default'].bool,
	  enableOutsideDays: _propTypes2['default'].bool,
	  modifiers: _propTypes2['default'].object,
	  orientation: _ScrollableOrientationShape2['default'],
	  daySize: _airbnbPropTypes.nonNegativeInteger,
	  onDayClick: _propTypes2['default'].func,
	  onDayMouseEnter: _propTypes2['default'].func,
	  onDayMouseLeave: _propTypes2['default'].func,
	  renderMonth: _propTypes2['default'].func,
	  renderCalendarDay: _propTypes2['default'].func,
	  renderDayContents: _propTypes2['default'].func,
	  firstDayOfWeek: _DayOfWeekShape2['default'],
	  setMonthHeight: _propTypes2['default'].func,
	  verticalBorderSpacing: _airbnbPropTypes.nonNegativeInteger,
	
	  focusedDate: _reactMomentProptypes2['default'].momentObj, // indicates focusable day
	  isFocused: _propTypes2['default'].bool, // indicates whether or not to move focus to focusable day
	
	  // i18n
	  monthFormat: _propTypes2['default'].string,
	  phrases: _propTypes2['default'].shape((0, _getPhrasePropTypes2['default'])(_defaultPhrases.CalendarDayPhrases)),
	  dayAriaLabelFormat: _propTypes2['default'].string
	}));
	
	var defaultProps = {
	  month: (0, _moment2['default'])(),
	  isVisible: true,
	  enableOutsideDays: false,
	  modifiers: {},
	  orientation: _constants.HORIZONTAL_ORIENTATION,
	  daySize: _constants.DAY_SIZE,
	  onDayClick: function () {
	    function onDayClick() {}
	
	    return onDayClick;
	  }(),
	  onDayMouseEnter: function () {
	    function onDayMouseEnter() {}
	
	    return onDayMouseEnter;
	  }(),
	  onDayMouseLeave: function () {
	    function onDayMouseLeave() {}
	
	    return onDayMouseLeave;
	  }(),
	
	  renderMonth: null,
	  renderCalendarDay: function () {
	    function renderCalendarDay(props) {
	      return _react2['default'].createElement(_CalendarDay2['default'], props);
	    }
	
	    return renderCalendarDay;
	  }(),
	  renderDayContents: null,
	  firstDayOfWeek: null,
	  setMonthHeight: function () {
	    function setMonthHeight() {}
	
	    return setMonthHeight;
	  }(),
	
	
	  focusedDate: null,
	  isFocused: false,
	
	  // i18n
	  monthFormat: 'MMMM YYYY', // english locale
	  phrases: _defaultPhrases.CalendarDayPhrases,
	  dayAriaLabelFormat: undefined,
	  verticalBorderSpacing: undefined
	};
	
	var CalendarMonth = function (_React$Component) {
	  _inherits(CalendarMonth, _React$Component);
	
	  function CalendarMonth(props) {
	    _classCallCheck(this, CalendarMonth);
	
	    var _this = _possibleConstructorReturn(this, (CalendarMonth.__proto__ || Object.getPrototypeOf(CalendarMonth)).call(this, props));
	
	    _this.state = {
	      weeks: (0, _getCalendarMonthWeeks2['default'])(props.month, props.enableOutsideDays, props.firstDayOfWeek == null ? _moment2['default'].localeData().firstDayOfWeek() : props.firstDayOfWeek)
	    };
	
	    _this.setCaptionRef = _this.setCaptionRef.bind(_this);
	    _this.setGridRef = _this.setGridRef.bind(_this);
	    _this.setMonthHeight = _this.setMonthHeight.bind(_this);
	    return _this;
	  }
	
	  _createClass(CalendarMonth, [{
	    key: 'componentDidMount',
	    value: function () {
	      function componentDidMount() {
	        this.setMonthHeightTimeout = setTimeout(this.setMonthHeight, 0);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function () {
	      function componentWillReceiveProps(nextProps) {
	        var month = nextProps.month,
	            enableOutsideDays = nextProps.enableOutsideDays,
	            firstDayOfWeek = nextProps.firstDayOfWeek;
	
	        if (!month.isSame(this.props.month) || enableOutsideDays !== this.props.enableOutsideDays || firstDayOfWeek !== this.props.firstDayOfWeek) {
	          this.setState({
	            weeks: (0, _getCalendarMonthWeeks2['default'])(month, enableOutsideDays, firstDayOfWeek == null ? _moment2['default'].localeData().firstDayOfWeek() : firstDayOfWeek)
	          });
	        }
	      }
	
	      return componentWillReceiveProps;
	    }()
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function () {
	      function shouldComponentUpdate(nextProps, nextState) {
	        return (0, _reactAddonsShallowCompare2['default'])(this, nextProps, nextState);
	      }
	
	      return shouldComponentUpdate;
	    }()
	  }, {
	    key: 'componentWillUnmount',
	    value: function () {
	      function componentWillUnmount() {
	        if (this.setMonthHeightTimeout) {
	          clearTimeout(this.setMonthHeightTimeout);
	        }
	      }
	
	      return componentWillUnmount;
	    }()
	  }, {
	    key: 'setMonthHeight',
	    value: function () {
	      function setMonthHeight() {
	        var setMonthHeight = this.props.setMonthHeight;
	
	        var captionHeight = (0, _calculateDimension2['default'])(this.captionRef, 'height', true, true);
	        var gridHeight = (0, _calculateDimension2['default'])(this.gridRef, 'height');
	
	        setMonthHeight(captionHeight + gridHeight + 1);
	      }
	
	      return setMonthHeight;
	    }()
	  }, {
	    key: 'setCaptionRef',
	    value: function () {
	      function setCaptionRef(ref) {
	        this.captionRef = ref;
	      }
	
	      return setCaptionRef;
	    }()
	  }, {
	    key: 'setGridRef',
	    value: function () {
	      function setGridRef(ref) {
	        this.gridRef = ref;
	      }
	
	      return setGridRef;
	    }()
	  }, {
	    key: 'render',
	    value: function () {
	      function render() {
	        var _props = this.props,
	            month = _props.month,
	            monthFormat = _props.monthFormat,
	            orientation = _props.orientation,
	            isVisible = _props.isVisible,
	            modifiers = _props.modifiers,
	            onDayClick = _props.onDayClick,
	            onDayMouseEnter = _props.onDayMouseEnter,
	            onDayMouseLeave = _props.onDayMouseLeave,
	            renderMonth = _props.renderMonth,
	            renderCalendarDay = _props.renderCalendarDay,
	            renderDayContents = _props.renderDayContents,
	            daySize = _props.daySize,
	            focusedDate = _props.focusedDate,
	            isFocused = _props.isFocused,
	            styles = _props.styles,
	            phrases = _props.phrases,
	            dayAriaLabelFormat = _props.dayAriaLabelFormat,
	            verticalBorderSpacing = _props.verticalBorderSpacing;
	        var weeks = this.state.weeks;
	
	        var monthTitle = renderMonth ? renderMonth(month) : month.format(monthFormat);
	
	        var verticalScrollable = orientation === _constants.VERTICAL_SCROLLABLE;
	
	        return _react2['default'].createElement(
	          'div',
	          _extends({}, (0, _reactWithStyles.css)(styles.CalendarMonth, orientation === _constants.HORIZONTAL_ORIENTATION && styles.CalendarMonth__horizontal, orientation === _constants.VERTICAL_ORIENTATION && styles.CalendarMonth__vertical, verticalScrollable && styles.CalendarMonth__verticalScrollable), {
	            'data-visible': isVisible
	          }),
	          _react2['default'].createElement(
	            'div',
	            _extends({
	              ref: this.setCaptionRef
	            }, (0, _reactWithStyles.css)(styles.CalendarMonth_caption, verticalScrollable && styles.CalendarMonth_caption__verticalScrollable)),
	            _react2['default'].createElement(
	              'strong',
	              null,
	              monthTitle
	            )
	          ),
	          _react2['default'].createElement(
	            'table',
	            _extends({}, (0, _reactWithStyles.css)(!verticalBorderSpacing && styles.CalendarMonth_table, verticalBorderSpacing && styles.CalendarMonth_verticalSpacing, verticalBorderSpacing && { borderSpacing: '0px ' + String(verticalBorderSpacing) + 'px' }), {
	              role: 'presentation'
	            }),
	            _react2['default'].createElement(
	              'tbody',
	              { ref: this.setGridRef },
	              weeks.map(function (week, i) {
	                return _react2['default'].createElement(
	                  _CalendarWeek2['default'],
	                  { key: i },
	                  week.map(function (day, dayOfWeek) {
	                    return renderCalendarDay({
	                      key: dayOfWeek,
	                      day: day,
	                      daySize: daySize,
	                      isOutsideDay: !day || day.month() !== month.month(),
	                      tabIndex: isVisible && (0, _isSameDay2['default'])(day, focusedDate) ? 0 : -1,
	                      isFocused: isFocused,
	                      onDayMouseEnter: onDayMouseEnter,
	                      onDayMouseLeave: onDayMouseLeave,
	                      onDayClick: onDayClick,
	                      renderDayContents: renderDayContents,
	                      phrases: phrases,
	                      modifiers: modifiers[(0, _toISODateString2['default'])(day)],
	                      ariaLabelFormat: dayAriaLabelFormat
	                    });
	                  })
	                );
	              })
	            )
	          )
	        );
	      }
	
	      return render;
	    }()
	  }]);
	
	  return CalendarMonth;
	}(_react2['default'].Component);
	
	CalendarMonth.propTypes = propTypes;
	CalendarMonth.defaultProps = defaultProps;
	
	exports['default'] = (0, _reactWithStyles.withStyles)(function (_ref) {
	  var _ref$reactDates = _ref.reactDates,
	      color = _ref$reactDates.color,
	      font = _ref$reactDates.font,
	      spacing = _ref$reactDates.spacing;
	  return {
	    CalendarMonth: {
	      background: color.background,
	      textAlign: 'center',
	      padding: '0 13px',
	      verticalAlign: 'top',
	      userSelect: 'none'
	    },
	
	    CalendarMonth_table: {
	      borderCollapse: 'collapse',
	      borderSpacing: 0
	    },
	
	    CalendarMonth_verticalSpacing: {
	      borderCollapse: 'separate'
	    },
	
	    CalendarMonth_caption: {
	      color: color.text,
	      fontSize: font.captionSize,
	      textAlign: 'center',
	      paddingTop: spacing.captionPaddingTop,
	      paddingBottom: spacing.captionPaddingBottom,
	      captionSide: 'initial'
	    },
	
	    CalendarMonth_caption__verticalScrollable: {
	      paddingTop: 12,
	      paddingBottom: 7
	    }
	  };
	})(CalendarMonth);

/***/ },
/* 850 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _object = __webpack_require__(55);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(27);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactAddonsShallowCompare = __webpack_require__(210);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _reactMomentProptypes = __webpack_require__(112);
	
	var _reactMomentProptypes2 = _interopRequireDefault(_reactMomentProptypes);
	
	var _airbnbPropTypes = __webpack_require__(42);
	
	var _reactWithStyles = __webpack_require__(72);
	
	var _moment = __webpack_require__(9);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _consolidatedEvents = __webpack_require__(301);
	
	var _defaultPhrases = __webpack_require__(50);
	
	var _getPhrasePropTypes = __webpack_require__(63);
	
	var _getPhrasePropTypes2 = _interopRequireDefault(_getPhrasePropTypes);
	
	var _CalendarMonth = __webpack_require__(849);
	
	var _CalendarMonth2 = _interopRequireDefault(_CalendarMonth);
	
	var _isTransitionEndSupported = __webpack_require__(2985);
	
	var _isTransitionEndSupported2 = _interopRequireDefault(_isTransitionEndSupported);
	
	var _getTransformStyles = __webpack_require__(2983);
	
	var _getTransformStyles2 = _interopRequireDefault(_getTransformStyles);
	
	var _getCalendarMonthWidth = __webpack_require__(868);
	
	var _getCalendarMonthWidth2 = _interopRequireDefault(_getCalendarMonthWidth);
	
	var _toISOMonthString = __webpack_require__(341);
	
	var _toISOMonthString2 = _interopRequireDefault(_toISOMonthString);
	
	var _isAfterDay = __webpack_require__(262);
	
	var _isAfterDay2 = _interopRequireDefault(_isAfterDay);
	
	var _ScrollableOrientationShape = __webpack_require__(212);
	
	var _ScrollableOrientationShape2 = _interopRequireDefault(_ScrollableOrientationShape);
	
	var _DayOfWeekShape = __webpack_require__(165);
	
	var _DayOfWeekShape2 = _interopRequireDefault(_DayOfWeekShape);
	
	var _constants = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)((0, _object2['default'])({}, _reactWithStyles.withStylesPropTypes, {
	  enableOutsideDays: _propTypes2['default'].bool,
	  firstVisibleMonthIndex: _propTypes2['default'].number,
	  initialMonth: _reactMomentProptypes2['default'].momentObj,
	  isAnimating: _propTypes2['default'].bool,
	  numberOfMonths: _propTypes2['default'].number,
	  modifiers: _propTypes2['default'].object,
	  orientation: _ScrollableOrientationShape2['default'],
	  onDayClick: _propTypes2['default'].func,
	  onDayMouseEnter: _propTypes2['default'].func,
	  onDayMouseLeave: _propTypes2['default'].func,
	  onMonthTransitionEnd: _propTypes2['default'].func,
	  renderMonth: _propTypes2['default'].func,
	  renderCalendarDay: _propTypes2['default'].func,
	  renderDayContents: _propTypes2['default'].func,
	  transformValue: _propTypes2['default'].string,
	  daySize: _airbnbPropTypes.nonNegativeInteger,
	  focusedDate: _reactMomentProptypes2['default'].momentObj, // indicates focusable day
	  isFocused: _propTypes2['default'].bool, // indicates whether or not to move focus to focusable day
	  firstDayOfWeek: _DayOfWeekShape2['default'],
	  setCalendarMonthHeights: _propTypes2['default'].func,
	  isRTL: _propTypes2['default'].bool,
	  transitionDuration: _airbnbPropTypes.nonNegativeInteger,
	  verticalBorderSpacing: _airbnbPropTypes.nonNegativeInteger,
	
	  // i18n
	  monthFormat: _propTypes2['default'].string,
	  phrases: _propTypes2['default'].shape((0, _getPhrasePropTypes2['default'])(_defaultPhrases.CalendarDayPhrases)),
	  dayAriaLabelFormat: _propTypes2['default'].string
	}));
	
	var defaultProps = {
	  enableOutsideDays: false,
	  firstVisibleMonthIndex: 0,
	  initialMonth: (0, _moment2['default'])(),
	  isAnimating: false,
	  numberOfMonths: 1,
	  modifiers: {},
	  orientation: _constants.HORIZONTAL_ORIENTATION,
	  onDayClick: function () {
	    function onDayClick() {}
	
	    return onDayClick;
	  }(),
	  onDayMouseEnter: function () {
	    function onDayMouseEnter() {}
	
	    return onDayMouseEnter;
	  }(),
	  onDayMouseLeave: function () {
	    function onDayMouseLeave() {}
	
	    return onDayMouseLeave;
	  }(),
	  onMonthTransitionEnd: function () {
	    function onMonthTransitionEnd() {}
	
	    return onMonthTransitionEnd;
	  }(),
	
	  renderMonth: null,
	  renderCalendarDay: undefined,
	  renderDayContents: null,
	  transformValue: 'none',
	  daySize: _constants.DAY_SIZE,
	  focusedDate: null,
	  isFocused: false,
	  firstDayOfWeek: null,
	  setCalendarMonthHeights: function () {
	    function setCalendarMonthHeights() {}
	
	    return setCalendarMonthHeights;
	  }(),
	
	  isRTL: false,
	  transitionDuration: 200,
	  verticalBorderSpacing: undefined,
	
	  // i18n
	  monthFormat: 'MMMM YYYY', // english locale
	  phrases: _defaultPhrases.CalendarDayPhrases,
	  dayAriaLabelFormat: undefined
	};
	
	function getMonths(initialMonth, numberOfMonths, withoutTransitionMonths) {
	  var month = initialMonth.clone();
	  if (!withoutTransitionMonths) month = month.subtract(1, 'month');
	
	  var months = [];
	  for (var i = 0; i < (withoutTransitionMonths ? numberOfMonths : numberOfMonths + 2); i += 1) {
	    months.push(month);
	    month = month.clone().add(1, 'month');
	  }
	
	  return months;
	}
	
	var CalendarMonthGrid = function (_React$Component) {
	  _inherits(CalendarMonthGrid, _React$Component);
	
	  function CalendarMonthGrid(props) {
	    _classCallCheck(this, CalendarMonthGrid);
	
	    var _this = _possibleConstructorReturn(this, (CalendarMonthGrid.__proto__ || Object.getPrototypeOf(CalendarMonthGrid)).call(this, props));
	
	    var withoutTransitionMonths = props.orientation === _constants.VERTICAL_SCROLLABLE;
	    _this.state = {
	      months: getMonths(props.initialMonth, props.numberOfMonths, withoutTransitionMonths)
	    };
	
	    _this.calendarMonthHeights = [];
	
	    _this.isTransitionEndSupported = (0, _isTransitionEndSupported2['default'])();
	    _this.onTransitionEnd = _this.onTransitionEnd.bind(_this);
	    _this.setContainerRef = _this.setContainerRef.bind(_this);
	
	    _this.locale = _moment2['default'].locale();
	    return _this;
	  }
	
	  _createClass(CalendarMonthGrid, [{
	    key: 'componentDidMount',
	    value: function () {
	      function componentDidMount() {
	        var _this2 = this;
	
	        var setCalendarMonthHeights = this.props.setCalendarMonthHeights;
	
	        this.removeEventListener = (0, _consolidatedEvents.addEventListener)(this.container, 'transitionend', this.onTransitionEnd);
	
	        this.setCalendarMonthHeightsTimeout = setTimeout(function () {
	          setCalendarMonthHeights(_this2.calendarMonthHeights);
	        }, 0);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function () {
	      function componentWillReceiveProps(nextProps) {
	        var _this3 = this;
	
	        var initialMonth = nextProps.initialMonth,
	            numberOfMonths = nextProps.numberOfMonths,
	            orientation = nextProps.orientation;
	        var months = this.state.months;
	
	
	        var hasMonthChanged = !this.props.initialMonth.isSame(initialMonth, 'month');
	        var hasNumberOfMonthsChanged = this.props.numberOfMonths !== numberOfMonths;
	        var newMonths = months;
	
	        if (hasMonthChanged && !hasNumberOfMonthsChanged) {
	          if ((0, _isAfterDay2['default'])(initialMonth, this.props.initialMonth)) {
	            newMonths = months.slice(1);
	            newMonths.push(months[months.length - 1].clone().add(1, 'month'));
	          } else {
	            newMonths = months.slice(0, months.length - 1);
	            newMonths.unshift(months[0].clone().subtract(1, 'month'));
	          }
	        }
	
	        if (hasNumberOfMonthsChanged) {
	          var withoutTransitionMonths = orientation === _constants.VERTICAL_SCROLLABLE;
	          newMonths = getMonths(initialMonth, numberOfMonths, withoutTransitionMonths);
	        }
	
	        var momentLocale = _moment2['default'].locale();
	        if (this.locale !== momentLocale) {
	          this.locale = momentLocale;
	          newMonths = newMonths.map(function (m) {
	            return m.locale(_this3.locale);
	          });
	        }
	
	        this.setState({
	          months: newMonths
	        });
	      }
	
	      return componentWillReceiveProps;
	    }()
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function () {
	      function shouldComponentUpdate(nextProps, nextState) {
	        return (0, _reactAddonsShallowCompare2['default'])(this, nextProps, nextState);
	      }
	
	      return shouldComponentUpdate;
	    }()
	  }, {
	    key: 'componentDidUpdate',
	    value: function () {
	      function componentDidUpdate(prevProps) {
	        var _this4 = this;
	
	        var _props = this.props,
	            isAnimating = _props.isAnimating,
	            transitionDuration = _props.transitionDuration,
	            onMonthTransitionEnd = _props.onMonthTransitionEnd,
	            setCalendarMonthHeights = _props.setCalendarMonthHeights;
	
	        // For IE9, immediately call onMonthTransitionEnd instead of
	        // waiting for the animation to complete. Similarly, if transitionDuration
	        // is set to 0, also immediately invoke the onMonthTransitionEnd callback
	
	        if ((!this.isTransitionEndSupported || !transitionDuration) && isAnimating) {
	          onMonthTransitionEnd();
	        }
	
	        if (!isAnimating && prevProps.isAnimating) {
	          this.setCalendarMonthHeightsTimeout = setTimeout(function () {
	            setCalendarMonthHeights(_this4.calendarMonthHeights);
	          }, 0);
	        }
	      }
	
	      return componentDidUpdate;
	    }()
	  }, {
	    key: 'componentWillUnmount',
	    value: function () {
	      function componentWillUnmount() {
	        if (this.removeEventListener) this.removeEventListener();
	        if (this.setCalendarMonthHeightsTimeout) {
	          clearTimeout(this.setCalendarMonthHeightsTimeout);
	        }
	      }
	
	      return componentWillUnmount;
	    }()
	  }, {
	    key: 'onTransitionEnd',
	    value: function () {
	      function onTransitionEnd() {
	        var onMonthTransitionEnd = this.props.onMonthTransitionEnd;
	
	        onMonthTransitionEnd();
	      }
	
	      return onTransitionEnd;
	    }()
	  }, {
	    key: 'setContainerRef',
	    value: function () {
	      function setContainerRef(ref) {
	        this.container = ref;
	      }
	
	      return setContainerRef;
	    }()
	  }, {
	    key: 'setMonthHeight',
	    value: function () {
	      function setMonthHeight(height, i) {
	        if (this.calendarMonthHeights[i]) {
	          if (i === 0) {
	            this.calendarMonthHeights = [height].concat(this.calendarMonthHeights.slice(0, -1));
	          } else if (i === this.calendarMonthHeights.length - 1) {
	            this.calendarMonthHeights = this.calendarMonthHeights.slice(1).concat(height);
	          }
	        } else {
	          this.calendarMonthHeights[i] = height;
	        }
	      }
	
	      return setMonthHeight;
	    }()
	  }, {
	    key: 'render',
	    value: function () {
	      function render() {
	        var _this5 = this;
	
	        var _props2 = this.props,
	            enableOutsideDays = _props2.enableOutsideDays,
	            firstVisibleMonthIndex = _props2.firstVisibleMonthIndex,
	            isAnimating = _props2.isAnimating,
	            modifiers = _props2.modifiers,
	            numberOfMonths = _props2.numberOfMonths,
	            monthFormat = _props2.monthFormat,
	            orientation = _props2.orientation,
	            transformValue = _props2.transformValue,
	            daySize = _props2.daySize,
	            onDayMouseEnter = _props2.onDayMouseEnter,
	            onDayMouseLeave = _props2.onDayMouseLeave,
	            onDayClick = _props2.onDayClick,
	            renderMonth = _props2.renderMonth,
	            renderCalendarDay = _props2.renderCalendarDay,
	            renderDayContents = _props2.renderDayContents,
	            onMonthTransitionEnd = _props2.onMonthTransitionEnd,
	            firstDayOfWeek = _props2.firstDayOfWeek,
	            focusedDate = _props2.focusedDate,
	            isFocused = _props2.isFocused,
	            isRTL = _props2.isRTL,
	            styles = _props2.styles,
	            phrases = _props2.phrases,
	            dayAriaLabelFormat = _props2.dayAriaLabelFormat,
	            transitionDuration = _props2.transitionDuration,
	            verticalBorderSpacing = _props2.verticalBorderSpacing;
	        var months = this.state.months;
	
	        var isVertical = orientation === _constants.VERTICAL_ORIENTATION;
	        var isVerticalScrollable = orientation === _constants.VERTICAL_SCROLLABLE;
	        var isHorizontal = orientation === _constants.HORIZONTAL_ORIENTATION;
	
	        var calendarMonthWidth = (0, _getCalendarMonthWidth2['default'])(daySize);
	
	        var width = isVertical || isVerticalScrollable ? calendarMonthWidth : (numberOfMonths + 2) * calendarMonthWidth;
	
	        return _react2['default'].createElement(
	          'div',
	          _extends({}, (0, _reactWithStyles.css)(styles.CalendarMonthGrid, isHorizontal && styles.CalendarMonthGrid__horizontal, isVertical && styles.CalendarMonthGrid__vertical, isVerticalScrollable && styles.CalendarMonthGrid__vertical_scrollable, isAnimating && styles.CalendarMonthGrid__animating, isAnimating && transitionDuration && {
	            transition: 'transform ' + String(transitionDuration) + 'ms ease-in-out'
	          }, (0, _object2['default'])({}, (0, _getTransformStyles2['default'])(transformValue), {
	            width: width
	          })), {
	            ref: this.setContainerRef,
	            onTransitionEnd: onMonthTransitionEnd
	          }),
	          months.map(function (month, i) {
	            var isVisible = i >= firstVisibleMonthIndex && i < firstVisibleMonthIndex + numberOfMonths;
	            var hideForAnimation = i === 0 && !isVisible;
	            var showForAnimation = i === 0 && isAnimating && isVisible;
	            var monthString = (0, _toISOMonthString2['default'])(month);
	            return _react2['default'].createElement(
	              'div',
	              _extends({
	                key: monthString
	              }, (0, _reactWithStyles.css)(isHorizontal && styles.CalendarMonthGrid_month__horizontal, hideForAnimation && styles.CalendarMonthGrid_month__hideForAnimation, showForAnimation && !isVertical && !isRTL && {
	                position: 'absolute',
	                left: -calendarMonthWidth
	              }, showForAnimation && !isVertical && isRTL && {
	                position: 'absolute',
	                right: 0
	              }, showForAnimation && isVertical && {
	                position: 'absolute',
	                top: -_this5.calendarMonthHeights[0]
	              }, !isVisible && !isAnimating && styles.CalendarMonthGrid_month__hidden)),
	              _react2['default'].createElement(_CalendarMonth2['default'], {
	                month: month,
	                isVisible: isVisible,
	                enableOutsideDays: enableOutsideDays,
	                modifiers: modifiers[monthString],
	                monthFormat: monthFormat,
	                orientation: orientation,
	                onDayMouseEnter: onDayMouseEnter,
	                onDayMouseLeave: onDayMouseLeave,
	                onDayClick: onDayClick,
	                renderMonth: renderMonth,
	                renderCalendarDay: renderCalendarDay,
	                renderDayContents: renderDayContents,
	                firstDayOfWeek: firstDayOfWeek,
	                daySize: daySize,
	                focusedDate: isVisible ? focusedDate : null,
	                isFocused: isFocused,
	                phrases: phrases,
	                setMonthHeight: function () {
	                  function setMonthHeight(height) {
	                    _this5.setMonthHeight(height, i);
	                  }
	
	                  return setMonthHeight;
	                }(),
	                dayAriaLabelFormat: dayAriaLabelFormat,
	                verticalBorderSpacing: verticalBorderSpacing
	              })
	            );
	          })
	        );
	      }
	
	      return render;
	    }()
	  }]);
	
	  return CalendarMonthGrid;
	}(_react2['default'].Component);
	
	CalendarMonthGrid.propTypes = propTypes;
	CalendarMonthGrid.defaultProps = defaultProps;
	
	exports['default'] = (0, _reactWithStyles.withStyles)(function (_ref) {
	  var _ref$reactDates = _ref.reactDates,
	      color = _ref$reactDates.color,
	      zIndex = _ref$reactDates.zIndex;
	  return {
	    CalendarMonthGrid: {
	      background: color.background,
	      textAlign: 'left',
	      zIndex: zIndex
	    },
	
	    CalendarMonthGrid__animating: {
	      zIndex: zIndex + 1
	    },
	
	    CalendarMonthGrid__horizontal: {
	      position: 'absolute',
	      left: 9
	    },
	
	    CalendarMonthGrid__vertical: {
	      margin: '0 auto'
	    },
	
	    CalendarMonthGrid__vertical_scrollable: {
	      margin: '0 auto',
	      overflowY: 'scroll'
	    },
	
	    CalendarMonthGrid_month__horizontal: {
	      display: 'inline-block',
	      verticalAlign: 'top',
	      minHeight: '100%'
	    },
	
	    CalendarMonthGrid_month__hideForAnimation: {
	      position: 'absolute',
	      zIndex: zIndex - 1,
	      opacity: 0,
	      pointerEvents: 'none'
	    },
	
	    CalendarMonthGrid_month__hidden: {
	      visibility: 'hidden'
	    }
	  };
	})(CalendarMonthGrid);

/***/ },
/* 851 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _object = __webpack_require__(55);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(27);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _airbnbPropTypes = __webpack_require__(42);
	
	var _reactWithStyles = __webpack_require__(72);
	
	var _throttle = __webpack_require__(756);
	
	var _throttle2 = _interopRequireDefault(_throttle);
	
	var _isTouchDevice = __webpack_require__(205);
	
	var _isTouchDevice2 = _interopRequireDefault(_isTouchDevice);
	
	var _getInputHeight = __webpack_require__(473);
	
	var _getInputHeight2 = _interopRequireDefault(_getInputHeight);
	
	var _OpenDirectionShape = __webpack_require__(211);
	
	var _OpenDirectionShape2 = _interopRequireDefault(_OpenDirectionShape);
	
	var _constants = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FANG_PATH_TOP = 'M0,' + String(_constants.FANG_HEIGHT_PX) + ' ' + String(_constants.FANG_WIDTH_PX) + ',' + String(_constants.FANG_HEIGHT_PX) + ' ' + _constants.FANG_WIDTH_PX / 2 + ',0z';
	var FANG_STROKE_TOP = 'M0,' + String(_constants.FANG_HEIGHT_PX) + ' ' + _constants.FANG_WIDTH_PX / 2 + ',0 ' + String(_constants.FANG_WIDTH_PX) + ',' + String(_constants.FANG_HEIGHT_PX);
	var FANG_PATH_BOTTOM = 'M0,0 ' + String(_constants.FANG_WIDTH_PX) + ',0 ' + _constants.FANG_WIDTH_PX / 2 + ',' + String(_constants.FANG_HEIGHT_PX) + 'z';
	var FANG_STROKE_BOTTOM = 'M0,0 ' + _constants.FANG_WIDTH_PX / 2 + ',' + String(_constants.FANG_HEIGHT_PX) + ' ' + String(_constants.FANG_WIDTH_PX) + ',0';
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)((0, _object2['default'])({}, _reactWithStyles.withStylesPropTypes, {
	  id: _propTypes2['default'].string.isRequired,
	  placeholder: _propTypes2['default'].string, // also used as label
	  displayValue: _propTypes2['default'].string,
	  screenReaderMessage: _propTypes2['default'].string,
	  focused: _propTypes2['default'].bool,
	  disabled: _propTypes2['default'].bool,
	  required: _propTypes2['default'].bool,
	  readOnly: _propTypes2['default'].bool,
	  openDirection: _OpenDirectionShape2['default'],
	  showCaret: _propTypes2['default'].bool,
	  verticalSpacing: _airbnbPropTypes.nonNegativeInteger,
	  small: _propTypes2['default'].bool,
	  block: _propTypes2['default'].bool,
	  regular: _propTypes2['default'].bool,
	
	  onChange: _propTypes2['default'].func,
	  onFocus: _propTypes2['default'].func,
	  onKeyDownShiftTab: _propTypes2['default'].func,
	  onKeyDownTab: _propTypes2['default'].func,
	
	  onKeyDownArrowDown: _propTypes2['default'].func,
	  onKeyDownQuestionMark: _propTypes2['default'].func,
	
	  // accessibility
	  isFocused: _propTypes2['default'].bool // describes actual DOM focus
	}));
	
	var defaultProps = {
	  placeholder: 'Select Date',
	  displayValue: '',
	  screenReaderMessage: '',
	  focused: false,
	  disabled: false,
	  required: false,
	  readOnly: null,
	  openDirection: _constants.OPEN_DOWN,
	  showCaret: false,
	  verticalSpacing: _constants.DEFAULT_VERTICAL_SPACING,
	  small: false,
	  block: false,
	  regular: false,
	
	  onChange: function () {
	    function onChange() {}
	
	    return onChange;
	  }(),
	  onFocus: function () {
	    function onFocus() {}
	
	    return onFocus;
	  }(),
	  onKeyDownShiftTab: function () {
	    function onKeyDownShiftTab() {}
	
	    return onKeyDownShiftTab;
	  }(),
	  onKeyDownTab: function () {
	    function onKeyDownTab() {}
	
	    return onKeyDownTab;
	  }(),
	  onKeyDownArrowDown: function () {
	    function onKeyDownArrowDown() {}
	
	    return onKeyDownArrowDown;
	  }(),
	  onKeyDownQuestionMark: function () {
	    function onKeyDownQuestionMark() {}
	
	    return onKeyDownQuestionMark;
	  }(),
	
	
	  // accessibility
	  isFocused: false
	};
	
	var DateInput = function (_React$Component) {
	  _inherits(DateInput, _React$Component);
	
	  function DateInput(props) {
	    _classCallCheck(this, DateInput);
	
	    var _this = _possibleConstructorReturn(this, (DateInput.__proto__ || Object.getPrototypeOf(DateInput)).call(this, props));
	
	    _this.state = {
	      dateString: '',
	      isTouchDevice: false
	    };
	
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onKeyDown = _this.onKeyDown.bind(_this);
	    _this.setInputRef = _this.setInputRef.bind(_this);
	    _this.throttledKeyDown = (0, _throttle2['default'])(_this.onFinalKeyDown, 300, { trailing: false });
	    return _this;
	  }
	
	  _createClass(DateInput, [{
	    key: 'componentDidMount',
	    value: function () {
	      function componentDidMount() {
	        this.setState({ isTouchDevice: (0, _isTouchDevice2['default'])() });
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function () {
	      function componentWillReceiveProps(nextProps) {
	        if (this.state.dateString && nextProps.displayValue) {
	          this.setState({
	            dateString: ''
	          });
	        }
	      }
	
	      return componentWillReceiveProps;
	    }()
	  }, {
	    key: 'componentDidUpdate',
	    value: function () {
	      function componentDidUpdate(prevProps) {
	        var _props = this.props,
	            focused = _props.focused,
	            isFocused = _props.isFocused;
	
	        if (prevProps.focused === focused && prevProps.isFocused === isFocused) return;
	
	        if (focused && isFocused) {
	          this.inputRef.focus();
	        } else {
	          this.inputRef.blur();
	        }
	      }
	
	      return componentDidUpdate;
	    }()
	  }, {
	    key: 'onChange',
	    value: function () {
	      function onChange(e) {
	        var _props2 = this.props,
	            onChange = _props2.onChange,
	            onKeyDownQuestionMark = _props2.onKeyDownQuestionMark;
	
	        var dateString = e.target.value;
	
	        // In Safari, onKeyDown does not consistently fire ahead of onChange. As a result, we need to
	        // special case the `?` key so that it always triggers the appropriate callback, instead of
	        // modifying the input value
	        if (dateString[dateString.length - 1] === '?') {
	          onKeyDownQuestionMark(e);
	        } else {
	          this.setState({ dateString: dateString }, function () {
	            return onChange(dateString);
	          });
	        }
	      }
	
	      return onChange;
	    }()
	  }, {
	    key: 'onKeyDown',
	    value: function () {
	      function onKeyDown(e) {
	        e.stopPropagation();
	        if (!_constants.MODIFIER_KEY_NAMES.has(e.key)) {
	          this.throttledKeyDown(e);
	        }
	      }
	
	      return onKeyDown;
	    }()
	  }, {
	    key: 'onFinalKeyDown',
	    value: function () {
	      function onFinalKeyDown(e) {
	        var _props3 = this.props,
	            onKeyDownShiftTab = _props3.onKeyDownShiftTab,
	            onKeyDownTab = _props3.onKeyDownTab,
	            onKeyDownArrowDown = _props3.onKeyDownArrowDown,
	            onKeyDownQuestionMark = _props3.onKeyDownQuestionMark;
	        var key = e.key;
	
	
	        if (key === 'Tab') {
	          if (e.shiftKey) {
	            onKeyDownShiftTab(e);
	          } else {
	            onKeyDownTab(e);
	          }
	        } else if (key === 'ArrowDown') {
	          onKeyDownArrowDown(e);
	        } else if (key === '?') {
	          e.preventDefault();
	          onKeyDownQuestionMark(e);
	        }
	      }
	
	      return onFinalKeyDown;
	    }()
	  }, {
	    key: 'setInputRef',
	    value: function () {
	      function setInputRef(ref) {
	        this.inputRef = ref;
	      }
	
	      return setInputRef;
	    }()
	  }, {
	    key: 'render',
	    value: function () {
	      function render() {
	        var _state = this.state,
	            dateString = _state.dateString,
	            isTouch = _state.isTouchDevice;
	        var _props4 = this.props,
	            id = _props4.id,
	            placeholder = _props4.placeholder,
	            displayValue = _props4.displayValue,
	            screenReaderMessage = _props4.screenReaderMessage,
	            focused = _props4.focused,
	            showCaret = _props4.showCaret,
	            onFocus = _props4.onFocus,
	            disabled = _props4.disabled,
	            required = _props4.required,
	            readOnly = _props4.readOnly,
	            openDirection = _props4.openDirection,
	            verticalSpacing = _props4.verticalSpacing,
	            small = _props4.small,
	            regular = _props4.regular,
	            block = _props4.block,
	            styles = _props4.styles,
	            reactDates = _props4.theme.reactDates;
	
	
	        var value = displayValue || dateString || '';
	        var screenReaderMessageId = 'DateInput__screen-reader-message-' + String(id);
	
	        var withFang = showCaret && focused;
	
	        var inputHeight = (0, _getInputHeight2['default'])(reactDates, small);
	
	        return _react2['default'].createElement(
	          'div',
	          (0, _reactWithStyles.css)(styles.DateInput, small && styles.DateInput__small, block && styles.DateInput__block, withFang && styles.DateInput__withFang, disabled && styles.DateInput__disabled, withFang && openDirection === _constants.OPEN_DOWN && styles.DateInput__openDown, withFang && openDirection === _constants.OPEN_UP && styles.DateInput__openUp),
	          _react2['default'].createElement('input', _extends({}, (0, _reactWithStyles.css)(styles.DateInput_input, small && styles.DateInput_input__small, regular && styles.DateInput_input__regular, readOnly && styles.DateInput_input__readOnly, focused && styles.DateInput_input__focused, disabled && styles.DateInput_input__disabled), {
	            'aria-label': placeholder,
	            type: 'text',
	            id: id,
	            name: id,
	            ref: this.setInputRef,
	            value: value,
	            onChange: this.onChange,
	            onKeyDown: this.onKeyDown,
	            onFocus: onFocus,
	            placeholder: placeholder,
	            autoComplete: 'off',
	            disabled: disabled,
	            readOnly: typeof readOnly === 'boolean' ? readOnly : isTouch,
	            required: required,
	            'aria-describedby': screenReaderMessage && screenReaderMessageId
	          })),
	          withFang && _react2['default'].createElement(
	            'svg',
	            _extends({
	              role: 'presentation',
	              focusable: 'false'
	            }, (0, _reactWithStyles.css)(styles.DateInput_fang, openDirection === _constants.OPEN_DOWN && {
	              top: inputHeight + verticalSpacing - _constants.FANG_HEIGHT_PX - 1
	            }, openDirection === _constants.OPEN_UP && {
	              bottom: inputHeight + verticalSpacing - _constants.FANG_HEIGHT_PX - 1
	            })),
	            _react2['default'].createElement('path', _extends({}, (0, _reactWithStyles.css)(styles.DateInput_fangShape), {
	              d: openDirection === _constants.OPEN_DOWN ? FANG_PATH_TOP : FANG_PATH_BOTTOM
	            })),
	            _react2['default'].createElement('path', _extends({}, (0, _reactWithStyles.css)(styles.DateInput_fangStroke), {
	              d: openDirection === _constants.OPEN_DOWN ? FANG_STROKE_TOP : FANG_STROKE_BOTTOM
	            }))
	          ),
	          screenReaderMessage && _react2['default'].createElement(
	            'p',
	            _extends({}, (0, _reactWithStyles.css)(styles.DateInput_screenReaderMessage), { id: screenReaderMessageId }),
	            screenReaderMessage
	          )
	        );
	      }
	
	      return render;
	    }()
	  }]);
	
	  return DateInput;
	}(_react2['default'].Component);
	
	DateInput.propTypes = propTypes;
	DateInput.defaultProps = defaultProps;
	
	exports['default'] = (0, _reactWithStyles.withStyles)(function (_ref) {
	  var _ref$reactDates = _ref.reactDates,
	      border = _ref$reactDates.border,
	      color = _ref$reactDates.color,
	      sizing = _ref$reactDates.sizing,
	      spacing = _ref$reactDates.spacing,
	      font = _ref$reactDates.font,
	      zIndex = _ref$reactDates.zIndex;
	  return {
	    DateInput: {
	      margin: 0,
	      padding: spacing.inputPadding,
	      background: color.background,
	      position: 'relative',
	      display: 'inline-block',
	      width: sizing.inputWidth,
	      verticalAlign: 'middle'
	    },
	
	    DateInput__small: {
	      width: sizing.inputWidth_small
	    },
	
	    DateInput__block: {
	      width: '100%'
	    },
	
	    DateInput__disabled: {
	      background: color.disabled,
	      color: color.textDisabled
	    },
	
	    DateInput_input: {
	      fontWeight: 200,
	      fontSize: font.input.size,
	      lineHeight: font.input.lineHeight,
	      color: color.text,
	      backgroundColor: color.background,
	      width: '100%',
	      padding: String(spacing.displayTextPaddingVertical) + 'px ' + String(spacing.displayTextPaddingHorizontal) + 'px',
	      paddingTop: spacing.displayTextPaddingTop,
	      paddingBottom: spacing.displayTextPaddingBottom,
	      paddingLeft: spacing.displayTextPaddingLeft,
	      paddingRight: spacing.displayTextPaddingRight,
	      border: border.input.border,
	      borderTop: border.input.borderTop,
	      borderRight: border.input.borderRight,
	      borderBottom: border.input.borderBottom,
	      borderLeft: border.input.borderLeft,
	      borderRadius: border.input.borderRadius
	    },
	
	    DateInput_input__small: {
	      fontSize: font.input.size_small,
	      lineHeight: font.input.lineHeight_small,
	      letterSpacing: font.input.letterSpacing_small,
	      padding: String(spacing.displayTextPaddingVertical_small) + 'px ' + String(spacing.displayTextPaddingHorizontal_small) + 'px',
	      paddingTop: spacing.displayTextPaddingTop_small,
	      paddingBottom: spacing.displayTextPaddingBottom_small,
	      paddingLeft: spacing.displayTextPaddingLeft_small,
	      paddingRight: spacing.displayTextPaddingRight_small
	    },
	
	    DateInput_input__regular: {
	      fontWeight: 'auto'
	    },
	
	    DateInput_input__readOnly: {
	      userSelect: 'none'
	    },
	
	    DateInput_input__focused: {
	      outline: border.input.outlineFocused,
	      background: color.backgroundFocused,
	      border: border.input.borderFocused,
	      borderTop: border.input.borderTopFocused,
	      borderRight: border.input.borderRightFocused,
	      borderBottom: border.input.borderBottomFocused,
	      borderLeft: border.input.borderLeftFocused
	    },
	
	    DateInput_input__disabled: {
	      background: color.disabled,
	      fontStyle: font.input.styleDisabled
	    },
	
	    DateInput_screenReaderMessage: {
	      border: 0,
	      clip: 'rect(0, 0, 0, 0)',
	      height: 1,
	      margin: -1,
	      overflow: 'hidden',
	      padding: 0,
	      position: 'absolute',
	      width: 1
	    },
	
	    DateInput_fang: {
	      position: 'absolute',
	      width: _constants.FANG_WIDTH_PX,
	      height: _constants.FANG_HEIGHT_PX,
	      left: 22,
	      zIndex: zIndex + 2
	    },
	
	    DateInput_fangShape: {
	      fill: color.background
	    },
	
	    DateInput_fangStroke: {
	      stroke: color.core.border,
	      fill: 'transparent'
	    }
	  };
	})(DateInput);

/***/ },
/* 852 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _object = __webpack_require__(55);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(27);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _airbnbPropTypes = __webpack_require__(42);
	
	var _reactWithStyles = __webpack_require__(72);
	
	var _defaultPhrases = __webpack_require__(50);
	
	var _getPhrasePropTypes = __webpack_require__(63);
	
	var _getPhrasePropTypes2 = _interopRequireDefault(_getPhrasePropTypes);
	
	var _OpenDirectionShape = __webpack_require__(211);
	
	var _OpenDirectionShape2 = _interopRequireDefault(_OpenDirectionShape);
	
	var _DateInput = __webpack_require__(851);
	
	var _DateInput2 = _interopRequireDefault(_DateInput);
	
	var _IconPositionShape = __webpack_require__(261);
	
	var _IconPositionShape2 = _interopRequireDefault(_IconPositionShape);
	
	var _DisabledShape = __webpack_require__(339);
	
	var _DisabledShape2 = _interopRequireDefault(_DisabledShape);
	
	var _RightArrow = __webpack_require__(857);
	
	var _RightArrow2 = _interopRequireDefault(_RightArrow);
	
	var _LeftArrow = __webpack_require__(856);
	
	var _LeftArrow2 = _interopRequireDefault(_LeftArrow);
	
	var _CloseButton = __webpack_require__(259);
	
	var _CloseButton2 = _interopRequireDefault(_CloseButton);
	
	var _CalendarIcon = __webpack_require__(848);
	
	var _CalendarIcon2 = _interopRequireDefault(_CalendarIcon);
	
	var _constants = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)((0, _object2['default'])({}, _reactWithStyles.withStylesPropTypes, {
	  startDateId: _propTypes2['default'].string,
	  startDatePlaceholderText: _propTypes2['default'].string,
	  screenReaderMessage: _propTypes2['default'].string,
	
	  endDateId: _propTypes2['default'].string,
	  endDatePlaceholderText: _propTypes2['default'].string,
	
	  onStartDateFocus: _propTypes2['default'].func,
	  onEndDateFocus: _propTypes2['default'].func,
	  onStartDateChange: _propTypes2['default'].func,
	  onEndDateChange: _propTypes2['default'].func,
	  onStartDateShiftTab: _propTypes2['default'].func,
	  onEndDateTab: _propTypes2['default'].func,
	  onClearDates: _propTypes2['default'].func,
	  onKeyDownArrowDown: _propTypes2['default'].func,
	  onKeyDownQuestionMark: _propTypes2['default'].func,
	
	  startDate: _propTypes2['default'].string,
	  endDate: _propTypes2['default'].string,
	
	  isStartDateFocused: _propTypes2['default'].bool,
	  isEndDateFocused: _propTypes2['default'].bool,
	  showClearDates: _propTypes2['default'].bool,
	  disabled: _DisabledShape2['default'],
	  required: _propTypes2['default'].bool,
	  readOnly: _propTypes2['default'].bool,
	  openDirection: _OpenDirectionShape2['default'],
	  showCaret: _propTypes2['default'].bool,
	  showDefaultInputIcon: _propTypes2['default'].bool,
	  inputIconPosition: _IconPositionShape2['default'],
	  customInputIcon: _propTypes2['default'].node,
	  customArrowIcon: _propTypes2['default'].node,
	  customCloseIcon: _propTypes2['default'].node,
	  noBorder: _propTypes2['default'].bool,
	  block: _propTypes2['default'].bool,
	  small: _propTypes2['default'].bool,
	  regular: _propTypes2['default'].bool,
	  verticalSpacing: _airbnbPropTypes.nonNegativeInteger,
	
	  // accessibility
	  isFocused: _propTypes2['default'].bool, // describes actual DOM focus
	
	  // i18n
	  phrases: _propTypes2['default'].shape((0, _getPhrasePropTypes2['default'])(_defaultPhrases.DateRangePickerInputPhrases)),
	
	  isRTL: _propTypes2['default'].bool
	}));
	
	var defaultProps = {
	  startDateId: _constants.START_DATE,
	  endDateId: _constants.END_DATE,
	  startDatePlaceholderText: 'Start Date',
	  endDatePlaceholderText: 'End Date',
	  screenReaderMessage: '',
	  onStartDateFocus: function () {
	    function onStartDateFocus() {}
	
	    return onStartDateFocus;
	  }(),
	  onEndDateFocus: function () {
	    function onEndDateFocus() {}
	
	    return onEndDateFocus;
	  }(),
	  onStartDateChange: function () {
	    function onStartDateChange() {}
	
	    return onStartDateChange;
	  }(),
	  onEndDateChange: function () {
	    function onEndDateChange() {}
	
	    return onEndDateChange;
	  }(),
	  onStartDateShiftTab: function () {
	    function onStartDateShiftTab() {}
	
	    return onStartDateShiftTab;
	  }(),
	  onEndDateTab: function () {
	    function onEndDateTab() {}
	
	    return onEndDateTab;
	  }(),
	  onClearDates: function () {
	    function onClearDates() {}
	
	    return onClearDates;
	  }(),
	  onKeyDownArrowDown: function () {
	    function onKeyDownArrowDown() {}
	
	    return onKeyDownArrowDown;
	  }(),
	  onKeyDownQuestionMark: function () {
	    function onKeyDownQuestionMark() {}
	
	    return onKeyDownQuestionMark;
	  }(),
	
	
	  startDate: '',
	  endDate: '',
	
	  isStartDateFocused: false,
	  isEndDateFocused: false,
	  showClearDates: false,
	  disabled: false,
	  required: false,
	  readOnly: false,
	  openDirection: _constants.OPEN_DOWN,
	  showCaret: false,
	  showDefaultInputIcon: false,
	  inputIconPosition: _constants.ICON_BEFORE_POSITION,
	  customInputIcon: null,
	  customArrowIcon: null,
	  customCloseIcon: null,
	  noBorder: false,
	  block: false,
	  small: false,
	  regular: false,
	  verticalSpacing: undefined,
	
	  // accessibility
	  isFocused: false,
	
	  // i18n
	  phrases: _defaultPhrases.DateRangePickerInputPhrases,
	
	  isRTL: false
	};
	
	function DateRangePickerInput(_ref) {
	  var startDate = _ref.startDate,
	      startDateId = _ref.startDateId,
	      startDatePlaceholderText = _ref.startDatePlaceholderText,
	      screenReaderMessage = _ref.screenReaderMessage,
	      isStartDateFocused = _ref.isStartDateFocused,
	      onStartDateChange = _ref.onStartDateChange,
	      onStartDateFocus = _ref.onStartDateFocus,
	      onStartDateShiftTab = _ref.onStartDateShiftTab,
	      endDate = _ref.endDate,
	      endDateId = _ref.endDateId,
	      endDatePlaceholderText = _ref.endDatePlaceholderText,
	      isEndDateFocused = _ref.isEndDateFocused,
	      onEndDateChange = _ref.onEndDateChange,
	      onEndDateFocus = _ref.onEndDateFocus,
	      onEndDateTab = _ref.onEndDateTab,
	      onKeyDownArrowDown = _ref.onKeyDownArrowDown,
	      onKeyDownQuestionMark = _ref.onKeyDownQuestionMark,
	      onClearDates = _ref.onClearDates,
	      showClearDates = _ref.showClearDates,
	      disabled = _ref.disabled,
	      required = _ref.required,
	      readOnly = _ref.readOnly,
	      showCaret = _ref.showCaret,
	      openDirection = _ref.openDirection,
	      showDefaultInputIcon = _ref.showDefaultInputIcon,
	      inputIconPosition = _ref.inputIconPosition,
	      customInputIcon = _ref.customInputIcon,
	      customArrowIcon = _ref.customArrowIcon,
	      customCloseIcon = _ref.customCloseIcon,
	      isFocused = _ref.isFocused,
	      phrases = _ref.phrases,
	      isRTL = _ref.isRTL,
	      noBorder = _ref.noBorder,
	      block = _ref.block,
	      verticalSpacing = _ref.verticalSpacing,
	      small = _ref.small,
	      regular = _ref.regular,
	      styles = _ref.styles;
	
	  var calendarIcon = customInputIcon || _react2['default'].createElement(_CalendarIcon2['default'], (0, _reactWithStyles.css)(styles.DateRangePickerInput_calendarIcon_svg));
	
	  var arrowIcon = customArrowIcon || _react2['default'].createElement(_RightArrow2['default'], (0, _reactWithStyles.css)(styles.DateRangePickerInput_arrow_svg));
	  if (isRTL) arrowIcon = _react2['default'].createElement(_LeftArrow2['default'], (0, _reactWithStyles.css)(styles.DateRangePickerInput_arrow_svg));
	  if (small) arrowIcon = '-';
	
	  var closeIcon = customCloseIcon || _react2['default'].createElement(_CloseButton2['default'], (0, _reactWithStyles.css)(styles.DateRangePickerInput_clearDates_svg, small && styles.DateRangePickerInput_clearDates_svg__small));
	  var screenReaderText = screenReaderMessage || phrases.keyboardNavigationInstructions;
	  var inputIcon = (showDefaultInputIcon || customInputIcon !== null) && _react2['default'].createElement(
	    'button',
	    _extends({}, (0, _reactWithStyles.css)(styles.DateRangePickerInput_calendarIcon), {
	      type: 'button',
	      disabled: disabled,
	      'aria-label': phrases.focusStartDate,
	      onClick: onKeyDownArrowDown
	    }),
	    calendarIcon
	  );
	  var startDateDisabled = disabled === _constants.START_DATE || disabled === true;
	  var endDateDisabled = disabled === _constants.END_DATE || disabled === true;
	
	  return _react2['default'].createElement(
	    'div',
	    (0, _reactWithStyles.css)(styles.DateRangePickerInput, disabled && styles.DateRangePickerInput__disabled, isRTL && styles.DateRangePickerInput__rtl, !noBorder && styles.DateRangePickerInput__withBorder, block && styles.DateRangePickerInput__block, showClearDates && styles.DateRangePickerInput__showClearDates),
	    inputIconPosition === _constants.ICON_BEFORE_POSITION && inputIcon,
	    _react2['default'].createElement(_DateInput2['default'], {
	      id: startDateId,
	      placeholder: startDatePlaceholderText,
	      displayValue: startDate,
	      screenReaderMessage: screenReaderText,
	      focused: isStartDateFocused,
	      isFocused: isFocused,
	      disabled: startDateDisabled,
	      required: required,
	      readOnly: readOnly,
	      showCaret: showCaret,
	      openDirection: openDirection,
	      onChange: onStartDateChange,
	      onFocus: onStartDateFocus,
	      onKeyDownShiftTab: onStartDateShiftTab,
	      onKeyDownArrowDown: onKeyDownArrowDown,
	      onKeyDownQuestionMark: onKeyDownQuestionMark,
	      verticalSpacing: verticalSpacing,
	      small: small,
	      regular: regular
	    }),
	    _react2['default'].createElement(
	      'div',
	      _extends({}, (0, _reactWithStyles.css)(styles.DateRangePickerInput_arrow), {
	        'aria-hidden': 'true',
	        role: 'presentation'
	      }),
	      arrowIcon
	    ),
	    _react2['default'].createElement(_DateInput2['default'], {
	      id: endDateId,
	      placeholder: endDatePlaceholderText,
	      displayValue: endDate,
	      screenReaderMessage: screenReaderText,
	      focused: isEndDateFocused,
	      isFocused: isFocused,
	      disabled: endDateDisabled,
	      required: required,
	      readOnly: readOnly,
	      showCaret: showCaret,
	      openDirection: openDirection,
	      onChange: onEndDateChange,
	      onFocus: onEndDateFocus,
	      onKeyDownTab: onEndDateTab,
	      onKeyDownArrowDown: onKeyDownArrowDown,
	      onKeyDownQuestionMark: onKeyDownQuestionMark,
	      verticalSpacing: verticalSpacing,
	      small: small,
	      regular: regular
	    }),
	    showClearDates && _react2['default'].createElement(
	      'button',
	      _extends({
	        type: 'button',
	        'aria-label': phrases.clearDates
	      }, (0, _reactWithStyles.css)(styles.DateRangePickerInput_clearDates, small && styles.DateRangePickerInput_clearDates__small, !customCloseIcon && styles.DateRangePickerInput_clearDates_default, !(startDate || endDate) && styles.DateRangePickerInput_clearDates__hide), {
	        onClick: onClearDates,
	        disabled: disabled
	      }),
	      closeIcon
	    ),
	    inputIconPosition === _constants.ICON_AFTER_POSITION && inputIcon
	  );
	}
	
	DateRangePickerInput.propTypes = propTypes;
	DateRangePickerInput.defaultProps = defaultProps;
	
	exports['default'] = (0, _reactWithStyles.withStyles)(function (_ref2) {
	  var _ref2$reactDates = _ref2.reactDates,
	      color = _ref2$reactDates.color,
	      sizing = _ref2$reactDates.sizing;
	  return {
	    DateRangePickerInput: {
	      backgroundColor: color.background,
	      display: 'inline-block'
	    },
	
	    DateRangePickerInput__disabled: {
	      background: color.disabled
	    },
	
	    DateRangePickerInput__withBorder: {
	      border: '1px solid ' + String(color.border),
	      borderRadius: 2
	    },
	
	    DateRangePickerInput__rtl: {
	      direction: 'rtl'
	    },
	
	    DateRangePickerInput__block: {
	      display: 'block'
	    },
	
	    DateRangePickerInput__showClearDates: {
	      paddingRight: 30
	    },
	
	    DateRangePickerInput_arrow: {
	      display: 'inline-block',
	      verticalAlign: 'middle',
	      color: color.text
	    },
	
	    DateRangePickerInput_arrow_svg: {
	      verticalAlign: 'middle',
	      fill: color.text,
	      height: sizing.arrowWidth,
	      width: sizing.arrowWidth
	    },
	
	    DateRangePickerInput_clearDates: {
	      background: 'none',
	      border: 0,
	      color: 'inherit',
	      font: 'inherit',
	      lineHeight: 'normal',
	      overflow: 'visible',
	
	      cursor: 'pointer',
	      padding: 10,
	      margin: '0 10px 0 5px',
	      position: 'absolute',
	      right: 0,
	      top: '50%',
	      transform: 'translateY(-50%)'
	    },
	
	    DateRangePickerInput_clearDates__small: {
	      padding: 6
	    },
	
	    DateRangePickerInput_clearDates_default: {
	      ':focus': {
	        background: color.core.border,
	        borderRadius: '50%'
	      },
	
	      ':hover': {
	        background: color.core.border,
	        borderRadius: '50%'
	      }
	    },
	
	    DateRangePickerInput_clearDates__hide: {
	      visibility: 'hidden'
	    },
	
	    DateRangePickerInput_clearDates_svg: {
	      fill: color.core.grayLight,
	      height: 12,
	      width: 15,
	      verticalAlign: 'middle'
	    },
	
	    DateRangePickerInput_clearDates_svg__small: {
	      height: 9
	    },
	
	    DateRangePickerInput_calendarIcon: {
	      background: 'none',
	      border: 0,
	      color: 'inherit',
	      font: 'inherit',
	      lineHeight: 'normal',
	      overflow: 'visible',
	
	      cursor: 'pointer',
	      display: 'inline-block',
	      verticalAlign: 'middle',
	      padding: 10,
	      margin: '0 5px 0 10px'
	    },
	
	    DateRangePickerInput_calendarIcon_svg: {
	      fill: color.core.grayLight,
	      height: 15,
	      width: 14,
	      verticalAlign: 'middle'
	    }
	  };
	})(DateRangePickerInput);

/***/ },
/* 853 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(27);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _moment = __webpack_require__(9);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactMomentProptypes = __webpack_require__(112);
	
	var _reactMomentProptypes2 = _interopRequireDefault(_reactMomentProptypes);
	
	var _airbnbPropTypes = __webpack_require__(42);
	
	var _OpenDirectionShape = __webpack_require__(211);
	
	var _OpenDirectionShape2 = _interopRequireDefault(_OpenDirectionShape);
	
	var _defaultPhrases = __webpack_require__(50);
	
	var _getPhrasePropTypes = __webpack_require__(63);
	
	var _getPhrasePropTypes2 = _interopRequireDefault(_getPhrasePropTypes);
	
	var _DateRangePickerInput = __webpack_require__(852);
	
	var _DateRangePickerInput2 = _interopRequireDefault(_DateRangePickerInput);
	
	var _IconPositionShape = __webpack_require__(261);
	
	var _IconPositionShape2 = _interopRequireDefault(_IconPositionShape);
	
	var _DisabledShape = __webpack_require__(339);
	
	var _DisabledShape2 = _interopRequireDefault(_DisabledShape);
	
	var _toMomentObject = __webpack_require__(215);
	
	var _toMomentObject2 = _interopRequireDefault(_toMomentObject);
	
	var _toLocalizedDateString = __webpack_require__(475);
	
	var _toLocalizedDateString2 = _interopRequireDefault(_toLocalizedDateString);
	
	var _isInclusivelyAfterDay = __webpack_require__(213);
	
	var _isInclusivelyAfterDay2 = _interopRequireDefault(_isInclusivelyAfterDay);
	
	var _isBeforeDay = __webpack_require__(263);
	
	var _isBeforeDay2 = _interopRequireDefault(_isBeforeDay);
	
	var _constants = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)({
	  startDate: _reactMomentProptypes2['default'].momentObj,
	  startDateId: _propTypes2['default'].string,
	  startDatePlaceholderText: _propTypes2['default'].string,
	  isStartDateFocused: _propTypes2['default'].bool,
	
	  endDate: _reactMomentProptypes2['default'].momentObj,
	  endDateId: _propTypes2['default'].string,
	  endDatePlaceholderText: _propTypes2['default'].string,
	  isEndDateFocused: _propTypes2['default'].bool,
	
	  screenReaderMessage: _propTypes2['default'].string,
	  showClearDates: _propTypes2['default'].bool,
	  showCaret: _propTypes2['default'].bool,
	  showDefaultInputIcon: _propTypes2['default'].bool,
	  inputIconPosition: _IconPositionShape2['default'],
	  disabled: _DisabledShape2['default'],
	  required: _propTypes2['default'].bool,
	  readOnly: _propTypes2['default'].bool,
	  openDirection: _OpenDirectionShape2['default'],
	  noBorder: _propTypes2['default'].bool,
	  block: _propTypes2['default'].bool,
	  small: _propTypes2['default'].bool,
	  regular: _propTypes2['default'].bool,
	  verticalSpacing: _airbnbPropTypes.nonNegativeInteger,
	
	  keepOpenOnDateSelect: _propTypes2['default'].bool,
	  reopenPickerOnClearDates: _propTypes2['default'].bool,
	  withFullScreenPortal: _propTypes2['default'].bool,
	  minimumNights: _airbnbPropTypes.nonNegativeInteger,
	  isOutsideRange: _propTypes2['default'].func,
	  displayFormat: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].func]),
	
	  onFocusChange: _propTypes2['default'].func,
	  onClose: _propTypes2['default'].func,
	  onDatesChange: _propTypes2['default'].func,
	  onKeyDownArrowDown: _propTypes2['default'].func,
	  onKeyDownQuestionMark: _propTypes2['default'].func,
	
	  customInputIcon: _propTypes2['default'].node,
	  customArrowIcon: _propTypes2['default'].node,
	  customCloseIcon: _propTypes2['default'].node,
	
	  // accessibility
	  isFocused: _propTypes2['default'].bool,
	
	  // i18n
	  phrases: _propTypes2['default'].shape((0, _getPhrasePropTypes2['default'])(_defaultPhrases.DateRangePickerInputPhrases)),
	
	  isRTL: _propTypes2['default'].bool
	});
	
	var defaultProps = {
	  startDate: null,
	  startDateId: _constants.START_DATE,
	  startDatePlaceholderText: 'Start Date',
	  isStartDateFocused: false,
	
	  endDate: null,
	  endDateId: _constants.END_DATE,
	  endDatePlaceholderText: 'End Date',
	  isEndDateFocused: false,
	
	  screenReaderMessage: '',
	  showClearDates: false,
	  showCaret: false,
	  showDefaultInputIcon: false,
	  inputIconPosition: _constants.ICON_BEFORE_POSITION,
	  disabled: false,
	  required: false,
	  readOnly: false,
	  openDirection: _constants.OPEN_DOWN,
	  noBorder: false,
	  block: false,
	  small: false,
	  regular: false,
	  verticalSpacing: undefined,
	
	  keepOpenOnDateSelect: false,
	  reopenPickerOnClearDates: false,
	  withFullScreenPortal: false,
	  minimumNights: 1,
	  isOutsideRange: function () {
	    function isOutsideRange(day) {
	      return !(0, _isInclusivelyAfterDay2['default'])(day, (0, _moment2['default'])());
	    }
	
	    return isOutsideRange;
	  }(),
	  displayFormat: function () {
	    function displayFormat() {
	      return _moment2['default'].localeData().longDateFormat('L');
	    }
	
	    return displayFormat;
	  }(),
	
	  onFocusChange: function () {
	    function onFocusChange() {}
	
	    return onFocusChange;
	  }(),
	  onClose: function () {
	    function onClose() {}
	
	    return onClose;
	  }(),
	  onDatesChange: function () {
	    function onDatesChange() {}
	
	    return onDatesChange;
	  }(),
	  onKeyDownArrowDown: function () {
	    function onKeyDownArrowDown() {}
	
	    return onKeyDownArrowDown;
	  }(),
	  onKeyDownQuestionMark: function () {
	    function onKeyDownQuestionMark() {}
	
	    return onKeyDownQuestionMark;
	  }(),
	
	
	  customInputIcon: null,
	  customArrowIcon: null,
	  customCloseIcon: null,
	
	  // accessibility
	  isFocused: false,
	
	  // i18n
	  phrases: _defaultPhrases.DateRangePickerInputPhrases,
	
	  isRTL: false
	};
	
	var DateRangePickerInputController = function (_React$Component) {
	  _inherits(DateRangePickerInputController, _React$Component);
	
	  function DateRangePickerInputController(props) {
	    _classCallCheck(this, DateRangePickerInputController);
	
	    var _this = _possibleConstructorReturn(this, (DateRangePickerInputController.__proto__ || Object.getPrototypeOf(DateRangePickerInputController)).call(this, props));
	
	    _this.onClearFocus = _this.onClearFocus.bind(_this);
	    _this.onStartDateChange = _this.onStartDateChange.bind(_this);
	    _this.onStartDateFocus = _this.onStartDateFocus.bind(_this);
	    _this.onEndDateChange = _this.onEndDateChange.bind(_this);
	    _this.onEndDateFocus = _this.onEndDateFocus.bind(_this);
	    _this.clearDates = _this.clearDates.bind(_this);
	    return _this;
	  }
	
	  _createClass(DateRangePickerInputController, [{
	    key: 'onClearFocus',
	    value: function () {
	      function onClearFocus() {
	        var _props = this.props,
	            onFocusChange = _props.onFocusChange,
	            onClose = _props.onClose,
	            startDate = _props.startDate,
	            endDate = _props.endDate;
	
	
	        onFocusChange(null);
	        onClose({ startDate: startDate, endDate: endDate });
	      }
	
	      return onClearFocus;
	    }()
	  }, {
	    key: 'onEndDateChange',
	    value: function () {
	      function onEndDateChange(endDateString) {
	        var _props2 = this.props,
	            startDate = _props2.startDate,
	            isOutsideRange = _props2.isOutsideRange,
	            minimumNights = _props2.minimumNights,
	            keepOpenOnDateSelect = _props2.keepOpenOnDateSelect,
	            onDatesChange = _props2.onDatesChange;
	
	
	        var endDate = (0, _toMomentObject2['default'])(endDateString, this.getDisplayFormat());
	
	        var isEndDateValid = endDate && !isOutsideRange(endDate) && !(startDate && (0, _isBeforeDay2['default'])(endDate, startDate.clone().add(minimumNights, 'days')));
	        if (isEndDateValid) {
	          onDatesChange({ startDate: startDate, endDate: endDate });
	          if (!keepOpenOnDateSelect) this.onClearFocus();
	        } else {
	          onDatesChange({
	            startDate: startDate,
	            endDate: null
	          });
	        }
	      }
	
	      return onEndDateChange;
	    }()
	  }, {
	    key: 'onEndDateFocus',
	    value: function () {
	      function onEndDateFocus() {
	        var _props3 = this.props,
	            startDate = _props3.startDate,
	            onFocusChange = _props3.onFocusChange,
	            withFullScreenPortal = _props3.withFullScreenPortal,
	            disabled = _props3.disabled;
	
	
	        if (!startDate && withFullScreenPortal && (!disabled || disabled === _constants.END_DATE)) {
	          // When the datepicker is full screen, we never want to focus the end date first
	          // because there's no indication that that is the case once the datepicker is open and it
	          // might confuse the user
	          onFocusChange(_constants.START_DATE);
	        } else if (!disabled || disabled === _constants.START_DATE) {
	          onFocusChange(_constants.END_DATE);
	        }
	      }
	
	      return onEndDateFocus;
	    }()
	  }, {
	    key: 'onStartDateChange',
	    value: function () {
	      function onStartDateChange(startDateString) {
	        var endDate = this.props.endDate;
	        var _props4 = this.props,
	            isOutsideRange = _props4.isOutsideRange,
	            minimumNights = _props4.minimumNights,
	            onDatesChange = _props4.onDatesChange,
	            onFocusChange = _props4.onFocusChange,
	            disabled = _props4.disabled;
	
	
	        var startDate = (0, _toMomentObject2['default'])(startDateString, this.getDisplayFormat());
	        var isEndDateBeforeStartDate = startDate && (0, _isBeforeDay2['default'])(endDate, startDate.clone().add(minimumNights, 'days'));
	        var isStartDateValid = startDate && !isOutsideRange(startDate) && !(disabled === _constants.END_DATE && isEndDateBeforeStartDate);
	
	        if (isStartDateValid) {
	          if (isEndDateBeforeStartDate) {
	            endDate = null;
	          }
	
	          onDatesChange({ startDate: startDate, endDate: endDate });
	          onFocusChange(_constants.END_DATE);
	        } else {
	          onDatesChange({
	            startDate: null,
	            endDate: endDate
	          });
	        }
	      }
	
	      return onStartDateChange;
	    }()
	  }, {
	    key: 'onStartDateFocus',
	    value: function () {
	      function onStartDateFocus() {
	        var _props5 = this.props,
	            disabled = _props5.disabled,
	            onFocusChange = _props5.onFocusChange;
	
	        if (!disabled || disabled === _constants.END_DATE) {
	          onFocusChange(_constants.START_DATE);
	        }
	      }
	
	      return onStartDateFocus;
	    }()
	  }, {
	    key: 'getDisplayFormat',
	    value: function () {
	      function getDisplayFormat() {
	        var displayFormat = this.props.displayFormat;
	
	        return typeof displayFormat === 'string' ? displayFormat : displayFormat();
	      }
	
	      return getDisplayFormat;
	    }()
	  }, {
	    key: 'getDateString',
	    value: function () {
	      function getDateString(date) {
	        var displayFormat = this.getDisplayFormat();
	        if (date && displayFormat) {
	          return date && date.format(displayFormat);
	        }
	        return (0, _toLocalizedDateString2['default'])(date);
	      }
	
	      return getDateString;
	    }()
	  }, {
	    key: 'clearDates',
	    value: function () {
	      function clearDates() {
	        var _props6 = this.props,
	            onDatesChange = _props6.onDatesChange,
	            reopenPickerOnClearDates = _props6.reopenPickerOnClearDates,
	            onFocusChange = _props6.onFocusChange;
	
	        onDatesChange({ startDate: null, endDate: null });
	        if (reopenPickerOnClearDates) {
	          onFocusChange(_constants.START_DATE);
	        }
	      }
	
	      return clearDates;
	    }()
	  }, {
	    key: 'render',
	    value: function () {
	      function render() {
	        var _props7 = this.props,
	            startDate = _props7.startDate,
	            startDateId = _props7.startDateId,
	            startDatePlaceholderText = _props7.startDatePlaceholderText,
	            isStartDateFocused = _props7.isStartDateFocused,
	            endDate = _props7.endDate,
	            endDateId = _props7.endDateId,
	            endDatePlaceholderText = _props7.endDatePlaceholderText,
	            isEndDateFocused = _props7.isEndDateFocused,
	            screenReaderMessage = _props7.screenReaderMessage,
	            showClearDates = _props7.showClearDates,
	            showCaret = _props7.showCaret,
	            showDefaultInputIcon = _props7.showDefaultInputIcon,
	            inputIconPosition = _props7.inputIconPosition,
	            customInputIcon = _props7.customInputIcon,
	            customArrowIcon = _props7.customArrowIcon,
	            customCloseIcon = _props7.customCloseIcon,
	            disabled = _props7.disabled,
	            required = _props7.required,
	            readOnly = _props7.readOnly,
	            openDirection = _props7.openDirection,
	            isFocused = _props7.isFocused,
	            phrases = _props7.phrases,
	            onKeyDownArrowDown = _props7.onKeyDownArrowDown,
	            onKeyDownQuestionMark = _props7.onKeyDownQuestionMark,
	            isRTL = _props7.isRTL,
	            noBorder = _props7.noBorder,
	            block = _props7.block,
	            small = _props7.small,
	            regular = _props7.regular,
	            verticalSpacing = _props7.verticalSpacing;
	
	
	        var startDateString = this.getDateString(startDate);
	        var endDateString = this.getDateString(endDate);
	
	        return _react2['default'].createElement(_DateRangePickerInput2['default'], {
	          startDate: startDateString,
	          startDateId: startDateId,
	          startDatePlaceholderText: startDatePlaceholderText,
	          isStartDateFocused: isStartDateFocused,
	          endDate: endDateString,
	          endDateId: endDateId,
	          endDatePlaceholderText: endDatePlaceholderText,
	          isEndDateFocused: isEndDateFocused,
	          isFocused: isFocused,
	          disabled: disabled,
	          required: required,
	          readOnly: readOnly,
	          openDirection: openDirection,
	          showCaret: showCaret,
	          showDefaultInputIcon: showDefaultInputIcon,
	          inputIconPosition: inputIconPosition,
	          customInputIcon: customInputIcon,
	          customArrowIcon: customArrowIcon,
	          customCloseIcon: customCloseIcon,
	          phrases: phrases,
	          onStartDateChange: this.onStartDateChange,
	          onStartDateFocus: this.onStartDateFocus,
	          onStartDateShiftTab: this.onClearFocus,
	          onEndDateChange: this.onEndDateChange,
	          onEndDateFocus: this.onEndDateFocus,
	          onEndDateTab: this.onClearFocus,
	          showClearDates: showClearDates,
	          onClearDates: this.clearDates,
	          screenReaderMessage: screenReaderMessage,
	          onKeyDownArrowDown: onKeyDownArrowDown,
	          onKeyDownQuestionMark: onKeyDownQuestionMark,
	          isRTL: isRTL,
	          noBorder: noBorder,
	          block: block,
	          small: small,
	          regular: regular,
	          verticalSpacing: verticalSpacing
	        });
	      }
	
	      return render;
	    }()
	  }]);
	
	  return DateRangePickerInputController;
	}(_react2['default'].Component);
	
	exports['default'] = DateRangePickerInputController;
	
	
	DateRangePickerInputController.propTypes = propTypes;
	DateRangePickerInputController.defaultProps = defaultProps;

/***/ },
/* 854 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _object = __webpack_require__(55);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(27);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactMomentProptypes = __webpack_require__(112);
	
	var _reactMomentProptypes2 = _interopRequireDefault(_reactMomentProptypes);
	
	var _airbnbPropTypes = __webpack_require__(42);
	
	var _moment = __webpack_require__(9);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _object3 = __webpack_require__(846);
	
	var _object4 = _interopRequireDefault(_object3);
	
	var _isTouchDevice = __webpack_require__(205);
	
	var _isTouchDevice2 = _interopRequireDefault(_isTouchDevice);
	
	var _defaultPhrases = __webpack_require__(50);
	
	var _getPhrasePropTypes = __webpack_require__(63);
	
	var _getPhrasePropTypes2 = _interopRequireDefault(_getPhrasePropTypes);
	
	var _isInclusivelyAfterDay = __webpack_require__(213);
	
	var _isInclusivelyAfterDay2 = _interopRequireDefault(_isInclusivelyAfterDay);
	
	var _isNextDay = __webpack_require__(872);
	
	var _isNextDay2 = _interopRequireDefault(_isNextDay);
	
	var _isSameDay = __webpack_require__(214);
	
	var _isSameDay2 = _interopRequireDefault(_isSameDay);
	
	var _isAfterDay = __webpack_require__(262);
	
	var _isAfterDay2 = _interopRequireDefault(_isAfterDay);
	
	var _isBeforeDay = __webpack_require__(263);
	
	var _isBeforeDay2 = _interopRequireDefault(_isBeforeDay);
	
	var _getVisibleDays = __webpack_require__(871);
	
	var _getVisibleDays2 = _interopRequireDefault(_getVisibleDays);
	
	var _isDayVisible = __webpack_require__(474);
	
	var _isDayVisible2 = _interopRequireDefault(_isDayVisible);
	
	var _getSelectedDateOffset = __webpack_require__(2982);
	
	var _getSelectedDateOffset2 = _interopRequireDefault(_getSelectedDateOffset);
	
	var _toISODateString = __webpack_require__(340);
	
	var _toISODateString2 = _interopRequireDefault(_toISODateString);
	
	var _toISOMonthString = __webpack_require__(341);
	
	var _toISOMonthString2 = _interopRequireDefault(_toISOMonthString);
	
	var _DisabledShape = __webpack_require__(339);
	
	var _DisabledShape2 = _interopRequireDefault(_DisabledShape);
	
	var _FocusedInputShape = __webpack_require__(861);
	
	var _FocusedInputShape2 = _interopRequireDefault(_FocusedInputShape);
	
	var _ScrollableOrientationShape = __webpack_require__(212);
	
	var _ScrollableOrientationShape2 = _interopRequireDefault(_ScrollableOrientationShape);
	
	var _DayOfWeekShape = __webpack_require__(165);
	
	var _DayOfWeekShape2 = _interopRequireDefault(_DayOfWeekShape);
	
	var _CalendarInfoPositionShape = __webpack_require__(260);
	
	var _CalendarInfoPositionShape2 = _interopRequireDefault(_CalendarInfoPositionShape);
	
	var _constants = __webpack_require__(30);
	
	var _DayPicker = __webpack_require__(472);
	
	var _DayPicker2 = _interopRequireDefault(_DayPicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)({
	  startDate: _reactMomentProptypes2['default'].momentObj,
	  endDate: _reactMomentProptypes2['default'].momentObj,
	  onDatesChange: _propTypes2['default'].func,
	  startDateOffset: _propTypes2['default'].func,
	  endDateOffset: _propTypes2['default'].func,
	
	  focusedInput: _FocusedInputShape2['default'],
	  onFocusChange: _propTypes2['default'].func,
	  onClose: _propTypes2['default'].func,
	
	  keepOpenOnDateSelect: _propTypes2['default'].bool,
	  minimumNights: _propTypes2['default'].number,
	  disabled: _DisabledShape2['default'],
	  isOutsideRange: _propTypes2['default'].func,
	  isDayBlocked: _propTypes2['default'].func,
	  isDayHighlighted: _propTypes2['default'].func,
	
	  // DayPicker props
	  renderMonth: _propTypes2['default'].func,
	  enableOutsideDays: _propTypes2['default'].bool,
	  numberOfMonths: _propTypes2['default'].number,
	  orientation: _ScrollableOrientationShape2['default'],
	  withPortal: _propTypes2['default'].bool,
	  initialVisibleMonth: _propTypes2['default'].func,
	  hideKeyboardShortcutsPanel: _propTypes2['default'].bool,
	  daySize: _airbnbPropTypes.nonNegativeInteger,
	  noBorder: _propTypes2['default'].bool,
	  verticalBorderSpacing: _airbnbPropTypes.nonNegativeInteger,
	
	  navPrev: _propTypes2['default'].node,
	  navNext: _propTypes2['default'].node,
	  noNavButtons: _propTypes2['default'].bool,
	
	  onPrevMonthClick: _propTypes2['default'].func,
	  onNextMonthClick: _propTypes2['default'].func,
	  onOutsideClick: _propTypes2['default'].func,
	  renderCalendarDay: _propTypes2['default'].func,
	  renderDayContents: _propTypes2['default'].func,
	  renderCalendarInfo: _propTypes2['default'].func,
	  calendarInfoPosition: _CalendarInfoPositionShape2['default'],
	  firstDayOfWeek: _DayOfWeekShape2['default'],
	  verticalHeight: _airbnbPropTypes.nonNegativeInteger,
	  transitionDuration: _airbnbPropTypes.nonNegativeInteger,
	
	  // accessibility
	  onBlur: _propTypes2['default'].func,
	  isFocused: _propTypes2['default'].bool,
	  showKeyboardShortcuts: _propTypes2['default'].bool,
	
	  // i18n
	  monthFormat: _propTypes2['default'].string,
	  weekDayFormat: _propTypes2['default'].string,
	  phrases: _propTypes2['default'].shape((0, _getPhrasePropTypes2['default'])(_defaultPhrases.DayPickerPhrases)),
	  dayAriaLabelFormat: _propTypes2['default'].string,
	
	  isRTL: _propTypes2['default'].bool
	});
	
	var defaultProps = {
	  startDate: undefined, // TODO: use null
	  endDate: undefined, // TODO: use null
	  onDatesChange: function () {
	    function onDatesChange() {}
	
	    return onDatesChange;
	  }(),
	
	  startDateOffset: undefined,
	  endDateOffset: undefined,
	
	  focusedInput: null,
	  onFocusChange: function () {
	    function onFocusChange() {}
	
	    return onFocusChange;
	  }(),
	  onClose: function () {
	    function onClose() {}
	
	    return onClose;
	  }(),
	
	
	  keepOpenOnDateSelect: false,
	  minimumNights: 1,
	  disabled: false,
	  isOutsideRange: function () {
	    function isOutsideRange() {}
	
	    return isOutsideRange;
	  }(),
	  isDayBlocked: function () {
	    function isDayBlocked() {}
	
	    return isDayBlocked;
	  }(),
	  isDayHighlighted: function () {
	    function isDayHighlighted() {}
	
	    return isDayHighlighted;
	  }(),
	
	
	  // DayPicker props
	  renderMonth: null,
	  enableOutsideDays: false,
	  numberOfMonths: 1,
	  orientation: _constants.HORIZONTAL_ORIENTATION,
	  withPortal: false,
	  hideKeyboardShortcutsPanel: false,
	  initialVisibleMonth: null,
	  daySize: _constants.DAY_SIZE,
	
	  navPrev: null,
	  navNext: null,
	  noNavButtons: false,
	
	  onPrevMonthClick: function () {
	    function onPrevMonthClick() {}
	
	    return onPrevMonthClick;
	  }(),
	  onNextMonthClick: function () {
	    function onNextMonthClick() {}
	
	    return onNextMonthClick;
	  }(),
	  onOutsideClick: function () {
	    function onOutsideClick() {}
	
	    return onOutsideClick;
	  }(),
	
	
	  renderCalendarDay: undefined,
	  renderDayContents: null,
	  renderCalendarInfo: null,
	  calendarInfoPosition: _constants.INFO_POSITION_BOTTOM,
	  firstDayOfWeek: null,
	  verticalHeight: null,
	  noBorder: false,
	  transitionDuration: undefined,
	  verticalBorderSpacing: undefined,
	
	  // accessibility
	  onBlur: function () {
	    function onBlur() {}
	
	    return onBlur;
	  }(),
	
	  isFocused: false,
	  showKeyboardShortcuts: false,
	
	  // i18n
	  monthFormat: 'MMMM YYYY',
	  weekDayFormat: 'dd',
	  phrases: _defaultPhrases.DayPickerPhrases,
	  dayAriaLabelFormat: undefined,
	
	  isRTL: false
	};
	
	var getChooseAvailableDatePhrase = function getChooseAvailableDatePhrase(phrases, focusedInput) {
	  if (focusedInput === _constants.START_DATE) {
	    return phrases.chooseAvailableStartDate;
	  } else if (focusedInput === _constants.END_DATE) {
	    return phrases.chooseAvailableEndDate;
	  }
	  return phrases.chooseAvailableDate;
	};
	
	var DayPickerRangeController = function (_React$Component) {
	  _inherits(DayPickerRangeController, _React$Component);
	
	  function DayPickerRangeController(props) {
	    _classCallCheck(this, DayPickerRangeController);
	
	    var _this = _possibleConstructorReturn(this, (DayPickerRangeController.__proto__ || Object.getPrototypeOf(DayPickerRangeController)).call(this, props));
	
	    _this.isTouchDevice = (0, _isTouchDevice2['default'])();
	    _this.today = (0, _moment2['default'])();
	    _this.modifiers = {
	      today: function () {
	        function today(day) {
	          return _this.isToday(day);
	        }
	
	        return today;
	      }(),
	      blocked: function () {
	        function blocked(day) {
	          return _this.isBlocked(day);
	        }
	
	        return blocked;
	      }(),
	      'blocked-calendar': function () {
	        function blockedCalendar(day) {
	          return props.isDayBlocked(day);
	        }
	
	        return blockedCalendar;
	      }(),
	      'blocked-out-of-range': function () {
	        function blockedOutOfRange(day) {
	          return props.isOutsideRange(day);
	        }
	
	        return blockedOutOfRange;
	      }(),
	      'highlighted-calendar': function () {
	        function highlightedCalendar(day) {
	          return props.isDayHighlighted(day);
	        }
	
	        return highlightedCalendar;
	      }(),
	      valid: function () {
	        function valid(day) {
	          return !_this.isBlocked(day);
	        }
	
	        return valid;
	      }(),
	      'selected-start': function () {
	        function selectedStart(day) {
	          return _this.isStartDate(day);
	        }
	
	        return selectedStart;
	      }(),
	      'selected-end': function () {
	        function selectedEnd(day) {
	          return _this.isEndDate(day);
	        }
	
	        return selectedEnd;
	      }(),
	      'blocked-minimum-nights': function () {
	        function blockedMinimumNights(day) {
	          return _this.doesNotMeetMinimumNights(day);
	        }
	
	        return blockedMinimumNights;
	      }(),
	      'selected-span': function () {
	        function selectedSpan(day) {
	          return _this.isInSelectedSpan(day);
	        }
	
	        return selectedSpan;
	      }(),
	      'last-in-range': function () {
	        function lastInRange(day) {
	          return _this.isLastInRange(day);
	        }
	
	        return lastInRange;
	      }(),
	      hovered: function () {
	        function hovered(day) {
	          return _this.isHovered(day);
	        }
	
	        return hovered;
	      }(),
	      'hovered-span': function () {
	        function hoveredSpan(day) {
	          return _this.isInHoveredSpan(day);
	        }
	
	        return hoveredSpan;
	      }(),
	      'hovered-offset': function () {
	        function hoveredOffset(day) {
	          return _this.isInHoveredSpan(day);
	        }
	
	        return hoveredOffset;
	      }(),
	      'after-hovered-start': function () {
	        function afterHoveredStart(day) {
	          return _this.isDayAfterHoveredStartDate(day);
	        }
	
	        return afterHoveredStart;
	      }(),
	      'first-day-of-week': function () {
	        function firstDayOfWeek(day) {
	          return _this.isFirstDayOfWeek(day);
	        }
	
	        return firstDayOfWeek;
	      }(),
	      'last-day-of-week': function () {
	        function lastDayOfWeek(day) {
	          return _this.isLastDayOfWeek(day);
	        }
	
	        return lastDayOfWeek;
	      }()
	    };
	
	    var _this$getStateForNewM = _this.getStateForNewMonth(props),
	        currentMonth = _this$getStateForNewM.currentMonth,
	        visibleDays = _this$getStateForNewM.visibleDays;
	
	    // initialize phrases
	    // set the appropriate CalendarDay phrase based on focusedInput
	
	
	    var chooseAvailableDate = getChooseAvailableDatePhrase(props.phrases, props.focusedInput);
	
	    _this.state = {
	      hoverDate: null,
	      currentMonth: currentMonth,
	      phrases: (0, _object2['default'])({}, props.phrases, {
	        chooseAvailableDate: chooseAvailableDate
	      }),
	      visibleDays: visibleDays
	    };
	
	    _this.onDayClick = _this.onDayClick.bind(_this);
	    _this.onDayMouseEnter = _this.onDayMouseEnter.bind(_this);
	    _this.onDayMouseLeave = _this.onDayMouseLeave.bind(_this);
	    _this.onPrevMonthClick = _this.onPrevMonthClick.bind(_this);
	    _this.onNextMonthClick = _this.onNextMonthClick.bind(_this);
	    _this.onMultiplyScrollableMonths = _this.onMultiplyScrollableMonths.bind(_this);
	    _this.getFirstFocusableDay = _this.getFirstFocusableDay.bind(_this);
	    _this.setDayPickerRef = _this.setDayPickerRef.bind(_this);
	    return _this;
	  }
	
	  _createClass(DayPickerRangeController, [{
	    key: 'componentWillReceiveProps',
	    value: function () {
	      function componentWillReceiveProps(nextProps) {
	        var _this2 = this;
	
	        var startDate = nextProps.startDate,
	            endDate = nextProps.endDate,
	            focusedInput = nextProps.focusedInput,
	            minimumNights = nextProps.minimumNights,
	            isOutsideRange = nextProps.isOutsideRange,
	            isDayBlocked = nextProps.isDayBlocked,
	            isDayHighlighted = nextProps.isDayHighlighted,
	            phrases = nextProps.phrases,
	            initialVisibleMonth = nextProps.initialVisibleMonth,
	            numberOfMonths = nextProps.numberOfMonths,
	            enableOutsideDays = nextProps.enableOutsideDays;
	        var _props = this.props,
	            prevStartDate = _props.startDate,
	            prevEndDate = _props.endDate,
	            prevFocusedInput = _props.focusedInput,
	            prevMinimumNights = _props.minimumNights,
	            prevIsOutsideRange = _props.isOutsideRange,
	            prevIsDayBlocked = _props.isDayBlocked,
	            prevIsDayHighlighted = _props.isDayHighlighted,
	            prevPhrases = _props.phrases,
	            prevInitialVisibleMonth = _props.initialVisibleMonth,
	            prevNumberOfMonths = _props.numberOfMonths,
	            prevEnableOutsideDays = _props.enableOutsideDays;
	        var visibleDays = this.state.visibleDays;
	
	
	        var recomputeOutsideRange = false;
	        var recomputeDayBlocked = false;
	        var recomputeDayHighlighted = false;
	
	        if (isOutsideRange !== prevIsOutsideRange) {
	          this.modifiers['blocked-out-of-range'] = function (day) {
	            return isOutsideRange(day);
	          };
	          recomputeOutsideRange = true;
	        }
	
	        if (isDayBlocked !== prevIsDayBlocked) {
	          this.modifiers['blocked-calendar'] = function (day) {
	            return isDayBlocked(day);
	          };
	          recomputeDayBlocked = true;
	        }
	
	        if (isDayHighlighted !== prevIsDayHighlighted) {
	          this.modifiers['highlighted-calendar'] = function (day) {
	            return isDayHighlighted(day);
	          };
	          recomputeDayHighlighted = true;
	        }
	
	        var recomputePropModifiers = recomputeOutsideRange || recomputeDayBlocked || recomputeDayHighlighted;
	
	        var didStartDateChange = startDate !== prevStartDate;
	        var didEndDateChange = endDate !== prevEndDate;
	        var didFocusChange = focusedInput !== prevFocusedInput;
	
	        if (numberOfMonths !== prevNumberOfMonths || enableOutsideDays !== prevEnableOutsideDays || initialVisibleMonth !== prevInitialVisibleMonth && !prevFocusedInput && didFocusChange) {
	          var newMonthState = this.getStateForNewMonth(nextProps);
	          var currentMonth = newMonthState.currentMonth;
	          visibleDays = newMonthState.visibleDays;
	
	          this.setState({
	            currentMonth: currentMonth,
	            visibleDays: visibleDays
	          });
	        }
	
	        var modifiers = {};
	
	        if (didStartDateChange) {
	          modifiers = this.deleteModifier(modifiers, prevStartDate, 'selected-start');
	          modifiers = this.addModifier(modifiers, startDate, 'selected-start');
	
	          if (prevStartDate) {
	            var startSpan = prevStartDate.clone().add(1, 'day');
	            var endSpan = prevStartDate.clone().add(prevMinimumNights + 1, 'days');
	            modifiers = this.deleteModifierFromRange(modifiers, startSpan, endSpan, 'after-hovered-start');
	          }
	        }
	
	        if (didEndDateChange) {
	          modifiers = this.deleteModifier(modifiers, prevEndDate, 'selected-end');
	          modifiers = this.addModifier(modifiers, endDate, 'selected-end');
	        }
	
	        if (didStartDateChange || didEndDateChange) {
	          if (prevStartDate && prevEndDate) {
	            modifiers = this.deleteModifierFromRange(modifiers, prevStartDate, prevEndDate.clone().add(1, 'day'), 'selected-span');
	          }
	
	          if (startDate && endDate) {
	            modifiers = this.deleteModifierFromRange(modifiers, startDate, endDate.clone().add(1, 'day'), 'hovered-span');
	
	            modifiers = this.addModifierToRange(modifiers, startDate.clone().add(1, 'day'), endDate, 'selected-span');
	          }
	        }
	
	        if (!this.isTouchDevice && didStartDateChange && startDate && !endDate) {
	          var _startSpan = startDate.clone().add(1, 'day');
	          var _endSpan = startDate.clone().add(minimumNights + 1, 'days');
	          modifiers = this.addModifierToRange(modifiers, _startSpan, _endSpan, 'after-hovered-start');
	        }
	
	        if (prevMinimumNights > 0) {
	          if (didFocusChange || didStartDateChange || minimumNights !== prevMinimumNights) {
	            var _startSpan2 = prevStartDate || this.today;
	            modifiers = this.deleteModifierFromRange(modifiers, _startSpan2, _startSpan2.clone().add(prevMinimumNights, 'days'), 'blocked-minimum-nights');
	
	            modifiers = this.deleteModifierFromRange(modifiers, _startSpan2, _startSpan2.clone().add(prevMinimumNights, 'days'), 'blocked');
	          }
	        }
	
	        if (minimumNights > 0 && startDate && focusedInput === _constants.END_DATE) {
	          modifiers = this.addModifierToRange(modifiers, startDate, startDate.clone().add(minimumNights, 'days'), 'blocked-minimum-nights');
	        }
	
	        if (didFocusChange || recomputePropModifiers) {
	          (0, _object4['default'])(visibleDays).forEach(function (days) {
	            Object.keys(days).forEach(function (day) {
	              var momentObj = (0, _moment2['default'])(day);
	
	              if (_this2.isBlocked(momentObj)) {
	                modifiers = _this2.addModifier(modifiers, momentObj, 'blocked');
	              } else {
	                modifiers = _this2.deleteModifier(modifiers, momentObj, 'blocked');
	              }
	
	              if (didFocusChange || recomputeOutsideRange) {
	                if (isOutsideRange(momentObj)) {
	                  modifiers = _this2.addModifier(modifiers, momentObj, 'blocked-out-of-range');
	                } else {
	                  modifiers = _this2.deleteModifier(modifiers, momentObj, 'blocked-out-of-range');
	                }
	              }
	
	              if (didFocusChange || recomputeDayBlocked) {
	                if (isDayBlocked(momentObj)) {
	                  modifiers = _this2.addModifier(modifiers, momentObj, 'blocked-calendar');
	                } else {
	                  modifiers = _this2.deleteModifier(modifiers, momentObj, 'blocked-calendar');
	                }
	              }
	
	              if (didFocusChange || recomputeDayHighlighted) {
	                if (isDayHighlighted(momentObj)) {
	                  modifiers = _this2.addModifier(modifiers, momentObj, 'highlighted-calendar');
	                } else {
	                  modifiers = _this2.deleteModifier(modifiers, momentObj, 'highlighted-calendar');
	                }
	              }
	            });
	          });
	        }
	
	        var today = (0, _moment2['default'])();
	        if (!(0, _isSameDay2['default'])(this.today, today)) {
	          modifiers = this.deleteModifier(modifiers, this.today, 'today');
	          modifiers = this.addModifier(modifiers, today, 'today');
	          this.today = today;
	        }
	
	        if (Object.keys(modifiers).length > 0) {
	          this.setState({
	            visibleDays: (0, _object2['default'])({}, visibleDays, modifiers)
	          });
	        }
	
	        if (didFocusChange || phrases !== prevPhrases) {
	          // set the appropriate CalendarDay phrase based on focusedInput
	          var chooseAvailableDate = getChooseAvailableDatePhrase(phrases, focusedInput);
	
	          this.setState({
	            phrases: (0, _object2['default'])({}, phrases, {
	              chooseAvailableDate: chooseAvailableDate
	            })
	          });
	        }
	      }
	
	      return componentWillReceiveProps;
	    }()
	  }, {
	    key: 'onDayClick',
	    value: function () {
	      function onDayClick(day, e) {
	        var _props2 = this.props,
	            keepOpenOnDateSelect = _props2.keepOpenOnDateSelect,
	            minimumNights = _props2.minimumNights,
	            onBlur = _props2.onBlur,
	            focusedInput = _props2.focusedInput,
	            onFocusChange = _props2.onFocusChange,
	            onClose = _props2.onClose,
	            onDatesChange = _props2.onDatesChange,
	            startDateOffset = _props2.startDateOffset,
	            endDateOffset = _props2.endDateOffset,
	            disabled = _props2.disabled;
	
	
	        if (e) e.preventDefault();
	        if (this.isBlocked(day)) return;
	
	        var _props3 = this.props,
	            startDate = _props3.startDate,
	            endDate = _props3.endDate;
	
	
	        if (startDateOffset || endDateOffset) {
	          startDate = (0, _getSelectedDateOffset2['default'])(startDateOffset, day);
	          endDate = (0, _getSelectedDateOffset2['default'])(endDateOffset, day);
	
	          if (!keepOpenOnDateSelect) {
	            onFocusChange(null);
	            onClose({ startDate: startDate, endDate: endDate });
	          }
	        } else if (focusedInput === _constants.START_DATE) {
	          var lastAllowedStartDate = endDate && endDate.clone().subtract(minimumNights, 'days');
	          var isStartDateAfterEndDate = (0, _isBeforeDay2['default'])(lastAllowedStartDate, day) || (0, _isAfterDay2['default'])(startDate, endDate);
	          var isEndDateDisabled = disabled === _constants.END_DATE;
	
	          if (!isEndDateDisabled || !isStartDateAfterEndDate) {
	            startDate = day;
	            if (isStartDateAfterEndDate) {
	              endDate = null;
	            }
	          }
	
	          if (isEndDateDisabled && !isStartDateAfterEndDate) {
	            onFocusChange(null);
	            onClose({ startDate: startDate, endDate: endDate });
	          } else if (!isEndDateDisabled) {
	            onFocusChange(_constants.END_DATE);
	          }
	        } else if (focusedInput === _constants.END_DATE) {
	          var firstAllowedEndDate = startDate && startDate.clone().add(minimumNights, 'days');
	
	          if (!startDate) {
	            endDate = day;
	            onFocusChange(_constants.START_DATE);
	          } else if ((0, _isInclusivelyAfterDay2['default'])(day, firstAllowedEndDate)) {
	            endDate = day;
	            if (!keepOpenOnDateSelect) {
	              onFocusChange(null);
	              onClose({ startDate: startDate, endDate: endDate });
	            }
	          } else if (disabled !== _constants.START_DATE) {
	            startDate = day;
	            endDate = null;
	          }
	        }
	
	        onDatesChange({ startDate: startDate, endDate: endDate });
	        onBlur();
	      }
	
	      return onDayClick;
	    }()
	  }, {
	    key: 'onDayMouseEnter',
	    value: function () {
	      function onDayMouseEnter(day) {
	        if (this.isTouchDevice) return;
	        var _props4 = this.props,
	            startDate = _props4.startDate,
	            endDate = _props4.endDate,
	            focusedInput = _props4.focusedInput,
	            minimumNights = _props4.minimumNights,
	            startDateOffset = _props4.startDateOffset,
	            endDateOffset = _props4.endDateOffset;
	        var _state = this.state,
	            hoverDate = _state.hoverDate,
	            visibleDays = _state.visibleDays;
	
	        var dateOffset = null;
	
	        if (focusedInput) {
	          var hasOffset = startDateOffset || endDateOffset;
	          var modifiers = {};
	
	          if (hasOffset) {
	            var start = (0, _getSelectedDateOffset2['default'])(startDateOffset, day);
	            var end = (0, _getSelectedDateOffset2['default'])(endDateOffset, day, function (rangeDay) {
	              return rangeDay.add(1, 'day');
	            });
	
	            dateOffset = {
	              start: start,
	              end: end
	            };
	
	            if (this.state.dateOffset && this.state.dateOffset.start && this.state.dateOffset.end) {
	              modifiers = this.deleteModifierFromRange(modifiers, this.state.dateOffset.start, this.state.dateOffset.end, 'hovered-offset');
	            }
	            modifiers = this.addModifierToRange(modifiers, start, end, 'hovered-offset');
	          }
	
	          if (!hasOffset) {
	            modifiers = this.deleteModifier(modifiers, hoverDate, 'hovered');
	            modifiers = this.addModifier(modifiers, day, 'hovered');
	
	            if (startDate && !endDate && focusedInput === _constants.END_DATE) {
	              if ((0, _isAfterDay2['default'])(hoverDate, startDate)) {
	                var endSpan = hoverDate.clone().add(1, 'day');
	                modifiers = this.deleteModifierFromRange(modifiers, startDate, endSpan, 'hovered-span');
	              }
	
	              if (!this.isBlocked(day) && (0, _isAfterDay2['default'])(day, startDate)) {
	                var _endSpan2 = day.clone().add(1, 'day');
	                modifiers = this.addModifierToRange(modifiers, startDate, _endSpan2, 'hovered-span');
	              }
	            }
	
	            if (!startDate && endDate && focusedInput === _constants.START_DATE) {
	              if ((0, _isBeforeDay2['default'])(hoverDate, endDate)) {
	                modifiers = this.deleteModifierFromRange(modifiers, hoverDate, endDate, 'hovered-span');
	              }
	
	              if (!this.isBlocked(day) && (0, _isBeforeDay2['default'])(day, endDate)) {
	                modifiers = this.addModifierToRange(modifiers, day, endDate, 'hovered-span');
	              }
	            }
	
	            if (startDate) {
	              var startSpan = startDate.clone().add(1, 'day');
	              var _endSpan3 = startDate.clone().add(minimumNights + 1, 'days');
	              modifiers = this.deleteModifierFromRange(modifiers, startSpan, _endSpan3, 'after-hovered-start');
	
	              if ((0, _isSameDay2['default'])(day, startDate)) {
	                var newStartSpan = startDate.clone().add(1, 'day');
	                var newEndSpan = startDate.clone().add(minimumNights + 1, 'days');
	                modifiers = this.addModifierToRange(modifiers, newStartSpan, newEndSpan, 'after-hovered-start');
	              }
	            }
	          }
	
	          this.setState({
	            hoverDate: day,
	            dateOffset: dateOffset,
	            visibleDays: (0, _object2['default'])({}, visibleDays, modifiers)
	          });
	        }
	      }
	
	      return onDayMouseEnter;
	    }()
	  }, {
	    key: 'onDayMouseLeave',
	    value: function () {
	      function onDayMouseLeave(day) {
	        var _props5 = this.props,
	            startDate = _props5.startDate,
	            endDate = _props5.endDate,
	            minimumNights = _props5.minimumNights;
	        var _state2 = this.state,
	            hoverDate = _state2.hoverDate,
	            visibleDays = _state2.visibleDays,
	            dateOffset = _state2.dateOffset;
	
	        if (this.isTouchDevice || !hoverDate) return;
	
	        var modifiers = {};
	        modifiers = this.deleteModifier(modifiers, hoverDate, 'hovered');
	
	        if (dateOffset) {
	          modifiers = this.deleteModifierFromRange(modifiers, this.state.dateOffset.start, this.state.dateOffset.end, 'hovered-offset');
	        }
	
	        if (startDate && !endDate && (0, _isAfterDay2['default'])(hoverDate, startDate)) {
	          var endSpan = hoverDate.clone().add(1, 'day');
	          modifiers = this.deleteModifierFromRange(modifiers, startDate, endSpan, 'hovered-span');
	        }
	
	        if (!startDate && endDate && (0, _isAfterDay2['default'])(endDate, hoverDate)) {
	          modifiers = this.deleteModifierFromRange(modifiers, hoverDate, endDate, 'hovered-span');
	        }
	
	        if (startDate && (0, _isSameDay2['default'])(day, startDate)) {
	          var startSpan = startDate.clone().add(1, 'day');
	          var _endSpan4 = startDate.clone().add(minimumNights + 1, 'days');
	          modifiers = this.deleteModifierFromRange(modifiers, startSpan, _endSpan4, 'after-hovered-start');
	        }
	
	        this.setState({
	          hoverDate: null,
	          visibleDays: (0, _object2['default'])({}, visibleDays, modifiers)
	        });
	      }
	
	      return onDayMouseLeave;
	    }()
	  }, {
	    key: 'onPrevMonthClick',
	    value: function () {
	      function onPrevMonthClick() {
	        var _props6 = this.props,
	            onPrevMonthClick = _props6.onPrevMonthClick,
	            numberOfMonths = _props6.numberOfMonths,
	            enableOutsideDays = _props6.enableOutsideDays;
	        var _state3 = this.state,
	            currentMonth = _state3.currentMonth,
	            visibleDays = _state3.visibleDays;
	
	
	        var newVisibleDays = {};
	        Object.keys(visibleDays).sort().slice(0, numberOfMonths + 1).forEach(function (month) {
	          newVisibleDays[month] = visibleDays[month];
	        });
	
	        var prevMonth = currentMonth.clone().subtract(2, 'months');
	        var prevMonthVisibleDays = (0, _getVisibleDays2['default'])(prevMonth, 1, enableOutsideDays, true);
	
	        var newCurrentMonth = currentMonth.clone().subtract(1, 'month');
	        this.setState({
	          currentMonth: newCurrentMonth,
	          visibleDays: (0, _object2['default'])({}, newVisibleDays, this.getModifiers(prevMonthVisibleDays))
	        }, function () {
	          onPrevMonthClick(newCurrentMonth.clone());
	        });
	      }
	
	      return onPrevMonthClick;
	    }()
	  }, {
	    key: 'onNextMonthClick',
	    value: function () {
	      function onNextMonthClick() {
	        var _props7 = this.props,
	            onNextMonthClick = _props7.onNextMonthClick,
	            numberOfMonths = _props7.numberOfMonths,
	            enableOutsideDays = _props7.enableOutsideDays;
	        var _state4 = this.state,
	            currentMonth = _state4.currentMonth,
	            visibleDays = _state4.visibleDays;
	
	
	        var newVisibleDays = {};
	        Object.keys(visibleDays).sort().slice(1).forEach(function (month) {
	          newVisibleDays[month] = visibleDays[month];
	        });
	
	        var nextMonth = currentMonth.clone().add(numberOfMonths + 1, 'month');
	        var nextMonthVisibleDays = (0, _getVisibleDays2['default'])(nextMonth, 1, enableOutsideDays, true);
	
	        var newCurrentMonth = currentMonth.clone().add(1, 'month');
	        this.setState({
	          currentMonth: newCurrentMonth,
	          visibleDays: (0, _object2['default'])({}, newVisibleDays, this.getModifiers(nextMonthVisibleDays))
	        }, function () {
	          onNextMonthClick(newCurrentMonth.clone());
	        });
	      }
	
	      return onNextMonthClick;
	    }()
	  }, {
	    key: 'onMultiplyScrollableMonths',
	    value: function () {
	      function onMultiplyScrollableMonths() {
	        var _props8 = this.props,
	            numberOfMonths = _props8.numberOfMonths,
	            enableOutsideDays = _props8.enableOutsideDays;
	        var _state5 = this.state,
	            currentMonth = _state5.currentMonth,
	            visibleDays = _state5.visibleDays;
	
	
	        var numberOfVisibleMonths = Object.keys(visibleDays).length;
	        var nextMonth = currentMonth.clone().add(numberOfVisibleMonths, 'month');
	        var newVisibleDays = (0, _getVisibleDays2['default'])(nextMonth, numberOfMonths, enableOutsideDays, true);
	
	        this.setState({
	          visibleDays: (0, _object2['default'])({}, visibleDays, this.getModifiers(newVisibleDays))
	        });
	      }
	
	      return onMultiplyScrollableMonths;
	    }()
	  }, {
	    key: 'getFirstFocusableDay',
	    value: function () {
	      function getFirstFocusableDay(newMonth) {
	        var _this3 = this;
	
	        var _props9 = this.props,
	            startDate = _props9.startDate,
	            endDate = _props9.endDate,
	            focusedInput = _props9.focusedInput,
	            minimumNights = _props9.minimumNights,
	            numberOfMonths = _props9.numberOfMonths;
	
	
	        var focusedDate = newMonth.clone().startOf('month');
	        if (focusedInput === _constants.START_DATE && startDate) {
	          focusedDate = startDate.clone();
	        } else if (focusedInput === _constants.END_DATE && !endDate && startDate) {
	          focusedDate = startDate.clone().add(minimumNights, 'days');
	        } else if (focusedInput === _constants.END_DATE && endDate) {
	          focusedDate = endDate.clone();
	        }
	
	        if (this.isBlocked(focusedDate)) {
	          var days = [];
	          var lastVisibleDay = newMonth.clone().add(numberOfMonths - 1, 'months').endOf('month');
	          var currentDay = focusedDate.clone();
	          while (!(0, _isAfterDay2['default'])(currentDay, lastVisibleDay)) {
	            currentDay = currentDay.clone().add(1, 'day');
	            days.push(currentDay);
	          }
	
	          var viableDays = days.filter(function (day) {
	            return !_this3.isBlocked(day);
	          });
	
	          if (viableDays.length > 0) {
	            var _viableDays = _slicedToArray(viableDays, 1);
	
	            focusedDate = _viableDays[0];
	          }
	        }
	
	        return focusedDate;
	      }
	
	      return getFirstFocusableDay;
	    }()
	  }, {
	    key: 'getModifiers',
	    value: function () {
	      function getModifiers(visibleDays) {
	        var _this4 = this;
	
	        var modifiers = {};
	        Object.keys(visibleDays).forEach(function (month) {
	          modifiers[month] = {};
	          visibleDays[month].forEach(function (day) {
	            modifiers[month][(0, _toISODateString2['default'])(day)] = _this4.getModifiersForDay(day);
	          });
	        });
	
	        return modifiers;
	      }
	
	      return getModifiers;
	    }()
	  }, {
	    key: 'getModifiersForDay',
	    value: function () {
	      function getModifiersForDay(day) {
	        var _this5 = this;
	
	        return new Set(Object.keys(this.modifiers).filter(function (modifier) {
	          return _this5.modifiers[modifier](day);
	        }));
	      }
	
	      return getModifiersForDay;
	    }()
	  }, {
	    key: 'getStateForNewMonth',
	    value: function () {
	      function getStateForNewMonth(nextProps) {
	        var _this6 = this;
	
	        var initialVisibleMonth = nextProps.initialVisibleMonth,
	            numberOfMonths = nextProps.numberOfMonths,
	            enableOutsideDays = nextProps.enableOutsideDays,
	            orientation = nextProps.orientation,
	            startDate = nextProps.startDate;
	
	        var initialVisibleMonthThunk = initialVisibleMonth || (startDate ? function () {
	          return startDate;
	        } : function () {
	          return _this6.today;
	        });
	        var currentMonth = initialVisibleMonthThunk();
	        var withoutTransitionMonths = orientation === _constants.VERTICAL_SCROLLABLE;
	        var visibleDays = this.getModifiers((0, _getVisibleDays2['default'])(currentMonth, numberOfMonths, enableOutsideDays, withoutTransitionMonths));
	        return { currentMonth: currentMonth, visibleDays: visibleDays };
	      }
	
	      return getStateForNewMonth;
	    }()
	  }, {
	    key: 'setDayPickerRef',
	    value: function () {
	      function setDayPickerRef(ref) {
	        this.dayPicker = ref;
	      }
	
	      return setDayPickerRef;
	    }()
	  }, {
	    key: 'addModifier',
	    value: function () {
	      function addModifier(updatedDays, day, modifier) {
	        var _props10 = this.props,
	            numberOfVisibleMonths = _props10.numberOfMonths,
	            enableOutsideDays = _props10.enableOutsideDays,
	            orientation = _props10.orientation;
	        var _state6 = this.state,
	            firstVisibleMonth = _state6.currentMonth,
	            visibleDays = _state6.visibleDays;
	
	
	        var currentMonth = firstVisibleMonth;
	        var numberOfMonths = numberOfVisibleMonths;
	        if (orientation !== _constants.VERTICAL_SCROLLABLE) {
	          currentMonth = currentMonth.clone().subtract(1, 'month');
	          numberOfMonths += 2;
	        }
	        if (!day || !(0, _isDayVisible2['default'])(day, currentMonth, numberOfMonths, enableOutsideDays)) {
	          return updatedDays;
	        }
	
	        var iso = (0, _toISODateString2['default'])(day);
	
	        var updatedDaysAfterAddition = (0, _object2['default'])({}, updatedDays);
	        if (enableOutsideDays) {
	          var monthsToUpdate = Object.keys(visibleDays).filter(function (monthKey) {
	            return Object.keys(visibleDays[monthKey]).indexOf(iso) > -1;
	          });
	
	          updatedDaysAfterAddition = monthsToUpdate.reduce(function (days, monthIso) {
	            var month = updatedDays[monthIso] || visibleDays[monthIso];
	            var modifiers = new Set(month[iso]);
	            modifiers.add(modifier);
	            return (0, _object2['default'])({}, days, _defineProperty({}, monthIso, (0, _object2['default'])({}, month, _defineProperty({}, iso, modifiers))));
	          }, updatedDaysAfterAddition);
	        } else {
	          var monthIso = (0, _toISOMonthString2['default'])(day);
	          var month = updatedDays[monthIso] || visibleDays[monthIso];
	
	          var modifiers = new Set(month[iso]);
	          modifiers.add(modifier);
	          updatedDaysAfterAddition = (0, _object2['default'])({}, updatedDaysAfterAddition, _defineProperty({}, monthIso, (0, _object2['default'])({}, month, _defineProperty({}, iso, modifiers))));
	        }
	
	        return updatedDaysAfterAddition;
	      }
	
	      return addModifier;
	    }()
	  }, {
	    key: 'addModifierToRange',
	    value: function () {
	      function addModifierToRange(updatedDays, start, end, modifier) {
	        var days = updatedDays;
	
	        var spanStart = start.clone();
	        while ((0, _isBeforeDay2['default'])(spanStart, end)) {
	          days = this.addModifier(days, spanStart, modifier);
	          spanStart = spanStart.clone().add(1, 'day');
	        }
	
	        return days;
	      }
	
	      return addModifierToRange;
	    }()
	  }, {
	    key: 'deleteModifier',
	    value: function () {
	      function deleteModifier(updatedDays, day, modifier) {
	        var _props11 = this.props,
	            numberOfVisibleMonths = _props11.numberOfMonths,
	            enableOutsideDays = _props11.enableOutsideDays,
	            orientation = _props11.orientation;
	        var _state7 = this.state,
	            firstVisibleMonth = _state7.currentMonth,
	            visibleDays = _state7.visibleDays;
	
	        var currentMonth = firstVisibleMonth;
	        var numberOfMonths = numberOfVisibleMonths;
	        if (orientation !== _constants.VERTICAL_SCROLLABLE) {
	          currentMonth = currentMonth.clone().subtract(1, 'month');
	          numberOfMonths += 2;
	        }
	        if (!day || !(0, _isDayVisible2['default'])(day, currentMonth, numberOfMonths, enableOutsideDays)) {
	          return updatedDays;
	        }
	
	        var iso = (0, _toISODateString2['default'])(day);
	
	        var updatedDaysAfterDeletion = (0, _object2['default'])({}, updatedDays);
	        if (enableOutsideDays) {
	          var monthsToUpdate = Object.keys(visibleDays).filter(function (monthKey) {
	            return Object.keys(visibleDays[monthKey]).indexOf(iso) > -1;
	          });
	
	          updatedDaysAfterDeletion = monthsToUpdate.reduce(function (days, monthIso) {
	            var month = updatedDays[monthIso] || visibleDays[monthIso];
	            var modifiers = new Set(month[iso]);
	            modifiers['delete'](modifier);
	            return (0, _object2['default'])({}, days, _defineProperty({}, monthIso, (0, _object2['default'])({}, month, _defineProperty({}, iso, modifiers))));
	          }, updatedDaysAfterDeletion);
	        } else {
	          var monthIso = (0, _toISOMonthString2['default'])(day);
	          var month = updatedDays[monthIso] || visibleDays[monthIso];
	
	          var modifiers = new Set(month[iso]);
	          modifiers['delete'](modifier);
	          updatedDaysAfterDeletion = (0, _object2['default'])({}, updatedDaysAfterDeletion, _defineProperty({}, monthIso, (0, _object2['default'])({}, month, _defineProperty({}, iso, modifiers))));
	        }
	
	        return updatedDaysAfterDeletion;
	      }
	
	      return deleteModifier;
	    }()
	  }, {
	    key: 'deleteModifierFromRange',
	    value: function () {
	      function deleteModifierFromRange(updatedDays, start, end, modifier) {
	        var days = updatedDays;
	
	        var spanStart = start.clone();
	        while ((0, _isBeforeDay2['default'])(spanStart, end)) {
	          days = this.deleteModifier(days, spanStart, modifier);
	          spanStart = spanStart.clone().add(1, 'day');
	        }
	
	        return days;
	      }
	
	      return deleteModifierFromRange;
	    }()
	  }, {
	    key: 'doesNotMeetMinimumNights',
	    value: function () {
	      function doesNotMeetMinimumNights(day) {
	        var _props12 = this.props,
	            startDate = _props12.startDate,
	            isOutsideRange = _props12.isOutsideRange,
	            focusedInput = _props12.focusedInput,
	            minimumNights = _props12.minimumNights;
	
	        if (focusedInput !== _constants.END_DATE) return false;
	
	        if (startDate) {
	          var dayDiff = day.diff(startDate.clone().startOf('day').hour(12), 'days');
	          return dayDiff < minimumNights && dayDiff >= 0;
	        }
	        return isOutsideRange((0, _moment2['default'])(day).subtract(minimumNights, 'days'));
	      }
	
	      return doesNotMeetMinimumNights;
	    }()
	  }, {
	    key: 'isDayAfterHoveredStartDate',
	    value: function () {
	      function isDayAfterHoveredStartDate(day) {
	        var _props13 = this.props,
	            startDate = _props13.startDate,
	            endDate = _props13.endDate,
	            minimumNights = _props13.minimumNights;
	
	        var _ref = this.state || {},
	            hoverDate = _ref.hoverDate;
	
	        return !!startDate && !endDate && !this.isBlocked(day) && (0, _isNextDay2['default'])(hoverDate, day) && minimumNights > 0 && (0, _isSameDay2['default'])(hoverDate, startDate);
	      }
	
	      return isDayAfterHoveredStartDate;
	    }()
	  }, {
	    key: 'isEndDate',
	    value: function () {
	      function isEndDate(day) {
	        return (0, _isSameDay2['default'])(day, this.props.endDate);
	      }
	
	      return isEndDate;
	    }()
	  }, {
	    key: 'isHovered',
	    value: function () {
	      function isHovered(day) {
	        var _ref2 = this.state || {},
	            hoverDate = _ref2.hoverDate;
	
	        var focusedInput = this.props.focusedInput;
	
	        return !!focusedInput && (0, _isSameDay2['default'])(day, hoverDate);
	      }
	
	      return isHovered;
	    }()
	  }, {
	    key: 'isInHoveredSpan',
	    value: function () {
	      function isInHoveredSpan(day) {
	        var _props14 = this.props,
	            startDate = _props14.startDate,
	            endDate = _props14.endDate;
	
	        var _ref3 = this.state || {},
	            hoverDate = _ref3.hoverDate;
	
	        var isForwardRange = !!startDate && !endDate && (day.isBetween(startDate, hoverDate) || (0, _isSameDay2['default'])(hoverDate, day));
	        var isBackwardRange = !!endDate && !startDate && (day.isBetween(hoverDate, endDate) || (0, _isSameDay2['default'])(hoverDate, day));
	
	        var isValidDayHovered = hoverDate && !this.isBlocked(hoverDate);
	
	        return (isForwardRange || isBackwardRange) && isValidDayHovered;
	      }
	
	      return isInHoveredSpan;
	    }()
	  }, {
	    key: 'isInSelectedSpan',
	    value: function () {
	      function isInSelectedSpan(day) {
	        var _props15 = this.props,
	            startDate = _props15.startDate,
	            endDate = _props15.endDate;
	
	        return day.isBetween(startDate, endDate);
	      }
	
	      return isInSelectedSpan;
	    }()
	  }, {
	    key: 'isLastInRange',
	    value: function () {
	      function isLastInRange(day) {
	        return this.isInSelectedSpan(day) && (0, _isNextDay2['default'])(day, this.props.endDate);
	      }
	
	      return isLastInRange;
	    }()
	  }, {
	    key: 'isStartDate',
	    value: function () {
	      function isStartDate(day) {
	        return (0, _isSameDay2['default'])(day, this.props.startDate);
	      }
	
	      return isStartDate;
	    }()
	  }, {
	    key: 'isBlocked',
	    value: function () {
	      function isBlocked(day) {
	        var _props16 = this.props,
	            isDayBlocked = _props16.isDayBlocked,
	            isOutsideRange = _props16.isOutsideRange;
	
	        return isDayBlocked(day) || isOutsideRange(day) || this.doesNotMeetMinimumNights(day);
	      }
	
	      return isBlocked;
	    }()
	  }, {
	    key: 'isToday',
	    value: function () {
	      function isToday(day) {
	        return (0, _isSameDay2['default'])(day, this.today);
	      }
	
	      return isToday;
	    }()
	  }, {
	    key: 'isFirstDayOfWeek',
	    value: function () {
	      function isFirstDayOfWeek(day) {
	        var firstDayOfWeek = this.props.firstDayOfWeek;
	
	        return day.day() === (firstDayOfWeek || _moment2['default'].localeData().firstDayOfWeek());
	      }
	
	      return isFirstDayOfWeek;
	    }()
	  }, {
	    key: 'isLastDayOfWeek',
	    value: function () {
	      function isLastDayOfWeek(day) {
	        var firstDayOfWeek = this.props.firstDayOfWeek;
	
	        return day.day() === ((firstDayOfWeek || _moment2['default'].localeData().firstDayOfWeek()) + 6) % 7;
	      }
	
	      return isLastDayOfWeek;
	    }()
	  }, {
	    key: 'render',
	    value: function () {
	      function render() {
	        var _props17 = this.props,
	            numberOfMonths = _props17.numberOfMonths,
	            orientation = _props17.orientation,
	            monthFormat = _props17.monthFormat,
	            renderMonth = _props17.renderMonth,
	            navPrev = _props17.navPrev,
	            navNext = _props17.navNext,
	            noNavButtons = _props17.noNavButtons,
	            onOutsideClick = _props17.onOutsideClick,
	            withPortal = _props17.withPortal,
	            enableOutsideDays = _props17.enableOutsideDays,
	            firstDayOfWeek = _props17.firstDayOfWeek,
	            hideKeyboardShortcutsPanel = _props17.hideKeyboardShortcutsPanel,
	            daySize = _props17.daySize,
	            focusedInput = _props17.focusedInput,
	            renderCalendarDay = _props17.renderCalendarDay,
	            renderDayContents = _props17.renderDayContents,
	            renderCalendarInfo = _props17.renderCalendarInfo,
	            calendarInfoPosition = _props17.calendarInfoPosition,
	            onBlur = _props17.onBlur,
	            isFocused = _props17.isFocused,
	            showKeyboardShortcuts = _props17.showKeyboardShortcuts,
	            isRTL = _props17.isRTL,
	            weekDayFormat = _props17.weekDayFormat,
	            dayAriaLabelFormat = _props17.dayAriaLabelFormat,
	            verticalHeight = _props17.verticalHeight,
	            noBorder = _props17.noBorder,
	            transitionDuration = _props17.transitionDuration,
	            verticalBorderSpacing = _props17.verticalBorderSpacing;
	        var _state8 = this.state,
	            currentMonth = _state8.currentMonth,
	            phrases = _state8.phrases,
	            visibleDays = _state8.visibleDays;
	
	
	        return _react2['default'].createElement(_DayPicker2['default'], {
	          ref: this.setDayPickerRef,
	          orientation: orientation,
	          enableOutsideDays: enableOutsideDays,
	          modifiers: visibleDays,
	          numberOfMonths: numberOfMonths,
	          onDayClick: this.onDayClick,
	          onDayMouseEnter: this.onDayMouseEnter,
	          onDayMouseLeave: this.onDayMouseLeave,
	          onPrevMonthClick: this.onPrevMonthClick,
	          onNextMonthClick: this.onNextMonthClick,
	          onMultiplyScrollableMonths: this.onMultiplyScrollableMonths,
	          monthFormat: monthFormat,
	          renderMonth: renderMonth,
	          withPortal: withPortal,
	          hidden: !focusedInput,
	          initialVisibleMonth: function () {
	            function initialVisibleMonth() {
	              return currentMonth;
	            }
	
	            return initialVisibleMonth;
	          }(),
	          daySize: daySize,
	          onOutsideClick: onOutsideClick,
	          navPrev: navPrev,
	          navNext: navNext,
	          noNavButtons: noNavButtons,
	          renderCalendarDay: renderCalendarDay,
	          renderDayContents: renderDayContents,
	          renderCalendarInfo: renderCalendarInfo,
	          calendarInfoPosition: calendarInfoPosition,
	          firstDayOfWeek: firstDayOfWeek,
	          hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
	          isFocused: isFocused,
	          getFirstFocusableDay: this.getFirstFocusableDay,
	          onBlur: onBlur,
	          showKeyboardShortcuts: showKeyboardShortcuts,
	          phrases: phrases,
	          isRTL: isRTL,
	          weekDayFormat: weekDayFormat,
	          dayAriaLabelFormat: dayAriaLabelFormat,
	          verticalHeight: verticalHeight,
	          verticalBorderSpacing: verticalBorderSpacing,
	          noBorder: noBorder,
	          transitionDuration: transitionDuration
	        });
	      }
	
	      return render;
	    }()
	  }]);
	
	  return DayPickerRangeController;
	}(_react2['default'].Component);
	
	exports['default'] = DayPickerRangeController;
	
	
	DayPickerRangeController.propTypes = propTypes;
	DayPickerRangeController.defaultProps = defaultProps;

/***/ },
/* 855 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _object = __webpack_require__(55);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(27);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactMomentProptypes = __webpack_require__(112);
	
	var _reactMomentProptypes2 = _interopRequireDefault(_reactMomentProptypes);
	
	var _airbnbPropTypes = __webpack_require__(42);
	
	var _moment = __webpack_require__(9);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _object3 = __webpack_require__(846);
	
	var _object4 = _interopRequireDefault(_object3);
	
	var _isTouchDevice = __webpack_require__(205);
	
	var _isTouchDevice2 = _interopRequireDefault(_isTouchDevice);
	
	var _defaultPhrases = __webpack_require__(50);
	
	var _getPhrasePropTypes = __webpack_require__(63);
	
	var _getPhrasePropTypes2 = _interopRequireDefault(_getPhrasePropTypes);
	
	var _isSameDay = __webpack_require__(214);
	
	var _isSameDay2 = _interopRequireDefault(_isSameDay);
	
	var _isAfterDay = __webpack_require__(262);
	
	var _isAfterDay2 = _interopRequireDefault(_isAfterDay);
	
	var _getVisibleDays = __webpack_require__(871);
	
	var _getVisibleDays2 = _interopRequireDefault(_getVisibleDays);
	
	var _isDayVisible = __webpack_require__(474);
	
	var _isDayVisible2 = _interopRequireDefault(_isDayVisible);
	
	var _toISODateString = __webpack_require__(340);
	
	var _toISODateString2 = _interopRequireDefault(_toISODateString);
	
	var _toISOMonthString = __webpack_require__(341);
	
	var _toISOMonthString2 = _interopRequireDefault(_toISOMonthString);
	
	var _ScrollableOrientationShape = __webpack_require__(212);
	
	var _ScrollableOrientationShape2 = _interopRequireDefault(_ScrollableOrientationShape);
	
	var _DayOfWeekShape = __webpack_require__(165);
	
	var _DayOfWeekShape2 = _interopRequireDefault(_DayOfWeekShape);
	
	var _CalendarInfoPositionShape = __webpack_require__(260);
	
	var _CalendarInfoPositionShape2 = _interopRequireDefault(_CalendarInfoPositionShape);
	
	var _constants = __webpack_require__(30);
	
	var _DayPicker = __webpack_require__(472);
	
	var _DayPicker2 = _interopRequireDefault(_DayPicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)({
	  date: _reactMomentProptypes2['default'].momentObj,
	  onDateChange: _propTypes2['default'].func,
	
	  focused: _propTypes2['default'].bool,
	  onFocusChange: _propTypes2['default'].func,
	  onClose: _propTypes2['default'].func,
	
	  keepOpenOnDateSelect: _propTypes2['default'].bool,
	  isOutsideRange: _propTypes2['default'].func,
	  isDayBlocked: _propTypes2['default'].func,
	  isDayHighlighted: _propTypes2['default'].func,
	
	  // DayPicker props
	  renderMonth: _propTypes2['default'].func,
	  enableOutsideDays: _propTypes2['default'].bool,
	  numberOfMonths: _propTypes2['default'].number,
	  orientation: _ScrollableOrientationShape2['default'],
	  withPortal: _propTypes2['default'].bool,
	  initialVisibleMonth: _propTypes2['default'].func,
	  firstDayOfWeek: _DayOfWeekShape2['default'],
	  hideKeyboardShortcutsPanel: _propTypes2['default'].bool,
	  daySize: _airbnbPropTypes.nonNegativeInteger,
	  verticalHeight: _airbnbPropTypes.nonNegativeInteger,
	  noBorder: _propTypes2['default'].bool,
	  verticalBorderSpacing: _airbnbPropTypes.nonNegativeInteger,
	  transitionDuration: _airbnbPropTypes.nonNegativeInteger,
	
	  navPrev: _propTypes2['default'].node,
	  navNext: _propTypes2['default'].node,
	
	  onPrevMonthClick: _propTypes2['default'].func,
	  onNextMonthClick: _propTypes2['default'].func,
	  onOutsideClick: _propTypes2['default'].func,
	  renderCalendarDay: _propTypes2['default'].func,
	  renderDayContents: _propTypes2['default'].func,
	  renderCalendarInfo: _propTypes2['default'].func,
	  calendarInfoPosition: _CalendarInfoPositionShape2['default'],
	
	  // accessibility
	  onBlur: _propTypes2['default'].func,
	  isFocused: _propTypes2['default'].bool,
	  showKeyboardShortcuts: _propTypes2['default'].bool,
	
	  // i18n
	  monthFormat: _propTypes2['default'].string,
	  weekDayFormat: _propTypes2['default'].string,
	  phrases: _propTypes2['default'].shape((0, _getPhrasePropTypes2['default'])(_defaultPhrases.DayPickerPhrases)),
	  dayAriaLabelFormat: _propTypes2['default'].string,
	
	  isRTL: _propTypes2['default'].bool
	});
	
	var defaultProps = {
	  date: undefined, // TODO: use null
	  onDateChange: function () {
	    function onDateChange() {}
	
	    return onDateChange;
	  }(),
	
	
	  focused: false,
	  onFocusChange: function () {
	    function onFocusChange() {}
	
	    return onFocusChange;
	  }(),
	  onClose: function () {
	    function onClose() {}
	
	    return onClose;
	  }(),
	
	
	  keepOpenOnDateSelect: false,
	  isOutsideRange: function () {
	    function isOutsideRange() {}
	
	    return isOutsideRange;
	  }(),
	  isDayBlocked: function () {
	    function isDayBlocked() {}
	
	    return isDayBlocked;
	  }(),
	  isDayHighlighted: function () {
	    function isDayHighlighted() {}
	
	    return isDayHighlighted;
	  }(),
	
	
	  // DayPicker props
	  renderMonth: null,
	  enableOutsideDays: false,
	  numberOfMonths: 1,
	  orientation: _constants.HORIZONTAL_ORIENTATION,
	  withPortal: false,
	  hideKeyboardShortcutsPanel: false,
	  initialVisibleMonth: null,
	  firstDayOfWeek: null,
	  daySize: _constants.DAY_SIZE,
	  verticalHeight: null,
	  noBorder: false,
	  verticalBorderSpacing: undefined,
	  transitionDuration: undefined,
	
	  navPrev: null,
	  navNext: null,
	
	  onPrevMonthClick: function () {
	    function onPrevMonthClick() {}
	
	    return onPrevMonthClick;
	  }(),
	  onNextMonthClick: function () {
	    function onNextMonthClick() {}
	
	    return onNextMonthClick;
	  }(),
	  onOutsideClick: function () {
	    function onOutsideClick() {}
	
	    return onOutsideClick;
	  }(),
	
	
	  renderCalendarDay: undefined,
	  renderDayContents: null,
	  renderCalendarInfo: null,
	  calendarInfoPosition: _constants.INFO_POSITION_BOTTOM,
	
	  // accessibility
	  onBlur: function () {
	    function onBlur() {}
	
	    return onBlur;
	  }(),
	
	  isFocused: false,
	  showKeyboardShortcuts: false,
	
	  // i18n
	  monthFormat: 'MMMM YYYY',
	  weekDayFormat: 'dd',
	  phrases: _defaultPhrases.DayPickerPhrases,
	  dayAriaLabelFormat: undefined,
	
	  isRTL: false
	};
	
	var DayPickerSingleDateController = function (_React$Component) {
	  _inherits(DayPickerSingleDateController, _React$Component);
	
	  function DayPickerSingleDateController(props) {
	    _classCallCheck(this, DayPickerSingleDateController);
	
	    var _this = _possibleConstructorReturn(this, (DayPickerSingleDateController.__proto__ || Object.getPrototypeOf(DayPickerSingleDateController)).call(this, props));
	
	    _this.isTouchDevice = false;
	    _this.today = (0, _moment2['default'])();
	
	    _this.modifiers = {
	      today: function () {
	        function today(day) {
	          return _this.isToday(day);
	        }
	
	        return today;
	      }(),
	      blocked: function () {
	        function blocked(day) {
	          return _this.isBlocked(day);
	        }
	
	        return blocked;
	      }(),
	      'blocked-calendar': function () {
	        function blockedCalendar(day) {
	          return props.isDayBlocked(day);
	        }
	
	        return blockedCalendar;
	      }(),
	      'blocked-out-of-range': function () {
	        function blockedOutOfRange(day) {
	          return props.isOutsideRange(day);
	        }
	
	        return blockedOutOfRange;
	      }(),
	      'highlighted-calendar': function () {
	        function highlightedCalendar(day) {
	          return props.isDayHighlighted(day);
	        }
	
	        return highlightedCalendar;
	      }(),
	      valid: function () {
	        function valid(day) {
	          return !_this.isBlocked(day);
	        }
	
	        return valid;
	      }(),
	      hovered: function () {
	        function hovered(day) {
	          return _this.isHovered(day);
	        }
	
	        return hovered;
	      }(),
	      selected: function () {
	        function selected(day) {
	          return _this.isSelected(day);
	        }
	
	        return selected;
	      }(),
	      'first-day-of-week': function () {
	        function firstDayOfWeek(day) {
	          return _this.isFirstDayOfWeek(day);
	        }
	
	        return firstDayOfWeek;
	      }(),
	      'last-day-of-week': function () {
	        function lastDayOfWeek(day) {
	          return _this.isLastDayOfWeek(day);
	        }
	
	        return lastDayOfWeek;
	      }()
	    };
	
	    var _this$getStateForNewM = _this.getStateForNewMonth(props),
	        currentMonth = _this$getStateForNewM.currentMonth,
	        visibleDays = _this$getStateForNewM.visibleDays;
	
	    _this.state = {
	      hoverDate: null,
	      currentMonth: currentMonth,
	      visibleDays: visibleDays
	    };
	
	    _this.onDayMouseEnter = _this.onDayMouseEnter.bind(_this);
	    _this.onDayMouseLeave = _this.onDayMouseLeave.bind(_this);
	    _this.onDayClick = _this.onDayClick.bind(_this);
	
	    _this.onPrevMonthClick = _this.onPrevMonthClick.bind(_this);
	    _this.onNextMonthClick = _this.onNextMonthClick.bind(_this);
	
	    _this.getFirstFocusableDay = _this.getFirstFocusableDay.bind(_this);
	    return _this;
	  }
	
	  _createClass(DayPickerSingleDateController, [{
	    key: 'componentDidMount',
	    value: function () {
	      function componentDidMount() {
	        this.isTouchDevice = (0, _isTouchDevice2['default'])();
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function () {
	      function componentWillReceiveProps(nextProps) {
	        var _this2 = this;
	
	        var date = nextProps.date,
	            focused = nextProps.focused,
	            isOutsideRange = nextProps.isOutsideRange,
	            isDayBlocked = nextProps.isDayBlocked,
	            isDayHighlighted = nextProps.isDayHighlighted,
	            initialVisibleMonth = nextProps.initialVisibleMonth,
	            numberOfMonths = nextProps.numberOfMonths,
	            enableOutsideDays = nextProps.enableOutsideDays;
	        var visibleDays = this.state.visibleDays;
	
	
	        var recomputeOutsideRange = false;
	        var recomputeDayBlocked = false;
	        var recomputeDayHighlighted = false;
	
	        if (isOutsideRange !== this.props.isOutsideRange) {
	          this.modifiers['blocked-out-of-range'] = function (day) {
	            return isOutsideRange(day);
	          };
	          recomputeOutsideRange = true;
	        }
	
	        if (isDayBlocked !== this.props.isDayBlocked) {
	          this.modifiers['blocked-calendar'] = function (day) {
	            return isDayBlocked(day);
	          };
	          recomputeDayBlocked = true;
	        }
	
	        if (isDayHighlighted !== this.props.isDayHighlighted) {
	          this.modifiers['highlighted-calendar'] = function (day) {
	            return isDayHighlighted(day);
	          };
	          recomputeDayHighlighted = true;
	        }
	
	        var recomputePropModifiers = recomputeOutsideRange || recomputeDayBlocked || recomputeDayHighlighted;
	
	        if (numberOfMonths !== this.props.numberOfMonths || enableOutsideDays !== this.props.enableOutsideDays || initialVisibleMonth !== this.props.initialVisibleMonth && !this.props.focused && focused) {
	          var newMonthState = this.getStateForNewMonth(nextProps);
	          var currentMonth = newMonthState.currentMonth;
	          visibleDays = newMonthState.visibleDays;
	
	          this.setState({
	            currentMonth: currentMonth,
	            visibleDays: visibleDays
	          });
	        }
	
	        var didDateChange = date !== this.props.date;
	        var didFocusChange = focused !== this.props.focused;
	
	        var modifiers = {};
	
	        if (didDateChange) {
	          modifiers = this.deleteModifier(modifiers, this.props.date, 'selected');
	          modifiers = this.addModifier(modifiers, date, 'selected');
	        }
	
	        if (didFocusChange || recomputePropModifiers) {
	          (0, _object4['default'])(visibleDays).forEach(function (days) {
	            Object.keys(days).forEach(function (day) {
	              var momentObj = (0, _moment2['default'])(day);
	              if (_this2.isBlocked(momentObj)) {
	                modifiers = _this2.addModifier(modifiers, momentObj, 'blocked');
	              } else {
	                modifiers = _this2.deleteModifier(modifiers, momentObj, 'blocked');
	              }
	
	              if (didFocusChange || recomputeOutsideRange) {
	                if (isOutsideRange(momentObj)) {
	                  modifiers = _this2.addModifier(modifiers, momentObj, 'blocked-out-of-range');
	                } else {
	                  modifiers = _this2.deleteModifier(modifiers, momentObj, 'blocked-out-of-range');
	                }
	              }
	
	              if (didFocusChange || recomputeDayBlocked) {
	                if (isDayBlocked(momentObj)) {
	                  modifiers = _this2.addModifier(modifiers, momentObj, 'blocked-calendar');
	                } else {
	                  modifiers = _this2.deleteModifier(modifiers, momentObj, 'blocked-calendar');
	                }
	              }
	
	              if (didFocusChange || recomputeDayHighlighted) {
	                if (isDayHighlighted(momentObj)) {
	                  modifiers = _this2.addModifier(modifiers, momentObj, 'highlighted-calendar');
	                } else {
	                  modifiers = _this2.deleteModifier(modifiers, momentObj, 'highlighted-calendar');
	                }
	              }
	            });
	          });
	        }
	
	        var today = (0, _moment2['default'])();
	        if (!(0, _isSameDay2['default'])(this.today, today)) {
	          modifiers = this.deleteModifier(modifiers, this.today, 'today');
	          modifiers = this.addModifier(modifiers, today, 'today');
	          this.today = today;
	        }
	
	        if (Object.keys(modifiers).length > 0) {
	          this.setState({
	            visibleDays: (0, _object2['default'])({}, visibleDays, modifiers)
	          });
	        }
	      }
	
	      return componentWillReceiveProps;
	    }()
	  }, {
	    key: 'componentWillUpdate',
	    value: function () {
	      function componentWillUpdate() {
	        this.today = (0, _moment2['default'])();
	      }
	
	      return componentWillUpdate;
	    }()
	  }, {
	    key: 'onDayClick',
	    value: function () {
	      function onDayClick(day, e) {
	        if (e) e.preventDefault();
	        if (this.isBlocked(day)) return;
	        var _props = this.props,
	            onDateChange = _props.onDateChange,
	            keepOpenOnDateSelect = _props.keepOpenOnDateSelect,
	            onFocusChange = _props.onFocusChange,
	            onClose = _props.onClose;
	
	
	        onDateChange(day);
	        if (!keepOpenOnDateSelect) {
	          onFocusChange({ focused: false });
	          onClose({ date: day });
	        }
	      }
	
	      return onDayClick;
	    }()
	  }, {
	    key: 'onDayMouseEnter',
	    value: function () {
	      function onDayMouseEnter(day) {
	        if (this.isTouchDevice) return;
	        var _state = this.state,
	            hoverDate = _state.hoverDate,
	            visibleDays = _state.visibleDays;
	
	
	        var modifiers = this.deleteModifier({}, hoverDate, 'hovered');
	        modifiers = this.addModifier(modifiers, day, 'hovered');
	
	        this.setState({
	          hoverDate: day,
	          visibleDays: (0, _object2['default'])({}, visibleDays, modifiers)
	        });
	      }
	
	      return onDayMouseEnter;
	    }()
	  }, {
	    key: 'onDayMouseLeave',
	    value: function () {
	      function onDayMouseLeave() {
	        var _state2 = this.state,
	            hoverDate = _state2.hoverDate,
	            visibleDays = _state2.visibleDays;
	
	        if (this.isTouchDevice || !hoverDate) return;
	
	        var modifiers = this.deleteModifier({}, hoverDate, 'hovered');
	
	        this.setState({
	          hoverDate: null,
	          visibleDays: (0, _object2['default'])({}, visibleDays, modifiers)
	        });
	      }
	
	      return onDayMouseLeave;
	    }()
	  }, {
	    key: 'onPrevMonthClick',
	    value: function () {
	      function onPrevMonthClick() {
	        var _props2 = this.props,
	            onPrevMonthClick = _props2.onPrevMonthClick,
	            numberOfMonths = _props2.numberOfMonths,
	            enableOutsideDays = _props2.enableOutsideDays;
	        var _state3 = this.state,
	            currentMonth = _state3.currentMonth,
	            visibleDays = _state3.visibleDays;
	
	
	        var newVisibleDays = {};
	        Object.keys(visibleDays).sort().slice(0, numberOfMonths + 1).forEach(function (month) {
	          newVisibleDays[month] = visibleDays[month];
	        });
	
	        var prevMonth = currentMonth.clone().subtract(1, 'month');
	        var prevMonthVisibleDays = (0, _getVisibleDays2['default'])(prevMonth, 1, enableOutsideDays);
	
	        this.setState({
	          currentMonth: prevMonth,
	          visibleDays: (0, _object2['default'])({}, newVisibleDays, this.getModifiers(prevMonthVisibleDays))
	        }, function () {
	          onPrevMonthClick(prevMonth.clone());
	        });
	      }
	
	      return onPrevMonthClick;
	    }()
	  }, {
	    key: 'onNextMonthClick',
	    value: function () {
	      function onNextMonthClick() {
	        var _props3 = this.props,
	            onNextMonthClick = _props3.onNextMonthClick,
	            numberOfMonths = _props3.numberOfMonths,
	            enableOutsideDays = _props3.enableOutsideDays;
	        var _state4 = this.state,
	            currentMonth = _state4.currentMonth,
	            visibleDays = _state4.visibleDays;
	
	
	        var newVisibleDays = {};
	        Object.keys(visibleDays).sort().slice(1).forEach(function (month) {
	          newVisibleDays[month] = visibleDays[month];
	        });
	
	        var nextMonth = currentMonth.clone().add(numberOfMonths, 'month');
	        var nextMonthVisibleDays = (0, _getVisibleDays2['default'])(nextMonth, 1, enableOutsideDays);
	
	        var newCurrentMonth = currentMonth.clone().add(1, 'month');
	        this.setState({
	          currentMonth: newCurrentMonth,
	          visibleDays: (0, _object2['default'])({}, newVisibleDays, this.getModifiers(nextMonthVisibleDays))
	        }, function () {
	          onNextMonthClick(newCurrentMonth.clone());
	        });
	      }
	
	      return onNextMonthClick;
	    }()
	  }, {
	    key: 'getFirstFocusableDay',
	    value: function () {
	      function getFirstFocusableDay(newMonth) {
	        var _this3 = this;
	
	        var _props4 = this.props,
	            date = _props4.date,
	            numberOfMonths = _props4.numberOfMonths;
	
	
	        var focusedDate = newMonth.clone().startOf('month');
	        if (date) {
	          focusedDate = date.clone();
	        }
	
	        if (this.isBlocked(focusedDate)) {
	          var days = [];
	          var lastVisibleDay = newMonth.clone().add(numberOfMonths - 1, 'months').endOf('month');
	          var currentDay = focusedDate.clone();
	          while (!(0, _isAfterDay2['default'])(currentDay, lastVisibleDay)) {
	            currentDay = currentDay.clone().add(1, 'day');
	            days.push(currentDay);
	          }
	
	          var viableDays = days.filter(function (day) {
	            return !_this3.isBlocked(day) && (0, _isAfterDay2['default'])(day, focusedDate);
	          });
	          if (viableDays.length > 0) {
	            var _viableDays = _slicedToArray(viableDays, 1);
	
	            focusedDate = _viableDays[0];
	          }
	        }
	
	        return focusedDate;
	      }
	
	      return getFirstFocusableDay;
	    }()
	  }, {
	    key: 'getModifiers',
	    value: function () {
	      function getModifiers(visibleDays) {
	        var _this4 = this;
	
	        var modifiers = {};
	        Object.keys(visibleDays).forEach(function (month) {
	          modifiers[month] = {};
	          visibleDays[month].forEach(function (day) {
	            modifiers[month][(0, _toISODateString2['default'])(day)] = _this4.getModifiersForDay(day);
	          });
	        });
	
	        return modifiers;
	      }
	
	      return getModifiers;
	    }()
	  }, {
	    key: 'getModifiersForDay',
	    value: function () {
	      function getModifiersForDay(day) {
	        var _this5 = this;
	
	        return new Set(Object.keys(this.modifiers).filter(function (modifier) {
	          return _this5.modifiers[modifier](day);
	        }));
	      }
	
	      return getModifiersForDay;
	    }()
	  }, {
	    key: 'getStateForNewMonth',
	    value: function () {
	      function getStateForNewMonth(nextProps) {
	        var _this6 = this;
	
	        var initialVisibleMonth = nextProps.initialVisibleMonth,
	            date = nextProps.date,
	            numberOfMonths = nextProps.numberOfMonths,
	            enableOutsideDays = nextProps.enableOutsideDays;
	
	        var initialVisibleMonthThunk = initialVisibleMonth || (date ? function () {
	          return date;
	        } : function () {
	          return _this6.today;
	        });
	        var currentMonth = initialVisibleMonthThunk();
	        var visibleDays = this.getModifiers((0, _getVisibleDays2['default'])(currentMonth, numberOfMonths, enableOutsideDays));
	        return { currentMonth: currentMonth, visibleDays: visibleDays };
	      }
	
	      return getStateForNewMonth;
	    }()
	  }, {
	    key: 'addModifier',
	    value: function () {
	      function addModifier(updatedDays, day, modifier) {
	        var _props5 = this.props,
	            numberOfVisibleMonths = _props5.numberOfMonths,
	            enableOutsideDays = _props5.enableOutsideDays,
	            orientation = _props5.orientation;
	        var _state5 = this.state,
	            firstVisibleMonth = _state5.currentMonth,
	            visibleDays = _state5.visibleDays;
	
	
	        var currentMonth = firstVisibleMonth;
	        var numberOfMonths = numberOfVisibleMonths;
	        if (orientation !== _constants.VERTICAL_SCROLLABLE) {
	          currentMonth = currentMonth.clone().subtract(1, 'month');
	          numberOfMonths += 2;
	        }
	        if (!day || !(0, _isDayVisible2['default'])(day, currentMonth, numberOfMonths, enableOutsideDays)) {
	          return updatedDays;
	        }
	
	        var iso = (0, _toISODateString2['default'])(day);
	
	        var updatedDaysAfterAddition = (0, _object2['default'])({}, updatedDays);
	        if (enableOutsideDays) {
	          var monthsToUpdate = Object.keys(visibleDays).filter(function (monthKey) {
	            return Object.keys(visibleDays[monthKey]).indexOf(iso) > -1;
	          });
	
	          updatedDaysAfterAddition = monthsToUpdate.reduce(function (days, monthIso) {
	            var month = updatedDays[monthIso] || visibleDays[monthIso];
	            var modifiers = new Set(month[iso]);
	            modifiers.add(modifier);
	            return (0, _object2['default'])({}, days, _defineProperty({}, monthIso, (0, _object2['default'])({}, month, _defineProperty({}, iso, modifiers))));
	          }, updatedDaysAfterAddition);
	        } else {
	          var monthIso = (0, _toISOMonthString2['default'])(day);
	          var month = updatedDays[monthIso] || visibleDays[monthIso];
	
	          var modifiers = new Set(month[iso]);
	          modifiers.add(modifier);
	          updatedDaysAfterAddition = (0, _object2['default'])({}, updatedDaysAfterAddition, _defineProperty({}, monthIso, (0, _object2['default'])({}, month, _defineProperty({}, iso, modifiers))));
	        }
	
	        return updatedDaysAfterAddition;
	      }
	
	      return addModifier;
	    }()
	  }, {
	    key: 'deleteModifier',
	    value: function () {
	      function deleteModifier(updatedDays, day, modifier) {
	        var _props6 = this.props,
	            numberOfVisibleMonths = _props6.numberOfMonths,
	            enableOutsideDays = _props6.enableOutsideDays,
	            orientation = _props6.orientation;
	        var _state6 = this.state,
	            firstVisibleMonth = _state6.currentMonth,
	            visibleDays = _state6.visibleDays;
	
	
	        var currentMonth = firstVisibleMonth;
	        var numberOfMonths = numberOfVisibleMonths;
	        if (orientation !== _constants.VERTICAL_SCROLLABLE) {
	          currentMonth = currentMonth.clone().subtract(1, 'month');
	          numberOfMonths += 2;
	        }
	        if (!day || !(0, _isDayVisible2['default'])(day, currentMonth, numberOfMonths, enableOutsideDays)) {
	          return updatedDays;
	        }
	
	        var iso = (0, _toISODateString2['default'])(day);
	
	        var updatedDaysAfterDeletion = (0, _object2['default'])({}, updatedDays);
	        if (enableOutsideDays) {
	          var monthsToUpdate = Object.keys(visibleDays).filter(function (monthKey) {
	            return Object.keys(visibleDays[monthKey]).indexOf(iso) > -1;
	          });
	
	          updatedDaysAfterDeletion = monthsToUpdate.reduce(function (days, monthIso) {
	            var month = updatedDays[monthIso] || visibleDays[monthIso];
	            var modifiers = new Set(month[iso]);
	            modifiers['delete'](modifier);
	            return (0, _object2['default'])({}, days, _defineProperty({}, monthIso, (0, _object2['default'])({}, month, _defineProperty({}, iso, modifiers))));
	          }, updatedDaysAfterDeletion);
	        } else {
	          var monthIso = (0, _toISOMonthString2['default'])(day);
	          var month = updatedDays[monthIso] || visibleDays[monthIso];
	
	          var modifiers = new Set(month[iso]);
	          modifiers['delete'](modifier);
	          updatedDaysAfterDeletion = (0, _object2['default'])({}, updatedDaysAfterDeletion, _defineProperty({}, monthIso, (0, _object2['default'])({}, month, _defineProperty({}, iso, modifiers))));
	        }
	
	        return updatedDaysAfterDeletion;
	      }
	
	      return deleteModifier;
	    }()
	  }, {
	    key: 'isBlocked',
	    value: function () {
	      function isBlocked(day) {
	        var _props7 = this.props,
	            isDayBlocked = _props7.isDayBlocked,
	            isOutsideRange = _props7.isOutsideRange;
	
	        return isDayBlocked(day) || isOutsideRange(day);
	      }
	
	      return isBlocked;
	    }()
	  }, {
	    key: 'isHovered',
	    value: function () {
	      function isHovered(day) {
	        var _ref = this.state || {},
	            hoverDate = _ref.hoverDate;
	
	        return (0, _isSameDay2['default'])(day, hoverDate);
	      }
	
	      return isHovered;
	    }()
	  }, {
	    key: 'isSelected',
	    value: function () {
	      function isSelected(day) {
	        return (0, _isSameDay2['default'])(day, this.props.date);
	      }
	
	      return isSelected;
	    }()
	  }, {
	    key: 'isToday',
	    value: function () {
	      function isToday(day) {
	        return (0, _isSameDay2['default'])(day, this.today);
	      }
	
	      return isToday;
	    }()
	  }, {
	    key: 'isFirstDayOfWeek',
	    value: function () {
	      function isFirstDayOfWeek(day) {
	        var firstDayOfWeek = this.props.firstDayOfWeek;
	
	        return day.day() === (firstDayOfWeek || _moment2['default'].localeData().firstDayOfWeek());
	      }
	
	      return isFirstDayOfWeek;
	    }()
	  }, {
	    key: 'isLastDayOfWeek',
	    value: function () {
	      function isLastDayOfWeek(day) {
	        var firstDayOfWeek = this.props.firstDayOfWeek;
	
	        return day.day() === ((firstDayOfWeek || _moment2['default'].localeData().firstDayOfWeek()) + 6) % 7;
	      }
	
	      return isLastDayOfWeek;
	    }()
	  }, {
	    key: 'render',
	    value: function () {
	      function render() {
	        var _props8 = this.props,
	            numberOfMonths = _props8.numberOfMonths,
	            orientation = _props8.orientation,
	            monthFormat = _props8.monthFormat,
	            renderMonth = _props8.renderMonth,
	            navPrev = _props8.navPrev,
	            navNext = _props8.navNext,
	            onOutsideClick = _props8.onOutsideClick,
	            withPortal = _props8.withPortal,
	            focused = _props8.focused,
	            enableOutsideDays = _props8.enableOutsideDays,
	            hideKeyboardShortcutsPanel = _props8.hideKeyboardShortcutsPanel,
	            daySize = _props8.daySize,
	            firstDayOfWeek = _props8.firstDayOfWeek,
	            renderCalendarDay = _props8.renderCalendarDay,
	            renderDayContents = _props8.renderDayContents,
	            renderCalendarInfo = _props8.renderCalendarInfo,
	            calendarInfoPosition = _props8.calendarInfoPosition,
	            isFocused = _props8.isFocused,
	            isRTL = _props8.isRTL,
	            phrases = _props8.phrases,
	            dayAriaLabelFormat = _props8.dayAriaLabelFormat,
	            onBlur = _props8.onBlur,
	            showKeyboardShortcuts = _props8.showKeyboardShortcuts,
	            weekDayFormat = _props8.weekDayFormat,
	            verticalHeight = _props8.verticalHeight,
	            noBorder = _props8.noBorder,
	            transitionDuration = _props8.transitionDuration,
	            verticalBorderSpacing = _props8.verticalBorderSpacing;
	        var _state7 = this.state,
	            currentMonth = _state7.currentMonth,
	            visibleDays = _state7.visibleDays;
	
	
	        return _react2['default'].createElement(_DayPicker2['default'], {
	          orientation: orientation,
	          enableOutsideDays: enableOutsideDays,
	          modifiers: visibleDays,
	          numberOfMonths: numberOfMonths,
	          onDayClick: this.onDayClick,
	          onDayMouseEnter: this.onDayMouseEnter,
	          onDayMouseLeave: this.onDayMouseLeave,
	          onPrevMonthClick: this.onPrevMonthClick,
	          onNextMonthClick: this.onNextMonthClick,
	          monthFormat: monthFormat,
	          withPortal: withPortal,
	          hidden: !focused,
	          hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
	          initialVisibleMonth: function () {
	            function initialVisibleMonth() {
	              return currentMonth;
	            }
	
	            return initialVisibleMonth;
	          }(),
	          firstDayOfWeek: firstDayOfWeek,
	          onOutsideClick: onOutsideClick,
	          navPrev: navPrev,
	          navNext: navNext,
	          renderMonth: renderMonth,
	          renderCalendarDay: renderCalendarDay,
	          renderDayContents: renderDayContents,
	          renderCalendarInfo: renderCalendarInfo,
	          calendarInfoPosition: calendarInfoPosition,
	          isFocused: isFocused,
	          getFirstFocusableDay: this.getFirstFocusableDay,
	          onBlur: onBlur,
	          phrases: phrases,
	          daySize: daySize,
	          isRTL: isRTL,
	          showKeyboardShortcuts: showKeyboardShortcuts,
	          weekDayFormat: weekDayFormat,
	          dayAriaLabelFormat: dayAriaLabelFormat,
	          verticalHeight: verticalHeight,
	          noBorder: noBorder,
	          transitionDuration: transitionDuration,
	          verticalBorderSpacing: verticalBorderSpacing
	        });
	      }
	
	      return render;
	    }()
	  }]);
	
	  return DayPickerSingleDateController;
	}(_react2['default'].Component);
	
	exports['default'] = DayPickerSingleDateController;
	
	
	DayPickerSingleDateController.propTypes = propTypes;
	DayPickerSingleDateController.defaultProps = defaultProps;

/***/ },
/* 856 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var LeftArrow = function () {
	  function LeftArrow(props) {
	    return _react2['default'].createElement(
	      'svg',
	      props,
	      _react2['default'].createElement('path', {
	        d: 'M336.2 274.5l-210.1 210h805.4c13 0 23 10 23 23s-10 23-23 23H126.1l210.1 210.1c11 11 11 21 0 32-5 5-10 7-16 7s-11-2-16-7l-249.1-249c-11-11-11-21 0-32l249.1-249.1c21-21.1 53 10.9 32 32z'
	      })
	    );
	  }
	
	  return LeftArrow;
	}();
	
	LeftArrow.defaultProps = {
	  viewBox: '0 0 1000 1000'
	};
	exports['default'] = LeftArrow;

/***/ },
/* 857 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var RightArrow = function () {
	  function RightArrow(props) {
	    return _react2['default'].createElement(
	      'svg',
	      props,
	      _react2['default'].createElement('path', {
	        d: 'M694.4 242.4l249.1 249.1c11 11 11 21 0 32L694.4 772.7c-5 5-10 7-16 7s-11-2-16-7c-11-11-11-21 0-32l210.1-210.1H67.1c-13 0-23-10-23-23s10-23 23-23h805.4L662.4 274.5c-21-21.1 11-53.1 32-32.1z'
	      })
	    );
	  }
	
	  return RightArrow;
	}();
	
	RightArrow.defaultProps = {
	  viewBox: '0 0 1000 1000'
	};
	exports['default'] = RightArrow;

/***/ },
/* 858 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _object = __webpack_require__(55);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(27);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _airbnbPropTypes = __webpack_require__(42);
	
	var _reactWithStyles = __webpack_require__(72);
	
	var _defaultPhrases = __webpack_require__(50);
	
	var _getPhrasePropTypes = __webpack_require__(63);
	
	var _getPhrasePropTypes2 = _interopRequireDefault(_getPhrasePropTypes);
	
	var _DateInput = __webpack_require__(851);
	
	var _DateInput2 = _interopRequireDefault(_DateInput);
	
	var _IconPositionShape = __webpack_require__(261);
	
	var _IconPositionShape2 = _interopRequireDefault(_IconPositionShape);
	
	var _CloseButton = __webpack_require__(259);
	
	var _CloseButton2 = _interopRequireDefault(_CloseButton);
	
	var _CalendarIcon = __webpack_require__(848);
	
	var _CalendarIcon2 = _interopRequireDefault(_CalendarIcon);
	
	var _OpenDirectionShape = __webpack_require__(211);
	
	var _OpenDirectionShape2 = _interopRequireDefault(_OpenDirectionShape);
	
	var _constants = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)((0, _object2['default'])({}, _reactWithStyles.withStylesPropTypes, {
	  id: _propTypes2['default'].string.isRequired,
	  placeholder: _propTypes2['default'].string, // also used as label
	  displayValue: _propTypes2['default'].string,
	  screenReaderMessage: _propTypes2['default'].string,
	  focused: _propTypes2['default'].bool,
	  isFocused: _propTypes2['default'].bool, // describes actual DOM focus
	  disabled: _propTypes2['default'].bool,
	  required: _propTypes2['default'].bool,
	  readOnly: _propTypes2['default'].bool,
	  openDirection: _OpenDirectionShape2['default'],
	  showCaret: _propTypes2['default'].bool,
	  showClearDate: _propTypes2['default'].bool,
	  customCloseIcon: _propTypes2['default'].node,
	  showDefaultInputIcon: _propTypes2['default'].bool,
	  inputIconPosition: _IconPositionShape2['default'],
	  customInputIcon: _propTypes2['default'].node,
	  isRTL: _propTypes2['default'].bool,
	  noBorder: _propTypes2['default'].bool,
	  block: _propTypes2['default'].bool,
	  small: _propTypes2['default'].bool,
	  regular: _propTypes2['default'].bool,
	  verticalSpacing: _airbnbPropTypes.nonNegativeInteger,
	
	  onChange: _propTypes2['default'].func,
	  onClearDate: _propTypes2['default'].func,
	  onFocus: _propTypes2['default'].func,
	  onKeyDownShiftTab: _propTypes2['default'].func,
	  onKeyDownTab: _propTypes2['default'].func,
	  onKeyDownArrowDown: _propTypes2['default'].func,
	  onKeyDownQuestionMark: _propTypes2['default'].func,
	
	  // i18n
	  phrases: _propTypes2['default'].shape((0, _getPhrasePropTypes2['default'])(_defaultPhrases.SingleDatePickerInputPhrases))
	}));
	
	var defaultProps = {
	  placeholder: 'Select Date',
	  displayValue: '',
	  screenReaderMessage: '',
	  focused: false,
	  isFocused: false,
	  disabled: false,
	  required: false,
	  readOnly: false,
	  openDirection: _constants.OPEN_DOWN,
	  showCaret: false,
	  showClearDate: false,
	  showDefaultInputIcon: false,
	  inputIconPosition: _constants.ICON_BEFORE_POSITION,
	  customCloseIcon: null,
	  customInputIcon: null,
	  isRTL: false,
	  noBorder: false,
	  block: false,
	  small: false,
	  regular: false,
	  verticalSpacing: undefined,
	
	  onChange: function () {
	    function onChange() {}
	
	    return onChange;
	  }(),
	  onClearDate: function () {
	    function onClearDate() {}
	
	    return onClearDate;
	  }(),
	  onFocus: function () {
	    function onFocus() {}
	
	    return onFocus;
	  }(),
	  onKeyDownShiftTab: function () {
	    function onKeyDownShiftTab() {}
	
	    return onKeyDownShiftTab;
	  }(),
	  onKeyDownTab: function () {
	    function onKeyDownTab() {}
	
	    return onKeyDownTab;
	  }(),
	  onKeyDownArrowDown: function () {
	    function onKeyDownArrowDown() {}
	
	    return onKeyDownArrowDown;
	  }(),
	  onKeyDownQuestionMark: function () {
	    function onKeyDownQuestionMark() {}
	
	    return onKeyDownQuestionMark;
	  }(),
	
	
	  // i18n
	  phrases: _defaultPhrases.SingleDatePickerInputPhrases
	};
	
	function SingleDatePickerInput(_ref) {
	  var id = _ref.id,
	      placeholder = _ref.placeholder,
	      displayValue = _ref.displayValue,
	      focused = _ref.focused,
	      isFocused = _ref.isFocused,
	      disabled = _ref.disabled,
	      required = _ref.required,
	      readOnly = _ref.readOnly,
	      showCaret = _ref.showCaret,
	      showClearDate = _ref.showClearDate,
	      showDefaultInputIcon = _ref.showDefaultInputIcon,
	      inputIconPosition = _ref.inputIconPosition,
	      phrases = _ref.phrases,
	      onClearDate = _ref.onClearDate,
	      onChange = _ref.onChange,
	      onFocus = _ref.onFocus,
	      onKeyDownShiftTab = _ref.onKeyDownShiftTab,
	      onKeyDownTab = _ref.onKeyDownTab,
	      onKeyDownArrowDown = _ref.onKeyDownArrowDown,
	      onKeyDownQuestionMark = _ref.onKeyDownQuestionMark,
	      screenReaderMessage = _ref.screenReaderMessage,
	      customCloseIcon = _ref.customCloseIcon,
	      customInputIcon = _ref.customInputIcon,
	      openDirection = _ref.openDirection,
	      isRTL = _ref.isRTL,
	      noBorder = _ref.noBorder,
	      block = _ref.block,
	      small = _ref.small,
	      regular = _ref.regular,
	      verticalSpacing = _ref.verticalSpacing,
	      styles = _ref.styles;
	
	  var calendarIcon = customInputIcon || _react2['default'].createElement(_CalendarIcon2['default'], (0, _reactWithStyles.css)(styles.SingleDatePickerInput_calendarIcon_svg));
	  var closeIcon = customCloseIcon || _react2['default'].createElement(_CloseButton2['default'], (0, _reactWithStyles.css)(styles.SingleDatePickerInput_clearDate_svg, small && styles.SingleDatePickerInput_clearDate_svg__small));
	
	  var screenReaderText = screenReaderMessage || phrases.keyboardNavigationInstructions;
	  var inputIcon = (showDefaultInputIcon || customInputIcon !== null) && _react2['default'].createElement(
	    'button',
	    _extends({}, (0, _reactWithStyles.css)(styles.SingleDatePickerInput_calendarIcon), {
	      type: 'button',
	      disabled: disabled,
	      'aria-label': phrases.focusStartDate,
	      onClick: onFocus
	    }),
	    calendarIcon
	  );
	
	  return _react2['default'].createElement(
	    'div',
	    (0, _reactWithStyles.css)(styles.SingleDatePickerInput, disabled && styles.SingleDatePickerInput__disabled, isRTL && styles.SingleDatePickerInput__rtl, !noBorder && styles.SingleDatePickerInput__withBorder, block && styles.SingleDatePickerInput__block, showClearDate && styles.SingleDatePickerInput__showClearDate),
	    inputIconPosition === _constants.ICON_BEFORE_POSITION && inputIcon,
	    _react2['default'].createElement(_DateInput2['default'], {
	      id: id,
	      placeholder: placeholder // also used as label
	      , displayValue: displayValue,
	      screenReaderMessage: screenReaderText,
	      focused: focused,
	      isFocused: isFocused,
	      disabled: disabled,
	      required: required,
	      readOnly: readOnly,
	      showCaret: showCaret,
	      onChange: onChange,
	      onFocus: onFocus,
	      onKeyDownShiftTab: onKeyDownShiftTab,
	      onKeyDownTab: onKeyDownTab,
	      onKeyDownArrowDown: onKeyDownArrowDown,
	      onKeyDownQuestionMark: onKeyDownQuestionMark,
	      openDirection: openDirection,
	      verticalSpacing: verticalSpacing,
	      small: small,
	      regular: regular,
	      block: block
	    }),
	    showClearDate && _react2['default'].createElement(
	      'button',
	      _extends({}, (0, _reactWithStyles.css)(styles.SingleDatePickerInput_clearDate, small && styles.SingleDatePickerInput_clearDate__small, !customCloseIcon && styles.SingleDatePickerInput_clearDate__default, !displayValue && styles.SingleDatePickerInput_clearDate__hide), {
	        type: 'button',
	        'aria-label': phrases.clearDate,
	        disabled: disabled,
	        onMouseEnter: this.onClearDateMouseEnter,
	        onMouseLeave: this.onClearDateMouseLeave,
	        onClick: onClearDate
	      }),
	      closeIcon
	    ),
	    inputIconPosition === _constants.ICON_AFTER_POSITION && inputIcon
	  );
	}
	
	SingleDatePickerInput.propTypes = propTypes;
	SingleDatePickerInput.defaultProps = defaultProps;
	
	exports['default'] = (0, _reactWithStyles.withStyles)(function (_ref2) {
	  var color = _ref2.reactDates.color;
	  return {
	    SingleDatePickerInput: {
	      display: 'inline-block',
	      backgroundColor: color.background
	    },
	
	    SingleDatePickerInput__withBorder: {
	      border: '1px solid ' + String(color.core.border)
	    },
	
	    SingleDatePickerInput__rtl: {
	      direction: 'rtl'
	    },
	
	    SingleDatePickerInput__disabled: {
	      backgroundColor: color.disabled
	    },
	
	    SingleDatePickerInput__block: {
	      display: 'block'
	    },
	
	    SingleDatePickerInput__showClearDate: {
	      paddingRight: 30
	    },
	
	    SingleDatePickerInput_clearDate: {
	      background: 'none',
	      border: 0,
	      color: 'inherit',
	      font: 'inherit',
	      lineHeight: 'normal',
	      overflow: 'visible',
	
	      cursor: 'pointer',
	      padding: 10,
	      margin: '0 10px 0 5px',
	      position: 'absolute',
	      right: 0,
	      top: '50%',
	      transform: 'translateY(-50%)'
	    },
	
	    SingleDatePickerInput_clearDate__default: {
	      ':focus': {
	        background: color.core.border,
	        borderRadius: '50%'
	      },
	
	      ':hover': {
	        background: color.core.border,
	        borderRadius: '50%'
	      }
	    },
	
	    SingleDatePickerInput_clearDate__small: {
	      padding: 6
	    },
	
	    SingleDatePickerInput_clearDate__hide: {
	      visibility: 'hidden'
	    },
	
	    SingleDatePickerInput_clearDate_svg: {
	      fill: color.core.grayLight,
	      height: 12,
	      width: 15,
	      verticalAlign: 'middle'
	    },
	
	    SingleDatePickerInput_clearDate_svg__small: {
	      height: 9
	    },
	
	    SingleDatePickerInput_calendarIcon: {
	      background: 'none',
	      border: 0,
	      color: 'inherit',
	      font: 'inherit',
	      lineHeight: 'normal',
	      overflow: 'visible',
	
	      cursor: 'pointer',
	      display: 'inline-block',
	      verticalAlign: 'middle',
	      padding: 10,
	      margin: '0 5px 0 10px'
	    },
	
	    SingleDatePickerInput_calendarIcon_svg: {
	      fill: color.core.grayLight,
	      height: 15,
	      width: 14,
	      verticalAlign: 'middle'
	    }
	  };
	})(SingleDatePickerInput);

/***/ },
/* 859 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(27);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _constants = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _propTypes2['default'].oneOf([_constants.ANCHOR_LEFT, _constants.ANCHOR_RIGHT]);

/***/ },
/* 860 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(27);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactMomentProptypes = __webpack_require__(112);
	
	var _reactMomentProptypes2 = _interopRequireDefault(_reactMomentProptypes);
	
	var _airbnbPropTypes = __webpack_require__(42);
	
	var _defaultPhrases = __webpack_require__(50);
	
	var _getPhrasePropTypes = __webpack_require__(63);
	
	var _getPhrasePropTypes2 = _interopRequireDefault(_getPhrasePropTypes);
	
	var _FocusedInputShape = __webpack_require__(861);
	
	var _FocusedInputShape2 = _interopRequireDefault(_FocusedInputShape);
	
	var _IconPositionShape = __webpack_require__(261);
	
	var _IconPositionShape2 = _interopRequireDefault(_IconPositionShape);
	
	var _OrientationShape = __webpack_require__(862);
	
	var _OrientationShape2 = _interopRequireDefault(_OrientationShape);
	
	var _DisabledShape = __webpack_require__(339);
	
	var _DisabledShape2 = _interopRequireDefault(_DisabledShape);
	
	var _AnchorDirectionShape = __webpack_require__(859);
	
	var _AnchorDirectionShape2 = _interopRequireDefault(_AnchorDirectionShape);
	
	var _OpenDirectionShape = __webpack_require__(211);
	
	var _OpenDirectionShape2 = _interopRequireDefault(_OpenDirectionShape);
	
	var _DayOfWeekShape = __webpack_require__(165);
	
	var _DayOfWeekShape2 = _interopRequireDefault(_DayOfWeekShape);
	
	var _CalendarInfoPositionShape = __webpack_require__(260);
	
	var _CalendarInfoPositionShape2 = _interopRequireDefault(_CalendarInfoPositionShape);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = {
	  // required props for a functional interactive DateRangePicker
	  startDate: _reactMomentProptypes2['default'].momentObj,
	  endDate: _reactMomentProptypes2['default'].momentObj,
	  onDatesChange: _propTypes2['default'].func.isRequired,
	
	  focusedInput: _FocusedInputShape2['default'],
	  onFocusChange: _propTypes2['default'].func.isRequired,
	
	  onClose: _propTypes2['default'].func,
	
	  // input related props
	  startDateId: _propTypes2['default'].string.isRequired,
	  startDatePlaceholderText: _propTypes2['default'].string,
	  endDateId: _propTypes2['default'].string.isRequired,
	  endDatePlaceholderText: _propTypes2['default'].string,
	  disabled: _DisabledShape2['default'],
	  required: _propTypes2['default'].bool,
	  readOnly: _propTypes2['default'].bool,
	  screenReaderInputMessage: _propTypes2['default'].string,
	  showClearDates: _propTypes2['default'].bool,
	  showDefaultInputIcon: _propTypes2['default'].bool,
	  inputIconPosition: _IconPositionShape2['default'],
	  customInputIcon: _propTypes2['default'].node,
	  customArrowIcon: _propTypes2['default'].node,
	  customCloseIcon: _propTypes2['default'].node,
	  noBorder: _propTypes2['default'].bool,
	  block: _propTypes2['default'].bool,
	  small: _propTypes2['default'].bool,
	  regular: _propTypes2['default'].bool,
	  keepFocusOnInput: _propTypes2['default'].bool,
	
	  // calendar presentation and interaction related props
	  renderMonth: _propTypes2['default'].func,
	  orientation: _OrientationShape2['default'],
	  anchorDirection: _AnchorDirectionShape2['default'],
	  openDirection: _OpenDirectionShape2['default'],
	  horizontalMargin: _propTypes2['default'].number,
	  withPortal: _propTypes2['default'].bool,
	  withFullScreenPortal: _propTypes2['default'].bool,
	  appendToBody: _propTypes2['default'].bool,
	  disableScroll: _propTypes2['default'].bool,
	  daySize: _airbnbPropTypes.nonNegativeInteger,
	  isRTL: _propTypes2['default'].bool,
	  firstDayOfWeek: _DayOfWeekShape2['default'],
	  initialVisibleMonth: _propTypes2['default'].func,
	  numberOfMonths: _propTypes2['default'].number,
	  keepOpenOnDateSelect: _propTypes2['default'].bool,
	  reopenPickerOnClearDates: _propTypes2['default'].bool,
	  renderCalendarInfo: _propTypes2['default'].func,
	  calendarInfoPosition: _CalendarInfoPositionShape2['default'],
	  hideKeyboardShortcutsPanel: _propTypes2['default'].bool,
	  verticalHeight: _airbnbPropTypes.nonNegativeInteger,
	  transitionDuration: _airbnbPropTypes.nonNegativeInteger,
	  verticalSpacing: _airbnbPropTypes.nonNegativeInteger,
	
	  // navigation related props
	  navPrev: _propTypes2['default'].node,
	  navNext: _propTypes2['default'].node,
	  onPrevMonthClick: _propTypes2['default'].func,
	  onNextMonthClick: _propTypes2['default'].func,
	
	  // day presentation and interaction related props
	  renderCalendarDay: _propTypes2['default'].func,
	  renderDayContents: _propTypes2['default'].func,
	  minimumNights: _propTypes2['default'].number,
	  enableOutsideDays: _propTypes2['default'].bool,
	  isDayBlocked: _propTypes2['default'].func,
	  isOutsideRange: _propTypes2['default'].func,
	  isDayHighlighted: _propTypes2['default'].func,
	
	  // internationalization props
	  displayFormat: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].func]),
	  monthFormat: _propTypes2['default'].string,
	  weekDayFormat: _propTypes2['default'].string,
	  phrases: _propTypes2['default'].shape((0, _getPhrasePropTypes2['default'])(_defaultPhrases.DateRangePickerPhrases)),
	  dayAriaLabelFormat: _propTypes2['default'].string
	};

/***/ },
/* 861 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(27);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _constants = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _propTypes2['default'].oneOf([_constants.START_DATE, _constants.END_DATE]);

/***/ },
/* 862 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(27);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _constants = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _propTypes2['default'].oneOf([_constants.HORIZONTAL_ORIENTATION, _constants.VERTICAL_ORIENTATION]);

/***/ },
/* 863 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(27);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactMomentProptypes = __webpack_require__(112);
	
	var _reactMomentProptypes2 = _interopRequireDefault(_reactMomentProptypes);
	
	var _airbnbPropTypes = __webpack_require__(42);
	
	var _defaultPhrases = __webpack_require__(50);
	
	var _getPhrasePropTypes = __webpack_require__(63);
	
	var _getPhrasePropTypes2 = _interopRequireDefault(_getPhrasePropTypes);
	
	var _IconPositionShape = __webpack_require__(261);
	
	var _IconPositionShape2 = _interopRequireDefault(_IconPositionShape);
	
	var _OrientationShape = __webpack_require__(862);
	
	var _OrientationShape2 = _interopRequireDefault(_OrientationShape);
	
	var _AnchorDirectionShape = __webpack_require__(859);
	
	var _AnchorDirectionShape2 = _interopRequireDefault(_AnchorDirectionShape);
	
	var _OpenDirectionShape = __webpack_require__(211);
	
	var _OpenDirectionShape2 = _interopRequireDefault(_OpenDirectionShape);
	
	var _DayOfWeekShape = __webpack_require__(165);
	
	var _DayOfWeekShape2 = _interopRequireDefault(_DayOfWeekShape);
	
	var _CalendarInfoPositionShape = __webpack_require__(260);
	
	var _CalendarInfoPositionShape2 = _interopRequireDefault(_CalendarInfoPositionShape);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = {
	  // required props for a functional interactive SingleDatePicker
	  date: _reactMomentProptypes2['default'].momentObj,
	  onDateChange: _propTypes2['default'].func.isRequired,
	
	  focused: _propTypes2['default'].bool,
	  onFocusChange: _propTypes2['default'].func.isRequired,
	
	  // input related props
	  id: _propTypes2['default'].string.isRequired,
	  placeholder: _propTypes2['default'].string,
	  disabled: _propTypes2['default'].bool,
	  required: _propTypes2['default'].bool,
	  readOnly: _propTypes2['default'].bool,
	  screenReaderInputMessage: _propTypes2['default'].string,
	  showClearDate: _propTypes2['default'].bool,
	  customCloseIcon: _propTypes2['default'].node,
	  showDefaultInputIcon: _propTypes2['default'].bool,
	  inputIconPosition: _IconPositionShape2['default'],
	  customInputIcon: _propTypes2['default'].node,
	  noBorder: _propTypes2['default'].bool,
	  block: _propTypes2['default'].bool,
	  small: _propTypes2['default'].bool,
	  regular: _propTypes2['default'].bool,
	  verticalSpacing: _airbnbPropTypes.nonNegativeInteger,
	  keepFocusOnInput: _propTypes2['default'].bool,
	
	  // calendar presentation and interaction related props
	  renderMonth: _propTypes2['default'].func,
	  orientation: _OrientationShape2['default'],
	  anchorDirection: _AnchorDirectionShape2['default'],
	  openDirection: _OpenDirectionShape2['default'],
	  horizontalMargin: _propTypes2['default'].number,
	  withPortal: _propTypes2['default'].bool,
	  withFullScreenPortal: _propTypes2['default'].bool,
	  appendToBody: _propTypes2['default'].bool,
	  disableScroll: _propTypes2['default'].bool,
	  initialVisibleMonth: _propTypes2['default'].func,
	  firstDayOfWeek: _DayOfWeekShape2['default'],
	  numberOfMonths: _propTypes2['default'].number,
	  keepOpenOnDateSelect: _propTypes2['default'].bool,
	  reopenPickerOnClearDate: _propTypes2['default'].bool,
	  renderCalendarInfo: _propTypes2['default'].func,
	  calendarInfoPosition: _CalendarInfoPositionShape2['default'],
	  hideKeyboardShortcutsPanel: _propTypes2['default'].bool,
	  daySize: _airbnbPropTypes.nonNegativeInteger,
	  isRTL: _propTypes2['default'].bool,
	  verticalHeight: _airbnbPropTypes.nonNegativeInteger,
	  transitionDuration: _airbnbPropTypes.nonNegativeInteger,
	
	  // navigation related props
	  navPrev: _propTypes2['default'].node,
	  navNext: _propTypes2['default'].node,
	
	  onPrevMonthClick: _propTypes2['default'].func,
	  onNextMonthClick: _propTypes2['default'].func,
	  onClose: _propTypes2['default'].func,
	
	  // day presentation and interaction related props
	  renderCalendarDay: _propTypes2['default'].func,
	  renderDayContents: _propTypes2['default'].func,
	  enableOutsideDays: _propTypes2['default'].bool,
	  isDayBlocked: _propTypes2['default'].func,
	  isOutsideRange: _propTypes2['default'].func,
	  isDayHighlighted: _propTypes2['default'].func,
	
	  // internationalization props
	  displayFormat: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].func]),
	  monthFormat: _propTypes2['default'].string,
	  weekDayFormat: _propTypes2['default'].string,
	  phrases: _propTypes2['default'].shape((0, _getPhrasePropTypes2['default'])(_defaultPhrases.SingleDatePickerPhrases)),
	  dayAriaLabelFormat: _propTypes2['default'].string
	};

/***/ },
/* 864 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var core = {
	  white: '#fff',
	  gray: '#484848',
	  grayLight: '#82888a',
	  grayLighter: '#cacccd',
	  grayLightest: '#f2f2f2',
	
	  borderMedium: '#c4c4c4',
	  border: '#dbdbdb',
	  borderLight: '#e4e7e7',
	  borderLighter: '#eceeee',
	  borderBright: '#f4f5f5',
	
	  primary: '#00a699',
	  primaryShade_1: '#33dacd',
	  primaryShade_2: '#66e2da',
	  primaryShade_3: '#80e8e0',
	  primaryShade_4: '#b2f1ec',
	  primary_dark: '#008489',
	
	  secondary: '#007a87',
	
	  yellow: '#ffe8bc',
	  yellow_dark: '#ffce71'
	};
	
	exports['default'] = {
	  reactDates: {
	    zIndex: 0,
	    border: {
	      input: {
	        border: 0,
	        borderTop: 0,
	        borderRight: 0,
	        borderBottom: '2px solid transparent',
	        borderLeft: 0,
	        outlineFocused: 0,
	        borderFocused: 0,
	        borderTopFocused: 0,
	        borderLeftFocused: 0,
	        borderBottomFocused: '2px solid ' + String(core.primary_dark),
	        borderRightFocused: 0,
	        borderRadius: 0
	      }
	    },
	
	    color: {
	      core: core,
	
	      disabled: core.grayLightest,
	
	      background: core.white,
	      backgroundDark: '#f2f2f2',
	      backgroundFocused: core.white,
	      border: 'rgb(219, 219, 219)',
	      text: core.gray,
	      textDisabled: core.border,
	      textFocused: '#007a87',
	      placeholderText: '#757575',
	
	      outside: {
	        backgroundColor: core.white,
	        backgroundColor_active: core.white,
	        backgroundColor_hover: core.white,
	        color: core.gray,
	        color_active: core.gray,
	        color_hover: core.gray
	      },
	
	      highlighted: {
	        backgroundColor: core.yellow,
	        backgroundColor_active: core.yellow_dark,
	        backgroundColor_hover: core.yellow_dark,
	        color: core.gray,
	        color_active: core.gray,
	        color_hover: core.gray
	      },
	
	      minimumNights: {
	        backgroundColor: core.white,
	        backgroundColor_active: core.white,
	        backgroundColor_hover: core.white,
	        borderColor: core.borderLighter,
	        color: core.grayLighter,
	        color_active: core.grayLighter,
	        color_hover: core.grayLighter
	      },
	
	      hoveredSpan: {
	        backgroundColor: core.primaryShade_4,
	        backgroundColor_active: core.primaryShade_3,
	        backgroundColor_hover: core.primaryShade_4,
	        borderColor: core.primaryShade_3,
	        borderColor_active: core.primaryShade_3,
	        borderColor_hover: core.primaryShade_3,
	        color: core.secondary,
	        color_active: core.secondary,
	        color_hover: core.secondary
	      },
	
	      selectedSpan: {
	        backgroundColor: core.primaryShade_2,
	        backgroundColor_active: core.primaryShade_1,
	        backgroundColor_hover: core.primaryShade_1,
	        borderColor: core.primaryShade_1,
	        borderColor_active: core.primary,
	        borderColor_hover: core.primary,
	        color: core.white,
	        color_active: core.white,
	        color_hover: core.white
	      },
	
	      selected: {
	        backgroundColor: core.primary,
	        backgroundColor_active: core.primary,
	        backgroundColor_hover: core.primary,
	        borderColor: core.primary,
	        borderColor_active: core.primary,
	        borderColor_hover: core.primary,
	        color: core.white,
	        color_active: core.white,
	        color_hover: core.white
	      },
	
	      blocked_calendar: {
	        backgroundColor: core.grayLighter,
	        backgroundColor_active: core.grayLighter,
	        backgroundColor_hover: core.grayLighter,
	        borderColor: core.grayLighter,
	        borderColor_active: core.grayLighter,
	        borderColor_hover: core.grayLighter,
	        color: core.grayLight,
	        color_active: core.grayLight,
	        color_hover: core.grayLight
	      },
	
	      blocked_out_of_range: {
	        backgroundColor: core.white,
	        backgroundColor_active: core.white,
	        backgroundColor_hover: core.white,
	        borderColor: core.borderLight,
	        borderColor_active: core.borderLight,
	        borderColor_hover: core.borderLight,
	        color: core.grayLighter,
	        color_active: core.grayLighter,
	        color_hover: core.grayLighter
	      }
	    },
	
	    spacing: {
	      captionPaddingTop: 22,
	      captionPaddingBottom: 37,
	      inputPadding: 0,
	      displayTextPaddingVertical: undefined,
	      displayTextPaddingTop: 11,
	      displayTextPaddingBottom: 9,
	      displayTextPaddingHorizontal: undefined,
	      displayTextPaddingLeft: 11,
	      displayTextPaddingRight: 11,
	      displayTextPaddingVertical_small: undefined,
	      displayTextPaddingTop_small: 7,
	      displayTextPaddingBottom_small: 5,
	      displayTextPaddingHorizontal_small: undefined,
	      displayTextPaddingLeft_small: 7,
	      displayTextPaddingRight_small: 7
	    },
	
	    sizing: {
	      inputWidth: 130,
	      inputWidth_small: 97,
	      arrowWidth: 24
	    },
	
	    font: {
	      size: 14,
	      captionSize: 18,
	      input: {
	        size: 19,
	        lineHeight: '24px',
	        size_small: 15,
	        lineHeight_small: '18px',
	        letterSpacing_small: '0.2px',
	        styleDisabled: 'italic'
	      }
	    }
	  }
	};

/***/ },
/* 865 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = calculateDimension;
	function calculateDimension(el, axis) {
	  var borderBox = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	  var withMargin = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	  if (!el) {
	    return 0;
	  }
	
	  var axisStart = axis === 'width' ? 'Left' : 'Top';
	  var axisEnd = axis === 'width' ? 'Right' : 'Bottom';
	
	  // Only read styles if we need to
	  var style = !borderBox || withMargin ? window.getComputedStyle(el) : null;
	
	  // Offset includes border and padding
	  var offsetWidth = el.offsetWidth,
	      offsetHeight = el.offsetHeight;
	
	  var size = axis === 'width' ? offsetWidth : offsetHeight;
	
	  // Get the inner size
	  if (!borderBox) {
	    size -= parseFloat(style['padding' + axisStart]) + parseFloat(style['padding' + axisEnd]) + parseFloat(style['border' + axisStart + 'Width']) + parseFloat(style['border' + axisEnd + 'Width']);
	  }
	
	  // Apply margin
	  if (withMargin) {
	    size += parseFloat(style['margin' + axisStart]) + parseFloat(style['margin' + axisEnd]);
	  }
	
	  return size;
	}

/***/ },
/* 866 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getScrollParent = getScrollParent;
	exports.getScrollAncestorsOverflowY = getScrollAncestorsOverflowY;
	exports['default'] = disableScroll;
	var getScrollingRoot = function getScrollingRoot() {
	  return document.scrollingElement || document.documentElement;
	};
	
	/**
	 * Recursively finds the scroll parent of a node. The scroll parrent of a node
	 * is the closest node that is scrollable. A node is scrollable if:
	 *  - it is allowed to scroll via CSS ('overflow-y' not visible or hidden);
	 *  - and its children/content are "bigger" than the node's box height.
	 *
	 * The root of the document always scrolls by default.
	 *
	 * @param {HTMLElement} node Any DOM element.
	 * @return {HTMLElement} The scroll parent element.
	 */
	function getScrollParent(node) {
	  var parent = node.parentElement;
	
	  if (parent == null) return getScrollingRoot();
	
	  var _window$getComputedSt = window.getComputedStyle(parent),
	      overflowY = _window$getComputedSt.overflowY;
	
	  var canScroll = overflowY !== 'visible' && overflowY !== 'hidden';
	
	  if (canScroll && parent.scrollHeight > parent.clientHeight) {
	    return parent;
	  }
	
	  return getScrollParent(parent);
	}
	
	/**
	 * Recursively traverses the tree upwards from the given node, capturing all
	 * ancestor nodes that scroll along with their current 'overflow-y' CSS
	 * property.
	 *
	 * @param {HTMLElement} node Any DOM element.
	 * @param {Map<HTMLElement,string>} [acc] Accumulator map.
	 * @return {Map<HTMLElement,string>} Map of ancestors with their 'overflow-y' value.
	 */
	function getScrollAncestorsOverflowY(node) {
	  var acc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Map();
	
	  var scrollingRoot = getScrollingRoot();
	  var scrollParent = getScrollParent(node);
	  acc.set(scrollParent, scrollParent.style.overflowY);
	
	  if (scrollParent === scrollingRoot) return acc;
	  return getScrollAncestorsOverflowY(scrollParent, acc);
	}
	
	/**
	 * Disabling the scroll on a node involves finding all the scrollable ancestors
	 * and set their 'overflow-y' CSS property to 'hidden'. When all ancestors have
	 * 'overflow-y: hidden' (up to the document element) there is no scroll
	 * container, thus all the scroll outside of the node is disabled. In order to
	 * enable scroll again, we store the previous value of the 'overflow-y' for
	 * every ancestor in a closure and reset it back.
	 *
	 * @param {HTMLElement} node Any DOM element.
	 */
	function disableScroll(node) {
	  var scrollAncestorsOverflowY = getScrollAncestorsOverflowY(node);
	  var toggle = function toggle(on) {
	    return scrollAncestorsOverflowY.forEach(function (overflowY, ancestor) {
	      ancestor.style.setProperty('overflow-y', on ? 'hidden' : overflowY);
	    });
	  };
	
	  toggle(true);
	  return function () {
	    return toggle(false);
	  };
	}

/***/ },
/* 867 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = getCalendarDaySettings;
	
	var _getPhrase = __webpack_require__(2981);
	
	var _getPhrase2 = _interopRequireDefault(_getPhrase);
	
	var _constants = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getCalendarDaySettings(day, ariaLabelFormat, daySize, modifiers, phrases) {
	  var chooseAvailableDate = phrases.chooseAvailableDate,
	      dateIsUnavailable = phrases.dateIsUnavailable,
	      dateIsSelected = phrases.dateIsSelected;
	
	
	  var daySizeStyles = {
	    width: daySize,
	    height: daySize - 1
	  };
	
	  var useDefaultCursor = modifiers.has('blocked-minimum-nights') || modifiers.has('blocked-calendar') || modifiers.has('blocked-out-of-range');
	
	  var selected = modifiers.has('selected') || modifiers.has('selected-start') || modifiers.has('selected-end');
	
	  var hoveredSpan = !selected && (modifiers.has('hovered-span') || modifiers.has('after-hovered-start'));
	
	  var isOutsideRange = modifiers.has('blocked-out-of-range');
	
	  var formattedDate = { date: day.format(ariaLabelFormat) };
	
	  var ariaLabel = (0, _getPhrase2['default'])(chooseAvailableDate, formattedDate);
	  if (modifiers.has(_constants.BLOCKED_MODIFIER)) {
	    ariaLabel = (0, _getPhrase2['default'])(dateIsUnavailable, formattedDate);
	  } else if (selected) {
	    ariaLabel = (0, _getPhrase2['default'])(dateIsSelected, formattedDate);
	  }
	
	  return {
	    daySizeStyles: daySizeStyles,
	    useDefaultCursor: useDefaultCursor,
	    selected: selected,
	    hoveredSpan: hoveredSpan,
	    isOutsideRange: isOutsideRange,
	    ariaLabel: ariaLabel
	  };
	}

/***/ },
/* 868 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = getCalendarMonthWidth;
	var CALENDAR_MONTH_PADDING = 9;
	
	function getCalendarMonthWidth(daySize) {
	  return 7 * (daySize + 1) + 2 * (CALENDAR_MONTH_PADDING + 1);
	}

/***/ },
/* 869 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = getDetachedContainerStyles;
	
	var _constants = __webpack_require__(30);
	
	/**
	 * Calculate and return a CSS transform style to position a detached element
	 * next to a reference element. The open and anchor direction indicate wether
	 * it should be positioned above/below and/or to the left/right of the
	 * reference element.
	 *
	 * Assuming r(0,0), r(1,1), d(0,0), d(1,1) for the bottom-left and top-right
	 * corners of the reference and detached elements, respectively:
	 *  - openDirection = DOWN, anchorDirection = LEFT => d(0,1) == r(0,1)
	 *  - openDirection = UP, anchorDirection = LEFT => d(0,0) == r(0,0)
	 *  - openDirection = DOWN, anchorDirection = RIGHT => d(1,1) == r(1,1)
	 *  - openDirection = UP, anchorDirection = RIGHT => d(1,0) == r(1,0)
	 *
	 * By using a CSS transform, we allow to further position it using
	 * top/bottom CSS properties for the anchor gutter.
	 *
	 * @param {string} openDirection The vertical positioning of the popup
	 * @param {string} anchorDirection The horizontal position of the popup
	 * @param {HTMLElement} referenceEl The reference element
	 */
	function getDetachedContainerStyles(openDirection, anchorDirection, referenceEl) {
	  var referenceRect = referenceEl.getBoundingClientRect();
	  var offsetX = referenceRect.left;
	  var offsetY = referenceRect.top;
	
	  if (openDirection === _constants.OPEN_UP) {
	    offsetY = -(window.innerHeight - referenceRect.bottom);
	  }
	
	  if (anchorDirection === _constants.ANCHOR_RIGHT) {
	    offsetX = -(window.innerWidth - referenceRect.right);
	  }
	
	  return {
	    transform: 'translate3d(' + String(Math.round(offsetX)) + 'px, ' + String(Math.round(offsetY)) + 'px, 0)'
	  };
	}

/***/ },
/* 870 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = getResponsiveContainerStyles;
	
	var _constants = __webpack_require__(30);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function getResponsiveContainerStyles(anchorDirection, currentOffset, containerEdge, margin) {
	  var windowWidth = typeof window !== 'undefined' ? window.innerWidth : 0;
	  var calculatedOffset = anchorDirection === _constants.ANCHOR_LEFT ? windowWidth - containerEdge : containerEdge;
	  var calculatedMargin = margin || 0;
	
	  return _defineProperty({}, anchorDirection, Math.min(currentOffset + calculatedOffset - calculatedMargin, 0));
	}

/***/ },
/* 871 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = getVisibleDays;
	
	var _moment = __webpack_require__(9);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _toISOMonthString = __webpack_require__(341);
	
	var _toISOMonthString2 = _interopRequireDefault(_toISOMonthString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getVisibleDays(month, numberOfMonths, enableOutsideDays, withoutTransitionMonths) {
	  if (!_moment2['default'].isMoment(month)) return {};
	
	  var visibleDaysByMonth = {};
	  var currentMonth = withoutTransitionMonths ? month.clone() : month.clone().subtract(1, 'month');
	  for (var i = 0; i < (withoutTransitionMonths ? numberOfMonths : numberOfMonths + 2); i += 1) {
	    var visibleDays = [];
	
	    // set utc offset to get correct dates in future (when timezone changes)
	    var baseDate = currentMonth.clone();
	    var firstOfMonth = baseDate.clone().startOf('month').hour(12);
	    var lastOfMonth = baseDate.clone().endOf('month').hour(12);
	
	    var currentDay = firstOfMonth.clone();
	
	    // days belonging to the previous month
	    if (enableOutsideDays) {
	      for (var j = 0; j < currentDay.weekday(); j += 1) {
	        var prevDay = currentDay.clone().subtract(j + 1, 'day');
	        visibleDays.unshift(prevDay);
	      }
	    }
	
	    while (currentDay < lastOfMonth) {
	      visibleDays.push(currentDay.clone());
	      currentDay.add(1, 'day');
	    }
	
	    if (enableOutsideDays) {
	      // weekday() returns the index of the day of the week according to the locale
	      // this means if the week starts on Monday, weekday() will return 0 for a Monday date, not 1
	      if (currentDay.weekday() !== 0) {
	        // days belonging to the next month
	        for (var k = currentDay.weekday(), count = 0; k < 7; k += 1, count += 1) {
	          var nextDay = currentDay.clone().add(count, 'day');
	          visibleDays.push(nextDay);
	        }
	      }
	    }
	
	    visibleDaysByMonth[(0, _toISOMonthString2['default'])(currentMonth)] = visibleDays;
	    currentMonth = currentMonth.clone().add(1, 'month');
	  }
	
	  return visibleDaysByMonth;
	}

/***/ },
/* 872 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = isNextDay;
	
	var _moment = __webpack_require__(9);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _isSameDay = __webpack_require__(214);
	
	var _isSameDay2 = _interopRequireDefault(_isSameDay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function isNextDay(a, b) {
	  if (!_moment2['default'].isMoment(a) || !_moment2['default'].isMoment(b)) return false;
	  var nextDay = (0, _moment2['default'])(a).add(1, 'day');
	  return (0, _isSameDay2['default'])(nextDay, b);
	}

/***/ },
/* 873 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridColumn: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ },
/* 874 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(32);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__(166);
	
	var invariant = __webpack_require__(19);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ },
/* 875 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(217);
	var ReactDOMComponentTree = __webpack_require__(44);
	var ReactInstrumentation = __webpack_require__(81);
	
	var quoteAttributeValueForBrowser = __webpack_require__(3046);
	var warning = __webpack_require__(26);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	
	};
	
	module.exports = DOMPropertyOperations;

/***/ },
/* 876 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(44);
	var ReactDefaultInjection = __webpack_require__(881);
	var ReactMount = __webpack_require__(887);
	var ReactReconciler = __webpack_require__(167);
	var ReactUpdates = __webpack_require__(89);
	var ReactVersion = __webpack_require__(890);
	
	var findDOMNode = __webpack_require__(3040);
	var getHostComponentFromComposite = __webpack_require__(893);
	var renderSubtreeIntoContainer = __webpack_require__(3047);
	var warning = __webpack_require__(26);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, 'It looks like you\'re using a minified copy of the development build ' + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ },
/* 877 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ },
/* 878 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(492);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ },
/* 879 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(29);
	
	var LinkedValueUtils = __webpack_require__(480);
	var ReactDOMComponentTree = __webpack_require__(44);
	var ReactUpdates = __webpack_require__(89);
	
	var warning = __webpack_require__(26);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ },
/* 880 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(29);
	
	var ReactUpdates = __webpack_require__(89);
	var Transaction = __webpack_require__(345);
	
	var emptyFunction = __webpack_require__(80);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 881 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(2988);
	var BeforeInputEventPlugin = __webpack_require__(2990);
	var ChangeEventPlugin = __webpack_require__(2992);
	var DefaultEventPluginOrder = __webpack_require__(2994);
	var EnterLeaveEventPlugin = __webpack_require__(2995);
	var HTMLDOMPropertyConfig = __webpack_require__(2998);
	var ReactComponentBrowserEnvironment = __webpack_require__(3000);
	var ReactDOMComponent = __webpack_require__(3002);
	var ReactDOMComponentTree = __webpack_require__(44);
	var ReactDOMEmptyComponent = __webpack_require__(3003);
	var ReactDOMTreeTraversal = __webpack_require__(3012);
	var ReactDOMTextComponent = __webpack_require__(3010);
	var ReactDefaultBatchingStrategy = __webpack_require__(880);
	var ReactEventListener = __webpack_require__(3015);
	var ReactInjection = __webpack_require__(3016);
	var ReactReconcileTransaction = __webpack_require__(3020);
	var SVGDOMPropertyConfig = __webpack_require__(3025);
	var SelectEventPlugin = __webpack_require__(3026);
	var SimpleEventPlugin = __webpack_require__(3027);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ },
/* 882 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ },
/* 883 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ },
/* 884 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(32),
	    _assign = __webpack_require__(29);
	
	var invariant = __webpack_require__(19);
	
	var genericComponentClass = null;
	// This registry keeps track of wrapper classes around host tags.
	var tagToComponentClass = {};
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  },
	  // This accepts a keyed object with classes as values. Each key represents a
	  // tag. That particular tag will use this class instead of the generic one.
	  injectComponentClasses: function (componentClasses) {
	    _assign(tagToComponentClass, componentClasses);
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ },
/* 885 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(3008);
	
	var containsNode = __webpack_require__(2768);
	var focusNode = __webpack_require__(705);
	var getActiveElement = __webpack_require__(706);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ },
/* 886 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(3038);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ },
/* 887 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(32);
	
	var DOMLazyTree = __webpack_require__(216);
	var DOMProperty = __webpack_require__(217);
	var React = __webpack_require__(105);
	var ReactBrowserEventEmitter = __webpack_require__(343);
	var ReactCurrentOwner = __webpack_require__(113);
	var ReactDOMComponentTree = __webpack_require__(44);
	var ReactDOMContainerInfo = __webpack_require__(878);
	var ReactDOMFeatureFlags = __webpack_require__(3004);
	var ReactFeatureFlags = __webpack_require__(883);
	var ReactInstanceMap = __webpack_require__(220);
	var ReactInstrumentation = __webpack_require__(81);
	var ReactMarkupChecksum = __webpack_require__(886);
	var ReactReconciler = __webpack_require__(167);
	var ReactUpdateQueue = __webpack_require__(483);
	var ReactUpdates = __webpack_require__(89);
	
	var emptyObject = __webpack_require__(203);
	var instantiateReactComponent = __webpack_require__(489);
	var invariant = __webpack_require__(19);
	var setInnerHTML = __webpack_require__(347);
	var shouldUpdateReactComponent = __webpack_require__(491);
	var warning = __webpack_require__(26);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' :
	    // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, { child: nextElement });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ },
/* 888 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(32);
	
	var React = __webpack_require__(105);
	
	var invariant = __webpack_require__(19);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ },
/* 889 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(29);
	
	var PooledClass = __webpack_require__(166);
	var Transaction = __webpack_require__(345);
	var ReactInstrumentation = __webpack_require__(81);
	var ReactServerUpdateQueue = __webpack_require__(3024);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ },
/* 890 */
3123,
/* 891 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(32);
	
	var invariant = __webpack_require__(19);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ },
/* 892 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ },
/* 893 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(888);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ },
/* 894 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(53);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ },
/* 895 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(53);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ },
/* 896 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  'color': true,
	  'date': true,
	  'datetime': true,
	  'datetime-local': true,
	  'email': true,
	  'month': true,
	  'number': true,
	  'password': true,
	  'range': true,
	  'search': true,
	  'tel': true,
	  'text': true,
	  'time': true,
	  'url': true,
	  'week': true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ },
/* 897 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(53);
	var escapeTextContentForBrowser = __webpack_require__(346);
	var setInnerHTML = __webpack_require__(347);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ },
/* 898 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(32);
	
	var ReactCurrentOwner = __webpack_require__(113);
	var REACT_ELEMENT_TYPE = __webpack_require__(3013);
	
	var getIteratorFn = __webpack_require__(3043);
	var invariant = __webpack_require__(19);
	var KeyEscapeUtils = __webpack_require__(479);
	var warning = __webpack_require__(26);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 899 */
/***/ function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSideEffect = __webpack_require__(3091);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(2431);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _objectAssign = __webpack_require__(29);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(3049);
	
	var _PlainComponent = __webpack_require__(3050);
	
	var _PlainComponent2 = _interopRequireDefault(_PlainComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var HELMET_ATTRIBUTE = "data-react-helmet";
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props[property]) {
	            return props[property];
	        }
	    }
	    return null;
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, "title");
	    var innermostTemplate = getInnermostProperty(propsList, "titleTemplate");
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, "defaultTitle");
	
	    return innermostTitle || innermostDefaultTitle || "";
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, "onChangeClientState") || function () {};
	};
	
	var getHtmlAttributesFromPropsList = function getHtmlAttributesFromPropsList(propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.HTML] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.HTML];
	    }).reduce(function (html, current) {
	        return _extends({}, html, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    var tagList = propsList.filter(function (props) {
	        return typeof props[tagName] !== "undefined";
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	
	    return tagList;
	};
	
	var updateTitle = function updateTitle(title) {
	    document.title = title || document.title;
	};
	
	var updateHtmlAttributes = function updateHtmlAttributes(attributes) {
	    var htmlTag = document.getElementsByTagName("html")[0];
	    var helmetAttributeString = htmlTag.getAttribute(HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	        htmlTag.setAttribute(attribute, value);
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        htmlTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        htmlTag.removeAttribute(HELMET_ATTRIBUTE);
	    } else {
	        htmlTag.setAttribute(HELMET_ATTRIBUTE, helmetAttributes.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector("head");
	    var tagNodes = headElement.querySelectorAll(type + "[" + HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === "innerHTML") {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === "cssText") {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateHtmlAttributesAsString = function generateHtmlAttributesAsString(attributes) {
	    var keys = Object.keys(attributes);
	    var attributeString = "";
	
	    for (var i = 0; i < keys.length; i++) {
	        var attribute = keys[i];
	        var attr = typeof attributes[attribute] !== "undefined" ? attribute + "=\"" + attributes[attribute] + "\"" : "" + attribute;
	        attributeString += attr + " ";
	    }
	
	    return attributeString.trim();
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title) {
	    var stringifiedMarkup = "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(title) + "</" + type + ">";
	
	    return stringifiedMarkup;
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags) {
	    var stringifiedMarkup = tags.map(function (tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === "innerHTML" || attribute === "cssText");
	        }).map(function (attribute) {
	            if (typeof tag[attribute] === "undefined") {
	                return attribute;
	            }
	
	            var encodedValue = encodeSpecialCharacters(tag[attribute]);
	            return attribute + "=\"" + encodedValue + "\"";
	        }).join(" ").trim();
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = [_HelmetConstants.TAG_NAMES.NOSCRIPT, _HelmetConstants.TAG_NAMES.SCRIPT, _HelmetConstants.TAG_NAMES.STYLE].indexOf(type) === -1;
	
	        return "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }).join("");
	
	    return stringifiedMarkup;
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title) {
	    // assigning into an array to define toString function on it
	    var component = [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, _defineProperty({
	        key: title
	    }, HELMET_ATTRIBUTE, true), title)];
	
	    return component;
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    /* eslint-disable react/display-name */
	    var component = tags.map(function (tag, i) {
	        var mappedTag = _defineProperty({
	            key: i
	        }, HELMET_ATTRIBUTE, true);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === "innerHTML" || mappedAttribute === "cssText") {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	
	    return component;
	    /* eslint-enable react/display-name */
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags);
	                }
	            };
	        case _HelmetConstants.TAG_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return tags;
	                },
	                toString: function toString() {
	                    return generateHtmlAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var htmlAttributes = _ref.htmlAttributes,
	        title = _ref.title,
	        baseTag = _ref.baseTag,
	        metaTags = _ref.metaTags,
	        linkTags = _ref.linkTags,
	        scriptTags = _ref.scriptTags,
	        noscriptTags = _ref.noscriptTags,
	        styleTags = _ref.styleTags;
	    return {
	        htmlAttributes: getMethodsForTag(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, title),
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	};
	
	var Helmet = function Helmet(Component) {
	    /* eslint-disable react/no-multi-comp */
	    var HelmetWrapper = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, (HelmetWrapper.__proto__ || Object.getPrototypeOf(HelmetWrapper)).apply(this, arguments));
	        }
	
	        _createClass(HelmetWrapper, [{
	            key: "shouldComponentUpdate",
	            value: function shouldComponentUpdate(nextProps) {
	                return !(0, _deepEqual2.default)(this.props, nextProps);
	            }
	        }, {
	            key: "render",
	            value: function render() {
	                return _react2.default.createElement(Component, this.props);
	            }
	        }], [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	            /**
	             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	             * @param {String} title: "Title"
	             * @param {String} defaultTitle: "Default Title"
	             * @param {String} titleTemplate: "MySite.com - %s"
	             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	             * @param {Array} style: [{"type": "text/css", "cssText": "div{ display: block; color: blue; }"}]
	             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	             */
	
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component);
	    /* eslint-enable react/no-multi-comp */
	
	    HelmetWrapper.propTypes = {
	        htmlAttributes: _react2.default.PropTypes.object,
	        title: _react2.default.PropTypes.string,
	        defaultTitle: _react2.default.PropTypes.string,
	        titleTemplate: _react2.default.PropTypes.string,
	        base: _react2.default.PropTypes.object,
	        meta: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object),
	        link: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object),
	        script: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object),
	        noscript: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object),
	        style: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object),
	        onChangeClientState: _react2.default.PropTypes.func
	    };
	    HelmetWrapper.peek = Component.peek;
	
	    HelmetWrapper.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = mapStateOnServer({
	                htmlAttributes: {},
	                title: "",
	                baseTag: [],
	                metaTags: [],
	                linkTags: [],
	                scriptTags: [],
	                noscriptTags: [],
	                styleTags: []
	            });
	        }
	
	        return mappedState;
	    };
	
	    return HelmetWrapper;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        htmlAttributes: getHtmlAttributesFromPropsList(propsList),
	        title: getTitleFromPropsList(propsList),
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY], propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        onChangeClientState: getOnChangeClientState(propsList)
	    };
	};
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    var htmlAttributes = newState.htmlAttributes,
	        title = newState.title,
	        baseTag = newState.baseTag,
	        metaTags = newState.metaTags,
	        linkTags = newState.linkTags,
	        scriptTags = newState.scriptTags,
	        noscriptTags = newState.noscriptTags,
	        styleTags = newState.styleTags,
	        onChangeClientState = newState.onChangeClientState;
	
	
	    updateHtmlAttributes(htmlAttributes);
	
	    updateTitle(title);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var SideEffect = (0, _reactSideEffect2.default)(reducePropsToState, handleClientStateChange, mapStateOnServer);
	
	// PlainComponent is used to be a blank component decorated by react-side-effect
	exports.default = Helmet(SideEffect(_PlainComponent2.default));
	module.exports = exports["default"];

/***/ },
/* 900 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactDom = __webpack_require__(104);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Portal = __webpack_require__(3062);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _LegacyPortal = __webpack_require__(3061);
	
	var _LegacyPortal2 = _interopRequireDefault(_LegacyPortal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Portal = void 0;
	
	if (_reactDom2.default.createPortal) {
	  Portal = _Portal2.default;
	} else {
	  Portal = _LegacyPortal2.default;
	}
	
	exports.default = Portal;

/***/ },
/* 901 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PortalWithState = exports.Portal = undefined;
	
	var _PortalCompat = __webpack_require__(900);
	
	var _PortalCompat2 = _interopRequireDefault(_PortalCompat);
	
	var _PortalWithState = __webpack_require__(3063);
	
	var _PortalWithState2 = _interopRequireDefault(_PortalWithState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Portal = _PortalCompat2.default;
	exports.PortalWithState = _PortalWithState2.default;

/***/ },
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */
/***/ function(module, exports) {

	'use strict';
	
	var defaultProps = {
	    className: '',
	    // accessibility: true,
	    adaptiveHeight: false,
	    arrows: true,
	    autoplay: false,
	    autoplaySpeed: 3000,
	    centerMode: false,
	    centerPadding: '50px',
	    cssEase: 'ease',
	    dots: false,
	    dotsClass: 'slick-dots',
	    draggable: true,
	    easing: 'linear',
	    edgeFriction: 0.35,
	    fade: false,
	    focusOnSelect: false,
	    infinite: true,
	    initialSlide: 0,
	    lazyLoad: false,
	    pauseOnHover: false,
	    responsive: null,
	    rtl: false,
	    slide: 'div',
	    slidesToShow: 1,
	    slidesToScroll: 1,
	    speed: 500,
	    swipe: true,
	    swipeToSlide: false,
	    touchMove: true,
	    touchThreshold: 5,
	    useCSS: true,
	    variableWidth: false,
	    vertical: false,
	    waitForAnimate: true,
	    afterChange: null,
	    beforeChange: null,
	    edgeEvent: null,
	    init: null,
	    swipeEvent: null,
	    // nextArrow, prevArrow are react componets
	    nextArrow: null,
	    prevArrow: null
	};
	
	module.exports = defaultProps;

/***/ },
/* 915 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(104);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var ReactDOM = _react2['default'].version >= '0.14.0' ? _reactDom2['default'] : _react2['default'];
	
	exports['default'] = ReactDOM;
	module.exports = exports['default'];

/***/ },
/* 916 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ReactDOM = __webpack_require__(915);
	
	var _ReactDOM2 = _interopRequireDefault(_ReactDOM);
	
	var _reactLibReactTransitionEvents = __webpack_require__(923);
	
	var _reactLibReactTransitionEvents2 = _interopRequireDefault(_reactLibReactTransitionEvents);
	
	var _trackHelper = __webpack_require__(917);
	
	var _objectAssign = __webpack_require__(29);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var helpers = {
	  initialize: function initialize(props) {
	    var slideCount = _react2['default'].Children.count(props.children);
	    var listWidth = this.getWidth(_ReactDOM2['default'].findDOMNode(this.refs.list));
	    var trackWidth = this.getWidth(_ReactDOM2['default'].findDOMNode(this.refs.track));
	    var slideWidth = this.getWidth(_ReactDOM2['default'].findDOMNode(this)) / props.slidesToShow;
	
	    var currentSlide = props.rtl ? slideCount - 1 - props.initialSlide : props.initialSlide;
	
	    this.setState({
	      slideCount: slideCount,
	      slideWidth: slideWidth,
	      listWidth: listWidth,
	      trackWidth: trackWidth,
	      currentSlide: currentSlide
	    }, function () {
	
	      var targetLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2['default'])({
	        slideIndex: this.state.currentSlide,
	        trackRef: this.refs.track
	      }, props, this.state));
	      // getCSS function needs previously set state
	      var trackStyle = (0, _trackHelper.getTrackCSS)((0, _objectAssign2['default'])({ left: targetLeft }, props, this.state));
	
	      this.setState({ trackStyle: trackStyle });
	
	      this.autoPlay(); // once we're set up, trigger the initial autoplay.
	    });
	  },
	  update: function update(props) {
	    // This method has mostly same code as initialize method.
	    // Refactor it
	    var slideCount = _react2['default'].Children.count(props.children);
	    var listWidth = this.getWidth(_ReactDOM2['default'].findDOMNode(this.refs.list));
	    var trackWidth = this.getWidth(_ReactDOM2['default'].findDOMNode(this.refs.track));
	    var slideWidth = this.getWidth(_ReactDOM2['default'].findDOMNode(this)) / props.slidesToShow;
	
	    this.setState({
	      slideCount: slideCount,
	      slideWidth: slideWidth,
	      listWidth: listWidth,
	      trackWidth: trackWidth
	    }, function () {
	
	      var targetLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2['default'])({
	        slideIndex: this.state.currentSlide,
	        trackRef: this.refs.track
	      }, props, this.state));
	      // getCSS function needs previously set state
	      var trackStyle = (0, _trackHelper.getTrackCSS)((0, _objectAssign2['default'])({ left: targetLeft }, props, this.state));
	
	      this.setState({ trackStyle: trackStyle });
	    });
	  },
	  getWidth: function getWidth(elem) {
	    return elem.getBoundingClientRect().width || elem.offsetWidth;
	  },
	  adaptHeight: function adaptHeight() {
	    if (this.props.adaptiveHeight) {
	      var selector = '[data-index="' + this.state.currentSlide + '"]';
	      if (this.refs.list) {
	        var slickList = _ReactDOM2['default'].findDOMNode(this.refs.list);
	        slickList.style.height = slickList.querySelector(selector).offsetHeight + 'px';
	      }
	    }
	  },
	  slideHandler: function slideHandler(index) {
	    var _this = this;
	
	    // Functionality of animateSlide and postSlide is merged into this function
	    // console.log('slideHandler', index);
	    var targetSlide, currentSlide;
	    var targetLeft, currentLeft;
	    var callback;
	
	    if (this.props.waitForAnimate && this.state.animating) {
	      return;
	    }
	
	    if (this.props.fade) {
	      currentSlide = this.state.currentSlide;
	
	      //  Shifting targetSlide back into the range
	      if (index < 0) {
	        targetSlide = index + this.state.slideCount;
	      } else if (index >= this.state.slideCount) {
	        targetSlide = index - this.state.slideCount;
	      } else {
	        targetSlide = index;
	      }
	
	      if (this.props.lazyLoad && this.state.lazyLoadedList.indexOf(targetSlide) < 0) {
	        this.setState({
	          lazyLoadedList: this.state.lazyLoadedList.concat(targetSlide)
	        });
	      }
	
	      callback = function () {
	        _this.setState({
	          animating: false
	        });
	        if (_this.props.afterChange) {
	          _this.props.afterChange(currentSlide);
	        }
	        _reactLibReactTransitionEvents2['default'].removeEndEventListener(_ReactDOM2['default'].findDOMNode(_this.refs.track).children[currentSlide], callback);
	      };
	
	      this.setState({
	        animating: true,
	        currentSlide: targetSlide
	      }, function () {
	        _reactLibReactTransitionEvents2['default'].addEndEventListener(_ReactDOM2['default'].findDOMNode(this.refs.track).children[currentSlide], callback);
	      });
	
	      if (this.props.beforeChange) {
	        this.props.beforeChange(this.state.currentSlide, currentSlide);
	      }
	
	      this.autoPlay();
	      return;
	    }
	
	    targetSlide = index;
	    if (targetSlide < 0) {
	      if (this.props.infinite === false) {
	        currentSlide = 0;
	      } else if (this.state.slideCount % this.props.slidesToScroll !== 0) {
	        currentSlide = this.state.slideCount - this.state.slideCount % this.props.slidesToScroll;
	      } else {
	        currentSlide = this.state.slideCount + targetSlide;
	      }
	    } else if (targetSlide >= this.state.slideCount) {
	      if (this.props.infinite === false) {
	        currentSlide = this.state.slideCount - this.props.slidesToShow;
	      } else if (this.state.slideCount % this.props.slidesToScroll !== 0) {
	        currentSlide = 0;
	      } else {
	        currentSlide = targetSlide - this.state.slideCount;
	      }
	    } else {
	      currentSlide = targetSlide;
	    }
	
	    targetLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2['default'])({
	      slideIndex: targetSlide,
	      trackRef: this.refs.track
	    }, this.props, this.state));
	
	    currentLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2['default'])({
	      slideIndex: currentSlide,
	      trackRef: this.refs.track
	    }, this.props, this.state));
	
	    if (this.props.infinite === false) {
	      targetLeft = currentLeft;
	    }
	
	    if (this.props.beforeChange) {
	      this.props.beforeChange(this.state.currentSlide, currentSlide);
	    }
	
	    if (this.props.lazyLoad) {
	      var loaded = true;
	      var slidesToLoad = [];
	      for (var i = targetSlide; i < targetSlide + this.props.slidesToShow; i++) {
	        loaded = loaded && this.state.lazyLoadedList.indexOf(i) >= 0;
	        if (!loaded) {
	          slidesToLoad.push(i);
	        }
	      }
	      if (!loaded) {
	        this.setState({
	          lazyLoadedList: this.state.lazyLoadedList.concat(slidesToLoad)
	        });
	      }
	    }
	
	    // Slide Transition happens here.
	    // animated transition happens to target Slide and
	    // non - animated transition happens to current Slide
	    // If CSS transitions are false, directly go the current slide.
	
	    if (this.props.useCSS === false) {
	
	      this.setState({
	        currentSlide: currentSlide,
	        trackStyle: (0, _trackHelper.getTrackCSS)((0, _objectAssign2['default'])({ left: currentLeft }, this.props, this.state))
	      }, function () {
	        if (this.props.afterChange) {
	          this.props.afterChange(currentSlide);
	        }
	      });
	    } else {
	
	      var nextStateChanges = {
	        animating: false,
	        currentSlide: currentSlide,
	        trackStyle: (0, _trackHelper.getTrackCSS)((0, _objectAssign2['default'])({ left: currentLeft }, this.props, this.state)),
	        swipeLeft: null
	      };
	
	      callback = function () {
	        _this.setState(nextStateChanges);
	        if (_this.props.afterChange) {
	          _this.props.afterChange(currentSlide);
	        }
	        _reactLibReactTransitionEvents2['default'].removeEndEventListener(_ReactDOM2['default'].findDOMNode(_this.refs.track), callback);
	      };
	
	      this.setState({
	        animating: true,
	        currentSlide: currentSlide,
	        trackStyle: (0, _trackHelper.getTrackAnimateCSS)((0, _objectAssign2['default'])({ left: targetLeft }, this.props, this.state))
	      }, function () {
	        _reactLibReactTransitionEvents2['default'].addEndEventListener(_ReactDOM2['default'].findDOMNode(this.refs.track), callback);
	      });
	    }
	
	    this.autoPlay();
	  },
	  swipeDirection: function swipeDirection(touchObject) {
	    var xDist, yDist, r, swipeAngle;
	
	    xDist = touchObject.startX - touchObject.curX;
	    yDist = touchObject.startY - touchObject.curY;
	    r = Math.atan2(yDist, xDist);
	
	    swipeAngle = Math.round(r * 180 / Math.PI);
	    if (swipeAngle < 0) {
	      swipeAngle = 360 - Math.abs(swipeAngle);
	    }
	    if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
	      return this.props.rtl === false ? 'left' : 'right';
	    }
	    if (swipeAngle >= 135 && swipeAngle <= 225) {
	      return this.props.rtl === false ? 'right' : 'left';
	    }
	
	    return 'vertical';
	  },
	  autoPlay: function autoPlay() {
	    var _this2 = this;
	
	    if (this.state.autoPlayTimer) {
	      return;
	    }
	    var play = function play() {
	      if (_this2.state.mounted) {
	        var nextIndex = _this2.props.rtl ? _this2.state.currentSlide - _this2.props.slidesToScroll : _this2.state.currentSlide + _this2.props.slidesToScroll;
	        _this2.slideHandler(nextIndex);
	      }
	    };
	    if (this.props.autoplay) {
	      this.setState({
	        autoPlayTimer: window.setInterval(play, this.props.autoplaySpeed)
	      });
	    }
	  },
	  pause: function pause() {
	    if (this.state.autoPlayTimer) {
	      window.clearInterval(this.state.autoPlayTimer);
	      this.setState({
	        autoPlayTimer: null
	      });
	    }
	  }
	};
	
	exports['default'] = helpers;
	module.exports = exports['default'];

/***/ },
/* 917 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _ReactDOM = __webpack_require__(915);
	
	var _ReactDOM2 = _interopRequireDefault(_ReactDOM);
	
	var checkSpecKeys = function checkSpecKeys(spec, keysArray) {
	  return keysArray.reduce(function (value, key) {
	    return value && spec.hasOwnProperty(key);
	  }, true) ? null : console.error('Keys Missing', spec);
	};
	
	var getTrackCSS = function getTrackCSS(spec) {
	  checkSpecKeys(spec, ['left', 'variableWidth', 'slideCount', 'slidesToShow', 'slideWidth']);
	
	  var trackWidth;
	
	  if (spec.variableWidth) {
	    trackWidth = (spec.slideCount + 2 * spec.slidesToShow) * spec.slideWidth;
	  } else if (spec.centerMode) {
	    trackWidth = (spec.slideCount + 2 * (spec.slidesToShow + 1)) * spec.slideWidth;
	  } else {
	    trackWidth = (spec.slideCount + 2 * spec.slidesToShow) * spec.slideWidth;
	  }
	
	  var style = {
	    opacity: 1,
	    width: trackWidth,
	    WebkitTransform: 'translate3d(' + spec.left + 'px, 0px, 0px)',
	    transform: 'translate3d(' + spec.left + 'px, 0px, 0px)',
	    transition: '',
	    WebkitTransition: '',
	    msTransform: 'translateX(' + spec.left + 'px)'
	  };
	
	  // Fallback for IE8
	  if (!window.addEventListener && window.attachEvent) {
	    style.marginLeft = spec.left + 'px';
	  }
	
	  return style;
	};
	
	exports.getTrackCSS = getTrackCSS;
	var getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
	  checkSpecKeys(spec, ['left', 'variableWidth', 'slideCount', 'slidesToShow', 'slideWidth', 'speed', 'cssEase']);
	
	  var style = getTrackCSS(spec);
	  // useCSS is true by default so it can be undefined
	  style.WebkitTransition = '-webkit-transform ' + spec.speed + 'ms ' + spec.cssEase;
	  style.transition = 'transform ' + spec.speed + 'ms ' + spec.cssEase;
	  return style;
	};
	
	exports.getTrackAnimateCSS = getTrackAnimateCSS;
	var getTrackLeft = function getTrackLeft(spec) {
	
	  checkSpecKeys(spec, ['slideIndex', 'trackRef', 'infinite', 'centerMode', 'slideCount', 'slidesToShow', 'slidesToScroll', 'slideWidth', 'listWidth', 'variableWidth']);
	
	  var slideOffset = 0;
	  var targetLeft;
	  var targetSlide;
	
	  if (spec.fade) {
	    return 0;
	  }
	
	  if (spec.infinite) {
	    if (spec.slideCount > spec.slidesToShow) {
	      slideOffset = spec.slideWidth * spec.slidesToShow * -1;
	    }
	    if (spec.slideCount % spec.slidesToScroll !== 0) {
	      if (spec.slideIndex + spec.slidesToScroll > spec.slideCount && spec.slideCount > spec.slidesToShow) {
	        if (spec.slideIndex > spec.slideCount) {
	          slideOffset = (spec.slidesToShow - (spec.slideIndex - spec.slideCount)) * spec.slideWidth * -1;
	        } else {
	          slideOffset = spec.slideCount % spec.slidesToScroll * spec.slideWidth * -1;
	        }
	      }
	    }
	  }
	
	  if (spec.centerMode) {
	    if (spec.infinite) {
	      slideOffset += spec.slideWidth * Math.floor(spec.slidesToShow / 2);
	    } else {
	      slideOffset = spec.slideWidth * Math.floor(spec.slidesToShow / 2);
	    }
	  }
	
	  targetLeft = spec.slideIndex * spec.slideWidth * -1 + slideOffset;
	
	  if (spec.variableWidth === true) {
	    var targetSlideIndex;
	    if (spec.slideCount <= spec.slidesToShow || spec.infinite === false) {
	      targetSlide = _ReactDOM2['default'].findDOMNode(spec.trackRef).childNodes[spec.slideIndex];
	    } else {
	      targetSlideIndex = spec.slideIndex + spec.slidesToShow;
	      targetSlide = _ReactDOM2['default'].findDOMNode(spec.trackRef).childNodes[targetSlideIndex];
	    }
	    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
	    if (spec.centerMode === true) {
	      if (spec.infinite === false) {
	        targetSlide = _ReactDOM2['default'].findDOMNode(spec.trackRef).children[spec.slideIndex];
	      } else {
	        targetSlide = _ReactDOM2['default'].findDOMNode(spec.trackRef).children[spec.slideIndex + spec.slidesToShow + 1];
	      }
	
	      targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
	      targetLeft += (spec.listWidth - targetSlide.offsetWidth) / 2;
	    }
	  }
	
	  return targetLeft;
	};
	exports.getTrackLeft = getTrackLeft;

/***/ },
/* 918 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var styleInterface = void 0;
	var styleTheme = void 0;
	
	function registerTheme(theme) {
	  styleTheme = theme;
	}
	
	function registerInterface(interfaceToRegister) {
	  styleInterface = interfaceToRegister;
	}
	
	function create(makeFromTheme, createWithDirection) {
	  var styles = createWithDirection(makeFromTheme(styleTheme));
	  return function () {
	    return styles;
	  };
	}
	
	function createLTR(makeFromTheme) {
	  return create(makeFromTheme, styleInterface.createLTR || styleInterface.create);
	}
	
	function createRTL(makeFromTheme) {
	  return create(makeFromTheme, styleInterface.createRTL || styleInterface.create);
	}
	
	function get() {
	  return styleTheme;
	}
	
	function resolve() {
	  if (false) {
	    performance.mark('react-with-styles.resolve.start');
	  }
	
	  for (var _len = arguments.length, styles = Array(_len), _key = 0; _key < _len; _key++) {
	    styles[_key] = arguments[_key];
	  }
	
	  var result = styleInterface.resolve(styles);
	
	  if (false) {
	    performance.mark('react-with-styles.resolve.end');
	
	    performance.measure('\uD83D\uDC69\u200D\uD83C\uDFA8 [resolve]', 'react-with-styles.resolve.start', 'react-with-styles.resolve.end');
	  }
	
	  return result;
	}
	
	function resolveLTR() {
	  for (var _len2 = arguments.length, styles = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    styles[_key2] = arguments[_key2];
	  }
	
	  if (styleInterface.resolveLTR) {
	    return styleInterface.resolveLTR(styles);
	  }
	
	  return resolve(styles);
	}
	
	function resolveRTL() {
	  for (var _len3 = arguments.length, styles = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	    styles[_key3] = arguments[_key3];
	  }
	
	  if (styleInterface.resolveRTL) {
	    return styleInterface.resolveRTL(styles);
	  }
	
	  return resolve(styles);
	}
	
	function flush() {
	  if (styleInterface.flush) {
	    styleInterface.flush();
	  }
	}
	
	exports['default'] = {
	  registerTheme: registerTheme,
	  registerInterface: registerInterface,
	  create: createLTR,
	  createLTR: createLTR,
	  createRTL: createRTL,
	  get: get,
	  resolve: resolveLTR,
	  resolveLTR: resolveLTR,
	  resolveRTL: resolveRTL,
	  flush: flush
	};

/***/ },
/* 919 */,
/* 920 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOM = __webpack_require__(876);
	var ReactInstanceMap = __webpack_require__(220);
	
	exports.getReactDOM = function () {
	  return ReactDOM;
	};
	
	exports.getReactInstanceMap = function () {
	  return ReactInstanceMap;
	};
	
	if (false) {
	  var ReactPerf = require('react-dom/lib/ReactPerf');
	  var ReactTestUtils = require('react-dom/lib/ReactTestUtils');
	
	  exports.getReactPerf = function () {
	    return ReactPerf;
	  };
	
	  exports.getReactTestUtils = function () {
	    return ReactTestUtils;
	  };
	}

/***/ },
/* 921 */,
/* 922 */,
/* 923 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(53);
	
	var getVendorPrefixedEventName = __webpack_require__(895);
	
	var endEvents = [];
	
	function detectEvents() {
	  var animEnd = getVendorPrefixedEventName('animationend');
	  var transEnd = getVendorPrefixedEventName('transitionend');
	
	  if (animEnd) {
	    endEvents.push(animEnd);
	  }
	
	  if (transEnd) {
	    endEvents.push(transEnd);
	  }
	}
	
	if (ExecutionEnvironment.canUseDOM) {
	  detectEvents();
	}
	
	// We use the raw {add|remove}EventListener() call because EventListener
	// does not know how to remove event listeners and we really should
	// clean up. Also, these events are not triggered in older browsers
	// so we should be A-OK here.
	
	function addEventListener(node, eventName, eventListener) {
	  node.addEventListener(eventName, eventListener, false);
	}
	
	function removeEventListener(node, eventName, eventListener) {
	  node.removeEventListener(eventName, eventListener, false);
	}
	
	var ReactTransitionEvents = {
	  addEndEventListener: function (node, eventListener) {
	    if (endEvents.length === 0) {
	      // If CSS transitions are not supported, trigger an "end animation"
	      // event immediately.
	      window.setTimeout(eventListener, 0);
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      addEventListener(node, endEvent, eventListener);
	    });
	  },
	
	  removeEndEventListener: function (node, eventListener) {
	    if (endEvents.length === 0) {
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      removeEventListener(node, endEvent, eventListener);
	    });
	  }
	};
	
	module.exports = ReactTransitionEvents;

/***/ },
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ActionsObservable = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Observable2 = __webpack_require__(6);
	
	var _of2 = __webpack_require__(942);
	
	var _from2 = __webpack_require__(940);
	
	var _filter = __webpack_require__(503);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ActionsObservable = exports.ActionsObservable = function (_Observable) {
	  _inherits(ActionsObservable, _Observable);
	
	  _createClass(ActionsObservable, null, [{
	    key: 'of',
	    value: function of() {
	      return new this(_of2.of.apply(undefined, arguments));
	    }
	  }, {
	    key: 'from',
	    value: function from(actions, scheduler) {
	      return new this((0, _from2.from)(actions, scheduler));
	    }
	  }]);
	
	  function ActionsObservable(actionsSubject) {
	    _classCallCheck(this, ActionsObservable);
	
	    var _this = _possibleConstructorReturn(this, (ActionsObservable.__proto__ || Object.getPrototypeOf(ActionsObservable)).call(this));
	
	    _this.source = actionsSubject;
	    return _this;
	  }
	
	  _createClass(ActionsObservable, [{
	    key: 'lift',
	    value: function lift(operator) {
	      var observable = new ActionsObservable(this);
	      observable.operator = operator;
	      return observable;
	    }
	  }, {
	    key: 'ofType',
	    value: function ofType() {
	      for (var _len = arguments.length, keys = Array(_len), _key = 0; _key < _len; _key++) {
	        keys[_key] = arguments[_key];
	      }
	
	      return _filter.filter.call(this, function (_ref) {
	        var type = _ref.type;
	
	        var len = keys.length;
	        if (len === 1) {
	          return type === keys[0];
	        } else {
	          for (var i = 0; i < len; i++) {
	            if (keys[i] === type) {
	              return true;
	            }
	          }
	        }
	        return false;
	      });
	    }
	  }]);
	
	  return ActionsObservable;
	}(_Observable2.Observable);

/***/ },
/* 929 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var EPIC_END = exports.EPIC_END = '@@redux-observable/EPIC_END';

/***/ },
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */
/***/ function(module, exports, __webpack_require__) {

	var sentenceCase = __webpack_require__(171)
	
	/**
	 * Snake case a string.
	 *
	 * @param  {String} str
	 * @param  {String} [locale]
	 * @return {String}
	 */
	module.exports = function (str, locale) {
	  return sentenceCase(str, locale, '_')
	}


/***/ },
/* 967 */
/***/ function(module, exports, __webpack_require__) {

	var upperCase = __webpack_require__(172)
	
	/**
	 * Upper case the first character of a string.
	 *
	 * @param  {String} str
	 * @return {String}
	 */
	module.exports = function (str, locale) {
	  if (str == null) {
	    return ''
	  }
	
	  str = String(str)
	
	  return upperCase(str.charAt(0), locale) + str.substr(1)
	}


/***/ },
/* 968 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 969 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var required = __webpack_require__(3136)
	  , lolcation = __webpack_require__(3458)
	  , qs = __webpack_require__(2963)
	  , protocolre = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\S\s]*)/i;
	
	/**
	 * These are the parse rules for the URL parser, it informs the parser
	 * about:
	 *
	 * 0. The char it Needs to parse, if it's a string it should be done using
	 *    indexOf, RegExp using exec and NaN means set as current value.
	 * 1. The property we should set when parsing this value.
	 * 2. Indication if it's backwards or forward parsing, when set as number it's
	 *    the value of extra chars that should be split off.
	 * 3. Inherit from location if non existing in the parser.
	 * 4. `toLowerCase` the resulting value.
	 */
	var rules = [
	  ['#', 'hash'],                        // Extract from the back.
	  ['?', 'query'],                       // Extract from the back.
	  ['/', 'pathname'],                    // Extract from the back.
	  ['@', 'auth', 1],                     // Extract from the front.
	  [NaN, 'host', undefined, 1, 1],       // Set left over value.
	  [/:(\d+)$/, 'port', undefined, 1],    // RegExp the back.
	  [NaN, 'hostname', undefined, 1, 1]    // Set left over.
	];
	
	/**
	 * @typedef ProtocolExtract
	 * @type Object
	 * @property {String} protocol Protocol matched in the URL, in lowercase.
	 * @property {Boolean} slashes `true` if protocol is followed by "//", else `false`.
	 * @property {String} rest Rest of the URL that is not part of the protocol.
	 */
	
	/**
	 * Extract protocol information from a URL with/without double slash ("//").
	 *
	 * @param {String} address URL we want to extract from.
	 * @return {ProtocolExtract} Extracted information.
	 * @api private
	 */
	function extractProtocol(address) {
	  var match = protocolre.exec(address);
	
	  return {
	    protocol: match[1] ? match[1].toLowerCase() : '',
	    slashes: !!match[2],
	    rest: match[3]
	  };
	}
	
	/**
	 * Resolve a relative URL pathname against a base URL pathname.
	 *
	 * @param {String} relative Pathname of the relative URL.
	 * @param {String} base Pathname of the base URL.
	 * @return {String} Resolved pathname.
	 * @api private
	 */
	function resolve(relative, base) {
	  var path = (base || '/').split('/').slice(0, -1).concat(relative.split('/'))
	    , i = path.length
	    , last = path[i - 1]
	    , unshift = false
	    , up = 0;
	
	  while (i--) {
	    if (path[i] === '.') {
	      path.splice(i, 1);
	    } else if (path[i] === '..') {
	      path.splice(i, 1);
	      up++;
	    } else if (up) {
	      if (i === 0) unshift = true;
	      path.splice(i, 1);
	      up--;
	    }
	  }
	
	  if (unshift) path.unshift('');
	  if (last === '.' || last === '..') path.push('');
	
	  return path.join('/');
	}
	
	/**
	 * The actual URL instance. Instead of returning an object we've opted-in to
	 * create an actual constructor as it's much more memory efficient and
	 * faster and it pleases my OCD.
	 *
	 * @constructor
	 * @param {String} address URL we want to parse.
	 * @param {Object|String} location Location defaults for relative paths.
	 * @param {Boolean|Function} parser Parser for the query string.
	 * @api public
	 */
	function URL(address, location, parser) {
	  if (!(this instanceof URL)) {
	    return new URL(address, location, parser);
	  }
	
	  var relative, extracted, parse, instruction, index, key
	    , instructions = rules.slice()
	    , type = typeof location
	    , url = this
	    , i = 0;
	
	  //
	  // The following if statements allows this module two have compatibility with
	  // 2 different API:
	  //
	  // 1. Node.js's `url.parse` api which accepts a URL, boolean as arguments
	  //    where the boolean indicates that the query string should also be parsed.
	  //
	  // 2. The `URL` interface of the browser which accepts a URL, object as
	  //    arguments. The supplied object will be used as default values / fall-back
	  //    for relative paths.
	  //
	  if ('object' !== type && 'string' !== type) {
	    parser = location;
	    location = null;
	  }
	
	  if (parser && 'function' !== typeof parser) parser = qs.parse;
	
	  location = lolcation(location);
	
	  //
	  // Extract protocol information before running the instructions.
	  //
	  extracted = extractProtocol(address || '');
	  relative = !extracted.protocol && !extracted.slashes;
	  url.slashes = extracted.slashes || relative && location.slashes;
	  url.protocol = extracted.protocol || location.protocol || '';
	  address = extracted.rest;
	
	  //
	  // When the authority component is absent the URL starts with a path
	  // component.
	  //
	  if (!extracted.slashes) instructions[2] = [/(.*)/, 'pathname'];
	
	  for (; i < instructions.length; i++) {
	    instruction = instructions[i];
	    parse = instruction[0];
	    key = instruction[1];
	
	    if (parse !== parse) {
	      url[key] = address;
	    } else if ('string' === typeof parse) {
	      if (~(index = address.indexOf(parse))) {
	        if ('number' === typeof instruction[2]) {
	          url[key] = address.slice(0, index);
	          address = address.slice(index + instruction[2]);
	        } else {
	          url[key] = address.slice(index);
	          address = address.slice(0, index);
	        }
	      }
	    } else if ((index = parse.exec(address))) {
	      url[key] = index[1];
	      address = address.slice(0, index.index);
	    }
	
	    url[key] = url[key] || (
	      relative && instruction[3] ? location[key] || '' : ''
	    );
	
	    //
	    // Hostname, host and protocol should be lowercased so they can be used to
	    // create a proper `origin`.
	    //
	    if (instruction[4]) url[key] = url[key].toLowerCase();
	  }
	
	  //
	  // Also parse the supplied query string in to an object. If we're supplied
	  // with a custom parser as function use that instead of the default build-in
	  // parser.
	  //
	  if (parser) url.query = parser(url.query);
	
	  //
	  // If the URL is relative, resolve the pathname against the base URL.
	  //
	  if (
	      relative
	    && location.slashes
	    && url.pathname.charAt(0) !== '/'
	    && (url.pathname !== '' || location.pathname !== '')
	  ) {
	    url.pathname = resolve(url.pathname, location.pathname);
	  }
	
	  //
	  // We should not add port numbers if they are already the default port number
	  // for a given protocol. As the host also contains the port number we're going
	  // override it with the hostname which contains no port number.
	  //
	  if (!required(url.port, url.protocol)) {
	    url.host = url.hostname;
	    url.port = '';
	  }
	
	  //
	  // Parse down the `auth` for the username and password.
	  //
	  url.username = url.password = '';
	  if (url.auth) {
	    instruction = url.auth.split(':');
	    url.username = instruction[0] || '';
	    url.password = instruction[1] || '';
	  }
	
	  url.origin = url.protocol && url.host && url.protocol !== 'file:'
	    ? url.protocol +'//'+ url.host
	    : 'null';
	
	  //
	  // The href is just the compiled result.
	  //
	  url.href = url.toString();
	}
	
	/**
	 * This is convenience method for changing properties in the URL instance to
	 * insure that they all propagate correctly.
	 *
	 * @param {String} part          Property we need to adjust.
	 * @param {Mixed} value          The newly assigned value.
	 * @param {Boolean|Function} fn  When setting the query, it will be the function
	 *                               used to parse the query.
	 *                               When setting the protocol, double slash will be
	 *                               removed from the final url if it is true.
	 * @returns {URL}
	 * @api public
	 */
	function set(part, value, fn) {
	  var url = this;
	
	  switch (part) {
	    case 'query':
	      if ('string' === typeof value && value.length) {
	        value = (fn || qs.parse)(value);
	      }
	
	      url[part] = value;
	      break;
	
	    case 'port':
	      url[part] = value;
	
	      if (!required(value, url.protocol)) {
	        url.host = url.hostname;
	        url[part] = '';
	      } else if (value) {
	        url.host = url.hostname +':'+ value;
	      }
	
	      break;
	
	    case 'hostname':
	      url[part] = value;
	
	      if (url.port) value += ':'+ url.port;
	      url.host = value;
	      break;
	
	    case 'host':
	      url[part] = value;
	
	      if (/:\d+$/.test(value)) {
	        value = value.split(':');
	        url.port = value.pop();
	        url.hostname = value.join(':');
	      } else {
	        url.hostname = value;
	        url.port = '';
	      }
	
	      break;
	
	    case 'protocol':
	      url.protocol = value.toLowerCase();
	      url.slashes = !fn;
	      break;
	
	    case 'pathname':
	      url.pathname = value.length && value.charAt(0) !== '/' ? '/' + value : value;
	
	      break;
	
	    default:
	      url[part] = value;
	  }
	
	  for (var i = 0; i < rules.length; i++) {
	    var ins = rules[i];
	
	    if (ins[4]) url[ins[1]] = url[ins[1]].toLowerCase();
	  }
	
	  url.origin = url.protocol && url.host && url.protocol !== 'file:'
	    ? url.protocol +'//'+ url.host
	    : 'null';
	
	  url.href = url.toString();
	
	  return url;
	};
	
	/**
	 * Transform the properties back in to a valid and full URL string.
	 *
	 * @param {Function} stringify Optional query stringify function.
	 * @returns {String}
	 * @api public
	 */
	function toString(stringify) {
	  if (!stringify || 'function' !== typeof stringify) stringify = qs.stringify;
	
	  var query
	    , url = this
	    , protocol = url.protocol;
	
	  if (protocol && protocol.charAt(protocol.length - 1) !== ':') protocol += ':';
	
	  var result = protocol + (url.slashes ? '//' : '');
	
	  if (url.username) {
	    result += url.username;
	    if (url.password) result += ':'+ url.password;
	    result += '@';
	  }
	
	  result += url.host + url.pathname;
	
	  query = 'object' === typeof url.query ? stringify(url.query) : url.query;
	  if (query) result += '?' !== query.charAt(0) ? '?'+ query : query;
	
	  if (url.hash) result += url.hash;
	
	  return result;
	}
	
	URL.prototype = { set: set, toString: toString };
	
	//
	// Expose the URL parser and some additional properties that might be useful for
	// others or testing.
	//
	URL.extractProtocol = extractProtocol;
	URL.location = lolcation;
	URL.qs = qs;
	
	module.exports = URL;


/***/ },
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _searchBar = __webpack_require__(544);
	
	var _searchBar2 = _interopRequireDefault(_searchBar);
	
	var _sharedProgressBar = __webpack_require__(94);
	
	var _sharedProgressBar2 = _interopRequireDefault(_sharedProgressBar);
	
	var _baseTabs = __webpack_require__(525);
	
	__webpack_require__(2642);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AddTitle = function (_BcReactComponent) {
	  _inherits(AddTitle, _BcReactComponent);
	
	  function AddTitle() {
	    _classCallCheck(this, AddTitle);
	
	    return _possibleConstructorReturn(this, (AddTitle.__proto__ || Object.getPrototypeOf(AddTitle)).apply(this, arguments));
	  }
	
	  _createClass(AddTitle, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.props.onUpdateHandle) {
	        this.props.onUpdateHandle();
	      }
	    }
	  }, {
	    key: 'renderTabContent',
	    value: function renderTabContent(options, id, eventkey) {
	      if (options === undefined) {
	        return null;
	      }
	
	      var handleSearch = options.handleSearch,
	          handleClear = options.handleClear,
	          handleQueryChange = options.handleQueryChange,
	          renderResults = options.renderResults,
	          searchLabel = options.searchLabel,
	          tabName = options.tabName,
	          query = options.query;
	
	
	      return _react2.default.createElement(
	        _baseTabs.TabContent,
	        {
	          eventKey: eventkey,
	          key: id,
	          tabHref: id,
	          label: tabName,
	          testId: 'add-' + id },
	        _react2.default.createElement(_searchBar2.default, {
	          query: query,
	          label: searchLabel,
	          handleSearch: handleSearch,
	          handleClear: handleClear,
	          handleChange: handleQueryChange,
	          isWrappedInForm: this.props.isWrappedInForm === undefined ? true : this.props.isWrappedInForm }),
	        this.renderProgressBar(),
	        renderResults()
	      );
	    }
	  }, {
	    key: 'renderProgressBar',
	    value: function renderProgressBar() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'progress-bar-wrapper' },
	        _react2.default.createElement(_sharedProgressBar2.default, { active: this.props.searching })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          catalogueOptions = _props.catalogueOptions,
	          webOptions = _props.webOptions;
	
	      return _react2.default.createElement(
	        'section',
	        { className: 'cp-add-title' },
	        _react2.default.createElement(
	          _baseTabs.Tabs,
	          { defaultActiveKey: '0' },
	          this.renderTabContent(catalogueOptions, 'catalog-item-tab', 0),
	          this.renderTabContent(webOptions, 'web-item-tab', 1)
	        )
	      );
	    }
	  }]);
	
	  return AddTitle;
	}(_baseBcReactComponent2.default);
	
	var tabOptionsShape = _react.PropTypes.shape({
	  tabName: _react.PropTypes.string.isRequired,
	  searchLabel: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.element]),
	  handleSearch: _react.PropTypes.func.isRequired,
	  handleClear: _react.PropTypes.func,
	  handleQueryChange: _react.PropTypes.func,
	  renderResults: _react.PropTypes.func
	});
	
	AddTitle.propTypes = {
	  catalogueOptions: tabOptionsShape,
	  webOptions: tabOptionsShape,
	  searching: _react.PropTypes.bool,
	  onUpdateHandle: _react.PropTypes.func,
	  isWrappedInForm: _react.PropTypes.bool
	};
	
	exports.default = AddTitle;

/***/ },
/* 974 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AddTitle = __webpack_require__(973);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AddTitle).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 975 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseAlerts = __webpack_require__(36);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	__webpack_require__(2643);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CatalogueResultItemAlert = function (_BcReactComponent) {
	  _inherits(CatalogueResultItemAlert, _BcReactComponent);
	
	  function CatalogueResultItemAlert() {
	    _classCallCheck(this, CatalogueResultItemAlert);
	
	    return _possibleConstructorReturn(this, (CatalogueResultItemAlert.__proto__ || Object.getPrototypeOf(CatalogueResultItemAlert)).apply(this, arguments));
	  }
	
	  _createClass(CatalogueResultItemAlert, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.props.isFocusOnUpdate) {
	        if (this._itemAddedMessage) {
	          this._itemAddedMessage.focus();
	        }
	      }
	      return null;
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.isFocusOnUpdate) {
	        if (this._itemAddedMessage) {
	          this._itemAddedMessage.focus();
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var label = this.props.label;
	
	
	      return _react2.default.createElement(
	        'span',
	        { className: 'cp-catalogue-result-item-alert', tabIndex: '-1', ref: function ref(el) {
	            return _this2._itemAddedMessage = el;
	          } },
	        _react2.default.createElement(
	          _baseScreenReaderMessage2.default,
	          null,
	          label
	        ),
	        _react2.default.createElement(
	          'span',
	          { 'aria-hidden': 'true' },
	          _react2.default.createElement(
	            _baseAlerts.AlertSuccess,
	            null,
	            label
	          )
	        )
	      );
	    }
	  }]);
	
	  return CatalogueResultItemAlert;
	}(_baseBcReactComponent2.default);
	
	CatalogueResultItemAlert.propTypes = {
	  label: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.element]),
	  isFocusOnUpdate: _react.PropTypes.bool
	};
	
	exports.default = CatalogueResultItemAlert;

/***/ },
/* 976 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CatalogueResultItemAlert = __webpack_require__(975);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CatalogueResultItemAlert).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 977 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseButtons = __webpack_require__(12);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	__webpack_require__(2644);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CatalogueResultItemButton = function (_BcReactComponent) {
	  _inherits(CatalogueResultItemButton, _BcReactComponent);
	
	  function CatalogueResultItemButton(props) {
	    _classCallCheck(this, CatalogueResultItemButton);
	
	    var _this = _possibleConstructorReturn(this, (CatalogueResultItemButton.__proto__ || Object.getPrototypeOf(CatalogueResultItemButton)).call(this, props));
	
	    _this.bindAll('handleClick');
	    return _this;
	  }
	
	  _createClass(CatalogueResultItemButton, [{
	    key: 'handleClick',
	    value: function handleClick() {
	      if (this.props.handleClick) {
	        this.props.handleClick();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          label = _props.label,
	          screenReaderMessage = _props.screenReaderMessage,
	          icon = _props.icon;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-catalogue-result-item-button' },
	        _react2.default.createElement(
	          _baseButtons.TextButton,
	          {
	            className: 'btn-ugc item-button',
	            'data-test-id': 'item-button',
	            flat: true,
	            handleClick: this.handleClick },
	          icon,
	          _react2.default.createElement(
	            'span',
	            { 'aria-hidden': true },
	            label
	          ),
	          _react2.default.createElement(
	            _baseScreenReaderMessage2.default,
	            null,
	            screenReaderMessage
	          )
	        )
	      );
	    }
	  }]);
	
	  return CatalogueResultItemButton;
	}(_baseBcReactComponent2.default);
	
	CatalogueResultItemButton.propTypes = {
	  handleClick: _react.PropTypes.func,
	  icon: _react.PropTypes.element,
	  label: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.element]),
	  screenReaderMessage: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.element])
	};
	
	exports.default = CatalogueResultItemButton;

/***/ },
/* 978 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CatalogueResultItemButton = __webpack_require__(977);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CatalogueResultItemButton).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 979 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BibItemInfo = __webpack_require__(509);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BibItemInfo).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 980 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _sharedJacketCover = __webpack_require__(93);
	
	var _sharedJacketCover2 = _interopRequireDefault(_sharedJacketCover);
	
	var _BibItemInfo = __webpack_require__(509);
	
	var _BibItemInfo2 = _interopRequireDefault(_BibItemInfo);
	
	__webpack_require__(2646);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getJacketCoverSrc(briefInfo) {
	  var jacket = briefInfo ? briefInfo.get('jacket') : _immutable2.default.Map();
	
	  return _immutable2.default.Map({
	    small: jacket.get('small'),
	    medium: jacket.get('medium'),
	    large: jacket.get('large'),
	    local_url: jacket.get('local_url'),
	    type: jacket.get('type')
	  });
	}
	
	var CatalogueResults = function (_BcReactComponent) {
	  _inherits(CatalogueResults, _BcReactComponent);
	
	  function CatalogueResults(props) {
	    _classCallCheck(this, CatalogueResults);
	
	    var _this = _possibleConstructorReturn(this, (CatalogueResults.__proto__ || Object.getPrototypeOf(CatalogueResults)).call(this, props));
	
	    _this.bindAll('focusOnTitle');
	    return _this;
	  }
	
	  _createClass(CatalogueResults, [{
	    key: 'focusOnTitle',
	    value: function focusOnTitle() {
	      if (this._bibItemInfo) {
	        this._bibItemInfo.focusOnTitle();
	      }
	    }
	  }, {
	    key: 'renderAddOn',
	    value: function renderAddOn(briefInfo) {
	      if (this.props.renderAddOn) {
	        return this.props.renderAddOn(briefInfo);
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderItem',
	    value: function renderItem(bib) {
	      var _this2 = this;
	
	      var availabilityDetailActions = this.props.availabilityDetailActions;
	
	      var briefInfo = bib.get('briefInfo');
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'catalogue-results-search-result-item' },
	        _react2.default.createElement(
	          'div',
	          { className: 'search-result-contents' },
	          _react2.default.createElement(
	            'div',
	            { className: 'item-inner-content' },
	            _react2.default.createElement(
	              'div',
	              { className: 'jacket-wrapper' },
	              _react2.default.createElement(_sharedJacketCover2.default, {
	                alt: '',
	                format: briefInfo.get('format'),
	                src: getJacketCoverSrc(briefInfo),
	                size: 'small' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'info-content' },
	              _react2.default.createElement(_BibItemInfo2.default, {
	                showAvailability: true,
	                bib: bib,
	                ref: function ref(el) {
	                  return _this2._bibItemInfo = el;
	                },
	                availabilityDetailActions: availabilityDetailActions,
	                compact: true }),
	              this.renderAddOn(briefInfo)
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          searchResults = _props.searchResults,
	          addRowClassNames = _props.addRowClassNames;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-catalogue-results' },
	        _react2.default.createElement(
	          'ul',
	          { className: 'search-results-list' },
	          searchResults.map(function (item, i) {
	            return _react2.default.createElement(
	              'li',
	              { key: i, className: (0, _classnames2.default)('search-results-row', addRowClassNames(item)) },
	              _this3.renderItem(item)
	            );
	          })
	        )
	      );
	    }
	  }]);
	
	  return CatalogueResults;
	}(_baseBcReactComponent2.default);
	
	CatalogueResults.propTypes = {
	  searchResults: _reactImmutableProptypes2.default.listOf(_bcPropTypes.bibShape),
	  availabilityDetailActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  addRowClassNames: _react.PropTypes.func,
	  renderAddOn: _react.PropTypes.func
	};
	
	CatalogueResults.defaultProps = {
	  addRowClassNames: function addRowClassNames() {}
	};
	
	exports.default = CatalogueResults;

/***/ },
/* 981 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CatalogueResults = __webpack_require__(980);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CatalogueResults).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 982 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _catalogueResults = __webpack_require__(981);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_catalogueResults).default;
	  }
	});
	
	var _bibItemInfo = __webpack_require__(979);
	
	Object.defineProperty(exports, 'BibItemInfo', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_bibItemInfo).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 983 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ItemAnnotationInput = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseInlineTextArea = __webpack_require__(1327);
	
	var _baseInlineTextArea2 = _interopRequireDefault(_baseInlineTextArea);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	var _utilsList = __webpack_require__(1563);
	
	var _bcPropTypes = __webpack_require__(5);
	
	__webpack_require__(2647);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ItemAnnotationInput = exports.ItemAnnotationInput = function (_BcReactComponent) {
	  _inherits(ItemAnnotationInput, _BcReactComponent);
	
	  function ItemAnnotationInput(props) {
	    _classCallCheck(this, ItemAnnotationInput);
	
	    var _this = _possibleConstructorReturn(this, (ItemAnnotationInput.__proto__ || Object.getPrototypeOf(ItemAnnotationInput)).call(this, props));
	
	    _this.bindAll('renderLabelContents');
	    return _this;
	  }
	
	  _createClass(ItemAnnotationInput, [{
	    key: 'renderLabelContents',
	    value: function renderLabelContents() {
	      if (this.props.renderLabelContents) {
	        return this.props.renderLabelContents;
	      }
	
	      return _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ada_label_edit_list_item_annotation_no_title' });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.props.allowFreeText) {
	        return null;
	      }
	
	      var key = this.props.item ? (0, _utilsList.generateKeyForListItem)(this.props.item) : 'new';
	      var labelId = key + '-item-annotation-label';
	      var inputId = key + '-item-annotation-input';
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-item-annotation-input' },
	        _react2.default.createElement(
	          _baseScreenReaderMessage2.default,
	          null,
	          _react2.default.createElement(
	            'label',
	            { id: labelId, htmlFor: inputId },
	            this.renderLabelContents()
	          )
	        ),
	        _react2.default.createElement(
	          _baseInlineTextArea2.default,
	          {
	            id: inputId,
	            labelledById: labelId,
	            value: this.props.value,
	            maxLength: 4000,
	            highlightOnHover: true,
	            handleChange: this.props.handleChange,
	            prompt: this.props.intl.formatMessage({ id: 'user_list_add_annotation' }),
	            buttonTestId: 'edit-item-annotation-button',
	            inputTestId: 'item-annotation-text-area',
	            fitToText: true },
	          _react2.default.createElement(
	            'span',
	            { className: 'user-annotation', 'data-test-id': 'item-annotation-value' },
	            this.props.value
	          )
	        )
	      );
	    }
	  }]);
	
	  return ItemAnnotationInput;
	}(_baseBcReactComponent2.default);
	
	ItemAnnotationInput.propTypes = {
	  value: _react.PropTypes.string,
	  renderLabelContents: _react.PropTypes.element,
	  allowFreeText: _react.PropTypes.bool.isRequired,
	  handleChange: _react.PropTypes.func.isRequired,
	  item: _bcPropTypes.listItemShape,
	  intl: _reactIntl.intlShape
	};
	
	exports.default = (0, _reactIntl.injectIntl)(ItemAnnotationInput);

/***/ },
/* 984 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.URLInput = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseClearableTextField = __webpack_require__(273);
	
	var _baseClearableTextField2 = _interopRequireDefault(_baseClearableTextField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var URLInput = exports.URLInput = function (_BcReactComponent) {
	  _inherits(URLInput, _BcReactComponent);
	
	  function URLInput(props) {
	    _classCallCheck(this, URLInput);
	
	    var _this = _possibleConstructorReturn(this, (URLInput.__proto__ || Object.getPrototypeOf(URLInput)).call(this, props));
	
	    _this.bindAll('clearPreview', 'handleChange');
	    return _this;
	  }
	
	  _createClass(URLInput, [{
	    key: 'handleChange',
	    value: function handleChange(value) {
	      this.props.handleWebItemPropertyChange(_immutable2.default.Map({ url: value }));
	    }
	  }, {
	    key: 'clearPreview',
	    value: function clearPreview() {
	      this.props.handleWebItemPropertyChange(_immutable2.default.Map({ url: '' }));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-url-input' },
	        _react2.default.createElement(
	          _reactIntl.FormattedMessage,
	          { id: 'user_list_url_label' },
	          function (message) {
	            return _react2.default.createElement(
	              'label',
	              { htmlFor: 'list-url', id: 'list-url-label' },
	              message
	            );
	          }
	        ),
	        _react2.default.createElement(_baseClearableTextField2.default, {
	          id: 'list-url',
	          labelledById: 'list-url-label',
	          value: this.props.value,
	          maxLength: 1000,
	          handleChange: this.handleChange,
	          handleClear: this.clearPreview,
	          hideClearButton: !this.props.value,
	          inputTestId: 'web-item-url',
	          clearButtonSrText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ada_label_clear_web_url' }),
	          characterCountSrOnly: true,
	          focus: true })
	      );
	    }
	  }]);
	
	  return URLInput;
	}(_baseBcReactComponent2.default);
	
	URLInput.propTypes = {
	  value: _react.PropTypes.string.isRequired,
	  handleWebItemPropertyChange: _react.PropTypes.func.isRequired,
	  intl: _reactIntl.intlShape.isRequired
	};
	
	exports.default = (0, _reactIntl.injectIntl)(URLInput);

/***/ },
/* 985 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.WebItemTitleInput = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseClearableTextField = __webpack_require__(273);
	
	var _baseClearableTextField2 = _interopRequireDefault(_baseClearableTextField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WebItemTitleInput = exports.WebItemTitleInput = function (_BcReactComponent) {
	  _inherits(WebItemTitleInput, _BcReactComponent);
	
	  function WebItemTitleInput(props) {
	    _classCallCheck(this, WebItemTitleInput);
	
	    var _this = _possibleConstructorReturn(this, (WebItemTitleInput.__proto__ || Object.getPrototypeOf(WebItemTitleInput)).call(this, props));
	
	    _this.bindAll('handleChange', 'handleClear');
	    return _this;
	  }
	
	  _createClass(WebItemTitleInput, [{
	    key: 'handleChange',
	    value: function handleChange(value) {
	      this.props.handleWebItemPropertyChange(_immutable2.default.Map({ title: value }));
	    }
	  }, {
	    key: 'handleClear',
	    value: function handleClear() {
	      this.props.handleWebItemPropertyChange(_immutable2.default.Map({ title: '' }));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-web-item-title-input' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'web-item-title-input', id: 'web-item-title-label' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'user_list_website_title' })
	        ),
	        _react2.default.createElement(_baseClearableTextField2.default, {
	          value: this.props.value,
	          id: 'web-item-title-input',
	          labelledById: 'web-item-title-label',
	          maxLength: 4000,
	          handleChange: this.handleChange,
	          handleClear: this.handleClear,
	          inputTestId: 'web-item-title-input',
	          hideClearButton: !this.props.value,
	          clearButtonSrText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ada_label_clear_title_text' }),
	          characterCountSrOnly: true,
	          focus: true })
	      );
	    }
	  }]);
	
	  return WebItemTitleInput;
	}(_baseBcReactComponent2.default);
	
	WebItemTitleInput.propTypes = {
	  value: _react.PropTypes.string,
	  handleWebItemPropertyChange: _react.PropTypes.func.isRequired,
	  intl: _reactIntl.intlShape.isRequired
	};
	
	exports.default = (0, _reactIntl.injectIntl)(WebItemTitleInput);

/***/ },
/* 986 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.WebResults = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _baseAlerts = __webpack_require__(36);
	
	var _baseIcons = __webpack_require__(10);
	
	var _sharedJacketCover = __webpack_require__(93);
	
	var _sharedJacketCover2 = _interopRequireDefault(_sharedJacketCover);
	
	var _baseButtons = __webpack_require__(12);
	
	var _itemAnnotationInput = __webpack_require__(510);
	
	var _itemAnnotationInput2 = _interopRequireDefault(_itemAnnotationInput);
	
	var _urlInput = __webpack_require__(511);
	
	var _urlInput2 = _interopRequireDefault(_urlInput);
	
	var _webItemTitleInput = __webpack_require__(512);
	
	var _webItemTitleInput2 = _interopRequireDefault(_webItemTitleInput);
	
	__webpack_require__(2648);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WebResults = exports.WebResults = function (_BcReactComponent) {
	  _inherits(WebResults, _BcReactComponent);
	
	  function WebResults(props) {
	    _classCallCheck(this, WebResults);
	
	    var _this = _possibleConstructorReturn(this, (WebResults.__proto__ || Object.getPrototypeOf(WebResults)).call(this, props));
	
	    _this.bindAll('handleAddBib', 'handleAnnotationChange', 'handleAddWebItem');
	    return _this;
	  }
	
	  _createClass(WebResults, [{
	    key: 'handleAddBib',
	    value: function handleAddBib(item) {
	      this.props.handleAddBib(item);
	    }
	  }, {
	    key: 'handleAnnotationChange',
	    value: function handleAnnotationChange(value) {
	      this.props.handleWebItemPropertyChange(_immutable2.default.Map({ annotation: value }));
	    }
	  }, {
	    key: 'handleAddWebItem',
	    value: function handleAddWebItem() {
	      if (this.webItemIsValid()) {
	        this.props.handleAddWebItem();
	      }
	    }
	  }, {
	    key: 'webItemIsValid',
	    value: function webItemIsValid() {
	      var webItem = this.props.webItem;
	
	      return webItem.get('url') && webItem.getIn(['jacketCover', 'localUrl']) && !webItem.get('invalidURL');
	    }
	  }, {
	    key: 'webItemIsAlreadyOnList',
	    value: function webItemIsAlreadyOnList() {
	      var _props = this.props,
	          webItem = _props.webItem,
	          listItems = _props.listItems;
	
	      var existingItemIndex = listItems.findIndex(function (item) {
	        return item.getIn(['urlListItem', 'url', 'url']) === webItem.get('url');
	      });
	
	      return existingItemIndex !== -1;
	    }
	  }, {
	    key: 'renderAddButton',
	    value: function renderAddButton() {
	      var webItem = this.props.webItem;
	
	      return _react2.default.createElement(
	        _baseButtons.PrimaryButton,
	        {
	          className: 'add-url',
	          disabled: !this.webItemIsValid() || !webItem.get('title') || this.webItemIsAlreadyOnList(),
	          'data-test-id': 'add-web-item-button',
	          handleClick: this.handleAddWebItem },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'add' })
	      );
	    }
	  }, {
	    key: 'renderPreview',
	    value: function renderPreview() {
	      var webItem = this.props.webItem;
	
	      // Check if URL is valid
	      if (webItem.get('invalidURL')) {
	        return _react2.default.createElement(
	          _baseAlerts.AlertFailure,
	          null,
	          _react2.default.createElement(
	            'span',
	            { 'data-test-id': 'web-item-error' },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'user_list_error_invalid_url' })
	          )
	        );
	      }
	
	      // Check if URL is already on list
	      if (webItem.get('validated') && this.webItemIsAlreadyOnList()) {
	        return _react2.default.createElement(
	          _baseAlerts.AlertFailure,
	          null,
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'user_list_error_url_already_on_list' })
	        );
	      }
	
	      // Display spinner if still waiting for previewURL
	      if (webItem.get('validating')) {
	        return _react2.default.createElement(_baseIcons.Spinner, { className: 'image-spinner' });
	      }
	
	      // Show preview
	      if (webItem.get('url') && webItem.getIn(['jacketCover', 'localUrl'])) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'preview row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'pull-left' },
	            _react2.default.createElement(_sharedJacketCover2.default, { format: 'WEBSITE', src: webItem.getIn(['jacketCover', 'localUrl']) })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'item-details' },
	            _react2.default.createElement(
	              'span',
	              { className: 'info-field website-title' },
	              _react2.default.createElement(_webItemTitleInput2.default, {
	                value: webItem.get('title'),
	                handleWebItemPropertyChange: this.props.handleWebItemPropertyChange })
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'info-field url' },
	              webItem.get('url')
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'info-field format' },
	              _react2.default.createElement('i', { 'aria-hidden': true, className: 'icon-export' }),
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'list_web_resource' })
	            ),
	            _react2.default.createElement(_itemAnnotationInput2.default, {
	              allowFreeText: true,
	              value: this.props.webItem.get('annotation'),
	              handleChange: this.handleAnnotationChange })
	          )
	        );
	      }
	
	      return _react2.default.createElement('noop', null);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var webItem = this.props.webItem;
	
	
	      return _react2.default.createElement(
	        'form',
	        {
	          action: '',
	          className: 'cp-add-web-item',
	          'data-test-id': 'add-web-item-form',
	          onSubmit: WebResults.handleFormSubmit,
	          'data-test-autopopulated': webItem.get('fieldsAutoPopulated') ? 'true' : 'false' },
	        _react2.default.createElement(
	          'div',
	          { className: 'url-field' },
	          _react2.default.createElement(_urlInput2.default, {
	            value: webItem.get('url'),
	            previewURL: webItem.getIn(['jacketCover', 'localUrl']),
	            invalidURL: webItem.get('invalidURL'),
	            handleWebItemPropertyChange: this.props.handleWebItemPropertyChange }),
	          _react2.default.createElement(
	            _baseButtons.PrimaryButton,
	            {
	              'data-test-id': 'web-item-submit-url-button',
	              className: 'submit-url-button',
	              handleClick: this.props.handleWebURLSelected },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_okay' })
	          )
	        ),
	        this.renderPreview(),
	        _react2.default.createElement(
	          'div',
	          { className: 'buttons row' },
	          this.renderAddButton()
	        )
	      );
	    }
	  }], [{
	    key: 'handleFormSubmit',
	    value: function handleFormSubmit(e) {
	      e.preventDefault();
	    }
	  }]);
	
	  return WebResults;
	}(_baseBcReactComponent2.default);
	
	WebResults.propTypes = {
	  listItems: _reactImmutableProptypes2.default.listOf(_bcPropTypes.listItemShape).isRequired,
	  webItem: _reactImmutableProptypes2.default.contains({
	    type: _react.PropTypes.string,
	    title: _react.PropTypes.string,
	    annotation: _react.PropTypes.string,
	    url: _react.PropTypes.string,
	    jacketCover: _reactImmutableProptypes2.default.contains({ localUrl: _react.PropTypes.string })
	  }),
	
	  handleAddWebItem: _react.PropTypes.func.isRequired,
	  handleWebItemPropertyChange: _react.PropTypes.func.isRequired,
	  handleWebURLSelected: _react.PropTypes.func.isRequired
	};
	
	exports.default = WebResults;

/***/ },
/* 987 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _WebResults = __webpack_require__(986);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_WebResults).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 988 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _webResults = __webpack_require__(987);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_webResults).default;
	  }
	});
	
	var _itemAnnotationInput = __webpack_require__(510);
	
	Object.defineProperty(exports, 'ItemAnnotationInput', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_itemAnnotationInput).default;
	  }
	});
	
	var _urlInput = __webpack_require__(511);
	
	Object.defineProperty(exports, 'URLInput', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_urlInput).default;
	  }
	});
	
	var _webItemTitleInput = __webpack_require__(512);
	
	Object.defineProperty(exports, 'WebItemTitleInput', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_webItemTitleInput).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 989 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.VIEW_ACTION = exports.VIEW_AVAILABILITY_EVENT = exports.AVAILABILITY_GTM_CATEGORY = undefined;
	exports.composeViewAvailabilityEvent = composeViewAvailabilityEvent;
	
	var _constantsAnalytics = __webpack_require__(714);
	
	var _constantsAnalytics2 = _interopRequireDefault(_constantsAnalytics);
	
	var _compose = __webpack_require__(67);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AVAILABILITY_GTM_CATEGORY = exports.AVAILABILITY_GTM_CATEGORY = _constantsAnalytics2.default.CATEGORIES.AVAILABILITY;
	
	var VIEW_AVAILABILITY_EVENT = exports.VIEW_AVAILABILITY_EVENT = _constantsAnalytics2.default.EVENTS.CHECK_AVAILABILITY;
	
	var VIEW_ACTION = exports.VIEW_ACTION = _constantsAnalytics2.default.ACTIONS.VIEW;
	
	function composeAvailabilityEvent(eventName, eventValue, eventAction, eventLabel) {
	  return (0, _compose.composeEvent)(eventName, {
	    gtmValue: eventValue,
	    gtmAction: eventAction,
	    gtmCategory: AVAILABILITY_GTM_CATEGORY,
	    gtmLabel: eventLabel
	  });
	}
	
	function composeViewAvailabilityEvent(status) {
	  return (0, _compose.composeAnalytics)([composeAvailabilityEvent(VIEW_AVAILABILITY_EVENT, 1, VIEW_ACTION, status && status.toLowerCase())]);
	}
	
	exports.default = {
	  AVAILABILITY_GTM_CATEGORY: AVAILABILITY_GTM_CATEGORY,
	  VIEW_AVAILABILITY_EVENT: VIEW_AVAILABILITY_EVENT,
	  VIEW_ACTION: VIEW_ACTION,
	  composeViewAvailabilityEvent: composeViewAvailabilityEvent
	};

/***/ },
/* 990 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _compose = __webpack_require__(67);
	
	var GTM_CATEGORY = 'v2-bib-format-chooser';
	
	var GTM_INTERACTION_ACTION = 'v2-container-interaction';
	var GTM_LINK_CLICK_ACTION = 'v2-link-click';
	
	var GTM_VIEW_ALL_LABEL = 'all-results';
	var GTM_EXPAND_LABEL = 'expand';
	var GTM_COLLAPSE_LABEL = 'collapse';
	
	var GTM_EVENT_NAME = 'bc.bibFormatChooserSelection';
	
	function composeFormatPickerExpandEvent(expand) {
	  return (0, _compose.composeAnalytics)([(0, _compose.composeEvent)(GTM_EVENT_NAME, {
	    gtmCategory: GTM_CATEGORY,
	    gtmAction: GTM_INTERACTION_ACTION,
	    gtmLabel: expand ? GTM_EXPAND_LABEL : GTM_COLLAPSE_LABEL,
	    gtmValue: 1
	  })]);
	}
	
	function composeFormatPickerSelectionEvent(label) {
	  return (0, _compose.composeAnalytics)([(0, _compose.composeEvent)(GTM_EVENT_NAME, {
	    gtmCategory: GTM_CATEGORY,
	    gtmAction: GTM_LINK_CLICK_ACTION,
	    gtmLabel: label,
	    gtmValue: 1
	  })]);
	}
	
	function composeFormatPickerViewAllEvent() {
	  return (0, _compose.composeAnalytics)([(0, _compose.composeEvent)(GTM_EVENT_NAME, {
	    gtmCategory: GTM_CATEGORY,
	    gtmAction: GTM_INTERACTION_ACTION,
	    gtmLabel: GTM_VIEW_ALL_LABEL,
	    gtmValue: 1
	  })]);
	}
	
	exports.default = {
	  composeFormatPickerExpandEvent: composeFormatPickerExpandEvent,
	  composeFormatPickerSelectionEvent: composeFormatPickerSelectionEvent,
	  composeFormatPickerViewAllEvent: composeFormatPickerViewAllEvent
	};

/***/ },
/* 991 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CHECKOUT_ACTION_RENEW = exports.RENEW_CHECKOUT_EVENT = exports.CHECKOUT_GTM_CATEGORY = undefined;
	exports.composeRenewCheckoutEvent = composeRenewCheckoutEvent;
	
	var _compose = __webpack_require__(67);
	
	var CHECKOUT_GTM_CATEGORY = exports.CHECKOUT_GTM_CATEGORY = 'v2-checkouts';
	
	var RENEW_CHECKOUT_EVENT = exports.RENEW_CHECKOUT_EVENT = 'bc.renewCheckout';
	
	var CHECKOUT_ACTION_RENEW = exports.CHECKOUT_ACTION_RENEW = 'v2-renew';
	
	function composeCheckoutEvent(eventName, eventValue, eventAction) {
	  return (0, _compose.composeEvent)(eventName, {
	    gtmValue: eventValue,
	    gtmAction: eventAction,
	    gtmCategory: CHECKOUT_GTM_CATEGORY
	  });
	}
	
	function composeRenewCheckoutEvent(checkoutIds) {
	  return (0, _compose.composeAnalytics)([composeCheckoutEvent(RENEW_CHECKOUT_EVENT, checkoutIds.length, CHECKOUT_ACTION_RENEW)]);
	}
	
	exports.default = {
	  CHECKOUT_GTM_CATEGORY: CHECKOUT_GTM_CATEGORY,
	  RENEW_CHECKOUT_EVENT: RENEW_CHECKOUT_EVENT,
	  CHECKOUT_ACTION_RENEW: CHECKOUT_ACTION_RENEW,
	  composeRenewCheckoutEvent: composeRenewCheckoutEvent
	};

/***/ },
/* 992 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _compose = __webpack_require__(67);
	
	var ADD_COMMENT_EVENT = 'bc.addComment';
	var EDIT_COMMENT_EVENT = 'bc.editComment';
	var REMOVE_COMMENT_EVENT = 'bc.removeComment';
	var ADD_COMMENT_ACTION = 'v2-add';
	var EDIT_COMMENT_ACTION = 'v2-edit';
	var REMOVE_COMMENT_ACTION = 'v2-remove';
	var COMMENTS_GTM_CATEGORY = 'v2-comments';
	
	function composeCommentEvent(eventName, action) {
	  return (0, _compose.composeEvent)(eventName, {
	    gtmValue: 1,
	    gtmLabel: undefined,
	    gtmCategory: COMMENTS_GTM_CATEGORY,
	    gtmAction: action
	  });
	}
	
	function composeAddCommentEvent() {
	  return (0, _compose.composeAnalytics)([composeCommentEvent(ADD_COMMENT_EVENT, ADD_COMMENT_ACTION)]);
	}
	
	function composeEditCommentEvent() {
	  return (0, _compose.composeAnalytics)([composeCommentEvent(EDIT_COMMENT_EVENT, EDIT_COMMENT_ACTION)]);
	}
	
	function composeRemoveCommentEvent() {
	  return (0, _compose.composeAnalytics)([composeCommentEvent(REMOVE_COMMENT_EVENT, REMOVE_COMMENT_ACTION)]);
	}
	
	exports.default = {
	  composeAddCommentEvent: composeAddCommentEvent,
	  composeEditCommentEvent: composeEditCommentEvent,
	  composeRemoveCommentEvent: composeRemoveCommentEvent,
	  ADD_COMMENT_EVENT: ADD_COMMENT_EVENT,
	  EDIT_COMMENT_EVENT: EDIT_COMMENT_EVENT,
	  REMOVE_COMMENT_EVENT: REMOVE_COMMENT_EVENT,
	  ADD_COMMENT_ACTION: ADD_COMMENT_ACTION,
	  EDIT_COMMENT_ACTION: EDIT_COMMENT_ACTION,
	  REMOVE_COMMENT_ACTION: REMOVE_COMMENT_ACTION,
	  COMMENTS_GTM_CATEGORY: COMMENTS_GTM_CATEGORY
	};

/***/ },
/* 993 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.HOLDS_ACTION_RESUME = exports.HOLDS_ACTION_PAUSE = exports.HOLDS_ACTION_CANCEL = exports.HOLDS_ACTION_PLACE = exports.RESUME_HOLD_EVENT = exports.PAUSE_HOLD_EVENT = exports.CANCEL_HOLD_EVENT = exports.PLACE_HOLD_EVENT = exports.HOLDS_GTM_CATEGORY = undefined;
	exports.composeCancelHoldEvent = composeCancelHoldEvent;
	exports.composePlaceHoldEvent = composePlaceHoldEvent;
	exports.composePauseHoldEvent = composePauseHoldEvent;
	exports.composeResumeHoldEvent = composeResumeHoldEvent;
	
	var _compose = __webpack_require__(67);
	
	var _shelvesEventComposer = __webpack_require__(513);
	
	var HOLDS_GTM_CATEGORY = exports.HOLDS_GTM_CATEGORY = 'v2-holds';
	
	var PLACE_HOLD_EVENT = exports.PLACE_HOLD_EVENT = 'bc.placeHold';
	var CANCEL_HOLD_EVENT = exports.CANCEL_HOLD_EVENT = 'bc.cancelHold';
	var PAUSE_HOLD_EVENT = exports.PAUSE_HOLD_EVENT = 'bc.pauseHold';
	var RESUME_HOLD_EVENT = exports.RESUME_HOLD_EVENT = 'bc.resumeHold';
	
	var HOLDS_ACTION_PLACE = exports.HOLDS_ACTION_PLACE = 'v2-place';
	var HOLDS_ACTION_CANCEL = exports.HOLDS_ACTION_CANCEL = 'v2-cancel';
	var HOLDS_ACTION_PAUSE = exports.HOLDS_ACTION_PAUSE = 'v2-pause';
	var HOLDS_ACTION_RESUME = exports.HOLDS_ACTION_RESUME = 'v2-resume';
	
	function composeHoldEvent(eventName, eventValue, metadataIds, eventAction) {
	  return (0, _compose.composeEvent)(eventName, {
	    gtmValue: eventValue,
	    gtmAction: eventAction,
	    gtmCategory: HOLDS_GTM_CATEGORY,
	    metadataIds: metadataIds
	  });
	}
	
	function composeCancelHoldEvent(holdCount, metadataIds, shelfState) {
	  var events = [];
	  if (shelfState && shelfState.toAdd) {
	    events.push((0, _shelvesEventComposer.composeShelfEvent)(_shelvesEventComposer.ADD_TO_SHELF_EVENT, metadataIds, shelfState.name, _shelvesEventComposer.SHELF_ACTION_ADD));
	  }
	  events.push(composeHoldEvent(CANCEL_HOLD_EVENT, holdCount, metadataIds, HOLDS_ACTION_CANCEL));
	  return (0, _compose.composeAnalytics)(events);
	}
	
	function composePlaceHoldEvent(metadataIds) {
	  return (0, _compose.composeAnalytics)([composeHoldEvent(PLACE_HOLD_EVENT, 1, metadataIds, HOLDS_ACTION_PLACE)]);
	}
	
	function composePauseHoldEvent(holdCount, metadataIds) {
	  return (0, _compose.composeAnalytics)([composeHoldEvent(PAUSE_HOLD_EVENT, holdCount, metadataIds, HOLDS_ACTION_PAUSE)]);
	}
	
	function composeResumeHoldEvent(holdCount, metadataIds) {
	  return (0, _compose.composeAnalytics)([composeHoldEvent(RESUME_HOLD_EVENT, holdCount, metadataIds, HOLDS_ACTION_RESUME)]);
	}
	
	exports.default = {
	  HOLDS_GTM_CATEGORY: HOLDS_GTM_CATEGORY,
	  PLACE_HOLD_EVENT: PLACE_HOLD_EVENT,
	  CANCEL_HOLD_EVENT: CANCEL_HOLD_EVENT,
	  PAUSE_HOLD_EVENT: PAUSE_HOLD_EVENT,
	  RESUME_HOLD_EVENT: RESUME_HOLD_EVENT,
	  HOLDS_ACTION_PLACE: HOLDS_ACTION_PLACE,
	  HOLDS_ACTION_CANCEL: HOLDS_ACTION_CANCEL,
	  HOLDS_ACTION_PAUSE: HOLDS_ACTION_PAUSE,
	  HOLDS_ACTION_RESUME: HOLDS_ACTION_RESUME,
	  composePlaceHoldEvent: composePlaceHoldEvent,
	  composeCancelHoldEvent: composeCancelHoldEvent,
	  composePauseHoldEvent: composePauseHoldEvent,
	  composeResumeHoldEvent: composeResumeHoldEvent
	};

/***/ },
/* 994 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _compose = __webpack_require__(67);
	
	var TOGGLE_I_OWN_THIS_EVENT = 'bc.toggleIOwnThis';
	var TOGGLE_I_OWN_THIS_ACTION = 'v2-toggle-i-own-this';
	var I_OWN_THIS_GTM_CATEGORY = 'v2-shelves';
	
	function composeIOwnThisEvent(iOwnThisStatus) {
	  return (0, _compose.composeEvent)(TOGGLE_I_OWN_THIS_EVENT, {
	    gtmValue: 1,
	    gtmLabel: iOwnThisStatus,
	    gtmCategory: I_OWN_THIS_GTM_CATEGORY,
	    gtmAction: TOGGLE_I_OWN_THIS_ACTION
	  });
	}
	
	function composeToggleIOwnThisEvent(iOwnThisStatus) {
	  // conversion made because gtmLabel is expecting a string
	  var status = iOwnThisStatus ? 'true' : 'false';
	  return (0, _compose.composeAnalytics)([composeIOwnThisEvent(status)]);
	}
	
	exports.default = {
	  composeToggleIOwnThisEvent: composeToggleIOwnThisEvent,
	  TOGGLE_I_OWN_THIS_EVENT: TOGGLE_I_OWN_THIS_EVENT,
	  TOGGLE_I_OWN_THIS_ACTION: TOGGLE_I_OWN_THIS_ACTION,
	  I_OWN_THIS_GTM_CATEGORY: I_OWN_THIS_GTM_CATEGORY
	};

/***/ },
/* 995 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _compose = __webpack_require__(67);
	
	var ADD_QUOTATION_EVENT = 'bc.addQuotation';
	var EDIT_QUOTATION_EVENT = 'bc.editQuotation';
	var REMOVE_QUOTATION_EVENT = 'bc.removeQuotation';
	var ADD_QUOTATION_ACTION = 'v2-add';
	var EDIT_QUOTATION_ACTION = 'v2-edit';
	var REMOVE_QUOTATION_ACTION = 'v2-remove';
	var QUOTATIONS_GTM_CATEGORY = 'v2-quotations';
	
	function composeQuotationEvent(eventName, action) {
	  return (0, _compose.composeEvent)(eventName, {
	    gtmValue: 1,
	    gtmLabel: undefined,
	    gtmCategory: QUOTATIONS_GTM_CATEGORY,
	    gtmAction: action
	  });
	}
	
	function composeAddQuotationEvent() {
	  return (0, _compose.composeAnalytics)([composeQuotationEvent(ADD_QUOTATION_EVENT, ADD_QUOTATION_ACTION)]);
	}
	
	function composeEditQuotationEvent() {
	  return (0, _compose.composeAnalytics)([composeQuotationEvent(EDIT_QUOTATION_EVENT, EDIT_QUOTATION_ACTION)]);
	}
	
	function composeRemoveQuotationEvent() {
	  return (0, _compose.composeAnalytics)([composeQuotationEvent(REMOVE_QUOTATION_EVENT, REMOVE_QUOTATION_ACTION)]);
	}
	
	exports.default = {
	  composeAddQuotationEvent: composeAddQuotationEvent,
	  composeEditQuotationEvent: composeEditQuotationEvent,
	  composeRemoveQuotationEvent: composeRemoveQuotationEvent,
	  ADD_QUOTATION_EVENT: ADD_QUOTATION_EVENT,
	  EDIT_QUOTATION_EVENT: EDIT_QUOTATION_EVENT,
	  REMOVE_QUOTATION_EVENT: REMOVE_QUOTATION_EVENT,
	  ADD_QUOTATION_ACTION: ADD_QUOTATION_ACTION,
	  EDIT_QUOTATION_ACTION: EDIT_QUOTATION_ACTION,
	  REMOVE_QUOTATION_ACTION: REMOVE_QUOTATION_ACTION,
	  QUOTATIONS_GTM_CATEGORY: QUOTATIONS_GTM_CATEGORY
	};

/***/ },
/* 996 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _compose = __webpack_require__(67);
	
	var ADD_RATING_EVENT = 'bc.addRating';
	var EDIT_RATING_EVENT = 'bc.editRating';
	var REMOVE_RATING_EVENT = 'bc.removeRating';
	var ADD_RATING_ACTION = 'v2-add';
	var EDIT_RATING_ACTION = 'v2-edit';
	var REMOVE_RATING_ACTION = 'v2-remove';
	var RATINGS_GTM_CATEGORY = 'v2-ratings';
	
	/**
	 * @param {string} ratingValue rating is based out of 10/100; ie 10, 30, 70 are valid values
	 */
	function composeRatingEvent(eventName, ratingValue, action) {
	  return (0, _compose.composeEvent)(eventName, {
	    gtmValue: 1,
	    gtmLabel: ratingValue,
	    gtmCategory: RATINGS_GTM_CATEGORY,
	    gtmAction: action
	  });
	}
	
	function composeAddRatingEvent(ratingValue) {
	  return (0, _compose.composeAnalytics)([composeRatingEvent(ADD_RATING_EVENT, ratingValue, ADD_RATING_ACTION)]);
	}
	
	function composeEditRatingEvent(ratingValue) {
	  return (0, _compose.composeAnalytics)([composeRatingEvent(EDIT_RATING_EVENT, ratingValue, EDIT_RATING_ACTION)]);
	}
	
	function composeRemoveRatingEvent() {
	  return (0, _compose.composeAnalytics)([composeRatingEvent(REMOVE_RATING_EVENT, undefined, REMOVE_RATING_ACTION)]);
	}
	
	exports.default = {
	  composeAddRatingEvent: composeAddRatingEvent,
	  composeEditRatingEvent: composeEditRatingEvent,
	  composeRemoveRatingEvent: composeRemoveRatingEvent
	};

/***/ },
/* 997 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LINK_CLICK_ACTION = exports.DID_YOU_MEAN_RESULT_ACTION = exports.RESULT_ACTION = exports.BROADEN_SEARCH_ACTION = exports.DID_YOU_MEAN_CLICK_EVENT = exports.DID_YOU_MEAN_IMPRESSION_EVENT = exports.SEARCH_RESULTS_EVENT = exports.EMPTY_SEARCH_RESULTS_EVENT = exports.BROADEN_SEARCH_EVENT = exports.EMPTY_SEARCH_GTM_CATEGORY = exports.SEARCH_GTM_CATEGORY = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.composeBroadenSearchEvent = composeBroadenSearchEvent;
	exports.composeEmptySearchResultsEvent = composeEmptySearchResultsEvent;
	exports.composeSearchResultsEvent = composeSearchResultsEvent;
	exports.composeDidYouMeanImpressionEvent = composeDidYouMeanImpressionEvent;
	exports.composeDidYouMeanClickEvent = composeDidYouMeanClickEvent;
	
	var _compose = __webpack_require__(67);
	
	var SEARCH_GTM_CATEGORY = exports.SEARCH_GTM_CATEGORY = 'v2-search';
	var EMPTY_SEARCH_GTM_CATEGORY = exports.EMPTY_SEARCH_GTM_CATEGORY = 'v2-search-empty';
	
	var BROADEN_SEARCH_EVENT = exports.BROADEN_SEARCH_EVENT = 'bc.broadenSearch';
	var EMPTY_SEARCH_RESULTS_EVENT = exports.EMPTY_SEARCH_RESULTS_EVENT = 'bc.emptySearchResult';
	var SEARCH_RESULTS_EVENT = exports.SEARCH_RESULTS_EVENT = 'bc.searchResult';
	var DID_YOU_MEAN_IMPRESSION_EVENT = exports.DID_YOU_MEAN_IMPRESSION_EVENT = 'bc.dymSearchResultImpression';
	var DID_YOU_MEAN_CLICK_EVENT = exports.DID_YOU_MEAN_CLICK_EVENT = 'bc.dymSearchResultClick';
	
	var BROADEN_SEARCH_ACTION = exports.BROADEN_SEARCH_ACTION = 'v2-broaden';
	var RESULT_ACTION = exports.RESULT_ACTION = 'v2-result';
	var DID_YOU_MEAN_RESULT_ACTION = exports.DID_YOU_MEAN_RESULT_ACTION = 'v2-result-did-you-mean';
	var LINK_CLICK_ACTION = exports.LINK_CLICK_ACTION = 'v2-link-click';
	
	function composeSearchEvent(eventCategory, eventName, eventValue, eventAction, eventLabel) {
	  var payload = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
	
	  return (0, _compose.composeEvent)(eventName, _extends({
	    gtmValue: eventValue,
	    gtmAction: eventAction,
	    gtmCategory: eventCategory,
	    gtmLabel: eventLabel
	  }, payload));
	}
	
	function composeBroadenSearchEvent(_ref) {
	  var query = _ref.query,
	      searchType = _ref.searchType;
	
	  return (0, _compose.composeAnalytics)([composeSearchEvent(SEARCH_GTM_CATEGORY, BROADEN_SEARCH_EVENT, 1, BROADEN_SEARCH_ACTION, query, { searchType: searchType })]);
	}
	
	function composeEmptySearchResultsEvent(_ref2) {
	  var query = _ref2.query,
	      searchType = _ref2.searchType;
	
	  return (0, _compose.composeAnalytics)([composeSearchEvent(EMPTY_SEARCH_GTM_CATEGORY, EMPTY_SEARCH_RESULTS_EVENT, 1, RESULT_ACTION, query, { searchType: searchType })]);
	}
	
	function composeSearchResultsEvent(_ref3) {
	  var query = _ref3.query,
	      searchType = _ref3.searchType;
	
	  return (0, _compose.composeAnalytics)([composeSearchEvent(SEARCH_GTM_CATEGORY, SEARCH_RESULTS_EVENT, 1, RESULT_ACTION, query, { searchType: searchType })]);
	}
	
	function composeDidYouMeanImpressionEvent(_ref4) {
	  var query = _ref4.query,
	      suggestion = _ref4.suggestion;
	
	  return (0, _compose.composeAnalytics)([composeSearchEvent(EMPTY_SEARCH_GTM_CATEGORY, DID_YOU_MEAN_IMPRESSION_EVENT, 1, DID_YOU_MEAN_RESULT_ACTION, suggestion + ' | ' + query)]);
	}
	
	function composeDidYouMeanClickEvent(_ref5) {
	  var query = _ref5.query,
	      suggestion = _ref5.suggestion;
	
	  return (0, _compose.composeAnalytics)([composeSearchEvent(EMPTY_SEARCH_GTM_CATEGORY, DID_YOU_MEAN_CLICK_EVENT, 1, LINK_CLICK_ACTION, suggestion + ' | ' + query)]);
	}
	
	exports.default = {
	  SEARCH_GTM_CATEGORY: SEARCH_GTM_CATEGORY,
	  EMPTY_SEARCH_GTM_CATEGORY: EMPTY_SEARCH_GTM_CATEGORY,
	  BROADEN_SEARCH_EVENT: BROADEN_SEARCH_EVENT,
	  EMPTY_SEARCH_RESULTS_EVENT: EMPTY_SEARCH_RESULTS_EVENT,
	  SEARCH_RESULTS_EVENT: SEARCH_RESULTS_EVENT,
	  DID_YOU_MEAN_IMPRESSION_EVENT: DID_YOU_MEAN_IMPRESSION_EVENT,
	  DID_YOU_MEAN_CLICK_EVENT: DID_YOU_MEAN_CLICK_EVENT,
	  BROADEN_SEARCH_ACTION: BROADEN_SEARCH_ACTION,
	  RESULT_ACTION: RESULT_ACTION,
	  DID_YOU_MEAN_RESULT_ACTION: DID_YOU_MEAN_RESULT_ACTION,
	  LINK_CLICK_ACTION: LINK_CLICK_ACTION,
	  composeBroadenSearchEvent: composeBroadenSearchEvent,
	  composeEmptySearchResultsEvent: composeEmptySearchResultsEvent,
	  composeSearchResultsEvent: composeSearchResultsEvent,
	  composeDidYouMeanImpressionEvent: composeDidYouMeanImpressionEvent,
	  composeDidYouMeanClickEvent: composeDidYouMeanClickEvent
	};

/***/ },
/* 998 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _constantsAnalytics = __webpack_require__(714);
	
	var _constantsAnalytics2 = _interopRequireDefault(_constantsAnalytics);
	
	var _compose = __webpack_require__(67);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SIMILAR_TITLES = _constantsAnalytics2.default.CATEGORIES.SIMILAR_TITLES;
	var _analyticsConstants$E = _constantsAnalytics2.default.EVENTS,
	    ADD_SIMILAR_TITLE = _analyticsConstants$E.ADD_SIMILAR_TITLE,
	    REMOVE_SIMILAR_TITLE = _analyticsConstants$E.REMOVE_SIMILAR_TITLE;
	var _analyticsConstants$A = _constantsAnalytics2.default.ACTIONS,
	    ADD_CONTENT = _analyticsConstants$A.ADD_CONTENT,
	    REMOVE_CONTENT = _analyticsConstants$A.REMOVE_CONTENT;
	
	
	function composeSimilarTitlesEvent(eventName, action) {
	  return (0, _compose.composeEvent)(eventName, {
	    gtmValue: 1,
	    gtmLabel: undefined,
	    gtmCategory: SIMILAR_TITLES,
	    gtmAction: action
	  });
	}
	
	function composeAddSimilarTitlesEvent() {
	  return (0, _compose.composeAnalytics)([composeSimilarTitlesEvent(ADD_SIMILAR_TITLE, ADD_CONTENT)]);
	}
	
	function composeRemoveSimilarTitlesEvent() {
	  return (0, _compose.composeAnalytics)([composeSimilarTitlesEvent(REMOVE_SIMILAR_TITLE, REMOVE_CONTENT)]);
	}
	
	exports.default = {
	  composeAddSimilarTitlesEvent: composeAddSimilarTitlesEvent,
	  composeRemoveSimilarTitlesEvent: composeRemoveSimilarTitlesEvent
	};

/***/ },
/* 999 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TAGS_GTM_CATEGORY = exports.TRIGGER_ADD_TAG_ACTION = exports.REMOVE_TAG_ACTION = exports.ADD_TAG_ACTION = exports.TRIGGER_ADD_TAG_EVENT = exports.REMOVE_TAG_EVENT = exports.ADD_TAG_EVENT = undefined;
	
	var _compose = __webpack_require__(67);
	
	var ADD_TAG_EVENT = exports.ADD_TAG_EVENT = 'bc.addTag';
	var REMOVE_TAG_EVENT = exports.REMOVE_TAG_EVENT = 'bc.removeTag';
	var TRIGGER_ADD_TAG_EVENT = exports.TRIGGER_ADD_TAG_EVENT = 'bc.triggerAddTag';
	var ADD_TAG_ACTION = exports.ADD_TAG_ACTION = 'v2-add';
	var REMOVE_TAG_ACTION = exports.REMOVE_TAG_ACTION = 'v2-remove';
	var TRIGGER_ADD_TAG_ACTION = exports.TRIGGER_ADD_TAG_ACTION = 'v2-trigger-add';
	var TAGS_GTM_CATEGORY = exports.TAGS_GTM_CATEGORY = 'v2-tags';
	
	function composeTagEvent(eventName, tagType, action) {
	  return (0, _compose.composeEvent)(eventName, {
	    gtmValue: 1,
	    gtmLabel: tagType,
	    gtmCategory: TAGS_GTM_CATEGORY,
	    gtmAction: action
	  });
	}
	
	function composeAddTagEvent(tagType) {
	  return (0, _compose.composeAnalytics)([composeTagEvent(ADD_TAG_EVENT, tagType, ADD_TAG_ACTION)]);
	}
	
	function composeRemoveTagEvent(tagType) {
	  return (0, _compose.composeAnalytics)([composeTagEvent(REMOVE_TAG_EVENT, tagType, REMOVE_TAG_ACTION)]);
	}
	// TODO: SHEL-286
	function composeTriggerAddTagEvent(triggerType) {
	  return (0, _compose.composeAnalytics)([composeTagEvent(TRIGGER_ADD_TAG_EVENT, triggerType, TRIGGER_ADD_TAG_ACTION)]);
	}
	
	exports.default = {
	  composeAddTagEvent: composeAddTagEvent,
	  composeRemoveTagEvent: composeRemoveTagEvent,
	  composeTriggerAddTagEvent: composeTriggerAddTagEvent
	};

/***/ },
/* 1000 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _compose = __webpack_require__(67);
	
	var ADD_VIDEO_EVENT = 'bc.addVideo';
	var EDIT_VIDEO_EVENT = 'bc.editVideo';
	var REMOVE_VIDEO_EVENT = 'bc.removeVideo';
	var ADD_VIDEO_ACTION = 'v2-add';
	var EDIT_VIDEO_ACTION = 'v2-edit';
	var REMOVE_VIDEO_ACTION = 'v2-remove';
	var VIDEOS_GTM_CATEGORY = 'v2-videos';
	
	function composeRatingEvent(eventName, action) {
	  return (0, _compose.composeEvent)(eventName, {
	    gtmValue: 1,
	    gtmLabel: undefined,
	    gtmCategory: VIDEOS_GTM_CATEGORY,
	    gtmAction: action
	  });
	}
	
	function composeAddVideoEvent() {
	  return (0, _compose.composeAnalytics)([composeRatingEvent(ADD_VIDEO_EVENT, ADD_VIDEO_ACTION)]);
	}
	
	function composeEditVideoEvent() {
	  return (0, _compose.composeAnalytics)([composeRatingEvent(EDIT_VIDEO_EVENT, EDIT_VIDEO_ACTION)]);
	}
	
	function composeRemoveVideoEvent() {
	  return (0, _compose.composeAnalytics)([composeRatingEvent(REMOVE_VIDEO_EVENT, REMOVE_VIDEO_ACTION)]);
	}
	
	exports.default = {
	  composeAddVideoEvent: composeAddVideoEvent,
	  composeEditVideoEvent: composeEditVideoEvent,
	  composeRemoveVideoEvent: composeRemoveVideoEvent,
	  ADD_VIDEO_EVENT: ADD_VIDEO_EVENT,
	  EDIT_VIDEO_EVENT: EDIT_VIDEO_EVENT,
	  REMOVE_VIDEO_EVENT: REMOVE_VIDEO_EVENT,
	  ADD_VIDEO_ACTION: ADD_VIDEO_ACTION,
	  EDIT_VIDEO_ACTION: EDIT_VIDEO_ACTION,
	  REMOVE_VIDEO_ACTION: REMOVE_VIDEO_ACTION,
	  VIDEOS_GTM_CATEGORY: VIDEOS_GTM_CATEGORY
	};

/***/ },
/* 1001 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _availabilityDigitalBlock = __webpack_require__(1003);
	
	var _availabilityDigitalBlock2 = _interopRequireDefault(_availabilityDigitalBlock);
	
	var _sharedEresourceLink = __webpack_require__(545);
	
	var _sharedEresourceLink2 = _interopRequireDefault(_sharedEresourceLink);
	
	var _availabilityPhysicalBlock = __webpack_require__(1007);
	
	var _availabilityPhysicalBlock2 = _interopRequireDefault(_availabilityPhysicalBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  bib: _reactImmutableProptypes2.default.map.isRequired,
	  availabilityStatus: _reactImmutableProptypes2.default.map.isRequired,
	  availabilityDetailActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  showAvailabilityLink: _react.PropTypes.bool,
	  showAvailabilityStatus: _react.PropTypes.bool,
	  showHoldCount: _react.PropTypes.bool,
	  showCheckDigitalAvailabilityButton: _react.PropTypes.bool
	};
	
	var BibBlock = function BibBlock(props) {
	  if (props.availabilityStatus.get('localisedStatus') === 'DELETED') {
	    return null;
	  }
	
	  var bib = props.bib,
	      availabilityStatus = props.availabilityStatus,
	      availabilityDetailActions = props.availabilityDetailActions,
	      showAvailabilityLink = props.showAvailabilityLink,
	      showAvailabilityStatus = props.showAvailabilityStatus,
	      showCheckDigitalAvailabilityButton = props.showCheckDigitalAvailabilityButton,
	      showHoldCount = props.showHoldCount;
	
	  var briefInfo = bib.get('briefInfo');
	
	  switch (props.availabilityStatus.get('bibType')) {
	    case 'PHYSICAL':
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_availabilityPhysicalBlock2.default, {
	          holdable: bib.getIn(['policy', 'holdable']),
	          bib: briefInfo,
	          availabilityStatus: availabilityStatus,
	          availabilityDetailActions: availabilityDetailActions,
	          showAvailabilityStatus: showAvailabilityStatus,
	          showAvailabilityLink: showAvailabilityLink,
	          showHoldCount: showHoldCount })
	      );
	    case 'DIGITAL':
	      return _react2.default.createElement(_availabilityDigitalBlock2.default, _extends({}, props, { bib: briefInfo, serviceAvailable: bib.getIn(['policy', 'materialPolicy', 'healthy']) }));
	    case 'DIGITAL_RESOURCE':
	      return _react2.default.createElement(_sharedEresourceLink2.default, {
	        format: briefInfo.get('format'),
	        showHoldCount: showHoldCount,
	        eresourceDescription: availabilityStatus.get('eresourceDescription'),
	        eresourceUrl: availabilityStatus.get('eresourceUrl') });
	    default:
	      return null;
	  }
	};
	
	BibBlock.propTypes = propTypes;
	
	exports.default = BibBlock;

/***/ },
/* 1002 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _availabilityStatus = __webpack_require__(361);
	
	var _availabilityStatus2 = _interopRequireDefault(_availabilityStatus);
	
	var _holdCounts = __webpack_require__(364);
	
	var _holdCounts2 = _interopRequireDefault(_holdCounts);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseButtons = __webpack_require__(12);
	
	var _utilsAnalytics = __webpack_require__(142);
	
	var _analyticsEventComposers = __webpack_require__(174);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var composeViewAvailabilityEvent = _analyticsEventComposers.availabilityEventComposer.composeViewAvailabilityEvent;
	
	
	var propTypes = {
	  availabilityStatus: _react.PropTypes.object.isRequired,
	  supportsFastAvailability: _react.PropTypes.bool,
	  availabilityDetailActions: _react.PropTypes.object.isRequired
	};
	
	var DigitalBlock = function (_BcReactComponent) {
	  _inherits(DigitalBlock, _BcReactComponent);
	
	  function DigitalBlock() {
	    _classCallCheck(this, DigitalBlock);
	
	    var _this = _possibleConstructorReturn(this, (DigitalBlock.__proto__ || Object.getPrototypeOf(DigitalBlock)).call(this));
	
	    _this.state = {
	      isLoading: false
	    };
	
	    _this.bindAll('fetchLiveAvailability');
	    return _this;
	  }
	
	  _createClass(DigitalBlock, [{
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps) {
	      if (this.state.isLoading === true && nextProps.availabilityStatus.get('status') !== 'UNKNOWN') {
	        this.setState({
	          isLoading: false
	        });
	      }
	    }
	  }, {
	    key: 'fetchLiveAvailability',
	    value: function fetchLiveAvailability() {
	      var _props = this.props,
	          availabilityDetailActions = _props.availabilityDetailActions,
	          availabilityStatus = _props.availabilityStatus,
	          bib = _props.bib;
	
	      (0, _utilsAnalytics.sendAnalyticsEvents)(composeViewAvailabilityEvent(availabilityStatus.get('status')));
	      this.setState({
	        isLoading: true
	      });
	      availabilityDetailActions.getDigitalAvailability(bib.get('id'));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          availabilityStatus = _props2.availabilityStatus,
	          serviceAvailable = _props2.serviceAvailable,
	          showAvailabilityStatus = _props2.showAvailabilityStatus,
	          showHoldCount = _props2.showHoldCount,
	          showCheckDigitalAvailabilityButton = _props2.showCheckDigitalAvailabilityButton;
	
	
	      if (!serviceAvailable) {
	        return _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'digital_service_unavailable' });
	      }
	
	      if (showCheckDigitalAvailabilityButton && availabilityStatus.get('status') === 'UNKNOWN') {
	        return _react2.default.createElement(
	          _baseButtons.TextButton,
	          { className: 'check-availability-button', handleClick: this.fetchLiveAvailability, isLoading: this.state.isLoading },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'check_digital_availability' })
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-digital-availability-block' },
	        showAvailabilityStatus && _react2.default.createElement(_availabilityStatus2.default, {
	          availabilityLocationType: availabilityStatus.get('availabilityLocationType'),
	          rollUpStatus: availabilityStatus.get('status'),
	          status: availabilityStatus.get('localisedStatus') }),
	        _react2.default.createElement('br', null),
	        showHoldCount && _react2.default.createElement(_holdCounts2.default, {
	          heldCopies: availabilityStatus.get('heldCopies'),
	          availableCopies: availabilityStatus.get('availableCopies'),
	          totalCopies: availabilityStatus.get('totalCopies') })
	      );
	    }
	  }]);
	
	  return DigitalBlock;
	}(_baseBcReactComponent2.default);
	
	DigitalBlock.propTypes = propTypes;
	DigitalBlock.displayName = 'DigitalBlock';
	DigitalBlock.defaultProps = {
	  showAvailabilityStatus: true,
	  showCheckDigitalAvailabilityButton: true
	};
	
	exports.default = DigitalBlock;

/***/ },
/* 1003 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DigitalBlock = __webpack_require__(1002);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DigitalBlock).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1004 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AvailabilityLink = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _reactRouter = __webpack_require__(17);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	var _analyticsEventComposers = __webpack_require__(174);
	
	var _utilsAnalytics = __webpack_require__(142);
	
	__webpack_require__(2649);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var composeViewAvailabilityEvent = _analyticsEventComposers.availabilityEventComposer.composeViewAvailabilityEvent;
	
	var AvailabilityLink = exports.AvailabilityLink = function (_BcReactComponent) {
	  _inherits(AvailabilityLink, _BcReactComponent);
	
	  function AvailabilityLink(props) {
	    _classCallCheck(this, AvailabilityLink);
	
	    var _this = _possibleConstructorReturn(this, (AvailabilityLink.__proto__ || Object.getPrototypeOf(AvailabilityLink)).call(this, props));
	
	    _this.bindAll('handleClick');
	    return _this;
	  }
	
	  _createClass(AvailabilityLink, [{
	    key: 'handleClick',
	    value: function handleClick() {
	      var _props = this.props,
	          availabilityDetailActions = _props.availabilityDetailActions,
	          metadataId = _props.metadataId,
	          status = _props.status;
	
	
	      (0, _utilsAnalytics.sendAnalyticsEvents)(composeViewAvailabilityEvent(status));
	
	      if (!this.context.isWidget) {
	        availabilityDetailActions.getAvailability(metadataId);
	      }
	    }
	  }, {
	    key: 'getLinkUrl',
	    value: function getLinkUrl(metadataId) {
	      if (this.context.isWidget) {
	        return '/v2/availability/' + metadataId;
	      }
	      var router = this.props.router;
	
	      var search = router ? router.location.search : '';
	      var pathname = router ? router.location.pathname : '';
	      return pathname + '/availability/' + metadataId + search;
	    }
	  }, {
	    key: 'getExtraLinkOptions',
	    value: function getExtraLinkOptions() {
	      if (this.context.isWidget) {
	        return {
	          target: '_top'
	        };
	      }
	
	      return {};
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          metadataId = _props2.metadataId,
	          title = _props2.title,
	          format = _props2.format,
	          status = _props2.status,
	          availabilityLocationType = _props2.availabilityLocationType,
	          intl = _props2.intl;
	
	
	      return _react2.default.createElement(
	        'span',
	        { className: 'cp-availability-trigger' },
	        _react2.default.createElement(
	          _reactRouter.Link,
	          _extends({ 'data-key': 'bib-availability-link', to: this.getLinkUrl(metadataId), onClick: this.handleClick }, this.getExtraLinkOptions()),
	          _react2.default.createElement(
	            'span',
	            { 'aria-hidden': 'true' },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Availability.detailsLink' })
	          ),
	          _react2.default.createElement(
	            _baseScreenReaderMessage2.default,
	            null,
	            _react2.default.createElement(_reactIntl.FormattedMessage, {
	              id: 'Availability.ada_detailsLink',
	              values: { title: title,
	                format: intl.formatMessage({ id: 'FORMAT.' + format.toLowerCase() }),
	                status: status ? intl.formatMessage({ id: 'circ_' + status.toLowerCase() }, { location: availabilityLocationType }) : '' } })
	          )
	        )
	      );
	    }
	  }]);
	
	  return AvailabilityLink;
	}(_baseBcReactComponent2.default);
	
	AvailabilityLink.propTypes = {
	  metadataId: _react.PropTypes.string.isRequired,
	  router: _reactRouter.routerShape,
	  availabilityDetailActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  title: _react.PropTypes.string.isRequired,
	  format: _react.PropTypes.string.isRequired,
	  status: _react.PropTypes.string,
	  availabilityLocationType: _react.PropTypes.string,
	  intl: _reactIntl.intlShape
	};
	
	AvailabilityLink.contextTypes = {
	  isWidget: _react.PropTypes.bool
	};
	
	exports.default = (0, _reactRouter.withRouter)((0, _reactIntl.injectIntl)(AvailabilityLink));

/***/ },
/* 1005 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AvailabilityLink = __webpack_require__(1004);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AvailabilityLink).default;
	  }
	});
	Object.defineProperty(exports, 'AvailabilityLink', {
	  enumerable: true,
	  get: function get() {
	    return _AvailabilityLink.AvailabilityLink;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1006 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _availabilityLink = __webpack_require__(1005);
	
	var _availabilityLink2 = _interopRequireDefault(_availabilityLink);
	
	var _availabilityStatus = __webpack_require__(361);
	
	var _availabilityStatus2 = _interopRequireDefault(_availabilityStatus);
	
	var _holdCounts = __webpack_require__(364);
	
	var _holdCounts2 = _interopRequireDefault(_holdCounts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  availabilityDetailActions: _react.PropTypes.object.isRequired,
	  availabilityStatus: _react.PropTypes.object.isRequired,
	  bib: _react.PropTypes.object.isRequired,
	  holdable: _react.PropTypes.bool,
	  showAvailabilityLink: _react.PropTypes.bool,
	  showHoldCount: _react.PropTypes.bool,
	  showAvailabilityStatus: _react.PropTypes.bool
	};
	
	var PhysicalBlock = function PhysicalBlock(_ref) {
	  var availabilityDetailActions = _ref.availabilityDetailActions,
	      availabilityStatus = _ref.availabilityStatus,
	      bib = _ref.bib,
	      holdable = _ref.holdable,
	      showAvailabilityLink = _ref.showAvailabilityLink,
	      showHoldCount = _ref.showHoldCount,
	      showAvailabilityStatus = _ref.showAvailabilityStatus;
	  return _react2.default.createElement(
	    'div',
	    { className: 'cp-physical-availability-block' },
	    showAvailabilityStatus && _react2.default.createElement(_availabilityStatus2.default, {
	      availabilityLocationType: availabilityStatus.get('availabilityLocationType'),
	      rollUpStatus: availabilityStatus.get('status'),
	      status: availabilityStatus.get('localisedStatus') }),
	    '\xA0',
	    showAvailabilityLink ? _react2.default.createElement(_availabilityLink2.default, {
	      metadataId: bib.get('id'),
	      availabilityDetailActions: availabilityDetailActions,
	      title: bib.get('title'),
	      format: bib.get('format'),
	      status: showAvailabilityStatus && availabilityStatus.get('localisedStatus') || null,
	      availabilityLocationType: availabilityStatus.get('availabilityLocationType') }) : null,
	    _react2.default.createElement('br', null),
	    holdable && showHoldCount ? _react2.default.createElement(_holdCounts2.default, {
	      heldCopies: availabilityStatus.get('heldCopies'),
	      availableCopies: availabilityStatus.get('availableCopies'),
	      totalCopies: availabilityStatus.get('totalCopies') }) : null
	  );
	};
	
	PhysicalBlock.propTypes = propTypes;
	PhysicalBlock.defaultProps = {
	  showAvailabilityLink: true,
	  showAvailabilityStatus: true
	};
	
	exports.default = PhysicalBlock;

/***/ },
/* 1007 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PhysicalBlock = __webpack_require__(1006);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PhysicalBlock).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1008 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = AvailabilityStatus;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	__webpack_require__(2650);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function AvailabilityStatus(_ref) {
	  var status = _ref.status,
	      rollUpStatus = _ref.rollUpStatus,
	      availabilityLocationType = _ref.availabilityLocationType,
	      props = _objectWithoutProperties(_ref, ['status', 'rollUpStatus', 'availabilityLocationType']);
	
	  return _react2.default.createElement(
	    _reactIntl.FormattedMessage,
	    {
	      id: 'circ_' + (status ? status.toLowerCase() : rollUpStatus.toLowerCase()),
	      values: { location: availabilityLocationType } },
	    function (statusMessage) {
	      return _react2.default.createElement(
	        'span',
	        _extends({}, props, { className: 'cp-availability-status ' + rollUpStatus.toLowerCase(), 'data-key': 'availability-status-' + rollUpStatus.toLowerCase() }),
	        statusMessage
	      );
	    }
	  );
	}
	
	AvailabilityStatus.propTypes = {
	  status: _react.PropTypes.string.isRequired,
	  rollUpStatus: _react.PropTypes.string.isRequired,
	  availabilityLocationType: _react.PropTypes.string.isRequired
	};

/***/ },
/* 1009 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AccessibleDatePicker = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(16);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(9);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactIntl = __webpack_require__(3);
	
	var _airbnbPropTypes = __webpack_require__(42);
	
	var _reactDates = __webpack_require__(2966);
	
	var _defaultPhrases = __webpack_require__(50);
	
	var _isInclusivelyAfterDay = __webpack_require__(213);
	
	var _isInclusivelyAfterDay2 = _interopRequireDefault(_isInclusivelyAfterDay);
	
	var _getPhrasePropTypes = __webpack_require__(63);
	
	var _getPhrasePropTypes2 = _interopRequireDefault(_getPhrasePropTypes);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseIcons = __webpack_require__(10);
	
	var _baseFullScreenOverlay = __webpack_require__(45);
	
	var _baseFullScreenOverlay2 = _interopRequireDefault(_baseFullScreenOverlay);
	
	var _baseButtons = __webpack_require__(12);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	__webpack_require__(2967);
	
	__webpack_require__(2764);
	
	__webpack_require__(2652);
	
	__webpack_require__(2651);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Initial component setup for airbnb/react-dates library
	
	
	// Initial css setup for airbnb/react-dates library
	
	
	var AccessibleDatePicker = exports.AccessibleDatePicker = function (_BcReactComponent) {
	  _inherits(AccessibleDatePicker, _BcReactComponent);
	
	  function AccessibleDatePicker(props) {
	    _classCallCheck(this, AccessibleDatePicker);
	
	    var _this = _possibleConstructorReturn(this, (AccessibleDatePicker.__proto__ || Object.getPrototypeOf(AccessibleDatePicker)).call(this, props));
	
	    _this.state = {
	      date: props.initialDate ? (0, _moment2.default)(props.initialDate) : (0, _moment2.default)()
	    };
	
	    _this.bindAll('onDateChange', 'renderExtraButtons', 'renderPhraseOverrides');
	    return _this;
	  }
	
	  _createClass(AccessibleDatePicker, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.addEventListener('click', this.handleDocumentClick.bind(this));
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener('click', this.handleDocumentClick.bind(this));
	    }
	  }, {
	    key: 'handleDocumentClick',
	    value: function handleDocumentClick(e) {
	      var wrapper = this._datePicker;
	      if (wrapper && wrapper !== e.target && !wrapper.contains(e.target)) {
	        this.props.handleClose();
	      }
	    }
	  }, {
	    key: 'onDateChange',
	    value: function onDateChange(date) {
	      var _this2 = this;
	
	      this.props.onDateChange(_moment2.default.isMoment(date) ? date.format('YYYY-MM-DD') : date);
	      this.setState({ date: (0, _moment2.default)(date) }, function () {
	        return setTimeout(function () {
	          _this2.props.handleClose();
	        }, 100);
	      });
	    }
	  }, {
	    key: 'renderPhraseOverrides',
	    value: function renderPhraseOverrides() {
	      var intl = this.props.intl;
	
	      // Overrides default screen reader phrases for interactive elements like previous, next buttons
	
	      return _extends({}, _defaultPhrases.SingleDatePickerPhrases, {
	        jumpToPrevMonth: intl.formatMessage({ id: 'calendar_prev_month' }),
	        jumpToNextMonth: intl.formatMessage({ id: 'calendar_next_month' }),
	        dateIsUnavailable: function dateIsUnavailable(_ref) {
	          var date = _ref.date;
	          return intl.formatMessage({ id: 'calendar_date_is_unavailable' }, { date: date });
	        },
	        dateIsSelected: function dateIsSelected(_ref2) {
	          var date = _ref2.date;
	          return intl.formatMessage({ id: 'calendar_date_is_selected' }, { date: date });
	        }
	      });
	    }
	  }, {
	    key: 'renderExtraButtons',
	    value: function renderExtraButtons() {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'date-picker-extra-buttons item-row' },
	        _react2.default.createElement(
	          _baseButtons.TextButton,
	          { className: 'item-column', handleClick: function handleClick() {
	              return _this3.onDateChange((0, _moment2.default)().format());
	            } },
	          _react2.default.createElement(_reactIntl.FormattedMessage, {
	            id: 'calendar_today',
	            values: {
	              date: _react2.default.createElement(
	                _baseScreenReaderMessage2.default,
	                null,
	                _react2.default.createElement(_reactIntl.FormattedDate, { value: (0, _moment2.default)().format(), year: 'numeric', month: 'short', day: '2-digit' })
	              )
	            } })
	        ),
	        _react2.default.createElement(
	          _baseButtons.TextButton,
	          { className: 'item-column', handleClick: this.props.handleClose },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_close' })
	        )
	      );
	    }
	  }, {
	    key: 'renderDatePickerPopUp',
	    value: function renderDatePickerPopUp(props) {
	      var _this4 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-accessible-date-picker-pop-up', ref: function ref(el) {
	            _this4._datePicker = el;
	          } },
	        _react2.default.createElement(
	          'div',
	          { className: 'cp-accessible-date-picker-content' },
	          this.props.children
	        ),
	        this.props.open && _react2.default.createElement(_reactDates.DayPickerSingleDateController, _extends({}, props, {
	          date: this.state.date,
	          withPortal: false,
	          phrases: this.renderPhraseOverrides(),
	          onDateChange: function onDateChange(dateValue) {
	            return _this4.onDateChange(dateValue);
	          },
	          renderCalendarInfo: this.renderExtraButtons }))
	      );
	    }
	  }, {
	    key: 'renderFullScreenOverlayDatePicker',
	    value: function renderFullScreenOverlayDatePicker(props) {
	      var _this5 = this;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _baseFullScreenOverlay2.default,
	          {
	            className: 'accessible-date-picker-full-screen-overlay',
	            open: this.props.open,
	            handleClose: this.props.handleClose },
	          _react2.default.createElement(_reactDates.DayPickerSingleDateController, _extends({}, props, {
	            date: this.state.date,
	            phrases: this.renderPhraseOverrides(),
	            onDateChange: function onDateChange(dateValue) {
	              return _this5.onDateChange(dateValue);
	            },
	            renderCalendarInfo: this.renderExtraButtons }))
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'cp-accessible-date-picker-content' },
	          this.props.children
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var props = _lodash2.default.omit(this.props, ['initialDate', 'open', 'handleClose', 'intl', 'children', 'displayFormat', 'inputIconPosition', 'fullScreen', 'className']);
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-accessible-date-picker ' + this.props.className },
	        this.props.fullScreen ? this.renderFullScreenOverlayDatePicker(props) : this.renderDatePickerPopUp(props)
	      );
	    }
	  }]);
	
	  return AccessibleDatePicker;
	}(_baseBcReactComponent2.default);
	
	var defaultProps = {
	  numberOfMonths: 1,
	  displayFormat: function displayFormat() {
	    return _moment2.default.localeData().longDateFormat('L');
	  },
	  inputIconPosition: 'after',
	  navPrev: _react2.default.createElement(_baseIcons.Angle.Left, null),
	  navNext: _react2.default.createElement(_baseIcons.Angle.Right, null),
	  hideKeyboardShortcutsPanel: true,
	  withPortal: true,
	  initialDate: null,
	  isOutsideRange: function isOutsideRange(day) {
	    return !(0, _isInclusivelyAfterDay2.default)(day, (0, _moment2.default)());
	  },
	  focused: true,
	  fullScreen: false,
	  className: ''
	
	};
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)({
	  // Props for AccessibleDatePicker component
	  intl: _reactIntl.intlShape,
	  open: _react.PropTypes.bool,
	  handleClose: _react.PropTypes.func.isRequired,
	  children: _bcPropTypes.childrenShape,
	  fullScreen: _react.PropTypes.bool,
	  className: _react.PropTypes.string,
	  // Props for DayPickerSingleDateController component
	  initialDate: _react.PropTypes.string,
	  onDateChange: _react.PropTypes.func,
	  focused: _react.PropTypes.bool,
	  onFocusChange: _react.PropTypes.func,
	  navPrev: _react.PropTypes.node,
	  navNext: _react.PropTypes.node,
	  phrases: _react.PropTypes.shape((0, _getPhrasePropTypes2.default)(_defaultPhrases.SingleDatePickerPhrases)),
	  noBorder: _react.PropTypes.bool,
	  hideKeyboardShortcutsPanel: _react.PropTypes.bool,
	  displayFormat: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.func]),
	  small: _react.PropTypes.bool,
	  withPortal: _react.PropTypes.bool,
	  inputIconPosition: _react.PropTypes.string,
	  numberOfMonths: _react.PropTypes.number,
	  renderCalendarInfo: _react.PropTypes.func,
	  customInputIcon: _react.PropTypes.node,
	  isOutsideRange: _react.PropTypes.func,
	  focus: _react.PropTypes.bool
	});
	
	AccessibleDatePicker.propTypes = propTypes;
	AccessibleDatePicker.defaultProps = defaultProps;
	
	exports.default = (0, _reactIntl.injectIntl)(AccessibleDatePicker);

/***/ },
/* 1010 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.shouldAllowBackwardTab = exports.shouldAllowForwardTab = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = manageFocus;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(104);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _tabbable = __webpack_require__(507);
	
	var _tabbable2 = _interopRequireDefault(_tabbable);
	
	var _lodash = __webpack_require__(16);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _utilsAccessibility = __webpack_require__(95);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TAB_KEYCODE = 9;
	
	/**
	 * Returns true if nodeA comes after nodeB in the DOM
	 */
	var nodeIsAfter = function nodeIsAfter(nodeA, nodeB) {
	  return !!(nodeA.compareDocumentPosition(nodeB) & Node.DOCUMENT_POSITION_PRECEDING);
	}; // eslint-disable-line no-bitwise
	
	/**
	* Returns true if nodeA comes before nodeB in the DOM
	*/
	var nodeIsBefore = function nodeIsBefore(nodeA, nodeB) {
	  return !!(nodeA.compareDocumentPosition(nodeB) & Node.DOCUMENT_POSITION_FOLLOWING);
	}; // eslint-disable-line no-bitwise
	
	
	var isSameTabbableElement = function isSameTabbableElement(target, compareTo) {
	  if (target === compareTo) {
	    return true;
	  }
	
	  // Radio buttons are in the same tabbable group but there are special rules to determine which can be tabbed to
	  // We don't care about those and just want to know if the whole group is the first or last element
	  if (target.nodeName === 'INPUT' && target.type === 'radio' && compareTo.nodeName === 'INPUT' && compareTo.type === 'radio') {
	    return target.name === compareTo.name;
	  }
	
	  return false;
	};
	
	var shouldAllowForwardTab = exports.shouldAllowForwardTab = function shouldAllowForwardTab(_ref) {
	  var currentElement = _ref.currentElement,
	      lastTabbable = _ref.lastTabbable;
	
	  var isAfterLastTabbableElement = nodeIsAfter(currentElement, lastTabbable);
	  var isLastTabbableElement = isSameTabbableElement(currentElement, lastTabbable);
	
	  return !isLastTabbableElement && !isAfterLastTabbableElement;
	};
	
	var shouldAllowBackwardTab = exports.shouldAllowBackwardTab = function shouldAllowBackwardTab(_ref2) {
	  var currentElement = _ref2.currentElement,
	      firstTabbable = _ref2.firstTabbable;
	
	  var isBeforeFirstTabbableElement = nodeIsBefore(currentElement, firstTabbable);
	  var isFirstTabbableElement = isSameTabbableElement(currentElement, firstTabbable);
	
	  return !isFirstTabbableElement && !isBeforeFirstTabbableElement;
	};
	
	/**
	 * Higher order component that restricts focus/tabbing to the content with the component
	 *
	 * @export
	 * @param {React.Component} ComposedComponent
	 * @returns {React.Component}
	 */
	function manageFocus(ComposedComponent) {
	  var ManageFocus = function (_BcReactComponent) {
	    _inherits(ManageFocus, _BcReactComponent);
	
	    function ManageFocus(props) {
	      _classCallCheck(this, ManageFocus);
	
	      var _this = _possibleConstructorReturn(this, (ManageFocus.__proto__ || Object.getPrototypeOf(ManageFocus)).call(this, props));
	
	      _this.bindAll('handleKeyDown', 'captureFocus', 'restoreFocus', 'getWrappedInstance');
	      _this._focusCaptured = false;
	      return _this;
	    }
	
	    _createClass(ManageFocus, [{
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        this.restoreFocus();
	      }
	
	      /**
	       * Traps the focus within the element
	       *
	       * @param {DOMNode} element
	       *
	       * @memberOf ManageFocus
	       */
	
	    }, {
	      key: 'captureFocus',
	      value: function captureFocus(element) {
	        var restrictFocus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	        if (this._focusCaptured) {
	          // captureFocus should not do anything if the focus is already constrained to the element
	          return;
	        }
	
	        this._element = _reactDom2.default.findDOMNode(element); // eslint-disable-line react/no-find-dom-node
	
	        if (this._element) {
	          this._focusCaptured = true;
	
	          // Store previously focused element and focus the mounted component
	          this._previouslyFocusedElement = (0, _utilsAccessibility.getActiveElement)(document);
	
	          if (this.props.handleFocusOnCapture) {
	            this.props.handleFocusOnCapture(this._element);
	          } else {
	            (0, _utilsAccessibility.setFocusWithinElement)(this._element);
	          }
	
	          if (restrictFocus) {
	            this._element.addEventListener('keydown', this.handleKeyDown);
	          }
	        }
	      }
	
	      /**
	       *
	       * Releases any focus restrictions and restores focus back to the element that had it before captureFocus was called
	       *
	       * @memberOf ManageFocus
	       */
	
	    }, {
	      key: 'restoreFocus',
	      value: function restoreFocus(elementToFocusOn) {
	        if (!this._focusCaptured) {
	          // restoreFocus cannot be called until captureFocus has been called
	          return;
	        }
	
	        if (this._element) {
	          this._element.removeEventListener('keydown', this.handleKeyDown);
	        }
	
	        var elementToRestoreFocusTo = elementToFocusOn || this._previouslyFocusedElement;
	        if (this.props.handleFocusOnRestore) {
	          this.props.handleFocusOnRestore(elementToRestoreFocusTo);
	        } else {
	          // Restore focus to the previously focused element
	          elementToRestoreFocusTo.focus();
	        }
	
	        this._element = null;
	        this._previouslyFocusedElement = null;
	        this._focusCaptured = false;
	      }
	    }, {
	      key: 'handleKeyDown',
	      value: function handleKeyDown(e) {
	        if (e.keyCode === TAB_KEYCODE) {
	          var tabbableElements = (0, _tabbable2.default)(this._element);
	          var lastTabbable = _lodash2.default.last(tabbableElements);
	          var firstTabbable = _lodash2.default.first(tabbableElements);
	
	          var allowForwardTab = shouldAllowForwardTab({ currentElement: e.target, lastTabbable: lastTabbable });
	          var allowBackwardTab = shouldAllowBackwardTab({ currentElement: e.target, firstTabbable: firstTabbable });
	
	          if (!allowForwardTab && !e.shiftKey) {
	            // If this is the last tabbable element in the component,
	            // we hijack the Tab key and move focus to the first element
	            e.preventDefault();
	            firstTabbable.focus();
	          } else if (!allowBackwardTab && e.shiftKey) {
	            // If this is the first tabbable element in the component and they're holding shift,
	            // we hijack the key and move focus to the last element
	            e.preventDefault();
	            lastTabbable.focus();
	          }
	        }
	      }
	    }, {
	      key: 'getWrappedInstance',
	      value: function getWrappedInstance() {
	        return this._wrappedComponent;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _this2 = this;
	
	        return _react2.default.createElement(ComposedComponent, _extends({}, this.props, {
	          captureFocus: this.captureFocus,
	          restoreFocus: this.restoreFocus,
	          ref: function ref(el) {
	            return _this2._wrappedComponent = el;
	          } }));
	      }
	    }]);
	
	    return ManageFocus;
	  }(_baseBcReactComponent2.default);
	
	  ManageFocus.propTypes = {
	    handleFocusOnCapture: _react.PropTypes.func,
	    handleFocusOnRestore: _react.PropTypes.func
	  };
	
	  ManageFocus.displayName = 'ManageFocus(' + ComposedComponent.displayName + ')';
	  ManageFocus.WrappedComponent = ComposedComponent;
	
	  return ManageFocus;
	}

/***/ },
/* 1011 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AccessiblePopOver = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _basePopupManager = __webpack_require__(523);
	
	var _basePopupManager2 = _interopRequireDefault(_basePopupManager);
	
	var _baseButtons = __webpack_require__(12);
	
	var _baseIcons = __webpack_require__(10);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	__webpack_require__(2653);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var handleTriggerClick = function handleTriggerClick(e, popupActions) {
	  e.preventDefault();
	  popupActions.toggleContent();
	};
	
	var AccessiblePopOver = exports.AccessiblePopOver = function (_BcReactComponent) {
	  _inherits(AccessiblePopOver, _BcReactComponent);
	
	  function AccessiblePopOver(props) {
	    _classCallCheck(this, AccessiblePopOver);
	
	    var _this = _possibleConstructorReturn(this, (AccessiblePopOver.__proto__ || Object.getPrototypeOf(AccessiblePopOver)).call(this, props));
	
	    _this.bindAll('getTriggerWidth', 'getArrowOffset', 'renderTrigger', 'renderPopUp', 'setTriggerRef');
	    return _this;
	  }
	
	  _createClass(AccessiblePopOver, [{
	    key: 'getTriggerWidth',
	    value: function getTriggerWidth() {
	      return this._trigger ? this._trigger.getBoundingClientRect().width : 0;
	    }
	  }, {
	    key: 'getArrowOffset',
	    value: function getArrowOffset() {
	      var offset = Math.floor(this.getTriggerWidth() / 2);
	      return offset + 'px';
	    }
	  }, {
	    key: 'renderTrigger',
	    value: function renderTrigger(popupActions) {
	      return _react2.default.createElement(
	        'a',
	        {
	          className: 'trigger-link',
	          ref: this.setTriggerRef,
	          href: this.props.href,
	          onClick: function onClick(e) {
	            return handleTriggerClick(e, popupActions);
	          } },
	        this.props.triggerContent
	      );
	    }
	  }, {
	    key: 'setTriggerRef',
	    value: function setTriggerRef(el) {
	      this._trigger = el;
	    }
	  }, {
	    key: 'renderCloseButton',
	    value: function renderCloseButton(popupActions) {
	      // eslint-disable-line class-methods-use-this
	      var handleClose = function handleClose(e) {
	        e.preventDefault();
	        popupActions.closeAndFocusContent();
	      };
	
	      return _react2.default.createElement(
	        _baseButtons.TextButton,
	        {
	          className: 'close-button',
	          handleClick: handleClose },
	        _react2.default.createElement(
	          _baseScreenReaderMessage2.default,
	          null,
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_close' })
	        ),
	        _react2.default.createElement(_baseIcons.Cross, null)
	      );
	    }
	  }, {
	    key: 'renderPopUp',
	    value: function renderPopUp(popupActions) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'absolute-wrapper' },
	        _react2.default.createElement(
	          'div',
	          { className: 'pop-up' },
	          _react2.default.createElement('div', {
	            className: 'pop-up-arrow',
	            style: { left: this.getArrowOffset() } }),
	          this.props.children,
	          this.renderCloseButton(popupActions)
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _basePopupManager2.default,
	        { className: 'cp-accessible-pop-over', renderContent: this.renderPopUp },
	        this.renderTrigger
	      );
	    }
	  }]);
	
	  return AccessiblePopOver;
	}(_baseBcReactComponent2.default);
	
	AccessiblePopOver.propTypes = {
	  href: _react.PropTypes.string,
	  triggerContent: _react.PropTypes.node,
	  children: _react.PropTypes.node
	};
	
	exports.default = AccessiblePopOver;

/***/ },
/* 1012 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AccessibleTextArea = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _omit = __webpack_require__(754);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	var _sharedFieldErrorWrapper = __webpack_require__(366);
	
	var _sharedFieldErrorWrapper2 = _interopRequireDefault(_sharedFieldErrorWrapper);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseCharacterCount = __webpack_require__(518);
	
	var _baseCharacterCount2 = _interopRequireDefault(_baseCharacterCount);
	
	var _utilsBrowser = __webpack_require__(59);
	
	__webpack_require__(2654);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AccessibleTextArea = exports.AccessibleTextArea = function (_BcReactComponent) {
	  _inherits(AccessibleTextArea, _BcReactComponent);
	
	  function AccessibleTextArea(props) {
	    _classCallCheck(this, AccessibleTextArea);
	
	    var _this = _possibleConstructorReturn(this, (AccessibleTextArea.__proto__ || Object.getPrototypeOf(AccessibleTextArea)).call(this, props));
	
	    _this.state = {
	      height: '0'
	    };
	
	    _this.bindAll('handleChange', 'handlePaste', 'getTextAreaStyle', 'updateHeightToFitText');
	    return _this;
	  }
	
	  _createClass(AccessibleTextArea, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.fitToText) {
	        this.updateHeightToFitText();
	      }
	    }
	  }, {
	    key: 'getTextAreaStyle',
	    value: function getTextAreaStyle() {
	      if (!this.state.height || !this.props.fitToText) {
	        return {};
	      }
	      return { height: this.state.height + 'px', overflow: 'hidden' };
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange() {
	      var value = this._textarea.value;
	
	      if (this.props.handleChange) {
	        this.props.handleChange(value);
	      }
	
	      if (this.props.fitToText) {
	        this.updateHeightToFitText();
	      }
	    }
	  }, {
	    key: 'handlePaste',
	    value: function handlePaste(e) {
	      var value = (0, _utilsBrowser.getTextFromPasteEvent)(e);
	
	      if (this.props.handlePaste) {
	        this.props.handlePaste(value);
	      }
	    }
	  }, {
	    key: 'updateRemainingCount',
	    value: function updateRemainingCount(charactersUsed) {
	      this.setState({
	        remainingCount: this.props.maxLength - charactersUsed || 0
	      });
	    }
	  }, {
	    key: 'updateHeightToFitText',
	    value: function updateHeightToFitText() {
	      var _this2 = this;
	
	      // Set the height to 0 so scrollHeight will reflect true height of text
	      // (this is necessary because the scrollHeight is not updated when text is removed)
	      // See http://bdadam.com/blog/automatically-adapting-the-height-textarea.html
	      this.setState({ height: '0' }, function () {
	        _this2.setState({ height: '' + _this2._textarea.scrollHeight });
	      });
	    }
	  }, {
	    key: 'renderCharacterCount',
	    value: function renderCharacterCount() {
	      var _props = this.props,
	          value = _props.value,
	          suggestedMaxLength = _props.suggestedMaxLength,
	          maxLength = _props.maxLength;
	
	      if (suggestedMaxLength || maxLength) {
	        return _react2.default.createElement(_baseCharacterCount2.default, {
	          count: value ? value.length : 0,
	          limit: suggestedMaxLength || maxLength });
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          value = _props2.value,
	          defaultValue = _props2.defaultValue,
	          placeholder = _props2.placeholder,
	          className = _props2.className,
	          labelledById = _props2.labelledById,
	          describedById = _props2.describedById,
	          disabled = _props2.disabled,
	          required = _props2.required,
	          maxLength = _props2.maxLength,
	          name = _props2.name,
	          handleFocus = _props2.handleFocus,
	          handleBlur = _props2.handleBlur,
	          setFocus = _props2.setFocus,
	          testId = _props2.testId;
	
	      var textAreaClass = 'form-control ' + className;
	
	      var textAreaProps = (0, _omit2.default)(this.props, ['labelledById', 'describedById', 'disabled', 'fitToText', 'required', 'suggestedMaxLength', 'maxLength', 'name', 'className', 'setFocus', 'placeholder', 'value', 'defaultValue', 'testId', 'handleChange', 'handlePaste', 'handleFocus', 'handleBlur', 'intl']);
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-accessible-text-area clearfix' },
	        _react2.default.createElement('textarea', _extends({
	          className: textAreaClass,
	          'aria-labelledby': labelledById,
	          'aria-describedby': describedById,
	          placeholder: placeholder,
	          defaultValue: defaultValue,
	          value: value,
	          disabled: disabled,
	          maxLength: maxLength,
	          required: required,
	          name: name,
	          ref: function ref(el) {
	            _this3._textarea = el;
	          },
	          onChange: this.handleChange,
	          onPaste: this.handlePaste,
	          onFocus: handleFocus,
	          onBlur: handleBlur,
	          autoFocus: setFocus,
	          'data-test-id': testId,
	          style: this.getTextAreaStyle()
	        }, textAreaProps)),
	        this.renderCharacterCount()
	      );
	    }
	  }]);
	
	  return AccessibleTextArea;
	}(_baseBcReactComponent2.default);
	
	AccessibleTextArea.propTypes = {
	  id: _react.PropTypes.string,
	  labelledById: _react.PropTypes.string.isRequired,
	  describedById: _react.PropTypes.string,
	  disabled: _react.PropTypes.bool,
	  fitToText: _react.PropTypes.bool,
	  required: _react.PropTypes.bool,
	  suggestedMaxLength: _react.PropTypes.number,
	  maxLength: _react.PropTypes.number,
	  name: _react.PropTypes.string,
	  className: _react.PropTypes.string,
	  setFocus: _react.PropTypes.bool,
	  placeholder: _react.PropTypes.string,
	  value: _react.PropTypes.string,
	  defaultValue: _react.PropTypes.string,
	  testId: _react.PropTypes.string,
	  handleChange: _react.PropTypes.func,
	  handlePaste: _react.PropTypes.func,
	  handleFocus: _react.PropTypes.func,
	  handleBlur: _react.PropTypes.func
	};
	
	AccessibleTextArea.defaultProps = {
	  className: '',
	  fitToText: false
	};
	
	exports.default = (0, _sharedFieldErrorWrapper2.default)(AccessibleTextArea);

/***/ },
/* 1013 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AccessibleTextField = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsBrowser = __webpack_require__(59);
	
	var _sharedFieldErrorWrapper = __webpack_require__(366);
	
	var _sharedFieldErrorWrapper2 = _interopRequireDefault(_sharedFieldErrorWrapper);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseCharacterCount = __webpack_require__(518);
	
	var _baseCharacterCount2 = _interopRequireDefault(_baseCharacterCount);
	
	var _bcPropTypes = __webpack_require__(5);
	
	__webpack_require__(2655);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AccessibleTextField = exports.AccessibleTextField = function (_BcReactComponent) {
	  _inherits(AccessibleTextField, _BcReactComponent);
	
	  function AccessibleTextField(props) {
	    _classCallCheck(this, AccessibleTextField);
	
	    var _this = _possibleConstructorReturn(this, (AccessibleTextField.__proto__ || Object.getPrototypeOf(AccessibleTextField)).call(this, props));
	
	    _this.bindAll('handleChange', 'handlePaste');
	    return _this;
	  }
	
	  _createClass(AccessibleTextField, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // for testing purposes.
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange() {
	      var value = this._textInput.value;
	      if (this.props.handleChange) {
	        this.props.handleChange(value);
	      }
	    }
	  }, {
	    key: 'handlePaste',
	    value: function handlePaste(e) {
	      var value = (0, _utilsBrowser.getTextFromPasteEvent)(e);
	      if (this.props.handlePaste) {
	        this.props.handlePaste(value);
	      }
	    }
	  }, {
	    key: 'renderInfo',
	    value: function renderInfo() {
	      return this.props.info ? _react2.default.createElement(
	        'div',
	        { className: 'info' },
	        this.props.info
	      ) : null;
	    }
	  }, {
	    key: 'renderInputIcon',
	    value: function renderInputIcon() {
	      return this.props.inputIcon ? this.props.inputIcon : null;
	    }
	  }, {
	    key: 'renderCharacterCount',
	    value: function renderCharacterCount() {
	      var _props = this.props,
	          value = _props.value,
	          suggestedMaxLength = _props.suggestedMaxLength,
	          maxLength = _props.maxLength,
	          characterCountSrOnly = _props.characterCountSrOnly;
	
	      if (suggestedMaxLength || maxLength) {
	        return _react2.default.createElement(_baseCharacterCount2.default, {
	          screenReaderOnly: characterCountSrOnly,
	          count: value ? value.length : 0,
	          limit: suggestedMaxLength || maxLength });
	      }
	
	      return null;
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      if (this._textInput) {
	        this._textInput.focus();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-accessible-text-field clearfix' },
	        _react2.default.createElement(
	          'div',
	          { className: 'input-holder' },
	          _react2.default.createElement('input', {
	            id: this.props.id,
	            type: this.props.type,
	            className: 'form-control ' + this.props.className,
	            ref: function ref(el) {
	              _this2._textInput = el;
	            },
	            'aria-labelledby': this.props.labelledById,
	            'aria-describedby': this.props.describedById,
	            disabled: this.props.disabled,
	            onChange: this.handleChange,
	            onPaste: this.handlePaste,
	            onFocus: this.props.handleFocus,
	            onBlur: this.props.handleBlur,
	            maxLength: this.props.maxLength,
	            name: this.props.name,
	            pattern: this.props.pattern,
	            placeholder: this.props.placeholder,
	            readOnly: this.props.readOnly,
	            required: this.props.required,
	            value: this.props.value,
	            autoFocus: this.props.focus,
	            'data-test-id': this.props.testId }),
	          this.renderInputIcon()
	        ),
	        this.renderInfo(),
	        this.renderCharacterCount()
	      );
	    }
	  }]);
	
	  return AccessibleTextField;
	}(_baseBcReactComponent2.default);
	
	var WrappedAccessibleTextField = (0, _sharedFieldErrorWrapper2.default)(AccessibleTextField);
	
	WrappedAccessibleTextField.propTypes = {
	  id: _react.PropTypes.string,
	  className: _react.PropTypes.string,
	  describedById: _react.PropTypes.string.isRequired,
	  disabled: _react.PropTypes.bool,
	  handleChange: _react.PropTypes.func,
	  handlePaste: _react.PropTypes.func,
	  handleBlur: _react.PropTypes.func,
	  handleFocus: _react.PropTypes.func,
	  info: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.element]),
	  labelledById: _react.PropTypes.string.isRequired,
	  showRemainingCharacterCount: _react.PropTypes.bool,
	  suggestedMaxLength: _react.PropTypes.number,
	  maxLength: _react.PropTypes.number,
	  name: _react.PropTypes.string,
	  pattern: _react.PropTypes.string,
	  type: _react.PropTypes.string,
	  focus: _react.PropTypes.bool,
	  placeholder: _react.PropTypes.string,
	  readOnly: _react.PropTypes.bool,
	  required: _react.PropTypes.bool,
	  value: _react.PropTypes.string,
	  testId: _react.PropTypes.string,
	  characterCountSrOnly: _react.PropTypes.bool,
	  inputIcon: _react.PropTypes.element,
	  fieldErrors: _react.PropTypes.objectOf(_bcPropTypes.fieldErrorsShape),
	  errorKey: _react.PropTypes.string
	};
	
	WrappedAccessibleTextField.defaultProps = {
	  type: 'text'
	};
	
	exports.default = WrappedAccessibleTextField;

/***/ },
/* 1014 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _dismiss = __webpack_require__(515);
	
	var _dismiss2 = _interopRequireDefault(_dismiss);
	
	__webpack_require__(2656);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Alert = function Alert(_ref) {
	  var className = _ref.className,
	      renderIcon = _ref.renderIcon,
	      handleDismiss = _ref.handleDismiss,
	      children = _ref.children;
	
	  var classNames = 'alert cp-alert ' + className;
	
	  return _react2.default.createElement(
	    'div',
	    { className: classNames, role: 'alert', 'aria-live': 'polite', 'aria-atomic': 'true' },
	    renderIcon && _react2.default.createElement(
	      'span',
	      { className: 'alert-icon' },
	      renderIcon()
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'alert-content' },
	      children
	    ),
	    handleDismiss && _react2.default.createElement(_dismiss2.default, { handleDismiss: handleDismiss })
	  );
	};
	
	Alert.propTypes = {
	  className: _react.PropTypes.string,
	  renderIcon: _react.PropTypes.func,
	  handleDismiss: _react.PropTypes.func,
	  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node])
	};
	
	Alert.defaultProps = {
	  className: ''
	};
	
	exports.default = Alert;

/***/ },
/* 1015 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = AlertDismiss;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	var _baseIcons = __webpack_require__(10);
	
	__webpack_require__(2657);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AlertDismiss(_ref) {
	  var handleDismiss = _ref.handleDismiss;
	
	  return _react2.default.createElement(
	    'button',
	    {
	      type: 'button',
	      className: 'close cp-alert-dismiss',
	      onClick: handleDismiss },
	    _react2.default.createElement(
	      _baseScreenReaderMessage2.default,
	      null,
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_close' })
	    ),
	    _react2.default.createElement(_baseIcons.Cross, null)
	  );
	}
	
	AlertDismiss.propTypes = {
	  handleDismiss: _react.PropTypes.func.isRequired
	};

/***/ },
/* 1016 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseIcons = __webpack_require__(10);
	
	var _alert = __webpack_require__(175);
	
	var _alert2 = _interopRequireDefault(_alert);
	
	__webpack_require__(2658);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AlertFailure = function AlertFailure(_ref) {
	  var handleDismiss = _ref.handleDismiss,
	      children = _ref.children;
	  return _react2.default.createElement(
	    _alert2.default,
	    {
	      className: 'alert-danger cp-alert-failure',
	      renderIcon: function renderIcon() {
	        return _react2.default.createElement(_baseIcons.Failure, null);
	      },
	      handleDismiss: handleDismiss },
	    children
	  );
	};
	
	AlertFailure.propTypes = {
	  handleDismiss: _react.PropTypes.func,
	  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node])
	};
	
	exports.default = AlertFailure;

/***/ },
/* 1017 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AlertFailure = __webpack_require__(1016);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AlertFailure).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1018 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseIcons = __webpack_require__(10);
	
	var _alert = __webpack_require__(175);
	
	var _alert2 = _interopRequireDefault(_alert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AlertInfo = function AlertInfo(_ref) {
	  var handleDismiss = _ref.handleDismiss,
	      children = _ref.children;
	  return _react2.default.createElement(
	    _alert2.default,
	    {
	      className: 'alert-info cp-alert-info',
	      renderIcon: function renderIcon() {
	        return _react2.default.createElement(_baseIcons.Info, null);
	      },
	      handleDismiss: handleDismiss },
	    children
	  );
	};
	
	AlertInfo.propTypes = {
	  handleDismiss: _react.PropTypes.func,
	  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node])
	};
	
	exports.default = AlertInfo;

/***/ },
/* 1019 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AlertInfo = __webpack_require__(1018);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AlertInfo).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1020 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _alert = __webpack_require__(175);
	
	var _alert2 = _interopRequireDefault(_alert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AlertNeutral = function AlertNeutral(_ref) {
	  var handleDismiss = _ref.handleDismiss,
	      children = _ref.children;
	  return _react2.default.createElement(
	    _alert2.default,
	    {
	      className: 'alert-neutral cp-alert-neutral',
	      handleDismiss: handleDismiss },
	    children
	  );
	};
	
	AlertNeutral.propTypes = {
	  handleDismiss: _react.PropTypes.func,
	  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node])
	};
	
	exports.default = AlertNeutral;

/***/ },
/* 1021 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AlertNeutral = __webpack_require__(1020);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AlertNeutral).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1022 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseIcons = __webpack_require__(10);
	
	var _alert = __webpack_require__(175);
	
	var _alert2 = _interopRequireDefault(_alert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AlertSuccess = function AlertSuccess(_ref) {
	  var handleDismiss = _ref.handleDismiss,
	      children = _ref.children;
	  return _react2.default.createElement(
	    _alert2.default,
	    {
	      className: 'alert-success cp-alert-success',
	      renderIcon: function renderIcon() {
	        return _react2.default.createElement(_baseIcons.CheckmarkCircle, null);
	      },
	      handleDismiss: handleDismiss },
	    children
	  );
	};
	
	AlertSuccess.propTypes = {
	  handleDismiss: _react.PropTypes.func,
	  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node])
	};
	
	exports.default = AlertSuccess;

/***/ },
/* 1023 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AlertSuccess = __webpack_require__(1022);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AlertSuccess).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1024 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseIcons = __webpack_require__(10);
	
	var _alert = __webpack_require__(175);
	
	var _alert2 = _interopRequireDefault(_alert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AlertWarning = function AlertWarning(_ref) {
	  var handleDismiss = _ref.handleDismiss,
	      children = _ref.children;
	  return _react2.default.createElement(
	    _alert2.default,
	    {
	      className: 'alert-warning cp-alert-warning',
	      renderIcon: function renderIcon() {
	        return _react2.default.createElement(_baseIcons.Warning, null);
	      },
	      handleDismiss: handleDismiss },
	    children
	  );
	};
	
	AlertWarning.propTypes = {
	  handleDismiss: _react.PropTypes.func,
	  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node])
	};
	
	exports.default = AlertWarning;

/***/ },
/* 1025 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AlertWarning = __webpack_require__(1024);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AlertWarning).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1026 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _reactRouter = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var renderAuthorLink = function renderAuthorLink(author, target, renderAsLink) {
	  var index = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
	
	  if (renderAsLink) {
	    return _react2.default.createElement(
	      _reactRouter.Link,
	      {
	        key: index,
	        className: 'author-link',
	        activeClassName: 'active-search-link',
	        target: target,
	        rel: 'noopener noreferrer',
	        to: { pathname: '/v2/search', query: { query: author, searchType: 'author' } } },
	      author
	    );
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { key: index, className: 'author-link' },
	    author
	  );
	};
	
	function AuthorLink(_ref) {
	  var _ref$authors = _ref.authors,
	      authors = _ref$authors === undefined ? [] : _ref$authors,
	      _ref$target = _ref.target,
	      target = _ref$target === undefined ? '_parent' : _ref$target,
	      _ref$renderAsLink = _ref.renderAsLink,
	      renderAsLink = _ref$renderAsLink === undefined ? true : _ref$renderAsLink;
	
	  var normalizedAuthors = Array.isArray(authors) ? authors : authors.toJS();
	
	  if (normalizedAuthors.length) {
	    if (normalizedAuthors.length >= 1) {
	      var links = normalizedAuthors.map(function (author, i) {
	        return _react2.default.createElement(
	          'span',
	          { key: author + '-' + i },
	          renderAuthorLink(author, target, renderAsLink, i),
	          i < normalizedAuthors.length - 1 ? ' • ' : ''
	        );
	      });
	
	      return _react2.default.createElement(
	        'span',
	        { className: 'author-link-list' },
	        links
	      );
	    }
	
	    return _react2.default.createElement(
	      'span',
	      { className: 'author-link-list' },
	      renderAuthorLink(normalizedAuthors[0], target, renderAsLink)
	    );
	  }
	
	  return _react2.default.createElement('noop', null);
	}
	
	AuthorLink.propTypes = {
	  authors: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.string), _reactImmutableProptypes2.default.listOf(_react.PropTypes.string)]),
	  target: _react.PropTypes.string,
	  renderAsLink: _react.PropTypes.bool
	};
	
	AuthorLink.displayName = 'AuthorLink';
	
	exports.default = AuthorLink;

/***/ },
/* 1027 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AuthorLink = __webpack_require__(1026);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AuthorLink).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1028 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _rxjs = __webpack_require__(169);
	
	var _rxjs2 = _interopRequireDefault(_rxjs);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseButtons = __webpack_require__(12);
	
	var _baseIcons = __webpack_require__(10);
	
	__webpack_require__(2659);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BackToTop = function (_BcReactComponent) {
	  _inherits(BackToTop, _BcReactComponent);
	
	  function BackToTop(props) {
	    _classCallCheck(this, BackToTop);
	
	    var _this = _possibleConstructorReturn(this, (BackToTop.__proto__ || Object.getPrototypeOf(BackToTop)).call(this, props));
	
	    _this.state = {
	      visible: false
	    };
	
	    _this.lastScrollPosition = 0;
	    _this.animationFrame = null;
	
	    _this.bindAll('handleClick', 'handleScroll');
	    return _this;
	  }
	
	  _createClass(BackToTop, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.intervalScrollChecker = setInterval(function () {
	        _this2.animationFrame = window.requestAnimationFrame(_this2.handleScroll);
	      }, this.props.scrollWaitTime);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.intervalScrollChecker) {
	        window.clearInterval(this.intervalScrollChecker);
	      }
	
	      if (this.animationFrame) {
	        window.cancelAnimationFrame(this.animationFrame);
	      }
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick() {
	      var initialScrollY = window.pageYOffset || document.documentElement.scrollTop;
	      var frameRate = 1000 / 60; // 60 FPS
	      var animationDuration = this.props.animationDuration;
	
	      var easingFnc = function easingFnc(time, begin, change, duration) {
	        return (// Cubic out
	          change * ((time = time / duration - 1) * time * time + 1) + begin
	        );
	      }; // eslint-disable-line
	
	      _rxjs.Observable.timer(0, frameRate, _rxjs2.default.Scheduler.animationFrame).map(function (i) {
	        return i * frameRate;
	      }).map(function (time) {
	        return easingFnc(time, initialScrollY, -initialScrollY, animationDuration);
	      }).concat(_rxjs.Observable.of(0)).takeWhile(function (val) {
	        return val > 0;
	      }).subscribe(function (val) {
	        return window.scroll(0, val);
	      });
	    }
	  }, {
	    key: 'handleScroll',
	    value: function handleScroll() {
	      var startPos = this.lastScrollPosition;
	      var endPos = window.pageYOffset;
	      var scrollDifference = Math.abs(endPos - startPos);
	      var scrolledFarEnough = Math.min(endPos, scrollDifference) > this.props.scrollUpwardsThreshold;
	
	      if (scrolledFarEnough) {
	        var amountNeededToScroll = window.innerHeight * (this.props.percentViewportScrolled / 100.0);
	        var visible = endPos > amountNeededToScroll && endPos < startPos;
	        this.setState({
	          visible: visible
	        });
	      }
	
	      this.lastScrollPosition = endPos;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var classnames = (0, _classnames2.default)('cp-back-to-top', { 'scrolled-visible': this.state.visible });
	      return _react2.default.createElement(
	        _baseButtons.SecondaryButton,
	        { className: classnames, handleClick: this.handleClick },
	        _react2.default.createElement(_baseIcons.Arrows.medium.Up, { color: '#fff' }),
	        ' ',
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'back_to_top' })
	      );
	    }
	  }]);
	
	  return BackToTop;
	}(_baseBcReactComponent2.default);
	
	exports.default = BackToTop;
	
	
	BackToTop.propTypes = {
	  // How long to wait for scrolling before calculating if the button should show
	  scrollWaitTime: _react.PropTypes.number,
	
	  // How far down the page the user has to have already scrolled before the button is allowed to be shown
	  // This is relative to the viewport, so if the value is 50%, the user must have scrolled 234px on a 468px height device
	  percentViewportScrolled: _react.PropTypes.number,
	
	  // How many pixels the user must scroll upwards before the button is shown
	  scrollUpwardsThreshold: _react.PropTypes.number,
	
	  // Duration of the scroll to top animation
	  animationDuration: _react.PropTypes.number
	};
	
	BackToTop.defaultProps = {
	  scrollWaitTime: 50,
	  percentViewportScrolled: 40,
	  scrollUpwardsThreshold: 20,
	  animationDuration: 700
	};

/***/ },
/* 1029 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BackToTop = __webpack_require__(1028);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BackToTop).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1030 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _utilsImmutable = __webpack_require__(374);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BcReactComponent = function (_Component) {
	  _inherits(BcReactComponent, _Component);
	
	  function BcReactComponent() {
	    _classCallCheck(this, BcReactComponent);
	
	    return _possibleConstructorReturn(this, (BcReactComponent.__proto__ || Object.getPrototypeOf(BcReactComponent)).apply(this, arguments));
	  }
	
	  _createClass(BcReactComponent, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return !(0, _utilsImmutable.shallowEquals)(this.props, nextProps) || !(0, _utilsImmutable.shallowEquals)(this.state, nextState);
	    }
	  }, {
	    key: 'bindAll',
	    value: function bindAll() {
	      var _this2 = this;
	
	      for (var _len = arguments.length, methods = Array(_len), _key = 0; _key < _len; _key++) {
	        methods[_key] = arguments[_key];
	      }
	
	      methods.forEach(function (method) {
	        _this2[method] = _this2[method].bind(_this2);
	      });
	    }
	  }]);
	
	  return BcReactComponent;
	}(_react.Component);
	
	exports.default = BcReactComponent;

/***/ },
/* 1031 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseIcons = __webpack_require__(10);
	
	var _button = __webpack_require__(82);
	
	var _button2 = _interopRequireDefault(_button);
	
	__webpack_require__(2660);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function BlueCaretArrowButton(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$children = _ref.children,
	      children = _ref$children === undefined ? '' : _ref$children,
	      _ref$caretUp = _ref.caretUp,
	      caretUp = _ref$caretUp === undefined ? false : _ref$caretUp,
	      props = _objectWithoutProperties(_ref, ['className', 'children', 'caretUp']);
	
	  return _react2.default.createElement(
	    _button2.default,
	    _extends({}, props, { className: 'cp-blue-caret-arrow-button ' + className }),
	    children,
	    caretUp ? _react2.default.createElement(_baseIcons.Carets.Up, null) : _react2.default.createElement(_baseIcons.Carets.Down, null)
	  );
	}
	
	BlueCaretArrowButton.propTypes = {
	  className: _react2.default.PropTypes.string,
	  children: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.arrayOf(_react2.default.PropTypes.node), _react2.default.PropTypes.node]).isRequired,
	  caretUp: _react2.default.PropTypes.bool
	};
	
	exports.default = BlueCaretArrowButton;

/***/ },
/* 1032 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BlueCaretArrowButton = __webpack_require__(1031);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BlueCaretArrowButton).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1033 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.BlueTextButton = BlueTextButton;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _button = __webpack_require__(82);
	
	var _button2 = _interopRequireDefault(_button);
	
	__webpack_require__(2661);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function BlueTextButton(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$children = _ref.children,
	      children = _ref$children === undefined ? '' : _ref$children,
	      props = _objectWithoutProperties(_ref, ['className', 'children']);
	
	  return _react2.default.createElement(
	    _button2.default,
	    _extends({}, props, { className: 'cp-blue-text-button ' + className }),
	    children
	  );
	}
	
	BlueTextButton.propTypes = {
	  className: _react2.default.PropTypes.string,
	  children: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.arrayOf(_react2.default.PropTypes.node), _react2.default.PropTypes.node]).isRequired
	};
	
	BlueTextButton.displayName = 'BlueTextButton';
	
	exports.default = BlueTextButton;

/***/ },
/* 1034 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BlueTextButton = __webpack_require__(1033);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BlueTextButton).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1035 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseIcons = __webpack_require__(10);
	
	var _bcPropTypes = __webpack_require__(5);
	
	__webpack_require__(2662);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  className: _react.PropTypes.string,
	  handleClick: _react.PropTypes.func,
	  disabled: _react.PropTypes.bool,
	  children: _bcPropTypes.childrenShape.isRequired,
	  loadingText: _bcPropTypes.childrenShape,
	  isLoading: _react.PropTypes.bool,
	  tagName: _react.PropTypes.string,
	  spinnerColor: _react.PropTypes.string,
	  spinnerPrimary: _react.PropTypes.bool,
	  block: _react.PropTypes.bool,
	  flat: _react.PropTypes.bool,
	  dataKey: _react.PropTypes.string
	};
	
	var Button = function (_BcReactComponent) {
	  _inherits(Button, _BcReactComponent);
	
	  function Button(props) {
	    _classCallCheck(this, Button);
	
	    var _this = _possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).call(this, props));
	
	    _this.bindAll('handleClick');
	    return _this;
	  }
	
	  _createClass(Button, [{
	    key: 'handleClick',
	    value: function handleClick(e) {
	      if (this.props.isLoading) {
	        e.preventDefault();
	        return;
	      }
	      if (this.props.handleClick) {
	        e.preventDefault();
	        this.props.handleClick(e);
	      }
	    }
	  }, {
	    key: 'renderSpinner',
	    value: function renderSpinner() {
	      var _props = this.props,
	          isLoading = _props.isLoading,
	          spinnerColor = _props.spinnerColor,
	          spinnerPrimary = _props.spinnerPrimary;
	
	      return isLoading && _react2.default.createElement(_baseIcons.Spinner, { color: spinnerColor, primary: spinnerPrimary });
	    }
	  }, {
	    key: 'renderContents',
	    value: function renderContents() {
	      var _props2 = this.props,
	          isLoading = _props2.isLoading,
	          loadingText = _props2.loadingText,
	          children = _props2.children;
	
	
	      return isLoading ? loadingText && _react2.default.createElement(
	        'span',
	        { className: 'btn-loading-content' },
	        loadingText
	      ) : children;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          className = _props3.className,
	          block = _props3.block,
	          flat = _props3.flat,
	          dataKey = _props3.dataKey,
	          Tag = _props3.tagName,
	          props = _objectWithoutProperties(_props3, ['className', 'block', 'flat', 'dataKey', 'tagName']);
	
	      delete props.handleClick;
	      delete props.currentPage;
	      delete props.spinnerPrimary;
	      delete props.isLoading;
	      delete props.spinnerColor;
	      delete props.loadingText;
	      delete props.children;
	
	      return _react2.default.createElement(
	        Tag,
	        _extends({}, props, {
	          onClick: this.handleClick,
	          className: Button.getButtonClassName(className, block, flat),
	          'data-key': dataKey }),
	        this.renderContents(),
	        this.renderSpinner()
	      );
	    }
	  }], [{
	    key: 'getButtonClassName',
	    value: function getButtonClassName() {
	      var classes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	      var isBlock = arguments[1];
	      var isFlat = arguments[2];
	
	      return (0, _classnames2.default)('cp-btn', 'btn', classes, {
	        'btn-block': isBlock,
	        'btn-flat': isFlat
	      });
	    }
	  }]);
	
	  return Button;
	}(_baseBcReactComponent2.default);
	
	Button.propTypes = propTypes;
	Button.defaultProps = {
	  tagName: 'button'
	};
	Button.displayName = 'Button';
	
	exports.default = Button;

/***/ },
/* 1036 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DefaultButton = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _button = __webpack_require__(82);
	
	var _button2 = _interopRequireDefault(_button);
	
	__webpack_require__(2663);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable react/prefer-stateless-function */
	var DefaultButton = exports.DefaultButton = function (_React$Component) {
	  _inherits(DefaultButton, _React$Component);
	
	  function DefaultButton() {
	    _classCallCheck(this, DefaultButton);
	
	    return _possibleConstructorReturn(this, (DefaultButton.__proto__ || Object.getPrototypeOf(DefaultButton)).apply(this, arguments));
	  }
	
	  _createClass(DefaultButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          _props$className = _props.className,
	          className = _props$className === undefined ? '' : _props$className,
	          _props$children = _props.children,
	          children = _props$children === undefined ? '' : _props$children,
	          _props$spinnerColor = _props.spinnerColor,
	          spinnerColor = _props$spinnerColor === undefined ? '' : _props$spinnerColor,
	          props = _objectWithoutProperties(_props, ['className', 'children', 'spinnerColor']);
	
	      var classNames = 'cp-default-btn btn-default ' + className;
	
	      return _react2.default.createElement(
	        _button2.default,
	        _extends({ className: classNames, spinnerColor: spinnerColor }, props),
	        children
	      );
	    }
	  }]);
	
	  return DefaultButton;
	}(_react2.default.Component);
	
	DefaultButton.propTypes = {
	  className: _react2.default.PropTypes.string,
	  children: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.arrayOf(_react2.default.PropTypes.node), _react2.default.PropTypes.node]).isRequired,
	  spinnerColor: _react2.default.PropTypes.string,
	  dataKey: _react2.default.PropTypes.string
	};
	DefaultButton.displayName = 'DefaultButton';
	
	exports.default = DefaultButton;

/***/ },
/* 1037 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DefaultButton = __webpack_require__(1036);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DefaultButton).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1038 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.GhostButton = GhostButton;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _button = __webpack_require__(82);
	
	var _button2 = _interopRequireDefault(_button);
	
	__webpack_require__(2664);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function GhostButton(_ref) {
	  var children = _ref.children,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$spinnerColor = _ref.spinnerColor,
	      spinnerColor = _ref$spinnerColor === undefined ? '#FFF' : _ref$spinnerColor,
	      props = _objectWithoutProperties(_ref, ['children', 'className', 'spinnerColor']);
	
	  var classNames = 'cp-ghost-btn ' + className;
	
	  return _react2.default.createElement(
	    _button2.default,
	    _extends({ className: classNames, spinnerColor: spinnerColor }, props),
	    children
	  );
	}
	
	GhostButton.propTypes = {
	  className: _react.PropTypes.string,
	  isLoading: _react.PropTypes.bool,
	  handleClick: _react.PropTypes.func,
	  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node]).isRequired,
	  spinnerColor: _react.PropTypes.string
	};
	
	GhostButton.displayName = 'GhostButton';
	
	exports.default = GhostButton;

/***/ },
/* 1039 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _button = __webpack_require__(82);
	
	var _button2 = _interopRequireDefault(_button);
	
	__webpack_require__(2665);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function HighlightButton(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$children = _ref.children,
	      children = _ref$children === undefined ? '' : _ref$children,
	      props = _objectWithoutProperties(_ref, ['className', 'children']);
	
	  var classNames = 'btn-highlight ' + className;
	
	  return _react2.default.createElement(
	    _button2.default,
	    _extends({ className: classNames }, props),
	    children
	  );
	}
	
	HighlightButton.propTypes = {
	  className: _react2.default.PropTypes.string,
	  children: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.arrayOf(_react2.default.PropTypes.node), _react2.default.PropTypes.node]).isRequired
	};
	
	HighlightButton.displayName = 'HighlightButton';
	
	exports.default = HighlightButton;

/***/ },
/* 1040 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _HighlightButton = __webpack_require__(1039);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_HighlightButton).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1041 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _button = __webpack_require__(82);
	
	var _button2 = _interopRequireDefault(_button);
	
	__webpack_require__(2666);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable react/prefer-stateless-function */
	var IconButton = function (_React$Component) {
	  _inherits(IconButton, _React$Component);
	
	  function IconButton() {
	    _classCallCheck(this, IconButton);
	
	    return _possibleConstructorReturn(this, (IconButton.__proto__ || Object.getPrototypeOf(IconButton)).apply(this, arguments));
	  }
	
	  _createClass(IconButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          _props$className = _props.className,
	          className = _props$className === undefined ? '' : _props$className,
	          _props$children = _props.children,
	          children = _props$children === undefined ? '' : _props$children,
	          buttonProps = _objectWithoutProperties(_props, ['className', 'children']);
	
	      return _react2.default.createElement(
	        _button2.default,
	        _extends({
	          spinnerPrimary: true,
	          className: 'cp-icon-button ' + className }, buttonProps),
	        children
	      );
	    }
	  }]);
	
	  return IconButton;
	}(_react2.default.Component);
	
	IconButton.propTypes = _extends({}, _button2.default.propTypes, {
	  children: _bcPropTypes.childrenShape.isRequired,
	  className: _react2.default.PropTypes.string
	});
	IconButton.displayName = 'IconButton';
	
	exports.default = IconButton;

/***/ },
/* 1042 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _IconButton = __webpack_require__(1041);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_IconButton).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1043 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PrimaryGhostButton = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ghost = __webpack_require__(516);
	
	var _ghost2 = _interopRequireDefault(_ghost);
	
	__webpack_require__(2667);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable react/prefer-stateless-function */
	var PrimaryGhostButton = exports.PrimaryGhostButton = function (_React$Component) {
	  _inherits(PrimaryGhostButton, _React$Component);
	
	  function PrimaryGhostButton() {
	    _classCallCheck(this, PrimaryGhostButton);
	
	    return _possibleConstructorReturn(this, (PrimaryGhostButton.__proto__ || Object.getPrototypeOf(PrimaryGhostButton)).apply(this, arguments));
	  }
	
	  _createClass(PrimaryGhostButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          _props$className = _props.className,
	          className = _props$className === undefined ? '' : _props$className,
	          children = _props.children,
	          props = _objectWithoutProperties(_props, ['className', 'children']);
	
	      var classNames = 'cp-primary-ghost-btn primary-ghost-btn ' + className;
	
	      return _react2.default.createElement(
	        _ghost2.default,
	        _extends({ className: classNames }, props),
	        children
	      );
	    }
	  }]);
	
	  return PrimaryGhostButton;
	}(_react2.default.Component);
	
	PrimaryGhostButton.propTypes = {
	  className: _react2.default.PropTypes.string,
	  children: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.arrayOf(_react2.default.PropTypes.node), _react2.default.PropTypes.node]).isRequired
	};
	
	PrimaryGhostButton.displayName = 'PrimaryGhostButton';
	
	exports.default = PrimaryGhostButton;

/***/ },
/* 1044 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PrimaryGhostButton = __webpack_require__(1043);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PrimaryGhostButton).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1045 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _button = __webpack_require__(82);
	
	var _button2 = _interopRequireDefault(_button);
	
	__webpack_require__(2668);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  className: _react2.default.PropTypes.string,
	  children: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.arrayOf(_react2.default.PropTypes.node), _react2.default.PropTypes.node]).isRequired,
	  spinnerColor: _react2.default.PropTypes.string
	};
	
	/* eslint-disable react/prefer-stateless-function */
	
	var PrimaryButton = function (_React$Component) {
	  _inherits(PrimaryButton, _React$Component);
	
	  function PrimaryButton() {
	    _classCallCheck(this, PrimaryButton);
	
	    return _possibleConstructorReturn(this, (PrimaryButton.__proto__ || Object.getPrototypeOf(PrimaryButton)).apply(this, arguments));
	  }
	
	  _createClass(PrimaryButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          _props$className = _props.className,
	          className = _props$className === undefined ? '' : _props$className,
	          _props$children = _props.children,
	          children = _props$children === undefined ? '' : _props$children,
	          _props$spinnerColor = _props.spinnerColor,
	          spinnerColor = _props$spinnerColor === undefined ? '#FFF' : _props$spinnerColor,
	          props = _objectWithoutProperties(_props, ['className', 'children', 'spinnerColor']);
	
	      var classNames = 'cp-primary-btn btn-primary ' + className;
	
	      return _react2.default.createElement(
	        _button2.default,
	        _extends({ className: classNames, spinnerColor: spinnerColor }, props),
	        children
	      );
	    }
	  }]);
	
	  return PrimaryButton;
	}(_react2.default.Component);
	
	PrimaryButton.propTypes = propTypes;
	PrimaryButton.displayName = 'PrimaryButton';
	exports.default = PrimaryButton;

/***/ },
/* 1046 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PrimaryButton = __webpack_require__(1045);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PrimaryButton).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1047 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseIcons = __webpack_require__(10);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	__webpack_require__(2669);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  className: _react2.default.PropTypes.string,
	  handleClick: _react2.default.PropTypes.func,
	  tagName: _react2.default.PropTypes.string,
	  isLoading: _react2.default.PropTypes.bool
	};
	
	var RemoveButton = function (_BcReactComponent) {
	  _inherits(RemoveButton, _BcReactComponent);
	
	  function RemoveButton(props) {
	    _classCallCheck(this, RemoveButton);
	
	    var _this = _possibleConstructorReturn(this, (RemoveButton.__proto__ || Object.getPrototypeOf(RemoveButton)).call(this, props));
	
	    _this.bindAll('handleClick');
	    return _this;
	  }
	
	  _createClass(RemoveButton, [{
	    key: 'getButtonClassName',
	    value: function getButtonClassName() {
	      return 'cp-remove-btn btn btn-remove ' + this.props.className;
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(e) {
	      if (this.props.handleClick && !this.props.isLoading) {
	        e.preventDefault();
	        this.props.handleClick();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var Tag = this.props.tagName;
	      return _react2.default.createElement(
	        Tag,
	        { onClick: this.handleClick, className: this.getButtonClassName() },
	        this.props.isLoading ? _react2.default.createElement(_baseIcons.Spinner, { color: '#FFF' }) : _react2.default.createElement(_baseIcons.Remove, { className: 'icon-svg-remove small', width: '12', height: '12' })
	      );
	    }
	  }]);
	
	  return RemoveButton;
	}(_baseBcReactComponent2.default);
	
	RemoveButton.propTypes = propTypes;
	RemoveButton.defaultProps = {
	  tagName: 'button',
	  isLoading: false
	};
	
	exports.default = RemoveButton;

/***/ },
/* 1048 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _RemoveButton = __webpack_require__(1047);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RemoveButton).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1049 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _button = __webpack_require__(82);
	
	var _button2 = _interopRequireDefault(_button);
	
	__webpack_require__(2670);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var propTypes = {
	  className: _react2.default.PropTypes.string,
	  children: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.arrayOf(_react2.default.PropTypes.node), _react2.default.PropTypes.node]).isRequired,
	  spinnerColor: _react2.default.PropTypes.string
	};
	
	function SecondaryButton(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$children = _ref.children,
	      children = _ref$children === undefined ? '' : _ref$children,
	      _ref$spinnerColor = _ref.spinnerColor,
	      spinnerColor = _ref$spinnerColor === undefined ? '#FFF' : _ref$spinnerColor,
	      props = _objectWithoutProperties(_ref, ['className', 'children', 'spinnerColor']);
	
	  var classNames = 'btn-secondary ' + className;
	
	  return _react2.default.createElement(
	    _button2.default,
	    _extends({ className: classNames, spinnerColor: spinnerColor }, props),
	    children
	  );
	}
	
	SecondaryButton.propTypes = propTypes;
	SecondaryButton.displayName = 'SecondaryButton';
	
	exports.default = SecondaryButton;

/***/ },
/* 1050 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SecondaryButton = __webpack_require__(1049);
	
	var _SecondaryButton2 = _interopRequireDefault(_SecondaryButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _SecondaryButton2.default; /*
	                                              * Exports
	                                              */

/***/ },
/* 1051 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _button = __webpack_require__(82);
	
	var _button2 = _interopRequireDefault(_button);
	
	__webpack_require__(2671);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable react/prefer-stateless-function */
	var TextButton = function (_React$Component) {
	  _inherits(TextButton, _React$Component);
	
	  function TextButton() {
	    _classCallCheck(this, TextButton);
	
	    return _possibleConstructorReturn(this, (TextButton.__proto__ || Object.getPrototypeOf(TextButton)).apply(this, arguments));
	  }
	
	  _createClass(TextButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          _props$className = _props.className,
	          className = _props$className === undefined ? '' : _props$className,
	          _props$children = _props.children,
	          children = _props$children === undefined ? '' : _props$children,
	          showLoadingText = _props.showLoadingText,
	          buttonProps = _objectWithoutProperties(_props, ['className', 'children', 'showLoadingText']);
	
	      return _react2.default.createElement(
	        _button2.default,
	        _extends({
	          spinnerPrimary: true,
	          className: 'cp-text-button ' + className,
	          loadingText: showLoadingText && children
	        }, buttonProps),
	        children
	      );
	    }
	  }]);
	
	  return TextButton;
	}(_react2.default.Component);
	
	TextButton.propTypes = _extends({}, _button2.default.propTypes, {
	  children: _bcPropTypes.childrenShape.isRequired,
	  className: _react2.default.PropTypes.string,
	  showLoadingText: _react2.default.PropTypes.bool
	});
	TextButton.displayName = 'TextButton';
	
	exports.default = TextButton;

/***/ },
/* 1052 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TextButton = __webpack_require__(1051);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TextButton).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1053 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _button = __webpack_require__(82);
	
	var _button2 = _interopRequireDefault(_button);
	
	__webpack_require__(2672);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var propTypes = {
	  className: _react2.default.PropTypes.string,
	  spinnerColor: _react2.default.PropTypes.string,
	  children: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.arrayOf(_react2.default.PropTypes.node), _react2.default.PropTypes.node]).isRequired,
	  dataKey: _react2.default.PropTypes.string
	};
	
	function TransactionalButton(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$children = _ref.children,
	      children = _ref$children === undefined ? '' : _ref$children,
	      _ref$spinnerColor = _ref.spinnerColor,
	      spinnerColor = _ref$spinnerColor === undefined ? '#FFF' : _ref$spinnerColor,
	      props = _objectWithoutProperties(_ref, ['className', 'children', 'spinnerColor']);
	
	  var classNames = 'btn-transactional ' + className;
	
	  return _react2.default.createElement(
	    _button2.default,
	    _extends({ className: classNames, spinnerColor: spinnerColor }, props),
	    children
	  );
	}
	
	TransactionalButton.propTypes = propTypes;
	
	TransactionalButton.displayName = 'TransactionalButton';
	
	exports.default = TransactionalButton;

/***/ },
/* 1054 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TransactionalButton = __webpack_require__(1053);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TransactionalButton).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1055 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseAuthorLink = __webpack_require__(1027);
	
	var _baseAuthorLink2 = _interopRequireDefault(_baseAuthorLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function ByAuthorBlock(_ref) {
	  var _ref$authors = _ref.authors,
	      authors = _ref$authors === undefined ? _immutable2.default.List() : _ref$authors,
	      _ref$target = _ref.target,
	      target = _ref$target === undefined ? '_parent' : _ref$target,
	      _ref$renderAsLink = _ref.renderAsLink,
	      renderAsLink = _ref$renderAsLink === undefined ? true : _ref$renderAsLink,
	      props = _objectWithoutProperties(_ref, ['authors', 'target', 'renderAsLink']);
	
	  if (authors.length || authors.count()) {
	    return _react2.default.createElement(
	      'span',
	      _extends({ className: 'cp-by-author-block' }, props),
	      _react2.default.createElement(_reactIntl.FormattedMessage, {
	        id: 'by_authors',
	        values: {
	          authorLinks: _react2.default.createElement(_baseAuthorLink2.default, {
	            authors: authors,
	            target: target,
	            renderAsLink: renderAsLink })
	        } })
	    );
	  }
	
	  return _react2.default.createElement('noop', null);
	}
	
	ByAuthorBlock.propTypes = {
	  authors: _reactImmutableProptypes2.default.listOf(_react.PropTypes.string),
	  target: _react.PropTypes.string,
	  renderAsLink: _react.PropTypes.bool
	};
	
	ByAuthorBlock.displayName = 'ByAuthorBlock';
	
	exports.default = ByAuthorBlock;

/***/ },
/* 1056 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = CharacterCount;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	__webpack_require__(2673);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CharacterCount(_ref) {
	  var count = _ref.count,
	      limit = _ref.limit,
	      _ref$screenReaderOnly = _ref.screenReaderOnly,
	      screenReaderOnly = _ref$screenReaderOnly === undefined ? false : _ref$screenReaderOnly;
	
	  var srOnlyClass = screenReaderOnly ? 'sr-only' : '';
	  var overLimitClass = count > limit ? 'over-limit' : '';
	  var totalText = _react2.default.createElement(
	    'span',
	    { className: '' + overLimitClass },
	    count
	  );
	  return _react2.default.createElement(
	    'small',
	    {
	      className: srOnlyClass + ' cp-character-count' },
	    _react2.default.createElement(
	      'div',
	      { 'aria-hidden': 'true', 'data-test-id': 'character-count-characters-used' },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'fraction_of_characters_used', values: { total: totalText, limit: limit } })
	    ),
	    _react2.default.createElement(
	      _baseScreenReaderMessage2.default,
	      null,
	      _react2.default.createElement(
	        _reactIntl.FormattedMessage,
	        { id: 'fraction_of_characters_used_screen_reader', values: { total: count, limit: limit } },
	        function (message) {
	          return _react2.default.createElement(
	            'div',
	            { 'aria-live': 'polite', 'aria-atomic': 'true' },
	            message
	          );
	        }
	      )
	    )
	  );
	}
	
	CharacterCount.propTypes = {
	  count: _react.PropTypes.number,
	  limit: _react.PropTypes.number,
	  screenReaderOnly: _react.PropTypes.bool
	};

/***/ },
/* 1057 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Checkbox = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _baseIcons = __webpack_require__(10);
	
	var Icons = _interopRequireWildcard(_baseIcons);
	
	__webpack_require__(2674);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Checkbox = exports.Checkbox = function (_BcReactComponent) {
	  _inherits(Checkbox, _BcReactComponent);
	
	  function Checkbox(props) {
	    _classCallCheck(this, Checkbox);
	
	    var _this = _possibleConstructorReturn(this, (Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).call(this, props));
	
	    _this.bindAll('setCheckbox', 'handleChange');
	    return _this;
	  }
	
	  _createClass(Checkbox, [{
	    key: 'setCheckbox',
	    value: function setCheckbox(el) {
	      this._checkbox = el;
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(e) {
	      e.preventDefault();
	      if (!this._checkbox) {
	        return;
	      }
	
	      var _props = this.props,
	          handleChange = _props.handleChange,
	          name = _props.name,
	          value = _props.value,
	          checked = _props.checked;
	
	      handleChange(!checked, {
	        name: name,
	        value: value
	      });
	    }
	  }, {
	    key: 'renderLabel',
	    value: function renderLabel() {
	      return _react2.default.createElement(
	        'label',
	        {
	          id: 'label_' + this.props.id,
	          htmlFor: this.props.id,
	          'data-test-id': this.props.labelTestId,
	          className: (0, _classnames2.default)('checkbox-label', {
	            'label-before': this.props.labelBefore,
	            'sr-only': this.props.srOnlyLabel,
	            'disabled-label': this.props.disabled
	          }) },
	        this.props.label
	      );
	    }
	  }, {
	    key: 'renderFakeCheckbox',
	    value: function renderFakeCheckbox() {
	      var _this2 = this;
	
	      var IconName = Icons[this.props.checked ? this.props.checkedIconName : this.props.uncheckedIconName];
	      var iconProps = this.props.checked ? this.props.checkedIconProps : this.props.uncheckedIconProps;
	      var buttonClassName = (0, _classnames2.default)('check', { 'no-borders': this.props.hideBorders, 'hide-icon': !IconName, 'checkbox-disabled': this.props.disabled });
	      var iconClassName = (0, _classnames2.default)('checkbox-icon', iconProps.className);
	      var setFocusElement = function setFocusElement(el) {
	        _this2._focusableElement = el;
	      };
	
	      if (!IconName) {
	        // We have to do this so the lack of icon doesn't cause "jumps" when you toggle between visible icon and no icon
	        IconName = Icons[this.props.checkedIconName];
	      }
	
	      return _react2.default.createElement(
	        'button',
	        { type: 'button', className: buttonClassName, role: 'checkbox', 'aria-checked': this.props.checked, 'aria-labelledby': 'label_' + this.props.id, onClick: this.handleChange, ref: setFocusElement },
	        IconName && _react2.default.createElement(IconName, _extends({}, iconProps, { className: iconClassName }))
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          labelBefore = _props2.labelBefore,
	          inline = _props2.inline,
	          variant = _props2.variant,
	          className = _props2.className,
	          props = _objectWithoutProperties(_props2, ['labelBefore', 'inline', 'variant', 'className']); // eslint-disable-line no-unused-vars
	
	      // Remove unused props before spreading
	
	
	      delete props.label;
	      delete props.checkedIconName;
	      delete props.checkedIconProps;
	      delete props.uncheckedIconName;
	      delete props.uncheckedIconProps;
	      delete props.handleChange;
	      delete props.labelTestId;
	      delete props.hideBorders;
	      delete props.srOnlyLabel;
	
	      var classNames = (0, _classnames2.default)('cp-checkbox', { 'inline-checkbox': inline }, 'checkbox-variant-' + variant);
	
	      return _react2.default.createElement(
	        'div',
	        { className: classNames },
	        labelBefore && this.renderLabel(),
	        !this.props.disabled && _react2.default.createElement('input', _extends({
	          type: 'checkbox',
	          ref: this.setCheckbox,
	          className: (0, _classnames2.default)('checkbox-input', className),
	          onChange: this.handleChange,
	          'aria-hidden': true
	        }, props)),
	        this.renderFakeCheckbox(),
	        !labelBefore && this.renderLabel()
	      );
	    }
	  }]);
	
	  return Checkbox;
	}(_baseBcReactComponent2.default);
	
	Checkbox.propTypes = {
	  /**
	   * id property for the checkbox. required for accessibility.
	   */
	  id: _react.PropTypes.string.isRequired,
	  /**
	   * Additional classes to pass to the checkbox container
	   */
	  className: _react.PropTypes.string,
	  /**
	   * Label should appear before Checkbox
	   */
	  labelBefore: _react.PropTypes.bool,
	  /**
	   * Label for the checkbox. Required for accessibility.
	   */
	  label: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node, _react.PropTypes.string]).isRequired,
	  /**
	   * Name for the checkbox. Required for accessibility.
	   */
	  name: _react.PropTypes.string,
	  /**
	   * Whether or not the checkbox is disabled
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * Function that gets called when the checkbox is checked/unchecked
	   * Function signature is `(checked : boolean, { name : string, value : string }) => void`
	   */
	  handleChange: _react.PropTypes.func,
	  /**
	   * Value to be passed to handleChange when checkbox is checked / unchecked
	   */
	  value: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string, _reactImmutableProptypes2.default.map]),
	  /**
	   * If the checkbox is checked or not
	   */
	  checked: _react.PropTypes.bool,
	  /**
	   * Checked by default
	   */
	  defaultChecked: _react.PropTypes.bool,
	  /**
	   * Icon to be used when checkbox is checked
	   */
	  checkedIconName: _react.PropTypes.string,
	  /**
	   * Props to be passed to the icon when checkbox is checked
	   */
	  checkedIconProps: _react.PropTypes.objectOf(_react.PropTypes.string, _react.PropTypes.any),
	  /**
	   * Icon to be used when checkbox is unchecked
	   */
	  uncheckedIconName: _react.PropTypes.string,
	  /**
	   * Props to be passed to the icon when checkbox is unchecked
	   */
	  uncheckedIconProps: _react.PropTypes.objectOf(_react.PropTypes.string, _react.PropTypes.any),
	  /**
	   * Checkbox should be displayed inline
	   */
	  inline: _react.PropTypes.bool,
	  /**
	   * Variant of the checkbox. It must be defined in the CSS.
	   */
	  variant: _react.PropTypes.oneOf(['primary', 'default', 'transparent']),
	  /**
	   * Hide borders on the checkbox
	   */
	  hideBorders: _react.PropTypes.bool,
	  labelTestId: _react.PropTypes.string,
	  srOnlyLabel: _react.PropTypes.bool
	};
	
	Checkbox.defaultProps = {
	  checked: false,
	  checkedIconName: 'Checkmark',
	  checkedIconProps: {},
	  uncheckedIconProps: {},
	  handleChange: function handleChange() {},
	
	  inline: false,
	  labelBefore: false,
	  disabled: false,
	  hideBorders: false,
	  variant: 'primary',
	  srOnlyLabel: false
	};
	
	exports.default = Checkbox;

/***/ },
/* 1058 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ClearableTextField = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseAccessibilityTextField = __webpack_require__(228);
	
	var _baseAccessibilityTextField2 = _interopRequireDefault(_baseAccessibilityTextField);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _baseButtons = __webpack_require__(12);
	
	var _baseIcons = __webpack_require__(10);
	
	__webpack_require__(2675);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ClearableTextField = exports.ClearableTextField = function (_BcReactComponent) {
	  _inherits(ClearableTextField, _BcReactComponent);
	
	  function ClearableTextField(props) {
	    _classCallCheck(this, ClearableTextField);
	
	    var _this = _possibleConstructorReturn(this, (ClearableTextField.__proto__ || Object.getPrototypeOf(ClearableTextField)).call(this, props));
	
	    _this.bindAll('handleClear', 'renderClearButton');
	    return _this;
	  }
	
	  _createClass(ClearableTextField, [{
	    key: 'handleClear',
	    value: function handleClear() {
	      this.props.handleClear();
	      if (this._textField) {
	        this._textField.getWrappedInstance().focus();
	      }
	    }
	  }, {
	    key: 'renderClearButtonScreenReaderText',
	    value: function renderClearButtonScreenReaderText() {
	      if (this.props.clearButtonSrText) {
	        return _react2.default.createElement(
	          _baseScreenReaderMessage2.default,
	          null,
	          this.props.clearButtonSrText
	        );
	      }
	
	      return _react2.default.createElement(
	        _reactIntl.FormattedMessage,
	        { id: 'ada_label_clear_text' },
	        function (message) {
	          return _react2.default.createElement(
	            _baseScreenReaderMessage2.default,
	            null,
	            message
	          );
	        }
	      );
	    }
	  }, {
	    key: 'renderClearButton',
	    value: function renderClearButton() {
	      if (!this.props.hideClearButton) {
	        return _react2.default.createElement(
	          _baseButtons.TextButton,
	          {
	            className: 'clear-icon',
	            handleClick: this.handleClear,
	            type: 'button' },
	          _react2.default.createElement(_baseIcons.Cross, null),
	          this.renderClearButtonScreenReaderText()
	        );
	      }
	
	      return _react2.default.createElement('noop', null);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-clearable-text-field' },
	        _react2.default.createElement(_baseAccessibilityTextField2.default, {
	          id: this.props.id,
	          value: this.props.value,
	          type: this.props.type,
	          labelledById: this.props.labelledById,
	          describedById: this.props.describedById,
	          fieldErrors: this.props.fieldErrors,
	          errorKey: this.props.errorKey,
	          handleChange: this.props.handleChange,
	          placeholder: this.props.placeholder,
	          maxLength: this.props.maxLength,
	          focus: this.props.focus,
	          testId: this.props.inputTestId,
	          info: this.props.info,
	          inputIcon: this.renderClearButton(),
	          className: this.props.className,
	          characterCountSrOnly: this.props.characterCountSrOnly,
	          ref: function ref(el) {
	            return _this2._textField = el;
	          } })
	      );
	    }
	  }]);
	
	  return ClearableTextField;
	}(_baseBcReactComponent2.default);
	
	ClearableTextField.propTypes = {
	  id: _react.PropTypes.string,
	  value: _react.PropTypes.string,
	  hideClearButton: _react.PropTypes.bool,
	  className: _react.PropTypes.string,
	  describedById: _react.PropTypes.string,
	  fieldErrors: _react.PropTypes.objectOf(_bcPropTypes.fieldErrorsShape),
	  errorKey: _react.PropTypes.string,
	  labelledById: _react.PropTypes.string.isRequired,
	  focus: _react.PropTypes.bool,
	  placeholder: _react.PropTypes.string,
	  maxLength: _react.PropTypes.number,
	  type: _react.PropTypes.string,
	  inputTestId: _react.PropTypes.string,
	  characterCountSrOnly: _react.PropTypes.bool,
	  info: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.element]),
	
	  handleChange: _react.PropTypes.func,
	  handleClear: _react.PropTypes.func
	};
	
	ClearableTextField.defaultProps = {
	  hideClearButton: false
	};
	
	exports.default = ClearableTextField;

/***/ },
/* 1059 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseDropdown = __webpack_require__(37);
	
	var _baseButtons = __webpack_require__(12);
	
	var _bcPropTypes = __webpack_require__(5);
	
	__webpack_require__(2676);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }
	
	function ComboButton(_ref) {
	  var options = _ref.options,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$btnClass = _ref.btnClass,
	      btnClass = _ref$btnClass === undefined ? '' : _ref$btnClass,
	      _ref$secondaryAriaLab = _ref.secondaryAriaLabel,
	      secondaryAriaLabel = _ref$secondaryAriaLab === undefined ? '' : _ref$secondaryAriaLab,
	      _handleClick = _ref.handleClick,
	      labelledById = _ref.labelledById,
	      label = _ref.label,
	      _ref$right = _ref.right,
	      right = _ref$right === undefined ? true : _ref$right,
	      _ref$isLoading = _ref.isLoading,
	      isLoading = _ref$isLoading === undefined ? false : _ref$isLoading,
	      _ref$ButtonTag = _ref.ButtonTag,
	      ButtonTag = _ref$ButtonTag === undefined ? _baseButtons.DefaultButton : _ref$ButtonTag,
	      children = _ref.children,
	      disabled = _ref.disabled,
	      _ref$dataKey = _ref.dataKey,
	      dataKey = _ref$dataKey === undefined ? '' : _ref$dataKey;
	
	  var _options = _toArray(options),
	      primary = _options[0],
	      secondary = _options.slice(1);
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'cp-combo-button btn-group ' + className },
	    _react2.default.createElement(
	      ButtonTag,
	      {
	        disabled: disabled,
	        className: btnClass,
	        isLoading: isLoading,
	        handleClick: function handleClick() {
	          return _handleClick(primary.value);
	        },
	        'data-key': dataKey },
	      primary.label,
	      children
	    ),
	    _react2.default.createElement(_baseDropdown.Dropdown, {
	      ButtonTag: ButtonTag,
	      right: right,
	      selected: _react2.default.createElement(
	        _baseScreenReaderMessage2.default,
	        null,
	        secondaryAriaLabel
	      ),
	      disableMobile: true,
	      disabled: disabled || isLoading,
	      options: secondary,
	      handleSelect: _handleClick,
	      labelledById: labelledById,
	      labelLocalizedText: label,
	      descriptionLocalizedText: label })
	  );
	}
	
	exports.default = ComboButton;
	ComboButton.displayName = 'ComboButton';
	
	ComboButton.propTypes = {
	  children: _bcPropTypes.childrenShape,
	  ButtonTag: _react.PropTypes.oneOfType([_react.PropTypes.instanceOf(_baseBcReactComponent2.default), _react.PropTypes.func]),
	  right: _react.PropTypes.bool,
	  disabled: _react.PropTypes.bool,
	  options: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	    label: _react.PropTypes.node,
	    value: _react.PropTypes.any
	  })).isRequired,
	  btnClass: _react.PropTypes.string,
	  handleClick: _react.PropTypes.func.isRequired,
	  labelledById: _react.PropTypes.string,
	  label: _react.PropTypes.string,
	  className: _react.PropTypes.string,
	  isLoading: _react.PropTypes.bool,
	  secondaryAriaLabel: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.string.isRequired]),
	  dataKey: _react.PropTypes.string
	};

/***/ },
/* 1060 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ComboButton = __webpack_require__(1059);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ComboButton).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1061 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	__webpack_require__(2677);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DRAWER_OPEN_CLASS = 'drawer-open';
	
	var Layout = function (_BcReactComponent) {
	  _inherits(Layout, _BcReactComponent);
	
	  function Layout() {
	    _classCallCheck(this, Layout);
	
	    return _possibleConstructorReturn(this, (Layout.__proto__ || Object.getPrototypeOf(Layout)).apply(this, arguments));
	  }
	
	  _createClass(Layout, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      Layout.toggleBodyScrolling(this.props.open);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.open !== this.props.open) {
	        Layout.toggleBodyScrolling(nextProps.open);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      Layout.toggleBodyScrolling(false);
	    }
	  }, {
	    key: 'getDrawerClasses',
	    value: function getDrawerClasses(open) {
	      var activeClass = open ? 'active' : '';
	      return 'cp-layout ' + this.props.containerClass + ' ' + activeClass + ' drawer-layout-left row';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: this.getDrawerClasses(this.props.open) },
	        _react2.default.Children.map(this.props.children, function (child) {
	          return _react2.default.cloneElement(child, { open: _this2.props.open });
	        })
	      );
	    }
	  }], [{
	    key: 'toggleBodyScrolling',
	    value: function toggleBodyScrolling(open) {
	      var method = open ? 'add' : 'remove';
	      document.body.classList[method](DRAWER_OPEN_CLASS);
	    }
	  }]);
	
	  return Layout;
	}(_baseBcReactComponent2.default);
	
	Layout.propTypes = {
	  open: _react.PropTypes.bool,
	  containerClass: _react.PropTypes.string
	};
	
	exports.default = Layout;

/***/ },
/* 1062 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Layout = __webpack_require__(1061);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Layout).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1063 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MainContent = function (_BcReactComponent) {
	  _inherits(MainContent, _BcReactComponent);
	
	  function MainContent() {
	    _classCallCheck(this, MainContent);
	
	    return _possibleConstructorReturn(this, (MainContent.__proto__ || Object.getPrototypeOf(MainContent)).apply(this, arguments));
	  }
	
	  _createClass(MainContent, [{
	    key: 'getMainClasses',
	    value: function getMainClasses() {
	      return this.props.mainClass + ' col-xs-12 col-sm-12 col-md-12 col-lg-9';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: this.getMainClasses() },
	        this.props.children
	      );
	    }
	  }]);
	
	  return MainContent;
	}(_baseBcReactComponent2.default);
	
	MainContent.propTypes = {
	  mainClass: _react.PropTypes.string
	};
	
	exports.default = MainContent;

/***/ },
/* 1064 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _MainContent = __webpack_require__(1063);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MainContent).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1065 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _baseGesturesSwipeable = __webpack_require__(520);
	
	var _baseGesturesSwipeable2 = _interopRequireDefault(_baseGesturesSwipeable);
	
	var _baseAccessibilityManageFocus = __webpack_require__(227);
	
	var _baseAccessibilityManageFocus2 = _interopRequireDefault(_baseAccessibilityManageFocus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Sidebar = function (_BcReactComponent) {
	  _inherits(Sidebar, _BcReactComponent);
	
	  function Sidebar(props) {
	    _classCallCheck(this, Sidebar);
	
	    var _this = _possibleConstructorReturn(this, (Sidebar.__proto__ || Object.getPrototypeOf(Sidebar)).call(this, props));
	
	    _this.bindAll('toggleFocus');
	    return _this;
	  }
	
	  _createClass(Sidebar, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._sidebar.addEventListener('transitionend', this.toggleFocus);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._sidebar.removeEventListener('transitionend', this.toggleFocus);
	    }
	  }, {
	    key: 'toggleFocus',
	    value: function toggleFocus() {
	      if (this.props.open) {
	        this.props.captureFocus(this._sidebar);
	      } else {
	        this.props.restoreFocus();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var sidebarClassNames = (0, _classnames2.default)(this.props.sidebarClass, 'col-xs-10 col-sm-8 col-md-7 col-lg-3 cp-sidebar');
	
	      return _react2.default.createElement(
	        _baseGesturesSwipeable2.default,
	        { onSwipedLeft: this.props.drawerActions.toggle },
	        _react2.default.createElement('div', { className: 'sidebar-overlay', onClick: this.props.drawerActions.toggle }),
	        _react2.default.createElement(
	          'section',
	          { className: sidebarClassNames, ref: function ref(el) {
	              _this2._sidebar = el;
	            } },
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return Sidebar;
	}(_baseBcReactComponent2.default);
	
	Sidebar.propTypes = {
	  drawerActions: _react.PropTypes.shape({
	    toggle: _react.PropTypes.func.isRequired
	  }),
	  sidebarClass: _react.PropTypes.string
	};
	
	Sidebar.defaultProps = {
	  sidebarClass: ''
	};
	
	exports.default = (0, _baseAccessibilityManageFocus2.default)(Sidebar);

/***/ },
/* 1066 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Sidebar = __webpack_require__(1065);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Sidebar).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1067 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsCssTransitionGroup = __webpack_require__(258);
	
	var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseVisibilitySensor = __webpack_require__(1365);
	
	var _baseVisibilitySensor2 = _interopRequireDefault(_baseVisibilitySensor);
	
	var _baseButtons = __webpack_require__(12);
	
	var _ = __webpack_require__(118);
	
	__webpack_require__(2678);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StickyToggleButton = function (_BcReactComponent) {
	  _inherits(StickyToggleButton, _BcReactComponent);
	
	  function StickyToggleButton(props) {
	    _classCallCheck(this, StickyToggleButton);
	
	    var _this = _possibleConstructorReturn(this, (StickyToggleButton.__proto__ || Object.getPrototypeOf(StickyToggleButton)).call(this, props));
	
	    _this.state = { drawerToggleVisible: true };
	    _this.bindAll('isVisible');
	    return _this;
	  }
	
	  _createClass(StickyToggleButton, [{
	    key: 'isVisible',
	    value: function isVisible(visible) {
	      if (visible !== this.state.drawerToggleVisible) {
	        this.setState({ drawerToggleVisible: visible });
	      }
	    }
	  }, {
	    key: 'renderSticky',
	    value: function renderSticky() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-sticky-toggle' },
	        _react2.default.createElement(
	          _.Toggle,
	          { drawerActions: this.props.drawerActions },
	          _react2.default.createElement(
	            _baseButtons.PrimaryButton,
	            { className: 'handle', handleClick: this.props.drawerActions.toggle },
	            this.props.renderCompact()
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'span',
	        { className: (0, _classnames2.default)('cp-sticky-toggle-button', this.props.className) },
	        _react2.default.createElement(
	          _baseVisibilitySensor2.default,
	          { isVisible: this.isVisible },
	          _react2.default.createElement(
	            _.Toggle,
	            { drawerActions: this.props.drawerActions },
	            _react2.default.createElement(
	              _baseButtons.PrimaryButton,
	              { handleClick: this.props.drawerActions.toggle },
	              this.props.renderFull()
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactAddonsCssTransitionGroup2.default,
	          { transitionName: 'slide', transitionEnterTimeout: 500, transitionLeaveTimeout: 100 },
	          this.state.drawerToggleVisible ? '' : this.renderSticky()
	        )
	      );
	    }
	  }]);
	
	  return StickyToggleButton;
	}(_baseBcReactComponent2.default);
	
	exports.default = StickyToggleButton;
	
	
	StickyToggleButton.propTypes = {
	  className: _react.PropTypes.string,
	  drawerActions: _react.PropTypes.objectOf(_react.PropTypes.func),
	  renderFull: _react.PropTypes.func.isRequired,
	  renderCompact: _react.PropTypes.func.isRequired
	};

/***/ },
/* 1068 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _StickyToggleButton = __webpack_require__(1067);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_StickyToggleButton).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1069 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTapEventPlugin = __webpack_require__(3104);
	
	var _reactTapEventPlugin2 = _interopRequireDefault(_reactTapEventPlugin);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseGesturesSwipeable = __webpack_require__(520);
	
	var _baseGesturesSwipeable2 = _interopRequireDefault(_baseGesturesSwipeable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	(0, _reactTapEventPlugin2.default)();
	
	var Toggle = function (_BcReactComponent) {
	  _inherits(Toggle, _BcReactComponent);
	
	  function Toggle(props) {
	    _classCallCheck(this, Toggle);
	
	    var _this = _possibleConstructorReturn(this, (Toggle.__proto__ || Object.getPrototypeOf(Toggle)).call(this, props));
	
	    _this.bindAll('toggleDrawer');
	    return _this;
	  }
	
	  _createClass(Toggle, [{
	    key: 'toggleDrawer',
	    value: function toggleDrawer(e) {
	      e.preventDefault();
	      this.props.drawerActions.toggle();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _baseGesturesSwipeable2.default,
	        {
	          onSwipedRight: this.toggleDrawer,
	          className: 'cp-drawer-toggle hidden-lg' },
	        _react2.default.createElement(
	          'span',
	          null,
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return Toggle;
	}(_baseBcReactComponent2.default);
	
	Toggle.propTypes = {
	  drawerActions: _react.PropTypes.shape({
	    toggle: _react.PropTypes.func.isRequired
	  })
	};
	
	exports.default = Toggle;

/***/ },
/* 1070 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Toggle = __webpack_require__(1069);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Toggle).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1071 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(16);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _tabbable = __webpack_require__(507);
	
	var _tabbable2 = _interopRequireDefault(_tabbable);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _2 = __webpack_require__(362);
	
	__webpack_require__(2679);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  handleSelect: _react2.default.PropTypes.func,
	  children: _react2.default.PropTypes.array,
	  options: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.array, _reactImmutableProptypes2.default.list]),
	  right: _react2.default.PropTypes.bool,
	  closeAndFocus: _react2.default.PropTypes.func
	};
	
	var ARROW_UP = 'ArrowUp';
	var ARROW_DOWN = 'ArrowDown';
	var TAB = 'Tab';
	
	var DropdownMenu = function (_BcReactComponent) {
	  _inherits(DropdownMenu, _BcReactComponent);
	
	  function DropdownMenu(props) {
	    _classCallCheck(this, DropdownMenu);
	
	    var _this = _possibleConstructorReturn(this, (DropdownMenu.__proto__ || Object.getPrototypeOf(DropdownMenu)).call(this, props));
	
	    _this.state = {
	      focusedValue: null
	    };
	    _this.items = [];
	    _this.bindAll('renderItem', 'handleKeyDown');
	    return _this;
	  }
	
	  _createClass(DropdownMenu, [{
	    key: 'handleKeyDown',
	    value: function handleKeyDown(e) {
	      var tabbableElements = (0, _tabbable2.default)(this._dropdownmenu);
	      if ([ARROW_DOWN, ARROW_UP, TAB].indexOf(e.key) !== -1) {
	        var moveUp = e.key === ARROW_UP || e.key === TAB && e.shiftKey;
	        var focusedIndex = _lodash2.default.findIndex(tabbableElements, function (item) {
	          return item === document.activeElement;
	        });
	        var moveIndex = moveUp ? -1 : 1;
	        var nextItem = tabbableElements[focusedIndex + moveIndex];
	
	        if (!nextItem) {
	          if (e.key === TAB && typeof this.props.closeAndFocus === 'function') {
	            e.preventDefault();
	            this.props.closeAndFocus();
	          }
	          return;
	        }
	        e.preventDefault();
	        document.activeElement.blur();
	        nextItem.focus();
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var tabbableElements = (0, _tabbable2.default)(this._dropdownmenu);
	      if (tabbableElements.length > 0) {
	        this._dropdownmenu.addEventListener('keydown', this.handleKeyDown);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      // remove listener for keydown on the document
	      if (this._dropdownmenu) {
	        this._dropdownmenu.removeEventListener('keydown', this.handleKeyDown);
	      }
	      this._dropdownmenu = null;
	    }
	  }, {
	    key: 'renderItem',
	    value: function renderItem(item) {
	      var _this2 = this;
	
	      var handleSelect = function handleSelect(event) {
	        event.preventDefault();
	        _this2.props.handleSelect(item);
	      };
	
	      return _react2.default.createElement(
	        _2.DropdownMenuItem,
	        { key: item.key || item.value },
	        _react2.default.createElement(
	          'a',
	          {
	            href: '#menu-item-' + item.value,
	            'data-test-id': 'dropdown-item-' + item.value,
	            onClick: handleSelect },
	          item.label
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var menuClasses = (0, _classnames2.default)('cp-dropdown-menu', 'dropdown-menu', { 'dropdown-menu-right': this.props.right });
	
	      return _react2.default.createElement(
	        'ul',
	        { id: this.props.id, className: menuClasses, style: { display: 'block' }, ref: function ref(el) {
	            _this3._dropdownmenu = el;
	          } },
	        this.props.children ? this.props.children : this.props.options.map(this.renderItem)
	      );
	    }
	  }]);
	
	  return DropdownMenu;
	}(_baseBcReactComponent2.default);
	
	DropdownMenu.propTypes = propTypes;
	
	exports.default = DropdownMenu;

/***/ },
/* 1072 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = DropdownMenuDivider;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function DropdownMenuDivider() {
	  return _react2.default.createElement("li", { className: "divider", role: "presentation" });
	}

/***/ },
/* 1073 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = DropdownMenuHeader;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function DropdownMenuHeader(_ref) {
	  var children = _ref.children;
	
	  return _react2.default.createElement(
	    'li',
	    { role: 'presentation', className: 'dropdown-header' },
	    children
	  );
	}
	
	DropdownMenuHeader.propTypes = {
	  children: _bcPropTypes.childrenShape.isRequired
	};

/***/ },
/* 1074 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = DropdownMenuItem;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function DropdownMenuItem(_ref) {
	  var children = _ref.children,
	      className = _ref.className;
	
	  return _react2.default.createElement(
	    'li',
	    { role: 'option', className: 'menu-item ' + className },
	    children
	  );
	}
	
	DropdownMenuItem.propTypes = {
	  children: _bcPropTypes.childrenShape.isRequired,
	  className: _react2.default.PropTypes.string
	};

/***/ },
/* 1075 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _baseButtons = __webpack_require__(12);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	__webpack_require__(2680);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DropdownTrigger = function (_BcReactComponent) {
	  _inherits(DropdownTrigger, _BcReactComponent);
	
	  function DropdownTrigger(props) {
	    _classCallCheck(this, DropdownTrigger);
	
	    var _this = _possibleConstructorReturn(this, (DropdownTrigger.__proto__ || Object.getPrototypeOf(DropdownTrigger)).call(this, props));
	
	    _this.bindAll('handleClick');
	    return _this;
	  }
	
	  _createClass(DropdownTrigger, [{
	    key: 'handleClick',
	    value: function handleClick(e) {
	      e.preventDefault();
	      this.props.onClick();
	    }
	  }, {
	    key: 'renderDescription',
	    value: function renderDescription() {
	      var _props = this.props,
	          describedById = _props.describedById,
	          descriptionLocalizedText = _props.descriptionLocalizedText;
	
	      if (descriptionLocalizedText) {
	        return _react2.default.createElement(
	          _baseScreenReaderMessage2.default,
	          { id: describedById },
	          descriptionLocalizedText
	        );
	      }
	      return null;
	    }
	  }, {
	    key: 'renderLabel',
	    value: function renderLabel() {
	      var _props2 = this.props,
	          labelLocalizedText = _props2.labelLocalizedText,
	          labelledById = _props2.labelledById;
	
	      if (labelLocalizedText) {
	        return _react2.default.createElement(
	          _baseScreenReaderMessage2.default,
	          { id: labelledById },
	          labelLocalizedText
	        );
	      }
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          className = _props3.className,
	          testId = _props3.testId,
	          hasPopup = _props3.hasPopup,
	          ButtonTag = _props3.ButtonTag,
	          isLoading = _props3.isLoading,
	          disabled = _props3.disabled,
	          renderTrigger = _props3.renderTrigger;
	
	      var btnClass = ButtonTag ? (0, _classnames2.default)('cp-dropdown-trigger', className) : (0, _classnames2.default)('cp-dropdown-trigger', 'btn', className, 'dropdown-toggle');
	
	      var TagForButton = ButtonTag || _baseButtons.Button;
	
	      var buttonChildren = [this.props.children, _react2.default.createElement(
	        _baseScreenReaderMessage2.default,
	        { key: 'shows-more-content' },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ada_shows_more_content' })
	      )];
	
	      var propsForButton = {
	        disabled: disabled,
	        type: 'button',
	        handleClick: this.handleClick,
	        isLoading: isLoading,
	        'aria-haspopup': hasPopup,
	        'aria-expanded': this.props.expanded,
	        className: btnClass,
	        'data-test-id': testId,
	        children: buttonChildren
	      };
	
	      if (renderTrigger) {
	        return renderTrigger(propsForButton);
	      }
	
	      return _react2.default.createElement(TagForButton, propsForButton);
	    }
	  }]);
	
	  return DropdownTrigger;
	}(_baseBcReactComponent2.default);
	
	DropdownTrigger.propTypes = {
	  ButtonTag: _react.PropTypes.oneOfType([_react.PropTypes.instanceOf(_baseBcReactComponent2.default), _react.PropTypes.func]),
	  className: _react.PropTypes.string.isRequired,
	  labelledById: _react.PropTypes.string.isRequired,
	  labelLocalizedText: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.node]),
	  descriptionLocalizedText: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.node]),
	  testId: _react.PropTypes.string,
	  isLoading: _react.PropTypes.bool,
	  hasPopup: _react.PropTypes.bool,
	  disabled: _react.PropTypes.bool,
	  renderTrigger: _react.PropTypes.func
	};
	
	exports.default = DropdownTrigger;

/***/ },
/* 1076 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Dropdown = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(16);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _basePopupManager = __webpack_require__(523);
	
	var _basePopupManager2 = _interopRequireDefault(_basePopupManager);
	
	var _baseIcons = __webpack_require__(10);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _baseMobileDropdownMenu = __webpack_require__(1334);
	
	var _baseMobileDropdownMenu2 = _interopRequireDefault(_baseMobileDropdownMenu);
	
	var _dropdownMenu = __webpack_require__(362);
	
	var _dropdownMenu2 = _interopRequireDefault(_dropdownMenu);
	
	var _dropdownTrigger = __webpack_require__(519);
	
	var _dropdownTrigger2 = _interopRequireDefault(_dropdownTrigger);
	
	__webpack_require__(2681);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Dropdown = exports.Dropdown = function (_BcReactComponent) {
	  _inherits(Dropdown, _BcReactComponent);
	
	  function Dropdown(props) {
	    _classCallCheck(this, Dropdown);
	
	    var _this = _possibleConstructorReturn(this, (Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).call(this, props));
	
	    _this.bindAll('handleSelect', 'renderDropdownMenu');
	    return _this;
	  }
	
	  _createClass(Dropdown, [{
	    key: 'handleSelect',
	    value: function handleSelect(_ref) {
	      var value = _ref.value;
	
	      this.props.handleSelect(value);
	    }
	  }, {
	    key: 'showMobileMenu',
	    value: function showMobileMenu() {
	      return !this.props.disableMobile && typeof window !== 'undefined' && /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(window.navigator.userAgent) && this.props.options;
	    }
	  }, {
	    key: 'renderDropdownMenu',
	    value: function renderDropdownMenu(popupActions) {
	      if (this.showMobileMenu()) {
	        return _react2.default.createElement(_baseMobileDropdownMenu2.default, {
	          selected: this.props.selected,
	          options: this.props.options,
	          handleSelect: this.handleSelect });
	      }
	
	      var dropdownMenuId = this.props.dropdownMenuId || _lodash2.default.uniqueId('dropdownMenu_');
	      return _react2.default.createElement(
	        _dropdownMenu2.default,
	        {
	          id: dropdownMenuId,
	          right: this.props.right,
	          options: this.props.options,
	          handleSelect: this.handleSelect,
	          closeAndFocus: popupActions.closeAndFocusContent },
	        this.props.children
	      );
	    }
	  }, {
	    key: 'renderTrigger',
	    value: function renderTrigger(handleToggle) {
	      var expanded = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      var _props = this.props,
	          labelledById = _props.labelledById,
	          selected = _props.selected,
	          renderSelected = _props.renderSelected,
	          descriptionLocalizedText = _props.descriptionLocalizedText,
	          labelLocalizedText = _props.labelLocalizedText,
	          isLoading = _props.isLoading,
	          disabled = _props.disabled,
	          renderTrigger = _props.renderTrigger;
	
	
	      return _react2.default.createElement(
	        _dropdownTrigger2.default,
	        {
	          ButtonTag: this.props.ButtonTag,
	          onClick: handleToggle || function () {},
	          hasPopup: true,
	          labelledById: labelledById,
	          className: this.props.className,
	          expanded: expanded,
	          labelLocalizedText: labelLocalizedText,
	          descriptionLocalizedText: descriptionLocalizedText,
	          testId: this.props.testId,
	          isLoading: isLoading,
	          disabled: disabled,
	          renderTrigger: renderTrigger },
	        renderSelected(selected)
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          dropup = _props2.dropup,
	          mountAsOpen = _props2.mountAsOpen;
	
	
	      var classNames = (0, _classnames2.default)('cp-dropdown', { dropup: dropup });
	      var useMobileMenu = this.showMobileMenu();
	
	      if (useMobileMenu) {
	        return _react2.default.createElement(
	          'div',
	          { className: classNames },
	          this.renderTrigger(),
	          this.renderDropdownMenu()
	        );
	      }
	
	      return _react2.default.createElement(
	        _basePopupManager2.default,
	        {
	          renderContent: this.renderDropdownMenu,
	          initialOpenState: mountAsOpen,
	          className: classNames,
	          closeOnClick: true },
	        function (popupActions, expanded) {
	          return _this2.renderTrigger(popupActions.toggleContent, expanded);
	        }
	      );
	    }
	  }]);
	
	  return Dropdown;
	}(_baseBcReactComponent2.default);
	
	var optionsShape = _react.PropTypes.shape({
	  key: _react.PropTypes.string,
	  label: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node, _react.PropTypes.string]),
	  value: _react.PropTypes.string
	});
	
	Dropdown.propTypes = {
	  ButtonTag: _react.PropTypes.oneOfType([_react.PropTypes.instanceOf(_baseBcReactComponent2.default), _react.PropTypes.func]),
	  children: _bcPropTypes.childrenShape,
	  selected: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.string]),
	  renderSelected: _react.PropTypes.func,
	  options: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(optionsShape), _react.PropTypes.object, _reactImmutableProptypes2.default.listOf(optionsShape)]),
	  dropup: _react.PropTypes.bool,
	  right: _react.PropTypes.bool,
	  isLoading: _react.PropTypes.bool,
	  handleSelect: _react.PropTypes.func,
	  className: _react.PropTypes.string.isRequired,
	  labelledById: _react.PropTypes.string.isRequired,
	  labelLocalizedText: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.node]),
	  descriptionLocalizedText: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.node]),
	  dropdownMenuId: _react.PropTypes.string,
	  disableMobile: _react.PropTypes.bool,
	  mountAsOpen: _react.PropTypes.bool,
	  testId: _react.PropTypes.string,
	  disabled: _react.PropTypes.bool,
	  renderTrigger: _react.PropTypes.func
	};
	
	Dropdown.defaultProps = {
	  className: 'btn-default',
	  dropup: false,
	  right: false,
	  isLoading: false,
	  labelledById: _lodash2.default.uniqueId('dropdown_'),
	  disableMobile: false,
	  mountAsOpen: false,
	  renderSelected: function renderSelected(selected) {
	    return _react2.default.createElement(
	      'span',
	      { className: 'selected-wrapper' },
	      _react2.default.createElement(
	        'span',
	        { className: 'selected-value' },
	        selected
	      ),
	      _react2.default.createElement(_baseIcons.Arrows.medium.Down, { className: 'selected-icon extra-small' })
	    );
	  }
	};
	
	exports.default = Dropdown;

/***/ },
/* 1077 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Dropdown = __webpack_require__(1076);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Dropdown).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1078 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FullScreenOverlay = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(16);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _basePortal = __webpack_require__(1341);
	
	var _basePortal2 = _interopRequireDefault(_basePortal);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	var _baseAccessibilityManageFocus = __webpack_require__(227);
	
	var _baseAccessibilityManageFocus2 = _interopRequireDefault(_baseAccessibilityManageFocus);
	
	__webpack_require__(2682);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ESCAPE_KEY_NAME = 'Escape';
	var ESCAPE_KEY_CODE = 27;
	
	var FullScreenOverlay = exports.FullScreenOverlay = function (_BcReactComponent) {
	  _inherits(FullScreenOverlay, _BcReactComponent);
	
	  function FullScreenOverlay(props) {
	    _classCallCheck(this, FullScreenOverlay);
	
	    var _this = _possibleConstructorReturn(this, (FullScreenOverlay.__proto__ || Object.getPrototypeOf(FullScreenOverlay)).call(this, props));
	
	    _this.bindAll('handleDocumentClick', 'handleCloseOnEscape', 'handleCloseIfOpen', 'handleClose');
	
	    // Refs seem to have problems inside the Portal so we'll use ref callbacks and set these vars
	    _this._overlayClose = null;
	    _this._overlayFocusContent = null;
	    _this._overlayContent = null;
	    _this.overlayId = _lodash2.default.uniqueId('overlay');
	    return _this;
	  }
	
	  _createClass(FullScreenOverlay, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var open = this.props.open;
	
	      if (open) {
	        this.handleToggleOpen(open);
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (this.props.open !== prevProps.open) {
	        this.handleToggleOpen(this.props.open);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.handleToggleOpen(false);
	      this._overlayClose = null;
	      this._overlayFocusContent = null;
	      this._overlayContent = null;
	    }
	  }, {
	    key: 'handleClose',
	    value: function handleClose() {
	      if (!this.props.disableClose) {
	        return this.props.handleClose();
	      }
	
	      return false;
	    }
	  }, {
	    key: 'handleCloseIfOpen',
	    value: function handleCloseIfOpen() {
	      if (this.props.open) {
	        this.handleClose();
	      }
	    }
	  }, {
	    key: 'handleToggleOpen',
	    value: function handleToggleOpen(open) {
	      // Remove the event listener on close, and add on open
	      var eventListener = open ? 'addEventListener' : 'removeEventListener';
	      var toggle = open ? 'add' : 'remove';
	
	      document[eventListener]('click', this.handleDocumentClick);
	      document.body.classList[toggle]('overlay-is-open');
	      document[eventListener]('keydown', this.handleCloseOnEscape);
	
	      if (!this.props.disableHistoryControls) {
	        window[eventListener]('popstate', this.handleCloseIfOpen);
	      }
	
	      if (open) {
	        if (!this.props.disableHistoryControls) {
	          window.history.pushState({ overlayId: this.overlayId }, '');
	        }
	        this.props.captureFocus(this._overlayFocusContent);
	        this._overlayContent.scrollTop = 0;
	      } else {
	        this.props.restoreFocus();
	        if (_lodash2.default.get(window, 'history.state.overlayId') === this.overlayId) {
	          // Go back to remove the hash from the URL when overlay was closed without popstate
	          window.history.back();
	        }
	      }
	    }
	  }, {
	    key: 'handleDocumentClick',
	    value: function handleDocumentClick(e) {
	      // If clicking outside the overlay's content, call the close handler
	      // This also works for the default close button which is outside the content
	      if (this.props.open) {
	        var content = this._overlayContent;
	        if (content && !content.contains(e.target) && document.body.contains(e.target) && !e.target.isEqualNode(this._overlayClose)) {
	          this.handleClose();
	        }
	      }
	    }
	  }, {
	    key: 'handleCloseOnEscape',
	    value: function handleCloseOnEscape(e) {
	      if (e.key === ESCAPE_KEY_NAME || e.which === ESCAPE_KEY_CODE) {
	        this.handleClose();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var classes = (0, _classnames2.default)('cp-full-screen-overlay', this.props.animation, this.props.className, { open: this.props.open });
	
	      return _react2.default.createElement(
	        'div',
	        { className: classes, role: 'dialog', 'aria-hidden': !this.props.open, 'data-test-id': this.props['data-test-id'] },
	        _react2.default.createElement('div', { className: 'overlay-backdrop' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'overlay-inner', ref: function ref(el) {
	              _this2._overlayFocusContent = el;
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'overlay-body', ref: function ref(el) {
	                _this2._overlayContent = el;
	              } },
	            this.props.children
	          ),
	          _react2.default.createElement(
	            'button',
	            { className: 'overlay-close', tabIndex: 0, ref: function ref(el) {
	                _this2._overlayClose = el;
	              }, onClick: this.handleClose },
	            _react2.default.createElement(
	              'span',
	              { 'aria-hidden': true },
	              '\xD7'
	            ),
	            _react2.default.createElement(
	              _baseScreenReaderMessage2.default,
	              null,
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'close_overlay' })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return FullScreenOverlay;
	}(_baseBcReactComponent2.default);
	
	var overlayPropTypes = {
	  animation: _react.PropTypes.oneOf(['simple-genie', 'slide-down', 'fade-in', 'instant']),
	  open: _react.PropTypes.bool.isRequired,
	  handleClose: _react.PropTypes.func,
	  disableHistoryControls: _react.PropTypes.bool, // Pass this as true when using the router to control the overlay,
	  disableClose: _react.PropTypes.bool
	};
	
	FullScreenOverlay.propTypes = _extends({}, overlayPropTypes, {
	  captureFocus: _react.PropTypes.func.isRequired,
	  restoreFocus: _react.PropTypes.func.isRequired
	});
	
	FullScreenOverlay.defaultProps = {
	  animation: 'simple-genie',
	  handleClose: _lodash2.default.noop,
	  disableHistoryControls: false,
	  disableClose: false
	};
	
	var PortaledOverlay = function PortaledOverlay(props) {
	  return _react2.default.createElement(
	    _basePortal2.default,
	    null,
	    _react2.default.createElement(FullScreenOverlay, props)
	  );
	};
	
	var WrappedFullScreenOverlay = (0, _baseAccessibilityManageFocus2.default)(PortaledOverlay);
	
	WrappedFullScreenOverlay.propTypes = _extends({}, overlayPropTypes, {
	  handleFocusOnCapture: _react.PropTypes.func,
	  handleFocusOnRestore: _react.PropTypes.func
	});
	
	exports.default = WrappedFullScreenOverlay;

/***/ },
/* 1079 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSwipeable = __webpack_require__(3100);
	
	var _reactSwipeable2 = _interopRequireDefault(_reactSwipeable);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {};
	
	var Swipeable = function (_BcReactComponent) {
	  _inherits(Swipeable, _BcReactComponent);
	
	  function Swipeable() {
	    _classCallCheck(this, Swipeable);
	
	    return _possibleConstructorReturn(this, (Swipeable.__proto__ || Object.getPrototypeOf(Swipeable)).apply(this, arguments));
	  }
	
	  _createClass(Swipeable, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _reactSwipeable2.default,
	        this.props,
	        this.props.children
	      );
	    }
	  }]);
	
	  return Swipeable;
	}(_baseBcReactComponent2.default);
	
	Swipeable.propTypes = propTypes;
	
	exports.default = Swipeable;

/***/ },
/* 1080 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	var _baseIcons = __webpack_require__(10);
	
	var _baseButtons = __webpack_require__(12);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GroupedSearchButton = function GroupedSearchButton(_ref) {
	  var currentView = _ref.currentView,
	      toggleListView = _ref.toggleListView,
	      className = _ref.className;
	
	  var isActive = currentView === 'grouped' ? 'active' : '';
	  var toggleView = function toggleView() {
	    return toggleListView('grouped');
	  };
	  var btnClasses = (0, _classnames2.default)('cp-group-search-button', className, {
	    active: currentView === 'grouped'
	  });
	
	  return _react2.default.createElement(
	    _reactIntl.FormattedMessage,
	    { id: 'grouped_view', values: { isActive: isActive ? 'yes' : 'no' } },
	    function (message) {
	      return _react2.default.createElement(
	        _baseButtons.DefaultButton,
	        { 'data-test-id': 'grouped-search-button', className: btnClasses, flat: true, handleClick: toggleView, title: message },
	        _react2.default.createElement(_baseIcons.GroupedView, null),
	        _react2.default.createElement(
	          _baseScreenReaderMessage2.default,
	          null,
	          message
	        )
	      );
	    }
	  );
	};
	
	GroupedSearchButton.propTypes = {
	  className: _react.PropTypes.string,
	  currentView: _react.PropTypes.string,
	  toggleListView: _react.PropTypes.func.isRequired
	};
	
	exports.default = GroupedSearchButton;

/***/ },
/* 1081 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GroupedSearchButton = __webpack_require__(1080);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GroupedSearchButton).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1082 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Icon = function (_BcReactComponent) {
	  _inherits(Icon, _BcReactComponent);
	
	  function Icon(props) {
	    _classCallCheck(this, Icon);
	
	    var _this = _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).call(this, props));
	
	    _this.bindAll('renderSRText');
	    return _this;
	  }
	
	  _createClass(Icon, [{
	    key: 'renderSRText',
	    value: function renderSRText() {
	      return _react2.default.createElement(
	        'span',
	        { className: 'sr-only' },
	        this.props.screenReaderText
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'span',
	        { 'aria-hidden': 'true', className: 'icon ' + this.props.icon },
	        this.props.screenReaderText ? this.renderSRText() : null
	      );
	    }
	  }]);
	
	  return Icon;
	}(_baseBcReactComponent2.default);
	
	Icon.propTypes = {
	  icon: _react.PropTypes.string.isRequired,
	  screenReaderText: _react.PropTypes.string
	};
	
	exports.default = Icon;

/***/ },
/* 1083 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function Abacus(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height;
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      xmlns: 'http://www.w3.org/2000/svg',
	      focusable: 'false',
	      'aria-hidden': true,
	      className: (0, _classnames2.default)('icon-svg-abacus', className),
	      width: width,
	      height: height,
	      viewBox: '0 0 48 48' },
	    _react2.default.createElement(
	      'g',
	      { fill: 'none', fillRule: 'evenodd' },
	      _react2.default.createElement('path', { fill: '', d: 'M0 0h48v48H0z' }),
	      _react2.default.createElement('path', { fill: color, fillRule: 'nonzero', d: 'M4.867 12.583v-2H44.2v2zM4.867 20.05v-2H44.2v2zM4.867 27.517v-2H44.2v2z' }),
	      _react2.default.createElement('circle', { cx: '36', cy: '26.333', r: '2.933', fill: color, fillRule: 'nonzero' }),
	      _react2.default.createElement('circle', { cx: '36', cy: '19.133', r: '2.933', fill: color, fillRule: 'nonzero' }),
	      _react2.default.createElement('circle', { cx: '11.467', cy: '11.6', r: '2.933', fill: color, fillRule: 'nonzero' }),
	      _react2.default.createElement('circle', { cx: '18.933', cy: '11.6', r: '2.933', fill: color, fillRule: 'nonzero' }),
	      _react2.default.createElement('circle', { cx: '27.6', cy: '26.333', r: '2.933', fill: color, fillRule: 'nonzero' }),
	      _react2.default.createElement('path', { fill: color, fillRule: 'nonzero', d: 'M2 4.256h3v38.011H2zM43 4.256h3v38.011h-3z' }),
	      _react2.default.createElement('path', { fill: color, fillRule: 'nonzero', d: 'M4 33h40v3H4zM0 42h7v3H0zM41 42h7v3h-7z' })
	    )
	  );
	}
	
	Abacus.propTypes = {
	  color: _react.PropTypes.string,
	  className: _react.PropTypes.string,
	  width: _react.PropTypes.number,
	  height: _react.PropTypes.number
	};
	
	Abacus.displayName = 'Abacus';
	
	exports.default = Abacus;

/***/ },
/* 1084 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Abacus = __webpack_require__(1083);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Abacus).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1085 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	var AccessibleFormat = function AccessibleFormat(_ref) {
	  var className = _ref.className,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 26 : _ref$height,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 26 : _ref$width;
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-accessible-format ' + className, preserveAspectRatio: 'xMinYMin meet', width: width, height: height, viewBox: '0 0 26 26' },
	    _react2.default.createElement('path', { fill: color, fillRule: 'evenodd', d: 'M11.328125,7.734375 L8.671875,14.765625 C10.21875,14.78125 11.765625,14.828125 13.3125,14.828125 C13.609375,14.828125 13.90625,14.8125 14.203125,14.796875 C13.390625,12.421875 12.4375,10 11.328125,7.734375 Z M0,25 L0.03125,23.765625 C1.5,23.3125 3.09375,23.625 3.75,21.9375 L7.453125,12.3125 L11.828125,1 L13.828125,1 C13.890625,1.109375 13.953125,1.21875 14,1.328125 L17.203125,8.828125 C18.375,11.59375 19.453125,14.390625 20.640625,17.140625 C21.34375,18.765625 21.890625,20.4375 22.671875,22.03125 C22.78125,22.28125 23,22.75 23.21875,22.921875 C23.734375,23.328125 25.171875,23.421875 25.90625,23.703125 C25.953125,24 26,24.296875 26,24.59375 C26,24.734375 25.984375,24.859375 25.984375,25 C24,25 22.015625,24.75 20.03125,24.75 C17.984375,24.75 15.9375,24.921875 13.890625,24.984375 C13.890625,24.578125 13.90625,24.171875 13.953125,23.765625 L16,23.328125 C16.421875,23.234375 17.25,23.125 17.25,22.546875 C17.25,21.984375 15.234375,17.34375 14.984375,16.703125 L7.953125,16.671875 C7.546875,17.578125 5.96875,21.671875 5.96875,22.265625 C5.96875,23.46875 8.265625,23.515625 9.15625,23.640625 C9.171875,23.9375 9.171875,24.234375 9.171875,24.546875 C9.171875,24.6875 9.15625,24.828125 9.140625,24.96875 C7.328125,24.96875 5.5,24.65625 3.6875,24.65625 C3.46875,24.65625 3.15625,24.75 2.9375,24.78125 C1.953125,24.953125 0.984375,25 0,25 Z' })
	  );
	};
	
	AccessibleFormat.propTypes = _bcPropTypes.iconShape;
	
	exports.default = AccessibleFormat;

/***/ },
/* 1086 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AccessibleFormat = __webpack_require__(1085);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AccessibleFormat).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1087 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = AngleLeft;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function AngleLeft(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height;
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      className: 'icon-svg-angle-left ' + className,
	      focusable: 'false',
	      'aria-hidden': true,
	      width: width,
	      height: height,
	      viewBox: '0 0 8 14' },
	    _react2.default.createElement('path', { fill: color, fillRule: 'evenodd', d: 'M8,1.16432866 C8,1.27655311 7.94501718,1.40280561 7.86254296,1.48697395 L2.4604811,7 L7.86254296,12.5130261 C7.94501718,12.5971944 8,12.7234469 8,12.8356713 C8,12.9478958 7.94501718,13.0741483 7.86254296,13.1583166 L7.17525773,13.8597194 C7.09278351,13.9438878 6.96907216,14 6.85910653,14 C6.74914089,14 6.62542955,13.9438878 6.54295533,13.8597194 L0.137457045,7.32264529 C0.0549828179,7.23847695 0,7.11222445 0,7 C0,6.88777555 0.0549828179,6.76152305 0.137457045,6.67735471 L6.54295533,0.140280561 C6.62542955,0.0561122244 6.74914089,0 6.85910653,0 C6.96907216,0 7.09278351,0.0561122244 7.17525773,0.140280561 L7.86254296,0.841683367 C7.94501718,0.925851703 8,1.03807615 8,1.16432866 Z' })
	  );
	}
	
	AngleLeft.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1088 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = AngleRight;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function AngleRight(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height;
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      className: 'icon-svg-angle-right ' + className,
	      focusable: 'false',
	      'aria-hidden': true,
	      width: width,
	      height: height,
	      viewBox: '0 0 8 14' },
	    _react2.default.createElement('path', { fill: color, fillRule: 'evenodd', d: 'M8,1.16432866 C8,1.27655311 7.94501718,1.40280561 7.86254296,1.48697395 L2.4604811,7 L7.86254296,12.5130261 C7.94501718,12.5971944 8,12.7234469 8,12.8356713 C8,12.9478958 7.94501718,13.0741483 7.86254296,13.1583166 L7.17525773,13.8597194 C7.09278351,13.9438878 6.96907216,14 6.85910653,14 C6.74914089,14 6.62542955,13.9438878 6.54295533,13.8597194 L0.137457045,7.32264529 C0.0549828179,7.23847695 0,7.11222445 0,7 C0,6.88777555 0.0549828179,6.76152305 0.137457045,6.67735471 L6.54295533,0.140280561 C6.62542955,0.0561122244 6.74914089,0 6.85910653,0 C6.96907216,0 7.09278351,0.0561122244 7.17525773,0.140280561 L7.86254296,0.841683367 C7.94501718,0.925851703 8,1.03807615 8,1.16432866 Z', transform: 'matrix(-1 0 0 1 8 0)' })
	  );
	}
	
	AngleRight.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1089 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Right = __webpack_require__(1088);
	
	var _Right2 = _interopRequireDefault(_Right);
	
	var _Left = __webpack_require__(1087);
	
	var _Left2 = _interopRequireDefault(_Left);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = { Left: _Left2.default, Right: _Right2.default };

/***/ },
/* 1090 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Down;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	function Down(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#000' : _ref$color,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height;
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      focusable: 'false',
	      'aria-hidden': true,
	      className: 'icon-svg-arrows-font-awesome-down ' + className,
	      viewBox: '0 0 1792 1792',
	      width: width,
	      height: height },
	    _react2.default.createElement('path', { fill: color, d: 'M1675 832q0 53-37 90l-651 652q-39 37-91 37-53 0-90-37l-651-652q-38-36-38-90 0-53 38-91l74-75q39-37 91-37 53 0 90 37l294 294v-704q0-52 38-90t90-38h128q52 0 90 38t38 90v704l294-294q37-37 90-37 52 0 91 37l75 75q37 39 37 91z' })
	  );
	}
	
	Down.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1091 */
[3480, 1090],
/* 1092 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Up;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	function Up(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#000' : _ref$color,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height;
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      focusable: 'false',
	      'aria-hidden': true,
	      className: 'icon-svg-arrows-font-awesome-up ' + className,
	      viewBox: '0 0 1792 1792',
	      width: width,
	      height: height },
	    _react2.default.createElement('path', { fill: color, d: 'M1675 971q0 51-37 90l-75 75q-38 38-91 38-54 0-90-38l-294-293v704q0 52-37.5 84.5t-90.5 32.5h-128q-53 0-90.5-32.5t-37.5-84.5v-704l-294 293q-36 38-90 38t-90-38l-75-75q-38-38-38-90 0-53 38-91l651-651q35-37 90-37 54 0 91 37l651 651q37 39 37 91z' })
	  );
	}
	
	Up.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1093 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Up = __webpack_require__(1092);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Up).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1094 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Up = __webpack_require__(1093);
	
	var _Up2 = _interopRequireDefault(_Up);
	
	var _Down = __webpack_require__(1091);
	
	var _Down2 = _interopRequireDefault(_Down);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  Up: _Up2.default,
	  Down: _Down2.default
	};

/***/ },
/* 1095 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _light = __webpack_require__(1102);
	
	var _light2 = _interopRequireDefault(_light);
	
	var _medium = __webpack_require__(1110);
	
	var _medium2 = _interopRequireDefault(_medium);
	
	var _long = __webpack_require__(1107);
	
	var _long2 = _interopRequireDefault(_long);
	
	var _fontAwesome = __webpack_require__(1094);
	
	var _fontAwesome2 = _interopRequireDefault(_fontAwesome);
	
	var _move = __webpack_require__(1112);
	
	var _move2 = _interopRequireDefault(_move);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  light: _light2.default,
	  medium: _medium2.default,
	  long: _long2.default,
	  fontAwesome: _fontAwesome2.default,
	  move: _move2.default
	}; /*
	    * Exports
	    */

/***/ },
/* 1096 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	function LightDown(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#000' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-arrows-light-down ' + className, width: width, height: height, viewBox: '0 0 18 16' },
	    _react2.default.createElement('path', { fill: color, d: 'M16 5.5l-1-1-7 7-7-7-1 1 8 8 8-8z' })
	  );
	}
	
	LightDown.propTypes = _bcPropTypes.iconShape;
	
	exports.default = LightDown;

/***/ },
/* 1097 */
[3480, 1096],
/* 1098 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = LightLeft;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function LightLeft(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#000' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-arrows-light-left ' + className, width: width, height: height, viewBox: '0 0 18 16' },
	    _react2.default.createElement('path', { fill: color, d: 'M10.5 16l1-1-7-7 7-7-1-1-8 8 8 8z' })
	  );
	}
	
	LightLeft.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1099 */
[3481, 1098],
/* 1100 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = LightRight;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function LightRight(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#000' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-arrows-light-right ' + className, width: width, height: height, viewBox: '0 0 18 16' },
	    _react2.default.createElement('path', { fill: color, d: 'M5.5 0l-1 1 7 7-7 7 1 1 8-8-8-8z' })
	  );
	}
	
	LightRight.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1101 */
[3482, 1100],
/* 1102 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Down = __webpack_require__(1097);
	
	var _Down2 = _interopRequireDefault(_Down);
	
	var _Left = __webpack_require__(1099);
	
	var _Left2 = _interopRequireDefault(_Left);
	
	var _Right = __webpack_require__(1101);
	
	var _Right2 = _interopRequireDefault(_Right);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = { Down: _Down2.default, Left: _Left2.default, Right: _Right2.default }; /*
	                                                                                           * Exports
	                                                                                           */

/***/ },
/* 1103 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function LongLeft(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height;
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      focusable: 'false',
	      'aria-hidden': true,
	      className: 'icon-svg-arrows-long-left ' + className,
	      viewBox: '0 0 1792 1792',
	      width: width,
	      height: height },
	    _react2.default.createElement('path', { d: 'M1792 800v192q0 14-9 23t-23 9h-1248v224q0 21-19 29t-35-5l-384-350q-10-10-10-23 0-14 10-24l384-354q16-14 35-6 19 9 19 29v224h1248q14 0 23 9t9 23z' })
	  );
	}
	
	LongLeft.propTypes = _bcPropTypes.iconShape;
	exports.default = LongLeft;

/***/ },
/* 1104 */
[3481, 1103],
/* 1105 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function LongRight(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-arrows-long-right ' + className, width: width, height: height, viewBox: '0 0 16 16' },
	    _react2.default.createElement('path', { d: 'M10 13.5l5.5-5.5-5.5-5.5v4.5h-9v2h9z' })
	  );
	}
	
	LongRight.propTypes = _bcPropTypes.iconShape;
	exports.default = LongRight;

/***/ },
/* 1106 */
[3482, 1105],
/* 1107 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Right = __webpack_require__(1106);
	
	var _Right2 = _interopRequireDefault(_Right);
	
	var _Left = __webpack_require__(1104);
	
	var _Left2 = _interopRequireDefault(_Left);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * Exports
	 */
	exports.default = { Right: _Right2.default, Left: _Left2.default };

/***/ },
/* 1108 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function MediumDown(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#000' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-arrow-medium-down ' + className, width: width, height: height, viewBox: '0 0 18 16' },
	    _react2.default.createElement('path', { fill: color, d: 'M16 5.5l-2-2-6 6-6-6-2 2 8 8 8-8z' })
	  );
	}
	
	MediumDown.propTypes = _bcPropTypes.iconShape;
	
	exports.default = MediumDown;

/***/ },
/* 1109 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function MediumUp(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#000' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-arrow-medium-up ' + className, width: width, height: height, viewBox: '0 0 18 16' },
	    _react2.default.createElement('path', { fill: color, d: 'M0 10.5l2 2 6-6 6 6 2-2-8-8-8 8z' })
	  );
	}
	
	MediumUp.propTypes = _bcPropTypes.iconShape;
	
	exports.default = MediumUp;

/***/ },
/* 1110 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Down = __webpack_require__(1108);
	
	var _Down2 = _interopRequireDefault(_Down);
	
	var _Up = __webpack_require__(1109);
	
	var _Up2 = _interopRequireDefault(_Up);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * Exports
	 */
	
	exports.default = {
	  Down: _Down2.default,
	  Up: _Up2.default
	};

/***/ },
/* 1111 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function MoveRight(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    { xmlns: 'http://www.w3.org/2000/svg', focusable: 'false', 'aria-hidden': true, className: 'icon-svg-arrow-move ' + className, width: width, height: height, viewBox: '0 0 16 16' },
	    _react2.default.createElement('path', { fill: color, fillRule: 'evenodd', d: 'M13.5000137,8.08594476 C13.5000137,8.35157007 13.3984511,8.60938288 13.2109509,8.7968831 L8.1250073,13.8828267 C7.93750708,14.0625144 7.67969427,14.1718895 7.41406895,14.1718895 C7.14844364,14.1718895 6.89844334,14.0625144 6.71094312,13.8828267 L6.12500492,13.2968885 C5.93750469,13.1093882 5.82812956,12.8515754 5.82812956,12.5859501 C5.82812956,12.3203248 5.93750469,12.062512 6.12500492,11.8750118 L8.41407015,9.58594654 L2.91406359,9.58594654 C2.35156292,9.58594654 2,9.11719598 2,8.58594535 L2,7.58594416 C2,7.05469353 2.35156292,6.58594297 2.91406359,6.58594297 L8.41407015,6.58594297 L6.12500492,4.28906523 C5.93750469,4.10937751 5.82812956,3.85156471 5.82812956,3.58593939 C5.82812956,3.32031407 5.93750469,3.06250127 6.12500492,2.88281355 L6.71094312,2.29687535 C6.89844334,2.10937513 7.14844364,2 7.41406895,2 C7.67969427,2 7.93750708,2.10937513 8.1250073,2.29687535 L13.2109509,7.38281892 C13.3984511,7.56250663 13.5000137,7.82031944 13.5000137,8.08594476 Z' })
	  );
	}
	
	MoveRight.propTypes = _bcPropTypes.iconShape;
	
	exports.default = MoveRight;

/***/ },
/* 1112 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Right = __webpack_require__(1111);
	
	var _Right2 = _interopRequireDefault(_Right);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  Right: _Right2.default
	}; /*
	    * Exports
	    */

/***/ },
/* 1113 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable max-len */
	var Attention = function (_BcReactComponent) {
	  _inherits(Attention, _BcReactComponent);
	
	  function Attention() {
	    _classCallCheck(this, Attention);
	
	    return _possibleConstructorReturn(this, (Attention.__proto__ || Object.getPrototypeOf(Attention)).apply(this, arguments));
	  }
	
	  _createClass(Attention, [{
	    key: 'render',
	    value: function render() {
	      var className = this.props.className;
	
	      return _react2.default.createElement(
	        'svg',
	        {
	          xmlns: 'http://www.w3.org/2000/svg',
	          focusable: 'false',
	          'aria-hidden': true,
	          className: 'icon-svg-failure ' + className,
	          preserveAspectRatio: 'xMinYMin meet',
	          viewBox: '0 0 16 16' },
	        _react2.default.createElement('path', { fillRule: 'evenodd', d: 'M16,8 C16,9.44086038 15.6397848,10.7741935 14.9193548,12 C14.1989249,13.2258065 13.2258065,14.1989249 12,14.9193548 C10.7741935,15.6397848 9.44086038,16 8,16 C6.55913962,16 5.22580645,15.6397848 4,14.9193548 C2.77419355,14.1989249 1.8010751,13.2258065 1.08064516,12 C0.360215218,10.7741935 0,9.44086038 0,8 C0,6.55913962 0.360215218,5.22580645 1.08064516,4 C1.8010751,2.77419355 2.77419355,1.8010751 4,1.08064516 C5.22580645,0.360215218 6.55913962,0 8,0 C9.44086038,0 10.7741935,0.360215218 12,1.08064516 C13.2258065,1.8010751 14.1989249,2.77419355 14.9193548,4 C15.6397848,5.22580645 16,6.55913962 16,8 Z M8,9.61290323 C7.59139769,9.61290323 7.24193548,9.75806452 6.9516129,10.0483871 C6.66129032,10.3387097 6.51612903,10.6881719 6.51612903,11.0967742 C6.51612903,11.5053765 6.66129032,11.8548387 6.9516129,12.1451613 C7.24193548,12.4354839 7.59139769,12.5806452 8,12.5806452 C8.40860231,12.5806452 8.75806452,12.4354839 9.0483871,12.1451613 C9.33870968,11.8548387 9.48387097,11.5053765 9.48387097,11.0967742 C9.48387097,10.6881719 9.33870968,10.3387097 9.0483871,10.0483871 C8.75806452,9.75806452 8.40860231,9.61290323 8,9.61290323 Z M6.58064516,4.29032258 L6.83870968,8.67741935 C6.83870968,8.76344102 6.87634425,8.84408619 6.9516129,8.91935484 C7.02688156,8.99462349 7.11827973,9.03225806 7.22580645,9.03225806 L8.77419355,9.03225806 C8.88172027,9.03225806 8.97311844,8.99462349 9.0483871,8.91935484 C9.12365575,8.84408619 9.16129032,8.76344102 9.16129032,8.67741935 L9.41935484,4.29032258 C9.41935484,4.16129032 9.38172027,4.05913962 9.30645161,3.98387097 C9.23118296,3.90860231 9.13978478,3.87096774 9.03225806,3.87096774 L6.96774194,3.87096774 C6.86021522,3.87096774 6.76881704,3.90860231 6.69354839,3.98387097 C6.61827973,4.05913962 6.58064516,4.16129032 6.58064516,4.29032258 Z' })
	      );
	    }
	  }]);
	
	  return Attention;
	}(_baseBcReactComponent2.default);
	
	Attention.propTypes = {
	  className: _react.PropTypes.string
	};
	
	exports.default = Attention;

/***/ },
/* 1114 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Attention = __webpack_require__(1113);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Attention).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1115 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Bars;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	function Bars(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className;
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      focusable: 'false',
	      'aria-hidden': true,
	      className: (0, _classnames2.default)('icon-svg-failure', className),
	      preserveAspectRatio: 'xMinYMin meet',
	      viewBox: '0 0 1792 1792',
	      xmlns: 'http://www.w3.org/2000/svg' },
	    _react2.default.createElement('path', { d: 'M1664 1344v128q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1408q26 0 45 19t19 45zm0-512v128q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1408q26 0 45 19t19 45zm0-512v128q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1408q26 0 45 19t19 45z' })
	  );
	}
	
	Bars.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1116 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Bars = __webpack_require__(1115);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Bars).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1117 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	var Book = function Book(_ref) {
	  var className = _ref.className,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 26 : _ref$height,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 26 : _ref$width;
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-book ' + className, preserveAspectRatio: 'xMinYMin meet', width: width, height: height, viewBox: '0 0 26 26' },
	    _react2.default.createElement(
	      'g',
	      { fill: 'none', fillRule: 'evenodd' },
	      _react2.default.createElement('path', { fill: color, d: 'M24.481,0.9998 C24.301,0.9998 24.116,1.0328 23.934,1.1028 L13.546,5.0978 C13.37,5.1658 13.185,5.1998 13,5.1998 C12.815,5.1998 12.63,5.1658 12.454,5.0978 L2.066,1.1028 C1.884,1.0328 1.7,0.9998 1.519,0.9998 C0.714,0.9998 0,1.6498 0,2.5218 L0,11.3078 L0,20.2638 C0,20.8928 0.388,21.4568 0.975,21.6828 L12.454,26.0978 C12.63,26.1658 12.815,26.1998 13,26.1998 C13.185,26.1998 13.37,26.1658 13.546,26.0978 L25.025,21.6828 C25.612,21.4568 26,20.8928 26,20.2638 L26,11.3078 L26,2.5218 C26,1.6498 25.286,0.9998 24.481,0.9998 M2,3.2198 L11.736,6.9648 C12.141,7.1208 12.566,7.1998 13,7.1998 C13.434,7.1998 13.859,7.1208 14.264,6.9648 L24,3.2198 L24,11.3078 L24,19.9348 L13,24.1658 L2,19.9348 L2,11.3078 L2,3.2198' }),
	      _react2.default.createElement('path', { stroke: color, strokeWidth: '2', d: 'M13,6.3079 L13,25.3079' }),
	      _react2.default.createElement('path', { fill: color, d: 'M4.5,10.7888 L4.5,9.2888 L10,11.4038 L10,12.9038 L4.5,10.7888 Z M4.5,15.7888 L4.5,14.2888 L10,16.4038 L10,17.9038 L4.5,15.7888 Z M22,10.7888 L16.5,12.9038 L16.5,11.4038 L22,9.2888 L22,10.7888 Z M22,15.7888 L16.5,17.9038 L16.5,16.4038 L22,14.2888 L22,15.7888 Z' })
	    )
	  );
	};
	
	Book.propTypes = _bcPropTypes.iconShape;
	
	exports.default = Book;

/***/ },
/* 1118 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Book = __webpack_require__(1117);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Book).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1119 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Books;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function Books(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 18 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#000' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-books ' + className, width: width, height: height, viewBox: '0 0 18 16' },
	    _react2.default.createElement('path', { fill: color, d: 'M3.5 2h-3c-0.275 0-0.5 0.225-0.5 0.5v11c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-11c0-0.275-0.225-0.5-0.5-0.5zM3 5h-2v-1h2v1z' }),
	    _react2.default.createElement('path', { fill: color, d: 'M8.5 2h-3c-0.275 0-0.5 0.225-0.5 0.5v11c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-11c0-0.275-0.225-0.5-0.5-0.5zM8 5h-2v-1h2v1z' }),
	    _react2.default.createElement('path', { fill: color, d: 'M11.954 2.773l-2.679 1.35c-0.246 0.124-0.345 0.426-0.222 0.671l4.5 8.93c0.124 0.246 0.426 0.345 0.671 0.222l2.679-1.35c0.246-0.124 0.345-0.426 0.222-0.671l-4.5-8.93c-0.124-0.246-0.426-0.345-0.671-0.222z' })
	  );
	}
	
	Books.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1120 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Books = __webpack_require__(1119);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Books).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1121 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = BorrowingHistoryIcon;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function BorrowingHistoryIcon(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      xmlns: 'http://www.w3.org/2000/svg',
	      focusable: 'false',
	      'aria-hidden': true,
	      className: 'icon-svg-borrowing-history ' + className,
	      width: width, height: height,
	      viewBox: '0 0 48 48' },
	    _react2.default.createElement(
	      'g',
	      { fill: 'none', fillRule: 'evenodd' },
	      _react2.default.createElement('path', { fill: color, d: 'M33.6825001,37.9975414 C33.6825001,39.8319368 33.2239011,41.5294367 32.3067037,43.0900416 C31.3895063,44.6506465 30.1506048,45.889548 28.5899999,46.8067454 C27.029395,47.7239428 25.3318951,48.1825418 23.4974997,48.1825418 C22.320201,48.1825418 21.1839716,47.984044 20.08881,47.5870478 C18.9936485,47.1900516 17.994314,46.6356262 17.0908059,45.9237716 C16.8717738,45.7321181 16.7554125,45.4925518 16.7417232,45.2050719 C16.7280339,44.9175921 16.8307053,44.6643358 17.0497373,44.4453038 L17.5014914,43.9935497 C17.6657656,43.8292755 17.8779533,43.7402934 18.1380539,43.7266041 C18.3981545,43.7129148 18.6240315,43.7745177 18.815685,43.9114126 C20.1846364,45.0065742 21.7452413,45.5541546 23.4974997,45.5541546 C24.8664511,45.5541546 26.1327318,45.2187612 27.2963406,44.5479751 C28.4599493,43.877189 29.3771473,42.959991 30.0479334,41.7963823 C30.7187195,40.6327736 31.0541129,39.3664929 31.0541129,37.9975414 C31.0541129,36.6285899 30.7187195,35.3623092 30.0479334,34.1987005 C29.3771473,33.0350918 28.4599493,32.1178938 27.2963406,31.4471077 C26.1327318,30.7763216 24.8664511,30.4409282 23.4974997,30.4409282 C22.5118545,30.4409282 21.5741228,30.6188917 20.684304,30.9748193 C19.7944852,31.330747 19.0073384,31.8372589 18.3228624,32.4943557 L20.4173584,34.5888517 C20.6090119,34.7805052 20.6500804,35.0132265 20.5405641,35.2870171 C20.4310477,35.5608076 20.225705,35.6977026 19.9245358,35.6977026 L13.9695961,35.6977026 C13.7779426,35.6977026 13.6205134,35.6360998 13.4973077,35.5128941 C13.3741021,35.3896885 13.3124993,35.2322592 13.3124993,35.0406058 L13.3124993,29.085666 C13.3124993,28.7844969 13.4493942,28.5791541 13.7231848,28.4696378 C13.9969753,28.3601214 14.2296967,28.40119 14.4213501,28.5928434 L16.4747776,30.6462709 C17.405665,29.7427628 18.4734473,29.0445975 19.6781245,28.5517749 C20.8828018,28.0589523 22.1559268,27.812541 23.4974997,27.812541 C25.3318951,27.812541 27.029395,28.27114 28.5899999,29.1883374 C30.1506048,30.1055348 31.3895063,31.3375913 32.3067037,32.8845069 C33.2239011,34.4314225 33.6825001,36.1357673 33.6825001,37.9975414 Z M26.2490925,41.2008883 C26.0848183,41.4199204 25.8657863,41.549971 25.5919957,41.5910395 C25.3182052,41.6321081 25.0717939,41.5705053 24.8527618,41.4062311 L22.1833061,39.311735 L22.1833061,33.7264122 C22.1833061,33.4526216 22.2791325,33.2199003 22.4707859,33.0282468 C22.6624394,32.8365934 22.8951607,32.740767 23.1689513,32.740767 L23.8260481,32.740767 C24.0998386,32.740767 24.33256,32.8365934 24.5242134,33.0282468 C24.7158669,33.2199003 24.8116933,33.4526216 24.8116933,33.7264122 L24.8116933,37.9975414 L26.4955038,39.311735 C26.7145359,39.4760092 26.8377415,39.6950413 26.8651208,39.9688318 C26.8925,40.2426223 26.8240522,40.4890336 26.659778,40.7080657 L26.2490925,41.2008883 Z' }),
	      _react2.default.createElement('path', { fill: color, d: 'M46,2 L2,2 C0.897,2 0,2.897 0,4 L0,37 C0,38.103 0.897,39 2,39 L9.814,39 C9.644,38.19 9.555,37.353 9.525,36.5 L2.5,36.5 L2.5,4.5 L45.5,4.5 L45.5,36.5 L38.475,36.5 C38.445,37.353 38.356,38.19 38.186,39 L46,39 C47.103,39 48,38.103 48,37 L48,4 C48,2.897 47.103,2 46,2' }),
	      _react2.default.createElement('polygon', { fill: color, points: '0 18 48 18 48 10 0 10' })
	    )
	  );
	}
	
	BorrowingHistoryIcon.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1122 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BorrowingHistoryIcon = __webpack_require__(1121);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BorrowingHistoryIcon).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1123 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Bullseye;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	function Bullseye(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-bullseye ' + className, width: width, height: height, viewBox: '0 0 1792 1792' },
	    _react2.default.createElement('path', { d: 'M1152 896q0 106-75 181t-181 75-181-75-75-181 75-181 181-75 181 75 75 181zm128 0q0-159-112.5-271.5t-271.5-112.5-271.5 112.5-112.5 271.5 112.5 271.5 271.5 112.5 271.5-112.5 112.5-271.5zm128 0q0 212-150 362t-362 150-362-150-150-362 150-362 362-150 362 150 150 362zm128 0q0-130-51-248.5t-136.5-204-204-136.5-248.5-51-248.5 51-204 136.5-136.5 204-51 248.5 51 248.5 136.5 204 204 136.5 248.5 51 248.5-51 204-136.5 136.5-204 51-248.5zm128 0q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z' })
	  );
	}
	
	Bullseye.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1124 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Bullseye = __webpack_require__(1123);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Bullseye).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1125 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = CalendarEmpty;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function CalendarEmpty(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height;
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      xmlns: 'http://www.w3.org/2000/svg',
	      className: 'icon-svg-calendar-empty ' + className,
	      focusable: 'false',
	      'aria-hidden': true,
	      width: width,
	      height: height,
	      viewBox: '0 0 16 16' },
	    _react2.default.createElement('path', { d: 'M13.5,2 L12,2 L12,0.3 C12,0.1 11.9,0 11.7,0 L10.3,0 C10.1,0 10,0.1 10,0.3 L10,2 L6,2 L6,0.3 C6,0.1 5.9,0 5.7,0 L4.3,0 C4.1,0 4,0.1 4,0.3 L4,2 L2.5,2 C1.7,2 1,2.7 1,3.5 L1,14.5 C1,15.3 1.7,16 2.5,16 L13.5,16 C14.3,16 15,15.3 15,14.5 L15,3.5 C15,2.7 14.3,2 13.5,2 Z M2.5,14.5 L2.5,5 L13.5,5 L13.5,14.5 L2.5,14.5 Z' })
	  );
	}
	
	CalendarEmpty.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1126 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CalendarEmpty = __webpack_require__(1125);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CalendarEmpty).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1127 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = CalendarFull;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function CalendarFull(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height;
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      xmlns: 'http://www.w3.org/2000/svg',
	      focusable: 'false',
	      'aria-hidden': true,
	      className: 'icon-svg-calendar-full ' + className,
	      width: width,
	      height: height,
	      viewBox: '0 0 16 16' },
	    _react2.default.createElement('path', { fillRule: 'evenodd', d: 'M14.625 5H1.375a.362.362 0 0 1-.266-.11A.362.362 0 0 1 1 4.626V3.5c0-.417.146-.77.437-1.062A1.447 1.447 0 0 1 2.5 2H4V.375c0-.104.036-.193.11-.266A.362.362 0 0 1 4.374 0h1.25c.104 0 .193.036.266.11.073.072.109.16.109.265V2h4V.375c0-.104.036-.193.11-.266A.362.362 0 0 1 10.374 0h1.25c.104 0 .193.036.266.11.073.072.109.16.109.265V2h1.5c.417 0 .77.146 1.062.438.292.291.438.645.438 1.062v1.125a.362.362 0 0 1-.11.266.362.362 0 0 1-.265.109zM1.375 6h13.25c.104 0 .193.036.266.11.073.072.109.16.109.265V14.5c0 .417-.146.77-.438 1.062A1.447 1.447 0 0 1 13.5 16h-11c-.417 0-.77-.146-1.063-.438A1.447 1.447 0 0 1 1 14.5V6.375c0-.104.036-.193.11-.266A.362.362 0 0 1 1.374 6zM5 12.375a.362.362 0 0 0-.11-.266.362.362 0 0 0-.265-.109h-1.25a.362.362 0 0 0-.266.11.362.362 0 0 0-.109.265v1.25c0 .104.036.193.11.266.072.073.16.109.265.109h1.25a.362.362 0 0 0 .266-.11.362.362 0 0 0 .109-.265v-1.25zm0-4a.362.362 0 0 0-.11-.266A.362.362 0 0 0 4.626 8h-1.25a.362.362 0 0 0-.266.11.362.362 0 0 0-.109.265v1.25c0 .104.036.193.11.266.072.073.16.109.265.109h1.25a.362.362 0 0 0 .266-.11A.362.362 0 0 0 5 9.626v-1.25zm4 4a.362.362 0 0 0-.11-.266.362.362 0 0 0-.265-.109h-1.25a.362.362 0 0 0-.266.11.362.362 0 0 0-.109.265v1.25c0 .104.036.193.11.266.072.073.16.109.265.109h1.25a.362.362 0 0 0 .266-.11.362.362 0 0 0 .109-.265v-1.25zm0-4a.362.362 0 0 0-.11-.266A.362.362 0 0 0 8.626 8h-1.25a.362.362 0 0 0-.266.11.362.362 0 0 0-.109.265v1.25c0 .104.036.193.11.266.072.073.16.109.265.109h1.25a.362.362 0 0 0 .266-.11A.362.362 0 0 0 9 9.626v-1.25zm4 4a.362.362 0 0 0-.11-.266.362.362 0 0 0-.265-.109h-1.25a.362.362 0 0 0-.266.11.362.362 0 0 0-.109.265v1.25c0 .104.036.193.11.266.072.073.16.109.265.109h1.25a.362.362 0 0 0 .266-.11.362.362 0 0 0 .109-.265v-1.25zm0-4a.362.362 0 0 0-.11-.266.362.362 0 0 0-.265-.109h-1.25a.362.362 0 0 0-.266.11.362.362 0 0 0-.109.265v1.25c0 .104.036.193.11.266.072.073.16.109.265.109h1.25a.362.362 0 0 0 .266-.11.362.362 0 0 0 .109-.265v-1.25z' })
	  );
	}
	
	CalendarFull.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1128 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CalendarFull = __webpack_require__(1127);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CalendarFull).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1129 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = CalendarWarning;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	function CalendarWarning(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      xmlns: 'http://www.w3.org/2000/svg',
	      focusable: 'false',
	      'aria-hidden': true,
	      className: (0, _classnames2.default)('icon-svg-calendar-warning', className),
	      width: width,
	      height: height,
	      viewBox: '0 0 16 16' },
	    _react2.default.createElement(
	      'g',
	      { fill: 'none', fillRule: 'evenodd' },
	      _react2.default.createElement('path', { fill: color, d: 'M7.1125,6.33593751 C7.1125,6.24635411 7.1416666,6.16796876 7.2,6.10078125 C7.2583334,6.03359375 7.3291666,6 7.4125,6 L8.5875,6 C8.6708334,6 8.7416666,6.03359375 8.8,6.10078125 C8.8583334,6.16796876 8.8875,6.24635411 8.8875,6.33593751 L8.7125,9.99093768 C8.7125,10.0805211 8.6833334,10.1544273 8.625,10.2126564 C8.5666666,10.2708855 8.4958334,10.3000002 8.4125,10.3000002 L7.5875,10.3000002 C7.5041666,10.3000002 7.4333334,10.2708855 7.375,10.2126564 C7.3166666,10.1544273 7.2875,10.0805211 7.2875,9.99093768 L7.1125,6.33593751 Z' }),
	      _react2.default.createElement('circle', { fill: color, fillRule: 'nonzero', cx: '8', cy: '12', r: '1' }),
	      _react2.default.createElement('rect', { stroke: color, width: '12.5', height: '12.5', x: '1.75', y: '2.75', strokeWidth: '1.5', rx: '1.5' }),
	      _react2.default.createElement('path', { fill: color, d: 'M5.69999999,3 L10.3,3 C10.1343146,3 10,2.86568542 10,2.69999999 L10,0.300000012 C10,0.13431458 10.1343146,-2.50752312e-17 10.3,-5.55111512e-17 L11.7,0 C11.8656854,-3.043592e-17 12,0.13431458 12,0.300000012 L12,2.69999999 C12,2.86568542 11.8656854,3 11.7,3 L14,3 L14,5 L2,5 L2,3 L4.30000001,3 C4.13431458,3 4,2.86568542 4,2.69999999 L4,0.300000012 C4,0.13431458 4.13431458,-2.50752312e-17 4.30000001,-5.55111512e-17 L5.69999999,0 C5.86568542,-3.043592e-17 6,0.13431458 6,0.300000012 L6,2.69999999 C6,2.86568542 5.86568542,3 5.69999999,3 Z' })
	    )
	  );
	}
	
	CalendarWarning.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1130 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CalendarWarning = __webpack_require__(1129);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CalendarWarning).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1131 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function Cancel(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$title = _ref.title,
	      title = _ref$title === undefined ? '' : _ref$title;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-cancel ' + className, width: width, height: height, viewBox: '0 0 16 16' },
	    title ? _react2.default.createElement(
	      'title',
	      null,
	      title
	    ) : null,
	    _react2.default.createElement('path', { fill: color, d: 'M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM12 10.5l-1.5 1.5-2.5-2.5-2.5 2.5-1.5-1.5 2.5-2.5-2.5-2.5 1.5-1.5 2.5 2.5 2.5-2.5 1.5 1.5-2.5 2.5 2.5 2.5z' })
	  );
	}
	
	Cancel.propTypes = _bcPropTypes.iconShape;
	
	exports.default = Cancel;

/***/ },
/* 1132 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Cancel = __webpack_require__(1131);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Cancel).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Card;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function Card(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height;
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      xmlns: 'http://www.w3.org/2000/svg',
	      focusable: 'false',
	      'aria-hidden': true,
	      className: 'icon-svg-card ' + className,
	      width: width,
	      height: height,
	      viewBox: '0 0 18 18' },
	    _react2.default.createElement(
	      'defs',
	      null,
	      _react2.default.createElement('rect', { id: 'borrowing-a', width: '18', height: '14', y: '2', rx: '2' })
	    ),
	    _react2.default.createElement(
	      'g',
	      { fill: 'none', fillRule: 'evenodd' },
	      _react2.default.createElement('use', { fill: '', fillOpacity: '0', xlinkHref: '#borrowing-a' }),
	      _react2.default.createElement('rect', { stroke: color, width: '16.5', height: '12.5', x: '.75', y: '2.75', strokeWidth: '1.5', rx: '2' }),
	      _react2.default.createElement('rect', { fill: color, width: '17', height: '3', y: '6' })
	    )
	  );
	}
	
	Card.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1134 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Card = __webpack_require__(1133);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Card).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1135 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function LightDown(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 8 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 5 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-carets-down ' + className, width: width, height: height, viewBox: '0 0 8 5' },
	    _react2.default.createElement('polygon', { fill: color, fillRule: 'evenodd', points: '4 0 8 5 0 5', transform: 'matrix(1 0 0 -1 0 5)' })
	  );
	}
	
	LightDown.propTypes = _bcPropTypes.iconShape;
	
	exports.default = LightDown;

/***/ },
/* 1136 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Down = __webpack_require__(1135);
	
	var _Down2 = _interopRequireDefault(_Down);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Down2.default;

/***/ },
/* 1137 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function LightUp(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 8 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 5 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-carets-up ' + className, width: width, height: height, viewBox: '0 0 8 5' },
	    _react2.default.createElement('polygon', { fill: color, fillRule: 'evenodd', points: '4 0 8 5 0 5' })
	  );
	}
	
	LightUp.propTypes = _bcPropTypes.iconShape;
	
	exports.default = LightUp;

/***/ },
/* 1138 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Up = __webpack_require__(1137);
	
	var _Up2 = _interopRequireDefault(_Up);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Up2.default;

/***/ },
/* 1139 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Down = __webpack_require__(1136);
	
	var _Down2 = _interopRequireDefault(_Down);
	
	var _Up = __webpack_require__(1138);
	
	var _Up2 = _interopRequireDefault(_Up);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  Down: _Down2.default,
	  Up: _Up2.default
	};

/***/ },
/* 1140 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Cart;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function Cart(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height;
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      xmlns: 'http://www.w3.org/2000/svg',
	      focusable: 'false',
	      'aria-hidden': true,
	      className: 'icon-svg-cart ' + className,
	      width: width,
	      height: height,
	      viewBox: '0 0 16 16' },
	    _react2.default.createElement('path', { fillRule: 'evenodd', d: 'M14.666 9.36a.649.649 0 0 1-.639.529H5.89l.166.889h7.472c.204 0 .37.083.5.25.13.166.176.351.14.555l-.167.695c.277.13.495.319.652.569.158.25.237.523.237.82 0 .425-.153.791-.459 1.097a1.497 1.497 0 0 1-1.097.458c-.426 0-.792-.153-1.097-.458a1.513 1.513 0 0 1-.459-1.112c0-.435.158-.8.473-1.097H6.417c.314.297.472.662.472 1.097 0 .436-.153.806-.459 1.112a1.497 1.497 0 0 1-1.097.458c-.426 0-.791-.153-1.097-.458a1.497 1.497 0 0 1-.458-1.098c0-.277.07-.537.208-.777.139-.241.329-.436.57-.584L2.61 2.778H.667a.643.643 0 0 1-.473-.195A.643.643 0 0 1 0 2.111v-.444c0-.186.065-.343.194-.473A.643.643 0 0 1 .667 1h2.86c.149 0 .283.05.403.153.12.102.2.227.237.375l.25 1.25h10.916c.222 0 .398.083.528.25.13.166.166.352.11.555l-1.305 5.778z' })
	  );
	}
	
	Cart.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Cart = __webpack_require__(1140);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Cart).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1142 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = CheckedOutIcon;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function CheckedOutIcon(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      xmlns: 'http://www.w3.org/2000/svg',
	      focusable: 'false',
	      'aria-hidden': true,
	      className: 'icon-svg-checked-out-icon ' + className,
	      width: width,
	      height: height,
	      viewBox: '0 0 48 48' },
	    _react2.default.createElement(
	      'g',
	      { fill: 'none', fillRule: 'evenodd' },
	      _react2.default.createElement('path', { fill: color, d: 'M8.8569,16.9219 C8.8569,16.8279 8.9029,16.7349 8.9959,16.6409 C9.0879,16.5469 9.1799,16.4999 9.2729,16.4999 L23.9419,16.4999 C24.0339,16.4999 24.1269,16.5469 24.2189,16.6409 C24.3109,16.7349 24.3569,16.8279 24.3569,16.9219 L24.3569,18.3279 C24.3569,18.4219 24.3109,18.5159 24.2189,18.6089 C24.1269,18.7029 24.0339,18.7499 23.9419,18.7499 L9.2729,18.7499 C9.1799,18.7499 9.0879,18.7029 8.9959,18.6089 C8.9029,18.5159 8.8569,18.4219 8.8569,18.3279 L8.8569,16.9219 Z M8.8569,12.4219 C8.8569,12.3279 8.9029,12.2349 8.9959,12.1409 C9.0879,12.0469 9.1799,11.9999 9.2729,11.9999 L23.9419,11.9999 C24.0339,11.9999 24.1269,12.0469 24.2189,12.1409 C24.3109,12.2349 24.3569,12.3279 24.3569,12.4219 L24.3569,13.8279 C24.3569,13.9219 24.3109,14.0159 24.2189,14.1089 C24.1269,14.2029 24.0339,14.2499 23.9419,14.2499 L9.2729,14.2499 C9.1799,14.2499 9.0879,14.2029 8.9959,14.1089 C8.9029,14.0159 8.8569,13.9219 8.8569,13.8279 L8.8569,12.4219 Z M21.5249,34.4999 L6.6429,34.4999 C6.0429,34.4999 5.5239,34.2769 5.0859,33.8319 C4.6479,33.3869 4.4289,32.8599 4.4289,32.2499 C4.4289,31.6409 4.6479,31.1129 5.0859,30.6679 C5.5239,30.2229 6.0429,29.9999 6.6429,29.9999 L22.0719,29.9999 C23.3479,25.5509 26.6909,21.9889 30.9999,20.4039 L30.9999,4.6879 C30.9999,4.2189 30.8379,3.8199 30.5159,3.4919 C30.1929,3.1639 29.8009,2.9999 29.3389,2.9999 L6.6429,2.9999 C4.7979,2.9999 3.2289,3.6559 1.9379,4.9689 C0.6459,6.2809 -0.0001,7.8749 -0.0001,9.7499 L-0.0001,32.2499 C-0.0001,34.1249 0.6459,35.7189 1.9379,37.0309 C3.2289,38.3439 4.7979,38.9999 6.6429,38.9999 L22.4039,38.9999 C21.8839,37.5889 21.5789,36.0779 21.5249,34.4999 Z' }),
	      _react2.default.createElement('path', { fill: color, d: 'M48,34 C48,36.161 47.459,38.161 46.379,40 C45.298,41.839 43.839,43.298 42,44.379 C40.161,45.459 38.161,46 36,46 C33.839,46 31.839,45.459 30,44.379 C28.161,43.298 26.702,41.839 25.621,40 C24.541,38.161 24,36.161 24,34 C24,31.839 24.541,29.839 25.621,28 C26.702,26.161 28.161,24.702 30,23.621 C31.839,22.541 33.839,22 36,22 C38.161,22 40.161,22.541 42,23.621 C43.839,24.702 45.298,26.161 46.379,28 C47.459,29.839 48,31.839 48,34 Z M26.323,34 C26.323,35.742 26.758,37.355 27.629,38.839 C28.5,40.323 29.677,41.5 31.161,42.371 C32.645,43.242 34.258,43.677 36,43.677 C37.742,43.677 39.355,43.242 40.839,42.371 C42.323,41.5 43.5,40.323 44.371,38.839 C45.242,37.355 45.677,35.742 45.677,34 C45.677,32.258 45.242,30.645 44.371,29.161 C43.5,27.677 42.323,26.5 40.839,25.629 C39.355,24.758 37.742,24.323 36,24.323 C34.258,24.323 32.645,24.758 31.161,25.629 C29.677,26.5 28.5,27.677 27.629,29.161 C26.758,30.645 26.323,32.258 26.323,34 Z M29.807,33.032 C29.807,32.871 29.863,32.734 29.976,32.621 C30.089,32.508 30.226,32.452 30.387,32.452 L36,32.452 L36,29.209 C36,28.952 36.121,28.774 36.363,28.677 C36.605,28.581 36.807,28.613 36.968,28.774 L41.807,33.564 C41.903,33.693 41.952,33.839 41.952,34 C41.952,34.161 41.903,34.307 41.807,34.436 L37.016,39.177 C36.823,39.371 36.605,39.419 36.363,39.323 C36.121,39.226 36,39.048 36,38.791 L36,35.548 L30.387,35.548 C30.226,35.548 30.089,35.492 29.976,35.379 C29.863,35.266 29.807,35.129 29.807,34.968 L29.807,33.032 Z' })
	    )
	  );
	}
	
	CheckedOutIcon.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1143 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CheckedOutIcon = __webpack_require__(1142);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CheckedOutIcon).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1144 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Checkmark;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Checkmark(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#000' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-checkmark ' + className, width: width, height: height, viewBox: '0 0 16 16' },
	    _react2.default.createElement('path', { fill: color, d: 'M13.5 2l-7.5 7.5-3.5-3.5-2.5 2.5 6 6 10-10z' })
	  );
	}
	
	Checkmark.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Checkmark = __webpack_require__(1144);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Checkmark).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	function CheckmarkCircle(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      xmlns: 'http://www.w3.org/2000/svg',
	      focusable: 'false',
	      'aria-hidden': true,
	      className: 'icon-svg-checkmark-circle ' + className,
	      preserveAspectRatio: 'xMinYMin meet',
	      width: width,
	      height: height,
	      viewBox: '0 0 16 16' },
	    _react2.default.createElement('path', { color: color, fillRule: 'evenodd', d: 'M16,8 C16,9.44086038 15.6397848,10.7741935 14.9193548,12 C14.1989249,13.2258065 13.2258065,14.1989249 12,14.9193548 C10.7741935,15.6397848 9.44086038,16 8,16 C6.55913962,16 5.22580645,15.6397848 4,14.9193548 C2.77419355,14.1989249 1.8010751,13.2258065 1.08064516,12 C0.360215218,10.7741935 0,9.44086038 0,8 C0,6.55913962 0.360215218,5.22580645 1.08064516,4 C1.8010751,2.77419355 2.77419355,1.8010751 4,1.08064516 C5.22580645,0.360215218 6.55913962,0 8,0 C9.44086038,0 10.7741935,0.360215218 12,1.08064516 C13.2258065,1.8010751 14.1989249,2.77419355 14.9193548,4 C15.6397848,5.22580645 16,6.55913962 16,8 Z M7.06451613,12.2258065 L13,6.29032258 C13.1075267,6.20430091 13.1612903,6.08602167 13.1612903,5.93548387 C13.1612903,5.78494607 13.1075267,5.66666683 13,5.58064516 L12.2903226,4.83870968 C12.1827959,4.73118296 12.0591396,4.67741935 11.9193548,4.67741935 C11.7795701,4.67741935 11.6559138,4.73118296 11.5483871,4.83870968 L6.70967742,9.67741935 L4.4516129,7.41935484 C4.34408619,7.31182812 4.22042994,7.25806452 4.08064516,7.25806452 C3.94086038,7.25806452 3.81720414,7.31182812 3.70967742,7.41935484 L3,8.16129032 C2.89247328,8.24731199 2.83870968,8.36559123 2.83870968,8.51612903 C2.83870968,8.66666683 2.89247328,8.78494607 3,8.87096774 L6.35483871,12.2258065 C6.44086038,12.3333332 6.55913962,12.3870968 6.70967742,12.3870968 C6.86021522,12.3870968 6.97849446,12.3333332 7.06451613,12.2258065 Z' })
	  );
	}
	
	CheckmarkCircle.propTypes = {
	  className: _react.PropTypes.string,
	  width: _react.PropTypes.number,
	  height: _react.PropTypes.number,
	  color: _react.PropTypes.string
	};
	
	exports.default = CheckmarkCircle;

/***/ },
/* 1147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CheckmarkCircle = __webpack_require__(1146);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CheckmarkCircle).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1148 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = DoubleRight;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	function DoubleRight(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 10 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 18 : _ref$height;
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      focusable: 'false',
	      'aria-hidden': true,
	      className: 'icon-svg-chevron-double-right ' + className,
	      width: width,
	      height: height,
	      viewBox: '0 0 10 18' },
	    _react2.default.createElement('path', { d: 'M5.9765625,8.21428571 C5.9765625,8.30133972 5.94308069,8.37834788 5.87611607,8.4453125 L1.1953125,13.1261161 C1.12834788,13.1930807 1.05133972,13.2265625 0.964285714,13.2265625 C0.877231708,13.2265625 0.800223549,13.1930807 0.733258929,13.1261161 L0.231026786,12.6238839 C0.164062165,12.5569193 0.130580357,12.4799111 0.130580357,12.3928571 C0.130580357,12.3058031 0.164062165,12.228795 0.231026786,12.1618304 L4.17857143,8.21428571 L0.231026786,4.26674107 C0.164062165,4.19977645 0.130580357,4.12276829 0.130580357,4.03571429 C0.130580357,3.94866028 0.164062165,3.87165212 0.231026786,3.8046875 L0.733258929,3.30245536 C0.800223549,3.23549074 0.877231708,3.20200893 0.964285714,3.20200893 C1.05133972,3.20200893 1.12834788,3.23549074 1.1953125,3.30245536 L5.87611607,7.98325893 C5.94308069,8.05022355 5.9765625,8.12723171 5.9765625,8.21428571 Z M9.83370536,8.21428571 C9.83370536,8.30133972 9.80022355,8.37834788 9.73325893,8.4453125 L5.05245536,13.1261161 C4.98549074,13.1930807 4.90848258,13.2265625 4.82142857,13.2265625 C4.73437456,13.2265625 4.65736641,13.1930807 4.59040179,13.1261161 L4.08816964,12.6238839 C4.02120502,12.5569193 3.98772321,12.4799111 3.98772321,12.3928571 C3.98772321,12.3058031 4.02120502,12.228795 4.08816964,12.1618304 L8.03571429,8.21428571 L4.08816964,4.26674107 C4.02120502,4.19977645 3.98772321,4.12276829 3.98772321,4.03571429 C3.98772321,3.94866028 4.02120502,3.87165212 4.08816964,3.8046875 L4.59040179,3.30245536 C4.65736641,3.23549074 4.73437456,3.20200893 4.82142857,3.20200893 C4.90848258,3.20200893 4.98549074,3.23549074 5.05245536,3.30245536 L9.73325893,7.98325893 C9.80022355,8.05022355 9.83370536,8.12723171 9.83370536,8.21428571 Z' })
	  );
	}
	
	DoubleRight.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1149 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Left;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	function Left(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className;
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      xmlns: 'http://www.w3.org/2000/svg',
	      focusable: 'false',
	      'aria-hidden': true,
	      className: 'icon-svg-chevron-left ' + className,
	      viewBox: '0 0 6 18' },
	    _react2.default.createElement('path', { fill: 'currentColor', d: 'M0.130580357,8.21428571 C0.130580357,8.30133972 0.164062165,8.37834788 0.231026786,8.4453125 L4.91183036,13.1261161 C4.97879498,13.1930807 5.05580314,13.2265625 5.14285714,13.2265625 C5.22991115,13.2265625 5.30691931,13.1930807 5.37388393,13.1261161 L5.87611607,12.6238839 C5.94308069,12.5569193 5.9765625,12.4799111 5.9765625,12.3928571 C5.9765625,12.3058031 5.94308069,12.228795 5.87611607,12.1618304 L1.92857143,8.21428571 L5.87611607,4.26674107 C5.94308069,4.19977645 5.9765625,4.12276829 5.9765625,4.03571429 C5.9765625,3.94866028 5.94308069,3.87165212 5.87611607,3.8046875 L5.37388393,3.30245536 C5.30691931,3.23549074 5.22991115,3.20200893 5.14285714,3.20200893 C5.05580314,3.20200893 4.97879498,3.23549074 4.91183036,3.30245536 L0.231026786,7.98325893 C0.164062165,8.05022355 0.130580357,8.12723171 0.130580357,8.21428571 Z' })
	  );
	}
	
	Left.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1150 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Right;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	function Right(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className;
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      xmlns: 'http://www.w3.org/2000/svg',
	      focusable: 'false',
	      'aria-hidden': true,
	      className: 'icon-svg-chevron-right ' + className,
	      viewBox: '0 0 6 18' },
	    _react2.default.createElement('path', { fill: 'currentColor', d: 'M5.9765625,8.21428571 C5.9765625,8.30133972 5.94308069,8.37834788 5.87611607,8.4453125 L1.1953125,13.1261161 C1.12834788,13.1930807 1.05133972,13.2265625 0.964285714,13.2265625 C0.877231708,13.2265625 0.800223549,13.1930807 0.733258929,13.1261161 L0.231026786,12.6238839 C0.164062165,12.5569193 0.130580357,12.4799111 0.130580357,12.3928571 C0.130580357,12.3058031 0.164062165,12.228795 0.231026786,12.1618304 L4.17857143,8.21428571 L0.231026786,4.26674107 C0.164062165,4.19977645 0.130580357,4.12276829 0.130580357,4.03571429 C0.130580357,3.94866028 0.164062165,3.87165212 0.231026786,3.8046875 L0.733258929,3.30245536 C0.800223549,3.23549074 0.877231708,3.20200893 0.964285714,3.20200893 C1.05133972,3.20200893 1.12834788,3.23549074 1.1953125,3.30245536 L5.87611607,7.98325893 C5.94308069,8.05022355 5.9765625,8.12723171 5.9765625,8.21428571 Z' })
	  );
	}
	
	Right.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1151 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Left = __webpack_require__(1149);
	
	var _Left2 = _interopRequireDefault(_Left);
	
	var _Right = __webpack_require__(1150);
	
	var _Right2 = _interopRequireDefault(_Right);
	
	var _DoubleRight = __webpack_require__(1148);
	
	var _DoubleRight2 = _interopRequireDefault(_DoubleRight);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = { Left: _Left2.default, Right: _Right2.default, DoubleRight: _DoubleRight2.default };

/***/ },
/* 1152 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function Clock(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 12 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 12 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-clock ' + className, xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 12 12' },
	    _react2.default.createElement(
	      'g',
	      { fill: color, fillRule: 'evenodd' },
	      _react2.default.createElement('path', { d: 'M12 6A6 6 0 0 1 0 6a6 6 0 0 1 12 0zm-1.25 0A4.75 4.75 0 0 0 6 1.25 4.75 4.75 0 0 0 1.25 6 4.75 4.75 0 0 0 6 10.75 4.75 4.75 0 0 0 10.75 6z' }),
	      _react2.default.createElement('path', { d: 'M5.443 6.823a.297.297 0 0 1-.12-.242V2.613a.28.28 0 0 1 .084-.206.282.282 0 0 1 .205-.084h.775a.28.28 0 0 1 .205.084.28.28 0 0 1 .085.206v3.436l1.621 1.16a.268.268 0 0 1 .11.195.297.297 0 0 1-.062.217l-.435.629a.309.309 0 0 1-.194.12.262.262 0 0 1-.217-.047l-2.057-1.5z' })
	    )
	  );
	}
	
	Clock.propTypes = _bcPropTypes.iconShape;
	
	exports.default = Clock;

/***/ },
/* 1153 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Clock = __webpack_require__(1152);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Clock).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1154 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	var CloudDownload = function CloudDownload(_ref) {
	  var className = _ref.className,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color;
	  return _react2.default.createElement(
	    'svg',
	    {
	      xmlns: 'http://www.w3.org/2000/svg',
	      focusable: 'false',
	      'aria-hidden': true,
	      className: 'icon-svg-cloud-download ' + className,
	      preserveAspectRatio: 'xMinYMin meet',
	      viewBox: '0 0 16 16' },
	    _react2.default.createElement('path', {
	      fill: color,
	      fillRule: 'evenodd',
	      d: 'M16,10.5 C16,11.0833332 15.8583332,11.6208332 15.575,12.1125 C15.2916668,12.6041668 14.9041668,12.9916668 14.4125,13.275 C13.9208332,13.5583332 13.3833332,13.7 12.8,13.7 L3.6,13.7 C2.95,13.7 2.35,13.5375 1.8,13.2125 C1.25,12.8875 0.8125,12.45 0.4875,11.9 C0.1625,11.35 0,10.75 0,10.1 C0,9.33333321 0.225,8.6375 0.675,8.0125 C1.125,7.3875 1.7,6.95 2.4,6.7 L2.4,6.5 C2.4,5.78333321 2.57916679,5.11666679 2.9375,4.5 C3.29583321,3.88333321 3.78333321,3.39583321 4.4,3.0375 C5.01666679,2.67916679 5.6875,2.5 6.4125,2.5 C7.1375,2.5 7.80833321,2.68333321 8.425,3.05 C9.04166679,3.41666679 9.525,3.9 9.875,4.5 C10.275,4.23333321 10.7166668,4.1 11.2,4.1 C11.8666668,4.1 12.4333332,4.33333321 12.9,4.8 C13.3666668,5.26666679 13.6,5.83333321 13.6,6.5 C13.6,6.8 13.55,7.09166679 13.45,7.375 C14.1833332,7.525 14.7916668,7.89166679 15.275,8.475 C15.7583332,9.05833321 16,9.73333321 16,10.5 Z M9.825,8.9 L8.2,8.9 L8.2,6.1 C8.2,5.98333321 8.1625,5.8875 8.0875,5.8125 C8.0125,5.7375 7.91666679,5.7 7.8,5.7 L6.6,5.7 C6.48333321,5.7 6.3875,5.7375 6.3125,5.8125 C6.2375,5.8875 6.2,5.98333321 6.2,6.1 L6.2,8.9 L4.575,8.9 C4.39166679,8.9 4.26666679,8.98333321 4.2,9.15 C4.13333321,9.31666679 4.15833321,9.45833321 4.275,9.575 L6.925,12.225 C6.99166679,12.2916668 7.08333321,12.325 7.2,12.325 C7.31666679,12.325 7.40833321,12.2916668 7.475,12.225 L10.125,9.575 C10.2416668,9.45833321 10.2666668,9.31666679 10.2,9.15 C10.1333332,8.98333321 10.0083332,8.9 9.825,8.9 Z' })
	  );
	};
	
	CloudDownload.propTypes = _bcPropTypes.iconShape;
	
	exports.default = CloudDownload;

/***/ },
/* 1155 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CloudDownload = __webpack_require__(1154);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CloudDownload).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1156 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Cog;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function Cog(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#000' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-cog ' + className, width: width, height: height, viewBox: '0 0 1792 1792' },
	    _react2.default.createElement('path', { fill: color, d: 'M1152 896q0-106-75-181t-181-75-181 75-75 181 75 181 181 75 181-75 75-181zm512-109v222q0 12-8 23t-20 13l-185 28q-19 54-39 91 35 50 107 138 10 12 10 25t-9 23q-27 37-99 108t-94 71q-12 0-26-9l-138-108q-44 23-91 38-16 136-29 186-7 28-36 28h-222q-14 0-24.5-8.5t-11.5-21.5l-28-184q-49-16-90-37l-141 107q-10 9-25 9-14 0-25-11-126-114-165-168-7-10-7-23 0-12 8-23 15-21 51-66.5t54-70.5q-27-50-41-99l-183-27q-13-2-21-12.5t-8-23.5v-222q0-12 8-23t19-13l186-28q14-46 39-92-40-57-107-138-10-12-10-24 0-10 9-23 26-36 98.5-107.5t94.5-71.5q13 0 26 10l138 107q44-23 91-38 16-136 29-186 7-28 36-28h222q14 0 24.5 8.5t11.5 21.5l28 184q49 16 90 37l142-107q9-9 24-9 13 0 25 10 129 119 165 170 7 8 7 22 0 12-8 23-15 21-51 66.5t-54 70.5q26 50 41 98l183 28q13 2 21 12.5t8 23.5z' })
	  );
	}
	
	Cog.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1157 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Cog = __webpack_require__(1156);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Cog).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1158 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = CogAlternate;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function CogAlternate(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#000' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-cog-alternate ' + className, width: width, height: height, viewBox: '0 0 16 16' },
	    _react2.default.createElement('path', { fill: color, d: 'M16 9.501v-3.003l-2.293-0.382c-0.093-0.283-0.207-0.557-0.339-0.82l1.351-1.891-2.123-2.123-1.888 1.349c-0.264-0.134-0.54-0.248-0.825-0.342l-0.381-2.288h-3.003l-0.381 2.288c-0.285 0.094-0.56 0.209-0.824 0.342l-1.888-1.349-2.123 2.123 1.351 1.891c-0.132 0.263-0.246 0.537-0.339 0.82l-2.293 0.382v3.003l2.299 0.383c0.093 0.281 0.206 0.552 0.338 0.813l-1.355 1.898 2.123 2.123 1.901-1.358c0.259 0.13 0.53 0.243 0.809 0.335l0.384 2.304h3.003l0.384-2.304c0.279-0.092 0.549-0.204 0.809-0.335l1.901 1.358 2.123-2.123-1.355-1.898c0.132-0.261 0.245-0.532 0.338-0.813l2.299-0.383zM8 10c-1.105 0-2-0.895-2-2s0.895-2 2-2c1.105 0 2 0.895 2 2s-0.895 2-2 2z' })
	  );
	}
	
	CogAlternate.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1159 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CogAlternate = __webpack_require__(1158);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CogAlternate).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1160 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable max-len */
	
	var Comment = function (_BcReactComponent) {
	  _inherits(Comment, _BcReactComponent);
	
	  function Comment() {
	    _classCallCheck(this, Comment);
	
	    return _possibleConstructorReturn(this, (Comment.__proto__ || Object.getPrototypeOf(Comment)).apply(this, arguments));
	  }
	
	  _createClass(Comment, [{
	    key: 'render',
	    value: function render() {
	      var className = this.props.className;
	
	      return _react2.default.createElement(
	        'svg',
	        { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-comment ' + className, preserveAspectRatio: 'xMinYMin meet', viewBox: '0 0 16 16' },
	        _react2.default.createElement('path', { className: 'path1', d: 'M8 1c4.418 0 8 2.91 8 6.5s-3.582 6.5-8 6.5c-0.424 0-0.841-0.027-1.247-0.079-1.718 1.718-3.77 2.027-5.753 2.072v-0.421c1.071-0.525 2-1.48 2-2.572 0-0.152-0.012-0.302-0.034-0.448-1.809-1.192-2.966-3.012-2.966-5.052 0-3.59 3.582-6.5 8-6.5z' })
	      );
	    }
	  }]);
	
	  return Comment;
	}(_baseBcReactComponent2.default);
	
	Comment.propTypes = {
	  className: _react.PropTypes.string
	};
	
	exports.default = Comment;

/***/ },
/* 1161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Comment = __webpack_require__(1160);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Comment).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1162 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	var CompactDisc = function CompactDisc(_ref) {
	  var className = _ref.className,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 26 : _ref$height,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 26 : _ref$width;
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-compact-disc ' + className, preserveAspectRatio: 'xMinYMin meet', width: width, height: height, viewBox: '0 0 26 26' },
	    _react2.default.createElement(
	      'g',
	      { fill: 'none', fillRule: 'evenodd' },
	      _react2.default.createElement('path', { fill: color, d: 'M13,0 C5.82,0 0,5.82 0,13 C0,20.18 5.82,26 13,26 C20.18,26 26,20.18 26,13 C26,5.82 20.18,0 13,0 M13,1.4 C19.396,1.4 24.6,6.604 24.6,13 C24.6,19.396 19.396,24.6 13,24.6 C6.604,24.6 1.4,19.396 1.4,13 C1.4,6.604 6.604,1.4 13,1.4' }),
	      _react2.default.createElement('path', { fill: color, d: 'M13,8 C10.239,8 8,10.239 8,13 C8,15.761 10.239,18 13,18 C15.761,18 18,15.761 18,13 C18,10.239 15.761,8 13,8 M13,9.4 C14.985,9.4 16.6,11.015 16.6,13 C16.6,14.985 14.985,16.6 13,16.6 C11.015,16.6 9.4,14.985 9.4,13 C9.4,11.015 11.015,9.4 13,9.4' }),
	      _react2.default.createElement('path', { fill: color, d: 'M13,11 C11.896,11 11,11.896 11,13 C11,14.104 11.896,15 13,15 C14.104,15 15,14.104 15,13 C15,11.896 14.104,11 13,11 M13,11.75 C13.689,11.75 14.25,12.311 14.25,13 C14.25,13.689 13.689,14.25 13,14.25 C12.311,14.25 11.75,13.689 11.75,13 C11.75,12.311 12.311,11.75 13,11.75' }),
	      _react2.default.createElement('path', { fill: color, fillRule: 'nonzero', d: 'M18.6666857,15.0978788 C18.7445143,14.905952 18.9631943,14.813457 19.1551212,14.8912857 C19.347048,14.9691143 19.439543,15.1877943 19.3617143,15.3797212 C19.0275712,16.2037247 18.5302482,16.9570819 17.8881506,17.5991793 C17.244699,18.2415914 16.4921158,18.7385803 15.6691212,19.0723143 C15.4771943,19.150143 15.2585143,19.057648 15.1806857,18.8657212 C15.102857,18.6737943 15.195352,18.4551143 15.3872788,18.3772857 C16.1177485,18.0810716 16.7859178,17.6398277 17.358035,17.068635 C17.9286073,16.4980626 18.3700856,15.8293003 18.6666857,15.0978788 Z M7.47791435,10.7576212 C7.40008573,10.949548 7.1814057,11.042043 6.98947883,10.9642143 C6.79755195,10.8863857 6.70505704,10.6677057 6.78288565,10.4757788 C7.11702882,9.65177528 7.61435177,8.89841814 8.25644941,8.25632068 C8.89990099,7.6139086 9.65248418,7.1169197 10.4754788,6.78318565 C10.6674057,6.70535704 10.8860857,6.79785195 10.9639143,6.98977883 C11.041743,7.1817057 10.949248,7.40038573 10.7573212,7.47821435 C10.0268515,7.77442842 9.35868222,8.2156723 8.78656504,8.78686504 C8.21599273,9.35743735 7.77451441,10.0261997 7.47791435,10.7576212 Z M20.2316202,15.7329937 C20.3094958,15.5410859 20.5281985,15.4486446 20.7201063,15.5265202 C20.9120141,15.6043958 21.0044554,15.8230985 20.9265798,16.0150063 C20.5075856,17.0475278 19.8857476,17.9896824 19.082265,18.793165 C18.2787824,19.5966476 17.3366278,20.2184856 16.3041063,20.6374798 C16.1121985,20.7153554 15.8934958,20.6229141 15.8156202,20.4310063 C15.7377446,20.2390985 15.8301859,20.0203958 16.0220937,19.9425202 C16.9621483,19.5610487 17.8197581,18.9950119 18.551935,18.262835 C19.2841119,17.5306581 19.8501487,16.6730483 20.2316202,15.7329937 Z M5.91287982,10.1224063 C5.83500419,10.3143141 5.6163015,10.4067554 5.4243937,10.3288798 C5.23248589,10.2510042 5.14004455,10.0323015 5.21792018,9.8403937 C5.63691442,8.80787218 6.25875236,7.86571756 7.06223496,7.06223496 C7.86571756,6.25875236 8.80787218,5.63691442 9.8403937,5.21792018 C10.0323015,5.14004455 10.2510042,5.23248589 10.3288798,5.4243937 C10.4067554,5.6163015 10.3143141,5.83500419 10.1224063,5.91287982 C9.18235168,6.29435126 8.32474195,6.86038814 7.59256504,7.59256504 C6.86038814,8.32474195 6.29435126,9.18235168 5.91287982,10.1224063 Z M21.7969812,16.3688899 C21.8748037,16.1769605 22.0934808,16.0844587 22.2854101,16.1622812 C22.4773395,16.2401037 22.5698413,16.4587808 22.4920188,16.6507101 C21.9896538,17.8896651 21.2425719,19.0210581 20.276665,19.986965 C19.3098944,20.9537357 18.1785335,21.7008856 16.9394101,22.2033188 C16.7474808,22.2811413 16.5288037,22.1886395 16.4509812,21.9967101 C16.3731587,21.8047808 16.4656605,21.5861037 16.6575899,21.5082812 C17.8040774,21.0434094 18.8508452,20.3521248 19.746335,19.456635 C20.640951,18.562019 21.3321725,17.5152217 21.7969812,16.3688899 Z M4.34751883,9.48661012 C4.26969632,9.67853947 4.05101923,9.77104134 3.85908988,9.69321883 C3.66716053,9.61539632 3.57465866,9.39671923 3.65248117,9.20478988 C4.15484616,7.96583488 4.90192806,6.83444185 5.86783496,5.86853496 C6.83460558,4.90176433 7.96596647,4.15461444 9.20508988,3.65218117 C9.39701923,3.57435866 9.61569632,3.66686053 9.69351883,3.85878988 C9.77134134,4.05071923 9.67883947,4.26939632 9.48691012,4.34721883 C8.34042262,4.81209058 7.29365484,5.50337524 6.39816504,6.39886504 C5.50354904,7.29348105 4.81232747,8.34027827 4.34751883,9.48661012 Z' })
	    )
	  );
	};
	
	CompactDisc.propTypes = _bcPropTypes.iconShape;
	
	exports.default = CompactDisc;

/***/ },
/* 1163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CompactDisc = __webpack_require__(1162);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CompactDisc).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable max-len */
	
	var ContentAdvisory = function (_BcReactComponent) {
	  _inherits(ContentAdvisory, _BcReactComponent);
	
	  function ContentAdvisory() {
	    _classCallCheck(this, ContentAdvisory);
	
	    return _possibleConstructorReturn(this, (ContentAdvisory.__proto__ || Object.getPrototypeOf(ContentAdvisory)).apply(this, arguments));
	  }
	
	  _createClass(ContentAdvisory, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'svg',
	        { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-content-advisory', preserveAspectRatio: 'xMinYMin meet', viewBox: '0 0 16 16' },
	        _react2.default.createElement('path', { className: 'path1', d: 'M15.781 14.309v0l-6.829-13.611c-0.262-0.465-0.606-0.698-0.951-0.698s-0.69 0.233-0.951 0.698l-6.829 13.611c-0.523 0.93-0.078 1.691 0.989 1.691h13.583c1.067 0 1.512-0.761 0.989-1.691zM8 14c-0.552 0-1-0.448-1-1s0.448-1 1-1c0.552 0 1 0.448 1 1s-0.448 1-1 1zM9 10c0 0.552-0.448 1-1 1s-1-0.448-1-1v-3c0-0.552 0.448-1 1-1s1 0.448 1 1v3z' })
	      );
	    }
	  }]);
	
	  return ContentAdvisory;
	}(_baseBcReactComponent2.default);
	
	exports.default = ContentAdvisory;

/***/ },
/* 1165 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ContentAdvisory = __webpack_require__(1164);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ContentAdvisory).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Cross;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function Cross(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-cross ' + className, width: width, height: height, viewBox: '0 0 16 16' },
	    _react2.default.createElement(
	      'g',
	      { fill: 'none', fillRule: 'evenodd' },
	      _react2.default.createElement('rect', { width: '2', height: '16', x: '6.964', y: '-.036', fill: color, transform: 'rotate(45 7.964 7.964)' }),
	      _react2.default.createElement('rect', { width: '2', height: '16', x: '6.964', y: '-.036', fill: color, transform: 'scale(-1 1) rotate(45 0 -11.263)' })
	    )
	  );
	}
	
	Cross.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Cross = __webpack_require__(1166);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Cross).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	var Device = function Device(_ref) {
	  var className = _ref.className,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 26 : _ref$height,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 26 : _ref$width;
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-device ' + className, preserveAspectRatio: 'xMinYMin meet', width: width, height: height, viewBox: '0 0 26 26' },
	    _react2.default.createElement('path', { fill: color, fillRule: 'evenodd', d: 'M6,2 L20,2 C21.1045695,2 22,2.8954305 22,4 L22,22 C22,23.1045695 21.1045695,24 20,24 L6,24 C4.8954305,24 4,23.1045695 4,22 L4,4 C4,2.8954305 4.8954305,2 6,2 Z M6,4 L6,20 L20,20 L20,4 L6,4 Z M13,23 C13.5522847,23 14,22.5522847 14,22 C14,21.4477153 13.5522847,21 13,21 C12.4477153,21 12,21.4477153 12,22 C12,22.5522847 12.4477153,23 13,23 Z' })
	  );
	};
	
	Device.propTypes = _bcPropTypes.iconShape;
	
	exports.default = Device;

/***/ },
/* 1169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Device = __webpack_require__(1168);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Device).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Empty;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	function Empty(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      focusable: 'false',
	      'aria-hidden': true,
	      className: 'icon-svg-dots-empty ' + className,
	      width: width,
	      height: height,
	      viewBox: '0 0 16 16' },
	    _react2.default.createElement('circle', {
	      cx: '8',
	      cy: '8',
	      r: '5.5',
	      stroke: color,
	      strokeWidth: '1',
	      fill: 'none',
	      fillRule: 'evenodd' })
	  );
	}
	
	Empty.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Full;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	function Full(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      xmlns: 'http://www.w3.org/2000/svg',
	      focusable: 'false',
	      'aria-hidden': true,
	      className: 'icon-svg-dots-full ' + className,
	      width: width,
	      height: height,
	      viewBox: '0 0 16 16' },
	    _react2.default.createElement('circle', {
	      cx: '8',
	      cy: '8',
	      r: '5.5',
	      stroke: color,
	      strokeWidth: '1',
	      fill: color,
	      fillRule: 'evenodd' })
	  );
	}
	
	Full.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Empty = __webpack_require__(1170);
	
	var _Empty2 = _interopRequireDefault(_Empty);
	
	var _Full = __webpack_require__(1171);
	
	var _Full2 = _interopRequireDefault(_Full);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = { Empty: _Empty2.default, Full: _Full2.default };

/***/ },
/* 1173 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Ellipsis;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function Ellipsis(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height;
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      xmlns: 'http://www.w3.org/2000/svg',
	      focusable: 'false',
	      'aria-hidden': true,
	      className: 'icon-svg-ellipsis ' + className,
	      width: width,
	      height: height,
	      viewBox: '0 0 16 16' },
	    _react2.default.createElement('path', { fillRule: 'evenodd', d: 'M3,10 C1.8954305,10 1,9.1045695 1,8 C1,6.8954305 1.8954305,6 3,6 C4.1045695,6 5,6.8954305 5,8 C5,9.1045695 4.1045695,10 3,10 Z M8,10 C6.8954305,10 6,9.1045695 6,8 C6,6.8954305 6.8954305,6 8,6 C9.1045695,6 10,6.8954305 10,8 C10,9.1045695 9.1045695,10 8,10 Z M13,10 C11.8954305,10 11,9.1045695 11,8 C11,6.8954305 11.8954305,6 13,6 C14.1045695,6 15,6.8954305 15,8 C15,9.1045695 14.1045695,10 13,10 Z' })
	  );
	}
	
	Ellipsis.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Ellipsis = __webpack_require__(1173);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Ellipsis).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Envelope;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function Envelope(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height;
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      xmlns: 'http://www.w3.org/2000/svg',
	      focusable: 'false',
	      'aria-hidden': true,
	      className: 'icon-svg-envelope ' + className,
	      width: width,
	      height: height,
	      viewBox: '0 0 16 16' },
	    _react2.default.createElement('path', { d: 'M.5 2h15a.5.5 0 0 1 .5.5v2.223a.5.5 0 0 1-.235.424l-7.5 4.687a.5.5 0 0 1-.53 0l-7.5-4.687A.5.5 0 0 1 0 4.723V2.5A.5.5 0 0 1 .5 2zM0 6.598l7.735 4.834a.5.5 0 0 0 .53 0L16 6.598v7.5a.5.5 0 0 1-.5.5H.5a.5.5 0 0 1-.5-.5v-7.5z' })
	  );
	}
	
	Envelope.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1176 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Envelope = __webpack_require__(1175);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Envelope).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ExternalArrow;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function ExternalArrow(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className;
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      xmlns: 'http://www.w3.org/2000/svg',
	      focusable: 'false',
	      'aria-hidden': true,
	      className: 'icon-svg-external-arrow ' + className,
	      viewBox: '0 0 16 16' },
	    _react2.default.createElement(
	      'defs',
	      null,
	      _react2.default.createElement('path', {
	        id: 'new-tab-3-a',
	        d: 'M8.92063492,2 L10.9269841,3.98119122 L6.14526984,8.68288401 C6.0487619,8.78018809 6,8.89655172 6,9.03398119 C6,9.17040752 6.0487619,9.28677116 6.14526984,9.3830721 L6.6247619,9.85554859 C6.72126984,9.95184953 6.84012698,10 6.97930159,10 C7.11746032,10 7.23631746,9.95184953 7.33384127,9.85554859 L12.0952381,5.13479624 L14,7.01567398 L14,2 L8.92063492,2 Z' })
	    ),
	    _react2.default.createElement(
	      'g',
	      { fill: 'none', fillRule: 'evenodd' },
	      _react2.default.createElement('polygon', {
	        fill: 'currentColor',
	        points: '11.46 8.5 11.46 12.46 3.54 12.46 3.54 4.54 7.5 4.54 7.5 3 2 3 2 14 13 14 13 8.5' }),
	      _react2.default.createElement('use', { fill: 'currentColor', xlinkHref: '#new-tab-3-a' })
	    )
	  );
	}
	
	ExternalArrow.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ExternalArrow = __webpack_require__(1177);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ExternalArrow).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Eye;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function Eye(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#000' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-eye ' + className, width: width, height: height, viewBox: '0 0 16 16' },
	    _react2.default.createElement('path', { fill: color, d: 'M8 3c-3.489 0-6.514 2.032-8 5 1.486 2.968 4.511 5 8 5s6.514-2.032 8-5c-1.486-2.968-4.511-5-8-5zM11.945 5.652c0.94 0.6 1.737 1.403 2.335 2.348-0.598 0.946-1.395 1.749-2.335 2.348-1.181 0.753-2.545 1.152-3.944 1.152s-2.763-0.398-3.945-1.152c-0.94-0.6-1.737-1.403-2.335-2.348 0.598-0.946 1.395-1.749 2.335-2.348 0.061-0.039 0.123-0.077 0.185-0.114-0.156 0.427-0.241 0.888-0.241 1.369 0 2.209 1.791 4 4 4s4-1.791 4-4c0-0.481-0.085-0.942-0.241-1.369 0.062 0.037 0.124 0.075 0.185 0.114v0zM8 6.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5 0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5z' })
	  );
	}
	
	Eye.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1180 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Eye = __webpack_require__(1179);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Eye).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1181 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Failure = function (_BcReactComponent) {
	  _inherits(Failure, _BcReactComponent);
	
	  function Failure() {
	    _classCallCheck(this, Failure);
	
	    return _possibleConstructorReturn(this, (Failure.__proto__ || Object.getPrototypeOf(Failure)).apply(this, arguments));
	  }
	
	  _createClass(Failure, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          _props$color = _props.color,
	          color = _props$color === undefined ? 'currentColor' : _props$color;
	
	      return _react2.default.createElement(
	        'svg',
	        { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-failure ' + className, preserveAspectRatio: 'xMinYMin meet', viewBox: '0 0 16 16' },
	        _react2.default.createElement('path', { fill: color, className: 'path1', d: 'M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM9 13h-2v-2h2v2zM9 9h-2v-6h2v6z' })
	      );
	    }
	  }]);
	
	  return Failure;
	}(_baseBcReactComponent2.default);
	
	Failure.propTypes = {
	  className: _react.PropTypes.string
	};
	
	exports.default = Failure;

/***/ },
/* 1182 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Failure = __webpack_require__(1181);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Failure).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1183 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Fees;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function Fees(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      xmlns: 'http://www.w3.org/2000/svg',
	      focusable: 'false',
	      'aria-hidden': true,
	      className: 'icon-svg-fees ' + className,
	      width: width, height: height,
	      viewBox: '0 0 48 48' },
	    _react2.default.createElement(
	      'g',
	      { fill: 'none', fillRule: 'evenodd' },
	      _react2.default.createElement('path', { fill: color, d: 'M46,2 L2,2 C0.897,2 0,2.897 0,4 L0,37 C0,38.103 0.897,39 2,39 L9.814,39 C9.644,38.19 9.555,37.353 9.525,36.5 L2.5,36.5 L2.5,4.5 L45.5,4.5 L45.5,36.5 L38.475,36.5 C38.445,37.353 38.356,38.19 38.186,39 L46,39 C47.103,39 48,38.103 48,37 L48,4 C48,2.897 47.103,2 46,2' }),
	      _react2.default.createElement('polygon', { fill: color, points: '0 18 48 18 48 10 0 10' }),
	      _react2.default.createElement('path', { fill: color, d: 'M24,24 C17.373,24 12,29.373 12,36 C12,42.627 17.373,48 24,48 C30.627,48 36,42.627 36,36 C36,29.373 30.627,24 24,24 M24,26.5 C29.238,26.5 33.5,30.762 33.5,36 C33.5,41.238 29.238,45.5 24,45.5 C18.762,45.5 14.5,41.238 14.5,36 C14.5,30.762 18.762,26.5 24,26.5' }),
	      _react2.default.createElement('path', { fill: color, d: 'M23.74487 43.0009065C21.34487 43.0009065 19.12787 41.5989065 18.09687 39.4299065 17.85987 38.9309065 18.07287 38.3349065 18.57087 38.0979065 19.06987 37.8599065 19.66587 38.0729065 19.90387 38.5719065 20.60487 40.0469065 22.11287 41.0009065 23.74487 41.0009065 25.37687 41.0009065 26.88487 40.0469065 27.58587 38.5719065 27.82387 38.0729065 28.41887 37.8589065 28.91887 38.0979065 29.41687 38.3349065 29.62987 38.9309065 29.39287 39.4299065 28.36187 41.5989065 26.14487 43.0009065 23.74487 43.0009065M22 33.5C22 34.329 21.329 35 20.5 35 19.671 35 19 34.329 19 33.5 19 32.671 19.671 32 20.5 32 21.329 32 22 32.671 22 33.5M29 33.5C29 34.329 28.329 35 27.5 35 26.671 35 26 34.329 26 33.5 26 32.671 26.671 32 27.5 32 28.329 32 29 32.671 29 33.5' }),
	      _react2.default.createElement('path', { fill: color, d: 'M46,2 L2,2 C0.897,2 0,2.897 0,4 L0,37 C0,38.103 0.897,39 2,39 L9.814,39 C9.644,38.19 9.555,37.353 9.525,36.5 L2.5,36.5 L2.5,4.5 L45.5,4.5 L45.5,36.5 L38.475,36.5 C38.445,37.353 38.356,38.19 38.186,39 L46,39 C47.103,39 48,38.103 48,37 L48,4 C48,2.897 47.103,2 46,2' }),
	      _react2.default.createElement('polygon', { fill: color, points: '0 18 48 18 48 10 0 10' })
	    )
	  );
	}
	
	Fees.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1184 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Fees = __webpack_require__(1183);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Fees).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1185 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Film;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function Film(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-eye ' + className, width: width, height: height, viewBox: '0 0 16 16' },
	    _react2.default.createElement('path', { fill: color, fillRule: 'evenodd', d: 'M15.25 2c.208 0 .385.073.531.219A.723.723 0 0 1 16 2.75v10.5a.723.723 0 0 1-.219.531.723.723 0 0 1-.531.219H15v-.625a.362.362 0 0 0-.11-.266.362.362 0 0 0-.265-.109h-1.25a.362.362 0 0 0-.266.11.362.362 0 0 0-.109.265V14H3v-.625a.362.362 0 0 0-.11-.266.362.362 0 0 0-.265-.109h-1.25a.362.362 0 0 0-.266.11.362.362 0 0 0-.109.265V14H.75a.723.723 0 0 1-.531-.219A.723.723 0 0 1 0 13.25V2.75c0-.208.073-.385.219-.531A.723.723 0 0 1 .75 2H1v.625c0 .104.036.193.11.266.072.073.16.109.265.109h1.25a.362.362 0 0 0 .266-.11A.362.362 0 0 0 3 2.626V2h10v.625c0 .104.036.193.11.266.072.073.16.109.265.109h1.25a.362.362 0 0 0 .266-.11.362.362 0 0 0 .109-.265V2h.25zM3 11.625v-1.25a.362.362 0 0 0-.11-.266.362.362 0 0 0-.265-.109h-1.25a.362.362 0 0 0-.266.11.362.362 0 0 0-.109.265v1.25c0 .104.036.193.11.266.072.073.16.109.265.109h1.25a.362.362 0 0 0 .266-.11.362.362 0 0 0 .109-.265zm0-3v-1.25a.362.362 0 0 0-.11-.266A.362.362 0 0 0 2.626 7h-1.25a.362.362 0 0 0-.266.11.362.362 0 0 0-.109.265v1.25c0 .104.036.193.11.266.072.073.16.109.265.109h1.25a.362.362 0 0 0 .266-.11A.362.362 0 0 0 3 8.626zm0-3v-1.25a.362.362 0 0 0-.11-.266A.362.362 0 0 0 2.626 4h-1.25a.362.362 0 0 0-.266.11.362.362 0 0 0-.109.265v1.25c0 .104.036.193.11.266.072.073.16.109.265.109h1.25a.362.362 0 0 0 .266-.11A.362.362 0 0 0 3 5.626zm8.5 6.5v-3a.362.362 0 0 0-.11-.266.362.362 0 0 0-.265-.109h-6.25a.362.362 0 0 0-.266.11.362.362 0 0 0-.109.265v3c0 .104.036.193.11.266.072.073.16.109.265.109h6.25a.362.362 0 0 0 .266-.11.362.362 0 0 0 .109-.265zm0-5.25v-3a.362.362 0 0 0-.11-.266.362.362 0 0 0-.265-.109h-6.25a.362.362 0 0 0-.266.11.362.362 0 0 0-.109.265v3c0 .104.036.193.11.266.072.073.16.109.265.109h6.25a.362.362 0 0 0 .266-.11.362.362 0 0 0 .109-.265zm3.5 4.75v-1.25a.362.362 0 0 0-.11-.266.362.362 0 0 0-.265-.109h-1.25a.362.362 0 0 0-.266.11.362.362 0 0 0-.109.265v1.25c0 .104.036.193.11.266.072.073.16.109.265.109h1.25a.362.362 0 0 0 .266-.11.362.362 0 0 0 .109-.265zm0-3v-1.25a.362.362 0 0 0-.11-.266.362.362 0 0 0-.265-.109h-1.25a.362.362 0 0 0-.266.11.362.362 0 0 0-.109.265v1.25c0 .104.036.193.11.266.072.073.16.109.265.109h1.25a.362.362 0 0 0 .266-.11.362.362 0 0 0 .109-.265zm0-3v-1.25a.362.362 0 0 0-.11-.266.362.362 0 0 0-.265-.109h-1.25a.362.362 0 0 0-.266.11.362.362 0 0 0-.109.265v1.25c0 .104.036.193.11.266.072.073.16.109.265.109h1.25a.362.362 0 0 0 .266-.11.362.362 0 0 0 .109-.265z' })
	  );
	}
	
	Film.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1186 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Film = __webpack_require__(1185);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Film).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1187 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Filter;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function Filter(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-filter ' + className, width: width, height: height, viewBox: '0 0 16 16' },
	    _react2.default.createElement('path', { d: 'M0 2l6 6v6l4-1v-5l6-6z' })
	  );
	}
	
	Filter.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1188 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Filter = __webpack_require__(1187);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Filter).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1189 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Flag = Flag;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Flag(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#000' : _ref$color,
	      _ref$hidden = _ref.hidden,
	      hidden = _ref$hidden === undefined ? true : _ref$hidden;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': hidden, className: 'icon-svg-flag ' + className, width: width, height: height, viewBox: '0 0 16 16' },
	    _react2.default.createElement('path', { fill: color, d: 'M0 0h2v16h-2v-16z' }),
	    _react2.default.createElement('path', { fill: color, d: 'M10 1c-0.5 0-0.75-0.25-1-0.5s-0.5-0.5-1-0.5h-5v10h5c0.5 0 0.75 0.25 1 0.5s0.5 0.5 1 0.5h5v-10h-5z' })
	  );
	}
	
	Flag.propTypes = _bcPropTypes.iconShape;
	
	exports.default = Flag;

/***/ },
/* 1190 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Flag = __webpack_require__(1189);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Flag).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1191 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Flashlight;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function Flashlight(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height;
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      xmlns: 'http://www.w3.org/2000/svg',
	      focusable: 'false',
	      'aria-hidden': true,
	      className: 'icon-svg-flashlight ' + className,
	      width: width,
	      height: height,
	      viewBox: '0 0 16 16' },
	    _react2.default.createElement(
	      'g',
	      { fill: color, fillRule: 'evenodd' },
	      _react2.default.createElement('path', { d: 'M15.12 3.987l-1.914.513a.416.416 0 1 0 .216.804l1.913-.513a.415.415 0 0 0 .1-.762.414.414 0 0 0-.316-.042M13.563 1.901l-1.718 1.718a.417.417 0 0 0 .588.589l1.718-1.718a.417.417 0 0 0-.588-.589M11.359 3.1a.416.416 0 0 0 .194-.253l.512-1.913a.417.417 0 0 0-.804-.215l-.512 1.912a.412.412 0 0 0 .041.316.412.412 0 0 0 .569.152M6.899 4.862l4.292 4.292a2.132 2.132 0 0 1-2.194.342L8.52 9.3l-5.384 5.385-1.767-1.767 5.385-5.384-.197-.478A2.132 2.132 0 0 1 6.9 4.862zm4.89 3.713l.812-.811-4.312-4.312-.811.812 4.312 4.311zM7.932 2.633L6.436 4.128a2.974 2.974 0 0 0-.664 3.21L4.726 8.384l-.34-.339-1.67 1.671.339.339L.549 12.56a.507.507 0 0 0 0 .716l2.228 2.227a.507.507 0 0 0 .716 0l5.223-5.223a2.976 2.976 0 0 0 3.209-.664l1.495-1.495a.507.507 0 0 0 0-.716L8.647 2.633a.507.507 0 0 0-.716 0z' })
	    )
	  );
	}
	
	Flashlight.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1192 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Flashlight = __webpack_require__(1191);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Flashlight).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1193 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable max-len */
	
	var FrighteningScenes = function (_BcReactComponent) {
	  _inherits(FrighteningScenes, _BcReactComponent);
	
	  function FrighteningScenes() {
	    _classCallCheck(this, FrighteningScenes);
	
	    return _possibleConstructorReturn(this, (FrighteningScenes.__proto__ || Object.getPrototypeOf(FrighteningScenes)).apply(this, arguments));
	  }
	
	  _createClass(FrighteningScenes, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'svg',
	        { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-frightening-scenes', preserveAspectRatio: 'xMinYMin meet', viewBox: '0 0 16 16' },
	        _react2.default.createElement('path', { className: 'path1', d: 'M12.803 3.197c-1.417-1.417-3.3-2.197-5.303-2.197s-3.887 0.78-5.303 2.197-2.197 3.3-2.197 5.303c0 0.276 0.224 0.5 0.5 0.5 1.93 0 3.5 1.57 3.5 3.5v2c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-2c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v3c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-3c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v3c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-3c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v2c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-2c0-1.93 1.57-3.5 3.5-3.5 0.276 0 0.5-0.224 0.5-0.5 0-2.003-0.78-3.887-2.197-5.303zM6 7c0 0.55-0.45 1-1 1h-1c-0.55 0-1-0.45-1-1v-1c0-0.55 0.45-1 1-1h1c0.55 0 1 0.45 1 1v1zM12 7c0 0.55-0.45 1-1 1h-1c-0.55 0-1-0.45-1-1v-1c0-0.55 0.45-1 1-1h1c0.55 0 1 0.45 1 1v1z' })
	      );
	    }
	  }]);
	
	  return FrighteningScenes;
	}(_baseBcReactComponent2.default);
	
	exports.default = FrighteningScenes;

/***/ },
/* 1194 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FrighteningScenes = __webpack_require__(1193);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FrighteningScenes).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1195 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	var GameController = function GameController(_ref) {
	  var className = _ref.className,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 26 : _ref$height,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 26 : _ref$width;
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-game-controller ' + className, preserveAspectRatio: 'xMinYMin meet', width: width, height: height, viewBox: '0 0 26 26' },
	    _react2.default.createElement('path', { fill: color, fillRule: 'evenodd', d: 'M19.5,5.56253442 C20.6645835,5.56253442 21.7479165,5.85368046 22.75,6.43597192 C23.7520835,7.01826338 24.544271,7.81045088 25.1265625,8.81253442 C25.708854,9.81461796 26,10.8979509 26,12.0625344 C26,13.227118 25.708854,14.3104509 25.1265625,15.3125344 C24.544271,16.314618 23.7520835,17.1068055 22.75,17.6890969 C21.7479165,18.2713884 20.6645835,18.5625344 19.5,18.5625344 C18.60625,18.5625344 17.759896,18.3932634 16.9609375,18.0547219 C16.161979,17.7161805 15.4645835,17.2354509 14.86875,16.6125344 L11.13125,16.6125344 C10.5354165,17.2354509 9.83802104,17.7161805 9.0390625,18.0547219 C8.24010396,18.3932634 7.39375,18.5625344 6.5,18.5625344 C5.33541646,18.5625344 4.25208354,18.2713884 3.25,17.6890969 C2.24791646,17.1068055 1.45572896,16.314618 0.8734375,15.3125344 C0.29114604,14.3104509 0,13.227118 0,12.0625344 C0,10.8979509 0.29114604,9.81461796 0.8734375,8.81253442 C1.45572896,7.81045088 2.24791646,7.01826338 3.25,6.43597192 C4.25208354,5.85368046 5.33541646,5.56253442 6.5,5.56253442 L19.5,5.56253442 Z M10.4,12.8750344 L10.4,11.2500344 C10.4,11.114618 10.352604,10.9995134 10.2578125,10.9047219 C10.163021,10.8099305 10.0479165,10.7625344 9.9125,10.7625344 L7.8,10.7625344 L7.8,8.65003442 C7.8,8.51461796 7.75260396,8.39951338 7.6578125,8.30472192 C7.56302104,8.20993046 7.44791646,8.16253442 7.3125,8.16253442 L5.6875,8.16253442 C5.55208354,8.16253442 5.43697896,8.20993046 5.3421875,8.30472192 C5.24739604,8.39951338 5.2,8.51461796 5.2,8.65003442 L5.2,10.7625344 L3.0875,10.7625344 C2.95208354,10.7625344 2.83697896,10.8099305 2.7421875,10.9047219 C2.64739604,10.9995134 2.6,11.114618 2.6,11.2500344 L2.6,12.8750344 C2.6,13.0104509 2.64739604,13.1255555 2.7421875,13.2203469 C2.83697896,13.3151384 2.95208354,13.3625344 3.0875,13.3625344 L5.2,13.3625344 L5.2,15.4750344 C5.2,15.6104509 5.24739604,15.7255555 5.3421875,15.8203469 C5.43697896,15.9151384 5.55208354,15.9625344 5.6875,15.9625344 L7.3125,15.9625344 C7.44791646,15.9625344 7.56302104,15.9151384 7.6578125,15.8203469 C7.75260396,15.7255555 7.8,15.6104509 7.8,15.4750344 L7.8,13.3625344 L9.9125,13.3625344 C10.0479165,13.3625344 10.163021,13.3151384 10.2578125,13.2203469 C10.352604,13.1255555 10.4,13.0104509 10.4,12.8750344 Z M17.875,15.6375344 C18.4166665,15.6375344 18.8770835,15.4479509 19.25625,15.0687844 C19.6354165,14.689618 19.825,14.2292009 19.825,13.6875344 C19.825,13.145868 19.6354165,12.6854509 19.25625,12.3062844 C18.8770835,11.927118 18.4166665,11.7375344 17.875,11.7375344 C17.3333335,11.7375344 16.8729165,11.927118 16.49375,12.3062844 C16.1145835,12.6854509 15.925,13.145868 15.925,13.6875344 C15.925,14.2292009 16.1145835,14.689618 16.49375,15.0687844 C16.8729165,15.4479509 17.3333335,15.6375344 17.875,15.6375344 Z M21.125,12.3875344 C21.6666665,12.3875344 22.1270835,12.1979509 22.50625,11.8187844 C22.8854165,11.439618 23.075,10.9792009 23.075,10.4375344 C23.075,9.89586796 22.8854165,9.43545088 22.50625,9.05628442 C22.1270835,8.67711796 21.6666665,8.48753442 21.125,8.48753442 C20.5833335,8.48753442 20.1229165,8.67711796 19.74375,9.05628442 C19.3645835,9.43545088 19.175,9.89586796 19.175,10.4375344 C19.175,10.9792009 19.3645835,11.439618 19.74375,11.8187844 C20.1229165,12.1979509 20.5833335,12.3875344 21.125,12.3875344 Z' })
	  );
	};
	
	GameController.propTypes = _bcPropTypes.iconShape;
	
	exports.default = GameController;

/***/ },
/* 1196 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GameController = __webpack_require__(1195);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GameController).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1197 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable max-len */
	
	var GraphicViolence = function (_BcReactComponent) {
	  _inherits(GraphicViolence, _BcReactComponent);
	
	  function GraphicViolence() {
	    _classCallCheck(this, GraphicViolence);
	
	    return _possibleConstructorReturn(this, (GraphicViolence.__proto__ || Object.getPrototypeOf(GraphicViolence)).apply(this, arguments));
	  }
	
	  _createClass(GraphicViolence, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'svg',
	        { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-graphic-violence', preserveAspectRatio: 'xMinYMin meet', viewBox: '0 0 16 16' },
	        _react2.default.createElement('path', { className: 'path1', d: 'M15.707 14.293l-3.146-3.146 2.293-2.293c0.195-0.195 0.195-0.512 0-0.707l-1-1c-0.195-0.195-0.512-0.195-0.707 0l-1.646 1.646-8.646-8.646c-0.094-0.094-0.221-0.146-0.354-0.146h-2c-0.276 0-0.5 0.224-0.5 0.5v2c0 0.133 0.053 0.26 0.146 0.354l8.646 8.646-1.646 1.646c-0.195 0.195-0.195 0.512 0 0.707l1 1c0.098 0.098 0.226 0.146 0.354 0.146s0.256-0.049 0.354-0.146l2.293-2.293 3.146 3.146c0.39 0.391 1.024 0.391 1.414 0s0.39-1.024 0-1.414zM9.5 11l-8.75-8.75 0.5-0.5 8.75 8.75-0.5 0.5z' })
	      );
	    }
	  }]);
	
	  return GraphicViolence;
	}(_baseBcReactComponent2.default);
	
	exports.default = GraphicViolence;

/***/ },
/* 1198 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GraphicViolence = __webpack_require__(1197);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GraphicViolence).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1199 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	var GroupedView = function GroupedView() {
	  return _react2.default.createElement(
	    "svg",
	    { focusable: "false", "aria-hidden": true, className: "icon-svg-grouped-view", preserveAspectRatio: "xMinYMin meet", viewBox: "0 0 16 16" },
	    _react2.default.createElement(
	      "g",
	      { fill: "none", fillRule: "evenodd" },
	      _react2.default.createElement("path", { fill: "#000", d: "M1.75 16L0 16 0 1.75 0 0 5 0 5 1.75 1.75 1.75 1.75 14.25 5 14.25 5 16 1.75 16zM14.25 14.25L14.25 1.75 11 1.75 11 0 16 0 16 1.75 16 16 14.25 16 11 16 11 14.25 14.25 14.25z" }),
	      _react2.default.createElement("rect", { width: "4.75", height: "2", x: "7.25", y: "5", fill: "#000" }),
	      _react2.default.createElement("rect", { width: "2", height: "2", x: "4", y: "5", fill: "#000" }),
	      _react2.default.createElement("rect", { width: "4.75", height: "2", x: "7.25", y: "9", fill: "#000" }),
	      _react2.default.createElement("rect", { width: "2", height: "2", x: "4", y: "9", fill: "#000" })
	    )
	  );
	};
	
	exports.default = GroupedView;

/***/ },
/* 1200 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GroupedView = __webpack_require__(1199);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GroupedView).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1201 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	var Headphones = function Headphones(_ref) {
	  var className = _ref.className,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 26 : _ref$height,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 26 : _ref$width;
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-headphones ' + className, preserveAspectRatio: 'xMinYMin meet', width: width, height: height, viewBox: '0 0 26 26' },
	    _react2.default.createElement('path', { fill: color, fillRule: 'evenodd', d: 'M26,12.84375 C26,14.546875 25.6875,16.203125 25.0625,17.75 L24.75,18.515625 L21.859375,19.03125 C21.40625,20.734375 19.859375,22 18,22 L18,22.5 C18,22.78125 17.78125,23 17.5,23 L16.5,23 C16.21875,23 16,22.78125 16,22.5 L16,13.5 C16,13.21875 16.21875,13 16.5,13 L17.5,13 C17.78125,13 18,13.21875 18,13.5 L18,14 C19.5,14 20.796875,14.828125 21.484375,16.046875 L22.546875,15.859375 C22.84375,14.890625 23,13.890625 23,12.84375 C23,8.125 18.328125,4 13,4 C7.671875,4 3,8.125 3,12.84375 C3,13.890625 3.15625,14.890625 3.453125,15.859375 L4.515625,16.046875 C5.203125,14.828125 6.5,14 8,14 L8,13.5 C8,13.21875 8.21875,13 8.5,13 L9.5,13 C9.78125,13 10,13.21875 10,13.5 L10,22.5 C10,22.78125 9.78125,23 9.5,23 L8.5,23 C8.21875,23 8,22.78125 8,22.5 L8,22 C6.140625,22 4.59375,20.734375 4.140625,19.03125 L1.25,18.515625 L0.9375,17.75 C0.3125,16.203125 0,14.546875 0,12.84375 C0,6.421875 5.953125,1 13,1 C20.046875,1 26,6.421875 26,12.84375 Z' })
	  );
	};
	
	Headphones.propTypes = _bcPropTypes.iconShape;
	
	exports.default = Headphones;

/***/ },
/* 1202 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Headphones = __webpack_require__(1201);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Headphones).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1203 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Heart;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function Heart(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      xmlns: 'http://www.w3.org/2000/svg',
	      className: 'icon-svg-heart ' + className,
	      width: width,
	      height: height,
	      focusable: 'false',
	      'aria-hidden': true,
	      viewBox: '0 0 16 16' },
	    _react2.default.createElement('path', { fill: color, fillRule: 'evenodd', d: 'M13.552 2.833a3.618 3.618 0 0 1 1.159 1.714c.215.679.247 1.361.094 2.049a3.547 3.547 0 0 1-.984 1.78L8.62 13.732A.855.855 0 0 1 8 14a.855.855 0 0 1-.62-.268L2.18 8.403a3.703 3.703 0 0 1-.984-1.807 3.875 3.875 0 0 1 .094-2.049 3.618 3.618 0 0 1 1.16-1.714 3.42 3.42 0 0 1 1.643-.776 3.652 3.652 0 0 1 1.806.134 3.823 3.823 0 0 1 1.563.99L8 3.717l.539-.536c.45-.464.97-.794 1.563-.99a3.652 3.652 0 0 1 1.806-.134 3.42 3.42 0 0 1 1.644.776z' })
	  );
	}
	
	Heart.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1204 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Heart = __webpack_require__(1203);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Heart).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1205 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = HoldsIcon;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function HoldsIcon(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      xmlns: 'http://www.w3.org/2000/svg',
	      xmlnsXlink: 'http://www.w3.org/1999/xlink',
	      focusable: 'false',
	      'aria-hidden': true,
	      className: 'icon-svg-holds ' + className,
	      width: width, height: height,
	      viewBox: '0 0 48 48' },
	    _react2.default.createElement(
	      'defs',
	      null,
	      _react2.default.createElement('polygon', { id: 'holds-a', points: '27.243 37.779 24.414 34.95 23 36.364 25.828 39.193 27.243 40.607 33.606 34.243 32.192 32.829' })
	    ),
	    _react2.default.createElement(
	      'g',
	      { fill: 'none', fillRule: 'evenodd' },
	      _react2.default.createElement('path', { fill: color, d: 'M8.8569,16.9219 C8.8569,16.8279 8.9029,16.7349 8.9959,16.6409 C9.0879,16.5469 9.1799,16.4999 9.2729,16.4999 L23.9419,16.4999 C24.0339,16.4999 24.1269,16.5469 24.2189,16.6409 C24.3109,16.7349 24.3569,16.8279 24.3569,16.9219 L24.3569,18.3279 C24.3569,18.4219 24.3109,18.5159 24.2189,18.6089 C24.1269,18.7029 24.0339,18.7499 23.9419,18.7499 L9.2729,18.7499 C9.1799,18.7499 9.0879,18.7029 8.9959,18.6089 C8.9029,18.5159 8.8569,18.4219 8.8569,18.3279 L8.8569,16.9219 Z M8.8569,12.4219 C8.8569,12.3279 8.9029,12.2349 8.9959,12.1409 C9.0879,12.0469 9.1799,11.9999 9.2729,11.9999 L23.9419,11.9999 C24.0339,11.9999 24.1269,12.0469 24.2189,12.1409 C24.3109,12.2349 24.3569,12.3279 24.3569,12.4219 L24.3569,13.8279 C24.3569,13.9219 24.3109,14.0159 24.2189,14.1089 C24.1269,14.2029 24.0339,14.2499 23.9419,14.2499 L9.2729,14.2499 C9.1799,14.2499 9.0879,14.2029 8.9959,14.1089 C8.9029,14.0159 8.8569,13.9219 8.8569,13.8279 L8.8569,12.4219 Z M13.4799,34.4999 L6.6429,34.4999 C6.0429,34.4999 5.5239,34.2769 5.0859,33.8319 C4.6479,33.3869 4.4289,32.8599 4.4289,32.2499 C4.4289,31.6409 4.6479,31.1129 5.0859,30.6679 C5.5239,30.2229 6.0429,29.9999 6.6429,29.9999 L14.5419,29.9999 L15.3589,26.5409 C15.5719,25.6379 16.3779,24.9999 17.3059,24.9999 L30.9999,24.9999 L30.9999,4.6879 C30.9999,4.2189 30.8379,3.8199 30.5159,3.4919 C30.1929,3.1639 29.8009,2.9999 29.3389,2.9999 L6.6429,2.9999 C4.7979,2.9999 3.2289,3.6559 1.9379,4.9689 C0.6459,6.2809 -0.0001,7.8749 -0.0001,9.7499 L-0.0001,32.2499 C-0.0001,34.1249 0.6459,35.7189 1.9379,37.0309 C3.2289,38.3439 4.7979,38.9999 6.6429,38.9999 L12.4169,38.9999 L13.4799,34.4999 Z' }),
	      _react2.default.createElement('path', { fill: color, d: 'M40.7334,42 L43.2474,31.316 L45.7394,42 L40.7334,42 Z M38.2084,44 L15.2624,44 L18.7914,29 L18.7924,29 L39.0004,29 L41.7374,29 L38.2084,44 Z M47.6874,41.546 L44.6544,28.546 C44.4414,27.636 43.6414,27 42.7064,27 L41.7374,27 L39.0004,27 L18.7924,27 C17.8594,27 17.0594,27.634 16.8444,28.542 L13.3154,43.543 C13.2804,43.693 13.2624,43.846 13.2624,44 C13.2624,45.103 14.1594,46 15.2624,46 L38.2084,46 C39.1404,46 39.9414,45.366 40.1554,44.458 L40.2634,44 L45.7394,44 C46.8424,44 47.7394,43.103 47.7394,42 C47.7394,41.849 47.7224,41.697 47.6874,41.546 Z' }),
	      _react2.default.createElement('polygon', { fill: color, points: '25.829 39.192 23 36.363 24.414 34.949 27.243 37.778 32.193 32.828 33.607 34.242 27.243 40.606' })
	    )
	  );
	}
	
	HoldsIcon.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1206 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _HoldsIcon = __webpack_require__(1205);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_HoldsIcon).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1207 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = IconWithBackground;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(2683);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function IconWithBackground(_ref) {
	  var className = _ref.className,
	      bgColor = _ref.bgColor,
	      icon = _ref.icon,
	      children = _ref.children;
	
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)('cp-icon-with-background', className) },
	    _react2.default.createElement(
	      'div',
	      { className: 'icon-holder', style: { backgroundColor: bgColor } },
	      icon
	    ),
	    _react2.default.createElement(
	      'span',
	      { className: 'content-holder' },
	      children
	    )
	  );
	}
	
	IconWithBackground.propTypes = {
	  className: _react.PropTypes.string,
	  bgColor: _react.PropTypes.string.isRequired,
	  icon: _react.PropTypes.node,
	  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node]).isRequired
	};

/***/ },
/* 1208 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _IconWithBackground = __webpack_require__(1207);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_IconWithBackground).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1209 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function Info(_ref) {
	  var className = _ref.className,
	      fill = _ref.fill;
	
	  return _react2.default.createElement(
	    "svg",
	    { focusable: "false", "aria-hidden": true, className: "icon-svg-info " + className, preserveAspectRatio: "xMinYMin meet", viewBox: "0 0 16 16" },
	    _react2.default.createElement("path", { fill: fill, className: "path1", d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM7 3.75c0-0.413 0.338-0.75 0.75-0.75h0.5c0.412 0 0.75 0.337 0.75 0.75v0.5c0 0.412-0.338 0.75-0.75 0.75h-0.5c-0.412 0-0.75-0.338-0.75-0.75v-0.5zM10 13h-4v-1h1v-4h-1v-1h3v5h1v1z" })
	  );
	}
	
	Info.propTypes = {
	  className: _react.PropTypes.string,
	  fill: _react.PropTypes.string
	};
	
	exports.default = Info;

/***/ },
/* 1210 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Info = __webpack_require__(1209);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Info).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1211 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Institution;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function Institution(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height;
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      className: 'icon-svg-institution ' + className,
	      focusable: 'false',
	      'aria-hidden': true,
	      width: width,
	      height: height,
	      viewBox: '0 0 2048 1792' },
	    _react2.default.createElement('path', { d: 'M960 0l960 384v128h-128q0 26-20.5 45t-48.5 19h-1526q-28 0-48.5-19t-20.5-45h-128v-128zm-704 640h256v768h128v-768h256v768h128v-768h256v768h128v-768h256v768h59q28 0 48.5 19t20.5 45v64h-1664v-64q0-26 20.5-45t48.5-19h59v-768zm1595 960q28 0 48.5 19t20.5 45v128h-1920v-128q0-26 20.5-45t48.5-19h1782z' })
	  );
	}
	
	Institution.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1212 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Institution = __webpack_require__(1211);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Institution).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1213 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = InterlibraryLoans;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function InterlibraryLoans(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height;
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      xmlns: 'http://www.w3.org/2000/svg',
	      focusable: 'false',
	      'aria-hidden': true,
	      className: 'icon-svg-interlibraryloans ' + className,
	      width: width,
	      height: height,
	      viewBox: '0 0 16 16' },
	    _react2.default.createElement(
	      'g',
	      { fill: color, fillRule: 'nonzero' },
	      _react2.default.createElement('path', { d: 'M16 8a7.76 7.76 0 0 1-1.08 4A8.084 8.084 0 0 1 12 14.92 7.76 7.76 0 0 1 8 16a7.76 7.76 0 0 1-4-1.08A8.084 8.084 0 0 1 1.08 12 7.76 7.76 0 0 1 0 8c0-1.44.36-2.774 1.08-4A8.084 8.084 0 0 1 4 1.08 7.76 7.76 0 0 1 8 0c1.44 0 2.773.36 4 1.08A8.084 8.084 0 0 1 14.919 4 7.76 7.76 0 0 1 16 8zM1.549 8c0 1.161.29 2.237.87 3.226a6.504 6.504 0 0 0 2.355 2.355 6.26 6.26 0 0 0 3.227.87 6.26 6.26 0 0 0 3.225-.87 6.504 6.504 0 0 0 2.355-2.355A6.26 6.26 0 0 0 14.45 8a6.26 6.26 0 0 0-.87-3.226 6.504 6.504 0 0 0-2.355-2.355A6.26 6.26 0 0 0 8 1.55a6.26 6.26 0 0 0-3.226.87 6.504 6.504 0 0 0-2.355 2.355A6.26 6.26 0 0 0 1.55 8z' }),
	      _react2.default.createElement('path', { d: 'M5.424 7.145v.734a.386.386 0 0 1-.103.272.332.332 0 0 1-.253.112.332.332 0 0 1-.252-.112L3.539 6.777a.384.384 0 0 1-.104-.271c0-.107.035-.197.104-.271L4.816 4.86a.332.332 0 0 1 .252-.111c.1 0 .183.037.253.111.068.074.105.171.103.272v.734h4.483c.049 0 .091.019.126.056a.192.192 0 0 1 .052.136v.894a.191.191 0 0 1-.052.136.166.166 0 0 1-.127.056H5.424zm5.091 3.27H6.033a.166.166 0 0 1-.126-.056.192.192 0 0 1-.052-.136V9.33c0-.054.018-.098.052-.136a.166.166 0 0 1 .127-.056h4.481v-.734c0-.107.035-.197.104-.272a.332.332 0 0 1 .253-.111.33.33 0 0 1 .252.111l1.277 1.374c.069.073.106.17.104.271a.384.384 0 0 1-.104.271l-1.277 1.374a.332.332 0 0 1-.252.112.332.332 0 0 1-.253-.112.384.384 0 0 1-.104-.272v-.734z' })
	    )
	  );
	}
	
	InterlibraryLoans.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1214 */
[3483, 1213],
/* 1215 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = JacketView;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function JacketView(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#000' : _ref$color,
	      _ref$hidden = _ref.hidden,
	      hidden = _ref$hidden === undefined ? true : _ref$hidden;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': hidden, className: 'icon-svg-jacket-view ' + className, width: width, height: height, viewBox: '0 0 16 16' },
	    _react2.default.createElement(
	      'g',
	      { fill: 'none', fillRule: 'evenodd' },
	      _react2.default.createElement('rect', { width: '3.5', height: '3.5', x: '1', y: '1', fill: color }),
	      _react2.default.createElement('rect', { width: '3.5', height: '3.5', x: '1', y: '11.5', fill: color }),
	      _react2.default.createElement('rect', { width: '3.5', height: '3.5', x: '1', y: '6.25', fill: color }),
	      _react2.default.createElement('rect', { width: '8.75', height: '1.75', x: '6.25', y: '1.875', fill: color }),
	      _react2.default.createElement('rect', { width: '8.75', height: '1.75', x: '6.25', y: '7.125', fill: color }),
	      _react2.default.createElement('rect', { width: '8.75', height: '1.75', x: '6.25', y: '12.375', fill: color })
	    )
	  );
	}
	
	JacketView.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1216 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _JacketView = __webpack_require__(1215);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_JacketView).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1217 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Laptop;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function Laptop(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#000' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-laptop ' + className, width: width, height: height, viewBox: '0 0 16 16' },
	    _react2.default.createElement('path', { fill: color, d: 'M14 11v-8c0-0.55-0.45-1-1-1h-10c-0.55 0-1 0.45-1 1v8h-2v3h16v-3h-2zM10 13h-4v-1h4v1zM13 11h-10v-7.998c0.001-0.001 0.001-0.001 0.002-0.002h9.996c0.001 0.001 0.001 0.001 0.002 0.002v7.998z' })
	  );
	}
	
	Laptop.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1218 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Laptop = __webpack_require__(1217);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Laptop).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1219 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Link;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function Link(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-link ' + className, width: width, height: height, viewBox: '0 0 1792 1792' },
	    _react2.default.createElement('path', { d: 'M1520 1216q0-40-28-68l-208-208q-28-28-68-28-42 0-72 32 3 3 19 18.5t21.5 21.5 15 19 13 25.5 3.5 27.5q0 40-28 68t-68 28q-15 0-27.5-3.5t-25.5-13-19-15-21.5-21.5-18.5-19q-33 31-33 73 0 40 28 68l206 207q27 27 68 27 40 0 68-26l147-146q28-28 28-67zm-703-705q0-40-28-68l-206-207q-28-28-68-28-39 0-68 27l-147 146q-28 28-28 67 0 40 28 68l208 208q27 27 68 27 42 0 72-31-3-3-19-18.5t-21.5-21.5-15-19-13-25.5-3.5-27.5q0-40 28-68t68-28q15 0 27.5 3.5t25.5 13 19 15 21.5 21.5 18.5 19q33-31 33-73zm895 705q0 120-85 203l-147 146q-83 83-203 83-121 0-204-85l-206-207q-83-83-83-203 0-123 88-209l-88-88q-86 88-208 88-120 0-204-84l-208-208q-84-84-84-204t85-203l147-146q83-83 203-83 121 0 204 85l206 207q83 83 83 203 0 123-88 209l88 88q86-88 208-88 120 0 204 84l208 208q84 84 84 204z' })
	  );
	}
	
	Link.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1220 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Link = __webpack_require__(1219);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Link).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1221 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = List;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function List(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      xmlns: 'http://www.w3.org/2000/svg',
	      focusable: 'false',
	      'aria-hidden': true,
	      className: (0, _classnames2.default)('icon-svg-list', className),
	      width: width,
	      height: height,
	      viewBox: '0 0 16 16' },
	    _react2.default.createElement(
	      'g',
	      { fill: 'none', fillRule: 'evenodd' },
	      _react2.default.createElement('rect', { fill: color, width: '10', height: '2', x: '5', y: '3' }),
	      _react2.default.createElement('rect', { fill: color, width: '2', height: '2', x: '1', y: '3' }),
	      _react2.default.createElement('rect', { fill: color, width: '10', height: '2', x: '5', y: '7' }),
	      _react2.default.createElement('rect', { fill: color, width: '2', height: '2', x: '1', y: '7' }),
	      _react2.default.createElement('rect', { fill: color, width: '10', height: '2', x: '5', y: '11' }),
	      _react2.default.createElement('rect', { fill: color, width: '2', height: '2', x: '1', y: '11' })
	    )
	  );
	}
	
	List.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1222 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _List = __webpack_require__(1221);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_List).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1223 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ListView;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ListView(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#000' : _ref$color,
	      _ref$hidden = _ref.hidden,
	      hidden = _ref$hidden === undefined ? true : _ref$hidden;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': hidden, className: 'icon-svg-list-view ' + className, width: width, height: height, viewBox: '0 0 16 16' },
	    _react2.default.createElement(
	      'g',
	      { fill: 'none', fillRule: 'evenodd' },
	      _react2.default.createElement('rect', { width: '13.635', height: '1.75', x: '1.365', y: '2.875', fill: color }),
	      _react2.default.createElement('rect', { width: '13.635', height: '1.75', x: '1.365', y: '7.125', fill: color }),
	      _react2.default.createElement('rect', { width: '13.635', height: '1.75', x: '1.365', y: '11.375', fill: color })
	    )
	  );
	}
	
	ListView.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1224 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ListView = __webpack_require__(1223);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ListView).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1225 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Location;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Location(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: (0, _classnames2.default)('icon-svg-location', className), width: width, height: height, viewBox: '0 0 16 16' },
	    _react2.default.createElement('path', {
	      fill: color,
	      d: 'M8 0c-2.761 0-5 2.239-5 5 0 5 5 11 5 11s5-6 5-11c0-2.761-2.239-5-5-5zM8 8c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3z' })
	  );
	}
	
	Location.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1226 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Location = __webpack_require__(1225);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Location).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1227 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	var Lock = function Lock(_ref) {
	  var color = _ref.color,
	      title = _ref.title,
	      className = _ref.className,
	      width = _ref.width,
	      height = _ref.height;
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-lock ' + className, width: width, height: height, preserveAspectRatio: 'xMinYMin meet', viewBox: '0 0 16 16' },
	    _react2.default.createElement(
	      'title',
	      null,
	      title
	    ),
	    _react2.default.createElement('path', { fill: color, className: 'path1', d: 'M9.25 7h-0.25v-3c0-1.654-1.346-3-3-3h-2c-1.654 0-3 1.346-3 3v3h-0.25c-0.412 0-0.75 0.338-0.75 0.75v7.5c0 0.412 0.338 0.75 0.75 0.75h8.5c0.412 0 0.75-0.338 0.75-0.75v-7.5c0-0.412-0.338-0.75-0.75-0.75zM3 4c0-0.551 0.449-1 1-1h2c0.551 0 1 0.449 1 1v3h-4v-3z' })
	  );
	};
	
	Lock.propTypes = _bcPropTypes.iconShape;
	
	exports.default = Lock;

/***/ },
/* 1228 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Lock = __webpack_require__(1227);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Lock).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1229 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = MessagesIcon;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function MessagesIcon(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      xmlns: 'http://www.w3.org/2000/svg',
	      focusable: 'false',
	      'aria-hidden': true,
	      className: 'icon-svg-messages ' + className,
	      width: width, height: height,
	      viewBox: '0 0 48 48' },
	    _react2.default.createElement(
	      'g',
	      { fill: 'none', fillRule: 'evenodd' },
	      _react2.default.createElement('path', { fill: color, d: 'M24,7.44192479 C23.6427013,7.44192479 23.2854026,7.55217188 22.9814026,7.77266605 L8.17522078,18.4734629 C7.73205195,18.7934722 7.46753247,19.308609 7.46753247,19.8510637 L7.46753247,38.8535637 C7.46753247,39.7950543 8.24233766,40.5609301 9.19480519,40.5609301 L38.8051948,40.5609301 C39.7576623,40.5609301 40.5324675,39.7950543 40.5324675,38.8535637 L40.5324675,19.8510637 C40.5324675,19.308609 40.2679481,18.7934722 39.8247792,18.4734629 L25.0195844,7.77266605 C24.7145974,7.55217188 24.3572987,7.44192479 24,7.44192479 M38.8051948,43.000025 L9.19480519,43.000025 C6.88223377,43.000025 5,41.1404591 5,38.8535637 L5,19.8510637 C5,18.5329768 5.64254545,17.2812334 6.71937662,16.5036499 L21.5245714,5.8038287 C23.0041039,4.73257825 24.9939221,4.73160261 26.4764156,5.8038287 L41.2806234,16.5036499 C42.3574545,17.2812334 43,18.5329768 43,19.8510637 L43,38.8535637 C43,41.1404591 41.1177662,43.000025 38.8051948,43.000025' }),
	      _react2.default.createElement('path', { fill: color, d: 'M24.3276,33.0537 C23.5106,33.0537 22.6946,32.8077 21.9976,32.3147 L11.5286,24.9077 C10.9646,24.5097 10.8306,23.7297 11.2296,23.1657 C11.6286,22.6017 12.4076,22.4677 12.9716,22.8667 L23.4416,30.2737 C23.9716,30.6477 24.6826,30.6487 25.2126,30.2737 L35.5286,22.9767 C36.0916,22.5777 36.8716,22.7107 37.2706,23.2757 C37.6686,23.8387 37.5356,24.6187 36.9716,25.0177 L26.6566,32.3147 C25.9606,32.8067 25.1436,33.0537 24.3276,33.0537' })
	    )
	  );
	}
	
	MessagesIcon.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1230 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _MessagesIcon = __webpack_require__(1229);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MessagesIcon).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1231 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Minus;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Minus(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: (0, _classnames2.default)('icon-svg-minus', className), width: width, height: height, viewBox: '0 0 16 16' },
	    _react2.default.createElement('path', {
	      fill: color,
	      d: 'M0 6.5v3c0 0.276 0.224 0.5 0.5 0.5h15c0.276 0 0.5-0.224 0.5-0.5v-3c0-0.276-0.224-0.5-0.5-0.5h-15c-0.276 0-0.5 0.224-0.5 0.5z' })
	  );
	}
	
	Minus.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1232 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Minus = __webpack_require__(1231);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Minus).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1233 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = MinusCircled;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function MinusCircled(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      xmlns: 'http://www.w3.org/2000/svg',
	      focusable: 'false',
	      'aria-hidden': true,
	      className: (0, _classnames2.default)('icon-svg-minus-circled', className),
	      width: width,
	      height: height,
	      viewBox: '0 0 16 16' },
	    _react2.default.createElement('path', {
	      fill: color,
	      fillRule: 'evenodd',
	      d: 'M8,16 C3.581722,16 0,12.418278 0,8 C0,3.581722 3.581722,0 8,0 C12.418278,0 16,3.581722 16,8 C16,12.418278 12.418278,16 8,16 Z M4,7 L4,9 L12,9 L12,7 L4,7 Z' })
	  );
	}
	
	MinusCircled.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1234 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _MinusCircled = __webpack_require__(1233);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MinusCircled).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1235 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	var More = function More(_ref) {
	  var color = _ref.color,
	      title = _ref.title,
	      className = _ref.className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height;
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-more ' + className, width: width, height: height, viewBox: '0 0 16 16', version: '1.1' },
	    _react2.default.createElement(
	      'title',
	      null,
	      title
	    ),
	    _react2.default.createElement('path', { fill: color, d: 'M6 1h4v4h-4zM6 6h4v4h-4zM6 11h4v4h-4z' })
	  );
	};
	
	More.propTypes = _bcPropTypes.iconShape;
	
	exports.default = More;

/***/ },
/* 1236 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _More = __webpack_require__(1235);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_More).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1237 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	var MusicalNote = function MusicalNote(_ref) {
	  var className = _ref.className,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 26 : _ref$height,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 26 : _ref$width;
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-musical-note ' + className, preserveAspectRatio: 'xMinYMin meet', width: width, height: height, viewBox: '0 0 26 26' },
	    _react2.default.createElement('path', { fill: color, fillRule: 'evenodd', d: 'M23,2.30354989 L23,18.3452166 C23,20.3647478 19.9778646,21.0952166 18.4166667,21.0952166 C16.8554688,21.0952166 13.8333333,20.3647478 13.8333333,18.3452166 C13.8333333,16.3256853 16.8554688,15.5952166 18.4166667,15.5952166 C19.3619792,15.5952166 20.3072917,15.7670916 21.1666667,16.1538103 L21.1666667,8.46240405 L10.1666667,11.8569353 L10.1666667,22.0118832 C10.1666667,24.0314145 7.14453125,24.7618832 5.58333333,24.7618832 C4.02213542,24.7618832 1,24.0314145 1,22.0118832 C1,19.992352 4.02213542,19.2618832 5.58333333,19.2618832 C6.52864583,19.2618832 7.47395833,19.4337582 8.33333333,19.820477 L8.33333333,5.97021655 C8.33333333,5.36865405 8.734375,4.83870614 9.30729167,4.65250822 L21.2239583,0.985841552 C21.3528646,0.942872802 21.4817708,0.928549886 21.625,0.928549886 C22.3841146,0.928549886 23,1.5444353 23,2.30354989 Z' })
	  );
	};
	
	MusicalNote.propTypes = _bcPropTypes.iconShape;
	
	exports.default = MusicalNote;

/***/ },
/* 1238 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _MusicalNote = __webpack_require__(1237);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MusicalNote).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1239 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.NewTab = NewTab;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function NewTab(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-new-tab ' + className, width: width, height: height, viewBox: '0 0 16 16' },
	    _react2.default.createElement('path', { fill: color, d: 'M11 13h-8v-8h4.5l2-2h-8.5v12h12v-8.5l-2 2v4.5z' }),
	    _react2.default.createElement('path', { fill: color, d: 'M16 0h-6.5l2.5 2.5-7.5 7.5 1.5 1.5 7.5-7.5 2.5 2.5v-6.5z' })
	  );
	}
	
	NewTab.propTypes = _bcPropTypes.iconShape;
	
	exports.default = NewTab;

/***/ },
/* 1240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _NewTab = __webpack_require__(1239);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_NewTab).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1241 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	var Newspaper = function Newspaper(_ref) {
	  var className = _ref.className,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 26 : _ref$height,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 26 : _ref$width;
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-newspaper ' + className, preserveAspectRatio: 'xMinYMin meet', width: width, height: height, viewBox: '0 0 26 26' },
	    _react2.default.createElement('path', { fill: color, fillRule: 'evenodd', d: 'M13,8.80354989 L8.125,8.80354989 L8.125,13.6785499 L13,13.6785499 L13,8.80354989 Z M14.625,16.9285499 L14.625,18.5535499 L6.5,18.5535499 L6.5,16.9285499 L14.625,16.9285499 Z M14.625,7.17854989 L14.625,15.3035499 L6.5,15.3035499 L6.5,7.17854989 L14.625,7.17854989 Z M22.75,16.9285499 L22.75,18.5535499 L16.25,18.5535499 L16.25,16.9285499 L22.75,16.9285499 Z M22.75,13.6785499 L22.75,15.3035499 L16.25,15.3035499 L16.25,13.6785499 L22.75,13.6785499 Z M22.75,10.4285499 L22.75,12.0535499 L16.25,12.0535499 L16.25,10.4285499 L22.75,10.4285499 Z M22.75,7.17854989 L22.75,8.80354989 L16.25,8.80354989 L16.25,7.17854989 L22.75,7.17854989 Z M3.25,19.3660499 L3.25,7.17854989 L1.625,7.17854989 L1.625,19.3660499 C1.625,19.8103858 1.99316406,20.1785499 2.4375,20.1785499 C2.88183594,20.1785499 3.25,19.8103858 3.25,19.3660499 Z M24.375,19.3660499 L24.375,5.55354989 L4.875,5.55354989 L4.875,19.3660499 C4.875,19.6453468 4.82421875,19.9246436 4.73535156,20.1785499 L23.5625,20.1785499 C24.0068359,20.1785499 24.375,19.8103858 24.375,19.3660499 Z M26,3.92854989 L26,19.3660499 C26,20.711753 24.9082031,21.8035499 23.5625,21.8035499 L2.4375,21.8035499 C1.09179688,21.8035499 0,20.711753 0,19.3660499 L0,5.55354989 L3.25,5.55354989 L3.25,3.92854989 L26,3.92854989 Z' })
	  );
	};
	
	Newspaper.propTypes = _bcPropTypes.iconShape;
	
	exports.default = Newspaper;

/***/ },
/* 1242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Newspaper = __webpack_require__(1241);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Newspaper).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1243 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable max-len */
	
	var OffensiveLanguage = function (_BcReactComponent) {
	  _inherits(OffensiveLanguage, _BcReactComponent);
	
	  function OffensiveLanguage() {
	    _classCallCheck(this, OffensiveLanguage);
	
	    return _possibleConstructorReturn(this, (OffensiveLanguage.__proto__ || Object.getPrototypeOf(OffensiveLanguage)).apply(this, arguments));
	  }
	
	  _createClass(OffensiveLanguage, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'svg',
	        { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-offensive-language', preserveAspectRatio: 'xMinYMin meet', viewBox: '0 0 16 16' },
	        _react2.default.createElement('path', { className: 'path1', d: 'M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v9c0 0.825 0.675 1.5 1.5 1.5h2.5v4l4.8-4h5.7c0.825 0 1.5-0.675 1.5-1.5v-9c0-0.825-0.675-1.5-1.5-1.5zM9 10h-2v-2h2v2zM9 6h-2v-4h2v4z' })
	      );
	    }
	  }]);
	
	  return OffensiveLanguage;
	}(_baseBcReactComponent2.default);
	
	exports.default = OffensiveLanguage;

/***/ },
/* 1244 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _OffensiveLanguage = __webpack_require__(1243);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_OffensiveLanguage).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1245 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = PaperPlane;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function PaperPlane(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#000' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-paper-plane ' + className, width: width, height: height, viewBox: '0 0 16 16' },
	    _react2.default.createElement('path', { fill: color, d: 'M7 11l6.151 2.195 2.849-12.459zM5 10.311l11-9.575-16 7.913zM7 12.062v3.938l2.902-2.902z' })
	  );
	}
	
	PaperPlane.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1246 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PaperPlane = __webpack_require__(1245);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PaperPlane).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1247 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = PauseCircled;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function PauseCircled(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      xmlns: 'http://www.w3.org/2000/svg',
	      focusable: 'false',
	      'aria-hidden': true,
	      className: (0, _classnames2.default)('icon-svg-pause-circled', className),
	      width: width,
	      height: height,
	      viewBox: '0 0 16 16' },
	    _react2.default.createElement(
	      'g',
	      { fill: 'none', fillRule: 'evenodd' },
	      _react2.default.createElement('rect', { fill: color, width: '2', height: '6', x: '5', y: '5' }),
	      _react2.default.createElement('rect', { fill: color, width: '2', height: '6', x: '9', y: '5' }),
	      _react2.default.createElement('circle', { stroke: color, cx: '8', cy: '8', r: '7.25', strokeWidth: '1.5' })
	    )
	  );
	}
	
	PauseCircled.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1248 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PauseCircled = __webpack_require__(1247);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PauseCircled).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1249 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable max-len */
	
	var Pencil = function (_BcReactComponent) {
	  _inherits(Pencil, _BcReactComponent);
	
	  function Pencil() {
	    _classCallCheck(this, Pencil);
	
	    return _possibleConstructorReturn(this, (Pencil.__proto__ || Object.getPrototypeOf(Pencil)).apply(this, arguments));
	  }
	
	  _createClass(Pencil, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'svg',
	        { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-pencil', preserveAspectRatio: 'xMinYMin meet', viewBox: '0 0 16 16' },
	        _react2.default.createElement('path', { className: 'path1', d: 'M13.5 0c1.381 0 2.5 1.119 2.5 2.5 0 0.563-0.186 1.082-0.5 1.5l-1 1-3.5-3.5 1-1c0.418-0.314 0.937-0.5 1.5-0.5zM1 11.5l-1 4.5 4.5-1 9.25-9.25-3.5-3.5-9.25 9.25zM11.181 5.681l-7 7-0.862-0.862 7-7 0.862 0.862z' })
	      );
	    }
	  }]);
	
	  return Pencil;
	}(_baseBcReactComponent2.default);
	
	exports.default = Pencil;

/***/ },
/* 1250 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Pencil = __webpack_require__(1249);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Pencil).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1251 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = PencilEdit;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function PencilEdit(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#000' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-pencil-edit ' + className, width: width, height: height, viewBox: '0 0 16 16' },
	    _react2.default.createElement('path', { fill: color, d: 'M12 8.5v5.5h-10v-10h5.5l2-2h-8c-0.825 0-1.5 0.675-1.5 1.5v11c0 0.825 0.675 1.5 1.5 1.5h11c0.825 0 1.5-0.675 1.5-1.5v-8l-2 2z' }),
	    _react2.default.createElement('path', { fill: color, d: 'M13.5 0l-9.5 9.5v2.5h2.5l9.5-9.5c0-1.5-1-2.5-2.5-2.5z' })
	  );
	}
	
	PencilEdit.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1252 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PencilEdit = __webpack_require__(1251);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PencilEdit).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1253 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Personal;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function Personal(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      xmlns: 'http://www.w3.org/2000/svg',
	      focusable: 'false',
	      'aria-hidden': true,
	      className: 'icon-svg-personal ' + className,
	      width: width,
	      height: height,
	      viewBox: '0 0 16 16' },
	    _react2.default.createElement(
	      'g',
	      { fill: 'none', fillRule: 'evenodd' },
	      _react2.default.createElement('path', { fill: color, d: 'M6,11 L10,11 C12.209139,11 14,12.790861 14,15 L2,15 L2,15 C2,12.790861 3.790861,11 6,11 Z' }),
	      _react2.default.createElement('circle', { cx: '8', cy: '6', r: '4', fill: color })
	    )
	  );
	}
	
	Personal.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1254 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Personal = __webpack_require__(1253);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Personal).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1255 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Plane;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function Plane(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      xmlns: 'http://www.w3.org/2000/svg',
	      focusable: 'false',
	      'aria-hidden': true,
	      className: (0, _classnames2.default)('icon-svg-truck', className),
	      width: width,
	      height: height,
	      viewBox: '0 0 16 16' },
	    _react2.default.createElement('path', { fill: color, fillRule: 'evenodd', d: 'M13.33 6.25c.332 0 .712.082 1.138.246.426.164.777.374 1.055.629.315.273.472.565.472.875 0 .31-.157.602-.472.875-.278.255-.63.465-1.055.629-.426.164-.806.246-1.139.246h-3.165l-2.916 5.031a.437.437 0 0 1-.389.219H5.026a.4.4 0 0 1-.347-.178.414.414 0 0 1-.07-.369L5.97 9.75H3.11l-1.194 1.586a.45.45 0 0 1-.36.164H.443a.412.412 0 0 1-.347-.164.503.503 0 0 1-.097-.383L.89 8 0 5.047a.503.503 0 0 1 .097-.383.412.412 0 0 1 .347-.164h1.111a.45.45 0 0 1 .361.164L3.11 6.25h2.86L4.61 1.547a.414.414 0 0 1 .07-.37A.4.4 0 0 1 5.025 1H6.86c.167 0 .296.073.389.219l2.916 5.031h3.165z' })
	  );
	}
	
	Plane.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1256 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Plane = __webpack_require__(1255);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Plane).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1257 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable max-len */
	
	var Plus = function (_BcReactComponent) {
	  _inherits(Plus, _BcReactComponent);
	
	  function Plus() {
	    _classCallCheck(this, Plus);
	
	    return _possibleConstructorReturn(this, (Plus.__proto__ || Object.getPrototypeOf(Plus)).apply(this, arguments));
	  }
	
	  _createClass(Plus, [{
	    key: 'render',
	    value: function render() {
	      var className = this.props.className;
	
	      return _react2.default.createElement(
	        'svg',
	        { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-plus ' + className, preserveAspectRatio: 'xMinYMin meet', viewBox: '0 0 16 16' },
	        _react2.default.createElement('path', { className: 'path1', d: 'M15.5 6h-5.5v-5.5c0-0.276-0.224-0.5-0.5-0.5h-3c-0.276 0-0.5 0.224-0.5 0.5v5.5h-5.5c-0.276 0-0.5 0.224-0.5 0.5v3c0 0.276 0.224 0.5 0.5 0.5h5.5v5.5c0 0.276 0.224 0.5 0.5 0.5h3c0.276 0 0.5-0.224 0.5-0.5v-5.5h5.5c0.276 0 0.5-0.224 0.5-0.5v-3c0-0.276-0.224-0.5-0.5-0.5z' })
	      );
	    }
	  }]);
	
	  return Plus;
	}(_baseBcReactComponent2.default);
	
	Plus.propTypes = _bcPropTypes.iconShape;
	
	exports.default = Plus;

/***/ },
/* 1258 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Plus = __webpack_require__(1257);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Plus).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1259 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Printer;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function Printer(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#000' : _ref$color,
	      _ref$title = _ref.title,
	      title = _ref$title === undefined ? 'Print' : _ref$title,
	      _ref$hidden = _ref.hidden,
	      hidden = _ref$hidden === undefined ? true : _ref$hidden;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': hidden, className: 'icon-svg-printer ' + className, width: width, height: height, viewBox: '0 0 16 16', 'aria-label': hidden ? null : title },
	    _react2.default.createElement(
	      'title',
	      null,
	      title
	    ),
	    _react2.default.createElement('path', { fill: color, d: 'M9.5 11h-3c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h3c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5z' }),
	    _react2.default.createElement('path', { fill: color, d: 'M10.5 13h-5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h5c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5z' }),
	    _react2.default.createElement('path', { fill: color, d: 'M15.916 7.223l-2-3c-0.093-0.139-0.249-0.223-0.416-0.223h-1.5v-3.5c0-0.276-0.224-0.5-0.5-0.5h-7c-0.276 0-0.5 0.224-0.5 0.5v3.5h-1.5c-0.167 0-0.323 0.084-0.416 0.223l-2 3c-0.055 0.082-0.084 0.179-0.084 0.277v5c0 0.276 0.224 0.5 0.5 0.5h2.306l-0.781 2.342c-0.051 0.152-0.025 0.32 0.069 0.45s0.245 0.208 0.406 0.208h11c0.161 0 0.312-0.077 0.406-0.208s0.12-0.298 0.069-0.45l-0.781-2.342h2.306c0.276 0 0.5-0.224 0.5-0.5v-5c0-0.099-0.029-0.195-0.084-0.277zM5 1h6v4h-6v-4zM3.194 15l1.667-5h6.279l1.667 5h-9.613z' })
	  );
	}
	
	Printer.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1260 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Printer = __webpack_require__(1259);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Printer).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1261 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	__webpack_require__(2684);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PushPin = function PushPin(_ref) {
	  var color = _ref.color,
	      title = _ref.title,
	      width = _ref.width,
	      height = _ref.height,
	      className = _ref.className;
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-push-pin ' + className, width: width, height: height, viewBox: '0 0 16 16' },
	    _react2.default.createElement(
	      'title',
	      null,
	      title
	    ),
	    _react2.default.createElement('path', { fill: color, d: 'M8.5 0l-1.5 1.5 1.5 1.5-3.5 4h-3.5l2.75 2.75-4.25 5.635v0.615h0.615l5.635-4.25 2.75 2.75v-3.5l4-3.5 1.5 1.5 1.5-1.5-7.5-7.5zM7 8.5l-1-1 3.5-3.5 1 1-3.5 3.5z' })
	  );
	};
	
	PushPin.propTypes = _bcPropTypes.iconShape;
	
	exports.default = PushPin;

/***/ },
/* 1262 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PushPin = __webpack_require__(1261);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PushPin).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1263 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = QuestionMarkCircled;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function QuestionMarkCircled(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '' : _ref$color,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height;
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      xmlns: 'http://www.w3.org/2000/svg',
	      focusable: 'false',
	      'aria-hidden': true,
	      className: 'icon-svg-question-mark-circled ' + className,
	      width: width,
	      height: height,
	      viewBox: '0 0 16 16' },
	    _react2.default.createElement(
	      'g',
	      { fill: color, fillRule: 'evenodd' },
	      _react2.default.createElement('path', { d: 'M11.452 6.226c0 .58-.172 1.075-.517 1.484-.215.236-.57.494-1.064.774-.258.15-.43.269-.516.355-.15.107-.226.236-.226.387v.193a.373.373 0 0 1-.113.275.373.373 0 0 1-.274.112H7.258a.373.373 0 0 1-.274-.112.373.373 0 0 1-.113-.275v-.29c0-.495.172-.914.516-1.258.194-.194.516-.42.968-.677l.064-.033c.323-.193.549-.344.678-.451a.71.71 0 0 0 .226-.516c0-.259-.135-.474-.404-.646a1.64 1.64 0 0 0-.903-.258 1.56 1.56 0 0 0-.855.226c-.193.13-.43.376-.71.742a.481.481 0 0 1-.241.13.323.323 0 0 1-.275-.065l-.903-.678a.353.353 0 0 1-.145-.258.52.52 0 0 1 .048-.29c.41-.58.871-1.016 1.388-1.307.516-.29 1.14-.435 1.87-.435.517 0 1.033.129 1.549.387s.93.602 1.242 1.032c.312.43.468.914.468 1.452zm-2.097 5.387c0 .365-.135.683-.403.952a1.301 1.301 0 0 1-.952.403c-.366 0-.683-.135-.952-.403a1.301 1.301 0 0 1-.403-.952c0-.366.135-.683.403-.952.27-.269.586-.403.952-.403s.683.134.952.403c.268.27.403.586.403.952z' }),
	      _react2.default.createElement('path', { fillRule: 'nonzero', d: 'M16 8a7.76 7.76 0 0 1-1.08 4A8.084 8.084 0 0 1 12 14.92 7.76 7.76 0 0 1 8 16a7.76 7.76 0 0 1-4-1.08A8.084 8.084 0 0 1 1.08 12 7.76 7.76 0 0 1 0 8c0-1.44.36-2.774 1.08-4A8.084 8.084 0 0 1 4 1.08 7.76 7.76 0 0 1 8 0c1.44 0 2.773.36 4 1.08A8.084 8.084 0 0 1 14.919 4 7.76 7.76 0 0 1 16 8zM1.549 8c0 1.161.29 2.237.87 3.226a6.504 6.504 0 0 0 2.355 2.355 6.26 6.26 0 0 0 3.227.87 6.26 6.26 0 0 0 3.225-.87 6.504 6.504 0 0 0 2.355-2.355A6.26 6.26 0 0 0 14.45 8a6.26 6.26 0 0 0-.87-3.226 6.504 6.504 0 0 0-2.355-2.355A6.26 6.26 0 0 0 8 1.55a6.26 6.26 0 0 0-3.226.87 6.504 6.504 0 0 0-2.355 2.355A6.26 6.26 0 0 0 1.55 8z' })
	    )
	  );
	}
	
	QuestionMarkCircled.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1264 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _QuestionMarkCircled = __webpack_require__(1263);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_QuestionMarkCircled).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1265 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = QuestionMarkSquared;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function QuestionMarkSquared(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '' : _ref$color,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height;
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      xmlns: 'http://www.w3.org/2000/svg',
	      focusable: 'false',
	      'aria-hidden': true,
	      className: 'icon-svg-question-mark-squared ' + className,
	      width: width,
	      height: height,
	      viewBox: '0 0 16 16' },
	    _react2.default.createElement(
	      'g',
	      { fill: color, fillRule: 'evenodd' },
	      _react2.default.createElement('path', { d: 'M14 0c.542 0 1.01.198 1.406.594C15.802.99 16 1.458 16 2v9c0 .542-.198 1.01-.594 1.406A1.922 1.922 0 0 1 14 13H9.5l-3.906 2.937a.414.414 0 0 1-.235.063.344.344 0 0 1-.25-.11.362.362 0 0 1-.109-.265V13H2c-.542 0-1.01-.198-1.406-.594A1.922 1.922 0 0 1 0 11V2C0 1.458.198.99.594.594A1.922 1.922 0 0 1 2 0h12zm.5 11V2a.487.487 0 0 0-.14-.36.487.487 0 0 0-.36-.14H2a.487.487 0 0 0-.36.14.487.487 0 0 0-.14.36v9c0 .146.047.266.14.36.094.093.214.14.36.14h4.5v1.875L9 11.5h5a.487.487 0 0 0 .36-.14.487.487 0 0 0 .14-.36z' }),
	      _react2.default.createElement('path', { d: 'M10.44 5.09c0 .423-.124.784-.375 1.081-.156.172-.415.36-.775.564-.188.11-.313.196-.376.258-.11.079-.164.173-.164.282v.141a.272.272 0 0 1-.083.2.272.272 0 0 1-.2.082h-1.08a.272.272 0 0 1-.2-.082.272.272 0 0 1-.082-.2v-.211c0-.36.126-.666.376-.916.141-.141.376-.306.705-.494l.047-.023c.235-.141.4-.25.493-.329a.517.517 0 0 0 .165-.376c0-.188-.098-.344-.294-.47a1.194 1.194 0 0 0-.658-.188c-.242 0-.45.055-.622.165-.141.094-.313.274-.517.54a.35.35 0 0 1-.176.094.235.235 0 0 1-.2-.047l-.658-.493a.257.257 0 0 1-.105-.188.38.38 0 0 1 .035-.212c.298-.422.634-.74 1.01-.95.376-.212.83-.318 1.362-.318.376 0 .752.094 1.128.282.376.188.677.438.904.752.227.313.34.665.34 1.057zM8.915 9.014a.948.948 0 0 1-.294.693.948.948 0 0 1-.692.294.948.948 0 0 1-.693-.294.948.948 0 0 1-.294-.693c0-.266.098-.497.294-.693a.948.948 0 0 1 .693-.293c.266 0 .497.098.692.293a.948.948 0 0 1 .294.693z' })
	    )
	  );
	}
	
	QuestionMarkSquared.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1266 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _QuestionMarkSquared = __webpack_require__(1265);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_QuestionMarkSquared).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1267 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Quotation;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	function Quotation(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: (0, _classnames2.default)('icon-svg-quotation', className), width: width, height: height, preserveAspectRatio: 'xMinYMin meet', viewBox: '0 0 16 16' },
	    _react2.default.createElement('path', { fill: color, fillRule: 'evenodd', d: 'M7.124 2.925c-.445.119-.942.349-1.491.69a9.135 9.135 0 0 0-1.537 1.202c-.474.46-.86.958-1.157 1.492-.297.534-.416 1.069-.356 1.603.059.208.222.326.49.356.267.03.519.045.756.045.742 0 1.388.245 1.937.734.55.49.824 1.18.824 2.07 0 .862-.304 1.604-.913 2.227-.608.624-1.299.935-2.07.935-1.188 0-2.086-.43-2.694-1.291C.304 12.128 0 11.073 0 9.827c0-.98.2-1.923.601-2.828.4-.905.928-1.73 1.58-2.471.654-.742 1.41-1.38 2.272-1.915A8.67 8.67 0 0 1 7.124 1.5v1.425zm8.876 0c-.445.119-.942.349-1.492.69a9.135 9.135 0 0 0-1.536 1.202c-.475.46-.86.958-1.158 1.492-.296.534-.415 1.069-.356 1.603.06.208.223.326.49.356.267.03.52.045.757.045.742 0 1.388.245 1.937.734.55.49.824 1.18.824 2.07 0 .862-.305 1.604-.913 2.227-.609.624-1.299.935-2.07.935-1.188 0-2.086-.43-2.695-1.291-.608-.86-.912-1.915-.912-3.161 0-.98.2-1.923.6-2.828.402-.905.928-1.73 1.582-2.471.653-.742 1.41-1.38 2.27-1.915A8.67 8.67 0 0 1 16 1.5v1.425z' })
	  );
	}
	
	Quotation.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1268 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Quotation = __webpack_require__(1267);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Quotation).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1269 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = RSS;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function RSS(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      focusable: 'false',
	      'aria-hidden': true,
	      className: 'icon-svg-rss ' + className,
	      width: width,
	      height: height,
	      viewBox: '0 0 16 16' },
	    _react2.default.createElement('path', { fill: color, d: 'M2.13 11.733c-1.175 0-2.13 0.958-2.13 2.126 0 1.174 0.955 2.122 2.13 2.122 1.179 0 2.133-0.948 2.133-2.122-0-1.168-0.954-2.126-2.133-2.126zM0.002 5.436v3.067c1.997 0 3.874 0.781 5.288 2.196 1.412 1.411 2.192 3.297 2.192 5.302h3.080c-0-5.825-4.739-10.564-10.56-10.564zM0.006 0v3.068c7.122 0 12.918 5.802 12.918 12.932h3.076c0-8.82-7.176-16-15.994-16z' })
	  );
	}
	
	RSS.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1270 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _RSS = __webpack_require__(1269);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RSS).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1271 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Redo;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function Redo(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-redo ' + className, width: width, height: height, viewBox: '0 0 1792 1792' },
	    _react2.default.createElement('path', { d: 'M1664 256v448q0 26-19 45t-45 19h-448q-42 0-59-40-17-39 14-69l138-138q-148-137-349-137-104 0-198.5 40.5t-163.5 109.5-109.5 163.5-40.5 198.5 40.5 198.5 109.5 163.5 163.5 109.5 198.5 40.5q119 0 225-52t179-147q7-10 23-12 15 0 25 9l137 138q9 8 9.5 20.5t-7.5 22.5q-109 132-264 204.5t-327 72.5q-156 0-298-61t-245-164-164-245-61-298 61-298 164-245 245-164 298-61q147 0 284.5 55.5t244.5 156.5l130-129q29-31 70-14 39 17 39 59z' })
	  );
	}
	
	Redo.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1272 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Redo = __webpack_require__(1271);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Redo).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1273 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Remove;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function Remove(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-remove ' + className, width: width, height: height, viewBox: '0 0 16 16' },
	    _react2.default.createElement('path', { fill: color, fillRule: 'evenodd', d: 'M1 2.625V1.75c0-.208.073-.385.219-.531A.723.723 0 0 1 1.75 1h3.5l.281-.594A.702.702 0 0 1 5.812.11.792.792 0 0 1 6.22 0H9.78c.146 0 .281.036.406.11a.702.702 0 0 1 .282.296L10.75 1h3.5c.208 0 .385.073.531.219A.723.723 0 0 1 15 1.75v.875a.362.362 0 0 1-.11.266.362.362 0 0 1-.265.109H1.375a.362.362 0 0 1-.266-.11A.362.362 0 0 1 1 2.626zm13 1.75V14.5c0 .417-.146.77-.438 1.062A1.447 1.447 0 0 1 12.5 16h-9c-.417 0-.77-.146-1.063-.438A1.447 1.447 0 0 1 2 14.5V4.375c0-.104.036-.193.11-.266A.362.362 0 0 1 2.374 4h11.25c.104 0 .193.036.266.11.073.072.109.16.109.265zM5.5 6.5a.487.487 0 0 0-.14-.36A.487.487 0 0 0 5 6a.487.487 0 0 0-.36.14.487.487 0 0 0-.14.36v7c0 .146.047.266.14.36.094.093.214.14.36.14a.487.487 0 0 0 .36-.14.487.487 0 0 0 .14-.36v-7zm3 0a.487.487 0 0 0-.14-.36A.487.487 0 0 0 8 6a.487.487 0 0 0-.36.14.487.487 0 0 0-.14.36v7c0 .146.047.266.14.36.094.093.214.14.36.14a.487.487 0 0 0 .36-.14.487.487 0 0 0 .14-.36v-7zm3 0a.487.487 0 0 0-.14-.36A.487.487 0 0 0 11 6a.487.487 0 0 0-.36.14.487.487 0 0 0-.14.36v7c0 .146.047.266.14.36.094.093.214.14.36.14a.487.487 0 0 0 .36-.14.487.487 0 0 0 .14-.36v-7z' })
	  );
	}
	
	Remove.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1274 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Remove = __webpack_require__(1273);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Remove).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1275 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Resume;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Resume(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: (0, _classnames2.default)('icon-svg-resume-circled', className), width: width, height: height, viewBox: '0 0 1792 1792' },
	    _react2.default.createElement('path', {
	      fill: color,
	      d: 'M1312 896q0 37-32 55l-544 320q-15 9-32 9-16 0-32-8-32-19-32-56v-640q0-37 32-56 33-18 64 1l544 320q32 18 32 55zm128 0q0-148-73-273t-198-198-273-73-273 73-198 198-73 273 73 273 198 198 273 73 273-73 198-198 73-273zm224 0q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z' })
	  );
	}
	
	Resume.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1276 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Resume = __webpack_require__(1275);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Resume).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1277 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	var RightArrowCircled = function RightArrowCircled(_ref) {
	  var className = _ref.className,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 12 : _ref$height,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 12 : _ref$width;
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-video-camera ' + className, preserveAspectRatio: 'xMinYMin meet', width: width, height: height, viewBox: '0 0 12 12' },
	    _react2.default.createElement(
	      'g',
	      { fillRule: 'evenodd' },
	      _react2.default.createElement('circle', { cx: '6', cy: '6', r: '6', fill: color }),
	      _react2.default.createElement('path', { fill: '#FFF', d: 'M6,7 L3,7 L3,5 L6,5 L6,3.15917967 C6,3.01732459 6.159,2.94747172 6.252,3.04741507 L8.896,5.88774058 C8.953,5.95007084 8.953,6.05001419 8.896,6.11234445 L6.252,8.95374462 C6.159,9.05261331 6,8.98276043 6,8.84090535 L6,7 Z' })
	    )
	  );
	};
	
	RightArrowCircled.propTypes = _bcPropTypes.iconShape;
	
	exports.default = RightArrowCircled;

/***/ },
/* 1278 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _RightArrowCircled = __webpack_require__(1277);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RightArrowCircled).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1279 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	var RightArrowCircledOutline = function RightArrowCircledOutline(_ref) {
	  var className = _ref.className,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color;
	  return _react2.default.createElement(
	    'svg',
	    {
	      xmlns: 'http://www.w3.org/2000/svg',
	      focusable: 'false',
	      'aria-hidden': true,
	      className: 'icon-svg-right-arrow-circled-outline ' + className,
	      preserveAspectRatio: 'xMinYMin meet',
	      viewBox: '0 0 16 16' },
	    _react2.default.createElement('path', {
	      fill: color,
	      fillRule: 'evenodd',
	      d: 'M15,8 C15,9.26075283 14.6848117,10.4274194 14.0544355,11.5 C13.4240593,12.5725806 12.5725806,13.4240593 11.5,14.0544355 C10.4274194,14.6848117 9.26075283,15 8,15 C6.73924717,15 5.57258065,14.6848117 4.5,14.0544355 C3.42741935,13.4240593 2.57594072,12.5725806 1.94556452,11.5 C1.31518832,10.4274194 1,9.26075283 1,8 C1,6.73924717 1.31518832,5.57258065 1.94556452,4.5 C2.57594072,3.42741935 3.42741935,2.57594072 4.5,1.94556452 C5.57258065,1.31518832 6.73924717,1 8,1 C9.26075283,1 10.4274194,1.31518832 11.5,1.94556452 C12.5725806,2.57594072 13.4240593,3.42741935 14.0544355,4.5 C14.6848117,5.57258065 15,6.73924717 15,8 Z M2.35483871,8 C2.35483871,9.01612903 2.60887097,9.9569891 3.11693548,10.8225806 C3.625,11.6881722 4.31182781,12.375 5.17741935,12.8830645 C6.0430109,13.391129 6.98387097,13.6451613 8,13.6451613 C9.01612903,13.6451613 9.9569891,13.391129 10.8225806,12.8830645 C11.6881722,12.375 12.375,11.6881722 12.8830645,10.8225806 C13.391129,9.9569891 13.6451613,9.01612903 13.6451613,8 C13.6451613,6.98387097 13.391129,6.0430109 12.8830645,5.17741935 C12.375,4.31182781 11.6881722,3.625 10.8225806,3.11693548 C9.9569891,2.60887097 9.01612903,2.35483871 8,2.35483871 C6.98387097,2.35483871 6.0430109,2.60887097 5.17741935,3.11693548 C4.31182781,3.625 3.625,4.31182781 3.11693548,5.17741935 C2.60887097,6.0430109 2.35483871,6.98387097 2.35483871,8 Z M4.38709677,7.43548387 C4.38709677,7.34139799 4.42002703,7.26142459 4.4858871,7.19556452 C4.55174717,7.12970444 4.63172057,7.09677419 4.72580645,7.09677419 L8,7.09677419 L8,5.20564516 C8,5.05510767 8.07056452,4.9516129 8.21169355,4.89516129 C8.35282258,4.83870968 8.47043025,4.85752703 8.56451613,4.9516129 L11.3870968,7.74596774 C11.4435484,7.8212367 11.4717742,7.90591412 11.4717742,8 C11.4717742,8.09408588 11.4435484,8.1787633 11.3870968,8.25403226 L8.59274194,11.0201613 C8.47983871,11.1330645 8.35282258,11.1612903 8.21169355,11.1048387 C8.07056452,11.0483871 8,10.9448923 8,10.7943548 L8,8.90322581 L4.72580645,8.90322581 C4.63172057,8.90322581 4.55174717,8.87029556 4.4858871,8.80443548 C4.42002703,8.73857541 4.38709677,8.65860201 4.38709677,8.56451613 L4.38709677,7.43548387 Z' })
	  );
	};
	
	RightArrowCircledOutline.propTypes = _bcPropTypes.iconShape;
	
	exports.default = RightArrowCircledOutline;

/***/ },
/* 1280 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _RightArrowCircledOutline = __webpack_require__(1279);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RightArrowCircledOutline).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1281 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = SearchIcon;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function SearchIcon(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#000' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-cog ' + className, width: width, height: height, viewBox: '0 0 16 16' },
	    _react2.default.createElement('path', { fill: color, d: 'M16 13.5l-4.695-4.695c0.444-0.837 0.695-1.792 0.695-2.805 0-3.314-2.686-6-6-6s-6 2.686-6 6 2.686 6 6 6c1.013 0 1.968-0.252 2.805-0.695l4.695 4.695 2.5-2.5zM2 6c0-2.209 1.791-4 4-4s4 1.791 4 4-1.791 4-4 4-4-1.791-4-4z' })
	  );
	}
	
	SearchIcon.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1282 */
[3484, 1281],
/* 1283 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable max-len */
	
	var SexualContent = function (_BcReactComponent) {
	  _inherits(SexualContent, _BcReactComponent);
	
	  function SexualContent() {
	    _classCallCheck(this, SexualContent);
	
	    return _possibleConstructorReturn(this, (SexualContent.__proto__ || Object.getPrototypeOf(SexualContent)).apply(this, arguments));
	  }
	
	  _createClass(SexualContent, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'svg',
	        { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-sexual-content', preserveAspectRatio: 'xMinYMin meet', viewBox: '0 0 16 16' },
	        _react2.default.createElement('path', { className: 'path1', d: 'M16 6.877l-0.157-0.005c-1.935-0.112-3.646-2.091-5.593-2.091-2 0-2.25 0.75-2.25 0.75s-0.25-0.75-2.25-0.75c-1.948 0-3.658 1.979-5.593 2.091l-0.157 0.005c0 0 5 0.904 8 0.904s8-0.904 8-0.904zM8 9.219c-2.637 0-7-1.531-7.793-2.138 2.25 1.722 3.894 4.794 7.793 4.794s5.543-3.073 7.793-4.794c-0.793 0.607-5.156 2.138-7.793 2.138z' })
	      );
	    }
	  }]);
	
	  return SexualContent;
	}(_baseBcReactComponent2.default);
	
	exports.default = SexualContent;

/***/ },
/* 1284 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SexualContent = __webpack_require__(1283);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SexualContent).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1285 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ShelfItem;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function ShelfItem(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 33 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 22 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#666' : _ref$color,
	      _ref$checkmarkBackgro = _ref.checkmarkBackgroundColor,
	      checkmarkBackgroundColor = _ref$checkmarkBackgro === undefined ? '#2F50B3' : _ref$checkmarkBackgro,
	      _ref$checkmarkStrokeC = _ref.checkmarkStrokeColor,
	      checkmarkStrokeColor = _ref$checkmarkStrokeC === undefined ? '#fff' : _ref$checkmarkStrokeC,
	      _ref$lockBackgroundCo = _ref.lockBackgroundColor,
	      lockBackgroundColor = _ref$lockBackgroundCo === undefined ? '#2F50B3' : _ref$lockBackgroundCo,
	      _ref$lockStrokeColor = _ref.lockStrokeColor,
	      lockStrokeColor = _ref$lockStrokeColor === undefined ? '#fff' : _ref$lockStrokeColor,
	      _ref$onShelf = _ref.onShelf,
	      onShelf = _ref$onShelf === undefined ? false : _ref$onShelf,
	      _ref$isPrivate = _ref.isPrivate,
	      isPrivate = _ref$isPrivate === undefined ? false : _ref$isPrivate;
	
	  var renderLockIcon = function renderLockIcon() {
	    return _react2.default.createElement(
	      'g',
	      { transform: 'translate(110.000000, 558.000000)' },
	      _react2.default.createElement('path', { d: 'M6.62249994,0 C4.41249994,0 2.62249994,1.79 2.62249994,4 L2.62249994,6 L0.622499943,6 L0.622499943,14 L12.6224999,14 L12.6224999,6 L10.6224999,6 L10.6224999,4 C10.6224999,1.79 8.83249994,0 6.62249994,0 Z M6.62249994,2 C7.81249994,2 8.62249994,2.81 8.62249994,4 L8.62249994,6 L4.62249994,6 L4.62249994,4 C4.62249994,2.81 5.43249994,2 6.62249994,2 Z', fill: lockBackgroundColor, fillRule: 'nonzero' }),
	      _react2.default.createElement(
	        'g',
	        { transform: 'translate(3.500000, 7.875000)', fill: lockStrokeColor },
	        _react2.default.createElement('polygon', { id: 'Checkmark', points: '2.79600174 2.66464878 1.33994949 1.20859653 0.35 2.19854602 2.76482323 4.61336925 3.75477272 3.62341976 6.37158225 0.989949494 5.38163276 1.33226763e-15' })
	      )
	    );
	  };
	
	  var renderCheckmark = function renderCheckmark() {
	    return _react2.default.createElement(
	      'g',
	      { stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd', transform: 'translate(110.000000, 558.000000)' },
	      _react2.default.createElement('circle', { className: 'CheckBackground', fill: checkmarkBackgroundColor, cx: '6', cy: '6', r: '6' }),
	      _react2.default.createElement('polygon', { className: 'Checkmark', fill: checkmarkStrokeColor, points: '5.49428821 6.80664111 3.41421356 4.72656647 2 6.14078003 5.44974747 9.5905275 6.86396103 8.17631394 10.6022604 4.41421356 9.1880468 3' })
	    );
	  };
	
	  var renderOnShelfIcon = function renderOnShelfIcon() {
	    if (onShelf && isPrivate) {
	      return renderLockIcon();
	    } else if (onShelf) {
	      return renderCheckmark();
	    }
	
	    return null;
	  };
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-shelf-item ' + className, width: width, height: height, viewBox: '89 558 33 22', version: '1.1' },
	    _react2.default.createElement(
	      'g',
	      { stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd', transform: 'translate(97.000000, 560.000000)' },
	      _react2.default.createElement(
	        'g',
	        { fill: color },
	        _react2.default.createElement(
	          'g',
	          { transform: 'translate(12.631579, 2.089245)' },
	          _react2.default.createElement('path', { d: 'M3.68421053,2.26544622 L3.36842105,0.926773455 C3.36842105,0.823798627 3.26315789,0.720823799 3.15789474,0.720823799 L0.315789474,1.23569794 C0.210526316,1.23569794 0.105263158,1.33867277 0.105263158,1.4416476 L0.421052632,2.78032037 L3.68421053,2.26544622 L3.68421053,2.26544622 Z' }),
	          _react2.default.createElement('polygon', { points: '3.79077895 3.16967849 5.92558947 13.5682002 2.72638947 14.1967483 0.591578947 3.79822654' }),
	          _react2.default.createElement('path', { d: 'M2.94736842,15.0343249 L3.26315789,16.3729977 C3.26315789,16.4759725 3.36842105,16.4759725 3.47368421,16.4759725 L6.31578947,15.9610984 C6.42105263,15.9610984 6.52631579,15.8581236 6.52631579,15.7551487 L6.10526316,14.416476 L2.94736842,15.0343249 L2.94736842,15.0343249 Z' })
	        ),
	        _react2.default.createElement(
	          'g',
	          { transform: 'translate(6.315789, 0.000000)' },
	          _react2.default.createElement('path', { d: 'M5.68421053,2.29519451 L5.68421053,0.338672769 C5.68421053,0.235697941 5.57894737,0.0297482838 5.36842105,0.0297482838 L1.15789474,0.0297482838 C0.947368421,0.0297482838 0.842105263,0.132723112 0.842105263,0.338672769 L0.842105263,2.29519451 L5.68421053,2.29519451 L5.68421053,2.29519451 Z' }),
	          _react2.default.createElement('rect', { x: '0.842105263', y: '3.11899314', width: '4.73684211', height: '12.9748284' }),
	          _react2.default.createElement('path', { d: 'M0.842105263,17.020595 L0.842105263,18.3592677 C0.842105263,18.4622426 0.947368421,18.5652174 1.05263158,18.5652174 L5.36842105,18.5652174 C5.47368421,18.5652174 5.68421053,18.4622426 5.68421053,18.3592677 L5.68421053,17.020595 L0.842105263,17.020595 L0.842105263,17.020595 Z' })
	        ),
	        _react2.default.createElement(
	          'g',
	          { transform: 'translate(0.000000, 1.059497)' },
	          _react2.default.createElement('path', { d: 'M5.68421053,2.78032037 L5.68421053,0.823798627 C5.68421053,0.720823799 5.57894737,0.61784897 5.47368421,0.61784897 L0.315789474,0.61784897 C0.210526316,0.61784897 0.105263158,0.720823799 0.105263158,0.823798627 L0.105263158,2.78032037 L5.68421053,2.78032037 L5.68421053,2.78032037 Z' }),
	          _react2.default.createElement('rect', { x: '0.105263158', y: '3.60411899', width: '5.57894737', height: '11.4302059' }),
	          _react2.default.createElement('path', { d: 'M0.105263158,15.9610984 L0.105263158,17.2997712 C0.105263158,17.402746 0.210526316,17.5057208 0.315789474,17.5057208 L5.36842105,17.5057208 C5.47368421,17.5057208 5.57894737,17.402746 5.57894737,17.2997712 L5.57894737,15.9610984 L0.105263158,15.9610984 L0.105263158,15.9610984 Z' })
	        )
	      )
	    ),
	    renderOnShelfIcon()
	  );
	}
	
	ShelfItem.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1286 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ShelfItem = __webpack_require__(1285);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ShelfItem).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1287 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Shelves;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function Shelves(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      xmlns: 'http://www.w3.org/2000/svg',
	      focusable: 'false',
	      'aria-hidden': true,
	      className: 'icon-svg-shelves ' + className,
	      width: width,
	      height: height,
	      viewBox: '0 0 16 16' },
	    _react2.default.createElement('path', { fill: color, fillRule: 'evenodd', d: 'M13.6667341,3.73254543 L10.9524689,4.27768449 L10.7228047,3.13369246 C10.7045229,3.04455022 10.7730794,2.93883667 10.8616315,2.92112251 L13.2353996,2.44398298 C13.324523,2.42626881 13.4193595,2.49941116 13.4370699,2.5885534 L13.6667341,3.73254543 Z M15.6177373,13.4490492 L12.903472,13.9947597 L11.1027218,5.02796497 L13.8175584,4.48282592 L15.6177373,13.4490492 Z M13.0537249,14.7444687 L15.7685615,14.1993297 L15.9970831,15.3393217 C16.0147935,15.4278925 15.9496649,15.5010349 15.8611128,15.518749 L13.4873447,15.9958886 C13.3982213,16.0136027 13.3005283,15.973603 13.2828179,15.8850322 L13.0537249,14.7444687 Z M10.0178155,1.93084369 L5.97412586,1.93084369 L5.97412586,0.230855535 C5.97412586,0.110856371 6.05639364,0 6.17636747,0 L9.7847235,0 C9.90469734,0 10.0178155,0.110856371 10.0178155,0.230855535 L10.0178155,1.93084369 Z M5.97412586,2.69598122 L10.0178155,2.69598122 L10.0178155,13.9181888 L5.97412586,13.9181888 L5.97412586,2.69598122 Z M5.97412586,14.6838977 L10.0178155,14.6838977 L10.0178155,15.7964614 C10.0178155,15.917032 9.90469734,15.9953171 9.7847235,15.9953171 L6.17636747,15.9953171 C6.05639364,15.9953171 5.97412586,15.917032 5.97412586,15.7964614 L5.97412586,14.6838977 Z M4.69897535,3.27940573 L0,3.27940573 L0,1.59598888 C0,1.47541829 0.091979943,1.38456178 0.211953782,1.38456178 L4.48016592,1.38456178 C4.60013976,1.38456178 4.69897535,1.47541829 4.69897535,1.59598888 L4.69897535,3.27940573 Z M0,4.00797208 L4.69954665,4.00797208 L4.69954665,13.9187602 L0,13.9187602 L0,4.00797208 Z M0,14.6838977 L4.69897535,14.6838977 L4.69897535,15.7964614 C4.69897535,15.917032 4.60013976,15.9953171 4.48016592,15.9953171 L0.211953782,15.9953171 C0.091979943,15.9953171 0,15.917032 0,15.7964614 L0,14.6838977 Z' })
	  );
	}
	
	Shelves.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1288 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Shelves = __webpack_require__(1287);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Shelves).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1289 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Down;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function Down(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height;
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      xmlns: 'http://www.w3.org/2000/svg',
	      'aria-hidden': true,
	      focusable: 'false',
	      className: 'icon-svg-sort-down ' + className,
	      width: width,
	      height: height,
	      viewBox: '0 0 16 16' },
	    _react2.default.createElement('path', { fill: 'currentColor', fillRule: 'evenodd', d: 'M14 8c0 1.08-.27 2.08-.81 3-.54.92-1.27 1.65-2.19 2.19-.92.54-1.92.81-3 .81s-2.08-.27-3-.81A6.063 6.063 0 0 1 2.81 11C2.27 10.08 2 9.08 2 8s.27-2.08.81-3C3.35 4.08 4.08 3.35 5 2.81 5.92 2.27 6.92 2 8 2s2.08.27 3 .81c.92.54 1.65 1.27 2.19 2.19.54.92.81 1.92.81 3zm-3.484-.702l-1.742 1.84V4.71a.56.56 0 0 0-.17-.412.56.56 0 0 0-.41-.169h-.388a.56.56 0 0 0-.41.17.56.56 0 0 0-.17.41v4.428L5.484 7.298a.574.574 0 0 0-.424-.169c-.169 0-.31.056-.423.17l-.266.266a.56.56 0 0 0-.17.41.56.56 0 0 0 .17.412l3.218 3.194A.56.56 0 0 0 8 11.75a.56.56 0 0 0 .411-.17l3.218-3.193a.56.56 0 0 0 .17-.411.56.56 0 0 0-.17-.411l-.266-.267a.574.574 0 0 0-.423-.169c-.17 0-.311.056-.424.17z' })
	  );
	}
	
	Down.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1290 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = SortArrows;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function SortArrows(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-sort-arrows ' + className, width: width, height: height, viewBox: '0 0 18 16' },
	    _react2.default.createElement('path', { fill: color, d: 'M12 7l-4-4-4 4zM4 10l4 4 4-4z' })
	  );
	}
	
	SortArrows.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1291 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Up;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function Up(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height;
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      xmlns: 'http://www.w3.org/2000/svg',
	      'aria-hidden': true,
	      focusable: 'false',
	      className: 'icon-svg-sort-up ' + className,
	      width: width,
	      height: height,
	      viewBox: '0 0 16 16' },
	    _react2.default.createElement('path', { fill: 'currentColor', fillRule: 'evenodd', d: 'M14 8c0-1.08-.27-2.08-.81-3A6.063 6.063 0 0 0 11 2.81C10.08 2.27 9.08 2 8 2s-2.08.27-3 .81C4.08 3.35 3.35 4.08 2.81 5 2.27 5.92 2 6.92 2 8s.27 2.08.81 3c.54.92 1.27 1.65 2.19 2.19.92.54 1.92.81 3 .81s2.08-.27 3-.81c.92-.54 1.65-1.27 2.19-2.19.54-.92.81-1.92.81-3zm-3.484.702l-1.742-1.84v4.428a.56.56 0 0 1-.17.412.56.56 0 0 1-.41.169h-.388a.56.56 0 0 1-.41-.17.56.56 0 0 1-.17-.41V6.862L5.484 8.702a.574.574 0 0 1-.424.169.574.574 0 0 1-.423-.17l-.266-.266a.56.56 0 0 1-.17-.41.56.56 0 0 1 .17-.412l3.218-3.194A.56.56 0 0 1 8 4.25a.56.56 0 0 1 .411.17l3.218 3.193a.56.56 0 0 1 .17.411.56.56 0 0 1-.17.411l-.266.267a.574.574 0 0 1-.423.169.574.574 0 0 1-.424-.17z' })
	  );
	}
	
	Up.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1292 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Up = __webpack_require__(1291);
	
	var _Up2 = _interopRequireDefault(_Up);
	
	var _Down = __webpack_require__(1289);
	
	var _Down2 = _interopRequireDefault(_Down);
	
	var _SortArrows = __webpack_require__(1290);
	
	var _SortArrows2 = _interopRequireDefault(_SortArrows);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = { Up: _Up2.default, Down: _Down2.default, SortArrows: _SortArrows2.default };

/***/ },
/* 1293 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(2685);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function Spinner(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$primary = _ref.primary,
	      primary = _ref$primary === undefined ? false : _ref$primary;
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      focusable: 'false',
	      'aria-hidden': true,
	      className: (0, _classnames2.default)('icon-svg-spinner', className, { primary: primary }),
	      width: width,
	      height: height,
	      viewBox: '0 0 16 16' },
	    _react2.default.createElement(
	      'g',
	      { transform: 'translate(8, 8)' },
	      _react2.default.createElement('circle', {
	        cx: '0',
	        cy: '0',
	        r: '7',
	        fill: 'rgba(0,0,0,0)',
	        stroke: color,
	        strokeWidth: '2',
	        strokeDasharray: '33' })
	    )
	  );
	}
	
	Spinner.propTypes = {
	  color: _react.PropTypes.string,
	  className: _react.PropTypes.string,
	  width: _react.PropTypes.number,
	  height: _react.PropTypes.number,
	  primary: _react.PropTypes.bool
	};
	
	Spinner.displayName = 'Spinner';
	
	exports.default = Spinner;

/***/ },
/* 1294 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Spinner = __webpack_require__(1293);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Spinner).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1295 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = StarEmpty;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function StarEmpty(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$strokeColor = _ref.strokeColor,
	      strokeColor = _ref$strokeColor === undefined ? 'currentColor' : _ref$strokeColor;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-star-empty ' + className, width: width, height: height, viewBox: '0 0 16 16' },
	    _react2.default.createElement('path', { fill: 'none', stroke: strokeColor, strokeWidth: '.9', d: 'M15.1941029,6.47387071 L10.222977,5.75176252 L8,1.24735641 L5.77702298,5.75176252 L0.805897078,6.47387071 L4.40292492,9.9800736 L3.55401651,14.9305405 L8,12.5933417 L12.4459835,14.9305405 L11.5970751,9.9800736 L15.1941029,6.47387071 Z' })
	  );
	}
	
	StarEmpty.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1296 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _StarEmpty = __webpack_require__(1295);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_StarEmpty).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1297 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = StarFull;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function StarFull(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$strokeColor = _ref.strokeColor,
	      strokeColor = _ref$strokeColor === undefined ? 'currentColor' : _ref$strokeColor;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-star-full ' + className, width: width, height: height, viewBox: '0 0 16 16' },
	    _react2.default.createElement('path', { fill: color, stroke: strokeColor, strokeWidth: '.9', d: 'M15.1941029,6.47387071 L10.222977,5.75176252 L8,1.24735641 L5.77702298,5.75176252 L0.805897078,6.47387071 L4.40292492,9.9800736 L3.55401651,14.9305405 L8,12.5933417 L12.4459835,14.9305405 L11.5970751,9.9800736 L15.1941029,6.47387071 Z' })
	  );
	}
	
	StarFull.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1298 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _StarFull = __webpack_require__(1297);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_StarFull).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1299 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = StarHalf;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function StarHalf(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$strokeColor = _ref.strokeColor,
	      strokeColor = _ref$strokeColor === undefined ? 'currentColor' : _ref$strokeColor;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-star-half ' + className, width: width, height: height, viewBox: '0 0 16 16' },
	    _react2.default.createElement(
	      'g',
	      { fill: 'none', fillRule: 'evenodd' },
	      _react2.default.createElement('path', { fill: color, fillRule: 'nonzero', d: 'M16,6.21200001 L10.472,5.40900001 L8,0.400000006 L5.528,5.40900001 L0,6.21200001 L4,10.111 L3.056,15.616 L8,13.017 L12.944,15.616 L12,10.111 L16,6.21200001 Z M8,12.3770234 L7.985,11.789 L8,2.21956464 L10.0358433,6.09733988 L14.4722466,6.78667448 L11.2286233,9.85690966 L11.9948141,14.1685241 L8,12.2810092 L8,12.3770234 Z' }),
	      _react2.default.createElement('path', { fill: 'none', stroke: strokeColor, strokeWidth: '.9', d: 'M15.1941029,6.47387071 L10.222977,5.75176252 L8,1.24735641 L5.77702298,5.75176252 L0.805897078,6.47387071 L4.40292492,9.9800736 L3.55401651,14.9305405 L8,12.5933417 L12.4459835,14.9305405 L11.5970751,9.9800736 L15.1941029,6.47387071 Z' })
	    )
	  );
	}
	
	StarHalf.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1300 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _StarHalf = __webpack_require__(1299);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_StarHalf).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1301 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Summary = function (_BcReactComponent) {
	  _inherits(Summary, _BcReactComponent);
	
	  function Summary() {
	    _classCallCheck(this, Summary);
	
	    return _possibleConstructorReturn(this, (Summary.__proto__ || Object.getPrototypeOf(Summary)).apply(this, arguments));
	  }
	
	  _createClass(Summary, [{
	    key: 'render',
	    value: function render() {
	      var className = this.props.className;
	
	      return _react2.default.createElement(
	        'svg',
	        { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-summary ' + className, preserveAspectRatio: 'xMinYMin meet', viewBox: '0 0 16 16' },
	        _react2.default.createElement('path', { className: 'path1', d: 'M11.445 0.055l-8.945 8.945-2.5 7 6.995-2.5 8.95-8.945c0.5-2-2.5-5-4.5-4.5zM4.5 11l-1-1 8.5-8.5 1 1-8.5 8.5z' })
	      );
	    }
	  }]);
	
	  return Summary;
	}(_baseBcReactComponent2.default);
	
	Summary.propTypes = {
	  className: _react.PropTypes.string
	};
	
	exports.default = Summary;

/***/ },
/* 1302 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Summary = __webpack_require__(1301);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Summary).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1303 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Tag;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function Tag(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-tag ' + className, width: width, height: height, viewBox: '0 0 16 16' },
	    _react2.default.createElement('path', { className: 'path1', fill: color, d: 'M15.25 0h-6c-0.412 0-0.989 0.239-1.28 0.53l-7.439 7.439c-0.292 0.292-0.292 0.769 0 1.061l6.439 6.439c0.292 0.292 0.769 0.292 1.061 0l7.439-7.439c0.292-0.292 0.53-0.868 0.53-1.28v-6c0-0.412-0.338-0.75-0.75-0.75zM11.5 6c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5z' })
	  );
	}
	
	Tag.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1304 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Tag = __webpack_require__(1303);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Tag).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1305 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = TextFile;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function TextFile(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#000' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-text-file ' + className, width: width, height: height, viewBox: '0 0 16 16' },
	    _react2.default.createElement('path', { fill: color, d: 'M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75c0-0.224-0.068-0.615-0.659-1.421zM12.271 2.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-11.5c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v9.75z' }),
	    _react2.default.createElement('path', { fill: color, d: 'M11.5 13h-7c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h7c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z' }),
	    _react2.default.createElement('path', { fill: color, d: 'M11.5 11h-7c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h7c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z' }),
	    _react2.default.createElement('path', { fill: color, d: 'M11.5 9h-7c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h7c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z' })
	  );
	}
	
	TextFile.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1306 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TextFile = __webpack_require__(1305);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TextFile).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1307 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Truck;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	function Truck(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color;
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      xmlns: 'http://www.w3.org/2000/svg',
	      focusable: 'false',
	      'aria-hidden': true,
	      className: (0, _classnames2.default)('icon-svg-truck', className),
	      width: width,
	      height: height,
	      viewBox: '0 0 16 16' },
	    _react2.default.createElement('path', { fill: color, d: 'M1.2 1.75c-.333 0-.617.117-.85.35-.233.233-.35.517-.35.85v8.6c0 .167.058.308.175.425a.579.579 0 0 0 .425.175h1c0 .667.233 1.233.7 1.7.467.467 1.033.7 1.7.7s1.233-.233 1.7-.7c.467-.467.7-1.033.7-1.7h3.2c0 .667.233 1.233.7 1.7.467.467 1.033.7 1.7.7s1.233-.233 1.7-.7c.467-.467.7-1.033.7-1.7h1a.579.579 0 0 0 .425-.175.579.579 0 0 0 .175-.425v-.4a.579.579 0 0 0-.175-.425.579.579 0 0 0-.425-.175h-.2v-2.7c0-.333-.117-.617-.35-.85l-2.5-2.5a1.157 1.157 0 0 0-.85-.35h-1.1v-1.2c0-.333-.117-.617-.35-.85a1.157 1.157 0 0 0-.85-.35h-8zM12 13.35c-.333 0-.617-.117-.85-.35a1.157 1.157 0 0 1-.35-.85c0-.333.117-.617.35-.85.233-.233.517-.35.85-.35.333 0 .617.117.85.35.233.233.35.517.35.85 0 .333-.117.617-.35.85-.233.233-.517.35-.85.35zm-1.6-5.2v-2.8h1.1l2.5 2.5v.3h-3.6zM4 13.35c-.333 0-.617-.117-.85-.35a1.157 1.157 0 0 1-.35-.85c0-.333.117-.617.35-.85.233-.233.517-.35.85-.35.333 0 .617.117.85.35.233.233.35.517.35.85 0 .333-.117.617-.35.85-.233.233-.517.35-.85.35z', fillRule: 'evenodd' })
	  );
	}
	
	Truck.propTypes = _bcPropTypes.iconShape;

/***/ },
/* 1308 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Truck = __webpack_require__(1307);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Truck).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1309 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	var Unlock = function Unlock(_ref) {
	  var color = _ref.color,
	      className = _ref.className,
	      width = _ref.width,
	      height = _ref.height,
	      title = _ref.title;
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-unlock ' + className, preserveAspectRatio: 'xMinYMin meet', width: width, height: height, viewBox: '0 0 16 16' },
	    _react2.default.createElement(
	      'title',
	      null,
	      title
	    ),
	    _react2.default.createElement('path', { fill: color, className: 'path1', d: 'M12 1c1.654 0 3 1.346 3 3v3h-2v-3c0-0.551-0.449-1-1-1h-2c-0.551 0-1 0.449-1 1v3h0.25c0.412 0 0.75 0.338 0.75 0.75v7.5c0 0.412-0.338 0.75-0.75 0.75h-8.5c-0.412 0-0.75-0.338-0.75-0.75v-7.5c0-0.412 0.338-0.75 0.75-0.75h6.25v-3c0-1.654 1.346-3 3-3h2z' })
	  );
	};
	
	Unlock.propTypes = _bcPropTypes.iconShape;
	
	exports.default = Unlock;

/***/ },
/* 1310 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Unlock = __webpack_require__(1309);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Unlock).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1311 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable max-len */
	
	var Video = function (_BcReactComponent) {
	  _inherits(Video, _BcReactComponent);
	
	  function Video() {
	    _classCallCheck(this, Video);
	
	    return _possibleConstructorReturn(this, (Video.__proto__ || Object.getPrototypeOf(Video)).apply(this, arguments));
	  }
	
	  _createClass(Video, [{
	    key: 'render',
	    value: function render() {
	      var className = this.props.className;
	
	      return _react2.default.createElement(
	        'svg',
	        { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-video ' + className, preserveAspectRatio: 'xMinYMin meet', viewBox: '0 0 16 16' },
	        _react2.default.createElement('path', { className: 'path1', d: 'M15.294 4.004c-0.165 0-0.335 0.058-0.491 0.168l-2.803 1.978v-1.651c0-0.825-0.675-1.5-1.5-1.5h-9c-0.825 0-1.5 0.675-1.5 1.5v7c0 0.825 0.675 1.5 1.5 1.5h9c0.825 0 1.5-0.675 1.5-1.5v-1.65l2.803 1.978c0.156 0.11 0.326 0.168 0.491 0.168 0 0 0 0 0 0 0.22 0 0.421-0.101 0.551-0.278 0.101-0.137 0.154-0.313 0.154-0.51v-6.415c-0-0.518-0.355-0.788-0.706-0.788z' })
	      );
	    }
	  }]);
	
	  return Video;
	}(_baseBcReactComponent2.default);
	
	Video.propTypes = {
	  className: _react.PropTypes.string
	};
	
	exports.default = Video;

/***/ },
/* 1312 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Video = __webpack_require__(1311);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Video).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1313 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	
	var VideoCamera = function VideoCamera(_ref) {
	  var className = _ref.className,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 26 : _ref$height,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 26 : _ref$width;
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-video-camera ' + className, preserveAspectRatio: 'xMinYMin meet', width: width, height: height, viewBox: '0 0 26 26' },
	    _react2.default.createElement('path', { fill: color, fillRule: 'evenodd', d: 'M26,5.53571429 L26,21.3214286 C26,21.6986607 25.7678571,22.0323661 25.4341518,22.1774554 C25.3180804,22.2209821 25.1875,22.25 25.0714286,22.25 C24.8247768,22.25 24.5926339,22.1629464 24.4185268,21.9743304 L18.5714286,16.1272321 L18.5714286,18.5357143 C18.5714286,20.8426339 16.6997768,22.7142857 14.3928571,22.7142857 L4.17857143,22.7142857 C1.87165179,22.7142857 0,20.8426339 0,18.5357143 L0,8.32142857 C0,6.01450893 1.87165179,4.14285714 4.17857143,4.14285714 L14.3928571,4.14285714 C16.6997768,4.14285714 18.5714286,6.01450893 18.5714286,8.32142857 L18.5714286,10.7154018 L24.4185268,4.8828125 C24.5926339,4.69419643 24.8247768,4.60714286 25.0714286,4.60714286 C25.1875,4.60714286 25.3180804,4.63616071 25.4341518,4.6796875 C25.7678571,4.82477679 26,5.15848214 26,5.53571429 Z' })
	  );
	};
	
	VideoCamera.propTypes = _bcPropTypes.iconShape;
	
	exports.default = VideoCamera;

/***/ },
/* 1314 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _VideoCamera = __webpack_require__(1313);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_VideoCamera).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1315 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Warning = function (_BcReactComponent) {
	  _inherits(Warning, _BcReactComponent);
	
	  function Warning() {
	    _classCallCheck(this, Warning);
	
	    return _possibleConstructorReturn(this, (Warning.__proto__ || Object.getPrototypeOf(Warning)).apply(this, arguments));
	  }
	
	  _createClass(Warning, [{
	    key: 'render',
	    value: function render() {
	      var className = this.props.className;
	
	      return _react2.default.createElement(
	        'svg',
	        { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-warning ' + className, preserveAspectRatio: 'xMinYMin meet', viewBox: '0 0 16 16' },
	        _react2.default.createElement('path', { className: 'path1', d: 'M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM9 13h-2v-2h2v2zM9 9h-2v-6h2v6z' })
	      );
	    }
	  }]);
	
	  return Warning;
	}(_baseBcReactComponent2.default);
	
	Warning.propTypes = {
	  className: _react.PropTypes.string
	};
	
	exports.default = Warning;

/***/ },
/* 1316 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Warning = __webpack_require__(1315);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Warning).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1317 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InlineOverlayBody = function InlineOverlayBody(_ref) {
	  var children = _ref.children,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className;
	  return _react2.default.createElement(
	    'div',
	    { className: 'content-body ' + className },
	    children
	  );
	};
	
	InlineOverlayBody.displayName = 'InlineOverlayBody';
	InlineOverlayBody.propTypes = {
	  children: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.arrayOf(_react2.default.PropTypes.node), _react2.default.PropTypes.node]).isRequired,
	  className: _react2.default.PropTypes.string
	};
	
	exports.default = InlineOverlayBody;

/***/ },
/* 1318 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _InlineOverlayBody = __webpack_require__(1317);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_InlineOverlayBody).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1319 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InlineOverlayCloseButton = function (_BcReactComponent) {
	  _inherits(InlineOverlayCloseButton, _BcReactComponent);
	
	  function InlineOverlayCloseButton(props, context) {
	    _classCallCheck(this, InlineOverlayCloseButton);
	
	    var _this = _possibleConstructorReturn(this, (InlineOverlayCloseButton.__proto__ || Object.getPrototypeOf(InlineOverlayCloseButton)).call(this, props, context));
	
	    _this.bindAll('handleClose');
	    return _this;
	  }
	
	  _createClass(InlineOverlayCloseButton, [{
	    key: 'handleClose',
	    value: function handleClose(e) {
	      e.preventDefault();
	
	      if (this.props.handleClose) {
	        this.props.handleClose();
	      }
	
	      if (this.context.handleClose) {
	        this.context.handleClose();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'a',
	        { href: '#close-inline-overlay', className: this.props.className, onClick: this.handleClose },
	        this.props.children
	      );
	    }
	  }]);
	
	  return InlineOverlayCloseButton;
	}(_baseBcReactComponent2.default);
	
	InlineOverlayCloseButton.propTypes = {
	  handleClose: _react.PropTypes.func,
	  children: _react.PropTypes.oneOfType([_react2.default.PropTypes.arrayOf(_react2.default.PropTypes.node), _react2.default.PropTypes.node]).isRequired,
	  className: _react.PropTypes.string
	};
	
	InlineOverlayCloseButton.contextTypes = {
	  handleClose: _react.PropTypes.func
	};
	
	InlineOverlayCloseButton.displayName = 'InlineOverlayCloseButton';
	
	exports.default = InlineOverlayCloseButton;

/***/ },
/* 1320 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InlineOverlayFooter = function InlineOverlayFooter(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    'div',
	    { className: 'content-footer clearfix' },
	    children
	  );
	};
	
	InlineOverlayFooter.displayName = 'InlineOverlayFooter';
	InlineOverlayFooter.propTypes = {
	  children: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.arrayOf(_react2.default.PropTypes.node), _react2.default.PropTypes.node]).isRequired
	};
	
	exports.default = InlineOverlayFooter;

/***/ },
/* 1321 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _InlineOverlayFooter = __webpack_require__(1320);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_InlineOverlayFooter).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1322 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	var _inlineOverlayCloseButton = __webpack_require__(521);
	
	var _inlineOverlayCloseButton2 = _interopRequireDefault(_inlineOverlayCloseButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InlineOverlayHeader = function InlineOverlayHeader(_ref) {
	  var title = _ref.title,
	      children = _ref.children;
	  return _react2.default.createElement(
	    'div',
	    { className: 'content-header' },
	    _react2.default.createElement(
	      _inlineOverlayCloseButton2.default,
	      { className: 'close-top-right' },
	      _react2.default.createElement(
	        'span',
	        { 'aria-hidden': 'true' },
	        '\xD7'
	      ),
	      _react2.default.createElement(
	        _baseScreenReaderMessage2.default,
	        null,
	        'Close'
	      )
	    ),
	    title || children ? _react2.default.createElement(
	      'h4',
	      { className: 'content-title' },
	      title || children
	    ) : null
	  );
	};
	
	InlineOverlayHeader.propTypes = {
	  title: _react.PropTypes.string,
	  children: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.arrayOf(_react2.default.PropTypes.node), _react2.default.PropTypes.node])
	};
	
	InlineOverlayHeader.displayName = 'InlineOverlayHeader';
	
	exports.default = InlineOverlayHeader;

/***/ },
/* 1323 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _InlineOverlayHeader = __webpack_require__(1322);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_InlineOverlayHeader).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1324 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InlineOverlay = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseAccessibilityManageFocus = __webpack_require__(227);
	
	var _baseAccessibilityManageFocus2 = _interopRequireDefault(_baseAccessibilityManageFocus);
	
	__webpack_require__(2687);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InlineOverlay = exports.InlineOverlay = function (_BcReactComponent) {
	  _inherits(InlineOverlay, _BcReactComponent);
	
	  function InlineOverlay() {
	    _classCallCheck(this, InlineOverlay);
	
	    return _possibleConstructorReturn(this, (InlineOverlay.__proto__ || Object.getPrototypeOf(InlineOverlay)).apply(this, arguments));
	  }
	
	  _createClass(InlineOverlay, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        handleClose: this.props.handleClose
	      };
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.captureFocus(this._element, false);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.restoreFocus();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          className = _props.className,
	          children = _props.children,
	          restProps = _objectWithoutProperties(_props, ['className', 'children']);
	
	      delete restProps.handleClose;
	
	      return _react2.default.createElement(
	        'div',
	        _extends({ className: (0, _classnames2.default)('cp-inline-overlay', className), ref: function ref(el) {
	            _this2._element = el;
	          } }, restProps),
	        children
	      );
	    }
	  }]);
	
	  return InlineOverlay;
	}(_baseBcReactComponent2.default);
	
	InlineOverlay.propTypes = {
	  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node]).isRequired,
	  className: _react.PropTypes.string,
	  handleClose: _react.PropTypes.func.isRequired
	};
	
	InlineOverlay.childContextTypes = {
	  handleClose: _react.PropTypes.func.isRequired
	};
	
	InlineOverlay.displayName = 'InlineOverlay';
	
	exports.default = (0, _baseAccessibilityManageFocus2.default)(InlineOverlay);

/***/ },
/* 1325 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _InlineOverlay = __webpack_require__(1324);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_InlineOverlay).default;
	  }
	});
	Object.defineProperty(exports, 'InlineOverlay', {
	  enumerable: true,
	  get: function get() {
	    return _InlineOverlay.InlineOverlay;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1326 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InlineTextArea = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseButtons = __webpack_require__(12);
	
	var _baseIcons = __webpack_require__(10);
	
	var _baseAccessibilityTextArea = __webpack_require__(117);
	
	var _baseAccessibilityTextArea2 = _interopRequireDefault(_baseAccessibilityTextArea);
	
	__webpack_require__(2688);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InlineTextArea = exports.InlineTextArea = function (_BcReactComponent) {
	  _inherits(InlineTextArea, _BcReactComponent);
	
	  function InlineTextArea(props) {
	    _classCallCheck(this, InlineTextArea);
	
	    var _this = _possibleConstructorReturn(this, (InlineTextArea.__proto__ || Object.getPrototypeOf(InlineTextArea)).call(this, props));
	
	    _this.state = {
	      editMode: false
	    };
	    _this.bindAll('handleBlur', 'handleClick', 'handleButtonFocus', 'renderValue');
	    return _this;
	  }
	
	  _createClass(InlineTextArea, [{
	    key: 'handleBlur',
	    value: function handleBlur() {
	      this.setState({ editMode: false });
	    }
	  }, {
	    key: 'handleButtonFocus',
	    value: function handleButtonFocus() {
	      if (this.props.openOnFocus) {
	        this.setState({ editMode: true });
	      }
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick() {
	      this.setState({ editMode: true });
	    }
	  }, {
	    key: 'renderValue',
	    value: function renderValue() {
	      if (this.props.value) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'text-area-value' },
	          this.props.children,
	          _react2.default.createElement(
	            _baseButtons.TextButton,
	            {
	              className: 'edit-button',
	              handleClick: this.handleClick,
	              onFocus: this.handleButtonFocus,
	              'data-test-id': this.props.buttonTestId,
	              'aria-label': this.props.intl.formatMessage({ id: 'button_edit' }) },
	            _react2.default.createElement(_baseIcons.Pencil, null),
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_edit' })
	          )
	        );
	      }
	      return _react2.default.createElement(
	        _baseButtons.TextButton,
	        {
	          handleClick: this.handleClick,
	          onFocus: this.handleButtonFocus,
	          className: 'prompt',
	          'aria-label': this.props.intl.formatMessage({ id: 'button_edit' }),
	          'data-test-id': this.props.buttonTestId },
	        _react2.default.createElement(_baseIcons.Pencil, null),
	        _react2.default.createElement(
	          'span',
	          null,
	          this.props.prompt
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var extraClasses = this.props.highlightOnHover ? 'highlight-on-hover' : '';
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-inline-text-area ' + extraClasses },
	        this.state.editMode ? _react2.default.createElement(_baseAccessibilityTextArea2.default, {
	          setFocus: true,
	          id: this.props.id,
	          value: this.props.value,
	          suggestedMaxLength: this.props.suggestedMaxLength,
	          maxLength: this.props.maxLength,
	          handleBlur: this.handleBlur,
	          className: this.props.customClass,
	          handleChange: this.props.handleChange,
	          errorKey: 'InlineTextArea',
	          labelledById: this.props.labelledById,
	          describedById: this.props.describedById,
	          testId: this.props.inputTestId,
	          fitToText: this.props.fitToText }) : this.renderValue()
	      );
	    }
	  }]);
	
	  return InlineTextArea;
	}(_baseBcReactComponent2.default);
	
	InlineTextArea.propTypes = {
	  id: _react.PropTypes.string,
	  value: _react.PropTypes.string,
	  handleChange: _react.PropTypes.func,
	  prompt: _react.PropTypes.string,
	  maxLength: _react.PropTypes.number,
	  suggestedMaxLength: _react.PropTypes.number,
	  customClass: _react.PropTypes.string,
	  fitToText: _react.PropTypes.bool,
	  labelledById: _react.PropTypes.string.isRequired,
	  describedById: _react.PropTypes.string,
	  openOnFocus: _react.PropTypes.bool,
	  highlightOnHover: _react.PropTypes.bool,
	  buttonTestId: _react.PropTypes.string,
	  inputTestId: _react.PropTypes.string,
	  intl: _reactIntl.intlShape
	};
	
	InlineTextArea.defaultProps = {
	  openOnFocus: true,
	  highlightOnHover: false
	};
	
	exports.default = (0, _reactIntl.injectIntl)(InlineTextArea);

/***/ },
/* 1327 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _InlineTextArea = __webpack_require__(1326);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_InlineTextArea).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1328 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	var _baseIcons = __webpack_require__(10);
	
	var _baseButtons = __webpack_require__(12);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var JacketViewButton = function JacketViewButton(_ref) {
	  var currentView = _ref.currentView,
	      toggleListView = _ref.toggleListView,
	      className = _ref.className;
	
	  var isActive = currentView === 'medium' ? 'active' : '';
	  var toggleView = function toggleView() {
	    return toggleListView('medium');
	  };
	
	  var btnClasses = (0, _classnames2.default)(className, { active: currentView === 'medium' });
	
	  return _react2.default.createElement(
	    _reactIntl.FormattedMessage,
	    { id: 'jacket_view', values: { isActive: isActive ? 'yes' : 'no' } },
	    function (message) {
	      return _react2.default.createElement(
	        _baseButtons.DefaultButton,
	        { 'data-test-id': 'jacket-view-button', flat: true, className: btnClasses, handleClick: toggleView, title: message },
	        _react2.default.createElement(_baseIcons.JacketView, null),
	        _react2.default.createElement(
	          _baseScreenReaderMessage2.default,
	          null,
	          message
	        )
	      );
	    }
	  );
	};
	
	JacketViewButton.propTypes = {
	  className: _react.PropTypes.string,
	  currentView: _react.PropTypes.string.isRequired,
	  toggleListView: _react.PropTypes.func.isRequired
	};
	
	exports.default = JacketViewButton;

/***/ },
/* 1329 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _JacketViewButton = __webpack_require__(1328);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_JacketViewButton).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1330 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	var _baseIcons = __webpack_require__(10);
	
	var _baseButtons = __webpack_require__(12);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListViewButton = function ListViewButton(_ref) {
	  var currentView = _ref.currentView,
	      toggleListView = _ref.toggleListView,
	      className = _ref.className;
	
	  var isActive = currentView === 'small' ? 'active' : '';
	  var toggleView = function toggleView() {
	    return toggleListView('small');
	  };
	
	  var btnClasses = (0, _classnames2.default)(className, { active: currentView === 'small' });
	
	  return _react2.default.createElement(
	    _reactIntl.FormattedMessage,
	    { id: 'list_view', values: { isActive: isActive ? 'yes' : 'no' } },
	    function (message) {
	      return _react2.default.createElement(
	        _baseButtons.DefaultButton,
	        { 'data-test-id': 'list-view-button', flat: true, className: btnClasses, handleClick: toggleView, title: message },
	        _react2.default.createElement(_baseIcons.ListView, null),
	        _react2.default.createElement(
	          _baseScreenReaderMessage2.default,
	          null,
	          message
	        )
	      );
	    }
	  );
	};
	
	ListViewButton.propTypes = {
	  className: _react.PropTypes.string,
	  currentView: _react.PropTypes.string.isRequired,
	  toggleListView: _react.PropTypes.func.isRequired
	};
	
	exports.default = ListViewButton;

/***/ },
/* 1331 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ListViewButton = __webpack_require__(1330);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ListViewButton).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1332 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	__webpack_require__(2689);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Loader = function (_BcReactComponent) {
	  _inherits(Loader, _BcReactComponent);
	
	  function Loader() {
	    _classCallCheck(this, Loader);
	
	    return _possibleConstructorReturn(this, (Loader.__proto__ || Object.getPrototypeOf(Loader)).apply(this, arguments));
	  }
	
	  _createClass(Loader, [{
	    key: 'renderMessage',
	    value: function renderMessage() {
	      if (this.props.message) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'loader-message' },
	          this.props.message
	        );
	      }
	
	      return _react2.default.createElement('noop', null);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-loader' },
	        this.renderMessage(),
	        _react2.default.createElement('img', { src: Loader.getSource(), alt: 'Loading' })
	      );
	    }
	  }], [{
	    key: 'getSource',
	    value: function getSource() {
	      // eslint-disable-next-line global-require
	      return __webpack_require__(3457);
	    }
	  }]);
	
	  return Loader;
	}(_baseBcReactComponent2.default);
	
	Loader.propTypes = {
	  message: _react2.default.PropTypes.node
	};
	
	exports.default = Loader;

/***/ },
/* 1333 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	__webpack_require__(2690);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MobileDropdownMenu = function (_BcReactComponent) {
	  _inherits(MobileDropdownMenu, _BcReactComponent);
	
	  function MobileDropdownMenu(props) {
	    _classCallCheck(this, MobileDropdownMenu);
	
	    var _this = _possibleConstructorReturn(this, (MobileDropdownMenu.__proto__ || Object.getPrototypeOf(MobileDropdownMenu)).call(this, props));
	
	    _this.bindAll('handleSelectChange');
	    return _this;
	  }
	
	  _createClass(MobileDropdownMenu, [{
	    key: 'handleSelectChange',
	    value: function handleSelectChange(e) {
	      var index = e.target.selectedIndex;
	      var option = _immutable2.default.Iterable.isIterable(this.props.options) ? this.props.options.get(index) : this.props.options[index];
	      this.props.handleSelect(option);
	    }
	  }, {
	    key: 'isOptionSelected',
	    value: function isOptionSelected(item) {
	      return item === this.props.selected ? 'selected' : '';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'select',
	        { className: 'cp-mobile-dropdown-menu', onChange: this.handleSelectChange },
	        this.props.options.map(function (item) {
	          return _react2.default.createElement(
	            'option',
	            { selected: _this2.isOptionSelected(item.label), key: item.key },
	            item.label
	          );
	        })
	      );
	    }
	  }]);
	
	  return MobileDropdownMenu;
	}(_baseBcReactComponent2.default);
	
	MobileDropdownMenu.propTypes = {
	  handleSelect: _react2.default.PropTypes.func.isRequired,
	  options: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.shape({
	    key: _react2.default.PropTypes.string,
	    label: _react2.default.PropTypes.string,
	    value: _react2.default.PropTypes.string
	  })),
	  selected: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.string])
	};
	
	exports.default = MobileDropdownMenu;

/***/ },
/* 1334 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _MobileDropdownMenu = __webpack_require__(1333);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MobileDropdownMenu).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1335 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _pinchHandler = __webpack_require__(522);
	
	var _pinchHandler2 = _interopRequireDefault(_pinchHandler);
	
	__webpack_require__(2691);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PanZoom = function (_BcReactComponent) {
	  _inherits(PanZoom, _BcReactComponent);
	
	  function PanZoom(props) {
	    _classCallCheck(this, PanZoom);
	
	    var _this = _possibleConstructorReturn(this, (PanZoom.__proto__ || Object.getPrototypeOf(PanZoom)).call(this, props));
	
	    _this.bindAll('handleUpdate');
	    return _this;
	  }
	
	  _createClass(PanZoom, [{
	    key: 'handleUpdate',
	    value: function handleUpdate(obj) {
	      this.props.handleUpdate(obj);
	    }
	  }, {
	    key: 'getContentStyles',
	    value: function getContentStyles() {
	      var _props = this.props,
	          scale = _props.scale,
	          x = _props.x,
	          y = _props.y;
	
	      return {
	        transform: 'scale(' + scale + ') translateY(' + y + 'px) translateX(' + x + 'px)'
	      };
	    }
	  }, {
	    key: 'getContainerStyles',
	    value: function getContainerStyles() {
	      var _props2 = this.props,
	          backgroundColor = _props2.backgroundColor,
	          height = _props2.height,
	          width = _props2.width;
	
	      var ratio = height / width * 100;
	      return {
	        paddingTop: ratio.toFixed(2) + '%',
	        backgroundColor: backgroundColor
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          children = _props3.children,
	          className = _props3.className,
	          props = _objectWithoutProperties(_props3, ['children', 'className']);
	
	      return _react2.default.createElement(
	        _pinchHandler2.default,
	        _extends({}, props, { onUpdate: this.handleUpdate }),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('cp-pan-zoom', className), tabIndex: '0' },
	          _react2.default.createElement(
	            'div',
	            { className: 'pan-zoom-container', style: this.getContainerStyles() },
	            _react2.default.createElement(
	              'div',
	              { className: 'pan-zoom-inner' },
	              _react2.default.createElement(
	                'div',
	                { className: 'pan-zoom-content', style: this.getContentStyles() },
	                children
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return PanZoom;
	}(_baseBcReactComponent2.default);
	
	exports.default = PanZoom;
	
	
	PanZoom.propTypes = {
	  backgroundColor: _react.PropTypes.string,
	  handleUpdate: _react.PropTypes.func.isRequired,
	  onPinchStart: _react.PropTypes.func,
	  onPinchStop: _react.PropTypes.func,
	  initialScale: _react.PropTypes.number,
	  scale: _react.PropTypes.number.isRequired,
	  height: _react.PropTypes.number.isRequired,
	  width: _react.PropTypes.number.isRequired,
	  x: _react.PropTypes.number.isRequired,
	  y: _react.PropTypes.number.isRequired
	};
	
	PanZoom.defaultProps = {
	  backgroundColor: '#fff'
	};

/***/ },
/* 1336 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PanZoom = __webpack_require__(1335);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PanZoom).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1337 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rxjs = __webpack_require__(169);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _utilsMath = __webpack_require__(1564);
	
	var _utilsEvent = __webpack_require__(1562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MIN_SCALE = 1;
	
	function isZoomed(scale) {
	  return scale > 1;
	}
	
	/**
	 *
	 * Usage:
	 *    <PinchHandler scale={1} x={0} y={0} onUpdate={({ x y, scale }) => this.setState({ x, y, scale })}>
	 *      <img src="" style={{}} />
	 *    </PinchHandler>
	 */
	
	var PinchHandler = function (_BcReactComponent) {
	  _inherits(PinchHandler, _BcReactComponent);
	
	  function PinchHandler(props) {
	    _classCallCheck(this, PinchHandler);
	
	    var _this = _possibleConstructorReturn(this, (PinchHandler.__proto__ || Object.getPrototypeOf(PinchHandler)).call(this, props));
	
	    _this.state = {
	      isPinching: false,
	      isPanning: false
	    };
	    return _this;
	  }
	
	  _createClass(PinchHandler, [{
	    key: 'resize',
	    value: function resize() {
	      if (this._root) {
	        var domNode = this._root;
	        this.setState({
	          size: {
	            width: domNode.offsetWidth,
	            height: domNode.offsetHeight
	          }
	        });
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.handlePinch();
	      this.handlePanWithKeyboard();
	      this.handleWheel();
	      this.resize();
	      this.resize$ = _rxjs.Observable.fromEvent(window, 'resize').throttleTime(500).subscribe(this.resize);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var _this2 = this;
	
	      var observables = ['pinch', 'resize', 'wheel', 'keyboard'];
	
	      observables.forEach(function (observableName) {
	        var obsv$ = _this2[observableName + '$'];
	        if (obsv$) {
	          obsv$.unsubscribe();
	          _this2[observableName + '$'] = null;
	        }
	      });
	
	      this._root = null;
	    }
	  }, {
	    key: 'handleWheel',
	    value: function handleWheel() {
	      var _this3 = this;
	
	      var domNode = this._root;
	      var wheel$ = _rxjs.Observable.fromEvent(domNode, 'wheel').map(function (e) {
	        var _props = _this3.props,
	            scale = _props.scale,
	            maxScale = _props.maxScale;
	
	
	        if (e.ctrlKey) {
	          e.preventDefault();
	          var mod = Math.exp(-e.deltaY / 100);
	
	          return (0, _utilsMath.between)(MIN_SCALE, maxScale, mod * scale);
	        }
	
	        return scale;
	      });
	
	      this.wheel$ = wheel$.subscribe(function (newScale) {
	        var _props2 = _this3.props,
	            scale = _props2.scale,
	            x = _props2.x,
	            y = _props2.y,
	            onUpdate = _props2.onUpdate;
	
	        if (scale !== newScale) {
	          onUpdate({
	            scale: newScale,
	            x: scale === MIN_SCALE ? 0 : x,
	            y: scale === MIN_SCALE ? 0 : y
	          });
	        }
	      });
	    }
	  }, {
	    key: 'handlePanWithKeyboard',
	    value: function handlePanWithKeyboard() {
	      var _this4 = this;
	
	      var domNode = this._root;
	      var keydown$ = _rxjs.Observable.fromEvent(domNode, 'keydown').filter(_utilsEvent.isArrowKey).map(function (e) {
	        e.preventDefault();
	
	        var _props3 = _this4.props,
	            scale = _props3.scale,
	            x = _props3.x,
	            y = _props3.y;
	        var size = _this4.state.size;
	
	        var movement = (0, _utilsEvent.getKeyCodeMovement)(e).map(function (val) {
	          return val * 25;
	        });
	
	        var _movement = _slicedToArray(movement, 2),
	            xDelta = _movement[0],
	            yDelta = _movement[1];
	
	        var scaleFactorX = (size.width * scale - size.width) / (scale * 2);
	        var scaleFactorY = (size.height * scale - size.height) / (scale * 2);
	        return {
	          x: (0, _utilsMath.between)((0, _utilsMath.inverse)(scaleFactorX), scaleFactorX, x + xDelta),
	          y: (0, _utilsMath.between)((0, _utilsMath.inverse)(scaleFactorY), scaleFactorY, y + yDelta),
	          scale: scale
	        };
	      });
	
	      this.keyboard$ = keydown$.subscribe(this.props.onUpdate);
	    }
	  }, {
	    key: 'handlePinch',
	    value: function handlePinch() {
	      var _this5 = this;
	
	      var domNode = this._root;
	      var touchStart = _rxjs.Observable.merge(_rxjs.Observable.fromEvent(domNode, 'touchstart'), _rxjs.Observable.fromEvent(domNode, 'mousedown'));
	      var touchMove = _rxjs.Observable.merge(_rxjs.Observable.fromEvent(document, 'touchmove'), _rxjs.Observable.fromEvent(document, 'mousemove'));
	      var touchEnd = _rxjs.Observable.merge(_rxjs.Observable.fromEvent(document, 'touchend'), _rxjs.Observable.fromEvent(document, 'mouseup'));
	
	      var translatePos = function translatePos(point, size) {
	        return {
	          x: point.x - size.width / 2,
	          y: point.y - size.height / 2
	        };
	      };
	
	      var pinch$ = touchStart.do(function (event) {
	        var scale = _this5.props.scale;
	        if ((0, _utilsEvent.hasTwoTouchPoints)(event) || isZoomed(scale)) {
	          event.preventDefault();
	        }
	      }).mergeMap(function (md) {
	        var startPoint = (0, _utilsEvent.normalizeTouch)(md);
	        var size = _this5.state.size;
	
	
	        return touchMove.map(function (mm) {
	          var _props4 = _this5.props,
	              scale = _props4.scale,
	              x = _props4.x,
	              y = _props4.y,
	              maxScale = _props4.maxScale;
	
	          var movePoint = (0, _utilsEvent.normalizeTouch)(mm);
	
	          if ((0, _utilsEvent.hasTwoTouchPoints)(mm)) {
	            var scaleFactor = 0;
	            if ((0, _utilsEvent.isTouchEvent)(mm) && mm.scale) {
	              scaleFactor = mm.scale;
	            } else if (movePoint.x < size.width / 2) {
	              scaleFactor = scale + (translatePos(startPoint, size).x - translatePos(movePoint, size).x) / size.width;
	            } else {
	              scaleFactor = scale + (translatePos(movePoint, size).x - translatePos(startPoint, size).x) / size.width;
	            }
	
	            var nextScale = (0, _utilsMath.between)(1, maxScale, scaleFactor);
	            return {
	              scale: nextScale,
	              x: nextScale < 1.01 ? 0 : x,
	              y: nextScale < 1.01 ? 0 : y
	            };
	          }
	
	          var scaleFactorX = (size.width * scale - size.width) / (maxScale * 2);
	          var scaleFactorY = (size.height * scale - size.height) / (maxScale * 2);
	          return {
	            x: (0, _utilsMath.between)((0, _utilsMath.inverse)(scaleFactorX), scaleFactorX, movePoint.x - startPoint.x),
	            y: (0, _utilsMath.between)((0, _utilsMath.inverse)(scaleFactorY), scaleFactorY, movePoint.y - startPoint.y)
	          };
	        }).takeUntil(touchEnd);
	      });
	
	      this.pinch$ = pinch$.subscribe(function (newObject) {
	        if (_this5.props.scale !== newObject.scale) {
	          _this5.refreshPinchTimeoutTimer();
	        }
	        window.requestAnimationFrame(function () {
	          _this5.props.onUpdate(_extends({
	            x: _this5.props.x,
	            y: _this5.props.y,
	            scale: _this5.props.scale
	          }, newObject));
	        });
	      });
	    }
	  }, {
	    key: 'refreshPinchTimeoutTimer',
	    value: function refreshPinchTimeoutTimer() {
	      var _this6 = this;
	
	      if (this.pinchTimeoutTimer) {
	        clearTimeout(this.pinchTimeoutTimer);
	      }
	
	      if (!this.state.isPinching) {
	        this.pinchStarted();
	      }
	
	      this.pinchTimeoutTimer = setTimeout(function () {
	        return _this6.pinchStopped();
	      }, 500);
	    }
	  }, {
	    key: 'pinchStarted',
	    value: function pinchStarted() {
	      this.setState({
	        isPinching: true
	      }, this.props.onPinchStart);
	    }
	  }, {
	    key: 'pinchStopped',
	    value: function pinchStopped() {
	      this.setState({
	        isPinching: false
	      }, this.props.onPinchStop);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this7 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { ref: function ref(el) {
	            _this7._root = el;
	          } },
	        this.props.children
	      );
	    }
	  }]);
	
	  return PinchHandler;
	}(_baseBcReactComponent2.default);
	
	exports.default = PinchHandler;
	
	
	PinchHandler.defaultProps = {
	  scale: 1,
	  maxScale: 2,
	  x: 0,
	  y: 0,
	  onPinchStart: function onPinchStart(f) {
	    return f;
	  },
	  onPinchStop: function onPinchStop(f) {
	    return f;
	  }
	};
	
	PinchHandler.propTypes = {
	  onPinchStart: _react.PropTypes.func,
	  onPinchStop: _react.PropTypes.func,
	  initialScale: _react.PropTypes.number,
	  scale: _react.PropTypes.number,
	  x: _react.PropTypes.number,
	  y: _react.PropTypes.number
	};

/***/ },
/* 1338 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _panZoom = __webpack_require__(1336);
	
	Object.defineProperty(exports, 'PanZoom', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_panZoom).default;
	  }
	});
	
	var _pinchHandler = __webpack_require__(522);
	
	Object.defineProperty(exports, 'PinchHandler', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_pinchHandler).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1339 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _utilsAccessibility = __webpack_require__(95);
	
	__webpack_require__(2692);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ESCAPE_KEY = 27;
	
	var PopupManager = function (_BcReactComponent) {
	  _inherits(PopupManager, _BcReactComponent);
	
	  function PopupManager(props) {
	    _classCallCheck(this, PopupManager);
	
	    var _this = _possibleConstructorReturn(this, (PopupManager.__proto__ || Object.getPrototypeOf(PopupManager)).call(this, props));
	
	    _this.state = {
	      expanded: props.initialOpenState
	    };
	
	    _this.triggerRef = null;
	    _this.wrapperRef = null;
	
	    _this.bindAll('setWrapperRef', 'setTriggerRef', 'setPopupRef', 'handleClickOutside', 'handleKeyboardAction', 'toggleContent', 'closeContent', 'openContent', 'focusContent', 'closeAndFocusContent');
	
	    _this.popupActions = {
	      openContent: _this.openContent,
	      closeContent: _this.closeContent,
	      focusContent: _this.focusContent,
	      toggleContent: _this.toggleContent,
	      closeAndFocusContent: _this.closeAndFocusContent
	    };
	    return _this;
	  }
	
	  _createClass(PopupManager, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.state.expanded) {
	        document.addEventListener('click', this.handleClickOutside);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener('click', this.handleClickOutside);
	      document.removeEventListener('keypress', this.handleKeyboardAction);
	    }
	  }, {
	    key: 'closeContent',
	    value: function closeContent() {
	      var _this2 = this;
	
	      var doFocus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      this.setState({ expanded: false }, function () {
	        document.removeEventListener('click', _this2.handleClickOutside);
	        document.removeEventListener('keydown', _this2.handleKeyboardAction);
	        if (doFocus) {
	          _this2.focusContent();
	        }
	      });
	    }
	  }, {
	    key: 'focusContent',
	    value: function focusContent() {
	      var _this3 = this;
	
	      setTimeout(function () {
	        var isActiveElementInPage = !!document.activeElement && document.activeElement !== document.body;
	        if (!isActiveElementInPage) {
	          (0, _utilsAccessibility.setFocusWithinElement)(_this3.triggerRef);
	        }
	      }, 0);
	    }
	  }, {
	    key: 'closeAndFocusContent',
	    value: function closeAndFocusContent() {
	      this.closeContent(true);
	    }
	  }, {
	    key: 'openContent',
	    value: function openContent() {
	      var _this4 = this;
	
	      this.setState({ expanded: true }, function () {
	        document.addEventListener('click', _this4.handleClickOutside);
	        document.addEventListener('keydown', _this4.handleKeyboardAction);
	        (0, _utilsAccessibility.setFocusWithinElement)(_this4.popupRef);
	      });
	    }
	  }, {
	    key: 'setWrapperRef',
	    value: function setWrapperRef(node) {
	      this.wrapperRef = node;
	    }
	  }, {
	    key: 'setTriggerRef',
	    value: function setTriggerRef(node) {
	      this.triggerRef = node;
	    }
	  }, {
	    key: 'setPopupRef',
	    value: function setPopupRef(node) {
	      this.popupRef = node;
	    }
	  }, {
	    key: 'toggleContent',
	    value: function toggleContent() {
	      if (this.state.expanded) {
	        this.closeContent();
	      } else {
	        this.openContent();
	      }
	    }
	  }, {
	    key: 'handleClickOutside',
	    value: function handleClickOutside(event) {
	      var wrapper = this.props.closeOnClick ? this.triggerRef : this.wrapperRef;
	      if (wrapper && !wrapper.contains(event.target)) {
	        this.closeAndFocusContent();
	      }
	    }
	  }, {
	    key: 'handleKeyboardAction',
	    value: function handleKeyboardAction(event) {
	      // close on escape
	      if (event.keyCode === ESCAPE_KEY) {
	        this.closeAndFocusContent();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-popup-manager ' + this.props.className, ref: this.setWrapperRef },
	        _react2.default.createElement(
	          'div',
	          { className: 'trigger-wrapper', ref: this.setTriggerRef },
	          this.props.children(this.popupActions, this.state.expanded)
	        ),
	        this.state.expanded ? _react2.default.createElement(
	          'span',
	          { ref: this.setPopupRef },
	          this.props.renderContent(this.popupActions)
	        ) : null
	      );
	    }
	  }]);
	
	  return PopupManager;
	}(_baseBcReactComponent2.default);
	
	PopupManager.propTypes = {
	  renderContent: _react.PropTypes.func.isRequired,
	  initialOpenState: _react.PropTypes.bool,
	  closeOnClick: _react.PropTypes.bool
	};
	
	PopupManager.defaultProps = {
	  initialOpenState: false,
	  closeOnClick: true
	};
	
	exports.default = PopupManager;

/***/ },
/* 1340 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(104);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Taken from react-toolbox
	
	
	function getContainer(container) {
	  var _container = typeof container === 'function' ? container() : container;
	  return _reactDom2.default.findDOMNode(_container) || document.body; // eslint-disable-line react/no-find-dom-node
	}
	
	var Portal = function (_Component) {
	  _inherits(Portal, _Component);
	
	  function Portal() {
	    _classCallCheck(this, Portal);
	
	    return _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
	  }
	
	  _createClass(Portal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._renderOverlay();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this._overlayTarget && nextProps.container !== this.props.container) {
	        this._portalContainerNode.removeChild(this._overlayTarget);
	        this._portalContainerNode = getContainer(nextProps.container);
	        this._portalContainerNode.appendChild(this._overlayTarget);
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this._renderOverlay();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._unrenderOverlay();
	      this._unmountOverlayTarget();
	    }
	  }, {
	    key: '_mountOverlayTarget',
	    value: function _mountOverlayTarget() {
	      if (!this._overlayTarget) {
	        this._overlayTarget = document.createElement('div');
	        this._portalContainerNode = getContainer(this.props.container);
	        this._portalContainerNode.appendChild(this._overlayTarget);
	      }
	    }
	  }, {
	    key: '_unmountOverlayTarget',
	    value: function _unmountOverlayTarget() {
	      if (this._overlayTarget) {
	        this._portalContainerNode.removeChild(this._overlayTarget);
	        this._overlayTarget = null;
	      }
	      this._portalContainerNode = null;
	    }
	  }, {
	    key: '_renderOverlay',
	    value: function _renderOverlay() {
	      var overlay = !this.props.children ? null : _react2.default.Children.only(this.props.children);
	
	      if (overlay !== null) {
	        this._mountOverlayTarget();
	        this._overlayInstance = _reactDom2.default.unstable_renderSubtreeIntoContainer(this, overlay, this._overlayTarget);
	      } else {
	        this._unrenderOverlay();
	        this._unmountOverlayTarget();
	      }
	    }
	  }, {
	    key: '_unrenderOverlay',
	    value: function _unrenderOverlay() {
	      if (this._overlayTarget) {
	        _reactDom2.default.unmountComponentAtNode(this._overlayTarget);
	        this._overlayInstance = null;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return Portal;
	}(_react.Component);
	
	Portal.propTypes = {
	  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react2.default.PropTypes.node), _react.PropTypes.node]).isRequired,
	  container: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.string])
	};
	
	exports.default = Portal;

/***/ },
/* 1341 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Portal = __webpack_require__(1340);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Portal).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1342 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ScreenReaderMessage = function (_BcReactComponent) {
	  _inherits(ScreenReaderMessage, _BcReactComponent);
	
	  function ScreenReaderMessage() {
	    _classCallCheck(this, ScreenReaderMessage);
	
	    return _possibleConstructorReturn(this, (ScreenReaderMessage.__proto__ || Object.getPrototypeOf(ScreenReaderMessage)).apply(this, arguments));
	  }
	
	  _createClass(ScreenReaderMessage, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          id = _props.id,
	          _props$className = _props.className,
	          className = _props$className === undefined ? '' : _props$className,
	          props = _objectWithoutProperties(_props, ['id', 'className']);
	
	      return _react2.default.createElement(
	        'span',
	        _extends({ className: 'sr-only ' + className, id: id }, props),
	        this.props.children
	      );
	    }
	  }]);
	
	  return ScreenReaderMessage;
	}(_baseBcReactComponent2.default);
	
	ScreenReaderMessage.propTypes = {
	  id: _react.PropTypes.string,
	  localeKey: _react.PropTypes.string,
	  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node]).isRequired
	};
	
	exports.default = ScreenReaderMessage;

/***/ },
/* 1343 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(2693);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ScreenReaderShortcuts = function ScreenReaderShortcuts(_ref) {
	  var screenReaderNavigation = _ref.screenReaderNavigation;
	  return _react2.default.createElement(
	    'div',
	    { className: 'cp-screen-reader-shortcuts' },
	    _react2.default.createElement('div', {
	      // eslint-disable-next-line react/no-danger
	      dangerouslySetInnerHTML: { __html: screenReaderNavigation } }),
	    _react2.default.createElement(
	      'a',
	      { href: '#content', className: 'screen_reader_nav' },
	      'Skip to Content'
	    )
	  );
	};
	
	ScreenReaderShortcuts.displayName = 'ScreenReaderShortcuts';
	ScreenReaderShortcuts.propTypes = {
	  screenReaderNavigation: _react.PropTypes.string.isRequired
	};
	
	exports.default = ScreenReaderShortcuts;

/***/ },
/* 1344 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ScreenReaderShortcuts = __webpack_require__(1343);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ScreenReaderShortcuts).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1345 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.StickyToolbar = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(16);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _utilsBrowser = __webpack_require__(59);
	
	__webpack_require__(2694);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StickyToolbar = exports.StickyToolbar = function (_BcReactComponent) {
	  _inherits(StickyToolbar, _BcReactComponent);
	
	  function StickyToolbar(props) {
	    _classCallCheck(this, StickyToolbar);
	
	    var _this = _possibleConstructorReturn(this, (StickyToolbar.__proto__ || Object.getPrototypeOf(StickyToolbar)).call(this, props));
	
	    _this.handleScroll = _lodash2.default.throttle(_this.handleScroll, 50).bind(_this);
	    _this.handleResize = _lodash2.default.throttle(_this.updateOffsets, 50).bind(_this);
	
	    _this.state = {
	      stickToTop: false,
	      initialOffset: 0,
	      toolbarHeight: 0,
	      toolbarWidth: 0,
	      toolbarLeft: 0,
	      toolbarTop: 0
	    };
	    return _this;
	  }
	
	  _createClass(StickyToolbar, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      window.addEventListener('scroll', this.handleScroll);
	      window.addEventListener('resize', this.handleResize);
	
	      setTimeout(function () {
	        _this2.updateOffsets();
	        _this2.handleScroll();
	      }, 0);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('scroll', this.handleScroll);
	    }
	  }, {
	    key: 'shouldStickToTop',
	    value: function shouldStickToTop(toolbarTop) {
	      return (0, _utilsBrowser.getScrollTop)() > this.state.initialOffset - toolbarTop;
	    }
	  }, {
	    key: 'handleScroll',
	    value: function handleScroll() {
	      this.updateOffsets();
	
	      var changes = {};
	
	      changes.toolbarTop = this.props.getOffsetForStickyToolbar ? this.props.getOffsetForStickyToolbar() : 0;
	
	      var shouldStickToTop = this.shouldStickToTop(changes.toolbarTop);
	
	      if (this.state.stickToTop !== shouldStickToTop) {
	        changes.stickToTop = shouldStickToTop;
	      }
	
	      this.setState(changes);
	    }
	  }, {
	    key: 'updateOffsets',
	    value: function updateOffsets() {
	      var _this3 = this;
	
	      var changes = {};
	
	      if (this._toolbarDiv) {
	        changes.initialOffset = this._toolbarDiv.getBoundingClientRect().top + window.pageYOffset - document.documentElement.clientTop;
	        var rect = this._toolbarDiv.getBoundingClientRect();
	        changes.toolbarLeft = rect.left;
	        changes.toolbarWidth = rect.width;
	      }
	
	      this.setState(changes, function () {
	        _this3.updateToolbarHeight();
	      });
	    }
	  }, {
	    key: 'updateToolbarHeight',
	    value: function updateToolbarHeight() {
	      if (this._toolbarContentsWrapper) {
	        this.setState({
	          toolbarHeight: this._toolbarContentsWrapper.clientHeight
	        });
	      }
	    }
	  }, {
	    key: 'getWrapperStyle',
	    value: function getWrapperStyle() {
	      if (this.state.stickToTop) {
	        return {
	          top: this.state.toolbarTop + 'px',
	          left: this.state.toolbarLeft + 'px',
	          width: this.state.toolbarWidth + 'px'
	        };
	      }
	
	      return {};
	    }
	  }, {
	    key: 'renderToolbarPlaceholder',
	    value: function renderToolbarPlaceholder() {
	      // Renders a div with the same height as the toolbar
	      //
	      // This is intended to preserve the vertical position of elements on
	      // the page when the toolbar switches from to the sticky version.
	      if (this.state.stickToTop) {
	        return _react2.default.createElement('div', { style: { height: this.state.toolbarHeight } });
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)('cp-sticky-toolbar', this.props.className),
	          ref: function ref(el) {
	            _this4._toolbarDiv = el;
	          } },
	        _react2.default.createElement(
	          'div',
	          {
	            className: (0, _classnames2.default)('toolbar-contents-wrapper', { sticky: this.state.stickToTop }),
	            style: this.getWrapperStyle(),
	            ref: function ref(el) {
	              return _this4._toolbarContentsWrapper = el;
	            } },
	          this.props.children
	        ),
	        this.renderToolbarPlaceholder()
	      );
	    }
	  }]);
	
	  return StickyToolbar;
	}(_baseBcReactComponent2.default);
	
	StickyToolbar.propTypes = {
	  className: _react.PropTypes.string,
	  getOffsetForStickyToolbar: _react.PropTypes.func,
	  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node]).isRequired
	};
	
	exports.default = StickyToolbar;

/***/ },
/* 1346 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _StickyToolbar = __webpack_require__(1345);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_StickyToolbar).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1347 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Placeholder = function Placeholder(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#000' : _ref$color,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 580 : _ref$width,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 110 : _ref$height;
	  return _react2.default.createElement(
	    'svg',
	    { focusable: 'false', viewBox: '0 0 ' + width + ' ' + height, preserveAspectRatio: 'xMinYMin meet', className: 'icon-svg-table-placeholder pulse responsive', xmlns: 'http://www.w3.org/2000/svg' },
	    _react2.default.createElement('path', { fill: color, d: 'M0 0h580v10H0zm0 20h580v10H0zm0 60h580v10H0zm0 20h580v10H0zm0-60h580v10H0zm0 20h580v10H0z' })
	  );
	};
	
	Placeholder.propTypes = {
	  color: _react.PropTypes.string.isRequired,
	  width: _react.PropTypes.number.isRequired,
	  height: _react.PropTypes.number.isRequired
	};
	
	exports.default = Placeholder;

/***/ },
/* 1348 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Placeholder = __webpack_require__(1347);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Placeholder).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1349 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _tableRow = __webpack_require__(1354);
	
	var _tableRow2 = _interopRequireDefault(_tableRow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TableBody = function (_React$Component) {
	  _inherits(TableBody, _React$Component);
	
	  function TableBody(props) {
	    _classCallCheck(this, TableBody);
	
	    var _this = _possibleConstructorReturn(this, (TableBody.__proto__ || Object.getPrototypeOf(TableBody)).call(this, props));
	
	    _this.renderTableRow = _this.renderTableRow.bind(_this);
	    return _this;
	  }
	
	  _createClass(TableBody, [{
	    key: 'renderTableRow',
	    value: function renderTableRow(row, index) {
	      return _react2.default.createElement(_tableRow2.default, { key: index, row: row, selected: row.get('selected'), fields: this.props.fields, index: index });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'tbody',
	        null,
	        this.props.rows.map(this.renderTableRow)
	      );
	    }
	  }]);
	
	  return TableBody;
	}(_react2.default.Component);
	
	TableBody.propTypes = {
	  rows: _reactImmutableProptypes2.default.list.isRequired,
	  fields: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	    key: _react.PropTypes.string.isRequired,
	    type: _react.PropTypes.string.isRequired,
	    localizationMap: _react.PropTypes.func
	  }).isRequired).isRequired
	};
	
	exports.default = TableBody;

/***/ },
/* 1350 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TableBody = __webpack_require__(1349);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TableBody).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1351 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseButtons = __webpack_require__(12);
	
	var _baseIcons = __webpack_require__(10);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Make item field table headings accessible compliant.
	 */
	function fieldHeadingLabel(key) {
	  return key && key === 'table_headings_item_select' ? _react2.default.createElement(
	    _baseScreenReaderMessage2.default,
	    null,
	    _react2.default.createElement(_reactIntl.FormattedMessage, { id: key })
	  ) : _react2.default.createElement(_reactIntl.FormattedMessage, { id: key });
	}
	
	var TableHeader = function (_BcReactComponent) {
	  _inherits(TableHeader, _BcReactComponent);
	
	  function TableHeader(props) {
	    _classCallCheck(this, TableHeader);
	
	    var _this = _possibleConstructorReturn(this, (TableHeader.__proto__ || Object.getPrototypeOf(TableHeader)).call(this, props));
	
	    _this.bindAll('renderFieldHeading', 'renderSortButton');
	    return _this;
	  }
	
	  _createClass(TableHeader, [{
	    key: 'renderFieldHeading',
	    value: function renderFieldHeading(field) {
	      var key = field.headerKey || field.key;
	      var className = (0, _classnames2.default)(field.type && field.type.toLowerCase(), {
	        'right-align': field.rightAlign
	      });
	
	      return _react2.default.createElement(
	        'th',
	        { scope: 'col', key: key, className: className },
	        this.props.sortable ? this.renderSortButton(key) : fieldHeadingLabel(key)
	      );
	    }
	  }, {
	    key: 'renderSortButton',
	    value: function renderSortButton(key) {
	      var _this2 = this;
	
	      var _props = this.props,
	          sortDirection = _props.sortDirection,
	          currentSortField = _props.currentSortField,
	          intl = _props.intl;
	
	      var currentSortOrder = sortDirection === 'asc' ? _baseIcons.Sort.Up : _baseIcons.Sort.Down;
	      var SortArrows = currentSortField === key ? currentSortOrder : _baseIcons.Sort.SortArrows;
	
	      return _react2.default.createElement(
	        _baseButtons.TextButton,
	        {
	          className: 'table-sort',
	          handleClick: function handleClick() {
	            return _this2.props.changeSortField(key);
	          },
	          'aria-label': intl.formatMessage({ id: 'change_sort_direction' }, { key: intl.formatMessage({ id: key }) }) },
	        fieldHeadingLabel(key),
	        _react2.default.createElement(SortArrows, null)
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var fields = this.props.fields;
	
	      return _react2.default.createElement(
	        'thead',
	        null,
	        _react2.default.createElement(
	          'tr',
	          { className: 'clearfix' },
	          fields.map(this.renderFieldHeading)
	        )
	      );
	    }
	  }]);
	
	  return TableHeader;
	}(_baseBcReactComponent2.default);
	
	TableHeader.propTypes = {
	  fields: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	    key: _react.PropTypes.string.isRequired,
	    headerKey: _react.PropTypes.string,
	    type: _react.PropTypes.string.isRequired,
	    localizationMap: _react.PropTypes.func
	  }).isRequired).isRequired,
	  changeSortField: _react.PropTypes.func.isRequired,
	  sortable: _react.PropTypes.bool,
	  sortDirection: _react.PropTypes.string,
	  currentSortField: _react.PropTypes.string
	};
	
	exports.default = (0, _reactIntl.injectIntl)(TableHeader);

/***/ },
/* 1352 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TableHeader = __webpack_require__(1351);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TableHeader).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1353 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(9);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TableRow = function (_BcReactComponent) {
	  _inherits(TableRow, _BcReactComponent);
	
	  function TableRow(props) {
	    _classCallCheck(this, TableRow);
	
	    var _this = _possibleConstructorReturn(this, (TableRow.__proto__ || Object.getPrototypeOf(TableRow)).call(this, props));
	
	    _this.bindAll('renderFields', 'localizedValue');
	    return _this;
	  }
	
	  _createClass(TableRow, [{
	    key: 'localizedValue',
	    value: function localizedValue(value, field, row) {
	      var _props = this.props,
	          intl = _props.intl,
	          index = _props.index;
	
	
	      if (!value) {
	        return null;
	      }
	
	      switch (field.type) {
	        case 'Date':
	          return intl.formatDate((0, _moment2.default)(value).toDate(), { year: 'numeric', day: 'numeric', month: 'short' });
	        case 'Currency':
	          return '$' + intl.formatNumber(value, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
	        default:
	          if (field.localizationMap) {
	            var localizationKey = field.localizationMap(value);
	            return intl.formatMessage({ id: localizationKey, default: value });
	          }
	          if (field.transformationMap) {
	            return field.transformationMap(value, index, row);
	          }
	          return value;
	      }
	    }
	  }, {
	    key: 'renderFields',
	    value: function renderFields(field, index) {
	      var _props2 = this.props,
	          row = _props2.row,
	          intl = _props2.intl;
	
	      var keys = field.key.split('.');
	      var value = row.getIn(keys);
	      var className = (0, _classnames2.default)(field.type && field.type.toLowerCase(), {
	        'no-wrap': field.noWrap,
	        'right-align': field.rightAlign,
	        'is-left-checkbox': field.leftAlignedCheckbox
	      });
	      return _react2.default.createElement(
	        'td',
	        { key: index, className: className, 'data-label': intl.formatMessage({ id: field.headerKey || field.key, default: field.key }) },
	        _react2.default.createElement(
	          'span',
	          { className: 'cell-value' },
	          this.localizedValue(value, field, row)
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var fields = this.props.fields;
	
	      return _react2.default.createElement(
	        'tr',
	        { className: (this.props.selected ? 'selected-row' : '') + ' clearfix' },
	        fields.map(this.renderFields)
	      );
	    }
	  }]);
	
	  return TableRow;
	}(_baseBcReactComponent2.default);
	
	TableRow.propTypes = {
	  row: _react.PropTypes.object, // eslint-disable-line react/forbid-prop-types
	  fields: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	    key: _react.PropTypes.string.isRequired,
	    type: _react.PropTypes.string.isRequired,
	    localizationMap: _react.PropTypes.func
	  }).isRequired).isRequired,
	  selected: _react.PropTypes.bool,
	  intl: _reactIntl.intlShape
	};
	
	TableRow.defaultProps = {
	  selected: false
	};
	
	exports.default = (0, _reactIntl.injectIntl)(TableRow);

/***/ },
/* 1354 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TableRow = __webpack_require__(1353);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TableRow).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1355 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _reactIntl = __webpack_require__(3);
	
	var _lodash = __webpack_require__(16);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	var _tableBody = __webpack_require__(1350);
	
	var _tableBody2 = _interopRequireDefault(_tableBody);
	
	var _tableHeader = __webpack_require__(1352);
	
	var _tableHeader2 = _interopRequireDefault(_tableHeader);
	
	__webpack_require__(2695);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Table = function (_BcReactComponent) {
	  _inherits(Table, _BcReactComponent);
	
	  function Table(props) {
	    _classCallCheck(this, Table);
	
	    var _this = _possibleConstructorReturn(this, (Table.__proto__ || Object.getPrototypeOf(Table)).call(this, props));
	
	    _this.state = {
	      currentSortField: '',
	      sortDirection: 'asc'
	    };
	    _this.bindAll('trimFields', 'sortRows', 'changeSortField');
	    return _this;
	  }
	
	  _createClass(Table, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {} /* testing goodness */
	
	    /*
	      Field objects can provide their own sort method which will be used for comparison.
	      This method will receive the list of rows, the current sort field, and the current
	      sort direction as parameters, and must return a List of sorted rows.
	    */
	
	  }, {
	    key: 'sortRows',
	    value: function sortRows(fields) {
	      var _props = this.props,
	          rows = _props.rows,
	          sortable = _props.sortable;
	      var _state = this.state,
	          currentSortField = _state.currentSortField,
	          sortDirection = _state.sortDirection;
	
	      var sortFieldObj = _lodash2.default.find(fields, { key: currentSortField });
	
	      if (sortable && currentSortField && _lodash2.default.some(fields, { key: currentSortField })) {
	        if (sortFieldObj.sort) {
	          return sortFieldObj.sort(rows, currentSortField, sortDirection);
	        }
	
	        return Table.defaultSort(rows, currentSortField, sortDirection);
	      }
	
	      return rows;
	    }
	  }, {
	    key: 'trimFields',
	    value: function trimFields() {
	      // return only fields which appear in the data.
	      var _props2 = this.props,
	          fields = _props2.fields,
	          rows = _props2.rows,
	          hideColumnsWithNoData = _props2.hideColumnsWithNoData;
	
	
	      if (hideColumnsWithNoData) {
	        return fields.filter(function (field) {
	          var keys = field.key.split('.');
	          return rows.some(function (val) {
	            return val.getIn(keys);
	          });
	        });
	      }
	
	      return fields;
	    }
	  }, {
	    key: 'changeSortField',
	    value: function changeSortField(sortField) {
	      if (this.state.currentSortField === sortField) {
	        this.setState({ sortDirection: this.state.sortDirection === 'asc' ? 'desc' : 'asc' });
	      } else {
	        this.setState({ currentSortField: sortField });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var fields = this.trimFields();
	      var _props3 = this.props,
	          intl = _props3.intl,
	          stackedOnMobile = _props3.stackedOnMobile,
	          hasLeftAlignedCheckbox = _props3.hasLeftAlignedCheckbox,
	          _props3$className = _props3.className,
	          customClassName = _props3$className === undefined ? 'table-striped' : _props3$className;
	
	      var className = (0, _classnames2.default)('table cp-table', { 'stacked-on-mobile': stackedOnMobile }, customClassName);
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _baseScreenReaderMessage2.default,
	          { 'aria-live': 'polite' },
	          this.state.currentSortField ? _react2.default.createElement(_reactIntl.FormattedMessage, {
	            id: 'table_sorted_by',
	            values: {
	              field: intl.formatMessage({ id: this.state.currentSortField }),
	              direction: intl.formatMessage({ id: this.state.sortDirection })
	            } }) : ''
	        ),
	        _react2.default.createElement(
	          'table',
	          { className: className + ' ' + (hasLeftAlignedCheckbox ? 'has-left-aligned-checkbox' : '') },
	          _react2.default.createElement(
	            'caption',
	            null,
	            this.props.caption
	          ),
	          _react2.default.createElement(_tableHeader2.default, {
	            fields: this.trimFields(),
	            sortable: this.props.sortable,
	            changeSortField: this.changeSortField,
	            sortDirection: this.state.sortDirection,
	            currentSortField: this.state.currentSortField }),
	          _react2.default.createElement(_tableBody2.default, {
	            rows: this.sortRows(fields),
	            fields: fields })
	        )
	      );
	    }
	  }], [{
	    key: 'defaultSort',
	    value: function defaultSort(rows, sortField, sortDirection) {
	      return rows.sort(function (a, b) {
	        var comparator = 0;
	        // Catch if a field is passed in as a reference to a value in an object
	        var normalizedField = sortField.split('.');
	
	        var aValue = a.getIn(normalizedField);
	        var bValue = b.getIn(normalizedField);
	
	        if (aValue && bValue) {
	          if (sortDirection === 'asc') {
	            comparator = aValue < bValue ? -1 : 1;
	          } else {
	            comparator = aValue < bValue ? 1 : -1;
	          }
	        }
	
	        if (aValue && !bValue) {
	          comparator = sortDirection === 'asc' ? 1 : -1;
	        }
	
	        if (!aValue && bValue) {
	          comparator = sortDirection === 'asc' ? -1 : 1;
	        }
	
	        return comparator;
	      });
	    }
	  }]);
	
	  return Table;
	}(_baseBcReactComponent2.default);
	
	Table.propTypes = {
	  rows: _reactImmutableProptypes2.default.list.isRequired,
	  /**
	   * List of columns for the table. Each field takes an optional localizationMap
	   * and sort comparator method.
	   */
	  fields: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	    key: _react.PropTypes.string.isRequired,
	    type: _react.PropTypes.string.isRequired,
	    localizationMap: _react.PropTypes.func,
	    headerKey: _react.PropTypes.string,
	    sort: _react.PropTypes.func,
	    leftAlignedCheckbox: _react.PropTypes.bool,
	    noWrap: _react.PropTypes.bool,
	    rightAlign: _react.PropTypes.bool
	  }).isRequired),
	  caption: _react.PropTypes.string,
	  /**
	   * Adds sorting buttons to the table headers and allows for sorting of rows
	   * by field. Default sort is ascending/descending, and a custom sort can
	   * be added to each field if necessary.
	   */
	  sortable: _react.PropTypes.bool,
	  intl: _reactIntl.intlShape,
	  hideColumnsWithNoData: _react.PropTypes.bool,
	  hasLeftAlignedCheckbox: _react.PropTypes.bool
	};
	
	Table.defaultProps = {
	  rows: [],
	  fields: [],
	  sortable: false,
	  caption: '',
	  stackedOnMobile: true,
	  hideColumnsWithNoData: true
	};
	
	exports.default = (0, _reactIntl.injectIntl)(Table);

/***/ },
/* 1356 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Table = __webpack_require__(1355);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Table).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1357 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TabContent(_ref) {
	  var children = _ref.children;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'tab-pane active' },
	    children
	  );
	}
	
	TabContent.propTypes = {
	  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react2.default.PropTypes.node), _react.PropTypes.node]).isRequired
	};
	
	TabContent.displayName = 'TabContent';
	
	exports.default = TabContent;

/***/ },
/* 1358 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Tabs = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(16);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseAccessibilityManageFocus = __webpack_require__(227);
	
	var _baseAccessibilityManageFocus2 = _interopRequireDefault(_baseAccessibilityManageFocus);
	
	var _tabContent = __webpack_require__(524);
	
	var _tabContent2 = _interopRequireDefault(_tabContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Tabs = exports.Tabs = function (_BcReactComponent) {
	  _inherits(Tabs, _BcReactComponent);
	
	  function Tabs(props) {
	    _classCallCheck(this, Tabs);
	
	    var _this = _possibleConstructorReturn(this, (Tabs.__proto__ || Object.getPrototypeOf(Tabs)).call(this, props));
	
	    _this.state = {
	      activeKey: props.defaultActiveKey,
	      children: _react2.default.Children.toArray(_this.props.children)
	    };
	    _this.bindAll('renderTab', 'renderTabs', 'renderTabContent', 'handleTabClick');
	    return _this;
	  }
	
	  _createClass(Tabs, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.defaultActiveKey !== this.props.defaultActiveKey) {
	        this.setState({ activeKey: nextProps.defaultActiveKey });
	      }
	      if (nextProps.children !== this.props.children) {
	        this.setState({ children: _react2.default.Children.toArray(nextProps.children) });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (prevState.activeKey !== this.state.activeKey) {
	        this.focusOnTabContent();
	      }
	    }
	  }, {
	    key: 'focusOnTabContent',
	    value: function focusOnTabContent() {
	      this.props.restoreFocus();
	      this.props.captureFocus(this._tabContentContainer, false);
	    }
	  }, {
	    key: 'handleTabClick',
	    value: function handleTabClick(e, targetKey) {
	      e.preventDefault();
	
	      if (targetKey === this.state.activeKey) {
	        this.focusOnTabContent();
	      }
	
	      this.setState({ activeKey: targetKey });
	    }
	  }, {
	    key: 'childIsActive',
	    value: function childIsActive(child) {
	      var activeKey = this.state.activeKey;
	
	
	      if (!activeKey || !child.props.eventKey) {
	        return false;
	      }
	
	      return activeKey.toString() === child.props.eventKey.toString();
	    }
	  }, {
	    key: 'renderTab',
	    value: function renderTab(child, index) {
	      var _this2 = this;
	
	      if (child.type.name === _tabContent2.default.name) {
	        var tabClass = this.childIsActive(child) ? 'active' : '';
	        return _react2.default.createElement(
	          'li',
	          { className: tabClass, key: index },
	          _react2.default.createElement(
	            'a',
	            {
	              href: '#' + (child.props.tabHref ? child.props.tabHref : child.props.label),
	              'data-index': index,
	              'data-test-id': child.props.testId,
	              onClick: function onClick(e) {
	                return _this2.handleTabClick(e, index);
	              } },
	            child.props.label
	          )
	        );
	      }
	
	      return _react2.default.createElement('noop', null);
	    }
	  }, {
	    key: 'renderTabs',
	    value: function renderTabs() {
	      var children = this.state.children;
	
	      if (children.length > 1) {
	        return _react2.default.createElement(
	          'ul',
	          { className: 'nav nav-tabs' },
	          _lodash2.default.map(children, this.renderTab)
	        );
	      }
	
	      return _react2.default.createElement('noop', null);
	    }
	  }, {
	    key: 'renderTabContent',
	    value: function renderTabContent() {
	      var children = this.state.children;
	
	      if (children.length === 1) {
	        return _react2.default.createElement(
	          'span',
	          null,
	          children
	        );
	      }
	      return this.props.children[this.state.activeKey];
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-tabs' },
	        this.renderTabs(),
	        _react2.default.createElement(
	          'div',
	          { className: 'tab-content', ref: function ref(el) {
	              return _this3._tabContentContainer = el;
	            } },
	          this.renderTabContent()
	        )
	      );
	    }
	  }]);
	
	  return Tabs;
	}(_baseBcReactComponent2.default);
	
	Tabs.propTypes = {
	  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react2.default.PropTypes.node), _react.PropTypes.node]).isRequired,
	  defaultActive: _react.PropTypes.number,
	
	  // injected by manageFocus
	  captureFocus: _react.PropTypes.func.isRequired,
	  restoreFocus: _react.PropTypes.func.isRequired
	};
	
	exports.default = (0, _reactIntl.injectIntl)((0, _baseAccessibilityManageFocus2.default)(Tabs));

/***/ },
/* 1359 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Tabs = __webpack_require__(1358);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Tabs).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1360 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	__webpack_require__(2696);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToggleSwitch = function ToggleSwitch(_ref) {
	  var active = _ref.active,
	      handleClick = _ref.handleClick,
	      children = _ref.children,
	      className = _ref.className,
	      activeLocaleKey = _ref.activeLocaleKey,
	      inactiveLocaleKey = _ref.inactiveLocaleKey;
	
	  var switchClass = active ? 'active' : 'inactive';
	  var localeKey = active ? activeLocaleKey : inactiveLocaleKey;
	  return _react2.default.createElement(
	    'button',
	    {
	      'aria-pressed': active,
	      className: 'cp-toggle-switch ' + className + ' ' + switchClass,
	      onClick: handleClick },
	    _react2.default.createElement(
	      'div',
	      { className: 'path' },
	      _react2.default.createElement(
	        'span',
	        { className: 'label', 'aria-hidden': 'true' },
	        active ? 'ON' : 'OFF'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'toggle' },
	        children
	      )
	    ),
	    _react2.default.createElement(
	      _reactIntl.FormattedMessage,
	      { id: localeKey },
	      function (message) {
	        return _react2.default.createElement(
	          _baseScreenReaderMessage2.default,
	          null,
	          message
	        );
	      }
	    )
	  );
	};
	
	ToggleSwitch.displayName = 'ToggleSwitch';
	
	ToggleSwitch.propTypes = {
	  active: _react.PropTypes.bool.isRequired,
	  handleClick: _react.PropTypes.func.isRequired,
	  className: _react.PropTypes.string,
	  activeLocaleKey: _react.PropTypes.string.isRequired,
	  inactiveLocaleKey: _react.PropTypes.string.isRequired,
	  children: _react.PropTypes.oneOfType([_react2.default.PropTypes.arrayOf(_react2.default.PropTypes.node), _react2.default.PropTypes.node]).isRequired
	};
	
	exports.default = ToggleSwitch;

/***/ },
/* 1361 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ToggleSwitch = __webpack_require__(1360);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ToggleSwitch).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1362 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TokenizedInput = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _analyticsEventComposers = __webpack_require__(174);
	
	var _utilsAnalytics = __webpack_require__(142);
	
	__webpack_require__(2697);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var COMMA_KEY_CODE = 188;
	var ENTER_KEY_CODE = 13;
	var COMMA_LABEL = 'comma';
	var ENTER_LABEL = 'enter';
	var composeTriggerAddTagEvent = _analyticsEventComposers.tagsEventComposer.composeTriggerAddTagEvent;
	
	var TokenizedInput = exports.TokenizedInput = function (_BcReactComponent) {
	  _inherits(TokenizedInput, _BcReactComponent);
	
	  function TokenizedInput(props) {
	    _classCallCheck(this, TokenizedInput);
	
	    var _this = _possibleConstructorReturn(this, (TokenizedInput.__proto__ || Object.getPrototypeOf(TokenizedInput)).call(this, props));
	
	    _this.bindAll('handleInputBlur', 'handleInputChange', 'handleInputFocus', 'handleInputKeyDown', 'handleComponentClick');
	
	    _this.state = {
	      focused: false,
	      inputValue: '',
	      newTokenValue: ''
	    };
	
	    _this.componentRef = null;
	    _this.inputRef = null;
	    return _this;
	  }
	
	  _createClass(TokenizedInput, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.componentRef) {
	        this.componentRef.addEventListener('click', this.handleComponentClick);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.componentRef) {
	        this.componentRef.removeEventListener('click', this.handleComponentClick);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var newTokenValue = this.state.newTokenValue;
	      var _props = this.props,
	          isSaving = _props.isSaving,
	          tokens = _props.tokens;
	
	      if (newTokenValue && isSaving && !nextProps.isSaving) {
	        this.setState({
	          newTokenValue: '',
	          inputValue: tokens.length === nextProps.tokens.length ? newTokenValue : ''
	        });
	      }
	    }
	  }, {
	    key: 'handleInputFocus',
	    value: function handleInputFocus() {
	      this.setState({
	        focused: true
	      });
	    }
	  }, {
	    key: 'handleInputBlur',
	    value: function handleInputBlur() {
	      this.setState({
	        focused: false
	      });
	    }
	  }, {
	    key: 'handleInputChange',
	    value: function handleInputChange(e) {
	      this.setState({
	        inputValue: e.target.value
	      });
	    }
	  }, {
	    key: 'handleInputKeyDown',
	    value: function handleInputKeyDown(e) {
	      if (this.state.newTokenValue || this.props.isSaving) {
	        e.preventDefault();
	        return;
	      }
	
	      if ([COMMA_KEY_CODE, ENTER_KEY_CODE].indexOf(e.keyCode) !== -1) {
	        e.preventDefault();
	
	        var inputValue = this.state.inputValue.trim();
	        if (inputValue) {
	          this.setState({
	            newTokenValue: inputValue,
	            inputValue: ''
	          });
	
	          // TODO: SHEL-286
	          var eventLabel = ENTER_KEY_CODE === e.keyCode ? ENTER_LABEL : COMMA_LABEL;
	          (0, _utilsAnalytics.sendAnalyticsEvents)(composeTriggerAddTagEvent(eventLabel));
	
	          this.props.handleTokenSave(inputValue);
	        }
	      }
	    }
	  }, {
	    key: 'handleComponentClick',
	    value: function handleComponentClick() {
	      if (this.inputRef && !this.containsFocusedElement()) {
	        this.inputRef.focus();
	      }
	    }
	  }, {
	    key: 'containsFocusedElement',
	    value: function containsFocusedElement() {
	      return this.componentRef && this.componentRef !== document.activeElement && this.componentRef.contains(document.activeElement);
	    }
	  }, {
	    key: 'renderTokens',
	    value: function renderTokens() {
	      var _props2 = this.props,
	          tokens = _props2.tokens,
	          getTokenKey = _props2.getTokenKey,
	          renderToken = _props2.renderToken,
	          renderNewToken = _props2.renderNewToken;
	
	
	      var renderedTokens = tokens.map(function (token) {
	        return _react2.default.createElement(
	          'li',
	          { key: getTokenKey(token), className: 'token-item' },
	          renderToken(token)
	        );
	      });
	
	      if (this.state.newTokenValue) {
	        renderedTokens.push(_react2.default.createElement(
	          'li',
	          { key: 'new-token-item', className: 'token-item' },
	          renderNewToken(this.state.newTokenValue)
	        ));
	      }
	
	      if (renderedTokens.length || renderedTokens.size) {
	        return _react2.default.createElement(
	          'ul',
	          { className: 'tokens-list' },
	          renderedTokens
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          className = _props3.className,
	          id = _props3.id,
	          maxInputLength = _props3.maxInputLength;
	      var _state = this.state,
	          focused = _state.focused,
	          inputValue = _state.inputValue;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('cp-tokenized-input', { focused: focused }, className), ref: function ref(el) {
	            return _this2.componentRef = el;
	          } },
	        this.renderTokens(),
	        _react2.default.createElement(
	          'span',
	          { className: 'new-token-input' },
	          _react2.default.createElement('input', {
	            id: id,
	            type: 'text',
	            autoComplete: 'off',
	            autoCorrect: 'off',
	            className: 'new-token-text-field',
	            maxLength: maxInputLength,
	            onChange: this.handleInputChange,
	            onFocus: this.handleInputFocus,
	            onBlur: this.handleInputBlur,
	            onKeyDown: this.handleInputKeyDown,
	            value: inputValue,
	            ref: function ref(el) {
	              return _this2.inputRef = el;
	            } }),
	          _react2.default.createElement(
	            'span',
	            { className: 'input-resizer', 'aria-hidden': true },
	            inputValue,
	            '\xA0'
	          )
	        )
	      );
	    }
	  }]);
	
	  return TokenizedInput;
	}(_baseBcReactComponent2.default);
	
	TokenizedInput.propTypes = {
	  id: _react.PropTypes.string,
	  className: _react.PropTypes.string,
	  isSaving: _react.PropTypes.bool,
	  maxInputLength: _react.PropTypes.number,
	  tokens: _react.PropTypes.oneOfType([_react.PropTypes.array, _reactImmutableProptypes2.default.list]).isRequired,
	  getTokenKey: _react.PropTypes.func.isRequired,
	  renderToken: _react.PropTypes.func.isRequired,
	  renderNewToken: _react.PropTypes.func.isRequired,
	  handleTokenSave: _react.PropTypes.func.isRequired
	};
	
	TokenizedInput.defaultProps = {
	  tokens: [],
	  maxInputLength: 100,
	  isSaving: false
	};
	
	exports.default = TokenizedInput;

/***/ },
/* 1363 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TokenizedInput = __webpack_require__(1362);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TokenizedInput).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1364 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsBrowser = __webpack_require__(59);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VisibilitySensor = function (_BcReactComponent) {
	  _inherits(VisibilitySensor, _BcReactComponent);
	
	  function VisibilitySensor(props) {
	    _classCallCheck(this, VisibilitySensor);
	
	    var _this = _possibleConstructorReturn(this, (VisibilitySensor.__proto__ || Object.getPrototypeOf(VisibilitySensor)).call(this, props));
	
	    _this.bindAll('handleScroll');
	    return _this;
	  }
	
	  _createClass(VisibilitySensor, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.isVisible((0, _utilsBrowser.isVisibleInViewPort)(this.node));
	      window.addEventListener('scroll', this.handleScroll);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('scroll', this.handleScroll);
	    }
	  }, {
	    key: 'handleScroll',
	    value: function handleScroll() {
	      this.props.isVisible((0, _utilsBrowser.isVisibleInViewPort)(this.node));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { ref: function ref(node) {
	            return _this2.node = node;
	          } },
	        _react2.default.Children.only(this.props.children)
	      );
	    }
	  }]);
	
	  return VisibilitySensor;
	}(_baseBcReactComponent2.default);
	
	VisibilitySensor.propTypes = {
	  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node]).isRequired,
	  isVisible: _react.PropTypes.func
	};
	
	exports.default = VisibilitySensor;

/***/ },
/* 1365 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _VisibilitySensor = __webpack_require__(1364);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_VisibilitySensor).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1366 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	exports.default = _react.PropTypes.shape({
	  buttonBackgroundColor: _react.PropTypes.string,
	  breakpointSettings: _react.PropTypes.objectOf(_react.PropTypes.shape({
	    gutterSize: _react.PropTypes.string,
	    itemsPerPage: _react.PropTypes.number,
	    partiallyShowOffscreenItems: _react.PropTypes.bool,
	    showDots: _react.PropTypes.bool,
	    useTouchArrows: _react.PropTypes.bool
	  }))
	});

/***/ },
/* 1367 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	exports.default = {
	  className: _react.PropTypes.string,
	  width: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	  height: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	  color: _react.PropTypes.string,
	  strokeColor: _react.PropTypes.string,
	  title: _react.PropTypes.string
	};

/***/ },
/* 1368 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _singleClickHoldsSettingsShape = __webpack_require__(532);
	
	var _singleClickHoldsSettingsShape2 = _interopRequireDefault(_singleClickHoldsSettingsShape);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var accountShape = _reactImmutableProptypes2.default.contains({
	  id: _react.PropTypes.number,
	  libId: _react.PropTypes.number,
	  digitalNotificationEmail: _react.PropTypes.string,
	  expiryDate: _react.PropTypes.string,
	  importedILSShelves: _react.PropTypes.bool,
	  borrowingHistoryEnabled: _react.PropTypes.bool,
	  singleClickHoldsSettings: _singleClickHoldsSettingsShape2.default,
	  preferredLocations: _reactImmutableProptypes2.default.listOf(_react.PropTypes.string)
	});
	
	exports.default = accountShape;

/***/ },
/* 1369 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _paginationShape = __webpack_require__(530);
	
	var _paginationShape2 = _interopRequireDefault(_paginationShape);
	
	var _bibShape = __webpack_require__(274);
	
	var _bibShape2 = _interopRequireDefault(_bibShape);
	
	var _searchQueryShape = __webpack_require__(531);
	
	var _searchQueryShape2 = _interopRequireDefault(_searchQueryShape);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var addTitleResultShape = _reactImmutableProptypes2.default.contains({
	  searchQuery: _searchQueryShape2.default.isRequired,
	  zeroResults: _react.PropTypes.bool.isRequired,
	  pagination: _paginationShape2.default.isRequired,
	  items: _reactImmutableProptypes2.default.listOf(_bibShape2.default).isRequired,
	  isFetching: _react.PropTypes.bool
	});
	
	exports.default = addTitleResultShape;

/***/ },
/* 1370 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var availabilityShape = _reactImmutableProptypes2.default.contains({
	  circulationType: _react.PropTypes.string,
	  localisedStatus: _react.PropTypes.string,
	  heldCopies: _react.PropTypes.number,
	  eresourceDescription: _react.PropTypes.string,
	  singleBranch: _react.PropTypes.bool,
	  metadataId: _react.PropTypes.string,
	  availabilityLocationType: _react.PropTypes.string,
	  status: _react.PropTypes.string,
	  bibType: _react.PropTypes.string,
	  totalCopies: _react.PropTypes.number,
	  libraryUseOnly: _react.PropTypes.bool,
	  eresourceUrl: _react.PropTypes.string,
	  availableCopies: _react.PropTypes.number
	});
	
	exports.default = availabilityShape;

/***/ },
/* 1371 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _reactImmutableProptypes2.default.mapContains({
	  remaining: _react.PropTypes.number,
	  total: _react.PropTypes.number,
	  type: _react.PropTypes.string
	});

/***/ },
/* 1372 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _bibShape = __webpack_require__(274);
	
	var _bibShape2 = _interopRequireDefault(_bibShape);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _reactImmutableProptypes2.default.mapContains({
	  actions: _reactImmutableProptypes2.default.listOf(_react.PropTypes.string),
	  bib: _bibShape2.default,
	  checkInEnabled: _react.PropTypes.bool,
	  checkoutId: _react.PropTypes.string,
	  digitalId: _react.PropTypes.string,
	  downloadUrl: _react.PropTypes.string,
	  downloadable: _react.PropTypes.bool,
	  dueDate: _react.PropTypes.string,
	  fines: _react.PropTypes.number,
	  format: _react.PropTypes.string,
	  materialType: _react.PropTypes.string,
	  metadataId: _react.PropTypes.string,
	  status: _react.PropTypes.string,
	  thirdPartyReaderUrl: _react.PropTypes.string,
	  timesRenewed: _react.PropTypes.number
	});

/***/ },
/* 1373 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	exports.default = _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.oneOfType([_react.PropTypes.node, _react.PropTypes.string])), _react.PropTypes.node, _react.PropTypes.string]);

/***/ },
/* 1374 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	exports.default = _react.PropTypes.shape({
	  id: _react.PropTypes.number.isRequired,
	  title: _react.PropTypes.string.isRequired,
	  content: _react.PropTypes.string.isRequired,
	  url: _react.PropTypes.string.isRequired,
	  contentType: _react.PropTypes.string.isRequired,
	  metadataId: _react.PropTypes.string
	});

/***/ },
/* 1375 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var fieldErrorsShape = _react.PropTypes.shape({
	  classification: _react.PropTypes.string,
	  message: _react.PropTypes.string,
	  id: _react.PropTypes.string,
	  values: _react.PropTypes.object
	});
	
	exports.default = fieldErrorsShape;

/***/ },
/* 1376 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _bibShape = __webpack_require__(274);
	
	var _bibShape2 = _interopRequireDefault(_bibShape);
	
	var _branchShape = __webpack_require__(527);
	
	var _branchShape2 = _interopRequireDefault(_branchShape);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _reactImmutableProptypes2.default.mapContains({
	  actions: _reactImmutableProptypes2.default.listOf(_react.PropTypes.string),
	  bib: _bibShape2.default,
	  expiryDate: _react.PropTypes.string,
	  holdPlacedDate: _react.PropTypes.string,
	  holdsId: _react.PropTypes.string,
	  holdsPosition: _react.PropTypes.number,
	  itemId: _react.PropTypes.string,
	  materialType: _react.PropTypes.string,
	  metadataId: _react.PropTypes.string,
	  pickupLocation: _branchShape2.default,
	  status: _react.PropTypes.string
	});

/***/ },
/* 1377 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _siteShape = __webpack_require__(533);
	
	var _siteShape2 = _interopRequireDefault(_siteShape);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var libraryShape = _reactImmutableProptypes2.default.contains({
	  getCardLink: _react.PropTypes.string,
	  showHoldCountInSearch: _react.PropTypes.bool,
	  showDueDateInCirc: _react.PropTypes.bool,
	  siteId: _react.PropTypes.string,
	  domain: _react.PropTypes.string,
	  showCallNumber: _react.PropTypes.bool,
	  numericPasswordRequired: _react.PropTypes.bool,
	  shortName: _react.PropTypes.string,
	  longName: _react.PropTypes.string,
	  showVolumeSelectorStatus: _react.PropTypes.bool,
	  singleBranch: _react.PropTypes.bool,
	  showExternalSearchLink: _react.PropTypes.bool,
	  logo: _react.PropTypes.string,
	  featuredContentBlockPosition: _react.PropTypes.number,
	  showVolumeSelectorDueDate: _react.PropTypes.bool,
	  showInactiveHolds: _react.PropTypes.bool,
	  featuredListTypes: _react.PropTypes.bool,
	  showCallNumberForDigital: _react.PropTypes.bool,
	  showVolumeSelectorCollection: _react.PropTypes.bool,
	  pickupLocationEditable: _react.PropTypes.bool,
	  libraryId: _react.PropTypes.number,
	  showCollectionInCirc: _react.PropTypes.bool,
	  recentlyReturned: _react.PropTypes.bool,
	  cmsEnabled: _react.PropTypes.bool,
	  holdInfoMessages: _reactImmutableProptypes2.default.list,
	  onlyShowEditionsForCDROMAndVideoGames: _react.PropTypes.bool,
	  fullName: _react.PropTypes.string,
	  type: _react.PropTypes.string,
	  id: _react.PropTypes.number,
	  hideCallNumberForHigherSearchScope: _react.PropTypes.bool,
	  linkableLibraries: _reactImmutableProptypes2.default.listOf(_siteShape2.default)
	});
	
	exports.default = libraryShape;

/***/ },
/* 1378 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var jacketCoverShape = _react.PropTypes.shape({
	  type: _react.PropTypes.string,
	  smallCover: _react.PropTypes.string,
	  mediumCover: _react.PropTypes.string,
	  largeCover: _react.PropTypes.string,
	  localUrl: _react.PropTypes.string
	});
	
	var bibListItemShape = _react.PropTypes.shape({
	  id: _react.PropTypes.string,
	  title: _react.PropTypes.string,
	  authors: _react.PropTypes.arrayOf(_react.PropTypes.string),
	  format: _react.PropTypes.string,
	  pubYear: _react.PropTypes.string
	});
	
	var urlListItemShape = _react.PropTypes.shape({
	  url: {
	    title: _react.PropTypes.string,
	    url: _react.PropTypes.string
	  }
	});
	
	var listItemShape = _react.PropTypes.oneOfType([_react.PropTypes.shape({
	  id: _react.PropTypes.number,
	  type: _react.PropTypes.string.isRequired,
	  bibListItem: bibListItemShape.isRequired,
	  annotation: _react.PropTypes.string,
	  jacketCover: jacketCoverShape
	}), _react.PropTypes.shape({
	  id: _react.PropTypes.number,
	  type: _react.PropTypes.string.isRequired,
	  urlListItem: urlListItemShape.isRequired,
	  annotation: _react.PropTypes.string,
	  jacketCover: jacketCoverShape
	})]);
	
	exports.default = listItemShape;

/***/ },
/* 1379 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _userIdentityShape = __webpack_require__(534);
	
	var _userIdentityShape2 = _interopRequireDefault(_userIdentityShape);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var listShape = _react.PropTypes.shape({
	  agencyScope: _react.PropTypes.string,
	  created: _react.PropTypes.string,
	  updated: _react.PropTypes.string,
	  id: _react.PropTypes.number,
	  intendedLocale: _react.PropTypes.string,
	  isPrivate: _react.PropTypes.bool,
	  itemCount: _react.PropTypes.number,
	  language: _react.PropTypes.string,
	  listType: _react.PropTypes.string,
	  name: _react.PropTypes.string,
	  owner: _userIdentityShape2.default
	});
	
	exports.default = listShape;

/***/ },
/* 1380 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var messagingShape = _reactImmutableProptypes2.default.contains({
	  message: _reactImmutableProptypes2.default.mapContains({
	    type: _react.PropTypes.string,
	    id: _react.PropTypes.string,
	    defaultMessage: _react.PropTypes.string
	  }),
	  values: _reactImmutableProptypes2.default.map,
	  duration: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.bool]),
	  fieldErrors: _reactImmutableProptypes2.default.contains({
	    classification: _react.PropTypes.string,
	    message: _react.PropTypes.string,
	    id: _react.PropTypes.string,
	    values: _reactImmutableProptypes2.default.map
	  }),
	  failureDuration: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.bool])
	});
	
	exports.default = messagingShape;

/***/ },
/* 1381 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _filterShape = __webpack_require__(528);
	
	var _filterShape2 = _interopRequireDefault(_filterShape);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var searchFieldShape = _react.PropTypes.shape({
	  id: _react.PropTypes.string,
	  hasMore: _react.PropTypes.bool,
	  fieldFilters: _react.PropTypes.arrayOf(_filterShape2.default)
	});
	
	exports.default = searchFieldShape;

/***/ },
/* 1382 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var shelfItemShape = _react.PropTypes.shape({
	  id: _react.PropTypes.number,
	  metadataId: _react.PropTypes.string,
	  shelf: _react.PropTypes.string,
	  privateItem: _react.PropTypes.bool,
	  dateAdded: _react.PropTypes.string
	});
	
	exports.default = shelfItemShape;

/***/ },
/* 1383 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var shelfShape = _reactImmutableProptypes2.default.contains({
	  userId: _react.PropTypes.number.isRequired,
	  name: _react.PropTypes.string.isRequired,
	  privateByDefault: _react.PropTypes.bool,
	  items: _reactImmutableProptypes2.default.list.isRequired,
	  pagination: _reactImmutableProptypes2.default.map.isRequired,
	  sort: _reactImmutableProptypes2.default.map.isRequired,
	  facets: _reactImmutableProptypes2.default.list.isRequired
	});
	
	exports.default = shelfShape;

/***/ },
/* 1384 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var truncateOptionsShape = _react.PropTypes.shape({
	  desiredLength: _react.PropTypes.number,
	  softTruncate: _react.PropTypes.bool,
	  showEllipsis: _react.PropTypes.bool
	});
	
	exports.default = truncateOptionsShape;

/***/ },
/* 1385 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ugcCommentShape = _reactImmutableProptypes2.default.contains({
	  id: _react.PropTypes.number.isRequired,
	  userId: _react.PropTypes.number.isRequired,
	  metadataId: _react.PropTypes.string.isRequired,
	  comment: _react.PropTypes.string.isRequired
	});
	
	exports.default = ugcCommentShape;

/***/ },
/* 1386 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ugcIOwnThisShape = _reactImmutableProptypes2.default.contains({
	  id: _react.PropTypes.number.isRequired,
	  metadataId: _react.PropTypes.string.isRequired,
	  userId: _react.PropTypes.number.isRequired
	});
	
	exports.default = ugcIOwnThisShape;

/***/ },
/* 1387 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ugcPrivateNoteShape = _reactImmutableProptypes2.default.contains({
	  id: _react.PropTypes.number.isRequired,
	  userId: _react.PropTypes.number.isRequired,
	  metadataId: _react.PropTypes.string.isRequired,
	  note: _react.PropTypes.string.isRequired
	});
	
	exports.default = ugcPrivateNoteShape;

/***/ },
/* 1388 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ugcQuotationShape = _reactImmutableProptypes2.default.contains({
	  id: _react.PropTypes.number.isRequired,
	  userId: _react.PropTypes.number.isRequired,
	  metadataId: _react.PropTypes.string.isRequired,
	  quotation: _react.PropTypes.string.isRequired
	});
	
	exports.default = ugcQuotationShape;

/***/ },
/* 1389 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ugcRatingShape = _reactImmutableProptypes2.default.contains({
	  id: _react.PropTypes.number.isRequired,
	  userId: _react.PropTypes.number.isRequired,
	  metadataId: _react.PropTypes.string.isRequired,
	  rating: _react.PropTypes.number.isRequired
	});
	
	exports.default = ugcRatingShape;

/***/ },
/* 1390 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ugcSimilarTitlesShape = _reactImmutableProptypes2.default.contains({
	  id: _react.PropTypes.number.isRequired,
	  metadataId: _react.PropTypes.string.isRequired,
	  similarMetadataId: _react.PropTypes.string.isRequired,
	  userId: _react.PropTypes.number.isRequired
	});
	
	exports.default = ugcSimilarTitlesShape;

/***/ },
/* 1391 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ugcTagShape = _reactImmutableProptypes2.default.contains({
	  id: _react.PropTypes.number.isRequired,
	  userId: _react.PropTypes.number.isRequired,
	  metadataId: _react.PropTypes.string.isRequired,
	  type: _react.PropTypes.oneOf(['genre', 'personal', 'mood', 'subject']).isRequired,
	  value: _react.PropTypes.string.isRequired
	});
	
	exports.default = ugcTagShape;

/***/ },
/* 1392 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ugcTagShape = _reactImmutableProptypes2.default.contains({
	  id: _react.PropTypes.number.isRequired,
	  metadataId: _react.PropTypes.string.isRequired,
	  title: _react.PropTypes.string.isRequired,
	  url: _react.PropTypes.string.isRequired,
	  createdDate: _react.PropTypes.string.isRequired,
	  description: _react.PropTypes.string,
	  userId: _react.PropTypes.number.isRequired
	});
	
	exports.default = ugcTagShape;

/***/ },
/* 1393 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CallNumber = function (_BcReactComponent) {
	  _inherits(CallNumber, _BcReactComponent);
	
	  function CallNumber() {
	    _classCallCheck(this, CallNumber);
	
	    return _possibleConstructorReturn(this, (CallNumber.__proto__ || Object.getPrototypeOf(CallNumber)).apply(this, arguments));
	  }
	
	  _createClass(CallNumber, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'span',
	        { className: 'cp-call-number' },
	        this.props.callNumber
	      );
	    }
	  }]);
	
	  return CallNumber;
	}(_baseBcReactComponent2.default);
	
	CallNumber.propTypes = {
	  callNumber: _react2.default.PropTypes.string
	};
	
	exports.default = CallNumber;

/***/ },
/* 1394 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CallNumber = __webpack_require__(1393);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CallNumber).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1395 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseButtons = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CancelHoldButton = function (_BcReactComponent) {
	  _inherits(CancelHoldButton, _BcReactComponent);
	
	  function CancelHoldButton(props) {
	    _classCallCheck(this, CancelHoldButton);
	
	    var _this = _possibleConstructorReturn(this, (CancelHoldButton.__proto__ || Object.getPrototypeOf(CancelHoldButton)).call(this, props));
	
	    _this.bindAll('handleClick');
	    return _this;
	  }
	
	  _createClass(CancelHoldButton, [{
	    key: 'handleClick',
	    value: function handleClick() {
	      this.props.cancelHold(this.props.metadataId);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _baseButtons.SecondaryButton,
	        {
	          handleClick: this.handleClick,
	          block: true,
	          className: 'cp-cancel-hold-button',
	          'data-test-id': 'cancel-hold-' + this.props.metadataId,
	          isLoading: this.props.isLoading },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'btn.cancelHold' })
	      );
	    }
	  }]);
	
	  return CancelHoldButton;
	}(_baseBcReactComponent2.default);
	
	CancelHoldButton.propTypes = {
	  cancelHold: _react.PropTypes.func.isRequired,
	  isLoading: _react.PropTypes.bool,
	  metadataId: _react.PropTypes.string.isRequired
	};
	
	exports.default = CancelHoldButton;

/***/ },
/* 1396 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CancelHoldButton = __webpack_require__(1395);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CancelHoldButton).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1397 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(104);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _lodash = __webpack_require__(16);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactSlick = __webpack_require__(3094);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseIcons = __webpack_require__(10);
	
	var _utilsAccessibility = __webpack_require__(95);
	
	var _Dots = __webpack_require__(1399);
	
	var _Dots2 = _interopRequireDefault(_Dots);
	
	var _ExitSlide = __webpack_require__(1400);
	
	var _ExitSlide2 = _interopRequireDefault(_ExitSlide);
	
	var _Item = __webpack_require__(1401);
	
	var _Item2 = _interopRequireDefault(_Item);
	
	var _RegularArrowButton = __webpack_require__(1402);
	
	var _RegularArrowButton2 = _interopRequireDefault(_RegularArrowButton);
	
	var _TouchArrowButton = __webpack_require__(1403);
	
	var _TouchArrowButton2 = _interopRequireDefault(_TouchArrowButton);
	
	__webpack_require__(2698);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SLIDER_TRANSITION_TIME = 750;
	var RESIZE_DEBOUNCE_TIME = 500;
	
	var BaseCarousel = function (_BcReactComponent) {
	  _inherits(BaseCarousel, _BcReactComponent);
	
	  function BaseCarousel(props) {
	    _classCallCheck(this, BaseCarousel);
	
	    var _this = _possibleConstructorReturn(this, (BaseCarousel.__proto__ || Object.getPrototypeOf(BaseCarousel)).call(this, props));
	
	    _this.bindAll('handleGoToNext', 'handleGoToPrevious', 'handleResize', 'handleSlideChanged', 'handleGoToPage', 'getResponsiveProps');
	    _this._items = {};
	    _this._pageBoundaries = [];
	    _this.state = {
	      loading: false,
	      currentPage: 0,
	      windowWidth: 1200,
	      responsiveProps: _this.getResponsiveProps()
	    };
	
	    _this.baseSlickSettings = {
	      infinite: false,
	      afterChange: _this.handleSlideChanged,
	      beforeChange: _this.handleSlideWillChange,
	      speed: SLIDER_TRANSITION_TIME,
	      accessibility: false,
	      draggable: false
	    };
	    return _this;
	  }
	
	  _createClass(BaseCarousel, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('resize', _lodash2.default.debounce(this.handleResize, RESIZE_DEBOUNCE_TIME));
	      setTimeout(function () {
	        if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {
	          var evt = document.createEvent('UIEvents');
	          evt.initUIEvent('resize', true, false, window, 0);
	          window.dispatchEvent(evt);
	        } else {
	          window.dispatchEvent(new Event('resize'));
	        }
	      }, 0);
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate() {
	      var settings = this.getSettings();
	      var sliderWrapperEl = _reactDom2.default.findDOMNode(this._slider); // eslint-disable-line react/no-find-dom-node
	      if (sliderWrapperEl !== undefined && settings.partiallyShowOffscreenItems) {
	        var slickListEl = sliderWrapperEl.getElementsByClassName('slick-list');
	        if (slickListEl[0] !== undefined && settings.partiallyShowOffscreenItems) {
	          slickListEl[0].style.margin = '0 calc(-1.5 * ' + settings.gutterSize + ')';
	          slickListEl[0].style.padding = '0 calc(1.5 * ' + settings.gutterSize + ')';
	        }
	      }
	    }
	  }, {
	    key: 'getBreakpoints',
	    value: function getBreakpoints() {
	      return Object.keys(this.props.breakpointSettings).map(function (breakPoint) {
	        return parseInt(breakPoint, 10);
	      }).sort(function (a, b) {
	        return a - b;
	      });
	    }
	  }, {
	    key: 'getCurrentBreakpoint',
	    value: function getCurrentBreakpoint() {
	      var width = this.state.windowWidth;
	      var breakPoints = this.getBreakpoints();
	      for (var i = 0; i < breakPoints.length; i += 1) {
	        if (width <= breakPoints[i]) {
	          return breakPoints[i];
	        }
	      }
	
	      return _lodash2.default.last(breakPoints);
	    }
	  }, {
	    key: 'handleGoToPage',
	    value: function handleGoToPage(page) {
	      var newPage = _lodash2.default.clamp(page, 0, this.getTotalPages());
	      if (!this.state.loading && newPage !== this.getCurrentPage()) {
	        this.setState({ currentPage: newPage, loading: true });
	      }
	    }
	  }, {
	    key: 'getSettings',
	    value: function getSettings() {
	      var breakPoint = this.getCurrentBreakpoint();
	      return this.props.breakpointSettings[breakPoint];
	    }
	  }, {
	    key: 'getResponsiveProps',
	    value: function getResponsiveProps() {
	      var _this2 = this;
	
	      return _lodash2.default.map(this.props.breakpointSettings, function (v, k) {
	        return { breakpoint: parseInt(k, 10), settings: _this2.getSlickProps(v) };
	      });
	    }
	  }, {
	    key: 'getSlickProps',
	    value: function getSlickProps(settings) {
	      return _extends({}, this.baseSlickSettings, {
	        dots: false,
	        arrows: false,
	        slidesToShow: settings.itemsPerPage,
	        slidesToScroll: settings.itemsPerPage
	      });
	    }
	  }, {
	    key: 'calcPageIndices',
	    value: function calcPageIndices() {
	      var _getSettings = this.getSettings(),
	          itemsPerPage = _getSettings.itemsPerPage;
	
	      var indices = _lodash2.default.times(this.getItemCount(), function (i) {
	        return i;
	      });
	      this._pageBoundaries = _lodash2.default.chain(indices).chunk(itemsPerPage).map(function (chunk) {
	        if (chunk.length < itemsPerPage) {
	          return _lodash2.default.nth(indices, -1 * itemsPerPage);
	        }
	        return chunk[0];
	      }).value();
	    }
	  }, {
	    key: 'getCurrentPage',
	    value: function getCurrentPage() {
	      return this.state.currentPage;
	    }
	  }, {
	    key: 'getTotalPages',
	    value: function getTotalPages() {
	      return Math.ceil(this.getItemCount() / this.getSettings().itemsPerPage);
	    }
	  }, {
	    key: 'handleSlideChanged',
	    value: function handleSlideChanged() {
	      var _this3 = this;
	
	      this.setState({ loading: false }, function () {
	        if (_this3._items[_this3._pageBoundaries[_this3.getCurrentPage()]]) {
	          (0, _utilsAccessibility.setFocusWithinElement)(_this3._items[_this3._pageBoundaries[_this3.getCurrentPage()]]);
	        }
	      });
	    }
	  }, {
	    key: 'handleGoToNext',
	    value: function handleGoToNext() {
	      var currentPage = this.state.currentPage;
	      var newPage = Math.min(currentPage + 1, this.getTotalPages());
	      if (!this.state.loading && newPage !== currentPage) {
	        this.setState({ currentPage: newPage, loading: true });
	      }
	    }
	  }, {
	    key: 'handleGoToPrevious',
	    value: function handleGoToPrevious() {
	      var currentPage = this.state.currentPage;
	      var newPage = Math.max(currentPage - 1, 0);
	      if (!this.state.loading && newPage !== currentPage) {
	        this.setState({ currentPage: newPage, loading: true });
	      }
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize() {
	      var _this4 = this;
	
	      var windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
	      this.setState({ windowWidth: windowWidth, currentPage: 0 }, function () {
	        if (_this4.props.renderExitSlide) {
	          var sliderWrapperEl = _reactDom2.default.findDOMNode(_this4._slider); // eslint-disable-line react/no-find-dom-node
	          var items = sliderWrapperEl.getElementsByClassName('cp-item');
	          var exitSlide = sliderWrapperEl.getElementsByClassName('cp-exit-slide')[0];
	          var newHeight = items.length >= 2 ? items[items.length - 2].clientHeight : 1.5 * exitSlide.clientWidth;
	          sliderWrapperEl.getElementsByClassName('cp-exit-slide')[0].style.height = newHeight + 'px';
	        }
	        _this4.calcPageIndices();
	        _this4.handleGoToPage(0);
	      });
	    }
	  }, {
	    key: 'getItemCount',
	    value: function getItemCount() {
	      var slideCount = this.props.children ? this.props.children.length : 0;
	      if (this.props.renderExitSlide && this.props.titleData.carouselTitleLink) {
	        slideCount += 1;
	      }
	      return slideCount;
	    }
	  }, {
	    key: 'itemIsActive',
	    value: function itemIsActive(index) {
	      var slidesPerPage = this.getSettings().itemsPerPage;
	      var startIndex = this._pageBoundaries[this.state.currentPage] || 0;
	      var endIndex = startIndex + slidesPerPage;
	      return index >= startIndex && index < endIndex;
	    }
	  }, {
	    key: 'renderItem',
	    value: function renderItem(contents, index) {
	      var _this5 = this;
	
	      var settings = this.getSettings();
	
	      return _react2.default.createElement(
	        'div',
	        { key: index, ref: function ref(el) {
	            return _this5._items[index] = el;
	          } },
	        _react2.default.createElement(
	          _Item2.default,
	          {
	            styles: { width: 'calc(100% - ' + settings.gutterSize + ')', margin: '0 auto' },
	            hidden: !this.itemIsActive(index) },
	          contents
	        )
	      );
	    }
	  }, {
	    key: 'renderRegularLeftArrow',
	    value: function renderRegularLeftArrow() {
	      var settings = this.getSettings();
	      var numberOfItems = this.getItemCount();
	
	      if (!settings.useTouchArrows) {
	        return _react2.default.createElement(_RegularArrowButton2.default, {
	          style: { backgroundColor: this.props.buttonBackgroundColor },
	          handleClick: this.handleGoToPrevious,
	          currentPage: this.getCurrentPage(),
	          pageSize: settings.itemsPerPage,
	          disabled: this.getCurrentPage() <= 0,
	          numberOfItems: numberOfItems,
	          direction: 'left' });
	      }
	      return null;
	    }
	  }, {
	    key: 'renderRegularRightArrow',
	    value: function renderRegularRightArrow() {
	      var settings = this.getSettings();
	      var numberOfItems = this.getItemCount();
	
	      if (!settings.useTouchArrows) {
	        return _react2.default.createElement(_RegularArrowButton2.default, {
	          style: { backgroundColor: this.props.buttonBackgroundColor },
	          handleClick: this.handleGoToNext,
	          currentPage: this.getCurrentPage(),
	          pageSize: settings.itemsPerPage,
	          disabled: this.getCurrentPage() >= this.getTotalPages() - 1,
	          numberOfItems: numberOfItems,
	          direction: 'right' });
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderTouchArrowButtons',
	    value: function renderTouchArrowButtons() {
	      var settings = this.getSettings();
	      var numberOfItems = this.getItemCount();
	
	      if (settings.useTouchArrows) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'touch-arrows' },
	          _react2.default.createElement(_TouchArrowButton2.default, {
	            handleClick: this.handleGoToPrevious,
	            currentPage: this.getCurrentPage(),
	            pageSize: settings.itemsPerPage,
	            disabled: this.getCurrentPage() <= 0,
	            numberOfItems: numberOfItems,
	            direction: 'left' }),
	          _react2.default.createElement(_TouchArrowButton2.default, {
	            handleClick: this.handleGoToNext,
	            currentPage: this.getCurrentPage(),
	            pageSize: settings.itemsPerPage,
	            disabled: this.getCurrentPage() >= this.getTotalPages() - 1,
	            numberOfItems: numberOfItems,
	            direction: 'right' })
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderDots',
	    value: function renderDots() {
	      var settings = this.getSettings();
	      if (this.getTotalPages() > 1 && settings.showDots) {
	        return _react2.default.createElement(_Dots2.default, {
	          currentPage: this.getCurrentPage(),
	          pages: this.getTotalPages(),
	          pageSize: settings.itemsPerPage,
	          numberOfItems: this.getItemCount(),
	          handleGoToPage: this.handleGoToPage });
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderCarouselTitle',
	    value: function renderCarouselTitle() {
	      var settings = this.getSettings();
	      var titleData = this.props.titleData;
	
	      if (titleData.carouselTitle) {
	        var titleClassName = (0, _classnames2.default)('heading-moderate', {
	          'with-touch-arrows': settings.useTouchArrows
	        });
	        var HeadingTag = titleData.headingTag;
	        return _react2.default.createElement(
	          HeadingTag,
	          { className: titleClassName },
	          titleData.carouselTitleLink ? _react2.default.createElement(
	            'a',
	            { className: 'link-carousel-heading', href: titleData.carouselTitleLink },
	            titleData.carouselTitle,
	            _react2.default.createElement(_baseIcons.Chevron.Right, { className: 'carousel-heading' })
	          ) : titleData.carouselTitle
	        );
	      }
	      return [];
	    }
	  }, {
	    key: 'renderExitSlide',
	    value: function renderExitSlide() {
	      if (this.props.renderExitSlide && this.props.titleData.carouselTitleLink) {
	        var exitLink = _react2.default.createElement(_ExitSlide2.default, { url: this.props.titleData.carouselTitleLink });
	        return this.renderItem(exitLink, this.props.children.length, 'empty-link');
	      }
	      return [];
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      var children = this.props.children;
	
	      var settings = this.getSettings();
	      var classnames = (0, _classnames2.default)('cp-base-carousel', {
	        'show-offscreen-items': settings.partiallyShowOffscreenItems
	      });
	      var wrapperStyles = settings.useTouchArrows ? { width: '100%' } : { width: 'calc(100% + ' + settings.gutterSize + ' - 100px)', margin: '0 calc(-1 * ' + settings.gutterSize + ' / 2)' };
	
	      return _react2.default.createElement(
	        'div',
	        {
	          ref: function ref(el) {
	            return _this6._carouselContainer = el;
	          },
	          className: classnames },
	        this.renderCarouselTitle(),
	        _react2.default.createElement(
	          'div',
	          { className: 'slider-with-arrows' },
	          this.renderRegularLeftArrow(),
	          _react2.default.createElement(
	            'div',
	            { className: 'slider-wrapper', style: wrapperStyles },
	            _react2.default.createElement(
	              _reactSlick2.default,
	              _extends({}, this.baseSlickSettings, {
	                responsive: this.state.responsiveProps,
	                slickGoTo: this._pageBoundaries[this.state.currentPage],
	                ref: function ref(el) {
	                  return _this6._slider = el;
	                } }),
	              children.map(function (child, index) {
	                return _this6.renderItem(child, index);
	              }),
	              this.renderExitSlide()
	            )
	          ),
	          this.renderRegularRightArrow()
	        ),
	        this.renderDots(),
	        this.renderTouchArrowButtons()
	      );
	    }
	  }]);
	
	  return BaseCarousel;
	}(_baseBcReactComponent2.default);
	
	BaseCarousel.propTypes = {
	  children: _react.PropTypes.arrayOf(_react.PropTypes.element),
	  buttonBackgroundColor: _react.PropTypes.string,
	  renderExitSlide: _react.PropTypes.bool,
	  breakpointSettings: _react.PropTypes.objectOf(_react.PropTypes.shape({
	    useTouchArrows: _react.PropTypes.bool,
	    itemsPerPage: _react.PropTypes.number,
	    partiallyShowOffscreenItems: _react.PropTypes.bool,
	    showDots: _react.PropTypes.bool,
	    gutterSize: _react.PropTypes.string
	  })),
	  titleData: _react.PropTypes.shape({
	    headingTag: _react.PropTypes.string,
	    carouselTitle: _react.PropTypes.string,
	    carouselTitleLink: _react.PropTypes.string
	  })
	};
	
	BaseCarousel.defaultProps = {
	  buttonBackgroundColor: '#fff',
	  renderExitSlide: false,
	  children: []
	};
	
	exports.default = BaseCarousel;

/***/ },
/* 1398 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseIcons = __webpack_require__(10);
	
	var _baseButtons = __webpack_require__(12);
	
	var _PageDescription = __webpack_require__(536);
	
	var _PageDescription2 = _interopRequireDefault(_PageDescription);
	
	__webpack_require__(2699);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Dot = function (_BcReactComponent) {
	  _inherits(Dot, _BcReactComponent);
	
	  function Dot() {
	    _classCallCheck(this, Dot);
	
	    return _possibleConstructorReturn(this, (Dot.__proto__ || Object.getPrototypeOf(Dot)).apply(this, arguments));
	  }
	
	  _createClass(Dot, [{
	    key: 'focus',
	    value: function focus() {
	      this._button.focus();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          handleClick = _props.handleClick,
	          active = _props.active,
	          page = _props.page,
	          pageSize = _props.pageSize,
	          numberOfItems = _props.numberOfItems;
	
	      var classnames = (0, _classnames2.default)('cp-dot', {
	        active: active
	      });
	
	      return _react2.default.createElement(
	        _baseButtons.Button,
	        {
	          ref: function ref(el) {
	            return _this2._button = el;
	          },
	          className: classnames,
	          handleClick: handleClick },
	        _react2.default.createElement(_baseIcons.Dots.Empty, null),
	        _react2.default.createElement(_baseIcons.Dots.Full, null),
	        _react2.default.createElement(_PageDescription2.default, {
	          page: page,
	          pageSize: pageSize,
	          numberOfItems: numberOfItems })
	      );
	    }
	  }]);
	
	  return Dot;
	}(_baseBcReactComponent2.default);
	
	exports.default = Dot;
	
	
	Dot.propTypes = {
	  active: _react.PropTypes.bool,
	  handleClick: _react.PropTypes.func,
	  page: _react.PropTypes.number,
	  pageSize: _react.PropTypes.number,
	  numberOfItems: _react.PropTypes.number
	};

/***/ },
/* 1399 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(16);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _Dot = __webpack_require__(1398);
	
	var _Dot2 = _interopRequireDefault(_Dot);
	
	__webpack_require__(2700);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Dots = function (_BcReactComponent) {
	  _inherits(Dots, _BcReactComponent);
	
	  function Dots() {
	    _classCallCheck(this, Dots);
	
	    return _possibleConstructorReturn(this, (Dots.__proto__ || Object.getPrototypeOf(Dots)).apply(this, arguments));
	  }
	
	  _createClass(Dots, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          pageSize = _props.pageSize,
	          numberOfItems = _props.numberOfItems;
	
	      var pages = _lodash2.default.range(0, this.props.pages);
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-dots' },
	        pages.map(function (page) {
	          return _react2.default.createElement(_Dot2.default, {
	            active: _this2.props.currentPage === page,
	            key: page,
	            page: page,
	            pageSize: pageSize,
	            numberOfItems: numberOfItems,
	            handleClick: function handleClick() {
	              return _this2.props.handleGoToPage(page);
	            } });
	        })
	      );
	    }
	  }]);
	
	  return Dots;
	}(_baseBcReactComponent2.default);
	
	exports.default = Dots;
	
	
	Dots.propTypes = {
	  currentPage: _react.PropTypes.number,
	  pages: _react.PropTypes.number,
	  pageSize: _react.PropTypes.number,
	  numberOfItems: _react.PropTypes.number,
	  handleGoToPage: _react.PropTypes.func
	};

/***/ },
/* 1400 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseIcons = __webpack_require__(10);
	
	__webpack_require__(2701);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ExitSlide = function ExitSlide(_ref) {
	  var url = _ref.url;
	  return _react2.default.createElement(
	    _reactIntl.FormattedMessage,
	    { id: 'view_all' },
	    function (message) {
	      return _react2.default.createElement(
	        'a',
	        { className: 'cp-exit-slide', href: url },
	        _react2.default.createElement(
	          'div',
	          { className: 'centered' },
	          _react2.default.createElement(
	            'span',
	            null,
	            message,
	            _react2.default.createElement(_baseIcons.Chevron.Right, { className: 'carousel-heading' })
	          )
	        )
	      );
	    }
	  );
	};
	
	ExitSlide.propTypes = {
	  url: _react.PropTypes.string.isRequired
	};
	
	exports.default = ExitSlide;

/***/ },
/* 1401 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _tabbable = __webpack_require__(507);
	
	var _tabbable2 = _interopRequireDefault(_tabbable);
	
	__webpack_require__(2702);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Item = function (_BcReactComponent) {
	  _inherits(Item, _BcReactComponent);
	
	  function Item(props) {
	    _classCallCheck(this, Item);
	
	    var _this = _possibleConstructorReturn(this, (Item.__proto__ || Object.getPrototypeOf(Item)).call(this, props));
	
	    _this.elementsToRestore = [];
	    return _this;
	  }
	
	  _createClass(Item, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.hidden) {
	        this.makeContentsUntabbable();
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(oldProps) {
	      if (oldProps.hidden && !this.props.hidden) {
	        this.restoreUntabbableContents();
	      } else if (!oldProps.hidden && this.props.hidden) {
	        this.makeContentsUntabbable();
	      }
	    }
	  }, {
	    key: 'makeContentsUntabbable',
	    value: function makeContentsUntabbable() {
	      var _this2 = this;
	
	      var tabbableElements = (0, _tabbable2.default)(this._itemDiv);
	      tabbableElements.forEach(function (element) {
	        var tabIndex = element.getAttribute('tabindex');
	        _this2.elementsToRestore.push({ element: element, tabIndex: tabIndex });
	        element.setAttribute('tabindex', -1);
	      });
	    }
	  }, {
	    key: 'restoreUntabbableContents',
	    value: function restoreUntabbableContents() {
	      this.elementsToRestore.forEach(function (elementData) {
	        var element = elementData.element,
	            tabIndex = elementData.tabIndex;
	
	        if (tabIndex == null) {
	          element.removeAttribute('tabindex');
	        } else {
	          element.setAttribute('tabindex', tabIndex);
	        }
	      });
	      this.elementsToRestore = [];
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var hiddenProps = this.props.hidden ? {
	        'aria-hidden': true, tabIndex: -1
	      } : {};
	
	      var emptyClass = this.props.children ? '' : 'empty';
	
	      return _react2.default.createElement(
	        'div',
	        _extends({
	          ref: function ref(el) {
	            return _this3._itemDiv = el;
	          },
	          className: 'cp-item ' + emptyClass
	        }, hiddenProps, {
	          style: this.props.styles }),
	        this.props.children
	      );
	    }
	  }]);
	
	  return Item;
	}(_baseBcReactComponent2.default);
	
	exports.default = Item;
	
	
	Item.propTypes = {
	  hidden: _react.PropTypes.bool,
	  children: _react.PropTypes.element
	};

/***/ },
/* 1402 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _ArrowButton = __webpack_require__(535);
	
	var _ArrowButton2 = _interopRequireDefault(_ArrowButton);
	
	__webpack_require__(2703);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RegularArrowButton = function (_BcReactComponent) {
	  _inherits(RegularArrowButton, _BcReactComponent);
	
	  function RegularArrowButton() {
	    _classCallCheck(this, RegularArrowButton);
	
	    return _possibleConstructorReturn(this, (RegularArrowButton.__proto__ || Object.getPrototypeOf(RegularArrowButton)).apply(this, arguments));
	  }
	
	  _createClass(RegularArrowButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          currentPage = _props.currentPage,
	          direction = _props.direction,
	          disabled = _props.disabled,
	          handleClick = _props.handleClick,
	          pageSize = _props.pageSize,
	          numberOfItems = _props.numberOfItems,
	          props = _objectWithoutProperties(_props, ['currentPage', 'direction', 'disabled', 'handleClick', 'pageSize', 'numberOfItems']);
	
	      return _react2.default.createElement(_ArrowButton2.default, _extends({}, props, {
	        className: 'cp-regular-arrow-button',
	        disabled: disabled,
	        handleClick: handleClick,
	        currentPage: currentPage,
	        pageSize: pageSize,
	        numberOfItems: numberOfItems,
	        direction: direction }));
	    }
	  }]);
	
	  return RegularArrowButton;
	}(_baseBcReactComponent2.default);
	
	exports.default = RegularArrowButton;
	
	
	RegularArrowButton.propTypes = {
	  currentPage: _react.PropTypes.number,
	  pageSize: _react.PropTypes.number,
	  numberOfItems: _react.PropTypes.number,
	  direction: _react.PropTypes.string,
	  disabled: _react.PropTypes.bool,
	  handleClick: _react.PropTypes.func
	};

/***/ },
/* 1403 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _ArrowButton = __webpack_require__(535);
	
	var _ArrowButton2 = _interopRequireDefault(_ArrowButton);
	
	__webpack_require__(2704);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TouchArrowButton = function (_BcReactComponent) {
	  _inherits(TouchArrowButton, _BcReactComponent);
	
	  function TouchArrowButton() {
	    _classCallCheck(this, TouchArrowButton);
	
	    return _possibleConstructorReturn(this, (TouchArrowButton.__proto__ || Object.getPrototypeOf(TouchArrowButton)).apply(this, arguments));
	  }
	
	  _createClass(TouchArrowButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          currentPage = _props.currentPage,
	          direction = _props.direction,
	          disabled = _props.disabled,
	          handleClick = _props.handleClick,
	          pageSize = _props.pageSize,
	          numberOfItems = _props.numberOfItems;
	
	
	      return _react2.default.createElement(_ArrowButton2.default, {
	        className: 'cp-touch-arrow-button',
	        disabled: disabled,
	        handleClick: handleClick,
	        currentPage: currentPage,
	        pageSize: pageSize,
	        numberOfItems: numberOfItems,
	        direction: direction });
	    }
	  }]);
	
	  return TouchArrowButton;
	}(_baseBcReactComponent2.default);
	
	exports.default = TouchArrowButton;
	
	
	TouchArrowButton.propTypes = {
	  currentPage: _react.PropTypes.number,
	  pageSize: _react.PropTypes.number,
	  numberOfItems: _react.PropTypes.number,
	  direction: _react.PropTypes.string,
	  disabled: _react.PropTypes.bool,
	  handleClick: _react.PropTypes.func
	};

/***/ },
/* 1404 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BaseCarousel = __webpack_require__(1397);
	
	var _BaseCarousel2 = _interopRequireDefault(_BaseCarousel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = { BaseCarousel: _BaseCarousel2.default };

/***/ },
/* 1405 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var VISIBILITY = exports.VISIBILITY = {
	  NOT_VISIBLE: 'not_visible',
	  LINK: 'visible_by_link',
	  GEOFENCED: 'geofenced',
	  EVERYWHERE: 'visible_everywhere'
	};
	
	var MAX_LIST_ITEMS = exports.MAX_LIST_ITEMS = 100;
	
	var LIST_NAME_LENGTH_SOFT_LIMIT = exports.LIST_NAME_LENGTH_SOFT_LIMIT = 140;
	var LIST_DESCRIPTION_LENGTH_SOFT_LIMIT = exports.LIST_DESCRIPTION_LENGTH_SOFT_LIMIT = 2000;
	
	exports.default = {
	  MAX_LIST_ITEMS: MAX_LIST_ITEMS,
	  VISIBILITY: VISIBILITY,
	  LIST_NAME_LENGTH_SOFT_LIMIT: LIST_NAME_LENGTH_SOFT_LIMIT,
	  LIST_DESCRIPTION_LENGTH_SOFT_LIMIT: LIST_DESCRIPTION_LENGTH_SOFT_LIMIT
	};

/***/ },
/* 1406 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PERMISSIONS = exports.ROLES = undefined;
	
	var _keymirror = __webpack_require__(325);
	
	var _keymirror2 = _interopRequireDefault(_keymirror);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ROLES = exports.ROLES = (0, _keymirror2.default)({
	  LIBRARY_PATRON: null,
	  LIBRARY_STAFF: null,
	  SYS_ADMIN: null
	});
	
	var PERMISSIONS = exports.PERMISSIONS = (0, _keymirror2.default)({
	  SYSTEM_MESSAGE: null,
	  USER_TAKEOVER: null,
	  EMAIL_TEMPLATES: null,
	  REPORT_FEEDBACK: null,
	  UGC_FREE_TEXT: null
	});
	
	exports.default = {
	  ROLES: ROLES,
	  PERMISSIONS: PERMISSIONS
	};

/***/ },
/* 1407 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ExpandButton;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseButtons = __webpack_require__(12);
	
	__webpack_require__(2705);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ExpandButton(_ref) {
	  var expanded = _ref.expanded,
	      handleToggle = _ref.handleToggle,
	      renderLabel = _ref.renderLabel;
	
	  return _react2.default.createElement(
	    _baseButtons.BlueCaretArrowButton,
	    { 'aria-expanded': expanded, className: 'cp-expand-button', handleClick: handleToggle, caretUp: expanded },
	    renderLabel(expanded)
	  );
	}
	
	ExpandButton.propTypes = {
	  expanded: _react.PropTypes.bool.isRequired,
	  handleToggle: _react.PropTypes.func.isRequired,
	  renderLabel: _react.PropTypes.func
	};
	
	ExpandButton.defaultProps = {
	  renderLabel: function renderLabel(expanded) {
	    return expanded ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_show_less' }) : _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_show_more' });
	  }
	};

/***/ },
/* 1408 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _utilsAccessibility = __webpack_require__(95);
	
	var _expandButton = __webpack_require__(275);
	
	var _expandButton2 = _interopRequireDefault(_expandButton);
	
	__webpack_require__(2706);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ExpandableList = function (_BcReactComponent) {
	  _inherits(ExpandableList, _BcReactComponent);
	
	  function ExpandableList(props) {
	    _classCallCheck(this, ExpandableList);
	
	    var _this = _possibleConstructorReturn(this, (ExpandableList.__proto__ || Object.getPrototypeOf(ExpandableList)).call(this, props));
	
	    _this.state = {
	      expanded: false
	    };
	    _this.bindAll('renderListItem', 'handleToggle');
	    _this.firstExpandedItem = null;
	    return _this;
	  }
	
	  _createClass(ExpandableList, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (!prevState.expanded && this.state.expanded && this.firstExpandedItem) {
	        (0, _utilsAccessibility.setFocusWithinElement)(this.firstExpandedItem);
	      }
	    }
	  }, {
	    key: 'handleToggle',
	    value: function handleToggle() {
	      this.setState({ expanded: !this.state.expanded });
	    }
	  }, {
	    key: 'renderExpandButton',
	    value: function renderExpandButton() {
	      var _props = this.props,
	          list = _props.list,
	          collapseCount = _props.collapseCount,
	          renderExpandButtonLabel = _props.renderExpandButtonLabel;
	
	      if ((list.length || list.size) > collapseCount) {
	        return _react2.default.createElement(_expandButton2.default, { handleToggle: this.handleToggle, expanded: this.state.expanded, renderLabel: renderExpandButtonLabel });
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderListItem',
	    value: function renderListItem(item, index) {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          collapseCount = _props2.collapseCount,
	          itemClassName = _props2.itemClassName,
	          getItemKey = _props2.getItemKey,
	          renderItem = _props2.renderItem;
	
	      var classNames = (0, _classnames2.default)('expandable-list-item', itemClassName);
	
	      if (!this.state.expanded && index > collapseCount - 1) {
	        return null;
	      }
	
	      var setRef = function setRef(ref) {
	        if (index === collapseCount) {
	          _this2.firstExpandedItem = ref;
	        }
	      };
	
	      return _react2.default.createElement(
	        'li',
	        { key: getItemKey(item), className: classNames, ref: setRef },
	        renderItem(item)
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          className = _props3.className,
	          list = _props3.list;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('cp-expandable-list', className) },
	        _react2.default.createElement(
	          'ul',
	          null,
	          list.map(this.renderListItem)
	        ),
	        this.renderExpandButton()
	      );
	    }
	  }]);
	
	  return ExpandableList;
	}(_baseBcReactComponent2.default);
	
	exports.default = ExpandableList;
	
	
	ExpandableList.propTypes = {
	  collapseCount: _react.PropTypes.number.isRequired,
	  className: _react.PropTypes.string,
	  itemClassName: _react.PropTypes.string,
	  list: _react.PropTypes.oneOfType([_react.PropTypes.array, _reactImmutableProptypes2.default.list]).isRequired,
	  renderItem: _react.PropTypes.func.isRequired,
	  getItemKey: _react.PropTypes.func.isRequired,
	  renderExpandButtonLabel: _react.PropTypes.func
	};

/***/ },
/* 1409 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ExpandableList = __webpack_require__(1408);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ExpandableList).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1410 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _utilsAccessibility = __webpack_require__(95);
	
	var _expandButton = __webpack_require__(275);
	
	var _expandButton2 = _interopRequireDefault(_expandButton);
	
	__webpack_require__(2707);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ExpandablePanel = function (_BcReactComponent) {
	  _inherits(ExpandablePanel, _BcReactComponent);
	
	  function ExpandablePanel(props) {
	    _classCallCheck(this, ExpandablePanel);
	
	    var _this = _possibleConstructorReturn(this, (ExpandablePanel.__proto__ || Object.getPrototypeOf(ExpandablePanel)).call(this, props));
	
	    _this.state = {
	      expanded: false
	    };
	    _this.bindAll('handleToggle', 'renderHeading', 'renderBodyContent');
	    _this.contentRef = null;
	    return _this;
	  }
	
	  _createClass(ExpandablePanel, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (!prevState.expanded && this.state.expanded && this.contentRef) {
	        (0, _utilsAccessibility.setFocusWithinElement)(this.contentRef);
	      }
	    }
	  }, {
	    key: 'handleToggle',
	    value: function handleToggle() {
	      this.setState({ expanded: !this.state.expanded });
	    }
	  }, {
	    key: 'renderExpandButton',
	    value: function renderExpandButton() {
	      var renderExpandButtonLabel = this.props.renderExpandButtonLabel;
	
	
	      return _react2.default.createElement(_expandButton2.default, { handleToggle: this.handleToggle, expanded: this.state.expanded, renderLabel: renderExpandButtonLabel });
	    }
	  }, {
	    key: 'renderHeading',
	    value: function renderHeading() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'panel-heading' },
	        this.props.renderHeaderContent(),
	        this.renderExpandButton()
	      );
	    }
	  }, {
	    key: 'renderBodyContent',
	    value: function renderBodyContent() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'panel-body', ref: function ref(el) {
	            _this2.contentRef = el;
	          } },
	        this.props.children
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var className = this.props.className;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('cp-expandable-panel panel', className) },
	        this.renderHeading(),
	        this.state.expanded ? this.renderBodyContent() : null
	      );
	    }
	  }]);
	
	  return ExpandablePanel;
	}(_baseBcReactComponent2.default);
	
	exports.default = ExpandablePanel;
	
	
	ExpandablePanel.propTypes = {
	  className: _react.PropTypes.string,
	  renderHeaderContent: _react.PropTypes.func,
	  renderExpandButtonLabel: _react.PropTypes.func,
	  renderBodyContent: _react.PropTypes.func,
	  children: _bcPropTypes.childrenShape
	};

/***/ },
/* 1411 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ExpandablePanel = __webpack_require__(1410);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ExpandablePanel).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1412 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _utilsString = __webpack_require__(375);
	
	var _expandButton = __webpack_require__(275);
	
	var _expandButton2 = _interopRequireDefault(_expandButton);
	
	__webpack_require__(2708);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ExpandableText = function (_BcReactComponent) {
	  _inherits(ExpandableText, _BcReactComponent);
	
	  function ExpandableText(props) {
	    _classCallCheck(this, ExpandableText);
	
	    var _this = _possibleConstructorReturn(this, (ExpandableText.__proto__ || Object.getPrototypeOf(ExpandableText)).call(this, props));
	
	    _this.bindAll('handleToggle');
	
	    _this.state = {
	      expanded: false
	    };
	    return _this;
	  }
	
	  _createClass(ExpandableText, [{
	    key: 'handleToggle',
	    value: function handleToggle() {
	      this.setState({ expanded: !this.state.expanded });
	    }
	  }, {
	    key: 'renderExpandButton',
	    value: function renderExpandButton() {
	      return _react2.default.createElement(_expandButton2.default, { handleToggle: this.handleToggle, expanded: this.state.expanded });
	    }
	  }, {
	    key: 'renderExpandedText',
	    value: function renderExpandedText() {
	      var text = this.props.text;
	      var expanded = this.state.expanded;
	
	
	      return _react2.default.createElement(
	        'span',
	        { className: (0, _classnames2.default)('expanded-text', { 'sr-only': !expanded }) },
	        text
	      );
	    }
	  }, {
	    key: 'renderTruncatedText',
	    value: function renderTruncatedText(truncatedText) {
	      if (this.state.expanded) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'span',
	        { className: 'truncated-text', 'aria-hidden': true },
	        truncatedText
	      );
	    }
	  }, {
	    key: 'renderContent',
	    value: function renderContent() {
	      var _props = this.props,
	          text = _props.text,
	          truncateCount = _props.truncateCount;
	
	      var truncatedText = (0, _utilsString.truncate)(text, { desiredLength: truncateCount });
	
	      if (text.length > truncatedText.length) {
	        return _react2.default.createElement(
	          'span',
	          null,
	          this.renderExpandedText(),
	          this.renderTruncatedText(truncatedText),
	          this.renderExpandButton()
	        );
	      }
	
	      return _react2.default.createElement(
	        'span',
	        null,
	        text
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('cp-expandable-text', this.props.className) },
	        this.renderContent()
	      );
	    }
	  }]);
	
	  return ExpandableText;
	}(_baseBcReactComponent2.default);
	
	exports.default = ExpandableText;
	
	
	ExpandableText.propTypes = {
	  text: _react.PropTypes.string.isRequired,
	  truncateCount: _react.PropTypes.number,
	  className: _react.PropTypes.string
	};
	
	ExpandableText.defaultProps = {
	  truncateCount: 250
	};

/***/ },
/* 1413 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ExpandableText = __webpack_require__(1412);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ExpandableText).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1414 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseIcons = __webpack_require__(10);
	
	__webpack_require__(2709);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FeaturedContentBlock = function (_BcReactComponent) {
	  _inherits(FeaturedContentBlock, _BcReactComponent);
	
	  function FeaturedContentBlock(props) {
	    _classCallCheck(this, FeaturedContentBlock);
	
	    var _this = _possibleConstructorReturn(this, (FeaturedContentBlock.__proto__ || Object.getPrototypeOf(FeaturedContentBlock)).call(this, props));
	
	    _this.bindAll('renderContentLink');
	    return _this;
	  }
	
	  _createClass(FeaturedContentBlock, [{
	    key: 'renderEditLink',
	    value: function renderEditLink(content) {
	      if (this.props.editable) {
	        var location =  true ? encodeURIComponent(window.location.href) : '';
	        return _react2.default.createElement(
	          'a',
	          { href: '/featured_content/edit/' + content.get('id') + '?previous_location=' + location },
	          _react2.default.createElement(_baseIcons.Pencil, null)
	        );
	      }
	
	      return _react2.default.createElement('noop', null);
	    }
	  }, {
	    key: 'renderContentLink',
	    value: function renderContentLink(content, index) {
	      // TODO: Google Analytics - catagory: outbound, label: Featured Content
	      var type = this.props.type;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'content-link', key: type.toLowerCase() + '-link-' + index },
	        _react2.default.createElement(
	          'a',
	          { href: content.get('url'), target: '_blank', rel: 'noopener noreferrer' },
	          content.get('title'),
	          ' ',
	          _react2.default.createElement(_baseIcons.NewTab, { color: null })
	        ),
	        this.renderEditLink(content)
	      );
	    }
	  }, {
	    key: 'renderContentList',
	    value: function renderContentList() {
	      var _this2 = this;
	
	      var _props = this.props,
	          list = _props.list,
	          twoColumns = _props.twoColumns,
	          numContentToShow = _props.numContentToShow,
	          type = _props.type;
	
	      var chunkSize = Math.ceil(list.count() / (twoColumns ? 2.0 : 1));
	      var visibleList = list.slice(0, numContentToShow);
	      return _immutable2.default.Range(0, visibleList.count(), chunkSize).map(function (chunkStart, index) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'content-links', key: type.toLowerCase() + '-links-' + index },
	          visibleList.slice(chunkStart, chunkStart + chunkSize).map(_this2.renderContentLink)
	        );
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-featured-content-block' },
	        _react2.default.createElement(
	          'div',
	          { className: 'featured-content-card clearfix' },
	          FeaturedContentBlock.renderContentTypeHeader(this.props.type),
	          _react2.default.createElement(
	            'div',
	            { className: 'content-container' },
	            this.renderContentList()
	          )
	        )
	      );
	    }
	  }], [{
	    key: 'renderContentTypeIcon',
	    value: function renderContentTypeIcon(type) {
	      var iconProps = {
	        className: 'content-type-icon medium',
	        color: '#0081b0'
	      };
	
	      switch (type) {
	        case 'RESOURCE':
	          return _react2.default.createElement(_baseIcons.Laptop, iconProps);
	        case 'BLOG_POST':
	          return _react2.default.createElement(_baseIcons.TextFile, iconProps);
	        case 'EVENT':
	          return _react2.default.createElement(_baseIcons.CalendarEmpty, iconProps);
	        default:
	          return null;
	      }
	    }
	  }, {
	    key: 'renderContentTypeHeader',
	    value: function renderContentTypeHeader(type) {
	      var typeSuffix = type === 'RESOURCE' ? 'online_resource' : type.toLowerCase();
	      return _react2.default.createElement(
	        'div',
	        { className: 'content-header' },
	        FeaturedContentBlock.renderContentTypeIcon(type),
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'section_title_featured_content_' + typeSuffix + 's' })
	      );
	    }
	  }]);
	
	  return FeaturedContentBlock;
	}(_baseBcReactComponent2.default);
	
	FeaturedContentBlock.propTypes = {
	  type: _react.PropTypes.string.isRequired,
	  list: _reactImmutableProptypes2.default.list.isRequired,
	  twoColumns: _react.PropTypes.boolean,
	  editable: _react.PropTypes.boolean,
	  numContentToShow: _react.PropTypes.number // Number of links to show
	};
	
	FeaturedContentBlock.defaultProps = {
	  numContentToShow: 5,
	  editable: false
	};
	
	exports.default = FeaturedContentBlock;

/***/ },
/* 1415 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FeaturedContentBlock = __webpack_require__(1414);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FeaturedContentBlock).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1416 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _utilsFormat = __webpack_require__(96);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormatIndicator = function (_BcReactComponent) {
	  _inherits(FormatIndicator, _BcReactComponent);
	
	  function FormatIndicator() {
	    _classCallCheck(this, FormatIndicator);
	
	    return _possibleConstructorReturn(this, (FormatIndicator.__proto__ || Object.getPrototypeOf(FormatIndicator)).apply(this, arguments));
	  }
	
	  _createClass(FormatIndicator, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'span',
	        { className: 'cp-format-indicator', 'data-test-id': 'format-indicator' },
	        _react2.default.createElement('span', { className: (0, _utilsFormat.getIconForFormat)(this.props.format), 'aria-hidden': true }),
	        '\xA0',
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'FORMAT.' + this.props.format.toLowerCase() })
	      );
	    }
	  }]);
	
	  return FormatIndicator;
	}(_baseBcReactComponent2.default);
	
	FormatIndicator.propTypes = {
	  format: _react2.default.PropTypes.string
	};
	
	exports.default = FormatIndicator;

/***/ },
/* 1417 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var addToShelf = function addToShelf(shelfToAdd) {
	  return {
	    eventCategory: 'AddToShelf',
	    eventAction: 'click',
	    eventLabel: shelfToAdd
	  };
	};
	
	exports.default = addToShelf;

/***/ },
/* 1418 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var openStackMap = function openStackMap(callNumber) {
	  return {
	    eventCategory: 'stack-map',
	    eventAction: 'clicked',
	    eventLabel: callNumber,
	    sendToLibrary: true
	  };
	};
	
	exports.default = openStackMap;

/***/ },
/* 1419 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var toggleDrawer = function toggleDrawer() {
	  return {
	    eventCategory: 'User',
	    eventAction: 'Toggled Drawer'
	  };
	};
	
	exports.default = toggleDrawer;

/***/ },
/* 1420 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ALWAYS_AVAILABLE = 999999;
	
	var HoldCounts = function HoldCounts(_ref) {
	  var availableCopies = _ref.availableCopies,
	      heldCopies = _ref.heldCopies,
	      totalCopies = _ref.totalCopies,
	      _ref$localeKey = _ref.localeKey,
	      localeKey = _ref$localeKey === undefined ? 'holdCount' : _ref$localeKey,
	      _ref$tagElement = _ref.tagElement,
	      tagElement = _ref$tagElement === undefined ? 'span' : _ref$tagElement,
	      props = _objectWithoutProperties(_ref, ['availableCopies', 'heldCopies', 'totalCopies', 'localeKey', 'tagElement']);
	
	  if (availableCopies === 0 && totalCopies !== ALWAYS_AVAILABLE && totalCopies !== 0) {
	    var TagElement = tagElement;
	    return _react2.default.createElement(
	      _reactIntl.FormattedMessage,
	      { id: localeKey, values: { heldCopies: heldCopies.toString(), totalCopies: totalCopies } },
	      function (message) {
	        return _react2.default.createElement(
	          TagElement,
	          _extends({}, props, { className: 'cp-hold-counts' }),
	          message
	        );
	      }
	    );
	  }
	  return _react2.default.createElement('noop', null);
	};
	
	HoldCounts.propTypes = {
	  localeKey: _react.PropTypes.string,
	  heldCopies: _react.PropTypes.number,
	  totalCopies: _react.PropTypes.number,
	  availableCopies: _react.PropTypes.number,
	  tagElement: _react.PropTypes.string
	};
	
	exports.default = HoldCounts;

/***/ },
/* 1421 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	__webpack_require__(2710);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Print = function (_BcReactComponent) {
	  _inherits(Print, _BcReactComponent);
	
	  function Print() {
	    _classCallCheck(this, Print);
	
	    return _possibleConstructorReturn(this, (Print.__proto__ || Object.getPrototypeOf(Print)).apply(this, arguments));
	  }
	
	  _createClass(Print, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-print' },
	        this.props.children
	      );
	    }
	  }]);
	
	  return Print;
	}(_baseBcReactComponent2.default);
	
	Print.propTypes = {
	  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node])
	};
	
	exports.default = Print;

/***/ },
/* 1422 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Print = __webpack_require__(1421);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Print).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1423 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function MessageIfExists(_ref) {
	  var _ref$component = _ref.component,
	      Component = _ref$component === undefined ? _reactIntl.FormattedMessage : _ref$component,
	      intl = _ref.intl,
	      props = _objectWithoutProperties(_ref, ['component', 'intl']);
	
	  if (intl.messages[props.id]) {
	    return _react2.default.createElement(Component, props);
	  }
	  return null;
	}
	
	MessageIfExists.propTypes = {
	  id: _react.PropTypes.string.isRequired,
	  intl: _reactIntl.intlShape,
	  component: _react2.default.PropTypes.oneOfType([_react.PropTypes.instanceOf(_react2.default.Component), _react2.default.PropTypes.func]),
	  children: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.arrayOf(_react2.default.PropTypes.node), _react2.default.PropTypes.node, _react2.default.PropTypes.func])
	};
	
	exports.default = (0, _reactIntl.injectIntl)(MessageIfExists);

/***/ },
/* 1424 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _MessageIfExists = __webpack_require__(1423);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MessageIfExists).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1425 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function MessageWithFallback(_ref) {
	  var children = _ref.children,
	      _ref$component = _ref.component,
	      component = _ref$component === undefined ? _reactIntl.FormattedMessage : _ref$component,
	      intl = _ref.intl,
	      props = _objectWithoutProperties(_ref, ['children', 'component', 'intl']);
	
	  if (intl.messages[props.id]) {
	    var Component = component;
	    return _react2.default.createElement(Component, props);
	  }
	  return children;
	}
	
	MessageWithFallback.propTypes = {
	  id: _react.PropTypes.string.isRequired,
	  intl: _reactIntl.intlShape,
	  component: _react.PropTypes.instanceOf(_react2.default.Component),
	  children: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.arrayOf(_react2.default.PropTypes.node), _react2.default.PropTypes.node])
	};
	
	exports.default = (0, _reactIntl.injectIntl)(MessageWithFallback);

/***/ },
/* 1426 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseAlerts = __webpack_require__(36);
	
	var _baseButtons = __webpack_require__(12);
	
	var _localizationMessageWithFallback = __webpack_require__(537);
	
	var _localizationMessageWithFallback2 = _interopRequireDefault(_localizationMessageWithFallback);
	
	var _utilsBrowser = __webpack_require__(59);
	
	var _baseCheckbox = __webpack_require__(58);
	
	var _baseCheckbox2 = _interopRequireDefault(_baseCheckbox);
	
	__webpack_require__(2711);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var REMEMBER_ME_COOKIE = 'remember_me';
	
	var LoginForm = function (_BcReactComponent) {
	  _inherits(LoginForm, _BcReactComponent);
	
	  function LoginForm(props) {
	    _classCallCheck(this, LoginForm);
	
	    var _this = _possibleConstructorReturn(this, (LoginForm.__proto__ || Object.getPrototypeOf(LoginForm)).call(this, props));
	
	    _this.state = {
	      username: (0, _utilsBrowser.getCookie)(REMEMBER_ME_COOKIE) || '',
	      password: '',
	      rememberMe: !!(0, _utilsBrowser.getCookie)(REMEMBER_ME_COOKIE)
	    };
	    _this.bindAll('handleSubmit', 'handleUsernameChange', 'handlePasswordChange', 'handleRememberMeChange', 'onFocus');
	    return _this;
	  }
	
	  _createClass(LoginForm, [{
	    key: 'handleUsernameChange',
	    value: function handleUsernameChange(e) {
	      this.setState({ username: e.target.value });
	    }
	  }, {
	    key: 'onFocus',
	    value: function onFocus() {
	      if (this._input === document.activeElement) {
	        document.body.scrollTop = 0;
	      }
	    }
	  }, {
	    key: 'handlePasswordChange',
	    value: function handlePasswordChange(e) {
	      this.setState({ password: e.target.value });
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(e) {
	      e.preventDefault();
	
	      // Store cookie if rememberMe is true, otherwise delete it by setting expiration to a time in the past
	      var expiryDate = new Date();
	      expiryDate.setFullYear(expiryDate.getFullYear() + (this.state.rememberMe ? 10 : -10));
	      (0, _utilsBrowser.setCookie)(REMEMBER_ME_COOKIE, this.state.username, { expires: expiryDate, path: '/' });
	
	      this.props.login(this.state.username, this.state.password);
	    }
	  }, {
	    key: 'handleRememberMeChange',
	    value: function handleRememberMeChange(checked) {
	      this.setState({
	        rememberMe: checked
	      });
	    }
	  }, {
	    key: 'renderLoginError',
	    value: function renderLoginError() {
	      if (!this.props.loginErrorMessage) return false;
	
	      return _react2.default.createElement(
	        _baseAlerts.AlertFailure,
	        null,
	        _react2.default.createElement(
	          _localizationMessageWithFallback2.default,
	          { id: this.props.loginErrorMessage },
	          _react2.default.createElement(
	            'span',
	            null,
	            this.props.loginErrorMessage
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderGetCardLink',
	    value: function renderGetCardLink() {
	      var getCardLink = this.props.getCardLink;
	
	
	      if (getCardLink) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'get-card-link' },
	          _react2.default.createElement(
	            'a',
	            { href: getCardLink, 'data-test-id': 'get-card-link' },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'form_label_get_a_card' })
	          )
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'getPasswordType',
	    value: function getPasswordType() {
	      return this.props.numericPasswordRequired ? 'pin' : 'password';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-login-form', ref: function ref(el) {
	            _this2._root = el;
	          } },
	        _react2.default.createElement(
	          'form',
	          { onSubmit: this.handleSubmit },
	          this.renderLoginError(),
	          _react2.default.createElement(
	            'div',
	            { className: 'cp-login-form-wrap' },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group' },
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'login-username' },
	                _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'form_label_username_barcode' })
	              ),
	              _react2.default.createElement('input', {
	                type: 'text',
	                name: 'login-username',
	                id: 'login-username',
	                ref: function ref(el) {
	                  return _this2._input = el;
	                },
	                className: 'form-control username',
	                onFocus: this.onFocus,
	                value: this.state.username,
	                onChange: this.handleUsernameChange })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group' },
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'login-password', 'data-test-id': 'loginform-password-label' },
	                _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'form_label_' + this.getPasswordType() })
	              ),
	              _react2.default.createElement('input', {
	                type: 'password',
	                name: 'login-password',
	                id: 'login-password',
	                className: 'form-control password',
	                value: this.state.password,
	                onChange: this.handlePasswordChange })
	            ),
	            _react2.default.createElement(_baseCheckbox2.default, {
	              id: 'remember-me-on-device',
	              inline: true,
	              label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'form_label_remember_credentials_device' }),
	              checked: this.state.rememberMe,
	              labelTestId: 'remember-me',
	              handleChange: this.handleRememberMeChange }),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group' },
	              _react2.default.createElement(
	                'a',
	                { href: '/user/forgot' },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'form_label_forgot_' + this.getPasswordType() })
	              )
	            ),
	            _react2.default.createElement(
	              _baseButtons.PrimaryButton,
	              {
	                type: 'submit',
	                isLoading: this.props.loading },
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_submit' })
	            ),
	            _react2.default.createElement(
	              _baseButtons.Button,
	              {
	                type: 'reset',
	                handleClick: this.props.handleClose,
	                className: 'btn-link' },
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_cancel' })
	            ),
	            this.renderGetCardLink()
	          )
	        )
	      );
	    }
	  }]);
	
	  return LoginForm;
	}(_baseBcReactComponent2.default);
	
	LoginForm.propTypes = {
	  handleClose: _react.PropTypes.func,
	  loading: _react.PropTypes.bool,
	  login: _react.PropTypes.func.isRequired,
	  numericPasswordRequired: _react.PropTypes.bool,
	  loginErrorMessage: _react.PropTypes.string,
	  getCardLink: _react.PropTypes.string
	};
	
	exports.default = LoginForm;

/***/ },
/* 1427 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseFullScreenOverlay = __webpack_require__(45);
	
	var _baseFullScreenOverlay2 = _interopRequireDefault(_baseFullScreenOverlay);
	
	var _loginForm = __webpack_require__(538);
	
	var _loginForm2 = _interopRequireDefault(_loginForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LoginOverlay = function (_BcReactComponent) {
	  _inherits(LoginOverlay, _BcReactComponent);
	
	  function LoginOverlay() {
	    _classCallCheck(this, LoginOverlay);
	
	    return _possibleConstructorReturn(this, (LoginOverlay.__proto__ || Object.getPrototypeOf(LoginOverlay)).apply(this, arguments));
	  }
	
	  _createClass(LoginOverlay, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if ('parentIFrame' in window && prevProps.loginOverlayOpen !== this.props.loginOverlayOpen) {
	        var resizer = window.parentIFrame;
	        if (this.props.loginOverlayOpen) {
	          resizer.autoResize(false);
	          resizer.size(this._loginForm._root.parentElement.scrollHeight);
	        } else if (!this.props.loginOverlayOpen) {
	          resizer.autoResize(true);
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          handleClose = _props.handleClose,
	          login = _props.login,
	          loginErrorMessage = _props.loginErrorMessage,
	          loginOverlayOpen = _props.loginOverlayOpen,
	          loading = _props.loading,
	          numericPasswordRequired = _props.numericPasswordRequired,
	          getCardLink = _props.getCardLink;
	
	      return _react2.default.createElement(
	        _baseFullScreenOverlay2.default,
	        { open: loginOverlayOpen, handleClose: handleClose, className: (0, _classnames2.default)('cp-login-overlay', { 'is-widget': this.context.isWidget }) },
	        _react2.default.createElement(_loginForm2.default, {
	          ref: function ref(el) {
	            _this2._loginForm = el;
	          },
	          login: login,
	          loginErrorMessage: loginErrorMessage,
	          handleClose: handleClose,
	          loading: loading,
	          numericPasswordRequired: numericPasswordRequired,
	          getCardLink: getCardLink })
	      );
	    }
	  }]);
	
	  return LoginOverlay;
	}(_baseBcReactComponent2.default);
	
	LoginOverlay.propTypes = {
	  login: _react.PropTypes.func.isRequired,
	  handleClose: _react.PropTypes.func.isRequired,
	  loginErrorMessage: _react.PropTypes.string,
	  loginOverlayOpen: _react.PropTypes.bool,
	  loading: _react.PropTypes.bool,
	  numericPasswordRequired: _react.PropTypes.bool,
	  getCardLink: _react.PropTypes.string
	};
	
	LoginOverlay.contextTypes = {
	  isWidget: _react.PropTypes.bool
	};
	
	exports.default = LoginOverlay;

/***/ },
/* 1428 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _LoginOverlay = __webpack_require__(1427);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_LoginOverlay).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1429 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseButtons = __webpack_require__(12);
	
	var _loginForm = __webpack_require__(538);
	
	var _loginForm2 = _interopRequireDefault(_loginForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  auth: _reactImmutableProptypes2.default.mapContains({
	    userInfo: _reactImmutableProptypes2.default.map
	  })
	};
	
	var Login = function (_BcReactComponent) {
	  _inherits(Login, _BcReactComponent);
	
	  function Login() {
	    _classCallCheck(this, Login);
	
	    return _possibleConstructorReturn(this, (Login.__proto__ || Object.getPrototypeOf(Login)).apply(this, arguments));
	  }
	
	  _createClass(Login, [{
	    key: 'render',
	    value: function render() {
	      var userInfo = this.props.auth.get('userInfo');
	      return _react2.default.createElement(
	        'div',
	        null,
	        userInfo ? Login.renderLoggedIn(this.props.authActions, userInfo) : Login.renderNotLoggedIn(this.props.authActions)
	      );
	    }
	  }], [{
	    key: 'renderNotLoggedIn',
	    value: function renderNotLoggedIn(authActions) {
	      return _react2.default.createElement(_loginForm2.default, { login: authActions.login });
	    }
	  }, {
	    key: 'renderLoggedIn',
	    value: function renderLoggedIn(authActions, userInfo) {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h1',
	          null,
	          userInfo.get('username')
	        ),
	        _react2.default.createElement(
	          _baseButtons.TextButton,
	          { handleClick: authActions.logout },
	          'Log Out'
	        )
	      );
	    }
	  }]);
	
	  return Login;
	}(_baseBcReactComponent2.default);
	
	Login.propTypes = propTypes;
	
	exports.default = Login;

/***/ },
/* 1430 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Login = __webpack_require__(1429);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Login).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1431 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _naturalSortBy = __webpack_require__(1432);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_naturalSortBy).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1432 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _lodash = __webpack_require__(16);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Array sort comparator to sort an array by provided field name alphanumerically.
	 * Supports pulling nested properties using _.get or .getIn if Immutable.
	 * E.g. a list of volumes such as 'v1', 'v3', 'v10', 'v2' will be sorted as
	 * 'v1', 'v2', 'v3', 'v10' rather than 'v1', 'v10', 'v2', 'v3'.
	 *
	 * Sorting by key solution adapted from http://stackoverflow.com/questions/979256/sorting-an-array-of-javascript-objects/979325#979325
	 * Alphanumeric sorting adapted from https://github.com/yobacca/node-natural-sort, which included sort direction and used ES2015
	 * eslint rules ignored in several places to maintain code without changes
	 *
	 * @param  {string} fieldName
	 * @param  {string} order - 'asc' or 'desc'
	 * @param  {boolean} caseSensitive
	 * @return {function}
	 */
	function naturalSortBy(fieldName, order, caseSensitive) {
	  var key = function key(item) {
	    if (fieldName) {
	      var normalizedField = _lodash2.default.split(fieldName, '.');
	      return _immutable2.default.Map.isMap(item) ? item.getIn(normalizedField) : _lodash2.default.get(item, normalizedField);
	    }
	
	    return item;
	  };
	
	  return function (valueA, valueB) {
	    var re = /(^([+\-]?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?(?=\D|\s|$))|^0x[\da-fA-F]+$|\d+)/g; // eslint-disable-line
	    var sre = /^\s+|\s+$/g; // trim pre-post whitespace
	    var snre = /\s+/g; // normalize all whitespace to single ' ' character
	    var dre = /(^([\w ]+,?[\w ]+)?[\w ]+,?[\w ]+\d+:\d+(:\d+)?[\w ]?|^\d{1,4}[\/\-]\d{1,4}[\/\-]\d{1,4}|^\w+, \w+ \d+, \d{4})/; // eslint-disable-line
	    var hre = /^0x[0-9a-f]+$/i;
	    var ore = /^0/;
	    var i = function i(s) {
	      return (!caseSensitive && ('' + s).toLowerCase() || '' + s).replace(sre, '');
	    }; // eslint-disable-line
	    // convert all to strings strip whitespace
	    var x = i(
	    // switch parameter for descending order
	    order === 'desc' ? key(valueB) : key(valueA));
	    var y = i(
	    // switch parameter for descending order
	    order === 'desc' ? key(valueA) : key(valueB));
	    // chunk/tokenize
	    var xN = x.replace(re, '\0$1\0').replace(/\0$/, '').replace(/^\0/, '').split('\0');
	    var yN = y.replace(re, '\0$1\0').replace(/\0$/, '').replace(/^\0/, '').split('\0');
	    // numeric, hex or date detection
	    var xD = parseInt(x.match(hre), 16) || xN.length !== 1 && Date.parse(x);
	    var yD = parseInt(y.match(hre), 16) || xD && y.match(dre) && Date.parse(y) || null; // eslint-disable-line
	    // normalize spaces; find floats not starting with '0',
	    // string or 0, if not defined (Clint Priest)
	    var normChunk = function normChunk(s, l) {
	      return (!s.match(ore) || l === 1) && parseFloat(s) || s.replace(snre, ' ').replace(sre, '') || 0 // eslint-disable-line
	      ;
	    };
	    var oFxNcL = void 0;
	    var oFyNcL = void 0;
	    // first try and sort Hex codes or Dates
	    if (yD) {
	      if (xD < yD) {
	        return -1;
	      } else if (xD > yD) {
	        return 1;
	      }
	    }
	    // natural sorting through split numeric strings and default strings
	    for (var cLoc = 0, xNl = xN.length, yNl = yN.length, numS = Math.max(xNl, yNl); cLoc < numS; cLoc++ // eslint-disable-line
	    ) {
	      oFxNcL = normChunk(xN[cLoc] || '', xNl);
	      oFyNcL = normChunk(yN[cLoc] || '', yNl);
	      // handle numeric vs string comparison - number < string - (Kyle Adams)
	      if (isNaN(oFxNcL) !== isNaN(oFyNcL)) {
	        return isNaN(oFxNcL) ? 1 : -1;
	      }
	      // if unicode use locale comparison
	      if (/[^\x00-\x80]/.test(oFxNcL + oFyNcL) && oFxNcL.localeCompare) {
	        // eslint-disable-line
	        var comp = oFxNcL.localeCompare(oFyNcL);
	        return comp / Math.abs(comp);
	      }
	      if (oFxNcL < oFyNcL) {
	        return -1;
	      } else if (oFxNcL > oFyNcL) {
	        return 1;
	      }
	    }
	    return 0;
	  };
	}
	
	exports.default = naturalSortBy;

/***/ },
/* 1433 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	__webpack_require__(2712);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NotFound = function (_BcReactComponent) {
	  _inherits(NotFound, _BcReactComponent);
	
	  function NotFound() {
	    _classCallCheck(this, NotFound);
	
	    return _possibleConstructorReturn(this, (NotFound.__proto__ || Object.getPrototypeOf(NotFound)).apply(this, arguments));
	  }
	
	  _createClass(NotFound, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-not-found' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          '404'
	        ),
	        _react2.default.createElement(
	          'h2',
	          null,
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'errors.pageDoesntExist' })
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'errors.urlDoesntExist' })
	        )
	      );
	    }
	  }]);
	
	  return NotFound;
	}(_baseBcReactComponent2.default);
	
	exports.default = NotFound;

/***/ },
/* 1434 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(16);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _optInFeedback = __webpack_require__(1439);
	
	var _optInFeedback2 = _interopRequireDefault(_optInFeedback);
	
	var _optInFeedbackSuccessMessage = __webpack_require__(1437);
	
	var _optInFeedbackSuccessMessage2 = _interopRequireDefault(_optInFeedbackSuccessMessage);
	
	var _optInPrompt = __webpack_require__(1441);
	
	var _optInPrompt2 = _interopRequireDefault(_optInPrompt);
	
	__webpack_require__(2713);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  allowOptOut: _react.PropTypes.bool,
	  allowDismiss: _react.PropTypes.bool,
	  bundle: _react.PropTypes.string.isRequired,
	  optedIn: _react.PropTypes.bool,
	  actions: _react.PropTypes.object.isRequired,
	  feedbackOpen: _react.PropTypes.bool,
	  feedbackCategory: _react.PropTypes.string.isRequired,
	  showFeedbackSuccess: _react.PropTypes.bool,
	  showAdditionalMessage: _react.PropTypes.bool,
	  isLoading: _react.PropTypes.bool,
	  location: _react.PropTypes.object
	};
	
	var OptInBanner = function (_BcReactComponent) {
	  _inherits(OptInBanner, _BcReactComponent);
	
	  function OptInBanner(props) {
	    _classCallCheck(this, OptInBanner);
	
	    var _this = _possibleConstructorReturn(this, (OptInBanner.__proto__ || Object.getPrototypeOf(OptInBanner)).call(this, props));
	
	    _this.bindAll('closeFeedbackSuccessMessage', 'dismissOptIn', 'openFeedbackForm', 'optOut', 'optIn', 'closeFeedbackForm');
	    return _this;
	  }
	
	  _createClass(OptInBanner, [{
	    key: 'renderFeedbackForm',
	    value: function renderFeedbackForm() {
	      if (this.props.feedbackOpen) {
	        return _react2.default.createElement(_optInFeedback2.default, {
	          feedbackCategory: this.props.feedbackCategory,
	          bundle: this.props.bundle,
	          closeFeedbackForm: this.closeFeedbackForm,
	          handleSubmit: this.props.actions.submitFeedback,
	          isLoading: this.props.isLoading });
	      }
	
	      return _react2.default.createElement('noop', null);
	    }
	  }, {
	    key: 'closeFeedbackForm',
	    value: function closeFeedbackForm() {
	      this.props.actions.closeFeedbackForm(this.props.bundle);
	    }
	  }, {
	    key: 'closeFeedbackSuccessMessage',
	    value: function closeFeedbackSuccessMessage() {
	      this.props.actions.closeFeedbackSuccessMessage(this.props.bundle);
	    }
	  }, {
	    key: 'dismissOptIn',
	    value: function dismissOptIn() {
	      this.props.actions.dismissOptIn(this.props.bundle);
	    }
	  }, {
	    key: 'openFeedbackForm',
	    value: function openFeedbackForm() {
	      this.props.actions.openFeedbackForm(this.props.bundle);
	    }
	  }, {
	    key: 'optOut',
	    value: function optOut() {
	      this.props.actions.optOut(this.props.bundle, _lodash2.default.pick(this.props.location, ['pathname', 'query']));
	    }
	  }, {
	    key: 'optIn',
	    value: function optIn() {
	      this.props.actions.optIn(this.props.bundle);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          bundle = _props.bundle,
	          optedIn = _props.optedIn,
	          showFeedbackSuccess = _props.showFeedbackSuccess,
	          showAdditionalMessage = _props.showAdditionalMessage,
	          allowOptOut = _props.allowOptOut,
	          allowDismiss = _props.allowDismiss;
	
	      if (showFeedbackSuccess) {
	        return _react2.default.createElement(_optInFeedbackSuccessMessage2.default, { close: this.closeFeedbackSuccessMessage });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-opt-in-banner bg-info clearfix' },
	        _react2.default.createElement(_optInPrompt2.default, {
	          optedIn: optedIn,
	          bundle: bundle,
	          allowOptOut: allowOptOut,
	          allowDismiss: allowDismiss,
	          showAdditionalMessage: showAdditionalMessage,
	          handleDismiss: this.dismissOptIn,
	          handleOpenFeedback: this.openFeedbackForm,
	          handleOptOut: this.optOut,
	          handleOptIn: this.optIn }),
	        this.renderFeedbackForm()
	      );
	    }
	  }]);
	
	  return OptInBanner;
	}(_baseBcReactComponent2.default);
	
	OptInBanner.propTypes = propTypes;
	
	exports.default = OptInBanner;

/***/ },
/* 1435 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _OptInBanner = __webpack_require__(1434);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_OptInBanner).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1436 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = OptInFeedbackSuccessMessage;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseAlerts = __webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function OptInFeedbackSuccessMessage(_ref) {
	  var close = _ref.close;
	
	  var timeout = setTimeout(close, 3000);
	  var handleDismiss = function handleDismiss() {
	    clearTimeout(timeout);
	    close();
	  };
	
	  return _react2.default.createElement(
	    _baseAlerts.AlertSuccess,
	    { className: 'feedback-thanks' },
	    _react2.default.createElement(_baseAlerts.AlertDismiss, { handleDismiss: handleDismiss }),
	    _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'opt_in_feedback_thanks' })
	  );
	}
	
	OptInFeedbackSuccessMessage.propTypes = {
	  close: _react2.default.PropTypes.func.isRequired
	};

/***/ },
/* 1437 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _OptInFeedbackSuccessMessage = __webpack_require__(1436);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_OptInFeedbackSuccessMessage).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1438 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseAccessibilityTextArea = __webpack_require__(117);
	
	var _baseAccessibilityTextArea2 = _interopRequireDefault(_baseAccessibilityTextArea);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseButtons = __webpack_require__(12);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	__webpack_require__(2714);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FEELINGS = ['positive', 'maybe', 'negative'];
	var COMMENT_MAX_LENGTH = 3800;
	
	var OptInFeedback = function (_BcReactComponent) {
	  _inherits(OptInFeedback, _BcReactComponent);
	
	  function OptInFeedback(props) {
	    _classCallCheck(this, OptInFeedback);
	
	    var _this = _possibleConstructorReturn(this, (OptInFeedback.__proto__ || Object.getPrototypeOf(OptInFeedback)).call(this, props));
	
	    _this.state = {
	      formData: {
	        feeling: null,
	        comment: ''
	      }
	    };
	
	    _this.bindAll('handleFeelingSelect', 'handleSubmit', 'handleCommentChange');
	    return _this;
	  }
	
	  _createClass(OptInFeedback, [{
	    key: 'handleSubmit',
	    value: function handleSubmit(e) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      this.props.handleSubmit(this.props.bundle, _extends({}, this.state.formData, OptInFeedback.getBrowserInformation(), {
	        category: this.props.feedbackCategory,
	        optIn: true
	      }));
	    }
	  }, {
	    key: 'handleFeelingSelect',
	    value: function handleFeelingSelect(e) {
	      this.setState({
	        formData: _extends({}, this.state.formData, {
	          feeling: e.target.value
	        })
	      });
	    }
	  }, {
	    key: 'handleCommentChange',
	    value: function handleCommentChange(value) {
	      this.setState({
	        formData: _extends({}, this.state.formData, {
	          comment: value
	        })
	      });
	    }
	  }, {
	    key: 'renderFeelingOptions',
	    value: function renderFeelingOptions() {
	      var _this2 = this;
	
	      return FEELINGS.map(function (feeling) {
	        return _react2.default.createElement(
	          'span',
	          { key: feeling },
	          _react2.default.createElement(
	            'label',
	            { className: 'radio-inline', htmlFor: 'overall-feeling-feel-' + feeling },
	            _react2.default.createElement('input', {
	              type: 'radio',
	              name: 'overall-feeling',
	              id: 'overall-feeling-feel-' + feeling,
	              required: true,
	              value: feeling,
	              onChange: _this2.handleFeelingSelect,
	              checked: _this2.state.formData.feeling === feeling,
	              'aria-describedby': 'overall-feeling' }),
	            _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
	              id: 'opt_in_feeling_' + feeling + '_' + _this2.props.bundle,
	              defaultMessage: _this2.props.intl.formatMessage({ id: 'opt_in_feeling_' + feeling }) })
	          ),
	          _react2.default.createElement(
	            _baseScreenReaderMessage2.default,
	            { id: 'overall-feeling' },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'group_search_feedback_feeling' })
	          )
	        );
	      });
	    }
	  }, {
	    key: 'renderCommentBox',
	    value: function renderCommentBox() {
	      if (!this.state.formData.feeling) {
	        return null;
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'form-group' },
	        _react2.default.createElement(
	          'label',
	          {
	            htmlFor: 'feedback-message',
	            id: 'feedback-message-label',
	            className: 'control-label' },
	          _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'opt_in_' + this.props.bundle + '_heading' })
	        ),
	        _react2.default.createElement(_baseAccessibilityTextArea2.default, {
	          labelledById: 'feedback-message-label',
	          describedById: 'feedback-message',
	          value: this.state.formData.comment,
	          required: true,
	          maxLength: COMMENT_MAX_LENGTH,
	          className: 'form-control',
	          handleChange: this.handleCommentChange }),
	        _react2.default.createElement(
	          _baseScreenReaderMessage2.default,
	          { id: 'feedback-message' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'group_search_feedback_additional_comments' })
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'form',
	        { className: 'cp-opt-in-feedback', onSubmit: this.handleSubmit },
	        _react2.default.createElement(
	          'div',
	          { className: 'form-group' },
	          this.renderFeelingOptions()
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'opt-in-textarea' },
	          this.renderCommentBox(),
	          _react2.default.createElement(
	            _baseButtons.PrimaryButton,
	            { type: 'submit', className: 'feedback-submit-btn', isLoading: this.props.isLoading },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'feedback_submit_feedback_btn' })
	          ),
	          _react2.default.createElement(
	            'a',
	            {
	              className: 'link-contextual',
	              href: '#close-feedback-form',
	              onClick: this.props.closeFeedbackForm },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_cancel' })
	          )
	        ),
	        _react2.default.createElement('div', { className: 'clear' })
	      );
	    }
	  }], [{
	    key: 'getBrowserInformation',
	    value: function getBrowserInformation() {
	      return {
	        screenResolution: window.screen.width + ' x ' + window.screen.height,
	        viewportSize: window.outerWidth + ' x ' + window.outerHeight,
	        referer: window.location.href,
	        userAgent: window.navigator.userAgent
	      };
	    }
	  }]);
	
	  return OptInFeedback;
	}(_baseBcReactComponent2.default);
	
	OptInFeedback.propTypes = {
	  feedbackCategory: _react2.default.PropTypes.string.isRequired,
	  bundle: _react2.default.PropTypes.string.isRequired,
	  handleSubmit: _react2.default.PropTypes.func.isRequired,
	  intl: _reactIntl.intlShape,
	  closeFeedbackForm: _react2.default.PropTypes.func.isRequired,
	  isLoading: _react2.default.PropTypes.bool
	};
	
	exports.default = (0, _reactIntl.injectIntl)(OptInFeedback);

/***/ },
/* 1439 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _OptInFeedback = __webpack_require__(1438);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_OptInFeedback).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1440 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseButtons = __webpack_require__(12);
	
	__webpack_require__(2715);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OptInPrompt = function (_BcReactComponent) {
	  _inherits(OptInPrompt, _BcReactComponent);
	
	  function OptInPrompt() {
	    _classCallCheck(this, OptInPrompt);
	
	    return _possibleConstructorReturn(this, (OptInPrompt.__proto__ || Object.getPrototypeOf(OptInPrompt)).apply(this, arguments));
	  }
	
	  _createClass(OptInPrompt, [{
	    key: 'renderPromptInfo',
	    value: function renderPromptInfo() {
	      var _props = this.props,
	          optedIn = _props.optedIn,
	          bundle = _props.bundle,
	          showAdditionalMessage = _props.showAdditionalMessage;
	
	
	      if (optedIn) {
	        var classNames = (0, _classnames2.default)('pull-left opt-in-cta col-xs-12 col-sm-8 col-md-9', {
	          'with-additional-info': showAdditionalMessage
	        });
	
	        return _react2.default.createElement(
	          'div',
	          { className: classNames },
	          _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'opt_in_active_' + bundle, className: 'test' }),
	          showAdditionalMessage && _react2.default.createElement(
	            'p',
	            { className: 'text-reg' },
	            _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
	              id: 'opt_in_active_additional_' + bundle,
	              defaultMessage: '' })
	          )
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'pull-left opt-in-cta col-xs-12 col-sm-7' },
	        _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'opt_in_inactive_' + bundle, className: 'test' })
	      );
	    }
	  }, {
	    key: 'renderOptOutLink',
	    value: function renderOptOutLink() {
	      return _react2.default.createElement(
	        _baseButtons.TextButton,
	        {
	          className: 'link-contextual',
	          role: 'button',
	          handleClick: this.props.handleOptOut },
	        _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'opt_in_disable_' + this.props.bundle })
	      );
	    }
	  }, {
	    key: 'renderDismissLink',
	    value: function renderDismissLink() {
	      return _react2.default.createElement(
	        _baseButtons.TextButton,
	        {
	          className: 'link-contextual',
	          role: 'button',
	          handleClick: this.props.handleDismiss },
	        _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'opt_in_decline_' + this.props.bundle })
	      );
	    }
	  }, {
	    key: 'renderActions',
	    value: function renderActions() {
	      var _props2 = this.props,
	          optedIn = _props2.optedIn,
	          bundle = _props2.bundle,
	          allowOptOut = _props2.allowOptOut,
	          allowDismiss = _props2.allowDismiss;
	
	
	      if (optedIn) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'pull-right opt-in-actions opted-in col-xs-12 col-sm-4 col-md-3' },
	          _react2.default.createElement(
	            'div',
	            { className: 'pull-right' },
	            allowOptOut && this.renderOptOutLink(),
	            _react2.default.createElement(
	              _baseButtons.HighlightButton,
	              { handleClick: this.props.handleOpenFeedback },
	              _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'opt_in_feedback_' + bundle })
	            )
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'opt-in-actions opted-out col-xs-12 col-sm-5' },
	        _react2.default.createElement(
	          'div',
	          { className: 'pull-right' },
	          allowDismiss && this.renderDismissLink(),
	          _react2.default.createElement(
	            _baseButtons.HighlightButton,
	            { handleClick: this.props.handleOptIn },
	            _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'opt_in_accept_' + bundle })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-opt-in-prompt clearfix row' },
	        this.renderPromptInfo(),
	        this.renderActions()
	      );
	    }
	  }]);
	
	  return OptInPrompt;
	}(_baseBcReactComponent2.default);
	
	OptInPrompt.propTypes = {
	  allowDismiss: _react.PropTypes.bool,
	  allowOptOut: _react.PropTypes.bool,
	  showAdditionalMessage: _react.PropTypes.bool,
	  bundle: _react.PropTypes.string.isRequired,
	  optedIn: _react.PropTypes.bool.isRequired,
	  handleOptIn: _react.PropTypes.func.isRequired,
	  handleDismiss: _react.PropTypes.func.isRequired,
	  handleOpenFeedback: _react.PropTypes.func.isRequired,
	  handleOptOut: _react.PropTypes.func.isRequired
	};
	
	OptInPrompt.defaultProps = {
	  allowOptOut: true,
	  allowDismiss: true,
	  showAdditionalMessage: true
	};
	
	exports.default = OptInPrompt;

/***/ },
/* 1441 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _OptInPrompt = __webpack_require__(1440);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_OptInPrompt).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1442 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _optInBanner = __webpack_require__(1435);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_optInBanner).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1443 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(16);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _reactRouter = __webpack_require__(17);
	
	var _utilsPagination = __webpack_require__(1565);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseButtons = __webpack_require__(12);
	
	var _baseIcons = __webpack_require__(10);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	__webpack_require__(2716);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Pagination = function (_BcReactComponent) {
	  _inherits(Pagination, _BcReactComponent);
	
	  function Pagination(props) {
	    _classCallCheck(this, Pagination);
	
	    var _this = _possibleConstructorReturn(this, (Pagination.__proto__ || Object.getPrototypeOf(Pagination)).call(this, props));
	
	    _this.bindAll('handleNextClick', 'handlePrevClick', 'handlePaginationNumberClick');
	    return _this;
	  }
	
	  _createClass(Pagination, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var autoFocus = this.props.autoFocus;
	      // if element allows autofocus && a fetch has completed && the results/route have changed
	
	      if (autoFocus && this.hasChanged(prevProps)) {
	        this.focusResultsCount();
	      }
	    }
	  }, {
	    key: 'hasChanged',
	    value: function hasChanged(prevProps) {
	      var _props = this.props,
	          limit = _props.limit,
	          page = _props.page,
	          pages = _props.pages,
	          count = _props.count,
	          router = _props.router;
	
	      return prevProps.limit !== limit || prevProps.page !== page || prevProps.pages !== pages || prevProps.count !== count || prevProps.router.location !== router.location;
	    }
	  }, {
	    key: 'focusResultsCount',
	    value: function focusResultsCount() {
	      if (this._resultsCount) {
	        this._resultsCount.focus();
	      }
	    }
	  }, {
	    key: 'updatePage',
	    value: function updatePage(page) {
	      if (this.props.updatePage) {
	        return this.props.updatePage(page);
	      }
	
	      return this.props.router.push(this.getHrefForPage(page));
	    }
	  }, {
	    key: 'getHrefForPage',
	    value: function getHrefForPage(page) {
	      var _props$router = this.props.router,
	          createHref = _props$router.createHref,
	          location = _props$router.location;
	
	      return createHref(_extends({}, location, { query: _extends({}, location.query, _defineProperty({}, this.props.queryField, page)) }));
	    }
	  }, {
	    key: 'handlePaginationNumberClick',
	    value: function handlePaginationNumberClick(e) {
	      this.updatePage(parseInt(e.currentTarget.getAttribute('data-page'), 10));
	    }
	  }, {
	    key: 'renderScreenReaderTextForPage',
	    value: function renderScreenReaderTextForPage(page) {
	      return _react2.default.createElement(
	        _baseScreenReaderMessage2.default,
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Search.jumpToPage', values: { page: page, isCurrentPage: page === this.props.page ? 'yes' : 'no' } })
	      );
	    }
	  }, {
	    key: 'renderPageNumbers',
	    value: function renderPageNumbers() {
	      var _this2 = this;
	
	      return _lodash2.default.map((0, _utilsPagination.pageRange)(this.props.page, this.props.pages), function (i) {
	        var isCurrentPage = _this2.props.page === i;
	        var isDisabled = _this2.props.isFetching || isCurrentPage;
	        var classString = isCurrentPage ? 'current-page' : 'btn-link';
	
	        return _react2.default.createElement(
	          'li',
	          { key: i, className: isDisabled ? 'disabled' : '' },
	          _react2.default.createElement(
	            _baseButtons.Button,
	            {
	              dataKey: 'page-link',
	              className: classString,
	              href: _this2.getHrefForPage(i),
	              tagName: isDisabled ? 'button' : 'a',
	              flat: true,
	              disabled: isDisabled,
	              'data-page': i,
	              'aria-disabled': isDisabled,
	              handleClick: _this2.handlePaginationNumberClick },
	            _react2.default.createElement(
	              'span',
	              { 'aria-hidden': true },
	              i
	            ),
	            _this2.renderScreenReaderTextForPage(i)
	          )
	        );
	      });
	    }
	  }, {
	    key: 'handleNextClick',
	    value: function handleNextClick() {
	      this.updatePage(this.props.page + 1);
	    }
	  }, {
	    key: 'handlePrevClick',
	    value: function handlePrevClick() {
	      this.updatePage(this.props.page - 1);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          page = _props2.page,
	          pages = _props2.pages,
	          isFetching = _props2.isFetching,
	          limit = _props2.limit,
	          count = _props2.count,
	          className = _props2.className,
	          showPages = _props2.showPages,
	          textKey = _props2.textKey;
	
	      var startIndex = (page - 1) * limit + 1;
	      var endIndex = _lodash2.default.min([page * limit, count]);
	      var previousDisabled = isFetching || (0, _utilsPagination.isPreviousDisabled)(page, pages);
	      var nextDisabled = isFetching || (0, _utilsPagination.isNextDisabled)(page, pages);
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-pagination ' + className, 'data-key': 'pagination-component' },
	        _react2.default.createElement(
	          _reactIntl.FormattedMessage,
	          { id: textKey, values: { start: startIndex, end: endIndex, count: count } },
	          function (message) {
	            return _react2.default.createElement(
	              'span',
	              { 'data-key': 'pagination-text', className: 'pagination-text', tabIndex: '-1', ref: function ref(el) {
	                  _this3._resultsCount = el;
	                } },
	              message
	            );
	          }
	        ),
	        _react2.default.createElement(
	          'ul',
	          { className: 'btn-group', role: 'group' },
	          _react2.default.createElement(
	            'li',
	            { className: previousDisabled ? 'disabled' : '' },
	            _react2.default.createElement(
	              _baseButtons.DefaultButton,
	              {
	                dataKey: 'previous-btn',
	                className: 'previous-btn',
	                flat: true,
	                disabled: previousDisabled,
	                'aria-disabled': previousDisabled,
	                handleClick: this.handlePrevClick,
	                href: this.getHrefForPage(page - 1),
	                tagName: previousDisabled ? 'button' : 'a' },
	              _react2.default.createElement(_baseIcons.Angle.Left, { className: 'extra-extra-small' }),
	              this.renderScreenReaderTextForPage(page - 1)
	            )
	          ),
	          showPages ? this.renderPageNumbers() : null,
	          _react2.default.createElement(
	            'li',
	            { className: nextDisabled ? 'disabled' : '' },
	            _react2.default.createElement(
	              _baseButtons.DefaultButton,
	              {
	                dataKey: 'next-btn',
	                className: 'next-btn',
	                flat: true,
	                disabled: nextDisabled,
	                'aria-disabled': nextDisabled,
	                handleClick: this.handleNextClick,
	                href: this.getHrefForPage(page + 1),
	                tagName: nextDisabled ? 'button' : 'a' },
	              _react2.default.createElement(_baseIcons.Angle.Right, { className: 'extra-extra-small' }),
	              this.renderScreenReaderTextForPage(page + 1)
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Pagination;
	}(_baseBcReactComponent2.default);
	
	Pagination.propTypes = {
	  page: _react.PropTypes.number.isRequired,
	  pages: _react.PropTypes.number.isRequired,
	  textKey: _react.PropTypes.string,
	  updatePage: _react.PropTypes.func,
	  autoFocus: _react.PropTypes.bool,
	  isFetching: _react.PropTypes.bool.isRequired,
	  showPages: _react.PropTypes.bool,
	  limit: _react.PropTypes.number,
	  count: _react.PropTypes.number,
	  className: _react.PropTypes.string,
	  queryField: _react.PropTypes.string
	};
	
	Pagination.defaultProps = {
	  textKey: 'paginationInfo',
	  queryField: 'page',
	  className: ''
	};
	
	// We need the withRefs so we can access the pagination count and focus it in the outer components
	exports.default = (0, _reactRouter.withRouter)(Pagination, { withRef: true });

/***/ },
/* 1444 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(16);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseIcons = __webpack_require__(10);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	var _baseButtons = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PRINT_WINDOW_NAME = 'printWindow';
	var PRINT_WINDOW_OPTIONS = (0, _lodash2.default)({
	  resizable: 1,
	  status: 0,
	  toolbar: 0,
	  scrollbars: 1,
	  location: 0,
	  menubar: 0
	}).map(function (value, key) {
	  return key + '=' + value;
	}).value().join(',');
	
	function PrintButton(_ref) {
	  var url = _ref.url,
	      iconColor = _ref.iconColor,
	      className = _ref.className;
	
	  var onClick = function onClick(e) {
	    if (e.target && typeof e.target.blur === 'function') {
	      e.target.blur();
	    }
	
	    // This is to prevent Microsoft Edge from exploding
	    function stopFocus(focusEvent) {
	      focusEvent.preventDefault();
	      window.removeEventListener('focus', stopFocus);
	    }
	    window.addEventListener('focus', stopFocus);
	
	    window.open(url, PRINT_WINDOW_NAME, PRINT_WINDOW_OPTIONS);
	  };
	
	  return _react2.default.createElement(
	    _baseButtons.DefaultButton,
	    { className: 'cp-print-button ' + className, 'data-test-id': 'print-view-button', href: url, tagName: 'a', flat: true, handleClick: onClick },
	    _react2.default.createElement(_baseIcons.Printer, {
	      color: iconColor }),
	    _react2.default.createElement(
	      _baseScreenReaderMessage2.default,
	      null,
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'print_view' })
	    )
	  );
	}
	
	PrintButton.propTypes = {
	  className: _react.PropTypes.string,
	  iconColor: _react.PropTypes.string,
	  url: _react.PropTypes.string.isRequired
	};
	
	exports.default = PrintButton;

/***/ },
/* 1445 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PrintButton = __webpack_require__(1444);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PrintButton).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1446 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseButtons = __webpack_require__(12);
	
	__webpack_require__(2717);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function PrintButtonsToolbar(_ref) {
	  var children = _ref.children,
	      numItemsToPrint = _ref.numItemsToPrint;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'cp-print-buttons-toolbar' },
	    _react2.default.createElement(
	      _baseButtons.PrimaryButton,
	      { className: 'btn-sm', handleClick: function handleClick() {
	          return window.print();
	        } },
	      _react2.default.createElement(_reactIntl.FormattedMessage, {
	        id: 'print_items',
	        values: {
	          num_items: numItemsToPrint
	        } })
	    ),
	    children,
	    _react2.default.createElement(
	      _baseButtons.PrimaryButton,
	      { className: 'btn-sm', handleClick: function handleClick() {
	          return window.close();
	        } },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_close' })
	    )
	  );
	}
	
	PrintButtonsToolbar.propTypes = {
	  numItemsToPrint: _react.PropTypes.number.isRequired,
	  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node]).isRequired
	};
	
	exports.default = PrintButtonsToolbar;

/***/ },
/* 1447 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PrintButtonsToolbar = __webpack_require__(1446);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PrintButtonsToolbar).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1448 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseButtons = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function PrintLoadNextButton(_ref) {
	  var numToLoad = _ref.numToLoad,
	      handleClick = _ref.handleClick,
	      currentPage = _ref.currentPage,
	      totalPages = _ref.totalPages,
	      _ref$isLoading = _ref.isLoading,
	      isLoading = _ref$isLoading === undefined ? false : _ref$isLoading;
	
	  if (currentPage >= totalPages) {
	    return null;
	  }
	
	  return _react2.default.createElement(
	    _baseButtons.PrimaryButton,
	    { className: 'btn-sm', handleClick: handleClick, isLoading: isLoading },
	    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'load_next', values: { num_items: numToLoad } })
	  );
	}
	
	PrintLoadNextButton.propTypes = {
	  numToLoad: _react.PropTypes.number.isRequired,
	  handleClick: _react.PropTypes.func.isRequired,
	  isLoading: _react.PropTypes.bool,
	  totalPages: _react.PropTypes.number.isRequired,
	  currentPage: _react.PropTypes.number.isRequired
	};
	
	exports.default = PrintLoadNextButton;

/***/ },
/* 1449 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PrintLoadNextButton = __webpack_require__(1448);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PrintLoadNextButton).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1450 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseTable = __webpack_require__(91);
	
	__webpack_require__(2718);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function PrintTable(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'cp-print-table' },
	    _react2.default.createElement(_baseTable.Table, props)
	  );
	}
	
	exports.default = PrintTable;

/***/ },
/* 1451 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PrintTable = __webpack_require__(1450);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PrintTable).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1452 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _availabilityStatus = __webpack_require__(361);
	
	var _availabilityStatus2 = _interopRequireDefault(_availabilityStatus);
	
	var _holdCounts = __webpack_require__(364);
	
	var _holdCounts2 = _interopRequireDefault(_holdCounts);
	
	var _baseIcons = __webpack_require__(10);
	
	var _sharedProbeLogo = __webpack_require__(548);
	
	var _sharedProbeLogo2 = _interopRequireDefault(_sharedProbeLogo);
	
	__webpack_require__(2719);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function HoldingsProbe(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)('cp-holdings-probe', props.rollupStatus.toLowerCase()) },
	    _react2.default.createElement(
	      'div',
	      { className: 'library-image' },
	      _react2.default.createElement(_sharedProbeLogo2.default, { circled: true, small: true, siteId: props.siteId })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'holdings-info' },
	      _react2.default.createElement(
	        'a',
	        { className: 'library-name', href: props.bibUrl, target: '_blank', rel: 'noopener noreferrer' },
	        props.libraryName,
	        ' ',
	        _react2.default.createElement(_baseIcons.Arrows.long.Right, null)
	      ),
	      _react2.default.createElement(_availabilityStatus2.default, { status: props.availabilityStatus, rollUpStatus: props.rollupStatus }),
	      !props.availabilityStatus ? _react2.default.createElement(
	        'a',
	        { href: props.bibUrl, className: 'check-avail-link', target: '_blank', rel: 'noopener noreferrer' },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'check_digital_availability' })
	      ) : null,
	      _react2.default.createElement(_holdCounts2.default, {
	        availableCopies: props.availableCopies,
	        totalCopies: props.totalCopies,
	        heldCopies: props.heldCopies })
	    )
	  );
	}
	
	HoldingsProbe.propTypes = {
	  libraryName: _react.PropTypes.string.isRequired,
	  siteId: _react.PropTypes.string.isRequired,
	  availabilityStatus: _react.PropTypes.string.isRequired,
	  rollupStatus: _react.PropTypes.string.isRequired,
	  availableCopies: _react.PropTypes.number.isRequired,
	  heldCopies: _react.PropTypes.number.isRequired,
	  totalCopies: _react.PropTypes.number.isRequired,
	  bibUrl: _react.PropTypes.string.isRequired
	};
	
	exports.default = HoldingsProbe;

/***/ },
/* 1453 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _HoldingsProbe = __webpack_require__(1452);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_HoldingsProbe).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1454 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = SearchProbeList;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _utilsImmutable = __webpack_require__(374);
	
	var _searchProbe = __webpack_require__(540);
	
	var _searchProbe2 = _interopRequireDefault(_searchProbe);
	
	__webpack_require__(2720);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function SearchProbeList(_ref) {
	  var probes = _ref.probes;
	
	  if (!probes || (0, _utilsImmutable.isEmpty)(probes)) {
	    return null;
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'cp-search-probe-list' },
	    _react2.default.createElement(
	      'h2',
	      null,
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'searchProbeAlsoAt' })
	    ),
	    _react2.default.createElement(
	      'ul',
	      { className: 'probe-list' },
	      probes.map(function (probe) {
	        return _react2.default.createElement(
	          'li',
	          { key: probe.siteId },
	          _react2.default.createElement(_searchProbe2.default, probe)
	        );
	      })
	    )
	  );
	}
	
	SearchProbeList.propTypes = {
	  probes: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	    siteId: _react.PropTypes.string.isRequired,
	    libraryName: _react.PropTypes.string.isRequired,
	    count: _react.PropTypes.number,
	    searchUrl: _react.PropTypes.string.isRequired
	  }))
	};

/***/ },
/* 1455 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SearchProbeList = __webpack_require__(1454);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SearchProbeList).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1456 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _sharedProbeLogo = __webpack_require__(548);
	
	var _sharedProbeLogo2 = _interopRequireDefault(_sharedProbeLogo);
	
	var _baseIcons = __webpack_require__(10);
	
	__webpack_require__(2721);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SearchProbe = function SearchProbe(_ref) {
	  var searchUrl = _ref.searchUrl,
	      libraryName = _ref.libraryName,
	      count = _ref.count,
	      siteId = _ref.siteId;
	  return count > 0 ? _react2.default.createElement(
	    'div',
	    { className: 'cp-search-probe' },
	    _react2.default.createElement(
	      'div',
	      { className: 'cp-avatar' },
	      _react2.default.createElement(_sharedProbeLogo2.default, { className: 'library-logo', siteId: siteId, small: true, circled: true })
	    ),
	    _react2.default.createElement(
	      'a',
	      { href: searchUrl, target: '_blank', rel: 'noopener noreferrer', className: 'search-probe-link' },
	      _react2.default.createElement(
	        'div',
	        { className: 'library-name' },
	        libraryName,
	        '\xA0',
	        _react2.default.createElement(_baseIcons.Arrows.long.Right, { color: '#333' })
	      ),
	      _react2.default.createElement(
	        _reactIntl.FormattedMessage,
	        { id: 'searchProbeCount', values: { count: count } },
	        function (message) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'result-count' },
	            message
	          );
	        }
	      )
	    )
	  ) : null;
	};
	
	SearchProbe.propTypes = {
	  siteId: _react.PropTypes.string.isRequired,
	  libraryName: _react.PropTypes.string.isRequired,
	  count: _react.PropTypes.number,
	  searchUrl: _react.PropTypes.string.isRequired
	};
	
	exports.default = SearchProbe;

/***/ },
/* 1457 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _lodash = __webpack_require__(16);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactDom = __webpack_require__(104);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	var _baseIcons = __webpack_require__(10);
	
	var _baseButtons = __webpack_require__(12);
	
	var _utilsAccessibility = __webpack_require__(95);
	
	__webpack_require__(2722);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var iconColorMap = {
	  gold: '#F4A204',
	  silver: '#999',
	  blue: '#02729E'
	};
	
	var iconStrokeColorMap = {
	  blue: '#035D80',
	  gold: '#9E5E15',
	  silver: '#666'
	};
	
	var Rating = function (_BcReactComponent) {
	  _inherits(Rating, _BcReactComponent);
	
	  function Rating(props) {
	    _classCallCheck(this, Rating);
	
	    var _this = _possibleConstructorReturn(this, (Rating.__proto__ || Object.getPrototypeOf(Rating)).call(this, props));
	
	    _this.state = {
	      selectedRating: 0
	    };
	
	    _this.bindAll('updateRating', 'handleRatingButtonClick', 'handleRemoveItemRating', 'renderStars');
	
	    _this.removeButtonRef = null;
	    return _this;
	  }
	
	  _createClass(Rating, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          rating = _props.rating,
	          readOnly = _props.readOnly;
	
	      if (rating && !readOnly) {
	        this.setState({
	          selectedRating: rating
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.timeout) {
	        clearTimeout(this.timeout);
	        this.timeout = null;
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      // If the remove button currently has focus, but it's about to be removed from the DOM,
	      // then move focus to the next focusable element on the page, othwerwise focus will be lost.
	      if (this.props.rating && !nextProps.rating && this.removeButtonRef && document.activeElement) {
	        var button = _reactDom2.default.findDOMNode(this.removeButtonRef); // eslint-disable-line react/no-find-dom-node
	
	        if (button.contains(document.activeElement)) {
	          var nextFocusableElement = (0, _utilsAccessibility.getNextFocusableElement)(button);
	          if (nextFocusableElement) {
	            nextFocusableElement.focus();
	          }
	        }
	      }
	    }
	  }, {
	    key: 'updateRating',
	    value: function updateRating(selectedRating) {
	      if (this.props.isLoading) {
	        return;
	      }
	
	      this.setState({ selectedRating: selectedRating });
	    }
	  }, {
	    key: 'handleRatingButtonClick',
	    value: function handleRatingButtonClick(rating) {
	      var _this2 = this;
	
	      if (this.props.isLoading) {
	        return;
	      }
	
	      this.setState({ selectedRating: rating });
	      this.props.handleButtonClick(rating);
	
	      this.timeout = setTimeout(function () {
	        if (!_this2.props.isLoading) {
	          _this2.setState({
	            selectedRating: _this2.props.rating || 0
	          });
	        }
	        _this2.timeout = null;
	      }, 100);
	    }
	  }, {
	    key: 'handleRemoveItemRating',
	    value: function handleRemoveItemRating() {
	      if (this.props.isLoading) {
	        return;
	      }
	
	      this.setState({ selectedRating: 0 });
	      this.props.handleRemoveClick();
	    }
	  }, {
	    key: 'renderStars',
	    value: function renderStars() {
	      var stars = [];
	      var _props2 = this.props,
	          id = _props2.id,
	          readOnly = _props2.readOnly,
	          variant = _props2.variant;
	
	      var rating = this.props.rating || 0;
	      var normalizedRating = void 0;
	
	      if (readOnly) {
	        // If the rating is read only, round up to the nearest star
	        normalizedRating = Math.round(rating / 10) * 10;
	      } else if (this.state.selectedRating > 0) {
	        normalizedRating = this.state.selectedRating;
	      } else {
	        normalizedRating = rating;
	      }
	
	      var halfStars = normalizedRating % 20 > 0 ? 1 : 0;
	
	      var color = normalizedRating === 0 ? iconColorMap.silver : iconColorMap[variant];
	      var strokeColor = normalizedRating === 0 ? iconStrokeColorMap.silver : iconStrokeColorMap[variant];
	
	      // Full stars
	      _lodash2.default.times(Math.floor(normalizedRating / 20), function (n) {
	        stars.push(_react2.default.createElement(_baseIcons.StarFull, { key: 'star-full-' + n + '-' + id, className: 'rating-star star-full', color: color, strokeColor: strokeColor }));
	      });
	
	      // Half stars
	      _lodash2.default.times(halfStars, function (n) {
	        stars.push(_react2.default.createElement(_baseIcons.StarHalf, { key: 'star-half-' + n + '-' + id, className: 'rating-star star-half', color: color, strokeColor: strokeColor }));
	      });
	
	      // Empty stars
	      _lodash2.default.times(5 - Math.round(normalizedRating / 20), function (n) {
	        stars.push(_react2.default.createElement(_baseIcons.StarEmpty, { key: 'star-empty-' + n + '-' + id, className: 'rating-star star-empty', color: color, strokeColor: strokeColor }));
	      });
	
	      return stars;
	    }
	  }, {
	    key: 'renderButtons',
	    value: function renderButtons() {
	      var _this3 = this;
	
	      var _props3 = this.props,
	          id = _props3.id,
	          readOnly = _props3.readOnly;
	
	
	      if (readOnly) {
	        return _react2.default.createElement('noop', null);
	      }
	
	      return _lodash2.default.times(10, function (n) {
	        var value = (n + 1) * 10;
	        var count = (n + 1) / 2;
	        return _react2.default.createElement(
	          _baseButtons.DefaultButton,
	          {
	            key: 'rating-button-' + n + '-' + id,
	            className: 'rating-button',
	            role: 'button',
	            onMouseOver: function onMouseOver() {
	              return _this3.updateRating(value);
	            },
	            onTouchStart: function onTouchStart() {
	              return _this3.handleRatingButtonClick(value);
	            },
	            onFocus: function onFocus() {
	              return _this3.updateRating(value);
	            },
	            handleClick: function handleClick() {
	              return _this3.handleRatingButtonClick(value);
	            } },
	          _react2.default.createElement(
	            _baseScreenReaderMessage2.default,
	            null,
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ratings_count', values: { count: count } })
	          )
	        );
	      });
	    }
	  }, {
	    key: 'renderRemoveButton',
	    value: function renderRemoveButton() {
	      var _this4 = this;
	
	      var _props4 = this.props,
	          rating = _props4.rating,
	          readOnly = _props4.readOnly,
	          isLoading = _props4.isLoading;
	
	      if (rating && !readOnly || isLoading) {
	        return _react2.default.createElement(
	          _baseButtons.IconButton,
	          {
	            className: 'remove-rating-button',
	            isLoading: isLoading,
	            handleClick: this.handleRemoveItemRating,
	            ref: function ref(el) {
	              _this4.removeButtonRef = el;
	            } },
	          _react2.default.createElement(_baseIcons.Cross, { className: 'extra-small' }),
	          _react2.default.createElement(
	            _baseScreenReaderMessage2.default,
	            null,
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'remove_rating' })
	          )
	        );
	      }
	
	      return _react2.default.createElement('noop', null);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var _props5 = this.props,
	          id = _props5.id,
	          rating = _props5.rating,
	          readOnly = _props5.readOnly,
	          variant = _props5.variant;
	
	
	      if (!rating && readOnly) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-rating ' + variant, 'aria-labelledby': id },
	        _react2.default.createElement(
	          'span',
	          { className: 'sr-only', id: id },
	          _react2.default.createElement(_reactIntl.FormattedMessage, {
	            id: 'screenReaderStarRating',
	            values: {
	              rating: rating / 20
	            } })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'rating-star-wrap' },
	          this.renderStars()
	        ),
	        _react2.default.createElement(
	          'div',
	          {
	            role: 'region',
	            id: 'rating-select-' + id,
	            className: 'rating-star-button-wrap',
	            onMouseLeave: function onMouseLeave() {
	              return _this5.updateRating(0);
	            },
	            onBlur: function onBlur() {
	              return _this5.updateRating(0);
	            } },
	          _react2.default.createElement(
	            'div',
	            { 'aria-controls': 'rating-select-' + id, 'aria-label': 'Rating stars' },
	            this.renderButtons()
	          )
	        ),
	        this.renderRemoveButton()
	      );
	    }
	  }]);
	
	  return Rating;
	}(_baseBcReactComponent2.default);
	
	Rating.propTypes = {
	  rating: _react.PropTypes.number, // integer 0 - 100
	  id: _react.PropTypes.string.isRequired,
	  variant: _react.PropTypes.oneOf(['blue', 'gold', 'silver']),
	  readOnly: _react.PropTypes.bool,
	  handleButtonClick: _react.PropTypes.func,
	  handleRemoveClick: _react.PropTypes.func,
	  isLoading: _react.PropTypes.bool
	};
	
	Rating.defaultProps = {
	  rating: 0,
	  variant: 'gold',
	  isLoading: false,
	  readOnly: false
	};
	
	Rating.displayName = 'Rating';
	
	exports.default = Rating;

/***/ },
/* 1458 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _sharedSliderJacketCover = __webpack_require__(1508);
	
	var _sharedSliderJacketCover2 = _interopRequireDefault(_sharedSliderJacketCover);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	__webpack_require__(2723);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RecommendationItem = function (_BcReactComponent) {
	  _inherits(RecommendationItem, _BcReactComponent);
	
	  function RecommendationItem(props) {
	    _classCallCheck(this, RecommendationItem);
	
	    var _this = _possibleConstructorReturn(this, (RecommendationItem.__proto__ || Object.getPrototypeOf(RecommendationItem)).call(this, props));
	
	    _this.bindAll('handleRecommendationClick');
	    return _this;
	  }
	
	  _createClass(RecommendationItem, [{
	    key: 'handleRecommendationClick',
	    value: function handleRecommendationClick() {
	      this.props.handleClick(this.props.item);
	    }
	  }, {
	    key: 'renderAvailableCount',
	    value: function renderAvailableCount() {
	      if (this.props.item.availableCopies) {
	        return _react2.default.createElement(
	          _reactIntl.FormattedMessage,
	          { id: 'while_you_wait_available_count', values: { count: this.props.item.availableCopies } },
	          function (message) {
	            return _react2.default.createElement(
	              'span',
	              { className: 'available-count' },
	              message
	            );
	          }
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          item = _props.item,
	          divProps = _objectWithoutProperties(_props, ['item']);
	
	      delete divProps.handleClick;
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, divProps, { className: 'cp-recommendation-item' }),
	        _react2.default.createElement(_sharedSliderJacketCover2.default, { key: item.id, item: item, handleClick: this.handleClickRecommendation }),
	        this.renderAvailableCount()
	      );
	    }
	  }]);
	
	  return RecommendationItem;
	}(_baseBcReactComponent2.default);
	
	exports.default = RecommendationItem;

/***/ },
/* 1459 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _RecommendationItem = __webpack_require__(1458);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RecommendationItem).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1460 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _map2 = __webpack_require__(2937);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseLoader = __webpack_require__(138);
	
	var _baseLoader2 = _interopRequireDefault(_baseLoader);
	
	var _carouselBase = __webpack_require__(1404);
	
	var _carouselBase2 = _interopRequireDefault(_carouselBase);
	
	var _recommendationItem = __webpack_require__(1459);
	
	var _recommendationItem2 = _interopRequireDefault(_recommendationItem);
	
	var _baseButtons = __webpack_require__(12);
	
	var _baseIcons = __webpack_require__(10);
	
	__webpack_require__(2724);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Recommendations = function (_BcReactComponent) {
	  _inherits(Recommendations, _BcReactComponent);
	
	  function Recommendations(props) {
	    _classCallCheck(this, Recommendations);
	
	    var _this = _possibleConstructorReturn(this, (Recommendations.__proto__ || Object.getPrototypeOf(Recommendations)).call(this, props));
	
	    _this.state = {
	      isExpanded: false
	    };
	
	    _this.bindAll('handleClick', 'renderSlider');
	    return _this;
	  }
	
	  _createClass(Recommendations, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {/** Need that in test to make sure that component got rendered properly **/}
	  }, {
	    key: 'handleClick',
	    value: function handleClick() {
	      if (!this.props.loaded) {
	        this.props.getRecommendations(this.props.itemId);
	      }
	
	      this.setState({ isExpanded: !this.state.isExpanded });
	    }
	  }, {
	    key: 'renderSlider',
	    value: function renderSlider() {
	      var _props = this.props,
	          zeroResults = _props.zeroResults,
	          loaded = _props.loaded,
	          recommendations = _props.recommendations,
	          handleClickRecommendation = _props.handleClickRecommendation;
	
	      if (loaded && zeroResults) {
	        return _react2.default.createElement(
	          _reactIntl.FormattedMessage,
	          { id: 'while_you_wait_empty' },
	          function (message) {
	            return _react2.default.createElement(
	              'p',
	              { className: 'empty-result' },
	              message
	            );
	          }
	        );
	      }
	
	      if (loaded && !zeroResults) {
	        return _react2.default.createElement(
	          _carouselBase2.default.BaseCarousel,
	          {
	            buttonBackgroundColor: '#f9f9f9',
	            breakpointSettings: {
	              10000: {
	                useTouchArrows: false,
	                itemsPerPage: 5,
	                partiallyShowOffscreenItems: false,
	                showDots: true,
	                gutterSize: '25px'
	              },
	              787: {
	                useTouchArrows: false,
	                itemsPerPage: 4,
	                partiallyShowOffscreenItems: false,
	                showDots: true,
	                gutterSize: '25px'
	              },
	              610: {
	                useTouchArrows: false,
	                itemsPerPage: 3,
	                partiallyShowOffscreenItems: false,
	                showDots: true,
	                gutterSize: '25px'
	              },
	              525: {
	                useTouchArrows: false,
	                itemsPerPage: 2,
	                partiallyShowOffscreenItems: false,
	                showDots: true,
	                gutterSize: '25px'
	              }
	            },
	            titleData: {} },
	          (0, _map3.default)(recommendations, function (item) {
	            return _react2.default.createElement(_recommendationItem2.default, { key: item.id, item: item, handleClick: handleClickRecommendation });
	          })
	        );
	      }
	
	      return _react2.default.createElement(
	        _reactIntl.FormattedMessage,
	        { id: 'while_you_wait_loading' },
	        function (message) {
	          return _react2.default.createElement(_baseLoader2.default, { message: message });
	        }
	      );
	    }
	  }, {
	    key: 'renderSourceMessage',
	    value: function renderSourceMessage() {
	      if (this.state.isExpanded) {
	        return _react2.default.createElement(
	          _reactIntl.FormattedMessage,
	          { id: 'recommendations_powered_by', values: { service: this.props.type } },
	          function (message) {
	            return _react2.default.createElement(
	              'small',
	              { className: 'recommendation-source' },
	              message
	            );
	          }
	        );
	      }
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var isExpanded = this.state.isExpanded;
	
	      var recommendationsClass = (0, _classnames2.default)('cp-recommendations', { 'is-expanded': isExpanded });
	      return _react2.default.createElement(
	        'div',
	        { className: recommendationsClass },
	        _react2.default.createElement(
	          _baseButtons.TextButton,
	          { className: 'while-you-wait-toggle', 'data-test-id': 'whileyouwait-toggle', handleClick: this.handleClick },
	          _react2.default.createElement(
	            _baseIcons.IconWithBackground,
	            {
	              bgColor: '#cc441e',
	              icon: _react2.default.createElement(_baseIcons.Clock, null) },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'while_you_wait_title' }),
	            _react2.default.createElement(_baseIcons.Carets.Down, { className: (0, _classnames2.default)('resource-expand-icon', { rot90: !this.state.isExpanded }) })
	          ),
	          this.props.loaded && this.renderSourceMessage()
	        ),
	        this.state.isExpanded && this.renderSlider()
	      );
	    }
	  }]);
	
	  return Recommendations;
	}(_baseBcReactComponent2.default);
	
	Recommendations.propTypes = {
	  getRecommendations: _react.PropTypes.func.isRequired,
	  handleClickRecommendation: _react.PropTypes.func.isRequired,
	  itemId: _react.PropTypes.string.isRequired,
	  recommendations: _react.PropTypes.arrayOf(_react.PropTypes.object),
	  type: _react.PropTypes.string,
	  loaded: _react.PropTypes.bool
	};
	
	exports.default = Recommendations;

/***/ },
/* 1461 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Recommendations = __webpack_require__(1460);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Recommendations).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1462 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _featuredContentBlock = __webpack_require__(1415);
	
	var _featuredContentBlock2 = _interopRequireDefault(_featuredContentBlock);
	
	var _bcPropTypes = __webpack_require__(5);
	
	__webpack_require__(2725);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RecommendedFeaturedContent = function (_BcReactComponent) {
	  _inherits(RecommendedFeaturedContent, _BcReactComponent);
	
	  function RecommendedFeaturedContent() {
	    _classCallCheck(this, RecommendedFeaturedContent);
	
	    return _possibleConstructorReturn(this, (RecommendedFeaturedContent.__proto__ || Object.getPrototypeOf(RecommendedFeaturedContent)).apply(this, arguments));
	  }
	
	  _createClass(RecommendedFeaturedContent, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          libraryShortName = _props.libraryShortName,
	          content = _props.content;
	
	
	      if (content.isEmpty()) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-recommended-featured-content' },
	        _react2.default.createElement(
	          'h3',
	          { className: 'content-recommended-by' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, {
	            id: 'related_resources',
	            values: { library_short_name: libraryShortName } })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'content-container' },
	          content.entrySeq().map(function (_ref) {
	            var _ref2 = _slicedToArray(_ref, 2),
	                contentType = _ref2[0],
	                contentList = _ref2[1];
	
	            return _react2.default.createElement(_featuredContentBlock2.default, { key: contentType, list: contentList, type: contentType, twoColumns: content.size === 1 });
	          })
	        )
	      );
	    }
	  }]);
	
	  return RecommendedFeaturedContent;
	}(_baseBcReactComponent2.default);
	
	RecommendedFeaturedContent.propTypes = {
	  libraryShortName: _react.PropTypes.string.isRequired,
	  content: _react.PropTypes.shape({
	    BLOG_POST: _react.PropTypes.arrayOf(_bcPropTypes.featuredContentShape),
	    RESOURCE: _react.PropTypes.arrayOf(_bcPropTypes.featuredContentShape),
	    EVENT: _react.PropTypes.arrayOf(_bcPropTypes.featuredContentShape)
	  })
	};
	
	exports.default = RecommendedFeaturedContent;

/***/ },
/* 1463 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _RecommendedFeaturedContent = __webpack_require__(1462);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RecommendedFeaturedContent).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1464 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseInlineOverlay = __webpack_require__(83);
	
	var _baseButtons = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DuplicateSavedSearch = function (_BcReactComponent) {
	  _inherits(DuplicateSavedSearch, _BcReactComponent);
	
	  function DuplicateSavedSearch(props) {
	    _classCallCheck(this, DuplicateSavedSearch);
	
	    var _this = _possibleConstructorReturn(this, (DuplicateSavedSearch.__proto__ || Object.getPrototypeOf(DuplicateSavedSearch)).call(this, props));
	
	    _this.bindAll('handleReplace');
	    return _this;
	  }
	
	  _createClass(DuplicateSavedSearch, [{
	    key: 'handleReplace',
	    value: function handleReplace() {
	      var query = window.location.search;
	      this.props.replaceSearch(query);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-duplicate-saved-search' },
	        _react2.default.createElement(
	          'div',
	          { className: 'form-group' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'save_search_duplicate_prompt', values: { search_name: this.props.lastNameAttempt } })
	        ),
	        _react2.default.createElement(
	          _baseInlineOverlay.InlineOverlayFooter,
	          null,
	          _react2.default.createElement(
	            _baseButtons.PrimaryButton,
	            {
	              handleClick: this.handleReplace,
	              id: 'save_search_save',
	              isLoading: this.props.isSaving },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'save_search_replace' })
	          ),
	          _react2.default.createElement(
	            _baseButtons.DefaultButton,
	            { handleClick: this.props.chooseNewName, 'data-test-id': 'save-search-new-name' },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'save_search_new_name' })
	          ),
	          _react2.default.createElement(
	            _baseInlineOverlay.InlineOverlayCloseButton,
	            { className: 'btn btn-default' },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_cancel' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return DuplicateSavedSearch;
	}(_baseBcReactComponent2.default);
	
	DuplicateSavedSearch.propTypes = {
	  isSaving: _react.PropTypes.bool,
	  replaceSearch: _react.PropTypes.func.isRequired,
	  lastNameAttempt: _react.PropTypes.string.isRequired,
	  chooseNewName: _react.PropTypes.func.isRequired
	};
	
	exports.default = DuplicateSavedSearch;

/***/ },
/* 1465 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseInlineOverlay = __webpack_require__(83);
	
	var _baseAccessibilityTextField = __webpack_require__(228);
	
	var _baseAccessibilityTextField2 = _interopRequireDefault(_baseAccessibilityTextField);
	
	var _baseButtons = __webpack_require__(12);
	
	__webpack_require__(2726);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NewSavedSearch = function (_BcReactComponent) {
	  _inherits(NewSavedSearch, _BcReactComponent);
	
	  function NewSavedSearch(props) {
	    _classCallCheck(this, NewSavedSearch);
	
	    var _this = _possibleConstructorReturn(this, (NewSavedSearch.__proto__ || Object.getPrototypeOf(NewSavedSearch)).call(this, props));
	
	    _this.bindAll('handleSubmit', 'handleChange');
	    _this.state = {
	      value: _this.props.searchQuery
	    };
	    return _this;
	  }
	
	  _createClass(NewSavedSearch, [{
	    key: 'handleChange',
	    value: function handleChange(value) {
	      this.setState({ value: value });
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(e) {
	      e.preventDefault();
	      var query = window.location.search;
	      this.props.saveSearch(this.state.value, query);
	    }
	  }, {
	    key: 'renderErrorMessage',
	    value: function renderErrorMessage() {
	      var error = this.props.fieldErrors && this.props.fieldErrors.get('name');
	      if (error) {
	        return _react2.default.createElement(
	          _reactIntl.FormattedMessage,
	          { id: 'errors.' + error.get('classification'), defaultMessage: error.get('message') },
	          function (message) {
	            return _react2.default.createElement(
	              'span',
	              { className: 'help-block' },
	              message
	            );
	          }
	        );
	      }
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'form',
	        { onSubmit: this.handleSubmit, className: 'form-inline cp-new-saved-search', action: '', role: 'form', method: 'post' },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('form-group', { 'has-error': this.props.fieldErrors && this.props.fieldErrors.get('name') }) },
	          _react2.default.createElement(
	            'label',
	            { htmlFor: 'search-name', className: 'search-name-label' },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'save_search_label' })
	          ),
	          _react2.default.createElement(_baseAccessibilityTextField2.default, {
	            type: 'text',
	            id: 'search-name',
	            maxLength: 100,
	            required: true,
	            handleChange: this.handleChange,
	            value: this.state.value,
	            testId: 'saved-search-name-field',
	            errorKey: 'search-name_field',
	            className: 'form-control search-name-field' }),
	          this.renderErrorMessage()
	        ),
	        _react2.default.createElement(
	          _baseInlineOverlay.InlineOverlayFooter,
	          null,
	          _react2.default.createElement(
	            _baseButtons.PrimaryButton,
	            {
	              type: 'submit',
	              id: 'save_search_save',
	              'data-test-id': 'save-search-submit',
	              isLoading: this.props.isSaving },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'save_search_save' })
	          ),
	          _react2.default.createElement(
	            _baseInlineOverlay.InlineOverlayCloseButton,
	            { className: 'btn btn-default' },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_cancel' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return NewSavedSearch;
	}(_baseBcReactComponent2.default);
	
	NewSavedSearch.propTypes = {
	  isSaving: _react.PropTypes.bool,
	  searchQuery: _react.PropTypes.string,
	  saveSearch: _react.PropTypes.func.isRequired
	};
	
	exports.default = NewSavedSearch;

/***/ },
/* 1466 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = SavedSearchForm;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseInlineOverlay = __webpack_require__(83);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _newSavedSearch = __webpack_require__(543);
	
	var _newSavedSearch2 = _interopRequireDefault(_newSavedSearch);
	
	var _duplicateSavedSearch = __webpack_require__(542);
	
	var _duplicateSavedSearch2 = _interopRequireDefault(_duplicateSavedSearch);
	
	__webpack_require__(2727);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function SavedSearchForm(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'cp-saved-search-form', 'data-test-id': 'saved-search-form' },
	    _react2.default.createElement(
	      _baseInlineOverlay.InlineOverlay,
	      { handleClose: props.closeWorkflow },
	      _react2.default.createElement(
	        _baseInlineOverlay.InlineOverlayHeader,
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'save_search' })
	      ),
	      _react2.default.createElement(
	        _baseInlineOverlay.InlineOverlayBody,
	        null,
	        props.isDuplicate ? _react2.default.createElement(_duplicateSavedSearch2.default, {
	          isSaving: props.isSaving,
	          replaceSearch: props.replaceSearch,
	          lastNameAttempt: props.lastNameAttempt,
	          chooseNewName: props.chooseNewName }) : _react2.default.createElement(_newSavedSearch2.default, {
	          isSaving: props.isSaving,
	          saveSearch: props.saveSearch,
	          searchQuery: props.searchQuery,
	          fieldErrors: props.fieldErrors })
	      )
	    )
	  );
	}
	
	SavedSearchForm.propTypes = {
	  isSaving: _react.PropTypes.bool,
	  isDuplicate: _react.PropTypes.bool,
	  lastNameAttempt: _react.PropTypes.string,
	  searchQuery: _react.PropTypes.string,
	  saveSearch: _react.PropTypes.func.isRequired,
	  chooseNewName: _react.PropTypes.func.isRequired,
	  replaceSearch: _react.PropTypes.func.isRequired,
	  closeWorkflow: _react.PropTypes.func.isRequired,
	  fieldErrors: _reactImmutableProptypes2.default.map
	};

/***/ },
/* 1467 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SavedSearchForm = __webpack_require__(1466);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SavedSearchForm).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1468 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _savedSearchForm = __webpack_require__(1467);
	
	Object.defineProperty(exports, 'SavedSearchForm', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_savedSearchForm).default;
	  }
	});
	
	var _newSavedSearch = __webpack_require__(543);
	
	Object.defineProperty(exports, 'NewSavedSearch', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_newSavedSearch).default;
	  }
	});
	
	var _duplicateSavedSearch = __webpack_require__(542);
	
	Object.defineProperty(exports, 'DuplicateSavedSearch', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_duplicateSavedSearch).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1469 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseClearableTextField = __webpack_require__(273);
	
	var _baseClearableTextField2 = _interopRequireDefault(_baseClearableTextField);
	
	var _baseButtons = __webpack_require__(12);
	
	var _baseIcons = __webpack_require__(10);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	__webpack_require__(2728);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SearchBar = function (_BcReactComponent) {
	  _inherits(SearchBar, _BcReactComponent);
	
	  function SearchBar(props) {
	    _classCallCheck(this, SearchBar);
	
	    var _this = _possibleConstructorReturn(this, (SearchBar.__proto__ || Object.getPrototypeOf(SearchBar)).call(this, props));
	
	    _this.bindAll('handleQueryCleared', 'handleSubmit', 'updateQuery', 'handleQueryChange');
	    _this.state = { query: '' };
	    return _this;
	  }
	
	  _createClass(SearchBar, [{
	    key: 'updateQuery',
	    value: function updateQuery(query) {
	      if (this.state.query !== query) {
	        this.setState({ query: query });
	      }
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.updateQuery(this.props.query);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.updateQuery(nextProps.query);
	    }
	  }, {
	    key: 'handleQueryCleared',
	    value: function handleQueryCleared() {
	      this.handleQueryChange('');
	      if (this.props.handleClear) {
	        this.props.handleClear();
	      }
	    }
	  }, {
	    key: 'handleQueryChange',
	    value: function handleQueryChange(value) {
	      this.updateQuery(value);
	
	      if (this.props.handleChange) {
	        this.props.handleChange(value);
	      }
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(e) {
	      e.preventDefault();
	      this.props.handleSearch(this.state.query);
	    }
	  }, {
	    key: 'renderLabelText',
	    value: function renderLabelText() {
	      if (this.props.label) {
	        return this.props.label;
	      }
	
	      return _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ada_label_search_box' });
	    }
	  }, {
	    key: 'renderLabel',
	    value: function renderLabel() {
	      var label = _react2.default.createElement(
	        'label',
	        { id: 'search-bar-label', className: 'search-bar-label', htmlFor: 'search-bar-query' },
	        this.renderLabelText()
	      );
	
	      if (!this.props.label) {
	        return _react2.default.createElement(
	          _baseScreenReaderMessage2.default,
	          null,
	          label
	        );
	      }
	
	      return label;
	    }
	  }, {
	    key: 'renderFormWrapper',
	    value: function renderFormWrapper() {
	      // A non-empty form action is required for having a search button appear on iOS 8+
	      // See http://stackoverflow.com/questions/4864167/show-search-button-in-iphone-ipad-safari-keyboard
	      return _react2.default.createElement(
	        'form',
	        { className: 'search-bar-form', action: '.' },
	        this.renderContent()
	      );
	    }
	  }, {
	    key: 'renderContent',
	    value: function renderContent() {
	      var _props = this.props,
	          placeholder = _props.placeholder,
	          focus = _props.focus;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.renderLabel(),
	        _react2.default.createElement(
	          'div',
	          { className: 'search-bar-holder' },
	          _react2.default.createElement(_baseClearableTextField2.default, {
	            id: 'search-bar-query',
	            value: this.state.query,
	            labelledById: 'search-bar-label',
	            describedById: 'search-bar-input',
	            handleChange: this.handleQueryChange,
	            handleClear: this.handleQueryCleared,
	            hideClearButton: !this.state.query,
	            placeholder: placeholder,
	            focus: focus,
	            type: 'search',
	            className: 'search-box',
	            clearButtonSrText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ada_label_clear_search_text' }),
	            inputTestId: 'search-bar-query' }),
	          _react2.default.createElement(
	            _baseButtons.PrimaryButton,
	            {
	              className: 'search-btn',
	              handleClick: this.handleSubmit,
	              flat: true,
	              'data-test-id': 'search-button' },
	            _react2.default.createElement(
	              _baseScreenReaderMessage2.default,
	              null,
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_search' })
	            ),
	            _react2.default.createElement(_baseIcons.Search, { color: '' })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var isWrappedInForm = this.props.isWrappedInForm;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-search-bar' },
	        isWrappedInForm ? this.renderFormWrapper() : this.renderContent()
	      );
	    }
	  }]);
	
	  return SearchBar;
	}(_baseBcReactComponent2.default);
	
	SearchBar.propTypes = {
	  focus: _react.PropTypes.bool,
	  placeholder: _react.PropTypes.string,
	  query: _react.PropTypes.string.isRequired,
	  handleChange: _react.PropTypes.func,
	  handleSearch: _react.PropTypes.func.isRequired,
	  handleClear: _react.PropTypes.func,
	  isWrappedInForm: _react.PropTypes.bool
	};
	
	SearchBar.defaultProps = {
	  query: '',
	  isWrappedInForm: true
	};
	
	exports.default = SearchBar;

/***/ },
/* 1470 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BibBrief = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseByAuthorBlock = __webpack_require__(517);
	
	var _baseByAuthorBlock2 = _interopRequireDefault(_baseByAuthorBlock);
	
	var _sharedBibTitle = __webpack_require__(1477);
	
	var _sharedBibTitle2 = _interopRequireDefault(_sharedBibTitle);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _bcPropTypes = __webpack_require__(5);
	
	__webpack_require__(2729);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BibBrief = exports.BibBrief = function (_BcReactComponent) {
	  _inherits(BibBrief, _BcReactComponent);
	
	  function BibBrief(props) {
	    _classCallCheck(this, BibBrief);
	
	    var _this = _possibleConstructorReturn(this, (BibBrief.__proto__ || Object.getPrototypeOf(BibBrief)).call(this, props));
	
	    _this.bindAll('focusOnTitle');
	    return _this;
	  }
	
	  _createClass(BibBrief, [{
	    key: 'getBib',
	    value: function getBib() {
	      return this.props.bib ? this.props.bib : _immutable2.default.fromJS({
	        title: this.props.fallbackTitle || this.props.intl.formatMessage({ id: 'undetermined_item' }),
	        id: ''
	      });
	    }
	  }, {
	    key: 'getAuthors',
	    value: function getAuthors() {
	      var bib = this.getBib();
	      var authors = bib.get('authors', _immutable2.default.List());
	
	      if (bib.get('multiscriptAuthor')) {
	        authors = authors.unshift(bib.get('multiscriptAuthor'));
	      }
	
	      return authors;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          titleTag = _props.titleTag,
	          children = _props.children,
	          anchorTarget = _props.anchorTarget,
	          renderTitleAsLink = _props.renderTitleAsLink,
	          renderAuthorsAsLink = _props.renderAuthorsAsLink,
	          renderIcon = _props.renderIcon,
	          truncateTitleOptions = _props.truncateTitleOptions;
	
	      var bib = this.getBib();
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-bib-brief' },
	        _react2.default.createElement(_sharedBibTitle2.default, {
	          title: bib.get('title'),
	          format: bib.get('format'),
	          subtitle: bib.get('subtitle'),
	          primaryLanguage: bib.get('primaryLanguage'),
	          multiscriptTitle: bib.get('multiscriptTitle'),
	          ref: function ref(el) {
	            return _this2._bibTitle = el;
	          },
	          id: bib.get('id'),
	          titleTag: titleTag,
	          target: anchorTarget,
	          renderAsLink: renderTitleAsLink,
	          renderIcon: renderIcon,
	          truncateOptions: truncateTitleOptions }),
	        _react2.default.createElement(_baseByAuthorBlock2.default, {
	          authors: this.getAuthors(),
	          target: anchorTarget,
	          renderAsLink: renderAuthorsAsLink }),
	        children
	      );
	    }
	  }, {
	    key: 'focusOnTitle',
	    value: function focusOnTitle() {
	      if (this._bibTitle) {
	        this._bibTitle.getWrappedInstance().focusOnTitle();
	      }
	    }
	  }]);
	
	  return BibBrief;
	}(_baseBcReactComponent2.default);
	
	BibBrief.displayName = 'BibBrief';
	
	BibBrief.defaultProps = {
	  children: null,
	  anchorTarget: '_parent',
	  renderTitleAsLink: true,
	  renderAuthorsAsLink: true
	};
	
	BibBrief.propTypes = {
	  bib: _bcPropTypes.bibBriefShape,
	  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node]),
	  renderIcon: _react.PropTypes.func,
	  titleTag: _react.PropTypes.string,
	  anchorTarget: _react.PropTypes.string,
	  renderTitleAsLink: _react.PropTypes.bool,
	  renderAuthorsAsLink: _react.PropTypes.bool,
	  truncateTitleOptions: _bcPropTypes.truncateOptionsShape,
	  fallBackTitle: _react.PropTypes.string
	};
	
	exports.default = (0, _reactIntl.injectIntl)(BibBrief);

/***/ },
/* 1471 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = BibScreenReaderDescription;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _baseByAuthorBlock = __webpack_require__(517);
	
	var _baseByAuthorBlock2 = _interopRequireDefault(_baseByAuthorBlock);
	
	var _formatIndicator = __webpack_require__(177);
	
	var _formatIndicator2 = _interopRequireDefault(_formatIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function BibScreenReaderDescription(_ref) {
	  var bibBrief = _ref.bibBrief;
	
	  var title = bibBrief.get('title');
	  var authors = bibBrief.get('authors');
	  var format = bibBrief.get('format');
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'cp-bib-screen-reader-description' },
	    title,
	    format ? _react2.default.createElement(_formatIndicator2.default, { format: format.toUpperCase() }) : null,
	    ' ',
	    _react2.default.createElement(_baseByAuthorBlock2.default, {
	      authors: authors,
	      renderAsLink: false })
	  );
	}
	
	BibScreenReaderDescription.propTypes = {
	  bibBrief: _reactImmutableProptypes2.default.map
	};

/***/ },
/* 1472 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _reactIntl = __webpack_require__(3);
	
	var _reactRouter = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function BibSeries(_ref) {
	  var series = _ref.series;
	
	  if (series && !series.isEmpty()) {
	    var name = series.get('name');
	    var volume = series.get('volume');
	    return _react2.default.createElement(
	      'span',
	      { className: 'cp-bib-series' },
	      _react2.default.createElement(
	        _reactRouter.IndexLink,
	        {
	          activeClassName: 'active-search-link',
	          to: { pathname: '/v2/search', query: { query: name, searchType: 'series' } } },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'seriesLabel', values: { name: name } })
	      ),
	      volume ? ' - ' + volume : null
	    );
	  }
	  return null;
	}
	
	BibSeries.displayName = 'BibSeries';
	BibSeries.propTypes = {
	  series: _reactImmutableProptypes2.default.mapContains({
	    name: _react.PropTypes.string,
	    volumeNumber: _react.PropTypes.number
	  })
	};
	
	exports.default = BibSeries;

/***/ },
/* 1473 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BibSeries = __webpack_require__(1472);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BibSeries).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1474 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function BibSubtitle(_ref) {
	  var subtitle = _ref.subtitle,
	      _ref$titleTag = _ref.titleTag,
	      titleTag = _ref$titleTag === undefined ? 'h5' : _ref$titleTag;
	
	  var TitleTag = titleTag; // This needs to start with an uppercase letter since its a component
	  if (subtitle) {
	    return _react2.default.createElement(
	      TitleTag,
	      { className: 'cp-subtitle' },
	      subtitle
	    );
	  }
	
	  return _react2.default.createElement('noop', null);
	}
	
	BibSubtitle.propTypes = {
	  subtitle: _react.PropTypes.string,
	  titleTag: _react.PropTypes.string
	};
	
	exports.default = BibSubtitle;

/***/ },
/* 1475 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BibSubtitle = __webpack_require__(1474);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BibSubtitle).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1476 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BibTitle = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	var _utilsLink = __webpack_require__(97);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _sharedBibSubtitle = __webpack_require__(1475);
	
	var _sharedBibSubtitle2 = _interopRequireDefault(_sharedBibSubtitle);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _utilsString = __webpack_require__(375);
	
	__webpack_require__(2730);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BibTitle = exports.BibTitle = function (_BcReactComponent) {
	  _inherits(BibTitle, _BcReactComponent);
	
	  function BibTitle(props) {
	    _classCallCheck(this, BibTitle);
	
	    var _this = _possibleConstructorReturn(this, (BibTitle.__proto__ || Object.getPrototypeOf(BibTitle)).call(this, props));
	
	    _this.bindAll('focusOnTitle');
	    return _this;
	  }
	
	  _createClass(BibTitle, [{
	    key: 'focusOnTitle',
	    value: function focusOnTitle() {
	      if (this._title) {
	        this._title.focus();
	      }
	    }
	  }, {
	    key: 'formatText',
	    value: function formatText(text) {
	      var truncateOptions = this.props.truncateOptions;
	
	      return truncateOptions ? (0, _utilsString.truncate)(text, truncateOptions) : text;
	    }
	  }, {
	    key: 'renderTitle',
	    value: function renderTitle() {
	      var _this2 = this;
	
	      var _props = this.props,
	          renderAsLink = _props.renderAsLink,
	          id = _props.id,
	          target = _props.target,
	          primaryLanguage = _props.primaryLanguage,
	          multiscriptTitle = _props.multiscriptTitle,
	          title = _props.title,
	          format = _props.format,
	          intl = _props.intl;
	
	      var titleContent = multiscriptTitle || title;
	      var formattedTitleContent = this.formatText(titleContent);
	
	      if (renderAsLink) {
	        return _react2.default.createElement(
	          'a',
	          {
	            href: '/item/show/' + (0, _utilsLink.metadataIdFixer)(id),
	            target: target,
	            lang: primaryLanguage,
	            rel: 'noopener',
	            ref: function ref(el) {
	              return _this2._title = el;
	            },
	            'data-test-id': 'bib-title-' + id,
	            'data-key': 'bib-title' },
	          _react2.default.createElement(
	            'span',
	            { 'aria-hidden': 'true', className: 'title-content' },
	            formattedTitleContent
	          ),
	          _react2.default.createElement(
	            _reactIntl.FormattedMessage,
	            { id: 'ada_link_to_item_page', values: { title: titleContent, format: intl.formatMessage({ id: 'FORMAT.' + format.toLowerCase() }) } },
	            function (message) {
	              return _react2.default.createElement(
	                _baseScreenReaderMessage2.default,
	                null,
	                message
	              );
	            }
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        {
	          lang: primaryLanguage,
	          'data-test-id': 'bib-title-' + id,
	          ref: function ref(el) {
	            return _this2._title = el;
	          },
	          tabIndex: '-1' },
	        _react2.default.createElement(
	          'span',
	          { 'aria-hidden': 'true', className: 'title-content' },
	          formattedTitleContent
	        ),
	        _react2.default.createElement(
	          _baseScreenReaderMessage2.default,
	          null,
	          title
	        )
	      );
	    }
	  }, {
	    key: 'renderSecondaryTitle',
	    value: function renderSecondaryTitle() {
	      var _props2 = this.props,
	          multiscriptTitle = _props2.multiscriptTitle,
	          title = _props2.title;
	
	
	      if (title && multiscriptTitle) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'secondary-title' },
	          _react2.default.createElement(
	            'span',
	            { 'aria-hidden': 'true' },
	            this.formatText(title)
	          ),
	          _react2.default.createElement(
	            _baseScreenReaderMessage2.default,
	            null,
	            title
	          )
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          subtitle = _props3.subtitle,
	          titleTag = _props3.titleTag,
	          renderIcon = _props3.renderIcon;
	
	      var TitleTag = titleTag; // This needs to start with an uppercase letter since its a component
	
	      return _react2.default.createElement(
	        TitleTag,
	        { className: 'cp-title' },
	        this.renderTitle(),
	        renderIcon(),
	        this.renderSecondaryTitle(),
	        _react2.default.createElement(_sharedBibSubtitle2.default, { subtitle: subtitle, titleTag: 'span' })
	      );
	    }
	  }]);
	
	  return BibTitle;
	}(_baseBcReactComponent2.default);
	
	BibTitle.defaultProps = {
	  primaryLanguage: 'en',
	  titleTag: 'h2',
	  target: '_parent',
	  renderAsLink: true,
	  renderIcon: function renderIcon() {
	    return null;
	  }
	};
	
	BibTitle.propTypes = {
	  id: _react.PropTypes.string.isRequired,
	  title: _react.PropTypes.string.isRequired,
	  format: _react.PropTypes.string.isRequired,
	  subtitle: _react.PropTypes.string,
	  titleTag: _react.PropTypes.string,
	  target: _react.PropTypes.string,
	  multiscriptTitle: _react.PropTypes.string,
	  primaryLanguage: _react.PropTypes.string.isRequired,
	  renderAsLink: _react.PropTypes.bool,
	  renderIcon: _react.PropTypes.func,
	  truncateOptions: _bcPropTypes.truncateOptionsShape,
	  intl: _reactIntl.intlShape
	};
	
	exports.default = (0, _reactIntl.injectIntl)(BibTitle, { withRef: true });

/***/ },
/* 1477 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BibTitle = __webpack_require__(1476);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BibTitle).default;
	  }
	});
	Object.defineProperty(exports, 'BibTitle', {
	  enumerable: true,
	  get: function get() {
	    return _BibTitle.BibTitle;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1478 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Edition = function Edition(_ref) {
	  var edition = _ref.edition,
	      _ref$separator = _ref.separator,
	      separator = _ref$separator === undefined ? ' | ' : _ref$separator;
	
	  if (edition) {
	    return _react2.default.createElement(
	      'span',
	      { className: 'cp-edition' },
	      separator,
	      edition
	    );
	  }
	
	  return null;
	};
	
	Edition.propTypes = {
	  edition: _react.PropTypes.string.isRequired,
	  separator: _react.PropTypes.string
	};
	
	exports.default = Edition;

/***/ },
/* 1479 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Edition = __webpack_require__(1478);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Edition).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1480 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	__webpack_require__(2731);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EmbeddedChatWidget = function (_BcReactComponent) {
	  _inherits(EmbeddedChatWidget, _BcReactComponent);
	
	  function EmbeddedChatWidget() {
	    _classCallCheck(this, EmbeddedChatWidget);
	
	    return _possibleConstructorReturn(this, (EmbeddedChatWidget.__proto__ || Object.getPrototypeOf(EmbeddedChatWidget)).apply(this, arguments));
	  }
	
	  _createClass(EmbeddedChatWidget, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          widget = _props.widget,
	          classes = _props.classes;
	
	      var iframeSrc = '/widgets/chat_widget/' + widget;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-embedded-chat-widget ' + widget + '-widget ' + (classes || '') },
	        _react2.default.createElement('iframe', { src: iframeSrc })
	      );
	    }
	  }]);
	
	  return EmbeddedChatWidget;
	}(_baseBcReactComponent2.default);
	
	EmbeddedChatWidget.propTypes = {
	  widget: _react.PropTypes.string.isRequired,
	  classes: _react.PropTypes.string
	};
	
	exports.default = EmbeddedChatWidget;

/***/ },
/* 1481 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _EmbeddedChatWidget = __webpack_require__(1480);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_EmbeddedChatWidget).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1482 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseIcons = __webpack_require__(10);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EResourceLink = function EResourceLink(_ref) {
	  var eresourceDescription = _ref.eresourceDescription,
	      eresourceUrl = _ref.eresourceUrl,
	      format = _ref.format,
	      intl = _ref.intl;
	
	  var resourceText = eresourceDescription || intl.formatMessage({ id: 'full_download_' + format.toLowerCase() });
	  return _react2.default.createElement(
	    'a',
	    { className: 'cp-eresource-link', href: eresourceUrl, target: '_blank', rel: 'noopener noreferrer' },
	    _react2.default.createElement(
	      'span',
	      { 'aria-hidden': 'true' },
	      resourceText,
	      '\xA0',
	      _react2.default.createElement(_baseIcons.NewTab, { color: 'currentColor' })
	    ),
	    _react2.default.createElement(
	      _baseScreenReaderMessage2.default,
	      null,
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ada_link_opens_new_window', values: { linkText: resourceText } })
	    )
	  );
	};
	
	EResourceLink.propTypes = {
	  eresourceUrl: _react.PropTypes.string.isRequired,
	  eresourceDescription: _react.PropTypes.string,
	  format: _react.PropTypes.string,
	  intl: _reactIntl.intlShape
	};
	
	EResourceLink.displayName = 'EResourceLink';
	
	exports.default = (0, _reactIntl.injectIntl)(EResourceLink);

/***/ },
/* 1483 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = fieldErrorWrapper;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseAlerts = __webpack_require__(36);
	
	var _bcPropTypes = __webpack_require__(5);
	
	__webpack_require__(2732);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function fieldErrorWrapper(Component) {
	  var FieldError = function (_BcReactComponent) {
	    _inherits(FieldError, _BcReactComponent);
	
	    function FieldError(props) {
	      _classCallCheck(this, FieldError);
	
	      var _this = _possibleConstructorReturn(this, (FieldError.__proto__ || Object.getPrototypeOf(FieldError)).call(this, props));
	
	      _this.bindAll('renderErrors');
	      return _this;
	    }
	
	    _createClass(FieldError, [{
	      key: 'renderErrors',
	      value: function renderErrors() {
	        var _props = this.props,
	            fieldErrors = _props.fieldErrors,
	            errorKey = _props.errorKey;
	
	
	        if (fieldErrors && errorKey && fieldErrors[errorKey]) {
	          var id = fieldErrors[errorKey].id || fieldErrors[errorKey].classification && 'error_' + fieldErrors[errorKey].classification.toLowerCase() || '';
	          var defaultMessage = fieldErrors[errorKey].message;
	          var values = fieldErrors[errorKey].values;
	
	          return _react2.default.createElement(
	            _baseAlerts.AlertFailure,
	            null,
	            _react2.default.createElement(_reactIntl.FormattedMessage, {
	              id: id,
	              values: values,
	              defaultMessage: defaultMessage })
	          );
	        }
	        return null;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _this2 = this;
	
	        var _props2 = this.props,
	            fieldErrors = _props2.fieldErrors,
	            errorKey = _props2.errorKey,
	            otherProps = _objectWithoutProperties(_props2, ['fieldErrors', 'errorKey']);
	
	        var errorClass = fieldErrors && errorKey && fieldErrors[errorKey] ? 'has-error' : '';
	
	        return _react2.default.createElement(
	          'div',
	          { className: 'cp-field-error-wrapper ' + errorClass },
	          this.renderErrors(),
	          _react2.default.createElement(Component, _extends({
	            ref: function ref(el) {
	              return _this2._wrappedComponent = el;
	            }
	          }, otherProps))
	        );
	      }
	    }, {
	      key: 'getWrappedInstance',
	      value: function getWrappedInstance() {
	        return this._wrappedComponent;
	      }
	    }]);
	
	    return FieldError;
	  }(_baseBcReactComponent2.default);
	
	  FieldError.propTypes = {
	    fieldErrors: _react.PropTypes.objectOf(_react.PropTypes.objectOf(_bcPropTypes.fieldErrorsShape)),
	    errorKey: _react.PropTypes.string
	  };
	
	  return FieldError;
	}

/***/ },
/* 1484 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = FormatInfo;
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _reactIntl = __webpack_require__(3);
	
	var _callNumber = __webpack_require__(1394);
	
	var _callNumber2 = _interopRequireDefault(_callNumber);
	
	var _sharedEdition = __webpack_require__(1479);
	
	var _sharedEdition2 = _interopRequireDefault(_sharedEdition);
	
	var _sharedPrimaryLanguage = __webpack_require__(1500);
	
	var _sharedPrimaryLanguage2 = _interopRequireDefault(_sharedPrimaryLanguage);
	
	var _sharedPublicationDate = __webpack_require__(369);
	
	var _sharedPublicationDate2 = _interopRequireDefault(_sharedPublicationDate);
	
	__webpack_require__(2733);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function FormatInfo(_ref) {
	  var item = _ref.item,
	      className = _ref.className,
	      showEdition = _ref.showEdition,
	      showLanguage = _ref.showLanguage,
	      showCallNumber = _ref.showCallNumber;
	
	  var format = item.getIn(['briefInfo', 'format']);
	  var publicationDate = item.getIn(['briefInfo', 'publicationDate']);
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)('cp-format-info', className) },
	    _react2.default.createElement(
	      'div',
	      { className: 'format-info-main-content' },
	      _react2.default.createElement(
	        'span',
	        { className: 'cp-format-indicator', 'data-test-id': 'format-indicator' },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'FORMAT.' + format.toLowerCase() })
	      ),
	      publicationDate && _react2.default.createElement(_sharedPublicationDate2.default, { publicationDate: publicationDate }),
	      showEdition && _react2.default.createElement(_sharedEdition2.default, { edition: item.getIn(['briefInfo', 'edition']) }),
	      showLanguage && _react2.default.createElement(_sharedPrimaryLanguage2.default, { bib: item })
	    ),
	    showCallNumber && _react2.default.createElement(_callNumber2.default, { callNumber: item.getIn(['briefInfo', 'callNumber']) })
	  );
	}
	
	FormatInfo.displayName = 'FormatInfo';
	
	FormatInfo.propTypes = {
	  item: _reactImmutableProptypes2.default.map.isRequired,
	  className: _react.PropTypes.string,
	  showEdition: _react.PropTypes.bool,
	  showLanguage: _react.PropTypes.bool,
	  showCallNumber: _react.PropTypes.bool
	};
	
	FormatInfo.defaultProps = {
	  showLanguage: true
	};

/***/ },
/* 1485 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	var _baseIcons = __webpack_require__(10);
	
	__webpack_require__(2734);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var defaultText = _react2.default.createElement(
	  _baseScreenReaderMessage2.default,
	  null,
	  _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ada_learn_more_about_feature' })
	);
	
	var openHelpWindow = function openHelpWindow(e, url) {
	  e.preventDefault();
	  window.open(url, '_blank', 'height=600,width=750,toolbar=no,scrollbars=yes,status=no,resizable=yes,location=no,menuBar=no');
	};
	
	function HelpLink(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$page = _ref.page,
	      page = _ref$page === undefined ? '' : _ref$page,
	      _ref$currentLanguage = _ref.currentLanguage,
	      currentLanguage = _ref$currentLanguage === undefined ? 'en-US' : _ref$currentLanguage,
	      _ref$showIcon = _ref.showIcon,
	      showIcon = _ref$showIcon === undefined ? true : _ref$showIcon,
	      _ref$children = _ref.children,
	      children = _ref$children === undefined ? defaultText : _ref$children,
	      props = _objectWithoutProperties(_ref, ['className', 'page', 'currentLanguage', 'showIcon', 'children']);
	
	  var classNames = 'cp-help-link ' + className;
	  var helpParts = page.split('#');
	  var url = '';
	  var formattedLocale = function (loc) {
	    switch (loc.toLowerCase()) {
	      case 'fr-ca':
	        return 'fr';
	      case 'es-es':
	        return 'es';
	      case 'ja-ja':
	        return 'ja';
	      case 'ru-ru':
	        return 'ru';
	      case 'ja-ja':
	        return 'ja';
	      case 'zh-cn':
	        return 'zh-hans';
	      case 'zh-tw':
	        return 'zh-hant';
	      default:
	        return '';
	    }
	  }(currentLanguage.toLowerCase());
	
	  if (helpParts[0]) {
	    url = helpParts[0].replace('_', '-');
	  }
	
	  if (url && helpParts[1]) {
	    url = helpParts[0].replace('_', '-') + '#' + helpParts[1];
	  }
	
	  if (formattedLocale) {
	    formattedLocale = '/' + formattedLocale;
	  }
	
	  if (url) {
	    url = '/' + url;
	  }
	
	  var href = 'http://help.bibliocommons.com' + formattedLocale + url;
	
	  return _react2.default.createElement(
	    'a',
	    _extends({
	      onClick: function onClick(e) {
	        return openHelpWindow(e, href);
	      },
	      className: classNames,
	      href: href,
	      target: '_blank',
	      rel: 'noopener noreferrer'
	    }, props),
	    showIcon ? _react2.default.createElement(_baseIcons.Info, null) : null,
	    children
	  );
	}
	
	HelpLink.propTypes = {
	  className: _react2.default.PropTypes.string,
	  page: _react2.default.PropTypes.string.isRequired,
	  showIcon: _react2.default.PropTypes.bool,
	  children: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.arrayOf(_react2.default.PropTypes.node), _react2.default.PropTypes.node]),
	  currentLanguage: _react2.default.PropTypes.string
	};
	
	exports.default = HelpLink;

/***/ },
/* 1486 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _HelpLink = __webpack_require__(1485);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_HelpLink).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1487 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = HoldInfoMessages;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	__webpack_require__(2735);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function HoldInfoMessages(_ref) {
	  var _ref$messageIds = _ref.messageIds,
	      messageIds = _ref$messageIds === undefined ? [] : _ref$messageIds;
	
	  if (messageIds.length === 0) {
	    return null;
	  }
	  return _react2.default.createElement(
	    'div',
	    null,
	    messageIds.map(function (num) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-hold-info-message' },
	        _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'hold_info_msg_block' + num })
	      );
	    })
	  );
	}
	
	HoldInfoMessages.propTypes = {
	  messageIds: _react.PropTypes.arrayOf(_react.PropTypes.number).isRequired
	};

/***/ },
/* 1488 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _HoldInfoMessages = __webpack_require__(1487);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_HoldInfoMessages).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1489 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _lodash = __webpack_require__(16);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _utilsFormat = __webpack_require__(96);
	
	var _utilsFormat2 = _interopRequireDefault(_utilsFormat);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(2736);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var JacketCover = function (_BcReactComponent) {
	  _inherits(JacketCover, _BcReactComponent);
	
	  function JacketCover(props) {
	    _classCallCheck(this, JacketCover);
	
	    var _this = _possibleConstructorReturn(this, (JacketCover.__proto__ || Object.getPrototypeOf(JacketCover)).call(this, props));
	
	    _this.state = {
	      imgSrc: null
	    };
	    return _this;
	  }
	
	  _createClass(JacketCover, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.validateImage();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (!_immutable2.default.is(this.props.src, nextProps.src)) {
	        this.props = nextProps;
	        this.setState({ imgSrc: null });
	        this.validateImage();
	      }
	    }
	  }, {
	    key: 'getSourceImage',
	    value: function getSourceImage() {
	      if (typeof this.props.src === 'string') {
	        if (this.props.src.indexOf('ftp://') !== 0) {
	          return [this.props.src];
	        }
	      }
	
	      if (_immutable2.default.Iterable.isIterable(this.props.src)) {
	        return _lodash2.default.compact([this.getLocalImageUrl(), this.props.src.get(this.props.size)]);
	      }
	
	      return [];
	    }
	  }, {
	    key: 'getLocalImageUrl',
	    value: function getLocalImageUrl() {
	      if (_immutable2.default.Iterable.isIterable(this.props.src)) {
	        var localUrl = this.props.src.get('local_url');
	        var isUrlHttp = localUrl && localUrl.indexOf('http://') !== -1;
	
	        // Use core CDN for image proxying http links to https
	        if (this.context.coreCdnHost && isUrlHttp) {
	          localUrl = this.context.coreCdnHost + '/image_proxy?url=' + localUrl;
	        }
	
	        return localUrl;
	      }
	
	      return null;
	    }
	  }, {
	    key: 'validateImage',
	    value: function validateImage() {
	      var _this2 = this;
	
	      var currentImageIndex = 0;
	      var src = this.getSourceImage();
	
	      if (src.length > 0) {
	        var testImage = new Image();
	
	        testImage.onload = function () {
	          if (testImage.width > 1 && testImage.height > 1) {
	            _this2.setState({ imgSrc: testImage.src });
	          }
	          currentImageIndex += 1;
	        };
	
	        testImage.onerror = function () {
	          if (src.length > currentImageIndex + 1) {
	            currentImageIndex += 1;
	            testImage.src = src[currentImageIndex];
	          }
	        };
	        testImage.src = src[0];
	      }
	    }
	  }, {
	    key: 'renderDefault',
	    value: function renderDefault() {
	      if (this.props.renderDefault) {
	        return this.props.renderDefault();
	      }
	
	      return this.renderImage(_utilsFormat2.default.getDefaultImage(this.props.format));
	    }
	  }, {
	    key: 'renderImage',
	    value: function renderImage(src) {
	      var jacketClass = (0, _classnames2.default)('cp-jacket-cover', {
	        'img-responsive': this.props.responsive,
	        'drop-shadow': this.props.dropShadow
	      });
	
	      return _react2.default.createElement('img', {
	        alt: this.props.alt || '',
	        src: src,
	        className: jacketClass,
	        'data-test-id': this.props.testId });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.state.imgSrc) {
	        return this.renderImage(this.state.imgSrc);
	      }
	      return this.renderDefault();
	    }
	  }]);
	
	  return JacketCover;
	}(_baseBcReactComponent2.default);
	
	JacketCover.propTypes = {
	  format: _react.PropTypes.string,
	  src: _react.PropTypes.oneOfType([_react.PropTypes.string, _reactImmutableProptypes2.default.map, _reactImmutableProptypes2.default.mapOf({
	    local_url: _react.PropTypes.string,
	    large: _react.PropTypes.string,
	    medium: _react.PropTypes.string,
	    small: _react.PropTypes.string,
	    type: _react.PropTypes.string
	  })]),
	  border: _react.PropTypes.bool,
	  dropShadow: _react.PropTypes.bool,
	  size: _react.PropTypes.string,
	  responsive: _react.PropTypes.bool,
	  testId: _react.PropTypes.string,
	  renderDefault: _react.PropTypes.func
	};
	
	JacketCover.defaultProps = {
	  size: 'medium',
	  responsive: false,
	  border: false,
	  dropShadow: false
	};
	
	JacketCover.contextTypes = {
	  coreCdnHost: _react.PropTypes.string
	};
	
	exports.default = JacketCover;

/***/ },
/* 1490 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	__webpack_require__(2737);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LibraryLogo = function (_BcReactComponent) {
	  _inherits(LibraryLogo, _BcReactComponent);
	
	  function LibraryLogo() {
	    _classCallCheck(this, LibraryLogo);
	
	    return _possibleConstructorReturn(this, (LibraryLogo.__proto__ || Object.getPrototypeOf(LibraryLogo)).apply(this, arguments));
	  }
	
	  _createClass(LibraryLogo, [{
	    key: 'getLogoUrl',
	    value: function getLogoUrl() {
	      var imageName = this.props.imageName || (this.props.small ? 'mobile_logo' : 'logo');
	      return this.props.baseUrl + '/images/' + this.props.siteId + '/' + imageName + '.png';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var classes = (0, _classnames2.default)('cp-library-logo', {
	        'logo-small': this.props.small,
	        'logo-circled': this.props.circled
	      }, this.props.className);
	
	      return _react2.default.createElement('img', { src: this.getLogoUrl(), className: classes, alt: this.props.alt });
	    }
	  }]);
	
	  return LibraryLogo;
	}(_baseBcReactComponent2.default);
	
	LibraryLogo.propTypes = {
	  siteId: _react.PropTypes.string.isRequired,
	  small: _react.PropTypes.bool,
	  circled: _react.PropTypes.bool,
	  imageName: _react.PropTypes.string,
	  baseUrl: _react.PropTypes.string,
	  alt: _react.PropTypes.string,
	  className: _react.PropTypes.string
	};
	
	LibraryLogo.defaultProps = {
	  baseUrl: '',
	  small: false,
	  circled: false,
	  alt: '' // Default to blank, assume it's decorative
	};
	
	exports.default = LibraryLogo;

/***/ },
/* 1491 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = GenericForm;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _generic = __webpack_require__(368);
	
	var _generic2 = _interopRequireDefault(_generic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function GenericForm(props) {
	  return !props.fieldErrors || props.fieldErrors.isEmpty() ? _react2.default.createElement(_generic2.default, props) : null;
	}
	
	GenericForm.propTypes = {
	  fieldErrors: _react.PropTypes.objectOf(_react.PropTypes.shape({
	    classification: _react.PropTypes.string,
	    message: _react.PropTypes.string
	  }))
	};

/***/ },
/* 1492 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GenericForm = __webpack_require__(1491);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GenericForm).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1493 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _lodash = __webpack_require__(16);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseAlerts = __webpack_require__(36);
	
	var Alerts = _interopRequireWildcard(_baseAlerts);
	
	var _keymirror = __webpack_require__(325);
	
	var _keymirror2 = _interopRequireDefault(_keymirror);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var STATUS_TYPES = (0, _keymirror2.default)({
	  Success: null,
	  Failure: null,
	  Neutral: null
	});
	
	var propTypes = {
	  message: _reactImmutableProptypes2.default.map.isRequired,
	  values: _reactImmutableProptypes2.default.map,
	  duration: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.bool]),
	  clearMessages: _react.PropTypes.func.isRequired,
	  fieldErrors: _react.PropTypes.objectOf(_react.PropTypes.shape({
	    classification: _react.PropTypes.string,
	    message: _react.PropTypes.string
	  })),
	  failureDuration: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.bool]),
	  useFormattedMessage: _react.PropTypes.bool,
	  intl: _reactIntl.intlShape
	};
	
	var defaultProps = {
	  duration: 10000,
	  failureDuration: 10000
	};
	
	var Generic = function (_BcReactComponent) {
	  _inherits(Generic, _BcReactComponent);
	
	  function Generic(props) {
	    _classCallCheck(this, Generic);
	
	    var _this = _possibleConstructorReturn(this, (Generic.__proto__ || Object.getPrototypeOf(Generic)).call(this, props));
	
	    _this.timeout = null;
	    return _this;
	  }
	
	  _createClass(Generic, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.scheduleMessageClearance();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.timeout) {
	        clearTimeout(this.timeout);
	        this.timeout = null;
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.timeout && nextProps.message !== this.props.message) {
	        clearTimeout(this.timeout);
	        this.timeout = null;
	        this.scheduleMessageClearance();
	      }
	    }
	  }, {
	    key: 'scheduleMessageClearance',
	    value: function scheduleMessageClearance() {
	      var _this2 = this;
	
	      var _props = this.props,
	          clearMessages = _props.clearMessages,
	          duration = _props.duration,
	          failureDuration = _props.failureDuration;
	
	      if (duration) {
	        var durationToUse = this.getAlertType() === STATUS_TYPES.Failure ? failureDuration : duration;
	        this.timeout = setTimeout(function () {
	          if (clearMessages) {
	            clearMessages();
	          }
	          _this2.timeout = null;
	        }, durationToUse);
	      }
	    }
	  }, {
	    key: 'getDefaultMessage',
	    value: function getDefaultMessage() {
	      if (this.props.message.get('defaultMessage')) {
	        return this.props.message.get('defaultMessage');
	      }
	
	      if (this.getAlertType() === STATUS_TYPES.Failure) {
	        return this.props.intl.formatMessage({ id: 'errors.ServiceException' });
	      }
	
	      return undefined;
	    }
	  }, {
	    key: 'getAlertType',
	    value: function getAlertType() {
	      var type = this.props.message.get('type');
	      var alertType = _lodash2.default.last(type.split('_'));
	      return (0, _lodash2.default)(alertType.toLowerCase()).capitalize();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var message = this.props.message;
	      var extraValues = this.props.values || _immutable2.default.Map();
	      var Component = Alerts['Alert' + this.getAlertType()];
	
	      if (!Component) {
	        return null;
	      }
	
	      var MessageComponent = this.props.useFormattedMessage ? _reactIntl.FormattedMessage : _reactIntl.FormattedHTMLMessage;
	
	      return _react2.default.createElement(
	        Component,
	        null,
	        _react2.default.createElement(MessageComponent, {
	          id: message.get('id'),
	          values: extraValues.merge(message.get('values', _immutable2.default.Map())).toJS(),
	          defaultMessage: this.getDefaultMessage() })
	      );
	    }
	  }]);
	
	  return Generic;
	}(_baseBcReactComponent2.default);
	
	Generic.propTypes = propTypes;
	Generic.defaultProps = defaultProps;
	
	exports.default = (0, _reactIntl.injectIntl)(Generic);

/***/ },
/* 1494 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _generic = __webpack_require__(368);
	
	var _generic2 = _interopRequireDefault(_generic);
	
	__webpack_require__(2738);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ToastMessage = function ToastMessage(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      props = _objectWithoutProperties(_ref, ['className']);
	
	  var classNames = 'cp-toast-message ' + className;
	
	  return _react2.default.createElement(
	    'div',
	    { className: classNames },
	    _react2.default.createElement(_generic2.default, props)
	  );
	};
	
	ToastMessage.propTypes = {
	  className: _react.PropTypes.string
	};
	
	exports.default = ToastMessage;

/***/ },
/* 1495 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ToastMessage = __webpack_require__(1494);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ToastMessage).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1496 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseIcons = __webpack_require__(10);
	
	var _baseButtons = __webpack_require__(12);
	
	__webpack_require__(2739);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OnShelfButton = function (_BcReactComponent) {
	  _inherits(OnShelfButton, _BcReactComponent);
	
	  function OnShelfButton() {
	    _classCallCheck(this, OnShelfButton);
	
	    return _possibleConstructorReturn(this, (OnShelfButton.__proto__ || Object.getPrototypeOf(OnShelfButton)).apply(this, arguments));
	  }
	
	  _createClass(OnShelfButton, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          shelfItem = _props.shelfItem,
	          intl = _props.intl,
	          disabled = _props.disabled;
	
	      var name = shelfItem.get('shelf');
	      var formattedShelfName = intl.formatMessage({ id: 'label_shelf_' + name });
	      var privateItem = shelfItem.get('privateItem');
	
	      return _react2.default.createElement(
	        _baseButtons.DefaultButton,
	        {
	          className: 'cp-on-shelf-button',
	          disabled: disabled,
	          handleClick: function handleClick() {
	            return _this2.props.handleClick();
	          },
	          'aria-label': intl.formatMessage({ id: 'item_on_shelf_cta' }, { shelfName: formattedShelfName }),
	          tagName: 'button',
	          href: '#add-to-shelf' },
	        _react2.default.createElement(
	          'div',
	          { className: 'shelf-button-flex-wrap' },
	          _react2.default.createElement(_baseIcons.ShelfItem, { isPrivate: privateItem, onShelf: true }),
	          _react2.default.createElement(
	            'span',
	            { className: 'shelf-name-text' },
	            formattedShelfName
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'cog-wrap' },
	          _react2.default.createElement(_baseIcons.CogAlternate, { color: '#666', width: 14, height: 14 })
	        )
	      );
	    }
	  }]);
	
	  return OnShelfButton;
	}(_baseBcReactComponent2.default);
	
	OnShelfButton.propTypes = {
	  shelfItem: _reactImmutableProptypes2.default.map,
	  handleClick: _react.PropTypes.func.isRequired,
	  disabled: _react.PropTypes.bool
	};
	
	exports.default = (0, _reactIntl.injectIntl)(OnShelfButton);

/***/ },
/* 1497 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _OnShelfButton = __webpack_require__(1496);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_OnShelfButton).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1498 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(16);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseDropdown = __webpack_require__(37);
	
	var _baseAlerts = __webpack_require__(36);
	
	var _sharedFieldErrorWrapper = __webpack_require__(366);
	
	var _sharedFieldErrorWrapper2 = _interopRequireDefault(_sharedFieldErrorWrapper);
	
	__webpack_require__(2740);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PickupBranchSelect = function (_BcReactComponent) {
	  _inherits(PickupBranchSelect, _BcReactComponent);
	
	  function PickupBranchSelect(props) {
	    _classCallCheck(this, PickupBranchSelect);
	
	    var _this = _possibleConstructorReturn(this, (PickupBranchSelect.__proto__ || Object.getPrototypeOf(PickupBranchSelect)).call(this, props));
	
	    _this.bindAll('handleSelect');
	
	    _this.state = {
	      labelledById: _lodash2.default.uniqueId('pickupBranchDropdown_')
	    };
	    return _this;
	  }
	
	  _createClass(PickupBranchSelect, [{
	    key: 'renderSelectPickupPrompt',
	    value: function renderSelectPickupPrompt() {
	      if (this.props.selectedBranch === undefined && this.props.branches.size > 1) {
	        return _react2.default.createElement(
	          _baseAlerts.AlertInfo,
	          null,
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'reselect_pickup_location_prompt' })
	        );
	      }
	      return null;
	    }
	  }, {
	    key: 'getSelectedBranchName',
	    value: function getSelectedBranchName() {
	      var _this2 = this;
	
	      var selected = this.props.branches.find(function (b) {
	        return b.get('code') === _this2.props.selectedBranch;
	      });
	      // TODO: This needs to be determined by a setting
	      return selected ? selected.get('name') : _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'form_label_select_a_branch' });
	    }
	  }, {
	    key: 'getOptions',
	    value: function getOptions() {
	      return this.props.branches.map(function (branch) {
	        return {
	          label: branch.get('name'),
	          value: branch.get('code')
	        };
	      });
	    }
	  }, {
	    key: 'handleSelect',
	    value: function handleSelect(value) {
	      this.props.handleSelect(this.props.branches.find(function (b) {
	        return b.get('code') === value;
	      }));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var label = this.props.label;
	      var labelledById = this.state.labelledById;
	
	
	      return _react2.default.createElement(
	        'span',
	        { className: 'cp-pickup-branch-select' },
	        label && _react2.default.createElement(
	          'span',
	          { id: labelledById, className: 'col-xs-12 col-sm-4 control-label' },
	          label
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'column-input-group col-xs-12 col-sm-8' },
	          this.renderSelectPickupPrompt(),
	          _react2.default.createElement(_baseDropdown.Dropdown, {
	            fieldErrors: this.props.fieldErrors,
	            errorKey: 'physicalParams.branchId',
	            selected: this.getSelectedBranchName(),
	            options: this.getOptions(),
	            handleSelect: this.handleSelect,
	            labelledById: labelledById,
	            labelLocalizedText: label,
	            descriptionLocalizedText: label,
	            className: 'btn-default btn-flat' })
	        )
	      );
	    }
	  }]);
	
	  return PickupBranchSelect;
	}(_baseBcReactComponent2.default);
	
	PickupBranchSelect.propTypes = {
	  label: _react.PropTypes.string,
	  fieldErrors: _react.PropTypes.objectOf(_react.PropTypes.shape({
	    classification: _react.PropTypes.string,
	    message: _react.PropTypes.string
	  })),
	  branches: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	    name: _react.PropTypes.string,
	    code: _react.PropTypes.string
	  })).isRequired,
	  handleSelect: _react.PropTypes.func.isRequired,
	  selectedBranch: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
	  intl: _reactIntl.intlShape
	};
	
	PickupBranchSelect.displayName = 'PickupBranchSelect';
	
	exports.default = (0, _reactIntl.injectIntl)((0, _sharedFieldErrorWrapper2.default)(PickupBranchSelect));

/***/ },
/* 1499 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = PrimaryLanguage;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _reactIntl = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function PrimaryLanguage(_ref) {
	  var bib = _ref.bib,
	      separator = _ref.separator,
	      hiddenLanguages = _ref.hiddenLanguages;
	
	  var primaryLanguage = bib.getIn(['briefInfo', 'primaryLanguage']);
	  if (primaryLanguage && !hiddenLanguages.includes(primaryLanguage)) {
	    return _react2.default.createElement(
	      'span',
	      { className: 'cp-primary-language' },
	      separator,
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'LANGUAGE.' + primaryLanguage })
	    );
	  }
	
	  return null;
	}
	
	PrimaryLanguage.defaultProps = {
	  hiddenLanguages: ['eng', 'und', 'zxx'],
	  separator: ' | '
	};
	
	PrimaryLanguage.propTypes = {
	  bib: _reactImmutableProptypes2.default.mapContains({
	    primaryLanguage: _react.PropTypes.string
	  }),
	  hiddenLanguages: _react.PropTypes.arrayOf(_react.PropTypes.string),
	  separator: _react.PropTypes.string
	};

/***/ },
/* 1500 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PrimaryLanguage = __webpack_require__(1499);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PrimaryLanguage).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1501 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseButtons = __webpack_require__(12);
	
	var _baseIcons = __webpack_require__(10);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	__webpack_require__(2741);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PrivacyTogglePills = function (_BcReactComponent) {
	  _inherits(PrivacyTogglePills, _BcReactComponent);
	
	  function PrivacyTogglePills(props) {
	    _classCallCheck(this, PrivacyTogglePills);
	
	    var _this = _possibleConstructorReturn(this, (PrivacyTogglePills.__proto__ || Object.getPrototypeOf(PrivacyTogglePills)).call(this, props));
	
	    _this.bindAll('handleToggleClick');
	    return _this;
	  }
	
	  _createClass(PrivacyTogglePills, [{
	    key: 'handleToggleClick',
	    value: function handleToggleClick(isPrivate) {
	      if (this.props.isPrivate === isPrivate) {
	        return;
	      }
	
	      this.props.handlePrivacyToggle(isPrivate);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var isPrivate = this.props.isPrivate;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-privacy-toggle-pills' },
	        _react2.default.createElement(
	          _baseScreenReaderMessage2.default,
	          { 'aria-live': 'polite' },
	          isPrivate ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'item_is_private' }) : _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'item_is_shared' })
	        ),
	        _react2.default.createElement(
	          _baseButtons.DefaultButton,
	          {
	            className: (0, _classnames2.default)('privacy-toggle-btn', 'lock', { selected: isPrivate }),
	            handleClick: function handleClick() {
	              return _this2.handleToggleClick(true);
	            },
	            'aria-label': this.props.intl.formatMessage({ id: 'change_item_privacy_to_private' }) },
	          _react2.default.createElement(_baseIcons.Lock, null)
	        ),
	        _react2.default.createElement(
	          _baseButtons.DefaultButton,
	          {
	            className: (0, _classnames2.default)('privacy-toggle-btn', 'unlock', { selected: !isPrivate }),
	            handleClick: function handleClick() {
	              return _this2.handleToggleClick(false);
	            },
	            'aria-label': this.props.intl.formatMessage({ id: 'change_item_privacy_to_shared' }) },
	          _react2.default.createElement(_baseIcons.Unlock, null)
	        )
	      );
	    }
	  }]);
	
	  return PrivacyTogglePills;
	}(_baseBcReactComponent2.default);
	
	PrivacyTogglePills.propTypes = {
	  isPrivate: _react.PropTypes.bool.isRequired,
	  handlePrivacyToggle: _react.PropTypes.func.isRequired
	};
	
	PrivacyTogglePills.displayName = 'PrivacyTogglePills';
	
	exports.default = (0, _reactIntl.injectIntl)(PrivacyTogglePills);

/***/ },
/* 1502 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PrivacyTogglePills = __webpack_require__(1501);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PrivacyTogglePills).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1503 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	__webpack_require__(2742);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProbeLogo = function (_BcReactComponent) {
	  _inherits(ProbeLogo, _BcReactComponent);
	
	  function ProbeLogo() {
	    _classCallCheck(this, ProbeLogo);
	
	    return _possibleConstructorReturn(this, (ProbeLogo.__proto__ || Object.getPrototypeOf(ProbeLogo)).apply(this, arguments));
	  }
	
	  _createClass(ProbeLogo, [{
	    key: 'getLogoUrl',
	    value: function getLogoUrl() {
	      var imageName = 'account_linking_image';
	      return this.props.baseUrl + '/images/' + this.props.siteId + '/' + imageName + '.png';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var classes = (0, _classnames2.default)('cp-probe-logo', {
	        'logo-small': this.props.small,
	        'logo-circled': this.props.circled
	      }, this.props.className);
	
	      return _react2.default.createElement('img', { src: this.getLogoUrl(), className: classes, alt: this.props.alt });
	    }
	  }]);
	
	  return ProbeLogo;
	}(_baseBcReactComponent2.default);
	
	ProbeLogo.propTypes = {
	  siteId: _react.PropTypes.string.isRequired,
	  small: _react.PropTypes.bool,
	  circled: _react.PropTypes.bool,
	  baseUrl: _react.PropTypes.string,
	  alt: _react.PropTypes.string,
	  className: _react.PropTypes.string
	};
	
	ProbeLogo.defaultProps = {
	  baseUrl: '',
	  small: false,
	  circled: false,
	  alt: '' // Default to blank, assume it's decorative
	};
	
	exports.default = ProbeLogo;

/***/ },
/* 1504 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	__webpack_require__(2743);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProgressBar = function (_BcReactComponent) {
	  _inherits(ProgressBar, _BcReactComponent);
	
	  function ProgressBar(props) {
	    _classCallCheck(this, ProgressBar);
	
	    var _this = _possibleConstructorReturn(this, (ProgressBar.__proto__ || Object.getPrototypeOf(ProgressBar)).call(this, props));
	
	    _this.state = {
	      showMessaging: false
	    };
	    _this.timeout = null;
	    return _this;
	  }
	
	  _createClass(ProgressBar, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      // Show a screen reader message when hiding the bar and hide the message when showing the bar
	      if (nextProps.active !== this.props.active) {
	        this.setState({
	          showMessaging: this.props.active
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-progress-bar' },
	        _react2.default.createElement('div', { className: 'bar ' + (this.props.active ? 'active' : '') }),
	        _react2.default.createElement(
	          _baseScreenReaderMessage2.default,
	          { 'aria-live': 'polite', 'aria-atomic': 'true', role: 'region' },
	          this.state.showMessaging && _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ada_results_updated' })
	        )
	      );
	    }
	  }]);
	
	  return ProgressBar;
	}(_baseBcReactComponent2.default);
	
	ProgressBar.propTypes = {
	  active: _react.PropTypes.bool
	};
	
	exports.default = ProgressBar;

/***/ },
/* 1505 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PublicationDate = function PublicationDate(_ref) {
	  var publicationDate = _ref.publicationDate,
	      _ref$separator = _ref.separator,
	      separator = _ref$separator === undefined ? ' - ' : _ref$separator;
	  return publicationDate ? _react2.default.createElement(
	    'span',
	    { className: 'cp-publication-date' },
	    separator,
	    publicationDate
	  ) : null;
	};
	
	PublicationDate.propTypes = {
	  publicationDate: _react.PropTypes.string.isRequired,
	  separator: _react.PropTypes.string
	};
	
	exports.default = PublicationDate;

/***/ },
/* 1506 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ScreenReaderItemInfo = function ScreenReaderItemInfo(_ref) {
	  var format = _ref.format,
	      title = _ref.title,
	      authors = _ref.authors;
	
	  var hasAuthors = authors && (authors.size || authors.length);
	  var firstAuthor = void 0;
	  if (hasAuthors) {
	    firstAuthor = Array.isArray(authors) ? authors[0] : authors.first();
	  }
	
	  return _react2.default.createElement(
	    _baseScreenReaderMessage2.default,
	    { className: 'cp-screen-reader-item-info' },
	    '\u2014 ',
	    title,
	    ',\xA0',
	    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'FORMAT.' + (format && format.toLowerCase()) }),
	    '\xA0',
	    hasAuthors ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'by_authors', values: { authorLinks: firstAuthor } }) : null
	  );
	};
	
	ScreenReaderItemInfo.propTypes = {
	  format: _react.PropTypes.string.isRequired,
	  title: _react.PropTypes.string.isRequired,
	  authors: _react.PropTypes.oneOfType([_reactImmutableProptypes2.default.listOf(_react2.default.PropTypes.string), _react.PropTypes.arrayOf(_react.PropTypes.string)])
	};
	
	exports.default = ScreenReaderItemInfo;

/***/ },
/* 1507 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsLink = __webpack_require__(97);
	
	var _reactRouter = __webpack_require__(17);
	
	var _sharedJacketCover = __webpack_require__(93);
	
	var _sharedJacketCover2 = _interopRequireDefault(_sharedJacketCover);
	
	var _BibTextSlide = __webpack_require__(550);
	
	var _BibTextSlide2 = _interopRequireDefault(_BibTextSlide);
	
	__webpack_require__(2745);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SliderJacketCover = function SliderJacketCover(_ref) {
	  var handleClick = _ref.handleClick,
	      item = _ref.item,
	      _ref$domain = _ref.domain,
	      domain = _ref$domain === undefined ? '' : _ref$domain;
	  return _react2.default.createElement(
	    'div',
	    { className: 'cp-slider-jacket-cover' },
	    _react2.default.createElement(
	      _reactRouter.Link,
	      { key: item.id, onClick: handleClick, href: domain + '/item/show/' + (0, _utilsLink.metadataIdFixer)(item.id), target: '_parent' },
	      _react2.default.createElement(_sharedJacketCover2.default, { renderDefault: function renderDefault() {
	          return null;
	        }, format: item.format, src: item.jacket.medium, alt: '' }),
	      _react2.default.createElement(_BibTextSlide2.default, { item: item })
	    )
	  );
	};
	
	SliderJacketCover.propTypes = {
	  handleClick: _react2.default.PropTypes.func,
	  domain: _react2.default.PropTypes.string,
	  item: _react2.default.PropTypes.shape({
	    id: _react.PropTypes.string.isRequired,
	    format: _react.PropTypes.string.required,
	    jacket: _react.PropTypes.shape({
	      medium: _react.PropTypes.string.isRequired
	    }).isRequired,
	    title: _react.PropTypes.string.required
	  })
	};
	
	exports.default = SliderJacketCover;

/***/ },
/* 1508 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BibTextSlide = __webpack_require__(550);
	
	Object.defineProperty(exports, 'BibTextSlide', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BibTextSlide).default;
	  }
	});
	
	var _SliderJacketCover = __webpack_require__(1507);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SliderJacketCover).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1509 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	__webpack_require__(2746);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StaffTakeoverMessage = function StaffTakeoverMessage(_ref) {
	  var intl = _ref.intl,
	      name = _ref.name;
	  return _react2.default.createElement(
	    'div',
	    { className: 'cp-staff-takeover-message' },
	    _react2.default.createElement(
	      'h2',
	      null,
	      intl.formatHTMLMessage({ id: 'staffTakeoverMessage' }, {
	        name: name
	      }),
	      '\xA0',
	      _react2.default.createElement(
	        'a',
	        { href: '/user/reset_admin_session' },
	        intl.formatMessage({ id: 'resetStaffSessionLink' })
	      )
	    )
	  );
	};
	
	StaffTakeoverMessage.propTypes = {
	  intl: _reactIntl.intlShape.isRequired,
	  name: _react.PropTypes.string.isRequired
	};
	
	exports.default = (0, _reactIntl.injectIntl)(StaffTakeoverMessage);

/***/ },
/* 1510 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _StaffTakeoverMessage = __webpack_require__(1509);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_StaffTakeoverMessage).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1511 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseIcons = __webpack_require__(10);
	
	var _baseButtons = __webpack_require__(12);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	var _reactIntl = __webpack_require__(3);
	
	__webpack_require__(2747);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  message: _react.PropTypes.object.isRequired,
	  noticeActions: _react.PropTypes.object.isRequired,
	  dismissable: _react.PropTypes.bool.isRequired
	};
	
	var SystemMessage = function (_BcReactComponent) {
	  _inherits(SystemMessage, _BcReactComponent);
	
	  function SystemMessage(props) {
	    _classCallCheck(this, SystemMessage);
	
	    var _this = _possibleConstructorReturn(this, (SystemMessage.__proto__ || Object.getPrototypeOf(SystemMessage)).call(this, props));
	
	    _this.bindAll('dismissMessage', 'renderCloseButton', 'renderExpandButton', 'toggleExpanded');
	
	    _this.state = {
	      collapsible: false,
	      expanded: true
	    };
	
	    _this.iconNameMap = {
	      CRITICAL: _react2.default.createElement(_baseIcons.Warning, { className: 'small' }),
	      HIGH: _react2.default.createElement(_baseIcons.Attention, { className: 'small' }),
	      MEDIUM: _react2.default.createElement(_baseIcons.Info, { className: 'small' }),
	      LOW: _react2.default.createElement(_baseIcons.Info, { className: 'small' })
	    };
	    return _this;
	  }
	
	  _createClass(SystemMessage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.messageBody.clientHeight > 34) {
	        // eslint-disable-next-line react/no-did-mount-set-state
	        this.setState({ collapsible: true, expanded: false });
	      }
	    }
	  }, {
	    key: 'dismissMessage',
	    value: function dismissMessage() {
	      this.props.noticeActions.dismissNotice(this.props.message.get('id'));
	    }
	  }, {
	    key: 'toggleExpanded',
	    value: function toggleExpanded() {
	      this.setState({
	        expanded: !this.state.expanded
	      });
	    }
	  }, {
	    key: 'renderExpandButton',
	    value: function renderExpandButton() {
	      if (this.state.collapsible) {
	        var iconClass = this.state.expanded ? 'icon-up-dir' : 'icon-down-dir';
	        return _react2.default.createElement(
	          'div',
	          { className: 'collapse-expand-actions' },
	          _react2.default.createElement(
	            _baseButtons.TextButton,
	            { handleClick: this.toggleExpanded, 'aria-expanded': this.state.expanded },
	            _react2.default.createElement(
	              _baseScreenReaderMessage2.default,
	              null,
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'section_title_system_messages' })
	            ),
	            _react2.default.createElement('span', { 'aria-hidden': 'true', className: 'icon ' + iconClass })
	          )
	        );
	      }
	
	      return _react2.default.createElement('noop', null);
	    }
	  }, {
	    key: 'renderCloseButton',
	    value: function renderCloseButton() {
	      var dismissable = this.props.dismissable;
	
	      if (!dismissable) {
	        return _react2.default.createElement('noop', null);
	      }
	      return _react2.default.createElement(
	        'button',
	        { className: 'close', onClick: this.dismissMessage },
	        _react2.default.createElement(
	          _baseScreenReaderMessage2.default,
	          null,
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_close' })
	        ),
	        _react2.default.createElement('span', { 'aria-hidden': 'true', className: 'icon icon-cancel' })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var styles = {
	        height: this.state.expanded ? null : '27px',
	        overflow: 'hidden'
	      };
	      var message = this.props.message;
	
	      var className = 'cp-system-message ' + message.get('priority').toLowerCase();
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        this.renderCloseButton(),
	        _react2.default.createElement(
	          'div',
	          { className: 'wrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'priority-icon' },
	            this.iconNameMap[message.get('priority')]
	          ),
	          _react2.default.createElement('div', { className: 'message-body', style: styles, ref: function ref(el) {
	              _this2.messageBody = el;
	            }, dangerouslySetInnerHTML: { __html: message.get('message') } }),
	          this.renderExpandButton()
	        )
	      );
	    }
	  }]);
	
	  return SystemMessage;
	}(_baseBcReactComponent2.default);
	
	SystemMessage.propTypes = propTypes;
	
	exports.default = SystemMessage;

/***/ },
/* 1512 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SystemMessage = __webpack_require__(1511);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SystemMessage).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1513 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(16);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseIcon = __webpack_require__(176);
	
	var _baseIcon2 = _interopRequireDefault(_baseIcon);
	
	var _baseIcons = __webpack_require__(10);
	
	var _baseButtons = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AdvisoryConstants = {
	  GRAPHIC_VIOLENCE: 'GRAPHIC_VIOLENCE',
	  OFFENSIVE_LANGUAGE: 'OFFENSIVE_LANGUAGE',
	  SEXUAL_CONTENT: 'SEXUAL_CONTENT',
	  FRIGHTENING_SCENES: 'FRIGHTENING_SCENES',
	  OTHER: 'OTHER'
	};
	
	var ContentAdvisoryTypePicker = function (_BcReactComponent) {
	  _inherits(ContentAdvisoryTypePicker, _BcReactComponent);
	
	  function ContentAdvisoryTypePicker(props) {
	    _classCallCheck(this, ContentAdvisoryTypePicker);
	
	    var _this = _possibleConstructorReturn(this, (ContentAdvisoryTypePicker.__proto__ || Object.getPrototypeOf(ContentAdvisoryTypePicker)).call(this, props));
	
	    _this.bindAll('renderContentTypes', 'handleSelect');
	    return _this;
	  }
	
	  _createClass(ContentAdvisoryTypePicker, [{
	    key: 'handleSelect',
	    value: function handleSelect(value) {
	      this.props.handleSelect(value);
	    }
	  }, {
	    key: 'renderContentTypes',
	    value: function renderContentTypes(option) {
	      var _this2 = this;
	
	      var _props = this.props,
	          intl = _props.intl,
	          advisories = _props.advisories,
	          bibId = _props.bibId;
	
	      var advisory = _lodash2.default.find(advisories, { type: option });
	      if (advisory) {
	        return _react2.default.createElement(
	          'span',
	          { className: 'list-group-item list-group-item-success' },
	          _react2.default.createElement(
	            'h3',
	            { className: 'list-group-item-heading' },
	            _react2.default.createElement(_baseIcon2.default, { icon: 'icon-check pull-right' }),
	            _react2.default.createElement(_baseIcons.SVGIcon, { name: option }),
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: option.toLowerCase() + '_advisory_type' }),
	            _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
	              id: 'content_advisory_added',
	              values: {
	                type: intl.formatMessage({ id: option.toLowerCase() + '_advisory_type' }),
	                bibId: bibId,
	                userContentId: advisory.userContentId
	              } })
	          )
	        );
	      }
	
	      var handleSelect = function handleSelect() {
	        _this2.props.handleSelect(option);
	      };
	
	      return _react2.default.createElement(
	        _baseButtons.DefaultButton,
	        { handleClick: handleSelect, className: 'list-group-item' },
	        _react2.default.createElement(
	          'h3',
	          { className: 'list-group-item-heading' },
	          _react2.default.createElement(_baseIcon2.default, { icon: 'icon-angle-right pull-right' }),
	          _react2.default.createElement(_baseIcons.SVGIcon, { name: option }),
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: option.toLowerCase() + '_advisory_type' })
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-content-advisory-type-picker' },
	        _react2.default.createElement(
	          'div',
	          { className: 'list-group' },
	          _lodash2.default.map(AdvisoryConstants, this.renderContentTypes)
	        )
	      );
	    }
	  }]);
	
	  return ContentAdvisoryTypePicker;
	}(_baseBcReactComponent2.default);
	
	ContentAdvisoryTypePicker.propTypes = {
	  bibId: _react.PropTypes.number.isRequired,
	  handleSelect: _react.PropTypes.func.isRequired,
	  advisories: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	    type: _react.PropTypes.string,
	    userContentId: _react.PropTypes.string
	  })).isRequired,
	  intl: _reactIntl.intlShape
	};
	exports.default = (0, _reactIntl.injectIntl)(ContentAdvisoryTypePicker);

/***/ },
/* 1514 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InlineCommentEditor = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseAlerts = __webpack_require__(36);
	
	var _simpleUgcDisplay = __webpack_require__(229);
	
	var _simpleUgcDisplay2 = _interopRequireDefault(_simpleUgcDisplay);
	
	var _simpleUgcForm = __webpack_require__(106);
	
	var _simpleUgcForm2 = _interopRequireDefault(_simpleUgcForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InlineCommentEditor = exports.InlineCommentEditor = function (_BcReactComponent) {
	  _inherits(InlineCommentEditor, _BcReactComponent);
	
	  function InlineCommentEditor(props) {
	    _classCallCheck(this, InlineCommentEditor);
	
	    var _this = _possibleConstructorReturn(this, (InlineCommentEditor.__proto__ || Object.getPrototypeOf(InlineCommentEditor)).call(this, props));
	
	    _this.state = {
	      focusInput: false
	    };
	    return _this;
	  }
	
	  _createClass(InlineCommentEditor, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {/* for testing purposes */}
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (!this.props.showForm && nextProps.showForm) {
	        this.setState({
	          focusInput: true
	        });
	      }
	    }
	  }, {
	    key: 'renderMessaging',
	    value: function renderMessaging() {
	      var _props = this.props,
	          status = _props.status,
	          pending = _props.pending;
	
	      var infoMessage = _react2.default.createElement(
	        _baseAlerts.AlertInfo,
	        null,
	        _react2.default.createElement('span', { className: 'icon-spinner' }),
	        'Submitting comment...'
	      );
	      var successMessage = _react2.default.createElement(
	        _baseAlerts.AlertSuccess,
	        null,
	        'Comment Saved'
	      );
	      var failureMessage = _react2.default.createElement(
	        _baseAlerts.AlertFailure,
	        null,
	        _react2.default.createElement('span', { className: 'icon-ok' }),
	        'Could not save comment.'
	      );
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        pending ? infoMessage : null,
	        status === 'success' ? successMessage : null,
	        status === 'failure' ? failureMessage : null
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          characterLimit = _props2.characterLimit,
	          comment = _props2.comment,
	          fieldErrors = _props2.fieldErrors,
	          handleCancel = _props2.handleCancel,
	          handleChange = _props2.handleChange,
	          handleDelete = _props2.handleDelete,
	          handleShowForm = _props2.handleShowForm,
	          handleSubmit = _props2.handleSubmit,
	          handlePrivacyToggle = _props2.handlePrivacyToggle,
	          bibId = _props2.bibId,
	          isPrivate = _props2.isPrivate,
	          rating = _props2.rating,
	          showForm = _props2.showForm,
	          user = _props2.user;
	
	
	      if (showForm) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'cp-inline-comment-editor well clearfix' },
	          this.renderMessaging(),
	          _react2.default.createElement(_simpleUgcForm2.default, {
	            fieldErrors: fieldErrors,
	            errorKey: 'comment',
	            characterLimit: characterLimit,
	            body: comment,
	            ugcType: 'comment',
	            handleDelete: handleDelete,
	            handleCancel: handleCancel,
	            handleChange: handleChange,
	            handleSubmit: handleSubmit,
	            setFocus: this.state.focusInput,
	            formHeadingText: 'enter_a_comment',
	            placeholderText: 'comment_field_placeholder',
	            submitButtonText: 'update_comment' })
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.renderMessaging(),
	        _react2.default.createElement(_simpleUgcDisplay2.default, {
	          user: user,
	          ugcType: 'comment',
	          body: comment,
	          rating: rating / 2,
	          bibId: bibId,
	          isPrivate: isPrivate,
	          handleDelete: handleDelete,
	          handleShowForm: handleShowForm,
	          handlePrivacyToggle: handlePrivacyToggle })
	      );
	    }
	  }]);
	
	  return InlineCommentEditor;
	}(_baseBcReactComponent2.default);
	
	InlineCommentEditor.propTypes = {
	  characterLimit: _react.PropTypes.number,
	  comment: _react.PropTypes.string,
	  fieldErrors: _react.PropTypes.objectOf(_react.PropTypes.shape({
	    classification: _react.PropTypes.string,
	    message: _react.PropTypes.string
	  })),
	  handleCancel: _react.PropTypes.func.isRequired,
	  handleChange: _react.PropTypes.func.isRequired,
	  handleDelete: _react.PropTypes.func.isRequired,
	  handleShowForm: _react.PropTypes.func.isRequired,
	  handleSubmit: _react.PropTypes.func.isRequired,
	  handlePrivacyToggle: _react.PropTypes.func.isRequired,
	  bibId: _react.PropTypes.number.isRequired,
	  isPrivate: _react.PropTypes.bool.isRequired,
	  pending: _react.PropTypes.bool.isRequired,
	  rating: _react.PropTypes.number,
	  user: _react.PropTypes.shape({
	    loggedIn: _react.PropTypes.bool
	  }).isRequired,
	  showForm: _react.PropTypes.bool.isRequired,
	  status: _react.PropTypes.string.isRequired
	};
	
	exports.default = (0, _reactIntl.injectIntl)(InlineCommentEditor);

/***/ },
/* 1515 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _InlineCommentEditor = __webpack_require__(1514);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_InlineCommentEditor).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1516 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InlineContentAdvisoryEditor = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseAlerts = __webpack_require__(36);
	
	var _baseIcons = __webpack_require__(10);
	
	var _simpleUgcDisplay = __webpack_require__(229);
	
	var _simpleUgcDisplay2 = _interopRequireDefault(_simpleUgcDisplay);
	
	var _simpleUgcForm = __webpack_require__(106);
	
	var _simpleUgcForm2 = _interopRequireDefault(_simpleUgcForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InlineContentAdvisoryEditor = exports.InlineContentAdvisoryEditor = function (_BcReactComponent) {
	  _inherits(InlineContentAdvisoryEditor, _BcReactComponent);
	
	  function InlineContentAdvisoryEditor(props) {
	    _classCallCheck(this, InlineContentAdvisoryEditor);
	
	    var _this = _possibleConstructorReturn(this, (InlineContentAdvisoryEditor.__proto__ || Object.getPrototypeOf(InlineContentAdvisoryEditor)).call(this, props));
	
	    _this.bindAll('renderMessaging', 'renderHeading');
	    _this.state = {
	      focusInput: false
	    };
	    return _this;
	  }
	
	  _createClass(InlineContentAdvisoryEditor, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {/* testing purposes */}
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (!this.props.showForm && nextProps.showForm) {
	        this.setState({
	          focusInput: true
	        });
	      }
	    }
	  }, {
	    key: 'renderMessaging',
	    value: function renderMessaging() {
	      var _props = this.props,
	          status = _props.status,
	          pending = _props.pending;
	
	      var infoMessage = _react2.default.createElement(
	        _baseAlerts.AlertInfo,
	        null,
	        _react2.default.createElement('span', { className: 'icon-spinner' }),
	        'Submitting Notice...'
	      );
	      var successMessage = _react2.default.createElement(
	        _baseAlerts.AlertSuccess,
	        null,
	        'Notice Saved'
	      );
	      var failureMessage = _react2.default.createElement(
	        _baseAlerts.AlertFailure,
	        null,
	        _react2.default.createElement('span', { className: 'icon-ok' }),
	        'Could not save Notice.'
	      );
	      return _react2.default.createElement(
	        'div',
	        null,
	        pending ? infoMessage : null,
	        status === 'success' ? successMessage : null,
	        status === 'failure' ? failureMessage : null
	      );
	    }
	  }, {
	    key: 'renderHeading',
	    value: function renderHeading() {
	      var advisoryType = this.props.advisoryType;
	
	      var advisoryPart = '';
	      if (advisoryType) {
	        advisoryPart = _react2.default.createElement(_reactIntl.FormattedMessage, { id: advisoryType.toLowerCase() + '_advisory_type' });
	      }
	      return _react2.default.createElement(
	        'h3',
	        null,
	        _react2.default.createElement(_baseIcons.ContentAdvisory, null),
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'usercontent_type_content_advisory' }),
	        advisoryType ? ' - ' : null,
	        advisoryPart
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          characterLimit = _props2.characterLimit,
	          bibId = _props2.bibId,
	          isPrivate = _props2.isPrivate,
	          handlePrivacyToggle = _props2.handlePrivacyToggle,
	          advisoryType = _props2.advisoryType,
	          advisoryBody = _props2.advisoryBody,
	          handleDelete = _props2.handleDelete,
	          handleCancel = _props2.handleCancel,
	          handleShowForm = _props2.handleShowForm,
	          handleAdvisoryBodyChange = _props2.handleAdvisoryBodyChange,
	          handleSubmit = _props2.handleSubmit,
	          showForm = _props2.showForm,
	          rating = _props2.rating,
	          user = _props2.user;
	
	      if (showForm) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'cp-inline-content-advisory-editor well' },
	          this.renderMessaging(),
	          this.renderHeading(),
	          _react2.default.createElement(_simpleUgcForm2.default, {
	            characterLimit: characterLimit,
	            body: advisoryBody,
	            handleDelete: handleDelete,
	            handleCancel: handleCancel,
	            handleChange: handleAdvisoryBodyChange,
	            handleSubmit: handleSubmit,
	            setFocus: this.state.focusInput,
	            placeholderText: advisoryType.toLowerCase() + '_field_placeholder',
	            submitButtonText: 'update_content_advisory' }),
	          _react2.default.createElement('div', { className: 'clear' })
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.renderMessaging(),
	        _react2.default.createElement(_reactIntl.FormattedMessage, {
	          id: advisoryType.toLowerCase() + '_advisory_type', values: {
	            tagName: 'strong'
	          } }),
	        _react2.default.createElement(_simpleUgcDisplay2.default, {
	          bibId: bibId,
	          isPrivate: isPrivate,
	          handlePrivacyToggle: handlePrivacyToggle,
	          user: user,
	          ugcType: 'content_advisory',
	          body: advisoryBody,
	          rating: rating / 2,
	          handleDelete: handleDelete,
	          handleShowForm: handleShowForm })
	      );
	    }
	  }]);
	
	  return InlineContentAdvisoryEditor;
	}(_baseBcReactComponent2.default);
	
	InlineContentAdvisoryEditor.propTypes = {
	  bibId: _react.PropTypes.number.isRequired,
	  isPrivate: _react.PropTypes.bool.isRequired,
	  handlePrivacyToggle: _react.PropTypes.func.isRequired,
	  characterLimit: _react.PropTypes.number,
	  handleSubmit: _react.PropTypes.func.isRequired,
	  handleCancel: _react.PropTypes.func.isRequired,
	  handleDelete: _react.PropTypes.func.isRequired,
	  handleAdvisoryBodyChange: _react.PropTypes.func.isRequired,
	  handleShowForm: _react.PropTypes.func.isRequired,
	  initialAdvisoryBody: _react.PropTypes.string.isRequired,
	  advisoryType: _react.PropTypes.string.isRequired,
	  advisoryBody: _react.PropTypes.string.isRequired,
	  showForm: _react.PropTypes.bool.isRequired,
	  user: _react.PropTypes.shape({
	    loggedIn: _react.PropTypes.bool
	  }).isRequired,
	  rating: _react.PropTypes.number,
	  status: _react.PropTypes.string,
	  pending: _react.PropTypes.bool
	};
	
	InlineContentAdvisoryEditor.defaultProps = {
	  rating: 0
	};
	
	exports.default = InlineContentAdvisoryEditor;

/***/ },
/* 1517 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _InlineContentAdvisoryEditor = __webpack_require__(1516);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_InlineContentAdvisoryEditor).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1518 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InlineQuotationEditor = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseAlerts = __webpack_require__(36);
	
	var _simpleUgcDisplay = __webpack_require__(229);
	
	var _simpleUgcDisplay2 = _interopRequireDefault(_simpleUgcDisplay);
	
	var _simpleUgcForm = __webpack_require__(106);
	
	var _simpleUgcForm2 = _interopRequireDefault(_simpleUgcForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InlineQuotationEditor = exports.InlineQuotationEditor = function (_BcReactComponent) {
	  _inherits(InlineQuotationEditor, _BcReactComponent);
	
	  function InlineQuotationEditor(props) {
	    _classCallCheck(this, InlineQuotationEditor);
	
	    var _this = _possibleConstructorReturn(this, (InlineQuotationEditor.__proto__ || Object.getPrototypeOf(InlineQuotationEditor)).call(this, props));
	
	    _this.state = {
	      focusInput: false
	    };
	    return _this;
	  }
	
	  _createClass(InlineQuotationEditor, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {/* for testing purposes */}
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (!this.props.showForm && nextProps.showForm) {
	        this.setState({
	          focusInput: true
	        });
	      }
	    }
	  }, {
	    key: 'renderMessaging',
	    value: function renderMessaging() {
	      var _props = this.props,
	          status = _props.status,
	          pending = _props.pending;
	
	      var infoMessage = _react2.default.createElement(
	        _baseAlerts.AlertInfo,
	        null,
	        _react2.default.createElement('span', { className: 'icon-spinner' }),
	        'Submitting quotation...'
	      );
	      var successMessage = _react2.default.createElement(
	        _baseAlerts.AlertSuccess,
	        null,
	        'Quotation Saved'
	      );
	      var failureMessage = _react2.default.createElement(
	        _baseAlerts.AlertFailure,
	        null,
	        _react2.default.createElement('span', { className: 'icon-ok' }),
	        'Could not save quotation.'
	      );
	      return _react2.default.createElement(
	        'div',
	        null,
	        pending ? infoMessage : null,
	        status === 'success' ? successMessage : null,
	        status === 'failure' ? failureMessage : null
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          characterLimit = _props2.characterLimit,
	          bibId = _props2.bibId,
	          isPrivate = _props2.isPrivate,
	          handlePrivacyToggle = _props2.handlePrivacyToggle,
	          quotation = _props2.quotation,
	          handleCancel = _props2.handleCancel,
	          handleChange = _props2.handleChange,
	          handleDelete = _props2.handleDelete,
	          handleShowForm = _props2.handleShowForm,
	          handleSubmit = _props2.handleSubmit,
	          rating = _props2.rating,
	          showForm = _props2.showForm,
	          user = _props2.user;
	
	
	      if (showForm) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'cp-inline-quotation-editor well' },
	          this.renderMessaging(),
	          _react2.default.createElement(_simpleUgcForm2.default, {
	            characterLimit: characterLimit,
	            body: quotation,
	            handleDelete: handleDelete,
	            handleCancel: handleCancel,
	            handleChange: handleChange,
	            handleSubmit: handleSubmit,
	            setFocus: this.state.focusInput,
	            isNew: false,
	            ugcType: 'quotation',
	            placeholderText: 'quotation_field_placeholder',
	            submitButtonText: 'update_quotation',
	            formHeadingText: 'enter_a_quotation' }),
	          _react2.default.createElement('div', { className: 'clear' })
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.renderMessaging(),
	        _react2.default.createElement(_simpleUgcDisplay2.default, {
	          bibId: bibId,
	          isPrivate: isPrivate,
	          handlePrivacyToggle: handlePrivacyToggle,
	          user: user,
	          ugcType: 'quotation',
	          body: quotation,
	          rating: rating / 2,
	          handleDelete: handleDelete,
	          handleShowForm: handleShowForm })
	      );
	    }
	  }]);
	
	  return InlineQuotationEditor;
	}(_baseBcReactComponent2.default);
	
	InlineQuotationEditor.propTypes = {
	  characterLimit: _react.PropTypes.number,
	  quotation: _react.PropTypes.string,
	  bibId: _react.PropTypes.number.isRequired,
	  isPrivate: _react.PropTypes.bool.isRequired,
	  handlePrivacyToggle: _react.PropTypes.func.isRequired,
	  handleCancel: _react.PropTypes.func.isRequired,
	  handleChange: _react.PropTypes.func.isRequired,
	  handleDelete: _react.PropTypes.func.isRequired,
	  handleShowForm: _react.PropTypes.func.isRequired,
	  handleSubmit: _react.PropTypes.func.isRequired,
	  pending: _react.PropTypes.bool.isRequired,
	  rating: _react.PropTypes.number,
	  user: _react.PropTypes.shape({
	    loggedIn: _react.PropTypes.bool
	  }),
	  showForm: _react.PropTypes.bool.isRequired,
	  status: _react.PropTypes.string.isRequired
	};
	
	exports.default = InlineQuotationEditor;

/***/ },
/* 1519 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _InlineQuotationEditor = __webpack_require__(1518);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_InlineQuotationEditor).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1520 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InlineSummaryEditor = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseAlerts = __webpack_require__(36);
	
	var _simpleUgcDisplay = __webpack_require__(229);
	
	var _simpleUgcDisplay2 = _interopRequireDefault(_simpleUgcDisplay);
	
	var _simpleUgcForm = __webpack_require__(106);
	
	var _simpleUgcForm2 = _interopRequireDefault(_simpleUgcForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InlineSummaryEditor = exports.InlineSummaryEditor = function (_BcReactComponent) {
	  _inherits(InlineSummaryEditor, _BcReactComponent);
	
	  function InlineSummaryEditor() {
	    _classCallCheck(this, InlineSummaryEditor);
	
	    return _possibleConstructorReturn(this, (InlineSummaryEditor.__proto__ || Object.getPrototypeOf(InlineSummaryEditor)).apply(this, arguments));
	  }
	
	  _createClass(InlineSummaryEditor, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {/* For Testing purposes */}
	  }, {
	    key: 'renderMessaging',
	    value: function renderMessaging() {
	      var _props = this.props,
	          status = _props.status,
	          pending = _props.pending;
	
	      var infoMessage = _react2.default.createElement(
	        _baseAlerts.AlertInfo,
	        null,
	        _react2.default.createElement('span', { className: 'icon-spinner' }),
	        'Submitting summary...'
	      );
	      var successMessage = _react2.default.createElement(
	        _baseAlerts.AlertSuccess,
	        null,
	        'Summary Saved'
	      );
	      var failureMessage = _react2.default.createElement(
	        _baseAlerts.AlertFailure,
	        null,
	        _react2.default.createElement('span', { className: 'icon-ok' }),
	        'Could not save summary.'
	      );
	      return _react2.default.createElement(
	        'div',
	        null,
	        pending ? infoMessage : null,
	        status === 'success' ? successMessage : null,
	        status === 'failure' ? failureMessage : null
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          characterLimit = _props2.characterLimit,
	          summary = _props2.summary,
	          handleCancel = _props2.handleCancel,
	          handleChange = _props2.handleChange,
	          handleDelete = _props2.handleDelete,
	          handleShowForm = _props2.handleShowForm,
	          handleSubmit = _props2.handleSubmit,
	          bibId = _props2.bibId,
	          isPrivate = _props2.isPrivate,
	          handlePrivacyToggle = _props2.handlePrivacyToggle,
	          rating = _props2.rating,
	          showForm = _props2.showForm,
	          user = _props2.user;
	
	
	      if (showForm) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'cp-inline-summary-editor well' },
	          this.renderMessaging(),
	          _react2.default.createElement(_simpleUgcForm2.default, {
	            ugcType: 'summary',
	            characterLimit: characterLimit,
	            body: summary,
	            handleCancel: handleCancel,
	            handleChange: handleChange,
	            handleSubmit: handleSubmit,
	            handleDelete: handleDelete,
	            isNew: false,
	            placeholderText: 'summary_field_placeholder',
	            submitButtonText: 'update_summary',
	            formHeadingText: 'enter_a_summary' }),
	          _react2.default.createElement('div', { className: 'clear' })
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.renderMessaging(),
	        _react2.default.createElement(_simpleUgcDisplay2.default, {
	          user: user,
	          bibId: bibId,
	          isPrivate: isPrivate,
	          handlePrivacyToggle: handlePrivacyToggle,
	          ugcType: 'summary',
	          body: summary,
	          rating: rating / 2,
	          handleDelete: handleDelete,
	          handleShowForm: handleShowForm })
	      );
	    }
	  }]);
	
	  return InlineSummaryEditor;
	}(_baseBcReactComponent2.default);
	
	InlineSummaryEditor.propTypes = {
	  characterLimit: _react.PropTypes.number,
	  summary: _react.PropTypes.string,
	  bibId: _react.PropTypes.number.isRequired,
	  handlePrivacyToggle: _react.PropTypes.func.isRequired,
	  isPrivate: _react.PropTypes.bool.isRequired,
	  handleCancel: _react.PropTypes.func.isRequired,
	  handleChange: _react.PropTypes.func.isRequired,
	  handleDelete: _react.PropTypes.func.isRequired,
	  handleShowForm: _react.PropTypes.func.isRequired,
	  handleSubmit: _react.PropTypes.func.isRequired,
	  pending: _react.PropTypes.bool.isRequired,
	  rating: _react.PropTypes.number,
	  user: _react.PropTypes.shape({
	    loggedIn: _react.PropTypes.bool
	  }),
	  showForm: _react.PropTypes.bool.isRequired,
	  status: _react.PropTypes.string.isRequired
	};
	
	exports.default = InlineSummaryEditor;

/***/ },
/* 1521 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _InlineSummaryEditor = __webpack_require__(1520);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_InlineSummaryEditor).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1522 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InlineVideoEditor = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseAlerts = __webpack_require__(36);
	
	var _videoForm = __webpack_require__(370);
	
	var _videoForm2 = _interopRequireDefault(_videoForm);
	
	var _videoPreview = __webpack_require__(371);
	
	var _videoPreview2 = _interopRequireDefault(_videoPreview);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InlineVideoEditor = exports.InlineVideoEditor = function (_React$Component) {
	  _inherits(InlineVideoEditor, _React$Component);
	
	  function InlineVideoEditor(props) {
	    _classCallCheck(this, InlineVideoEditor);
	
	    var _this = _possibleConstructorReturn(this, (InlineVideoEditor.__proto__ || Object.getPrototypeOf(InlineVideoEditor)).call(this, props));
	
	    _this.state = {
	      focusTitle: false
	    };
	    return _this;
	  }
	
	  _createClass(InlineVideoEditor, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {/* testing goodness */}
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (!this.props.showForm && nextProps.showForm) {
	        this.setState({
	          focusTitle: true
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          bibId = _props.bibId,
	          description = _props.description,
	          deleted = _props.deleted,
	          embedSnippet = _props.embedSnippet,
	          iFrameSrc = _props.iFrameSrc,
	          isNew = _props.isNew,
	          isPrivate = _props.isPrivate,
	          fieldErrors = _props.fieldErrors,
	          handleCancel = _props.handleCancel,
	          handleCancelPreview = _props.handleCancelPreview,
	          handleDelete = _props.handleDelete,
	          handleDescriptionChange = _props.handleDescriptionChange,
	          handleEmbedSnippetChange = _props.handleEmbedSnippetChange,
	          handlePrivacyToggle = _props.handlePrivacyToggle,
	          handleShowForm = _props.handleShowForm,
	          handleSubmit = _props.handleSubmit,
	          handleTitleChange = _props.handleTitleChange,
	          showForm = _props.showForm,
	          videoTitle = _props.videoTitle;
	
	
	      if (deleted) {
	        return _react2.default.createElement(
	          _baseAlerts.AlertSuccess,
	          null,
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'video_deleted' })
	        );
	      }
	
	      if (showForm) {
	        return _react2.default.createElement(_videoForm2.default, {
	          fieldErrors: fieldErrors,
	          description: description,
	          embedSnippet: embedSnippet,
	          focusTitle: this.state.focusTitle,
	          iFrameSrc: iFrameSrc,
	          isNew: isNew,
	          handleCancel: handleCancel,
	          handleCancelPreview: handleCancelPreview,
	          handleDelete: handleDelete,
	          handleDescriptionChange: handleDescriptionChange,
	          handleEmbedSnippetChange: handleEmbedSnippetChange,
	          handleSubmit: handleSubmit,
	          handleTitleChange: handleTitleChange,
	          submitButtonText: 'update_video',
	          videoTitle: videoTitle });
	      }
	
	      return _react2.default.createElement(_videoPreview2.default, {
	        bibId: bibId,
	        description: description,
	        handleDelete: handleDelete,
	        handleShowForm: handleShowForm,
	        handlePrivacyToggle: handlePrivacyToggle,
	        iFrameSrc: iFrameSrc,
	        isPrivate: isPrivate,
	        showActions: true,
	        videoTitle: videoTitle });
	    }
	  }]);
	
	  return InlineVideoEditor;
	}(_react2.default.Component);
	
	InlineVideoEditor.propTypes = {
	  deleted: _react.PropTypes.bool,
	  videoTitle: _react.PropTypes.string,
	  description: _react.PropTypes.string,
	  fieldErrors: _react.PropTypes.objectOf(_react.PropTypes.shape({
	    classification: _react.PropTypes.string,
	    message: _react.PropTypes.string
	  })),
	  handleCancel: _react.PropTypes.func.isRequired,
	  handleCancelPreview: _react.PropTypes.func.isRequired,
	  handleDescriptionChange: _react.PropTypes.func.isRequired,
	  handleEmbedSnippetChange: _react.PropTypes.func.isRequired,
	  handleShowForm: _react.PropTypes.func,
	  handleDelete: _react.PropTypes.func,
	  handleSubmit: _react.PropTypes.func.isRequired,
	  handleTitleChange: _react.PropTypes.func.isRequired,
	  handlePrivacyToggle: _react.PropTypes.func.isRequired,
	  isPrivate: _react.PropTypes.bool.isRequired,
	  bibId: _react.PropTypes.number.isRequired,
	  iFrameSrc: _react.PropTypes.string,
	  isNew: _react.PropTypes.bool,
	  showForm: _react.PropTypes.bool,
	  embedSnippet: _react.PropTypes.string
	};
	
	exports.default = InlineVideoEditor;

/***/ },
/* 1523 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _InlineVideoEditor = __webpack_require__(1522);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_InlineVideoEditor).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1524 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LoginLink = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LoginLink = exports.LoginLink = function (_BcReactComponent) {
	  _inherits(LoginLink, _BcReactComponent);
	
	  function LoginLink() {
	    _classCallCheck(this, LoginLink);
	
	    return _possibleConstructorReturn(this, (LoginLink.__proto__ || Object.getPrototypeOf(LoginLink)).apply(this, arguments));
	  }
	
	  _createClass(LoginLink, [{
	    key: 'render',
	    value: function render() {
	      var handleLogin = this.props.handleLogin;
	
	      return _react2.default.createElement(
	        'a',
	        { href: '/user/login', onClick: handleLogin, className: 'cp-login-link btn btn-primary', tabIndex: '0' },
	        this.props.children
	      );
	    }
	  }]);
	
	  return LoginLink;
	}(_baseBcReactComponent2.default);
	
	LoginLink.propTypes = {
	  handleLogin: _react.PropTypes.func.isRequired,
	  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node]).isRequired
	};
	
	exports.default = LoginLink;

/***/ },
/* 1525 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PrimaryCommentEditor = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _utilsLocalization = __webpack_require__(233);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseLoader = __webpack_require__(138);
	
	var _baseLoader2 = _interopRequireDefault(_baseLoader);
	
	var _baseAlerts = __webpack_require__(36);
	
	var _baseIcons = __webpack_require__(10);
	
	var _loginLink = __webpack_require__(178);
	
	var _loginLink2 = _interopRequireDefault(_loginLink);
	
	var _simpleUgcForm = __webpack_require__(106);
	
	var _simpleUgcForm2 = _interopRequireDefault(_simpleUgcForm);
	
	var _simpleUgcPermalink = __webpack_require__(277);
	
	var _simpleUgcPermalink2 = _interopRequireDefault(_simpleUgcPermalink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PrimaryCommentEditor = exports.PrimaryCommentEditor = function (_BcReactComponent) {
	  _inherits(PrimaryCommentEditor, _BcReactComponent);
	
	  function PrimaryCommentEditor() {
	    _classCallCheck(this, PrimaryCommentEditor);
	
	    return _possibleConstructorReturn(this, (PrimaryCommentEditor.__proto__ || Object.getPrototypeOf(PrimaryCommentEditor)).apply(this, arguments));
	  }
	
	  _createClass(PrimaryCommentEditor, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {/* For Testing Purposes */}
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          characterLimit = _props.characterLimit,
	          fieldErrors = _props.fieldErrors,
	          handleChange = _props.handleChange,
	          handleLogin = _props.handleLogin,
	          handleSubmit = _props.handleSubmit,
	          isPrivate = _props.isPrivate,
	          handlePrivacyToggle = _props.handlePrivacyToggle,
	          bibId = _props.bibId,
	          showForm = _props.showForm,
	          user = _props.user,
	          userContentId = _props.userContentId,
	          comment = _props.comment,
	          initializingStatus = _props.initializingStatus;
	
	
	      if (initializingStatus.status === 'pending') {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_baseLoader2.default, null)
	        );
	      }
	      if (initializingStatus.status === 'failure') {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _baseAlerts.AlertFailure,
	            null,
	            _react2.default.createElement('span', { className: 'icon-ok' }),
	            (0, _utilsLocalization.localizeFromKey)(initializingStatus, this.props.intl)
	          )
	        );
	      }
	
	      if (user.loggedIn) {
	        if (showForm) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'cp-primary-comment-editor well clearfix' },
	            _react2.default.createElement(_simpleUgcForm2.default, {
	              fieldErrors: fieldErrors,
	              errorKey: 'comment',
	              formHeadingText: 'enter_a_comment',
	              placeholderText: 'comment_field_placeholder',
	              submitButtonText: 'add_comment',
	              characterLimit: characterLimit,
	              body: comment,
	              ugcType: 'comment',
	              handleChange: handleChange,
	              handleSubmit: handleSubmit,
	              isNew: true })
	          );
	        }
	
	        return _react2.default.createElement(_simpleUgcPermalink2.default, {
	          bibId: bibId,
	          userContentId: userContentId,
	          isPrivate: isPrivate,
	          ugcType: 'comment',
	          handlePrivacyToggle: handlePrivacyToggle });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'well login' },
	        _react2.default.createElement(
	          _loginLink2.default,
	          { handleLogin: handleLogin },
	          _react2.default.createElement(_baseIcons.Comment, null),
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'login_to_add_comment' })
	        )
	      );
	    }
	  }]);
	
	  return PrimaryCommentEditor;
	}(_baseBcReactComponent2.default);
	
	PrimaryCommentEditor.propTypes = {
	  initializingStatus: _react.PropTypes.shape({
	    status: _react.PropTypes.string
	  }).isRequired,
	  characterLimit: _react.PropTypes.number,
	  comment: _react.PropTypes.string,
	  fieldErrors: _react.PropTypes.objectOf(_react.PropTypes.shape({
	    classification: _react.PropTypes.string,
	    message: _react.PropTypes.string
	  })),
	  handleChange: _react.PropTypes.func.isRequired,
	  handleLogin: _react.PropTypes.func.isRequired,
	  handleSubmit: _react.PropTypes.func.isRequired,
	  handlePrivacyToggle: _react.PropTypes.func.isRequired,
	  isPrivate: _react.PropTypes.bool,
	  bibId: _react.PropTypes.number.isRequired,
	  showForm: _react.PropTypes.bool.isRequired,
	  user: _react.PropTypes.shape({
	    loggedIn: _react.PropTypes.bool
	  }).isRequired,
	  userContentId: _react.PropTypes.number,
	  intl: _reactIntl.intlShape
	};
	
	exports.default = (0, _reactIntl.injectIntl)(PrimaryCommentEditor);

/***/ },
/* 1526 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PrimaryCommentEditor = __webpack_require__(1525);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PrimaryCommentEditor).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1527 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _utilsLocalization = __webpack_require__(233);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseLoader = __webpack_require__(138);
	
	var _baseLoader2 = _interopRequireDefault(_baseLoader);
	
	var _baseAlerts = __webpack_require__(36);
	
	var _baseIcons = __webpack_require__(10);
	
	var _contentAdvisoryTypePicker = __webpack_require__(551);
	
	var _contentAdvisoryTypePicker2 = _interopRequireDefault(_contentAdvisoryTypePicker);
	
	var _loginLink = __webpack_require__(178);
	
	var _loginLink2 = _interopRequireDefault(_loginLink);
	
	var _simpleUgcForm = __webpack_require__(106);
	
	var _simpleUgcForm2 = _interopRequireDefault(_simpleUgcForm);
	
	__webpack_require__(2748);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PrimaryContentAdvisoryEditor = function (_BcReactComponent) {
	  _inherits(PrimaryContentAdvisoryEditor, _BcReactComponent);
	
	  function PrimaryContentAdvisoryEditor(props) {
	    _classCallCheck(this, PrimaryContentAdvisoryEditor);
	
	    var _this = _possibleConstructorReturn(this, (PrimaryContentAdvisoryEditor.__proto__ || Object.getPrototypeOf(PrimaryContentAdvisoryEditor)).call(this, props));
	
	    _this.bindAll('renderHeading');
	    return _this;
	  }
	
	  _createClass(PrimaryContentAdvisoryEditor, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {/* For Testing Purposes */}
	  }, {
	    key: 'renderHeading',
	    value: function renderHeading() {
	      var advisoryType = this.props.advisoryType;
	
	      var advisoryPart = '';
	      if (advisoryType) {
	        advisoryPart = _react2.default.createElement(_reactIntl.FormattedMessage, { id: advisoryType.toLowerCase() + '_advisory_type' });
	      }
	      return _react2.default.createElement(
	        'h3',
	        null,
	        _react2.default.createElement(_baseIcons.ContentAdvisory, null),
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'usercontent_type_content_advisory' }),
	        advisoryType ? ' - ' : null,
	        advisoryPart
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          advisoryBody = _props.advisoryBody,
	          advisoryType = _props.advisoryType,
	          handleAdvisoryBodyChange = _props.handleAdvisoryBodyChange,
	          handleSubmit = _props.handleSubmit,
	          handleCancel = _props.handleCancel,
	          handleLogin = _props.handleLogin,
	          intl = _props.intl,
	          initializingStatus = _props.initializingStatus,
	          characterLimit = _props.characterLimit,
	          user = _props.user;
	
	
	      if (initializingStatus.status === 'pending') {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_baseLoader2.default, null)
	        );
	      }
	
	      if (initializingStatus.status === 'failure') {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _baseAlerts.AlertFailure,
	            null,
	            _react2.default.createElement('span', { className: 'icon-ok' }),
	            (0, _utilsLocalization.localizeFromKey)(initializingStatus, intl)
	          )
	        );
	      }
	      if (user.loggedIn) {
	        if (advisoryType !== null) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'cp-primary-content-advisory-editor well clearfix' },
	            this.renderHeading(),
	            _react2.default.createElement(_simpleUgcForm2.default, {
	              placeholderText: advisoryType.toLowerCase() + '_field_placeholder',
	              submitButtonText: 'add_content',
	              characterLimit: characterLimit,
	              body: advisoryBody,
	              handleChange: handleAdvisoryBodyChange,
	              handleSubmit: handleSubmit,
	              handleCancel: handleCancel,
	              isNew: true })
	          );
	        }
	
	        return _react2.default.createElement(
	          'div',
	          { className: 'cp-primary-content-advisory-editor well' },
	          this.renderHeading(),
	          _react2.default.createElement(_contentAdvisoryTypePicker2.default, {
	            advisories: this.props.advisories,
	            bibId: this.props.bibId,
	            handleSelect: this.props.handleAdvisoryTypeChange })
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'well' },
	        _react2.default.createElement(
	          _loginLink2.default,
	          { handleLogin: handleLogin },
	          _react2.default.createElement(_baseIcons.ContentAdvisory, null),
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'login_to_add_content_advisory' })
	        )
	      );
	    }
	  }]);
	
	  return PrimaryContentAdvisoryEditor;
	}(_baseBcReactComponent2.default);
	
	PrimaryContentAdvisoryEditor.propTypes = {
	  bibId: _react.PropTypes.string.isRequired,
	  advisories: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	    type: _react.PropTypes.string,
	    userContentId: _react.PropTypes.string
	  })).isRequired,
	  advisoryType: _react.PropTypes.string,
	  advisoryBody: _react.PropTypes.string,
	  handleAdvisoryTypeChange: _react.PropTypes.func.isRequired,
	  handleAdvisoryBodyChange: _react.PropTypes.func.isRequired,
	  handleSubmit: _react.PropTypes.func.isRequired,
	  handleCancel: _react.PropTypes.func.isRequired,
	  handleLogin: _react.PropTypes.func.isRequired,
	  characterLimit: _react.PropTypes.number,
	  initializingStatus: _react.PropTypes.shape({
	    status: _react.PropTypes.string
	  }).isRequired,
	  user: _react.PropTypes.shape({
	    loggedIn: _react.PropTypes.bool
	  }).isRequired,
	  intl: _reactIntl.intlShape
	};
	
	PrimaryContentAdvisoryEditor.defaultProps = {
	  characterLimit: 500
	};
	
	exports.default = (0, _reactIntl.injectIntl)(PrimaryContentAdvisoryEditor);

/***/ },
/* 1528 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PrimaryContentAdvisoryEditor = __webpack_require__(1527);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PrimaryContentAdvisoryEditor).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1529 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PrimaryQuotationEditor = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _utilsLocalization = __webpack_require__(233);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseLoader = __webpack_require__(138);
	
	var _baseLoader2 = _interopRequireDefault(_baseLoader);
	
	var _baseAlerts = __webpack_require__(36);
	
	var _baseIcons = __webpack_require__(10);
	
	var _loginLink = __webpack_require__(178);
	
	var _loginLink2 = _interopRequireDefault(_loginLink);
	
	var _simpleUgcForm = __webpack_require__(106);
	
	var _simpleUgcForm2 = _interopRequireDefault(_simpleUgcForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PrimaryQuotationEditor = exports.PrimaryQuotationEditor = function (_BcReactComponent) {
	  _inherits(PrimaryQuotationEditor, _BcReactComponent);
	
	  function PrimaryQuotationEditor() {
	    _classCallCheck(this, PrimaryQuotationEditor);
	
	    return _possibleConstructorReturn(this, (PrimaryQuotationEditor.__proto__ || Object.getPrototypeOf(PrimaryQuotationEditor)).apply(this, arguments));
	  }
	
	  _createClass(PrimaryQuotationEditor, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {/* For Testing purposes */}
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          characterLimit = _props.characterLimit,
	          intl = _props.intl,
	          handleChange = _props.handleChange,
	          handleLogin = _props.handleLogin,
	          handleSubmit = _props.handleSubmit,
	          initializingStatus = _props.initializingStatus,
	          user = _props.user;
	
	
	      if (initializingStatus.status === 'pending') {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_baseLoader2.default, null)
	        );
	      }
	
	      if (initializingStatus.status === 'failure') {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _baseAlerts.AlertFailure,
	            null,
	            _react2.default.createElement('span', { className: 'icon-ok' }),
	            (0, _utilsLocalization.localizeFromKey)(initializingStatus, intl)
	          )
	        );
	      }
	
	      if (user.loggedIn) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'cp-primary-quotation-editor well clearfix' },
	          _react2.default.createElement(_simpleUgcForm2.default, {
	            characterLimit: characterLimit,
	            body: '',
	            ugcType: 'quotation',
	            placeholderText: 'quotation_field_placeholder',
	            submitButtonText: 'add_quotation',
	            formHeadingText: 'enter_a_quotation',
	            handleChange: handleChange,
	            handleSubmit: handleSubmit,
	            isNew: true })
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'well' },
	        _react2.default.createElement(
	          _loginLink2.default,
	          { handleLogin: handleLogin },
	          _react2.default.createElement(_baseIcons.Quotation, null),
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'login_to_add_quotation' })
	        )
	      );
	    }
	  }]);
	
	  return PrimaryQuotationEditor;
	}(_baseBcReactComponent2.default);
	
	PrimaryQuotationEditor.propTypes = {
	  initializingStatus: _react.PropTypes.shape({
	    status: _react.PropTypes.string
	  }).isRequired,
	  characterLimit: _react.PropTypes.number,
	  quotation: _react.PropTypes.string,
	  handleChange: _react.PropTypes.func.isRequired,
	  handleLogin: _react.PropTypes.func.isRequired,
	  handleSubmit: _react.PropTypes.func.isRequired,
	  user: _react.PropTypes.shape({
	    loggedIn: _react.PropTypes.bool
	  }).isRequired,
	  intl: _reactIntl.intlShape
	};
	
	exports.default = (0, _reactIntl.injectIntl)(PrimaryQuotationEditor);

/***/ },
/* 1530 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PrimaryQuotationEditor = __webpack_require__(1529);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PrimaryQuotationEditor).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1531 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PrimarySummaryEditor = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _utilsLocalization = __webpack_require__(233);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseLoader = __webpack_require__(138);
	
	var _baseLoader2 = _interopRequireDefault(_baseLoader);
	
	var _baseAlerts = __webpack_require__(36);
	
	var _baseIcons = __webpack_require__(10);
	
	var _loginLink = __webpack_require__(178);
	
	var _loginLink2 = _interopRequireDefault(_loginLink);
	
	var _simpleUgcForm = __webpack_require__(106);
	
	var _simpleUgcForm2 = _interopRequireDefault(_simpleUgcForm);
	
	var _simpleUgcPermalink = __webpack_require__(277);
	
	var _simpleUgcPermalink2 = _interopRequireDefault(_simpleUgcPermalink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PrimarySummaryEditor = exports.PrimarySummaryEditor = function (_BcReactComponent) {
	  _inherits(PrimarySummaryEditor, _BcReactComponent);
	
	  function PrimarySummaryEditor() {
	    _classCallCheck(this, PrimarySummaryEditor);
	
	    return _possibleConstructorReturn(this, (PrimarySummaryEditor.__proto__ || Object.getPrototypeOf(PrimarySummaryEditor)).apply(this, arguments));
	  }
	
	  _createClass(PrimarySummaryEditor, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {/* testing goodness */}
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          characterLimit = _props.characterLimit,
	          handleChange = _props.handleChange,
	          handleLogin = _props.handleLogin,
	          handleSubmit = _props.handleSubmit,
	          showForm = _props.showForm,
	          user = _props.user,
	          userContentId = _props.userContentId,
	          summary = _props.summary,
	          bibId = _props.bibId,
	          isPrivate = _props.isPrivate,
	          handlePrivacyToggle = _props.handlePrivacyToggle,
	          initializingStatus = _props.initializingStatus;
	
	
	      if (initializingStatus.status === 'pending') {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_baseLoader2.default, null)
	        );
	      }
	
	      if (initializingStatus.status === 'failure') {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _baseAlerts.AlertFailure,
	            null,
	            _react2.default.createElement('span', { className: 'icon-ok' }),
	            (0, _utilsLocalization.localizeFromKey)(initializingStatus, this.props.intl)
	          )
	        );
	      }
	
	      if (user.loggedIn) {
	        if (showForm) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'cp-primary-summary-editor well clearfix' },
	            _react2.default.createElement(_simpleUgcForm2.default, {
	              placeholderText: 'summary_field_placeholder',
	              submitButtonText: 'add_summary',
	              formHeadingText: 'enter_a_summary',
	              characterLimit: characterLimit,
	              body: summary,
	              ugcType: 'summary',
	              handleChange: handleChange,
	              handleSubmit: handleSubmit,
	              isNew: true })
	          );
	        }
	
	        return _react2.default.createElement(_simpleUgcPermalink2.default, {
	          bibId: bibId,
	          userContentId: userContentId,
	          ugcType: 'summary',
	          isPrivate: isPrivate,
	          handlePrivacyToggle: handlePrivacyToggle });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'well' },
	        _react2.default.createElement(
	          _loginLink2.default,
	          { handleLogin: handleLogin },
	          _react2.default.createElement(_baseIcons.Summary, null),
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'login_to_add_summary' })
	        )
	      );
	    }
	  }]);
	
	  return PrimarySummaryEditor;
	}(_baseBcReactComponent2.default);
	
	PrimarySummaryEditor.propTypes = {
	  initializingStatus: _react.PropTypes.shape({
	    status: _react.PropTypes.string
	  }).isRequired,
	  characterLimit: _react.PropTypes.number,
	  summary: _react.PropTypes.string,
	  handleCancel: _react.PropTypes.func.isRequired,
	  handleChange: _react.PropTypes.func.isRequired,
	  handleLogin: _react.PropTypes.func.isRequired,
	  handleSubmit: _react.PropTypes.func.isRequired,
	  bibId: _react.PropTypes.string.isRequired,
	  isPrivate: _react.PropTypes.bool.isRequired,
	  handlePrivacyToggle: _react.PropTypes.func.isRequired,
	  showForm: _react.PropTypes.bool.isRequired,
	  user: _react.PropTypes.shape({
	    loggedIn: _react.PropTypes.bool
	  }).isRequired,
	  userContentId: _react.PropTypes.number,
	  intl: _reactIntl.intlShape
	};
	
	exports.default = (0, _reactIntl.injectIntl)(PrimarySummaryEditor);

/***/ },
/* 1532 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PrimarySummaryEditor = __webpack_require__(1531);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PrimarySummaryEditor).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1533 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PrimaryVideoEditor = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseLoader = __webpack_require__(138);
	
	var _baseLoader2 = _interopRequireDefault(_baseLoader);
	
	var _baseAlerts = __webpack_require__(36);
	
	var _baseIcons = __webpack_require__(10);
	
	var _baseButtons = __webpack_require__(12);
	
	var _loginLink = __webpack_require__(178);
	
	var _loginLink2 = _interopRequireDefault(_loginLink);
	
	var _simpleUgcPermalink = __webpack_require__(277);
	
	var _simpleUgcPermalink2 = _interopRequireDefault(_simpleUgcPermalink);
	
	var _videoForm = __webpack_require__(370);
	
	var _videoForm2 = _interopRequireDefault(_videoForm);
	
	__webpack_require__(2749);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PrimaryVideoEditor = exports.PrimaryVideoEditor = function (_BcReactComponent) {
	  _inherits(PrimaryVideoEditor, _BcReactComponent);
	
	  function PrimaryVideoEditor() {
	    _classCallCheck(this, PrimaryVideoEditor);
	
	    return _possibleConstructorReturn(this, (PrimaryVideoEditor.__proto__ || Object.getPrototypeOf(PrimaryVideoEditor)).apply(this, arguments));
	  }
	
	  _createClass(PrimaryVideoEditor, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {/* testing */}
	  }, {
	    key: 'recoveryLink',
	    value: function recoveryLink() {
	      return _react2.default.createElement(
	        _baseButtons.Button,
	        { className: 'recovery-link', handleClick: this.props.handleNerfRecovery },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'error_ugc_broken_retry_button' })
	      );
	    }
	  }, {
	    key: 'recoveryInfo',
	    value: function recoveryInfo() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'recovery-info' },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'error_ugc_recovery_info', values: { tries: this.props.initializingStatus.tries || 1, retry_link: this.recoveryLink() } })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          embedSnippet = _props.embedSnippet,
	          bibId = _props.bibId,
	          fieldErrors = _props.fieldErrors,
	          isPrivate = _props.isPrivate,
	          handlePrivacyToggle = _props.handlePrivacyToggle,
	          iFrameSrc = _props.iFrameSrc,
	          isNew = _props.isNew,
	          showForm = _props.showForm,
	          handleCancelPreview = _props.handleCancelPreview,
	          handleDescriptionChange = _props.handleDescriptionChange,
	          handleEmbedSnippetChange = _props.handleEmbedSnippetChange,
	          handleSubmit = _props.handleSubmit,
	          handleTitleChange = _props.handleTitleChange,
	          handleLogin = _props.handleLogin,
	          videoTitle = _props.videoTitle,
	          description = _props.description,
	          user = _props.user,
	          initializingStatus = _props.initializingStatus,
	          userContentId = _props.userContentId,
	          handleCancel = _props.handleCancel,
	          handleNerfRecovery = _props.handleNerfRecovery;
	
	
	      if (initializingStatus.status === 'pending') {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_baseLoader2.default, null)
	        );
	      }
	
	      if (initializingStatus.status === 'failure') {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _baseAlerts.AlertFailure,
	            null,
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: initializingStatus.localeKey, values: { recoveryInfo: this.recoveryInfo() } })
	          )
	        );
	      }
	
	      if (user.loggedIn) {
	        if (showForm) {
	          return _react2.default.createElement(_videoForm2.default, {
	            fieldErrors: fieldErrors,
	            embedSnippet: embedSnippet,
	            isNew: isNew,
	            videoTitle: videoTitle,
	            showPreview: !!iFrameSrc,
	            description: description,
	            iFrameSrc: iFrameSrc,
	            handleTitleChange: handleTitleChange,
	            handleDescriptionChange: handleDescriptionChange,
	            handleEmbedSnippetChange: handleEmbedSnippetChange,
	            handleSubmit: handleSubmit,
	            submitButtonText: 'add_video',
	            handleCancel: handleCancel,
	            handleCancelPreview: handleCancelPreview,
	            handleNerfRecovery: handleNerfRecovery });
	        }
	
	        return _react2.default.createElement(_simpleUgcPermalink2.default, {
	          bibId: bibId,
	          userContentId: userContentId,
	          ugcType: 'video',
	          isPrivate: isPrivate,
	          handlePrivacyToggle: handlePrivacyToggle });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'well login' },
	        _react2.default.createElement(
	          _loginLink2.default,
	          { handleLogin: handleLogin },
	          _react2.default.createElement(_baseIcons.Video, null),
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'login_to_add_video' })
	        )
	      );
	    }
	  }]);
	
	  return PrimaryVideoEditor;
	}(_baseBcReactComponent2.default);
	
	PrimaryVideoEditor.propTypes = {
	  fieldErrors: _react.PropTypes.objectOf(_react.PropTypes.shape({
	    classification: _react.PropTypes.string,
	    message: _react.PropTypes.string
	  })),
	  user: _react.PropTypes.shape({
	    loggedIn: _react.PropTypes.bool
	  }).isRequired,
	  initializingStatus: _react.PropTypes.shape({
	    status: _react.PropTypes.string
	  }).isRequired,
	  videoTitle: _react.PropTypes.string,
	  showPreview: _react.PropTypes.bool,
	  description: _react.PropTypes.string,
	  handleCancelPreview: _react.PropTypes.func.isRequired,
	  handleDescriptionChange: _react.PropTypes.func.isRequired,
	  handleEmbedSnippetChange: _react.PropTypes.func.isRequired,
	  handleLogin: _react.PropTypes.func.isRequired,
	  handleSubmit: _react.PropTypes.func.isRequired,
	  handleTitleChange: _react.PropTypes.func.isRequired,
	  bibId: _react.PropTypes.number.isRequired,
	  isPrivate: _react.PropTypes.bool.isRequired,
	  handlePrivacyToggle: _react.PropTypes.func.isRequired,
	  handleNerfRecovery: _react.PropTypes.func.isRequired,
	  userContentId: _react.PropTypes.number,
	  iFrameSrc: _react.PropTypes.string,
	  isNew: _react.PropTypes.bool,
	  showEmbedForm: _react.PropTypes.bool,
	  showForm: _react.PropTypes.bool,
	  embedSnippet: _react.PropTypes.string,
	  intl: _reactIntl.intlShape,
	  handleCancel: _react.PropTypes.func
	};
	
	exports.default = (0, _reactIntl.injectIntl)(PrimaryVideoEditor);

/***/ },
/* 1534 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PrimaryVideoEditor = __webpack_require__(1533);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PrimaryVideoEditor).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1535 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PrivacyToggle = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseButtons = __webpack_require__(12);
	
	var _baseIcons = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PrivacyToggle = exports.PrivacyToggle = function (_React$Component) {
	  _inherits(PrivacyToggle, _React$Component);
	
	  function PrivacyToggle() {
	    _classCallCheck(this, PrivacyToggle);
	
	    return _possibleConstructorReturn(this, (PrivacyToggle.__proto__ || Object.getPrototypeOf(PrivacyToggle)).apply(this, arguments));
	  }
	
	  _createClass(PrivacyToggle, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {/* for testing goodness */}
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          isPrivate = _props.isPrivate,
	          handlePrivacyToggle = _props.handlePrivacyToggle,
	          showLabel = _props.showLabel;
	
	
	      return _react2.default.createElement(
	        _baseButtons.TextButton,
	        { handleClick: handlePrivacyToggle, className: 'cp-privacy-toggle' },
	        PrivacyToggle.renderIcon(isPrivate),
	        showLabel ? PrivacyToggle.renderLabel(isPrivate) : null
	      );
	    }
	  }], [{
	    key: 'renderIcon',
	    value: function renderIcon(isPrivate) {
	      if (isPrivate) {
	        return _react2.default.createElement(_baseIcons.Lock, null);
	      }
	      return _react2.default.createElement(_baseIcons.Unlock, null);
	    }
	  }, {
	    key: 'renderLabel',
	    value: function renderLabel(isPrivate) {
	      if (isPrivate) {
	        return _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'private' });
	      }
	      return _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'shared' });
	    }
	  }]);
	
	  return PrivacyToggle;
	}(_react2.default.Component);
	
	PrivacyToggle.propTypes = {
	  isPrivate: _react.PropTypes.bool.isRequired,
	  showLabel: _react.PropTypes.bool.isRequired,
	  handlePrivacyToggle: _react.PropTypes.func.isRequired
	};
	
	exports.default = PrivacyToggle;

/***/ },
/* 1536 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SimpleUGCDisplay = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _rating = __webpack_require__(141);
	
	var _rating2 = _interopRequireDefault(_rating);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseIcon = __webpack_require__(176);
	
	var _baseIcon2 = _interopRequireDefault(_baseIcon);
	
	var _baseButtons = __webpack_require__(12);
	
	var _privacyToggle = __webpack_require__(276);
	
	var _privacyToggle2 = _interopRequireDefault(_privacyToggle);
	
	__webpack_require__(2750);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SimpleUGCDisplay = exports.SimpleUGCDisplay = function (_BcReactComponent) {
	  _inherits(SimpleUGCDisplay, _BcReactComponent);
	
	  function SimpleUGCDisplay(props) {
	    _classCallCheck(this, SimpleUGCDisplay);
	
	    var _this = _possibleConstructorReturn(this, (SimpleUGCDisplay.__proto__ || Object.getPrototypeOf(SimpleUGCDisplay)).call(this, props));
	
	    _this.bindAll('renderRating');
	    return _this;
	  }
	
	  _createClass(SimpleUGCDisplay, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {/* For testing */}
	  }, {
	    key: 'renderRating',
	    value: function renderRating() {
	      var _props = this.props,
	          user = _props.user,
	          rating = _props.rating;
	
	      if (user.name && rating > 0) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'user-rating' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, {
	            id: 'users_rating',
	            values: {
	              username: user.name,
	              rating: _react2.default.createElement(_rating2.default, { rating: rating }),
	              type: 'blue'
	            } })
	        );
	      }
	      return null;
	    }
	  }, {
	    key: 'renderUGCActions',
	    value: function renderUGCActions() {
	      var _props2 = this.props,
	          handleShowForm = _props2.handleShowForm,
	          handleDelete = _props2.handleDelete,
	          bibId = _props2.bibId,
	          isPrivate = _props2.isPrivate,
	          handlePrivacyToggle = _props2.handlePrivacyToggle;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ugc-actions' },
	        _react2.default.createElement(
	          _baseButtons.TextButton,
	          { handleClick: handleShowForm },
	          _react2.default.createElement(_baseIcon2.default, { icon: 'icon-edit' }),
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'edit_button' })
	        ),
	        _react2.default.createElement(
	          _baseButtons.TextButton,
	          { handleClick: handleDelete },
	          _react2.default.createElement(_baseIcon2.default, { icon: 'icon-trash' }),
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'delete_button' })
	        ),
	        _react2.default.createElement(_privacyToggle2.default, {
	          bibId: bibId,
	          showLabel: true,
	          isPrivate: isPrivate,
	          handlePrivacyToggle: handlePrivacyToggle })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          body = _props3.body,
	          ugcType = _props3.ugcType;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-simple-ugc-display' },
	        _react2.default.createElement(
	          'div',
	          { className: ugcType + ' preformat' },
	          body
	        ),
	        this.renderRating(),
	        this.renderUGCActions()
	      );
	    }
	  }]);
	
	  return SimpleUGCDisplay;
	}(_baseBcReactComponent2.default);
	
	SimpleUGCDisplay.propTypes = {
	  body: _react.PropTypes.string.isRequired,
	  ugcType: _react.PropTypes.string.isRequired,
	  rating: _react.PropTypes.number,
	  user: _react.PropTypes.shape({
	    name: _react.PropTypes.string
	  }),
	  handleShowForm: _react.PropTypes.func.isRequired,
	  handleDelete: _react.PropTypes.func.isRequired,
	  bibId: _react.PropTypes.number.isRequired,
	  handlePrivacyToggle: _react.PropTypes.func.isRequired,
	  isPrivate: _react.PropTypes.bool.isRequired
	};
	
	SimpleUGCDisplay.defaultProps = {
	  rating: 0,
	  user: {}
	};
	
	exports.default = SimpleUGCDisplay;

/***/ },
/* 1537 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SimpleUGCForm = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(16);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseIcon = __webpack_require__(176);
	
	var _baseIcon2 = _interopRequireDefault(_baseIcon);
	
	var _changeCase = __webpack_require__(2192);
	
	var _baseIcons = __webpack_require__(10);
	
	var Icons = _interopRequireWildcard(_baseIcons);
	
	var _baseAccessibilityTextArea = __webpack_require__(117);
	
	var _baseAccessibilityTextArea2 = _interopRequireDefault(_baseAccessibilityTextArea);
	
	__webpack_require__(2751);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SimpleUGCForm = exports.SimpleUGCForm = function (_BcReactComponent) {
	  _inherits(SimpleUGCForm, _BcReactComponent);
	
	  function SimpleUGCForm(props) {
	    _classCallCheck(this, SimpleUGCForm);
	
	    var _this = _possibleConstructorReturn(this, (SimpleUGCForm.__proto__ || Object.getPrototypeOf(SimpleUGCForm)).call(this, props));
	
	    _this.state = {
	      expanded: false,
	      isEmpty: _this.props.body.length < 1
	    };
	
	    _this.bindAll('renderCancelButton', 'renderDeleteButton', 'handleChange', 'handleFocus', 'handleBlur');
	    return _this;
	  }
	
	  _createClass(SimpleUGCForm, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'handleChange',
	    value: function handleChange(value) {
	      this.setState({
	        isEmpty: value.length < 1
	      });
	      this.props.handleChange(value);
	    }
	  }, {
	    key: 'handleFocus',
	    value: function handleFocus() {
	      this.setState({
	        expanded: true
	      });
	    }
	  }, {
	    key: 'handleBlur',
	    value: function handleBlur() {
	      this.setState({
	        expanded: false
	      });
	    }
	  }, {
	    key: 'renderCancelButton',
	    value: function renderCancelButton() {
	      var _props = this.props,
	          handleCancel = _props.handleCancel,
	          submitting = _props.submitting;
	
	      return _react2.default.createElement(
	        'button',
	        { type: 'button', onClick: handleCancel, className: 'btn btn-link pull-right', disabled: submitting },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'cancel_button' })
	      );
	    }
	  }, {
	    key: 'renderDeleteButton',
	    value: function renderDeleteButton() {
	      var _props2 = this.props,
	          handleDelete = _props2.handleDelete,
	          submitting = _props2.submitting;
	
	
	      return _react2.default.createElement(
	        'button',
	        { type: 'button', className: 'btn btn-link', onClick: handleDelete, disabled: submitting },
	        _react2.default.createElement(_baseIcon2.default, { icon: 'icon-trash' }),
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'delete_button' })
	      );
	    }
	  }, {
	    key: 'renderHeader',
	    value: function renderHeader(labelId) {
	      var _props3 = this.props,
	          formHeadingText = _props3.formHeadingText,
	          ugcType = _props3.ugcType;
	
	      if (!formHeadingText) return null;
	      var UGCIcon = Icons[(0, _changeCase.pascal)(ugcType)];
	
	      return _react2.default.createElement(
	        'h3',
	        { id: labelId },
	        _react2.default.createElement(UGCIcon, null),
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: formHeadingText })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props,
	          characterLimit = _props4.characterLimit,
	          submitting = _props4.submitting,
	          body = _props4.body,
	          handleSubmit = _props4.handleSubmit,
	          placeholderText = _props4.placeholderText,
	          submitButtonText = _props4.submitButtonText,
	          setFocus = _props4.setFocus,
	          errorKey = _props4.errorKey,
	          fieldErrors = _props4.fieldErrors,
	          intl = _props4.intl;
	      var _state = this.state,
	          isEmpty = _state.isEmpty,
	          expanded = _state.expanded;
	
	
	      var labelId = _lodash2.default.uniqueId('simpleUGCForm_');
	      var formClass = expanded || !isEmpty ? 'active' : '';
	      var disableSubmit = submitting || isEmpty;
	      var buttonClass = expanded || !isEmpty ? 'btn btn-primary' : 'btn btn-default';
	
	      return _react2.default.createElement(
	        'form',
	        { onSubmit: handleSubmit, className: 'cp-simple-ugc-form ' + formClass },
	        this.renderHeader(labelId),
	        _react2.default.createElement(_baseAccessibilityTextArea2.default, {
	          errorKey: errorKey,
	          fieldErrors: fieldErrors,
	          className: 'input-lg',
	          placeholder: intl.formatMessage({ id: placeholderText }),
	          maxLength: characterLimit,
	          value: body,
	          setFocus: setFocus,
	          labelledById: labelId,
	          disabled: submitting,
	          handleFocus: this.handleFocus,
	          handleBlur: this.handleBlur,
	          handleChange: this.handleChange }),
	        _react2.default.createElement(
	          'div',
	          { className: 'ugc-actions' },
	          this.props.handleDelete ? this.renderDeleteButton() : null,
	          _react2.default.createElement('input', { type: 'submit', value: intl.formatMessage({ id: submitButtonText }), className: 'btn ' + buttonClass + ' pull-right', disabled: disableSubmit }),
	          this.props.handleCancel ? this.renderCancelButton() : null
	        )
	      );
	    }
	  }]);
	
	  return SimpleUGCForm;
	}(_baseBcReactComponent2.default);
	
	SimpleUGCForm.propTypes = {
	  errorKey: _react.PropTypes.string.isRequired,
	  fieldErrors: _react.PropTypes.objectOf(_react.PropTypes.shape({
	    classification: _react.PropTypes.string,
	    message: _react.PropTypes.string
	  })),
	  formHeadingText: _react.PropTypes.string,
	  submitButtonText: _react.PropTypes.string.isRequired,
	  placeholderText: _react.PropTypes.string.isRequired,
	  submitting: _react.PropTypes.bool.isRequired,
	  handleSubmit: _react.PropTypes.func.isRequired,
	  body: _react.PropTypes.string,
	  setFocus: _react.PropTypes.bool,
	  handleChange: _react.PropTypes.func.isRequired,
	  handleCancel: _react.PropTypes.func,
	  handleLogin: _react.PropTypes.func,
	  handleDelete: _react.PropTypes.func.isRequired,
	  intl: _reactIntl.intlShape,
	  characterLimit: _react.PropTypes.number,
	  ugcType: _react.PropTypes.string.isRequired
	};
	
	SimpleUGCForm.defaultProps = {
	  user: { loggedIn: false },
	  submitting: false,
	  body: '',
	  formHeadingText: false,
	  handleCancel: false,
	  handleLogin: false,
	  handleDelete: false
	};
	exports.default = (0, _reactIntl.injectIntl)(SimpleUGCForm);

/***/ },
/* 1538 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SimpleUGCPermalink = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseIcons = __webpack_require__(10);
	
	var _privacyToggle = __webpack_require__(276);
	
	var _privacyToggle2 = _interopRequireDefault(_privacyToggle);
	
	__webpack_require__(2752);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getIconForUGC = function getIconForUGC(ugcType) {
	  switch (ugcType) {
	    case 'video':
	      return _react2.default.createElement(_baseIcons.Video, null);
	    case 'comment':
	      return _react2.default.createElement(_baseIcons.Comment, null);
	    case 'quotation':
	      return _react2.default.createElement(_baseIcons.Quotation, null);
	    case 'summary':
	      return _react2.default.createElement(_baseIcons.Summary, null);
	    default:
	      return null;
	  }
	};
	
	var SimpleUGCPermalink = exports.SimpleUGCPermalink = function (_BcReactComponent) {
	  _inherits(SimpleUGCPermalink, _BcReactComponent);
	
	  function SimpleUGCPermalink() {
	    _classCallCheck(this, SimpleUGCPermalink);
	
	    return _possibleConstructorReturn(this, (SimpleUGCPermalink.__proto__ || Object.getPrototypeOf(SimpleUGCPermalink)).apply(this, arguments));
	  }
	
	  _createClass(SimpleUGCPermalink, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          bibId = _props.bibId,
	          isPrivate = _props.isPrivate,
	          userContentId = _props.userContentId,
	          ugcType = _props.ugcType,
	          handlePrivacyToggle = _props.handlePrivacyToggle;
	
	      var messageKey = isPrivate ? 'private_' + ugcType + '_exists' : ugcType + '_exists';
	      return _react2.default.createElement(
	        'div',
	        { className: 'well permalink cp-simple-ugc-permalink' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-1' },
	            getIconForUGC(ugcType)
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-11' },
	            _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
	              id: messageKey,
	              values: {
	                bibId: bibId,
	                userContentId: userContentId
	              } }),
	            _react2.default.createElement(_privacyToggle2.default, { bibId: bibId, isPrivate: isPrivate, handlePrivacyToggle: handlePrivacyToggle, showLabel: true })
	          )
	        )
	      );
	    }
	  }]);
	
	  return SimpleUGCPermalink;
	}(_baseBcReactComponent2.default);
	
	SimpleUGCPermalink.propTypes = {
	  bibId: _react.PropTypes.number.isRequired,
	  isPrivate: _react.PropTypes.bool.isRequired,
	  handlePrivacyToggle: _react.PropTypes.func.isRequired,
	  userContentId: _react.PropTypes.number.isRequired,
	  ugcType: _react.PropTypes.string.isRequired
	};
	
	exports.default = SimpleUGCPermalink;

/***/ },
/* 1539 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.VideoEmbedCodeField = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(16);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseAccessibilityTextField = __webpack_require__(228);
	
	var _baseAccessibilityTextField2 = _interopRequireDefault(_baseAccessibilityTextField);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseIcon = __webpack_require__(176);
	
	var _baseIcon2 = _interopRequireDefault(_baseIcon);
	
	var _videoPreview = __webpack_require__(371);
	
	var _videoPreview2 = _interopRequireDefault(_videoPreview);
	
	__webpack_require__(2753);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VideoEmbedCodeField = exports.VideoEmbedCodeField = function (_BcReactComponent) {
	  _inherits(VideoEmbedCodeField, _BcReactComponent);
	
	  function VideoEmbedCodeField(props) {
	    _classCallCheck(this, VideoEmbedCodeField);
	
	    var _this = _possibleConstructorReturn(this, (VideoEmbedCodeField.__proto__ || Object.getPrototypeOf(VideoEmbedCodeField)).call(this, props));
	
	    _this.bindAll('handleCancelPreview');
	    _this.state = {
	      focusInput: !!props.iFrameSrc
	    };
	    return _this;
	  }
	
	  _createClass(VideoEmbedCodeField, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {/* For Testing purposes */}
	  }, {
	    key: 'handleCancelPreview',
	    value: function handleCancelPreview(e) {
	      e.preventDefault();
	      this.setState({
	        focusInput: true
	      });
	      this.props.handleCancelPreview();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          intl = _props.intl,
	          fieldErrors = _props.fieldErrors,
	          submitting = _props.submitting,
	          handleEmbedSnippetChange = _props.handleEmbedSnippetChange,
	          iFrameSrc = _props.iFrameSrc,
	          embedSnippet = _props.embedSnippet,
	          handleFocus = _props.handleFocus,
	          handleBlur = _props.handleBlur;
	
	
	      var labelId = _lodash2.default.uniqueId('video_');
	      var descriptionId = _lodash2.default.uniqueId('video_');
	
	      if (iFrameSrc) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'cp-video-embed-code-field' },
	          _react2.default.createElement(
	            'button',
	            { className: 'btn btn-danger clear-preview', onClick: this.handleCancelPreview },
	            _react2.default.createElement(_baseIcon2.default, { icon: 'icon-trash', screenReaderText: intl.formatMessage({ id: 'cancel_button' }) }),
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'clear_preview' })
	          ),
	          _react2.default.createElement(_videoPreview2.default, { iFrameSrc: iFrameSrc, showActions: false })
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-video-embed-code-field' },
	        _react2.default.createElement(
	          'span',
	          { id: labelId, className: 'sr-only' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'enter_a_url_or_embed_code' })
	        ),
	        _react2.default.createElement(
	          'span',
	          { id: descriptionId, className: 'sr-only' },
	          _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'enter_a_url_or_embed_code_description' })
	        ),
	        _react2.default.createElement(_baseAccessibilityTextField2.default, {
	          className: 'input-lg',
	          id: 'video-text-field',
	          fieldErrors: fieldErrors,
	          errorKey: 'url',
	          value: embedSnippet,
	          focus: this.state.focusInput,
	          placeholder: intl.formatMessage({ id: 'enter_a_url_or_embed_code' }),
	          disabled: submitting,
	          handleChange: handleEmbedSnippetChange,
	          handlePaste: handleEmbedSnippetChange,
	          handleFocus: handleFocus,
	          handleBlur: handleBlur })
	      );
	    }
	  }]);
	
	  return VideoEmbedCodeField;
	}(_baseBcReactComponent2.default);
	
	VideoEmbedCodeField.propTypes = {
	  fieldErrors: _react.PropTypes.objectOf(_react.PropTypes.shape({
	    classification: _react.PropTypes.string,
	    message: _react.PropTypes.string
	  })),
	  embedSnippet: _react.PropTypes.string,
	  iFrameSrc: _react.PropTypes.string,
	  submitting: _react.PropTypes.bool,
	  handleEmbedSnippetChange: _react.PropTypes.func.isRequired,
	  handleCancelPreview: _react.PropTypes.func.isRequired,
	  handleBlur: _react.PropTypes.func.isRequired,
	  handleFocus: _react.PropTypes.func.isRequired,
	  intl: _reactIntl.intlShape
	};
	
	exports.default = (0, _reactIntl.injectIntl)(VideoEmbedCodeField);

/***/ },
/* 1540 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.VideoForm = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseAccessibilityTextArea = __webpack_require__(117);
	
	var _baseAccessibilityTextArea2 = _interopRequireDefault(_baseAccessibilityTextArea);
	
	var _baseAccessibilityTextField = __webpack_require__(228);
	
	var _baseAccessibilityTextField2 = _interopRequireDefault(_baseAccessibilityTextField);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseIcon = __webpack_require__(176);
	
	var _baseIcon2 = _interopRequireDefault(_baseIcon);
	
	var _baseIcons = __webpack_require__(10);
	
	var _videoEmbedCodeField = __webpack_require__(552);
	
	var _videoEmbedCodeField2 = _interopRequireDefault(_videoEmbedCodeField);
	
	__webpack_require__(2754);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VideoForm = exports.VideoForm = function (_BcReactComponent) {
	  _inherits(VideoForm, _BcReactComponent);
	
	  function VideoForm(props) {
	    _classCallCheck(this, VideoForm);
	
	    var _this = _possibleConstructorReturn(this, (VideoForm.__proto__ || Object.getPrototypeOf(VideoForm)).call(this, props));
	
	    _this.state = {
	      expanded: false,
	      isEmpty: true
	    };
	    _this.bindAll('renderTitleField', 'renderDescriptionField', 'renderCancelButton', 'handleFocus', 'handleBlur');
	    return _this;
	  }
	
	  _createClass(VideoForm, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'isAnyFieldPopuplated',
	    value: function isAnyFieldPopuplated() {
	      var _props = this.props,
	          iFrameSrc = _props.iFrameSrc,
	          videoTitle = _props.videoTitle,
	          description = _props.description;
	
	      return videoTitle || description || iFrameSrc;
	    }
	  }, {
	    key: 'handleFocus',
	    value: function handleFocus() {
	      this.setState({
	        expanded: true
	      });
	    }
	  }, {
	    key: 'handleBlur',
	    value: function handleBlur() {
	      this.setState({
	        expanded: false
	      });
	    }
	  }, {
	    key: 'renderDescriptionField',
	    value: function renderDescriptionField() {
	      var _props2 = this.props,
	          intl = _props2.intl,
	          fieldErrors = _props2.fieldErrors,
	          description = _props2.description,
	          iFrameSrc = _props2.iFrameSrc,
	          handleDescriptionChange = _props2.handleDescriptionChange,
	          submitting = _props2.submitting;
	
	
	      return _react2.default.createElement(_baseAccessibilityTextArea2.default, {
	        errorKey: 'description',
	        fieldErrors: fieldErrors,
	        className: 'input-lg',
	        value: description,
	        handleChange: handleDescriptionChange,
	        maxLength: 500,
	        handleFocus: this.handleFocus,
	        handleBlur: this.handleBlur,
	        placeholder: intl.formatMessage({ id: 'video_description' }),
	        disabled: submitting || !iFrameSrc });
	    }
	  }, {
	    key: 'renderTitleField',
	    value: function renderTitleField() {
	      var _props3 = this.props,
	          intl = _props3.intl,
	          videoTitle = _props3.videoTitle,
	          fieldErrors = _props3.fieldErrors,
	          handleTitleChange = _props3.handleTitleChange,
	          iFrameSrc = _props3.iFrameSrc,
	          focusTitle = _props3.focusTitle,
	          submitting = _props3.submitting;
	
	      return _react2.default.createElement(_baseAccessibilityTextField2.default, {
	        errorKey: 'title',
	        fieldErrors: fieldErrors,
	        className: 'input-lg',
	        value: videoTitle,
	        disabled: submitting || !iFrameSrc,
	        handleFocus: this.handleFocus,
	        handleBlur: this.handleBlur,
	        focus: focusTitle,
	        placeholder: intl.formatMessage({ id: 'video_title' }),
	        handleChange: handleTitleChange,
	        maxLength: 50 });
	    }
	  }, {
	    key: 'renderDeleteButton',
	    value: function renderDeleteButton() {
	      var _props4 = this.props,
	          handleDelete = _props4.handleDelete,
	          submitting = _props4.submitting;
	
	
	      return _react2.default.createElement(
	        'button',
	        { type: 'button', className: 'btn btn-link', onClick: handleDelete, disabled: submitting },
	        _react2.default.createElement(_baseIcon2.default, { icon: 'icon-trash' }),
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'delete_button' })
	      );
	    }
	  }, {
	    key: 'renderCancelButton',
	    value: function renderCancelButton() {
	      var _props5 = this.props,
	          handleCancel = _props5.handleCancel,
	          submitting = _props5.submitting,
	          intl = _props5.intl;
	
	
	      return _react2.default.createElement('input', { type: 'reset', onClick: handleCancel, className: 'btn btn-link pull-right', value: intl.formatMessage({ id: 'cancel_button' }), disabled: submitting });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props6 = this.props,
	          intl = _props6.intl,
	          iFrameSrc = _props6.iFrameSrc,
	          submitting = _props6.submitting,
	          fieldErrors = _props6.fieldErrors,
	          videoTitle = _props6.videoTitle,
	          description = _props6.description,
	          embedSnippet = _props6.embedSnippet,
	          handleSubmit = _props6.handleSubmit,
	          handleCancelPreview = _props6.handleCancelPreview,
	          handleCancel = _props6.handleCancel,
	          handleEmbedSnippetChange = _props6.handleEmbedSnippetChange;
	      var expanded = this.state.expanded;
	
	      var isEmpty = !iFrameSrc || !videoTitle;
	      var disableSubmit = submitting || isEmpty;
	      var buttonClass = !isEmpty ? 'btn-primary' : 'btn-default';
	      var formClass = expanded || !isEmpty ? 'active' : '';
	
	      return _react2.default.createElement(
	        'form',
	        { onSubmit: handleSubmit, className: 'cp-video-form clearfix well ' + formClass + ' ' },
	        _react2.default.createElement(
	          'h3',
	          { className: 'form-title' },
	          _react2.default.createElement(_baseIcons.Video, null),
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'enter_a_video' })
	        ),
	        _react2.default.createElement(_videoEmbedCodeField2.default, {
	          fieldErrors: fieldErrors,
	          embedSnippet: embedSnippet,
	          iFrameSrc: iFrameSrc,
	          handleCancelPreview: handleCancelPreview,
	          handleEmbedSnippetChange: handleEmbedSnippetChange,
	          handleFocus: this.handleFocus,
	          handleBlur: this.handleBlur,
	          disabled: submitting }),
	        videoTitle || iFrameSrc ? this.renderTitleField() : null,
	        description || iFrameSrc ? this.renderDescriptionField() : null,
	        _react2.default.createElement(
	          'div',
	          { className: 'ugc-actions' },
	          this.props.handleDelete ? this.renderDeleteButton() : null,
	          _react2.default.createElement('input', { type: 'submit', value: intl.formatMessage({ id: this.props.submitButtonText }), className: 'btn ' + buttonClass + ' pull-right', disabled: disableSubmit }),
	          !!handleCancel && this.isAnyFieldPopuplated() ? this.renderCancelButton() : null
	        )
	      );
	    }
	  }]);
	
	  return VideoForm;
	}(_baseBcReactComponent2.default);
	
	VideoForm.propTypes = {
	  fieldErrors: _react.PropTypes.objectOf(_react.PropTypes.shape({
	    classification: _react.PropTypes.string,
	    message: _react.PropTypes.string
	  })),
	  submitting: _react.PropTypes.bool.isRequired,
	  handleSubmit: _react.PropTypes.func.isRequired,
	  formHeadingText: _react.PropTypes.string.isRequired,
	  submitButtonText: _react.PropTypes.string.isRequired,
	  iFrameSrc: _react.PropTypes.string,
	  focusTitle: _react.PropTypes.bool,
	  embedSnippet: _react.PropTypes.string,
	  videoTitle: _react.PropTypes.string,
	  description: _react.PropTypes.string,
	  handleTitleChange: _react.PropTypes.func,
	  handleDescriptionChange: _react.PropTypes.func,
	  handleCancel: _react.PropTypes.func.isRequired,
	  handleCancelPreview: _react.PropTypes.func.isRequired,
	  handleEmbedSnippetChange: _react.PropTypes.func.isRequired,
	  handleDelete: _react.PropTypes.func.isRequired,
	  characterLimit: _react.PropTypes.number,
	  expanded: _react.PropTypes.bool.isRequired,
	  isEmpty: _react.PropTypes.bool.isRequired,
	  handleBlur: _react.PropTypes.func.isRequired,
	  handleFocus: _react.PropTypes.func.isRequired,
	  intl: _reactIntl.intlShape
	};
	
	VideoForm.defaultProps = {
	  user: { loggedIn: false },
	  submitting: false,
	  handleCancel: false,
	  handleDelete: false
	};
	
	exports.default = (0, _reactIntl.injectIntl)(VideoForm);

/***/ },
/* 1541 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.VideoPreview = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseIcon = __webpack_require__(176);
	
	var _baseIcon2 = _interopRequireDefault(_baseIcon);
	
	var _baseButtons = __webpack_require__(12);
	
	var _privacyToggle = __webpack_require__(276);
	
	var _privacyToggle2 = _interopRequireDefault(_privacyToggle);
	
	__webpack_require__(2755);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VideoPreview = exports.VideoPreview = function (_BcReactComponent) {
	  _inherits(VideoPreview, _BcReactComponent);
	
	  function VideoPreview(props) {
	    _classCallCheck(this, VideoPreview);
	
	    var _this = _possibleConstructorReturn(this, (VideoPreview.__proto__ || Object.getPrototypeOf(VideoPreview)).call(this, props));
	
	    _this.bindAll('renderTitle', 'renderDescription', 'renderActions');
	    return _this;
	  }
	
	  _createClass(VideoPreview, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {/* for testing purposes */}
	  }, {
	    key: 'renderTitle',
	    value: function renderTitle() {
	      return _react2.default.createElement(
	        'h3',
	        null,
	        this.props.videoTitle
	      );
	    }
	  }, {
	    key: 'renderDescription',
	    value: function renderDescription() {
	      if (this.props.description) {
	        return _react2.default.createElement(
	          'p',
	          null,
	          this.props.description
	        );
	      }
	      return null;
	    }
	  }, {
	    key: 'renderActions',
	    value: function renderActions() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'ugc-actions' },
	        _react2.default.createElement(
	          _baseButtons.TextButton,
	          { handleClick: this.props.handleShowForm },
	          _react2.default.createElement(_baseIcon2.default, { icon: 'icon-edit' }),
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'edit_button' })
	        ),
	        _react2.default.createElement(
	          _baseButtons.TextButton,
	          { handleClick: this.props.handleDelete },
	          _react2.default.createElement(_baseIcon2.default, { icon: 'icon-trash' }),
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'delete_button' })
	        ),
	        _react2.default.createElement(_privacyToggle2.default, {
	          bibId: this.props.bibId,
	          handlePrivacyToggle: this.props.handlePrivacyToggle,
	          isPrivate: this.props.isPrivate,
	          showLabel: true })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-video-preview' },
	        _react2.default.createElement(
	          'div',
	          { className: 'embed-responsive embed-responsive-16by9' },
	          _react2.default.createElement('iframe', { className: 'embed-responsive-item', src: this.props.iFrameSrc })
	        ),
	        this.props.videoTitle ? this.renderTitle() : null,
	        this.renderDescription(),
	        this.props.showActions ? this.renderActions() : null
	      );
	    }
	  }]);
	
	  return VideoPreview;
	}(_baseBcReactComponent2.default);
	
	VideoPreview.propTypes = {
	  bibId: _react.PropTypes.number.isRequired,
	  handlePrivacyToggle: _react.PropTypes.func.isRequired,
	  isPrivate: _react.PropTypes.bool.isRequired,
	  handleDelete: _react.PropTypes.func,
	  handleShowForm: _react.PropTypes.func,
	  iFrameSrc: _react.PropTypes.string.isRequired,
	  videoTitle: _react.PropTypes.string,
	  description: _react.PropTypes.string,
	  showActions: _react.PropTypes.bool
	};
	
	VideoPreview.defaultProps = {
	  showActions: true
	};
	
	exports.default = VideoPreview;

/***/ },
/* 1542 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(16);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(17);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseDropdown = __webpack_require__(37);
	
	__webpack_require__(2756);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SortDropdown = function (_BcReactComponent) {
	  _inherits(SortDropdown, _BcReactComponent);
	
	  function SortDropdown(props) {
	    _classCallCheck(this, SortDropdown);
	
	    var _this = _possibleConstructorReturn(this, (SortDropdown.__proto__ || Object.getPrototypeOf(SortDropdown)).call(this, props));
	
	    _this.labelledById = _lodash2.default.uniqueId('sortDropdown_');
	    _this.bindAll('currentSort', 'getOptions', 'handleSelect');
	    return _this;
	  }
	
	  _createClass(SortDropdown, [{
	    key: 'currentSort',
	    value: function currentSort() {
	      var option = this.props.options.find(function (sort) {
	        return sort.get('applied');
	      });
	      return option ? this.props.intl.formatMessage({ id: 'sort.' + option.get('id').toLowerCase() }) : this.props.intl.formatMessage({ id: 'sort.relevancy' });
	    }
	  }, {
	    key: 'getOptions',
	    value: function getOptions() {
	      var _this2 = this;
	
	      var options = this.props.options.map(function (option) {
	        return {
	          key: 'sort-dropdown-option-' + option.get('id'),
	          label: _this2.props.intl.formatMessage({ id: 'sort.' + option.get('id').toLowerCase() }),
	          value: option.get('id')
	        };
	      });
	
	      return options;
	    }
	  }, {
	    key: 'handleSelect',
	    value: function handleSelect(id) {
	      if (this.props.sort) {
	        this.props.sort(id);
	      } else {
	        var _extends2;
	
	        var _props = this.props,
	            location = _props.location,
	            router = _props.router,
	            paginationField = _props.paginationField,
	            queryField = _props.queryField;
	
	        router.push(_extends({}, location, {
	          query: _extends({}, location.query, (_extends2 = {}, _defineProperty(_extends2, queryField, id), _defineProperty(_extends2, paginationField, undefined), _extends2))
	        }));
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var right = this.props.right;
	
	      return _react2.default.createElement(
	        'span',
	        { className: 'cp-sort-dropdown' },
	        _react2.default.createElement(_baseDropdown.Dropdown, {
	          selected: this.props.intl.formatMessage({ id: 'Search.sortBy' }, { currentSort: this.currentSort() }),
	          options: this.getOptions(),
	          handleSelect: this.handleSelect,
	          describedById: this.describedById,
	          labelledById: this.labelledById,
	          descriptionLocaleKey: 'sortDropdownDescription',
	          className: 'btn-link',
	          right: right })
	      );
	    }
	  }]);
	
	  return SortDropdown;
	}(_baseBcReactComponent2.default);
	
	SortDropdown.propTypes = {
	  options: _reactImmutableProptypes2.default.list,
	  sort: _react.PropTypes.func,
	  right: _react.PropTypes.bool,
	  queryField: _react.PropTypes.string,
	  paginationField: _react.PropTypes.string,
	  intl: _reactIntl.intlShape
	};
	
	SortDropdown.defaultProps = {
	  paginationField: 'page',
	  queryField: 'sort'
	};
	
	exports.default = (0, _reactIntl.injectIntl)((0, _reactRouter.withRouter)(SortDropdown));

/***/ },
/* 1543 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseFullScreenOverlay = __webpack_require__(45);
	
	var _baseFullScreenOverlay2 = _interopRequireDefault(_baseFullScreenOverlay);
	
	var _baseTable = __webpack_require__(91);
	
	var _zoomableMapDisplay = __webpack_require__(553);
	
	var _zoomableMapDisplay2 = _interopRequireDefault(_zoomableMapDisplay);
	
	__webpack_require__(2757);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StackMapOverlay = function (_BcReactComponent) {
	  _inherits(StackMapOverlay, _BcReactComponent);
	
	  function StackMapOverlay() {
	    _classCallCheck(this, StackMapOverlay);
	
	    return _possibleConstructorReturn(this, (StackMapOverlay.__proto__ || Object.getPrototypeOf(StackMapOverlay)).apply(this, arguments));
	  }
	
	  _createClass(StackMapOverlay, [{
	    key: 'renderContent',
	    value: function renderContent() {
	      var _this2 = this;
	
	      if (this.props.isFetching) {
	        return _react2.default.createElement(_baseTable.Placeholder, null);
	      }
	
	      if (this.props.noResults) {
	        return _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'stackmap_fail' });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'stackmap-data' },
	        this.props.maps.map(function (map) {
	          return _react2.default.createElement(_zoomableMapDisplay2.default, {
	            map: map,
	            library: _this2.props.library,
	            callno: _this2.props.callno,
	            domain: _this2.props.domain,
	            hideRanges: _this2.props.hideRanges,
	            location: _this2.props.location });
	        })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _baseFullScreenOverlay2.default,
	        { open: true, animation: 'instant', className: 'cp-stackmap-overlay', handleClose: this.props.closeStackMap },
	        _react2.default.createElement(
	          _reactIntl.FormattedMessage,
	          { id: 'stackmap_powered_by' },
	          function (message) {
	            return _react2.default.createElement(
	              'span',
	              { className: 'powered-by-stackmap' },
	              message
	            );
	          }
	        ),
	        _react2.default.createElement(
	          'h3',
	          null,
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'stackmap_general_info_heading' })
	        ),
	        this.renderContent()
	      );
	    }
	  }]);
	
	  return StackMapOverlay;
	}(_baseBcReactComponent2.default);
	
	StackMapOverlay.propTypes = {
	  isFetching: _react.PropTypes.bool,
	  noResults: _react.PropTypes.bool,
	  maps: _reactImmutableProptypes2.default.mapContains({
	    directions: _react.PropTypes.string,
	    hideRanges: _react.PropTypes.bool,
	    floorname: _react.PropTypes.string,
	    height: _react.PropTypes.number,
	    width: _react.PropTypes.number,
	    ranges: _reactImmutableProptypes2.default.listOf(_reactImmutableProptypes2.default.mapContains({
	      callnoDisplay: _react.PropTypes.string,
	      rangename: _react.PropTypes.string
	    }))
	  })
	};
	
	exports.default = StackMapOverlay;

/***/ },
/* 1544 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _StackMapOverlay = __webpack_require__(1543);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_StackMapOverlay).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1545 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _basePanZoom = __webpack_require__(1338);
	
	var _baseButtons = __webpack_require__(12);
	
	var _baseIcons = __webpack_require__(10);
	
	var _utilsHttp = __webpack_require__(373);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MAX_SCALE_FACTOR = 5;
	
	var ZoomableMapDisplay = function (_BcReactComponent) {
	  _inherits(ZoomableMapDisplay, _BcReactComponent);
	
	  function ZoomableMapDisplay(props) {
	    _classCallCheck(this, ZoomableMapDisplay);
	
	    var _this = _possibleConstructorReturn(this, (ZoomableMapDisplay.__proto__ || Object.getPrototypeOf(ZoomableMapDisplay)).call(this, props));
	
	    _this.state = {
	      x: 0,
	      y: 0,
	      scale: 1
	    };
	    _this.bindAll('handleMapUpdate', 'handleZoomIn', 'handleZoomOut', 'handlePrint');
	    return _this;
	  }
	
	  _createClass(ZoomableMapDisplay, [{
	    key: 'handleMapUpdate',
	    value: function handleMapUpdate(obj) {
	      this.setState(obj);
	    }
	  }, {
	    key: 'handleZoomIn',
	    value: function handleZoomIn() {
	      this.setState({
	        scale: Math.min(MAX_SCALE_FACTOR, this.state.scale + 0.5)
	      });
	    }
	  }, {
	    key: 'handleZoomOut',
	    value: function handleZoomOut() {
	      var newScale = Math.max(1, this.state.scale - 0.5);
	      this.setState({
	        scale: newScale,
	        x: newScale !== 1 ? this.state.x : 0,
	        y: newScale !== 1 ? this.state.y : 0
	      });
	    }
	  }, {
	    key: 'handlePrint',
	    value: function handlePrint() {
	      var queryString = (0, _utilsHttp.createQueryString)({
	        callno: this.props.callno,
	        library: this.props.library,
	        location: this.props.location,
	        v: 'pf'
	      });
	      var pfUrl = 'https://' + this.props.domain + '.stackmap.com/view/?' + queryString;
	      window.open(pfUrl, 'stackmap', 'width=950,height=800,toolbar=no,directories=no,scrollbars=1,location=no,menubar=no,status=no,left=0,top=0');
	      return false;
	    }
	  }, {
	    key: 'renderRanges',
	    value: function renderRanges() {
	      var map = this.props.map;
	
	      return _react2.default.createElement(
	        'ul',
	        { className: 'stackmap-ranges' },
	        map.get('ranges').map(function (range) {
	          return _react2.default.createElement(
	            'li',
	            { className: 'stackmap-range', key: range.get('rangename') },
	            _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'stackmap_range_info', values: { rangename: range.get('rangename'), callnoDisplay: range.get('callnoDisplay') } })
	          );
	        })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var map = this.props.map;
	      return _react2.default.createElement(
	        'div',
	        { className: 'stackmap-text' },
	        _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'stackmap_general_info', values: { floorname: map.get('floorname'), library: map.get('library') } }),
	        !this.props.hideRanges && this.renderRanges(),
	        _react2.default.createElement(
	          'div',
	          { className: 'stackmap-buttons' },
	          _react2.default.createElement(
	            _baseButtons.DefaultButton,
	            { handleClick: this.handleZoomIn, 'data-test-id': 'zoom-in' },
	            _react2.default.createElement(
	              _baseIcons.IconWithBackground,
	              { icon: _react2.default.createElement(_baseIcons.Plus, null), bgColor: '#02729e' },
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'stackmap_zoom_in' })
	            )
	          ),
	          _react2.default.createElement(
	            _baseButtons.DefaultButton,
	            { handleClick: this.handleZoomOut, 'data-test-id': 'zoom-out' },
	            _react2.default.createElement(
	              _baseIcons.IconWithBackground,
	              { icon: _react2.default.createElement(_baseIcons.Minus, null), bgColor: '#02729e' },
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'stackmap_zoom_out' })
	            )
	          ),
	          _react2.default.createElement(
	            _baseButtons.DefaultButton,
	            { tagName: 'a', href: '#print-view', handleClick: this.handlePrint },
	            _react2.default.createElement(
	              _baseIcons.IconWithBackground,
	              { icon: _react2.default.createElement(_baseIcons.Printer, { color: 'currentColor' }), bgColor: '#02729e' },
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'print' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _basePanZoom.PanZoom,
	          _extends({ handleUpdate: this.handleMapUpdate, className: 'stackmap-image-container' }, this.state, { height: map.get('height'), width: map.get('width'), maxScale: MAX_SCALE_FACTOR }),
	          _react2.default.createElement('img', { className: 'stackmap-image', alt: '', src: map.get('mapurl') + '&marker=1' })
	        ),
	        map.get('directions') ? _react2.default.createElement(
	          'div',
	          { className: 'stackmap-directions' },
	          _react2.default.createElement(
	            _reactIntl.FormattedMessage,
	            { id: 'stackmap_directions' },
	            function (message) {
	              return _react2.default.createElement(
	                'h3',
	                null,
	                message
	              );
	            }
	          ),
	          map.get('directions')
	        ) : null
	      );
	    }
	  }]);
	
	  return ZoomableMapDisplay;
	}(_baseBcReactComponent2.default);
	
	ZoomableMapDisplay.propTypes = {
	  isFetching: _react.PropTypes.bool,
	  noResults: _react.PropTypes.bool,
	  hideRanges: _react.PropTypes.bool,
	  maps: _reactImmutableProptypes2.default.mapContains({
	    directions: _react.PropTypes.string,
	    floorname: _react.PropTypes.string,
	    height: _react.PropTypes.number,
	    width: _react.PropTypes.number,
	    ranges: _reactImmutableProptypes2.default.listOf(_reactImmutableProptypes2.default.mapContains({
	      callnoDisplay: _react.PropTypes.string,
	      rangename: _react.PropTypes.string
	    }))
	  })
	};
	
	exports.default = ZoomableMapDisplay;

/***/ },
/* 1546 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stackmapOverlay = __webpack_require__(1544);
	
	Object.defineProperty(exports, 'StackmapOverlay', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_stackmapOverlay).default;
	  }
	});
	
	var _zoomableMapDisplay = __webpack_require__(553);
	
	Object.defineProperty(exports, 'ZoomableMapDisplay', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_zoomableMapDisplay).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1547 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	var _baseIcons = __webpack_require__(10);
	
	var _baseButtons = __webpack_require__(12);
	
	__webpack_require__(2758);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TagPill = function (_BcReactComponent) {
	  _inherits(TagPill, _BcReactComponent);
	
	  function TagPill(props) {
	    _classCallCheck(this, TagPill);
	
	    var _this = _possibleConstructorReturn(this, (TagPill.__proto__ || Object.getPrototypeOf(TagPill)).call(this, props));
	
	    _this.bindAll('handleFocus', 'handleBlur');
	
	    _this.state = {
	      focused: false
	    };
	    return _this;
	  }
	
	  _createClass(TagPill, [{
	    key: 'handleFocus',
	    value: function handleFocus() {
	      this.setState({
	        focused: true
	      });
	    }
	  }, {
	    key: 'handleBlur',
	    value: function handleBlur() {
	      this.setState({
	        focused: false
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          value = _props.value,
	          className = _props.className,
	          url = _props.url,
	          renderIcon = _props.renderIcon,
	          handleClick = _props.handleClick,
	          handleRemove = _props.handleRemove,
	          isLoading = _props.isLoading,
	          otherProps = _objectWithoutProperties(_props, ['value', 'className', 'url', 'renderIcon', 'handleClick', 'handleRemove', 'isLoading']);
	
	      var renderedIcon = renderIcon && renderIcon();
	      var tagIcon = renderedIcon && _react2.default.createElement(
	        'span',
	        { className: 'tag-icon' },
	        renderedIcon
	      );
	
	      var tagLink = url && _react2.default.createElement(
	        'a',
	        { href: url, onClick: handleClick, className: 'tag-link' },
	        value
	      );
	
	      var removeButton = (handleRemove || isLoading) && _react2.default.createElement(
	        _baseButtons.IconButton,
	        { className: 'remove-tag-button', isLoading: isLoading, handleClick: handleRemove, spinnerPrimary: !!tagLink },
	        _react2.default.createElement(_baseIcons.Cross, { className: 'extra-extra-small' }),
	        _react2.default.createElement(
	          _baseScreenReaderMessage2.default,
	          null,
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'remove_tag', values: { value: value } })
	        )
	      );
	
	      var classNames = (0, _classnames2.default)('cp-tag-pill', className, {
	        focused: this.state.focused,
	        clickable: !!tagLink
	      });
	
	      return _react2.default.createElement(
	        'span',
	        _extends({ className: classNames }, otherProps, { onFocus: this.handleFocus, onBlur: this.handleBlur }),
	        tagIcon,
	        ' ',
	        tagLink || value,
	        ' ',
	        removeButton
	      );
	    }
	  }]);
	
	  return TagPill;
	}(_baseBcReactComponent2.default);
	
	exports.default = TagPill;
	
	
	TagPill.propTypes = {
	  value: _react.PropTypes.string.isRequired,
	  className: _react.PropTypes.string,
	  url: _react.PropTypes.string,
	  renderIcon: _react.PropTypes.func,
	  handleClick: _react.PropTypes.func,
	  handleRemove: _react.PropTypes.func,
	  isLoading: _react.PropTypes.bool
	};

/***/ },
/* 1548 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TagPill = __webpack_require__(1547);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TagPill).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1549 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _avatar_default = __webpack_require__(3421);
	
	var _avatar_default2 = _interopRequireDefault(_avatar_default);
	
	__webpack_require__(2759);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEFAULT_AVATAR_IMAGE = 'avatar_default.png';
	
	var UserAvatar = function (_BcReactComponent) {
	  _inherits(UserAvatar, _BcReactComponent);
	
	  function UserAvatar() {
	    _classCallCheck(this, UserAvatar);
	
	    return _possibleConstructorReturn(this, (UserAvatar.__proto__ || Object.getPrototypeOf(UserAvatar)).apply(this, arguments));
	  }
	
	  _createClass(UserAvatar, [{
	    key: 'renderAvatar',
	    value: function renderAvatar() {
	      var avatar = this.props.userIdentity.get('avatar');
	      var coreCdnHost = this.context.coreCdnHost || '';
	      var avatarURL = avatar === DEFAULT_AVATAR_IMAGE ? _avatar_default2.default : '' + coreCdnHost + avatar;
	
	      return _react2.default.createElement('img', { src: avatarURL, className: 'img-circle', alt: '' });
	    }
	  }, {
	    key: 'renderInitial',
	    value: function renderInitial() {
	      var initial = this.props.userIdentity.get('name').charAt(0);
	
	      return _react2.default.createElement(
	        'span',
	        { className: 'img-circle initial' },
	        _react2.default.createElement(
	          'span',
	          null,
	          initial
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var userIdentity = this.props.userIdentity;
	
	      var size = this.props.size || 'sm';
	      var classNames = (0, _classnames2.default)('cp-user-avatar', 'avatar-' + size, { 'home-patron': userIdentity.get('homePatron') });
	      var profileURL = '/user_profile/' + userIdentity.get('id');
	
	      return _react2.default.createElement(
	        'span',
	        { className: classNames, 'aria-hidden': 'true' },
	        _react2.default.createElement(
	          'a',
	          { className: 'user-avatar-link', href: profileURL },
	          userIdentity.get('avatar') ? this.renderAvatar() : this.renderInitial()
	        )
	      );
	    }
	  }]);
	
	  return UserAvatar;
	}(_baseBcReactComponent2.default);
	
	UserAvatar.propTypes = {
	  size: _react.PropTypes.string,
	  userIdentity: _bcPropTypes.userIdentityShape.isRequired
	};
	
	UserAvatar.contextTypes = {
	  coreCdnHost: _react.PropTypes.string
	};
	
	exports.default = UserAvatar;

/***/ },
/* 1550 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _UserAvatar = __webpack_require__(1549);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_UserAvatar).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1551 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = UserHeaderActions;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function UserHeaderActions() {
	  return _react2.default.createElement(
	    "div",
	    { className: "cp-user-header-actions" },
	    "TODO"
	  );
	}

/***/ },
/* 1552 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _UserHeaderActions = __webpack_require__(1551);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_UserHeaderActions).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1553 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UserHeaderNav = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _reactIntl = __webpack_require__(3);
	
	var _reactRouter = __webpack_require__(17);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _baseIcons = __webpack_require__(10);
	
	__webpack_require__(2760);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UserHeaderNav = exports.UserHeaderNav = function (_BcReactComponent) {
	  _inherits(UserHeaderNav, _BcReactComponent);
	
	  function UserHeaderNav() {
	    _classCallCheck(this, UserHeaderNav);
	
	    return _possibleConstructorReturn(this, (UserHeaderNav.__proto__ || Object.getPrototypeOf(UserHeaderNav)).apply(this, arguments));
	  }
	
	  _createClass(UserHeaderNav, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          renderHeading = _props.renderHeading,
	          renderIcon = _props.renderIcon,
	          isCurrentUser = _props.isCurrentUser,
	          items = _props.items,
	          userIdentity = _props.userIdentity;
	
	      var classNames = (0, _classnames2.default)('cp-user-header-nav', { 'home-patron': userIdentity.get('homePatron'), 'main-nav': items.size <= 0 });
	      var exitLabel = isCurrentUser ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'section_title_my_profile' }) : _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'section_title_users_profile', values: { username: userIdentity.get('name') } });
	      var profileURL = '/user_profile/' + userIdentity.get('id');
	
	      return _react2.default.createElement(
	        'div',
	        { className: classNames },
	        _react2.default.createElement(
	          'a',
	          { className: 'exit-link', href: profileURL },
	          _react2.default.createElement(_baseIcons.Arrows.long.Left, { color: '#fff' }),
	          _react2.default.createElement(
	            _baseScreenReaderMessage2.default,
	            null,
	            exitLabel
	          )
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'heading', 'aria-hidden': 'true' },
	          renderIcon(),
	          ' ',
	          renderHeading()
	        ),
	        _react2.default.createElement(
	          'ul',
	          { className: 'links-list hidden-xs' },
	          items.map(function (navItem) {
	            return _react2.default.createElement(
	              'li',
	              { key: navItem.get('key'), className: 'user-header-nav-item' },
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: navItem.get('link'), activeClassName: 'active' },
	                navItem.get('label')
	              )
	            );
	          })
	        )
	      );
	    }
	  }]);
	
	  return UserHeaderNav;
	}(_baseBcReactComponent2.default);
	
	var itemShape = _reactImmutableProptypes2.default.mapContains({
	  key: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
	  label: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.element]),
	  link: _react.PropTypes.string.isRequired
	});
	
	UserHeaderNav.propTypes = {
	  renderHeading: _react.PropTypes.func.isRequired,
	  renderIcon: _react.PropTypes.func.isRequired,
	  isCurrentUser: _react.PropTypes.bool,
	  items: _reactImmutableProptypes2.default.iterableOf(itemShape).isRequired,
	  userIdentity: _bcPropTypes.userIdentityShape.isRequired
	};
	
	exports.default = UserHeaderNav;

/***/ },
/* 1554 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _UserHeaderNav = __webpack_require__(1553);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_UserHeaderNav).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1555 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _userAvatar = __webpack_require__(1550);
	
	var _userAvatar2 = _interopRequireDefault(_userAvatar);
	
	var _userStaffStamp = __webpack_require__(1559);
	
	var _userStaffStamp2 = _interopRequireDefault(_userStaffStamp);
	
	__webpack_require__(2761);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UserHeader = function (_BcReactComponent) {
	  _inherits(UserHeader, _BcReactComponent);
	
	  function UserHeader() {
	    _classCallCheck(this, UserHeader);
	
	    return _possibleConstructorReturn(this, (UserHeader.__proto__ || Object.getPrototypeOf(UserHeader)).apply(this, arguments));
	  }
	
	  _createClass(UserHeader, [{
	    key: 'renderUserStaffStamp',
	    value: function renderUserStaffStamp() {
	      var userIdentity = this.props.userIdentity;
	
	
	      if (userIdentity.get('staff')) {
	        return _react2.default.createElement(_userStaffStamp2.default, { inverse: true });
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          renderActions = _props.renderActions,
	          userIdentity = _props.userIdentity,
	          renderNav = _props.renderNav;
	
	      var classNames = (0, _classnames2.default)('cp-user-header', { 'home-patron': userIdentity.get('homePatron') });
	
	      return _react2.default.createElement(
	        'div',
	        { className: classNames },
	        _react2.default.createElement(
	          'div',
	          { className: 'user-header-top' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-12 col-sm-8' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-md-8' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'pull-left user-header-avatar' },
	                    _react2.default.createElement(_userAvatar2.default, { userIdentity: userIdentity, size: 'lg' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'pull-left user-header-info' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'user-header-username' },
	                      userIdentity.get('name')
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'user-header-library' },
	                      this.renderUserStaffStamp(),
	                      userIdentity.get('homeLibraryFullName')
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-md-4' },
	                  _react2.default.createElement('div', { className: 'user-header-about' })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-12 col-sm-4' },
	              _react2.default.createElement(
	                'div',
	                { className: 'user-header-actions' },
	                renderActions()
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'user-header-bottom' },
	          renderNav()
	        )
	      );
	    }
	  }]);
	
	  return UserHeader;
	}(_baseBcReactComponent2.default);
	
	UserHeader.propTypes = {
	  renderActions: _react.PropTypes.func,
	  renderNav: _react.PropTypes.func,
	  profile: _reactImmutableProptypes2.default.map,
	  userIdentity: _bcPropTypes.userIdentityShape.isRequired
	};
	
	UserHeader.defaultProps = {
	  renderActions: function renderActions() {
	    return null;
	  },
	  renderNav: function renderNav() {
	    return null;
	  }
	};
	
	exports.default = UserHeader;

/***/ },
/* 1556 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _UserHeader = __webpack_require__(1555);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_UserHeader).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1557 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _userHeader = __webpack_require__(1556);
	
	Object.defineProperty(exports, 'UserHeader', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_userHeader).default;
	  }
	});
	
	var _userHeaderActions = __webpack_require__(1552);
	
	Object.defineProperty(exports, 'UserHeaderActions', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_userHeaderActions).default;
	  }
	});
	
	var _userHeaderNav = __webpack_require__(1554);
	
	Object.defineProperty(exports, 'UserHeaderNav', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_userHeaderNav).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1558 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	__webpack_require__(2762);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UserStaffStamp = function (_BcReactComponent) {
	  _inherits(UserStaffStamp, _BcReactComponent);
	
	  function UserStaffStamp() {
	    _classCallCheck(this, UserStaffStamp);
	
	    return _possibleConstructorReturn(this, (UserStaffStamp.__proto__ || Object.getPrototypeOf(UserStaffStamp)).apply(this, arguments));
	  }
	
	  _createClass(UserStaffStamp, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          inverse = _props.inverse;
	
	
	      return _react2.default.createElement(
	        'span',
	        { className: (0, _classnames2.default)('cp-user-staff-stamp', className, { inverse: inverse }) },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'library_staff' })
	      );
	    }
	  }]);
	
	  return UserStaffStamp;
	}(_baseBcReactComponent2.default);
	
	UserStaffStamp.propTypes = {
	  inverse: _react.PropTypes.bool
	};
	
	exports.default = UserStaffStamp;

/***/ },
/* 1559 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _UserStaffStamp = __webpack_require__(1558);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_UserStaffStamp).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1560 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _airbrakeJs = __webpack_require__(1574);
	
	var _airbrakeJs2 = _interopRequireDefault(_airbrakeJs);
	
	var _detectBrowser = __webpack_require__(2435);
	
	var _detectBrowser2 = _interopRequireDefault(_detectBrowser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AirbrakeErrorService = function () {
	  function AirbrakeErrorService() {
	    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, AirbrakeErrorService);
	
	    var projectKey = config.projectKey,
	        projectId = config.projectId,
	        env = config.env,
	        appVersion = config.appVersion;
	
	    this.client = new _airbrakeJs2.default({ projectId: projectId, projectKey: projectKey });
	    this.addContextFilter({ env: env, appVersion: appVersion });
	    this.addBrowserFilter();
	  }
	
	  /*
	   * Includes additional context information about the outgoing notice.
	   */
	
	
	  _createClass(AirbrakeErrorService, [{
	    key: 'addContextFilter',
	    value: function addContextFilter(_ref) {
	      var env = _ref.env,
	          appVersion = _ref.appVersion;
	
	      this.client.addFilter(function (notice) {
	        var updatedNotice = notice;
	        updatedNotice.context.environment = env;
	        updatedNotice.context.version = appVersion;
	        return updatedNotice;
	      });
	    }
	  }, {
	    key: 'addBrowserFilter',
	    value: function addBrowserFilter() {
	      this.client.addFilter(function (notice) {
	        var version = parseInt(_detectBrowser2.default.version, 10);
	        switch (_detectBrowser2.default && _detectBrowser2.default.name) {
	          case 'safari':
	            // Support Desktop Safari >= 8
	            return version >= 8 ? notice : null;
	          case 'ie':
	            // Support IE >= 11
	            return version >= 11 ? notice : null;
	          case 'ios':
	            // Support Mobile Safari >= 8
	            // We support iOS Safari 8 and above
	            return version >= 8 ? notice : null;
	          default:
	            return notice;
	        }
	      });
	    }
	
	    /*
	     * Notifies airbrake of the specified error.
	     */
	
	  }, {
	    key: 'notify',
	    value: function notify(err) {
	      if (!err) return Promise.reject(new Error('Undefined err object'));
	      if (!this.client) return Promise.reject(new Error('Undefined service client'));
	
	      return this.client.notify(err).then(function (notice) {
	        return notice && notice.id;
	      });
	    }
	  }]);
	
	  return AirbrakeErrorService;
	}();
	
	exports.default = AirbrakeErrorService;

/***/ },
/* 1561 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ConsoleErrorService = function () {
	  function ConsoleErrorService() {
	    _classCallCheck(this, ConsoleErrorService);
	  }
	
	  _createClass(ConsoleErrorService, [{
	    key: "notify",
	    value: function notify(err) {
	      // eslint-disable-line class-methods-use-this
	      return Promise.resolve().then(function () {
	        return console.error(err);
	      }); // eslint-disable-line no-console
	    }
	  }]);
	
	  return ConsoleErrorService;
	}();
	
	exports.default = ConsoleErrorService;

/***/ },
/* 1562 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isArrowKey = isArrowKey;
	exports.getKeyCodeMovement = getKeyCodeMovement;
	exports.isTouchEvent = isTouchEvent;
	exports.hasTwoTouchPoints = hasTwoTouchPoints;
	exports.normalizeTouch = normalizeTouch;
	/**
	 * @param {KeyboardEvent} e
	 * @returns  {boolean} Is the keyboard event for an arrow key
	 */
	function isArrowKey(e) {
	  var keyCode = e.keyCode;
	  return keyCode >= 37 && keyCode <= 40;
	}
	
	/**
	 * @param {KeyboardEvent} e
	 * @returns {array} [x, y] movement of the keyboard event
	 */
	function getKeyCodeMovement(e) {
	  switch (e.keyCode) {
	    case 37:
	      return [1, 0];
	    case 38:
	      return [0, 1];
	    case 39:
	      return [-1, 0];
	    case 40:
	      return [0, -1];
	    default:
	      return [0, 0];
	  }
	}
	
	/**
	 * @param {UIEvent} e
	 * @returns {boolean} whether the event is a touch event
	 */
	function isTouchEvent(e) {
	  return e.touches !== undefined;
	}
	
	/**
	 * @param {TouchEvent} event
	 * @returns {boolean} if the event has two touch points
	 */
	function hasTwoTouchPoints(event) {
	  if (isTouchEvent(event)) {
	    return event.touches && event.touches.length === 2;
	  }
	  return false;
	}
	
	/**
	 * Normalizes touch and mouse events to return { x, y } coords
	 *
	 * @param {UIEvent} e
	 * @returns {Object} x and y coordinates of the event
	 */
	function normalizeTouch(e) {
	  var p = isTouchEvent(e) ? e.touches[0] : e;
	  return {
	    x: p.clientX,
	    y: p.clientY
	  };
	}

/***/ },
/* 1563 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.listOrderHasChanged = exports.listDescriptionIsTooLong = exports.listNameIsTooLong = exports.generateKeyForListItem = exports.isStaffOnlyList = exports.getListVisibilityType = exports.isNewList = exports.isListDraft = exports.isReadalikeList = undefined;
	
	var _constantsList = __webpack_require__(1405);
	
	var isReadalikeList = exports.isReadalikeList = function isReadalikeList(list) {
	  return list.get('listType') === 'read_a_like';
	};
	
	var isListDraft = exports.isListDraft = function isListDraft(list) {
	  return list.get('isDraft');
	};
	
	var isNewList = exports.isNewList = function isNewList(list) {
	  return !list.get('id');
	};
	
	var getListVisibilityType = exports.getListVisibilityType = function getListVisibilityType(list) {
	  if (list.get('visibility')) {
	    return list.get('visibility');
	  }
	
	  return _constantsList.VISIBILITY.NOT_VISIBLE;
	};
	
	var isStaffOnlyList = exports.isStaffOnlyList = function isStaffOnlyList(list) {
	  return ['staff_picks', 'languages', 'default_newly_acquired', 'admin_newly_acquired', 'teacher_picks'].indexOf(list.get('listType')) !== -1;
	};
	
	var generateKeyForListItem = exports.generateKeyForListItem = function generateKeyForListItem(item) {
	  if (item.get('type') === 'url') {
	    return item.get('type') + '-' + item.getIn(['urlListItem', 'url', 'url']);
	  }
	  return item.get('type') + '-' + item.getIn(['bibListItem', 'id']);
	};
	
	var listNameIsTooLong = exports.listNameIsTooLong = function listNameIsTooLong(list) {
	  return list.get('name', '').length > _constantsList.LIST_NAME_LENGTH_SOFT_LIMIT;
	};
	
	var listDescriptionIsTooLong = exports.listDescriptionIsTooLong = function listDescriptionIsTooLong(list) {
	  return list.get('description', '').length > _constantsList.LIST_DESCRIPTION_LENGTH_SOFT_LIMIT;
	};
	
	var listOrderHasChanged = exports.listOrderHasChanged = function listOrderHasChanged(oldListItems, newListItems) {
	  if (oldListItems.size === newListItems.size) {
	    for (var i = 0; i < oldListItems.size; i += 1) {
	      var oldItem = oldListItems.get(i);
	      var newItem = newListItems.get(i);
	      if (generateKeyForListItem(oldItem) !== generateKeyForListItem(newItem)) {
	        return true;
	      }
	    }
	  }
	
	  return false;
	};
	
	exports.default = {
	  isReadalikeList: isReadalikeList,
	  isListDraft: isListDraft,
	  isNewList: isNewList,
	  isStaffOnlyList: isStaffOnlyList,
	  getListVisibilityType: getListVisibilityType,
	  generateKeyForListItem: generateKeyForListItem,
	  listNameIsTooLong: listNameIsTooLong,
	  listDescriptionIsTooLong: listDescriptionIsTooLong,
	  listOrderHasChanged: listOrderHasChanged
	};

/***/ },
/* 1564 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.between = between;
	exports.inverse = inverse;
	function between(min, max, val) {
	  return Math.min(max, Math.max(min, val));
	}
	
	function inverse(val) {
	  return val * -1;
	}

/***/ },
/* 1565 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isPreviousDisabled = isPreviousDisabled;
	exports.isNextDisabled = isNextDisabled;
	exports.pageRange = pageRange;
	
	var _lodash = __webpack_require__(16);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isPreviousDisabled(page) {
	  return page <= 1;
	}
	
	function isNextDisabled(page, pages) {
	  return page >= pages;
	}
	
	function pageRange(page, pages) {
	  var startPage = void 0;
	  var endPage = void 0;
	  var potentialLastPage = page + 3;
	
	  if (page <= 5) {
	    startPage = 1;
	    endPage = _lodash2.default.min([7, pages]);
	  } else if (page >= pages - 5) {
	    startPage = _lodash2.default.max([1, pages - 6]);
	    endPage = pages;
	  } else {
	    startPage = page - 3;
	    endPage = _lodash2.default.min([potentialLastPage, pages]);
	  }
	
	  return _lodash2.default.range(startPage, endPage + 1);
	}

/***/ },
/* 1566 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setBackTo = undefined;
	
	var _superagent = __webpack_require__(270);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Sets the back_to in the rails session
	 * @param {Object} options
	 * @param {String} options.url      URL the back to link should navigate to
	 * @param {String} options.title    Title key for the back to link
	 */
	var setBackTo = exports.setBackTo = function setBackTo(_ref) {
	  var url = _ref.url,
	      title = _ref.title;
	
	  _superagent2.default.get('/session/back_to').set('Content-Type', 'application/json').query({ url: url, title: title, redirect: true }).end();
	};
	
	exports.default = {
	  setBackTo: setBackTo
	};

/***/ },
/* 1567 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _when = __webpack_require__(271);
	
	var _when2 = _interopRequireDefault(_when);
	
	var _sequence = __webpack_require__(3474);
	
	var _sequence2 = _interopRequireDefault(_sequence);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function fetchInitialDataForComponent(component) {
	  return component.fetchInitialData || component.WrappedComponent && component.WrappedComponent.fetchInitialData;
	}
	
	function filterForApiDependentRoutes(routes) {
	  return routes.filter(function (route) {
	    return route.component && fetchInitialDataForComponent(route.component);
	  });
	}
	
	function fetchDataForCurrentRoute(state, store, apiClient) {
	  var apiDependentRoutes = filterForApiDependentRoutes(state.routes);
	  var fetchTasks = apiDependentRoutes.map(function (route) {
	    return function () {
	      return _when2.default.all(fetchInitialDataForComponent(route.component).apply(undefined, arguments));
	    };
	  });
	  return (0, _sequence2.default)(fetchTasks, state.params, state.location.query, store, apiClient);
	}
	
	exports.default = {
	  filterForApiDependentRoutes: filterForApiDependentRoutes,
	  fetchDataForCurrentRoute: fetchDataForCurrentRoute
	};

/***/ },
/* 1568 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _urlToIFrameSrc = __webpack_require__(1569);
	
	var _urlToIFrameSrc2 = _interopRequireDefault(_urlToIFrameSrc);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  urlToIFrameSrc: _urlToIFrameSrc2.default
	};

/***/ },
/* 1569 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _last = __webpack_require__(753);
	
	var _last2 = _interopRequireDefault(_last);
	
	var _includes = __webpack_require__(2934);
	
	var _includes2 = _interopRequireDefault(_includes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HOSTS = {
	  SCHOOLTUBE: 'www.schooltube.com',
	  TEACHERTUBE: 'www.teachertube.com',
	  VIMEO: 'player.vimeo.com',
	  YOUTUBE: 'www.youtube.com'
	};
	
	var substituteProtocol = function substituteProtocol(url) {
	  return url.replace(/.*\/\//, 'https://');
	};
	var lastPathSegment = function lastPathSegment(url) {
	  return (0, _last2.default)(url.split('/'));
	};
	var removeQuery = function removeQuery(url) {
	  return url.split('?')[0];
	};
	
	/**
	 * Validates a URL using a modified version of the @stephenhay regex from http://mathiasbynens.be/demo/url-regex
	 * @param  {string} url
	 * @return {boolean}
	 */
	var isUrl = function isUrl(url) {
	  return (/^(https?|ftp):\/\/[^\s/$.?:#]+\.[^\s]*$/i.test(url)
	  );
	};
	
	/**
	 * Returns the host part of a url.
	 */
	var getHost = function getHost(url) {
	  return (url.match(/:\/\/([^/]*)/) || [])[1];
	};
	
	/**
	 * Extracts a src="..." URL from a string like <iframe src="some_url">
	 * @param  {string} str
	 * @return {string|undefined}
	 */
	function fromIframeSrc(str) {
	  var match = str.match(/src=["']([^"']*)["']/);
	  return (match || [])[1];
	}
	
	/**
	 * Converts a video URL to the embedded player URL of the relevant video service.
	 * Supported: vimeo, youtube, google drive
	 *
	 * @param  {string} videoUrl
	 * @return {string}
	 */
	function urlToIFrameSrc(videoUrl) {
	  if (!videoUrl) return '';
	
	  var url = void 0;
	  url = fromIframeSrc(videoUrl) || videoUrl;
	  url = substituteProtocol(url);
	
	  // Sanity check that we know what we're parsing
	  if (!isUrl(url)) return '';
	
	  if (url.match(/vimeo/)) {
	    return 'https://' + HOSTS.VIMEO + '/video/' + url.match(/[0-9]+/);
	  }
	
	  if (url.match(/youtu(\.?)be/)) {
	    var videoId = '';
	    if (/\?v=|\/v\//.test(url)) {
	      videoId = url.split(/\?v=|\/v\//)[1];
	    } else {
	      videoId = removeQuery(lastPathSegment(url));
	    }
	
	    return 'https://' + HOSTS.YOUTUBE + '/embed/' + videoId;
	  }
	
	  if (url.match(/teachertube/)) {
	    return 'https://' + HOSTS.TEACHERTUBE + '/embed/video/' + url.match(/[0-9]+/)[0];
	  }
	
	  if (url.match(/schooltube/)) {
	    var match = url.match(/www\.schooltube\.com\/(video|embed_force)\/([^/]*)/i);
	    return match ? 'https://' + HOSTS.SCHOOLTUBE + '/embed_force/' + match[2] : '';
	  }
	
	  // No matching transformation
	  return '';
	}
	
	// Decorate urlToIFrameSrc() with a whitelisting check, to ensure that the
	// returned URL matches a known video host. Cf CORE-37097.
	
	exports.default = function (url) {
	  var src = urlToIFrameSrc(url);
	  return src && (0, _includes2.default)(HOSTS, getHost(src)) ? src : '';
	};

/***/ },
/* 1570 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = VersionMessage;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _localizationMessageIfExists = __webpack_require__(1424);
	
	var _localizationMessageIfExists2 = _interopRequireDefault(_localizationMessageIfExists);
	
	__webpack_require__(2763);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function VersionMessage(_ref) {
	  var version = _ref.version;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'cp-version-message' },
	    _react2.default.createElement(
	      'p',
	      { className: 'powered-by' },
	      _react2.default.createElement(_localizationMessageIfExists2.default, { id: 'static_powered_by', component: _reactIntl.FormattedHTMLMessage })
	    ),
	    _react2.default.createElement(
	      'p',
	      { className: 'product-version' },
	      'NERF: ',
	      version
	    )
	  );
	}
	
	VersionMessage.displayName = 'VersionMessage';
	VersionMessage.propTypes = {
	  version: _react.PropTypes.string.isRequired
	};

/***/ },
/* 1571 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _VersionMessage = __webpack_require__(1570);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_VersionMessage).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1572 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(2188);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(2190);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(2189);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _get = __webpack_require__(750);
	
	var _get2 = _interopRequireDefault(_get);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* global clearTimeout, setTimeout */
	
	var SHOW_TIMEOUT = 50;
	
	/**
	A component for configurable skip loading.
	@examples
	```jsx
	<AboveTheFoldOnlyServerRender skip={true}>
	  <Footer />
	</AboveTheFoldOnlyServerRender>
	```
	@component AboveTheFoldOnlyServerRender
	@import {AboveTheFoldOnlyServerRender}
	@playground
	AboveTheFoldOnlyServerRender
	```
	<AboveTheFoldOnlyServerRender skip={true}>
	  <Footer />
	</AboveTheFoldOnlyServerRender>
	```
	@returns {ReactElement} The rendered component
	*/
	
	var AboveTheFoldOnlyServerRender = function (_Component) {
	  (0, _inherits3.default)(AboveTheFoldOnlyServerRender, _Component);
	
	  function AboveTheFoldOnlyServerRender(props, context) {
	    (0, _classCallCheck3.default)(this, AboveTheFoldOnlyServerRender);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props, context));
	
	    if (props.skip) {
	      _this.state = { visible: false };
	    } else {
	      _this.state = { visible: !(0, _get2.default)(context, props.contextKey, false) };
	    }
	
	    _this._onShow = _this._onShow.bind(_this);
	    return _this;
	  }
	
	  AboveTheFoldOnlyServerRender.prototype.componentDidMount = function componentDidMount() {
	    if (!this.state.visible) {
	      this.timeout = setTimeout(this._onShow, SHOW_TIMEOUT);
	    }
	  };
	
	  AboveTheFoldOnlyServerRender.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.timeout) {
	      clearTimeout(this.timeout);
	      this.timeout = undefined;
	    }
	  };
	
	  AboveTheFoldOnlyServerRender.prototype._onShow = function _onShow() {
	    this.setState({ visible: true });
	  };
	
	  AboveTheFoldOnlyServerRender.prototype.render = function render() {
	    if (this.state.visible) {
	      return this.props.children;
	    }
	
	    var _props = this.props,
	        placeholder = _props.placeholder,
	        placeholderClassName = _props.placeholderClassName,
	        placeholderStyle = _props.placeholderStyle;
	
	
	    return placeholder || _react2.default.createElement("div", { className: placeholderClassName, style: placeholderStyle });
	  };
	
	  return AboveTheFoldOnlyServerRender;
	}(_react.Component);
	
	AboveTheFoldOnlyServerRender.propTypes = {
	  /**
	  Children to render when visible
	  */
	  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node]),
	
	  /**
	  Tell AboveTheFoldOnlyServerRender to read context in order to skip server side rendering
	  */
	  contextKey: _react.PropTypes.string,
	
	  /**
	  Pass in another element to render when skipping server side rendering
	  */
	  placeholder: _react.PropTypes.element,
	
	  /**
	  Sets the className of the default placeholder
	  */
	  placeholderClassName: _react.PropTypes.string,
	
	  /**
	  Sets the style of the default placeholder
	  */
	  placeholderStyle: _react.PropTypes.object,
	
	  /**
	  Tell AboveTheFoldOnlyServerRender to skip server side rendering
	  */
	  skip: _react.PropTypes.bool
	};
	
	AboveTheFoldOnlyServerRender.contextTypes = {
	  aboveTheFoldOnlyServerRender: _react.PropTypes.object
	};
	
	AboveTheFoldOnlyServerRender.defaultProps = {
	  skip: false
	};
	
	exports.default = AboveTheFoldOnlyServerRender;

/***/ },
/* 1573 */
/***/ function(module, exports) {

	function noop() {
	  return null;
	}
	noop.isRequired = noop;
	function noopThunk() {
	  return noop;
	}
	
	module.exports = {
	  and: noopThunk,
	  between: noopThunk,
	  booleanSome: noopThunk,
	  childrenHavePropXorChildren: noopThunk,
	  childrenOf: noopThunk,
	  childrenOfType: noopThunk,
	  childrenSequenceOf: noopThunk,
	  componentWithName: noopThunk,
	  elementType: noopThunk,
	  explicitNull: noopThunk,
	  forbidExtraProps: Object,
	  integer: noopThunk,
	  keysOf: noopThunk,
	  mutuallyExclusiveProps: noopThunk,
	  mutuallyExclusiveTrueProps: noopThunk,
	  nChildren: noopThunk,
	  nonNegativeInteger: noop,
	  nonNegativeNumber: noopThunk,
	  numericString: noopThunk,
	  object: noopThunk,
	  or: noopThunk,
	  range: noopThunk,
	  requiredBy: noopThunk,
	  restrictedProp: noopThunk,
	  sequenceOf: noopThunk,
	  shape: noopThunk,
	  stringStartsWith: noopThunk,
	  uniqueArray: noopThunk,
	  uniqueArrayOf: noopThunk,
	  valuesOf: noopThunk,
	  withShape: noopThunk
	};
	//# sourceMappingURL=index.js.map

/***/ },
/* 1574 */
/***/ function(module, exports, __webpack_require__) {

	/*! airbrake-js v0.9.8 */
	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define([], factory);
		else if(typeof exports === 'object')
			exports["Client"] = factory();
		else
			root["airbrakeJs"] = root["airbrakeJs"] || {}, root["airbrakeJs"]["Client"] = factory();
	})(this, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 2);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	function detectReporter(_opts) {
	    if (typeof fetch === 'function') {
	        return 'fetch';
	    }
	    if (typeof XMLHttpRequest === 'function') {
	        return 'xhr';
	    }
	    if (typeof window === 'object') {
	        return 'jsonp';
	    }
	    return 'node';
	}
	exports.detectReporter = detectReporter;
	exports.errors = {
	    unauthorized: new Error('airbrake: unauthorized: project id or key are wrong'),
	    ipRateLimited: new Error('airbrake: IP is rate limited'),
	};
	
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	// jsonifyNotice serializes notice to JSON and truncates params,
	// environment and session keys.
	function jsonifyNotice(notice, maxLength) {
	    if (maxLength === void 0) { maxLength = 64000; }
	    var s = '';
	    for (var level = 0; level < 8; level++) {
	        notice.context = truncateObj(notice.context, level);
	        notice.params = truncateObj(notice.params, level);
	        notice.environment = truncateObj(notice.environment, level);
	        notice.session = truncateObj(notice.session, level);
	        s = JSON.stringify(notice);
	        if (s.length < maxLength) {
	            return s;
	        }
	    }
	    var err = new Error("airbrake-js: cannot jsonify notice (length=" + s.length + " maxLength=" + maxLength + ")");
	    err.params = {
	        json: s.slice(0, Math.floor(maxLength / 2)) + '...',
	    };
	    throw err;
	}
	exports.default = jsonifyNotice;
	// truncateObj truncates each key in the object separately, which is
	// useful for handling circular references.
	function truncateObj(obj, level) {
	    var dst = {};
	    for (var attr in obj) {
	        dst[attr] = truncate(obj[attr], level);
	    }
	    return dst;
	}
	var Truncator = (function () {
	    function Truncator(level) {
	        if (level === void 0) { level = 0; }
	        this.maxStringLength = 1024;
	        this.maxObjectLength = 128;
	        this.maxArrayLength = 32;
	        this.maxDepth = 8;
	        this.keys = [];
	        this.seen = [];
	        this.maxStringLength = (this.maxStringLength >> level) || 1;
	        this.maxObjectLength = (this.maxObjectLength >> level) || 1;
	        this.maxArrayLength = (this.maxArrayLength >> level) || 1;
	        this.maxDepth = (this.maxDepth >> level) || 1;
	    }
	    Truncator.prototype.truncate = function (value, key, depth) {
	        if (key === void 0) { key = ''; }
	        if (depth === void 0) { depth = 0; }
	        if (value === null || value === undefined) {
	            return value;
	        }
	        switch (typeof value) {
	            case 'boolean':
	            case 'number':
	            case 'function':
	                return value;
	            case 'string':
	                return this.truncateString(value);
	            case 'object':
	                break;
	            default:
	                return String(value);
	        }
	        if (value instanceof String) {
	            return this.truncateString(value.toString());
	        }
	        if (value instanceof Boolean ||
	            value instanceof Number ||
	            value instanceof Date ||
	            value instanceof RegExp) {
	            return value;
	        }
	        if (value instanceof Error) {
	            return value.toString();
	        }
	        if (this.seen.indexOf(value) >= 0) {
	            return "[Circular " + this.getPath(value) + "]";
	        }
	        var type = objectType(value);
	        depth++;
	        if (depth > this.maxDepth) {
	            return "[Truncated " + type + "]";
	        }
	        this.keys.push(key);
	        this.seen.push(value);
	        switch (type) {
	            case 'Array':
	                return this.truncateArray(value, depth);
	            case 'Object':
	                return this.truncateObject(value, depth);
	            default:
	                var saved = this.maxDepth;
	                this.maxDepth = 0;
	                var obj = this.truncateObject(value, depth);
	                obj.__type = type;
	                this.maxDepth = saved;
	                return obj;
	        }
	    };
	    Truncator.prototype.getPath = function (value) {
	        var index = this.seen.indexOf(value);
	        var path = [this.keys[index]];
	        for (var i = index; i >= 0; i--) {
	            var sub = this.seen[i];
	            if (sub && getAttr(sub, path[0]) === value) {
	                value = sub;
	                path.unshift(this.keys[i]);
	            }
	        }
	        return '~' + path.join('.');
	    };
	    Truncator.prototype.truncateString = function (s) {
	        if (s.length > this.maxStringLength) {
	            return s.slice(0, this.maxStringLength) + '...';
	        }
	        return s;
	    };
	    Truncator.prototype.truncateArray = function (arr, depth) {
	        var length = 0;
	        var dst = [];
	        for (var i in arr) {
	            var el = arr[i];
	            length++;
	            if (length >= this.maxArrayLength) {
	                break;
	            }
	            dst.push(this.truncate(el, i, depth));
	        }
	        return dst;
	    };
	    Truncator.prototype.truncateObject = function (obj, depth) {
	        var length = 0;
	        var dst = {};
	        for (var attr in obj) {
	            var value = getAttr(obj, attr);
	            if (value === undefined || typeof value === 'function') {
	                continue;
	            }
	            length++;
	            if (length >= this.maxObjectLength) {
	                break;
	            }
	            dst[attr] = this.truncate(value, attr, depth);
	        }
	        return dst;
	    };
	    return Truncator;
	}());
	function truncate(value, level) {
	    var t = new Truncator(level);
	    return t.truncate(value);
	}
	exports.truncate = truncate;
	function getAttr(obj, attr) {
	    // Ignore browser specific exception trying to read attribute (#79).
	    try {
	        return obj[attr];
	    }
	    catch (_) {
	        return;
	    }
	}
	function objectType(obj) {
	    var s = Object.prototype.toString.apply(obj);
	    return s.slice('[object '.length, -1);
	}
	
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {
	
	__webpack_require__(3);
	module.exports = __webpack_require__(4);
	
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports) {
	
	if (!Object.assign) {
	    Object.assign = function (target) {
	        var args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            args[_i - 1] = arguments[_i];
	        }
	        var _loop_1 = function (source) {
	            if (source) {
	                Object.keys(source).forEach(function (key) { return target[key] = source[key]; });
	            }
	        };
	        for (var _a = 0, args_1 = args; _a < args_1.length; _a++) {
	            var source = args_1[_a];
	            _loop_1(source);
	        }
	        return target;
	    };
	}
	
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var promise_1 = __webpack_require__(5);
	var stacktracejs_1 = __webpack_require__(6);
	var ignore_1 = __webpack_require__(9);
	var debounce_1 = __webpack_require__(10);
	var uncaught_message_1 = __webpack_require__(11);
	var angular_message_1 = __webpack_require__(12);
	var window_1 = __webpack_require__(13);
	var node_1 = __webpack_require__(14);
	var reporter_1 = __webpack_require__(0);
	var fetch_1 = __webpack_require__(15);
	var node_2 = __webpack_require__(16);
	var xhr_1 = __webpack_require__(17);
	var jsonp_1 = __webpack_require__(18);
	var historian_1 = __webpack_require__(19);
	var Client = (function () {
	    function Client(opts) {
	        if (opts === void 0) { opts = {}; }
	        var _this = this;
	        this.opts = {};
	        this.reporters = [];
	        this.filters = [];
	        this.offline = false;
	        this.errors = [];
	        this.opts = opts;
	        this.opts.host = this.opts.host || 'https://api.airbrake.io';
	        this.opts.timeout = this.opts.timeout || 10000;
	        this.processor = opts.processor || stacktracejs_1.default;
	        this.addReporter(opts.reporter || reporter_1.detectReporter(opts));
	        this.addFilter(ignore_1.default);
	        this.addFilter(debounce_1.default());
	        this.addFilter(uncaught_message_1.default);
	        this.addFilter(angular_message_1.default);
	        if (typeof window === 'object') {
	            this.addFilter(window_1.default);
	            if (typeof window.addEventListener === 'function') {
	                window.addEventListener('online', this.onOnline.bind(this));
	                window.addEventListener('offline', function () { return _this.offline = true; });
	            }
	        }
	        else {
	            this.addFilter(node_1.default);
	        }
	        historian_1.historian.registerNotifier(this);
	    }
	    Client.prototype.setProject = function (id, key) {
	        this.opts.projectId = id;
	        this.opts.projectKey = key;
	    };
	    Client.prototype.setHost = function (host) {
	        this.opts.host = host;
	    };
	    Client.prototype.addReporter = function (name) {
	        var reporter;
	        switch (name) {
	            case 'fetch':
	                reporter = fetch_1.default;
	                break;
	            case 'node':
	                reporter = node_2.default;
	                break;
	            case 'xhr':
	                reporter = xhr_1.default;
	                break;
	            case 'jsonp':
	                reporter = jsonp_1.default;
	                break;
	            default:
	                reporter = name;
	        }
	        this.reporters.push(reporter);
	    };
	    Client.prototype.addFilter = function (filter) {
	        this.filters.push(filter);
	    };
	    Client.prototype.notify = function (err) {
	        var _this = this;
	        if (typeof err !== 'object' || err.error === undefined) {
	            err = { error: err };
	        }
	        var promise = err.promise || new promise_1.default();
	        if (!err.error) {
	            var reason = new Error("airbrake-js: got err=" + JSON.stringify(err.error) + ", wanted an Error");
	            promise.reject(reason);
	            return promise;
	        }
	        if (this.opts.ignoreWindowError && err.context && err.context.windowError) {
	            var reason = new Error('airbrake-js: window error is ignored');
	            promise.reject(reason);
	            return promise;
	        }
	        if (this.offline) {
	            err.promise = promise;
	            this.errors.push(err);
	            if (this.errors.length > 100) {
	                this.errors.slice(-100);
	            }
	            return promise;
	        }
	        var notice = {
	            id: '',
	            errors: [],
	            context: Object.assign({
	                language: 'JavaScript',
	                severity: 'error',
	                notifier: {
	                    name: 'airbrake-js',
	                    version: "0.9.8",
	                    url: 'https://github.com/airbrake/airbrake-js',
	                },
	            }, err.context),
	            params: err.params || {},
	            environment: err.environment || {},
	            session: err.session || {},
	        };
	        var history = historian_1.getHistory();
	        if (history.length > 0) {
	            notice.context.history = history;
	        }
	        this.processor(err.error, function (_, error) {
	            notice.errors.push(error);
	            for (var _i = 0, _a = _this.filters; _i < _a.length; _i++) {
	                var filter = _a[_i];
	                var r = filter(notice);
	                if (r === null) {
	                    promise.reject(new Error('airbrake-js: error is filtered'));
	                    return;
	                }
	                notice = r;
	            }
	            for (var _b = 0, _c = _this.reporters; _b < _c.length; _b++) {
	                var reporter = _c[_b];
	                reporter(notice, _this.opts, promise);
	            }
	        });
	        return promise;
	    };
	    Client.prototype.wrap = function (fn) {
	        if (fn._airbrake) {
	            return fn;
	        }
	        var client = this;
	        var airbrakeWrapper = function () {
	            var fnArgs = Array.prototype.slice.call(arguments);
	            var wrappedArgs = client.wrapArguments(fnArgs);
	            try {
	                return fn.apply(this, wrappedArgs);
	            }
	            catch (err) {
	                client.notify({ error: err, params: { arguments: fnArgs } });
	                historian_1.historian.ignoreNextWindowError();
	                throw err;
	            }
	        };
	        for (var prop in fn) {
	            if (fn.hasOwnProperty(prop)) {
	                airbrakeWrapper[prop] = fn[prop];
	            }
	        }
	        airbrakeWrapper._airbrake = true;
	        airbrakeWrapper.inner = fn;
	        return airbrakeWrapper;
	    };
	    Client.prototype.wrapArguments = function (args) {
	        for (var i in args) {
	            var arg = args[i];
	            if (typeof arg === 'function') {
	                args[i] = this.wrap(arg);
	            }
	        }
	        return args;
	    };
	    Client.prototype.call = function (fn) {
	        var _args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            _args[_i - 1] = arguments[_i];
	        }
	        var wrapper = this.wrap(fn);
	        return wrapper.apply(this, Array.prototype.slice.call(arguments, 1));
	    };
	    Client.prototype.onerror = function () {
	        historian_1.historian.onerror.apply(historian_1.historian, arguments);
	    };
	    Client.prototype.onOnline = function () {
	        this.offline = false;
	        for (var _i = 0, _a = this.errors; _i < _a.length; _i++) {
	            var err = _a[_i];
	            this.notify(err);
	        }
	        this.errors = [];
	    };
	    return Client;
	}());
	module.exports = Client;
	
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var Promise = (function () {
	    function Promise(executor) {
	        this.onResolved = [];
	        this.onRejected = [];
	        if (executor) {
	            executor(this.resolve.bind(this), this.reject.bind(this));
	        }
	    }
	    Promise.prototype.then = function (onResolved, onRejected) {
	        if (onResolved) {
	            if (this.resolvedWith) {
	                onResolved(this.resolvedWith);
	            }
	            else {
	                this.onResolved.push(onResolved);
	            }
	        }
	        if (onRejected) {
	            if (this.rejectedWith) {
	                onRejected(this.rejectedWith);
	            }
	            else {
	                this.onRejected.push(onRejected);
	            }
	        }
	        return this;
	    };
	    Promise.prototype.catch = function (onRejected) {
	        if (this.rejectedWith) {
	            onRejected(this.rejectedWith);
	        }
	        else {
	            this.onRejected.push(onRejected);
	        }
	        return this;
	    };
	    Promise.prototype.resolve = function (value) {
	        if (this.resolvedWith || this.rejectedWith) {
	            throw new Error('Promise is already resolved or rejected');
	        }
	        this.resolvedWith = value;
	        for (var _i = 0, _a = this.onResolved; _i < _a.length; _i++) {
	            var fn = _a[_i];
	            fn(value);
	        }
	        return this;
	    };
	    Promise.prototype.reject = function (reason) {
	        if (this.resolvedWith || this.rejectedWith) {
	            throw new Error('Promise is already resolved or rejected');
	        }
	        this.rejectedWith = reason;
	        for (var _i = 0, _a = this.onRejected; _i < _a.length; _i++) {
	            var fn = _a[_i];
	            fn(reason);
	        }
	        return this;
	    };
	    return Promise;
	}());
	exports.default = Promise;
	
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var ErrorStackParser = __webpack_require__(7);
	var hasConsole = typeof console === 'object' && console.warn;
	function parse(err) {
	    try {
	        return ErrorStackParser.parse(err);
	    }
	    catch (parseErr) {
	        if (hasConsole && err.stack) {
	            console.warn('ErrorStackParser:', parseErr.toString(), err.stack);
	        }
	    }
	    if (err.fileName) {
	        return [err];
	    }
	    return [];
	}
	function processor(err, cb) {
	    var backtrace = [];
	    if (!err.noStack) {
	        var frames_1 = parse(err);
	        if (frames_1.length === 0) {
	            try {
	                throw new Error('fake');
	            }
	            catch (fakeErr) {
	                frames_1 = parse(fakeErr);
	                frames_1.shift();
	                frames_1.shift();
	            }
	        }
	        for (var _i = 0, frames_2 = frames_1; _i < frames_2.length; _i++) {
	            var frame = frames_2[_i];
	            backtrace.push({
	                function: frame.functionName || '',
	                file: frame.fileName || '<unknown>',
	                line: frame.lineNumber || 0,
	                column: frame.columnNumber || 0,
	            });
	        }
	    }
	    var type;
	    if (err.name) {
	        type = err.name;
	    }
	    else {
	        type = '';
	    }
	    var msg;
	    if (err.message) {
	        msg = String(err.message);
	    }
	    else {
	        msg = String(err);
	    }
	    cb('stacktracejs', {
	        type: type,
	        message: msg,
	        backtrace: backtrace,
	    });
	}
	exports.default = processor;
	
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports, __webpack_require__) {
	
	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	(function(root, factory) {
	    'use strict';
	    // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.
	
	    /* istanbul ignore next */
	    if (typeof define === 'function' && define.amd) {
	        define('error-stack-parser', ['stackframe'], factory);
	    } else if (true) {
	        module.exports = factory(__webpack_require__(8));
	    } else {
	        root.ErrorStackParser = factory(root.StackFrame);
	    }
	}(this, function ErrorStackParser(StackFrame) {
	    'use strict';
	
	    var FIREFOX_SAFARI_STACK_REGEXP = /(^|@)\S+\:\d+/;
	    var CHROME_IE_STACK_REGEXP = /^\s*at .*(\S+\:\d+|\(native\))/m;
	    var SAFARI_NATIVE_CODE_REGEXP = /^(eval@)?(\[native code\])?$/;
	
	    return {
	        /**
	         * Given an Error object, extract the most information from it.
	         *
	         * @param {Error} error object
	         * @return {Array} of StackFrames
	         */
	        parse: function ErrorStackParser$$parse(error) {
	            if (typeof error.stacktrace !== 'undefined' || typeof error['opera#sourceloc'] !== 'undefined') {
	                return this.parseOpera(error);
	            } else if (error.stack && error.stack.match(CHROME_IE_STACK_REGEXP)) {
	                return this.parseV8OrIE(error);
	            } else if (error.stack) {
	                return this.parseFFOrSafari(error);
	            } else {
	                throw new Error('Cannot parse given Error object');
	            }
	        },
	
	        // Separate line and column numbers from a string of the form: (URI:Line:Column)
	        extractLocation: function ErrorStackParser$$extractLocation(urlLike) {
	            // Fail-fast but return locations like "(native)"
	            if (urlLike.indexOf(':') === -1) {
	                return [urlLike];
	            }
	
	            var regExp = /(.+?)(?:\:(\d+))?(?:\:(\d+))?$/;
	            var parts = regExp.exec(urlLike.replace(/[\(\)]/g, ''));
	            return [parts[1], parts[2] || undefined, parts[3] || undefined];
	        },
	
	        parseV8OrIE: function ErrorStackParser$$parseV8OrIE(error) {
	            var filtered = error.stack.split('\n').filter(function(line) {
	                return !!line.match(CHROME_IE_STACK_REGEXP);
	            }, this);
	
	            return filtered.map(function(line) {
	                if (line.indexOf('(eval ') > -1) {
	                    // Throw away eval information until we implement stacktrace.js/stackframe#8
	                    line = line.replace(/eval code/g, 'eval').replace(/(\(eval at [^\()]*)|(\)\,.*$)/g, '');
	                }
	                var tokens = line.replace(/^\s+/, '').replace(/\(eval code/g, '(').split(/\s+/).slice(1);
	                var locationParts = this.extractLocation(tokens.pop());
	                var functionName = tokens.join(' ') || undefined;
	                var fileName = ['eval', '<anonymous>'].indexOf(locationParts[0]) > -1 ? undefined : locationParts[0];
	
	                return new StackFrame({
	                    functionName: functionName,
	                    fileName: fileName,
	                    lineNumber: locationParts[1],
	                    columnNumber: locationParts[2],
	                    source: line
	                });
	            }, this);
	        },
	
	        parseFFOrSafari: function ErrorStackParser$$parseFFOrSafari(error) {
	            var filtered = error.stack.split('\n').filter(function(line) {
	                return !line.match(SAFARI_NATIVE_CODE_REGEXP);
	            }, this);
	
	            return filtered.map(function(line) {
	                // Throw away eval information until we implement stacktrace.js/stackframe#8
	                if (line.indexOf(' > eval') > -1) {
	                    line = line.replace(/ line (\d+)(?: > eval line \d+)* > eval\:\d+\:\d+/g, ':$1');
	                }
	
	                if (line.indexOf('@') === -1 && line.indexOf(':') === -1) {
	                    // Safari eval frames only have function names and nothing else
	                    return new StackFrame({
	                        functionName: line
	                    });
	                } else {
	                    var tokens = line.split('@');
	                    var locationParts = this.extractLocation(tokens.pop());
	                    var functionName = tokens.join('@') || undefined;
	
	                    return new StackFrame({
	                        functionName: functionName,
	                        fileName: locationParts[0],
	                        lineNumber: locationParts[1],
	                        columnNumber: locationParts[2],
	                        source: line
	                    });
	                }
	            }, this);
	        },
	
	        parseOpera: function ErrorStackParser$$parseOpera(e) {
	            if (!e.stacktrace || (e.message.indexOf('\n') > -1 &&
	                e.message.split('\n').length > e.stacktrace.split('\n').length)) {
	                return this.parseOpera9(e);
	            } else if (!e.stack) {
	                return this.parseOpera10(e);
	            } else {
	                return this.parseOpera11(e);
	            }
	        },
	
	        parseOpera9: function ErrorStackParser$$parseOpera9(e) {
	            var lineRE = /Line (\d+).*script (?:in )?(\S+)/i;
	            var lines = e.message.split('\n');
	            var result = [];
	
	            for (var i = 2, len = lines.length; i < len; i += 2) {
	                var match = lineRE.exec(lines[i]);
	                if (match) {
	                    result.push(new StackFrame({
	                        fileName: match[2],
	                        lineNumber: match[1],
	                        source: lines[i]
	                    }));
	                }
	            }
	
	            return result;
	        },
	
	        parseOpera10: function ErrorStackParser$$parseOpera10(e) {
	            var lineRE = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i;
	            var lines = e.stacktrace.split('\n');
	            var result = [];
	
	            for (var i = 0, len = lines.length; i < len; i += 2) {
	                var match = lineRE.exec(lines[i]);
	                if (match) {
	                    result.push(
	                        new StackFrame({
	                            functionName: match[3] || undefined,
	                            fileName: match[2],
	                            lineNumber: match[1],
	                            source: lines[i]
	                        })
	                    );
	                }
	            }
	
	            return result;
	        },
	
	        // Opera 10.65+ Error.stack very similar to FF/Safari
	        parseOpera11: function ErrorStackParser$$parseOpera11(error) {
	            var filtered = error.stack.split('\n').filter(function(line) {
	                return !!line.match(FIREFOX_SAFARI_STACK_REGEXP) && !line.match(/^Error created at/);
	            }, this);
	
	            return filtered.map(function(line) {
	                var tokens = line.split('@');
	                var locationParts = this.extractLocation(tokens.pop());
	                var functionCall = (tokens.shift() || '');
	                var functionName = functionCall
	                        .replace(/<anonymous function(: (\w+))?>/, '$2')
	                        .replace(/\([^\)]*\)/g, '') || undefined;
	                var argsRaw;
	                if (functionCall.match(/\(([^\)]*)\)/)) {
	                    argsRaw = functionCall.replace(/^[^\(]+\(([^\)]*)\)$/, '$1');
	                }
	                var args = (argsRaw === undefined || argsRaw === '[arguments not available]') ?
	                    undefined : argsRaw.split(',');
	
	                return new StackFrame({
	                    functionName: functionName,
	                    args: args,
	                    fileName: locationParts[0],
	                    lineNumber: locationParts[1],
	                    columnNumber: locationParts[2],
	                    source: line
	                });
	            }, this);
	        }
	    };
	}));
	
	
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports, __webpack_require__) {
	
	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	(function(root, factory) {
	    'use strict';
	    // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.
	
	    /* istanbul ignore next */
	    if (typeof define === 'function' && define.amd) {
	        define('stackframe', [], factory);
	    } else if (true) {
	        module.exports = factory();
	    } else {
	        root.StackFrame = factory();
	    }
	}(this, function() {
	    'use strict';
	    function _isNumber(n) {
	        return !isNaN(parseFloat(n)) && isFinite(n);
	    }
	
	    function _capitalize(str) {
	        return str[0].toUpperCase() + str.substring(1);
	    }
	
	    function _getter(p) {
	        return function() {
	            return this[p];
	        };
	    }
	
	    var booleanProps = ['isConstructor', 'isEval', 'isNative', 'isToplevel'];
	    var numericProps = ['columnNumber', 'lineNumber'];
	    var stringProps = ['fileName', 'functionName', 'source'];
	    var arrayProps = ['args'];
	
	    var props = booleanProps.concat(numericProps, stringProps, arrayProps);
	
	    function StackFrame(obj) {
	        if (obj instanceof Object) {
	            for (var i = 0; i < props.length; i++) {
	                if (obj.hasOwnProperty(props[i]) && obj[props[i]] !== undefined) {
	                    this['set' + _capitalize(props[i])](obj[props[i]]);
	                }
	            }
	        }
	    }
	
	    StackFrame.prototype = {
	        getArgs: function() {
	            return this.args;
	        },
	        setArgs: function(v) {
	            if (Object.prototype.toString.call(v) !== '[object Array]') {
	                throw new TypeError('Args must be an Array');
	            }
	            this.args = v;
	        },
	
	        getEvalOrigin: function() {
	            return this.evalOrigin;
	        },
	        setEvalOrigin: function(v) {
	            if (v instanceof StackFrame) {
	                this.evalOrigin = v;
	            } else if (v instanceof Object) {
	                this.evalOrigin = new StackFrame(v);
	            } else {
	                throw new TypeError('Eval Origin must be an Object or StackFrame');
	            }
	        },
	
	        toString: function() {
	            var functionName = this.getFunctionName() || '{anonymous}';
	            var args = '(' + (this.getArgs() || []).join(',') + ')';
	            var fileName = this.getFileName() ? ('@' + this.getFileName()) : '';
	            var lineNumber = _isNumber(this.getLineNumber()) ? (':' + this.getLineNumber()) : '';
	            var columnNumber = _isNumber(this.getColumnNumber()) ? (':' + this.getColumnNumber()) : '';
	            return functionName + args + fileName + lineNumber + columnNumber;
	        }
	    };
	
	    for (var i = 0; i < booleanProps.length; i++) {
	        StackFrame.prototype['get' + _capitalize(booleanProps[i])] = _getter(booleanProps[i]);
	        StackFrame.prototype['set' + _capitalize(booleanProps[i])] = (function(p) {
	            return function(v) {
	                this[p] = Boolean(v);
	            };
	        })(booleanProps[i]);
	    }
	
	    for (var j = 0; j < numericProps.length; j++) {
	        StackFrame.prototype['get' + _capitalize(numericProps[j])] = _getter(numericProps[j]);
	        StackFrame.prototype['set' + _capitalize(numericProps[j])] = (function(p) {
	            return function(v) {
	                if (!_isNumber(v)) {
	                    throw new TypeError(p + ' must be a Number');
	                }
	                this[p] = Number(v);
	            };
	        })(numericProps[j]);
	    }
	
	    for (var k = 0; k < stringProps.length; k++) {
	        StackFrame.prototype['get' + _capitalize(stringProps[k])] = _getter(stringProps[k]);
	        StackFrame.prototype['set' + _capitalize(stringProps[k])] = (function(p) {
	            return function(v) {
	                this[p] = String(v);
	            };
	        })(stringProps[k]);
	    }
	
	    return StackFrame;
	}));
	
	
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var IGNORED_MESSAGES = [
	    'Script error',
	    'Script error.',
	    'InvalidAccessError',
	];
	function filter(notice) {
	    var err = notice.errors[0];
	    if (err.type === '' && IGNORED_MESSAGES.indexOf(err.message) !== -1) {
	        return null;
	    }
	    if (err.backtrace && err.backtrace.length > 0) {
	        var frame = err.backtrace[0];
	        if (frame.file === '<anonymous>') {
	            return null;
	        }
	    }
	    return notice;
	}
	exports.default = filter;
	
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	function makeFilter() {
	    var lastNoticeJSON;
	    var timeout;
	    return function (notice) {
	        var s = JSON.stringify(notice.errors);
	        if (s === lastNoticeJSON) {
	            return null;
	        }
	        if (timeout) {
	            clearTimeout(timeout);
	        }
	        lastNoticeJSON = s;
	        timeout = setTimeout(function () {
	            lastNoticeJSON = '';
	        }, 1000);
	        return notice;
	    };
	}
	exports.default = makeFilter;
	
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var re = new RegExp([
	    '^',
	    'Uncaught\\s',
	    '(.+?)',
	    ':\\s',
	    '(.+)',
	    '$',
	].join(''));
	function filter(notice) {
	    var err = notice.errors[0];
	    if (err.type !== '' && err.type !== 'Error') {
	        return notice;
	    }
	    var m = err.message.match(re);
	    if (m !== null) {
	        err.type = m[1];
	        err.message = m[2];
	    }
	    return notice;
	}
	exports.default = filter;
	
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var re = new RegExp([
	    '^',
	    '\\[(\\$.+)\\]',
	    '\\s',
	    '([\\s\\S]+)',
	    '$',
	].join(''));
	function filter(notice) {
	    var err = notice.errors[0];
	    if (err.type !== '' && err.type !== 'Error') {
	        return notice;
	    }
	    var m = err.message.match(re);
	    if (m !== null) {
	        err.type = m[1];
	        err.message = m[2];
	    }
	    return notice;
	}
	exports.default = filter;
	
	
	/***/ }),
	/* 13 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	function filter(notice) {
	    if (window.navigator && window.navigator.userAgent) {
	        notice.context.userAgent = window.navigator.userAgent;
	    }
	    if (window.location) {
	        notice.context.url = String(window.location);
	        // Set root directory to group errors on different subdomains together.
	        notice.context.rootDirectory = window.location.protocol + '//' + window.location.host;
	    }
	    return notice;
	}
	exports.default = filter;
	
	
	/***/ }),
	/* 14 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var myProcess, os;
	try {
	    // Use eval to hide import from Webpack and browserify.
	    myProcess = eval('process');
	    os = eval('require')('os');
	}
	catch (_) { }
	function filter(notice) {
	    if (os) {
	        notice.context.os = os.type() + "/" + os.release();
	        notice.context.architecture = os.arch();
	        notice.context.hostname = os.hostname();
	    }
	    notice.context.platform = myProcess.platform;
	    if (!notice.context.rootDirectory) {
	        notice.context.rootDirectory = myProcess.cwd();
	    }
	    if (myProcess.env.NODE_ENV) {
	        notice.context.environment = myProcess.env.NODE_ENV;
	    }
	    notice.params.process = {
	        pid: myProcess.pid,
	        cwd: myProcess.cwd(),
	        execPath: myProcess.execPath,
	        argv: myProcess.argv,
	    };
	    for (var name_1 in ['uptime', 'cpuUsage', 'memoryUsage']) {
	        if (myProcess[name_1]) {
	            notice.params.process[name_1] = myProcess[name_1]();
	        }
	    }
	    if (os) {
	        notice.params.os = {
	            homedir: os.homedir(),
	            uptime: os.uptime(),
	            freemem: os.freemem(),
	            totalmem: os.totalmem(),
	            loadavg: os.loadavg(),
	        };
	    }
	    return notice;
	}
	exports.default = filter;
	
	
	/***/ }),
	/* 15 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var jsonify_notice_1 = __webpack_require__(1);
	var reporter_1 = __webpack_require__(0);
	var rateLimitReset = 0;
	function report(notice, opts, promise) {
	    var utime = Date.now() / 1000;
	    if (utime < rateLimitReset) {
	        promise.reject(reporter_1.errors.ipRateLimited);
	        return;
	    }
	    var url = opts.host + "/api/v3/projects/" + opts.projectId + "/notices?key=" + opts.projectKey;
	    var payload = jsonify_notice_1.default(notice);
	    var opt = {
	        method: 'POST',
	        body: payload,
	    };
	    fetch(url, opt).then(function (req) {
	        if (req.status === 401) {
	            promise.reject(reporter_1.errors.unauthorized);
	            return;
	        }
	        if (req.status === 429) {
	            promise.reject(reporter_1.errors.ipRateLimited);
	            var s = req.headers.get('X-RateLimit-Delay');
	            if (!s) {
	                return;
	            }
	            var n = parseInt(s, 10);
	            if (n > 0) {
	                rateLimitReset = Date.now() / 1000 + n;
	            }
	            return;
	        }
	        if (req.status >= 200 && req.status < 500) {
	            req.json().then(function (resp) {
	                if (resp.id) {
	                    notice.id = resp.id;
	                    promise.resolve(notice);
	                    return;
	                }
	                if (resp.error) {
	                    var err = new Error(resp.error);
	                    promise.reject(err);
	                    return;
	                }
	            });
	            return;
	        }
	        req.text().then(function (body) {
	            var err = new Error("airbrake: fetch: unexpected response: code=" + req.status + " body='" + body + "'");
	            promise.reject(err);
	        });
	    }).catch(function (err) {
	        promise.reject(err);
	    });
	}
	exports.default = report;
	
	
	/***/ }),
	/* 16 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var jsonify_notice_1 = __webpack_require__(1);
	var reporter_1 = __webpack_require__(0);
	var request;
	try {
	    // Use eval to hide import from Webpack.
	    request = eval('require')('request');
	}
	catch (_) { }
	var rateLimitReset = 0;
	function report(notice, opts, promise) {
	    var utime = Date.now() / 1000;
	    if (utime < rateLimitReset) {
	        promise.reject(reporter_1.errors.ipRateLimited);
	        return;
	    }
	    var url = opts.host + "/api/v3/projects/" + opts.projectId + "/notices?key=" + opts.projectKey;
	    var payload = jsonify_notice_1.default(notice);
	    request({
	        url: url,
	        method: 'POST',
	        body: payload,
	        headers: {
	            'content-type': 'application/json'
	        },
	        timeout: opts.timeout,
	    }, function (error, response, body) {
	        if (error) {
	            promise.reject(error);
	            return;
	        }
	        if (!response.statusCode) {
	            promise.reject(new Error('airbrake: node: statusCode is undefined'));
	            return;
	        }
	        if (response.statusCode === 401) {
	            promise.reject(reporter_1.errors.unauthorized);
	            return;
	        }
	        if (response.statusCode === 429) {
	            promise.reject(reporter_1.errors.ipRateLimited);
	            var h = response.headers['x-ratelimit-delay'];
	            if (!h) {
	                return;
	            }
	            var s = void 0;
	            if (typeof h === 'string') {
	                s = h;
	            }
	            else if (h instanceof Array) {
	                s = h[0];
	            }
	            else {
	                return;
	            }
	            var n = parseInt(s, 10);
	            if (n > 0) {
	                rateLimitReset = Date.now() / 1000 + n;
	            }
	            return;
	        }
	        if (response.statusCode >= 200 && response.statusCode < 500) {
	            var resp = JSON.parse(body);
	            if (resp.id) {
	                notice.id = resp.id;
	                promise.resolve(notice);
	                return;
	            }
	            if (resp.error) {
	                var err_1 = new Error(resp.error);
	                promise.reject(err_1);
	                return;
	            }
	        }
	        body = body.trim();
	        var err = new Error("airbrake: node: unexpected response: code=" + response.statusCode + " body='" + body + "'");
	        promise.reject(err);
	    });
	}
	exports.default = report;
	
	
	/***/ }),
	/* 17 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var jsonify_notice_1 = __webpack_require__(1);
	var reporter_1 = __webpack_require__(0);
	var rateLimitReset = 0;
	function report(notice, opts, promise) {
	    var utime = Date.now() / 1000;
	    if (utime < rateLimitReset) {
	        promise.reject(reporter_1.errors.ipRateLimited);
	        return;
	    }
	    var url = opts.host + "/api/v3/projects/" + opts.projectId + "/notices?key=" + opts.projectKey;
	    var payload = jsonify_notice_1.default(notice);
	    var req = new XMLHttpRequest();
	    req.open('POST', url, true);
	    req.timeout = opts.timeout;
	    req.onreadystatechange = function () {
	        if (req.readyState !== 4) {
	            return;
	        }
	        if (req.status === 401) {
	            promise.reject(reporter_1.errors.unauthorized);
	            return;
	        }
	        if (req.status === 429) {
	            promise.reject(reporter_1.errors.ipRateLimited);
	            var s = req.getResponseHeader('X-RateLimit-Delay');
	            if (!s) {
	                return;
	            }
	            var n = parseInt(s, 10);
	            if (n > 0) {
	                rateLimitReset = Date.now() / 1000 + n;
	            }
	            return;
	        }
	        if (req.status >= 200 && req.status < 500) {
	            var resp = JSON.parse(req.responseText);
	            if (resp.id) {
	                notice.id = resp.id;
	                promise.resolve(notice);
	                return;
	            }
	            if (resp.error) {
	                var err_1 = new Error(resp.error);
	                promise.reject(err_1);
	                return;
	            }
	        }
	        var body = req.responseText.trim();
	        var err = new Error("airbrake: xhr: unexpected response: code=" + req.status + " body='" + body + "'");
	        promise.reject(err);
	    };
	    req.send(payload);
	}
	exports.default = report;
	
	
	/***/ }),
	/* 18 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var jsonify_notice_1 = __webpack_require__(1);
	var cbCount = 0;
	function report(notice, opts, promise) {
	    cbCount++;
	    var cbName = 'airbrakeCb' + String(cbCount);
	    window[cbName] = function (resp) {
	        try {
	            delete window[cbName];
	        }
	        catch (_) {
	            window[cbName] = undefined;
	        }
	        if (resp.id) {
	            notice.id = resp.id;
	            promise.resolve(notice);
	            return;
	        }
	        if (resp.error) {
	            var err_1 = new Error(resp.error);
	            promise.reject(err_1);
	            return;
	        }
	        var err = new Error(resp);
	        promise.reject(err);
	    };
	    var payload = encodeURIComponent(jsonify_notice_1.default(notice));
	    var url = opts.host + "/api/v3/projects/" + opts.projectId + "/create-notice?key=" + opts.projectKey + "&callback=" + cbName + "&body=" + payload;
	    var document = window.document;
	    var head = document.getElementsByTagName('head')[0];
	    var script = document.createElement('script');
	    script.src = url;
	    script.onload = function () { return head.removeChild(script); };
	    script.onerror = function () {
	        head.removeChild(script);
	        var err = new Error('airbrake: JSONP script error');
	        promise.reject(err);
	    };
	    head.appendChild(script);
	}
	exports.default = report;
	
	
	/***/ }),
	/* 19 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var dom_1 = __webpack_require__(20);
	var Historian = (function () {
	    function Historian() {
	        var _this = this;
	        this.historyMaxLen = 20;
	        this.notifiers = [];
	        this.errors = [];
	        this.ignoreWindowError = 0;
	        this.history = [];
	        this.ignoreNextXHR = 0;
	        if (typeof window === 'object') {
	            var self_1 = this;
	            var oldHandler_1 = window.onerror;
	            window.onerror = function () {
	                if (oldHandler_1) {
	                    oldHandler_1.apply(this, arguments);
	                }
	                self_1.onerror.apply(self_1, arguments);
	            };
	        }
	        else {
	            // Use eval to hide process usage from Webpack and Browserify.
	            var p = eval('process');
	            p.on('uncaughtException', function (err) {
	                // TODO: add wait for async notify
	                _this.notify(err);
	                throw err;
	            });
	            p.on('unhandledRejection', function (reason, _p) {
	                _this.notify(reason);
	            });
	        }
	        if (typeof document === 'object') {
	            this.dom();
	        }
	        if (typeof console === 'object') {
	            this.console();
	        }
	        if (typeof fetch === 'function') {
	            this.fetch();
	        }
	        if (typeof XMLHttpRequest !== 'undefined') {
	            this.xhr();
	        }
	        if (typeof history === 'object') {
	            this.location();
	        }
	    }
	    Historian.prototype.registerNotifier = function (n) {
	        this.notifiers.push(n);
	        for (var _i = 0, _a = this.errors; _i < _a.length; _i++) {
	            var err = _a[_i];
	            this.notifyNotifiers(err);
	        }
	        this.errors = [];
	    };
	    Historian.prototype.notify = function (err) {
	        if (this.notifiers.length > 0) {
	            this.notifyNotifiers(err);
	            return;
	        }
	        this.errors.push(err);
	        if (this.errors.length > this.historyMaxLen) {
	            this.errors = this.errors.slice(-this.historyMaxLen);
	        }
	    };
	    Historian.prototype.notifyNotifiers = function (err) {
	        for (var _i = 0, _a = this.notifiers; _i < _a.length; _i++) {
	            var notifier = _a[_i];
	            notifier.notify(err);
	        }
	    };
	    Historian.prototype.onerror = function (message, filename, line, column, err) {
	        if (this.ignoreWindowError > 0) {
	            return;
	        }
	        if (err) {
	            this.notify({
	                error: err,
	                context: {
	                    windowError: true,
	                },
	            });
	            return;
	        }
	        // Ignore errors without file or line.
	        if (!filename || !line) {
	            return;
	        }
	        this.notify({
	            error: {
	                message: message,
	                fileName: filename,
	                lineNumber: line,
	                columnNumber: column,
	                noStack: true,
	            },
	            context: {
	                windowError: true,
	            },
	        });
	    };
	    Historian.prototype.ignoreNextWindowError = function () {
	        var _this = this;
	        this.ignoreWindowError++;
	        setTimeout(function () { return _this.ignoreWindowError--; });
	    };
	    Historian.prototype.getHistory = function () {
	        return this.history;
	    };
	    Historian.prototype.pushHistory = function (state) {
	        if (this.isDupState(state)) {
	            if (this.lastState.num) {
	                this.lastState.num++;
	            }
	            else {
	                this.lastState.num = 2;
	            }
	            return;
	        }
	        if (!state.date) {
	            state.date = new Date();
	        }
	        this.history.push(state);
	        this.lastState = state;
	        if (this.history.length > this.historyMaxLen) {
	            this.history = this.history.slice(-this.historyMaxLen);
	        }
	    };
	    Historian.prototype.isDupState = function (state) {
	        if (!this.lastState) {
	            return false;
	        }
	        for (var key in state) {
	            if (key === 'date') {
	                continue;
	            }
	            if (state[key] !== this.lastState[key]) {
	                return false;
	            }
	        }
	        return true;
	    };
	    Historian.prototype.dom = function () {
	        var handler = dom_1.makeEventHandler(this);
	        document.addEventListener('DOMContentLoaded', handler);
	        window.addEventListener('load', handler);
	        document.addEventListener('click', handler);
	        document.addEventListener('keypress', handler);
	        window.addEventListener('error', function (event) {
	            if ('error' in event) {
	                return;
	            }
	            handler(event);
	        }, true);
	    };
	    Historian.prototype.console = function () {
	        var client = this;
	        var methods = ['debug', 'log', 'info', 'warn', 'error'];
	        var _loop_1 = function (m) {
	            if (!(m in console)) {
	                return "continue";
	            }
	            var oldFn = console[m];
	            var newFn = function () {
	                oldFn.apply(console, arguments);
	                client.pushHistory({
	                    type: 'log',
	                    severity: m,
	                    arguments: Array.prototype.slice.call(arguments),
	                });
	            };
	            newFn.inner = oldFn;
	            console[m] = newFn;
	        };
	        for (var _i = 0, methods_1 = methods; _i < methods_1.length; _i++) {
	            var m = methods_1[_i];
	            _loop_1(m);
	        }
	    };
	    Historian.prototype.fetch = function () {
	        var client = this;
	        var oldFetch = fetch;
	        window.fetch = function (input, init) {
	            var state = {
	                type: 'xhr',
	                date: new Date(),
	            };
	            if (typeof input === 'string') {
	                state.url = input;
	            }
	            else {
	                state.url = input.url;
	            }
	            if (init && init.method) {
	                state.method = init.method;
	            }
	            else {
	                state.method = 'GET';
	            }
	            // Some platforms (e.g. react-native) implement fetch via XHR.
	            client.ignoreNextXHR++;
	            setTimeout(function () { return client.ignoreNextXHR--; });
	            var promise = oldFetch.apply(this, arguments);
	            promise.then(function (req) {
	                state.statusCode = req.status;
	                state.duration = new Date().getTime() - state.date.getTime();
	                client.pushHistory(state);
	            });
	            return promise;
	        };
	    };
	    Historian.prototype.xhr = function () {
	        var client = this;
	        var oldOpen = XMLHttpRequest.prototype.open;
	        XMLHttpRequest.prototype.open = function (method, url, _async, _user, _password) {
	            if (client.ignoreNextXHR === 0) {
	                this.__state = {
	                    type: 'xhr',
	                    method: method,
	                    url: url,
	                };
	            }
	            oldOpen.apply(this, arguments);
	        };
	        var oldSend = XMLHttpRequest.prototype.send;
	        XMLHttpRequest.prototype.send = function (_data) {
	            var oldFn = this.onreadystatechange;
	            this.onreadystatechange = function (_ev) {
	                if (this.readyState === 4 && this.__state) {
	                    client.recordReq(this);
	                }
	                if (oldFn) {
	                    return oldFn.apply(this, arguments);
	                }
	            };
	            if (this.__state) {
	                this.__state.date = new Date();
	            }
	            return oldSend.apply(this, arguments);
	        };
	    };
	    Historian.prototype.recordReq = function (req) {
	        var state = req.__state;
	        state.statusCode = req.status;
	        state.duration = new Date().getTime() - state.date.getTime();
	        this.pushHistory(state);
	    };
	    Historian.prototype.location = function () {
	        this.lastLocation = document.location.pathname;
	        var client = this;
	        var oldFn = window.onpopstate;
	        window.onpopstate = function (_event) {
	            client.recordLocation(document.location.pathname);
	            if (oldFn) {
	                return oldFn.apply(this, arguments);
	            }
	        };
	        var oldPushState = history.pushState;
	        history.pushState = function (_state, _title, url) {
	            if (url) {
	                client.recordLocation(url.toString());
	            }
	            oldPushState.apply(this, arguments);
	        };
	    };
	    Historian.prototype.recordLocation = function (url) {
	        var index = url.indexOf('://');
	        if (index >= 0) {
	            url = url.slice(index + 3);
	            index = url.indexOf('/');
	            if (index >= 0) {
	                url = url.slice(index);
	            }
	            else {
	                url = '/';
	            }
	        }
	        else if (url.charAt(0) !== '/') {
	            url = '/' + url;
	        }
	        this.pushHistory({
	            type: 'location',
	            from: this.lastLocation,
	            to: url,
	        });
	        this.lastLocation = url;
	    };
	    return Historian;
	}());
	exports.default = Historian;
	exports.historian = new Historian();
	function getHistory() {
	    return exports.historian.getHistory();
	}
	exports.getHistory = getHistory;
	
	
	/***/ }),
	/* 20 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var elemAttrs = ['type', 'name', 'src'];
	function elemName(elem) {
	    if (!elem) {
	        return '';
	    }
	    var s = [];
	    if (elem.tagName) {
	        s.push(elem.tagName.toLowerCase());
	    }
	    if (elem.id) {
	        s.push('#');
	        s.push(elem.id);
	    }
	    if (elem.className) {
	        s.push('.');
	        s.push(elem.className.split(' ').join('.'));
	    }
	    if (elem.getAttribute) {
	        for (var _i = 0, elemAttrs_1 = elemAttrs; _i < elemAttrs_1.length; _i++) {
	            var attr = elemAttrs_1[_i];
	            var value = elem.getAttribute(attr);
	            if (value) {
	                s.push("[" + attr + "=\"" + value + "\"]");
	            }
	        }
	    }
	    return s.join('');
	}
	function elemPath(elem) {
	    var maxLen = 10;
	    var path = [];
	    var parent = elem;
	    while (parent) {
	        var name_1 = elemName(parent);
	        if (name_1 !== '') {
	            path.push(name_1);
	            if (path.length > maxLen) {
	                break;
	            }
	        }
	        parent = parent.parentNode;
	    }
	    if (path.length === 0) {
	        return String(elem);
	    }
	    return path.reverse().join(' > ');
	}
	function makeEventHandler(client) {
	    return function (event) {
	        var target;
	        try {
	            target = event.target;
	        }
	        catch (_) {
	            return;
	        }
	        if (!target) {
	            return;
	        }
	        var state = { type: event.type };
	        try {
	            state.target = elemPath(target);
	        }
	        catch (err) {
	            state.target = "<" + err.toString() + ">";
	        }
	        client.pushHistory(state);
	    };
	}
	exports.makeEventHandler = makeEventHandler;
	
	
	/***/ })
	/******/ ]);
	});
	//# sourceMappingURL=client.js.map

/***/ },
/* 1575 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(251);
	var bind = __webpack_require__(253);
	
	var implementation = __webpack_require__(554);
	var getPolyfill = __webpack_require__(555);
	var polyfill = getPolyfill();
	var shim = __webpack_require__(1576);
	
	var boundFlat = bind.call(Function.call, polyfill);
	
	define(boundFlat, {
		getPolyfill: getPolyfill,
		implementation: implementation,
		shim: shim
	});
	
	module.exports = boundFlat;


/***/ },
/* 1576 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(251);
	var getPolyfill = __webpack_require__(555);
	
	module.exports = function shimFlat() {
		var polyfill = getPolyfill();
		define(
			Array.prototype,
			{ flat: polyfill },
			{ flat: function () { return Array.prototype.flat !== polyfill; } }
		);
		return polyfill;
	};


/***/ },
/* 1577 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AnalyticsApi = __webpack_require__(1597);
	
	var _AnalyticsApi2 = _interopRequireDefault(_AnalyticsApi);
	
	var _AnalyticsConstants = __webpack_require__(611);
	
	var _AnalyticsConstants2 = _interopRequireDefault(_AnalyticsConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function fetchDataLayer() {
	  return {
	    types: [_AnalyticsConstants2.default.FETCH_DATALAYER_REQUEST, _AnalyticsConstants2.default.FETCH_DATALAYER_SUCCESS, _AnalyticsConstants2.default.FETCH_DATALAYER_FAILURE],
	    apiRequest: function apiRequest(state, client) {
	      return _AnalyticsApi2.default.fetchDataLayer(client);
	    }
	  };
	}
	
	exports.default = {
	  fetchDataLayer: fetchDataLayer
	};

/***/ },
/* 1578 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CommentsApi = __webpack_require__(1603);
	
	var _CommentsApi2 = _interopRequireDefault(_CommentsApi);
	
	var _CommentsConstants = __webpack_require__(613);
	
	var _CommentsConstants2 = _interopRequireDefault(_CommentsConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function addComment(_ref) {
	  var metadataId = _ref.metadataId,
	      comment = _ref.comment,
	      postSuccess = _ref.postSuccess;
	
	  return {
	    metadataId: metadataId,
	    postSuccess: postSuccess,
	    types: [_CommentsConstants2.default.ADD_COMMENT_REQUEST, _CommentsConstants2.default.ADD_COMMENT_SUCCESS, _CommentsConstants2.default.ADD_COMMENT_FAILURE],
	    middlewareData: {
	      authRequired: true
	    },
	    apiRequest: function apiRequest(state, client) {
	      return _CommentsApi2.default.addComment({
	        metadataId: metadataId,
	        comment: comment,
	        userId: state.getIn(['auth', 'currentUserId'])
	      }, client);
	    }
	  };
	}
	
	function updateComment(_ref2) {
	  var metadataId = _ref2.metadataId,
	      commentId = _ref2.commentId,
	      comment = _ref2.comment,
	      postSuccess = _ref2.postSuccess;
	
	  return {
	    metadataId: metadataId,
	    commentId: commentId,
	    postSuccess: postSuccess,
	    types: [_CommentsConstants2.default.UPDATE_COMMENT_REQUEST, _CommentsConstants2.default.UPDATE_COMMENT_SUCCESS, _CommentsConstants2.default.UPDATE_COMMENT_FAILURE],
	    middlewareData: {
	      authRequired: true
	    },
	    apiRequest: function apiRequest(state, client) {
	      return _CommentsApi2.default.updateComment({
	        commentId: commentId,
	        comment: comment,
	        userId: state.getIn(['auth', 'currentUserId'])
	      }, client);
	    }
	  };
	}
	
	function removeComment(_ref3) {
	  var metadataId = _ref3.metadataId,
	      commentId = _ref3.commentId,
	      postSuccess = _ref3.postSuccess;
	
	  return {
	    metadataId: metadataId,
	    commentId: commentId,
	    postSuccess: postSuccess,
	    types: [_CommentsConstants2.default.REMOVE_COMMENT_REQUEST, _CommentsConstants2.default.REMOVE_COMMENT_SUCCESS, _CommentsConstants2.default.REMOVE_COMMENT_FAILURE],
	    middlewareData: {
	      authRequired: true
	    },
	    apiRequest: function apiRequest(state, client) {
	      return _CommentsApi2.default.removeComment({
	        commentId: commentId,
	        userId: state.getIn(['auth', 'currentUserId'])
	      }, client);
	    },
	    apiSuccess: function apiSuccess() {
	      return {
	        deletedEntities: ['ugc.comments.' + commentId]
	      };
	    }
	  };
	}
	
	exports.default = {
	  addComment: addComment,
	  updateComment: updateComment,
	  removeComment: removeComment
	};

/***/ },
/* 1579 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ErrorConstants = __webpack_require__(615);
	
	var _ErrorConstants2 = _interopRequireDefault(_ErrorConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Tell the reducer to store the notice ID in the redux store.
	 * @param  {object} error
	 * @return {object]}
	 */
	
	function storeInternalError() {
	  var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return {
	    type: _ErrorConstants2.default.STORE_INTERNAL_ERROR,
	    payload: {
	      error: error
	    }
	  };
	}
	
	exports.default = {
	  storeInternalError: storeInternalError
	};

/***/ },
/* 1580 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FeaturedContentApi = __webpack_require__(1605);
	
	var _FeaturedContentApi2 = _interopRequireDefault(_FeaturedContentApi);
	
	var _FeaturedContentConstants = __webpack_require__(616);
	
	var _FeaturedContentConstants2 = _interopRequireDefault(_FeaturedContentConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function fetch(results) {
	  return {
	    types: [_FeaturedContentConstants2.default.FEATURED_CONTENT_REQUEST, _FeaturedContentConstants2.default.FEATURED_CONTENT_SUCCESS, _FeaturedContentConstants2.default.FEATURED_CONTENT_FAILURE],
	    apiRequest: function apiRequest(state, client) {
	      return _FeaturedContentApi2.default.fetch(client, results);
	    }
	  };
	}
	
	exports.default = {
	  fetch: fetch
	};

/***/ },
/* 1581 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.collapseFeedbackBox = collapseFeedbackBox;
	exports.expandFeedbackBox = expandFeedbackBox;
	exports.updateCategory = updateCategory;
	exports.submitFeedback = submitFeedback;
	
	var _FeedbackConstants = __webpack_require__(617);
	
	var _FeedbackConstants2 = _interopRequireDefault(_FeedbackConstants);
	
	var _FeedbackApi = __webpack_require__(381);
	
	var _FeedbackApi2 = _interopRequireDefault(_FeedbackApi);
	
	var _composeSuccessMessaging = __webpack_require__(190);
	
	var _composeSuccessMessaging2 = _interopRequireDefault(_composeSuccessMessaging);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function collapseFeedbackBox() {
	  return {
	    type: _FeedbackConstants2.default.COLLAPSE_FEEDBACK
	  };
	}
	
	function expandFeedbackBox() {
	  return {
	    type: _FeedbackConstants2.default.EXPAND_FEEDBACK
	  };
	}
	
	function updateCategory(category) {
	  return {
	    type: _FeedbackConstants2.default.UPDATE_CATEGORY,
	    payload: category
	  };
	}
	
	function submitFeedback(feedback) {
	  return {
	    types: [_FeedbackConstants2.default.SUBMIT_FEEDBACK_REQUEST, _FeedbackConstants2.default.SUBMIT_FEEDBACK_SUCCESS, _FeedbackConstants2.default.SUBMIT_FEEDBACK_FAILURE],
	    apiRequest: function apiRequest(state, apiClient) {
	      return _FeedbackApi2.default.submitFeedback(feedback, apiClient);
	    },
	    apiSuccess: function apiSuccess() {
	      return {
	        messaging: (0, _composeSuccessMessaging2.default)('userFeedback', 'message_feedback_confirmed')
	      };
	    }
	  };
	}
	
	exports.default = {
	  collapseFeedbackBox: collapseFeedbackBox,
	  expandFeedbackBox: expandFeedbackBox,
	  updateCategory: updateCategory,
	  submitFeedback: submitFeedback
	};

/***/ },
/* 1582 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchTotalFines = fetchTotalFines;
	exports.fetchFines = fetchFines;
	exports.updatePage = updatePage;
	exports.fetchFinesPaymentForm = fetchFinesPaymentForm;
	
	var _FinesApi = __webpack_require__(1606);
	
	var _FinesApi2 = _interopRequireDefault(_FinesApi);
	
	var _FinesConstants = __webpack_require__(618);
	
	var _FinesConstants2 = _interopRequireDefault(_FinesConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function fetchTotalFines() {
	  return {
	    types: [_FinesConstants2.default.FETCH_FINES_REQUEST, _FinesConstants2.default.FETCH_FINES_SUCCESS, _FinesConstants2.default.FETCH_FINES_FAILURE],
	    middlewareData: {
	      accountRequired: (true)
	    },
	    apiRequest: function apiRequest(state, apiClient) {
	      return _FinesApi2.default.getFines(apiClient, '');
	    }
	  };
	}
	
	function fetchFines(query) {
	  return {
	    types: [_FinesConstants2.default.FETCH_FINES_REQUEST, _FinesConstants2.default.FETCH_FINES_SUCCESS, _FinesConstants2.default.FETCH_FINES_FAILURE],
	    middlewareData: {
	      accountRequired: (true)
	    },
	    apiRequest: function apiRequest(state, apiClient) {
	      return _FinesApi2.default.getFines(apiClient, query);
	    }
	  };
	}
	
	function updatePage(query) {
	  return {
	    types: [_FinesConstants2.default.UPDATE_PAGE_REQUEST, _FinesConstants2.default.UPDATE_PAGE_SUCCESS, _FinesConstants2.default.UPDATE_PAGE_FAILURE],
	    middlewareData: {
	      accountRequired: (true)
	    },
	    apiRequest: function apiRequest(state, apiClient) {
	      return _FinesApi2.default.getFines(apiClient, query);
	    }
	  };
	}
	
	function fetchFinesPaymentForm(query) {
	  return {
	    messagingId: 'finesNotice',
	    types: [_FinesConstants2.default.FETCH_FINES_PAYMENT_FORM_REQUEST, _FinesConstants2.default.FETCH_FINES_PAYMENT_FORM_SUCCESS, _FinesConstants2.default.FETCH_FINES_PAYMENT_FORM_FAILURE],
	    middlewareData: {
	      accountRequired: (true)
	    },
	    apiRequest: function apiRequest(state, apiClient) {
	      return _FinesApi2.default.getFinesPaymentForm(apiClient, query);
	    }
	  };
	}
	
	exports.default = {
	  fetchFines: fetchFines,
	  fetchTotalFines: fetchTotalFines
	};

/***/ },
/* 1583 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _IOwnThisApi = __webpack_require__(1608);
	
	var _IOwnThisApi2 = _interopRequireDefault(_IOwnThisApi);
	
	var _IOwnThisConstants = __webpack_require__(620);
	
	var _IOwnThisConstants2 = _interopRequireDefault(_IOwnThisConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createIOwnThisSetting(metadataId) {
	  return {
	    metadataId: metadataId,
	    types: [_IOwnThisConstants2.default.CREATE_I_OWN_THIS_SETTING_REQUEST, _IOwnThisConstants2.default.CREATE_I_OWN_THIS_SETTING_SUCCESS, _IOwnThisConstants2.default.CREATE_I_OWN_THIS_SETTING_FAILURE],
	    middlewareData: {
	      authRequired: true
	    },
	    apiRequest: function apiRequest(state, client) {
	      return _IOwnThisApi2.default.createIOwnThisSetting({
	        metadataId: metadataId,
	        userId: state.getIn(['auth', 'currentUserId'])
	      }, client);
	    }
	  };
	}
	
	function removeIOwnThisSetting(metadataId, ownerSettingId) {
	  return {
	    metadataId: metadataId,
	    ownerSettingId: ownerSettingId,
	    types: [_IOwnThisConstants2.default.REMOVE_I_OWN_THIS_SETTING_REQUEST, _IOwnThisConstants2.default.REMOVE_I_OWN_THIS_SETTING_SUCCESS, _IOwnThisConstants2.default.REMOVE_I_OWN_THIS_SETTING_FAILURE],
	    middlewareData: {
	      authRequired: true
	    },
	    apiRequest: function apiRequest(state, client) {
	      return _IOwnThisApi2.default.removeIOwnThisSetting({
	        ownerSettingId: ownerSettingId,
	        userId: state.getIn(['auth', 'currentUserId'])
	      }, client);
	    },
	    apiSuccess: function apiSuccess() {
	      return {
	        deletedEntities: ['ugc.iOwnThis.' + ownerSettingId]
	      };
	    }
	  };
	}
	
	exports.default = {
	  createIOwnThisSetting: createIOwnThisSetting,
	  removeIOwnThisSetting: removeIOwnThisSetting
	};

/***/ },
/* 1584 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchInterlibraryLoans = fetchInterlibraryLoans;
	
	var _InterlibraryLoansApi = __webpack_require__(1609);
	
	var _InterlibraryLoansApi2 = _interopRequireDefault(_InterlibraryLoansApi);
	
	var _InterlibraryLoansConstants = __webpack_require__(621);
	
	var _InterlibraryLoansConstants2 = _interopRequireDefault(_InterlibraryLoansConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function fetchInterlibraryLoans(query) {
	  return {
	    types: [_InterlibraryLoansConstants2.default.FETCH_ILL_REQUEST, _InterlibraryLoansConstants2.default.FETCH_ILL_SUCCESS, _InterlibraryLoansConstants2.default.FETCH_ILL_FAILURE],
	    middlewareData: {
	      accountRequired: true
	    },
	    apiRequest: function apiRequest(state, apiClient) {
	      return _InterlibraryLoansApi2.default.getInterlibraryLoans(apiClient, query);
	    }
	  };
	}
	
	exports.default = {
	  fetchInterlibraryLoans: fetchInterlibraryLoans
	};

/***/ },
/* 1585 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _LibraryApi = __webpack_require__(1610);
	
	var _LibraryApi2 = _interopRequireDefault(_LibraryApi);
	
	var _LibraryConstants = __webpack_require__(296);
	
	var _LibraryConstants2 = _interopRequireDefault(_LibraryConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getLibrary(locale) {
	  return {
	    types: [_LibraryConstants2.default.LIBRARY_REQUEST, _LibraryConstants2.default.LIBRARY_SUCCESS, _LibraryConstants2.default.LIBRARY_FAILURE],
	    apiRequest: function apiRequest(state, client) {
	      return _LibraryApi2.default.getLibrary(client, locale);
	    }
	  };
	}
	
	exports.default = {
	  getLibrary: getLibrary
	};

/***/ },
/* 1586 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.openFeedbackForm = openFeedbackForm;
	exports.closeFeedbackForm = closeFeedbackForm;
	exports.submitFeedback = submitFeedback;
	exports.optIn = optIn;
	exports.optOut = optOut;
	exports.dismissOptIn = dismissOptIn;
	exports.closeFeedbackSuccessMessage = closeFeedbackSuccessMessage;
	
	var _OptInApi = __webpack_require__(1612);
	
	var _OptInApi2 = _interopRequireDefault(_OptInApi);
	
	var _FeedbackApi = __webpack_require__(381);
	
	var _FeedbackApi2 = _interopRequireDefault(_FeedbackApi);
	
	var _OptInConstants = __webpack_require__(625);
	
	var _OptInConstants2 = _interopRequireDefault(_OptInConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function openFeedbackForm(bundle) {
	  return {
	    type: _OptInConstants2.default.TOGGLE_OPT_IN_FEEDBACK_FORM,
	    bundle: bundle,
	    payload: {
	      open: true
	    }
	  };
	}
	
	function closeFeedbackForm(bundle) {
	  return {
	    type: _OptInConstants2.default.TOGGLE_OPT_IN_FEEDBACK_FORM,
	    bundle: bundle,
	    payload: {
	      open: false
	    }
	  };
	}
	
	function submitFeedback(bundle, feedback) {
	  return {
	    bundle: bundle,
	    middlewareData: {
	      authRequired: true
	    },
	    types: [_OptInConstants2.default.SUBMIT_OPT_IN_FEEDBACK_REQUEST, _OptInConstants2.default.SUBMIT_OPT_IN_FEEDBACK_SUCCESS, _OptInConstants2.default.SUBMIT_OPT_IN_FEEDBACK_FAILURE],
	    apiRequest: function apiRequest(state, apiClient) {
	      return _FeedbackApi2.default.submitFeedback(feedback, apiClient);
	    }
	  };
	}
	
	function optIn(bundle) {
	  return {
	    bundle: bundle,
	    types: [_OptInConstants2.default.OPT_IN_REQUEST, _OptInConstants2.default.OPT_IN_SUCCESS, _OptInConstants2.default.OPT_IN_FAILURE],
	    apiRequest: function apiRequest(state, apiClient) {
	      return _OptInApi2.default.optIn(bundle, apiClient);
	    }
	  };
	}
	
	function optOut(bundle, currentLocation) {
	  return {
	    bundle: bundle,
	    types: [_OptInConstants2.default.OPT_OUT_REQUEST, _OptInConstants2.default.OPT_OUT_SUCCESS, _OptInConstants2.default.OPT_OUT_FAILURE],
	    apiRequest: function apiRequest(state, apiClient) {
	      return _OptInApi2.default.optOut(bundle, currentLocation, apiClient);
	    }
	  };
	}
	
	function dismissOptIn(bundle) {
	  return {
	    type: _OptInConstants2.default.DISMISS_OPT_IN,
	    payload: bundle
	  };
	}
	
	function closeFeedbackSuccessMessage(bundle) {
	  return {
	    type: _OptInConstants2.default.CLOSE_FEEDBACK_SUCCESS,
	    payload: bundle
	  };
	}
	
	exports.default = {
	  openFeedbackForm: openFeedbackForm,
	  closeFeedbackForm: closeFeedbackForm,
	  submitFeedback: submitFeedback,
	  optIn: optIn,
	  optOut: optOut,
	  dismissOptIn: dismissOptIn,
	  closeFeedbackSuccessMessage: closeFeedbackSuccessMessage
	};

/***/ },
/* 1587 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PrivateNotesApi = __webpack_require__(1613);
	
	var _PrivateNotesApi2 = _interopRequireDefault(_PrivateNotesApi);
	
	var _PrivateNotesConstants = __webpack_require__(626);
	
	var _PrivateNotesConstants2 = _interopRequireDefault(_PrivateNotesConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function addPrivateNote(_ref) {
	  var metadataId = _ref.metadataId,
	      note = _ref.note,
	      postSuccess = _ref.postSuccess;
	
	  return {
	    metadataId: metadataId,
	    postSuccess: postSuccess,
	    types: [_PrivateNotesConstants2.default.ADD_PRIVATE_NOTES_REQUEST, _PrivateNotesConstants2.default.ADD_PRIVATE_NOTES_SUCCESS, _PrivateNotesConstants2.default.ADD_PRIVATE_NOTES_FAILURE],
	    middlewareData: {
	      authRequired: true
	    },
	    apiRequest: function apiRequest(state, client) {
	      return _PrivateNotesApi2.default.addPrivateNote({
	        metadataId: metadataId,
	        note: note,
	        userId: state.getIn(['auth', 'currentUserId'])
	      }, client);
	    }
	  };
	}
	
	function updatePrivateNote(_ref2) {
	  var metadataId = _ref2.metadataId,
	      noteId = _ref2.noteId,
	      note = _ref2.note,
	      postSuccess = _ref2.postSuccess;
	
	  return {
	    metadataId: metadataId,
	    noteId: noteId,
	    postSuccess: postSuccess,
	    types: [_PrivateNotesConstants2.default.UPDATE_PRIVATE_NOTES_REQUEST, _PrivateNotesConstants2.default.UPDATE_PRIVATE_NOTES_SUCCESS, _PrivateNotesConstants2.default.UPDATE_PRIVATE_NOTES_FAILURE],
	    middlewareData: {
	      authRequired: true
	    },
	    apiRequest: function apiRequest(state, client) {
	      return _PrivateNotesApi2.default.updatePrivateNote({
	        noteId: noteId,
	        note: note,
	        userId: state.getIn(['auth', 'currentUserId'])
	      }, client);
	    }
	  };
	}
	
	function removePrivateNote(_ref3) {
	  var metadataId = _ref3.metadataId,
	      noteId = _ref3.noteId,
	      postSuccess = _ref3.postSuccess;
	
	  return {
	    metadataId: metadataId,
	    noteId: noteId,
	    postSuccess: postSuccess,
	    types: [_PrivateNotesConstants2.default.REMOVE_PRIVATE_NOTES_REQUEST, _PrivateNotesConstants2.default.REMOVE_PRIVATE_NOTES_SUCCESS, _PrivateNotesConstants2.default.REMOVE_PRIVATE_NOTES_FAILURE],
	    middlewareData: {
	      authRequired: true
	    },
	    apiRequest: function apiRequest(state, client) {
	      return _PrivateNotesApi2.default.removePrivateNote({
	        noteId: noteId,
	        userId: state.getIn(['auth', 'currentUserId'])
	      }, client);
	    },
	    apiSuccess: function apiSuccess() {
	      return {
	        deletedEntities: ['ugc.privateNotes.' + noteId]
	      };
	    }
	  };
	}
	
	exports.default = {
	  addPrivateNote: addPrivateNote,
	  updatePrivateNote: updatePrivateNote,
	  removePrivateNote: removePrivateNote
	};

/***/ },
/* 1588 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _QuotationsApi = __webpack_require__(1614);
	
	var _QuotationsApi2 = _interopRequireDefault(_QuotationsApi);
	
	var _QuotationsConstants = __webpack_require__(627);
	
	var _QuotationsConstants2 = _interopRequireDefault(_QuotationsConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function addQuotation(_ref) {
	  var metadataId = _ref.metadataId,
	      quotation = _ref.quotation,
	      postSuccess = _ref.postSuccess;
	
	  return {
	    metadataId: metadataId,
	    postSuccess: postSuccess,
	    types: [_QuotationsConstants2.default.ADD_QUOTATION_REQUEST, _QuotationsConstants2.default.ADD_QUOTATION_SUCCESS, _QuotationsConstants2.default.ADD_QUOTATION_FAILURE],
	    middlewareData: {
	      authRequired: true
	    },
	    apiRequest: function apiRequest(state, client) {
	      return _QuotationsApi2.default.addQuotation({
	        metadataId: metadataId,
	        quotation: quotation,
	        userId: state.getIn(['auth', 'currentUserId'])
	      }, client);
	    }
	  };
	}
	
	function updateQuotation(_ref2) {
	  var metadataId = _ref2.metadataId,
	      quotationId = _ref2.quotationId,
	      quotation = _ref2.quotation,
	      postSuccess = _ref2.postSuccess;
	
	  return {
	    metadataId: metadataId,
	    quotationId: quotationId,
	    postSuccess: postSuccess,
	    types: [_QuotationsConstants2.default.UPDATE_QUOTATION_REQUEST, _QuotationsConstants2.default.UPDATE_QUOTATION_SUCCESS, _QuotationsConstants2.default.UPDATE_QUOTATION_FAILURE],
	    middlewareData: {
	      authRequired: true
	    },
	    apiRequest: function apiRequest(state, client) {
	      return _QuotationsApi2.default.updateQuotation({
	        quotationId: quotationId,
	        quotation: quotation,
	        userId: state.getIn(['auth', 'currentUserId'])
	      }, client);
	    }
	  };
	}
	
	function removeQuotation(_ref3) {
	  var metadataId = _ref3.metadataId,
	      quotationId = _ref3.quotationId,
	      postSuccess = _ref3.postSuccess;
	
	  return {
	    metadataId: metadataId,
	    quotationId: quotationId,
	    postSuccess: postSuccess,
	    types: [_QuotationsConstants2.default.REMOVE_QUOTATION_REQUEST, _QuotationsConstants2.default.REMOVE_QUOTATION_SUCCESS, _QuotationsConstants2.default.REMOVE_QUOTATION_FAILURE],
	    middlewareData: {
	      authRequired: true
	    },
	    apiRequest: function apiRequest(state, client) {
	      return _QuotationsApi2.default.removeQuotation({
	        quotationId: quotationId,
	        userId: state.getIn(['auth', 'currentUserId'])
	      }, client);
	    },
	    apiSuccess: function apiSuccess() {
	      return {
	        deletedEntities: ['ugc.quotations.' + quotationId]
	      };
	    }
	  };
	}
	
	exports.default = {
	  addQuotation: addQuotation,
	  updateQuotation: updateQuotation,
	  removeQuotation: removeQuotation
	};

/***/ },
/* 1589 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.saveSearch = saveSearch;
	exports.replaceSearch = replaceSearch;
	exports.chooseNewName = chooseNewName;
	
	var _SavedSearchConstants = __webpack_require__(394);
	
	var _SavedSearchConstants2 = _interopRequireDefault(_SavedSearchConstants);
	
	var _SavedSearchApi = __webpack_require__(1618);
	
	var _SavedSearchApi2 = _interopRequireDefault(_SavedSearchApi);
	
	var _composeSuccessMessaging = __webpack_require__(190);
	
	var _composeSuccessMessaging2 = _interopRequireDefault(_composeSuccessMessaging);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function removeTitleFromQuery(query) {
	  return query.replace(/title=[^&]+/g, '');
	}
	
	function saveSearch(name, query) {
	  return {
	    types: [_SavedSearchConstants2.default.SAVE_REQUEST, _SavedSearchConstants2.default.SAVE_SUCCESS, _SavedSearchConstants2.default.SAVE_FAILURE],
	    payload: { name: name },
	    apiRequest: function apiRequest(state, apiClient) {
	      return _SavedSearchApi2.default.saveSearch(name, removeTitleFromQuery(query), apiClient);
	    },
	    apiSuccess: function apiSuccess() {
	      return {
	        messaging: (0, _composeSuccessMessaging2.default)('searchTitle', 'saved_search_success', { values: { search_name: name } })
	      };
	    },
	    apiFailure: function apiFailure() {
	      return {
	        messaging: null
	      };
	    }
	  };
	}
	
	function replaceSearch(query) {
	  return {
	    types: [_SavedSearchConstants2.default.SAVE_REQUEST, _SavedSearchConstants2.default.SAVE_SUCCESS, _SavedSearchConstants2.default.SAVE_FAILURE],
	    payload: { name: name },
	    apiRequest: function apiRequest(state, apiClient) {
	      return _SavedSearchApi2.default.replaceSearch(state.getIn(['ui', 'savedSearch', 'lastNameAttempt']), removeTitleFromQuery(query), state.getIn(['ui', 'savedSearch', 'duplicateSearchId']), apiClient);
	    }
	  };
	}
	
	function chooseNewName() {
	  return {
	    type: _SavedSearchConstants2.default.CHOOSE_NEW_NAME
	  };
	}
	
	exports.default = {
	  saveSearch: saveSearch,
	  replaceSearch: replaceSearch,
	  chooseNewName: chooseNewName
	};

/***/ },
/* 1590 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SimilarTitlesApi = __webpack_require__(1621);
	
	var _SimilarTitlesApi2 = _interopRequireDefault(_SimilarTitlesApi);
	
	var _SimilarTitlesConstants = __webpack_require__(631);
	
	var _SimilarTitlesConstants2 = _interopRequireDefault(_SimilarTitlesConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function addSimilarTitle(metadataId, similarMetadataId, postSuccess) {
	  return {
	    metadataId: metadataId,
	    similarMetadataId: similarMetadataId,
	    postSuccess: postSuccess,
	    types: [_SimilarTitlesConstants2.default.ADD_SIMILAR_TITLES_REQUEST, _SimilarTitlesConstants2.default.ADD_SIMILAR_TITLES_SUCCESS, _SimilarTitlesConstants2.default.ADD_SIMILAR_TITLES_FAILURE],
	    middlewareData: {
	      authRequired: true
	    },
	    apiRequest: function apiRequest(state, client) {
	      return _SimilarTitlesApi2.default.addSimilarTitle({
	        metadataId: metadataId,
	        similarMetadataId: similarMetadataId,
	        userId: state.getIn(['auth', 'currentUserId'])
	      }, client);
	    }
	  };
	}
	
	function removeSimilarTitle(metadataId, similarMetadataId) {
	  return {
	    metadataId: metadataId,
	    similarMetadataId: similarMetadataId,
	    types: [_SimilarTitlesConstants2.default.REMOVE_SIMILAR_TITLES_REQUEST, _SimilarTitlesConstants2.default.REMOVE_SIMILAR_TITLES_SUCCESS, _SimilarTitlesConstants2.default.REMOVE_SIMILAR_TITLES_FAILURE],
	    middlewareData: {
	      authRequired: true
	    },
	    apiRequest: function apiRequest(state, client) {
	      return _SimilarTitlesApi2.default.removeSimilarTitle({
	        similarMetadataId: similarMetadataId,
	        userId: state.getIn(['auth', 'currentUserId'])
	      }, client);
	    },
	    apiSuccess: function apiSuccess() {
	      return {
	        deletedEntities: ['ugc.similarTitles.' + similarMetadataId]
	      };
	    }
	  };
	}
	
	exports.default = {
	  addSimilarTitle: addSimilarTitle,
	  removeSimilarTitle: removeSimilarTitle
	};

/***/ },
/* 1591 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SystemMessagesApi = __webpack_require__(1623);
	
	var _SystemMessagesApi2 = _interopRequireDefault(_SystemMessagesApi);
	
	var _SystemMessageConstants = __webpack_require__(2055);
	
	var _SystemMessageConstants2 = _interopRequireDefault(_SystemMessageConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function fetchSystemMessages(priority) {
	  return {
	    types: [_SystemMessageConstants2.default.SYSTEM_MESSAGES_REQUEST, _SystemMessageConstants2.default.SYSTEM_MESSAGES_SUCCESS, _SystemMessageConstants2.default.SYSTEM_MESSAGES_ERROR],
	    apiRequest: function apiRequest(state, client) {
	      return _SystemMessagesApi2.default.fetchSystemMessages(state, client, priority);
	    }
	  };
	}
	
	function toggleMessage(id) {
	  return {
	    type: _SystemMessageConstants2.default.TOGGLE_SYSTEM_MESSAGE,
	    id: id
	  };
	}
	
	exports.default = {
	  fetchSystemMessages: fetchSystemMessages,
	  toggleMessage: toggleMessage
	};

/***/ },
/* 1592 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TagsApi = __webpack_require__(1624);
	
	var _TagsApi2 = _interopRequireDefault(_TagsApi);
	
	var _TagsConstants = __webpack_require__(242);
	
	var _TagsConstants2 = _interopRequireDefault(_TagsConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function addTag(metadataId, type, value) {
	  return {
	    metadataId: metadataId,
	    types: [_TagsConstants2.default.ADD_TAG_REQUEST, _TagsConstants2.default.ADD_TAG_SUCCESS, _TagsConstants2.default.ADD_TAG_FAILURE],
	    middlewareData: {
	      authRequired: true
	    },
	    apiRequest: function apiRequest(state, client) {
	      return _TagsApi2.default.addTag({
	        metadataId: metadataId,
	        type: type,
	        value: value,
	        userId: state.getIn(['auth', 'currentUserId'])
	      }, client);
	    }
	  };
	}
	
	function removeTag(metadataId, tagId, type) {
	  return {
	    metadataId: metadataId,
	    tagId: tagId,
	    types: [_TagsConstants2.default.REMOVE_TAG_REQUEST, _TagsConstants2.default.REMOVE_TAG_SUCCESS, _TagsConstants2.default.REMOVE_TAG_FAILURE],
	    middlewareData: {
	      authRequired: true
	    },
	    apiRequest: function apiRequest(state, client) {
	      return _TagsApi2.default.removeTag({
	        tagId: tagId,
	        userId: state.getIn(['auth', 'currentUserId']),
	        type: type
	      }, client);
	    },
	    apiSuccess: function apiSuccess() {
	      return {
	        deletedEntities: ['ugc.tags.' + tagId]
	      };
	    }
	  };
	}
	
	exports.default = {
	  addTag: addTag,
	  removeTag: removeTag
	};

/***/ },
/* 1593 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rxjs = __webpack_require__(169);
	
	var _UserApi = __webpack_require__(1625);
	
	var _UserApi2 = _interopRequireDefault(_UserApi);
	
	var _UserConstants = __webpack_require__(633);
	
	var _UserConstants2 = _interopRequireDefault(_UserConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function fetchUser(userId) {
	  return {
	    types: [_UserConstants2.default.FETCH_USER_REQUEST, _UserConstants2.default.FETCH_USER_SUCCESS, _UserConstants2.default.FETCH_USER_ERROR],
	    apiRequest: function apiRequest(state, client) {
	      if (!userId) {
	        return _rxjs.Observable.of({ user: null });
	      }
	
	      return _UserApi2.default.fetchUser({ userId: userId }, client);
	    }
	  };
	}
	
	exports.default = {
	  fetchUser: fetchUser
	};

/***/ },
/* 1594 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _VideosApi = __webpack_require__(1626);
	
	var _VideosApi2 = _interopRequireDefault(_VideosApi);
	
	var _VideosConstants = __webpack_require__(634);
	
	var _VideosConstants2 = _interopRequireDefault(_VideosConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function addVideo(_ref) {
	  var metadataId = _ref.metadataId,
	      url = _ref.url,
	      title = _ref.title,
	      description = _ref.description,
	      postSuccess = _ref.postSuccess;
	
	  return {
	    metadataId: metadataId,
	    postSuccess: postSuccess,
	    types: [_VideosConstants2.default.ADD_VIDEO_REQUEST, _VideosConstants2.default.ADD_VIDEO_SUCCESS, _VideosConstants2.default.ADD_VIDEO_FAILURE],
	    middlewareData: {
	      authRequired: true
	    },
	    apiRequest: function apiRequest(state, client) {
	      return _VideosApi2.default.addVideo({
	        metadataId: metadataId,
	        url: url,
	        title: title,
	        description: description,
	        userId: state.getIn(['auth', 'currentUserId'])
	      }, client);
	    }
	  };
	}
	
	function updateVideo(_ref2) {
	  var metadataId = _ref2.metadataId,
	      videoId = _ref2.videoId,
	      url = _ref2.url,
	      title = _ref2.title,
	      description = _ref2.description,
	      postSuccess = _ref2.postSuccess;
	
	  return {
	    metadataId: metadataId,
	    videoId: videoId,
	    postSuccess: postSuccess,
	    types: [_VideosConstants2.default.UPDATE_VIDEO_REQUEST, _VideosConstants2.default.UPDATE_VIDEO_SUCCESS, _VideosConstants2.default.UPDATE_VIDEO_FAILURE],
	    middlewareData: {
	      authRequired: true
	    },
	    apiRequest: function apiRequest(state, client) {
	      return _VideosApi2.default.updateVideo({
	        metadataId: metadataId,
	        videoId: videoId,
	        url: url,
	        title: title,
	        description: description,
	        userId: state.getIn(['auth', 'currentUserId'])
	      }, client);
	    }
	  };
	}
	
	function removeVideo(metadataId, videoId) {
	  return {
	    metadataId: metadataId,
	    videoId: videoId,
	    types: [_VideosConstants2.default.REMOVE_VIDEO_REQUEST, _VideosConstants2.default.REMOVE_VIDEO_SUCCESS, _VideosConstants2.default.REMOVE_VIDEO_FAILURE],
	    middlewareData: {
	      authRequired: true
	    },
	    apiRequest: function apiRequest(state, client) {
	      return _VideosApi2.default.removeVideo({
	        videoId: videoId,
	        userId: state.getIn(['auth', 'currentUserId'])
	      }, client);
	    },
	    apiSuccess: function apiSuccess() {
	      return {
	        deletedEntities: ['ugc.videos.' + videoId]
	      };
	    }
	  };
	}
	
	exports.default = {
	  addVideo: addVideo,
	  updateVideo: updateVideo,
	  removeVideo: removeVideo
	};

/***/ },
/* 1595 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _WidgetApi = __webpack_require__(1627);
	
	var _WidgetApi2 = _interopRequireDefault(_WidgetApi);
	
	var _WidgetConstants = __webpack_require__(2056);
	
	var _WidgetConstants2 = _interopRequireDefault(_WidgetConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function fetchItem(metadataId) {
	  return {
	    types: [_WidgetConstants2.default.FETCH_ITEM_REQUEST, _WidgetConstants2.default.FETCH_ITEM_SUCCESS, _WidgetConstants2.default.FETCH_ITEM_FAILURE],
	    apiRequest: function apiRequest(state, apiClient) {
	      return _WidgetApi2.default.fetchItem(metadataId, apiClient);
	    }
	  };
	}
	
	exports.default = {
	  fetchItem: fetchItem
	};

/***/ },
/* 1596 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['/libraries/', '/accounts/', '/settings/singleClickHolds'], ['/libraries/', '/accounts/', '/settings/singleClickHolds']),
	    _templateObject2 = _taggedTemplateLiteral(['/libraries/', '/accounts/', '/settings/borrowingHistorySetting'], ['/libraries/', '/accounts/', '/settings/borrowingHistorySetting']);
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	function updateSingleClickHoldsSettings(accountId, enabled, branchId, apiClient) {
	  var route = apiClient.route(_templateObject, ':librarySubdomain', accountId);
	  return apiClient.put(route, { enabled: enabled, branchId: branchId });
	}
	
	function updateBorrowingHistorySetting(accountId, enabled, apiClient) {
	  var route = apiClient.route(_templateObject2, ':librarySubdomain', accountId);
	  return apiClient.put(route, { enabled: enabled });
	}
	
	exports.default = {
	  updateSingleClickHoldsSettings: updateSingleClickHoldsSettings,
	  updateBorrowingHistorySetting: updateBorrowingHistorySetting
	};

/***/ },
/* 1597 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['/libraries/', '/analytics/dataLayer'], ['/libraries/', '/analytics/dataLayer']);
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	function fetchDataLayer(apiClient) {
	  var route = apiClient.route(_templateObject, ':librarySubdomain');
	  return apiClient.get(route);
	}
	
	exports.default = { fetchDataLayer: fetchDataLayer };

/***/ },
/* 1598 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _isEmpty = __webpack_require__(2935);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _querystring = __webpack_require__(2962);
	
	var _querystring2 = _interopRequireDefault(_querystring);
	
	var _utilsHttp = __webpack_require__(373);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var sub = function sub(val, substitutions) {
	  return substitutions[val] || val;
	};
	
	/**
	 * Client for the NERF API gateway. Implemented as a "universal/isomorphic"
	 * class that can be used on both server and browser.
	 *
	 * @property {string} apiGatewayURL      - Base URL of the API gateway
	 * @property {object} httpClient         - Module that the ApiClient will use to make HTTP requests.
	 *                                         According to APIClient's universal design, this can be
	                                           different for server and browser uses -- any library that
	                                           is API compatible with Superagent will do.
	 * @property {object} requestHeaders     - Custom headers to send (e.g. cookie, user-agent, x-forwarded-for, x-requested-with)
	 * @property {object} routeSubstitutions - Hash of template substitutions used in APIClient#route
	 * @property {string} routeSubstitutions[':librarySubdomain']
	 *
	 */
	
	var ApiClient = function () {
	  function ApiClient(librarySubdomain, apiGatewayURL, httpClient) {
	    var requestHeaders = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	    _classCallCheck(this, ApiClient);
	
	    Object.assign(this, {
	      apiGatewayURL: apiGatewayURL,
	      httpClient: httpClient,
	      requestHeaders: requestHeaders,
	      _server: !!(false),
	      _routeSubstitutions: {
	        ':librarySubdomain': librarySubdomain
	      }
	    });
	  }
	
	  /**
	   * It does the GET request on both client and server.
	   *
	   * @param  {string} path          - relative path (eg, '/search')
	   * @param  {Object} options       - additional request properties;
	                                      also see `getFullUrl()`
	   * @param {string} options.Accept - value of the Accept request header
	                                      (default: 'application/json')
	   */
	
	
	  _createClass(ApiClient, [{
	    key: 'get',
	    value: function get(path) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      return this._request('get', path, null, options);
	    }
	
	    /**
	     * It does the POST request on both client and server.
	     *
	     * @param  {string} path          - relative path (eg, '/search')
	     * @param  {Object} data          - data to be sent in the POST body
	     * @param  {Object} options       - additional request properties;
	                                        also see `getFullUrl()`
	     * @param {string} options.Accept - value of the Accept request header
	                                        (default: 'application/json')
	     */
	
	  }, {
	    key: 'post',
	    value: function post(path) {
	      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      return this._request('post', path, data, options);
	    }
	
	    /**
	     * It does the Patch request on both client and server.
	     *
	     * @param  {string} path          - relative path (eg, '/search')
	     * @param  {Object} data          - data to be sent in the PATCH body
	     * @param  {Object} options       - additional request properties; also see `getFullUrl()`
	     * @param   {string} options.Accept - value of the Accept request header
	                                          (default: 'application/json')
	     */
	
	  }, {
	    key: 'patch',
	    value: function patch(path) {
	      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      return this._request('patch', path, data, options);
	    }
	
	    /**
	     * It does the PUT request on both client and server.
	     *
	     * @param  {string} path          - relative path (eg, '/search')
	     * @param  {Object} data          - data to be sent in the PUT body
	     * @param  {Object} options       - additional request properties; also see `getFullUrl()`
	     * @param   {string} options.Accept - value of the Accept request header
	                                          (default: 'application/json')
	     */
	
	  }, {
	    key: 'put',
	    value: function put(path) {
	      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      return this._request('put', path, data, options);
	    }
	
	    /**
	     * It does the DELETE request on both client and server.
	     *
	     * @param  {string} path          - relative path (eg, '/search')
	     * @param  {Object} data          - data to be sent in the body
	     * @param  {Object} options       - additional request properties; also see `getFullUrl()`
	     * @param {string} options.Accept - value of the Accept request header
	                                        (default: 'application/json')
	     */
	
	  }, {
	    key: 'delete',
	    value: function _delete(path) {
	      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      return this._request('del', path, data, options);
	    }
	
	    /**
	     * Helper method for constructing full URL
	     *
	     * @param  {object} path   - base path of the URL like /search or /item/show
	     * @param  {object} options (destructured)
	     * @param  {string} options.params - the dynamic part of the path eg. /item/show/:id
	     *                    //TODO: CORE-33100 - Fixing Dynamic Params
	     * @param  {object} options.query  - Object which converts into query string
	     * @return {string}
	     */
	
	  }, {
	    key: 'getFullUrl',
	    value: function getFullUrl(path) {
	      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	          params = _ref.params,
	          query = _ref.query;
	
	      var queryStr = (0, _isEmpty2.default)(query) ? '' : '?' + _querystring2.default.stringify(query);
	      return '' + this.apiGatewayURL + (path || '') + (params || '') + queryStr;
	    }
	
	    /**
	     * Template tag function that builds a route string from a template
	     * literal, with support for "magic" substitution of contextual params.
	     *
	     * @see `ApiClient#routeSubstitutions`.
	     *
	     * @example
	     *   const apiClient = new ApiClient('opl', [other args]);
	     *   const bibId     = '12345';
	     *   const route     = apiClient.route `/libraries/${':libraryDomain'}/bibs/${someBibId}`;
	     *   console.info(route); // '/libraries/opl/bibs/12345'
	     *
	     * @implements {TagFunction}
	     * @return {string} the interpolated path
	     */
	
	  }, {
	    key: 'route',
	    value: function route(segments) {
	      var _this = this;
	
	      var path = segments[0];
	      // Build the path, inserting route substitutions where needed
	
	      for (var _len = arguments.length, values = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        values[_key - 1] = arguments[_key];
	      }
	
	      values.forEach(function (val, i) {
	        path += sub(val, _this._routeSubstitutions) + segments[i + 1];
	      });
	      return path;
	    }
	
	    /**
	     * Makes a request to the API
	     * @param  {string} method  HTTP method
	     * @param  {string} path    relative path of API endpoint
	     * @param  {object} options
	     * @return {Promise}        Promise which will resolve / reject based of status of request
	     */
	
	  }, {
	    key: '_request',
	    value: function _request(method, path) {
	      var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	      var options = arguments[3];
	
	      var client = this.httpClient[method](this.getFullUrl(path, options)).set('Accept', options.Accept || 'application/json');
	
	      if (data) client.send(data);
	      if (!this._server) client.withCredentials();
	      if (this._server) {
	        if (this.requestHeaders.cookie) {
	          client.set('Cookie', this.requestHeaders.cookie);
	        }
	        if (this.requestHeaders['x-forwarded-for']) {
	          client.set('X-Forwarded-For', this.requestHeaders['x-forwarded-for']);
	        }
	
	        if (this.requestHeaders['x-forwarded-with']) {
	          client.set('X-Requested-With', this.requestHeaders['x-forwarded-with']);
	        }
	
	        if (this.requestHeaders['user-agent']) {
	          client.set('User-Agent', this.requestHeaders['user-agent']);
	        }
	
	        if (this.requestHeaders.referer) {
	          client.set('Referer', this.requestHeaders.referer);
	        }
	      }
	
	      return (0, _utilsHttp.superagentToObservable)(client);
	    }
	  }]);
	
	  return ApiClient;
	}();
	
	exports.default = ApiClient;

/***/ },
/* 1599 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['/libraries/', '/sessions/current'], ['/libraries/', '/sessions/current']),
	    _templateObject2 = _taggedTemplateLiteral(['/libraries/', '/sessions'], ['/libraries/', '/sessions']);
	
	var _rxjs = __webpack_require__(169);
	
	var _superagent = __webpack_require__(270);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); } /**
	                                                                                                                                                   * This class calls Api Gateway to fetch Authentication information.
	                                                                                                                                                   * We pass down all the cookies to API gateway including Auth Token.
	                                                                                                                                                   * API Gateway communicates with BCRest to fetch Auth info
	                                                                                                                                                   */
	
	/**
	 * Loads common user info
	 *
	 * @param  {object} - ApiClient - this is a stateful client which knows about the baseAPiURL passed down.
	 * @return {promise}
	 */
	function loadUser(apiClient) {
	  var route = apiClient.route(_templateObject, ':librarySubdomain');
	  return apiClient.get(route);
	}
	
	function login(username, password, apiClient) {
	  var route = apiClient.route(_templateObject2, ':librarySubdomain');
	  var data = { username: username, password: password };
	
	  return apiClient.post(route, data).mergeMap(function (auth) {
	    var isValidSsoUrl = auth.ssoUrl && auth.ssoUrl.indexOf('https') === 0;
	
	    if (isValidSsoUrl) {
	      // We don't care about the result of the SSO request.
	      // It shouldn't affect the user from logging on our end
	      _superagent2.default.get(auth.ssoUrl).withCredentials().end();
	    }
	
	    return _rxjs.Observable.of(auth);
	  });
	}
	
	exports.default = {
	  loadUser: loadUser,
	  login: login
	};

/***/ },
/* 1600 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['/libraries/', '/availability/', ''], ['/libraries/', '/availability/', '']),
	    _templateObject2 = _taggedTemplateLiteral(['/libraries/', '/bibs/holdings/probes/', ''], ['/libraries/', '/bibs/holdings/probes/', '']);
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	function fetchResults(id, locale, apiClient) {
	  var route = apiClient.route(_templateObject, ':librarySubdomain', id);
	  return apiClient.get(route, { query: { locale: locale } });
	}
	
	function fetchHoldingsProbes(id, apiClient) {
	  var route = apiClient.route(_templateObject2, ':librarySubdomain', id);
	  return apiClient.get(route);
	}
	
	exports.default = {
	  fetchResults: fetchResults,
	  fetchHoldingsProbes: fetchHoldingsProbes
	};

/***/ },
/* 1601 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['/libraries/', '/borrowing/summaries'], ['/libraries/', '/borrowing/summaries']);
	
	exports.getBorrowingSummaries = getBorrowingSummaries;
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	function getBorrowingSummaries(apiClient, params) {
	  var route = apiClient.route(_templateObject, ':librarySubdomain');
	  return apiClient.get(route, { query: params });
	}
	
	exports.default = {
	  getBorrowingSummaries: getBorrowingSummaries
	};

/***/ },
/* 1602 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['/libraries/', '/bibs/digital_formats/', '/', ''], ['/libraries/', '/bibs/digital_formats/', '/', '']),
	    _templateObject2 = _taggedTemplateLiteral(['/libraries/', '/checkouts'], ['/libraries/', '/checkouts']),
	    _templateObject3 = _taggedTemplateLiteral(['/libraries/', '/checkouts/', ''], ['/libraries/', '/checkouts/', '']);
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	function fetchDigitalFormats(_ref, apiClient) {
	  var metadataId = _ref.metadataId,
	      libraryId = _ref.libraryId;
	
	  var route = apiClient.route(_templateObject, ':librarySubdomain', libraryId, metadataId);
	  return apiClient.get(route);
	}
	
	function digitalCheckout(_ref2, apiClient) {
	  var metadataId = _ref2.metadataId,
	      accountId = _ref2.accountId,
	      _ref2$format = _ref2.format,
	      format = _ref2$format === undefined ? null : _ref2$format,
	      _ref2$duration = _ref2.duration,
	      duration = _ref2$duration === undefined ? null : _ref2$duration;
	
	  var route = apiClient.route(_templateObject2, ':librarySubdomain');
	  return apiClient.post(route, {
	    metadataId: metadataId,
	    accountId: accountId,
	    format: format,
	    duration: duration
	  });
	}
	
	function lockInDigitalFormat(_ref3, apiClient) {
	  var metadataId = _ref3.metadataId,
	      accountId = _ref3.accountId,
	      checkoutId = _ref3.checkoutId,
	      format = _ref3.format;
	
	  var route = apiClient.route(_templateObject3, ':librarySubdomain', checkoutId);
	  return apiClient.put(route, {
	    metadataId: metadataId,
	    accountId: accountId,
	    format: format
	  });
	}
	
	function checkInDigitalBib(_ref4, apiClient) {
	  var metadataId = _ref4.metadataId,
	      checkoutId = _ref4.checkoutId,
	      accountId = _ref4.accountId;
	
	  var route = apiClient.route(_templateObject3, ':librarySubdomain', checkoutId);
	  return apiClient.delete(route, {
	    metadataId: metadataId,
	    accountId: accountId
	  });
	}
	
	function getCheckouts(query, apiClient) {
	  var route = apiClient.route(_templateObject2, ':librarySubdomain');
	  return apiClient.get(route, { query: query });
	}
	
	function renewCheckouts(_ref5, apiClient) {
	  var checkoutIds = _ref5.checkoutIds,
	      messagingId = _ref5.messagingId,
	      accountId = _ref5.accountId;
	
	  var route = apiClient.route(_templateObject2, ':librarySubdomain');
	  return apiClient.patch(route, { messagingId: messagingId, accountId: accountId, checkoutIds: checkoutIds, renew: true });
	}
	
	exports.default = {
	  fetchDigitalFormats: fetchDigitalFormats,
	  digitalCheckout: digitalCheckout,
	  lockInDigitalFormat: lockInDigitalFormat,
	  checkInDigitalBib: checkInDigitalBib,
	  getCheckouts: getCheckouts,
	  renewCheckouts: renewCheckouts
	};

/***/ },
/* 1603 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['/libraries/', '/ugc/comments'], ['/libraries/', '/ugc/comments']),
	    _templateObject2 = _taggedTemplateLiteral(['/libraries/', '/ugc/comments/', ''], ['/libraries/', '/ugc/comments/', '']);
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	function addComment(_ref, apiClient) {
	  var userId = _ref.userId,
	      metadataId = _ref.metadataId,
	      comment = _ref.comment;
	
	  var route = apiClient.route(_templateObject, ':librarySubdomain');
	  return apiClient.post(route, { userId: userId, metadataId: metadataId, comment: comment });
	}
	
	function updateComment(_ref2, apiClient) {
	  var userId = _ref2.userId,
	      commentId = _ref2.commentId,
	      comment = _ref2.comment;
	
	  var route = apiClient.route(_templateObject2, ':librarySubdomain', commentId);
	  return apiClient.patch(route, { userId: userId, comment: comment });
	}
	
	function removeComment(_ref3, apiClient) {
	  var userId = _ref3.userId,
	      commentId = _ref3.commentId;
	
	  var route = apiClient.route(_templateObject2, ':librarySubdomain', commentId);
	  return apiClient.delete(route, { userId: userId });
	}
	
	exports.default = {
	  addComment: addComment,
	  updateComment: updateComment,
	  removeComment: removeComment
	};

/***/ },
/* 1604 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(["/featureFlags/", ""], ["/featureFlags/", ""]);
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	function updateFlag(flag, value, apiClient) {
	  var route = apiClient.route(_templateObject, flag);
	  return apiClient.patch(route, { enabled: value });
	}
	
	exports.default = { updateFlag: updateFlag };

/***/ },
/* 1605 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['/libraries/', '/featuredContent'], ['/libraries/', '/featuredContent']);
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	// Fetch Featured Content for a given set of metadataIds
	function fetch(apiClient, results) {
	  var route = apiClient.route(_templateObject, ':librarySubdomain');
	  return apiClient.get(route, { query: { metadataIds: results.toArray() } });
	}
	
	exports.default = { fetch: fetch };

/***/ },
/* 1606 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['/libraries/', '/fines'], ['/libraries/', '/fines']),
	    _templateObject2 = _taggedTemplateLiteral(['/libraries/', '/fines/getPaymentForm'], ['/libraries/', '/fines/getPaymentForm']);
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	function getFines(apiClient, params) {
	  var route = apiClient.route(_templateObject, ':librarySubdomain');
	  return apiClient.get(route, { query: params });
	}
	
	function getFinesPaymentForm(apiClient, params) {
	  var route = apiClient.route(_templateObject2, ':librarySubdomain');
	  return apiClient.get(route, { query: params });
	}
	
	exports.default = {
	  getFines: getFines,
	  getFinesPaymentForm: getFinesPaymentForm
	};

/***/ },
/* 1607 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['/libraries/', '/holds'], ['/libraries/', '/holds']),
	    _templateObject2 = _taggedTemplateLiteral(['/libraries/', '/bibs/item_groups/', ''], ['/libraries/', '/bibs/item_groups/', '']);
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	function placeHold(data, apiClient) {
	  var route = apiClient.route(_templateObject, ':librarySubdomain');
	  return apiClient.post(route, data);
	}
	
	function cancelHold(data, apiClient) {
	  var route = apiClient.route(_templateObject, ':librarySubdomain');
	  return apiClient.delete(route, data);
	}
	
	function fetchItemGroups(metadataId, apiClient) {
	  var route = apiClient.route(_templateObject2, ':librarySubdomain', metadataId);
	  return apiClient.get(route);
	}
	
	function getHolds(query, apiClient) {
	  var route = apiClient.route(_templateObject, ':librarySubdomain');
	  return apiClient.get(route, { query: query });
	}
	
	function updateHolds(_ref, apiClient) {
	  var holdIds = _ref.holdIds,
	      messagingId = _ref.messagingId,
	      accountId = _ref.accountId,
	      suspended = _ref.suspended,
	      expiryDate = _ref.expiryDate,
	      location = _ref.location;
	
	  var route = apiClient.route(_templateObject, ':librarySubdomain');
	  return apiClient.patch(route, { holdIds: holdIds, messagingId: messagingId, accountId: accountId, suspended: suspended, location: location, expiryDate: expiryDate });
	}
	
	exports.default = {
	  placeHold: placeHold,
	  cancelHold: cancelHold,
	  fetchItemGroups: fetchItemGroups,
	  getHolds: getHolds,
	  updateHolds: updateHolds
	};

/***/ },
/* 1608 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['/libraries/', '/ugc/iownthis'], ['/libraries/', '/ugc/iownthis']),
	    _templateObject2 = _taggedTemplateLiteral(['/libraries/', '/ugc/iownthis/', ''], ['/libraries/', '/ugc/iownthis/', '']);
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	function createIOwnThisSetting(_ref, apiClient) {
	  var userId = _ref.userId,
	      metadataId = _ref.metadataId;
	
	  var route = apiClient.route(_templateObject, ':librarySubdomain');
	  return apiClient.post(route, { userId: userId, metadataId: metadataId });
	}
	
	function removeIOwnThisSetting(_ref2, apiClient) {
	  var userId = _ref2.userId,
	      ownerSettingId = _ref2.ownerSettingId;
	
	  var route = apiClient.route(_templateObject2, ':librarySubdomain', ownerSettingId);
	  return apiClient.delete(route, { userId: userId });
	}
	
	exports.default = {
	  createIOwnThisSetting: createIOwnThisSetting,
	  removeIOwnThisSetting: removeIOwnThisSetting
	};

/***/ },
/* 1609 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['/libraries/', '/interlibraryloans'], ['/libraries/', '/interlibraryloans']);
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	function getInterlibraryLoans(apiClient, params) {
	  var route = apiClient.route(_templateObject, ':librarySubdomain');
	  return apiClient.get(route, { query: params });
	}
	
	exports.default = {
	  getInterlibraryLoans: getInterlibraryLoans
	};

/***/ },
/* 1610 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['/libraries/', ''], ['/libraries/', '']);
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	function getLibrary(apiClient, locale) {
	  var route = apiClient.route(_templateObject, ':librarySubdomain');
	  return apiClient.get(route, { query: { locale: locale } });
	}
	
	exports.default = { getLibrary: getLibrary };

/***/ },
/* 1611 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['/libraries/', '/messages'], ['/libraries/', '/messages']);
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	function getMessages(_ref, apiClient) {
	  var accountId = _ref.accountId;
	
	  var route = apiClient.route(_templateObject, ':librarySubdomain');
	  return apiClient.get(route, { query: { accountId: accountId } });
	}
	
	exports.default = {
	  getMessages: getMessages
	};

/***/ },
/* 1612 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['/libraries/', '/optIn/', ''], ['/libraries/', '/optIn/', '']);
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	function optIn(bundle, apiClient) {
	  var route = apiClient.route(_templateObject, ':librarySubdomain', bundle);
	  return apiClient.post(route);
	}
	
	function optOut(bundle, currentLocation, apiClient) {
	  var route = apiClient.route(_templateObject, ':librarySubdomain', bundle);
	  return apiClient.delete(route, { currentLocation: currentLocation });
	}
	
	exports.default = {
	  optIn: optIn,
	  optOut: optOut
	};

/***/ },
/* 1613 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['/libraries/', '/ugc/privatenotes'], ['/libraries/', '/ugc/privatenotes']),
	    _templateObject2 = _taggedTemplateLiteral(['/libraries/', '/ugc/privatenotes/', ''], ['/libraries/', '/ugc/privatenotes/', '']);
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	function addPrivateNote(_ref, apiClient) {
	  var userId = _ref.userId,
	      metadataId = _ref.metadataId,
	      note = _ref.note;
	
	  var route = apiClient.route(_templateObject, ':librarySubdomain');
	  return apiClient.post(route, { userId: userId, metadataId: metadataId, note: note });
	}
	
	function updatePrivateNote(_ref2, apiClient) {
	  var userId = _ref2.userId,
	      noteId = _ref2.noteId,
	      note = _ref2.note;
	
	  var route = apiClient.route(_templateObject2, ':librarySubdomain', noteId);
	  return apiClient.patch(route, { userId: userId, note: note });
	}
	
	function removePrivateNote(_ref3, apiClient) {
	  var userId = _ref3.userId,
	      noteId = _ref3.noteId;
	
	  var route = apiClient.route(_templateObject2, ':librarySubdomain', noteId);
	  return apiClient.delete(route, { userId: userId });
	}
	
	exports.default = {
	  addPrivateNote: addPrivateNote,
	  updatePrivateNote: updatePrivateNote,
	  removePrivateNote: removePrivateNote
	};

/***/ },
/* 1614 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['/libraries/', '/ugc/quotations'], ['/libraries/', '/ugc/quotations']),
	    _templateObject2 = _taggedTemplateLiteral(['/libraries/', '/ugc/quotations/', ''], ['/libraries/', '/ugc/quotations/', '']);
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	function addQuotation(_ref, apiClient) {
	  var userId = _ref.userId,
	      metadataId = _ref.metadataId,
	      quotation = _ref.quotation;
	
	  var route = apiClient.route(_templateObject, ':librarySubdomain');
	  return apiClient.post(route, { userId: userId, metadataId: metadataId, quotation: quotation });
	}
	
	function updateQuotation(_ref2, apiClient) {
	  var userId = _ref2.userId,
	      metadataId = _ref2.metadataId,
	      quotationId = _ref2.quotationId,
	      quotation = _ref2.quotation;
	
	  var route = apiClient.route(_templateObject2, ':librarySubdomain', quotationId);
	  return apiClient.patch(route, { userId: userId, quotation: quotation });
	}
	
	function removeQuotation(_ref3, apiClient) {
	  var userId = _ref3.userId,
	      quotationId = _ref3.quotationId;
	
	  var route = apiClient.route(_templateObject2, ':librarySubdomain', quotationId);
	  return apiClient.delete(route, { userId: userId });
	}
	
	exports.default = {
	  addQuotation: addQuotation,
	  updateQuotation: updateQuotation,
	  removeQuotation: removeQuotation
	};

/***/ },
/* 1615 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['/libraries/', '/ugc/ratings'], ['/libraries/', '/ugc/ratings']),
	    _templateObject2 = _taggedTemplateLiteral(['/libraries/', '/ugc/ratings/', ''], ['/libraries/', '/ugc/ratings/', '']);
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	function getItemRatings(_ref, apiClient) {
	  var metadataIds = _ref.metadataIds;
	
	  var route = apiClient.route(_templateObject, ':librarySubdomain');
	  return apiClient.get(route, { query: { metadataIds: metadataIds } });
	}
	
	function rateItem(_ref2, apiClient) {
	  var metadataId = _ref2.metadataId,
	      rating = _ref2.rating;
	
	  var route = apiClient.route(_templateObject2, ':librarySubdomain', metadataId);
	  return apiClient.post(route, { metadataId: metadataId, rating: rating });
	}
	
	function changeItemRating(_ref3, apiClient) {
	  var metadataId = _ref3.metadataId,
	      rating = _ref3.rating;
	
	  var route = apiClient.route(_templateObject2, ':librarySubdomain', metadataId);
	  return apiClient.patch(route, { metadataId: metadataId, rating: rating });
	}
	
	function removeItemRating(_ref4, apiClient) {
	  var metadataId = _ref4.metadataId;
	
	  var route = apiClient.route(_templateObject2, ':librarySubdomain', metadataId);
	  return apiClient.delete(route);
	}
	
	exports.default = {
	  getItemRatings: getItemRatings,
	  rateItem: rateItem,
	  changeItemRating: changeItemRating,
	  removeItemRating: removeItemRating
	};

/***/ },
/* 1616 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['/libraries/', '/borrowinghistory'], ['/libraries/', '/borrowinghistory']);
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	function getRecentlyReturned(apiClient, params) {
	  var route = apiClient.route(_templateObject, ':librarySubdomain');
	  return apiClient.get(route, { query: params });
	}
	
	exports.default = {
	  getRecentlyReturned: getRecentlyReturned
	};

/***/ },
/* 1617 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['/libraries/', '/bibs/', '/recommendations/'], ['/libraries/', '/bibs/', '/recommendations/']);
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	function fetchRecommendations(id, apiClient) {
	  var route = apiClient.route(_templateObject, ':librarySubdomain', id);
	  return apiClient.get(route);
	}
	
	exports.default = {
	  fetchRecommendations: fetchRecommendations
	};

/***/ },
/* 1618 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['/libraries/', '/savedsearch'], ['/libraries/', '/savedsearch']),
	    _templateObject2 = _taggedTemplateLiteral(['/libraries/', '/savedsearch/', ''], ['/libraries/', '/savedsearch/', '']);
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	function saveSearch(name, query, apiClient) {
	  var route = apiClient.route(_templateObject, ':librarySubdomain');
	  return apiClient.post(route, { name: name, query: query });
	}
	
	function replaceSearch(name, query, searchId, apiClient) {
	  var route = apiClient.route(_templateObject2, ':librarySubdomain', searchId);
	  return apiClient.patch(route, { name: name, query: query });
	}
	
	exports.default = {
	  saveSearch: saveSearch,
	  replaceSearch: replaceSearch
	};

/***/ },
/* 1619 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['/libraries/', '/bibs/search'], ['/libraries/', '/bibs/search']),
	    _templateObject2 = _taggedTemplateLiteral(['/libraries/', '/bibs/search/fields/', '/filters'], ['/libraries/', '/bibs/search/fields/', '/filters']),
	    _templateObject3 = _taggedTemplateLiteral(['/libraries/', '/bibs/search/probes'], ['/libraries/', '/bibs/search/probes']),
	    _templateObject4 = _taggedTemplateLiteral(['/libraries/', '/bibs/search/groupSearchSummaries'], ['/libraries/', '/bibs/search/groupSearchSummaries']);
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	function fetchResults(query, apiClient) {
	  var route = apiClient.route(_templateObject, ':librarySubdomain');
	  return apiClient.get(route, { query: query });
	}
	
	function fetchAdditionalFilters(query, fieldId, apiClient) {
	  var route = apiClient.route(_templateObject2, ':librarySubdomain', fieldId);
	  return apiClient.get(route, { query: query });
	}
	
	function fetchSearchProbes(query, searchType, apiClient) {
	  var route = apiClient.route(_templateObject3, ':librarySubdomain');
	  return apiClient.get(route, { query: { query: query, searchType: searchType } });
	}
	
	function fetchGroupSearchSummaries(metadataIds, libraryId, apiClient) {
	  var route = apiClient.route(_templateObject4, ':librarySubdomain');
	  return apiClient.get(route, { query: { metadataIds: metadataIds, libraryId: libraryId } });
	}
	
	exports.default = {
	  fetchAdditionalFilters: fetchAdditionalFilters,
	  fetchResults: fetchResults,
	  fetchSearchProbes: fetchSearchProbes,
	  fetchGroupSearchSummaries: fetchGroupSearchSummaries
	};

/***/ },
/* 1620 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['/libraries/', '/shelves/'], ['/libraries/', '/shelves/']),
	    _templateObject2 = _taggedTemplateLiteral(['/libraries/', '/shelves/', ''], ['/libraries/', '/shelves/', '']),
	    _templateObject3 = _taggedTemplateLiteral(['/libraries/', '/shelves/', '/fields/', ''], ['/libraries/', '/shelves/', '/fields/', '']),
	    _templateObject4 = _taggedTemplateLiteral(['/libraries/', '/shelves/', '/', ''], ['/libraries/', '/shelves/', '/', '']),
	    _templateObject5 = _taggedTemplateLiteral(['/libraries/', '/shelves/', '/items'], ['/libraries/', '/shelves/', '/items']),
	    _templateObject6 = _taggedTemplateLiteral(['/libraries/', '/shelves/', '/import'], ['/libraries/', '/shelves/', '/import']);
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	function addToShelf(data, apiClient) {
	  var route = apiClient.route(_templateObject, ':librarySubdomain');
	  return apiClient.post(route, data);
	}
	
	function removeFromShelf(_ref, apiClient) {
	  var shelfName = _ref.shelfName,
	      data = _objectWithoutProperties(_ref, ['shelfName']);
	
	  var route = apiClient.route(_templateObject2, ':librarySubdomain', shelfName);
	  return apiClient.delete(route, data);
	}
	
	function searchUserShelf(_ref2, apiClient) {
	  var shelfName = _ref2.shelfName,
	      query = _objectWithoutProperties(_ref2, ['shelfName']);
	
	  var route = apiClient.route(_templateObject2, ':librarySubdomain', shelfName);
	  return apiClient.get(route, { query: query });
	}
	
	function fetchAdditionalFilters(_ref3, apiClient) {
	  var shelfName = _ref3.shelfName,
	      fieldId = _ref3.fieldId,
	      query = _objectWithoutProperties(_ref3, ['shelfName', 'fieldId']);
	
	  var route = apiClient.route(_templateObject3, ':librarySubdomain', shelfName, fieldId);
	  return apiClient.get(route, { query: query });
	}
	
	// TODO SHEL-191: remove this depricated call
	function updateShelfItem(_ref4, apiClient) {
	  var shelfItemId = _ref4.shelfItemId,
	      shelfName = _ref4.shelfName,
	      data = _objectWithoutProperties(_ref4, ['shelfItemId', 'shelfName']);
	
	  var route = apiClient.route(_templateObject4, ':librarySubdomain', shelfName, shelfItemId);
	  return apiClient.patch(route, data);
	}
	
	function updateShelfItems(_ref5, apiClient) {
	  var shelfName = _ref5.shelfName,
	      newShelfName = _ref5.newShelfName,
	      privateItem = _ref5.privateItem,
	      metadataIds = _ref5.metadataIds,
	      shelfItemIds = _ref5.shelfItemIds;
	
	  var route = apiClient.route(_templateObject5, ':librarySubdomain', shelfName);
	  return apiClient.patch(route, { newShelfName: newShelfName, privateItem: privateItem, metadataIds: metadataIds, shelfItemIds: shelfItemIds });
	}
	
	function importILSBibs(shelfName, accountId, apiClient) {
	  var route = apiClient.route(_templateObject6, ':librarySubdomain', shelfName);
	  return apiClient.post(route, { accountId: accountId });
	}
	
	exports.default = {
	  addToShelf: addToShelf,
	  removeFromShelf: removeFromShelf,
	  searchUserShelf: searchUserShelf,
	  fetchAdditionalFilters: fetchAdditionalFilters,
	  updateShelfItem: updateShelfItem,
	  updateShelfItems: updateShelfItems,
	  importILSBibs: importILSBibs
	};

/***/ },
/* 1621 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['/libraries/', '/ugc/similartitles'], ['/libraries/', '/ugc/similartitles']),
	    _templateObject2 = _taggedTemplateLiteral(['/libraries/', '/ugc/similartitles/', ''], ['/libraries/', '/ugc/similartitles/', '']);
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	function addSimilarTitle(_ref, apiClient) {
	  var userId = _ref.userId,
	      metadataId = _ref.metadataId,
	      similarMetadataId = _ref.similarMetadataId;
	
	  var route = apiClient.route(_templateObject, ':librarySubdomain');
	  return apiClient.post(route, { userId: userId, metadataId: metadataId, similarMetadataId: similarMetadataId });
	}
	
	function removeSimilarTitle(_ref2, apiClient) {
	  var userId = _ref2.userId,
	      similarMetadataId = _ref2.similarMetadataId;
	
	  var route = apiClient.route(_templateObject2, ':librarySubdomain', similarMetadataId);
	  return apiClient.delete(route, { userId: userId });
	}
	
	exports.default = {
	  addSimilarTitle: addSimilarTitle,
	  removeSimilarTitle: removeSimilarTitle
	};

/***/ },
/* 1622 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utilsHttp = __webpack_require__(373);
	
	/**
	 * Fetch map data from StackMap
	 * @param {string} domain
	 * @param {object} data
	 * @param {string} data.library - Branch name
	 * @param {string} data.location - Collection
	 * @param {string} data.callno - Call Numbers
	 * @returns {Observable}
	 */
	function fetchMap(domain, data) {
	  var queryString = (0, _utilsHttp.createQueryString)(data);
	  var url = 'https://' + domain + '.stackmap.com/json/?' + queryString + '&callback=';
	  return (0, _utilsHttp.jsonp)(url);
	} /**
	   * API to interact with StackMap
	   */
	
	exports.default = {
	  fetchMap: fetchMap
	};

/***/ },
/* 1623 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['/libraries/', '/systemMessages'], ['/libraries/', '/systemMessages']);
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	function fetchSystemMessages(data, apiClient, priority) {
	  var route = apiClient.route(_templateObject, ':librarySubdomain');
	  return apiClient.get(route, { query: { priority: priority } });
	}
	
	exports.default = {
	  fetchSystemMessages: fetchSystemMessages
	};

/***/ },
/* 1624 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['/libraries/', '/ugc/tags'], ['/libraries/', '/ugc/tags']),
	    _templateObject2 = _taggedTemplateLiteral(['/libraries/', '/ugc/tags/', ''], ['/libraries/', '/ugc/tags/', '']);
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	function addTag(_ref, apiClient) {
	  var userId = _ref.userId,
	      metadataId = _ref.metadataId,
	      type = _ref.type,
	      value = _ref.value;
	
	  var route = apiClient.route(_templateObject, ':librarySubdomain');
	  return apiClient.post(route, { userId: userId, metadataId: metadataId, type: type, value: value });
	}
	
	function removeTag(_ref2, apiClient) {
	  var userId = _ref2.userId,
	      tagId = _ref2.tagId,
	      type = _ref2.type;
	
	  var route = apiClient.route(_templateObject2, ':librarySubdomain', tagId);
	  return apiClient.delete(route, { userId: userId, type: type });
	}
	
	exports.default = {
	  addTag: addTag,
	  removeTag: removeTag
	};

/***/ },
/* 1625 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['/libraries/', '/users/', ''], ['/libraries/', '/users/', '']);
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function fetchUser(_ref, apiClient) {
	  var userId = _ref.userId,
	      query = _objectWithoutProperties(_ref, ['userId']);
	
	  var route = apiClient.route(_templateObject, ':librarySubdomain', userId);
	  return apiClient.get(route, { query: query });
	}
	
	exports.default = {
	  fetchUser: fetchUser
	};

/***/ },
/* 1626 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['/libraries/', '/ugc/videos'], ['/libraries/', '/ugc/videos']),
	    _templateObject2 = _taggedTemplateLiteral(['/libraries/', '/ugc/videos/', ''], ['/libraries/', '/ugc/videos/', '']);
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	function addVideo(_ref, apiClient) {
	  var userId = _ref.userId,
	      metadataId = _ref.metadataId,
	      url = _ref.url,
	      title = _ref.title,
	      description = _ref.description;
	
	  var route = apiClient.route(_templateObject, ':librarySubdomain');
	  return apiClient.post(route, { userId: userId, metadataId: metadataId, url: url, title: title, description: description });
	}
	
	function updateVideo(_ref2, apiClient) {
	  var userId = _ref2.userId,
	      metadataId = _ref2.metadataId,
	      url = _ref2.url,
	      title = _ref2.title,
	      description = _ref2.description,
	      videoId = _ref2.videoId;
	
	  var route = apiClient.route(_templateObject2, ':librarySubdomain', videoId);
	  return apiClient.patch(route, { userId: userId, metadataId: metadataId, url: url, title: title, description: description });
	}
	
	function removeVideo(_ref3, apiClient) {
	  var userId = _ref3.userId,
	      videoId = _ref3.videoId;
	
	  var route = apiClient.route(_templateObject2, ':librarySubdomain', videoId);
	  return apiClient.delete(route, { userId: userId });
	}
	
	exports.default = {
	  addVideo: addVideo,
	  updateVideo: updateVideo,
	  removeVideo: removeVideo
	};

/***/ },
/* 1627 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['/libraries/', '/widgets/item/', ''], ['/libraries/', '/widgets/item/', '']);
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	function fetchItem(metadataId, apiClient) {
	  var route = apiClient.route(_templateObject, ':librarySubdomain', metadataId);
	  return apiClient.get(route);
	}
	
	exports.default = {
	  fetchItem: fetchItem
	};

/***/ },
/* 1628 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(2453);
	
	var _AnalyticsContainer = __webpack_require__(2059);
	
	var _AnalyticsContainer2 = _interopRequireDefault(_AnalyticsContainer);
	
	var _CoreHeaderContainer = __webpack_require__(2064);
	
	var _CoreHeaderContainer2 = _interopRequireDefault(_CoreHeaderContainer);
	
	var _DocumentHeadContainer = __webpack_require__(52);
	
	var _DocumentHeadContainer2 = _interopRequireDefault(_DocumentHeadContainer);
	
	var _FooterContainer = __webpack_require__(2070);
	
	var _FooterContainer2 = _interopRequireDefault(_FooterContainer);
	
	var _GlobalProgressBarContainer = __webpack_require__(2071);
	
	var _GlobalProgressBarContainer2 = _interopRequireDefault(_GlobalProgressBarContainer);
	
	var _GlobalMessagingContainer = __webpack_require__(2104);
	
	var _GlobalMessagingContainer2 = _interopRequireDefault(_GlobalMessagingContainer);
	
	var _InternalErrorContainer = __webpack_require__(2077);
	
	var _InternalErrorContainer2 = _interopRequireDefault(_InternalErrorContainer);
	
	var _LoginOverlayContainer = __webpack_require__(636);
	
	var _LoginOverlayContainer2 = _interopRequireDefault(_LoginOverlayContainer);
	
	var _StaffTakeoverContainer = __webpack_require__(2092);
	
	var _StaffTakeoverContainer2 = _interopRequireDefault(_StaffTakeoverContainer);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _ScreenReaderNavigationContainer = __webpack_require__(2086);
	
	var _ScreenReaderNavigationContainer2 = _interopRequireDefault(_ScreenReaderNavigationContainer);
	
	var _SystemMessagesContainer = __webpack_require__(2093);
	
	var _SystemMessagesContainer2 = _interopRequireDefault(_SystemMessagesContainer);
	
	var _baseBackToTop = __webpack_require__(1029);
	
	var _baseBackToTop2 = _interopRequireDefault(_baseBackToTop);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // TODO: Split out this file so the components themselves require their own stylesheet
	
	
	var BCApp = function (_BcReactComponent) {
	  _inherits(BCApp, _BcReactComponent);
	
	  function BCApp() {
	    _classCallCheck(this, BCApp);
	
	    return _possibleConstructorReturn(this, (BCApp.__proto__ || Object.getPrototypeOf(BCApp)).apply(this, arguments));
	  }
	
	  _createClass(BCApp, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_AnalyticsContainer2.default, null),
	        _react2.default.createElement(_DocumentHeadContainer2.default, null),
	        _react2.default.createElement(_ScreenReaderNavigationContainer2.default, null),
	        _react2.default.createElement(_GlobalProgressBarContainer2.default, null),
	        _react2.default.createElement(_StaffTakeoverContainer2.default, null),
	        _react2.default.createElement(_CoreHeaderContainer2.default, null),
	        _react2.default.createElement(
	          'div',
	          { className: 'container', id: 'content' },
	          _react2.default.createElement(_SystemMessagesContainer2.default, { priority: 'CRITICAL' }),
	          _react2.default.createElement(
	            _InternalErrorContainer2.default,
	            null,
	            this.props.children
	          )
	        ),
	        _react2.default.createElement(_GlobalMessagingContainer2.default, null),
	        _react2.default.createElement(_LoginOverlayContainer2.default, null),
	        _react2.default.createElement(_FooterContainer2.default, null),
	        _react2.default.createElement(_baseBackToTop2.default, null)
	      );
	    }
	  }]);
	
	  return BCApp;
	}(_baseBcReactComponent2.default);
	
	BCApp.propTypes = {
	  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node]).isRequired
	};
	
	exports.default = BCApp;

/***/ },
/* 1629 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Dashboard;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Dashboard() {
	  return _react2.default.createElement(
	    "div",
	    { className: "container" },
	    _react2.default.createElement(
	      "div",
	      { className: "row" },
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-12" },
	        _react2.default.createElement(
	          "h1",
	          null,
	          "Dashboard"
	        )
	      )
	    )
	  );
	}

/***/ },
/* 1630 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseFullScreenOverlay = __webpack_require__(45);
	
	var _baseFullScreenOverlay2 = _interopRequireDefault(_baseFullScreenOverlay);
	
	var _sharedBibBrief = __webpack_require__(46);
	
	var _sharedBibBrief2 = _interopRequireDefault(_sharedBibBrief);
	
	var _baseButtons = __webpack_require__(12);
	
	var _sharedJacketCover = __webpack_require__(93);
	
	var _sharedJacketCover2 = _interopRequireDefault(_sharedJacketCover);
	
	var _baseAccessibilityTextArea = __webpack_require__(117);
	
	var _baseAccessibilityTextArea2 = _interopRequireDefault(_baseAccessibilityTextArea);
	
	var _FormatInfoContainer = __webpack_require__(188);
	
	var _FormatInfoContainer2 = _interopRequireDefault(_FormatInfoContainer);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseAlerts = __webpack_require__(36);
	
	__webpack_require__(2454);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GroupSearchFeedback = function (_BcReactComponent) {
	  _inherits(GroupSearchFeedback, _BcReactComponent);
	
	  function GroupSearchFeedback(props) {
	    _classCallCheck(this, GroupSearchFeedback);
	
	    var _this = _possibleConstructorReturn(this, (GroupSearchFeedback.__proto__ || Object.getPrototypeOf(GroupSearchFeedback)).call(this, props));
	
	    _this.bindAll('handleShouldMatchChange', 'handleSelectMatchingBib', 'handleMessageChange', 'handleSubmit');
	    _this.state = {
	      notes: ''
	    };
	    return _this;
	  }
	
	  _createClass(GroupSearchFeedback, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.isEditing !== this.props.isEditing && this.props.sourceBib && !this.hasMatches()) {
	        this.props.groupSearchFeedbackActions.updateShouldMatch(true);
	      }
	    }
	  }, {
	    key: 'handleShouldMatchChange',
	    value: function handleShouldMatchChange(e) {
	      var shouldMatch = e.currentTarget.value === 'true';
	      this.props.groupSearchFeedbackActions.updateShouldMatch(shouldMatch);
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(e) {
	      e.preventDefault();
	      if (!this.props.isSubmitting) {
	        this.props.groupSearchFeedbackActions.submitFeedback({
	          messagingId: this.props.sourceBib.get('id'),
	          notes: this.state.notes
	        });
	      }
	      this.setState({ notes: '' });
	    }
	  }, {
	    key: 'handleSelectMatchingBib',
	    value: function handleSelectMatchingBib(bib) {
	      this.props.groupSearchFeedbackActions.selectMatchingBib(bib);
	    }
	  }, {
	    key: 'handleMessageChange',
	    value: function handleMessageChange(notes) {
	      this.setState({ notes: notes });
	    }
	  }, {
	    key: 'hasMatches',
	    value: function hasMatches() {
	      var _props = this.props,
	          sourceBib = _props.sourceBib,
	          searchResults = _props.searchResults;
	
	      return searchResults.find(function (group) {
	        return group.manifestations.includes(sourceBib);
	      }).size > 1;
	    }
	  }, {
	    key: 'renderMatchingBibSelect',
	    value: function renderMatchingBibSelect() {
	      var _this2 = this;
	
	      if (this.props.shouldMatch) {
	        if (this.props.bibToMatch) {
	          return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'h4',
	              null,
	              'It should be grouped with...'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'matching-bib-list' },
	              _react2.default.createElement(
	                'div',
	                { className: 'search-result-bib' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'bib-jacket' },
	                  _react2.default.createElement(_sharedJacketCover2.default, { src: this.props.bibToMatch.getIn(['briefInfo', 'jacket']), format: this.props.bibToMatch.getIn(['briefInfo', 'format']) })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'group-bib-brief-info' },
	                  _react2.default.createElement(_sharedBibBrief2.default, { bib: this.props.bibToMatch.get('briefInfo') }),
	                  _react2.default.createElement(_FormatInfoContainer2.default, { item: this.props.bibToMatch }),
	                  _react2.default.createElement(
	                    _baseButtons.TextButton,
	                    { className: 'change-matching-bib', handleClick: this.props.groupSearchFeedbackActions.changeMatchingBib },
	                    'Pick a different item to group with'
	                  )
	                )
	              )
	            )
	          );
	        }
	
	        var items = this.props.searchResults.filter(function (group) {
	          return !group.manifestations.includes(_this2.props.sourceBib);
	        }).map(function (group) {
	          return group.representative;
	        });
	        return _react2.default.createElement(
	          'div',
	          { className: 'select-matching-bib' },
	          _react2.default.createElement(
	            'h4',
	            null,
	            'Select the item that this should be grouped with'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'matching-bib-list' },
	            items.map(function (item) {
	              return _react2.default.createElement(
	                'div',
	                { className: 'search-result-bib' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'bib-jacket' },
	                  _react2.default.createElement(_sharedJacketCover2.default, { src: item.getIn(['briefInfo', 'jacket']), format: item.getIn(['briefInfo', 'format']) })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'group-bib-brief-info' },
	                  _react2.default.createElement(_sharedBibBrief2.default, { bib: item.get('briefInfo') }),
	                  _react2.default.createElement(_FormatInfoContainer2.default, { item: item }),
	                  _react2.default.createElement(
	                    _baseButtons.PrimaryButton,
	                    { handleClick: function handleClick() {
	                        return _this2.handleSelectMatchingBib(item);
	                      }, isLoading: _this2.props.isSubmitting },
	                    'Group with this item'
	                  )
	                )
	              );
	            })
	          )
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderShouldMatchOptions',
	    value: function renderShouldMatchOptions() {
	      if (this.hasMatches()) {
	        return _react2.default.createElement(
	          'fieldset',
	          { className: 'should-match' },
	          _react2.default.createElement(
	            'legend',
	            { className: 'should-match-label' },
	            'This item should be...'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'radio' },
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'diff-group' },
	              _react2.default.createElement('input', { type: 'radio', name: 'shouldMatch', value: 'true', id: 'diff-group', onChange: this.handleShouldMatchChange, required: true }),
	              'in a different group'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'radio' },
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'no-group' },
	              _react2.default.createElement('input', { type: 'radio', name: 'shouldMatch', value: 'false', id: 'no-group', onChange: this.handleShouldMatchChange, required: true }),
	              'not be grouped'
	            )
	          )
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderOverlayContents',
	    value: function renderOverlayContents() {
	      var _props2 = this.props,
	          sourceBib = _props2.sourceBib,
	          isMissingRequiredFields = _props2.isMissingRequiredFields;
	
	
	      if (!sourceBib) {
	        return _react2.default.createElement('noop', null);
	      }
	
	      var sourceBibBrief = sourceBib.get('briefInfo');
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-group-search-feedback' },
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Report incorrect grouping for...'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'clearfix source-bib-display' },
	          _react2.default.createElement(
	            'div',
	            { className: 'source-bib-jacket-cover' },
	            _react2.default.createElement(_sharedJacketCover2.default, { src: sourceBibBrief.get('jacket'), format: sourceBibBrief.get('format'), alt: sourceBibBrief.get('title') })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'source-bib-info' },
	            _react2.default.createElement(_sharedBibBrief2.default, { bib: sourceBibBrief, titleTag: 'h3' }),
	            _react2.default.createElement(_FormatInfoContainer2.default, { item: sourceBib })
	          )
	        ),
	        _react2.default.createElement(
	          'form',
	          { onSubmit: this.handleSubmit },
	          this.renderShouldMatchOptions(),
	          this.renderMatchingBibSelect(),
	          isMissingRequiredFields ? _react2.default.createElement(
	            _baseAlerts.AlertFailure,
	            null,
	            ' ',
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'groupSearchFeedbackFormError' }),
	            ' '
	          ) : null,
	          _react2.default.createElement(
	            'label',
	            { htmlFor: 'additional-comments', id: 'additional-comments-label' },
	            'Additional comments'
	          ),
	          _react2.default.createElement(_baseAccessibilityTextArea2.default, {
	            maxLength: 4000,
	            id: 'additional-comments',
	            labelledById: 'additional-comments-label',
	            value: this.state.notes,
	            handleChange: this.handleMessageChange,
	            errorKey: 'additional-comments',
	            rows: '5',
	            cols: '60' }),
	          _react2.default.createElement(
	            _baseButtons.PrimaryButton,
	            { type: 'submit', isLoading: this.props.isSubmitting },
	            'Submit'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          isEditing = _props3.isEditing,
	          closeOverlay = _props3.groupSearchFeedbackActions.closeOverlay;
	
	      return _react2.default.createElement(
	        _baseFullScreenOverlay2.default,
	        { open: isEditing, handleClose: closeOverlay },
	        this.renderOverlayContents()
	      );
	    }
	  }]);
	
	  return GroupSearchFeedback;
	}(_baseBcReactComponent2.default);
	
	GroupSearchFeedback.propTypes = {
	  groupSearchFeedbackActions: _react.PropTypes.objectOf(_react.PropTypes.func),
	  sourceBib: _reactImmutableProptypes2.default.map,
	  bibToMatch: _reactImmutableProptypes2.default.map,
	  shouldMatch: _react.PropTypes.bool,
	  isEditing: _react.PropTypes.bool,
	  isSubmitting: _react.PropTypes.bool,
	  searchResults: _reactImmutableProptypes2.default.listOf(_reactImmutableProptypes2.default.listOf(_reactImmutableProptypes2.default.map))
	};
	
	exports.default = GroupSearchFeedback;

/***/ },
/* 1631 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GroupSearchFeedback = __webpack_require__(1630);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GroupSearchFeedback).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1632 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseIcons = __webpack_require__(10);
	
	var _baseButtons = __webpack_require__(12);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	var _reactIntl = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GroupSearchFeedbackButton = function (_BcReactComponent) {
	  _inherits(GroupSearchFeedbackButton, _BcReactComponent);
	
	  function GroupSearchFeedbackButton(props) {
	    _classCallCheck(this, GroupSearchFeedbackButton);
	
	    var _this = _possibleConstructorReturn(this, (GroupSearchFeedbackButton.__proto__ || Object.getPrototypeOf(GroupSearchFeedbackButton)).call(this, props));
	
	    _this.bindAll('handleClick');
	    return _this;
	  }
	
	  _createClass(GroupSearchFeedbackButton, [{
	    key: 'handleClick',
	    value: function handleClick() {
	      this.props.handleClick(this.props.bib);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _baseButtons.TextButton,
	        { className: 'cp-group-search-feedback-button', handleClick: this.handleClick },
	        _react2.default.createElement(
	          _baseScreenReaderMessage2.default,
	          null,
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'group_search_feedback' })
	        ),
	        _react2.default.createElement(_baseIcons.Flag, null)
	      );
	    }
	  }]);
	
	  return GroupSearchFeedbackButton;
	}(_baseBcReactComponent2.default);
	
	exports.default = GroupSearchFeedbackButton;
	
	
	GroupSearchFeedbackButton.propTypes = {
	  handleClick: _react.PropTypes.func.isRequired,
	  bib: _reactImmutableProptypes2.default.map
	};

/***/ },
/* 1633 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GroupSearchFeedbackButton = __webpack_require__(1632);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GroupSearchFeedbackButton).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1634 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _PrimaryCommentEditorContainer = __webpack_require__(2094);
	
	var _PrimaryCommentEditorContainer2 = _interopRequireDefault(_PrimaryCommentEditorContainer);
	
	var _PrimaryContentAdvisoryEditorContainer = __webpack_require__(2095);
	
	var _PrimaryContentAdvisoryEditorContainer2 = _interopRequireDefault(_PrimaryContentAdvisoryEditorContainer);
	
	var _PrimaryQuotationEditorContainer = __webpack_require__(2096);
	
	var _PrimaryQuotationEditorContainer2 = _interopRequireDefault(_PrimaryQuotationEditorContainer);
	
	var _PrimarySummaryEditorContainer = __webpack_require__(2097);
	
	var _PrimarySummaryEditorContainer2 = _interopRequireDefault(_PrimarySummaryEditorContainer);
	
	var _notFound = __webpack_require__(140);
	
	var _notFound2 = _interopRequireDefault(_notFound);
	
	var _FeatureFlagContainer = __webpack_require__(147);
	
	var _FeatureFlagContainer2 = _interopRequireDefault(_FeatureFlagContainer);
	
	__webpack_require__(2456);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UGCTestLayout = function (_BcReactComponent) {
	  _inherits(UGCTestLayout, _BcReactComponent);
	
	  function UGCTestLayout() {
	    _classCallCheck(this, UGCTestLayout);
	
	    return _possibleConstructorReturn(this, (UGCTestLayout.__proto__ || Object.getPrototypeOf(UGCTestLayout)).apply(this, arguments));
	  }
	
	  _createClass(UGCTestLayout, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _FeatureFlagContainer2.default,
	        null,
	        function (flags) {
	          return flags.get('ugcTestbed') ? UGCTestLayout.renderMainLayout() : _react2.default.createElement(_notFound2.default, null);
	        }
	      );
	    }
	  }], [{
	    key: 'renderMainLayout',
	    value: function renderMainLayout() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'ugc-test-layout' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          'UGC Editors'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'ugc-editor' },
	          _react2.default.createElement(
	            'h2',
	            null,
	            'PrimaryContentAdvisoryEditor'
	          ),
	          _react2.default.createElement(_PrimaryContentAdvisoryEditorContainer2.default, {
	            bibId: 'S30C2638413',
	            metadataId: 'S30C2638413' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'ugc-editor' },
	          _react2.default.createElement(
	            'h2',
	            null,
	            'PrimaryCommentEditor'
	          ),
	          _react2.default.createElement(_PrimaryCommentEditorContainer2.default, {
	            bibId: 'S30C2638413',
	            metadataId: 'S30C2638413' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'ugc-editor' },
	          _react2.default.createElement(
	            'h2',
	            null,
	            'PrimaryQuotationEditor'
	          ),
	          _react2.default.createElement(_PrimaryQuotationEditorContainer2.default, {
	            bibId: 'S30C2638413',
	            metadataId: 'S30C2638413' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'ugc-editor' },
	          _react2.default.createElement(
	            'h2',
	            null,
	            'PrimarySummaryEditor'
	          ),
	          _react2.default.createElement(_PrimarySummaryEditorContainer2.default, {
	            bibId: 'S30C2638413',
	            metadataId: 'S30C2638413' })
	        )
	      );
	    }
	  }]);
	
	  return UGCTestLayout;
	}(_baseBcReactComponent2.default);
	
	exports.default = UGCTestLayout;

/***/ },
/* 1635 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = HoldPosition;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function HoldPosition(_ref) {
	  var status = _ref.status,
	      position = _ref.position,
	      totalCopies = _ref.totalCopies,
	      holdText = _ref.holdText;
	
	  var renderPosition = function renderPosition() {
	    return _react2.default.createElement(_reactIntl.FormattedMessage, {
	      id: 'holds_queue_info',
	      values: { holdsPosition: _react2.default.createElement(
	          'strong',
	          null,
	          position
	        ), totalCopies: totalCopies } });
	  };
	
	  return _react2.default.createElement(
	    'span',
	    { className: 'cp-hold-position', 'data-test-id': 'holds_queue_info' },
	    position >= 1 ? renderPosition() : status === 'NOT_YET_AVAILABLE' && holdText
	  );
	}
	
	HoldPosition.propTypes = {
	  status: _react.PropTypes.string,
	  holdText: _react.PropTypes.string,
	  position: _react.PropTypes.number,
	  totalCopies: _react.PropTypes.number
	};

/***/ },
/* 1636 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _HoldPosition = __webpack_require__(1635);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_HoldPosition).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1637 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _BorrowingList = __webpack_require__(236);
	
	var _BorrowingList2 = _interopRequireDefault(_BorrowingList);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _baseTable = __webpack_require__(91);
	
	var _reactRouter = __webpack_require__(17);
	
	var _utilsLink = __webpack_require__(97);
	
	var _sharedProgressBar = __webpack_require__(94);
	
	var _sharedProgressBar2 = _interopRequireDefault(_sharedProgressBar);
	
	var _BorrowingHeader = __webpack_require__(124);
	
	var _BorrowingHeader2 = _interopRequireDefault(_BorrowingHeader);
	
	var _AccountMessagesEmptyContentPanel = __webpack_require__(1640);
	
	var _AccountMessagesEmptyContentPanel2 = _interopRequireDefault(_AccountMessagesEmptyContentPanel);
	
	__webpack_require__(2457);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AccountMessages = function (_BcReactComponent) {
	  _inherits(AccountMessages, _BcReactComponent);
	
	  function AccountMessages() {
	    _classCallCheck(this, AccountMessages);
	
	    return _possibleConstructorReturn(this, (AccountMessages.__proto__ || Object.getPrototypeOf(AccountMessages)).apply(this, arguments));
	  }
	
	  _createClass(AccountMessages, [{
	    key: 'renderContent',
	    value: function renderContent() {
	      var _props = this.props,
	          messages = _props.messages,
	          fetching = _props.fetching;
	
	
	      if (messages.size === 0) {
	        return _react2.default.createElement(_AccountMessagesEmptyContentPanel2.default, { fetching: fetching });
	      }
	
	      var fields = [{
	        key: 'reason',
	        headerKey: 'facets_fine_reason',
	        type: 'string'
	      }, { key: 'message',
	        headerKey: 'facets_message',
	        type: 'String',
	        transformationMap: AccountMessages.renderMessage
	      }, { key: 'messageDate', id: 'message_date', headerKey: 'message_date', type: 'Date' }];
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'title-row' },
	        _react2.default.createElement(_BorrowingHeader2.default, {
	          headingKey: 'section_title_messages',
	          taglineKey: 'section_tagline_messages' }),
	        _react2.default.createElement(
	          _BorrowingList2.default,
	          null,
	          _react2.default.createElement(_baseTable.Table, {
	            rows: messages,
	            fields: fields })
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var fetching = this.props.fetching;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-messages' },
	        _react2.default.createElement(_sharedProgressBar2.default, { active: fetching }),
	        this.renderContent()
	      );
	    }
	  }], [{
	    key: 'renderMessage',
	    value: function renderMessage(value, index, row) {
	      var bibTitle = '';
	      if (row.get('metadataId')) {
	        bibTitle = _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/item/show/' + (0, _utilsLink.metadataIdFixer)(row.get('metadataId')), title: row.get('bibTitle') },
	            row.get('bibTitle')
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'message-subtitle' },
	            row.get('message')
	          )
	        );
	      } else {
	        bibTitle = _react2.default.createElement(
	          'span',
	          { className: 'message-subtitle' },
	          row.get('message')
	        );
	      }
	
	      return bibTitle;
	    }
	  }]);
	
	  return AccountMessages;
	}(_baseBcReactComponent2.default);
	
	AccountMessages.propTypes = {
	  user: _reactImmutableProptypes2.default.map,
	  messages: _reactImmutableProptypes2.default.map.isRequired,
	  intl: _reactIntl.intlShape.isRequired,
	  fetching: _react.PropTypes.bool
	};
	
	exports.default = (0, _reactIntl.injectIntl)(AccountMessages);

/***/ },
/* 1638 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AccountMessages = __webpack_require__(1637);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AccountMessages).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1639 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = AccountMessagesEmptyContentPanel;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _BorrowingHeader = __webpack_require__(124);
	
	var _BorrowingHeader2 = _interopRequireDefault(_BorrowingHeader);
	
	var _BorrowingEmptyContentPanel = __webpack_require__(235);
	
	var _BorrowingEmptyContentPanel2 = _interopRequireDefault(_BorrowingEmptyContentPanel);
	
	var _baseIcons = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AccountMessagesEmptyContentPanel(_ref) {
	  var fetching = _ref.fetching;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'cp-recentlyreturned' },
	    _react2.default.createElement(
	      'div',
	      { className: 'title-row' },
	      _react2.default.createElement(_BorrowingHeader2.default, {
	        headingKey: 'section_title_messages',
	        taglineKey: 'section_tagline_messages' }),
	      _react2.default.createElement(_BorrowingEmptyContentPanel2.default, {
	        className: 'cp-recentlyreturned-empty-content-panel',
	        fetching: fetching,
	        showStaffPicksLink: false,
	        helpPage: '040settings/005privacy-settings',
	        icon: _react2.default.createElement(_baseIcons.MessagesIcon, null),
	        title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'empty_messages' }) })
	    )
	  );
	}
	
	AccountMessagesEmptyContentPanel.propTypes = {
	  fetching: _react.PropTypes.bool
	};

/***/ },
/* 1640 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AccountMessagesEmptyContentPanel = __webpack_require__(1639);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AccountMessagesEmptyContentPanel).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1641 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _BorrowingStatus = __webpack_require__(182);
	
	var _BorrowingStatus2 = _interopRequireDefault(_BorrowingStatus);
	
	var _SidebarCompactTitle = __webpack_require__(183);
	
	var _SidebarCompactTitle2 = _interopRequireDefault(_SidebarCompactTitle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AccountMessagesStatus = function (_BcReactComponent) {
	  _inherits(AccountMessagesStatus, _BcReactComponent);
	
	  function AccountMessagesStatus() {
	    _classCallCheck(this, AccountMessagesStatus);
	
	    return _possibleConstructorReturn(this, (AccountMessagesStatus.__proto__ || Object.getPrototypeOf(AccountMessagesStatus)).apply(this, arguments));
	  }
	
	  _createClass(AccountMessagesStatus, [{
	    key: 'render',
	    value: function render() {
	      var currentSection = this.props.currentSection;
	
	
	      return _react2.default.createElement(
	        _BorrowingStatus2.default,
	        { currentSection: currentSection, to: '/v2/accountmessages' },
	        _react2.default.createElement(_SidebarCompactTitle2.default, {
	          title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'section_title_messages' }),
	          count: _react2.default.createElement(
	            'span',
	            null,
	            this.props.messages.size
	          ),
	          selected: currentSection })
	      );
	    }
	  }]);
	
	  return AccountMessagesStatus;
	}(_baseBcReactComponent2.default);
	
	exports.default = AccountMessagesStatus;
	
	
	AccountMessagesStatus.propTypes = {
	  currentSection: _react.PropTypes.bool,
	  messages: _reactImmutableProptypes2.default.map.isRequired
	};

/***/ },
/* 1642 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AccountMessagesStatus = __webpack_require__(1641);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AccountMessagesStatus).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1643 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CheckedOut = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _reactRouter = __webpack_require__(17);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _pagination = __webpack_require__(92);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _sharedProgressBar = __webpack_require__(94);
	
	var _sharedProgressBar2 = _interopRequireDefault(_sharedProgressBar);
	
	var _baseButtons = __webpack_require__(12);
	
	var _BorrowingList = __webpack_require__(236);
	
	var _BorrowingList2 = _interopRequireDefault(_BorrowingList);
	
	var _CheckedOutUtilityBar = __webpack_require__(1671);
	
	var _CheckedOutUtilityBar2 = _interopRequireDefault(_CheckedOutUtilityBar);
	
	var _CheckedOutList = __webpack_require__(1655);
	
	var _CheckedOutList2 = _interopRequireDefault(_CheckedOutList);
	
	var _CheckedOutBatchActions = __webpack_require__(1647);
	
	var _CheckedOutBatchActions2 = _interopRequireDefault(_CheckedOutBatchActions);
	
	var _CheckedOutEmptyContentPanel = __webpack_require__(1651);
	
	var _CheckedOutEmptyContentPanel2 = _interopRequireDefault(_CheckedOutEmptyContentPanel);
	
	var _BorrowingHeader = __webpack_require__(124);
	
	var _BorrowingHeader2 = _interopRequireDefault(_BorrowingHeader);
	
	var _RenewFailureOverlayContainer = __webpack_require__(2084);
	
	var _RenewFailureOverlayContainer2 = _interopRequireDefault(_RenewFailureOverlayContainer);
	
	__webpack_require__(2458);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CheckedOut = exports.CheckedOut = function (_BcReactComponent) {
	  _inherits(CheckedOut, _BcReactComponent);
	
	  function CheckedOut(props) {
	    _classCallCheck(this, CheckedOut);
	
	    var _this = _possibleConstructorReturn(this, (CheckedOut.__proto__ || Object.getPrototypeOf(CheckedOut)).call(this, props));
	
	    _this.state = {
	      renewFailureOverlayOpen: false
	    };
	
	    _this.bindAll('handleSort', 'handleBatchRenew', 'handleBatchAddToShelf', 'handleRenewFailureOverlayOpen', 'handleRenewFailureOverlayClose');
	    return _this;
	  }
	
	  _createClass(CheckedOut, [{
	    key: 'handleRenewFailureOverlayOpen',
	    value: function handleRenewFailureOverlayOpen() {
	      this.setState({ renewFailureOverlayOpen: true });
	    }
	  }, {
	    key: 'handleRenewFailureOverlayClose',
	    value: function handleRenewFailureOverlayClose() {
	      this.setState({ renewFailureOverlayOpen: false });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.redirectIfSingleStatus();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var _props = this.props,
	          items = _props.items,
	          router = _props.router,
	          selectedStatus = _props.selectedStatus,
	          presentStatuses = _props.presentStatuses;
	
	      // Unselect status if there are no longer any checkouts with status
	
	      if (selectedStatus && items.size === 0) {
	        router.replace('/v2/checkedout');
	      }
	
	      if (!prevProps.presentStatuses.equals(presentStatuses)) {
	        this.redirectIfSingleStatus();
	      }
	    }
	  }, {
	    key: 'redirectIfSingleStatus',
	    value: function redirectIfSingleStatus() {
	      var _props2 = this.props,
	          router = _props2.router,
	          presentStatuses = _props2.presentStatuses,
	          selectedStatus = _props2.selectedStatus;
	
	      // Redirect to the route for a specific status if there is only one status
	
	      if (!selectedStatus && presentStatuses && presentStatuses.size === 1) {
	        router.replace('/v2/checkedout/' + presentStatuses.first().toLowerCase());
	      }
	    }
	  }, {
	    key: 'getPrintURL',
	    value: function getPrintURL() {
	      var search = this.props.location.search;
	
	      return '/v2/print/checkedout' + search;
	    }
	  }, {
	    key: 'allItemsDigital',
	    value: function allItemsDigital() {
	      return this.props.items.every(function (item) {
	        return item.getIn(['bib', 'policy', 'materialType']) === 'DIGITAL';
	      });
	    }
	  }, {
	    key: 'renderMoreDetailsLink',
	    value: function renderMoreDetailsLink() {
	      return _react2.default.createElement(
	        _baseButtons.TextButton,
	        { handleClick: this.handleRenewFailureOverlayOpen },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'more_details' })
	      );
	    }
	  }, {
	    key: 'handleBatchRenew',
	    value: function handleBatchRenew(items) {
	      var _props3 = this.props,
	          accountId = _props3.accountId,
	          checkoutActions = _props3.checkoutActions;
	
	      checkoutActions.renew({
	        accountId: accountId,
	        checkoutIds: items.map(function (item) {
	          return item.get('id');
	        }).toArray(),
	        moreDetails: this.renderMoreDetailsLink()
	      });
	    }
	  }, {
	    key: 'handleBatchAddToShelf',
	    value: function handleBatchAddToShelf(items, shelfName) {
	      var metadataIds = items.map(function (item) {
	        return item.get('metadataId');
	      }).toSet().toList();
	
	      this.props.shelfActions.batchAddToShelf({ metadataIds: metadataIds, shelfName: shelfName });
	    }
	  }, {
	    key: 'getSortOptions',
	    value: function getSortOptions() {
	      var currentSort = this.props.router.location.query.sort || 'dueDate';
	      return ['dueDate', 'title', 'author', 'format'].reduce(function (acc, val) {
	        return acc.set(val, _immutable2.default.Map({
	          id: val,
	          applied: val === currentSort
	        }));
	      }, _immutable2.default.Map()).toList();
	    }
	  }, {
	    key: 'handleSort',
	    value: function handleSort(sortType) {
	      var _props4 = this.props,
	          location = _props4.location,
	          router = _props4.router;
	
	      router.push(_extends({}, location, {
	        query: _extends({}, location.query, {
	          sort: sortType
	        })
	      }));
	    }
	  }, {
	    key: 'renderBatchActionButtons',
	    value: function renderBatchActionButtons(itemsForAction) {
	      return _react2.default.createElement(_CheckedOutBatchActions2.default, {
	        itemsForAction: itemsForAction,
	        handleBatchRenew: this.handleBatchRenew,
	        handleBatchAddToShelf: this.handleBatchAddToShelf });
	    }
	  }, {
	    key: 'renderBorrowingList',
	    value: function renderBorrowingList() {
	      var _this2 = this;
	
	      var _props5 = this.props,
	          items = _props5.items,
	          showStaffPicksLink = _props5.showStaffPicksLink,
	          pagination = _props5.pagination,
	          fetching = _props5.fetching,
	          ratingsActions = _props5.ratingsActions;
	
	      var actionList = items.map(function (item) {
	        return _immutable2.default.Map({
	          id: item.get('checkoutId'),
	          metadataId: item.get('metadataId'),
	          actions: item.get('actions')
	        });
	      });
	
	      if (!items || items.size === 0) {
	        return _react2.default.createElement(_CheckedOutEmptyContentPanel2.default, {
	          fetching: fetching,
	          showStaffPicksLink: showStaffPicksLink });
	      }
	
	      return _react2.default.createElement(
	        _BorrowingList2.default,
	        null,
	        _react2.default.createElement(_CheckedOutUtilityBar2.default, {
	          allItemsDigital: this.allItemsDigital(),
	          status: this.props.selectedStatus,
	          totalCount: this.props.totalUnfilteredCount,
	          materialTypeCounts: this.props.materialTypeCounts,
	          sortOptions: this.getSortOptions(),
	          printURL: this.getPrintURL(),
	          quotas: this.props.quotas,
	          pagination: this.props.pagination,
	          handleSort: this.handleSort }),
	        _react2.default.createElement(_CheckedOutList2.default, {
	          accountId: this.props.accountId,
	          items: items,
	          actionList: actionList,
	          shelfTransactions: this.props.shelfTransactions,
	          totalCount: this.props.totalCount,
	          isFetching: this.props.isFetching,
	          workflowActions: this.props.workflowActions,
	          checkoutActions: this.props.checkoutActions,
	          ratingsActions: ratingsActions,
	          checkoutTransactions: this.props.checkoutTransactions,
	          ratingsTransactions: this.props.ratingsTransactions,
	          handleBatchRenew: this.handleBatchRenew,
	          handleBatchAddToShelf: this.handleBatchAddToShelf,
	          ratings: this.props.ratings,
	          renderBatchActionButtons: function renderBatchActionButtons(itemsForAction) {
	            return _this2.renderBatchActionButtons(itemsForAction);
	          } }),
	        _react2.default.createElement(
	          'section',
	          { className: 'bottom-controls' },
	          _react2.default.createElement(_pagination2.default, {
	            isFetching: false,
	            showPages: true,
	            page: pagination.get('page'),
	            limit: pagination.get('limit'),
	            count: pagination.get('count'),
	            pages: pagination.get('pages') })
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-checked-out' },
	        _react2.default.createElement(_sharedProgressBar2.default, { active: this.props.fetching }),
	        _react2.default.createElement(
	          'div',
	          { className: 'title-row' },
	          _react2.default.createElement(_BorrowingHeader2.default, {
	            headingKey: 'section_title_checkedout',
	            taglineKey: 'section_tagline_checkedout',
	            helpLinkPage: '005borrowing' }),
	          this.renderBorrowingList()
	        ),
	        _react2.default.createElement(_RenewFailureOverlayContainer2.default, {
	          open: this.state.renewFailureOverlayOpen,
	          handleClose: this.handleRenewFailureOverlayClose })
	      );
	    }
	  }]);
	
	  return CheckedOut;
	}(_baseBcReactComponent2.default);
	
	CheckedOut.propTypes = {
	  accountId: _react.PropTypes.number,
	  isFetching: _react.PropTypes.bool,
	  items: _reactImmutableProptypes2.default.listOf(_bcPropTypes.checkedOutItemShape),
	  materialTypeCounts: _reactImmutableProptypes2.default.mapContains({
	    PHYSICAL: _react.PropTypes.number,
	    DIGITAL: _react.PropTypes.number
	  }),
	  selectedStatus: _react.PropTypes.string,
	  presentStatuses: _reactImmutableProptypes2.default.listOf(_react.PropTypes.string),
	  totalCount: _react.PropTypes.number,
	  totalUnfilteredCount: _react.PropTypes.number,
	  showStaffPicksLink: _react.PropTypes.bool,
	  quotas: _reactImmutableProptypes2.default.listOf(_bcPropTypes.borrowingQuotaShape),
	  workflowActions: _react.PropTypes.objectOf(_react.PropTypes.func),
	  checkoutActions: _react.PropTypes.objectOf(_react.PropTypes.func),
	  shelfActions: _react.PropTypes.objectOf(_react.PropTypes.func),
	  ratingsActions: _react.PropTypes.objectOf(_react.PropTypes.func),
	  ratings: _reactImmutableProptypes2.default.map,
	  pagination: _reactImmutableProptypes2.default.mapContains({
	    page: _react.PropTypes.number,
	    limit: _react.PropTypes.number,
	    count: _react.PropTypes.number,
	    pages: _react.PropTypes.number
	  }),
	  checkoutTransactions: _reactImmutableProptypes2.default.map,
	  ratingsTransactions: _reactImmutableProptypes2.default.map,
	  shelfTransactions: _reactImmutableProptypes2.default.map,
	  fetching: _react.PropTypes.bool
	};
	
	exports.default = (0, _reactRouter.withRouter)(CheckedOut);

/***/ },
/* 1644 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CheckedOut = __webpack_require__(1643);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CheckedOut).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1645 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _rating = __webpack_require__(141);
	
	var _rating2 = _interopRequireDefault(_rating);
	
	var _DigitalItemInfo = __webpack_require__(1673);
	
	var _DigitalItemInfo2 = _interopRequireDefault(_DigitalItemInfo);
	
	var _ItemField = __webpack_require__(237);
	
	var _ItemField2 = _interopRequireDefault(_ItemField);
	
	var _ItemFormat = __webpack_require__(289);
	
	var _ItemFormat2 = _interopRequireDefault(_ItemFormat);
	
	__webpack_require__(2459);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CheckedOutAdditionalBriefInfo = function (_BcReactComponent) {
	  _inherits(CheckedOutAdditionalBriefInfo, _BcReactComponent);
	
	  function CheckedOutAdditionalBriefInfo(props) {
	    _classCallCheck(this, CheckedOutAdditionalBriefInfo);
	
	    var _this = _possibleConstructorReturn(this, (CheckedOutAdditionalBriefInfo.__proto__ || Object.getPrototypeOf(CheckedOutAdditionalBriefInfo)).call(this, props));
	
	    _this.bindAll('handleUpdateRating', 'handleRemoveRating');
	    return _this;
	  }
	
	  _createClass(CheckedOutAdditionalBriefInfo, [{
	    key: 'renderVolume',
	    value: function renderVolume() {
	      var volume = this.props.item.get('volume');
	      return volume && _react2.default.createElement(_ItemField2.default, { className: 'volume-field', name: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'volume' }), value: volume });
	    }
	  }, {
	    key: 'renderCopy',
	    value: function renderCopy() {
	      var copy = this.props.item.get('copy');
	      return copy && _react2.default.createElement(_ItemField2.default, { className: 'copy-field', name: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'copy' }), value: copy });
	    }
	  }, {
	    key: 'isDigital',
	    value: function isDigital() {
	      return this.props.item.getIn(['bib', 'policy', 'materialType']) === 'DIGITAL';
	    }
	  }, {
	    key: 'renderCallNumberAndBarcode',
	    value: function renderCallNumberAndBarcode() {
	      var item = this.props.item;
	
	
	      if (!this.isDigital()) {
	        return _react2.default.createElement(
	          'div',
	          { 'data-test-id': 'call-number-and-barcode', className: 'call-number-and-barcode' },
	          _react2.default.createElement(_ItemField2.default, {
	            name: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'CALL_NUMBER' }),
	            value: item.get('callNumber') }),
	          _react2.default.createElement(_ItemField2.default, {
	            name: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'form_label_barcode' }),
	            value: item.get('barcode') })
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderBibFields',
	    value: function renderBibFields() {
	      var item = this.props.item;
	
	      var bib = item.get('bib');
	
	      if (bib) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'format-field' },
	          _react2.default.createElement(_ItemFormat2.default, { bib: item.get('bib') }),
	          this.renderRating(),
	          _react2.default.createElement(_DigitalItemInfo2.default, {
	            format: item.get('format'),
	            bib: bib })
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'handleUpdateRating',
	    value: function handleUpdateRating(rating) {
	      if (this.props.rating) {
	        return this.props.ratingsActions.changeItemRating(this.props.item.get('metadataId'), rating);
	      }
	
	      return this.props.ratingsActions.rateItem(this.props.item.get('metadataId'), rating);
	    }
	  }, {
	    key: 'handleRemoveRating',
	    value: function handleRemoveRating() {
	      return this.props.ratingsActions.removeItemRating(this.props.item.get('metadataId'), this.props.rating.get(0).get('id'));
	    }
	  }, {
	    key: 'renderRating',
	    value: function renderRating() {
	      var _props = this.props,
	          item = _props.item,
	          ratingsTransactions = _props.ratingsTransactions,
	          rating = _props.rating;
	
	      if (item.get('bib')) {
	        var currentUserRating = rating ? rating.get(0).get('rating') : null;
	        var metadataId = item.get('metadataId');
	        var isLoading = ratingsTransactions.getIn([metadataId, 'isLoading'], false);
	        return _react2.default.createElement(
	          'div',
	          { className: 'post-success-rating' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'label_rate_this' }),
	          _react2.default.createElement(_rating2.default, {
	            id: 'added_to_shelf_rating_' + metadataId,
	            isLoading: isLoading,
	            rating: currentUserRating,
	            handleButtonClick: this.handleUpdateRating,
	            handleRemoveClick: this.handleRemoveRating })
	        );
	      }
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-checked-out-additional-brief-info' },
	        this.renderVolume(),
	        this.renderCopy(),
	        this.renderBibFields(),
	        this.renderCallNumberAndBarcode()
	      );
	    }
	  }]);
	
	  return CheckedOutAdditionalBriefInfo;
	}(_baseBcReactComponent2.default);
	
	exports.default = CheckedOutAdditionalBriefInfo;
	
	
	CheckedOutAdditionalBriefInfo.propTypes = {
	  item: _bcPropTypes.checkedOutItemShape,
	  rating: _reactImmutableProptypes2.default.list,
	  ratingsActions: _react.PropTypes.objectOf(_react.PropTypes.func),
	  ratingsTransactions: _reactImmutableProptypes2.default.map
	};
	
	CheckedOutAdditionalBriefInfo.defaultProps = {
	  renderRating: function renderRating() {
	    return null;
	  }
	};

/***/ },
/* 1646 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CheckedOutAdditionalBriefInfo = __webpack_require__(1645);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CheckedOutAdditionalBriefInfo).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1647 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = CheckedOutBatchActions;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _baseIcons = __webpack_require__(10);
	
	var _BatchActionButton = __webpack_require__(584);
	
	var _BatchActionButton2 = _interopRequireDefault(_BatchActionButton);
	
	var _BatchAddToShelfButton = __webpack_require__(388);
	
	var _BatchAddToShelfButton2 = _interopRequireDefault(_BatchAddToShelfButton);
	
	__webpack_require__(2460);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CheckedOutBatchActions(_ref) {
	  var itemsForAction = _ref.itemsForAction,
	      handleBatchRenew = _ref.handleBatchRenew,
	      handleBatchAddToShelf = _ref.handleBatchAddToShelf;
	
	  var renewItemsSelected = itemsForAction.get('renew', _immutable2.default.List());
	  var shelfItemsSelected = itemsForAction.get('addToShelf', _immutable2.default.List());
	  return _react2.default.createElement(
	    'div',
	    { className: 'cp-checked-out-batch-actions' },
	    _react2.default.createElement(
	      _BatchActionButton2.default,
	      {
	        className: 'batch-renew-button',
	        selectedItemCount: renewItemsSelected.size,
	        handleClick: function handleClick() {
	          return handleBatchRenew(renewItemsSelected);
	        } },
	      _react2.default.createElement(_baseIcons.Redo, null),
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_renew' })
	    ),
	    _react2.default.createElement(_BatchAddToShelfButton2.default, {
	      selectedItemCount: shelfItemsSelected.size,
	      handleClick: function handleClick(shelfName) {
	        return handleBatchAddToShelf(shelfItemsSelected, shelfName);
	      } })
	  );
	}
	
	CheckedOutBatchActions.propTypes = {
	  itemsForAction: _reactImmutableProptypes2.default.map,
	  handleBatchRenew: _react.PropTypes.func,
	  handleBatchAddToShelf: _react.PropTypes.func
	};

/***/ },
/* 1648 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = CheckedOutDueOn;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _ShortFormattedDate = __webpack_require__(60);
	
	var _ShortFormattedDate2 = _interopRequireDefault(_ShortFormattedDate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CheckedOutDueOn(_ref) {
	  var isDigital = _ref.isDigital,
	      dueDate = _ref.dueDate;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'cp-checked-out-due-on' },
	    _react2.default.createElement(_reactIntl.FormattedMessage, {
	      id: isDigital ? 'digital_expires_on_date' : 'due_by_date',
	      values: { date: _react2.default.createElement(_ShortFormattedDate2.default, { value: dueDate }) } })
	  );
	}
	
	CheckedOutDueOn.propTypes = {
	  isDigital: _react.PropTypes.bool,
	  dueDate: _react.PropTypes.string
	};

/***/ },
/* 1649 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CheckedOutDueOn = __webpack_require__(1648);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CheckedOutDueOn).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1650 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = CheckedOutEmptyContentPanel;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseIcons = __webpack_require__(10);
	
	var _BorrowingEmptyContentPanel = __webpack_require__(235);
	
	var _BorrowingEmptyContentPanel2 = _interopRequireDefault(_BorrowingEmptyContentPanel);
	
	__webpack_require__(2461);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CheckedOutEmptyContentPanel(_ref) {
	  var fetching = _ref.fetching;
	
	  return _react2.default.createElement(_BorrowingEmptyContentPanel2.default, {
	    className: 'cp-checked-out-empty-content-panel',
	    icon: _react2.default.createElement(_baseIcons.CheckedOutIcon, null),
	    showExploreNewTitlesLink: true,
	    fetching: fetching,
	    title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'checkedout_empty_title' }) });
	}
	
	CheckedOutEmptyContentPanel.propTypes = {
	  fetching: _react.PropTypes.bool
	};

/***/ },
/* 1651 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CheckedOutEmptyContentPanel = __webpack_require__(1650);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CheckedOutEmptyContentPanel).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1652 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _BorrowingBibBrief = __webpack_require__(284);
	
	var _BorrowingBibBrief2 = _interopRequireDefault(_BorrowingBibBrief);
	
	var _CheckedOutSecondaryInfo = __webpack_require__(1660);
	
	var _CheckedOutSecondaryInfo2 = _interopRequireDefault(_CheckedOutSecondaryInfo);
	
	var _CheckedOutAdditionalBriefInfo = __webpack_require__(1646);
	
	var _CheckedOutAdditionalBriefInfo2 = _interopRequireDefault(_CheckedOutAdditionalBriefInfo);
	
	var _RenewButton = __webpack_require__(1680);
	
	var _RenewButton2 = _interopRequireDefault(_RenewButton);
	
	var _BibListItem = __webpack_require__(239);
	
	var _BibListItem2 = _interopRequireDefault(_BibListItem);
	
	var _AddToShelfButtonContainer = __webpack_require__(146);
	
	var _AddToShelfButtonContainer2 = _interopRequireDefault(_AddToShelfButtonContainer);
	
	var _ItemTransactions = __webpack_require__(291);
	
	__webpack_require__(2462);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CheckedOutItem = function (_BcReactComponent) {
	  _inherits(CheckedOutItem, _BcReactComponent);
	
	  function CheckedOutItem(props) {
	    _classCallCheck(this, CheckedOutItem);
	
	    var _this = _possibleConstructorReturn(this, (CheckedOutItem.__proto__ || Object.getPrototypeOf(CheckedOutItem)).call(this, props));
	
	    _this.bindAll('handleRenew', 'renderSecondaryInfo', 'renderBibBrief', 'startDigitalMissingFormatSelection');
	    return _this;
	  }
	
	  _createClass(CheckedOutItem, [{
	    key: 'handleRenew',
	    value: function handleRenew() {
	      var _props = this.props,
	          item = _props.item,
	          accountId = _props.accountId,
	          checkoutActions = _props.checkoutActions;
	
	      var checkoutId = item.get('checkoutId');
	
	      checkoutActions.renew({
	        accountId: accountId,
	        checkoutIds: [checkoutId]
	      });
	    }
	  }, {
	    key: 'startDigitalMissingFormatSelection',
	    value: function startDigitalMissingFormatSelection() {
	      var item = this.props.item;
	
	      this.props.checkoutActions.startDigitalMissingFormatSelection(item.get('checkoutId'), item.get('metadataId'));
	    }
	  }, {
	    key: 'renderReadingLinks',
	    value: function renderReadingLinks() {
	      var _props2 = this.props,
	          item = _props2.item,
	          accountId = _props2.accountId,
	          checkoutActions = _props2.checkoutActions,
	          actionInProgress = _props2.actionInProgress;
	
	      if (item.getIn(['bib', 'policy', 'materialType']) === 'DIGITAL') {
	        return _react2.default.createElement(_ItemTransactions.CheckedOutReadingLinks, {
	          disabled: actionInProgress,
	          checkInEnabled: item.get('checkInEnabled'),
	          downloadable: item.get('downloadable'),
	          format: item.get('format'),
	          downloadUrl: item.get('downloadUrl'),
	          thirdPartyReaderUrl: item.get('thirdPartyReaderUrl'),
	          policy: item.getIn(['bib', 'policy', 'materialPolicy']),
	          metadataId: item.get('metadataId'),
	          checkoutId: item.get('checkoutId'),
	          accountId: accountId,
	          checkIn: checkoutActions.digitalCheckIn,
	          startDigitalMissingFormatSelection: this.startDigitalMissingFormatSelection });
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderAddToShelfButton',
	    value: function renderAddToShelfButton() {
	      var _props3 = this.props,
	          item = _props3.item,
	          shelfTransactions = _props3.shelfTransactions,
	          actionInProgress = _props3.actionInProgress;
	
	      var shelfActionInProgress = !shelfTransactions.get(item.get('metadataId'), _immutable2.default.Map()).isEmpty();
	
	      if (item.get('bib')) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'shelf-button' },
	          _react2.default.createElement(_AddToShelfButtonContainer2.default, {
	            disabled: actionInProgress && !shelfActionInProgress,
	            metadataId: item.get('metadataId'),
	            workflowId: item.get('checkoutId') })
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderRenewButton',
	    value: function renderRenewButton() {
	      var _props4 = this.props,
	          item = _props4.item,
	          checkoutTransactions = _props4.checkoutTransactions,
	          actionInProgress = _props4.actionInProgress;
	
	      var checkoutId = item.get('checkoutId');
	      var isRenewing = checkoutTransactions.getIn([checkoutId, 'isRenewing']);
	
	      return _react2.default.createElement(_RenewButton2.default, {
	        disabled: actionInProgress && !isRenewing,
	        isLoading: checkoutTransactions.getIn([checkoutId, 'isRenewing']),
	        canRenew: item.get('actions').contains('renew'),
	        canReturn: item.get('actions').contains('checkIn'),
	        handleClick: this.handleRenew });
	    }
	  }, {
	    key: 'renderBibActions',
	    value: function renderBibActions() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.renderReadingLinks(),
	        this.renderRenewButton(),
	        this.renderAddToShelfButton()
	      );
	    }
	  }, {
	    key: 'renderSecondaryInfo',
	    value: function renderSecondaryInfo() {
	      var item = this.props.item;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'checkedout-status' },
	          _react2.default.createElement(_CheckedOutSecondaryInfo2.default, { item: item })
	        ),
	        this.renderBibActions()
	      );
	    }
	  }, {
	    key: 'renderBibBrief',
	    value: function renderBibBrief() {
	      var briefInfo = this.props.item.getIn(['bib', 'briefInfo']);
	      return _react2.default.createElement(
	        _BorrowingBibBrief2.default,
	        { bib: briefInfo, fallbackTitle: this.props.item.get('bibTitle') },
	        _react2.default.createElement(_CheckedOutAdditionalBriefInfo2.default, {
	          item: this.props.item,
	          rating: this.props.rating,
	          ratingsActions: this.props.ratingsActions,
	          ratingsTransactions: this.props.ratingsTransactions })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var item = this.props.item;
	
	      return _react2.default.createElement(_BibListItem2.default, {
	        workflowId: item.get('checkoutId'),
	        className: (0, _classnames2.default)('cp-checked-out-item', item.get('status').toLowerCase()),
	        bib: item.getIn(['bib', 'briefInfo']),
	        renderInfo: function renderInfo() {
	          return _this2.renderSecondaryInfo();
	        },
	        renderBibBrief: function renderBibBrief() {
	          return _this2.renderBibBrief();
	        } });
	    }
	  }]);
	
	  return CheckedOutItem;
	}(_baseBcReactComponent2.default);
	
	exports.default = CheckedOutItem;
	
	
	CheckedOutItem.propTypes = {
	  accountId: _react.PropTypes.number,
	  item: _bcPropTypes.checkedOutItemShape,
	  actionInProgress: _react.PropTypes.bool,
	  checkoutTransactions: _reactImmutableProptypes2.default.map,
	  ratingsTransactions: _reactImmutableProptypes2.default.map,
	  shelfTransactions: _reactImmutableProptypes2.default.map,
	  rating: _reactImmutableProptypes2.default.list,
	  checkoutActions: _react.PropTypes.objectOf(_react.PropTypes.func),
	  workflowActions: _react.PropTypes.objectOf(_react.PropTypes.func),
	  ratingsActions: _react.PropTypes.objectOf(_react.PropTypes.func)
	};

/***/ },
/* 1653 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CheckedOutItem = __webpack_require__(1652);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CheckedOutItem).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1654 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseDropdown = __webpack_require__(37);
	
	var _BatchActionsListItem = __webpack_require__(288);
	
	var _BatchActionsListItem2 = _interopRequireDefault(_BatchActionsListItem);
	
	var _BatchActionsListContainer = __webpack_require__(298);
	
	var _BatchActionsListContainer2 = _interopRequireDefault(_BatchActionsListContainer);
	
	var _ItemList = __webpack_require__(145);
	
	var _ItemList2 = _interopRequireDefault(_ItemList);
	
	var _CheckedOutItem = __webpack_require__(1653);
	
	var _CheckedOutItem2 = _interopRequireDefault(_CheckedOutItem);
	
	var _AddToShelfBatchActions = __webpack_require__(382);
	
	var _AddToShelfBatchActions2 = _interopRequireDefault(_AddToShelfBatchActions);
	
	var _BatchActionLink = __webpack_require__(238);
	
	var _BatchActionLink2 = _interopRequireDefault(_BatchActionLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CheckedOutList = function (_BcReactComponent) {
	  _inherits(CheckedOutList, _BcReactComponent);
	
	  function CheckedOutList(props) {
	    _classCallCheck(this, CheckedOutList);
	
	    var _this = _possibleConstructorReturn(this, (CheckedOutList.__proto__ || Object.getPrototypeOf(CheckedOutList)).call(this, props));
	
	    _this.bindAll('renderBatchActionsMenu');
	    return _this;
	  }
	
	  _createClass(CheckedOutList, [{
	    key: 'batchActionsLoading',
	    value: function batchActionsLoading() {
	      var _this2 = this;
	
	      return this.props.items.some(function (item) {
	        return _this2.anyActionInProgressForItem(item);
	      });
	    }
	  }, {
	    key: 'anyActionInProgressForItem',
	    value: function anyActionInProgressForItem(item) {
	      var _props = this.props,
	          checkoutTransactions = _props.checkoutTransactions,
	          shelfTransactions = _props.shelfTransactions;
	
	      var checkoutId = item.get('checkoutId');
	      var metadataId = item.get('metadataId');
	
	      var anyOngoingCheckoutAction = !checkoutTransactions.get(checkoutId, _immutable2.default.Map()).isEmpty();
	      var anyOngoingShelfAction = !shelfTransactions.get(metadataId, _immutable2.default.Map()).isEmpty();
	
	      return anyOngoingCheckoutAction || anyOngoingShelfAction;
	    }
	  }, {
	    key: 'renderBibListItem',
	    value: function renderBibListItem(item, selectedItems, updateItem) {
	      var _props2 = this.props,
	          accountId = _props2.accountId,
	          checkoutActions = _props2.checkoutActions,
	          workflowActions = _props2.workflowActions,
	          ratingsActions = _props2.ratingsActions;
	
	
	      var actionItem = _immutable2.default.Map({
	        id: item.get('checkoutId'),
	        metadataId: item.getIn(['bib', 'briefInfo', 'metadataId']),
	        actions: item.get('actions', _immutable2.default.List())
	      });
	
	      return _react2.default.createElement(
	        _BatchActionsListItem2.default,
	        {
	          key: item.get('checkoutId'),
	          actionItem: actionItem,
	          selectedItems: selectedItems,
	          updateItem: updateItem },
	        _react2.default.createElement(_CheckedOutItem2.default, {
	          actionInProgress: this.anyActionInProgressForItem(item),
	          accountId: accountId,
	          item: item,
	          checkoutTransactions: this.props.checkoutTransactions,
	          shelfTransactions: this.props.shelfTransactions,
	          ratingsTransactions: this.props.ratingsTransactions,
	          checkoutActions: checkoutActions,
	          workflowActions: workflowActions,
	          rating: this.props.ratings.get(item.get('metadataId')),
	          ratingsActions: ratingsActions })
	      );
	    }
	  }, {
	    key: 'renderRenewBatchAction',
	    value: function renderRenewBatchAction(selectedActionItems) {
	      var _this3 = this;
	
	      var renewBatchActionItems = selectedActionItems.filter(function (item) {
	        return item.get('actions').includes('renew');
	      });
	      return _react2.default.createElement(
	        _baseDropdown.DropdownMenuItem,
	        { key: 'checked-out-batch-actions-renew' },
	        _react2.default.createElement(
	          _BatchActionLink2.default,
	          {
	            disabled: renewBatchActionItems.size === 0,
	            href: '#checked-out-batch-actions-renew',
	            handleClick: function handleClick() {
	              return _this3.props.handleBatchRenew(renewBatchActionItems);
	            } },
	          _react2.default.createElement(_reactIntl.FormattedMessage, {
	            id: 'renew_items_with_count',
	            values: { count: renewBatchActionItems.size } })
	        )
	      );
	    }
	  }, {
	    key: 'renderBatchActionsMenu',
	    value: function renderBatchActionsMenu(selectedActionItems) {
	      return [this.renderRenewBatchAction(selectedActionItems), _react2.default.createElement(_baseDropdown.DropdownMenuDivider, { key: 'checked-out-batch-actions-divider' })].concat(_toConsumableArray((0, _AddToShelfBatchActions2.default)({
	        items: selectedActionItems,
	        handleBatchAddToShelf: this.props.handleBatchAddToShelf
	      })));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-checked-out-list' },
	        _react2.default.createElement(
	          _BatchActionsListContainer2.default,
	          {
	            actionIsLoading: this.batchActionsLoading(),
	            list: this.props.actionList,
	            totalItems: this.props.totalCount,
	            renderActionsMenu: this.renderBatchActionsMenu },
	          function (selectedItems, updateItem) {
	            return _react2.default.createElement(
	              _ItemList2.default,
	              null,
	              _this4.props.items.map(function (item) {
	                return _this4.renderBibListItem(item, selectedItems, updateItem);
	              })
	            );
	          }
	        )
	      );
	    }
	  }]);
	
	  return CheckedOutList;
	}(_baseBcReactComponent2.default);
	
	exports.default = CheckedOutList;
	
	
	CheckedOutList.propTypes = {
	  accountId: _react.PropTypes.number,
	  items: _reactImmutableProptypes2.default.listOf(_bcPropTypes.checkedOutItemShape),
	  actionList: _reactImmutableProptypes2.default.list,
	  shelfTransactions: _reactImmutableProptypes2.default.map,
	  ratingsTransactions: _reactImmutableProptypes2.default.map,
	  totalCount: _react.PropTypes.number,
	  isFetching: _react.PropTypes.bool,
	  checkoutTransactions: _reactImmutableProptypes2.default.map,
	  renderBatchActionButtons: _react.PropTypes.func,
	  checkoutActions: _react.PropTypes.objectOf(_react.PropTypes.func),
	  workflowActions: _react.PropTypes.objectOf(_react.PropTypes.func),
	  ratings: _reactImmutableProptypes2.default.map,
	  ratingsActions: _react.PropTypes.objectOf(_react.PropTypes.func),
	  handleBatchRenew: _react.PropTypes.func,
	  handleBatchAddToShelf: _react.PropTypes.func
	};

/***/ },
/* 1655 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CheckedOutList = __webpack_require__(1654);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CheckedOutList).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1656 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CheckedOutPrintList = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(17);
	
	var _reactIntl = __webpack_require__(3);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _print = __webpack_require__(120);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _sharedFormatInfo = __webpack_require__(367);
	
	var _sharedFormatInfo2 = _interopRequireDefault(_sharedFormatInfo);
	
	var _sharedBibBrief = __webpack_require__(46);
	
	var _sharedBibBrief2 = _interopRequireDefault(_sharedBibBrief);
	
	var _CheckedOutStatusOverview = __webpack_require__(1669);
	
	var _CheckedOutStatusOverview2 = _interopRequireDefault(_CheckedOutStatusOverview);
	
	__webpack_require__(2463);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var renderFormat = function renderFormat(format, index, item) {
	  return _react2.default.createElement(_sharedFormatInfo2.default, { item: item.get('bib'), showLanguage: false });
	};
	
	var renderStatus = function renderStatus(status, index, item) {
	  return _react2.default.createElement(_CheckedOutStatusOverview2.default, { item: item });
	};
	
	var renderTitle = function renderTitle(title, index, item) {
	  return _react2.default.createElement(_sharedBibBrief2.default, {
	    bib: item.getIn(['bib', 'briefInfo']),
	    titleTag: 'span',
	    renderTitleAsLink: false,
	    renderAuthorsAsLink: false });
	};
	
	var CheckedOutPrintList = exports.CheckedOutPrintList = function (_BcReactComponent) {
	  _inherits(CheckedOutPrintList, _BcReactComponent);
	
	  function CheckedOutPrintList(props) {
	    _classCallCheck(this, CheckedOutPrintList);
	
	    var _this = _possibleConstructorReturn(this, (CheckedOutPrintList.__proto__ || Object.getPrototypeOf(CheckedOutPrintList)).call(this, props));
	
	    _this.bindAll('handleUpdatePage');
	    return _this;
	  }
	
	  _createClass(CheckedOutPrintList, [{
	    key: 'handleUpdatePage',
	    value: function handleUpdatePage() {
	      var _props = this.props,
	          router = _props.router,
	          pagination = _props.pagination;
	      var location = router.location;
	
	      var newPage = pagination.get('page') + 1;
	      router.push(_extends({}, location, { query: _extends({}, location.query, { page: newPage }) }));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          pagination = _props2.pagination,
	          items = _props2.items,
	          isFetching = _props2.isFetching;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-checked-out-print-list' },
	        _react2.default.createElement(
	          _print.PrintButtonsToolbar,
	          { numItemsToPrint: items.size },
	          _react2.default.createElement(_print.PrintLoadNextButton, {
	            handleClick: this.handleUpdatePage,
	            numToLoad: pagination.get('limit'),
	            totalPages: pagination.get('pages'),
	            currentPage: pagination.get('page'),
	            isLoading: isFetching })
	        ),
	        _react2.default.createElement(
	          'h1',
	          null,
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'section_title_checkedout' })
	        ),
	        _react2.default.createElement(
	          _reactIntl.FormattedMessage,
	          { id: 'label_number_of_items', values: { count: items.size } },
	          function (message) {
	            return _react2.default.createElement(
	              'p',
	              null,
	              message
	            );
	          }
	        ),
	        _react2.default.createElement(_print.PrintTable, {
	          rows: items,
	          fields: [{ key: 'bib.briefInfo.title', type: 'item-title', headerKey: 'table_headings_title', transformationMap: renderTitle }, { key: 'bib.briefInfo.format', type: 'item-format', headerKey: 'table_headings_format', transformationMap: renderFormat }, { key: 'bib.briefInfo.callNumber', type: 'item-callNumber', headerKey: 'callNumber' }, { key: 'barcode', type: 'item-barcode', headerKey: 'form_label_barcode' }, { key: 'status', type: 'item-status', headerKey: 'status_overview', transformationMap: renderStatus }] }),
	        _react2.default.createElement(
	          'div',
	          { className: 'page-info' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'form_label_current_page', values: { current_page: pagination.get('page') } }),
	          '\xA0',
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'form_label_total_pages', values: { total_pages: pagination.get('pages') } })
	        )
	      );
	    }
	  }]);
	
	  return CheckedOutPrintList;
	}(_baseBcReactComponent2.default);
	
	CheckedOutPrintList.propTypes = {
	  isFetching: _react.PropTypes.bool,
	  items: _reactImmutableProptypes2.default.listOf(_bcPropTypes.checkedOutItemShape),
	  pagination: _bcPropTypes.paginationShape,
	  router: _reactRouter.routerShape
	};
	
	exports.default = (0, _reactRouter.withRouter)(CheckedOutPrintList);

/***/ },
/* 1657 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CheckedOutPrintList = __webpack_require__(1656);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CheckedOutPrintList).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1658 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = CheckedOutQuotasPopOver;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseAccessibilityPopOver = __webpack_require__(514);
	
	var _baseAccessibilityPopOver2 = _interopRequireDefault(_baseAccessibilityPopOver);
	
	var _baseIcons = __webpack_require__(10);
	
	var _BorrowingQuotas = __webpack_require__(568);
	
	var _BorrowingQuotas2 = _interopRequireDefault(_BorrowingQuotas);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var renderTriggerContent = function renderTriggerContent() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_baseIcons.Info, null),
	    '\xA0',
	    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'checkedout_see_limits' })
	  );
	};
	
	function CheckedOutQuotasPopOver(_ref) {
	  var quotas = _ref.quotas;
	
	  if (!quotas || quotas.size === 0) {
	    return null;
	  }
	
	  return _react2.default.createElement(
	    'span',
	    { className: 'cp-checked-out-quotas-pop-over' },
	    _react2.default.createElement(
	      _baseAccessibilityPopOver2.default,
	      {
	        href: '#checked-out-quotas-pop-over',
	        triggerContent: renderTriggerContent() },
	      _react2.default.createElement(_BorrowingQuotas2.default, {
	        title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'checkedout_my_limits' }),
	        quotas: quotas })
	    )
	  );
	}
	
	CheckedOutQuotasPopOver.propTypes = {
	  quotas: _reactImmutableProptypes2.default.list
	};

/***/ },
/* 1659 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CheckedOutQuotasPopOver = __webpack_require__(1658);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CheckedOutQuotasPopOver).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1660 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = CheckedOutSecondaryInfo;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _CheckedOutDueOn = __webpack_require__(1649);
	
	var _CheckedOutDueOn2 = _interopRequireDefault(_CheckedOutDueOn);
	
	var _HeldCopiesCount = __webpack_require__(1677);
	
	var _HeldCopiesCount2 = _interopRequireDefault(_HeldCopiesCount);
	
	var _RenewCount = __webpack_require__(1682);
	
	var _RenewCount2 = _interopRequireDefault(_RenewCount);
	
	var _DueDateNotice = __webpack_require__(1675);
	
	var _DueDateNotice2 = _interopRequireDefault(_DueDateNotice);
	
	var _DollarAmount = __webpack_require__(286);
	
	var _DollarAmount2 = _interopRequireDefault(_DollarAmount);
	
	var _ItemField = __webpack_require__(237);
	
	var _ItemField2 = _interopRequireDefault(_ItemField);
	
	__webpack_require__(2464);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CheckedOutSecondaryInfo(_ref) {
	  var item = _ref.item;
	
	  var heldCopiesCount = item.getIn(['bib', 'availability', 'heldCopies'], 0);
	  var isDigital = item.getIn(['bib', 'policy', 'materialType']) === 'DIGITAL';
	  var renewCount = item.get('timesRenewed', 0);
	  var fines = item.get('fines', 0);
	  return _react2.default.createElement(
	    'div',
	    { className: 'cp-checked-out-secondary-info' },
	    _react2.default.createElement(_DueDateNotice2.default, {
	      status: item.get('status'),
	      dueDate: item.get('dueDate') }),
	    item.get('dueDate') && _react2.default.createElement(_CheckedOutDueOn2.default, {
	      dueDate: item.get('dueDate'),
	      isDigital: isDigital }),
	    heldCopiesCount > 0 && !isDigital && _react2.default.createElement(_HeldCopiesCount2.default, { count: heldCopiesCount }),
	    renewCount > 0 && _react2.default.createElement(_RenewCount2.default, { count: renewCount }),
	    fines > 0 && _react2.default.createElement(_ItemField2.default, {
	      className: 'fine-amount',
	      name: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'fines' }),
	      value: _react2.default.createElement(_DollarAmount2.default, { amount: fines }) })
	  );
	}
	
	CheckedOutSecondaryInfo.propTypes = {
	  item: _reactImmutableProptypes2.default.map
	};

/***/ },
/* 1661 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = CheckedOutSidebarLink;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _CheckedOutStatusIcon = __webpack_require__(281);
	
	var _CheckedOutStatusIcon2 = _interopRequireDefault(_CheckedOutStatusIcon);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _StatusSidebarLink = __webpack_require__(385);
	
	var _StatusSidebarLink2 = _interopRequireDefault(_StatusSidebarLink);
	
	var _NextDueDate = __webpack_require__(564);
	
	var _NextDueDate2 = _interopRequireDefault(_NextDueDate);
	
	__webpack_require__(2465);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var renderStatus = function renderStatus(status) {
	  return _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'checkedout_status_' + status.toLowerCase() });
	};
	
	var renderNextDue = function renderNextDue(nextDue) {
	  return _react2.default.createElement(_reactIntl.FormattedMessage, {
	    tagName: 'div',
	    id: 'label_next_due_on_date',
	    values: { date: _react2.default.createElement(_NextDueDate2.default, { date: nextDue.get('date') }) } });
	};
	
	function CheckedOutSidebarLink(_ref) {
	  var status = _ref.status,
	      selected = _ref.selected,
	      summary = _ref.summary,
	      nextDue = _ref.nextDue;
	
	  return _react2.default.createElement(
	    _StatusSidebarLink2.default,
	    {
	      className: 'cp-checked-out-sidebar-link',
	      selected: selected,
	      status: status,
	      icon: _react2.default.createElement(_CheckedOutStatusIcon2.default, { status: status }),
	      summary: summary,
	      statusText: renderStatus(status),
	      to: '/v2/checkedout/' + status.toLowerCase() },
	    nextDue && nextDue.get('status') === status && renderNextDue(nextDue) || null
	  );
	}
	
	CheckedOutSidebarLink.propTypes = {
	  status: _react.PropTypes.string,
	  selected: _react.PropTypes.bool,
	  summary: _reactImmutableProptypes2.default.map,
	  nextDue: _reactImmutableProptypes2.default.map
	};

/***/ },
/* 1662 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CheckedOutSidebarLink = __webpack_require__(1661);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CheckedOutSidebarLink).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1663 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CheckedOutStatus = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _reactRouter = __webpack_require__(17);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _utilsBorrowing = __webpack_require__(230);
	
	var _CheckedOutStatusIcon = __webpack_require__(281);
	
	var _CheckedOutStatusIcon2 = _interopRequireDefault(_CheckedOutStatusIcon);
	
	var _BorrowingStatus = __webpack_require__(182);
	
	var _BorrowingStatus2 = _interopRequireDefault(_BorrowingStatus);
	
	var _NextDueDate = __webpack_require__(564);
	
	var _NextDueDate2 = _interopRequireDefault(_NextDueDate);
	
	var _CheckedOutSidebarLink = __webpack_require__(1662);
	
	var _CheckedOutSidebarLink2 = _interopRequireDefault(_CheckedOutSidebarLink);
	
	var _SidebarCompactTitle = __webpack_require__(183);
	
	var _SidebarCompactTitle2 = _interopRequireDefault(_SidebarCompactTitle);
	
	var _AllSidebarLink = __webpack_require__(572);
	
	var _AllSidebarLink2 = _interopRequireDefault(_AllSidebarLink);
	
	__webpack_require__(2466);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var STATUS_ORDER = ['OVERDUE', 'COMING_DUE', 'OUT'];
	
	var CheckedOutStatus = exports.CheckedOutStatus = function (_BcReactComponent) {
	  _inherits(CheckedOutStatus, _BcReactComponent);
	
	  function CheckedOutStatus(props) {
	    _classCallCheck(this, CheckedOutStatus);
	
	    var _this = _possibleConstructorReturn(this, (CheckedOutStatus.__proto__ || Object.getPrototypeOf(CheckedOutStatus)).call(this, props));
	
	    _this.bindAll('renderGrouping');
	    return _this;
	  }
	
	  _createClass(CheckedOutStatus, [{
	    key: 'getTotalCount',
	    value: function getTotalCount() {
	      return (0, _utilsBorrowing.getTotalCountFromSummary)(this.props.summary);
	    }
	  }, {
	    key: 'renderAllItemsButton',
	    value: function renderAllItemsButton(groupedCheckouts) {
	      if (groupedCheckouts.size > 1) {
	        return _react2.default.createElement(_AllSidebarLink2.default, { to: '/v2/checkedout', selected: this.noStatusIsSelected() });
	      }
	
	      return null;
	    }
	  }, {
	    key: 'statusIsActive',
	    value: function statusIsActive(status) {
	      return this.props.router.location.pathname.includes('v2/checkedout/' + status.toLowerCase());
	    }
	  }, {
	    key: 'noStatusIsSelected',
	    value: function noStatusIsSelected() {
	      return this.props.router.location.pathname === '/v2/checkedout';
	    }
	  }, {
	    key: 'renderGrouping',
	    value: function renderGrouping(status) {
	      var nextDue = this.props.summary.get('nextDue');
	
	      return _react2.default.createElement(_CheckedOutSidebarLink2.default, {
	        key: 'checkedout-sidebar-link-' + status,
	        summary: this.props.summary,
	        status: status,
	        selected: this.statusIsActive(status),
	        nextDue: nextDue });
	    }
	  }, {
	    key: 'renderFullStatus',
	    value: function renderFullStatus() {
	      var statusSummaries = this.props.summary.get('status', _immutable2.default.Map());
	
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement(
	          _reactRouter.Link,
	          {
	            className: 'section-title',
	            to: '/v2/checkedout' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'section_title_checkedout' }),
	          _react2.default.createElement(
	            'span',
	            { className: 'pull-right', 'data-test-id': 'total-items-count' },
	            this.getTotalCount()
	          )
	        ),
	        this.renderAllItemsButton(statusSummaries),
	        statusSummaries.map(function (summary, status) {
	          return status;
	        }).toList().sortBy(function (status) {
	          return STATUS_ORDER.indexOf(status);
	        }).map(this.renderGrouping).toArray()
	      );
	    }
	  }, {
	    key: 'renderNextDue',
	    value: function renderNextDue() {
	      var nextDue = this.props.summary.get('nextDue');
	      return nextDue && nextDue.get('status') && _react2.default.createElement(
	        'span',
	        { className: (0, _classnames2.default)(nextDue.get('status').toLowerCase()) },
	        _react2.default.createElement(
	          'div',
	          { className: 'checkedout-status-icon' },
	          _react2.default.createElement(_CheckedOutStatusIcon2.default, { status: nextDue.get('status') })
	        ),
	        _react2.default.createElement(_NextDueDate2.default, { date: nextDue.get('date') })
	      );
	    }
	  }, {
	    key: 'renderOverdueCount',
	    value: function renderOverdueCount() {
	      var statusSummaries = this.props.summary.get('status', _immutable2.default.Map());
	      return statusSummaries.get('OVERDUE') && _react2.default.createElement(
	        'span',
	        { className: 'overdue' },
	        _react2.default.createElement(
	          'div',
	          { className: 'checkedout-status-icon status-icon' },
	          _react2.default.createElement(_CheckedOutStatusIcon2.default, { status: 'OVERDUE' })
	        ),
	        (0, _utilsBorrowing.getMaterialTypeCountsForStatus)(this.props.summary, 'OVERDUE')
	      );
	    }
	  }, {
	    key: 'renderCompactStatus',
	    value: function renderCompactStatus() {
	      var overDueCount = this.renderOverdueCount();
	      var nextDue = this.renderNextDue();
	
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement(_SidebarCompactTitle2.default, {
	          title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'section_title_checkedout' }),
	          count: this.getTotalCount() }),
	        (overDueCount || nextDue) && _react2.default.createElement(
	          'div',
	          { className: 'small checkedout-status' },
	          overDueCount,
	          nextDue
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _BorrowingStatus2.default,
	        { to: '/v2/checkedout', className: 'cp-checked-out-status', currentSection: this.props.currentSection },
	        this.props.currentSection ? this.renderFullStatus() : this.renderCompactStatus()
	      );
	    }
	  }]);
	
	  return CheckedOutStatus;
	}(_baseBcReactComponent2.default);
	
	CheckedOutStatus.PropTypes = {
	  summary: _reactImmutableProptypes2.default.mapContains({
	    nextDue: _reactImmutableProptypes2.default.mapContains({
	      date: _react.PropTypes.string,
	      status: _react.PropTypes.string
	    }),
	    status: _reactImmutableProptypes2.default.mapOf(_react.PropTypes.number, _react.PropTypes.string),
	    router: _reactRouter.routerShape
	  })
	};
	
	exports.default = (0, _reactRouter.withRouter)(CheckedOutStatus);

/***/ },
/* 1664 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CheckedOutStatus = __webpack_require__(1663);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CheckedOutStatus).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1665 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = CheckedOutStatusIcon;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseIcons = __webpack_require__(10);
	
	var _BorrowingStatusIcon = __webpack_require__(384);
	
	var _BorrowingStatusIcon2 = _interopRequireDefault(_BorrowingStatusIcon);
	
	__webpack_require__(2467);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getIcon = function getIcon(status) {
	  switch (status) {
	    case 'OVERDUE':
	      return _react2.default.createElement(_baseIcons.Attention, null);
	    case 'COMING_DUE':
	      return _react2.default.createElement(_baseIcons.CalendarWarning, null);
	    default:
	      return _react2.default.createElement(_baseIcons.CalendarEmpty, null);
	  }
	};
	
	function CheckedOutStatusIcon(_ref) {
	  var status = _ref.status,
	      withBackground = _ref.withBackground,
	      withLabel = _ref.withLabel;
	
	  var label = status && _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'checkedout_status_' + status.toLowerCase() });
	
	  return _react2.default.createElement(_BorrowingStatusIcon2.default, {
	    className: 'cp-checked-out-status-icon',
	    icon: getIcon(status),
	    status: status,
	    withBackground: withBackground,
	    renderLabel: withLabel && function () {
	      return label;
	    } });
	}
	
	CheckedOutStatusIcon.propTypes = {
	  status: _react.PropTypes.string.isRequired,
	  withBackground: _react.PropTypes.bool,
	  withLabel: _react.PropTypes.bool
	};

/***/ },
/* 1666 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = CheckedOutStatusName;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CheckedOutStatusName(_ref) {
	  var status = _ref.status,
	      className = _ref.className;
	
	  if (status) {
	    var classNames = (0, _classnames2.default)('cp-checked-out-status-name', className);
	    return _react2.default.createElement(
	      _reactIntl.FormattedMessage,
	      { id: 'checkedout_status_' + status.toLowerCase() },
	      function (message) {
	        return _react2.default.createElement(
	          'span',
	          { className: classNames },
	          message
	        );
	      }
	    );
	  }
	
	  return null;
	}
	
	CheckedOutStatusName.propTypes = {
	  className: _react.PropTypes.string,
	  status: _react.PropTypes.string
	};

/***/ },
/* 1667 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CheckedOutStatusName = __webpack_require__(1666);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CheckedOutStatusName).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1668 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = CheckedOutStatusOverview;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _moment = __webpack_require__(9);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _CheckedOutStatusName = __webpack_require__(1667);
	
	var _CheckedOutStatusName2 = _interopRequireDefault(_CheckedOutStatusName);
	
	var _ItemField = __webpack_require__(237);
	
	var _ItemField2 = _interopRequireDefault(_ItemField);
	
	__webpack_require__(2468);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getDueDate = function getDueDate(item) {
	  if (item.get('dueDate')) {
	    return (0, _moment2.default)(item.get('dueDate'), 'YYYY-MM-DD').format('MMM DD, YYYY');
	  }
	
	  return null;
	};
	
	var isDownloadable = function isDownloadable(item) {
	  return item.getIn(['bib', 'policy', 'materialPolicy', 'supportsDownload'], false);
	};
	
	function CheckedOutStatusOverview(_ref) {
	  var item = _ref.item;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'cp-checked-out-status-overview' },
	    item.get('status') !== 'OUT' && _react2.default.createElement(_CheckedOutStatusName2.default, { status: item.get('status') }),
	    _react2.default.createElement(_ItemField2.default, {
	      name: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'dueDate' }),
	      value: getDueDate(item) }),
	    !isDownloadable(item) && _react2.default.createElement(_ItemField2.default, {
	      name: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'label_times_renewed' }),
	      value: item.get('timesRenewed') === 0 ? '0' : item.get('timesRenewed') })
	  );
	}
	
	CheckedOutStatusOverview.propTypes = {
	  item: _bcPropTypes.checkedOutItemShape
	};

/***/ },
/* 1669 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CheckedOutStatusOverview = __webpack_require__(1668);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CheckedOutStatusOverview).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1670 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _BorrowingUtilityBarTitle = __webpack_require__(569);
	
	var _BorrowingUtilityBarTitle2 = _interopRequireDefault(_BorrowingUtilityBarTitle);
	
	var _BorrowingUtilityBar = __webpack_require__(285);
	
	var _BorrowingUtilityBar2 = _interopRequireDefault(_BorrowingUtilityBar);
	
	var _CheckedOutStatusIcon = __webpack_require__(281);
	
	var _CheckedOutStatusIcon2 = _interopRequireDefault(_CheckedOutStatusIcon);
	
	var _MaterialTypeFilterLinks = __webpack_require__(571);
	
	var _MaterialTypeFilterLinks2 = _interopRequireDefault(_MaterialTypeFilterLinks);
	
	var _CheckedOutQuotasPopOver = __webpack_require__(1659);
	
	var _CheckedOutQuotasPopOver2 = _interopRequireDefault(_CheckedOutQuotasPopOver);
	
	__webpack_require__(2469);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CheckedOutUtilityBar = function (_BCReactComponent) {
	  _inherits(CheckedOutUtilityBar, _BCReactComponent);
	
	  function CheckedOutUtilityBar() {
	    _classCallCheck(this, CheckedOutUtilityBar);
	
	    return _possibleConstructorReturn(this, (CheckedOutUtilityBar.__proto__ || Object.getPrototypeOf(CheckedOutUtilityBar)).apply(this, arguments));
	  }
	
	  _createClass(CheckedOutUtilityBar, [{
	    key: 'canFilter',
	    value: function canFilter() {
	      var materialTypeCounts = this.props.materialTypeCounts;
	
	      return materialTypeCounts && materialTypeCounts.get('DIGITAL', 0) > 0 && materialTypeCounts.get('PHYSICAL', 0) > 0;
	    }
	  }, {
	    key: 'renderIcon',
	    value: function renderIcon() {
	      return this.props.status && _react2.default.createElement(_CheckedOutStatusIcon2.default, { status: this.props.status, withBackground: true });
	    }
	  }, {
	    key: 'renderTitle',
	    value: function renderTitle() {
	      var showFilterLinks = this.canFilter();
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_BorrowingUtilityBarTitle2.default, {
	          status: this.props.status,
	          statusIcon: this.renderIcon(),
	          count: this.props.totalCount }),
	        showFilterLinks && _react2.default.createElement(_MaterialTypeFilterLinks2.default, {
	          totalCount: this.props.totalCount,
	          materialTypeCounts: this.props.materialTypeCounts }),
	        this.props.allItemsDigital && _react2.default.createElement(_CheckedOutQuotasPopOver2.default, { quotas: this.props.quotas })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_BorrowingUtilityBar2.default, {
	        className: 'cp-checked-out-utility-bar',
	        title: this.renderTitle(),
	        printURL: this.props.printURL,
	        pagination: this.props.pagination,
	        sortOptions: this.props.sortOptions });
	    }
	  }]);
	
	  return CheckedOutUtilityBar;
	}(_baseBcReactComponent2.default);
	
	exports.default = CheckedOutUtilityBar;
	
	
	CheckedOutUtilityBar.propTypes = {
	  allItemsDigital: _react.PropTypes.bool,
	  status: _react.PropTypes.string,
	  totalCount: _react.PropTypes.number,
	  materialTypeCounts: _reactImmutableProptypes2.default.mapContains({
	    PHYSICAL: _react.PropTypes.number,
	    DIGITAL: _react.PropTypes.number
	  }),
	  sortOptions: _reactImmutableProptypes2.default.list,
	  handleSort: _react.PropTypes.func,
	  printURL: _react.PropTypes.string,
	  quotas: _reactImmutableProptypes2.default.listOf(_bcPropTypes.borrowingQuotaShape),
	  pagination: _reactImmutableProptypes2.default.map
	};

/***/ },
/* 1671 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CheckedOutUtilityBar = __webpack_require__(1670);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CheckedOutUtilityBar).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1672 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = DigitalItemInfo;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _ItemField = __webpack_require__(237);
	
	var _ItemField2 = _interopRequireDefault(_ItemField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var renderFormat = function renderFormat(format) {
	  if (format) {
	    return _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'digiformat_' + format.toLowerCase() });
	  }
	
	  return null;
	};
	
	var renderFileType = function renderFileType(format, size) {
	  return _react2.default.createElement(
	    'span',
	    null,
	    renderFormat(format),
	    format && size ? ' | ' : null,
	    size
	  );
	};
	
	function DigitalItemInfo(_ref) {
	  var bib = _ref.bib,
	      size = _ref.size,
	      format = _ref.format;
	
	  if (bib.getIn(['policy', 'materialType']) !== 'DIGITAL') {
	    return null;
	  }
	
	  if (!size && !format) {
	    return null;
	  }
	
	  return _react2.default.createElement(_ItemField2.default, {
	    className: 'cp-digital-item-info',
	    name: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'file_type' }),
	    value: renderFileType(format, size) });
	}
	
	DigitalItemInfo.propTypes = {
	  bib: _bcPropTypes.bibShape,
	  size: _react.PropTypes.string,
	  format: _react.PropTypes.string
	};

/***/ },
/* 1673 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DigitalItemInfo = __webpack_require__(1672);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DigitalItemInfo).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1674 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _moment = __webpack_require__(9);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _CheckedOutStatusIcon = __webpack_require__(281);
	
	var _CheckedOutStatusIcon2 = _interopRequireDefault(_CheckedOutStatusIcon);
	
	__webpack_require__(2470);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DueDateNotice = function (_BCReactComponent) {
	  _inherits(DueDateNotice, _BCReactComponent);
	
	  function DueDateNotice() {
	    _classCallCheck(this, DueDateNotice);
	
	    return _possibleConstructorReturn(this, (DueDateNotice.__proto__ || Object.getPrototypeOf(DueDateNotice)).apply(this, arguments));
	  }
	
	  _createClass(DueDateNotice, [{
	    key: 'getDaysAway',
	    value: function getDaysAway() {
	      var today = (0, _moment2.default)().startOf('day');
	      var days = today.diff(this.props.dueDate, 'days');
	      return Math.abs(days);
	    }
	  }, {
	    key: 'isDueToday',
	    value: function isDueToday() {
	      return this.getDaysAway() < 1;
	    }
	  }, {
	    key: 'isOneDayAway',
	    value: function isOneDayAway() {
	      var daysAway = this.getDaysAway();
	      return daysAway >= 1 && daysAway < 2;
	    }
	  }, {
	    key: 'renderDaysRemaining',
	    value: function renderDaysRemaining() {
	      var _props = this.props,
	          status = _props.status,
	          dueDate = _props.dueDate;
	
	
	      var timeSince = this.isOneDayAway() ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'number_of_days', values: { count: 1 } }) : (0, _moment2.default)().startOf('day').to(dueDate, true);
	
	      return _react2.default.createElement(_reactIntl.FormattedMessage, {
	        id: 'label_due_date_notice',
	        values: { status: status, timeSince: timeSince } });
	    }
	  }, {
	    key: 'renderDate',
	    value: function renderDate() {
	      var _props2 = this.props,
	          status = _props2.status,
	          dueDate = _props2.dueDate;
	
	      return this.isDueToday() ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'due_today' }) : this.renderDaysRemaining(status, dueDate);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          status = _props3.status,
	          dueDate = _props3.dueDate;
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('cp-due-date-notice', status && status.toLowerCase()) },
	        _react2.default.createElement(_CheckedOutStatusIcon2.default, {
	          status: status,
	          withBackground: true,
	          withLabel: true }),
	        _react2.default.createElement(
	          'span',
	          { className: 'due-date-notice' },
	          dueDate && this.renderDate()
	        )
	      );
	    }
	  }]);
	
	  return DueDateNotice;
	}(_baseBcReactComponent2.default);
	
	exports.default = DueDateNotice;
	
	
	DueDateNotice.propTypes = {
	  status: _react.PropTypes.string,
	  dueDate: _react.PropTypes.string
	};

/***/ },
/* 1675 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DueDateNotice = __webpack_require__(1674);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DueDateNotice).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1676 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = HeldCopiesCount;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function HeldCopiesCount(_ref) {
	  var count = _ref.count;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'cp-held-copies-count' },
	    _react2.default.createElement(_reactIntl.FormattedMessage, {
	      id: count === 1 ? 'held_copies_count' : 'held_copies_count_plural',
	      values: { count: count } })
	  );
	}
	
	HeldCopiesCount.propTypes = {
	  count: _react.PropTypes.number
	};

/***/ },
/* 1677 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _HeldCopiesCount = __webpack_require__(1676);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_HeldCopiesCount).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1678 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = NextDueDate;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _moment = __webpack_require__(9);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function NextDueDate(_ref) {
	  var date = _ref.date;
	
	  // MMM D
	  return _react2.default.createElement(
	    _reactIntl.FormattedDate,
	    {
	      value: (0, _moment2.default)(date).toDate(),
	      month: 'short',
	      day: '2-digit' },
	    function (formattedDate) {
	      return _react2.default.createElement(
	        'span',
	        { className: 'cp-next-due-date' },
	        formattedDate
	      );
	    }
	  );
	}
	
	NextDueDate.propTypes = {
	  date: _react.PropTypes.string
	};

/***/ },
/* 1679 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = RenewButton;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseButtons = __webpack_require__(12);
	
	__webpack_require__(2471);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function RenewButton(_ref) {
	  var canRenew = _ref.canRenew,
	      canReturn = _ref.canReturn,
	      disabled = _ref.disabled,
	      handleClick = _ref.handleClick,
	      isLoading = _ref.isLoading;
	
	  if (!canRenew) {
	    return _react2.default.createElement(
	      'div',
	      { className: 'cp-renew-button' },
	      _react2.default.createElement(
	        'div',
	        { className: 'cannot-renew-text' },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: canReturn ? 'label_cannot_renew' : 'label_cannot_renew_or_return' })
	      )
	    );
	  }
	
	  return _react2.default.createElement(
	    _baseButtons.PrimaryButton,
	    {
	      block: true,
	      disabled: disabled,
	      isLoading: isLoading,
	      className: 'cp-renew-button',
	      handleClick: handleClick },
	    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_renew_checkedout' })
	  );
	}
	
	RenewButton.propTypes = {
	  disabled: _react.PropTypes.bool,
	  canRenew: _react.PropTypes.bool,
	  canReturn: _react.PropTypes.bool,
	  handleClick: _react.PropTypes.func,
	  isLoading: _react.PropTypes.bool
	};

/***/ },
/* 1680 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _RenewButton = __webpack_require__(1679);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RenewButton).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1681 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = RenewCount;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function RenewCount(_ref) {
	  var count = _ref.count;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'cp-renew-count' },
	    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'renewed' }),
	    ' ',
	    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'times_renewed', values: { count: count } })
	  );
	}
	
	RenewCount.propTypes = {
	  count: _react.PropTypes.number
	};

/***/ },
/* 1682 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _RenewCount = __webpack_require__(1681);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RenewCount).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1683 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseFullScreenOverlay = __webpack_require__(45);
	
	var _baseFullScreenOverlay2 = _interopRequireDefault(_baseFullScreenOverlay);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseTable = __webpack_require__(91);
	
	var _ShortFormattedDate = __webpack_require__(60);
	
	var _ShortFormattedDate2 = _interopRequireDefault(_ShortFormattedDate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var tableFields = [{
	  key: 'bib.briefInfo.title',
	  headerKey: 'table_headings_title',
	  type: 'string'
	}, {
	  key: 'bib.briefInfo.authors',
	  headerKey: 'table_headings_author',
	  type: 'string',
	  transformationMap: function transformationMap(authors) {
	    return authors.map(function (author) {
	      return _react2.default.createElement(
	        'div',
	        null,
	        author
	      );
	    });
	  }
	}, {
	  key: 'errorResponseDTO.message',
	  headerKey: 'table_headings_reason',
	  type: 'string'
	}, {
	  key: 'checkout.dueDate',
	  headerKey: 'table_headings_due_date',
	  type: 'string',
	  transformationMap: function transformationMap(value) {
	    return _react2.default.createElement(_ShortFormattedDate2.default, { value: value });
	  }
	}];
	
	var RenewFailureOverlay = function (_BcReactComponent) {
	  _inherits(RenewFailureOverlay, _BcReactComponent);
	
	  function RenewFailureOverlay() {
	    _classCallCheck(this, RenewFailureOverlay);
	
	    return _possibleConstructorReturn(this, (RenewFailureOverlay.__proto__ || Object.getPrototypeOf(RenewFailureOverlay)).apply(this, arguments));
	  }
	
	  _createClass(RenewFailureOverlay, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (this.props.open && !prevProps.open) {
	        this.props.messagingActions.clearGlobalMessage();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          open = _props.open,
	          handleClose = _props.handleClose,
	          failures = _props.failures;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-renew-failure-overlay' },
	        _react2.default.createElement(
	          _baseFullScreenOverlay2.default,
	          {
	            handleClose: handleClose,
	            open: open },
	          _react2.default.createElement(_reactIntl.FormattedMessage, {
	            tagName: 'h2',
	            id: 'unable_to_renew_title',
	            values: { count: failures.size } }),
	          _react2.default.createElement(_reactIntl.FormattedMessage, { tagName: 'p', id: 'following_items_not_renewed' }),
	          _react2.default.createElement(_baseTable.Table, { rows: failures, fields: tableFields })
	        )
	      );
	    }
	  }]);
	
	  return RenewFailureOverlay;
	}(_baseBcReactComponent2.default);
	
	exports.default = RenewFailureOverlay;
	
	
	RenewFailureOverlay.propTypes = {
	  open: _react.PropTypes.bool,
	  failures: _reactImmutableProptypes2.default.list,
	  messagingActions: _react.PropTypes.objectOf(_react.PropTypes.func),
	  handleClose: _react.PropTypes.func
	};

/***/ },
/* 1684 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _RenewFailureOverlay = __webpack_require__(1683);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RenewFailureOverlay).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1685 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Capsule;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _bcPropTypes = __webpack_require__(5);
	
	__webpack_require__(2472);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Capsule(_ref) {
	  var className = _ref.className,
	      children = _ref.children;
	
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)('cp-capsule', className) },
	    children
	  );
	}
	
	Capsule.propTypes = {
	  className: _react.PropTypes.string,
	  children: _bcPropTypes.childrenShape
	};

/***/ },
/* 1686 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = FineDateFields;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _ShortFormattedDate = __webpack_require__(60);
	
	var _ShortFormattedDate2 = _interopRequireDefault(_ShortFormattedDate);
	
	__webpack_require__(2473);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var renderDateField = function renderDateField(name, date) {
	  if (date) {
	    return _react2.default.createElement(
	      'div',
	      { className: 'fine-date-field' },
	      _react2.default.createElement(_reactIntl.FormattedMessage, {
	        id: 'fines_date_field_' + name,
	        values: { date: _react2.default.createElement(_ShortFormattedDate2.default, { value: date }) } })
	    );
	  }
	
	  return null;
	};
	
	function FineDateFields(_ref) {
	  var fine = _ref.fine;
	
	  var checkedOutDate = fine.get('checkedOutDate');
	  var dueDate = fine.get('dueDate');
	  var returnedDate = fine.get('returnedDate');
	  var renewedDate = fine.get('renewedDate');
	
	  var anyDatePresent = checkedOutDate || dueDate || returnedDate || renewedDate;
	
	  if (anyDatePresent) {
	    return _react2.default.createElement(
	      'div',
	      { className: 'cp-fine-date-fields' },
	      renderDateField('checked_out', checkedOutDate),
	      renderDateField('due', dueDate),
	      renderDateField('returned', returnedDate),
	      renderDateField('renewed', renewedDate)
	    );
	  }
	
	  return null;
	}
	
	FineDateFields.propTypes = {
	  fine: _reactImmutableProptypes2.default.map
	};

/***/ },
/* 1687 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FineDateFields = __webpack_require__(1686);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FineDateFields).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1688 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = FineStatusCapsule;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _baseIcons = __webpack_require__(10);
	
	var _Capsule = __webpack_require__(565);
	
	var _Capsule2 = _interopRequireDefault(_Capsule);
	
	__webpack_require__(2474);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getIconForStatus = function getIconForStatus(status) {
	  switch (status) {
	    case 'PAID':
	      return _react2.default.createElement(_baseIcons.Checkmark, { color: 'currentColor' });
	    case 'ACCRUING':
	      return _react2.default.createElement(_baseIcons.Warning, null);
	    case 'CREDIT':
	      return _react2.default.createElement(_baseIcons.Plus, null);
	    default:
	      return null;
	  }
	};
	
	function FineStatusCapsule(_ref) {
	  var status = _ref.status;
	
	  var formattedStatus = status && status.toLowerCase();
	
	  var className = (0, _classnames2.default)('cp-fine-status-capsule', formattedStatus);
	
	  return _react2.default.createElement(
	    _Capsule2.default,
	    { className: className },
	    getIconForStatus(status),
	    ' ',
	    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'fines_' + formattedStatus })
	  );
	}
	
	FineStatusCapsule.propTypes = {
	  status: _react.PropTypes.string
	};

/***/ },
/* 1689 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FineStatusCapsule = __webpack_require__(1688);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FineStatusCapsule).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1690 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(17);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _BorrowingList = __webpack_require__(236);
	
	var _BorrowingList2 = _interopRequireDefault(_BorrowingList);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _baseCheckbox = __webpack_require__(58);
	
	var _baseCheckbox2 = _interopRequireDefault(_baseCheckbox);
	
	var _baseTable = __webpack_require__(91);
	
	var _BatchActionsControls = __webpack_require__(585);
	
	var _BatchActionsControls2 = _interopRequireDefault(_BatchActionsControls);
	
	var _baseButtons = __webpack_require__(12);
	
	var _sharedProgressBar = __webpack_require__(94);
	
	var _sharedProgressBar2 = _interopRequireDefault(_sharedProgressBar);
	
	__webpack_require__(2475);
	
	var _sharedMessages = __webpack_require__(64);
	
	var _MessagingContainer = __webpack_require__(68);
	
	var _MessagingContainer2 = _interopRequireDefault(_MessagingContainer);
	
	var _utilsLink = __webpack_require__(97);
	
	var _FinesUtilityBar = __webpack_require__(1698);
	
	var _FinesUtilityBar2 = _interopRequireDefault(_FinesUtilityBar);
	
	var _pagination = __webpack_require__(92);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _DollarAmount = __webpack_require__(286);
	
	var _DollarAmount2 = _interopRequireDefault(_DollarAmount);
	
	var _BorrowingHeader = __webpack_require__(124);
	
	var _BorrowingHeader2 = _interopRequireDefault(_BorrowingHeader);
	
	var _FinesEmptyContentPanel = __webpack_require__(1693);
	
	var _FinesEmptyContentPanel2 = _interopRequireDefault(_FinesEmptyContentPanel);
	
	var _BatchActionsToolbar = __webpack_require__(586);
	
	var _BatchActionsToolbar2 = _interopRequireDefault(_BatchActionsToolbar);
	
	var _baseDropdown = __webpack_require__(37);
	
	var _BatchActionLink = __webpack_require__(238);
	
	var _BatchActionLink2 = _interopRequireDefault(_BatchActionLink);
	
	var _FineStatusCapsule = __webpack_require__(1689);
	
	var _FineStatusCapsule2 = _interopRequireDefault(_FineStatusCapsule);
	
	var _FineDateFields = __webpack_require__(1687);
	
	var _FineDateFields2 = _interopRequireDefault(_FineDateFields);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var fineIsPayable = function fineIsPayable(fine) {
	  return fine.get('status').includes('UNPAID') && !fine.get('accruing') && !fine.get('credit');
	};
	
	// TODO: BCRest will be updated to return 'CREDIT', 'ACCRUING', 'PAID', or 'UNPAID' for the status
	// in CORE-51497. Currently the status is 'UNPAID' for credit and accruing fines.
	var getFineStatus = function getFineStatus(fine) {
	  return fine.get('credit') && 'CREDIT' || fine.get('accruing') && 'ACCRUING' || fine.get('status');
	};
	
	var renderAmountAndStatus = function renderAmountAndStatus(value, index, fine) {
	  var status = getFineStatus(fine);
	  var dollarAmount = _react2.default.createElement(_DollarAmount2.default, { amount: value });
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'fine-amount-and-status' },
	    dollarAmount,
	    status !== 'UNPAID' && _react2.default.createElement(
	      'div',
	      { className: 'fine-status' },
	      _react2.default.createElement(_FineStatusCapsule2.default, { status: status })
	    )
	  );
	};
	
	var Fines = function (_BcReactComponent) {
	  _inherits(Fines, _BcReactComponent);
	
	  function Fines(props) {
	    _classCallCheck(this, Fines);
	
	    var _this = _possibleConstructorReturn(this, (Fines.__proto__ || Object.getPrototypeOf(Fines)).call(this, props));
	
	    _this.state = {
	      selectedItems: _immutable2.default.Map(),
	      showEmptyFineError: false
	    };
	
	    _this.bindAll('handleSort', 'renderFinesCheckbox', 'toggleFineSelection', 'selectAll', 'payAll', 'createMarkup', 'postToFinesGateway', 'paySelected', 'getSortOptions', 'handleSort', 'updatePage', 'refreshTable', 'renderBatchActionsMenu', 'renderBatchActionsToolbar');
	    return _this;
	  }
	
	  _createClass(Fines, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.paymentForm && nextProps.paymentForm !== this.props.paymentForm) {
	        setTimeout(function () {
	          document.getElementById('checkout').submit();
	        }, 0);
	      }
	
	      var pageChanged = nextProps.currentPage !== this.props.currentPage;
	      var sortChanged = nextProps.location.query.sort !== this.props.location.query.sort;
	      if (pageChanged || sortChanged) {
	        this.props.FinesActions.updatePage(_extends({}, location.query, {
	          page: nextProps.currentPage,
	          sort: nextProps.location.query.sort,
	          accountId: this.props.account.get('id')
	        }));
	      }
	    }
	  }, {
	    key: 'selectAll',
	    value: function selectAll(selected) {
	      if (selected) {
	        this.setState({
	          selectedItems: this.props.fines.filter(function (fine) {
	            return fineIsPayable(fine);
	          }).map(function (fine) {
	            return fine.get('id');
	          }).reduce(function (result, item) {
	            return result.set(item, item);
	          }, _immutable2.default.Map())
	        });
	      } else {
	        this.setState({
	          selectedItems: _immutable2.default.Map()
	        });
	      }
	    }
	  }, {
	    key: 'toggleFineSelection',
	    value: function toggleFineSelection(e, _ref) {
	      var id = _ref.value;
	
	      var isSelected = this.state.selectedItems.has(id);
	      if (isSelected) {
	        return this.setState({
	          selectedItems: this.state.selectedItems.deleteIn([id])
	        });
	      }
	
	      return this.setState({
	        selectedItems: this.state.selectedItems.set(id)
	      });
	    }
	  }, {
	    key: 'renderFinesCheckbox',
	    value: function renderFinesCheckbox(value, index, fine) {
	      var payable = fineIsPayable(fine);
	
	      return _react2.default.createElement(_baseCheckbox2.default, {
	        id: 'item_' + value,
	        handleChange: this.toggleFineSelection,
	        name: 'items[]',
	        disabled: !payable,
	        checked: this.state.selectedItems.has(value),
	        value: value,
	        label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'batch_actions_checkbox' }),
	        srOnlyLabel: true,
	        inline: true });
	    }
	  }, {
	    key: 'postToFinesGateway',
	    value: function postToFinesGateway(query) {
	      this.props.FinesActions.fetchFinesPaymentForm(query);
	    }
	  }, {
	    key: 'payAll',
	    value: function payAll() {
	      this.postToFinesGateway({ payAll: 1 });
	    }
	  }, {
	    key: 'paySelected',
	    value: function paySelected() {
	      var items = [];
	      if (this.state.selectedItems.size === 0) {
	        this.setState({ showEmptyFineError: true });
	      } else {
	        this.state.selectedItems.forEach(function (k, v) {
	          items.push('' + v);
	        });
	        this.postToFinesGateway({ items: items });
	      }
	    }
	  }, {
	    key: 'createMarkup',
	    value: function createMarkup() {
	      return { __html: this.props.paymentForm };
	    }
	  }, {
	    key: 'getUrlWithPatronInfo',
	    value: function getUrlWithPatronInfo(url) {
	      var newUrl = url.replace('{patronID}', this.props.user.get('id'));
	      newUrl = newUrl.replace('{barcode}', this.props.account.get('barcode'));
	      return newUrl;
	    }
	  }, {
	    key: 'renderFinesPaymentButtons',
	    value: function renderFinesPaymentButtons() {
	      var finesSettings = this.props.onlineFinesPayment;
	      var popup = finesSettings.get('popup');
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-fines-buttons' },
	        finesSettings.get('message') && _react2.default.createElement(
	          'div',
	          { className: 'col-sm-7' },
	          finesSettings.get('message')
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: finesSettings.get('message') ? 'col-sm-5' : 'col-sm-12' },
	          finesSettings.get('url') && _react2.default.createElement(
	            _reactRouter.Link,
	            { to: this.getUrlWithPatronInfo(finesSettings.get('url')), target: popup ? '_blank' : '_self', className: 'btn cp-primary-btn btn-primary pay-all' },
	            finesSettings.get('text') ? finesSettings.get('text') : this.props.intl.formatMessage({ id: 'pay_all' }) + ' ',
	            !finesSettings.get('text') ? _react2.default.createElement(_DollarAmount2.default, { amount: this.props.summary.get('totalFines', 0) }) : ''
	          ),
	          finesSettings.get('url2') && _react2.default.createElement(
	            _reactRouter.Link,
	            { to: this.getUrlWithPatronInfo(finesSettings.get('url2')), target: popup ? '_blank' : '_self', className: 'btn cp-primary-btn btn-secondary pay-all' },
	            finesSettings.get('text2')
	          ),
	          finesSettings.get('type') && _react2.default.createElement(
	            _baseButtons.PrimaryButton,
	            { handleClick: this.payAll, className: 'pay-all' },
	            this.props.intl.formatMessage({ id: 'pay_all' }),
	            ' ',
	            _react2.default.createElement(_DollarAmount2.default, { amount: this.props.summary.get('totalFines', 0) })
	          )
	        ),
	        _react2.default.createElement('div', {
	          className: 'payflow_invisible_form'
	          // eslint-disable-next-line react/no-danger
	          , dangerouslySetInnerHTML: this.createMarkup() })
	      );
	    }
	  }, {
	    key: 'getSortOptions',
	    value: function getSortOptions() {
	      var currentSort = this.props.router.location.query.sort || 'messageDate';
	      return ['messageDate', 'bibTitle', 'amount', 'description'].reduce(function (acc, val) {
	        return acc.set(val, _immutable2.default.Map({
	          id: val,
	          applied: val === currentSort
	        }));
	      }, _immutable2.default.Map()).toList();
	    }
	  }, {
	    key: 'handleSort',
	    value: function handleSort(sortType) {
	      var _props = this.props,
	          location = _props.location,
	          router = _props.router;
	
	      router.push(_extends({}, location, {
	        query: _extends({}, location.query, {
	          page: this.props.router.location.query.page,
	          sort: sortType
	        })
	      }));
	      this.props.FinesActions.updatePage(_extends({}, location.query, {
	        page: this.props.router.location.query.page,
	        sort: sortType,
	        accountId: this.props.account.get('id')
	      }));
	    }
	  }, {
	    key: 'updatePage',
	    value: function updatePage(page) {
	      var sort = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'messageDate';
	      var _props2 = this.props,
	          location = _props2.location,
	          router = _props2.router;
	
	      router.push(_extends({}, location, {
	        query: _extends({}, location.query, {
	          page: page,
	          sort: sort
	        })
	      }));
	      this.props.FinesActions.updatePage(_extends({}, location.query, {
	        page: page,
	        sort: sort,
	        accountId: this.props.account.get('id')
	      }));
	    }
	  }, {
	    key: 'refreshTable',
	    value: function refreshTable() {
	      this.updatePage(1);
	    }
	  }, {
	    key: 'getPagination',
	    value: function getPagination() {
	      var _props3 = this.props,
	          currentPage = _props3.currentPage,
	          pageSize = _props3.pageSize,
	          totalItems = _props3.totalItems,
	          totalPages = _props3.totalPages;
	
	      return _immutable2.default.Map({
	        page: currentPage,
	        limit: pageSize,
	        count: totalItems,
	        pages: totalPages
	      });
	    }
	  }, {
	    key: 'updateAll',
	    value: function updateAll() {
	      this.setState({
	        selectedItems: _immutable2.default.Map()
	      });
	    }
	  }, {
	    key: 'renderBatchActionsToolbar',
	    value: function renderBatchActionsToolbar() {
	      var _this2 = this;
	
	      return _react2.default.createElement(_BatchActionsToolbar2.default, {
	        actionIsLoading: this.props.isFetching,
	        handleClear: function handleClear() {
	          return _this2.updateAll(false);
	        },
	        renderActionsMenu: this.renderBatchActionsMenu,
	        totalItems: this.props.totalItems,
	        messagingActions: this.props.messagingActions,
	        selectedItems: this.state.selectedItems });
	    }
	  }, {
	    key: 'getSelectedTotal',
	    value: function getSelectedTotal() {
	      var _this3 = this;
	
	      var finesTotal = 0;
	      this.props.fines.forEach(function (fine) {
	        _this3.state.selectedItems.keySeq().forEach(function (v) {
	          if (fine.get('id') === v) {
	            if (fineIsPayable(fine)) {
	              finesTotal += fine.get('amount');
	            }
	          }
	        });
	      });
	
	      return finesTotal;
	    }
	  }, {
	    key: 'renderBatchActionsMenu',
	    value: function renderBatchActionsMenu(selectedActionItems) {
	      return [_react2.default.createElement(
	        _baseDropdown.DropdownMenuItem,
	        { key: 'fines-batch-actions-pay' },
	        _react2.default.createElement(
	          _BatchActionLink2.default,
	          {
	            disabled: selectedActionItems.size === 0,
	            href: '#fines-batch-actions-pay',
	            handleClick: this.paySelected },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'pay_selected' }),
	          '\xA0 (',
	          _react2.default.createElement(_DollarAmount2.default, { amount: this.getSelectedTotal() }),
	          ')'
	        )
	      )];
	    }
	  }, {
	    key: 'formatFines',
	    value: function formatFines() {
	      var _this4 = this;
	
	      var indiviualFinePayment = this.props.onlineFinesPayment ? this.props.onlineFinesPayment.get('individual_fine_payment') : false;
	      var formattedFines = this.props.fines.map(function (fine) {
	        var newFine = fine;
	
	        if (!fine.get('description') && fine.get('message')) {
	          newFine = newFine.set('description', fine.get('message'));
	        }
	
	        return newFine;
	      }).toList();
	
	      formattedFines = formattedFines.map(function (row) {
	        var newRow = row;
	        _this4.state.selectedItems.keySeq().forEach(function (v) {
	          if (row.get('id') === v) {
	            newRow = row.set('selected', true);
	          }
	        });
	        if (!indiviualFinePayment) {
	          newRow = newRow.delete('id');
	        }
	        return newRow;
	      });
	
	      return formattedFines;
	    }
	  }, {
	    key: 'renderContent',
	    value: function renderContent() {
	      var _this5 = this;
	
	      var _props4 = this.props,
	          fines = _props4.fines,
	          onlineFinesPayment = _props4.onlineFinesPayment,
	          isFetching = _props4.isFetching;
	
	      var payableFines = fines.size > 0 ? fines.filter(fineIsPayable) : 0;
	
	      var indiviualFinePayment = onlineFinesPayment ? onlineFinesPayment.get('individual_fine_payment') : false;
	      var finePaymentAllowed = onlineFinesPayment && payableFines.size > 0;
	
	      if (fines.size === 0) {
	        return _react2.default.createElement(_FinesEmptyContentPanel2.default, { fetching: isFetching });
	      }
	
	      var fields = [{ key: 'id', type: 'id', headerKey: 'table_headings_item_select', transformationMap: this.renderFinesCheckbox, leftAlignedCheckbox: true }, { key: 'messageDate', id: 'facets_fine_date', headerKey: 'facets_fine_date', type: 'Date', noWrap: true }, { key: 'bibTitle',
	        headerKey: 'facets_message',
	        type: 'String',
	        transformationMap: function transformationMap(value, index, row) {
	          var bibTitle = '';
	          var subTitle = '';
	          if (row.has('bibSubtitle') && row.get('bibSubtitle') !== null && row.get('bibSubtitle').length > 0) {
	            subTitle = ' - ' + row.get('bibSubtitle');
	          }
	          if (row.get('metadataId')) {
	            bibTitle = _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: '/item/show/' + (0, _utilsLink.metadataIdFixer)(row.get('metadataId')), title: row.get('bibTitle') },
	                row.get('bibTitle')
	              ),
	              subTitle
	            );
	          } else {
	            bibTitle = '' + row.get('bibTitle') + subTitle;
	          }
	
	          return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              null,
	              bibTitle
	            ),
	            _react2.default.createElement(_FineDateFields2.default, { fine: row })
	          );
	        }
	      }, {
	        key: 'description',
	        headerKey: 'facets_fine_reason',
	        type: 'string',
	        transformationMap: function transformationMap(value, index, row) {
	          var reason = '';
	          if (row.has('message') && row.get('message').length > 0 && row.has('description') && row.get('description').length > 0) {
	            reason = row.get('description') + ' - ' + row.get('message');
	          } else {
	            reason = '' + row.get('description') + row.get('message');
	          }
	          return reason;
	        }
	      }, { key: 'amount', headerKey: 'facets_amount', transformationMap: renderAmountAndStatus, rightAlign: true }];
	
	      if (!indiviualFinePayment) {
	        fields.unshift({ key: 'id', type: 'id', headerKey: 'table_headings_item_select', transformationMap: this.renderFinesCheckbox });
	      }
	
	      var emptyMessageOptions = _immutable2.default.Map({
	        type: 'Failure',
	        id: 'error_no_fines_selected'
	      });
	
	      var pagination = this.getPagination();
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.state.showEmptyFineError && _react2.default.createElement(_sharedMessages.Generic, { message: emptyMessageOptions, failureDuration: 3000, clearMessages: function clearMessages() {
	            return _this5.setState({ showEmptyFineError: false });
	          } }),
	        _react2.default.createElement(
	          _MessagingContainer2.default,
	          { id: 'finesNotice' },
	          function (messageOptions) {
	            return _react2.default.createElement(_sharedMessages.Generic, messageOptions);
	          }
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'title-row' },
	          _react2.default.createElement(_BorrowingHeader2.default, {
	            headingKey: 'section_title_fines',
	            taglineKey: 'section_tagline_fines',
	            helpLinkPage: '005borrowing/010fines' }),
	          _react2.default.createElement(
	            _BorrowingList2.default,
	            null,
	            _react2.default.createElement(_FinesUtilityBar2.default, {
	              isFetching: this.props.isFetching,
	              sortOptions: this.getSortOptions(),
	              summary: this.props.summary,
	              handleRefresh: this.refreshTable,
	              pagination: pagination,
	              onlineFinesPayment: onlineFinesPayment,
	              home: '/v2/fines' }),
	            finePaymentAllowed && indiviualFinePayment && _react2.default.createElement(
	              _BatchActionsControls2.default,
	              {
	                list: payableFines.map(function (fine) {
	                  return fine.get('id');
	                }),
	                totalItems: payableFines,
	                selectedItems: this.state.selectedItems,
	                updateAll: this.selectAll },
	              this.renderFinesPaymentButtons()
	            ),
	            finePaymentAllowed && !indiviualFinePayment && _react2.default.createElement(
	              'div',
	              { className: 'cp-fines-control' },
	              this.renderFinesPaymentButtons()
	            ),
	            fines.size > 0 && _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)('cp-fines-table', { 'without-payment': !finePaymentAllowed }) },
	              _react2.default.createElement(_baseTable.Table, {
	                rows: this.formatFines(),
	                fields: fields,
	                selectedRows: this.state.selectedItems,
	                className: 'fines-table',
	                hasLeftAlignedCheckbox: indiviualFinePayment })
	            ),
	            finePaymentAllowed ? this.renderBatchActionsToolbar() : ''
	          ),
	          fines.size > 0 && _react2.default.createElement(_pagination2.default, {
	            isFetching: this.props.isFetching,
	            page: pagination.get('page'),
	            limit: pagination.get('limit'),
	            count: pagination.get('count'),
	            pages: pagination.get('pages'),
	            className: 'cp-pagination-bottom',
	            showPages: true })
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var isFetching = this.props.isFetching;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-fines' },
	        _react2.default.createElement(_sharedProgressBar2.default, { active: isFetching }),
	        this.renderContent()
	      );
	    }
	  }]);
	
	  return Fines;
	}(_baseBcReactComponent2.default);
	
	Fines.propTypes = {
	  user: _reactImmutableProptypes2.default.map,
	  account: _reactImmutableProptypes2.default.map,
	  fines: _reactImmutableProptypes2.default.map.isRequired,
	  finesIDs: _reactImmutableProptypes2.default.list.isRequired,
	  summary: _reactImmutableProptypes2.default.map.isRequired,
	  paymentForm: _react2.default.PropTypes.string,
	  FinesActions: _react.PropTypes.objectOf(_react.PropTypes.func),
	  totalItems: _react2.default.PropTypes.number.isRequired,
	  totalPages: _react2.default.PropTypes.number.isRequired,
	  pageSize: _react2.default.PropTypes.number.isRequired,
	  currentPage: _react2.default.PropTypes.number.isRequired,
	  isFetching: _react2.default.PropTypes.bool,
	  onlineFinesPayment: _reactImmutableProptypes2.default.map,
	  messagingActions: _react.PropTypes.objectOf(_react.PropTypes.func),
	  intl: _reactIntl.intlShape.isRequired
	};
	
	exports.default = (0, _reactIntl.injectIntl)((0, _reactRouter.withRouter)(Fines));

/***/ },
/* 1691 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Fines = __webpack_require__(1690);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Fines).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1692 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = FinesEmptyContentPanel;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _BorrowingHeader = __webpack_require__(124);
	
	var _BorrowingHeader2 = _interopRequireDefault(_BorrowingHeader);
	
	var _BorrowingEmptyContentPanel = __webpack_require__(235);
	
	var _BorrowingEmptyContentPanel2 = _interopRequireDefault(_BorrowingEmptyContentPanel);
	
	var _baseIcons = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function FinesEmptyContentPanel(_ref) {
	  var fetching = _ref.fetching;
	
	  var icon = fetching ? _react2.default.createElement(_baseIcons.Abacus, null) : _react2.default.createElement(_baseIcons.Fees, null);
	  return _react2.default.createElement(
	    'div',
	    { className: 'cp-fines' },
	    _react2.default.createElement(
	      'div',
	      { className: 'title-row' },
	      _react2.default.createElement(_BorrowingHeader2.default, {
	        headingKey: 'section_title_fines',
	        taglineKey: 'section_tagline_fines',
	        helpLinkPage: '005borrowing/010fines' }),
	      _react2.default.createElement(_BorrowingEmptyContentPanel2.default, {
	        className: 'cp-recentlyreturned-empty-content-panel',
	        fetching: fetching,
	        showStaffPicksLink: false,
	        helpPage: '040settings/005privacy-settings',
	        icon: icon,
	        title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'empty_fines' }) })
	    )
	  );
	}
	
	FinesEmptyContentPanel.propTypes = {
	  fetching: _react.PropTypes.bool
	};

/***/ },
/* 1693 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FinesEmptyContentPanel = __webpack_require__(1692);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FinesEmptyContentPanel).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1694 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _BorrowingStatus = __webpack_require__(182);
	
	var _BorrowingStatus2 = _interopRequireDefault(_BorrowingStatus);
	
	var _SidebarCompactTitle = __webpack_require__(183);
	
	var _SidebarCompactTitle2 = _interopRequireDefault(_SidebarCompactTitle);
	
	var _DollarAmount = __webpack_require__(286);
	
	var _DollarAmount2 = _interopRequireDefault(_DollarAmount);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FinesStatus = function (_BcReactComponent) {
	  _inherits(FinesStatus, _BcReactComponent);
	
	  function FinesStatus() {
	    _classCallCheck(this, FinesStatus);
	
	    return _possibleConstructorReturn(this, (FinesStatus.__proto__ || Object.getPrototypeOf(FinesStatus)).apply(this, arguments));
	  }
	
	  _createClass(FinesStatus, [{
	    key: 'renderFineAmount',
	    value: function renderFineAmount() {
	      var totalFines = this.props.totalFines;
	
	      return _react2.default.createElement(
	        'span',
	        { className: 'fine-amount' },
	        _react2.default.createElement(_DollarAmount2.default, { amount: totalFines })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _BorrowingStatus2.default,
	        { currentSection: this.props.currentSection, to: '/v2/fines' },
	        _react2.default.createElement(_SidebarCompactTitle2.default, {
	          title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'section_title_fines' }),
	          count: this.renderFineAmount(),
	          selected: this.props.currentSection })
	      );
	    }
	  }]);
	
	  return FinesStatus;
	}(_baseBcReactComponent2.default);
	
	exports.default = FinesStatus;
	
	
	FinesStatus.propTypes = {
	  currentSection: _react.PropTypes.bool,
	  totalFines: _react.PropTypes.number
	};

/***/ },
/* 1695 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FinesStatus = __webpack_require__(1694);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FinesStatus).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1696 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = FinesTotalCapsule;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Capsule = __webpack_require__(565);
	
	var _Capsule2 = _interopRequireDefault(_Capsule);
	
	var _DollarAmount = __webpack_require__(286);
	
	var _DollarAmount2 = _interopRequireDefault(_DollarAmount);
	
	__webpack_require__(2476);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function FinesTotalCapsule(_ref) {
	  var status = _ref.status,
	      amount = _ref.amount;
	
	  var formattedStatus = status && status.toLowerCase();
	
	  var className = (0, _classnames2.default)('cp-fines-total-capsule', formattedStatus, { 'is-zero': amount === 0 });
	
	  return _react2.default.createElement(
	    _Capsule2.default,
	    { className: className },
	    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'fines_total_' + formattedStatus, values: { amount: _react2.default.createElement(_DollarAmount2.default, { amount: amount }) } })
	  );
	}
	
	FinesTotalCapsule.propTypes = {
	  status: _react.PropTypes.string,
	  amount: _react.PropTypes.number
	};

/***/ },
/* 1697 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FinesTotalCapsule = __webpack_require__(1696);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FinesTotalCapsule).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1698 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = FinesUtilityBar;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _RefreshTable = __webpack_require__(1700);
	
	var _RefreshTable2 = _interopRequireDefault(_RefreshTable);
	
	var _FinesTotalCapsule = __webpack_require__(1697);
	
	var _FinesTotalCapsule2 = _interopRequireDefault(_FinesTotalCapsule);
	
	var _BorrowingUtilityBar = __webpack_require__(285);
	
	var _BorrowingUtilityBar2 = _interopRequireDefault(_BorrowingUtilityBar);
	
	__webpack_require__(2477);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var renderTitle = function renderTitle(summary, handleRefresh, home, onlineFinesPayment) {
	  var showAccruedCapsule = !!summary.get('totalAccrued');
	  var showCreditsCapsule = !!summary.get('totalCredits');
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'utility-context-info' },
	    _react2.default.createElement(_FinesTotalCapsule2.default, { status: 'due', amount: summary.get('totalFines', 0) }),
	    showAccruedCapsule && _react2.default.createElement(_FinesTotalCapsule2.default, { status: 'accruing', amount: summary.get('totalAccrued') }),
	    showCreditsCapsule && _react2.default.createElement(_FinesTotalCapsule2.default, { status: 'credit', amount: summary.get('totalCredits') }),
	    onlineFinesPayment && _react2.default.createElement(_RefreshTable2.default, { handleRefresh: handleRefresh, home: home })
	  );
	};
	
	function FinesUtilityBar(_ref) {
	  var isFetching = _ref.isFetching,
	      sortOptions = _ref.sortOptions,
	      summary = _ref.summary,
	      handleRefresh = _ref.handleRefresh,
	      home = _ref.home,
	      pagination = _ref.pagination,
	      onlineFinesPayment = _ref.onlineFinesPayment;
	
	  var totalFines = summary.get('totalFines', 0);
	  return _react2.default.createElement(_BorrowingUtilityBar2.default, {
	    className: 'cp-fines-utility-bar',
	    isFetching: isFetching,
	    pagination: pagination,
	    title: renderTitle(summary, handleRefresh, home, onlineFinesPayment),
	    sortOptions: totalFines > 0 && sortOptions });
	}
	
	FinesUtilityBar.propTypes = {
	  isFetching: _react.PropTypes.bool,
	  sortOptions: _reactImmutableProptypes2.default.list,
	  handleRefresh: _react.PropTypes.func,
	  home: _react.PropTypes.string,
	  onlineFinesPayment: _react.PropTypes.bool,
	  summary: _reactImmutableProptypes2.default.map,
	  pagination: _reactImmutableProptypes2.default.map
	};

/***/ },
/* 1699 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseIcons = __webpack_require__(10);
	
	var _reactIntl = __webpack_require__(3);
	
	var _reactRouter = __webpack_require__(17);
	
	__webpack_require__(2478);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RefreshTable = function (_BcReactComponent) {
	  _inherits(RefreshTable, _BcReactComponent);
	
	  function RefreshTable() {
	    _classCallCheck(this, RefreshTable);
	
	    return _possibleConstructorReturn(this, (RefreshTable.__proto__ || Object.getPrototypeOf(RefreshTable)).apply(this, arguments));
	  }
	
	  _createClass(RefreshTable, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          handleRefresh = _props.handleRefresh,
	          home = _props.home;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'updated-fines-page' },
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { to: home, onClick: handleRefresh, id: 'updated_fines_page' },
	          _react2.default.createElement(_baseIcons.Redo, { className: 'small' }),
	          ' ',
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'fines_refresh_totals' })
	        )
	      );
	    }
	  }]);
	
	  return RefreshTable;
	}(_baseBcReactComponent2.default);
	
	exports.default = RefreshTable;
	
	
	RefreshTable.propTypes = {
	  handleRefresh: _react.PropTypes.func,
	  home: _react.PropTypes.string
	};

/***/ },
/* 1700 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _RefreshTable = __webpack_require__(1699);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RefreshTable).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1701 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = AvailableForCheckoutButton;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseButtons = __webpack_require__(12);
	
	var _reactIntl = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AvailableForCheckoutButton(_ref) {
	  var handleClick = _ref.handleClick,
	      disabled = _ref.disabled;
	
	  return _react2.default.createElement(
	    _baseButtons.TransactionalButton,
	    {
	      block: true,
	      disabled: disabled,
	      className: 'cp-holds-available-for-checkout',
	      handleClick: handleClick },
	    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'holds_available_for_checkout_button' })
	  );
	}
	
	AvailableForCheckoutButton.propTypes = {
	  handleClick: _react.PropTypes.func,
	  disabled: _react.PropTypes.bool
	};

/***/ },
/* 1702 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AvailableForCheckoutButton = __webpack_require__(1701);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AvailableForCheckoutButton).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1703 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseButtons = __webpack_require__(12);
	
	var _baseCheckbox = __webpack_require__(58);
	
	var _baseCheckbox2 = _interopRequireDefault(_baseCheckbox);
	
	var _reactIntl = __webpack_require__(3);
	
	var _BorrowingBatchActionsOverlay = __webpack_require__(383);
	
	var _BorrowingBatchActionsOverlay2 = _interopRequireDefault(_BorrowingBatchActionsOverlay);
	
	var _ShelfConstants = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BatchCancelOverlay = function (_BcReactComponent) {
	  _inherits(BatchCancelOverlay, _BcReactComponent);
	
	  function BatchCancelOverlay(props) {
	    _classCallCheck(this, BatchCancelOverlay);
	
	    var _this = _possibleConstructorReturn(this, (BatchCancelOverlay.__proto__ || Object.getPrototypeOf(BatchCancelOverlay)).call(this, props));
	
	    _this.state = {
	      addToShelf: false
	    };
	    _this.bindAll('handleToggleAddToShelf', 'handleBatchCancel');
	    return _this;
	  }
	
	  _createClass(BatchCancelOverlay, [{
	    key: 'handleToggleAddToShelf',
	    value: function handleToggleAddToShelf() {
	      this.setState({ addToShelf: !this.state.addToShelf });
	    }
	  }, {
	    key: 'handleBatchCancel',
	    value: function handleBatchCancel() {
	      var addToShelf = this.state.addToShelf;
	
	      var shelfState = addToShelf && {
	        toAdd: true,
	        name: _ShelfConstants.SHELF_NAMES.FOR_LATER
	      };
	
	      this.props.handleBatchCancel({ shelfState: shelfState });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.isLoading && !this.props.isLoading) {
	        this.props.handleClose();
	      }
	    }
	  }, {
	    key: 'renderFooter',
	    value: function renderFooter() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'edit-hold-date-submit' },
	        _react2.default.createElement(
	          _baseButtons.PrimaryButton,
	          { className: 'pull-left', handleClick: this.handleBatchCancel, isLoading: this.props.isLoading },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'cancel_confirmation_holds_button_yes' })
	        ),
	        _react2.default.createElement(
	          _baseButtons.TextButton,
	          { className: 'btn btn-link pull-left', handleClick: this.props.handleClose },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_nevermind_close' })
	        )
	      );
	    }
	  }, {
	    key: 'renderShelfControls',
	    value: function renderShelfControls() {
	      var shelfName = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'label_shelf_for_later' });
	      return this.props.showShelfControls && [_react2.default.createElement(
	        'h4',
	        { key: 'shelf-controls-heading' },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'keep_a_reference' })
	      ), _react2.default.createElement(_baseCheckbox2.default, {
	        key: 'shelf-controls-checkbox',
	        id: 'batch-cancel-add-to-shelf',
	        handleChange: this.handleToggleAddToShelf,
	        checked: this.state.addToShelf,
	        label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'add_titles_to_shelf', values: { shelfName: shelfName } }) })];
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _BorrowingBatchActionsOverlay2.default,
	        {
	          open: this.props.open,
	          className: 'cp-batch-cancel-overlay',
	          handleClose: this.props.handleClose,
	          header: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'batch_cancel_holds_title', values: { count: this.props.count } }),
	          subtitle: _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_reactIntl.FormattedMessage, { tagName: 'p', id: 'your_position_will_be_lost' }),
	            _react2.default.createElement(_reactIntl.FormattedMessage, { tagName: 'p', id: 'action_cannot_be_undone' })
	          ),
	          footer: this.renderFooter() },
	        this.renderShelfControls()
	      );
	    }
	  }]);
	
	  return BatchCancelOverlay;
	}(_baseBcReactComponent2.default);
	
	exports.default = BatchCancelOverlay;
	
	
	BatchCancelOverlay.propTypes = {
	  count: _react.PropTypes.number,
	  open: _react.PropTypes.bool,
	  showShelfControls: _react.PropTypes.bool,
	  isLoading: _react.PropTypes.bool,
	  handleClose: _react.PropTypes.func,
	  handleBatchCancel: _react.PropTypes.func
	};

/***/ },
/* 1704 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BatchCancelOverlay = __webpack_require__(1703);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BatchCancelOverlay).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1705 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseDropdown = __webpack_require__(37);
	
	var _BatchActionLink = __webpack_require__(238);
	
	var _BatchActionLink2 = _interopRequireDefault(_BatchActionLink);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CancelHoldBatchAction(_ref) {
	  var items = _ref.items,
	      _handleClick = _ref.handleClick;
	
	  var cancelItems = items.filter(function (item) {
	    return item.get('actions').includes('cancel');
	  });
	
	  return _react2.default.createElement(
	    _baseDropdown.DropdownMenuItem,
	    { key: 'cancel-hold-batch-cancel', className: 'cp-cancel-hold-batch-action' },
	    _react2.default.createElement(
	      _BatchActionLink2.default,
	      {
	        disabled: cancelItems.size === 0,
	        href: '#cancel-hold-batch-cancel',
	        handleClick: function handleClick() {
	          return _handleClick(cancelItems);
	        } },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'cancel_holds_with_count', values: { count: cancelItems.size } })
	    )
	  );
	}
	
	exports.default = CancelHoldBatchAction;
	CancelHoldBatchAction.propTypes = {
	  items: _reactImmutableProptypes2.default.map,
	  handleClick: _react.PropTypes.func
	};

/***/ },
/* 1706 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CancelHoldBatchAction = __webpack_require__(1705);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CancelHoldBatchAction).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1707 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = CancelHoldButton;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseButtons = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CancelHoldButton(_ref) {
	  var handleClick = _ref.handleClick,
	      isLoading = _ref.isLoading,
	      disabled = _ref.disabled;
	
	  return _react2.default.createElement(
	    _baseButtons.SecondaryButton,
	    {
	      className: 'cp-cancel-hold-button',
	      isLoading: isLoading,
	      disabled: disabled,
	      handleClick: handleClick },
	    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'cancel_hold' })
	  );
	}
	
	CancelHoldButton.propTypes = {
	  handleClick: _react.PropTypes.func,
	  isLoading: _react.PropTypes.bool,
	  disabled: _react.PropTypes.bool
	};

/***/ },
/* 1708 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CancelHoldButton = __webpack_require__(1707);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CancelHoldButton).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1709 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _moment = __webpack_require__(9);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseAccessibilityDatePicker = __webpack_require__(272);
	
	var _baseAccessibilityDatePicker2 = _interopRequireDefault(_baseAccessibilityDatePicker);
	
	var _baseButtons = __webpack_require__(12);
	
	var _baseIcons = __webpack_require__(10);
	
	var _reactIntl = __webpack_require__(3);
	
	var _BorrowingBatchActionsOverlay = __webpack_require__(383);
	
	var _BorrowingBatchActionsOverlay2 = _interopRequireDefault(_BorrowingBatchActionsOverlay);
	
	var _ShortFormattedDate = __webpack_require__(60);
	
	var _ShortFormattedDate2 = _interopRequireDefault(_ShortFormattedDate);
	
	var _bcPropTypes = __webpack_require__(5);
	
	__webpack_require__(2479);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var renderSubtitle = function renderSubtitle() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactIntl.FormattedMessage, { tagName: 'p', id: 'holds_edit_pause_dates_description' }),
	    _react2.default.createElement(_reactIntl.FormattedMessage, { tagName: 'p', id: 'holds_chosen_dates_subtitle' })
	  );
	};
	
	var EditHoldDatesBatchActions = function (_BcReactComponent) {
	  _inherits(EditHoldDatesBatchActions, _BcReactComponent);
	
	  function EditHoldDatesBatchActions(props) {
	    _classCallCheck(this, EditHoldDatesBatchActions);
	
	    var _this = _possibleConstructorReturn(this, (EditHoldDatesBatchActions.__proto__ || Object.getPrototypeOf(EditHoldDatesBatchActions)).call(this, props));
	
	    _this.state = {
	      showDatePicker: false,
	      date: null
	    };
	    _this.bindAll('handleDate', 'renderUntilDate', 'handleUpdatePauseEndDate');
	    return _this;
	  }
	
	  _createClass(EditHoldDatesBatchActions, [{
	    key: 'handleDate',
	    value: function handleDate(dateValue) {
	      this.setState({
	        date: dateValue
	      });
	    }
	  }, {
	    key: 'handleUpdatePauseEndDate',
	    value: function handleUpdatePauseEndDate() {
	      var _props = this.props,
	          items = _props.items,
	          handleUpdateHoldsPauseEndDate = _props.handleUpdateHoldsPauseEndDate;
	
	      var holdIds = items.map(function (item) {
	        return item.get('holdsId');
	      }).toSet().toList().toJS();
	
	      handleUpdateHoldsPauseEndDate(holdIds, this.state.date);
	      this.props.handleClose();
	    }
	  }, {
	    key: 'renderUntilDate',
	    value: function renderUntilDate() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'edit-hold-until-date' },
	        _react2.default.createElement(
	          _baseAccessibilityDatePicker2.default,
	          {
	            open: this.state.showDatePicker,
	            onDateChange: function onDateChange(dateValue) {
	              return _this2.setState({ date: dateValue });
	            },
	            isOutsideRange: function isOutsideRange(day) {
	              return !day.isAfter((0, _moment2.default)(), 'day');
	            },
	            handleClose: function handleClose() {
	              return _this2.setState({ showDatePicker: false });
	            } },
	          _react2.default.createElement(
	            _baseButtons.PrimaryGhostButton,
	            {
	              handleClick: function handleClick() {
	                return _this2.setState({ showDatePicker: true });
	              },
	              className: 'edit-holds-select-dates-button' },
	            _react2.default.createElement(_baseIcons.CalendarEmpty, null),
	            _react2.default.createElement(
	              'span',
	              null,
	              this.state.date ? _react2.default.createElement(_ShortFormattedDate2.default, { value: this.state.date }) : _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'select_a_date' })
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderFooter',
	    value: function renderFooter() {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'edit-hold-date-submit' },
	        _react2.default.createElement(
	          _baseButtons.PrimaryButton,
	          { className: 'pull-left', disabled: !this.state.date, handleClick: function handleClick() {
	              return _this3.handleUpdatePauseEndDate();
	            } },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'edit_holds_date_button' })
	        ),
	        _react2.default.createElement(
	          _baseButtons.TextButton,
	          { className: 'btn btn-link pull-left', handleClick: this.props.handleClose },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_nevermind_close' })
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _BorrowingBatchActionsOverlay2.default,
	        {
	          open: this.props.open,
	          className: 'cp-edit-hold-date-batch-actions-overlay',
	          handleClose: this.props.handleClose,
	          header: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'edit_holds_date_header', values: { count: this.props.items.size } }),
	          subtitle: renderSubtitle(),
	          footer: this.renderFooter() },
	        _react2.default.createElement(
	          'div',
	          { className: 'until-date' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { tagName: 'strong', id: 'pause_holds_until' }),
	          this.renderUntilDate()
	        )
	      );
	    }
	  }]);
	
	  return EditHoldDatesBatchActions;
	}(_baseBcReactComponent2.default);
	
	exports.default = EditHoldDatesBatchActions;
	
	
	EditHoldDatesBatchActions.propTypes = {
	  handleUpdateHoldsPauseEndDate: _react.PropTypes.func.isRequired,
	  items: _reactImmutableProptypes2.default.listOf(_bcPropTypes.holdItemShape)
	};

/***/ },
/* 1710 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _EditHoldDatesBatchActions = __webpack_require__(1709);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_EditHoldDatesBatchActions).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1711 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = EditHoldDatesButton;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseButtons = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function EditHoldDatesButton(_ref) {
	  var handleClick = _ref.handleClick,
	      isLoading = _ref.isLoading,
	      disabled = _ref.disabled;
	
	  return _react2.default.createElement(
	    _baseButtons.PrimaryButton,
	    {
	      isLoading: isLoading,
	      disabled: disabled,
	      className: 'cp-edit-hold-button',
	      handleClick: handleClick },
	    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'holds_batch_action_edit_dates' })
	  );
	}
	
	EditHoldDatesButton.propTypes = {
	  handleClick: _react.PropTypes.func,
	  isLoading: _react.PropTypes.bool,
	  disabled: _react.PropTypes.bool
	};

/***/ },
/* 1712 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _EditHoldDatesButton = __webpack_require__(1711);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_EditHoldDatesButton).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1713 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _moment = __webpack_require__(9);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _HoldsAdditionalBriefInfo = __webpack_require__(1719);
	
	var _HoldsAdditionalBriefInfo2 = _interopRequireDefault(_HoldsAdditionalBriefInfo);
	
	var _HoldsSecondaryInfo = __webpack_require__(1739);
	
	var _HoldsSecondaryInfo2 = _interopRequireDefault(_HoldsSecondaryInfo);
	
	var _CancelHoldButton = __webpack_require__(1708);
	
	var _CancelHoldButton2 = _interopRequireDefault(_CancelHoldButton);
	
	var _PauseHoldButton = __webpack_require__(1753);
	
	var _PauseHoldButton2 = _interopRequireDefault(_PauseHoldButton);
	
	var _EditHoldDatesButton = __webpack_require__(1712);
	
	var _EditHoldDatesButton2 = _interopRequireDefault(_EditHoldDatesButton);
	
	var _ResumeHoldButton = __webpack_require__(1759);
	
	var _ResumeHoldButton2 = _interopRequireDefault(_ResumeHoldButton);
	
	var _AvailableForCheckoutButton = __webpack_require__(1702);
	
	var _AvailableForCheckoutButton2 = _interopRequireDefault(_AvailableForCheckoutButton);
	
	var _AddToShelfButtonContainer = __webpack_require__(146);
	
	var _AddToShelfButtonContainer2 = _interopRequireDefault(_AddToShelfButtonContainer);
	
	var _ShortFormattedDate = __webpack_require__(60);
	
	var _ShortFormattedDate2 = _interopRequireDefault(_ShortFormattedDate);
	
	var _BorrowingBibBrief = __webpack_require__(284);
	
	var _BorrowingBibBrief2 = _interopRequireDefault(_BorrowingBibBrief);
	
	var _reactIntl = __webpack_require__(3);
	
	var _BibListItem = __webpack_require__(239);
	
	var _BibListItem2 = _interopRequireDefault(_BibListItem);
	
	var _HoldsConstants = __webpack_require__(98);
	
	var _WorkflowConstants = __webpack_require__(74);
	
	__webpack_require__(2480);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HoldItem = function (_BcReactComponent) {
	  _inherits(HoldItem, _BcReactComponent);
	
	  function HoldItem(props) {
	    _classCallCheck(this, HoldItem);
	
	    var _this = _possibleConstructorReturn(this, (HoldItem.__proto__ || Object.getPrototypeOf(HoldItem)).call(this, props));
	
	    _this.bindAll('renderBibActions', 'renderSecondaryInfo', 'renderBibBrief', 'handlePauseHolds', 'handleResumeHolds', 'handleCancelHolds', 'handleAvailableCheckout', 'handleUpdatePickupBranch', 'handleUpdatePauseEndDate', 'handleUpdateExpiryDate', 'shouldShowEditDatesButton');
	    return _this;
	  }
	
	  _createClass(HoldItem, [{
	    key: 'handleAvailableCheckout',
	    value: function handleAvailableCheckout() {
	      var _props = this.props,
	          item = _props.item,
	          workflowActions = _props.workflowActions;
	
	
	      workflowActions.updateWorkflow(item.get('holdsId'), _WorkflowConstants.ITEM_TRANSACTION_WORKFLOW, _immutable2.default.Map({
	        metadataId: item.get('metadataId'),
	        step: _HoldsConstants.WORKFLOW_VIEWS.DIGITAL_CHECKOUT
	      }), true, true);
	    }
	  }, {
	    key: 'handleCancelHolds',
	    value: function handleCancelHolds() {
	      var _props2 = this.props,
	          item = _props2.item,
	          workflowActions = _props2.workflowActions;
	
	      workflowActions.updateWorkflow(item.get('holdsId'), _WorkflowConstants.ITEM_TRANSACTION_WORKFLOW, _immutable2.default.Map({
	        metadataId: item.get('metadataId'),
	        step: _HoldsConstants.WORKFLOW_VIEWS.CANCEL_HOLD,
	        holdsId: item.get('holdsId')
	      }), true, true);
	    }
	  }, {
	    key: 'handlePauseHolds',
	    value: function handlePauseHolds() {
	      var _props3 = this.props,
	          item = _props3.item,
	          workflowActions = _props3.workflowActions,
	          accountId = _props3.accountId,
	          holdActions = _props3.holdActions;
	
	
	      var enableStartDate = item.getIn(['bib', 'policy', 'materialPolicy', 'supportsSuspendHoldStartDateEdit']);
	      var enableEndDate = item.getIn(['bib', 'policy', 'materialPolicy', 'supportsSuspendHoldEndDateEdit']);
	
	      if (enableStartDate || enableEndDate) {
	        workflowActions.updateWorkflow(item.get('holdsId'), _WorkflowConstants.ITEM_TRANSACTION_WORKFLOW, _immutable2.default.Map({
	          metadataId: item.get('metadataId'),
	          step: _HoldsConstants.WORKFLOW_VIEWS.PAUSE_HOLD
	        }), true, true);
	      } else {
	        holdActions.pauseOrResumeHolds({
	          accountId: accountId,
	          holdIds: [item.get('holdsId')],
	          workflowId: item.get('holdsId'),
	          suspended: {
	            startDate: null,
	            endDate: (0, _moment2.default)().add(1, 'day').format(),
	            status: true
	          }
	        });
	      }
	
	      return null;
	    }
	  }, {
	    key: 'handleResumeHolds',
	    value: function handleResumeHolds() {
	      var _props4 = this.props,
	          item = _props4.item,
	          accountId = _props4.accountId,
	          holdActions = _props4.holdActions;
	
	      holdActions.pauseOrResumeHolds({
	        accountId: accountId,
	        holdIds: [item.get('holdsId')],
	        workflowId: item.get('holdsId'),
	        suspended: { status: false }
	      });
	    }
	  }, {
	    key: 'handleUpdatePickupBranch',
	    value: function handleUpdatePickupBranch(location) {
	      var _props5 = this.props,
	          item = _props5.item,
	          accountId = _props5.accountId,
	          branches = _props5.branches,
	          holdActions = _props5.holdActions;
	
	
	      var selectedBranch = branches.filter(function (branch) {
	        return branch.get('code') === location;
	      }).first();
	
	      holdActions.savePickupLocation({
	        accountId: accountId,
	        holdId: item.get('holdsId'),
	        branch: selectedBranch
	      });
	    }
	  }, {
	    key: 'handleUpdatePauseEndDate',
	    value: function handleUpdatePauseEndDate(endDate) {
	      var _props6 = this.props,
	          item = _props6.item,
	          handleUpdateHoldsPauseEndDate = _props6.handleUpdateHoldsPauseEndDate;
	
	      handleUpdateHoldsPauseEndDate([item.get('holdsId')], endDate);
	    }
	  }, {
	    key: 'handleUpdateExpiryDate',
	    value: function handleUpdateExpiryDate(expiryDate) {
	      var _props7 = this.props,
	          item = _props7.item,
	          handleUpdateHoldsExpiryDate = _props7.handleUpdateHoldsExpiryDate;
	
	      handleUpdateHoldsExpiryDate([item.get('holdsId')], expiryDate);
	    }
	  }, {
	    key: 'isHoldPausable',
	    value: function isHoldPausable() {
	      var item = this.props.item;
	
	      return item.get('status') !== 'READY_FOR_PICKUP' && item.get('status') !== 'SUSPENDED' && item.get('actions', _immutable2.default.List()).includes('suspend');
	    }
	  }, {
	    key: 'shouldShowEditDatesButton',
	    value: function shouldShowEditDatesButton() {
	      var item = this.props.item;
	
	      return item.get('status') !== 'READY_FOR_PICKUP' && item.get('status') !== 'SUSPENDED' && item.get('actions', _immutable2.default.List()).includes('updateSuspend');
	    }
	  }, {
	    key: 'canResumeHolds',
	    value: function canResumeHolds() {
	      var item = this.props.item;
	
	      return item.get('status') === 'SUSPENDED' && item.get('actions', _immutable2.default.List()).includes('activate');
	    }
	  }, {
	    key: 'isAvailableForCheckout',
	    value: function isAvailableForCheckout() {
	      return this.props.item.get('materialType') === 'DIGITAL' && this.props.item.get('actions', _immutable2.default.List()).includes('checkout');
	    }
	  }, {
	    key: 'renderPauseResumeActions',
	    value: function renderPauseResumeActions() {
	      var _props8 = this.props,
	          holdsTransactions = _props8.holdsTransactions,
	          item = _props8.item,
	          actionInProgress = _props8.actionInProgress;
	
	      var isPausing = holdsTransactions.getIn([item.get('holdsId'), 'isPausing'], false);
	      var isResuming = holdsTransactions.getIn([item.get('holdsId'), 'isResuming'], false);
	
	      if (this.shouldShowEditDatesButton()) {
	        return _react2.default.createElement(_EditHoldDatesButton2.default, {
	          disabled: actionInProgress && !isPausing,
	          handleClick: this.handlePauseHolds,
	          isLoading: isPausing });
	      } else if (this.isHoldPausable()) {
	        return _react2.default.createElement(_PauseHoldButton2.default, {
	          disabled: actionInProgress && !isPausing,
	          handleClick: this.handlePauseHolds,
	          isLoading: isPausing });
	      } else if (this.canResumeHolds()) {
	        return _react2.default.createElement(_ResumeHoldButton2.default, {
	          disabled: actionInProgress && !isResuming,
	          handleClick: this.handleResumeHolds,
	          isLoading: isResuming });
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderCannotModifyMessage',
	    value: function renderCannotModifyMessage() {
	      var isReadyForPickup = this.props.item.get('status') === 'READY_FOR_PICKUP';
	      var isInTransit = this.props.item.get('status') === 'IN_TRANSIT';
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cannot-modify-message' },
	        isReadyForPickup && !this.isAvailableForCheckout() && _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'holds_cannot_pause_ready_for_pickup' }),
	        isInTransit && _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'holds_in_transit_cannot_be_modified' })
	      );
	    }
	  }, {
	    key: 'renderBibActions',
	    value: function renderBibActions() {
	      var _props9 = this.props,
	          item = _props9.item,
	          holdsTransactions = _props9.holdsTransactions,
	          shelfTransactions = _props9.shelfTransactions,
	          actionInProgress = _props9.actionInProgress;
	
	      var isCancelling = holdsTransactions.getIn([item.get('holdsId'), 'isCancelling'], false);
	      var shelfActionInProgress = !shelfTransactions.get(item.get('metadataId'), _immutable2.default.Map()).isEmpty();
	      var canCancel = item.get('actions', _immutable2.default.List()).includes('cancel');
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'actions' },
	        this.isAvailableForCheckout() && _react2.default.createElement(_AvailableForCheckoutButton2.default, { disabled: actionInProgress, handleClick: this.handleAvailableCheckout }),
	        this.renderPauseResumeActions(),
	        canCancel && _react2.default.createElement(_CancelHoldButton2.default, {
	          disabled: actionInProgress && !isCancelling,
	          isLoading: isCancelling,
	          handleClick: this.handleCancelHolds }),
	        this.renderCannotModifyMessage(),
	        this.props.item.get('bib') && _react2.default.createElement(
	          'div',
	          { className: 'holds-shelf-button' },
	          _react2.default.createElement(_AddToShelfButtonContainer2.default, {
	            disabled: actionInProgress && !shelfActionInProgress,
	            metadataId: this.props.item.get('metadataId'),
	            workflowId: this.props.item.get('holdsId') })
	        )
	      );
	    }
	  }, {
	    key: 'renderDatePlaced',
	    value: function renderDatePlaced() {
	      var item = this.props.item;
	
	      var status = item.get('status');
	      var bibType = item.get('materialType');
	      var datePlaced = item.get('holdPlacedDate');
	
	      return ['NOT_YET_AVAILABLE', 'SUSPENDED'].includes(status) && bibType === 'PHYSICAL' && datePlaced && _react2.default.createElement(
	        'div',
	        { className: 'holds-placed-date' },
	        _react2.default.createElement(_reactIntl.FormattedMessage, {
	          key: 'holds-placed-date',
	          id: 'placed_on_date',
	          values: { date: _react2.default.createElement(_ShortFormattedDate2.default, { value: item.get('holdPlacedDate') }) } })
	      );
	    }
	  }, {
	    key: 'renderSecondaryInfo',
	    value: function renderSecondaryInfo() {
	      var _props10 = this.props,
	          item = _props10.item,
	          branches = _props10.branches,
	          holdsTransactions = _props10.holdsTransactions,
	          actionInProgress = _props10.actionInProgress;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('holds-status', item.get('status').toLowerCase()) },
	          _react2.default.createElement(_HoldsSecondaryInfo2.default, {
	            actionInProgress: actionInProgress,
	            item: item,
	            branches: branches,
	            handleUpdatePickupBranch: this.handleUpdatePickupBranch,
	            handleUpdatePauseEndDate: this.handleUpdatePauseEndDate,
	            handleUpdateExpiryDate: this.handleUpdateExpiryDate,
	            holdsTransactions: holdsTransactions })
	        ),
	        this.renderBibActions(),
	        this.renderDatePlaced()
	      );
	    }
	  }, {
	    key: 'renderBibBrief',
	    value: function renderBibBrief() {
	      var _props11 = this.props,
	          item = _props11.item,
	          availabilityDetailActions = _props11.availabilityDetailActions;
	
	      var briefInfo = item.getIn(['bib', 'briefInfo']);
	
	      return _react2.default.createElement(
	        _BorrowingBibBrief2.default,
	        { bib: briefInfo, fallbackTitle: this.props.item.get('bibTitle') },
	        _react2.default.createElement(_HoldsAdditionalBriefInfo2.default, { item: item, availabilityDetailActions: availabilityDetailActions })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var item = this.props.item;
	
	
	      return _react2.default.createElement(_BibListItem2.default, {
	        workflowId: item.get('holdsId'),
	        className: (0, _classnames2.default)('cp-hold-item', item.get('status').toLowerCase()),
	        bib: item.getIn(['bib', 'briefInfo'], _immutable2.default.Map()),
	        renderInfo: function renderInfo() {
	          return _this2.renderSecondaryInfo();
	        },
	        renderBibBrief: function renderBibBrief() {
	          return _this2.renderBibBrief();
	        } });
	    }
	  }]);
	
	  return HoldItem;
	}(_baseBcReactComponent2.default);
	
	exports.default = HoldItem;
	
	
	HoldItem.propTypes = {
	  actionInProgress: _react.PropTypes.bool,
	  accountId: _react.PropTypes.number,
	  item: _bcPropTypes.holdItemShape,
	  branches: _reactImmutableProptypes2.default.listOf(_bcPropTypes.branchShape).isRequired,
	  holdsTransactions: _reactImmutableProptypes2.default.map,
	  shelfTransactions: _reactImmutableProptypes2.default.map,
	  workflowActions: _react.PropTypes.objectOf(_react.PropTypes.func),
	  holdActions: _react.PropTypes.objectOf(_react.PropTypes.func),
	  availabilityDetailActions: _react.PropTypes.objectOf(_react.PropTypes.func),
	  handleUpdateHoldsPauseEndDate: _react.PropTypes.func,
	  handleUpdateHoldsExpiryDate: _react.PropTypes.func
	};

/***/ },
/* 1714 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _HoldItem = __webpack_require__(1713);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_HoldItem).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1715 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = HoldStatusIcon;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseIcons = __webpack_require__(10);
	
	var _BorrowingStatusIcon = __webpack_require__(384);
	
	var _BorrowingStatusIcon2 = _interopRequireDefault(_BorrowingStatusIcon);
	
	__webpack_require__(2481);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getIcon = function getIcon(status) {
	  switch (status) {
	    case 'READY_FOR_PICKUP':
	    case 'READY_SOON':
	      return _react2.default.createElement(_baseIcons.CheckmarkCircle, null);
	    case 'IN_TRANSIT':
	      return _react2.default.createElement(_baseIcons.Truck, null);
	    case 'SUSPENDED':
	      return _react2.default.createElement(_baseIcons.PauseCircled, null);
	    default:
	      return _react2.default.createElement(_baseIcons.MinusCircled, null);
	  }
	};
	
	function HoldStatusIcon(_ref) {
	  var status = _ref.status,
	      withBackground = _ref.withBackground,
	      withLabel = _ref.withLabel;
	
	  var label = status && _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'circ_' + status.toLowerCase() });
	
	  return _react2.default.createElement(_BorrowingStatusIcon2.default, {
	    className: 'cp-hold-status-icon',
	    icon: getIcon(status),
	    status: status,
	    withBackground: withBackground,
	    renderLabel: withLabel && function () {
	      return label;
	    } });
	}
	
	HoldStatusIcon.propTypes = {
	  status: _react.PropTypes.string.isRequired,
	  withBackground: _react.PropTypes.bool,
	  withLabel: _react.PropTypes.bool
	};

/***/ },
/* 1716 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Holds = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(17);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _pagination = __webpack_require__(92);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _sharedProgressBar = __webpack_require__(94);
	
	var _sharedProgressBar2 = _interopRequireDefault(_sharedProgressBar);
	
	var _HoldsToReviewContainer = __webpack_require__(2075);
	
	var _HoldsToReviewContainer2 = _interopRequireDefault(_HoldsToReviewContainer);
	
	var _BorrowingList = __webpack_require__(236);
	
	var _BorrowingList2 = _interopRequireDefault(_BorrowingList);
	
	var _HoldsList = __webpack_require__(1729);
	
	var _HoldsList2 = _interopRequireDefault(_HoldsList);
	
	var _HoldsUtilityBar = __webpack_require__(1747);
	
	var _HoldsUtilityBar2 = _interopRequireDefault(_HoldsUtilityBar);
	
	var _HoldsEmptyContentPanel = __webpack_require__(1725);
	
	var _HoldsEmptyContentPanel2 = _interopRequireDefault(_HoldsEmptyContentPanel);
	
	var _HoldsBatchActions = __webpack_require__(1723);
	
	var _HoldsBatchActions2 = _interopRequireDefault(_HoldsBatchActions);
	
	var _BorrowingHeader = __webpack_require__(124);
	
	var _BorrowingHeader2 = _interopRequireDefault(_BorrowingHeader);
	
	var _MessagingConstants = __webpack_require__(73);
	
	__webpack_require__(2482);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Holds = exports.Holds = function (_BcReactComponent) {
	  _inherits(Holds, _BcReactComponent);
	
	  function Holds(props) {
	    _classCallCheck(this, Holds);
	
	    var _this = _possibleConstructorReturn(this, (Holds.__proto__ || Object.getPrototypeOf(Holds)).call(this, props));
	
	    _this.bindAll('handleSort', 'handleBatchCancel', 'handleBatchAddToShelf', 'handleBatchResumeHolds');
	    return _this;
	  }
	
	  _createClass(Holds, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.redirectIfSingleStatus();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var _props = this.props,
	          items = _props.items,
	          router = _props.router,
	          selectedStatus = _props.selectedStatus,
	          presentStatuses = _props.presentStatuses;
	
	      // Unselect status if there are no longer any holds with status
	
	      if (selectedStatus && items.size === 0) {
	        router.replace('/v2/holds');
	      }
	
	      if (!prevProps.presentStatuses.equals(presentStatuses)) {
	        this.redirectIfSingleStatus();
	      }
	    }
	  }, {
	    key: 'redirectIfSingleStatus',
	    value: function redirectIfSingleStatus() {
	      var _props2 = this.props,
	          router = _props2.router,
	          presentStatuses = _props2.presentStatuses,
	          selectedStatus = _props2.selectedStatus;
	
	      // Redirect to the route for a specific status if there is only one status
	
	      if (!selectedStatus && presentStatuses && presentStatuses.size === 1) {
	        router.replace('/v2/holds/' + presentStatuses.first().toLowerCase());
	      }
	    }
	  }, {
	    key: 'allItemsDigital',
	    value: function allItemsDigital() {
	      return this.props.items.every(function (item) {
	        return item.getIn(['bib', 'policy', 'materialType']) === 'DIGITAL';
	      });
	    }
	  }, {
	    key: 'getPrintURL',
	    value: function getPrintURL() {
	      var search = this.props.location.search;
	
	      return '/v2/print/holds' + search;
	    }
	  }, {
	    key: 'hasReadyForPickupItems',
	    value: function hasReadyForPickupItems() {
	      return this.props.items.map(function (item) {
	        return item.get('status');
	      }).toSet().toList().includes('READY_FOR_PICKUP');
	    }
	  }, {
	    key: 'getSortOptions',
	    value: function getSortOptions() {
	      var currentSort = this.props.router.location.query.sort || 'status';
	      var sortOptions = ['status', 'holdsPosition', 'expiryDate', 'title', 'author', 'format'];
	
	      sortOptions = this.hasReadyForPickupItems() ? sortOptions.concat(['pickupByDate']) : sortOptions;
	
	      return sortOptions.reduce(function (acc, val) {
	        return acc.set(val, _immutable2.default.Map({
	          id: val,
	          applied: val === currentSort
	        }));
	      }, _immutable2.default.Map()).toList();
	    }
	  }, {
	    key: 'handleSort',
	    value: function handleSort(sortType) {
	      var _props3 = this.props,
	          location = _props3.location,
	          router = _props3.router;
	
	      router.push(_extends({}, location, {
	        query: _extends({}, location.query, {
	          sort: sortType
	        })
	      }));
	    }
	  }, {
	    key: 'handleBatchCancel',
	    value: function handleBatchCancel(_ref) {
	      var _this2 = this;
	
	      var shelfState = _ref.shelfState,
	          items = _ref.items;
	      var accountId = this.props.accountId;
	
	
	      this.props.holdActions.cancelHold({
	        accountId: accountId,
	        metadataIds: items.map(function (item) {
	          return item.get('metadataId');
	        }).filter(function (metadataId) {
	          return !_this2.props.shelves.has(metadataId);
	        }).toList().toJS(),
	        holdIds: items.map(function (item) {
	          return item.get('id');
	        }).toList().toJS(),
	        shelfState: shelfState,
	        messagingId: _MessagingConstants.GLOBAL_MESSAGING_ID,
	        isBatch: true
	      });
	    }
	  }, {
	    key: 'handleBatchAddToShelf',
	    value: function handleBatchAddToShelf(items, shelfName) {
	      var metadataIds = items.map(function (item) {
	        return item.get('metadataId');
	      }).toSet().toList();
	
	      this.props.shelfActions.batchAddToShelf({ metadataIds: metadataIds, shelfName: shelfName });
	    }
	  }, {
	    key: 'handleBatchResumeHolds',
	    value: function handleBatchResumeHolds(items) {
	      var _props4 = this.props,
	          accountId = _props4.accountId,
	          holdActions = _props4.holdActions;
	
	      var holdIds = items.map(function (item) {
	        return item.get('id');
	      }).toSet().toList().toJS();
	
	      holdActions.pauseOrResumeHolds({
	        accountId: accountId,
	        holdIds: holdIds,
	        suspended: { status: false }
	      });
	    }
	  }, {
	    key: 'renderBatchActionButtons',
	    value: function renderBatchActionButtons(itemsForAction) {
	      return _react2.default.createElement(_HoldsBatchActions2.default, {
	        itemsForAction: itemsForAction,
	        handleBatchCancel: this.handleBatchCancel,
	        handleBatchAddToShelf: this.handleBatchAddToShelf });
	    }
	  }, {
	    key: 'renderBorrowingList',
	    value: function renderBorrowingList() {
	      var _this3 = this;
	
	      var _props5 = this.props,
	          items = _props5.items,
	          showStaffPicksLink = _props5.showStaffPicksLink,
	          branches = _props5.branches,
	          pagination = _props5.pagination,
	          fetching = _props5.fetching;
	
	
	      var actionList = items.map(function (item) {
	        return _immutable2.default.Map({
	          id: item.get('holdsId'),
	          metadataId: item.get('metadataId'),
	          actions: item.get('actions')
	        });
	      });
	
	      if (!items || items.size === 0) {
	        return _react2.default.createElement(_HoldsEmptyContentPanel2.default, { fetching: fetching, showStaffPicksLink: showStaffPicksLink });
	      }
	
	      return _react2.default.createElement(
	        _BorrowingList2.default,
	        null,
	        _react2.default.createElement(_HoldsUtilityBar2.default, {
	          allItemsDigital: this.allItemsDigital(),
	          status: this.props.selectedStatus,
	          totalCount: this.props.totalUnfilteredCount,
	          materialTypeCounts: this.props.materialTypeCounts,
	          sortOptions: this.getSortOptions(),
	          printURL: this.getPrintURL(),
	          quotas: this.props.quotas,
	          pagination: this.props.pagination,
	          handleSort: this.handleSort }),
	        _react2.default.createElement(_HoldsList2.default, {
	          accountId: this.props.accountId,
	          items: items,
	          totalCount: items.size,
	          branches: branches,
	          actionList: actionList,
	          shelfTransactions: this.props.shelfTransactions,
	          workflowActions: this.props.workflowActions,
	          holdActions: this.props.holdActions,
	          availabilityDetailActions: this.props.availabilityDetailActions,
	          handleBatchAddToShelf: this.handleBatchAddToShelf,
	          handleBatchCancel: this.handleBatchCancel,
	          handleBatchResumeHolds: this.handleBatchResumeHolds,
	          renderBatchActionButtons: function renderBatchActionButtons(itemsForAction) {
	            return _this3.renderBatchActionButtons(itemsForAction);
	          },
	          holdsTransactions: this.props.holdsTransactions }),
	        _react2.default.createElement(
	          'section',
	          { className: 'bottom-controls' },
	          _react2.default.createElement(_pagination2.default, {
	            showPages: true,
	            isFetching: fetching,
	            page: pagination.get('page'),
	            limit: pagination.get('limit'),
	            count: pagination.get('count'),
	            pages: pagination.get('pages') })
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-holds' },
	        _react2.default.createElement(_sharedProgressBar2.default, { active: this.props.fetching }),
	        _react2.default.createElement(_BorrowingHeader2.default, {
	          headingKey: 'section_title_holds',
	          taglineKey: 'section_tagline_holds',
	          helpLinkPage: '005borrowing' }),
	        this.renderBorrowingList(),
	        _react2.default.createElement(_HoldsToReviewContainer2.default, null)
	      );
	    }
	  }]);
	
	  return Holds;
	}(_baseBcReactComponent2.default);
	
	Holds.propTypes = {
	  items: _reactImmutableProptypes2.default.listOf(_bcPropTypes.holdItemShape),
	  selectedStatus: _react.PropTypes.string,
	  presentStatuses: _reactImmutableProptypes2.default.listOf(_react.PropTypes.string),
	  totalUnfilteredCount: _react.PropTypes.number,
	  borrowingActions: _react.PropTypes.objectOf(_react.PropTypes.func),
	  materialTypeCounts: _reactImmutableProptypes2.default.mapContains({
	    PHYSICAL: _react.PropTypes.number,
	    DIGITAL: _react.PropTypes.number
	  }),
	  printURL: _react.PropTypes.string,
	  quotas: _reactImmutableProptypes2.default.listOf(_bcPropTypes.borrowingQuotaShape),
	  showStaffPicksLink: _react.PropTypes.bool,
	  branches: _reactImmutableProptypes2.default.listOf(_bcPropTypes.branchShape).isRequired,
	  accountId: _react.PropTypes.number,
	  holdsTransactions: _reactImmutableProptypes2.default.map,
	  shelves: _reactImmutableProptypes2.default.map,
	  shelfTransactions: _reactImmutableProptypes2.default.map,
	  fetching: _react.PropTypes.bool
	};
	
	exports.default = (0, _reactRouter.withRouter)(Holds);

/***/ },
/* 1717 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Holds = __webpack_require__(1716);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Holds).default;
	  }
	});
	Object.defineProperty(exports, 'Holds', {
	  enumerable: true,
	  get: function get() {
	    return _Holds.Holds;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1718 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _availabilityBibBlock = __webpack_require__(226);
	
	var _availabilityBibBlock2 = _interopRequireDefault(_availabilityBibBlock);
	
	var _ItemField = __webpack_require__(237);
	
	var _ItemField2 = _interopRequireDefault(_ItemField);
	
	var _ItemFormat = __webpack_require__(289);
	
	var _ItemFormat2 = _interopRequireDefault(_ItemFormat);
	
	__webpack_require__(2483);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HoldsAdditionalBriefInfo = function (_BcReactComponent) {
	  _inherits(HoldsAdditionalBriefInfo, _BcReactComponent);
	
	  function HoldsAdditionalBriefInfo() {
	    _classCallCheck(this, HoldsAdditionalBriefInfo);
	
	    return _possibleConstructorReturn(this, (HoldsAdditionalBriefInfo.__proto__ || Object.getPrototypeOf(HoldsAdditionalBriefInfo)).apply(this, arguments));
	  }
	
	  _createClass(HoldsAdditionalBriefInfo, [{
	    key: 'renderVolume',
	    value: function renderVolume() {
	      var volume = this.props.item.get('volume');
	      return volume && _react2.default.createElement(_ItemField2.default, { className: 'volume-field', name: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'volume' }), value: volume });
	    }
	  }, {
	    key: 'renderCopy',
	    value: function renderCopy() {
	      var copy = this.props.item.get('copy');
	      return copy && _react2.default.createElement(_ItemField2.default, { className: 'copy-field', name: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'copy' }), value: copy });
	    }
	  }, {
	    key: 'renderItemDetails',
	    value: function renderItemDetails() {
	      var additionalTitleText = this.props.item.get('additionalTitleText');
	      return additionalTitleText && _react2.default.createElement(_ItemField2.default, { className: 'item-details-field', name: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'item_details' }), value: additionalTitleText });
	    }
	  }, {
	    key: 'isOnOrder',
	    value: function isOnOrder() {
	      var availabilityStatus = this.props.item.getIn(['bib', 'availability']);
	      var status = availabilityStatus.get('status') || availabilityStatus.get('localisedStatus');
	      return status === 'ON_ORDER';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          item = _props.item,
	          availabilityDetailActions = _props.availabilityDetailActions;
	
	      var bib = item.getIn(['bib', 'briefInfo']);
	      if (!bib) {
	        return null;
	      }
	
	      var availabilityStatus = item.getIn(['bib', 'availability']);
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-holds-additional-brief-info' },
	        this.renderItemDetails(),
	        this.renderVolume(),
	        this.renderCopy(),
	        _react2.default.createElement(_ItemFormat2.default, { bib: item.get('bib') }),
	        _react2.default.createElement(
	          'div',
	          { className: 'cp-holds-availability-link' },
	          _react2.default.createElement(_availabilityBibBlock2.default, {
	            bib: item.get('bib'),
	            availabilityStatus: availabilityStatus,
	            availabilityDetailActions: availabilityDetailActions,
	            showCheckDigitalAvailabilityButton: false,
	            showAvailabilityStatus: this.isOnOrder(),
	            showAvailabilityLink: true })
	        )
	      );
	    }
	  }]);
	
	  return HoldsAdditionalBriefInfo;
	}(_baseBcReactComponent2.default);
	
	exports.default = HoldsAdditionalBriefInfo;
	
	
	HoldsAdditionalBriefInfo.propTypes = {
	  item: _bcPropTypes.holdItemShape
	};

/***/ },
/* 1719 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _HoldsAdditionalBriefInfo = __webpack_require__(1718);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_HoldsAdditionalBriefInfo).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1720 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = renderHoldsBatchActionsOptions;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseDropdown = __webpack_require__(37);
	
	var _reactIntl = __webpack_require__(3);
	
	var _BatchActionLink = __webpack_require__(238);
	
	var _BatchActionLink2 = _interopRequireDefault(_BatchActionLink);
	
	var _CancelHoldBatchAction = __webpack_require__(1706);
	
	var _CancelHoldBatchAction2 = _interopRequireDefault(_CancelHoldBatchAction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO: convert this to a proper React component when we update to React 16.
	// In React 15 component render methods are not allowed to return arrays, so this has to be a regular function.
	function renderHoldsBatchActionsOptions(_ref) {
	  var items = _ref.items,
	      handlePauseHoldsOverlay = _ref.handlePauseHoldsOverlay,
	      handleEditHoldsOverlay = _ref.handleEditHoldsOverlay,
	      handleResumeHolds = _ref.handleResumeHolds,
	      handleOpenBatchCancelOverlay = _ref.handleOpenBatchCancelOverlay,
	      itemsWithBibs = _ref.itemsWithBibs;
	
	  var pauseHoldItems = items.filter(function (item) {
	    return item.get('actions').includes('suspend') && !item.get('actions').includes('activate') && !item.get('actions').includes('updateSuspend');
	  });
	  var resumeHoldsItems = items.filter(function (item) {
	    return item.get('actions').includes('activate');
	  });
	
	  var itemsWithSuspend = items.filter(function (item) {
	    return item.get('actions').includes('updateSuspend');
	  });
	  var metadataIds = itemsWithSuspend.map(function (item) {
	    return item.get('metadataId');
	  });
	  var selectedBibs = itemsWithBibs.filter(function (item) {
	    return metadataIds.includes(item.getIn(['bib', 'id']));
	  });
	  var editHoldsDateItems = selectedBibs.filter(function (bib) {
	    return bib.getIn(['bib', 'policy', 'materialPolicy', 'supportsSuspendHoldStartDate']) === true || bib.getIn(['bib', 'policy', 'materialPolicy', 'supportsSuspendHoldEndDateEdit']) === true;
	  });
	
	  var cancelHoldsOption = _react2.default.createElement(_CancelHoldBatchAction2.default, {
	    key: 'batch-cancel-action',
	    items: items,
	    handleClick: function handleClick() {
	      return handleOpenBatchCancelOverlay();
	    } });
	
	  var editHoldsOption = _react2.default.createElement(
	    _baseDropdown.DropdownMenuItem,
	    { key: 'edit-holds-dropdown-option' },
	    _react2.default.createElement(
	      _BatchActionLink2.default,
	      {
	        disabled: editHoldsDateItems.size === 0,
	        handleClick: function handleClick() {
	          return handleEditHoldsOverlay();
	        } },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'batch_edit_dates_with_count', values: { count: editHoldsDateItems.size } })
	    )
	  );
	
	  var pauseHoldsOption = _react2.default.createElement(
	    _baseDropdown.DropdownMenuItem,
	    { key: 'pause-holds-dropdown-option' },
	    _react2.default.createElement(
	      _BatchActionLink2.default,
	      {
	        disabled: pauseHoldItems.size === 0,
	        handleClick: function handleClick() {
	          return handlePauseHoldsOverlay();
	        } },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'batch_pause_holds_with_count', values: { count: pauseHoldItems.size } })
	    )
	  );
	
	  var resumeHoldsOption = _react2.default.createElement(
	    _baseDropdown.DropdownMenuItem,
	    { key: 'resume-holds-dropdown-option' },
	    _react2.default.createElement(
	      _BatchActionLink2.default,
	      {
	        disabled: resumeHoldsItems.size === 0,
	        handleClick: function handleClick() {
	          return handleResumeHolds(resumeHoldsItems);
	        } },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'batch_resume_holds_with_count', values: { count: resumeHoldsItems.size } })
	    )
	  );
	
	  return [cancelHoldsOption, resumeHoldsOption, pauseHoldsOption, editHoldsOption, _react2.default.createElement(_baseDropdown.DropdownMenuDivider, { key: 'holds-batch-actions-divider' })];
	}

/***/ },
/* 1721 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _HoldsBatchActionOptions = __webpack_require__(1720);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_HoldsBatchActionOptions).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1722 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = HoldsBatchActions;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _baseIcons = __webpack_require__(10);
	
	var _BatchActionButton = __webpack_require__(584);
	
	var _BatchActionButton2 = _interopRequireDefault(_BatchActionButton);
	
	var _BatchAddToShelfButton = __webpack_require__(388);
	
	var _BatchAddToShelfButton2 = _interopRequireDefault(_BatchAddToShelfButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function HoldsBatchActions(_ref) {
	  var itemsForAction = _ref.itemsForAction,
	      handleBatchAction = _ref.handleBatchAction,
	      handleBatchCancel = _ref.handleBatchCancel,
	      handleBatchAddToShelf = _ref.handleBatchAddToShelf;
	
	  // setting this as default for now until we figure multiple batch actions
	  var itemSelected = itemsForAction.get('cancel', _immutable2.default.List());
	  var shelfItemsSelected = itemsForAction.get('addToShelf', _immutable2.default.List());
	  return _react2.default.createElement(
	    'div',
	    { className: 'cp-holds-batch-actions' },
	    _react2.default.createElement(
	      _BatchActionButton2.default,
	      {
	        className: 'batch-cancel-button',
	        selectedItemCount: itemSelected.size,
	        handleClick: function handleClick() {
	          return handleBatchCancel(itemSelected);
	        } },
	      _react2.default.createElement(_baseIcons.Cancel, { color: 'currentcolor' }),
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'cancel_button' })
	    ),
	    '\xA0',
	    _react2.default.createElement(
	      _BatchActionButton2.default,
	      {
	        className: 'batch-pause-button',
	        selectedItemCount: itemSelected.size,
	        handleClick: function handleClick() {
	          return handleBatchAction(itemSelected);
	        } },
	      _react2.default.createElement(_baseIcons.PauseCircled, null),
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'holds_batch_action_pause' })
	    ),
	    '\xA0',
	    _react2.default.createElement(
	      _BatchActionButton2.default,
	      {
	        className: 'batch-resume-button',
	        selectedItemCount: itemSelected.size,
	        handleClick: function handleClick() {
	          return handleBatchAction(itemSelected);
	        } },
	      _react2.default.createElement(_baseIcons.Resume, null),
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'holds_batch_action_resume' })
	    ),
	    '\xA0',
	    _react2.default.createElement(
	      _BatchActionButton2.default,
	      {
	        className: 'batch-edit-dates-button',
	        selectedItemCount: itemSelected.size,
	        handleClick: function handleClick() {
	          return handleBatchAction(itemSelected);
	        } },
	      _react2.default.createElement(_baseIcons.CalendarEmpty, null),
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'holds_batch_action_edit_dates' })
	    ),
	    '\xA0',
	    _react2.default.createElement(_BatchAddToShelfButton2.default, {
	      selectedItemCount: shelfItemsSelected.size,
	      handleClick: function handleClick(shelfName) {
	        return handleBatchAddToShelf(shelfItemsSelected, shelfName);
	      } })
	  );
	}
	
	HoldsBatchActions.propTypes = {
	  itemsForAction: _reactImmutableProptypes2.default.map,
	  handleBatchAction: _react.PropTypes.func,
	  handleBatchCancel: _react.PropTypes.func,
	  handleBatchAddToShelf: _react.PropTypes.func
	};

/***/ },
/* 1723 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _HoldsBatchActions = __webpack_require__(1722);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_HoldsBatchActions).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1724 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = HoldsEmptyContentPanel;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _BorrowingEmptyContentPanel = __webpack_require__(235);
	
	var _BorrowingEmptyContentPanel2 = _interopRequireDefault(_BorrowingEmptyContentPanel);
	
	var _baseIcons = __webpack_require__(10);
	
	__webpack_require__(2484);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function HoldsEmptyContentPanel(_ref) {
	  var fetching = _ref.fetching;
	
	  return _react2.default.createElement(_BorrowingEmptyContentPanel2.default, {
	    className: 'cp-holds-empty-content-panel',
	    icon: _react2.default.createElement(_baseIcons.HoldsIcon, null),
	    showExploreNewTitlesLink: true,
	    fetching: fetching,
	    title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'holds_empty_title' }) });
	}
	
	HoldsEmptyContentPanel.propTypes = {
	  fetching: _react.PropTypes.bool
	};

/***/ },
/* 1725 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _HoldsEmptyContentPanel = __webpack_require__(1724);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_HoldsEmptyContentPanel).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1726 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(9);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseAccessibilityDatePicker = __webpack_require__(272);
	
	var _baseAccessibilityDatePicker2 = _interopRequireDefault(_baseAccessibilityDatePicker);
	
	var _baseButtons = __webpack_require__(12);
	
	var _baseIcons = __webpack_require__(10);
	
	var _ShortFormattedDate = __webpack_require__(60);
	
	var _ShortFormattedDate2 = _interopRequireDefault(_ShortFormattedDate);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	__webpack_require__(2485);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HoldsExpiryDate = function (_BcReactComponent) {
	  _inherits(HoldsExpiryDate, _BcReactComponent);
	
	  function HoldsExpiryDate(props) {
	    _classCallCheck(this, HoldsExpiryDate);
	
	    var _this = _possibleConstructorReturn(this, (HoldsExpiryDate.__proto__ || Object.getPrototypeOf(HoldsExpiryDate)).call(this, props));
	
	    _this.state = {
	      open: false,
	      date: _this.getExpiryDate()
	    };
	    _this.bindAll('handleDate', 'handleClose');
	    return _this;
	  }
	
	  _createClass(HoldsExpiryDate, [{
	    key: 'getExpiryDate',
	    value: function getExpiryDate() {
	      return this.props.item.get('expiryDate');
	    }
	  }, {
	    key: 'handleDate',
	    value: function handleDate(date) {
	      this.setState({ date: date });
	      this.props.handleUpdateExpiryDate(date);
	    }
	  }, {
	    key: 'handleClose',
	    value: function handleClose() {
	      this.setState({
	        open: false
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var isExpiryDateEditable = this.props.item.get('actions').includes('updateExpiry');
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-holds-expiry-date' },
	        isExpiryDateEditable ? _react2.default.createElement(
	          _baseAccessibilityDatePicker2.default,
	          {
	            open: this.state.open,
	            onDateChange: this.handleDate,
	            handleClose: this.handleClose,
	            initialDate: this.getExpiryDate(),
	            isOutsideRange: function isOutsideRange(day) {
	              return !day.isAfter((0, _moment2.default)(), 'day');
	            },
	            fullScreen: true },
	          _react2.default.createElement(
	            _baseButtons.TextButton,
	            {
	              disabled: this.props.disabled,
	              showLoadingText: true,
	              isLoading: this.props.isLoading,
	              className: 'cp-holds-expiry-button',
	              handleClick: function handleClick() {
	                return _this2.setState({ open: true });
	              } },
	            _react2.default.createElement(_baseIcons.CalendarEmpty, null),
	            _react2.default.createElement(_ShortFormattedDate2.default, { value: this.getExpiryDate() })
	          )
	        ) : _react2.default.createElement(_ShortFormattedDate2.default, { value: this.state.date })
	      );
	    }
	  }]);
	
	  return HoldsExpiryDate;
	}(_baseBcReactComponent2.default);
	
	exports.default = HoldsExpiryDate;
	
	
	HoldsExpiryDate.propTypes = {
	  item: _reactImmutableProptypes2.default.map,
	  handleUpdateExpiryDate: _react.PropTypes.func,
	  isLoading: _react.PropTypes.bool,
	  disabled: _react.PropTypes.bool
	};

/***/ },
/* 1727 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _HoldsExpiryDate = __webpack_require__(1726);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_HoldsExpiryDate).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1728 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.HoldsList = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _moment = __webpack_require__(9);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _ItemList = __webpack_require__(145);
	
	var _ItemList2 = _interopRequireDefault(_ItemList);
	
	var _BatchActionsListContainer = __webpack_require__(298);
	
	var _BatchActionsListContainer2 = _interopRequireDefault(_BatchActionsListContainer);
	
	var _BatchActionsListItem = __webpack_require__(288);
	
	var _BatchActionsListItem2 = _interopRequireDefault(_BatchActionsListItem);
	
	var _HoldItem = __webpack_require__(1714);
	
	var _HoldItem2 = _interopRequireDefault(_HoldItem);
	
	var _AddToShelfBatchActions = __webpack_require__(382);
	
	var _AddToShelfBatchActions2 = _interopRequireDefault(_AddToShelfBatchActions);
	
	var _EditHoldDatesBatchActions = __webpack_require__(1710);
	
	var _EditHoldDatesBatchActions2 = _interopRequireDefault(_EditHoldDatesBatchActions);
	
	var _PauseHoldsBatchActions = __webpack_require__(1757);
	
	var _PauseHoldsBatchActions2 = _interopRequireDefault(_PauseHoldsBatchActions);
	
	var _HoldsBatchActionOptions = __webpack_require__(1721);
	
	var _HoldsBatchActionOptions2 = _interopRequireDefault(_HoldsBatchActionOptions);
	
	var _BatchCancelOverlay = __webpack_require__(1704);
	
	var _BatchCancelOverlay2 = _interopRequireDefault(_BatchCancelOverlay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isStartDateEditable = function isStartDateEditable(hold) {
	  return hold.getIn(['bib', 'policy', 'materialPolicy', 'supportsSuspendHoldStartDate'], false);
	};
	
	var isEndDateEditable = function isEndDateEditable(hold) {
	  return hold.getIn(['bib', 'policy', 'materialPolicy', 'supportsSuspendHoldEndDateEdit'], false);
	};
	
	var HoldsList = exports.HoldsList = function (_BcReactComponent) {
	  _inherits(HoldsList, _BcReactComponent);
	
	  function HoldsList(props) {
	    _classCallCheck(this, HoldsList);
	
	    var _this = _possibleConstructorReturn(this, (HoldsList.__proto__ || Object.getPrototypeOf(HoldsList)).call(this, props));
	
	    _this.state = {
	      showEditHoldsDateOverlay: false,
	      showPauseHoldsDateOverlay: false,
	      showBatchCancelOverlay: false
	    };
	
	    _this.bindAll('renderBibListItem', 'renderBatchActionsMenu', 'handleCloseEditHoldsDateOverlay', 'handleClosePauseHoldsDateOverlay', 'handleOpenBatchCancelOverlay', 'handleCloseBatchCancelOverlay', 'handleUpdateHoldsPauseEndDate', 'handleUpdateHoldsExpiryDate');
	    return _this;
	  }
	
	  _createClass(HoldsList, [{
	    key: 'handleCloseEditHoldsDateOverlay',
	    value: function handleCloseEditHoldsDateOverlay() {
	      this.setState({
	        showEditHoldsDateOverlay: false
	      });
	    }
	  }, {
	    key: 'handleOpenBatchCancelOverlay',
	    value: function handleOpenBatchCancelOverlay() {
	      this.setState({ showBatchCancelOverlay: true });
	    }
	  }, {
	    key: 'handleCloseBatchCancelOverlay',
	    value: function handleCloseBatchCancelOverlay() {
	      this.setState({ showBatchCancelOverlay: false });
	    }
	  }, {
	    key: 'handleUpdateHoldsPauseEndDate',
	    value: function handleUpdateHoldsPauseEndDate(holdIds, endDate) {
	      var _props = this.props,
	          accountId = _props.accountId,
	          holdActions = _props.holdActions,
	          intl = _props.intl;
	
	      holdActions.updateHoldsPauseEndDate({
	        accountId: accountId,
	        holdIds: holdIds,
	        endDate: endDate,
	        formattedEndDate: intl.formatDate((0, _moment2.default)(endDate).toDate(), { year: 'numeric', day: '2-digit', month: 'short' })
	      });
	    }
	  }, {
	    key: 'handleUpdateHoldsExpiryDate',
	    value: function handleUpdateHoldsExpiryDate(holdIds, expiryDate) {
	      var _props2 = this.props,
	          accountId = _props2.accountId,
	          holdActions = _props2.holdActions,
	          intl = _props2.intl;
	
	      holdActions.updateHoldsExpiryDate({
	        accountId: accountId,
	        holdIds: holdIds,
	        expiryDate: expiryDate,
	        formattedExpiryDate: intl.formatDate((0, _moment2.default)(expiryDate).toDate(), { year: 'numeric', day: '2-digit', month: 'short' })
	      });
	    }
	  }, {
	    key: 'anyHoldCancelling',
	    value: function anyHoldCancelling() {
	      return this.props.holdsTransactions.toList().some(function (item) {
	        return item.get('isCancelling', false);
	      });
	    }
	  }, {
	    key: 'anyActionInProgressForItem',
	    value: function anyActionInProgressForItem(item) {
	      var _props3 = this.props,
	          holdsTransactions = _props3.holdsTransactions,
	          shelfTransactions = _props3.shelfTransactions;
	
	      var holdsId = item.get('holdsId');
	      var metadataId = item.get('metadataId');
	
	      var anyOngoingHoldsAction = !holdsTransactions.get(holdsId, _immutable2.default.Map()).isEmpty();
	      var anyOngoingShelfAction = !shelfTransactions.get(metadataId, _immutable2.default.Map()).isEmpty();
	
	      return anyOngoingHoldsAction || anyOngoingShelfAction;
	    }
	  }, {
	    key: 'batchActionsLoading',
	    value: function batchActionsLoading() {
	      var _this2 = this;
	
	      return this.props.items.some(function (item) {
	        return _this2.anyActionInProgressForItem(item);
	      });
	    }
	  }, {
	    key: 'handleClosePauseHoldsDateOverlay',
	    value: function handleClosePauseHoldsDateOverlay() {
	      this.setState({
	        showPauseHoldsDateOverlay: false
	      });
	    }
	  }, {
	    key: 'renderBibListItem',
	    value: function renderBibListItem(item, selectedItems, updateItem) {
	      var _props4 = this.props,
	          branches = _props4.branches,
	          holdActions = _props4.holdActions,
	          workflowActions = _props4.workflowActions,
	          availabilityDetailActions = _props4.availabilityDetailActions,
	          accountId = _props4.accountId;
	
	
	      var actionItem = _immutable2.default.Map({
	        id: item.get('holdsId'),
	        metadataId: item.getIn(['bib', 'briefInfo', 'metadataId']),
	        actions: item.get('actions', _immutable2.default.List())
	      });
	
	      return _react2.default.createElement(
	        _BatchActionsListItem2.default,
	        {
	          key: item.get('holdsId'),
	          actionItem: actionItem,
	          selectedItems: selectedItems,
	          updateItem: updateItem },
	        _react2.default.createElement(_HoldItem2.default, {
	          actionInProgress: this.anyActionInProgressForItem(item),
	          item: item,
	          accountId: accountId,
	          branches: branches,
	          holdActions: holdActions,
	          workflowActions: workflowActions,
	          availabilityDetailActions: availabilityDetailActions,
	          handleUpdateHoldsPauseEndDate: this.handleUpdateHoldsPauseEndDate,
	          handleUpdateHoldsExpiryDate: this.handleUpdateHoldsExpiryDate,
	          holdsTransactions: this.props.holdsTransactions,
	          shelfTransactions: this.props.shelfTransactions })
	      );
	    }
	  }, {
	    key: 'renderBatchEditHoldDatesOverlay',
	    value: function renderBatchEditHoldDatesOverlay(selectedItems) {
	      var accountId = this.props.accountId;
	
	      var canEditHoldDateItems = selectedItems.filter(function (item) {
	        return item.get('actions').includes('updateSuspend');
	      });
	      var metadataIds = canEditHoldDateItems.map(function (item) {
	        return item.get('metadataId');
	      });
	      var selectedHolds = this.props.items.filter(function (item) {
	        return metadataIds.includes(item.getIn(['bib', 'id']));
	      });
	      var editableHolds = selectedHolds.filter(function (hold) {
	        return isStartDateEditable(hold) || isEndDateEditable(hold);
	      });
	
	      return _react2.default.createElement(_EditHoldDatesBatchActions2.default, {
	        key: 'batch-edit-dates',
	        open: this.state.showEditHoldsDateOverlay,
	        accountId: accountId,
	        items: editableHolds,
	        handleUpdateHoldsPauseEndDate: this.handleUpdateHoldsPauseEndDate,
	        handleClose: this.handleCloseEditHoldsDateOverlay });
	    }
	  }, {
	    key: 'renderBatchPauseHoldDatesOverlay',
	    value: function renderBatchPauseHoldDatesOverlay(selectedItems) {
	      var _props5 = this.props,
	          accountId = _props5.accountId,
	          holdActions = _props5.holdActions;
	
	      var canPauseHoldItems = selectedItems.filter(function (item) {
	        return item.get('actions').includes('suspend') && !item.get('actions').includes('activate') && !item.get('actions').includes('updateSuspend');
	      });
	
	      var metadataIds = canPauseHoldItems.map(function (item) {
	        return item.get('metadataId');
	      });
	      var selectedHolds = this.props.items.filter(function (item) {
	        return metadataIds.includes(item.getIn(['bib', 'id']));
	      });
	
	      var supportsSuspendHoldStartDate = selectedHolds.some(isStartDateEditable);
	      var supportsSuspendHoldEndDate = selectedHolds.some(isEndDateEditable);
	
	      return _react2.default.createElement(_PauseHoldsBatchActions2.default, {
	        open: this.state.showPauseHoldsDateOverlay,
	        accountId: accountId,
	        items: canPauseHoldItems,
	        supportsSuspendHoldStartDate: supportsSuspendHoldStartDate,
	        supportsSuspendHoldEndDate: supportsSuspendHoldEndDate,
	        handlePauseHolds: holdActions.pauseOrResumeHolds,
	        handleClose: this.handleClosePauseHoldsDateOverlay });
	    }
	  }, {
	    key: 'renderBatchCancelOverlay',
	    value: function renderBatchCancelOverlay(selectedItems) {
	      var _this3 = this;
	
	      var accountId = this.props.accountId;
	
	      var canAddAnyItemToShelf = !selectedItems.filter(function (item) {
	        return item.get('actions').includes('addToShelf');
	      }).isEmpty();
	
	      return _react2.default.createElement(_BatchCancelOverlay2.default, {
	        open: this.state.showBatchCancelOverlay,
	        accountId: accountId,
	        count: selectedItems.size,
	        showShelfControls: canAddAnyItemToShelf,
	        handleBatchCancel: function handleBatchCancel(_ref) {
	          var shelfState = _ref.shelfState;
	          return _this3.props.handleBatchCancel({ shelfState: shelfState, items: selectedItems });
	        },
	        isLoading: this.anyHoldCancelling(),
	        handleClose: this.handleCloseBatchCancelOverlay });
	    }
	  }, {
	    key: 'renderBatchActionsMenu',
	    value: function renderBatchActionsMenu(selectedActionItems) {
	      var _this4 = this;
	
	      var handleOpenBatchCancelOverlay = this.handleOpenBatchCancelOverlay;
	
	      return [].concat(_toConsumableArray((0, _HoldsBatchActionOptions2.default)({
	        items: selectedActionItems,
	        itemsWithBibs: this.props.items,
	        handlePauseHoldsOverlay: function handlePauseHoldsOverlay() {
	          return _this4.setState({ showPauseHoldsDateOverlay: true });
	        },
	        handleEditHoldsOverlay: function handleEditHoldsOverlay() {
	          return _this4.setState({ showEditHoldsDateOverlay: true });
	        },
	        handleResumeHolds: this.props.handleBatchResumeHolds,
	        handleOpenBatchCancelOverlay: handleOpenBatchCancelOverlay
	      })), _toConsumableArray((0, _AddToShelfBatchActions2.default)({
	        items: selectedActionItems,
	        handleBatchAddToShelf: this.props.handleBatchAddToShelf
	      })));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-holds-list' },
	        _react2.default.createElement(
	          _BatchActionsListContainer2.default,
	          {
	            actionIsLoading: this.batchActionsLoading(),
	            list: this.props.actionList,
	            totalItems: this.props.totalCount,
	            renderActionsMenu: this.renderBatchActionsMenu },
	          function (selectedItems, updateItem) {
	            return _react2.default.createElement(
	              _ItemList2.default,
	              null,
	              _this5.props.items.map(function (item) {
	                return _this5.renderBibListItem(item, selectedItems, updateItem);
	              }),
	              _this5.renderBatchEditHoldDatesOverlay(selectedItems),
	              _this5.renderBatchPauseHoldDatesOverlay(selectedItems),
	              _this5.renderBatchCancelOverlay(selectedItems)
	            );
	          }
	        )
	      );
	    }
	  }]);
	
	  return HoldsList;
	}(_baseBcReactComponent2.default);
	
	HoldsList.propTypes = {
	  accountId: _react.PropTypes.number,
	  items: _reactImmutableProptypes2.default.list,
	  totalCount: _react.PropTypes.number,
	  branches: _reactImmutableProptypes2.default.listOf(_bcPropTypes.branchShape).isRequired,
	  actionList: _reactImmutableProptypes2.default.list,
	  holdsTransactions: _reactImmutableProptypes2.default.map,
	  shelfTransactions: _reactImmutableProptypes2.default.map,
	  workflowActions: _react.PropTypes.objectOf(_react.PropTypes.func),
	  holdActions: _react.PropTypes.objectOf(_react.PropTypes.func),
	  renderBatchActionButtons: _react.PropTypes.func,
	  handleBatchAddToShelf: _react.PropTypes.func,
	  intl: _reactIntl.intlShape
	};
	
	exports.default = (0, _reactIntl.injectIntl)(HoldsList);

/***/ },
/* 1729 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _HoldsList = __webpack_require__(1728);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_HoldsList).default;
	  }
	});
	Object.defineProperty(exports, 'HoldsList', {
	  enumerable: true,
	  get: function get() {
	    return _HoldsList.HoldsList;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1730 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(9);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseAccessibilityDatePicker = __webpack_require__(272);
	
	var _baseAccessibilityDatePicker2 = _interopRequireDefault(_baseAccessibilityDatePicker);
	
	var _baseButtons = __webpack_require__(12);
	
	var _baseIcons = __webpack_require__(10);
	
	var _ShortFormattedDate = __webpack_require__(60);
	
	var _ShortFormattedDate2 = _interopRequireDefault(_ShortFormattedDate);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	__webpack_require__(2486);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HoldsPauseDateLink = function (_BcReactComponent) {
	  _inherits(HoldsPauseDateLink, _BcReactComponent);
	
	  function HoldsPauseDateLink(props) {
	    _classCallCheck(this, HoldsPauseDateLink);
	
	    var _this = _possibleConstructorReturn(this, (HoldsPauseDateLink.__proto__ || Object.getPrototypeOf(HoldsPauseDateLink)).call(this, props));
	
	    _this.state = {
	      openPauseDateOverlay: false,
	      date: _this.getPauseEndDate()
	    };
	    _this.bindAll('handleDate', 'handleClose');
	    return _this;
	  }
	
	  _createClass(HoldsPauseDateLink, [{
	    key: 'getPauseEndDate',
	    value: function getPauseEndDate() {
	      return this.props.item.get('suspendEndDate');
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps) {
	      if (nextProps.item.get('suspendEndDate') !== this.props.item.get('suspendEndDate')) {
	        this.setState({ date: nextProps.item.get('suspendEndDate') });
	      }
	
	      return null;
	    }
	  }, {
	    key: 'handleDate',
	    value: function handleDate(dateValue) {
	      this.setState({
	        date: dateValue
	      });
	      this.props.handleUpdatePauseEndDate(dateValue);
	    }
	  }, {
	    key: 'handleClose',
	    value: function handleClose() {
	      this.setState({
	        openPauseDateOverlay: false
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var canChangePauseUntilDate = this.props.item.get('actions').includes('updateSuspend');
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-holds-pause-date-link' },
	        canChangePauseUntilDate ? _react2.default.createElement(
	          _baseAccessibilityDatePicker2.default,
	          {
	            className: 'cp-holds-pause-date-link-date-picker',
	            open: this.state.openPauseDateOverlay,
	            onDateChange: this.handleDate,
	            handleClose: this.handleClose,
	            initialDate: this.props.item.get('suspendEndDate'),
	            isOutsideRange: function isOutsideRange(day) {
	              return !day.isAfter((0, _moment2.default)(), 'day');
	            },
	            fullScreen: true },
	          _react2.default.createElement(
	            _baseButtons.TextButton,
	            {
	              showLoadingText: true,
	              disabled: this.props.disabled,
	              isLoading: this.props.isLoading,
	              className: 'holds-pause-date-link-button',
	              handleClick: function handleClick() {
	                return _this2.setState({ openPauseDateOverlay: true });
	              } },
	            _react2.default.createElement(_baseIcons.CalendarEmpty, null),
	            _react2.default.createElement(_ShortFormattedDate2.default, { value: this.getPauseEndDate() })
	          )
	        ) : _react2.default.createElement(_ShortFormattedDate2.default, { value: this.state.date })
	      );
	    }
	  }]);
	
	  return HoldsPauseDateLink;
	}(_baseBcReactComponent2.default);
	
	exports.default = HoldsPauseDateLink;
	
	
	HoldsPauseDateLink.propTypes = {
	  item: _reactImmutableProptypes2.default.map,
	  handleUpdatePauseEndDate: _react.PropTypes.func,
	  isLoading: _react.PropTypes.bool,
	  disabled: _react.PropTypes.bool
	};

/***/ },
/* 1731 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _HoldsPauseDateLink = __webpack_require__(1730);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_HoldsPauseDateLink).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1732 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(9);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseAccessibilityDatePicker = __webpack_require__(272);
	
	var _baseAccessibilityDatePicker2 = _interopRequireDefault(_baseAccessibilityDatePicker);
	
	var _baseButtons = __webpack_require__(12);
	
	var _baseIcons = __webpack_require__(10);
	
	var _ShortFormattedDate = __webpack_require__(60);
	
	var _ShortFormattedDate2 = _interopRequireDefault(_ShortFormattedDate);
	
	__webpack_require__(2487);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getTomorrow = function getTomorrow() {
	  return (0, _moment2.default)().add(1, 'day').format('YYYY-MM-DD');
	};
	
	var HoldsPauseDateSelect = function (_BcReactComponent) {
	  _inherits(HoldsPauseDateSelect, _BcReactComponent);
	
	  function HoldsPauseDateSelect(props) {
	    _classCallCheck(this, HoldsPauseDateSelect);
	
	    var _this = _possibleConstructorReturn(this, (HoldsPauseDateSelect.__proto__ || Object.getPrototypeOf(HoldsPauseDateSelect)).call(this, props));
	
	    var startDate = null;
	    if (_this.props.enableStartDate) {
	      startDate = props.initialSuspendStartDate ? props.initialSuspendStartDate : (0, _moment2.default)().format('YYYY-MM-DD');
	    }
	    var endDate = props.initialSuspendEndDate ? props.initialSuspendEndDate : null;
	    _this.state = {
	      openStartDateOverlay: false,
	      openEndDateOverlay: false,
	      suspended: {
	        startDate: startDate,
	        endDate: endDate,
	        status: false
	      }
	    };
	    return _this;
	  }
	
	  _createClass(HoldsPauseDateSelect, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var _state$suspended = this.state.suspended,
	          startDate = _state$suspended.startDate,
	          endDate = _state$suspended.endDate;
	
	
	      if (startDate !== prevState.suspended.startDate || endDate !== prevState.suspended.endDate) {
	        this.props.onSelectDates(this.state.suspended);
	      }
	      return null;
	    }
	  }, {
	    key: 'renderPauseStartDatePickerOverlay',
	    value: function renderPauseStartDatePickerOverlay() {
	      var _this2 = this;
	
	      var openStartDateOverlay = this.state.openStartDateOverlay;
	      var startDate = this.state.suspended.startDate;
	
	      var date = startDate || getTomorrow();
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'suspend-start-date-field item-row' },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'pause_holds_from' }),
	        _react2.default.createElement(
	          _baseAccessibilityDatePicker2.default,
	          {
	            open: openStartDateOverlay,
	            className: 'start-date',
	            fullScreen: this.props.fullScreen,
	            initialDate: date,
	            handleClose: function handleClose() {
	              return _this2.setState({ openStartDateOverlay: false });
	            },
	            isOutsideRange: function isOutsideRange(day) {
	              var isBeforeToday = day.isBefore((0, _moment2.default)(), 'day');
	
	              if (_this2.state.suspended.endDate) {
	                var isBeforeEnd = day.isBefore(_this2.state.suspended.endDate, 'day');
	                return !isBeforeEnd || isBeforeToday;
	              }
	
	              return isBeforeToday;
	            },
	            onDateChange: function onDateChange(fromDate) {
	              return _this2.setState({ suspended: _extends({}, _this2.state.suspended, { startDate: fromDate }) });
	            } },
	          _react2.default.createElement(
	            _baseButtons.PrimaryGhostButton,
	            { handleClick: function handleClick() {
	                return _this2.setState({ openStartDateOverlay: true });
	              } },
	            _react2.default.createElement(_baseIcons.CalendarEmpty, null),
	            _react2.default.createElement(_ShortFormattedDate2.default, { value: date })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderPauseEndDatePickerOverlay',
	    value: function renderPauseEndDatePickerOverlay() {
	      var _this3 = this;
	
	      var openEndDateOverlay = this.state.openEndDateOverlay;
	      var endDate = this.state.suspended.endDate;
	
	      var date = endDate;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'suspend-end-date-field item-row' },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'pause_holds_until' }),
	        _react2.default.createElement(
	          _baseAccessibilityDatePicker2.default,
	          {
	            open: openEndDateOverlay,
	            className: 'end-date',
	            fullScreen: this.props.fullScreen,
	            initialDate: date,
	            isOutsideRange: function isOutsideRange(day) {
	              var isAfterToday = day.isAfter((0, _moment2.default)(), 'day');
	
	              if (_this3.state.suspended.startDate) {
	                var isAfterStart = day.isAfter(_this3.state.suspended.startDate, 'day');
	                return !isAfterStart || !isAfterToday;
	              }
	
	              return !isAfterToday;
	            },
	            handleClose: function handleClose() {
	              return _this3.setState({ openEndDateOverlay: false });
	            },
	            onDateChange: function onDateChange(untilDate) {
	              return _this3.setState({ suspended: _extends({}, _this3.state.suspended, { endDate: untilDate }) });
	            } },
	          _react2.default.createElement(
	            _baseButtons.PrimaryGhostButton,
	            { handleClick: function handleClick() {
	                return _this3.setState({ openEndDateOverlay: true });
	              } },
	            _react2.default.createElement(_baseIcons.CalendarEmpty, null),
	            date ? _react2.default.createElement(_ShortFormattedDate2.default, { value: date }) : _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'select_a_date' })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          enableStartDate = _props.enableStartDate,
	          enableEndDate = _props.enableEndDate;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-holds-pause-date-select' },
	        enableStartDate && this.renderPauseStartDatePickerOverlay(),
	        enableEndDate && this.renderPauseEndDatePickerOverlay()
	      );
	    }
	  }]);
	
	  return HoldsPauseDateSelect;
	}(_baseBcReactComponent2.default);
	
	exports.default = HoldsPauseDateSelect;
	
	
	HoldsPauseDateSelect.defaultProps = {
	  enableStartDate: false
	};
	
	HoldsPauseDateSelect.propTypes = {
	  onSelectDates: _react.PropTypes.func,
	  enableStartDate: _react.PropTypes.bool,
	  enableEndDate: _react.PropTypes.bool,
	  initialSuspendStartDate: _react.PropTypes.string,
	  initialSuspendEndDate: _react.PropTypes.string
	};

/***/ },
/* 1733 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _baseButtons = __webpack_require__(12);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	var _BranchDropdown = __webpack_require__(587);
	
	var _BranchDropdown2 = _interopRequireDefault(_BranchDropdown);
	
	__webpack_require__(2488);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var renderDropdownTrigger = function renderDropdownTrigger(props) {
	  return _react2.default.createElement(_baseButtons.TextButton, _extends({ showLoadingText: true }, props));
	};
	
	var HoldsPickupBranchSelect = function (_BcReactComponent) {
	  _inherits(HoldsPickupBranchSelect, _BcReactComponent);
	
	  function HoldsPickupBranchSelect(props) {
	    _classCallCheck(this, HoldsPickupBranchSelect);
	
	    var _this = _possibleConstructorReturn(this, (HoldsPickupBranchSelect.__proto__ || Object.getPrototypeOf(HoldsPickupBranchSelect)).call(this, props));
	
	    _this.state = {
	      pickupLocation: _this.getInitialPickupLocation()
	    };
	
	    _this.bindAll('handleUpdatePickupLocation', 'isPickupLocationEditable');
	    return _this;
	  }
	
	  _createClass(HoldsPickupBranchSelect, [{
	    key: 'getSelectedBranch',
	    value: function getSelectedBranch() {
	      var _props = this.props,
	          branches = _props.branches,
	          selected = _props.selected;
	
	      return branches.find(function (b) {
	        return b.get('code') === selected;
	      });
	    }
	  }, {
	    key: 'getInitialPickupLocation',
	    value: function getInitialPickupLocation() {
	      var branches = this.props.branches;
	
	      var selectedBranch = this.getSelectedBranch();
	      var branch = selectedBranch || branches.first();
	      return branch && branch.get('code');
	    }
	  }, {
	    key: 'isPickupLocationEditable',
	    value: function isPickupLocationEditable() {
	      return !this.props.item.get('status').includes('READY_FOR_PICKUP') && this.props.item.get('actions').includes('updateLocation') && this.getSelectedBranch();
	    }
	  }, {
	    key: 'handleUpdatePickupLocation',
	    value: function handleUpdatePickupLocation(pickupLocation) {
	      this.setState({
	        pickupLocation: pickupLocation
	      });
	
	      this.props.handleUpdatePickupBranch(pickupLocation);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          item = _props2.item,
	          branches = _props2.branches,
	          isLoading = _props2.isLoading,
	          disabled = _props2.disabled;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'holds-pickup-branch-select' },
	        this.isPickupLocationEditable() ? _react2.default.createElement(
	          'div',
	          { className: 'holds-pickup-dropdown' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, {
	            id: 'pickup_at_location',
	            values: { location: _react2.default.createElement(
	                _BranchDropdown2.default,
	                {
	                  disabled: disabled,
	                  branches: branches,
	                  handleSelect: this.handleUpdatePickupLocation,
	                  selectedBranchCode: this.state.pickupLocation,
	                  ButtonTag: _baseButtons.TextButton,
	                  isLoading: isLoading,
	                  buttonClassName: '',
	                  renderDropdownTrigger: renderDropdownTrigger },
	                HoldsPickupBranchSelect.screenReaderLabel()
	              ) } })
	        ) : _react2.default.createElement(_reactIntl.FormattedMessage, {
	          id: 'pickup_at_location',
	          values: { location: _react2.default.createElement(
	              'span',
	              { className: 'branch-name' },
	              item.getIn(['pickupLocation', 'name'])
	            ) } })
	      );
	    }
	  }], [{
	    key: 'screenReaderLabel',
	    value: function screenReaderLabel() {
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement(
	          _baseScreenReaderMessage2.default,
	          null,
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'holds_pickup_dropdown' })
	        )
	      );
	    }
	  }]);
	
	  return HoldsPickupBranchSelect;
	}(_baseBcReactComponent2.default);
	
	exports.default = HoldsPickupBranchSelect;
	
	
	HoldsPickupBranchSelect.propTypes = {
	  item: _reactImmutableProptypes2.default.map,
	  branches: _reactImmutableProptypes2.default.listOf(_bcPropTypes.branchShape).isRequired,
	  selected: _react.PropTypes.string,
	  handleUpdatePickupBranch: _react.PropTypes.func,
	  isLoading: _react.PropTypes.bool,
	  disabled: _react.PropTypes.bool
	};

/***/ },
/* 1734 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _HoldsPickupBranchSelect = __webpack_require__(1733);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_HoldsPickupBranchSelect).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1735 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.HoldsPrintList = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(17);
	
	var _reactIntl = __webpack_require__(3);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _print = __webpack_require__(120);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _sharedFormatInfo = __webpack_require__(367);
	
	var _sharedFormatInfo2 = _interopRequireDefault(_sharedFormatInfo);
	
	var _sharedBibBrief = __webpack_require__(46);
	
	var _sharedBibBrief2 = _interopRequireDefault(_sharedBibBrief);
	
	var _ShortFormattedDate = __webpack_require__(60);
	
	var _ShortFormattedDate2 = _interopRequireDefault(_ShortFormattedDate);
	
	__webpack_require__(2489);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var renderStatus = function renderStatus(status, index, item) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'cp-holds-status-overview' },
	    _react2.default.createElement(
	      'div',
	      { className: 'print-borrowing-status' },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'circ_' + item.get('status').toLowerCase() })
	    ),
	    item.get('holdsPosition') !== -1 ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'holds_queue_info', values: { holdsPosition: _react2.default.createElement(
	          'strong',
	          null,
	          item.get('holdsPosition')
	        ), totalCopies: item.getIn(['bib', 'availability', 'totalCopies'], 0) } }) : '',
	    item.get('suspendEndDate') && _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'strong',
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'print_view_resume_hold' })
	      ),
	      _react2.default.createElement(_ShortFormattedDate2.default, { value: item.get('suspendEndDate') })
	    )
	  );
	};
	
	var renderFormat = function renderFormat(format, index, item) {
	  return _react2.default.createElement(_sharedFormatInfo2.default, { item: item.get('bib'), showLanguage: false });
	};
	
	var renderTitle = function renderTitle(title, index, item) {
	  return _react2.default.createElement(_sharedBibBrief2.default, {
	    bib: item.getIn(['bib', 'briefInfo']),
	    titleTag: 'span',
	    renderTitleAsLink: false,
	    renderAuthorsAsLink: false });
	};
	
	var HoldsPrintList = exports.HoldsPrintList = function (_BcReactComponent) {
	  _inherits(HoldsPrintList, _BcReactComponent);
	
	  function HoldsPrintList(props) {
	    _classCallCheck(this, HoldsPrintList);
	
	    var _this = _possibleConstructorReturn(this, (HoldsPrintList.__proto__ || Object.getPrototypeOf(HoldsPrintList)).call(this, props));
	
	    _this.bindAll('handleUpdatePage');
	    return _this;
	  }
	
	  _createClass(HoldsPrintList, [{
	    key: 'handleUpdatePage',
	    value: function handleUpdatePage() {
	      var _props = this.props,
	          router = _props.router,
	          pagination = _props.pagination;
	      var location = router.location;
	
	      var newPage = pagination.get('page') + 1;
	      this.props.router.push(_extends({}, location, { query: _extends({}, location.query, { page: newPage }) }));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          pagination = _props2.pagination,
	          items = _props2.items,
	          isFetching = _props2.isFetching;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-holds-print-list' },
	        _react2.default.createElement(
	          _print.PrintButtonsToolbar,
	          { numItemsToPrint: items.size },
	          _react2.default.createElement(_print.PrintLoadNextButton, {
	            handleClick: this.handleUpdatePage,
	            numToLoad: pagination.get('limit'),
	            totalPages: pagination.get('pages'),
	            currentPage: pagination.get('page'),
	            isLoading: isFetching })
	        ),
	        _react2.default.createElement(
	          'h1',
	          null,
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'section_title_holds' })
	        ),
	        _react2.default.createElement(
	          _reactIntl.FormattedMessage,
	          { id: 'label_number_of_items', values: { count: items.size } },
	          function (message) {
	            return _react2.default.createElement(
	              'p',
	              null,
	              message
	            );
	          }
	        ),
	        _react2.default.createElement(_print.PrintTable, {
	          rows: items,
	          fields: [{ key: 'bib.briefInfo.title', type: 'item-title', headerKey: 'table_headings_title', transformationMap: renderTitle }, { key: 'bib.briefInfo.format', type: 'item-format', headerKey: 'table_headings_format', transformationMap: renderFormat }, { key: 'bib.briefInfo.callNumber', type: 'item-callNumber', headerKey: 'callNumber' }, { key: 'barcode', type: 'item-barcode', headerKey: 'form_label_barcode' }, { key: 'status', type: 'item-status', headerKey: 'status_overview', transformationMap: renderStatus }] }),
	        _react2.default.createElement(
	          'div',
	          { className: 'page-info' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'form_label_current_page', values: { current_page: pagination.get('page') } }),
	          '\xA0',
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'form_label_total_pages', values: { total_pages: pagination.get('pages') } })
	        )
	      );
	    }
	  }]);
	
	  return HoldsPrintList;
	}(_baseBcReactComponent2.default);
	
	HoldsPrintList.propTypes = {
	  isFetching: _react.PropTypes.bool,
	  items: _reactImmutableProptypes2.default.listOf(_bcPropTypes.holdItemShape),
	  pagination: _bcPropTypes.paginationShape,
	  router: _reactRouter.routerShape
	};
	
	exports.default = (0, _reactRouter.withRouter)(HoldsPrintList);

/***/ },
/* 1736 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _HoldsPrintList = __webpack_require__(1735);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_HoldsPrintList).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1737 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = HoldsQuotasPopOver;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseAccessibilityPopOver = __webpack_require__(514);
	
	var _baseAccessibilityPopOver2 = _interopRequireDefault(_baseAccessibilityPopOver);
	
	var _baseIcons = __webpack_require__(10);
	
	var _BorrowingQuotas = __webpack_require__(568);
	
	var _BorrowingQuotas2 = _interopRequireDefault(_BorrowingQuotas);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var renderTriggerContent = function renderTriggerContent() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_baseIcons.Info, null),
	    '\xA0',
	    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'holds_see_limits' })
	  );
	};
	
	function HoldsQuotasPopOver(_ref) {
	  var quotas = _ref.quotas;
	
	  if (!quotas || quotas.size === 0) {
	    return null;
	  }
	
	  return _react2.default.createElement(
	    'span',
	    { className: 'cp-holds-quotas-pop-over' },
	    _react2.default.createElement(
	      _baseAccessibilityPopOver2.default,
	      {
	        href: '#holds-quotas-pop-over',
	        triggerContent: renderTriggerContent() },
	      _react2.default.createElement(_BorrowingQuotas2.default, {
	        title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'holds_my_limits' }),
	        quotas: quotas })
	    )
	  );
	}
	
	HoldsQuotasPopOver.propTypes = {
	  quotas: _reactImmutableProptypes2.default.list
	};

/***/ },
/* 1738 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _HoldsQuotasPopOver = __webpack_require__(1737);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_HoldsQuotasPopOver).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1739 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _reactIntl = __webpack_require__(3);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _HoldsPickupBranchSelect = __webpack_require__(1734);
	
	var _HoldsPickupBranchSelect2 = _interopRequireDefault(_HoldsPickupBranchSelect);
	
	var _HoldsExpiryDate = __webpack_require__(1727);
	
	var _HoldsExpiryDate2 = _interopRequireDefault(_HoldsExpiryDate);
	
	var _HoldsPauseDateLink = __webpack_require__(1731);
	
	var _HoldsPauseDateLink2 = _interopRequireDefault(_HoldsPauseDateLink);
	
	var _HoldStatusIcon = __webpack_require__(282);
	
	var _HoldStatusIcon2 = _interopRequireDefault(_HoldStatusIcon);
	
	var _HoldPosition = __webpack_require__(1636);
	
	var _HoldPosition2 = _interopRequireDefault(_HoldPosition);
	
	var _ShortFormattedDate = __webpack_require__(60);
	
	var _ShortFormattedDate2 = _interopRequireDefault(_ShortFormattedDate);
	
	__webpack_require__(2490);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HoldsSecondaryInfo = function (_BcReactComponent) {
	  _inherits(HoldsSecondaryInfo, _BcReactComponent);
	
	  function HoldsSecondaryInfo() {
	    _classCallCheck(this, HoldsSecondaryInfo);
	
	    return _possibleConstructorReturn(this, (HoldsSecondaryInfo.__proto__ || Object.getPrototypeOf(HoldsSecondaryInfo)).apply(this, arguments));
	  }
	
	  _createClass(HoldsSecondaryInfo, [{
	    key: 'renderHoldsStatus',
	    value: function renderHoldsStatus() {
	      var item = this.props.item;
	
	      var statusClass = item.get('status') ? item.get('status').toLowerCase() : '';
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('holds-status', statusClass) },
	        _react2.default.createElement(_HoldStatusIcon2.default, {
	          status: item.get('status'),
	          withBackground: true,
	          withLabel: true }),
	        _react2.default.createElement(_HoldPosition2.default, {
	          status: item.get('status'),
	          position: item.get('holdsPosition'),
	          totalCopies: item.getIn(['bib', 'availability', 'totalCopies'], 0),
	          holdText: item.get('holdText') })
	      );
	    }
	  }, {
	    key: 'renderPauseDate',
	    value: function renderPauseDate() {
	      var _props = this.props,
	          item = _props.item,
	          holdsTransactions = _props.holdsTransactions,
	          handleUpdatePauseEndDate = _props.handleUpdatePauseEndDate,
	          actionInProgress = _props.actionInProgress;
	
	      var pauseDataStatus = null;
	
	      var isLoading = holdsTransactions.getIn([item.get('holdsId'), 'isUpdatingPauseDate'], false);
	      if (item.get('suspendEndDate') && item.get('status') === 'SUSPENDED') {
	        pauseDataStatus = _react2.default.createElement(_reactIntl.FormattedMessage, {
	          key: 'holds-pause-date',
	          tagName: 'div',
	          id: 'paused_until_date',
	          values: {
	            date: _react2.default.createElement(_HoldsPauseDateLink2.default, {
	              disabled: actionInProgress && !isLoading,
	              item: item,
	              isLoading: isLoading,
	              handleUpdatePauseEndDate: handleUpdatePauseEndDate })
	          } });
	      } else if (item.get('suspendEndDate') && item.get('suspendStartDate')) {
	        pauseDataStatus = _react2.default.createElement(_reactIntl.FormattedMessage, {
	          key: 'holds-pause-date',
	          tagName: 'div',
	          id: 'paused_from',
	          values: {
	            date: _react2.default.createElement(_ShortFormattedDate2.default, { value: item.get('suspendStartDate') })
	          } });
	      }
	
	      return pauseDataStatus;
	    }
	  }, {
	    key: 'renderPickupDate',
	    value: function renderPickupDate() {
	      var item = this.props.item;
	
	      var isReadyForPickup = item.get('status') === 'READY_FOR_PICKUP';
	      var pickupByDate = item.get('pickupByDate');
	
	      return isReadyForPickup && pickupByDate && _react2.default.createElement(_reactIntl.FormattedMessage, {
	        key: 'holds-pickup-date',
	        id: 'pick_up_by_date',
	        values: { date: _react2.default.createElement(_ShortFormattedDate2.default, { value: pickupByDate }) } });
	    }
	  }, {
	    key: 'renderExpiryDate',
	    value: function renderExpiryDate() {
	      var _props2 = this.props,
	          item = _props2.item,
	          holdsTransactions = _props2.holdsTransactions,
	          handleUpdateExpiryDate = _props2.handleUpdateExpiryDate,
	          actionInProgress = _props2.actionInProgress;
	
	      var status = item.get('status');
	      var isLoading = holdsTransactions.getIn([item.get('holdsId'), 'isUpdatingExpiryDate'], false);
	
	      return ['NOT_YET_AVAILABLE'].includes(status) && item.get('expiryDate') && _react2.default.createElement(
	        'div',
	        { className: 'holds-expiry-date', key: 'hold-expires-date' },
	        _react2.default.createElement(_reactIntl.FormattedMessage, {
	          id: 'expires_on_date',
	          values: { date: _react2.default.createElement(_HoldsExpiryDate2.default, {
	              disabled: actionInProgress && !isLoading,
	              isLoading: isLoading,
	              handleUpdateExpiryDate: handleUpdateExpiryDate,
	              item: item }) } })
	      );
	    }
	  }, {
	    key: 'renderPickupLocation',
	    value: function renderPickupLocation() {
	      var _props3 = this.props,
	          item = _props3.item,
	          holdsTransactions = _props3.holdsTransactions,
	          branches = _props3.branches,
	          handleUpdatePickupBranch = _props3.handleUpdatePickupBranch,
	          actionInProgress = _props3.actionInProgress;
	
	      var bibType = item.get('materialType');
	      var isLoading = holdsTransactions.getIn([item.get('holdsId'), 'isUpdatingPickupLocation'], false);
	      return _react2.default.createElement(
	        'div',
	        { key: 'holds-pickup-branch', className: 'holds-pickup-branch' },
	        bibType === 'PHYSICAL' && _react2.default.createElement(_HoldsPickupBranchSelect2.default, {
	          handleUpdatePickupBranch: handleUpdatePickupBranch,
	          disabled: actionInProgress && !isLoading,
	          isLoading: isLoading,
	          item: item,
	          selected: item.getIn(['pickupLocation', 'code']),
	          branches: branches })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var item = this.props.item;
	
	      var bibType = item.get('materialType');
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-holds-secondary-info' },
	        this.renderHoldsStatus(),
	        bibType === 'PHYSICAL' && [this.renderPickupLocation(), this.renderExpiryDate(), this.renderPickupDate()],
	        this.renderPauseDate()
	      );
	    }
	  }]);
	
	  return HoldsSecondaryInfo;
	}(_baseBcReactComponent2.default);
	
	exports.default = HoldsSecondaryInfo;
	
	
	HoldsSecondaryInfo.propTypes = {
	  actionInProgress: _react.PropTypes.bool,
	  item: _reactImmutableProptypes2.default.map,
	  branches: _reactImmutableProptypes2.default.listOf(_bcPropTypes.branchShape).isRequired,
	  isPickupLocationEditable: _react.PropTypes.bool,
	  holdsTransactions: _reactImmutableProptypes2.default.map,
	  handleUpdatePickupBranch: _react.PropTypes.func,
	  handleUpdatePauseEndDate: _react.PropTypes.func,
	  handleUpdateExpiryDate: _react.PropTypes.func
	};

/***/ },
/* 1740 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = HoldsSidebarLink;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _HoldStatusIcon = __webpack_require__(282);
	
	var _HoldStatusIcon2 = _interopRequireDefault(_HoldStatusIcon);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _StatusSidebarLink = __webpack_require__(385);
	
	var _StatusSidebarLink2 = _interopRequireDefault(_StatusSidebarLink);
	
	__webpack_require__(2491);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var renderStatus = function renderStatus(status) {
	  return _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'circ_' + status.toLowerCase() });
	};
	
	function HoldsSidebarLink(_ref) {
	  var status = _ref.status,
	      selected = _ref.selected,
	      summary = _ref.summary;
	
	  return _react2.default.createElement(_StatusSidebarLink2.default, {
	    className: 'cp-holds-sidebar-link',
	    selected: selected,
	    status: status,
	    icon: _react2.default.createElement(_HoldStatusIcon2.default, { status: status }),
	    summary: summary,
	    statusText: renderStatus(status),
	    to: '/v2/holds/' + status.toLowerCase() });
	}
	
	HoldsSidebarLink.propTypes = {
	  status: _react.PropTypes.string,
	  selected: _react.PropTypes.bool,
	  summary: _reactImmutableProptypes2.default.map
	};

/***/ },
/* 1741 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _HoldsSidebarLink = __webpack_require__(1740);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_HoldsSidebarLink).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1742 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.HoldsStatus = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _reactRouter = __webpack_require__(17);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _utilsBorrowing = __webpack_require__(230);
	
	var _HoldStatusIcon = __webpack_require__(282);
	
	var _HoldStatusIcon2 = _interopRequireDefault(_HoldStatusIcon);
	
	var _BorrowingStatus = __webpack_require__(182);
	
	var _BorrowingStatus2 = _interopRequireDefault(_BorrowingStatus);
	
	var _SidebarCompactTitle = __webpack_require__(183);
	
	var _SidebarCompactTitle2 = _interopRequireDefault(_SidebarCompactTitle);
	
	var _HoldsSidebarLink = __webpack_require__(1741);
	
	var _HoldsSidebarLink2 = _interopRequireDefault(_HoldsSidebarLink);
	
	var _AllSidebarLink = __webpack_require__(572);
	
	var _AllSidebarLink2 = _interopRequireDefault(_AllSidebarLink);
	
	__webpack_require__(2492);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var STATUS_ORDER = ['SUSPENDED', 'NOT_YET_AVAILABLE', 'IN_TRANSIT', 'READY_FOR_PICKUP'];
	
	var HoldsStatus = exports.HoldsStatus = function (_BcReactComponent) {
	  _inherits(HoldsStatus, _BcReactComponent);
	
	  function HoldsStatus() {
	    _classCallCheck(this, HoldsStatus);
	
	    return _possibleConstructorReturn(this, (HoldsStatus.__proto__ || Object.getPrototypeOf(HoldsStatus)).apply(this, arguments));
	  }
	
	  _createClass(HoldsStatus, [{
	    key: 'renderAllItemsButton',
	    value: function renderAllItemsButton() {
	      var statusSummaries = this.props.summary.get('status', _immutable2.default.Map());
	      if (statusSummaries.size > 1) {
	        return _react2.default.createElement(_AllSidebarLink2.default, { to: '/v2/holds', selected: this.noStatusIsSelected() });
	      }
	
	      return null;
	    }
	  }, {
	    key: 'getTotalCount',
	    value: function getTotalCount() {
	      return (0, _utilsBorrowing.getTotalCountFromSummary)(this.props.summary);
	    }
	  }, {
	    key: 'statusIsActive',
	    value: function statusIsActive(status) {
	      return this.props.router.location.pathname.includes('v2/holds/' + status.toLowerCase());
	    }
	  }, {
	    key: 'noStatusIsSelected',
	    value: function noStatusIsSelected() {
	      return this.props.router.location.pathname === '/v2/holds';
	    }
	  }, {
	    key: 'renderGrouping',
	    value: function renderGrouping(status) {
	      return _react2.default.createElement(_HoldsSidebarLink2.default, {
	        key: status,
	        status: status,
	        selected: this.statusIsActive(status),
	        summary: this.props.summary });
	    }
	  }, {
	    key: 'renderRemainingHolds',
	    value: function renderRemainingHolds() {
	      if (this.props.summary.get('quotas')) {
	        if (this.props.ILSQuotas) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'free-holds-remaining' },
	            _react2.default.createElement(
	              'span',
	              { className: 'free-holds-text' },
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'free_holds_remaining' })
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'pull-right free-holds-count' },
	              this.props.ILSQuotas.get('remaining'),
	              ' / ',
	              this.props.ILSQuotas.get('total')
	            )
	          );
	        }
	      }
	      return null;
	    }
	  }, {
	    key: 'renderReadyForPickupSummary',
	    value: function renderReadyForPickupSummary() {
	      var statusSummaries = this.props.summary.get('status', _immutable2.default.Map());
	      return statusSummaries.get('READY_FOR_PICKUP') && _react2.default.createElement(
	        'span',
	        { className: 'ready_for_pickup status-label' },
	        _react2.default.createElement(
	          'div',
	          { className: 'hold-status-icon status-icon' },
	          _react2.default.createElement(_HoldStatusIcon2.default, { status: 'READY_FOR_PICKUP' })
	        ),
	        (0, _utilsBorrowing.getTotalFromMaterialTypeCounts)(statusSummaries.get('READY_FOR_PICKUP'))
	      );
	    }
	  }, {
	    key: 'renderInTransitSummary',
	    value: function renderInTransitSummary() {
	      var statusSummaries = this.props.summary.get('status', _immutable2.default.Map());
	      return statusSummaries.get('IN_TRANSIT') && _react2.default.createElement(
	        'span',
	        { className: 'in_transit status-label' },
	        _react2.default.createElement(
	          'div',
	          { className: 'hold-status-icon status-icon' },
	          _react2.default.createElement(_HoldStatusIcon2.default, { status: 'IN_TRANSIT' })
	        ),
	        (0, _utilsBorrowing.getTotalFromMaterialTypeCounts)(statusSummaries.get('IN_TRANSIT'))
	      );
	    }
	  }, {
	    key: 'renderCompactStatus',
	    value: function renderCompactStatus() {
	      var readyForPickupSummary = this.renderReadyForPickupSummary();
	      var inTransitSummary = this.renderInTransitSummary();
	
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement(_SidebarCompactTitle2.default, {
	          title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'section_title_holds' }),
	          count: this.getTotalCount() }),
	        (readyForPickupSummary || inTransitSummary) && _react2.default.createElement(
	          'div',
	          { className: 'small hold-status' },
	          readyForPickupSummary,
	          inTransitSummary
	        )
	      );
	    }
	  }, {
	    key: 'renderFullStatus',
	    value: function renderFullStatus() {
	      var _this2 = this;
	
	      var statusSummaries = this.props.summary.get('status', _immutable2.default.Map());
	
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { className: 'section-title', to: '/v2/holds' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'section_title_holds' }),
	          _react2.default.createElement(
	            'span',
	            { className: 'pull-right', 'data-test-id': 'total-items-count' },
	            this.getTotalCount()
	          )
	        ),
	        this.renderAllItemsButton(),
	        statusSummaries.map(function (summary, status) {
	          return status;
	        }).toList().filter(function (status) {
	          return !['EXPIRED', 'CANCELLED'].includes(status);
	        }).sortBy(function (status) {
	          return -1 * STATUS_ORDER.indexOf(status);
	        }).map(function (status) {
	          return _this2.renderGrouping(status);
	        }).toArray(),
	        this.props.isRemainingHoldsEnabled && this.renderRemainingHolds()
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _BorrowingStatus2.default,
	        { to: '/v2/holds', className: 'cp-holds-status', currentSection: this.props.currentSection },
	        this.props.currentSection ? this.renderFullStatus() : this.renderCompactStatus()
	      );
	    }
	  }]);
	
	  return HoldsStatus;
	}(_baseBcReactComponent2.default);
	
	HoldsStatus.propTypes = {
	  summary: _reactImmutableProptypes2.default.mapContains({
	    status: _reactImmutableProptypes2.default.map,
	    quotas: _reactImmutableProptypes2.default.listOf(_bcPropTypes.borrowingQuotaShape)
	  }),
	  currentSection: _react.PropTypes.bool,
	  ILSQuotas: _reactImmutableProptypes2.default.map,
	  isRemainingHoldsEnabled: _react.PropTypes.bool
	};
	
	exports.default = (0, _reactRouter.withRouter)(HoldsStatus);

/***/ },
/* 1743 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _HoldsStatus = __webpack_require__(1742);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_HoldsStatus).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1744 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _baseIcons = __webpack_require__(10);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _ReviewButton = __webpack_require__(1761);
	
	var _ReviewButton2 = _interopRequireDefault(_ReviewButton);
	
	var _baseFullScreenOverlay = __webpack_require__(45);
	
	var _baseFullScreenOverlay2 = _interopRequireDefault(_baseFullScreenOverlay);
	
	var _InactiveHoldsList = __webpack_require__(1751);
	
	var _InactiveHoldsList2 = _interopRequireDefault(_InactiveHoldsList);
	
	var _ItemField = __webpack_require__(570);
	
	var _ItemField2 = _interopRequireDefault(_ItemField);
	
	var _ShortFormattedDate = __webpack_require__(60);
	
	var _ShortFormattedDate2 = _interopRequireDefault(_ShortFormattedDate);
	
	__webpack_require__(2493);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HoldsToReview = function (_BcReactComponent) {
	  _inherits(HoldsToReview, _BcReactComponent);
	
	  _createClass(HoldsToReview, null, [{
	    key: 'renderDateField',
	    value: function renderDateField(name, date) {
	      var formattedDate = _react2.default.createElement(_ShortFormattedDate2.default, { value: date });
	      return _react2.default.createElement(_ItemField2.default, { className: 'inactive-item-date', name: name, value: formattedDate });
	    }
	  }, {
	    key: 'renderExpiredItemDetails',
	    value: function renderExpiredItemDetails(item) {
	      var date = item.get('expiredDate');
	      return date && HoldsToReview.renderDateField(_react2.default.createElement(_reactIntl.FormattedMessage, { id: 'holds_date_expired' }), date);
	    }
	  }, {
	    key: 'renderCancelledItemDetails',
	    value: function renderCancelledItemDetails(item) {
	      var date = item.get('cancelledDate');
	      return date && HoldsToReview.renderDateField(_react2.default.createElement(_reactIntl.FormattedMessage, { id: 'holds_date_cancelled' }), date);
	    }
	  }]);
	
	  function HoldsToReview(props) {
	    _classCallCheck(this, HoldsToReview);
	
	    var _this = _possibleConstructorReturn(this, (HoldsToReview.__proto__ || Object.getPrototypeOf(HoldsToReview)).call(this, props));
	
	    _this.bindAll('handleShowExpiredOverlay', 'handleCloseExpiredOverlay', 'handleShowCancelledOverlay', 'handleCloseCancelledOverlay', 'handleUpdateExpiredPage', 'handleUpdateCancelledPage');
	
	    _this.state = {
	      showExpiredOverlay: false,
	      showCancelledOverlay: false
	    };
	    return _this;
	  }
	
	  _createClass(HoldsToReview, [{
	    key: 'handleShowExpiredOverlay',
	    value: function handleShowExpiredOverlay() {
	      var _this2 = this;
	
	      var accountId = this.props.accountId;
	
	      this.setState({ showExpiredOverlay: true }, function () {
	        _this2.props.fetchExpiredHolds({ accountId: accountId });
	      });
	    }
	  }, {
	    key: 'handleCloseExpiredOverlay',
	    value: function handleCloseExpiredOverlay() {
	      this.setState({ showExpiredOverlay: false });
	    }
	  }, {
	    key: 'handleShowCancelledOverlay',
	    value: function handleShowCancelledOverlay() {
	      var _this3 = this;
	
	      var accountId = this.props.accountId;
	
	      this.setState({ showCancelledOverlay: true }, function () {
	        _this3.props.fetchCancelledHolds({ accountId: accountId });
	      });
	    }
	  }, {
	    key: 'handleCloseCancelledOverlay',
	    value: function handleCloseCancelledOverlay() {
	      this.setState({ showCancelledOverlay: false });
	    }
	  }, {
	    key: 'handleUpdateExpiredPage',
	    value: function handleUpdateExpiredPage(page) {
	      var accountId = this.props.accountId;
	
	      this.props.fetchExpiredHolds({ accountId: accountId, page: page });
	    }
	  }, {
	    key: 'handleUpdateCancelledPage',
	    value: function handleUpdateCancelledPage(page) {
	      var accountId = this.props.accountId;
	
	      this.props.fetchCancelledHolds({ accountId: accountId, page: page });
	    }
	  }, {
	    key: 'renderExpiredButton',
	    value: function renderExpiredButton() {
	      var expiredCount = this.props.expiredCount;
	
	      return expiredCount > 0 && _react2.default.createElement(_ReviewButton2.default, {
	        className: 'expired-button',
	        handleClick: this.handleShowExpiredOverlay,
	        title: _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement(_baseIcons.Clock, { className: 'holds-expired-icon' }),
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: expiredCount === 1 ? 'holds_number_expired_singular' : 'holds_number_expired_plural', values: { count: expiredCount } })
	        ) });
	    }
	  }, {
	    key: 'renderCancelledButton',
	    value: function renderCancelledButton() {
	      var cancelledCount = this.props.cancelledCount;
	
	      return cancelledCount > 0 && _react2.default.createElement(_ReviewButton2.default, {
	        className: 'cancelled-button',
	        handleClick: this.handleShowCancelledOverlay,
	        title: _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement(_baseIcons.Cancel, { className: 'holds-cancelled-icon' }),
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: cancelledCount === 1 ? 'holds_number_cancelled_singular' : 'holds_number_cancelled_plural', values: { count: cancelledCount } })
	        ) });
	    }
	  }, {
	    key: 'renderTitle',
	    value: function renderTitle() {
	      var _props = this.props,
	          expiredCount = _props.expiredCount,
	          cancelledCount = _props.cancelledCount;
	
	      return (expiredCount > 0 || cancelledCount > 0) && _react2.default.createElement(
	        'h2',
	        { className: 'holds-to-review-heading' },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'section_title_previously_on_hold' })
	      );
	    }
	  }, {
	    key: 'renderExpiredOverlay',
	    value: function renderExpiredOverlay() {
	      var _props2 = this.props,
	          expiredHolds = _props2.expiredHolds,
	          fetchingExpired = _props2.fetchingExpired,
	          expiredHoldsPagination = _props2.expiredHoldsPagination,
	          bibs = _props2.bibs;
	
	      return _react2.default.createElement(
	        _baseFullScreenOverlay2.default,
	        {
	          handleClose: this.handleCloseExpiredOverlay,
	          open: this.state.showExpiredOverlay },
	        _react2.default.createElement(_InactiveHoldsList2.default, {
	          fetching: fetchingExpired,
	          title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'holds_expired' }),
	          items: expiredHolds,
	          bibs: bibs,
	          handleUpdatePage: this.handleUpdateExpiredPage,
	          pagination: expiredHoldsPagination,
	          renderItemDetails: HoldsToReview.renderExpiredItemDetails })
	      );
	    }
	  }, {
	    key: 'renderCancelledOverlay',
	    value: function renderCancelledOverlay() {
	      var _props3 = this.props,
	          cancelledHolds = _props3.cancelledHolds,
	          fetchingCancelled = _props3.fetchingCancelled,
	          cancelledHoldsPagination = _props3.cancelledHoldsPagination,
	          bibs = _props3.bibs;
	
	      return _react2.default.createElement(
	        _baseFullScreenOverlay2.default,
	        {
	          handleClose: this.handleCloseCancelledOverlay,
	          open: this.state.showCancelledOverlay },
	        _react2.default.createElement(_InactiveHoldsList2.default, {
	          fetching: fetchingCancelled,
	          title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'holds_cancelled' }),
	          items: cancelledHolds,
	          bibs: bibs,
	          handleUpdatePage: this.handleUpdateCancelledPage,
	          pagination: cancelledHoldsPagination,
	          renderItemDetails: HoldsToReview.renderCancelledItemDetails })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-holds-to-review' },
	        this.renderTitle(),
	        _react2.default.createElement(
	          'div',
	          { className: 'buttons' },
	          this.renderExpiredButton(),
	          this.renderCancelledButton()
	        ),
	        this.renderExpiredOverlay(),
	        this.renderCancelledOverlay()
	      );
	    }
	  }]);
	
	  return HoldsToReview;
	}(_baseBcReactComponent2.default);
	
	exports.default = HoldsToReview;
	
	
	HoldsToReview.propTypes = {
	  expiredHolds: _reactImmutableProptypes2.default.listOf(_bcPropTypes.holdItemShape),
	  cancelledHolds: _reactImmutableProptypes2.default.listOf(_bcPropTypes.holdItemShape),
	  expiredCount: _react.PropTypes.number,
	  cancelledCount: _react.PropTypes.number,
	  fetchExpiredHolds: _react.PropTypes.func,
	  fetchCancelledHolds: _react.PropTypes.func,
	  fetchingExpired: _react.PropTypes.bool,
	  fetchingCancelled: _react.PropTypes.bool,
	  cancelledHoldsPagination: _bcPropTypes.paginationShape,
	  expiredHoldsPagination: _bcPropTypes.paginationShape,
	  bibs: _reactImmutableProptypes2.default.mapOf(_bcPropTypes.bibShape),
	  accountId: _react.PropTypes.number
	};

/***/ },
/* 1745 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _HoldsToReview = __webpack_require__(1744);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_HoldsToReview).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1746 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _BorrowingUtilityBarTitle = __webpack_require__(569);
	
	var _BorrowingUtilityBarTitle2 = _interopRequireDefault(_BorrowingUtilityBarTitle);
	
	var _MaterialTypeFilterLinks = __webpack_require__(571);
	
	var _MaterialTypeFilterLinks2 = _interopRequireDefault(_MaterialTypeFilterLinks);
	
	var _HoldsQuotasPopOver = __webpack_require__(1738);
	
	var _HoldsQuotasPopOver2 = _interopRequireDefault(_HoldsQuotasPopOver);
	
	var _HoldStatusIcon = __webpack_require__(282);
	
	var _HoldStatusIcon2 = _interopRequireDefault(_HoldStatusIcon);
	
	var _BorrowingUtilityBar = __webpack_require__(285);
	
	var _BorrowingUtilityBar2 = _interopRequireDefault(_BorrowingUtilityBar);
	
	__webpack_require__(2494);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HoldsUtilityBar = function (_BcReactComponent) {
	  _inherits(HoldsUtilityBar, _BcReactComponent);
	
	  function HoldsUtilityBar() {
	    _classCallCheck(this, HoldsUtilityBar);
	
	    return _possibleConstructorReturn(this, (HoldsUtilityBar.__proto__ || Object.getPrototypeOf(HoldsUtilityBar)).apply(this, arguments));
	  }
	
	  _createClass(HoldsUtilityBar, [{
	    key: 'showFilterLinks',
	    value: function showFilterLinks() {
	      var materialTypeCounts = this.props.materialTypeCounts;
	
	
	      return materialTypeCounts && materialTypeCounts.get('DIGITAL', 0) > 0 && materialTypeCounts.get('PHYSICAL', 0) > 0;
	    }
	  }, {
	    key: 'renderStatusIcon',
	    value: function renderStatusIcon() {
	      if (this.props.status) {
	        return _react2.default.createElement(_HoldStatusIcon2.default, { status: this.props.status, withBackground: true });
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderTitle',
	    value: function renderTitle() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_BorrowingUtilityBarTitle2.default, {
	          status: this.props.status,
	          statusIcon: this.renderStatusIcon(),
	          count: this.props.totalCount }),
	        this.showFilterLinks() && _react2.default.createElement(_MaterialTypeFilterLinks2.default, {
	          totalCount: this.props.totalCount,
	          materialTypeCounts: this.props.materialTypeCounts }),
	        this.props.allItemsDigital && _react2.default.createElement(_HoldsQuotasPopOver2.default, { quotas: this.props.quotas })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_BorrowingUtilityBar2.default, {
	        className: 'cp-holds-utility-bar',
	        title: this.renderTitle(),
	        printURL: this.props.printURL,
	        pagination: this.props.pagination,
	        sortOptions: this.props.sortOptions });
	    }
	  }]);
	
	  return HoldsUtilityBar;
	}(_baseBcReactComponent2.default);
	
	exports.default = HoldsUtilityBar;
	
	
	HoldsUtilityBar.propTypes = {
	  allItemsDigital: _react.PropTypes.bool,
	  status: _react.PropTypes.string,
	  totalCount: _react.PropTypes.number,
	  materialTypeCounts: _reactImmutableProptypes2.default.mapContains({
	    PHYSICAL: _react.PropTypes.number,
	    DIGITAL: _react.PropTypes.number
	  }),
	  pagination: _reactImmutableProptypes2.default.map,
	  sortOptions: _reactImmutableProptypes2.default.list,
	  handleSort: _react.PropTypes.func,
	  printURL: _react.PropTypes.string,
	  quotas: _reactImmutableProptypes2.default.listOf(_bcPropTypes.borrowingQuotaShape)
	};

/***/ },
/* 1747 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _HoldsUtilityBar = __webpack_require__(1746);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_HoldsUtilityBar).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1748 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _BorrowingBibBrief = __webpack_require__(284);
	
	var _BorrowingBibBrief2 = _interopRequireDefault(_BorrowingBibBrief);
	
	var _BibListItem = __webpack_require__(239);
	
	var _BibListItem2 = _interopRequireDefault(_BibListItem);
	
	var _AddToShelfButtonContainer = __webpack_require__(146);
	
	var _AddToShelfButtonContainer2 = _interopRequireDefault(_AddToShelfButtonContainer);
	
	var _ItemTransactionButtonContainer = __webpack_require__(297);
	
	var _ItemTransactionButtonContainer2 = _interopRequireDefault(_ItemTransactionButtonContainer);
	
	var _ItemFormat = __webpack_require__(289);
	
	var _ItemFormat2 = _interopRequireDefault(_ItemFormat);
	
	__webpack_require__(2495);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InactiveHoldItem = function (_BcReactComponent) {
	  _inherits(InactiveHoldItem, _BcReactComponent);
	
	  function InactiveHoldItem(props) {
	    _classCallCheck(this, InactiveHoldItem);
	
	    var _this = _possibleConstructorReturn(this, (InactiveHoldItem.__proto__ || Object.getPrototypeOf(InactiveHoldItem)).call(this, props));
	
	    _this.bindAll('renderBibBrief', 'renderInfo');
	    return _this;
	  }
	
	  _createClass(InactiveHoldItem, [{
	    key: 'getBriefOrPlaceholder',
	    value: function getBriefOrPlaceholder() {
	      return this.getBibBrief() || _immutable2.default.Map({
	        id: '',
	        title: this.props.item.get('bibTitle')
	      });
	    }
	  }, {
	    key: 'getBibBrief',
	    value: function getBibBrief() {
	      return this.props.bib && this.props.bib.get('briefInfo');
	    }
	  }, {
	    key: 'getWorkflowId',
	    value: function getWorkflowId() {
	      return 'inactive-hold-' + this.props.item.get('holdsId');
	    }
	  }, {
	    key: 'renderShelfButton',
	    value: function renderShelfButton() {
	      var item = this.props.item;
	
	      return this.getBibBrief() && _react2.default.createElement(_AddToShelfButtonContainer2.default, {
	        metadataId: item.get('metadataId'),
	        workflowId: this.getWorkflowId() });
	    }
	  }, {
	    key: 'renderPlaceHoldButton',
	    value: function renderPlaceHoldButton() {
	      var item = this.props.item;
	
	      return this.getBibBrief() && _react2.default.createElement(_ItemTransactionButtonContainer2.default, {
	        id: item.get('metadataId'),
	        workflowId: this.getWorkflowId() });
	    }
	  }, {
	    key: 'renderAdditionalBriefInformation',
	    value: function renderAdditionalBriefInformation() {
	      return this.getBibBrief() && _react2.default.createElement(
	        'div',
	        { className: 'bib-format-details' },
	        _react2.default.createElement(_ItemFormat2.default, { bib: this.props.bib })
	      );
	    }
	  }, {
	    key: 'renderBibBrief',
	    value: function renderBibBrief() {
	      var bib = this.getBriefOrPlaceholder();
	      return _react2.default.createElement(
	        _BorrowingBibBrief2.default,
	        { bib: bib },
	        this.renderAdditionalBriefInformation()
	      );
	    }
	  }, {
	    key: 'renderInfo',
	    value: function renderInfo() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.props.additionalDetails,
	        _react2.default.createElement(
	          'div',
	          { className: 'actions' },
	          this.renderPlaceHoldButton(),
	          this.renderShelfButton()
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var bib = this.getBriefOrPlaceholder();
	
	      var result = _react2.default.createElement(_BibListItem2.default, {
	        className: 'cp-inactive-hold-item',
	        workflowId: this.getWorkflowId(),
	        bib: bib,
	        renderInfo: this.renderInfo,
	        renderBibBrief: function renderBibBrief() {
	          return _this2.renderBibBrief();
	        } });
	
	      return result;
	    }
	  }]);
	
	  return InactiveHoldItem;
	}(_baseBcReactComponent2.default);
	
	exports.default = InactiveHoldItem;
	
	
	InactiveHoldItem.propTypes = {
	  item: _bcPropTypes.holdItemShape,
	  additionalDetails: _bcPropTypes.childrenShape,
	  bib: _bcPropTypes.bibShape
	};

/***/ },
/* 1749 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _InactiveHoldItem = __webpack_require__(1748);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_InactiveHoldItem).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1750 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _sharedProgressBar = __webpack_require__(94);
	
	var _sharedProgressBar2 = _interopRequireDefault(_sharedProgressBar);
	
	var _baseTable = __webpack_require__(91);
	
	var _pagination = __webpack_require__(92);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _ItemList = __webpack_require__(145);
	
	var _ItemList2 = _interopRequireDefault(_ItemList);
	
	var _InactiveHoldItem = __webpack_require__(1749);
	
	var _InactiveHoldItem2 = _interopRequireDefault(_InactiveHoldItem);
	
	__webpack_require__(2496);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InactiveHoldsList = function (_BcReactComponent) {
	  _inherits(InactiveHoldsList, _BcReactComponent);
	
	  function InactiveHoldsList() {
	    _classCallCheck(this, InactiveHoldsList);
	
	    return _possibleConstructorReturn(this, (InactiveHoldsList.__proto__ || Object.getPrototypeOf(InactiveHoldsList)).apply(this, arguments));
	  }
	
	  _createClass(InactiveHoldsList, [{
	    key: 'renderPagination',
	    value: function renderPagination() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var _props = this.props,
	          fetching = _props.fetching,
	          pagination = _props.pagination,
	          handleUpdatePage = _props.handleUpdatePage;
	
	      return pagination && !pagination.isEmpty() && _react2.default.createElement(_pagination2.default, _extends({}, props, {
	        isFetching: fetching,
	        updatePage: handleUpdatePage,
	        page: pagination.get('page'),
	        limit: pagination.get('limit'),
	        count: pagination.get('count'),
	        pages: pagination.get('pages') }));
	    }
	  }, {
	    key: 'renderBibListItem',
	    value: function renderBibListItem(item) {
	      var _props2 = this.props,
	          renderItemDetails = _props2.renderItemDetails,
	          bibs = _props2.bibs;
	
	      var additionalDetails = renderItemDetails && renderItemDetails(item);
	      return _react2.default.createElement(_InactiveHoldItem2.default, {
	        key: item.get('holdsId'),
	        item: item,
	        bib: bibs.get(item.get('metadataId')),
	        additionalDetails: additionalDetails });
	    }
	  }, {
	    key: 'renderBibList',
	    value: function renderBibList() {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          fetching = _props3.fetching,
	          items = _props3.items;
	
	      var showPlaceholder = fetching && (!items || items.isEmpty());
	
	      return _react2.default.createElement(
	        _ItemList2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'count-and-pagination-row' },
	          _react2.default.createElement(
	            'p',
	            { className: 'holds-count' },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'label_number_of_items', values: { count: items.size } })
	          ),
	          this.renderPagination({ className: 'top-pagination', autoFocus: true })
	        ),
	        showPlaceholder ? _react2.default.createElement(
	          'div',
	          { className: 'placeholder-wrapper' },
	          _react2.default.createElement(_baseTable.Placeholder, null)
	        ) : items.map(function (item) {
	          return _this2.renderBibListItem(item);
	        }),
	        this.renderPagination()
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props,
	          title = _props4.title,
	          fetching = _props4.fetching;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-inactive-holds-list' },
	        _react2.default.createElement(_sharedProgressBar2.default, { active: fetching }),
	        _react2.default.createElement(
	          'h2',
	          null,
	          title
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'list-wrapper' },
	          this.renderBibList()
	        )
	      );
	    }
	  }]);
	
	  return InactiveHoldsList;
	}(_baseBcReactComponent2.default);
	
	exports.default = InactiveHoldsList;
	
	
	InactiveHoldsList.propTypes = {
	  title: _bcPropTypes.childrenShape,
	  items: _reactImmutableProptypes2.default.listOf(_bcPropTypes.holdItemShape),
	  bibs: _reactImmutableProptypes2.default.mapOf(_bcPropTypes.bibShape),
	  renderItemDetails: _react.PropTypes.func,
	  pagination: _bcPropTypes.paginationShape,
	  fetching: _react.PropTypes.bool,
	  handleUpdatePage: _react.PropTypes.func
	};

/***/ },
/* 1751 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _InactiveHoldsList = __webpack_require__(1750);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_InactiveHoldsList).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1752 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = PauseHoldButton;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseButtons = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function PauseHoldButton(_ref) {
	  var handleClick = _ref.handleClick,
	      isLoading = _ref.isLoading,
	      disabled = _ref.disabled;
	
	  return _react2.default.createElement(
	    _baseButtons.PrimaryButton,
	    {
	      isLoading: isLoading,
	      disabled: disabled,
	      className: 'cp-pause-hold-button',
	      handleClick: handleClick },
	    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'pause_hold' })
	  );
	}
	
	PauseHoldButton.propTypes = {
	  handleClick: _react.PropTypes.func,
	  isLoading: _react.PropTypes.bool,
	  disabled: _react.PropTypes.bool
	};

/***/ },
/* 1753 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PauseHoldButton = __webpack_require__(1752);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PauseHoldButton).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1754 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseInlineOverlay = __webpack_require__(83);
	
	var _sharedBibBrief = __webpack_require__(46);
	
	var _sharedBibBrief2 = _interopRequireDefault(_sharedBibBrief);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseButtons = __webpack_require__(12);
	
	var _baseIcons = __webpack_require__(10);
	
	var _HoldsPauseDateSelect = __webpack_require__(566);
	
	var _HoldsPauseDateSelect2 = _interopRequireDefault(_HoldsPauseDateSelect);
	
	__webpack_require__(2497);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BasePauseHoldWorkflowView = function (_BcReactComponent) {
	  _inherits(BasePauseHoldWorkflowView, _BcReactComponent);
	
	  function BasePauseHoldWorkflowView(props) {
	    _classCallCheck(this, BasePauseHoldWorkflowView);
	
	    var _this = _possibleConstructorReturn(this, (BasePauseHoldWorkflowView.__proto__ || Object.getPrototypeOf(BasePauseHoldWorkflowView)).call(this, props));
	
	    _this.state = {
	      suspendDates: {
	        startDate: props.initialSuspendStartDate || null,
	        endDate: props.initialSuspendEndDate || null
	      }
	    };
	
	    _this.bindAll('handlePauseUpdate');
	    return _this;
	  }
	
	  _createClass(BasePauseHoldWorkflowView, [{
	    key: 'handlePauseUpdate',
	    value: function handlePauseUpdate() {
	      var suspendDates = this.state.suspendDates;
	
	      this.props.handleHoldPauseDate(suspendDates);
	    }
	  }, {
	    key: 'renderBibInfo',
	    value: function renderBibInfo() {
	      var _props = this.props,
	          bibs = _props.bibs,
	          holdIds = _props.holdIds;
	
	      var bib = bibs.first();
	      var showBrief = holdIds.size === 1 && bib;
	
	      return showBrief && _react2.default.createElement(_sharedBibBrief2.default, {
	        bib: bib,
	        titleTag: 'h3',
	        renderTitleAsLink: false,
	        renderAuthorsAsLink: false });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state$suspendDates = this.state.suspendDates,
	          startDate = _state$suspendDates.startDate,
	          endDate = _state$suspendDates.endDate;
	      var _props2 = this.props,
	          isLoading = _props2.isLoading,
	          handleClose = _props2.handleClose,
	          enableStartDate = _props2.enableStartDate,
	          enableEndDate = _props2.enableEndDate;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-base-pause-hold-workflow-view' },
	        _react2.default.createElement(
	          _baseInlineOverlay.InlineOverlay,
	          { handleClose: handleClose },
	          _react2.default.createElement(
	            _baseInlineOverlay.InlineOverlayHeader,
	            null,
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'pause_confirmation_hold_title' })
	          ),
	          _react2.default.createElement(
	            _baseInlineOverlay.InlineOverlayBody,
	            null,
	            this.renderBibInfo(),
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'pause_workflow_info_text' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'cp-pause-hold-workflow-date item-row' },
	              _react2.default.createElement(_HoldsPauseDateSelect2.default, {
	                fullScreen: true,
	                enableStartDate: enableStartDate,
	                enableEndDate: enableEndDate,
	                initialSuspendStartDate: this.props.initialSuspendStartDate,
	                initialSuspendEndDate: this.props.initialSuspendEndDate,
	                onSelectDates: function onSelectDates(suspendDates) {
	                  return _this2.setState({ suspendDates: suspendDates });
	                } })
	            )
	          ),
	          _react2.default.createElement(
	            _baseInlineOverlay.InlineOverlayFooter,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-12' },
	              _react2.default.createElement(
	                _baseButtons.PrimaryButton,
	                { className: 'pull-right', isLoading: isLoading, handleClick: this.handlePauseUpdate, disabled: !startDate && enableStartDate || !endDate && enableEndDate },
	                _react2.default.createElement(_baseIcons.Checkmark, { color: '#FFF' }),
	                ' ',
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'pause_confirmation_hold_button_yes' })
	              ),
	              _react2.default.createElement(
	                _baseInlineOverlay.InlineOverlayCloseButton,
	                { className: 'btn btn-link pull-right' },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_nevermind_close' })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return BasePauseHoldWorkflowView;
	}(_baseBcReactComponent2.default);
	
	exports.default = BasePauseHoldWorkflowView;
	
	
	BasePauseHoldWorkflowView.propTypes = {
	  bibs: _react.PropTypes.shape({
	    id: _react.PropTypes.string
	  }).isRequired,
	  handleClose: _react.PropTypes.func.isRequired,
	  holdsId: _react.PropTypes.string,
	  pauseHold: _react.PropTypes.func,
	  handleHoldPauseDate: _react.PropTypes.func.isRequired,
	  initialSuspendStartDate: _react.PropTypes.string,
	  initialSuspendEndDate: _react.PropTypes.string,
	  enableStartDate: _react.PropTypes.bool,
	  enableEndDate: _react.PropTypes.bool
	};

/***/ },
/* 1755 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SinglePauseHoldWorkflowView = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _BasePauseHoldWorkflowView = __webpack_require__(1754);
	
	var _BasePauseHoldWorkflowView2 = _interopRequireDefault(_BasePauseHoldWorkflowView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SinglePauseHoldWorkflowView = exports.SinglePauseHoldWorkflowView = function (_BcReactComponent) {
	  _inherits(SinglePauseHoldWorkflowView, _BcReactComponent);
	
	  function SinglePauseHoldWorkflowView(props) {
	    _classCallCheck(this, SinglePauseHoldWorkflowView);
	
	    var _this = _possibleConstructorReturn(this, (SinglePauseHoldWorkflowView.__proto__ || Object.getPrototypeOf(SinglePauseHoldWorkflowView)).call(this, props));
	
	    _this.bindAll('handlePauseHolds');
	    return _this;
	  }
	
	  _createClass(SinglePauseHoldWorkflowView, [{
	    key: 'handlePauseHolds',
	    value: function handlePauseHolds(suspended) {
	      var _props = this.props,
	          accountId = _props.accountId,
	          holdId = _props.holdId,
	          messagingId = _props.messagingId,
	          workflowId = _props.workflowId;
	
	      this.props.pauseHolds({
	        accountId: accountId,
	        messagingId: messagingId,
	        holdIds: [holdId],
	        workflowId: workflowId,
	        suspended: _extends({}, suspended, {
	          status: true
	        })
	      });
	      this.props.handleClose();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          handleClose = _props2.handleClose,
	          accountId = _props2.accountId,
	          holdId = _props2.holdId,
	          bib = _props2.bib,
	          messagingId = _props2.messagingId,
	          isLoading = _props2.isLoading,
	          initialSuspendStartDate = _props2.initialSuspendStartDate,
	          initialSuspendEndDate = _props2.initialSuspendEndDate,
	          enableEndDate = _props2.enableEndDate,
	          enableStartDate = _props2.enableStartDate;
	
	
	      return _react2.default.createElement(_BasePauseHoldWorkflowView2.default, {
	        handleClose: handleClose,
	        handleHoldPauseDate: this.handlePauseHolds,
	        accountId: accountId,
	        holdIds: _immutable2.default.List.of(holdId),
	        initialSuspendEndDate: initialSuspendEndDate,
	        initialSuspendStartDate: initialSuspendStartDate,
	        isLoading: isLoading,
	        bibs: _immutable2.default.List.of(bib),
	        enableEndDate: enableEndDate,
	        enableStartDate: enableStartDate,
	        messagingId: messagingId });
	    }
	  }]);
	
	  return SinglePauseHoldWorkflowView;
	}(_baseBcReactComponent2.default);
	
	SinglePauseHoldWorkflowView.propTypes = {
	  handleClose: _react.PropTypes.func.isRequired,
	  pauseHolds: _react.PropTypes.func.isRequired,
	  accountId: _react.PropTypes.number.isRequired,
	  holdId: _react.PropTypes.string,
	  isLoading: _react.PropTypes.bool,
	  bib: _bcPropTypes.bibShape.isRequired,
	  messagingId: _react.PropTypes.string,
	  workflowId: _react.PropTypes.string,
	  initialSuspendStartDate: _react.PropTypes.string,
	  initialSuspendEndDate: _react.PropTypes.string,
	  enableStartDate: _react.PropTypes.bool,
	  enableEndDate: _react.PropTypes.bool
	};
	
	exports.default = SinglePauseHoldWorkflowView;

/***/ },
/* 1756 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PauseHoldsBatchActions = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseButtons = __webpack_require__(12);
	
	var _moment = __webpack_require__(9);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactIntl = __webpack_require__(3);
	
	var _BorrowingBatchActionsOverlay = __webpack_require__(383);
	
	var _BorrowingBatchActionsOverlay2 = _interopRequireDefault(_BorrowingBatchActionsOverlay);
	
	var _HoldsPauseDateSelect = __webpack_require__(566);
	
	var _HoldsPauseDateSelect2 = _interopRequireDefault(_HoldsPauseDateSelect);
	
	__webpack_require__(2498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PauseHoldsBatchActions = exports.PauseHoldsBatchActions = function (_BcReactComponent) {
	  _inherits(PauseHoldsBatchActions, _BcReactComponent);
	
	  function PauseHoldsBatchActions(props) {
	    _classCallCheck(this, PauseHoldsBatchActions);
	
	    var _this = _possibleConstructorReturn(this, (PauseHoldsBatchActions.__proto__ || Object.getPrototypeOf(PauseHoldsBatchActions)).call(this, props));
	
	    _this.state = {
	      showDatePicker: false,
	      suspendDates: {}
	    };
	    _this.bindAll();
	    return _this;
	  }
	
	  _createClass(PauseHoldsBatchActions, [{
	    key: 'handleBatchedPauseHolds',
	    value: function handleBatchedPauseHolds() {
	      var _props = this.props,
	          accountId = _props.accountId,
	          items = _props.items,
	          handlePauseHolds = _props.handlePauseHolds,
	          supportsSuspendHoldEndDate = _props.supportsSuspendHoldEndDate;
	      var suspendDates = this.state.suspendDates;
	
	
	      if (!supportsSuspendHoldEndDate) {
	        suspendDates = {
	          startDate: null,
	          endDate: (0, _moment2.default)().add(1, 'day').format()
	        };
	      }
	
	      var holdIds = items.map(function (item) {
	        return item.get('id');
	      }).toSet().toList().toJS();
	
	      handlePauseHolds({
	        accountId: accountId,
	        messagingId: '',
	        holdIds: holdIds,
	        workflowId: '',
	        suspended: _extends({}, suspendDates, {
	          status: true
	        })
	      });
	
	      this.props.handleClose();
	    }
	  }, {
	    key: 'renderFooter',
	    value: function renderFooter() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'pause-hold-date-submit' },
	        _react2.default.createElement(
	          _baseButtons.PrimaryButton,
	          { className: 'pull-left', disabled: false, handleClick: function handleClick() {
	              return _this2.handleBatchedPauseHolds();
	            } },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'pause_confirmation_holds_button_yes' })
	        ),
	        _react2.default.createElement(
	          _baseButtons.TextButton,
	          { className: 'btn btn-link pull-left', handleClick: this.props.handleClose },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_nevermind_close' })
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        _BorrowingBatchActionsOverlay2.default,
	        {
	          open: this.props.open,
	          className: 'cp-pause-hold-date-batch-actions-overlay',
	          handleClose: this.props.handleClose,
	          header: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'pause_holds_date_header', values: { count: this.props.items.size } }),
	          subtitle: _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_reactIntl.FormattedMessage, { tagName: 'p', id: 'pause_workflow_info_text' }),
	            (this.props.supportsSuspendHoldStartDate || this.props.supportsSuspendHoldEndDate) && _react2.default.createElement(_reactIntl.FormattedMessage, { tagName: 'p', id: 'holds_chosen_dates_subtitle' })
	          ),
	          footer: this.renderFooter() },
	        _react2.default.createElement(_HoldsPauseDateSelect2.default, {
	          enableStartDate: this.props.supportsSuspendHoldStartDate,
	          enableEndDate: this.props.supportsSuspendHoldEndDate,
	          onSelectDates: function onSelectDates(suspendDates) {
	            return _this3.setState({ suspendDates: suspendDates });
	          } })
	      );
	    }
	  }]);
	
	  return PauseHoldsBatchActions;
	}(_baseBcReactComponent2.default);
	
	exports.default = PauseHoldsBatchActions;

/***/ },
/* 1757 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PauseHoldsBatchActions = __webpack_require__(1756);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PauseHoldsBatchActions).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1758 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ResumeHoldButton;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseButtons = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ResumeHoldButton(_ref) {
	  var handleClick = _ref.handleClick,
	      isLoading = _ref.isLoading,
	      disabled = _ref.disabled;
	
	  return _react2.default.createElement(
	    _baseButtons.PrimaryButton,
	    {
	      isLoading: isLoading,
	      disabled: disabled,
	      className: 'cp-resume-hold-button',
	      handleClick: handleClick },
	    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'resume_hold' })
	  );
	}
	
	ResumeHoldButton.propTypes = {
	  handleClick: _react.PropTypes.func,
	  isLoading: _react.PropTypes.bool,
	  disabled: _react.PropTypes.bool
	};

/***/ },
/* 1759 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ResumeHoldButton = __webpack_require__(1758);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ResumeHoldButton).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1760 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ReviewButton;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _baseButtons = __webpack_require__(12);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _baseIcons = __webpack_require__(10);
	
	__webpack_require__(2499);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ReviewButton(_ref) {
	  var title = _ref.title,
	      action = _ref.action,
	      handleClick = _ref.handleClick,
	      className = _ref.className;
	
	  return _react2.default.createElement(
	    _baseButtons.DefaultButton,
	    { handleClick: handleClick, className: (0, _classnames2.default)('cp-review-button', className) },
	    _react2.default.createElement(
	      'div',
	      { className: 'title' },
	      title
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'action' },
	      action,
	      '\xA0',
	      _react2.default.createElement(_baseIcons.Angle.Right, null)
	    )
	  );
	}
	
	ReviewButton.propTypes = {
	  handleClick: _react.PropTypes.func,
	  title: _bcPropTypes.childrenShape,
	  action: _bcPropTypes.childrenShape,
	  className: _react.PropTypes.string
	};

/***/ },
/* 1761 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ReviewButton = __webpack_require__(1760);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ReviewButton).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1762 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _CompactListItem = __webpack_require__(1919);
	
	var _CompactListItem2 = _interopRequireDefault(_CompactListItem);
	
	var _CompactItemInfo = __webpack_require__(1915);
	
	var _CompactItemInfo2 = _interopRequireDefault(_CompactItemInfo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InterlibraryLoanItem = function (_BcReactComponent) {
	  _inherits(InterlibraryLoanItem, _BcReactComponent);
	
	  function InterlibraryLoanItem(props) {
	    _classCallCheck(this, InterlibraryLoanItem);
	
	    var _this = _possibleConstructorReturn(this, (InterlibraryLoanItem.__proto__ || Object.getPrototypeOf(InterlibraryLoanItem)).call(this, props));
	
	    _this.bindAll('renderItemSummary', 'renderItemStatus', 'renderPickUpAt', 'renderPlacedOn', 'renderPickUpBy');
	    return _this;
	  }
	
	  _createClass(InterlibraryLoanItem, [{
	    key: 'renderItemStatus',
	    value: function renderItemStatus() {
	      // TODO CORE-48927 Build a status component
	      var item = this.props.item;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'item-status', key: 'item-status' },
	        item.get('status')
	      );
	    }
	  }, {
	    key: 'renderItemSummary',
	    value: function renderItemSummary() {
	      // TODO CORE-48926 Build a generic component for compact list item info
	      var item = this.props.item;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'item-summary', key: 'item-summary' },
	        _react2.default.createElement(_CompactItemInfo2.default, {
	          title: item.get('title'),
	          subtitle: item.get('subtitle'),
	          author: item.get('author'),
	          format: item.get('format') })
	      );
	    }
	  }, {
	    key: 'renderPickUpAt',
	    value: function renderPickUpAt() {
	      // TODO CORE-48929 Build a generic compact info component
	      var item = this.props.item;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'item-pick-up-at', key: 'item-pick-up-at' },
	        item.has('pickupLocation') ? item.getIn(['pickupLocation', 'name']) : ''
	      );
	    }
	  }, {
	    key: 'renderPickUpBy',
	    value: function renderPickUpBy() {
	      // TODO CORE-48929 Build a generic compact info component
	      var item = this.props.item;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'item-pick-by', key: 'item-pick-up-by' },
	        item.has('pickupByDate') ? item.get('pickupByDate') : ''
	      );
	    }
	  }, {
	    key: 'renderPlacedOn',
	    value: function renderPlacedOn() {
	      // TODO CORE-48929 Build a generic compact info component
	      var item = this.props.item;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'item-placed-on', key: 'item-placed-on' },
	        item.get('holdPlacedDate')
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_CompactListItem2.default, {
	        columns: [this.renderItemSummary(), this.renderItemStatus(), this.renderPickUpAt(), this.renderPickUpBy(), this.renderPlacedOn()],
	        className: 'cp-interlibraryloan-item' });
	    }
	  }]);
	
	  return InterlibraryLoanItem;
	}(_baseBcReactComponent2.default);
	
	exports.default = InterlibraryLoanItem;
	
	
	InterlibraryLoanItem.propTypes = {
	  item: _reactImmutableProptypes2.default.map
	};

/***/ },
/* 1763 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _InterlibraryLoanItem = __webpack_require__(1762);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_InterlibraryLoanItem).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1764 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _sharedProgressBar = __webpack_require__(94);
	
	var _sharedProgressBar2 = _interopRequireDefault(_sharedProgressBar);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _InterlibraryLoansList = __webpack_require__(1767);
	
	var _InterlibraryLoansList2 = _interopRequireDefault(_InterlibraryLoansList);
	
	var _InterlibraryLoansTitle = __webpack_require__(1775);
	
	var _InterlibraryLoansTitle2 = _interopRequireDefault(_InterlibraryLoansTitle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InterlibraryLoans = function (_BcReactComponent) {
	  _inherits(InterlibraryLoans, _BcReactComponent);
	
	  function InterlibraryLoans(props) {
	    _classCallCheck(this, InterlibraryLoans);
	
	    var _this = _possibleConstructorReturn(this, (InterlibraryLoans.__proto__ || Object.getPrototypeOf(InterlibraryLoans)).call(this, props));
	
	    _this.bindAll('renderContent');
	    return _this;
	  }
	
	  _createClass(InterlibraryLoans, [{
	    key: 'renderContent',
	    value: function renderContent() {
	      var items = this.props.items;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'title-row' },
	        _react2.default.createElement(_InterlibraryLoansTitle2.default, null),
	        _react2.default.createElement(_InterlibraryLoansList2.default, {
	          items: items })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var isFetching = this.props.isFetching;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-interlibraryloans' },
	        _react2.default.createElement(_sharedProgressBar2.default, { active: isFetching }),
	        this.renderContent()
	      );
	    }
	  }]);
	
	  return InterlibraryLoans;
	}(_baseBcReactComponent2.default);
	
	InterlibraryLoans.propTypes = {
	  user: _reactImmutableProptypes2.default.map,
	  items: _reactImmutableProptypes2.default.list,
	  isFetching: _react2.default.PropTypes.bool
	};
	
	exports.default = InterlibraryLoans;

/***/ },
/* 1765 */
[3483, 1764],
/* 1766 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _ItemList = __webpack_require__(145);
	
	var _ItemList2 = _interopRequireDefault(_ItemList);
	
	var _reactIntl = __webpack_require__(3);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _InterlibraryLoanItem = __webpack_require__(1763);
	
	var _InterlibraryLoanItem2 = _interopRequireDefault(_InterlibraryLoanItem);
	
	var _CompactList = __webpack_require__(1917);
	
	var _CompactList2 = _interopRequireDefault(_CompactList);
	
	__webpack_require__(2500);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function renderListItem(item) {
	  return _react2.default.createElement(_InterlibraryLoanItem2.default, { item: item, key: item.get('id') });
	}
	
	var InterlibraryLoansList = function (_BcReactComponent) {
	  _inherits(InterlibraryLoansList, _BcReactComponent);
	
	  function InterlibraryLoansList() {
	    _classCallCheck(this, InterlibraryLoansList);
	
	    return _possibleConstructorReturn(this, (InterlibraryLoansList.__proto__ || Object.getPrototypeOf(InterlibraryLoansList)).apply(this, arguments));
	  }
	
	  _createClass(InterlibraryLoansList, [{
	    key: 'render',
	    value: function render() {
	      var items = this.props.items;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-interlibraryloans-list' },
	        _react2.default.createElement(
	          _ItemList2.default,
	          null,
	          _react2.default.createElement(
	            _reactIntl.FormattedMessage,
	            { id: 'ill_active_requests_message' },
	            function (message) {
	              return message !== 'ill_active_requests_message' ? _react2.default.createElement(
	                'p',
	                { className: 'interlibrary-loans-help' },
	                message
	              ) : null;
	            }
	          ),
	          _react2.default.createElement(
	            _CompactList2.default,
	            null,
	            items.map(function (item) {
	              return renderListItem(item);
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return InterlibraryLoansList;
	}(_baseBcReactComponent2.default);
	
	InterlibraryLoansList.propTypes = {
	  items: _reactImmutableProptypes2.default.map
	};
	
	exports.default = InterlibraryLoansList;

/***/ },
/* 1767 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _InterlibraryLoansList = __webpack_require__(1766);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_InterlibraryLoansList).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1768 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = InterlibraryLoansSidebarLink;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _InterlibraryLoansStatusIcon = __webpack_require__(1773);
	
	var _InterlibraryLoansStatusIcon2 = _interopRequireDefault(_InterlibraryLoansStatusIcon);
	
	var _SidebarLink = __webpack_require__(573);
	
	var _SidebarLink2 = _interopRequireDefault(_SidebarLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var renderCount = function renderCount(count) {
	  return _react2.default.createElement(
	    'span',
	    { className: 'status-count' },
	    count
	  );
	};
	
	function InterlibraryLoansSidebarLink(_ref) {
	  var status = _ref.status,
	      selected = _ref.selected,
	      summary = _ref.summary;
	
	  var formattedStatus = status.toLowerCase();
	  var count = summary.get('status').get(status);
	  return _react2.default.createElement(
	    _SidebarLink2.default,
	    {
	      className: (0, _classnames2.default)('cp-status-sidebar-link', 'cp-interlibraryloans-sidebar-link', formattedStatus),
	      selected: selected,
	      to: '/v2/interlibraryloans/' + status.toLowerCase() },
	    _react2.default.createElement(_InterlibraryLoansStatusIcon2.default, { status: status }),
	    _react2.default.createElement(
	      'div',
	      { className: 'contents' },
	      _react2.default.createElement(
	        'div',
	        { className: 'status-wrapper' },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ill_status_' + status.toLowerCase() })
	      ),
	      count > 0 && renderCount(count)
	    )
	  );
	}
	
	InterlibraryLoansSidebarLink.propTypes = {
	  status: _react.PropTypes.string,
	  selected: _react.PropTypes.bool,
	  summary: _reactImmutableProptypes2.default.map
	};

/***/ },
/* 1769 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _InterlibraryLoansSidebarLink = __webpack_require__(1768);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_InterlibraryLoansSidebarLink).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1770 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InterlibraryLoansStatus = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _reactIntl = __webpack_require__(3);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reactRouter = __webpack_require__(17);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _BorrowingStatus = __webpack_require__(182);
	
	var _BorrowingStatus2 = _interopRequireDefault(_BorrowingStatus);
	
	var _SidebarCompactTitle = __webpack_require__(183);
	
	var _SidebarCompactTitle2 = _interopRequireDefault(_SidebarCompactTitle);
	
	var _InterlibraryLoansSidebarLink = __webpack_require__(1769);
	
	var _InterlibraryLoansSidebarLink2 = _interopRequireDefault(_InterlibraryLoansSidebarLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var STATUS_ORDER = ['READY', 'IN_TRANSIT', 'SHIPPED', 'NOT_READY', 'INACTIVE'];
	
	var InterlibraryLoansStatus = exports.InterlibraryLoansStatus = function (_BcReactComponent) {
	  _inherits(InterlibraryLoansStatus, _BcReactComponent);
	
	  function InterlibraryLoansStatus() {
	    _classCallCheck(this, InterlibraryLoansStatus);
	
	    return _possibleConstructorReturn(this, (InterlibraryLoansStatus.__proto__ || Object.getPrototypeOf(InterlibraryLoansStatus)).apply(this, arguments));
	  }
	
	  _createClass(InterlibraryLoansStatus, [{
	    key: 'statusIsActive',
	    value: function statusIsActive(status) {
	      return this.props.router.location.pathname.includes('v2/interlibraryloans/' + status.toLowerCase());
	    }
	  }, {
	    key: 'renderGrouping',
	    value: function renderGrouping(status) {
	      return _react2.default.createElement(_InterlibraryLoansSidebarLink2.default, {
	        key: status,
	        status: status,
	        selected: this.statusIsActive(status),
	        summary: this.props.summary });
	    }
	  }, {
	    key: 'renderFullStatus',
	    value: function renderFullStatus() {
	      var _this2 = this;
	
	      var statusSummaries = this.props.summary.get('status', _immutable2.default.Map());
	
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { className: 'section-title', to: '/v2/interlibraryloans' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'sidebar_title_ill' }),
	          _react2.default.createElement(
	            'span',
	            { className: 'pull-right', 'data-test-id': 'total-items-count' },
	            this.props.summary.get('total')
	          )
	        ),
	        statusSummaries.map(function (summary, status) {
	          return status;
	        }).toList().sortBy(function (status) {
	          return -1 * STATUS_ORDER.indexOf(status);
	        }).map(function (status) {
	          return _this2.renderGrouping(status);
	        }).toArray()
	      );
	    }
	  }, {
	    key: 'renderCompactStatus',
	    value: function renderCompactStatus() {
	      return _react2.default.createElement(_SidebarCompactTitle2.default, {
	        title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'sidebar_title_ill' }),
	        count: this.props.summary.get('total') });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _BorrowingStatus2.default,
	        { currentSection: this.props.currentSection, to: '/v2/interlibraryloans' },
	        this.props.currentSection ? this.renderFullStatus() : this.renderCompactStatus()
	      );
	    }
	  }]);
	
	  return InterlibraryLoansStatus;
	}(_baseBcReactComponent2.default);
	
	InterlibraryLoansStatus.propTypes = {
	  summary: _reactImmutableProptypes2.default.mapContains({
	    total: _react.PropTypes.number,
	    status: _reactImmutableProptypes2.default.map
	  })
	};
	
	exports.default = (0, _reactRouter.withRouter)(InterlibraryLoansStatus);

/***/ },
/* 1771 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _InterlibaryLoansStatus = __webpack_require__(1770);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_InterlibaryLoansStatus).default;
	  }
	});
	Object.defineProperty(exports, 'InterlibraryLoansStatus', {
	  enumerable: true,
	  get: function get() {
	    return _InterlibaryLoansStatus.InterlibraryLoansStatus;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1772 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = InterlibraryLoansStatusIcon;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseIcons = __webpack_require__(10);
	
	var _BorrowingStatusIcon = __webpack_require__(384);
	
	var _BorrowingStatusIcon2 = _interopRequireDefault(_BorrowingStatusIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getIcon = function getIcon(status) {
	  switch (status) {
	    case 'READY':
	      return _react2.default.createElement(_baseIcons.CheckmarkCircle, null);
	    case 'IN_TRANSIT':
	      return _react2.default.createElement(_baseIcons.Truck, null);
	    case 'INACTIVE':
	      return _react2.default.createElement(_baseIcons.PauseCircled, null);
	    case 'SHIPPED':
	      return _react2.default.createElement(_baseIcons.Plane, null);
	    default:
	      return _react2.default.createElement(_baseIcons.MinusCircled, null);
	  }
	};
	
	function InterlibraryLoansStatusIcon(_ref) {
	  var status = _ref.status,
	      withBackground = _ref.withBackground,
	      withLabel = _ref.withLabel;
	
	  var label = status && _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ill_status_' + status.toLowerCase() });
	
	  return _react2.default.createElement(_BorrowingStatusIcon2.default, {
	    className: 'cp-interlibraryloans-status-icon',
	    icon: getIcon(status),
	    status: status,
	    withBackground: withBackground,
	    renderLabel: withLabel && function () {
	      return label;
	    } });
	}
	
	InterlibraryLoansStatusIcon.propTypes = {
	  status: _react.PropTypes.string.isRequired,
	  withBackground: _react.PropTypes.bool,
	  withLabel: _react.PropTypes.bool
	};

/***/ },
/* 1773 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _InterlibraryLoansStatusIcon = __webpack_require__(1772);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_InterlibraryLoansStatusIcon).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1774 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = InterlibraryLoansTitle;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BorrowingHeader = __webpack_require__(124);
	
	var _BorrowingHeader2 = _interopRequireDefault(_BorrowingHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function InterlibraryLoansTitle() {
	  return _react2.default.createElement(_BorrowingHeader2.default, {
	    headingKey: 'section_title_ill' });
	}

/***/ },
/* 1775 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _InterlibraryLoansTitle = __webpack_require__(1774);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_InterlibraryLoansTitle).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1776 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _sharedProgressBar = __webpack_require__(94);
	
	var _sharedProgressBar2 = _interopRequireDefault(_sharedProgressBar);
	
	var _RecentlyReturnedTitle = __webpack_require__(283);
	
	var _RecentlyReturnedTitle2 = _interopRequireDefault(_RecentlyReturnedTitle);
	
	var _BorrowingList = __webpack_require__(236);
	
	var _BorrowingList2 = _interopRequireDefault(_BorrowingList);
	
	var _RecentlyReturnedUtilityBar = __webpack_require__(1797);
	
	var _RecentlyReturnedUtilityBar2 = _interopRequireDefault(_RecentlyReturnedUtilityBar);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _RecentlyReturnedEmptyContentPanel = __webpack_require__(567);
	
	var _RecentlyReturnedEmptyContentPanel2 = _interopRequireDefault(_RecentlyReturnedEmptyContentPanel);
	
	var _RecentlyReturnedIsDisabledContentPanel = __webpack_require__(1784);
	
	var _RecentlyReturnedIsDisabledContentPanel2 = _interopRequireDefault(_RecentlyReturnedIsDisabledContentPanel);
	
	var _RecentlyReturnedSummaryView = __webpack_require__(1794);
	
	var _RecentlyReturnedSummaryView2 = _interopRequireDefault(_RecentlyReturnedSummaryView);
	
	var _RecentlyReturnedHistoryView = __webpack_require__(1782);
	
	var _RecentlyReturnedHistoryView2 = _interopRequireDefault(_RecentlyReturnedHistoryView);
	
	var _RecentlyReturnedAddToShelf = __webpack_require__(1779);
	
	var _RecentlyReturnedAddToShelf2 = _interopRequireDefault(_RecentlyReturnedAddToShelf);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _WorkflowConstants = __webpack_require__(74);
	
	__webpack_require__(2501);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RecentlyReturned = function (_BcReactComponent) {
	  _inherits(RecentlyReturned, _BcReactComponent);
	
	  function RecentlyReturned(props) {
	    _classCallCheck(this, RecentlyReturned);
	
	    var _this = _possibleConstructorReturn(this, (RecentlyReturned.__proto__ || Object.getPrototypeOf(RecentlyReturned)).call(this, props));
	
	    var historyView = false;
	    if (props.router.location.query.page || props.router.location.query.sort) {
	      historyView = true;
	    }
	    _this.state = {
	      historyView: historyView
	    };
	
	    _this.bindAll('enableBorrowingHistory', 'switchToHistoryView', 'renderBatchActionButtons', 'handleBatchAddToShelf');
	    return _this;
	  }
	
	  _createClass(RecentlyReturned, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.currentView === 'small') {
	        this.setState({
	          historyView: true
	        });
	      }
	    }
	  }, {
	    key: 'enableBorrowingHistory',
	    value: function enableBorrowingHistory() {
	      this.props.accountActions.updateBorrowingHistorySetting(this.props.accountId, true);
	    }
	  }, {
	    key: 'switchToHistoryView',
	    value: function switchToHistoryView() {
	      this.setState({
	        historyView: true
	      });
	    }
	  }, {
	    key: 'getPrintURL',
	    value: function getPrintURL() {
	      var search = this.props.location.search;
	
	      return '/v2/print/recentlyreturned' + search;
	    }
	  }, {
	    key: 'handleBatchAddToShelf',
	    value: function handleBatchAddToShelf(items, shelfName) {
	      var metadataIds = items.map(function (item) {
	        return item.get('metadataId');
	      }).toSet().toList();
	
	      this.props.shelfActions.batchAddToShelf({ metadataIds: metadataIds, shelfName: shelfName });
	      this.props.workflowActions.updateWorkflow(_WorkflowConstants.BATCH_ACTIONS, _WorkflowConstants.BATCH_ADDED_TO_SHELF_WORKFLOW, _immutable2.default.Map({ shelfName: shelfName, metadataIds: metadataIds }));
	    }
	  }, {
	    key: 'renderBatchActionButtons',
	    value: function renderBatchActionButtons(itemsForAction) {
	      return _react2.default.createElement(_RecentlyReturnedAddToShelf2.default, {
	        itemsForAction: itemsForAction,
	        handleBatchAddToShelf: this.handleBatchAddToShelf });
	    }
	  }, {
	    key: 'getSortOptions',
	    value: function getSortOptions() {
	      var sortOptions = this.props.sortOptions;
	      if (!sortOptions) {
	        return _immutable2.default.List();
	      }
	      var defaultSort = sortOptions.indexOf('checkedoutDate') === -1 ? 'returnedDate' : 'checkedoutDate';
	      var currentSort = this.props.router.location.query.sort || defaultSort;
	      return sortOptions.reduce(function (acc, val) {
	        return acc.set(val, _immutable2.default.Map({
	          id: val,
	          applied: val === currentSort
	        }));
	      }, _immutable2.default.Map()).toList();
	    }
	  }, {
	    key: 'renderContent',
	    value: function renderContent() {
	      var _this2 = this;
	
	      var _props = this.props,
	          saveBorrowingHistoryEnabled = _props.saveBorrowingHistoryEnabled,
	          items = _props.items,
	          returnedItemsOnLastDate = _props.returnedItemsOnLastDate,
	          recentlyReturnedPaging = _props.recentlyReturnedPaging,
	          RecentlyReturnedActions = _props.RecentlyReturnedActions,
	          isFetching = _props.isFetching,
	          shelfActions = _props.shelfActions;
	
	
	      if (saveBorrowingHistoryEnabled && recentlyReturnedPaging.get('count') === 0) {
	        return _react2.default.createElement(_RecentlyReturnedEmptyContentPanel2.default, null);
	      }
	
	      if (!saveBorrowingHistoryEnabled) {
	        return _react2.default.createElement(_RecentlyReturnedIsDisabledContentPanel2.default, { handleClick: this.enableBorrowingHistory });
	      }
	
	      var itemsSinceLastCheckout = items.filter(function (item, index) {
	        return index < returnedItemsOnLastDate;
	      });
	      var defaultSort = this.props.sortOptions && this.props.sortOptions.indexOf('checkedoutDate') === -1 ? 'returnedDate' : 'checkedoutDate';
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'title-row' },
	        _react2.default.createElement(_RecentlyReturnedTitle2.default, null),
	        _react2.default.createElement(
	          _BorrowingList2.default,
	          null,
	          _react2.default.createElement(_RecentlyReturnedUtilityBar2.default, {
	            sortEnabled: this.state.historyView,
	            sortOptions: this.getSortOptions(),
	            printURL: this.getPrintURL(),
	            recentlyReturnedPaging: this.state.historyView ? recentlyReturnedPaging : null,
	            totalCount: recentlyReturnedPaging.get('count') }),
	          this.state.historyView && _react2.default.createElement(_RecentlyReturnedHistoryView2.default, {
	            items: items,
	            totalCount: recentlyReturnedPaging.get('count'),
	            renderBatchActionButtons: function renderBatchActionButtons(itemsForAction) {
	              return _this2.renderBatchActionButtons(itemsForAction);
	            },
	            RecentlyReturnedActions: RecentlyReturnedActions,
	            recentlyReturnedPaging: recentlyReturnedPaging,
	            isFetching: isFetching,
	            shelfActions: shelfActions,
	            ratingsTransactions: this.props.ratingsTransactions,
	            ratingsActions: this.props.ratingsActions,
	            ratings: this.props.ratings,
	            defaultSort: defaultSort }),
	          !this.state.historyView && _react2.default.createElement(_RecentlyReturnedSummaryView2.default, { totalItems: recentlyReturnedPaging.get('count'), switchViews: this.switchToHistoryView, itemsSinceLastCheckout: itemsSinceLastCheckout })
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var isFetching = this.props.isFetching;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-recentlyreturned' },
	        _react2.default.createElement(_sharedProgressBar2.default, { active: isFetching }),
	        this.renderContent()
	      );
	    }
	  }]);
	
	  return RecentlyReturned;
	}(_baseBcReactComponent2.default);
	
	RecentlyReturned.propTypes = {
	  user: _reactImmutableProptypes2.default.map,
	  recentlyReturnedPaging: _reactImmutableProptypes2.default.map,
	  sortOptions: _reactImmutableProptypes2.default.list,
	  saveBorrowingHistoryEnabled: _react.PropTypes.bool,
	  items: _reactImmutableProptypes2.default.list,
	  returnedItemsOnLastDate: _react.PropTypes.number,
	  workflowActions: _react.PropTypes.objectOf(_react.PropTypes.func),
	  shelfActions: _react.PropTypes.objectOf(_react.PropTypes.func),
	  isFetching: _react2.default.PropTypes.bool,
	  currentView: _react.PropTypes.string,
	  listPresentationActions: _react.PropTypes.objectOf(_react.PropTypes.func),
	  RecentlyReturnedActions: _react.PropTypes.objectOf(_react.PropTypes.func),
	  accountActions: _react.PropTypes.objectOf(_react.PropTypes.func),
	  accountId: _react.PropTypes.number,
	  ratingsTransactions: _reactImmutableProptypes2.default.map,
	  ratings: _reactImmutableProptypes2.default.map,
	  ratingsActions: _react.PropTypes.objectOf(_react.PropTypes.func)
	};
	
	exports.default = RecentlyReturned;

/***/ },
/* 1777 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _RecentlyReturned = __webpack_require__(1776);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RecentlyReturned).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1778 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = RecentlyReturnedAddToShelf;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _BatchAddToShelfButton = __webpack_require__(388);
	
	var _BatchAddToShelfButton2 = _interopRequireDefault(_BatchAddToShelfButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function RecentlyReturnedAddToShelf(_ref) {
	  var itemsForAction = _ref.itemsForAction,
	      handleBatchAddToShelf = _ref.handleBatchAddToShelf;
	
	  var shelfItemsSelected = itemsForAction.get('addToShelf', _immutable2.default.List());
	  return _react2.default.createElement(
	    'div',
	    { className: 'cp-holds-batch-actions' },
	    _react2.default.createElement(_BatchAddToShelfButton2.default, {
	      selectedItemCount: shelfItemsSelected.size,
	      handleClick: function handleClick(shelfName) {
	        return handleBatchAddToShelf(shelfItemsSelected, shelfName);
	      } })
	  );
	}
	
	RecentlyReturnedAddToShelf.propTypes = {
	  itemsForAction: _reactImmutableProptypes2.default.map,
	  handleBatchAddToShelf: _react.PropTypes.func
	};

/***/ },
/* 1779 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _RecentlyReturnedAddToShelf = __webpack_require__(1778);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RecentlyReturnedAddToShelf).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1780 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = RecentlyReturnedEmptyContentPanel;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _RecentlyReturnedTitle = __webpack_require__(283);
	
	var _RecentlyReturnedTitle2 = _interopRequireDefault(_RecentlyReturnedTitle);
	
	var _BorrowingEmptyContentPanel = __webpack_require__(235);
	
	var _BorrowingEmptyContentPanel2 = _interopRequireDefault(_BorrowingEmptyContentPanel);
	
	var _baseIcons = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function RecentlyReturnedEmptyContentPanel(_ref) {
	  var fetching = _ref.fetching;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'cp-recentlyreturned' },
	    _react2.default.createElement(
	      'div',
	      { className: 'title-row' },
	      _react2.default.createElement(_RecentlyReturnedTitle2.default, null),
	      _react2.default.createElement(_BorrowingEmptyContentPanel2.default, {
	        className: 'cp-recentlyreturned-empty-content-panel',
	        showStaffPicksLink: false,
	        fetching: fetching,
	        helpPage: '040settings/005privacy-settings',
	        icon: _react2.default.createElement(_baseIcons.BorrowingHistoryIcon, null),
	        title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'empty_recentlyreturned_is_enabled_title' }),
	        subtitle: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'empty_recentlyreturned_is_enabled_text' }) })
	    )
	  );
	}
	
	RecentlyReturnedEmptyContentPanel.propTypes = {
	  fetching: _react.PropTypes.bool
	};

/***/ },
/* 1781 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(17);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _BatchActionsListContainer = __webpack_require__(298);
	
	var _BatchActionsListContainer2 = _interopRequireDefault(_BatchActionsListContainer);
	
	var _ItemList = __webpack_require__(145);
	
	var _ItemList2 = _interopRequireDefault(_ItemList);
	
	var _pagination = __webpack_require__(92);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _RecentlyReturnedItem = __webpack_require__(1786);
	
	var _RecentlyReturnedItem2 = _interopRequireDefault(_RecentlyReturnedItem);
	
	var _BatchActionsListItem = __webpack_require__(288);
	
	var _BatchActionsListItem2 = _interopRequireDefault(_BatchActionsListItem);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	__webpack_require__(2502);
	
	var _AddToShelfBatchActions = __webpack_require__(382);
	
	var _AddToShelfBatchActions2 = _interopRequireDefault(_AddToShelfBatchActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var historyItemToActionItem = function historyItemToActionItem(item) {
	  return _immutable2.default.Map({
	    id: item.get('id'),
	    metadataId: item.get('metadataId'),
	    actions: item.get('actions', _immutable2.default.List())
	  });
	};
	
	var RecentlyReturnedHistoryView = function (_BcReactComponent) {
	  _inherits(RecentlyReturnedHistoryView, _BcReactComponent);
	
	  function RecentlyReturnedHistoryView(props) {
	    _classCallCheck(this, RecentlyReturnedHistoryView);
	
	    var _this = _possibleConstructorReturn(this, (RecentlyReturnedHistoryView.__proto__ || Object.getPrototypeOf(RecentlyReturnedHistoryView)).call(this, props));
	
	    _this.bindAll('renderBatchActionsMenu', 'handleBatchAdd');
	    return _this;
	  }
	
	  _createClass(RecentlyReturnedHistoryView, [{
	    key: 'renderBibListItem',
	    value: function renderBibListItem(item, selectedItems, updateItem) {
	      if (!item.get('metadataId')) {
	        return null;
	      }
	
	      var actionItem = historyItemToActionItem(item);
	
	      return _react2.default.createElement(
	        _BatchActionsListItem2.default,
	        {
	          actionItem: actionItem,
	          selectedItems: selectedItems,
	          updateItem: updateItem },
	        _react2.default.createElement(_RecentlyReturnedItem2.default, {
	          item: item,
	          defaultSort: this.props.defaultSort,
	          rating: this.props.ratings.get(item.get('metadataId')),
	          ratingsTransactions: this.props.ratingsTransactions,
	          ratingsActions: this.props.ratingsActions })
	      );
	    }
	  }, {
	    key: 'renderBatchActionsMenu',
	    value: function renderBatchActionsMenu(selectedActionItems) {
	      var itemsprefilter = selectedActionItems.filter(function (selectedItem) {
	        return _immutable2.default.List.isList(selectedItem.get('actions'));
	      });
	
	      return [].concat(_toConsumableArray((0, _AddToShelfBatchActions2.default)({
	        items: itemsprefilter,
	        handleBatchAddToShelf: this.handleBatchAdd
	      })));
	    }
	  }, {
	    key: 'handleBatchAdd',
	    value: function handleBatchAdd(selectedActionItems, shelfName) {
	      var metadataIds = selectedActionItems.map(function (item) {
	        return item.get('metadataId');
	      }).toSet().toList();
	      this.props.shelfActions.batchAddToShelf({ metadataIds: metadataIds, shelfName: shelfName });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var actionList = this.props.items.map(historyItemToActionItem);
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-borrowing-history-list' },
	        _react2.default.createElement(
	          _BatchActionsListContainer2.default,
	          {
	            list: actionList,
	            totalItems: this.props.totalCount,
	            renderActionsMenu: this.renderBatchActionsMenu },
	          function (selectedItems, updateItem) {
	            return _react2.default.createElement(
	              _ItemList2.default,
	              null,
	              _this2.props.items.map(function (item) {
	                return _this2.renderBibListItem(item, selectedItems, updateItem);
	              })
	            );
	          }
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'borrowing-history-paging' },
	          _react2.default.createElement(_pagination2.default, {
	            isFetching: this.props.isFetching,
	            page: this.props.recentlyReturnedPaging.get('page'),
	            limit: this.props.recentlyReturnedPaging.get('limit'),
	            count: this.props.recentlyReturnedPaging.get('count'),
	            pages: this.props.recentlyReturnedPaging.get('pages'),
	            className: 'recently-returned-paging clearfix',
	            showPages: true })
	        )
	      );
	    }
	  }]);
	
	  return RecentlyReturnedHistoryView;
	}(_baseBcReactComponent2.default);
	
	RecentlyReturnedHistoryView.propTypes = {
	  items: _reactImmutableProptypes2.default.list,
	  totalCount: _react.PropTypes.number,
	  recentlyReturnedPaging: _reactImmutableProptypes2.default.map,
	  renderBatchActionButtons: _react.PropTypes.func,
	  isFetching: _react2.default.PropTypes.bool,
	  shelfActions: _react.PropTypes.objectOf(_react.PropTypes.func),
	  defaultSort: _react.PropTypes.string,
	  RecentlyReturnedActions: _react.PropTypes.objectOf(_react.PropTypes.func),
	  ratingsTransactions: _reactImmutableProptypes2.default.map,
	  ratings: _reactImmutableProptypes2.default.map,
	  ratingsActions: _react.PropTypes.objectOf(_react.PropTypes.func)
	};
	
	exports.default = (0, _reactRouter.withRouter)(RecentlyReturnedHistoryView);

/***/ },
/* 1782 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _RecentlyReturnedHistoryView = __webpack_require__(1781);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RecentlyReturnedHistoryView).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1783 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = RecentlyReturnedIsDisabledContentPanel;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RecentlyReturnedTitle = __webpack_require__(283);
	
	var _RecentlyReturnedTitle2 = _interopRequireDefault(_RecentlyReturnedTitle);
	
	var _reactIntl = __webpack_require__(3);
	
	var _EmptyContentPanel = __webpack_require__(588);
	
	var _EmptyContentPanel2 = _interopRequireDefault(_EmptyContentPanel);
	
	var _baseIcons = __webpack_require__(10);
	
	__webpack_require__(2503);
	
	var _baseButtons = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function RecentlyReturnedIsDisabledContentPanel(_ref) {
	  var handleClick = _ref.handleClick;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'cp-recentlyreturned' },
	    _react2.default.createElement(
	      'div',
	      { className: 'title-row' },
	      _react2.default.createElement(_RecentlyReturnedTitle2.default, null)
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'cp-recentlyreturned-disabled-content-panel' },
	      _react2.default.createElement(
	        _EmptyContentPanel2.default,
	        {
	          icon: _react2.default.createElement(_baseIcons.BorrowingHistoryIcon, null),
	          title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'empty_recentlyreturned_opt_in_title' }),
	          subtitle: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'empty_recentlyreturned_opt_in_text' }) },
	        _react2.default.createElement(
	          'div',
	          { className: 'enable-borrowing-block' },
	          '\u200C',
	          _react2.default.createElement(
	            _reactIntl.FormattedMessage,
	            { id: 'form_label_retreive_borrowing_history' },
	            function (message) {
	              return _react2.default.createElement(
	                _baseButtons.PrimaryButton,
	                { handleClick: handleClick, className: 'enable-borrowing-history btn-primary' },
	                message
	              );
	            }
	          )
	        )
	      )
	    )
	  );
	}
	
	RecentlyReturnedIsDisabledContentPanel.propTypes = {
	  handleClick: _react.PropTypes.func
	};

/***/ },
/* 1784 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _RecentlyReturnedIsDisabledContentPanel = __webpack_require__(1783);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RecentlyReturnedIsDisabledContentPanel).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1785 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _AddToShelfButtonContainer = __webpack_require__(146);
	
	var _AddToShelfButtonContainer2 = _interopRequireDefault(_AddToShelfButtonContainer);
	
	var _formatIndicator = __webpack_require__(177);
	
	var _formatIndicator2 = _interopRequireDefault(_formatIndicator);
	
	var _BorrowingBibBrief = __webpack_require__(284);
	
	var _BorrowingBibBrief2 = _interopRequireDefault(_BorrowingBibBrief);
	
	var _ShortFormattedDate = __webpack_require__(60);
	
	var _ShortFormattedDate2 = _interopRequireDefault(_ShortFormattedDate);
	
	var _reactIntl = __webpack_require__(3);
	
	var _rating = __webpack_require__(141);
	
	var _rating2 = _interopRequireDefault(_rating);
	
	var _BibListItem = __webpack_require__(239);
	
	var _BibListItem2 = _interopRequireDefault(_BibListItem);
	
	__webpack_require__(2504);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RecentlyReturnedItem = function (_BcReactComponent) {
	  _inherits(RecentlyReturnedItem, _BcReactComponent);
	
	  function RecentlyReturnedItem(props) {
	    _classCallCheck(this, RecentlyReturnedItem);
	
	    var _this = _possibleConstructorReturn(this, (RecentlyReturnedItem.__proto__ || Object.getPrototypeOf(RecentlyReturnedItem)).call(this, props));
	
	    _this.bindAll('renderBibActions', 'renderSecondaryInfo', 'renderBibBrief', 'handleUpdateRating', 'handleRemoveRating');
	    return _this;
	  }
	
	  _createClass(RecentlyReturnedItem, [{
	    key: 'handleUpdateRating',
	    value: function handleUpdateRating(rating) {
	      if (this.props.rating) {
	        return this.props.ratingsActions.changeItemRating(this.props.item.get('metadataId'), rating);
	      }
	
	      return this.props.ratingsActions.rateItem(this.props.item.get('metadataId'), rating);
	    }
	  }, {
	    key: 'handleRemoveRating',
	    value: function handleRemoveRating() {
	      return this.props.ratingsActions.removeItemRating(this.props.item.get('metadataId'), this.props.rating.get(0).get('id'));
	    }
	  }, {
	    key: 'renderRating',
	    value: function renderRating() {
	      var _props = this.props,
	          item = _props.item,
	          ratingsTransactions = _props.ratingsTransactions,
	          rating = _props.rating;
	
	      var currentUserRating = rating ? rating.get(0).get('rating') : null;
	      var metadataId = item.get('metadataId');
	      var isLoading = ratingsTransactions.getIn([metadataId, 'isLoading'], false);
	      return _react2.default.createElement(
	        'div',
	        { className: 'post-success-rating' },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'label_rate_this' }),
	        _react2.default.createElement(_rating2.default, {
	          id: 'added_to_shelf_rating_' + metadataId,
	          isLoading: isLoading,
	          rating: currentUserRating,
	          handleButtonClick: this.handleUpdateRating,
	          handleRemoveClick: this.handleRemoveRating })
	      );
	    }
	  }, {
	    key: 'renderBibActions',
	    value: function renderBibActions() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.props.item && this.props.item.get('bib') && _react2.default.createElement(
	          'div',
	          { className: 'recently-returned-shelf-button' },
	          _react2.default.createElement(_AddToShelfButtonContainer2.default, {
	            metadataId: this.props.item.get('metadataId'),
	            workflowId: this.props.item.get('id') })
	        )
	      );
	    }
	  }, {
	    key: 'renderSecondaryInfo',
	    value: function renderSecondaryInfo() {
	      var _props2 = this.props,
	          item = _props2.item,
	          defaultSort = _props2.defaultSort;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'returned-checkout-date' },
	          defaultSort === 'checkedoutDate' && item.getIn(['checkedoutDate']) && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'span',
	              { className: 'info_label' },
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'checked_out_on' }),
	              ': '
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'text_black' },
	              _react2.default.createElement(_ShortFormattedDate2.default, { value: item.getIn(['checkedoutDate']) })
	            )
	          ),
	          defaultSort === 'returnedDate' && item.getIn(['returnedDate']) && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'span',
	              { className: 'info_label' },
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'returned_on' }),
	              ': '
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'text_black' },
	              _react2.default.createElement(_ShortFormattedDate2.default, { value: item.getIn(['returnedDate']) })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          this.renderBibActions()
	        )
	      );
	    }
	  }, {
	    key: 'renderBibBrief',
	    value: function renderBibBrief() {
	      var item = this.props.item;
	
	      if (item && item.getIn(['bib'])) {
	        var briefInfo = item.getIn(['bib', 'briefInfo']);
	        return _react2.default.createElement(
	          _BorrowingBibBrief2.default,
	          { bib: briefInfo },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_formatIndicator2.default, { format: item.getIn(['bib', 'briefInfo', 'format']) }),
	            item.getIn(['bib', 'briefInfo', 'publicationDate']) && _react2.default.createElement(
	              'span',
	              null,
	              ' - ',
	              item.getIn(['bib', 'briefInfo', 'publicationDate'])
	            )
	          ),
	          this.renderRating()
	        );
	      }
	      return '';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var item = this.props.item;
	
	
	      return _react2.default.createElement(_BibListItem2.default, {
	        workflowId: item.get('id'),
	        className: 'cp-recently-returned-item',
	        bib: item.getIn(['bib', 'briefInfo']),
	        renderInfo: this.renderSecondaryInfo,
	        renderBibBrief: function renderBibBrief() {
	          return _this2.renderBibBrief();
	        } });
	    }
	  }]);
	
	  return RecentlyReturnedItem;
	}(_baseBcReactComponent2.default);
	
	exports.default = RecentlyReturnedItem;
	
	
	RecentlyReturnedItem.propTypes = {
	  item: _reactImmutableProptypes2.default.map,
	  defaultSort: _react.PropTypes.string,
	  ratingsTransactions: _reactImmutableProptypes2.default.map,
	  rating: _reactImmutableProptypes2.default.map,
	  ratingsActions: _react.PropTypes.objectOf(_react.PropTypes.func)
	};

/***/ },
/* 1786 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _RecentlyReturnedItem = __webpack_require__(1785);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RecentlyReturnedItem).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1787 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _RecentlyReturnedTitle = __webpack_require__(283);
	
	var _RecentlyReturnedTitle2 = _interopRequireDefault(_RecentlyReturnedTitle);
	
	var _baseButtons = __webpack_require__(12);
	
	var _reactIntl = __webpack_require__(3);
	
	__webpack_require__(2505);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RecentlyReturnedLoading = function (_BcReactComponent) {
	  _inherits(RecentlyReturnedLoading, _BcReactComponent);
	
	  function RecentlyReturnedLoading() {
	    _classCallCheck(this, RecentlyReturnedLoading);
	
	    return _possibleConstructorReturn(this, (RecentlyReturnedLoading.__proto__ || Object.getPrototypeOf(RecentlyReturnedLoading)).apply(this, arguments));
	  }
	
	  _createClass(RecentlyReturnedLoading, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-recentlyreturned' },
	        _react2.default.createElement(
	          'div',
	          { className: 'title-row' },
	          _react2.default.createElement(_RecentlyReturnedTitle2.default, null),
	          _react2.default.createElement(
	            'div',
	            { className: 'recently-returned-loading-panel clearfix' },
	            _react2.default.createElement(
	              'div',
	              { className: 'loading-message' },
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'recently_returned_loading' })
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                _baseButtons.PrimaryButton,
	                { handleClick: this.props.retryLoading, className: 'retry-loading', isLoading: this.props.isLoading },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'reload_now' })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return RecentlyReturnedLoading;
	}(_baseBcReactComponent2.default);
	
	exports.default = RecentlyReturnedLoading;
	
	
	RecentlyReturnedLoading.propTypes = {
	  retryLoading: _react.PropTypes.func,
	  isLoading: _react.PropTypes.bool
	};

/***/ },
/* 1788 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _RecentlyReturnedLoading = __webpack_require__(1787);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RecentlyReturnedLoading).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1789 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _print = __webpack_require__(120);
	
	var _formatIndicator = __webpack_require__(177);
	
	var _formatIndicator2 = _interopRequireDefault(_formatIndicator);
	
	var _sharedPublicationDate = __webpack_require__(369);
	
	var _sharedPublicationDate2 = _interopRequireDefault(_sharedPublicationDate);
	
	var _sharedBibBrief = __webpack_require__(46);
	
	var _sharedBibBrief2 = _interopRequireDefault(_sharedBibBrief);
	
	var _ShortFormattedDate = __webpack_require__(60);
	
	var _ShortFormattedDate2 = _interopRequireDefault(_ShortFormattedDate);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	__webpack_require__(2506);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var renderFormat = function renderFormat(format, index, item) {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_formatIndicator2.default, { format: format }),
	    _react2.default.createElement(_sharedPublicationDate2.default, { publicationDate: item.getIn(['bib', 'briefInfo', 'publicationDate']) })
	  );
	};
	
	var renderTitle = function renderTitle(title, index, item) {
	  return _react2.default.createElement(_sharedBibBrief2.default, {
	    bib: item.getIn(['bib', 'briefInfo']),
	    titleTag: 'span',
	    renderTitleAsLink: false,
	    renderAuthorsAsLink: false });
	};
	
	var renderCheckoutDate = function renderCheckoutDate(checkedoutDate) {
	  return _react2.default.createElement(_ShortFormattedDate2.default, { value: checkedoutDate });
	};
	
	var RecentlyReturnedPrintList = function (_BcReactComponent) {
	  _inherits(RecentlyReturnedPrintList, _BcReactComponent);
	
	  function RecentlyReturnedPrintList(props) {
	    _classCallCheck(this, RecentlyReturnedPrintList);
	
	    var _this = _possibleConstructorReturn(this, (RecentlyReturnedPrintList.__proto__ || Object.getPrototypeOf(RecentlyReturnedPrintList)).call(this, props));
	
	    _this.bindAll('handleUpdatePage');
	    return _this;
	  }
	
	  _createClass(RecentlyReturnedPrintList, [{
	    key: 'handleUpdatePage',
	    value: function handleUpdatePage() {
	      var page = parseInt(this.props.router.location.query.page || 1, 10);
	      page += 1;
	      var _props = this.props,
	          location = _props.location,
	          router = _props.router,
	          accountId = _props.accountId;
	
	      router.push(_extends({}, location, {
	        query: _extends({}, location.query, {
	          page: page
	        })
	      }));
	
	      this.props.RecentlyReturnedActions.fetchReturnHistory(_extends({}, location.query, {
	        page: page,
	        accountId: accountId
	      }));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          items = _props2.items,
	          pagination = _props2.pagination,
	          isFetching = _props2.isFetching;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-holds-print-list' },
	        _react2.default.createElement(
	          _print.PrintButtonsToolbar,
	          { numItemsToPrint: items.size },
	          _react2.default.createElement(_print.PrintLoadNextButton, {
	            handleClick: this.handleUpdatePage,
	            numToLoad: pagination.get('size'),
	            totalPages: pagination.get('totalPages'),
	            currentPage: pagination.get('number') + 1,
	            isLoading: isFetching })
	        ),
	        _react2.default.createElement(
	          'h1',
	          null,
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'section_title_recently_returned' })
	        ),
	        _react2.default.createElement(
	          _reactIntl.FormattedMessage,
	          { id: 'label_number_of_items', values: { count: items.size } },
	          function (message) {
	            return _react2.default.createElement(
	              'p',
	              null,
	              message
	            );
	          }
	        ),
	        _react2.default.createElement(_print.PrintTable, {
	          rows: items,
	          fields: [{ key: 'bib.briefInfo.title', type: 'item-title', headerKey: 'table_headings_title', transformationMap: renderTitle }, { key: 'bib.briefInfo.format', type: 'item-format', headerKey: 'table_headings_format', transformationMap: renderFormat }, { key: 'bib.briefInfo.callNumber', type: 'item-callNumber', headerKey: 'callNumber' }, { key: 'barcode', type: 'item-barcode', headerKey: 'form_label_barcode' }, { key: 'checkedoutDate', type: 'item-checkedoutDate', headerKey: 'section_title_checkedout', transformationMap: renderCheckoutDate }] }),
	        _react2.default.createElement(
	          'div',
	          { className: 'page-info' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'form_label_current_page', values: { current_page: this.props.router.location.query.page || 1 } }),
	          '\xA0',
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'form_label_total_pages', values: { total_pages: pagination.get('pages') } })
	        )
	      );
	    }
	  }]);
	
	  return RecentlyReturnedPrintList;
	}(_baseBcReactComponent2.default);
	
	exports.default = RecentlyReturnedPrintList;
	
	
	RecentlyReturnedPrintList.propTypes = {
	  items: _reactImmutableProptypes2.default.list,
	  pagination: _reactImmutableProptypes2.default.map,
	  isFetching: _react.PropTypes.bool,
	  RecentlyReturnedActions: _react.PropTypes.objectOf(_react.PropTypes.func),
	  accountId: _react.PropTypes.number
	};

/***/ },
/* 1790 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _RecentlyReturnedPrintList = __webpack_require__(1789);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RecentlyReturnedPrintList).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1791 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _SidebarCompactTitle = __webpack_require__(183);
	
	var _SidebarCompactTitle2 = _interopRequireDefault(_SidebarCompactTitle);
	
	var _BorrowingStatus = __webpack_require__(182);
	
	var _BorrowingStatus2 = _interopRequireDefault(_BorrowingStatus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RecentlyReturnedStatus = function (_BcReactComponent) {
	  _inherits(RecentlyReturnedStatus, _BcReactComponent);
	
	  function RecentlyReturnedStatus() {
	    _classCallCheck(this, RecentlyReturnedStatus);
	
	    return _possibleConstructorReturn(this, (RecentlyReturnedStatus.__proto__ || Object.getPrototypeOf(RecentlyReturnedStatus)).apply(this, arguments));
	  }
	
	  _createClass(RecentlyReturnedStatus, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _BorrowingStatus2.default,
	        { to: '/v2/recentlyreturned', currentSection: this.props.currentSection },
	        _react2.default.createElement(_SidebarCompactTitle2.default, {
	          title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'section_title_recently_returned' }),
	          count: _react2.default.createElement(
	            'span',
	            null,
	            this.props.totalBorrowingHistory === -1 ? '' : this.props.totalBorrowingHistory
	          ),
	          selected: this.props.currentSection })
	      );
	    }
	  }]);
	
	  return RecentlyReturnedStatus;
	}(_baseBcReactComponent2.default);
	
	exports.default = RecentlyReturnedStatus;
	
	
	RecentlyReturnedStatus.propTypes = {
	  currentSection: _react.PropTypes.bool,
	  totalBorrowingHistory: _react.PropTypes.number.isRequired
	};

/***/ },
/* 1792 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _RecentlyReturnedStatus = __webpack_require__(1791);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RecentlyReturnedStatus).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1793 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	__webpack_require__(2507);
	
	var _utilsLink = __webpack_require__(97);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseIcons = __webpack_require__(10);
	
	var _JacketCoverContainer = __webpack_require__(395);
	
	var _JacketCoverContainer2 = _interopRequireDefault(_JacketCoverContainer);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _ItemList = __webpack_require__(145);
	
	var _ItemList2 = _interopRequireDefault(_ItemList);
	
	var _utilsFormat = __webpack_require__(96);
	
	var _baseButtons = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RecentlyReturnedSummaryView = function (_BcReactComponent) {
	  _inherits(RecentlyReturnedSummaryView, _BcReactComponent);
	
	  function RecentlyReturnedSummaryView() {
	    _classCallCheck(this, RecentlyReturnedSummaryView);
	
	    return _possibleConstructorReturn(this, (RecentlyReturnedSummaryView.__proto__ || Object.getPrototypeOf(RecentlyReturnedSummaryView)).apply(this, arguments));
	  }
	
	  _createClass(RecentlyReturnedSummaryView, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          switchViews = _props.switchViews,
	          totalItems = _props.totalItems,
	          itemsSinceLastCheckout = _props.itemsSinceLastCheckout;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'recently-returned-grid-view clearfix' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-12 col-sm-7' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'recently_returned' })
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'recently_returned_description' })
	            )
	          ),
	          _react2.default.createElement(
	            _ItemList2.default,
	            { className: 'cp-bcslider recently-returned-bibs col-xs-12' },
	            itemsSinceLastCheckout.map(function (item) {
	              return RecentlyReturnedSummaryView.renderBibs(item);
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'switch-views col-md-12' },
	            _react2.default.createElement(
	              _baseButtons.TextButton,
	              { handleClick: switchViews, className: 'history-link' },
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'recently_returned_show_all_history', values: { total: totalItems } }),
	              _react2.default.createElement(_baseIcons.Chevron.Right, null)
	            )
	          )
	        )
	      );
	    }
	  }], [{
	    key: 'renderBibs',
	    value: function renderBibs(item) {
	      if (!item.get('bib')) {
	        return null;
	      }
	      var bib = item.get('bib');
	      return _react2.default.createElement(
	        'div',
	        { className: 'recently-returned-bib' },
	        _react2.default.createElement(
	          'div',
	          { className: 'jacketCoverDiv' },
	          _react2.default.createElement(_JacketCoverContainer2.default, { src: bib.getIn(['briefInfo', 'jacket']), format: bib.getIn(['briefInfo', 'format']), alt: '' })
	        ),
	        _react2.default.createElement(
	          'a',
	          { className: 'hover-overlay', href: '/item/show/' + (0, _utilsLink.metadataIdFixer)(bib.get('id')), title: bib.getIn(['briefInfo', 'title']) },
	          _react2.default.createElement(
	            'span',
	            { className: 'hover-overlay-inner' },
	            _react2.default.createElement('span', { className: (0, _utilsFormat.getIconForFormat)(bib.getIn(['briefInfo', 'format'])), 'aria-hidden': true }),
	            _react2.default.createElement(
	              'div',
	              { className: 'title' },
	              bib.getIn(['briefInfo', 'title'])
	            ),
	            bib.getIn(['briefInfo', 'authors']).size ? _react2.default.createElement(
	              'div',
	              { className: 'author' },
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'by_authors', values: { authorLinks: bib.getIn(['briefInfo', 'authors']).first() } })
	            ) : null
	          )
	        )
	      );
	    }
	  }]);
	
	  return RecentlyReturnedSummaryView;
	}(_baseBcReactComponent2.default);
	
	exports.default = RecentlyReturnedSummaryView;
	
	
	RecentlyReturnedSummaryView.propTypes = {
	  switchViews: _react.PropTypes.func,
	  totalItems: _react.PropTypes.number,
	  itemsSinceLastCheckout: _reactImmutableProptypes2.default.list
	};

/***/ },
/* 1794 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _RecentlyReturnedSummaryView = __webpack_require__(1793);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RecentlyReturnedSummaryView).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1795 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = RecentlyReturnedTitle;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BorrowingHeader = __webpack_require__(124);
	
	var _BorrowingHeader2 = _interopRequireDefault(_BorrowingHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function RecentlyReturnedTitle() {
	  return _react2.default.createElement(_BorrowingHeader2.default, {
	    headingKey: 'section_title_recently_returned',
	    helpLinkPage: '040settings/005privacy-settings' });
	}

/***/ },
/* 1796 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _BorrowingUtilityBar = __webpack_require__(285);
	
	var _BorrowingUtilityBar2 = _interopRequireDefault(_BorrowingUtilityBar);
	
	var _reactIntl = __webpack_require__(3);
	
	__webpack_require__(2508);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RecentlyReturnedUtilityBar = function (_BcReactComponent) {
	  _inherits(RecentlyReturnedUtilityBar, _BcReactComponent);
	
	  function RecentlyReturnedUtilityBar() {
	    _classCallCheck(this, RecentlyReturnedUtilityBar);
	
	    return _possibleConstructorReturn(this, (RecentlyReturnedUtilityBar.__proto__ || Object.getPrototypeOf(RecentlyReturnedUtilityBar)).apply(this, arguments));
	  }
	
	  _createClass(RecentlyReturnedUtilityBar, [{
	    key: 'renderTitle',
	    value: function renderTitle() {
	      return _react2.default.createElement(
	        'span',
	        { className: 'cp-borrowing-utility-bar-title' },
	        _react2.default.createElement(
	          'h2',
	          null,
	          _react2.default.createElement(
	            'span',
	            { className: 'item_count_label' },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'label_number_of_items', values: { count: this.props.totalCount } })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_BorrowingUtilityBar2.default, {
	        className: 'cp-recently-returned-utility-bar',
	        printURL: this.props.printURL,
	        title: this.renderTitle(),
	        pagination: this.props.recentlyReturnedPaging,
	        sortOptions: this.props.sortOptions });
	    }
	  }]);
	
	  return RecentlyReturnedUtilityBar;
	}(_baseBcReactComponent2.default);
	
	exports.default = RecentlyReturnedUtilityBar;
	
	
	RecentlyReturnedUtilityBar.propTypes = {
	  totalCount: _react.PropTypes.number,
	  sortOptions: _reactImmutableProptypes2.default.list,
	  printURL: _react.PropTypes.string,
	  recentlyReturnedPaging: _reactImmutableProptypes2.default.map
	};

/***/ },
/* 1797 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _RecentlyReturnedUtilityBar = __webpack_require__(1796);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RecentlyReturnedUtilityBar).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1798 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = renderAddToShelfBatchActions;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseDropdown = __webpack_require__(37);
	
	var _reactIntl = __webpack_require__(3);
	
	var _ShelfConstants = __webpack_require__(43);
	
	var _BatchActionLink = __webpack_require__(238);
	
	var _BatchActionLink2 = _interopRequireDefault(_BatchActionLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	// TODO: convert this to a proper React component when we update to React 16.
	// In React 15 component render methods are not allowed to return arrays, so this has to be a regular function.
	function renderAddToShelfBatchActions(_ref) {
	  var items = _ref.items,
	      handleBatchAddToShelf = _ref.handleBatchAddToShelf;
	
	  var addToShelfItems = items.filter(function (item) {
	    return item.get('actions').includes('addToShelf');
	  });
	  var moveMenuHeader = _react2.default.createElement(
	    _baseDropdown.DropdownMenuHeader,
	    { key: 'shelf-batch-actions-header' },
	    _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'add_to_shelf_with_count', values: { count: addToShelfItems.size } })
	  );
	
	  var shelfNames = [_ShelfConstants.SHELF_NAMES.IN_PROGRESS, _ShelfConstants.SHELF_NAMES.FOR_LATER, _ShelfConstants.SHELF_NAMES.COMPLETED];
	
	  var moveMenuItems = shelfNames.map(function (shelfName) {
	    return _react2.default.createElement(
	      _baseDropdown.DropdownMenuItem,
	      { key: 'add-to-shelf-batch-actions-' + shelfName },
	      _react2.default.createElement(
	        _BatchActionLink2.default,
	        {
	          disabled: addToShelfItems.size === 0,
	          href: '#add-to-shelf-batch-actions-' + shelfName,
	          handleClick: function handleClick() {
	            return handleBatchAddToShelf(addToShelfItems, shelfName);
	          } },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'label_shelf_' + shelfName })
	      )
	    );
	  });
	
	  return [moveMenuHeader].concat(_toConsumableArray(moveMenuItems));
	}

/***/ },
/* 1799 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseInlineOverlay = __webpack_require__(83);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _sharedMessages = __webpack_require__(64);
	
	var _MessagingContainer = __webpack_require__(68);
	
	var _MessagingContainer2 = _interopRequireDefault(_MessagingContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BatchAddedToShelfWorkflow = function (_BcReactComponent) {
	  _inherits(BatchAddedToShelfWorkflow, _BcReactComponent);
	
	  function BatchAddedToShelfWorkflow() {
	    _classCallCheck(this, BatchAddedToShelfWorkflow);
	
	    return _possibleConstructorReturn(this, (BatchAddedToShelfWorkflow.__proto__ || Object.getPrototypeOf(BatchAddedToShelfWorkflow)).apply(this, arguments));
	  }
	
	  _createClass(BatchAddedToShelfWorkflow, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-batch-added-to-shelf-workflow' },
	        _react2.default.createElement(
	          _baseInlineOverlay.InlineOverlay,
	          { handleClose: this.props.closeWorkflow },
	          _react2.default.createElement(
	            _baseInlineOverlay.InlineOverlayHeader,
	            null,
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'add_to_my_shelf_' + this.props.shelfName })
	          ),
	          _react2.default.createElement(
	            _baseInlineOverlay.InlineOverlayBody,
	            null,
	            _react2.default.createElement(
	              _MessagingContainer2.default,
	              { id: this.props.workflowId },
	              function (messageOptions) {
	                return _react2.default.createElement(_sharedMessages.Generic, _extends({}, messageOptions, { duration: false }));
	              }
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return BatchAddedToShelfWorkflow;
	}(_baseBcReactComponent2.default);
	
	exports.default = BatchAddedToShelfWorkflow;
	
	
	BatchAddedToShelfWorkflow.propTypes = {
	  closeWorkflow: _react.PropTypes.func,
	  workflowId: _react.PropTypes.string,
	  shelfName: _react.PropTypes.string
	};

/***/ },
/* 1800 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BatchAddedToShelfWorkflow = __webpack_require__(1799);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BatchAddedToShelfWorkflow).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1801 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = BorrowingBatchActionsOverlay;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseFullScreenOverlay = __webpack_require__(45);
	
	var _baseFullScreenOverlay2 = _interopRequireDefault(_baseFullScreenOverlay);
	
	var _bcPropTypes = __webpack_require__(5);
	
	__webpack_require__(2509);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function BorrowingBatchActionsOverlay(_ref) {
	  var className = _ref.className,
	      open = _ref.open,
	      handleClose = _ref.handleClose,
	      header = _ref.header,
	      subtitle = _ref.subtitle,
	      children = _ref.children,
	      footer = _ref.footer;
	
	  return _react2.default.createElement(
	    _baseFullScreenOverlay2.default,
	    {
	      className: 'cp-borrowing-batch-actions-overlay ' + className,
	      disableHistoryControls: true,
	      open: open,
	      handleClose: handleClose },
	    header && _react2.default.createElement(
	      'h2',
	      { className: 'overlay-header ' + className },
	      ' ',
	      header,
	      ' '
	    ),
	    subtitle && _react2.default.createElement(
	      'div',
	      { className: 'overlay-subtitle ' + className },
	      ' ',
	      subtitle,
	      ' '
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'overlay-content ' + className },
	      children
	    ),
	    _react2.default.createElement('hr', null),
	    footer && _react2.default.createElement(
	      'div',
	      { className: 'overlay-footer clearfix' },
	      footer
	    )
	  );
	}
	
	BorrowingBatchActionsOverlay.propTypes = {
	  open: _react.PropTypes.bool.isRequired,
	  className: _react.PropTypes.string,
	  handleClose: _react.PropTypes.func,
	  header: _react.PropTypes.node,
	  subtitle: _react.PropTypes.node,
	  children: _bcPropTypes.childrenShape,
	  footer: _react.PropTypes.node
	};

/***/ },
/* 1802 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _sharedBibBrief = __webpack_require__(46);
	
	var _sharedBibBrief2 = _interopRequireDefault(_sharedBibBrief);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BorrowingBibBrief = function (_BcReactComponent) {
	  _inherits(BorrowingBibBrief, _BcReactComponent);
	
	  function BorrowingBibBrief() {
	    _classCallCheck(this, BorrowingBibBrief);
	
	    return _possibleConstructorReturn(this, (BorrowingBibBrief.__proto__ || Object.getPrototypeOf(BorrowingBibBrief)).apply(this, arguments));
	  }
	
	  _createClass(BorrowingBibBrief, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          bib = _props.bib,
	          fallbackTitle = _props.fallbackTitle,
	          children = _props.children;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-borrowing-bib-brief' },
	        _react2.default.createElement(
	          _sharedBibBrief2.default,
	          {
	            renderAuthorsAsLink: !this.context.mobileApp,
	            bib: bib,
	            fallbackTitle: fallbackTitle,
	            renderTitleAsLink: !!(bib && bib.get('id')) },
	          children
	        )
	      );
	    }
	  }]);
	
	  return BorrowingBibBrief;
	}(_baseBcReactComponent2.default);
	
	exports.default = BorrowingBibBrief;
	
	
	BorrowingBibBrief.propTypes = {
	  bib: _bcPropTypes.bibBriefShape,
	  fallbackTitle: _react.PropTypes.string,
	  children: _bcPropTypes.childrenShape
	};
	
	BorrowingBibBrief.contextTypes = {
	  mobileApp: _react.PropTypes.bool
	};

/***/ },
/* 1803 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = BorrowingEmptyContentPanel;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _EmptyContentPanel = __webpack_require__(588);
	
	var _EmptyContentPanel2 = _interopRequireDefault(_EmptyContentPanel);
	
	__webpack_require__(2510);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function BorrowingEmptyContentPanel(_ref) {
	  var className = _ref.className,
	      title = _ref.title,
	      subtitle = _ref.subtitle,
	      icon = _ref.icon,
	      showExploreNewTitlesLink = _ref.showExploreNewTitlesLink,
	      fetching = _ref.fetching;
	
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)('cp-borrowing-empty-content-panel', className) },
	    _react2.default.createElement(
	      _EmptyContentPanel2.default,
	      {
	        icon: icon,
	        title: title,
	        subtitle: subtitle,
	        fetching: fetching },
	      showExploreNewTitlesLink && _react2.default.createElement(
	        'a',
	        {
	          className: 'cp-explore-new-titles-link',
	          href: '/explore/recent_arrivals' },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'explore_new_titles' })
	      )
	    )
	  );
	}
	
	BorrowingEmptyContentPanel.defaultProps = {
	  showExploreNewTitlesLink: false
	};
	
	BorrowingEmptyContentPanel.propTypes = {
	  className: _react.PropTypes.string,
	  title: _react.PropTypes.node,
	  subtitle: _react.PropTypes.node,
	  icon: _react.PropTypes.node,
	  showExploreNewTitlesLink: _react.PropTypes.bool,
	  fetching: _react.PropTypes.bool
	};

/***/ },
/* 1804 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = BorrowingHeader;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _HelpLinkContainer = __webpack_require__(126);
	
	var _HelpLinkContainer2 = _interopRequireDefault(_HelpLinkContainer);
	
	var _AccountSwitcherContainer = __webpack_require__(635);
	
	var _AccountSwitcherContainer2 = _interopRequireDefault(_AccountSwitcherContainer);
	
	var _BorrowingTitle = __webpack_require__(1816);
	
	var _BorrowingTitle2 = _interopRequireDefault(_BorrowingTitle);
	
	__webpack_require__(2511);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function BorrowingHeader(_ref) {
	  var headingKey = _ref.headingKey,
	      taglineKey = _ref.taglineKey,
	      helpLinkPage = _ref.helpLinkPage;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'cp-borrowing-header' },
	    _react2.default.createElement(
	      'div',
	      { className: 'title-and-faqs' },
	      _react2.default.createElement(_BorrowingTitle2.default, { headingKey: headingKey, taglineKey: taglineKey }),
	      helpLinkPage && _react2.default.createElement(_HelpLinkContainer2.default, { page: helpLinkPage })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'right-controls' },
	      _react2.default.createElement(_AccountSwitcherContainer2.default, null)
	    )
	  );
	}
	
	BorrowingHeader.propTypes = {
	  headingKey: _react.PropTypes.string,
	  taglineKey: _react.PropTypes.string,
	  helpLinkPage: _react.PropTypes.string
	};

/***/ },
/* 1805 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BorrowingLayout = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _reactRedux = __webpack_require__(14);
	
	var _reactRouter = __webpack_require__(17);
	
	var _redux = __webpack_require__(18);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseDrawer = __webpack_require__(118);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _DrawerActions = __webpack_require__(379);
	
	var _DrawerActions2 = _interopRequireDefault(_DrawerActions);
	
	var _MessagesActions = __webpack_require__(558);
	
	var _MessagesActions2 = _interopRequireDefault(_MessagesActions);
	
	var _LibrarySelector = __webpack_require__(33);
	
	var _BorrowingSelector = __webpack_require__(300);
	
	var _AuthSelector = __webpack_require__(21);
	
	var _MyBorrowingSidebar = __webpack_require__(1835);
	
	var _MyBorrowingSidebar2 = _interopRequireDefault(_MyBorrowingSidebar);
	
	var _BorrowingSidebarToggleButton = __webpack_require__(1829);
	
	var _BorrowingSidebarToggleButton2 = _interopRequireDefault(_BorrowingSidebarToggleButton);
	
	var _AccountSwitcherContainer = __webpack_require__(635);
	
	var _AccountSwitcherContainer2 = _interopRequireDefault(_AccountSwitcherContainer);
	
	var _HoldsSelector = __webpack_require__(127);
	
	var _BorrowingOptIn = __webpack_require__(1809);
	
	var _BorrowingOptIn2 = _interopRequireDefault(_BorrowingOptIn);
	
	__webpack_require__(2512);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getActiveSection = function getActiveSection(path) {
	  var ctrl = path.split('/')[2];
	  if (['checkedout', 'holds', 'fines', 'recentlyreturned', 'interlibraryloans', 'accountmessages'].includes(ctrl)) {
	    return ctrl;
	  }
	
	  return 'other';
	};
	
	var BorrowingLayout = exports.BorrowingLayout = function (_BcReactComponent) {
	  _inherits(BorrowingLayout, _BcReactComponent);
	
	  function BorrowingLayout() {
	    _classCallCheck(this, BorrowingLayout);
	
	    return _possibleConstructorReturn(this, (BorrowingLayout.__proto__ || Object.getPrototypeOf(BorrowingLayout)).apply(this, arguments));
	  }
	
	  _createClass(BorrowingLayout, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var accountId = this.props.account.get('id');
	      this.props.messagesActions.fetchMessages({ accountId: accountId });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          account = _props.account,
	          drawerActions = _props.drawerActions,
	          checkoutSummary = _props.checkoutSummary,
	          holdsSummary = _props.holdsSummary,
	          totalFines = _props.totalFines,
	          totalBorrowingHistory = _props.totalBorrowingHistory,
	          messages = _props.messages,
	          drawer = _props.drawer,
	          library = _props.library,
	          ILSQuotas = _props.ILSQuotas,
	          accountsByLibraryId = _props.accountsByLibraryId,
	          illSummary = _props.illSummary,
	          location = _props.router.location;
	
	
	      var active = getActiveSection(location.pathname);
	
	      return _react2.default.createElement(
	        _baseDrawer.Layout,
	        { open: drawer.get('open'), containerClass: 'cp-borrowing-layout' },
	        _react2.default.createElement(_BorrowingOptIn2.default, { location: location }),
	        _react2.default.createElement(
	          _baseDrawer.Sidebar,
	          { sidebarClass: 'borrowing-widget-sidebar', drawerActions: drawerActions },
	          _react2.default.createElement(_MyBorrowingSidebar2.default, {
	            account: account,
	            drawer: drawer,
	            location: location,
	            activeSection: active,
	            libraryName: library.get('fullName', ''),
	            linkableLibraries: library.get('linkableLibraries', _immutable2.default.List()),
	            holdsSummary: holdsSummary,
	            checkoutSummary: checkoutSummary,
	            accountsByLibraryId: accountsByLibraryId,
	            totalFines: totalFines,
	            totalBorrowingHistory: totalBorrowingHistory,
	            drawerActions: drawerActions,
	            ILSQuotas: ILSQuotas,
	            messages: messages,
	            isRecentlyReturnedEnabled: library.get('recentlyReturned'),
	            isIllRequestsEnabled: library.get('illRequests'),
	            illSummary: illSummary,
	            isAccountMessagesEnabled: library.get('accountMessages'),
	            isRemainingHoldsEnabled: library.get('remainingHolds'),
	            showCardExpiryDate: library.get('cardExpiryDate') })
	        ),
	        _react2.default.createElement(
	          _baseDrawer.MainContent,
	          { mainClass: 'borrowing-content' },
	          _react2.default.createElement(_BorrowingSidebarToggleButton2.default, { drawerActions: drawerActions }),
	          _react2.default.createElement(
	            'span',
	            { className: 'top-accout-swticher' },
	            _react2.default.createElement(_AccountSwitcherContainer2.default, null)
	          ),
	          children
	        )
	      );
	    }
	  }]);
	
	  return BorrowingLayout;
	}(_baseBcReactComponent2.default);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    drawer: state.get('drawer'),
	    checkoutSummary: (0, _BorrowingSelector.getSummary)(state, 'checkedout'),
	    holdsSummary: (0, _BorrowingSelector.getSummary)(state, 'holds'),
	    totalFines: (0, _BorrowingSelector.getSummary)(state, 'fines').get('totalFines', 0),
	    totalBorrowingHistory: (0, _BorrowingSelector.getBorrowingHistorySummary)(state),
	    illSummary: (0, _BorrowingSelector.getSummary)(state, 'interlibraryLoans'),
	    messages: state.getIn(['entities', 'messages']),
	    account: (0, _AuthSelector.currentAccountSelector)(state),
	    library: (0, _LibrarySelector.currentLibrarySelector)(state),
	    accountsByLibraryId: (0, _AuthSelector.getAccountsByLibraryId)(state),
	    ILSQuotas: (0, _HoldsSelector.getILSQuotas)(state)
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    drawerActions: (0, _redux.bindActionCreators)(_DrawerActions2.default, dispatch),
	    messagesActions: (0, _redux.bindActionCreators)(_MessagesActions2.default, dispatch)
	  };
	};
	
	BorrowingLayout.propTypes = {
	  account: _bcPropTypes.accountShape,
	  drawer: _reactImmutableProptypes2.default.mapContains({
	    open: _react.PropTypes.bool
	  }).isRequired,
	  checkoutSummary: _reactImmutableProptypes2.default.mapContains({
	    nextDue: _reactImmutableProptypes2.default.mapContains({
	      date: _react.PropTypes.string,
	      status: _react.PropTypes.string
	    }),
	    status: _reactImmutableProptypes2.default.map
	  }),
	  holdsSummary: _reactImmutableProptypes2.default.mapContains({
	    status: _reactImmutableProptypes2.default.map
	  }),
	  totalFines: _react.PropTypes.number.isRequired,
	  totalBorrowingHistory: _react.PropTypes.number,
	  messages: _reactImmutableProptypes2.default.map.isRequired,
	  ILSQuotas: _reactImmutableProptypes2.default.map,
	  drawerActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node]).isRequired,
	  library: _bcPropTypes.libraryShape,
	  router: _reactRouter.routerShape,
	  accountsByLibraryId: _reactImmutableProptypes2.default.mapOf(_bcPropTypes.accountShape),
	  messagesActions: _react.PropTypes.objectOf(_react.PropTypes.func)
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(BorrowingLayout);

/***/ },
/* 1806 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BorrowingLayout = __webpack_require__(1805);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BorrowingLayout).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1807 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = BorrowingList;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function BorrowingList(_ref) {
	  var children = _ref.children;
	
	  return _react2.default.createElement(
	    "div",
	    { className: "cp-borrowing-list" },
	    children
	  );
	}
	
	BorrowingList.propTypes = {
	  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node]).isRequired
	};

/***/ },
/* 1808 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = BorrowingOptIn;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PropTypes = __webpack_require__(90);
	
	var _OptInContainer = __webpack_require__(637);
	
	var _OptInContainer2 = _interopRequireDefault(_OptInContainer);
	
	var _FeatureFlagContainer = __webpack_require__(147);
	
	var _FeatureFlagContainer2 = _interopRequireDefault(_FeatureFlagContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function BorrowingOptIn(_ref) {
	  var location = _ref.location;
	
	  var renderOptIn = function renderOptIn() {
	    return _react2.default.createElement(_OptInContainer2.default, {
	      optedIn: true,
	      bundleName: 'nerf_borrowing',
	      allowDismiss: false,
	      showAdditionalMessage: true,
	      location: location });
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'cp-borrowing-opt-in' },
	    _react2.default.createElement(
	      _FeatureFlagContainer2.default,
	      null,
	      function (flags) {
	        return flags.get('nerfBorrowing') ? null : renderOptIn();
	      }
	    )
	  );
	}
	
	BorrowingOptIn.propTypes = {
	  location: _PropTypes.locationShape
	};

/***/ },
/* 1809 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BorrowingOptIn = __webpack_require__(1808);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BorrowingOptIn).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1810 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = BorrowingQuota;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _bcPropTypes = __webpack_require__(5);
	
	__webpack_require__(2513);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function BorrowingQuota(_ref) {
	  var quota = _ref.quota;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'cp-borrowing-quota' },
	    _react2.default.createElement(
	      'div',
	      { className: 'name' },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'digital_service_type_' + quota.get('type', '').toLowerCase() })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'remaining' },
	      _react2.default.createElement(_reactIntl.FormattedMessage, {
	        id: 'borrowing_quota_count',
	        values: {
	          remaining: quota.get('total', 0) - quota.get('remaining', 0),
	          total: quota.get('total', 0)
	        } })
	    )
	  );
	}
	
	BorrowingQuota.propTypes = {
	  quota: _bcPropTypes.borrowingQuotaShape
	};

/***/ },
/* 1811 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BorrowingQuota = __webpack_require__(1810);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BorrowingQuota).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1812 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = BorrowingQuotas;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _BorrowingQuota = __webpack_require__(1811);
	
	var _BorrowingQuota2 = _interopRequireDefault(_BorrowingQuota);
	
	__webpack_require__(2514);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function BorrowingQuotas(_ref) {
	  var title = _ref.title,
	      quotas = _ref.quotas;
	
	  var renderedQutoas = quotas.filter(function (quota) {
	    return quota.get('type') !== 'ILS';
	  }).map(function (quota) {
	    return _react2.default.createElement(_BorrowingQuota2.default, { quota: quota });
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'cp-borrowing-quotas' },
	    _react2.default.createElement(
	      'h2',
	      null,
	      title
	    ),
	    renderedQutoas
	  );
	}
	
	BorrowingQuotas.propTypes = {
	  title: _react.PropTypes.element,
	  quotas: _reactImmutableProptypes2.default.listOf(_bcPropTypes.borrowingQuotaShape)
	};

/***/ },
/* 1813 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = BorrowingStatus;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRouter = __webpack_require__(17);
	
	__webpack_require__(2515);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * BorrowingStatus is a component that is used for
	 * encapsulating common styles for the statuses
	 */
	
	function BorrowingStatus(_ref) {
	  var children = _ref.children,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      currentSection = _ref.currentSection,
	      to = _ref.to;
	
	  var classes = (0, _classnames2.default)('cp-borrowing-status', 'list-group-item', className, currentSection ? 'current' : 'stale-state');
	  if (currentSection) {
	    return _react2.default.createElement(
	      'div',
	      { className: classes },
	      children
	    );
	  }
	
	  return _react2.default.createElement(
	    _reactRouter.Link,
	    { to: to, className: classes },
	    children
	  );
	}
	
	BorrowingStatus.propTypes = {
	  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node]).isRequired,
	  className: _react.PropTypes.string,
	  to: _react.PropTypes.string,
	  currentSection: _react.PropTypes.bool
	};

/***/ },
/* 1814 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = BorrowingStatusIcon;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(2516);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function BorrowingStatusIcon(_ref) {
	  var className = _ref.className,
	      status = _ref.status,
	      icon = _ref.icon,
	      withBackground = _ref.withBackground,
	      renderLabel = _ref.renderLabel;
	
	  var normalizedStatus = status && status.toLowerCase();
	  var classNames = (0, _classnames2.default)(className, 'cp-borrowing-status-icon', normalizedStatus, { 'with-background': withBackground });
	
	  return _react2.default.createElement(
	    'div',
	    { className: classNames },
	    icon,
	    renderLabel && _react2.default.createElement(
	      'span',
	      { className: 'status-name' },
	      renderLabel()
	    )
	  );
	}
	
	BorrowingStatusIcon.propTypes = {
	  className: _react.PropTypes.string,
	  status: _react.PropTypes.string,
	  icon: _react.PropTypes.node,
	  withBackground: _react.PropTypes.bool,
	  renderLabel: _react.PropTypes.func
	};

/***/ },
/* 1815 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = BorrowingTitle;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	__webpack_require__(2517);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function BorrowingTitle(_ref) {
	  var headingKey = _ref.headingKey,
	      taglineKey = _ref.taglineKey;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'cp-borrowing-title' },
	    _react2.default.createElement(
	      _reactIntl.FormattedMessage,
	      { id: headingKey },
	      function (message) {
	        return _react2.default.createElement(
	          'h1',
	          { className: 'page-heading' },
	          message
	        );
	      }
	    ),
	    taglineKey && _react2.default.createElement(
	      _reactIntl.FormattedMessage,
	      { id: taglineKey },
	      function (message) {
	        return _react2.default.createElement(
	          'p',
	          { className: 'tagline' },
	          message
	        );
	      }
	    )
	  );
	}
	
	BorrowingTitle.propTypes = {
	  headingKey: _react.PropTypes.string.isRequired,
	  taglineKey: _react.PropTypes.string
	};

/***/ },
/* 1816 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BorrowingTitle = __webpack_require__(1815);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BorrowingTitle).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1817 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _sortDropdown = __webpack_require__(372);
	
	var _sortDropdown2 = _interopRequireDefault(_sortDropdown);
	
	var _print = __webpack_require__(120);
	
	var _UtilityBar = __webpack_require__(609);
	
	var _UtilityBar2 = _interopRequireDefault(_UtilityBar);
	
	var _pagination = __webpack_require__(92);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _bcPropTypes = __webpack_require__(5);
	
	__webpack_require__(2518);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BorrowingUtilityBar = function (_BCReactComponent) {
	  _inherits(BorrowingUtilityBar, _BCReactComponent);
	
	  function BorrowingUtilityBar() {
	    _classCallCheck(this, BorrowingUtilityBar);
	
	    return _possibleConstructorReturn(this, (BorrowingUtilityBar.__proto__ || Object.getPrototypeOf(BorrowingUtilityBar)).apply(this, arguments));
	  }
	
	  _createClass(BorrowingUtilityBar, [{
	    key: 'renderBottomRow',
	    value: function renderBottomRow() {
	      var _props = this.props,
	          pagination = _props.pagination,
	          sortOptions = _props.sortOptions,
	          printURL = _props.printURL,
	          isFetching = _props.isFetching;
	
	
	      if (pagination || sortOptions) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'bottom-row' },
	          sortOptions && _react2.default.createElement(_sortDropdown2.default, { options: sortOptions }),
	          _react2.default.createElement(
	            'div',
	            null,
	            pagination && _react2.default.createElement(_pagination2.default, {
	              autoFocus: true,
	              isFetching: isFetching || false,
	              page: pagination.get('page'),
	              limit: pagination.get('limit'),
	              count: pagination.get('count'),
	              pages: pagination.get('pages') }),
	            printURL && _react2.default.createElement(_print.PrintButton, { url: printURL })
	          )
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderSortRow',
	    value: function renderSortRow() {
	      var sortOptions = this.props.sortOptions;
	
	      return sortOptions && _react2.default.createElement(
	        'div',
	        { className: 'sort-row visible-sm visible-xs' },
	        _react2.default.createElement(_sortDropdown2.default, { options: sortOptions })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var className = (0, _classnames2.default)('cp-borrowing-utility-bar', this.props.className);
	      return _react2.default.createElement(
	        _UtilityBar2.default,
	        { className: className },
	        _react2.default.createElement(
	          'div',
	          { className: 'top-row' },
	          this.props.title
	        ),
	        this.renderSortRow(),
	        this.renderBottomRow()
	      );
	    }
	  }]);
	
	  return BorrowingUtilityBar;
	}(_baseBcReactComponent2.default);
	
	exports.default = BorrowingUtilityBar;
	
	
	BorrowingUtilityBar.propTypes = {
	  isFetching: _react.PropTypes.bool,
	  sortOptions: _reactImmutableProptypes2.default.list,
	  pagination: _reactImmutableProptypes2.default.map,
	  title: _bcPropTypes.childrenShape,
	  renderPagination: _react.PropTypes.func,
	  printURL: _react.PropTypes.string,
	  className: _react.PropTypes.string
	};

/***/ },
/* 1818 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = BorrowingUtilityBarTitle;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(2519);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getMessageKeyForTitle = function getMessageKeyForTitle(status) {
	  if (status) {
	    return 'borrowing_item_count_' + status.toLowerCase();
	  }
	
	  return 'borrowing_item_count_all';
	};
	
	var getTitle = function getTitle(status, count, appendColon) {
	  var key = getMessageKeyForTitle(status);
	
	  if (appendColon) {
	    return _react2.default.createElement(
	      _reactIntl.FormattedMessage,
	      { id: key, values: { count: count } },
	      function (title) {
	        return _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'title_with_colon', values: { title: title } });
	      }
	    );
	  }
	
	  return _react2.default.createElement(_reactIntl.FormattedMessage, { id: key, values: { count: count } });
	};
	
	function BorrowingUtilityBarTitle(_ref) {
	  var status = _ref.status,
	      statusIcon = _ref.statusIcon,
	      count = _ref.count,
	      appendColon = _ref.appendColon;
	
	  var classNames = (0, _classnames2.default)('cp-borrowing-utility-bar-title', status ? status.toLowerCase() : '');
	
	  return _react2.default.createElement(
	    'span',
	    { className: classNames },
	    statusIcon ? _react2.default.createElement(
	      'div',
	      { className: 'status-icon-wrapper' },
	      statusIcon
	    ) : null,
	    _react2.default.createElement(
	      'h2',
	      null,
	      getTitle(status, count, appendColon)
	    )
	  );
	}
	
	BorrowingUtilityBarTitle.propTypes = {
	  status: _react.PropTypes.string,
	  statusIcon: _react.PropTypes.element,
	  count: _react.PropTypes.number,
	  appendColon: _react.PropTypes.bool
	};
	
	BorrowingUtilityBarTitle.defaultProps = {
	  appendColon: false
	};

/***/ },
/* 1819 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DollarAmount = function DollarAmount(_ref) {
	  var amount = _ref.amount;
	  return _react2.default.createElement(
	    'span',
	    { className: 'cp-dollar-amount' },
	    _react2.default.createElement(_reactIntl.FormattedMessage, {
	      id: 'dollar_amount',
	      values: {
	        amount: _react2.default.createElement(_reactIntl.FormattedNumber, { value: amount, minimumFractionDigits: 2, maximumFractionDigits: 2 })
	      } })
	  );
	};
	
	DollarAmount.propTypes = {
	  amount: _react.PropTypes.number
	};
	
	exports.default = DollarAmount;

/***/ },
/* 1820 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = MaterialTypeFilterLinks;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _MaterialTypeLink = __webpack_require__(1822);
	
	var _MaterialTypeLink2 = _interopRequireDefault(_MaterialTypeLink);
	
	__webpack_require__(2520);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function MaterialTypeFilterLinks(_ref) {
	  var materialTypeCounts = _ref.materialTypeCounts;
	
	  return _react2.default.createElement(
	    'span',
	    { className: 'cp-material-type-filter-links' },
	    _react2.default.createElement(
	      _MaterialTypeLink2.default,
	      { materialType: undefined },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'filter_material_type_all' })
	    ),
	    materialTypeCounts.map(function (count, materialType) {
	      return _react2.default.createElement(
	        'span',
	        { key: 'material-type-' + materialType },
	        _react2.default.createElement(
	          'span',
	          { className: 'material-type-divder' },
	          '|'
	        ),
	        _react2.default.createElement(_MaterialTypeLink2.default, { count: count, materialType: materialType })
	      );
	    }).toArray()
	  );
	}
	
	MaterialTypeFilterLinks.propTypes = {
	  materialTypeCounts: _reactImmutableProptypes2.default.map
	};

/***/ },
/* 1821 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MaterialTypeLink = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(17);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(2521);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MaterialTypeLink = exports.MaterialTypeLink = function (_BcReactComponent) {
	  _inherits(MaterialTypeLink, _BcReactComponent);
	
	  function MaterialTypeLink() {
	    _classCallCheck(this, MaterialTypeLink);
	
	    return _possibleConstructorReturn(this, (MaterialTypeLink.__proto__ || Object.getPrototypeOf(MaterialTypeLink)).apply(this, arguments));
	  }
	
	  _createClass(MaterialTypeLink, [{
	    key: 'getLinkURL',
	    value: function getLinkURL() {
	      var _props = this.props,
	          router = _props.router,
	          materialType = _props.materialType;
	
	      return {
	        pathname: router.location.pathname,
	        query: _extends({}, router.location.query, {
	          materialType: materialType,
	          page: 1
	        })
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          count = _props2.count,
	          router = _props2.router,
	          materialType = _props2.materialType;
	
	      var currentMaterialType = router.location.query.materialType;
	      var classnames = (0, _classnames2.default)('cp-material-type-link', {
	        active: materialType === currentMaterialType || !materialType && !currentMaterialType
	      });
	      return _react2.default.createElement(
	        _reactRouter.Link,
	        { className: classnames, to: this.getLinkURL() },
	        _react2.default.createElement(_reactIntl.FormattedMessage, {
	          id: 'filter_material_type_' + (materialType || 'all').toLowerCase(),
	          values: { count: count } })
	      );
	    }
	  }]);
	
	  return MaterialTypeLink;
	}(_baseBcReactComponent2.default);
	
	MaterialTypeLink.PropTypes = {
	  count: _react.PropTypes.number,
	  materialType: _react.PropTypes.string
	};
	
	exports.default = (0, _reactRouter.withRouter)(MaterialTypeLink);

/***/ },
/* 1822 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _MaterialTypeLink = __webpack_require__(1821);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MaterialTypeLink).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1823 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = AccountExpiryWarning;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _moment = __webpack_require__(9);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _ShortFormattedDate = __webpack_require__(60);
	
	var _ShortFormattedDate2 = _interopRequireDefault(_ShortFormattedDate);
	
	__webpack_require__(2522);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var accountExpiresSoon = function accountExpiresSoon(expiryDate) {
	  var sixtyDaysFromNow = (0, _moment2.default)().add('days', 60);
	  return (0, _moment2.default)(expiryDate).isBefore(sixtyDaysFromNow);
	};
	
	function AccountExpiryWarning(_ref) {
	  var expiryDate = _ref.expiryDate;
	
	  return expiryDate && accountExpiresSoon(expiryDate) && _react2.default.createElement(
	    'a',
	    { className: 'cp-account-expiry-warning list-group-item', href: '/account' },
	    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'label_renew_card_by' }),
	    ' ',
	    _react2.default.createElement(_ShortFormattedDate2.default, { value: expiryDate })
	  ) || null;
	}
	
	AccountExpiryWarning.propTypes = {
	  expiryDate: _react.PropTypes.string
	};

/***/ },
/* 1824 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AccountExpiryWarning = __webpack_require__(1823);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AccountExpiryWarning).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1825 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AccountSwitcher = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _reactRouter = __webpack_require__(17);
	
	var _PropTypes = __webpack_require__(90);
	
	var _PropTypes2 = _interopRequireDefault(_PropTypes);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	var _baseDropdown = __webpack_require__(37);
	
	var _baseButtons = __webpack_require__(12);
	
	var _sharedLibraryLogo = __webpack_require__(546);
	
	var _sharedLibraryLogo2 = _interopRequireDefault(_sharedLibraryLogo);
	
	__webpack_require__(2523);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AccountSwitcher = exports.AccountSwitcher = function (_BcReactComponent) {
	  _inherits(AccountSwitcher, _BcReactComponent);
	
	  function AccountSwitcher() {
	    _classCallCheck(this, AccountSwitcher);
	
	    return _possibleConstructorReturn(this, (AccountSwitcher.__proto__ || Object.getPrototypeOf(AccountSwitcher)).apply(this, arguments));
	  }
	
	  _createClass(AccountSwitcher, [{
	    key: 'getLinkForLibrary',
	    value: function getLinkForLibrary(library) {
	      var location = this.props.location;
	
	      return '' + library.get('baseUrl') + location.pathname + location.search;
	    }
	  }, {
	    key: 'renderLibraryLogo',
	    value: function renderLibraryLogo(library) {
	      return _react2.default.createElement(_sharedLibraryLogo2.default, {
	        key: 'logo-' + library.get('siteId'),
	        siteId: library.get('siteId'),
	        imageName: 'account_linking_image',
	        small: true,
	        circled: true,
	        baseUrl: this.context.coreCdnHost || '' });
	    }
	  }, {
	    key: 'renderLibraryLogos',
	    value: function renderLibraryLogos() {
	      var _this2 = this;
	
	      return this.props.linkedLibrariesById.map(function (library) {
	        return _this2.renderLibraryLogo(library);
	      }).toArray();
	    }
	  }, {
	    key: 'renderLibraryLink',
	    value: function renderLibraryLink(library) {
	      return _react2.default.createElement(
	        'a',
	        { className: 'library-link', href: this.getLinkForLibrary(library) },
	        this.renderLibraryLogo(library),
	        library.get('longName')
	      );
	    }
	  }, {
	    key: 'renderLibraryLinks',
	    value: function renderLibraryLinks() {
	      var _this3 = this;
	
	      return this.props.linkedLibrariesById.map(function (library) {
	        return _react2.default.createElement(
	          'li',
	          { key: 'library-link-' + library.get('siteId') },
	          _this3.renderLibraryLink(library)
	        );
	      }).toArray();
	    }
	  }, {
	    key: 'renderTriggerButtonContents',
	    value: function renderTriggerButtonContents() {
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement(
	          'span',
	          { className: 'trigger-text', 'aria-hidden': 'true' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'switch_account' })
	        ),
	        _react2.default.createElement(
	          _baseScreenReaderMessage2.default,
	          null,
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'switch_account' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'library-logos' },
	          this.renderLibraryLogos()
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.props.linkedLibrariesById.isEmpty()) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'cp-account-switcher' },
	          _react2.default.createElement(
	            _baseDropdown.Dropdown,
	            {
	              className: '',
	              disableMobile: true,
	              ButtonTag: _baseButtons.TextButton,
	              selected: this.renderTriggerButtonContents() },
	            this.renderLibraryLinks()
	          )
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return AccountSwitcher;
	}(_baseBcReactComponent2.default);
	
	AccountSwitcher.propTypes = {
	  linkedLibrariesById: _reactImmutableProptypes2.default.mapOf(_bcPropTypes.siteShape),
	  location: _react.PropTypes.shape(_PropTypes2.default)
	};
	
	exports.default = (0, _reactRouter.withRouter)(AccountSwitcher);

/***/ },
/* 1826 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AccountSwitcher = __webpack_require__(1825);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AccountSwitcher).default;
	  }
	});
	Object.defineProperty(exports, 'AccountSwitcher', {
	  enumerable: true,
	  get: function get() {
	    return _AccountSwitcher.AccountSwitcher;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1827 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = AllSidebarLink;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseIcons = __webpack_require__(10);
	
	var _StatusSidebarLink = __webpack_require__(385);
	
	var _StatusSidebarLink2 = _interopRequireDefault(_StatusSidebarLink);
	
	__webpack_require__(2524);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AllSidebarLink(_ref) {
	  var to = _ref.to,
	      selected = _ref.selected;
	
	  return _react2.default.createElement(_StatusSidebarLink2.default, {
	    className: 'cp-all-sidebar-link',
	    selected: selected,
	    status: 'all',
	    icon: _react2.default.createElement(
	      'div',
	      { className: 'all-icon' },
	      _react2.default.createElement(_baseIcons.List, null)
	    ),
	    statusText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'all_items' }),
	    to: to });
	}
	
	AllSidebarLink.propTypes = {
	  to: _react.PropTypes.string,
	  selected: _react.PropTypes.bool
	};

/***/ },
/* 1828 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseIcons = __webpack_require__(10);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	var _baseDrawer = __webpack_require__(118);
	
	__webpack_require__(2525);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BorrowingSidebarToggleButton = function BorrowingSidebarToggleButton(_ref) {
	  var drawerActions = _ref.drawerActions;
	  return _react2.default.createElement(_baseDrawer.StickyToggleButton, {
	    className: 'cp-borrowing-sidebar-toggle-button',
	    drawerActions: drawerActions,
	    renderCompact: function renderCompact() {
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement(_baseIcons.Chevron.DoubleRight, null),
	        _react2.default.createElement(
	          _baseScreenReaderMessage2.default,
	          null,
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'section_title_my_borrowing' })
	        )
	      );
	    },
	    renderFull: function renderFull() {
	      return _react2.default.createElement(
	        'span',
	        { className: 'full-content' },
	        _react2.default.createElement(_baseIcons.Chevron.DoubleRight, null),
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'section_title_my_borrowing' })
	      );
	    } });
	};
	
	exports.default = BorrowingSidebarToggleButton;
	
	
	BorrowingSidebarToggleButton.propTypes = {
	  drawerActions: _react.PropTypes.objectOf(_react.PropTypes.func)
	};

/***/ },
/* 1829 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BorrowingSidebarToggleButton = __webpack_require__(1828);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BorrowingSidebarToggleButton).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1830 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _Panel = __webpack_require__(601);
	
	var _Panel2 = _interopRequireDefault(_Panel);
	
	var _LinkableLibrary = __webpack_require__(1833);
	
	var _LinkableLibrary2 = _interopRequireDefault(_LinkableLibrary);
	
	__webpack_require__(2526);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LinkableLibrariesPanel = function (_BcReactComponent) {
	  _inherits(LinkableLibrariesPanel, _BcReactComponent);
	
	  function LinkableLibrariesPanel() {
	    _classCallCheck(this, LinkableLibrariesPanel);
	
	    return _possibleConstructorReturn(this, (LinkableLibrariesPanel.__proto__ || Object.getPrototypeOf(LinkableLibrariesPanel)).apply(this, arguments));
	  }
	
	  _createClass(LinkableLibrariesPanel, [{
	    key: 'hasLinkedAccount',
	    value: function hasLinkedAccount(library) {
	      return this.props.accountsByLibraryId.has(library.get('libraryId'));
	    }
	  }, {
	    key: 'renderLinkableLibraries',
	    value: function renderLinkableLibraries() {
	      var _this2 = this;
	
	      return this.props.linkableLibraries.map(function (library) {
	        return _react2.default.createElement(_LinkableLibrary2.default, {
	          key: 'linkable-library-' + library.get('libraryId'),
	          withoutLinks: _this2.context.mobileApp,
	          library: library,
	          linked: _this2.hasLinkedAccount(library) });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _Panel2.default,
	        { className: 'cp-linkable-libraries-panel' },
	        _react2.default.createElement(
	          'h3',
	          null,
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'connected_accounts' })
	        ),
	        _react2.default.createElement(
	          'ul',
	          { className: 'libraries' },
	          this.renderLinkableLibraries()
	        )
	      );
	    }
	  }]);
	
	  return LinkableLibrariesPanel;
	}(_baseBcReactComponent2.default);
	
	exports.default = LinkableLibrariesPanel;
	
	
	LinkableLibrariesPanel.propTypes = {
	  accountsByLibraryId: _reactImmutableProptypes2.default.mapOf(_bcPropTypes.accountShape),
	  linkableLibraries: _reactImmutableProptypes2.default.listOf(_bcPropTypes.siteShape)
	};
	
	LinkableLibrariesPanel.contextTypes = {
	  mobileApp: _react.PropTypes.bool
	};

/***/ },
/* 1831 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _LinkableLibrariesPanel = __webpack_require__(1830);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_LinkableLibrariesPanel).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1832 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(17);
	
	var _PropTypes = __webpack_require__(90);
	
	var _PropTypes2 = _interopRequireDefault(_PropTypes);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _sharedLibraryLogo = __webpack_require__(546);
	
	var _sharedLibraryLogo2 = _interopRequireDefault(_sharedLibraryLogo);
	
	__webpack_require__(2527);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LinkableLibrary = function (_BcReactComponent) {
	  _inherits(LinkableLibrary, _BcReactComponent);
	
	  function LinkableLibrary() {
	    _classCallCheck(this, LinkableLibrary);
	
	    return _possibleConstructorReturn(this, (LinkableLibrary.__proto__ || Object.getPrototypeOf(LinkableLibrary)).apply(this, arguments));
	  }
	
	  _createClass(LinkableLibrary, [{
	    key: 'getUrlForLink',
	    value: function getUrlForLink() {
	      var _props = this.props,
	          location = _props.location,
	          library = _props.library,
	          linked = _props.linked;
	
	      return linked ? '' + library.get('baseUrl') + location.pathname + location.search : '/library_accounts';
	    }
	  }, {
	    key: 'getImageBaseUrl',
	    value: function getImageBaseUrl() {
	      var coreCdnHost = this.context.coreCdnHost;
	
	      return coreCdnHost || '';
	    }
	  }, {
	    key: 'renderStatusText',
	    value: function renderStatusText() {
	      return this.props.linked ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'account_linking_status_linked' }) : _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'account_linking_status_unlinked' });
	    }
	  }, {
	    key: 'renderLinkText',
	    value: function renderLinkText() {
	      return this.props.linked ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'view_account' }) : _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'connect_card' });
	    }
	  }, {
	    key: 'renderLink',
	    value: function renderLink() {
	      return !this.props.withoutLinks && _react2.default.createElement(
	        'a',
	        { href: this.getUrlForLink() },
	        this.renderLinkText()
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'li',
	        { className: 'cp-linkable-library' },
	        _react2.default.createElement(_sharedLibraryLogo2.default, {
	          siteId: this.props.library.get('siteId'),
	          imageName: 'account_linking_image',
	          small: true,
	          circled: true,
	          baseUrl: this.getImageBaseUrl() }),
	        _react2.default.createElement(
	          'div',
	          { className: 'library-info' },
	          _react2.default.createElement(
	            'div',
	            { className: 'library-name' },
	            this.props.library.get('longName')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'status' },
	            this.renderStatusText()
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            this.renderLink()
	          )
	        )
	      );
	    }
	  }]);
	
	  return LinkableLibrary;
	}(_baseBcReactComponent2.default);
	
	LinkableLibrary.propTypes = {
	  library: _bcPropTypes.siteShape,
	  linked: _react.PropTypes.bool,
	  location: _react.PropTypes.shape(_PropTypes2.default),
	  withoutLinks: _react.PropTypes.bool
	};
	
	LinkableLibrary.contextTypes = {
	  coreCdnHost: _react.PropTypes.string
	};
	
	exports.default = (0, _reactRouter.withRouter)(LinkableLibrary);

/***/ },
/* 1833 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _LinkableLibrary = __webpack_require__(1832);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_LinkableLibrary).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1834 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _PropTypes = __webpack_require__(90);
	
	var _baseDrawer = __webpack_require__(118);
	
	var Drawer = _interopRequireWildcard(_baseDrawer);
	
	var _baseButtons = __webpack_require__(12);
	
	var _baseIcons = __webpack_require__(10);
	
	var _CheckedOutStatus = __webpack_require__(1664);
	
	var _CheckedOutStatus2 = _interopRequireDefault(_CheckedOutStatus);
	
	var _HoldsStatus = __webpack_require__(1743);
	
	var _HoldsStatus2 = _interopRequireDefault(_HoldsStatus);
	
	var _FinesStatus = __webpack_require__(1695);
	
	var _FinesStatus2 = _interopRequireDefault(_FinesStatus);
	
	var _RecentlyReturnedStatus = __webpack_require__(1792);
	
	var _RecentlyReturnedStatus2 = _interopRequireDefault(_RecentlyReturnedStatus);
	
	var _AccountMessagesStatus = __webpack_require__(1642);
	
	var _AccountMessagesStatus2 = _interopRequireDefault(_AccountMessagesStatus);
	
	var _SingleClickHoldsPanelContainer = __webpack_require__(2090);
	
	var _SingleClickHoldsPanelContainer2 = _interopRequireDefault(_SingleClickHoldsPanelContainer);
	
	var _AccountExpiryWarning = __webpack_require__(1824);
	
	var _AccountExpiryWarning2 = _interopRequireDefault(_AccountExpiryWarning);
	
	var _LinkableLibrariesPanel = __webpack_require__(1831);
	
	var _LinkableLibrariesPanel2 = _interopRequireDefault(_LinkableLibrariesPanel);
	
	var _InterlibraryLoansStatus = __webpack_require__(1771);
	
	var _InterlibraryLoansStatus2 = _interopRequireDefault(_InterlibraryLoansStatus);
	
	__webpack_require__(2528);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */
	
	
	var MyBorrowingSidebar = function (_BcReactComponent) {
	  _inherits(MyBorrowingSidebar, _BcReactComponent);
	
	  function MyBorrowingSidebar() {
	    _classCallCheck(this, MyBorrowingSidebar);
	
	    return _possibleConstructorReturn(this, (MyBorrowingSidebar.__proto__ || Object.getPrototypeOf(MyBorrowingSidebar)).apply(this, arguments));
	  }
	
	  _createClass(MyBorrowingSidebar, [{
	    key: 'isActive',
	    value: function isActive(section) {
	      return this.props.activeSection === section;
	    }
	  }, {
	    key: 'showLinkableLibraries',
	    value: function showLinkableLibraries() {
	      var _this2 = this;
	
	      var unlinkedLibraries = this.props.linkableLibraries.filter(function (library) {
	        return !_this2.props.accountsByLibraryId.has(library.get('libraryId'));
	      });
	
	      return unlinkedLibraries.size > 0;
	    }
	  }, {
	    key: 'renderSingleClickHoldsWidget',
	    value: function renderSingleClickHoldsWidget() {
	      if (this.props.activeSection === 'holds') {
	        return _react2.default.createElement(_SingleClickHoldsPanelContainer2.default, null);
	      }
	    }
	  }, {
	    key: 'renderTitle',
	    value: function renderTitle() {
	      var libraryName = this.props.libraryName;
	
	      return _react2.default.createElement(
	        'h3',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'my-borrowing-at' },
	          _react2.default.createElement(_baseIcons.Card, null),
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'section_title_my_borrowing' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'lib-at' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, {
	            id: 'at_library',
	            values: { library: _react2.default.createElement(
	                'strong',
	                null,
	                libraryName
	              ) } })
	        )
	      );
	    }
	  }, {
	    key: 'pathnameHasChanged',
	    value: function pathnameHasChanged(prevProps) {
	      return this.props.location.pathname !== prevProps.location.pathname;
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var _props = this.props,
	          drawer = _props.drawer,
	          drawerActions = _props.drawerActions;
	
	
	      if (drawer.get('open') && this.pathnameHasChanged(prevProps)) {
	        drawerActions.toggle();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          account = _props2.account,
	          isRecentlyReturnedEnabled = _props2.isRecentlyReturnedEnabled,
	          isAccountMessagesEnabled = _props2.isAccountMessagesEnabled,
	          isRemainingHoldsEnabled = _props2.isRemainingHoldsEnabled,
	          isIllRequestsEnabled = _props2.isIllRequestsEnabled,
	          showCardExpiryDate = _props2.showCardExpiryDate;
	
	      var expiryDate = account.get('expiryDate');
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-my-borrowing-sidebar' },
	        _react2.default.createElement(
	          'div',
	          { className: 'panel panel-default' },
	          _react2.default.createElement(
	            'div',
	            { className: 'close-drawer' },
	            _react2.default.createElement(
	              Drawer.Toggle,
	              { drawerActions: this.props.drawerActions },
	              _react2.default.createElement(
	                _baseButtons.TextButton,
	                { handleClick: this.props.drawerActions.toggle },
	                _react2.default.createElement('span', { className: 'icon icon-left-open' }),
	                'Close'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'panel-heading' },
	            this.renderTitle()
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'panel-body' },
	            _react2.default.createElement(
	              'div',
	              { className: 'list-group' },
	              showCardExpiryDate && _react2.default.createElement(_AccountExpiryWarning2.default, { expiryDate: expiryDate }),
	              _react2.default.createElement(_HoldsStatus2.default, {
	                summary: this.props.holdsSummary,
	                currentSection: this.isActive('holds'),
	                ILSQuotas: this.props.ILSQuotas,
	                isRemainingHoldsEnabled: isRemainingHoldsEnabled }),
	              _react2.default.createElement(_CheckedOutStatus2.default, {
	                summary: this.props.checkoutSummary,
	                currentSection: this.isActive('checkedout') }),
	              isRecentlyReturnedEnabled && _react2.default.createElement(_RecentlyReturnedStatus2.default, {
	                totalBorrowingHistory: this.props.totalBorrowingHistory,
	                currentSection: this.props.activeSection === 'recentlyreturned' }),
	              _react2.default.createElement(_FinesStatus2.default, {
	                totalFines: this.props.totalFines,
	                currentSection: this.props.activeSection === 'fines' }),
	              isAccountMessagesEnabled && _react2.default.createElement(_AccountMessagesStatus2.default, {
	                messages: this.props.messages,
	                currentSection: this.props.activeSection === 'accountmessages' }),
	              isIllRequestsEnabled && _react2.default.createElement(_InterlibraryLoansStatus2.default, {
	                summary: this.props.illSummary,
	                currentSection: this.props.activeSection === 'interlibraryloans' })
	            )
	          ),
	          this.renderSingleClickHoldsWidget(),
	          this.showLinkableLibraries() && _react2.default.createElement(_LinkableLibrariesPanel2.default, {
	            accountsByLibraryId: this.props.accountsByLibraryId,
	            linkableLibraries: this.props.linkableLibraries })
	        )
	      );
	    }
	  }]);
	
	  return MyBorrowingSidebar;
	}(_baseBcReactComponent2.default);
	
	MyBorrowingSidebar.propTypes = {
	  account: _bcPropTypes.accountShape,
	  activeSection: _react.PropTypes.string.isRequired,
	  libraryName: _react.PropTypes.string,
	  linkableLibraries: _reactImmutableProptypes2.default.listOf(_bcPropTypes.siteShape),
	  checkoutSummary: _reactImmutableProptypes2.default.mapContains({
	    nextDue: _reactImmutableProptypes2.default.mapContains({
	      date: _react.PropTypes.string,
	      status: _react.PropTypes.string
	    })
	  }),
	  totalFines: _react.PropTypes.number.isRequired,
	  totalBorrowingHistory: _react.PropTypes.number.isRequired,
	  ILSQuotas: _reactImmutableProptypes2.default.map,
	  messages: _reactImmutableProptypes2.default.map.isRequired,
	  status: _reactImmutableProptypes2.default.mapOf(_react.PropTypes.number, _react.PropTypes.string),
	  accountsByLibraryId: _reactImmutableProptypes2.default.mapOf(_bcPropTypes.accountShape),
	  drawerActions: _react.PropTypes.objectOf(_react.PropTypes.func),
	  isRecentlyReturnedEnabled: _react.PropTypes.bool,
	  isAccountMessagesEnabled: _react.PropTypes.bool,
	  isRemainingHoldsEnabled: _react.PropTypes.bool,
	  isIllRequestsEnabled: _react.PropTypes.bool,
	  illSummary: _react.PropTypes.map,
	  showCardExpiryDate: _react.PropTypes.bool,
	  location: _PropTypes.locationShape,
	  drawer: _reactImmutableProptypes2.default.mapContains({
	    open: _react.PropTypes.bool
	  })
	};
	
	exports.default = MyBorrowingSidebar;

/***/ },
/* 1835 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _MyBorrowingSidebar = __webpack_require__(1834);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MyBorrowingSidebar).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1836 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = SidebarCompactTitle;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _baseIcons = __webpack_require__(10);
	
	__webpack_require__(2529);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function SidebarCompactTitle(_ref) {
	  var title = _ref.title,
	      count = _ref.count,
	      selected = _ref.selected;
	
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)('cp-sidebar-compact-title', { selected: selected }) },
	    title,
	    _react2.default.createElement(
	      'div',
	      { className: 'count-wrapper' },
	      _react2.default.createElement(
	        'div',
	        { className: 'count' },
	        count
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'icon-wrapper' },
	        _react2.default.createElement(_baseIcons.Angle.Right, null)
	      )
	    )
	  );
	}
	
	SidebarCompactTitle.propTypes = {
	  title: _react.PropTypes.node,
	  count: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node, _react.PropTypes.number, _react.PropTypes.string]),
	  selected: _react.PropTypes.bool
	};

/***/ },
/* 1837 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = SidebarLink;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(17);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _bcPropTypes = __webpack_require__(5);
	
	__webpack_require__(2530);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function SidebarLink(_ref) {
	  var className = _ref.className,
	      selected = _ref.selected,
	      to = _ref.to,
	      children = _ref.children;
	
	  var classNames = (0, _classnames2.default)('cp-sidebar-link', { selected: selected }, className);
	  return _react2.default.createElement(
	    _reactRouter.Link,
	    { to: to, className: classNames },
	    children
	  );
	}
	
	SidebarLink.propTypes = {
	  className: _react.PropTypes.string,
	  selected: _react.PropTypes.bool,
	  to: _react.PropTypes.string,
	  children: _bcPropTypes.childrenShape
	};

/***/ },
/* 1838 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseButtons = __webpack_require__(12);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _HelpLinkContainer = __webpack_require__(126);
	
	var _HelpLinkContainer2 = _interopRequireDefault(_HelpLinkContainer);
	
	var _BranchDropdown = __webpack_require__(587);
	
	var _BranchDropdown2 = _interopRequireDefault(_BranchDropdown);
	
	__webpack_require__(2531);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SingleClickHoldsForm = function (_BcReactComponent) {
	  _inherits(SingleClickHoldsForm, _BcReactComponent);
	
	  function SingleClickHoldsForm(props) {
	    _classCallCheck(this, SingleClickHoldsForm);
	
	    var _this = _possibleConstructorReturn(this, (SingleClickHoldsForm.__proto__ || Object.getPrototypeOf(SingleClickHoldsForm)).call(this, props));
	
	    _this.state = {
	      selectedBranchCode: _this.props.branchCode || props.branches.first().get('code')
	    };
	
	    _this.bindAll('handleSelect', 'handleSubmit');
	    return _this;
	  }
	
	  _createClass(SingleClickHoldsForm, [{
	    key: 'handleSelect',
	    value: function handleSelect(branchCode) {
	      this.setState({
	        selectedBranchCode: branchCode
	      });
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit() {
	      this.props.handleSubmit({
	        branchCode: this.state.selectedBranchCode
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'form',
	        { className: 'cp-single-click-holds-form' },
	        _react2.default.createElement(_HelpLinkContainer2.default, { page: '010singleclick' }),
	        _react2.default.createElement(
	          'h3',
	          null,
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'single_click_holds_form_title' })
	        ),
	        _react2.default.createElement(
	          _BranchDropdown2.default,
	          {
	            branches: this.props.branches,
	            handleSelect: this.handleSelect,
	            selectedBranchCode: this.state.selectedBranchCode },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'single_click_holds_location_label' })
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'small description' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'single_click_holds_location_description' })
	        ),
	        _react2.default.createElement(
	          _baseButtons.PrimaryButton,
	          { className: 'save-button', handleClick: this.handleSubmit },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_save' })
	        ),
	        _react2.default.createElement(
	          _baseButtons.TextButton,
	          { className: 'cancel-button', handleClick: this.props.handleCancel },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_cancel' })
	        )
	      );
	    }
	  }]);
	
	  return SingleClickHoldsForm;
	}(_baseBcReactComponent2.default);
	
	exports.default = SingleClickHoldsForm;
	
	
	SingleClickHoldsForm.propTypes = {
	  branches: _reactImmutableProptypes2.default.listOf(_bcPropTypes.branchShape),
	  branchCode: _react.PropTypes.string,
	  handleCancel: _react.PropTypes.func,
	  handleSubmit: _react.PropTypes.func
	};

/***/ },
/* 1839 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SingleClickHoldsForm = __webpack_require__(1838);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SingleClickHoldsForm).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1840 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _SingleClickHoldsStatusButton = __webpack_require__(1843);
	
	var _SingleClickHoldsStatusButton2 = _interopRequireDefault(_SingleClickHoldsStatusButton);
	
	var _Panel = __webpack_require__(601);
	
	var _Panel2 = _interopRequireDefault(_Panel);
	
	var _HelpLinkContainer = __webpack_require__(126);
	
	var _HelpLinkContainer2 = _interopRequireDefault(_HelpLinkContainer);
	
	var _SingleClickHoldsForm = __webpack_require__(1839);
	
	var _SingleClickHoldsForm2 = _interopRequireDefault(_SingleClickHoldsForm);
	
	__webpack_require__(2532);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SingleClickHoldsPanel = function (_BcReactComponent) {
	  _inherits(SingleClickHoldsPanel, _BcReactComponent);
	
	  function SingleClickHoldsPanel(props) {
	    _classCallCheck(this, SingleClickHoldsPanel);
	
	    var _this = _possibleConstructorReturn(this, (SingleClickHoldsPanel.__proto__ || Object.getPrototypeOf(SingleClickHoldsPanel)).call(this, props));
	
	    _this.state = {
	      showForm: false
	    };
	    _this.bindAll('handleStatusButtonClick', 'handleCancel', 'handleSubmit');
	    return _this;
	  }
	
	  _createClass(SingleClickHoldsPanel, [{
	    key: 'renderButton',
	    value: function renderButton() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'button-wrapper' },
	        _react2.default.createElement(_SingleClickHoldsStatusButton2.default, {
	          singleClickHoldsEnabled: this.props.singleClickHoldsSettings.get('enabled', false),
	          handleClick: this.handleStatusButtonClick }),
	        _react2.default.createElement(_HelpLinkContainer2.default, { page: '010singleclick' })
	      );
	    }
	  }, {
	    key: 'getCurrentBranchName',
	    value: function getCurrentBranchName() {
	      var currentBranchCode = this.props.singleClickHoldsSettings.get('branchId');
	      var branch = this.props.branches.find(function (b) {
	        return b.get('code') === currentBranchCode;
	      });
	      return branch ? branch.get('name') : '';
	    }
	  }, {
	    key: 'renderForm',
	    value: function renderForm() {
	      return _react2.default.createElement(_SingleClickHoldsForm2.default, {
	        handleCancel: this.handleCancel,
	        handleSubmit: this.handleSubmit,
	        branchCode: this.props.singleClickHoldsSettings.get('branchId'),
	        branches: this.props.branches });
	    }
	  }, {
	    key: 'renderCurrentLocation',
	    value: function renderCurrentLocation() {
	      var branch = _react2.default.createElement(
	        'div',
	        { className: 'branch-name' },
	        this.getCurrentBranchName()
	      );
	      return _react2.default.createElement(
	        'div',
	        { className: 'current-branch' },
	        _react2.default.createElement(_reactIntl.FormattedMessage, {
	          id: 'single_click_holds_current_location',
	          values: { branch: branch } })
	      );
	    }
	  }, {
	    key: 'renderButtonAndLocation',
	    value: function renderButtonAndLocation() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.renderButton(),
	        this.props.singleClickHoldsSettings.get('enabled', false) && this.renderCurrentLocation()
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _Panel2.default,
	        { className: 'cp-single-click-holds-panel' },
	        this.state.showForm ? this.renderForm() : this.renderButtonAndLocation()
	      );
	    }
	  }, {
	    key: 'handleStatusButtonClick',
	    value: function handleStatusButtonClick() {
	      this.setState({ showForm: true });
	    }
	  }, {
	    key: 'handleCancel',
	    value: function handleCancel() {
	      this.setState({ showForm: false });
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(_ref) {
	      var branchCode = _ref.branchCode;
	
	      this.props.accountActions.updateSingleClickHoldsSettings(this.props.accountId, true, branchCode);
	
	      this.setState({ showForm: false });
	    }
	  }]);
	
	  return SingleClickHoldsPanel;
	}(_baseBcReactComponent2.default);
	
	exports.default = SingleClickHoldsPanel;
	
	
	SingleClickHoldsPanel.propTypes = {
	  accountId: _react.PropTypes.number,
	  singleClickHoldsEnabled: _react.PropTypes.bool,
	  branches: _reactImmutableProptypes2.default.listOf(_bcPropTypes.branchShape),
	  singleClickHoldsSettings: _bcPropTypes.singleClickHoldsSettingsShape,
	  accountActions: _react.PropTypes.objectOf(_react.PropTypes.func)
	};

/***/ },
/* 1841 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SingleClickHoldsPanel = __webpack_require__(1840);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SingleClickHoldsPanel).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1842 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = SingleClickHoldsStatusButton;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseButtons = __webpack_require__(12);
	
	__webpack_require__(2533);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getStatus = function getStatus(enabled) {
	  return enabled ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'on' }) : _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'off' });
	};
	
	function SingleClickHoldsStatusButton(_ref) {
	  var singleClickHoldsEnabled = _ref.singleClickHoldsEnabled,
	      handleClick = _ref.handleClick;
	
	  var status = _react2.default.createElement(
	    'span',
	    { className: 'status' },
	    getStatus(singleClickHoldsEnabled)
	  );
	
	  return _react2.default.createElement(
	    _baseButtons.TextButton,
	    { className: 'cp-single-click-holds-status-button', handleClick: handleClick },
	    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'single_click_holds_status', values: { status: status } })
	  );
	}
	
	SingleClickHoldsStatusButton.propTypes = {
	  singleClickHoldsEnabled: _react.PropTypes.bool,
	  handleClick: _react.PropTypes.func
	};

/***/ },
/* 1843 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SingleClickHoldsStatusButton = __webpack_require__(1842);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SingleClickHoldsStatusButton).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1844 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = StatusSidebarLink;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _SidebarLink = __webpack_require__(573);
	
	var _SidebarLink2 = _interopRequireDefault(_SidebarLink);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsBorrowing = __webpack_require__(230);
	
	var _bcPropTypes = __webpack_require__(5);
	
	__webpack_require__(2534);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var renderCount = function renderCount(count) {
	  return _react2.default.createElement(
	    'span',
	    { className: 'status-count' },
	    count
	  );
	};
	
	function StatusSidebarLink(_ref) {
	  var className = _ref.className,
	      status = _ref.status,
	      icon = _ref.icon,
	      to = _ref.to,
	      statusText = _ref.statusText,
	      selected = _ref.selected,
	      summary = _ref.summary,
	      children = _ref.children;
	
	  var counts = (0, _utilsBorrowing.getCountsByStatusFromSummary)(summary || _immutable2.default.Map());
	  var moreThanOneStatus = counts.size > 1;
	  var formattedStatus = status.toLowerCase();
	
	  return _react2.default.createElement(
	    _SidebarLink2.default,
	    {
	      className: (0, _classnames2.default)('cp-status-sidebar-link', className, formattedStatus),
	      selected: selected,
	      to: to },
	    icon,
	    _react2.default.createElement(
	      'div',
	      { className: 'contents' },
	      _react2.default.createElement(
	        'div',
	        { className: 'status-wrapper' },
	        statusText,
	        _react2.default.createElement(
	          'span',
	          { className: 'extra-content' },
	          children
	        )
	      ),
	      moreThanOneStatus && renderCount(counts.get(status))
	    )
	  );
	}
	
	StatusSidebarLink.propTypes = {
	  className: _react.PropTypes.string,
	  to: _react.PropTypes.string,
	  icon: _react.PropTypes.node,
	  statusText: _react.PropTypes.node,
	  children: _bcPropTypes.childrenShape,
	  status: _react.PropTypes.string,
	  selected: _react.PropTypes.bool,
	  summary: _reactImmutableProptypes2.default.map
	};

/***/ },
/* 1845 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FeedbackBox = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _FeedbackContactLinks = __webpack_require__(1846);
	
	var _FeedbackContactLinks2 = _interopRequireDefault(_FeedbackContactLinks);
	
	var _FeedbackForm = __webpack_require__(1847);
	
	var _FeedbackForm2 = _interopRequireDefault(_FeedbackForm);
	
	var _sharedMessages = __webpack_require__(64);
	
	var _MessagingContainer = __webpack_require__(68);
	
	var _MessagingContainer2 = _interopRequireDefault(_MessagingContainer);
	
	var _baseButtons = __webpack_require__(12);
	
	__webpack_require__(2535);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  categories: _reactImmutableProptypes2.default.listOf(_react.PropTypes.string),
	  contactLinks: _reactImmutableProptypes2.default.mapOf(_react.PropTypes.string, _react.PropTypes.string),
	  selectedCategory: _react.PropTypes.string,
	  isSubmitting: _react.PropTypes.bool,
	  expanded: _react.PropTypes.bool,
	  intl: _reactIntl.intlShape,
	  actions: _react.PropTypes.objectOf(_react.PropTypes.func),
	  suggestForPurchaseEnabled: _react.PropTypes.bool
	};
	
	var FeedbackBox = exports.FeedbackBox = function (_BcReactComponent) {
	  _inherits(FeedbackBox, _BcReactComponent);
	
	  function FeedbackBox() {
	    _classCallCheck(this, FeedbackBox);
	
	    return _possibleConstructorReturn(this, (FeedbackBox.__proto__ || Object.getPrototypeOf(FeedbackBox)).apply(this, arguments));
	  }
	
	  _createClass(FeedbackBox, [{
	    key: 'renderCloseButton',
	    value: function renderCloseButton(visibleOnMobile) {
	      return _react2.default.createElement(
	        _baseButtons.TextButton,
	        { type: 'button', className: 'close ' + (visibleOnMobile ? 'visible-xs' : 'hidden-xs'), 'aria-label': this.props.intl.formatMessage({ id: 'button_close' }), handleClick: this.props.actions.collapseFeedbackBox },
	        _react2.default.createElement(
	          'span',
	          { 'aria-hidden': 'true' },
	          '\xD7'
	        )
	      );
	    }
	  }, {
	    key: 'renderCollapsed',
	    value: function renderCollapsed() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'feedback-teaser clearfix' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-12 col-sm-8' },
	          _react2.default.createElement(
	            'h3',
	            null,
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'feedback_heading' })
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'feedback_prompt' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-12 col-sm-4' },
	          _react2.default.createElement(
	            _baseButtons.PrimaryButton,
	            { className: 'feedback-expand-btn', handleClick: this.props.actions.expandFeedbackBox },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'feedback_submit_feedback_btn' })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderExpanded',
	    value: function renderExpanded() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'feedback-expanded clearfix' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-12 col-sm-7' },
	          this.renderCloseButton(true),
	          _react2.default.createElement(
	            'h3',
	            null,
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'feedback_heading' })
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'feedback_review_notice' })
	          ),
	          _react2.default.createElement(_FeedbackForm2.default, {
	            categories: this.props.categories,
	            selectedCategory: this.props.selectedCategory,
	            isSubmitting: this.props.isSubmitting,
	            actions: this.props.actions,
	            suggestForPurchaseEnabled: this.props.suggestForPurchaseEnabled })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-12 col-sm-5' },
	          this.renderCloseButton(false),
	          _react2.default.createElement(_FeedbackContactLinks2.default, { contactLinks: this.props.contactLinks })
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-feedback-box' },
	        _react2.default.createElement(
	          'div',
	          { className: 'feedback-wrapper' },
	          this.props.expanded ? this.renderExpanded() : this.renderCollapsed(),
	          _react2.default.createElement(
	            _MessagingContainer2.default,
	            { id: 'userFeedback' },
	            function (messageOptions) {
	              return _react2.default.createElement(_sharedMessages.Generic, messageOptions);
	            }
	          )
	        )
	      );
	    }
	  }]);
	
	  return FeedbackBox;
	}(_baseBcReactComponent2.default);
	
	FeedbackBox.propTypes = propTypes;
	
	exports.default = (0, _reactIntl.injectIntl)(FeedbackBox);

/***/ },
/* 1846 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = FeedbackContactLinks;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _reactIntl = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function FeedbackContactLinks(_ref) {
	  var contactLinks = _ref.contactLinks;
	
	  if (contactLinks.isEmpty()) {
	    return null;
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'cp-feedback-contact-links' },
	    _react2.default.createElement(
	      'h3',
	      null,
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'feedback_contact_lib_heading' })
	    ),
	    contactLinks.entrySeq().map(function (_ref2) {
	      var _ref3 = _slicedToArray(_ref2, 2),
	          localeKey = _ref3[0],
	          url = _ref3[1];
	
	      return _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'a',
	          { href: url },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: localeKey })
	        )
	      );
	    })
	  );
	}
	
	FeedbackContactLinks.propTypes = {
	  contactLinks: _reactImmutableProptypes2.default.mapOf(_react.PropTypes.string, _react.PropTypes.string)
	};
	
	FeedbackContactLinks.displayName = 'FeedbackContactLinks';

/***/ },
/* 1847 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FeedbackForm = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseDropdown = __webpack_require__(37);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	var _CommentableForm = __webpack_require__(1848);
	
	var _CommentableForm2 = _interopRequireDefault(_CommentableForm);
	
	var _SuggestForPurchaseForm = __webpack_require__(1849);
	
	var _SuggestForPurchaseForm2 = _interopRequireDefault(_SuggestForPurchaseForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  categories: _reactImmutableProptypes2.default.listOf(_react.PropTypes.string),
	  selectedCategory: _react.PropTypes.string,
	  isSubmitting: _react.PropTypes.bool,
	  intl: _reactIntl.intlShape,
	  suggestForPurchaseEnabled: _react.PropTypes.bool,
	  actions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired
	};
	
	var FeedbackForm = exports.FeedbackForm = function (_BcReactComponent) {
	  _inherits(FeedbackForm, _BcReactComponent);
	
	  function FeedbackForm(props) {
	    _classCallCheck(this, FeedbackForm);
	
	    var _this = _possibleConstructorReturn(this, (FeedbackForm.__proto__ || Object.getPrototypeOf(FeedbackForm)).call(this, props));
	
	    _this.bindAll('handleSubmit', 'handleMessageChange');
	    _this.state = {
	      messageText: ''
	    };
	    return _this;
	  }
	
	  _createClass(FeedbackForm, [{
	    key: 'getCategoryOptions',
	    value: function getCategoryOptions() {
	      var _this2 = this;
	
	      return this.props.categories.valueSeq().map(function (category) {
	        return {
	          label: _this2.props.intl.formatMessage({ id: 'feedback_cat_' + category }),
	          value: category
	        };
	      });
	    }
	  }, {
	    key: 'getSelectedCategoryLabel',
	    value: function getSelectedCategoryLabel() {
	      var localizationKey = this.props.selectedCategory || 'default';
	      return this.props.intl.formatMessage({ id: 'feedback_cat_' + localizationKey });
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(e) {
	      e.preventDefault();
	      this.props.actions.submitFeedback(_extends({
	        comment: this.state.messageText
	      }, FeedbackForm.getBrowserInformation(), {
	        category: this.props.selectedCategory,
	        optIn: false
	      }));
	    }
	  }, {
	    key: 'handleMessageChange',
	    value: function handleMessageChange(messageText) {
	      this.setState({ messageText: messageText });
	    }
	  }, {
	    key: 'renderFormFields',
	    value: function renderFormFields() {
	      switch (this.props.selectedCategory) {
	        case null:
	          return null;
	        case 'suggest_for_purchase':
	          {
	            if (this.props.suggestForPurchaseEnabled) {
	              return _react2.default.createElement(_SuggestForPurchaseForm2.default, null);
	            }
	            return _react2.default.createElement(_CommentableForm2.default, {
	              value: this.state.messageText,
	              selectedCategory: this.props.selectedCategory,
	              handleMessageChange: this.handleMessageChange });
	          }
	        default:
	          return _react2.default.createElement(_CommentableForm2.default, { value: this.state.messageText, handleMessageChange: this.handleMessageChange });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'form',
	        { className: 'cp-feedback-form', onSubmit: this.handleSubmit },
	        _react2.default.createElement(
	          'div',
	          { className: 'form-group' },
	          _react2.default.createElement(
	            _baseScreenReaderMessage2.default,
	            { id: 'feedback-category-label' },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'feedback_category_label' })
	          ),
	          _react2.default.createElement(_baseDropdown.Dropdown, {
	            handleSelect: this.props.actions.updateCategory,
	            labelledById: 'feedback-category-label',
	            options: this.getCategoryOptions(),
	            selected: this.getSelectedCategoryLabel() })
	        ),
	        this.renderFormFields()
	      );
	    }
	  }], [{
	    key: 'getBrowserInformation',
	    value: function getBrowserInformation() {
	      return {
	        screenResolution: window.screen.width + ' x ' + window.screen.height,
	        viewportSize: window.outerWidth + ' x ' + window.outerHeight,
	        referer: window.location.href,
	        userAgent: window.navigator.userAgent
	      };
	    }
	  }]);
	
	  return FeedbackForm;
	}(_baseBcReactComponent2.default);
	
	FeedbackForm.propTypes = propTypes;
	
	exports.default = (0, _reactIntl.injectIntl)(FeedbackForm);

/***/ },
/* 1848 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = CommentableForm;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseAccessibilityTextArea = __webpack_require__(117);
	
	var _baseAccessibilityTextArea2 = _interopRequireDefault(_baseAccessibilityTextArea);
	
	var _baseButtons = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CommentableForm(_ref) {
	  var value = _ref.value,
	      handleMessageChange = _ref.handleMessageChange,
	      selectedCategory = _ref.selectedCategory;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'form-group' },
	      _react2.default.createElement(
	        'label',
	        { id: 'feedback-message-label', htmlFor: 'feedback-message', className: 'sr-only' },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'feedback_comment_label' })
	      ),
	      _react2.default.createElement(_baseAccessibilityTextArea2.default, {
	        maxLength: 4000,
	        required: true,
	        value: value,
	        id: 'feedback-message',
	        labelledById: 'feedback-message-label',
	        handleChange: handleMessageChange,
	        handlePaste: handleMessageChange,
	        rows: '5',
	        cols: '60' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'text-right form-group' },
	      _react2.default.createElement(
	        _baseButtons.PrimaryButton,
	        { type: 'submit', disabled: selectedCategory === null },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_submit' })
	      )
	    )
	  );
	}
	
	CommentableForm.propTypes = {
	  selectedCategory: _react.PropTypes.string,
	  handleMessageChange: _react.PropTypes.func.isRequired,
	  value: _react.PropTypes.string
	};
	
	CommentableForm.displayName = 'CommentableForm';

/***/ },
/* 1849 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = SuggestForPurchaseForm;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function SuggestForPurchaseForm() {
	  return _react2.default.createElement(
	    'a',
	    { href: '/suggested_purchases' },
	    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'feedback_suggest_for_purchase_link' })
	  );
	}

/***/ },
/* 1850 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _iframeResizer = __webpack_require__(2790);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DocumentHeadContainer = __webpack_require__(52);
	
	var _DocumentHeadContainer2 = _interopRequireDefault(_DocumentHeadContainer);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // eslint-disable-line no-unused-vars
	
	
	var propTypes = {
	  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node]).isRequired
	};
	
	var WidgetLayout = function (_BcReactComponent) {
	  _inherits(WidgetLayout, _BcReactComponent);
	
	  function WidgetLayout() {
	    _classCallCheck(this, WidgetLayout);
	
	    return _possibleConstructorReturn(this, (WidgetLayout.__proto__ || Object.getPrototypeOf(WidgetLayout)).apply(this, arguments));
	  }
	
	  _createClass(WidgetLayout, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return { isWidget: true };
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      if ('parentIFrame' in window && this._root) {
	        // The setTimeout fixes race condition with iframe height calculation by removing it from the event loop
	        setTimeout(function () {
	          window.parentIFrame.autoResize(false);
	          window.parentIFrame.size(_this2._root.clientHeight);
	          window.parentIFrame.autoResize(true);
	        }, 0);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-widget-layout', ref: function ref(el) {
	            _this3._root = el;
	          } },
	        _react2.default.createElement(_DocumentHeadContainer2.default, null),
	        this.props.children
	      );
	    }
	  }]);
	
	  return WidgetLayout;
	}(_baseBcReactComponent2.default);
	
	exports.default = WidgetLayout;
	
	
	WidgetLayout.propTypes = propTypes;
	WidgetLayout.childContextTypes = {
	  isWidget: _react.PropTypes.bool
	};

/***/ },
/* 1851 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _WidgetLayout = __webpack_require__(1850);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_WidgetLayout).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1852 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ActiveFilterLockSwitch = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(17);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseToggleSwitch = __webpack_require__(1361);
	
	var _baseToggleSwitch2 = _interopRequireDefault(_baseToggleSwitch);
	
	var _baseIcons = __webpack_require__(10);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _updateSearchQuery = __webpack_require__(148);
	
	var _updateSearchQuery2 = _interopRequireDefault(_updateSearchQuery);
	
	__webpack_require__(2536);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ActiveFilterLockSwitch = exports.ActiveFilterLockSwitch = function (_BcReactComponent) {
	  _inherits(ActiveFilterLockSwitch, _BcReactComponent);
	
	  function ActiveFilterLockSwitch(props) {
	    _classCallCheck(this, ActiveFilterLockSwitch);
	
	    var _this = _possibleConstructorReturn(this, (ActiveFilterLockSwitch.__proto__ || Object.getPrototypeOf(ActiveFilterLockSwitch)).call(this, props));
	
	    _this.bindAll('handleToggleFilterLock');
	    return _this;
	  }
	
	  _createClass(ActiveFilterLockSwitch, [{
	    key: 'handleToggleFilterLock',
	    value: function handleToggleFilterLock() {
	      var _props = this.props,
	          router = _props.router,
	          location = _props.location,
	          active = _props.active,
	          activeFilters = _props.activeFilters,
	          searchType = _props.searchType;
	
	
	      var query = (0, _updateSearchQuery2.default)({
	        currentQuery: location.query,
	        activeFilters: activeFilters,
	        searchType: searchType,
	        locked: active ? undefined : 'true'
	      });
	
	      router.push(_extends({}, location, { query: query }));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var active = this.props.active;
	
	      return _react2.default.createElement(
	        _baseToggleSwitch2.default,
	        {
	          className: 'cp-active-filter-lock-switch',
	          active: active,
	          activeLocaleKey: 'active_filters_locked',
	          inactiveLocaleKey: 'active_filters_unlocked',
	          handleClick: this.handleToggleFilterLock },
	        _react2.default.createElement(_baseIcons.PushPin, { className: 'small' })
	      );
	    }
	  }]);
	
	  return ActiveFilterLockSwitch;
	}(_baseBcReactComponent2.default);
	
	ActiveFilterLockSwitch.displayName = 'ActiveFilterLockSwitch';
	ActiveFilterLockSwitch.propTypes = {
	  active: _react.PropTypes.bool.isRequired,
	  activeFilters: _reactImmutableProptypes2.default.map,
	  handleClick: _react.PropTypes.func.isRequired,
	  searchType: _react.PropTypes.string,
	  router: _reactRouter.routerShape
	};
	
	exports.default = (0, _reactRouter.withRouter)(ActiveFilterLockSwitch);

/***/ },
/* 1853 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ActiveFilterLockSwitch = __webpack_require__(1852);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ActiveFilterLockSwitch).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1854 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ActiveFilters = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _reactRouter = __webpack_require__(17);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsFilter = __webpack_require__(179);
	
	__webpack_require__(2537);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseButtons = __webpack_require__(12);
	
	var _getToggledFilter = __webpack_require__(643);
	
	var _getToggledFilter2 = _interopRequireDefault(_getToggledFilter);
	
	var _ActiveFilterLockSwitch = __webpack_require__(1853);
	
	var _ActiveFilterLockSwitch2 = _interopRequireDefault(_ActiveFilterLockSwitch);
	
	var _ActiveFilterToken = __webpack_require__(589);
	
	var _ActiveFilterToken2 = _interopRequireDefault(_ActiveFilterToken);
	
	var _updateSearchQuery = __webpack_require__(148);
	
	var _updateSearchQuery2 = _interopRequireDefault(_updateSearchQuery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ActiveFilters = exports.ActiveFilters = function (_BcReactComponent) {
	  _inherits(ActiveFilters, _BcReactComponent);
	
	  function ActiveFilters(props) {
	    _classCallCheck(this, ActiveFilters);
	
	    var _this = _possibleConstructorReturn(this, (ActiveFilters.__proto__ || Object.getPrototypeOf(ActiveFilters)).call(this, props));
	
	    _this.bindAll('renderActiveFilters', 'handleClearFilters', 'handleToggleFilter');
	    return _this;
	  }
	
	  _createClass(ActiveFilters, [{
	    key: 'handleClearFilters',
	    value: function handleClearFilters() {
	      var _props = this.props,
	          searchType = _props.searchType,
	          location = _props.location;
	
	      var query = (0, _updateSearchQuery2.default)({
	        currentQuery: location.query,
	        searchType: searchType,
	        pagination_page: undefined
	      });
	
	      this.props.router.push(_extends({}, location, { query: query }));
	    }
	  }, {
	    key: 'handleToggleFilter',
	    value: function handleToggleFilter(fieldId, currentFilter) {
	      var _props2 = this.props,
	          activeFilters = _props2.activeFilters,
	          location = _props2.location,
	          searchType = _props2.searchType;
	
	
	      var query = (0, _updateSearchQuery2.default)(_extends({
	        currentQuery: location.query,
	        activeFilters: activeFilters,
	        searchType: searchType,
	        pagination_page: undefined
	      }, (0, _getToggledFilter2.default)(fieldId, currentFilter, activeFilters)));
	
	      this.props.router.push(_extends({}, location, { query: query }));
	    }
	  }, {
	    key: 'renderClearFilter',
	    value: function renderClearFilter() {
	      if (!this.props.activeFilters.isEmpty()) {
	        return _react2.default.createElement(
	          _baseButtons.Button,
	          {
	            className: 'cp-filter-token clear-token',
	            handleClick: this.handleClearFilters },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'clear_filters' })
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderActiveFilters',
	    value: function renderActiveFilters(fieldId, filter) {
	      var normalizedId = fieldId === 'PRIMARY_LANGUAGE' ? 'LANGUAGE' : fieldId;
	      var filterLabel = (0, _utilsFilter.getLabel)(this.props.intl, normalizedId, filter.get('label') || filter.get('value'), this.props.singleBranch);
	
	      return _react2.default.createElement(_ActiveFilterToken2.default, {
	        handleToggleFilter: this.handleToggleFilter,
	        filter: filter,
	        fieldId: fieldId,
	        filterLabel: filterLabel });
	    }
	  }, {
	    key: 'renderActiveFields',
	    value: function renderActiveFields() {
	      var _this2 = this;
	
	      return this.props.activeFilters.entrySeq().map(function (_ref) {
	        var _ref2 = _slicedToArray(_ref, 2),
	            fieldId = _ref2[0],
	            filters = _ref2[1];
	
	        return filters ? filters.map(_this2.renderActiveFilters.bind(null, fieldId)) : null;
	      });
	    }
	  }, {
	    key: 'renderFilterControls',
	    value: function renderFilterControls() {
	      var _props3 = this.props,
	          activeFilters = _props3.activeFilters,
	          searchType = _props3.searchType,
	          locked = _props3.locked,
	          showLockSwitch = _props3.showLockSwitch;
	
	
	      return showLockSwitch && _react2.default.createElement(
	        'div',
	        { className: 'filter-controls' },
	        _react2.default.createElement(
	          _reactIntl.FormattedMessage,
	          { id: 'Search.activeFilters' },
	          function (message) {
	            return _react2.default.createElement(
	              'span',
	              { className: 'active-filter-label' },
	              message
	            );
	          }
	        ),
	        _react2.default.createElement(_ActiveFilterLockSwitch2.default, {
	          searchType: searchType,
	          active: locked,
	          activeFilters: activeFilters })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var activeFilterClass = (0, _classnames2.default)('cp-active-filter', 'clearfix', this.props.locked ? 'active' : '');
	      return _react2.default.createElement(
	        'div',
	        { className: activeFilterClass },
	        this.renderFilterControls(),
	        _react2.default.createElement(
	          'div',
	          { className: 'filter-tokens' },
	          this.renderActiveFields(),
	          this.renderClearFilter()
	        )
	      );
	    }
	  }]);
	
	  return ActiveFilters;
	}(_baseBcReactComponent2.default);
	
	ActiveFilters.propTypes = {
	  activeFilters: _reactImmutableProptypes2.default.map,
	  searchType: _react.PropTypes.string,
	  locked: _react.PropTypes.bool,
	  singleBranch: _react.PropTypes.bool,
	  intl: _reactIntl.intlShape,
	  router: _reactRouter.routerShape,
	  showLockSwitch: _react.PropTypes.bool
	};
	
	ActiveFilters.defaultProps = {
	  showLockSwitch: true
	};
	
	exports.default = (0, _reactIntl.injectIntl)((0, _reactRouter.withRouter)(ActiveFilters));

/***/ },
/* 1855 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseIcons = __webpack_require__(10);
	
	var _searchBar = __webpack_require__(544);
	
	var _searchBar2 = _interopRequireDefault(_searchBar);
	
	__webpack_require__(2539);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CatalogueSearchBar = function (_BcReactComponent) {
	  _inherits(CatalogueSearchBar, _BcReactComponent);
	
	  function CatalogueSearchBar() {
	    _classCallCheck(this, CatalogueSearchBar);
	
	    return _possibleConstructorReturn(this, (CatalogueSearchBar.__proto__ || Object.getPrototypeOf(CatalogueSearchBar)).apply(this, arguments));
	  }
	
	  _createClass(CatalogueSearchBar, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('cp-catalogue-search-bar', { locked: this.props.locked }) },
	        this.props.locked && _react2.default.createElement(_baseIcons.PushPin, { className: 'locked-icon' }),
	        _react2.default.createElement(_searchBar2.default, {
	          query: this.props.query,
	          handleSearch: this.props.handleSearch,
	          handleChange: this.props.handleChange,
	          isWrappedInForm: false })
	      );
	    }
	  }]);
	
	  return CatalogueSearchBar;
	}(_baseBcReactComponent2.default);
	
	exports.default = CatalogueSearchBar;
	
	
	CatalogueSearchBar.propTypes = {
	  query: _react.PropTypes.string,
	  locked: _react.PropTypes.bool,
	  handleSearch: _react.PropTypes.func,
	  handleChange: _react.PropTypes.func
	};

/***/ },
/* 1856 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CatalogueSearchBar = __webpack_require__(1855);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CatalogueSearchBar).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1857 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ChatWidgetButton;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseButtons = __webpack_require__(12);
	
	var _utilsBrowser = __webpack_require__(59);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ChatWidgetButton(_ref) {
	  var widget = _ref.widget;
	
	  var widgetSrc = '/widgets/chat_widget/' + widget;
	
	  return _react2.default.createElement(
	    _baseButtons.PrimaryButton,
	    {
	      className: 'cp-chat-widget-button ' + widget,
	      handleClick: function handleClick() {
	        return (0, _utilsBrowser.openPopUpWindow)({ url: widgetSrc, width: 300, height: 350 });
	      } },
	    _react2.default.createElement(
	      'span',
	      { 'aria-hidden': true },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'chat_widget_button_text' })
	    ),
	    _react2.default.createElement(
	      _baseScreenReaderMessage2.default,
	      null,
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ada_link_opens_new_window', values: { linkText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'chat_widget_button_text' }) } })
	    )
	  );
	}
	
	ChatWidgetButton.propTypes = {
	  widget: _react.PropTypes.string.isRequired
	};

/***/ },
/* 1858 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _baseIcons = __webpack_require__(10);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	var _DidNotFindServiceItem = __webpack_require__(1866);
	
	var _DidNotFindServiceItem2 = _interopRequireDefault(_DidNotFindServiceItem);
	
	var _DidNotFindResourceItem = __webpack_require__(1864);
	
	var _DidNotFindResourceItem2 = _interopRequireDefault(_DidNotFindResourceItem);
	
	__webpack_require__(2540);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DidNotFind = function (_BcReactComponent) {
	  _inherits(DidNotFind, _BcReactComponent);
	
	  function DidNotFind() {
	    _classCallCheck(this, DidNotFind);
	
	    return _possibleConstructorReturn(this, (DidNotFind.__proto__ || Object.getPrototypeOf(DidNotFind)).apply(this, arguments));
	  }
	
	  _createClass(DidNotFind, [{
	    key: 'renderDidNotFindResources',
	    value: function renderDidNotFindResources() {
	      var _props = this.props,
	          query = _props.query,
	          didNotFindOptions = _props.didNotFindOptions;
	
	
	      return didNotFindOptions.get('didNotFindResources').map(function (resource) {
	        return _react2.default.createElement(_DidNotFindResourceItem2.default, {
	          className: 'did-not-find-resource',
	          key: resource.get('resourceName'),
	          query: query,
	          resourceName: resource.get('resourceName'),
	          resourceDescription: resource.get('resourceDescription'),
	          resourceTags: resource.get('resourceTags'),
	          resourceLink: resource.get('resourceLink') });
	      });
	    }
	  }, {
	    key: 'renderDidNotFindServices',
	    value: function renderDidNotFindServices() {
	      var didNotFindOptions = this.props.didNotFindOptions;
	
	
	      return didNotFindOptions.get('didNotFindServices').map(function (service) {
	        return _react2.default.createElement(_DidNotFindServiceItem2.default, {
	          className: 'did-not-find-service',
	          key: service.get('id'),
	          serviceId: service.get('id'),
	          serviceName: service.get('localeKey'),
	          serviceLink: service.get('link') });
	      });
	    }
	  }, {
	    key: 'renderMoreResources',
	    value: function renderMoreResources() {
	      var didNotFindOptions = this.props.didNotFindOptions;
	
	
	      return didNotFindOptions.get('additionalResourcesLink') && _react2.default.createElement(
	        'a',
	        { className: 'did-not-find-additional-resources-link', href: '' + didNotFindOptions.get('additionalResourcesLink') },
	        _react2.default.createElement(
	          'span',
	          { 'aria-hidden': true },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'view_more_resources' }),
	          _react2.default.createElement(_baseIcons.Angle.Right, null)
	        ),
	        _react2.default.createElement(
	          _baseScreenReaderMessage2.default,
	          null,
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ada_opens_a_new_tab', values: { linkText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'view_more_resources' }) } })
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'did-not-find' },
	        _react2.default.createElement(
	          'div',
	          { className: 'did-not-find-resources' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'other_resources', tagName: 'h3' }),
	          this.renderDidNotFindResources(),
	          _react2.default.createElement(
	            'div',
	            { className: 'did-not-find-more-resources' },
	            this.renderMoreResources()
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'did-not-find-services' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'library_resources', tagName: 'h3' }),
	          this.renderDidNotFindServices()
	        )
	      );
	    }
	  }]);
	
	  return DidNotFind;
	}(_baseBcReactComponent2.default);
	
	exports.default = DidNotFind;
	
	
	DidNotFind.propTypes = {
	  query: _react.PropTypes.string,
	  didNotFindOptions: _reactImmutableProptypes2.default.map
	};

/***/ },
/* 1859 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _reactIntl = __webpack_require__(3);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _baseDropdown = __webpack_require__(37);
	
	var _utilsBrowser = __webpack_require__(59);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	var _ExternalSearchLink = __webpack_require__(287);
	
	var _ExternalSearchLink2 = _interopRequireDefault(_ExternalSearchLink);
	
	__webpack_require__(2541);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function injectQueryIntoUrl(query, url) {
	  return query && url ? url.replace(/{query}/gi, (0, _utilsBrowser.fixedEncodeURIComponent)(query)) : url;
	}
	
	var DidNotFindDropdown = function (_BcReactComponent) {
	  _inherits(DidNotFindDropdown, _BcReactComponent);
	
	  function DidNotFindDropdown() {
	    _classCallCheck(this, DidNotFindDropdown);
	
	    return _possibleConstructorReturn(this, (DidNotFindDropdown.__proto__ || Object.getPrototypeOf(DidNotFindDropdown)).apply(this, arguments));
	  }
	
	  _createClass(DidNotFindDropdown, [{
	    key: 'renderResourceLink',
	    value: function renderResourceLink(linkText, url) {
	      return _react2.default.createElement(
	        'a',
	        {
	          className: 'did-not-find-link',
	          href: injectQueryIntoUrl(this.props.query, url),
	          rel: 'noopener noreferrer',
	          target: '_blank' },
	        _react2.default.createElement(
	          'span',
	          { 'aria-hidden': true },
	          linkText
	        ),
	        _react2.default.createElement(
	          _baseScreenReaderMessage2.default,
	          null,
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ada_opens_a_new_tab', values: { linkText: linkText } })
	        )
	      );
	    }
	  }, {
	    key: 'renderExternalSearchLink',
	    value: function renderExternalSearchLink() {
	      var _props = this.props,
	          query = _props.query,
	          searchType = _props.searchType;
	
	
	      return _react2.default.createElement(
	        _baseDropdown.DropdownMenuItem,
	        { key: 'external-link-item' },
	        _react2.default.createElement(_ExternalSearchLink2.default, { query: query, searchType: searchType })
	      );
	    }
	  }, {
	    key: 'renderResourceLinksMenu',
	    value: function renderResourceLinksMenu() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          showExternalSearchLink = _props2.showExternalSearchLink,
	          searchType = _props2.searchType;
	
	
	      var resourceLinkMenuHeader = _react2.default.createElement(
	        _baseDropdown.DropdownMenuHeader,
	        { key: 'resource-link-menu-header' },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'more_resources' })
	      );
	
	      var resourceLinkMenuItems = this.props.didNotFindOptions.get('didNotFindResources').map(function (resource) {
	        return _react2.default.createElement(
	          _baseDropdown.DropdownMenuItem,
	          {
	            key: 'did-not-find-link-' + resource.get('resourceName').toLowerCase() },
	          _this2.renderResourceLink(resource.get('resourceName'), resource.get('resourceLink'))
	        );
	      });
	
	      var menuDivider = _react2.default.createElement(_baseDropdown.DropdownMenuDivider, { key: 'did-not-find-resource-links-divider' });
	
	      var externalSearchLink = showExternalSearchLink && searchType !== 'bl' ? [this.renderExternalSearchLink(), menuDivider] : null;
	
	      return [externalSearchLink, resourceLinkMenuHeader, resourceLinkMenuItems];
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-did-not-find-dropdown' },
	        _react2.default.createElement(
	          _baseDropdown.Dropdown,
	          {
	            selected: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'other_resources' }),
	            className: '' },
	          this.renderResourceLinksMenu()
	        )
	      );
	    }
	  }]);
	
	  return DidNotFindDropdown;
	}(_baseBcReactComponent2.default);
	
	exports.default = DidNotFindDropdown;
	
	
	DidNotFindDropdown.propTypes = {
	  query: _react.PropTypes.string,
	  searchType: _react.PropTypes.string,
	  didNotFindOptions: _reactImmutableProptypes2.default.map,
	  showExternalSearchLink: _react2.default.PropTypes.bool
	
	};

/***/ },
/* 1860 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DidNotFindDropdown = __webpack_require__(1859);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DidNotFindDropdown).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1861 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = DidNotFindExpandablePanel;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _baseIcons = __webpack_require__(10);
	
	var _DidNotFind = __webpack_require__(577);
	
	var _DidNotFind2 = _interopRequireDefault(_DidNotFind);
	
	var _ChatWidgetButton = __webpack_require__(576);
	
	var _ChatWidgetButton2 = _interopRequireDefault(_ChatWidgetButton);
	
	var _expandable = __webpack_require__(139);
	
	__webpack_require__(2542);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function renderTriggerContent() {
	  return _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'did_not_find_discover' });
	}
	
	function renderChatWidgetButton(chatWidgets) {
	  var enabledWidget = chatWidgets.findLastKey(function (widget) {
	    return widget.get('enabled');
	  });
	
	  if (enabledWidget) {
	    return _react2.default.createElement(
	      'span',
	      { className: 'did-not-find-collapible-chat-widget' },
	      _react2.default.createElement(_ChatWidgetButton2.default, { widget: enabledWidget })
	    );
	  }
	
	  return null;
	}
	
	function renderHeader(chatWidgets) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'did-not-find-heading-content' },
	    _react2.default.createElement(
	      'div',
	      { className: 'panel-title' },
	      _react2.default.createElement(_baseIcons.Flashlight, null),
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'did_not_find_heading' })
	    ),
	    renderChatWidgetButton(chatWidgets)
	  );
	}
	
	function DidNotFindExpandablePanel(_ref) {
	  var query = _ref.query,
	      didNotFindOptions = _ref.didNotFindOptions,
	      chatWidgets = _ref.chatWidgets;
	
	  return _react2.default.createElement(
	    _expandable.ExpandablePanel,
	    {
	      className: 'did-not-find-expandable-panel',
	      renderHeaderContent: function renderHeaderContent() {
	        return renderHeader(chatWidgets);
	      },
	      renderExpandButtonLabel: function renderExpandButtonLabel() {
	        return renderTriggerContent();
	      } },
	    _react2.default.createElement(_DidNotFind2.default, { query: query, didNotFindOptions: didNotFindOptions })
	  );
	}
	
	DidNotFindExpandablePanel.propTypes = {
	  query: _react.PropTypes.string,
	  didNotFindOptions: _reactImmutableProptypes2.default.map,
	  chatWidgets: _reactImmutableProptypes2.default.mapOf(_react.PropTypes.object)
	};

/***/ },
/* 1862 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DidNotFindExpandablePanel = __webpack_require__(1861);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DidNotFindExpandablePanel).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1863 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = DidNotFindResourceItem;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseIcons = __webpack_require__(10);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	__webpack_require__(2543);
	
	var _utilsBrowser = __webpack_require__(59);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var renderResourceTags = function renderResourceTags(resourceTags) {
	  return resourceTags.map(function (tag, index) {
	    return _react2.default.createElement(
	      'span',
	      null,
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: '' + tag }),
	      index < resourceTags.size - 1 ? ' | ' : ''
	    );
	  });
	};
	
	var injectQueryIntoUrl = function injectQueryIntoUrl(query, url) {
	  return query && url ? url.replace(/{query}/gi, (0, _utilsBrowser.fixedEncodeURIComponent)(query)) : url;
	};
	
	function DidNotFindResourceItem(_ref) {
	  var className = _ref.className,
	      query = _ref.query,
	      resourceName = _ref.resourceName,
	      resourceDescription = _ref.resourceDescription,
	      resourceTags = _ref.resourceTags,
	      resourceLink = _ref.resourceLink;
	
	  return _react2.default.createElement(
	    'li',
	    { className: 'resource-item ' + className },
	    resourceName && _react2.default.createElement(
	      'h5',
	      { className: 'resource-name' },
	      resourceName
	    ),
	    resourceDescription && _react2.default.createElement(
	      'div',
	      {
	        className: 'resource-description' },
	      resourceDescription
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'resource-tags' },
	      renderResourceTags(resourceTags)
	    ),
	    resourceLink && _react2.default.createElement(
	      'a',
	      {
	        className: 'did-not-find-resource-link-' + resourceName,
	        href: injectQueryIntoUrl(query, resourceLink) },
	      _react2.default.createElement(
	        'span',
	        { 'aria-hidden': true },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'search_link_text' }),
	        _react2.default.createElement(_baseIcons.Angle.Right, null)
	      ),
	      _react2.default.createElement(
	        _baseScreenReaderMessage2.default,
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ada_opens_a_new_tab', values: { linkText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'search_link_text' }) } })
	      )
	    )
	  );
	}
	
	DidNotFindResourceItem.propTypes = {
	  className: _react.PropTypes.string,
	  query: _react.PropTypes.string,
	  resourceName: _react.PropTypes.string,
	  resourceDescription: _react.PropTypes.node,
	  resourceTags: _reactImmutableProptypes2.default.list,
	  resourceLink: _react.PropTypes.string
	};

/***/ },
/* 1864 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DidNotFindResourceItem = __webpack_require__(1863);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DidNotFindResourceItem).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1865 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = DidNotFindServiceItem;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseIcons = __webpack_require__(10);
	
	__webpack_require__(2544);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapIcon = function mapIcon(service) {
	  switch (service) {
	    case 's4p':
	      return _react2.default.createElement(_baseIcons.Cart, null);
	    case 'bookAnAppt':
	      return _react2.default.createElement(_baseIcons.CalendarFull, null);
	    case 'contactUs':
	      return _react2.default.createElement(_baseIcons.Envelope, null);
	    case 'interLibraryLoans':
	      return _react2.default.createElement(_baseIcons.InterlibraryLoans, null);
	    case 'askAQuestion':
	      return _react2.default.createElement(_baseIcons.QuestionMarkSquared, null);
	    default:
	      return _react2.default.createElement('noop', null);
	  }
	};
	
	function DidNotFindServiceItem(_ref) {
	  var className = _ref.className,
	      serviceId = _ref.serviceId,
	      serviceName = _ref.serviceName,
	      serviceLink = _ref.serviceLink;
	
	  return _react2.default.createElement(
	    'li',
	    { className: 'service-item ' + className },
	    mapIcon(serviceId),
	    _react2.default.createElement(
	      'a',
	      { className: 'did-not-find-service-link-' + serviceId, href: serviceLink },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: '' + serviceName }),
	      _react2.default.createElement(_baseIcons.Angle.Right, null)
	    )
	  );
	}
	
	DidNotFindServiceItem.propTypes = {
	  className: _react.PropTypes.string,
	  serviceId: _react.PropTypes.string,
	  serviceName: _react.PropTypes.string,
	  serviceLink: _react.PropTypes.string
	};

/***/ },
/* 1866 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DidNotFindServiceItem = __webpack_require__(1865);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DidNotFindServiceItem).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1867 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EmptySearchResult = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseButtons = __webpack_require__(12);
	
	var _utilsAnalytics = __webpack_require__(142);
	
	var _analyticsEventComposers = __webpack_require__(174);
	
	var _sharedEmbeddedChatWidget = __webpack_require__(1481);
	
	var _sharedEmbeddedChatWidget2 = _interopRequireDefault(_sharedEmbeddedChatWidget);
	
	var _baseIcons = __webpack_require__(10);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	var _WorkflowConstants = __webpack_require__(74);
	
	var _SearchTitle = __webpack_require__(580);
	
	var _SearchTitle2 = _interopRequireDefault(_SearchTitle);
	
	var _MobileSearchBox = __webpack_require__(578);
	
	var _MobileSearchBox2 = _interopRequireDefault(_MobileSearchBox);
	
	var _DidNotFind = __webpack_require__(577);
	
	var _DidNotFind2 = _interopRequireDefault(_DidNotFind);
	
	var _DidYouMean = __webpack_require__(386);
	
	var _DidYouMean2 = _interopRequireDefault(_DidYouMean);
	
	var _ExternalSearchLink = __webpack_require__(287);
	
	var _ExternalSearchLink2 = _interopRequireDefault(_ExternalSearchLink);
	
	var _ChatWidgetButton = __webpack_require__(576);
	
	var _ChatWidgetButton2 = _interopRequireDefault(_ChatWidgetButton);
	
	var _SearchTitleDeprecated = __webpack_require__(581);
	
	var _SearchTitleDeprecated2 = _interopRequireDefault(_SearchTitleDeprecated);
	
	var _FeatureFlagContainer = __webpack_require__(147);
	
	var _FeatureFlagContainer2 = _interopRequireDefault(_FeatureFlagContainer);
	
	var _ActiveFilters = __webpack_require__(574);
	
	var _ActiveFilters2 = _interopRequireDefault(_ActiveFilters);
	
	__webpack_require__(2546);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EmptySearchResult = exports.EmptySearchResult = function (_BcReactComponent) {
	  _inherits(EmptySearchResult, _BcReactComponent);
	
	  function EmptySearchResult(props) {
	    _classCallCheck(this, EmptySearchResult);
	
	    var _this = _possibleConstructorReturn(this, (EmptySearchResult.__proto__ || Object.getPrototypeOf(EmptySearchResult)).call(this, props));
	
	    _this.bindAll('handleDidYouMeanImpression');
	    return _this;
	  }
	
	  _createClass(EmptySearchResult, [{
	    key: 'handleDidYouMeanImpression',
	    value: function handleDidYouMeanImpression() {
	      var _props = this.props,
	          query = _props.query,
	          didYouMeanQuerySuggestion = _props.didYouMeanQuerySuggestion;
	
	      (0, _utilsAnalytics.sendAnalyticsEvents)(_analyticsEventComposers.searchEventComposer.composeDidYouMeanImpressionEvent({ query: query, suggestion: didYouMeanQuerySuggestion }));
	    }
	  }, {
	    key: 'renderActiveFilters',
	    value: function renderActiveFilters() {
	      var _props2 = this.props,
	          activeFilters = _props2.activeFilters,
	          locked = _props2.locked,
	          singleBranch = _props2.singleBranch,
	          searchType = _props2.searchType;
	
	
	      if (!activeFilters.isEmpty()) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'active-filters' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'empty_search_clear_filters_info' }),
	          _react2.default.createElement(_ActiveFilters2.default, {
	            searchType: searchType,
	            singleBranch: singleBranch,
	            activeFilters: activeFilters,
	            locked: locked,
	            showLockSwitch: false })
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderStaticEmptySearchResults',
	    value: function renderStaticEmptySearchResults() {
	      var _props3 = this.props,
	          hasStaticEmptySearchResults = _props3.hasStaticEmptySearchResults,
	          intl = _props3.intl,
	          query = _props3.query;
	
	
	      if (!hasStaticEmptySearchResults) {
	        return null;
	      }
	
	      var staticEmptySearchContent = intl.formatMessage({
	        id: 'static_empty_search_results_page'
	      });
	
	      if (staticEmptySearchContent) {
	        var InjectQueryIntoHtml = staticEmptySearchContent.replace(/{query}/gi, query);
	
	        return _react2.default.createElement(
	          'div',
	          { className: 'static-empty-search-content' },
	          _react2.default.createElement('div', {
	            // eslint-disable-next-line react/no-danger
	            dangerouslySetInnerHTML: { __html: InjectQueryIntoHtml } })
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderSavedSearchLink',
	    value: function renderSavedSearchLink(updateWorkflow) {
	      return _react2.default.createElement(
	        _baseButtons.TextButton,
	        { handleClick: function handleClick() {
	            return updateWorkflow(_WorkflowConstants.SAVED_SEARCH_WORKFLOW);
	          }, className: 'save-search-link', 'data-test-id': 'save-search-link' },
	        this.props.intl.formatMessage({ id: 'save_search' })
	      );
	    }
	  }, {
	    key: 'renderSearchBox',
	    value: function renderSearchBox() {
	      var _props4 = this.props,
	          orderedSearchTypes = _props4.orderedSearchTypes,
	          locked = _props4.locked,
	          query = _props4.query,
	          searchType = _props4.searchType,
	          activeFilters = _props4.activeFilters;
	
	      return this.context.mobileApp && _react2.default.createElement(_MobileSearchBox2.default, {
	        locked: locked,
	        query: query,
	        searchType: searchType,
	        searchTypes: orderedSearchTypes,
	        activeFilters: activeFilters });
	    }
	  }, {
	    key: 'renderDidNotFind',
	    value: function renderDidNotFind() {
	      var _props5 = this.props,
	          query = _props5.query,
	          didNotFindOptions = _props5.didNotFindOptions;
	
	
	      return didNotFindOptions.get('isEnabled') && _react2.default.createElement(
	        'div',
	        { className: 'empty-search-did-not-find' },
	        _react2.default.createElement(_DidNotFind2.default, { query: query, didNotFindOptions: didNotFindOptions })
	      );
	    }
	  }, {
	    key: 'renderDidYouMean',
	    value: function renderDidYouMean() {
	      var _props6 = this.props,
	          handleDidYouMeanImpression = _props6.handleDidYouMeanImpression,
	          didYouMeanQuerySuggestion = _props6.didYouMeanQuerySuggestion,
	          didYouMeanResultCount = _props6.didYouMeanResultCount;
	
	      return _react2.default.createElement(_DidYouMean2.default, {
	        key: 'did-you-mean',
	        handleDidYouMeanImpression: handleDidYouMeanImpression,
	        querySuggestion: didYouMeanQuerySuggestion,
	        resultCount: didYouMeanResultCount });
	    }
	  }, {
	    key: 'renderExternalSearch',
	    value: function renderExternalSearch() {
	      var _props7 = this.props,
	          query = _props7.query,
	          searchType = _props7.searchType,
	          showExternalSearchLink = _props7.showExternalSearchLink;
	
	
	      return showExternalSearchLink && _react2.default.createElement(_ExternalSearchLink2.default, { query: query, searchType: searchType, formatted: true });
	    }
	  }, {
	    key: 'renderEmbeddedChatWidget',
	    value: function renderEmbeddedChatWidget() {
	      var chatWidgets = this.props.chatWidgets;
	
	      var supportedWidgets = ['qwidget', 'libanswers', 'libraryh3lp', 'mosio', 'refchatter'];
	      var widgets = [];
	
	      if (!chatWidgets) {
	        return null;
	      }
	
	      supportedWidgets.forEach(function (widget, index) {
	        if (chatWidgets.get(widget) && chatWidgets.getIn([widget, 'enabled'])) {
	          widgets.push(_react2.default.createElement(_sharedEmbeddedChatWidget2.default, { key: index, widget: widget }));
	        }
	      });
	
	      if (widgets.length) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'empty-search-embedded-chat-widgets' },
	          widgets
	        );
	      }
	
	      return widgets;
	    }
	  }, {
	    key: 'renderChatWidgetButton',
	    value: function renderChatWidgetButton() {
	      var enabledWidget = this.props.chatWidgets.findLastKey(function (widget) {
	        return widget.get('enabled');
	      });
	
	      if (enabledWidget) {
	        return _react2.default.createElement(
	          'span',
	          { className: 'empty-search-chat-widget' },
	          _react2.default.createElement(_ChatWidgetButton2.default, { widget: enabledWidget })
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderSearchTipsLink',
	    value: function renderSearchTipsLink() {
	      var searchTipsLink = this.props.intl.formatMessage({ id: 'search_tips_link' });
	
	      if (searchTipsLink) {
	        return _react2.default.createElement(
	          'a',
	          {
	            className: 'search-tips',
	            href: searchTipsLink,
	            target: '_blank',
	            rel: 'noopener noreferrer' },
	          _react2.default.createElement(
	            'span',
	            { 'aria-hidden': true },
	            _react2.default.createElement(_baseIcons.QuestionMarkCircled, null),
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'search_tips_link_text' })
	          ),
	          _react2.default.createElement(
	            _baseScreenReaderMessage2.default,
	            null,
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ada_opens_a_new_tab', values: { linkText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'search_tips_link_text' }) } })
	          )
	        );
	      }
	      return null;
	    }
	  }, {
	    key: 'renderSearchTitleDeprecated',
	    value: function renderSearchTitleDeprecated() {
	      var _props8 = this.props,
	          percent = _props8.percent,
	          query = _props8.query,
	          searchType = _props8.searchType,
	          broadened = _props8.broadened,
	          didYouMeanQuerySuggestion = _props8.didYouMeanQuerySuggestion,
	          showExternalSearchLink = _props8.showExternalSearchLink,
	          drawerActions = _props8.drawerActions,
	          broadenedSearchType = _props8.broadenedSearchType,
	          broadenedSearchCount = _props8.broadenedSearchCount,
	          didYouMeanResultCount = _props8.didYouMeanResultCount,
	          title = _props8.title,
	          titleKey = _props8.titleKey,
	          suppress = _props8.suppress,
	          customEdit = _props8.customEdit;
	
	
	      return _react2.default.createElement(_SearchTitleDeprecated2.default, {
	        broadened: broadened,
	        broadenedSearchCount: broadenedSearchCount,
	        broadenedSearchType: broadenedSearchType,
	        customEdit: customEdit,
	        didYouMeanQuerySuggestion: didYouMeanQuerySuggestion,
	        didYouMeanResultCount: didYouMeanResultCount,
	        drawerActions: drawerActions,
	        id: 'searchTitle',
	        percent: percent,
	        query: query,
	        searchType: searchType,
	        showExternalSearchLink: showExternalSearchLink,
	        suppress: suppress,
	        title: title,
	        titleKey: titleKey });
	    }
	  }, {
	    key: 'renderMainContents',
	    value: function renderMainContents() {
	      var query = this.props.query;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'empty-search-main-content' },
	        _react2.default.createElement(
	          'div',
	          { className: 'empty-search-sub-title' },
	          query && _react2.default.createElement(_reactIntl.FormattedMessage, {
	            id: 'Search.empty_search',
	            tagName: 'h4',
	            values: { query: _react2.default.createElement(
	                'strong',
	                null,
	                query
	              ) } }),
	          this.renderDidYouMean(),
	          this.renderActiveFilters(),
	          this.renderExternalSearch()
	        ),
	        this.renderSearchTools()
	      );
	    }
	  }, {
	    key: 'renderSecondaryContents',
	    value: function renderSecondaryContents() {
	      return !this.props.didNotFindOptions.get('isEnabled') && _react2.default.createElement(
	        'div',
	        { className: 'empty-search-secondary-content' },
	        this.renderStaticEmptySearchResults(),
	        this.renderEmbeddedChatWidget()
	      );
	    }
	  }, {
	    key: 'renderSearchTools',
	    value: function renderSearchTools() {
	      return this.props.didNotFindOptions.get('isEnabled') && _react2.default.createElement(
	        'div',
	        { className: 'empty-search-help-tools' },
	        this.renderSearchTipsLink(),
	        this.renderChatWidgetButton()
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props9 = this.props,
	          query = _props9.query,
	          title = _props9.title,
	          titleKey = _props9.titleKey,
	          didYouMeanQuerySuggestion = _props9.didYouMeanQuerySuggestion,
	          didYouMeanResultCount = _props9.didYouMeanResultCount,
	          searchType = _props9.searchType,
	          broadened = _props9.broadened,
	          broadenedSearchType = _props9.broadenedSearchType,
	          showExternalSearchLink = _props9.showExternalSearchLink,
	          rssURL = _props9.rssURL,
	          customEdit = _props9.customEdit,
	          suppress = _props9.suppress,
	          didNotFindOptions = _props9.didNotFindOptions;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-empty-search-result' },
	        this.renderSearchBox(),
	        _react2.default.createElement(
	          _FeatureFlagContainer2.default,
	          null,
	          function (flags) {
	            return flags.get('searchImprovements') ? _react2.default.createElement(_SearchTitle2.default, {
	              broadened: broadened,
	              broadenedSearchType: broadenedSearchType,
	              customEdit: customEdit,
	              didYouMeanQuerySuggestion: didYouMeanQuerySuggestion,
	              didYouMeanResultCount: didYouMeanResultCount,
	              showDidYouMean: false,
	              id: 'searchTitle',
	              query: query,
	              searchType: searchType,
	              showExternalSearchLink: showExternalSearchLink,
	              suppress: suppress,
	              title: title,
	              titleKey: titleKey,
	              handleDidYouMeanImpression: _this2.handleDidYouMeanImpression,
	              rssURL: rssURL,
	              didNotFindOptions: didNotFindOptions }) : _this2.renderSearchTitleDeprecated();
	          }
	        ),
	        this.renderMainContents(),
	        this.renderSecondaryContents(),
	        this.renderDidNotFind()
	      );
	    }
	  }]);
	
	  return EmptySearchResult;
	}(_baseBcReactComponent2.default);
	
	EmptySearchResult.displayName = 'EmptySearchResult';
	EmptySearchResult.propTypes = {
	  query: _react.PropTypes.string,
	  title: _react.PropTypes.string,
	  titleKey: _react.PropTypes.string,
	  activeFilters: _reactImmutableProptypes2.default.mapOf(_react.PropTypes.object).isRequired,
	  chatWidgets: _reactImmutableProptypes2.default.mapOf(_react.PropTypes.object),
	  orderedSearchTypes: _reactImmutableProptypes2.default.list,
	  didYouMeanQuerySuggestion: _react.PropTypes.string,
	  didYouMeanResultCount: _react.PropTypes.number,
	  intl: _reactIntl.intlShape,
	  search: _react.PropTypes.func.isRequired,
	  hasStaticEmptySearchResults: _react.PropTypes.bool.isRequired,
	  searchType: _react.PropTypes.string,
	  broadened: _react.PropTypes.bool,
	  broadenedSearchType: _react.PropTypes.string,
	  showExternalSearchLink: _react.PropTypes.bool,
	  locked: _react.PropTypes.bool,
	  rssURL: _react.PropTypes.string,
	  customEdit: _react.PropTypes.bool,
	  suppress: _react.PropTypes.bool,
	  didNotFindOptions: _reactImmutableProptypes2.default.map,
	  singleBranch: _react.PropTypes.bool
	};
	
	EmptySearchResult.contextTypes = {
	  mobileApp: _react.PropTypes.bool
	};
	
	exports.default = (0, _reactIntl.injectIntl)(EmptySearchResult);

/***/ },
/* 1868 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _EmptySearchResult = __webpack_require__(1867);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_EmptySearchResult).default;
	  }
	});
	Object.defineProperty(exports, 'EmptySearchResult', {
	  enumerable: true,
	  get: function get() {
	    return _EmptySearchResult.EmptySearchResult;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1869 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseDropdown = __webpack_require__(37);
	
	var _baseIcons = __webpack_require__(10);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	__webpack_require__(2548);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GroupingSummary = function (_BcReactComponent) {
	  _inherits(GroupingSummary, _BcReactComponent);
	
	  function GroupingSummary() {
	    _classCallCheck(this, GroupingSummary);
	
	    return _possibleConstructorReturn(this, (GroupingSummary.__proto__ || Object.getPrototypeOf(GroupingSummary)).apply(this, arguments));
	  }
	
	  _createClass(GroupingSummary, [{
	    key: 'render',
	    value: function render() {
	      var groupSummary = this.props.groupSummary;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-grouping-summary' },
	        _react2.default.createElement(
	          _baseDropdown.Dropdown,
	          {
	            selected: GroupingSummary.renderDefaultSelected(),
	            handleSelect: function handleSelect() {},
	            className: 'btn-link',
	            right: true },
	          groupSummary && groupSummary.map(GroupingSummary.renderOption).toArray()
	        )
	      );
	    }
	  }], [{
	    key: 'renderOption',
	    value: function renderOption(value, key) {
	      return _react2.default.createElement(
	        'li',
	        { key: key, className: 'menu-item', style: { color: value ? 'green' : 'lightgrey' } },
	        _react2.default.createElement(
	          'strong',
	          null,
	          key
	        ),
	        ': ',
	        value
	      );
	    }
	  }, {
	    key: 'renderDefaultSelected',
	    value: function renderDefaultSelected() {
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement(_baseIcons.Cog, null),
	        _react2.default.createElement(
	          _baseScreenReaderMessage2.default,
	          null,
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'debug_grouping_summary' })
	        )
	      );
	    }
	  }]);
	
	  return GroupingSummary;
	}(_baseBcReactComponent2.default);
	
	exports.default = GroupingSummary;
	
	
	GroupingSummary.propTypes = {
	  groupSummary: _react.PropTypes.objectOf(_react.PropTypes.string)
	};

/***/ },
/* 1870 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GroupingSummary = __webpack_require__(1869);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GroupingSummary).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1871 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ManifestationList = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _ManifestationListItemContainer = __webpack_require__(2080);
	
	var _ManifestationListItemContainer2 = _interopRequireDefault(_ManifestationListItemContainer);
	
	__webpack_require__(2549);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ManifestationList = exports.ManifestationList = function (_BcReactComponent) {
	  _inherits(ManifestationList, _BcReactComponent);
	
	  function ManifestationList(props) {
	    _classCallCheck(this, ManifestationList);
	
	    var _this = _possibleConstructorReturn(this, (ManifestationList.__proto__ || Object.getPrototypeOf(ManifestationList)).call(this, props));
	
	    _this.bindAll('renderListings');
	    return _this;
	  }
	
	  _createClass(ManifestationList, [{
	    key: 'renderListings',
	    value: function renderListings() {
	      var manifestations = this.props.manifestations;
	
	      var singleItem = manifestations.count() === 1;
	      return manifestations.map(function (item) {
	        return _react2.default.createElement(_ManifestationListItemContainer2.default, {
	          item: item,
	          key: item.get('id'),
	          drawerOpen: singleItem });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-manifestation-list' },
	        this.renderListings()
	      );
	    }
	  }]);
	
	  return ManifestationList;
	}(_baseBcReactComponent2.default);
	
	ManifestationList.propTypes = {
	  manifestations: _reactImmutableProptypes2.default.list,
	  availabilityDetail: _reactImmutableProptypes2.default.map,
	  availabilityDetailActions: _react.PropTypes.objectOf(_react.PropTypes.func),
	  catalogSearchOptions: _reactImmutableProptypes2.default.map,
	  currentUser: _reactImmutableProptypes2.default.map
	};
	
	ManifestationList.defaultProps = {
	  manifestations: []
	};
	
	exports.default = ManifestationList;

/***/ },
/* 1872 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ManifestationList = __webpack_require__(1871);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ManifestationList).default;
	  }
	});
	Object.defineProperty(exports, 'ManifestationList', {
	  enumerable: true,
	  get: function get() {
	    return _ManifestationList.ManifestationList;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1873 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _utilsFormat = __webpack_require__(96);
	
	var _utilsLink = __webpack_require__(97);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseIcons = __webpack_require__(10);
	
	var Icons = _interopRequireWildcard(_baseIcons);
	
	var _baseAccessibilityManageFocus = __webpack_require__(227);
	
	var _baseAccessibilityManageFocus2 = _interopRequireDefault(_baseAccessibilityManageFocus);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	var _sharedMessages = __webpack_require__(64);
	
	var _Messages = __webpack_require__(600);
	
	var _baseButtons = __webpack_require__(12);
	
	var _availabilityBibBlock = __webpack_require__(226);
	
	var _availabilityBibBlock2 = _interopRequireDefault(_availabilityBibBlock);
	
	var _FormatInfoContainer = __webpack_require__(188);
	
	var _FormatInfoContainer2 = _interopRequireDefault(_FormatInfoContainer);
	
	var _AddToShelfButtonContainer = __webpack_require__(146);
	
	var _AddToShelfButtonContainer2 = _interopRequireDefault(_AddToShelfButtonContainer);
	
	var _GroupingSummary = __webpack_require__(1870);
	
	var _GroupingSummary2 = _interopRequireDefault(_GroupingSummary);
	
	var _ItemTransactionButtonContainer = __webpack_require__(297);
	
	var _ItemTransactionButtonContainer2 = _interopRequireDefault(_ItemTransactionButtonContainer);
	
	var _GroupSearchFeedbackButton = __webpack_require__(1633);
	
	var _GroupSearchFeedbackButton2 = _interopRequireDefault(_GroupSearchFeedbackButton);
	
	var _MessagingContainer = __webpack_require__(68);
	
	var _MessagingContainer2 = _interopRequireDefault(_MessagingContainer);
	
	var _WorkflowContainer = __webpack_require__(243);
	
	var _WorkflowContainer2 = _interopRequireDefault(_WorkflowContainer);
	
	__webpack_require__(2550);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ManifestationListItem = function (_BcReactComponent) {
	  _inherits(ManifestationListItem, _BcReactComponent);
	
	  function ManifestationListItem(props) {
	    _classCallCheck(this, ManifestationListItem);
	
	    var _this = _possibleConstructorReturn(this, (ManifestationListItem.__proto__ || Object.getPrototypeOf(ManifestationListItem)).call(this, props));
	
	    _this.bindAll('handleToggleClick', 'renderGroupSummary', 'renderManifestationItemToggle');
	    _this.state = {
	      transactionButtonToggleOpen: _this.props.drawerOpen || false
	    };
	    return _this;
	  }
	
	  _createClass(ManifestationListItem, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (this.state.transactionButtonToggleOpen && !prevState.transactionButtonToggleOpen) {
	        this.props.captureFocus(this._actionDrawer, false);
	      } else {
	        this.props.restoreFocus();
	      }
	    }
	  }, {
	    key: 'handleToggleClick',
	    value: function handleToggleClick(e) {
	      e.preventDefault();
	
	      return this.setState({
	        transactionButtonToggleOpen: !this.state.transactionButtonToggleOpen
	      });
	    }
	  }, {
	    key: 'renderGroupSummary',
	    value: function renderGroupSummary(item) {
	      var _props = this.props,
	          catalogSearchOptions = _props.catalogSearchOptions,
	          groupSearchFeedbackActions = _props.groupSearchFeedbackActions,
	          showGroupingDebug = _props.showGroupingDebug;
	
	      if (catalogSearchOptions.get('showGroupings') && showGroupingDebug) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'manifestation-item-debug-actions hidden-xs' },
	          _react2.default.createElement(_GroupingSummary2.default, { groupSummary: item.get('groupSearchSummary') }),
	          _react2.default.createElement(_GroupSearchFeedbackButton2.default, { handleClick: groupSearchFeedbackActions.startGroupSearchFeedback, bib: item })
	        );
	      }
	      return null;
	    }
	  }, {
	    key: 'renderManifestationItemToggle',
	    value: function renderManifestationItemToggle() {
	      var transactionButtonToggleOpen = this.state.transactionButtonToggleOpen;
	      var editable = this.props.editable;
	
	      var itemId = this.props.item.get('id');
	      var toggleIcon = editable ? _react2.default.createElement(Icons.PencilEdit, { width: 20, height: 20, color: '#02729e' }) : _react2.default.createElement(Icons.More, { width: 20, height: 20, color: '#02729e' });
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('manifestation-item-action-toggle', 'hidden-sm hidden-md hidden-lg', { 'visible-xs toggled-open': transactionButtonToggleOpen }) },
	        _react2.default.createElement(
	          _baseButtons.TextButton,
	          { handleClick: this.handleToggleClick, id: 'manifestation-item-action-wrap-' + itemId, 'aria-expanded': transactionButtonToggleOpen },
	          toggleIcon,
	          _react2.default.createElement(
	            _baseScreenReaderMessage2.default,
	            null,
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ada_toggle_manifestation_item_actions' })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          item = _props2.item,
	          showHoldCount = _props2.showHoldCount;
	      var transactionButtonToggleOpen = this.state.transactionButtonToggleOpen;
	
	      var itemId = item.get('id');
	      var bibTitle = item.getIn(['briefInfo', 'title']);
	      var status = item.getIn(['availability', 'status']);
	
	      return _react2.default.createElement(
	        _WorkflowContainer2.default,
	        { id: itemId },
	        function (workflowComponent) {
	          return workflowComponent || _react2.default.createElement(
	            'div',
	            { className: 'manifestation-item cp-manifestation-list-item row', key: itemId },
	            _react2.default.createElement(
	              _MessagingContainer2.default,
	              { id: itemId },
	              function (messageOptions, dispatch) {
	                return messageOptions.message.get('type') === 'SHELF' ? _react2.default.createElement(_Messages.ShelfMessage, _extends({}, messageOptions, { dispatch: dispatch, values: messageOptions.message.get('values', _immutable2.default.Map()).merge({ title: bibTitle, username: _this2.props.currentUser.get('name') }) })) : _react2.default.createElement(_sharedMessages.Generic, _extends({}, messageOptions, { values: messageOptions.message.get('values', _immutable2.default.Map()).merge({ title: bibTitle }) }));
	              }
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'manifestation-item-format-call-wrap ' + status.toLowerCase() },
	              _react2.default.createElement(
	                'div',
	                { className: 'manifestation-item-format-info-wrap' },
	                _react2.default.createElement('span', { className: (0, _utilsFormat.getIconForFormat)(item.getIn(['briefInfo', 'format'])), 'aria-hidden': true }),
	                _react2.default.createElement(
	                  'a',
	                  {
	                    href: '/item/show/' + (0, _utilsLink.metadataIdFixer)(itemId),
	                    target: '_parent', lang: item.get('primaryLanguage'),
	                    rel: 'noopener',
	                    'data-test-id': 'item-link-' + itemId,
	                    'data-key': 'bib-manifestation-item-link' },
	                  _react2.default.createElement(_FormatInfoContainer2.default, { item: item, className: 'manifestation-item-format-info', searchScopeIsCurrent: _this2.props.searchScopeIsCurrent })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'manifestation-item-availability-block-wrap' },
	                _react2.default.createElement(_availabilityBibBlock2.default, {
	                  bib: item,
	                  availabilityStatus: item.get('availability'),
	                  availabilityDetail: _this2.props.availabilityDetail,
	                  availabilityDetailActions: _this2.props.availabilityDetailActions,
	                  showHoldCount: showHoldCount })
	              )
	            ),
	            _this2.renderManifestationItemToggle(),
	            _react2.default.createElement(
	              'div',
	              {
	                className: 'manifestation-item-action-wrap ' + (transactionButtonToggleOpen ? 'toggled-open' : ''),
	                ref: function ref(el) {
	                  _this2._actionDrawer = el;
	                } },
	              _react2.default.createElement(
	                'div',
	                { className: 'add-to-shelf-wrap' },
	                _react2.default.createElement(_AddToShelfButtonContainer2.default, { metadataId: itemId })
	              ),
	              _react2.default.createElement(_ItemTransactionButtonContainer2.default, { id: itemId, messagingId: itemId }),
	              _this2.renderGroupSummary(item)
	            )
	          );
	        }
	      );
	    }
	  }]);
	
	  return ManifestationListItem;
	}(_baseBcReactComponent2.default);
	
	ManifestationListItem.PropTypes = {
	  availabilityDetail: _reactImmutableProptypes2.default.map,
	  availabilityDetailActions: _react.PropTypes.objectOf(_react.PropTypes.func),
	  catalogSearchOptions: _reactImmutableProptypes2.default.map,
	  currentUser: _reactImmutableProptypes2.default.map,
	  item: _reactImmutableProptypes2.default.map,
	  drawerOpen: _react.PropTypes.bool,
	  showHoldCount: _react.PropTypes.bool
	};
	
	exports.default = (0, _baseAccessibilityManageFocus2.default)(ManifestationListItem);

/***/ },
/* 1874 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ManifestationListItem = __webpack_require__(1873);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ManifestationListItem).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1875 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MobileSearchBox = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _reactRouter = __webpack_require__(17);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _utilsAccessibility = __webpack_require__(95);
	
	var _CatalogueSearchBar = __webpack_require__(1856);
	
	var _CatalogueSearchBar2 = _interopRequireDefault(_CatalogueSearchBar);
	
	var _NewSearchButton = __webpack_require__(1877);
	
	var _NewSearchButton2 = _interopRequireDefault(_NewSearchButton);
	
	var _SearchTypeDropdown = __webpack_require__(1893);
	
	var _SearchTypeDropdown2 = _interopRequireDefault(_SearchTypeDropdown);
	
	var _updateSearchQuery = __webpack_require__(148);
	
	var _updateSearchQuery2 = _interopRequireDefault(_updateSearchQuery);
	
	__webpack_require__(2551);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var renderSavedSearchLink = function renderSavedSearchLink() {
	  return _react2.default.createElement(
	    'a',
	    { href: '/user/saved_searches' },
	    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'saved_searches' })
	  );
	};
	
	var EXCLUDED_SEARCH_TYPES = ['tag', 'userlist', 'user'];
	
	var MobileSearchBox = exports.MobileSearchBox = function (_BcReactComponent) {
	  _inherits(MobileSearchBox, _BcReactComponent);
	
	  function MobileSearchBox(props) {
	    _classCallCheck(this, MobileSearchBox);
	
	    var _this = _possibleConstructorReturn(this, (MobileSearchBox.__proto__ || Object.getPrototypeOf(MobileSearchBox)).call(this, props));
	
	    var _this$props = _this.props,
	        query = _this$props.query,
	        searchType = _this$props.searchType;
	
	
	    _this.state = {
	      expanded: false,
	      searchType: searchType,
	      query: query
	    };
	
	    _this.bindAll('handleExpand', 'handleCollapse', 'handleSearchTypeSelect', 'handleSearch', 'handleQueryChange');
	    return _this;
	  }
	
	  _createClass(MobileSearchBox, [{
	    key: 'handleExpand',
	    value: function handleExpand() {
	      var _this2 = this;
	
	      this.setState({ expanded: true }, function () {
	        setTimeout(function () {
	          return (0, _utilsAccessibility.setFocusWithinElement)(_this2._form);
	        }, 250);
	      });
	    }
	  }, {
	    key: 'handleCollapse',
	    value: function handleCollapse() {
	      var _this3 = this;
	
	      this.setState({ expanded: false }, function () {
	        return (0, _utilsAccessibility.setFocusWithinElement)(_this3._newSearchButton);
	      });
	    }
	  }, {
	    key: 'handleSearchTypeSelect',
	    value: function handleSearchTypeSelect(searchType) {
	      this.setState({ searchType: searchType });
	    }
	  }, {
	    key: 'handleQueryChange',
	    value: function handleQueryChange(query) {
	      this.setState({ query: query });
	    }
	  }, {
	    key: 'handleSearch',
	    value: function handleSearch() {
	      var _state = this.state,
	          searchType = _state.searchType,
	          query = _state.query;
	      var _props = this.props,
	          router = _props.router,
	          location = _props.location,
	          locked = _props.locked,
	          activeFilters = _props.activeFilters;
	
	
	      var newQuery = (0, _updateSearchQuery2.default)({
	        currentQuery: location.query,
	        activeFilters: locked && activeFilters,
	        query: query,
	        searchType: searchType,
	        pagination_page: undefined
	      });
	
	      router.push(_extends({}, location, { query: newQuery }));
	
	      this.handleCollapse();
	    }
	  }, {
	    key: 'renderNewSearchButton',
	    value: function renderNewSearchButton() {
	      var _this4 = this;
	
	      return _react2.default.createElement(_NewSearchButton2.default, {
	        expanded: this.state.expanded,
	        handleCollapse: this.handleCollapse,
	        handleExpand: this.handleExpand,
	        ref: function ref(el) {
	          return _this4._newSearchButton = el;
	        } });
	    }
	  }, {
	    key: 'getSearchTypeOptions',
	    value: function getSearchTypeOptions() {
	      return this.props.searchTypes.filter(function (type) {
	        return EXCLUDED_SEARCH_TYPES.indexOf(type) === -1;
	      }).toJS();
	    }
	  }, {
	    key: 'renderSearchForm',
	    value: function renderSearchForm() {
	      var _this5 = this;
	
	      if (this.state.expanded) {
	        return _react2.default.createElement(
	          'form',
	          { ref: function ref(el) {
	              return _this5._form = el;
	            }, action: '.' },
	          _react2.default.createElement(
	            'h2',
	            null,
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'section_title_search' })
	          ),
	          _react2.default.createElement(_SearchTypeDropdown2.default, {
	            options: this.getSearchTypeOptions(),
	            handleSelect: this.handleSearchTypeSelect,
	            selected: this.state.searchType }),
	          _react2.default.createElement(_CatalogueSearchBar2.default, {
	            query: this.state.query,
	            locked: this.props.locked,
	            handleChange: this.handleQueryChange,
	            handleSearch: this.handleSearch })
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderTopControls',
	    value: function renderTopControls() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'top-controls' },
	        this.renderNewSearchButton(),
	        renderSavedSearchLink()
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-mobile-search-box' },
	        this.renderTopControls(),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('form-wrapper', { expanded: this.state.expanded }) },
	          this.renderSearchForm()
	        )
	      );
	    }
	  }]);
	
	  return MobileSearchBox;
	}(_baseBcReactComponent2.default);
	
	MobileSearchBox.propTypes = {
	  router: _reactRouter.routerShape,
	  locked: _react.PropTypes.bool,
	  query: _react.PropTypes.string,
	  searchType: _react.PropTypes.string,
	  searchTypes: _reactImmutableProptypes2.default.listOf(_react.PropTypes.string),
	  activeFilters: _reactImmutableProptypes2.default.map
	};
	
	exports.default = (0, _reactRouter.withRouter)(MobileSearchBox);

/***/ },
/* 1876 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseButtons = __webpack_require__(12);
	
	var _baseIcons = __webpack_require__(10);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	__webpack_require__(2552);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var renderExpanded = function renderExpanded() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_baseIcons.Cross, null),
	    _react2.default.createElement(
	      _baseScreenReaderMessage2.default,
	      null,
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'close_search_form' })
	    )
	  );
	};
	
	var renderCollapsed = function renderCollapsed() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_baseIcons.Search, null),
	    ' ',
	    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'new_search' })
	  );
	};
	
	var NewSearchButton = function (_BcReactComponent) {
	  _inherits(NewSearchButton, _BcReactComponent);
	
	  function NewSearchButton(props) {
	    _classCallCheck(this, NewSearchButton);
	
	    var _this = _possibleConstructorReturn(this, (NewSearchButton.__proto__ || Object.getPrototypeOf(NewSearchButton)).call(this, props));
	
	    _this.bindAll('handleClick');
	    return _this;
	  }
	
	  _createClass(NewSearchButton, [{
	    key: 'handleClick',
	    value: function handleClick() {
	      var _props = this.props,
	          expanded = _props.expanded,
	          handleExpand = _props.handleExpand,
	          handleCollapse = _props.handleCollapse;
	
	      return expanded ? handleCollapse() : handleExpand();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _baseButtons.TextButton,
	        { handleClick: this.handleClick, className: 'cp-new-search-button' },
	        this.props.expanded ? renderExpanded() : renderCollapsed()
	      );
	    }
	  }]);
	
	  return NewSearchButton;
	}(_baseBcReactComponent2.default);
	
	exports.default = NewSearchButton;
	
	
	NewSearchButton.propTypes = {
	  expanded: _react.PropTypes.bool,
	  handleExpand: _react.PropTypes.func,
	  handleCollapse: _react.PropTypes.func
	};

/***/ },
/* 1877 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _NewSearchButton = __webpack_require__(1876);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_NewSearchButton).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1878 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _PropTypes = __webpack_require__(90);
	
	var _PropTypes2 = _interopRequireDefault(_PropTypes);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseDrawer = __webpack_require__(118);
	
	var _FieldList = __webpack_require__(593);
	
	var _FieldList2 = _interopRequireDefault(_FieldList);
	
	var _SearchResults = __webpack_require__(1887);
	
	var _SearchResults2 = _interopRequireDefault(_SearchResults);
	
	var _SearchTitle = __webpack_require__(580);
	
	var _SearchTitle2 = _interopRequireDefault(_SearchTitle);
	
	var _SearchScopeFieldContainer = __webpack_require__(2088);
	
	var _SearchScopeFieldContainer2 = _interopRequireDefault(_SearchScopeFieldContainer);
	
	var _MobileSearchBox = __webpack_require__(578);
	
	var _MobileSearchBox2 = _interopRequireDefault(_MobileSearchBox);
	
	var _SearchTitleDeprecated = __webpack_require__(581);
	
	var _SearchTitleDeprecated2 = _interopRequireDefault(_SearchTitleDeprecated);
	
	var _FeatureFlagContainer = __webpack_require__(147);
	
	var _FeatureFlagContainer2 = _interopRequireDefault(_FeatureFlagContainer);
	
	var _updateSearchQuery = __webpack_require__(148);
	
	var _updateSearchQuery2 = _interopRequireDefault(_updateSearchQuery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Search = function (_BcReactComponent) {
	  _inherits(Search, _BcReactComponent);
	
	  function Search(props) {
	    _classCallCheck(this, Search);
	
	    var _this = _possibleConstructorReturn(this, (Search.__proto__ || Object.getPrototypeOf(Search)).call(this, props));
	
	    _this.bindAll('handleExpandField', 'transformQueryForFieldList');
	    return _this;
	  }
	
	  _createClass(Search, [{
	    key: 'handleExpandField',
	    value: function handleExpandField(value) {
	      this.props.searchActions.expandField(value, this.props.router.location.query);
	    }
	  }, {
	    key: 'transformQueryForFieldList',
	    value: function transformQueryForFieldList(query) {
	      var _props = this.props,
	          searchType = _props.searchType,
	          activeFilters = _props.activeFilters,
	          location = _props.location;
	
	      return (0, _updateSearchQuery2.default)(_extends({
	        currentQuery: location.query,
	        activeFilters: activeFilters
	      }, query, {
	        searchType: searchType
	      }));
	    }
	  }, {
	    key: 'resultContentStatusClassName',
	    value: function resultContentStatusClassName() {
	      return this.props.resultPaneActive ? 'active' : 'inactive';
	    }
	  }, {
	    key: 'renderSearchBox',
	    value: function renderSearchBox() {
	      var _props2 = this.props,
	          orderedSearchTypes = _props2.orderedSearchTypes,
	          locked = _props2.locked,
	          query = _props2.query,
	          searchType = _props2.searchType,
	          activeFilters = _props2.activeFilters;
	
	      return this.context.mobileApp && _react2.default.createElement(_MobileSearchBox2.default, {
	        locked: locked,
	        searchTypes: orderedSearchTypes,
	        query: query,
	        searchType: searchType,
	        activeFilters: activeFilters });
	    }
	  }, {
	    key: 'renderSearchResults',
	    value: function renderSearchResults() {
	      // values
	      var _props3 = this.props,
	          activeFilters = _props3.activeFilters,
	          branches = _props3.branches,
	          currentView = _props3.currentView,
	          groupedSearchEnabled = _props3.groupedSearchEnabled,
	          drawer = _props3.drawer,
	          isFetching = _props3.isFetching,
	          featuredContent = _props3.featuredContent,
	          featuredContentBlockPosition = _props3.featuredContentBlockPosition,
	          fields = _props3.fields,
	          groupSearchFeedbackActions = _props3.groupSearchFeedbackActions,
	          libraryShortName = _props3.libraryShortName,
	          location = _props3.location,
	          locked = _props3.locked,
	          pagination = _props3.pagination,
	          results = _props3.results,
	          rssURL = _props3.rssURL,
	          searchType = _props3.searchType,
	          singleBranch = _props3.singleBranch,
	          sortBys = _props3.sortBys,
	          otherProps = _objectWithoutProperties(_props3, ['activeFilters', 'branches', 'currentView', 'groupedSearchEnabled', 'drawer', 'isFetching', 'featuredContent', 'featuredContentBlockPosition', 'fields', 'groupSearchFeedbackActions', 'libraryShortName', 'location', 'locked', 'pagination', 'results', 'rssURL', 'searchType', 'singleBranch', 'sortBys']);
	
	      // actions
	
	
	      var _props4 = this.props,
	          drawerActions = _props4.drawerActions,
	          listPresentationActions = _props4.listPresentationActions,
	          searchActions = _props4.searchActions,
	          didNotFindOptions = _props4.didNotFindOptions,
	          chatWidgets = _props4.chatWidgets;
	
	      return _react2.default.createElement(
	        _baseDrawer.Layout,
	        { open: drawer.get('open'), containerClass: 'results_container' },
	        _react2.default.createElement(
	          _baseDrawer.Sidebar,
	          { sidebarClass: 'results_fields', drawerActions: drawerActions },
	          _react2.default.createElement(_FieldList2.default, {
	            paginationField: 'pagination_page',
	            fields: fields,
	            drawerActions: drawerActions,
	            activeFilters: activeFilters,
	            singleBranch: singleBranch,
	            renderSearchScope: function renderSearchScope() {
	              return _react2.default.createElement(_SearchScopeFieldContainer2.default, null);
	            },
	            handleExpandField: this.handleExpandField,
	            transformQuery: this.transformQueryForFieldList })
	        ),
	        _react2.default.createElement(
	          _baseDrawer.MainContent,
	          { mainClass: 'result-content ' + this.resultContentStatusClassName() },
	          _react2.default.createElement(_SearchResults2.default, _extends({}, otherProps, {
	            activeFilters: activeFilters,
	            branches: branches,
	            currentUser: this.props.currentUser,
	            currentView: currentView,
	            groupedSearchEnabled: groupedSearchEnabled,
	            isFetching: isFetching,
	            featuredContent: featuredContent,
	            featuredContentBlockPosition: featuredContentBlockPosition,
	            groupSearchFeedbackActions: groupSearchFeedbackActions,
	            libraryShortName: libraryShortName,
	            listPresentationActions: listPresentationActions,
	            location: location,
	            locked: locked,
	            pagination: pagination,
	            results: results,
	            rssURL: rssURL,
	            searchActions: searchActions,
	            searchType: searchType,
	            singleBranch: singleBranch,
	            sortBys: sortBys,
	            didNotFindOptions: didNotFindOptions,
	            chatWidgets: chatWidgets }))
	        )
	      );
	    }
	  }, {
	    key: 'renderSearchTitleDeprecated',
	    value: function renderSearchTitleDeprecated() {
	      var _props5 = this.props,
	          percent = _props5.percent,
	          query = _props5.query,
	          searchType = _props5.searchType,
	          broadened = _props5.broadened,
	          didYouMeanQuerySuggestion = _props5.didYouMeanQuerySuggestion,
	          showExternalSearchLink = _props5.showExternalSearchLink,
	          drawerActions = _props5.drawerActions,
	          broadenedSearchType = _props5.broadenedSearchType,
	          broadenedSearchCount = _props5.broadenedSearchCount,
	          didYouMeanResultCount = _props5.didYouMeanResultCount,
	          title = _props5.title,
	          titleKey = _props5.titleKey,
	          suppress = _props5.suppress,
	          customEdit = _props5.customEdit;
	
	
	      return _react2.default.createElement(_SearchTitleDeprecated2.default, {
	        broadened: broadened,
	        broadenedSearchCount: broadenedSearchCount,
	        broadenedSearchType: broadenedSearchType,
	        customEdit: customEdit,
	        didYouMeanQuerySuggestion: didYouMeanQuerySuggestion,
	        didYouMeanResultCount: didYouMeanResultCount,
	        drawerActions: drawerActions,
	        id: 'searchTitle',
	        percent: percent,
	        query: query,
	        searchType: searchType,
	        showExternalSearchLink: showExternalSearchLink,
	        suppress: suppress,
	        title: title,
	        titleKey: titleKey });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props6 = this.props,
	          percent = _props6.percent,
	          query = _props6.query,
	          searchType = _props6.searchType,
	          broadened = _props6.broadened,
	          didYouMeanQuerySuggestion = _props6.didYouMeanQuerySuggestion,
	          showExternalSearchLink = _props6.showExternalSearchLink,
	          drawerActions = _props6.drawerActions,
	          broadenedSearchType = _props6.broadenedSearchType,
	          broadenedSearchCount = _props6.broadenedSearchCount,
	          didYouMeanResultCount = _props6.didYouMeanResultCount,
	          title = _props6.title,
	          titleKey = _props6.titleKey,
	          suppress = _props6.suppress,
	          customEdit = _props6.customEdit,
	          rssURL = _props6.rssURL,
	          didNotFindOptions = _props6.didNotFindOptions;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.renderSearchBox(),
	        _react2.default.createElement(
	          _FeatureFlagContainer2.default,
	          null,
	          function (flags) {
	            return flags.get('searchImprovements') ? _react2.default.createElement(_SearchTitle2.default, {
	              broadened: broadened,
	              broadenedSearchCount: broadenedSearchCount,
	              broadenedSearchType: broadenedSearchType,
	              customEdit: customEdit,
	              didYouMeanQuerySuggestion: didYouMeanQuerySuggestion,
	              didYouMeanResultCount: didYouMeanResultCount,
	              drawerActions: drawerActions,
	              id: 'searchTitle',
	              percent: percent,
	              query: query,
	              searchType: searchType,
	              showExternalSearchLink: showExternalSearchLink,
	              suppress: suppress,
	              title: title,
	              titleKey: titleKey,
	              rssURL: rssURL,
	              didNotFindOptions: didNotFindOptions }) : _this2.renderSearchTitleDeprecated();
	          }
	        ),
	        this.renderSearchResults()
	      );
	    }
	  }]);
	
	  return Search;
	}(_baseBcReactComponent2.default);
	
	Search.defaultProps = {
	  currentView: 'medium'
	};
	
	Search.propTypes = {
	  activeFilters: _reactImmutableProptypes2.default.map.isRequired,
	  branches: _reactImmutableProptypes2.default.list,
	  broadened: _react.PropTypes.bool,
	  broadenedSearchCount: _react.PropTypes.number,
	  broadenedSearchType: _react.PropTypes.string,
	  catalogSearchOptions: _reactImmutableProptypes2.default.map,
	  currentUser: _reactImmutableProptypes2.default.map,
	  currentView: _react.PropTypes.string.isRequired,
	  groupedSearchEnabled: _react.PropTypes.bool.isRequired,
	  customEdit: _react.PropTypes.bool,
	  didYouMeanQuerySuggestion: _react.PropTypes.string,
	  didYouMeanResultCount: _react.PropTypes.number,
	  drawer: _reactImmutableProptypes2.default.map,
	  drawerActions: _react.PropTypes.objectOf(_react.PropTypes.func),
	  featuredContent: _reactImmutableProptypes2.default.map,
	  featuredContentBlockPosition: _react.PropTypes.number,
	  fields: _reactImmutableProptypes2.default.list.isRequired,
	  isFetching: _react.PropTypes.bool,
	  libraryShortName: _react.PropTypes.string.isRequired,
	  listPresentationActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  location: _react.PropTypes.shape(_PropTypes2.default),
	  locked: _react.PropTypes.bool,
	  pagination: _reactImmutableProptypes2.default.map.isRequired,
	  query: _react.PropTypes.string.isRequired,
	  resultPaneActive: _react.PropTypes.bool,
	  results: _reactImmutableProptypes2.default.list.isRequired,
	  rssURL: _react.PropTypes.string,
	  searchActions: _react.PropTypes.shape({
	    betaSearch: _react.PropTypes.func,
	    clearFilters: _react.PropTypes.func,
	    closeExpandField: _react.PropTypes.func,
	    expandField: _react.PropTypes.func
	  }),
	  searchType: _react.PropTypes.string.isRequired,
	  showExternalSearchLink: _react.PropTypes.bool,
	  singleBranch: _react.PropTypes.bool,
	  sortBys: _reactImmutableProptypes2.default.list.isRequired,
	  suppress: _react.PropTypes.bool,
	  title: _react.PropTypes.string,
	  titleKey: _react.PropTypes.string,
	  zeroResults: _react.PropTypes.bool.isRequired,
	  searchTypes: _reactImmutableProptypes2.default.list,
	  didNotFindOptions: _reactImmutableProptypes2.default.map,
	  chatWidgets: _reactImmutableProptypes2.default.mapOf(_react.PropTypes.object)
	};
	
	Search.contextTypes = {
	  mobileApp: _react.PropTypes.bool
	};
	
	exports.default = Search;

/***/ },
/* 1879 */
[3484, 1878],
/* 1880 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SearchPrintList = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _reactRouter = __webpack_require__(17);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _print = __webpack_require__(120);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SearchPrintList = exports.SearchPrintList = function (_BcReactComponent) {
	  _inherits(SearchPrintList, _BcReactComponent);
	
	  function SearchPrintList(props) {
	    _classCallCheck(this, SearchPrintList);
	
	    var _this = _possibleConstructorReturn(this, (SearchPrintList.__proto__ || Object.getPrototypeOf(SearchPrintList)).call(this, props));
	
	    _this.bindAll('handleUpdatePage');
	    return _this;
	  }
	
	  _createClass(SearchPrintList, [{
	    key: 'handleUpdatePage',
	    value: function handleUpdatePage() {
	      var router = this.props.router;
	      var location = router.location;
	
	
	      var newPage = this.props.pagination.get('page') + 1;
	      this.props.router.push(_extends({}, location, {
	        query: _extends({}, location.query, { pagination_page: newPage })
	      }));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          pagination = _props.pagination,
	          results = _props.results,
	          searchQuery = _props.searchQuery,
	          isFetching = _props.isFetching;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-search-print-list' },
	        _react2.default.createElement(
	          _print.PrintButtonsToolbar,
	          { numItemsToPrint: results.size },
	          _react2.default.createElement(_print.PrintLoadNextButton, {
	            handleClick: this.handleUpdatePage,
	            numToLoad: pagination.get('limit'),
	            totalPages: pagination.get('pages'),
	            currentPage: pagination.get('page'),
	            isLoading: isFetching })
	        ),
	        _react2.default.createElement(
	          'h1',
	          { className: 'page-header' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'print_search_for', values: { search_name: searchQuery.get('query') } })
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'label_number_of_items', values: { count: pagination.get('count') } })
	        ),
	        _react2.default.createElement(_print.PrintTable, {
	          rows: results,
	          fields: [{ key: 'title', type: 'item-title', headerKey: 'table_headings_title' }, { key: 'subtitle', type: 'subtitle-title', headerKey: 'table_headings_subtitle' }, { key: 'authors', type: 'item-author', headerKey: 'table_headings_author' }, { key: 'format', type: 'item-format', headerKey: 'table_headings_format', localizationMap: function localizationMap(val) {
	              return 'FORMAT.' + val.toLowerCase();
	            } }, { key: 'callNumber', type: 'item-call-number', headerKey: 'table_headings_call_number' }] }),
	        _react2.default.createElement(
	          'div',
	          { className: 'page-info' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'form_label_current_page', values: { current_page: pagination.get('page') } }),
	          '\xA0',
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'form_label_total_pages', values: { total_pages: pagination.get('pages') } })
	        )
	      );
	    }
	  }]);
	
	  return SearchPrintList;
	}(_baseBcReactComponent2.default);
	
	SearchPrintList.propTypes = {
	  pagination: _reactImmutableProptypes2.default.map,
	  results: _reactImmutableProptypes2.default.list,
	  searchQuery: _reactImmutableProptypes2.default.map,
	  searchActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  isFetching: _react.PropTypes.bool,
	  router: _reactRouter.routerShape.isRequired
	};
	
	exports.default = (0, _reactRouter.withRouter)(SearchPrintList);

/***/ },
/* 1881 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SearchPrintList = __webpack_require__(1880);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SearchPrintList).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1882 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.SearchResultItem = SearchResultItem;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _utilsLink = __webpack_require__(97);
	
	var _utilsItem = __webpack_require__(232);
	
	__webpack_require__(2553);
	
	var _SearchResultItemContent = __webpack_require__(1885);
	
	var _SearchResultItemContent2 = _interopRequireDefault(_SearchResultItemContent);
	
	var _sharedJacketCover = __webpack_require__(93);
	
	var _sharedJacketCover2 = _interopRequireDefault(_sharedJacketCover);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// These props are used in SearchResultItemContent
	/* eslint-disable react/no-unused-prop-types */
	var propTypes = {
	  availabilityDetail: _reactImmutableProptypes2.default.map,
	  item: _reactImmutableProptypes2.default.map,
	  itemRecommendations: _reactImmutableProptypes2.default.map,
	  catalogSearchOptions: _reactImmutableProptypes2.default.map,
	  branches: _reactImmutableProptypes2.default.list,
	  currentUser: _reactImmutableProptypes2.default.map,
	  showJacketCover: _react.PropTypes.bool,
	  showSeries: _react.PropTypes.bool,
	  order: _react.PropTypes.number,
	  dataResultRank: _react.PropTypes.number,
	  dataKey: _react.PropTypes.string
	};
	/* eslint-enable react/no-unused-prop-types */
	
	function SearchResultItem(props) {
	  var item = props.item,
	      showJacketCover = props.showJacketCover,
	      showSeries = props.showSeries;
	
	  var jacketSource = item.getIn(['briefInfo', 'jacket']);
	  var bibCoverAltText = (0, _utilsItem.bibJacketCoverAltText)(item.getIn(['briefInfo', 'title']), item.getIn(['briefInfo', 'authors']));
	  var jacketBlock = _react2.default.createElement(
	    'div',
	    { className: 'col-md-2 visible-md visible-lg item-column' },
	    _react2.default.createElement(
	      'a',
	      { href: '/item/show/' + (0, _utilsLink.metadataIdFixer)(item.get('id')), tabIndex: '-1', 'aria-hidden': 'true', target: '_parent', 'data-key': 'bib-image-link' },
	      _react2.default.createElement(_sharedJacketCover2.default, { src: jacketSource, format: item.getIn(['briefInfo', 'format']), alt: bibCoverAltText, responsive: true })
	    )
	  );
	
	  var itemClass = showJacketCover ? 'col-md-10' : 'col-md-12';
	  return _react2.default.createElement(
	    'li',
	    { className: 'row cp-search-result-item', 'data-test-id': 'searchResultItem', style: { order: props.order }, 'data-key': props.dataKey, 'data-result-rank': props.dataResultRank },
	    showJacketCover ? jacketBlock : _react2.default.createElement('noop', null),
	    _react2.default.createElement(
	      'div',
	      { className: itemClass + ' item-column' },
	      _react2.default.createElement(_SearchResultItemContent2.default, _extends({}, props, { showSeries: showSeries, id: item.get('id'), showJacketCover: showJacketCover }))
	    )
	  );
	}
	
	SearchResultItem.propTypes = propTypes;
	SearchResultItem.defaultProps = {
	  order: 0
	};
	
	exports.default = SearchResultItem;

/***/ },
/* 1883 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SearchResultItem = __webpack_require__(1882);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SearchResultItem).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1884 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _utilsLink = __webpack_require__(97);
	
	var _utilsItem = __webpack_require__(232);
	
	var _rating = __webpack_require__(141);
	
	var _rating2 = _interopRequireDefault(_rating);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _sharedBibBrief = __webpack_require__(46);
	
	var _sharedBibBrief2 = _interopRequireDefault(_sharedBibBrief);
	
	var _sharedJacketCover = __webpack_require__(93);
	
	var _sharedJacketCover2 = _interopRequireDefault(_sharedJacketCover);
	
	var _sharedBibSeries = __webpack_require__(1473);
	
	var _sharedBibSeries2 = _interopRequireDefault(_sharedBibSeries);
	
	var _RecommendationsContainer = __webpack_require__(2083);
	
	var _RecommendationsContainer2 = _interopRequireDefault(_RecommendationsContainer);
	
	var _ManifestationList = __webpack_require__(1872);
	
	var _ManifestationList2 = _interopRequireDefault(_ManifestationList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  availabilityDetail: _reactImmutableProptypes2.default.map,
	  item: _reactImmutableProptypes2.default.map,
	  catalogSearchOptions: _reactImmutableProptypes2.default.map,
	  branches: _reactImmutableProptypes2.default.list,
	  currentUser: _reactImmutableProptypes2.default.map,
	  showSeries: _react.PropTypes.bool
	};
	
	var SearchResultItemContent = function (_BcReactComponent) {
	  _inherits(SearchResultItemContent, _BcReactComponent);
	
	  function SearchResultItemContent(props) {
	    _classCallCheck(this, SearchResultItemContent);
	
	    var _this = _possibleConstructorReturn(this, (SearchResultItemContent.__proto__ || Object.getPrototypeOf(SearchResultItemContent)).call(this, props));
	
	    _this.bindAll('renderManifestations');
	    return _this;
	  }
	
	  _createClass(SearchResultItemContent, [{
	    key: 'renderSeries',
	    value: function renderSeries() {
	      if (this.props.showSeries) {
	        return _react2.default.createElement(
	          'span',
	          { className: 'series-list' },
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'series' }),
	            ':'
	          ),
	          this.props.item.getIn(['briefInfo', 'series']).valueSeq().map(function (series) {
	            return _react2.default.createElement(_sharedBibSeries2.default, { series: series });
	          })
	        );
	      }
	      return null;
	    }
	  }, {
	    key: 'renderManifestations',
	    value: function renderManifestations() {
	      return _react2.default.createElement(_ManifestationList2.default, {
	        availabilityDetail: this.props.availabilityDetail,
	        availabilityBib: this.props.item.get('briefInfo'),
	        availabilityDetailActions: this.props.availabilityDetailActions,
	        manifestations: this.props.manifestations,
	        catalogSearchOptions: this.props.catalogSearchOptions,
	        currentUser: this.props.currentUser,
	        groupSearchFeedbackActions: this.props.groupSearchFeedbackActions });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var bibTitle = this.props.item.getIn(['briefInfo', 'title']);
	      var bibCoverAltText = (0, _utilsItem.bibJacketCoverAltText)(bibTitle, this.props.item.getIn(['briefInfo', 'authors']));
	      var jacketSource = this.props.item.getIn(['briefInfo', 'jacket']);
	      var manifestations = this.props.manifestations;
	      var searchResultItemContentClasses = (0, _classnames2.default)('cp-search-result-item-content');
	
	      return _react2.default.createElement(
	        'div',
	        { className: searchResultItemContentClasses },
	        _react2.default.createElement(
	          'div',
	          { className: 'cp-search-result-item-info' },
	          _react2.default.createElement(
	            'div',
	            { className: 'jacket-cover-wrap hidden-md hidden-lg' },
	            _react2.default.createElement(
	              'a',
	              { href: '/item/show/' + (0, _utilsLink.metadataIdFixer)(this.props.item.get('id')), title: bibTitle, target: '_parent' },
	              _react2.default.createElement(_sharedJacketCover2.default, { src: jacketSource, format: this.props.item.getIn(['briefInfo', 'format']), alt: bibCoverAltText })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _sharedBibBrief2.default,
	              { bib: this.props.item.get('briefInfo'), renderAuthorsAsLink: true },
	              this.renderSeries()
	            ),
	            _react2.default.createElement(_rating2.default, {
	              readOnly: true,
	              rating: this.props.item.getIn(['briefInfo', 'rating', 'averageRating']) || 0,
	              id: 'rating_' + this.props.item.get('id') })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'info' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-12 availability_status' },
	              this.renderManifestations()
	            )
	          )
	        ),
	        _react2.default.createElement(_RecommendationsContainer2.default, { manifestations: manifestations })
	      );
	    }
	  }]);
	
	  return SearchResultItemContent;
	}(_baseBcReactComponent2.default);
	
	SearchResultItemContent.propTypes = propTypes;
	
	exports.default = SearchResultItemContent;

/***/ },
/* 1885 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SearchResultItemContent = __webpack_require__(1884);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SearchResultItemContent).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1886 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _aboveTheFoldOnlyServerRender = __webpack_require__(376);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _reactAddonsCssTransitionGroup = __webpack_require__(258);
	
	var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	var _baseCheckbox = __webpack_require__(58);
	
	var _baseCheckbox2 = _interopRequireDefault(_baseCheckbox);
	
	var _print = __webpack_require__(120);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _ViewSelector = __webpack_require__(1896);
	
	var _ViewSelector2 = _interopRequireDefault(_ViewSelector);
	
	var _sortDropdown = __webpack_require__(372);
	
	var _sortDropdown2 = _interopRequireDefault(_sortDropdown);
	
	var _pagination = __webpack_require__(92);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _ActiveFilters = __webpack_require__(574);
	
	var _ActiveFilters2 = _interopRequireDefault(_ActiveFilters);
	
	var _FeaturedContentContainer = __webpack_require__(2067);
	
	var _FeaturedContentContainer2 = _interopRequireDefault(_FeaturedContentContainer);
	
	var _RSSButton = __webpack_require__(579);
	
	var _RSSButton2 = _interopRequireDefault(_RSSButton);
	
	var _FacetDrawerToggle = __webpack_require__(592);
	
	var _FacetDrawerToggle2 = _interopRequireDefault(_FacetDrawerToggle);
	
	var _SearchResultItem = __webpack_require__(1883);
	
	var _SearchResultItem2 = _interopRequireDefault(_SearchResultItem);
	
	var _DidNotFindExpandablePanel = __webpack_require__(1862);
	
	var _DidNotFindExpandablePanel2 = _interopRequireDefault(_DidNotFindExpandablePanel);
	
	__webpack_require__(2554);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SearchResults = function (_BcReactComponent) {
	  _inherits(SearchResults, _BcReactComponent);
	
	  function SearchResults(props) {
	    _classCallCheck(this, SearchResults);
	
	    var _this = _possibleConstructorReturn(this, (SearchResults.__proto__ || Object.getPrototypeOf(SearchResults)).call(this, props));
	
	    _this.bindAll('renderGroupingToggle');
	    return _this;
	  }
	
	  _createClass(SearchResults, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchGroupSearchSummaries();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (this.props.results !== prevProps.results || this.props.currentUser !== prevProps.currentUser) {
	        this.fetchGroupSearchSummaries();
	      }
	    }
	  }, {
	    key: 'getPrintUrl',
	    value: function getPrintUrl() {
	      var search = this.props.location.search;
	
	      return '/v2/print/search' + search;
	    }
	  }, {
	    key: 'renderResultItems',
	    value: function renderResultItems() {
	      var _this2 = this;
	
	      var startIndex = (this.props.pagination.get('page') - 1) * this.props.pagination.get('limit') + 1;
	      return this.props.results.valueSeq().map(function (result, index) {
	        return _react2.default.createElement(
	          _aboveTheFoldOnlyServerRender.AboveTheFoldOnlyServerRender,
	          { skip: index > 4, key: index },
	          _react2.default.createElement(_SearchResultItem2.default, {
	            dataResultRank: '' + (startIndex + index),
	            dataKey: 'search-result-item',
	            currentView: _this2.props.currentView,
	            order: index > _this2.props.featuredContentBlockPosition ? 2 : 0,
	            showSeries: _this2.props.searchType === 'series',
	            item: result.representative,
	            key: result.representative.get('id'),
	            availabilityDetail: _this2.props.availabilityDetail,
	            availabilityDetailActions: _this2.props.availabilityDetailActions,
	            catalogSearchOptions: _this2.props.catalogSearchOptions,
	            manifestations: result.manifestations,
	            showJacketCover: _this2.props.currentView !== 'small',
	            groupSearchFeedbackActions: _this2.props.groupSearchFeedbackActions,
	            branches: _this2.props.branches,
	            currentUser: _this2.props.currentUser })
	        );
	      });
	    }
	  }, {
	    key: 'fetchGroupSearchSummaries',
	    value: function fetchGroupSearchSummaries() {
	      if (this.shouldShowGroupingToggle()) {
	        this.props.searchActions.getGroupSearchSummaries(this.props.results.map(function (result) {
	          return result.manifestations;
	        }).flatten(true).map(function (result) {
	          return result.get('id');
	        }).toArray());
	      }
	    }
	  }, {
	    key: 'shouldShowGroupingToggle',
	    value: function shouldShowGroupingToggle() {
	      return this.props.currentUser && this.props.currentUser.get('showGroupingDebug') && this.props.currentView === 'grouped';
	    }
	  }, {
	    key: 'renderGroupingToggle',
	    value: function renderGroupingToggle() {
	      var _props = this.props,
	          searchActions = _props.searchActions,
	          catalogSearchOptions = _props.catalogSearchOptions;
	
	
	      if (!this.shouldShowGroupingToggle()) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'grouping-summary-debug hidden-xs' },
	        _react2.default.createElement(_baseCheckbox2.default, {
	          id: 'grouping-summary-debug',
	          label: 'Debug Groupings',
	          handleChange: searchActions.toggleShowGroupings,
	          checked: catalogSearchOptions.get('showGroupings'),
	          inline: true,
	          labelBefore: true })
	      );
	    }
	  }, {
	    key: 'renderActiveFilters',
	    value: function renderActiveFilters() {
	      var _props2 = this.props,
	          activeFilters = _props2.activeFilters,
	          locked = _props2.locked,
	          singleBranch = _props2.singleBranch,
	          searchType = _props2.searchType;
	
	      if (!activeFilters.isEmpty()) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'active-filters row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-12' },
	            _react2.default.createElement(_ActiveFilters2.default, {
	              searchType: searchType,
	              singleBranch: singleBranch,
	              activeFilters: activeFilters,
	              locked: locked })
	          )
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderDidNotFindExpandablePanel',
	    value: function renderDidNotFindExpandablePanel() {
	      var _props3 = this.props,
	          didNotFindOptions = _props3.didNotFindOptions,
	          chatWidgets = _props3.chatWidgets,
	          query = _props3.query;
	
	
	      return didNotFindOptions.get('isEnabled') && _react2.default.createElement(_DidNotFindExpandablePanel2.default, {
	        query: query,
	        didNotFindOptions: didNotFindOptions,
	        chatWidgets: chatWidgets });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props,
	          activeFilters = _props4.activeFilters,
	          currentView = _props4.currentView,
	          groupedSearchEnabled = _props4.groupedSearchEnabled,
	          isFetching = _props4.isFetching,
	          pagination = _props4.pagination,
	          rssURL = _props4.rssURL,
	          searchActions = _props4.searchActions,
	          sortBys = _props4.sortBys;
	
	
	      return _react2.default.createElement(
	        'section',
	        { className: 'cp-search-results' },
	        this.renderActiveFilters(),
	        _react2.default.createElement(
	          'section',
	          { className: 'result-controls btn-toolbar' },
	          _react2.default.createElement(_FacetDrawerToggle2.default, {
	            drawerActions: this.props.drawerActions,
	            activeFilterCount: activeFilters.toList().flatten(true).count() }),
	          _react2.default.createElement(_sortDropdown2.default, { options: sortBys, paginationField: 'pagination_page', right: true }),
	          _react2.default.createElement(_ViewSelector2.default, {
	            currentView: currentView,
	            groupedSearchEnabled: groupedSearchEnabled,
	            searchActions: searchActions }),
	          _react2.default.createElement(_print.PrintButton, {
	            className: 'hidden-xs hidden-sm',
	            url: this.getPrintUrl(),
	            iconColor: '#333' }),
	          _react2.default.createElement(_pagination2.default, {
	            autoFocus: true,
	            isFetching: isFetching,
	            textKey: 'Search.paginationInfo',
	            page: pagination.get('page'),
	            limit: pagination.get('limit'),
	            count: pagination.get('count'),
	            pages: pagination.get('pages'),
	            queryField: 'pagination_page' })
	        ),
	        _react2.default.createElement(
	          'section',
	          { className: 'results-list row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-12 results-list-items' },
	            _react2.default.createElement(
	              _reactAddonsCssTransitionGroup2.default,
	              {
	                component: 'ul',
	                className: 'results',
	                transitionName: 'fade',
	                transitionEnterTimeout: 500,
	                transitionLeaveTimeout: 500 },
	              this.renderResultItems(),
	              _react2.default.createElement(_FeaturedContentContainer2.default, null)
	            ),
	            !this.context.mobileApp && _react2.default.createElement(_RSSButton2.default, { url: rssURL })
	          )
	        ),
	        _react2.default.createElement(
	          _aboveTheFoldOnlyServerRender.AboveTheFoldOnlyServerRender,
	          { skip: true },
	          _react2.default.createElement(
	            'section',
	            { className: 'bottom-controls' },
	            _react2.default.createElement(_pagination2.default, {
	              showPages: true,
	              isFetching: isFetching,
	              queryField: 'pagination_page',
	              textKey: 'Search.paginationInfo',
	              page: pagination.get('page'),
	              limit: pagination.get('limit'),
	              count: pagination.get('count'),
	              pages: pagination.get('pages') }),
	            this.renderGroupingToggle()
	          )
	        ),
	        _react2.default.createElement(
	          'section',
	          { className: 'did-not-find-panel' },
	          this.renderDidNotFindExpandablePanel()
	        )
	      );
	    }
	  }]);
	
	  return SearchResults;
	}(_baseBcReactComponent2.default);
	
	var propTypes = {
	  branches: _reactImmutableProptypes2.default.list,
	  catalogSearch: _react.PropTypes.object,
	  catalogSearchOptions: _react.PropTypes.object,
	  currentUser: _react.PropTypes.object,
	  currentView: _react.PropTypes.string.isRequired,
	  groupedSearchEnabled: _react.PropTypes.bool.isRequired,
	  drawerActions: _react.PropTypes.objectOf(_react.PropTypes.func),
	  featuredContent: _react.PropTypes.object,
	  featuredContentBlockPosition: _react.PropTypes.number,
	  isFetching: _react.PropTypes.bool,
	  libraryShortName: _react.PropTypes.string.isRequired,
	  listPresentationActions: _react.PropTypes.object.isRequired,
	  location: _react.PropTypes.object.isRequired,
	  locked: _react.PropTypes.bool,
	  rssURL: _react.PropTypes.string,
	  searchActions: _react.PropTypes.objectOf(_react.PropTypes.func),
	  searchType: _react.PropTypes.string,
	  singleBranch: _react.PropTypes.bool,
	  sortBys: _reactImmutableProptypes2.default.list.isRequired,
	  didNotFindOptions: _reactImmutableProptypes2.default.map,
	  chatWidgets: _reactImmutableProptypes2.default.mapOf(_react.PropTypes.object)
	};
	
	SearchResults.contextTypes = {
	  mobileApp: _react.PropTypes.bool
	};
	
	SearchResults.propTypes = propTypes;
	
	exports.default = SearchResults;

/***/ },
/* 1887 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SearchResults = __webpack_require__(1886);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SearchResults).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1888 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SearchScopeField = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRouter = __webpack_require__(17);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	__webpack_require__(2555);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SearchScopeField = exports.SearchScopeField = function (_BcReactComponent) {
	  _inherits(SearchScopeField, _BcReactComponent);
	
	  function SearchScopeField(props) {
	    _classCallCheck(this, SearchScopeField);
	
	    var _this = _possibleConstructorReturn(this, (SearchScopeField.__proto__ || Object.getPrototypeOf(SearchScopeField)).call(this, props));
	
	    _this.bindAll('renderScopeLink');
	    return _this;
	  }
	
	  _createClass(SearchScopeField, [{
	    key: 'getHrefForScope',
	    value: function getHrefForScope(searchScope) {
	      var _props$router = this.props.router,
	          createHref = _props$router.createHref,
	          location = _props$router.location;
	
	      return createHref(_extends({}, location, {
	        query: _extends({}, location.query, {
	          searchScope: searchScope,
	          lastSearchScope: location.query.searchScope
	        })
	      }));
	    }
	  }, {
	    key: 'renderScopeLink',
	    value: function renderScopeLink(scope, index) {
	      var linkClasses = (0, _classnames2.default)('filter', { applied: this.props.currentSearchScope === scope.get('scopeId') });
	
	      var styles = {
	        paddingLeft: (index <= 1 ? 0 : index - 1) + 'em'
	      };
	
	      return _react2.default.createElement(
	        'li',
	        { className: linkClasses, style: styles },
	        _react2.default.createElement(
	          'a',
	          {
	            href: this.getHrefForScope(scope.get('scopeId')),
	            'data-scope-id': scope.get('scopeId'),
	            onClick: this.updateScope },
	          index > 0 ? '\u2014 ' : '',
	          scope.get('scopeName')
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'section',
	        { className: 'cp-search-scope-field' },
	        _react2.default.createElement(
	          _reactIntl.FormattedMessage,
	          { id: 'section_title_show_results_at' },
	          function (message) {
	            return _react2.default.createElement(
	              'h4',
	              { className: 'field-name' },
	              message
	            );
	          }
	        ),
	        _react2.default.createElement(
	          'ul',
	          { className: 'filter-list' },
	          this.props.scopes.map(this.renderScopeLink)
	        )
	      );
	    }
	  }]);
	
	  return SearchScopeField;
	}(_baseBcReactComponent2.default);
	
	SearchScopeField.displayName = 'SearchScopeField';
	SearchScopeField.propTypes = {
	  currentSearchScope: _react.PropTypes.string.isRequired,
	  router: _reactRouter.routerShape,
	  scopes: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	    scopeName: _react.PropTypes.string.isRequired,
	    scopeId: _react.PropTypes.string.isRequired,
	    parentScopeId: _react.PropTypes.string.isRequired
	  }).isRequired).isRequired
	};
	
	exports.default = (0, _reactRouter.withRouter)(SearchScopeField);

/***/ },
/* 1889 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SearchScopeField = __webpack_require__(1888);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SearchScopeField).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1890 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _WorkflowConstants = __webpack_require__(74);
	
	var _MessagingContainer = __webpack_require__(68);
	
	var _MessagingContainer2 = _interopRequireDefault(_MessagingContainer);
	
	var _WorkflowContainer = __webpack_require__(243);
	
	var _WorkflowContainer2 = _interopRequireDefault(_WorkflowContainer);
	
	var _SearchProbeContainer = __webpack_require__(638);
	
	var _SearchProbeContainer2 = _interopRequireDefault(_SearchProbeContainer);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseButtons = __webpack_require__(12);
	
	var _sharedMessages = __webpack_require__(64);
	
	var _BroadenSearchLink = __webpack_require__(575);
	
	var _BroadenSearchLink2 = _interopRequireDefault(_BroadenSearchLink);
	
	var _DidYouMean = __webpack_require__(386);
	
	var _DidYouMean2 = _interopRequireDefault(_DidYouMean);
	
	var _RSSButton = __webpack_require__(579);
	
	var _RSSButton2 = _interopRequireDefault(_RSSButton);
	
	var _baseIcons = __webpack_require__(10);
	
	var _DidNotFindDropdown = __webpack_require__(1860);
	
	var _DidNotFindDropdown2 = _interopRequireDefault(_DidNotFindDropdown);
	
	var _ExternalSearchLink = __webpack_require__(287);
	
	var _ExternalSearchLink2 = _interopRequireDefault(_ExternalSearchLink);
	
	__webpack_require__(2556);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SearchTitle = function (_BcReactComponent) {
	  _inherits(SearchTitle, _BcReactComponent);
	
	  function SearchTitle() {
	    _classCallCheck(this, SearchTitle);
	
	    return _possibleConstructorReturn(this, (SearchTitle.__proto__ || Object.getPrototypeOf(SearchTitle)).apply(this, arguments));
	  }
	
	  _createClass(SearchTitle, [{
	    key: 'renderSearchTitle',
	    value: function renderSearchTitle() {
	      var _props = this.props,
	          query = _props.query,
	          title = _props.title,
	          titleKey = _props.titleKey,
	          searchType = _props.searchType,
	          intl = _props.intl,
	          broadened = _props.broadened;
	
	
	      var localizedSearchType = intl.formatMessage({
	        id: 'Search.searchTypes.' + (broadened ? 'bkw' : searchType)
	      });
	      var localizedTitle = titleKey ? intl.formatMessage({ id: titleKey }) : null;
	
	      return _react2.default.createElement(
	        'h1',
	        { key: 'titleForCurrentSearch', 'data-test-id': 'searchTitle', className: 'search-query' },
	        title || localizedTitle || _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'SearchTitle.typeResultsForQuery', values: { type: localizedSearchType, query: _react2.default.createElement(
	              'strong',
	              null,
	              query
	            ) } })
	      );
	    }
	  }, {
	    key: 'renderBroadenSearchLink',
	    value: function renderBroadenSearchLink() {
	      var _props2 = this.props,
	          broadened = _props2.broadened,
	          broadenedSearchType = _props2.broadenedSearchType,
	          query = _props2.query,
	          searchType = _props2.searchType;
	
	
	      return _react2.default.createElement(_BroadenSearchLink2.default, {
	        query: query,
	        searchType: searchType,
	        broadenedSearchType: broadenedSearchType,
	        isBroadened: broadened });
	    }
	  }, {
	    key: 'renderDidYouMean',
	    value: function renderDidYouMean() {
	      var _props3 = this.props,
	          handleDidYouMeanImpression = _props3.handleDidYouMeanImpression,
	          didYouMeanQuerySuggestion = _props3.didYouMeanQuerySuggestion,
	          didYouMeanResultCount = _props3.didYouMeanResultCount,
	          showDidYouMean = _props3.showDidYouMean;
	
	
	      return showDidYouMean && _react2.default.createElement(_DidYouMean2.default, {
	        key: 'did-you-mean',
	        handleDidYouMeanImpression: handleDidYouMeanImpression,
	        querySuggestion: didYouMeanQuerySuggestion,
	        resultCount: didYouMeanResultCount });
	    }
	  }, {
	    key: 'renderDidNotFindDropdown',
	    value: function renderDidNotFindDropdown() {
	      var _props4 = this.props,
	          didNotFindOptions = _props4.didNotFindOptions,
	          query = _props4.query,
	          searchType = _props4.searchType,
	          showExternalSearchLink = _props4.showExternalSearchLink;
	
	
	      return didNotFindOptions.get('isEnabled') ? _react2.default.createElement(_DidNotFindDropdown2.default, {
	        query: query,
	        searchType: searchType,
	        showExternalSearchLink: showExternalSearchLink,
	        didNotFindOptions: didNotFindOptions }) : _react2.default.createElement(
	        'div',
	        { className: 'external-search-link' },
	        _react2.default.createElement(_ExternalSearchLink2.default, { query: query, searchType: searchType })
	      );
	    }
	  }, {
	    key: 'renderSavedSearchLink',
	    value: function renderSavedSearchLink(updateWorkflow) {
	      if (!this.context.mobileApp) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'saved-search-link' },
	          _react2.default.createElement(
	            _baseButtons.TextButton,
	            {
	              handleClick: function handleClick() {
	                return updateWorkflow(_WorkflowConstants.SAVED_SEARCH_WORKFLOW);
	              },
	              className: 'save-search-link',
	              'data-test-id': 'save-search-link' },
	            _react2.default.createElement(_baseIcons.Heart, null),
	            this.props.intl.formatMessage({ id: 'save_search' })
	          )
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderModifyLink',
	    value: function renderModifyLink() {
	      var _props5 = this.props,
	          customEdit = _props5.customEdit,
	          intl = _props5.intl,
	          query = _props5.query,
	          searchType = _props5.searchType;
	
	      var searchUrl = '/search?custom_edit=' + customEdit + '&query=' + encodeURIComponent(query);
	
	      if (searchType !== 'bl' || this.context.mobileApp) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'a',
	        { href: searchUrl, className: 'modify-search-link', 'data-test-id': 'modify-search-link' },
	        intl.formatMessage({ id: 'form_label_modify_my_search' })
	      );
	    }
	  }, {
	    key: 'renderRSSButton',
	    value: function renderRSSButton() {
	      var rssURL = this.props.rssURL;
	
	
	      if (!this.context.mobileApp) {
	        return _react2.default.createElement(
	          'span',
	          { className: 'rss-button' },
	          _react2.default.createElement(_RSSButton2.default, { url: rssURL })
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props6 = this.props,
	          query = _props6.query,
	          title = _props6.title,
	          titleKey = _props6.titleKey,
	          suppress = _props6.suppress;
	
	
	      return _react2.default.createElement(
	        _WorkflowContainer2.default,
	        { id: this.props.id },
	        function (workflowComponent, workflowActions) {
	          return workflowComponent || _react2.default.createElement(
	            'div',
	            { className: 'row cp-search-title', 'data-test-id': 'search-title' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-12 search-title-block', 'aria-atomic': 'true' },
	              _react2.default.createElement(
	                'div',
	                { className: 'search-term' },
	                _react2.default.createElement(
	                  _MessagingContainer2.default,
	                  { id: 'searchTitle' },
	                  SearchTitle.renderMessaging
	                ),
	                query || title || titleKey ? _this2.renderSearchTitle() : _react2.default.createElement('noop', null),
	                _this2.renderSavedSearchLink(workflowActions.updateWorkflow),
	                _this2.renderRSSButton()
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-12 search-links' },
	              !suppress && query ? _this2.renderBroadenSearchLink() : null,
	              _this2.renderModifyLink(),
	              _this2.renderDidYouMean(),
	              _this2.renderDidNotFindDropdown(),
	              _react2.default.createElement(
	                'div',
	                { className: 'other-search-tools' },
	                _react2.default.createElement(_SearchProbeContainer2.default, null)
	              )
	            )
	          );
	        }
	      );
	    }
	  }], [{
	    key: 'renderMessaging',
	    value: function renderMessaging(_ref) {
	      var message = _ref.message,
	          clearMessages = _ref.clearMessages;
	
	      if (message.get('type') === 'Success') {
	        return _react2.default.createElement(_sharedMessages.Generic, { message: message, clearMessages: clearMessages });
	      }
	      return _react2.default.createElement(_reactIntl.FormattedMessage, {
	        id: message.get('id'),
	        values: message.get('values'),
	        tagName: 'h1' });
	    }
	  }]);
	
	  return SearchTitle;
	}(_baseBcReactComponent2.default);
	
	SearchTitle.propTypes = {
	  title: _react.PropTypes.string,
	  titleKey: _react.PropTypes.string,
	  customEdit: _react.PropTypes.bool,
	  suppress: _react.PropTypes.bool,
	  intl: _reactIntl.intlShape,
	  searchType: _react.PropTypes.string,
	  query: _react.PropTypes.string,
	  broadenedSearchType: _react.PropTypes.string,
	  broadenedSearchCount: _react.PropTypes.number,
	  broadened: _react.PropTypes.bool,
	  didYouMeanResultCount: _react.PropTypes.number,
	  didYouMeanQuerySuggestion: _react.PropTypes.string,
	  showExternalSearchLink: _react2.default.PropTypes.bool,
	  rssURL: _react.PropTypes.string,
	  didNotFindOptions: _reactImmutableProptypes2.default.map,
	  showDidYouMean: _react.PropTypes.bool
	};
	
	SearchTitle.defaultProps = {
	  showDidYouMean: true
	};
	
	SearchTitle.contextTypes = {
	  mobileApp: _react.PropTypes.bool
	};
	
	exports.default = (0, _reactIntl.injectIntl)(SearchTitle);

/***/ },
/* 1891 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _WorkflowConstants = __webpack_require__(74);
	
	var _MessagingContainer = __webpack_require__(68);
	
	var _MessagingContainer2 = _interopRequireDefault(_MessagingContainer);
	
	var _FeatureFlagContainer = __webpack_require__(147);
	
	var _FeatureFlagContainer2 = _interopRequireDefault(_FeatureFlagContainer);
	
	var _WorkflowContainer = __webpack_require__(243);
	
	var _WorkflowContainer2 = _interopRequireDefault(_WorkflowContainer);
	
	var _SearchProbeContainer = __webpack_require__(638);
	
	var _SearchProbeContainer2 = _interopRequireDefault(_SearchProbeContainer);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseButtons = __webpack_require__(12);
	
	var _sharedMessages = __webpack_require__(64);
	
	var _BroadenSearchLink = __webpack_require__(575);
	
	var _BroadenSearchLink2 = _interopRequireDefault(_BroadenSearchLink);
	
	var _DidYouMean = __webpack_require__(386);
	
	var _DidYouMean2 = _interopRequireDefault(_DidYouMean);
	
	var _ExternalSearchLink = __webpack_require__(287);
	
	var _ExternalSearchLink2 = _interopRequireDefault(_ExternalSearchLink);
	
	__webpack_require__(2557);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SearchTitleDeprecated = function (_BcReactComponent) {
	  _inherits(SearchTitleDeprecated, _BcReactComponent);
	
	  function SearchTitleDeprecated() {
	    _classCallCheck(this, SearchTitleDeprecated);
	
	    return _possibleConstructorReturn(this, (SearchTitleDeprecated.__proto__ || Object.getPrototypeOf(SearchTitleDeprecated)).apply(this, arguments));
	  }
	
	  _createClass(SearchTitleDeprecated, [{
	    key: 'renderSearchPaths',
	    value: function renderSearchPaths() {
	      var _props = this.props,
	          broadened = _props.broadened,
	          broadenedSearchType = _props.broadenedSearchType,
	          query = _props.query,
	          searchType = _props.searchType;
	
	
	      return _react2.default.createElement(_BroadenSearchLink2.default, {
	        query: query,
	        searchType: searchType,
	        broadenedSearchType: broadenedSearchType,
	        isBroadened: broadened });
	    }
	  }, {
	    key: 'renderSearchTitle',
	    value: function renderSearchTitle() {
	      var _props2 = this.props,
	          query = _props2.query,
	          title = _props2.title,
	          titleKey = _props2.titleKey,
	          searchType = _props2.searchType,
	          intl = _props2.intl,
	          broadened = _props2.broadened;
	
	      var localizedSearchType = intl.formatMessage({
	        id: 'Search.searchTypes.' + (broadened ? 'bkw' : searchType)
	      });
	      var localizedTitle = titleKey ? intl.formatMessage({ id: titleKey }) : null;
	      return _react2.default.createElement(
	        'h1',
	        { key: 'titleForCurrentSearch', 'data-test-id': 'searchTitle', className: 'search-query' },
	        title || localizedTitle || intl.formatMessage({ id: 'SearchTitle.typeResultsForQuery' }, { type: localizedSearchType, query: query })
	      );
	    }
	  }, {
	    key: 'renderSavedSearchLink',
	    value: function renderSavedSearchLink(updateWorkflow) {
	      if (!this.context.mobileApp) {
	        return _react2.default.createElement(
	          _baseButtons.TextButton,
	          { handleClick: function handleClick() {
	              return updateWorkflow(_WorkflowConstants.SAVED_SEARCH_WORKFLOW);
	            }, className: 'save-search-link', 'data-test-id': 'save-search-link' },
	          this.props.intl.formatMessage({ id: 'save_search' })
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderModifyLink',
	    value: function renderModifyLink() {
	      var _props3 = this.props,
	          customEdit = _props3.customEdit,
	          intl = _props3.intl,
	          query = _props3.query,
	          searchType = _props3.searchType;
	
	      var searchUrl = '/search?custom_edit=' + customEdit + '&query=' + encodeURIComponent(query);
	
	      if (searchType !== 'bl' || this.context.mobileApp) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'a',
	        { href: searchUrl, className: 'modify-search-link', 'data-test-id': 'modify-search-link' },
	        intl.formatMessage({ id: 'form_label_modify_my_search' })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props4 = this.props,
	          query = _props4.query,
	          title = _props4.title,
	          titleKey = _props4.titleKey,
	          suppress = _props4.suppress,
	          searchType = _props4.searchType,
	          didYouMeanQuerySuggestion = _props4.didYouMeanQuerySuggestion,
	          didYouMeanResultCount = _props4.didYouMeanResultCount,
	          handleDidYouMeanImpression = _props4.handleDidYouMeanImpression,
	          showExternalSearchLink = _props4.showExternalSearchLink;
	
	      return _react2.default.createElement(
	        _WorkflowContainer2.default,
	        { id: this.props.id },
	        function (workflowComponent, workflowActions) {
	          return workflowComponent || _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-12 cp-search-title-deprecated', 'aria-atomic': 'true', 'data-test-id': 'search-title' },
	              _react2.default.createElement(
	                'div',
	                { className: 'search-term' },
	                _react2.default.createElement(
	                  _MessagingContainer2.default,
	                  { id: 'searchTitle' },
	                  SearchTitleDeprecated.renderMessaging
	                ),
	                query || title || titleKey ? _this2.renderSearchTitle() : _react2.default.createElement('noop', null),
	                _react2.default.createElement(_DidYouMean2.default, {
	                  key: 'did-you-mean',
	                  handleDidYouMeanImpression: handleDidYouMeanImpression,
	                  querySuggestion: didYouMeanQuerySuggestion,
	                  resultCount: didYouMeanResultCount })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'search-tools' },
	                _react2.default.createElement(
	                  _FeatureFlagContainer2.default,
	                  null,
	                  function (flags) {
	                    return flags.get('savedSearch') ? _this2.renderSavedSearchLink(workflowActions.updateWorkflow) : null;
	                  }
	                ),
	                showExternalSearchLink ? _react2.default.createElement(_ExternalSearchLink2.default, { query: query, searchType: searchType }) : null,
	                !suppress && query ? _this2.renderSearchPaths() : null,
	                _this2.renderModifyLink(),
	                _react2.default.createElement(_SearchProbeContainer2.default, null)
	              )
	            )
	          );
	        }
	      );
	    }
	  }], [{
	    key: 'renderMessaging',
	    value: function renderMessaging(_ref) {
	      var message = _ref.message,
	          clearMessages = _ref.clearMessages;
	
	      if (message.get('type') === 'Success') {
	        return _react2.default.createElement(_sharedMessages.Generic, { message: message, clearMessages: clearMessages });
	      }
	      return _react2.default.createElement(_reactIntl.FormattedMessage, {
	        id: message.get('id'),
	        values: message.get('values'),
	        tagName: 'h1' });
	    }
	  }]);
	
	  return SearchTitleDeprecated;
	}(_baseBcReactComponent2.default);
	
	SearchTitleDeprecated.propTypes = {
	  title: _react.PropTypes.string,
	  titleKey: _react.PropTypes.string,
	  customEdit: _react.PropTypes.bool,
	  suppress: _react.PropTypes.bool,
	  intl: _reactIntl.intlShape,
	  searchType: _react.PropTypes.string,
	  query: _react.PropTypes.string,
	  broadenedSearchType: _react.PropTypes.string,
	  broadenedSearchCount: _react.PropTypes.number,
	  broadened: _react.PropTypes.bool,
	  didYouMeanResultCount: _react.PropTypes.number,
	  didYouMeanQuerySuggestion: _react.PropTypes.string,
	  showExternalSearchLink: _react2.default.PropTypes.bool
	};
	
	SearchTitleDeprecated.contextTypes = {
	  mobileApp: _react.PropTypes.bool
	};
	
	exports.default = (0, _reactIntl.injectIntl)(SearchTitleDeprecated);

/***/ },
/* 1892 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(16);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseDropdown = __webpack_require__(37);
	
	__webpack_require__(2558);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SearchTypeDropdown = function (_BcReactComponent) {
	  _inherits(SearchTypeDropdown, _BcReactComponent);
	
	  function SearchTypeDropdown() {
	    _classCallCheck(this, SearchTypeDropdown);
	
	    return _possibleConstructorReturn(this, (SearchTypeDropdown.__proto__ || Object.getPrototypeOf(SearchTypeDropdown)).apply(this, arguments));
	  }
	
	  _createClass(SearchTypeDropdown, [{
	    key: 'getOptions',
	    value: function getOptions() {
	      var options = _lodash2.default.map(this.props.options, function (option) {
	        return {
	          label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Search.searchTypes.' + option }),
	          value: option
	        };
	      });
	      return options;
	    }
	  }, {
	    key: 'getSelected',
	    value: function getSelected() {
	      return _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Search.searchTypes.' + this.props.selected });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          handleSelect = _props.handleSelect,
	          className = _props.className;
	
	      var labelledById = _lodash2.default.uniqueId('searchTypeDropdown_');
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-search-type-dropdown', 'data-test-id': 'searchType' },
	        _react2.default.createElement(_baseDropdown.Dropdown, {
	          selected: this.getSelected(),
	          className: (0, _classnames2.default)('btn dropdown-toggle btn-flat btn-default', className),
	          options: this.getOptions(),
	          handleSelect: handleSelect,
	          labelledById: labelledById,
	          labelLocalizedText: SearchTypeDropdown.getAriaLabel() })
	      );
	    }
	  }], [{
	    key: 'getAriaLabel',
	    value: function getAriaLabel() {
	      return _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'searchTypeDropdownLabel' });
	    }
	  }]);
	
	  return SearchTypeDropdown;
	}(_baseBcReactComponent2.default);
	
	SearchTypeDropdown.propTypes = {
	  selected: _react.PropTypes.string,
	  options: _react.PropTypes.arrayOf(_react.PropTypes.string),
	  handleSelect: _react.PropTypes.func,
	  className: _react.PropTypes.string
	};
	
	exports.default = SearchTypeDropdown;

/***/ },
/* 1893 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SearchTypeDropdown = __webpack_require__(1892);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SearchTypeDropdown).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1894 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SingleBranchStatusField = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseCheckbox = __webpack_require__(58);
	
	var _baseCheckbox2 = _interopRequireDefault(_baseCheckbox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SingleBranchStatusField = exports.SingleBranchStatusField = function (_BcReactComponent) {
	  _inherits(SingleBranchStatusField, _BcReactComponent);
	
	  function SingleBranchStatusField(props) {
	    _classCallCheck(this, SingleBranchStatusField);
	
	    var _this = _possibleConstructorReturn(this, (SingleBranchStatusField.__proto__ || Object.getPrototypeOf(SingleBranchStatusField)).call(this, props));
	
	    _this.bindAll('handleToggleFilter');
	    return _this;
	  }
	
	  _createClass(SingleBranchStatusField, [{
	    key: 'handleToggleFilter',
	    value: function handleToggleFilter() {
	      this.props.handleToggleFilter(this.props.fieldId, this.props.filter);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          filter = _props.filter,
	          label = _props.label;
	
	      var value = filter.get('value');
	
	      var classString = 'filter';
	      if (filter.get('applied')) {
	        classString += ' applied';
	      }
	      var formattedLabel = this.props.intl.formatMessage({ id: label });
	
	      return _react2.default.createElement(
	        'li',
	        { key: this.props.fieldId + '-' + value, className: classString },
	        _react2.default.createElement(_baseCheckbox2.default, {
	          id: 'field-' + value,
	          handleChange: this.handleToggleFilter,
	          checked: filter.get('applied'),
	          label: formattedLabel })
	      );
	    }
	  }]);
	
	  return SingleBranchStatusField;
	}(_baseBcReactComponent2.default);
	
	SingleBranchStatusField.propTypes = {
	  filter: _reactImmutableProptypes2.default.map,
	  label: _react.PropTypes.string.isRequired,
	  activeFilters: _reactImmutableProptypes2.default.list,
	  intl: _reactIntl.intlShape
	};
	
	exports.default = (0, _reactIntl.injectIntl)(SingleBranchStatusField);

/***/ },
/* 1895 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseJacketViewButton = __webpack_require__(1329);
	
	var _baseJacketViewButton2 = _interopRequireDefault(_baseJacketViewButton);
	
	var _baseListViewButton = __webpack_require__(1331);
	
	var _baseListViewButton2 = _interopRequireDefault(_baseListViewButton);
	
	var _baseGroupedSearchButton = __webpack_require__(1081);
	
	var _baseGroupedSearchButton2 = _interopRequireDefault(_baseGroupedSearchButton);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ViewSelector = function ViewSelector(_ref) {
	  var currentView = _ref.currentView,
	      searchActions = _ref.searchActions,
	      groupedSearchEnabled = _ref.groupedSearchEnabled;
	
	  var toggleSearchView = function toggleSearchView(view) {
	    return searchActions.toggleSearchView(view);
	  };
	  var groupedSearchButton = _react2.default.createElement(_baseGroupedSearchButton2.default, { currentView: currentView, toggleListView: toggleSearchView });
	  var selectorClasses = (0, _classnames2.default)('cp-view-selector', 'btn-group', {
	    'hidden-sm hidden-xs': !groupedSearchEnabled
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { className: selectorClasses },
	    _react2.default.createElement(_baseListViewButton2.default, { className: 'hidden-sm hidden-xs', currentView: currentView, toggleListView: toggleSearchView }),
	    _react2.default.createElement(_baseJacketViewButton2.default, { currentView: currentView, toggleListView: toggleSearchView }),
	    groupedSearchEnabled && groupedSearchButton
	  );
	};
	
	ViewSelector.propTypes = {
	  searchActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  currentView: _react.PropTypes.string.isRequired,
	  groupedSearchEnabled: _react.PropTypes.bool.isRequired
	};
	
	exports.default = ViewSelector;

/***/ },
/* 1896 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ViewSelector = __webpack_require__(1895);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ViewSelector).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1897 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AddTitle = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _addTitle = __webpack_require__(360);
	
	var _addTitle2 = _interopRequireDefault(_addTitle);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _pagination = __webpack_require__(92);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseButtons = __webpack_require__(12);
	
	var _debounce = __webpack_require__(466);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	__webpack_require__(2559);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AddTitle = exports.AddTitle = function (_BcReactComponent) {
	  _inherits(AddTitle, _BcReactComponent);
	
	  function AddTitle(props) {
	    _classCallCheck(this, AddTitle);
	
	    var _this = _possibleConstructorReturn(this, (AddTitle.__proto__ || Object.getPrototypeOf(AddTitle)).call(this, props));
	
	    _this.state = {
	      isUpdatingResultItem: props.isUpdatingResultItem,
	      query: '',
	      doneButtonContainerWidth: 0,
	      isInitialSearch: true
	    };
	    _this.bindAll('handleCatalogueSearch', 'handleCatalogueSearchResults', 'handlePagination', 'handleResize', 'addTitleRef');
	    return _this;
	  }
	
	  _createClass(AddTitle, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.state.isInitialSearch) {
	        var isQueryTheSame = nextProps.searchQuery.get('query') === this.state.query && nextProps.results === this.props.results;
	        var hasResultsChanged = nextProps.results !== this.props.results;
	        if (isQueryTheSame || hasResultsChanged) {
	          this.setState({ isInitialSearch: false });
	        }
	      }
	    }
	  }, {
	    key: 'handleCatalogueSearch',
	    value: function handleCatalogueSearch(query) {
	      var _props = this.props,
	          searchActions = _props.searchActions,
	          searchQuery = _props.searchQuery;
	
	      var curPage = query === searchQuery.get('query') ? searchQuery.get('pagination_page') : 1;
	      searchActions.addTitleSearch(_extends({}, searchQuery.toJS(), { query: query, pagination_page: curPage }));
	      this.setState({ query: query });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('resize', (0, _debounce2.default)(this.handleResize, 100));
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.handleResize);
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize() {
	      if (this._doneButtonContainer && this._addTitleWrapper) {
	        this.setState({ doneButtonContainerWidth: this._addTitleWrapper.offsetWidth + 'px' });
	      }
	    }
	  }, {
	    key: 'handlePagination',
	    value: function handlePagination(page) {
	      var _props2 = this.props,
	          searchActions = _props2.searchActions,
	          searchQuery = _props2.searchQuery;
	
	      searchActions.addTitleSearch(_extends({}, searchQuery.toJS(), { pagination_page: page }));
	    }
	  }, {
	    key: 'renderPagination',
	    value: function renderPagination(focus) {
	      var className = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	      var _props3 = this.props,
	          isFetching = _props3.isFetching,
	          pagination = _props3.pagination;
	
	      return _react2.default.createElement(_pagination2.default, {
	        className: className,
	        autoFocus: focus,
	        isFetching: isFetching,
	        textKey: 'Search.paginationInfo',
	        page: pagination.get('page'),
	        limit: pagination.get('limit'),
	        count: pagination.get('count'),
	        pages: pagination.get('pages'),
	        queryField: 'pagination_page',
	        updatePage: this.handlePagination });
	    }
	  }, {
	    key: 'handleCatalogueSearchResults',
	    value: function handleCatalogueSearchResults() {
	      var _this2 = this;
	
	      var _props4 = this.props,
	          zeroResults = _props4.zeroResults,
	          results = _props4.results,
	          availabilityDetailActions = _props4.availabilityDetailActions,
	          addRowClassNames = _props4.addRowClassNames;
	
	
	      if (this.state.isInitialSearch || zeroResults && !this.state.query) {
	        return null;
	      } else if (zeroResults && this.state.query) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'no-results-found' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'add_title_no_results_found' })
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'pagination-holder' },
	          this.renderPagination(true),
	          _react2.default.createElement(_addTitle.CatalogueResults, {
	            className: 'clearfix',
	            searchResults: results,
	            availabilityDetailActions: availabilityDetailActions,
	            renderAddOn: function renderAddOn(item) {
	              return _this2.props.renderAddOn(item);
	            },
	            addRowClassNames: addRowClassNames }),
	          this.renderPagination(false, 'pagination-right')
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'clearfix done-button-container', style: { width: this.state.doneButtonContainerWidth }, ref: function ref(el) {
	              _this2._doneButtonContainer = el;
	            } },
	          _react2.default.createElement(
	            _baseButtons.PrimaryButton,
	            { className: 'done-button', handleClick: this.props.handleClose },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'done' })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'addTitleRef',
	    value: function addTitleRef(el) {
	      this._addTitleWrapper = el;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props5 = this.props,
	          isFetching = _props5.isFetching,
	          isWrappedInForm = _props5.isWrappedInForm;
	
	      var catalogueSearchOptions = {
	        tabName: 'catalogue search',
	        searchLabel: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'search_by_keyword' }),
	        handleSearch: this.handleCatalogueSearch,
	        renderResults: this.handleCatalogueSearchResults,
	        query: this.state.query
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-shared-add-title' },
	        _react2.default.createElement(
	          'div',
	          { className: 'add-title-wrapper', ref: this.addTitleRef },
	          _react2.default.createElement(_addTitle2.default, { catalogueOptions: catalogueSearchOptions, onUpdateHandle: this.handleResize, searching: isFetching, isWrappedInForm: isWrappedInForm })
	        )
	      );
	    }
	  }]);
	
	  return AddTitle;
	}(_baseBcReactComponent2.default);
	
	AddTitle.propTypes = {
	  searchActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  availabilityDetailActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  searchQuery: _reactImmutableProptypes2.default.map.isRequired,
	  pagination: _reactImmutableProptypes2.default.map.isRequired,
	  zeroResults: _react.PropTypes.bool.isRequired,
	  results: _reactImmutableProptypes2.default.list.isRequired,
	  handleClose: _react.PropTypes.func.isRequired,
	  addRowClassNames: _react.PropTypes.func,
	  renderAddOn: _react.PropTypes.func,
	  isFetching: _react.PropTypes.bool,
	  isWrappedInForm: _react.PropTypes.bool,
	  isUpdatingResultItem: _react.PropTypes.bool
	};
	
	AddTitle.defaultProps = {
	  renderAddOn: function renderAddOn() {},
	  isWrappedInForm: false
	};
	
	exports.default = AddTitle;

/***/ },
/* 1898 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseComboButton = __webpack_require__(1060);
	
	var _baseComboButton2 = _interopRequireDefault(_baseComboButton);
	
	var _baseIcons = __webpack_require__(10);
	
	var Icons = _interopRequireWildcard(_baseIcons);
	
	var _sharedBibScreenReaderDescription = __webpack_require__(365);
	
	var _sharedBibScreenReaderDescription2 = _interopRequireDefault(_sharedBibScreenReaderDescription);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _ShelfConstants = __webpack_require__(43);
	
	__webpack_require__(2561);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultShelfOrder = [_ShelfConstants.SHELF_NAMES.FOR_LATER, _ShelfConstants.SHELF_NAMES.IN_PROGRESS, _ShelfConstants.SHELF_NAMES.COMPLETED];
	
	var AddToShelfComboButton = function (_BcReactComponent) {
	  _inherits(AddToShelfComboButton, _BcReactComponent);
	
	  function AddToShelfComboButton() {
	    _classCallCheck(this, AddToShelfComboButton);
	
	    return _possibleConstructorReturn(this, (AddToShelfComboButton.__proto__ || Object.getPrototypeOf(AddToShelfComboButton)).apply(this, arguments));
	  }
	
	  _createClass(AddToShelfComboButton, [{
	    key: 'renderAddToShelfButtonContent',
	    value: function renderAddToShelfButtonContent(name) {
	      var formattedShelfName = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'label_shelf_' + name });
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement(Icons.ShelfItem, { color: 'currentColor' }),
	        _react2.default.createElement(
	          'span',
	          { className: 'shelf-name-text', 'aria-hidden': 'true' },
	          formattedShelfName
	        ),
	        _react2.default.createElement(
	          _baseScreenReaderMessage2.default,
	          null,
	          this.renderShelfSrMessage(formattedShelfName)
	        )
	      );
	    }
	  }, {
	    key: 'getContentScreenReaderTitle',
	    value: function getContentScreenReaderTitle() {
	      var bibBrief = this.props.bibBrief;
	
	
	      return bibBrief ? _react2.default.createElement(_sharedBibScreenReaderDescription2.default, { bibBrief: bibBrief }) : _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'selected_items' });
	    }
	  }, {
	    key: 'renderShelfSrMessage',
	    value: function renderShelfSrMessage(shelfName) {
	      return _react2.default.createElement(_reactIntl.FormattedMessage, {
	        id: 'ada_add_to_named_shelf',
	        values: {
	          title: this.getContentScreenReaderTitle(),
	          shelf: shelfName
	        } });
	    }
	  }, {
	    key: 'getShelfOptions',
	    value: function getShelfOptions() {
	      var _this2 = this;
	
	      var shelfNamesOrder = this.props.primaryShelfAction ? this.setPrimaryShelfOption() : defaultShelfOrder;
	
	      return shelfNamesOrder.map(function (name) {
	        return {
	          label: _this2.renderAddToShelfButtonContent(name),
	          value: name
	        };
	      });
	    }
	  }, {
	    key: 'setPrimaryShelfOption',
	    value: function setPrimaryShelfOption() {
	      var _this3 = this;
	
	      return [this.props.primaryShelfAction].concat(_toConsumableArray(defaultShelfOrder.filter(function (shelf) {
	        return shelf !== _this3.props.primaryShelfAction;
	      })));
	    }
	  }, {
	    key: 'renderSecondaryAriaLabel',
	    value: function renderSecondaryAriaLabel() {
	      return _react2.default.createElement(_reactIntl.FormattedMessage, {
	        id: 'ada_add_to_different_shelf',
	        values: { title: this.getContentScreenReaderTitle() } });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-add-to-shelf-combo-button' },
	        _react2.default.createElement(
	          _baseComboButton2.default,
	          {
	            ButtonTag: this.props.ButtonTag,
	            right: true,
	            disabled: this.props.disabled,
	            isLoading: this.props.isLoading,
	            options: this.getShelfOptions(),
	            secondaryAriaLabel: this.renderSecondaryAriaLabel(),
	            handleClick: this.props.handleClick,
	            dataKey: 'bib-shelf-button' },
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return AddToShelfComboButton;
	}(_baseBcReactComponent2.default);
	
	exports.default = AddToShelfComboButton;
	
	
	AddToShelfComboButton.propTypes = {
	  disabled: _react.PropTypes.bool,
	  children: _bcPropTypes.childrenShape,
	  handleClick: _react.PropTypes.func,
	  bibBrief: _bcPropTypes.bibBriefShape,
	  isLoading: _react.PropTypes.bool,
	  ButtonTag: _react.PropTypes.oneOfType([_react.PropTypes.instanceOf(_baseBcReactComponent2.default), _react.PropTypes.func]),
	  primaryShelfAction: _react.PropTypes.string
	};

/***/ },
/* 1899 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(17);
	
	var _reactRedux = __webpack_require__(14);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _AuthSelector = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AuthenticatedRoute = function (_BcReactComponent) {
	  _inherits(AuthenticatedRoute, _BcReactComponent);
	
	  function AuthenticatedRoute() {
	    _classCallCheck(this, AuthenticatedRoute);
	
	    return _possibleConstructorReturn(this, (AuthenticatedRoute.__proto__ || Object.getPrototypeOf(AuthenticatedRoute)).apply(this, arguments));
	  }
	
	  _createClass(AuthenticatedRoute, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          isAuthenticated = _props.isAuthenticated,
	          router = _props.router;
	
	      if (!isAuthenticated) {
	        window.location = '/user/login?destination=' + encodeURIComponent('' + router.location.pathname + router.location.search);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.isAuthenticated ? this.props.children : null;
	    }
	  }]);
	
	  return AuthenticatedRoute;
	}(_baseBcReactComponent2.default);
	
	AuthenticatedRoute.requiresAuthentication = true;
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    isAuthenticated: !!(0, _AuthSelector.currentUserSelector)(state)
	  };
	};
	
	AuthenticatedRoute.propTypes = {
	  children: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.arrayOf(_react2.default.PropTypes.node), _react2.default.PropTypes.node]).isRequired,
	  isAuthenticated: _react2.default.PropTypes.bool,
	  router: _reactRouter.routerShape
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(AuthenticatedRoute);

/***/ },
/* 1900 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AuthenticatedRoute = __webpack_require__(1899);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AuthenticatedRoute).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1901 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AvailabilityDetailOverlay = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _baseTabs = __webpack_require__(525);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _sharedBibBrief = __webpack_require__(46);
	
	var _sharedBibBrief2 = _interopRequireDefault(_sharedBibBrief);
	
	var _baseFullScreenOverlay = __webpack_require__(45);
	
	var _baseFullScreenOverlay2 = _interopRequireDefault(_baseFullScreenOverlay);
	
	var _sharedJacketCover = __webpack_require__(93);
	
	var _sharedJacketCover2 = _interopRequireDefault(_sharedJacketCover);
	
	var _baseTable = __webpack_require__(91);
	
	var _AvailabilityTable = __webpack_require__(1904);
	
	var _AvailabilityTable2 = _interopRequireDefault(_AvailabilityTable);
	
	var _DocumentHeadContainer = __webpack_require__(52);
	
	var _DocumentHeadContainer2 = _interopRequireDefault(_DocumentHeadContainer);
	
	var _HoldingsProbeContainer = __webpack_require__(2073);
	
	var _HoldingsProbeContainer2 = _interopRequireDefault(_HoldingsProbeContainer);
	
	var _StackMapContainer = __webpack_require__(2091);
	
	var _StackMapContainer2 = _interopRequireDefault(_StackMapContainer);
	
	var _formatIndicator = __webpack_require__(177);
	
	var _formatIndicator2 = _interopRequireDefault(_formatIndicator);
	
	var _MarcHoldingsTable = __webpack_require__(1968);
	
	var _MarcHoldingsTable2 = _interopRequireDefault(_MarcHoldingsTable);
	
	var _SubscriptionTable = __webpack_require__(1976);
	
	var _SubscriptionTable2 = _interopRequireDefault(_SubscriptionTable);
	
	var _EResourceBlock = __webpack_require__(1923);
	
	var _EResourceBlock2 = _interopRequireDefault(_EResourceBlock);
	
	__webpack_require__(2562);
	
	var _baseAlerts = __webpack_require__(36);
	
	var _utilsItem = __webpack_require__(232);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  bib: _react.PropTypes.object.isRequired,
	  handleClose: _react.PropTypes.func.isRequired,
	  open: _react.PropTypes.bool,
	  intl: _reactIntl.intlShape,
	  availabilityDetail: _react.PropTypes.shape({
	    marcHoldings: _react.PropTypes.object,
	    subscriptions: _react.PropTypes.object,
	    items: _react.PropTypes.object,
	    format: _react.PropTypes.string,
	    jacket: _react.PropTypes.object,
	    title: _react.PropTypes.string,
	    subtitle: _react.PropTypes.string
	  }),
	  stackMap: _reactImmutableProptypes2.default.mapContains({
	    enabled: _react.PropTypes.bool,
	    branches: _reactImmutableProptypes2.default.listOf(_react.PropTypes.string),
	    domain: _react.PropTypes.string
	  }),
	  openStackMap: _react.PropTypes.func.isRequired,
	  disableClose: _react.PropTypes.bool,
	  standalone: _react.PropTypes.bool,
	  showDueDateInCirc: _react.PropTypes.bool,
	  showCollectionInCirc: _react.PropTypes.bool,
	  isILSDown: _react.PropTypes.bool
	};
	
	var AvailabilityDetailOverlay = exports.AvailabilityDetailOverlay = function (_BcReactComponent) {
	  _inherits(AvailabilityDetailOverlay, _BcReactComponent);
	
	  function AvailabilityDetailOverlay(props) {
	    _classCallCheck(this, AvailabilityDetailOverlay);
	
	    var _this = _possibleConstructorReturn(this, (AvailabilityDetailOverlay.__proto__ || Object.getPrototypeOf(AvailabilityDetailOverlay)).call(this, props));
	
	    _this.bindAll('renderAvailabilityTables', 'renderSubscriptionTables', 'renderMarcHoldingsTables');
	    return _this;
	  }
	
	  _createClass(AvailabilityDetailOverlay, [{
	    key: 'renderSubscriptionTables',
	    value: function renderSubscriptionTables() {
	      var intl = this.props.intl;
	      var subscriptions = this.props.availabilityDetail.subscriptions;
	
	      if (subscriptions && subscriptions.size < 1) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        _baseTabs.TabContent,
	        { eventKey: 1, label: intl.formatMessage({ id: 'availability_modal_tab_subscription' }) },
	        _react2.default.createElement(_SubscriptionTable2.default, { subscriptions: subscriptions })
	      );
	    }
	  }, {
	    key: 'renderMarcHoldingsTables',
	    value: function renderMarcHoldingsTables() {
	      var intl = this.props.intl;
	      var marcHoldings = this.props.availabilityDetail.marcHoldings;
	
	      if (marcHoldings && marcHoldings.size < 1) {
	        return null;
	      }
	      return _react2.default.createElement(
	        _baseTabs.TabContent,
	        { eventKey: 2, label: intl.formatMessage({ id: 'availability_modal_tab_marc_holdings' }) },
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Marc Holdings'
	        ),
	        _react2.default.createElement(_MarcHoldingsTable2.default, { rows: marcHoldings })
	      );
	    }
	  }, {
	    key: 'renderAvailabilityTables',
	    value: function renderAvailabilityTables() {
	      var _props = this.props,
	          intl = _props.intl,
	          stackMap = _props.stackMap,
	          openStackMap = _props.openStackMap,
	          showDueDateInCirc = _props.showDueDateInCirc,
	          showCollectionInCirc = _props.showCollectionInCirc;
	
	      var itemGroup = this.props.availabilityDetail.items;
	      if (!itemGroup || itemGroup.size < 1) {
	        return null;
	      }
	
	      var tables = itemGroup.map(function (availability) {
	        return _react2.default.createElement(_AvailabilityTable2.default, {
	          stackMap: stackMap,
	          openStackMap: openStackMap,
	          key: availability.get('key'),
	          status: availability.get('status'),
	          rows: availability.get('items'),
	          showDueDateInCirc: showDueDateInCirc,
	          showCollectionInCirc: showCollectionInCirc });
	      });
	
	      return _react2.default.createElement(
	        _baseTabs.TabContent,
	        { eventKey: 0, label: intl.formatMessage({ id: 'availability_modal_tab_circulation' }) },
	        tables
	      );
	    }
	  }, {
	    key: 'renderEResources',
	    value: function renderEResources() {
	      var url = this.props.bib.getIn(['availability', 'eresourceUrl']);
	      var description = this.props.bib.getIn(['availability', 'eresourceDescription']);
	      if (url) {
	        // TODO: This should be updated to use pass in all eResources instead
	        var eResources = _immutable2.default.List.of(_immutable2.default.Map({ description: description, url: url }));
	        return _react2.default.createElement(_EResourceBlock2.default, { eResources: eResources, format: this.props.bib.getIn(['briefInfo', 'format']) });
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderOverlayContent',
	    value: function renderOverlayContent() {
	      if (this.props.open) {
	        var _props2 = this.props,
	            bib = _props2.bib,
	            isILSDown = _props2.isILSDown;
	
	        var bibCoverAltText = (0, _utilsItem.bibJacketCoverAltText)(bib.getIn(['briefInfo', 'title']), bib.getIn(['briefInfo', 'authors']));
	
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_reactIntl.FormattedMessage, { tagName: 'h2', id: 'availabilityFor' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'availability-title-block' },
	            _react2.default.createElement(
	              'div',
	              { className: 'availability-title-block-jacket' },
	              _react2.default.createElement(_sharedJacketCover2.default, {
	                src: bib.getIn(['briefInfo', 'jacket']),
	                format: bib.getIn(['briefInfo', 'format']),
	                alt: bibCoverAltText })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'availability-title-block-brief' },
	              _react2.default.createElement(_sharedBibBrief2.default, {
	                bib: bib.get('briefInfo'),
	                titleTag: 'h1',
	                renderAuthorsAsLink: !this.context.mobileApp }),
	              _react2.default.createElement(_formatIndicator2.default, { format: bib.getIn(['briefInfo', 'format']) }),
	              _react2.default.createElement(
	                'span',
	                null,
	                ' \u2013 ',
	                bib.getIn(['briefInfo', 'publicationDate'])
	              ),
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                'span',
	                null,
	                this.props.intl.formatMessage({ id: 'totalCopies' }, { totalCopies: bib.getIn(['availability', 'totalCopies']) })
	              )
	            ),
	            _react2.default.createElement(_HoldingsProbeContainer2.default, { id: this.props.bib.get('id') })
	          ),
	          _react2.default.createElement('hr', null),
	          isILSDown && _react2.default.createElement(
	            _baseAlerts.AlertFailure,
	            null,
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'errors_ils_item_availability_error' })
	          ),
	          this.renderEResources(),
	          this.renderTabs()
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderTabs',
	    value: function renderTabs() {
	      if (this.props.isFetching) {
	        return _react2.default.createElement(_baseTable.Placeholder, null);
	      }
	
	      return _react2.default.createElement(
	        _baseTabs.Tabs,
	        { defaultActiveKey: 0 },
	        this.renderAvailabilityTables(),
	        this.renderSubscriptionTables()
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var intl = this.props.intl;
	
	      var className = (0, _classnames2.default)('cp-availability-details-overlay', { 'is-standalone': this.props.standalone });
	      return _react2.default.createElement(
	        _baseFullScreenOverlay2.default,
	        { open: this.props.open, handleClose: this.props.handleClose, disableHistoryControls: true, disableClose: this.props.disableClose, className: className },
	        _react2.default.createElement(_DocumentHeadContainer2.default, { pageTitle: intl.formatMessage({ id: 'availabilityForTitle' }, { title: this.props.bib.getIn(['briefInfo', 'title']) }) }),
	        this.renderOverlayContent(),
	        _react2.default.createElement(_StackMapContainer2.default, null)
	      );
	    }
	  }]);
	
	  return AvailabilityDetailOverlay;
	}(_baseBcReactComponent2.default);
	
	AvailabilityDetailOverlay.propTypes = propTypes;
	
	AvailabilityDetailOverlay.contextTypes = {
	  mobileApp: _react.PropTypes.bool
	};
	
	exports.default = (0, _reactIntl.injectIntl)(AvailabilityDetailOverlay);

/***/ },
/* 1902 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AvailabilityDetailOverlay = __webpack_require__(1901);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AvailabilityDetailOverlay).default;
	  }
	});
	Object.defineProperty(exports, 'AvailabilityDetailOverlay', {
	  enumerable: true,
	  get: function get() {
	    return _AvailabilityDetailOverlay.AvailabilityDetailOverlay;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1903 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AvailabilityTable = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _reactIntl = __webpack_require__(3);
	
	var _naturalSortBy = __webpack_require__(1431);
	
	var _naturalSortBy2 = _interopRequireDefault(_naturalSortBy);
	
	var _baseTable = __webpack_require__(91);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseIcons = __webpack_require__(10);
	
	var _baseButtons = __webpack_require__(12);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	var _injectLibrary = __webpack_require__(396);
	
	var _injectLibrary2 = _interopRequireDefault(_injectLibrary);
	
	__webpack_require__(2563);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AvailabilityTable = exports.AvailabilityTable = function (_BcReactComponent) {
	  _inherits(AvailabilityTable, _BcReactComponent);
	
	  function AvailabilityTable(props) {
	    _classCallCheck(this, AvailabilityTable);
	
	    var _this = _possibleConstructorReturn(this, (AvailabilityTable.__proto__ || Object.getPrototypeOf(AvailabilityTable)).call(this, props));
	
	    _this.bindAll('renderStatus');
	    return _this;
	  }
	
	  _createClass(AvailabilityTable, [{
	    key: 'shouldRenderStackMap',
	    value: function shouldRenderStackMap(item) {
	      var stackMap = this.props.stackMap;
	
	
	      return stackMap.get('enabled') && item.get('collection') && item.get('callNumber') && stackMap.get('supportedBranches').includes(item.getIn(['branch', 'name'])) && item.getIn(['availability', 'status']) !== 'UNAVAILABLE';
	    }
	  }, {
	    key: 'renderStatus',
	    value: function renderStatus(value, index) {
	      var _this2 = this;
	
	      var item = this.props.rows.get(index);
	      var stackMap = this.props.stackMap;
	      var renderStackMapLink = this.shouldRenderStackMap(item);
	
	      if (renderStackMapLink) {
	        return _react2.default.createElement(
	          'span',
	          null,
	          value,
	          _react2.default.createElement(
	            _baseButtons.TextButton,
	            { handleClick: function handleClick() {
	                return _this2.props.openStackMap(stackMap, item);
	              }, className: 'stackmap-link' },
	            _react2.default.createElement(_baseIcons.Location, null),
	            _react2.default.createElement(
	              _reactIntl.FormattedMessage,
	              { id: 'map_it' },
	              function (message) {
	                return _react2.default.createElement(
	                  'span',
	                  { 'aria-hidden': true },
	                  message
	                );
	              }
	            ),
	            _react2.default.createElement(
	              _baseScreenReaderMessage2.default,
	              null,
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ada_map_it', values: { branch: item.getIn(['branch', 'name']) } })
	            ),
	            _react2.default.createElement(_baseIcons.Arrows.long.Right, { color: 'currentColor' })
	          )
	        );
	      }
	
	      return value;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          intl = _props.intl,
	          rows = _props.rows,
	          status = _props.status,
	          singleBranch = _props.singleBranch,
	          showDueDateInCirc = _props.showDueDateInCirc,
	          showCollectionInCirc = _props.showCollectionInCirc;
	
	      var count = rows.size;
	      var inSiteScope = rows.first().get('inSiteScope');
	      var fields = [{ key: 'callNumber', type: 'String', sort: AvailabilityTable.handleAlphanumericSort }, { key: 'volume', type: 'String', sort: AvailabilityTable.handleAlphanumericSort }, { key: 'copy', type: 'String', sort: AvailabilityTable.handleAlphanumericSort }, { key: 'availability.libraryStatus', type: 'String', sort: AvailabilityTable.handleAlphanumericSort, transformationMap: this.renderStatus }];
	
	      if (showCollectionInCirc) {
	        fields = [{ key: 'collection', type: 'String', sort: AvailabilityTable.handleAlphanumericSort }].concat(_toConsumableArray(fields));
	      }
	
	      if (showDueDateInCirc) {
	        fields = [].concat(_toConsumableArray(fields), [{ key: 'dueDate', type: 'Date', sort: AvailabilityTable.handleAlphanumericSort }]);
	      }
	
	      if (!singleBranch) {
	        fields = [{ key: 'branchName', type: 'String', sort: AvailabilityTable.handleAlphanumericSort }].concat(_toConsumableArray(fields));
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-availability-table' },
	        _react2.default.createElement(
	          _reactIntl.FormattedMessage,
	          {
	            id: 'CircTableTitle',
	            values: {
	              status: intl.formatMessage({ id: 'circ_table_' + status.toLowerCase() }),
	              count: count,
	              inSiteScope: inSiteScope ? 'yes' : 'no'
	            } },
	          function (string) {
	            return _react2.default.createElement(
	              'h4',
	              { className: status.toLowerCase() },
	              string
	            );
	          }
	        ),
	        _react2.default.createElement(_baseTable.Table, {
	          rows: rows,
	          fields: fields,
	          sortable: true })
	      );
	    }
	  }], [{
	    key: 'handleAlphanumericSort',
	    value: function handleAlphanumericSort(items, sortField, sortDirection) {
	      return items.sort((0, _naturalSortBy2.default)(sortField, sortDirection));
	    }
	  }]);
	
	  return AvailabilityTable;
	}(_baseBcReactComponent2.default);
	
	AvailabilityTable.propTypes = {
	  rows: _reactImmutableProptypes2.default.list.isRequired,
	  status: _react.PropTypes.string.isRequired,
	  singleBranch: _react.PropTypes.bool.isRequired,
	  intl: _reactIntl.intlShape,
	  stackMap: _reactImmutableProptypes2.default.mapContains({
	    enabled: _react.PropTypes.bool,
	    branches: _reactImmutableProptypes2.default.listOf(_react.PropTypes.string),
	    domain: _react.PropTypes.string
	  }),
	  openStackMap: _react.PropTypes.func.isRequired,
	  showDueDateInCirc: _react.PropTypes.bool,
	  showCollectionInCirc: _react.PropTypes.bool
	};
	
	AvailabilityTable.displayName = 'AvailabilityTable';
	
	var mapLibraryToProps = function mapLibraryToProps(_ref) {
	  var library = _ref.library;
	  return { singleBranch: library.get('singleBranch') };
	};
	
	exports.default = (0, _reactIntl.injectIntl)((0, _injectLibrary2.default)(mapLibraryToProps)(AvailabilityTable));

/***/ },
/* 1904 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AvailabilityTable = __webpack_require__(1903);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AvailabilityTable).default;
	  }
	});
	Object.defineProperty(exports, 'AvailabilityTable', {
	  enumerable: true,
	  get: function get() {
	    return _AvailabilityTable.AvailabilityTable;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1905 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = BatchActionLink;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _bcPropTypes = __webpack_require__(5);
	
	__webpack_require__(2565);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function BatchActionLink(_ref) {
	  var className = _ref.className,
	      disabled = _ref.disabled,
	      href = _ref.href,
	      children = _ref.children,
	      handleClick = _ref.handleClick;
	
	  if (disabled) {
	    return _react2.default.createElement(
	      'span',
	      { className: (0, _classnames2.default)('cp-batch-action-link', 'btn disabled', className) },
	      children
	    );
	  }
	
	  return _react2.default.createElement(
	    'a',
	    { className: (0, _classnames2.default)('cp-batch-action-link', className), href: href, onClick: handleClick },
	    children
	  );
	}
	
	BatchActionLink.propTypes = {
	  className: _react.PropTypes.string,
	  disabled: _react.PropTypes.bool,
	  href: _react.PropTypes.string,
	  children: _bcPropTypes.childrenShape,
	  handleClick: _react.PropTypes.func
	};

/***/ },
/* 1906 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = BatchActionsControls;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _baseCheckbox = __webpack_require__(58);
	
	var _baseCheckbox2 = _interopRequireDefault(_baseCheckbox);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseStickyToolbar = __webpack_require__(1346);
	
	var _baseStickyToolbar2 = _interopRequireDefault(_baseStickyToolbar);
	
	__webpack_require__(2566);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function BatchActionsControls(_ref) {
	  var list = _ref.list,
	      updateAll = _ref.updateAll,
	      selectedItems = _ref.selectedItems,
	      sticky = _ref.sticky,
	      children = _ref.children;
	
	  var Tag = sticky ? _baseStickyToolbar2.default : 'div';
	  return _react2.default.createElement(
	    Tag,
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'cp-batch-action-controls' },
	      _react2.default.createElement(
	        'div',
	        { className: 'master-checkbox' },
	        _react2.default.createElement(
	          _reactIntl.FormattedMessage,
	          { id: 'batch_action_select_items', values: { count: list.size } },
	          function (label) {
	            return _react2.default.createElement(_baseCheckbox2.default, { id: 'batch-actions-master', inline: true, handleChange: updateAll, checked: selectedItems.size === list.size, label: label });
	          }
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'action-buttons' },
	        children
	      )
	    )
	  );
	}
	
	BatchActionsControls.propTypes = {
	  list: _reactImmutableProptypes2.default.list.isRequired,
	  updateAll: _react.PropTypes.func.isRequired,
	  selectedItems: _reactImmutableProptypes2.default.map.isRequired,
	  sticky: _react.PropTypes.bool,
	  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node])
	};
	
	BatchActionsControls.defaultProps = {
	  pageNumber: 1,
	  pageLimit: 25,
	  sticky: false
	};

/***/ },
/* 1907 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _BatchActionsControls = __webpack_require__(585);
	
	var _BatchActionsControls2 = _interopRequireDefault(_BatchActionsControls);
	
	var _BatchActionsToolbar = __webpack_require__(586);
	
	var _BatchActionsToolbar2 = _interopRequireDefault(_BatchActionsToolbar);
	
	__webpack_require__(2567);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BatchActionsList = function (_BcReactComponent) {
	  _inherits(BatchActionsList, _BcReactComponent);
	
	  function BatchActionsList(props) {
	    _classCallCheck(this, BatchActionsList);
	
	    var _this = _possibleConstructorReturn(this, (BatchActionsList.__proto__ || Object.getPrototypeOf(BatchActionsList)).call(this, props));
	
	    _this.state = {
	      selectedItems: _immutable2.default.Map()
	    };
	
	    _this.bindAll('updateItem', 'updateAll');
	    return _this;
	  }
	
	  _createClass(BatchActionsList, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.list.equals(this.props.list)) {
	        this.updateSelectedItemsForList(nextProps.list);
	      } else {
	        this.setState({ selectedItems: _immutable2.default.Map() });
	      }
	    }
	  }, {
	    key: 'updateSelectedItemsForList',
	    value: function updateSelectedItemsForList(list) {
	      var _this2 = this;
	
	      // Items in the list may have been removed or changed.
	      // Remove deleted items from the list, and update existing references.
	      var selectedItems = _immutable2.default.Map().withMutations(function (updatedSelectedItems) {
	        _this2.state.selectedItems.forEach(function (selectedItem) {
	          var updatedItem = list.find(function (item) {
	            return selectedItem.get('id') === item.get('id');
	          });
	          if (updatedItem) {
	            updatedSelectedItems.set(updatedItem.get('id'), updatedItem);
	          }
	        });
	      });
	
	      this.setState({ selectedItems: selectedItems });
	    }
	  }, {
	    key: 'updateAll',
	    value: function updateAll(selected) {
	      if (selected) {
	        this.setState({
	          selectedItems: this.props.list.reduce(function (result, item) {
	            return result.set(item.get('id'), item);
	          }, _immutable2.default.Map())
	        });
	      } else {
	        this.setState({
	          selectedItems: _immutable2.default.Map()
	        });
	      }
	    }
	  }, {
	    key: 'updateItem',
	    value: function updateItem(item) {
	      if (typeof item.get('id') === 'undefined') {
	        throw new Error('[BatchActionsList] updateItem must be called with an Immutable.Map with an `id`', item);
	      }
	
	      var isSelected = this.state.selectedItems.has(item.get('id'));
	      if (isSelected) {
	        return this.setState({
	          selectedItems: this.state.selectedItems.deleteIn([item.get('id')])
	        });
	      }
	
	      return this.setState({
	        selectedItems: this.state.selectedItems.set(item.get('id'), item)
	      });
	    }
	  }, {
	    key: 'renderBatchActionControls',
	    value: function renderBatchActionControls() {
	      return _react2.default.createElement(_BatchActionsControls2.default, {
	        list: this.props.list,
	        selectedItems: this.state.selectedItems,
	        updateAll: this.updateAll });
	    }
	  }, {
	    key: 'renderBatchActionsToolbar',
	    value: function renderBatchActionsToolbar() {
	      var _this3 = this;
	
	      return _react2.default.createElement(_BatchActionsToolbar2.default, {
	        actionIsLoading: this.props.actionIsLoading,
	        handleClear: function handleClear() {
	          return _this3.updateAll(false);
	        },
	        renderActionsMenu: this.props.renderActionsMenu,
	        totalItems: this.props.totalItems,
	        globalMessaging: this.props.globalMessaging,
	        messagingActions: this.props.messagingActions,
	        selectedItems: this.state.selectedItems });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-batch-actions-list' },
	        this.renderBatchActionControls(),
	        this.props.children(this.state.selectedItems, this.updateItem),
	        this.renderBatchActionsToolbar()
	      );
	    }
	  }]);
	
	  return BatchActionsList;
	}(_baseBcReactComponent2.default);
	
	exports.default = BatchActionsList;
	
	
	BatchActionsList.propTypes = {
	  actionIsLoading: _react.PropTypes.bool,
	  list: _reactImmutableProptypes2.default.list.isRequired,
	  pageNumber: _react.PropTypes.number,
	  pageLimit: _react.PropTypes.number,
	  totalItems: _react.PropTypes.number.isRequired,
	  renderActionsMenu: _react.PropTypes.func.isRequired,
	  globalMessaging: _reactImmutableProptypes2.default.map,
	  children: _react.PropTypes.func.isRequired,
	  messagingActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired
	};

/***/ },
/* 1908 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BatchActionsList = __webpack_require__(1907);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BatchActionsList).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1909 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = BatchActionsListItem;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _baseCheckbox = __webpack_require__(58);
	
	var _baseCheckbox2 = _interopRequireDefault(_baseCheckbox);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	var _reactIntl = __webpack_require__(3);
	
	__webpack_require__(2568);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var srCheckboxLabel = function srCheckboxLabel() {
	  return _react2.default.createElement(
	    _baseScreenReaderMessage2.default,
	    null,
	    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'batch_actions_checkbox' })
	  );
	};
	
	function BatchActionsListItem(_ref) {
	  var actionItem = _ref.actionItem,
	      updateItem = _ref.updateItem,
	      selectedItems = _ref.selectedItems,
	      children = _ref.children;
	
	  var id = actionItem.get('id');
	  var selected = selectedItems.has(id);
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'cp-batch-actions-list-item' },
	    _react2.default.createElement(_baseCheckbox2.default, {
	      label: srCheckboxLabel(),
	      id: 'batch-actions-list-item-checkbox-' + id,
	      inline: true,
	      handleChange: function handleChange() {
	        return updateItem(actionItem);
	      },
	      value: id,
	      checked: selected }),
	    _react2.default.createElement(
	      'div',
	      { className: 'batch-actions-list-item-details' },
	      children
	    )
	  );
	}
	
	BatchActionsListItem.propTypes = {
	  actionItem: _reactImmutableProptypes2.default.map.isRequired,
	  selectedItems: _reactImmutableProptypes2.default.map.isRequired,
	  updateItem: _react.PropTypes.func.isRequired,
	  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node]).isRequired
	};

/***/ },
/* 1910 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _reactIntl = __webpack_require__(3);
	
	var _reactAddonsCssTransitionGroup = __webpack_require__(258);
	
	var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	var _baseIcons = __webpack_require__(10);
	
	var _baseDropdown = __webpack_require__(37);
	
	var _baseButtons = __webpack_require__(12);
	
	__webpack_require__(2569);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BatchActionsToolbar = function (_BcReactComponent) {
	  _inherits(BatchActionsToolbar, _BcReactComponent);
	
	  function BatchActionsToolbar() {
	    _classCallCheck(this, BatchActionsToolbar);
	
	    return _possibleConstructorReturn(this, (BatchActionsToolbar.__proto__ || Object.getPrototypeOf(BatchActionsToolbar)).apply(this, arguments));
	  }
	
	  _createClass(BatchActionsToolbar, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.handleClear();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.globalMessaging) {
	        if (this.props.selectedItems.size === 0 && nextProps.selectedItems.size > 0) {
	          this.props.messagingActions.clearGlobalMessage();
	        } else {
	          this.props.handleClear();
	        }
	      }
	    }
	  }, {
	    key: 'renderDropdown',
	    value: function renderDropdown() {
	      var _props = this.props,
	          selectedItems = _props.selectedItems,
	          totalItems = _props.totalItems,
	          renderActionsMenu = _props.renderActionsMenu,
	          actionIsLoading = _props.actionIsLoading;
	
	
	      var renderDropdownButtonText = function renderDropdownButtonText() {
	        return _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement(
	            'span',
	            { 'aria-hidden': true },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'batch_actions_edit_items' }),
	            _react2.default.createElement(_baseIcons.Ellipsis, null)
	          ),
	          _react2.default.createElement(
	            _baseScreenReaderMessage2.default,
	            null,
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ada_label_batch_actions_edit_items', values: { totalItems: totalItems, count: selectedItems.size } })
	          )
	        );
	      };
	
	      return _react2.default.createElement(
	        _baseDropdown.Dropdown,
	        {
	          dropup: true,
	          right: true,
	          disableMobile: true,
	          className: 'actions-dropdown',
	          isLoading: actionIsLoading,
	          ButtonTag: _baseButtons.GhostButton,
	          renderSelected: renderDropdownButtonText },
	        renderActionsMenu(selectedItems)
	      );
	    }
	  }, {
	    key: 'renderSummary',
	    value: function renderSummary() {
	      var _props2 = this.props,
	          selectedItems = _props2.selectedItems,
	          handleClear = _props2.handleClear;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'actions-summary' },
	        _react2.default.createElement(
	          'span',
	          { 'aria-hidden': true },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'batch_actions_selected_count', values: { count: selectedItems.size } })
	        ),
	        _react2.default.createElement(
	          _baseButtons.TextButton,
	          { className: 'clear-button', handleClick: handleClear },
	          _react2.default.createElement(
	            'span',
	            { 'aria-hidden': true },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_clear' })
	          ),
	          _react2.default.createElement(
	            _baseScreenReaderMessage2.default,
	            null,
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ada_label_batch_actions_clear' })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderToolbar',
	    value: function renderToolbar() {
	      if (this.props.selectedItems.size > 0 && !this.props.globalMessaging) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'cp-batch-actions-toolbar' },
	          _react2.default.createElement(
	            'div',
	            { className: 'container toolbar-container' },
	            _react2.default.createElement(
	              'div',
	              { className: 'toolbar-content' },
	              this.renderSummary(),
	              this.renderDropdown()
	            )
	          )
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _reactAddonsCssTransitionGroup2.default,
	        {
	          component: 'div',
	          transitionName: 'slide-up',
	          transitionEnterTimeout: 250,
	          transitionLeaveTimeout: 100 },
	        this.renderToolbar()
	      );
	    }
	  }]);
	
	  return BatchActionsToolbar;
	}(_baseBcReactComponent2.default);
	
	exports.default = BatchActionsToolbar;
	
	
	BatchActionsToolbar.propTypes = {
	  actionIsLoading: _react.PropTypes.bool,
	  totalItems: _react.PropTypes.number.isRequired,
	  selectedItems: _reactImmutableProptypes2.default.map.isRequired,
	  handleClear: _react.PropTypes.func.isRequired,
	  renderActionsMenu: _react.PropTypes.func.isRequired,
	  globalMessaging: _reactImmutableProptypes2.default.map,
	  messagingActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired
	};
	
	BatchActionsToolbar.defaultProps = {
	  actionIsLoading: false
	};

/***/ },
/* 1911 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseButtons = __webpack_require__(12);
	
	var _AddToShelfComboButton = __webpack_require__(583);
	
	var _AddToShelfComboButton2 = _interopRequireDefault(_AddToShelfComboButton);
	
	__webpack_require__(2570);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BatchAddToShelfButton = function (_BcReactComponent) {
	  _inherits(BatchAddToShelfButton, _BcReactComponent);
	
	  function BatchAddToShelfButton() {
	    _classCallCheck(this, BatchAddToShelfButton);
	
	    return _possibleConstructorReturn(this, (BatchAddToShelfButton.__proto__ || Object.getPrototypeOf(BatchAddToShelfButton)).apply(this, arguments));
	  }
	
	  _createClass(BatchAddToShelfButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          selectedItemCount = _props.selectedItemCount,
	          isLoading = _props.isLoading,
	          handleClick = _props.handleClick;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-batch-add-to-shelf-button' },
	        _react2.default.createElement(
	          _AddToShelfComboButton2.default,
	          {
	            handleClick: handleClick,
	            disabled: selectedItemCount === 0,
	            isLoading: isLoading,
	            ButtonTag: _baseButtons.PrimaryButton },
	          selectedItemCount > 0 ? ' (' + selectedItemCount + ')' : ''
	        )
	      );
	    }
	  }]);
	
	  return BatchAddToShelfButton;
	}(_baseBcReactComponent2.default);
	
	exports.default = BatchAddToShelfButton;
	
	
	BatchAddToShelfButton.propTypes = {
	  handleClick: _react.PropTypes.func,
	  selectedItemCount: _react.PropTypes.number,
	  isLoading: _react.PropTypes.bool
	};

/***/ },
/* 1912 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BibListItem = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _JacketCoverContainer = __webpack_require__(395);
	
	var _JacketCoverContainer2 = _interopRequireDefault(_JacketCoverContainer);
	
	var _WorkflowContainer = __webpack_require__(243);
	
	var _WorkflowContainer2 = _interopRequireDefault(_WorkflowContainer);
	
	__webpack_require__(2571);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BibListItem = exports.BibListItem = function (_BcReactComponent) {
	  _inherits(BibListItem, _BcReactComponent);
	
	  function BibListItem() {
	    _classCallCheck(this, BibListItem);
	
	    return _possibleConstructorReturn(this, (BibListItem.__proto__ || Object.getPrototypeOf(BibListItem)).apply(this, arguments));
	  }
	
	  _createClass(BibListItem, [{
	    key: 'getBib',
	    value: function getBib() {
	      return this.props.bib ? this.props.bib : _immutable2.default.fromJS({
	        title: this.props.intl.formatMessage({ id: 'not_available' }),
	        id: ''
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          renderInfo = _props.renderInfo,
	          renderFooterInfo = _props.renderFooterInfo,
	          renderBibBrief = _props.renderBibBrief,
	          workflowId = _props.workflowId;
	
	      var bib = this.getBib();
	      var renderedInfo = renderInfo();
	      var renderedFooterInfo = renderFooterInfo();
	
	      return _react2.default.createElement(
	        _WorkflowContainer2.default,
	        { id: workflowId || bib.get('metadataId') },
	        function (workflowComponent) {
	          return workflowComponent || _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('cp-bib-list-item', className) },
	            _react2.default.createElement(
	              'div',
	              { className: 'item-row item-header' },
	              _react2.default.createElement(
	                'div',
	                { className: 'item-column brief-info' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'jacket-cover-container' },
	                  _react2.default.createElement(_JacketCoverContainer2.default, { src: bib.get('jacket'), format: bib.get('format'), alt: '' })
	                ),
	                renderBibBrief()
	              ),
	              renderedInfo ? _react2.default.createElement(
	                'div',
	                { className: 'item-column additional-info' },
	                renderedInfo
	              ) : null
	            ),
	            renderedFooterInfo ? _react2.default.createElement(
	              'div',
	              { className: 'item-row item-footer' },
	              renderedFooterInfo
	            ) : null
	          );
	        }
	      );
	    }
	  }]);
	
	  return BibListItem;
	}(_baseBcReactComponent2.default);
	
	BibListItem.propTypes = {
	  renderInfo: _react.PropTypes.func, // The side information
	  renderFooterInfo: _react.PropTypes.func,
	  className: _react.PropTypes.string,
	  bib: _reactImmutableProptypes2.default.map,
	  workflowId: _react.PropTypes.string,
	  renderBibBrief: _react.PropTypes.func,
	  intl: _reactIntl.intlShape
	};
	
	BibListItem.defaultProps = {
	  renderInfo: function renderInfo() {
	    return null;
	  },
	  renderFooterInfo: function renderFooterInfo() {
	    return null;
	  },
	  renderBibBrief: function renderBibBrief() {
	    return null;
	  }
	};
	
	exports.default = (0, _reactIntl.injectIntl)(BibListItem);

/***/ },
/* 1913 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _uniqueId = __webpack_require__(2947);
	
	var _uniqueId2 = _interopRequireDefault(_uniqueId);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseDropdown = __webpack_require__(37);
	
	__webpack_require__(2572);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BranchDropdown = function (_BcReactComponent) {
	  _inherits(BranchDropdown, _BcReactComponent);
	
	  function BranchDropdown(props) {
	    _classCallCheck(this, BranchDropdown);
	
	    var _this = _possibleConstructorReturn(this, (BranchDropdown.__proto__ || Object.getPrototypeOf(BranchDropdown)).call(this, props));
	
	    _this.id = (0, _uniqueId2.default)('branch-dropdown-');
	    return _this;
	  }
	
	  _createClass(BranchDropdown, [{
	    key: 'getSelectedBranchName',
	    value: function getSelectedBranchName() {
	      var _this2 = this;
	
	      return this.props.branches.filter(function (branch) {
	        return branch.get('code') === _this2.props.selectedBranchCode;
	      }).first().get('name');
	    }
	  }, {
	    key: 'getOptionsForDropdown',
	    value: function getOptionsForDropdown() {
	      return this.props.branches.map(function (branch) {
	        return {
	          label: branch.get('name', ''),
	          value: branch.get('code', '')
	        };
	      }).toIndexedSeq().toJS();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-branch-dropdown' },
	        _react2.default.createElement(
	          'label',
	          { id: this.id + '-label', htmlFor: this.id },
	          this.props.children
	        ),
	        _react2.default.createElement(_baseDropdown.Dropdown, {
	          selected: this.getSelectedBranchName(),
	          disabled: this.props.disabled,
	          dropdownMenuId: this.id,
	          labelledById: this.id + '-label',
	          options: this.getOptionsForDropdown(),
	          isLoading: this.props.isLoading,
	          className: this.props.buttonClassName,
	          ButtonTag: this.props.ButtonTag,
	          handleSelect: this.props.handleSelect,
	          testId: 'single-click-holds-location',
	          renderTrigger: this.props.renderDropdownTrigger })
	      );
	    }
	  }]);
	
	  return BranchDropdown;
	}(_baseBcReactComponent2.default);
	
	exports.default = BranchDropdown;
	
	
	BranchDropdown.propTypes = {
	  children: _bcPropTypes.childrenShape,
	  branches: _reactImmutableProptypes2.default.listOf(_bcPropTypes.branchShape),
	  handleSelect: _react.PropTypes.func,
	  selectedBranchCode: _react.PropTypes.string,
	  ButtonTag: _react.PropTypes.oneOfType([_react.PropTypes.instanceOf(_baseBcReactComponent2.default), _react.PropTypes.func]),
	  buttonClassName: _react.PropTypes.string,
	  isLoading: _react.PropTypes.bool,
	  disabled: _react.PropTypes.bool,
	  renderDropdownTrigger: _react.PropTypes.func
	};
	
	BranchDropdown.defaultProps = {
	  buttonClassName: 'btn-block'
	};

/***/ },
/* 1914 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = CompactItemInfo;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _formatIndicator = __webpack_require__(177);
	
	var _formatIndicator2 = _interopRequireDefault(_formatIndicator);
	
	var _sharedPublicationDate = __webpack_require__(369);
	
	var _sharedPublicationDate2 = _interopRequireDefault(_sharedPublicationDate);
	
	var _CompactTitle = __webpack_require__(1921);
	
	var _CompactTitle2 = _interopRequireDefault(_CompactTitle);
	
	__webpack_require__(2573);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CompactItemInfo(_ref) {
	  var title = _ref.title,
	      subtitle = _ref.subtitle,
	      author = _ref.author,
	      format = _ref.format,
	      publicationDate = _ref.publicationDate,
	      id = _ref.id;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'cp-compact-item-info' },
	    (title || subtitle) && _react2.default.createElement(_CompactTitle2.default, {
	      title: title,
	      subtitle: subtitle,
	      renderAsLink: typeof id === 'string',
	      id: id }),
	    author && _react2.default.createElement(
	      'div',
	      { className: 'author' },
	      author
	    ),
	    format && _react2.default.createElement(_formatIndicator2.default, { format: format }),
	    publicationDate && _react2.default.createElement(_sharedPublicationDate2.default, { publicationDate: publicationDate })
	  );
	}
	
	CompactItemInfo.defaultProps = {
	  id: false
	};
	
	// Note: Can't pass bib may or may not be derived from a bib
	CompactItemInfo.propTypes = {
	  title: _react.PropTypes.string,
	  subtitle: _react.PropTypes.string,
	  author: _react.PropTypes.string,
	  format: _react.PropTypes.string,
	  publicationDate: _react.PropTypes.string,
	  id: _react.PropTypes.string
	};

/***/ },
/* 1915 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CompactItemInfo = __webpack_require__(1914);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CompactItemInfo).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1916 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = CompactList;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(2574);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CompactList(_ref) {
	  var children = _ref.children;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'cp-compact-list' },
	    children
	  );
	}
	
	CompactList.propTypes = {
	  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node]).isRequired
	};

/***/ },
/* 1917 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CompactList = __webpack_require__(1916);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CompactList).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1918 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = CompactListItem;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(2575);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CompactListItem(_ref) {
	  var columns = _ref.columns,
	      className = _ref.className;
	
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)('cp-compact-list-item', className) },
	    _react2.default.createElement(
	      'div',
	      { className: 'item-row' },
	      columns.map(function (column) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'item-column' },
	          column
	        );
	      })
	    )
	  );
	}
	
	CompactListItem.propTypes = {
	  columns: _react.PropTypes.arrayOf(_react.PropTypes.node).isRequired,
	  className: _react.PropTypes.string
	};

/***/ },
/* 1919 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CompactListItem = __webpack_require__(1918);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CompactListItem).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1920 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = CompactTitle;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsLink = __webpack_require__(97);
	
	__webpack_require__(2576);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CompactTitle(_ref) {
	  var title = _ref.title,
	      subtitle = _ref.subtitle,
	      renderAsLink = _ref.renderAsLink,
	      id = _ref.id;
	
	  if (renderAsLink && typeof id === 'string') {
	    return _react2.default.createElement(
	      'div',
	      { className: 'cp-compact-title' },
	      title && _react2.default.createElement(
	        'span',
	        { className: 'bib-title' },
	        _react2.default.createElement(
	          'a',
	          { href: '/item/show/' + (0, _utilsLink.metadataIdFixer)(id) },
	          title
	        )
	      ),
	      subtitle && _react2.default.createElement(
	        'span',
	        { className: 'sub-title' },
	        subtitle
	      )
	    );
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'cp-compact-title' },
	    title && _react2.default.createElement(
	      'span',
	      { className: 'bib-title' },
	      title
	    ),
	    subtitle && _react2.default.createElement(
	      'span',
	      { className: 'sub-title' },
	      subtitle
	    )
	  );
	}
	
	CompactTitle.defaultProps = {
	  renderAsLink: false
	};
	
	// Note: Can't pass bib may or may not be derived from a bib
	CompactTitle.propTypes = {
	  title: _react.PropTypes.string,
	  subtitle: _react.PropTypes.string,
	  renderAsLink: _react.PropTypes.bool,
	  id: _react.PropTypes.string
	};

/***/ },
/* 1921 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CompactTitle = __webpack_require__(1920);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CompactTitle).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1922 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _reactIntl = __webpack_require__(3);
	
	var _sharedEresourceLink = __webpack_require__(545);
	
	var _sharedEresourceLink2 = _interopRequireDefault(_sharedEresourceLink);
	
	__webpack_require__(2577);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EResourceBlock = function EResourceBlock(_ref) {
	  var eResources = _ref.eResources,
	      format = _ref.format;
	  return eResources.isEmpty() ? null : _react2.default.createElement(
	    'div',
	    { className: 'cp-eresource-block well' },
	    _react2.default.createElement(
	      _reactIntl.FormattedMessage,
	      { id: 'bib_electronic_resources' },
	      function (heading) {
	        return _react2.default.createElement(
	          'h4',
	          null,
	          heading
	        );
	      }
	    ),
	    _react2.default.createElement(
	      'ul',
	      null,
	      eResources.map(function (eResource) {
	        return _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(_sharedEresourceLink2.default, { eresourceDescription: eResource.get('description'), eresourceUrl: eResource.get('url'), format: format })
	        );
	      })
	    )
	  );
	};
	
	EResourceBlock.propTypes = {
	  eResources: _reactImmutableProptypes2.default.listOf(_reactImmutableProptypes2.default.mapContains({
	    description: _react.PropTypes.string,
	    url: _react.PropTypes.string.isRequired
	  })),
	  format: _react.PropTypes.string
	};
	
	EResourceBlock.displayName = 'EResourceBlock';
	
	exports.default = EResourceBlock;

/***/ },
/* 1923 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _EResourceBlock = __webpack_require__(1922);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_EResourceBlock).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1924 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = EmptyContentPanel;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseIcons = __webpack_require__(10);
	
	__webpack_require__(2578);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function EmptyContentPanel(_ref) {
	  var icon = _ref.icon,
	      title = _ref.title,
	      subtitle = _ref.subtitle,
	      fetching = _ref.fetching,
	      children = _ref.children;
	
	  var renderContents = function renderContents() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'contents' },
	      title && _react2.default.createElement(
	        'h2',
	        { className: 'title-wrapper' },
	        title
	      ),
	      subtitle && _react2.default.createElement(
	        'h3',
	        { className: 'subtitle-wrapper' },
	        subtitle
	      ),
	      children
	    );
	  };
	
	  var renderLoading = function renderLoading() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'loading' },
	      _react2.default.createElement(_baseIcons.Spinner, { primary: true }),
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'loading' })
	    );
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'cp-empty-content-panel' },
	    icon && _react2.default.createElement(
	      'div',
	      { className: 'icon-wrapper' },
	      icon
	    ),
	    fetching ? renderLoading() : renderContents()
	  );
	}
	
	EmptyContentPanel.propTypes = {
	  icon: _react.PropTypes.element,
	  title: _react.PropTypes.node,
	  subtitle: _react.PropTypes.node,
	  fetching: _react.PropTypes.bool,
	  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node])
	};

/***/ },
/* 1925 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseButtons = __webpack_require__(12);
	
	var _baseIcons = __webpack_require__(10);
	
	__webpack_require__(2579);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ActiveFilterToken = function (_BcReactComponent) {
	  _inherits(ActiveFilterToken, _BcReactComponent);
	
	  function ActiveFilterToken(props) {
	    _classCallCheck(this, ActiveFilterToken);
	
	    var _this = _possibleConstructorReturn(this, (ActiveFilterToken.__proto__ || Object.getPrototypeOf(ActiveFilterToken)).call(this, props));
	
	    _this.bindAll('handleToggleFilter');
	    return _this;
	  }
	
	  _createClass(ActiveFilterToken, [{
	    key: 'handleToggleFilter',
	    value: function handleToggleFilter() {
	      this.props.handleToggleFilter(this.props.fieldId, this.props.filter);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var btnClass = (0, _classnames2.default)('cp-filter-token', this.props.className);
	      return _react2.default.createElement(
	        _baseButtons.Button,
	        {
	          handleClick: this.handleToggleFilter,
	          'data-test-id': this.props.fieldId + '-' + this.props.filter.get('value') + '-active-filter',
	          className: btnClass },
	        this.props.filterLabel,
	        _react2.default.createElement(_baseIcons.Cross, { className: 'extra-small' })
	      );
	    }
	  }]);
	
	  return ActiveFilterToken;
	}(_baseBcReactComponent2.default);
	
	exports.default = ActiveFilterToken;
	
	
	ActiveFilterToken.propTypes = {
	  className: _react.PropTypes.string,
	  fieldId: _react.PropTypes.string.isRequired,
	  filter: _reactImmutableProptypes2.default.map,
	  filterLabel: _react.PropTypes.string.isRequired
	};

/***/ },
/* 1926 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseCheckbox = __webpack_require__(58);
	
	var _baseCheckbox2 = _interopRequireDefault(_baseCheckbox);
	
	__webpack_require__(2580);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CheckboxField = function (_BcReactComponent) {
	  _inherits(CheckboxField, _BcReactComponent);
	
	  function CheckboxField(props) {
	    _classCallCheck(this, CheckboxField);
	
	    var _this = _possibleConstructorReturn(this, (CheckboxField.__proto__ || Object.getPrototypeOf(CheckboxField)).call(this, props));
	
	    _this.bindAll('handleToggleFilter');
	    return _this;
	  }
	
	  _createClass(CheckboxField, [{
	    key: 'handleToggleFilter',
	    value: function handleToggleFilter(checked, _ref) {
	      var filter = _ref.value;
	
	      this.props.handleToggleFilter(this.props.fieldId, filter);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          fieldId = _props.fieldId,
	          filter = _props.filter;
	
	      var applied = filter.get('applied');
	      var checkboxId = [fieldId, applied].join('-');
	
	      return _react2.default.createElement(
	        'section',
	        { className: 'cp-checkbox-field' },
	        _react2.default.createElement(_baseCheckbox2.default, {
	          id: checkboxId,
	          handleChange: this.handleToggleFilter,
	          value: filter,
	          checked: applied,
	          label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: fieldId + '.field' }),
	          labelTestId: checkboxId + '-field' })
	      );
	    }
	  }]);
	
	  return CheckboxField;
	}(_baseBcReactComponent2.default);
	
	CheckboxField.propTypes = {
	  filter: _reactImmutableProptypes2.default.map.isRequired,
	  fieldId: _react.PropTypes.string.isRequired,
	  handleToggleFilter: _react.PropTypes.func.isRequired
	};
	
	exports.default = CheckboxField;

/***/ },
/* 1927 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CheckboxField = __webpack_require__(1926);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CheckboxField).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1928 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseCheckbox = __webpack_require__(58);
	
	var _baseCheckbox2 = _interopRequireDefault(_baseCheckbox);
	
	var _utilsFilter = __webpack_require__(179);
	
	__webpack_require__(2581);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CheckboxFilter = function (_BcReactComponent) {
	  _inherits(CheckboxFilter, _BcReactComponent);
	
	  function CheckboxFilter(props) {
	    _classCallCheck(this, CheckboxFilter);
	
	    var _this = _possibleConstructorReturn(this, (CheckboxFilter.__proto__ || Object.getPrototypeOf(CheckboxFilter)).call(this, props));
	
	    _this.bindAll('handleToggleFilter');
	    return _this;
	  }
	
	  _createClass(CheckboxFilter, [{
	    key: 'handleToggleFilter',
	    value: function handleToggleFilter(checked, _ref) {
	      var filter = _ref.value;
	
	      this.props.handleToggleFilter(this.props.fieldId, filter);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          fieldId = _props.fieldId,
	          filter = _props.filter,
	          intl = _props.intl,
	          refFunction = _props.refFunction,
	          group = _props.group;
	
	      var value = filter.get('value');
	      var label = filter.get('label');
	      var count = filter.get('count');
	      var applied = filter.get('applied');
	
	      var filterLabel = (0, _utilsFilter.getLabel)(intl, fieldId, label || value);
	      var formattedLabel = intl.formatMessage({ id: 'Facets.filterLabelFormat' }, { value: filterLabel, count: count });
	      var checkboxId = [fieldId, group, value].filter(function (v) {
	        return !!v;
	      }).join('-');
	
	      return _react2.default.createElement(_baseCheckbox2.default, {
	        id: checkboxId,
	        handleChange: this.handleToggleFilter,
	        value: filter,
	        checked: applied,
	        label: formattedLabel,
	        labelTestId: checkboxId + '-filter',
	        ref: refFunction });
	    }
	  }]);
	
	  return CheckboxFilter;
	}(_baseBcReactComponent2.default);
	
	CheckboxFilter.propTypes = {
	  group: _react.PropTypes.string,
	  filter: _reactImmutableProptypes2.default.map.isRequired,
	  fieldId: _react.PropTypes.string.isRequired,
	  handleToggleFilter: _react.PropTypes.func.isRequired,
	  intl: _reactIntl.intlShape,
	  refFunction: _react.PropTypes.func
	};
	
	CheckboxFilter.defaultProps = {
	  group: ''
	};
	
	exports.default = (0, _reactIntl.injectIntl)(CheckboxFilter);

/***/ },
/* 1929 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _ExpandedFiltersOverlay = __webpack_require__(1931);
	
	var _ExpandedFiltersOverlay2 = _interopRequireDefault(_ExpandedFiltersOverlay);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseButtons = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  fieldId: _react2.default.PropTypes.string,
	  handleToggleExpandedField: _react2.default.PropTypes.func.isRequired,
	  handleExpandField: _react2.default.PropTypes.func.isRequired,
	  handleCloseExpandField: _react2.default.PropTypes.func
	};
	
	var ExpandFilterLink = function (_BcReactComponent) {
	  _inherits(ExpandFilterLink, _BcReactComponent);
	
	  function ExpandFilterLink(props) {
	    _classCallCheck(this, ExpandFilterLink);
	
	    var _this = _possibleConstructorReturn(this, (ExpandFilterLink.__proto__ || Object.getPrototypeOf(ExpandFilterLink)).call(this, props));
	
	    _this.state = {
	      open: false
	    };
	    _this.bindAll('handleClick', 'handleClose');
	    return _this;
	  }
	
	  _createClass(ExpandFilterLink, [{
	    key: 'handleClick',
	    value: function handleClick() {
	      this.setState({
	        open: true
	      });
	      this.props.handleExpandField(this.props.fieldId);
	    }
	  }, {
	    key: 'handleClose',
	    value: function handleClose() {
	      var handleCloseExpandField = this.props.handleCloseExpandField;
	
	
	      if (handleCloseExpandField) {
	        handleCloseExpandField();
	      }
	
	      this.setState({
	        open: false
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _baseButtons.TextButton,
	          {
	            className: 'cp-expand-filter-link',
	            handleClick: this.handleClick,
	            'data-test-id': this.props.fieldId + '-show-more',
	            block: true },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Facets.showMore' })
	        ),
	        _react2.default.createElement(_ExpandedFiltersOverlay2.default, _extends({}, this.props, { open: this.state.open, handleClose: this.handleClose }))
	      );
	    }
	  }]);
	
	  return ExpandFilterLink;
	}(_baseBcReactComponent2.default);
	
	ExpandFilterLink.propTypes = propTypes;
	
	exports.default = ExpandFilterLink;

/***/ },
/* 1930 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _utilsFilter = __webpack_require__(179);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseFullScreenOverlay = __webpack_require__(45);
	
	var _baseFullScreenOverlay2 = _interopRequireDefault(_baseFullScreenOverlay);
	
	var _CheckboxFilter = __webpack_require__(590);
	
	var _CheckboxFilter2 = _interopRequireDefault(_CheckboxFilter);
	
	var _LinkFilter = __webpack_require__(594);
	
	var _LinkFilter2 = _interopRequireDefault(_LinkFilter);
	
	__webpack_require__(2582);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  activeFilters: _react2.default.PropTypes.object.isRequired,
	  fieldId: _react2.default.PropTypes.string.isRequired,
	  handleToggleExpandedField: _react2.default.PropTypes.func.isRequired,
	  filters: _react2.default.PropTypes.object.isRequired,
	  intl: _reactIntl.intlShape,
	  open: _react2.default.PropTypes.bool,
	  label: _react2.default.PropTypes.string,
	  handleClose: _react2.default.PropTypes.func.isRequired
	};
	
	var ExpandedFiltersOverlay = function (_BcReactComponent) {
	  _inherits(ExpandedFiltersOverlay, _BcReactComponent);
	
	  function ExpandedFiltersOverlay(props) {
	    _classCallCheck(this, ExpandedFiltersOverlay);
	
	    var _this = _possibleConstructorReturn(this, (ExpandedFiltersOverlay.__proto__ || Object.getPrototypeOf(ExpandedFiltersOverlay)).call(this, props));
	
	    _this.bindAll('renderFilter');
	    return _this;
	  }
	
	  _createClass(ExpandedFiltersOverlay, [{
	    key: 'renderFilter',
	    value: function renderFilter(filter) {
	      var classString = 'filter';
	      if (filter.get('applied')) {
	        classString += ' applied';
	      }
	
	      var FilterTag = (0, _utilsFilter.isConjunctiveField)(this.props.fieldId) ? _LinkFilter2.default : _CheckboxFilter2.default;
	
	      return _react2.default.createElement(
	        'div',
	        { key: filter.get('value'), className: classString + ' col-sm-6 col-md-6' },
	        _react2.default.createElement(
	          'div',
	          { className: 'expanded-filter-label-wrap' },
	          _react2.default.createElement(FilterTag, {
	            fieldId: this.props.fieldId,
	            filter: filter,
	            handleToggleFilter: this.props.handleToggleExpandedField })
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _baseFullScreenOverlay2.default,
	        _extends({}, this.props, { 'data-test-id': this.props.fieldId + '-more-filters-overlay' }),
	        _react2.default.createElement(
	          'h1',
	          null,
	          _react2.default.createElement(_reactIntl.FormattedMessage, {
	            id: 'expanded_filter_header',
	            values: { field: this.props.intl.formatMessage({ id: this.props.label || this.props.fieldId + '.field' }) } })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'expanded-filter-list' },
	          this.props.filters.valueSeq().map(this.renderFilter)
	        )
	      );
	    }
	  }]);
	
	  return ExpandedFiltersOverlay;
	}(_baseBcReactComponent2.default);
	
	ExpandedFiltersOverlay.propTypes = propTypes;
	
	exports.default = (0, _reactIntl.injectIntl)(ExpandedFiltersOverlay);

/***/ },
/* 1931 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ExpandedFiltersOverlay = __webpack_require__(1930);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ExpandedFiltersOverlay).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1932 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseIcons = __webpack_require__(10);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	var _baseDrawer = __webpack_require__(118);
	
	__webpack_require__(2583);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FacetDrawerToggle = function (_BcReactComponent) {
	  _inherits(FacetDrawerToggle, _BcReactComponent);
	
	  function FacetDrawerToggle(props) {
	    _classCallCheck(this, FacetDrawerToggle);
	
	    var _this = _possibleConstructorReturn(this, (FacetDrawerToggle.__proto__ || Object.getPrototypeOf(FacetDrawerToggle)).call(this, props));
	
	    _this.bindAll('renderCompact', 'renderFull');
	    return _this;
	  }
	
	  _createClass(FacetDrawerToggle, [{
	    key: 'renderFilterCount',
	    value: function renderFilterCount() {
	      if (this.props.activeFilterCount > 0) {
	        return _react2.default.createElement(
	          _reactIntl.FormattedNumber,
	          { value: this.props.activeFilterCount },
	          function (number) {
	            return _react2.default.createElement(
	              'span',
	              null,
	              '\xA0(',
	              number,
	              ')'
	            );
	          }
	        );
	      }
	      return _react2.default.createElement('noop', null);
	    }
	  }, {
	    key: 'renderCompact',
	    value: function renderCompact() {
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement(_baseIcons.Filter, { className: 'small' }),
	        _react2.default.createElement(
	          _baseScreenReaderMessage2.default,
	          null,
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Facets.filterResults' })
	        ),
	        this.renderFilterCount()
	      );
	    }
	  }, {
	    key: 'renderFull',
	    value: function renderFull() {
	      return _react2.default.createElement(
	        'span',
	        { className: 'full-content' },
	        _react2.default.createElement(_baseIcons.Filter, { className: 'small' }),
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Facets.filterResults' }),
	        this.renderFilterCount()
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_baseDrawer.StickyToggleButton, {
	        className: 'cp-facet-drawer-toggle',
	        drawerActions: this.props.drawerActions,
	        renderCompact: this.renderCompact,
	        renderFull: this.renderFull });
	    }
	  }]);
	
	  return FacetDrawerToggle;
	}(_baseBcReactComponent2.default);
	
	FacetDrawerToggle.propTypes = {
	  activeFilterCount: _react2.default.PropTypes.number,
	  drawerActions: _react2.default.PropTypes.objectOf(_react2.default.PropTypes.func)
	};
	
	exports.default = FacetDrawerToggle;

/***/ },
/* 1933 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FieldList = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(17);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _aboveTheFoldOnlyServerRender = __webpack_require__(376);
	
	var _reactIntl = __webpack_require__(3);
	
	var _utilsFilter = __webpack_require__(179);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseDrawer = __webpack_require__(118);
	
	var Drawer = _interopRequireWildcard(_baseDrawer);
	
	var _baseButtons = __webpack_require__(12);
	
	var _CheckboxField = __webpack_require__(1927);
	
	var _CheckboxField2 = _interopRequireDefault(_CheckboxField);
	
	var _FormatField = __webpack_require__(1935);
	
	var _FormatField2 = _interopRequireDefault(_FormatField);
	
	var _LanguageField = __webpack_require__(1937);
	
	var _LanguageField2 = _interopRequireDefault(_LanguageField);
	
	var _SimpleField = __webpack_require__(389);
	
	var _SimpleField2 = _interopRequireDefault(_SimpleField);
	
	var _TagGroupField = __webpack_require__(1941);
	
	var _TagGroupField2 = _interopRequireDefault(_TagGroupField);
	
	var _SingleBranchStatusField = __webpack_require__(1894);
	
	var _SingleBranchStatusField2 = _interopRequireDefault(_SingleBranchStatusField);
	
	var _FacetConstants = __webpack_require__(187);
	
	var _getToggledFilter = __webpack_require__(643);
	
	var _getToggledFilter2 = _interopRequireDefault(_getToggledFilter);
	
	var _formatFiltersForQuery = __webpack_require__(397);
	
	var _formatFiltersForQuery2 = _interopRequireDefault(_formatFiltersForQuery);
	
	__webpack_require__(2584);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FieldList = exports.FieldList = function (_BcReactComponent) {
	  _inherits(FieldList, _BcReactComponent);
	
	  function FieldList(props) {
	    _classCallCheck(this, FieldList);
	
	    var _this = _possibleConstructorReturn(this, (FieldList.__proto__ || Object.getPrototypeOf(FieldList)).call(this, props));
	
	    _this.bindAll('renderFields', 'handleToggleFilter', 'handleToggleExpandedField');
	    return _this;
	  }
	
	  _createClass(FieldList, [{
	    key: 'handleToggleFilter',
	    value: function handleToggleFilter(fieldId, currentFilter) {
	      var _props = this.props,
	          activeFilters = _props.activeFilters,
	          paginationField = _props.paginationField,
	          location = _props.location,
	          router = _props.router,
	          transformQuery = _props.transformQuery;
	
	
	      var query = _extends({}, location.query, _defineProperty({}, paginationField, undefined), (0, _formatFiltersForQuery2.default)(activeFilters), (0, _getToggledFilter2.default)(fieldId, currentFilter, activeFilters));
	
	      if (transformQuery) {
	        query = transformQuery(query);
	      }
	
	      router.push(_extends({}, location, { query: query }));
	    }
	  }, {
	    key: 'handleToggleExpandedField',
	    value: function handleToggleExpandedField(fieldId, currentFilter) {
	      this.handleToggleFilter(fieldId, currentFilter);
	    }
	  }, {
	    key: 'isFieldExpanded',
	    value: function isFieldExpanded(id) {
	      return this.props.activeFilters.has(id);
	    }
	  }, {
	    key: 'renderFields',
	    value: function renderFields(fieldId) {
	      var handleToggleFilter = this.props.handleToggleFilter || this.handleToggleFilter;
	      var handleToggleExpandedField = this.props.handleToggleExpandedField || this.handleToggleExpandedField;
	
	      var fieldTag = void 0;
	      switch (fieldId) {
	        case 'SEARCH_SCOPE':
	          {
	            fieldTag = this.props.renderSearchScope ? this.props.renderSearchScope() : null;
	            break;
	          }
	        case 'IS_PRIVATE':
	        case 'I_OWN_THIS':
	          {
	            var field = this.props.fields.find(function (f) {
	              return f.get('id') === fieldId;
	            });
	            var fieldFilter = field && field.get('fieldFilters').find(function (filter) {
	              return '' + filter.get('value') === 'true';
	            });
	
	            if (!fieldFilter) {
	              return _react2.default.createElement('noop', { key: fieldId });
	            }
	
	            fieldTag = _react2.default.createElement(_CheckboxField2.default, {
	              key: fieldId,
	              fieldId: fieldId,
	              filter: fieldFilter,
	              handleToggleFilter: handleToggleFilter });
	            break;
	          }
	        case 'TAGS':
	          {
	            var genreTagField = this.props.fields.find(function (f) {
	              return f.get('id') === 'TAG_GENRE';
	            });
	            var toneTagField = this.props.fields.find(function (f) {
	              return f.get('id') === 'TAG_TONE';
	            });
	            var aboutTagField = this.props.fields.find(function (f) {
	              return f.get('id') === 'TAG_ABOUT';
	            });
	            var personalTagField = this.props.fields.find(function (f) {
	              return f.get('id') === 'TAG_PERSONAL';
	            });
	            if (!(genreTagField || toneTagField || aboutTagField)) {
	              return _react2.default.createElement('noop', { key: 'tagGroupField' });
	            }
	            fieldTag = _react2.default.createElement(
	              _aboveTheFoldOnlyServerRender.AboveTheFoldOnlyServerRender,
	              { skip: true },
	              _react2.default.createElement(_TagGroupField2.default, {
	                key: 'TAG_GROUP',
	                genreTagField: genreTagField,
	                genreExpanded: this.isFieldExpanded('TAG_GENRE'),
	                toneTagField: toneTagField,
	                toneExpanded: this.isFieldExpanded('TAG_TONE'),
	                aboutTagField: aboutTagField,
	                aboutExpanded: this.isFieldExpanded('TAG_ABOUT'),
	                personalTagField: personalTagField,
	                personalExpanded: this.isFieldExpanded('TAG_PERSONAL'),
	                handleToggleFilter: handleToggleFilter,
	                handleExpandField: this.props.handleExpandField,
	                activeFilters: this.props.activeFilters,
	                handleCloseExpandField: this.props.handleCloseExpandField,
	                handleToggleExpandedField: handleToggleExpandedField })
	            );
	            break;
	          }
	        case 'LANGUAGES':
	          {
	            var _field = null;
	            var primaryLanguage = this.props.fields.find(function (f) {
	              return f.get('id') === 'PRIMARY_LANGUAGE';
	            });
	            var language = this.props.fields.find(function (f) {
	              return f.get('id') === 'LANGUAGE';
	            });
	
	            if (!(primaryLanguage || language)) {
	              return _react2.default.createElement('noop', { key: fieldId });
	            }
	
	            if (!primaryLanguage && language) {
	              _field = language;
	            }
	
	            if (primaryLanguage && !language) {
	              _field = primaryLanguage;
	            }
	
	            if (_field) {
	              fieldTag = _react2.default.createElement(
	                _aboveTheFoldOnlyServerRender.AboveTheFoldOnlyServerRender,
	                { skip: true },
	                _react2.default.createElement(_SimpleField2.default, {
	                  key: _field.get('id'),
	                  label: 'LANGUAGE.field',
	                  fieldId: _field.get('id'),
	                  hasMore: _field.get('hasMore'),
	                  filters: _field.get('fieldFilters'),
	                  handleExpandField: this.props.handleExpandField,
	                  handleToggleFilter: handleToggleFilter,
	                  activeFilters: this.props.activeFilters,
	                  initialIsExpanded: this.isFieldExpanded(_field.get('id')),
	                  handleCloseExpandField: this.props.handleCloseExpandField,
	                  handleToggleExpandedField: handleToggleExpandedField })
	              );
	            } else {
	              fieldTag = _react2.default.createElement(
	                _aboveTheFoldOnlyServerRender.AboveTheFoldOnlyServerRender,
	                { skip: true },
	                _react2.default.createElement(_LanguageField2.default, {
	                  key: 'LANGUAGES',
	                  primaryLanguage: primaryLanguage,
	                  language: language,
	                  handleToggleFilter: handleToggleFilter,
	                  handleExpandField: this.props.handleExpandField,
	                  handleCloseExpandField: this.props.handleCloseExpandField,
	                  activeFilters: this.props.activeFilters,
	                  handleToggleExpandedField: handleToggleExpandedField,
	                  handleLanguageToggle: this.props.handleLanguageToggle,
	                  transformQuery: this.props.transformQuery,
	                  router: this.props.router })
	              );
	            }
	            break;
	          }
	        case 'FORMAT':
	          {
	            var formatField = this.props.fields.find(function (f) {
	              return f.get('id') === fieldId;
	            });
	
	            if (!formatField) {
	              return _react2.default.createElement('noop', { key: fieldId });
	            }
	
	            fieldTag = _react2.default.createElement(_FormatField2.default, {
	              key: 'FORMAT',
	              fieldId: formatField.get('id'),
	              hasMore: formatField.get('hasMore'),
	              filters: formatField.get('fieldFilters'),
	              handleToggleFilter: handleToggleFilter,
	              activeFilters: this.props.activeFilters });
	            break;
	          }
	        case 'STATUS':
	          if (this.props.singleBranch) {
	            var _field2 = this.props.fields.find(function (f) {
	              return f.get('id') === fieldId;
	            });
	            if (typeof _field2 === 'undefined') {
	              return _react2.default.createElement('noop', { key: fieldId });
	            }
	            fieldTag = _react2.default.createElement(_SingleBranchStatusField2.default, {
	              key: _field2.get('id'),
	              label: _field2.get('id') + '.field',
	              fieldId: _field2.get('id'),
	              filter: _field2.get('fieldFilters').first(),
	              handleToggleFilter: handleToggleFilter,
	              activeFilters: this.props.activeFilters });
	            break;
	          }
	        // STATUS must be the last case before default so it can fallthrough on non single branch libraries
	        default:
	          {
	            // eslint-disable-line no-fallthrough
	            var _field3 = this.props.fields.find(function (f) {
	              return f.get('id') === fieldId;
	            });
	            if (typeof _field3 === 'undefined') {
	              return _react2.default.createElement('noop', { key: fieldId });
	            }
	            fieldTag = _react2.default.createElement(
	              _aboveTheFoldOnlyServerRender.AboveTheFoldOnlyServerRender,
	              { skip: true },
	              _react2.default.createElement(_SimpleField2.default, {
	                isConjunctive: (0, _utilsFilter.isConjunctiveField)(fieldId),
	                key: _field3.get('id'),
	                label: _field3.get('id') + '.field',
	                fieldId: _field3.get('id'),
	                hasMore: _field3.get('hasMore'),
	                filters: _field3.get('fieldFilters'),
	                handleExpandField: this.props.handleExpandField,
	                handleToggleFilter: handleToggleFilter,
	                activeFilters: this.props.activeFilters,
	                initialIsExpanded: this.isFieldExpanded(_field3.get('id')),
	                handleCloseExpandField: this.props.handleCloseExpandField,
	                handleToggleExpandedField: handleToggleExpandedField })
	            );
	            break;
	          }
	      }
	
	      if (!fieldTag) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'li',
	        { key: fieldId, className: 'field' },
	        fieldTag
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-field-list' },
	        _react2.default.createElement(
	          'h3',
	          null,
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Facets.refineBy' }),
	          _react2.default.createElement(
	            'small',
	            { className: 'pull-right' },
	            _react2.default.createElement(
	              Drawer.Toggle,
	              { drawerActions: this.props.drawerActions },
	              _react2.default.createElement(
	                _baseButtons.TextButton,
	                { handleClick: this.props.drawerActions.toggle },
	                _react2.default.createElement('span', { className: 'icon icon-left-open' }),
	                'Close'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          _FacetConstants.FIELD_ORDER.map(this.renderFields)
	        )
	      );
	    }
	  }]);
	
	  return FieldList;
	}(_baseBcReactComponent2.default);
	
	FieldList.propTypes = {
	  activeFilters: _reactImmutableProptypes2.default.map.isRequired,
	  fields: _reactImmutableProptypes2.default.list.isRequired,
	  handleExpandField: _react.PropTypes.func.isRequired,
	  handleToggleFilter: _react.PropTypes.func,
	  handleToggleExpandedField: _react.PropTypes.func,
	  handleCloseExpandField: _react.PropTypes.func,
	  handleLanguageToggle: _react.PropTypes.func,
	  paginationField: _react.PropTypes.string,
	  renderSearchScope: _react.PropTypes.func,
	  transformQuery: _react.PropTypes.func,
	  singleBranch: _react.PropTypes.bool,
	  drawerActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  router: _reactRouter.routerShape
	};
	
	FieldList.defaultProps = {
	  paginationField: 'page',
	  singleBranch: false
	};
	
	exports.default = (0, _reactRouter.withRouter)(FieldList);

/***/ },
/* 1934 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _utilsFormat = __webpack_require__(96);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _SimpleField = __webpack_require__(389);
	
	var _SimpleField2 = _interopRequireDefault(_SimpleField);
	
	var _FacetConstants = __webpack_require__(187);
	
	__webpack_require__(2585);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function groupFilters(filters) {
	  return _immutable2.default.Map().withMutations(function (groups) {
	    return filters.forEach(function (filter) {
	      filter.get('groupIds').forEach(function (groupId) {
	        if (groups.has(groupId)) {
	          groups.set(groupId, groups.get(groupId).push(filter));
	        } else {
	          groups.set(groupId, _immutable2.default.List.of(filter));
	        }
	      });
	    });
	  }).toSeq().filter(function (value, groupId) {
	    return _FacetConstants.FORMAT_GROUP_ORDER.indexOf(groupId) >= 0;
	  }).sortBy(function (value, groupId) {
	    return _FacetConstants.FORMAT_GROUP_ORDER.indexOf(groupId);
	  }).map(function (value, group) {
	    return _immutable2.default.Map({ group: group, filters: value });
	  }).toList();
	}
	
	var FormatField = function (_BcReactComponent) {
	  _inherits(FormatField, _BcReactComponent);
	
	  function FormatField(props) {
	    _classCallCheck(this, FormatField);
	
	    var _this = _possibleConstructorReturn(this, (FormatField.__proto__ || Object.getPrototypeOf(FormatField)).call(this, props));
	
	    _this.bindAll('renderGrouping');
	    return _this;
	  }
	
	  _createClass(FormatField, [{
	    key: 'renderGrouping',
	    value: function renderGrouping(grouping) {
	      var filters = grouping.get('filters');
	      var group = grouping.get('group');
	
	      return _react2.default.createElement(
	        'li',
	        { className: 'sub-field ' + group, key: 'SUPERFORMAT.' + group.toLowerCase() },
	        _react2.default.createElement(_SimpleField2.default, {
	          icon: (0, _utilsFormat.getIconForFormat)(group),
	          label: 'SUPERFORMAT.' + group.toLowerCase(),
	          group: group,
	          fieldId: this.props.fieldId,
	          filters: filters,
	          activeFilters: this.props.activeFilters,
	          initialIsExpanded: true,
	          handleToggleFilter: this.props.handleToggleFilter })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          filters = _props.filters,
	          fieldId = _props.fieldId;
	
	      var groupedFilters = groupFilters(filters);
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-format-field' },
	        _react2.default.createElement(
	          'h4',
	          { className: 'field-name' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: fieldId + '.field' })
	        ),
	        _react2.default.createElement(
	          'ul',
	          { key: fieldId, className: 'filter-group' },
	          groupedFilters.map(this.renderGrouping)
	        )
	      );
	    }
	  }]);
	
	  return FormatField;
	}(_baseBcReactComponent2.default);
	
	FormatField.propTypes = {
	  fieldId: _react.PropTypes.string,
	  filters: _reactImmutableProptypes2.default.list,
	  hasMore: _react.PropTypes.bool,
	  activeFilters: _reactImmutableProptypes2.default.map,
	  handleToggleFilter: _react2.default.PropTypes.func
	};
	
	exports.default = FormatField;

/***/ },
/* 1935 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FormatField = __webpack_require__(1934);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FormatField).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1936 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _reactRouter = __webpack_require__(17);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _utilsFilter = __webpack_require__(179);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var bcPropTypes = _interopRequireWildcard(_bcPropTypes);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseCheckbox = __webpack_require__(58);
	
	var _baseCheckbox2 = _interopRequireDefault(_baseCheckbox);
	
	var _baseIcons = __webpack_require__(10);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	var _ExpandFilterLink = __webpack_require__(591);
	
	var _ExpandFilterLink2 = _interopRequireDefault(_ExpandFilterLink);
	
	var _HelpLinkContainer = __webpack_require__(126);
	
	var _HelpLinkContainer2 = _interopRequireDefault(_HelpLinkContainer);
	
	var _formatFilterForQuery = __webpack_require__(642);
	
	var _formatFilterForQuery2 = _interopRequireDefault(_formatFilterForQuery);
	
	var _formatFiltersForQuery = __webpack_require__(397);
	
	var _formatFiltersForQuery2 = _interopRequireDefault(_formatFiltersForQuery);
	
	__webpack_require__(2586);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LanguageField = function (_BcReactComponent) {
	  _inherits(LanguageField, _BcReactComponent);
	
	  function LanguageField(props) {
	    _classCallCheck(this, LanguageField);
	
	    var _this = _possibleConstructorReturn(this, (LanguageField.__proto__ || Object.getPrototypeOf(LanguageField)).call(this, props));
	
	    _this.state = {
	      translationsIncluded: false,
	      isExpanded: false
	    };
	    _this.bindAll('renderFilters', 'renderFilter', 'toggleTranslationsIncluded', 'expandField', 'handleToggleFilter', 'handleLanguageToggle');
	    return _this;
	  }
	
	  _createClass(LanguageField, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (!prevState.isExpanded && this.state.isExpanded && this._fieldToggle && this._fieldToggle._focusableElement) {
	        this._fieldToggle._focusableElement.focus();
	      }
	    }
	  }, {
	    key: 'handleLanguageToggle',
	    value: function handleLanguageToggle(fieldId) {
	      var _props = this.props,
	          router = _props.router,
	          activeFilters = _props.activeFilters,
	          transformQuery = _props.transformQuery;
	      var location = router.location;
	
	
	      var filters = activeFilters.get('LANGUAGE') || activeFilters.get('PRIMARY_LANGUAGE');
	
	      if (filters) {
	        var query = _extends({}, location.query, (0, _formatFiltersForQuery2.default)(activeFilters), {
	          f_LANGUAGE: undefined,
	          f_PRIMARY_LANGUAGE: undefined
	        }, (0, _formatFilterForQuery2.default)(fieldId, filters));
	
	        if (transformQuery) {
	          query = transformQuery(query);
	        }
	
	        router.push(_extends({}, location, { query: query }));
	      }
	    }
	  }, {
	    key: 'toggleTranslationsIncluded',
	    value: function toggleTranslationsIncluded() {
	      var newToggleState = !this.state.translationsIncluded;
	      this.setState(_extends({}, this.state, {
	        translationsIncluded: newToggleState
	      }));
	      var fieldId = newToggleState ? 'LANGUAGE' : 'PRIMARY_LANGUAGE';
	
	      return this.handleLanguageToggle(fieldId);
	    }
	  }, {
	    key: 'handleToggleFilter',
	    value: function handleToggleFilter(checked, _ref) {
	      var value = _ref.value;
	
	      this.props.handleToggleFilter(this.getCurrentFieldId(), value);
	    }
	  }, {
	    key: 'getCurrentFieldId',
	    value: function getCurrentFieldId() {
	      return this.state.translationsIncluded && this.props.language ? this.props.language.get('id') : this.props.primaryLanguage.get('id');
	    }
	  }, {
	    key: 'expandField',
	    value: function expandField() {
	      this.setState(_extends({}, this.state, {
	        isExpanded: !this.state.isExpanded
	      }));
	    }
	  }, {
	    key: 'renderExpandIcon',
	    value: function renderExpandIcon() {
	      if (this.state.isExpanded) {
	        return _react2.default.createElement(_baseIcons.Arrows.medium.Up, { color: '#333', className: 'small' });
	      }
	
	      return _react2.default.createElement(_baseIcons.Arrows.medium.Down, { color: '#333', className: 'small' });
	    }
	  }, {
	    key: 'renderFilter',
	    value: function renderFilter(filter) {
	      var value = filter.get('value');
	      var label = filter.get('label');
	      var currentFieldId = this.getCurrentFieldId();
	      var renderKey = currentFieldId + '-' + value;
	      if (!this.state.isExpanded) {
	        return _react2.default.createElement('span', { key: renderKey });
	      }
	
	      var classString = 'filter';
	      if (filter.get('applied')) {
	        classString += ' applied';
	      }
	      var filterLabel = (0, _utilsFilter.getLabel)(this.props.intl, 'LANGUAGE', label || value);
	      var formattedLabel = this.props.intl.formatMessage({ id: 'Facets.filterLabelFormat' }, { value: filterLabel, count: filter.get('count') });
	
	      return _react2.default.createElement(
	        'li',
	        { key: renderKey, className: classString },
	        _react2.default.createElement(_baseCheckbox2.default, {
	          id: 'field-' + value,
	          value: filter,
	          handleChange: this.handleToggleFilter,
	          checked: filter.get('applied'),
	          label: formattedLabel })
	      );
	    }
	  }, {
	    key: 'renderFilters',
	    value: function renderFilters() {
	      var currentField = this.state.translationsIncluded ? this.props.language : this.props.primaryLanguage;
	      var visibleFilter = function visibleFilter(f, index) {
	        return index < 15 || f.get('applied');
	      };
	      return currentField.get('fieldFilters').filter(visibleFilter).map(this.renderFilter);
	    }
	  }, {
	    key: 'renderFieldToggle',
	    value: function renderFieldToggle() {
	      var _this2 = this;
	
	      if (!this.state.isExpanded) {
	        return _react2.default.createElement('span', null);
	      }
	      return _react2.default.createElement(
	        'li',
	        { key: 'language-toggle-checkbox', className: 'language-toggle' },
	        _react2.default.createElement(_baseCheckbox2.default, {
	          id: 'language-translation-toggle',
	          checked: this.state.translationsIncluded,
	          handleChange: this.toggleTranslationsIncluded,
	          inline: true,
	          ref: function ref(el) {
	            _this2._fieldToggle = el;
	          },
	          label: this.props.intl.formatMessage({ id: 'include_translations' }) }),
	        _react2.default.createElement(
	          _HelpLinkContainer2.default,
	          {
	            className: 'small',
	            page: '045faq/030faq-searching/#trans' },
	          _react2.default.createElement(
	            _baseScreenReaderMessage2.default,
	            null,
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ada_include_translations_help_link' })
	          )
	        ),
	        _react2.default.createElement('hr', null)
	      );
	    }
	  }, {
	    key: 'renderExpandFilterLink',
	    value: function renderExpandFilterLink() {
	      var currentField = this.state.translationsIncluded ? this.props.language : this.props.primaryLanguage;
	      if (currentField.get('hasMore') && this.state.isExpanded) {
	        return _react2.default.createElement(_ExpandFilterLink2.default, {
	          fieldId: currentField.get('id'),
	          filters: currentField.get('fieldFilters'),
	          label: 'LANGUAGE.field',
	          handleToggleExpandedField: this.props.handleToggleExpandedField,
	          handleCloseExpandField: this.props.handleCloseExpandField,
	          handleExpandField: this.props.handleExpandField });
	      }
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.primaryLanguage ? !this.props.language : this.props.language) {
	        return null;
	      }
	      if (this.props.primaryLanguage || this.props.language) {
	        return _react2.default.createElement(
	          'section',
	          { className: 'cp-language-field' },
	          _react2.default.createElement(
	            'a',
	            { href: '#expand-filter', onClick: this.expandField, className: 'field-toggle' },
	            this.props.iconName || this.props.icon ? this.renderIcon() : null,
	            _react2.default.createElement(
	              'span',
	              { className: 'field-text field-name' },
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'LANGUAGES.field' })
	            ),
	            this.renderExpandIcon()
	          ),
	          _react2.default.createElement(
	            'ul',
	            { className: 'filter-list' },
	            this.renderFieldToggle(),
	            this.renderFilters()
	          ),
	          this.renderExpandFilterLink()
	        );
	      }
	      return _react2.default.createElement('noop', null);
	    }
	  }]);
	
	  return LanguageField;
	}(_baseBcReactComponent2.default);
	
	LanguageField.displayName = 'LanguageField';
	
	LanguageField.propTypes = {
	  primaryLanguage: bcPropTypes.searchFieldShape,
	  language: bcPropTypes.searchFieldShape,
	  activeFilters: _reactImmutableProptypes2.default.map,
	  handleToggleFilter: _react.PropTypes.func,
	  transformQuery: _react.PropTypes.func,
	  intl: _reactIntl.intlShape,
	  key: _react.PropTypes.string,
	  router: _reactRouter.routerShape
	};
	
	exports.default = (0, _reactIntl.injectIntl)(LanguageField);

/***/ },
/* 1937 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _LanguageField = __webpack_require__(1936);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_LanguageField).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1938 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _reactIntl = __webpack_require__(3);
	
	var _reactRouter = __webpack_require__(17);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _ActiveFilterToken = __webpack_require__(589);
	
	var _ActiveFilterToken2 = _interopRequireDefault(_ActiveFilterToken);
	
	var _utilsFilter = __webpack_require__(179);
	
	__webpack_require__(2587);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LinkFilter = function (_BcReactComponent) {
	  _inherits(LinkFilter, _BcReactComponent);
	
	  function LinkFilter(props) {
	    _classCallCheck(this, LinkFilter);
	
	    var _this = _possibleConstructorReturn(this, (LinkFilter.__proto__ || Object.getPrototypeOf(LinkFilter)).call(this, props));
	
	    _this.bindAll('handleToggleFilter');
	    return _this;
	  }
	
	  _createClass(LinkFilter, [{
	    key: 'handleToggleFilter',
	    value: function handleToggleFilter(e) {
	      if (e) {
	        e.preventDefault();
	      }
	      this.props.handleToggleFilter(this.props.fieldId, this.props.filter);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          fieldId = _props.fieldId,
	          filter = _props.filter,
	          intl = _props.intl,
	          refFunction = _props.refFunction,
	          group = _props.group;
	
	      var value = filter.get('value');
	      var label = filter.get('label');
	      var count = filter.get('count');
	      var applied = filter.get('applied');
	
	      var filterLabel = (0, _utilsFilter.getLabel)(intl, fieldId, label || value);
	      var formattedLabel = intl.formatMessage({ id: 'Facets.filterLabelFormat' }, { value: filterLabel, count: count });
	      var linkId = [fieldId, group, value].filter(function (v) {
	        return !!v;
	      }).join('-');
	
	      if (applied) {
	        return _react2.default.createElement(
	          'span',
	          { className: 'cp-link-filter' },
	          _react2.default.createElement(_ActiveFilterToken2.default, { filter: filter, handleToggleFilter: this.props.handleToggleFilter, fieldId: fieldId, filterLabel: filterLabel, ref: refFunction })
	        );
	      }
	
	      return _react2.default.createElement(
	        _reactRouter.Link,
	        {
	          className: 'cp-link-filter',
	          'data-test-id': linkId + '-filter',
	          onClick: this.handleToggleFilter,
	          ref: refFunction,
	          href: '#filter-' + fieldId + '-' + value },
	        formattedLabel
	      );
	    }
	  }]);
	
	  return LinkFilter;
	}(_baseBcReactComponent2.default);
	
	LinkFilter.propTypes = {
	  group: _react.PropTypes.string,
	  filter: _reactImmutableProptypes2.default.map.isRequired,
	  fieldId: _react.PropTypes.string.isRequired,
	  handleToggleFilter: _react.PropTypes.func.isRequired,
	  router: _reactRouter.routerShape,
	  intl: _reactIntl.intlShape,
	  refFunction: _react.PropTypes.func
	};
	
	LinkFilter.defaultProps = {
	  group: ''
	};
	
	exports.default = (0, _reactIntl.injectIntl)((0, _reactRouter.withRouter)(LinkFilter));

/***/ },
/* 1939 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _reactAddonsCssTransitionGroup = __webpack_require__(258);
	
	var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _CheckboxFilter = __webpack_require__(590);
	
	var _CheckboxFilter2 = _interopRequireDefault(_CheckboxFilter);
	
	var _ExpandFilterLink = __webpack_require__(591);
	
	var _ExpandFilterLink2 = _interopRequireDefault(_ExpandFilterLink);
	
	var _LinkFilter = __webpack_require__(594);
	
	var _LinkFilter2 = _interopRequireDefault(_LinkFilter);
	
	var _baseIcons = __webpack_require__(10);
	
	var Icons = _interopRequireWildcard(_baseIcons);
	
	__webpack_require__(2588);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  group: _react2.default.PropTypes.string,
	  initialIsExpanded: _react2.default.PropTypes.bool,
	  isConjunctive: _react.PropTypes.bool,
	  fieldId: _react2.default.PropTypes.string,
	  filters: _reactImmutableProptypes2.default.list,
	  hasMore: _react2.default.PropTypes.bool,
	  activeFilters: _react2.default.PropTypes.object,
	  intl: _react2.default.PropTypes.object,
	  icon: _react2.default.PropTypes.string,
	  iconName: _react2.default.PropTypes.string
	};
	
	var SimpleField = function (_BcReactComponent) {
	  _inherits(SimpleField, _BcReactComponent);
	
	  function SimpleField(props) {
	    _classCallCheck(this, SimpleField);
	
	    var _this = _possibleConstructorReturn(this, (SimpleField.__proto__ || Object.getPrototypeOf(SimpleField)).call(this, props));
	
	    _this.state = {
	      isExpanded: _this.props.initialIsExpanded
	    };
	
	    _this.bindAll('expandField', 'renderFilter');
	    return _this;
	  }
	
	  _createClass(SimpleField, [{
	    key: 'expandField',
	    value: function expandField(e) {
	      if (e) {
	        e.preventDefault();
	      }
	      this.setState({ isExpanded: !this.state.isExpanded });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (!prevState.isExpanded && this.state.isExpanded && this._firstFilter && this._firstFilter._focusableElement) {
	        this._firstFilter._focusableElement.focus();
	      }
	    }
	  }, {
	    key: 'renderFilter',
	    value: function renderFilter(filter, index) {
	      var _this2 = this;
	
	      var _props = this.props,
	          fieldId = _props.fieldId,
	          isConjunctive = _props.isConjunctive,
	          group = _props.group;
	
	      var FilterTag = isConjunctive ? _LinkFilter2.default : _CheckboxFilter2.default;
	      var value = filter.get('value');
	      var setFirstFilter = function setFirstFilter(el) {
	        if (index === 0) {
	          _this2._firstFilter = el;
	        }
	      };
	
	      if (!this.state.isExpanded) {
	        return _react2.default.createElement('span', { key: fieldId + '-' + group + '-' + value });
	      }
	
	      var classString = 'filter';
	      if (filter.get('applied')) {
	        classString += ' applied';
	      }
	
	      return _react2.default.createElement(
	        'li',
	        { key: fieldId + '-' + group + '-' + value, className: classString },
	        _react2.default.createElement(FilterTag, {
	          group: group,
	          fieldId: this.props.fieldId,
	          filter: filter,
	          handleToggleFilter: this.props.handleToggleFilter,
	          refFunction: setFirstFilter })
	      );
	    }
	  }, {
	    key: 'renderExpandFilterLink',
	    value: function renderExpandFilterLink() {
	      if (this.props.hasMore && this.state.isExpanded) {
	        return _react2.default.createElement(_ExpandFilterLink2.default, this.props);
	      }
	      return null;
	    }
	  }, {
	    key: 'renderIcon',
	    value: function renderIcon() {
	      if (this.props.iconName) {
	        var IconComponent = Icons[this.props.iconName];
	
	        return _react2.default.createElement(IconComponent, { className: 'flip-vert', color: '#333' });
	      }
	      return _react2.default.createElement('span', { 'aria-hidden': true, className: this.props.icon });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          intl = _props2.intl,
	          label = _props2.label,
	          fieldId = _props2.fieldId,
	          filters = _props2.filters;
	
	      return _react2.default.createElement(
	        'section',
	        { className: 'cp-simple-field clearfix ' + fieldId + ' ' },
	        _react2.default.createElement(
	          'a',
	          { href: '#expand-filter', 'data-test-id': fieldId + '-expand-filter', onClick: this.expandField, className: 'field-toggle', 'aria-expanded': this.state.isExpanded },
	          this.renderIcon(),
	          _react2.default.createElement(
	            'span',
	            { className: 'field-name' },
	            intl.formatMessage({ id: label })
	          ),
	          SimpleField.renderExpandIcon(this.state.isExpanded)
	        ),
	        _react2.default.createElement(
	          _reactAddonsCssTransitionGroup2.default,
	          {
	            transitionName: 'fade',
	            transitionEnterTimeout: 100,
	            transitionLeaveTimeout: 100,
	            component: 'ul',
	            className: 'filter-list' },
	          filters.filter(function (f, index) {
	            return index < 15 || f.get('applied');
	          }).valueSeq().map(this.renderFilter)
	        ),
	        this.renderExpandFilterLink()
	      );
	    }
	  }], [{
	    key: 'renderExpandIcon',
	    value: function renderExpandIcon(expanded) {
	      if (expanded) {
	        return _react2.default.createElement(Icons.Arrows.medium.Up, { color: '#333', className: 'small' });
	      }
	
	      return _react2.default.createElement(Icons.Arrows.medium.Down, { color: '#333', className: 'small' });
	    }
	  }, {
	    key: 'renderLabel',
	    value: function renderLabel(filterLabel, filter) {
	      return _react2.default.createElement(
	        'span',
	        { className: 'filter-label-text' },
	        filterLabel,
	        _react2.default.createElement(
	          'span',
	          { className: 'filter-count' },
	          '(',
	          _react2.default.createElement(_reactIntl.FormattedNumber, { value: filter.get('count') }),
	          ')'
	        )
	      );
	    }
	  }]);
	
	  return SimpleField;
	}(_baseBcReactComponent2.default);
	
	SimpleField.propTypes = propTypes;
	
	exports.default = (0, _reactIntl.injectIntl)(SimpleField);

/***/ },
/* 1940 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _reactIntl = __webpack_require__(3);
	
	var _SimpleField = __webpack_require__(389);
	
	var _SimpleField2 = _interopRequireDefault(_SimpleField);
	
	var _baseIcons = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TagGroupField = function (_Component) {
	  _inherits(TagGroupField, _Component);
	
	  function TagGroupField(props) {
	    _classCallCheck(this, TagGroupField);
	
	    var _this = _possibleConstructorReturn(this, (TagGroupField.__proto__ || Object.getPrototypeOf(TagGroupField)).call(this, props));
	
	    _this.state = {
	      expanded: props.genreExpanded || props.toneExpanded || props.aboutExpanded || props.personalExpanded
	    };
	    _this.expandField = _this.expandField.bind(_this);
	    return _this;
	  }
	
	  _createClass(TagGroupField, [{
	    key: 'expandField',
	    value: function expandField(e) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      this.setState({
	        expanded: !this.state.expanded
	      });
	    }
	  }, {
	    key: 'renderSubField',
	    value: function renderSubField(field, expanded) {
	      if (typeof field === 'undefined') {
	        return null;
	      }
	      return _react2.default.createElement(
	        'li',
	        { key: field.get('id'), className: 'sub-field' },
	        _react2.default.createElement(_SimpleField2.default, {
	          isConjunctive: true,
	          iconName: 'Tag',
	          label: field.get('id') + '.field',
	          fieldId: field.get('id'),
	          filters: field.get('fieldFilters'),
	          hasMore: field.get('hasMore'),
	          activeFilters: this.props.activeFilters,
	          initialIsExpanded: expanded,
	          handleToggleFilter: this.props.handleToggleFilter,
	          handleCloseExpandField: this.props.handleCloseExpandField,
	          handleToggleExpandedField: this.props.handleToggleExpandedField,
	          handleExpandField: this.props.handleExpandField })
	      );
	    }
	  }, {
	    key: 'renderSubFields',
	    value: function renderSubFields() {
	      var _props = this.props,
	          genreTagField = _props.genreTagField,
	          toneTagField = _props.toneTagField,
	          aboutTagField = _props.aboutTagField,
	          personalTagField = _props.personalTagField,
	          genreExpanded = _props.genreExpanded,
	          toneExpanded = _props.toneExpanded,
	          aboutExpanded = _props.aboutExpanded,
	          personalExpanded = _props.personalExpanded;
	
	      return _react2.default.createElement(
	        'ul',
	        { key: 'TAG_GROUP', className: 'filter-group' },
	        this.renderSubField(genreTagField, genreExpanded),
	        this.renderSubField(toneTagField, toneExpanded),
	        this.renderSubField(aboutTagField, aboutExpanded),
	        this.renderSubField(personalTagField, personalExpanded)
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          genreTagField = _props2.genreTagField,
	          toneTagField = _props2.toneTagField,
	          aboutTagField = _props2.aboutTagField,
	          personalTagField = _props2.personalTagField,
	          intl = _props2.intl;
	
	
	      if (genreTagField || toneTagField || aboutTagField || personalTagField) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'a',
	            { href: '#expand-filter', onClick: this.expandField, className: 'field-toggle' },
	            _react2.default.createElement(
	              'span',
	              { className: 'field-text field-name' },
	              intl.formatMessage({ id: 'TAGS.field' })
	            ),
	            TagGroupField.renderExpandIcon(this.state.expanded)
	          ),
	          this.state.expanded ? this.renderSubFields() : null
	        );
	      }
	      return null;
	    }
	  }], [{
	    key: 'renderExpandIcon',
	    value: function renderExpandIcon(expanded) {
	      if (expanded) {
	        return _react2.default.createElement(_baseIcons.Arrows.medium.Up, { color: '#333', className: 'small' });
	      }
	
	      return _react2.default.createElement(_baseIcons.Arrows.medium.Down, { color: '#333', className: 'small' });
	    }
	  }]);
	
	  return TagGroupField;
	}(_react.Component);
	
	TagGroupField.propTypes = {
	  genreTagField: _reactImmutableProptypes2.default.map,
	  genreExpanded: _react.PropTypes.bool,
	  toneTagField: _reactImmutableProptypes2.default.map,
	  toneExpanded: _react.PropTypes.bool,
	  aboutExpanded: _react.PropTypes.bool,
	  aboutTagField: _reactImmutableProptypes2.default.map,
	  personalExpanded: _react.PropTypes.bool,
	  personalTagField: _reactImmutableProptypes2.default.map,
	  handleToggleFilter: _react.PropTypes.func.isRequired,
	  handleCloseExpandField: _react.PropTypes.func,
	  handleToggleExpandedField: _react.PropTypes.func.isRequired,
	  handleExpandField: _react.PropTypes.func.isRequired,
	  activeFilters: _reactImmutableProptypes2.default.map,
	  intl: _reactIntl.intlShape.isRequired
	};
	
	exports.default = (0, _reactIntl.injectIntl)(TagGroupField);

/***/ },
/* 1941 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TagGroupField = __webpack_require__(1940);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TagGroupField).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1942 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseInlineOverlay = __webpack_require__(83);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var bcPropTypes = _interopRequireWildcard(_bcPropTypes);
	
	var _ShelfConstants = __webpack_require__(43);
	
	var _rating = __webpack_require__(141);
	
	var _rating2 = _interopRequireDefault(_rating);
	
	var _baseAlerts = __webpack_require__(36);
	
	var _OnShelfDropdown = __webpack_require__(1970);
	
	var _OnShelfDropdown2 = _interopRequireDefault(_OnShelfDropdown);
	
	var _baseButtons = __webpack_require__(12);
	
	var _sharedPrivacyTogglePills = __webpack_require__(1502);
	
	var _sharedPrivacyTogglePills2 = _interopRequireDefault(_sharedPrivacyTogglePills);
	
	var _utilsGoogleAnalytics = __webpack_require__(231);
	
	var _utilsGoogleAnalytics2 = _interopRequireDefault(_utilsGoogleAnalytics);
	
	__webpack_require__(2589);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ItemAddedToShelfView = function (_BcReactComponent) {
	  _inherits(ItemAddedToShelfView, _BcReactComponent);
	
	  function ItemAddedToShelfView(props) {
	    _classCallCheck(this, ItemAddedToShelfView);
	
	    var _this = _possibleConstructorReturn(this, (ItemAddedToShelfView.__proto__ || Object.getPrototypeOf(ItemAddedToShelfView)).call(this, props));
	
	    _this.bindAll('toggleItemPrivacy', 'handleUpdateRating', 'handleRemoveRating', 'renderRatingSection', 'getSuccessMessageStringId', 'handleUpdateShelfItem', 'handleRemoveShelfItem');
	    return _this;
	  }
	
	  _createClass(ItemAddedToShelfView, [{
	    key: 'toggleItemPrivacy',
	    value: function toggleItemPrivacy(isPrivate) {
	      var shelfItem = this.props.shelfItem;
	
	      var shelfName = shelfItem.get('shelf');
	
	      _utilsGoogleAnalytics2.default.event({
	        eventCategory: 'NERF Search',
	        eventAction: 'Change item privacy',
	        eventLabel: isPrivate ? 'Private' : 'Shared'
	      });
	
	      return this.handleUpdateShelfItem(shelfName, shelfItem.get('id'), shelfItem.get('metadataId'), {
	        newShelfName: shelfName,
	        privateItem: isPrivate
	      });
	    }
	  }, {
	    key: 'handleUpdateRating',
	    value: function handleUpdateRating(rating) {
	      var _props = this.props,
	          rateItem = _props.rateItem,
	          changeItemRating = _props.changeItemRating,
	          bib = _props.bib,
	          currentUserRating = _props.currentUserRating;
	      // updates existing rating
	
	      if (currentUserRating) {
	        return changeItemRating(bib.get('id'), rating);
	      }
	
	      // adds new rating
	      return rateItem(bib.get('id'), rating);
	    }
	  }, {
	    key: 'handleRemoveRating',
	    value: function handleRemoveRating() {
	      var _props2 = this.props,
	          removeItemRating = _props2.removeItemRating,
	          bib = _props2.bib,
	          currentUserRating = _props2.currentUserRating;
	
	      return removeItemRating(bib.get('id'), currentUserRating.get('id'));
	    }
	  }, {
	    key: 'handleUpdateShelfItem',
	    value: function handleUpdateShelfItem(shelfName, id, metadataId, fieldsToUpdate) {
	      return this.props.updateShelfItems(_extends({
	        shelfName: shelfName,
	        shelfItemIds: [id],
	        metadataIds: [metadataId]
	      }, fieldsToUpdate));
	    }
	  }, {
	    key: 'handleRemoveShelfItem',
	    value: function handleRemoveShelfItem(shelfName, id, metadataId) {
	      this.props.removeShelfItems({
	        shelfName: shelfName,
	        shelfItemIds: [id],
	        metadataIds: [metadataId],
	        workflowId: this.props.workflowId
	      });
	    }
	  }, {
	    key: 'renderRatingSection',
	    value: function renderRatingSection() {
	      var _props3 = this.props,
	          shelfItem = _props3.shelfItem,
	          bib = _props3.bib,
	          currentUserRating = _props3.currentUserRating,
	          ratingsTransactions = _props3.ratingsTransactions;
	
	      var shelfName = shelfItem.get('shelf');
	      var metadataId = bib.get('id');
	      var isLoading = ratingsTransactions.getIn([metadataId, 'isLoading'], false);
	
	      if (shelfName === _ShelfConstants.SHELF_NAMES.COMPLETED) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'post-success-rating' },
	          _react2.default.createElement(_rating2.default, {
	            id: 'added_to_shelf_rating_' + metadataId,
	            isLoading: isLoading,
	            rating: currentUserRating ? currentUserRating.get('rating') : null,
	            handleButtonClick: this.handleUpdateRating,
	            handleRemoveClick: this.handleRemoveRating })
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderShelfSelectDropdown',
	    value: function renderShelfSelectDropdown() {
	      return _react2.default.createElement(_OnShelfDropdown2.default, {
	        currentShelfItem: this.props.shelfItem,
	        updateShelfItem: this.handleUpdateShelfItem,
	        removeShelfItem: this.handleRemoveShelfItem });
	    }
	  }, {
	    key: 'getSuccessMessageStringId',
	    value: function getSuccessMessageStringId() {
	      var shelfItem = this.props.shelfItem;
	
	      var shelfName = shelfItem.get('shelf');
	      var isPrivate = shelfItem.get('privateItem', false);
	
	      if (isPrivate) {
	        return 'message_add_to_' + shelfName + '_library';
	      }
	
	      return 'message_shared_on_' + shelfName + '_library';
	    }
	  }, {
	    key: 'renderPostSuccessMessage',
	    value: function renderPostSuccessMessage() {
	      var _props4 = this.props,
	          bib = _props4.bib,
	          view = _props4.view;
	
	      var bibTitle = bib.get('title');
	
	      if (view === _ShelfConstants.WORKFLOW_VIEWS.EXISTS_ON_SHELF) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        _baseAlerts.AlertSuccess,
	        { className: 'hidden-xs' },
	        _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
	          id: this.getSuccessMessageStringId(),
	          values: { titles: bibTitle } })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props5 = this.props,
	          handleClose = _props5.handleClose,
	          shelfItem = _props5.shelfItem;
	
	      var isPrivate = shelfItem.get('privateItem') || false;
	
	      return _react2.default.createElement(
	        _baseInlineOverlay.InlineOverlay,
	        { handleClose: handleClose },
	        _react2.default.createElement(_baseInlineOverlay.InlineOverlayHeader, null),
	        _react2.default.createElement(
	          _baseInlineOverlay.InlineOverlayBody,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'post-shelf-success-body' },
	            this.renderShelfSelectDropdown(),
	            _react2.default.createElement(_sharedPrivacyTogglePills2.default, { isPrivate: isPrivate, handlePrivacyToggle: this.toggleItemPrivacy }),
	            this.renderRatingSection()
	          )
	        ),
	        _react2.default.createElement(
	          _baseInlineOverlay.InlineOverlayFooter,
	          null,
	          _react2.default.createElement(
	            _baseButtons.DefaultButton,
	            { handleClick: handleClose },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_close' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return ItemAddedToShelfView;
	}(_baseBcReactComponent2.default);
	
	ItemAddedToShelfView.propTypes = {
	  workflowId: _react.PropTypes.string,
	  rateItem: _react.PropTypes.func.isRequired,
	  changeItemRating: _react.PropTypes.func.isRequired,
	  removeShelfItems: _react.PropTypes.func.isRequired,
	  removeItemRating: _react.PropTypes.func.isRequired,
	  updateShelfItems: _react.PropTypes.func.isRequired,
	  bib: _react.PropTypes.shape({
	    id: _react.PropTypes.string
	  }).isRequired,
	  handleClose: _react.PropTypes.func.isRequired,
	  shelfItem: bcPropTypes.shelfItemShape,
	  currentUserRating: _reactImmutableProptypes2.default.mapContains({
	    id: _react.PropTypes.number,
	    metadataId: _react.PropTypes.string,
	    userId: _react.PropTypes.number,
	    rating: _react.PropTypes.number
	  }),
	  ratingsTransactions: _reactImmutableProptypes2.default.map.isRequired
	};
	
	ItemAddedToShelfView.displayName = 'ItemAddedToShelfView';
	
	exports.default = ItemAddedToShelfView;

/***/ },
/* 1943 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ItemAddedToShelfView = __webpack_require__(1942);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ItemAddedToShelfView).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1944 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ItemFormat;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsFormat = __webpack_require__(96);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _FormatInfoContainer = __webpack_require__(188);
	
	var _FormatInfoContainer2 = _interopRequireDefault(_FormatInfoContainer);
	
	__webpack_require__(2590);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ItemFormat(_ref) {
	  var bib = _ref.bib;
	
	  var format = bib.getIn(['briefInfo', 'format']);
	
	  if (!bib) {
	    return null;
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'cp-item-format' },
	    _react2.default.createElement('span', {
	      'data-test-id': 'format-indicator-' + format.toLowerCase(),
	      className: (0, _utilsFormat.getIconForFormat)(format),
	      'aria-hidden': true }),
	    _react2.default.createElement(_FormatInfoContainer2.default, { item: bib, showCallNumber: false })
	  );
	}
	
	ItemFormat.propTypes = {
	  bib: _bcPropTypes.bibShape
	};

/***/ },
/* 1945 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ItemList;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(2591);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ItemList(_ref) {
	  var children = _ref.children,
	      className = _ref.className;
	
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)('cp-item-list', className) },
	    children
	  );
	}
	
	ItemList.propTypes = {
	  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node]),
	  className: _react.PropTypes.string
	};

/***/ },
/* 1946 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _lodash = __webpack_require__(16);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseCheckbox = __webpack_require__(58);
	
	var _baseCheckbox2 = _interopRequireDefault(_baseCheckbox);
	
	var _baseDropdown = __webpack_require__(37);
	
	var _ShelfConstants = __webpack_require__(43);
	
	__webpack_require__(2592);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  toAdd: _react.PropTypes.bool,
	  name: _react.PropTypes.string.isRequired,
	  isPrivate: _react.PropTypes.bool
	};
	
	var CancelHoldShelfPrompt = function (_BcReactComponent) {
	  _inherits(CancelHoldShelfPrompt, _BcReactComponent);
	
	  function CancelHoldShelfPrompt(props) {
	    _classCallCheck(this, CancelHoldShelfPrompt);
	
	    var _this = _possibleConstructorReturn(this, (CancelHoldShelfPrompt.__proto__ || Object.getPrototypeOf(CancelHoldShelfPrompt)).call(this, props));
	
	    _this.bindAll('handleChangeAddTo', 'handleChangeShelf');
	    _this._checkboxId = _lodash2.default.uniqueId('shelf_checkbox_');
	    return _this;
	  }
	
	  _createClass(CancelHoldShelfPrompt, [{
	    key: 'handleChangeAddTo',
	    value: function handleChangeAddTo(toAdd) {
	      this.props.handleChange({ toAdd: toAdd });
	    }
	  }, {
	    key: 'handleChangeShelf',
	    value: function handleChangeShelf(name) {
	      this.props.handleChange({ name: name });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-cancel-hold-shelf-prompt' },
	        _react2.default.createElement(_baseCheckbox2.default, {
	          inline: true,
	          className: 'add-to-shelf-checkbox',
	          id: this._checkboxId,
	          checked: this.props.toAdd,
	          handleChange: this.handleChangeAddTo,
	          label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'label_also_move_shelf' }) }),
	        _react2.default.createElement(_baseDropdown.Dropdown, {
	          className: 'btn-flat btn btn-default',
	          options: CancelHoldShelfPrompt.getShelfOptions(),
	          selected: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'label_my_shelf_' + this.props.name }),
	          handleSelect: this.handleChangeShelf })
	      );
	    }
	  }], [{
	    key: 'getShelfOptions',
	    value: function getShelfOptions() {
	      return _immutable2.default.Map(_ShelfConstants.SHELF_NAMES).valueSeq().toArray().map(function (name) {
	        return {
	          label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'label_shelf_' + name }),
	          value: name
	        };
	      });
	    }
	  }]);
	
	  return CancelHoldShelfPrompt;
	}(_baseBcReactComponent2.default);
	
	CancelHoldShelfPrompt.propTypes = propTypes;
	
	exports.default = CancelHoldShelfPrompt;

/***/ },
/* 1947 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BatchCancelHoldWorkflowView = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _BaseCancelHoldWorkflowView = __webpack_require__(596);
	
	var _BaseCancelHoldWorkflowView2 = _interopRequireDefault(_BaseCancelHoldWorkflowView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BatchCancelHoldWorkflowView = exports.BatchCancelHoldWorkflowView = function (_BcReactComponent) {
	  _inherits(BatchCancelHoldWorkflowView, _BcReactComponent);
	
	  function BatchCancelHoldWorkflowView(props) {
	    _classCallCheck(this, BatchCancelHoldWorkflowView);
	
	    var _this = _possibleConstructorReturn(this, (BatchCancelHoldWorkflowView.__proto__ || Object.getPrototypeOf(BatchCancelHoldWorkflowView)).call(this, props));
	
	    _this.bindAll('handleCancelHold');
	    return _this;
	  }
	
	  _createClass(BatchCancelHoldWorkflowView, [{
	    key: 'handleCancelHold',
	    value: function handleCancelHold(_ref) {
	      var _this2 = this;
	
	      var shelfState = _ref.shelfState;
	      var _props = this.props,
	          accountId = _props.accountId,
	          holdIds = _props.holdIds,
	          bibs = _props.bibs,
	          messagingId = _props.messagingId,
	          workflowId = _props.workflowId;
	
	      this.props.cancelHold({
	        accountId: accountId,
	        metadataIds: bibs.map(function (bib) {
	          return bib.get('metadataId');
	        }).filter(function (metadataId) {
	          return !_this2.props.shelves.has(metadataId);
	        }),
	        holdIds: holdIds,
	        shelfState: shelfState,
	        messagingId: messagingId,
	        workflowId: workflowId,
	        isBatch: true
	      });
	    }
	  }, {
	    key: 'anyBibNotOnShelf',
	    value: function anyBibNotOnShelf() {
	      var _this3 = this;
	
	      return this.props.bibs.map(function (bib) {
	        return bib && bib.get('metadataId');
	      }).some(function (metadataId) {
	        return !_this3.props.shelves.has(metadataId);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          handleClose = _props2.handleClose,
	          accountId = _props2.accountId,
	          holdIds = _props2.holdIds,
	          isLoading = _props2.isLoading,
	          done = _props2.done,
	          bibs = _props2.bibs,
	          messagingId = _props2.messagingId,
	          workflowId = _props2.workflowId;
	
	      var showShelfPrompt = this.anyBibNotOnShelf();
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-batch-cancel-hold-view' },
	        _react2.default.createElement(_BaseCancelHoldWorkflowView2.default, {
	          handleCancelHold: this.handleCancelHold,
	          handleClose: handleClose,
	          accountId: accountId,
	          holdIds: holdIds,
	          isLoading: isLoading,
	          done: done,
	          bibs: bibs,
	          messagingId: messagingId,
	          showShelfPrompt: showShelfPrompt,
	          workflowId: workflowId })
	      );
	    }
	  }]);
	
	  return BatchCancelHoldWorkflowView;
	}(_baseBcReactComponent2.default);
	
	BatchCancelHoldWorkflowView.propTypes = {
	  handleClose: _react.PropTypes.func.isRequired,
	  cancelHold: _react.PropTypes.func.isRequired,
	  accountId: _react.PropTypes.number.isRequired,
	  holdIds: _reactImmutableProptypes2.default.listOf(_react.PropTypes.string),
	  isLoading: _react.PropTypes.bool,
	  done: _react.PropTypes.bool,
	  bibs: _reactImmutableProptypes2.default.listOf(_bcPropTypes.bibShape).isRequired,
	  messagingId: _react.PropTypes.string,
	  workflowId: _react.PropTypes.string,
	  shelves: _reactImmutableProptypes2.default.map.isRequired
	};
	
	exports.default = BatchCancelHoldWorkflowView;

/***/ },
/* 1948 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SingleCancelHoldWorkflowView = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _BaseCancelHoldWorkflowView = __webpack_require__(596);
	
	var _BaseCancelHoldWorkflowView2 = _interopRequireDefault(_BaseCancelHoldWorkflowView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SingleCancelHoldWorkflowView = exports.SingleCancelHoldWorkflowView = function (_BcReactComponent) {
	  _inherits(SingleCancelHoldWorkflowView, _BcReactComponent);
	
	  function SingleCancelHoldWorkflowView(props) {
	    _classCallCheck(this, SingleCancelHoldWorkflowView);
	
	    var _this = _possibleConstructorReturn(this, (SingleCancelHoldWorkflowView.__proto__ || Object.getPrototypeOf(SingleCancelHoldWorkflowView)).call(this, props));
	
	    _this.bindAll('handleCancelHold');
	    return _this;
	  }
	
	  _createClass(SingleCancelHoldWorkflowView, [{
	    key: 'handleCancelHold',
	    value: function handleCancelHold(_ref) {
	      var shelfState = _ref.shelfState;
	      var _props = this.props,
	          accountId = _props.accountId,
	          holdId = _props.holdId,
	          bib = _props.bib,
	          messagingId = _props.messagingId,
	          workflowId = _props.workflowId;
	
	      this.props.cancelHold({
	        accountId: accountId,
	        metadataIds: [bib.get('metadataId')],
	        holdIds: [holdId],
	        shelfState: shelfState,
	        messagingId: messagingId,
	        workflowId: workflowId
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          handleClose = _props2.handleClose,
	          accountId = _props2.accountId,
	          holdId = _props2.holdId,
	          isLoading = _props2.isLoading,
	          bib = _props2.bib,
	          shelves = _props2.shelves,
	          messagingId = _props2.messagingId;
	
	      var showShelfPrompt = !shelves.get(bib.get('metadataId'));
	
	      return _react2.default.createElement(_BaseCancelHoldWorkflowView2.default, {
	        testId: 'cancel-holds-overlay-' + bib.get('id'),
	        handleClose: handleClose,
	        handleCancelHold: this.handleCancelHold,
	        accountId: accountId,
	        holdIds: _immutable2.default.List.of(holdId),
	        isLoading: isLoading,
	        showShelfPrompt: showShelfPrompt,
	        bibs: _immutable2.default.List.of(bib),
	        messagingId: messagingId });
	    }
	  }]);
	
	  return SingleCancelHoldWorkflowView;
	}(_baseBcReactComponent2.default);
	
	SingleCancelHoldWorkflowView.propTypes = {
	  handleClose: _react.PropTypes.func.isRequired,
	  cancelHold: _react.PropTypes.func.isRequired,
	  accountId: _react.PropTypes.number.isRequired,
	  holdId: _react.PropTypes.string,
	  isLoading: _react.PropTypes.bool,
	  bib: _bcPropTypes.bibShape.isRequired,
	  shelves: _reactImmutableProptypes2.default.map.isRequired,
	  messagingId: _react.PropTypes.string,
	  workflowId: _react.PropTypes.string
	};
	
	exports.default = SingleCancelHoldWorkflowView;

/***/ },
/* 1949 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SingleCancelHoldWorkflowView = __webpack_require__(1948);
	
	Object.defineProperty(exports, 'SingleCancelHoldWorkflowView', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SingleCancelHoldWorkflowView).default;
	  }
	});
	
	var _BatchCancelHoldWorkflowView = __webpack_require__(1947);
	
	Object.defineProperty(exports, 'BatchCancelHoldWorkflowView', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BatchCancelHoldWorkflowView).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1950 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CheckedOutReadingLinks = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseButtons = __webpack_require__(12);
	
	var _baseIcons = __webpack_require__(10);
	
	__webpack_require__(2594);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CheckedOutReadingLinks = exports.CheckedOutReadingLinks = function (_BcReactComponent) {
	  _inherits(CheckedOutReadingLinks, _BcReactComponent);
	
	  function CheckedOutReadingLinks(props) {
	    _classCallCheck(this, CheckedOutReadingLinks);
	
	    var _this = _possibleConstructorReturn(this, (CheckedOutReadingLinks.__proto__ || Object.getPrototypeOf(CheckedOutReadingLinks)).call(this, props));
	
	    _this.bindAll('handleCheckIn', 'startDigitalMissingFormatSelection');
	    return _this;
	  }
	
	  _createClass(CheckedOutReadingLinks, [{
	    key: 'handleCheckIn',
	    value: function handleCheckIn(e) {
	      e.preventDefault();
	      var _props = this.props,
	          accountId = _props.accountId,
	          metadataId = _props.metadataId,
	          checkoutId = _props.checkoutId,
	          messagingId = _props.messagingId;
	
	      this.props.checkIn({ accountId: accountId, metadataId: metadataId, messagingId: messagingId, checkoutId: checkoutId });
	    }
	  }, {
	    key: 'startDigitalMissingFormatSelection',
	    value: function startDigitalMissingFormatSelection(e) {
	      e.preventDefault();
	      this.props.startDigitalMissingFormatSelection(this.props.metadataId);
	    }
	  }, {
	    key: 'renderThirdPartyReaderLink',
	    value: function renderThirdPartyReaderLink() {
	      if (this.props.thirdPartyReaderUrl) {
	        return _react2.default.createElement(
	          'a',
	          {
	            href: this.props.thirdPartyReaderUrl,
	            rel: 'noopener noreferrer',
	            target: '_blank',
	            className: 'btn btn-link',
	            'data-testid': 'link_thirdparty_reader' },
	          _react2.default.createElement(_baseIcons.RightArrowCircledOutline, null),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'open_in_third_party_reader' }),
	            _react2.default.createElement(_baseIcons.ExternalArrow, null)
	          )
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderCheckInLink',
	    value: function renderCheckInLink() {
	      if (this.props.checkInEnabled) {
	        return _react2.default.createElement(
	          _baseButtons.PrimaryButton,
	          {
	            block: true,
	            handleClick: this.handleCheckIn,
	            disabled: this.props.disabled },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'digital_return_now' })
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderDownloadBlock',
	    value: function renderDownloadBlock() {
	      if (this.props.policy.get('supportsDownload')) {
	        if (!this.props.downloadable && this.props.thirdPartyReaderUrl) {
	          // The service supports downloading but the format isn't downloadable (e.g MediaDo)
	          return null;
	        }
	
	        if (this.props.format) {
	          if (this.props.downloadUrl) {
	            return _react2.default.createElement(
	              'a',
	              {
	                href: this.props.downloadUrl,
	                className: 'btn btn-link',
	                target: '_blank',
	                rel: 'noopener noreferrer' },
	              _react2.default.createElement(_baseIcons.CloudDownload, null),
	              _react2.default.createElement(_reactIntl.FormattedMessage, {
	                id: 'download_now_' + this.props.format.toLowerCase(),
	                defaultMessage: this.props.intl.formatMessage({
	                  id: 'download_now_format'
	                }, {
	                  format: this.props.intl.formatMessage({ id: 'digiformat_' + this.props.format.toLowerCase() })
	                }) })
	            );
	          }
	
	          return _react2.default.createElement(
	            'a',
	            { href: this.props.policy.get('helpUrl'), target: '_blank', rel: 'noopener noreferrer', className: 'btn btn-link' },
	            _react2.default.createElement(_baseIcons.Info, null),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                _reactIntl.FormattedMessage,
	                { id: 'how_do_i_get_digital_checkout' },
	                function (message) {
	                  return _react2.default.createElement(
	                    'span',
	                    { 'aria-hidden': true },
	                    message
	                  );
	                }
	              ),
	              _react2.default.createElement(
	                _baseScreenReaderMessage2.default,
	                null,
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ada_how_do_i_get_digital_checkout' })
	              ),
	              _react2.default.createElement(_baseIcons.ExternalArrow, null)
	            )
	          );
	        }
	
	        return _react2.default.createElement(
	          'button',
	          {
	            disabled: this.props.disabled,
	            onClick: this.startDigitalMissingFormatSelection,
	            className: 'btn btn-link download-missing-format' },
	          _react2.default.createElement(_baseIcons.CloudDownload, null),
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'missing_format_download' })
	        );
	      }
	      return (
	        // Get Link URL from Settings
	        _react2.default.createElement(
	          'a',
	          { href: this.props.policy.get('quickStartUrl'), target: '_blank', rel: 'noopener noreferrer', className: 'btn btn-link' },
	          _react2.default.createElement(_baseIcons.Info, null),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _reactIntl.FormattedMessage,
	              { id: 'how_do_i_3m' },
	              function (message) {
	                return _react2.default.createElement(
	                  'span',
	                  { 'aria-hidden': true },
	                  message
	                );
	              }
	            ),
	            _react2.default.createElement(
	              _reactIntl.FormattedMessage,
	              { id: 'ada_how_do_i_3m' },
	              function (message) {
	                return _react2.default.createElement(
	                  _baseScreenReaderMessage2.default,
	                  null,
	                  message
	                );
	              }
	            ),
	            _react2.default.createElement(_baseIcons.ExternalArrow, null)
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var policy = this.props.policy;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-checked-out-reading-links' },
	        this.renderCheckInLink(),
	        _react2.default.createElement(
	          'div',
	          { className: 'access-title-block' },
	          policy.get('supportsDownload') && _react2.default.createElement(_reactIntl.FormattedMessage, { tagName: 'h3', id: 'access_this_title' }),
	          this.renderDownloadBlock(),
	          this.renderThirdPartyReaderLink()
	        )
	      );
	    }
	  }]);
	
	  return CheckedOutReadingLinks;
	}(_baseBcReactComponent2.default);
	
	CheckedOutReadingLinks.propTypes = {
	  checkInEnabled: _react.PropTypes.bool,
	  disabled: _react.PropTypes.bool,
	  policy: _react.PropTypes.shape({
	    thirdPartyReaderUrl: _react.PropTypes.string,
	    supportsDownload: _react.PropTypes.bool,
	    quickstartUrl: _react.PropTypes.string,
	    helpUrl: _react.PropTypes.string
	  }),
	  checkoutId: _react.PropTypes.string.isRequired,
	  metadataId: _react.PropTypes.string.isRequired,
	  accountId: _react.PropTypes.number.isRequired,
	  downloadable: _react.PropTypes.bool,
	  downloadUrl: _react.PropTypes.string,
	  format: _react.PropTypes.string,
	  checkIn: _react.PropTypes.func.isRequired,
	  startDigitalMissingFormatSelection: _react.PropTypes.func.isRequired,
	  messagingId: _react.PropTypes.string
	};
	
	exports.default = (0, _reactIntl.injectIntl)(CheckedOutReadingLinks);

/***/ },
/* 1951 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CheckedOutReadingLinks = __webpack_require__(1950);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CheckedOutReadingLinks).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1952 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseCheckbox = __webpack_require__(58);
	
	var _baseCheckbox2 = _interopRequireDefault(_baseCheckbox);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseIcons = __webpack_require__(10);
	
	__webpack_require__(2595);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EnableAutoCheckouts = function (_BcReactComponent) {
	  _inherits(EnableAutoCheckouts, _BcReactComponent);
	
	  function EnableAutoCheckouts(props) {
	    _classCallCheck(this, EnableAutoCheckouts);
	
	    var _this = _possibleConstructorReturn(this, (EnableAutoCheckouts.__proto__ || Object.getPrototypeOf(EnableAutoCheckouts)).call(this, props));
	
	    _this.state = {
	      helpIsOpen: _this.props.initialHelpIsOpen,
	      isChecked: _this.props.initialIsChecked
	    };
	
	    _this.bindAll('toggleHelp', 'toggleAutoCheckouts');
	    return _this;
	  }
	
	  _createClass(EnableAutoCheckouts, [{
	    key: 'toggleHelp',
	    value: function toggleHelp(e) {
	      if (e) {
	        e.preventDefault();
	      }
	      this.setState({ helpIsOpen: !this.state.helpIsOpen });
	    }
	  }, {
	    key: 'renderHelp',
	    value: function renderHelp() {
	      var intl = this.props.intl;
	
	      if (this.state.helpIsOpen) {
	        var helpInfo = intl.formatMessage({ id: 'enable_auto_checkout_info' });
	        return _react2.default.createElement(
	          'div',
	          { className: 'toggle-auto-checkouts-help', 'aria-expanded': this.state.helpIsOpen, 'aria-live': 'polite' },
	          helpInfo
	        );
	      }
	      return null;
	    }
	  }, {
	    key: 'toggleAutoCheckouts',
	    value: function toggleAutoCheckouts(checked) {
	      this.setState({ isChecked: !this.state.isChecked });
	      this.props.handleChange(checked);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          intl = _props.intl,
	          supportAutoCheckout = _props.supportAutoCheckout;
	
	      var helpInfoTriggerText = intl.formatMessage({ id: 'label_info' });
	      var checkboxLabel = intl.formatMessage({ id: 'enable_auto_checkout' });
	
	      if (supportAutoCheckout) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'cp-digital-auto-checkouts' },
	          _react2.default.createElement(_baseCheckbox2.default, {
	            id: 'toggle-auto-checkouts',
	            label: checkboxLabel,
	            name: 'autoCheckout',
	            checked: this.state.isChecked,
	            inline: true,
	            handleChange: this.toggleAutoCheckouts,
	            labelAfter: true }),
	          _react2.default.createElement(
	            'a',
	            { href: '#toggle-help', onClick: this.toggleHelp, className: 'toggle-help-trigger' },
	            _react2.default.createElement(_baseIcons.Info, null),
	            ' ',
	            helpInfoTriggerText
	          ),
	          this.renderHelp()
	        );
	      }
	      return null;
	    }
	  }]);
	
	  return EnableAutoCheckouts;
	}(_baseBcReactComponent2.default);
	
	EnableAutoCheckouts.defaultProps = {
	  initialHelpIsOpen: false,
	  initialIsChecked: false,
	  supportAutoCheckout: false
	};
	
	EnableAutoCheckouts.propTypes = {
	  handleChange: _react.PropTypes.func.isRequired,
	  initialHelpIsOpen: _react.PropTypes.bool,
	  initialIsChecked: _react.PropTypes.bool,
	  supportAutoCheckout: _react.PropTypes.bool,
	  intl: _reactIntl.intlShape
	};
	
	exports.default = (0, _reactIntl.injectIntl)(EnableAutoCheckouts);

/***/ },
/* 1953 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _EnableAutoCheckouts = __webpack_require__(1952);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_EnableAutoCheckouts).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1954 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DigitalCheckoutWorkflowView = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseInlineOverlay = __webpack_require__(83);
	
	var _baseButtons = __webpack_require__(12);
	
	var _baseIcons = __webpack_require__(10);
	
	var _sharedMessages = __webpack_require__(64);
	
	var _MessagingContainer = __webpack_require__(68);
	
	var _MessagingContainer2 = _interopRequireDefault(_MessagingContainer);
	
	var _digitalFormats = __webpack_require__(290);
	
	var _digitalFormats2 = _interopRequireDefault(_digitalFormats);
	
	var _sharedBibBrief = __webpack_require__(46);
	
	var _sharedBibBrief2 = _interopRequireDefault(_sharedBibBrief);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DigitalCheckoutWorkflowView = exports.DigitalCheckoutWorkflowView = function (_BcReactComponent) {
	  _inherits(DigitalCheckoutWorkflowView, _BcReactComponent);
	
	  function DigitalCheckoutWorkflowView(props) {
	    _classCallCheck(this, DigitalCheckoutWorkflowView);
	
	    var _this = _possibleConstructorReturn(this, (DigitalCheckoutWorkflowView.__proto__ || Object.getPrototypeOf(DigitalCheckoutWorkflowView)).call(this, props));
	
	    _this.state = {
	      duration: null,
	      format: null
	    };
	    _this.bindAll('handleFormatSelect', 'handleCheckout', 'handleDurationSelect');
	    return _this;
	  }
	
	  _createClass(DigitalCheckoutWorkflowView, [{
	    key: 'handleFormatSelect',
	    value: function handleFormatSelect(format) {
	      this.setState({ format: format });
	    }
	  }, {
	    key: 'handleDurationSelect',
	    value: function handleDurationSelect(duration) {
	      this.setState({ duration: duration });
	    }
	  }, {
	    key: 'handleCheckout',
	    value: function handleCheckout(e) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      var _state = this.state,
	          format = _state.format,
	          duration = _state.duration;
	      var _props = this.props,
	          accountId = _props.accountId,
	          bib = _props.bib,
	          holdId = _props.holdId,
	          messagingId = _props.messagingId,
	          workflowId = _props.workflowId;
	
	      this.props.digitalCheckout({
	        accountId: accountId,
	        messagingId: messagingId,
	        metadataId: bib.get('id'),
	        workflowId: workflowId,
	        title: bib.get('title'),
	        format: format,
	        duration: duration,
	        holdId: holdId
	      });
	    }
	  }, {
	    key: 'renderQuickstartLink',
	    value: function renderQuickstartLink() {
	      var _props2 = this.props,
	          showQuickStartLink = _props2.showQuickStartLink,
	          quickStartUrl = _props2.quickStartUrl;
	
	
	      if (showQuickStartLink) {
	        return _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'digital_download_quickstart_link', values: { quickStartUrl: quickStartUrl } });
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          handleClose = _props3.handleClose,
	          bib = _props3.bib,
	          isLoading = _props3.isLoading,
	          formats = _props3.formats,
	          provider = _props3.provider,
	          _props3$requireFormat = _props3.requireFormats,
	          requireFormats = _props3$requireFormat === undefined ? false : _props3$requireFormat;
	
	      return _react2.default.createElement(
	        _baseInlineOverlay.InlineOverlay,
	        { handleClose: handleClose },
	        _react2.default.createElement(
	          'form',
	          { action: '/', onSubmit: this.handleCheckout, role: 'form', method: 'post' },
	          _react2.default.createElement(
	            _baseInlineOverlay.InlineOverlayHeader,
	            null,
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'check_out_now' })
	          ),
	          _react2.default.createElement(
	            _baseInlineOverlay.InlineOverlayBody,
	            null,
	            _react2.default.createElement(
	              _MessagingContainer2.default,
	              { id: bib.get('id') },
	              function (messageOptions) {
	                return _react2.default.createElement(_sharedMessages.GenericForm, messageOptions);
	              }
	            ),
	            _react2.default.createElement(_sharedBibBrief2.default, { bib: bib, titleTag: 'h3', renderTitleAsLink: false, renderAuthorsAsLink: false }),
	            _react2.default.createElement(_digitalFormats2.default, {
	              formats: formats,
	              provider: provider,
	              selectable: requireFormats,
	              isAvailable: true,
	              metadataId: bib.get('id'),
	              onSelectFormat: this.handleFormatSelect,
	              handleDurationSelect: this.handleDurationSelect,
	              fetchDigitalFormats: this.props.fetchDigitalFormats }),
	            this.renderQuickstartLink()
	          ),
	          _react2.default.createElement(
	            _baseInlineOverlay.InlineOverlayFooter,
	            null,
	            _react2.default.createElement(
	              _baseButtons.PrimaryButton,
	              { className: 'pull-right', isLoading: isLoading, type: 'submit' },
	              _react2.default.createElement(_baseIcons.Checkmark, { color: '#FFF' }),
	              ' ',
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'check_out_now' })
	            ),
	            _react2.default.createElement(
	              _baseInlineOverlay.InlineOverlayCloseButton,
	              { className: 'btn btn-link pull-right' },
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_nevermind_close' })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return DigitalCheckoutWorkflowView;
	}(_baseBcReactComponent2.default);
	
	DigitalCheckoutWorkflowView.propTypes = {
	  workflowId: _react.PropTypes.string,
	  handleClose: _react.PropTypes.func.isRequired,
	  bib: _react.PropTypes.shape({
	    id: _react.PropTypes.string
	  }).isRequired,
	  isLoading: _react.PropTypes.bool,
	  formats: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	    name: _react.PropTypes.string,
	    hasDownloadLink: _react.PropTypes.bool
	  })).isRequired,
	  provider: _react.PropTypes.string.isRequired,
	  requireFormats: _react.PropTypes.bool,
	  digitalCheckout: _react.PropTypes.func.isRequired,
	  accountId: _react.PropTypes.number.isRequired,
	  fetchDigitalFormats: _react.PropTypes.func.isRequired,
	  holdId: _react.PropTypes.string,
	  holdActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  borrowingActions: _react.PropTypes.objectOf(_react.PropTypes.func)
	};
	
	DigitalCheckoutWorkflowView.displayName = 'DigitalCheckoutWorkflowView';
	
	exports.default = DigitalCheckoutWorkflowView;

/***/ },
/* 1955 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DigitalCheckoutWorkflowView = __webpack_require__(1954);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DigitalCheckoutWorkflowView).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1956 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = DigitalDurations;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _reactIntl = __webpack_require__(3);
	
	__webpack_require__(2596);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function DigitalDurations(_ref) {
	  var durations = _ref.durations,
	      handleSelect = _ref.handleSelect;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'cp-digital-durations' },
	    _react2.default.createElement(
	      'h3',
	      null,
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'select_a_duration' })
	    ),
	    _react2.default.createElement(
	      'ul',
	      null,
	      durations.map(function (duration, index) {
	        return _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'label',
	            { className: 'duration-label', htmlFor: 'digital-duration-' + index },
	            _react2.default.createElement('input', {
	              id: 'digital-duration-' + index,
	              type: 'radio',
	              className: 'digital-duration',
	              name: 'digital-duration',
	              value: duration,
	              onChange: function onChange() {
	                return handleSelect(duration);
	              },
	              required: true }),
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'label_duration_length', values: { days: duration } })
	          )
	        );
	      })
	    )
	  );
	}
	
	DigitalDurations.propTypes = {
	  durations: _reactImmutableProptypes2.default.listOf(_react.PropTypes.number),
	  handleSelect: _react.PropTypes.func.isRequired
	};
	
	DigitalDurations.diplayName = 'DigitalDurations';

/***/ },
/* 1957 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DigitalFormats = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(16);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactIntl = __webpack_require__(3);
	
	var _utilsFormat = __webpack_require__(96);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseLoader = __webpack_require__(138);
	
	var _baseLoader2 = _interopRequireDefault(_baseLoader);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	var _localizationMessageWithFallback = __webpack_require__(537);
	
	var _localizationMessageWithFallback2 = _interopRequireDefault(_localizationMessageWithFallback);
	
	var _digitalDurations = __webpack_require__(597);
	
	var _digitalDurations2 = _interopRequireDefault(_digitalDurations);
	
	__webpack_require__(2597);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DigitalFormats = exports.DigitalFormats = function (_BcReactComponent) {
	  _inherits(DigitalFormats, _BcReactComponent);
	
	  function DigitalFormats(props) {
	    _classCallCheck(this, DigitalFormats);
	
	    var _this = _possibleConstructorReturn(this, (DigitalFormats.__proto__ || Object.getPrototypeOf(DigitalFormats)).call(this, props));
	
	    _this.state = {
	      selected: null
	    };
	    _this.bindAll('renderFormat', 'handleSelect');
	    return _this;
	  }
	
	  _createClass(DigitalFormats, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (!this.props.formats) {
	        this.props.fetchDigitalFormats(this.props.metadataId);
	      }
	    }
	  }, {
	    key: 'getDigitalFormatDescription',
	    value: function getDigitalFormatDescription() {
	      var format = this.props.formats.first().get('name');
	      var formatType = (0, _utilsFormat.getDigitalFormatTypeString)(format);
	      if (this.props.selectable) {
	        return _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'please_pick_a_format_' + formatType });
	      }
	
	      return _react2.default.createElement(
	        _localizationMessageWithFallback2.default,
	        { id: 'digital_content_' + this.props.provider.toLowerCase() + '_desc' },
	        _react2.default.createElement(
	          _localizationMessageWithFallback2.default,
	          {
	            id: formatType + '_available_now',
	            values: {
	              help_link: _react2.default.createElement(
	                'a',
	                { href: this.props.intl.formatMessage({ id: formatType + '_help_url' }) },
	                _react2.default.createElement(
	                  'span',
	                  { 'aria-hidden': true },
	                  _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'learn_more' })
	                ),
	                _react2.default.createElement(
	                  _baseScreenReaderMessage2.default,
	                  null,
	                  _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ada_' + formatType + '_help_text' })
	                )
	              )
	            } },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: this.props.isAvailable ? 'available_formats_now' : 'available_formats' })
	        )
	      );
	    }
	
	    /* istanbul ignore next */
	    /* eslint-disable global-require */
	
	  }, {
	    key: 'handleSelect',
	
	    /* eslint-enable global-require */
	
	    value: function handleSelect(format) {
	      this.setState({
	        selected: format
	      });
	      this.props.onSelectFormat(format);
	    }
	  }, {
	    key: 'renderDurations',
	    value: function renderDurations() {
	      if (!this.state.selected || !this.props.selectable) {
	        return null;
	      }
	      var durations = this.state.selected.get('durations');
	      if (durations && durations.size > 1) {
	        return _react2.default.createElement(_digitalDurations2.default, { durations: durations, handleSelect: this.props.handleDurationSelect });
	      }
	
	      if (durations && durations.size === 1) {
	        this.props.handleDurationSelect(durations.first());
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderFormat',
	    value: function renderFormat(format) {
	      var _this2 = this;
	
	      var radioButton = null;
	      var formatLabel = format.get('additionalInfo') || _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'digiformat_' + format.get('name').toLowerCase() });
	      var image = DigitalFormats.getFormatImage(format);
	      var formatSelectable = this.props.selectable && (format.get('hasDownloadLink') || !format.get('durations').isEmpty());
	      var id = 'format-' + format.get('name');
	      var classNames = (0, _classnames2.default)('format-item', 'format-' + _lodash2.default.kebabCase(format.get('name')), { selectable: formatSelectable, selected: this.state.selected === format });
	      if (formatSelectable) {
	        radioButton = _react2.default.createElement('input', {
	          type: 'radio',
	          name: 'format-select',
	          id: id,
	          className: 'format-radio',
	          onChange: function onChange() {
	            return _this2.handleSelect(format);
	          },
	          required: true });
	      }
	      return _react2.default.createElement(
	        'label',
	        { htmlFor: id, className: classNames },
	        radioButton,
	        _react2.default.createElement(
	          'div',
	          { className: 'format-label' },
	          _react2.default.createElement(
	            'span',
	            { className: 'format-label-name' },
	            formatLabel
	          ),
	          image && _react2.default.createElement('img', { src: image, alt: formatLabel + ' logo', className: 'format-logo' })
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.props.formats) {
	        return _react2.default.createElement(_baseLoader2.default, null);
	      }
	      if (this.props.formats.count() === 0) {
	        return _react2.default.createElement(
	          'h3',
	          null,
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'digital_format_not_available' })
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-digital-formats' },
	        _react2.default.createElement(
	          'span',
	          null,
	          this.getDigitalFormatDescription()
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'format-group' },
	          this.props.formats.map(this.renderFormat)
	        ),
	        this.renderDurations()
	      );
	    }
	  }], [{
	    key: 'getFormatImage',
	    value: function getFormatImage(format) {
	      switch (format.get('name').toLowerCase()) {
	        case 'acoustik':
	          return __webpack_require__(3442);
	        case 'adobe_epub_ebook':
	          return __webpack_require__(3443);
	        case 'adobe_pdf_ebook':
	          return __webpack_require__(3444);
	        case 'biblio_ereader':
	          return __webpack_require__(3445);
	        case 'blio':
	          return __webpack_require__(3446);
	        case 'kindle':
	          return __webpack_require__(3447);
	        case 'mmm_ebook':
	          return __webpack_require__(3448);
	        case 'music':
	          return __webpack_require__(3449);
	        case 'open_epub_ebook':
	          return __webpack_require__(3450);
	        case 'open_pdf_ebook':
	          return __webpack_require__(3451);
	        case 'overdrive_mp3_audiobook':
	          return __webpack_require__(3452);
	        case 'overdrive_read':
	          return __webpack_require__(3453);
	        case 'overdrive_wma_audiobook':
	          return __webpack_require__(3454);
	        case 'streaming_video':
	          return __webpack_require__(3455);
	        case 'video':
	          return __webpack_require__(3456);
	        default:
	          return null;
	      }
	    }
	  }]);
	
	  return DigitalFormats;
	}(_baseBcReactComponent2.default);
	
	DigitalFormats.displayName = 'DigitalFormats';
	
	DigitalFormats.propTypes = {
	  formats: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	    name: _react.PropTypes.string,
	    hasDownloadLink: _react.PropTypes.bool
	  })).isRequired,
	  isAvailable: _react.PropTypes.bool,
	  provider: _react.PropTypes.string,
	  supportsReadNow: _react.PropTypes.bool,
	  titleAvailableForReader: _react.PropTypes.bool,
	  selectable: _react.PropTypes.bool,
	  onSelectFormat: _react.PropTypes.func,
	  intl: _reactIntl.intlShape,
	  handleDurationSelect: _react.PropTypes.func,
	  fetchDigitalFormats: _react.PropTypes.func.isRequired,
	  metadataId: _react.PropTypes.string.isRequired
	};
	
	exports.default = (0, _reactIntl.injectIntl)(DigitalFormats);

/***/ },
/* 1958 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DigitalHoldsWorkflowView = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseInlineOverlay = __webpack_require__(83);
	
	var _baseButtons = __webpack_require__(12);
	
	var _baseIcons = __webpack_require__(10);
	
	var _sharedMessages = __webpack_require__(64);
	
	var _BibConstants = __webpack_require__(241);
	
	var _MessagingContainer = __webpack_require__(68);
	
	var _MessagingContainer2 = _interopRequireDefault(_MessagingContainer);
	
	var _digitalFormats = __webpack_require__(290);
	
	var _digitalFormats2 = _interopRequireDefault(_digitalFormats);
	
	var _digitalNotificationEmail = __webpack_require__(598);
	
	var _digitalNotificationEmail2 = _interopRequireDefault(_digitalNotificationEmail);
	
	var _digitalAutoCheckouts = __webpack_require__(1953);
	
	var _digitalAutoCheckouts2 = _interopRequireDefault(_digitalAutoCheckouts);
	
	var _sharedBibBrief = __webpack_require__(46);
	
	var _sharedBibBrief2 = _interopRequireDefault(_sharedBibBrief);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DigitalHoldsWorkflowView = exports.DigitalHoldsWorkflowView = function (_BcReactComponent) {
	  _inherits(DigitalHoldsWorkflowView, _BcReactComponent);
	
	  function DigitalHoldsWorkflowView(props) {
	    _classCallCheck(this, DigitalHoldsWorkflowView);
	
	    var _this = _possibleConstructorReturn(this, (DigitalHoldsWorkflowView.__proto__ || Object.getPrototypeOf(DigitalHoldsWorkflowView)).call(this, props));
	
	    _this.state = {
	      digitalNotificationEmail: _this.props.digitalNotificationEmail,
	      autoCheckoutsEnabled: _this.props.autoCheckoutsEnabled,
	      format: null
	    };
	
	    _this.bindAll('handleSubmit', 'handleEmailChange', 'handleAutoCheckoutChange');
	    return _this;
	  }
	
	  _createClass(DigitalHoldsWorkflowView, [{
	    key: 'handleSubmit',
	    value: function handleSubmit(e) {
	      e.preventDefault();
	      this.props.placeHold({
	        workflowId: this.props.workflowId,
	        messagingId: this.props.messagingId,
	        accountId: this.props.accountId,
	        metadataId: this.props.bib.get('id'),
	        materialType: _BibConstants.MATERIAL_TYPE_DIGITAL,
	        enableSingleClickHolds: false,
	        materialParams: {
	          email: this.state.digitalNotificationEmail,
	          autoCheckout: this.state.autoCheckoutsEnabled,
	          format: this.state.format
	        }
	      });
	    }
	  }, {
	    key: 'handleEmailChange',
	    value: function handleEmailChange(e) {
	      var digitalNotificationEmail = e.target.value;
	      this.setState({
	        digitalNotificationEmail: digitalNotificationEmail
	      });
	    }
	  }, {
	    key: 'handleAutoCheckoutChange',
	    value: function handleAutoCheckoutChange(autoCheckoutsEnabled) {
	      this.setState({
	        autoCheckoutsEnabled: autoCheckoutsEnabled
	      });
	    }
	  }, {
	    key: 'getColumnClasses',
	    value: function getColumnClasses() {
	      if (this.props.showFormatDuringHold) {
	        return 'col-xs-12 col-md-6';
	      }
	      return 'col-xs-12';
	    }
	  }, {
	    key: 'renderQuickstartLink',
	    value: function renderQuickstartLink() {
	      var _props = this.props,
	          showQuickStartLink = _props.showQuickStartLink,
	          quickStartUrl = _props.quickStartUrl;
	
	
	      if (showQuickStartLink) {
	        return _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'digital_download_quickstart_link', values: { quickStartUrl: quickStartUrl } });
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderFormats',
	    value: function renderFormats() {
	      var _props2 = this.props,
	          formats = _props2.formats,
	          provider = _props2.provider,
	          showFormatDuringHold = _props2.showFormatDuringHold,
	          requiresFormatDuringHold = _props2.requiresFormatDuringHold,
	          fetchDigitalFormats = _props2.fetchDigitalFormats,
	          bib = _props2.bib;
	
	      if (showFormatDuringHold) {
	        return _react2.default.createElement(
	          'div',
	          { className: this.getColumnClasses() },
	          _react2.default.createElement(_digitalFormats2.default, {
	            metadataId: bib.get('id'),
	            formats: formats,
	            provider: provider,
	            requireFormats: requiresFormatDuringHold,
	            fetchDigitalFormats: fetchDigitalFormats }),
	          this.renderQuickstartLink()
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          handleClose = _props3.handleClose,
	          bib = _props3.bib,
	          isLoading = _props3.isLoading,
	          supportAutoCheckout = _props3.supportAutoCheckout,
	          messagingId = _props3.messagingId;
	
	      return _react2.default.createElement(
	        _baseInlineOverlay.InlineOverlay,
	        { handleClose: handleClose },
	        _react2.default.createElement(
	          'form',
	          { action: '#submit-digital', onSubmit: this.handleSubmit },
	          _react2.default.createElement(
	            _baseInlineOverlay.InlineOverlayHeader,
	            null,
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'request_this_title' })
	          ),
	          _react2.default.createElement(
	            _baseInlineOverlay.InlineOverlayBody,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                _MessagingContainer2.default,
	                { id: messagingId },
	                function (messageOptions) {
	                  return _react2.default.createElement(_sharedMessages.GenericForm, messageOptions);
	                }
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: this.getColumnClasses() },
	                _react2.default.createElement(_sharedBibBrief2.default, { bib: bib, titleTag: 'h3', renderTitleAsLink: false, renderAuthorsAsLink: false }),
	                _react2.default.createElement(_digitalAutoCheckouts2.default, { supportAutoCheckout: supportAutoCheckout, handleChange: this.handleAutoCheckoutChange }),
	                _react2.default.createElement(_digitalNotificationEmail2.default, { value: this.state.digitalNotificationEmail, onChange: this.handleEmailChange })
	              ),
	              this.renderFormats()
	            )
	          ),
	          _react2.default.createElement(
	            _baseInlineOverlay.InlineOverlayFooter,
	            null,
	            _react2.default.createElement(
	              _baseButtons.PrimaryButton,
	              { type: 'submit', className: 'pull-right', isLoading: isLoading },
	              _react2.default.createElement(_baseIcons.Checkmark, { color: '#FFF' }),
	              ' ',
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'form_label_place_a_digital_hold' })
	            ),
	            _react2.default.createElement(
	              _baseInlineOverlay.InlineOverlayCloseButton,
	              { className: 'btn btn-link pull-right' },
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_nevermind_close' })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return DigitalHoldsWorkflowView;
	}(_baseBcReactComponent2.default);
	
	DigitalHoldsWorkflowView.propTypes = {
	  handleClose: _react.PropTypes.func.isRequired,
	  bib: _react.PropTypes.shape({
	    id: _react.PropTypes.string
	  }).isRequired,
	  isLoading: _react.PropTypes.bool,
	  formats: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	    name: _react.PropTypes.string,
	    hasDownloadLink: _react.PropTypes.bool
	  })).isRequired,
	  provider: _react.PropTypes.string.isRequired,
	  supportAutoCheckout: _react.PropTypes.bool.isRequired,
	  accountId: _react.PropTypes.number.isRequired,
	  digitalNotificationEmail: _react.PropTypes.string,
	  placeHold: _react.PropTypes.func.isRequired,
	  requiresFormatDuringHold: _react.PropTypes.bool.isRequired,
	  showFormatDuringHold: _react.PropTypes.bool.isRequired,
	  fetchDigitalFormats: _react.PropTypes.func.isRequired,
	  workflowId: _react.PropTypes.string,
	  messagingId: _react.PropTypes.string
	};
	
	DigitalHoldsWorkflowView.displayName = 'DigitalHoldsWorkflowView';
	
	exports.default = DigitalHoldsWorkflowView;

/***/ },
/* 1959 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DigitalHoldsWorkflowView = __webpack_require__(1958);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DigitalHoldsWorkflowView).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1960 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DigitalMissingFormatWorkflowView = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseInlineOverlay = __webpack_require__(83);
	
	var _baseButtons = __webpack_require__(12);
	
	var _baseIcons = __webpack_require__(10);
	
	var _sharedMessages = __webpack_require__(64);
	
	var _sharedBibBrief = __webpack_require__(46);
	
	var _sharedBibBrief2 = _interopRequireDefault(_sharedBibBrief);
	
	var _MessagingContainer = __webpack_require__(68);
	
	var _MessagingContainer2 = _interopRequireDefault(_MessagingContainer);
	
	var _digitalFormats = __webpack_require__(290);
	
	var _digitalFormats2 = _interopRequireDefault(_digitalFormats);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	/* eslint-disable import/no-extraneous-dependencies */
	
	/* eslint-enable import/no-extraneous-dependencies */
	
	
	var DigitalMissingFormatWorkflowView = exports.DigitalMissingFormatWorkflowView = function (_BcReactComponent) {
	  _inherits(DigitalMissingFormatWorkflowView, _BcReactComponent);
	
	  function DigitalMissingFormatWorkflowView(props) {
	    _classCallCheck(this, DigitalMissingFormatWorkflowView);
	
	    var _this = _possibleConstructorReturn(this, (DigitalMissingFormatWorkflowView.__proto__ || Object.getPrototypeOf(DigitalMissingFormatWorkflowView)).call(this, props));
	
	    _this.state = {
	      format: null
	    };
	    _this.bindAll('handleFormatSelect', 'handleFormatLockIn');
	    return _this;
	  }
	
	  _createClass(DigitalMissingFormatWorkflowView, [{
	    key: 'handleFormatSelect',
	    value: function handleFormatSelect(format) {
	      this.setState({ format: format });
	    }
	  }, {
	    key: 'handleFormatLockIn',
	    value: function handleFormatLockIn() {
	      var format = this.state.format;
	      var _props = this.props,
	          accountId = _props.accountId,
	          checkout = _props.checkout,
	          bib = _props.bib,
	          messagingId = _props.messagingId,
	          workflowId = _props.workflowId;
	
	
	      if (format) {
	        this.props.lockInFormat({
	          accountId: accountId,
	          checkoutId: checkout.get('checkoutId'),
	          format: format.get('name'),
	          metadataId: bib.get('id'),
	          messagingId: messagingId,
	          workflowId: workflowId
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          handleClose = _props2.handleClose,
	          bib = _props2.bib,
	          isLoading = _props2.isLoading,
	          formats = _props2.formats,
	          provider = _props2.provider;
	
	      return _react2.default.createElement(
	        _baseInlineOverlay.InlineOverlay,
	        { handleClose: handleClose },
	        _react2.default.createElement(
	          _baseInlineOverlay.InlineOverlayHeader,
	          null,
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'digital_title_is_available', values: { title: bib.get('title') } })
	        ),
	        _react2.default.createElement(
	          _baseInlineOverlay.InlineOverlayBody,
	          null,
	          _react2.default.createElement(
	            _MessagingContainer2.default,
	            { id: bib.get('id') },
	            function (messageOptions) {
	              return _react2.default.createElement(_sharedMessages.GenericForm, messageOptions);
	            }
	          ),
	          _react2.default.createElement(_sharedBibBrief2.default, { bib: bib, titleTag: 'h3' }),
	          _react2.default.createElement(_digitalFormats2.default, {
	            formats: formats,
	            provider: provider,
	            selectable: true,
	            isAvailable: true,
	            onSelectFormat: this.handleFormatSelect,
	            metadataId: bib.get('id'),
	            fetchDigitalFormats: this.props.fetchDigitalFormats })
	        ),
	        _react2.default.createElement(
	          _baseInlineOverlay.InlineOverlayFooter,
	          null,
	          _react2.default.createElement(
	            _baseButtons.TransactionalButton,
	            { 'data-test-id': 'missing-format-checkout-now', className: 'pull-right', isLoading: isLoading, handleClick: this.handleFormatLockIn, disabled: !this.state.format },
	            _react2.default.createElement(_baseIcons.Checkmark, { color: '#FFF' }),
	            ' ',
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'check_out_now' })
	          ),
	          _react2.default.createElement(
	            _baseInlineOverlay.InlineOverlayCloseButton,
	            { className: 'btn btn-link pull-right' },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_nevermind_close' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return DigitalMissingFormatWorkflowView;
	}(_baseBcReactComponent2.default);
	
	DigitalMissingFormatWorkflowView.propTypes = {
	  workflowId: _react.PropTypes.string,
	  messagingId: _react.PropTypes.string,
	  handleClose: _react.PropTypes.func.isRequired,
	  bib: _react.PropTypes.shape({
	    id: _react.PropTypes.string,
	    title: _react.PropTypes.string
	  }).isRequired,
	  isLoading: _react.PropTypes.bool,
	  formats: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	    name: _react.PropTypes.string,
	    hasDownloadLink: _react.PropTypes.bool
	  })).isRequired,
	  lockInFormat: _react.PropTypes.func.isRequired,
	  accountId: _react.PropTypes.number.isRequired,
	  checkout: _react.PropTypes.shape({
	    checkoutId: _react.PropTypes.string
	  }).isRequired,
	  provider: _react.PropTypes.string,
	  fetchDigitalFormats: _react.PropTypes.func.isRequired
	};
	
	DigitalMissingFormatWorkflowView.displayName = 'DigitalMissingFormatWorkflowView';
	
	exports.default = DigitalMissingFormatWorkflowView;

/***/ },
/* 1961 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DigitalMissingFormatWorkflowView = __webpack_require__(1960);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DigitalMissingFormatWorkflowView).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1962 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DigitalNotificationEmail = DigitalNotificationEmail;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	var _HelpLinkContainer = __webpack_require__(126);
	
	var _HelpLinkContainer2 = _interopRequireDefault(_HelpLinkContainer);
	
	__webpack_require__(2598);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable import/no-extraneous-dependencies */
	function DigitalNotificationEmail(_ref) {
	  var onChange = _ref.onChange,
	      value = _ref.value;
	
	  return _react2.default.createElement(
	    'label',
	    { className: 'cp-digital-notification-email', htmlFor: 'digital-notification' },
	    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'digital_hold_digital_notification_email' }),
	    _react2.default.createElement(
	      _HelpLinkContainer2.default,
	      {
	        page: '045faq/025faq-downloadable/#dne' },
	      _react2.default.createElement(
	        _baseScreenReaderMessage2.default,
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ada_digital_notification_email' })
	      )
	    ),
	    _react2.default.createElement('input', { type: 'email', id: 'digital-notification', className: 'form-control', onChange: onChange, value: value, required: true })
	  );
	}
	/* eslint-enable import/no-extraneous-dependencies */
	
	
	DigitalNotificationEmail.propTypes = {
	  onChange: _react.PropTypes.func.isRequired,
	  value: _react.PropTypes.string.isRequired
	};
	
	exports.default = DigitalNotificationEmail;

/***/ },
/* 1963 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseFullScreenOverlay = __webpack_require__(45);
	
	var _baseFullScreenOverlay2 = _interopRequireDefault(_baseFullScreenOverlay);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseTable = __webpack_require__(91);
	
	var _sharedMessages = __webpack_require__(64);
	
	var _baseIcons = __webpack_require__(10);
	
	var _baseButtons = __webpack_require__(12);
	
	var _sharedPickupBranchSelect = __webpack_require__(547);
	
	var _sharedPickupBranchSelect2 = _interopRequireDefault(_sharedPickupBranchSelect);
	
	var _sharedProgressBar = __webpack_require__(94);
	
	var _sharedProgressBar2 = _interopRequireDefault(_sharedProgressBar);
	
	var _MessagingContainer = __webpack_require__(68);
	
	var _MessagingContainer2 = _interopRequireDefault(_MessagingContainer);
	
	var _MessagingActions = __webpack_require__(181);
	
	var _MessagingActions2 = _interopRequireDefault(_MessagingActions);
	
	var _ItemLevelHoldsWorkflowTitle = __webpack_require__(599);
	
	var _ItemLevelHoldsWorkflowTitle2 = _interopRequireDefault(_ItemLevelHoldsWorkflowTitle);
	
	__webpack_require__(2599);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ItemLevelHoldsWorkflowView = function (_BcReactComponent) {
	  _inherits(ItemLevelHoldsWorkflowView, _BcReactComponent);
	
	  function ItemLevelHoldsWorkflowView(props) {
	    _classCallCheck(this, ItemLevelHoldsWorkflowView);
	
	    var _this = _possibleConstructorReturn(this, (ItemLevelHoldsWorkflowView.__proto__ || Object.getPrototypeOf(ItemLevelHoldsWorkflowView)).call(this, props));
	
	    _this.state = {
	      pickupLocation: props.branches.find(function (b) {
	        return b.get('code') === props.preferredBranch;
	      }) || _immutable2.default.Map(),
	      formValid: false
	    };
	
	    _this.bindAll('handleSubmit', 'handleUpdatePickupLocation', 'renderInputControl', 'clearAllItemMessages', 'validateForm', 'renderItemLevelHoldsTable');
	    return _this;
	  }
	
	  _createClass(ItemLevelHoldsWorkflowView, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.fetchItemGroups(this.props.bib.get('id'));
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(e) {
	      e.preventDefault();
	      this.clearAllItemMessages();
	      var itemIds = this.getSelectedItems();
	      var _props = this.props,
	          messagingId = _props.messagingId,
	          workflowId = _props.workflowId;
	
	      this.props.placeItemHold({
	        metadataId: this.props.bib.get('id'),
	        itemIds: itemIds,
	        branchId: this.props.selectedBranch || this.state.pickupLocation.get('code'),
	        messagingId: messagingId,
	        workflowId: workflowId
	      });
	    }
	  }, {
	    key: 'handleUpdatePickupLocation',
	    value: function handleUpdatePickupLocation(pickupLocation) {
	      this.setState({
	        pickupLocation: pickupLocation
	      });
	    }
	  }, {
	    key: 'validateForm',
	    value: function validateForm() {
	      this.setState({
	        formValid: this.getSelectedItems().length > 0
	      });
	    }
	  }, {
	    key: 'getSelectedItems',
	    value: function getSelectedItems() {
	      return Array.prototype.slice.call(this._form.elements).filter(function (el) {
	        return el.checked;
	      }).map(function (el) {
	        return el.value;
	      });
	    }
	  }, {
	    key: 'renderInputControl',
	    value: function renderInputControl(value, index) {
	      if (this.props.failedItemIds.includes(value.toString())) {
	        return _react2.default.createElement(_baseIcons.Failure, { color: '#cf000f' });
	      } else if (this.props.successfulItemIds.includes(value.toString())) {
	        return _react2.default.createElement(_baseIcons.Checkmark, { color: '#008000' });
	      }
	
	      var disabled = this.props.itemIdsOnHold.includes(value);
	      return _react2.default.createElement('input', { type: this.props.supportsBatchVolumeHolds ? 'checkbox' : 'radio', onChange: this.validateForm, name: 'itemId', id: 'itemGroup-' + index, value: value, disabled: disabled });
	    }
	  }, {
	    key: 'clearAllItemMessages',
	    value: function clearAllItemMessages() {
	      var itemIds = this.props.itemGroups.map(function (group) {
	        return group.get('itemId');
	      }).toArray();
	      this.props.dispatch(_MessagingActions2.default.clearMessages(itemIds));
	    }
	  }, {
	    key: 'renderItemLevelHoldsTable',
	    value: function renderItemLevelHoldsTable(fields) {
	      var _props2 = this.props,
	          itemGroups = _props2.itemGroups,
	          isFetchingItemGroups = _props2.isFetchingItemGroups;
	
	      if (isFetchingItemGroups) {
	        return _react2.default.createElement(_baseTable.Placeholder, null);
	      }
	
	      return _react2.default.createElement(_baseTable.Table, {
	        className: 'table-hover',
	        rows: itemGroups,
	        fields: fields.filter(Boolean) });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          handleClose = _props3.handleClose,
	          bib = _props3.bib,
	          branches = _props3.branches,
	          isLoading = _props3.isLoading,
	          fieldErrors = _props3.fieldErrors,
	          itemGroups = _props3.itemGroups,
	          showVolumeSelectorCollection = _props3.showVolumeSelectorCollection,
	          showVolumeSelectorStatus = _props3.showVolumeSelectorStatus,
	          showVolumeSelectorDueDate = _props3.showVolumeSelectorDueDate,
	          isFetchingItemGroups = _props3.isFetchingItemGroups;
	
	      var bibTitle = bib.get('title');
	      var fields = [{ key: 'itemId', type: 'itemId', transformationMap: this.renderInputControl, headerKey: 'table_headings_item_select' }, showVolumeSelectorCollection && { key: 'collection', type: 'collection', transformationMap: ItemLevelHoldsWorkflowView.renderInputLabel }, { key: 'callNumber', type: 'callNumber' }, { key: 'volume', type: 'volume' }, { key: 'copy', type: 'copy' }, showVolumeSelectorStatus && { key: 'availability.libraryStatus', type: 'String' }, showVolumeSelectorDueDate && { key: 'dueDate', type: 'Date' }];
	
	      return _react2.default.createElement(
	        _baseFullScreenOverlay2.default,
	        { open: true, handleClose: handleClose },
	        _react2.default.createElement(_sharedProgressBar2.default, { active: isFetchingItemGroups }),
	        _react2.default.createElement(
	          'div',
	          { className: 'cp-item-level-holds-workflow-view' },
	          _react2.default.createElement(_ItemLevelHoldsWorkflowTitle2.default, { itemGroups: itemGroups, bibTitle: bibTitle }),
	          _react2.default.createElement(
	            'form',
	            { action: '', onSubmit: this.handleSubmit, ref: function ref(el) {
	                _this2._form = el;
	              } },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group clearfix' },
	              !this.props.selectedBranch && _react2.default.createElement(_sharedPickupBranchSelect2.default, {
	                fieldErrors: fieldErrors,
	                branches: branches,
	                label: 'Pickup at',
	                handleSelect: this.handleUpdatePickupLocation,
	                selectedBranch: this.state.pickupLocation.get('code') })
	            ),
	            this.renderItemLevelHoldsTable(fields),
	            itemGroups.map(function (group) {
	              return _react2.default.createElement(
	                _MessagingContainer2.default,
	                { id: group.get('itemId') },
	                function (messageOptions) {
	                  return _react2.default.createElement(_sharedMessages.GenericForm, _extends({}, messageOptions, { values: messageOptions.message.get('values', _immutable2.default.Map()).merge({ title: bibTitle }) }));
	                }
	              );
	            }),
	            _react2.default.createElement(
	              _MessagingContainer2.default,
	              { id: bib.get('id') },
	              function (messageOptions) {
	                return _react2.default.createElement(_sharedMessages.GenericForm, _extends({}, messageOptions, { values: messageOptions.message.get('values', _immutable2.default.Map()).merge({ title: bibTitle }) }));
	              }
	            ),
	            !isFetchingItemGroups && _react2.default.createElement(
	              _baseButtons.TransactionalButton,
	              { isLoading: isLoading, type: 'submit', disabled: !this.state.formValid },
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_confirm' })
	            ),
	            !isFetchingItemGroups && !this.state.formValid && _react2.default.createElement(
	              'span',
	              { className: 'form-error' },
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ilh_required_items' })
	            )
	          )
	        )
	      );
	    }
	  }], [{
	    key: 'renderInputLabel',
	    value: function renderInputLabel(value, index) {
	      return _react2.default.createElement(
	        'label',
	        { className: 'collection', htmlFor: 'itemGroup-' + index },
	        value
	      );
	    }
	  }]);
	
	  return ItemLevelHoldsWorkflowView;
	}(_baseBcReactComponent2.default);
	
	ItemLevelHoldsWorkflowView.displayName = 'ItemLevelHoldsWorkflowView';
	ItemLevelHoldsWorkflowView.propTypes = {
	  messagingId: _react.PropTypes.string,
	  workflowId: _react.PropTypes.string,
	  bib: _reactImmutableProptypes2.default.map,
	  placeItemHold: _react.PropTypes.func.isRequired,
	  fetchItemGroups: _react.PropTypes.func.isRequired,
	  selectedBranch: _react.PropTypes.string,
	  preferredBranch: _react.PropTypes.string,
	  handleClose: _react.PropTypes.func.isRequired,
	  fieldErrors: _reactImmutableProptypes2.default.map,
	  isLoading: _react.PropTypes.bool,
	  branches: _reactImmutableProptypes2.default.listOf(_reactImmutableProptypes2.default.mapContains({
	    code: _react.PropTypes.string,
	    name: _react.PropTypes.string
	  })),
	  itemGroups: _reactImmutableProptypes2.default.listOf(_reactImmutableProptypes2.default.mapContains({
	    volume: _react.PropTypes.string,
	    collection: _react.PropTypes.string.isRequired,
	    copy: _react.PropTypes.string,
	    itemId: _react.PropTypes.string.isRequired,
	    callNumber: _react.PropTypes.string
	  })),
	  dispatch: _react.PropTypes.func.isRequired,
	  itemIdsOnHold: _reactImmutableProptypes2.default.listOf(_react.PropTypes.string),
	  supportsBatchVolumeHolds: _react.PropTypes.bool,
	  failedItemIds: _reactImmutableProptypes2.default.listOf(_react.PropTypes.number),
	  successfulItemIds: _reactImmutableProptypes2.default.listOf(_react.PropTypes.number),
	  showVolumeSelectorCollection: _react.PropTypes.bool,
	  showVolumeSelectorStatus: _react.PropTypes.bool,
	  showVolumeSelectorDueDate: _react.PropTypes.bool,
	  isFetchingItemGroups: _react.PropTypes.bool
	};
	
	exports.default = ItemLevelHoldsWorkflowView;

/***/ },
/* 1964 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ItemLevelHoldsWorkflowView = __webpack_require__(1963);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ItemLevelHoldsWorkflowView).default;
	  }
	});
	
	var _ItemLevelHoldsWorkflowTitle = __webpack_require__(599);
	
	Object.defineProperty(exports, 'ItemLevelHoldsWorkflowTitle', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ItemLevelHoldsWorkflowTitle).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1965 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseCheckbox = __webpack_require__(58);
	
	var _baseCheckbox2 = _interopRequireDefault(_baseCheckbox);
	
	var _baseInlineOverlay = __webpack_require__(83);
	
	var _baseButtons = __webpack_require__(12);
	
	var _baseIcons = __webpack_require__(10);
	
	var _sharedMessages = __webpack_require__(64);
	
	var _sharedHoldInfoMessages = __webpack_require__(1488);
	
	var _sharedHoldInfoMessages2 = _interopRequireDefault(_sharedHoldInfoMessages);
	
	var _sharedPickupBranchSelect = __webpack_require__(547);
	
	var _sharedPickupBranchSelect2 = _interopRequireDefault(_sharedPickupBranchSelect);
	
	var _BibConstants = __webpack_require__(241);
	
	var _MessagingContainer = __webpack_require__(68);
	
	var _MessagingContainer2 = _interopRequireDefault(_MessagingContainer);
	
	var _sharedBibBrief = __webpack_require__(46);
	
	var _sharedBibBrief2 = _interopRequireDefault(_sharedBibBrief);
	
	__webpack_require__(2600);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PhysicalHoldsWorkflowView = function (_BcReactComponent) {
	  _inherits(PhysicalHoldsWorkflowView, _BcReactComponent);
	
	  function PhysicalHoldsWorkflowView(props) {
	    _classCallCheck(this, PhysicalHoldsWorkflowView);
	
	    var _this = _possibleConstructorReturn(this, (PhysicalHoldsWorkflowView.__proto__ || Object.getPrototypeOf(PhysicalHoldsWorkflowView)).call(this, props));
	
	    _this.state = {
	      pickupLocation: props.branches.size === 1 ? props.branches.first() : props.branches.find(function (b) {
	        return b.get('code') === props.preferredBranch;
	      }) || _immutable2.default.Map(),
	      singleClickHoldsEnabled: false,
	      expiryDate: null,
	      singleClickHoldsInfoOpen: false
	    };
	
	    _this.bindAll('handlePlaceHold', 'handleUpdatePickupLocation', 'handleUpdateSingleClickHolds', 'handleClickInfoButton');
	    return _this;
	  }
	
	  _createClass(PhysicalHoldsWorkflowView, [{
	    key: 'handlePlaceHold',
	    value: function handlePlaceHold() {
	      this.props.placeHold({
	        workflowId: this.props.workflowId,
	        messagingId: this.props.messagingId,
	        accountId: this.props.accountId,
	        metadataId: this.props.bib.get('id'),
	        materialType: _BibConstants.MATERIAL_TYPE_PHYSICAL,
	        enableSingleClickHolds: this.state.singleClickHoldsEnabled,
	        materialParams: {
	          branchId: this.state.pickupLocation.get('code'),
	          expiryDate: null,
	          errorMessageLocale: this.props.currentLocale
	        }
	      });
	    }
	  }, {
	    key: 'handleUpdatePickupLocation',
	    value: function handleUpdatePickupLocation(pickupLocation) {
	      this.setState({
	        pickupLocation: pickupLocation
	      });
	    }
	  }, {
	    key: 'handleUpdateSingleClickHolds',
	    value: function handleUpdateSingleClickHolds(value) {
	      this.setState({
	        singleClickHoldsEnabled: value
	      });
	    }
	  }, {
	    key: 'handleClickInfoButton',
	    value: function handleClickInfoButton() {
	      this.setState({
	        singleClickHoldsInfoOpen: !this.state.singleClickHoldsInfoOpen
	      });
	    }
	  }, {
	    key: 'renderSingleClickHoldsInfo',
	    value: function renderSingleClickHoldsInfo() {
	      if (this.state.singleClickHoldsInfoOpen) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'text-left single-click-holds-info' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'single_click_holds_enable_desc', tagName: 'p' })
	        );
	      }
	
	      return _react2.default.createElement('noop', null);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          handleClose = _props.handleClose,
	          bib = _props.bib,
	          branches = _props.branches,
	          holdInfoMessages = _props.holdInfoMessages,
	          isLoading = _props.isLoading;
	
	      return _react2.default.createElement(
	        _baseInlineOverlay.InlineOverlay,
	        { handleClose: handleClose, 'data-test-id': 'physical-holds-overlay-' + bib.get('id') },
	        _react2.default.createElement(
	          _baseInlineOverlay.InlineOverlayHeader,
	          null,
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'section_title_request_hold' })
	        ),
	        _react2.default.createElement(
	          _baseInlineOverlay.InlineOverlayBody,
	          null,
	          _react2.default.createElement(
	            _MessagingContainer2.default,
	            { id: bib.get('id') },
	            function (messageOptions) {
	              return _react2.default.createElement(_sharedMessages.GenericForm, messageOptions);
	            }
	          ),
	          _react2.default.createElement(_sharedBibBrief2.default, { bib: bib, titleTag: 'h3', renderTitleAsLink: false, renderAuthorsAsLink: false }),
	          _react2.default.createElement(_sharedHoldInfoMessages2.default, { messageIds: holdInfoMessages })
	        ),
	        _react2.default.createElement(
	          _baseInlineOverlay.InlineOverlayFooter,
	          null,
	          _react2.default.createElement(
	            'form',
	            { className: 'form-horizontal' },
	            _react2.default.createElement(
	              'div',
	              { className: 'branch-select-column' },
	              _react2.default.createElement(
	                'div',
	                { className: 'clearfix' },
	                branches.size > 1 && _react2.default.createElement(_sharedPickupBranchSelect2.default, {
	                  fieldErrors: this.props.fieldErrors,
	                  branches: branches,
	                  label: 'Pickup at',
	                  handleSelect: this.handleUpdatePickupLocation,
	                  selectedBranch: this.state.pickupLocation.get('code') })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'text-left enable-single-click-holds-wrap' },
	                _react2.default.createElement(_baseCheckbox2.default, {
	                  label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'single_click_holds_enable_title' }),
	                  id: 'enable-single-click-holds-' + bib.get('id'),
	                  checked: this.state.singleClickHoldsEnabled,
	                  handleChange: this.handleUpdateSingleClickHolds }),
	                _react2.default.createElement(
	                  _baseButtons.TextButton,
	                  { className: 'help-info', handleClick: this.handleClickInfoButton },
	                  _react2.default.createElement(_baseIcons.Info, null),
	                  _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'label_info' })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'holds-action-column' },
	              _react2.default.createElement(
	                _baseButtons.PrimaryButton,
	                { className: 'pull-right', isLoading: isLoading, handleClick: this.handlePlaceHold, 'data-test-id': 'submit-place-hold-' + bib.get('id') },
	                _react2.default.createElement(_baseIcons.Checkmark, { color: '#FFF' }),
	                '\xA0',
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_confirm_hold' })
	              ),
	              _react2.default.createElement(
	                _baseInlineOverlay.InlineOverlayCloseButton,
	                { className: 'btn btn-link pull-right' },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_nevermind_close' })
	              )
	            ),
	            this.renderSingleClickHoldsInfo()
	          )
	        )
	      );
	    }
	  }]);
	
	  return PhysicalHoldsWorkflowView;
	}(_baseBcReactComponent2.default);
	
	PhysicalHoldsWorkflowView.displayName = 'PhysicalHoldsWorkflowView';
	PhysicalHoldsWorkflowView.propTypes = {
	  handleClose: _react.PropTypes.func.isRequired,
	  fieldErrors: _react.PropTypes.objectOf(_react.PropTypes.shape({
	    classification: _react.PropTypes.string,
	    message: _react.PropTypes.string
	  })),
	  bib: _reactImmutableProptypes2.default.map,
	  branches: _react.PropTypes.arrayOf(_reactImmutableProptypes2.default.map).isRequired,
	  preferredBranch: _react.PropTypes.string,
	  placeHold: _react.PropTypes.func.isRequired,
	  accountId: _react.PropTypes.number.isRequired,
	  currentLocale: _react.PropTypes.string.isRequired,
	  holdInfoMessages: _react.PropTypes.arrayOf(_react.PropTypes.number),
	  isLoading: _react.PropTypes.bool,
	  renderMessage: _react.PropTypes.func.isRequired,
	  workflowId: _react.PropTypes.string,
	  messagingId: _react.PropTypes.string
	};
	
	exports.default = PhysicalHoldsWorkflowView;

/***/ },
/* 1966 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PhysicalHoldsWorkflowView = __webpack_require__(1965);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PhysicalHoldsWorkflowView).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1967 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseTable = __webpack_require__(91);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function MarcHoldingsTable(_ref) {
	  var rows = _ref.rows;
	
	  var eResourceMap = function eResourceMap(resources) {
	    return _react2.default.createElement(
	      'ul',
	      null,
	      resources.map(function (resource) {
	        return _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'a',
	            { href: resource.get('url') },
	            resource.get('description')
	          )
	        );
	      })
	    );
	  };
	
	  return _react2.default.createElement(_baseTable.Table, {
	    rows: rows,
	    fields: [{ key: 'location' }, { key: 'collection' }, { key: 'format', localizationMap: function localizationMap(value) {
	        return 'FORMAT.' + value.toLowerCase();
	      } }, { key: 'holdDuration' }, { key: 'electronicResource', localizationMap: eResourceMap }] });
	}
	
	MarcHoldingsTable.propTypes = {
	  rows: _react.PropTypes.arrayOf(_react.PropTypes.objectOf(_react.PropTypes.string)).isRequired
	};
	
	exports.default = MarcHoldingsTable;

/***/ },
/* 1968 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _MarcHoldingsTable = __webpack_require__(1967);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MarcHoldingsTable).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1969 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ShelfMessage = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _ShelfActions = __webpack_require__(107);
	
	var _ShelfActions2 = _interopRequireDefault(_ShelfActions);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseAlerts = __webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ShelfMessageTypes = {
	  ADD: 'ADD',
	  REMOVE: 'REMOVE',
	  MOVE: 'MOVE',
	  PRIVACY: 'PRIVACY'
	};
	
	var ShelfMessage = exports.ShelfMessage = function (_BcReactComponent) {
	  _inherits(ShelfMessage, _BcReactComponent);
	
	  function ShelfMessage(props) {
	    _classCallCheck(this, ShelfMessage);
	
	    var _this = _possibleConstructorReturn(this, (ShelfMessage.__proto__ || Object.getPrototypeOf(ShelfMessage)).call(this, props));
	
	    _this.timeout = null;
	
	    _this.bindAll('clearMessage', 'handlePrivacyChange');
	    return _this;
	  }
	
	  _createClass(ShelfMessage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.scheduleMessageClearance();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.timeout && nextProps.message !== this.props.message) {
	        clearTimeout(this.timeout);
	        this.timeout = null;
	        this.scheduleMessageClearance();
	      }
	    }
	  }, {
	    key: 'scheduleMessageClearance',
	    value: function scheduleMessageClearance() {
	      var _this2 = this;
	
	      var _props = this.props,
	          clearMessages = _props.clearMessages,
	          duration = _props.duration;
	
	      if (duration) {
	        this.timeout = setTimeout(function () {
	          clearMessages();
	          _this2.timeout = null;
	        }, duration);
	      }
	    }
	  }, {
	    key: 'clearMessage',
	    value: function clearMessage() {
	      if (this.timeout) {
	        clearTimeout(this.timeout);
	      }
	      this.props.clearMessages();
	    }
	  }, {
	    key: 'handlePrivacyChange',
	    value: function handlePrivacyChange(e) {
	      e.preventDefault();
	
	      this.clearMessage();
	
	      var shelfItem = this.props.values;
	      this.props.dispatch(_ShelfActions2.default.updateShelfItems({
	        shelfName: shelfItem.get('shelf'),
	        shelfItemIds: [shelfItem.get('id')],
	        metadataIds: [shelfItem.get('metadataId')],
	        newShelfName: shelfItem.get('shelf'),
	        privateItem: !shelfItem.get('privateItem')
	      }));
	    }
	  }, {
	    key: 'getListName',
	    value: function getListName() {
	      return this.props.intl.formatMessage({
	        id: 'section_title_users_' + this.props.values.get('shelf') + '_library'
	      });
	    }
	  }, {
	    key: 'getShelfMessage',
	    value: function getShelfMessage() {
	      var id = this.props.message.get('id');
	      var values = this.props.message.get('values');
	      switch (id) {
	        case ShelfMessageTypes.ADD:
	          if (values.privateItem) {
	            return 'message_add_to_' + values.get('shelf') + '_library';
	          }
	          return 'message_shared_on_' + values.get('shelf') + '_library';
	        case ShelfMessageTypes.REMOVE:
	          return 'message_remove_from_list';
	        case ShelfMessageTypes.MOVE:
	          return 'message_update_item_status';
	        case ShelfMessageTypes.PRIVACY:
	          if (values.get('privateItem')) {
	            return 'content_marked_private';
	          }
	          return 'content_marked_public_' + values.get('shelf');
	        default:
	          return null;
	      }
	    }
	  }, {
	    key: 'renderPrivacyMessage',
	    value: function renderPrivacyMessage() {
	      if (this.props.message.get('id') === ShelfMessageTypes.ADD || this.props.message.get('id') === ShelfMessageTypes.PRIVACY) {
	        var message = this.props.message.get('id') === ShelfMessageTypes.ADD ? _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
	          id: this.props.values.get('privateItem') ? 'make_public' : 'make_private' }) : _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'undo' });
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'a',
	            { role: 'button', href: '#handlePrivacyToggle', onClick: this.handlePrivacyChange },
	            message
	          )
	        );
	      }
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _baseAlerts.AlertSuccess,
	        null,
	        _react2.default.createElement(_baseAlerts.AlertDismiss, { handleDismiss: this.clearMessage }),
	        _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
	          id: this.getShelfMessage(),
	          values: _extends({}, this.props.values.toObject(), {
	            list_name: this.getListName(),
	            titles: this.props.values.get('title')
	          }) }),
	        this.renderPrivacyMessage()
	      );
	    }
	  }]);
	
	  return ShelfMessage;
	}(_baseBcReactComponent2.default);
	
	ShelfMessage.propTypes = {
	  dispatch: _react.PropTypes.func.isRequired,
	  message: _react.PropTypes.shape({
	    id: _react.PropTypes.string
	  }).isRequired,
	  duration: _react.PropTypes.number,
	  clearMessages: _react.PropTypes.func.isRequired,
	  fieldErrors: _react.PropTypes.objectOf(_react.PropTypes.shape({
	    classification: _react.PropTypes.string,
	    message: _react.PropTypes.string
	  })),
	  intl: _reactIntl.intlShape
	};
	
	ShelfMessage.defaultProps = {
	  duration: 20000
	};
	
	exports.default = (0, _reactIntl.injectIntl)(ShelfMessage);

/***/ },
/* 1970 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseDropdown = __webpack_require__(37);
	
	var _baseIcons = __webpack_require__(10);
	
	var Icons = _interopRequireWildcard(_baseIcons);
	
	var _ShelfConstants = __webpack_require__(43);
	
	var _utilsGoogleAnalytics = __webpack_require__(231);
	
	var _utilsGoogleAnalytics2 = _interopRequireDefault(_utilsGoogleAnalytics);
	
	__webpack_require__(2601);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OnShelfDropdown = function (_BcReactComponent) {
	  _inherits(OnShelfDropdown, _BcReactComponent);
	
	  function OnShelfDropdown(props) {
	    _classCallCheck(this, OnShelfDropdown);
	
	    var _this = _possibleConstructorReturn(this, (OnShelfDropdown.__proto__ || Object.getPrototypeOf(OnShelfDropdown)).call(this, props));
	
	    _this.bindAll('renderMovableShelfOptions', 'renderOnShelfOptions');
	    return _this;
	  }
	
	  _createClass(OnShelfDropdown, [{
	    key: 'handleShelfMove',
	    value: function handleShelfMove(newShelf) {
	      var shelf = this.props.currentShelfItem.get('shelf');
	      var id = this.props.currentShelfItem.get('id');
	      var metadataId = this.props.currentShelfItem.get('metadataId');
	      this.props.updateShelfItem(shelf, id, metadataId, { newShelfName: newShelf });
	      _utilsGoogleAnalytics2.default.event({
	        eventCategory: 'NERF Search',
	        eventAction: 'Move shelf item',
	        eventLabel: shelf
	      });
	    }
	  }, {
	    key: 'handleRemoveFromShelf',
	    value: function handleRemoveFromShelf() {
	      var shelf = this.props.currentShelfItem.get('shelf');
	      var id = this.props.currentShelfItem.get('id');
	      var metadataId = this.props.currentShelfItem.get('metadataId');
	      this.props.removeShelfItem(shelf, id, metadataId);
	    }
	  }, {
	    key: 'renderMovableShelfOptions',
	    value: function renderMovableShelfOptions() {
	      var _this2 = this;
	
	      var shelf = this.props.currentShelfItem.get('shelf');
	      return OnShelfDropdown.getShelfOptions().filter(function (option) {
	        return option.value !== shelf;
	      }).map(function (option) {
	        var handleShelfMove = function handleShelfMove(e) {
	          e.preventDefault();
	          _this2.handleShelfMove(option.value);
	        };
	
	        return _react2.default.createElement(
	          _baseDropdown.DropdownMenuItem,
	          { key: 'on-shelf-dropdown-header-move-' + option.value },
	          _react2.default.createElement(
	            'a',
	            { href: '#move-to-shelf', onClick: handleShelfMove },
	            option.label
	          )
	        );
	      });
	    }
	  }, {
	    key: 'renderOnShelfOptions',
	    value: function renderOnShelfOptions() {
	      var _this3 = this;
	
	      var shelf = this.props.currentShelfItem.get('shelf');
	      var header = _react2.default.createElement(
	        _baseDropdown.DropdownMenuHeader,
	        { key: 'on-shelf-dropdown-header' },
	        _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'change_shelf_location' })
	      );
	
	      var handleRemoveFromShelf = function handleRemoveFromShelf(e) {
	        e.preventDefault();
	        _this3.handleRemoveFromShelf();
	      };
	
	      var deleteOption = _react2.default.createElement(
	        _baseDropdown.DropdownMenuItem,
	        { key: 'on-shelf-dropdown-delete' },
	        _react2.default.createElement(
	          'a',
	          { href: '#remove-from-shelf', className: 'shelf-delete', onClick: handleRemoveFromShelf },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_remove_from_shelves' })
	        )
	      );
	
	      var deleteDivider = _react2.default.createElement(_baseDropdown.DropdownMenuDivider, { key: 'on-shelf-dropdown-delete-divider' });
	      var goToShelfDivider = _react2.default.createElement(_baseDropdown.DropdownMenuDivider, { key: 'on-shelf-dropdown-go-to-shelf-divider' });
	
	      var goToShelfOption = _react2.default.createElement(
	        _baseDropdown.DropdownMenuItem,
	        { key: 'on-shelf-dropdown-go-to-shelf' },
	        _react2.default.createElement(
	          'a',
	          { href: '/collection/show/my/library/' + shelf, target: '_parent' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, {
	            id: 'go_to_my_shelf', values: {
	              shelf: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'label_shelf_' + shelf })
	            } })
	        )
	      );
	
	      return [header, this.renderMovableShelfOptions(), deleteDivider, deleteOption, goToShelfDivider, goToShelfOption];
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var currentShelfItem = this.props.currentShelfItem;
	
	      var shelf = currentShelfItem.get('shelf');
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-on-shelf-dropdown' },
	        _react2.default.createElement(
	          _baseDropdown.Dropdown,
	          {
	            className: 'btn-default btn-on-shelf',
	            selected: OnShelfDropdown.renderAddToShelfButtonContent(shelf) },
	          this.renderOnShelfOptions()
	        )
	      );
	    }
	  }], [{
	    key: 'getShelfOptions',
	    value: function getShelfOptions() {
	      return _immutable2.default.Map(_ShelfConstants.SHELF_NAMES).valueSeq().toArray().map(function (name) {
	        return {
	          label: OnShelfDropdown.renderAddToShelfButtonContent(name),
	          value: name
	        };
	      });
	    }
	  }, {
	    key: 'renderAddToShelfButtonContent',
	    value: function renderAddToShelfButtonContent(name) {
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement(Icons.Books, { width: 20, height: 19, color: '#666' }),
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'label_shelf_' + name })
	      );
	    }
	  }]);
	
	  return OnShelfDropdown;
	}(_baseBcReactComponent2.default);
	
	OnShelfDropdown.propTypes = {
	  currentShelfItem: _reactImmutableProptypes2.default.map,
	  updateShelfItem: _react.PropTypes.func.isRequired,
	  removeShelfItem: _react.PropTypes.func.isRequired
	};
	
	exports.default = OnShelfDropdown;

/***/ },
/* 1971 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Panel;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _bcPropTypes = __webpack_require__(5);
	
	__webpack_require__(2602);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Panel(_ref) {
	  var className = _ref.className,
	      children = _ref.children;
	
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)(className, 'cp-panel') },
	    children
	  );
	}
	
	Panel.propTypes = {
	  className: _react.PropTypes.string,
	  children: _bcPropTypes.childrenShape
	};

/***/ },
/* 1972 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _reactIntl = __webpack_require__(3);
	
	var _BibConstants = __webpack_require__(241);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseButtons = __webpack_require__(12);
	
	var _sharedScreenReaderItemInfo = __webpack_require__(549);
	
	var _sharedScreenReaderItemInfo2 = _interopRequireDefault(_sharedScreenReaderItemInfo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RequestItemButton = function (_BcReactComponent) {
	  _inherits(RequestItemButton, _BcReactComponent);
	
	  function RequestItemButton(props) {
	    _classCallCheck(this, RequestItemButton);
	
	    var _this = _possibleConstructorReturn(this, (RequestItemButton.__proto__ || Object.getPrototypeOf(RequestItemButton)).call(this, props));
	
	    _this.bindAll('handleClick');
	    return _this;
	  }
	
	  _createClass(RequestItemButton, [{
	    key: 'handleClick',
	    value: function handleClick() {
	      if (this.props.availableForCheckout && this.props.materialType !== _BibConstants.MATERIAL_TYPE_PHYSICAL) {
	        this.props.handleCheckoutClick(this.props.metadataId);
	      } else {
	        this.props.handleHoldClick(this.props.metadataId);
	      }
	    }
	  }, {
	    key: 'getDataKey',
	    value: function getDataKey() {
	      if (this.props.materialType === _BibConstants.MATERIAL_TYPE_PHYSICAL) {
	        return 'place-a-hold';
	      }
	      if (this.props.availableForCheckout) {
	        return 'checkout-now';
	      }
	      return 'request-this-download';
	    }
	  }, {
	    key: 'renderButtonText',
	    value: function renderButtonText() {
	      if (this.props.materialType === _BibConstants.MATERIAL_TYPE_PHYSICAL) {
	        return _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'btn.placeAHold' });
	      }
	      if (this.props.availableForCheckout) {
	        return _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'check_out_now' });
	      }
	      return _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'request_this_title' });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          format = _props.format,
	          title = _props.title,
	          authors = _props.authors,
	          serviceAvailable = _props.serviceAvailable,
	          titleNotOwned = _props.titleNotOwned;
	
	      return _react2.default.createElement(
	        _baseButtons.TransactionalButton,
	        {
	          handleClick: this.handleClick,
	          className: 'cp-request-item-button',
	          isLoading: this.props.isLoading,
	          block: true,
	          disabled: !serviceAvailable || titleNotOwned,
	          'data-test-id': 'request-item-' + this.props.metadataId,
	          dataKey: 'bib-' + this.getDataKey() },
	        this.renderButtonText(),
	        _react2.default.createElement(_sharedScreenReaderItemInfo2.default, { format: format, title: title, authors: authors })
	      );
	    }
	  }]);
	
	  return RequestItemButton;
	}(_baseBcReactComponent2.default);
	
	RequestItemButton.propTypes = {
	  handleCheckoutClick: _react.PropTypes.func.isRequired,
	  handleHoldClick: _react.PropTypes.func.isRequired,
	  isLoading: _react.PropTypes.bool,
	  availableForCheckout: _react.PropTypes.bool,
	  materialType: _react.PropTypes.string.isRequired,
	  format: _react.PropTypes.string.isRequired,
	  title: _react.PropTypes.string.isRequired,
	  authors: _reactImmutableProptypes2.default.listOf(_react2.default.PropTypes.string),
	  treatAsItemLevelHold: _react.PropTypes.bool,
	  metadataId: _react.PropTypes.string.isRequired,
	  titleNotOwned: _react.PropTypes.bool
	};
	
	exports.default = RequestItemButton;

/***/ },
/* 1973 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _RequestItemButton = __webpack_require__(1972);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RequestItemButton).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1974 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _moment = __webpack_require__(9);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ShortFormattedDate = function ShortFormattedDate(_ref) {
	  var value = _ref.value;
	
	  if (value) {
	    return _react2.default.createElement(
	      _reactIntl.FormattedDate,
	      {
	        value: (0, _moment2.default)(value).toDate(),
	        year: 'numeric',
	        month: 'short',
	        day: '2-digit' },
	      function (message) {
	        return _react2.default.createElement(
	          'span',
	          { className: 'cp-short-formatted-date' },
	          message
	        );
	      }
	    );
	  }
	
	  return null;
	};
	
	ShortFormattedDate.propTypes = {
	  value: _react.PropTypes.string
	};
	
	exports.default = ShortFormattedDate;

/***/ },
/* 1975 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SubscriptionTable = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _reactIntl = __webpack_require__(3);
	
	var _lodash = __webpack_require__(16);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	__webpack_require__(2603);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SubscriptionTable = exports.SubscriptionTable = function (_BcReactComponent) {
	  _inherits(SubscriptionTable, _BcReactComponent);
	
	  function SubscriptionTable() {
	    _classCallCheck(this, SubscriptionTable);
	
	    return _possibleConstructorReturn(this, (SubscriptionTable.__proto__ || Object.getPrototypeOf(SubscriptionTable)).apply(this, arguments));
	  }
	
	  _createClass(SubscriptionTable, [{
	    key: 'render',
	    value: function render() {
	      var subscriptions = this.props.subscriptions;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-subscription-table' },
	        subscriptions.map(SubscriptionTable.renderGroup)
	      );
	    }
	  }], [{
	    key: 'getRowItems',
	    value: function getRowItems() {
	      return [{
	        id: 'collection',
	        get: function get(row) {
	          return row.get('collection');
	        }
	      }, {
	        id: 'callNumber',
	        get: function get(row) {
	          return row.get('callNumbers').join(', ');
	        }
	      }, {
	        id: 'mediaType',
	        get: function get(row) {
	          return row.get('mediaType');
	        }
	      }, {
	        id: 'status',
	        get: function get(row) {
	          return row.get('status');
	        }
	      }, {
	        id: 'notes',
	        get: function get(row) {
	          return SubscriptionTable.renderNotes(row.get('notes'));
	        }
	      }, {
	        id: 'runDuration',
	        get: function get(row) {
	          return SubscriptionTable.renderDurations(row.get('runDuration'));
	        }
	      }];
	    }
	  }, {
	    key: 'renderDuration',
	    value: function renderDuration(duration) {
	      var beginText = duration.get('beginText');
	      var endText = duration.get('endText');
	      var note = duration.get('note');
	
	      if (!beginText && !endText && !note) {
	        return null;
	      }
	
	      var formattedDuration = beginText || '';
	      if (endText) {
	        formattedDuration += ' - ' + endText;
	      }
	
	      if (note) {
	        formattedDuration += ' (' + note + ')';
	      }
	      return formattedDuration;
	    }
	  }, {
	    key: 'renderDurations',
	    value: function renderDurations(durations) {
	      if (durations.isEmpty()) {
	        return null;
	      }
	
	      if (durations.size === 1) {
	        return SubscriptionTable.renderDuration(durations.first());
	      }
	
	      return _react2.default.createElement(
	        'ul',
	        { className: 'run-duration-list' },
	        durations.map(function (duration) {
	          return SubscriptionTable.renderDurations(duration);
	        })
	      );
	    }
	  }, {
	    key: 'renderNotes',
	    value: function renderNotes(notes) {
	      if (notes.size === 0) {
	        return null;
	      }
	      if (notes.size === 1) {
	        return notes.get(0);
	      }
	      var list = notes.map(function (item, index) {
	        return _react2.default.createElement(
	          'li',
	          { key: index },
	          item
	        );
	      });
	
	      return _react2.default.createElement(
	        'ul',
	        null,
	        list
	      );
	    }
	  }, {
	    key: 'renderSubscriptions',
	    value: function renderSubscriptions(row) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'subscription-item' },
	        SubscriptionTable.getRowItems().map(function (_ref) {
	          var id = _ref.id,
	              get = _ref.get;
	          return !_lodash2.default.isEmpty(get(row)) && _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-3' },
	              _react2.default.createElement(_reactIntl.FormattedMessage, { tagName: 'strong', id: id })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-9' },
	              get(row)
	            )
	          );
	        })
	      );
	    }
	  }, {
	    key: 'renderGroup',
	    value: function renderGroup(group) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'subscription-group' },
	        group.get('label') ? _react2.default.createElement(
	          'h4',
	          null,
	          group.get('label')
	        ) : null,
	        group.get('subscriptions').map(SubscriptionTable.renderSubscriptions)
	      );
	    }
	  }]);
	
	  return SubscriptionTable;
	}(_baseBcReactComponent2.default);
	
	SubscriptionTable.propTypes = {
	  subscriptions: _reactImmutableProptypes2.default.listOf(_reactImmutableProptypes2.default.mapOf({
	    label: _react.PropTypes.string,
	    subscriptions: _reactImmutableProptypes2.default.listOf(_reactImmutableProptypes2.default.mapOf({
	      collection: _react.PropTypes.string,
	      status: _react.PropTypes.string,
	      callNumbers: _reactImmutableProptypes2.default.listOf(_react.PropTypes.string),
	      mediaType: _react.PropTypes.string,
	      notes: _reactImmutableProptypes2.default.listOf(_react.PropTypes.string),
	      runDuration: _reactImmutableProptypes2.default.mapOf({
	        beginText: _react.PropTypes.string,
	        endText: _react.PropTypes.string,
	        note: _react.PropTypes.note
	      })
	    }))
	  })).isRequired,
	  intl: _reactIntl.intlShape
	};
	
	exports.default = (0, _reactIntl.injectIntl)(SubscriptionTable);

/***/ },
/* 1976 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SubscriptionTable = __webpack_require__(1975);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SubscriptionTable).default;
	  }
	});
	Object.defineProperty(exports, 'SubscriptionTable', {
	  enumerable: true,
	  get: function get() {
	    return _SubscriptionTable.SubscriptionTable;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1977 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = AddButton;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	var _baseIcons = __webpack_require__(10);
	
	var _baseButtons = __webpack_require__(12);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _utilsUser = __webpack_require__(234);
	
	__webpack_require__(2604);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AddButton(_ref) {
	  var owner = _ref.owner,
	      handleClick = _ref.handleClick,
	      screenReaderMessage = _ref.screenReaderMessage;
	
	  if (owner.get('loggedIn') && (0, _utilsUser.allowFreeText)(owner)) {
	    return _react2.default.createElement(
	      _baseButtons.TextButton,
	      { className: 'cp-ugc-add-button', handleClick: handleClick },
	      _react2.default.createElement(
	        'span',
	        { 'aria-hidden': true },
	        _react2.default.createElement(_baseIcons.Plus, null),
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_add' })
	      ),
	      _react2.default.createElement(
	        _baseScreenReaderMessage2.default,
	        null,
	        screenReaderMessage
	      )
	    );
	  }
	
	  return null;
	}
	
	AddButton.propTypes = {
	  owner: _bcPropTypes.userIdentityShape.isRequired,
	  handleClick: _react.PropTypes.func.isRequired,
	  screenReaderMessage: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.element]).isRequired
	};

/***/ },
/* 1978 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseFullScreenOverlay = __webpack_require__(45);
	
	var _baseFullScreenOverlay2 = _interopRequireDefault(_baseFullScreenOverlay);
	
	var _expandable = __webpack_require__(139);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _utilsUser = __webpack_require__(234);
	
	var _CommentUGCEditor = __webpack_require__(603);
	
	var _CommentUGCEditor2 = _interopRequireDefault(_CommentUGCEditor);
	
	var _DisplayWrapper = __webpack_require__(185);
	
	var _DisplayWrapper2 = _interopRequireDefault(_DisplayWrapper);
	
	var _DisplayActions = __webpack_require__(240);
	
	var _DisplayActions2 = _interopRequireDefault(_DisplayActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CommentDisplay = function (_BcReactComponent) {
	  _inherits(CommentDisplay, _BcReactComponent);
	
	  function CommentDisplay(props) {
	    _classCallCheck(this, CommentDisplay);
	
	    var _this = _possibleConstructorReturn(this, (CommentDisplay.__proto__ || Object.getPrototypeOf(CommentDisplay)).call(this, props));
	
	    _this.bindAll('openEditor', 'closeEditor');
	
	    _this.state = {
	      showEditor: false
	    };
	    return _this;
	  }
	
	  _createClass(CommentDisplay, [{
	    key: 'openEditor',
	    value: function openEditor() {
	      this.setState({ showEditor: true });
	    }
	  }, {
	    key: 'closeEditor',
	    value: function closeEditor() {
	      this.setState({ showEditor: false });
	    }
	  }, {
	    key: 'renderEditor',
	    value: function renderEditor() {
	      return this.state.showEditor && _react2.default.createElement(_CommentUGCEditor2.default, {
	        bib: this.props.bib,
	        shelfItem: this.props.shelfItem,
	        handleClose: this.closeEditor,
	        existingComment: this.props.comment,
	        commentsTransactions: this.props.commentsTransactions,
	        shelfTransactions: this.props.shelfTransactions,
	        commentsActions: this.props.commentsActions,
	        shelfActions: this.props.shelfActions });
	    }
	  }, {
	    key: 'renderActions',
	    value: function renderActions() {
	      var _props = this.props,
	          commentsActions = _props.commentsActions,
	          commentsTransactions = _props.commentsTransactions,
	          owner = _props.owner,
	          comment = _props.comment,
	          bib = _props.bib;
	
	
	      if (owner.get('loggedIn')) {
	        var commentId = comment.get('id');
	        var metadataId = comment.get('metadataId');
	        var handleRemove = function handleRemove() {
	          return commentsActions.removeComment({ metadataId: metadataId, commentId: commentId });
	        };
	        var isRemoving = commentsTransactions.getIn([metadataId, commentId, 'isRemoving'], false);
	        var title = bib.getIn(['briefInfo', 'title']);
	        var editScreenReaderMessage = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ada_ugc_edit_comment', values: { title: title } });
	        var removeScreenReaderMessage = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ada_ugc_remove_comment', values: { title: title } });
	
	        return _react2.default.createElement(_DisplayActions2.default, {
	          handleEdit: (0, _utilsUser.allowFreeText)(owner) ? this.openEditor : undefined,
	          handleRemove: handleRemove,
	          isRemoving: isRemoving,
	          editScreenReaderMessage: editScreenReaderMessage,
	          removeScreenReaderMessage: removeScreenReaderMessage });
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _DisplayWrapper2.default,
	        { className: 'cp-ugc-comment-display' },
	        _react2.default.createElement(_expandable.ExpandableText, { text: this.props.comment.get('comment') }),
	        this.renderActions(),
	        _react2.default.createElement(
	          _baseFullScreenOverlay2.default,
	          { open: !!this.state.showEditor, handleClose: this.closeEditor },
	          this.renderEditor()
	        )
	      );
	    }
	  }]);
	
	  return CommentDisplay;
	}(_baseBcReactComponent2.default);
	
	exports.default = CommentDisplay;
	
	
	CommentDisplay.propTypes = {
	  bib: _bcPropTypes.bibShape.isRequired,
	  shelfItem: _bcPropTypes.shelfItemShape.isRequired,
	  owner: _bcPropTypes.userIdentityShape.isRequired,
	  comment: _bcPropTypes.ugcCommentShape.isRequired,
	  commentsTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  shelfTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  commentsActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  shelfActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired
	};

/***/ },
/* 1979 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CommentDisplay = __webpack_require__(1978);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CommentDisplay).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1980 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = DisplayActions;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseButtons = __webpack_require__(12);
	
	var _baseIcons = __webpack_require__(10);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	__webpack_require__(2605);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function DisplayActions(_ref) {
	  var handleEdit = _ref.handleEdit,
	      handleRemove = _ref.handleRemove,
	      isRemoving = _ref.isRemoving,
	      editScreenReaderMessage = _ref.editScreenReaderMessage,
	      removeScreenReaderMessage = _ref.removeScreenReaderMessage;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'cp-ugc-display-actions' },
	    handleEdit && _react2.default.createElement(
	      _baseButtons.TextButton,
	      { className: 'ugc-display-edit-button', handleClick: handleEdit },
	      _react2.default.createElement(
	        _baseScreenReaderMessage2.default,
	        null,
	        editScreenReaderMessage
	      ),
	      _react2.default.createElement(_baseIcons.Pencil, null)
	    ),
	    handleRemove && _react2.default.createElement(
	      _baseButtons.TextButton,
	      { className: 'ugc-display-delete-button', handleClick: handleRemove, isLoading: isRemoving },
	      _react2.default.createElement(
	        _baseScreenReaderMessage2.default,
	        null,
	        removeScreenReaderMessage
	      ),
	      _react2.default.createElement(_baseIcons.Remove, null)
	    )
	  );
	}
	
	DisplayActions.propTypes = {
	  handleEdit: _react.PropTypes.func,
	  handleRemove: _react.PropTypes.func,
	  isRemoving: _react.PropTypes.bool,
	  editScreenReaderMessage: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.element]),
	  removeScreenReaderMessage: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.element])
	};

/***/ },
/* 1981 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = DisplayHeading;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bcPropTypes = __webpack_require__(5);
	
	__webpack_require__(2606);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function DisplayHeading(_ref) {
	  var children = _ref.children,
	      _ref$tag = _ref.tag,
	      tag = _ref$tag === undefined ? 'h4' : _ref$tag;
	
	  var HeadingTag = tag;
	
	  return _react2.default.createElement(
	    HeadingTag,
	    { className: 'cp-ugc-display-heading', tabIndex: '-1' },
	    children
	  );
	}
	
	DisplayHeading.propTypes = {
	  children: _bcPropTypes.childrenShape.isRequired,
	  tag: _react.PropTypes.string
	};

/***/ },
/* 1982 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _utilsAccessibility = __webpack_require__(95);
	
	var _bcPropTypes = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DisplayWrapper = function (_BcReactComponent) {
	  _inherits(DisplayWrapper, _BcReactComponent);
	
	  function DisplayWrapper(props) {
	    _classCallCheck(this, DisplayWrapper);
	
	    var _this = _possibleConstructorReturn(this, (DisplayWrapper.__proto__ || Object.getPrototypeOf(DisplayWrapper)).call(this, props));
	
	    _this.displayRef = null;
	    return _this;
	  }
	
	  _createClass(DisplayWrapper, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      // If this Display component has focus, then move focus to the next focusable element on the page once it's removed.
	      if (this.displayRef && document.activeElement && this.displayRef.contains(document.activeElement)) {
	        var nextFocusableElement = (0, _utilsAccessibility.getNextFocusableElement)(this.displayRef);
	        if (nextFocusableElement) {
	          nextFocusableElement.focus();
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)('cp-ugc-display', this.props.className),
	          ref: function ref(el) {
	            _this2.displayRef = el;
	          } },
	        this.props.children
	      );
	    }
	  }]);
	
	  return DisplayWrapper;
	}(_baseBcReactComponent2.default);
	
	exports.default = DisplayWrapper;
	
	
	DisplayWrapper.propTypes = {
	  className: _react.PropTypes.string,
	  children: _bcPropTypes.childrenShape.isRequired
	};

/***/ },
/* 1983 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseFullScreenOverlay = __webpack_require__(45);
	
	var _baseFullScreenOverlay2 = _interopRequireDefault(_baseFullScreenOverlay);
	
	var _expandable = __webpack_require__(139);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _PrivateNoteUGCEditor = __webpack_require__(604);
	
	var _PrivateNoteUGCEditor2 = _interopRequireDefault(_PrivateNoteUGCEditor);
	
	var _DisplayWrapper = __webpack_require__(185);
	
	var _DisplayWrapper2 = _interopRequireDefault(_DisplayWrapper);
	
	var _DisplayActions = __webpack_require__(240);
	
	var _DisplayActions2 = _interopRequireDefault(_DisplayActions);
	
	__webpack_require__(2607);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PrivateNoteDisplay = function (_BcReactComponent) {
	  _inherits(PrivateNoteDisplay, _BcReactComponent);
	
	  function PrivateNoteDisplay(props) {
	    _classCallCheck(this, PrivateNoteDisplay);
	
	    var _this = _possibleConstructorReturn(this, (PrivateNoteDisplay.__proto__ || Object.getPrototypeOf(PrivateNoteDisplay)).call(this, props));
	
	    _this.bindAll('openEditor', 'closeEditor');
	
	    _this.state = {
	      showEditor: false
	    };
	    return _this;
	  }
	
	  _createClass(PrivateNoteDisplay, [{
	    key: 'openEditor',
	    value: function openEditor() {
	      this.setState({ showEditor: true });
	    }
	  }, {
	    key: 'closeEditor',
	    value: function closeEditor() {
	      this.setState({ showEditor: false });
	    }
	  }, {
	    key: 'renderEditor',
	    value: function renderEditor() {
	      return this.state.showEditor && _react2.default.createElement(_PrivateNoteUGCEditor2.default, {
	        bib: this.props.bib,
	        shelfItem: this.props.shelfItem,
	        handleClose: this.closeEditor,
	        existingPrivateNote: this.props.privateNote,
	        privateNotesTransactions: this.props.privateNotesTransactions,
	        shelfTransactions: this.props.shelfTransactions,
	        privateNotesActions: this.props.privateNotesActions,
	        shelfActions: this.props.shelfActions });
	    }
	  }, {
	    key: 'renderActions',
	    value: function renderActions() {
	      var _props = this.props,
	          privateNotesActions = _props.privateNotesActions,
	          privateNotesTransactions = _props.privateNotesTransactions,
	          owner = _props.owner,
	          privateNote = _props.privateNote,
	          bib = _props.bib;
	
	
	      if (owner.get('loggedIn')) {
	        var noteId = privateNote.get('id');
	        var metadataId = privateNote.get('metadataId');
	        var handleRemove = function handleRemove() {
	          return privateNotesActions.removePrivateNote({ metadataId: metadataId, noteId: noteId });
	        };
	        var isRemoving = privateNotesTransactions.getIn([metadataId, noteId, 'isRemoving'], false);
	        var title = bib.getIn(['briefInfo', 'title']);
	        var editScreenReaderMessage = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ada_ugc_edit_private_note', values: { title: title } });
	        var removeScreenReaderMessage = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ada_ugc_remove_private_note', values: { title: title } });
	
	        return _react2.default.createElement(_DisplayActions2.default, {
	          handleEdit: this.openEditor,
	          handleRemove: handleRemove,
	          isRemoving: isRemoving,
	          editScreenReaderMessage: editScreenReaderMessage,
	          removeScreenReaderMessage: removeScreenReaderMessage });
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _DisplayWrapper2.default,
	        { className: 'cp-ugc-private-note-display' },
	        _react2.default.createElement(_expandable.ExpandableText, { text: this.props.privateNote.get('note') }),
	        this.renderActions(),
	        _react2.default.createElement(
	          _baseFullScreenOverlay2.default,
	          { open: !!this.state.showEditor, handleClose: this.closeEditor },
	          this.renderEditor()
	        )
	      );
	    }
	  }]);
	
	  return PrivateNoteDisplay;
	}(_baseBcReactComponent2.default);
	
	exports.default = PrivateNoteDisplay;
	
	
	PrivateNoteDisplay.propTypes = {
	  bib: _bcPropTypes.bibShape.isRequired,
	  shelfItem: _bcPropTypes.shelfItemShape.isRequired,
	  owner: _bcPropTypes.userIdentityShape.isRequired,
	  privateNote: _bcPropTypes.ugcPrivateNoteShape.isRequired,
	  privateNotesTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  shelfTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  privateNotesActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  shelfActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired
	};

/***/ },
/* 1984 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PrivateNoteDisplay = __webpack_require__(1983);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PrivateNoteDisplay).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1985 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseFullScreenOverlay = __webpack_require__(45);
	
	var _baseFullScreenOverlay2 = _interopRequireDefault(_baseFullScreenOverlay);
	
	var _expandable = __webpack_require__(139);
	
	var _reactIntl = __webpack_require__(3);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _utilsUser = __webpack_require__(234);
	
	var _QuotationUGCEditor = __webpack_require__(391);
	
	var _QuotationUGCEditor2 = _interopRequireDefault(_QuotationUGCEditor);
	
	var _DisplayWrapper = __webpack_require__(185);
	
	var _DisplayWrapper2 = _interopRequireDefault(_DisplayWrapper);
	
	var _DisplayActions = __webpack_require__(240);
	
	var _DisplayActions2 = _interopRequireDefault(_DisplayActions);
	
	__webpack_require__(2608);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var QuotationDisplay = function (_BcReactComponent) {
	  _inherits(QuotationDisplay, _BcReactComponent);
	
	  function QuotationDisplay(props) {
	    _classCallCheck(this, QuotationDisplay);
	
	    var _this = _possibleConstructorReturn(this, (QuotationDisplay.__proto__ || Object.getPrototypeOf(QuotationDisplay)).call(this, props));
	
	    _this.bindAll('openEditor', 'closeEditor');
	
	    _this.state = {
	      showEditor: false
	    };
	    return _this;
	  }
	
	  _createClass(QuotationDisplay, [{
	    key: 'openEditor',
	    value: function openEditor() {
	      this.setState({ showEditor: true });
	    }
	  }, {
	    key: 'closeEditor',
	    value: function closeEditor() {
	      this.setState({ showEditor: false });
	    }
	  }, {
	    key: 'renderEditor',
	    value: function renderEditor() {
	      return this.state.showEditor && _react2.default.createElement(_QuotationUGCEditor2.default, {
	        bib: this.props.bib,
	        shelfItem: this.props.shelfItem,
	        handleClose: this.closeEditor,
	        existingQuotation: this.props.quotation,
	        quotationsTransactions: this.props.quotationsTransactions,
	        shelfTransactions: this.props.shelfTransactions,
	        quotationsActions: this.props.quotationsActions,
	        shelfActions: this.props.shelfActions });
	    }
	  }, {
	    key: 'renderActions',
	    value: function renderActions() {
	      var _props = this.props,
	          quotationsActions = _props.quotationsActions,
	          quotationsTransactions = _props.quotationsTransactions,
	          owner = _props.owner,
	          quotation = _props.quotation,
	          bib = _props.bib;
	
	
	      if (owner.get('loggedIn')) {
	        var quotationId = quotation.get('id');
	        var metadataId = quotation.get('metadataId');
	        var handleRemove = function handleRemove() {
	          return quotationsActions.removeQuotation({ metadataId: metadataId, quotationId: quotationId });
	        };
	        var isRemoving = quotationsTransactions.getIn([metadataId, quotationId, 'isRemoving'], false);
	        var title = bib.getIn(['briefInfo', 'title']);
	        var editScreenReaderMessage = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ada_ugc_edit_quotation', values: { title: title } });
	        var removeScreenReaderMessage = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ada_ugc_remove_quotation', values: { title: title } });
	
	        return _react2.default.createElement(_DisplayActions2.default, {
	          handleEdit: (0, _utilsUser.allowFreeText)(owner) ? this.openEditor : undefined,
	          handleRemove: handleRemove,
	          isRemoving: isRemoving,
	          editScreenReaderMessage: editScreenReaderMessage,
	          removeScreenReaderMessage: removeScreenReaderMessage });
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _DisplayWrapper2.default,
	        { className: 'cp-ugc-quotation-display' },
	        _react2.default.createElement(_expandable.ExpandableText, { text: this.props.quotation.get('quotation') }),
	        this.renderActions(),
	        _react2.default.createElement(
	          _baseFullScreenOverlay2.default,
	          { open: !!this.state.showEditor, handleClose: this.closeEditor },
	          this.renderEditor()
	        )
	      );
	    }
	  }]);
	
	  return QuotationDisplay;
	}(_baseBcReactComponent2.default);
	
	exports.default = QuotationDisplay;
	
	
	QuotationDisplay.propTypes = {
	  bib: _bcPropTypes.bibShape.isRequired,
	  shelfItem: _bcPropTypes.shelfItemShape.isRequired,
	  owner: _bcPropTypes.userIdentityShape.isRequired,
	  quotation: _bcPropTypes.ugcQuotationShape.isRequired,
	  quotationsTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  shelfTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  quotationsActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  shelfActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired
	};

/***/ },
/* 1986 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _QuotationDisplay = __webpack_require__(1985);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_QuotationDisplay).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1987 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ShelfPrivacyAlert;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseAlerts = __webpack_require__(36);
	
	var _baseCheckbox = __webpack_require__(58);
	
	var _baseCheckbox2 = _interopRequireDefault(_baseCheckbox);
	
	__webpack_require__(2609);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ShelfPrivacyAlert(_ref) {
	  var setToPublic = _ref.setToPublic,
	      handleChange = _ref.handleChange;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'cp-ugc-shelf-privacy-alert' },
	    _react2.default.createElement(
	      _baseAlerts.Alert,
	      null,
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ugc_shelf_privacy_alert' })
	      ),
	      _react2.default.createElement(_baseCheckbox2.default, {
	        id: 'ugc-shelf-privacy-checkbox',
	        checked: setToPublic,
	        handleChange: handleChange,
	        label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ugc_shelf_privacy_toggle' }) })
	    )
	  );
	}
	
	ShelfPrivacyAlert.propTypes = {
	  handleChange: _react.PropTypes.func.isRequired,
	  setToPublic: _react.PropTypes.bool.isRequired
	};

/***/ },
/* 1988 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ShelfPrivacyAlert = __webpack_require__(1987);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ShelfPrivacyAlert).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1989 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _sharedBibBrief = __webpack_require__(46);
	
	var _sharedBibBrief2 = _interopRequireDefault(_sharedBibBrief);
	
	var _utilsFormat = __webpack_require__(96);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _FormatInfoContainer = __webpack_require__(188);
	
	var _FormatInfoContainer2 = _interopRequireDefault(_FormatInfoContainer);
	
	var _JacketCoverContainer = __webpack_require__(395);
	
	var _JacketCoverContainer2 = _interopRequireDefault(_JacketCoverContainer);
	
	var _DisplayWrapper = __webpack_require__(185);
	
	var _DisplayWrapper2 = _interopRequireDefault(_DisplayWrapper);
	
	var _DisplayActions = __webpack_require__(240);
	
	var _DisplayActions2 = _interopRequireDefault(_DisplayActions);
	
	__webpack_require__(2610);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SimilarTitleDisplay = function (_BcReactComponent) {
	  _inherits(SimilarTitleDisplay, _BcReactComponent);
	
	  function SimilarTitleDisplay(props) {
	    _classCallCheck(this, SimilarTitleDisplay);
	
	    var _this = _possibleConstructorReturn(this, (SimilarTitleDisplay.__proto__ || Object.getPrototypeOf(SimilarTitleDisplay)).call(this, props));
	
	    _this.state = {
	      showEditor: false
	    };
	
	    _this.bindAll('renderBibBrief');
	    return _this;
	  }
	
	  _createClass(SimilarTitleDisplay, [{
	    key: 'renderActions',
	    value: function renderActions(briefInfo) {
	      var _props = this.props,
	          similarTitlesActions = _props.similarTitlesActions,
	          similarTitlesTransactions = _props.similarTitlesTransactions,
	          similarTitle = _props.similarTitle,
	          owner = _props.owner;
	
	
	      if (owner.get('loggedIn')) {
	        var similarTitleId = similarTitle.get('id');
	        var metadataId = similarTitle.get('metadataId');
	        var title = briefInfo.get('title');
	        var handleRemove = function handleRemove() {
	          return similarTitlesActions.removeSimilarTitle(metadataId, similarTitleId);
	        };
	        var isRemoving = similarTitlesTransactions.getIn([metadataId, similarTitleId, 'isRemoving'], false);
	        var removeScreenReaderMessage = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ada_ugc_remove_similar_title', values: { title: title } });
	
	        return _react2.default.createElement(_DisplayActions2.default, {
	          handleRemove: handleRemove,
	          isRemoving: isRemoving,
	          removeScreenReaderMessage: removeScreenReaderMessage });
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderBibBrief',
	    value: function renderBibBrief(similarTitleBib) {
	      var briefInfo = similarTitleBib.get('briefInfo');
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'similar-titles-bib-brief-info' },
	        _react2.default.createElement(
	          _sharedBibBrief2.default,
	          { bib: briefInfo, renderTitleAsLink: !!briefInfo.get('id'), titleTag: 'h5', truncateTitleOptions: { desiredLength: 50 } },
	          _react2.default.createElement(
	            'div',
	            { className: 'similar-titles-item-format' },
	            _react2.default.createElement('span', { className: (0, _utilsFormat.getIconForFormat)(briefInfo.get('format')), 'aria-hidden': true }),
	            _react2.default.createElement(_FormatInfoContainer2.default, { item: similarTitleBib, showCallNumber: false })
	          )
	        ),
	        this.renderActions(briefInfo)
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var briefInfo = this.props.similarTitleBib.get('briefInfo');
	
	      return _react2.default.createElement(
	        _DisplayWrapper2.default,
	        { className: 'cp-ugc-similar-title-display' },
	        _react2.default.createElement(
	          'div',
	          { className: 'jacket-cover-container' },
	          _react2.default.createElement(_JacketCoverContainer2.default, { src: briefInfo.get('jacket'), format: briefInfo.get('format'), alt: '' })
	        ),
	        this.renderBibBrief(this.props.similarTitleBib)
	      );
	    }
	  }]);
	
	  return SimilarTitleDisplay;
	}(_baseBcReactComponent2.default);
	
	exports.default = SimilarTitleDisplay;
	
	
	SimilarTitleDisplay.propTypes = {
	  similarTitleBib: _bcPropTypes.bibShape.isRequired,
	  similarTitle: _bcPropTypes.ugcSimilarTitlesShape.isRequired,
	  similarTitlesTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  similarTitlesActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  owner: _bcPropTypes.userIdentityShape.isRequired
	};

/***/ },
/* 1990 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SimilarTitleDisplay = __webpack_require__(1989);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SimilarTitleDisplay).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1991 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _tagPill = __webpack_require__(1548);
	
	var _tagPill2 = _interopRequireDefault(_tagPill);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseIcons = __webpack_require__(10);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _TagsConstants = __webpack_require__(242);
	
	var _DisplayWrapper = __webpack_require__(185);
	
	var _DisplayWrapper2 = _interopRequireDefault(_DisplayWrapper);
	
	__webpack_require__(2611);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TagDisplay = function (_BcReactComponent) {
	  _inherits(TagDisplay, _BcReactComponent);
	
	  function TagDisplay() {
	    _classCallCheck(this, TagDisplay);
	
	    return _possibleConstructorReturn(this, (TagDisplay.__proto__ || Object.getPrototypeOf(TagDisplay)).apply(this, arguments));
	  }
	
	  _createClass(TagDisplay, [{
	    key: 'renderTagPill',
	    value: function renderTagPill() {
	      var _props = this.props,
	          tag = _props.tag,
	          owner = _props.owner,
	          url = _props.url,
	          handleClick = _props.handleClick,
	          tagsTransactions = _props.tagsTransactions,
	          tagsActions = _props.tagsActions;
	
	      var tagId = tag.get('id');
	      var tagValue = tag.get('value');
	      var tagType = tag.get('type');
	      var metadataId = tag.get('metadataId');
	      var renderIcon = function renderIcon() {
	        return tagType === _TagsConstants.TAG_TYPES.PERSONAL && _react2.default.createElement(_baseIcons.Personal, null);
	      };
	      var handleRemove = tagId && owner.get('loggedIn') ? function () {
	        return tagsActions.removeTag(metadataId, tagId, tagType);
	      } : undefined;
	      var isLoading = tagId ? tagsTransactions.getIn([metadataId, tagId, 'isRemoving'], false) : true;
	
	      return _react2.default.createElement(_tagPill2.default, {
	        value: tagValue,
	        url: url,
	        renderIcon: renderIcon,
	        handleClick: handleClick,
	        handleRemove: handleRemove,
	        isLoading: isLoading });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _DisplayWrapper2.default,
	        { className: 'cp-ugc-tag-display' },
	        this.renderTagPill()
	      );
	    }
	  }]);
	
	  return TagDisplay;
	}(_baseBcReactComponent2.default);
	
	exports.default = TagDisplay;
	
	
	TagDisplay.propTypes = {
	  handleClick: _react.PropTypes.func,
	  url: _react.PropTypes.string,
	  tag: _react.PropTypes.oneOfType([_bcPropTypes.ugcTagShape, _reactImmutableProptypes2.default.contains({
	    metadataId: _react.PropTypes.string.isRequired,
	    type: _react.PropTypes.oneOf(_immutable2.default.Map(_TagsConstants.TAG_TYPES).valueSeq().toArray()).isRequired,
	    value: _react.PropTypes.string.isRequired
	  })]).isRequired,
	  owner: _bcPropTypes.userIdentityShape.isRequired,
	  tagsTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  tagsActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired
	};

/***/ },
/* 1992 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactIntl = __webpack_require__(3);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseButtons = __webpack_require__(12);
	
	var _sharedJacketCover = __webpack_require__(93);
	
	var _sharedJacketCover2 = _interopRequireDefault(_sharedJacketCover);
	
	var _sharedBibBrief = __webpack_require__(46);
	
	var _sharedBibBrief2 = _interopRequireDefault(_sharedBibBrief);
	
	var _utilsFormat = __webpack_require__(96);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _FormatInfoContainer = __webpack_require__(188);
	
	var _FormatInfoContainer2 = _interopRequireDefault(_FormatInfoContainer);
	
	var _ShelfPrivacyAlert = __webpack_require__(1988);
	
	var _ShelfPrivacyAlert2 = _interopRequireDefault(_ShelfPrivacyAlert);
	
	__webpack_require__(2612);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BaseUGCEditor = function (_BcReactComponent) {
	  _inherits(BaseUGCEditor, _BcReactComponent);
	
	  function BaseUGCEditor(props) {
	    _classCallCheck(this, BaseUGCEditor);
	
	    var _this = _possibleConstructorReturn(this, (BaseUGCEditor.__proto__ || Object.getPrototypeOf(BaseUGCEditor)).call(this, props));
	
	    _this.bindAll('handlePrivacyToggle', 'handleSubmit', 'handlePrivacySave', 'handleSave', 'handleSaveAndReset');
	
	    _this.state = {
	      addAnother: false,
	      setToPublic: false
	    };
	    return _this;
	  }
	
	  _createClass(BaseUGCEditor, [{
	    key: 'handleSubmit',
	    value: function handleSubmit(e) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      if (!this.props.saveButtonDisabled && !this.isSaving()) {
	        this.handleSave();
	      }
	    }
	  }, {
	    key: 'handlePrivacyToggle',
	    value: function handlePrivacyToggle(setToPublic) {
	      this.setState({ setToPublic: setToPublic });
	    }
	  }, {
	    key: 'handlePrivacySave',
	    value: function handlePrivacySave() {
	      var _state = this.state,
	          addAnother = _state.addAnother,
	          setToPublic = _state.setToPublic;
	      var _props = this.props,
	          shelfItem = _props.shelfItem,
	          shelfActions = _props.shelfActions,
	          handleClose = _props.handleClose,
	          handleReset = _props.handleReset;
	
	      var callback = addAnother ? handleReset : handleClose;
	
	      if (shelfItem && shelfActions && setToPublic) {
	        shelfActions.updateShelfItems({
	          shelfName: shelfItem.get('shelf'),
	          newShelfName: shelfItem.get('shelf'),
	          shelfItemIds: [shelfItem.get('id')],
	          metadataIds: [shelfItem.get('metadataId')],
	          privateItem: false,
	          postSuccess: callback
	        });
	      } else {
	        callback();
	      }
	    }
	  }, {
	    key: 'handleSave',
	    value: function handleSave() {
	      var _this2 = this;
	
	      this.setState({ addAnother: false }, function () {
	        _this2.props.handleSave(_this2.handlePrivacySave);
	      });
	    }
	  }, {
	    key: 'handleSaveAndReset',
	    value: function handleSaveAndReset() {
	      var _this3 = this;
	
	      this.setState({ addAnother: true }, function () {
	        _this3.props.handleSave(_this3.handlePrivacySave);
	      });
	    }
	  }, {
	    key: 'renderPrivacyAlert',
	    value: function renderPrivacyAlert() {
	      var _props2 = this.props,
	          showPrivacyAlert = _props2.showPrivacyAlert,
	          renderCustomPrivacyAlert = _props2.renderCustomPrivacyAlert,
	          shelfItem = _props2.shelfItem;
	
	
	      if (renderCustomPrivacyAlert) {
	        return renderCustomPrivacyAlert();
	      } else if (showPrivacyAlert && shelfItem && shelfItem.get('privateItem')) {
	        return _react2.default.createElement(_ShelfPrivacyAlert2.default, {
	          setToPublic: this.state.setToPublic,
	          handleChange: this.handlePrivacyToggle });
	      }
	
	      return null;
	    }
	  }, {
	    key: 'isSaving',
	    value: function isSaving() {
	      var _props3 = this.props,
	          bib = _props3.bib,
	          isSaving = _props3.isSaving,
	          shelfTransactions = _props3.shelfTransactions;
	
	      var metadataId = bib.getIn(['briefInfo', 'metadataId']);
	      return isSaving || shelfTransactions && shelfTransactions.getIn([metadataId, 'isUpdatingPrivacy'], false);
	    }
	  }, {
	    key: 'renderFooter',
	    value: function renderFooter() {
	      var addAnother = this.state.addAnother;
	      var _props4 = this.props,
	          handleSave = _props4.handleSave,
	          handleReset = _props4.handleReset,
	          handleClose = _props4.handleClose,
	          saveButtonDisabled = _props4.saveButtonDisabled;
	
	
	      if (handleSave || handleClose || handleReset) {
	        var isSaving = this.isSaving();
	        var saveButtonLoading = isSaving && !addAnother;
	        var saveAndResetButtonLoading = isSaving && addAnother;
	
	        var saveButton = handleSave && _react2.default.createElement(
	          _baseButtons.PrimaryButton,
	          {
	            className: 'save-button',
	            disabled: saveButtonDisabled || saveAndResetButtonLoading,
	            isLoading: saveButtonLoading,
	            handleClick: this.handleSave },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_save' })
	        );
	
	        var saveAndResetButton = handleSave && handleReset && _react2.default.createElement(
	          _baseButtons.SecondaryButton,
	          {
	            className: 'save-and-reset-button',
	            disabled: saveButtonDisabled || saveButtonLoading,
	            isLoading: saveAndResetButtonLoading,
	            handleClick: this.handleSaveAndReset },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_save_and_reset' })
	        );
	
	        var closeButton = handleClose && _react2.default.createElement(
	          _baseButtons.TextButton,
	          {
	            className: 'close-button',
	            disabled: saveButtonLoading || saveAndResetButtonLoading,
	            handleClick: handleClose },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_cancel' })
	        );
	
	        return _react2.default.createElement(
	          'div',
	          { className: 'ugc-editor-footer' },
	          saveButton,
	          ' ',
	          saveAndResetButton,
	          ' ',
	          closeButton
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderBibInfo',
	    value: function renderBibInfo() {
	      var bib = this.props.bib;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ugc-bib-info' },
	        _react2.default.createElement(
	          'div',
	          { className: 'jacket-cover-wrapper' },
	          _react2.default.createElement(_sharedJacketCover2.default, { src: bib.getIn(['briefInfo', 'jacket']), format: bib.getIn(['briefInfo', 'format']) })
	        ),
	        _react2.default.createElement(
	          _sharedBibBrief2.default,
	          { bib: bib.get('briefInfo'), titleTag: 'h3', renderTitleAsLink: false, renderAuthorsAsLink: false },
	          _react2.default.createElement(
	            'div',
	            { className: 'ugc-bib-format' },
	            _react2.default.createElement('span', { className: (0, _utilsFormat.getIconForFormat)(bib.getIn(['briefInfo', 'format'])), 'aria-hidden': true }),
	            _react2.default.createElement(_FormatInfoContainer2.default, { item: bib, showCallNumber: false })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props5 = this.props,
	          className = _props5.className,
	          children = _props5.children,
	          renderHeader = _props5.renderHeader;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('cp-base-ugc-editor', className) },
	        _react2.default.createElement(
	          'div',
	          { className: 'ugc-editor-header' },
	          renderHeader()
	        ),
	        this.renderBibInfo(),
	        _react2.default.createElement(
	          'form',
	          { onSubmit: this.handleSubmit, className: 'ugc-editor-form', action: '.', autoComplete: 'off' },
	          _react2.default.createElement(
	            'div',
	            { className: 'ugc-editor-body' },
	            children
	          ),
	          this.renderPrivacyAlert(),
	          this.renderFooter()
	        )
	      );
	    }
	  }]);
	
	  return BaseUGCEditor;
	}(_baseBcReactComponent2.default);
	
	exports.default = BaseUGCEditor;
	
	
	BaseUGCEditor.propTypes = {
	  bib: _bcPropTypes.bibShape.isRequired,
	  className: _react.PropTypes.string,
	  children: _bcPropTypes.childrenShape.isRequired,
	  renderHeader: _react.PropTypes.func.isRequired,
	  handleSave: _react.PropTypes.func,
	  handleClose: _react.PropTypes.func,
	  handleReset: _react.PropTypes.func,
	  isSaving: _react.PropTypes.bool,
	  saveButtonDisabled: _react.PropTypes.bool,
	  showPrivacyAlert: _react.PropTypes.bool,
	  renderCustomPrivacyAlert: _react.PropTypes.func,
	  shelfItem: _bcPropTypes.shelfItemShape,
	  shelfTransactions: _reactImmutableProptypes2.default.map,
	  shelfActions: _react.PropTypes.objectOf(_react.PropTypes.func)
	};
	
	BaseUGCEditor.defaultProps = {
	  isSaving: false,
	  saveButtonDisabled: false,
	  showPrivacyAlert: false
	};

/***/ },
/* 1993 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CommentUGCEditor = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _TextUGCEditor = __webpack_require__(392);
	
	var _TextUGCEditor2 = _interopRequireDefault(_TextUGCEditor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CHARACTER_LIMIT = 4000;
	
	var CommentUGCEditor = exports.CommentUGCEditor = function (_BcReactComponent) {
	  _inherits(CommentUGCEditor, _BcReactComponent);
	
	  function CommentUGCEditor(props) {
	    _classCallCheck(this, CommentUGCEditor);
	
	    var _this = _possibleConstructorReturn(this, (CommentUGCEditor.__proto__ || Object.getPrototypeOf(CommentUGCEditor)).call(this, props));
	
	    _this.bindAll('handleTextChange', 'handleSave');
	
	    _this.state = {
	      comment: ''
	    };
	    return _this;
	  }
	
	  _createClass(CommentUGCEditor, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var existingComment = this.props.existingComment;
	
	      if (existingComment && existingComment.get('comment')) {
	        this.setState({
	          comment: existingComment.get('comment')
	        });
	      }
	    }
	  }, {
	    key: 'handleTextChange',
	    value: function handleTextChange(value) {
	      this.setState({ comment: value });
	    }
	  }, {
	    key: 'handleSave',
	    value: function handleSave(callback) {
	      var _props = this.props,
	          bib = _props.bib,
	          existingComment = _props.existingComment,
	          commentsActions = _props.commentsActions;
	
	      var metadataId = bib.getIn(['briefInfo', 'metadataId']);
	      var commentId = existingComment && existingComment.get('id');
	      var comment = this.state.comment;
	      var postSuccess = callback;
	
	      if (commentId) {
	        commentsActions.updateComment({
	          comment: comment,
	          metadataId: metadataId,
	          commentId: commentId,
	          postSuccess: postSuccess
	        });
	      } else {
	        commentsActions.addComment({
	          comment: comment,
	          metadataId: metadataId,
	          postSuccess: postSuccess
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          bib = _props2.bib,
	          existingComment = _props2.existingComment,
	          commentsTransactions = _props2.commentsTransactions,
	          shelfItem = _props2.shelfItem,
	          shelfActions = _props2.shelfActions,
	          shelfTransactions = _props2.shelfTransactions,
	          handleClose = _props2.handleClose,
	          intl = _props2.intl;
	
	
	      var commentId = existingComment && existingComment.get('id');
	      var metadataId = bib.getIn(['briefInfo', 'metadataId']);
	      var renderHeader = function renderHeader() {
	        return _react2.default.createElement(
	          'h2',
	          null,
	          commentId ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'my_comment' }) : _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'add_comment' })
	        );
	      };
	      var isSavingComment = commentId ? commentsTransactions.getIn([metadataId, commentId, 'isUpdating'], false) : commentsTransactions.getIn([metadataId, 'isAdding'], false);
	      var placeholder = intl.formatMessage({ id: 'comment_placeholder' });
	      var textAreaLabel = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'comment' });
	
	      return _react2.default.createElement(_TextUGCEditor2.default, {
	        bib: bib,
	        characterLimit: CHARACTER_LIMIT,
	        className: 'cp-comment-ugc-editor',
	        errorKey: 'comment',
	        renderHeader: renderHeader,
	        handleClose: handleClose,
	        handleSave: this.handleSave,
	        handleTextChange: this.handleTextChange,
	        placeholder: placeholder,
	        isSaving: isSavingComment,
	        showPrivacyAlert: true,
	        shelfItem: shelfItem,
	        shelfTransactions: shelfTransactions,
	        shelfActions: shelfActions,
	        textAreaLabel: textAreaLabel,
	        text: this.state.comment });
	    }
	  }]);
	
	  return CommentUGCEditor;
	}(_baseBcReactComponent2.default);
	
	CommentUGCEditor.propTypes = {
	  bib: _bcPropTypes.bibShape.isRequired,
	  existingComment: _bcPropTypes.ugcCommentShape,
	  shelfItem: _bcPropTypes.shelfItemShape,
	  handleClose: _react.PropTypes.func.isRequired,
	  commentsTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  shelfTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  commentsActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  shelfActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired
	};
	
	exports.default = (0, _reactIntl.injectIntl)(CommentUGCEditor);

/***/ },
/* 1994 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PrivateNoteUGCEditor = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseAlerts = __webpack_require__(36);
	
	var _baseIcons = __webpack_require__(10);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _TextUGCEditor = __webpack_require__(392);
	
	var _TextUGCEditor2 = _interopRequireDefault(_TextUGCEditor);
	
	__webpack_require__(2613);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CHARACTER_LIMIT = 4000;
	
	function renderPrivacyAlert() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'private-note-alert' },
	    _react2.default.createElement(
	      _baseAlerts.Alert,
	      null,
	      _react2.default.createElement(_baseIcons.Lock, null),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ugc_private_note_alert' })
	      )
	    )
	  );
	}
	
	var PrivateNoteUGCEditor = exports.PrivateNoteUGCEditor = function (_BcReactComponent) {
	  _inherits(PrivateNoteUGCEditor, _BcReactComponent);
	
	  function PrivateNoteUGCEditor(props) {
	    _classCallCheck(this, PrivateNoteUGCEditor);
	
	    var _this = _possibleConstructorReturn(this, (PrivateNoteUGCEditor.__proto__ || Object.getPrototypeOf(PrivateNoteUGCEditor)).call(this, props));
	
	    _this.bindAll('handleTextChange', 'handleSave');
	
	    _this.state = {
	      note: ''
	    };
	    return _this;
	  }
	
	  _createClass(PrivateNoteUGCEditor, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var existingPrivateNote = this.props.existingPrivateNote;
	
	      if (existingPrivateNote && existingPrivateNote.get('note')) {
	        this.setState({
	          note: existingPrivateNote.get('note')
	        });
	      }
	    }
	  }, {
	    key: 'handleTextChange',
	    value: function handleTextChange(value) {
	      this.setState({ note: value });
	    }
	  }, {
	    key: 'handleSave',
	    value: function handleSave(callback) {
	      var _props = this.props,
	          bib = _props.bib,
	          existingPrivateNote = _props.existingPrivateNote,
	          privateNotesActions = _props.privateNotesActions;
	
	      var metadataId = bib.getIn(['briefInfo', 'metadataId']);
	      var noteId = existingPrivateNote && existingPrivateNote.get('id');
	      var note = this.state.note;
	      var postSuccess = callback;
	
	      if (noteId) {
	        privateNotesActions.updatePrivateNote({
	          note: note,
	          metadataId: metadataId,
	          noteId: noteId,
	          postSuccess: postSuccess
	        });
	      } else {
	        privateNotesActions.addPrivateNote({
	          note: note,
	          metadataId: metadataId,
	          postSuccess: postSuccess
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          bib = _props2.bib,
	          existingPrivateNote = _props2.existingPrivateNote,
	          privateNotesTransactions = _props2.privateNotesTransactions,
	          shelfItem = _props2.shelfItem,
	          shelfActions = _props2.shelfActions,
	          shelfTransactions = _props2.shelfTransactions,
	          handleClose = _props2.handleClose,
	          intl = _props2.intl;
	
	
	      var noteId = existingPrivateNote && existingPrivateNote.get('id');
	      var metadataId = bib.getIn(['briefInfo', 'metadataId']);
	      var renderHeader = function renderHeader() {
	        return _react2.default.createElement(
	          'h2',
	          null,
	          noteId ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'my_private_note' }) : _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'add_private_note' })
	        );
	      };
	      var isSavingPrivateNote = noteId ? privateNotesTransactions.getIn([metadataId, noteId, 'isUpdating'], false) : privateNotesTransactions.getIn([metadataId, 'isAdding'], false);
	      var placeholder = intl.formatMessage({ id: 'private_note_placeholder' });
	      var textAreaLabel = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'private_note_editor_label' });
	
	      return _react2.default.createElement(_TextUGCEditor2.default, {
	        bib: bib,
	        characterLimit: CHARACTER_LIMIT,
	        className: 'cp-private-note-ugc-editor',
	        errorKey: 'privateNote',
	        renderHeader: renderHeader,
	        handleClose: handleClose,
	        handleSave: this.handleSave,
	        handleTextChange: this.handleTextChange,
	        placeholder: placeholder,
	        isSaving: isSavingPrivateNote,
	        showPrivacyAlert: false,
	        renderCustomPrivacyAlert: renderPrivacyAlert,
	        shelfItem: shelfItem,
	        shelfTransactions: shelfTransactions,
	        shelfActions: shelfActions,
	        textAreaLabel: textAreaLabel,
	        text: this.state.note });
	    }
	  }]);
	
	  return PrivateNoteUGCEditor;
	}(_baseBcReactComponent2.default);
	
	PrivateNoteUGCEditor.propTypes = {
	  bib: _bcPropTypes.bibShape.isRequired,
	  existingPrivateNote: _bcPropTypes.ugcPrivateNoteShape,
	  shelfItem: _bcPropTypes.shelfItemShape,
	  handleClose: _react.PropTypes.func.isRequired,
	  privateNotesTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  shelfTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  privateNotesActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  shelfActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired
	};
	
	exports.default = (0, _reactIntl.injectIntl)(PrivateNoteUGCEditor);

/***/ },
/* 1995 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.QuotationUGCEditor = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _utilsAccessibility = __webpack_require__(95);
	
	var _TextUGCEditor = __webpack_require__(392);
	
	var _TextUGCEditor2 = _interopRequireDefault(_TextUGCEditor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CHARACTER_LIMIT = 1000;
	
	var QuotationUGCEditor = exports.QuotationUGCEditor = function (_BcReactComponent) {
	  _inherits(QuotationUGCEditor, _BcReactComponent);
	
	  function QuotationUGCEditor(props) {
	    _classCallCheck(this, QuotationUGCEditor);
	
	    var _this = _possibleConstructorReturn(this, (QuotationUGCEditor.__proto__ || Object.getPrototypeOf(QuotationUGCEditor)).call(this, props));
	
	    _this.bindAll('handleTextChange', 'handleSave', 'handleReset');
	
	    _this.textAreaRef = null;
	
	    _this.state = {
	      quotation: '',
	      quotationId: null
	    };
	    return _this;
	  }
	
	  _createClass(QuotationUGCEditor, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var existingQuotation = this.props.existingQuotation;
	
	      if (existingQuotation && existingQuotation.get('quotation')) {
	        this.setState({
	          quotationId: existingQuotation.get('id'),
	          quotation: existingQuotation.get('quotation')
	        });
	      }
	    }
	  }, {
	    key: 'handleTextChange',
	    value: function handleTextChange(value) {
	      this.setState({ quotation: value });
	    }
	  }, {
	    key: 'handleSave',
	    value: function handleSave(callback) {
	      var _state = this.state,
	          quotation = _state.quotation,
	          quotationId = _state.quotationId;
	      var _props = this.props,
	          bib = _props.bib,
	          quotationsActions = _props.quotationsActions;
	
	      var metadataId = bib.getIn(['briefInfo', 'metadataId']);
	      var postSuccess = callback;
	
	      if (quotationId) {
	        quotationsActions.updateQuotation({
	          quotation: quotation,
	          metadataId: metadataId,
	          quotationId: quotationId,
	          postSuccess: postSuccess
	        });
	      } else {
	        quotationsActions.addQuotation({
	          quotation: quotation,
	          metadataId: metadataId,
	          postSuccess: postSuccess
	        });
	      }
	    }
	  }, {
	    key: 'handleReset',
	    value: function handleReset() {
	      var _this2 = this;
	
	      this.setState({
	        quotationId: null,
	        quotation: ''
	      }, function () {
	        if (_this2.textAreaRef) {
	          (0, _utilsAccessibility.setFocusWithinElement)(_this2.textAreaRef);
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state2 = this.state,
	          quotation = _state2.quotation,
	          quotationId = _state2.quotationId;
	      var _props2 = this.props,
	          bib = _props2.bib,
	          quotationsTransactions = _props2.quotationsTransactions,
	          shelfItem = _props2.shelfItem,
	          shelfActions = _props2.shelfActions,
	          shelfTransactions = _props2.shelfTransactions,
	          handleClose = _props2.handleClose,
	          intl = _props2.intl;
	
	
	      var metadataId = bib.getIn(['briefInfo', 'metadataId']);
	      var renderHeader = function renderHeader() {
	        return _react2.default.createElement(
	          'h2',
	          null,
	          quotationId ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'my_quotation' }) : _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'add_quotation' })
	        );
	      };
	      var isSavingQuotation = quotationId ? quotationsTransactions.getIn([metadataId, quotationId, 'isUpdating'], false) : quotationsTransactions.getIn([metadataId, 'isAdding'], false);
	      var placeholder = intl.formatMessage({ id: 'quotation_placeholder' });
	      var textAreaLabel = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'quotation' });
	
	      return _react2.default.createElement(_TextUGCEditor2.default, {
	        bib: bib,
	        characterLimit: CHARACTER_LIMIT,
	        className: 'cp-quotation-ugc-editor',
	        errorKey: 'quotation',
	        renderHeader: renderHeader,
	        handleClose: handleClose,
	        handleReset: this.handleReset,
	        handleSave: this.handleSave,
	        handleTextChange: this.handleTextChange,
	        placeholder: placeholder,
	        isSaving: isSavingQuotation,
	        showPrivacyAlert: true,
	        shelfItem: shelfItem,
	        shelfTransactions: shelfTransactions,
	        shelfActions: shelfActions,
	        textAreaLabel: textAreaLabel,
	        textAreaRef: function textAreaRef(el) {
	          _this3.textAreaRef = el;
	        },
	        text: quotation });
	    }
	  }]);
	
	  return QuotationUGCEditor;
	}(_baseBcReactComponent2.default);
	
	QuotationUGCEditor.propTypes = {
	  bib: _bcPropTypes.bibShape.isRequired,
	  existingQuotation: _bcPropTypes.ugcQuotationShape,
	  shelfItem: _bcPropTypes.shelfItemShape,
	  handleClose: _react.PropTypes.func.isRequired,
	  quotationsTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  shelfTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  quotationsActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  shelfActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired
	};
	
	exports.default = (0, _reactIntl.injectIntl)(QuotationUGCEditor);

/***/ },
/* 1996 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SimilarTitlesUGCEditor = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _sharedBibScreenReaderDescription = __webpack_require__(365);
	
	var _sharedBibScreenReaderDescription2 = _interopRequireDefault(_sharedBibScreenReaderDescription);
	
	var _addTitle = __webpack_require__(360);
	
	var _AddTitleContainer = __webpack_require__(639);
	
	var _AddTitleContainer2 = _interopRequireDefault(_AddTitleContainer);
	
	var _baseIcons = __webpack_require__(10);
	
	var _BaseUGCEditor = __webpack_require__(292);
	
	var _BaseUGCEditor2 = _interopRequireDefault(_BaseUGCEditor);
	
	__webpack_require__(2614);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SimilarTitlesUGCEditor = exports.SimilarTitlesUGCEditor = function (_BcReactComponent) {
	  _inherits(SimilarTitlesUGCEditor, _BcReactComponent);
	
	  function SimilarTitlesUGCEditor(props) {
	    _classCallCheck(this, SimilarTitlesUGCEditor);
	
	    var _this = _possibleConstructorReturn(this, (SimilarTitlesUGCEditor.__proto__ || Object.getPrototypeOf(SimilarTitlesUGCEditor)).call(this, props));
	
	    _this.bindAll('renderAddOn', 'renderScreenReaderMessage', 'handleAdd');
	    return _this;
	  }
	
	  _createClass(SimilarTitlesUGCEditor, [{
	    key: 'renderScreenReaderMessage',
	    value: function renderScreenReaderMessage(item) {
	      return _react2.default.createElement(_reactIntl.FormattedMessage, {
	        id: 'ada_label_add_similar_title_to_bib',
	        values: { similarTitle: _react2.default.createElement(_sharedBibScreenReaderDescription2.default, { bibBrief: item }), relatedBibTitle: this.props.bib.getIn(['briefInfo', 'title']) } });
	    }
	
	    /*
	    handleAddSuccess(data) {
	      TODO: update once POST Request endpoint is working
	    } */
	
	  }, {
	    key: 'handleAdd',
	    value: function handleAdd(item) {
	      var _this2 = this;
	
	      // make api call
	      return function () {
	        var metadataId = _this2.props.bib.get('id');
	        var similarTitleId = item.get('id');
	        // TODO: pass in postSuccess method once endpoint is working
	        _this2.props.similarTitlesActions.addSimilarTitle(metadataId, similarTitleId, function () {
	          return null;
	        });
	      };
	    }
	  }, {
	    key: 'renderAddOn',
	    value: function renderAddOn(item) {
	      // if item does not have same metadataId as current bib, render addOn view
	      if (item.get('id') !== this.props.bib.get('id')) {
	        // if item exist in similar titles list, render the added icon
	        if (this.props.similarTitleBibs.keySeq().includes(item.get('id'))) {
	          return _react2.default.createElement(_addTitle.CatalogueResultItemAlert, { label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'added_to_shelf' }) });
	        }
	
	        // else render the add button
	        return _react2.default.createElement(_addTitle.CatalogueResultItemButton, {
	          icon: _react2.default.createElement(_baseIcons.Plus, null),
	          label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'add_to_shelf' }),
	          item: item,
	          screenReaderMessage: this.renderScreenReaderMessage(item),
	          handleClick: this.handleAdd(item) });
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          bib = _props.bib,
	          shelfItem = _props.shelfItem,
	          shelfActions = _props.shelfActions,
	          shelfTransactions = _props.shelfTransactions,
	          handleClose = _props.handleClose;
	
	
	      var renderHeader = function renderHeader() {
	        return _react2.default.createElement(
	          'h2',
	          null,
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'add_similar_titles' })
	        );
	      };
	
	      return _react2.default.createElement(
	        _BaseUGCEditor2.default,
	        {
	          bib: bib,
	          className: 'cp-similar-title-ugc-editor',
	          renderHeader: renderHeader,
	          shelfItem: shelfItem,
	          shelfTransactions: shelfTransactions,
	          shelfActions: shelfActions },
	        _react2.default.createElement(_AddTitleContainer2.default, {
	          handleClose: handleClose,
	          renderAddOn: this.renderAddOn,
	          addRowClassNames: function addRowClassNames(item) {
	            return { 'current-bib': item.get('id') === bib.get('id') };
	          } })
	      );
	    }
	  }]);
	
	  return SimilarTitlesUGCEditor;
	}(_baseBcReactComponent2.default);
	
	SimilarTitlesUGCEditor.propTypes = {
	  bib: _bcPropTypes.bibShape.isRequired,
	  shelfItem: _bcPropTypes.shelfItemShape,
	  handleClose: _react.PropTypes.func.isRequired,
	  similarTitleBibs: _reactImmutableProptypes2.default.map,
	  similarTitlesTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  shelfTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  similarTitlesActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  shelfActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired
	};
	
	exports.default = SimilarTitlesUGCEditor;

/***/ },
/* 1997 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TagsUGCEditor = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseButtons = __webpack_require__(12);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _baseTokenizedInput = __webpack_require__(1363);
	
	var _baseTokenizedInput2 = _interopRequireDefault(_baseTokenizedInput);
	
	var _baseIcons = __webpack_require__(10);
	
	var _BaseUGCEditor = __webpack_require__(292);
	
	var _BaseUGCEditor2 = _interopRequireDefault(_BaseUGCEditor);
	
	var _TagDisplay = __webpack_require__(602);
	
	var _TagDisplay2 = _interopRequireDefault(_TagDisplay);
	
	var _TagsConstants = __webpack_require__(242);
	
	__webpack_require__(2615);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function renderHeader() {
	  return _react2.default.createElement(
	    'h2',
	    null,
	    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'add_tags' })
	  );
	}
	
	function filterTagsByType(tags, type) {
	  return tags ? tags.filter(function (tag) {
	    return tag.get('type') === type;
	  }).toArray() : [];
	}
	
	var TagsUGCEditor = exports.TagsUGCEditor = function (_BcReactComponent) {
	  _inherits(TagsUGCEditor, _BcReactComponent);
	
	  function TagsUGCEditor(props) {
	    _classCallCheck(this, TagsUGCEditor);
	
	    var _this = _possibleConstructorReturn(this, (TagsUGCEditor.__proto__ || Object.getPrototypeOf(TagsUGCEditor)).call(this, props));
	
	    _this.bindAll('handleTagSave', 'renderTokenizedInput', 'renderTagDisplay');
	    return _this;
	  }
	
	  _createClass(TagsUGCEditor, [{
	    key: 'handleTagSave',
	    value: function handleTagSave(type, value) {
	      var _props = this.props,
	          bib = _props.bib,
	          tagsActions = _props.tagsActions;
	
	      var metadataId = bib.getIn(['briefInfo', 'metadataId']);
	
	      tagsActions.addTag(metadataId, type, value);
	    }
	  }, {
	    key: 'renderTagDisplay',
	    value: function renderTagDisplay(tag) {
	      var _props2 = this.props,
	          owner = _props2.owner,
	          tagsTransactions = _props2.tagsTransactions,
	          tagsActions = _props2.tagsActions;
	
	      var tagId = tag.get('id');
	      var tagType = tag.get('type');
	
	      return _react2.default.createElement(_TagDisplay2.default, {
	        key: 'tag-' + tagType + '-' + tagId,
	        tag: tag,
	        owner: owner,
	        tagsTransactions: tagsTransactions,
	        tagsActions: tagsActions });
	    }
	  }, {
	    key: 'renderTokenizedInput',
	    value: function renderTokenizedInput(type) {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          bib = _props3.bib,
	          existingTags = _props3.existingTags,
	          tagsTransactions = _props3.tagsTransactions;
	
	      var metadataId = bib.getIn(['briefInfo', 'metadataId']);
	      var tags = filterTagsByType(existingTags, type);
	
	      return _react2.default.createElement(_baseTokenizedInput2.default, {
	        id: type.toLowerCase() + '-tags-field',
	        maxInputLength: 50,
	        tokens: tags,
	        renderToken: this.renderTagDisplay,
	        getTokenKey: function getTokenKey(tag) {
	          return tag.get('id');
	        },
	        isSaving: tagsTransactions.getIn([metadataId, 'isAdding'], false),
	        handleTokenSave: function handleTokenSave(value) {
	          return _this2.handleTagSave(type, value);
	        },
	        renderNewToken: function renderNewToken(value) {
	          return _this2.renderTagDisplay(_immutable2.default.Map({ metadataId: metadataId, type: type, value: value }));
	        } });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props,
	          bib = _props4.bib,
	          handleClose = _props4.handleClose;
	
	
	      return _react2.default.createElement(
	        _BaseUGCEditor2.default,
	        { bib: bib, renderHeader: renderHeader, className: 'cp-tags-ugc-editor' },
	        _react2.default.createElement(
	          'div',
	          { className: 'tags-ugc-form' },
	          _react2.default.createElement(
	            'p',
	            { className: 'tags-form-help' },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'tags_form_help' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'genre-tags-field' },
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'tag_heading_genre' })
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'help-info' },
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'tag_help_genre' })
	            ),
	            this.renderTokenizedInput(_TagsConstants.TAG_TYPES.GENRE)
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'mood-tags-field' },
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'tag_heading_mood' })
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'help-info' },
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'tag_help_mood' })
	            ),
	            this.renderTokenizedInput(_TagsConstants.TAG_TYPES.MOOD)
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'subject-tags-field' },
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'tag_heading_subject' })
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'help-info' },
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'tag_help_subject' })
	            ),
	            this.renderTokenizedInput(_TagsConstants.TAG_TYPES.SUBJECT)
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'personal-tags-wrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-group' },
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'personal-tags-field' },
	                _react2.default.createElement(_baseIcons.Personal, null),
	                ' ',
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'tag_heading_personal' })
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'help-info' },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'tag_type_personal_description' }),
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'tag_help_personal' })
	              ),
	              this.renderTokenizedInput(_TagsConstants.TAG_TYPES.PERSONAL)
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'ugc-editor-footer' },
	          _react2.default.createElement(
	            _baseButtons.PrimaryButton,
	            { handleClick: handleClose },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'done' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return TagsUGCEditor;
	}(_baseBcReactComponent2.default);
	
	TagsUGCEditor.propTypes = {
	  bib: _bcPropTypes.bibShape.isRequired,
	  owner: _bcPropTypes.userIdentityShape.isRequired,
	  existingTags: _reactImmutableProptypes2.default.listOf(_bcPropTypes.ugcTagShape),
	  tagsTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  handleClose: _react.PropTypes.func.isRequired,
	  tagsActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired
	};
	
	exports.default = TagsUGCEditor;

/***/ },
/* 1998 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseAccessibilityTextArea = __webpack_require__(117);
	
	var _baseAccessibilityTextArea2 = _interopRequireDefault(_baseAccessibilityTextArea);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _BaseUGCEditor = __webpack_require__(292);
	
	var _BaseUGCEditor2 = _interopRequireDefault(_BaseUGCEditor);
	
	__webpack_require__(2616);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TextUGCEditor = function (_BcReactComponent) {
	  _inherits(TextUGCEditor, _BcReactComponent);
	
	  function TextUGCEditor() {
	    _classCallCheck(this, TextUGCEditor);
	
	    return _possibleConstructorReturn(this, (TextUGCEditor.__proto__ || Object.getPrototypeOf(TextUGCEditor)).apply(this, arguments));
	  }
	
	  _createClass(TextUGCEditor, [{
	    key: 'renderTextArea',
	    value: function renderTextArea() {
	      var _props = this.props,
	          bib = _props.bib,
	          characterLimit = _props.characterLimit,
	          errorKey = _props.errorKey,
	          placeholder = _props.placeholder,
	          handleTextChange = _props.handleTextChange,
	          text = _props.text,
	          textAreaLabel = _props.textAreaLabel,
	          textAreaRef = _props.textAreaRef;
	
	      var metadataId = bib.getIn(['briefInfo', 'metadataId']);
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _baseScreenReaderMessage2.default,
	          null,
	          _react2.default.createElement(
	            'label',
	            { htmlFor: 'editor-textarea-' + metadataId, id: 'label-' + metadataId },
	            textAreaLabel
	          )
	        ),
	        _react2.default.createElement(_baseAccessibilityTextArea2.default, {
	          required: true,
	          fitToText: true,
	          name: 'text',
	          className: 'editor-textarea',
	          errorKey: errorKey,
	          maxLength: characterLimit,
	          placeholder: placeholder,
	          id: 'editor-textarea-' + metadataId,
	          labelledById: 'label-' + metadataId,
	          handleChange: handleTextChange,
	          ref: textAreaRef,
	          value: text })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          bib = _props2.bib,
	          className = _props2.className,
	          text = _props2.text,
	          renderHeader = _props2.renderHeader,
	          handleSave = _props2.handleSave,
	          handleClose = _props2.handleClose,
	          handleReset = _props2.handleReset,
	          isSaving = _props2.isSaving,
	          showPrivacyAlert = _props2.showPrivacyAlert,
	          renderCustomPrivacyAlert = _props2.renderCustomPrivacyAlert,
	          shelfItem = _props2.shelfItem,
	          shelfTransactions = _props2.shelfTransactions,
	          shelfActions = _props2.shelfActions;
	
	
	      return _react2.default.createElement(
	        _BaseUGCEditor2.default,
	        {
	          bib: bib,
	          className: (0, _classnames2.default)('cp-text-ugc-editor', className),
	          renderHeader: renderHeader,
	          handleSave: handleSave,
	          handleClose: handleClose,
	          handleReset: handleReset,
	          isSaving: isSaving,
	          saveButtonDisabled: text.length <= 0,
	          showPrivacyAlert: showPrivacyAlert,
	          renderCustomPrivacyAlert: renderCustomPrivacyAlert,
	          shelfItem: shelfItem,
	          shelfTransactions: shelfTransactions,
	          shelfActions: shelfActions },
	        this.renderTextArea()
	      );
	    }
	  }]);
	
	  return TextUGCEditor;
	}(_baseBcReactComponent2.default);
	
	exports.default = TextUGCEditor;
	
	
	TextUGCEditor.propTypes = {
	  bib: _bcPropTypes.bibShape.isRequired,
	  characterLimit: _react.PropTypes.number,
	  className: _react.PropTypes.string,
	  errorKey: _react.PropTypes.string,
	  text: _react.PropTypes.string,
	  textAreaRef: _react.PropTypes.func,
	  handleClose: _react.PropTypes.func,
	  handleReset: _react.PropTypes.func,
	  handleSave: _react.PropTypes.func.isRequired,
	  handleTextChange: _react.PropTypes.func.isRequired,
	  placeholder: _react.PropTypes.string.isRequired,
	  isSaving: _react.PropTypes.bool.isRequired,
	  showPrivacyAlert: _react.PropTypes.bool.isRequired,
	  renderCustomPrivacyAlert: _react.PropTypes.func,
	  renderHeader: _react.PropTypes.func.isRequired,
	  shelfItem: _bcPropTypes.shelfItemShape,
	  shelfTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  shelfActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  textAreaLabel: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.node]).isRequired
	};
	
	TextUGCEditor.defaultProps = {
	  characterLimit: 1000,
	  errorKey: 'text',
	  text: ''
	};

/***/ },
/* 1999 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.VideoUGCEditor = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _reactIntl = __webpack_require__(3);
	
	var _lodash = __webpack_require__(16);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _baseAccessibilityTextArea = __webpack_require__(117);
	
	var _baseAccessibilityTextArea2 = _interopRequireDefault(_baseAccessibilityTextArea);
	
	var _baseClearableTextField = __webpack_require__(273);
	
	var _baseClearableTextField2 = _interopRequireDefault(_baseClearableTextField);
	
	var _baseAccessibilityTextField = __webpack_require__(228);
	
	var _baseAccessibilityTextField2 = _interopRequireDefault(_baseAccessibilityTextField);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	var _utilsUgc = __webpack_require__(121);
	
	var _baseIcons = __webpack_require__(10);
	
	var _HelpLinkContainer = __webpack_require__(126);
	
	var _HelpLinkContainer2 = _interopRequireDefault(_HelpLinkContainer);
	
	var _VideoPlayback = __webpack_require__(608);
	
	var _VideoPlayback2 = _interopRequireDefault(_VideoPlayback);
	
	var _BaseUGCEditor = __webpack_require__(292);
	
	var _BaseUGCEditor2 = _interopRequireDefault(_BaseUGCEditor);
	
	__webpack_require__(2617);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TITLE_CHARACTER_LIMIT = 50;
	var DESC_CHARACTER_LIMIT = 500;
	var URL_CHARACTER_LIMIT = 1000;
	var URL_ERROR_KEY = 'url';
	var TITLE_ERROR_KEY = 'title';
	
	var urlToIFrameSrc = _utilsUgc.videoUtils.urlToIFrameSrc;
	
	
	function renderAsterisk() {
	  return _react2.default.createElement(
	    'span',
	    { className: 'required' },
	    '*',
	    _react2.default.createElement(
	      _baseScreenReaderMessage2.default,
	      null,
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'FIELD_REQUIRED' })
	    )
	  );
	}
	
	function renderPlaceHolder() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'placeholder', 'data-key': 'ugc-video-placeholder' },
	      _react2.default.createElement(
	        'div',
	        { className: 'icon-film' },
	        _react2.default.createElement(_baseIcons.Film, null)
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'instruction' },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'video_embed_placeholder_info' })
	      )
	    )
	  );
	}
	
	var VideoUGCEditor = exports.VideoUGCEditor = function (_BcReactComponent) {
	  _inherits(VideoUGCEditor, _BcReactComponent);
	
	  function VideoUGCEditor(props) {
	    _classCallCheck(this, VideoUGCEditor);
	
	    var _this = _possibleConstructorReturn(this, (VideoUGCEditor.__proto__ || Object.getPrototypeOf(VideoUGCEditor)).call(this, props));
	
	    _this.bindAll('handleUrlChange', 'handleSave', 'handleClear', 'handleTitleChange', 'handleDescriptionChange');
	
	    _this.state = {
	      url: '',
	      urlError: null,
	      title: '',
	      titleError: null,
	      description: ''
	    };
	    return _this;
	  }
	
	  _createClass(VideoUGCEditor, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var existingVideo = this.props.existingVideo;
	
	
	      var existingVideoState = {};
	
	      if (existingVideo) {
	        existingVideoState.url = existingVideo.get('url');
	        existingVideoState.title = existingVideo.get('title');
	        existingVideoState.description = existingVideo.get('description') ? existingVideo.get('description') : '';
	        this.setState(existingVideoState);
	      }
	    }
	  }, {
	    key: 'renderVideo',
	    value: function renderVideo() {
	      var video = !this.state.urlError && this.state.url !== '' ? _react2.default.createElement(_VideoPlayback2.default, { src: urlToIFrameSrc(this.state.url) }) : renderPlaceHolder();
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'label-non-input' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'preview_label' })
	        ),
	        video
	      );
	    }
	  }, {
	    key: 'handleClear',
	    value: function handleClear() {
	      this.setState({ url: '', urlError: null });
	    }
	  }, {
	    key: 'handleUrlChange',
	    value: function handleUrlChange(value) {
	      var urlError = value && !urlToIFrameSrc(value) ? { id: 'error_invalid_url' } : null;
	      this.setState({ url: value, urlError: urlError });
	    }
	  }, {
	    key: 'handleDescriptionChange',
	    value: function handleDescriptionChange(value) {
	      this.setState({ description: value });
	    }
	  }, {
	    key: 'handleTitleChange',
	    value: function handleTitleChange(value) {
	      this.setState({ title: value, titleError: null });
	    }
	  }, {
	    key: 'handleSave',
	    value: function handleSave(callback) {
	      if (this.isFormValid()) {
	        var _props = this.props,
	            bib = _props.bib,
	            existingVideo = _props.existingVideo,
	            videosActions = _props.videosActions;
	
	        var metadataId = bib.getIn(['briefInfo', 'metadataId']);
	        var videoId = existingVideo && existingVideo.get('id');
	        var url = this.state.url;
	        var title = this.state.title;
	        var description = this.state.description;
	        var postSuccess = callback;
	
	        if (videoId) {
	          videosActions.updateVideo({ metadataId: metadataId, videoId: videoId, url: url, title: title, description: description, postSuccess: postSuccess });
	        } else {
	          videosActions.addVideo({ metadataId: metadataId, url: url, title: title, description: description, postSuccess: postSuccess });
	        }
	      } else {
	        var errorState = {};
	
	        if (!this.state.url) {
	          errorState.urlError = { id: 'error_invalid_url' };
	        }
	
	        if (!this.state.title) {
	          errorState.titleError = { id: 'error_title_required' };
	        }
	
	        if (!(0, _lodash.isEmpty)(errorState)) {
	          this.setState(errorState);
	        }
	      }
	    }
	  }, {
	    key: 'renderUrlInput',
	    value: function renderUrlInput() {
	      var metadataId = this.props.bib.getIn(['briefInfo', 'metadataId']);
	
	      var fieldErrors = this.state.urlError ? _defineProperty({}, URL_ERROR_KEY, _extends({}, this.state.urlError, {
	        values: {
	          url: _react2.default.createElement(
	            _HelpLinkContainer2.default,
	            {
	              showIcon: false,
	              page: '025ug/020video/' },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'catalog_help' })
	          )
	        }
	      })) : {};
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'editor-url-' + metadataId, id: 'label-url-' + metadataId },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'video_url_label' }),
	          ' ',
	          renderAsterisk()
	        ),
	        _react2.default.createElement(_baseClearableTextField2.default, {
	          id: 'editor-url-' + metadataId,
	          className: 'editor-url',
	          fieldErrors: fieldErrors,
	          errorKey: URL_ERROR_KEY,
	          handleChange: this.handleUrlChange,
	          handleClear: this.handleClear,
	          hideClearButton: !this.state.url,
	          labelledById: 'label-url-' + metadataId,
	          describedById: 'editor-url-' + metadataId,
	          maxLength: URL_CHARACTER_LIMIT,
	          characterCountSrOnly: true,
	          name: 'url',
	          type: 'text',
	          value: this.state.url,
	          inputTestId: 'editor-url',
	          info: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'video_url_info' }),
	          required: true })
	      );
	    }
	  }, {
	    key: 'renderTitleInput',
	    value: function renderTitleInput() {
	      var metadataId = this.props.bib.getIn(['briefInfo', 'metadataId']);
	
	      var fieldErrors = this.state.titleError ? _defineProperty({}, TITLE_ERROR_KEY, this.state.titleError) : {};
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'editor-title-' + metadataId, id: 'label-title-' + metadataId },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'add_title_label' }),
	          ' ',
	          renderAsterisk()
	        ),
	        _react2.default.createElement(_baseAccessibilityTextField2.default, {
	          id: 'editor-title-' + metadataId,
	          className: 'editor-title',
	          fieldErrors: fieldErrors,
	          errorKey: TITLE_ERROR_KEY,
	          handleChange: this.handleTitleChange,
	          labelledById: 'label-title-' + metadataId,
	          describedById: 'editor-title-' + metadataId,
	          name: 'title',
	          type: 'text',
	          value: this.state.title,
	          maxLength: TITLE_CHARACTER_LIMIT,
	          testId: 'editor-title',
	          required: true })
	      );
	    }
	  }, {
	    key: 'renderDescription',
	    value: function renderDescription() {
	      var metadataId = this.props.bib.getIn(['briefInfo', 'metadataId']);
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'editor-description-' + metadataId, id: 'label-description-' + metadataId },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'add_description_label' })
	        ),
	        _react2.default.createElement(_baseAccessibilityTextArea2.default, {
	          id: 'editor-description-' + metadataId,
	          required: true,
	          fitToText: true,
	          name: 'description',
	          className: 'editor-textarea',
	          maxLength: DESC_CHARACTER_LIMIT,
	          labelledById: 'label-description-' + metadataId,
	          handleChange: this.handleDescriptionChange,
	          testId: 'editor-description',
	          value: this.state.description })
	      );
	    }
	  }, {
	    key: 'isFormValid',
	    value: function isFormValid() {
	      var _state = this.state,
	          urlError = _state.urlError,
	          titleError = _state.titleError,
	          url = _state.url,
	          title = _state.title;
	
	      return url && title && !urlError && !titleError;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          bib = _props2.bib,
	          existingVideo = _props2.existingVideo,
	          videosTransactions = _props2.videosTransactions,
	          shelfItem = _props2.shelfItem,
	          shelfActions = _props2.shelfActions,
	          shelfTransactions = _props2.shelfTransactions,
	          handleClose = _props2.handleClose;
	
	      var videoId = existingVideo && existingVideo.get('id');
	      var metadataId = bib.getIn(['briefInfo', 'metadataId']);
	      var renderHeader = function renderHeader() {
	        return _react2.default.createElement(
	          'h2',
	          null,
	          videoId ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'my_video' }) : _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'add_a_video' })
	        );
	      };
	      var isSavingVideo = videoId ? videosTransactions.getIn([metadataId, videoId, 'isUpdating'], false) : videosTransactions.getIn([metadataId, 'isAdding'], false);
	
	      return _react2.default.createElement(
	        _BaseUGCEditor2.default,
	        {
	          bib: bib,
	          className: 'cp-video-ugc-editor',
	          renderHeader: renderHeader,
	          handleSave: this.handleSave,
	          handleClose: handleClose,
	          isSaving: isSavingVideo,
	          showPrivacyAlert: true,
	          shelfItem: shelfItem,
	          shelfTransactions: shelfTransactions,
	          shelfActions: shelfActions },
	        _react2.default.createElement(
	          'div',
	          { className: 'content-blocks' },
	          _react2.default.createElement(
	            'div',
	            { className: 'left-block' },
	            this.renderUrlInput(),
	            this.renderTitleInput(),
	            this.renderDescription()
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'right-block' },
	            this.renderVideo()
	          )
	        )
	      );
	    }
	  }]);
	
	  return VideoUGCEditor;
	}(_baseBcReactComponent2.default);
	
	VideoUGCEditor.propTypes = {
	  bib: _bcPropTypes.bibShape.isRequired,
	  existingVideo: _bcPropTypes.ugcVideoShape,
	  shelfItem: _bcPropTypes.shelfItemShape,
	  handleClose: _react.PropTypes.func.isRequired,
	  videosTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  shelfTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  videosActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  shelfActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired
	};
	
	exports.default = VideoUGCEditor;

/***/ },
/* 2000 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseFullScreenOverlay = __webpack_require__(45);
	
	var _baseFullScreenOverlay2 = _interopRequireDefault(_baseFullScreenOverlay);
	
	var _expandable = __webpack_require__(139);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _utilsUser = __webpack_require__(234);
	
	var _VideoUGCEditor = __webpack_require__(607);
	
	var _VideoUGCEditor2 = _interopRequireDefault(_VideoUGCEditor);
	
	var _VideoPlayback = __webpack_require__(608);
	
	var _VideoPlayback2 = _interopRequireDefault(_VideoPlayback);
	
	var _DisplayHeading = __webpack_require__(184);
	
	var _DisplayHeading2 = _interopRequireDefault(_DisplayHeading);
	
	var _DisplayWrapper = __webpack_require__(185);
	
	var _DisplayWrapper2 = _interopRequireDefault(_DisplayWrapper);
	
	var _DisplayActions = __webpack_require__(240);
	
	var _DisplayActions2 = _interopRequireDefault(_DisplayActions);
	
	__webpack_require__(2618);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VideoDisplay = function (_BcReactComponent) {
	  _inherits(VideoDisplay, _BcReactComponent);
	
	  function VideoDisplay(props) {
	    _classCallCheck(this, VideoDisplay);
	
	    var _this = _possibleConstructorReturn(this, (VideoDisplay.__proto__ || Object.getPrototypeOf(VideoDisplay)).call(this, props));
	
	    _this.bindAll('openEditor', 'closeEditor');
	
	    _this.state = {
	      showEditor: false
	    };
	    return _this;
	  }
	
	  _createClass(VideoDisplay, [{
	    key: 'openEditor',
	    value: function openEditor() {
	      this.setState({ showEditor: true });
	    }
	  }, {
	    key: 'closeEditor',
	    value: function closeEditor() {
	      this.setState({ showEditor: false });
	    }
	  }, {
	    key: 'renderEditor',
	    value: function renderEditor() {
	      return this.state.showEditor && _react2.default.createElement(_VideoUGCEditor2.default, {
	        bib: this.props.bib,
	        shelfItem: this.props.shelfItem,
	        handleClose: this.closeEditor,
	        existingVideo: this.props.video,
	        videosTransactions: this.props.videosTransactions,
	        shelfTransactions: this.props.shelfTransactions,
	        videosActions: this.props.videosActions,
	        shelfActions: this.props.shelfActions });
	    }
	  }, {
	    key: 'renderActions',
	    value: function renderActions() {
	      var _props = this.props,
	          owner = _props.owner,
	          videosActions = _props.videosActions,
	          videosTransactions = _props.videosTransactions,
	          video = _props.video,
	          bib = _props.bib;
	
	
	      if (owner.get('loggedIn')) {
	        var videoId = video.get('id');
	        var metadataId = video.get('metadataId');
	        var handleRemove = function handleRemove() {
	          return videosActions.removeVideo(metadataId, videoId);
	        };
	        var isRemoving = videosTransactions.getIn([metadataId, videoId, 'isRemoving'], false);
	        var title = bib.getIn(['briefInfo', 'title']);
	        var editScreenReaderMessage = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ada_ugc_edit_video', values: { title: title } });
	        var removeScreenReaderMessage = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ada_ugc_remove_video', values: { title: title } });
	
	        return _react2.default.createElement(_DisplayActions2.default, {
	          handleEdit: (0, _utilsUser.allowFreeText)(owner) ? this.openEditor : undefined,
	          handleRemove: handleRemove,
	          isRemoving: isRemoving,
	          editScreenReaderMessage: editScreenReaderMessage,
	          removeScreenReaderMessage: removeScreenReaderMessage });
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _DisplayWrapper2.default,
	        { className: 'cp-ugc-video-display' },
	        _react2.default.createElement(
	          'div',
	          { className: 'description-block' },
	          _react2.default.createElement(
	            _DisplayHeading2.default,
	            null,
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ugc_video_display_label' }),
	            ' ',
	            this.props.video.get('title')
	          ),
	          _react2.default.createElement(_expandable.ExpandableText, { text: this.props.video.get('description') || '', truncateCount: 160 }),
	          this.renderActions()
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'video-block' },
	          _react2.default.createElement(_VideoPlayback2.default, { src: this.props.video.get('url') })
	        ),
	        _react2.default.createElement(
	          _baseFullScreenOverlay2.default,
	          { open: !!this.state.showEditor, handleClose: this.closeEditor },
	          this.renderEditor()
	        )
	      );
	    }
	  }]);
	
	  return VideoDisplay;
	}(_baseBcReactComponent2.default);
	
	exports.default = VideoDisplay;
	
	
	VideoDisplay.propTypes = {
	  bib: _bcPropTypes.bibShape.isRequired,
	  shelfItem: _bcPropTypes.shelfItemShape.isRequired,
	  video: _bcPropTypes.ugcVideoShape.isRequired,
	  owner: _bcPropTypes.userIdentityShape.isRequired,
	  videosTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  videosActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  shelfTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  shelfActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired
	};

/***/ },
/* 2001 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _VideoDisplay = __webpack_require__(2000);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_VideoDisplay).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 2002 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.VideoPlayback = VideoPlayback;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(2619);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function VideoPlayback(_ref) {
	  var src = _ref.src;
	
	  return _react2.default.createElement('iframe', {
	    className: 'cp-ugc-video-playback',
	    'data-key': 'ugc-video-playback',
	    src: src,
	    frameBorder: '0',
	    allowFullScreen: true });
	}
	
	VideoPlayback.propTypes = {
	  src: _react.PropTypes.string.isRequired
	};
	
	exports.default = VideoPlayback;

/***/ },
/* 2003 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = UtilityBar;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(2620);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function UtilityBar(_ref) {
	  var children = _ref.children,
	      className = _ref.className;
	
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)('cp-utility-bar', className) },
	    children
	  );
	}
	
	UtilityBar.propTypes = {
	  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node]),
	  className: _react.PropTypes.string
	};

/***/ },
/* 2004 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EmptyShelf = EmptyShelf;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _reactRouter = __webpack_require__(17);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseIcons = __webpack_require__(10);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	var _HelpLinkContainer = __webpack_require__(126);
	
	var _HelpLinkContainer2 = _interopRequireDefault(_HelpLinkContainer);
	
	var _ShelfAddTitleButton = __webpack_require__(610);
	
	var _ShelfAddTitleButton2 = _interopRequireDefault(_ShelfAddTitleButton);
	
	__webpack_require__(2621);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function renderEmptyPublicShelf(shelf) {
	  var shelfName = shelf.get('name');
	  return _react2.default.createElement(
	    'div',
	    { className: 'empty-public-shelf' },
	    _react2.default.createElement(
	      'h2',
	      null,
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'users_empty_shelf_heading' })
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      _react2.default.createElement(_reactIntl.FormattedMessage, {
	        id: 'users_empty_shelf_description',
	        values: { shelf: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'label_' + shelfName + '_shelf' }) } })
	    )
	  );
	}
	
	function renderEmptyOwnerShelf(shelf, owner, currentUserShelves, shelfActions) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'empty-owner-shelf' },
	    _react2.default.createElement(
	      'h2',
	      null,
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'empty_shelf_heading' })
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'empty_shelf_description' })
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      _react2.default.createElement(
	        _HelpLinkContainer2.default,
	        { page: '020shelves/000my_shelves', showIcon: false },
	        _react2.default.createElement(
	          _baseScreenReaderMessage2.default,
	          null,
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ada_shelves_learn_more' })
	        ),
	        _react2.default.createElement(
	          'span',
	          { 'aria-hidden': true },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'label_about_my_shelves' })
	        ),
	        _react2.default.createElement(_baseIcons.ExternalArrow, { className: 'help-link-icon' })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'add-title-button-wrapper' },
	      _react2.default.createElement(_ShelfAddTitleButton2.default, {
	        shelfActions: shelfActions,
	        currentShelfName: shelf.get('name'),
	        currentUserShelves: currentUserShelves,
	        ownerId: owner.get('id') })
	    )
	  );
	}
	
	function renderEmptySearchResults(router) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'empty-search-results' },
	    _react2.default.createElement(
	      'h2',
	      null,
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'empty_shelf_no_titles' })
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'empty_shelf_no_titles_description' })
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      _react2.default.createElement(
	        _reactRouter.Link,
	        { to: router.location.pathname },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'clear_filters' })
	      )
	    )
	  );
	}
	
	function renderContent(shelf, owner, currentUserShelves, shelfActions, router) {
	  var searchFilters = shelf.getIn(['query', 'filters']);
	
	  if (searchFilters && !searchFilters.isEmpty()) {
	    return renderEmptySearchResults(router);
	  }
	
	  return owner.get('loggedIn') ? renderEmptyOwnerShelf(shelf, owner, currentUserShelves, shelfActions) : renderEmptyPublicShelf(shelf);
	}
	
	function EmptyShelf(_ref) {
	  var shelf = _ref.shelf,
	      owner = _ref.owner,
	      currentUserShelves = _ref.currentUserShelves,
	      shelfActions = _ref.shelfActions,
	      router = _ref.router,
	      children = _ref.children;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'cp-empty-shelf' },
	    _react2.default.createElement(
	      'div',
	      { className: 'empty-shelf-content' },
	      _react2.default.createElement(_baseIcons.Shelves, { color: 'currentColor', className: 'empty-shelf-icon' }),
	      renderContent(shelf, owner, currentUserShelves, shelfActions, router)
	    ),
	    children
	  );
	}
	
	EmptyShelf.propTypes = {
	  shelf: _bcPropTypes.shelfShape.isRequired,
	  owner: _bcPropTypes.userIdentityShape.isRequired,
	  currentUserShelves: _reactImmutableProptypes2.default.map.isRequired,
	  shelfActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  router: _reactRouter.routerShape.isRequired,
	  children: _bcPropTypes.childrenShape
	};
	
	exports.default = (0, _reactRouter.withRouter)(EmptyShelf);

/***/ },
/* 2005 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _EmptyShelf = __webpack_require__(2004);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_EmptyShelf).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 2006 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Shelf = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _baseDrawer = __webpack_require__(118);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _EmptyShelf = __webpack_require__(2005);
	
	var _EmptyShelf2 = _interopRequireDefault(_EmptyShelf);
	
	var _ShelfBottomControls = __webpack_require__(2010);
	
	var _ShelfBottomControls2 = _interopRequireDefault(_ShelfBottomControls);
	
	var _ShelfFacets = __webpack_require__(2012);
	
	var _ShelfFacets2 = _interopRequireDefault(_ShelfFacets);
	
	var _ShelfHeader = __webpack_require__(2014);
	
	var _ShelfHeader2 = _interopRequireDefault(_ShelfHeader);
	
	var _ShelfImportAlert = __webpack_require__(2016);
	
	var _ShelfImportAlert2 = _interopRequireDefault(_ShelfImportAlert);
	
	var _ShelfList = __webpack_require__(2018);
	
	var _ShelfList2 = _interopRequireDefault(_ShelfList);
	
	var _ShelfTitleBar = __webpack_require__(2049);
	
	var _ShelfTitleBar2 = _interopRequireDefault(_ShelfTitleBar);
	
	var _ShelfUtilityBar = __webpack_require__(2051);
	
	var _ShelfUtilityBar2 = _interopRequireDefault(_ShelfUtilityBar);
	
	__webpack_require__(2622);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Shelf = exports.Shelf = function (_BcReactComponent) {
	  _inherits(Shelf, _BcReactComponent);
	
	  function Shelf() {
	    _classCallCheck(this, Shelf);
	
	    return _possibleConstructorReturn(this, (Shelf.__proto__ || Object.getPrototypeOf(Shelf)).apply(this, arguments));
	  }
	
	  _createClass(Shelf, [{
	    key: 'renderImportAlert',
	    value: function renderImportAlert() {
	      var _props = this.props,
	          shelf = _props.shelf,
	          currentAccount = _props.currentAccount,
	          currentLibrary = _props.currentLibrary,
	          importResult = _props.importResult,
	          localBranch = _props.localBranch,
	          hiddenNotices = _props.hiddenNotices,
	          noticeActions = _props.noticeActions,
	          owner = _props.owner,
	          shelfActions = _props.shelfActions;
	
	
	      return _react2.default.createElement(_ShelfImportAlert2.default, {
	        shelfName: shelf.get('name'),
	        shelfOwner: owner,
	        currentAccount: currentAccount,
	        currentLibrary: currentLibrary,
	        importResult: importResult,
	        localBranch: localBranch,
	        hiddenNotices: hiddenNotices,
	        noticeActions: noticeActions,
	        shelfActions: shelfActions });
	    }
	  }, {
	    key: 'renderResults',
	    value: function renderResults() {
	      var _props2 = this.props,
	          shelf = _props2.shelf,
	          activeFilters = _props2.activeFilters,
	          owner = _props2.owner,
	          currentUserShelves = _props2.currentUserShelves,
	          shelfActions = _props2.shelfActions;
	
	
	      if (shelf.get('items').size > 0) {
	        var _props3 = this.props,
	            currentLibrary = _props3.currentLibrary,
	            localBranch = _props3.localBranch,
	            isFetching = _props3.isFetching,
	            printURL = _props3.printURL,
	            bibs = _props3.bibs,
	            ownerComments = _props3.ownerComments,
	            ownerQuotations = _props3.ownerQuotations,
	            ownerRatings = _props3.ownerRatings,
	            ownerTags = _props3.ownerTags,
	            ownerVideos = _props3.ownerVideos,
	            iOwnThisSettings = _props3.iOwnThisSettings,
	            ownerSimilarTitles = _props3.ownerSimilarTitles,
	            ownerPrivateNotes = _props3.ownerPrivateNotes,
	            commentsTransactions = _props3.commentsTransactions,
	            quotationsTransactions = _props3.quotationsTransactions,
	            ratingsTransactions = _props3.ratingsTransactions,
	            tagsTransactions = _props3.tagsTransactions,
	            similarTitlesTransactions = _props3.similarTitlesTransactions,
	            privateNotesTransactions = _props3.privateNotesTransactions,
	            iOwnThisTransactions = _props3.iOwnThisTransactions,
	            shelfTransactions = _props3.shelfTransactions,
	            videosTransactions = _props3.videosTransactions,
	            videosActions = _props3.videosActions,
	            iOwnThisActions = _props3.iOwnThisActions,
	            availabilityDetailActions = _props3.availabilityDetailActions,
	            commentsActions = _props3.commentsActions,
	            quotationsActions = _props3.quotationsActions,
	            drawerActions = _props3.drawerActions,
	            ratingsActions = _props3.ratingsActions,
	            tagsActions = _props3.tagsActions,
	            similarTitlesActions = _props3.similarTitlesActions,
	            privateNotesActions = _props3.privateNotesActions,
	            workflowActions = _props3.workflowActions;
	
	
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_ShelfUtilityBar2.default, {
	            activeFilters: activeFilters,
	            isFetching: isFetching,
	            pagination: shelf.get('pagination'),
	            printURL: printURL,
	            sortFields: shelf.getIn(['sort', 'fields']),
	            drawerActions: drawerActions }),
	          _react2.default.createElement(_ShelfList2.default, {
	            currentLibrary: currentLibrary,
	            localBranch: localBranch,
	            owner: owner,
	            shelf: shelf,
	            bibs: bibs,
	            currentUserShelves: currentUserShelves,
	            commentsTransactions: commentsTransactions,
	            quotationsTransactions: quotationsTransactions,
	            ratingsTransactions: ratingsTransactions,
	            tagsTransactions: tagsTransactions,
	            privateNotesTransactions: privateNotesTransactions,
	            shelfTransactions: shelfTransactions,
	            videosTransactions: videosTransactions,
	            iOwnThisTransactions: iOwnThisTransactions,
	            similarTitlesTransactions: similarTitlesTransactions,
	            ownerComments: ownerComments,
	            ownerQuotations: ownerQuotations,
	            ownerRatings: ownerRatings,
	            ownerTags: ownerTags,
	            ownerVideos: ownerVideos,
	            ownerPrivateNotes: ownerPrivateNotes,
	            iOwnThisSettings: iOwnThisSettings,
	            ownerSimilarTitles: ownerSimilarTitles,
	            commentsActions: commentsActions,
	            availabilityDetailActions: availabilityDetailActions,
	            quotationsActions: quotationsActions,
	            ratingsActions: ratingsActions,
	            tagsActions: tagsActions,
	            similarTitlesActions: similarTitlesActions,
	            privateNotesActions: privateNotesActions,
	            videosActions: videosActions,
	            iOwnThisActions: iOwnThisActions,
	            shelfActions: shelfActions,
	            workflowActions: workflowActions }),
	          _react2.default.createElement(_ShelfBottomControls2.default, {
	            isFetching: isFetching,
	            pagination: shelf.get('pagination') })
	        );
	      }
	
	      return _react2.default.createElement(_EmptyShelf2.default, {
	        owner: owner,
	        shelf: shelf,
	        currentUserShelves: currentUserShelves,
	        shelfActions: shelfActions });
	    }
	  }, {
	    key: 'renderShelfSearch',
	    value: function renderShelfSearch() {
	      var _props4 = this.props,
	          shelf = _props4.shelf,
	          activeFilters = _props4.activeFilters,
	          owner = _props4.owner,
	          shelfActions = _props4.shelfActions,
	          currentUserShelves = _props4.currentUserShelves;
	
	      var totalCount = shelf.getIn(['pagination', 'count']);
	
	      if (totalCount > 0 || activeFilters.size > 0) {
	        var drawerActions = this.props.drawerActions;
	
	
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_ShelfTitleBar2.default, { owner: owner, shelfActions: shelfActions, currentShelfName: shelf.get('name'), currentUserShelves: currentUserShelves }),
	          _react2.default.createElement(
	            _baseDrawer.Sidebar,
	            { sidebarClass: 'shelf-sidebar', drawerActions: drawerActions },
	            _react2.default.createElement(_ShelfFacets2.default, {
	              owner: owner,
	              activeFilters: activeFilters,
	              shelf: shelf,
	              drawerActions: drawerActions,
	              shelfActions: shelfActions })
	          ),
	          _react2.default.createElement(
	            _baseDrawer.MainContent,
	            { mainClass: 'shelf-main-content' },
	            this.renderImportAlert(),
	            this.renderResults()
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        _EmptyShelf2.default,
	        {
	          owner: owner,
	          shelf: shelf,
	          currentUserShelves: currentUserShelves,
	          shelfActions: shelfActions },
	        this.renderImportAlert()
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props5 = this.props,
	          drawer = _props5.drawer,
	          owner = _props5.owner,
	          pageTitle = _props5.pageTitle,
	          shelf = _props5.shelf,
	          summary = _props5.summary;
	
	
	      return _react2.default.createElement(
	        _baseDrawer.Layout,
	        { open: drawer.get('open'), containerClass: 'cp-shelf' },
	        _react2.default.createElement(_ShelfHeader2.default, { owner: owner, summary: summary, currentShelfName: shelf.get('name') }),
	        _react2.default.createElement(
	          _baseScreenReaderMessage2.default,
	          { className: 'shelf-page-title' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            pageTitle
	          )
	        ),
	        this.renderShelfSearch()
	      );
	    }
	  }]);
	
	  return Shelf;
	}(_baseBcReactComponent2.default);
	
	var drawerShape = _reactImmutableProptypes2.default.mapContains({
	  open: _react.PropTypes.bool
	});
	
	var importResultShape = _reactImmutableProptypes2.default.mapContains({
	  isFetching: _react.PropTypes.bool,
	  count: _react.PropTypes.number,
	  status: _react.PropTypes.string
	});
	
	Shelf.propTypes = {
	  currentAccount: _bcPropTypes.accountShape,
	  importResult: importResultShape,
	  localBranch: _react.PropTypes.string,
	  currentLibrary: _reactImmutableProptypes2.default.map.isRequired,
	  drawer: drawerShape.isRequired,
	  isFetching: _react.PropTypes.bool.isRequired,
	  owner: _bcPropTypes.userIdentityShape.isRequired,
	  pageTitle: _react.PropTypes.string.isRequired,
	  printURL: _react.PropTypes.string.isRequired,
	  shelf: _bcPropTypes.shelfShape.isRequired,
	  activeFilters: _reactImmutableProptypes2.default.map.isRequired,
	  summary: _reactImmutableProptypes2.default.map.isRequired,
	  bibs: _reactImmutableProptypes2.default.map.isRequired,
	  ownerRatings: _reactImmutableProptypes2.default.map.isRequired,
	  ownerComments: _reactImmutableProptypes2.default.map.isRequired,
	  ownerQuotations: _reactImmutableProptypes2.default.map.isRequired,
	  ownerTags: _reactImmutableProptypes2.default.map.isRequired,
	  ownerVideos: _reactImmutableProptypes2.default.map.isRequired,
	  iOwnThisSettings: _reactImmutableProptypes2.default.map.isRequired,
	  ownerSimilarTitles: _reactImmutableProptypes2.default.map.isRequired,
	  ownerPrivateNotes: _reactImmutableProptypes2.default.map.isRequired,
	  commentsTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  quotationsTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  ratingsTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  tagsTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  videosTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  iOwnThisTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  similarTitlesTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  privateNotesTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  shelfTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  hiddenNotices: _reactImmutableProptypes2.default.set.isRequired,
	  currentUserShelves: _reactImmutableProptypes2.default.map.isRequired,
	  availabilityDetailActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  commentsActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  drawerActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  quotationsActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  ratingsActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  tagsActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  videosActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  iOwnThisActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  noticeActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  similarTitlesActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  privateNotesActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  shelfActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  workflowActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired
	};
	
	exports.default = Shelf;

/***/ },
/* 2007 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Shelf = __webpack_require__(2006);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Shelf).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 2008 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ShelfAddTitleButton = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _reactRouter = __webpack_require__(17);
	
	var _PropTypes = __webpack_require__(90);
	
	var _sharedBibScreenReaderDescription = __webpack_require__(365);
	
	var _sharedBibScreenReaderDescription2 = _interopRequireDefault(_sharedBibScreenReaderDescription);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseButtons = __webpack_require__(12);
	
	var _baseIcons = __webpack_require__(10);
	
	var _addTitle = __webpack_require__(360);
	
	var _AddTitleOverlay = __webpack_require__(582);
	
	var _AddTitleContainer = __webpack_require__(639);
	
	var _AddTitleContainer2 = _interopRequireDefault(_AddTitleContainer);
	
	__webpack_require__(2623);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ShelfAddTitleButton = exports.ShelfAddTitleButton = function (_BcReactComponent) {
	  _inherits(ShelfAddTitleButton, _BcReactComponent);
	
	  function ShelfAddTitleButton(props) {
	    _classCallCheck(this, ShelfAddTitleButton);
	
	    var _this = _possibleConstructorReturn(this, (ShelfAddTitleButton.__proto__ || Object.getPrototypeOf(ShelfAddTitleButton)).call(this, props));
	
	    _this.bindAll('closeEditor', 'openEditor', 'handleAdd', 'handleMove', 'renderAddOn');
	    _this.state = {
	      showEditor: false,
	      itemsAddedHash: {},
	      isUpdatingResultItem: false,
	      anyTransactionSuccess: false // determines if at least one transaction has been successful
	    };
	    return _this;
	  }
	
	  _createClass(ShelfAddTitleButton, [{
	    key: 'closeEditor',
	    value: function closeEditor() {
	      this.setState({ showEditor: false });
	      if (this.state.anyTransactionSuccess) {
	        var _props = this.props,
	            location = _props.location,
	            ownerId = _props.ownerId,
	            shelfActions = _props.shelfActions,
	            currentShelfName = _props.currentShelfName;
	
	        shelfActions.searchUserShelf(currentShelfName, ownerId, _extends({}, location.query, { page: undefined }));
	      }
	    }
	  }, {
	    key: 'openEditor',
	    value: function openEditor() {
	      this.setState({ showEditor: true, anyTransactionSuccess: false });
	    }
	  }, {
	    key: 'renderOverlay',
	    value: function renderOverlay() {
	      return this.state.showEditor && _react2.default.createElement(_AddTitleContainer2.default, {
	        handleClose: this.closeEditor,
	        renderAddOn: this.renderAddOn,
	        isUpdatingResultItem: this.state.isUpdatingResultItem,
	        isWrappedInForm: true });
	    }
	  }, {
	    key: 'renderScreenReaderMessage',
	    value: function renderScreenReaderMessage(item) {
	      var shelfLabelEnum = {
	        completed: 'label_my_shelf_completed',
	        in_progress: 'label_my_shelf_in_progress',
	        for_later: 'label_my_shelf_for_later'
	      };
	
	      return _react2.default.createElement(_reactIntl.FormattedMessage, {
	        id: 'ada_label_add_item_to_list_type',
	        values: { title: _react2.default.createElement(_sharedBibScreenReaderDescription2.default, { bibBrief: item }), listType: _react2.default.createElement(_reactIntl.FormattedMessage, { id: shelfLabelEnum[this.props.currentShelfName] }) } });
	    }
	  }, {
	    key: 'handleAdd',
	    value: function handleAdd(item) {
	      var _this2 = this;
	
	      return function () {
	        var _props2 = _this2.props,
	            shelfActions = _props2.shelfActions,
	            currentShelfName = _props2.currentShelfName;
	
	        _this2.setState({ isUpdatingResultItem: true });
	
	        shelfActions.addToShelf(item.get('metadataId'), currentShelfName, function () {
	          _this2.setState(function (prevState) {
	            return {
	              itemsAddedHash: _extends({}, prevState.itemsAddedHash, _defineProperty({}, item.get('metadataId'), true)),
	              isUpdatingResultItem: false,
	              anyTransactionSuccess: true
	            };
	          });
	        });
	      };
	    }
	  }, {
	    key: 'handleMove',
	    value: function handleMove(item) {
	      var _this3 = this;
	
	      return function () {
	        var _props3 = _this3.props,
	            shelfActions = _props3.shelfActions,
	            currentShelfName = _props3.currentShelfName;
	
	        shelfActions.updateShelfItems({
	          shelfName: item.get('shelf'),
	          shelfItemIds: [item.get('id')],
	          metadataIds: [item.get('metadataId')],
	          newShelfName: currentShelfName,
	          postSuccess: function postSuccess() {
	            _this3.setState(function (prevState) {
	              return {
	                itemsAddedHash: _extends({}, prevState.itemsAddedHash, _defineProperty({}, item.get('metadataId'), true)),
	                isUpdatingResultItem: false,
	                anyTransactionSuccess: true
	              };
	            });
	          }
	        });
	
	        _this3.setState({ isUpdatingResultItem: true });
	      };
	    }
	  }, {
	    key: 'renderAddOn',
	    value: function renderAddOn(item) {
	      var _props4 = this.props,
	          currentUserShelves = _props4.currentUserShelves,
	          currentShelfName = _props4.currentShelfName;
	
	      var currentShelfItem = currentUserShelves.get(item.get('metadataId'));
	
	      if (currentShelfItem) {
	        if (currentShelfItem.get('shelf') === currentShelfName) {
	          var alertLabel = this.state.itemsAddedHash[item.get('metadataId')] ? 'added_to_shelf' : 'on_shelf';
	          return _react2.default.createElement(_addTitle.CatalogueResultItemAlert, { label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: alertLabel }) });
	        }
	        return _react2.default.createElement(_addTitle.CatalogueResultItemButton, {
	          icon: _react2.default.createElement(_baseIcons.Arrows.move.Right, { className: 'result-item-icon' }),
	          label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'move_to_this_shelf' }),
	          item: item,
	          screenReaderMessage: this.renderScreenReaderMessage(item),
	          handleClick: this.handleMove(currentShelfItem) });
	      }
	
	      return _react2.default.createElement(_addTitle.CatalogueResultItemButton, {
	        icon: _react2.default.createElement(_baseIcons.Plus, null),
	        label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'add_to_shelf' }),
	        item: item, screenReaderMessage: this.renderScreenReaderMessage(item),
	        handleClick: this.handleAdd(item) });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _baseButtons.PrimaryButton,
	        {
	          handleClick: this.openEditor,
	          className: 'cp-shelf-add-title-button' },
	        _react2.default.createElement(_baseIcons.Plus, null),
	        ' ',
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'label_add_title' }),
	        _react2.default.createElement(
	          _AddTitleOverlay.AddTitleOverlay,
	          { open: !!this.state.showEditor, handleClose: this.closeEditor },
	          this.renderOverlay()
	        )
	      );
	    }
	  }]);
	
	  return ShelfAddTitleButton;
	}(_baseBcReactComponent2.default);
	
	var WrappedShelfAddTitleButton = (0, _reactRouter.withRouter)(ShelfAddTitleButton);
	
	WrappedShelfAddTitleButton.propTypes = {
	  shelfActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  currentShelfName: _react.PropTypes.string.isRequired,
	  currentUserShelves: _reactImmutableProptypes2.default.map.isRequired,
	  ownerId: _react.PropTypes.number.isRequired,
	  // from router wrapper
	  location: _PropTypes.locationShape
	};
	
	exports.default = WrappedShelfAddTitleButton;

/***/ },
/* 2009 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ShelfBottomControls;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _pagination = __webpack_require__(92);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	__webpack_require__(2624);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ShelfBottomControls(_ref) {
	  var isFetching = _ref.isFetching,
	      pagination = _ref.pagination;
	
	  return _react2.default.createElement(
	    'section',
	    { className: 'cp-shelf-bottom-controls' },
	    _react2.default.createElement(_pagination2.default, {
	      showPages: true,
	      isFetching: isFetching,
	      page: pagination.get('page'),
	      limit: pagination.get('limit'),
	      count: pagination.get('count'),
	      pages: pagination.get('pages') })
	  );
	}
	
	ShelfBottomControls.propTypes = {
	  isFetching: _react.PropTypes.bool,
	  pagination: _reactImmutableProptypes2.default.map.isRequired
	};

/***/ },
/* 2010 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ShelfBottomControls = __webpack_require__(2009);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ShelfBottomControls).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 2011 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ShelfFacets = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(17);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _FieldList = __webpack_require__(593);
	
	var _FieldList2 = _interopRequireDefault(_FieldList);
	
	__webpack_require__(2625);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ShelfFacets = exports.ShelfFacets = function (_BcReactComponent) {
	  _inherits(ShelfFacets, _BcReactComponent);
	
	  function ShelfFacets(props) {
	    _classCallCheck(this, ShelfFacets);
	
	    var _this = _possibleConstructorReturn(this, (ShelfFacets.__proto__ || Object.getPrototypeOf(ShelfFacets)).call(this, props));
	
	    _this.bindAll('handleExpandField');
	    return _this;
	  }
	
	  _createClass(ShelfFacets, [{
	    key: 'handleExpandField',
	    value: function handleExpandField(fieldId) {
	      var _props = this.props,
	          owner = _props.owner,
	          shelf = _props.shelf,
	          location = _props.location;
	
	      this.props.shelfActions.fetchAdditionalFilters(shelf.get('name'), owner.get('id'), fieldId, location.query);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          activeFilters = _props2.activeFilters,
	          shelf = _props2.shelf,
	          drawerActions = _props2.drawerActions;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-shelf-facets' },
	        _react2.default.createElement(_FieldList2.default, {
	          fields: shelf.get('facets'),
	          drawerActions: drawerActions,
	          activeFilters: activeFilters,
	          handleExpandField: this.handleExpandField })
	      );
	    }
	  }]);
	
	  return ShelfFacets;
	}(_baseBcReactComponent2.default);
	
	ShelfFacets.propTypes = {
	  activeFilters: _reactImmutableProptypes2.default.map.isRequired,
	  owner: _bcPropTypes.userIdentityShape.isRequired,
	  shelf: _bcPropTypes.shelfShape.isRequired,
	  drawerActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  shelfActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired
	};
	
	exports.default = (0, _reactRouter.withRouter)(ShelfFacets);

/***/ },
/* 2012 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ShelfFacets = __webpack_require__(2011);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ShelfFacets).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 2013 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ShelfHeader = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(17);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _reactIntl = __webpack_require__(3);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _userHeader = __webpack_require__(1557);
	
	var _baseIcons = __webpack_require__(10);
	
	var _baseDropdown = __webpack_require__(37);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _ShelfConstants = __webpack_require__(43);
	
	__webpack_require__(2626);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ShelfHeader = exports.ShelfHeader = function (_BcReactComponent) {
	  _inherits(ShelfHeader, _BcReactComponent);
	
	  function ShelfHeader() {
	    _classCallCheck(this, ShelfHeader);
	
	    return _possibleConstructorReturn(this, (ShelfHeader.__proto__ || Object.getPrototypeOf(ShelfHeader)).apply(this, arguments));
	  }
	
	  _createClass(ShelfHeader, [{
	    key: 'getNavItems',
	    value: function getNavItems() {
	      var _props = this.props,
	          currentShelfName = _props.currentShelfName,
	          summary = _props.summary,
	          params = _props.params;
	
	      var orderedSummary = summary.get('shelves').sortBy(function (shelf) {
	        return _ShelfConstants.SUMMARY_ORDER.indexOf(shelf.get('name'));
	      });
	
	      return orderedSummary.map(function (shelf) {
	        var shelfName = shelf.get('name');
	        var label = shelf.get('label') || _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'label_' + shelfName + '_shelf' });
	        var basePath = params.userId ? '/v2/users/' + params.userId + '/shelves' : '/v2/shelves';
	
	        return _immutable2.default.Map({
	          key: 'shelf_' + shelfName,
	          label: _react2.default.createElement(
	            'span',
	            { className: 'nav-item-label' },
	            label,
	            ' (',
	            shelf.get('count'),
	            ')'
	          ),
	          link: basePath + '/' + shelfName,
	          value: basePath + '/' + shelfName,
	          active: shelfName === currentShelfName
	        });
	      });
	    }
	  }, {
	    key: 'renderNav',
	    value: function renderNav(navItems) {
	      var owner = this.props.owner;
	
	      var heading = owner.get('loggedIn') ? 'section_title_my_shelves' : 'section_title_shelves';
	
	      return _react2.default.createElement(_userHeader.UserHeaderNav, {
	        renderHeading: function renderHeading() {
	          return _react2.default.createElement(_reactIntl.FormattedMessage, { id: heading });
	        },
	        renderIcon: function renderIcon() {
	          return _react2.default.createElement(_baseIcons.Shelves, null);
	        },
	        isCurrentUser: owner.get('loggedIn'),
	        items: navItems,
	        userIdentity: owner });
	    }
	  }, {
	    key: 'renderMobileNav',
	    value: function renderMobileNav(navItems) {
	      var _this2 = this;
	
	      var currentShelf = navItems.find(function (item) {
	        return item.get('active');
	      });
	
	      return _react2.default.createElement(
	        'span',
	        { className: 'shelf-mobile-nav visible-xs' },
	        _react2.default.createElement(_baseDropdown.Dropdown, {
	          disableMobile: true,
	          selected: currentShelf.get('label'),
	          options: navItems.toJS(),
	          handleSelect: function handleSelect(href) {
	            return _this2.props.router.push(href);
	          },
	          className: 'btn-link' })
	      );
	    }
	  }, {
	    key: 'renderUserHeader',
	    value: function renderUserHeader(navItems) {
	      var _this3 = this;
	
	      return !this.context.mobileApp ? _react2.default.createElement(_userHeader.UserHeader, { userIdentity: this.props.owner, renderNav: function renderNav() {
	          return _this3.renderNav(navItems);
	        } }) : null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var navItems = this.getNavItems();
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-shelf-header' },
	        this.renderUserHeader(navItems),
	        this.renderMobileNav(navItems)
	      );
	    }
	  }]);
	
	  return ShelfHeader;
	}(_baseBcReactComponent2.default);
	
	ShelfHeader.propTypes = {
	  currentShelfName: _react.PropTypes.string.isRequired,
	  owner: _bcPropTypes.userIdentityShape.isRequired,
	  summary: _reactImmutableProptypes2.default.contains({
	    shelves: _reactImmutableProptypes2.default.list.isRequired
	  }).isRequired
	};
	
	ShelfHeader.contextTypes = {
	  mobileApp: _react.PropTypes.bool
	};
	
	exports.default = (0, _reactRouter.withRouter)(ShelfHeader);

/***/ },
/* 2014 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ShelfHeader = __webpack_require__(2013);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ShelfHeader).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 2015 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ShelfImportAlert = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _reactIntl = __webpack_require__(3);
	
	var _reactRouter = __webpack_require__(17);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	var _baseAlerts = __webpack_require__(36);
	
	var _baseButtons = __webpack_require__(12);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _HelpLinkContainer = __webpack_require__(126);
	
	var _HelpLinkContainer2 = _interopRequireDefault(_HelpLinkContainer);
	
	var _ShelfConstants = __webpack_require__(43);
	
	__webpack_require__(2627);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var helpLink = _react2.default.createElement(
	  _HelpLinkContainer2.default,
	  { page: '045faq/070faq-for-later/#listimport', showIcon: false },
	  _react2.default.createElement(
	    _baseScreenReaderMessage2.default,
	    null,
	    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ada_shelves_import_learn_more' })
	  ),
	  _react2.default.createElement(
	    'span',
	    { 'aria-hidden': true },
	    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'learn_more' })
	  )
	);
	
	var ShelfImportAlert = exports.ShelfImportAlert = function (_BcReactComponent) {
	  _inherits(ShelfImportAlert, _BcReactComponent);
	
	  function ShelfImportAlert(props) {
	    _classCallCheck(this, ShelfImportAlert);
	
	    var _this = _possibleConstructorReturn(this, (ShelfImportAlert.__proto__ || Object.getPrototypeOf(ShelfImportAlert)).call(this, props));
	
	    _this.bindAll('importILSBibs', 'dismissNotice', 'dismissResults');
	
	    _this.state = {
	      resultsDismissed: false
	    };
	    return _this;
	  }
	
	  _createClass(ShelfImportAlert, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var nextImportResult = nextProps.importResult;
	      if (this.props.importResult !== nextImportResult && nextImportResult.get('status') === _ShelfConstants.IMPORT_STATUSES.DONE) {
	        var _props = this.props,
	            location = _props.location,
	            shelfName = _props.shelfName,
	            shelfOwner = _props.shelfOwner;
	
	        this.props.shelfActions.searchUserShelf(shelfName, shelfOwner.get('id'), location.query);
	      }
	    }
	  }, {
	    key: 'importILSBibs',
	    value: function importILSBibs() {
	      var _props2 = this.props,
	          currentAccount = _props2.currentAccount,
	          shelfName = _props2.shelfName,
	          shelfActions = _props2.shelfActions;
	
	      shelfActions.importILSBibs(shelfName, currentAccount.get('id'));
	    }
	  }, {
	    key: 'dismissNotice',
	    value: function dismissNotice() {
	      this.props.noticeActions.dismissNotice(_ShelfConstants.SHELF_IMPORT_NOTICE_ID);
	    }
	  }, {
	    key: 'dismissResults',
	    value: function dismissResults() {
	      this.setState({ resultsDismissed: true });
	    }
	  }, {
	    key: 'renderResults',
	    value: function renderResults() {
	      if (this.state.resultsDismissed) {
	        return null;
	      }
	
	      var importResult = this.props.importResult;
	
	
	      switch (importResult.get('status')) {
	        case _ShelfConstants.IMPORT_STATUSES.DONE:
	          {
	            var count = importResult.get('count') || 0;
	
	            if (count > 0) {
	              return _react2.default.createElement(
	                _baseAlerts.AlertSuccess,
	                { handleDismiss: this.dismissResults },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'message_successful_shelf_import', values: { count: count } })
	              );
	            }
	
	            return _react2.default.createElement(
	              _baseAlerts.AlertWarning,
	              { handleDismiss: this.dismissResults },
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'message_no_items_to_import' })
	            );
	          }
	
	        case _ShelfConstants.IMPORT_STATUSES.SUBMITTED:
	          {
	            return _react2.default.createElement(
	              _baseAlerts.AlertSuccess,
	              { handleDismiss: this.dismissResults },
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'message_shelf_import_submitted' })
	            );
	          }
	
	        default:
	          {
	            return null;
	          }
	      }
	    }
	  }, {
	    key: 'renderNotice',
	    value: function renderNotice() {
	      var _props3 = this.props,
	          importResult = _props3.importResult,
	          localBranch = _props3.localBranch;
	
	      var handleDismiss = localBranch ? undefined : this.dismissNotice;
	
	      return _react2.default.createElement(
	        _baseAlerts.AlertInfo,
	        { handleDismiss: handleDismiss },
	        _react2.default.createElement(
	          'span',
	          { className: 'alert-message' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'message_shelf_import' })
	        ),
	        ' ',
	        helpLink,
	        _react2.default.createElement(
	          'div',
	          { className: 'alert-actions' },
	          _react2.default.createElement(
	            _baseButtons.SecondaryButton,
	            { className: 'shelf-import-button', handleClick: this.importILSBibs, isLoading: importResult.get('isFetching') },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_shelf_import' })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props,
	          shelfName = _props4.shelfName,
	          shelfOwner = _props4.shelfOwner,
	          currentAccount = _props4.currentAccount,
	          currentLibrary = _props4.currentLibrary,
	          importResult = _props4.importResult,
	          hiddenNotices = _props4.hiddenNotices;
	
	
	      if (shelfOwner.get('loggedIn') && currentAccount && currentLibrary.get('listImport') && shelfName === _ShelfConstants.SHELF_NAMES.FOR_LATER) {
	        var importedILSShelves = currentAccount.get('importedILSShelves');
	        var isHidden = hiddenNotices.has(_ShelfConstants.SHELF_IMPORT_NOTICE_ID);
	
	        if (!importedILSShelves && !isHidden) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'cp-shelf-import-alert' },
	            importResult.get('status') ? this.renderResults() : this.renderNotice()
	          );
	        }
	      }
	
	      return null;
	    }
	  }]);
	
	  return ShelfImportAlert;
	}(_baseBcReactComponent2.default);
	
	var importResultShape = _reactImmutableProptypes2.default.mapContains({
	  count: _react.PropTypes.number,
	  status: _react.PropTypes.string,
	  isFetching: _react.PropTypes.bool
	});
	
	ShelfImportAlert.propTypes = {
	  shelfName: _react.PropTypes.string.isRequired,
	  shelfOwner: _bcPropTypes.userIdentityShape.isRequired,
	  currentAccount: _bcPropTypes.accountShape,
	  importResult: importResultShape,
	  localBranch: _react.PropTypes.string,
	  hiddenNotices: _reactImmutableProptypes2.default.set.isRequired,
	  noticeActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  shelfActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired
	};
	
	exports.default = (0, _reactRouter.withRouter)(ShelfImportAlert);

/***/ },
/* 2016 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ShelfImportAlert = __webpack_require__(2015);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ShelfImportAlert).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 2017 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ShelfList = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(17);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _baseDropdown = __webpack_require__(37);
	
	var _ShelfConstants = __webpack_require__(43);
	
	var _BatchActionsListContainer = __webpack_require__(298);
	
	var _BatchActionsListContainer2 = _interopRequireDefault(_BatchActionsListContainer);
	
	var _BatchActionsListItem = __webpack_require__(288);
	
	var _BatchActionsListItem2 = _interopRequireDefault(_BatchActionsListItem);
	
	var _ItemList = __webpack_require__(145);
	
	var _ItemList2 = _interopRequireDefault(_ItemList);
	
	var _ShelfListItem = __webpack_require__(2045);
	
	var _ShelfListItem2 = _interopRequireDefault(_ShelfListItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ShelfList = exports.ShelfList = function (_BcReactComponent) {
	  _inherits(ShelfList, _BcReactComponent);
	
	  function ShelfList(props) {
	    _classCallCheck(this, ShelfList);
	
	    var _this = _possibleConstructorReturn(this, (ShelfList.__proto__ || Object.getPrototypeOf(ShelfList)).call(this, props));
	
	    _this.bindAll('handleBatchRemove', 'handleBatchMove', 'renderBatchActionsMenu');
	    return _this;
	  }
	
	  _createClass(ShelfList, [{
	    key: 'renderBibList',
	    value: function renderBibList() {
	      var _this2 = this;
	
	      var items = this.props.shelf.get('items');
	
	      return _react2.default.createElement(
	        _ItemList2.default,
	        null,
	        items.map(function (item) {
	          return _this2.renderShelfListItem(item);
	        })
	      );
	    }
	  }, {
	    key: 'renderBatchActionsList',
	    value: function renderBatchActionsList() {
	      var _this3 = this;
	
	      var _props = this.props,
	          shelf = _props.shelf,
	          shelfTransactions = _props.shelfTransactions;
	
	      var items = shelf.get('items');
	      var pageNumber = shelf.getIn(['pagination', 'page']);
	      var pageLimit = shelf.getIn(['pagination', 'limit']);
	      var totalCount = shelf.getIn(['pagination', 'count']);
	
	      var actionIsLoading = shelfTransactions.toList().some(function (item) {
	        return item.get('isBatchRemoving') || item.get('isBatchMoving');
	      });
	
	      return _react2.default.createElement(
	        _BatchActionsListContainer2.default,
	        {
	          list: items,
	          actionIsLoading: actionIsLoading,
	          pageNumber: pageNumber,
	          pageLimit: pageLimit,
	          totalItems: totalCount,
	          renderActionsMenu: this.renderBatchActionsMenu },
	        function (selectedActionItems, updateItem) {
	          return _react2.default.createElement(
	            _ItemList2.default,
	            null,
	            items.map(function (item) {
	              return _this3.renderBatchActionsListItem(item, selectedActionItems, updateItem);
	            })
	          );
	        }
	      );
	    }
	  }, {
	    key: 'renderBatchActionsListItem',
	    value: function renderBatchActionsListItem(item, selectedActionItems, updateItem) {
	      return _react2.default.createElement(
	        _BatchActionsListItem2.default,
	        { key: 'batch-actions-list-item-' + item.get('id'), actionItem: item, selectedItems: selectedActionItems, updateItem: updateItem },
	        this.renderShelfListItem(item)
	      );
	    }
	
	    // used to trim down list of bibs related for each similar titles component
	
	  }, {
	    key: 'getBibsForSimilarTitles',
	    value: function getBibsForSimilarTitles(ownerSimilarTitles, metadataId) {
	      return this.props.bibs.filter(function (item) {
	        return ownerSimilarTitles.get(metadataId, []).some(function (similarTitle) {
	          return item.get('id') === similarTitle.get('similarMetadataId');
	        });
	      });
	    }
	  }, {
	    key: 'renderShelfListItem',
	    value: function renderShelfListItem(item) {
	      var _props2 = this.props,
	          availabilityDetailActions = _props2.availabilityDetailActions,
	          commentsActions = _props2.commentsActions,
	          quotationsActions = _props2.quotationsActions,
	          ratingsActions = _props2.ratingsActions,
	          tagsActions = _props2.tagsActions,
	          shelfActions = _props2.shelfActions,
	          tagsTransactions = _props2.tagsTransactions,
	          videosActions = _props2.videosActions,
	          iOwnThisActions = _props2.iOwnThisActions,
	          similarTitlesActions = _props2.similarTitlesActions,
	          shelfTransactions = _props2.shelfTransactions,
	          privateNotesActions = _props2.privateNotesActions,
	          bibs = _props2.bibs,
	          shelf = _props2.shelf,
	          owner = _props2.owner,
	          ownerComments = _props2.ownerComments,
	          ownerQuotations = _props2.ownerQuotations,
	          ownerRatings = _props2.ownerRatings,
	          ownerTags = _props2.ownerTags,
	          ownerVideos = _props2.ownerVideos,
	          ownerSimilarTitles = _props2.ownerSimilarTitles,
	          ownerPrivateNotes = _props2.ownerPrivateNotes,
	          iOwnThisSettings = _props2.iOwnThisSettings,
	          currentLibrary = _props2.currentLibrary,
	          localBranch = _props2.localBranch,
	          commentsTransactions = _props2.commentsTransactions,
	          quotationsTransactions = _props2.quotationsTransactions,
	          ratingsTransactions = _props2.ratingsTransactions,
	          videosTransactions = _props2.videosTransactions,
	          iOwnThisTransactions = _props2.iOwnThisTransactions,
	          similarTitlesTransactions = _props2.similarTitlesTransactions,
	          privateNotesTransactions = _props2.privateNotesTransactions,
	          currentUserShelves = _props2.currentUserShelves;
	
	
	      var metadataId = item.get('metadataId');
	
	      return _react2.default.createElement(_ShelfListItem2.default, {
	        key: 'shelf-list-item-' + item.get('id'),
	        item: item,
	        owner: owner,
	        shelfName: shelf.get('name'),
	        bib: bibs.get(metadataId),
	        currentLibrary: currentLibrary,
	        localBranch: localBranch,
	        currentUserShelfItemForBib: currentUserShelves.get(metadataId),
	        ownerCommentForBib: ownerComments.get(metadataId),
	        ownerQuotationsForBib: ownerQuotations.get(metadataId),
	        ownerRatingForBib: ownerRatings.get(metadataId),
	        ownerTagsForBib: ownerTags.get(metadataId),
	        ownerVideoForBib: ownerVideos.get(metadataId),
	        ownerSettingForBib: iOwnThisSettings.get(metadataId),
	        ownerSimilarTitlesForBib: ownerSimilarTitles.get(metadataId),
	        ownerPrivateNoteForBib: ownerPrivateNotes.get(metadataId),
	        similarTitleBibs: this.getBibsForSimilarTitles(ownerSimilarTitles, metadataId),
	        commentsTransactions: commentsTransactions,
	        quotationsTransactions: quotationsTransactions,
	        ratingsTransactions: ratingsTransactions,
	        tagsTransactions: tagsTransactions,
	        videosTransactions: videosTransactions,
	        iOwnThisTransactions: iOwnThisTransactions,
	        similarTitlesTransactions: similarTitlesTransactions,
	        privateNotesTransactions: privateNotesTransactions,
	        shelfTransactions: shelfTransactions,
	        availabilityDetailActions: availabilityDetailActions,
	        commentsActions: commentsActions,
	        quotationsActions: quotationsActions,
	        ratingsActions: ratingsActions,
	        tagsActions: tagsActions,
	        videosActions: videosActions,
	        similarTitlesActions: similarTitlesActions,
	        iOwnThisActions: iOwnThisActions,
	        privateNotesActions: privateNotesActions,
	        shelfActions: shelfActions });
	    }
	  }, {
	    key: 'renderBatchActionsMenu',
	    value: function renderBatchActionsMenu(selectedActionItems) {
	      var _this4 = this;
	
	      var shelf = this.props.shelf;
	
	      var selectedCount = selectedActionItems.size;
	
	      var moveMenuHeader = _react2.default.createElement(
	        _baseDropdown.DropdownMenuHeader,
	        { key: 'shelf-batch-actions-header' },
	        _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'change_shelf_location' })
	      );
	
	      var shelfNamesForMove = _immutable2.default.Map(_ShelfConstants.SHELF_NAMES).valueSeq().toArray().filter(function (shelfName) {
	        return shelfName !== shelf.get('name');
	      });
	      var moveMenuItems = shelfNamesForMove.map(function (shelfName) {
	        return _react2.default.createElement(
	          _baseDropdown.DropdownMenuItem,
	          { key: 'shelf-batch-actions-menu-item-move-' + shelfName },
	          _react2.default.createElement(
	            'a',
	            { href: '#shelf-batch-move', onClick: function onClick(e) {
	                return _this4.handleBatchMove(e, shelfName, selectedActionItems);
	              } },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'label_shelf_' + shelfName }),
	            '  (',
	            selectedCount,
	            ')'
	          )
	        );
	      });
	
	      var menuDivider = _react2.default.createElement(_baseDropdown.DropdownMenuDivider, { key: 'shelf-batch-actions-divider' });
	
	      var removeMenuItem = _react2.default.createElement(
	        _baseDropdown.DropdownMenuItem,
	        { key: 'shelf-batch-actions-menu-item-remove' },
	        _react2.default.createElement(
	          'a',
	          { href: '#shelf-batch-remove', onClick: function onClick(e) {
	              return _this4.handleBatchRemove(e, selectedActionItems);
	            } },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_remove_from_shelves' }),
	          ' (',
	          selectedCount,
	          ')'
	        )
	      );
	
	      return [moveMenuHeader].concat(_toConsumableArray(moveMenuItems), [menuDivider, removeMenuItem]);
	    }
	  }, {
	    key: 'handleBatchRemove',
	    value: function handleBatchRemove(e, selectedActionItems) {
	      var _this5 = this;
	
	      e.preventDefault();
	
	      var shelfName = this.props.shelf.get('name');
	      var selectedItems = selectedActionItems.toList();
	      var shelfItemIds = selectedItems.map(function (item) {
	        return item.get('id');
	      });
	      var metadataIds = selectedItems.map(function (item) {
	        return item.get('metadataId');
	      });
	      this.props.shelfActions.removeShelfItems({
	        shelfName: shelfName,
	        shelfItemIds: shelfItemIds,
	        metadataIds: metadataIds,
	        isBatch: true,
	        postSuccess: function postSuccess() {
	          var _props3 = _this5.props,
	              location = _props3.location,
	              owner = _props3.owner,
	              shelfActions = _props3.shelfActions;
	
	          shelfActions.searchUserShelf(shelfName, owner.get('id'), _extends({}, location.query, { page: undefined }));
	        }
	      });
	    }
	  }, {
	    key: 'handleBatchMove',
	    value: function handleBatchMove(e, newShelfName, selectedActionItems) {
	      var _this6 = this;
	
	      e.preventDefault();
	
	      var shelfName = this.props.shelf.get('name');
	      var selectedItems = selectedActionItems.toList();
	      var shelfItemIds = selectedItems.map(function (item) {
	        return item.get('id');
	      });
	      var metadataIds = selectedItems.map(function (item) {
	        return item.get('metadataId');
	      });
	      this.props.shelfActions.updateShelfItems({
	        shelfName: shelfName,
	        newShelfName: newShelfName,
	        shelfItemIds: shelfItemIds,
	        metadataIds: metadataIds,
	        isBatch: true,
	        postSuccess: function postSuccess() {
	          var _props4 = _this6.props,
	              location = _props4.location,
	              owner = _props4.owner,
	              shelfActions = _props4.shelfActions;
	
	          shelfActions.searchUserShelf(shelfName, owner.get('id'), _extends({}, location.query, { page: undefined }));
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var owner = this.props.owner;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-shelf-list' },
	        owner.get('loggedIn') ? this.renderBatchActionsList() : this.renderBibList()
	      );
	    }
	  }]);
	
	  return ShelfList;
	}(_baseBcReactComponent2.default);
	
	ShelfList.propTypes = {
	  currentLibrary: _reactImmutableProptypes2.default.map.isRequired,
	  owner: _bcPropTypes.userIdentityShape.isRequired,
	  shelf: _bcPropTypes.shelfShape.isRequired,
	  localBranch: _react.PropTypes.string,
	  bibs: _reactImmutableProptypes2.default.map.isRequired,
	  commentsTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  quotationsTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  ratingsTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  tagsTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  videosTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  iOwnThisTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  shelfTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  similarTitlesTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  privateNotesTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  ownerComments: _reactImmutableProptypes2.default.map.isRequired,
	  ownerQuotations: _reactImmutableProptypes2.default.map.isRequired,
	  ownerRatings: _reactImmutableProptypes2.default.map.isRequired,
	  ownerTags: _reactImmutableProptypes2.default.map.isRequired,
	  ownerVideos: _reactImmutableProptypes2.default.map.isRequired,
	  ownerSimilarTitles: _reactImmutableProptypes2.default.map.isRequired,
	  ownerPrivateNotes: _reactImmutableProptypes2.default.map.isRequired,
	  iOwnThisSettings: _reactImmutableProptypes2.default.map.isRequired,
	  availabilityDetailActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  commentsActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  quotationsActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  ratingsActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  tagsActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  videosActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  iOwnThisActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  similarTitlesActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  privateNotesActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  shelfActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  workflowActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  currentUserShelves: _reactImmutableProptypes2.default.map.isRequired
	};
	
	exports.default = (0, _reactRouter.withRouter)(ShelfList);

/***/ },
/* 2018 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ShelfList = __webpack_require__(2017);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ShelfList).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 2019 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ShelfListItemBibBriefInfo;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _reactIntl = __webpack_require__(3);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _baseIcons = __webpack_require__(10);
	
	var _sharedBibBrief = __webpack_require__(46);
	
	var _sharedBibBrief2 = _interopRequireDefault(_sharedBibBrief);
	
	var _availabilityBibBlock = __webpack_require__(226);
	
	var _availabilityBibBlock2 = _interopRequireDefault(_availabilityBibBlock);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	var _ItemFormat = __webpack_require__(289);
	
	var _ItemFormat2 = _interopRequireDefault(_ItemFormat);
	
	__webpack_require__(2628);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function renderAvailabilityInfo(bib, currentLibrary, availabilityDetailActions) {
	  var availabilityStatus = bib.get('availability');
	
	  if (bib.get('briefInfo') && availabilityStatus && bib.get('sourceLibId') === currentLibrary.get('id')) {
	    return _react2.default.createElement(
	      'div',
	      { className: 'shelf-availability-info' },
	      _react2.default.createElement(_availabilityBibBlock2.default, {
	        bib: bib,
	        showAvailabilityLink: true,
	        availabilityStatus: availabilityStatus,
	        availabilityDetailActions: availabilityDetailActions })
	    );
	  }
	
	  return null;
	}
	
	function renderPrivacyLock(item, owner) {
	  if (!item.get('privateItem') || !owner.get('loggedIn')) {
	    return null;
	  }
	
	  return _react2.default.createElement(
	    'span',
	    { className: 'privacy-lock' },
	    _react2.default.createElement(_baseIcons.Lock, null),
	    _react2.default.createElement(
	      _baseScreenReaderMessage2.default,
	      null,
	      _react2.default.createElement(_reactIntl.FormattedMessage, {
	        id: 'item_is_private' })
	    )
	  );
	}
	
	function ShelfListItemBibBriefInfo(_ref, context) {
	  var bib = _ref.bib,
	      item = _ref.item,
	      owner = _ref.owner,
	      currentLibrary = _ref.currentLibrary,
	      availabilityDetailActions = _ref.availabilityDetailActions;
	
	  var briefInfo = bib.get('briefInfo');
	  return _react2.default.createElement(
	    'div',
	    { className: 'cp-shelf-list-item-bib-brief-info' },
	    _react2.default.createElement(
	      _sharedBibBrief2.default,
	      { bib: briefInfo, renderAuthorsAsLink: !context.mobileApp, renderTitleAsLink: !!briefInfo.get('id'), titleTag: 'h3', renderIcon: function renderIcon() {
	          return renderPrivacyLock(item, owner);
	        } },
	      _react2.default.createElement(_ItemFormat2.default, { bib: bib }),
	      renderAvailabilityInfo(bib, currentLibrary, availabilityDetailActions)
	    )
	  );
	}
	
	ShelfListItemBibBriefInfo.propTypes = {
	  currentLibrary: _reactImmutableProptypes2.default.map.isRequired,
	  bib: _bcPropTypes.bibShape.isRequired,
	  item: _bcPropTypes.shelfItemShape.isRequired,
	  owner: _bcPropTypes.userIdentityShape.isRequired,
	  availabilityDetailActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired
	};
	
	ShelfListItemBibBriefInfo.contextTypes = {
	  mobileApp: _react.PropTypes.bool
	};

/***/ },
/* 2020 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BibBriefInfo = __webpack_require__(2019);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BibBriefInfo).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 2021 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _constantsUgc = __webpack_require__(119);
	
	var _utilsUgc = __webpack_require__(121);
	
	var _DisplayHeading = __webpack_require__(184);
	
	var _DisplayHeading2 = _interopRequireDefault(_DisplayHeading);
	
	var _CommentDisplay = __webpack_require__(1979);
	
	var _CommentDisplay2 = _interopRequireDefault(_CommentDisplay);
	
	__webpack_require__(2629);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ShelfListItemCommentInfo = function (_BcReactComponent) {
	  _inherits(ShelfListItemCommentInfo, _BcReactComponent);
	
	  function ShelfListItemCommentInfo() {
	    _classCallCheck(this, ShelfListItemCommentInfo);
	
	    return _possibleConstructorReturn(this, (ShelfListItemCommentInfo.__proto__ || Object.getPrototypeOf(ShelfListItemCommentInfo)).apply(this, arguments));
	  }
	
	  _createClass(ShelfListItemCommentInfo, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          bib = _props.bib,
	          item = _props.item,
	          owner = _props.owner,
	          currentLibrary = _props.currentLibrary,
	          localBranch = _props.localBranch,
	          ownerCommentForBib = _props.ownerCommentForBib,
	          commentsTransactions = _props.commentsTransactions,
	          shelfTransactions = _props.shelfTransactions,
	          commentsActions = _props.commentsActions,
	          shelfActions = _props.shelfActions;
	
	
	      if (ownerCommentForBib && (0, _utilsUgc.supportsUGCContentType)(_constantsUgc.UGC_CONTENT_TYPES.COMMENT, currentLibrary, localBranch)) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'cp-shelf-list-item-comment-info' },
	          _react2.default.createElement(
	            _DisplayHeading2.default,
	            null,
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ugc_comment_display_label' })
	          ),
	          _react2.default.createElement(_CommentDisplay2.default, {
	            bib: bib,
	            shelfItem: item,
	            owner: owner,
	            comment: ownerCommentForBib,
	            commentsTransactions: commentsTransactions,
	            shelfTransactions: shelfTransactions,
	            commentsActions: commentsActions,
	            shelfActions: shelfActions })
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return ShelfListItemCommentInfo;
	}(_baseBcReactComponent2.default);
	
	exports.default = ShelfListItemCommentInfo;
	
	
	ShelfListItemCommentInfo.propTypes = {
	  bib: _bcPropTypes.bibShape.isRequired,
	  currentLibrary: _reactImmutableProptypes2.default.map.isRequired,
	  item: _bcPropTypes.shelfItemShape.isRequired,
	  owner: _bcPropTypes.userIdentityShape.isRequired,
	  localBranch: _react.PropTypes.string,
	  ownerCommentForBib: _bcPropTypes.ugcCommentShape,
	  commentsTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  shelfTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  commentsActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  shelfActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired
	};

/***/ },
/* 2022 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CommentInfo = __webpack_require__(2021);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CommentInfo).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 2023 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _utilsUser = __webpack_require__(234);
	
	var _utilsAccessibility = __webpack_require__(95);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _CommentInfo = __webpack_require__(2022);
	
	var _CommentInfo2 = _interopRequireDefault(_CommentInfo);
	
	var _QuotationsInfo = __webpack_require__(2030);
	
	var _QuotationsInfo2 = _interopRequireDefault(_QuotationsInfo);
	
	var _RatingsInfo = __webpack_require__(2032);
	
	var _RatingsInfo2 = _interopRequireDefault(_RatingsInfo);
	
	var _TagsInfo = __webpack_require__(2040);
	
	var _TagsInfo2 = _interopRequireDefault(_TagsInfo);
	
	var _VideoInfo = __webpack_require__(2044);
	
	var _VideoInfo2 = _interopRequireDefault(_VideoInfo);
	
	var _Toolbar = __webpack_require__(2042);
	
	var _Toolbar2 = _interopRequireDefault(_Toolbar);
	
	var _SimilarTitlesInfo = __webpack_require__(2038);
	
	var _SimilarTitlesInfo2 = _interopRequireDefault(_SimilarTitlesInfo);
	
	var _PrivateNoteInfo = __webpack_require__(2028);
	
	var _PrivateNoteInfo2 = _interopRequireDefault(_PrivateNoteInfo);
	
	__webpack_require__(2630);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ShelfListItemFooterInfo = function (_BcReactComponent) {
	  _inherits(ShelfListItemFooterInfo, _BcReactComponent);
	
	  function ShelfListItemFooterInfo(props) {
	    _classCallCheck(this, ShelfListItemFooterInfo);
	
	    var _this = _possibleConstructorReturn(this, (ShelfListItemFooterInfo.__proto__ || Object.getPrototypeOf(ShelfListItemFooterInfo)).call(this, props));
	
	    _this.bindAll('handleUGCFocus');
	
	    _this.commentInfoRef = null;
	    _this.quotationsInfoRef = null;
	    _this.tagsInfoRef = null;
	    _this.videoInfoRef = null;
	
	    _this.state = {
	      commentAdded: false,
	      quotationsAdded: false,
	      tagsAdded: false,
	      videoAdded: false,
	      similarTitlesAdded: false,
	      privateNoteAdded: false
	    };
	    return _this;
	  }
	
	  _createClass(ShelfListItemFooterInfo, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props = this.props,
	          ownerCommentForBib = _props.ownerCommentForBib,
	          ownerQuotationsForBib = _props.ownerQuotationsForBib,
	          ownerTagsForBib = _props.ownerTagsForBib,
	          ownerVideoForBib = _props.ownerVideoForBib,
	          ownerSimilarTitlesForBib = _props.ownerSimilarTitlesForBib,
	          ownerPrivateNoteForBib = _props.ownerPrivateNoteForBib;
	
	
	      var tagsCount = ownerTagsForBib ? ownerTagsForBib.size : 0;
	      var nextTagsCount = nextProps.ownerTagsForBib ? nextProps.ownerTagsForBib.size : 0;
	      var quotationsCount = ownerQuotationsForBib ? ownerQuotationsForBib.size : 0;
	      var nextQuotationsCount = nextProps.ownerQuotationsForBib ? nextProps.ownerQuotationsForBib.size : 0;
	      var similarTitlesCount = ownerSimilarTitlesForBib ? ownerSimilarTitlesForBib.size : 0;
	      var nextSimilarTitlesCount = nextProps.ownerSimilarTitlesForBib ? nextProps.ownerSimilarTitlesForBib.size : 0;
	
	      this.setState({
	        commentAdded: nextProps.ownerCommentForBib && !ownerCommentForBib,
	        quotationsAdded: nextQuotationsCount > quotationsCount,
	        tagsAdded: nextTagsCount > tagsCount,
	        videoAdded: nextProps.ownerVideoForBib && !ownerVideoForBib,
	        similarTitlesAdded: nextSimilarTitlesCount > similarTitlesCount,
	        privateNoteAdded: nextProps.ownerPrivateNoteForBib && !ownerPrivateNoteForBib
	      });
	    }
	  }, {
	    key: 'handleUGCFocus',
	    value: function handleUGCFocus(previouslyFocusedElement) {
	      var _this2 = this;
	
	      var _state = this.state,
	          commentAdded = _state.commentAdded,
	          quotationsAdded = _state.quotationsAdded,
	          tagsAdded = _state.tagsAdded,
	          videoAdded = _state.videoAdded,
	          similarTitlesAdded = _state.similarTitlesAdded,
	          privateNoteAdded = _state.privateNoteAdded;
	
	
	      setTimeout(function () {
	        if (commentAdded && _this2.commentInfoRef) {
	          return (0, _utilsAccessibility.setFocusWithinElement)(_this2.commentInfoRef);
	        }
	
	        if (quotationsAdded && _this2.quotationsInfoRef) {
	          return (0, _utilsAccessibility.setFocusWithinElement)(_this2.quotationsInfoRef);
	        }
	
	        if (tagsAdded && _this2.tagsInfoRef) {
	          return (0, _utilsAccessibility.setFocusWithinElement)(_this2.tagsInfoRef);
	        }
	
	        if (videoAdded && _this2.videoInfoRef) {
	          return (0, _utilsAccessibility.setFocusWithinElement)(_this2.videoInfoRef);
	        }
	
	        if (similarTitlesAdded && _this2.similarTitlesInfoRef) {
	          return (0, _utilsAccessibility.setFocusWithinElement)(_this2.similarTitlesInfoRef);
	        }
	
	        if (privateNoteAdded && _this2.privateNoteInfoRef) {
	          return (0, _utilsAccessibility.setFocusWithinElement)(_this2.privateNoteInfoRef);
	        }
	
	        return previouslyFocusedElement.focus();
	      }, 0);
	    }
	  }, {
	    key: 'renderToolbar',
	    value: function renderToolbar() {
	      var owner = this.props.owner;
	
	      if (owner.get('loggedIn') && (0, _utilsUser.allowFreeText)(owner)) {
	        return _react2.default.createElement(_Toolbar2.default, {
	          bib: this.props.bib,
	          item: this.props.item,
	          owner: this.props.owner,
	          currentLibrary: this.props.currentLibrary,
	          localBranch: this.props.localBranch,
	          ownerCommentForBib: this.props.ownerCommentForBib,
	          ownerTagsForBib: this.props.ownerTagsForBib,
	          ownerVideoForBib: this.props.ownerVideoForBib,
	          similarTitleBibs: this.props.similarTitleBibs,
	          ownerPrivateNoteForBib: this.props.ownerPrivateNoteForBib,
	          commentsTransactions: this.props.commentsTransactions,
	          quotationsTransactions: this.props.quotationsTransactions,
	          shelfTransactions: this.props.shelfTransactions,
	          tagsTransactions: this.props.tagsTransactions,
	          videosTransactions: this.props.videosTransactions,
	          similarTitlesTransactions: this.props.similarTitlesTransactions,
	          privateNotesTransactions: this.props.privateNotesTransactions,
	          commentsActions: this.props.commentsActions,
	          quotationsActions: this.props.quotationsActions,
	          shelfActions: this.props.shelfActions,
	          tagsActions: this.props.tagsActions,
	          videosActions: this.props.videosActions,
	          similarTitlesActions: this.props.similarTitlesActions,
	          privateNotesActions: this.props.privateNotesActions,
	          handleUGCFocus: this.handleUGCFocus });
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          bib = _props2.bib,
	          owner = _props2.owner,
	          item = _props2.item,
	          shelfName = _props2.shelfName,
	          currentLibrary = _props2.currentLibrary,
	          localBranch = _props2.localBranch,
	          ownerCommentForBib = _props2.ownerCommentForBib,
	          ownerQuotationsForBib = _props2.ownerQuotationsForBib,
	          ownerRatingForBib = _props2.ownerRatingForBib,
	          ownerTagsForBib = _props2.ownerTagsForBib,
	          ownerVideoForBib = _props2.ownerVideoForBib,
	          ownerSimilarTitlesForBib = _props2.ownerSimilarTitlesForBib,
	          ownerPrivateNoteForBib = _props2.ownerPrivateNoteForBib,
	          similarTitleBibs = _props2.similarTitleBibs,
	          commentsTransactions = _props2.commentsTransactions,
	          quotationsTransactions = _props2.quotationsTransactions,
	          ratingsTransactions = _props2.ratingsTransactions,
	          shelfTransactions = _props2.shelfTransactions,
	          tagsTransactions = _props2.tagsTransactions,
	          videosTransactions = _props2.videosTransactions,
	          similarTitlesTransactions = _props2.similarTitlesTransactions,
	          privateNotesTransactions = _props2.privateNotesTransactions,
	          commentsActions = _props2.commentsActions,
	          quotationsActions = _props2.quotationsActions,
	          ratingsActions = _props2.ratingsActions,
	          shelfActions = _props2.shelfActions,
	          tagsActions = _props2.tagsActions,
	          videosActions = _props2.videosActions,
	          similarTitlesActions = _props2.similarTitlesActions,
	          privateNotesActions = _props2.privateNotesActions;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-shelf-list-item-footer-info' },
	        _react2.default.createElement(
	          'div',
	          { className: 'ugc-info' },
	          _react2.default.createElement(_RatingsInfo2.default, {
	            owner: owner,
	            item: item,
	            shelfName: shelfName,
	            ownerRatingForBib: ownerRatingForBib,
	            ratingsTransactions: ratingsTransactions,
	            ratingsActions: ratingsActions }),
	          _react2.default.createElement(_CommentInfo2.default, {
	            bib: bib,
	            item: item,
	            owner: owner,
	            currentLibrary: currentLibrary,
	            localBranch: localBranch,
	            ownerCommentForBib: ownerCommentForBib,
	            commentsTransactions: commentsTransactions,
	            shelfTransactions: shelfTransactions,
	            commentsActions: commentsActions,
	            shelfActions: shelfActions,
	            ref: function ref(el) {
	              _this3.commentInfoRef = el;
	            } }),
	          _react2.default.createElement(_TagsInfo2.default, {
	            bib: bib,
	            owner: owner,
	            currentLibrary: currentLibrary,
	            localBranch: localBranch,
	            ownerTagsForBib: ownerTagsForBib,
	            tagsTransactions: tagsTransactions,
	            tagsActions: tagsActions,
	            ref: function ref(el) {
	              _this3.tagsInfoRef = el;
	            } }),
	          _react2.default.createElement(_QuotationsInfo2.default, {
	            bib: bib,
	            item: item,
	            owner: owner,
	            currentLibrary: currentLibrary,
	            localBranch: localBranch,
	            ownerQuotationsForBib: ownerQuotationsForBib,
	            quotationsTransactions: quotationsTransactions,
	            shelfTransactions: shelfTransactions,
	            quotationsActions: quotationsActions,
	            shelfActions: shelfActions,
	            ref: function ref(el) {
	              _this3.quotationsInfoRef = el;
	            } }),
	          _react2.default.createElement(_VideoInfo2.default, {
	            bib: bib,
	            item: item,
	            owner: owner,
	            currentLibrary: currentLibrary,
	            localBranch: localBranch,
	            ownerVideoForBib: ownerVideoForBib,
	            shelfTransactions: shelfTransactions,
	            videosActions: videosActions,
	            videosTransactions: videosTransactions,
	            shelfActions: shelfActions,
	            ref: function ref(el) {
	              _this3.videoInfoRef = el;
	            } }),
	          _react2.default.createElement(_SimilarTitlesInfo2.default, {
	            bib: bib,
	            item: item,
	            owner: owner,
	            currentLibrary: currentLibrary,
	            localBranch: localBranch,
	            similarTitleBibs: similarTitleBibs,
	            ownerSimilarTitlesForBib: ownerSimilarTitlesForBib,
	            similarTitlesActions: similarTitlesActions,
	            similarTitlesTransactions: similarTitlesTransactions,
	            shelfActions: shelfActions,
	            shelfTransactions: shelfTransactions,
	            ref: function ref(el) {
	              _this3.similarTitlesInfoRef = el;
	            } }),
	          _react2.default.createElement(_PrivateNoteInfo2.default, {
	            bib: bib,
	            item: item,
	            owner: owner,
	            currentLibrary: currentLibrary,
	            localBranch: localBranch,
	            ownerPrivateNoteForBib: ownerPrivateNoteForBib,
	            privateNotesTransactions: privateNotesTransactions,
	            shelfTransactions: shelfTransactions,
	            privateNotesActions: privateNotesActions,
	            shelfActions: shelfActions,
	            ref: function ref(el) {
	              _this3.privateNoteInfoRef = el;
	            } })
	        ),
	        this.renderToolbar()
	      );
	    }
	  }]);
	
	  return ShelfListItemFooterInfo;
	}(_baseBcReactComponent2.default);
	
	exports.default = ShelfListItemFooterInfo;
	
	
	ShelfListItemFooterInfo.propTypes = {
	  bib: _bcPropTypes.bibShape.isRequired,
	  currentLibrary: _reactImmutableProptypes2.default.map.isRequired,
	  owner: _bcPropTypes.userIdentityShape.isRequired,
	  item: _bcPropTypes.shelfItemShape.isRequired,
	  shelfName: _react.PropTypes.string.isRequired,
	  localBranch: _react.PropTypes.string,
	  ownerCommentForBib: _bcPropTypes.ugcCommentShape,
	  ownerQuotationsForBib: _reactImmutableProptypes2.default.listOf(_bcPropTypes.ugcQuotationShape),
	  ownerRatingForBib: _bcPropTypes.ugcRatingShape,
	  ownerVideoForBib: _bcPropTypes.ugcVideoShape,
	  ownerSimilarTitlesForBib: _reactImmutableProptypes2.default.listOf(_bcPropTypes.ugcSimilarTitlesShape),
	  similarTitleBibs: _reactImmutableProptypes2.default.map,
	  ownerTagsForBib: _reactImmutableProptypes2.default.listOf(_bcPropTypes.ugcTagShape),
	  ownerPrivateNoteForBib: _bcPropTypes.ugcPrivateNoteShape,
	  commentsTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  quotationsTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  ratingsTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  shelfTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  tagsTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  videosTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  similarTitlesTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  privateNotesTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  commentsActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  quotationsActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  ratingsActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  shelfActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  tagsActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  videosActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  similarTitlesActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  privateNotesActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired
	};

/***/ },
/* 2024 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FooterInfo = __webpack_require__(2023);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FooterInfo).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 2025 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ShelfListItemOptionsDropdown = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _reactIntl = __webpack_require__(3);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _reactRouter = __webpack_require__(17);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _baseDropdown = __webpack_require__(37);
	
	var _baseCheckbox = __webpack_require__(58);
	
	var _baseCheckbox2 = _interopRequireDefault(_baseCheckbox);
	
	var _baseIcons = __webpack_require__(10);
	
	var Icons = _interopRequireWildcard(_baseIcons);
	
	var _ShelfConstants = __webpack_require__(43);
	
	__webpack_require__(2631);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function renderAddToShelfButtonContent(name) {
	  var onShelf = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  return _react2.default.createElement(
	    'span',
	    { className: 'on-shelf-label' },
	    _react2.default.createElement(Icons.ShelfItem, { className: 'button-content-icon-shelfitem', width: 20, height: 19, onShelf: onShelf }),
	    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'label_shelf_' + name })
	  );
	}
	
	function getShelfOptions() {
	  return _immutable2.default.Map(_ShelfConstants.SHELF_NAMES).valueSeq().toArray().map(function (name) {
	    return {
	      label: renderAddToShelfButtonContent(name),
	      value: name
	    };
	  });
	}
	
	var ShelfListItemOptionsDropdown = exports.ShelfListItemOptionsDropdown = function (_BcReactComponent) {
	  _inherits(ShelfListItemOptionsDropdown, _BcReactComponent);
	
	  function ShelfListItemOptionsDropdown(props) {
	    _classCallCheck(this, ShelfListItemOptionsDropdown);
	
	    var _this = _possibleConstructorReturn(this, (ShelfListItemOptionsDropdown.__proto__ || Object.getPrototypeOf(ShelfListItemOptionsDropdown)).call(this, props));
	
	    _this.bindAll('renderMovableShelfOptions', 'renderOnShelfOptions', 'renderSelectedLabel', 'postSuccess', 'handleOwnershipToggle', 'handlePrivacyToggle');
	    return _this;
	  }
	
	  _createClass(ShelfListItemOptionsDropdown, [{
	    key: 'handleOwnershipToggle',
	    value: function handleOwnershipToggle(flagAsOwned) {
	      var _props = this.props,
	          currentUserShelfItem = _props.currentUserShelfItem,
	          iOwnThisActions = _props.iOwnThisActions,
	          ownerSettingForBib = _props.ownerSettingForBib;
	
	
	      if (flagAsOwned) {
	        iOwnThisActions.createIOwnThisSetting(currentUserShelfItem.get('metadataId'));
	      } else {
	        iOwnThisActions.removeIOwnThisSetting(currentUserShelfItem.get('metadataId'), ownerSettingForBib.get('id'));
	      }
	    }
	  }, {
	    key: 'handlePrivacyToggle',
	    value: function handlePrivacyToggle(status) {
	      var _props2 = this.props,
	          currentUserShelfItem = _props2.currentUserShelfItem,
	          updateShelfItem = _props2.updateShelfItem;
	
	
	      updateShelfItem({
	        shelfName: currentUserShelfItem.get('shelf'),
	        shelfItemIds: [currentUserShelfItem.get('id')],
	        metadataIds: [currentUserShelfItem.get('metadataId')],
	        privateItem: status,
	        newShelfName: currentUserShelfItem.get('shelf')
	      });
	    }
	  }, {
	    key: 'renderSelectedLabel',
	    value: function renderSelectedLabel() {
	      var _props3 = this.props,
	          owner = _props3.owner,
	          currentUserShelfItem = _props3.currentUserShelfItem;
	
	
	      if (owner.get('loggedIn')) {
	        return _react2.default.createElement(
	          'span',
	          { className: 'manage-item-label' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'manage_item' })
	        );
	      }
	
	      return renderAddToShelfButtonContent(currentUserShelfItem.get('shelf'), true);
	    }
	  }, {
	    key: 'handleShelfMove',
	    value: function handleShelfMove(newShelf) {
	      var shelfName = this.props.currentUserShelfItem.get('shelf');
	      var id = this.props.currentUserShelfItem.get('id');
	      var metadataId = this.props.currentUserShelfItem.get('metadataId');
	      var privateItem = this.props.currentUserShelfItem.get('privateItem');
	
	      this.props.updateShelfItem({
	        shelfName: shelfName,
	        privateItem: privateItem,
	        shelfItemIds: [id],
	        metadataIds: [metadataId],
	        newShelfName: newShelf,
	        postSuccess: this.postSuccess
	      });
	    }
	  }, {
	    key: 'handleRemoveFromShelf',
	    value: function handleRemoveFromShelf() {
	      var shelfName = this.props.currentUserShelfItem.get('shelf');
	      var id = this.props.currentUserShelfItem.get('id');
	      var metadataId = this.props.currentUserShelfItem.get('metadataId');
	
	      this.props.removeShelfItem({
	        shelfName: shelfName,
	        shelfItemIds: [id],
	        metadataIds: [metadataId],
	        postSuccess: this.postSuccess
	      });
	    }
	  }, {
	    key: 'postSuccess',
	    value: function postSuccess() {
	      var _props4 = this.props,
	          location = _props4.location,
	          params = _props4.params,
	          owner = _props4.owner,
	          searchUserShelf = _props4.searchUserShelf;
	
	
	      if (owner.get('loggedIn')) {
	        searchUserShelf(params.shelfName, owner.get('id'), location.query);
	      }
	    }
	  }, {
	    key: 'renderMovableShelfOptions',
	    value: function renderMovableShelfOptions() {
	      var _this2 = this;
	
	      var shelf = this.props.currentUserShelfItem.get('shelf');
	
	      return getShelfOptions().filter(function (option) {
	        return option.value !== shelf;
	      }).map(function (option) {
	        var handleShelfMove = function handleShelfMove(e) {
	          e.preventDefault();
	          _this2.handleShelfMove(option.value);
	        };
	
	        return _react2.default.createElement(
	          _baseDropdown.DropdownMenuItem,
	          { key: 'on-shelf-dropdown-item-move-' + option.value },
	          _react2.default.createElement(
	            'a',
	            { href: '#move-to-shelf', onClick: handleShelfMove },
	            option.label
	          )
	        );
	      });
	    }
	  }, {
	    key: 'renderOnShelfOptions',
	    value: function renderOnShelfOptions() {
	      var _this3 = this;
	
	      var _props5 = this.props,
	          owner = _props5.owner,
	          ownerSettingForBib = _props5.ownerSettingForBib,
	          currentUserShelfItem = _props5.currentUserShelfItem;
	
	
	      var heading = _react2.default.createElement(
	        _baseDropdown.DropdownMenuHeader,
	        { key: 'on-shelf-dropdown-header' },
	        _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'change_shelf_location' })
	      );
	
	      var handleRemoveFromShelf = function handleRemoveFromShelf(e) {
	        e.preventDefault();
	        _this3.handleRemoveFromShelf();
	      };
	
	      var deleteOption = _react2.default.createElement(
	        _baseDropdown.DropdownMenuItem,
	        { key: 'on-shelf-dropdown-delete' },
	        _react2.default.createElement(
	          'a',
	          { href: '#remove-from-shelf', className: 'shelf-delete', onClick: handleRemoveFromShelf },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_remove_from_shelves' })
	        )
	      );
	
	      var ownershipMenuItem = _react2.default.createElement(
	        _baseDropdown.DropdownMenuItem,
	        { key: 'item-settings-ownership', className: 'item-settings' },
	        _react2.default.createElement(_baseCheckbox2.default, {
	          id: 'item-settings-ownership',
	          handleChange: this.handleOwnershipToggle,
	          checked: !!ownerSettingForBib,
	          label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_i_own_this' }) })
	      );
	
	      var privacyMenuItem = _react2.default.createElement(
	        _baseDropdown.DropdownMenuItem,
	        { key: 'item-settings-privacy', className: 'item-settings' },
	        _react2.default.createElement(_baseCheckbox2.default, {
	          id: 'item-settings-privacy',
	          handleChange: this.handlePrivacyToggle,
	          checked: currentUserShelfItem.get('privateItem'),
	          label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_mark_as_private' }) })
	      );
	
	      var ownerHeading = _react2.default.createElement(
	        _baseDropdown.DropdownMenuHeader,
	        { key: 'move-to-shelf-label' },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'move_to_shelf' })
	      );
	      var deleteDivider = _react2.default.createElement(_baseDropdown.DropdownMenuDivider, { key: 'on-shelf-dropdown-delete-divider' });
	      var settingsDivider = _react2.default.createElement(_baseDropdown.DropdownMenuDivider, { key: 'on-shelf-dropdown-settings-divider' });
	
	      return [owner.get('loggedIn') ? ownerHeading : heading, this.renderMovableShelfOptions(), owner.get('loggedIn') ? deleteDivider : null, owner.get('loggedIn') ? deleteOption : null, owner.get('loggedIn') ? settingsDivider : null, owner.get('loggedIn') ? ownershipMenuItem : null, owner.get('loggedIn') ? privacyMenuItem : null];
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props6 = this.props,
	          shelfTransactions = _props6.shelfTransactions,
	          currentUserShelfItem = _props6.currentUserShelfItem,
	          iOwnThisTransactions = _props6.iOwnThisTransactions;
	
	      var metadataId = currentUserShelfItem.get('metadataId');
	      var isMoving = shelfTransactions.getIn([metadataId, 'isMoving'], false);
	      var isRemoving = shelfTransactions.getIn([metadataId, 'isRemoving'], false);
	      var isUpdatingPrivacy = shelfTransactions.getIn([metadataId, 'isUpdatingPrivacy'], false);
	      var isUpdatingOwnership = iOwnThisTransactions.getIn([metadataId, 'isAdding'], false) || iOwnThisTransactions.getIn([metadataId, 'isRemoving'], false);
	      var isLoading = isMoving || isRemoving || isUpdatingPrivacy || isUpdatingOwnership;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-shelf-list-item-options-dropdown' },
	        _react2.default.createElement(
	          _baseDropdown.Dropdown,
	          {
	            isLoading: isLoading,
	            className: 'btn-default btn-block btn-on-shelf',
	            selected: this.renderSelectedLabel() },
	          this.renderOnShelfOptions()
	        )
	      );
	    }
	  }]);
	
	  return ShelfListItemOptionsDropdown;
	}(_baseBcReactComponent2.default);
	
	ShelfListItemOptionsDropdown.propTypes = {
	  currentUserShelfItem: _bcPropTypes.shelfItemShape,
	  updateShelfItem: _react.PropTypes.func.isRequired,
	  removeShelfItem: _react.PropTypes.func.isRequired,
	  searchUserShelf: _react.PropTypes.func.isRequired,
	  iOwnThisActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  shelfTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  owner: _bcPropTypes.userIdentityShape.isRequired,
	  iOwnThisTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  ownerSettingForBib: _bcPropTypes.ugcIOwnThisShape
	};
	
	exports.default = (0, _reactRouter.withRouter)(ShelfListItemOptionsDropdown);

/***/ },
/* 2026 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _OptionsDropdown = __webpack_require__(2025);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_OptionsDropdown).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 2027 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _constantsUgc = __webpack_require__(119);
	
	var _utilsUgc = __webpack_require__(121);
	
	var _DisplayHeading = __webpack_require__(184);
	
	var _DisplayHeading2 = _interopRequireDefault(_DisplayHeading);
	
	var _PrivateNoteDisplay = __webpack_require__(1984);
	
	var _PrivateNoteDisplay2 = _interopRequireDefault(_PrivateNoteDisplay);
	
	__webpack_require__(2632);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ShelfListItemPrivateNoteInfo = function (_BcReactComponent) {
	  _inherits(ShelfListItemPrivateNoteInfo, _BcReactComponent);
	
	  function ShelfListItemPrivateNoteInfo() {
	    _classCallCheck(this, ShelfListItemPrivateNoteInfo);
	
	    return _possibleConstructorReturn(this, (ShelfListItemPrivateNoteInfo.__proto__ || Object.getPrototypeOf(ShelfListItemPrivateNoteInfo)).apply(this, arguments));
	  }
	
	  _createClass(ShelfListItemPrivateNoteInfo, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          bib = _props.bib,
	          item = _props.item,
	          owner = _props.owner,
	          currentLibrary = _props.currentLibrary,
	          localBranch = _props.localBranch,
	          ownerPrivateNoteForBib = _props.ownerPrivateNoteForBib,
	          privateNotesTransactions = _props.privateNotesTransactions,
	          shelfTransactions = _props.shelfTransactions,
	          privateNotesActions = _props.privateNotesActions,
	          shelfActions = _props.shelfActions;
	
	
	      if (ownerPrivateNoteForBib && (0, _utilsUgc.supportsUGCContentType)(_constantsUgc.UGC_CONTENT_TYPES.PRIVATE_NOTE, currentLibrary, localBranch)) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'cp-shelf-list-item-private-note-info' },
	          _react2.default.createElement(
	            _DisplayHeading2.default,
	            null,
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ugc_private_note_display_label' })
	          ),
	          _react2.default.createElement(_PrivateNoteDisplay2.default, {
	            bib: bib,
	            shelfItem: item,
	            owner: owner,
	            privateNote: ownerPrivateNoteForBib,
	            privateNotesTransactions: privateNotesTransactions,
	            shelfTransactions: shelfTransactions,
	            privateNotesActions: privateNotesActions,
	            shelfActions: shelfActions })
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return ShelfListItemPrivateNoteInfo;
	}(_baseBcReactComponent2.default);
	
	exports.default = ShelfListItemPrivateNoteInfo;
	
	
	ShelfListItemPrivateNoteInfo.propTypes = {
	  bib: _bcPropTypes.bibShape.isRequired,
	  currentLibrary: _reactImmutableProptypes2.default.map.isRequired,
	  item: _bcPropTypes.shelfItemShape.isRequired,
	  owner: _bcPropTypes.userIdentityShape.isRequired,
	  localBranch: _react.PropTypes.string,
	  ownerPrivateNoteForBib: _bcPropTypes.ugcPrivateNoteShape,
	  privateNotesTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  shelfTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  privateNotesActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  shelfActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired
	};

/***/ },
/* 2028 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PrivateNoteInfo = __webpack_require__(2027);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PrivateNoteInfo).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 2029 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseIcons = __webpack_require__(10);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _constantsUgc = __webpack_require__(119);
	
	var _utilsUgc = __webpack_require__(121);
	
	var _DisplayHeading = __webpack_require__(184);
	
	var _DisplayHeading2 = _interopRequireDefault(_DisplayHeading);
	
	var _QuotationDisplay = __webpack_require__(1986);
	
	var _QuotationDisplay2 = _interopRequireDefault(_QuotationDisplay);
	
	var _QuotationUGCEditor = __webpack_require__(391);
	
	var _QuotationUGCEditor2 = _interopRequireDefault(_QuotationUGCEditor);
	
	var _AddButton = __webpack_require__(390);
	
	var _AddButton2 = _interopRequireDefault(_AddButton);
	
	var _baseFullScreenOverlay = __webpack_require__(45);
	
	var _baseFullScreenOverlay2 = _interopRequireDefault(_baseFullScreenOverlay);
	
	__webpack_require__(2633);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ShelfListItemQuotationsInfo = function (_BcReactComponent) {
	  _inherits(ShelfListItemQuotationsInfo, _BcReactComponent);
	
	  function ShelfListItemQuotationsInfo(props) {
	    _classCallCheck(this, ShelfListItemQuotationsInfo);
	
	    var _this = _possibleConstructorReturn(this, (ShelfListItemQuotationsInfo.__proto__ || Object.getPrototypeOf(ShelfListItemQuotationsInfo)).call(this, props));
	
	    _this.bindAll('openEditor', 'closeEditor');
	
	    _this.state = {
	      showEditor: false
	    };
	    return _this;
	  }
	
	  _createClass(ShelfListItemQuotationsInfo, [{
	    key: 'closeEditor',
	    value: function closeEditor() {
	      this.setState({ showEditor: false });
	    }
	  }, {
	    key: 'openEditor',
	    value: function openEditor() {
	      this.setState({ showEditor: true });
	    }
	  }, {
	    key: 'renderEditor',
	    value: function renderEditor() {
	      return this.state.showEditor && _react2.default.createElement(_QuotationUGCEditor2.default, {
	        bib: this.props.bib,
	        shelfItem: this.props.item,
	        quotationsTransactions: this.props.quotationsTransactions,
	        shelfTransactions: this.props.shelfTransactions,
	        quotationsActions: this.props.quotationsActions,
	        shelfActions: this.props.shelfActions,
	        handleClose: this.closeEditor });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          bib = _props.bib,
	          item = _props.item,
	          owner = _props.owner,
	          currentLibrary = _props.currentLibrary,
	          localBranch = _props.localBranch,
	          ownerQuotationsForBib = _props.ownerQuotationsForBib,
	          quotationsTransactions = _props.quotationsTransactions,
	          shelfTransactions = _props.shelfTransactions,
	          quotationsActions = _props.quotationsActions,
	          shelfActions = _props.shelfActions;
	
	
	      if (ownerQuotationsForBib && ownerQuotationsForBib.size > 0 && (0, _utilsUgc.supportsUGCContentType)(_constantsUgc.UGC_CONTENT_TYPES.QUOTATIONS, currentLibrary, localBranch)) {
	        var count = ownerQuotationsForBib.size;
	
	        return _react2.default.createElement(
	          'div',
	          { className: 'cp-shelf-list-item-quotations-info' },
	          _react2.default.createElement(
	            _DisplayHeading2.default,
	            null,
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ugc_quotations_display_label', values: { count: count } })
	          ),
	          _react2.default.createElement(_AddButton2.default, {
	            owner: owner,
	            handleClick: this.openEditor,
	            screenReaderMessage: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ada_add_quotations', values: { title: bib.getIn(['briefInfo', 'title']) } }) }),
	          _react2.default.createElement(
	            'ul',
	            { className: 'quotations-display-list' },
	            ownerQuotationsForBib.map(function (quotation) {
	              return _react2.default.createElement(
	                'li',
	                { className: 'quotation-display-item', key: 'quotation-display-' + quotation.get('id') },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'left-block' },
	                  _react2.default.createElement(_baseIcons.Quotation, null)
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'right-block' },
	                  _react2.default.createElement(_QuotationDisplay2.default, {
	                    bib: bib,
	                    shelfItem: item,
	                    owner: owner,
	                    quotation: quotation,
	                    quotationsTransactions: quotationsTransactions,
	                    shelfTransactions: shelfTransactions,
	                    quotationsActions: quotationsActions,
	                    shelfActions: shelfActions })
	                )
	              );
	            })
	          ),
	          _react2.default.createElement(
	            _baseFullScreenOverlay2.default,
	            { open: !!this.state.showEditor, handleClose: this.closeEditor },
	            this.renderEditor()
	          )
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return ShelfListItemQuotationsInfo;
	}(_baseBcReactComponent2.default);
	
	exports.default = ShelfListItemQuotationsInfo;
	
	
	ShelfListItemQuotationsInfo.propTypes = {
	  bib: _bcPropTypes.bibShape.isRequired,
	  currentLibrary: _reactImmutableProptypes2.default.map.isRequired,
	  item: _bcPropTypes.shelfItemShape.isRequired,
	  owner: _bcPropTypes.userIdentityShape.isRequired,
	  localBranch: _react.PropTypes.string,
	  ownerQuotationsForBib: _reactImmutableProptypes2.default.listOf(_bcPropTypes.ugcQuotationShape),
	  quotationsTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  shelfTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  quotationsActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  shelfActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired
	};

/***/ },
/* 2030 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _QuotationsInfo = __webpack_require__(2029);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_QuotationsInfo).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 2031 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	var _rating = __webpack_require__(141);
	
	var _rating2 = _interopRequireDefault(_rating);
	
	var _ShelfConstants = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RatingsInfo = function (_BcReactComponent) {
	  _inherits(RatingsInfo, _BcReactComponent);
	
	  function RatingsInfo(props) {
	    _classCallCheck(this, RatingsInfo);
	
	    var _this = _possibleConstructorReturn(this, (RatingsInfo.__proto__ || Object.getPrototypeOf(RatingsInfo)).call(this, props));
	
	    _this.bindAll('handleUpdateRating', 'handleRemoveRating', 'renderRating');
	    return _this;
	  }
	
	  _createClass(RatingsInfo, [{
	    key: 'handleUpdateRating',
	    value: function handleUpdateRating(rating) {
	      // updates existing rating
	      if (this.props.ownerRatingForBib) {
	        return this.props.ratingsActions.changeItemRating(this.props.item.get('metadataId'), rating);
	      }
	
	      // adds new rating
	      return this.props.ratingsActions.rateItem(this.props.item.get('metadataId'), rating);
	    }
	  }, {
	    key: 'handleRemoveRating',
	    value: function handleRemoveRating() {
	      return this.props.ratingsActions.removeItemRating(this.props.item.get('metadataId'), this.props.ownerRatingForBib.get('id'));
	    }
	  }, {
	    key: 'renderRating',
	    value: function renderRating() {
	      var _props = this.props,
	          item = _props.item,
	          owner = _props.owner,
	          ownerRatingForBib = _props.ownerRatingForBib,
	          ratingsTransactions = _props.ratingsTransactions;
	
	      var metadataId = item.get('metadataId');
	      var rating = ownerRatingForBib ? ownerRatingForBib.get('rating') : 0;
	      var isLoading = ratingsTransactions.getIn([metadataId, 'isLoading'], false);
	
	      if (owner.get('loggedIn')) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'shelf-owner-rating' },
	          _react2.default.createElement(
	            _baseScreenReaderMessage2.default,
	            null,
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'label_my_rating' })
	          ),
	          _react2.default.createElement(_rating2.default, {
	            rating: rating,
	            isLoading: isLoading,
	            id: 'shelf-owner-rating-' + metadataId,
	            handleButtonClick: this.handleUpdateRating,
	            handleRemoveClick: this.handleRemoveRating })
	        );
	      }
	
	      var username = owner.get('name');
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'shelf-public-rating' },
	        _react2.default.createElement(
	          _baseScreenReaderMessage2.default,
	          null,
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'users_rating', values: { username: username } })
	        ),
	        _react2.default.createElement(_rating2.default, {
	          readOnly: true,
	          variant: 'blue',
	          rating: rating,
	          id: 'shelf-public-rating-' + metadataId })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          shelfName = _props2.shelfName,
	          owner = _props2.owner,
	          ownerRatingForBib = _props2.ownerRatingForBib;
	
	      // Hide ratings on the `for later` shelf.
	
	      if (shelfName === _ShelfConstants.SHELF_NAMES.FOR_LATER) {
	        return null;
	      }
	
	      // Display the owner's rating and allow the owner to add/update their rating.
	      if (ownerRatingForBib || owner.get('loggedIn')) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'cp-shelf-list-item-ratings-info' },
	          this.renderRating()
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return RatingsInfo;
	}(_baseBcReactComponent2.default);
	
	exports.default = RatingsInfo;
	
	
	RatingsInfo.propTypes = {
	  owner: _bcPropTypes.userIdentityShape.isRequired,
	  item: _bcPropTypes.shelfItemShape.isRequired,
	  shelfName: _react.PropTypes.string.isRequired,
	  ownerRatingForBib: _bcPropTypes.ugcRatingShape,
	  ratingsTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  ratingsActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired
	};

/***/ },
/* 2032 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _RatingsInfo = __webpack_require__(2031);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RatingsInfo).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 2033 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ShelfListItemSecondaryInfo;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _AddToShelfButtonContainer = __webpack_require__(146);
	
	var _AddToShelfButtonContainer2 = _interopRequireDefault(_AddToShelfButtonContainer);
	
	var _ItemTransactionButtonContainer = __webpack_require__(297);
	
	var _ItemTransactionButtonContainer2 = _interopRequireDefault(_ItemTransactionButtonContainer);
	
	var _ShortFormattedDate = __webpack_require__(60);
	
	var _ShortFormattedDate2 = _interopRequireDefault(_ShortFormattedDate);
	
	var _OptionsDropdown = __webpack_require__(2026);
	
	var _OptionsDropdown2 = _interopRequireDefault(_OptionsDropdown);
	
	__webpack_require__(2634);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function renderOptionsDropdown(item, currentUserShelfItemForBib, shelfTransactions, owner, shelfActions, ownerSettingForBib, iOwnThisActions, iOwnThisTransactions) {
	  if (currentUserShelfItemForBib) {
	    return _react2.default.createElement(_OptionsDropdown2.default, {
	      currentUserShelfItem: currentUserShelfItemForBib,
	      shelfTransactions: shelfTransactions,
	      updateShelfItem: shelfActions.updateShelfItems,
	      removeShelfItem: shelfActions.removeShelfItems,
	      searchUserShelf: shelfActions.searchUserShelf,
	      ownerSettingForBib: ownerSettingForBib,
	      iOwnThisActions: iOwnThisActions,
	      iOwnThisTransactions: iOwnThisTransactions,
	      owner: owner });
	  }
	
	  return _react2.default.createElement(_AddToShelfButtonContainer2.default, { metadataId: item.get('metadataId') });
	}
	
	function ShelfListItemSecondaryInfo(_ref) {
	  var item = _ref.item,
	      currentUserShelfItemForBib = _ref.currentUserShelfItemForBib,
	      shelfTransactions = _ref.shelfTransactions,
	      owner = _ref.owner,
	      shelfActions = _ref.shelfActions,
	      ownerSettingForBib = _ref.ownerSettingForBib,
	      iOwnThisActions = _ref.iOwnThisActions,
	      iOwnThisTransactions = _ref.iOwnThisTransactions;
	
	  var formattedDate = _react2.default.createElement(_ShortFormattedDate2.default, { value: item.get('dateAdded') });
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'cp-shelf-list-item-secondary-info' },
	    _react2.default.createElement(
	      'div',
	      { className: 'shelf-add-to-shelf' },
	      renderOptionsDropdown(item, currentUserShelfItemForBib, shelfTransactions, owner, shelfActions, ownerSettingForBib, iOwnThisActions, iOwnThisTransactions)
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'shelf-item-transaction-buttons' },
	      _react2.default.createElement(_ItemTransactionButtonContainer2.default, { id: item.get('metadataId') })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'shelf-date-info' },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ada_shelf_added_on', values: { date: formattedDate } })
	    )
	  );
	}
	
	ShelfListItemSecondaryInfo.propTypes = {
	  owner: _bcPropTypes.userIdentityShape.isRequired,
	  item: _bcPropTypes.shelfItemShape.isRequired,
	  shelfActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  shelfTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  iOwnThisActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  iOwnThisTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  ownerSettingForBib: _bcPropTypes.ugcIOwnThisShape,
	  currentUserShelfItemForBib: _bcPropTypes.shelfItemShape
	};

/***/ },
/* 2034 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SecondaryInfo = __webpack_require__(2033);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SecondaryInfo).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 2035 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ShelfListItem = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _BibListItem = __webpack_require__(239);
	
	var _BibListItem2 = _interopRequireDefault(_BibListItem);
	
	var _BibBriefInfo = __webpack_require__(2020);
	
	var _BibBriefInfo2 = _interopRequireDefault(_BibBriefInfo);
	
	var _FooterInfo = __webpack_require__(2024);
	
	var _FooterInfo2 = _interopRequireDefault(_FooterInfo);
	
	var _SecondaryInfo = __webpack_require__(2034);
	
	var _SecondaryInfo2 = _interopRequireDefault(_SecondaryInfo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ShelfListItem = exports.ShelfListItem = function (_BcReactComponent) {
	  _inherits(ShelfListItem, _BcReactComponent);
	
	  function ShelfListItem(props) {
	    _classCallCheck(this, ShelfListItem);
	
	    var _this = _possibleConstructorReturn(this, (ShelfListItem.__proto__ || Object.getPrototypeOf(ShelfListItem)).call(this, props));
	
	    _this.bindAll('renderSecondaryInfo', 'renderFooterInfo', 'renderBibBrief');
	    return _this;
	  }
	
	  _createClass(ShelfListItem, [{
	    key: 'renderBibBrief',
	    value: function renderBibBrief() {
	      return _react2.default.createElement(_BibBriefInfo2.default, {
	        bib: this.props.bib,
	        item: this.props.item,
	        owner: this.props.owner,
	        currentLibrary: this.props.currentLibrary,
	        availabilityDetailActions: this.props.availabilityDetailActions });
	    }
	  }, {
	    key: 'renderSecondaryInfo',
	    value: function renderSecondaryInfo() {
	      return _react2.default.createElement(_SecondaryInfo2.default, {
	        item: this.props.item,
	        owner: this.props.owner,
	        shelfActions: this.props.shelfActions,
	        ownerSettingForBib: this.props.ownerSettingForBib,
	        shelfTransactions: this.props.shelfTransactions,
	        iOwnThisActions: this.props.iOwnThisActions,
	        iOwnThisTransactions: this.props.iOwnThisTransactions,
	        currentUserShelfItemForBib: this.props.currentUserShelfItemForBib });
	    }
	  }, {
	    key: 'renderFooterInfo',
	    value: function renderFooterInfo() {
	      return _react2.default.createElement(_FooterInfo2.default, {
	        bib: this.props.bib,
	        item: this.props.item,
	        owner: this.props.owner,
	        shelfName: this.props.shelfName,
	        currentLibrary: this.props.currentLibrary,
	        localBranch: this.props.localBranch,
	        ownerCommentForBib: this.props.ownerCommentForBib,
	        ownerQuotationsForBib: this.props.ownerQuotationsForBib,
	        ownerTagsForBib: this.props.ownerTagsForBib,
	        ownerRatingForBib: this.props.ownerRatingForBib,
	        ownerVideoForBib: this.props.ownerVideoForBib,
	        ownerSimilarTitlesForBib: this.props.ownerSimilarTitlesForBib,
	        ownerPrivateNoteForBib: this.props.ownerPrivateNoteForBib,
	        similarTitleBibs: this.props.similarTitleBibs,
	        commentsTransactions: this.props.commentsTransactions,
	        quotationsTransactions: this.props.quotationsTransactions,
	        ratingsTransactions: this.props.ratingsTransactions,
	        shelfTransactions: this.props.shelfTransactions,
	        tagsTransactions: this.props.tagsTransactions,
	        videosTransactions: this.props.videosTransactions,
	        similarTitlesTransactions: this.props.similarTitlesTransactions,
	        privateNotesTransactions: this.props.privateNotesTransactions,
	        ratingsActions: this.props.ratingsActions,
	        commentsActions: this.props.commentsActions,
	        quotationsActions: this.props.quotationsActions,
	        tagsActions: this.props.tagsActions,
	        videosActions: this.props.videosActions,
	        similarTitlesActions: this.props.similarTitlesActions,
	        shelfActions: this.props.shelfActions,
	        privateNotesActions: this.props.privateNotesActions });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var bib = this.props.bib;
	
	
	      return _react2.default.createElement(_BibListItem2.default, {
	        bib: bib.get('briefInfo'),
	        className: 'cp-shelf-list-item',
	        renderBibBrief: function renderBibBrief() {
	          return _this2.renderBibBrief();
	        },
	        renderInfo: function renderInfo() {
	          return _this2.renderSecondaryInfo();
	        },
	        renderFooterInfo: function renderFooterInfo() {
	          return _this2.renderFooterInfo();
	        } });
	    }
	  }]);
	
	  return ShelfListItem;
	}(_baseBcReactComponent2.default);
	
	ShelfListItem.propTypes = {
	  currentLibrary: _reactImmutableProptypes2.default.map.isRequired,
	  owner: _bcPropTypes.userIdentityShape.isRequired,
	  item: _bcPropTypes.shelfItemShape.isRequired,
	  bib: _bcPropTypes.bibShape.isRequired,
	  shelfName: _react.PropTypes.string.isRequired,
	  localBranch: _react.PropTypes.string,
	  currentUserShelfItemForBib: _bcPropTypes.shelfItemShape,
	  ownerCommentForBib: _bcPropTypes.ugcCommentShape,
	  ownerQuotationsForBib: _reactImmutableProptypes2.default.listOf(_bcPropTypes.ugcQuotationShape),
	  ownerRatingForBib: _bcPropTypes.ugcRatingShape,
	  ownerTagsForBib: _reactImmutableProptypes2.default.listOf(_bcPropTypes.ugcTagShape),
	  ownerVideoForBib: _bcPropTypes.ugcVideoShape,
	  ownerSimilarTitlesForBib: _reactImmutableProptypes2.default.listOf(_bcPropTypes.ugcSimilarTitlesShape),
	  ownerPrivateNoteForBib: _bcPropTypes.ugcPrivateNoteShape,
	  ownerSettingForBib: _bcPropTypes.ugcIOwnThisShape,
	  similarTitleBibs: _reactImmutableProptypes2.default.map.isRequired,
	  commentsTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  quotationsTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  ratingsTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  videosTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  iOwnThisTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  similarTitlesTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  privateNotesTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  tagsTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  shelfTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  availabilityDetailActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  commentsActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  quotationsActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  ratingsActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  tagsActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  videosActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  similarTitlesActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  iOwnThisActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  privateNotesActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  shelfActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired
	};
	
	ShelfListItem.defaultProps = {
	  bib: _immutable2.default.Map()
	};
	
	exports.default = ShelfListItem;

/***/ },
/* 2036 */
[3485, 2035],
/* 2037 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _reactIntl = __webpack_require__(3);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _constantsUgc = __webpack_require__(119);
	
	var _utilsUgc = __webpack_require__(121);
	
	var _expandable = __webpack_require__(139);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	var _SimilarTitleDisplay = __webpack_require__(1990);
	
	var _SimilarTitleDisplay2 = _interopRequireDefault(_SimilarTitleDisplay);
	
	var _SimilarTitlesUGCEditor = __webpack_require__(605);
	
	var _SimilarTitlesUGCEditor2 = _interopRequireDefault(_SimilarTitlesUGCEditor);
	
	var _DisplayHeading = __webpack_require__(184);
	
	var _DisplayHeading2 = _interopRequireDefault(_DisplayHeading);
	
	var _AddButton = __webpack_require__(390);
	
	var _AddButton2 = _interopRequireDefault(_AddButton);
	
	var _AddTitle = __webpack_require__(387);
	
	__webpack_require__(2635);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _renderExpandButtonLabel(expanded, bib) {
	  var title = bib.getIn(['briefInfo', 'title']);
	
	  if (expanded) {
	    return _react2.default.createElement(
	      'span',
	      null,
	      _react2.default.createElement(
	        _baseScreenReaderMessage2.default,
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ada_show_less_similar_titles', values: { title: title } })
	      ),
	      _react2.default.createElement(
	        'span',
	        { 'aria-hidden': true },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_show_less' })
	      )
	    );
	  }
	
	  return _react2.default.createElement(
	    'span',
	    null,
	    _react2.default.createElement(
	      _baseScreenReaderMessage2.default,
	      null,
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ada_show_more_similar_titles', values: { title: title } })
	    ),
	    _react2.default.createElement(
	      'span',
	      { 'aria-hidden': true },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_show_more' })
	    )
	  );
	}
	
	var ShelfListItemSimilarTitlesInfo = function (_BcReactComponent) {
	  _inherits(ShelfListItemSimilarTitlesInfo, _BcReactComponent);
	
	  function ShelfListItemSimilarTitlesInfo(props) {
	    _classCallCheck(this, ShelfListItemSimilarTitlesInfo);
	
	    var _this = _possibleConstructorReturn(this, (ShelfListItemSimilarTitlesInfo.__proto__ || Object.getPrototypeOf(ShelfListItemSimilarTitlesInfo)).call(this, props));
	
	    _this.bindAll('renderSimilarTitleDisplay', 'closeEditor', 'openEditor');
	    _this.state = {
	      showEditor: false
	    };
	    return _this;
	  }
	
	  _createClass(ShelfListItemSimilarTitlesInfo, [{
	    key: 'closeEditor',
	    value: function closeEditor() {
	      this.setState({ showEditor: false });
	    }
	  }, {
	    key: 'openEditor',
	    value: function openEditor() {
	      this.setState({ showEditor: true });
	    }
	  }, {
	    key: 'renderEditor',
	    value: function renderEditor() {
	      return this.state.showEditor && _react2.default.createElement(_SimilarTitlesUGCEditor2.default, {
	        bib: this.props.bib,
	        shelfItem: this.props.item,
	        similarTitleBibs: this.props.similarTitleBibs,
	        similarTitlesTransactions: this.props.similarTitlesTransactions,
	        shelfTransactions: this.props.shelfTransactions,
	        similarTitlesActions: this.props.similarTitlesActions,
	        shelfActions: this.props.shelfActions,
	        handleClose: this.closeEditor });
	    }
	  }, {
	    key: 'renderSimilarTitleDisplay',
	    value: function renderSimilarTitleDisplay(similarTitle) {
	      var _props = this.props,
	          similarTitleBibs = _props.similarTitleBibs,
	          similarTitlesActions = _props.similarTitlesActions,
	          similarTitlesTransactions = _props.similarTitlesTransactions,
	          owner = _props.owner;
	
	      return _react2.default.createElement(_SimilarTitleDisplay2.default, {
	        similarTitleBib: similarTitleBibs.get(similarTitle.get('similarMetadataId')),
	        similarTitle: similarTitle,
	        similarTitlesActions: similarTitlesActions,
	        similarTitlesTransactions: similarTitlesTransactions,
	        owner: owner });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          bib = _props2.bib,
	          ownerSimilarTitlesForBib = _props2.ownerSimilarTitlesForBib,
	          owner = _props2.owner,
	          currentLibrary = _props2.currentLibrary,
	          localBranch = _props2.localBranch;
	
	
	      if (ownerSimilarTitlesForBib && ownerSimilarTitlesForBib.size > 0 && (0, _utilsUgc.supportsUGCContentType)(_constantsUgc.UGC_CONTENT_TYPES.SIMILAR_TITLES, currentLibrary, localBranch)) {
	        var count = ownerSimilarTitlesForBib.size;
	        return _react2.default.createElement(
	          'div',
	          { className: 'cp-shelf-list-item-similar-titles-info' },
	          _react2.default.createElement(
	            _DisplayHeading2.default,
	            null,
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ugc_similar_titles_display_label', values: { count: count } })
	          ),
	          _react2.default.createElement(_AddButton2.default, {
	            owner: owner,
	            handleClick: this.openEditor,
	            screenReaderMessage: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ada_add_similar_title', values: { title: bib.getIn(['briefInfo', 'title']) } }) }),
	          _react2.default.createElement(_expandable.ExpandableList, {
	            collapseCount: 2,
	            itemClassName: 'similar-titles-bib',
	            list: ownerSimilarTitlesForBib.toList(),
	            getItemKey: function getItemKey(similarTitleBib) {
	              return similarTitleBib.get('id');
	            },
	            renderItem: this.renderSimilarTitleDisplay,
	            renderExpandButtonLabel: function renderExpandButtonLabel(expanded) {
	              return _renderExpandButtonLabel(expanded, bib);
	            } }),
	          _react2.default.createElement(
	            _AddTitle.AddTitleOverlay,
	            { open: !!this.state.showEditor, handleClose: this.closeEditor },
	            this.renderEditor()
	          )
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return ShelfListItemSimilarTitlesInfo;
	}(_baseBcReactComponent2.default);
	
	exports.default = ShelfListItemSimilarTitlesInfo;
	
	
	ShelfListItemSimilarTitlesInfo.propTypes = {
	  bib: _bcPropTypes.bibShape.isRequired,
	  ownerSimilarTitlesForBib: _reactImmutableProptypes2.default.listOf(_bcPropTypes.ugcSimilarTitlesShape),
	  similarTitleBibs: _reactImmutableProptypes2.default.map,
	  item: _bcPropTypes.shelfItemShape.isRequired,
	  owner: _bcPropTypes.userIdentityShape.isRequired,
	  currentLibrary: _reactImmutableProptypes2.default.map.isRequired,
	  localBranch: _react.PropTypes.string,
	  similarTitlesTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  similarTitlesActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  shelfTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  shelfActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired
	};

/***/ },
/* 2038 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SimilarTitlesInfo = __webpack_require__(2037);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SimilarTitlesInfo).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 2039 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ShelfListItemTagsInfo = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _QUERY_FIELDS;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _reactRouter = __webpack_require__(17);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseFullScreenOverlay = __webpack_require__(45);
	
	var _baseFullScreenOverlay2 = _interopRequireDefault(_baseFullScreenOverlay);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	var _expandable = __webpack_require__(139);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _constantsUgc = __webpack_require__(119);
	
	var _utilsUgc = __webpack_require__(121);
	
	var _TagsConstants = __webpack_require__(242);
	
	var _TagsUGCEditor = __webpack_require__(606);
	
	var _TagsUGCEditor2 = _interopRequireDefault(_TagsUGCEditor);
	
	var _AddButton = __webpack_require__(390);
	
	var _AddButton2 = _interopRequireDefault(_AddButton);
	
	var _DisplayHeading = __webpack_require__(184);
	
	var _DisplayHeading2 = _interopRequireDefault(_DisplayHeading);
	
	var _TagDisplay = __webpack_require__(602);
	
	var _TagDisplay2 = _interopRequireDefault(_TagDisplay);
	
	__webpack_require__(2636);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var QUERY_FIELDS = (_QUERY_FIELDS = {}, _defineProperty(_QUERY_FIELDS, _TagsConstants.TAG_TYPES.GENRE, 'f_TAG_GENRE'), _defineProperty(_QUERY_FIELDS, _TagsConstants.TAG_TYPES.PERSONAL, 'f_TAG_PERSONAL'), _defineProperty(_QUERY_FIELDS, _TagsConstants.TAG_TYPES.MOOD, 'f_TAG_TONE'), _defineProperty(_QUERY_FIELDS, _TagsConstants.TAG_TYPES.SUBJECT, 'f_TAG_ABOUT'), _QUERY_FIELDS);
	
	function _renderExpandButtonLabel(expanded, bib) {
	  var title = bib.getIn(['briefInfo', 'title']);
	
	  if (expanded) {
	    return _react2.default.createElement(
	      'span',
	      null,
	      _react2.default.createElement(
	        _baseScreenReaderMessage2.default,
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ada_show_less_tags', values: { title: title } })
	      ),
	      _react2.default.createElement(
	        'span',
	        { 'aria-hidden': true },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_show_less' })
	      )
	    );
	  }
	
	  return _react2.default.createElement(
	    'span',
	    null,
	    _react2.default.createElement(
	      _baseScreenReaderMessage2.default,
	      null,
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ada_show_more_tags', values: { title: title } })
	    ),
	    _react2.default.createElement(
	      'span',
	      { 'aria-hidden': true },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_show_more' })
	    )
	  );
	}
	
	var ShelfListItemTagsInfo = exports.ShelfListItemTagsInfo = function (_BcReactComponent) {
	  _inherits(ShelfListItemTagsInfo, _BcReactComponent);
	
	  function ShelfListItemTagsInfo(props) {
	    _classCallCheck(this, ShelfListItemTagsInfo);
	
	    var _this = _possibleConstructorReturn(this, (ShelfListItemTagsInfo.__proto__ || Object.getPrototypeOf(ShelfListItemTagsInfo)).call(this, props));
	
	    _this.bindAll('renderTagDisplay', 'handleTagClick', 'openEditor', 'closeEditor');
	
	    _this.state = {
	      showEditor: false
	    };
	    return _this;
	  }
	
	  _createClass(ShelfListItemTagsInfo, [{
	    key: 'openEditor',
	    value: function openEditor() {
	      this.setState({ showEditor: true });
	    }
	  }, {
	    key: 'closeEditor',
	    value: function closeEditor() {
	      this.setState({ showEditor: false });
	    }
	  }, {
	    key: 'handleTagClick',
	    value: function handleTagClick(e, tag) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      var _props = this.props,
	          location = _props.location,
	          router = _props.router;
	
	      var tagValue = tag.get('value');
	      var tagType = tag.get('type');
	
	      router.push(_extends({}, location, {
	        query: _defineProperty({}, QUERY_FIELDS[tagType], tagValue)
	      }));
	    }
	  }, {
	    key: 'renderTagDisplay',
	    value: function renderTagDisplay(tag) {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          owner = _props2.owner,
	          tagsTransactions = _props2.tagsTransactions,
	          tagsActions = _props2.tagsActions;
	
	      var tagValue = tag.get('value');
	      var tagType = tag.get('type');
	
	      return _react2.default.createElement(_TagDisplay2.default, {
	        key: tag.get('id'),
	        tag: tag,
	        owner: owner,
	        url: '?' + QUERY_FIELDS[tagType] + '=' + tagValue,
	        handleClick: function handleClick(e) {
	          return _this2.handleTagClick(e, tag);
	        },
	        tagsTransactions: tagsTransactions,
	        tagsActions: tagsActions });
	    }
	  }, {
	    key: 'renderEditor',
	    value: function renderEditor() {
	      return this.state.showEditor && _react2.default.createElement(_TagsUGCEditor2.default, {
	        bib: this.props.bib,
	        owner: this.props.owner,
	        existingTags: this.props.ownerTagsForBib,
	        tagsActions: this.props.tagsActions,
	        tagsTransactions: this.props.tagsTransactions,
	        handleClose: this.closeEditor });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          bib = _props3.bib,
	          owner = _props3.owner,
	          currentLibrary = _props3.currentLibrary,
	          localBranch = _props3.localBranch,
	          ownerTagsForBib = _props3.ownerTagsForBib;
	
	
	      if (ownerTagsForBib && ownerTagsForBib.size > 0 && (0, _utilsUgc.supportsUGCContentType)(_constantsUgc.UGC_CONTENT_TYPES.TAGS, currentLibrary, localBranch)) {
	        var count = ownerTagsForBib.size;
	
	        return _react2.default.createElement(
	          'div',
	          { className: 'cp-shelf-list-item-tags-info' },
	          _react2.default.createElement(
	            _DisplayHeading2.default,
	            null,
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ugc_tags_display_label', values: { count: count } })
	          ),
	          _react2.default.createElement(_expandable.ExpandableList, {
	            collapseCount: 5,
	            itemClassName: 'shelf-tag-pill',
	            list: ownerTagsForBib,
	            getItemKey: function getItemKey(tag) {
	              return tag.get('id');
	            },
	            renderItem: this.renderTagDisplay,
	            renderExpandButtonLabel: function renderExpandButtonLabel(expanded) {
	              return _renderExpandButtonLabel(expanded, bib);
	            } }),
	          _react2.default.createElement(_AddButton2.default, {
	            owner: owner,
	            handleClick: this.openEditor,
	            screenReaderMessage: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ada_add_tags', values: { title: bib.getIn(['briefInfo', 'title']) } }) }),
	          _react2.default.createElement(
	            _baseFullScreenOverlay2.default,
	            { open: !!this.state.showEditor, handleClose: this.closeEditor },
	            this.renderEditor()
	          )
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return ShelfListItemTagsInfo;
	}(_baseBcReactComponent2.default);
	
	ShelfListItemTagsInfo.propTypes = {
	  bib: _bcPropTypes.bibShape.isRequired,
	  currentLibrary: _reactImmutableProptypes2.default.map.isRequired,
	  owner: _bcPropTypes.userIdentityShape.isRequired,
	  localBranch: _react.PropTypes.string,
	  ownerTagsForBib: _reactImmutableProptypes2.default.listOf(_bcPropTypes.ugcTagShape),
	  tagsTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  tagsActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired
	};
	
	exports.default = (0, _reactRouter.withRouter)(ShelfListItemTagsInfo, { withRef: true });

/***/ },
/* 2040 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TagsInfo = __webpack_require__(2039);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TagsInfo).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 2041 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _baseButtons = __webpack_require__(12);
	
	var _baseFullScreenOverlay = __webpack_require__(45);
	
	var _baseFullScreenOverlay2 = _interopRequireDefault(_baseFullScreenOverlay);
	
	var _baseIcons = __webpack_require__(10);
	
	var _baseDropdown = __webpack_require__(37);
	
	var _baseScreenReaderMessage = __webpack_require__(13);
	
	var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);
	
	var _constantsUgc = __webpack_require__(119);
	
	var _utilsUgc = __webpack_require__(121);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _SimilarTitlesUGCEditor = __webpack_require__(605);
	
	var _SimilarTitlesUGCEditor2 = _interopRequireDefault(_SimilarTitlesUGCEditor);
	
	var _CommentUGCEditor = __webpack_require__(603);
	
	var _CommentUGCEditor2 = _interopRequireDefault(_CommentUGCEditor);
	
	var _QuotationUGCEditor = __webpack_require__(391);
	
	var _QuotationUGCEditor2 = _interopRequireDefault(_QuotationUGCEditor);
	
	var _TagsUGCEditor = __webpack_require__(606);
	
	var _TagsUGCEditor2 = _interopRequireDefault(_TagsUGCEditor);
	
	var _VideoUGCEditor = __webpack_require__(607);
	
	var _VideoUGCEditor2 = _interopRequireDefault(_VideoUGCEditor);
	
	var _PrivateNoteUGCEditor = __webpack_require__(604);
	
	var _PrivateNoteUGCEditor2 = _interopRequireDefault(_PrivateNoteUGCEditor);
	
	var _AddTitle = __webpack_require__(387);
	
	__webpack_require__(2637);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ShelfListItemToolbar = function (_BcReactComponent) {
	  _inherits(ShelfListItemToolbar, _BcReactComponent);
	
	  function ShelfListItemToolbar(props) {
	    _classCallCheck(this, ShelfListItemToolbar);
	
	    var _this = _possibleConstructorReturn(this, (ShelfListItemToolbar.__proto__ || Object.getPrototypeOf(ShelfListItemToolbar)).call(this, props));
	
	    _this.bindAll('openUGCEditor', 'closeUGCEditor');
	
	    _this.state = {
	      ugcContentType: null
	    };
	    return _this;
	  }
	
	  _createClass(ShelfListItemToolbar, [{
	    key: 'openUGCEditor',
	    value: function openUGCEditor(ugcContentType) {
	      this.setState({ ugcContentType: ugcContentType });
	    }
	  }, {
	    key: 'closeUGCEditor',
	    value: function closeUGCEditor() {
	      this.setState({ ugcContentType: null });
	    }
	  }, {
	    key: 'supportsUGCContentType',
	    value: function supportsUGCContentType(type) {
	      return (0, _utilsUgc.supportsUGCContentType)(type, this.props.currentLibrary, this.props.localBranch);
	    }
	  }, {
	    key: 'renderCommentButton',
	    value: function renderCommentButton() {
	      var _this2 = this;
	
	      if (this.props.ownerCommentForBib || !this.supportsUGCContentType(_constantsUgc.UGC_CONTENT_TYPES.COMMENT)) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        _baseButtons.TextButton,
	        { className: 'shelf-ugc-comment-button', handleClick: function handleClick() {
	            return _this2.openUGCEditor(_constantsUgc.UGC_CONTENT_TYPES.COMMENT);
	          } },
	        _react2.default.createElement(
	          'span',
	          { 'aria-hidden': true },
	          _react2.default.createElement(_baseIcons.Comment, { className: 'shelf-ugc-icon' }),
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ugc_toolbar_comment_btn_label' })
	        ),
	        _react2.default.createElement(
	          _baseScreenReaderMessage2.default,
	          null,
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ada_add_comment', values: { title: this.props.bib.getIn(['briefInfo', 'title']) } })
	        )
	      );
	    }
	  }, {
	    key: 'renderTagsButton',
	    value: function renderTagsButton() {
	      var _this3 = this;
	
	      if (!this.supportsUGCContentType(_constantsUgc.UGC_CONTENT_TYPES.TAGS)) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        _baseButtons.TextButton,
	        { className: 'shelf-ugc-tags-button', handleClick: function handleClick() {
	            return _this3.openUGCEditor(_constantsUgc.UGC_CONTENT_TYPES.TAGS);
	          } },
	        _react2.default.createElement(
	          'span',
	          { 'aria-hidden': true },
	          _react2.default.createElement(_baseIcons.Tag, { color: 'currentColor', className: 'shelf-ugc-icon' }),
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ugc_toolbar_tags_btn_label' })
	        ),
	        _react2.default.createElement(
	          _baseScreenReaderMessage2.default,
	          null,
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ada_add_tags', values: { title: this.props.bib.getIn(['briefInfo', 'title']) } })
	        )
	      );
	    }
	  }, {
	    key: 'renderQuotationButton',
	    value: function renderQuotationButton() {
	      var _this4 = this;
	
	      if (!this.supportsUGCContentType(_constantsUgc.UGC_CONTENT_TYPES.QUOTATIONS)) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        _baseButtons.TextButton,
	        { className: 'shelf-ugc-quotation-button', handleClick: function handleClick() {
	            return _this4.openUGCEditor(_constantsUgc.UGC_CONTENT_TYPES.QUOTATIONS);
	          } },
	        _react2.default.createElement(
	          'span',
	          { 'aria-hidden': true },
	          _react2.default.createElement(_baseIcons.Quotation, { className: 'shelf-ugc-icon' }),
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ugc_toolbar_quotations_btn_label' })
	        ),
	        _react2.default.createElement(
	          _baseScreenReaderMessage2.default,
	          null,
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ada_add_quotations', values: { title: this.props.bib.getIn(['briefInfo', 'title']) } })
	        )
	      );
	    }
	  }, {
	    key: 'renderVideoButton',
	    value: function renderVideoButton() {
	      var _this5 = this;
	
	      if (this.props.ownerVideoForBib || !this.supportsUGCContentType(_constantsUgc.UGC_CONTENT_TYPES.VIDEO)) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        _baseButtons.TextButton,
	        { className: 'shelf-ugc-video-button', handleClick: function handleClick() {
	            return _this5.openUGCEditor(_constantsUgc.UGC_CONTENT_TYPES.VIDEO);
	          } },
	        _react2.default.createElement(
	          'span',
	          { 'aria-hidden': true },
	          _react2.default.createElement(_baseIcons.Video, { className: 'shelf-ugc-icon' }),
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ugc_toolbar_video_btn_label' })
	        ),
	        _react2.default.createElement(
	          _baseScreenReaderMessage2.default,
	          null,
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ada_add_video', values: { title: this.props.bib.getIn(['briefInfo', 'title']) } })
	        )
	      );
	    }
	  }, {
	    key: 'filterOption',
	    value: function filterOption(option) {
	      if (!this.supportsUGCContentType(option)) {
	        return false;
	      }
	
	      switch (option) {
	        case _constantsUgc.UGC_CONTENT_TYPES.VIDEO:
	          return !this.props.ownerVideoForBib;
	        case _constantsUgc.UGC_CONTENT_TYPES.PRIVATE_NOTE:
	          return !this.props.ownerPrivateNoteForBib;
	        default:
	          return true;
	      }
	    }
	  }, {
	    key: 'renderAddMoreDropdown',
	    value: function renderAddMoreDropdown() {
	      var _this6 = this;
	
	      var renderAddMoreButton = function renderAddMoreButton() {
	        return _react2.default.createElement(
	          'span',
	          { className: 'shelf-ugc-add-more-button' },
	          _react2.default.createElement(
	            'span',
	            { 'aria-hidden': true },
	            _react2.default.createElement(_baseIcons.Plus, { className: 'shelf-ugc-icon' }),
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ugc_toolbar_more_dropdown_label' }),
	            _react2.default.createElement(_baseIcons.Arrows.medium.Down, { className: 'selected-icon extra-small' })
	          ),
	          _react2.default.createElement(
	            _baseScreenReaderMessage2.default,
	            null,
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ada_add_more_ugc', values: { title: _this6.props.bib.getIn(['briefInfo', 'title']) } })
	          )
	        );
	      };
	
	      var options = [_constantsUgc.UGC_CONTENT_TYPES.VIDEO, _constantsUgc.UGC_CONTENT_TYPES.SIMILAR_TITLES, _constantsUgc.UGC_CONTENT_TYPES.PRIVATE_NOTE
	      // UGC_CONTENT_TYPES.SUMMARY,
	      // UGC_CONTENT_TYPES.AGE_SUITABILITY,
	      // UGC_CONTENT_TYPES.CONTENT_ADVISORIES,
	      ].filter(function (option) {
	        return _this6.filterOption(option);
	      }).map(function (type) {
	        return {
	          value: type,
	          label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ugc_' + type })
	        };
	      });
	
	      return _react2.default.createElement(_baseDropdown.Dropdown, {
	        disableMobile: true,
	        className: 'shelf-ugc-add-more-dropdown',
	        ButtonTag: _baseButtons.TextButton,
	        options: options,
	        handleSelect: this.openUGCEditor,
	        renderSelected: renderAddMoreButton });
	    }
	  }, {
	    key: 'renderUGCEditor',
	    value: function renderUGCEditor() {
	      switch (this.state.ugcContentType) {
	        case _constantsUgc.UGC_CONTENT_TYPES.TAGS:
	          {
	            return _react2.default.createElement(_TagsUGCEditor2.default, {
	              bib: this.props.bib,
	              owner: this.props.owner,
	              existingTags: this.props.ownerTagsForBib,
	              tagsActions: this.props.tagsActions,
	              tagsTransactions: this.props.tagsTransactions,
	              handleClose: this.closeUGCEditor });
	          }
	
	        case _constantsUgc.UGC_CONTENT_TYPES.COMMENT:
	          {
	            return _react2.default.createElement(_CommentUGCEditor2.default, {
	              bib: this.props.bib,
	              shelfItem: this.props.item,
	              handleClose: this.closeUGCEditor,
	              commentsTransactions: this.props.commentsTransactions,
	              shelfTransactions: this.props.shelfTransactions,
	              commentsActions: this.props.commentsActions,
	              shelfActions: this.props.shelfActions });
	          }
	
	        case _constantsUgc.UGC_CONTENT_TYPES.QUOTATIONS:
	          {
	            return _react2.default.createElement(_QuotationUGCEditor2.default, {
	              bib: this.props.bib,
	              shelfItem: this.props.item,
	              handleClose: this.closeUGCEditor,
	              quotationsTransactions: this.props.quotationsTransactions,
	              shelfTransactions: this.props.shelfTransactions,
	              quotationsActions: this.props.quotationsActions,
	              shelfActions: this.props.shelfActions });
	          }
	
	        case _constantsUgc.UGC_CONTENT_TYPES.VIDEO:
	          {
	            return _react2.default.createElement(_VideoUGCEditor2.default, {
	              bib: this.props.bib,
	              shelfItem: this.props.item,
	              handleClose: this.closeUGCEditor,
	              videosTransactions: this.props.videosTransactions,
	              shelfTransactions: this.props.shelfTransactions,
	              videosActions: this.props.videosActions,
	              shelfActions: this.props.shelfActions });
	          }
	
	        case _constantsUgc.UGC_CONTENT_TYPES.PRIVATE_NOTE:
	          {
	            return _react2.default.createElement(_PrivateNoteUGCEditor2.default, {
	              bib: this.props.bib,
	              shelfItem: this.props.item,
	              handleClose: this.closeUGCEditor,
	              privateNotesTransactions: this.props.privateNotesTransactions,
	              shelfTransactions: this.props.shelfTransactions,
	              privateNotesActions: this.props.privateNotesActions,
	              shelfActions: this.props.shelfActions });
	          }
	
	        default:
	          return null;
	      }
	    }
	  }, {
	    key: 'renderSimilarTitlesUGCEditor',
	    value: function renderSimilarTitlesUGCEditor() {
	      if (this.state.ugcContentType === _constantsUgc.UGC_CONTENT_TYPES.SIMILAR_TITLES) {
	        return _react2.default.createElement(_SimilarTitlesUGCEditor2.default, {
	          bib: this.props.bib,
	          shelfItem: this.props.item,
	          similarTitleBibs: this.props.similarTitleBibs,
	          similarTitlesTransactions: this.props.similarTitlesTransactions,
	          shelfTransactions: this.props.shelfTransactions,
	          similarTitlesActions: this.props.similarTitlesActions,
	          shelfActions: this.props.shelfActions,
	          handleClose: this.closeUGCEditor });
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-shelf-list-item-toolbar' },
	        _react2.default.createElement(
	          'div',
	          { className: 'ugc-toolbar' },
	          _react2.default.createElement(
	            'span',
	            { className: 'add-label' },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ugc_toolbar_add_label' })
	          ),
	          this.renderCommentButton(),
	          this.renderTagsButton(),
	          this.renderQuotationButton(),
	          this.renderAddMoreDropdown()
	        ),
	        _react2.default.createElement(
	          _AddTitle.AddTitleOverlay,
	          {
	            open: this.state.ugcContentType === _constantsUgc.UGC_CONTENT_TYPES.SIMILAR_TITLES,
	            handleClose: this.closeUGCEditor,
	            handleFocusOnRestore: this.props.handleUGCFocus },
	          this.renderSimilarTitlesUGCEditor()
	        ),
	        _react2.default.createElement(
	          _baseFullScreenOverlay2.default,
	          {
	            open: !!this.state.ugcContentType && this.state.ugcContentType !== _constantsUgc.UGC_CONTENT_TYPES.SIMILAR_TITLES,
	            handleClose: this.closeUGCEditor,
	            handleFocusOnRestore: this.props.handleUGCFocus },
	          this.renderUGCEditor()
	        )
	      );
	    }
	  }]);
	
	  return ShelfListItemToolbar;
	}(_baseBcReactComponent2.default);
	
	exports.default = ShelfListItemToolbar;
	
	
	ShelfListItemToolbar.propTypes = {
	  bib: _bcPropTypes.bibShape.isRequired,
	  currentLibrary: _reactImmutableProptypes2.default.map.isRequired,
	  item: _bcPropTypes.shelfItemShape.isRequired,
	  owner: _bcPropTypes.userIdentityShape.isRequired,
	  localBranch: _react.PropTypes.string,
	  ownerCommentForBib: _bcPropTypes.ugcCommentShape,
	  ownerTagsForBib: _reactImmutableProptypes2.default.listOf(_bcPropTypes.ugcTagShape),
	  ownerVideoForBib: _bcPropTypes.ugcVideoShape,
	  ownerPrivateNoteForBib: _bcPropTypes.ugcPrivateNoteShape,
	  similarTitleBibs: _reactImmutableProptypes2.default.map,
	  quotationsTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  commentsTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  shelfTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  tagsTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  videosTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  similarTitlesTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  privateNotesTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  commentsActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  quotationsActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  shelfActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  tagsActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  videosActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  similarTitlesActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  privateNotesActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  handleUGCFocus: _react.PropTypes.func.isRequired
	};

/***/ },
/* 2042 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Toolbar = __webpack_require__(2041);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Toolbar).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 2043 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _constantsUgc = __webpack_require__(119);
	
	var _utilsUgc = __webpack_require__(121);
	
	var _VideoDisplay = __webpack_require__(2001);
	
	var _VideoDisplay2 = _interopRequireDefault(_VideoDisplay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ShelfListItemVideoInfo = function (_BcReactComponent) {
	  _inherits(ShelfListItemVideoInfo, _BcReactComponent);
	
	  function ShelfListItemVideoInfo() {
	    _classCallCheck(this, ShelfListItemVideoInfo);
	
	    return _possibleConstructorReturn(this, (ShelfListItemVideoInfo.__proto__ || Object.getPrototypeOf(ShelfListItemVideoInfo)).apply(this, arguments));
	  }
	
	  _createClass(ShelfListItemVideoInfo, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          bib = _props.bib,
	          item = _props.item,
	          owner = _props.owner,
	          currentLibrary = _props.currentLibrary,
	          localBranch = _props.localBranch,
	          ownerVideoForBib = _props.ownerVideoForBib,
	          videosTransactions = _props.videosTransactions,
	          shelfTransactions = _props.shelfTransactions,
	          videosActions = _props.videosActions,
	          shelfActions = _props.shelfActions;
	
	
	      if (ownerVideoForBib && (0, _utilsUgc.supportsUGCContentType)(_constantsUgc.UGC_CONTENT_TYPES.VIDEO, currentLibrary, localBranch)) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'cp-shelf-list-item-video-info' },
	          _react2.default.createElement(_VideoDisplay2.default, {
	            bib: bib,
	            shelfItem: item,
	            video: ownerVideoForBib,
	            owner: owner,
	            videosTransactions: videosTransactions,
	            shelfTransactions: shelfTransactions,
	            videosActions: videosActions,
	            shelfActions: shelfActions })
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return ShelfListItemVideoInfo;
	}(_baseBcReactComponent2.default);
	
	exports.default = ShelfListItemVideoInfo;
	
	
	ShelfListItemVideoInfo.propTypes = {
	  bib: _bcPropTypes.bibShape.isRequired,
	  currentLibrary: _reactImmutableProptypes2.default.map.isRequired,
	  item: _bcPropTypes.shelfItemShape.isRequired,
	  owner: _bcPropTypes.userIdentityShape.isRequired,
	  ownerVideoForBib: _bcPropTypes.ugcVideoShape,
	  videosTransactions: _reactImmutableProptypes2.default.map,
	  videosActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  shelfTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  shelfActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired
	};

/***/ },
/* 2044 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _VideoInfo = __webpack_require__(2043);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_VideoInfo).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 2045 */
[3485, 2036],
/* 2046 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ShelfPrintList = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(17);
	
	var _reactIntl = __webpack_require__(3);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _print = __webpack_require__(120);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _rating = __webpack_require__(141);
	
	var _rating2 = _interopRequireDefault(_rating);
	
	__webpack_require__(2638);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function formatWithRatingsElement(results) {
	  return results.map(function (item) {
	    return item.get('currentUserRating') !== undefined ? item.set('currentUserRating', _react2.default.createElement(
	      'div',
	      { className: 'shelf-owner-rating' },
	      _react2.default.createElement(_rating2.default, {
	        id: 'shelf-owner-rating-' + item.get('metadataId'),
	        type: 'blue',
	        readOnly: true,
	        rating: item.get('currentUserRating') })
	    )) : item.set('currentUserRating', null);
	  });
	}
	
	var ShelfPrintList = exports.ShelfPrintList = function (_BcReactComponent) {
	  _inherits(ShelfPrintList, _BcReactComponent);
	
	  function ShelfPrintList(props) {
	    _classCallCheck(this, ShelfPrintList);
	
	    var _this = _possibleConstructorReturn(this, (ShelfPrintList.__proto__ || Object.getPrototypeOf(ShelfPrintList)).call(this, props));
	
	    _this.bindAll('handleUpdatePage');
	    return _this;
	  }
	
	  _createClass(ShelfPrintList, [{
	    key: 'handleUpdatePage',
	    value: function handleUpdatePage() {
	      var newPage = this.props.pagination.get('page') + 1;
	      this.props.router.push(this.getHrefForPage(newPage));
	    }
	  }, {
	    key: 'getHrefForPage',
	    value: function getHrefForPage(page) {
	      var _props$router = this.props.router,
	          createHref = _props$router.createHref,
	          location = _props$router.location;
	
	      return createHref(_extends({}, location, { query: _extends({}, location.query, { page: page }) }));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          pagination = _props.pagination,
	          results = _props.results,
	          isFetching = _props.isFetching,
	          username = _props.username,
	          shelfName = _props.shelfName,
	          loggedIn = _props.loggedIn;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-shelf-print-list' },
	        _react2.default.createElement(
	          _print.PrintButtonsToolbar,
	          { numItemsToPrint: results.size },
	          _react2.default.createElement(_print.PrintLoadNextButton, {
	            handleClick: this.handleUpdatePage,
	            numToLoad: pagination.get('limit'),
	            totalPages: pagination.get('pages'),
	            currentPage: pagination.get('page'),
	            isLoading: isFetching })
	        ),
	        _react2.default.createElement(
	          'h1',
	          { className: 'page-header' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'section_title_users_' + shelfName + '_shelf', values: { username: username } })
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'label_number_of_items', values: { count: pagination.get('count') } })
	        ),
	        _react2.default.createElement(_print.PrintTable, {
	          rows: formatWithRatingsElement(results),
	          fields: [{ key: 'title', type: 'item-title', headerKey: 'table_headings_title' }, { key: 'authors', type: 'item-author', headerKey: 'table_headings_author' }, { key: 'format', type: 'item-format', headerKey: 'table_headings_format', localizationMap: function localizationMap(val) {
	              return 'FORMAT.' + val.toLowerCase();
	            } }, { key: 'currentUserRating', type: 'item-rating', headerKey: 'table_headings_rating' }, { key: 'callNumber', type: 'item-call-number', headerKey: 'table_headings_call_number' }],
	          hideColumnsWithNoData: !loggedIn }),
	        _react2.default.createElement(
	          'div',
	          { className: 'page-info' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'form_label_current_page', values: { current_page: pagination.get('page') } }),
	          '\xA0',
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'form_label_total_pages', values: { total_pages: pagination.get('pages') } })
	        )
	      );
	    }
	  }]);
	
	  return ShelfPrintList;
	}(_baseBcReactComponent2.default);
	
	ShelfPrintList.propTypes = {
	  pagination: _reactImmutableProptypes2.default.map,
	  results: _reactImmutableProptypes2.default.list,
	  isFetching: _react.PropTypes.bool,
	  username: _reactImmutableProptypes2.default.string,
	  shelfName: _reactImmutableProptypes2.default.string,
	  router: _reactRouter.routerShape.isRequired,
	  loggedIn: _react.PropTypes.bool
	};
	
	exports.default = (0, _reactRouter.withRouter)(ShelfPrintList);

/***/ },
/* 2047 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ShelfPrintList = __webpack_require__(2046);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ShelfPrintList).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 2048 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ShelfTitleBar;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _ShelfAddTitleButton = __webpack_require__(610);
	
	var _ShelfAddTitleButton2 = _interopRequireDefault(_ShelfAddTitleButton);
	
	__webpack_require__(2639);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ShelfTitleBar(_ref) {
	  var owner = _ref.owner,
	      shelfActions = _ref.shelfActions,
	      currentShelfName = _ref.currentShelfName,
	      currentUserShelves = _ref.currentUserShelves;
	
	  if (owner.get('loggedIn')) {
	    return _react2.default.createElement(
	      'div',
	      { className: 'cp-shelf-title-bar' },
	      _react2.default.createElement(_ShelfAddTitleButton2.default, {
	        shelfActions: shelfActions,
	        currentShelfName: currentShelfName,
	        currentUserShelves: currentUserShelves,
	        ownerId: owner.get('id') })
	    );
	  }
	
	  return null;
	}
	
	ShelfTitleBar.propTypes = {
	  owner: _reactImmutableProptypes2.default.map.isRequired,
	  shelfActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  currentShelfName: _react.PropTypes.string.isRequired,
	  currentUserShelves: _reactImmutableProptypes2.default.map.isRequired
	};

/***/ },
/* 2049 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ShelfTitleBar = __webpack_require__(2048);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ShelfTitleBar).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 2050 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ShelfUtilityBar = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _print = __webpack_require__(120);
	
	var _sortDropdown = __webpack_require__(372);
	
	var _sortDropdown2 = _interopRequireDefault(_sortDropdown);
	
	var _pagination = __webpack_require__(92);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _FacetDrawerToggle = __webpack_require__(592);
	
	var _FacetDrawerToggle2 = _interopRequireDefault(_FacetDrawerToggle);
	
	var _UtilityBar = __webpack_require__(609);
	
	var _UtilityBar2 = _interopRequireDefault(_UtilityBar);
	
	__webpack_require__(2640);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ShelfUtilityBar = exports.ShelfUtilityBar = function (_BcReactComponent) {
	  _inherits(ShelfUtilityBar, _BcReactComponent);
	
	  function ShelfUtilityBar() {
	    _classCallCheck(this, ShelfUtilityBar);
	
	    return _possibleConstructorReturn(this, (ShelfUtilityBar.__proto__ || Object.getPrototypeOf(ShelfUtilityBar)).apply(this, arguments));
	  }
	
	  _createClass(ShelfUtilityBar, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          activeFilters = _props.activeFilters,
	          isFetching = _props.isFetching,
	          pagination = _props.pagination,
	          printURL = _props.printURL,
	          sortFields = _props.sortFields,
	          drawerActions = _props.drawerActions;
	
	
	      var activeFilterCount = activeFilters.toList().flatten(true).count();
	
	      return _react2.default.createElement(
	        _UtilityBar2.default,
	        { className: 'cp-shelf-utility-bar' },
	        _react2.default.createElement(_FacetDrawerToggle2.default, {
	          drawerActions: drawerActions,
	          activeFilterCount: activeFilterCount }),
	        _react2.default.createElement(_sortDropdown2.default, {
	          options: sortFields }),
	        _react2.default.createElement(
	          'div',
	          { className: 'pagination-and-print' },
	          _react2.default.createElement(_pagination2.default, {
	            autoFocus: true,
	            isFetching: isFetching,
	            page: pagination.get('page'),
	            limit: pagination.get('limit'),
	            count: pagination.get('count'),
	            pages: pagination.get('pages') }),
	          _react2.default.createElement(_print.PrintButton, { url: printURL })
	        )
	      );
	    }
	  }]);
	
	  return ShelfUtilityBar;
	}(_baseBcReactComponent2.default);
	
	ShelfUtilityBar.propTypes = {
	  activeFilters: _reactImmutableProptypes2.default.map.isRequired,
	  isFetching: _react.PropTypes.bool.isRequired,
	  pagination: _reactImmutableProptypes2.default.map.isRequired,
	  printURL: _react.PropTypes.string.isRequired,
	  sortFields: _reactImmutableProptypes2.default.list,
	  drawerActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired
	};
	
	exports.default = ShelfUtilityBar;

/***/ },
/* 2051 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ShelfUtilityBar = __webpack_require__(2050);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ShelfUtilityBar).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 2052 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _utilsFormat = __webpack_require__(96);
	
	var _utilsLink = __webpack_require__(97);
	
	var _sharedBibBrief = __webpack_require__(46);
	
	var _sharedBibBrief2 = _interopRequireDefault(_sharedBibBrief);
	
	var _sharedJacketCover = __webpack_require__(93);
	
	var _sharedJacketCover2 = _interopRequireDefault(_sharedJacketCover);
	
	var _sharedMessages = __webpack_require__(64);
	
	var _availabilityBibBlock = __webpack_require__(226);
	
	var _availabilityBibBlock2 = _interopRequireDefault(_availabilityBibBlock);
	
	var _MessagingContainer = __webpack_require__(68);
	
	var _MessagingContainer2 = _interopRequireDefault(_MessagingContainer);
	
	var _WorkflowContainer = __webpack_require__(243);
	
	var _WorkflowContainer2 = _interopRequireDefault(_WorkflowContainer);
	
	var _Messages = __webpack_require__(600);
	
	var _FormatInfoContainer = __webpack_require__(188);
	
	var _FormatInfoContainer2 = _interopRequireDefault(_FormatInfoContainer);
	
	var _AddToShelfButtonContainer = __webpack_require__(146);
	
	var _AddToShelfButtonContainer2 = _interopRequireDefault(_AddToShelfButtonContainer);
	
	var _ItemTransactionButtonContainer = __webpack_require__(297);
	
	var _ItemTransactionButtonContainer2 = _interopRequireDefault(_ItemTransactionButtonContainer);
	
	__webpack_require__(2641);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ItemWidget(_ref) {
	  var item = _ref.item,
	      availabilityDetail = _ref.availabilityDetail,
	      availabilityDetailActions = _ref.availabilityDetailActions,
	      currentUser = _ref.currentUser,
	      isWidget = _ref.isWidget;
	
	  var bibTitle = item.getIn(['briefInfo', 'title']);
	  var jacketSource = item.getIn(['briefInfo', 'jacket']);
	  var itemId = item.get('id');
	
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)('cp-item-widget', { 'is-widget': isWidget }) },
	    _react2.default.createElement(
	      'div',
	      { className: 'col-md-2 visible-md visible-lg outer-jacket' },
	      _react2.default.createElement(
	        'a',
	        { href: '/item/show/' + (0, _utilsLink.metadataIdFixer)(item.get('id')), tabIndex: '-1', 'aria-hidden': 'true', target: '_parent' },
	        _react2.default.createElement(_sharedJacketCover2.default, { src: jacketSource, format: item.getIn(['briefInfo', 'format']), alt: '', responsive: true })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'col-md-10 item-column' },
	      _react2.default.createElement(
	        'div',
	        { className: 'item-content' },
	        _react2.default.createElement(
	          'div',
	          { className: 'item-info' },
	          _react2.default.createElement(
	            'div',
	            { className: 'jacket-cover-wrap hidden-md hidden-lg' },
	            _react2.default.createElement(
	              'a',
	              { href: '/item/show/' + (0, _utilsLink.metadataIdFixer)(item.get('id')), title: bibTitle, target: '_parent' },
	              _react2.default.createElement(_sharedJacketCover2.default, { src: jacketSource, format: item.getIn(['briefInfo', 'format']), alt: bibTitle })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _sharedBibBrief2.default,
	              { bib: item.get('briefInfo'), renderAuthorsAsLink: true, renderTitleAsLink: true, titleTag: 'h3' },
	              _react2.default.createElement(
	                'div',
	                { className: 'visible-xs brief-extra-info' },
	                _react2.default.createElement(
	                  'a',
	                  {
	                    href: '/item/show/' + (0, _utilsLink.metadataIdFixer)(itemId),
	                    target: '_parent', lang: item.get('primaryLanguage'),
	                    rel: 'noopener',
	                    'data-test-id': 'item-link-' + itemId },
	                  _react2.default.createElement(_FormatInfoContainer2.default, { item: item, className: 'manifestation-item-format-info' })
	                ),
	                _react2.default.createElement(_availabilityBibBlock2.default, {
	                  bib: item,
	                  availabilityStatus: item.get('availability'),
	                  availabilityDetail: availabilityDetail,
	                  availabilityDetailActions: availabilityDetailActions })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'info' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-12 availability-status' },
	              _react2.default.createElement(
	                _WorkflowContainer2.default,
	                { id: itemId },
	                function (workflowComponent) {
	                  return workflowComponent || _react2.default.createElement(
	                    'div',
	                    { className: 'manifestation-item cp-manifestation-list-item row', key: itemId },
	                    _react2.default.createElement(
	                      _MessagingContainer2.default,
	                      { id: itemId },
	                      function (messageOptions, dispatch) {
	                        return messageOptions.message.get('type') === 'SHELF' ? _react2.default.createElement(_Messages.ShelfMessage, _extends({}, messageOptions, { dispatch: dispatch, values: messageOptions.message.get('values', _immutable2.default.Map()).merge({ title: bibTitle, username: currentUser.get('name') }) })) : _react2.default.createElement(_sharedMessages.Generic, _extends({}, messageOptions, { values: messageOptions.message.get('values', _immutable2.default.Map()).merge({ title: bibTitle }) }));
	                      }
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'manifestation-item-format-call-wrap ' + item.getIn(['availability', 'status']).toLowerCase() },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'manifestation-item-format-info-wrap' },
	                        _react2.default.createElement('span', { className: (0, _utilsFormat.getIconForFormat)(item.getIn(['briefInfo', 'format'])), 'aria-hidden': true }),
	                        _react2.default.createElement(
	                          'a',
	                          {
	                            href: '/item/show/' + (0, _utilsLink.metadataIdFixer)(itemId),
	                            target: '_parent', lang: item.get('primaryLanguage'),
	                            rel: 'noopener',
	                            'data-test-id': 'item-link-' + itemId },
	                          _react2.default.createElement(_FormatInfoContainer2.default, { item: item, className: 'manifestation-item-format-info' })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'manifestation-item-availability-block-wrap' },
	                        _react2.default.createElement(_availabilityBibBlock2.default, {
	                          bib: item,
	                          availabilityStatus: item.get('availability'),
	                          availabilityDetail: availabilityDetail,
	                          availabilityDetailActions: availabilityDetailActions })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      {
	                        className: 'manifestation-item-action-wrap toggled-open' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'add-to-shelf-wrap' },
	                        _react2.default.createElement(_AddToShelfButtonContainer2.default, { metadataId: itemId })
	                      ),
	                      _react2.default.createElement(_ItemTransactionButtonContainer2.default, { id: itemId, messagingId: itemId })
	                    )
	                  );
	                }
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	}
	
	ItemWidget.propTypes = {
	  item: _reactImmutableProptypes2.default.map,
	  availabilityDetail: _reactImmutableProptypes2.default.map,
	  currentUser: _reactImmutableProptypes2.default.map,
	  availabilityDetailActions: _react.PropTypes.objectOf(_react.PropTypes.func),
	  isWidget: _react.PropTypes.bool
	};
	
	exports.default = ItemWidget;

/***/ },
/* 2053 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ItemWidget = __webpack_require__(2052);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ItemWidget).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 2054 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utilsRedux = __webpack_require__(20);
	
	exports.default = (0, _utilsRedux.createReduxConstants)('ACCOUNT', {
	  UPDATE_SINGLE_CLICK_HOLDS_REQUEST: null,
	  UPDATE_SINGLE_CLICK_HOLDS_SUCCESS: null,
	  UPDATE_SINGLE_CLICK_HOLDS_FAILURE: null,
	  UPDATE_BORROWING_HISTORY_REQUEST: null,
	  UPDATE_BORROWING_HISTORY_SUCCESS: null,
	  UPDATE_BORROWING_HISTORY_FAILURE: null
	});

/***/ },
/* 2055 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utilsRedux = __webpack_require__(20);
	
	exports.default = (0, _utilsRedux.createReduxConstants)('SYSTEM_MESSAGES', {
	  SYSTEM_MESSAGES_REQUEST: null,
	  SYSTEM_MESSAGES_SUCCESS: null,
	  SYSTEM_MESSAGES_ERROR: null,
	
	  // UI toggle expanded state.
	  TOGGLE_SYSTEM_MESSAGE: null
	});

/***/ },
/* 2056 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utilsRedux = __webpack_require__(20);
	
	exports.default = (0, _utilsRedux.createReduxConstants)('WIDGET', {
	  FETCH_ITEM_REQUEST: null,
	  FETCH_ITEM_FAILURE: null,
	  FETCH_ITEM_SUCCESS: null
	});

/***/ },
/* 2057 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AccountRequiredRouteContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(14);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _AuthSelector = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AccountRequiredRouteContainer = exports.AccountRequiredRouteContainer = function (_BcReactComponent) {
	  _inherits(AccountRequiredRouteContainer, _BcReactComponent);
	
	  function AccountRequiredRouteContainer() {
	    _classCallCheck(this, AccountRequiredRouteContainer);
	
	    return _possibleConstructorReturn(this, (AccountRequiredRouteContainer.__proto__ || Object.getPrototypeOf(AccountRequiredRouteContainer)).apply(this, arguments));
	  }
	
	  _createClass(AccountRequiredRouteContainer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var accountPresent = this.props.accountPresent;
	
	      if (window && !accountPresent) {
	        window.location = '/user_dashboard';
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.accountPresent ? this.props.children : null;
	    }
	  }]);
	
	  return AccountRequiredRouteContainer;
	}(_baseBcReactComponent2.default);
	
	AccountRequiredRouteContainer.requiresAccount = true;
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    accountPresent: !!(0, _AuthSelector.currentAccountSelector)(state)
	  };
	};
	
	AccountRequiredRouteContainer.propTypes = {
	  children: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.arrayOf(_react2.default.PropTypes.node), _react2.default.PropTypes.node]).isRequired,
	  accountPresent: _react2.default.PropTypes.bool
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(AccountRequiredRouteContainer);

/***/ },
/* 2058 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AddedToShelfWorkflowContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(14);
	
	var _redux = __webpack_require__(18);
	
	var _RatingsActions = __webpack_require__(280);
	
	var _RatingsActions2 = _interopRequireDefault(_RatingsActions);
	
	var _ShelfActions = __webpack_require__(107);
	
	var _ShelfActions2 = _interopRequireDefault(_ShelfActions);
	
	var _ShelfSelector = __webpack_require__(75);
	
	var _RatingsSelector = __webpack_require__(246);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _ItemAddedToShelfView = __webpack_require__(1943);
	
	var _ItemAddedToShelfView2 = _interopRequireDefault(_ItemAddedToShelfView);
	
	var _ShelfConstants = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AddedToShelfWorkflowContainer = exports.AddedToShelfWorkflowContainer = function (_BcReactComponent) {
	  _inherits(AddedToShelfWorkflowContainer, _BcReactComponent);
	
	  function AddedToShelfWorkflowContainer() {
	    _classCallCheck(this, AddedToShelfWorkflowContainer);
	
	    return _possibleConstructorReturn(this, (AddedToShelfWorkflowContainer.__proto__ || Object.getPrototypeOf(AddedToShelfWorkflowContainer)).apply(this, arguments));
	  }
	
	  _createClass(AddedToShelfWorkflowContainer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          ratingsActions = _props.ratingsActions,
	          shelfItem = _props.shelfItem,
	          bib = _props.bib;
	
	      if (shelfItem.get('shelf') === _ShelfConstants.SHELF_NAMES.COMPLETED) {
	        ratingsActions.getItemRatings([bib.get('metadataId')]);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          id = _props2.id,
	          bib = _props2.bib,
	          shelfItem = _props2.shelfItem,
	          rating = _props2.rating,
	          ratingsTransactions = _props2.ratingsTransactions,
	          closeWorkflow = _props2.closeWorkflow,
	          ratingsActions = _props2.ratingsActions,
	          shelfActions = _props2.shelfActions,
	          view = _props2.view;
	
	
	      return _react2.default.createElement(_ItemAddedToShelfView2.default, {
	        workflowId: id,
	        bib: bib,
	        shelfItem: shelfItem,
	        currentUserRating: rating,
	        ratingsTransactions: ratingsTransactions,
	        handleClose: closeWorkflow,
	        rateItem: ratingsActions.rateItem,
	        changeItemRating: ratingsActions.changeItemRating,
	        removeItemRating: ratingsActions.removeItemRating,
	        updateShelfItems: shelfActions.updateShelfItems,
	        removeShelfItems: shelfActions.removeShelfItems,
	        view: view });
	    }
	  }]);
	
	  return AddedToShelfWorkflowContainer;
	}(_baseBcReactComponent2.default);
	
	AddedToShelfWorkflowContainer.propTypes = {
	  id: _react.PropTypes.string,
	  metadataId: _react.PropTypes.string,
	  bib: _reactImmutableProptypes2.default.map,
	  shelfItem: _reactImmutableProptypes2.default.map,
	  rating: _reactImmutableProptypes2.default.map,
	  ratingsTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  closeWorkflow: _react.PropTypes.func.isRequired,
	  ratingsActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  shelfActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  view: _react.PropTypes.string,
	  existsOnShelf: _react.PropTypes.bool
	};
	
	AddedToShelfWorkflowContainer.displayName = 'ItemTransactionWorkflowContainer';
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  var bib = state.getIn(['entities', 'bibs', ownProps.metadataId, 'briefInfo']);
	  var shelfItem = (0, _ShelfSelector.getShelvesForCurrentUser)(state).get(ownProps.metadataId);
	  var rating = (0, _RatingsSelector.getCurrentUserRatings)(state).get(ownProps.metadataId);
	  var ratingsTransactions = (0, _RatingsSelector.getRatingsTransactions)(state);
	
	  return {
	    bib: bib,
	    shelfItem: shelfItem,
	    rating: rating,
	    ratingsTransactions: ratingsTransactions
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    ratingsActions: (0, _redux.bindActionCreators)(_RatingsActions2.default, dispatch),
	    shelfActions: (0, _redux.bindActionCreators)(_ShelfActions2.default, dispatch)
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AddedToShelfWorkflowContainer);

/***/ },
/* 2059 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AnalyticsContainer = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _reactRedux = __webpack_require__(14);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _AnalyticsSelector = __webpack_require__(2172);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AnalyticsContainer = exports.AnalyticsContainer = function (_BcReactComponent) {
	  _inherits(AnalyticsContainer, _BcReactComponent);
	
	  function AnalyticsContainer() {
	    _classCallCheck(this, AnalyticsContainer);
	
	    return _possibleConstructorReturn(this, (AnalyticsContainer.__proto__ || Object.getPrototypeOf(AnalyticsContainer)).apply(this, arguments));
	  }
	
	  _createClass(AnalyticsContainer, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var prevDataLayer = prevProps.dataLayer;
	      var nextDataLayer = this.props.dataLayer;
	
	      // Pushes new data into the global dataLayer.
	      // Sets removed data to `undefined` in the global dataLayer.
	      if (window.dataLayer) {
	        var addedData = nextDataLayer.filter(function (val, key) {
	          return !prevDataLayer.has(key);
	        });
	        var removedData = prevDataLayer.filter(function (val, key) {
	          return !nextDataLayer.has(key);
	        });
	
	        if (removedData.size || addedData.size) {
	          window.dataLayer.push(_extends({}, addedData.toJS(), removedData.map(function () {
	            return undefined;
	          }).toJS()));
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return AnalyticsContainer;
	}(_baseBcReactComponent2.default);
	
	AnalyticsContainer.propTypes = {
	  dataLayer: _reactImmutableProptypes2.default.map
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    dataLayer: (0, _AnalyticsSelector.getDataLayer)(state)
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(AnalyticsContainer);

/***/ },
/* 2060 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(14);
	
	var _reactRouter = __webpack_require__(17);
	
	var _redux = __webpack_require__(18);
	
	var _AvailabilityDetailActions = __webpack_require__(122);
	
	var _AvailabilityDetailActions2 = _interopRequireDefault(_AvailabilityDetailActions);
	
	var _StackMapActions = __webpack_require__(562);
	
	var _StackMapActions2 = _interopRequireDefault(_StackMapActions);
	
	var _AvailabilityDetailOverlay = __webpack_require__(1902);
	
	var _AvailabilityDetailOverlay2 = _interopRequireDefault(_AvailabilityDetailOverlay);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _bcPropTypes2 = _interopRequireDefault(_bcPropTypes);
	
	var _LibrarySelector = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function mapStateToProps(state, ownProps) {
	  var availabilityDetail = state.get('availabilityDetail');
	  var library = (0, _LibrarySelector.currentLibrarySelector)(state);
	  var checkILSErrorClassification = availabilityDetail.get('errorClassification');
	
	  return {
	    items: availabilityDetail.get('items'),
	    subscriptions: availabilityDetail.get('subscriptions'),
	    marcHoldings: availabilityDetail.get('marcHoldings'),
	    isFetching: availabilityDetail.get('isFetching'),
	    stackMapSettings: library.get('stackMap'),
	    bib: state.getIn(['entities', 'bibs', ownProps.params.metadataId], _immutable2.default.Map()),
	    stackMapOpen: state.getIn(['ui', 'stackmap', 'open']),
	    standalone: ownProps.router.location.pathname === '/v2/availability/' + ownProps.params.metadataId,
	    showDueDateInCirc: library.get('showDueDateInCirc'),
	    showCollectionInCirc: library.get('showCollectionInCirc'),
	    isILSDown: typeof checkILSErrorClassification !== 'undefined' && checkILSErrorClassification.length > 0
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return _extends({
	    availabilityDetailActions: (0, _redux.bindActionCreators)(_AvailabilityDetailActions2.default, dispatch)
	  }, (0, _redux.bindActionCreators)(_StackMapActions2.default, dispatch));
	}
	
	var AvailabilityDetailsContainer = function (_React$Component) {
	  _inherits(AvailabilityDetailsContainer, _React$Component);
	
	  _createClass(AvailabilityDetailsContainer, null, [{
	    key: 'fetchInitialData',
	    value: function fetchInitialData(params, query, store) {
	      return [store.dispatch(_AvailabilityDetailActions2.default.getAvailability(params.metadataId))];
	    }
	  }]);
	
	  function AvailabilityDetailsContainer(props) {
	    _classCallCheck(this, AvailabilityDetailsContainer);
	
	    var _this = _possibleConstructorReturn(this, (AvailabilityDetailsContainer.__proto__ || Object.getPrototypeOf(AvailabilityDetailsContainer)).call(this, props));
	
	    _this.state = {
	      open: false
	    };
	    _this.handleClose = _this.handleClose.bind(_this);
	    return _this;
	  }
	
	  _createClass(AvailabilityDetailsContainer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      setTimeout(function () {
	        return _this2.setState({ open: true });
	      }, 0);
	    }
	  }, {
	    key: 'handleClose',
	    value: function handleClose() {
	      this.setState({
	        open: false
	      });
	      setTimeout(function () {
	        _reactRouter.browserHistory.goBack();
	      }, 300);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          subscriptions = _props.subscriptions,
	          marcHoldings = _props.marcHoldings,
	          items = _props.items,
	          bib = _props.bib,
	          availabilityDetailActions = _props.availabilityDetailActions,
	          isILSDown = _props.isILSDown;
	
	      return _react2.default.createElement(_AvailabilityDetailOverlay2.default, {
	        bib: bib,
	        availabilityDetailActions: availabilityDetailActions,
	        availabilityDetail: { subscriptions: subscriptions,
	          marcHoldings: marcHoldings,
	          items: items },
	        open: this.state.open,
	        disableClose: this.props.stackMapOpen || this.props.standalone,
	        handleClose: this.handleClose,
	        isFetching: this.props.isFetching,
	        openStackMap: this.props.openStackMap,
	        stackMap: this.props.stackMapSettings,
	        standalone: this.props.standalone,
	        showDueDateInCirc: this.props.showDueDateInCirc,
	        showCollectionInCirc: this.props.showCollectionInCirc,
	        isILSDown: isILSDown });
	    }
	  }]);
	
	  return AvailabilityDetailsContainer;
	}(_react2.default.Component);
	
	AvailabilityDetailsContainer.propTypes = {
	  bib: _reactImmutableProptypes2.default.map.isRequired,
	  availabilityDetailActions: _react.PropTypes.objectOf(_react.PropTypes.func.isRequired),
	  subscriptions: _reactImmutableProptypes2.default.list,
	  items: _reactImmutableProptypes2.default.listOf(_reactImmutableProptypes2.default.contains({
	    label: _react.PropTypes.string,
	    items: _reactImmutableProptypes2.default.listOf(_reactImmutableProptypes2.default.contains({
	      availability: _bcPropTypes2.default,
	      branch: _reactImmutableProptypes2.default.contains({
	        code: _react.PropTypes.string,
	        name: _react.PropTypes.string
	      }),
	      branchName: _react.PropTypes.string,
	      callNumber: _react.PropTypes.string,
	      collection: _react.PropTypes.string,
	      copy: _react.PropTypes.string,
	      dueDate: _react.PropTypes.number,
	      groupName: _react.PropTypes.string,
	      local: _react.PropTypes.bool,
	      preferred: _react.PropTypes.bool,
	      volume: _react.PropTypes.string
	    }))
	  })),
	  stackMapOpen: _react.PropTypes.bool,
	  stackMapSettings: _reactImmutableProptypes2.default.mapContains({
	    enabled: _react.PropTypes.bool,
	    branches: _reactImmutableProptypes2.default.listOf(_react.PropTypes.string),
	    domain: _react.PropTypes.string
	  }),
	  marcHoldings: _reactImmutableProptypes2.default.list,
	  isFetching: _react.PropTypes.bool,
	  openStackMap: _react.PropTypes.func,
	  standalone: _react.PropTypes.bool,
	  showDueDateInCirc: _react.PropTypes.bool,
	  showCollectionInCirc: _react.PropTypes.bool,
	  isILSDown: _react.PropTypes.bool
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AvailabilityDetailsContainer);

/***/ },
/* 2061 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _moment = __webpack_require__(9);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRedux = __webpack_require__(14);
	
	var _AnalyticsActions = __webpack_require__(1577);
	
	var _AnalyticsActions2 = _interopRequireDefault(_AnalyticsActions);
	
	var _AuthActions = __webpack_require__(378);
	
	var _AuthActions2 = _interopRequireDefault(_AuthActions);
	
	var _LibraryActions = __webpack_require__(1585);
	
	var _LibraryActions2 = _interopRequireDefault(_LibraryActions);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _utilsLocalization = __webpack_require__(233);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function mapStateToProps(state) {
	  return {
	    localization: state.get('localization').toJS(),
	    coreCdnHost: state.getIn(['app', 'coreAssets', 'cdnHost']),
	    mobileApp: state.getIn(['app', 'mobileApp'], false)
	  };
	}
	
	var BCAppContainer = function (_BcReactComponent) {
	  _inherits(BCAppContainer, _BcReactComponent);
	
	  function BCAppContainer(props) {
	    _classCallCheck(this, BCAppContainer);
	
	    var _this = _possibleConstructorReturn(this, (BCAppContainer.__proto__ || Object.getPrototypeOf(BCAppContainer)).call(this, props));
	
	    _moment2.default.locale((0, _utilsLocalization.mapLocaleForMoment)(props.localization.currentLanguage));
	    return _this;
	  }
	
	  _createClass(BCAppContainer, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        coreCdnHost: this.props.coreCdnHost,
	        mobileApp: this.props.mobileApp
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          localization = _props.localization;
	
	
	      return _react2.default.createElement(
	        _reactIntl.IntlProvider,
	        {
	          messages: localization.messages,
	          locale: localization.currentLanguage },
	        children
	      );
	    }
	  }], [{
	    key: 'fetchInitialData',
	    value: function fetchInitialData(params, query, store) {
	      return [store.dispatch(_AnalyticsActions2.default.fetchDataLayer()), store.dispatch(_LibraryActions2.default.getLibrary()), store.dispatch(_AuthActions2.default.loadUser())];
	    }
	  }]);
	
	  return BCAppContainer;
	}(_baseBcReactComponent2.default);
	
	BCAppContainer.propTypes = {
	  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node]),
	  localization: _react.PropTypes.shape({
	    messages: _react.PropTypes.objectOf(_react.PropTypes.string),
	    currentLanguage: _react.PropTypes.string
	  }),
	  coreCdnHost: _react.PropTypes.string.isRequired
	};
	
	BCAppContainer.childContextTypes = {
	  coreCdnHost: _react.PropTypes.string,
	  mobileApp: _react.PropTypes.bool
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(BCAppContainer);

/***/ },
/* 2062 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BatchCancelHoldWorkflowContainer = BatchCancelHoldWorkflowContainer;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(14);
	
	var _redux = __webpack_require__(18);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _HoldActions = __webpack_require__(143);
	
	var HoldActions = _interopRequireWildcard(_HoldActions);
	
	var _AuthSelector = __webpack_require__(21);
	
	var _HoldsSelector = __webpack_require__(127);
	
	var _ShelfSelector = __webpack_require__(75);
	
	var _ItemTransactions = __webpack_require__(291);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function BatchCancelHoldWorkflowContainer(props) {
	  return _react2.default.createElement(_ItemTransactions.BatchCancelHoldWorkflowView, {
	    handleClose: props.closeWorkflow,
	    cancelHold: props.holdActions.cancelHold,
	    accountId: props.accountId,
	    holdIds: props.holdIds,
	    messagingId: props.messagingId,
	    workflowId: props.workflowId,
	    isLoading: props.isLoading,
	    shelves: props.shelves,
	    done: props.done,
	    bibs: props.items.map(function (item) {
	      return item && item.getIn(['bib', 'briefInfo']);
	    }) });
	}
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  var items = ownProps.holdIds.reduce(function (holdsForIds, holdId) {
	    return holdsForIds.push((0, _HoldsSelector.getHoldsWithBibsById)(state).get(holdId));
	  }, _immutable2.default.List());
	
	  var isLoading = state.getIn(['ui', 'itemTransactions', ownProps.workflowId, 'isLoading']);
	  var done = !items.some(function (item) {
	    return item !== undefined;
	  });
	
	  return {
	    items: items,
	    isLoading: isLoading,
	    done: done,
	    accountId: (0, _AuthSelector.currentAccountSelector)(state).get('id'),
	    shelves: (0, _ShelfSelector.getShelvesForCurrentUser)(state)
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    holdActions: (0, _redux.bindActionCreators)(HoldActions, dispatch)
	  };
	};
	
	BatchCancelHoldWorkflowContainer.propTypes = {
	  holdIds: _react.PropTypes.arrayOf(_react.PropTypes.string),
	  items: _reactImmutableProptypes2.default.listOf(_bcPropTypes.holdItemShape),
	  workflowId: _react.PropTypes.string,
	  closeWorkflow: _react.PropTypes.func,
	  accountId: _react.PropTypes.number,
	  holdActions: _react.PropTypes.objectOf(_react.PropTypes.func),
	  messagingId: _react.PropTypes.string,
	  isLoading: _react.PropTypes.bool,
	  done: _react.PropTypes.bool,
	  shelves: _reactImmutableProptypes2.default.map
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(BatchCancelHoldWorkflowContainer);

/***/ },
/* 2063 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CheckedOutContainer = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(14);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _isEqual = __webpack_require__(162);
	
	var _isEqual2 = _interopRequireDefault(_isEqual);
	
	var _reactIntl = __webpack_require__(3);
	
	var _redux = __webpack_require__(18);
	
	var _CheckoutActions = __webpack_require__(279);
	
	var CheckoutActions = _interopRequireWildcard(_CheckoutActions);
	
	var _BorrowingActions = __webpack_require__(180);
	
	var BorrowingActions = _interopRequireWildcard(_BorrowingActions);
	
	var _ShelfActions = __webpack_require__(107);
	
	var _ShelfActions2 = _interopRequireDefault(_ShelfActions);
	
	var _RatingsActions = __webpack_require__(280);
	
	var _RatingsActions2 = _interopRequireDefault(_RatingsActions);
	
	var _RatingsSelector = __webpack_require__(246);
	
	var _AuthSelector = __webpack_require__(21);
	
	var _LibrarySelector = __webpack_require__(33);
	
	var _CheckoutSelector = __webpack_require__(191);
	
	var CheckoutSelector = _interopRequireWildcard(_CheckoutSelector);
	
	var _ShelfSelector = __webpack_require__(75);
	
	var _CheckedOut = __webpack_require__(1644);
	
	var _CheckedOut2 = _interopRequireDefault(_CheckedOut);
	
	var _WorkflowActions = __webpack_require__(123);
	
	var _WorkflowActions2 = _interopRequireDefault(_WorkflowActions);
	
	var _DocumentHeadContainer = __webpack_require__(52);
	
	var _DocumentHeadContainer2 = _interopRequireDefault(_DocumentHeadContainer);
	
	var _BasePageContainer2 = __webpack_require__(108);
	
	var _BasePageContainer3 = _interopRequireDefault(_BasePageContainer2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CheckedOutContainer = exports.CheckedOutContainer = function (_BasePageContainer) {
	  _inherits(CheckedOutContainer, _BasePageContainer);
	
	  function CheckedOutContainer() {
	    _classCallCheck(this, CheckedOutContainer);
	
	    return _possibleConstructorReturn(this, (CheckedOutContainer.__proto__ || Object.getPrototypeOf(CheckedOutContainer)).apply(this, arguments));
	  }
	
	  _createClass(CheckedOutContainer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      _get(CheckedOutContainer.prototype.__proto__ || Object.getPrototypeOf(CheckedOutContainer.prototype), 'componentDidMount', this).call(this);
	
	      var _props = this.props,
	          accountId = _props.accountId,
	          router = _props.router,
	          location = _props.location;
	
	      this.props.checkoutActions.fetchCheckouts(_extends({ accountId: accountId }, router.params, location.query));
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps) {
	      var _props2 = this.props,
	          location = _props2.location,
	          items = _props2.items;
	
	
	      var locationChanged = !(0, _isEqual2.default)(location, nextProps.location);
	      var itemsChanged = !(0, _isEqual2.default)(items, nextProps.items);
	
	      if (locationChanged || itemsChanged) {
	        this.props.checkoutActions.fetchCheckouts(_extends({
	          accountId: nextProps.accountId
	        }, nextProps.router.params, nextProps.location.query));
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var pageTitle = this.props.intl.formatMessage({ id: 'section_title_checkedout' });
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_DocumentHeadContainer2.default, { pageTitle: pageTitle }),
	        _react2.default.createElement(_CheckedOut2.default, this.props)
	      );
	    }
	  }], [{
	    key: 'fetchInitialData',
	    value: function fetchInitialData(params, query, store) {
	      var account = (0, _AuthSelector.currentAccountSelector)(store.getState());
	      var accountId = account && account.get('id');
	
	      return [store.dispatch(BorrowingActions.fetchSummaries({ accountId: accountId })), store.dispatch(CheckoutActions.fetchCheckouts(_extends({ accountId: accountId }, params, query)))];
	    }
	  }, {
	    key: 'getBackToTitleKey',
	    value: function getBackToTitleKey() {
	      return 'checkedout';
	    }
	  }]);
	
	  return CheckedOutContainer;
	}(_BasePageContainer3.default);
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  var library = (0, _LibrarySelector.currentLibrarySelector)(state);
	  var user = (0, _AuthSelector.currentUserSelector)(state);
	  var items = CheckoutSelector.getCurrentCheckouts(state, ownProps);
	  var materialTypeCounts = CheckoutSelector.getMaterialTypeCounts(state, ownProps);
	  var selectedStatus = CheckoutSelector.getSelectedStatus(state, ownProps);
	  var quotas = CheckoutSelector.getCheckedoutQuotas(state, ownProps);
	  var featuredListTypes = library.get('featuredListTypes', _immutable2.default.List());
	  var showStaffPicksLink = featuredListTypes && featuredListTypes.includes('staff_picks');
	  var presentStatuses = CheckoutSelector.getPresentStatuses(state, ownProps);
	  var accountId = (0, _AuthSelector.currentAccountSelector)(state).get('id');
	  var shelfTransactions = (0, _ShelfSelector.getShelfTransactions)(state);
	  var checkedoutStatus = CheckoutSelector.getCheckedoutStatus(state);
	  var countsByStatus = CheckoutSelector.getCountsByStatus(state);
	  var pagination = CheckoutSelector.getPagination(state, ownProps);
	  var checkoutTransactions = CheckoutSelector.getCheckoutTransactions(state);
	  var ratingsTransactions = (0, _RatingsSelector.getRatingsTransactions)(state);
	  var ratings = (0, _RatingsSelector.getRatingsByBibs)(state);
	
	  return {
	    user: user,
	    totalCount: items.size,
	    totalUnfilteredCount: selectedStatus ? countsByStatus.get(selectedStatus) : pagination.get('count', 0),
	    materialTypeCounts: materialTypeCounts,
	    items: items.take(state.getIn(['borrowing', 'checkedout', 'numItemsShowing'])),
	    selectedStatus: selectedStatus,
	    quotas: quotas,
	    showStaffPicksLink: showStaffPicksLink,
	    presentStatuses: presentStatuses,
	    accountId: accountId,
	    pagination: pagination,
	    checkoutTransactions: checkoutTransactions,
	    shelfTransactions: shelfTransactions,
	    ratingsTransactions: ratingsTransactions,
	    ratings: ratings,
	    fetching: checkedoutStatus.get('fetching', false)
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    checkoutActions: (0, _redux.bindActionCreators)(CheckoutActions, dispatch),
	    workflowActions: (0, _redux.bindActionCreators)(_WorkflowActions2.default, dispatch),
	    shelfActions: (0, _redux.bindActionCreators)(_ShelfActions2.default, dispatch),
	    ratingsActions: (0, _redux.bindActionCreators)(_RatingsActions2.default, dispatch)
	  };
	};
	
	CheckedOutContainer.propTypes = {
	  intl: _reactIntl.intlShape,
	  checkoutTransactions: _reactImmutableProptypes2.default.map,
	  shelfTransactions: _reactImmutableProptypes2.default.map,
	  ratingsTransactions: _reactImmutableProptypes2.default.map,
	  fetching: _react.PropTypes.bool
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIntl.injectIntl)(CheckedOutContainer));

/***/ },
/* 2064 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CoreHeaderContainer = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(16);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _reactRedux = __webpack_require__(14);
	
	var _reactRouter = __webpack_require__(17);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _utilsBrowser = __webpack_require__(59);
	
	var _updateSearchQuery = __webpack_require__(148);
	
	var _updateSearchQuery2 = _interopRequireDefault(_updateSearchQuery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ApiMethods = {
	  getTerm: 'getTerm',
	  setTerm: 'setTerm',
	  toggleFilterLock: 'toggleFilterLock',
	  sessionChanged: 'sessionChanged',
	  setSearchType: 'setSearchCategory',
	  getSearchType: 'getSearchCategory',
	  getSearchTarget: 'getSearchTarget',
	  setSearchTarget: 'setSearchTarget',
	  onSearch: 'onSearch'
	};
	
	var propTypes = {
	  headerTemplate: _react.PropTypes.string,
	  dispatch: _react.PropTypes.func,
	  router: _react.PropTypes.object.isRequired,
	  searchTerm: _react.PropTypes.string,
	  searchCategory: _react.PropTypes.string,
	  locked: _react.PropTypes.bool,
	  loggedIn: _react.PropTypes.bool,
	  isAdvancedSearch: _react.PropTypes.bool,
	  activeFilters: _reactImmutableProptypes2.default.map
	};
	
	var isNERFLink = function isNERFLink(e) {
	  return e.target.nodeName === 'A' && e.target.pathname.match('/v2/') && !(0, _utilsBrowser.isCurrentUrl)(e.target.href);
	};
	
	var isAdvancedSearchLink = function isAdvancedSearchLink(e) {
	  return e.target.nodeName === 'A' && e.target.search.match('custom_edit') && !(0, _utilsBrowser.isCurrentUrl)(e.target.href);
	};
	
	var CoreHeaderContainer = exports.CoreHeaderContainer = function (_BcReactComponent) {
	  _inherits(CoreHeaderContainer, _BcReactComponent);
	
	  function CoreHeaderContainer(props) {
	    _classCallCheck(this, CoreHeaderContainer);
	
	    var _this = _possibleConstructorReturn(this, (CoreHeaderContainer.__proto__ || Object.getPrototypeOf(CoreHeaderContainer)).call(this, props));
	
	    _this.bindAll('handleNERFLink', 'onSearch', 'initHeader');
	    _this.headerApi = null;
	    return _this;
	  }
	
	  _createClass(CoreHeaderContainer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.headerTemplate) {
	        this.initHeader();
	        this.updateHeaderSearchForm();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (!this.props.headerTemplate) {
	        return;
	      }
	
	      if (nextProps.loggedIn !== this.props.loggedIn) {
	        this.headerApi(ApiMethods.sessionChanged);
	      }
	      if (nextProps.locked !== this.props.locked) {
	        this.headerApi(ApiMethods.toggleFilterLock, nextProps.locked);
	      }
	
	      if (nextProps.searchTerm !== this.props.searchTerm) {
	        this.headerApi(ApiMethods.setTerm, nextProps.searchTerm);
	      }
	
	      if (nextProps.searchCategory !== this.props.searchCategory) {
	        this.headerApi(ApiMethods.setSearchType, nextProps.searchCategory);
	      }
	    }
	  }, {
	    key: 'updateHeaderSearchForm',
	    value: function updateHeaderSearchForm() {
	      if (!this.props.isAdvancedSearch) {
	        this.headerApi(ApiMethods.setTerm, this.props.searchTerm);
	        this.headerApi(ApiMethods.setSearchType, this.props.searchCategory);
	        this.headerApi(ApiMethods.toggleFilterLock, this.props.locked);
	      }
	    }
	  }, {
	    key: 'initHeader',
	    value: function initHeader() {
	      this.headerApi = window.BCHeaderPublic;
	      this.headerApi(ApiMethods.onSearch, 'catalogue', this.onSearch);
	    }
	  }, {
	    key: 'isSearchSupported',
	    value: function isSearchSupported() {
	      var searchType = this.headerApi(ApiMethods.getSearchTarget);
	      var searchCategory = this.headerApi(ApiMethods.getSearchType);
	
	      var isCatalogSearch = searchType === 'catalogue';
	      var isSupportedSearchCategory = !_lodash2.default.includes(['user', 'userlist'], searchCategory);
	      return isCatalogSearch && isSupportedSearchCategory;
	    }
	  }, {
	    key: 'isOnSearchPage',
	    value: function isOnSearchPage() {
	      return this.props.router.location.pathname === '/v2/search';
	    }
	  }, {
	    key: 'onSearch',
	    value: function onSearch() {
	      // Automatically hides keyboard on iOS
	      if (true) {
	        document.activeElement.blur();
	      }
	
	      if (this.isOnSearchPage() && this.isSearchSupported()) {
	        var _props = this.props,
	            router = _props.router,
	            activeFilters = _props.activeFilters,
	            location = _props.location,
	            locked = _props.locked;
	
	
	        var query = (0, _updateSearchQuery2.default)({
	          currentQuery: location.query,
	          activeFilters: locked && activeFilters,
	          query: this.headerApi(ApiMethods.getTerm),
	          searchType: this.headerApi(ApiMethods.getSearchType),
	          pagination_page: undefined
	        });
	
	        router.push(_extends({}, location, { query: query }));
	      } else {
	        this.headerApi('performDefaultSearch');
	      }
	    }
	  }, {
	    key: 'handleNERFLink',
	    value: function handleNERFLink(e) {
	      if (isNERFLink(e) && !isAdvancedSearchLink(e)) {
	        e.preventDefault();
	        this.props.router.push(e.target.href);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.headerTemplate) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'cp-core-external-header' },
	          _react2.default.createElement('div', { ref: 'headerWrapper', 'data-testid': 'headerWrapper', onClick: this.handleNERFLink, dangerouslySetInnerHTML: { __html: this.props.headerTemplate } })
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return CoreHeaderContainer;
	}(_baseBcReactComponent2.default);
	
	function mapStateToProps(state) {
	  return {
	    headerTemplate: state.getIn(['templates', 'header']),
	    locked: state.getIn(['search', 'catalogSearch', 'locked']),
	    searchTerm: state.getIn(['search', 'searchForm', 'searchTerm']),
	    searchCategory: state.getIn(['search', 'searchForm', 'searchType']),
	    isAdvancedSearch: state.getIn(['search', 'catalogSearch', 'searchType']) === 'bl',
	    activeFilters: state.getIn(['search', 'catalogSearch', 'activeFilters']),
	    loggedIn: !!state.getIn(['auth', 'currentUserId'])
	  };
	}
	
	CoreHeaderContainer.propTypes = propTypes;
	
	exports.default = (0, _reactRouter.withRouter)((0, _reactRedux.connect)(mapStateToProps)(CoreHeaderContainer));

/***/ },
/* 2065 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _reactRedux = __webpack_require__(14);
	
	var _redux = __webpack_require__(18);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _LibrarySelector = __webpack_require__(33);
	
	var _SearchActions = __webpack_require__(144);
	
	var _SearchActions2 = _interopRequireDefault(_SearchActions);
	
	var _EmptySearchResult = __webpack_require__(1868);
	
	var _EmptySearchResult2 = _interopRequireDefault(_EmptySearchResult);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EmptySearchResultContainer = function (_BcReactComponent) {
	  _inherits(EmptySearchResultContainer, _BcReactComponent);
	
	  function EmptySearchResultContainer() {
	    _classCallCheck(this, EmptySearchResultContainer);
	
	    return _possibleConstructorReturn(this, (EmptySearchResultContainer.__proto__ || Object.getPrototypeOf(EmptySearchResultContainer)).apply(this, arguments));
	  }
	
	  _createClass(EmptySearchResultContainer, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          query = _props.query,
	          title = _props.title,
	          titleKey = _props.titleKey,
	          activeFilters = _props.activeFilters,
	          chatWidgets = _props.chatWidgets,
	          didYouMeanQuerySuggestion = _props.didYouMeanQuerySuggestion,
	          didYouMeanResultCount = _props.didYouMeanResultCount,
	          hasStaticEmptySearchResults = _props.hasStaticEmptySearchResults,
	          broadened = _props.broadened,
	          broadenedSearchType = _props.broadenedSearchType,
	          searchType = _props.searchType,
	          showExternalSearchLink = _props.showExternalSearchLink,
	          rssURL = _props.rssURL,
	          customEdit = _props.customEdit,
	          suppress = _props.suppress,
	          orderedSearchTypes = _props.orderedSearchTypes,
	          locked = _props.locked,
	          didNotFindOptions = _props.didNotFindOptions,
	          singleBranch = _props.singleBranch;
	
	
	      return _react2.default.createElement(_EmptySearchResult2.default, {
	        query: query,
	        title: title,
	        titleKey: titleKey,
	        activeFilters: activeFilters,
	        chatWidgets: chatWidgets,
	        didYouMeanQuerySuggestion: didYouMeanQuerySuggestion,
	        didYouMeanResultCount: didYouMeanResultCount,
	        hasStaticEmptySearchResults: hasStaticEmptySearchResults,
	        broadened: broadened,
	        broadenedSearchType: broadenedSearchType,
	        searchType: searchType,
	        showExternalSearchLink: showExternalSearchLink,
	        customEdit: customEdit,
	        suppress: suppress,
	        rssURL: rssURL,
	        orderedSearchTypes: orderedSearchTypes,
	        locked: locked,
	        didNotFindOptions: didNotFindOptions,
	        singleBranch: singleBranch });
	    }
	  }]);
	
	  return EmptySearchResultContainer;
	}(_baseBcReactComponent2.default);
	
	EmptySearchResultContainer.propTypes = {
	  query: _react.PropTypes.string,
	  title: _react.PropTypes.string,
	  titleKey: _react.PropTypes.string,
	  locked: _react.PropTypes.bool,
	  activeFilters: _reactImmutableProptypes2.default.mapOf(_react.PropTypes.object).isRequired,
	  chatWidgets: _reactImmutableProptypes2.default.mapOf(_react.PropTypes.object),
	  orderedSearchTypes: _reactImmutableProptypes2.default.list,
	  didYouMeanQuerySuggestion: _react.PropTypes.string,
	  didYouMeanResultCount: _react.PropTypes.number,
	  hasStaticEmptySearchResults: _react.PropTypes.bool.isRequired,
	  searchType: _react.PropTypes.string,
	  broadened: _react.PropTypes.bool,
	  broadenedSearchType: _react.PropTypes.string,
	  rssURL: _react.PropTypes.string,
	  customEdit: _react.PropTypes.bool,
	  suppress: _react.PropTypes.bool,
	  didNotFindOptions: _reactImmutableProptypes2.default.map,
	  singleBranch: _react.PropTypes.bool
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  var catalogSearch = state.getIn(['search', 'catalogSearch']);
	  var library = (0, _LibrarySelector.currentLibrarySelector)(state);
	
	  return {
	    broadened: catalogSearch.get('broadened'),
	    broadenedSearchType: catalogSearch.get('broadenedSearchType'),
	    searchType: catalogSearch.get('searchType'),
	    locked: catalogSearch.get('locked'),
	    query: catalogSearch.get('query'),
	    title: catalogSearch.get('title'),
	    activeFilters: catalogSearch.get('activeFilters'),
	    chatWidgets: library.get('chatWidgets'),
	    didYouMeanQuerySuggestion: catalogSearch.get('didYouMeanQuerySuggestion'),
	    didYouMeanResultCount: catalogSearch.get('didYouMeanResultCount'),
	    hasStaticEmptySearchResults: !!state.getIn(['localization', 'messages', 'static_empty_search_results_page']),
	    showExternalSearchLink: library.get('showExternalSearchLink'),
	    suppress: catalogSearch.get('suppress'),
	    rssURL: catalogSearch.get('rssURL'),
	    customEdit: catalogSearch.get('custom_edit'),
	    titleKey: catalogSearch.get('title_key'),
	    orderedSearchTypes: library.get('orderedSearchTypes', _immutable2.default.List()),
	    didNotFindOptions: library.get('didNotFindOptions'),
	    singleBranch: library.get('singleBranch')
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    searchActions: (0, _redux.bindActionCreators)(_SearchActions2.default, dispatch)
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(EmptySearchResultContainer);

/***/ },
/* 2066 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRedux = __webpack_require__(14);
	
	var _baseButtons = __webpack_require__(12);
	
	var _notFound = __webpack_require__(140);
	
	var _notFound2 = _interopRequireDefault(_notFound);
	
	var _BasePageContainer2 = __webpack_require__(108);
	
	var _BasePageContainer3 = _interopRequireDefault(_BasePageContainer2);
	
	var _AppActions = __webpack_require__(377);
	
	var _AppActions2 = _interopRequireDefault(_AppActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FeatureToggleContainer = function (_BasePageContainer) {
	  _inherits(FeatureToggleContainer, _BasePageContainer);
	
	  function FeatureToggleContainer() {
	    _classCallCheck(this, FeatureToggleContainer);
	
	    return _possibleConstructorReturn(this, (FeatureToggleContainer.__proto__ || Object.getPrototypeOf(FeatureToggleContainer)).apply(this, arguments));
	  }
	
	  _createClass(FeatureToggleContainer, [{
	    key: 'renderFlags',
	    value: function renderFlags() {
	      var _props = this.props,
	          dispatch = _props.dispatch,
	          featureFlags = _props.featureFlags;
	
	      return featureFlags.sortBy(function (value, flag) {
	        return flag.toLowerCase();
	      }).map(function (value, name) {
	        return _react2.default.createElement(
	          'tr',
	          { className: (0, _classnames2.default)({ success: value }) },
	          _react2.default.createElement(
	            'td',
	            null,
	            name
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(
	              'span',
	              { className: (0, _classnames2.default)('label', { 'label-danger': !value }, { 'label-success': value }), style: { 'font-size': '1.2em' } },
	              value ? 'YES' : 'NO'
	            )
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(
	              _baseButtons.SecondaryButton,
	              { handleClick: function handleClick() {
	                  return dispatch(_AppActions2.default.updateFeatureFlag(name, !value));
	                } },
	              'Toggle'
	            )
	          )
	        );
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.props.allowsEditing) {
	        return _react2.default.createElement(_notFound2.default, null);
	      }
	
	      return _react2.default.createElement(
	        'table',
	        { className: 'table table-striped table-condensed' },
	        _react2.default.createElement(
	          'thead',
	          null,
	          _react2.default.createElement(
	            'tr',
	            null,
	            _react2.default.createElement(
	              'th',
	              { width: '50%' },
	              'Title'
	            ),
	            _react2.default.createElement(
	              'th',
	              { width: '30%' },
	              'Enabled?'
	            ),
	            _react2.default.createElement(
	              'th',
	              { width: '20%' },
	              'Action'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'tbody',
	          null,
	          this.renderFlags()
	        )
	      );
	    }
	  }]);
	
	  return FeatureToggleContainer;
	}(_BasePageContainer3.default);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    featureFlags: state.getIn(['app', 'featureFlags']),
	    allowsEditing: state.getIn(['app', 'allowFeatureFlagEditing'], false)
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(FeatureToggleContainer);

/***/ },
/* 2067 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(14);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _redux = __webpack_require__(18);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _recommendedFeaturedContent = __webpack_require__(1463);
	
	var _recommendedFeaturedContent2 = _interopRequireDefault(_recommendedFeaturedContent);
	
	var _LibrarySelector = __webpack_require__(33);
	
	var _FeaturedContentActions = __webpack_require__(1580);
	
	var _FeaturedContentActions2 = _interopRequireDefault(_FeaturedContentActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function mapStateToProps(state) {
	  var catalogSearch = state.getIn(['search', 'catalogSearch']);
	  var library = (0, _LibrarySelector.currentLibrarySelector)(state);
	  return {
	    featuredContent: catalogSearch.get('featuredContent', _immutable2.default.Map()).reduce(function (transformedFeaturedContent, contentIds, contentType) {
	      return transformedFeaturedContent.set(contentType, contentIds.map(function (id) {
	        return state.getIn(['entities', 'featuredContent', id.toString()]);
	      }));
	    }, _immutable2.default.Map()),
	    results: catalogSearch.get('results').flatten(),
	    libraryShortName: library.get('shortName')
	  };
	}
	
	var FeaturedContentContainer = function (_BcReactComponent) {
	  _inherits(FeaturedContentContainer, _BcReactComponent);
	
	  function FeaturedContentContainer(props) {
	    _classCallCheck(this, FeaturedContentContainer);
	
	    var _this = _possibleConstructorReturn(this, (FeaturedContentContainer.__proto__ || Object.getPrototypeOf(FeaturedContentContainer)).call(this, props));
	
	    _this.featuredContentActions = (0, _redux.bindActionCreators)(_FeaturedContentActions2.default, _this.props.dispatch);
	    return _this;
	  }
	
	  _createClass(FeaturedContentContainer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.results.size > 0) {
	        this.featuredContentActions.fetch(this.props.results);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.results.size > 0 && !_immutable2.default.is(this.props.results, nextProps.results)) {
	        this.featuredContentActions.fetch(nextProps.results);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_recommendedFeaturedContent2.default, {
	        libraryShortName: this.props.libraryShortName,
	        content: this.props.featuredContent });
	    }
	  }]);
	
	  return FeaturedContentContainer;
	}(_baseBcReactComponent2.default);
	
	FeaturedContentContainer.propTypes = {
	  featuredContent: _reactImmutableProptypes2.default.map,
	  libraryShortName: _react.PropTypes.string,
	  results: _reactImmutableProptypes2.default.list
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(FeaturedContentContainer);

/***/ },
/* 2068 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _reactRedux = __webpack_require__(14);
	
	var _redux = __webpack_require__(18);
	
	var _FeedbackBox = __webpack_require__(1845);
	
	var _FeedbackBox2 = _interopRequireDefault(_FeedbackBox);
	
	var _FeedbackActions = __webpack_require__(1581);
	
	var _FeedbackActions2 = _interopRequireDefault(_FeedbackActions);
	
	var _AuthSelector = __webpack_require__(21);
	
	var _LibrarySelector = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  user: _reactImmutableProptypes2.default.mapContains({
	    id: _react.PropTypes.number.isRequired
	  }),
	  enabled: _react.PropTypes.bool,
	  categories: _reactImmutableProptypes2.default.listOf(_react.PropTypes.string),
	  contactLinks: _reactImmutableProptypes2.default.mapOf(_react.PropTypes.string, _react.PropTypes.string),
	  actions: _react.PropTypes.objectOf(_react.PropTypes.func),
	  selectedCategory: _react.PropTypes.string,
	  isSubmitting: _react.PropTypes.bool,
	  expanded: _react.PropTypes.bool,
	  suggestForPurchaseEnabled: _react.PropTypes.bool
	};
	
	var FeedbackContainer = function FeedbackContainer(_ref) {
	  var user = _ref.user,
	      enabled = _ref.enabled,
	      actions = _ref.actions,
	      categories = _ref.categories,
	      contactLinks = _ref.contactLinks,
	      expanded = _ref.expanded,
	      selectedCategory = _ref.selectedCategory,
	      isSubmitting = _ref.isSubmitting,
	      suggestForPurchaseEnabled = _ref.suggestForPurchaseEnabled;
	  return user && enabled ? _react2.default.createElement(_FeedbackBox2.default, {
	    actions: actions,
	    categories: categories,
	    contactLinks: contactLinks,
	    expanded: expanded,
	    selectedCategory: selectedCategory,
	    isSubmitting: isSubmitting,
	    suggestForPurchaseEnabled: suggestForPurchaseEnabled }) : null;
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  var user = (0, _AuthSelector.currentUserSelector)(state);
	  var library = (0, _LibrarySelector.currentLibrarySelector)(state);
	  return {
	    user: user,
	    enabled: library.getIn(['feedback', 'enabled']),
	    categories: library.getIn(['feedback', 'categories']),
	    contactLinks: library.getIn(['feedback', 'links']),
	    expanded: state.getIn(['ui', 'feedback', 'expanded']),
	    selectedCategory: state.getIn(['ui', 'feedback', 'category']),
	    isSubmitting: state.getIn(['ui', 'feedback', 'isSubmitting']),
	    suggestForPurchaseEnabled: library.getIn(['suggestForPurchase', 'enabled'])
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    actions: (0, _redux.bindActionCreators)(_FeedbackActions2.default, dispatch)
	  };
	};
	
	FeedbackContainer.propTypes = propTypes;
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(FeedbackContainer);

/***/ },
/* 2069 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FinesContainer = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(14);
	
	var _redux = __webpack_require__(18);
	
	var _AuthSelector = __webpack_require__(21);
	
	var _FinesActions = __webpack_require__(1582);
	
	var FinesActions = _interopRequireWildcard(_FinesActions);
	
	var _BorrowingActions = __webpack_require__(180);
	
	var BorrowingActions = _interopRequireWildcard(_BorrowingActions);
	
	var _MessagingActions = __webpack_require__(181);
	
	var _MessagingActions2 = _interopRequireDefault(_MessagingActions);
	
	var _LibrarySelector = __webpack_require__(33);
	
	var _BasePageContainer2 = __webpack_require__(108);
	
	var _BasePageContainer3 = _interopRequireDefault(_BasePageContainer2);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _Fines = __webpack_require__(1691);
	
	var _Fines2 = _interopRequireDefault(_Fines);
	
	var _BorrowingSelector = __webpack_require__(300);
	
	var _FinesSelector = __webpack_require__(2173);
	
	var _DocumentHeadContainer = __webpack_require__(52);
	
	var _DocumentHeadContainer2 = _interopRequireDefault(_DocumentHeadContainer);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FinesContainer = exports.FinesContainer = function (_BasePageContainer) {
	  _inherits(FinesContainer, _BasePageContainer);
	
	  function FinesContainer() {
	    _classCallCheck(this, FinesContainer);
	
	    return _possibleConstructorReturn(this, (FinesContainer.__proto__ || Object.getPrototypeOf(FinesContainer)).apply(this, arguments));
	  }
	
	  _createClass(FinesContainer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      _get(FinesContainer.prototype.__proto__ || Object.getPrototypeOf(FinesContainer.prototype), 'componentDidMount', this).call(this);
	
	      var _props = this.props,
	          accountId = _props.accountId,
	          location = _props.location;
	
	      this.props.FinesActions.fetchFines(_extends({}, location.query, { accountId: accountId }));
	    }
	  }, {
	    key: 'finesIDList',
	    value: function finesIDList() {
	      return this.props.fines.map(function (fine) {
	        var fineId = fine.get('id');
	        return fineId;
	      }).toList();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var pageTitle = this.props.intl.formatMessage({ id: 'section_title_fines' });
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_DocumentHeadContainer2.default, { pageTitle: pageTitle }),
	        _react2.default.createElement(_Fines2.default, _extends({ finesIDs: this.finesIDList() }, this.props))
	      );
	    }
	  }], [{
	    key: 'fetchInitialData',
	    value: function fetchInitialData(params, query, store) {
	      var account = (0, _AuthSelector.currentAccountSelector)(store.getState());
	      var accountId = account && account.get('id');
	
	      return [store.dispatch(BorrowingActions.fetchSummaries({ accountId: accountId })), store.dispatch(FinesActions.fetchFines(_extends({}, query, {
	        accountId: accountId
	      })))];
	    }
	  }, {
	    key: 'getBackToTitleKey',
	    value: function getBackToTitleKey() {
	      return 'fines';
	    }
	  }]);
	
	  return FinesContainer;
	}(_BasePageContainer3.default);
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    FinesActions: (0, _redux.bindActionCreators)(FinesActions, dispatch),
	    messagingActions: (0, _redux.bindActionCreators)(_MessagingActions2.default, dispatch)
	  };
	};
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  var user = (0, _AuthSelector.currentUserSelector)(state);
	  var library = (0, _LibrarySelector.currentLibrarySelector)(state);
	  var onlineFinesPayment = library.get('onlineFinePayment', _immutable2.default.Map());
	  var account = (0, _AuthSelector.currentAccountSelector)(state);
	  var accountId = (0, _AuthSelector.currentAccountSelector)(state).get('id').toString();
	  var fines = (0, _FinesSelector.getFines)(state);
	  var paymentForm = state.getIn(['borrowing', 'fines', 'paymentForm', 'html']);
	  var totalItems = state.getIn(['borrowing', 'fines', accountId, 'page', 'totalElements']);
	  var totalPages = state.getIn(['borrowing', 'fines', accountId, 'page', 'totalPages']);
	  var pageSize = state.getIn(['borrowing', 'fines', accountId, 'page', 'size']);
	  var currentPage = parseInt(ownProps.location.query.page || '1', 10);
	  var summary = (0, _BorrowingSelector.getSummary)(state, 'fines');
	  var isFetching = state.getIn(['borrowing', 'fines', 'isFetching']);
	  return {
	    user: user,
	    account: account,
	    fines: fines,
	    summary: summary,
	    paymentForm: paymentForm,
	    totalItems: totalItems,
	    totalPages: totalPages,
	    pageSize: pageSize,
	    currentPage: currentPage,
	    isFetching: isFetching,
	    onlineFinesPayment: onlineFinesPayment,
	    accountId: accountId
	  };
	};
	
	FinesContainer.propTypes = {
	  intl: _reactIntl.intlShape,
	  accountId: _react.PropTypes.number
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIntl.injectIntl)(FinesContainer));

/***/ },
/* 2070 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FooterContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(14);
	
	var _versionMessage = __webpack_require__(1571);
	
	var _versionMessage2 = _interopRequireDefault(_versionMessage);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _FeedbackContainer = __webpack_require__(2068);
	
	var _FeedbackContainer2 = _interopRequireDefault(_FeedbackContainer);
	
	var _LibrarySelector = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable react/no-danger */
	
	function mapStateToProps(state) {
	  var library = (0, _LibrarySelector.currentLibrarySelector)(state);
	  return {
	    footer: state.getIn(['templates', 'footer']),
	    appVersion: state.getIn(['app', 'appVersion']),
	    cmsEnabled: library.get('cmsEnabled')
	  };
	}
	
	var FooterContainer = exports.FooterContainer = function (_BcReactComponent) {
	  _inherits(FooterContainer, _BcReactComponent);
	
	  function FooterContainer() {
	    _classCallCheck(this, FooterContainer);
	
	    return _possibleConstructorReturn(this, (FooterContainer.__proto__ || Object.getPrototypeOf(FooterContainer)).apply(this, arguments));
	  }
	
	  _createClass(FooterContainer, [{
	    key: 'render',
	    value: function render() {
	      if (this.props.footer) {
	        return _react2.default.createElement(
	          'div',
	          { className: this.props.cmsEnabled ? 'cms-footer' : 'container' },
	          _react2.default.createElement(_FeedbackContainer2.default, null),
	          _react2.default.createElement('div', { className: 'cp-footer', dangerouslySetInnerHTML: { __html: this.props.footer } }),
	          _react2.default.createElement(_versionMessage2.default, { version: this.props.appVersion })
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return FooterContainer;
	}(_baseBcReactComponent2.default);
	
	FooterContainer.propTypes = {
	  footer: _react2.default.PropTypes.string
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(FooterContainer);

/***/ },
/* 2071 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(14);
	
	var _sharedProgressBar = __webpack_require__(94);
	
	var _sharedProgressBar2 = _interopRequireDefault(_sharedProgressBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    active: state.get('ui').get('progressBar')
	  };
	};
	
	var propTypes = {
	  active: _react.PropTypes.bool.isRequired
	};
	
	var GlobalProgressBarContainer = function GlobalProgressBarContainer(_ref) {
	  var active = _ref.active;
	  return _react2.default.createElement(_sharedProgressBar2.default, { active: active });
	};
	
	GlobalProgressBarContainer.propTypes = propTypes;
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(GlobalProgressBarContainer);

/***/ },
/* 2072 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(14);
	
	var _redux = __webpack_require__(18);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _GroupSearchFeedbackActions = __webpack_require__(380);
	
	var _GroupSearchFeedbackActions2 = _interopRequireDefault(_GroupSearchFeedbackActions);
	
	var _GroupSearchFeedback = __webpack_require__(1631);
	
	var _GroupSearchFeedback2 = _interopRequireDefault(_GroupSearchFeedback);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function GroupSearchFeedbackContainer(props) {
	  return _react2.default.createElement(_GroupSearchFeedback2.default, props);
	}
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    shouldMatch: state.getIn(['ui', 'groupSearchFeedback', 'shouldMatch']),
	    isEditing: state.getIn(['ui', 'groupSearchFeedback', 'isEditing']),
	    isSubmitting: state.getIn(['ui', 'groupSearchFeedback', 'isSubmitting']),
	    sourceBib: state.getIn(['entities', 'bibs', state.getIn(['ui', 'groupSearchFeedback', 'metadataId1'])]),
	    bibToMatch: state.getIn(['entities', 'bibs', state.getIn(['ui', 'groupSearchFeedback', 'metadataId2'])]),
	    isMissingRequiredFields: state.getIn(['ui', 'groupSearchFeedback', 'isMissingRequiredFields'])
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    groupSearchFeedbackActions: (0, _redux.bindActionCreators)(_GroupSearchFeedbackActions2.default, dispatch)
	  };
	};
	
	GroupSearchFeedbackContainer.propTypes = {
	  groupSearchFeedbackActions: _react.PropTypes.objectOf(_react.PropTypes.func),
	  sourceBib: _reactImmutableProptypes2.default.map,
	  bibToMatch: _reactImmutableProptypes2.default.map,
	  shouldMatch: _react.PropTypes.bool,
	  isEditing: _react.PropTypes.bool,
	  isSubmitting: _react.PropTypes.bool,
	  searchResults: _reactImmutableProptypes2.default.listOf(_reactImmutableProptypes2.default.listOf(_reactImmutableProptypes2.default.map)),
	  isMissingRequiredFields: _react.PropTypes.bool
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(GroupSearchFeedbackContainer);

/***/ },
/* 2073 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(14);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _redux = __webpack_require__(18);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _probes = __webpack_require__(541);
	
	var _probes2 = _interopRequireDefault(_probes);
	
	var _AvailabilityDetailActions = __webpack_require__(122);
	
	var _AvailabilityDetailActions2 = _interopRequireDefault(_AvailabilityDetailActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    probes: state.getIn(['entities', 'bibs', ownProps.id, 'probes'], _immutable2.default.List())
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return _extends({}, (0, _redux.bindActionCreators)(_AvailabilityDetailActions2.default, dispatch));
	};
	
	var HoldingsProbeContainer = function (_BcReactComponent) {
	  _inherits(HoldingsProbeContainer, _BcReactComponent);
	
	  function HoldingsProbeContainer() {
	    _classCallCheck(this, HoldingsProbeContainer);
	
	    return _possibleConstructorReturn(this, (HoldingsProbeContainer.__proto__ || Object.getPrototypeOf(HoldingsProbeContainer)).apply(this, arguments));
	  }
	
	  _createClass(HoldingsProbeContainer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.getHoldingsProbes(this.props.id);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.id && this.props.id !== nextProps.id) {
	        this.props.getHoldingsProbes(nextProps.id);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var probes = this.props.probes;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-holdings-probes-list' },
	        probes.map(function (probe) {
	          return _react2.default.createElement(_probes2.default, _extends({}, probe.toObject(), { key: probe.metadataId }));
	        })
	      );
	    }
	  }]);
	
	  return HoldingsProbeContainer;
	}(_baseBcReactComponent2.default);
	
	HoldingsProbeContainer.propTypes = {
	  probes: _reactImmutableProptypes2.default.list,
	  getHoldingsProbes: _react.PropTypes.func.isRequired
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(HoldingsProbeContainer);

/***/ },
/* 2074 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.HoldsContainer = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(14);
	
	var _reactIntl = __webpack_require__(3);
	
	var _redux = __webpack_require__(18);
	
	var _isEqual = __webpack_require__(162);
	
	var _isEqual2 = _interopRequireDefault(_isEqual);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _HoldActions = __webpack_require__(143);
	
	var HoldActions = _interopRequireWildcard(_HoldActions);
	
	var _AuthSelector = __webpack_require__(21);
	
	var _AvailabilityDetailActions = __webpack_require__(122);
	
	var _AvailabilityDetailActions2 = _interopRequireDefault(_AvailabilityDetailActions);
	
	var _LibrarySelector = __webpack_require__(33);
	
	var _ShelfSelector = __webpack_require__(75);
	
	var _BasePageContainer2 = __webpack_require__(108);
	
	var _BasePageContainer3 = _interopRequireDefault(_BasePageContainer2);
	
	var _HoldsSelector = __webpack_require__(127);
	
	var _WorkflowActions = __webpack_require__(123);
	
	var _WorkflowActions2 = _interopRequireDefault(_WorkflowActions);
	
	var _ShelfActions = __webpack_require__(107);
	
	var _ShelfActions2 = _interopRequireDefault(_ShelfActions);
	
	var _Holds = __webpack_require__(1717);
	
	var _Holds2 = _interopRequireDefault(_Holds);
	
	var _BorrowingActions = __webpack_require__(180);
	
	var BorrowingActions = _interopRequireWildcard(_BorrowingActions);
	
	var _DocumentHeadContainer = __webpack_require__(52);
	
	var _DocumentHeadContainer2 = _interopRequireDefault(_DocumentHeadContainer);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HoldsContainer = exports.HoldsContainer = function (_BasePageContainer) {
	  _inherits(HoldsContainer, _BasePageContainer);
	
	  function HoldsContainer() {
	    _classCallCheck(this, HoldsContainer);
	
	    return _possibleConstructorReturn(this, (HoldsContainer.__proto__ || Object.getPrototypeOf(HoldsContainer)).apply(this, arguments));
	  }
	
	  _createClass(HoldsContainer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      _get(HoldsContainer.prototype.__proto__ || Object.getPrototypeOf(HoldsContainer.prototype), 'componentDidMount', this).call(this);
	
	      var _props = this.props,
	          accountId = _props.accountId,
	          location = _props.location,
	          router = _props.router;
	
	      this.props.holdActions.fetchHolds(_extends({ accountId: accountId }, router.params, location.query));
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps) {
	      var _props2 = this.props,
	          location = _props2.location,
	          items = _props2.items;
	
	
	      var locationChanged = !(0, _isEqual2.default)(location, nextProps.location);
	      var itemsChanged = !(0, _isEqual2.default)(items, nextProps.items);
	
	      if (locationChanged || itemsChanged) {
	        this.props.holdActions.fetchHolds(_extends({
	          accountId: nextProps.accountId
	        }, nextProps.router.params, nextProps.location.query));
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var pageTitle = this.props.intl.formatMessage({ id: 'section_title_holds' });
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_DocumentHeadContainer2.default, { pageTitle: pageTitle }),
	        _react2.default.createElement(_Holds2.default, this.props),
	        this.props.children
	      );
	    }
	  }], [{
	    key: 'fetchInitialData',
	    value: function fetchInitialData(params, query, store) {
	      var account = (0, _AuthSelector.currentAccountSelector)(store.getState());
	      var accountId = account && account.get('id');
	
	      return [store.dispatch(BorrowingActions.fetchSummaries({ accountId: accountId })), store.dispatch(HoldActions.fetchHolds(_extends({ accountId: accountId }, params, query)))];
	    }
	  }, {
	    key: 'getBackToTitleKey',
	    value: function getBackToTitleKey() {
	      return 'holds';
	    }
	  }]);
	
	  return HoldsContainer;
	}(_BasePageContainer3.default);
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  var countsByStatus = (0, _HoldsSelector.getCountsByStatus)(state);
	  var user = (0, _AuthSelector.currentUserSelector)(state);
	  var items = (0, _HoldsSelector.getCurrentHolds)(state, ownProps);
	  var materialTypeCounts = (0, _HoldsSelector.getMaterialTypeCounts)(state, ownProps);
	  var selectedStatus = (0, _HoldsSelector.getSelectedStatus)(state, ownProps);
	  var presentStatuses = (0, _HoldsSelector.getPresentStatuses)(state, ownProps);
	  var quotas = (0, _HoldsSelector.getHoldsQuotas)(state, ownProps);
	  var library = (0, _LibrarySelector.currentLibrarySelector)(state);
	  var featuredListTypes = library.get('featuredListTypes', _immutable2.default.List());
	  var showStaffPicksLink = featuredListTypes && featuredListTypes.includes('staff_picks');
	  var branches = (0, _LibrarySelector.sortedPickupBranchSelector)(state, ownProps);
	  var accountId = (0, _AuthSelector.currentAccountSelector)(state).get('id');
	  var availabilityDetail = state.get('availabilityDetail');
	  var pagination = (0, _HoldsSelector.getPagination)(state, ownProps);
	  var holdsTransactions = (0, _HoldsSelector.getHoldsTransactions)(state);
	  var shelves = (0, _ShelfSelector.getShelvesForCurrentUser)(state);
	  var shelfTransactions = (0, _ShelfSelector.getShelfTransactions)(state);
	  var holdsStatus = (0, _HoldsSelector.getHoldsStatus)(state);
	
	  return {
	    user: user,
	    items: items,
	    totalUnfilteredCount: selectedStatus ? countsByStatus.get(selectedStatus) : pagination.get('count', 0),
	    materialTypeCounts: materialTypeCounts,
	    selectedStatus: selectedStatus,
	    presentStatuses: presentStatuses,
	    quotas: quotas,
	    showStaffPicksLink: showStaffPicksLink,
	    branches: branches,
	    accountId: accountId,
	    availabilityDetail: availabilityDetail,
	    pagination: pagination,
	    holdsTransactions: holdsTransactions,
	    shelves: shelves,
	    shelfTransactions: shelfTransactions,
	    fetching: holdsStatus.get('fetching', false)
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    holdActions: (0, _redux.bindActionCreators)(HoldActions, dispatch),
	    workflowActions: (0, _redux.bindActionCreators)(_WorkflowActions2.default, dispatch),
	    availabilityDetailActions: (0, _redux.bindActionCreators)(_AvailabilityDetailActions2.default, dispatch),
	    shelfActions: (0, _redux.bindActionCreators)(_ShelfActions2.default, dispatch),
	    borrowingActions: (0, _redux.bindActionCreators)(BorrowingActions, dispatch)
	  };
	};
	
	HoldsContainer.propTypes = {
	  intl: _reactIntl.intlShape,
	  pagination: _reactImmutableProptypes2.default.map,
	  holdsActionItems: _reactImmutableProptypes2.default.map,
	  shelves: _reactImmutableProptypes2.default.map,
	  shelfTransactions: _reactImmutableProptypes2.default.map,
	  fetching: _react.PropTypes.bool
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIntl.injectIntl)(HoldsContainer));

/***/ },
/* 2075 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.HoldsContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(14);
	
	var _redux = __webpack_require__(18);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _HoldActions = __webpack_require__(143);
	
	var _HoldActions2 = _interopRequireDefault(_HoldActions);
	
	var _HoldsSelector = __webpack_require__(127);
	
	var HoldsSelector = _interopRequireWildcard(_HoldsSelector);
	
	var _BibSelector = __webpack_require__(398);
	
	var _AuthSelector = __webpack_require__(21);
	
	var _HoldsToReview = __webpack_require__(1745);
	
	var _HoldsToReview2 = _interopRequireDefault(_HoldsToReview);
	
	var _LibrarySelector = __webpack_require__(33);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HoldsContainer = exports.HoldsContainer = function (_BcReactComponent) {
	  _inherits(HoldsContainer, _BcReactComponent);
	
	  function HoldsContainer() {
	    _classCallCheck(this, HoldsContainer);
	
	    return _possibleConstructorReturn(this, (HoldsContainer.__proto__ || Object.getPrototypeOf(HoldsContainer)).apply(this, arguments));
	  }
	
	  _createClass(HoldsContainer, [{
	    key: 'render',
	    value: function render() {
	      return this.props.showInactiveHolds && _react2.default.createElement(_HoldsToReview2.default, {
	        expiredCount: this.props.expiredCount,
	        cancelledCount: this.props.cancelledCount,
	        expiredHolds: this.props.expiredHolds,
	        cancelledHolds: this.props.cancelledHolds,
	        fetchingExpired: this.props.fetchingExpired,
	        fetchingCancelled: this.props.fetchingCancelled,
	        fetchExpiredHolds: this.props.holdActions.fetchExpiredHolds,
	        fetchCancelledHolds: this.props.holdActions.fetchCancelledHolds,
	        cancelledHoldsPagination: this.props.cancelledHoldsPagination,
	        expiredHoldsPagination: this.props.expiredHoldsPagination,
	        accountId: this.props.accountId,
	        bibs: this.props.bibs });
	    }
	  }]);
	
	  return HoldsContainer;
	}(_baseBcReactComponent2.default);
	
	var mapStateToProps = function mapStateToProps(state) {
	  var library = (0, _LibrarySelector.currentLibrarySelector)(state);
	  var showInactiveHolds = library.get('showInactiveHolds', false);
	  var bibs = (0, _BibSelector.getBibsByMetadataId)(state);
	
	  var holdCounts = HoldsSelector.getInactiveHoldCountsByStatus(state);
	  var inactiveHoldData = HoldsSelector.getInactiveHoldData(state);
	  var accountId = (0, _AuthSelector.currentAccountSelector)(state).get('id');
	
	  return {
	    expiredCount: holdCounts.get('EXPIRED', 0),
	    cancelledCount: holdCounts.get('CANCELLED', 0),
	    expiredHolds: HoldsSelector.getExpiredHolds(state),
	    cancelledHolds: HoldsSelector.getCancelledHolds(state),
	    showInactiveHolds: showInactiveHolds,
	    fetchingExpired: inactiveHoldData.getIn(['expired', 'fetching']),
	    fetchingCancelled: inactiveHoldData.getIn(['cancelled', 'fetching']),
	    bibs: bibs,
	    cancelledHoldsPagination: inactiveHoldData.getIn(['cancelled', 'pagination']),
	    expiredHoldsPagination: inactiveHoldData.getIn(['expired', 'pagination']),
	    accountId: accountId
	  };
	};
	
	HoldsContainer.propTypes = {
	  expiredCount: _react.PropTypes.number,
	  cancelledCount: _react.PropTypes.number,
	  holdActions: _react.PropTypes.objectOf(_react.PropTypes.func),
	  cancelledHoldsPagination: _bcPropTypes.paginationShape,
	  expiredHoldsPagination: _bcPropTypes.paginationShape,
	  accountId: _react.PropTypes.number
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    holdActions: (0, _redux.bindActionCreators)(_HoldActions2.default, dispatch)
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(HoldsContainer);

/***/ },
/* 2076 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InterlibraryLoansContainer = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LibrarySelector = __webpack_require__(33);
	
	var _reactRedux = __webpack_require__(14);
	
	var _reactIntl = __webpack_require__(3);
	
	var _BorrowingActions = __webpack_require__(180);
	
	var BorrowingActions = _interopRequireWildcard(_BorrowingActions);
	
	var _AuthSelector = __webpack_require__(21);
	
	var _InterlibraryLoansActions = __webpack_require__(1584);
	
	var InterlibraryLoansActions = _interopRequireWildcard(_InterlibraryLoansActions);
	
	var _redux = __webpack_require__(18);
	
	var _notFound = __webpack_require__(140);
	
	var _notFound2 = _interopRequireDefault(_notFound);
	
	var _InterlibraryLoans = __webpack_require__(1765);
	
	var _InterlibraryLoans2 = _interopRequireDefault(_InterlibraryLoans);
	
	var _DocumentHeadContainer = __webpack_require__(52);
	
	var _DocumentHeadContainer2 = _interopRequireDefault(_DocumentHeadContainer);
	
	var _InterlibraryLoansSelector = __webpack_require__(2174);
	
	var _BasePageContainer2 = __webpack_require__(108);
	
	var _BasePageContainer3 = _interopRequireDefault(_BasePageContainer2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InterlibraryLoansContainer = exports.InterlibraryLoansContainer = function (_BasePageContainer) {
	  _inherits(InterlibraryLoansContainer, _BasePageContainer);
	
	  function InterlibraryLoansContainer() {
	    _classCallCheck(this, InterlibraryLoansContainer);
	
	    return _possibleConstructorReturn(this, (InterlibraryLoansContainer.__proto__ || Object.getPrototypeOf(InterlibraryLoansContainer)).apply(this, arguments));
	  }
	
	  _createClass(InterlibraryLoansContainer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      _get(InterlibraryLoansContainer.prototype.__proto__ || Object.getPrototypeOf(InterlibraryLoansContainer.prototype), 'componentDidMount', this).call(this);
	
	      var accountId = this.props.accountId;
	
	      this.props.InterlibraryLoansActions.fetchInterlibraryLoans({ accountId: accountId });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var pageTitle = this.props.intl.formatMessage({ id: 'section_title_interlibraryloans' });
	
	      if (!this.props.interlibraryLoansSupported) {
	        return _react2.default.createElement(_notFound2.default, null);
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_DocumentHeadContainer2.default, { pageTitle: pageTitle }),
	        _react2.default.createElement(_InterlibraryLoans2.default, this.props)
	      );
	    }
	  }], [{
	    key: 'fetchInitialData',
	    value: function fetchInitialData(params, query, store) {
	      var account = (0, _AuthSelector.currentAccountSelector)(store.getState());
	      var accountId = account && account.get('id');
	
	      return [store.dispatch(BorrowingActions.fetchSummaries({ accountId: accountId })), store.dispatch(InterlibraryLoansActions.fetchInterlibraryLoans(_extends({ accountId: accountId }, params, query)))];
	    }
	  }, {
	    key: 'getBackToTitleKey',
	    value: function getBackToTitleKey() {
	      return 'interlibrary_loans';
	    }
	  }]);
	
	  return InterlibraryLoansContainer;
	}(_BasePageContainer3.default);
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    InterlibraryLoansActions: (0, _redux.bindActionCreators)(InterlibraryLoansActions, dispatch)
	  };
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  var library = (0, _LibrarySelector.currentLibrarySelector)(state);
	  var interlibraryLoansSupported = library.get('illRequests');
	  var user = (0, _AuthSelector.currentUserSelector)(state);
	  var accountId = (0, _AuthSelector.currentAccountSelector)(state).get('id');
	  var interlibraryLoansStatus = (0, _InterlibraryLoansSelector.getInterlibaryLoansStatus)(state);
	  var items = (0, _InterlibraryLoansSelector.getInterlibaryLoans)(state);
	  return {
	    intl: _reactIntl.intlShape,
	    user: user,
	    accountId: accountId,
	    items: items,
	    interlibraryLoansSupported: interlibraryLoansSupported,
	    isFetching: interlibraryLoansStatus.get('isFetching')
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIntl.injectIntl)(InterlibraryLoansContainer));

/***/ },
/* 2077 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InternalErrorContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(14);
	
	var _InternalError = __webpack_require__(563);
	
	var _InternalError2 = _interopRequireDefault(_InternalError);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _AppActions = __webpack_require__(377);
	
	var _AppActions2 = _interopRequireDefault(_AppActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  error: _react2.default.PropTypes.bool,
	  appVersion: _react.PropTypes.string,
	  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node]).isRequired,
	  errorId: _react.PropTypes.string
	};
	
	var InternalErrorContainer = exports.InternalErrorContainer = function (_BcReactComponent) {
	  _inherits(InternalErrorContainer, _BcReactComponent);
	
	  function InternalErrorContainer() {
	    _classCallCheck(this, InternalErrorContainer);
	
	    return _possibleConstructorReturn(this, (InternalErrorContainer.__proto__ || Object.getPrototypeOf(InternalErrorContainer)).apply(this, arguments));
	  }
	
	  _createClass(InternalErrorContainer, [{
	    key: 'unstable_handleError',
	    value: function unstable_handleError() {
	      // eslint-disable-line camelcase
	      this.props.dispatch(_AppActions2.default.showErrorPage());
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          appVersion = _props.appVersion,
	          children = _props.children,
	          error = _props.error,
	          errorId = _props.errorId;
	
	      if (error) {
	        return _react2.default.createElement(_InternalError2.default, { appVersion: appVersion, errorId: errorId });
	      }
	
	      return children;
	    }
	  }]);
	
	  return InternalErrorContainer;
	}(_baseBcReactComponent2.default);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    error: state.get('internalError'),
	    errorId: state.getIn(['app', 'internalError', 'id']),
	    appVersion: state.getIn(['app', 'appVersion'])
	  };
	};
	
	InternalErrorContainer.propTypes = propTypes;
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(InternalErrorContainer);

/***/ },
/* 2078 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ItemTransactionWorkflowContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(14);
	
	var _redux = __webpack_require__(18);
	
	var _CheckoutActions = __webpack_require__(279);
	
	var CheckoutActions = _interopRequireWildcard(_CheckoutActions);
	
	var _HoldActions = __webpack_require__(143);
	
	var HoldActions = _interopRequireWildcard(_HoldActions);
	
	var _BorrowingActions = __webpack_require__(180);
	
	var BorrowingActions = _interopRequireWildcard(_BorrowingActions);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _BibSelector = __webpack_require__(398);
	
	var _ItemTransactions = __webpack_require__(291);
	
	var _SinglePauseHoldWorkflowView = __webpack_require__(1755);
	
	var _SinglePauseHoldWorkflowView2 = _interopRequireDefault(_SinglePauseHoldWorkflowView);
	
	var _HoldsConstants = __webpack_require__(98);
	
	var _AuthSelector = __webpack_require__(21);
	
	var _LibrarySelector = __webpack_require__(33);
	
	var _HoldsSelector = __webpack_require__(127);
	
	var _CheckoutSelector = __webpack_require__(191);
	
	var _ShelfSelector = __webpack_require__(75);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ItemTransactionWorkflowContainer = exports.ItemTransactionWorkflowContainer = function (_BcReactComponent) {
	  _inherits(ItemTransactionWorkflowContainer, _BcReactComponent);
	
	  function ItemTransactionWorkflowContainer() {
	    _classCallCheck(this, ItemTransactionWorkflowContainer);
	
	    return _possibleConstructorReturn(this, (ItemTransactionWorkflowContainer.__proto__ || Object.getPrototypeOf(ItemTransactionWorkflowContainer)).apply(this, arguments));
	  }
	
	  _createClass(ItemTransactionWorkflowContainer, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          bib = _props.bib,
	          holdsId = _props.holdsId,
	          initialSuspendStartDate = _props.initialSuspendStartDate,
	          initialSuspendEndDate = _props.initialSuspendEndDate,
	          enableStartDate = _props.enableStartDate,
	          enableEndDate = _props.enableEndDate,
	          closeWorkflow = _props.closeWorkflow,
	          branches = _props.branches,
	          isLoading = _props.isLoading,
	          accountId = _props.accountId,
	          shelves = _props.shelves,
	          preferredBranch = _props.preferredBranch,
	          currentLocale = _props.currentLocale,
	          holdActions = _props.holdActions,
	          checkoutActions = _props.checkoutActions,
	          requiresExpiryDate = _props.requiresExpiryDate,
	          holdInfoMessages = _props.holdInfoMessages,
	          fieldErrors = _props.fieldErrors,
	          provider = _props.provider,
	          supportAutoCheckout = _props.supportAutoCheckout,
	          formats = _props.formats,
	          checkout = _props.checkout,
	          digitalNotificationEmail = _props.digitalNotificationEmail,
	          view = _props.view,
	          materialPolicy = _props.materialPolicy,
	          selectedBranch = _props.selectedBranch,
	          itemGroups = _props.itemGroups,
	          itemIdsOnHold = _props.itemIdsOnHold,
	          successfulItemIds = _props.successfulItemIds,
	          failedItemIds = _props.failedItemIds,
	          singleBranch = _props.singleBranch,
	          showVolumeSelectorCollection = _props.showVolumeSelectorCollection,
	          showVolumeSelectorDueDate = _props.showVolumeSelectorDueDate,
	          showVolumeSelectorStatus = _props.showVolumeSelectorStatus,
	          isFetchingItemGroups = _props.isFetchingItemGroups,
	          borrowingActions = _props.borrowingActions,
	          messagingId = _props.messagingId,
	          workflowId = _props.workflowId,
	          holdsTransactions = _props.holdsTransactions;
	
	
	      switch (view) {
	        case _HoldsConstants.WORKFLOW_VIEWS.CANCEL_HOLD:
	          return _react2.default.createElement(_ItemTransactions.SingleCancelHoldWorkflowView, {
	            messagingId: messagingId,
	            workflowId: workflowId || bib.get('metadataId'),
	            bib: bib,
	            holdId: holdsId,
	            cancelHold: holdActions.cancelHold,
	            handleClose: closeWorkflow,
	            isLoading: isLoading || holdsTransactions.getIn([holdsId, 'isCancelling'], false),
	            accountId: accountId,
	            shelves: shelves,
	            fieldErrors: fieldErrors });
	        case _HoldsConstants.WORKFLOW_VIEWS.ITEM_LEVEL_HOLD:
	          return _react2.default.createElement(_ItemTransactions.ItemLevelHoldsWorkflowView, {
	            messagingId: messagingId,
	            workflowId: workflowId || bib.get('metadataId'),
	            bib: bib,
	            branches: branches,
	            dispatch: this.props.dispatch,
	            handleClose: closeWorkflow,
	            preferredBranch: preferredBranch,
	            selectedBranch: selectedBranch,
	            placeItemHold: holdActions.placeItemHold,
	            fetchItemGroups: holdActions.getItemGroups,
	            holdInfoMessages: holdInfoMessages,
	            isLoading: isLoading,
	            fieldErrors: fieldErrors,
	            itemGroups: itemGroups,
	            itemIdsOnHold: itemIdsOnHold,
	            successfulItemIds: successfulItemIds,
	            failedItemIds: failedItemIds,
	            supportsBatchVolumeHolds: materialPolicy.get('supportsBatchVolumeHolds'),
	            showVolumeSelectorCollection: showVolumeSelectorCollection,
	            showVolumeSelectorStatus: showVolumeSelectorStatus,
	            showVolumeSelectorDueDate: showVolumeSelectorDueDate,
	            isFetchingItemGroups: isFetchingItemGroups });
	        case _HoldsConstants.WORKFLOW_VIEWS.DIGITAL_MISSING_FORMAT:
	          {
	            return _react2.default.createElement(_ItemTransactions.DigitalMissingFormatWorkflowView, {
	              messagingId: messagingId,
	              workflowId: workflowId || bib.get('metadataId'),
	              lockInFormat: checkoutActions.lockInFormat,
	              formats: formats,
	              bib: bib,
	              checkout: checkout,
	              provider: provider,
	              accountId: accountId,
	              isLoading: isLoading,
	              handleClose: closeWorkflow,
	              fetchDigitalFormats: checkoutActions.fetchDigitalFormats });
	          }
	        case _HoldsConstants.WORKFLOW_VIEWS.DIGITAL_CHECKOUT:
	          return _react2.default.createElement(_ItemTransactions.DigitalCheckoutWorkflowView, {
	            bib: bib,
	            holdId: holdsId,
	            workflowId: workflowId || bib.get('metadataId'),
	            messagingId: messagingId,
	            handleClose: closeWorkflow,
	            accountId: accountId,
	            isLoading: isLoading,
	            holdActions: holdActions,
	            borrowingActions: borrowingActions,
	            digitalCheckout: checkoutActions.digitalCheckout,
	            provider: provider,
	            requireFormats: materialPolicy.get('requiresFormatDuringCheckout'),
	            fieldErrors: fieldErrors,
	            formats: formats,
	            fetchDigitalFormats: checkoutActions.fetchDigitalFormats,
	            quickStartUrl: materialPolicy.get('quickStartUrl'),
	            showQuickStartLink: materialPolicy.get('showQuickstartLink') });
	        case _HoldsConstants.WORKFLOW_VIEWS.DIGITAL_HOLD:
	          return _react2.default.createElement(_ItemTransactions.DigitalHoldsWorkflowView, {
	            bib: bib,
	            branches: branches,
	            provider: provider,
	            supportAutoCheckout: supportAutoCheckout,
	            isLoading: isLoading,
	            handleClose: closeWorkflow,
	            formats: formats,
	            showFormatDuringHold: materialPolicy.get('showFormatDuringHold'),
	            requiresFormatDuringHold: materialPolicy.get('requiresFormatDuringHold'),
	            quickStartUrl: materialPolicy.get('quickStartUrl'),
	            showQuickStartLink: materialPolicy.get('showQuickstartLink'),
	            accountId: accountId,
	            placeHold: holdActions.placeHold,
	            digitalNotificationEmail: digitalNotificationEmail,
	            fetchDigitalFormats: checkoutActions.fetchDigitalFormats,
	            workflowId: workflowId,
	            messagingId: messagingId });
	        case _HoldsConstants.WORKFLOW_VIEWS.PAUSE_HOLD:
	          return _react2.default.createElement(_SinglePauseHoldWorkflowView2.default, {
	            bib: bib,
	            messagingId: messagingId || holdsId,
	            workflowId: workflowId || holdsId,
	            holdId: holdsId,
	            initialSuspendStartDate: initialSuspendStartDate,
	            initialSuspendEndDate: initialSuspendEndDate,
	            enableStartDate: enableStartDate,
	            enableEndDate: enableEndDate,
	            pauseHolds: holdActions.pauseOrResumeHolds,
	            handleClose: closeWorkflow,
	            isLoading: isLoading,
	            accountId: accountId,
	            fieldErrors: fieldErrors });
	        default:
	          return _react2.default.createElement(_ItemTransactions.PhysicalHoldsWorkflowView, {
	            bib: bib,
	            branches: branches,
	            handleClose: closeWorkflow,
	            preferredBranch: preferredBranch,
	            placeHold: holdActions.placeHold,
	            accountId: accountId,
	            singleBranch: singleBranch,
	            currentLocale: currentLocale,
	            requiresExpiryDate: requiresExpiryDate,
	            holdInfoMessages: holdInfoMessages,
	            isLoading: isLoading,
	            fieldErrors: fieldErrors,
	            workflowId: workflowId,
	            messagingId: messagingId });
	      }
	    }
	  }]);
	
	  return ItemTransactionWorkflowContainer;
	}(_baseBcReactComponent2.default);
	
	ItemTransactionWorkflowContainer.propTypes = {
	  bib: _reactImmutableProptypes2.default.map,
	  dispatch: _react.PropTypes.func.isRequired,
	  materialPolicy: _reactImmutableProptypes2.default.map,
	  holdsId: _react.PropTypes.string,
	  id: _react.PropTypes.string.isRequired,
	  metadataId: _react.PropTypes.string,
	  closeWorkflow: _react.PropTypes.func.isRequired,
	  isLoading: _react.PropTypes.bool,
	  holdInfoMessages: _react.PropTypes.arrayOf(_react.PropTypes.number).isRequired,
	  accountId: _react.PropTypes.number.isRequired,
	  shelves: _reactImmutableProptypes2.default.map.isRequired,
	  branches: _react.PropTypes.arrayOf(_reactImmutableProptypes2.default.map).isRequired,
	  currentLocale: _react.PropTypes.string,
	  preferredBranch: _react.PropTypes.string,
	  selectedBranch: _react.PropTypes.string,
	  singleBranch: _react.PropTypes.bool,
	  holdActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  checkoutActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  borrowingActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  requiresExpiryDate: _react.PropTypes.bool.isRequired,
	  fieldErrors: _react.PropTypes.objectOf(_react.PropTypes.shape({
	    classification: _react.PropTypes.string,
	    message: _react.PropTypes.string
	  })),
	  renderMessage: _react.PropTypes.func.isRequired,
	  provider: _react.PropTypes.string.isRequired,
	  supportAutoCheckout: _react.PropTypes.bool,
	  formats: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	    name: _react.PropTypes.string,
	    hasDownloadLink: _react.PropTypes.bool
	  })).isRequired,
	  checkout: _react.PropTypes.shape({
	    checkoutId: _react.PropTypes.string
	  }).isRequired,
	  digitalNotificationEmail: _react.PropTypes.string,
	  view: _react.PropTypes.string,
	  itemGroups: _reactImmutableProptypes2.default.listOf(_reactImmutableProptypes2.default.mapContains({
	    volume: _react.PropTypes.string,
	    collection: _react.PropTypes.string.isRequired,
	    copy: _react.PropTypes.string,
	    itemId: _react.PropTypes.string.isRequired,
	    callNumber: _react.PropTypes.string
	  })),
	  itemIdsOnHold: _reactImmutableProptypes2.default.listOf(_react.PropTypes.string),
	  failedItemIds: _reactImmutableProptypes2.default.listOf(_react.PropTypes.number),
	  successfulItemIds: _reactImmutableProptypes2.default.listOf(_react.PropTypes.number),
	  showVolumeSelectorCollection: _react.PropTypes.bool,
	  showVolumeSelectorStatus: _react.PropTypes.bool,
	  showVolumeSelectorDueDate: _react.PropTypes.bool,
	  isFetchingItemGroups: _react.PropTypes.bool,
	  messagingId: _react.PropTypes.string,
	  workflowId: _react.PropTypes.string
	};
	
	ItemTransactionWorkflowContainer.displayName = 'ItemTransactionWorkflowContainer';
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  var account = (0, _AuthSelector.currentAccountSelector)(state, ownProps) || _immutable2.default.Map();
	  var library = (0, _LibrarySelector.currentLibrarySelector)(state);
	  var policy = state.getIn(['entities', 'bibs', ownProps.metadataId, 'policy'], _immutable2.default.Map());
	  var branches = (0, _LibrarySelector.sortedPickupBranchSelector)(state, ownProps);
	  var checkouts = (0, _CheckoutSelector.getCheckoutsByMetadataId)(state).get(ownProps.metadataId, _immutable2.default.List());
	
	  var holds = (0, _HoldsSelector.getActiveHoldsByMetadataId)(state).get(ownProps.metadataId, _immutable2.default.List());
	  var holdsId = ownProps.holdsId || (holds.size === 1 ? holds.first().get('holdsId') : null);
	  var initialSuspendStartDate = holds.size === 1 ? holds.first().get('suspendStartDate') : null;
	  var initialSuspendEndDate = holds.size === 1 ? holds.first().get('suspendEndDate') : null;
	  var bibs = (0, _BibSelector.getBibsByMetadataId)(state);
	  return {
	    bib: state.getIn(['entities', 'bibs', ownProps.metadataId, 'briefInfo']),
	    enableStartDate: bibs.getIn([ownProps.metadataId, 'policy', 'materialPolicy', 'supportsSuspendHoldStartDateEdit']),
	    enableEndDate: bibs.getIn([ownProps.metadataId, 'policy', 'materialPolicy', 'supportsSuspendHoldEndDateEdit']),
	    itemGroups: state.getIn(['entities', 'bibs', ownProps.metadataId, 'itemGroups'], _immutable2.default.List()),
	    holdsId: holdsId,
	    initialSuspendStartDate: initialSuspendStartDate,
	    initialSuspendEndDate: initialSuspendEndDate,
	    itemIdsOnHold: holds.map(function (hold) {
	      return hold.get('itemId');
	    }),
	    checkout: checkouts.first(),
	    formats: state.getIn(['entities', 'bibs', ownProps.metadataId, 'policy', 'formats'], null),
	    branches: branches,
	    provider: policy.get('provider'),
	    materialPolicy: policy.get('materialPolicy'),
	    supportAutoCheckout: policy.getIn(['materialPolicy', 'supportAutoCheckout']),
	    accountId: account.get('id'),
	    shelves: (0, _ShelfSelector.getShelvesForCurrentUser)(state),
	    singleBranch: library.get('singleBranch'),
	    preferredBranch: state.getIn(['app', 'localBranch']) || account.get('preferredLocations', _immutable2.default.List()).first(),
	    selectedBranch: state.getIn(['ui', 'itemTransactions', ownProps.metadataId, 'selectedBranch']),
	    isLoading: state.getIn(['ui', 'itemTransactions', ownProps.metadataId, 'isLoading']),
	    currentLocale: state.getIn(['localization', 'currentLanguage'], 'en-US'),
	    requiresExpiryDate: library.get('requiresHoldExpiryDate', false),
	    holdInfoMessages: library.get('holdInfoMessages', []),
	    availableForCheckout: state.getIn(['entities', 'bibs', ownProps.metadataId, 'availability', 'status'], false) === 'AVAILABLE',
	    digitalNotificationEmail: account.get('digitalNotificationEmail'),
	    failedItemIds: state.getIn(['ui', 'itemTransactions', ownProps.metadataId, 'failedItemIds'], _immutable2.default.List()),
	    successfulItemIds: state.getIn(['ui', 'itemTransactions', ownProps.metadataId, 'successfulItemIds'], _immutable2.default.List()),
	    showVolumeSelectorCollection: library.get('showVolumeSelectorCollection'),
	    showVolumeSelectorStatus: library.get('showVolumeSelectorStatus'),
	    showVolumeSelectorDueDate: library.get('showVolumeSelectorDueDate'),
	    isFetchingItemGroups: state.getIn(['ui', 'itemLevelHold', ownProps.metadataId, 'isFetching']),
	    holdsTransactions: (0, _HoldsSelector.getHoldsTransactions)(state)
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    holdActions: (0, _redux.bindActionCreators)(HoldActions, dispatch),
	    checkoutActions: (0, _redux.bindActionCreators)(CheckoutActions, dispatch),
	    borrowingActions: (0, _redux.bindActionCreators)(BorrowingActions, dispatch),
	    dispatch: dispatch
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ItemTransactionWorkflowContainer);

/***/ },
/* 2079 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LoginContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(14);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _redux = __webpack_require__(18);
	
	var _login = __webpack_require__(539);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _AuthActions = __webpack_require__(378);
	
	var _AuthActions2 = _interopRequireDefault(_AuthActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function select(state) {
	  return { auth: state.get('auth') };
	}
	
	var LoginContainer = exports.LoginContainer = function (_BcReactComponent) {
	  _inherits(LoginContainer, _BcReactComponent);
	
	  function LoginContainer() {
	    _classCallCheck(this, LoginContainer);
	
	    return _possibleConstructorReturn(this, (LoginContainer.__proto__ || Object.getPrototypeOf(LoginContainer)).apply(this, arguments));
	  }
	
	  _createClass(LoginContainer, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          dispatch = _props.dispatch,
	          auth = _props.auth;
	
	      return _react2.default.createElement(_login2.default, {
	        auth: auth,
	        authActions: (0, _redux.bindActionCreators)(_AuthActions2.default, dispatch) });
	    }
	  }]);
	
	  return LoginContainer;
	}(_baseBcReactComponent2.default);
	
	LoginContainer.propTypes = {
	  auth: _reactImmutableProptypes2.default.mapContains({
	    userInfo: _reactImmutableProptypes2.default.map
	  }),
	  dispatch: _react2.default.PropTypes.func.isRequired
	};
	
	exports.default = (0, _reactRedux.connect)(select)(LoginContainer);

/***/ },
/* 2080 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ManifestationListItemContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(14);
	
	var _redux = __webpack_require__(18);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _AvailabilityDetailActions = __webpack_require__(122);
	
	var _AvailabilityDetailActions2 = _interopRequireDefault(_AvailabilityDetailActions);
	
	var _GroupSearchFeedbackActions = __webpack_require__(380);
	
	var _GroupSearchFeedbackActions2 = _interopRequireDefault(_GroupSearchFeedbackActions);
	
	var _HoldsSelector = __webpack_require__(127);
	
	var _AuthSelector = __webpack_require__(21);
	
	var _ScopeSelector = __webpack_require__(648);
	
	var _ShelfSelector = __webpack_require__(75);
	
	var _ManifestationListItem = __webpack_require__(1874);
	
	var _ManifestationListItem2 = _interopRequireDefault(_ManifestationListItem);
	
	var _utilsItem = __webpack_require__(232);
	
	var _LibrarySelector = __webpack_require__(33);
	
	var _CheckoutSelector = __webpack_require__(191);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ManifestationListItemContainer = exports.ManifestationListItemContainer = function (_BcReactComponent) {
	  _inherits(ManifestationListItemContainer, _BcReactComponent);
	
	  function ManifestationListItemContainer() {
	    _classCallCheck(this, ManifestationListItemContainer);
	
	    return _possibleConstructorReturn(this, (ManifestationListItemContainer.__proto__ || Object.getPrototypeOf(ManifestationListItemContainer)).apply(this, arguments));
	  }
	
	  _createClass(ManifestationListItemContainer, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          hold = _props.hold,
	          materialType = _props.materialType,
	          hasItemLevelHoldableItems = _props.hasItemLevelHoldableItems,
	          checkout = _props.checkout,
	          shelfItem = _props.shelfItem,
	          availabilityDetail = _props.availabilityDetail,
	          availabilityDetailActions = _props.availabilityDetailActions,
	          groupSearchFeedbackActions = _props.groupSearchFeedbackActions,
	          catalogSearchOptions = _props.catalogSearchOptions,
	          currentUser = _props.currentUser,
	          item = _props.item,
	          drawerOpen = _props.drawerOpen,
	          showGroupingDebug = _props.showGroupingDebug,
	          searchScopeIsCurrent = _props.searchScopeIsCurrent,
	          showHoldCount = _props.showHoldCount;
	
	
	      var status = (0, _utilsItem.itemTransactionStatus)(hold, materialType, hasItemLevelHoldableItems, checkout);
	      var editable = false;
	
	      if ([_utilsItem.itemTransactionConstants.CANCEL_HOLD_BUTTON, _utilsItem.itemTransactionConstants.DIGITAL_READING_LINKS].includes(status) || shelfItem) {
	        editable = true;
	      }
	
	      return _react2.default.createElement(_ManifestationListItem2.default, {
	        availabilityDetail: availabilityDetail,
	        availabilityDetailActions: availabilityDetailActions,
	        groupSearchFeedbackActions: groupSearchFeedbackActions,
	        catalogSearchOptions: catalogSearchOptions,
	        currentUser: currentUser,
	        item: item,
	        drawerOpen: drawerOpen,
	        editable: editable,
	        showGroupingDebug: showGroupingDebug,
	        searchScopeIsCurrent: searchScopeIsCurrent,
	        showHoldCount: showHoldCount });
	    }
	  }]);
	
	  return ManifestationListItemContainer;
	}(_baseBcReactComponent2.default);
	
	ManifestationListItemContainer.propTypes = {
	  materialType: _react.PropTypes.string,
	  hasItemLevelHoldableItems: _react.PropTypes.bool,
	  item: _reactImmutableProptypes2.default.map,
	  shelfItem: _reactImmutableProptypes2.default.map,
	  availabilityDetail: _reactImmutableProptypes2.default.map,
	  availabilityDetailActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  groupSearchFeedbackActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  catalogSearchOptions: _reactImmutableProptypes2.default.map,
	  currentUser: _reactImmutableProptypes2.default.map,
	  drawerOpen: _react.PropTypes.bool,
	  checkout: _reactImmutableProptypes2.default.mapContains({
	    id: _react.PropTypes.string
	  }),
	  hold: _reactImmutableProptypes2.default.mapContains({
	    id: _react.PropTypes.string,
	    status: _react.PropTypes.string
	  }),
	  searchScopeIsCurrent: _react.PropTypes.bool,
	  showHoldCount: _react.PropTypes.bool
	};
	
	ManifestationListItemContainer.displayName = 'ManifestationListItemContainer';
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  var library = (0, _LibrarySelector.currentLibrarySelector)(state);
	  var itemId = ownProps.item.get('id');
	  var currentUser = (0, _AuthSelector.currentUserSelector)(state);
	  var shelfItem = (0, _ShelfSelector.getShelvesForCurrentUser)(state).get(itemId);
	  var holds = (0, _HoldsSelector.getActiveHoldsByMetadataId)(state).get(itemId, _immutable2.default.List());
	  var checkouts = (0, _CheckoutSelector.getCheckoutsByMetadataId)(state).get(itemId, _immutable2.default.List());
	  var policy = state.getIn(['entities', 'bibs', itemId, 'policy'], _immutable2.default.Map());
	  var currentScopeId = (0, _ScopeSelector.currentSiteScopes)(state).last().get('scopeId');
	  var searchScopeIsCurrent = state.getIn(['search', 'catalogSearch', 'scope']) === currentScopeId;
	  var showHoldCount = library.get('showHoldCountInSearch');
	
	  return {
	    shelfItem: shelfItem,
	    hold: holds.size === 1 ? holds.first() : null,
	    holdable: state.getIn(['entities', 'bibs', itemId, 'policy', 'holdable'], false),
	    materialType: state.getIn(['entities', 'bibs', itemId, 'policy', 'materialType']),
	    hasItemLevelHoldableItems: policy.get('itemLevelHoldableItems'),
	    checkout: checkouts.first(),
	    availabilityDetail: state.get('availabilityDetail'),
	    catalogSearchOptions: state.getIn(['search', 'catalogSearchOptions']),
	    currentUser: currentUser,
	    showGroupingDebug: currentUser && currentUser.get('showGroupingDebug') && state.getIn(['search', 'catalogSearch', 'view']) === 'grouped',
	    searchScopeIsCurrent: searchScopeIsCurrent,
	    showHoldCount: showHoldCount
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    availabilityDetailActions: (0, _redux.bindActionCreators)(_AvailabilityDetailActions2.default, dispatch),
	    groupSearchFeedbackActions: (0, _redux.bindActionCreators)(_GroupSearchFeedbackActions2.default, dispatch)
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ManifestationListItemContainer);

/***/ },
/* 2081 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MessagesContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(14);
	
	var _reactIntl = __webpack_require__(3);
	
	var _redux = __webpack_require__(18);
	
	var _AuthSelector = __webpack_require__(21);
	
	var _AccountMessagesSelector = __webpack_require__(2171);
	
	var _MessagesActions = __webpack_require__(558);
	
	var MessagesActions = _interopRequireWildcard(_MessagesActions);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _AccountMessages = __webpack_require__(1638);
	
	var _AccountMessages2 = _interopRequireDefault(_AccountMessages);
	
	var _DocumentHeadContainer = __webpack_require__(52);
	
	var _DocumentHeadContainer2 = _interopRequireDefault(_DocumentHeadContainer);
	
	var _BasePageContainer2 = __webpack_require__(108);
	
	var _BasePageContainer3 = _interopRequireDefault(_BasePageContainer2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MessagesContainer = exports.MessagesContainer = function (_BasePageContainer) {
	  _inherits(MessagesContainer, _BasePageContainer);
	
	  function MessagesContainer() {
	    _classCallCheck(this, MessagesContainer);
	
	    return _possibleConstructorReturn(this, (MessagesContainer.__proto__ || Object.getPrototypeOf(MessagesContainer)).apply(this, arguments));
	  }
	
	  _createClass(MessagesContainer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      _get(MessagesContainer.prototype.__proto__ || Object.getPrototypeOf(MessagesContainer.prototype), 'componentDidMount', this).call(this);
	
	      var accountId = this.props.accountId;
	
	      this.props.messageActions.fetchMessages({ accountId: accountId });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var pageTitle = this.props.intl.formatMessage({ id: 'section_title_messages' });
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_DocumentHeadContainer2.default, { pageTitle: pageTitle }),
	        _react2.default.createElement(_AccountMessages2.default, this.props)
	      );
	    }
	  }], [{
	    key: 'fetchInitialData',
	    value: function fetchInitialData(params, query, store) {
	      var account = (0, _AuthSelector.currentAccountSelector)(store.getState());
	      var accountId = account && account.get('id');
	
	      return [store.dispatch(MessagesActions.fetchMessages({ accountId: accountId }))];
	    }
	  }, {
	    key: 'getBackToTitleKey',
	    value: function getBackToTitleKey() {
	      return 'messages';
	    }
	  }]);
	
	  return MessagesContainer;
	}(_BasePageContainer3.default);
	
	var mapStateToProps = function mapStateToProps(state) {
	  var user = (0, _AuthSelector.currentUserSelector)(state);
	  var messages = state.getIn(['entities', 'messages'], _immutable2.default.Map());
	  var accountMessagesStatus = (0, _AccountMessagesSelector.getAccountMessagesStatus)(state);
	  var account = (0, _AuthSelector.currentAccountSelector)(state);
	  var accountId = account.get('id');
	
	  return {
	    user: user,
	    messages: messages,
	    fetching: accountMessagesStatus.get('fetching', false),
	    accountId: accountId
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    messageActions: (0, _redux.bindActionCreators)(MessagesActions, dispatch)
	  };
	};
	
	MessagesContainer.propTypes = {
	  intl: _reactIntl.intlShape,
	  fetching: _react.PropTypes.bool,
	  messageActions: _react.PropTypes.objectOf(_react.PropTypes.func),
	  accountId: _react.PropTypes.number
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIntl.injectIntl)(MessagesContainer));

/***/ },
/* 2082 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RecentlyReturnedContainer = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _RecentlyReturnedEmptyContentPanel = __webpack_require__(567);
	
	var _RecentlyReturnedEmptyContentPanel2 = _interopRequireDefault(_RecentlyReturnedEmptyContentPanel);
	
	var _redux = __webpack_require__(18);
	
	var _reactIntl = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(14);
	
	var _ListPresentationActions = __webpack_require__(557);
	
	var _ListPresentationActions2 = _interopRequireDefault(_ListPresentationActions);
	
	var _AccountActions = __webpack_require__(556);
	
	var AccountActions = _interopRequireWildcard(_AccountActions);
	
	var _AuthSelector = __webpack_require__(21);
	
	var _BorrowingActions = __webpack_require__(180);
	
	var BorrowingActions = _interopRequireWildcard(_BorrowingActions);
	
	var _RecentlyReturnedActions = __webpack_require__(560);
	
	var RecentlyReturnedActions = _interopRequireWildcard(_RecentlyReturnedActions);
	
	var _RecentlyReturned = __webpack_require__(1777);
	
	var _RecentlyReturned2 = _interopRequireDefault(_RecentlyReturned);
	
	var _notFound = __webpack_require__(140);
	
	var _notFound2 = _interopRequireDefault(_notFound);
	
	var _LibrarySelector = __webpack_require__(33);
	
	var _RecentlyReturnedSelector = __webpack_require__(647);
	
	var _RatingsActions = __webpack_require__(280);
	
	var _RatingsActions2 = _interopRequireDefault(_RatingsActions);
	
	var _RatingsSelector = __webpack_require__(246);
	
	var _WorkflowActions = __webpack_require__(123);
	
	var _WorkflowActions2 = _interopRequireDefault(_WorkflowActions);
	
	var _ListPresentationSelector = __webpack_require__(645);
	
	var _ShelfActions = __webpack_require__(107);
	
	var _ShelfActions2 = _interopRequireDefault(_ShelfActions);
	
	var _RecentlyReturnedLoading = __webpack_require__(1788);
	
	var _RecentlyReturnedLoading2 = _interopRequireDefault(_RecentlyReturnedLoading);
	
	var _DocumentHeadContainer = __webpack_require__(52);
	
	var _DocumentHeadContainer2 = _interopRequireDefault(_DocumentHeadContainer);
	
	var _BasePageContainer2 = __webpack_require__(108);
	
	var _BasePageContainer3 = _interopRequireDefault(_BasePageContainer2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RecentlyReturnedContainer = exports.RecentlyReturnedContainer = function (_BasePageContainer) {
	  _inherits(RecentlyReturnedContainer, _BasePageContainer);
	
	  function RecentlyReturnedContainer() {
	    _classCallCheck(this, RecentlyReturnedContainer);
	
	    return _possibleConstructorReturn(this, (RecentlyReturnedContainer.__proto__ || Object.getPrototypeOf(RecentlyReturnedContainer)).apply(this, arguments));
	  }
	
	  _createClass(RecentlyReturnedContainer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      _get(RecentlyReturnedContainer.prototype.__proto__ || Object.getPrototypeOf(RecentlyReturnedContainer.prototype), 'componentDidMount', this).call(this);
	
	      var _props = this.props,
	          accountId = _props.accountId,
	          location = _props.location;
	
	      this.props.RecentlyReturnedActions.fetchReturnHistory(_extends({}, location.query, { accountId: accountId }));
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props2 = this.props,
	          location = _props2.location,
	          accountId = _props2.accountId;
	      var nextLocation = nextProps.location;
	
	      if (this.interval && nextProps.sortOptions) {
	        clearInterval(this.interval);
	        this.interval = false;
	      }
	
	      if (location !== nextLocation) {
	        this.props.RecentlyReturnedActions.fetchReturnHistory(_extends({}, nextLocation.query, { accountId: accountId }));
	      }
	    }
	  }, {
	    key: 'retryLoading',
	    value: function retryLoading() {
	      var accountId = this.props.accountId;
	
	      this.props.RecentlyReturnedActions.fetchReturnHistory(_extends({}, this.props.router.location.query, { accountId: accountId }));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var pageTitle = this.props.intl.formatMessage({ id: 'section_title_recently_returned' });
	      if (!this.props.items || this.props.items.size === 0) {
	        if (this.props.isFetching || this.props.sortOptions && this.props.recentlyReturnedSupported && this.props.saveBorrowingHistoryEnabled) {
	          return _react2.default.createElement(_RecentlyReturnedEmptyContentPanel2.default, { fetching: this.props.isFetching });
	        }
	      }
	      if (!this.interval && !this.props.isFetching && !this.props.sortOptions && this.props.recentlyReturnedSupported && this.props.saveBorrowingHistoryEnabled) {
	        this.interval = setInterval(function () {
	          _this2.retryLoading();
	        }, 5000);
	      }
	      if (!this.props.sortOptions && this.props.recentlyReturnedSupported && this.props.saveBorrowingHistoryEnabled) {
	        return _react2.default.createElement(_RecentlyReturnedLoading2.default, { retryLoading: this.retryLoading, isLoading: this.props.isFetching });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_DocumentHeadContainer2.default, { pageTitle: pageTitle }),
	        this.props.recentlyReturnedSupported ? _react2.default.createElement(_RecentlyReturned2.default, this.props) : _react2.default.createElement(_notFound2.default, null)
	      );
	    }
	  }], [{
	    key: 'fetchInitialData',
	    value: function fetchInitialData(params, query, store) {
	      var account = (0, _AuthSelector.currentAccountSelector)(store.getState());
	      var accountId = account && account.get('id');
	
	      return [store.dispatch(BorrowingActions.fetchSummaries({ accountId: accountId })), store.dispatch(RecentlyReturnedActions.fetchReturnHistory(_extends({}, params, query, { accountId: accountId })))];
	    }
	  }, {
	    key: 'getBackToTitleKey',
	    value: function getBackToTitleKey() {
	      return 'borrowing_history';
	    }
	  }]);
	
	  return RecentlyReturnedContainer;
	}(_BasePageContainer3.default);
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    RecentlyReturnedActions: (0, _redux.bindActionCreators)(RecentlyReturnedActions, dispatch),
	    workflowActions: (0, _redux.bindActionCreators)(_WorkflowActions2.default, dispatch),
	    listPresentationActions: (0, _redux.bindActionCreators)(_ListPresentationActions2.default, dispatch),
	    accountActions: (0, _redux.bindActionCreators)(AccountActions, dispatch),
	    shelfActions: (0, _redux.bindActionCreators)(_ShelfActions2.default, dispatch),
	    ratingsActions: (0, _redux.bindActionCreators)(_RatingsActions2.default, dispatch)
	  };
	};
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  var library = (0, _LibrarySelector.currentLibrarySelector)(state);
	  var recentlyReturnedSupported = library.get('recentlyReturned');
	  var user = (0, _AuthSelector.currentUserSelector)(state);
	  var accountId = (0, _AuthSelector.currentAccountSelector)(state).get('id').toString();
	  var saveBorrowingHistoryEnabled = (0, _AuthSelector.currentAccountSelector)(state).get('borrowingHistoryEnabled');
	  var items = (0, _RecentlyReturnedSelector.getRecentlyReturnedWithBibs)(state, ownProps);
	  var ilsProperties = _immutable2.default.Map({
	    supportsBorrowingHistory: library.get('supportsBorrowingHistory', false),
	    borrowingHistorySupportsReturnedDates: library.get('borrowingHistorySupportsReturnedDates', false),
	    maintainsBorrowingHistoryOnDisable: library.get('maintainsBorrowingHistoryOnDisable', false)
	  });
	  var currentView = (0, _ListPresentationSelector.getCurrentView)(state, ownProps);
	  var borrowingHistoryData = (0, _RecentlyReturnedSelector.getBorrowingHistoryData)(state);
	  var recentlyReturnedPaging = borrowingHistoryData.get('pagination', _immutable2.default.Map());
	  var returnedItemsOnLastDate = borrowingHistoryData.get('returnedItemsOnLastDate');
	  var sortOptions = borrowingHistoryData.get('sortOptions');
	  var isFetching = borrowingHistoryData.get('isFetching');
	
	  var ratingsTransactions = (0, _RatingsSelector.getRatingsTransactions)(state);
	  var ratings = (0, _RatingsSelector.getRatingsByBibs)(state);
	
	  return {
	    user: user,
	    recentlyReturnedSupported: recentlyReturnedSupported,
	    saveBorrowingHistoryEnabled: saveBorrowingHistoryEnabled,
	    recentlyReturnedPaging: recentlyReturnedPaging,
	    ilsProperties: ilsProperties,
	    items: items,
	    isFetching: isFetching,
	    currentView: currentView,
	    sortOptions: sortOptions,
	    returnedItemsOnLastDate: returnedItemsOnLastDate,
	    accountId: accountId,
	    ratings: ratings,
	    ratingsTransactions: ratingsTransactions
	  };
	};
	
	RecentlyReturnedContainer.propTypes = {
	  intl: _reactIntl.intlShape,
	  ratingsTransactions: _reactImmutableProptypes2.default.map,
	  accountId: _react.PropTypes.number
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIntl.injectIntl)(RecentlyReturnedContainer));

/***/ },
/* 2083 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RecommendationsContainer = RecommendationsContainer;
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(14);
	
	var _redux = __webpack_require__(18);
	
	var _recommendations = __webpack_require__(1461);
	
	var _recommendations2 = _interopRequireDefault(_recommendations);
	
	var _RecommendationConstants = __webpack_require__(393);
	
	var _RecommendationActions = __webpack_require__(561);
	
	var _RecommendationActions2 = _interopRequireDefault(_RecommendationActions);
	
	var _LibrarySelector = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function RecommendationsContainer(_ref) {
	  var zeroResults = _ref.zeroResults,
	      loaded = _ref.loaded,
	      item = _ref.item,
	      recommendations = _ref.recommendations,
	      type = _ref.type,
	      supportedRecommendationServices = _ref.supportedRecommendationServices,
	      recommendationActions = _ref.recommendationActions;
	
	  if (supportedRecommendationServices.isEmpty()) return null;
	  if (!item) return null;
	  return _react2.default.createElement(_recommendations2.default, {
	    recommendations: recommendations,
	    type: type,
	    loaded: loaded,
	    zeroResults: zeroResults,
	    getRecommendations: recommendationActions.getRecommendations,
	    itemId: item.get('id'), itemStatus: item.getIn(['availability', 'status']),
	    itemFormat: item.getIn(['briefInfo', 'format']) });
	}
	
	RecommendationsContainer.displayName = 'RecommendationsContainer';
	RecommendationsContainer.propTypes = {
	  item: _reactImmutableProptypes2.default.mapContains({
	    id: _react.PropTypes.string,
	    briefInfo: _reactImmutableProptypes2.default.mapContains({
	      format: _react.PropTypes.string
	    }),
	    availability: _reactImmutableProptypes2.default.mapContains({
	      status: _react.PropTypes.string
	    })
	  }),
	  loaded: _react.PropTypes.bool,
	  recommendationActions: _react.PropTypes.objectOf(_react.PropTypes.func),
	  supportedRecommendationServices: _reactImmutableProptypes2.default.listOf(_reactImmutableProptypes2.default.map),
	  recommendations: _reactImmutableProptypes2.default.listOf(_reactImmutableProptypes2.default.map),
	  type: _react.PropTypes.string,
	  zeroResults: _react.PropTypes.bool
	};
	
	// Find the first item that is of a valid format and is unavailable
	var findItemForRecommendation = function findItemForRecommendation(manifestations) {
	  return manifestations.find(function (manifestation) {
	    return _RecommendationConstants.FORMATS_WHITELIST.includes(manifestation.getIn(['briefInfo', 'format'])) && manifestation.getIn(['availability', 'status']) === 'UNAVAILABLE';
	  });
	};
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  var selectedItem = findItemForRecommendation(ownProps.manifestations);
	  var filteredRecommendationServices = (0, _LibrarySelector.currentLibrarySelector)(state).get('supportedRecommendationServices', _immutable2.default.List()).filter(function (service) {
	    return service.get('serviceName') !== 'bookish';
	  });
	  var itemRecommendations = selectedItem ? state.getIn(['recommendation', selectedItem.get('id')], _immutable2.default.Map()) : _immutable2.default.Map();
	
	  return {
	    item: selectedItem,
	    recommendations: itemRecommendations.recommendations,
	    type: itemRecommendations.type,
	    loaded: itemRecommendations.loaded,
	    zeroResults: itemRecommendations.zeroResults,
	    supportedRecommendationServices: filteredRecommendationServices
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    recommendationActions: (0, _redux.bindActionCreators)(_RecommendationActions2.default, dispatch)
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(RecommendationsContainer);

/***/ },
/* 2084 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RenewFailureOverlayContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(14);
	
	var _redux = __webpack_require__(18);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _MessagingActions = __webpack_require__(181);
	
	var _MessagingActions2 = _interopRequireDefault(_MessagingActions);
	
	var _CheckoutSelector = __webpack_require__(191);
	
	var _RenewFailureOverlay = __webpack_require__(1684);
	
	var _RenewFailureOverlay2 = _interopRequireDefault(_RenewFailureOverlay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RenewFailureOverlayContainer = exports.RenewFailureOverlayContainer = function (_BcReactComponent) {
	  _inherits(RenewFailureOverlayContainer, _BcReactComponent);
	
	  function RenewFailureOverlayContainer() {
	    _classCallCheck(this, RenewFailureOverlayContainer);
	
	    return _possibleConstructorReturn(this, (RenewFailureOverlayContainer.__proto__ || Object.getPrototypeOf(RenewFailureOverlayContainer)).apply(this, arguments));
	  }
	
	  _createClass(RenewFailureOverlayContainer, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_RenewFailureOverlay2.default, this.props);
	    }
	  }]);
	
	  return RenewFailureOverlayContainer;
	}(_baseBcReactComponent2.default);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    failures: (0, _CheckoutSelector.getRenewFailures)(state)
	  };
	};
	
	RenewFailureOverlayContainer.propTypes = {
	  messagingActions: _react.PropTypes.objectOf(_react.PropTypes.func),
	  open: _react.PropTypes.bool,
	  handleClose: _react.PropTypes.func
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    messagingActions: (0, _redux.bindActionCreators)(_MessagingActions2.default, dispatch)
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(RenewFailureOverlayContainer);

/***/ },
/* 2085 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SaveSearchContainer = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(14);
	
	var _reactRouter = __webpack_require__(17);
	
	var _redux = __webpack_require__(18);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _savedSearch = __webpack_require__(1468);
	
	var _SavedSearchActions = __webpack_require__(1589);
	
	var _SavedSearchActions2 = _interopRequireDefault(_SavedSearchActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SaveSearchContainer = exports.SaveSearchContainer = function (_BCReactComponent) {
	  _inherits(SaveSearchContainer, _BCReactComponent);
	
	  function SaveSearchContainer() {
	    _classCallCheck(this, SaveSearchContainer);
	
	    return _possibleConstructorReturn(this, (SaveSearchContainer.__proto__ || Object.getPrototypeOf(SaveSearchContainer)).apply(this, arguments));
	  }
	
	  _createClass(SaveSearchContainer, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          router = _props.router,
	          props = _objectWithoutProperties(_props, ['router']);
	
	      return _react2.default.createElement(_savedSearch.SavedSearchForm, _extends({}, props, {
	        searchQuery: router.location.query.query }));
	    }
	  }]);
	
	  return SaveSearchContainer;
	}(_baseBcReactComponent2.default);
	
	SaveSearchContainer.propTypes = {
	  isSaving: _react.PropTypes.bool,
	  isDuplicate: _react.PropTypes.bool,
	  lastNameAttempt: _react.PropTypes.string,
	  saveSearch: _react.PropTypes.func.isRequired,
	  replaceSearch: _react.PropTypes.func.isRequired,
	  chooseNewName: _react.PropTypes.func.isRequired,
	  closeWorkflow: _react.PropTypes.func.isRequired,
	  router: _reactRouter.routerShape
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    isSaving: state.getIn(['ui', 'savedSearch', 'isSaving']),
	    isDuplicate: state.getIn(['ui', 'savedSearch', 'isDuplicate']),
	    lastNameAttempt: state.getIn(['ui', 'savedSearch', 'lastNameAttempt']),
	    searchQuery: state.getIn(['search', 'catalogSearch', 'searchQuery', 'query']),
	    fieldErrors: state.getIn(['ui', 'savedSearch', 'fieldErrors'])
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return _extends({}, (0, _redux.bindActionCreators)(_SavedSearchActions2.default, dispatch));
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactRouter.withRouter)(SaveSearchContainer));

/***/ },
/* 2086 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(14);
	
	var _baseScreenReaderShortcuts = __webpack_require__(1344);
	
	var _baseScreenReaderShortcuts2 = _interopRequireDefault(_baseScreenReaderShortcuts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    screenReaderNavigation: state.getIn(['templates', 'screenReaderNavigation'])
	  };
	};
	
	var ScreenReaderNavigationContainer = function ScreenReaderNavigationContainer(_ref) {
	  var screenReaderNavigation = _ref.screenReaderNavigation;
	  return _react2.default.createElement(_baseScreenReaderShortcuts2.default, { screenReaderNavigation: screenReaderNavigation });
	};
	
	ScreenReaderNavigationContainer.displayName = 'ScreenReaderNavigationContainer';
	
	ScreenReaderNavigationContainer.propTypes = {
	  screenReaderNavigation: _react.PropTypes.string.isRequired
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(ScreenReaderNavigationContainer);

/***/ },
/* 2087 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SearchContainer = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _isEqual2 = __webpack_require__(162);
	
	var _isEqual3 = _interopRequireDefault(_isEqual2);
	
	var _debounce2 = __webpack_require__(466);
	
	var _debounce3 = _interopRequireDefault(_debounce2);
	
	var _PropTypes = __webpack_require__(90);
	
	var _PropTypes2 = _interopRequireDefault(_PropTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _reactIntl = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(14);
	
	var _redux = __webpack_require__(18);
	
	var _AvailabilityDetailActions = __webpack_require__(122);
	
	var _AvailabilityDetailActions2 = _interopRequireDefault(_AvailabilityDetailActions);
	
	var _DrawerActions = __webpack_require__(379);
	
	var _DrawerActions2 = _interopRequireDefault(_DrawerActions);
	
	var _ListPresentationActions = __webpack_require__(557);
	
	var _ListPresentationActions2 = _interopRequireDefault(_ListPresentationActions);
	
	var _RecommendationActions = __webpack_require__(561);
	
	var _RecommendationActions2 = _interopRequireDefault(_RecommendationActions);
	
	var _GroupSearchFeedbackActions = __webpack_require__(380);
	
	var _GroupSearchFeedbackActions2 = _interopRequireDefault(_GroupSearchFeedbackActions);
	
	var _SearchActions = __webpack_require__(144);
	
	var _SearchActions2 = _interopRequireDefault(_SearchActions);
	
	var _Search = __webpack_require__(1879);
	
	var _Search2 = _interopRequireDefault(_Search);
	
	var _AuthSelector = __webpack_require__(21);
	
	var _LibrarySelector = __webpack_require__(33);
	
	var _SearchSelector = __webpack_require__(400);
	
	var _BasePageContainer2 = __webpack_require__(108);
	
	var _BasePageContainer3 = _interopRequireDefault(_BasePageContainer2);
	
	var _DocumentHeadContainer = __webpack_require__(52);
	
	var _DocumentHeadContainer2 = _interopRequireDefault(_DocumentHeadContainer);
	
	var _EmptySearchResultContainer = __webpack_require__(2065);
	
	var _EmptySearchResultContainer2 = _interopRequireDefault(_EmptySearchResultContainer);
	
	var _GroupSearchFeedbackContainer = __webpack_require__(2072);
	
	var _GroupSearchFeedbackContainer2 = _interopRequireDefault(_GroupSearchFeedbackContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SEARCH_DEBOUNCE_TIME = 100;
	
	var SearchContainer = exports.SearchContainer = function (_BasePageContainer) {
	  _inherits(SearchContainer, _BasePageContainer);
	
	  _createClass(SearchContainer, null, [{
	    key: 'fetchInitialData',
	    value: function fetchInitialData(params, query, store) {
	      var view = store.getState().getIn(['search', 'catalogSearch', 'view']);
	      return [store.dispatch(_SearchActions2.default.performSearch(_extends({}, query, { view: view })))];
	    }
	  }, {
	    key: 'getBackToTitleKey',
	    value: function getBackToTitleKey() {
	      return 'search';
	    }
	  }]);
	
	  function SearchContainer(props) {
	    _classCallCheck(this, SearchContainer);
	
	    var _this = _possibleConstructorReturn(this, (SearchContainer.__proto__ || Object.getPrototypeOf(SearchContainer)).call(this, props));
	
	    _this.performSearch = (0, _debounce3.default)(function (query) {
	      return _this.props.searchActions.performSearch(query);
	    }, SEARCH_DEBOUNCE_TIME);
	    return _this;
	  }
	
	  _createClass(SearchContainer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      _get(SearchContainer.prototype.__proto__ || Object.getPrototypeOf(SearchContainer.prototype), 'componentDidMount', this).call(this);
	
	      // This is used to let the header know it's a search results page
	      document.body.classList.add('search-results');
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.body.classList.remove('search-results');
	    }
	  }, {
	    key: 'shouldSearch',
	    value: function shouldSearch(nextProps) {
	      var userChanged = this.props.currentUser !== nextProps.currentUser;
	      var viewChanged = this.props.currentView !== nextProps.currentView;
	      return userChanged || viewChanged || !(0, _isEqual3.default)(this.props.location.query, nextProps.location.query);
	    }
	  }, {
	    key: 'resetPageOnViewChange',
	    value: function resetPageOnViewChange(nextProps) {
	      var router = this.props.router;
	      var location = router.location;
	
	      var query = nextProps.router.location.query;
	      var viewChanged = this.props.currentView !== nextProps.currentView;
	
	      if (viewChanged) {
	        router.push(_extends({}, location, {
	          query: _extends({}, query, {
	            pagination_page: undefined
	          })
	        }));
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.shouldSearch(nextProps)) {
	        this.performSearch(_extends({}, nextProps.location.query, {
	          view: nextProps.currentView
	        }));
	      }
	
	      this.resetPageOnViewChange(nextProps);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          activeFilters = _props.activeFilters,
	          availabilityDetail = _props.availabilityDetail,
	          branches = _props.branches,
	          broadened = _props.broadened,
	          broadenedSearchCount = _props.broadenedSearchCount,
	          broadenedSearchType = _props.broadenedSearchType,
	          catalogSearchOptions = _props.catalogSearchOptions,
	          currentView = _props.currentView,
	          groupedSearchEnabled = _props.groupedSearchEnabled,
	          customEdit = _props.customEdit,
	          didYouMeanQuerySuggestion = _props.didYouMeanQuerySuggestion,
	          didYouMeanResultCount = _props.didYouMeanResultCount,
	          drawer = _props.drawer,
	          featuredContent = _props.featuredContent,
	          featuredContentBlockPosition = _props.featuredContentBlockPosition,
	          fields = _props.fields,
	          intl = _props.intl,
	          isFetching = _props.isFetching,
	          pagination = _props.pagination,
	          query = _props.query,
	          recommendation = _props.recommendation,
	          resultPaneActive = _props.resultPaneActive,
	          results = _props.results,
	          rssURL = _props.rssURL,
	          searchQuery = _props.searchQuery,
	          searchType = _props.searchType,
	          singleBranch = _props.singleBranch,
	          sortBys = _props.sortBys,
	          suppress = _props.suppress,
	          title = _props.title,
	          titleKey = _props.titleKey,
	          zeroResults = _props.zeroResults,
	          didNotFindOptions = _props.didNotFindOptions;
	
	      // Actions
	
	      var _props2 = this.props,
	          availabilityDetailActions = _props2.availabilityDetailActions,
	          drawerActions = _props2.drawerActions,
	          groupSearchFeedbackActions = _props2.groupSearchFeedbackActions,
	          listPresentationActions = _props2.listPresentationActions,
	          recommendationActions = _props2.recommendationActions,
	          searchActions = _props2.searchActions,
	          chatWidgets = _props2.chatWidgets;
	
	
	      if (zeroResults) {
	        return _react2.default.createElement(_EmptySearchResultContainer2.default, null);
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_DocumentHeadContainer2.default, { pageTitle: intl.formatMessage({ id: 'searchTitle' }) }),
	        _react2.default.createElement(_GroupSearchFeedbackContainer2.default, { searchResults: results }),
	        _react2.default.createElement(_Search2.default, {
	          activeFilters: activeFilters,
	          availabilityDetail: availabilityDetail,
	          availabilityDetailActions: availabilityDetailActions,
	          branches: branches,
	          broadened: broadened,
	          broadenedSearchCount: broadenedSearchCount,
	          broadenedSearchType: broadenedSearchType,
	          catalogSearchOptions: catalogSearchOptions,
	          currentUser: this.props.currentUser,
	          currentView: currentView,
	          groupedSearchEnabled: groupedSearchEnabled,
	          customEdit: customEdit,
	          didYouMeanQuerySuggestion: didYouMeanQuerySuggestion,
	          didYouMeanResultCount: didYouMeanResultCount,
	          drawer: drawer,
	          drawerActions: drawerActions,
	          featuredContent: featuredContent,
	          featuredContentBlockPosition: featuredContentBlockPosition,
	          fields: fields,
	          groupSearchFeedbackActions: groupSearchFeedbackActions,
	          isFetching: isFetching,
	          libraryShortName: this.props.libraryShortName,
	          listPresentationActions: listPresentationActions,
	          location: this.props.location,
	          locked: this.props.locked,
	          pagination: pagination,
	          query: query,
	          recommendation: recommendation,
	          recommendationActions: recommendationActions,
	          resultPaneActive: resultPaneActive,
	          results: results,
	          rssURL: rssURL,
	          searchActions: searchActions,
	          searchQuery: searchQuery,
	          searchType: searchType,
	          showExternalSearchLink: this.props.showExternalSearchLink,
	          singleBranch: singleBranch,
	          sortBys: sortBys,
	          suppress: suppress,
	          title: title,
	          titleKey: titleKey,
	          zeroResults: zeroResults,
	          router: this.props.router,
	          didNotFindOptions: didNotFindOptions,
	          orderedSearchTypes: this.props.orderedSearchTypes,
	          chatWidgets: chatWidgets }),
	        this.props.children
	      );
	    }
	  }]);
	
	  return SearchContainer;
	}(_BasePageContainer3.default);
	
	SearchContainer.propTypes = {
	  activeFilters: _reactImmutableProptypes2.default.map,
	  availabilityDetail: _reactImmutableProptypes2.default.map,
	  availabilityDetailActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  branches: _reactImmutableProptypes2.default.list,
	  broadened: _react.PropTypes.bool,
	  broadenedSearchCount: _react.PropTypes.number,
	  broadenedSearchType: _react.PropTypes.string,
	  catalogSearchOptions: _reactImmutableProptypes2.default.map,
	  children: _reactImmutableProptypes2.default.map,
	  currentUser: _reactImmutableProptypes2.default.map,
	  currentView: _react.PropTypes.string,
	  groupedSearchEnabled: _react.PropTypes.bool.isRequired,
	  customEdit: _react.PropTypes.bool,
	  didYouMeanQuerySuggestion: _react.PropTypes.string,
	  didYouMeanResultCount: _react.PropTypes.number,
	  drawer: _reactImmutableProptypes2.default.map,
	  drawerActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  featuredContentBlockPosition: _react.PropTypes.number,
	  fields: _reactImmutableProptypes2.default.list,
	  groupSearchFeedbackActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  intl: _reactIntl.intlShape,
	  isFetching: _react.PropTypes.bool,
	  libraryName: _reactImmutableProptypes2.default.map,
	  libraryShortName: _react.PropTypes.string.isRequired,
	  listPresentationActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  location: _react.PropTypes.shape(_PropTypes2.default),
	  locked: _react.PropTypes.bool,
	  pagination: _reactImmutableProptypes2.default.map,
	  query: _react.PropTypes.string.isRequired,
	  recommendation: _reactImmutableProptypes2.default.map,
	  recommendationActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  resultPaneActive: _react.PropTypes.bool,
	  results: _reactImmutableProptypes2.default.list,
	  rssURL: _react.PropTypes.string,
	  searchActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  searchQuery: _reactImmutableProptypes2.default.map,
	  searchType: _react.PropTypes.string.isRequired,
	  showExternalSearchLink: _react.PropTypes.bool,
	  singleBranch: _react.PropTypes.bool,
	  sortBys: _reactImmutableProptypes2.default.list,
	  suppress: _react.PropTypes.bool,
	  title: _react.PropTypes.string,
	  titleKey: _react.PropTypes.string,
	  zeroResults: _react.PropTypes.bool,
	  didNotFindOptions: _reactImmutableProptypes2.default.map,
	  chatWidgets: _reactImmutableProptypes2.default.mapOf(_react.PropTypes.object)
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  var catalogSearch = state.getIn(['search', 'catalogSearch']);
	  var library = (0, _LibrarySelector.currentLibrarySelector)(state);
	  return {
	    activeFilters: catalogSearch.get('activeFilters'),
	    availabilityDetail: state.get('availabilityDetail'),
	    branches: library.get('branches'),
	    broadened: catalogSearch.get('broadened'),
	    broadenedSearchCount: catalogSearch.get('broadenedSearchCount'),
	    broadenedSearchType: catalogSearch.get('broadenedSearchType'),
	    catalogSearchOptions: state.getIn(['search', 'catalogSearchOptions']),
	    currentUser: (0, _AuthSelector.currentUserSelector)(state),
	    currentView: catalogSearch.get('view'),
	    groupedSearchEnabled: catalogSearch.get('groupedSearchEnabled'),
	    customEdit: catalogSearch.get('custom_edit'),
	    didYouMeanQuerySuggestion: catalogSearch.get('didYouMeanQuerySuggestion'),
	    didYouMeanResultCount: catalogSearch.get('didYouMeanResultCount'),
	    drawer: state.get('drawer'),
	    featuredContentBlockPosition: library.get('featuredContentBlockPosition'),
	    fields: catalogSearch.get('fields'),
	    isFetching: catalogSearch.get('isFetching'),
	    libraryShortName: library.get('shortName'),
	    orderedSearchTypes: library.get('orderedSearchTypes', _immutable2.default.List()),
	    locked: catalogSearch.get('locked'),
	    pagination: catalogSearch.get('pagination'),
	    query: catalogSearch.get('query'),
	    recommendation: state.get('recommendation'),
	    resultPaneActive: catalogSearch.get('resultPaneActive'),
	    results: (0, _SearchSelector.searchResultBibSelector)(state),
	    rssURL: catalogSearch.get('rssURL'),
	    searchType: catalogSearch.get('searchType'),
	    showExternalSearchLink: library.get('showExternalSearchLink'),
	    singleBranch: library.get('singleBranch'),
	    sortBys: catalogSearch.get('sortBys'),
	    suppress: catalogSearch.get('suppress'),
	    title: catalogSearch.get('title'),
	    titleKey: catalogSearch.get('title_key'),
	    zeroResults: catalogSearch.get('zeroResults'),
	    didNotFindOptions: library.get('didNotFindOptions'),
	    chatWidgets: library.get('chatWidgets')
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    searchActions: (0, _redux.bindActionCreators)(_SearchActions2.default, dispatch),
	    drawerActions: (0, _redux.bindActionCreators)(_DrawerActions2.default, dispatch),
	    recommendationActions: (0, _redux.bindActionCreators)(_RecommendationActions2.default, dispatch),
	    availabilityDetailActions: (0, _redux.bindActionCreators)(_AvailabilityDetailActions2.default, dispatch),
	    listPresentationActions: (0, _redux.bindActionCreators)(_ListPresentationActions2.default, dispatch),
	    groupSearchFeedbackActions: (0, _redux.bindActionCreators)(_GroupSearchFeedbackActions2.default, dispatch)
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIntl.injectIntl)(SearchContainer));

/***/ },
/* 2088 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(14);
	
	var _redux = __webpack_require__(18);
	
	var _ScopeSelector = __webpack_require__(648);
	
	var _LibrarySelector = __webpack_require__(33);
	
	var _SearchActions = __webpack_require__(144);
	
	var _SearchActions2 = _interopRequireDefault(_SearchActions);
	
	var _SearchScopeField = __webpack_require__(1889);
	
	var _SearchScopeField2 = _interopRequireDefault(_SearchScopeField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    scopes: (0, _ScopeSelector.currentSiteScopes)(state),
	    currentSearchScope: state.getIn(['search', 'catalogSearch', 'scope']),
	    scopeFacetEnabled: (0, _LibrarySelector.currentLibrarySelector)(state).get('scopeFacetEnabled')
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    searchActions: (0, _redux.bindActionCreators)(_SearchActions2.default, dispatch)
	  };
	};
	
	var SearchScopeFieldContainer = function SearchScopeFieldContainer(_ref) {
	  var scopes = _ref.scopes,
	      currentSearchScope = _ref.currentSearchScope,
	      scopeFacetEnabled = _ref.scopeFacetEnabled;
	
	  if (!scopeFacetEnabled || typeof scopes === 'undefined' || scopes.size <= 1) {
	    return null;
	  }
	  return _react2.default.createElement(_SearchScopeField2.default, { scopes: scopes, currentSearchScope: currentSearchScope });
	};
	
	SearchScopeFieldContainer.propTypes = {
	  scopes: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	    scopeName: _react.PropTypes.string.isRequired,
	    scopeId: _react.PropTypes.string.isRequired,
	    parentScopeId: _react.PropTypes.string.isRequired
	  }).isRequired),
	  scopeFacetEnabled: _react.PropTypes.bool.isRequired,
	  currentSearchScope: _react.PropTypes.string.isRequired
	};
	
	SearchScopeFieldContainer.displayName = 'SearchScopFieldContainer';
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SearchScopeFieldContainer);

/***/ },
/* 2089 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ShelfContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _reactIntl = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(14);
	
	var _redux = __webpack_require__(18);
	
	var _isEqual = __webpack_require__(162);
	
	var _isEqual2 = _interopRequireDefault(_isEqual);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _utilsImmutable = __webpack_require__(374);
	
	var _AuthSelector = __webpack_require__(21);
	
	var _UserSelector = __webpack_require__(401);
	
	var _CommentsSelector = __webpack_require__(2176);
	
	var _QuotationsSelector = __webpack_require__(2179);
	
	var _RatingsSelector = __webpack_require__(246);
	
	var _TagsSelector = __webpack_require__(2181);
	
	var _VideosSelector = __webpack_require__(2182);
	
	var _IOwnThisSelector = __webpack_require__(2177);
	
	var _SimilarTitlesSelector = __webpack_require__(2180);
	
	var _PrivateNotesSelector = __webpack_require__(2178);
	
	var _LibrarySelector = __webpack_require__(33);
	
	var _NoticeSelector = __webpack_require__(646);
	
	var _DocumentHeadContainer = __webpack_require__(52);
	
	var _DocumentHeadContainer2 = _interopRequireDefault(_DocumentHeadContainer);
	
	var _Shelf = __webpack_require__(2007);
	
	var _Shelf2 = _interopRequireDefault(_Shelf);
	
	var _FeatureFlagContainer = __webpack_require__(147);
	
	var _FeatureFlagContainer2 = _interopRequireDefault(_FeatureFlagContainer);
	
	var _OptInContainer = __webpack_require__(637);
	
	var _OptInContainer2 = _interopRequireDefault(_OptInContainer);
	
	var _BasePageContainer2 = __webpack_require__(108);
	
	var _BasePageContainer3 = _interopRequireDefault(_BasePageContainer2);
	
	var _ShelfSelector = __webpack_require__(75);
	
	var _AvailabilityDetailActions = __webpack_require__(122);
	
	var _AvailabilityDetailActions2 = _interopRequireDefault(_AvailabilityDetailActions);
	
	var _CommentsActions = __webpack_require__(1578);
	
	var _CommentsActions2 = _interopRequireDefault(_CommentsActions);
	
	var _DrawerActions = __webpack_require__(379);
	
	var _DrawerActions2 = _interopRequireDefault(_DrawerActions);
	
	var _QuotationsActions = __webpack_require__(1588);
	
	var _QuotationsActions2 = _interopRequireDefault(_QuotationsActions);
	
	var _RatingsActions = __webpack_require__(280);
	
	var _RatingsActions2 = _interopRequireDefault(_RatingsActions);
	
	var _TagsActions = __webpack_require__(1592);
	
	var _TagsActions2 = _interopRequireDefault(_TagsActions);
	
	var _VideosActions = __webpack_require__(1594);
	
	var _VideosActions2 = _interopRequireDefault(_VideosActions);
	
	var _IOwnThisActions = __webpack_require__(1583);
	
	var _IOwnThisActions2 = _interopRequireDefault(_IOwnThisActions);
	
	var _NoticeActions = __webpack_require__(559);
	
	var _NoticeActions2 = _interopRequireDefault(_NoticeActions);
	
	var _SimilarTitlesActions = __webpack_require__(1590);
	
	var _SimilarTitlesActions2 = _interopRequireDefault(_SimilarTitlesActions);
	
	var _PrivateNotesActions = __webpack_require__(1587);
	
	var _PrivateNotesActions2 = _interopRequireDefault(_PrivateNotesActions);
	
	var _ShelfActions = __webpack_require__(107);
	
	var _ShelfActions2 = _interopRequireDefault(_ShelfActions);
	
	var _WorkflowActions = __webpack_require__(123);
	
	var _WorkflowActions2 = _interopRequireDefault(_WorkflowActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ShelfContainer = exports.ShelfContainer = function (_BasePageContainer) {
	  _inherits(ShelfContainer, _BasePageContainer);
	
	  function ShelfContainer() {
	    _classCallCheck(this, ShelfContainer);
	
	    return _possibleConstructorReturn(this, (ShelfContainer.__proto__ || Object.getPrototypeOf(ShelfContainer)).apply(this, arguments));
	  }
	
	  _createClass(ShelfContainer, [{
	    key: 'getBackToTitleKey',
	    value: function getBackToTitleKey() {
	      var params = this.props.params;
	
	      return params.shelfName + '_shelf';
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props = this.props,
	          location = _props.location,
	          owner = _props.owner,
	          currentUser = _props.currentUser;
	      var nextLocation = nextProps.location,
	          nextParams = nextProps.params,
	          nextCurrentUser = nextProps.currentUser;
	
	
	      if (!(0, _isEqual2.default)(location, nextLocation) || !(0, _utilsImmutable.shallowEquals)(currentUser, nextCurrentUser)) {
	        this.props.shelfActions.searchUserShelf(nextParams.shelfName, owner.get('id'), nextLocation.query);
	      }
	    }
	  }, {
	    key: 'getPrintUrl',
	    value: function getPrintUrl() {
	      var _props2 = this.props,
	          location = _props2.location,
	          params = _props2.params,
	          owner = _props2.owner;
	
	      return '/v2/print/users/' + owner.get('id') + '/shelves/' + params.shelfName + location.search;
	    }
	  }, {
	    key: 'renderOptIn',
	    value: function renderOptIn() {
	      return _react2.default.createElement(_OptInContainer2.default, {
	        optedIn: true,
	        bundleName: 'nerf_shelves',
	        allowDismiss: false,
	        showAdditionalMessage: true,
	        location: this.props.location });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          activeFilters = _props3.activeFilters,
	          currentAccount = _props3.currentAccount,
	          currentLibrary = _props3.currentLibrary,
	          drawer = _props3.drawer,
	          intl = _props3.intl,
	          isFetching = _props3.isFetching,
	          owner = _props3.owner,
	          shelf = _props3.shelf,
	          summary = _props3.summary,
	          bibs = _props3.bibs,
	          commentsTransactions = _props3.commentsTransactions,
	          quotationsTransactions = _props3.quotationsTransactions,
	          ratingsTransactions = _props3.ratingsTransactions,
	          tagsTransactions = _props3.tagsTransactions,
	          videosTransactions = _props3.videosTransactions,
	          iOwnThisTransactions = _props3.iOwnThisTransactions,
	          similarTitlesTransactions = _props3.similarTitlesTransactions,
	          privateNotesTransactions = _props3.privateNotesTransactions,
	          shelfTransactions = _props3.shelfTransactions,
	          localBranch = _props3.localBranch,
	          importResult = _props3.importResult,
	          ownerComments = _props3.ownerComments,
	          ownerQuotations = _props3.ownerQuotations,
	          ownerRatings = _props3.ownerRatings,
	          ownerTags = _props3.ownerTags,
	          ownerVideos = _props3.ownerVideos,
	          iOwnThisSettings = _props3.iOwnThisSettings,
	          ownerSimilarTitles = _props3.ownerSimilarTitles,
	          ownerPrivateNotes = _props3.ownerPrivateNotes,
	          hiddenNotices = _props3.hiddenNotices,
	          currentUserShelves = _props3.currentUserShelves;
	
	      // Actions
	
	      var _props4 = this.props,
	          availabilityDetailActions = _props4.availabilityDetailActions,
	          commentsActions = _props4.commentsActions,
	          drawerActions = _props4.drawerActions,
	          quotationsActions = _props4.quotationsActions,
	          ratingsActions = _props4.ratingsActions,
	          tagsActions = _props4.tagsActions,
	          videosActions = _props4.videosActions,
	          iOwnThisActions = _props4.iOwnThisActions,
	          noticeActions = _props4.noticeActions,
	          similarTitlesActions = _props4.similarTitlesActions,
	          privateNotesActions = _props4.privateNotesActions,
	          shelfActions = _props4.shelfActions,
	          workflowActions = _props4.workflowActions;
	
	
	      var pageTitleId = 'section_title_users_' + shelf.get('name') + '_shelf';
	      var pageTitle = intl.formatMessage({ id: pageTitleId }, { username: owner.get('name') });
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_DocumentHeadContainer2.default, { pageTitle: pageTitle }),
	        _react2.default.createElement(
	          _FeatureFlagContainer2.default,
	          null,
	          function (flags) {
	            return flags.get('nerfShelves') ? null : _this2.renderOptIn();
	          }
	        ),
	        _react2.default.createElement(_Shelf2.default, {
	          activeFilters: activeFilters,
	          currentAccount: currentAccount,
	          currentLibrary: currentLibrary,
	          drawer: drawer,
	          isFetching: isFetching,
	          owner: owner,
	          pageTitle: pageTitle,
	          printURL: this.getPrintUrl(),
	          shelf: shelf,
	          summary: summary,
	          bibs: bibs,
	          commentsTransactions: commentsTransactions,
	          quotationsTransactions: quotationsTransactions,
	          ratingsTransactions: ratingsTransactions,
	          tagsTransactions: tagsTransactions,
	          videosTransactions: videosTransactions,
	          iOwnThisTransactions: iOwnThisTransactions,
	          shelfTransactions: shelfTransactions,
	          similarTitlesTransactions: similarTitlesTransactions,
	          privateNotesTransactions: privateNotesTransactions,
	          localBranch: localBranch,
	          importResult: importResult,
	          ownerComments: ownerComments,
	          ownerQuotations: ownerQuotations,
	          ownerRatings: ownerRatings,
	          ownerTags: ownerTags,
	          ownerVideos: ownerVideos,
	          iOwnThisSettings: iOwnThisSettings,
	          ownerSimilarTitles: ownerSimilarTitles,
	          ownerPrivateNotes: ownerPrivateNotes,
	          hiddenNotices: hiddenNotices,
	          availabilityDetailActions: availabilityDetailActions,
	          commentsActions: commentsActions,
	          quotationsActions: quotationsActions,
	          drawerActions: drawerActions,
	          ratingsActions: ratingsActions,
	          tagsActions: tagsActions,
	          videosActions: videosActions,
	          iOwnThisActions: iOwnThisActions,
	          noticeActions: noticeActions,
	          similarTitlesActions: similarTitlesActions,
	          privateNotesActions: privateNotesActions,
	          shelfActions: shelfActions,
	          workflowActions: workflowActions,
	          currentUserShelves: currentUserShelves }),
	        this.props.children
	      );
	    }
	  }], [{
	    key: 'fetchInitialData',
	    value: function fetchInitialData(params, query, store) {
	      var user = params.userId ? (0, _UserSelector.getRequestedUser)(store.getState()) : (0, _AuthSelector.currentUserSelector)(store.getState());
	      var userId = user && user.get('id');
	
	      if (userId && params.shelfName) {
	        return [store.dispatch(_ShelfActions2.default.searchUserShelf(params.shelfName, userId, query))];
	      }
	
	      return [];
	    }
	  }]);
	
	  return ShelfContainer;
	}(_BasePageContainer3.default);
	
	var drawerShape = _reactImmutableProptypes2.default.contains({
	  open: _react.PropTypes.bool
	});
	
	var importResultShape = _reactImmutableProptypes2.default.mapContains({
	  count: _react.PropTypes.number,
	  status: _react.PropTypes.string
	});
	
	ShelfContainer.propTypes = {
	  currentAccount: _bcPropTypes.accountShape,
	  importResult: importResultShape,
	  localBranch: _react.PropTypes.string,
	  currentLibrary: _reactImmutableProptypes2.default.map.isRequired,
	  currentUser: _reactImmutableProptypes2.default.map,
	  drawer: drawerShape.isRequired,
	  isFetching: _react.PropTypes.bool.isRequired,
	  owner: _bcPropTypes.userIdentityShape.isRequired,
	  shelf: _bcPropTypes.shelfShape.isRequired,
	  activeFilters: _reactImmutableProptypes2.default.map.isRequired,
	  summary: _reactImmutableProptypes2.default.map.isRequired,
	  bibs: _reactImmutableProptypes2.default.map.isRequired,
	  ownerRatings: _reactImmutableProptypes2.default.map.isRequired,
	  ownerComments: _reactImmutableProptypes2.default.map.isRequired,
	  ownerQuotations: _reactImmutableProptypes2.default.map.isRequired,
	  ownerTags: _reactImmutableProptypes2.default.map.isRequired,
	  ownerVideos: _reactImmutableProptypes2.default.map.isRequired,
	  iOwnThisSettings: _reactImmutableProptypes2.default.map.isRequired,
	  ownerSimilarTitles: _reactImmutableProptypes2.default.map.isRequired,
	  ownerPrivateNotes: _reactImmutableProptypes2.default.map.isRequired,
	  commentsTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  quotationsTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  ratingsTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  tagsTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  videosTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  iOwnThisTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  similarTitlesTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  privateNotesTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  shelfTransactions: _reactImmutableProptypes2.default.map.isRequired,
	  hiddenNotices: _reactImmutableProptypes2.default.set.isRequired,
	  availabilityDetailActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  commentsActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  quotationsActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  drawerActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  ratingsActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  tagsActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  similarTitlesActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  privateNotesActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  noticeActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  iOwnThisActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  shelfActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  workflowActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  intl: _reactIntl.intlShape.isRequired,
	  currentUserShelves: _reactImmutableProptypes2.default.map.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  var owner = (0, _ShelfSelector.getShelfOwner)(state);
	  var ownerId = owner.get('id');
	
	  return {
	    owner: owner,
	    currentUserShelves: (0, _ShelfSelector.getShelvesForCurrentUser)(state),
	    activeFilters: (0, _ShelfSelector.getActiveShelfFilters)(state),
	    currentAccount: (0, _AuthSelector.currentAccountSelector)(state),
	    currentLibrary: (0, _LibrarySelector.currentLibrarySelector)(state),
	    currentUser: (0, _AuthSelector.currentUserSelector)(state),
	    drawer: state.get('drawer'),
	    bibs: state.getIn(['entities', 'bibs'], _immutable2.default.Map()),
	    isFetching: state.getIn(['shelves', 'shelfSearch', 'isFetching']),
	    localBranch: state.getIn(['app', 'localBranch']),
	    shelf: (0, _ShelfSelector.getRequestedShelf)(state),
	    summary: (0, _ShelfSelector.getShelvesSummary)(state),
	    ownerSimilarTitles: (0, _SimilarTitlesSelector.getSimilarTitlesByUsers)(state).get(ownerId, _immutable2.default.Map()),
	    ownerComments: (0, _CommentsSelector.getCommentsByUsers)(state).get(ownerId, _immutable2.default.Map()),
	    ownerQuotations: (0, _QuotationsSelector.getQuotationsByUsers)(state).get(ownerId, _immutable2.default.Map()),
	    ownerRatings: (0, _RatingsSelector.getRatingsByUsers)(state).get(ownerId, _immutable2.default.Map()),
	    ownerTags: (0, _TagsSelector.getTagsByUsers)(state).get(ownerId, _immutable2.default.Map()),
	    ownerVideos: (0, _VideosSelector.getVideosByUsers)(state).get(ownerId, _immutable2.default.Map()),
	    ownerPrivateNotes: (0, _PrivateNotesSelector.getPrivateNotesByUsers)(state).get(ownerId, _immutable2.default.Map()),
	    iOwnThisSettings: (0, _IOwnThisSelector.getIOwnThisByUsers)(state).get(ownerId, _immutable2.default.Map()),
	    commentsTransactions: (0, _CommentsSelector.getCommentsTransactions)(state),
	    quotationsTransactions: (0, _QuotationsSelector.getQuotationsTransactions)(state),
	    ratingsTransactions: (0, _RatingsSelector.getRatingsTransactions)(state),
	    tagsTransactions: (0, _TagsSelector.getTagsTransactions)(state),
	    videosTransactions: (0, _VideosSelector.getVideosTransactions)(state),
	    shelfTransactions: (0, _ShelfSelector.getShelfTransactions)(state),
	    iOwnThisTransactions: (0, _IOwnThisSelector.getIOwnThisTransactions)(state),
	    similarTitlesTransactions: (0, _SimilarTitlesSelector.getSimilarTitlesTransactions)(state),
	    privateNotesTransactions: (0, _PrivateNotesSelector.getPrivateNotesTransactions)(state),
	    importResult: (0, _ShelfSelector.getImportResult)(state),
	    hiddenNotices: (0, _NoticeSelector.getHiddenNotices)(state)
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    availabilityDetailActions: (0, _redux.bindActionCreators)(_AvailabilityDetailActions2.default, dispatch),
	    commentsActions: (0, _redux.bindActionCreators)(_CommentsActions2.default, dispatch),
	    quotationsActions: (0, _redux.bindActionCreators)(_QuotationsActions2.default, dispatch),
	    videosActions: (0, _redux.bindActionCreators)(_VideosActions2.default, dispatch),
	    iOwnThisActions: (0, _redux.bindActionCreators)(_IOwnThisActions2.default, dispatch),
	    drawerActions: (0, _redux.bindActionCreators)(_DrawerActions2.default, dispatch),
	    ratingsActions: (0, _redux.bindActionCreators)(_RatingsActions2.default, dispatch),
	    tagsActions: (0, _redux.bindActionCreators)(_TagsActions2.default, dispatch),
	    noticeActions: (0, _redux.bindActionCreators)(_NoticeActions2.default, dispatch),
	    shelfActions: (0, _redux.bindActionCreators)(_ShelfActions2.default, dispatch),
	    similarTitlesActions: (0, _redux.bindActionCreators)(_SimilarTitlesActions2.default, dispatch),
	    privateNotesActions: (0, _redux.bindActionCreators)(_PrivateNotesActions2.default, dispatch),
	    workflowActions: (0, _redux.bindActionCreators)(_WorkflowActions2.default, dispatch)
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIntl.injectIntl)(ShelfContainer));

/***/ },
/* 2090 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SingleClickHoldsPanelContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _redux = __webpack_require__(18);
	
	var _reactRedux = __webpack_require__(14);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _AccountActions = __webpack_require__(556);
	
	var AccountActions = _interopRequireWildcard(_AccountActions);
	
	var _LibrarySelector = __webpack_require__(33);
	
	var _AuthSelector = __webpack_require__(21);
	
	var _SingleClickHoldsPanel = __webpack_require__(1841);
	
	var _SingleClickHoldsPanel2 = _interopRequireDefault(_SingleClickHoldsPanel);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SingleClickHoldsPanelContainer = exports.SingleClickHoldsPanelContainer = function (_BcReactComponent) {
	  _inherits(SingleClickHoldsPanelContainer, _BcReactComponent);
	
	  function SingleClickHoldsPanelContainer() {
	    _classCallCheck(this, SingleClickHoldsPanelContainer);
	
	    return _possibleConstructorReturn(this, (SingleClickHoldsPanelContainer.__proto__ || Object.getPrototypeOf(SingleClickHoldsPanelContainer)).apply(this, arguments));
	  }
	
	  _createClass(SingleClickHoldsPanelContainer, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_SingleClickHoldsPanel2.default, this.props);
	    }
	  }]);
	
	  return SingleClickHoldsPanelContainer;
	}(_baseBcReactComponent2.default);
	
	SingleClickHoldsPanelContainer.propTypes = {};
	
	var mapStateToProps = function mapStateToProps(state) {
	  var branches = (0, _LibrarySelector.sortedPickupBranchSelector)(state);
	  var account = (0, _AuthSelector.currentAccountSelector)(state);
	  var singleClickHoldsSettings = account && account.get('singleClickHoldsSettings', _immutable2.default.Map());
	  return {
	    accountId: account.get('id'),
	    branches: branches,
	    singleClickHoldsSettings: singleClickHoldsSettings
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    accountActions: (0, _redux.bindActionCreators)(AccountActions, dispatch)
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SingleClickHoldsPanelContainer);
	
	
	SingleClickHoldsPanelContainer.propTypes = {
	  accountId: _react.PropTypes.number,
	  singleClickHoldsEnabled: _react.PropTypes.bool,
	  branches: _reactImmutableProptypes2.default.listOf(_bcPropTypes.branchShape),
	  singleClickHoldsSettings: _bcPropTypes.singleClickHoldsSettingsShape,
	  accountActions: _react.PropTypes.objectOf(_react.PropTypes.func)
	};

/***/ },
/* 2091 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(14);
	
	var _redux = __webpack_require__(18);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _StackMapActions = __webpack_require__(562);
	
	var _StackMapActions2 = _interopRequireDefault(_StackMapActions);
	
	var _stackmap = __webpack_require__(1546);
	
	var _LibrarySelector = __webpack_require__(33);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _utilsGoogleAnalytics = __webpack_require__(231);
	
	var _utilsGoogleAnalytics2 = _interopRequireDefault(_utilsGoogleAnalytics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StackMapContainer = function (_BcReactComponent) {
	  _inherits(StackMapContainer, _BcReactComponent);
	
	  function StackMapContainer() {
	    _classCallCheck(this, StackMapContainer);
	
	    return _possibleConstructorReturn(this, (StackMapContainer.__proto__ || Object.getPrototypeOf(StackMapContainer)).apply(this, arguments));
	  }
	
	  _createClass(StackMapContainer, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (!this.props.isFetching && prevProps.isFetching) {
	        _utilsGoogleAnalytics2.default.event({
	          eventCategory: 'stack-map',
	          eventAction: 'map-found',
	          eventLabel: this.props.callno,
	          eventValue: this.props.noResults ? 0 : 1
	        }, true);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.open ? _react2.default.createElement(_stackmap.StackmapOverlay, this.props) : null;
	    }
	  }]);
	
	  return StackMapContainer;
	}(_baseBcReactComponent2.default);
	
	StackMapContainer.propTypes = {
	  open: _react.PropTypes.bool,
	  hideRanges: _react.PropTypes.bool
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  var library = (0, _LibrarySelector.currentLibrarySelector)(state);
	
	  return _extends({
	    noResults: state.getIn(['ui', 'stackmap', 'noResults']),
	    isFetching: state.getIn(['ui', 'stackmap', 'isFetching']),
	    open: state.getIn(['ui', 'stackmap', 'open']),
	    domain: library.getIn(['stackMap', 'domain']),
	    hideRanges: library.getIn(['stackMap', 'hideRanges'])
	  }, (state.getIn(['ui', 'stackmap', 'data']) || _immutable2.default.Map()).toObject());
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return _extends({}, (0, _redux.bindActionCreators)(_StackMapActions2.default, dispatch));
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(StackMapContainer);

/***/ },
/* 2092 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.StaffTakeoverContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(14);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _sharedStaffTakeoverMessage = __webpack_require__(1510);
	
	var _sharedStaffTakeoverMessage2 = _interopRequireDefault(_sharedStaffTakeoverMessage);
	
	var _AuthSelector = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StaffTakeoverContainer = exports.StaffTakeoverContainer = function (_BcReactComponent) {
	  _inherits(StaffTakeoverContainer, _BcReactComponent);
	
	  function StaffTakeoverContainer() {
	    _classCallCheck(this, StaffTakeoverContainer);
	
	    return _possibleConstructorReturn(this, (StaffTakeoverContainer.__proto__ || Object.getPrototypeOf(StaffTakeoverContainer)).apply(this, arguments));
	  }
	
	  _createClass(StaffTakeoverContainer, [{
	    key: 'render',
	    value: function render() {
	      if (this.props.name && this.props.showStaffTakeover) {
	        return _react2.default.createElement(_sharedStaffTakeoverMessage2.default, this.props);
	      }
	      return _react2.default.createElement('noop', null);
	    }
	  }]);
	
	  return StaffTakeoverContainer;
	}(_baseBcReactComponent2.default);
	
	StaffTakeoverContainer.propTypes = {
	  name: _react.PropTypes.string,
	  showStaffTakeover: _react.PropTypes.bool
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  var currentUser = (0, _AuthSelector.currentUserSelector)(state);
	  return {
	    name: currentUser && currentUser.get('name'),
	    showStaffTakeover: currentUser && currentUser.get('staffTakeover')
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(StaffTakeoverContainer);

/***/ },
/* 2093 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _reactRedux = __webpack_require__(14);
	
	var _redux = __webpack_require__(18);
	
	var _NoticeActions = __webpack_require__(559);
	
	var _NoticeActions2 = _interopRequireDefault(_NoticeActions);
	
	var _SystemMessageActions = __webpack_require__(1591);
	
	var _SystemMessageActions2 = _interopRequireDefault(_SystemMessageActions);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _sharedSystemMessage = __webpack_require__(1512);
	
	var _sharedSystemMessage2 = _interopRequireDefault(_sharedSystemMessage);
	
	var _SystemMessageSelector = __webpack_require__(2175);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function mapStateToProps(state) {
	  return {
	    localBranch: !!state.getIn(['app', 'localBranch']),
	    systemMessages: (0, _SystemMessageSelector.getVisibleMessages)(state)
	  };
	}
	
	var propTypes = {
	  dispatch: _react.PropTypes.func.isRequired,
	  systemMessages: _reactImmutableProptypes2.default.list.isRequired,
	  localBranch: _react.PropTypes.bool,
	  priority: _react.PropTypes.string.isRequired
	};
	
	var SystemMessagesContainer = function (_BcReactComponent) {
	  _inherits(SystemMessagesContainer, _BcReactComponent);
	
	  function SystemMessagesContainer(props) {
	    _classCallCheck(this, SystemMessagesContainer);
	
	    var _this = _possibleConstructorReturn(this, (SystemMessagesContainer.__proto__ || Object.getPrototypeOf(SystemMessagesContainer)).call(this, props));
	
	    _this.bindAll('renderMessage');
	    _this.systemMessageActions = (0, _redux.bindActionCreators)(_SystemMessageActions2.default, props.dispatch);
	    _this.noticeActions = (0, _redux.bindActionCreators)(_NoticeActions2.default, props.dispatch);
	    return _this;
	  }
	
	  _createClass(SystemMessagesContainer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.systemMessageActions.fetchSystemMessages(this.props.priority);
	    }
	  }, {
	    key: 'renderMessage',
	    value: function renderMessage(message) {
	      var localBranch = this.props.localBranch;
	
	      return _react2.default.createElement(_sharedSystemMessage2.default, { key: message.get('id'), message: message, dismissable: !localBranch, noticeActions: this.noticeActions });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.props.systemMessages.valueSeq().map(this.renderMessage)
	      );
	    }
	  }]);
	
	  return SystemMessagesContainer;
	}(_baseBcReactComponent2.default);
	
	SystemMessagesContainer.propTypes = propTypes;
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(SystemMessagesContainer);

/***/ },
/* 2094 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(14);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _sharedUgcEditors = __webpack_require__(278);
	
	var _AuthSelector = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Missing several props and methods from core implementation, as well as the PrivacyToggleContainer implementation.
	
	var PrimaryCommentEditorContainer = function (_BcReactComponent) {
	  _inherits(PrimaryCommentEditorContainer, _BcReactComponent);
	
	  function PrimaryCommentEditorContainer(props) {
	    _classCallCheck(this, PrimaryCommentEditorContainer);
	
	    var _this = _possibleConstructorReturn(this, (PrimaryCommentEditorContainer.__proto__ || Object.getPrototypeOf(PrimaryCommentEditorContainer)).call(this, props));
	
	    _this.state = {
	      showForm: true,
	      initialComment: '',
	      comment: '',
	      bibId: props.bibId,
	      isNew: true,
	      userContentId: null,
	      expanded: false,
	      initializingStatus: {
	        status: 'success',
	        localeKey: null
	      },
	      user: props.user
	    };
	
	    _this.bindAll('handleChange', 'handleFocus', 'handleBlur');
	    return _this;
	  }
	
	  _createClass(PrimaryCommentEditorContainer, [{
	    key: 'handleFocus',
	    value: function handleFocus() {
	      this.setState({
	        expanded: true
	      });
	    }
	  }, {
	    key: 'handleBlur',
	    value: function handleBlur() {
	      this.setState({
	        expanded: false
	      });
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(value) {
	      this.setState({
	        comment: value,
	        isEmpty: value.length <= 0
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_sharedUgcEditors.PrimaryCommentEditor, {
	        characterLimit: 4000,
	        bibId: this.props.bibId,
	        comment: this.state.comment,
	        expanded: this.state.expanded,
	        handleLogin: PrimaryCommentEditorContainer.handleLogin,
	        handleBlur: this.handleBlur,
	        handleChange: this.handleChange,
	        handleFocus: this.handleFocus,
	        isNew: this.state.isNew,
	        showForm: this.state.showForm,
	        handleSubmit: PrimaryCommentEditorContainer.handleSubmit,
	        isEmpty: this.state.isEmpty,
	        metadataId: this.props.metadataId,
	        user: this.state.user,
	        userContentId: this.state.userContentId,
	        initializingStatus: this.state.initializingStatus,
	        isPrivate: false,
	        handlePrivacyToggle: function handlePrivacyToggle(e) {
	          e.preventDefault();
	        } });
	    }
	  }], [{
	    key: 'handleLogin',
	    value: function handleLogin(e) {
	      e.preventDefault();
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(e) {
	      e.preventDefault();
	    }
	  }]);
	
	  return PrimaryCommentEditorContainer;
	}(_baseBcReactComponent2.default);
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  var user = (0, _AuthSelector.currentUserSelector)(state);
	  var editorUser = user ? {
	    loggedIn: true,
	    id: user.id,
	    // idHash: '',
	    allowFreeText: true
	  } : { loggedIn: false };
	
	  return {
	    bibId: ownProps.bibId,
	    metadataId: ownProps.metadataId,
	    user: editorUser
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(PrimaryCommentEditorContainer);

/***/ },
/* 2095 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(14);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _sharedUgcEditors = __webpack_require__(278);
	
	var _AuthSelector = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Missing several props and methods from core implementation
	
	var PrimaryContentAdvisoryEditorContainer = function (_BcReactComponent) {
	  _inherits(PrimaryContentAdvisoryEditorContainer, _BcReactComponent);
	
	  function PrimaryContentAdvisoryEditorContainer(props) {
	    _classCallCheck(this, PrimaryContentAdvisoryEditorContainer);
	
	    var _this = _possibleConstructorReturn(this, (PrimaryContentAdvisoryEditorContainer.__proto__ || Object.getPrototypeOf(PrimaryContentAdvisoryEditorContainer)).call(this, props));
	
	    var advisories = props.advisories,
	        advisoryBody = props.advisoryBody,
	        user = props.user,
	        bibId = props.bibId,
	        domain = props.domain,
	        metadataId = props.metadataId;
	
	    _this.state = {
	      characterLimit: 4000,
	      advisories: advisories || [],
	      advisoryType: null,
	      advisoryBody: advisoryBody,
	      initializingStatus: {
	        status: 'success',
	        localeKey: null
	      },
	      user: user,
	      bibId: bibId,
	      domain: domain,
	      metadataId: metadataId
	    };
	    _this.bindAll('handleAdvisoryTypeChange', 'handleAdvisoryBodyChange', 'handleCancel', 'handleSubmit');
	    return _this;
	  }
	
	  _createClass(PrimaryContentAdvisoryEditorContainer, [{
	    key: 'handleAdvisoryTypeChange',
	    value: function handleAdvisoryTypeChange(value) {
	      this.setState(_extends({}, this.state, {
	        advisoryType: value
	      }));
	    }
	  }, {
	    key: 'handleAdvisoryBodyChange',
	    value: function handleAdvisoryBodyChange(value) {
	      this.setState(_extends({}, this.state, {
	        advisoryBody: value
	      }));
	    }
	  }, {
	    key: 'handleCancel',
	    value: function handleCancel() {
	      this.setState(_extends({}, this.state, {
	        advisoryType: null,
	        advisoryBody: ''
	      }));
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(e) {
	      var _this2 = this;
	
	      e.preventDefault();
	      this.setState(_extends({}, this.state, {
	        pending: true
	      }));
	
	      window.setTimeout(function () {
	        _this2.setState(_extends({}, _this2.state, {
	          advisories: [].concat(_toConsumableArray(_this2.state.advisories), [{
	            type: _this2.state.advisoryType,
	            content: _this2.state.advisoryBody,
	            userContentId: 567365434567
	          }]),
	          advisoryType: null,
	          advisoryBody: '',
	          pending: false,
	          status: 'success'
	        }));
	      }, 1000);
	      window.setTimeout(function () {
	        _this2.setState(_extends({}, _this2.state, {
	          status: ''
	        }));
	      }, 2000);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_sharedUgcEditors.PrimaryContentAdvisoryEditor, _extends({}, this.state, {
	        handleSubmit: this.handleSubmit,
	        handleLogin: this.handleLogin,
	        handleCancel: this.handleCancel,
	        handleAdvisoryBodyChange: this.handleAdvisoryBodyChange,
	        handleAdvisoryTypeChange: this.handleAdvisoryTypeChange }));
	    }
	  }], [{
	    key: 'handleLogin',
	    value: function handleLogin(e) {
	      e.preventDefault();
	    }
	  }]);
	
	  return PrimaryContentAdvisoryEditorContainer;
	}(_baseBcReactComponent2.default);
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  var user = (0, _AuthSelector.currentUserSelector)(state);
	  var editorUser = user ? {
	    loggedIn: true,
	    id: user.id,
	    // idHash: '',
	    allowFreeText: true
	  } : { loggedIn: false };
	
	  return {
	    user: editorUser,
	    bibId: ownProps.bibId,
	    domain: state.getIn('library', 'domain'),
	    metadataId: ownProps.metadataId
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(PrimaryContentAdvisoryEditorContainer);

/***/ },
/* 2096 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(14);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _sharedUgcEditors = __webpack_require__(278);
	
	var _AuthSelector = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Missing several props and methods from core implementation
	
	var PrimaryQuotationEditorContainer = function (_BcReactComponent) {
	  _inherits(PrimaryQuotationEditorContainer, _BcReactComponent);
	
	  function PrimaryQuotationEditorContainer(props) {
	    _classCallCheck(this, PrimaryQuotationEditorContainer);
	
	    var _this = _possibleConstructorReturn(this, (PrimaryQuotationEditorContainer.__proto__ || Object.getPrototypeOf(PrimaryQuotationEditorContainer)).call(this, props));
	
	    _this.state = {
	      quotation: null,
	      isNew: true,
	      userContentId: null,
	      showForm: true,
	      expanded: false,
	      initializingStatus: {
	        status: 'success',
	        localeKey: null
	      },
	      user: props.user
	    };
	
	    _this.bindAll('handleChange');
	    return _this;
	  }
	
	  _createClass(PrimaryQuotationEditorContainer, [{
	    key: 'handleChange',
	    value: function handleChange(value) {
	      this.setState({
	        quotation: value
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_sharedUgcEditors.PrimaryQuotationEditor, {
	        characterLimit: 4000,
	        quotation: this.state.quotation,
	        handleLogin: PrimaryQuotationEditorContainer.handleLogin,
	        handleChange: this.handleChange,
	        isNew: this.state.isNew,
	        handleSubmit: PrimaryQuotationEditorContainer.handleSubmit,
	        messages: this.props.messages,
	        user: this.state.user,
	        initializingStatus: this.state.initializingStatus });
	    }
	  }], [{
	    key: 'handleLogin',
	    value: function handleLogin(e) {
	      e.preventDefault();
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(e) {
	      e.preventDefault();
	    }
	  }]);
	
	  return PrimaryQuotationEditorContainer;
	}(_baseBcReactComponent2.default);
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  var user = (0, _AuthSelector.currentUserSelector)(state);
	  var editorUser = user ? {
	    loggedIn: true,
	    id: user.id,
	    // idHash: '',
	    allowFreeText: true
	  } : { loggedIn: false };
	
	  return {
	    bibId: ownProps.bibId,
	    metadataId: ownProps.metadataId,
	    user: editorUser
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(PrimaryQuotationEditorContainer);

/***/ },
/* 2097 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(14);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _sharedUgcEditors = __webpack_require__(278);
	
	var _AuthSelector = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Missing several props and methods from core implementation
	
	var PrimarySummaryEditorContainer = function (_BcReactComponent) {
	  _inherits(PrimarySummaryEditorContainer, _BcReactComponent);
	
	  function PrimarySummaryEditorContainer(props) {
	    _classCallCheck(this, PrimarySummaryEditorContainer);
	
	    var _this = _possibleConstructorReturn(this, (PrimarySummaryEditorContainer.__proto__ || Object.getPrototypeOf(PrimarySummaryEditorContainer)).call(this, props));
	
	    _this.state = {
	      showForm: true,
	      initialSummary: '',
	      summary: '',
	      isNew: true,
	      bibId: props.bibId,
	      isPrivate: false,
	      userContentId: null,
	      expanded: false,
	      initializingStatus: {
	        status: 'success',
	        localeKey: null
	      },
	      user: props.user
	    };
	
	    _this.bindAll('handleChange');
	    return _this;
	  }
	
	  _createClass(PrimarySummaryEditorContainer, [{
	    key: 'handleChange',
	    value: function handleChange(value) {
	      this.setState({
	        summary: value,
	        isEmpty: value.length <= 0
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_sharedUgcEditors.PrimarySummaryEditor, {
	        characterLimit: 4000,
	        summary: this.state.summary,
	        handleLogin: PrimarySummaryEditorContainer.handleLogin,
	        handleChange: this.handleChange,
	        isNew: this.state.isNew,
	        showForm: this.state.showForm,
	        handleSubmit: PrimarySummaryEditorContainer.handleSubmit,
	        handlePrivacyToggle: PrimarySummaryEditorContainer.handlePrivacyToggle,
	        bibId: this.state.bibId,
	        isPrivate: this.props.isPrivate,
	        isEmpty: this.state.isEmpty,
	        metadataId: this.props.metadataId,
	        user: this.state.user,
	        userContentId: this.state.userContentId,
	        initializingStatus: this.state.initializingStatus });
	    }
	  }], [{
	    key: 'handleLogin',
	    value: function handleLogin(e) {
	      e.preventDefault();
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(e) {
	      e.preventDefault();
	    }
	  }, {
	    key: 'handlePrivacyToggle',
	    value: function handlePrivacyToggle() {}
	  }]);
	
	  return PrimarySummaryEditorContainer;
	}(_baseBcReactComponent2.default);
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  var user = (0, _AuthSelector.currentUserSelector)(state);
	  var editorUser = user ? {
	    loggedIn: true,
	    id: user.id,
	    // idHash: '',
	    allowFreeText: true
	  } : { loggedIn: false };
	
	  return {
	    bibId: ownProps.bibId,
	    metadataId: ownProps.metadataId,
	    user: editorUser
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(PrimarySummaryEditorContainer);

/***/ },
/* 2098 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UserContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _reactRedux = __webpack_require__(14);
	
	var _redux = __webpack_require__(18);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _notFound = __webpack_require__(140);
	
	var _notFound2 = _interopRequireDefault(_notFound);
	
	var _AuthSelector = __webpack_require__(21);
	
	var _UserSelector = __webpack_require__(401);
	
	var _UserActions = __webpack_require__(1593);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UserContainer = exports.UserContainer = function (_BcReactComponent) {
	  _inherits(UserContainer, _BcReactComponent);
	
	  function UserContainer() {
	    _classCallCheck(this, UserContainer);
	
	    return _possibleConstructorReturn(this, (UserContainer.__proto__ || Object.getPrototypeOf(UserContainer)).apply(this, arguments));
	  }
	
	  _createClass(UserContainer, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var user = this.props.user;
	      var nextParams = nextProps.params,
	          userActions = nextProps.userActions;
	
	      var userId = user && user.get('id') || undefined;
	      var nextUserId = nextParams.userId ? parseInt(nextParams.userId, 10) : undefined;
	
	      if (nextUserId !== userId) {
	        userActions.fetchUser(nextParams.userId);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var user = this.props.user;
	
	
	      if (user && user.get('active')) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          this.props.children
	        );
	      }
	
	      return _react2.default.createElement(_notFound2.default, null);
	    }
	  }], [{
	    key: 'fetchInitialData',
	    value: function fetchInitialData(params, query, store) {
	      return [store.dispatch(_UserActions2.default.fetchUser(params.userId))];
	    }
	  }]);
	
	  return UserContainer;
	}(_baseBcReactComponent2.default);
	
	UserContainer.propTypes = {
	  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node]).isRequired,
	  user: _reactImmutableProptypes2.default.map
	};
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    user: ownProps.params.userId ? (0, _UserSelector.getRequestedUser)(state) : (0, _AuthSelector.currentUserSelector)(state)
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    userActions: (0, _redux.bindActionCreators)(_UserActions2.default, dispatch)
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(UserContainer);

/***/ },
/* 2099 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(14);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _redux = __webpack_require__(18);
	
	var _isEqual = __webpack_require__(162);
	
	var _isEqual2 = _interopRequireDefault(_isEqual);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _DocumentHeadContainer = __webpack_require__(52);
	
	var _DocumentHeadContainer2 = _interopRequireDefault(_DocumentHeadContainer);
	
	var _AuthSelector = __webpack_require__(21);
	
	var _CheckoutSelector = __webpack_require__(191);
	
	var _CheckoutActions = __webpack_require__(279);
	
	var CheckoutActions = _interopRequireWildcard(_CheckoutActions);
	
	var _CheckedOutPrintList = __webpack_require__(1657);
	
	var _CheckedOutPrintList2 = _interopRequireDefault(_CheckedOutPrintList);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PrintCheckedOutContainer = function (_BcReactComponent) {
	  _inherits(PrintCheckedOutContainer, _BcReactComponent);
	
	  function PrintCheckedOutContainer() {
	    _classCallCheck(this, PrintCheckedOutContainer);
	
	    return _possibleConstructorReturn(this, (PrintCheckedOutContainer.__proto__ || Object.getPrototypeOf(PrintCheckedOutContainer)).apply(this, arguments));
	  }
	
	  _createClass(PrintCheckedOutContainer, [{
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps) {
	      var location = this.props.location;
	
	
	      if (!(0, _isEqual2.default)(location.search, nextProps.location.search)) {
	        this.props.checkoutActions.fetchCheckouts(_extends({
	          accountId: nextProps.accountId
	        }, nextProps.router.params, nextProps.location.query));
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          intl = _props.intl,
	          props = _objectWithoutProperties(_props, ['intl']);
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-print-list' },
	        _react2.default.createElement(_DocumentHeadContainer2.default, { pageTitle: intl.formatMessage({ id: 'section_title_checkedout' }) }),
	        _react2.default.createElement(_CheckedOutPrintList2.default, props)
	      );
	    }
	  }], [{
	    key: 'fetchInitialData',
	    value: function fetchInitialData(params, query, store) {
	      var account = (0, _AuthSelector.currentAccountSelector)(store.getState());
	      var accountId = account && account.get('id');
	
	      return [store.dispatch(CheckoutActions.fetchCheckouts(_extends({ accountId: accountId }, query, params)))];
	    }
	  }]);
	
	  return PrintCheckedOutContainer;
	}(_baseBcReactComponent2.default);
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  var items = (0, _CheckoutSelector.getCurrentCheckouts)(state, ownProps);
	  var pagination = (0, _CheckoutSelector.getPagination)(state, ownProps);
	  var isFetching = (0, _CheckoutSelector.getCheckedoutStatus)(state).get('fetching', false);
	  var account = (0, _AuthSelector.currentAccountSelector)(state);
	  var accountId = account && account.get('id');
	
	  return {
	    items: items,
	    pagination: pagination,
	    isFetching: isFetching,
	    accountId: accountId
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    checkoutActions: (0, _redux.bindActionCreators)(CheckoutActions, dispatch)
	  };
	};
	
	PrintCheckedOutContainer.propTypes = {
	  intl: _reactIntl.intlShape,
	  items: _reactImmutableProptypes2.default.list,
	  isFetching: _react.PropTypes.bool,
	  pagination: _bcPropTypes.paginationShape,
	  accountId: _react.PropTypes.number
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIntl.injectIntl)(PrintCheckedOutContainer));

/***/ },
/* 2100 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(14);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _redux = __webpack_require__(18);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _AuthSelector = __webpack_require__(21);
	
	var _SearchActions = __webpack_require__(144);
	
	var _SearchActions2 = _interopRequireDefault(_SearchActions);
	
	var _DocumentHeadContainer = __webpack_require__(52);
	
	var _DocumentHeadContainer2 = _interopRequireDefault(_DocumentHeadContainer);
	
	var _HoldsSelector = __webpack_require__(127);
	
	var _HoldActions = __webpack_require__(143);
	
	var HoldActions = _interopRequireWildcard(_HoldActions);
	
	var _HoldsPrintList = __webpack_require__(1736);
	
	var _HoldsPrintList2 = _interopRequireDefault(_HoldsPrintList);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PrintHoldsContainer = function (_BcReactComponent) {
	  _inherits(PrintHoldsContainer, _BcReactComponent);
	
	  function PrintHoldsContainer() {
	    _classCallCheck(this, PrintHoldsContainer);
	
	    return _possibleConstructorReturn(this, (PrintHoldsContainer.__proto__ || Object.getPrototypeOf(PrintHoldsContainer)).apply(this, arguments));
	  }
	
	  _createClass(PrintHoldsContainer, [{
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps) {
	      var location = this.props.location;
	
	
	      if (location.search !== nextProps.location.search) {
	        this.props.holdActions.fetchHolds(_extends({
	          accountId: nextProps.accountId
	        }, nextProps.router.params, nextProps.location.query));
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          intl = _props.intl,
	          props = _objectWithoutProperties(_props, ['intl']);
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-print-list' },
	        _react2.default.createElement(_DocumentHeadContainer2.default, { pageTitle: intl.formatMessage({ id: 'section_title_holds' }) }),
	        _react2.default.createElement(_HoldsPrintList2.default, props)
	      );
	    }
	  }], [{
	    key: 'fetchInitialData',
	    value: function fetchInitialData(params, query, store) {
	      var account = (0, _AuthSelector.currentAccountSelector)(store.getState());
	      var accountId = account && account.get('id');
	
	      return [store.dispatch(HoldActions.fetchHolds(_extends({ accountId: accountId }, params, query)))];
	    }
	  }]);
	
	  return PrintHoldsContainer;
	}(_baseBcReactComponent2.default);
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  var items = (0, _HoldsSelector.getCurrentHolds)(state, ownProps);
	  var pagination = (0, _HoldsSelector.getPagination)(state, ownProps);
	  var holdsStatus = (0, _HoldsSelector.getHoldsStatus)(state);
	  var isFetching = holdsStatus.get('fetching', false);
	  var account = (0, _AuthSelector.currentAccountSelector)(state);
	  var accountId = account && account.get('id');
	
	  return {
	    items: items,
	    pagination: pagination,
	    isFetching: isFetching,
	    accountId: accountId
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    searchActions: (0, _redux.bindActionCreators)(_SearchActions2.default, dispatch),
	    holdActions: (0, _redux.bindActionCreators)(HoldActions, dispatch)
	  };
	};
	
	PrintHoldsContainer.propTypes = {
	  intl: _reactIntl.intlShape,
	  items: _reactImmutableProptypes2.default.list,
	  accountId: _react.PropTypes.number
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIntl.injectIntl)(PrintHoldsContainer));

/***/ },
/* 2101 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(14);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _redux = __webpack_require__(18);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _DocumentHeadContainer = __webpack_require__(52);
	
	var _DocumentHeadContainer2 = _interopRequireDefault(_DocumentHeadContainer);
	
	var _notFound = __webpack_require__(140);
	
	var _notFound2 = _interopRequireDefault(_notFound);
	
	var _LibrarySelector = __webpack_require__(33);
	
	var _AuthSelector = __webpack_require__(21);
	
	var _RecentlyReturnedSelector = __webpack_require__(647);
	
	var _RecentlyReturnedActions = __webpack_require__(560);
	
	var RecentlyReturnedActions = _interopRequireWildcard(_RecentlyReturnedActions);
	
	var _RecentlyReturnedPrintList = __webpack_require__(1790);
	
	var _RecentlyReturnedPrintList2 = _interopRequireDefault(_RecentlyReturnedPrintList);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PrintRecentlyReturnedContainer = function (_BcReactComponent) {
	  _inherits(PrintRecentlyReturnedContainer, _BcReactComponent);
	
	  function PrintRecentlyReturnedContainer() {
	    _classCallCheck(this, PrintRecentlyReturnedContainer);
	
	    return _possibleConstructorReturn(this, (PrintRecentlyReturnedContainer.__proto__ || Object.getPrototypeOf(PrintRecentlyReturnedContainer)).apply(this, arguments));
	  }
	
	  _createClass(PrintRecentlyReturnedContainer, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-print-list' },
	        _react2.default.createElement(_DocumentHeadContainer2.default, { pageTitle: this.props.intl.formatMessage({ id: 'section_title_recently_returned' }) }),
	        this.props.recentlyReturnedSupported ? _react2.default.createElement(_RecentlyReturnedPrintList2.default, this.props) : _react2.default.createElement(_notFound2.default, null)
	      );
	    }
	  }], [{
	    key: 'fetchInitialData',
	    value: function fetchInitialData(params, query, store) {
	      var account = (0, _AuthSelector.currentAccountSelector)(store.getState());
	      var accountId = account && account.get('id');
	
	      return [store.dispatch(RecentlyReturnedActions.fetchReturnHistory(_extends({}, params, query, { accountId: accountId })))];
	    }
	  }]);
	
	  return PrintRecentlyReturnedContainer;
	}(_baseBcReactComponent2.default);
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    RecentlyReturnedActions: (0, _redux.bindActionCreators)(RecentlyReturnedActions, dispatch)
	  };
	};
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  var library = (0, _LibrarySelector.currentLibrarySelector)(state);
	  var recentlyReturnedSupported = library.get('recentlyReturned');
	  var items = (0, _RecentlyReturnedSelector.getRecentlyReturnedWithBibs)(state, ownProps);
	  var accountId = (0, _AuthSelector.currentAccountSelector)(state).get('id').toString();
	  var borrowingHistoryData = (0, _RecentlyReturnedSelector.getBorrowingHistoryData)(state);
	  var pagination = borrowingHistoryData.get('pagination', _immutable2.default.Map());
	  var isFetching = borrowingHistoryData.get('isFetching');
	
	  return {
	    items: items,
	    pagination: pagination,
	    isFetching: isFetching,
	    recentlyReturnedSupported: recentlyReturnedSupported,
	    accountId: accountId
	  };
	};
	
	PrintRecentlyReturnedContainer.propTypes = {
	  intl: _reactIntl.intlShape,
	  items: _reactImmutableProptypes2.default.list,
	  pagination: _reactImmutableProptypes2.default.map,
	  isFetching: _react.PropTypes.bool,
	  accountId: _react.PropTypes.number
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIntl.injectIntl)(PrintRecentlyReturnedContainer));

/***/ },
/* 2102 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(3);
	
	var _reactRedux = __webpack_require__(14);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _isEqual = __webpack_require__(162);
	
	var _isEqual2 = _interopRequireDefault(_isEqual);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _redux = __webpack_require__(18);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _SearchActions = __webpack_require__(144);
	
	var _SearchActions2 = _interopRequireDefault(_SearchActions);
	
	var _SearchPrintList = __webpack_require__(1881);
	
	var _SearchPrintList2 = _interopRequireDefault(_SearchPrintList);
	
	var _DocumentHeadContainer = __webpack_require__(52);
	
	var _DocumentHeadContainer2 = _interopRequireDefault(_DocumentHeadContainer);
	
	var _SearchSelector = __webpack_require__(400);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PrintSearchContainer = function (_BcReactComponent) {
	  _inherits(PrintSearchContainer, _BcReactComponent);
	
	  function PrintSearchContainer() {
	    _classCallCheck(this, PrintSearchContainer);
	
	    return _possibleConstructorReturn(this, (PrintSearchContainer.__proto__ || Object.getPrototypeOf(PrintSearchContainer)).apply(this, arguments));
	  }
	
	  _createClass(PrintSearchContainer, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (!(0, _isEqual2.default)(this.props.location.query, nextProps.location.query)) {
	        this.props.searchActions.performSearch(_extends({}, nextProps.location.query, { print: true }));
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          pagination = _props.pagination,
	          results = _props.results,
	          searchActions = _props.searchActions,
	          intl = _props.intl,
	          isFetching = _props.isFetching,
	          location = _props.location;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-print-list' },
	        _react2.default.createElement(_DocumentHeadContainer2.default, { pageTitle: intl.formatMessage({ id: 'searchTitle' }) }),
	        _react2.default.createElement(_SearchPrintList2.default, {
	          isFetching: isFetching,
	          results: results,
	          pagination: pagination,
	          searchActions: searchActions,
	          searchQuery: _immutable2.default.fromJS(location.query) })
	      );
	    }
	  }], [{
	    key: 'fetchInitialData',
	    value: function fetchInitialData(params, query, store) {
	      return [store.dispatch(_SearchActions2.default.performSearch(_extends({}, query, { print: true })))];
	    }
	  }]);
	
	  return PrintSearchContainer;
	}(_baseBcReactComponent2.default);
	
	var mapStateToProps = function mapStateToProps(state) {
	  var catalogSearch = state.getIn(['search', 'catalogSearch']);
	  return {
	    pagination: catalogSearch.get('pagination'),
	    // FIXME: This ignores FRBR
	    results: (0, _SearchSelector.searchResultBibSelector)(state).map(function (result) {
	      return result.representative;
	    }),
	    isFetching: catalogSearch.get('isFetching')
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    searchActions: (0, _redux.bindActionCreators)(_SearchActions2.default, dispatch)
	  };
	};
	
	PrintSearchContainer.propTypes = {
	  pagination: _reactImmutableProptypes2.default.map,
	  results: _reactImmutableProptypes2.default.list,
	  searchQuery: _reactImmutableProptypes2.default.map,
	  searchActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  intl: _reactIntl.intlShape,
	  isFetching: _react.PropTypes.bool
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIntl.injectIntl)(PrintSearchContainer));

/***/ },
/* 2103 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PrintShelfContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(14);
	
	var _reactIntl = __webpack_require__(3);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _redux = __webpack_require__(18);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _ShelfPrintList = __webpack_require__(2047);
	
	var _ShelfPrintList2 = _interopRequireDefault(_ShelfPrintList);
	
	var _UserSelector = __webpack_require__(401);
	
	var _DocumentHeadContainer = __webpack_require__(52);
	
	var _DocumentHeadContainer2 = _interopRequireDefault(_DocumentHeadContainer);
	
	var _ShelfSelector = __webpack_require__(75);
	
	var _ShelfActions = __webpack_require__(107);
	
	var _ShelfActions2 = _interopRequireDefault(_ShelfActions);
	
	var _AuthSelector = __webpack_require__(21);
	
	var _RatingsSelector = __webpack_require__(246);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PrintShelfContainer = exports.PrintShelfContainer = function (_BcReactComponent) {
	  _inherits(PrintShelfContainer, _BcReactComponent);
	
	  function PrintShelfContainer() {
	    _classCallCheck(this, PrintShelfContainer);
	
	    return _possibleConstructorReturn(this, (PrintShelfContainer.__proto__ || Object.getPrototypeOf(PrintShelfContainer)).apply(this, arguments));
	  }
	
	  _createClass(PrintShelfContainer, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props = this.props,
	          location = _props.location,
	          params = _props.params,
	          owner = _props.owner;
	      var nextLocation = nextProps.location,
	          nextParams = nextProps.params;
	
	
	      if (params !== nextParams || location !== nextLocation) {
	        this.props.shelfActions.searchUserShelf(nextParams.shelfName, owner.get('id'), nextLocation.query);
	      }
	    }
	  }, {
	    key: 'getFormatResults',
	    value: function getFormatResults() {
	      var _props2 = this.props,
	          results = _props2.results,
	          ratings = _props2.ratings,
	          bibs = _props2.bibs;
	
	      return results.get('items').map(function (item) {
	        return item.set('format', bibs.getIn([item.get('metadataId'), 'briefInfo', 'format'])).set('callNumber', bibs.getIn([item.get('metadataId'), 'briefInfo', 'callNumber'])).set('currentUserRating', ratings.getIn([item.get('metadataId'), 'rating']));
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          pagination = _props3.pagination,
	          intl = _props3.intl,
	          isFetching = _props3.isFetching,
	          username = _props3.username,
	          shelfName = _props3.shelfName,
	          loggedIn = _props3.loggedIn;
	
	      var pageTitleId = 'section_title_users_' + shelfName + '_shelf';
	      var pageTitle = intl.formatMessage({ id: pageTitleId }, { username: username });
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cp-shelf-print-list' },
	        _react2.default.createElement(_DocumentHeadContainer2.default, { pageTitle: intl.formatMessage({ id: pageTitle }) }),
	        _react2.default.createElement(_ShelfPrintList2.default, {
	          isFetching: isFetching,
	          results: this.getFormatResults(),
	          pagination: pagination,
	          username: username,
	          shelfName: shelfName,
	          loggedIn: loggedIn })
	      );
	    }
	  }], [{
	    key: 'fetchInitialData',
	    value: function fetchInitialData(params, query, store) {
	      var user = params.userId ? (0, _UserSelector.getRequestedUser)(store.getState()) : (0, _AuthSelector.currentUserSelector)(store.getState());
	      var userId = user && user.get('id');
	      if (userId && params.shelfName) {
	        return [store.dispatch(_ShelfActions2.default.searchUserShelf(params.shelfName, userId, query))];
	      }
	
	      return [];
	    }
	  }]);
	
	  return PrintShelfContainer;
	}(_baseBcReactComponent2.default);
	
	var mapStateToProps = function mapStateToProps(state) {
	  var owner = (0, _ShelfSelector.getShelfOwner)(state);
	  var shelfSearch = state.getIn(['shelves', 'shelfSearch']);
	
	  return {
	    pagination: shelfSearch.getIn(['shelf', 'pagination']),
	    shelfName: shelfSearch.getIn(['shelf', 'name']),
	    bibs: state.getIn(['entities', 'bibs'], _immutable2.default.Map()),
	    results: (0, _ShelfSelector.getRequestedShelf)(state),
	    username: owner.get('name'),
	    ratings: owner.get('loggedIn') ? (0, _RatingsSelector.getCurrentUserRatings)(state) : _immutable2.default.Map(),
	    loggedIn: !!owner.get('loggedIn'),
	    isFetching: false
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    shelfActions: (0, _redux.bindActionCreators)(_ShelfActions2.default, dispatch)
	  };
	};
	
	PrintShelfContainer.propTypes = {
	  pagination: _reactImmutableProptypes2.default.map,
	  results: _reactImmutableProptypes2.default.Map,
	  bibs: _reactImmutableProptypes2.default.list,
	  searchActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
	  ratings: _reactImmutableProptypes2.default.map,
	  intl: _reactIntl.intlShape,
	  isFetching: _react.PropTypes.bool,
	  shelfName: _react.PropTypes.string,
	  username: _react.PropTypes.string,
	  loggedIn: _react.PropTypes.bool
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIntl.injectIntl)(PrintShelfContainer));

/***/ },
/* 2104 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(14);
	
	var _redux = __webpack_require__(18);
	
	var _reactAddonsCssTransitionGroup = __webpack_require__(258);
	
	var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	var _sharedMessages = __webpack_require__(64);
	
	var _bcPropTypes = __webpack_require__(5);
	
	var _MessagingActions = __webpack_require__(181);
	
	var _MessagingActions2 = _interopRequireDefault(_MessagingActions);
	
	var _MessagingSelector = __webpack_require__(399);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function GlobalMessagingContainer(_ref) {
	  var messaging = _ref.messaging,
	      messagingActions = _ref.messagingActions;
	
	  var renderMessaging = function renderMessaging() {
	    if (messaging && messaging.get('message')) {
	      var props = {
	        message: messaging.get('message'),
	        fieldErrors: messaging.get('fieldErrors'),
	        duration: messaging.get('duration'),
	        failureDuration: messaging.get('failureDuration'),
	        values: messaging.get('values'),
	        useFormattedMessage: messaging.get('useFormattedMessage'),
	        clearMessages: function clearMessages() {
	          return messagingActions.clearGlobalMessage();
	        }
	      };
	
	      return _react2.default.createElement(_sharedMessages.ToastMessage, props);
	    }
	
	    return null;
	  };
	
	  return _react2.default.createElement(
	    _reactAddonsCssTransitionGroup2.default,
	    {
	      component: 'div',
	      transitionName: 'slide-up',
	      transitionEnterTimeout: 250,
	      transitionLeaveTimeout: 100 },
	    renderMessaging()
	  );
	}
	
	GlobalMessagingContainer.propTypes = {
	  messaging: _bcPropTypes.messagingShape,
	  messagingActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    messaging: (0, _MessagingSelector.getGlobalMessaging)(state)
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    messagingActions: (0, _redux.bindActionCreators)(_MessagingActions2.default, dispatch)
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(GlobalMessagingContainer);

/***/ },
/* 2105 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(14);
	
	var _redux = __webpack_require__(18);
	
	var _aboveTheFoldOnlyServerRender = __webpack_require__(376);
	
	var _reactImmutableProptypes = __webpack_require__(4);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _baseBcReactComponent = __webpack_require__(2);
	
	var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);
	
	var _LoginOverlayContainer = __webpack_require__(636);
	
	var _LoginOverlayContainer2 = _interopRequireDefault(_LoginOverlayContainer);
	
	var _ItemWidget = __webpack_require__(2053);
	
	var _ItemWidget2 = _interopRequireDefault(_ItemWidget);
	
	var _AuthSelector = __webpack_require__(21);
	
	var _AvailabilityDetailActions = __webpack_require__(122);
	
	var _AvailabilityDetailActions2 = _interopRequireDefault(_AvailabilityDetailActions);
	
	var _WidgetActions = __webpack_require__(1595);
	
	var _WidgetActions2 = _interopRequireDefault(_WidgetActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ItemWidgetContainer = function (_BcReactComponent) {
	  _inherits(ItemWidgetContainer, _BcReactComponent);
	
	  function ItemWidgetContainer() {
	    _classCallCheck(this, ItemWidgetContainer);
	
	    return _possibleConstructorReturn(this, (ItemWidgetContainer.__proto__ || Object.getPrototypeOf(ItemWidgetContainer)).apply(this, arguments));
	  }
	
	  _createClass(ItemWidgetContainer, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.currentUser !== nextProps.currentUser) {
	        this.props.widgetActions.fetchItem(this.props.item.get('id'));
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          item = _props.item,
	          availabilityDetail = _props.availabilityDetail,
	          availabilityDetailActions = _props.availabilityDetailActions,
	          currentUser = _props.currentUser;
	
	      var skipSSR = this.props.location.query.ssr === '0';
	      return _react2.default.createElement(
	        _aboveTheFoldOnlyServerRender.AboveTheFoldOnlyServerRender,
	        { skip: skipSSR },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_ItemWidget2.default, { item: item, availabilityDetail: availabilityDetail, availabilityDetailActions: availabilityDetailActions, currentUser: currentUser, isWidget: this.context.isWidget }),
	          _react2.default.createElement(_LoginOverlayContainer2.default, null)
	        )
	      );
	    }
	  }], [{
	    key: 'fetchInitialData',
	    value: function fetchInitialData(params, query, store) {
	      return [store.dispatch(_WidgetActions2.default.fetchItem(params.metadataId))];
	    }
	  }]);
	
	  return ItemWidgetContainer;
	}(_baseBcReactComponent2.default);
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    item: state.getIn(['entities', 'bibs', ownProps.params.metadataId]),
	    availabilityDetail: state.get('availabilityDetail'),
	    currentUser: (0, _AuthSelector.currentUserSelector)(state)
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    availabilityDetailActions: (0, _redux.bindActionCreators)(_AvailabilityDetailActions2.default, dispatch),
	    widgetActions: (0, _redux.bindActionCreators)(_WidgetActions2.default, dispatch)
	  };
	};
	
	ItemWidgetContainer.propTypes = {
	  item: _reactImmutableProptypes2.default.map,
	  availabilityDetail: _reactImmutableProptypes2.default.map,
	  availabilityDetailActions: _react.PropTypes.objectOf(_react.PropTypes.func)
	};
	
	ItemWidgetContainer.contextTypes = {
	  isWidget: _react.PropTypes.bool
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ItemWidgetContainer);

/***/ },
/* 2106 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rxjs = __webpack_require__(169);
	
	var _lodash = __webpack_require__(16);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _HoldActions = __webpack_require__(143);
	
	var _HoldsConstants = __webpack_require__(98);
	
	var _HoldsConstants2 = _interopRequireDefault(_HoldsConstants);
	
	var _WorkflowActions = __webpack_require__(123);
	
	var _WorkflowActions2 = _interopRequireDefault(_WorkflowActions);
	
	var _WorkflowConstants = __webpack_require__(74);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var itemLevelHoldExceptionEpic = function itemLevelHoldExceptionEpic(action$) {
	  return action$.ofType(_HoldsConstants2.default.PLACE_HOLD_REQUEST).switchMap(function (placeHoldAction) {
	    return action$.ofType(_HoldsConstants2.default.PLACE_HOLD_FAILURE).filter(function (action) {
	      return _lodash2.default.get(action, 'payload.error.classification') === 'HoldIsItemLevel';
	    }).flatMap(function (action) {
	      return _rxjs.Observable.concat(_rxjs.Observable.of((0, _HoldActions.updatePickupLocation)(action.workflowId, placeHoldAction.payload.selectedBranch)), _rxjs.Observable.of(_WorkflowActions2.default.updateWorkflow(action.workflowId, _WorkflowConstants.ITEM_TRANSACTION_WORKFLOW, _immutable2.default.Map({
	        metadataId: action.workflowId,
	        step: _HoldsConstants.WORKFLOW_VIEWS.ITEM_LEVEL_HOLD,
	        messagingId: action.messagingId
	      }), true, true)));
	    });
	  });
	};
	
	exports.default = itemLevelHoldExceptionEpic;

/***/ },
/* 2107 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = removeFiltersFromQuery;
	
	var _omitBy = __webpack_require__(2942);
	
	var _omitBy2 = _interopRequireDefault(_omitBy);
	
	var _FacetConstants = __webpack_require__(187);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function removeFiltersFromQuery(query) {
	  return (0, _omitBy2.default)(query, function (value, key) {
	    return key.indexOf(_FacetConstants.FILTER_PREFIX) === 0;
	  });
	}

/***/ },
/* 2108 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = composeGlobalNeutralMessaging;
	
	var _composeNeutralMessaging = __webpack_require__(2109);
	
	var _composeNeutralMessaging2 = _interopRequireDefault(_composeNeutralMessaging);
	
	var _MessagingConstants = __webpack_require__(73);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function composeGlobalNeutralMessaging(messageId) {
	  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  return (0, _composeNeutralMessaging2.default)(_MessagingConstants.GLOBAL_MESSAGING_ID, messageId, opts);
	}

/***/ },
/* 2109 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = composeNeutralMessaging;
	
	var _composeMessaging = __webpack_require__(189);
	
	var _composeMessaging2 = _interopRequireDefault(_composeMessaging);
	
	var _MessagingConstants = __webpack_require__(73);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function composeNeutralMessaging(messagingId, messageId) {
	  var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  return (0, _composeMessaging2.default)(_MessagingConstants.STATUS_TYPES.Neutral, messagingId, messageId, opts);
	}

/***/ },
/* 2110 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = analytics;
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _AnalyticsConstants = __webpack_require__(611);
	
	var _AnalyticsConstants2 = _interopRequireDefault(_AnalyticsConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = _immutable2.default.Map();
	
	function analytics() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _AnalyticsConstants2.default.FETCH_DATALAYER_SUCCESS:
	      {
	        return state.merge({ siteDataLayer: action.payload });
	      }
	    default:
	      return state;
	  }
	}

/***/ },
/* 2111 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = app;
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _AppConstants = __webpack_require__(186);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	var _ErrorConstants = __webpack_require__(615);
	
	var _ErrorConstants2 = _interopRequireDefault(_ErrorConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = _immutable2.default.Map({
	  currentLocale: null,
	  featureFlags: _immutable2.default.Map(),
	  messages: _immutable2.default.List(),
	  appVersion: null,
	  allowFeatureFlagEditing: false,
	  baseUrl: '/v2',
	  coreAssets: _immutable2.default.Map(),
	  internalError: _immutable2.default.Map(),
	  localBranch: null,
	  mobileApp: false
	});
	
	function app() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _AppConstants2.default.LOAD_APP_CONFIG:
	      {
	        return state.merge(action.appConfig);
	      }
	
	    case _AppConstants2.default.UPDATE_FEATURE_FLAG_SUCCESS:
	      {
	        return state.setIn(['featureFlags', action.payload.flag], action.payload.enabled);
	      }
	
	    case _ErrorConstants2.default.STORE_INTERNAL_ERROR:
	      {
	        return state.setIn(['internalError'], _immutable2.default.fromJS(action.payload.error));
	      }
	
	    default:
	      return state;
	  }
	}

/***/ },
/* 2112 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = auth;
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _lodash = __webpack_require__(16);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _AuthConstants = __webpack_require__(293);
	
	var _AuthConstants2 = _interopRequireDefault(_AuthConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = _immutable2.default.Map({
	  currentUserId: null,
	  loginOverlayOpen: false,
	  postLoginAction: null,
	  loading: false
	});
	
	function auth() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  var nextState = state;
	  if (nextState.getIn(['middlewareData', 'authRequired'])) {
	    // Always update the postLoginAction incase the action is fired after the session expires
	    nextState = nextState.set('postLoginAction', action);
	  }
	
	  if (['invalid_token', 'RailsSessionInvalidationException'].includes(_lodash2.default.get(action, 'payload.error.classification'))) {
	    // This happens when the user's session has expired
	    return nextState.merge({
	      loginErrorMessage: 'errors.' + action.payload.error.classification,
	      currentUserId: null,
	      loginOverlayOpen: true
	    });
	  }
	
	  switch (action.type) {
	
	    case _AuthConstants2.default.AUTH_LOAD_USER_FAILURE:
	      {
	        return initialState;
	      }
	
	    case _AuthConstants2.default.AUTH_LOAD_USER_SUCCESS:
	      {
	        return state.merge(action.payload.auth);
	      }
	
	    case _AuthConstants2.default.AUTH_LOGIN_SUCCESS:
	      {
	        return state.merge({
	          currentUserId: action.payload.auth.currentUserId,
	          loginErrorMessage: null,
	          loginOverlayOpen: false,
	          loading: false
	        });
	      }
	
	    case _AuthConstants2.default.AUTH_LOGIN_ERROR:
	      {
	        return state.merge({
	          currentUserId: action.payload.currentUserId,
	          loginErrorMessage: action.payload.error && action.payload.error.message, // TODO: default message?
	          loginOverlayOpen: true,
	          loading: false
	        });
	      }
	
	    case _AuthConstants2.default.AUTH_LOGOUT:
	      {
	        return initialState;
	      }
	
	    case _AuthConstants2.default.OPEN_LOGIN_OVERLAY:
	      {
	        return state.merge({
	          loginErrorMessage: null,
	          loginOverlayOpen: true,
	          postLoginAction: action.payload.postLoginAction
	        });
	      }
	
	    case _AuthConstants2.default.CLOSE_LOGIN_OVERLAY:
	      {
	        return state.merge({
	          loginErrorMessage: null,
	          loginOverlayOpen: false,
	          postLoginAction: null
	        });
	      }
	
	    case _AuthConstants2.default.AUTH_LOGIN_REQUEST:
	      {
	        return state.merge({
	          loading: true
	        });
	      }
	
	    default:
	      return state;
	  }
	}

/***/ },
/* 2113 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = availabilityDetail;
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _AvailabilityDetailConstants = __webpack_require__(612);
	
	var _AvailabilityDetailConstants2 = _interopRequireDefault(_AvailabilityDetailConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AVAILABILITY_DETAIL_REQUEST = _AvailabilityDetailConstants2.default.AVAILABILITY_DETAIL_REQUEST,
	    AVAILABILITY_DETAIL_SUCCESS = _AvailabilityDetailConstants2.default.AVAILABILITY_DETAIL_SUCCESS,
	    AVAILABILITY_DETAIL_ERROR = _AvailabilityDetailConstants2.default.AVAILABILITY_DETAIL_ERROR;
	
	
	var initialState = _immutable2.default.Map({
	  jacket: {},
	  probes: _immutable2.default.Map()
	});
	
	function availabilityDetail() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	
	    case AVAILABILITY_DETAIL_REQUEST:
	      {
	        return state.set('isFetching', true);
	      }
	
	    case AVAILABILITY_DETAIL_SUCCESS:
	      {
	        return state.merge(_extends({}, action.payload, {
	          isFetching: false
	        }));
	      }
	
	    case AVAILABILITY_DETAIL_ERROR:
	      {
	        return state.set('isFetching', false);
	      }
	
	    default:
	      return state;
	  }
	}

/***/ },
/* 2114 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = drawer;
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _DrawerConstants = __webpack_require__(614);
	
	var _DrawerConstants2 = _interopRequireDefault(_DrawerConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = _immutable2.default.Map({
	  open: false
	});
	
	function drawer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _DrawerConstants2.default.TOGGLE:
	      {
	        return state.set('open', !state.get('open'));
	      }
	
	    default:
	      return state;
	  }
	}

/***/ },
/* 2115 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = internalError;
	
	var _AppConstants = __webpack_require__(186);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	var _RouterConstants = __webpack_require__(630);
	
	var _RouterConstants2 = _interopRequireDefault(_RouterConstants);
	
	var _SearchConstants = __webpack_require__(125);
	
	var _SearchConstants2 = _interopRequireDefault(_SearchConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = false;
	
	function internalError() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _AppConstants2.default.SHOW_ERROR_PAGE:
	      {
	        return true;
	      }
	
	    case _SearchConstants2.default.SEARCH_FAILURE:
	      {
	        return typeof action.payload.status !== 'undefined' && action.payload.status && action.payload.status !== 422;
	      }
	
	    case _RouterConstants2.default.ROUTER_TRANSITION:
	    case _RouterConstants2.default.LOCATION_CHANGED:
	      {
	        return false;
	      }
	
	    default:
	      return state;
	  }
	}

/***/ },
/* 2116 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = library;
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _LibraryConstants = __webpack_require__(296);
	
	var _LibraryConstants2 = _interopRequireDefault(_LibraryConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = _immutable2.default.Map({
	  id: ''
	});
	
	function library() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _LibraryConstants2.default.LIBRARY_SUCCESS:
	      {
	        return state.merge(action.payload.library);
	      }
	
	    default:
	      return state;
	  }
	}

/***/ },
/* 2117 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = localization;
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _LibraryConstants = __webpack_require__(296);
	
	var _LibraryConstants2 = _interopRequireDefault(_LibraryConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = _immutable2.default.Map({
	  messages: {},
	  availableLanguages: []
	});
	
	function localization() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _LibraryConstants2.default.LIBRARY_SUCCESS:
	      {
	        return state.merge(action.payload.localizations);
	      }
	    default:
	      return state;
	  }
	}

/***/ },
/* 2118 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = optInReducer;
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _OptInConstants = __webpack_require__(625);
	
	var _OptInConstants2 = _interopRequireDefault(_OptInConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialState = _immutable2.default.Map({});
	
	var updateStateForBundle = function updateStateForBundle(bundle, state, newState) {
	  return state.merge(_defineProperty({}, bundle, _extends({}, state.get(bundle, {}), newState)));
	};
	
	function optInReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _OptInConstants2.default.TOGGLE_OPT_IN_FEEDBACK_FORM:
	      return updateStateForBundle(action.bundle, state, {
	        feedbackOpen: action.payload.open
	      });
	    case _OptInConstants2.default.OPT_IN_REQUEST:
	    case _OptInConstants2.default.OPT_OUT_REQUEST:
	    case _OptInConstants2.default.SUBMIT_OPT_IN_FEEDBACK_REQUEST:
	      return updateStateForBundle(action.bundle, state, {
	        isLoading: true
	      });
	    case _OptInConstants2.default.OPT_IN_SUCCESS:
	    case _OptInConstants2.default.OPT_OUT_SUCCESS:
	    case _OptInConstants2.default.OPT_IN_FAILURE:
	    case _OptInConstants2.default.OPT_OUT_FAILURE:
	      return updateStateForBundle(action.bundle, state, {
	        isLoading: false
	      });
	    case _OptInConstants2.default.SUBMIT_OPT_IN_FEEDBACK_SUCCESS:
	      return updateStateForBundle(action.bundle, state, {
	        isLoading: false,
	        showFeedbackSuccess: true,
	        feedbackOpen: false
	      });
	    case _OptInConstants2.default.CLOSE_FEEDBACK_SUCCESS:
	      return updateStateForBundle(action.payload, state, {
	        showFeedbackSuccess: false
	      });
	    default:
	      return state;
	  }
	}

/***/ },
/* 2119 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = recommendation;
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _RecommendationConstants = __webpack_require__(393);
	
	var _RecommendationConstants2 = _interopRequireDefault(_RecommendationConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = _immutable2.default.Map({});
	
	function recommendation() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _RecommendationConstants2.default.RECOMMENDATION_REQUEST:
	      {
	        return state.set(action.id, {
	          loaded: false,
	          zeroResults: true
	        });
	      }
	
	    case _RecommendationConstants2.default.RECOMMENDATION_SUCCESS:
	      {
	        return state.set(action.id, _extends({}, action.payload, {
	          loaded: true,
	          zeroResults: action.payload.recommendations.length === 0
	        }));
	      }
	
	    case _RecommendationConstants2.default.RECOMMENDATION_ERROR:
	      {
	        return state.set(action.id, {
	          recommendations: _immutable2.default.List(),
	          loaded: true,
	          type: null,
	          zeroResults: true
	        });
	      }
	
	    default:
	      return state;
	  }
	}

/***/ },
/* 2120 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = templates;
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _LibraryConstants = __webpack_require__(296);
	
	var _LibraryConstants2 = _interopRequireDefault(_LibraryConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = _immutable2.default.Map({
	  header: '',
	  js: '',
	  css: '',
	  footer: '',
	  screenReaderNavigation: ''
	});
	
	function templates() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _LibraryConstants2.default.LIBRARY_SUCCESS:
	      {
	        var _ref = action.payload.templates || {},
	            header = _ref.header,
	            footer = _ref.footer,
	            js = _ref.js,
	            css = _ref.css,
	            screenReaderNavigation = _ref.screen_reader_navigation;
	
	        return state.withMutations(function (newState) {
	          return newState.merge({
	            header: header,
	            footer: footer,
	            js: js,
	            css: css,
	            screenReaderNavigation: screenReaderNavigation
	          });
	        });
	      }
	    default:
	      return state;
	  }
	}

/***/ },
/* 2121 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = userReducer;
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _UserConstants = __webpack_require__(633);
	
	var _UserConstants2 = _interopRequireDefault(_UserConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = _immutable2.default.Map({
	  id: undefined,
	  isFetching: false
	});
	
	var FETCH_USER_REQUEST = _UserConstants2.default.FETCH_USER_REQUEST,
	    FETCH_USER_SUCCESS = _UserConstants2.default.FETCH_USER_SUCCESS,
	    FETCH_USER_ERROR = _UserConstants2.default.FETCH_USER_ERROR;
	function userReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case FETCH_USER_ERROR:
	      return initialState;
	
	    case FETCH_USER_REQUEST:
	      {
	        return state.merge({ isFetching: true });
	      }
	
	    case FETCH_USER_SUCCESS:
	      {
	        return state.mergeDeep(_extends({}, action.payload.user, {
	          isFetching: false
	        }));
	      }
	
	    default:
	      return state;
	  }
	}

/***/ },
/* 2122 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = borrowingHistory;
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _RecentlyReturnedConstants = __webpack_require__(629);
	
	var _RecentlyReturnedConstants2 = _interopRequireDefault(_RecentlyReturnedConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FETCH_RETURN_HISTORY_REQUEST = _RecentlyReturnedConstants2.default.FETCH_RETURN_HISTORY_REQUEST,
	    FETCH_RETURN_HISTORY_SUCCESS = _RecentlyReturnedConstants2.default.FETCH_RETURN_HISTORY_SUCCESS,
	    FETCH_RETURN_HISTORY_FAILURE = _RecentlyReturnedConstants2.default.FETCH_RETURN_HISTORY_FAILURE;
	
	
	var initialState = _immutable2.default.fromJS({
	  results: [],
	  isFetching: false
	});
	
	function borrowingHistory() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case FETCH_RETURN_HISTORY_SUCCESS:
	    case FETCH_RETURN_HISTORY_FAILURE:
	      {
	        var borrowing = action.payload.borrowing || {};
	        var history = borrowing.borrowingHistory || {};
	        return state.mergeDeep(history).set('isFetching', false);
	      }
	
	    case FETCH_RETURN_HISTORY_REQUEST:
	      {
	        return state.set('isFetching', true);
	      }
	
	    default:
	      return state;
	  }
	}

/***/ },
/* 2123 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = borrowing;
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _lodash = __webpack_require__(16);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = _immutable2.default.fromJS({
	  summaries: {
	    holds: {},
	    inactiveHolds: {},
	    checkedout: {},
	    fines: {},
	    interlibraryLoans: {}
	  }
	});
	
	function borrowing() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  var summaries = _lodash2.default.get(action, 'payload.borrowing.summaries', false);
	
	  if (summaries) {
	    var updatedSummaries = state.get('summaries', _immutable2.default.Map());
	
	    Object.keys(summaries).forEach(function (summaryType) {
	      return updatedSummaries = updatedSummaries.set(summaryType, _immutable2.default.fromJS(summaries[summaryType]));
	    });
	
	    return state.set('summaries', updatedSummaries);
	  }
	
	  return state;
	}

/***/ },
/* 2124 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = checkedOut;
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _CheckoutConstants = __webpack_require__(295);
	
	var _CheckoutConstants2 = _interopRequireDefault(_CheckoutConstants);
	
	var _BorrowingConstants = __webpack_require__(294);
	
	var _BorrowingConstants2 = _interopRequireDefault(_BorrowingConstants);
	
	var _lodash = __webpack_require__(16);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = _immutable2.default.Map({
	  items: _immutable2.default.List(),
	  pagination: _immutable2.default.Map(),
	  displayQuantity: 25,
	  numItemsShowing: 25,
	  summary: _immutable2.default.Map(),
	  checkoutTransactions: _immutable2.default.Map(),
	  failures: _immutable2.default.Map(),
	  fetching: false
	});
	
	function checkedOut() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  var checkoutTransactions = void 0;
	  var updatedState = void 0;
	
	  switch (action.type) {
	    case _CheckoutConstants2.default.FETCH_CHECKOUTS_REQUEST:
	      return state.mergeDeep({
	        fetching: true
	      });
	
	    case _CheckoutConstants2.default.FETCH_CHECKOUTS_SUCCESS:
	      return state.mergeDeep({
	        items: action.payload.borrowing.checkouts.items,
	        pagination: action.payload.borrowing.checkouts.pagination,
	        numItemsShowing: Math.min(action.payload.borrowing.checkouts.items.length, state.get('displayQuantity')),
	        summary: action.payload.borrowing.summaries.checkedout,
	        fetching: false
	      });
	
	    case _CheckoutConstants2.default.SHOW_MORE:
	      return state.set('numItemsShowing', Math.min(state.get('items').size, state.get('numItemsShowing') + state.get('displayQuantity')));
	
	    case _CheckoutConstants2.default.RENEW_REQUEST:
	      checkoutTransactions = state.get('checkoutTransactions').asMutable();
	      action.checkoutIds.forEach(function (id) {
	        return checkoutTransactions.setIn([id, 'isRenewing'], true);
	      });
	      return state.set('checkoutTransactions', checkoutTransactions.asImmutable());
	
	    case _CheckoutConstants2.default.RENEW_SUCCESS:
	    case _CheckoutConstants2.default.RENEW_FAILURE:
	      checkoutTransactions = state.get('checkoutTransactions').asMutable();
	      action.checkoutIds.forEach(function (id) {
	        return checkoutTransactions.deleteIn([id, 'isRenewing']);
	      });
	
	      updatedState = state;
	      if (action.payload.failures) {
	        updatedState = updatedState.setIn(['failures', 'renew'], _immutable2.default.fromJS(action.payload.failures));
	      }
	
	      return updatedState.set('checkoutTransactions', checkoutTransactions.asImmutable());
	
	    case _BorrowingConstants2.default.FETCH_SUMMARIES_SUCCESS:
	      return state.mergeDeep({ summary: _lodash2.default.get(action, 'payload.borrowing.checkedout.summary', {}) });
	
	    case _CheckoutConstants2.default.FETCH_CHECKOUTS_FAILURE:
	      return state.set('fetching', false);
	
	    default:
	      return state;
	  }
	}

/***/ },
/* 2125 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = finesReducer;
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _FinesConstants = __webpack_require__(618);
	
	var _FinesConstants2 = _interopRequireDefault(_FinesConstants);
	
	var _BorrowingConstants = __webpack_require__(294);
	
	var _BorrowingConstants2 = _interopRequireDefault(_BorrowingConstants);
	
	var _lodash = __webpack_require__(16);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FETCH_FINES_REQUEST = _FinesConstants2.default.FETCH_FINES_REQUEST,
	    FETCH_FINES_SUCCESS = _FinesConstants2.default.FETCH_FINES_SUCCESS,
	    FETCH_FINES_FAILURE = _FinesConstants2.default.FETCH_FINES_FAILURE,
	    FETCH_FINES_PAYMENT_FORM_SUCCESS = _FinesConstants2.default.FETCH_FINES_PAYMENT_FORM_SUCCESS,
	    FETCH_FINES_PAYMENT_FORM_FAILURE = _FinesConstants2.default.FETCH_FINES_PAYMENT_FORM_FAILURE,
	    UPDATE_PAGE_REQUEST = _FinesConstants2.default.UPDATE_PAGE_REQUEST,
	    UPDATE_PAGE_SUCCESS = _FinesConstants2.default.UPDATE_PAGE_SUCCESS,
	    UPDATE_PAGE_FAILURE = _FinesConstants2.default.UPDATE_PAGE_FAILURE;
	
	
	var initialState = _immutable2.default.Map({
	  results: _immutable2.default.List()
	});
	
	function finesReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case FETCH_FINES_SUCCESS:
	      {
	        return state.mergeDeep(action.payload.borrowing).set('results', _immutable2.default.fromJS(action.payload.borrowing.fines.results)).set('isFetching', false);
	      }
	
	    case FETCH_FINES_PAYMENT_FORM_SUCCESS:
	    case FETCH_FINES_PAYMENT_FORM_FAILURE:
	      {
	        return state.mergeDeep(action.payload.borrowing).set('isFetching', false);
	      }
	
	    case FETCH_FINES_REQUEST:
	    case UPDATE_PAGE_REQUEST:
	      {
	        return state.set('isFetching', true);
	      }
	
	    case UPDATE_PAGE_SUCCESS:
	      {
	        return state.mergeDeep(action.payload.borrowing).set('results', _immutable2.default.fromJS(action.payload.borrowing.fines.results)).set('isFetching', false);
	      }
	
	    case FETCH_FINES_FAILURE:
	    case UPDATE_PAGE_FAILURE:
	      {
	        return state.set('isFetching', false);
	      }
	
	    case _BorrowingConstants2.default.FETCH_SUMMARIES_SUCCESS:
	      {
	        return state.mergeDeep(_lodash2.default.get(action, 'payload.borrowing', {}));
	      }
	
	    default:
	      return state;
	  }
	}

/***/ },
/* 2126 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = holds;
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _HoldsConstants = __webpack_require__(98);
	
	var _HoldsConstants2 = _interopRequireDefault(_HoldsConstants);
	
	var _BorrowingConstants = __webpack_require__(294);
	
	var _BorrowingConstants2 = _interopRequireDefault(_BorrowingConstants);
	
	var _lodash = __webpack_require__(16);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialState = _immutable2.default.Map({
	  fetching: false,
	  items: _immutable2.default.List(),
	  displayQuantity: 25,
	  numItemsShowing: 25,
	  summary: _immutable2.default.Map(),
	  holdsTransactions: _immutable2.default.Map(),
	  pagination: _immutable2.default.Map()
	});
	
	function holds() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _HoldsConstants2.default.FETCH_HOLDS_REQUEST:
	      return state.mergeDeep({
	        fetching: true
	      });
	
	    case _HoldsConstants2.default.FETCH_HOLDS_SUCCESS:
	      {
	        var holdsData = action.payload.borrowing.holds || {};
	        return state.set('items', _immutable2.default.fromJS(holdsData.items)).mergeDeep({
	          numItemsShowing: Math.min(holdsData.items.length, state.get('displayQuantity')),
	          summary: action.payload.borrowing.summaries.holds,
	          pagination: holdsData.pagination,
	          fetching: false
	        });
	      }
	    case _BorrowingConstants2.default.FETCH_SUMMARIES_SUCCESS:
	      return state.mergeDeep({ summary: _lodash2.default.get(action, 'payload.borrowing.holds.summary', {}) });
	    case _HoldsConstants2.default.CANCEL_HOLD_REQUEST:
	      {
	        return state.withMutations(function (newState) {
	          action.holdIds.forEach(function (id) {
	            return newState.mergeIn(['holdsTransactions', id], { isCancelling: true });
	          });
	        });
	      }
	    case _HoldsConstants2.default.CANCEL_HOLD_SUCCESS:
	    case _HoldsConstants2.default.CANCEL_HOLD_FAILURE:
	      {
	        return state.withMutations(function (newState) {
	          action.holdIds.forEach(function (id) {
	            return newState.deleteIn(['holdsTransactions', id, 'isCancelling']);
	          });
	        });
	      }
	
	    case _HoldsConstants2.default.UPDATE_HOLDS_EXPIRY_REQUEST:
	      {
	        return state.withMutations(function (newState) {
	          action.holdIds.forEach(function (id) {
	            return newState.mergeIn(['holdsTransactions', id], { isUpdatingExpiryDate: true });
	          });
	        });
	      }
	    case _HoldsConstants2.default.UPDATE_HOLDS_EXPIRY_SUCCESS:
	    case _HoldsConstants2.default.UPDATE_HOLDS_EXPIRY_FAILURE:
	      {
	        return state.withMutations(function (newState) {
	          action.holdIds.forEach(function (id) {
	            return newState.deleteIn(['holdsTransactions', id, 'isUpdatingExpiryDate']);
	          });
	        });
	      }
	
	    case _HoldsConstants2.default.UPDATE_PAUSE_HOLDS_DATE_REQUEST:
	      {
	        return state.withMutations(function (newState) {
	          action.holdIds.forEach(function (id) {
	            return newState.mergeIn(['holdsTransactions', id], { isUpdatingPauseDate: true });
	          });
	        });
	      }
	    case _HoldsConstants2.default.UPDATE_PAUSE_HOLDS_DATE_SUCCESS:
	    case _HoldsConstants2.default.UPDATE_PAUSE_HOLDS_DATE_FAILURE:
	      {
	        return state.withMutations(function (newState) {
	          action.holdIds.forEach(function (id) {
	            return newState.deleteIn(['holdsTransactions', id, 'isUpdatingPauseDate']);
	          });
	        });
	      }
	
	    case _HoldsConstants2.default.UPDATE_PAUSE_HOLDS_REQUEST:
	      {
	        var key = action.suspended.status ? 'isPausing' : 'isResuming';
	        return state.withMutations(function (newState) {
	          action.holdIds.forEach(function (id) {
	            return newState.mergeIn(['holdsTransactions', id], _defineProperty({}, key, true));
	          });
	        });
	      }
	    case _HoldsConstants2.default.UPDATE_PAUSE_HOLDS_SUCCESS:
	    case _HoldsConstants2.default.UPDATE_PAUSE_HOLDS_FAILURE:
	      {
	        var _key = action.suspended.status ? 'isPausing' : 'isResuming';
	        return state.withMutations(function (newState) {
	          action.holdIds.forEach(function (id) {
	            return newState.deleteIn(['holdsTransactions', id, _key]);
	          });
	        });
	      }
	
	    case _HoldsConstants2.default.UPDATE_PICKUP_LOCATION_REQUEST:
	      {
	        return state.withMutations(function (newState) {
	          newState.mergeIn(['holdsTransactions', action.holdId], { isUpdatingPickupLocation: true });
	        });
	      }
	    case _HoldsConstants2.default.UPDATE_PICKUP_LOCATION_SUCCESS:
	    case _HoldsConstants2.default.UPDATE_PICKUP_LOCATION_FAILURE:
	      {
	        return state.withMutations(function (newState) {
	          newState.deleteIn(['holdsTransactions', action.holdId, 'isUpdatingPickupLocation']);
	        });
	      }
	
	    case _HoldsConstants2.default.CANCEL_HOLD_REQUEST:
	      {
	        return state.withMutations(function (newState) {
	          action.holdIds.forEach(function (id) {
	            return newState.mergeIn(['holdsTransactions', id], { isCancelling: true });
	          });
	        });
	      }
	    case _HoldsConstants2.default.CANCEL_HOLD_SUCCESS:
	    case _HoldsConstants2.default.CANCEL_HOLD_FAILURE:
	      {
	        return state.withMutations(function (newState) {
	          action.holdIds.forEach(function (id) {
	            return newState.deleteIn(['holdsTransactions', id, 'isCancelling']);
	          });
	        });
	      }
	
	    default:
	      return state;
	  }
	}

/***/ },
/* 2127 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = holds;
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _HoldsConstants = __webpack_require__(98);
	
	var _HoldsConstants2 = _interopRequireDefault(_HoldsConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = _immutable2.default.fromJS({
	  cancelled: {
	    fetching: false,
	    pagination: {}
	  },
	  expired: {
	    fetching: false,
	    pagination: {}
	  }
	});
	
	function holds() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _HoldsConstants2.default.FETCH_CANCELLED_HOLDS_REQUEST:
	      return state.mergeDeep({
	        cancelled: {
	          fetching: true
	        }
	      });
	    case _HoldsConstants2.default.FETCH_CANCELLED_HOLDS_SUCCESS:
	      {
	        var holdsData = action.payload.borrowing.holds || {};
	        return state.mergeDeep({
	          cancelled: {
	            pagination: holdsData.pagination || {},
	            holdIds: holdsData.items || [],
	            fetching: false
	          }
	        });
	      }
	    case _HoldsConstants2.default.FETCH_CANCELLED_HOLDS_FAILURE:
	      return state.mergeDeep({
	        cancelled: {
	          fetching: false
	        }
	      });
	
	    case _HoldsConstants2.default.FETCH_EXPIRED_HOLDS_REQUEST:
	      return state.mergeDeep({
	        expired: {
	          fetching: true
	        }
	      });
	
	    case _HoldsConstants2.default.FETCH_EXPIRED_HOLDS_SUCCESS:
	      {
	        var _holdsData = action.payload.borrowing.holds || {};
	        return state.mergeDeep({
	          expired: {
	            pagination: _holdsData.pagination || {},
	            holdIds: _holdsData.items || [],
	            fetching: false
	          }
	        });
	      }
	    case _HoldsConstants2.default.FETCH_EXPIRED_HOLDS_FAILURE:
	      return state.mergeDeep({
	        expired: {
	          fetching: false
	        }
	      });
	    default:
	      return state;
	  }
	}

/***/ },
/* 2128 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = InterlibraryLoansReducer;
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _InterlibraryLoansConstants = __webpack_require__(621);
	
	var _InterlibraryLoansConstants2 = _interopRequireDefault(_InterlibraryLoansConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FETCH_ILL_REQUEST = _InterlibraryLoansConstants2.default.FETCH_ILL_REQUEST,
	    FETCH_ILL_SUCCESS = _InterlibraryLoansConstants2.default.FETCH_ILL_SUCCESS,
	    FETCH_ILL_FAILURE = _InterlibraryLoansConstants2.default.FETCH_ILL_FAILURE;
	
	
	var initialState = _immutable2.default.Map();
	
	function InterlibraryLoansReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case FETCH_ILL_SUCCESS:
	    case FETCH_ILL_FAILURE:
	      {
	        return state.mergeDeep(action.payload.borrowing).set('isFetching', false);
	      }
	
	    case FETCH_ILL_REQUEST:
	      {
	        return state.set('isFetching', true);
	      }
	
	    default:
	      return state;
	  }
	}

/***/ },
/* 2129 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reduxImmutablejs = __webpack_require__(168);
	
	var _FinesReducer = __webpack_require__(2125);
	
	var _FinesReducer2 = _interopRequireDefault(_FinesReducer);
	
	var _CheckedOutReducer = __webpack_require__(2124);
	
	var _CheckedOutReducer2 = _interopRequireDefault(_CheckedOutReducer);
	
	var _BorrowingHistoryReducer = __webpack_require__(2122);
	
	var _BorrowingHistoryReducer2 = _interopRequireDefault(_BorrowingHistoryReducer);
	
	var _HoldsReducer = __webpack_require__(2126);
	
	var _HoldsReducer2 = _interopRequireDefault(_HoldsReducer);
	
	var _BorrowingReducer = __webpack_require__(2123);
	
	var _BorrowingReducer2 = _interopRequireDefault(_BorrowingReducer);
	
	var _InactiveHoldsReducer = __webpack_require__(2127);
	
	var _InactiveHoldsReducer2 = _interopRequireDefault(_InactiveHoldsReducer);
	
	var _InterlibraryLoansReducer = __webpack_require__(2128);
	
	var _InterlibraryLoansReducer2 = _interopRequireDefault(_InterlibraryLoansReducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _reduxImmutablejs.combineReducers)(_immutable2.default.Map({
	  borrowingHistory: _BorrowingHistoryReducer2.default,
	  fines: _FinesReducer2.default,
	  checkedout: _CheckedOutReducer2.default,
	  holds: _HoldsReducer2.default,
	  borrowing: _BorrowingReducer2.default,
	  inactiveHolds: _InactiveHoldsReducer2.default,
	  interlibraryLoans: _InterlibraryLoansReducer2.default
	}));

/***/ },
/* 2130 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createEntitiesReducer;
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }
	
	function createEntitiesReducer(key) {
	  var mergeDeep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var initialState = _immutable2.default.Map();
	
	  return function entityReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    var payload = action.payload || {};
	    var entities = action.entities || payload.entities;
	    var deletedEntities = action.deletedEntities || payload.deletedEntities;
	
	    if (entities || deletedEntities) {
	      var updated = state;
	      if (deletedEntities) {
	        deletedEntities.forEach(function (entityPath) {
	          var _entityPath$split = entityPath.split('.'),
	              _entityPath$split2 = _toArray(_entityPath$split),
	              rootKey = _entityPath$split2[0],
	              path = _entityPath$split2.slice(1);
	
	          if (rootKey === key) {
	            updated = updated.deleteIn(path);
	          }
	        });
	      }
	
	      if (entities && entities[key]) {
	        updated = mergeDeep ? updated.mergeDeep(entities[key]) : updated.merge(entities[key]);
	      }
	
	      return updated;
	    }
	
	    return state;
	  };
	}

/***/ },
/* 2131 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reduxImmutablejs = __webpack_require__(168);
	
	var _DefaultEntitiesReducer = __webpack_require__(2130);
	
	var _DefaultEntitiesReducer2 = _interopRequireDefault(_DefaultEntitiesReducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _reduxImmutablejs.combineReducers)(_immutable2.default.Map({
	  users: (0, _DefaultEntitiesReducer2.default)('users', true),
	  accounts: (0, _DefaultEntitiesReducer2.default)('accounts', true),
	  bibs: (0, _DefaultEntitiesReducer2.default)('bibs', true),
	  borrowingHistory: (0, _DefaultEntitiesReducer2.default)('borrowingHistory'),
	  holds: (0, _DefaultEntitiesReducer2.default)('holds'),
	  checkouts: (0, _DefaultEntitiesReducer2.default)('checkouts'),
	  fines: (0, _DefaultEntitiesReducer2.default)('fines', true),
	  interlibraryLoans: (0, _DefaultEntitiesReducer2.default)('interlibraryLoans', true),
	  messages: (0, _DefaultEntitiesReducer2.default)('messages'),
	  shelves: (0, _DefaultEntitiesReducer2.default)('shelves', true),
	  sites: (0, _DefaultEntitiesReducer2.default)('sites', true),
	  optIn: (0, _DefaultEntitiesReducer2.default)('optIn', true),
	  libraries: (0, _DefaultEntitiesReducer2.default)('libraries', true),
	  featuredContent: (0, _DefaultEntitiesReducer2.default)('featuredContent', true),
	  systemMessages: (0, _DefaultEntitiesReducer2.default)('systemMessages', true),
	  ugc: (0, _DefaultEntitiesReducer2.default)('ugc', true)
	}));

/***/ },
/* 2132 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addTitle;
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _SearchConstants = __webpack_require__(125);
	
	var _SearchConstants2 = _interopRequireDefault(_SearchConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TOOD: zeroResults should go in facade layer
	
	var DEFAULT_SEARCH_TYPE = 'smart';
	var DEFAULT_PAGE = 1;
	
	var initialState = _immutable2.default.Map({
	  isFetching: false,
	  pagination: _immutable2.default.Map({
	    page: 1,
	    pages: 1,
	    limit: 25,
	    count: 1
	  }),
	  results: _immutable2.default.List(),
	  searchQuery: _immutable2.default.Map({
	    query: null,
	    pagination_page: DEFAULT_PAGE,
	    searchType: DEFAULT_SEARCH_TYPE
	  }),
	  zeroResults: true
	});
	
	function addTitle() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _SearchConstants2.default.ADD_TITLE_SEARCH_FAILURE:
	      return initialState;
	
	    case _SearchConstants2.default.ADD_TITLE_SEARCH_REQUEST:
	      {
	        return state.merge({
	          isFetching: true
	        });
	      }
	
	    case _SearchConstants2.default.ADD_TITLE_SEARCH_SUCCESS:
	      {
	        var _action$payload$catal = action.payload.catalogSearch,
	            results = _action$payload$catal.results,
	            pagination = _action$payload$catal.pagination;
	
	        return state.merge({
	          results: results,
	          pagination: pagination,
	          searchQuery: state.get('searchQuery').merge(action.searchQuery),
	          isFetching: false,
	          zeroResults: results.length <= 0
	        });
	      }
	
	    default:
	      return state;
	  }
	}

/***/ },
/* 2133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = catalogSearchOptions;
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _AppConstants = __webpack_require__(186);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	var _SearchConstants = __webpack_require__(125);
	
	var _SearchConstants2 = _interopRequireDefault(_SearchConstants);
	
	var _utilsBrowser = __webpack_require__(59);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = _immutable2.default.Map({
	  showGroupings: false
	});
	
	var GROUPING_COOKIE = 'catalog_search_show_groupings';
	var isTrue = function isTrue(val) {
	  return (/^true$/i.test(val)
	  );
	};
	
	function catalogSearchOptions() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	
	    case _AppConstants2.default.FETCH_COOKIES:
	      {
	        return state.set('showGroupings', isTrue((0, _utilsBrowser.getCookie)(GROUPING_COOKIE)));
	      }
	
	    case _AppConstants2.default.LOAD_COOKIES:
	      {
	        return state.set('showGroupings', isTrue(action.cookies[GROUPING_COOKIE]));
	      }
	
	    case _SearchConstants2.default.TOGGLE_SHOW_GROUPINGS:
	      {
	        var showGroupings = !state.get('showGroupings');
	        return state.set('showGroupings', showGroupings);
	      }
	
	    default:
	      return state;
	  }
	}

/***/ },
/* 2134 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = catalogSearch;
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _SearchConstants = __webpack_require__(125);
	
	var _SearchConstants2 = _interopRequireDefault(_SearchConstants);
	
	var _FeaturedContentConstants = __webpack_require__(616);
	
	var _FeaturedContentConstants2 = _interopRequireDefault(_FeaturedContentConstants);
	
	var _AppConstants = __webpack_require__(186);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	var _utilsBrowser = __webpack_require__(59);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEFAULT_SEARCH_TYPE = 'smart';
	
	var initialState = _immutable2.default.Map({
	  isFetching: false,
	  pagination: _immutable2.default.Map({
	    page: 1,
	    pages: 1,
	    limit: 25,
	    count: 1
	  }),
	  title: null,
	  locked: false,
	  broadened: false,
	  view: 'grouped',
	  broadenedSearchType: null,
	  broadenedSearchCount: 0,
	  didYouMeanResultCount: 0,
	  probes: _immutable2.default.Map(),
	  didYouMeanQuerySuggestion: null,
	  featuredContent: _immutable2.default.Map(),
	  searchType: DEFAULT_SEARCH_TYPE,
	  sortBys: _immutable2.default.List(),
	  fields: _immutable2.default.List(),
	  results: _immutable2.default.List(),
	  resultPaneActive: true,
	  activeFilters: _immutable2.default.Map(),
	  searchTerm: null,
	  zeroResults: true
	});
	
	function updateActiveFilters(state) {
	  var activeFilters = state.get('fields') // get the fields
	  .filter(function (field) {
	    return !field.get('fieldFilters').filter(function (filter) {
	      return filter.get('applied') === true;
	    }).isEmpty();
	  }) // only fields that have filters applied
	  .map(function (field) {
	    return [field.get('id'), field.get('fieldFilters').filter(function (filter) {
	      return filter.get('applied') === true;
	    })];
	  } // map the applied filters
	  );
	
	  return state.merge({
	    isFetching: false,
	    activeFilters: _immutable2.default.Map(activeFilters)
	  });
	}
	
	function updatedField(fields, newField) {
	  return fields.update(fields.findIndex(function (field) {
	    return field.get('id') === newField.id;
	  }), function () {
	    return _immutable2.default.fromJS(_extends({}, newField, { hasMore: true }));
	  });
	}
	
	function catalogSearch() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _AppConstants2.default.FETCH_COOKIES:
	      {
	        return state.set('view', (0, _utilsBrowser.getCookie)(_SearchConstants.SEARCH_VIEW_COOKIE_NAME) || 'grouped');
	      }
	    case _AppConstants2.default.LOAD_COOKIES:
	      {
	        return state.set('view', action.cookies[_SearchConstants.SEARCH_VIEW_COOKIE_NAME] || 'grouped');
	      }
	    case _SearchConstants2.default.SEARCH_FAILURE:
	      return initialState;
	
	    case _SearchConstants2.default.TOGGLE_SEARCH_VIEW:
	      {
	        return state.merge({ view: action.view });
	      }
	
	    case _SearchConstants2.default.SEARCH_PROBE_SUCCESS:
	      {
	        return state.set('probes', _immutable2.default.Map(action.payload));
	      }
	
	    case _SearchConstants2.default.SEARCH_REQUEST:
	      {
	        return state.merge({
	          isFetching: true,
	          featuredContent: _immutable2.default.Map(),
	          resultPaneActive: false,
	          zeroResults: false
	        });
	      }
	    case _SearchConstants2.default.SEARCH_SUCCESS:
	      {
	        var hasNewQuery = state.has('query') && state.has('searchTerm') && state.get('query') !== state.get('searchTerm');
	        return updateActiveFilters(state.merge(_extends({}, action.payload.catalogSearch, {
	          title: hasNewQuery ? null : action.payload.catalogSearch.title || state.get('title'),
	          title_key: hasNewQuery ? null : action.payload.catalogSearch.title_key || state.get('title_key'),
	          searchTerm: action.payload.catalogSearch.query,
	          resultPaneActive: true,
	          zeroResults: action.payload.catalogSearch.results.length <= 0,
	          broadenedSearchType: action.payload.catalogSearch.broadenedSearchType || null,
	          rssURL: action.payload.rssURL
	        })));
	      }
	
	    case _FeaturedContentConstants2.default.FEATURED_CONTENT_SUCCESS:
	      {
	        return state.merge({ featuredContent: action.payload.featuredContent });
	      }
	
	    case _SearchConstants2.default.EXPAND_FIELD_SUCCESS:
	    case _SearchConstants2.default.TOGGLE_EXPANDED_FIELD_SUCCESS:
	      {
	        return state.set('fields', updatedField(state.get('fields'), action.payload));
	      }
	
	    default:
	      return state;
	  }
	}

/***/ },
/* 2135 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = searchForm;
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _SearchConstants = __webpack_require__(125);
	
	var _SearchConstants2 = _interopRequireDefault(_SearchConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEFAULT_SEARCH_TYPE = 'smart';
	
	var initialState = _immutable2.default.Map({
	  searchTerm: null,
	  searchType: DEFAULT_SEARCH_TYPE
	});
	
	var searchTypeMap = {
	  bl: 'smart',
	  bkw: 'smart',
	  keyword: 'smart',
	  catalogue: 'smart',
	  xauthor: 'author',
	  xsubject: 'subject',
	  composite_heading: 'subject'
	};
	
	var mapSearchType = function mapSearchType(type) {
	  return searchTypeMap[type] || type;
	};
	
	function searchForm() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _SearchConstants2.default.SEARCH_SUCCESS:
	      {
	        return state.merge({
	          searchType: mapSearchType(action.payload.catalogSearch.searchType),
	          searchTerm: action.payload.catalogSearch.query
	        });
	      }
	
	    default:
	      return state;
	  }
	}

/***/ },
/* 2136 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reduxImmutablejs = __webpack_require__(168);
	
	var _AddTitleReducer = __webpack_require__(2132);
	
	var _AddTitleReducer2 = _interopRequireDefault(_AddTitleReducer);
	
	var _CatalogSearchOptionsReducer = __webpack_require__(2133);
	
	var _CatalogSearchOptionsReducer2 = _interopRequireDefault(_CatalogSearchOptionsReducer);
	
	var _CatalogSearchReducer = __webpack_require__(2134);
	
	var _CatalogSearchReducer2 = _interopRequireDefault(_CatalogSearchReducer);
	
	var _SearchFormReducer = __webpack_require__(2135);
	
	var _SearchFormReducer2 = _interopRequireDefault(_SearchFormReducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _reduxImmutablejs.combineReducers)(_immutable2.default.Map({
	  addTitle: _AddTitleReducer2.default,
	  catalogSearch: _CatalogSearchReducer2.default,
	  catalogSearchOptions: _CatalogSearchOptionsReducer2.default,
	  searchForm: _SearchFormReducer2.default
	}));

/***/ },
/* 2137 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = importResultReducer;
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _ShelfConstants = __webpack_require__(43);
	
	var _ShelfConstants2 = _interopRequireDefault(_ShelfConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IMPORT_ILS_BIBS_REQUEST = _ShelfConstants2.default.IMPORT_ILS_BIBS_REQUEST,
	    IMPORT_ILS_BIBS_SUCCESS = _ShelfConstants2.default.IMPORT_ILS_BIBS_SUCCESS,
	    IMPORT_ILS_BIBS_FAILURE = _ShelfConstants2.default.IMPORT_ILS_BIBS_FAILURE;
	
	
	var initialState = _immutable2.default.Map({
	  isFetching: false
	});
	
	function importResultReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case IMPORT_ILS_BIBS_FAILURE:
	      {
	        return initialState;
	      }
	
	    case IMPORT_ILS_BIBS_REQUEST:
	      {
	        return state.set('isFetching', true);
	      }
	
	    case IMPORT_ILS_BIBS_SUCCESS:
	      {
	        return state.mergeDeep(_extends({}, action.payload.importResult, {
	          isFetching: false
	        }));
	      }
	
	    default:
	      return state;
	  }
	}

/***/ },
/* 2138 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = shelfSearchReducer;
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _ShelfConstants = __webpack_require__(43);
	
	var _ShelfConstants2 = _interopRequireDefault(_ShelfConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = _immutable2.default.fromJS({
	  isFetching: false,
	  shelf: {
	    userId: null,
	    name: null,
	    privateByDefault: false,
	    facets: [],
	    items: [],
	    sort: {
	      direction: null,
	      fields: []
	    },
	    query: {
	      filters: {}
	    },
	    pagination: {
	      page: 0,
	      pages: 1,
	      limit: 25,
	      count: 1
	    }
	  },
	  summary: {
	    shelves: []
	  }
	});
	
	var FETCH_FILTERS_REQUEST = _ShelfConstants2.default.FETCH_FILTERS_REQUEST,
	    FETCH_FILTERS_SUCCESS = _ShelfConstants2.default.FETCH_FILTERS_SUCCESS,
	    SHELF_SEARCH_FAILURE = _ShelfConstants2.default.SHELF_SEARCH_FAILURE,
	    SHELF_SEARCH_REQUEST = _ShelfConstants2.default.SHELF_SEARCH_REQUEST,
	    SHELF_SEARCH_SUCCESS = _ShelfConstants2.default.SHELF_SEARCH_SUCCESS;
	function shelfSearchReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case SHELF_SEARCH_FAILURE:
	      return initialState;
	
	    case FETCH_FILTERS_REQUEST:
	    case SHELF_SEARCH_REQUEST:
	      {
	        return state.merge({ isFetching: true });
	      }
	
	    case SHELF_SEARCH_SUCCESS:
	      {
	        return state.merge(_immutable2.default.fromJS({
	          shelf: action.payload.shelf,
	          summary: action.payload.summary,
	          isFetching: false
	        }));
	      }
	
	    case FETCH_FILTERS_SUCCESS:
	      {
	        var fieldIndex = state.getIn(['shelf', 'facets']).findIndex(function (field) {
	          return field.get('id') === action.payload.id;
	        });
	        return state.setIn(['shelf', 'facets', fieldIndex], _immutable2.default.fromJS(_extends({}, action.payload, { hasMore: true })));
	      }
	
	    default:
	      return state;
	  }
	}

/***/ },
/* 2139 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = shelfTransactionsReducer;
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _ShelfConstants = __webpack_require__(43);
	
	var _ShelfConstants2 = _interopRequireDefault(_ShelfConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ADD_TO_SHELF_REQUEST = _ShelfConstants2.default.ADD_TO_SHELF_REQUEST,
	    ADD_TO_SHELF_SUCCESS = _ShelfConstants2.default.ADD_TO_SHELF_SUCCESS,
	    ADD_TO_SHELF_FAILURE = _ShelfConstants2.default.ADD_TO_SHELF_FAILURE,
	    REMOVE_FROM_SHELF_REQUEST = _ShelfConstants2.default.REMOVE_FROM_SHELF_REQUEST,
	    REMOVE_FROM_SHELF_SUCCESS = _ShelfConstants2.default.REMOVE_FROM_SHELF_SUCCESS,
	    REMOVE_FROM_SHELF_FAILURE = _ShelfConstants2.default.REMOVE_FROM_SHELF_FAILURE,
	    UPDATE_SHELF_ITEM_REQUEST = _ShelfConstants2.default.UPDATE_SHELF_ITEM_REQUEST,
	    UPDATE_SHELF_ITEM_SUCCESS = _ShelfConstants2.default.UPDATE_SHELF_ITEM_SUCCESS,
	    UPDATE_SHELF_ITEM_FAILURE = _ShelfConstants2.default.UPDATE_SHELF_ITEM_FAILURE;
	
	
	var initialState = _immutable2.default.Map();
	
	function shelfTransactionsReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	  var isBatch = action.isBatch,
	      metadataIds = action.metadataIds,
	      type = action.type,
	      fields = action.fields;
	
	
	  switch (type) {
	    case ADD_TO_SHELF_REQUEST:
	      {
	        return state.withMutations(function (newState) {
	          var transaction = isBatch ? { isBatchAdding: true } : { isAdding: true };
	          metadataIds.forEach(function (id) {
	            return newState.mergeIn([id], transaction);
	          });
	        });
	      }
	
	    case REMOVE_FROM_SHELF_REQUEST:
	      {
	        return state.withMutations(function (newState) {
	          var transaction = isBatch ? { isBatchRemoving: true } : { isRemoving: true };
	          metadataIds.forEach(function (id) {
	            return newState.mergeIn([id], transaction);
	          });
	        });
	      }
	
	    case UPDATE_SHELF_ITEM_REQUEST:
	      {
	        return state.withMutations(function (newState) {
	          var privacyTransaction = isBatch ? { isBatchUpdatingPrivacy: true } : { isUpdatingPrivacy: true };
	          var moveTransaction = isBatch ? { isBatchMoving: true } : { isMoving: true };
	          var transaction = fields.privateItem !== undefined ? privacyTransaction : moveTransaction;
	          metadataIds.forEach(function (id) {
	            return newState.mergeIn([id], transaction);
	          });
	        });
	      }
	
	    case ADD_TO_SHELF_SUCCESS:
	    case ADD_TO_SHELF_FAILURE:
	    case UPDATE_SHELF_ITEM_SUCCESS:
	    case UPDATE_SHELF_ITEM_FAILURE:
	    case REMOVE_FROM_SHELF_FAILURE:
	    case REMOVE_FROM_SHELF_SUCCESS:
	      {
	        return state.withMutations(function (newState) {
	          metadataIds.forEach(function (id) {
	            return newState.delete(id);
	          });
	        });
	      }
	
	    default:
	      return state;
	  }
	}

/***/ },
/* 2140 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reduxImmutablejs = __webpack_require__(168);
	
	var _ImportResultReducer = __webpack_require__(2137);
	
	var _ImportResultReducer2 = _interopRequireDefault(_ImportResultReducer);
	
	var _ShelfSearchReducer = __webpack_require__(2138);
	
	var _ShelfSearchReducer2 = _interopRequireDefault(_ShelfSearchReducer);
	
	var _ShelfTransactionsReducer = __webpack_require__(2139);
	
	var _ShelfTransactionsReducer2 = _interopRequireDefault(_ShelfTransactionsReducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _reduxImmutablejs.combineReducers)(_immutable2.default.Map({
	  importResult: _ImportResultReducer2.default,
	  shelfTransactions: _ShelfTransactionsReducer2.default,
	  shelfSearch: _ShelfSearchReducer2.default
	}));

/***/ },
/* 2141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = CommentsTransactionsReducer;
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _CommentsConstants = __webpack_require__(613);
	
	var _CommentsConstants2 = _interopRequireDefault(_CommentsConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ADD_COMMENT_REQUEST = _CommentsConstants2.default.ADD_COMMENT_REQUEST,
	    ADD_COMMENT_SUCCESS = _CommentsConstants2.default.ADD_COMMENT_SUCCESS,
	    ADD_COMMENT_FAILURE = _CommentsConstants2.default.ADD_COMMENT_FAILURE,
	    UPDATE_COMMENT_REQUEST = _CommentsConstants2.default.UPDATE_COMMENT_REQUEST,
	    UPDATE_COMMENT_SUCCESS = _CommentsConstants2.default.UPDATE_COMMENT_SUCCESS,
	    UPDATE_COMMENT_FAILURE = _CommentsConstants2.default.UPDATE_COMMENT_FAILURE,
	    REMOVE_COMMENT_REQUEST = _CommentsConstants2.default.REMOVE_COMMENT_REQUEST,
	    REMOVE_COMMENT_SUCCESS = _CommentsConstants2.default.REMOVE_COMMENT_SUCCESS,
	    REMOVE_COMMENT_FAILURE = _CommentsConstants2.default.REMOVE_COMMENT_FAILURE;
	
	
	var initialState = _immutable2.default.Map();
	
	function CommentsTransactionsReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case ADD_COMMENT_REQUEST:
	      {
	        return state.mergeIn([action.metadataId], { isAdding: true });
	      }
	
	    case UPDATE_COMMENT_REQUEST:
	      {
	        return state.mergeIn([action.metadataId, action.commentId], { isUpdating: true });
	      }
	
	    case REMOVE_COMMENT_REQUEST:
	      {
	        return state.mergeIn([action.metadataId, action.commentId], { isRemoving: true });
	      }
	
	    case ADD_COMMENT_SUCCESS:
	    case ADD_COMMENT_FAILURE:
	    case UPDATE_COMMENT_SUCCESS:
	    case UPDATE_COMMENT_FAILURE:
	    case REMOVE_COMMENT_SUCCESS:
	    case REMOVE_COMMENT_FAILURE:
	      {
	        return state.delete(action.metadataId);
	      }
	
	    default:
	      return state;
	  }
	}

/***/ },
/* 2142 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = IOwnThisTransactionsReducer;
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _IOwnThisConstants = __webpack_require__(620);
	
	var _IOwnThisConstants2 = _interopRequireDefault(_IOwnThisConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CREATE_I_OWN_THIS_SETTING_REQUEST = _IOwnThisConstants2.default.CREATE_I_OWN_THIS_SETTING_REQUEST,
	    CREATE_I_OWN_THIS_SETTING_SUCCESS = _IOwnThisConstants2.default.CREATE_I_OWN_THIS_SETTING_SUCCESS,
	    CREATE_I_OWN_THIS_SETTING_FAILURE = _IOwnThisConstants2.default.CREATE_I_OWN_THIS_SETTING_FAILURE,
	    REMOVE_I_OWN_THIS_SETTING_REQUEST = _IOwnThisConstants2.default.REMOVE_I_OWN_THIS_SETTING_REQUEST,
	    REMOVE_I_OWN_THIS_SETTING_SUCCESS = _IOwnThisConstants2.default.REMOVE_I_OWN_THIS_SETTING_SUCCESS,
	    REMOVE_I_OWN_THIS_SETTING_FAILURE = _IOwnThisConstants2.default.REMOVE_I_OWN_THIS_SETTING_FAILURE;
	
	
	var initialState = _immutable2.default.Map();
	
	function IOwnThisTransactionsReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case CREATE_I_OWN_THIS_SETTING_REQUEST:
	      {
	        return state.mergeIn([action.metadataId], { isAdding: true });
	      }
	
	    case REMOVE_I_OWN_THIS_SETTING_REQUEST:
	      {
	        return state.mergeIn([action.metadataId, action.ownerSettingId], { isRemoving: true });
	      }
	
	    case CREATE_I_OWN_THIS_SETTING_SUCCESS:
	    case CREATE_I_OWN_THIS_SETTING_FAILURE:
	    case REMOVE_I_OWN_THIS_SETTING_SUCCESS:
	    case REMOVE_I_OWN_THIS_SETTING_FAILURE:
	      {
	        return state.delete(action.metadataId);
	      }
	
	    default:
	      return state;
	  }
	}

/***/ },
/* 2143 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = PrivateNotesTransactionsReducer;
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _PrivateNotesConstants = __webpack_require__(626);
	
	var _PrivateNotesConstants2 = _interopRequireDefault(_PrivateNotesConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ADD_PRIVATE_NOTES_REQUEST = _PrivateNotesConstants2.default.ADD_PRIVATE_NOTES_REQUEST,
	    ADD_PRIVATE_NOTES_SUCCESS = _PrivateNotesConstants2.default.ADD_PRIVATE_NOTES_SUCCESS,
	    ADD_PRIVATE_NOTES_FAILURE = _PrivateNotesConstants2.default.ADD_PRIVATE_NOTES_FAILURE,
	    UPDATE_PRIVATE_NOTES_REQUEST = _PrivateNotesConstants2.default.UPDATE_PRIVATE_NOTES_REQUEST,
	    UPDATE_PRIVATE_NOTES_SUCCESS = _PrivateNotesConstants2.default.UPDATE_PRIVATE_NOTES_SUCCESS,
	    UPDATE_PRIVATE_NOTES_FAILURE = _PrivateNotesConstants2.default.UPDATE_PRIVATE_NOTES_FAILURE,
	    REMOVE_PRIVATE_NOTES_REQUEST = _PrivateNotesConstants2.default.REMOVE_PRIVATE_NOTES_REQUEST,
	    REMOVE_PRIVATE_NOTES_SUCCESS = _PrivateNotesConstants2.default.REMOVE_PRIVATE_NOTES_SUCCESS,
	    REMOVE_PRIVATE_NOTES_FAILURE = _PrivateNotesConstants2.default.REMOVE_PRIVATE_NOTES_FAILURE;
	
	
	var initialState = _immutable2.default.Map();
	
	function PrivateNotesTransactionsReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case ADD_PRIVATE_NOTES_REQUEST:
	      {
	        return state.mergeIn([action.metadataId], { isAdding: true });
	      }
	
	    case UPDATE_PRIVATE_NOTES_REQUEST:
	      {
	        return state.mergeIn([action.metadataId, action.noteId], { isUpdating: true });
	      }
	
	    case REMOVE_PRIVATE_NOTES_REQUEST:
	      {
	        return state.mergeIn([action.metadataId, action.noteId], { isRemoving: true });
	      }
	
	    case ADD_PRIVATE_NOTES_SUCCESS:
	    case ADD_PRIVATE_NOTES_FAILURE:
	    case UPDATE_PRIVATE_NOTES_SUCCESS:
	    case UPDATE_PRIVATE_NOTES_FAILURE:
	    case REMOVE_PRIVATE_NOTES_SUCCESS:
	    case REMOVE_PRIVATE_NOTES_FAILURE:
	      {
	        return state.delete(action.metadataId);
	      }
	
	    default:
	      return state;
	  }
	}

/***/ },
/* 2144 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = QuotationsTransactionsReducer;
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _QuotationsConstants = __webpack_require__(627);
	
	var _QuotationsConstants2 = _interopRequireDefault(_QuotationsConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ADD_QUOTATION_REQUEST = _QuotationsConstants2.default.ADD_QUOTATION_REQUEST,
	    ADD_QUOTATION_SUCCESS = _QuotationsConstants2.default.ADD_QUOTATION_SUCCESS,
	    ADD_QUOTATION_FAILURE = _QuotationsConstants2.default.ADD_QUOTATION_FAILURE,
	    UPDATE_QUOTATION_REQUEST = _QuotationsConstants2.default.UPDATE_QUOTATION_REQUEST,
	    UPDATE_QUOTATION_SUCCESS = _QuotationsConstants2.default.UPDATE_QUOTATION_SUCCESS,
	    UPDATE_QUOTATION_FAILURE = _QuotationsConstants2.default.UPDATE_QUOTATION_FAILURE,
	    REMOVE_QUOTATION_REQUEST = _QuotationsConstants2.default.REMOVE_QUOTATION_REQUEST,
	    REMOVE_QUOTATION_SUCCESS = _QuotationsConstants2.default.REMOVE_QUOTATION_SUCCESS,
	    REMOVE_QUOTATION_FAILURE = _QuotationsConstants2.default.REMOVE_QUOTATION_FAILURE;
	
	
	var initialState = _immutable2.default.Map();
	
	function QuotationsTransactionsReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case ADD_QUOTATION_REQUEST:
	      {
	        return state.mergeIn([action.metadataId], { isAdding: true });
	      }
	
	    case UPDATE_QUOTATION_REQUEST:
	      {
	        return state.mergeIn([action.metadataId, action.quotationId], { isUpdating: true });
	      }
	
	    case REMOVE_QUOTATION_REQUEST:
	      {
	        return state.mergeIn([action.metadataId, action.quotationId], { isRemoving: true });
	      }
	
	    case ADD_QUOTATION_SUCCESS:
	    case ADD_QUOTATION_FAILURE:
	    case UPDATE_QUOTATION_SUCCESS:
	    case UPDATE_QUOTATION_FAILURE:
	    case REMOVE_QUOTATION_SUCCESS:
	    case REMOVE_QUOTATION_FAILURE:
	      {
	        return state.delete(action.metadataId);
	      }
	
	    default:
	      return state;
	  }
	}

/***/ },
/* 2145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ratingsTransactionsReducer;
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _RatingsConstants = __webpack_require__(628);
	
	var _RatingsConstants2 = _interopRequireDefault(_RatingsConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RATE_ITEM_REQUEST = _RatingsConstants2.default.RATE_ITEM_REQUEST,
	    RATE_ITEM_SUCCESS = _RatingsConstants2.default.RATE_ITEM_SUCCESS,
	    RATE_ITEM_FAILURE = _RatingsConstants2.default.RATE_ITEM_FAILURE,
	    CHANGE_ITEM_RATING_REQUEST = _RatingsConstants2.default.CHANGE_ITEM_RATING_REQUEST,
	    CHANGE_ITEM_RATING_SUCCESS = _RatingsConstants2.default.CHANGE_ITEM_RATING_SUCCESS,
	    CHANGE_ITEM_RATING_FAILURE = _RatingsConstants2.default.CHANGE_ITEM_RATING_FAILURE,
	    REMOVE_ITEM_RATING_REQUEST = _RatingsConstants2.default.REMOVE_ITEM_RATING_REQUEST,
	    REMOVE_ITEM_RATING_SUCCESS = _RatingsConstants2.default.REMOVE_ITEM_RATING_SUCCESS,
	    REMOVE_ITEM_RATING_FAILURE = _RatingsConstants2.default.REMOVE_ITEM_RATING_FAILURE;
	
	
	var initialState = _immutable2.default.Map();
	
	function ratingsTransactionsReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case RATE_ITEM_REQUEST:
	    case CHANGE_ITEM_RATING_REQUEST:
	    case REMOVE_ITEM_RATING_REQUEST:
	      {
	        return state.withMutations(function (newState) {
	          action.metadataIds.forEach(function (id) {
	            return newState.mergeIn([id], { isLoading: true });
	          });
	        });
	      }
	
	    case RATE_ITEM_SUCCESS:
	    case RATE_ITEM_FAILURE:
	    case CHANGE_ITEM_RATING_FAILURE:
	    case CHANGE_ITEM_RATING_SUCCESS:
	    case REMOVE_ITEM_RATING_SUCCESS:
	    case REMOVE_ITEM_RATING_FAILURE:
	      {
	        return state.withMutations(function (newState) {
	          action.metadataIds.forEach(function (id) {
	            return newState.delete(id);
	          });
	        });
	      }
	
	    default:
	      return state;
	  }
	}

/***/ },
/* 2146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = SimilarTitlesTransactionsReducer;
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _SimilarTitlesConstants = __webpack_require__(631);
	
	var _SimilarTitlesConstants2 = _interopRequireDefault(_SimilarTitlesConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var REMOVE_SIMILAR_TITLES_REQUEST = _SimilarTitlesConstants2.default.REMOVE_SIMILAR_TITLES_REQUEST,
	    REMOVE_SIMILAR_TITLES_SUCCESS = _SimilarTitlesConstants2.default.REMOVE_SIMILAR_TITLES_SUCCESS,
	    REMOVE_SIMILAR_TITLES_FAILURE = _SimilarTitlesConstants2.default.REMOVE_SIMILAR_TITLES_FAILURE;
	
	
	var initialState = _immutable2.default.Map();
	
	function SimilarTitlesTransactionsReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case REMOVE_SIMILAR_TITLES_REQUEST:
	      {
	        return state.mergeIn([action.metadataId, action.similarMetadataId], { isRemoving: true });
	      }
	
	    case REMOVE_SIMILAR_TITLES_SUCCESS:
	    case REMOVE_SIMILAR_TITLES_FAILURE:
	      {
	        return state.delete(action.metadataId);
	      }
	
	    default:
	      return state;
	  }
	}

/***/ },
/* 2147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = TagsTransactionsReducer;
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _TagsConstants = __webpack_require__(242);
	
	var _TagsConstants2 = _interopRequireDefault(_TagsConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ADD_TAG_REQUEST = _TagsConstants2.default.ADD_TAG_REQUEST,
	    ADD_TAG_SUCCESS = _TagsConstants2.default.ADD_TAG_SUCCESS,
	    ADD_TAG_FAILURE = _TagsConstants2.default.ADD_TAG_FAILURE,
	    REMOVE_TAG_REQUEST = _TagsConstants2.default.REMOVE_TAG_REQUEST,
	    REMOVE_TAG_SUCCESS = _TagsConstants2.default.REMOVE_TAG_SUCCESS,
	    REMOVE_TAG_FAILURE = _TagsConstants2.default.REMOVE_TAG_FAILURE;
	
	
	var initialState = _immutable2.default.Map();
	
	function TagsTransactionsReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case ADD_TAG_REQUEST:
	      {
	        return state.mergeIn([action.metadataId], { isAdding: true });
	      }
	
	    case REMOVE_TAG_REQUEST:
	      {
	        return state.mergeIn([action.metadataId, action.tagId], { isRemoving: true });
	      }
	
	    case ADD_TAG_SUCCESS:
	    case ADD_TAG_FAILURE:
	    case REMOVE_TAG_SUCCESS:
	    case REMOVE_TAG_FAILURE:
	      {
	        return state.delete(action.metadataId);
	      }
	
	    default:
	      return state;
	  }
	}

/***/ },
/* 2148 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = VideosTransactionsReducer;
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _VideosConstants = __webpack_require__(634);
	
	var _VideosConstants2 = _interopRequireDefault(_VideosConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ADD_VIDEO_REQUEST = _VideosConstants2.default.ADD_VIDEO_REQUEST,
	    ADD_VIDEO_SUCCESS = _VideosConstants2.default.ADD_VIDEO_SUCCESS,
	    ADD_VIDEO_FAILURE = _VideosConstants2.default.ADD_VIDEO_FAILURE,
	    UPDATE_VIDEO_REQUEST = _VideosConstants2.default.UPDATE_VIDEO_REQUEST,
	    UPDATE_VIDEO_SUCCESS = _VideosConstants2.default.UPDATE_VIDEO_SUCCESS,
	    UPDATE_VIDEO_FAILURE = _VideosConstants2.default.UPDATE_VIDEO_FAILURE,
	    REMOVE_VIDEO_REQUEST = _VideosConstants2.default.REMOVE_VIDEO_REQUEST,
	    REMOVE_VIDEO_SUCCESS = _VideosConstants2.default.REMOVE_VIDEO_SUCCESS,
	    REMOVE_VIDEO_FAILURE = _VideosConstants2.default.REMOVE_VIDEO_FAILURE;
	
	
	var initialState = _immutable2.default.Map();
	
	function VideosTransactionsReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case ADD_VIDEO_REQUEST:
	      {
	        return state.mergeIn([action.metadataId], { isAdding: true });
	      }
	
	    case UPDATE_VIDEO_REQUEST:
	      {
	        return state.mergeIn([action.metadataId, action.videoId], { isUpdating: true });
	      }
	
	    case REMOVE_VIDEO_REQUEST:
	      {
	        return state.mergeIn([action.metadataId, action.videoId], { isRemoving: true });
	      }
	
	    case ADD_VIDEO_SUCCESS:
	    case ADD_VIDEO_FAILURE:
	    case UPDATE_VIDEO_SUCCESS:
	    case UPDATE_VIDEO_FAILURE:
	    case REMOVE_VIDEO_SUCCESS:
	    case REMOVE_VIDEO_FAILURE:
	      {
	        return state.delete(action.metadataId);
	      }
	
	    default:
	      return state;
	  }
	}

/***/ },
/* 2149 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reduxImmutablejs = __webpack_require__(168);
	
	var _CommentsTransactionsReducer = __webpack_require__(2141);
	
	var _CommentsTransactionsReducer2 = _interopRequireDefault(_CommentsTransactionsReducer);
	
	var _QuotationsTransactionsReducer = __webpack_require__(2144);
	
	var _QuotationsTransactionsReducer2 = _interopRequireDefault(_QuotationsTransactionsReducer);
	
	var _RatingsTransactionsReducer = __webpack_require__(2145);
	
	var _RatingsTransactionsReducer2 = _interopRequireDefault(_RatingsTransactionsReducer);
	
	var _TagsTransactionsReducer = __webpack_require__(2147);
	
	var _TagsTransactionsReducer2 = _interopRequireDefault(_TagsTransactionsReducer);
	
	var _VideosTransactionsReducer = __webpack_require__(2148);
	
	var _VideosTransactionsReducer2 = _interopRequireDefault(_VideosTransactionsReducer);
	
	var _IOwnThisTransactionsReducer = __webpack_require__(2142);
	
	var _IOwnThisTransactionsReducer2 = _interopRequireDefault(_IOwnThisTransactionsReducer);
	
	var _SimilarTitlesTransactionsReducer = __webpack_require__(2146);
	
	var _SimilarTitlesTransactionsReducer2 = _interopRequireDefault(_SimilarTitlesTransactionsReducer);
	
	var _PrivateNotesTransactionsReducer = __webpack_require__(2143);
	
	var _PrivateNotesTransactionsReducer2 = _interopRequireDefault(_PrivateNotesTransactionsReducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _reduxImmutablejs.combineReducers)(_immutable2.default.Map({
	  commentsTransactions: _CommentsTransactionsReducer2.default,
	  quotationsTransactions: _QuotationsTransactionsReducer2.default,
	  ratingsTransactions: _RatingsTransactionsReducer2.default,
	  tagsTransactions: _TagsTransactionsReducer2.default,
	  videosTransactions: _VideosTransactionsReducer2.default,
	  iOwnThisTransactions: _IOwnThisTransactionsReducer2.default,
	  similarTitlesTransactions: _SimilarTitlesTransactionsReducer2.default,
	  privateNotesTransactionsReducer: _PrivateNotesTransactionsReducer2.default
	}));

/***/ },
/* 2150 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = accountMessages;
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _MessagesConstants = __webpack_require__(623);
	
	var _MessagesConstants2 = _interopRequireDefault(_MessagesConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = _immutable2.default.Map({
	  fetching: false
	});
	
	function accountMessages() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _MessagesConstants2.default.FETCH_MESSAGES_REQUEST:
	      return state.mergeDeep({
	        fetching: true
	      });
	
	    case _MessagesConstants2.default.FETCH_MESSAGES_SUCCESS:
	    case _MessagesConstants2.default.FETCH_MESSAGES_FAILURE:
	      return state.mergeDeep({
	        fetching: false
	      });
	
	    default:
	      return state;
	  }
	}

/***/ },
/* 2151 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = feedback;
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _FeedbackConstants = __webpack_require__(617);
	
	var _FeedbackConstants2 = _interopRequireDefault(_FeedbackConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = _immutable2.default.Map({
	  isSubmitting: false,
	  expanded: false,
	  category: null
	});
	
	function feedback() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _FeedbackConstants2.default.EXPAND_FEEDBACK:
	      return state.set('expanded', true);
	    case _FeedbackConstants2.default.COLLAPSE_FEEDBACK:
	      return state.set('expanded', false);
	    case _FeedbackConstants2.default.UPDATE_CATEGORY:
	      return state.set('category', action.payload);
	    case _FeedbackConstants2.default.SUBMIT_FEEDBACK_REQUEST:
	      return state.set('isSubmitting', true);
	    case _FeedbackConstants2.default.SUBMIT_FEEDBACK_SUCCESS:
	    case _FeedbackConstants2.default.SUBMIT_FEEDBACK_FAILURE:
	      return state.merge({
	        isSubmitting: false,
	        expanded: action.type === _FeedbackConstants2.default.SUBMIT_FEEDBACK_FAILURE
	      });
	    default:
	      return state;
	  }
	}

/***/ },
/* 2152 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = itemTransactionReducer;
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _GroupSearchFeedbackConstants = __webpack_require__(619);
	
	var _GroupSearchFeedbackConstants2 = _interopRequireDefault(_GroupSearchFeedbackConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = _immutable2.default.Map({
	  metadataId1: null,
	  metadataId2: null,
	  searchUrl: null,
	  shouldMatch: false,
	  notes: null,
	  groupSearchSummary1: null,
	  groupSearchSummary2: null,
	  isSubmitting: false,
	  isEditing: false
	});
	
	function itemTransactionReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _GroupSearchFeedbackConstants2.default.OPEN_FEEDBACK_OVERLAY:
	      return state.merge({
	        metadataId1: action.payload.metadataId,
	        groupSearchSummary1: action.payload.groupSearchSummary,
	        searchUrl: action.payload.searchUrl,
	        isEditing: true
	      });
	    case _GroupSearchFeedbackConstants2.default.CLOSE_FEEDBACK_OVERLAY:
	      return initialState;
	
	    case _GroupSearchFeedbackConstants2.default.SELECT_MATCHING_BIB:
	      return state.merge({
	        metadataId2: action.payload.metadataId,
	        groupSearchSummary2: action.payload.groupSearchSummary
	      });
	
	    case _GroupSearchFeedbackConstants2.default.CHANGE_MATCHING_BIB:
	      return state.merge({
	        metadataId2: null,
	        groupSearchSummary2: null
	      });
	
	    case _GroupSearchFeedbackConstants2.default.CHOOSE_SHOULD_MATCH:
	      return state.set('shouldMatch', action.payload);
	
	    case _GroupSearchFeedbackConstants2.default.SUBMIT_FEEDBACK_REQUEST:
	      return state.merge({
	        isSubmitting: true,
	        notes: action.payload.notes
	      });
	
	    case _GroupSearchFeedbackConstants2.default.SUBMIT_FEEDBACK_SUCCESS:
	      return initialState;
	    case _GroupSearchFeedbackConstants2.default.SUBMIT_FEEDBACK_FAILURE:
	      {
	        var isMissingRequiredFields = action.payload.status === 422;
	        if (isMissingRequiredFields) {
	          return state.merge({
	            isMissingRequiredFields: isMissingRequiredFields,
	            isSubmitting: false
	          });
	        }
	        return state.set('isSubmitting', false);
	      }
	
	    default:
	      return state;
	  }
	}

/***/ },
/* 2153 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = itemLevelHoldReducer;
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _HoldsConstants = __webpack_require__(98);
	
	var _HoldsConstants2 = _interopRequireDefault(_HoldsConstants);
	
	var _lodash = __webpack_require__(16);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FETCH_ITEM_GROUPS_REQUEST = _HoldsConstants2.default.FETCH_ITEM_GROUPS_REQUEST,
	    FETCH_ITEM_GROUPS_SUCCESS = _HoldsConstants2.default.FETCH_ITEM_GROUPS_SUCCESS,
	    FETCH_ITEM_GROUPS_FAILURE = _HoldsConstants2.default.FETCH_ITEM_GROUPS_FAILURE;
	
	
	var initialState = _immutable2.default.Map();
	
	function itemLevelHoldReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case FETCH_ITEM_GROUPS_REQUEST:
	      {
	        return state.mergeIn([action.payload.id], {
	          isFetching: true
	        });
	      }
	    case FETCH_ITEM_GROUPS_SUCCESS:
	    case FETCH_ITEM_GROUPS_FAILURE:
	      {
	        return state.mergeIn(_lodash2.default.keys(_lodash2.default.get(action, 'payload.entities.bibs')), {
	          isFetching: false
	        });
	      }
	    default:
	      return state;
	  }
	}

/***/ },
/* 2154 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = itemTransactionReducer;
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _lodash = __webpack_require__(16);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _CheckoutConstants = __webpack_require__(295);
	
	var _CheckoutConstants2 = _interopRequireDefault(_CheckoutConstants);
	
	var _HoldsConstants = __webpack_require__(98);
	
	var _HoldsConstants2 = _interopRequireDefault(_HoldsConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PLACE_HOLD_REQUEST = _HoldsConstants2.default.PLACE_HOLD_REQUEST,
	    PLACE_HOLD_SUCCESS = _HoldsConstants2.default.PLACE_HOLD_SUCCESS,
	    PLACE_HOLD_FAILURE = _HoldsConstants2.default.PLACE_HOLD_FAILURE,
	    CANCEL_HOLD_REQUEST = _HoldsConstants2.default.CANCEL_HOLD_REQUEST,
	    CANCEL_HOLD_SUCCESS = _HoldsConstants2.default.CANCEL_HOLD_SUCCESS,
	    CANCEL_HOLD_FAILURE = _HoldsConstants2.default.CANCEL_HOLD_FAILURE,
	    UPDATE_PICKUP_LOCATION = _HoldsConstants2.default.UPDATE_PICKUP_LOCATION,
	    UPDATE_PAUSE_HOLDS_REQUEST = _HoldsConstants2.default.UPDATE_PAUSE_HOLDS_REQUEST,
	    UPDATE_PAUSE_HOLDS_SUCCESS = _HoldsConstants2.default.UPDATE_PAUSE_HOLDS_SUCCESS,
	    UPDATE_PAUSE_HOLDS_FAILURE = _HoldsConstants2.default.UPDATE_PAUSE_HOLDS_FAILURE;
	var DIGITAL_CHECKOUT_REQUEST = _CheckoutConstants2.default.DIGITAL_CHECKOUT_REQUEST,
	    DIGITAL_CHECKOUT_SUCCESS = _CheckoutConstants2.default.DIGITAL_CHECKOUT_SUCCESS,
	    DIGITAL_CHECKOUT_FAILURE = _CheckoutConstants2.default.DIGITAL_CHECKOUT_FAILURE,
	    DIGITAL_FORMAT_LOCK_REQUEST = _CheckoutConstants2.default.DIGITAL_FORMAT_LOCK_REQUEST,
	    DIGITAL_FORMAT_LOCK_SUCCESS = _CheckoutConstants2.default.DIGITAL_FORMAT_LOCK_SUCCESS,
	    DIGITAL_FORMAT_LOCK_FAILURE = _CheckoutConstants2.default.DIGITAL_FORMAT_LOCK_FAILURE;
	
	
	var initialState = _immutable2.default.Map();
	
	function itemTransactionReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case PLACE_HOLD_REQUEST:
	    case DIGITAL_CHECKOUT_REQUEST:
	    case DIGITAL_FORMAT_LOCK_REQUEST:
	      {
	        return state.mergeIn([action.payload.id], {
	          isLoading: true,
	          failedItemIds: _immutable2.default.List(),
	          successfulItemIds: _immutable2.default.List()
	        });
	      }
	    case CANCEL_HOLD_REQUEST:
	    case UPDATE_PAUSE_HOLDS_REQUEST:
	      {
	        return state.mergeIn([action.workflowId], {
	          isLoading: true
	        });
	      }
	
	    case PLACE_HOLD_SUCCESS:
	    case DIGITAL_CHECKOUT_SUCCESS:
	    case DIGITAL_FORMAT_LOCK_SUCCESS:
	      {
	        return state.mergeIn([action.payload.id], _extends({
	          isLoading: false,
	          failedItemIds: _immutable2.default.List(),
	          successfulItemIds: _immutable2.default.List()
	        }, action.payload));
	      }
	    case CANCEL_HOLD_SUCCESS:
	    case UPDATE_PAUSE_HOLDS_SUCCESS:
	      {
	        return state.mergeIn([action.workflowId], _extends({}, action.payload, {
	          isLoading: false
	        }));
	      }
	
	    case PLACE_HOLD_FAILURE:
	    case DIGITAL_CHECKOUT_FAILURE:
	    case DIGITAL_FORMAT_LOCK_FAILURE:
	      {
	        return state.mergeIn([action.workflowId], {
	          isLoading: false,
	          failedItemIds: _immutable2.default.List(_lodash2.default.get(action, 'payload.ui.itemTransactions.failedItemIds')),
	          successfulItemIds: _immutable2.default.List(_lodash2.default.get(action, 'payload.ui.itemTransactions.successfulItemIds'))
	        });
	      }
	    case CANCEL_HOLD_FAILURE:
	    case UPDATE_PAUSE_HOLDS_FAILURE:
	      {
	        return state.mergeIn([action.workflowId], {
	          isLoading: false
	        });
	      }
	
	    case UPDATE_PICKUP_LOCATION:
	      {
	        return state.setIn([action.payload.id, 'selectedBranch'], action.payload.pickupLocation);
	      }
	    default:
	      return state;
	  }
	}

/***/ },
/* 2155 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ListPresentationReducer;
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _ListPresentationConstants = __webpack_require__(622);
	
	var _ListPresentationConstants2 = _interopRequireDefault(_ListPresentationConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = _immutable2.default.Map({
	  view: 'medium'
	});
	
	function ListPresentationReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ListPresentationConstants2.default.TOGGLE_LIST_VIEW:
	      return state.set('view', action.payload.view);
	    default:
	      return state;
	  }
	}

/***/ },
/* 2156 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = MessagingReducer;
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _MessagingConstants = __webpack_require__(73);
	
	var _MessagingConstants2 = _interopRequireDefault(_MessagingConstants);
	
	var _SearchConstants = __webpack_require__(125);
	
	var _SearchConstants2 = _interopRequireDefault(_SearchConstants);
	
	var _WorkflowConstants = __webpack_require__(74);
	
	var _WorkflowConstants2 = _interopRequireDefault(_WorkflowConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = _immutable2.default.Map();
	
	function MessagingReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  if (action.messaging) {
	    return state.merge(action.messaging);
	  }
	
	  switch (action.type) {
	    case _MessagingConstants2.default.CLEAR_MESSAGING:
	      {
	        return state.withMutations(function (mutatedState) {
	          action.messagingIds.forEach(function (id) {
	            return mutatedState.delete(id);
	          });
	        });
	      }
	
	    // FIXME: This logic should be in SearchActions or SearchTitle component.
	    case _SearchConstants2.default.SEARCH_SUCCESS:
	      {
	        return state.delete('searchTitle');
	      }
	
	    // FIXME: This logic should be in WorkflowActions
	    case _WorkflowConstants2.default.UPDATE_WORKFLOW:
	      {
	        return state.delete(action.payload.id);
	      }
	
	    default:
	      return state;
	  }
	}

/***/ },
/* 2157 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = app;
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _utilsBrowser = __webpack_require__(59);
	
	var _AppConstants = __webpack_require__(186);
	
	var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
	var _NoticeConstants = __webpack_require__(624);
	
	var _NoticeConstants2 = _interopRequireDefault(_NoticeConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = _immutable2.default.Map({
	  hidden: _immutable2.default.Set()
	});
	
	function app() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _AppConstants2.default.FETCH_COOKIES:
	      {
	        var cookie = (0, _utilsBrowser.getCookie)(_NoticeConstants.HIDDEN_NOTICES_COOKIE);
	        return cookie ? state.set('hidden', _immutable2.default.Set(cookie.split(':'))) : state;
	      }
	
	    case _AppConstants2.default.LOAD_COOKIES:
	      {
	        if (action.cookies && action.cookies[_NoticeConstants.HIDDEN_NOTICES_COOKIE]) {
	          return state.set('hidden', _immutable2.default.Set(action.cookies[_NoticeConstants.HIDDEN_NOTICES_COOKIE].split(':')));
	        }
	        return state;
	      }
	
	    case _NoticeConstants2.default.DISMISS_NOTICE:
	      {
	        var newHidden = _immutable2.default.Set(state.get('hidden')).add(action.noticeId);
	        (0, _utilsBrowser.setCookie)(_NoticeConstants.HIDDEN_NOTICES_COOKIE, newHidden.join(':'));
	        return state.set('hidden', newHidden);
	      }
	
	    default:
	      return state;
	  }
	}

/***/ },
/* 2158 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ProgressBarReducer;
	
	var _SearchConstants = __webpack_require__(125);
	
	var _SearchConstants2 = _interopRequireDefault(_SearchConstants);
	
	var _ShelfConstants = __webpack_require__(43);
	
	var _ShelfConstants2 = _interopRequireDefault(_ShelfConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = false;
	
	function ProgressBarReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _SearchConstants2.default.SEARCH_REQUEST:
	    case _SearchConstants2.default.EXPAND_FIELD_REQUEST:
	    case _ShelfConstants2.default.SHELF_SEARCH_REQUEST:
	    case _ShelfConstants2.default.FETCH_FILTERS_REQUEST:
	      return true;
	    case _SearchConstants2.default.SEARCH_SUCCESS:
	    case _SearchConstants2.default.SEARCH_FAILURE:
	    case _SearchConstants2.default.EXPAND_FIELD_SUCCESS:
	    case _SearchConstants2.default.EXPAND_FIELD_FAILURE:
	    case _SearchConstants2.default.TOGGLE_EXPANDED_FIELD_SUCCESS:
	    case _SearchConstants2.default.TOGGLE_EXPANDED_FIELD_FAILURE:
	    case _ShelfConstants2.default.SHELF_SEARCH_SUCCESS:
	    case _ShelfConstants2.default.SHELF_SEARCH_FAILURE:
	    case _ShelfConstants2.default.FETCH_FILTERS_SUCCESS:
	    case _ShelfConstants2.default.FETCH_FILTERS_FAILURE:
	      return false;
	    default:
	      return state;
	  }
	}

/***/ },
/* 2159 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = SavedSearchReducer;
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _SavedSearchConstants = __webpack_require__(394);
	
	var _SavedSearchConstants2 = _interopRequireDefault(_SavedSearchConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = _immutable2.default.Map({
	  isSaving: false,
	  isDuplicate: false,
	  lastNameAttempt: null,
	  duplicateSearchId: null,
	  fieldErrors: null
	});
	
	function SavedSearchReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _SavedSearchConstants2.default.SAVE_REQUEST:
	      return state.merge({
	        isSaving: true,
	        fieldErrors: undefined,
	        lastNameAttempt: action.payload.name || state.get('lastNameAttempt')
	      });
	    case _SavedSearchConstants2.default.SAVE_SUCCESS:
	      return initialState;
	    case _SavedSearchConstants2.default.SAVE_FAILURE:
	      {
	        var _action$payload = action.payload,
	            status = _action$payload.status,
	            error = _action$payload.error;
	
	        return state.merge({
	          isDuplicate: status === 409,
	          duplicateSearchId: error && error.meta && error.meta.searchId,
	          fieldErrors: error.fieldErrors && _immutable2.default.fromJS(error.fieldErrors),
	          isSaving: false
	        });
	      }
	    case _SavedSearchConstants2.default.CHOOSE_NEW_NAME:
	      return state.set('isDuplicate', false);
	    default:
	      return state;
	  }
	}

/***/ },
/* 2160 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = availabilityDetail;
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _StackMapConstants = __webpack_require__(632);
	
	var _StackMapConstants2 = _interopRequireDefault(_StackMapConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var REQUEST = _StackMapConstants2.default.REQUEST,
	    SUCCESS = _StackMapConstants2.default.SUCCESS,
	    FAILURE = _StackMapConstants2.default.FAILURE,
	    CLOSE = _StackMapConstants2.default.CLOSE;
	
	
	var initialState = _immutable2.default.Map({
	  data: null,
	  open: false,
	  noResults: false,
	  isFetching: false
	});
	
	function availabilityDetail() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case REQUEST:
	      {
	        return state.merge({
	          open: true,
	          isFetching: true
	        });
	      }
	
	    case SUCCESS:
	      {
	        if (action.payload && action.payload.stat === 'OK' && action.payload.results.maps.length > 0) {
	          return state.mergeDeep({
	            data: action.payload.results,
	            isFetching: false
	          });
	        }
	
	        return state.merge({
	          noResults: true,
	          isFetching: false
	        });
	      }
	
	    case FAILURE:
	      {
	        return state.merge({
	          noResults: true,
	          isFetching: false
	        });
	      }
	
	    case CLOSE:
	      {
	        return initialState;
	      }
	
	    default:
	      return state;
	  }
	}

/***/ },
/* 2161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = WorkflowReducer;
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _lodash = __webpack_require__(16);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _CheckoutConstants = __webpack_require__(295);
	
	var _CheckoutConstants2 = _interopRequireDefault(_CheckoutConstants);
	
	var _HoldsConstants = __webpack_require__(98);
	
	var _HoldsConstants2 = _interopRequireDefault(_HoldsConstants);
	
	var _WorkflowConstants = __webpack_require__(74);
	
	var _WorkflowConstants2 = _interopRequireDefault(_WorkflowConstants);
	
	var _ShelfConstants = __webpack_require__(43);
	
	var _ShelfConstants2 = _interopRequireDefault(_ShelfConstants);
	
	var _SavedSearchConstants = __webpack_require__(394);
	
	var _SavedSearchConstants2 = _interopRequireDefault(_SavedSearchConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = _immutable2.default.Map();
	
	var mapDigitalFailureToWorkflow = function mapDigitalFailureToWorkflow(classification, metadataId) {
	  switch (classification) {
	    case 'TitleNotAvailable':
	      return _immutable2.default.Map({ step: _HoldsConstants.WORKFLOW_VIEWS.DIGITAL_HOLD, metadataId: metadataId });
	    case 'TitleIsAvailable':
	      return _immutable2.default.Map({ step: _HoldsConstants.WORKFLOW_VIEWS.DIGITAL_CHECKOUT, metadataId: metadataId });
	    default:
	      return null;
	  }
	};
	
	var getShelfWorkflowViewName = function getShelfWorkflowViewName(shelfToAdd) {
	  switch (shelfToAdd) {
	    case _ShelfConstants.SHELF_NAMES.FOR_LATER:
	      return _ShelfConstants.WORKFLOW_VIEWS.ADDED_TO_FOR_LATER_SHELF;
	    case _ShelfConstants.SHELF_NAMES.COMPLETED:
	      return _ShelfConstants.WORKFLOW_VIEWS.ADDED_TO_COMPLETED_SHELF;
	    case _ShelfConstants.SHELF_NAMES.IN_PROGRESS:
	      return _ShelfConstants.WORKFLOW_VIEWS.ADDED_TO_IN_PROGRESS_SHELF;
	    default:
	      return '';
	  }
	};
	
	function WorkflowReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _WorkflowConstants2.default.UPDATE_WORKFLOW:
	      {
	        return state.setIn([action.payload.id], _immutable2.default.fromJS({
	          name: action.payload.workflow,
	          view: action.payload.view
	        }));
	      }
	
	    case _HoldsConstants2.default.CANCEL_HOLD_SUCCESS:
	      {
	        return action.isBatch ? state : state.delete(action.workflowId);
	      }
	
	    case _HoldsConstants2.default.UPDATE_PAUSE_HOLDS_SUCCESS:
	      {
	        return state.delete(action.workflowId);
	      }
	
	    case _HoldsConstants2.default.PLACE_HOLD_SUCCESS:
	    case _HoldsConstants2.default.UPDATE_PAUSE_HOLDS_SUCCESS:
	    case _CheckoutConstants2.default.DIGITAL_CHECKOUT_SUCCESS:
	    case _CheckoutConstants2.default.DIGITAL_FORMAT_LOCK_SUCCESS:
	      {
	        return state.delete(action.workflowId || action.payload.id);
	      }
	
	    case _ShelfConstants2.default.REMOVE_FROM_SHELF_SUCCESS:
	      {
	        return action.workflowId ? state.delete(action.workflowId) : state;
	      }
	
	    case _ShelfConstants2.default.SHOW_POST_ADD_TO_SHELF_VIEW:
	      {
	        if (action.payload.existsOnShelf) {
	          return state.setIn([action.workflowId], _immutable2.default.Map({
	            name: _WorkflowConstants.ADDED_TO_SHELF_WORKFLOW,
	            view: _ShelfConstants.WORKFLOW_VIEWS.EXISTS_ON_SHELF,
	            metadataId: action.id
	          }));
	        }
	
	        if (action.payload.ui && action.payload.ui.messages[action.id]) {
	          return state.setIn([action.workflowId], _immutable2.default.Map({
	            name: _WorkflowConstants.ADDED_TO_SHELF_WORKFLOW,
	            view: getShelfWorkflowViewName(action.payload.ui.messages[action.id].message.values.shelf)
	          }));
	        }
	
	        return state;
	      }
	
	    case _HoldsConstants2.default.PLACE_HOLD_FAILURE:
	    case _CheckoutConstants2.default.DIGITAL_CHECKOUT_FAILURE:
	      {
	        var newWorkflow = mapDigitalFailureToWorkflow(_lodash2.default.get(action, 'payload.error.classification'), action.workflowId);
	
	        if (newWorkflow) {
	          return state.setIn([action.workflowId, 'view'], newWorkflow);
	        }
	        return state;
	      }
	
	    case _SavedSearchConstants2.default.SAVE_SUCCESS:
	      {
	        return state.delete('searchTitle');
	      }
	
	    default:
	      return state;
	  }
	}

/***/ },
/* 2162 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reduxImmutablejs = __webpack_require__(168);
	
	var _FeedbackReducer = __webpack_require__(2151);
	
	var _FeedbackReducer2 = _interopRequireDefault(_FeedbackReducer);
	
	var _ItemTransactionReducer = __webpack_require__(2154);
	
	var _ItemTransactionReducer2 = _interopRequireDefault(_ItemTransactionReducer);
	
	var _ItemLevelHoldReducer = __webpack_require__(2153);
	
	var _ItemLevelHoldReducer2 = _interopRequireDefault(_ItemLevelHoldReducer);
	
	var _ListPresentationReducer = __webpack_require__(2155);
	
	var _ListPresentationReducer2 = _interopRequireDefault(_ListPresentationReducer);
	
	var _MessagingReducer = __webpack_require__(2156);
	
	var _MessagingReducer2 = _interopRequireDefault(_MessagingReducer);
	
	var _ProgressBarReducer = __webpack_require__(2158);
	
	var _ProgressBarReducer2 = _interopRequireDefault(_ProgressBarReducer);
	
	var _SavedSearchReducer = __webpack_require__(2159);
	
	var _SavedSearchReducer2 = _interopRequireDefault(_SavedSearchReducer);
	
	var _StackMapReducer = __webpack_require__(2160);
	
	var _StackMapReducer2 = _interopRequireDefault(_StackMapReducer);
	
	var _NoticesReducer = __webpack_require__(2157);
	
	var _NoticesReducer2 = _interopRequireDefault(_NoticesReducer);
	
	var _WorkflowReducer = __webpack_require__(2161);
	
	var _WorkflowReducer2 = _interopRequireDefault(_WorkflowReducer);
	
	var _GroupSearchFeedbackReducer = __webpack_require__(2152);
	
	var _GroupSearchFeedbackReducer2 = _interopRequireDefault(_GroupSearchFeedbackReducer);
	
	var _AccountMessagesReducer = __webpack_require__(2150);
	
	var _AccountMessagesReducer2 = _interopRequireDefault(_AccountMessagesReducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _reduxImmutablejs.combineReducers)(_immutable2.default.Map({
	  feedback: _FeedbackReducer2.default,
	  itemTransactions: _ItemTransactionReducer2.default,
	  workflow: _WorkflowReducer2.default,
	  messaging: _MessagingReducer2.default,
	  listPresentation: _ListPresentationReducer2.default,
	  progressBar: _ProgressBarReducer2.default,
	  savedSearch: _SavedSearchReducer2.default,
	  stackmap: _StackMapReducer2.default,
	  notices: _NoticesReducer2.default,
	  groupSearchFeedback: _GroupSearchFeedbackReducer2.default,
	  itemLevelHold: _ItemLevelHoldReducer2.default,
	  accountMessages: _AccountMessagesReducer2.default
	}));

/***/ },
/* 2163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = airbrakeMiddlewareFactory;
	
	var _lodash = __webpack_require__(16);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NUM_RECENT_ACTIONS_TO_SEND = 5;
	var FILTERED = '[FILTERED]';
	
	function airbrakeMiddlewareFactory(service) {
	  if (!_lodash2.default.get(service, 'client.addFilter')) {
	    return function () {
	      return function (next) {
	        return function (action) {
	          return next(action);
	        };
	      };
	    };
	  }
	
	  var actionsToSend = [];
	  service.client.addFilter(function (notice) {
	    /* eslint-disable no-param-reassign */
	    notice.context.recentActions = actionsToSend.map(function (action) {
	      if (action.payload && action.payload.entities) {
	        var filteredPayload = _extends({}, action.payload);
	        var _action$payload = action.payload,
	            entities = _action$payload.entities,
	            auth = _action$payload.auth;
	
	        if (entities) {
	          if (entities.accounts) {
	            filteredPayload.entities.accounts = FILTERED;
	          }
	          if (entities.users) {
	            filteredPayload.entities.users = FILTERED;
	          }
	        }
	
	        if (auth && auth.currentUserId) {
	          filteredPayload.auth.currentUserId = FILTERED;
	        }
	
	        return _extends({}, action, {
	          payload: filteredPayload
	        });
	      }
	      return action;
	    });
	    return notice;
	  });
	
	  return function () {
	    return function (next) {
	      return function (action) {
	        if (_lodash2.default.get(action, 'type') !== '@@INIT') {
	          actionsToSend.splice(0, actionsToSend.length > NUM_RECENT_ACTIONS_TO_SEND ? actionsToSend.length - NUM_RECENT_ACTIONS_TO_SEND : 0, action);
	        }
	        next(action);
	      };
	    };
	  };
	}

/***/ },
/* 2164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = analyticsMiddleware;
	
	var _utilsAnalytics = __webpack_require__(142);
	
	function analyticsMiddleware() {
	  return function () {
	    return function (next) {
	      return function (action) {
	        var payload = action.payload;
	
	
	        if ((true) && payload && payload.analytics) {
	          (0, _utilsAnalytics.sendAnalyticsEvents)(payload.analytics);
	        }
	
	        return next(action);
	      };
	    };
	  };
	}

/***/ },
/* 2165 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = apiRequestMiddleware;
	
	var _omit = __webpack_require__(754);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	var _composeFailureMessaging = __webpack_require__(299);
	
	var _composeFailureMessaging2 = _interopRequireDefault(_composeFailureMessaging);
	
	var _composeGlobalFailureMessaging = __webpack_require__(244);
	
	var _composeGlobalFailureMessaging2 = _interopRequireDefault(_composeGlobalFailureMessaging);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * Middleware for making and handling asynchronous requests to the API Gateway.
	 *
	 * Handles actions with the following properties:
	 *  apiRequest:         A function to make the API request, with the signature `(state, apiClient)`. Should return an `Observable`.
	 *  types:              [BEFORE_REQUEST, SUCCESS, FAILURE], to be used as the action's `type` during the request and when it completes.
	 *  apiSuccess:         A function which can be used modify the `SUCCESS` action before being passed along, with the signature `(responseBody, store)`.
	 *  apiFailure:         A function which can be used modify the `FAILURE` action before being passed along, with the signature `(responseBody, store)`.
	 *  postSuccess:        A function which takes the `state`, and returns an `action` object, to be dispatched separately when the request succeeds.
	 *
	 * NB: BEFORE_REQUEST, as implied, is called before `apiRequest()` is called.
	 * This fact is very important if you have reducers that modify the state in
	 * response to BEFORE_REQUEST, as `apiRequest()` will be passed the modified
	 * state.
	 *
	 * @param {object} apiClient
	 */
	function apiRequestMiddleware(apiClient) {
	  return function (store) {
	    return function (next) {
	      return function (action) {
	        if (!action.apiRequest) {
	          return next(action);
	        }
	
	        var apiRequest = action.apiRequest,
	            apiSuccess = action.apiSuccess,
	            apiFailure = action.apiFailure,
	            types = action.types,
	            middlewareData = action.middlewareData,
	            postSuccess = action.postSuccess,
	            rest = _objectWithoutProperties(action, ['apiRequest', 'apiSuccess', 'apiFailure', 'types', 'middlewareData', 'postSuccess']);
	
	        var originalPayload = rest.payload;
	
	        var _types = _slicedToArray(types, 3),
	            BEFORE_REQUEST = _types[0],
	            SUCCESS = _types[1],
	            FAILURE = _types[2];
	
	        var basicMiddleware = (0, _omit2.default)(middlewareData, ['gaEvent', 'appEvent', 'gtmEvent']);
	
	        if (!BEFORE_REQUEST) {
	          throw new Error('Expected "action.types[0]" to be defined. Found [' + types.join(', ') + ']');
	        }
	
	        if (!SUCCESS) {
	          throw new Error('Expected "action.types[1]" to be defined. Found [' + types.join(', ') + ']');
	        }
	
	        if (!FAILURE) {
	          throw new Error('Expected "action.types[2]" to be defined. Found [' + types.join(', ') + ']');
	        }
	
	        // Dispatch a BEFORE_REQUEST action and kick off the request
	        next(_extends({}, rest, { originalPayload: originalPayload, middlewareData: basicMiddleware, type: BEFORE_REQUEST }));
	
	        var promise = apiRequest(store.getState(), apiClient).toPromise();
	        return promise.then(function (response) {
	          var successAction = _extends({}, rest, {
	            middlewareData: middlewareData,
	            type: SUCCESS,
	            payload: response.body || {}
	          });
	
	          // Allow the success action to be modified before passing along.
	          if (apiSuccess) {
	            next(_extends({}, successAction, apiSuccess(response.body, store)));
	          } else {
	            next(successAction);
	          }
	
	          if (postSuccess) {
	            var postSuccessAction = postSuccess(store.getState());
	            if (postSuccessAction) {
	              store.dispatch(postSuccessAction);
	            }
	          }
	        }).catch(function (_ref) {
	          var response = _ref.response,
	              status = _ref.status;
	
	          var res = response || {};
	          var body = res.body || {};
	
	          var _ref2 = res.req || {},
	              method = _ref2.method;
	
	          // Default messaging for non-GET requests
	
	
	          var defaultMessaging = method === 'GET' ? {} : {
	            messaging: action.messagingId ? (0, _composeFailureMessaging2.default)(action.messagingId, body.error) : (0, _composeGlobalFailureMessaging2.default)(body.error)
	          };
	
	          var failureAction = _extends({}, defaultMessaging, rest, {
	            middlewareData: middlewareData,
	            type: FAILURE,
	            payload: _extends({ status: status }, body)
	          });
	
	          // Allow the failure action to be modified before passing along.
	          if (apiFailure) {
	            next(_extends({}, failureAction, apiFailure(body, store)));
	          } else {
	            next(failureAction);
	          }
	        });
	      };
	    };
	  };
	}

/***/ },
/* 2166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = authMiddleware;
	
	var _AuthConstants = __webpack_require__(293);
	
	var _AuthConstants2 = _interopRequireDefault(_AuthConstants);
	
	var _AuthSelector = __webpack_require__(21);
	
	var _composeFailureMessaging = __webpack_require__(299);
	
	var _composeFailureMessaging2 = _interopRequireDefault(_composeFailureMessaging);
	
	var _composeGlobalFailureMessaging = __webpack_require__(244);
	
	var _composeGlobalFailureMessaging2 = _interopRequireDefault(_composeGlobalFailureMessaging);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Checks if this action is protected with Authentication and if its then dispatch an action to show
	 * modal.
	 *
	 * @param {object} apiClient
	 */
	function authMiddleware(store) {
	  return function (next) {
	    return function (action) {
	      var middlewareData = action.middlewareData;
	
	      var auth = store.getState().get('auth');
	
	      if ((true) && middlewareData && (middlewareData.authRequired || middlewareData.accountRequired) && !auth.get('currentUserId')) {
	        return next({ type: _AuthConstants2.default.OPEN_LOGIN_OVERLAY, payload: { postLoginAction: action } });
	      }
	
	      if ((true) && middlewareData && middlewareData.accountRequired && !(0, _AuthSelector.currentAccountSelector)(store.getState())) {
	        var err = { classification: 'requiresLibraryAccount' };
	        var payload = action.payload || {};
	        var messagingId = action.messagingId || payload.id || action.id; // TODO: only support action.messagingId
	
	        return next({
	          type: _AuthConstants2.default.REQUIRES_LIBRARY_ACCOUNT,
	          id: payload.id || action.id,
	          messaging: messagingId ? (0, _composeFailureMessaging2.default)(messagingId, err) : (0, _composeGlobalFailureMessaging2.default)(err)
	        });
	      }
	
	      return next(action);
	    };
	  };
	}

/***/ },
/* 2167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = gaMiddleware;
	
	var _lodash = __webpack_require__(16);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Value                  Notes
	// --------------------------------------------------------
	// event.eventCategory          String. Required. A top level category for these events. E.g. 'User', 'Navigation', 'App Editing', etc.
	// event.eventAction            String. Required. A description of the behaviour. E.g. 'Clicked Delete', 'Added a component', 'Deleted account', etc.
	// event.eventLabel             String. Optional. More precise labelling of the related action. E.g. alongside the 'Added a component' action, we could add the name of
	//                          a component as the label. E.g. 'Survey', 'Heading', 'Button', etc.
	// event.eventValue             Int. Optional. A means of recording a numerical value against an event. E.g. a rating, a score, etc.
	// event.nonInteraction    Boolean. Optional. If an event is not triggered by a user interaction, but instead by our code (e.g. on page load, it should be flagged
	//                          as a nonInteraction event to avoid skewing bounce rate data.
	// event.transport         String. Optional. This specifies the transport mechanism with which hits will be sent. Valid values include 'beacon', 'xhr', or 'image'.
	// event.sendToLibrary     Boolean. Optional. Sends the event to the library's GA as well.
	
	function gaMiddleware(BCGoogleAnalyticsUtils) {
	  return function (store) {
	    return function (next) {
	      return function (action) {
	        var middlewareData = action.middlewareData;
	
	        if (!middlewareData || !middlewareData.gaEvent) {
	          return next(action);
	        }
	
	        var state = store.getState();
	        var value = _lodash2.default.isFunction(middlewareData.gaEvent) ? middlewareData.gaEvent(state) : middlewareData.gaEvent;
	        var sendToLibrary = !!middlewareData.gaEvent.sendToLibrary;
	        delete middlewareData.gaEvent.sendToLibrary;
	        if (!value.eventCategory || !value.eventAction) {
	          console.warn('GA events require a eventCategory and an eventAction'); // eslint-disable-line no-console
	        } else {
	          BCGoogleAnalyticsUtils.event(value, sendToLibrary);
	        }
	
	        return next(action);
	      };
	    };
	  };
	}

/***/ },
/* 2168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = redirectMiddleware;
	
	var _utilsBrowser = __webpack_require__(59);
	
	function redirectMiddleware() {
	  return function (next) {
	    return function (action) {
	      if (action.payload && action.payload.forceRedirectURL && (true)) {
	        var PRE_LOGIN_URL_COOKIE = 'pre_login_url';
	        (0, _utilsBrowser.setCookie)(PRE_LOGIN_URL_COOKIE, window.location.href, { path: '/' });
	        window.location.href = action.payload.forceRedirectURL;
	      }
	
	      return next(action);
	    };
	  };
	}

/***/ },
/* 2169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = transitionMiddleware;
	
	var _RouterConstants = __webpack_require__(630);
	
	var _RouterConstants2 = _interopRequireDefault(_RouterConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function transitionMiddleware(_ref) {
	  var dispatch = _ref.dispatch,
	      getState = _ref.getState;
	  // eslint-disable-line no-unused-vars
	  return function (next) {
	    return function (action) {
	      var transition = action.transition,
	          middlewareData = action.middlewareData,
	          rest = _objectWithoutProperties(action, ['transition', 'middlewareData']); // eslint-disable-line no-unused-vars
	
	
	      if (!transition) {
	        return next(action);
	      }
	
	      var nextAction = next(action);
	
	      var _transition = transition(getState()),
	          history = _transition.history,
	          to = _transition.to,
	          query = _transition.query,
	          external = _transition.external;
	
	      if (external && (true)) {
	        window.location = to;
	      }
	
	      if (history) {
	        var updatedQuery = Object.assign({}, query);
	        history.push(history.createHref({ pathname: to, query: updatedQuery }));
	        return next(_extends({}, rest, { transition: transition, type: _RouterConstants2.default.ROUTER_TRANSITION }));
	      }
	      return nextAction;
	    };
	  };
	}

/***/ },
/* 2170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(17);
	
	var _BCApp = __webpack_require__(1628);
	
	var _BCApp2 = _interopRequireDefault(_BCApp);
	
	var _Dashboard = __webpack_require__(1629);
	
	var _Dashboard2 = _interopRequireDefault(_Dashboard);
	
	var _notFound = __webpack_require__(140);
	
	var _notFound2 = _interopRequireDefault(_notFound);
	
	var _layoutsPrint = __webpack_require__(1422);
	
	var _layoutsPrint2 = _interopRequireDefault(_layoutsPrint);
	
	var _WidgetLayout = __webpack_require__(1851);
	
	var _WidgetLayout2 = _interopRequireDefault(_WidgetLayout);
	
	var _UserContainer = __webpack_require__(2098);
	
	var _UserContainer2 = _interopRequireDefault(_UserContainer);
	
	var _AvailabilityDetailsContainer = __webpack_require__(2060);
	
	var _AvailabilityDetailsContainer2 = _interopRequireDefault(_AvailabilityDetailsContainer);
	
	var _BCAppContainer = __webpack_require__(2061);
	
	var _BCAppContainer2 = _interopRequireDefault(_BCAppContainer);
	
	var _LoginContainer = __webpack_require__(2079);
	
	var _LoginContainer2 = _interopRequireDefault(_LoginContainer);
	
	var _SearchContainer = __webpack_require__(2087);
	
	var _SearchContainer2 = _interopRequireDefault(_SearchContainer);
	
	var _ShelfContainer = __webpack_require__(2089);
	
	var _ShelfContainer2 = _interopRequireDefault(_ShelfContainer);
	
	var _PrintSearchContainer = __webpack_require__(2102);
	
	var _PrintSearchContainer2 = _interopRequireDefault(_PrintSearchContainer);
	
	var _PrintCheckedOutContainer = __webpack_require__(2099);
	
	var _PrintCheckedOutContainer2 = _interopRequireDefault(_PrintCheckedOutContainer);
	
	var _PrintHoldsContainer = __webpack_require__(2100);
	
	var _PrintHoldsContainer2 = _interopRequireDefault(_PrintHoldsContainer);
	
	var _PrintShelfContainer = __webpack_require__(2103);
	
	var _PrintShelfContainer2 = _interopRequireDefault(_PrintShelfContainer);
	
	var _FeatureToggleContainer = __webpack_require__(2066);
	
	var _FeatureToggleContainer2 = _interopRequireDefault(_FeatureToggleContainer);
	
	var _ItemWidgetContainer = __webpack_require__(2105);
	
	var _ItemWidgetContainer2 = _interopRequireDefault(_ItemWidgetContainer);
	
	var _UGCTestLayout = __webpack_require__(1634);
	
	var _UGCTestLayout2 = _interopRequireDefault(_UGCTestLayout);
	
	var _InternalError = __webpack_require__(563);
	
	var _InternalError2 = _interopRequireDefault(_InternalError);
	
	var _BorrowingLayout = __webpack_require__(1806);
	
	var _BorrowingLayout2 = _interopRequireDefault(_BorrowingLayout);
	
	var _AuthenticatedRoute = __webpack_require__(1900);
	
	var _AuthenticatedRoute2 = _interopRequireDefault(_AuthenticatedRoute);
	
	var _AccountRequiredRouteContainer = __webpack_require__(2057);
	
	var _AccountRequiredRouteContainer2 = _interopRequireDefault(_AccountRequiredRouteContainer);
	
	var _CheckedOutContainer = __webpack_require__(2063);
	
	var _CheckedOutContainer2 = _interopRequireDefault(_CheckedOutContainer);
	
	var _FinesContainer = __webpack_require__(2069);
	
	var _FinesContainer2 = _interopRequireDefault(_FinesContainer);
	
	var _HoldsContainer = __webpack_require__(2074);
	
	var _HoldsContainer2 = _interopRequireDefault(_HoldsContainer);
	
	var _MessagesContainer = __webpack_require__(2081);
	
	var _MessagesContainer2 = _interopRequireDefault(_MessagesContainer);
	
	var _InterlibraryLoansContainer = __webpack_require__(2076);
	
	var _InterlibraryLoansContainer2 = _interopRequireDefault(_InterlibraryLoansContainer);
	
	var _RecentlyReturnedContainer = __webpack_require__(2082);
	
	var _RecentlyReturnedContainer2 = _interopRequireDefault(_RecentlyReturnedContainer);
	
	var _PrintRecentlyReturnedContainer = __webpack_require__(2101);
	
	var _PrintRecentlyReturnedContainer2 = _interopRequireDefault(_PrintRecentlyReturnedContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (basePath) {
	  return _react2.default.createElement(
	    _reactRouter.Route,
	    { path: basePath + '/', component: _BCAppContainer2.default },
	    _react2.default.createElement(
	      _reactRouter.Route,
	      { path: 'print', component: _layoutsPrint2.default },
	      _react2.default.createElement(_reactRouter.Route, { path: 'search', component: _PrintSearchContainer2.default }),
	      _react2.default.createElement(
	        _reactRouter.Route,
	        { path: 'users/:userId', component: _UserContainer2.default },
	        _react2.default.createElement(_reactRouter.Route, { path: 'shelves/:shelfName', component: _PrintShelfContainer2.default })
	      ),
	      _react2.default.createElement(
	        _reactRouter.Route,
	        { component: _AuthenticatedRoute2.default },
	        _react2.default.createElement(
	          _reactRouter.Route,
	          { component: _AccountRequiredRouteContainer2.default },
	          _react2.default.createElement(_reactRouter.Route, { path: 'checkedout', component: _PrintCheckedOutContainer2.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'holds', component: _PrintHoldsContainer2.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'recentlyreturned', component: _PrintRecentlyReturnedContainer2.default })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      { path: 'widgets', component: _WidgetLayout2.default },
	      _react2.default.createElement(_reactRouter.Route, { path: 'item/:metadataId', component: _ItemWidgetContainer2.default })
	    ),
	    _react2.default.createElement(_reactRouter.Route, { path: 'ugctest', component: _UGCTestLayout2.default }),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      { component: _BCApp2.default },
	      _react2.default.createElement(_reactRouter.Route, { path: 'dashboard', component: _Dashboard2.default }),
	      _react2.default.createElement(
	        _reactRouter.Route,
	        { path: 'search', component: _SearchContainer2.default },
	        _react2.default.createElement(_reactRouter.Route, { path: 'availability/:metadataId', component: _AvailabilityDetailsContainer2.default })
	      ),
	      _react2.default.createElement(
	        _reactRouter.Route,
	        { path: 'users/:userId', component: _UserContainer2.default },
	        _react2.default.createElement(
	          _reactRouter.Route,
	          { path: 'shelves/:shelfName', component: _ShelfContainer2.default },
	          _react2.default.createElement(_reactRouter.Route, { path: 'availability/:metadataId', component: _AvailabilityDetailsContainer2.default })
	        ),
	        _react2.default.createElement(_reactRouter.Route, { path: 'lists/:listId', component: _notFound2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'activity-feed', component: _notFound2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'news-feed', component: _notFound2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'following', component: _notFound2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'followers', component: _notFound2.default })
	      ),
	      _react2.default.createElement(
	        _reactRouter.Route,
	        { component: _AuthenticatedRoute2.default },
	        _react2.default.createElement(
	          _reactRouter.Route,
	          { component: _UserContainer2.default },
	          _react2.default.createElement(
	            _reactRouter.Route,
	            { path: 'shelves/:shelfName', component: _ShelfContainer2.default },
	            _react2.default.createElement(_reactRouter.Route, { path: 'availability/:metadataId', component: _AvailabilityDetailsContainer2.default })
	          ),
	          _react2.default.createElement(_reactRouter.Route, { path: 'lists/:listId', component: _notFound2.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'activity-feed', component: _notFound2.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'news-feed', component: _notFound2.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'following', component: _notFound2.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'followers', component: _notFound2.default })
	        ),
	        _react2.default.createElement(
	          _reactRouter.Route,
	          { component: _AccountRequiredRouteContainer2.default },
	          _react2.default.createElement(
	            _reactRouter.Route,
	            { component: _BorrowingLayout2.default },
	            _react2.default.createElement(_reactRouter.Route, { path: 'checkedout', component: _CheckedOutContainer2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'checkedout/:status', component: _CheckedOutContainer2.default }),
	            _react2.default.createElement(
	              _reactRouter.Route,
	              { path: 'holds', component: _HoldsContainer2.default },
	              _react2.default.createElement(_reactRouter.Route, { path: 'availability/:metadataId', component: _AvailabilityDetailsContainer2.default })
	            ),
	            _react2.default.createElement(
	              _reactRouter.Route,
	              { path: 'holds/:status', component: _HoldsContainer2.default },
	              _react2.default.createElement(_reactRouter.Route, { path: 'availability/:metadataId', component: _AvailabilityDetailsContainer2.default })
	            ),
	            _react2.default.createElement(_reactRouter.Route, { path: 'fines', component: _FinesContainer2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'recentlyreturned', component: _RecentlyReturnedContainer2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'accountmessages', component: _MessagesContainer2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'interlibraryloans', component: _InterlibraryLoansContainer2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'interlibraryloans/:status', component: _notFound2.default })
	          )
	        )
	      ),
	      _react2.default.createElement(_reactRouter.Route, { path: 'availability/:metadataId', component: _AvailabilityDetailsContainer2.default }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'login', component: _LoginContainer2.default }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'feature-toggles', component: _FeatureToggleContainer2.default }),
	      _react2.default.createElement(_reactRouter.Route, { path: '500_client', component: _InternalError2.default }),
	      _react2.default.createElement(_reactRouter.IndexRoute, { component: _Dashboard2.default }),
	      _react2.default.createElement(_reactRouter.Route, { path: '*', component: _notFound2.default })
	    )
	  );
	};

/***/ },
/* 2171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getAccountMessagesStatus = undefined;
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reselect = __webpack_require__(34);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var accountMessagesStatus = function accountMessagesStatus(state) {
	  return state.getIn(['ui', 'accountMessages'], _immutable2.default.Map());
	};
	
	var getAccountMessagesStatus = exports.getAccountMessagesStatus = (0, _reselect.createSelector)([accountMessagesStatus], function (status) {
	  return status;
	});
	
	exports.default = {
	  getAccountMessagesStatus: getAccountMessagesStatus
	};

/***/ },
/* 2172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getDataLayer = undefined;
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reselect = __webpack_require__(34);
	
	var _AuthSelector = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getSiteDataLayer = function getSiteDataLayer(state) {
	  return state.getIn(['analytics', 'siteDataLayer'], _immutable2.default.Map());
	};
	
	var getDataLayer = exports.getDataLayer = (0, _reselect.createSelector)([getSiteDataLayer, _AuthSelector.currentUserSelector], function (siteDataLayer, user) {
	  var userDataLayer = user ? {
	    'bc.encodedUserId': user.get('encodedId')
	  } : {};
	
	  return siteDataLayer.merge(userDataLayer);
	});
	
	exports.default = {
	  getDataLayer: getDataLayer
	};

/***/ },
/* 2173 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getFines = undefined;
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reselect = __webpack_require__(34);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var currentFinesIds = function currentFinesIds(state) {
	  return state.getIn(['borrowing', 'fines', 'results'], _immutable2.default.List());
	};
	var finesEntities = function finesEntities(state) {
	  return state.getIn(['entities', 'fines'], _immutable2.default.Map());
	};
	
	var getFines = exports.getFines = (0, _reselect.createSelector)([finesEntities, currentFinesIds], function (fines, fineIds) {
	  return fines.filter(function (fine) {
	    return fineIds.includes(fine.get('id'));
	  });
	});
	
	exports.default = {
	  getFines: getFines
	};

/***/ },
/* 2174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getInterlibaryLoans = exports.getInterlibaryLoansStatus = undefined;
	
	var _reselect = __webpack_require__(34);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var interlibraryLoansStatus = function interlibraryLoansStatus(state) {
	  return state.getIn(['borrowing', 'interlibraryLoans'], _immutable2.default.Map());
	};
	var interlibraryLoans = function interlibraryLoans(state) {
	  return state.getIn(['entities', 'interlibraryLoans'], _immutable2.default.Map());
	};
	
	var getInterlibaryLoansStatus = exports.getInterlibaryLoansStatus = (0, _reselect.createSelector)([interlibraryLoansStatus], function (status) {
	  return status;
	});
	
	var getInterlibaryLoans = exports.getInterlibaryLoans = (0, _reselect.createSelector)([interlibraryLoans], function (loans) {
	  return loans;
	});
	
	exports.default = {
	  getInterlibaryLoansStatus: getInterlibaryLoansStatus,
	  getInterlibaryLoans: getInterlibaryLoans
	};

/***/ },
/* 2175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getVisibleMessages = undefined;
	
	var _reselect = __webpack_require__(34);
	
	var _moment = __webpack_require__(9);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _NoticeSelector = __webpack_require__(646);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var systemMessages = function systemMessages(state) {
	  return state.getIn(['entities', 'systemMessages']);
	};
	
	var getVisibleMessages = exports.getVisibleMessages = (0, _reselect.createSelector)([systemMessages, _NoticeSelector.getHiddenNotices], function (messages, hidden) {
	  return messages.filterNot(function (message) {
	    return hidden.has(message.get('id').toString());
	  }).toList().sortBy(function (message) {
	    return message.get('updatedDateTime');
	  }, function (a, b) {
	    return (0, _moment2.default)(a).diff((0, _moment2.default)(b));
	  }).reverse();
	});
	exports.default = {
	  getVisibleMessages: getVisibleMessages
	};

/***/ },
/* 2176 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getCommentsTransactions = exports.getCommentsByBibs = exports.getCommentsByUsers = exports.getComments = undefined;
	
	var _reselect = __webpack_require__(34);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _UGCBaseSelector = __webpack_require__(128);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getTransactions = function getTransactions(state) {
	  return state.getIn(['ugc', 'commentsTransactions'], _immutable2.default.Map());
	};
	
	var getComments = exports.getComments = (0, _UGCBaseSelector.getUGCByType)('comments');
	var getCommentsByUsers = exports.getCommentsByUsers = (0, _UGCBaseSelector.getSingularUGCByUsers)('comments');
	var getCommentsByBibs = exports.getCommentsByBibs = (0, _UGCBaseSelector.getUGCByBibs)('comments');
	
	var getCommentsTransactions = exports.getCommentsTransactions = (0, _reselect.createSelector)([getTransactions], function (transactions) {
	  return transactions;
	});
	
	exports.default = {
	  getComments: getComments,
	  getCommentsByUsers: getCommentsByUsers,
	  getCommentsByBibs: getCommentsByBibs,
	  getCommentsTransactions: getCommentsTransactions
	};

/***/ },
/* 2177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getIOwnThisTransactions = exports.getIOwnThisByUsers = undefined;
	
	var _reselect = __webpack_require__(34);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _UGCBaseSelector = __webpack_require__(128);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getTransactions = function getTransactions(state) {
	  return state.getIn(['ugc', 'iOwnThisTransactions'], _immutable2.default.Map());
	};
	
	var getIOwnThisByUsers = exports.getIOwnThisByUsers = (0, _UGCBaseSelector.getSingularUGCByUsers)('iOwnThis');
	
	var getIOwnThisTransactions = exports.getIOwnThisTransactions = (0, _reselect.createSelector)([getTransactions], function (transactions) {
	  return transactions;
	});
	
	exports.default = {
	  getIOwnThisByUsers: getIOwnThisByUsers,
	  getIOwnThisTransactions: getIOwnThisTransactions
	};

/***/ },
/* 2178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getPrivateNotesTransactions = exports.getPrivateNotesByUsers = undefined;
	
	var _reselect = __webpack_require__(34);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _UGCBaseSelector = __webpack_require__(128);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getTransactions = function getTransactions(state) {
	  return state.getIn(['ugc', 'privateNotesTransactions'], _immutable2.default.Map());
	};
	
	var getPrivateNotesByUsers = exports.getPrivateNotesByUsers = (0, _UGCBaseSelector.getSingularUGCByUsers)('privateNotes');
	
	var getPrivateNotesTransactions = exports.getPrivateNotesTransactions = (0, _reselect.createSelector)([getTransactions], function (transactions) {
	  return transactions;
	});
	
	exports.default = {
	  getPrivateNotesByUsers: getPrivateNotesByUsers,
	  getPrivateNotesTransactions: getPrivateNotesTransactions
	};

/***/ },
/* 2179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getQuotationsTransactions = exports.getQuotationsByBibs = exports.getQuotationsByUsers = exports.getQuotations = undefined;
	
	var _reselect = __webpack_require__(34);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _UGCBaseSelector = __webpack_require__(128);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getTransactions = function getTransactions(state) {
	  return state.getIn(['ugc', 'quotationsTransactions'], _immutable2.default.Map());
	};
	
	var getQuotations = exports.getQuotations = (0, _UGCBaseSelector.getUGCByType)('quotations');
	var getQuotationsByUsers = exports.getQuotationsByUsers = (0, _UGCBaseSelector.getUGCListByUsers)('quotations');
	var getQuotationsByBibs = exports.getQuotationsByBibs = (0, _UGCBaseSelector.getUGCByBibs)('quotations');
	
	var getQuotationsTransactions = exports.getQuotationsTransactions = (0, _reselect.createSelector)([getTransactions], function (transactions) {
	  return transactions;
	});
	
	exports.default = {
	  getQuotations: getQuotations,
	  getQuotationsByUsers: getQuotationsByUsers,
	  getQuotationsByBibs: getQuotationsByBibs,
	  getQuotationsTransactions: getQuotationsTransactions
	};

/***/ },
/* 2180 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getSimilarTitlesTransactions = exports.getSimilarTitlesByUsers = undefined;
	
	var _reselect = __webpack_require__(34);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _UGCBaseSelector = __webpack_require__(128);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getTransactions = function getTransactions(state) {
	  return state.getIn(['ugc', 'similarTitlesTransactions'], _immutable2.default.Map());
	};
	
	var getSimilarTitlesByUsers = exports.getSimilarTitlesByUsers = (0, _UGCBaseSelector.getUGCListByUsers)('similarTitles');
	
	var getSimilarTitlesTransactions = exports.getSimilarTitlesTransactions = (0, _reselect.createSelector)([getTransactions], function (transactions) {
	  return transactions;
	});
	
	exports.default = {
	  getSimilarTitlesByUsers: getSimilarTitlesByUsers,
	  getSimilarTitlesTransactions: getSimilarTitlesTransactions
	};

/***/ },
/* 2181 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getTagsTransactions = exports.getTagsByBibs = exports.getTagsByUsers = exports.getTags = undefined;
	
	var _reselect = __webpack_require__(34);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _UGCBaseSelector = __webpack_require__(128);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getTransactions = function getTransactions(state) {
	  return state.getIn(['ugc', 'tagsTransactions'], _immutable2.default.Map());
	};
	
	var getTags = exports.getTags = (0, _UGCBaseSelector.getUGCByType)('tags');
	var getTagsByUsers = exports.getTagsByUsers = (0, _UGCBaseSelector.getUGCListByUsers)('tags');
	var getTagsByBibs = exports.getTagsByBibs = (0, _UGCBaseSelector.getUGCByBibs)('tags');
	
	var getTagsTransactions = exports.getTagsTransactions = (0, _reselect.createSelector)([getTransactions], function (transactions) {
	  return transactions;
	});
	
	exports.default = {
	  getTags: getTags,
	  getTagsByUsers: getTagsByUsers,
	  getTagsByBibs: getTagsByBibs,
	  getTagsTransactions: getTagsTransactions
	};

/***/ },
/* 2182 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getVideosTransactions = exports.getVideosByUsers = undefined;
	
	var _reselect = __webpack_require__(34);
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _UGCBaseSelector = __webpack_require__(128);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getTransactions = function getTransactions(state) {
	  return state.getIn(['ugc', 'videosTransactions'], _immutable2.default.Map());
	};
	
	var getVideosByUsers = exports.getVideosByUsers = (0, _UGCBaseSelector.getSingularUGCByUsers)('videos');
	
	var getVideosTransactions = exports.getVideosTransactions = (0, _reselect.createSelector)([getTransactions], function (transactions) {
	  return transactions;
	});
	
	exports.default = {
	  getVideosByUsers: getVideosByUsers,
	  getVideosTransactions: getVideosTransactions
	};

/***/ },
/* 2183 */,
/* 2184 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(2201), __esModule: true };

/***/ },
/* 2185 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(2202), __esModule: true };

/***/ },
/* 2186 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(2203), __esModule: true };

/***/ },
/* 2187 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(2204), __esModule: true };

/***/ },
/* 2188 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ },
/* 2189 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _setPrototypeOf = __webpack_require__(2185);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__(2184);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _typeof2 = __webpack_require__(649);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }
	
	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};

/***/ },
/* 2190 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _typeof2 = __webpack_require__(649);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};

/***/ },
/* 2191 */
/***/ function(module, exports) {

	var canUseDOM = !!(
	  typeof window !== 'undefined' &&
	  window.document &&
	  window.document.createElement
	);
	
	module.exports = canUseDOM;

/***/ },
/* 2192 */
/***/ function(module, exports, __webpack_require__) {

	exports.dot = exports.dotCase = __webpack_require__(2437)
	exports.swap = exports.swapCase = __webpack_require__(3417)
	exports.path = exports.pathCase = __webpack_require__(2955)
	exports.upper = exports.upperCase = __webpack_require__(172)
	exports.lower = exports.lowerCase = __webpack_require__(257)
	exports.camel = exports.camelCase = __webpack_require__(650)
	exports.snake = exports.snakeCase = __webpack_require__(966)
	exports.title = exports.titleCase = __webpack_require__(3420)
	exports.param = exports.paramCase = __webpack_require__(2953)
	exports.pascal = exports.pascalCase = __webpack_require__(2954)
	exports.constant = exports.constantCase = __webpack_require__(2199)
	exports.sentence = exports.sentenceCase = __webpack_require__(171)
	exports.isUpper = exports.isUpperCase = __webpack_require__(2815)
	exports.isLower = exports.isLowerCase = __webpack_require__(2813)
	exports.ucFirst = exports.upperCaseFirst = __webpack_require__(967)
	exports.lcFirst = exports.lowerCaseFirst = __webpack_require__(2949)


/***/ },
/* 2193 */,
/* 2194 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _eventOptionsKey = __webpack_require__(2197);
	
	var _eventOptionsKey2 = _interopRequireDefault(_eventOptionsKey);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function ensureCanMutateNextEventHandlers(eventHandlers) {
	  if (eventHandlers.handlers === eventHandlers.nextHandlers) {
	    // eslint-disable-next-line no-param-reassign
	    eventHandlers.nextHandlers = eventHandlers.handlers.slice();
	  }
	}
	
	var TargetEventHandlers = function () {
	  function TargetEventHandlers(target) {
	    _classCallCheck(this, TargetEventHandlers);
	
	    this.target = target;
	    this.events = {};
	  }
	
	  _createClass(TargetEventHandlers, [{
	    key: 'getEventHandlers',
	    value: function () {
	      function getEventHandlers(eventName, options) {
	        var key = String(eventName) + ' ' + String((0, _eventOptionsKey2['default'])(options));
	
	        if (!this.events[key]) {
	          this.events[key] = {
	            handlers: [],
	            handleEvent: undefined
	          };
	          this.events[key].nextHandlers = this.events[key].handlers;
	        }
	
	        return this.events[key];
	      }
	
	      return getEventHandlers;
	    }()
	  }, {
	    key: 'handleEvent',
	    value: function () {
	      function handleEvent(eventName, options, event) {
	        var eventHandlers = this.getEventHandlers(eventName, options);
	        eventHandlers.handlers = eventHandlers.nextHandlers;
	        eventHandlers.handlers.forEach(function (handler) {
	          if (handler) {
	            // We need to check for presence here because a handler function may
	            // cause later handlers to get removed. This can happen if you for
	            // instance have a waypoint that unmounts another waypoint as part of an
	            // onEnter/onLeave handler.
	            handler(event);
	          }
	        });
	      }
	
	      return handleEvent;
	    }()
	  }, {
	    key: 'add',
	    value: function () {
	      function add(eventName, listener, options) {
	        var _this = this;
	
	        // options has already been normalized at this point.
	        var eventHandlers = this.getEventHandlers(eventName, options);
	
	        ensureCanMutateNextEventHandlers(eventHandlers);
	
	        if (eventHandlers.nextHandlers.length === 0) {
	          eventHandlers.handleEvent = this.handleEvent.bind(this, eventName, options);
	
	          this.target.addEventListener(eventName, eventHandlers.handleEvent, options);
	        }
	
	        eventHandlers.nextHandlers.push(listener);
	
	        var isSubscribed = true;
	        var unsubscribe = function () {
	          function unsubscribe() {
	            if (!isSubscribed) {
	              return;
	            }
	
	            isSubscribed = false;
	
	            ensureCanMutateNextEventHandlers(eventHandlers);
	            var index = eventHandlers.nextHandlers.indexOf(listener);
	            eventHandlers.nextHandlers.splice(index, 1);
	
	            if (eventHandlers.nextHandlers.length === 0) {
	              // All event handlers have been removed, so we want to remove the event
	              // listener from the target node.
	
	              if (_this.target) {
	                // There can be a race condition where the target may no longer exist
	                // when this function is called, e.g. when a React component is
	                // unmounting. Guarding against this prevents the following error:
	                //
	                //   Cannot read property 'removeEventListener' of undefined
	                _this.target.removeEventListener(eventName, eventHandlers.handleEvent, options);
	              }
	
	              eventHandlers.handleEvent = undefined;
	            }
	          }
	
	          return unsubscribe;
	        }();
	        return unsubscribe;
	      }
	
	      return add;
	    }()
	  }]);
	
	  return TargetEventHandlers;
	}();
	
	exports['default'] = TargetEventHandlers;

/***/ },
/* 2195 */
/***/ function(module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var CAN_USE_DOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	exports['default'] = CAN_USE_DOM;

/***/ },
/* 2196 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = canUsePassiveEventListeners;
	
	var _canUseDOM = __webpack_require__(2195);
	
	var _canUseDOM2 = _interopRequireDefault(_canUseDOM);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// Adapted from Modernizr
	// https://github.com/Modernizr/Modernizr/blob/5eea7e2a/feature-detects/dom/passiveeventlisteners.js#L26-L35
	function testPassiveEventListeners() {
	  if (!_canUseDOM2['default']) {
	    return false;
	  }
	
	  if (!window.addEventListener || !window.removeEventListener || !Object.defineProperty) {
	    return false;
	  }
	
	  var supportsPassiveOption = false;
	  try {
	    var opts = Object.defineProperty({}, 'passive', {
	      get: function () {
	        function get() {
	          supportsPassiveOption = true;
	        }
	
	        return get;
	      }()
	    });
	    window.addEventListener('test', null, opts);
	  } catch (e) {
	    // do nothing
	  }
	
	  return supportsPassiveOption;
	}
	
	var memoized = void 0;
	
	function canUsePassiveEventListeners() {
	  if (memoized === undefined) {
	    memoized = testPassiveEventListeners();
	  }
	  return memoized;
	}

/***/ },
/* 2197 */
/***/ function(module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = eventOptionsKey;
	/* eslint-disable no-bitwise */
	
	/**
	 * Generate a unique key for any set of event options
	 */
	function eventOptionsKey(normalizedEventOptions) {
	  if (!normalizedEventOptions) {
	    return 0;
	  }
	
	  // If the browser does not support passive event listeners, the normalized
	  // event options will be a boolean.
	  if (normalizedEventOptions === true) {
	    return 100;
	  }
	
	  // At this point, the browser supports passive event listeners, so we expect
	  // the event options to be an object with possible properties of capture,
	  // passive, and once.
	  //
	  // We want to consistently return the same value, regardless of the order of
	  // these properties, so let's use binary maths to assign each property to a
	  // bit, and then add those together (with an offset to account for the
	  // booleans at the beginning of this function).
	  var capture = normalizedEventOptions.capture << 0;
	  var passive = normalizedEventOptions.passive << 1;
	  var once = normalizedEventOptions.once << 2;
	  return capture + passive + once;
	}

/***/ },
/* 2198 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = normalizeEventOptions;
	
	var _canUsePassiveEventListeners = __webpack_require__(2196);
	
	var _canUsePassiveEventListeners2 = _interopRequireDefault(_canUsePassiveEventListeners);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function normalizeEventOptions(eventOptions) {
	  if (!eventOptions) {
	    return undefined;
	  }
	
	  if (!(0, _canUsePassiveEventListeners2['default'])()) {
	    // If the browser does not support the passive option, then it is expecting
	    // a boolean for the options argument to specify whether it should use
	    // capture or not. In more modern browsers, this is passed via the `capture`
	    // option, so let's just hoist that value up.
	    return !!eventOptions.capture;
	  }
	
	  return eventOptions;
	}

/***/ },
/* 2199 */
/***/ function(module, exports, __webpack_require__) {

	var upperCase = __webpack_require__(172)
	var snakeCase = __webpack_require__(966)
	
	/**
	 * Constant case a string.
	 *
	 * @param  {String} string
	 * @param  {String} [locale]
	 * @return {String}
	 */
	module.exports = function (string, locale) {
	  return upperCase(snakeCase(string, locale), locale)
	}


/***/ },
/* 2200 */,
/* 2201 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(2224);
	var $Object = __webpack_require__(192).Object;
	module.exports = function create(P, D) {
	  return $Object.create(P, D);
	};


/***/ },
/* 2202 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(2225);
	module.exports = __webpack_require__(192).Object.setPrototypeOf;


/***/ },
/* 2203 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(2228);
	__webpack_require__(2226);
	__webpack_require__(2229);
	__webpack_require__(2230);
	module.exports = __webpack_require__(192).Symbol;


/***/ },
/* 2204 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(2227);
	__webpack_require__(2231);
	module.exports = __webpack_require__(414).f('iterator');


/***/ },
/* 2205 */
61,
/* 2206 */
/***/ function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ },
/* 2207 */
[3487, 197, 2221, 2220],
/* 2208 */
[3491, 406, 659, 407],
/* 2209 */
[3493, 129],
/* 2210 */
[3495, 652],
/* 2211 */
[3496, 652],
/* 2212 */
[3497, 405, 305, 408, 194, 198],
/* 2213 */
675,
/* 2214 */
[3499, 306, 195, 149, 196, 303],
/* 2215 */
[3502, 196, 247, 406, 193],
/* 2216 */
[3504, 197, 658],
/* 2217 */
[3506, 149, 2222, 409],
/* 2218 */
[3509, 195, 247, 653, 657],
/* 2219 */
[3513, 411, 402],
/* 2220 */
[3514, 411],
/* 2221 */
[3516, 411],
/* 2222 */
[3517, 402],
/* 2223 */
[3522, 2206, 2213, 404, 197, 656],
/* 2224 */
[3523, 302, 405],
/* 2225 */
[3524, 302, 2218],
/* 2226 */
/***/ function(module, exports) {



/***/ },
/* 2227 */
[3525, 2219, 656],
/* 2228 */
[3526, 129, 149, 193, 302, 661, 2214, 303, 410, 408, 306, 198, 414, 413, 2208, 2211, 247, 195, 197, 412, 305, 405, 2216, 657, 196, 406, 658, 407, 659, 304, 194],
/* 2229 */
[3527, 413],
/* 2230 */
[3528, 413],
/* 2231 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(2223);
	var global = __webpack_require__(129);
	var hide = __webpack_require__(194);
	var Iterators = __webpack_require__(404);
	var TO_STRING_TAG = __webpack_require__(198)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ },
/* 2232 */,
/* 2233 */,
/* 2234 */,
/* 2235 */,
/* 2236 */,
/* 2237 */,
/* 2238 */,
/* 2239 */,
/* 2240 */,
/* 2241 */,
/* 2242 */,
/* 2243 */,
/* 2244 */,
/* 2245 */,
/* 2246 */,
/* 2247 */,
/* 2248 */,
/* 2249 */,
/* 2250 */,
/* 2251 */,
/* 2252 */,
/* 2253 */,
/* 2254 */,
/* 2255 */,
/* 2256 */,
/* 2257 */,
/* 2258 */,
/* 2259 */,
/* 2260 */,
/* 2261 */,
/* 2262 */,
/* 2263 */,
/* 2264 */,
/* 2265 */,
/* 2266 */,
/* 2267 */,
/* 2268 */,
/* 2269 */,
/* 2270 */,
/* 2271 */,
/* 2272 */,
/* 2273 */,
/* 2274 */,
/* 2275 */,
/* 2276 */,
/* 2277 */,
/* 2278 */,
/* 2279 */,
/* 2280 */,
/* 2281 */,
/* 2282 */,
/* 2283 */,
/* 2284 */,
/* 2285 */,
/* 2286 */,
/* 2287 */,
/* 2288 */,
/* 2289 */,
/* 2290 */,
/* 2291 */,
/* 2292 */,
/* 2293 */,
/* 2294 */,
/* 2295 */,
/* 2296 */,
/* 2297 */,
/* 2298 */,
/* 2299 */,
/* 2300 */,
/* 2301 */,
/* 2302 */,
/* 2303 */,
/* 2304 */,
/* 2305 */,
/* 2306 */,
/* 2307 */,
/* 2308 */,
/* 2309 */,
/* 2310 */,
/* 2311 */,
/* 2312 */,
/* 2313 */,
/* 2314 */,
/* 2315 */,
/* 2316 */,
/* 2317 */,
/* 2318 */,
/* 2319 */,
/* 2320 */,
/* 2321 */,
/* 2322 */,
/* 2323 */,
/* 2324 */,
/* 2325 */,
/* 2326 */,
/* 2327 */,
/* 2328 */,
/* 2329 */,
/* 2330 */,
/* 2331 */,
/* 2332 */,
/* 2333 */,
/* 2334 */,
/* 2335 */,
/* 2336 */,
/* 2337 */,
/* 2338 */,
/* 2339 */,
/* 2340 */,
/* 2341 */,
/* 2342 */,
/* 2343 */,
/* 2344 */,
/* 2345 */,
/* 2346 */,
/* 2347 */,
/* 2348 */,
/* 2349 */,
/* 2350 */,
/* 2351 */,
/* 2352 */,
/* 2353 */,
/* 2354 */,
/* 2355 */,
/* 2356 */,
/* 2357 */,
/* 2358 */,
/* 2359 */,
/* 2360 */,
/* 2361 */,
/* 2362 */,
/* 2363 */,
/* 2364 */,
/* 2365 */,
/* 2366 */,
/* 2367 */,
/* 2368 */,
/* 2369 */,
/* 2370 */,
/* 2371 */,
/* 2372 */,
/* 2373 */,
/* 2374 */,
/* 2375 */,
/* 2376 */,
/* 2377 */,
/* 2378 */,
/* 2379 */,
/* 2380 */,
/* 2381 */,
/* 2382 */,
/* 2383 */,
/* 2384 */,
/* 2385 */,
/* 2386 */,
/* 2387 */,
/* 2388 */,
/* 2389 */,
/* 2390 */,
/* 2391 */,
/* 2392 */,
/* 2393 */,
/* 2394 */,
/* 2395 */,
/* 2396 */,
/* 2397 */,
/* 2398 */,
/* 2399 */,
/* 2400 */,
/* 2401 */,
/* 2402 */,
/* 2403 */,
/* 2404 */,
/* 2405 */,
/* 2406 */,
/* 2407 */,
/* 2408 */,
/* 2409 */,
/* 2410 */,
/* 2411 */,
/* 2412 */,
/* 2413 */,
/* 2414 */,
/* 2415 */,
/* 2416 */,
/* 2417 */,
/* 2418 */,
/* 2419 */,
/* 2420 */,
/* 2421 */,
/* 2422 */,
/* 2423 */,
/* 2424 */,
/* 2425 */,
/* 2426 */,
/* 2427 */,
/* 2428 */,
/* 2429 */,
/* 2430 */,
/* 2431 */
/***/ function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(2433);
	var isArguments = __webpack_require__(2432);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ },
/* 2432 */
/***/ function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ },
/* 2433 */
/***/ function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ },
/* 2434 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === 'object') {
	        module.exports = factory();
	    } else {
	        root.deepmerge = factory();
	    }
	}(this, function () {
	
	function isMergeableObject(val) {
	    var nonNullObject = val && typeof val === 'object'
	
	    return nonNullObject
	        && Object.prototype.toString.call(val) !== '[object RegExp]'
	        && Object.prototype.toString.call(val) !== '[object Date]'
	}
	
	function emptyTarget(val) {
	    return Array.isArray(val) ? [] : {}
	}
	
	function cloneIfNecessary(value, optionsArgument) {
	    var clone = optionsArgument && optionsArgument.clone === true
	    return (clone && isMergeableObject(value)) ? deepmerge(emptyTarget(value), value, optionsArgument) : value
	}
	
	function defaultArrayMerge(target, source, optionsArgument) {
	    var destination = target.slice()
	    source.forEach(function(e, i) {
	        if (typeof destination[i] === 'undefined') {
	            destination[i] = cloneIfNecessary(e, optionsArgument)
	        } else if (isMergeableObject(e)) {
	            destination[i] = deepmerge(target[i], e, optionsArgument)
	        } else if (target.indexOf(e) === -1) {
	            destination.push(cloneIfNecessary(e, optionsArgument))
	        }
	    })
	    return destination
	}
	
	function mergeObject(target, source, optionsArgument) {
	    var destination = {}
	    if (isMergeableObject(target)) {
	        Object.keys(target).forEach(function (key) {
	            destination[key] = cloneIfNecessary(target[key], optionsArgument)
	        })
	    }
	    Object.keys(source).forEach(function (key) {
	        if (!isMergeableObject(source[key]) || !target[key]) {
	            destination[key] = cloneIfNecessary(source[key], optionsArgument)
	        } else {
	            destination[key] = deepmerge(target[key], source[key], optionsArgument)
	        }
	    })
	    return destination
	}
	
	function deepmerge(target, source, optionsArgument) {
	    var array = Array.isArray(source);
	    var options = optionsArgument || { arrayMerge: defaultArrayMerge }
	    var arrayMerge = options.arrayMerge || defaultArrayMerge
	
	    if (array) {
	        return Array.isArray(target) ? arrayMerge(target, source, optionsArgument) : cloneIfNecessary(source, optionsArgument)
	    } else {
	        return mergeObject(target, source, optionsArgument)
	    }
	}
	
	deepmerge.all = function deepmergeAll(array, optionsArgument) {
	    if (!Array.isArray(array) || array.length < 2) {
	        throw new Error('first argument should be an array with at least two elements')
	    }
	
	    // we are sure there are at least 2 values, so it is safe to have no initial value
	    return array.reduce(function(prev, next) {
	        return deepmerge(prev, next, optionsArgument)
	    })
	}
	
	return deepmerge
	
	}));


/***/ },
/* 2435 */
/***/ function(module, exports, __webpack_require__) {

	var detectBrowser = __webpack_require__(2436);
	
	var agent;
	
	if (typeof navigator !== 'undefined' && navigator) {
	  agent = navigator.userAgent;
	}
	
	module.exports = detectBrowser(agent);


/***/ },
/* 2436 */
/***/ function(module, exports) {

	module.exports = function detectBrowser(userAgentString) {
	  if (!userAgentString) return null;
	
	  var browsers = [
	    [ 'edge', /Edge\/([0-9\._]+)/ ],
	    [ 'yandexbrowser', /YaBrowser\/([0-9\._]+)/ ],
	    [ 'vivaldi', /Vivaldi\/([0-9\.]+)/ ],
	    [ 'chrome', /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/ ],
	    [ 'crios', /CriOS\/([0-9\.]+)(:?\s|$)/ ],
	    [ 'firefox', /Firefox\/([0-9\.]+)(?:\s|$)/ ],
	    [ 'fxios', /FxiOS\/([0-9\.]+)/ ],
	    [ 'opera', /Opera\/([0-9\.]+)(?:\s|$)/ ],
	    [ 'opera', /OPR\/([0-9\.]+)(:?\s|$)$/ ],
	    [ 'ie', /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/ ],
	    [ 'ie', /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/ ],
	    [ 'ie', /MSIE\s(7\.0)/ ],
	    [ 'bb10', /BB10;\sTouch.*Version\/([0-9\.]+)/ ],
	    [ 'android', /Android\s([0-9\.]+)/ ],
	    [ 'ios', /Version\/([0-9\._]+).*Mobile.*Safari.*/ ],
	    [ 'safari', /Version\/([0-9\._]+).*Safari/ ]
	  ];
	
	  return browsers.map(function (rule) {
	      if (rule[1].test(userAgentString)) {
	          var match = rule[1].exec(userAgentString);
	          var version = match && match[1].split(/[._]/).slice(0,3);
	
	          if (version && version.length < 3) {
	              Array.prototype.push.apply(version, (version.length == 1) ? [0, 0] : [0]);
	          }
	
	          return {
	              name: rule[0],
	              version: version.join('.')
	          };
	      }
	  }).filter(Boolean).shift();
	};


/***/ },
/* 2437 */
/***/ function(module, exports, __webpack_require__) {

	var sentenceCase = __webpack_require__(171)
	
	/**
	 * Dot case a string.
	 *
	 * @param  {String} string
	 * @param  {String} [locale]
	 * @return {String}
	 */
	module.exports = function (string, locale) {
	  return sentenceCase(string, locale, '.')
	}


/***/ },
/* 2438 */
/***/ function(module, exports, __webpack_require__) {

	var QueryHandler = __webpack_require__(2440);
	var each = __webpack_require__(696).each;
	
	/**
	 * Represents a single media query, manages it's state and registered handlers for this query
	 *
	 * @constructor
	 * @param {string} query the media query string
	 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
	 */
	function MediaQuery(query, isUnconditional) {
	    this.query = query;
	    this.isUnconditional = isUnconditional;
	    this.handlers = [];
	    this.mql = window.matchMedia(query);
	
	    var self = this;
	    this.listener = function(mql) {
	        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
	        self.mql = mql.currentTarget || mql;
	        self.assess();
	    };
	    this.mql.addListener(this.listener);
	}
	
	MediaQuery.prototype = {
	
	    constuctor : MediaQuery,
	
	    /**
	     * add a handler for this query, triggering if already active
	     *
	     * @param {object} handler
	     * @param {function} handler.match callback for when query is activated
	     * @param {function} [handler.unmatch] callback for when query is deactivated
	     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
	     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
	     */
	    addHandler : function(handler) {
	        var qh = new QueryHandler(handler);
	        this.handlers.push(qh);
	
	        this.matches() && qh.on();
	    },
	
	    /**
	     * removes the given handler from the collection, and calls it's destroy methods
	     *
	     * @param {object || function} handler the handler to remove
	     */
	    removeHandler : function(handler) {
	        var handlers = this.handlers;
	        each(handlers, function(h, i) {
	            if(h.equals(handler)) {
	                h.destroy();
	                return !handlers.splice(i,1); //remove from array and exit each early
	            }
	        });
	    },
	
	    /**
	     * Determine whether the media query should be considered a match
	     *
	     * @return {Boolean} true if media query can be considered a match, false otherwise
	     */
	    matches : function() {
	        return this.mql.matches || this.isUnconditional;
	    },
	
	    /**
	     * Clears all handlers and unbinds events
	     */
	    clear : function() {
	        each(this.handlers, function(handler) {
	            handler.destroy();
	        });
	        this.mql.removeListener(this.listener);
	        this.handlers.length = 0; //clear array
	    },
	
	    /*
	        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
	        */
	    assess : function() {
	        var action = this.matches() ? 'on' : 'off';
	
	        each(this.handlers, function(handler) {
	            handler[action]();
	        });
	    }
	};
	
	module.exports = MediaQuery;


/***/ },
/* 2439 */
/***/ function(module, exports, __webpack_require__) {

	var MediaQuery = __webpack_require__(2438);
	var Util = __webpack_require__(696);
	var each = Util.each;
	var isFunction = Util.isFunction;
	var isArray = Util.isArray;
	
	/**
	 * Allows for registration of query handlers.
	 * Manages the query handler's state and is responsible for wiring up browser events
	 *
	 * @constructor
	 */
	function MediaQueryDispatch () {
	    if(!window.matchMedia) {
	        throw new Error('matchMedia not present, legacy browsers require a polyfill');
	    }
	
	    this.queries = {};
	    this.browserIsIncapable = !window.matchMedia('only all').matches;
	}
	
	MediaQueryDispatch.prototype = {
	
	    constructor : MediaQueryDispatch,
	
	    /**
	     * Registers a handler for the given media query
	     *
	     * @param {string} q the media query
	     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
	     * @param {function} options.match fired when query matched
	     * @param {function} [options.unmatch] fired when a query is no longer matched
	     * @param {function} [options.setup] fired when handler first triggered
	     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
	     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
	     */
	    register : function(q, options, shouldDegrade) {
	        var queries         = this.queries,
	            isUnconditional = shouldDegrade && this.browserIsIncapable;
	
	        if(!queries[q]) {
	            queries[q] = new MediaQuery(q, isUnconditional);
	        }
	
	        //normalise to object in an array
	        if(isFunction(options)) {
	            options = { match : options };
	        }
	        if(!isArray(options)) {
	            options = [options];
	        }
	        each(options, function(handler) {
	            if (isFunction(handler)) {
	                handler = { match : handler };
	            }
	            queries[q].addHandler(handler);
	        });
	
	        return this;
	    },
	
	    /**
	     * unregisters a query and all it's handlers, or a specific handler for a query
	     *
	     * @param {string} q the media query to target
	     * @param {object || function} [handler] specific handler to unregister
	     */
	    unregister : function(q, handler) {
	        var query = this.queries[q];
	
	        if(query) {
	            if(handler) {
	                query.removeHandler(handler);
	            }
	            else {
	                query.clear();
	                delete this.queries[q];
	            }
	        }
	
	        return this;
	    }
	};
	
	module.exports = MediaQueryDispatch;


/***/ },
/* 2440 */
/***/ function(module, exports) {

	/**
	 * Delegate to handle a media query being matched and unmatched.
	 *
	 * @param {object} options
	 * @param {function} options.match callback for when the media query is matched
	 * @param {function} [options.unmatch] callback for when the media query is unmatched
	 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
	 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
	 * @constructor
	 */
	function QueryHandler(options) {
	    this.options = options;
	    !options.deferSetup && this.setup();
	}
	
	QueryHandler.prototype = {
	
	    constructor : QueryHandler,
	
	    /**
	     * coordinates setup of the handler
	     *
	     * @function
	     */
	    setup : function() {
	        if(this.options.setup) {
	            this.options.setup();
	        }
	        this.initialised = true;
	    },
	
	    /**
	     * coordinates setup and triggering of the handler
	     *
	     * @function
	     */
	    on : function() {
	        !this.initialised && this.setup();
	        this.options.match && this.options.match();
	    },
	
	    /**
	     * coordinates the unmatch event for the handler
	     *
	     * @function
	     */
	    off : function() {
	        this.options.unmatch && this.options.unmatch();
	    },
	
	    /**
	     * called when a handler is to be destroyed.
	     * delegates to the destroy or unmatch callbacks, depending on availability.
	     *
	     * @function
	     */
	    destroy : function() {
	        this.options.destroy ? this.options.destroy() : this.off();
	    },
	
	    /**
	     * determines equality by reference.
	     * if object is supplied compare options, if function, compare match callback
	     *
	     * @function
	     * @param {object || function} [target] the target for comparison
	     */
	    equals : function(target) {
	        return this.options === target || this.options.match === target;
	    }
	
	};
	
	module.exports = QueryHandler;


/***/ },
/* 2441 */
/***/ function(module, exports, __webpack_require__) {

	var MediaQueryDispatch = __webpack_require__(2439);
	module.exports = new MediaQueryDispatch();


/***/ },
/* 2442 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var has = __webpack_require__(322);
	var toPrimitive = __webpack_require__(2449);
	
	var GetIntrinsic = __webpack_require__(697);
	
	var $TypeError = GetIntrinsic('%TypeError%');
	var $SyntaxError = GetIntrinsic('%SyntaxError%');
	var $Array = GetIntrinsic('%Array%');
	var $String = GetIntrinsic('%String%');
	var $Object = GetIntrinsic('%Object%');
	var $Number = GetIntrinsic('%Number%');
	var $Symbol = GetIntrinsic('%Symbol%', true);
	var $RegExp = GetIntrinsic('%RegExp%');
	
	var hasSymbols = !!$Symbol;
	
	var $isNaN = __webpack_require__(700);
	var $isFinite = __webpack_require__(699);
	var MAX_SAFE_INTEGER = $Number.MAX_SAFE_INTEGER || Math.pow(2, 53) - 1;
	
	var assign = __webpack_require__(441);
	var sign = __webpack_require__(702);
	var mod = __webpack_require__(701);
	var isPrimitive = __webpack_require__(2446);
	var parseInteger = parseInt;
	var bind = __webpack_require__(253);
	var arraySlice = bind.call(Function.call, $Array.prototype.slice);
	var strSlice = bind.call(Function.call, $String.prototype.slice);
	var isBinary = bind.call(Function.call, $RegExp.prototype.test, /^0b[01]+$/i);
	var isOctal = bind.call(Function.call, $RegExp.prototype.test, /^0o[0-7]+$/i);
	var regexExec = bind.call(Function.call, $RegExp.prototype.exec);
	var nonWS = ['\u0085', '\u200b', '\ufffe'].join('');
	var nonWSregex = new $RegExp('[' + nonWS + ']', 'g');
	var hasNonWS = bind.call(Function.call, $RegExp.prototype.test, nonWSregex);
	var invalidHexLiteral = /^[-+]0x[0-9a-f]+$/i;
	var isInvalidHexLiteral = bind.call(Function.call, $RegExp.prototype.test, invalidHexLiteral);
	var $charCodeAt = bind.call(Function.call, $String.prototype.charCodeAt);
	
	var toStr = bind.call(Function.call, Object.prototype.toString);
	
	var $floor = Math.floor;
	var $abs = Math.abs;
	
	var $ObjectCreate = Object.create;
	var $gOPD = $Object.getOwnPropertyDescriptor;
	
	var $isExtensible = $Object.isExtensible;
	
	// whitespace from: http://es5.github.io/#x15.5.4.20
	// implementation from https://github.com/es-shims/es5-shim/blob/v3.4.0/es5-shim.js#L1304-L1324
	var ws = [
		'\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003',
		'\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028',
		'\u2029\uFEFF'
	].join('');
	var trimRegex = new RegExp('(^[' + ws + ']+)|([' + ws + ']+$)', 'g');
	var replace = bind.call(Function.call, $String.prototype.replace);
	var trim = function (value) {
		return replace(value, trimRegex, '');
	};
	
	var ES5 = __webpack_require__(2444);
	
	var hasRegExpMatcher = __webpack_require__(2814);
	
	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-abstract-operations
	var ES6 = assign(assign({}, ES5), {
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-call-f-v-args
		Call: function Call(F, V) {
			var args = arguments.length > 2 ? arguments[2] : [];
			if (!this.IsCallable(F)) {
				throw new $TypeError(F + ' is not a function');
			}
			return F.apply(V, args);
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toprimitive
		ToPrimitive: toPrimitive,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toboolean
		// ToBoolean: ES5.ToBoolean,
	
		// https://ecma-international.org/ecma-262/6.0/#sec-tonumber
		ToNumber: function ToNumber(argument) {
			var value = isPrimitive(argument) ? argument : toPrimitive(argument, $Number);
			if (typeof value === 'symbol') {
				throw new $TypeError('Cannot convert a Symbol value to a number');
			}
			if (typeof value === 'string') {
				if (isBinary(value)) {
					return this.ToNumber(parseInteger(strSlice(value, 2), 2));
				} else if (isOctal(value)) {
					return this.ToNumber(parseInteger(strSlice(value, 2), 8));
				} else if (hasNonWS(value) || isInvalidHexLiteral(value)) {
					return NaN;
				} else {
					var trimmed = trim(value);
					if (trimmed !== value) {
						return this.ToNumber(trimmed);
					}
				}
			}
			return $Number(value);
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tointeger
		// ToInteger: ES5.ToNumber,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toint32
		// ToInt32: ES5.ToInt32,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint32
		// ToUint32: ES5.ToUint32,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toint16
		ToInt16: function ToInt16(argument) {
			var int16bit = this.ToUint16(argument);
			return int16bit >= 0x8000 ? int16bit - 0x10000 : int16bit;
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint16
		// ToUint16: ES5.ToUint16,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toint8
		ToInt8: function ToInt8(argument) {
			var int8bit = this.ToUint8(argument);
			return int8bit >= 0x80 ? int8bit - 0x100 : int8bit;
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint8
		ToUint8: function ToUint8(argument) {
			var number = this.ToNumber(argument);
			if ($isNaN(number) || number === 0 || !$isFinite(number)) { return 0; }
			var posInt = sign(number) * $floor($abs(number));
			return mod(posInt, 0x100);
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint8clamp
		ToUint8Clamp: function ToUint8Clamp(argument) {
			var number = this.ToNumber(argument);
			if ($isNaN(number) || number <= 0) { return 0; }
			if (number >= 0xFF) { return 0xFF; }
			var f = $floor(argument);
			if (f + 0.5 < number) { return f + 1; }
			if (number < f + 0.5) { return f; }
			if (f % 2 !== 0) { return f + 1; }
			return f;
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tostring
		ToString: function ToString(argument) {
			if (typeof argument === 'symbol') {
				throw new $TypeError('Cannot convert a Symbol value to a string');
			}
			return $String(argument);
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toobject
		ToObject: function ToObject(value) {
			this.RequireObjectCoercible(value);
			return $Object(value);
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-topropertykey
		ToPropertyKey: function ToPropertyKey(argument) {
			var key = this.ToPrimitive(argument, $String);
			return typeof key === 'symbol' ? key : this.ToString(key);
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
		ToLength: function ToLength(argument) {
			var len = this.ToInteger(argument);
			if (len <= 0) { return 0; } // includes converting -0 to +0
			if (len > MAX_SAFE_INTEGER) { return MAX_SAFE_INTEGER; }
			return len;
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-canonicalnumericindexstring
		CanonicalNumericIndexString: function CanonicalNumericIndexString(argument) {
			if (toStr(argument) !== '[object String]') {
				throw new $TypeError('must be a string');
			}
			if (argument === '-0') { return -0; }
			var n = this.ToNumber(argument);
			if (this.SameValue(this.ToString(n), argument)) { return n; }
			return void 0;
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-requireobjectcoercible
		RequireObjectCoercible: ES5.CheckObjectCoercible,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isarray
		IsArray: $Array.isArray || function IsArray(argument) {
			return toStr(argument) === '[object Array]';
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-iscallable
		// IsCallable: ES5.IsCallable,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isconstructor
		IsConstructor: function IsConstructor(argument) {
			return typeof argument === 'function' && !!argument.prototype; // unfortunately there's no way to truly check this without try/catch `new argument`
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isextensible-o
		IsExtensible: Object.preventExtensions
			? function IsExtensible(obj) {
				if (isPrimitive(obj)) {
					return false;
				}
				return $isExtensible(obj);
			}
			: function isExtensible(obj) { return true; }, // eslint-disable-line no-unused-vars
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isinteger
		IsInteger: function IsInteger(argument) {
			if (typeof argument !== 'number' || $isNaN(argument) || !$isFinite(argument)) {
				return false;
			}
			var abs = $abs(argument);
			return $floor(abs) === abs;
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-ispropertykey
		IsPropertyKey: function IsPropertyKey(argument) {
			return typeof argument === 'string' || typeof argument === 'symbol';
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-isregexp
		IsRegExp: function IsRegExp(argument) {
			if (!argument || typeof argument !== 'object') {
				return false;
			}
			if (hasSymbols) {
				var isRegExp = argument[$Symbol.match];
				if (typeof isRegExp !== 'undefined') {
					return ES5.ToBoolean(isRegExp);
				}
			}
			return hasRegExpMatcher(argument);
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevalue
		// SameValue: ES5.SameValue,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevaluezero
		SameValueZero: function SameValueZero(x, y) {
			return (x === y) || ($isNaN(x) && $isNaN(y));
		},
	
		/**
		 * 7.3.2 GetV (V, P)
		 * 1. Assert: IsPropertyKey(P) is true.
		 * 2. Let O be ToObject(V).
		 * 3. ReturnIfAbrupt(O).
		 * 4. Return O.[[Get]](P, V).
		 */
		GetV: function GetV(V, P) {
			// 7.3.2.1
			if (!this.IsPropertyKey(P)) {
				throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
			}
	
			// 7.3.2.2-3
			var O = this.ToObject(V);
	
			// 7.3.2.4
			return O[P];
		},
	
		/**
		 * 7.3.9 - https://ecma-international.org/ecma-262/6.0/#sec-getmethod
		 * 1. Assert: IsPropertyKey(P) is true.
		 * 2. Let func be GetV(O, P).
		 * 3. ReturnIfAbrupt(func).
		 * 4. If func is either undefined or null, return undefined.
		 * 5. If IsCallable(func) is false, throw a TypeError exception.
		 * 6. Return func.
		 */
		GetMethod: function GetMethod(O, P) {
			// 7.3.9.1
			if (!this.IsPropertyKey(P)) {
				throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
			}
	
			// 7.3.9.2
			var func = this.GetV(O, P);
	
			// 7.3.9.4
			if (func == null) {
				return void 0;
			}
	
			// 7.3.9.5
			if (!this.IsCallable(func)) {
				throw new $TypeError(P + 'is not a function');
			}
	
			// 7.3.9.6
			return func;
		},
	
		/**
		 * 7.3.1 Get (O, P) - https://ecma-international.org/ecma-262/6.0/#sec-get-o-p
		 * 1. Assert: Type(O) is Object.
		 * 2. Assert: IsPropertyKey(P) is true.
		 * 3. Return O.[[Get]](P, O).
		 */
		Get: function Get(O, P) {
			// 7.3.1.1
			if (this.Type(O) !== 'Object') {
				throw new $TypeError('Assertion failed: Type(O) is not Object');
			}
			// 7.3.1.2
			if (!this.IsPropertyKey(P)) {
				throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
			}
			// 7.3.1.3
			return O[P];
		},
	
		Type: function Type(x) {
			if (typeof x === 'symbol') {
				return 'Symbol';
			}
			return ES5.Type(x);
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-speciesconstructor
		SpeciesConstructor: function SpeciesConstructor(O, defaultConstructor) {
			if (this.Type(O) !== 'Object') {
				throw new $TypeError('Assertion failed: Type(O) is not Object');
			}
			var C = O.constructor;
			if (typeof C === 'undefined') {
				return defaultConstructor;
			}
			if (this.Type(C) !== 'Object') {
				throw new $TypeError('O.constructor is not an Object');
			}
			var S = hasSymbols && $Symbol.species ? C[$Symbol.species] : void 0;
			if (S == null) {
				return defaultConstructor;
			}
			if (this.IsConstructor(S)) {
				return S;
			}
			throw new $TypeError('no constructor found');
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-completepropertydescriptor
		CompletePropertyDescriptor: function CompletePropertyDescriptor(Desc) {
			if (!this.IsPropertyDescriptor(Desc)) {
				throw new $TypeError('Desc must be a Property Descriptor');
			}
	
			if (this.IsGenericDescriptor(Desc) || this.IsDataDescriptor(Desc)) {
				if (!has(Desc, '[[Value]]')) {
					Desc['[[Value]]'] = void 0;
				}
				if (!has(Desc, '[[Writable]]')) {
					Desc['[[Writable]]'] = false;
				}
			} else {
				if (!has(Desc, '[[Get]]')) {
					Desc['[[Get]]'] = void 0;
				}
				if (!has(Desc, '[[Set]]')) {
					Desc['[[Set]]'] = void 0;
				}
			}
			if (!has(Desc, '[[Enumerable]]')) {
				Desc['[[Enumerable]]'] = false;
			}
			if (!has(Desc, '[[Configurable]]')) {
				Desc['[[Configurable]]'] = false;
			}
			return Desc;
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-set-o-p-v-throw
		Set: function Set(O, P, V, Throw) {
			if (this.Type(O) !== 'Object') {
				throw new $TypeError('O must be an Object');
			}
			if (!this.IsPropertyKey(P)) {
				throw new $TypeError('P must be a Property Key');
			}
			if (this.Type(Throw) !== 'Boolean') {
				throw new $TypeError('Throw must be a Boolean');
			}
			if (Throw) {
				O[P] = V;
				return true;
			} else {
				try {
					O[P] = V;
				} catch (e) {
					return false;
				}
			}
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-hasownproperty
		HasOwnProperty: function HasOwnProperty(O, P) {
			if (this.Type(O) !== 'Object') {
				throw new $TypeError('O must be an Object');
			}
			if (!this.IsPropertyKey(P)) {
				throw new $TypeError('P must be a Property Key');
			}
			return has(O, P);
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-hasproperty
		HasProperty: function HasProperty(O, P) {
			if (this.Type(O) !== 'Object') {
				throw new $TypeError('O must be an Object');
			}
			if (!this.IsPropertyKey(P)) {
				throw new $TypeError('P must be a Property Key');
			}
			return P in O;
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-isconcatspreadable
		IsConcatSpreadable: function IsConcatSpreadable(O) {
			if (this.Type(O) !== 'Object') {
				return false;
			}
			if (hasSymbols && typeof $Symbol.isConcatSpreadable === 'symbol') {
				var spreadable = this.Get(O, Symbol.isConcatSpreadable);
				if (typeof spreadable !== 'undefined') {
					return this.ToBoolean(spreadable);
				}
			}
			return this.IsArray(O);
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-invoke
		Invoke: function Invoke(O, P) {
			if (!this.IsPropertyKey(P)) {
				throw new $TypeError('P must be a Property Key');
			}
			var argumentsList = arraySlice(arguments, 2);
			var func = this.GetV(O, P);
			return this.Call(func, O, argumentsList);
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-getiterator
		GetIterator: function GetIterator(obj, method) {
			if (!hasSymbols) {
				throw new SyntaxError('ES.GetIterator depends on native iterator support.');
			}
	
			var actualMethod = method;
			if (arguments.length < 2) {
				actualMethod = this.GetMethod(obj, $Symbol.iterator);
			}
			var iterator = this.Call(actualMethod, obj);
			if (this.Type(iterator) !== 'Object') {
				throw new $TypeError('iterator must return an object');
			}
	
			return iterator;
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-iteratornext
		IteratorNext: function IteratorNext(iterator, value) {
			var result = this.Invoke(iterator, 'next', arguments.length < 2 ? [] : [value]);
			if (this.Type(result) !== 'Object') {
				throw new $TypeError('iterator next must return an object');
			}
			return result;
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-iteratorcomplete
		IteratorComplete: function IteratorComplete(iterResult) {
			if (this.Type(iterResult) !== 'Object') {
				throw new $TypeError('Assertion failed: Type(iterResult) is not Object');
			}
			return this.ToBoolean(this.Get(iterResult, 'done'));
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-iteratorvalue
		IteratorValue: function IteratorValue(iterResult) {
			if (this.Type(iterResult) !== 'Object') {
				throw new $TypeError('Assertion failed: Type(iterResult) is not Object');
			}
			return this.Get(iterResult, 'value');
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-iteratorstep
		IteratorStep: function IteratorStep(iterator) {
			var result = this.IteratorNext(iterator);
			var done = this.IteratorComplete(result);
			return done === true ? false : result;
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-iteratorclose
		IteratorClose: function IteratorClose(iterator, completion) {
			if (this.Type(iterator) !== 'Object') {
				throw new $TypeError('Assertion failed: Type(iterator) is not Object');
			}
			if (!this.IsCallable(completion)) {
				throw new $TypeError('Assertion failed: completion is not a thunk for a Completion Record');
			}
			var completionThunk = completion;
	
			var iteratorReturn = this.GetMethod(iterator, 'return');
	
			if (typeof iteratorReturn === 'undefined') {
				return completionThunk();
			}
	
			var completionRecord;
			try {
				var innerResult = this.Call(iteratorReturn, iterator, []);
			} catch (e) {
				// if we hit here, then "e" is the innerResult completion that needs re-throwing
	
				// if the completion is of type "throw", this will throw.
				completionRecord = completionThunk();
				completionThunk = null; // ensure it's not called twice.
	
				// if not, then return the innerResult completion
				throw e;
			}
			completionRecord = completionThunk(); // if innerResult worked, then throw if the completion does
			completionThunk = null; // ensure it's not called twice.
	
			if (this.Type(innerResult) !== 'Object') {
				throw new $TypeError('iterator .return must return an object');
			}
	
			return completionRecord;
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-createiterresultobject
		CreateIterResultObject: function CreateIterResultObject(value, done) {
			if (this.Type(done) !== 'Boolean') {
				throw new $TypeError('Assertion failed: Type(done) is not Boolean');
			}
			return {
				value: value,
				done: done
			};
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-regexpexec
		RegExpExec: function RegExpExec(R, S) {
			if (this.Type(R) !== 'Object') {
				throw new $TypeError('R must be an Object');
			}
			if (this.Type(S) !== 'String') {
				throw new $TypeError('S must be a String');
			}
			var exec = this.Get(R, 'exec');
			if (this.IsCallable(exec)) {
				var result = this.Call(exec, R, [S]);
				if (result === null || this.Type(result) === 'Object') {
					return result;
				}
				throw new $TypeError('"exec" method must return `null` or an Object');
			}
			return regexExec(R, S);
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-arrayspeciescreate
		ArraySpeciesCreate: function ArraySpeciesCreate(originalArray, length) {
			if (!this.IsInteger(length) || length < 0) {
				throw new $TypeError('Assertion failed: length must be an integer >= 0');
			}
			var len = length === 0 ? 0 : length;
			var C;
			var isArray = this.IsArray(originalArray);
			if (isArray) {
				C = this.Get(originalArray, 'constructor');
				// TODO: figure out how to make a cross-realm normal Array, a same-realm Array
				// if (this.IsConstructor(C)) {
				// 	if C is another realm's Array, C = undefined
				// 	Object.getPrototypeOf(Object.getPrototypeOf(Object.getPrototypeOf(Array))) === null ?
				// }
				if (this.Type(C) === 'Object' && hasSymbols && $Symbol.species) {
					C = this.Get(C, $Symbol.species);
					if (C === null) {
						C = void 0;
					}
				}
			}
			if (typeof C === 'undefined') {
				return $Array(len);
			}
			if (!this.IsConstructor(C)) {
				throw new $TypeError('C must be a constructor');
			}
			return new C(len); // this.Construct(C, len);
		},
	
		CreateDataProperty: function CreateDataProperty(O, P, V) {
			if (this.Type(O) !== 'Object') {
				throw new $TypeError('Assertion failed: Type(O) is not Object');
			}
			if (!this.IsPropertyKey(P)) {
				throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
			}
			var oldDesc = $gOPD(O, P);
			var extensible = oldDesc || (typeof $isExtensible !== 'function' || $isExtensible(O));
			var immutable = oldDesc && (!oldDesc.writable || !oldDesc.configurable);
			if (immutable || !extensible) {
				return false;
			}
			var newDesc = {
				configurable: true,
				enumerable: true,
				value: V,
				writable: true
			};
			Object.defineProperty(O, P, newDesc);
			return true;
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-createdatapropertyorthrow
		CreateDataPropertyOrThrow: function CreateDataPropertyOrThrow(O, P, V) {
			if (this.Type(O) !== 'Object') {
				throw new $TypeError('Assertion failed: Type(O) is not Object');
			}
			if (!this.IsPropertyKey(P)) {
				throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
			}
			var success = this.CreateDataProperty(O, P, V);
			if (!success) {
				throw new $TypeError('unable to create data property');
			}
			return success;
		},
	
		// https://www.ecma-international.org/ecma-262/6.0/#sec-objectcreate
		ObjectCreate: function ObjectCreate(proto, internalSlotsList) {
			if (proto !== null && this.Type(proto) !== 'Object') {
				throw new $TypeError('Assertion failed: proto must be null or an object');
			}
			var slots = arguments.length < 2 ? [] : internalSlotsList;
			if (slots.length > 0) {
				throw new $SyntaxError('es-abstract does not yet support internal slots');
			}
	
			if (proto === null && !$ObjectCreate) {
				throw new $SyntaxError('native Object.create support is required to create null objects');
			}
	
			return $ObjectCreate(proto);
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-advancestringindex
		AdvanceStringIndex: function AdvanceStringIndex(S, index, unicode) {
			if (this.Type(S) !== 'String') {
				throw new $TypeError('S must be a String');
			}
			if (!this.IsInteger(index) || index < 0 || index > MAX_SAFE_INTEGER) {
				throw new $TypeError('Assertion failed: length must be an integer >= 0 and <= 2**53');
			}
			if (this.Type(unicode) !== 'Boolean') {
				throw new $TypeError('Assertion failed: unicode must be a Boolean');
			}
			if (!unicode) {
				return index + 1;
			}
			var length = S.length;
			if ((index + 1) >= length) {
				return index + 1;
			}
	
			var first = $charCodeAt(S, index);
			if (first < 0xD800 || first > 0xDBFF) {
				return index + 1;
			}
	
			var second = $charCodeAt(S, index + 1);
			if (second < 0xDC00 || second > 0xDFFF) {
				return index + 1;
			}
	
			return index + 2;
		}
	});
	
	delete ES6.CheckObjectCoercible; // renamed in ES6 to RequireObjectCoercible
	
	module.exports = ES6;


/***/ },
/* 2443 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var ES2016 = __webpack_require__(698);
	var assign = __webpack_require__(441);
	
	var ES2017 = assign(assign({}, ES2016), {
		ToIndex: function ToIndex(value) {
			if (typeof value === 'undefined') {
				return 0;
			}
			var integerIndex = this.ToInteger(value);
			if (integerIndex < 0) {
				throw new RangeError('index must be >= 0');
			}
			var index = this.ToLength(integerIndex);
			if (!this.SameValueZero(integerIndex, index)) {
				throw new RangeError('index must be >= 0 and < 2 ** 53 - 1');
			}
			return index;
		}
	});
	
	delete ES2017.EnumerableOwnNames; // replaced with EnumerableOwnProperties
	
	module.exports = ES2017;


/***/ },
/* 2444 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(697);
	
	var $Object = GetIntrinsic('%Object%');
	var $TypeError = GetIntrinsic('%TypeError%');
	var $String = GetIntrinsic('%String%');
	
	var $isNaN = __webpack_require__(700);
	var $isFinite = __webpack_require__(699);
	
	var sign = __webpack_require__(702);
	var mod = __webpack_require__(701);
	
	var IsCallable = __webpack_require__(447);
	var toPrimitive = __webpack_require__(2448);
	
	var has = __webpack_require__(322);
	
	// https://es5.github.io/#x9
	var ES5 = {
		ToPrimitive: toPrimitive,
	
		ToBoolean: function ToBoolean(value) {
			return !!value;
		},
		ToNumber: function ToNumber(value) {
			return +value; // eslint-disable-line no-implicit-coercion
		},
		ToInteger: function ToInteger(value) {
			var number = this.ToNumber(value);
			if ($isNaN(number)) { return 0; }
			if (number === 0 || !$isFinite(number)) { return number; }
			return sign(number) * Math.floor(Math.abs(number));
		},
		ToInt32: function ToInt32(x) {
			return this.ToNumber(x) >> 0;
		},
		ToUint32: function ToUint32(x) {
			return this.ToNumber(x) >>> 0;
		},
		ToUint16: function ToUint16(value) {
			var number = this.ToNumber(value);
			if ($isNaN(number) || number === 0 || !$isFinite(number)) { return 0; }
			var posInt = sign(number) * Math.floor(Math.abs(number));
			return mod(posInt, 0x10000);
		},
		ToString: function ToString(value) {
			return $String(value);
		},
		ToObject: function ToObject(value) {
			this.CheckObjectCoercible(value);
			return $Object(value);
		},
		CheckObjectCoercible: function CheckObjectCoercible(value, optMessage) {
			/* jshint eqnull:true */
			if (value == null) {
				throw new $TypeError(optMessage || 'Cannot call method on ' + value);
			}
			return value;
		},
		IsCallable: IsCallable,
		SameValue: function SameValue(x, y) {
			if (x === y) { // 0 === -0, but they are not identical.
				if (x === 0) { return 1 / x === 1 / y; }
				return true;
			}
			return $isNaN(x) && $isNaN(y);
		},
	
		// https://www.ecma-international.org/ecma-262/5.1/#sec-8
		Type: function Type(x) {
			if (x === null) {
				return 'Null';
			}
			if (typeof x === 'undefined') {
				return 'Undefined';
			}
			if (typeof x === 'function' || typeof x === 'object') {
				return 'Object';
			}
			if (typeof x === 'number') {
				return 'Number';
			}
			if (typeof x === 'boolean') {
				return 'Boolean';
			}
			if (typeof x === 'string') {
				return 'String';
			}
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-property-descriptor-specification-type
		IsPropertyDescriptor: function IsPropertyDescriptor(Desc) {
			if (this.Type(Desc) !== 'Object') {
				return false;
			}
			var allowed = {
				'[[Configurable]]': true,
				'[[Enumerable]]': true,
				'[[Get]]': true,
				'[[Set]]': true,
				'[[Value]]': true,
				'[[Writable]]': true
			};
			// jscs:disable
			for (var key in Desc) { // eslint-disable-line
				if (has(Desc, key) && !allowed[key]) {
					return false;
				}
			}
			// jscs:enable
			var isData = has(Desc, '[[Value]]');
			var IsAccessor = has(Desc, '[[Get]]') || has(Desc, '[[Set]]');
			if (isData && IsAccessor) {
				throw new $TypeError('Property Descriptors may not be both accessor and data descriptors');
			}
			return true;
		},
	
		// https://ecma-international.org/ecma-262/5.1/#sec-8.10.1
		IsAccessorDescriptor: function IsAccessorDescriptor(Desc) {
			if (typeof Desc === 'undefined') {
				return false;
			}
	
			if (!this.IsPropertyDescriptor(Desc)) {
				throw new $TypeError('Desc must be a Property Descriptor');
			}
	
			if (!has(Desc, '[[Get]]') && !has(Desc, '[[Set]]')) {
				return false;
			}
	
			return true;
		},
	
		// https://ecma-international.org/ecma-262/5.1/#sec-8.10.2
		IsDataDescriptor: function IsDataDescriptor(Desc) {
			if (typeof Desc === 'undefined') {
				return false;
			}
	
			if (!this.IsPropertyDescriptor(Desc)) {
				throw new $TypeError('Desc must be a Property Descriptor');
			}
	
			if (!has(Desc, '[[Value]]') && !has(Desc, '[[Writable]]')) {
				return false;
			}
	
			return true;
		},
	
		// https://ecma-international.org/ecma-262/5.1/#sec-8.10.3
		IsGenericDescriptor: function IsGenericDescriptor(Desc) {
			if (typeof Desc === 'undefined') {
				return false;
			}
	
			if (!this.IsPropertyDescriptor(Desc)) {
				throw new $TypeError('Desc must be a Property Descriptor');
			}
	
			if (!this.IsAccessorDescriptor(Desc) && !this.IsDataDescriptor(Desc)) {
				return true;
			}
	
			return false;
		},
	
		// https://ecma-international.org/ecma-262/5.1/#sec-8.10.4
		FromPropertyDescriptor: function FromPropertyDescriptor(Desc) {
			if (typeof Desc === 'undefined') {
				return Desc;
			}
	
			if (!this.IsPropertyDescriptor(Desc)) {
				throw new $TypeError('Desc must be a Property Descriptor');
			}
	
			if (this.IsDataDescriptor(Desc)) {
				return {
					value: Desc['[[Value]]'],
					writable: !!Desc['[[Writable]]'],
					enumerable: !!Desc['[[Enumerable]]'],
					configurable: !!Desc['[[Configurable]]']
				};
			} else if (this.IsAccessorDescriptor(Desc)) {
				return {
					get: Desc['[[Get]]'],
					set: Desc['[[Set]]'],
					enumerable: !!Desc['[[Enumerable]]'],
					configurable: !!Desc['[[Configurable]]']
				};
			} else {
				throw new $TypeError('FromPropertyDescriptor must be called with a fully populated Property Descriptor');
			}
		},
	
		// https://ecma-international.org/ecma-262/5.1/#sec-8.10.5
		ToPropertyDescriptor: function ToPropertyDescriptor(Obj) {
			if (this.Type(Obj) !== 'Object') {
				throw new $TypeError('ToPropertyDescriptor requires an object');
			}
	
			var desc = {};
			if (has(Obj, 'enumerable')) {
				desc['[[Enumerable]]'] = this.ToBoolean(Obj.enumerable);
			}
			if (has(Obj, 'configurable')) {
				desc['[[Configurable]]'] = this.ToBoolean(Obj.configurable);
			}
			if (has(Obj, 'value')) {
				desc['[[Value]]'] = Obj.value;
			}
			if (has(Obj, 'writable')) {
				desc['[[Writable]]'] = this.ToBoolean(Obj.writable);
			}
			if (has(Obj, 'get')) {
				var getter = Obj.get;
				if (typeof getter !== 'undefined' && !this.IsCallable(getter)) {
					throw new TypeError('getter must be a function');
				}
				desc['[[Get]]'] = getter;
			}
			if (has(Obj, 'set')) {
				var setter = Obj.set;
				if (typeof setter !== 'undefined' && !this.IsCallable(setter)) {
					throw new $TypeError('setter must be a function');
				}
				desc['[[Set]]'] = setter;
			}
	
			if ((has(desc, '[[Get]]') || has(desc, '[[Set]]')) && (has(desc, '[[Value]]') || has(desc, '[[Writable]]'))) {
				throw new $TypeError('Invalid property descriptor. Cannot both specify accessors and a value or writable attribute');
			}
			return desc;
		}
	};
	
	module.exports = ES5;


/***/ },
/* 2445 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(698);


/***/ },
/* 2446 */
703,
/* 2447 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var hasSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol';
	
	var isPrimitive = __webpack_require__(703);
	var isCallable = __webpack_require__(447);
	var isDate = __webpack_require__(2812);
	var isSymbol = __webpack_require__(712);
	
	var ordinaryToPrimitive = function OrdinaryToPrimitive(O, hint) {
		if (typeof O === 'undefined' || O === null) {
			throw new TypeError('Cannot call method on ' + O);
		}
		if (typeof hint !== 'string' || (hint !== 'number' && hint !== 'string')) {
			throw new TypeError('hint must be "string" or "number"');
		}
		var methodNames = hint === 'string' ? ['toString', 'valueOf'] : ['valueOf', 'toString'];
		var method, result, i;
		for (i = 0; i < methodNames.length; ++i) {
			method = O[methodNames[i]];
			if (isCallable(method)) {
				result = method.call(O);
				if (isPrimitive(result)) {
					return result;
				}
			}
		}
		throw new TypeError('No default value');
	};
	
	var GetMethod = function GetMethod(O, P) {
		var func = O[P];
		if (func !== null && typeof func !== 'undefined') {
			if (!isCallable(func)) {
				throw new TypeError(func + ' returned for property ' + P + ' of object ' + O + ' is not a function');
			}
			return func;
		}
		return void 0;
	};
	
	// http://www.ecma-international.org/ecma-262/6.0/#sec-toprimitive
	module.exports = function ToPrimitive(input) {
		if (isPrimitive(input)) {
			return input;
		}
		var hint = 'default';
		if (arguments.length > 1) {
			if (arguments[1] === String) {
				hint = 'string';
			} else if (arguments[1] === Number) {
				hint = 'number';
			}
		}
	
		var exoticToPrim;
		if (hasSymbols) {
			if (Symbol.toPrimitive) {
				exoticToPrim = GetMethod(input, Symbol.toPrimitive);
			} else if (isSymbol(input)) {
				exoticToPrim = Symbol.prototype.valueOf;
			}
		}
		if (typeof exoticToPrim !== 'undefined') {
			var result = exoticToPrim.call(input, hint);
			if (isPrimitive(result)) {
				return result;
			}
			throw new TypeError('unable to convert exotic object to primitive');
		}
		if (hint === 'default' && (isDate(input) || isSymbol(input))) {
			hint = 'string';
		}
		return ordinaryToPrimitive(input, hint === 'default' ? 'number' : hint);
	};


/***/ },
/* 2448 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var toStr = Object.prototype.toString;
	
	var isPrimitive = __webpack_require__(703);
	
	var isCallable = __webpack_require__(447);
	
	// http://ecma-international.org/ecma-262/5.1/#sec-8.12.8
	var ES5internalSlots = {
		'[[DefaultValue]]': function (O) {
			var actualHint;
			if (arguments.length > 1) {
				actualHint = arguments[1];
			} else {
				actualHint = toStr.call(O) === '[object Date]' ? String : Number;
			}
	
			if (actualHint === String || actualHint === Number) {
				var methods = actualHint === String ? ['toString', 'valueOf'] : ['valueOf', 'toString'];
				var value, i;
				for (i = 0; i < methods.length; ++i) {
					if (isCallable(O[methods[i]])) {
						value = O[methods[i]]();
						if (isPrimitive(value)) {
							return value;
						}
					}
				}
				throw new TypeError('No default value');
			}
			throw new TypeError('invalid [[DefaultValue]] hint supplied');
		}
	};
	
	// http://ecma-international.org/ecma-262/5.1/#sec-9.1
	module.exports = function ToPrimitive(input) {
		if (isPrimitive(input)) {
			return input;
		}
		if (arguments.length > 1) {
			return ES5internalSlots['[[DefaultValue]]'](input, arguments[1]);
		}
		return ES5internalSlots['[[DefaultValue]]'](input);
	};


/***/ },
/* 2449 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(2447);


/***/ },
/* 2450 */,
/* 2451 */,
/* 2452 */,
/* 2453 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 2454 */
2453,
/* 2455 */
2453,
/* 2456 */
2453,
/* 2457 */
2453,
/* 2458 */
2453,
/* 2459 */
2453,
/* 2460 */
2453,
/* 2461 */
2453,
/* 2462 */
2453,
/* 2463 */
2453,
/* 2464 */
2453,
/* 2465 */
2453,
/* 2466 */
2453,
/* 2467 */
2453,
/* 2468 */
2453,
/* 2469 */
2453,
/* 2470 */
2453,
/* 2471 */
2453,
/* 2472 */
2453,
/* 2473 */
2453,
/* 2474 */
2453,
/* 2475 */
2453,
/* 2476 */
2453,
/* 2477 */
2453,
/* 2478 */
2453,
/* 2479 */
2453,
/* 2480 */
2453,
/* 2481 */
2453,
/* 2482 */
2453,
/* 2483 */
2453,
/* 2484 */
2453,
/* 2485 */
2453,
/* 2486 */
2453,
/* 2487 */
2453,
/* 2488 */
2453,
/* 2489 */
2453,
/* 2490 */
2453,
/* 2491 */
2453,
/* 2492 */
2453,
/* 2493 */
2453,
/* 2494 */
2453,
/* 2495 */
2453,
/* 2496 */
2453,
/* 2497 */
2453,
/* 2498 */
2453,
/* 2499 */
2453,
/* 2500 */
2453,
/* 2501 */
2453,
/* 2502 */
2453,
/* 2503 */
2453,
/* 2504 */
2453,
/* 2505 */
2453,
/* 2506 */
2453,
/* 2507 */
2453,
/* 2508 */
2453,
/* 2509 */
2453,
/* 2510 */
2453,
/* 2511 */
2453,
/* 2512 */
2453,
/* 2513 */
2453,
/* 2514 */
2453,
/* 2515 */
2453,
/* 2516 */
2453,
/* 2517 */
2453,
/* 2518 */
2453,
/* 2519 */
2453,
/* 2520 */
2453,
/* 2521 */
2453,
/* 2522 */
2453,
/* 2523 */
2453,
/* 2524 */
2453,
/* 2525 */
2453,
/* 2526 */
2453,
/* 2527 */
2453,
/* 2528 */
2453,
/* 2529 */
2453,
/* 2530 */
2453,
/* 2531 */
2453,
/* 2532 */
2453,
/* 2533 */
2453,
/* 2534 */
2453,
/* 2535 */
2453,
/* 2536 */
2453,
/* 2537 */
2453,
/* 2538 */
2453,
/* 2539 */
2453,
/* 2540 */
2453,
/* 2541 */
2453,
/* 2542 */
2453,
/* 2543 */
2453,
/* 2544 */
2453,
/* 2545 */
2453,
/* 2546 */
2453,
/* 2547 */
2453,
/* 2548 */
2453,
/* 2549 */
2453,
/* 2550 */
2453,
/* 2551 */
2453,
/* 2552 */
2453,
/* 2553 */
2453,
/* 2554 */
2453,
/* 2555 */
2453,
/* 2556 */
2453,
/* 2557 */
2453,
/* 2558 */
2453,
/* 2559 */
2453,
/* 2560 */
2453,
/* 2561 */
2453,
/* 2562 */
2453,
/* 2563 */
2453,
/* 2564 */
2453,
/* 2565 */
2453,
/* 2566 */
2453,
/* 2567 */
2453,
/* 2568 */
2453,
/* 2569 */
2453,
/* 2570 */
2453,
/* 2571 */
2453,
/* 2572 */
2453,
/* 2573 */
2453,
/* 2574 */
2453,
/* 2575 */
2453,
/* 2576 */
2453,
/* 2577 */
2453,
/* 2578 */
2453,
/* 2579 */
2453,
/* 2580 */
2453,
/* 2581 */
2453,
/* 2582 */
2453,
/* 2583 */
2453,
/* 2584 */
2453,
/* 2585 */
2453,
/* 2586 */
2453,
/* 2587 */
2453,
/* 2588 */
2453,
/* 2589 */
2453,
/* 2590 */
2453,
/* 2591 */
2453,
/* 2592 */
2453,
/* 2593 */
2453,
/* 2594 */
2453,
/* 2595 */
2453,
/* 2596 */
2453,
/* 2597 */
2453,
/* 2598 */
2453,
/* 2599 */
2453,
/* 2600 */
2453,
/* 2601 */
2453,
/* 2602 */
2453,
/* 2603 */
2453,
/* 2604 */
2453,
/* 2605 */
2453,
/* 2606 */
2453,
/* 2607 */
2453,
/* 2608 */
2453,
/* 2609 */
2453,
/* 2610 */
2453,
/* 2611 */
2453,
/* 2612 */
2453,
/* 2613 */
2453,
/* 2614 */
2453,
/* 2615 */
2453,
/* 2616 */
2453,
/* 2617 */
2453,
/* 2618 */
2453,
/* 2619 */
2453,
/* 2620 */
2453,
/* 2621 */
2453,
/* 2622 */
2453,
/* 2623 */
2453,
/* 2624 */
2453,
/* 2625 */
2453,
/* 2626 */
2453,
/* 2627 */
2453,
/* 2628 */
2453,
/* 2629 */
2453,
/* 2630 */
2453,
/* 2631 */
2453,
/* 2632 */
2453,
/* 2633 */
2453,
/* 2634 */
2453,
/* 2635 */
2453,
/* 2636 */
2453,
/* 2637 */
2453,
/* 2638 */
2453,
/* 2639 */
2453,
/* 2640 */
2453,
/* 2641 */
2453,
/* 2642 */
2453,
/* 2643 */
2453,
/* 2644 */
2453,
/* 2645 */
2453,
/* 2646 */
2453,
/* 2647 */
2453,
/* 2648 */
2453,
/* 2649 */
2453,
/* 2650 */
2453,
/* 2651 */
2453,
/* 2652 */
2453,
/* 2653 */
2453,
/* 2654 */
2453,
/* 2655 */
2453,
/* 2656 */
2453,
/* 2657 */
2453,
/* 2658 */
2453,
/* 2659 */
2453,
/* 2660 */
2453,
/* 2661 */
2453,
/* 2662 */
2453,
/* 2663 */
2453,
/* 2664 */
2453,
/* 2665 */
2453,
/* 2666 */
2453,
/* 2667 */
2453,
/* 2668 */
2453,
/* 2669 */
2453,
/* 2670 */
2453,
/* 2671 */
2453,
/* 2672 */
2453,
/* 2673 */
2453,
/* 2674 */
2453,
/* 2675 */
2453,
/* 2676 */
2453,
/* 2677 */
2453,
/* 2678 */
2453,
/* 2679 */
2453,
/* 2680 */
2453,
/* 2681 */
2453,
/* 2682 */
2453,
/* 2683 */
2453,
/* 2684 */
2453,
/* 2685 */
2453,
/* 2686 */
2453,
/* 2687 */
2453,
/* 2688 */
2453,
/* 2689 */
2453,
/* 2690 */
2453,
/* 2691 */
2453,
/* 2692 */
2453,
/* 2693 */
2453,
/* 2694 */
2453,
/* 2695 */
2453,
/* 2696 */
2453,
/* 2697 */
2453,
/* 2698 */
2453,
/* 2699 */
2453,
/* 2700 */
2453,
/* 2701 */
2453,
/* 2702 */
2453,
/* 2703 */
2453,
/* 2704 */
2453,
/* 2705 */
2453,
/* 2706 */
2453,
/* 2707 */
2453,
/* 2708 */
2453,
/* 2709 */
2453,
/* 2710 */
2453,
/* 2711 */
2453,
/* 2712 */
2453,
/* 2713 */
2453,
/* 2714 */
2453,
/* 2715 */
2453,
/* 2716 */
2453,
/* 2717 */
2453,
/* 2718 */
2453,
/* 2719 */
2453,
/* 2720 */
2453,
/* 2721 */
2453,
/* 2722 */
2453,
/* 2723 */
2453,
/* 2724 */
2453,
/* 2725 */
2453,
/* 2726 */
2453,
/* 2727 */
2453,
/* 2728 */
2453,
/* 2729 */
2453,
/* 2730 */
2453,
/* 2731 */
2453,
/* 2732 */
2453,
/* 2733 */
2453,
/* 2734 */
2453,
/* 2735 */
2453,
/* 2736 */
2453,
/* 2737 */
2453,
/* 2738 */
2453,
/* 2739 */
2453,
/* 2740 */
2453,
/* 2741 */
2453,
/* 2742 */
2453,
/* 2743 */
2453,
/* 2744 */
2453,
/* 2745 */
2453,
/* 2746 */
2453,
/* 2747 */
2453,
/* 2748 */
2453,
/* 2749 */
2453,
/* 2750 */
2453,
/* 2751 */
2453,
/* 2752 */
2453,
/* 2753 */
2453,
/* 2754 */
2453,
/* 2755 */
2453,
/* 2756 */
2453,
/* 2757 */
2453,
/* 2758 */
2453,
/* 2759 */
2453,
/* 2760 */
2453,
/* 2761 */
2453,
/* 2762 */
2453,
/* 2763 */
2453,
/* 2764 */
2453,
/* 2765 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(19);
	
	/**
	 * The CSSCore module specifies the API (and implements most of the methods)
	 * that should be used when dealing with the display of elements (via their
	 * CSS classes and visibility on screen. It is an API focused on mutating the
	 * display and not reading it as no logical state should be encoded in the
	 * display of elements.
	 */
	
	/* Slow implementation for browsers that don't natively support .matches() */
	function matchesSelector_SLOW(element, selector) {
	  var root = element;
	  while (root.parentNode) {
	    root = root.parentNode;
	  }
	
	  var all = root.querySelectorAll(selector);
	  return Array.prototype.indexOf.call(all, element) !== -1;
	}
	
	var CSSCore = {
	
	  /**
	   * Adds the class passed in to the element if it doesn't already have it.
	   *
	   * @param {DOMElement} element the element to set the class on
	   * @param {string} className the CSS className
	   * @return {DOMElement} the element passed in
	   */
	  addClass: function addClass(element, className) {
	    !!/\s/.test(className) ?  false ? invariant(false, 'CSSCore.addClass takes only a single class name. "%s" contains ' + 'multiple classes.', className) : invariant(false) : void 0;
	
	    if (className) {
	      if (element.classList) {
	        element.classList.add(className);
	      } else if (!CSSCore.hasClass(element, className)) {
	        element.className = element.className + ' ' + className;
	      }
	    }
	    return element;
	  },
	
	  /**
	   * Removes the class passed in from the element
	   *
	   * @param {DOMElement} element the element to set the class on
	   * @param {string} className the CSS className
	   * @return {DOMElement} the element passed in
	   */
	  removeClass: function removeClass(element, className) {
	    !!/\s/.test(className) ?  false ? invariant(false, 'CSSCore.removeClass takes only a single class name. "%s" contains ' + 'multiple classes.', className) : invariant(false) : void 0;
	
	    if (className) {
	      if (element.classList) {
	        element.classList.remove(className);
	      } else if (CSSCore.hasClass(element, className)) {
	        element.className = element.className.replace(new RegExp('(^|\\s)' + className + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ') // multiple spaces to one
	        .replace(/^\s*|\s*$/g, ''); // trim the ends
	      }
	    }
	    return element;
	  },
	
	  /**
	   * Helper to add or remove a class from an element based on a condition.
	   *
	   * @param {DOMElement} element the element to set the class on
	   * @param {string} className the CSS className
	   * @param {*} bool condition to whether to add or remove the class
	   * @return {DOMElement} the element passed in
	   */
	  conditionClass: function conditionClass(element, className, bool) {
	    return (bool ? CSSCore.addClass : CSSCore.removeClass)(element, className);
	  },
	
	  /**
	   * Tests whether the element has the class specified.
	   *
	   * @param {DOMNode|DOMWindow} element the element to check the class on
	   * @param {string} className the CSS className
	   * @return {boolean} true if the element has the class, false if not
	   */
	  hasClass: function hasClass(element, className) {
	    !!/\s/.test(className) ?  false ? invariant(false, 'CSS.hasClass takes only a single class name.') : invariant(false) : void 0;
	    if (element.classList) {
	      return !!className && element.classList.contains(className);
	    }
	    return (' ' + element.className + ' ').indexOf(' ' + className + ' ') > -1;
	  },
	
	  /**
	   * Tests whether the element matches the selector specified
	   *
	   * @param {DOMNode|DOMWindow} element the element that we are querying
	   * @param {string} selector the CSS selector
	   * @return {boolean} true if the element matches the selector, false if not
	   */
	  matchesSelector: function matchesSelector(element, selector) {
	    var matchesImpl = element.matches || element.webkitMatchesSelector || element.mozMatchesSelector || element.msMatchesSelector || function (s) {
	      return matchesSelector_SLOW(element, s);
	    };
	    return matchesImpl.call(element, selector);
	  }
	
	};
	
	module.exports = CSSCore;

/***/ },
/* 2766 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 2767 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(2766);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },
/* 2768 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(2776);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 2769 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(19);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 2770 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(53);
	
	var createArrayFromMixed = __webpack_require__(2769);
	var getMarkupWrap = __webpack_require__(2771);
	var invariant = __webpack_require__(19);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ },
/* 2771 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(53);
	
	var invariant = __webpack_require__(19);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ },
/* 2772 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 2773 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 2774 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(2773);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 2775 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 2776 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(2775);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 2777 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/**
	 * Allows extraction of a minified key. Let's the build system minify keys
	 * without losing the ability to dynamically use key strings as values
	 * themselves. Pass in an object with a single key/val pair and it will return
	 * you the string key of that single record. Suppose you want to grab the
	 * value for a key 'className' inside of an object. Key/val minification may
	 * have aliased that key to be 'xa12'. keyOf({className: null}) will return
	 * 'xa12' in that case. Resolve keys you want to use once at startup time, then
	 * reuse those resolutions.
	 */
	var keyOf = function keyOf(oneKeyObj) {
	  var key;
	  for (key in oneKeyObj) {
	    if (!oneKeyObj.hasOwnProperty(key)) {
	      continue;
	    }
	    return key;
	  }
	  return null;
	};
	
	module.exports = keyOf;

/***/ },
/* 2778 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 2779 */
/***/ function(module, exports) {

	'use strict';
	
	/* eslint no-invalid-this: 1 */
	
	var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
	var slice = Array.prototype.slice;
	var toStr = Object.prototype.toString;
	var funcType = '[object Function]';
	
	module.exports = function bind(that) {
	    var target = this;
	    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
	        throw new TypeError(ERROR_MESSAGE + target);
	    }
	    var args = slice.call(arguments, 1);
	
	    var bound;
	    var binder = function () {
	        if (this instanceof bound) {
	            var result = target.apply(
	                this,
	                args.concat(slice.call(arguments))
	            );
	            if (Object(result) === result) {
	                return result;
	            }
	            return this;
	        } else {
	            return target.apply(
	                that,
	                args.concat(slice.call(arguments))
	            );
	        }
	    };
	
	    var boundLength = Math.max(0, target.length - args.length);
	    var boundArgs = [];
	    for (var i = 0; i < boundLength; i++) {
	        boundArgs.push('$' + i);
	    }
	
	    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);
	
	    if (target.prototype) {
	        var Empty = function Empty() {};
	        Empty.prototype = target.prototype;
	        bound.prototype = new Empty();
	        Empty.prototype = null;
	    }
	
	    return bound;
	};


/***/ },
/* 2780 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var define = __webpack_require__(251);
	var isSymbol = __webpack_require__(712);
	
	var globalKey = '__ global cache key __';
	/* istanbul ignore else */
	// eslint-disable-next-line no-restricted-properties
	if (typeof Symbol === 'function' && isSymbol(Symbol('foo')) && typeof Symbol['for'] === 'function') {
		// eslint-disable-next-line no-restricted-properties
		globalKey = Symbol['for'](globalKey);
	}
	
	var trueThunk = function () {
		return true;
	};
	
	var ensureCache = function ensureCache() {
		if (!global[globalKey]) {
			var properties = {};
			properties[globalKey] = {};
			var predicates = {};
			predicates[globalKey] = trueThunk;
			define(global, properties, predicates);
		}
		return global[globalKey];
	};
	
	var cache = ensureCache();
	
	var isPrimitive = function isPrimitive(val) {
		return val === null || (typeof val !== 'object' && typeof val !== 'function');
	};
	
	var getPrimitiveKey = function getPrimitiveKey(val) {
		if (isSymbol(val)) {
			return Symbol.prototype.valueOf.call(val);
		}
		return typeof val + ' | ' + String(val);
	};
	
	var requirePrimitiveKey = function requirePrimitiveKey(val) {
		if (!isPrimitive(val)) {
			throw new TypeError('key must not be an object');
		}
	};
	
	var globalCache = {
		clear: function clear() {
			delete global[globalKey];
			cache = ensureCache();
		},
	
		'delete': function deleteKey(key) {
			requirePrimitiveKey(key);
			delete cache[getPrimitiveKey(key)];
			return !globalCache.has(key);
		},
	
		get: function get(key) {
			requirePrimitiveKey(key);
			return cache[getPrimitiveKey(key)];
		},
	
		has: function has(key) {
			requirePrimitiveKey(key);
			return getPrimitiveKey(key) in cache;
		},
	
		set: function set(key, value) {
			requirePrimitiveKey(key);
			var primitiveKey = getPrimitiveKey(key);
			var props = {};
			props[primitiveKey] = value;
			var predicates = {};
			predicates[primitiveKey] = trueThunk;
			define(cache, props, predicates);
			return globalCache.has(key);
		},
	
		setIfMissingThenGet: function setIfMissingThenGet(key, valueThunk) {
			if (globalCache.has(key)) {
				return globalCache.get(key);
			}
			var item = valueThunk();
			globalCache.set(key, item);
			return item;
		}
	};
	
	module.exports = globalCache;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 2781 */,
/* 2782 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var origSymbol = global.Symbol;
	var hasSymbolSham = __webpack_require__(2783);
	
	module.exports = function hasNativeSymbols() {
		if (typeof origSymbol !== 'function') { return false; }
		if (typeof Symbol !== 'function') { return false; }
		if (typeof origSymbol('foo') !== 'symbol') { return false; }
		if (typeof Symbol('bar') !== 'symbol') { return false; }
	
		return hasSymbolSham();
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 2783 */
/***/ function(module, exports) {

	'use strict';
	
	/* eslint complexity: [2, 17], max-statements: [2, 33] */
	module.exports = function hasSymbols() {
		if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
		if (typeof Symbol.iterator === 'symbol') { return true; }
	
		var obj = {};
		var sym = Symbol('test');
		var symObj = Object(sym);
		if (typeof sym === 'string') { return false; }
	
		if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
		if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }
	
		// temp disabled per https://github.com/ljharb/object.assign/issues/17
		// if (sym instanceof Symbol) { return false; }
		// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
		// if (!(symObj instanceof Symbol)) { return false; }
	
		// if (typeof Symbol.prototype.toString !== 'function') { return false; }
		// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
	
		var symVal = 42;
		obj[sym] = symVal;
		for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax
		if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }
	
		if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }
	
		var syms = Object.getOwnPropertySymbols(obj);
		if (syms.length !== 1 || syms[0] !== sym) { return false; }
	
		if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }
	
		if (typeof Object.getOwnPropertyDescriptor === 'function') {
			var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
			if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
		}
	
		return true;
	};


/***/ },
/* 2784 */,
/* 2785 */,
/* 2786 */,
/* 2787 */,
/* 2788 */,
/* 2789 */,
/* 2790 */
/***/ function(module, exports, __webpack_require__) {

	
	'use strict';
	
	module.exports = __webpack_require__(2793);


/***/ },
/* 2791 */
/***/ function(module, exports) {

	/*
	 * File: iframeResizer.contentWindow.js
	 * Desc: Include this file in any page being loaded into an iframe
	 *       to force the iframe to resize to the content size.
	 * Requires: iframeResizer.js on host page.
	 * Doc: https://github.com/davidjbradshaw/iframe-resizer
	 * Author: David J. Bradshaw - dave@bradshaw.net
	 * Contributor: Jure Mav - jure.mav@gmail.com
	 * Contributor: Ian Caunce - ian@hallnet.co.uk
	 */
	
	
	;(function(undefined) {
		'use strict';
	
		if(typeof window === 'undefined') return; // don't run for server side render
	
		var
			autoResize            = true,
			base                  = 10,
			bodyBackground        = '',
			bodyMargin            = 0,
			bodyMarginStr         = '',
			bodyObserver          = null,
			bodyPadding           = '',
			calculateWidth        = false,
			doubleEventList       = {'resize':1,'click':1},
			eventCancelTimer      = 128,
			firstRun              = true,
			height                = 1,
			heightCalcModeDefault = 'bodyOffset',
			heightCalcMode        = heightCalcModeDefault,
			initLock              = true,
			initMsg               = '',
			inPageLinks           = {},
			interval              = 32,
			intervalTimer         = null,
			logging               = false,
			msgID                 = '[iFrameSizer]',  //Must match host page msg ID
			msgIdLen              = msgID.length,
			myID                  = '',
			observer              = null,
			resetRequiredMethods  = {max:1,min:1,bodyScroll:1,documentElementScroll:1},
			resizeFrom            = 'child',
			sendPermit            = true,
			target                = window.parent,
			targetOriginDefault   = '*',
			tolerance             = 0,
			triggerLocked         = false,
			triggerLockedTimer    = null,
			throttledTimer        = 16,
			width                 = 1,
			widthCalcModeDefault  = 'scroll',
			widthCalcMode         = widthCalcModeDefault,
			win                   = window,
			messageCallback       = function(){ warn('MessageCallback function not defined'); },
			readyCallback         = function(){},
			pageInfoCallback      = function(){},
			customCalcMethods     = {
				height: function(){
					warn('Custom height calculation function not defined');
					return document.documentElement.offsetHeight;
				},
				width: function(){
					warn('Custom width calculation function not defined');
					return document.body.scrollWidth;
				}
			},
			eventHandlersByName   = {};
	
	
		function addEventListener(el,evt,func){
			/* istanbul ignore else */ // Not testable in phantonJS
			if ('addEventListener' in window){
				el.addEventListener(evt,func, false);
			} else if ('attachEvent' in window){ //IE
				el.attachEvent('on'+evt,func);
			}
		}
	
		function removeEventListener(el,evt,func){
			/* istanbul ignore else */ // Not testable in phantonJS
			if ('removeEventListener' in window){
				el.removeEventListener(evt,func, false);
			} else if ('detachEvent' in window){ //IE
				el.detachEvent('on'+evt,func);
			}
		}
	
		function capitalizeFirstLetter(string) {
			return string.charAt(0).toUpperCase() + string.slice(1);
		}
	
		//Based on underscore.js
		function throttle(func) {
			var
				context, args, result,
				timeout = null,
				previous = 0,
				later = function() {
					previous = getNow();
					timeout = null;
					result = func.apply(context, args);
					if (!timeout) {
						context = args = null;
					}
				};
	
			return function() {
				var now = getNow();
	
				if (!previous) {
					previous = now;
				}
	
				var remaining = throttledTimer - (now - previous);
	
				context = this;
				args = arguments;
	
				if (remaining <= 0 || remaining > throttledTimer) {
					if (timeout) {
						clearTimeout(timeout);
						timeout = null;
					}
	
					previous = now;
					result = func.apply(context, args);
	
					if (!timeout) {
						context = args = null;
					}
	
				} else if (!timeout) {
					timeout = setTimeout(later, remaining);
				}
	
				return result;
			};
		}
	
		var getNow = Date.now || function() {
			/* istanbul ignore next */ // Not testable in PhantonJS
			return new Date().getTime();
		};
	
		function formatLogMsg(msg){
			return msgID + '[' + myID + ']' + ' ' + msg;
		}
	
		function log(msg){
			if (logging && ('object' === typeof window.console)){
				console.log(formatLogMsg(msg));
			}
		}
	
		function warn(msg){
			if ('object' === typeof window.console){
				console.warn(formatLogMsg(msg));
			}
		}
	
	
		function init(){
			readDataFromParent();
			log('Initialising iFrame ('+location.href+')');
			readDataFromPage();
			setMargin();
			setBodyStyle('background',bodyBackground);
			setBodyStyle('padding',bodyPadding);
			injectClearFixIntoBodyElement();
			checkHeightMode();
			checkWidthMode();
			stopInfiniteResizingOfIFrame();
			setupPublicMethods();
			startEventListeners();
			inPageLinks = setupInPageLinks();
			sendSize('init','Init message from host page');
			readyCallback();
		}
	
		function readDataFromParent(){
	
			function strBool(str){
				return 'true' === str ? true : false;
			}
	
			var data = initMsg.substr(msgIdLen).split(':');
	
			myID               = data[0];
			bodyMargin         = (undefined !== data[1]) ? Number(data[1])   : bodyMargin; //For V1 compatibility
			calculateWidth     = (undefined !== data[2]) ? strBool(data[2])  : calculateWidth;
			logging            = (undefined !== data[3]) ? strBool(data[3])  : logging;
			interval           = (undefined !== data[4]) ? Number(data[4])   : interval;
			autoResize         = (undefined !== data[6]) ? strBool(data[6])  : autoResize;
			bodyMarginStr      = data[7];
			heightCalcMode     = (undefined !== data[8]) ? data[8]           : heightCalcMode;
			bodyBackground     = data[9];
			bodyPadding        = data[10];
			tolerance          = (undefined !== data[11]) ? Number(data[11]) : tolerance;
			inPageLinks.enable = (undefined !== data[12]) ? strBool(data[12]): false;
			resizeFrom         = (undefined !== data[13]) ? data[13]         : resizeFrom;
			widthCalcMode      = (undefined !== data[14]) ? data[14]         : widthCalcMode;
		}
	
		function readDataFromPage(){
			function readData(){
				var data = window.iFrameResizer;
	
				log('Reading data from page: ' + JSON.stringify(data));
	
				messageCallback     = ('messageCallback'         in data) ? data.messageCallback         : messageCallback;
				readyCallback       = ('readyCallback'           in data) ? data.readyCallback           : readyCallback;
				targetOriginDefault = ('targetOrigin'            in data) ? data.targetOrigin            : targetOriginDefault;
				heightCalcMode      = ('heightCalculationMethod' in data) ? data.heightCalculationMethod : heightCalcMode;
				widthCalcMode       = ('widthCalculationMethod'  in data) ? data.widthCalculationMethod  : widthCalcMode;
			}
	
			function setupCustomCalcMethods(calcMode, calcFunc){
				if ('function' === typeof calcMode) {
					log('Setup custom ' + calcFunc + 'CalcMethod');
					customCalcMethods[calcFunc] = calcMode;
					calcMode = 'custom';
				}
	
				return calcMode;
			}
	
			if(('iFrameResizer' in window) && (Object === window.iFrameResizer.constructor)) {
				readData();
				heightCalcMode = setupCustomCalcMethods(heightCalcMode, 'height');
				widthCalcMode  = setupCustomCalcMethods(widthCalcMode,  'width');
			}
	
			log('TargetOrigin for parent set to: ' + targetOriginDefault);
		}
	
	
		function chkCSS(attr,value){
			if (-1 !== value.indexOf('-')){
				warn('Negative CSS value ignored for '+attr);
				value='';
			}
			return value;
		}
	
		function setBodyStyle(attr,value){
			if ((undefined !== value) && ('' !== value) && ('null' !== value)){
				document.body.style[attr] = value;
				log('Body '+attr+' set to "'+value+'"');
			}
		}
	
		function setMargin(){
			//If called via V1 script, convert bodyMargin from int to str
			if (undefined === bodyMarginStr){
				bodyMarginStr = bodyMargin+'px';
			}
	
			setBodyStyle('margin',chkCSS('margin',bodyMarginStr));
		}
	
		function stopInfiniteResizingOfIFrame(){
			document.documentElement.style.height = '';
			document.body.style.height = '';
			log('HTML & body height set to "auto"');
		}
	
	
		function manageTriggerEvent(options){
	
			var listener = {
				add:    function(eventName){
					function handleEvent(){
						sendSize(options.eventName,options.eventType);
					}
	
					eventHandlersByName[eventName] = handleEvent;
	
					addEventListener(window,eventName,handleEvent);
				},
				remove: function(eventName){
					var handleEvent = eventHandlersByName[eventName];
					delete eventHandlersByName[eventName];
	
					removeEventListener(window,eventName,handleEvent);
				}
			};
	
			if(options.eventNames && Array.prototype.map){
				options.eventName = options.eventNames[0];
				options.eventNames.map(listener[options.method]);
			} else {
				listener[options.method](options.eventName);
			}
	
			log(capitalizeFirstLetter(options.method) + ' event listener: ' + options.eventType);
		}
	
		function manageEventListeners(method){
			manageTriggerEvent({method:method, eventType: 'Animation Start',           eventNames: ['animationstart','webkitAnimationStart'] });
			manageTriggerEvent({method:method, eventType: 'Animation Iteration',       eventNames: ['animationiteration','webkitAnimationIteration'] });
			manageTriggerEvent({method:method, eventType: 'Animation End',             eventNames: ['animationend','webkitAnimationEnd'] });
			manageTriggerEvent({method:method, eventType: 'Input',                     eventName:  'input' });
			manageTriggerEvent({method:method, eventType: 'Mouse Up',                  eventName:  'mouseup' });
			manageTriggerEvent({method:method, eventType: 'Mouse Down',                eventName:  'mousedown' });
			manageTriggerEvent({method:method, eventType: 'Orientation Change',        eventName:  'orientationchange' });
			manageTriggerEvent({method:method, eventType: 'Print',                     eventName:  ['afterprint', 'beforeprint'] });
			manageTriggerEvent({method:method, eventType: 'Ready State Change',        eventName:  'readystatechange' });
			manageTriggerEvent({method:method, eventType: 'Touch Start',               eventName:  'touchstart' });
			manageTriggerEvent({method:method, eventType: 'Touch End',                 eventName:  'touchend' });
			manageTriggerEvent({method:method, eventType: 'Touch Cancel',              eventName:  'touchcancel' });
			manageTriggerEvent({method:method, eventType: 'Transition Start',          eventNames: ['transitionstart','webkitTransitionStart','MSTransitionStart','oTransitionStart','otransitionstart'] });
			manageTriggerEvent({method:method, eventType: 'Transition Iteration',      eventNames: ['transitioniteration','webkitTransitionIteration','MSTransitionIteration','oTransitionIteration','otransitioniteration'] });
			manageTriggerEvent({method:method, eventType: 'Transition End',            eventNames: ['transitionend','webkitTransitionEnd','MSTransitionEnd','oTransitionEnd','otransitionend'] });
			if('child' === resizeFrom){
				manageTriggerEvent({method:method, eventType: 'IFrame Resized',        eventName:  'resize' });
			}
		}
	
		function checkCalcMode(calcMode,calcModeDefault,modes,type){
			if (calcModeDefault !== calcMode){
				if (!(calcMode in modes)){
					warn(calcMode + ' is not a valid option for '+type+'CalculationMethod.');
					calcMode=calcModeDefault;
				}
				log(type+' calculation method set to "'+calcMode+'"');
			}
	
			return calcMode;
		}
	
		function checkHeightMode(){
			heightCalcMode = checkCalcMode(heightCalcMode,heightCalcModeDefault,getHeight,'height');
		}
	
		function checkWidthMode(){
			widthCalcMode = checkCalcMode(widthCalcMode,widthCalcModeDefault,getWidth,'width');
		}
	
		function startEventListeners(){
			if ( true === autoResize ) {
				manageEventListeners('add');
				setupMutationObserver();
			}
			else {
				log('Auto Resize disabled');
			}
		}
	
		function stopMsgsToParent(){
			log('Disable outgoing messages');
			sendPermit = false;
		}
	
		function removeMsgListener(){
			log('Remove event listener: Message');
			removeEventListener(window, 'message', receiver);
		}
	
		function disconnectMutationObserver(){
			if (null !== bodyObserver){
				/* istanbul ignore next */ // Not testable in PhantonJS
				bodyObserver.disconnect();
			}
		}
	
		function stopEventListeners(){
			manageEventListeners('remove');
			disconnectMutationObserver();
			clearInterval(intervalTimer);
		}
	
		function teardown(){
			stopMsgsToParent();
			removeMsgListener();
			if (true === autoResize) stopEventListeners();
		}
	
		function injectClearFixIntoBodyElement(){
			var clearFix = document.createElement('div');
			clearFix.style.clear   = 'both';
			clearFix.style.display = 'block'; //Guard against this having been globally redefined in CSS.
			document.body.appendChild(clearFix);
		}
	
		function setupInPageLinks(){
	
			function getPagePosition (){
				return {
					x: (window.pageXOffset !== undefined) ? window.pageXOffset : document.documentElement.scrollLeft,
					y: (window.pageYOffset !== undefined) ? window.pageYOffset : document.documentElement.scrollTop
				};
			}
	
			function getElementPosition(el){
				var
					elPosition   = el.getBoundingClientRect(),
					pagePosition = getPagePosition();
	
				return {
					x: parseInt(elPosition.left,10) + parseInt(pagePosition.x,10),
					y: parseInt(elPosition.top,10)  + parseInt(pagePosition.y,10)
				};
			}
	
			function findTarget(location){
				function jumpToTarget(target){
					var jumpPosition = getElementPosition(target);
	
					log('Moving to in page link (#'+hash+') at x: '+jumpPosition.x+' y: '+jumpPosition.y);
					sendMsg(jumpPosition.y, jumpPosition.x, 'scrollToOffset'); // X&Y reversed at sendMsg uses height/width
				}
	
				var
					hash     = location.split('#')[1] || location, //Remove # if present
					hashData = decodeURIComponent(hash),
					target   = document.getElementById(hashData) || document.getElementsByName(hashData)[0];
	
				if (undefined !== target){
					jumpToTarget(target);
				} else {
					log('In page link (#' + hash + ') not found in iFrame, so sending to parent');
					sendMsg(0,0,'inPageLink','#'+hash);
				}
			}
	
			function checkLocationHash(){
				if ('' !== location.hash && '#' !== location.hash){
					findTarget(location.href);
				}
			}
	
			function bindAnchors(){
				function setupLink(el){
					function linkClicked(e){
						e.preventDefault();
	
						/*jshint validthis:true */
						findTarget(this.getAttribute('href'));
					}
	
					if ('#' !== el.getAttribute('href')){
						addEventListener(el,'click',linkClicked);
					}
				}
	
				Array.prototype.forEach.call( document.querySelectorAll( 'a[href^="#"]' ), setupLink );
			}
	
			function bindLocationHash(){
				addEventListener(window,'hashchange',checkLocationHash);
			}
	
			function initCheck(){ //check if page loaded with location hash after init resize
				setTimeout(checkLocationHash,eventCancelTimer);
			}
	
			function enableInPageLinks(){
				/* istanbul ignore else */ // Not testable in phantonJS
				if(Array.prototype.forEach && document.querySelectorAll){
					log('Setting up location.hash handlers');
					bindAnchors();
					bindLocationHash();
					initCheck();
				} else {
					warn('In page linking not fully supported in this browser! (See README.md for IE8 workaround)');
				}
			}
	
			if(inPageLinks.enable){
				enableInPageLinks();
			} else {
				log('In page linking not enabled');
			}
	
			return {
				findTarget:findTarget
			};
		}
	
		function setupPublicMethods(){
			log('Enable public methods');
	
			win.parentIFrame = {
	
				autoResize: function autoResizeF(resize){
					if (true === resize && false === autoResize) {
						autoResize=true;
						startEventListeners();
						//sendSize('autoResize','Auto Resize enabled');
					} else if (false === resize && true === autoResize) {
						autoResize=false;
						stopEventListeners();
					}
	
					return autoResize;
				},
	
				close: function closeF(){
					sendMsg(0,0,'close');
					teardown();
				},
	
				getId: function getIdF(){
					return myID;
				},
	
				getPageInfo: function getPageInfoF(callback){
					if ('function' === typeof callback){
						pageInfoCallback = callback;
						sendMsg(0,0,'pageInfo');
					} else {
						pageInfoCallback = function(){};
						sendMsg(0,0,'pageInfoStop');
					}
				},
	
				moveToAnchor: function moveToAnchorF(hash){
					inPageLinks.findTarget(hash);
				},
	
				reset: function resetF(){
					resetIFrame('parentIFrame.reset');
				},
	
				scrollTo: function scrollToF(x,y){
					sendMsg(y,x,'scrollTo'); // X&Y reversed at sendMsg uses height/width
				},
	
				scrollToOffset: function scrollToF(x,y){
					sendMsg(y,x,'scrollToOffset'); // X&Y reversed at sendMsg uses height/width
				},
	
				sendMessage: function sendMessageF(msg,targetOrigin){
					sendMsg(0,0,'message',JSON.stringify(msg),targetOrigin);
				},
	
				setHeightCalculationMethod: function setHeightCalculationMethodF(heightCalculationMethod){
					heightCalcMode = heightCalculationMethod;
					checkHeightMode();
				},
	
				setWidthCalculationMethod: function setWidthCalculationMethodF(widthCalculationMethod){
					widthCalcMode = widthCalculationMethod;
					checkWidthMode();
				},
	
				setTargetOrigin: function setTargetOriginF(targetOrigin){
					log('Set targetOrigin: '+targetOrigin);
					targetOriginDefault = targetOrigin;
				},
	
				size: function sizeF(customHeight, customWidth){
					var valString = ''+(customHeight?customHeight:'')+(customWidth?','+customWidth:'');
					//lockTrigger();
					sendSize('size','parentIFrame.size('+valString+')', customHeight, customWidth);
				}
			};
		}
	
		function initInterval(){
			if ( 0 !== interval ){
				log('setInterval: '+interval+'ms');
				intervalTimer = setInterval(function(){
					sendSize('interval','setInterval: '+interval);
				},Math.abs(interval));
			}
		}
	
		/* istanbul ignore next */  //Not testable in PhantomJS
		function setupBodyMutationObserver(){
			function addImageLoadListners(mutation) {
				function addImageLoadListener(element){
					if (false === element.complete) {
						log('Attach listeners to ' + element.src);
						element.addEventListener('load', imageLoaded, false);
						element.addEventListener('error', imageError, false);
						elements.push(element);
					}
				}
	
				if (mutation.type === 'attributes' && mutation.attributeName === 'src'){
					addImageLoadListener(mutation.target);
				} else if (mutation.type === 'childList'){
					Array.prototype.forEach.call(
						mutation.target.querySelectorAll('img'),
						addImageLoadListener
					);
				}
			}
	
			function removeFromArray(element){
				elements.splice(elements.indexOf(element),1);
			}
	
			function removeImageLoadListener(element){
				log('Remove listeners from ' + element.src);
				element.removeEventListener('load', imageLoaded, false);
				element.removeEventListener('error', imageError, false);
				removeFromArray(element);
			}
	
			function imageEventTriggered(event,type,typeDesc){
				removeImageLoadListener(event.target);
				sendSize(type, typeDesc + ': ' + event.target.src, undefined, undefined);
			}
	
			function imageLoaded(event) {
				imageEventTriggered(event,'imageLoad','Image loaded');
			}
	
			function imageError(event) {
				imageEventTriggered(event,'imageLoadFailed','Image load failed');
			}
	
			function mutationObserved(mutations) {
				sendSize('mutationObserver','mutationObserver: ' + mutations[0].target + ' ' + mutations[0].type);
	
				//Deal with WebKit asyncing image loading when tags are injected into the page
				mutations.forEach(addImageLoadListners);
			}
	
			function createMutationObserver(){
				var
					target = document.querySelector('body'),
	
					config = {
						attributes            : true,
						attributeOldValue     : false,
						characterData         : true,
						characterDataOldValue : false,
						childList             : true,
						subtree               : true
					};
	
				observer = new MutationObserver(mutationObserved);
	
				log('Create body MutationObserver');
				observer.observe(target, config);
	
				return observer;
			}
	
			var
				elements         = [],
				MutationObserver = window.MutationObserver || window.WebKitMutationObserver,
				observer         = createMutationObserver();
	
			return {
				disconnect: function (){
					if ('disconnect' in observer){
						log('Disconnect body MutationObserver');
						observer.disconnect();
						elements.forEach(removeImageLoadListener);
					}
				}
			};
		}
	
		function setupMutationObserver(){
			var	forceIntervalTimer = 0 > interval;
	
			/* istanbul ignore if */ // Not testable in PhantomJS
			if (window.MutationObserver || window.WebKitMutationObserver){
				if (forceIntervalTimer) {
					initInterval();
				} else {
					bodyObserver = setupBodyMutationObserver();
				}
			} else {
				log('MutationObserver not supported in this browser!');
				initInterval();
			}
		}
	
	
		// document.documentElement.offsetHeight is not reliable, so
		// we have to jump through hoops to get a better value.
		function getComputedStyle(prop,el) {
			/* istanbul ignore next */  //Not testable in PhantomJS
			function convertUnitsToPxForIE8(value) {
				var PIXEL = /^\d+(px)?$/i;
	
				if (PIXEL.test(value)) {
					return parseInt(value,base);
				}
	
				var
					style = el.style.left,
					runtimeStyle = el.runtimeStyle.left;
	
				el.runtimeStyle.left = el.currentStyle.left;
				el.style.left = value || 0;
				value = el.style.pixelLeft;
				el.style.left = style;
				el.runtimeStyle.left = runtimeStyle;
	
				return value;
			}
	
			var retVal = 0;
			el =  el || document.body;
	
			/* istanbul ignore else */ // Not testable in phantonJS
			if (('defaultView' in document) && ('getComputedStyle' in document.defaultView)) {
				retVal = document.defaultView.getComputedStyle(el, null);
				retVal = (null !== retVal) ? retVal[prop] : 0;
			} else {//IE8
				retVal =  convertUnitsToPxForIE8(el.currentStyle[prop]);
			}
	
			return parseInt(retVal,base);
		}
	
		function chkEventThottle(timer){
			if(timer > throttledTimer/2){
				throttledTimer = 2*timer;
				log('Event throttle increased to ' + throttledTimer + 'ms');
			}
		}
	
		//Idea from https://github.com/guardian/iframe-messenger
		function getMaxElement(side,elements) {
			var
				elementsLength = elements.length,
				elVal          = 0,
				maxVal         = 0,
				Side           = capitalizeFirstLetter(side),
				timer          = getNow();
	
			for (var i = 0; i < elementsLength; i++) {
				elVal = elements[i].getBoundingClientRect()[side] + getComputedStyle('margin'+Side,elements[i]);
				if (elVal > maxVal) {
					maxVal = elVal;
				}
			}
	
			timer = getNow() - timer;
	
			log('Parsed '+elementsLength+' HTML elements');
			log('Element position calculated in ' + timer + 'ms');
	
			chkEventThottle(timer);
	
			return maxVal;
		}
	
		function getAllMeasurements(dimention){
			return [
				dimention.bodyOffset(),
				dimention.bodyScroll(),
				dimention.documentElementOffset(),
				dimention.documentElementScroll()
			];
		}
	
		function getTaggedElements(side,tag){
			function noTaggedElementsFound(){
				warn('No tagged elements ('+tag+') found on page');
				return document.querySelectorAll('body *');
			}
	
			var elements = document.querySelectorAll('['+tag+']');
	
			if (0 === elements.length) noTaggedElementsFound();
	
			return getMaxElement(side,elements);
		}
	
		function getAllElements(){
			return document.querySelectorAll('body *');
		}
	
		var
			getHeight = {
				bodyOffset: function getBodyOffsetHeight(){
					return  document.body.offsetHeight + getComputedStyle('marginTop') + getComputedStyle('marginBottom');
				},
	
				offset: function(){
					return getHeight.bodyOffset(); //Backwards compatability
				},
	
				bodyScroll: function getBodyScrollHeight(){
					return document.body.scrollHeight;
				},
	
				custom: function getCustomWidth(){
					return customCalcMethods.height();
				},
	
				documentElementOffset: function getDEOffsetHeight(){
					return document.documentElement.offsetHeight;
				},
	
				documentElementScroll: function getDEScrollHeight(){
					return document.documentElement.scrollHeight;
				},
	
				max: function getMaxHeight(){
					return Math.max.apply(null,getAllMeasurements(getHeight));
				},
	
				min: function getMinHeight(){
					return Math.min.apply(null,getAllMeasurements(getHeight));
				},
	
				grow: function growHeight(){
					return getHeight.max(); //Run max without the forced downsizing
				},
	
				lowestElement: function getBestHeight(){
					return Math.max(getHeight.bodyOffset(), getMaxElement('bottom',getAllElements()));
				},
	
				taggedElement: function getTaggedElementsHeight(){
					return getTaggedElements('bottom','data-iframe-height');
				}
			},
	
			getWidth = {
				bodyScroll: function getBodyScrollWidth(){
					return document.body.scrollWidth;
				},
	
				bodyOffset: function getBodyOffsetWidth(){
					return document.body.offsetWidth;
				},
	
				custom: function getCustomWidth(){
					return customCalcMethods.width();
				},
	
				documentElementScroll: function getDEScrollWidth(){
					return document.documentElement.scrollWidth;
				},
	
				documentElementOffset: function getDEOffsetWidth(){
					return document.documentElement.offsetWidth;
				},
	
				scroll: function getMaxWidth(){
					return Math.max(getWidth.bodyScroll(), getWidth.documentElementScroll());
				},
	
				max: function getMaxWidth(){
					return Math.max.apply(null,getAllMeasurements(getWidth));
				},
	
				min: function getMinWidth(){
					return Math.min.apply(null,getAllMeasurements(getWidth));
				},
	
				rightMostElement: function rightMostElement(){
					return getMaxElement('right', getAllElements());
				},
	
				taggedElement: function getTaggedElementsWidth(){
					return getTaggedElements('right', 'data-iframe-width');
				}
			};
	
	
		function sizeIFrame(triggerEvent, triggerEventDesc, customHeight, customWidth){
	
			function resizeIFrame(){
				height = currentHeight;
				width  = currentWidth;
	
				sendMsg(height,width,triggerEvent);
			}
	
			function isSizeChangeDetected(){
				function checkTolarance(a,b){
					var retVal = Math.abs(a-b) <= tolerance;
					return !retVal;
				}
	
				currentHeight = (undefined !== customHeight)  ? customHeight : getHeight[heightCalcMode]();
				currentWidth  = (undefined !== customWidth )  ? customWidth  : getWidth[widthCalcMode]();
	
				return	checkTolarance(height,currentHeight) || (calculateWidth && checkTolarance(width,currentWidth));
			}
	
			function isForceResizableEvent(){
				return !(triggerEvent in {'init':1,'interval':1,'size':1});
			}
	
			function isForceResizableCalcMode(){
				return (heightCalcMode in resetRequiredMethods) || (calculateWidth && widthCalcMode in resetRequiredMethods);
			}
	
			function logIgnored(){
				log('No change in size detected');
			}
	
			function checkDownSizing(){
				if (isForceResizableEvent() && isForceResizableCalcMode()){
					resetIFrame(triggerEventDesc);
				} else if (!(triggerEvent in {'interval':1})){
					logIgnored();
				}
			}
	
			var	currentHeight,currentWidth;
	
			if (isSizeChangeDetected() || 'init' === triggerEvent){
				lockTrigger();
				resizeIFrame();
			} else {
				checkDownSizing();
			}
		}
	
		var sizeIFrameThrottled = throttle(sizeIFrame);
	
		function sendSize(triggerEvent, triggerEventDesc, customHeight, customWidth){
			function recordTrigger(){
				if (!(triggerEvent in {'reset':1,'resetPage':1,'init':1})){
					log( 'Trigger event: ' + triggerEventDesc );
				}
			}
	
			function isDoubleFiredEvent(){
				return  triggerLocked && (triggerEvent in doubleEventList);
			}
	
			if (!isDoubleFiredEvent()){
				recordTrigger();
				sizeIFrameThrottled(triggerEvent, triggerEventDesc, customHeight, customWidth);
			} else {
				log('Trigger event cancelled: '+triggerEvent);
			}
		}
	
		function lockTrigger(){
			if (!triggerLocked){
				triggerLocked = true;
				log('Trigger event lock on');
			}
			clearTimeout(triggerLockedTimer);
			triggerLockedTimer = setTimeout(function(){
				triggerLocked = false;
				log('Trigger event lock off');
				log('--');
			},eventCancelTimer);
		}
	
		function triggerReset(triggerEvent){
			height = getHeight[heightCalcMode]();
			width  = getWidth[widthCalcMode]();
	
			sendMsg(height,width,triggerEvent);
		}
	
		function resetIFrame(triggerEventDesc){
			var hcm = heightCalcMode;
			heightCalcMode = heightCalcModeDefault;
	
			log('Reset trigger event: ' + triggerEventDesc);
			lockTrigger();
			triggerReset('reset');
	
			heightCalcMode = hcm;
		}
	
		function sendMsg(height,width,triggerEvent,msg,targetOrigin){
			function setTargetOrigin(){
				if (undefined === targetOrigin){
					targetOrigin = targetOriginDefault;
				} else {
					log('Message targetOrigin: '+targetOrigin);
				}
			}
	
			function sendToParent(){
				var
					size  = height + ':' + width,
					message = myID + ':' +  size + ':' + triggerEvent + (undefined !== msg ? ':' + msg : '');
	
				log('Sending message to host page (' + message + ')');
				target.postMessage( msgID + message, targetOrigin);
			}
	
			if(true === sendPermit){
				setTargetOrigin();
				sendToParent();
			}
		}
	
		function receiver(event) {
			var processRequestFromParent = {
				init: function initFromParent(){
					function fireInit(){
						initMsg = event.data;
						target  = event.source;
	
						init();
						firstRun = false;
						setTimeout(function(){ initLock = false;},eventCancelTimer);
					}
	
					if (document.body){
						fireInit();
					} else {
						log('Waiting for page ready');
						addEventListener(window,'readystatechange',processRequestFromParent.initFromParent);
					}
				},
	
				reset: function resetFromParent(){
					if (!initLock){
						log('Page size reset by host page');
						triggerReset('resetPage');
					} else {
						log('Page reset ignored by init');
					}
				},
	
				resize: function resizeFromParent(){
					sendSize('resizeParent','Parent window requested size check');
				},
	
				moveToAnchor: function moveToAnchorF(){
					inPageLinks.findTarget(getData());
				},
				inPageLink: function inPageLinkF() {this.moveToAnchor();}, //Backward compatability
	
				pageInfo: function pageInfoFromParent(){
					var msgBody = getData();
					log('PageInfoFromParent called from parent: ' + msgBody );
					pageInfoCallback(JSON.parse(msgBody));
					log(' --');
				},
	
				message: function messageFromParent(){
					var msgBody = getData();
	
					log('MessageCallback called from parent: ' + msgBody );
					messageCallback(JSON.parse(msgBody));
					log(' --');
				}
			};
	
			function isMessageForUs(){
				return msgID === (''+event.data).substr(0,msgIdLen); //''+ Protects against non-string messages
			}
	
			function getMessageType(){
				return event.data.split(']')[1].split(':')[0];
			}
	
			function getData(){
				return event.data.substr(event.data.indexOf(':')+1);
			}
	
			function isMiddleTier(){
				return !(typeof module !== 'undefined' && module.exports) && ('iFrameResize' in window);
			}
	
			function isInitMsg(){
				//Test if this message is from a child below us. This is an ugly test, however, updating
				//the message format would break backwards compatibity.
				return event.data.split(':')[2] in {'true':1,'false':1};
			}
	
			function callFromParent(){
				var messageType = getMessageType();
	
				if (messageType in processRequestFromParent){
					processRequestFromParent[messageType]();
				} else if (!isMiddleTier() && !isInitMsg()){
					warn('Unexpected message ('+event.data+')');
				}
			}
	
			function processMessage(){
				if (false === firstRun) {
					callFromParent();
				} else if (isInitMsg()) {
					processRequestFromParent.init();
				} else {
					log('Ignored message of type "' + getMessageType() + '". Received before initialization.');
				}
			}
	
			if (isMessageForUs()){
				processMessage();
			}
		}
	
		//Normally the parent kicks things off when it detects the iFrame has loaded.
		//If this script is async-loaded, then tell parent page to retry init.
		function chkLateLoaded(){
			if('loading' !== document.readyState){
				window.parent.postMessage('[iFrameResizerChild]Ready','*');
			}
		}
	
		addEventListener(window, 'message', receiver);
		chkLateLoaded();
	
		
	
	})();


/***/ },
/* 2792 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
	 * File: iframeResizer.js
	 * Desc: Force iframes to size to content.
	 * Requires: iframeResizer.contentWindow.js to be loaded into the target frame.
	 * Doc: https://github.com/davidjbradshaw/iframe-resizer
	 * Author: David J. Bradshaw - dave@bradshaw.net
	 * Contributor: Jure Mav - jure.mav@gmail.com
	 * Contributor: Reed Dadoune - reed@dadoune.com
	 */
	
	
	;(function(undefined) {
		'use strict';
	
		if(typeof window === 'undefined') return; // don't run for server side render
	
		var
			count                 = 0,
			logEnabled            = false,
			hiddenCheckEnabled    = false,
			msgHeader             = 'message',
			msgHeaderLen          = msgHeader.length,
			msgId                 = '[iFrameSizer]', //Must match iframe msg ID
			msgIdLen              = msgId.length,
			pagePosition          = null,
			requestAnimationFrame = window.requestAnimationFrame,
			resetRequiredMethods  = {max:1,scroll:1,bodyScroll:1,documentElementScroll:1},
			settings              = {},
			timer                 = null,
			logId                 = 'Host Page',
	
			defaults              = {
				autoResize                : true,
				bodyBackground            : null,
				bodyMargin                : null,
				bodyMarginV1              : 8,
				bodyPadding               : null,
				checkOrigin               : true,
				inPageLinks               : false,
				enablePublicMethods       : true,
				heightCalculationMethod   : 'bodyOffset',
				id                        : 'iFrameResizer',
				interval                  : 32,
				log                       : false,
				maxHeight                 : Infinity,
				maxWidth                  : Infinity,
				minHeight                 : 0,
				minWidth                  : 0,
				resizeFrom                : 'parent',
				scrolling                 : false,
				sizeHeight                : true,
				sizeWidth                 : false,
				warningTimeout            : 5000,
				tolerance                 : 0,
				widthCalculationMethod    : 'scroll',
				closedCallback            : function(){},
				initCallback              : function(){},
				messageCallback           : function(){warn('MessageCallback function not defined');},
				resizedCallback           : function(){},
				scrollCallback            : function(){return true;}
			};
	
		function addEventListener(obj,evt,func){
			/* istanbul ignore else */ // Not testable in PhantonJS
			if ('addEventListener' in window){
				obj.addEventListener(evt,func, false);
			} else if ('attachEvent' in window){//IE
				obj.attachEvent('on'+evt,func);
			}
		}
	
		function removeEventListener(el,evt,func){
			/* istanbul ignore else */ // Not testable in phantonJS
			if ('removeEventListener' in window){
				el.removeEventListener(evt,func, false);
			} else if ('detachEvent' in window){ //IE
				el.detachEvent('on'+evt,func);
			}
		}
	
		function setupRequestAnimationFrame(){
			var
				vendors = ['moz', 'webkit', 'o', 'ms'],
				x;
	
			// Remove vendor prefixing if prefixed and break early if not
			for (x = 0; x < vendors.length && !requestAnimationFrame; x += 1) {
				requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
			}
	
			if (!(requestAnimationFrame)){
				log('setup','RequestAnimationFrame not supported');
			}
		}
	
		function getMyID(iframeId){
			var retStr = 'Host page: '+iframeId;
	
			if (window.top !== window.self){
				if (window.parentIFrame && window.parentIFrame.getId){
					retStr = window.parentIFrame.getId()+': '+iframeId;
				} else {
					retStr = 'Nested host page: '+iframeId;
				}
			}
	
			return retStr;
		}
	
		function formatLogHeader(iframeId){
			return msgId + '[' + getMyID(iframeId) + ']';
		}
	
		function isLogEnabled(iframeId){
			return settings[iframeId] ? settings[iframeId].log : logEnabled;
		}
	
		function log(iframeId,msg){
			output('log',iframeId,msg,isLogEnabled(iframeId));
		}
	
		function info(iframeId,msg){
			output('info',iframeId,msg,isLogEnabled(iframeId));
		}
	
		function warn(iframeId,msg){
			output('warn',iframeId,msg,true);
		}
	
		function output(type,iframeId,msg,enabled){
			if (true === enabled && 'object' === typeof window.console){
				console[type](formatLogHeader(iframeId),msg);
			}
		}
	
		function iFrameListener(event){
			function resizeIFrame(){
				function resize(){
					setSize(messageData);
					setPagePosition(iframeId);
					callback('resizedCallback',messageData);
				}
	
				ensureInRange('Height');
				ensureInRange('Width');
	
				syncResize(resize,messageData,'init');
			}
	
			function processMsg(){
				var data = msg.substr(msgIdLen).split(':');
	
				return {
					iframe: settings[data[0]].iframe,
					id:     data[0],
					height: data[1],
					width:  data[2],
					type:   data[3]
				};
			}
	
			function ensureInRange(Dimension){
				var
					max  = Number(settings[iframeId]['max' + Dimension]),
					min  = Number(settings[iframeId]['min' + Dimension]),
					dimension = Dimension.toLowerCase(),
					size = Number(messageData[dimension]);
	
				log(iframeId,'Checking ' + dimension + ' is in range ' + min + '-' + max);
	
				if (size<min) {
					size=min;
					log(iframeId,'Set ' + dimension + ' to min value');
				}
	
				if (size>max) {
					size=max;
					log(iframeId,'Set ' + dimension + ' to max value');
				}
	
				messageData[dimension] = '' + size;
			}
	
	
			function isMessageFromIFrame(){
				function checkAllowedOrigin(){
					function checkList(){
						var
							i = 0,
							retCode = false;
	
						log(iframeId,'Checking connection is from allowed list of origins: ' + checkOrigin);
	
						for (; i < checkOrigin.length; i++) {
							if (checkOrigin[i] === origin) {
								retCode = true;
								break;
							}
						}
						return retCode;
					}
	
					function checkSingle(){
						var remoteHost  = settings[iframeId].remoteHost;
						log(iframeId,'Checking connection is from: '+remoteHost);
						return origin === remoteHost;
					}
	
					return checkOrigin.constructor === Array ? checkList() : checkSingle();
				}
	
				var
					origin      = event.origin,
					checkOrigin = settings[iframeId].checkOrigin;
	
				if (checkOrigin && (''+origin !== 'null') && !checkAllowedOrigin()) {
					throw new Error(
						'Unexpected message received from: ' + origin +
						' for ' + messageData.iframe.id +
						'. Message was: ' + event.data +
						'. This error can be disabled by setting the checkOrigin: false option or by providing of array of trusted domains.'
					);
				}
	
				return true;
			}
	
			function isMessageForUs(){
				return msgId === (('' + msg).substr(0,msgIdLen)) && (msg.substr(msgIdLen).split(':')[0] in settings); //''+Protects against non-string msg
			}
	
			function isMessageFromMetaParent(){
				//Test if this message is from a parent above us. This is an ugly test, however, updating
				//the message format would break backwards compatibity.
				var retCode = messageData.type in {'true':1,'false':1,'undefined':1};
	
				if (retCode){
					log(iframeId,'Ignoring init message from meta parent page');
				}
	
				return retCode;
			}
	
			function getMsgBody(offset){
				return msg.substr(msg.indexOf(':')+msgHeaderLen+offset);
			}
	
			function forwardMsgFromIFrame(msgBody){
				log(iframeId,'MessageCallback passed: {iframe: '+ messageData.iframe.id + ', message: ' + msgBody + '}');
				callback('messageCallback',{
					iframe: messageData.iframe,
					message: JSON.parse(msgBody)
				});
				log(iframeId,'--');
			}
	
			function getPageInfo(){
				var
					bodyPosition   = document.body.getBoundingClientRect(),
					iFramePosition = messageData.iframe.getBoundingClientRect();
	
				return JSON.stringify({
					iframeHeight: iFramePosition.height,
					iframeWidth:  iFramePosition.width,
					clientHeight: Math.max(document.documentElement.clientHeight, window.innerHeight || 0),
					clientWidth:  Math.max(document.documentElement.clientWidth,  window.innerWidth  || 0),
					offsetTop:    parseInt(iFramePosition.top  - bodyPosition.top,  10),
					offsetLeft:   parseInt(iFramePosition.left - bodyPosition.left, 10),
					scrollTop:    window.pageYOffset,
					scrollLeft:   window.pageXOffset
				});
			}
	
			function sendPageInfoToIframe(iframe,iframeId){
				function debouncedTrigger(){
					trigger(
						'Send Page Info',
						'pageInfo:' + getPageInfo(),
						iframe,
						iframeId
					);
				}
	
				debouce(debouncedTrigger,32);
			}
	
	
			function startPageInfoMonitor(){
				function setListener(type,func){
					function sendPageInfo(){
						if (settings[id]){
							sendPageInfoToIframe(settings[id].iframe,id);
						} else {
							stop();
						}
					}
	
					['scroll','resize'].forEach(function(evt){
						log(id, type +  evt + ' listener for sendPageInfo');
						func(window,evt,sendPageInfo);
					});
				}
	
				function stop(){
					setListener('Remove ', removeEventListener);
				}
	
				function start(){
					setListener('Add ', addEventListener);
				}
	
				var id = iframeId; //Create locally scoped copy of iFrame ID
	
				start();
	
				settings[id].stopPageInfo = stop;
			}
	
			function stopPageInfoMonitor(){
				if (settings[iframeId] && settings[iframeId].stopPageInfo){
					settings[iframeId].stopPageInfo();
					delete settings[iframeId].stopPageInfo;
				}
			}
	
			function checkIFrameExists(){
				var retBool = true;
	
				if (null === messageData.iframe) {
					warn(iframeId,'IFrame ('+messageData.id+') not found');
					retBool = false;
				}
				return retBool;
			}
	
			function getElementPosition(target){
				var iFramePosition = target.getBoundingClientRect();
	
				getPagePosition(iframeId);
	
				return {
					x: Math.floor( Number(iFramePosition.left) + Number(pagePosition.x) ),
					y: Math.floor( Number(iFramePosition.top)  + Number(pagePosition.y) )
				};
			}
	
			function scrollRequestFromChild(addOffset){
				/* istanbul ignore next */  //Not testable in Karma
				function reposition(){
					pagePosition = newPosition;
					scrollTo();
					log(iframeId,'--');
				}
	
				function calcOffset(){
					return {
						x: Number(messageData.width) + offset.x,
						y: Number(messageData.height) + offset.y
					};
				}
	
				function scrollParent(){
					if (window.parentIFrame){
						window.parentIFrame['scrollTo'+(addOffset?'Offset':'')](newPosition.x,newPosition.y);
					} else {
						warn(iframeId,'Unable to scroll to requested position, window.parentIFrame not found');
					}
				}
	
				var
					offset = addOffset ? getElementPosition(messageData.iframe) : {x:0,y:0},
					newPosition = calcOffset();
	
				log(iframeId,'Reposition requested from iFrame (offset x:'+offset.x+' y:'+offset.y+')');
	
				if(window.top !== window.self){
					scrollParent();
				} else {
					reposition();
				}
			}
	
			function scrollTo(){
				if (false !== callback('scrollCallback',pagePosition)){
					setPagePosition(iframeId);
				} else {
					unsetPagePosition();
				}
			}
	
			function findTarget(location){
				function jumpToTarget(){
					var jumpPosition = getElementPosition(target);
	
					log(iframeId,'Moving to in page link (#'+hash+') at x: '+jumpPosition.x+' y: '+jumpPosition.y);
					pagePosition = {
						x: jumpPosition.x,
						y: jumpPosition.y
					};
	
					scrollTo();
					log(iframeId,'--');
				}
	
				function jumpToParent(){
					if (window.parentIFrame){
						window.parentIFrame.moveToAnchor(hash);
					} else {
						log(iframeId,'In page link #'+hash+' not found and window.parentIFrame not found');
					}
				}
	
				var
					hash     = location.split('#')[1] || '',
					hashData = decodeURIComponent(hash),
					target   = document.getElementById(hashData) || document.getElementsByName(hashData)[0];
	
				if (target){
					jumpToTarget();
				} else if(window.top!==window.self){
					jumpToParent();
				} else {
					log(iframeId,'In page link #'+hash+' not found');
				}
			}
	
			function callback(funcName,val){
				return chkCallback(iframeId,funcName,val);
			}
	
			function actionMsg(){
	
				if(settings[iframeId].firstRun) firstRun();
	
				switch(messageData.type){
				case 'close':
					closeIFrame(messageData.iframe);
					break;
				case 'message':
					forwardMsgFromIFrame(getMsgBody(6));
					break;
				case 'scrollTo':
					scrollRequestFromChild(false);
					break;
				case 'scrollToOffset':
					scrollRequestFromChild(true);
					break;
				case 'pageInfo':
					sendPageInfoToIframe(settings[iframeId].iframe,iframeId);
					startPageInfoMonitor();
					break;
				case 'pageInfoStop':
					stopPageInfoMonitor();
					break;
				case 'inPageLink':
					findTarget(getMsgBody(9));
					break;
				case 'reset':
					resetIFrame(messageData);
					break;
				case 'init':
					resizeIFrame();
					callback('initCallback',messageData.iframe);
					break;
				default:
					resizeIFrame();
				}
			}
	
			function hasSettings(iframeId){
				var retBool = true;
	
				if (!settings[iframeId]){
					retBool = false;
					warn(messageData.type + ' No settings for ' + iframeId + '. Message was: ' + msg);
				}
	
				return retBool;
			}
	
			function iFrameReadyMsgReceived(){
				for (var iframeId in settings){
					trigger('iFrame requested init',createOutgoingMsg(iframeId),document.getElementById(iframeId),iframeId);
				}
			}
	
			function firstRun() {
				settings[iframeId].firstRun = false;
			}
	
			function clearWarningTimeout() {
				clearTimeout(settings[iframeId].msgTimeout);
				settings[iframeId].warningTimeout = 0;
			}
	
			var
				msg = event.data,
				messageData = {},
				iframeId = null;
	
			if('[iFrameResizerChild]Ready' === msg){
				iFrameReadyMsgReceived();
			} else if (isMessageForUs()){
				messageData = processMsg();
				iframeId    = logId = messageData.id;
				settings[iframeId].loaded = true;
	
				if (!isMessageFromMetaParent() && hasSettings(iframeId)){
					log(iframeId,'Received: '+msg);
	
					if ( checkIFrameExists() && isMessageFromIFrame() ){
						actionMsg();
					}
				}
			} else {
				info(iframeId,'Ignored: '+msg);
			}
	
		}
	
	
		function chkCallback(iframeId,funcName,val){
			var
				func = null,
				retVal = null;
	
			if(settings[iframeId]){
				func = settings[iframeId][funcName];
	
				if( 'function' === typeof func){
					retVal = func(val);
				} else {
					throw new TypeError(funcName+' on iFrame['+iframeId+'] is not a function');
				}
			}
	
			return retVal;
		}
	
		function closeIFrame(iframe){
			var iframeId = iframe.id;
	
			log(iframeId,'Removing iFrame: '+iframeId);
			if (iframe.parentNode) { iframe.parentNode.removeChild(iframe); }
			chkCallback(iframeId,'closedCallback',iframeId);
			log(iframeId,'--');
			delete settings[iframeId];
		}
	
		function getPagePosition(iframeId){
			if(null === pagePosition){
				pagePosition = {
					x: (window.pageXOffset !== undefined) ? window.pageXOffset : document.documentElement.scrollLeft,
					y: (window.pageYOffset !== undefined) ? window.pageYOffset : document.documentElement.scrollTop
				};
				log(iframeId,'Get page position: '+pagePosition.x+','+pagePosition.y);
			}
		}
	
		function setPagePosition(iframeId){
			if(null !== pagePosition){
				window.scrollTo(pagePosition.x,pagePosition.y);
				log(iframeId,'Set page position: '+pagePosition.x+','+pagePosition.y);
				unsetPagePosition();
			}
		}
	
		function unsetPagePosition(){
			pagePosition = null;
		}
	
		function resetIFrame(messageData){
			function reset(){
				setSize(messageData);
				trigger('reset','reset',messageData.iframe,messageData.id);
			}
	
			log(messageData.id,'Size reset requested by '+('init'===messageData.type?'host page':'iFrame'));
			getPagePosition(messageData.id);
			syncResize(reset,messageData,'reset');
		}
	
		function setSize(messageData){
			function setDimension(dimension){
				messageData.iframe.style[dimension] = messageData[dimension] + 'px';
				log(
					messageData.id,
					'IFrame (' + iframeId +
					') ' + dimension +
					' set to ' + messageData[dimension] + 'px'
				);
			}
	
			function chkZero(dimension){
				//FireFox sets dimension of hidden iFrames to zero.
				//So if we detect that set up an event to check for
				//when iFrame becomes visible.
	
				/* istanbul ignore next */  //Not testable in PhantomJS
				if (!hiddenCheckEnabled && '0' === messageData[dimension]){
					hiddenCheckEnabled = true;
					log(iframeId,'Hidden iFrame detected, creating visibility listener');
					fixHiddenIFrames();
				}
			}
	
			function processDimension(dimension){
				setDimension(dimension);
				chkZero(dimension);
			}
	
			var iframeId = messageData.iframe.id;
	
			if(settings[iframeId]){
				if( settings[iframeId].sizeHeight) { processDimension('height'); }
				if( settings[iframeId].sizeWidth ) { processDimension('width'); }
			}
		}
	
		function syncResize(func,messageData,doNotSync){
			/* istanbul ignore if */  //Not testable in PhantomJS
			if(doNotSync!==messageData.type && requestAnimationFrame){
				log(messageData.id,'Requesting animation frame');
				requestAnimationFrame(func);
			} else {
				func();
			}
		}
	
		function trigger(calleeMsg, msg, iframe, id, noResponseWarning) {
			function postMessageToIFrame(){
				var target = settings[id].targetOrigin;
				log(id,'[' + calleeMsg + '] Sending msg to iframe['+id+'] ('+msg+') targetOrigin: '+target);
				iframe.contentWindow.postMessage( msgId + msg, target );
			}
	
			function iFrameNotFound(){
				warn(id,'[' + calleeMsg + '] IFrame('+id+') not found');
			}
	
			function chkAndSend(){
				if(iframe && 'contentWindow' in iframe && (null !== iframe.contentWindow)){ //Null test for PhantomJS
					postMessageToIFrame();
				} else {
					iFrameNotFound();
				}
			}
	
			function warnOnNoResponse() {
				function warning() {
					if (settings[id] && !settings[id].loaded && !errorShown) {
						errorShown = true;
						warn(id, 'IFrame has not responded within '+ settings[id].warningTimeout/1000 +' seconds. Check iFrameResizer.contentWindow.js has been loaded in iFrame. This message can be ingored if everything is working, or you can set the warningTimeout option to a higher value or zero to suppress this warning.');
					}
				}
	
				if (!!noResponseWarning && !!settings[id].warningTimeout) {
					settings[id].msgTimeout = setTimeout(warning, settings[id].warningTimeout);
				}
			}
	
			var errorShown = false;
	
			id = id || iframe.id;
	
			if(settings[id]) {
				chkAndSend();
				warnOnNoResponse();
			}
	
		}
	
		function createOutgoingMsg(iframeId){
			return iframeId +
				':' + settings[iframeId].bodyMarginV1 +
				':' + settings[iframeId].sizeWidth +
				':' + settings[iframeId].log +
				':' + settings[iframeId].interval +
				':' + settings[iframeId].enablePublicMethods +
				':' + settings[iframeId].autoResize +
				':' + settings[iframeId].bodyMargin +
				':' + settings[iframeId].heightCalculationMethod +
				':' + settings[iframeId].bodyBackground +
				':' + settings[iframeId].bodyPadding +
				':' + settings[iframeId].tolerance +
				':' + settings[iframeId].inPageLinks +
				':' + settings[iframeId].resizeFrom +
				':' + settings[iframeId].widthCalculationMethod;
		}
	
		function setupIFrame(iframe,options){
			function setLimits(){
				function addStyle(style){
					if ((Infinity !== settings[iframeId][style]) && (0 !== settings[iframeId][style])){
						iframe.style[style] = settings[iframeId][style] + 'px';
						log(iframeId,'Set '+style+' = '+settings[iframeId][style]+'px');
					}
				}
	
				function chkMinMax(dimension){
					if (settings[iframeId]['min'+dimension]>settings[iframeId]['max'+dimension]){
						throw new Error('Value for min'+dimension+' can not be greater than max'+dimension);
					}
				}
	
				chkMinMax('Height');
				chkMinMax('Width');
	
				addStyle('maxHeight');
				addStyle('minHeight');
				addStyle('maxWidth');
				addStyle('minWidth');
			}
	
			function newId(){
				var id = ((options && options.id) || defaults.id + count++);
				if  (null !== document.getElementById(id)){
					id = id + count++;
				}
				return id;
			}
	
			function ensureHasId(iframeId){
				logId=iframeId;
				if (''===iframeId){
					iframe.id = iframeId =  newId();
					logEnabled = (options || {}).log;
					logId=iframeId;
					log(iframeId,'Added missing iframe ID: '+ iframeId +' (' + iframe.src + ')');
				}
	
	
				return iframeId;
			}
	
			function setScrolling(){
				log(iframeId,'IFrame scrolling ' + (settings[iframeId].scrolling ? 'enabled' : 'disabled') + ' for ' + iframeId);
				iframe.style.overflow = false === settings[iframeId].scrolling ? 'hidden' : 'auto';
				switch(settings[iframeId].scrolling) {
					case true:
						iframe.scrolling = 'yes';
						break;
					case false:
						iframe.scrolling = 'no';
						break;
					default:
						iframe.scrolling = settings[iframeId].scrolling;
				}
			}
	
			//The V1 iFrame script expects an int, where as in V2 expects a CSS
			//string value such as '1px 3em', so if we have an int for V2, set V1=V2
			//and then convert V2 to a string PX value.
			function setupBodyMarginValues(){
				if (('number'===typeof(settings[iframeId].bodyMargin)) || ('0'===settings[iframeId].bodyMargin)){
					settings[iframeId].bodyMarginV1 = settings[iframeId].bodyMargin;
					settings[iframeId].bodyMargin   = '' + settings[iframeId].bodyMargin + 'px';
				}
			}
	
			function checkReset(){
				// Reduce scope of firstRun to function, because IE8's JS execution
				// context stack is borked and this value gets externally
				// changed midway through running this function!!!
				var
					firstRun           = settings[iframeId].firstRun,
					resetRequertMethod = settings[iframeId].heightCalculationMethod in resetRequiredMethods;
	
				if (!firstRun && resetRequertMethod){
					resetIFrame({iframe:iframe, height:0, width:0, type:'init'});
				}
			}
	
			function setupIFrameObject(){
				if(Function.prototype.bind){ //Ignore unpolyfilled IE8.
					settings[iframeId].iframe.iFrameResizer = {
	
						close        : closeIFrame.bind(null,settings[iframeId].iframe),
	
						resize       : trigger.bind(null,'Window resize', 'resize', settings[iframeId].iframe),
	
						moveToAnchor : function(anchor){
							trigger('Move to anchor','moveToAnchor:'+anchor, settings[iframeId].iframe,iframeId);
						},
	
						sendMessage  : function(message){
							message = JSON.stringify(message);
							trigger('Send Message','message:'+message, settings[iframeId].iframe, iframeId);
						}
					};
				}
			}
	
			//We have to call trigger twice, as we can not be sure if all
			//iframes have completed loading when this code runs. The
			//event listener also catches the page changing in the iFrame.
			function init(msg){
				function iFrameLoaded(){
					trigger('iFrame.onload', msg, iframe, undefined , true);
					checkReset();
				}
	
				addEventListener(iframe,'load',iFrameLoaded);
				trigger('init', msg, iframe, undefined, true);
			}
	
			function checkOptions(options){
				if ('object' !== typeof options){
					throw new TypeError('Options is not an object');
				}
			}
	
			function copyOptions(options){
				for (var option in defaults) {
					if (defaults.hasOwnProperty(option)){
						settings[iframeId][option] = options.hasOwnProperty(option) ? options[option] : defaults[option];
					}
				}
			}
	
			function getTargetOrigin (remoteHost){
				return ('' === remoteHost || 'file://' === remoteHost) ? '*' : remoteHost;
			}
	
			function processOptions(options){
				options = options || {};
				settings[iframeId] = {
					firstRun	: true,
					iframe		: iframe,
					remoteHost	: iframe.src.split('/').slice(0,3).join('/')
				};
	
				checkOptions(options);
				copyOptions(options);
	
				settings[iframeId].targetOrigin = true === settings[iframeId].checkOrigin ? getTargetOrigin(settings[iframeId].remoteHost) : '*';
			}
	
			function beenHere(){
				return (iframeId in settings && 'iFrameResizer' in iframe);
			}
	
			var iframeId = ensureHasId(iframe.id);
	
			if (!beenHere()){
				processOptions(options);
				setScrolling();
				setLimits();
				setupBodyMarginValues();
				init(createOutgoingMsg(iframeId));
				setupIFrameObject();
			} else {
				warn(iframeId,'Ignored iFrame, already setup.');
			}
		}
	
		function debouce(fn,time){
			if (null === timer){
				timer = setTimeout(function(){
					timer = null;
					fn();
				}, time);
			}
		}
	
		/* istanbul ignore next */  //Not testable in PhantomJS
		function fixHiddenIFrames(){
			function checkIFrames(){
				function checkIFrame(settingId){
					function chkDimension(dimension){
						return '0px' === settings[settingId].iframe.style[dimension];
					}
	
					function isVisible(el) {
						return (null !== el.offsetParent);
					}
	
					if (isVisible(settings[settingId].iframe) && (chkDimension('height') || chkDimension('width'))){
						trigger('Visibility change', 'resize', settings[settingId].iframe, settingId);
					}
				}
	
				for (var settingId in settings){
					checkIFrame(settingId);
				}
			}
	
			function mutationObserved(mutations){
				log('window','Mutation observed: ' + mutations[0].target + ' ' + mutations[0].type);
				debouce(checkIFrames,16);
			}
	
			function createMutationObserver(){
				var
					target = document.querySelector('body'),
	
					config = {
						attributes            : true,
						attributeOldValue     : false,
						characterData         : true,
						characterDataOldValue : false,
						childList             : true,
						subtree               : true
					},
	
					observer = new MutationObserver(mutationObserved);
	
				observer.observe(target, config);
			}
	
			var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
	
			if (MutationObserver) createMutationObserver();
		}
	
	
		function resizeIFrames(event){
			function resize(){
				sendTriggerMsg('Window '+event,'resize');
			}
	
			log('window','Trigger event: '+event);
			debouce(resize,16);
		}
	
		/* istanbul ignore next */  //Not testable in PhantomJS
		function tabVisible() {
			function resize(){
				sendTriggerMsg('Tab Visable','resize');
			}
	
			if('hidden' !== document.visibilityState) {
				log('document','Trigger event: Visiblity change');
				debouce(resize,16);
			}
		}
	
		function sendTriggerMsg(eventName,event){
			function isIFrameResizeEnabled(iframeId) {
				return	'parent' === settings[iframeId].resizeFrom &&
						settings[iframeId].autoResize &&
						!settings[iframeId].firstRun;
			}
	
			for (var iframeId in settings){
				if(isIFrameResizeEnabled(iframeId)){
					trigger(eventName, event, document.getElementById(iframeId), iframeId);
				}
			}
		}
	
		function setupEventListeners(){
			addEventListener(window,'message',iFrameListener);
	
			addEventListener(window,'resize', function(){resizeIFrames('resize');});
	
			addEventListener(document,'visibilitychange',tabVisible);
			addEventListener(document,'-webkit-visibilitychange',tabVisible); //Andriod 4.4
			addEventListener(window,'focusin',function(){resizeIFrames('focus');}); //IE8-9
			addEventListener(window,'focus',function(){resizeIFrames('focus');});
		}
	
	
		function factory(){
			function init(options,element){
				function chkType(){
					if(!element.tagName) {
						throw new TypeError('Object is not a valid DOM element');
					} else if ('IFRAME' !== element.tagName.toUpperCase()) {
						throw new TypeError('Expected <IFRAME> tag, found <'+element.tagName+'>');
					}
				}
	
				if(element) {
					chkType();
					setupIFrame(element, options);
					iFrames.push(element);
				}
			}
	
			function warnDeprecatedOptions(options) {
				if (options && options.enablePublicMethods) {
					warn('enablePublicMethods option has been removed, public methods are now always available in the iFrame');
				}
			}
	
			var iFrames;
	
			setupRequestAnimationFrame();
			setupEventListeners();
	
			return function iFrameResizeF(options,target){
				iFrames = []; //Only return iFrames past in on this call
	
				warnDeprecatedOptions(options);
	
				switch (typeof(target)){
				case 'undefined':
				case 'string':
					Array.prototype.forEach.call(
						document.querySelectorAll( target || 'iframe' ),
						init.bind(undefined, options)
					);
					break;
				case 'object':
					init(options,target);
					break;
				default:
					throw new TypeError('Unexpected data type ('+typeof(target)+')');
				}
	
				return iFrames;
			};
		}
	
		function createJQueryPublicMethod($){
			if (!$.fn) {
				info('','Unable to bind to jQuery, it is not fully loaded.');
			} else if (!$.fn.iFrameResize){
				$.fn.iFrameResize = function $iFrameResizeF(options) {
					function init(index, element) {
						setupIFrame(element, options);
					}
	
					return this.filter('iframe').each(init).end();
				};
			}
		}
	
		if (window.jQuery) { createJQueryPublicMethod(window.jQuery); }
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module === 'object' && typeof module.exports === 'object') { //Node for browserfy
			module.exports = factory();
		} else {
			window.iFrameResize = window.iFrameResize || factory();
		}
	
	})();


/***/ },
/* 2793 */
/***/ function(module, exports, __webpack_require__) {

	exports.iframeResizer = __webpack_require__(2792);
	exports.iframeResizerContentWindow = __webpack_require__(2791);


/***/ },
/* 2794 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports = module.exports = __webpack_require__(2796)['default'];
	exports['default'] = exports;


/***/ },
/* 2795 */
/***/ function(module, exports) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	// Function.prototype.bind implementation from Mozilla Developer Network:
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind#Polyfill
	
	"use strict";
	
	var bind = Function.prototype.bind || function (oThis) {
	    if (typeof this !== 'function') {
	      // closest thing possible to the ECMAScript 5
	      // internal IsCallable function
	      throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');
	    }
	
	    var aArgs   = Array.prototype.slice.call(arguments, 1),
	        fToBind = this,
	        fNOP    = function() {},
	        fBound  = function() {
	          return fToBind.apply(this instanceof fNOP
	                 ? this
	                 : oThis,
	                 aArgs.concat(Array.prototype.slice.call(arguments)));
	        };
	
	    if (this.prototype) {
	      // native functions don't have a prototype
	      fNOP.prototype = this.prototype;
	    }
	    fBound.prototype = new fNOP();
	
	    return fBound;
	};
	
	// Purposely using the same implementation as the Intl.js `Intl` polyfill.
	// Copyright 2013 Andy Earnshaw, MIT License
	
	var hop = Object.prototype.hasOwnProperty;
	
	var realDefineProp = (function () {
	    try { return !!Object.defineProperty({}, 'a', {}); }
	    catch (e) { return false; }
	})();
	
	var es3 = !realDefineProp && !Object.prototype.__defineGetter__;
	
	var defineProperty = realDefineProp ? Object.defineProperty :
	        function (obj, name, desc) {
	
	    if ('get' in desc && obj.__defineGetter__) {
	        obj.__defineGetter__(name, desc.get);
	    } else if (!hop.call(obj, name) || 'value' in desc) {
	        obj[name] = desc.value;
	    }
	};
	
	var objCreate = Object.create || function (proto, props) {
	    var obj, k;
	
	    function F() {}
	    F.prototype = proto;
	    obj = new F();
	
	    for (k in props) {
	        if (hop.call(props, k)) {
	            defineProperty(obj, k, props[k]);
	        }
	    }
	
	    return obj;
	};
	
	exports.bind = bind, exports.defineProperty = defineProperty, exports.objCreate = objCreate;
	
	//# sourceMappingURL=es5.js.map

/***/ },
/* 2796 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jshint esnext: true */
	
	"use strict";
	var src$es5$$ = __webpack_require__(2795);
	exports["default"] = createFormatCache;
	
	// -----------------------------------------------------------------------------
	
	function createFormatCache(FormatConstructor) {
	    var cache = src$es5$$.objCreate(null);
	
	    return function () {
	        var args    = Array.prototype.slice.call(arguments);
	        var cacheId = getCacheId(args);
	        var format  = cacheId && cache[cacheId];
	
	        if (!format) {
	            format = new (src$es5$$.bind.apply(FormatConstructor, [null].concat(args)))();
	
	            if (cacheId) {
	                cache[cacheId] = format;
	            }
	        }
	
	        return format;
	    };
	}
	
	// -- Utilities ----------------------------------------------------------------
	
	function getCacheId(inputs) {
	    // When JSON is not available in the runtime, we will not create a cache id.
	    if (typeof JSON === 'undefined') { return; }
	
	    var cacheId = [];
	
	    var i, len, input;
	
	    for (i = 0, len = inputs.length; i < len; i += 1) {
	        input = inputs[i];
	
	        if (input && typeof input === 'object') {
	            cacheId.push(orderedProps(input));
	        } else {
	            cacheId.push(input);
	        }
	    }
	
	    return JSON.stringify(cacheId);
	}
	
	function orderedProps(obj) {
	    var props = [],
	        keys  = [];
	
	    var key, i, len, prop;
	
	    for (key in obj) {
	        if (obj.hasOwnProperty(key)) {
	            keys.push(key);
	        }
	    }
	
	    var orderedKeys = keys.sort();
	
	    for (i = 0, len = orderedKeys.length; i < len; i += 1) {
	        key  = orderedKeys[i];
	        prop = {};
	
	        prop[key] = obj[key];
	        props[i]  = prop;
	    }
	
	    return props;
	}
	
	//# sourceMappingURL=memoizer.js.map

/***/ },
/* 2797 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports = module.exports = __webpack_require__(2798)['default'];
	exports['default'] = exports;


/***/ },
/* 2798 */
/***/ function(module, exports) {

	"use strict";
	
	exports["default"] = (function() {
	  /*
	   * Generated by PEG.js 0.8.0.
	   *
	   * http://pegjs.majda.cz/
	   */
	
	  function peg$subclass(child, parent) {
	    function ctor() { this.constructor = child; }
	    ctor.prototype = parent.prototype;
	    child.prototype = new ctor();
	  }
	
	  function SyntaxError(message, expected, found, offset, line, column) {
	    this.message  = message;
	    this.expected = expected;
	    this.found    = found;
	    this.offset   = offset;
	    this.line     = line;
	    this.column   = column;
	
	    this.name     = "SyntaxError";
	  }
	
	  peg$subclass(SyntaxError, Error);
	
	  function parse(input) {
	    var options = arguments.length > 1 ? arguments[1] : {},
	
	        peg$FAILED = {},
	
	        peg$startRuleFunctions = { start: peg$parsestart },
	        peg$startRuleFunction  = peg$parsestart,
	
	        peg$c0 = [],
	        peg$c1 = function(elements) {
	                return {
	                    type    : 'messageFormatPattern',
	                    elements: elements
	                };
	            },
	        peg$c2 = peg$FAILED,
	        peg$c3 = function(text) {
	                var string = '',
	                    i, j, outerLen, inner, innerLen;
	
	                for (i = 0, outerLen = text.length; i < outerLen; i += 1) {
	                    inner = text[i];
	
	                    for (j = 0, innerLen = inner.length; j < innerLen; j += 1) {
	                        string += inner[j];
	                    }
	                }
	
	                return string;
	            },
	        peg$c4 = function(messageText) {
	                return {
	                    type : 'messageTextElement',
	                    value: messageText
	                };
	            },
	        peg$c5 = /^[^ \t\n\r,.+={}#]/,
	        peg$c6 = { type: "class", value: "[^ \\t\\n\\r,.+={}#]", description: "[^ \\t\\n\\r,.+={}#]" },
	        peg$c7 = "{",
	        peg$c8 = { type: "literal", value: "{", description: "\"{\"" },
	        peg$c9 = null,
	        peg$c10 = ",",
	        peg$c11 = { type: "literal", value: ",", description: "\",\"" },
	        peg$c12 = "}",
	        peg$c13 = { type: "literal", value: "}", description: "\"}\"" },
	        peg$c14 = function(id, format) {
	                return {
	                    type  : 'argumentElement',
	                    id    : id,
	                    format: format && format[2]
	                };
	            },
	        peg$c15 = "number",
	        peg$c16 = { type: "literal", value: "number", description: "\"number\"" },
	        peg$c17 = "date",
	        peg$c18 = { type: "literal", value: "date", description: "\"date\"" },
	        peg$c19 = "time",
	        peg$c20 = { type: "literal", value: "time", description: "\"time\"" },
	        peg$c21 = function(type, style) {
	                return {
	                    type : type + 'Format',
	                    style: style && style[2]
	                };
	            },
	        peg$c22 = "plural",
	        peg$c23 = { type: "literal", value: "plural", description: "\"plural\"" },
	        peg$c24 = function(pluralStyle) {
	                return {
	                    type   : pluralStyle.type,
	                    ordinal: false,
	                    offset : pluralStyle.offset || 0,
	                    options: pluralStyle.options
	                };
	            },
	        peg$c25 = "selectordinal",
	        peg$c26 = { type: "literal", value: "selectordinal", description: "\"selectordinal\"" },
	        peg$c27 = function(pluralStyle) {
	                return {
	                    type   : pluralStyle.type,
	                    ordinal: true,
	                    offset : pluralStyle.offset || 0,
	                    options: pluralStyle.options
	                }
	            },
	        peg$c28 = "select",
	        peg$c29 = { type: "literal", value: "select", description: "\"select\"" },
	        peg$c30 = function(options) {
	                return {
	                    type   : 'selectFormat',
	                    options: options
	                };
	            },
	        peg$c31 = "=",
	        peg$c32 = { type: "literal", value: "=", description: "\"=\"" },
	        peg$c33 = function(selector, pattern) {
	                return {
	                    type    : 'optionalFormatPattern',
	                    selector: selector,
	                    value   : pattern
	                };
	            },
	        peg$c34 = "offset:",
	        peg$c35 = { type: "literal", value: "offset:", description: "\"offset:\"" },
	        peg$c36 = function(number) {
	                return number;
	            },
	        peg$c37 = function(offset, options) {
	                return {
	                    type   : 'pluralFormat',
	                    offset : offset,
	                    options: options
	                };
	            },
	        peg$c38 = { type: "other", description: "whitespace" },
	        peg$c39 = /^[ \t\n\r]/,
	        peg$c40 = { type: "class", value: "[ \\t\\n\\r]", description: "[ \\t\\n\\r]" },
	        peg$c41 = { type: "other", description: "optionalWhitespace" },
	        peg$c42 = /^[0-9]/,
	        peg$c43 = { type: "class", value: "[0-9]", description: "[0-9]" },
	        peg$c44 = /^[0-9a-f]/i,
	        peg$c45 = { type: "class", value: "[0-9a-f]i", description: "[0-9a-f]i" },
	        peg$c46 = "0",
	        peg$c47 = { type: "literal", value: "0", description: "\"0\"" },
	        peg$c48 = /^[1-9]/,
	        peg$c49 = { type: "class", value: "[1-9]", description: "[1-9]" },
	        peg$c50 = function(digits) {
	            return parseInt(digits, 10);
	        },
	        peg$c51 = /^[^{}\\\0-\x1F \t\n\r]/,
	        peg$c52 = { type: "class", value: "[^{}\\\\\\0-\\x1F \\t\\n\\r]", description: "[^{}\\\\\\0-\\x1F \\t\\n\\r]" },
	        peg$c53 = "\\\\",
	        peg$c54 = { type: "literal", value: "\\\\", description: "\"\\\\\\\\\"" },
	        peg$c55 = function() { return '\\'; },
	        peg$c56 = "\\#",
	        peg$c57 = { type: "literal", value: "\\#", description: "\"\\\\#\"" },
	        peg$c58 = function() { return '\\#'; },
	        peg$c59 = "\\{",
	        peg$c60 = { type: "literal", value: "\\{", description: "\"\\\\{\"" },
	        peg$c61 = function() { return '\u007B'; },
	        peg$c62 = "\\}",
	        peg$c63 = { type: "literal", value: "\\}", description: "\"\\\\}\"" },
	        peg$c64 = function() { return '\u007D'; },
	        peg$c65 = "\\u",
	        peg$c66 = { type: "literal", value: "\\u", description: "\"\\\\u\"" },
	        peg$c67 = function(digits) {
	                return String.fromCharCode(parseInt(digits, 16));
	            },
	        peg$c68 = function(chars) { return chars.join(''); },
	
	        peg$currPos          = 0,
	        peg$reportedPos      = 0,
	        peg$cachedPos        = 0,
	        peg$cachedPosDetails = { line: 1, column: 1, seenCR: false },
	        peg$maxFailPos       = 0,
	        peg$maxFailExpected  = [],
	        peg$silentFails      = 0,
	
	        peg$result;
	
	    if ("startRule" in options) {
	      if (!(options.startRule in peg$startRuleFunctions)) {
	        throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
	      }
	
	      peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
	    }
	
	    function text() {
	      return input.substring(peg$reportedPos, peg$currPos);
	    }
	
	    function offset() {
	      return peg$reportedPos;
	    }
	
	    function line() {
	      return peg$computePosDetails(peg$reportedPos).line;
	    }
	
	    function column() {
	      return peg$computePosDetails(peg$reportedPos).column;
	    }
	
	    function expected(description) {
	      throw peg$buildException(
	        null,
	        [{ type: "other", description: description }],
	        peg$reportedPos
	      );
	    }
	
	    function error(message) {
	      throw peg$buildException(message, null, peg$reportedPos);
	    }
	
	    function peg$computePosDetails(pos) {
	      function advance(details, startPos, endPos) {
	        var p, ch;
	
	        for (p = startPos; p < endPos; p++) {
	          ch = input.charAt(p);
	          if (ch === "\n") {
	            if (!details.seenCR) { details.line++; }
	            details.column = 1;
	            details.seenCR = false;
	          } else if (ch === "\r" || ch === "\u2028" || ch === "\u2029") {
	            details.line++;
	            details.column = 1;
	            details.seenCR = true;
	          } else {
	            details.column++;
	            details.seenCR = false;
	          }
	        }
	      }
	
	      if (peg$cachedPos !== pos) {
	        if (peg$cachedPos > pos) {
	          peg$cachedPos = 0;
	          peg$cachedPosDetails = { line: 1, column: 1, seenCR: false };
	        }
	        advance(peg$cachedPosDetails, peg$cachedPos, pos);
	        peg$cachedPos = pos;
	      }
	
	      return peg$cachedPosDetails;
	    }
	
	    function peg$fail(expected) {
	      if (peg$currPos < peg$maxFailPos) { return; }
	
	      if (peg$currPos > peg$maxFailPos) {
	        peg$maxFailPos = peg$currPos;
	        peg$maxFailExpected = [];
	      }
	
	      peg$maxFailExpected.push(expected);
	    }
	
	    function peg$buildException(message, expected, pos) {
	      function cleanupExpected(expected) {
	        var i = 1;
	
	        expected.sort(function(a, b) {
	          if (a.description < b.description) {
	            return -1;
	          } else if (a.description > b.description) {
	            return 1;
	          } else {
	            return 0;
	          }
	        });
	
	        while (i < expected.length) {
	          if (expected[i - 1] === expected[i]) {
	            expected.splice(i, 1);
	          } else {
	            i++;
	          }
	        }
	      }
	
	      function buildMessage(expected, found) {
	        function stringEscape(s) {
	          function hex(ch) { return ch.charCodeAt(0).toString(16).toUpperCase(); }
	
	          return s
	            .replace(/\\/g,   '\\\\')
	            .replace(/"/g,    '\\"')
	            .replace(/\x08/g, '\\b')
	            .replace(/\t/g,   '\\t')
	            .replace(/\n/g,   '\\n')
	            .replace(/\f/g,   '\\f')
	            .replace(/\r/g,   '\\r')
	            .replace(/[\x00-\x07\x0B\x0E\x0F]/g, function(ch) { return '\\x0' + hex(ch); })
	            .replace(/[\x10-\x1F\x80-\xFF]/g,    function(ch) { return '\\x'  + hex(ch); })
	            .replace(/[\u0180-\u0FFF]/g,         function(ch) { return '\\u0' + hex(ch); })
	            .replace(/[\u1080-\uFFFF]/g,         function(ch) { return '\\u'  + hex(ch); });
	        }
	
	        var expectedDescs = new Array(expected.length),
	            expectedDesc, foundDesc, i;
	
	        for (i = 0; i < expected.length; i++) {
	          expectedDescs[i] = expected[i].description;
	        }
	
	        expectedDesc = expected.length > 1
	          ? expectedDescs.slice(0, -1).join(", ")
	              + " or "
	              + expectedDescs[expected.length - 1]
	          : expectedDescs[0];
	
	        foundDesc = found ? "\"" + stringEscape(found) + "\"" : "end of input";
	
	        return "Expected " + expectedDesc + " but " + foundDesc + " found.";
	      }
	
	      var posDetails = peg$computePosDetails(pos),
	          found      = pos < input.length ? input.charAt(pos) : null;
	
	      if (expected !== null) {
	        cleanupExpected(expected);
	      }
	
	      return new SyntaxError(
	        message !== null ? message : buildMessage(expected, found),
	        expected,
	        found,
	        pos,
	        posDetails.line,
	        posDetails.column
	      );
	    }
	
	    function peg$parsestart() {
	      var s0;
	
	      s0 = peg$parsemessageFormatPattern();
	
	      return s0;
	    }
	
	    function peg$parsemessageFormatPattern() {
	      var s0, s1, s2;
	
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$parsemessageFormatElement();
	      while (s2 !== peg$FAILED) {
	        s1.push(s2);
	        s2 = peg$parsemessageFormatElement();
	      }
	      if (s1 !== peg$FAILED) {
	        peg$reportedPos = s0;
	        s1 = peg$c1(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    function peg$parsemessageFormatElement() {
	      var s0;
	
	      s0 = peg$parsemessageTextElement();
	      if (s0 === peg$FAILED) {
	        s0 = peg$parseargumentElement();
	      }
	
	      return s0;
	    }
	
	    function peg$parsemessageText() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$currPos;
	      s3 = peg$parse_();
	      if (s3 !== peg$FAILED) {
	        s4 = peg$parsechars();
	        if (s4 !== peg$FAILED) {
	          s5 = peg$parse_();
	          if (s5 !== peg$FAILED) {
	            s3 = [s3, s4, s5];
	            s2 = s3;
	          } else {
	            peg$currPos = s2;
	            s2 = peg$c2;
	          }
	        } else {
	          peg$currPos = s2;
	          s2 = peg$c2;
	        }
	      } else {
	        peg$currPos = s2;
	        s2 = peg$c2;
	      }
	      if (s2 !== peg$FAILED) {
	        while (s2 !== peg$FAILED) {
	          s1.push(s2);
	          s2 = peg$currPos;
	          s3 = peg$parse_();
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parsechars();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parse_();
	              if (s5 !== peg$FAILED) {
	                s3 = [s3, s4, s5];
	                s2 = s3;
	              } else {
	                peg$currPos = s2;
	                s2 = peg$c2;
	              }
	            } else {
	              peg$currPos = s2;
	              s2 = peg$c2;
	            }
	          } else {
	            peg$currPos = s2;
	            s2 = peg$c2;
	          }
	        }
	      } else {
	        s1 = peg$c2;
	      }
	      if (s1 !== peg$FAILED) {
	        peg$reportedPos = s0;
	        s1 = peg$c3(s1);
	      }
	      s0 = s1;
	      if (s0 === peg$FAILED) {
	        s0 = peg$currPos;
	        s1 = peg$parsews();
	        if (s1 !== peg$FAILED) {
	          s1 = input.substring(s0, peg$currPos);
	        }
	        s0 = s1;
	      }
	
	      return s0;
	    }
	
	    function peg$parsemessageTextElement() {
	      var s0, s1;
	
	      s0 = peg$currPos;
	      s1 = peg$parsemessageText();
	      if (s1 !== peg$FAILED) {
	        peg$reportedPos = s0;
	        s1 = peg$c4(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    function peg$parseargument() {
	      var s0, s1, s2;
	
	      s0 = peg$parsenumber();
	      if (s0 === peg$FAILED) {
	        s0 = peg$currPos;
	        s1 = [];
	        if (peg$c5.test(input.charAt(peg$currPos))) {
	          s2 = input.charAt(peg$currPos);
	          peg$currPos++;
	        } else {
	          s2 = peg$FAILED;
	          if (peg$silentFails === 0) { peg$fail(peg$c6); }
	        }
	        if (s2 !== peg$FAILED) {
	          while (s2 !== peg$FAILED) {
	            s1.push(s2);
	            if (peg$c5.test(input.charAt(peg$currPos))) {
	              s2 = input.charAt(peg$currPos);
	              peg$currPos++;
	            } else {
	              s2 = peg$FAILED;
	              if (peg$silentFails === 0) { peg$fail(peg$c6); }
	            }
	          }
	        } else {
	          s1 = peg$c2;
	        }
	        if (s1 !== peg$FAILED) {
	          s1 = input.substring(s0, peg$currPos);
	        }
	        s0 = s1;
	      }
	
	      return s0;
	    }
	
	    function peg$parseargumentElement() {
	      var s0, s1, s2, s3, s4, s5, s6, s7, s8;
	
	      s0 = peg$currPos;
	      if (input.charCodeAt(peg$currPos) === 123) {
	        s1 = peg$c7;
	        peg$currPos++;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c8); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          s3 = peg$parseargument();
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parse_();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$currPos;
	              if (input.charCodeAt(peg$currPos) === 44) {
	                s6 = peg$c10;
	                peg$currPos++;
	              } else {
	                s6 = peg$FAILED;
	                if (peg$silentFails === 0) { peg$fail(peg$c11); }
	              }
	              if (s6 !== peg$FAILED) {
	                s7 = peg$parse_();
	                if (s7 !== peg$FAILED) {
	                  s8 = peg$parseelementFormat();
	                  if (s8 !== peg$FAILED) {
	                    s6 = [s6, s7, s8];
	                    s5 = s6;
	                  } else {
	                    peg$currPos = s5;
	                    s5 = peg$c2;
	                  }
	                } else {
	                  peg$currPos = s5;
	                  s5 = peg$c2;
	                }
	              } else {
	                peg$currPos = s5;
	                s5 = peg$c2;
	              }
	              if (s5 === peg$FAILED) {
	                s5 = peg$c9;
	              }
	              if (s5 !== peg$FAILED) {
	                s6 = peg$parse_();
	                if (s6 !== peg$FAILED) {
	                  if (input.charCodeAt(peg$currPos) === 125) {
	                    s7 = peg$c12;
	                    peg$currPos++;
	                  } else {
	                    s7 = peg$FAILED;
	                    if (peg$silentFails === 0) { peg$fail(peg$c13); }
	                  }
	                  if (s7 !== peg$FAILED) {
	                    peg$reportedPos = s0;
	                    s1 = peg$c14(s3, s5);
	                    s0 = s1;
	                  } else {
	                    peg$currPos = s0;
	                    s0 = peg$c2;
	                  }
	                } else {
	                  peg$currPos = s0;
	                  s0 = peg$c2;
	                }
	              } else {
	                peg$currPos = s0;
	                s0 = peg$c2;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$c2;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$c2;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$c2;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$c2;
	      }
	
	      return s0;
	    }
	
	    function peg$parseelementFormat() {
	      var s0;
	
	      s0 = peg$parsesimpleFormat();
	      if (s0 === peg$FAILED) {
	        s0 = peg$parsepluralFormat();
	        if (s0 === peg$FAILED) {
	          s0 = peg$parseselectOrdinalFormat();
	          if (s0 === peg$FAILED) {
	            s0 = peg$parseselectFormat();
	          }
	        }
	      }
	
	      return s0;
	    }
	
	    function peg$parsesimpleFormat() {
	      var s0, s1, s2, s3, s4, s5, s6;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 6) === peg$c15) {
	        s1 = peg$c15;
	        peg$currPos += 6;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c16); }
	      }
	      if (s1 === peg$FAILED) {
	        if (input.substr(peg$currPos, 4) === peg$c17) {
	          s1 = peg$c17;
	          peg$currPos += 4;
	        } else {
	          s1 = peg$FAILED;
	          if (peg$silentFails === 0) { peg$fail(peg$c18); }
	        }
	        if (s1 === peg$FAILED) {
	          if (input.substr(peg$currPos, 4) === peg$c19) {
	            s1 = peg$c19;
	            peg$currPos += 4;
	          } else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c20); }
	          }
	        }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          s3 = peg$currPos;
	          if (input.charCodeAt(peg$currPos) === 44) {
	            s4 = peg$c10;
	            peg$currPos++;
	          } else {
	            s4 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c11); }
	          }
	          if (s4 !== peg$FAILED) {
	            s5 = peg$parse_();
	            if (s5 !== peg$FAILED) {
	              s6 = peg$parsechars();
	              if (s6 !== peg$FAILED) {
	                s4 = [s4, s5, s6];
	                s3 = s4;
	              } else {
	                peg$currPos = s3;
	                s3 = peg$c2;
	              }
	            } else {
	              peg$currPos = s3;
	              s3 = peg$c2;
	            }
	          } else {
	            peg$currPos = s3;
	            s3 = peg$c2;
	          }
	          if (s3 === peg$FAILED) {
	            s3 = peg$c9;
	          }
	          if (s3 !== peg$FAILED) {
	            peg$reportedPos = s0;
	            s1 = peg$c21(s1, s3);
	            s0 = s1;
	          } else {
	            peg$currPos = s0;
	            s0 = peg$c2;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$c2;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$c2;
	      }
	
	      return s0;
	    }
	
	    function peg$parsepluralFormat() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 6) === peg$c22) {
	        s1 = peg$c22;
	        peg$currPos += 6;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c23); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          if (input.charCodeAt(peg$currPos) === 44) {
	            s3 = peg$c10;
	            peg$currPos++;
	          } else {
	            s3 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c11); }
	          }
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parse_();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parsepluralStyle();
	              if (s5 !== peg$FAILED) {
	                peg$reportedPos = s0;
	                s1 = peg$c24(s5);
	                s0 = s1;
	              } else {
	                peg$currPos = s0;
	                s0 = peg$c2;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$c2;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$c2;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$c2;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$c2;
	      }
	
	      return s0;
	    }
	
	    function peg$parseselectOrdinalFormat() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 13) === peg$c25) {
	        s1 = peg$c25;
	        peg$currPos += 13;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c26); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          if (input.charCodeAt(peg$currPos) === 44) {
	            s3 = peg$c10;
	            peg$currPos++;
	          } else {
	            s3 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c11); }
	          }
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parse_();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parsepluralStyle();
	              if (s5 !== peg$FAILED) {
	                peg$reportedPos = s0;
	                s1 = peg$c27(s5);
	                s0 = s1;
	              } else {
	                peg$currPos = s0;
	                s0 = peg$c2;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$c2;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$c2;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$c2;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$c2;
	      }
	
	      return s0;
	    }
	
	    function peg$parseselectFormat() {
	      var s0, s1, s2, s3, s4, s5, s6;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 6) === peg$c28) {
	        s1 = peg$c28;
	        peg$currPos += 6;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c29); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          if (input.charCodeAt(peg$currPos) === 44) {
	            s3 = peg$c10;
	            peg$currPos++;
	          } else {
	            s3 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c11); }
	          }
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parse_();
	            if (s4 !== peg$FAILED) {
	              s5 = [];
	              s6 = peg$parseoptionalFormatPattern();
	              if (s6 !== peg$FAILED) {
	                while (s6 !== peg$FAILED) {
	                  s5.push(s6);
	                  s6 = peg$parseoptionalFormatPattern();
	                }
	              } else {
	                s5 = peg$c2;
	              }
	              if (s5 !== peg$FAILED) {
	                peg$reportedPos = s0;
	                s1 = peg$c30(s5);
	                s0 = s1;
	              } else {
	                peg$currPos = s0;
	                s0 = peg$c2;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$c2;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$c2;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$c2;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$c2;
	      }
	
	      return s0;
	    }
	
	    function peg$parseselector() {
	      var s0, s1, s2, s3;
	
	      s0 = peg$currPos;
	      s1 = peg$currPos;
	      if (input.charCodeAt(peg$currPos) === 61) {
	        s2 = peg$c31;
	        peg$currPos++;
	      } else {
	        s2 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c32); }
	      }
	      if (s2 !== peg$FAILED) {
	        s3 = peg$parsenumber();
	        if (s3 !== peg$FAILED) {
	          s2 = [s2, s3];
	          s1 = s2;
	        } else {
	          peg$currPos = s1;
	          s1 = peg$c2;
	        }
	      } else {
	        peg$currPos = s1;
	        s1 = peg$c2;
	      }
	      if (s1 !== peg$FAILED) {
	        s1 = input.substring(s0, peg$currPos);
	      }
	      s0 = s1;
	      if (s0 === peg$FAILED) {
	        s0 = peg$parsechars();
	      }
	
	      return s0;
	    }
	
	    function peg$parseoptionalFormatPattern() {
	      var s0, s1, s2, s3, s4, s5, s6, s7, s8;
	
	      s0 = peg$currPos;
	      s1 = peg$parse_();
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parseselector();
	        if (s2 !== peg$FAILED) {
	          s3 = peg$parse_();
	          if (s3 !== peg$FAILED) {
	            if (input.charCodeAt(peg$currPos) === 123) {
	              s4 = peg$c7;
	              peg$currPos++;
	            } else {
	              s4 = peg$FAILED;
	              if (peg$silentFails === 0) { peg$fail(peg$c8); }
	            }
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parse_();
	              if (s5 !== peg$FAILED) {
	                s6 = peg$parsemessageFormatPattern();
	                if (s6 !== peg$FAILED) {
	                  s7 = peg$parse_();
	                  if (s7 !== peg$FAILED) {
	                    if (input.charCodeAt(peg$currPos) === 125) {
	                      s8 = peg$c12;
	                      peg$currPos++;
	                    } else {
	                      s8 = peg$FAILED;
	                      if (peg$silentFails === 0) { peg$fail(peg$c13); }
	                    }
	                    if (s8 !== peg$FAILED) {
	                      peg$reportedPos = s0;
	                      s1 = peg$c33(s2, s6);
	                      s0 = s1;
	                    } else {
	                      peg$currPos = s0;
	                      s0 = peg$c2;
	                    }
	                  } else {
	                    peg$currPos = s0;
	                    s0 = peg$c2;
	                  }
	                } else {
	                  peg$currPos = s0;
	                  s0 = peg$c2;
	                }
	              } else {
	                peg$currPos = s0;
	                s0 = peg$c2;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$c2;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$c2;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$c2;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$c2;
	      }
	
	      return s0;
	    }
	
	    function peg$parseoffset() {
	      var s0, s1, s2, s3;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 7) === peg$c34) {
	        s1 = peg$c34;
	        peg$currPos += 7;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c35); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          s3 = peg$parsenumber();
	          if (s3 !== peg$FAILED) {
	            peg$reportedPos = s0;
	            s1 = peg$c36(s3);
	            s0 = s1;
	          } else {
	            peg$currPos = s0;
	            s0 = peg$c2;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$c2;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$c2;
	      }
	
	      return s0;
	    }
	
	    function peg$parsepluralStyle() {
	      var s0, s1, s2, s3, s4;
	
	      s0 = peg$currPos;
	      s1 = peg$parseoffset();
	      if (s1 === peg$FAILED) {
	        s1 = peg$c9;
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          s3 = [];
	          s4 = peg$parseoptionalFormatPattern();
	          if (s4 !== peg$FAILED) {
	            while (s4 !== peg$FAILED) {
	              s3.push(s4);
	              s4 = peg$parseoptionalFormatPattern();
	            }
	          } else {
	            s3 = peg$c2;
	          }
	          if (s3 !== peg$FAILED) {
	            peg$reportedPos = s0;
	            s1 = peg$c37(s1, s3);
	            s0 = s1;
	          } else {
	            peg$currPos = s0;
	            s0 = peg$c2;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$c2;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$c2;
	      }
	
	      return s0;
	    }
	
	    function peg$parsews() {
	      var s0, s1;
	
	      peg$silentFails++;
	      s0 = [];
	      if (peg$c39.test(input.charAt(peg$currPos))) {
	        s1 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c40); }
	      }
	      if (s1 !== peg$FAILED) {
	        while (s1 !== peg$FAILED) {
	          s0.push(s1);
	          if (peg$c39.test(input.charAt(peg$currPos))) {
	            s1 = input.charAt(peg$currPos);
	            peg$currPos++;
	          } else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c40); }
	          }
	        }
	      } else {
	        s0 = peg$c2;
	      }
	      peg$silentFails--;
	      if (s0 === peg$FAILED) {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c38); }
	      }
	
	      return s0;
	    }
	
	    function peg$parse_() {
	      var s0, s1, s2;
	
	      peg$silentFails++;
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$parsews();
	      while (s2 !== peg$FAILED) {
	        s1.push(s2);
	        s2 = peg$parsews();
	      }
	      if (s1 !== peg$FAILED) {
	        s1 = input.substring(s0, peg$currPos);
	      }
	      s0 = s1;
	      peg$silentFails--;
	      if (s0 === peg$FAILED) {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c41); }
	      }
	
	      return s0;
	    }
	
	    function peg$parsedigit() {
	      var s0;
	
	      if (peg$c42.test(input.charAt(peg$currPos))) {
	        s0 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s0 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c43); }
	      }
	
	      return s0;
	    }
	
	    function peg$parsehexDigit() {
	      var s0;
	
	      if (peg$c44.test(input.charAt(peg$currPos))) {
	        s0 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s0 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c45); }
	      }
	
	      return s0;
	    }
	
	    function peg$parsenumber() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      if (input.charCodeAt(peg$currPos) === 48) {
	        s1 = peg$c46;
	        peg$currPos++;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c47); }
	      }
	      if (s1 === peg$FAILED) {
	        s1 = peg$currPos;
	        s2 = peg$currPos;
	        if (peg$c48.test(input.charAt(peg$currPos))) {
	          s3 = input.charAt(peg$currPos);
	          peg$currPos++;
	        } else {
	          s3 = peg$FAILED;
	          if (peg$silentFails === 0) { peg$fail(peg$c49); }
	        }
	        if (s3 !== peg$FAILED) {
	          s4 = [];
	          s5 = peg$parsedigit();
	          while (s5 !== peg$FAILED) {
	            s4.push(s5);
	            s5 = peg$parsedigit();
	          }
	          if (s4 !== peg$FAILED) {
	            s3 = [s3, s4];
	            s2 = s3;
	          } else {
	            peg$currPos = s2;
	            s2 = peg$c2;
	          }
	        } else {
	          peg$currPos = s2;
	          s2 = peg$c2;
	        }
	        if (s2 !== peg$FAILED) {
	          s2 = input.substring(s1, peg$currPos);
	        }
	        s1 = s2;
	      }
	      if (s1 !== peg$FAILED) {
	        peg$reportedPos = s0;
	        s1 = peg$c50(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    function peg$parsechar() {
	      var s0, s1, s2, s3, s4, s5, s6, s7;
	
	      if (peg$c51.test(input.charAt(peg$currPos))) {
	        s0 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s0 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c52); }
	      }
	      if (s0 === peg$FAILED) {
	        s0 = peg$currPos;
	        if (input.substr(peg$currPos, 2) === peg$c53) {
	          s1 = peg$c53;
	          peg$currPos += 2;
	        } else {
	          s1 = peg$FAILED;
	          if (peg$silentFails === 0) { peg$fail(peg$c54); }
	        }
	        if (s1 !== peg$FAILED) {
	          peg$reportedPos = s0;
	          s1 = peg$c55();
	        }
	        s0 = s1;
	        if (s0 === peg$FAILED) {
	          s0 = peg$currPos;
	          if (input.substr(peg$currPos, 2) === peg$c56) {
	            s1 = peg$c56;
	            peg$currPos += 2;
	          } else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c57); }
	          }
	          if (s1 !== peg$FAILED) {
	            peg$reportedPos = s0;
	            s1 = peg$c58();
	          }
	          s0 = s1;
	          if (s0 === peg$FAILED) {
	            s0 = peg$currPos;
	            if (input.substr(peg$currPos, 2) === peg$c59) {
	              s1 = peg$c59;
	              peg$currPos += 2;
	            } else {
	              s1 = peg$FAILED;
	              if (peg$silentFails === 0) { peg$fail(peg$c60); }
	            }
	            if (s1 !== peg$FAILED) {
	              peg$reportedPos = s0;
	              s1 = peg$c61();
	            }
	            s0 = s1;
	            if (s0 === peg$FAILED) {
	              s0 = peg$currPos;
	              if (input.substr(peg$currPos, 2) === peg$c62) {
	                s1 = peg$c62;
	                peg$currPos += 2;
	              } else {
	                s1 = peg$FAILED;
	                if (peg$silentFails === 0) { peg$fail(peg$c63); }
	              }
	              if (s1 !== peg$FAILED) {
	                peg$reportedPos = s0;
	                s1 = peg$c64();
	              }
	              s0 = s1;
	              if (s0 === peg$FAILED) {
	                s0 = peg$currPos;
	                if (input.substr(peg$currPos, 2) === peg$c65) {
	                  s1 = peg$c65;
	                  peg$currPos += 2;
	                } else {
	                  s1 = peg$FAILED;
	                  if (peg$silentFails === 0) { peg$fail(peg$c66); }
	                }
	                if (s1 !== peg$FAILED) {
	                  s2 = peg$currPos;
	                  s3 = peg$currPos;
	                  s4 = peg$parsehexDigit();
	                  if (s4 !== peg$FAILED) {
	                    s5 = peg$parsehexDigit();
	                    if (s5 !== peg$FAILED) {
	                      s6 = peg$parsehexDigit();
	                      if (s6 !== peg$FAILED) {
	                        s7 = peg$parsehexDigit();
	                        if (s7 !== peg$FAILED) {
	                          s4 = [s4, s5, s6, s7];
	                          s3 = s4;
	                        } else {
	                          peg$currPos = s3;
	                          s3 = peg$c2;
	                        }
	                      } else {
	                        peg$currPos = s3;
	                        s3 = peg$c2;
	                      }
	                    } else {
	                      peg$currPos = s3;
	                      s3 = peg$c2;
	                    }
	                  } else {
	                    peg$currPos = s3;
	                    s3 = peg$c2;
	                  }
	                  if (s3 !== peg$FAILED) {
	                    s3 = input.substring(s2, peg$currPos);
	                  }
	                  s2 = s3;
	                  if (s2 !== peg$FAILED) {
	                    peg$reportedPos = s0;
	                    s1 = peg$c67(s2);
	                    s0 = s1;
	                  } else {
	                    peg$currPos = s0;
	                    s0 = peg$c2;
	                  }
	                } else {
	                  peg$currPos = s0;
	                  s0 = peg$c2;
	                }
	              }
	            }
	          }
	        }
	      }
	
	      return s0;
	    }
	
	    function peg$parsechars() {
	      var s0, s1, s2;
	
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$parsechar();
	      if (s2 !== peg$FAILED) {
	        while (s2 !== peg$FAILED) {
	          s1.push(s2);
	          s2 = peg$parsechar();
	        }
	      } else {
	        s1 = peg$c2;
	      }
	      if (s1 !== peg$FAILED) {
	        peg$reportedPos = s0;
	        s1 = peg$c68(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    peg$result = peg$startRuleFunction();
	
	    if (peg$result !== peg$FAILED && peg$currPos === input.length) {
	      return peg$result;
	    } else {
	      if (peg$result !== peg$FAILED && peg$currPos < input.length) {
	        peg$fail({ type: "end", description: "end of input" });
	      }
	
	      throw peg$buildException(null, peg$maxFailExpected, peg$maxFailPos);
	    }
	  }
	
	  return {
	    SyntaxError: SyntaxError,
	    parse:       parse
	  };
	})();
	
	//# sourceMappingURL=parser.js.map

/***/ },
/* 2799 */
/***/ function(module, exports) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	exports["default"] = Compiler;
	
	function Compiler(locales, formats, pluralFn) {
	    this.locales  = locales;
	    this.formats  = formats;
	    this.pluralFn = pluralFn;
	}
	
	Compiler.prototype.compile = function (ast) {
	    this.pluralStack        = [];
	    this.currentPlural      = null;
	    this.pluralNumberFormat = null;
	
	    return this.compileMessage(ast);
	};
	
	Compiler.prototype.compileMessage = function (ast) {
	    if (!(ast && ast.type === 'messageFormatPattern')) {
	        throw new Error('Message AST is not of type: "messageFormatPattern"');
	    }
	
	    var elements = ast.elements,
	        pattern  = [];
	
	    var i, len, element;
	
	    for (i = 0, len = elements.length; i < len; i += 1) {
	        element = elements[i];
	
	        switch (element.type) {
	            case 'messageTextElement':
	                pattern.push(this.compileMessageText(element));
	                break;
	
	            case 'argumentElement':
	                pattern.push(this.compileArgument(element));
	                break;
	
	            default:
	                throw new Error('Message element does not have a valid type');
	        }
	    }
	
	    return pattern;
	};
	
	Compiler.prototype.compileMessageText = function (element) {
	    // When this `element` is part of plural sub-pattern and its value contains
	    // an unescaped '#', use a `PluralOffsetString` helper to properly output
	    // the number with the correct offset in the string.
	    if (this.currentPlural && /(^|[^\\])#/g.test(element.value)) {
	        // Create a cache a NumberFormat instance that can be reused for any
	        // PluralOffsetString instance in this message.
	        if (!this.pluralNumberFormat) {
	            this.pluralNumberFormat = new Intl.NumberFormat(this.locales);
	        }
	
	        return new PluralOffsetString(
	                this.currentPlural.id,
	                this.currentPlural.format.offset,
	                this.pluralNumberFormat,
	                element.value);
	    }
	
	    // Unescape the escaped '#'s in the message text.
	    return element.value.replace(/\\#/g, '#');
	};
	
	Compiler.prototype.compileArgument = function (element) {
	    var format = element.format;
	
	    if (!format) {
	        return new StringFormat(element.id);
	    }
	
	    var formats  = this.formats,
	        locales  = this.locales,
	        pluralFn = this.pluralFn,
	        options;
	
	    switch (format.type) {
	        case 'numberFormat':
	            options = formats.number[format.style];
	            return {
	                id    : element.id,
	                format: new Intl.NumberFormat(locales, options).format
	            };
	
	        case 'dateFormat':
	            options = formats.date[format.style];
	            return {
	                id    : element.id,
	                format: new Intl.DateTimeFormat(locales, options).format
	            };
	
	        case 'timeFormat':
	            options = formats.time[format.style];
	            return {
	                id    : element.id,
	                format: new Intl.DateTimeFormat(locales, options).format
	            };
	
	        case 'pluralFormat':
	            options = this.compileOptions(element);
	            return new PluralFormat(
	                element.id, format.ordinal, format.offset, options, pluralFn
	            );
	
	        case 'selectFormat':
	            options = this.compileOptions(element);
	            return new SelectFormat(element.id, options);
	
	        default:
	            throw new Error('Message element does not have a valid format type');
	    }
	};
	
	Compiler.prototype.compileOptions = function (element) {
	    var format      = element.format,
	        options     = format.options,
	        optionsHash = {};
	
	    // Save the current plural element, if any, then set it to a new value when
	    // compiling the options sub-patterns. This conforms the spec's algorithm
	    // for handling `"#"` syntax in message text.
	    this.pluralStack.push(this.currentPlural);
	    this.currentPlural = format.type === 'pluralFormat' ? element : null;
	
	    var i, len, option;
	
	    for (i = 0, len = options.length; i < len; i += 1) {
	        option = options[i];
	
	        // Compile the sub-pattern and save it under the options's selector.
	        optionsHash[option.selector] = this.compileMessage(option.value);
	    }
	
	    // Pop the plural stack to put back the original current plural value.
	    this.currentPlural = this.pluralStack.pop();
	
	    return optionsHash;
	};
	
	// -- Compiler Helper Classes --------------------------------------------------
	
	function StringFormat(id) {
	    this.id = id;
	}
	
	StringFormat.prototype.format = function (value) {
	    if (!value) {
	        return '';
	    }
	
	    return typeof value === 'string' ? value : String(value);
	};
	
	function PluralFormat(id, useOrdinal, offset, options, pluralFn) {
	    this.id         = id;
	    this.useOrdinal = useOrdinal;
	    this.offset     = offset;
	    this.options    = options;
	    this.pluralFn   = pluralFn;
	}
	
	PluralFormat.prototype.getOption = function (value) {
	    var options = this.options;
	
	    var option = options['=' + value] ||
	            options[this.pluralFn(value - this.offset, this.useOrdinal)];
	
	    return option || options.other;
	};
	
	function PluralOffsetString(id, offset, numberFormat, string) {
	    this.id           = id;
	    this.offset       = offset;
	    this.numberFormat = numberFormat;
	    this.string       = string;
	}
	
	PluralOffsetString.prototype.format = function (value) {
	    var number = this.numberFormat.format(value - this.offset);
	
	    return this.string
	            .replace(/(^|[^\\])#/g, '$1' + number)
	            .replace(/\\#/g, '#');
	};
	
	function SelectFormat(id, options) {
	    this.id      = id;
	    this.options = options;
	}
	
	SelectFormat.prototype.getOption = function (value) {
	    var options = this.options;
	    return options[value] || options.other;
	};
	
	//# sourceMappingURL=compiler.js.map

/***/ },
/* 2800 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	var src$utils$$ = __webpack_require__(711), src$es5$$ = __webpack_require__(2802), src$compiler$$ = __webpack_require__(2799), intl$messageformat$parser$$ = __webpack_require__(2797);
	exports["default"] = MessageFormat;
	
	// -- MessageFormat --------------------------------------------------------
	
	function MessageFormat(message, locales, formats) {
	    // Parse string messages into an AST.
	    var ast = typeof message === 'string' ?
	            MessageFormat.__parse(message) : message;
	
	    if (!(ast && ast.type === 'messageFormatPattern')) {
	        throw new TypeError('A message must be provided as a String or AST.');
	    }
	
	    // Creates a new object with the specified `formats` merged with the default
	    // formats.
	    formats = this._mergeFormats(MessageFormat.formats, formats);
	
	    // Defined first because it's used to build the format pattern.
	    src$es5$$.defineProperty(this, '_locale',  {value: this._resolveLocale(locales)});
	
	    // Compile the `ast` to a pattern that is highly optimized for repeated
	    // `format()` invocations. **Note:** This passes the `locales` set provided
	    // to the constructor instead of just the resolved locale.
	    var pluralFn = this._findPluralRuleFunction(this._locale);
	    var pattern  = this._compilePattern(ast, locales, formats, pluralFn);
	
	    // "Bind" `format()` method to `this` so it can be passed by reference like
	    // the other `Intl` APIs.
	    var messageFormat = this;
	    this.format = function (values) {
	        return messageFormat._format(pattern, values);
	    };
	}
	
	// Default format options used as the prototype of the `formats` provided to the
	// constructor. These are used when constructing the internal Intl.NumberFormat
	// and Intl.DateTimeFormat instances.
	src$es5$$.defineProperty(MessageFormat, 'formats', {
	    enumerable: true,
	
	    value: {
	        number: {
	            'currency': {
	                style: 'currency'
	            },
	
	            'percent': {
	                style: 'percent'
	            }
	        },
	
	        date: {
	            'short': {
	                month: 'numeric',
	                day  : 'numeric',
	                year : '2-digit'
	            },
	
	            'medium': {
	                month: 'short',
	                day  : 'numeric',
	                year : 'numeric'
	            },
	
	            'long': {
	                month: 'long',
	                day  : 'numeric',
	                year : 'numeric'
	            },
	
	            'full': {
	                weekday: 'long',
	                month  : 'long',
	                day    : 'numeric',
	                year   : 'numeric'
	            }
	        },
	
	        time: {
	            'short': {
	                hour  : 'numeric',
	                minute: 'numeric'
	            },
	
	            'medium':  {
	                hour  : 'numeric',
	                minute: 'numeric',
	                second: 'numeric'
	            },
	
	            'long': {
	                hour        : 'numeric',
	                minute      : 'numeric',
	                second      : 'numeric',
	                timeZoneName: 'short'
	            },
	
	            'full': {
	                hour        : 'numeric',
	                minute      : 'numeric',
	                second      : 'numeric',
	                timeZoneName: 'short'
	            }
	        }
	    }
	});
	
	// Define internal private properties for dealing with locale data.
	src$es5$$.defineProperty(MessageFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
	src$es5$$.defineProperty(MessageFormat, '__addLocaleData', {value: function (data) {
	    if (!(data && data.locale)) {
	        throw new Error(
	            'Locale data provided to IntlMessageFormat is missing a ' +
	            '`locale` property'
	        );
	    }
	
	    MessageFormat.__localeData__[data.locale.toLowerCase()] = data;
	}});
	
	// Defines `__parse()` static method as an exposed private.
	src$es5$$.defineProperty(MessageFormat, '__parse', {value: intl$messageformat$parser$$["default"].parse});
	
	// Define public `defaultLocale` property which defaults to English, but can be
	// set by the developer.
	src$es5$$.defineProperty(MessageFormat, 'defaultLocale', {
	    enumerable: true,
	    writable  : true,
	    value     : undefined
	});
	
	MessageFormat.prototype.resolvedOptions = function () {
	    // TODO: Provide anything else?
	    return {
	        locale: this._locale
	    };
	};
	
	MessageFormat.prototype._compilePattern = function (ast, locales, formats, pluralFn) {
	    var compiler = new src$compiler$$["default"](locales, formats, pluralFn);
	    return compiler.compile(ast);
	};
	
	MessageFormat.prototype._findPluralRuleFunction = function (locale) {
	    var localeData = MessageFormat.__localeData__;
	    var data       = localeData[locale.toLowerCase()];
	
	    // The locale data is de-duplicated, so we have to traverse the locale's
	    // hierarchy until we find a `pluralRuleFunction` to return.
	    while (data) {
	        if (data.pluralRuleFunction) {
	            return data.pluralRuleFunction;
	        }
	
	        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
	    }
	
	    throw new Error(
	        'Locale data added to IntlMessageFormat is missing a ' +
	        '`pluralRuleFunction` for :' + locale
	    );
	};
	
	MessageFormat.prototype._format = function (pattern, values) {
	    var result = '',
	        i, len, part, id, value;
	
	    for (i = 0, len = pattern.length; i < len; i += 1) {
	        part = pattern[i];
	
	        // Exist early for string parts.
	        if (typeof part === 'string') {
	            result += part;
	            continue;
	        }
	
	        id = part.id;
	
	        // Enforce that all required values are provided by the caller.
	        if (!(values && src$utils$$.hop.call(values, id))) {
	            throw new Error('A value must be provided for: ' + id);
	        }
	
	        value = values[id];
	
	        // Recursively format plural and select parts' option — which can be a
	        // nested pattern structure. The choosing of the option to use is
	        // abstracted-by and delegated-to the part helper object.
	        if (part.options) {
	            result += this._format(part.getOption(value), values);
	        } else {
	            result += part.format(value);
	        }
	    }
	
	    return result;
	};
	
	MessageFormat.prototype._mergeFormats = function (defaults, formats) {
	    var mergedFormats = {},
	        type, mergedType;
	
	    for (type in defaults) {
	        if (!src$utils$$.hop.call(defaults, type)) { continue; }
	
	        mergedFormats[type] = mergedType = src$es5$$.objCreate(defaults[type]);
	
	        if (formats && src$utils$$.hop.call(formats, type)) {
	            src$utils$$.extend(mergedType, formats[type]);
	        }
	    }
	
	    return mergedFormats;
	};
	
	MessageFormat.prototype._resolveLocale = function (locales) {
	    if (typeof locales === 'string') {
	        locales = [locales];
	    }
	
	    // Create a copy of the array so we can push on the default locale.
	    locales = (locales || []).concat(MessageFormat.defaultLocale);
	
	    var localeData = MessageFormat.__localeData__;
	    var i, len, localeParts, data;
	
	    // Using the set of locales + the default locale, we look for the first one
	    // which that has been registered. When data does not exist for a locale, we
	    // traverse its ancestors to find something that's been registered within
	    // its hierarchy of locales. Since we lack the proper `parentLocale` data
	    // here, we must take a naive approach to traversal.
	    for (i = 0, len = locales.length; i < len; i += 1) {
	        localeParts = locales[i].toLowerCase().split('-');
	
	        while (localeParts.length) {
	            data = localeData[localeParts.join('-')];
	            if (data) {
	                // Return the normalized locale string; e.g., we return "en-US",
	                // instead of "en-us".
	                return data.locale;
	            }
	
	            localeParts.pop();
	        }
	    }
	
	    var defaultLocale = locales.pop();
	    throw new Error(
	        'No locale data has been added to IntlMessageFormat for: ' +
	        locales.join(', ') + ', or the default locale: ' + defaultLocale
	    );
	};
	
	//# sourceMappingURL=core.js.map

/***/ },
/* 2801 */
/***/ function(module, exports) {

	// GENERATED FILE
	"use strict";
	exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"}};
	
	//# sourceMappingURL=en.js.map

/***/ },
/* 2802 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	var src$utils$$ = __webpack_require__(711);
	
	// Purposely using the same implementation as the Intl.js `Intl` polyfill.
	// Copyright 2013 Andy Earnshaw, MIT License
	
	var realDefineProp = (function () {
	    try { return !!Object.defineProperty({}, 'a', {}); }
	    catch (e) { return false; }
	})();
	
	var es3 = !realDefineProp && !Object.prototype.__defineGetter__;
	
	var defineProperty = realDefineProp ? Object.defineProperty :
	        function (obj, name, desc) {
	
	    if ('get' in desc && obj.__defineGetter__) {
	        obj.__defineGetter__(name, desc.get);
	    } else if (!src$utils$$.hop.call(obj, name) || 'value' in desc) {
	        obj[name] = desc.value;
	    }
	};
	
	var objCreate = Object.create || function (proto, props) {
	    var obj, k;
	
	    function F() {}
	    F.prototype = proto;
	    obj = new F();
	
	    for (k in props) {
	        if (src$utils$$.hop.call(props, k)) {
	            defineProperty(obj, k, props[k]);
	        }
	    }
	
	    return obj;
	};
	exports.defineProperty = defineProperty, exports.objCreate = objCreate;
	
	//# sourceMappingURL=es5.js.map

/***/ },
/* 2803 */
[3529, 2800, 2801],
/* 2804 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node:true */
	
	'use strict';
	
	var IntlRelativeFormat = __webpack_require__(2809)['default'];
	
	// Add all locale data to `IntlRelativeFormat`. This module will be ignored when
	// bundling for the browser with Browserify/Webpack.
	__webpack_require__(3477);
	
	// Re-export `IntlRelativeFormat` as the CommonJS default exports with all the
	// locale data registered, and with English set as the default locale. Define
	// the `default` prop for use with other compiled ES6 Modules.
	exports = module.exports = IntlRelativeFormat;
	exports['default'] = exports;


/***/ },
/* 2805 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	var intl$messageformat$$ = __webpack_require__(710), src$diff$$ = __webpack_require__(2806), src$es5$$ = __webpack_require__(2808);
	exports["default"] = RelativeFormat;
	
	// -----------------------------------------------------------------------------
	
	var FIELDS = ['second', 'minute', 'hour', 'day', 'month', 'year'];
	var STYLES = ['best fit', 'numeric'];
	
	// -- RelativeFormat -----------------------------------------------------------
	
	function RelativeFormat(locales, options) {
	    options = options || {};
	
	    // Make a copy of `locales` if it's an array, so that it doesn't change
	    // since it's used lazily.
	    if (src$es5$$.isArray(locales)) {
	        locales = locales.concat();
	    }
	
	    src$es5$$.defineProperty(this, '_locale', {value: this._resolveLocale(locales)});
	    src$es5$$.defineProperty(this, '_options', {value: {
	        style: this._resolveStyle(options.style),
	        units: this._isValidUnits(options.units) && options.units
	    }});
	
	    src$es5$$.defineProperty(this, '_locales', {value: locales});
	    src$es5$$.defineProperty(this, '_fields', {value: this._findFields(this._locale)});
	    src$es5$$.defineProperty(this, '_messages', {value: src$es5$$.objCreate(null)});
	
	    // "Bind" `format()` method to `this` so it can be passed by reference like
	    // the other `Intl` APIs.
	    var relativeFormat = this;
	    this.format = function format(date, options) {
	        return relativeFormat._format(date, options);
	    };
	}
	
	// Define internal private properties for dealing with locale data.
	src$es5$$.defineProperty(RelativeFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
	src$es5$$.defineProperty(RelativeFormat, '__addLocaleData', {value: function (data) {
	    if (!(data && data.locale)) {
	        throw new Error(
	            'Locale data provided to IntlRelativeFormat is missing a ' +
	            '`locale` property value'
	        );
	    }
	
	    RelativeFormat.__localeData__[data.locale.toLowerCase()] = data;
	
	    // Add data to IntlMessageFormat.
	    intl$messageformat$$["default"].__addLocaleData(data);
	}});
	
	// Define public `defaultLocale` property which can be set by the developer, or
	// it will be set when the first RelativeFormat instance is created by
	// leveraging the resolved locale from `Intl`.
	src$es5$$.defineProperty(RelativeFormat, 'defaultLocale', {
	    enumerable: true,
	    writable  : true,
	    value     : undefined
	});
	
	// Define public `thresholds` property which can be set by the developer, and
	// defaults to relative time thresholds from moment.js.
	src$es5$$.defineProperty(RelativeFormat, 'thresholds', {
	    enumerable: true,
	
	    value: {
	        second: 45,  // seconds to minute
	        minute: 45,  // minutes to hour
	        hour  : 22,  // hours to day
	        day   : 26,  // days to month
	        month : 11   // months to year
	    }
	});
	
	RelativeFormat.prototype.resolvedOptions = function () {
	    return {
	        locale: this._locale,
	        style : this._options.style,
	        units : this._options.units
	    };
	};
	
	RelativeFormat.prototype._compileMessage = function (units) {
	    // `this._locales` is the original set of locales the user specified to the
	    // constructor, while `this._locale` is the resolved root locale.
	    var locales        = this._locales;
	    var resolvedLocale = this._locale;
	
	    var field        = this._fields[units];
	    var relativeTime = field.relativeTime;
	    var future       = '';
	    var past         = '';
	    var i;
	
	    for (i in relativeTime.future) {
	        if (relativeTime.future.hasOwnProperty(i)) {
	            future += ' ' + i + ' {' +
	                relativeTime.future[i].replace('{0}', '#') + '}';
	        }
	    }
	
	    for (i in relativeTime.past) {
	        if (relativeTime.past.hasOwnProperty(i)) {
	            past += ' ' + i + ' {' +
	                relativeTime.past[i].replace('{0}', '#') + '}';
	        }
	    }
	
	    var message = '{when, select, future {{0, plural, ' + future + '}}' +
	                                 'past {{0, plural, ' + past + '}}}';
	
	    // Create the synthetic IntlMessageFormat instance using the original
	    // locales value specified by the user when constructing the the parent
	    // IntlRelativeFormat instance.
	    return new intl$messageformat$$["default"](message, locales);
	};
	
	RelativeFormat.prototype._getMessage = function (units) {
	    var messages = this._messages;
	
	    // Create a new synthetic message based on the locale data from CLDR.
	    if (!messages[units]) {
	        messages[units] = this._compileMessage(units);
	    }
	
	    return messages[units];
	};
	
	RelativeFormat.prototype._getRelativeUnits = function (diff, units) {
	    var field = this._fields[units];
	
	    if (field.relative) {
	        return field.relative[diff];
	    }
	};
	
	RelativeFormat.prototype._findFields = function (locale) {
	    var localeData = RelativeFormat.__localeData__;
	    var data       = localeData[locale.toLowerCase()];
	
	    // The locale data is de-duplicated, so we have to traverse the locale's
	    // hierarchy until we find `fields` to return.
	    while (data) {
	        if (data.fields) {
	            return data.fields;
	        }
	
	        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
	    }
	
	    throw new Error(
	        'Locale data added to IntlRelativeFormat is missing `fields` for :' +
	        locale
	    );
	};
	
	RelativeFormat.prototype._format = function (date, options) {
	    var now = options && options.now !== undefined ? options.now : src$es5$$.dateNow();
	
	    if (date === undefined) {
	        date = now;
	    }
	
	    // Determine if the `date` and optional `now` values are valid, and throw a
	    // similar error to what `Intl.DateTimeFormat#format()` would throw.
	    if (!isFinite(now)) {
	        throw new RangeError(
	            'The `now` option provided to IntlRelativeFormat#format() is not ' +
	            'in valid range.'
	        );
	    }
	
	    if (!isFinite(date)) {
	        throw new RangeError(
	            'The date value provided to IntlRelativeFormat#format() is not ' +
	            'in valid range.'
	        );
	    }
	
	    var diffReport  = src$diff$$["default"](now, date);
	    var units       = this._options.units || this._selectUnits(diffReport);
	    var diffInUnits = diffReport[units];
	
	    if (this._options.style !== 'numeric') {
	        var relativeUnits = this._getRelativeUnits(diffInUnits, units);
	        if (relativeUnits) {
	            return relativeUnits;
	        }
	    }
	
	    return this._getMessage(units).format({
	        '0' : Math.abs(diffInUnits),
	        when: diffInUnits < 0 ? 'past' : 'future'
	    });
	};
	
	RelativeFormat.prototype._isValidUnits = function (units) {
	    if (!units || src$es5$$.arrIndexOf.call(FIELDS, units) >= 0) {
	        return true;
	    }
	
	    if (typeof units === 'string') {
	        var suggestion = /s$/.test(units) && units.substr(0, units.length - 1);
	        if (suggestion && src$es5$$.arrIndexOf.call(FIELDS, suggestion) >= 0) {
	            throw new Error(
	                '"' + units + '" is not a valid IntlRelativeFormat `units` ' +
	                'value, did you mean: ' + suggestion
	            );
	        }
	    }
	
	    throw new Error(
	        '"' + units + '" is not a valid IntlRelativeFormat `units` value, it ' +
	        'must be one of: "' + FIELDS.join('", "') + '"'
	    );
	};
	
	RelativeFormat.prototype._resolveLocale = function (locales) {
	    if (typeof locales === 'string') {
	        locales = [locales];
	    }
	
	    // Create a copy of the array so we can push on the default locale.
	    locales = (locales || []).concat(RelativeFormat.defaultLocale);
	
	    var localeData = RelativeFormat.__localeData__;
	    var i, len, localeParts, data;
	
	    // Using the set of locales + the default locale, we look for the first one
	    // which that has been registered. When data does not exist for a locale, we
	    // traverse its ancestors to find something that's been registered within
	    // its hierarchy of locales. Since we lack the proper `parentLocale` data
	    // here, we must take a naive approach to traversal.
	    for (i = 0, len = locales.length; i < len; i += 1) {
	        localeParts = locales[i].toLowerCase().split('-');
	
	        while (localeParts.length) {
	            data = localeData[localeParts.join('-')];
	            if (data) {
	                // Return the normalized locale string; e.g., we return "en-US",
	                // instead of "en-us".
	                return data.locale;
	            }
	
	            localeParts.pop();
	        }
	    }
	
	    var defaultLocale = locales.pop();
	    throw new Error(
	        'No locale data has been added to IntlRelativeFormat for: ' +
	        locales.join(', ') + ', or the default locale: ' + defaultLocale
	    );
	};
	
	RelativeFormat.prototype._resolveStyle = function (style) {
	    // Default to "best fit" style.
	    if (!style) {
	        return STYLES[0];
	    }
	
	    if (src$es5$$.arrIndexOf.call(STYLES, style) >= 0) {
	        return style;
	    }
	
	    throw new Error(
	        '"' + style + '" is not a valid IntlRelativeFormat `style` value, it ' +
	        'must be one of: "' + STYLES.join('", "') + '"'
	    );
	};
	
	RelativeFormat.prototype._selectUnits = function (diffReport) {
	    var i, l, units;
	
	    for (i = 0, l = FIELDS.length; i < l; i += 1) {
	        units = FIELDS[i];
	
	        if (Math.abs(diffReport[units]) < RelativeFormat.thresholds[units]) {
	            break;
	        }
	    }
	
	    return units;
	};
	
	//# sourceMappingURL=core.js.map

/***/ },
/* 2806 */
/***/ function(module, exports) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	
	var round = Math.round;
	
	function daysToYears(days) {
	    // 400 years have 146097 days (taking into account leap year rules)
	    return days * 400 / 146097;
	}
	
	exports["default"] = function (from, to) {
	    // Convert to ms timestamps.
	    from = +from;
	    to   = +to;
	
	    var millisecond = round(to - from),
	        second      = round(millisecond / 1000),
	        minute      = round(second / 60),
	        hour        = round(minute / 60),
	        day         = round(hour / 24),
	        week        = round(day / 7);
	
	    var rawYears = daysToYears(day),
	        month    = round(rawYears * 12),
	        year     = round(rawYears);
	
	    return {
	        millisecond: millisecond,
	        second     : second,
	        minute     : minute,
	        hour       : hour,
	        day        : day,
	        week       : week,
	        month      : month,
	        year       : year
	    };
	};
	
	//# sourceMappingURL=diff.js.map

/***/ },
/* 2807 */
/***/ function(module, exports) {

	// GENERATED FILE
	"use strict";
	exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"},"fields":{"year":{"displayName":"year","relative":{"0":"this year","1":"next year","-1":"last year"},"relativeTime":{"future":{"one":"in {0} year","other":"in {0} years"},"past":{"one":"{0} year ago","other":"{0} years ago"}}},"month":{"displayName":"month","relative":{"0":"this month","1":"next month","-1":"last month"},"relativeTime":{"future":{"one":"in {0} month","other":"in {0} months"},"past":{"one":"{0} month ago","other":"{0} months ago"}}},"day":{"displayName":"day","relative":{"0":"today","1":"tomorrow","-1":"yesterday"},"relativeTime":{"future":{"one":"in {0} day","other":"in {0} days"},"past":{"one":"{0} day ago","other":"{0} days ago"}}},"hour":{"displayName":"hour","relativeTime":{"future":{"one":"in {0} hour","other":"in {0} hours"},"past":{"one":"{0} hour ago","other":"{0} hours ago"}}},"minute":{"displayName":"minute","relativeTime":{"future":{"one":"in {0} minute","other":"in {0} minutes"},"past":{"one":"{0} minute ago","other":"{0} minutes ago"}}},"second":{"displayName":"second","relative":{"0":"now"},"relativeTime":{"future":{"one":"in {0} second","other":"in {0} seconds"},"past":{"one":"{0} second ago","other":"{0} seconds ago"}}}}};
	
	//# sourceMappingURL=en.js.map

/***/ },
/* 2808 */
/***/ function(module, exports) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	
	// Purposely using the same implementation as the Intl.js `Intl` polyfill.
	// Copyright 2013 Andy Earnshaw, MIT License
	
	var hop = Object.prototype.hasOwnProperty;
	var toString = Object.prototype.toString;
	
	var realDefineProp = (function () {
	    try { return !!Object.defineProperty({}, 'a', {}); }
	    catch (e) { return false; }
	})();
	
	var es3 = !realDefineProp && !Object.prototype.__defineGetter__;
	
	var defineProperty = realDefineProp ? Object.defineProperty :
	        function (obj, name, desc) {
	
	    if ('get' in desc && obj.__defineGetter__) {
	        obj.__defineGetter__(name, desc.get);
	    } else if (!hop.call(obj, name) || 'value' in desc) {
	        obj[name] = desc.value;
	    }
	};
	
	var objCreate = Object.create || function (proto, props) {
	    var obj, k;
	
	    function F() {}
	    F.prototype = proto;
	    obj = new F();
	
	    for (k in props) {
	        if (hop.call(props, k)) {
	            defineProperty(obj, k, props[k]);
	        }
	    }
	
	    return obj;
	};
	
	var arrIndexOf = Array.prototype.indexOf || function (search, fromIndex) {
	    /*jshint validthis:true */
	    var arr = this;
	    if (!arr.length) {
	        return -1;
	    }
	
	    for (var i = fromIndex || 0, max = arr.length; i < max; i++) {
	        if (arr[i] === search) {
	            return i;
	        }
	    }
	
	    return -1;
	};
	
	var isArray = Array.isArray || function (obj) {
	    return toString.call(obj) === '[object Array]';
	};
	
	var dateNow = Date.now || function () {
	    return new Date().getTime();
	};
	exports.defineProperty = defineProperty, exports.objCreate = objCreate, exports.arrIndexOf = arrIndexOf, exports.isArray = isArray, exports.dateNow = dateNow;
	
	//# sourceMappingURL=es5.js.map

/***/ },
/* 2809 */
[3529, 2805, 2807],
/* 2810 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {// Expose `IntlPolyfill` as global to add locale data into runtime later on.
	global.IntlPolyfill = __webpack_require__(2811);
	
	// Require all locale data for `Intl`. This module will be
	// ignored when bundling for the browser with Browserify/Webpack.
	__webpack_require__(3475);
	
	// hack to export the polyfill as global Intl if needed
	if (!global.Intl) {
	    global.Intl = global.IntlPolyfill;
	    global.IntlPolyfill.__applyLocaleSensitivePrototypes();
	}
	
	// providing an idiomatic api for the nodejs version of this module
	module.exports = global.IntlPolyfill;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 2811 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj;
	};
	
	var jsx = function () {
	  var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7;
	  return function createRawReactElement(type, props, key, children) {
	    var defaultProps = type && type.defaultProps;
	    var childrenLength = arguments.length - 3;
	
	    if (!props && childrenLength !== 0) {
	      props = {};
	    }
	
	    if (props && defaultProps) {
	      for (var propName in defaultProps) {
	        if (props[propName] === void 0) {
	          props[propName] = defaultProps[propName];
	        }
	      }
	    } else if (!props) {
	      props = defaultProps || {};
	    }
	
	    if (childrenLength === 1) {
	      props.children = children;
	    } else if (childrenLength > 1) {
	      var childArray = Array(childrenLength);
	
	      for (var i = 0; i < childrenLength; i++) {
	        childArray[i] = arguments[i + 3];
	      }
	
	      props.children = childArray;
	    }
	
	    return {
	      $$typeof: REACT_ELEMENT_TYPE,
	      type: type,
	      key: key === undefined ? null : '' + key,
	      ref: null,
	      props: props,
	      _owner: null
	    };
	  };
	}();
	
	var asyncToGenerator = function (fn) {
	  return function () {
	    var gen = fn.apply(this, arguments);
	    return new Promise(function (resolve, reject) {
	      function step(key, arg) {
	        try {
	          var info = gen[key](arg);
	          var value = info.value;
	        } catch (error) {
	          reject(error);
	          return;
	        }
	
	        if (info.done) {
	          resolve(value);
	        } else {
	          return Promise.resolve(value).then(function (value) {
	            return step("next", value);
	          }, function (err) {
	            return step("throw", err);
	          });
	        }
	      }
	
	      return step("next");
	    });
	  };
	};
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	var defineEnumerableProperties = function (obj, descs) {
	  for (var key in descs) {
	    var desc = descs[key];
	    desc.configurable = desc.enumerable = true;
	    if ("value" in desc) desc.writable = true;
	    Object.defineProperty(obj, key, desc);
	  }
	
	  return obj;
	};
	
	var defaults = function (obj, defaults) {
	  var keys = Object.getOwnPropertyNames(defaults);
	
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var value = Object.getOwnPropertyDescriptor(defaults, key);
	
	    if (value && value.configurable && obj[key] === undefined) {
	      Object.defineProperty(obj, key, value);
	    }
	  }
	
	  return obj;
	};
	
	var defineProperty$1 = function (obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	var get = function get(object, property, receiver) {
	  if (object === null) object = Function.prototype;
	  var desc = Object.getOwnPropertyDescriptor(object, property);
	
	  if (desc === undefined) {
	    var parent = Object.getPrototypeOf(object);
	
	    if (parent === null) {
	      return undefined;
	    } else {
	      return get(parent, property, receiver);
	    }
	  } else if ("value" in desc) {
	    return desc.value;
	  } else {
	    var getter = desc.get;
	
	    if (getter === undefined) {
	      return undefined;
	    }
	
	    return getter.call(receiver);
	  }
	};
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	var _instanceof = function (left, right) {
	  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
	    return right[Symbol.hasInstance](left);
	  } else {
	    return left instanceof right;
	  }
	};
	
	var interopRequireDefault = function (obj) {
	  return obj && obj.__esModule ? obj : {
	    default: obj
	  };
	};
	
	var interopRequireWildcard = function (obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  } else {
	    var newObj = {};
	
	    if (obj != null) {
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
	      }
	    }
	
	    newObj.default = obj;
	    return newObj;
	  }
	};
	
	var newArrowCheck = function (innerThis, boundThis) {
	  if (innerThis !== boundThis) {
	    throw new TypeError("Cannot instantiate an arrow function");
	  }
	};
	
	var objectDestructuringEmpty = function (obj) {
	  if (obj == null) throw new TypeError("Cannot destructure undefined");
	};
	
	var objectWithoutProperties = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	var selfGlobal = typeof global === "undefined" ? self : global;
	
	var set = function set(object, property, value, receiver) {
	  var desc = Object.getOwnPropertyDescriptor(object, property);
	
	  if (desc === undefined) {
	    var parent = Object.getPrototypeOf(object);
	
	    if (parent !== null) {
	      set(parent, property, value, receiver);
	    }
	  } else if ("value" in desc && desc.writable) {
	    desc.value = value;
	  } else {
	    var setter = desc.set;
	
	    if (setter !== undefined) {
	      setter.call(receiver, value);
	    }
	  }
	
	  return value;
	};
	
	var slicedToArray = function () {
	  function sliceIterator(arr, i) {
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _e = undefined;
	
	    try {
	      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);
	
	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"]) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }
	
	    return _arr;
	  }
	
	  return function (arr, i) {
	    if (Array.isArray(arr)) {
	      return arr;
	    } else if (Symbol.iterator in Object(arr)) {
	      return sliceIterator(arr, i);
	    } else {
	      throw new TypeError("Invalid attempt to destructure non-iterable instance");
	    }
	  };
	}();
	
	var slicedToArrayLoose = function (arr, i) {
	  if (Array.isArray(arr)) {
	    return arr;
	  } else if (Symbol.iterator in Object(arr)) {
	    var _arr = [];
	
	    for (var _iterator = arr[Symbol.iterator](), _step; !(_step = _iterator.next()).done;) {
	      _arr.push(_step.value);
	
	      if (i && _arr.length === i) break;
	    }
	
	    return _arr;
	  } else {
	    throw new TypeError("Invalid attempt to destructure non-iterable instance");
	  }
	};
	
	var taggedTemplateLiteral = function (strings, raw) {
	  return Object.freeze(Object.defineProperties(strings, {
	    raw: {
	      value: Object.freeze(raw)
	    }
	  }));
	};
	
	var taggedTemplateLiteralLoose = function (strings, raw) {
	  strings.raw = raw;
	  return strings;
	};
	
	var temporalRef = function (val, name, undef) {
	  if (val === undef) {
	    throw new ReferenceError(name + " is not defined - temporal dead zone");
	  } else {
	    return val;
	  }
	};
	
	var temporalUndefined = {};
	
	var toArray = function (arr) {
	  return Array.isArray(arr) ? arr : Array.from(arr);
	};
	
	var toConsumableArray = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
	
	    return arr2;
	  } else {
	    return Array.from(arr);
	  }
	};
	
	
	
	var babelHelpers$1 = Object.freeze({
	  jsx: jsx,
	  asyncToGenerator: asyncToGenerator,
	  classCallCheck: classCallCheck,
	  createClass: createClass,
	  defineEnumerableProperties: defineEnumerableProperties,
	  defaults: defaults,
	  defineProperty: defineProperty$1,
	  get: get,
	  inherits: inherits,
	  interopRequireDefault: interopRequireDefault,
	  interopRequireWildcard: interopRequireWildcard,
	  newArrowCheck: newArrowCheck,
	  objectDestructuringEmpty: objectDestructuringEmpty,
	  objectWithoutProperties: objectWithoutProperties,
	  possibleConstructorReturn: possibleConstructorReturn,
	  selfGlobal: selfGlobal,
	  set: set,
	  slicedToArray: slicedToArray,
	  slicedToArrayLoose: slicedToArrayLoose,
	  taggedTemplateLiteral: taggedTemplateLiteral,
	  taggedTemplateLiteralLoose: taggedTemplateLiteralLoose,
	  temporalRef: temporalRef,
	  temporalUndefined: temporalUndefined,
	  toArray: toArray,
	  toConsumableArray: toConsumableArray,
	  typeof: _typeof,
	  extends: _extends,
	  instanceof: _instanceof
	});
	
	var realDefineProp = function () {
	    var sentinel = function sentinel() {};
	    try {
	        Object.defineProperty(sentinel, 'a', {
	            get: function get() {
	                return 1;
	            }
	        });
	        Object.defineProperty(sentinel, 'prototype', { writable: false });
	        return sentinel.a === 1 && sentinel.prototype instanceof Object;
	    } catch (e) {
	        return false;
	    }
	}();
	
	// Need a workaround for getters in ES3
	var es3 = !realDefineProp && !Object.prototype.__defineGetter__;
	
	// We use this a lot (and need it for proto-less objects)
	var hop = Object.prototype.hasOwnProperty;
	
	// Naive defineProperty for compatibility
	var defineProperty = realDefineProp ? Object.defineProperty : function (obj, name, desc) {
	    if ('get' in desc && obj.__defineGetter__) obj.__defineGetter__(name, desc.get);else if (!hop.call(obj, name) || 'value' in desc) obj[name] = desc.value;
	};
	
	// Array.prototype.indexOf, as good as we need it to be
	var arrIndexOf = Array.prototype.indexOf || function (search) {
	    /*jshint validthis:true */
	    var t = this;
	    if (!t.length) return -1;
	
	    for (var i = arguments[1] || 0, max = t.length; i < max; i++) {
	        if (t[i] === search) return i;
	    }
	
	    return -1;
	};
	
	// Create an object with the specified prototype (2nd arg required for Record)
	var objCreate = Object.create || function (proto, props) {
	    var obj = void 0;
	
	    function F() {}
	    F.prototype = proto;
	    obj = new F();
	
	    for (var k in props) {
	        if (hop.call(props, k)) defineProperty(obj, k, props[k]);
	    }
	
	    return obj;
	};
	
	// Snapshot some (hopefully still) native built-ins
	var arrSlice = Array.prototype.slice;
	var arrConcat = Array.prototype.concat;
	var arrPush = Array.prototype.push;
	var arrJoin = Array.prototype.join;
	var arrShift = Array.prototype.shift;
	
	// Naive Function.prototype.bind for compatibility
	var fnBind = Function.prototype.bind || function (thisObj) {
	    var fn = this,
	        args = arrSlice.call(arguments, 1);
	
	    // All our (presently) bound functions have either 1 or 0 arguments. By returning
	    // different function signatures, we can pass some tests in ES3 environments
	    if (fn.length === 1) {
	        return function () {
	            return fn.apply(thisObj, arrConcat.call(args, arrSlice.call(arguments)));
	        };
	    }
	    return function () {
	        return fn.apply(thisObj, arrConcat.call(args, arrSlice.call(arguments)));
	    };
	};
	
	// Object housing internal properties for constructors
	var internals = objCreate(null);
	
	// Keep internal properties internal
	var secret = Math.random();
	
	// Helper functions
	// ================
	
	/**
	 * A function to deal with the inaccuracy of calculating log10 in pre-ES6
	 * JavaScript environments. Math.log(num) / Math.LN10 was responsible for
	 * causing issue #62.
	 */
	function log10Floor(n) {
	    // ES6 provides the more accurate Math.log10
	    if (typeof Math.log10 === 'function') return Math.floor(Math.log10(n));
	
	    var x = Math.round(Math.log(n) * Math.LOG10E);
	    return x - (Number('1e' + x) > n);
	}
	
	/**
	 * A map that doesn't contain Object in its prototype chain
	 */
	function Record(obj) {
	    // Copy only own properties over unless this object is already a Record instance
	    for (var k in obj) {
	        if (obj instanceof Record || hop.call(obj, k)) defineProperty(this, k, { value: obj[k], enumerable: true, writable: true, configurable: true });
	    }
	}
	Record.prototype = objCreate(null);
	
	/**
	 * An ordered list
	 */
	function List() {
	    defineProperty(this, 'length', { writable: true, value: 0 });
	
	    if (arguments.length) arrPush.apply(this, arrSlice.call(arguments));
	}
	List.prototype = objCreate(null);
	
	/**
	 * Constructs a regular expression to restore tainted RegExp properties
	 */
	function createRegExpRestore() {
	    if (internals.disableRegExpRestore) {
	        return function () {/* no-op */};
	    }
	
	    var regExpCache = {
	        lastMatch: RegExp.lastMatch || '',
	        leftContext: RegExp.leftContext,
	        multiline: RegExp.multiline,
	        input: RegExp.input
	    },
	        has = false;
	
	    // Create a snapshot of all the 'captured' properties
	    for (var i = 1; i <= 9; i++) {
	        has = (regExpCache['$' + i] = RegExp['$' + i]) || has;
	    }return function () {
	        // Now we've snapshotted some properties, escape the lastMatch string
	        var esc = /[.?*+^$[\]\\(){}|-]/g,
	            lm = regExpCache.lastMatch.replace(esc, '\\$&'),
	            reg = new List();
	
	        // If any of the captured strings were non-empty, iterate over them all
	        if (has) {
	            for (var _i = 1; _i <= 9; _i++) {
	                var m = regExpCache['$' + _i];
	
	                // If it's empty, add an empty capturing group
	                if (!m) lm = '()' + lm;
	
	                // Else find the string in lm and escape & wrap it to capture it
	                else {
	                        m = m.replace(esc, '\\$&');
	                        lm = lm.replace(m, '(' + m + ')');
	                    }
	
	                // Push it to the reg and chop lm to make sure further groups come after
	                arrPush.call(reg, lm.slice(0, lm.indexOf('(') + 1));
	                lm = lm.slice(lm.indexOf('(') + 1);
	            }
	        }
	
	        var exprStr = arrJoin.call(reg, '') + lm;
	
	        // Shorten the regex by replacing each part of the expression with a match
	        // for a string of that exact length.  This is safe for the type of
	        // expressions generated above, because the expression matches the whole
	        // match string, so we know each group and each segment between capturing
	        // groups can be matched by its length alone.
	        exprStr = exprStr.replace(/(\\\(|\\\)|[^()])+/g, function (match) {
	            return '[\\s\\S]{' + match.replace('\\', '').length + '}';
	        });
	
	        // Create the regular expression that will reconstruct the RegExp properties
	        var expr = new RegExp(exprStr, regExpCache.multiline ? 'gm' : 'g');
	
	        // Set the lastIndex of the generated expression to ensure that the match
	        // is found in the correct index.
	        expr.lastIndex = regExpCache.leftContext.length;
	
	        expr.exec(regExpCache.input);
	    };
	}
	
	/**
	 * Mimics ES5's abstract ToObject() function
	 */
	function toObject(arg) {
	    if (arg === null) throw new TypeError('Cannot convert null or undefined to object');
	
	    if ((typeof arg === 'undefined' ? 'undefined' : babelHelpers$1['typeof'](arg)) === 'object') return arg;
	    return Object(arg);
	}
	
	function toNumber(arg) {
	    if (typeof arg === 'number') return arg;
	    return Number(arg);
	}
	
	function toInteger(arg) {
	    var number = toNumber(arg);
	    if (isNaN(number)) return 0;
	    if (number === +0 || number === -0 || number === +Infinity || number === -Infinity) return number;
	    if (number < 0) return Math.floor(Math.abs(number)) * -1;
	    return Math.floor(Math.abs(number));
	}
	
	function toLength(arg) {
	    var len = toInteger(arg);
	    if (len <= 0) return 0;
	    if (len === Infinity) return Math.pow(2, 53) - 1;
	    return Math.min(len, Math.pow(2, 53) - 1);
	}
	
	/**
	 * Returns "internal" properties for an object
	 */
	function getInternalProperties(obj) {
	    if (hop.call(obj, '__getInternalProperties')) return obj.__getInternalProperties(secret);
	
	    return objCreate(null);
	}
	
	/**
	* Defines regular expressions for various operations related to the BCP 47 syntax,
	* as defined at http://tools.ietf.org/html/bcp47#section-2.1
	*/
	
	// extlang       = 3ALPHA              ; selected ISO 639 codes
	//                 *2("-" 3ALPHA)      ; permanently reserved
	var extlang = '[a-z]{3}(?:-[a-z]{3}){0,2}';
	
	// language      = 2*3ALPHA            ; shortest ISO 639 code
	//                 ["-" extlang]       ; sometimes followed by
	//                                     ; extended language subtags
	//               / 4ALPHA              ; or reserved for future use
	//               / 5*8ALPHA            ; or registered language subtag
	var language = '(?:[a-z]{2,3}(?:-' + extlang + ')?|[a-z]{4}|[a-z]{5,8})';
	
	// script        = 4ALPHA              ; ISO 15924 code
	var script = '[a-z]{4}';
	
	// region        = 2ALPHA              ; ISO 3166-1 code
	//               / 3DIGIT              ; UN M.49 code
	var region = '(?:[a-z]{2}|\\d{3})';
	
	// variant       = 5*8alphanum         ; registered variants
	//               / (DIGIT 3alphanum)
	var variant = '(?:[a-z0-9]{5,8}|\\d[a-z0-9]{3})';
	
	//                                     ; Single alphanumerics
	//                                     ; "x" reserved for private use
	// singleton     = DIGIT               ; 0 - 9
	//               / %x41-57             ; A - W
	//               / %x59-5A             ; Y - Z
	//               / %x61-77             ; a - w
	//               / %x79-7A             ; y - z
	var singleton = '[0-9a-wy-z]';
	
	// extension     = singleton 1*("-" (2*8alphanum))
	var extension = singleton + '(?:-[a-z0-9]{2,8})+';
	
	// privateuse    = "x" 1*("-" (1*8alphanum))
	var privateuse = 'x(?:-[a-z0-9]{1,8})+';
	
	// irregular     = "en-GB-oed"         ; irregular tags do not match
	//               / "i-ami"             ; the 'langtag' production and
	//               / "i-bnn"             ; would not otherwise be
	//               / "i-default"         ; considered 'well-formed'
	//               / "i-enochian"        ; These tags are all valid,
	//               / "i-hak"             ; but most are deprecated
	//               / "i-klingon"         ; in favor of more modern
	//               / "i-lux"             ; subtags or subtag
	//               / "i-mingo"           ; combination
	//               / "i-navajo"
	//               / "i-pwn"
	//               / "i-tao"
	//               / "i-tay"
	//               / "i-tsu"
	//               / "sgn-BE-FR"
	//               / "sgn-BE-NL"
	//               / "sgn-CH-DE"
	var irregular = '(?:en-GB-oed' + '|i-(?:ami|bnn|default|enochian|hak|klingon|lux|mingo|navajo|pwn|tao|tay|tsu)' + '|sgn-(?:BE-FR|BE-NL|CH-DE))';
	
	// regular       = "art-lojban"        ; these tags match the 'langtag'
	//               / "cel-gaulish"       ; production, but their subtags
	//               / "no-bok"            ; are not extended language
	//               / "no-nyn"            ; or variant subtags: their meaning
	//               / "zh-guoyu"          ; is defined by their registration
	//               / "zh-hakka"          ; and all of these are deprecated
	//               / "zh-min"            ; in favor of a more modern
	//               / "zh-min-nan"        ; subtag or sequence of subtags
	//               / "zh-xiang"
	var regular = '(?:art-lojban|cel-gaulish|no-bok|no-nyn' + '|zh-(?:guoyu|hakka|min|min-nan|xiang))';
	
	// grandfathered = irregular           ; non-redundant tags registered
	//               / regular             ; during the RFC 3066 era
	var grandfathered = '(?:' + irregular + '|' + regular + ')';
	
	// langtag       = language
	//                 ["-" script]
	//                 ["-" region]
	//                 *("-" variant)
	//                 *("-" extension)
	//                 ["-" privateuse]
	var langtag = language + '(?:-' + script + ')?(?:-' + region + ')?(?:-' + variant + ')*(?:-' + extension + ')*(?:-' + privateuse + ')?';
	
	// Language-Tag  = langtag             ; normal language tags
	//               / privateuse          ; private use tag
	//               / grandfathered       ; grandfathered tags
	var expBCP47Syntax = RegExp('^(?:' + langtag + '|' + privateuse + '|' + grandfathered + ')$', 'i');
	
	// Match duplicate variants in a language tag
	var expVariantDupes = RegExp('^(?!x).*?-(' + variant + ')-(?:\\w{4,8}-(?!x-))*\\1\\b', 'i');
	
	// Match duplicate singletons in a language tag (except in private use)
	var expSingletonDupes = RegExp('^(?!x).*?-(' + singleton + ')-(?:\\w+-(?!x-))*\\1\\b', 'i');
	
	// Match all extension sequences
	var expExtSequences = RegExp('-' + extension, 'ig');
	
	// Default locale is the first-added locale data for us
	var defaultLocale = void 0;
	function setDefaultLocale(locale) {
	    defaultLocale = locale;
	}
	
	// IANA Subtag Registry redundant tag and subtag maps
	var redundantTags = {
	    tags: {
	        "art-lojban": "jbo",
	        "i-ami": "ami",
	        "i-bnn": "bnn",
	        "i-hak": "hak",
	        "i-klingon": "tlh",
	        "i-lux": "lb",
	        "i-navajo": "nv",
	        "i-pwn": "pwn",
	        "i-tao": "tao",
	        "i-tay": "tay",
	        "i-tsu": "tsu",
	        "no-bok": "nb",
	        "no-nyn": "nn",
	        "sgn-BE-FR": "sfb",
	        "sgn-BE-NL": "vgt",
	        "sgn-CH-DE": "sgg",
	        "zh-guoyu": "cmn",
	        "zh-hakka": "hak",
	        "zh-min-nan": "nan",
	        "zh-xiang": "hsn",
	        "sgn-BR": "bzs",
	        "sgn-CO": "csn",
	        "sgn-DE": "gsg",
	        "sgn-DK": "dsl",
	        "sgn-ES": "ssp",
	        "sgn-FR": "fsl",
	        "sgn-GB": "bfi",
	        "sgn-GR": "gss",
	        "sgn-IE": "isg",
	        "sgn-IT": "ise",
	        "sgn-JP": "jsl",
	        "sgn-MX": "mfs",
	        "sgn-NI": "ncs",
	        "sgn-NL": "dse",
	        "sgn-NO": "nsl",
	        "sgn-PT": "psr",
	        "sgn-SE": "swl",
	        "sgn-US": "ase",
	        "sgn-ZA": "sfs",
	        "zh-cmn": "cmn",
	        "zh-cmn-Hans": "cmn-Hans",
	        "zh-cmn-Hant": "cmn-Hant",
	        "zh-gan": "gan",
	        "zh-wuu": "wuu",
	        "zh-yue": "yue"
	    },
	    subtags: {
	        BU: "MM",
	        DD: "DE",
	        FX: "FR",
	        TP: "TL",
	        YD: "YE",
	        ZR: "CD",
	        heploc: "alalc97",
	        'in': "id",
	        iw: "he",
	        ji: "yi",
	        jw: "jv",
	        mo: "ro",
	        ayx: "nun",
	        bjd: "drl",
	        ccq: "rki",
	        cjr: "mom",
	        cka: "cmr",
	        cmk: "xch",
	        drh: "khk",
	        drw: "prs",
	        gav: "dev",
	        hrr: "jal",
	        ibi: "opa",
	        kgh: "kml",
	        lcq: "ppr",
	        mst: "mry",
	        myt: "mry",
	        sca: "hle",
	        tie: "ras",
	        tkk: "twm",
	        tlw: "weo",
	        tnf: "prs",
	        ybd: "rki",
	        yma: "lrr"
	    },
	    extLang: {
	        aao: ["aao", "ar"],
	        abh: ["abh", "ar"],
	        abv: ["abv", "ar"],
	        acm: ["acm", "ar"],
	        acq: ["acq", "ar"],
	        acw: ["acw", "ar"],
	        acx: ["acx", "ar"],
	        acy: ["acy", "ar"],
	        adf: ["adf", "ar"],
	        ads: ["ads", "sgn"],
	        aeb: ["aeb", "ar"],
	        aec: ["aec", "ar"],
	        aed: ["aed", "sgn"],
	        aen: ["aen", "sgn"],
	        afb: ["afb", "ar"],
	        afg: ["afg", "sgn"],
	        ajp: ["ajp", "ar"],
	        apc: ["apc", "ar"],
	        apd: ["apd", "ar"],
	        arb: ["arb", "ar"],
	        arq: ["arq", "ar"],
	        ars: ["ars", "ar"],
	        ary: ["ary", "ar"],
	        arz: ["arz", "ar"],
	        ase: ["ase", "sgn"],
	        asf: ["asf", "sgn"],
	        asp: ["asp", "sgn"],
	        asq: ["asq", "sgn"],
	        asw: ["asw", "sgn"],
	        auz: ["auz", "ar"],
	        avl: ["avl", "ar"],
	        ayh: ["ayh", "ar"],
	        ayl: ["ayl", "ar"],
	        ayn: ["ayn", "ar"],
	        ayp: ["ayp", "ar"],
	        bbz: ["bbz", "ar"],
	        bfi: ["bfi", "sgn"],
	        bfk: ["bfk", "sgn"],
	        bjn: ["bjn", "ms"],
	        bog: ["bog", "sgn"],
	        bqn: ["bqn", "sgn"],
	        bqy: ["bqy", "sgn"],
	        btj: ["btj", "ms"],
	        bve: ["bve", "ms"],
	        bvl: ["bvl", "sgn"],
	        bvu: ["bvu", "ms"],
	        bzs: ["bzs", "sgn"],
	        cdo: ["cdo", "zh"],
	        cds: ["cds", "sgn"],
	        cjy: ["cjy", "zh"],
	        cmn: ["cmn", "zh"],
	        coa: ["coa", "ms"],
	        cpx: ["cpx", "zh"],
	        csc: ["csc", "sgn"],
	        csd: ["csd", "sgn"],
	        cse: ["cse", "sgn"],
	        csf: ["csf", "sgn"],
	        csg: ["csg", "sgn"],
	        csl: ["csl", "sgn"],
	        csn: ["csn", "sgn"],
	        csq: ["csq", "sgn"],
	        csr: ["csr", "sgn"],
	        czh: ["czh", "zh"],
	        czo: ["czo", "zh"],
	        doq: ["doq", "sgn"],
	        dse: ["dse", "sgn"],
	        dsl: ["dsl", "sgn"],
	        dup: ["dup", "ms"],
	        ecs: ["ecs", "sgn"],
	        esl: ["esl", "sgn"],
	        esn: ["esn", "sgn"],
	        eso: ["eso", "sgn"],
	        eth: ["eth", "sgn"],
	        fcs: ["fcs", "sgn"],
	        fse: ["fse", "sgn"],
	        fsl: ["fsl", "sgn"],
	        fss: ["fss", "sgn"],
	        gan: ["gan", "zh"],
	        gds: ["gds", "sgn"],
	        gom: ["gom", "kok"],
	        gse: ["gse", "sgn"],
	        gsg: ["gsg", "sgn"],
	        gsm: ["gsm", "sgn"],
	        gss: ["gss", "sgn"],
	        gus: ["gus", "sgn"],
	        hab: ["hab", "sgn"],
	        haf: ["haf", "sgn"],
	        hak: ["hak", "zh"],
	        hds: ["hds", "sgn"],
	        hji: ["hji", "ms"],
	        hks: ["hks", "sgn"],
	        hos: ["hos", "sgn"],
	        hps: ["hps", "sgn"],
	        hsh: ["hsh", "sgn"],
	        hsl: ["hsl", "sgn"],
	        hsn: ["hsn", "zh"],
	        icl: ["icl", "sgn"],
	        ils: ["ils", "sgn"],
	        inl: ["inl", "sgn"],
	        ins: ["ins", "sgn"],
	        ise: ["ise", "sgn"],
	        isg: ["isg", "sgn"],
	        isr: ["isr", "sgn"],
	        jak: ["jak", "ms"],
	        jax: ["jax", "ms"],
	        jcs: ["jcs", "sgn"],
	        jhs: ["jhs", "sgn"],
	        jls: ["jls", "sgn"],
	        jos: ["jos", "sgn"],
	        jsl: ["jsl", "sgn"],
	        jus: ["jus", "sgn"],
	        kgi: ["kgi", "sgn"],
	        knn: ["knn", "kok"],
	        kvb: ["kvb", "ms"],
	        kvk: ["kvk", "sgn"],
	        kvr: ["kvr", "ms"],
	        kxd: ["kxd", "ms"],
	        lbs: ["lbs", "sgn"],
	        lce: ["lce", "ms"],
	        lcf: ["lcf", "ms"],
	        liw: ["liw", "ms"],
	        lls: ["lls", "sgn"],
	        lsg: ["lsg", "sgn"],
	        lsl: ["lsl", "sgn"],
	        lso: ["lso", "sgn"],
	        lsp: ["lsp", "sgn"],
	        lst: ["lst", "sgn"],
	        lsy: ["lsy", "sgn"],
	        ltg: ["ltg", "lv"],
	        lvs: ["lvs", "lv"],
	        lzh: ["lzh", "zh"],
	        max: ["max", "ms"],
	        mdl: ["mdl", "sgn"],
	        meo: ["meo", "ms"],
	        mfa: ["mfa", "ms"],
	        mfb: ["mfb", "ms"],
	        mfs: ["mfs", "sgn"],
	        min: ["min", "ms"],
	        mnp: ["mnp", "zh"],
	        mqg: ["mqg", "ms"],
	        mre: ["mre", "sgn"],
	        msd: ["msd", "sgn"],
	        msi: ["msi", "ms"],
	        msr: ["msr", "sgn"],
	        mui: ["mui", "ms"],
	        mzc: ["mzc", "sgn"],
	        mzg: ["mzg", "sgn"],
	        mzy: ["mzy", "sgn"],
	        nan: ["nan", "zh"],
	        nbs: ["nbs", "sgn"],
	        ncs: ["ncs", "sgn"],
	        nsi: ["nsi", "sgn"],
	        nsl: ["nsl", "sgn"],
	        nsp: ["nsp", "sgn"],
	        nsr: ["nsr", "sgn"],
	        nzs: ["nzs", "sgn"],
	        okl: ["okl", "sgn"],
	        orn: ["orn", "ms"],
	        ors: ["ors", "ms"],
	        pel: ["pel", "ms"],
	        pga: ["pga", "ar"],
	        pks: ["pks", "sgn"],
	        prl: ["prl", "sgn"],
	        prz: ["prz", "sgn"],
	        psc: ["psc", "sgn"],
	        psd: ["psd", "sgn"],
	        pse: ["pse", "ms"],
	        psg: ["psg", "sgn"],
	        psl: ["psl", "sgn"],
	        pso: ["pso", "sgn"],
	        psp: ["psp", "sgn"],
	        psr: ["psr", "sgn"],
	        pys: ["pys", "sgn"],
	        rms: ["rms", "sgn"],
	        rsi: ["rsi", "sgn"],
	        rsl: ["rsl", "sgn"],
	        sdl: ["sdl", "sgn"],
	        sfb: ["sfb", "sgn"],
	        sfs: ["sfs", "sgn"],
	        sgg: ["sgg", "sgn"],
	        sgx: ["sgx", "sgn"],
	        shu: ["shu", "ar"],
	        slf: ["slf", "sgn"],
	        sls: ["sls", "sgn"],
	        sqk: ["sqk", "sgn"],
	        sqs: ["sqs", "sgn"],
	        ssh: ["ssh", "ar"],
	        ssp: ["ssp", "sgn"],
	        ssr: ["ssr", "sgn"],
	        svk: ["svk", "sgn"],
	        swc: ["swc", "sw"],
	        swh: ["swh", "sw"],
	        swl: ["swl", "sgn"],
	        syy: ["syy", "sgn"],
	        tmw: ["tmw", "ms"],
	        tse: ["tse", "sgn"],
	        tsm: ["tsm", "sgn"],
	        tsq: ["tsq", "sgn"],
	        tss: ["tss", "sgn"],
	        tsy: ["tsy", "sgn"],
	        tza: ["tza", "sgn"],
	        ugn: ["ugn", "sgn"],
	        ugy: ["ugy", "sgn"],
	        ukl: ["ukl", "sgn"],
	        uks: ["uks", "sgn"],
	        urk: ["urk", "ms"],
	        uzn: ["uzn", "uz"],
	        uzs: ["uzs", "uz"],
	        vgt: ["vgt", "sgn"],
	        vkk: ["vkk", "ms"],
	        vkt: ["vkt", "ms"],
	        vsi: ["vsi", "sgn"],
	        vsl: ["vsl", "sgn"],
	        vsv: ["vsv", "sgn"],
	        wuu: ["wuu", "zh"],
	        xki: ["xki", "sgn"],
	        xml: ["xml", "sgn"],
	        xmm: ["xmm", "ms"],
	        xms: ["xms", "sgn"],
	        yds: ["yds", "sgn"],
	        ysl: ["ysl", "sgn"],
	        yue: ["yue", "zh"],
	        zib: ["zib", "sgn"],
	        zlm: ["zlm", "ms"],
	        zmi: ["zmi", "ms"],
	        zsl: ["zsl", "sgn"],
	        zsm: ["zsm", "ms"]
	    }
	};
	
	/**
	 * Convert only a-z to uppercase as per section 6.1 of the spec
	 */
	function toLatinUpperCase(str) {
	    var i = str.length;
	
	    while (i--) {
	        var ch = str.charAt(i);
	
	        if (ch >= "a" && ch <= "z") str = str.slice(0, i) + ch.toUpperCase() + str.slice(i + 1);
	    }
	
	    return str;
	}
	
	/**
	 * The IsStructurallyValidLanguageTag abstract operation verifies that the locale
	 * argument (which must be a String value)
	 *
	 * - represents a well-formed BCP 47 language tag as specified in RFC 5646 section
	 *   2.1, or successor,
	 * - does not include duplicate variant subtags, and
	 * - does not include duplicate singleton subtags.
	 *
	 * The abstract operation returns true if locale can be generated from the ABNF
	 * grammar in section 2.1 of the RFC, starting with Language-Tag, and does not
	 * contain duplicate variant or singleton subtags (other than as a private use
	 * subtag). It returns false otherwise. Terminal value characters in the grammar are
	 * interpreted as the Unicode equivalents of the ASCII octet values given.
	 */
	function /* 6.2.2 */IsStructurallyValidLanguageTag(locale) {
	    // represents a well-formed BCP 47 language tag as specified in RFC 5646
	    if (!expBCP47Syntax.test(locale)) return false;
	
	    // does not include duplicate variant subtags, and
	    if (expVariantDupes.test(locale)) return false;
	
	    // does not include duplicate singleton subtags.
	    if (expSingletonDupes.test(locale)) return false;
	
	    return true;
	}
	
	/**
	 * The CanonicalizeLanguageTag abstract operation returns the canonical and case-
	 * regularized form of the locale argument (which must be a String value that is
	 * a structurally valid BCP 47 language tag as verified by the
	 * IsStructurallyValidLanguageTag abstract operation). It takes the steps
	 * specified in RFC 5646 section 4.5, or successor, to bring the language tag
	 * into canonical form, and to regularize the case of the subtags, but does not
	 * take the steps to bring a language tag into “extlang form” and to reorder
	 * variant subtags.
	
	 * The specifications for extensions to BCP 47 language tags, such as RFC 6067,
	 * may include canonicalization rules for the extension subtag sequences they
	 * define that go beyond the canonicalization rules of RFC 5646 section 4.5.
	 * Implementations are allowed, but not required, to apply these additional rules.
	 */
	function /* 6.2.3 */CanonicalizeLanguageTag(locale) {
	    var match = void 0,
	        parts = void 0;
	
	    // A language tag is in 'canonical form' when the tag is well-formed
	    // according to the rules in Sections 2.1 and 2.2
	
	    // Section 2.1 says all subtags use lowercase...
	    locale = locale.toLowerCase();
	
	    // ...with 2 exceptions: 'two-letter and four-letter subtags that neither
	    // appear at the start of the tag nor occur after singletons.  Such two-letter
	    // subtags are all uppercase (as in the tags "en-CA-x-ca" or "sgn-BE-FR") and
	    // four-letter subtags are titlecase (as in the tag "az-Latn-x-latn").
	    parts = locale.split('-');
	    for (var i = 1, max = parts.length; i < max; i++) {
	        // Two-letter subtags are all uppercase
	        if (parts[i].length === 2) parts[i] = parts[i].toUpperCase();
	
	        // Four-letter subtags are titlecase
	        else if (parts[i].length === 4) parts[i] = parts[i].charAt(0).toUpperCase() + parts[i].slice(1);
	
	            // Is it a singleton?
	            else if (parts[i].length === 1 && parts[i] !== 'x') break;
	    }
	    locale = arrJoin.call(parts, '-');
	
	    // The steps laid out in RFC 5646 section 4.5 are as follows:
	
	    // 1.  Extension sequences are ordered into case-insensitive ASCII order
	    //     by singleton subtag.
	    if ((match = locale.match(expExtSequences)) && match.length > 1) {
	        // The built-in sort() sorts by ASCII order, so use that
	        match.sort();
	
	        // Replace all extensions with the joined, sorted array
	        locale = locale.replace(RegExp('(?:' + expExtSequences.source + ')+', 'i'), arrJoin.call(match, ''));
	    }
	
	    // 2.  Redundant or grandfathered tags are replaced by their 'Preferred-
	    //     Value', if there is one.
	    if (hop.call(redundantTags.tags, locale)) locale = redundantTags.tags[locale];
	
	    // 3.  Subtags are replaced by their 'Preferred-Value', if there is one.
	    //     For extlangs, the original primary language subtag is also
	    //     replaced if there is a primary language subtag in the 'Preferred-
	    //     Value'.
	    parts = locale.split('-');
	
	    for (var _i = 1, _max = parts.length; _i < _max; _i++) {
	        if (hop.call(redundantTags.subtags, parts[_i])) parts[_i] = redundantTags.subtags[parts[_i]];else if (hop.call(redundantTags.extLang, parts[_i])) {
	            parts[_i] = redundantTags.extLang[parts[_i]][0];
	
	            // For extlang tags, the prefix needs to be removed if it is redundant
	            if (_i === 1 && redundantTags.extLang[parts[1]][1] === parts[0]) {
	                parts = arrSlice.call(parts, _i++);
	                _max -= 1;
	            }
	        }
	    }
	
	    return arrJoin.call(parts, '-');
	}
	
	/**
	 * The DefaultLocale abstract operation returns a String value representing the
	 * structurally valid (6.2.2) and canonicalized (6.2.3) BCP 47 language tag for the
	 * host environment’s current locale.
	 */
	function /* 6.2.4 */DefaultLocale() {
	    return defaultLocale;
	}
	
	// Sect 6.3 Currency Codes
	// =======================
	
	var expCurrencyCode = /^[A-Z]{3}$/;
	
	/**
	 * The IsWellFormedCurrencyCode abstract operation verifies that the currency argument
	 * (after conversion to a String value) represents a well-formed 3-letter ISO currency
	 * code. The following steps are taken:
	 */
	function /* 6.3.1 */IsWellFormedCurrencyCode(currency) {
	    // 1. Let `c` be ToString(currency)
	    var c = String(currency);
	
	    // 2. Let `normalized` be the result of mapping c to upper case as described
	    //    in 6.1.
	    var normalized = toLatinUpperCase(c);
	
	    // 3. If the string length of normalized is not 3, return false.
	    // 4. If normalized contains any character that is not in the range "A" to "Z"
	    //    (U+0041 to U+005A), return false.
	    if (expCurrencyCode.test(normalized) === false) return false;
	
	    // 5. Return true
	    return true;
	}
	
	var expUnicodeExSeq = /-u(?:-[0-9a-z]{2,8})+/gi; // See `extension` below
	
	function /* 9.2.1 */CanonicalizeLocaleList(locales) {
	    // The abstract operation CanonicalizeLocaleList takes the following steps:
	
	    // 1. If locales is undefined, then a. Return a new empty List
	    if (locales === undefined) return new List();
	
	    // 2. Let seen be a new empty List.
	    var seen = new List();
	
	    // 3. If locales is a String value, then
	    //    a. Let locales be a new array created as if by the expression new
	    //    Array(locales) where Array is the standard built-in constructor with
	    //    that name and locales is the value of locales.
	    locales = typeof locales === 'string' ? [locales] : locales;
	
	    // 4. Let O be ToObject(locales).
	    var O = toObject(locales);
	
	    // 5. Let lenValue be the result of calling the [[Get]] internal method of
	    //    O with the argument "length".
	    // 6. Let len be ToUint32(lenValue).
	    var len = toLength(O.length);
	
	    // 7. Let k be 0.
	    var k = 0;
	
	    // 8. Repeat, while k < len
	    while (k < len) {
	        // a. Let Pk be ToString(k).
	        var Pk = String(k);
	
	        // b. Let kPresent be the result of calling the [[HasProperty]] internal
	        //    method of O with argument Pk.
	        var kPresent = Pk in O;
	
	        // c. If kPresent is true, then
	        if (kPresent) {
	            // i. Let kValue be the result of calling the [[Get]] internal
	            //     method of O with argument Pk.
	            var kValue = O[Pk];
	
	            // ii. If the type of kValue is not String or Object, then throw a
	            //     TypeError exception.
	            if (kValue === null || typeof kValue !== 'string' && (typeof kValue === "undefined" ? "undefined" : babelHelpers$1["typeof"](kValue)) !== 'object') throw new TypeError('String or Object type expected');
	
	            // iii. Let tag be ToString(kValue).
	            var tag = String(kValue);
	
	            // iv. If the result of calling the abstract operation
	            //     IsStructurallyValidLanguageTag (defined in 6.2.2), passing tag as
	            //     the argument, is false, then throw a RangeError exception.
	            if (!IsStructurallyValidLanguageTag(tag)) throw new RangeError("'" + tag + "' is not a structurally valid language tag");
	
	            // v. Let tag be the result of calling the abstract operation
	            //    CanonicalizeLanguageTag (defined in 6.2.3), passing tag as the
	            //    argument.
	            tag = CanonicalizeLanguageTag(tag);
	
	            // vi. If tag is not an element of seen, then append tag as the last
	            //     element of seen.
	            if (arrIndexOf.call(seen, tag) === -1) arrPush.call(seen, tag);
	        }
	
	        // d. Increase k by 1.
	        k++;
	    }
	
	    // 9. Return seen.
	    return seen;
	}
	
	/**
	 * The BestAvailableLocale abstract operation compares the provided argument
	 * locale, which must be a String value with a structurally valid and
	 * canonicalized BCP 47 language tag, against the locales in availableLocales and
	 * returns either the longest non-empty prefix of locale that is an element of
	 * availableLocales, or undefined if there is no such element. It uses the
	 * fallback mechanism of RFC 4647, section 3.4. The following steps are taken:
	 */
	function /* 9.2.2 */BestAvailableLocale(availableLocales, locale) {
	    // 1. Let candidate be locale
	    var candidate = locale;
	
	    // 2. Repeat
	    while (candidate) {
	        // a. If availableLocales contains an element equal to candidate, then return
	        // candidate.
	        if (arrIndexOf.call(availableLocales, candidate) > -1) return candidate;
	
	        // b. Let pos be the character index of the last occurrence of "-"
	        // (U+002D) within candidate. If that character does not occur, return
	        // undefined.
	        var pos = candidate.lastIndexOf('-');
	
	        if (pos < 0) return;
	
	        // c. If pos ≥ 2 and the character "-" occurs at index pos-2 of candidate,
	        //    then decrease pos by 2.
	        if (pos >= 2 && candidate.charAt(pos - 2) === '-') pos -= 2;
	
	        // d. Let candidate be the substring of candidate from position 0, inclusive,
	        //    to position pos, exclusive.
	        candidate = candidate.substring(0, pos);
	    }
	}
	
	/**
	 * The LookupMatcher abstract operation compares requestedLocales, which must be
	 * a List as returned by CanonicalizeLocaleList, against the locales in
	 * availableLocales and determines the best available language to meet the
	 * request. The following steps are taken:
	 */
	function /* 9.2.3 */LookupMatcher(availableLocales, requestedLocales) {
	    // 1. Let i be 0.
	    var i = 0;
	
	    // 2. Let len be the number of elements in requestedLocales.
	    var len = requestedLocales.length;
	
	    // 3. Let availableLocale be undefined.
	    var availableLocale = void 0;
	
	    var locale = void 0,
	        noExtensionsLocale = void 0;
	
	    // 4. Repeat while i < len and availableLocale is undefined:
	    while (i < len && !availableLocale) {
	        // a. Let locale be the element of requestedLocales at 0-origined list
	        //    position i.
	        locale = requestedLocales[i];
	
	        // b. Let noExtensionsLocale be the String value that is locale with all
	        //    Unicode locale extension sequences removed.
	        noExtensionsLocale = String(locale).replace(expUnicodeExSeq, '');
	
	        // c. Let availableLocale be the result of calling the
	        //    BestAvailableLocale abstract operation (defined in 9.2.2) with
	        //    arguments availableLocales and noExtensionsLocale.
	        availableLocale = BestAvailableLocale(availableLocales, noExtensionsLocale);
	
	        // d. Increase i by 1.
	        i++;
	    }
	
	    // 5. Let result be a new Record.
	    var result = new Record();
	
	    // 6. If availableLocale is not undefined, then
	    if (availableLocale !== undefined) {
	        // a. Set result.[[locale]] to availableLocale.
	        result['[[locale]]'] = availableLocale;
	
	        // b. If locale and noExtensionsLocale are not the same String value, then
	        if (String(locale) !== String(noExtensionsLocale)) {
	            // i. Let extension be the String value consisting of the first
	            //    substring of locale that is a Unicode locale extension sequence.
	            var extension = locale.match(expUnicodeExSeq)[0];
	
	            // ii. Let extensionIndex be the character position of the initial
	            //     "-" of the first Unicode locale extension sequence within locale.
	            var extensionIndex = locale.indexOf('-u-');
	
	            // iii. Set result.[[extension]] to extension.
	            result['[[extension]]'] = extension;
	
	            // iv. Set result.[[extensionIndex]] to extensionIndex.
	            result['[[extensionIndex]]'] = extensionIndex;
	        }
	    }
	    // 7. Else
	    else
	        // a. Set result.[[locale]] to the value returned by the DefaultLocale abstract
	        //    operation (defined in 6.2.4).
	        result['[[locale]]'] = DefaultLocale();
	
	    // 8. Return result
	    return result;
	}
	
	/**
	 * The BestFitMatcher abstract operation compares requestedLocales, which must be
	 * a List as returned by CanonicalizeLocaleList, against the locales in
	 * availableLocales and determines the best available language to meet the
	 * request. The algorithm is implementation dependent, but should produce results
	 * that a typical user of the requested locales would perceive as at least as
	 * good as those produced by the LookupMatcher abstract operation. Options
	 * specified through Unicode locale extension sequences must be ignored by the
	 * algorithm. Information about such subsequences is returned separately.
	 * The abstract operation returns a record with a [[locale]] field, whose value
	 * is the language tag of the selected locale, which must be an element of
	 * availableLocales. If the language tag of the request locale that led to the
	 * selected locale contained a Unicode locale extension sequence, then the
	 * returned record also contains an [[extension]] field whose value is the first
	 * Unicode locale extension sequence, and an [[extensionIndex]] field whose value
	 * is the index of the first Unicode locale extension sequence within the request
	 * locale language tag.
	 */
	function /* 9.2.4 */BestFitMatcher(availableLocales, requestedLocales) {
	    return LookupMatcher(availableLocales, requestedLocales);
	}
	
	/**
	 * The ResolveLocale abstract operation compares a BCP 47 language priority list
	 * requestedLocales against the locales in availableLocales and determines the
	 * best available language to meet the request. availableLocales and
	 * requestedLocales must be provided as List values, options as a Record.
	 */
	function /* 9.2.5 */ResolveLocale(availableLocales, requestedLocales, options, relevantExtensionKeys, localeData) {
	    if (availableLocales.length === 0) {
	        throw new ReferenceError('No locale data has been provided for this object yet.');
	    }
	
	    // The following steps are taken:
	    // 1. Let matcher be the value of options.[[localeMatcher]].
	    var matcher = options['[[localeMatcher]]'];
	
	    var r = void 0;
	
	    // 2. If matcher is "lookup", then
	    if (matcher === 'lookup')
	        // a. Let r be the result of calling the LookupMatcher abstract operation
	        //    (defined in 9.2.3) with arguments availableLocales and
	        //    requestedLocales.
	        r = LookupMatcher(availableLocales, requestedLocales);
	
	        // 3. Else
	    else
	        // a. Let r be the result of calling the BestFitMatcher abstract
	        //    operation (defined in 9.2.4) with arguments availableLocales and
	        //    requestedLocales.
	        r = BestFitMatcher(availableLocales, requestedLocales);
	
	    // 4. Let foundLocale be the value of r.[[locale]].
	    var foundLocale = r['[[locale]]'];
	
	    var extensionSubtags = void 0,
	        extensionSubtagsLength = void 0;
	
	    // 5. If r has an [[extension]] field, then
	    if (hop.call(r, '[[extension]]')) {
	        // a. Let extension be the value of r.[[extension]].
	        var extension = r['[[extension]]'];
	        // b. Let split be the standard built-in function object defined in ES5,
	        //    15.5.4.14.
	        var split = String.prototype.split;
	        // c. Let extensionSubtags be the result of calling the [[Call]] internal
	        //    method of split with extension as the this value and an argument
	        //    list containing the single item "-".
	        extensionSubtags = split.call(extension, '-');
	        // d. Let extensionSubtagsLength be the result of calling the [[Get]]
	        //    internal method of extensionSubtags with argument "length".
	        extensionSubtagsLength = extensionSubtags.length;
	    }
	
	    // 6. Let result be a new Record.
	    var result = new Record();
	
	    // 7. Set result.[[dataLocale]] to foundLocale.
	    result['[[dataLocale]]'] = foundLocale;
	
	    // 8. Let supportedExtension be "-u".
	    var supportedExtension = '-u';
	    // 9. Let i be 0.
	    var i = 0;
	    // 10. Let len be the result of calling the [[Get]] internal method of
	    //     relevantExtensionKeys with argument "length".
	    var len = relevantExtensionKeys.length;
	
	    // 11 Repeat while i < len:
	    while (i < len) {
	        // a. Let key be the result of calling the [[Get]] internal method of
	        //    relevantExtensionKeys with argument ToString(i).
	        var key = relevantExtensionKeys[i];
	        // b. Let foundLocaleData be the result of calling the [[Get]] internal
	        //    method of localeData with the argument foundLocale.
	        var foundLocaleData = localeData[foundLocale];
	        // c. Let keyLocaleData be the result of calling the [[Get]] internal
	        //    method of foundLocaleData with the argument key.
	        var keyLocaleData = foundLocaleData[key];
	        // d. Let value be the result of calling the [[Get]] internal method of
	        //    keyLocaleData with argument "0".
	        var value = keyLocaleData['0'];
	        // e. Let supportedExtensionAddition be "".
	        var supportedExtensionAddition = '';
	        // f. Let indexOf be the standard built-in function object defined in
	        //    ES5, 15.4.4.14.
	        var indexOf = arrIndexOf;
	
	        // g. If extensionSubtags is not undefined, then
	        if (extensionSubtags !== undefined) {
	            // i. Let keyPos be the result of calling the [[Call]] internal
	            //    method of indexOf with extensionSubtags as the this value and
	            // an argument list containing the single item key.
	            var keyPos = indexOf.call(extensionSubtags, key);
	
	            // ii. If keyPos ≠ -1, then
	            if (keyPos !== -1) {
	                // 1. If keyPos + 1 < extensionSubtagsLength and the length of the
	                //    result of calling the [[Get]] internal method of
	                //    extensionSubtags with argument ToString(keyPos +1) is greater
	                //    than 2, then
	                if (keyPos + 1 < extensionSubtagsLength && extensionSubtags[keyPos + 1].length > 2) {
	                    // a. Let requestedValue be the result of calling the [[Get]]
	                    //    internal method of extensionSubtags with argument
	                    //    ToString(keyPos + 1).
	                    var requestedValue = extensionSubtags[keyPos + 1];
	                    // b. Let valuePos be the result of calling the [[Call]]
	                    //    internal method of indexOf with keyLocaleData as the
	                    //    this value and an argument list containing the single
	                    //    item requestedValue.
	                    var valuePos = indexOf.call(keyLocaleData, requestedValue);
	
	                    // c. If valuePos ≠ -1, then
	                    if (valuePos !== -1) {
	                        // i. Let value be requestedValue.
	                        value = requestedValue,
	                        // ii. Let supportedExtensionAddition be the
	                        //     concatenation of "-", key, "-", and value.
	                        supportedExtensionAddition = '-' + key + '-' + value;
	                    }
	                }
	                // 2. Else
	                else {
	                        // a. Let valuePos be the result of calling the [[Call]]
	                        // internal method of indexOf with keyLocaleData as the this
	                        // value and an argument list containing the single item
	                        // "true".
	                        var _valuePos = indexOf(keyLocaleData, 'true');
	
	                        // b. If valuePos ≠ -1, then
	                        if (_valuePos !== -1)
	                            // i. Let value be "true".
	                            value = 'true';
	                    }
	            }
	        }
	        // h. If options has a field [[<key>]], then
	        if (hop.call(options, '[[' + key + ']]')) {
	            // i. Let optionsValue be the value of options.[[<key>]].
	            var optionsValue = options['[[' + key + ']]'];
	
	            // ii. If the result of calling the [[Call]] internal method of indexOf
	            //     with keyLocaleData as the this value and an argument list
	            //     containing the single item optionsValue is not -1, then
	            if (indexOf.call(keyLocaleData, optionsValue) !== -1) {
	                // 1. If optionsValue is not equal to value, then
	                if (optionsValue !== value) {
	                    // a. Let value be optionsValue.
	                    value = optionsValue;
	                    // b. Let supportedExtensionAddition be "".
	                    supportedExtensionAddition = '';
	                }
	            }
	        }
	        // i. Set result.[[<key>]] to value.
	        result['[[' + key + ']]'] = value;
	
	        // j. Append supportedExtensionAddition to supportedExtension.
	        supportedExtension += supportedExtensionAddition;
	
	        // k. Increase i by 1.
	        i++;
	    }
	    // 12. If the length of supportedExtension is greater than 2, then
	    if (supportedExtension.length > 2) {
	        // a.
	        var privateIndex = foundLocale.indexOf("-x-");
	        // b.
	        if (privateIndex === -1) {
	            // i.
	            foundLocale = foundLocale + supportedExtension;
	        }
	        // c.
	        else {
	                // i.
	                var preExtension = foundLocale.substring(0, privateIndex);
	                // ii.
	                var postExtension = foundLocale.substring(privateIndex);
	                // iii.
	                foundLocale = preExtension + supportedExtension + postExtension;
	            }
	        // d. asserting - skipping
	        // e.
	        foundLocale = CanonicalizeLanguageTag(foundLocale);
	    }
	    // 13. Set result.[[locale]] to foundLocale.
	    result['[[locale]]'] = foundLocale;
	
	    // 14. Return result.
	    return result;
	}
	
	/**
	 * The LookupSupportedLocales abstract operation returns the subset of the
	 * provided BCP 47 language priority list requestedLocales for which
	 * availableLocales has a matching locale when using the BCP 47 Lookup algorithm.
	 * Locales appear in the same order in the returned list as in requestedLocales.
	 * The following steps are taken:
	 */
	function /* 9.2.6 */LookupSupportedLocales(availableLocales, requestedLocales) {
	    // 1. Let len be the number of elements in requestedLocales.
	    var len = requestedLocales.length;
	    // 2. Let subset be a new empty List.
	    var subset = new List();
	    // 3. Let k be 0.
	    var k = 0;
	
	    // 4. Repeat while k < len
	    while (k < len) {
	        // a. Let locale be the element of requestedLocales at 0-origined list
	        //    position k.
	        var locale = requestedLocales[k];
	        // b. Let noExtensionsLocale be the String value that is locale with all
	        //    Unicode locale extension sequences removed.
	        var noExtensionsLocale = String(locale).replace(expUnicodeExSeq, '');
	        // c. Let availableLocale be the result of calling the
	        //    BestAvailableLocale abstract operation (defined in 9.2.2) with
	        //    arguments availableLocales and noExtensionsLocale.
	        var availableLocale = BestAvailableLocale(availableLocales, noExtensionsLocale);
	
	        // d. If availableLocale is not undefined, then append locale to the end of
	        //    subset.
	        if (availableLocale !== undefined) arrPush.call(subset, locale);
	
	        // e. Increment k by 1.
	        k++;
	    }
	
	    // 5. Let subsetArray be a new Array object whose elements are the same
	    //    values in the same order as the elements of subset.
	    var subsetArray = arrSlice.call(subset);
	
	    // 6. Return subsetArray.
	    return subsetArray;
	}
	
	/**
	 * The BestFitSupportedLocales abstract operation returns the subset of the
	 * provided BCP 47 language priority list requestedLocales for which
	 * availableLocales has a matching locale when using the Best Fit Matcher
	 * algorithm. Locales appear in the same order in the returned list as in
	 * requestedLocales. The steps taken are implementation dependent.
	 */
	function /*9.2.7 */BestFitSupportedLocales(availableLocales, requestedLocales) {
	    // ###TODO: implement this function as described by the specification###
	    return LookupSupportedLocales(availableLocales, requestedLocales);
	}
	
	/**
	 * The SupportedLocales abstract operation returns the subset of the provided BCP
	 * 47 language priority list requestedLocales for which availableLocales has a
	 * matching locale. Two algorithms are available to match the locales: the Lookup
	 * algorithm described in RFC 4647 section 3.4, and an implementation dependent
	 * best-fit algorithm. Locales appear in the same order in the returned list as
	 * in requestedLocales. The following steps are taken:
	 */
	function /*9.2.8 */SupportedLocales(availableLocales, requestedLocales, options) {
	    var matcher = void 0,
	        subset = void 0;
	
	    // 1. If options is not undefined, then
	    if (options !== undefined) {
	        // a. Let options be ToObject(options).
	        options = new Record(toObject(options));
	        // b. Let matcher be the result of calling the [[Get]] internal method of
	        //    options with argument "localeMatcher".
	        matcher = options.localeMatcher;
	
	        // c. If matcher is not undefined, then
	        if (matcher !== undefined) {
	            // i. Let matcher be ToString(matcher).
	            matcher = String(matcher);
	
	            // ii. If matcher is not "lookup" or "best fit", then throw a RangeError
	            //     exception.
	            if (matcher !== 'lookup' && matcher !== 'best fit') throw new RangeError('matcher should be "lookup" or "best fit"');
	        }
	    }
	    // 2. If matcher is undefined or "best fit", then
	    if (matcher === undefined || matcher === 'best fit')
	        // a. Let subset be the result of calling the BestFitSupportedLocales
	        //    abstract operation (defined in 9.2.7) with arguments
	        //    availableLocales and requestedLocales.
	        subset = BestFitSupportedLocales(availableLocales, requestedLocales);
	        // 3. Else
	    else
	        // a. Let subset be the result of calling the LookupSupportedLocales
	        //    abstract operation (defined in 9.2.6) with arguments
	        //    availableLocales and requestedLocales.
	        subset = LookupSupportedLocales(availableLocales, requestedLocales);
	
	    // 4. For each named own property name P of subset,
	    for (var P in subset) {
	        if (!hop.call(subset, P)) continue;
	
	        // a. Let desc be the result of calling the [[GetOwnProperty]] internal
	        //    method of subset with P.
	        // b. Set desc.[[Writable]] to false.
	        // c. Set desc.[[Configurable]] to false.
	        // d. Call the [[DefineOwnProperty]] internal method of subset with P, desc,
	        //    and true as arguments.
	        defineProperty(subset, P, {
	            writable: false, configurable: false, value: subset[P]
	        });
	    }
	    // "Freeze" the array so no new elements can be added
	    defineProperty(subset, 'length', { writable: false });
	
	    // 5. Return subset
	    return subset;
	}
	
	/**
	 * The GetOption abstract operation extracts the value of the property named
	 * property from the provided options object, converts it to the required type,
	 * checks whether it is one of a List of allowed values, and fills in a fallback
	 * value if necessary.
	 */
	function /*9.2.9 */GetOption(options, property, type, values, fallback) {
	    // 1. Let value be the result of calling the [[Get]] internal method of
	    //    options with argument property.
	    var value = options[property];
	
	    // 2. If value is not undefined, then
	    if (value !== undefined) {
	        // a. Assert: type is "boolean" or "string".
	        // b. If type is "boolean", then let value be ToBoolean(value).
	        // c. If type is "string", then let value be ToString(value).
	        value = type === 'boolean' ? Boolean(value) : type === 'string' ? String(value) : value;
	
	        // d. If values is not undefined, then
	        if (values !== undefined) {
	            // i. If values does not contain an element equal to value, then throw a
	            //    RangeError exception.
	            if (arrIndexOf.call(values, value) === -1) throw new RangeError("'" + value + "' is not an allowed value for `" + property + '`');
	        }
	
	        // e. Return value.
	        return value;
	    }
	    // Else return fallback.
	    return fallback;
	}
	
	/**
	 * The GetNumberOption abstract operation extracts a property value from the
	 * provided options object, converts it to a Number value, checks whether it is
	 * in the allowed range, and fills in a fallback value if necessary.
	 */
	function /* 9.2.10 */GetNumberOption(options, property, minimum, maximum, fallback) {
	    // 1. Let value be the result of calling the [[Get]] internal method of
	    //    options with argument property.
	    var value = options[property];
	
	    // 2. If value is not undefined, then
	    if (value !== undefined) {
	        // a. Let value be ToNumber(value).
	        value = Number(value);
	
	        // b. If value is NaN or less than minimum or greater than maximum, throw a
	        //    RangeError exception.
	        if (isNaN(value) || value < minimum || value > maximum) throw new RangeError('Value is not a number or outside accepted range');
	
	        // c. Return floor(value).
	        return Math.floor(value);
	    }
	    // 3. Else return fallback.
	    return fallback;
	}
	
	// 8 The Intl Object
	var Intl = {};
	
	// 8.2 Function Properties of the Intl Object
	
	// 8.2.1
	// @spec[tc39/ecma402/master/spec/intl.html]
	// @clause[sec-intl.getcanonicallocales]
	function getCanonicalLocales(locales) {
	    // 1. Let ll be ? CanonicalizeLocaleList(locales).
	    var ll = CanonicalizeLocaleList(locales);
	    // 2. Return CreateArrayFromList(ll).
	    {
	        var result = [];
	
	        var len = ll.length;
	        var k = 0;
	
	        while (k < len) {
	            result[k] = ll[k];
	            k++;
	        }
	        return result;
	    }
	}
	
	Object.defineProperty(Intl, 'getCanonicalLocales', {
	    enumerable: false,
	    configurable: true,
	    writable: true,
	    value: getCanonicalLocales
	});
	
	// Currency minor units output from get-4217 grunt task, formatted
	var currencyMinorUnits = {
	    BHD: 3, BYR: 0, XOF: 0, BIF: 0, XAF: 0, CLF: 4, CLP: 0, KMF: 0, DJF: 0,
	    XPF: 0, GNF: 0, ISK: 0, IQD: 3, JPY: 0, JOD: 3, KRW: 0, KWD: 3, LYD: 3,
	    OMR: 3, PYG: 0, RWF: 0, TND: 3, UGX: 0, UYI: 0, VUV: 0, VND: 0
	};
	
	// Define the NumberFormat constructor internally so it cannot be tainted
	function NumberFormatConstructor() {
	    var locales = arguments[0];
	    var options = arguments[1];
	
	    if (!this || this === Intl) {
	        return new Intl.NumberFormat(locales, options);
	    }
	
	    return InitializeNumberFormat(toObject(this), locales, options);
	}
	
	defineProperty(Intl, 'NumberFormat', {
	    configurable: true,
	    writable: true,
	    value: NumberFormatConstructor
	});
	
	// Must explicitly set prototypes as unwritable
	defineProperty(Intl.NumberFormat, 'prototype', {
	    writable: false
	});
	
	/**
	 * The abstract operation InitializeNumberFormat accepts the arguments
	 * numberFormat (which must be an object), locales, and options. It initializes
	 * numberFormat as a NumberFormat object.
	 */
	function /*11.1.1.1 */InitializeNumberFormat(numberFormat, locales, options) {
	    // This will be a internal properties object if we're not already initialized
	    var internal = getInternalProperties(numberFormat);
	
	    // Create an object whose props can be used to restore the values of RegExp props
	    var regexpRestore = createRegExpRestore();
	
	    // 1. If numberFormat has an [[initializedIntlObject]] internal property with
	    // value true, throw a TypeError exception.
	    if (internal['[[initializedIntlObject]]'] === true) throw new TypeError('`this` object has already been initialized as an Intl object');
	
	    // Need this to access the `internal` object
	    defineProperty(numberFormat, '__getInternalProperties', {
	        value: function value() {
	            // NOTE: Non-standard, for internal use only
	            if (arguments[0] === secret) return internal;
	        }
	    });
	
	    // 2. Set the [[initializedIntlObject]] internal property of numberFormat to true.
	    internal['[[initializedIntlObject]]'] = true;
	
	    // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
	    //    abstract operation (defined in 9.2.1) with argument locales.
	    var requestedLocales = CanonicalizeLocaleList(locales);
	
	    // 4. If options is undefined, then
	    if (options === undefined)
	        // a. Let options be the result of creating a new object as if by the
	        // expression new Object() where Object is the standard built-in constructor
	        // with that name.
	        options = {};
	
	        // 5. Else
	    else
	        // a. Let options be ToObject(options).
	        options = toObject(options);
	
	    // 6. Let opt be a new Record.
	    var opt = new Record(),
	
	
	    // 7. Let matcher be the result of calling the GetOption abstract operation
	    //    (defined in 9.2.9) with the arguments options, "localeMatcher", "string",
	    //    a List containing the two String values "lookup" and "best fit", and
	    //    "best fit".
	    matcher = GetOption(options, 'localeMatcher', 'string', new List('lookup', 'best fit'), 'best fit');
	
	    // 8. Set opt.[[localeMatcher]] to matcher.
	    opt['[[localeMatcher]]'] = matcher;
	
	    // 9. Let NumberFormat be the standard built-in object that is the initial value
	    //    of Intl.NumberFormat.
	    // 10. Let localeData be the value of the [[localeData]] internal property of
	    //     NumberFormat.
	    var localeData = internals.NumberFormat['[[localeData]]'];
	
	    // 11. Let r be the result of calling the ResolveLocale abstract operation
	    //     (defined in 9.2.5) with the [[availableLocales]] internal property of
	    //     NumberFormat, requestedLocales, opt, the [[relevantExtensionKeys]]
	    //     internal property of NumberFormat, and localeData.
	    var r = ResolveLocale(internals.NumberFormat['[[availableLocales]]'], requestedLocales, opt, internals.NumberFormat['[[relevantExtensionKeys]]'], localeData);
	
	    // 12. Set the [[locale]] internal property of numberFormat to the value of
	    //     r.[[locale]].
	    internal['[[locale]]'] = r['[[locale]]'];
	
	    // 13. Set the [[numberingSystem]] internal property of numberFormat to the value
	    //     of r.[[nu]].
	    internal['[[numberingSystem]]'] = r['[[nu]]'];
	
	    // The specification doesn't tell us to do this, but it's helpful later on
	    internal['[[dataLocale]]'] = r['[[dataLocale]]'];
	
	    // 14. Let dataLocale be the value of r.[[dataLocale]].
	    var dataLocale = r['[[dataLocale]]'];
	
	    // 15. Let s be the result of calling the GetOption abstract operation with the
	    //     arguments options, "style", "string", a List containing the three String
	    //     values "decimal", "percent", and "currency", and "decimal".
	    var s = GetOption(options, 'style', 'string', new List('decimal', 'percent', 'currency'), 'decimal');
	
	    // 16. Set the [[style]] internal property of numberFormat to s.
	    internal['[[style]]'] = s;
	
	    // 17. Let c be the result of calling the GetOption abstract operation with the
	    //     arguments options, "currency", "string", undefined, and undefined.
	    var c = GetOption(options, 'currency', 'string');
	
	    // 18. If c is not undefined and the result of calling the
	    //     IsWellFormedCurrencyCode abstract operation (defined in 6.3.1) with
	    //     argument c is false, then throw a RangeError exception.
	    if (c !== undefined && !IsWellFormedCurrencyCode(c)) throw new RangeError("'" + c + "' is not a valid currency code");
	
	    // 19. If s is "currency" and c is undefined, throw a TypeError exception.
	    if (s === 'currency' && c === undefined) throw new TypeError('Currency code is required when style is currency');
	
	    var cDigits = void 0;
	
	    // 20. If s is "currency", then
	    if (s === 'currency') {
	        // a. Let c be the result of converting c to upper case as specified in 6.1.
	        c = c.toUpperCase();
	
	        // b. Set the [[currency]] internal property of numberFormat to c.
	        internal['[[currency]]'] = c;
	
	        // c. Let cDigits be the result of calling the CurrencyDigits abstract
	        //    operation (defined below) with argument c.
	        cDigits = CurrencyDigits(c);
	    }
	
	    // 21. Let cd be the result of calling the GetOption abstract operation with the
	    //     arguments options, "currencyDisplay", "string", a List containing the
	    //     three String values "code", "symbol", and "name", and "symbol".
	    var cd = GetOption(options, 'currencyDisplay', 'string', new List('code', 'symbol', 'name'), 'symbol');
	
	    // 22. If s is "currency", then set the [[currencyDisplay]] internal property of
	    //     numberFormat to cd.
	    if (s === 'currency') internal['[[currencyDisplay]]'] = cd;
	
	    // 23. Let mnid be the result of calling the GetNumberOption abstract operation
	    //     (defined in 9.2.10) with arguments options, "minimumIntegerDigits", 1, 21,
	    //     and 1.
	    var mnid = GetNumberOption(options, 'minimumIntegerDigits', 1, 21, 1);
	
	    // 24. Set the [[minimumIntegerDigits]] internal property of numberFormat to mnid.
	    internal['[[minimumIntegerDigits]]'] = mnid;
	
	    // 25. If s is "currency", then let mnfdDefault be cDigits; else let mnfdDefault
	    //     be 0.
	    var mnfdDefault = s === 'currency' ? cDigits : 0;
	
	    // 26. Let mnfd be the result of calling the GetNumberOption abstract operation
	    //     with arguments options, "minimumFractionDigits", 0, 20, and mnfdDefault.
	    var mnfd = GetNumberOption(options, 'minimumFractionDigits', 0, 20, mnfdDefault);
	
	    // 27. Set the [[minimumFractionDigits]] internal property of numberFormat to mnfd.
	    internal['[[minimumFractionDigits]]'] = mnfd;
	
	    // 28. If s is "currency", then let mxfdDefault be max(mnfd, cDigits); else if s
	    //     is "percent", then let mxfdDefault be max(mnfd, 0); else let mxfdDefault
	    //     be max(mnfd, 3).
	    var mxfdDefault = s === 'currency' ? Math.max(mnfd, cDigits) : s === 'percent' ? Math.max(mnfd, 0) : Math.max(mnfd, 3);
	
	    // 29. Let mxfd be the result of calling the GetNumberOption abstract operation
	    //     with arguments options, "maximumFractionDigits", mnfd, 20, and mxfdDefault.
	    var mxfd = GetNumberOption(options, 'maximumFractionDigits', mnfd, 20, mxfdDefault);
	
	    // 30. Set the [[maximumFractionDigits]] internal property of numberFormat to mxfd.
	    internal['[[maximumFractionDigits]]'] = mxfd;
	
	    // 31. Let mnsd be the result of calling the [[Get]] internal method of options
	    //     with argument "minimumSignificantDigits".
	    var mnsd = options.minimumSignificantDigits;
	
	    // 32. Let mxsd be the result of calling the [[Get]] internal method of options
	    //     with argument "maximumSignificantDigits".
	    var mxsd = options.maximumSignificantDigits;
	
	    // 33. If mnsd is not undefined or mxsd is not undefined, then:
	    if (mnsd !== undefined || mxsd !== undefined) {
	        // a. Let mnsd be the result of calling the GetNumberOption abstract
	        //    operation with arguments options, "minimumSignificantDigits", 1, 21,
	        //    and 1.
	        mnsd = GetNumberOption(options, 'minimumSignificantDigits', 1, 21, 1);
	
	        // b. Let mxsd be the result of calling the GetNumberOption abstract
	        //     operation with arguments options, "maximumSignificantDigits", mnsd,
	        //     21, and 21.
	        mxsd = GetNumberOption(options, 'maximumSignificantDigits', mnsd, 21, 21);
	
	        // c. Set the [[minimumSignificantDigits]] internal property of numberFormat
	        //    to mnsd, and the [[maximumSignificantDigits]] internal property of
	        //    numberFormat to mxsd.
	        internal['[[minimumSignificantDigits]]'] = mnsd;
	        internal['[[maximumSignificantDigits]]'] = mxsd;
	    }
	    // 34. Let g be the result of calling the GetOption abstract operation with the
	    //     arguments options, "useGrouping", "boolean", undefined, and true.
	    var g = GetOption(options, 'useGrouping', 'boolean', undefined, true);
	
	    // 35. Set the [[useGrouping]] internal property of numberFormat to g.
	    internal['[[useGrouping]]'] = g;
	
	    // 36. Let dataLocaleData be the result of calling the [[Get]] internal method of
	    //     localeData with argument dataLocale.
	    var dataLocaleData = localeData[dataLocale];
	
	    // 37. Let patterns be the result of calling the [[Get]] internal method of
	    //     dataLocaleData with argument "patterns".
	    var patterns = dataLocaleData.patterns;
	
	    // 38. Assert: patterns is an object (see 11.2.3)
	
	    // 39. Let stylePatterns be the result of calling the [[Get]] internal method of
	    //     patterns with argument s.
	    var stylePatterns = patterns[s];
	
	    // 40. Set the [[positivePattern]] internal property of numberFormat to the
	    //     result of calling the [[Get]] internal method of stylePatterns with the
	    //     argument "positivePattern".
	    internal['[[positivePattern]]'] = stylePatterns.positivePattern;
	
	    // 41. Set the [[negativePattern]] internal property of numberFormat to the
	    //     result of calling the [[Get]] internal method of stylePatterns with the
	    //     argument "negativePattern".
	    internal['[[negativePattern]]'] = stylePatterns.negativePattern;
	
	    // 42. Set the [[boundFormat]] internal property of numberFormat to undefined.
	    internal['[[boundFormat]]'] = undefined;
	
	    // 43. Set the [[initializedNumberFormat]] internal property of numberFormat to
	    //     true.
	    internal['[[initializedNumberFormat]]'] = true;
	
	    // In ES3, we need to pre-bind the format() function
	    if (es3) numberFormat.format = GetFormatNumber.call(numberFormat);
	
	    // Restore the RegExp properties
	    regexpRestore();
	
	    // Return the newly initialised object
	    return numberFormat;
	}
	
	function CurrencyDigits(currency) {
	    // When the CurrencyDigits abstract operation is called with an argument currency
	    // (which must be an upper case String value), the following steps are taken:
	
	    // 1. If the ISO 4217 currency and funds code list contains currency as an
	    // alphabetic code, then return the minor unit value corresponding to the
	    // currency from the list; else return 2.
	    return currencyMinorUnits[currency] !== undefined ? currencyMinorUnits[currency] : 2;
	}
	
	/* 11.2.3 */internals.NumberFormat = {
	    '[[availableLocales]]': [],
	    '[[relevantExtensionKeys]]': ['nu'],
	    '[[localeData]]': {}
	};
	
	/**
	 * When the supportedLocalesOf method of Intl.NumberFormat is called, the
	 * following steps are taken:
	 */
	/* 11.2.2 */
	defineProperty(Intl.NumberFormat, 'supportedLocalesOf', {
	    configurable: true,
	    writable: true,
	    value: fnBind.call(function (locales) {
	        // Bound functions only have the `this` value altered if being used as a constructor,
	        // this lets us imitate a native function that has no constructor
	        if (!hop.call(this, '[[availableLocales]]')) throw new TypeError('supportedLocalesOf() is not a constructor');
	
	        // Create an object whose props can be used to restore the values of RegExp props
	        var regexpRestore = createRegExpRestore(),
	
	
	        // 1. If options is not provided, then let options be undefined.
	        options = arguments[1],
	
	
	        // 2. Let availableLocales be the value of the [[availableLocales]] internal
	        //    property of the standard built-in object that is the initial value of
	        //    Intl.NumberFormat.
	
	        availableLocales = this['[[availableLocales]]'],
	
	
	        // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
	        //    abstract operation (defined in 9.2.1) with argument locales.
	        requestedLocales = CanonicalizeLocaleList(locales);
	
	        // Restore the RegExp properties
	        regexpRestore();
	
	        // 4. Return the result of calling the SupportedLocales abstract operation
	        //    (defined in 9.2.8) with arguments availableLocales, requestedLocales,
	        //    and options.
	        return SupportedLocales(availableLocales, requestedLocales, options);
	    }, internals.NumberFormat)
	});
	
	/**
	 * This named accessor property returns a function that formats a number
	 * according to the effective locale and the formatting options of this
	 * NumberFormat object.
	 */
	/* 11.3.2 */defineProperty(Intl.NumberFormat.prototype, 'format', {
	    configurable: true,
	    get: GetFormatNumber
	});
	
	function GetFormatNumber() {
	    var internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);
	
	    // Satisfy test 11.3_b
	    if (!internal || !internal['[[initializedNumberFormat]]']) throw new TypeError('`this` value for format() is not an initialized Intl.NumberFormat object.');
	
	    // The value of the [[Get]] attribute is a function that takes the following
	    // steps:
	
	    // 1. If the [[boundFormat]] internal property of this NumberFormat object
	    //    is undefined, then:
	    if (internal['[[boundFormat]]'] === undefined) {
	        // a. Let F be a Function object, with internal properties set as
	        //    specified for built-in functions in ES5, 15, or successor, and the
	        //    length property set to 1, that takes the argument value and
	        //    performs the following steps:
	        var F = function F(value) {
	            // i. If value is not provided, then let value be undefined.
	            // ii. Let x be ToNumber(value).
	            // iii. Return the result of calling the FormatNumber abstract
	            //      operation (defined below) with arguments this and x.
	            return FormatNumber(this, /* x = */Number(value));
	        };
	
	        // b. Let bind be the standard built-in function object defined in ES5,
	        //    15.3.4.5.
	        // c. Let bf be the result of calling the [[Call]] internal method of
	        //    bind with F as the this value and an argument list containing
	        //    the single item this.
	        var bf = fnBind.call(F, this);
	
	        // d. Set the [[boundFormat]] internal property of this NumberFormat
	        //    object to bf.
	        internal['[[boundFormat]]'] = bf;
	    }
	    // Return the value of the [[boundFormat]] internal property of this
	    // NumberFormat object.
	    return internal['[[boundFormat]]'];
	}
	
	function formatToParts() {
	    var value = arguments.length <= 0 || arguments[0] === undefined ? undefined : arguments[0];
	
	    var internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);
	    if (!internal || !internal['[[initializedNumberFormat]]']) throw new TypeError('`this` value for formatToParts() is not an initialized Intl.NumberFormat object.');
	
	    var x = Number(value);
	    return FormatNumberToParts(this, x);
	}
	
	Object.defineProperty(Intl.NumberFormat.prototype, 'formatToParts', {
	    configurable: true,
	    enumerable: false,
	    writable: true,
	    value: formatToParts
	});
	
	/*
	 * @spec[stasm/ecma402/number-format-to-parts/spec/numberformat.html]
	 * @clause[sec-formatnumbertoparts]
	 */
	function FormatNumberToParts(numberFormat, x) {
	    // 1. Let parts be ? PartitionNumberPattern(numberFormat, x).
	    var parts = PartitionNumberPattern(numberFormat, x);
	    // 2. Let result be ArrayCreate(0).
	    var result = [];
	    // 3. Let n be 0.
	    var n = 0;
	    // 4. For each part in parts, do:
	    for (var i = 0; parts.length > i; i++) {
	        var part = parts[i];
	        // a. Let O be ObjectCreate(%ObjectPrototype%).
	        var O = {};
	        // a. Perform ? CreateDataPropertyOrThrow(O, "type", part.[[type]]).
	        O.type = part['[[type]]'];
	        // a. Perform ? CreateDataPropertyOrThrow(O, "value", part.[[value]]).
	        O.value = part['[[value]]'];
	        // a. Perform ? CreateDataPropertyOrThrow(result, ? ToString(n), O).
	        result[n] = O;
	        // a. Increment n by 1.
	        n += 1;
	    }
	    // 5. Return result.
	    return result;
	}
	
	/*
	 * @spec[stasm/ecma402/number-format-to-parts/spec/numberformat.html]
	 * @clause[sec-partitionnumberpattern]
	 */
	function PartitionNumberPattern(numberFormat, x) {
	
	    var internal = getInternalProperties(numberFormat),
	        locale = internal['[[dataLocale]]'],
	        nums = internal['[[numberingSystem]]'],
	        data = internals.NumberFormat['[[localeData]]'][locale],
	        ild = data.symbols[nums] || data.symbols.latn,
	        pattern = void 0;
	
	    // 1. If x is not NaN and x < 0, then:
	    if (!isNaN(x) && x < 0) {
	        // a. Let x be -x.
	        x = -x;
	        // a. Let pattern be the value of numberFormat.[[negativePattern]].
	        pattern = internal['[[negativePattern]]'];
	    }
	    // 2. Else,
	    else {
	            // a. Let pattern be the value of numberFormat.[[positivePattern]].
	            pattern = internal['[[positivePattern]]'];
	        }
	    // 3. Let result be a new empty List.
	    var result = new List();
	    // 4. Let beginIndex be Call(%StringProto_indexOf%, pattern, "{", 0).
	    var beginIndex = pattern.indexOf('{', 0);
	    // 5. Let endIndex be 0.
	    var endIndex = 0;
	    // 6. Let nextIndex be 0.
	    var nextIndex = 0;
	    // 7. Let length be the number of code units in pattern.
	    var length = pattern.length;
	    // 8. Repeat while beginIndex is an integer index into pattern:
	    while (beginIndex > -1 && beginIndex < length) {
	        // a. Set endIndex to Call(%StringProto_indexOf%, pattern, "}", beginIndex)
	        endIndex = pattern.indexOf('}', beginIndex);
	        // a. If endIndex = -1, throw new Error exception.
	        if (endIndex === -1) throw new Error();
	        // a. If beginIndex is greater than nextIndex, then:
	        if (beginIndex > nextIndex) {
	            // i. Let literal be a substring of pattern from position nextIndex, inclusive, to position beginIndex, exclusive.
	            var literal = pattern.substring(nextIndex, beginIndex);
	            // ii. Add new part record { [[type]]: "literal", [[value]]: literal } as a new element of the list result.
	            arrPush.call(result, { '[[type]]': 'literal', '[[value]]': literal });
	        }
	        // a. Let p be the substring of pattern from position beginIndex, exclusive, to position endIndex, exclusive.
	        var p = pattern.substring(beginIndex + 1, endIndex);
	        // a. If p is equal "number", then:
	        if (p === "number") {
	            // i. If x is NaN,
	            if (isNaN(x)) {
	                // 1. Let n be an ILD String value indicating the NaN value.
	                var n = ild.nan;
	                // 2. Add new part record { [[type]]: "nan", [[value]]: n } as a new element of the list result.
	                arrPush.call(result, { '[[type]]': 'nan', '[[value]]': n });
	            }
	            // ii. Else if isFinite(x) is false,
	            else if (!isFinite(x)) {
	                    // 1. Let n be an ILD String value indicating infinity.
	                    var _n = ild.infinity;
	                    // 2. Add new part record { [[type]]: "infinity", [[value]]: n } as a new element of the list result.
	                    arrPush.call(result, { '[[type]]': 'infinity', '[[value]]': _n });
	                }
	                // iii. Else,
	                else {
	                        // 1. If the value of numberFormat.[[style]] is "percent" and isFinite(x), let x be 100 × x.
	                        if (internal['[[style]]'] === 'percent' && isFinite(x)) x *= 100;
	
	                        var _n2 = void 0;
	                        // 2. If the numberFormat.[[minimumSignificantDigits]] and numberFormat.[[maximumSignificantDigits]] are present, then
	                        if (hop.call(internal, '[[minimumSignificantDigits]]') && hop.call(internal, '[[maximumSignificantDigits]]')) {
	                            // a. Let n be ToRawPrecision(x, numberFormat.[[minimumSignificantDigits]], numberFormat.[[maximumSignificantDigits]]).
	                            _n2 = ToRawPrecision(x, internal['[[minimumSignificantDigits]]'], internal['[[maximumSignificantDigits]]']);
	                        }
	                        // 3. Else,
	                        else {
	                                // a. Let n be ToRawFixed(x, numberFormat.[[minimumIntegerDigits]], numberFormat.[[minimumFractionDigits]], numberFormat.[[maximumFractionDigits]]).
	                                _n2 = ToRawFixed(x, internal['[[minimumIntegerDigits]]'], internal['[[minimumFractionDigits]]'], internal['[[maximumFractionDigits]]']);
	                            }
	                        // 4. If the value of the numberFormat.[[numberingSystem]] matches one of the values in the "Numbering System" column of Table 2 below, then
	                        if (numSys[nums]) {
	                            (function () {
	                                // a. Let digits be an array whose 10 String valued elements are the UTF-16 string representations of the 10 digits specified in the "Digits" column of the matching row in Table 2.
	                                var digits = numSys[nums];
	                                // a. Replace each digit in n with the value of digits[digit].
	                                _n2 = String(_n2).replace(/\d/g, function (digit) {
	                                    return digits[digit];
	                                });
	                            })();
	                        }
	                        // 5. Else use an implementation dependent algorithm to map n to the appropriate representation of n in the given numbering system.
	                        else _n2 = String(_n2); // ###TODO###
	
	                        var integer = void 0;
	                        var fraction = void 0;
	                        // 6. Let decimalSepIndex be Call(%StringProto_indexOf%, n, ".", 0).
	                        var decimalSepIndex = _n2.indexOf('.', 0);
	                        // 7. If decimalSepIndex > 0, then:
	                        if (decimalSepIndex > 0) {
	                            // a. Let integer be the substring of n from position 0, inclusive, to position decimalSepIndex, exclusive.
	                            integer = _n2.substring(0, decimalSepIndex);
	                            // a. Let fraction be the substring of n from position decimalSepIndex, exclusive, to the end of n.
	                            fraction = _n2.substring(decimalSepIndex + 1, decimalSepIndex.length);
	                        }
	                        // 8. Else:
	                        else {
	                                // a. Let integer be n.
	                                integer = _n2;
	                                // a. Let fraction be undefined.
	                                fraction = undefined;
	                            }
	                        // 9. If the value of the numberFormat.[[useGrouping]] is true,
	                        if (internal['[[useGrouping]]'] === true) {
	                            // a. Let groupSepSymbol be the ILND String representing the grouping separator.
	                            var groupSepSymbol = ild.group;
	                            // a. Let groups be a List whose elements are, in left to right order, the substrings defined by ILND set of locations within the integer.
	                            var groups = [];
	                            // ----> implementation:
	                            // Primary group represents the group closest to the decimal
	                            var pgSize = data.patterns.primaryGroupSize || 3;
	                            // Secondary group is every other group
	                            var sgSize = data.patterns.secondaryGroupSize || pgSize;
	                            // Group only if necessary
	                            if (integer.length > pgSize) {
	                                // Index of the primary grouping separator
	                                var end = integer.length - pgSize;
	                                // Starting index for our loop
	                                var idx = end % sgSize;
	                                var start = integer.slice(0, idx);
	                                if (start.length) arrPush.call(groups, start);
	                                // Loop to separate into secondary grouping digits
	                                while (idx < end) {
	                                    arrPush.call(groups, integer.slice(idx, idx + sgSize));
	                                    idx += sgSize;
	                                }
	                                // Add the primary grouping digits
	                                arrPush.call(groups, integer.slice(end));
	                            } else {
	                                arrPush.call(groups, integer);
	                            }
	                            // a. Assert: The number of elements in groups List is greater than 0.
	                            if (groups.length === 0) throw new Error();
	                            // a. Repeat, while groups List is not empty:
	                            while (groups.length) {
	                                // i. Remove the first element from groups and let integerGroup be the value of that element.
	                                var integerGroup = arrShift.call(groups);
	                                // ii. Add new part record { [[type]]: "integer", [[value]]: integerGroup } as a new element of the list result.
	                                arrPush.call(result, { '[[type]]': 'integer', '[[value]]': integerGroup });
	                                // iii. If groups List is not empty, then:
	                                if (groups.length) {
	                                    // 1. Add new part record { [[type]]: "group", [[value]]: groupSepSymbol } as a new element of the list result.
	                                    arrPush.call(result, { '[[type]]': 'group', '[[value]]': groupSepSymbol });
	                                }
	                            }
	                        }
	                        // 10. Else,
	                        else {
	                                // a. Add new part record { [[type]]: "integer", [[value]]: integer } as a new element of the list result.
	                                arrPush.call(result, { '[[type]]': 'integer', '[[value]]': integer });
	                            }
	                        // 11. If fraction is not undefined, then:
	                        if (fraction !== undefined) {
	                            // a. Let decimalSepSymbol be the ILND String representing the decimal separator.
	                            var decimalSepSymbol = ild.decimal;
	                            // a. Add new part record { [[type]]: "decimal", [[value]]: decimalSepSymbol } as a new element of the list result.
	                            arrPush.call(result, { '[[type]]': 'decimal', '[[value]]': decimalSepSymbol });
	                            // a. Add new part record { [[type]]: "fraction", [[value]]: fraction } as a new element of the list result.
	                            arrPush.call(result, { '[[type]]': 'fraction', '[[value]]': fraction });
	                        }
	                    }
	        }
	        // a. Else if p is equal "plusSign", then:
	        else if (p === "plusSign") {
	                // i. Let plusSignSymbol be the ILND String representing the plus sign.
	                var plusSignSymbol = ild.plusSign;
	                // ii. Add new part record { [[type]]: "plusSign", [[value]]: plusSignSymbol } as a new element of the list result.
	                arrPush.call(result, { '[[type]]': 'plusSign', '[[value]]': plusSignSymbol });
	            }
	            // a. Else if p is equal "minusSign", then:
	            else if (p === "minusSign") {
	                    // i. Let minusSignSymbol be the ILND String representing the minus sign.
	                    var minusSignSymbol = ild.minusSign;
	                    // ii. Add new part record { [[type]]: "minusSign", [[value]]: minusSignSymbol } as a new element of the list result.
	                    arrPush.call(result, { '[[type]]': 'minusSign', '[[value]]': minusSignSymbol });
	                }
	                // a. Else if p is equal "percentSign" and numberFormat.[[style]] is "percent", then:
	                else if (p === "percentSign" && internal['[[style]]'] === "percent") {
	                        // i. Let percentSignSymbol be the ILND String representing the percent sign.
	                        var percentSignSymbol = ild.percentSign;
	                        // ii. Add new part record { [[type]]: "percentSign", [[value]]: percentSignSymbol } as a new element of the list result.
	                        arrPush.call(result, { '[[type]]': 'literal', '[[value]]': percentSignSymbol });
	                    }
	                    // a. Else if p is equal "currency" and numberFormat.[[style]] is "currency", then:
	                    else if (p === "currency" && internal['[[style]]'] === "currency") {
	                            // i. Let currency be the value of numberFormat.[[currency]].
	                            var currency = internal['[[currency]]'];
	
	                            var cd = void 0;
	
	                            // ii. If numberFormat.[[currencyDisplay]] is "code", then
	                            if (internal['[[currencyDisplay]]'] === "code") {
	                                // 1. Let cd be currency.
	                                cd = currency;
	                            }
	                            // iii. Else if numberFormat.[[currencyDisplay]] is "symbol", then
	                            else if (internal['[[currencyDisplay]]'] === "symbol") {
	                                    // 1. Let cd be an ILD string representing currency in short form. If the implementation does not have such a representation of currency, use currency itself.
	                                    cd = data.currencies[currency] || currency;
	                                }
	                                // iv. Else if numberFormat.[[currencyDisplay]] is "name", then
	                                else if (internal['[[currencyDisplay]]'] === "name") {
	                                        // 1. Let cd be an ILD string representing currency in long form. If the implementation does not have such a representation of currency, then use currency itself.
	                                        cd = currency;
	                                    }
	                            // v. Add new part record { [[type]]: "currency", [[value]]: cd } as a new element of the list result.
	                            arrPush.call(result, { '[[type]]': 'currency', '[[value]]': cd });
	                        }
	                        // a. Else,
	                        else {
	                                // i. Let literal be the substring of pattern from position beginIndex, inclusive, to position endIndex, inclusive.
	                                var _literal = pattern.substring(beginIndex, endIndex);
	                                // ii. Add new part record { [[type]]: "literal", [[value]]: literal } as a new element of the list result.
	                                arrPush.call(result, { '[[type]]': 'literal', '[[value]]': _literal });
	                            }
	        // a. Set nextIndex to endIndex + 1.
	        nextIndex = endIndex + 1;
	        // a. Set beginIndex to Call(%StringProto_indexOf%, pattern, "{", nextIndex)
	        beginIndex = pattern.indexOf('{', nextIndex);
	    }
	    // 9. If nextIndex is less than length, then:
	    if (nextIndex < length) {
	        // a. Let literal be the substring of pattern from position nextIndex, inclusive, to position length, exclusive.
	        var _literal2 = pattern.substring(nextIndex, length);
	        // a. Add new part record { [[type]]: "literal", [[value]]: literal } as a new element of the list result.
	        arrPush.call(result, { '[[type]]': 'literal', '[[value]]': _literal2 });
	    }
	    // 10. Return result.
	    return result;
	}
	
	/*
	 * @spec[stasm/ecma402/number-format-to-parts/spec/numberformat.html]
	 * @clause[sec-formatnumber]
	 */
	function FormatNumber(numberFormat, x) {
	    // 1. Let parts be ? PartitionNumberPattern(numberFormat, x).
	    var parts = PartitionNumberPattern(numberFormat, x);
	    // 2. Let result be an empty String.
	    var result = '';
	    // 3. For each part in parts, do:
	    for (var i = 0; parts.length > i; i++) {
	        var part = parts[i];
	        // a. Set result to a String value produced by concatenating result and part.[[value]].
	        result += part['[[value]]'];
	    }
	    // 4. Return result.
	    return result;
	}
	
	/**
	 * When the ToRawPrecision abstract operation is called with arguments x (which
	 * must be a finite non-negative number), minPrecision, and maxPrecision (both
	 * must be integers between 1 and 21) the following steps are taken:
	 */
	function ToRawPrecision(x, minPrecision, maxPrecision) {
	    // 1. Let p be maxPrecision.
	    var p = maxPrecision;
	
	    var m = void 0,
	        e = void 0;
	
	    // 2. If x = 0, then
	    if (x === 0) {
	        // a. Let m be the String consisting of p occurrences of the character "0".
	        m = arrJoin.call(Array(p + 1), '0');
	        // b. Let e be 0.
	        e = 0;
	    }
	    // 3. Else
	    else {
	            // a. Let e and n be integers such that 10ᵖ⁻¹ ≤ n < 10ᵖ and for which the
	            //    exact mathematical value of n × 10ᵉ⁻ᵖ⁺¹ – x is as close to zero as
	            //    possible. If there are two such sets of e and n, pick the e and n for
	            //    which n × 10ᵉ⁻ᵖ⁺¹ is larger.
	            e = log10Floor(Math.abs(x));
	
	            // Easier to get to m from here
	            var f = Math.round(Math.exp(Math.abs(e - p + 1) * Math.LN10));
	
	            // b. Let m be the String consisting of the digits of the decimal
	            //    representation of n (in order, with no leading zeroes)
	            m = String(Math.round(e - p + 1 < 0 ? x * f : x / f));
	        }
	
	    // 4. If e ≥ p, then
	    if (e >= p)
	        // a. Return the concatenation of m and e-p+1 occurrences of the character "0".
	        return m + arrJoin.call(Array(e - p + 1 + 1), '0');
	
	        // 5. If e = p-1, then
	    else if (e === p - 1)
	            // a. Return m.
	            return m;
	
	            // 6. If e ≥ 0, then
	        else if (e >= 0)
	                // a. Let m be the concatenation of the first e+1 characters of m, the character
	                //    ".", and the remaining p–(e+1) characters of m.
	                m = m.slice(0, e + 1) + '.' + m.slice(e + 1);
	
	                // 7. If e < 0, then
	            else if (e < 0)
	                    // a. Let m be the concatenation of the String "0.", –(e+1) occurrences of the
	                    //    character "0", and the string m.
	                    m = '0.' + arrJoin.call(Array(-(e + 1) + 1), '0') + m;
	
	    // 8. If m contains the character ".", and maxPrecision > minPrecision, then
	    if (m.indexOf(".") >= 0 && maxPrecision > minPrecision) {
	        // a. Let cut be maxPrecision – minPrecision.
	        var cut = maxPrecision - minPrecision;
	
	        // b. Repeat while cut > 0 and the last character of m is "0":
	        while (cut > 0 && m.charAt(m.length - 1) === '0') {
	            //  i. Remove the last character from m.
	            m = m.slice(0, -1);
	
	            //  ii. Decrease cut by 1.
	            cut--;
	        }
	
	        // c. If the last character of m is ".", then
	        if (m.charAt(m.length - 1) === '.')
	            //    i. Remove the last character from m.
	            m = m.slice(0, -1);
	    }
	    // 9. Return m.
	    return m;
	}
	
	/**
	 * @spec[tc39/ecma402/master/spec/numberformat.html]
	 * @clause[sec-torawfixed]
	 * When the ToRawFixed abstract operation is called with arguments x (which must
	 * be a finite non-negative number), minInteger (which must be an integer between
	 * 1 and 21), minFraction, and maxFraction (which must be integers between 0 and
	 * 20) the following steps are taken:
	 */
	function ToRawFixed(x, minInteger, minFraction, maxFraction) {
	    // 1. Let f be maxFraction.
	    var f = maxFraction;
	    // 2. Let n be an integer for which the exact mathematical value of n ÷ 10f – x is as close to zero as possible. If there are two such n, pick the larger n.
	    var n = Math.pow(10, f) * x; // diverging...
	    // 3. If n = 0, let m be the String "0". Otherwise, let m be the String consisting of the digits of the decimal representation of n (in order, with no leading zeroes).
	    var m = n === 0 ? "0" : n.toFixed(0); // divering...
	
	    {
	        // this diversion is needed to take into consideration big numbers, e.g.:
	        // 1.2344501e+37 -> 12344501000000000000000000000000000000
	        var idx = void 0;
	        var exp = (idx = m.indexOf('e')) > -1 ? m.slice(idx + 1) : 0;
	        if (exp) {
	            m = m.slice(0, idx).replace('.', '');
	            m += arrJoin.call(Array(exp - (m.length - 1) + 1), '0');
	        }
	    }
	
	    var int = void 0;
	    // 4. If f ≠ 0, then
	    if (f !== 0) {
	        // a. Let k be the number of characters in m.
	        var k = m.length;
	        // a. If k ≤ f, then
	        if (k <= f) {
	            // i. Let z be the String consisting of f+1–k occurrences of the character "0".
	            var z = arrJoin.call(Array(f + 1 - k + 1), '0');
	            // ii. Let m be the concatenation of Strings z and m.
	            m = z + m;
	            // iii. Let k be f+1.
	            k = f + 1;
	        }
	        // a. Let a be the first k–f characters of m, and let b be the remaining f characters of m.
	        var a = m.substring(0, k - f),
	            b = m.substring(k - f, m.length);
	        // a. Let m be the concatenation of the three Strings a, ".", and b.
	        m = a + "." + b;
	        // a. Let int be the number of characters in a.
	        int = a.length;
	    }
	    // 5. Else, let int be the number of characters in m.
	    else int = m.length;
	    // 6. Let cut be maxFraction – minFraction.
	    var cut = maxFraction - minFraction;
	    // 7. Repeat while cut > 0 and the last character of m is "0":
	    while (cut > 0 && m.slice(-1) === "0") {
	        // a. Remove the last character from m.
	        m = m.slice(0, -1);
	        // a. Decrease cut by 1.
	        cut--;
	    }
	    // 8. If the last character of m is ".", then
	    if (m.slice(-1) === ".") {
	        // a. Remove the last character from m.
	        m = m.slice(0, -1);
	    }
	    // 9. If int < minInteger, then
	    if (int < minInteger) {
	        // a. Let z be the String consisting of minInteger–int occurrences of the character "0".
	        var _z = arrJoin.call(Array(minInteger - int + 1), '0');
	        // a. Let m be the concatenation of Strings z and m.
	        m = _z + m;
	    }
	    // 10. Return m.
	    return m;
	}
	
	// Sect 11.3.2 Table 2, Numbering systems
	// ======================================
	var numSys = {
	    arab: ["٠", "١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩"],
	    arabext: ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"],
	    bali: ["᭐", "᭑", "᭒", "᭓", "᭔", "᭕", "᭖", "᭗", "᭘", "᭙"],
	    beng: ["০", "১", "২", "৩", "৪", "৫", "৬", "৭", "৮", "৯"],
	    deva: ["०", "१", "२", "३", "४", "५", "६", "७", "८", "९"],
	    fullwide: ["０", "１", "２", "３", "４", "５", "６", "７", "８", "９"],
	    gujr: ["૦", "૧", "૨", "૩", "૪", "૫", "૬", "૭", "૮", "૯"],
	    guru: ["੦", "੧", "੨", "੩", "੪", "੫", "੬", "੭", "੮", "੯"],
	    hanidec: ["〇", "一", "二", "三", "四", "五", "六", "七", "八", "九"],
	    khmr: ["០", "១", "២", "៣", "៤", "៥", "៦", "៧", "៨", "៩"],
	    knda: ["೦", "೧", "೨", "೩", "೪", "೫", "೬", "೭", "೮", "೯"],
	    laoo: ["໐", "໑", "໒", "໓", "໔", "໕", "໖", "໗", "໘", "໙"],
	    latn: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
	    limb: ["᥆", "᥇", "᥈", "᥉", "᥊", "᥋", "᥌", "᥍", "᥎", "᥏"],
	    mlym: ["൦", "൧", "൨", "൩", "൪", "൫", "൬", "൭", "൮", "൯"],
	    mong: ["᠐", "᠑", "᠒", "᠓", "᠔", "᠕", "᠖", "᠗", "᠘", "᠙"],
	    mymr: ["၀", "၁", "၂", "၃", "၄", "၅", "၆", "၇", "၈", "၉"],
	    orya: ["୦", "୧", "୨", "୩", "୪", "୫", "୬", "୭", "୮", "୯"],
	    tamldec: ["௦", "௧", "௨", "௩", "௪", "௫", "௬", "௭", "௮", "௯"],
	    telu: ["౦", "౧", "౨", "౩", "౪", "౫", "౬", "౭", "౮", "౯"],
	    thai: ["๐", "๑", "๒", "๓", "๔", "๕", "๖", "๗", "๘", "๙"],
	    tibt: ["༠", "༡", "༢", "༣", "༤", "༥", "༦", "༧", "༨", "༩"]
	};
	
	/**
	 * This function provides access to the locale and formatting options computed
	 * during initialization of the object.
	 *
	 * The function returns a new object whose properties and attributes are set as
	 * if constructed by an object literal assigning to each of the following
	 * properties the value of the corresponding internal property of this
	 * NumberFormat object (see 11.4): locale, numberingSystem, style, currency,
	 * currencyDisplay, minimumIntegerDigits, minimumFractionDigits,
	 * maximumFractionDigits, minimumSignificantDigits, maximumSignificantDigits, and
	 * useGrouping. Properties whose corresponding internal properties are not present
	 * are not assigned.
	 */
	/* 11.3.3 */defineProperty(Intl.NumberFormat.prototype, 'resolvedOptions', {
	    configurable: true,
	    writable: true,
	    value: function value() {
	        var prop = void 0,
	            descs = new Record(),
	            props = ['locale', 'numberingSystem', 'style', 'currency', 'currencyDisplay', 'minimumIntegerDigits', 'minimumFractionDigits', 'maximumFractionDigits', 'minimumSignificantDigits', 'maximumSignificantDigits', 'useGrouping'],
	            internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);
	
	        // Satisfy test 11.3_b
	        if (!internal || !internal['[[initializedNumberFormat]]']) throw new TypeError('`this` value for resolvedOptions() is not an initialized Intl.NumberFormat object.');
	
	        for (var i = 0, max = props.length; i < max; i++) {
	            if (hop.call(internal, prop = '[[' + props[i] + ']]')) descs[props[i]] = { value: internal[prop], writable: true, configurable: true, enumerable: true };
	        }
	
	        return objCreate({}, descs);
	    }
	});
	
	/* jslint esnext: true */
	
	// Match these datetime components in a CLDR pattern, except those in single quotes
	var expDTComponents = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
	// trim patterns after transformations
	var expPatternTrimmer = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
	// Skip over patterns with these datetime components because we don't have data
	// to back them up:
	// timezone, weekday, amoung others
	var unwantedDTCs = /[rqQASjJgwWIQq]/; // xXVO were removed from this list in favor of computing matches with timeZoneName values but printing as empty string
	
	var dtKeys = ["era", "year", "month", "day", "weekday", "quarter"];
	var tmKeys = ["hour", "minute", "second", "hour12", "timeZoneName"];
	
	function isDateFormatOnly(obj) {
	    for (var i = 0; i < tmKeys.length; i += 1) {
	        if (obj.hasOwnProperty(tmKeys[i])) {
	            return false;
	        }
	    }
	    return true;
	}
	
	function isTimeFormatOnly(obj) {
	    for (var i = 0; i < dtKeys.length; i += 1) {
	        if (obj.hasOwnProperty(dtKeys[i])) {
	            return false;
	        }
	    }
	    return true;
	}
	
	function joinDateAndTimeFormats(dateFormatObj, timeFormatObj) {
	    var o = { _: {} };
	    for (var i = 0; i < dtKeys.length; i += 1) {
	        if (dateFormatObj[dtKeys[i]]) {
	            o[dtKeys[i]] = dateFormatObj[dtKeys[i]];
	        }
	        if (dateFormatObj._[dtKeys[i]]) {
	            o._[dtKeys[i]] = dateFormatObj._[dtKeys[i]];
	        }
	    }
	    for (var j = 0; j < tmKeys.length; j += 1) {
	        if (timeFormatObj[tmKeys[j]]) {
	            o[tmKeys[j]] = timeFormatObj[tmKeys[j]];
	        }
	        if (timeFormatObj._[tmKeys[j]]) {
	            o._[tmKeys[j]] = timeFormatObj._[tmKeys[j]];
	        }
	    }
	    return o;
	}
	
	function computeFinalPatterns(formatObj) {
	    // From http://www.unicode.org/reports/tr35/tr35-dates.html#Date_Format_Patterns:
	    //  'In patterns, two single quotes represents a literal single quote, either
	    //   inside or outside single quotes. Text within single quotes is not
	    //   interpreted in any way (except for two adjacent single quotes).'
	    formatObj.pattern12 = formatObj.extendedPattern.replace(/'([^']*)'/g, function ($0, literal) {
	        return literal ? literal : "'";
	    });
	
	    // pattern 12 is always the default. we can produce the 24 by removing {ampm}
	    formatObj.pattern = formatObj.pattern12.replace('{ampm}', '').replace(expPatternTrimmer, '');
	    return formatObj;
	}
	
	function expDTComponentsMeta($0, formatObj) {
	    switch ($0.charAt(0)) {
	        // --- Era
	        case 'G':
	            formatObj.era = ['short', 'short', 'short', 'long', 'narrow'][$0.length - 1];
	            return '{era}';
	
	        // --- Year
	        case 'y':
	        case 'Y':
	        case 'u':
	        case 'U':
	        case 'r':
	            formatObj.year = $0.length === 2 ? '2-digit' : 'numeric';
	            return '{year}';
	
	        // --- Quarter (not supported in this polyfill)
	        case 'Q':
	        case 'q':
	            formatObj.quarter = ['numeric', '2-digit', 'short', 'long', 'narrow'][$0.length - 1];
	            return '{quarter}';
	
	        // --- Month
	        case 'M':
	        case 'L':
	            formatObj.month = ['numeric', '2-digit', 'short', 'long', 'narrow'][$0.length - 1];
	            return '{month}';
	
	        // --- Week (not supported in this polyfill)
	        case 'w':
	            // week of the year
	            formatObj.week = $0.length === 2 ? '2-digit' : 'numeric';
	            return '{weekday}';
	        case 'W':
	            // week of the month
	            formatObj.week = 'numeric';
	            return '{weekday}';
	
	        // --- Day
	        case 'd':
	            // day of the month
	            formatObj.day = $0.length === 2 ? '2-digit' : 'numeric';
	            return '{day}';
	        case 'D': // day of the year
	        case 'F': // day of the week
	        case 'g':
	            // 1..n: Modified Julian day
	            formatObj.day = 'numeric';
	            return '{day}';
	
	        // --- Week Day
	        case 'E':
	            // day of the week
	            formatObj.weekday = ['short', 'short', 'short', 'long', 'narrow', 'short'][$0.length - 1];
	            return '{weekday}';
	        case 'e':
	            // local day of the week
	            formatObj.weekday = ['numeric', '2-digit', 'short', 'long', 'narrow', 'short'][$0.length - 1];
	            return '{weekday}';
	        case 'c':
	            // stand alone local day of the week
	            formatObj.weekday = ['numeric', undefined, 'short', 'long', 'narrow', 'short'][$0.length - 1];
	            return '{weekday}';
	
	        // --- Period
	        case 'a': // AM, PM
	        case 'b': // am, pm, noon, midnight
	        case 'B':
	            // flexible day periods
	            formatObj.hour12 = true;
	            return '{ampm}';
	
	        // --- Hour
	        case 'h':
	        case 'H':
	            formatObj.hour = $0.length === 2 ? '2-digit' : 'numeric';
	            return '{hour}';
	        case 'k':
	        case 'K':
	            formatObj.hour12 = true; // 12-hour-cycle time formats (using h or K)
	            formatObj.hour = $0.length === 2 ? '2-digit' : 'numeric';
	            return '{hour}';
	
	        // --- Minute
	        case 'm':
	            formatObj.minute = $0.length === 2 ? '2-digit' : 'numeric';
	            return '{minute}';
	
	        // --- Second
	        case 's':
	            formatObj.second = $0.length === 2 ? '2-digit' : 'numeric';
	            return '{second}';
	        case 'S':
	        case 'A':
	            formatObj.second = 'numeric';
	            return '{second}';
	
	        // --- Timezone
	        case 'z': // 1..3, 4: specific non-location format
	        case 'Z': // 1..3, 4, 5: The ISO8601 varios formats
	        case 'O': // 1, 4: miliseconds in day short, long
	        case 'v': // 1, 4: generic non-location format
	        case 'V': // 1, 2, 3, 4: time zone ID or city
	        case 'X': // 1, 2, 3, 4: The ISO8601 varios formats
	        case 'x':
	            // 1, 2, 3, 4: The ISO8601 varios formats
	            // this polyfill only supports much, for now, we are just doing something dummy
	            formatObj.timeZoneName = $0.length < 4 ? 'short' : 'long';
	            return '{timeZoneName}';
	    }
	}
	
	/**
	 * Converts the CLDR availableFormats into the objects and patterns required by
	 * the ECMAScript Internationalization API specification.
	 */
	function createDateTimeFormat(skeleton, pattern) {
	    // we ignore certain patterns that are unsupported to avoid this expensive op.
	    if (unwantedDTCs.test(pattern)) return undefined;
	
	    var formatObj = {
	        originalPattern: pattern,
	        _: {}
	    };
	
	    // Replace the pattern string with the one required by the specification, whilst
	    // at the same time evaluating it for the subsets and formats
	    formatObj.extendedPattern = pattern.replace(expDTComponents, function ($0) {
	        // See which symbol we're dealing with
	        return expDTComponentsMeta($0, formatObj._);
	    });
	
	    // Match the skeleton string with the one required by the specification
	    // this implementation is based on the Date Field Symbol Table:
	    // http://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
	    // Note: we are adding extra data to the formatObject even though this polyfill
	    //       might not support it.
	    skeleton.replace(expDTComponents, function ($0) {
	        // See which symbol we're dealing with
	        return expDTComponentsMeta($0, formatObj);
	    });
	
	    return computeFinalPatterns(formatObj);
	}
	
	/**
	 * Processes DateTime formats from CLDR to an easier-to-parse format.
	 * the result of this operation should be cached the first time a particular
	 * calendar is analyzed.
	 *
	 * The specification requires we support at least the following subsets of
	 * date/time components:
	 *
	 *   - 'weekday', 'year', 'month', 'day', 'hour', 'minute', 'second'
	 *   - 'weekday', 'year', 'month', 'day'
	 *   - 'year', 'month', 'day'
	 *   - 'year', 'month'
	 *   - 'month', 'day'
	 *   - 'hour', 'minute', 'second'
	 *   - 'hour', 'minute'
	 *
	 * We need to cherry pick at least these subsets from the CLDR data and convert
	 * them into the pattern objects used in the ECMA-402 API.
	 */
	function createDateTimeFormats(formats) {
	    var availableFormats = formats.availableFormats;
	    var timeFormats = formats.timeFormats;
	    var dateFormats = formats.dateFormats;
	    var result = [];
	    var skeleton = void 0,
	        pattern = void 0,
	        computed = void 0,
	        i = void 0,
	        j = void 0;
	    var timeRelatedFormats = [];
	    var dateRelatedFormats = [];
	
	    // Map available (custom) formats into a pattern for createDateTimeFormats
	    for (skeleton in availableFormats) {
	        if (availableFormats.hasOwnProperty(skeleton)) {
	            pattern = availableFormats[skeleton];
	            computed = createDateTimeFormat(skeleton, pattern);
	            if (computed) {
	                result.push(computed);
	                // in some cases, the format is only displaying date specific props
	                // or time specific props, in which case we need to also produce the
	                // combined formats.
	                if (isDateFormatOnly(computed)) {
	                    dateRelatedFormats.push(computed);
	                } else if (isTimeFormatOnly(computed)) {
	                    timeRelatedFormats.push(computed);
	                }
	            }
	        }
	    }
	
	    // Map time formats into a pattern for createDateTimeFormats
	    for (skeleton in timeFormats) {
	        if (timeFormats.hasOwnProperty(skeleton)) {
	            pattern = timeFormats[skeleton];
	            computed = createDateTimeFormat(skeleton, pattern);
	            if (computed) {
	                result.push(computed);
	                timeRelatedFormats.push(computed);
	            }
	        }
	    }
	
	    // Map date formats into a pattern for createDateTimeFormats
	    for (skeleton in dateFormats) {
	        if (dateFormats.hasOwnProperty(skeleton)) {
	            pattern = dateFormats[skeleton];
	            computed = createDateTimeFormat(skeleton, pattern);
	            if (computed) {
	                result.push(computed);
	                dateRelatedFormats.push(computed);
	            }
	        }
	    }
	
	    // combine custom time and custom date formats when they are orthogonals to complete the
	    // formats supported by CLDR.
	    // This Algo is based on section "Missing Skeleton Fields" from:
	    // http://unicode.org/reports/tr35/tr35-dates.html#availableFormats_appendItems
	    for (i = 0; i < timeRelatedFormats.length; i += 1) {
	        for (j = 0; j < dateRelatedFormats.length; j += 1) {
	            if (dateRelatedFormats[j].month === 'long') {
	                pattern = dateRelatedFormats[j].weekday ? formats.full : formats.long;
	            } else if (dateRelatedFormats[j].month === 'short') {
	                pattern = formats.medium;
	            } else {
	                pattern = formats.short;
	            }
	            computed = joinDateAndTimeFormats(dateRelatedFormats[j], timeRelatedFormats[i]);
	            computed.originalPattern = pattern;
	            computed.extendedPattern = pattern.replace('{0}', timeRelatedFormats[i].extendedPattern).replace('{1}', dateRelatedFormats[j].extendedPattern).replace(/^[,\s]+|[,\s]+$/gi, '');
	            result.push(computeFinalPatterns(computed));
	        }
	    }
	
	    return result;
	}
	
	// this represents the exceptions of the rule that are not covered by CLDR availableFormats
	// for single property configurations, they play no role when using multiple properties, and
	// those that are not in this table, are not exceptions or are not covered by the data we
	// provide.
	var validSyntheticProps = {
	    second: {
	        numeric: 's',
	        '2-digit': 'ss'
	    },
	    minute: {
	        numeric: 'm',
	        '2-digit': 'mm'
	    },
	    year: {
	        numeric: 'y',
	        '2-digit': 'yy'
	    },
	    day: {
	        numeric: 'd',
	        '2-digit': 'dd'
	    },
	    month: {
	        numeric: 'L',
	        '2-digit': 'LL',
	        narrow: 'LLLLL',
	        short: 'LLL',
	        long: 'LLLL'
	    },
	    weekday: {
	        narrow: 'ccccc',
	        short: 'ccc',
	        long: 'cccc'
	    }
	};
	
	function generateSyntheticFormat(propName, propValue) {
	    if (validSyntheticProps[propName] && validSyntheticProps[propName][propValue]) {
	        var _ref2;
	
	        return _ref2 = {
	            originalPattern: validSyntheticProps[propName][propValue],
	            _: defineProperty$1({}, propName, propValue),
	            extendedPattern: "{" + propName + "}"
	        }, defineProperty$1(_ref2, propName, propValue), defineProperty$1(_ref2, "pattern12", "{" + propName + "}"), defineProperty$1(_ref2, "pattern", "{" + propName + "}"), _ref2;
	    }
	}
	
	// An object map of date component keys, saves using a regex later
	var dateWidths = objCreate(null, { narrow: {}, short: {}, long: {} });
	
	/**
	 * Returns a string for a date component, resolved using multiple inheritance as specified
	 * as specified in the Unicode Technical Standard 35.
	 */
	function resolveDateString(data, ca, component, width, key) {
	    // From http://www.unicode.org/reports/tr35/tr35.html#Multiple_Inheritance:
	    // 'In clearly specified instances, resources may inherit from within the same locale.
	    //  For example, ... the Buddhist calendar inherits from the Gregorian calendar.'
	    var obj = data[ca] && data[ca][component] ? data[ca][component] : data.gregory[component],
	
	
	    // "sideways" inheritance resolves strings when a key doesn't exist
	    alts = {
	        narrow: ['short', 'long'],
	        short: ['long', 'narrow'],
	        long: ['short', 'narrow']
	    },
	
	
	    //
	    resolved = hop.call(obj, width) ? obj[width] : hop.call(obj, alts[width][0]) ? obj[alts[width][0]] : obj[alts[width][1]];
	
	    // `key` wouldn't be specified for components 'dayPeriods'
	    return key !== null ? resolved[key] : resolved;
	}
	
	// Define the DateTimeFormat constructor internally so it cannot be tainted
	function DateTimeFormatConstructor() {
	    var locales = arguments[0];
	    var options = arguments[1];
	
	    if (!this || this === Intl) {
	        return new Intl.DateTimeFormat(locales, options);
	    }
	    return InitializeDateTimeFormat(toObject(this), locales, options);
	}
	
	defineProperty(Intl, 'DateTimeFormat', {
	    configurable: true,
	    writable: true,
	    value: DateTimeFormatConstructor
	});
	
	// Must explicitly set prototypes as unwritable
	defineProperty(DateTimeFormatConstructor, 'prototype', {
	    writable: false
	});
	
	/**
	 * The abstract operation InitializeDateTimeFormat accepts the arguments dateTimeFormat
	 * (which must be an object), locales, and options. It initializes dateTimeFormat as a
	 * DateTimeFormat object.
	 */
	function /* 12.1.1.1 */InitializeDateTimeFormat(dateTimeFormat, locales, options) {
	    // This will be a internal properties object if we're not already initialized
	    var internal = getInternalProperties(dateTimeFormat);
	
	    // Create an object whose props can be used to restore the values of RegExp props
	    var regexpRestore = createRegExpRestore();
	
	    // 1. If dateTimeFormat has an [[initializedIntlObject]] internal property with
	    //    value true, throw a TypeError exception.
	    if (internal['[[initializedIntlObject]]'] === true) throw new TypeError('`this` object has already been initialized as an Intl object');
	
	    // Need this to access the `internal` object
	    defineProperty(dateTimeFormat, '__getInternalProperties', {
	        value: function value() {
	            // NOTE: Non-standard, for internal use only
	            if (arguments[0] === secret) return internal;
	        }
	    });
	
	    // 2. Set the [[initializedIntlObject]] internal property of numberFormat to true.
	    internal['[[initializedIntlObject]]'] = true;
	
	    // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
	    //    abstract operation (defined in 9.2.1) with argument locales.
	    var requestedLocales = CanonicalizeLocaleList(locales);
	
	    // 4. Let options be the result of calling the ToDateTimeOptions abstract
	    //    operation (defined below) with arguments options, "any", and "date".
	    options = ToDateTimeOptions(options, 'any', 'date');
	
	    // 5. Let opt be a new Record.
	    var opt = new Record();
	
	    // 6. Let matcher be the result of calling the GetOption abstract operation
	    //    (defined in 9.2.9) with arguments options, "localeMatcher", "string", a List
	    //    containing the two String values "lookup" and "best fit", and "best fit".
	    var matcher = GetOption(options, 'localeMatcher', 'string', new List('lookup', 'best fit'), 'best fit');
	
	    // 7. Set opt.[[localeMatcher]] to matcher.
	    opt['[[localeMatcher]]'] = matcher;
	
	    // 8. Let DateTimeFormat be the standard built-in object that is the initial
	    //    value of Intl.DateTimeFormat.
	    var DateTimeFormat = internals.DateTimeFormat; // This is what we *really* need
	
	    // 9. Let localeData be the value of the [[localeData]] internal property of
	    //    DateTimeFormat.
	    var localeData = DateTimeFormat['[[localeData]]'];
	
	    // 10. Let r be the result of calling the ResolveLocale abstract operation
	    //     (defined in 9.2.5) with the [[availableLocales]] internal property of
	    //      DateTimeFormat, requestedLocales, opt, the [[relevantExtensionKeys]]
	    //      internal property of DateTimeFormat, and localeData.
	    var r = ResolveLocale(DateTimeFormat['[[availableLocales]]'], requestedLocales, opt, DateTimeFormat['[[relevantExtensionKeys]]'], localeData);
	
	    // 11. Set the [[locale]] internal property of dateTimeFormat to the value of
	    //     r.[[locale]].
	    internal['[[locale]]'] = r['[[locale]]'];
	
	    // 12. Set the [[calendar]] internal property of dateTimeFormat to the value of
	    //     r.[[ca]].
	    internal['[[calendar]]'] = r['[[ca]]'];
	
	    // 13. Set the [[numberingSystem]] internal property of dateTimeFormat to the value of
	    //     r.[[nu]].
	    internal['[[numberingSystem]]'] = r['[[nu]]'];
	
	    // The specification doesn't tell us to do this, but it's helpful later on
	    internal['[[dataLocale]]'] = r['[[dataLocale]]'];
	
	    // 14. Let dataLocale be the value of r.[[dataLocale]].
	    var dataLocale = r['[[dataLocale]]'];
	
	    // 15. Let tz be the result of calling the [[Get]] internal method of options with
	    //     argument "timeZone".
	    var tz = options.timeZone;
	
	    // 16. If tz is not undefined, then
	    if (tz !== undefined) {
	        // a. Let tz be ToString(tz).
	        // b. Convert tz to upper case as described in 6.1.
	        //    NOTE: If an implementation accepts additional time zone values, as permitted
	        //          under certain conditions by the Conformance clause, different casing
	        //          rules apply.
	        tz = toLatinUpperCase(tz);
	
	        // c. If tz is not "UTC", then throw a RangeError exception.
	        // ###TODO: accept more time zones###
	        if (tz !== 'UTC') throw new RangeError('timeZone is not supported.');
	    }
	
	    // 17. Set the [[timeZone]] internal property of dateTimeFormat to tz.
	    internal['[[timeZone]]'] = tz;
	
	    // 18. Let opt be a new Record.
	    opt = new Record();
	
	    // 19. For each row of Table 3, except the header row, do:
	    for (var prop in dateTimeComponents) {
	        if (!hop.call(dateTimeComponents, prop)) continue;
	
	        // 20. Let prop be the name given in the Property column of the row.
	        // 21. Let value be the result of calling the GetOption abstract operation,
	        //     passing as argument options, the name given in the Property column of the
	        //     row, "string", a List containing the strings given in the Values column of
	        //     the row, and undefined.
	        var value = GetOption(options, prop, 'string', dateTimeComponents[prop]);
	
	        // 22. Set opt.[[<prop>]] to value.
	        opt['[[' + prop + ']]'] = value;
	    }
	
	    // Assigned a value below
	    var bestFormat = void 0;
	
	    // 23. Let dataLocaleData be the result of calling the [[Get]] internal method of
	    //     localeData with argument dataLocale.
	    var dataLocaleData = localeData[dataLocale];
	
	    // 24. Let formats be the result of calling the [[Get]] internal method of
	    //     dataLocaleData with argument "formats".
	    //     Note: we process the CLDR formats into the spec'd structure
	    var formats = ToDateTimeFormats(dataLocaleData.formats);
	
	    // 25. Let matcher be the result of calling the GetOption abstract operation with
	    //     arguments options, "formatMatcher", "string", a List containing the two String
	    //     values "basic" and "best fit", and "best fit".
	    matcher = GetOption(options, 'formatMatcher', 'string', new List('basic', 'best fit'), 'best fit');
	
	    // Optimization: caching the processed formats as a one time operation by
	    // replacing the initial structure from localeData
	    dataLocaleData.formats = formats;
	
	    // 26. If matcher is "basic", then
	    if (matcher === 'basic') {
	        // 27. Let bestFormat be the result of calling the BasicFormatMatcher abstract
	        //     operation (defined below) with opt and formats.
	        bestFormat = BasicFormatMatcher(opt, formats);
	
	        // 28. Else
	    } else {
	        {
	            // diverging
	            var _hr = GetOption(options, 'hour12', 'boolean' /*, undefined, undefined*/);
	            opt.hour12 = _hr === undefined ? dataLocaleData.hour12 : _hr;
	        }
	        // 29. Let bestFormat be the result of calling the BestFitFormatMatcher
	        //     abstract operation (defined below) with opt and formats.
	        bestFormat = BestFitFormatMatcher(opt, formats);
	    }
	
	    // 30. For each row in Table 3, except the header row, do
	    for (var _prop in dateTimeComponents) {
	        if (!hop.call(dateTimeComponents, _prop)) continue;
	
	        // a. Let prop be the name given in the Property column of the row.
	        // b. Let pDesc be the result of calling the [[GetOwnProperty]] internal method of
	        //    bestFormat with argument prop.
	        // c. If pDesc is not undefined, then
	        if (hop.call(bestFormat, _prop)) {
	            // i. Let p be the result of calling the [[Get]] internal method of bestFormat
	            //    with argument prop.
	            var p = bestFormat[_prop];
	            {
	                // diverging
	                p = bestFormat._ && hop.call(bestFormat._, _prop) ? bestFormat._[_prop] : p;
	            }
	
	            // ii. Set the [[<prop>]] internal property of dateTimeFormat to p.
	            internal['[[' + _prop + ']]'] = p;
	        }
	    }
	
	    var pattern = void 0; // Assigned a value below
	
	    // 31. Let hr12 be the result of calling the GetOption abstract operation with
	    //     arguments options, "hour12", "boolean", undefined, and undefined.
	    var hr12 = GetOption(options, 'hour12', 'boolean' /*, undefined, undefined*/);
	
	    // 32. If dateTimeFormat has an internal property [[hour]], then
	    if (internal['[[hour]]']) {
	        // a. If hr12 is undefined, then let hr12 be the result of calling the [[Get]]
	        //    internal method of dataLocaleData with argument "hour12".
	        hr12 = hr12 === undefined ? dataLocaleData.hour12 : hr12;
	
	        // b. Set the [[hour12]] internal property of dateTimeFormat to hr12.
	        internal['[[hour12]]'] = hr12;
	
	        // c. If hr12 is true, then
	        if (hr12 === true) {
	            // i. Let hourNo0 be the result of calling the [[Get]] internal method of
	            //    dataLocaleData with argument "hourNo0".
	            var hourNo0 = dataLocaleData.hourNo0;
	
	            // ii. Set the [[hourNo0]] internal property of dateTimeFormat to hourNo0.
	            internal['[[hourNo0]]'] = hourNo0;
	
	            // iii. Let pattern be the result of calling the [[Get]] internal method of
	            //      bestFormat with argument "pattern12".
	            pattern = bestFormat.pattern12;
	        }
	
	        // d. Else
	        else
	            // i. Let pattern be the result of calling the [[Get]] internal method of
	            //    bestFormat with argument "pattern".
	            pattern = bestFormat.pattern;
	    }
	
	    // 33. Else
	    else
	        // a. Let pattern be the result of calling the [[Get]] internal method of
	        //    bestFormat with argument "pattern".
	        pattern = bestFormat.pattern;
	
	    // 34. Set the [[pattern]] internal property of dateTimeFormat to pattern.
	    internal['[[pattern]]'] = pattern;
	
	    // 35. Set the [[boundFormat]] internal property of dateTimeFormat to undefined.
	    internal['[[boundFormat]]'] = undefined;
	
	    // 36. Set the [[initializedDateTimeFormat]] internal property of dateTimeFormat to
	    //     true.
	    internal['[[initializedDateTimeFormat]]'] = true;
	
	    // In ES3, we need to pre-bind the format() function
	    if (es3) dateTimeFormat.format = GetFormatDateTime.call(dateTimeFormat);
	
	    // Restore the RegExp properties
	    regexpRestore();
	
	    // Return the newly initialised object
	    return dateTimeFormat;
	}
	
	/**
	 * Several DateTimeFormat algorithms use values from the following table, which provides
	 * property names and allowable values for the components of date and time formats:
	 */
	var dateTimeComponents = {
	    weekday: ["narrow", "short", "long"],
	    era: ["narrow", "short", "long"],
	    year: ["2-digit", "numeric"],
	    month: ["2-digit", "numeric", "narrow", "short", "long"],
	    day: ["2-digit", "numeric"],
	    hour: ["2-digit", "numeric"],
	    minute: ["2-digit", "numeric"],
	    second: ["2-digit", "numeric"],
	    timeZoneName: ["short", "long"]
	};
	
	/**
	 * When the ToDateTimeOptions abstract operation is called with arguments options,
	 * required, and defaults, the following steps are taken:
	 */
	function ToDateTimeFormats(formats) {
	    if (Object.prototype.toString.call(formats) === '[object Array]') {
	        return formats;
	    }
	    return createDateTimeFormats(formats);
	}
	
	/**
	 * When the ToDateTimeOptions abstract operation is called with arguments options,
	 * required, and defaults, the following steps are taken:
	 */
	function ToDateTimeOptions(options, required, defaults) {
	    // 1. If options is undefined, then let options be null, else let options be
	    //    ToObject(options).
	    if (options === undefined) options = null;else {
	        // (#12) options needs to be a Record, but it also needs to inherit properties
	        var opt2 = toObject(options);
	        options = new Record();
	
	        for (var k in opt2) {
	            options[k] = opt2[k];
	        }
	    }
	
	    // 2. Let create be the standard built-in function object defined in ES5, 15.2.3.5.
	    var create = objCreate;
	
	    // 3. Let options be the result of calling the [[Call]] internal method of create with
	    //    undefined as the this value and an argument list containing the single item
	    //    options.
	    options = create(options);
	
	    // 4. Let needDefaults be true.
	    var needDefaults = true;
	
	    // 5. If required is "date" or "any", then
	    if (required === 'date' || required === 'any') {
	        // a. For each of the property names "weekday", "year", "month", "day":
	        // i. If the result of calling the [[Get]] internal method of options with the
	        //    property name is not undefined, then let needDefaults be false.
	        if (options.weekday !== undefined || options.year !== undefined || options.month !== undefined || options.day !== undefined) needDefaults = false;
	    }
	
	    // 6. If required is "time" or "any", then
	    if (required === 'time' || required === 'any') {
	        // a. For each of the property names "hour", "minute", "second":
	        // i. If the result of calling the [[Get]] internal method of options with the
	        //    property name is not undefined, then let needDefaults be false.
	        if (options.hour !== undefined || options.minute !== undefined || options.second !== undefined) needDefaults = false;
	    }
	
	    // 7. If needDefaults is true and defaults is either "date" or "all", then
	    if (needDefaults && (defaults === 'date' || defaults === 'all'))
	        // a. For each of the property names "year", "month", "day":
	        // i. Call the [[DefineOwnProperty]] internal method of options with the
	        //    property name, Property Descriptor {[[Value]]: "numeric", [[Writable]]:
	        //    true, [[Enumerable]]: true, [[Configurable]]: true}, and false.
	        options.year = options.month = options.day = 'numeric';
	
	    // 8. If needDefaults is true and defaults is either "time" or "all", then
	    if (needDefaults && (defaults === 'time' || defaults === 'all'))
	        // a. For each of the property names "hour", "minute", "second":
	        // i. Call the [[DefineOwnProperty]] internal method of options with the
	        //    property name, Property Descriptor {[[Value]]: "numeric", [[Writable]]:
	        //    true, [[Enumerable]]: true, [[Configurable]]: true}, and false.
	        options.hour = options.minute = options.second = 'numeric';
	
	    // 9. Return options.
	    return options;
	}
	
	/**
	 * When the BasicFormatMatcher abstract operation is called with two arguments options and
	 * formats, the following steps are taken:
	 */
	function BasicFormatMatcher(options, formats) {
	    // 1. Let removalPenalty be 120.
	    var removalPenalty = 120;
	
	    // 2. Let additionPenalty be 20.
	    var additionPenalty = 20;
	
	    // 3. Let longLessPenalty be 8.
	    var longLessPenalty = 8;
	
	    // 4. Let longMorePenalty be 6.
	    var longMorePenalty = 6;
	
	    // 5. Let shortLessPenalty be 6.
	    var shortLessPenalty = 6;
	
	    // 6. Let shortMorePenalty be 3.
	    var shortMorePenalty = 3;
	
	    // 7. Let bestScore be -Infinity.
	    var bestScore = -Infinity;
	
	    // 8. Let bestFormat be undefined.
	    var bestFormat = void 0;
	
	    // 9. Let i be 0.
	    var i = 0;
	
	    // 10. Assert: formats is an Array object.
	
	    // 11. Let len be the result of calling the [[Get]] internal method of formats with argument "length".
	    var len = formats.length;
	
	    // 12. Repeat while i < len:
	    while (i < len) {
	        // a. Let format be the result of calling the [[Get]] internal method of formats with argument ToString(i).
	        var format = formats[i];
	
	        // b. Let score be 0.
	        var score = 0;
	
	        // c. For each property shown in Table 3:
	        for (var property in dateTimeComponents) {
	            if (!hop.call(dateTimeComponents, property)) continue;
	
	            // i. Let optionsProp be options.[[<property>]].
	            var optionsProp = options['[[' + property + ']]'];
	
	            // ii. Let formatPropDesc be the result of calling the [[GetOwnProperty]] internal method of format
	            //     with argument property.
	            // iii. If formatPropDesc is not undefined, then
	            //     1. Let formatProp be the result of calling the [[Get]] internal method of format with argument property.
	            var formatProp = hop.call(format, property) ? format[property] : undefined;
	
	            // iv. If optionsProp is undefined and formatProp is not undefined, then decrease score by
	            //     additionPenalty.
	            if (optionsProp === undefined && formatProp !== undefined) score -= additionPenalty;
	
	            // v. Else if optionsProp is not undefined and formatProp is undefined, then decrease score by
	            //    removalPenalty.
	            else if (optionsProp !== undefined && formatProp === undefined) score -= removalPenalty;
	
	                // vi. Else
	                else {
	                        // 1. Let values be the array ["2-digit", "numeric", "narrow", "short",
	                        //    "long"].
	                        var values = ['2-digit', 'numeric', 'narrow', 'short', 'long'];
	
	                        // 2. Let optionsPropIndex be the index of optionsProp within values.
	                        var optionsPropIndex = arrIndexOf.call(values, optionsProp);
	
	                        // 3. Let formatPropIndex be the index of formatProp within values.
	                        var formatPropIndex = arrIndexOf.call(values, formatProp);
	
	                        // 4. Let delta be max(min(formatPropIndex - optionsPropIndex, 2), -2).
	                        var delta = Math.max(Math.min(formatPropIndex - optionsPropIndex, 2), -2);
	
	                        // 5. If delta = 2, decrease score by longMorePenalty.
	                        if (delta === 2) score -= longMorePenalty;
	
	                        // 6. Else if delta = 1, decrease score by shortMorePenalty.
	                        else if (delta === 1) score -= shortMorePenalty;
	
	                            // 7. Else if delta = -1, decrease score by shortLessPenalty.
	                            else if (delta === -1) score -= shortLessPenalty;
	
	                                // 8. Else if delta = -2, decrease score by longLessPenalty.
	                                else if (delta === -2) score -= longLessPenalty;
	                    }
	        }
	
	        // d. If score > bestScore, then
	        if (score > bestScore) {
	            // i. Let bestScore be score.
	            bestScore = score;
	
	            // ii. Let bestFormat be format.
	            bestFormat = format;
	        }
	
	        // e. Increase i by 1.
	        i++;
	    }
	
	    // 13. Return bestFormat.
	    return bestFormat;
	}
	
	/**
	 * When the BestFitFormatMatcher abstract operation is called with two arguments options
	 * and formats, it performs implementation dependent steps, which should return a set of
	 * component representations that a typical user of the selected locale would perceive as
	 * at least as good as the one returned by BasicFormatMatcher.
	 *
	 * This polyfill defines the algorithm to be the same as BasicFormatMatcher,
	 * with the addition of bonus points awarded where the requested format is of
	 * the same data type as the potentially matching format.
	 *
	 * This algo relies on the concept of closest distance matching described here:
	 * http://unicode.org/reports/tr35/tr35-dates.html#Matching_Skeletons
	 * Typically a “best match” is found using a closest distance match, such as:
	 *
	 * Symbols requesting a best choice for the locale are replaced.
	 *      j → one of {H, k, h, K}; C → one of {a, b, B}
	 * -> Covered by cldr.js matching process
	 *
	 * For fields with symbols representing the same type (year, month, day, etc):
	 *     Most symbols have a small distance from each other.
	 *         M ≅ L; E ≅ c; a ≅ b ≅ B; H ≅ k ≅ h ≅ K; ...
	 *     -> Covered by cldr.js matching process
	 *
	 *     Width differences among fields, other than those marking text vs numeric, are given small distance from each other.
	 *         MMM ≅ MMMM
	 *         MM ≅ M
	 *     Numeric and text fields are given a larger distance from each other.
	 *         MMM ≈ MM
	 *     Symbols representing substantial differences (week of year vs week of month) are given much larger a distances from each other.
	 *         d ≋ D; ...
	 *     Missing or extra fields cause a match to fail. (But see Missing Skeleton Fields).
	 *
	 *
	 * For example,
	 *
	 *     { month: 'numeric', day: 'numeric' }
	 *
	 * should match
	 *
	 *     { month: '2-digit', day: '2-digit' }
	 *
	 * rather than
	 *
	 *     { month: 'short', day: 'numeric' }
	 *
	 * This makes sense because a user requesting a formatted date with numeric parts would
	 * not expect to see the returned format containing narrow, short or long part names
	 */
	function BestFitFormatMatcher(options, formats) {
	    /** Diverging: this block implements the hack for single property configuration, eg.:
	     *
	     *      `new Intl.DateTimeFormat('en', {day: 'numeric'})`
	     *
	     * should produce a single digit with the day of the month. This is needed because
	     * CLDR `availableFormats` data structure doesn't cover these cases.
	     */
	    {
	        var optionsPropNames = [];
	        for (var property in dateTimeComponents) {
	            if (!hop.call(dateTimeComponents, property)) continue;
	
	            if (options['[[' + property + ']]'] !== undefined) {
	                optionsPropNames.push(property);
	            }
	        }
	        if (optionsPropNames.length === 1) {
	            var _bestFormat = generateSyntheticFormat(optionsPropNames[0], options['[[' + optionsPropNames[0] + ']]']);
	            if (_bestFormat) {
	                return _bestFormat;
	            }
	        }
	    }
	
	    // 1. Let removalPenalty be 120.
	    var removalPenalty = 120;
	
	    // 2. Let additionPenalty be 20.
	    var additionPenalty = 20;
	
	    // 3. Let longLessPenalty be 8.
	    var longLessPenalty = 8;
	
	    // 4. Let longMorePenalty be 6.
	    var longMorePenalty = 6;
	
	    // 5. Let shortLessPenalty be 6.
	    var shortLessPenalty = 6;
	
	    // 6. Let shortMorePenalty be 3.
	    var shortMorePenalty = 3;
	
	    var patternPenalty = 2;
	
	    var hour12Penalty = 1;
	
	    // 7. Let bestScore be -Infinity.
	    var bestScore = -Infinity;
	
	    // 8. Let bestFormat be undefined.
	    var bestFormat = void 0;
	
	    // 9. Let i be 0.
	    var i = 0;
	
	    // 10. Assert: formats is an Array object.
	
	    // 11. Let len be the result of calling the [[Get]] internal method of formats with argument "length".
	    var len = formats.length;
	
	    // 12. Repeat while i < len:
	    while (i < len) {
	        // a. Let format be the result of calling the [[Get]] internal method of formats with argument ToString(i).
	        var format = formats[i];
	
	        // b. Let score be 0.
	        var score = 0;
	
	        // c. For each property shown in Table 3:
	        for (var _property in dateTimeComponents) {
	            if (!hop.call(dateTimeComponents, _property)) continue;
	
	            // i. Let optionsProp be options.[[<property>]].
	            var optionsProp = options['[[' + _property + ']]'];
	
	            // ii. Let formatPropDesc be the result of calling the [[GetOwnProperty]] internal method of format
	            //     with argument property.
	            // iii. If formatPropDesc is not undefined, then
	            //     1. Let formatProp be the result of calling the [[Get]] internal method of format with argument property.
	            var formatProp = hop.call(format, _property) ? format[_property] : undefined;
	
	            // Diverging: using the default properties produced by the pattern/skeleton
	            // to match it with user options, and apply a penalty
	            var patternProp = hop.call(format._, _property) ? format._[_property] : undefined;
	            if (optionsProp !== patternProp) {
	                score -= patternPenalty;
	            }
	
	            // iv. If optionsProp is undefined and formatProp is not undefined, then decrease score by
	            //     additionPenalty.
	            if (optionsProp === undefined && formatProp !== undefined) score -= additionPenalty;
	
	            // v. Else if optionsProp is not undefined and formatProp is undefined, then decrease score by
	            //    removalPenalty.
	            else if (optionsProp !== undefined && formatProp === undefined) score -= removalPenalty;
	
	                // vi. Else
	                else {
	                        // 1. Let values be the array ["2-digit", "numeric", "narrow", "short",
	                        //    "long"].
	                        var values = ['2-digit', 'numeric', 'narrow', 'short', 'long'];
	
	                        // 2. Let optionsPropIndex be the index of optionsProp within values.
	                        var optionsPropIndex = arrIndexOf.call(values, optionsProp);
	
	                        // 3. Let formatPropIndex be the index of formatProp within values.
	                        var formatPropIndex = arrIndexOf.call(values, formatProp);
	
	                        // 4. Let delta be max(min(formatPropIndex - optionsPropIndex, 2), -2).
	                        var delta = Math.max(Math.min(formatPropIndex - optionsPropIndex, 2), -2);
	
	                        {
	                            // diverging from spec
	                            // When the bestFit argument is true, subtract additional penalty where data types are not the same
	                            if (formatPropIndex <= 1 && optionsPropIndex >= 2 || formatPropIndex >= 2 && optionsPropIndex <= 1) {
	                                // 5. If delta = 2, decrease score by longMorePenalty.
	                                if (delta > 0) score -= longMorePenalty;else if (delta < 0) score -= longLessPenalty;
	                            } else {
	                                // 5. If delta = 2, decrease score by longMorePenalty.
	                                if (delta > 1) score -= shortMorePenalty;else if (delta < -1) score -= shortLessPenalty;
	                            }
	                        }
	                    }
	        }
	
	        {
	            // diverging to also take into consideration differences between 12 or 24 hours
	            // which is special for the best fit only.
	            if (format._.hour12 !== options.hour12) {
	                score -= hour12Penalty;
	            }
	        }
	
	        // d. If score > bestScore, then
	        if (score > bestScore) {
	            // i. Let bestScore be score.
	            bestScore = score;
	            // ii. Let bestFormat be format.
	            bestFormat = format;
	        }
	
	        // e. Increase i by 1.
	        i++;
	    }
	
	    // 13. Return bestFormat.
	    return bestFormat;
	}
	
	/* 12.2.3 */internals.DateTimeFormat = {
	    '[[availableLocales]]': [],
	    '[[relevantExtensionKeys]]': ['ca', 'nu'],
	    '[[localeData]]': {}
	};
	
	/**
	 * When the supportedLocalesOf method of Intl.DateTimeFormat is called, the
	 * following steps are taken:
	 */
	/* 12.2.2 */
	defineProperty(Intl.DateTimeFormat, 'supportedLocalesOf', {
	    configurable: true,
	    writable: true,
	    value: fnBind.call(function (locales) {
	        // Bound functions only have the `this` value altered if being used as a constructor,
	        // this lets us imitate a native function that has no constructor
	        if (!hop.call(this, '[[availableLocales]]')) throw new TypeError('supportedLocalesOf() is not a constructor');
	
	        // Create an object whose props can be used to restore the values of RegExp props
	        var regexpRestore = createRegExpRestore(),
	
	
	        // 1. If options is not provided, then let options be undefined.
	        options = arguments[1],
	
	
	        // 2. Let availableLocales be the value of the [[availableLocales]] internal
	        //    property of the standard built-in object that is the initial value of
	        //    Intl.NumberFormat.
	
	        availableLocales = this['[[availableLocales]]'],
	
	
	        // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
	        //    abstract operation (defined in 9.2.1) with argument locales.
	        requestedLocales = CanonicalizeLocaleList(locales);
	
	        // Restore the RegExp properties
	        regexpRestore();
	
	        // 4. Return the result of calling the SupportedLocales abstract operation
	        //    (defined in 9.2.8) with arguments availableLocales, requestedLocales,
	        //    and options.
	        return SupportedLocales(availableLocales, requestedLocales, options);
	    }, internals.NumberFormat)
	});
	
	/**
	 * This named accessor property returns a function that formats a number
	 * according to the effective locale and the formatting options of this
	 * DateTimeFormat object.
	 */
	/* 12.3.2 */defineProperty(Intl.DateTimeFormat.prototype, 'format', {
	    configurable: true,
	    get: GetFormatDateTime
	});
	
	function GetFormatDateTime() {
	    var internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);
	
	    // Satisfy test 12.3_b
	    if (!internal || !internal['[[initializedDateTimeFormat]]']) throw new TypeError('`this` value for format() is not an initialized Intl.DateTimeFormat object.');
	
	    // The value of the [[Get]] attribute is a function that takes the following
	    // steps:
	
	    // 1. If the [[boundFormat]] internal property of this DateTimeFormat object
	    //    is undefined, then:
	    if (internal['[[boundFormat]]'] === undefined) {
	        // a. Let F be a Function object, with internal properties set as
	        //    specified for built-in functions in ES5, 15, or successor, and the
	        //    length property set to 0, that takes the argument date and
	        //    performs the following steps:
	        var F = function F() {
	            var date = arguments.length <= 0 || arguments[0] === undefined ? undefined : arguments[0];
	
	            //   i. If date is not provided or is undefined, then let x be the
	            //      result as if by the expression Date.now() where Date.now is
	            //      the standard built-in function defined in ES5, 15.9.4.4.
	            //  ii. Else let x be ToNumber(date).
	            // iii. Return the result of calling the FormatDateTime abstract
	            //      operation (defined below) with arguments this and x.
	            var x = date === undefined ? Date.now() : toNumber(date);
	            return FormatDateTime(this, x);
	        };
	        // b. Let bind be the standard built-in function object defined in ES5,
	        //    15.3.4.5.
	        // c. Let bf be the result of calling the [[Call]] internal method of
	        //    bind with F as the this value and an argument list containing
	        //    the single item this.
	        var bf = fnBind.call(F, this);
	        // d. Set the [[boundFormat]] internal property of this NumberFormat
	        //    object to bf.
	        internal['[[boundFormat]]'] = bf;
	    }
	    // Return the value of the [[boundFormat]] internal property of this
	    // NumberFormat object.
	    return internal['[[boundFormat]]'];
	}
	
	function formatToParts$1() {
	    var date = arguments.length <= 0 || arguments[0] === undefined ? undefined : arguments[0];
	
	    var internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);
	
	    if (!internal || !internal['[[initializedDateTimeFormat]]']) throw new TypeError('`this` value for formatToParts() is not an initialized Intl.DateTimeFormat object.');
	
	    var x = date === undefined ? Date.now() : toNumber(date);
	    return FormatToPartsDateTime(this, x);
	}
	
	Object.defineProperty(Intl.DateTimeFormat.prototype, 'formatToParts', {
	    enumerable: false,
	    writable: true,
	    configurable: true,
	    value: formatToParts$1
	});
	
	function CreateDateTimeParts(dateTimeFormat, x) {
	    // 1. If x is not a finite Number, then throw a RangeError exception.
	    if (!isFinite(x)) throw new RangeError('Invalid valid date passed to format');
	
	    var internal = dateTimeFormat.__getInternalProperties(secret);
	
	    // Creating restore point for properties on the RegExp object... please wait
	    /* let regexpRestore = */createRegExpRestore(); // ###TODO: review this
	
	    // 2. Let locale be the value of the [[locale]] internal property of dateTimeFormat.
	    var locale = internal['[[locale]]'];
	
	    // 3. Let nf be the result of creating a new NumberFormat object as if by the
	    // expression new Intl.NumberFormat([locale], {useGrouping: false}) where
	    // Intl.NumberFormat is the standard built-in constructor defined in 11.1.3.
	    var nf = new Intl.NumberFormat([locale], { useGrouping: false });
	
	    // 4. Let nf2 be the result of creating a new NumberFormat object as if by the
	    // expression new Intl.NumberFormat([locale], {minimumIntegerDigits: 2, useGrouping:
	    // false}) where Intl.NumberFormat is the standard built-in constructor defined in
	    // 11.1.3.
	    var nf2 = new Intl.NumberFormat([locale], { minimumIntegerDigits: 2, useGrouping: false });
	
	    // 5. Let tm be the result of calling the ToLocalTime abstract operation (defined
	    // below) with x, the value of the [[calendar]] internal property of dateTimeFormat,
	    // and the value of the [[timeZone]] internal property of dateTimeFormat.
	    var tm = ToLocalTime(x, internal['[[calendar]]'], internal['[[timeZone]]']);
	
	    // 6. Let result be the value of the [[pattern]] internal property of dateTimeFormat.
	    var pattern = internal['[[pattern]]'];
	
	    // 7.
	    var result = new List();
	
	    // 8.
	    var index = 0;
	
	    // 9.
	    var beginIndex = pattern.indexOf('{');
	
	    // 10.
	    var endIndex = 0;
	
	    // Need the locale minus any extensions
	    var dataLocale = internal['[[dataLocale]]'];
	
	    // Need the calendar data from CLDR
	    var localeData = internals.DateTimeFormat['[[localeData]]'][dataLocale].calendars;
	    var ca = internal['[[calendar]]'];
	
	    // 11.
	    while (beginIndex !== -1) {
	        var fv = void 0;
	        // a.
	        endIndex = pattern.indexOf('}', beginIndex);
	        // b.
	        if (endIndex === -1) {
	            throw new Error('Unclosed pattern');
	        }
	        // c.
	        if (beginIndex > index) {
	            arrPush.call(result, {
	                type: 'literal',
	                value: pattern.substring(index, beginIndex)
	            });
	        }
	        // d.
	        var p = pattern.substring(beginIndex + 1, endIndex);
	        // e.
	        if (dateTimeComponents.hasOwnProperty(p)) {
	            //   i. Let f be the value of the [[<p>]] internal property of dateTimeFormat.
	            var f = internal['[[' + p + ']]'];
	            //  ii. Let v be the value of tm.[[<p>]].
	            var v = tm['[[' + p + ']]'];
	            // iii. If p is "year" and v ≤ 0, then let v be 1 - v.
	            if (p === 'year' && v <= 0) {
	                v = 1 - v;
	            }
	            //  iv. If p is "month", then increase v by 1.
	            else if (p === 'month') {
	                    v++;
	                }
	                //   v. If p is "hour" and the value of the [[hour12]] internal property of
	                //      dateTimeFormat is true, then
	                else if (p === 'hour' && internal['[[hour12]]'] === true) {
	                        // 1. Let v be v modulo 12.
	                        v = v % 12;
	                        // 2. If v is 0 and the value of the [[hourNo0]] internal property of
	                        //    dateTimeFormat is true, then let v be 12.
	                        if (v === 0 && internal['[[hourNo0]]'] === true) {
	                            v = 12;
	                        }
	                    }
	
	            //  vi. If f is "numeric", then
	            if (f === 'numeric') {
	                // 1. Let fv be the result of calling the FormatNumber abstract operation
	                //    (defined in 11.3.2) with arguments nf and v.
	                fv = FormatNumber(nf, v);
	            }
	            // vii. Else if f is "2-digit", then
	            else if (f === '2-digit') {
	                    // 1. Let fv be the result of calling the FormatNumber abstract operation
	                    //    with arguments nf2 and v.
	                    fv = FormatNumber(nf2, v);
	                    // 2. If the length of fv is greater than 2, let fv be the substring of fv
	                    //    containing the last two characters.
	                    if (fv.length > 2) {
	                        fv = fv.slice(-2);
	                    }
	                }
	                // viii. Else if f is "narrow", "short", or "long", then let fv be a String
	                //     value representing f in the desired form; the String value depends upon
	                //     the implementation and the effective locale and calendar of
	                //     dateTimeFormat. If p is "month", then the String value may also depend
	                //     on whether dateTimeFormat has a [[day]] internal property. If p is
	                //     "timeZoneName", then the String value may also depend on the value of
	                //     the [[inDST]] field of tm.
	                else if (f in dateWidths) {
	                        switch (p) {
	                            case 'month':
	                                fv = resolveDateString(localeData, ca, 'months', f, tm['[[' + p + ']]']);
	                                break;
	
	                            case 'weekday':
	                                try {
	                                    fv = resolveDateString(localeData, ca, 'days', f, tm['[[' + p + ']]']);
	                                    // fv = resolveDateString(ca.days, f)[tm['[['+ p +']]']];
	                                } catch (e) {
	                                    throw new Error('Could not find weekday data for locale ' + locale);
	                                }
	                                break;
	
	                            case 'timeZoneName':
	                                fv = ''; // ###TODO
	                                break;
	
	                            case 'era':
	                                try {
	                                    fv = resolveDateString(localeData, ca, 'eras', f, tm['[[' + p + ']]']);
	                                } catch (e) {
	                                    throw new Error('Could not find era data for locale ' + locale);
	                                }
	                                break;
	
	                            default:
	                                fv = tm['[[' + p + ']]'];
	                        }
	                    }
	            // ix
	            arrPush.call(result, {
	                type: p,
	                value: fv
	            });
	            // f.
	        } else if (p === 'ampm') {
	            // i.
	            var _v = tm['[[hour]]'];
	            // ii./iii.
	            fv = resolveDateString(localeData, ca, 'dayPeriods', _v > 11 ? 'pm' : 'am', null);
	            // iv.
	            arrPush.call(result, {
	                type: 'dayPeriod',
	                value: fv
	            });
	            // g.
	        } else {
	            arrPush.call(result, {
	                type: 'literal',
	                value: pattern.substring(beginIndex, endIndex + 1)
	            });
	        }
	        // h.
	        index = endIndex + 1;
	        // i.
	        beginIndex = pattern.indexOf('{', index);
	    }
	    // 12.
	    if (endIndex < pattern.length - 1) {
	        arrPush.call(result, {
	            type: 'literal',
	            value: pattern.substr(endIndex + 1)
	        });
	    }
	    // 13.
	    return result;
	}
	
	/**
	 * When the FormatDateTime abstract operation is called with arguments dateTimeFormat
	 * (which must be an object initialized as a DateTimeFormat) and x (which must be a Number
	 * value), it returns a String value representing x (interpreted as a time value as
	 * specified in ES5, 15.9.1.1) according to the effective locale and the formatting
	 * options of dateTimeFormat.
	 */
	function FormatDateTime(dateTimeFormat, x) {
	    var parts = CreateDateTimeParts(dateTimeFormat, x);
	    var result = '';
	
	    for (var i = 0; parts.length > i; i++) {
	        var part = parts[i];
	        result += part.value;
	    }
	    return result;
	}
	
	function FormatToPartsDateTime(dateTimeFormat, x) {
	    var parts = CreateDateTimeParts(dateTimeFormat, x);
	    var result = [];
	    for (var i = 0; parts.length > i; i++) {
	        var part = parts[i];
	        result.push({
	            type: part.type,
	            value: part.value
	        });
	    }
	    return result;
	}
	
	/**
	 * When the ToLocalTime abstract operation is called with arguments date, calendar, and
	 * timeZone, the following steps are taken:
	 */
	function ToLocalTime(date, calendar, timeZone) {
	    // 1. Apply calendrical calculations on date for the given calendar and time zone to
	    //    produce weekday, era, year, month, day, hour, minute, second, and inDST values.
	    //    The calculations should use best available information about the specified
	    //    calendar and time zone. If the calendar is "gregory", then the calculations must
	    //    match the algorithms specified in ES5, 15.9.1, except that calculations are not
	    //    bound by the restrictions on the use of best available information on time zones
	    //    for local time zone adjustment and daylight saving time adjustment imposed by
	    //    ES5, 15.9.1.7 and 15.9.1.8.
	    // ###TODO###
	    var d = new Date(date),
	        m = 'get' + (timeZone || '');
	
	    // 2. Return a Record with fields [[weekday]], [[era]], [[year]], [[month]], [[day]],
	    //    [[hour]], [[minute]], [[second]], and [[inDST]], each with the corresponding
	    //    calculated value.
	    return new Record({
	        '[[weekday]]': d[m + 'Day'](),
	        '[[era]]': +(d[m + 'FullYear']() >= 0),
	        '[[year]]': d[m + 'FullYear'](),
	        '[[month]]': d[m + 'Month'](),
	        '[[day]]': d[m + 'Date'](),
	        '[[hour]]': d[m + 'Hours'](),
	        '[[minute]]': d[m + 'Minutes'](),
	        '[[second]]': d[m + 'Seconds'](),
	        '[[inDST]]': false // ###TODO###
	    });
	}
	
	/**
	 * The function returns a new object whose properties and attributes are set as if
	 * constructed by an object literal assigning to each of the following properties the
	 * value of the corresponding internal property of this DateTimeFormat object (see 12.4):
	 * locale, calendar, numberingSystem, timeZone, hour12, weekday, era, year, month, day,
	 * hour, minute, second, and timeZoneName. Properties whose corresponding internal
	 * properties are not present are not assigned.
	 */
	/* 12.3.3 */defineProperty(Intl.DateTimeFormat.prototype, 'resolvedOptions', {
	    writable: true,
	    configurable: true,
	    value: function value() {
	        var prop = void 0,
	            descs = new Record(),
	            props = ['locale', 'calendar', 'numberingSystem', 'timeZone', 'hour12', 'weekday', 'era', 'year', 'month', 'day', 'hour', 'minute', 'second', 'timeZoneName'],
	            internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);
	
	        // Satisfy test 12.3_b
	        if (!internal || !internal['[[initializedDateTimeFormat]]']) throw new TypeError('`this` value for resolvedOptions() is not an initialized Intl.DateTimeFormat object.');
	
	        for (var i = 0, max = props.length; i < max; i++) {
	            if (hop.call(internal, prop = '[[' + props[i] + ']]')) descs[props[i]] = { value: internal[prop], writable: true, configurable: true, enumerable: true };
	        }
	
	        return objCreate({}, descs);
	    }
	});
	
	var ls = Intl.__localeSensitiveProtos = {
	    Number: {},
	    Date: {}
	};
	
	/**
	 * When the toLocaleString method is called with optional arguments locales and options,
	 * the following steps are taken:
	 */
	/* 13.2.1 */ls.Number.toLocaleString = function () {
	    // Satisfy test 13.2.1_1
	    if (Object.prototype.toString.call(this) !== '[object Number]') throw new TypeError('`this` value must be a number for Number.prototype.toLocaleString()');
	
	    // 1. Let x be this Number value (as defined in ES5, 15.7.4).
	    // 2. If locales is not provided, then let locales be undefined.
	    // 3. If options is not provided, then let options be undefined.
	    // 4. Let numberFormat be the result of creating a new object as if by the
	    //    expression new Intl.NumberFormat(locales, options) where
	    //    Intl.NumberFormat is the standard built-in constructor defined in 11.1.3.
	    // 5. Return the result of calling the FormatNumber abstract operation
	    //    (defined in 11.3.2) with arguments numberFormat and x.
	    return FormatNumber(new NumberFormatConstructor(arguments[0], arguments[1]), this);
	};
	
	/**
	 * When the toLocaleString method is called with optional arguments locales and options,
	 * the following steps are taken:
	 */
	/* 13.3.1 */ls.Date.toLocaleString = function () {
	    // Satisfy test 13.3.0_1
	    if (Object.prototype.toString.call(this) !== '[object Date]') throw new TypeError('`this` value must be a Date instance for Date.prototype.toLocaleString()');
	
	    // 1. Let x be this time value (as defined in ES5, 15.9.5).
	    var x = +this;
	
	    // 2. If x is NaN, then return "Invalid Date".
	    if (isNaN(x)) return 'Invalid Date';
	
	    // 3. If locales is not provided, then let locales be undefined.
	    var locales = arguments[0];
	
	    // 4. If options is not provided, then let options be undefined.
	    var options = arguments[1];
	
	    // 5. Let options be the result of calling the ToDateTimeOptions abstract
	    //    operation (defined in 12.1.1) with arguments options, "any", and "all".
	    options = ToDateTimeOptions(options, 'any', 'all');
	
	    // 6. Let dateTimeFormat be the result of creating a new object as if by the
	    //    expression new Intl.DateTimeFormat(locales, options) where
	    //    Intl.DateTimeFormat is the standard built-in constructor defined in 12.1.3.
	    var dateTimeFormat = new DateTimeFormatConstructor(locales, options);
	
	    // 7. Return the result of calling the FormatDateTime abstract operation (defined
	    //    in 12.3.2) with arguments dateTimeFormat and x.
	    return FormatDateTime(dateTimeFormat, x);
	};
	
	/**
	 * When the toLocaleDateString method is called with optional arguments locales and
	 * options, the following steps are taken:
	 */
	/* 13.3.2 */ls.Date.toLocaleDateString = function () {
	    // Satisfy test 13.3.0_1
	    if (Object.prototype.toString.call(this) !== '[object Date]') throw new TypeError('`this` value must be a Date instance for Date.prototype.toLocaleDateString()');
	
	    // 1. Let x be this time value (as defined in ES5, 15.9.5).
	    var x = +this;
	
	    // 2. If x is NaN, then return "Invalid Date".
	    if (isNaN(x)) return 'Invalid Date';
	
	    // 3. If locales is not provided, then let locales be undefined.
	    var locales = arguments[0],
	
	
	    // 4. If options is not provided, then let options be undefined.
	    options = arguments[1];
	
	    // 5. Let options be the result of calling the ToDateTimeOptions abstract
	    //    operation (defined in 12.1.1) with arguments options, "date", and "date".
	    options = ToDateTimeOptions(options, 'date', 'date');
	
	    // 6. Let dateTimeFormat be the result of creating a new object as if by the
	    //    expression new Intl.DateTimeFormat(locales, options) where
	    //    Intl.DateTimeFormat is the standard built-in constructor defined in 12.1.3.
	    var dateTimeFormat = new DateTimeFormatConstructor(locales, options);
	
	    // 7. Return the result of calling the FormatDateTime abstract operation (defined
	    //    in 12.3.2) with arguments dateTimeFormat and x.
	    return FormatDateTime(dateTimeFormat, x);
	};
	
	/**
	 * When the toLocaleTimeString method is called with optional arguments locales and
	 * options, the following steps are taken:
	 */
	/* 13.3.3 */ls.Date.toLocaleTimeString = function () {
	    // Satisfy test 13.3.0_1
	    if (Object.prototype.toString.call(this) !== '[object Date]') throw new TypeError('`this` value must be a Date instance for Date.prototype.toLocaleTimeString()');
	
	    // 1. Let x be this time value (as defined in ES5, 15.9.5).
	    var x = +this;
	
	    // 2. If x is NaN, then return "Invalid Date".
	    if (isNaN(x)) return 'Invalid Date';
	
	    // 3. If locales is not provided, then let locales be undefined.
	    var locales = arguments[0];
	
	    // 4. If options is not provided, then let options be undefined.
	    var options = arguments[1];
	
	    // 5. Let options be the result of calling the ToDateTimeOptions abstract
	    //    operation (defined in 12.1.1) with arguments options, "time", and "time".
	    options = ToDateTimeOptions(options, 'time', 'time');
	
	    // 6. Let dateTimeFormat be the result of creating a new object as if by the
	    //    expression new Intl.DateTimeFormat(locales, options) where
	    //    Intl.DateTimeFormat is the standard built-in constructor defined in 12.1.3.
	    var dateTimeFormat = new DateTimeFormatConstructor(locales, options);
	
	    // 7. Return the result of calling the FormatDateTime abstract operation (defined
	    //    in 12.3.2) with arguments dateTimeFormat and x.
	    return FormatDateTime(dateTimeFormat, x);
	};
	
	defineProperty(Intl, '__applyLocaleSensitivePrototypes', {
	    writable: true,
	    configurable: true,
	    value: function value() {
	        defineProperty(Number.prototype, 'toLocaleString', { writable: true, configurable: true, value: ls.Number.toLocaleString });
	        // Need this here for IE 8, to avoid the _DontEnum_ bug
	        defineProperty(Date.prototype, 'toLocaleString', { writable: true, configurable: true, value: ls.Date.toLocaleString });
	
	        for (var k in ls.Date) {
	            if (hop.call(ls.Date, k)) defineProperty(Date.prototype, k, { writable: true, configurable: true, value: ls.Date[k] });
	        }
	    }
	});
	
	/**
	 * Can't really ship a single script with data for hundreds of locales, so we provide
	 * this __addLocaleData method as a means for the developer to add the data on an
	 * as-needed basis
	 */
	defineProperty(Intl, '__addLocaleData', {
	    value: function value(data) {
	        if (!IsStructurallyValidLanguageTag(data.locale)) throw new Error("Object passed doesn't identify itself with a valid language tag");
	
	        addLocaleData(data, data.locale);
	    }
	});
	
	function addLocaleData(data, tag) {
	    // Both NumberFormat and DateTimeFormat require number data, so throw if it isn't present
	    if (!data.number) throw new Error("Object passed doesn't contain locale data for Intl.NumberFormat");
	
	    var locale = void 0,
	        locales = [tag],
	        parts = tag.split('-');
	
	    // Create fallbacks for locale data with scripts, e.g. Latn, Hans, Vaii, etc
	    if (parts.length > 2 && parts[1].length === 4) arrPush.call(locales, parts[0] + '-' + parts[2]);
	
	    while (locale = arrShift.call(locales)) {
	        // Add to NumberFormat internal properties as per 11.2.3
	        arrPush.call(internals.NumberFormat['[[availableLocales]]'], locale);
	        internals.NumberFormat['[[localeData]]'][locale] = data.number;
	
	        // ...and DateTimeFormat internal properties as per 12.2.3
	        if (data.date) {
	            data.date.nu = data.number.nu;
	            arrPush.call(internals.DateTimeFormat['[[availableLocales]]'], locale);
	            internals.DateTimeFormat['[[localeData]]'][locale] = data.date;
	        }
	    }
	
	    // If this is the first set of locale data added, make it the default
	    if (defaultLocale === undefined) setDefaultLocale(tag);
	}
	
	defineProperty(Intl, '__disableRegExpRestore', {
	    value: function value() {
	        internals.disableRegExpRestore = true;
	    }
	});
	
	module.exports = Intl;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 2812 */
/***/ function(module, exports) {

	'use strict';
	
	var getDay = Date.prototype.getDay;
	var tryDateObject = function tryDateObject(value) {
		try {
			getDay.call(value);
			return true;
		} catch (e) {
			return false;
		}
	};
	
	var toStr = Object.prototype.toString;
	var dateClass = '[object Date]';
	var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
	
	module.exports = function isDateObject(value) {
		if (typeof value !== 'object' || value === null) { return false; }
		return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
	};


/***/ },
/* 2813 */
/***/ function(module, exports, __webpack_require__) {

	var lowerCase = __webpack_require__(257)
	
	/**
	 * Check if a string is lower case.
	 *
	 * @param  {String}  string
	 * @param  {String}  [locale]
	 * @return {Boolean}
	 */
	module.exports = function (string, locale) {
	  return lowerCase(string, locale) === string
	}


/***/ },
/* 2814 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var has = __webpack_require__(322);
	var regexExec = RegExp.prototype.exec;
	var gOPD = Object.getOwnPropertyDescriptor;
	
	var tryRegexExecCall = function tryRegexExec(value) {
		try {
			var lastIndex = value.lastIndex;
			value.lastIndex = 0;
	
			regexExec.call(value);
			return true;
		} catch (e) {
			return false;
		} finally {
			value.lastIndex = lastIndex;
		}
	};
	var toStr = Object.prototype.toString;
	var regexClass = '[object RegExp]';
	var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
	
	module.exports = function isRegex(value) {
		if (!value || typeof value !== 'object') {
			return false;
		}
		if (!hasToStringTag) {
			return toStr.call(value) === regexClass;
		}
	
		var descriptor = gOPD(value, 'lastIndex');
		var hasLastIndexDataProperty = descriptor && has(descriptor, 'value');
		if (!hasLastIndexDataProperty) {
			return false;
		}
	
		return tryRegexExecCall(value);
	};


/***/ },
/* 2815 */
/***/ function(module, exports, __webpack_require__) {

	var upperCase = __webpack_require__(172)
	
	/**
	 * Check if a string is upper case.
	 *
	 * @param  {String}  string
	 * @param  {String}  [locale]
	 * @return {Boolean}
	 */
	module.exports = function (string, locale) {
	  return upperCase(string, locale) === string
	}


/***/ },
/* 2816 */,
/* 2817 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(161),
	    root = __webpack_require__(62);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ },
/* 2818 */
/***/ function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(2885),
	    hashDelete = __webpack_require__(2886),
	    hashGet = __webpack_require__(2887),
	    hashHas = __webpack_require__(2888),
	    hashSet = __webpack_require__(2889);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ },
/* 2819 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(161),
	    root = __webpack_require__(62);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ },
/* 2820 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(161),
	    root = __webpack_require__(62);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ },
/* 2821 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(450),
	    setCacheAdd = __webpack_require__(2918),
	    setCacheHas = __webpack_require__(2919);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ },
/* 2822 */
/***/ function(module, exports) {

	/**
	 * Adds the key-value `pair` to `map`.
	 *
	 * @private
	 * @param {Object} map The map to modify.
	 * @param {Array} pair The key-value pair to add.
	 * @returns {Object} Returns `map`.
	 */
	function addMapEntry(map, pair) {
	  // Don't return `map.set` because it's not chainable in IE 11.
	  map.set(pair[0], pair[1]);
	  return map;
	}
	
	module.exports = addMapEntry;


/***/ },
/* 2823 */
/***/ function(module, exports) {

	/**
	 * Adds `value` to `set`.
	 *
	 * @private
	 * @param {Object} set The set to modify.
	 * @param {*} value The value to add.
	 * @returns {Object} Returns `set`.
	 */
	function addSetEntry(set, value) {
	  // Don't return `set.add` because it's not chainable in IE 11.
	  set.add(value);
	  return set;
	}
	
	module.exports = addSetEntry;


/***/ },
/* 2824 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ },
/* 2825 */
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(724);
	
	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes(array, value) {
	  var length = array == null ? 0 : array.length;
	  return !!length && baseIndexOf(array, value, 0) > -1;
	}
	
	module.exports = arrayIncludes;


/***/ },
/* 2826 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ },
/* 2827 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(255),
	    keys = __webpack_require__(163);
	
	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ },
/* 2828 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(255),
	    keysIn = __webpack_require__(752);
	
	/**
	 * The base implementation of `_.assignIn` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssignIn(object, source) {
	  return object && copyObject(source, keysIn(source), object);
	}
	
	module.exports = baseAssignIn;


/***/ },
/* 2829 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(451),
	    arrayEach = __webpack_require__(719),
	    assignValue = __webpack_require__(454),
	    baseAssign = __webpack_require__(2827),
	    baseAssignIn = __webpack_require__(2828),
	    cloneBuffer = __webpack_require__(2859),
	    copyArray = __webpack_require__(459),
	    copySymbols = __webpack_require__(2866),
	    copySymbolsIn = __webpack_require__(2867),
	    getAllKeys = __webpack_require__(734),
	    getAllKeysIn = __webpack_require__(460),
	    getTag = __webpack_require__(463),
	    initCloneArray = __webpack_require__(2890),
	    initCloneByTag = __webpack_require__(2891),
	    initCloneObject = __webpack_require__(2892),
	    isArray = __webpack_require__(65),
	    isBuffer = __webpack_require__(336),
	    isObject = __webpack_require__(88),
	    keys = __webpack_require__(163);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	cloneableTags[boolTag] = cloneableTags[dateTag] =
	cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	cloneableTags[int32Tag] = cloneableTags[mapTag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[setTag] =
	cloneableTags[stringTag] = cloneableTags[symbolTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Deep clone
	 *  2 - Flatten inherited properties
	 *  4 - Clone symbols
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, bitmask, customizer, key, object, stack) {
	  var result,
	      isDeep = bitmask & CLONE_DEEP_FLAG,
	      isFlat = bitmask & CLONE_FLAT_FLAG,
	      isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag(value),
	        isFunc = tag == funcTag || tag == genTag;
	
	    if (isBuffer(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      result = (isFlat || isFunc) ? {} : initCloneObject(value);
	      if (!isDeep) {
	        return isFlat
	          ? copySymbolsIn(value, baseAssignIn(result, value))
	          : copySymbols(value, baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, baseClone, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);
	
	  var keysFunc = isFull
	    ? (isFlat ? getAllKeysIn : getAllKeys)
	    : (isFlat ? keysIn : keys);
	
	  var props = isArr ? undefined : keysFunc(value);
	  arrayEach(props || value, function(subValue, key) {
	    if (props) {
	      key = subValue;
	      subValue = value[key];
	    }
	    // Recursively populate clone (susceptible to call stack limits).
	    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	  });
	  return result;
	}
	
	module.exports = baseClone;


/***/ },
/* 2830 */
/***/ function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(2834),
	    createBaseEach = __webpack_require__(2870);
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ },
/* 2831 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ },
/* 2832 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(453),
	    isFlattenable = __webpack_require__(2894);
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ },
/* 2833 */
/***/ function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(2871);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ },
/* 2834 */
/***/ function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(2833),
	    keys = __webpack_require__(163);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ },
/* 2835 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.has` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHas(object, key) {
	  return object != null && hasOwnProperty.call(object, key);
	}
	
	module.exports = baseHas;


/***/ },
/* 2836 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ },
/* 2837 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(160),
	    isObjectLike = __webpack_require__(134);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ },
/* 2838 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(451),
	    equalArrays = __webpack_require__(732),
	    equalByTag = __webpack_require__(2877),
	    equalObjects = __webpack_require__(2878),
	    getTag = __webpack_require__(463),
	    isArray = __webpack_require__(65),
	    isBuffer = __webpack_require__(336),
	    isTypedArray = __webpack_require__(470);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ },
/* 2839 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(451),
	    baseIsEqual = __webpack_require__(455);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ },
/* 2840 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	module.exports = baseIsNaN;


/***/ },
/* 2841 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(751),
	    isMasked = __webpack_require__(2897),
	    isObject = __webpack_require__(88),
	    toSource = __webpack_require__(749);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ },
/* 2842 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(160),
	    isLength = __webpack_require__(469),
	    isObjectLike = __webpack_require__(134);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ },
/* 2843 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(88),
	    isPrototype = __webpack_require__(333),
	    nativeKeysIn = __webpack_require__(2911);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeysIn;


/***/ },
/* 2844 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(2830),
	    isArrayLike = __webpack_require__(209);
	
	/**
	 * The base implementation of `_.map` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap(collection, iteratee) {
	  var index = -1,
	      result = isArrayLike(collection) ? Array(collection.length) : [];
	
	  baseEach(collection, function(value, key, collection) {
	    result[++index] = iteratee(value, key, collection);
	  });
	  return result;
	}
	
	module.exports = baseMap;


/***/ },
/* 2845 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(2839),
	    getMatchData = __webpack_require__(2881),
	    matchesStrictComparable = __webpack_require__(741);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ },
/* 2846 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(455),
	    get = __webpack_require__(750),
	    hasIn = __webpack_require__(2933),
	    isKey = __webpack_require__(464),
	    isStrictComparable = __webpack_require__(739),
	    matchesStrictComparable = __webpack_require__(741),
	    toKey = __webpack_require__(208);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ },
/* 2847 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(329),
	    baseSet = __webpack_require__(2850),
	    castPath = __webpack_require__(207);
	
	/**
	 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} paths The property paths to pick.
	 * @param {Function} predicate The function invoked per property.
	 * @returns {Object} Returns the new object.
	 */
	function basePickBy(object, paths, predicate) {
	  var index = -1,
	      length = paths.length,
	      result = {};
	
	  while (++index < length) {
	    var path = paths[index],
	        value = baseGet(object, path);
	
	    if (predicate(value, path)) {
	      baseSet(result, castPath(path, object), value);
	    }
	  }
	  return result;
	}
	
	module.exports = basePickBy;


/***/ },
/* 2848 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ },
/* 2849 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(329);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ },
/* 2850 */
/***/ function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(454),
	    castPath = __webpack_require__(207),
	    isIndex = __webpack_require__(332),
	    isObject = __webpack_require__(88),
	    toKey = __webpack_require__(208);
	
	/**
	 * The base implementation of `_.set`.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to set.
	 * @param {*} value The value to set.
	 * @param {Function} [customizer] The function to customize path creation.
	 * @returns {Object} Returns `object`.
	 */
	function baseSet(object, path, value, customizer) {
	  if (!isObject(object)) {
	    return object;
	  }
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      lastIndex = length - 1,
	      nested = object;
	
	  while (nested != null && ++index < length) {
	    var key = toKey(path[index]),
	        newValue = value;
	
	    if (index != lastIndex) {
	      var objValue = nested[key];
	      newValue = customizer ? customizer(objValue, key, nested) : undefined;
	      if (newValue === undefined) {
	        newValue = isObject(objValue)
	          ? objValue
	          : (isIndex(path[index + 1]) ? [] : {});
	      }
	    }
	    assignValue(nested, key, newValue);
	    nested = nested[key];
	  }
	  return object;
	}
	
	module.exports = baseSet;


/***/ },
/* 2851 */
/***/ function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(2929),
	    defineProperty = __webpack_require__(731),
	    identity = __webpack_require__(468);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ },
/* 2852 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;
	
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = end > length ? length : end;
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;
	
	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}
	
	module.exports = baseSlice;


/***/ },
/* 2853 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ },
/* 2854 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(206),
	    arrayMap = __webpack_require__(254),
	    isArray = __webpack_require__(65),
	    isSymbol = __webpack_require__(337);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ },
/* 2855 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ },
/* 2856 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(207),
	    last = __webpack_require__(753),
	    parent = __webpack_require__(2915),
	    toKey = __webpack_require__(208);
	
	/**
	 * The base implementation of `_.unset`.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The property path to unset.
	 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	 */
	function baseUnset(object, path) {
	  path = castPath(path, object);
	  object = parent(object, path);
	  return object == null || delete object[toKey(last(path))];
	}
	
	module.exports = baseUnset;


/***/ },
/* 2857 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(254);
	
	/**
	 * The base implementation of `_.values` and `_.valuesIn` which creates an
	 * array of `object` property values corresponding to the property names
	 * of `props`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} props The property names to get values for.
	 * @returns {Object} Returns the array of property values.
	 */
	function baseValues(object, props) {
	  return arrayMap(props, function(key) {
	    return object[key];
	  });
	}
	
	module.exports = baseValues;


/***/ },
/* 2858 */
/***/ function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ },
/* 2859 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(62);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	  buffer.copy(result);
	  return result;
	}
	
	module.exports = cloneBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(173)(module)))

/***/ },
/* 2860 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(458);
	
	/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */
	function cloneDataView(dataView, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}
	
	module.exports = cloneDataView;


/***/ },
/* 2861 */
/***/ function(module, exports, __webpack_require__) {

	var addMapEntry = __webpack_require__(2822),
	    arrayReduce = __webpack_require__(721),
	    mapToArray = __webpack_require__(740);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1;
	
	/**
	 * Creates a clone of `map`.
	 *
	 * @private
	 * @param {Object} map The map to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned map.
	 */
	function cloneMap(map, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
	  return arrayReduce(array, addMapEntry, new map.constructor);
	}
	
	module.exports = cloneMap;


/***/ },
/* 2862 */
/***/ function(module, exports) {

	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}
	
	module.exports = cloneRegExp;


/***/ },
/* 2863 */
/***/ function(module, exports, __webpack_require__) {

	var addSetEntry = __webpack_require__(2823),
	    arrayReduce = __webpack_require__(721),
	    setToArray = __webpack_require__(745);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1;
	
	/**
	 * Creates a clone of `set`.
	 *
	 * @private
	 * @param {Object} set The set to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned set.
	 */
	function cloneSet(set, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
	  return arrayReduce(array, addSetEntry, new set.constructor);
	}
	
	module.exports = cloneSet;


/***/ },
/* 2864 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(206);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	}
	
	module.exports = cloneSymbol;


/***/ },
/* 2865 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(458);
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	module.exports = cloneTypedArray;


/***/ },
/* 2866 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(255),
	    getSymbols = __webpack_require__(462);
	
	/**
	 * Copies own symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols(source), object);
	}
	
	module.exports = copySymbols;


/***/ },
/* 2867 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(255),
	    getSymbolsIn = __webpack_require__(737);
	
	/**
	 * Copies own and inherited symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbolsIn(source, object) {
	  return copyObject(source, getSymbolsIn(source), object);
	}
	
	module.exports = copySymbolsIn;


/***/ },
/* 2868 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(62);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ },
/* 2869 */
/***/ function(module, exports) {

	/**
	 * Gets the number of `placeholder` occurrences in `array`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} placeholder The placeholder to search for.
	 * @returns {number} Returns the placeholder count.
	 */
	function countHolders(array, placeholder) {
	  var length = array.length,
	      result = 0;
	
	  while (length--) {
	    if (array[length] === placeholder) {
	      ++result;
	    }
	  }
	  return result;
	}
	
	module.exports = countHolders;


/***/ },
/* 2870 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(209);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ },
/* 2871 */
/***/ function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ },
/* 2872 */
/***/ function(module, exports, __webpack_require__) {

	var createCtor = __webpack_require__(330),
	    root = __webpack_require__(62);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1;
	
	/**
	 * Creates a function that wraps `func` to invoke it with the optional `this`
	 * binding of `thisArg`.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createBind(func, bitmask, thisArg) {
	  var isBind = bitmask & WRAP_BIND_FLAG,
	      Ctor = createCtor(func);
	
	  function wrapper() {
	    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	    return fn.apply(isBind ? thisArg : this, arguments);
	  }
	  return wrapper;
	}
	
	module.exports = createBind;


/***/ },
/* 2873 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(452),
	    createCtor = __webpack_require__(330),
	    createHybrid = __webpack_require__(729),
	    createRecurry = __webpack_require__(730),
	    getHolder = __webpack_require__(736),
	    replaceHolders = __webpack_require__(465),
	    root = __webpack_require__(62);
	
	/**
	 * Creates a function that wraps `func` to enable currying.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {number} arity The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createCurry(func, bitmask, arity) {
	  var Ctor = createCtor(func);
	
	  function wrapper() {
	    var length = arguments.length,
	        args = Array(length),
	        index = length,
	        placeholder = getHolder(wrapper);
	
	    while (index--) {
	      args[index] = arguments[index];
	    }
	    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	      ? []
	      : replaceHolders(args, placeholder);
	
	    length -= holders.length;
	    if (length < arity) {
	      return createRecurry(
	        func, bitmask, createHybrid, wrapper.placeholder, undefined,
	        args, holders, undefined, undefined, arity - length);
	    }
	    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	    return apply(fn, this, args);
	  }
	  return wrapper;
	}
	
	module.exports = createCurry;


/***/ },
/* 2874 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(452),
	    createCtor = __webpack_require__(330),
	    root = __webpack_require__(62);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1;
	
	/**
	 * Creates a function that wraps `func` to invoke it with the `this` binding
	 * of `thisArg` and `partials` prepended to the arguments it receives.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} partials The arguments to prepend to those provided to
	 *  the new function.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createPartial(func, bitmask, thisArg, partials) {
	  var isBind = bitmask & WRAP_BIND_FLAG,
	      Ctor = createCtor(func);
	
	  function wrapper() {
	    var argsIndex = -1,
	        argsLength = arguments.length,
	        leftIndex = -1,
	        leftLength = partials.length,
	        args = Array(leftLength + argsLength),
	        fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	    while (++leftIndex < leftLength) {
	      args[leftIndex] = partials[leftIndex];
	    }
	    while (argsLength--) {
	      args[leftIndex++] = arguments[++argsIndex];
	    }
	    return apply(fn, isBind ? thisArg : this, args);
	  }
	  return wrapper;
	}
	
	module.exports = createPartial;


/***/ },
/* 2875 */
/***/ function(module, exports, __webpack_require__) {

	var baseSetData = __webpack_require__(726),
	    createBind = __webpack_require__(2872),
	    createCurry = __webpack_require__(2873),
	    createHybrid = __webpack_require__(729),
	    createPartial = __webpack_require__(2874),
	    getData = __webpack_require__(735),
	    mergeData = __webpack_require__(2909),
	    setData = __webpack_require__(744),
	    setWrapToString = __webpack_require__(747),
	    toInteger = __webpack_require__(757);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_CURRY_RIGHT_FLAG = 16,
	    WRAP_PARTIAL_FLAG = 32,
	    WRAP_PARTIAL_RIGHT_FLAG = 64;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates a function that either curries or invokes `func` with optional
	 * `this` binding and partially applied arguments.
	 *
	 * @private
	 * @param {Function|string} func The function or method name to wrap.
	 * @param {number} bitmask The bitmask flags.
	 *    1 - `_.bind`
	 *    2 - `_.bindKey`
	 *    4 - `_.curry` or `_.curryRight` of a bound function
	 *    8 - `_.curry`
	 *   16 - `_.curryRight`
	 *   32 - `_.partial`
	 *   64 - `_.partialRight`
	 *  128 - `_.rearg`
	 *  256 - `_.ary`
	 *  512 - `_.flip`
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to be partially applied.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	  var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	  if (!isBindKey && typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var length = partials ? partials.length : 0;
	  if (!length) {
	    bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	    partials = holders = undefined;
	  }
	  ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	  arity = arity === undefined ? arity : toInteger(arity);
	  length -= holders ? holders.length : 0;
	
	  if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	    var partialsRight = partials,
	        holdersRight = holders;
	
	    partials = holders = undefined;
	  }
	  var data = isBindKey ? undefined : getData(func);
	
	  var newData = [
	    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	    argPos, ary, arity
	  ];
	
	  if (data) {
	    mergeData(newData, data);
	  }
	  func = newData[0];
	  bitmask = newData[1];
	  thisArg = newData[2];
	  partials = newData[3];
	  holders = newData[4];
	  arity = newData[9] = newData[9] === undefined
	    ? (isBindKey ? 0 : func.length)
	    : nativeMax(newData[9] - length, 0);
	
	  if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	    bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	  }
	  if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	    var result = createBind(func, bitmask, thisArg);
	  } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	    result = createCurry(func, bitmask, arity);
	  } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	    result = createPartial(func, bitmask, thisArg, partials);
	  } else {
	    result = createHybrid.apply(undefined, newData);
	  }
	  var setter = data ? baseSetData : setData;
	  return setWrapToString(setter(result, newData), func, bitmask);
	}
	
	module.exports = createWrap;


/***/ },
/* 2876 */
/***/ function(module, exports, __webpack_require__) {

	var isPlainObject = __webpack_require__(256);
	
	/**
	 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	 * objects.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {string} key The key of the property to inspect.
	 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	 */
	function customOmitClone(value) {
	  return isPlainObject(value) ? undefined : value;
	}
	
	module.exports = customOmitClone;


/***/ },
/* 2877 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(206),
	    Uint8Array = __webpack_require__(717),
	    eq = __webpack_require__(467),
	    equalArrays = __webpack_require__(732),
	    mapToArray = __webpack_require__(740),
	    setToArray = __webpack_require__(745);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ },
/* 2878 */
/***/ function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__(734);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ },
/* 2879 */
/***/ function(module, exports, __webpack_require__) {

	var flatten = __webpack_require__(2931),
	    overRest = __webpack_require__(2914),
	    setToString = __webpack_require__(746);
	
	/**
	 * A specialized version of `baseRest` which flattens the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @returns {Function} Returns the new function.
	 */
	function flatRest(func) {
	  return setToString(overRest(func, undefined, flatten), func + '');
	}
	
	module.exports = flatRest;


/***/ },
/* 2880 */
/***/ function(module, exports, __webpack_require__) {

	var realNames = __webpack_require__(2916);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the name of `func`.
	 *
	 * @private
	 * @param {Function} func The function to query.
	 * @returns {string} Returns the function name.
	 */
	function getFuncName(func) {
	  var result = (func.name + ''),
	      array = realNames[result],
	      length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	  while (length--) {
	    var data = array[length],
	        otherFunc = data.func;
	    if (otherFunc == null || otherFunc == func) {
	      return data.name;
	    }
	  }
	  return result;
	}
	
	module.exports = getFuncName;


/***/ },
/* 2881 */
/***/ function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(739),
	    keys = __webpack_require__(163);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ },
/* 2882 */,
/* 2883 */
/***/ function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ },
/* 2884 */
/***/ function(module, exports) {

	/** Used to match wrap detail comments. */
	var reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	    reSplitDetails = /,? & /;
	
	/**
	 * Extracts wrapper details from the `source` body comment.
	 *
	 * @private
	 * @param {string} source The source to inspect.
	 * @returns {Array} Returns the wrapper details.
	 */
	function getWrapDetails(source) {
	  var match = source.match(reWrapDetails);
	  return match ? match[1].split(reSplitDetails) : [];
	}
	
	module.exports = getWrapDetails;


/***/ },
/* 2885 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(334);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ },
/* 2886 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ },
/* 2887 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(334);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ },
/* 2888 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(334);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ },
/* 2889 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(334);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ },
/* 2890 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = array.constructor(length);
	
	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	module.exports = initCloneArray;


/***/ },
/* 2891 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(458),
	    cloneDataView = __webpack_require__(2860),
	    cloneMap = __webpack_require__(2861),
	    cloneRegExp = __webpack_require__(2862),
	    cloneSet = __webpack_require__(2863),
	    cloneSymbol = __webpack_require__(2864),
	    cloneTypedArray = __webpack_require__(2865);
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, cloneFunc, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return cloneArrayBuffer(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case dataViewTag:
	      return cloneDataView(object, isDeep);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      return cloneTypedArray(object, isDeep);
	
	    case mapTag:
	      return cloneMap(object, isDeep, cloneFunc);
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      return cloneRegExp(object);
	
	    case setTag:
	      return cloneSet(object, isDeep, cloneFunc);
	
	    case symbolTag:
	      return cloneSymbol(object);
	  }
	}
	
	module.exports = initCloneByTag;


/***/ },
/* 2892 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(328),
	    getPrototype = __webpack_require__(461),
	    isPrototype = __webpack_require__(333);
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	module.exports = initCloneObject;


/***/ },
/* 2893 */
/***/ function(module, exports) {

	/** Used to match wrap detail comments. */
	var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;
	
	/**
	 * Inserts wrapper `details` in a comment at the top of the `source` body.
	 *
	 * @private
	 * @param {string} source The source to modify.
	 * @returns {Array} details The details to insert.
	 * @returns {string} Returns the modified source.
	 */
	function insertWrapDetails(source, details) {
	  var length = details.length;
	  if (!length) {
	    return source;
	  }
	  var lastIndex = length - 1;
	  details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	  details = details.join(length > 2 ? ', ' : ' ');
	  return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	}
	
	module.exports = insertWrapDetails;


/***/ },
/* 2894 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(206),
	    isArguments = __webpack_require__(335),
	    isArray = __webpack_require__(65);
	
	/** Built-in value references. */
	var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	module.exports = isFlattenable;


/***/ },
/* 2895 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ },
/* 2896 */
/***/ function(module, exports, __webpack_require__) {

	var LazyWrapper = __webpack_require__(448),
	    getData = __webpack_require__(735),
	    getFuncName = __webpack_require__(2880),
	    lodash = __webpack_require__(2948);
	
	/**
	 * Checks if `func` has a lazy counterpart.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	 *  else `false`.
	 */
	function isLaziable(func) {
	  var funcName = getFuncName(func),
	      other = lodash[funcName];
	
	  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	    return false;
	  }
	  if (func === other) {
	    return true;
	  }
	  var data = getData(other);
	  return !!data && func === data[0];
	}
	
	module.exports = isLaziable;


/***/ },
/* 2897 */
/***/ function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(2868);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ },
/* 2898 */
/***/ function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ },
/* 2899 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(327);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ },
/* 2900 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(327);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ },
/* 2901 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(327);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ },
/* 2902 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(327);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ },
/* 2903 */
/***/ function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(2818),
	    ListCache = __webpack_require__(326),
	    Map = __webpack_require__(449);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ },
/* 2904 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(331);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ },
/* 2905 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(331);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ },
/* 2906 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(331);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ },
/* 2907 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(331);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ },
/* 2908 */
/***/ function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(2938);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ },
/* 2909 */
/***/ function(module, exports, __webpack_require__) {

	var composeArgs = __webpack_require__(727),
	    composeArgsRight = __webpack_require__(728),
	    replaceHolders = __webpack_require__(465);
	
	/** Used as the internal argument placeholder. */
	var PLACEHOLDER = '__lodash_placeholder__';
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_BOUND_FLAG = 4,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_ARY_FLAG = 128,
	    WRAP_REARG_FLAG = 256;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * Merges the function metadata of `source` into `data`.
	 *
	 * Merging metadata reduces the number of wrappers used to invoke a function.
	 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	 * may be applied regardless of execution order. Methods like `_.ary` and
	 * `_.rearg` modify function arguments, making the order in which they are
	 * executed important, preventing the merging of metadata. However, we make
	 * an exception for a safe combined case where curried functions have `_.ary`
	 * and or `_.rearg` applied.
	 *
	 * @private
	 * @param {Array} data The destination metadata.
	 * @param {Array} source The source metadata.
	 * @returns {Array} Returns `data`.
	 */
	function mergeData(data, source) {
	  var bitmask = data[1],
	      srcBitmask = source[1],
	      newBitmask = bitmask | srcBitmask,
	      isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	  var isCombo =
	    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	    ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	  // Exit early if metadata can't be merged.
	  if (!(isCommon || isCombo)) {
	    return data;
	  }
	  // Use source `thisArg` if available.
	  if (srcBitmask & WRAP_BIND_FLAG) {
	    data[2] = source[2];
	    // Set when currying a bound function.
	    newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	  }
	  // Compose partial arguments.
	  var value = source[3];
	  if (value) {
	    var partials = data[3];
	    data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	    data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	  }
	  // Compose partial right arguments.
	  value = source[5];
	  if (value) {
	    partials = data[5];
	    data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	    data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	  }
	  // Use source `argPos` if available.
	  value = source[7];
	  if (value) {
	    data[7] = value;
	  }
	  // Use source `ary` if it's smaller.
	  if (srcBitmask & WRAP_ARY_FLAG) {
	    data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	  }
	  // Use source `arity` if one is not provided.
	  if (data[9] == null) {
	    data[9] = source[9];
	  }
	  // Use source `func` and merge bitmasks.
	  data[0] = source[0];
	  data[1] = newBitmask;
	
	  return data;
	}
	
	module.exports = mergeData;


/***/ },
/* 2910 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(743);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ },
/* 2911 */
/***/ function(module, exports) {

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = nativeKeysIn;


/***/ },
/* 2912 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(733);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(173)(module)))

/***/ },
/* 2913 */,
/* 2914 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(452);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ },
/* 2915 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(329),
	    baseSlice = __webpack_require__(2852);
	
	/**
	 * Gets the parent value at `path` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} path The path to get the parent value of.
	 * @returns {*} Returns the parent value.
	 */
	function parent(object, path) {
	  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	}
	
	module.exports = parent;


/***/ },
/* 2916 */
/***/ function(module, exports) {

	/** Used to lookup unminified function names. */
	var realNames = {};
	
	module.exports = realNames;


/***/ },
/* 2917 */
/***/ function(module, exports, __webpack_require__) {

	var copyArray = __webpack_require__(459),
	    isIndex = __webpack_require__(332);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * Reorder `array` according to the specified indexes where the element at
	 * the first index is assigned as the first element, the element at
	 * the second index is assigned as the second element, and so on.
	 *
	 * @private
	 * @param {Array} array The array to reorder.
	 * @param {Array} indexes The arranged array indexes.
	 * @returns {Array} Returns `array`.
	 */
	function reorder(array, indexes) {
	  var arrLength = array.length,
	      length = nativeMin(indexes.length, arrLength),
	      oldArray = copyArray(array);
	
	  while (length--) {
	    var index = indexes[length];
	    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	  }
	  return array;
	}
	
	module.exports = reorder;


/***/ },
/* 2918 */
/***/ function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ },
/* 2919 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ },
/* 2920 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(326);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ },
/* 2921 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ },
/* 2922 */
/***/ function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ },
/* 2923 */
/***/ function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ },
/* 2924 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(326),
	    Map = __webpack_require__(449),
	    MapCache = __webpack_require__(450);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ },
/* 2925 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.indexOf` which performs strict equality
	 * comparisons of values, i.e. `===`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function strictIndexOf(array, value, fromIndex) {
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = strictIndexOf;


/***/ },
/* 2926 */
/***/ function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(2908);
	
	/** Used to match property names within property paths. */
	var reLeadingDot = /^\./,
	    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (reLeadingDot.test(string)) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ },
/* 2927 */
/***/ function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(719),
	    arrayIncludes = __webpack_require__(2825);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_CURRY_RIGHT_FLAG = 16,
	    WRAP_PARTIAL_FLAG = 32,
	    WRAP_PARTIAL_RIGHT_FLAG = 64,
	    WRAP_ARY_FLAG = 128,
	    WRAP_REARG_FLAG = 256,
	    WRAP_FLIP_FLAG = 512;
	
	/** Used to associate wrap methods with their bit flags. */
	var wrapFlags = [
	  ['ary', WRAP_ARY_FLAG],
	  ['bind', WRAP_BIND_FLAG],
	  ['bindKey', WRAP_BIND_KEY_FLAG],
	  ['curry', WRAP_CURRY_FLAG],
	  ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	  ['flip', WRAP_FLIP_FLAG],
	  ['partial', WRAP_PARTIAL_FLAG],
	  ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	  ['rearg', WRAP_REARG_FLAG]
	];
	
	/**
	 * Updates wrapper `details` based on `bitmask` flags.
	 *
	 * @private
	 * @returns {Array} details The details to modify.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @returns {Array} Returns `details`.
	 */
	function updateWrapDetails(details, bitmask) {
	  arrayEach(wrapFlags, function(pair) {
	    var value = '_.' + pair[0];
	    if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	      details.push(value);
	    }
	  });
	  return details.sort();
	}
	
	module.exports = updateWrapDetails;


/***/ },
/* 2928 */
/***/ function(module, exports, __webpack_require__) {

	var LazyWrapper = __webpack_require__(448),
	    LodashWrapper = __webpack_require__(716),
	    copyArray = __webpack_require__(459);
	
	/**
	 * Creates a clone of `wrapper`.
	 *
	 * @private
	 * @param {Object} wrapper The wrapper to clone.
	 * @returns {Object} Returns the cloned wrapper.
	 */
	function wrapperClone(wrapper) {
	  if (wrapper instanceof LazyWrapper) {
	    return wrapper.clone();
	  }
	  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	  result.__actions__ = copyArray(wrapper.__actions__);
	  result.__index__  = wrapper.__index__;
	  result.__values__ = wrapper.__values__;
	  return result;
	}
	
	module.exports = wrapperClone;


/***/ },
/* 2929 */
/***/ function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ },
/* 2930 */
/***/ function(module, exports, __webpack_require__) {

	var createWrap = __webpack_require__(2875);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_CURRY_FLAG = 8;
	
	/**
	 * Creates a function that accepts arguments of `func` and either invokes
	 * `func` returning its result, if at least `arity` number of arguments have
	 * been provided, or returns a function that accepts the remaining `func`
	 * arguments, and so on. The arity of `func` may be specified if `func.length`
	 * is not sufficient.
	 *
	 * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	 * may be used as a placeholder for provided arguments.
	 *
	 * **Note:** This method doesn't set the "length" property of curried functions.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.0.0
	 * @category Function
	 * @param {Function} func The function to curry.
	 * @param {number} [arity=func.length] The arity of `func`.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Function} Returns the new curried function.
	 * @example
	 *
	 * var abc = function(a, b, c) {
	 *   return [a, b, c];
	 * };
	 *
	 * var curried = _.curry(abc);
	 *
	 * curried(1)(2)(3);
	 * // => [1, 2, 3]
	 *
	 * curried(1, 2)(3);
	 * // => [1, 2, 3]
	 *
	 * curried(1, 2, 3);
	 * // => [1, 2, 3]
	 *
	 * // Curried with placeholders.
	 * curried(1)(_, 3)(2);
	 * // => [1, 2, 3]
	 */
	function curry(func, arity, guard) {
	  arity = guard ? undefined : arity;
	  var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	  result.placeholder = curry.placeholder;
	  return result;
	}
	
	// Assign default placeholders.
	curry.placeholder = {};
	
	module.exports = curry;


/***/ },
/* 2931 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(2832);
	
	/**
	 * Flattens `array` a single level deep.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to flatten.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * _.flatten([1, [2, [3, [4]], 5]]);
	 * // => [1, 2, [3, [4]], 5]
	 */
	function flatten(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? baseFlatten(array, 1) : [];
	}
	
	module.exports = flatten;


/***/ },
/* 2932 */
/***/ function(module, exports, __webpack_require__) {

	var baseHas = __webpack_require__(2835),
	    hasPath = __webpack_require__(738);
	
	/**
	 * Checks if `path` is a direct property of `object`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = { 'a': { 'b': 2 } };
	 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.has(object, 'a');
	 * // => true
	 *
	 * _.has(object, 'a.b');
	 * // => true
	 *
	 * _.has(object, ['a', 'b']);
	 * // => true
	 *
	 * _.has(other, 'a');
	 * // => false
	 */
	function has(object, path) {
	  return object != null && hasPath(object, path, baseHas);
	}
	
	module.exports = has;


/***/ },
/* 2933 */
/***/ function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(2836),
	    hasPath = __webpack_require__(738);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ },
/* 2934 */
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(724),
	    isArrayLike = __webpack_require__(209),
	    isString = __webpack_require__(2936),
	    toInteger = __webpack_require__(757),
	    values = __webpack_require__(760);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Checks if `value` is in `collection`. If `collection` is a string, it's
	 * checked for a substring of `value`, otherwise
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * is used for equality comparisons. If `fromIndex` is negative, it's used as
	 * the offset from the end of `collection`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	 * @returns {boolean} Returns `true` if `value` is found, else `false`.
	 * @example
	 *
	 * _.includes([1, 2, 3], 1);
	 * // => true
	 *
	 * _.includes([1, 2, 3], 1, 2);
	 * // => false
	 *
	 * _.includes({ 'a': 1, 'b': 2 }, 1);
	 * // => true
	 *
	 * _.includes('abcd', 'bc');
	 * // => true
	 */
	function includes(collection, value, fromIndex, guard) {
	  collection = isArrayLike(collection) ? collection : values(collection);
	  fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	  var length = collection.length;
	  if (fromIndex < 0) {
	    fromIndex = nativeMax(length + fromIndex, 0);
	  }
	  return isString(collection)
	    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	    : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	}
	
	module.exports = includes;


/***/ },
/* 2935 */
/***/ function(module, exports, __webpack_require__) {

	var baseKeys = __webpack_require__(725),
	    getTag = __webpack_require__(463),
	    isArguments = __webpack_require__(335),
	    isArray = __webpack_require__(65),
	    isArrayLike = __webpack_require__(209),
	    isBuffer = __webpack_require__(336),
	    isPrototype = __webpack_require__(333),
	    isTypedArray = __webpack_require__(470);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    setTag = '[object Set]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if `value` is an empty object, collection, map, or set.
	 *
	 * Objects are considered empty if they have no own enumerable string keyed
	 * properties.
	 *
	 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	 * jQuery-like collections are considered empty if they have a `length` of `0`.
	 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	 * @example
	 *
	 * _.isEmpty(null);
	 * // => true
	 *
	 * _.isEmpty(true);
	 * // => true
	 *
	 * _.isEmpty(1);
	 * // => true
	 *
	 * _.isEmpty([1, 2, 3]);
	 * // => false
	 *
	 * _.isEmpty({ 'a': 1 });
	 * // => false
	 */
	function isEmpty(value) {
	  if (value == null) {
	    return true;
	  }
	  if (isArrayLike(value) &&
	      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	    return !value.length;
	  }
	  var tag = getTag(value);
	  if (tag == mapTag || tag == setTag) {
	    return !value.size;
	  }
	  if (isPrototype(value)) {
	    return !baseKeys(value).length;
	  }
	  for (var key in value) {
	    if (hasOwnProperty.call(value, key)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = isEmpty;


/***/ },
/* 2936 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(160),
	    isArray = __webpack_require__(65),
	    isObjectLike = __webpack_require__(134);
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	}
	
	module.exports = isString;


/***/ },
/* 2937 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(254),
	    baseIteratee = __webpack_require__(456),
	    baseMap = __webpack_require__(2844),
	    isArray = __webpack_require__(65);
	
	/**
	 * Creates an array of values by running each element in `collection` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	 *
	 * The guarded methods are:
	 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * _.map([4, 8], square);
	 * // => [16, 64]
	 *
	 * _.map({ 'a': 4, 'b': 8 }, square);
	 * // => [16, 64] (iteration order is not guaranteed)
	 *
	 * var users = [
	 *   { 'user': 'barney' },
	 *   { 'user': 'fred' }
	 * ];
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.map(users, 'user');
	 * // => ['barney', 'fred']
	 */
	function map(collection, iteratee) {
	  var func = isArray(collection) ? arrayMap : baseMap;
	  return func(collection, baseIteratee(iteratee, 3));
	}
	
	module.exports = map;


/***/ },
/* 2938 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(450);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ },
/* 2939 */
/***/ function(module, exports) {

	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that negates the result of the predicate `func`. The
	 * `func` predicate is invoked with the `this` binding and arguments of the
	 * created function.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Function
	 * @param {Function} predicate The predicate to negate.
	 * @returns {Function} Returns the new negated function.
	 * @example
	 *
	 * function isEven(n) {
	 *   return n % 2 == 0;
	 * }
	 *
	 * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	 * // => [1, 3, 5]
	 */
	function negate(predicate) {
	  if (typeof predicate != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  return function() {
	    var args = arguments;
	    switch (args.length) {
	      case 0: return !predicate.call(this);
	      case 1: return !predicate.call(this, args[0]);
	      case 2: return !predicate.call(this, args[0], args[1]);
	      case 3: return !predicate.call(this, args[0], args[1], args[2]);
	    }
	    return !predicate.apply(this, args);
	  };
	}
	
	module.exports = negate;


/***/ },
/* 2940 */
/***/ function(module, exports) {

	/**
	 * This method returns `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.3.0
	 * @category Util
	 * @example
	 *
	 * _.times(2, _.noop);
	 * // => [undefined, undefined]
	 */
	function noop() {
	  // No operation performed.
	}
	
	module.exports = noop;


/***/ },
/* 2941 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(62);
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	module.exports = now;


/***/ },
/* 2942 */
/***/ function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(456),
	    negate = __webpack_require__(2939),
	    pickBy = __webpack_require__(2943);
	
	/**
	 * The opposite of `_.pickBy`; this method creates an object composed of
	 * the own and inherited enumerable string keyed properties of `object` that
	 * `predicate` doesn't return truthy for. The predicate is invoked with two
	 * arguments: (value, key).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {Function} [predicate=_.identity] The function invoked per property.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.omitBy(object, _.isNumber);
	 * // => { 'b': '2' }
	 */
	function omitBy(object, predicate) {
	  return pickBy(object, negate(baseIteratee(predicate)));
	}
	
	module.exports = omitBy;


/***/ },
/* 2943 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(254),
	    baseIteratee = __webpack_require__(456),
	    basePickBy = __webpack_require__(2847),
	    getAllKeysIn = __webpack_require__(460);
	
	/**
	 * Creates an object composed of the `object` properties `predicate` returns
	 * truthy for. The predicate is invoked with two arguments: (value, key).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {Function} [predicate=_.identity] The function invoked per property.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.pickBy(object, _.isNumber);
	 * // => { 'a': 1, 'c': 3 }
	 */
	function pickBy(object, predicate) {
	  if (object == null) {
	    return {};
	  }
	  var props = arrayMap(getAllKeysIn(object), function(prop) {
	    return [prop];
	  });
	  predicate = baseIteratee(predicate);
	  return basePickBy(object, props, function(value, path) {
	    return predicate(value, path[0]);
	  });
	}
	
	module.exports = pickBy;


/***/ },
/* 2944 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(2848),
	    basePropertyDeep = __webpack_require__(2849),
	    isKey = __webpack_require__(464),
	    toKey = __webpack_require__(208);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ },
/* 2945 */
/***/ function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ },
/* 2946 */
/***/ function(module, exports, __webpack_require__) {

	var toNumber = __webpack_require__(758);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	module.exports = toFinite;


/***/ },
/* 2947 */
/***/ function(module, exports, __webpack_require__) {

	var toString = __webpack_require__(759);
	
	/** Used to generate unique IDs. */
	var idCounter = 0;
	
	/**
	 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {string} [prefix=''] The value to prefix the ID with.
	 * @returns {string} Returns the unique ID.
	 * @example
	 *
	 * _.uniqueId('contact_');
	 * // => 'contact_104'
	 *
	 * _.uniqueId();
	 * // => '105'
	 */
	function uniqueId(prefix) {
	  var id = ++idCounter;
	  return toString(prefix) + id;
	}
	
	module.exports = uniqueId;


/***/ },
/* 2948 */
/***/ function(module, exports, __webpack_require__) {

	var LazyWrapper = __webpack_require__(448),
	    LodashWrapper = __webpack_require__(716),
	    baseLodash = __webpack_require__(457),
	    isArray = __webpack_require__(65),
	    isObjectLike = __webpack_require__(134),
	    wrapperClone = __webpack_require__(2928);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates a `lodash` object which wraps `value` to enable implicit method
	 * chain sequences. Methods that operate on and return arrays, collections,
	 * and functions can be chained together. Methods that retrieve a single value
	 * or may return a primitive value will automatically end the chain sequence
	 * and return the unwrapped value. Otherwise, the value must be unwrapped
	 * with `_#value`.
	 *
	 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	 * enabled using `_.chain`.
	 *
	 * The execution of chained methods is lazy, that is, it's deferred until
	 * `_#value` is implicitly or explicitly called.
	 *
	 * Lazy evaluation allows several methods to support shortcut fusion.
	 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	 * the creation of intermediate arrays and can greatly reduce the number of
	 * iteratee executions. Sections of a chain sequence qualify for shortcut
	 * fusion if the section is applied to an array and iteratees accept only
	 * one argument. The heuristic for whether a section qualifies for shortcut
	 * fusion is subject to change.
	 *
	 * Chaining is supported in custom builds as long as the `_#value` method is
	 * directly or indirectly included in the build.
	 *
	 * In addition to lodash methods, wrappers have `Array` and `String` methods.
	 *
	 * The wrapper `Array` methods are:
	 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	 *
	 * The wrapper `String` methods are:
	 * `replace` and `split`
	 *
	 * The wrapper methods that support shortcut fusion are:
	 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	 *
	 * The chainable wrapper methods are:
	 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	 * `zipObject`, `zipObjectDeep`, and `zipWith`
	 *
	 * The wrapper methods that are **not** chainable by default are:
	 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	 * `upperFirst`, `value`, and `words`
	 *
	 * @name _
	 * @constructor
	 * @category Seq
	 * @param {*} value The value to wrap in a `lodash` instance.
	 * @returns {Object} Returns the new `lodash` wrapper instance.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * var wrapped = _([1, 2, 3]);
	 *
	 * // Returns an unwrapped value.
	 * wrapped.reduce(_.add);
	 * // => 6
	 *
	 * // Returns a wrapped value.
	 * var squares = wrapped.map(square);
	 *
	 * _.isArray(squares);
	 * // => false
	 *
	 * _.isArray(squares.value());
	 * // => true
	 */
	function lodash(value) {
	  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	    if (value instanceof LodashWrapper) {
	      return value;
	    }
	    if (hasOwnProperty.call(value, '__wrapped__')) {
	      return wrapperClone(value);
	    }
	  }
	  return new LodashWrapper(value);
	}
	
	// Ensure wrappers are instances of `baseLodash`.
	lodash.prototype = baseLodash.prototype;
	lodash.prototype.constructor = lodash;
	
	module.exports = lodash;


/***/ },
/* 2949 */
/***/ function(module, exports, __webpack_require__) {

	var lowerCase = __webpack_require__(257)
	
	/**
	 * Lower case the first character of a string.
	 *
	 * @param  {String} str
	 * @return {String}
	 */
	module.exports = function (str, locale) {
	  if (str == null) {
	    return ''
	  }
	
	  str = String(str)
	
	  return lowerCase(str.charAt(0), locale) + str.substr(1)
	}


/***/ },
/* 2950 */,
/* 2951 */
/***/ function(module, exports) {

	'use strict';
	
	var toStr = Object.prototype.toString;
	
	module.exports = function isArguments(value) {
		var str = toStr.call(value);
		var isArgs = str === '[object Arguments]';
		if (!isArgs) {
			isArgs = str !== '[object Array]' &&
				value !== null &&
				typeof value === 'object' &&
				typeof value.length === 'number' &&
				value.length >= 0 &&
				toStr.call(value.callee) === '[object Function]';
		}
		return isArgs;
	};


/***/ },
/* 2952 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var getPolyfill = __webpack_require__(847);
	var define = __webpack_require__(251);
	
	module.exports = function shimValues() {
		var polyfill = getPolyfill();
		define(Object, { values: polyfill }, {
			values: function testValues() {
				return Object.values !== polyfill;
			}
		});
		return polyfill;
	};


/***/ },
/* 2953 */
/***/ function(module, exports, __webpack_require__) {

	var sentenceCase = __webpack_require__(171)
	
	/**
	 * Param case a string.
	 *
	 * @param  {String} string
	 * @param  {String} [locale]
	 * @return {String}
	 */
	module.exports = function (string, locale) {
	  return sentenceCase(string, locale, '-')
	}


/***/ },
/* 2954 */
/***/ function(module, exports, __webpack_require__) {

	var camelCase = __webpack_require__(650)
	var upperCaseFirst = __webpack_require__(967)
	
	/**
	 * Pascal case a string.
	 *
	 * @param  {String} string
	 * @param  {String} [locale]
	 * @return {String}
	 */
	module.exports = function (string, locale) {
	  return upperCaseFirst(camelCase(string, locale), locale)
	}


/***/ },
/* 2955 */
/***/ function(module, exports, __webpack_require__) {

	var sentenceCase = __webpack_require__(171)
	
	/**
	 * Path case a string.
	 *
	 * @param  {String} string
	 * @param  {String} [locale]
	 * @return {String}
	 */
	module.exports = function (string, locale) {
	  return sentenceCase(string, locale, '/')
	}


/***/ },
/* 2956 */,
/* 2957 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(2958);
	
	function emptyFunction() {}
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 2958 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 2959 */,
/* 2960 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	// If obj.hasOwnProperty has been overridden, then calling
	// obj.hasOwnProperty(prop) will break.
	// See: https://github.com/joyent/node/issues/1707
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	module.exports = function(qs, sep, eq, options) {
	  sep = sep || '&';
	  eq = eq || '=';
	  var obj = {};
	
	  if (typeof qs !== 'string' || qs.length === 0) {
	    return obj;
	  }
	
	  var regexp = /\+/g;
	  qs = qs.split(sep);
	
	  var maxKeys = 1000;
	  if (options && typeof options.maxKeys === 'number') {
	    maxKeys = options.maxKeys;
	  }
	
	  var len = qs.length;
	  // maxKeys <= 0 means that we should not limit keys count
	  if (maxKeys > 0 && len > maxKeys) {
	    len = maxKeys;
	  }
	
	  for (var i = 0; i < len; ++i) {
	    var x = qs[i].replace(regexp, '%20'),
	        idx = x.indexOf(eq),
	        kstr, vstr, k, v;
	
	    if (idx >= 0) {
	      kstr = x.substr(0, idx);
	      vstr = x.substr(idx + 1);
	    } else {
	      kstr = x;
	      vstr = '';
	    }
	
	    k = decodeURIComponent(kstr);
	    v = decodeURIComponent(vstr);
	
	    if (!hasOwnProperty(obj, k)) {
	      obj[k] = v;
	    } else if (Array.isArray(obj[k])) {
	      obj[k].push(v);
	    } else {
	      obj[k] = [obj[k], v];
	    }
	  }
	
	  return obj;
	};


/***/ },
/* 2961 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	var stringifyPrimitive = function(v) {
	  switch (typeof v) {
	    case 'string':
	      return v;
	
	    case 'boolean':
	      return v ? 'true' : 'false';
	
	    case 'number':
	      return isFinite(v) ? v : '';
	
	    default:
	      return '';
	  }
	};
	
	module.exports = function(obj, sep, eq, name) {
	  sep = sep || '&';
	  eq = eq || '=';
	  if (obj === null) {
	    obj = undefined;
	  }
	
	  if (typeof obj === 'object') {
	    return Object.keys(obj).map(function(k) {
	      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
	      if (Array.isArray(obj[k])) {
	        return obj[k].map(function(v) {
	          return ks + encodeURIComponent(stringifyPrimitive(v));
	        }).join(sep);
	      } else {
	        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
	      }
	    }).join(sep);
	
	  }
	
	  if (!name) return '';
	  return encodeURIComponent(stringifyPrimitive(name)) + eq +
	         encodeURIComponent(stringifyPrimitive(obj));
	};


/***/ },
/* 2962 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.decode = exports.parse = __webpack_require__(2960);
	exports.encode = exports.stringify = __webpack_require__(2961);


/***/ },
/* 2963 */
/***/ function(module, exports) {

	'use strict';
	
	var has = Object.prototype.hasOwnProperty;
	
	/**
	 * Simple query string parser.
	 *
	 * @param {String} query The query string that needs to be parsed.
	 * @returns {Object}
	 * @api public
	 */
	function querystring(query) {
	  var parser = /([^=?&]+)=?([^&]*)/g
	    , result = {}
	    , part;
	
	  //
	  // Little nifty parsing hack, leverage the fact that RegExp.exec increments
	  // the lastIndex property so we can continue executing this loop until we've
	  // parsed all results.
	  //
	  for (;
	    part = parser.exec(query);
	    result[decodeURIComponent(part[1])] = decodeURIComponent(part[2])
	  );
	
	  return result;
	}
	
	/**
	 * Transform a query string to an object.
	 *
	 * @param {Object} obj Object that should be transformed.
	 * @param {String} prefix Optional prefix.
	 * @returns {String}
	 * @api public
	 */
	function querystringify(obj, prefix) {
	  prefix = prefix || '';
	
	  var pairs = [];
	
	  //
	  // Optionally prefix with a '?' if needed
	  //
	  if ('string' !== typeof prefix) prefix = '?';
	
	  for (var key in obj) {
	    if (has.call(obj, key)) {
	      pairs.push(encodeURIComponent(key) +'='+ encodeURIComponent(obj[key]));
	    }
	  }
	
	  return pairs.length ? prefix + pairs.join('&') : '';
	}
	
	//
	// Expose the module.
	//
	exports.stringify = querystringify;
	exports.parse = querystring;


/***/ },
/* 2964 */,
/* 2965 */,
/* 2966 */
/***/ function(module, exports, __webpack_require__) {

	// eslint-disable-next-line import/no-unresolved
	module.exports = __webpack_require__(2977);


/***/ },
/* 2967 */
/***/ function(module, exports, __webpack_require__) {

	// eslint-disable-next-line import/no-unresolved
	__webpack_require__(2978);


/***/ },
/* 2968 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = CalendarWeek;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _airbnbPropTypes = __webpack_require__(42);
	
	var _CalendarDay = __webpack_require__(471);
	
	var _CalendarDay2 = _interopRequireDefault(_CalendarDay);
	
	var _CustomizableCalendarDay = __webpack_require__(2971);
	
	var _CustomizableCalendarDay2 = _interopRequireDefault(_CustomizableCalendarDay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)({
	  children: (0, _airbnbPropTypes.or)([(0, _airbnbPropTypes.childrenOfType)(_CalendarDay2['default']), (0, _airbnbPropTypes.childrenOfType)(_CustomizableCalendarDay2['default'])]).isRequired
	});
	
	function CalendarWeek(_ref) {
	  var children = _ref.children;
	
	  return _react2['default'].createElement(
	    'tr',
	    null,
	    children
	  );
	}
	
	CalendarWeek.propTypes = propTypes;

/***/ },
/* 2969 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ChevronDown = function () {
	  function ChevronDown(props) {
	    return _react2['default'].createElement(
	      'svg',
	      props,
	      _react2['default'].createElement('path', {
	        d: 'M967.5 288.5L514.3 740.7c-11 11-21 11-32 0L29.1 288.5c-4-5-6-11-6-16 0-13 10-23 23-23 6 0 11 2 15 7l437.2 436.2 437.2-436.2c4-5 9-7 16-7 6 0 11 2 16 7 9 10.9 9 21 0 32z'
	      })
	    );
	  }
	
	  return ChevronDown;
	}();
	
	ChevronDown.defaultProps = {
	  viewBox: '0 0 1000 1000'
	};
	exports['default'] = ChevronDown;

/***/ },
/* 2970 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ChevronUp = function () {
	  function ChevronUp(props) {
	    return _react2['default'].createElement(
	      'svg',
	      props,
	      _react2['default'].createElement('path', {
	        d: 'M32.1 712.6l453.2-452.2c11-11 21-11 32 0l453.2 452.2c4 5 6 10 6 16 0 13-10 23-22 23-7 0-12-2-16-7L501.3 308.5 64.1 744.7c-4 5-9 7-15 7-7 0-12-2-17-7-9-11-9-21 0-32.1z'
	      })
	    );
	  }
	
	  return ChevronUp;
	}();
	
	ChevronUp.defaultProps = {
	  viewBox: '0 0 1000 1000'
	};
	exports['default'] = ChevronUp;

/***/ },
/* 2971 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PureCustomizableCalendarDay = exports.selectedStyles = exports.lastInRangeStyles = exports.selectedSpanStyles = exports.hoveredSpanStyles = exports.blockedOutOfRangeStyles = exports.blockedCalendarStyles = exports.blockedMinNightsStyles = exports.highlightedCalendarStyles = exports.outsideStyles = exports.defaultStyles = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _object = __webpack_require__(55);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(27);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactAddonsShallowCompare = __webpack_require__(210);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _reactMomentProptypes = __webpack_require__(112);
	
	var _reactMomentProptypes2 = _interopRequireDefault(_reactMomentProptypes);
	
	var _airbnbPropTypes = __webpack_require__(42);
	
	var _reactWithStyles = __webpack_require__(72);
	
	var _moment = __webpack_require__(9);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _defaultPhrases = __webpack_require__(50);
	
	var _getPhrasePropTypes = __webpack_require__(63);
	
	var _getPhrasePropTypes2 = _interopRequireDefault(_getPhrasePropTypes);
	
	var _getCalendarDaySettings = __webpack_require__(867);
	
	var _getCalendarDaySettings2 = _interopRequireDefault(_getCalendarDaySettings);
	
	var _constants = __webpack_require__(30);
	
	var _DefaultTheme = __webpack_require__(864);
	
	var _DefaultTheme2 = _interopRequireDefault(_DefaultTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var color = _DefaultTheme2['default'].reactDates.color;
	
	
	function getStyles(stylesObj, isHovered) {
	  if (!stylesObj) return null;
	
	  var hover = stylesObj.hover;
	
	  if (isHovered && hover) {
	    return hover;
	  }
	
	  return stylesObj;
	}
	
	var DayStyleShape = _propTypes2['default'].shape({
	  background: _propTypes2['default'].string,
	  border: (0, _airbnbPropTypes.or)([_propTypes2['default'].string, _propTypes2['default'].number]),
	  color: _propTypes2['default'].string,
	
	  hover: _propTypes2['default'].shape({
	    background: _propTypes2['default'].string,
	    border: (0, _airbnbPropTypes.or)([_propTypes2['default'].string, _propTypes2['default'].number]),
	    color: _propTypes2['default'].string
	  })
	});
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)((0, _object2['default'])({}, _reactWithStyles.withStylesPropTypes, {
	  day: _reactMomentProptypes2['default'].momentObj,
	  daySize: _airbnbPropTypes.nonNegativeInteger,
	  isOutsideDay: _propTypes2['default'].bool,
	  modifiers: _propTypes2['default'].instanceOf(Set),
	  isFocused: _propTypes2['default'].bool,
	  tabIndex: _propTypes2['default'].oneOf([0, -1]),
	  onDayClick: _propTypes2['default'].func,
	  onDayMouseEnter: _propTypes2['default'].func,
	  onDayMouseLeave: _propTypes2['default'].func,
	  renderDayContents: _propTypes2['default'].func,
	  ariaLabelFormat: _propTypes2['default'].string,
	
	  // style overrides
	  defaultStyles: DayStyleShape,
	  outsideStyles: DayStyleShape,
	  todayStyles: DayStyleShape,
	  firstDayOfWeekStyles: DayStyleShape,
	  lastDayOfWeekStyles: DayStyleShape,
	  highlightedCalendarStyles: DayStyleShape,
	  blockedMinNightsStyles: DayStyleShape,
	  blockedCalendarStyles: DayStyleShape,
	  blockedOutOfRangeStyles: DayStyleShape,
	  hoveredSpanStyles: DayStyleShape,
	  selectedSpanStyles: DayStyleShape,
	  lastInRangeStyles: DayStyleShape,
	  selectedStyles: DayStyleShape,
	  selectedStartStyles: DayStyleShape,
	  selectedEndStyles: DayStyleShape,
	  afterHoveredStartStyles: DayStyleShape,
	
	  // internationalization
	  phrases: _propTypes2['default'].shape((0, _getPhrasePropTypes2['default'])(_defaultPhrases.CalendarDayPhrases))
	}));
	
	var defaultStyles = exports.defaultStyles = {
	  border: '1px solid ' + String(color.core.borderLight),
	  color: color.text,
	  background: color.background,
	
	  hover: {
	    background: color.core.borderLight,
	    border: '1px double ' + String(color.core.borderLight),
	    color: 'inherit'
	  }
	};
	
	var outsideStyles = exports.outsideStyles = {
	  background: color.outside.backgroundColor,
	  border: 0,
	  color: color.outside.color
	};
	
	var highlightedCalendarStyles = exports.highlightedCalendarStyles = {
	  background: color.highlighted.backgroundColor,
	  color: color.highlighted.color,
	
	  hover: {
	    background: color.highlighted.backgroundColor_hover,
	    color: color.highlighted.color_active
	  }
	};
	
	var blockedMinNightsStyles = exports.blockedMinNightsStyles = {
	  background: color.minimumNights.backgroundColor,
	  border: '1px solid ' + String(color.minimumNights.borderColor),
	  color: color.minimumNights.color,
	
	  hover: {
	    background: color.minimumNights.backgroundColor_hover,
	    color: color.minimumNights.color_active
	  }
	};
	
	var blockedCalendarStyles = exports.blockedCalendarStyles = {
	  background: color.blocked_calendar.backgroundColor,
	  border: '1px solid ' + String(color.blocked_calendar.borderColor),
	  color: color.blocked_calendar.color,
	
	  hover: {
	    background: color.blocked_calendar.backgroundColor_hover,
	    border: '1px solid ' + String(color.blocked_calendar.borderColor),
	    color: color.blocked_calendar.color_active
	  }
	};
	
	var blockedOutOfRangeStyles = exports.blockedOutOfRangeStyles = {
	  background: color.blocked_out_of_range.backgroundColor,
	  border: '1px solid ' + String(color.blocked_out_of_range.borderColor),
	  color: color.blocked_out_of_range.color,
	
	  hover: {
	    background: color.blocked_out_of_range.backgroundColor_hover,
	    border: '1px solid ' + String(color.blocked_out_of_range.borderColor),
	    color: color.blocked_out_of_range.color_active
	  }
	};
	
	var hoveredSpanStyles = exports.hoveredSpanStyles = {
	  background: color.hoveredSpan.backgroundColor,
	  border: '1px solid ' + String(color.hoveredSpan.borderColor),
	  color: color.hoveredSpan.color,
	
	  hover: {
	    background: color.hoveredSpan.backgroundColor_hover,
	    border: '1px solid ' + String(color.hoveredSpan.borderColor),
	    color: color.hoveredSpan.color_active
	  }
	};
	
	var selectedSpanStyles = exports.selectedSpanStyles = {
	  background: color.selectedSpan.backgroundColor,
	  border: '1px solid ' + String(color.selectedSpan.borderColor),
	  color: color.selectedSpan.color,
	
	  hover: {
	    background: color.selectedSpan.backgroundColor_hover,
	    border: '1px solid ' + String(color.selectedSpan.borderColor),
	    color: color.selectedSpan.color_active
	  }
	};
	
	var lastInRangeStyles = exports.lastInRangeStyles = {
	  borderRight: color.core.primary
	};
	
	var selectedStyles = exports.selectedStyles = {
	  background: color.selected.backgroundColor,
	  border: '1px solid ' + String(color.selected.borderColor),
	  color: color.selected.color,
	
	  hover: {
	    background: color.selected.backgroundColor_hover,
	    border: '1px solid ' + String(color.selected.borderColor),
	    color: color.selected.color_active
	  }
	};
	
	var defaultProps = {
	  day: (0, _moment2['default'])(),
	  daySize: _constants.DAY_SIZE,
	  isOutsideDay: false,
	  modifiers: new Set(),
	  isFocused: false,
	  tabIndex: -1,
	  onDayClick: function () {
	    function onDayClick() {}
	
	    return onDayClick;
	  }(),
	  onDayMouseEnter: function () {
	    function onDayMouseEnter() {}
	
	    return onDayMouseEnter;
	  }(),
	  onDayMouseLeave: function () {
	    function onDayMouseLeave() {}
	
	    return onDayMouseLeave;
	  }(),
	
	  renderDayContents: null,
	  ariaLabelFormat: 'dddd, LL',
	
	  // style defaults
	  defaultStyles: defaultStyles,
	  outsideStyles: outsideStyles,
	  todayStyles: {},
	  highlightedCalendarStyles: highlightedCalendarStyles,
	  blockedMinNightsStyles: blockedMinNightsStyles,
	  blockedCalendarStyles: blockedCalendarStyles,
	  blockedOutOfRangeStyles: blockedOutOfRangeStyles,
	  hoveredSpanStyles: hoveredSpanStyles,
	  selectedSpanStyles: selectedSpanStyles,
	  lastInRangeStyles: lastInRangeStyles,
	  selectedStyles: selectedStyles,
	  selectedStartStyles: {},
	  selectedEndStyles: {},
	  afterHoveredStartStyles: {},
	  firstDayOfWeekStyles: {},
	  lastDayOfWeekStyles: {},
	
	  // internationalization
	  phrases: _defaultPhrases.CalendarDayPhrases
	};
	
	var CustomizableCalendarDay = function (_React$Component) {
	  _inherits(CustomizableCalendarDay, _React$Component);
	
	  function CustomizableCalendarDay() {
	    var _ref;
	
	    _classCallCheck(this, CustomizableCalendarDay);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = _possibleConstructorReturn(this, (_ref = CustomizableCalendarDay.__proto__ || Object.getPrototypeOf(CustomizableCalendarDay)).call.apply(_ref, [this].concat(args)));
	
	    _this.state = {
	      isHovered: false
	    };
	
	    _this.setButtonRef = _this.setButtonRef.bind(_this);
	    return _this;
	  }
	
	  _createClass(CustomizableCalendarDay, [{
	    key: 'shouldComponentUpdate',
	    value: function () {
	      function shouldComponentUpdate(nextProps, nextState) {
	        return (0, _reactAddonsShallowCompare2['default'])(this, nextProps, nextState);
	      }
	
	      return shouldComponentUpdate;
	    }()
	  }, {
	    key: 'componentDidUpdate',
	    value: function () {
	      function componentDidUpdate(prevProps) {
	        var _props = this.props,
	            isFocused = _props.isFocused,
	            tabIndex = _props.tabIndex;
	
	        if (tabIndex === 0) {
	          if (isFocused || tabIndex !== prevProps.tabIndex) {
	            this.buttonRef.focus();
	          }
	        }
	      }
	
	      return componentDidUpdate;
	    }()
	  }, {
	    key: 'onDayClick',
	    value: function () {
	      function onDayClick(day, e) {
	        var onDayClick = this.props.onDayClick;
	
	        onDayClick(day, e);
	      }
	
	      return onDayClick;
	    }()
	  }, {
	    key: 'onDayMouseEnter',
	    value: function () {
	      function onDayMouseEnter(day, e) {
	        var onDayMouseEnter = this.props.onDayMouseEnter;
	
	        this.setState({ isHovered: true });
	        onDayMouseEnter(day, e);
	      }
	
	      return onDayMouseEnter;
	    }()
	  }, {
	    key: 'onDayMouseLeave',
	    value: function () {
	      function onDayMouseLeave(day, e) {
	        var onDayMouseLeave = this.props.onDayMouseLeave;
	
	        this.setState({ isHovered: false });
	        onDayMouseLeave(day, e);
	      }
	
	      return onDayMouseLeave;
	    }()
	  }, {
	    key: 'onKeyDown',
	    value: function () {
	      function onKeyDown(day, e) {
	        var onDayClick = this.props.onDayClick;
	        var key = e.key;
	
	        if (key === 'Enter' || key === ' ') {
	          onDayClick(day, e);
	        }
	      }
	
	      return onKeyDown;
	    }()
	  }, {
	    key: 'setButtonRef',
	    value: function () {
	      function setButtonRef(ref) {
	        this.buttonRef = ref;
	      }
	
	      return setButtonRef;
	    }()
	  }, {
	    key: 'render',
	    value: function () {
	      function render() {
	        var _this2 = this;
	
	        var _props2 = this.props,
	            day = _props2.day,
	            ariaLabelFormat = _props2.ariaLabelFormat,
	            daySize = _props2.daySize,
	            isOutsideDay = _props2.isOutsideDay,
	            modifiers = _props2.modifiers,
	            tabIndex = _props2.tabIndex,
	            renderDayContents = _props2.renderDayContents,
	            styles = _props2.styles,
	            phrases = _props2.phrases,
	            defaultStylesWithHover = _props2.defaultStyles,
	            outsideStylesWithHover = _props2.outsideStyles,
	            todayStylesWithHover = _props2.todayStyles,
	            firstDayOfWeekStylesWithHover = _props2.firstDayOfWeekStyles,
	            lastDayOfWeekStylesWithHover = _props2.lastDayOfWeekStyles,
	            highlightedCalendarStylesWithHover = _props2.highlightedCalendarStyles,
	            blockedMinNightsStylesWithHover = _props2.blockedMinNightsStyles,
	            blockedCalendarStylesWithHover = _props2.blockedCalendarStyles,
	            blockedOutOfRangeStylesWithHover = _props2.blockedOutOfRangeStyles,
	            hoveredSpanStylesWithHover = _props2.hoveredSpanStyles,
	            selectedSpanStylesWithHover = _props2.selectedSpanStyles,
	            lastInRangeStylesWithHover = _props2.lastInRangeStyles,
	            selectedStylesWithHover = _props2.selectedStyles,
	            selectedStartStylesWithHover = _props2.selectedStartStyles,
	            selectedEndStylesWithHover = _props2.selectedEndStyles,
	            afterHoveredStartStylesWithHover = _props2.afterHoveredStartStyles;
	        var isHovered = this.state.isHovered;
	
	
	        if (!day) return _react2['default'].createElement('td', null);
	
	        var _getCalendarDaySettin = (0, _getCalendarDaySettings2['default'])(day, ariaLabelFormat, daySize, modifiers, phrases),
	            daySizeStyles = _getCalendarDaySettin.daySizeStyles,
	            useDefaultCursor = _getCalendarDaySettin.useDefaultCursor,
	            selected = _getCalendarDaySettin.selected,
	            hoveredSpan = _getCalendarDaySettin.hoveredSpan,
	            isOutsideRange = _getCalendarDaySettin.isOutsideRange,
	            ariaLabel = _getCalendarDaySettin.ariaLabel;
	
	        return _react2['default'].createElement(
	          'td',
	          _extends({}, (0, _reactWithStyles.css)(styles.CalendarDay, useDefaultCursor && styles.CalendarDay__defaultCursor, daySizeStyles, getStyles(defaultStylesWithHover, isHovered), isOutsideDay && getStyles(outsideStylesWithHover, isHovered), modifiers.has('today') && getStyles(todayStylesWithHover, isHovered), modifiers.has('first-day-of-week') && getStyles(firstDayOfWeekStylesWithHover, isHovered), modifiers.has('last-day-of-week') && getStyles(lastDayOfWeekStylesWithHover, isHovered), modifiers.has('highlighted-calendar') && getStyles(highlightedCalendarStylesWithHover, isHovered), modifiers.has('blocked-minimum-nights') && getStyles(blockedMinNightsStylesWithHover, isHovered), modifiers.has('blocked-calendar') && getStyles(blockedCalendarStylesWithHover, isHovered), hoveredSpan && getStyles(hoveredSpanStylesWithHover, isHovered), modifiers.has('after-hovered-start') && getStyles(afterHoveredStartStylesWithHover, isHovered), modifiers.has('selected-span') && getStyles(selectedSpanStylesWithHover, isHovered), modifiers.has('last-in-range') && getStyles(lastInRangeStylesWithHover, isHovered), selected && getStyles(selectedStylesWithHover, isHovered), modifiers.has('selected-start') && getStyles(selectedStartStylesWithHover, isHovered), modifiers.has('selected-end') && getStyles(selectedEndStylesWithHover, isHovered), isOutsideRange && getStyles(blockedOutOfRangeStylesWithHover, isHovered)), {
	            role: 'button' // eslint-disable-line jsx-a11y/no-noninteractive-element-to-interactive-role
	            , ref: this.setButtonRef,
	            'aria-label': ariaLabel,
	            onMouseEnter: function () {
	              function onMouseEnter(e) {
	                _this2.onDayMouseEnter(day, e);
	              }
	
	              return onMouseEnter;
	            }(),
	            onMouseLeave: function () {
	              function onMouseLeave(e) {
	                _this2.onDayMouseLeave(day, e);
	              }
	
	              return onMouseLeave;
	            }(),
	            onMouseUp: function () {
	              function onMouseUp(e) {
	                e.currentTarget.blur();
	              }
	
	              return onMouseUp;
	            }(),
	            onClick: function () {
	              function onClick(e) {
	                _this2.onDayClick(day, e);
	              }
	
	              return onClick;
	            }(),
	            onKeyDown: function () {
	              function onKeyDown(e) {
	                _this2.onKeyDown(day, e);
	              }
	
	              return onKeyDown;
	            }(),
	            tabIndex: tabIndex
	          }),
	          renderDayContents ? renderDayContents(day, modifiers) : day.format('D')
	        );
	      }
	
	      return render;
	    }()
	  }]);
	
	  return CustomizableCalendarDay;
	}(_react2['default'].Component);
	
	CustomizableCalendarDay.propTypes = propTypes;
	CustomizableCalendarDay.defaultProps = defaultProps;
	
	exports.PureCustomizableCalendarDay = CustomizableCalendarDay;
	exports['default'] = (0, _reactWithStyles.withStyles)(function (_ref2) {
	  var font = _ref2.reactDates.font;
	  return {
	    CalendarDay: {
	      boxSizing: 'border-box',
	      cursor: 'pointer',
	      fontSize: font.size,
	      textAlign: 'center',
	
	      ':active': {
	        outline: 0
	      }
	    },
	
	    CalendarDay__defaultCursor: {
	      cursor: 'default'
	    }
	  };
	})(CustomizableCalendarDay);

/***/ },
/* 2972 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PureDateRangePicker = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _object = __webpack_require__(55);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsShallowCompare = __webpack_require__(210);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _moment = __webpack_require__(9);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactWithStyles = __webpack_require__(72);
	
	var _reactPortal = __webpack_require__(901);
	
	var _airbnbPropTypes = __webpack_require__(42);
	
	var _consolidatedEvents = __webpack_require__(301);
	
	var _isTouchDevice = __webpack_require__(205);
	
	var _isTouchDevice2 = _interopRequireDefault(_isTouchDevice);
	
	var _DateRangePickerShape = __webpack_require__(860);
	
	var _DateRangePickerShape2 = _interopRequireDefault(_DateRangePickerShape);
	
	var _defaultPhrases = __webpack_require__(50);
	
	var _getResponsiveContainerStyles = __webpack_require__(870);
	
	var _getResponsiveContainerStyles2 = _interopRequireDefault(_getResponsiveContainerStyles);
	
	var _getDetachedContainerStyles = __webpack_require__(869);
	
	var _getDetachedContainerStyles2 = _interopRequireDefault(_getDetachedContainerStyles);
	
	var _getInputHeight = __webpack_require__(473);
	
	var _getInputHeight2 = _interopRequireDefault(_getInputHeight);
	
	var _isInclusivelyAfterDay = __webpack_require__(213);
	
	var _isInclusivelyAfterDay2 = _interopRequireDefault(_isInclusivelyAfterDay);
	
	var _disableScroll2 = __webpack_require__(866);
	
	var _disableScroll3 = _interopRequireDefault(_disableScroll2);
	
	var _DateRangePickerInputController = __webpack_require__(853);
	
	var _DateRangePickerInputController2 = _interopRequireDefault(_DateRangePickerInputController);
	
	var _DayPickerRangeController = __webpack_require__(854);
	
	var _DayPickerRangeController2 = _interopRequireDefault(_DayPickerRangeController);
	
	var _OutsideClickHandler = __webpack_require__(338);
	
	var _OutsideClickHandler2 = _interopRequireDefault(_OutsideClickHandler);
	
	var _CloseButton = __webpack_require__(259);
	
	var _CloseButton2 = _interopRequireDefault(_CloseButton);
	
	var _constants = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)((0, _object2['default'])({}, _reactWithStyles.withStylesPropTypes, _DateRangePickerShape2['default']));
	
	var defaultProps = {
	  // required props for a functional interactive DateRangePicker
	  startDate: null,
	  endDate: null,
	  focusedInput: null,
	
	  // input related props
	  startDatePlaceholderText: 'Start Date',
	  endDatePlaceholderText: 'End Date',
	  disabled: false,
	  required: false,
	  readOnly: false,
	  screenReaderInputMessage: '',
	  showClearDates: false,
	  showDefaultInputIcon: false,
	  inputIconPosition: _constants.ICON_BEFORE_POSITION,
	  customInputIcon: null,
	  customArrowIcon: null,
	  customCloseIcon: null,
	  noBorder: false,
	  block: false,
	  small: false,
	  regular: false,
	  keepFocusOnInput: false,
	
	  // calendar presentation and interaction related props
	  renderMonth: null,
	  orientation: _constants.HORIZONTAL_ORIENTATION,
	  anchorDirection: _constants.ANCHOR_LEFT,
	  openDirection: _constants.OPEN_DOWN,
	  horizontalMargin: 0,
	  withPortal: false,
	  withFullScreenPortal: false,
	  appendToBody: false,
	  disableScroll: false,
	  initialVisibleMonth: null,
	  numberOfMonths: 2,
	  keepOpenOnDateSelect: false,
	  reopenPickerOnClearDates: false,
	  renderCalendarInfo: null,
	  calendarInfoPosition: _constants.INFO_POSITION_BOTTOM,
	  hideKeyboardShortcutsPanel: false,
	  daySize: _constants.DAY_SIZE,
	  isRTL: false,
	  firstDayOfWeek: null,
	  verticalHeight: null,
	  transitionDuration: undefined,
	  verticalSpacing: _constants.DEFAULT_VERTICAL_SPACING,
	
	  // navigation related props
	  navPrev: null,
	  navNext: null,
	
	  onPrevMonthClick: function () {
	    function onPrevMonthClick() {}
	
	    return onPrevMonthClick;
	  }(),
	  onNextMonthClick: function () {
	    function onNextMonthClick() {}
	
	    return onNextMonthClick;
	  }(),
	  onClose: function () {
	    function onClose() {}
	
	    return onClose;
	  }(),
	
	
	  // day presentation and interaction related props
	  renderCalendarDay: undefined,
	  renderDayContents: null,
	  minimumNights: 1,
	  enableOutsideDays: false,
	  isDayBlocked: function () {
	    function isDayBlocked() {
	      return false;
	    }
	
	    return isDayBlocked;
	  }(),
	  isOutsideRange: function () {
	    function isOutsideRange(day) {
	      return !(0, _isInclusivelyAfterDay2['default'])(day, (0, _moment2['default'])());
	    }
	
	    return isOutsideRange;
	  }(),
	  isDayHighlighted: function () {
	    function isDayHighlighted() {
	      return false;
	    }
	
	    return isDayHighlighted;
	  }(),
	
	  // internationalization
	  displayFormat: function () {
	    function displayFormat() {
	      return _moment2['default'].localeData().longDateFormat('L');
	    }
	
	    return displayFormat;
	  }(),
	  monthFormat: 'MMMM YYYY',
	  weekDayFormat: 'dd',
	  phrases: _defaultPhrases.DateRangePickerPhrases,
	  dayAriaLabelFormat: undefined
	};
	
	var DateRangePicker = function (_React$Component) {
	  _inherits(DateRangePicker, _React$Component);
	
	  function DateRangePicker(props) {
	    _classCallCheck(this, DateRangePicker);
	
	    var _this = _possibleConstructorReturn(this, (DateRangePicker.__proto__ || Object.getPrototypeOf(DateRangePicker)).call(this, props));
	
	    _this.state = {
	      dayPickerContainerStyles: {},
	      isDateRangePickerInputFocused: false,
	      isDayPickerFocused: false,
	      showKeyboardShortcuts: false
	    };
	
	    _this.isTouchDevice = false;
	
	    _this.onOutsideClick = _this.onOutsideClick.bind(_this);
	    _this.onDateRangePickerInputFocus = _this.onDateRangePickerInputFocus.bind(_this);
	    _this.onDayPickerFocus = _this.onDayPickerFocus.bind(_this);
	    _this.onDayPickerBlur = _this.onDayPickerBlur.bind(_this);
	    _this.showKeyboardShortcutsPanel = _this.showKeyboardShortcutsPanel.bind(_this);
	
	    _this.responsivizePickerPosition = _this.responsivizePickerPosition.bind(_this);
	    _this.disableScroll = _this.disableScroll.bind(_this);
	
	    _this.setDayPickerContainerRef = _this.setDayPickerContainerRef.bind(_this);
	    _this.setContainerRef = _this.setContainerRef.bind(_this);
	    return _this;
	  }
	
	  _createClass(DateRangePicker, [{
	    key: 'componentDidMount',
	    value: function () {
	      function componentDidMount() {
	        this.removeEventListener = (0, _consolidatedEvents.addEventListener)(window, 'resize', this.responsivizePickerPosition, { passive: true });
	        this.responsivizePickerPosition();
	        this.disableScroll();
	
	        if (this.props.focusedInput) {
	          this.setState({
	            isDateRangePickerInputFocused: true
	          });
	        }
	
	        this.isTouchDevice = (0, _isTouchDevice2['default'])();
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function () {
	      function shouldComponentUpdate(nextProps, nextState) {
	        return (0, _reactAddonsShallowCompare2['default'])(this, nextProps, nextState);
	      }
	
	      return shouldComponentUpdate;
	    }()
	  }, {
	    key: 'componentDidUpdate',
	    value: function () {
	      function componentDidUpdate(prevProps) {
	        if (!prevProps.focusedInput && this.props.focusedInput && this.isOpened()) {
	          // The date picker just changed from being closed to being open.
	          this.responsivizePickerPosition();
	          this.disableScroll();
	        } else if (prevProps.focusedInput && !this.props.focusedInput && !this.isOpened()) {
	          // The date picker just changed from being open to being closed.
	          if (this.enableScroll) this.enableScroll();
	        }
	      }
	
	      return componentDidUpdate;
	    }()
	  }, {
	    key: 'componentWillUnmount',
	    value: function () {
	      function componentWillUnmount() {
	        if (this.removeEventListener) this.removeEventListener();
	        if (this.enableScroll) this.enableScroll();
	      }
	
	      return componentWillUnmount;
	    }()
	  }, {
	    key: 'onOutsideClick',
	    value: function () {
	      function onOutsideClick(event) {
	        var _props = this.props,
	            onFocusChange = _props.onFocusChange,
	            onClose = _props.onClose,
	            startDate = _props.startDate,
	            endDate = _props.endDate;
	
	        if (!this.isOpened()) return;
	        if (this.props.appendToBody && this.dayPickerContainer.contains(event.target)) return;
	
	        this.setState({
	          isDateRangePickerInputFocused: false,
	          isDayPickerFocused: false,
	          showKeyboardShortcuts: false
	        });
	
	        onFocusChange(null);
	        onClose({ startDate: startDate, endDate: endDate });
	      }
	
	      return onOutsideClick;
	    }()
	  }, {
	    key: 'onDateRangePickerInputFocus',
	    value: function () {
	      function onDateRangePickerInputFocus(focusedInput) {
	        var _props2 = this.props,
	            onFocusChange = _props2.onFocusChange,
	            readOnly = _props2.readOnly,
	            withPortal = _props2.withPortal,
	            withFullScreenPortal = _props2.withFullScreenPortal,
	            keepFocusOnInput = _props2.keepFocusOnInput;
	
	
	        if (focusedInput) {
	          var withAnyPortal = withPortal || withFullScreenPortal;
	          var moveFocusToDayPicker = withAnyPortal || readOnly && !keepFocusOnInput || this.isTouchDevice && !keepFocusOnInput;
	
	          if (moveFocusToDayPicker) {
	            this.onDayPickerFocus();
	          } else {
	            this.onDayPickerBlur();
	          }
	        }
	
	        onFocusChange(focusedInput);
	      }
	
	      return onDateRangePickerInputFocus;
	    }()
	  }, {
	    key: 'onDayPickerFocus',
	    value: function () {
	      function onDayPickerFocus() {
	        var _props3 = this.props,
	            focusedInput = _props3.focusedInput,
	            onFocusChange = _props3.onFocusChange;
	
	        if (!focusedInput) onFocusChange(_constants.START_DATE);
	
	        this.setState({
	          isDateRangePickerInputFocused: false,
	          isDayPickerFocused: true,
	          showKeyboardShortcuts: false
	        });
	      }
	
	      return onDayPickerFocus;
	    }()
	  }, {
	    key: 'onDayPickerBlur',
	    value: function () {
	      function onDayPickerBlur() {
	        this.setState({
	          isDateRangePickerInputFocused: true,
	          isDayPickerFocused: false,
	          showKeyboardShortcuts: false
	        });
	      }
	
	      return onDayPickerBlur;
	    }()
	  }, {
	    key: 'setDayPickerContainerRef',
	    value: function () {
	      function setDayPickerContainerRef(ref) {
	        this.dayPickerContainer = ref;
	      }
	
	      return setDayPickerContainerRef;
	    }()
	  }, {
	    key: 'setContainerRef',
	    value: function () {
	      function setContainerRef(ref) {
	        this.container = ref;
	      }
	
	      return setContainerRef;
	    }()
	  }, {
	    key: 'isOpened',
	    value: function () {
	      function isOpened() {
	        var focusedInput = this.props.focusedInput;
	
	        return focusedInput === _constants.START_DATE || focusedInput === _constants.END_DATE;
	      }
	
	      return isOpened;
	    }()
	  }, {
	    key: 'disableScroll',
	    value: function () {
	      function disableScroll() {
	        if (!this.props.appendToBody && !this.props.disableScroll) return;
	        if (!this.isOpened()) return;
	
	        // Disable scroll for every ancestor of this DateRangePicker up to the
	        // document level. This ensures the input and the picker never move. Other
	        // sibling elements or the picker itself can scroll.
	        this.enableScroll = (0, _disableScroll3['default'])(this.container);
	      }
	
	      return disableScroll;
	    }()
	  }, {
	    key: 'responsivizePickerPosition',
	    value: function () {
	      function responsivizePickerPosition() {
	        // It's possible the portal props have been changed in response to window resizes
	        // So let's ensure we reset this back to the base state each time
	        this.setState({ dayPickerContainerStyles: {} });
	
	        if (!this.isOpened()) {
	          return;
	        }
	
	        var _props4 = this.props,
	            openDirection = _props4.openDirection,
	            anchorDirection = _props4.anchorDirection,
	            horizontalMargin = _props4.horizontalMargin,
	            withPortal = _props4.withPortal,
	            withFullScreenPortal = _props4.withFullScreenPortal,
	            appendToBody = _props4.appendToBody;
	        var dayPickerContainerStyles = this.state.dayPickerContainerStyles;
	
	
	        var isAnchoredLeft = anchorDirection === _constants.ANCHOR_LEFT;
	        if (!withPortal && !withFullScreenPortal) {
	          var containerRect = this.dayPickerContainer.getBoundingClientRect();
	          var currentOffset = dayPickerContainerStyles[anchorDirection] || 0;
	          var containerEdge = isAnchoredLeft ? containerRect[_constants.ANCHOR_RIGHT] : containerRect[_constants.ANCHOR_LEFT];
	
	          this.setState({
	            dayPickerContainerStyles: (0, _object2['default'])({}, (0, _getResponsiveContainerStyles2['default'])(anchorDirection, currentOffset, containerEdge, horizontalMargin), appendToBody && (0, _getDetachedContainerStyles2['default'])(openDirection, anchorDirection, this.container))
	          });
	        }
	      }
	
	      return responsivizePickerPosition;
	    }()
	  }, {
	    key: 'showKeyboardShortcutsPanel',
	    value: function () {
	      function showKeyboardShortcutsPanel() {
	        this.setState({
	          isDateRangePickerInputFocused: false,
	          isDayPickerFocused: true,
	          showKeyboardShortcuts: true
	        });
	      }
	
	      return showKeyboardShortcutsPanel;
	    }()
	  }, {
	    key: 'maybeRenderDayPickerWithPortal',
	    value: function () {
	      function maybeRenderDayPickerWithPortal() {
	        var _props5 = this.props,
	            withPortal = _props5.withPortal,
	            withFullScreenPortal = _props5.withFullScreenPortal,
	            appendToBody = _props5.appendToBody;
	
	
	        if (!this.isOpened()) {
	          return null;
	        }
	
	        if (withPortal || withFullScreenPortal || appendToBody) {
	          return _react2['default'].createElement(
	            _reactPortal.Portal,
	            null,
	            this.renderDayPicker()
	          );
	        }
	
	        return this.renderDayPicker();
	      }
	
	      return maybeRenderDayPickerWithPortal;
	    }()
	  }, {
	    key: 'renderDayPicker',
	    value: function () {
	      function renderDayPicker() {
	        var _props6 = this.props,
	            anchorDirection = _props6.anchorDirection,
	            openDirection = _props6.openDirection,
	            isDayBlocked = _props6.isDayBlocked,
	            isDayHighlighted = _props6.isDayHighlighted,
	            isOutsideRange = _props6.isOutsideRange,
	            numberOfMonths = _props6.numberOfMonths,
	            orientation = _props6.orientation,
	            monthFormat = _props6.monthFormat,
	            renderMonth = _props6.renderMonth,
	            navPrev = _props6.navPrev,
	            navNext = _props6.navNext,
	            onPrevMonthClick = _props6.onPrevMonthClick,
	            onNextMonthClick = _props6.onNextMonthClick,
	            onDatesChange = _props6.onDatesChange,
	            onFocusChange = _props6.onFocusChange,
	            withPortal = _props6.withPortal,
	            withFullScreenPortal = _props6.withFullScreenPortal,
	            daySize = _props6.daySize,
	            enableOutsideDays = _props6.enableOutsideDays,
	            focusedInput = _props6.focusedInput,
	            startDate = _props6.startDate,
	            endDate = _props6.endDate,
	            minimumNights = _props6.minimumNights,
	            keepOpenOnDateSelect = _props6.keepOpenOnDateSelect,
	            renderCalendarDay = _props6.renderCalendarDay,
	            renderDayContents = _props6.renderDayContents,
	            renderCalendarInfo = _props6.renderCalendarInfo,
	            calendarInfoPosition = _props6.calendarInfoPosition,
	            firstDayOfWeek = _props6.firstDayOfWeek,
	            initialVisibleMonth = _props6.initialVisibleMonth,
	            hideKeyboardShortcutsPanel = _props6.hideKeyboardShortcutsPanel,
	            customCloseIcon = _props6.customCloseIcon,
	            onClose = _props6.onClose,
	            phrases = _props6.phrases,
	            dayAriaLabelFormat = _props6.dayAriaLabelFormat,
	            isRTL = _props6.isRTL,
	            weekDayFormat = _props6.weekDayFormat,
	            styles = _props6.styles,
	            verticalHeight = _props6.verticalHeight,
	            transitionDuration = _props6.transitionDuration,
	            verticalSpacing = _props6.verticalSpacing,
	            small = _props6.small,
	            disabled = _props6.disabled,
	            reactDates = _props6.theme.reactDates;
	        var _state = this.state,
	            dayPickerContainerStyles = _state.dayPickerContainerStyles,
	            isDayPickerFocused = _state.isDayPickerFocused,
	            showKeyboardShortcuts = _state.showKeyboardShortcuts;
	
	
	        var onOutsideClick = !withFullScreenPortal && withPortal ? this.onOutsideClick : undefined;
	        var initialVisibleMonthThunk = initialVisibleMonth || function () {
	          return startDate || endDate || (0, _moment2['default'])();
	        };
	
	        var closeIcon = customCloseIcon || _react2['default'].createElement(_CloseButton2['default'], (0, _reactWithStyles.css)(styles.DateRangePicker_closeButton_svg));
	
	        var inputHeight = (0, _getInputHeight2['default'])(reactDates, small);
	
	        var withAnyPortal = withPortal || withFullScreenPortal;
	
	        return _react2['default'].createElement(
	          'div',
	          _extends({ // eslint-disable-line jsx-a11y/no-static-element-interactions
	            ref: this.setDayPickerContainerRef
	          }, (0, _reactWithStyles.css)(styles.DateRangePicker_picker, anchorDirection === _constants.ANCHOR_LEFT && styles.DateRangePicker_picker__directionLeft, anchorDirection === _constants.ANCHOR_RIGHT && styles.DateRangePicker_picker__directionRight, orientation === _constants.HORIZONTAL_ORIENTATION && styles.DateRangePicker_picker__horizontal, orientation === _constants.VERTICAL_ORIENTATION && styles.DateRangePicker_picker__vertical, !withAnyPortal && openDirection === _constants.OPEN_DOWN && {
	            top: inputHeight + verticalSpacing
	          }, !withAnyPortal && openDirection === _constants.OPEN_UP && {
	            bottom: inputHeight + verticalSpacing
	          }, withAnyPortal && styles.DateRangePicker_picker__portal, withFullScreenPortal && styles.DateRangePicker_picker__fullScreenPortal, isRTL && styles.DateRangePicker_picker__rtl, dayPickerContainerStyles), {
	            onClick: onOutsideClick
	          }),
	          _react2['default'].createElement(_DayPickerRangeController2['default'], {
	            orientation: orientation,
	            enableOutsideDays: enableOutsideDays,
	            numberOfMonths: numberOfMonths,
	            onPrevMonthClick: onPrevMonthClick,
	            onNextMonthClick: onNextMonthClick,
	            onDatesChange: onDatesChange,
	            onFocusChange: onFocusChange,
	            onClose: onClose,
	            focusedInput: focusedInput,
	            startDate: startDate,
	            endDate: endDate,
	            monthFormat: monthFormat,
	            renderMonth: renderMonth,
	            withPortal: withAnyPortal,
	            daySize: daySize,
	            initialVisibleMonth: initialVisibleMonthThunk,
	            hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
	            navPrev: navPrev,
	            navNext: navNext,
	            minimumNights: minimumNights,
	            isOutsideRange: isOutsideRange,
	            isDayHighlighted: isDayHighlighted,
	            isDayBlocked: isDayBlocked,
	            keepOpenOnDateSelect: keepOpenOnDateSelect,
	            renderCalendarDay: renderCalendarDay,
	            renderDayContents: renderDayContents,
	            renderCalendarInfo: renderCalendarInfo,
	            calendarInfoPosition: calendarInfoPosition,
	            isFocused: isDayPickerFocused,
	            showKeyboardShortcuts: showKeyboardShortcuts,
	            onBlur: this.onDayPickerBlur,
	            phrases: phrases,
	            dayAriaLabelFormat: dayAriaLabelFormat,
	            isRTL: isRTL,
	            firstDayOfWeek: firstDayOfWeek,
	            weekDayFormat: weekDayFormat,
	            verticalHeight: verticalHeight,
	            transitionDuration: transitionDuration,
	            disabled: disabled
	          }),
	          withFullScreenPortal && _react2['default'].createElement(
	            'button',
	            _extends({}, (0, _reactWithStyles.css)(styles.DateRangePicker_closeButton), {
	              type: 'button',
	              onClick: this.onOutsideClick,
	              'aria-label': phrases.closeDatePicker
	            }),
	            closeIcon
	          )
	        );
	      }
	
	      return renderDayPicker;
	    }()
	  }, {
	    key: 'render',
	    value: function () {
	      function render() {
	        var _props7 = this.props,
	            startDate = _props7.startDate,
	            startDateId = _props7.startDateId,
	            startDatePlaceholderText = _props7.startDatePlaceholderText,
	            endDate = _props7.endDate,
	            endDateId = _props7.endDateId,
	            endDatePlaceholderText = _props7.endDatePlaceholderText,
	            focusedInput = _props7.focusedInput,
	            screenReaderInputMessage = _props7.screenReaderInputMessage,
	            showClearDates = _props7.showClearDates,
	            showDefaultInputIcon = _props7.showDefaultInputIcon,
	            inputIconPosition = _props7.inputIconPosition,
	            customInputIcon = _props7.customInputIcon,
	            customArrowIcon = _props7.customArrowIcon,
	            customCloseIcon = _props7.customCloseIcon,
	            disabled = _props7.disabled,
	            required = _props7.required,
	            readOnly = _props7.readOnly,
	            openDirection = _props7.openDirection,
	            phrases = _props7.phrases,
	            isOutsideRange = _props7.isOutsideRange,
	            minimumNights = _props7.minimumNights,
	            withPortal = _props7.withPortal,
	            withFullScreenPortal = _props7.withFullScreenPortal,
	            displayFormat = _props7.displayFormat,
	            reopenPickerOnClearDates = _props7.reopenPickerOnClearDates,
	            keepOpenOnDateSelect = _props7.keepOpenOnDateSelect,
	            onDatesChange = _props7.onDatesChange,
	            onClose = _props7.onClose,
	            isRTL = _props7.isRTL,
	            noBorder = _props7.noBorder,
	            block = _props7.block,
	            verticalSpacing = _props7.verticalSpacing,
	            small = _props7.small,
	            regular = _props7.regular,
	            styles = _props7.styles;
	        var isDateRangePickerInputFocused = this.state.isDateRangePickerInputFocused;
	
	
	        var onOutsideClick = !withPortal && !withFullScreenPortal ? this.onOutsideClick : undefined;
	
	        var hideFang = verticalSpacing < _constants.FANG_HEIGHT_PX;
	
	        return _react2['default'].createElement(
	          'div',
	          _extends({
	            ref: this.setContainerRef
	          }, (0, _reactWithStyles.css)(styles.DateRangePicker, block && styles.DateRangePicker__block)),
	          _react2['default'].createElement(
	            _OutsideClickHandler2['default'],
	            { onOutsideClick: onOutsideClick },
	            _react2['default'].createElement(_DateRangePickerInputController2['default'], {
	              startDate: startDate,
	              startDateId: startDateId,
	              startDatePlaceholderText: startDatePlaceholderText,
	              isStartDateFocused: focusedInput === _constants.START_DATE,
	              endDate: endDate,
	              endDateId: endDateId,
	              endDatePlaceholderText: endDatePlaceholderText,
	              isEndDateFocused: focusedInput === _constants.END_DATE,
	              displayFormat: displayFormat,
	              showClearDates: showClearDates,
	              showCaret: !withPortal && !withFullScreenPortal && !hideFang,
	              showDefaultInputIcon: showDefaultInputIcon,
	              inputIconPosition: inputIconPosition,
	              customInputIcon: customInputIcon,
	              customArrowIcon: customArrowIcon,
	              customCloseIcon: customCloseIcon,
	              disabled: disabled,
	              required: required,
	              readOnly: readOnly,
	              openDirection: openDirection,
	              reopenPickerOnClearDates: reopenPickerOnClearDates,
	              keepOpenOnDateSelect: keepOpenOnDateSelect,
	              isOutsideRange: isOutsideRange,
	              minimumNights: minimumNights,
	              withFullScreenPortal: withFullScreenPortal,
	              onDatesChange: onDatesChange,
	              onFocusChange: this.onDateRangePickerInputFocus,
	              onKeyDownArrowDown: this.onDayPickerFocus,
	              onKeyDownQuestionMark: this.showKeyboardShortcutsPanel,
	              onClose: onClose,
	              phrases: phrases,
	              screenReaderMessage: screenReaderInputMessage,
	              isFocused: isDateRangePickerInputFocused,
	              isRTL: isRTL,
	              noBorder: noBorder,
	              block: block,
	              small: small,
	              regular: regular,
	              verticalSpacing: verticalSpacing
	            }),
	            this.maybeRenderDayPickerWithPortal()
	          )
	        );
	      }
	
	      return render;
	    }()
	  }]);
	
	  return DateRangePicker;
	}(_react2['default'].Component);
	
	DateRangePicker.propTypes = propTypes;
	DateRangePicker.defaultProps = defaultProps;
	
	exports.PureDateRangePicker = DateRangePicker;
	exports['default'] = (0, _reactWithStyles.withStyles)(function (_ref) {
	  var _ref$reactDates = _ref.reactDates,
	      color = _ref$reactDates.color,
	      zIndex = _ref$reactDates.zIndex;
	  return {
	    DateRangePicker: {
	      position: 'relative',
	      display: 'inline-block'
	    },
	
	    DateRangePicker__block: {
	      display: 'block'
	    },
	
	    DateRangePicker_picker: {
	      zIndex: zIndex + 1,
	      backgroundColor: color.background,
	      position: 'absolute'
	    },
	
	    DateRangePicker_picker__rtl: {
	      direction: 'rtl'
	    },
	
	    DateRangePicker_picker__directionLeft: {
	      left: 0
	    },
	
	    DateRangePicker_picker__directionRight: {
	      right: 0
	    },
	
	    DateRangePicker_picker__portal: {
	      backgroundColor: 'rgba(0, 0, 0, 0.3)',
	      position: 'fixed',
	      top: 0,
	      left: 0,
	      height: '100%',
	      width: '100%'
	    },
	
	    DateRangePicker_picker__fullScreenPortal: {
	      backgroundColor: color.background
	    },
	
	    DateRangePicker_closeButton: {
	      background: 'none',
	      border: 0,
	      color: 'inherit',
	      font: 'inherit',
	      lineHeight: 'normal',
	      overflow: 'visible',
	      cursor: 'pointer',
	
	      position: 'absolute',
	      top: 0,
	      right: 0,
	      padding: 15,
	      zIndex: zIndex + 2,
	
	      ':hover': {
	        color: 'darken(' + String(color.core.grayLighter) + ', 10%)',
	        textDecoration: 'none'
	      },
	
	      ':focus': {
	        color: 'darken(' + String(color.core.grayLighter) + ', 10%)',
	        textDecoration: 'none'
	      }
	    },
	
	    DateRangePicker_closeButton_svg: {
	      height: 15,
	      width: 15,
	      fill: color.core.grayLighter
	    }
	  };
	})(DateRangePicker);

/***/ },
/* 2973 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BOTTOM_RIGHT = exports.TOP_RIGHT = exports.TOP_LEFT = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _object = __webpack_require__(55);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(27);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _airbnbPropTypes = __webpack_require__(42);
	
	var _reactWithStyles = __webpack_require__(72);
	
	var _defaultPhrases = __webpack_require__(50);
	
	var _getPhrasePropTypes = __webpack_require__(63);
	
	var _getPhrasePropTypes2 = _interopRequireDefault(_getPhrasePropTypes);
	
	var _KeyboardShortcutRow = __webpack_require__(2975);
	
	var _KeyboardShortcutRow2 = _interopRequireDefault(_KeyboardShortcutRow);
	
	var _CloseButton = __webpack_require__(259);
	
	var _CloseButton2 = _interopRequireDefault(_CloseButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TOP_LEFT = exports.TOP_LEFT = 'top-left';
	var TOP_RIGHT = exports.TOP_RIGHT = 'top-right';
	var BOTTOM_RIGHT = exports.BOTTOM_RIGHT = 'bottom-right';
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)((0, _object2['default'])({}, _reactWithStyles.withStylesPropTypes, {
	  block: _propTypes2['default'].bool,
	  buttonLocation: _propTypes2['default'].oneOf([TOP_LEFT, TOP_RIGHT, BOTTOM_RIGHT]),
	  showKeyboardShortcutsPanel: _propTypes2['default'].bool,
	  openKeyboardShortcutsPanel: _propTypes2['default'].func,
	  closeKeyboardShortcutsPanel: _propTypes2['default'].func,
	  phrases: _propTypes2['default'].shape((0, _getPhrasePropTypes2['default'])(_defaultPhrases.DayPickerKeyboardShortcutsPhrases))
	}));
	
	var defaultProps = {
	  block: false,
	  buttonLocation: BOTTOM_RIGHT,
	  showKeyboardShortcutsPanel: false,
	  openKeyboardShortcutsPanel: function () {
	    function openKeyboardShortcutsPanel() {}
	
	    return openKeyboardShortcutsPanel;
	  }(),
	  closeKeyboardShortcutsPanel: function () {
	    function closeKeyboardShortcutsPanel() {}
	
	    return closeKeyboardShortcutsPanel;
	  }(),
	
	  phrases: _defaultPhrases.DayPickerKeyboardShortcutsPhrases
	};
	
	function getKeyboardShortcuts(phrases) {
	  return [{
	    unicode: '↵',
	    label: phrases.enterKey,
	    action: phrases.selectFocusedDate
	  }, {
	    unicode: '←/→',
	    label: phrases.leftArrowRightArrow,
	    action: phrases.moveFocusByOneDay
	  }, {
	    unicode: '↑/↓',
	    label: phrases.upArrowDownArrow,
	    action: phrases.moveFocusByOneWeek
	  }, {
	    unicode: 'PgUp/PgDn',
	    label: phrases.pageUpPageDown,
	    action: phrases.moveFocusByOneMonth
	  }, {
	    unicode: 'Home/End',
	    label: phrases.homeEnd,
	    action: phrases.moveFocustoStartAndEndOfWeek
	  }, {
	    unicode: 'Esc',
	    label: phrases.escape,
	    action: phrases.returnFocusToInput
	  }, {
	    unicode: '?',
	    label: phrases.questionMark,
	    action: phrases.openThisPanel
	  }];
	}
	
	var DayPickerKeyboardShortcuts = function (_React$Component) {
	  _inherits(DayPickerKeyboardShortcuts, _React$Component);
	
	  function DayPickerKeyboardShortcuts() {
	    var _ref;
	
	    _classCallCheck(this, DayPickerKeyboardShortcuts);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = _possibleConstructorReturn(this, (_ref = DayPickerKeyboardShortcuts.__proto__ || Object.getPrototypeOf(DayPickerKeyboardShortcuts)).call.apply(_ref, [this].concat(args)));
	
	    _this.keyboardShortcuts = getKeyboardShortcuts(_this.props.phrases);
	
	    _this.onShowKeyboardShortcutsButtonClick = _this.onShowKeyboardShortcutsButtonClick.bind(_this);
	    _this.setShowKeyboardShortcutsButtonRef = _this.setShowKeyboardShortcutsButtonRef.bind(_this);
	    _this.setHideKeyboardShortcutsButtonRef = _this.setHideKeyboardShortcutsButtonRef.bind(_this);
	    _this.handleFocus = _this.handleFocus.bind(_this);
	    _this.onKeyDown = _this.onKeyDown.bind(_this);
	    return _this;
	  }
	
	  _createClass(DayPickerKeyboardShortcuts, [{
	    key: 'componentWillReceiveProps',
	    value: function () {
	      function componentWillReceiveProps(nextProps) {
	        if (nextProps.phrases !== this.props.phrases) {
	          this.keyboardShortcuts = getKeyboardShortcuts(nextProps.phrases);
	        }
	      }
	
	      return componentWillReceiveProps;
	    }()
	  }, {
	    key: 'componentDidUpdate',
	    value: function () {
	      function componentDidUpdate() {
	        this.handleFocus();
	      }
	
	      return componentDidUpdate;
	    }()
	  }, {
	    key: 'onKeyDown',
	    value: function () {
	      function onKeyDown(e) {
	        e.stopPropagation();
	
	        var closeKeyboardShortcutsPanel = this.props.closeKeyboardShortcutsPanel;
	        // Because the close button is the only focusable element inside of the panel, this
	        // amounts to a very basic focus trap. The user can exit the panel by "pressing" the
	        // close button or hitting escape
	
	        switch (e.key) {
	          case 'Enter':
	          case ' ':
	          case 'Spacebar': // for older browsers
	          case 'Escape':
	            closeKeyboardShortcutsPanel();
	            break;
	
	          // do nothing - this allows the up and down arrows continue their
	          // default behavior of scrolling the content of the Keyboard Shortcuts Panel
	          // which is needed when only a single month is shown for instance.
	          case 'ArrowUp':
	          case 'ArrowDown':
	            break;
	
	          // completely block the rest of the keys that have functionality outside of this panel
	          case 'Tab':
	          case 'Home':
	          case 'End':
	          case 'PageUp':
	          case 'PageDown':
	          case 'ArrowLeft':
	          case 'ArrowRight':
	            e.preventDefault();
	            break;
	
	          default:
	            break;
	        }
	      }
	
	      return onKeyDown;
	    }()
	  }, {
	    key: 'onShowKeyboardShortcutsButtonClick',
	    value: function () {
	      function onShowKeyboardShortcutsButtonClick() {
	        var _this2 = this;
	
	        var openKeyboardShortcutsPanel = this.props.openKeyboardShortcutsPanel;
	
	        // we want to return focus to this button after closing the keyboard shortcuts panel
	
	        openKeyboardShortcutsPanel(function () {
	          _this2.showKeyboardShortcutsButton.focus();
	        });
	      }
	
	      return onShowKeyboardShortcutsButtonClick;
	    }()
	  }, {
	    key: 'setShowKeyboardShortcutsButtonRef',
	    value: function () {
	      function setShowKeyboardShortcutsButtonRef(ref) {
	        this.showKeyboardShortcutsButton = ref;
	      }
	
	      return setShowKeyboardShortcutsButtonRef;
	    }()
	  }, {
	    key: 'setHideKeyboardShortcutsButtonRef',
	    value: function () {
	      function setHideKeyboardShortcutsButtonRef(ref) {
	        this.hideKeyboardShortcutsButton = ref;
	      }
	
	      return setHideKeyboardShortcutsButtonRef;
	    }()
	  }, {
	    key: 'handleFocus',
	    value: function () {
	      function handleFocus() {
	        if (this.hideKeyboardShortcutsButton) {
	          // automatically move focus into the dialog by moving
	          // to the only interactive element, the hide button
	          this.hideKeyboardShortcutsButton.focus();
	        }
	      }
	
	      return handleFocus;
	    }()
	  }, {
	    key: 'render',
	    value: function () {
	      function render() {
	        var _this3 = this;
	
	        var _props = this.props,
	            block = _props.block,
	            buttonLocation = _props.buttonLocation,
	            showKeyboardShortcutsPanel = _props.showKeyboardShortcutsPanel,
	            closeKeyboardShortcutsPanel = _props.closeKeyboardShortcutsPanel,
	            styles = _props.styles,
	            phrases = _props.phrases;
	
	
	        var toggleButtonText = showKeyboardShortcutsPanel ? phrases.hideKeyboardShortcutsPanel : phrases.showKeyboardShortcutsPanel;
	
	        var bottomRight = buttonLocation === BOTTOM_RIGHT;
	        var topRight = buttonLocation === TOP_RIGHT;
	        var topLeft = buttonLocation === TOP_LEFT;
	
	        return _react2['default'].createElement(
	          'div',
	          null,
	          _react2['default'].createElement(
	            'button',
	            _extends({
	              ref: this.setShowKeyboardShortcutsButtonRef
	            }, (0, _reactWithStyles.css)(styles.DayPickerKeyboardShortcuts_buttonReset, styles.DayPickerKeyboardShortcuts_show, bottomRight && styles.DayPickerKeyboardShortcuts_show__bottomRight, topRight && styles.DayPickerKeyboardShortcuts_show__topRight, topLeft && styles.DayPickerKeyboardShortcuts_show__topLeft), {
	              type: 'button',
	              'aria-label': toggleButtonText,
	              onClick: this.onShowKeyboardShortcutsButtonClick,
	              onKeyDown: function () {
	                function onKeyDown(e) {
	                  if (e.key === 'Enter') {
	                    e.preventDefault();
	                  } else if (e.key === 'Space') {
	                    _this3.onShowKeyboardShortcutsButtonClick(e);
	                  }
	                }
	
	                return onKeyDown;
	              }(),
	              onMouseUp: function () {
	                function onMouseUp(e) {
	                  e.currentTarget.blur();
	                }
	
	                return onMouseUp;
	              }()
	            }),
	            _react2['default'].createElement(
	              'span',
	              (0, _reactWithStyles.css)(styles.DayPickerKeyboardShortcuts_showSpan, bottomRight && styles.DayPickerKeyboardShortcuts_showSpan__bottomRight, topRight && styles.DayPickerKeyboardShortcuts_showSpan__topRight, topLeft && styles.DayPickerKeyboardShortcuts_showSpan__topLeft),
	              '?'
	            )
	          ),
	          showKeyboardShortcutsPanel && _react2['default'].createElement(
	            'div',
	            _extends({}, (0, _reactWithStyles.css)(styles.DayPickerKeyboardShortcuts_panel), {
	              role: 'dialog',
	              'aria-labelledby': 'DayPickerKeyboardShortcuts_title',
	              'aria-describedby': 'DayPickerKeyboardShortcuts_description'
	            }),
	            _react2['default'].createElement(
	              'div',
	              _extends({}, (0, _reactWithStyles.css)(styles.DayPickerKeyboardShortcuts_title), {
	                id: 'DayPickerKeyboardShortcuts_title'
	              }),
	              phrases.keyboardShortcuts
	            ),
	            _react2['default'].createElement(
	              'button',
	              _extends({
	                ref: this.setHideKeyboardShortcutsButtonRef
	              }, (0, _reactWithStyles.css)(styles.DayPickerKeyboardShortcuts_buttonReset, styles.DayPickerKeyboardShortcuts_close), {
	                type: 'button',
	                tabIndex: '0',
	                'aria-label': phrases.hideKeyboardShortcutsPanel,
	                onClick: closeKeyboardShortcutsPanel,
	                onKeyDown: this.onKeyDown
	              }),
	              _react2['default'].createElement(_CloseButton2['default'], (0, _reactWithStyles.css)(styles.DayPickerKeyboardShortcuts_closeSvg))
	            ),
	            _react2['default'].createElement(
	              'ul',
	              _extends({}, (0, _reactWithStyles.css)(styles.DayPickerKeyboardShortcuts_list), {
	                id: 'DayPickerKeyboardShortcuts_description'
	              }),
	              this.keyboardShortcuts.map(function (_ref2) {
	                var unicode = _ref2.unicode,
	                    label = _ref2.label,
	                    action = _ref2.action;
	                return _react2['default'].createElement(_KeyboardShortcutRow2['default'], {
	                  key: label,
	                  unicode: unicode,
	                  label: label,
	                  action: action,
	                  block: block
	                });
	              })
	            )
	          )
	        );
	      }
	
	      return render;
	    }()
	  }]);
	
	  return DayPickerKeyboardShortcuts;
	}(_react2['default'].Component);
	
	DayPickerKeyboardShortcuts.propTypes = propTypes;
	DayPickerKeyboardShortcuts.defaultProps = defaultProps;
	
	exports['default'] = (0, _reactWithStyles.withStyles)(function (_ref3) {
	  var _ref3$reactDates = _ref3.reactDates,
	      color = _ref3$reactDates.color,
	      font = _ref3$reactDates.font,
	      zIndex = _ref3$reactDates.zIndex;
	  return {
	    DayPickerKeyboardShortcuts_buttonReset: {
	      background: 'none',
	      border: 0,
	      borderRadius: 0,
	      color: 'inherit',
	      font: 'inherit',
	      lineHeight: 'normal',
	      overflow: 'visible',
	      padding: 0,
	      cursor: 'pointer',
	      fontSize: font.size,
	
	      ':active': {
	        outline: 'none'
	      }
	    },
	
	    DayPickerKeyboardShortcuts_show: {
	      width: 22,
	      position: 'absolute',
	      zIndex: zIndex + 2
	    },
	
	    DayPickerKeyboardShortcuts_show__bottomRight: {
	      borderTop: '26px solid transparent',
	      borderRight: '33px solid ' + String(color.core.primary),
	      bottom: 0,
	      right: 0,
	
	      ':hover': {
	        borderRight: '33px solid ' + String(color.core.primary_dark)
	      }
	    },
	
	    DayPickerKeyboardShortcuts_show__topRight: {
	      borderBottom: '26px solid transparent',
	      borderRight: '33px solid ' + String(color.core.primary),
	      top: 0,
	      right: 0,
	
	      ':hover': {
	        borderRight: '33px solid ' + String(color.core.primary_dark)
	      }
	    },
	
	    DayPickerKeyboardShortcuts_show__topLeft: {
	      borderBottom: '26px solid transparent',
	      borderLeft: '33px solid ' + String(color.core.primary),
	      top: 0,
	      left: 0,
	
	      ':hover': {
	        borderLeft: '33px solid ' + String(color.core.primary_dark)
	      }
	    },
	
	    DayPickerKeyboardShortcuts_showSpan: {
	      color: color.core.white,
	      position: 'absolute'
	    },
	
	    DayPickerKeyboardShortcuts_showSpan__bottomRight: {
	      bottom: 0,
	      right: -28
	    },
	
	    DayPickerKeyboardShortcuts_showSpan__topRight: {
	      top: 1,
	      right: -28
	    },
	
	    DayPickerKeyboardShortcuts_showSpan__topLeft: {
	      top: 1,
	      left: -28
	    },
	
	    DayPickerKeyboardShortcuts_panel: {
	      overflow: 'auto',
	      background: color.background,
	      border: '1px solid ' + String(color.core.border),
	      borderRadius: 2,
	      position: 'absolute',
	      top: 0,
	      bottom: 0,
	      right: 0,
	      left: 0,
	      zIndex: zIndex + 2,
	      padding: 22,
	      margin: 33
	    },
	
	    DayPickerKeyboardShortcuts_title: {
	      fontSize: 16,
	      fontWeight: 'bold',
	      margin: 0
	    },
	
	    DayPickerKeyboardShortcuts_list: {
	      listStyle: 'none',
	      padding: 0,
	      fontSize: font.size
	    },
	
	    DayPickerKeyboardShortcuts_close: {
	      position: 'absolute',
	      right: 22,
	      top: 22,
	      zIndex: zIndex + 2,
	
	      ':active': {
	        outline: 'none'
	      }
	    },
	
	    DayPickerKeyboardShortcuts_closeSvg: {
	      height: 15,
	      width: 15,
	      fill: color.core.grayLighter,
	
	      ':hover': {
	        fill: color.core.grayLight
	      },
	
	      ':focus': {
	        fill: color.core.grayLight
	      }
	    }
	  };
	})(DayPickerKeyboardShortcuts);

/***/ },
/* 2974 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _object = __webpack_require__(55);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(27);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _airbnbPropTypes = __webpack_require__(42);
	
	var _reactWithStyles = __webpack_require__(72);
	
	var _defaultPhrases = __webpack_require__(50);
	
	var _getPhrasePropTypes = __webpack_require__(63);
	
	var _getPhrasePropTypes2 = _interopRequireDefault(_getPhrasePropTypes);
	
	var _LeftArrow = __webpack_require__(856);
	
	var _LeftArrow2 = _interopRequireDefault(_LeftArrow);
	
	var _RightArrow = __webpack_require__(857);
	
	var _RightArrow2 = _interopRequireDefault(_RightArrow);
	
	var _ChevronUp = __webpack_require__(2970);
	
	var _ChevronUp2 = _interopRequireDefault(_ChevronUp);
	
	var _ChevronDown = __webpack_require__(2969);
	
	var _ChevronDown2 = _interopRequireDefault(_ChevronDown);
	
	var _ScrollableOrientationShape = __webpack_require__(212);
	
	var _ScrollableOrientationShape2 = _interopRequireDefault(_ScrollableOrientationShape);
	
	var _constants = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)((0, _object2['default'])({}, _reactWithStyles.withStylesPropTypes, {
	  navPrev: _propTypes2['default'].node,
	  navNext: _propTypes2['default'].node,
	  orientation: _ScrollableOrientationShape2['default'],
	
	  onPrevMonthClick: _propTypes2['default'].func,
	  onNextMonthClick: _propTypes2['default'].func,
	
	  // internationalization
	  phrases: _propTypes2['default'].shape((0, _getPhrasePropTypes2['default'])(_defaultPhrases.DayPickerNavigationPhrases)),
	
	  isRTL: _propTypes2['default'].bool
	}));
	
	var defaultProps = {
	  navPrev: null,
	  navNext: null,
	  orientation: _constants.HORIZONTAL_ORIENTATION,
	
	  onPrevMonthClick: function () {
	    function onPrevMonthClick() {}
	
	    return onPrevMonthClick;
	  }(),
	  onNextMonthClick: function () {
	    function onNextMonthClick() {}
	
	    return onNextMonthClick;
	  }(),
	
	
	  // internationalization
	  phrases: _defaultPhrases.DayPickerNavigationPhrases,
	  isRTL: false
	};
	
	function DayPickerNavigation(_ref) {
	  var navPrev = _ref.navPrev,
	      navNext = _ref.navNext,
	      onPrevMonthClick = _ref.onPrevMonthClick,
	      onNextMonthClick = _ref.onNextMonthClick,
	      orientation = _ref.orientation,
	      phrases = _ref.phrases,
	      isRTL = _ref.isRTL,
	      styles = _ref.styles;
	
	  var isHorizontal = orientation === _constants.HORIZONTAL_ORIENTATION;
	  var isVertical = orientation !== _constants.HORIZONTAL_ORIENTATION;
	  var isVerticalScrollable = orientation === _constants.VERTICAL_SCROLLABLE;
	
	  var navPrevIcon = navPrev;
	  var navNextIcon = navNext;
	  var isDefaultNavPrev = false;
	  var isDefaultNavNext = false;
	  if (!navPrevIcon) {
	    isDefaultNavPrev = true;
	    var Icon = isVertical ? _ChevronUp2['default'] : _LeftArrow2['default'];
	    if (isRTL && !isVertical) {
	      Icon = _RightArrow2['default'];
	    }
	    navPrevIcon = _react2['default'].createElement(Icon, (0, _reactWithStyles.css)(isHorizontal && styles.DayPickerNavigation_svg__horizontal, isVertical && styles.DayPickerNavigation_svg__vertical));
	  }
	
	  if (!navNextIcon) {
	    isDefaultNavNext = true;
	    var _Icon = isVertical ? _ChevronDown2['default'] : _RightArrow2['default'];
	    if (isRTL && !isVertical) {
	      _Icon = _LeftArrow2['default'];
	    }
	    navNextIcon = _react2['default'].createElement(_Icon, (0, _reactWithStyles.css)(isHorizontal && styles.DayPickerNavigation_svg__horizontal, isVertical && styles.DayPickerNavigation_svg__vertical));
	  }
	
	  return _react2['default'].createElement(
	    'div',
	    (0, _reactWithStyles.css)(styles.DayPickerNavigation_container, isHorizontal && styles.DayPickerNavigation_container__horizontal, isVertical && styles.DayPickerNavigation_container__vertical, isVerticalScrollable && styles.DayPickerNavigation_container__verticalScrollable),
	    !isVerticalScrollable && _react2['default'].createElement(
	      'button',
	      _extends({}, _reactWithStyles.css.apply(undefined, [styles.DayPickerNavigation_button, isDefaultNavPrev && styles.DayPickerNavigation_button__default].concat(_toConsumableArray(isHorizontal && [styles.DayPickerNavigation_button__horizontal, !isRTL && styles.DayPickerNavigation_leftButton__horizontal, isRTL && styles.DayPickerNavigation_rightButton__horizontal]), _toConsumableArray(isVertical && [styles.DayPickerNavigation_button__vertical, styles.DayPickerNavigation_prevButton__vertical, isDefaultNavPrev && styles.DayPickerNavigation_button__vertical__default]))), {
	        type: 'button',
	        'aria-label': phrases.jumpToPrevMonth,
	        onClick: onPrevMonthClick,
	        onMouseUp: function () {
	          function onMouseUp(e) {
	            e.currentTarget.blur();
	          }
	
	          return onMouseUp;
	        }()
	      }),
	      navPrevIcon
	    ),
	    _react2['default'].createElement(
	      'button',
	      _extends({}, _reactWithStyles.css.apply(undefined, [styles.DayPickerNavigation_button, isDefaultNavNext && styles.DayPickerNavigation_button__default].concat(_toConsumableArray(isHorizontal && [styles.DayPickerNavigation_button__horizontal, isRTL && styles.DayPickerNavigation_leftButton__horizontal, !isRTL && styles.DayPickerNavigation_rightButton__horizontal]), _toConsumableArray(isVertical && [styles.DayPickerNavigation_button__vertical, styles.DayPickerNavigation_nextButton__vertical, isDefaultNavNext && styles.DayPickerNavigation_button__vertical__default, isDefaultNavNext && styles.DayPickerNavigation_nextButton__vertical__default]), [isVerticalScrollable && styles.DayPickerNavigation_nextButton__verticalScrollable])), {
	        type: 'button',
	        'aria-label': phrases.jumpToNextMonth,
	        onClick: onNextMonthClick,
	        onMouseUp: function () {
	          function onMouseUp(e) {
	            e.currentTarget.blur();
	          }
	
	          return onMouseUp;
	        }()
	      }),
	      navNextIcon
	    )
	  );
	}
	
	DayPickerNavigation.propTypes = propTypes;
	DayPickerNavigation.defaultProps = defaultProps;
	
	exports['default'] = (0, _reactWithStyles.withStyles)(function (_ref2) {
	  var _ref2$reactDates = _ref2.reactDates,
	      color = _ref2$reactDates.color,
	      zIndex = _ref2$reactDates.zIndex;
	  return {
	    DayPickerNavigation_container: {
	      position: 'relative',
	      zIndex: zIndex + 2
	    },
	
	    DayPickerNavigation_container__horizontal: {},
	
	    DayPickerNavigation_container__vertical: {
	      background: color.background,
	      boxShadow: '0 0 5px 2px rgba(0, 0, 0, 0.1)',
	      position: 'absolute',
	      bottom: 0,
	      left: 0,
	      height: 52,
	      width: '100%'
	    },
	
	    DayPickerNavigation_container__verticalScrollable: {
	      position: 'relative'
	    },
	
	    DayPickerNavigation_button: {
	      cursor: 'pointer',
	      lineHeight: 0.78,
	      userSelect: 'none'
	    },
	
	    DayPickerNavigation_button__default: {
	      border: '1px solid ' + String(color.core.borderLight),
	      backgroundColor: color.background,
	      color: color.placeholderText,
	
	      ':focus': {
	        border: '1px solid ' + String(color.core.borderMedium)
	      },
	
	      ':hover': {
	        border: '1px solid ' + String(color.core.borderMedium)
	      },
	
	      ':active': {
	        background: color.backgroundDark
	      }
	    },
	
	    DayPickerNavigation_button__horizontal: {
	      borderRadius: 3,
	      padding: '6px 9px',
	      top: 18,
	      position: 'absolute'
	    },
	
	    DayPickerNavigation_leftButton__horizontal: {
	      left: 22
	    },
	
	    DayPickerNavigation_rightButton__horizontal: {
	      right: 22
	    },
	
	    DayPickerNavigation_button__vertical: {
	      display: 'inline-block',
	      position: 'relative',
	      height: '100%',
	      width: '50%'
	    },
	
	    DayPickerNavigation_button__vertical__default: {
	      padding: 5
	    },
	
	    DayPickerNavigation_nextButton__vertical__default: {
	      borderLeft: 0
	    },
	
	    DayPickerNavigation_nextButton__verticalScrollable: {
	      width: '100%'
	    },
	
	    DayPickerNavigation_svg__horizontal: {
	      height: 19,
	      width: 19,
	      fill: color.core.grayLight
	    },
	
	    DayPickerNavigation_svg__vertical: {
	      height: 42,
	      width: 42,
	      fill: color.text
	    }
	  };
	})(DayPickerNavigation);

/***/ },
/* 2975 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _object = __webpack_require__(55);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(27);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _airbnbPropTypes = __webpack_require__(42);
	
	var _reactWithStyles = __webpack_require__(72);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)((0, _object2['default'])({}, _reactWithStyles.withStylesPropTypes, {
	  unicode: _propTypes2['default'].string.isRequired,
	  label: _propTypes2['default'].string.isRequired,
	  action: _propTypes2['default'].string.isRequired,
	  block: _propTypes2['default'].bool
	}));
	
	var defaultProps = {
	  block: false
	};
	
	function KeyboardShortcutRow(_ref) {
	  var unicode = _ref.unicode,
	      label = _ref.label,
	      action = _ref.action,
	      block = _ref.block,
	      styles = _ref.styles;
	
	  return _react2['default'].createElement(
	    'li',
	    (0, _reactWithStyles.css)(styles.KeyboardShortcutRow, block && styles.KeyboardShortcutRow__block),
	    _react2['default'].createElement(
	      'div',
	      (0, _reactWithStyles.css)(styles.KeyboardShortcutRow_keyContainer, block && styles.KeyboardShortcutRow_keyContainer__block),
	      _react2['default'].createElement(
	        'span',
	        _extends({}, (0, _reactWithStyles.css)(styles.KeyboardShortcutRow_key), {
	          role: 'img',
	          'aria-label': String(label) + ',' // add comma so screen readers will pause before reading action
	        }),
	        unicode
	      )
	    ),
	    _react2['default'].createElement(
	      'div',
	      (0, _reactWithStyles.css)(styles.KeyboardShortcutRow_action),
	      action
	    )
	  );
	}
	
	KeyboardShortcutRow.propTypes = propTypes;
	KeyboardShortcutRow.defaultProps = defaultProps;
	
	exports['default'] = (0, _reactWithStyles.withStyles)(function (_ref2) {
	  var color = _ref2.reactDates.color;
	  return {
	    KeyboardShortcutRow: {
	      listStyle: 'none',
	      margin: '6px 0'
	    },
	
	    KeyboardShortcutRow__block: {
	      marginBottom: 16
	    },
	
	    KeyboardShortcutRow_keyContainer: {
	      display: 'inline-block',
	      whiteSpace: 'nowrap',
	      textAlign: 'right',
	      marginRight: 6
	    },
	
	    KeyboardShortcutRow_keyContainer__block: {
	      textAlign: 'left',
	      display: 'inline'
	    },
	
	    KeyboardShortcutRow_key: {
	      fontFamily: 'monospace',
	      fontSize: 12,
	      textTransform: 'uppercase',
	      background: color.core.grayLightest,
	      padding: '2px 6px'
	    },
	
	    KeyboardShortcutRow_action: {
	      display: 'inline',
	      wordBreak: 'break-word',
	      marginLeft: 8
	    }
	  };
	})(KeyboardShortcutRow);

/***/ },
/* 2976 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PureSingleDatePicker = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _object = __webpack_require__(55);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(9);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactWithStyles = __webpack_require__(72);
	
	var _reactPortal = __webpack_require__(901);
	
	var _airbnbPropTypes = __webpack_require__(42);
	
	var _consolidatedEvents = __webpack_require__(301);
	
	var _isTouchDevice = __webpack_require__(205);
	
	var _isTouchDevice2 = _interopRequireDefault(_isTouchDevice);
	
	var _SingleDatePickerShape = __webpack_require__(863);
	
	var _SingleDatePickerShape2 = _interopRequireDefault(_SingleDatePickerShape);
	
	var _defaultPhrases = __webpack_require__(50);
	
	var _toMomentObject = __webpack_require__(215);
	
	var _toMomentObject2 = _interopRequireDefault(_toMomentObject);
	
	var _toLocalizedDateString = __webpack_require__(475);
	
	var _toLocalizedDateString2 = _interopRequireDefault(_toLocalizedDateString);
	
	var _getResponsiveContainerStyles = __webpack_require__(870);
	
	var _getResponsiveContainerStyles2 = _interopRequireDefault(_getResponsiveContainerStyles);
	
	var _getDetachedContainerStyles = __webpack_require__(869);
	
	var _getDetachedContainerStyles2 = _interopRequireDefault(_getDetachedContainerStyles);
	
	var _getInputHeight = __webpack_require__(473);
	
	var _getInputHeight2 = _interopRequireDefault(_getInputHeight);
	
	var _isInclusivelyAfterDay = __webpack_require__(213);
	
	var _isInclusivelyAfterDay2 = _interopRequireDefault(_isInclusivelyAfterDay);
	
	var _disableScroll2 = __webpack_require__(866);
	
	var _disableScroll3 = _interopRequireDefault(_disableScroll2);
	
	var _SingleDatePickerInput = __webpack_require__(858);
	
	var _SingleDatePickerInput2 = _interopRequireDefault(_SingleDatePickerInput);
	
	var _DayPickerSingleDateController = __webpack_require__(855);
	
	var _DayPickerSingleDateController2 = _interopRequireDefault(_DayPickerSingleDateController);
	
	var _OutsideClickHandler = __webpack_require__(338);
	
	var _OutsideClickHandler2 = _interopRequireDefault(_OutsideClickHandler);
	
	var _CloseButton = __webpack_require__(259);
	
	var _CloseButton2 = _interopRequireDefault(_CloseButton);
	
	var _constants = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)((0, _object2['default'])({}, _reactWithStyles.withStylesPropTypes, _SingleDatePickerShape2['default']));
	
	var defaultProps = {
	  // required props for a functional interactive SingleDatePicker
	  date: null,
	  focused: false,
	
	  // input related props
	  id: 'date',
	  placeholder: 'Date',
	  disabled: false,
	  required: false,
	  readOnly: false,
	  screenReaderInputMessage: '',
	  showClearDate: false,
	  showDefaultInputIcon: false,
	  inputIconPosition: _constants.ICON_BEFORE_POSITION,
	  customInputIcon: null,
	  customCloseIcon: null,
	  noBorder: false,
	  block: false,
	  small: false,
	  regular: false,
	  verticalSpacing: _constants.DEFAULT_VERTICAL_SPACING,
	  keepFocusOnInput: false,
	
	  // calendar presentation and interaction related props
	  orientation: _constants.HORIZONTAL_ORIENTATION,
	  anchorDirection: _constants.ANCHOR_LEFT,
	  openDirection: _constants.OPEN_DOWN,
	  horizontalMargin: 0,
	  withPortal: false,
	  withFullScreenPortal: false,
	  appendToBody: false,
	  disableScroll: false,
	  initialVisibleMonth: null,
	  firstDayOfWeek: null,
	  numberOfMonths: 2,
	  keepOpenOnDateSelect: false,
	  reopenPickerOnClearDate: false,
	  renderCalendarInfo: null,
	  calendarInfoPosition: _constants.INFO_POSITION_BOTTOM,
	  hideKeyboardShortcutsPanel: false,
	  daySize: _constants.DAY_SIZE,
	  isRTL: false,
	  verticalHeight: null,
	  transitionDuration: undefined,
	
	  // navigation related props
	  navPrev: null,
	  navNext: null,
	
	  onPrevMonthClick: function () {
	    function onPrevMonthClick() {}
	
	    return onPrevMonthClick;
	  }(),
	  onNextMonthClick: function () {
	    function onNextMonthClick() {}
	
	    return onNextMonthClick;
	  }(),
	  onClose: function () {
	    function onClose() {}
	
	    return onClose;
	  }(),
	
	
	  // month presentation and interaction related props
	  renderMonth: null,
	
	  // day presentation and interaction related props
	  renderCalendarDay: undefined,
	  renderDayContents: null,
	  enableOutsideDays: false,
	  isDayBlocked: function () {
	    function isDayBlocked() {
	      return false;
	    }
	
	    return isDayBlocked;
	  }(),
	  isOutsideRange: function () {
	    function isOutsideRange(day) {
	      return !(0, _isInclusivelyAfterDay2['default'])(day, (0, _moment2['default'])());
	    }
	
	    return isOutsideRange;
	  }(),
	  isDayHighlighted: function () {
	    function isDayHighlighted() {}
	
	    return isDayHighlighted;
	  }(),
	
	  // internationalization props
	  displayFormat: function () {
	    function displayFormat() {
	      return _moment2['default'].localeData().longDateFormat('L');
	    }
	
	    return displayFormat;
	  }(),
	  monthFormat: 'MMMM YYYY',
	  weekDayFormat: 'dd',
	  phrases: _defaultPhrases.SingleDatePickerPhrases,
	  dayAriaLabelFormat: undefined
	};
	
	var SingleDatePicker = function (_React$Component) {
	  _inherits(SingleDatePicker, _React$Component);
	
	  function SingleDatePicker(props) {
	    _classCallCheck(this, SingleDatePicker);
	
	    var _this = _possibleConstructorReturn(this, (SingleDatePicker.__proto__ || Object.getPrototypeOf(SingleDatePicker)).call(this, props));
	
	    _this.isTouchDevice = false;
	
	    _this.state = {
	      dayPickerContainerStyles: {},
	      isDayPickerFocused: false,
	      isInputFocused: false,
	      showKeyboardShortcuts: false
	    };
	
	    _this.onDayPickerFocus = _this.onDayPickerFocus.bind(_this);
	    _this.onDayPickerBlur = _this.onDayPickerBlur.bind(_this);
	    _this.showKeyboardShortcutsPanel = _this.showKeyboardShortcutsPanel.bind(_this);
	
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onFocus = _this.onFocus.bind(_this);
	    _this.onClearFocus = _this.onClearFocus.bind(_this);
	    _this.clearDate = _this.clearDate.bind(_this);
	
	    _this.responsivizePickerPosition = _this.responsivizePickerPosition.bind(_this);
	    _this.disableScroll = _this.disableScroll.bind(_this);
	
	    _this.setDayPickerContainerRef = _this.setDayPickerContainerRef.bind(_this);
	    _this.setContainerRef = _this.setContainerRef.bind(_this);
	    return _this;
	  }
	
	  /* istanbul ignore next */
	
	
	  _createClass(SingleDatePicker, [{
	    key: 'componentDidMount',
	    value: function () {
	      function componentDidMount() {
	        this.removeEventListener = (0, _consolidatedEvents.addEventListener)(window, 'resize', this.responsivizePickerPosition, { passive: true });
	        this.responsivizePickerPosition();
	        this.disableScroll();
	
	        if (this.props.focused) {
	          this.setState({
	            isInputFocused: true
	          });
	        }
	
	        this.isTouchDevice = (0, _isTouchDevice2['default'])();
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentDidUpdate',
	    value: function () {
	      function componentDidUpdate(prevProps) {
	        if (!prevProps.focused && this.props.focused) {
	          this.responsivizePickerPosition();
	          this.disableScroll();
	        } else if (prevProps.focused && !this.props.focused) {
	          if (this.enableScroll) this.enableScroll();
	        }
	      }
	
	      return componentDidUpdate;
	    }()
	
	    /* istanbul ignore next */
	
	  }, {
	    key: 'componentWillUnmount',
	    value: function () {
	      function componentWillUnmount() {
	        if (this.removeEventListener) this.removeEventListener();
	        if (this.enableScroll) this.enableScroll();
	      }
	
	      return componentWillUnmount;
	    }()
	  }, {
	    key: 'onChange',
	    value: function () {
	      function onChange(dateString) {
	        var _props = this.props,
	            isOutsideRange = _props.isOutsideRange,
	            keepOpenOnDateSelect = _props.keepOpenOnDateSelect,
	            onDateChange = _props.onDateChange,
	            onFocusChange = _props.onFocusChange,
	            onClose = _props.onClose;
	
	        var newDate = (0, _toMomentObject2['default'])(dateString, this.getDisplayFormat());
	
	        var isValid = newDate && !isOutsideRange(newDate);
	        if (isValid) {
	          onDateChange(newDate);
	          if (!keepOpenOnDateSelect) {
	            onFocusChange({ focused: false });
	            onClose({ date: newDate });
	          }
	        } else {
	          onDateChange(null);
	        }
	      }
	
	      return onChange;
	    }()
	  }, {
	    key: 'onFocus',
	    value: function () {
	      function onFocus() {
	        var _props2 = this.props,
	            disabled = _props2.disabled,
	            onFocusChange = _props2.onFocusChange,
	            readOnly = _props2.readOnly,
	            withPortal = _props2.withPortal,
	            withFullScreenPortal = _props2.withFullScreenPortal,
	            keepFocusOnInput = _props2.keepFocusOnInput;
	
	
	        var withAnyPortal = withPortal || withFullScreenPortal;
	        var moveFocusToDayPicker = withAnyPortal || readOnly && !keepFocusOnInput || this.isTouchDevice && !keepFocusOnInput;
	
	        if (moveFocusToDayPicker) {
	          this.onDayPickerFocus();
	        } else {
	          this.onDayPickerBlur();
	        }
	
	        if (!disabled) {
	          onFocusChange({ focused: true });
	        }
	      }
	
	      return onFocus;
	    }()
	  }, {
	    key: 'onClearFocus',
	    value: function () {
	      function onClearFocus(event) {
	        var _props3 = this.props,
	            date = _props3.date,
	            focused = _props3.focused,
	            onFocusChange = _props3.onFocusChange,
	            onClose = _props3.onClose;
	
	        if (!focused) return;
	        if (this.props.appendToBody && this.dayPickerContainer.contains(event.target)) return;
	
	        this.setState({
	          isInputFocused: false,
	          isDayPickerFocused: false
	        });
	
	        onFocusChange({ focused: false });
	        onClose({ date: date });
	      }
	
	      return onClearFocus;
	    }()
	  }, {
	    key: 'onDayPickerFocus',
	    value: function () {
	      function onDayPickerFocus() {
	        this.setState({
	          isInputFocused: false,
	          isDayPickerFocused: true,
	          showKeyboardShortcuts: false
	        });
	      }
	
	      return onDayPickerFocus;
	    }()
	  }, {
	    key: 'onDayPickerBlur',
	    value: function () {
	      function onDayPickerBlur() {
	        this.setState({
	          isInputFocused: true,
	          isDayPickerFocused: false,
	          showKeyboardShortcuts: false
	        });
	      }
	
	      return onDayPickerBlur;
	    }()
	  }, {
	    key: 'getDateString',
	    value: function () {
	      function getDateString(date) {
	        var displayFormat = this.getDisplayFormat();
	        if (date && displayFormat) {
	          return date && date.format(displayFormat);
	        }
	        return (0, _toLocalizedDateString2['default'])(date);
	      }
	
	      return getDateString;
	    }()
	  }, {
	    key: 'getDisplayFormat',
	    value: function () {
	      function getDisplayFormat() {
	        var displayFormat = this.props.displayFormat;
	
	        return typeof displayFormat === 'string' ? displayFormat : displayFormat();
	      }
	
	      return getDisplayFormat;
	    }()
	  }, {
	    key: 'setDayPickerContainerRef',
	    value: function () {
	      function setDayPickerContainerRef(ref) {
	        this.dayPickerContainer = ref;
	      }
	
	      return setDayPickerContainerRef;
	    }()
	  }, {
	    key: 'setContainerRef',
	    value: function () {
	      function setContainerRef(ref) {
	        this.container = ref;
	      }
	
	      return setContainerRef;
	    }()
	  }, {
	    key: 'clearDate',
	    value: function () {
	      function clearDate() {
	        var _props4 = this.props,
	            onDateChange = _props4.onDateChange,
	            reopenPickerOnClearDate = _props4.reopenPickerOnClearDate,
	            onFocusChange = _props4.onFocusChange;
	
	        onDateChange(null);
	        if (reopenPickerOnClearDate) {
	          onFocusChange({ focused: true });
	        }
	      }
	
	      return clearDate;
	    }()
	  }, {
	    key: 'disableScroll',
	    value: function () {
	      function disableScroll() {
	        if (!this.props.appendToBody && !this.props.disableScroll) return;
	        if (!this.props.focused) return;
	
	        // Disable scroll for every ancestor of this <SingleDatePicker> up to the
	        // document level. This ensures the input and the picker never move. Other
	        // sibling elements or the picker itself can scroll.
	        this.enableScroll = (0, _disableScroll3['default'])(this.container);
	      }
	
	      return disableScroll;
	    }()
	
	    /* istanbul ignore next */
	
	  }, {
	    key: 'responsivizePickerPosition',
	    value: function () {
	      function responsivizePickerPosition() {
	        // It's possible the portal props have been changed in response to window resizes
	        // So let's ensure we reset this back to the base state each time
	        this.setState({ dayPickerContainerStyles: {} });
	
	        var _props5 = this.props,
	            openDirection = _props5.openDirection,
	            anchorDirection = _props5.anchorDirection,
	            horizontalMargin = _props5.horizontalMargin,
	            withPortal = _props5.withPortal,
	            withFullScreenPortal = _props5.withFullScreenPortal,
	            appendToBody = _props5.appendToBody,
	            focused = _props5.focused;
	        var dayPickerContainerStyles = this.state.dayPickerContainerStyles;
	
	
	        if (!focused) {
	          return;
	        }
	
	        var isAnchoredLeft = anchorDirection === _constants.ANCHOR_LEFT;
	
	        if (!withPortal && !withFullScreenPortal) {
	          var containerRect = this.dayPickerContainer.getBoundingClientRect();
	          var currentOffset = dayPickerContainerStyles[anchorDirection] || 0;
	          var containerEdge = isAnchoredLeft ? containerRect[_constants.ANCHOR_RIGHT] : containerRect[_constants.ANCHOR_LEFT];
	
	          this.setState({
	            dayPickerContainerStyles: (0, _object2['default'])({}, (0, _getResponsiveContainerStyles2['default'])(anchorDirection, currentOffset, containerEdge, horizontalMargin), appendToBody && (0, _getDetachedContainerStyles2['default'])(openDirection, anchorDirection, this.container))
	          });
	        }
	      }
	
	      return responsivizePickerPosition;
	    }()
	  }, {
	    key: 'showKeyboardShortcutsPanel',
	    value: function () {
	      function showKeyboardShortcutsPanel() {
	        this.setState({
	          isInputFocused: false,
	          isDayPickerFocused: true,
	          showKeyboardShortcuts: true
	        });
	      }
	
	      return showKeyboardShortcutsPanel;
	    }()
	  }, {
	    key: 'maybeRenderDayPickerWithPortal',
	    value: function () {
	      function maybeRenderDayPickerWithPortal() {
	        var _props6 = this.props,
	            focused = _props6.focused,
	            withPortal = _props6.withPortal,
	            withFullScreenPortal = _props6.withFullScreenPortal,
	            appendToBody = _props6.appendToBody;
	
	
	        if (!focused) {
	          return null;
	        }
	
	        if (withPortal || withFullScreenPortal || appendToBody) {
	          return _react2['default'].createElement(
	            _reactPortal.Portal,
	            null,
	            this.renderDayPicker()
	          );
	        }
	
	        return this.renderDayPicker();
	      }
	
	      return maybeRenderDayPickerWithPortal;
	    }()
	  }, {
	    key: 'renderDayPicker',
	    value: function () {
	      function renderDayPicker() {
	        var _props7 = this.props,
	            anchorDirection = _props7.anchorDirection,
	            openDirection = _props7.openDirection,
	            onDateChange = _props7.onDateChange,
	            date = _props7.date,
	            onFocusChange = _props7.onFocusChange,
	            focused = _props7.focused,
	            enableOutsideDays = _props7.enableOutsideDays,
	            numberOfMonths = _props7.numberOfMonths,
	            orientation = _props7.orientation,
	            monthFormat = _props7.monthFormat,
	            navPrev = _props7.navPrev,
	            navNext = _props7.navNext,
	            onPrevMonthClick = _props7.onPrevMonthClick,
	            onNextMonthClick = _props7.onNextMonthClick,
	            onClose = _props7.onClose,
	            withPortal = _props7.withPortal,
	            withFullScreenPortal = _props7.withFullScreenPortal,
	            keepOpenOnDateSelect = _props7.keepOpenOnDateSelect,
	            initialVisibleMonth = _props7.initialVisibleMonth,
	            renderMonth = _props7.renderMonth,
	            renderCalendarDay = _props7.renderCalendarDay,
	            renderDayContents = _props7.renderDayContents,
	            renderCalendarInfo = _props7.renderCalendarInfo,
	            calendarInfoPosition = _props7.calendarInfoPosition,
	            hideKeyboardShortcutsPanel = _props7.hideKeyboardShortcutsPanel,
	            firstDayOfWeek = _props7.firstDayOfWeek,
	            customCloseIcon = _props7.customCloseIcon,
	            phrases = _props7.phrases,
	            dayAriaLabelFormat = _props7.dayAriaLabelFormat,
	            daySize = _props7.daySize,
	            isRTL = _props7.isRTL,
	            isOutsideRange = _props7.isOutsideRange,
	            isDayBlocked = _props7.isDayBlocked,
	            isDayHighlighted = _props7.isDayHighlighted,
	            weekDayFormat = _props7.weekDayFormat,
	            styles = _props7.styles,
	            verticalHeight = _props7.verticalHeight,
	            transitionDuration = _props7.transitionDuration,
	            verticalSpacing = _props7.verticalSpacing,
	            small = _props7.small,
	            reactDates = _props7.theme.reactDates;
	        var _state = this.state,
	            dayPickerContainerStyles = _state.dayPickerContainerStyles,
	            isDayPickerFocused = _state.isDayPickerFocused,
	            showKeyboardShortcuts = _state.showKeyboardShortcuts;
	
	
	        var onOutsideClick = !withFullScreenPortal && withPortal ? this.onClearFocus : undefined;
	        var closeIcon = customCloseIcon || _react2['default'].createElement(_CloseButton2['default'], null);
	
	        var inputHeight = (0, _getInputHeight2['default'])(reactDates, small);
	
	        var withAnyPortal = withPortal || withFullScreenPortal;
	
	        return _react2['default'].createElement(
	          'div',
	          _extends({ // eslint-disable-line jsx-a11y/no-static-element-interactions
	            ref: this.setDayPickerContainerRef
	          }, (0, _reactWithStyles.css)(styles.SingleDatePicker_picker, anchorDirection === _constants.ANCHOR_LEFT && styles.SingleDatePicker_picker__directionLeft, anchorDirection === _constants.ANCHOR_RIGHT && styles.SingleDatePicker_picker__directionRight, openDirection === _constants.OPEN_DOWN && styles.SingleDatePicker_picker__openDown, openDirection === _constants.OPEN_UP && styles.SingleDatePicker_picker__openUp, !withAnyPortal && openDirection === _constants.OPEN_DOWN && {
	            top: inputHeight + verticalSpacing
	          }, !withAnyPortal && openDirection === _constants.OPEN_UP && {
	            bottom: inputHeight + verticalSpacing
	          }, orientation === _constants.HORIZONTAL_ORIENTATION && styles.SingleDatePicker_picker__horizontal, orientation === _constants.VERTICAL_ORIENTATION && styles.SingleDatePicker_picker__vertical, withAnyPortal && styles.SingleDatePicker_picker__portal, withFullScreenPortal && styles.SingleDatePicker_picker__fullScreenPortal, isRTL && styles.SingleDatePicker_picker__rtl, dayPickerContainerStyles), {
	            onClick: onOutsideClick
	          }),
	          _react2['default'].createElement(_DayPickerSingleDateController2['default'], {
	            date: date,
	            onDateChange: onDateChange,
	            onFocusChange: onFocusChange,
	            orientation: orientation,
	            enableOutsideDays: enableOutsideDays,
	            numberOfMonths: numberOfMonths,
	            monthFormat: monthFormat,
	            withPortal: withAnyPortal,
	            focused: focused,
	            keepOpenOnDateSelect: keepOpenOnDateSelect,
	            hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
	            initialVisibleMonth: initialVisibleMonth,
	            navPrev: navPrev,
	            navNext: navNext,
	            onPrevMonthClick: onPrevMonthClick,
	            onNextMonthClick: onNextMonthClick,
	            onClose: onClose,
	            renderMonth: renderMonth,
	            renderCalendarDay: renderCalendarDay,
	            renderDayContents: renderDayContents,
	            renderCalendarInfo: renderCalendarInfo,
	            calendarInfoPosition: calendarInfoPosition,
	            isFocused: isDayPickerFocused,
	            showKeyboardShortcuts: showKeyboardShortcuts,
	            onBlur: this.onDayPickerBlur,
	            phrases: phrases,
	            dayAriaLabelFormat: dayAriaLabelFormat,
	            daySize: daySize,
	            isRTL: isRTL,
	            isOutsideRange: isOutsideRange,
	            isDayBlocked: isDayBlocked,
	            isDayHighlighted: isDayHighlighted,
	            firstDayOfWeek: firstDayOfWeek,
	            weekDayFormat: weekDayFormat,
	            verticalHeight: verticalHeight,
	            transitionDuration: transitionDuration
	          }),
	          withFullScreenPortal && _react2['default'].createElement(
	            'button',
	            _extends({}, (0, _reactWithStyles.css)(styles.SingleDatePicker_closeButton), {
	              'aria-label': phrases.closeDatePicker,
	              type: 'button',
	              onClick: this.onClearFocus
	            }),
	            _react2['default'].createElement(
	              'div',
	              (0, _reactWithStyles.css)(styles.SingleDatePicker_closeButton_svg),
	              closeIcon
	            )
	          )
	        );
	      }
	
	      return renderDayPicker;
	    }()
	  }, {
	    key: 'render',
	    value: function () {
	      function render() {
	        var _props8 = this.props,
	            id = _props8.id,
	            placeholder = _props8.placeholder,
	            disabled = _props8.disabled,
	            focused = _props8.focused,
	            required = _props8.required,
	            readOnly = _props8.readOnly,
	            openDirection = _props8.openDirection,
	            showClearDate = _props8.showClearDate,
	            showDefaultInputIcon = _props8.showDefaultInputIcon,
	            inputIconPosition = _props8.inputIconPosition,
	            customCloseIcon = _props8.customCloseIcon,
	            customInputIcon = _props8.customInputIcon,
	            date = _props8.date,
	            phrases = _props8.phrases,
	            withPortal = _props8.withPortal,
	            withFullScreenPortal = _props8.withFullScreenPortal,
	            screenReaderInputMessage = _props8.screenReaderInputMessage,
	            isRTL = _props8.isRTL,
	            noBorder = _props8.noBorder,
	            block = _props8.block,
	            small = _props8.small,
	            regular = _props8.regular,
	            verticalSpacing = _props8.verticalSpacing,
	            styles = _props8.styles;
	        var isInputFocused = this.state.isInputFocused;
	
	
	        var displayValue = this.getDateString(date);
	
	        var onOutsideClick = !withPortal && !withFullScreenPortal ? this.onClearFocus : undefined;
	
	        var hideFang = verticalSpacing < _constants.FANG_HEIGHT_PX;
	
	        return _react2['default'].createElement(
	          'div',
	          _extends({
	            ref: this.setContainerRef
	          }, (0, _reactWithStyles.css)(styles.SingleDatePicker, block && styles.SingleDatePicker__block)),
	          _react2['default'].createElement(
	            _OutsideClickHandler2['default'],
	            { onOutsideClick: onOutsideClick },
	            _react2['default'].createElement(_SingleDatePickerInput2['default'], {
	              id: id,
	              placeholder: placeholder,
	              focused: focused,
	              isFocused: isInputFocused,
	              disabled: disabled,
	              required: required,
	              readOnly: readOnly,
	              openDirection: openDirection,
	              showCaret: !withPortal && !withFullScreenPortal && !hideFang,
	              onClearDate: this.clearDate,
	              showClearDate: showClearDate,
	              showDefaultInputIcon: showDefaultInputIcon,
	              inputIconPosition: inputIconPosition,
	              customCloseIcon: customCloseIcon,
	              customInputIcon: customInputIcon,
	              displayValue: displayValue,
	              onChange: this.onChange,
	              onFocus: this.onFocus,
	              onKeyDownShiftTab: this.onClearFocus,
	              onKeyDownTab: this.onClearFocus,
	              onKeyDownArrowDown: this.onDayPickerFocus,
	              onKeyDownQuestionMark: this.showKeyboardShortcutsPanel,
	              screenReaderMessage: screenReaderInputMessage,
	              phrases: phrases,
	              isRTL: isRTL,
	              noBorder: noBorder,
	              block: block,
	              small: small,
	              regular: regular,
	              verticalSpacing: verticalSpacing
	            }),
	            this.maybeRenderDayPickerWithPortal()
	          )
	        );
	      }
	
	      return render;
	    }()
	  }]);
	
	  return SingleDatePicker;
	}(_react2['default'].Component);
	
	SingleDatePicker.propTypes = propTypes;
	SingleDatePicker.defaultProps = defaultProps;
	
	exports.PureSingleDatePicker = SingleDatePicker;
	exports['default'] = (0, _reactWithStyles.withStyles)(function (_ref) {
	  var _ref$reactDates = _ref.reactDates,
	      color = _ref$reactDates.color,
	      zIndex = _ref$reactDates.zIndex;
	  return {
	    SingleDatePicker: {
	      position: 'relative',
	      display: 'inline-block'
	    },
	
	    SingleDatePicker__block: {
	      display: 'block'
	    },
	
	    SingleDatePicker_picker: {
	      zIndex: zIndex + 1,
	      backgroundColor: color.background,
	      position: 'absolute'
	    },
	
	    SingleDatePicker_picker__rtl: {
	      direction: 'rtl'
	    },
	
	    SingleDatePicker_picker__directionLeft: {
	      left: 0
	    },
	
	    SingleDatePicker_picker__directionRight: {
	      right: 0
	    },
	
	    SingleDatePicker_picker__portal: {
	      backgroundColor: 'rgba(0, 0, 0, 0.3)',
	      position: 'fixed',
	      top: 0,
	      left: 0,
	      height: '100%',
	      width: '100%'
	    },
	
	    SingleDatePicker_picker__fullScreenPortal: {
	      backgroundColor: color.background
	    },
	
	    SingleDatePicker_closeButton: {
	      background: 'none',
	      border: 0,
	      color: 'inherit',
	      font: 'inherit',
	      lineHeight: 'normal',
	      overflow: 'visible',
	      cursor: 'pointer',
	
	      position: 'absolute',
	      top: 0,
	      right: 0,
	      padding: 15,
	      zIndex: zIndex + 2,
	
	      ':hover': {
	        color: 'darken(' + String(color.core.grayLighter) + ', 10%)',
	        textDecoration: 'none'
	      },
	
	      ':focus': {
	        color: 'darken(' + String(color.core.grayLighter) + ', 10%)',
	        textDecoration: 'none'
	      }
	    },
	
	    SingleDatePicker_closeButton_svg: {
	      height: 15,
	      width: 15,
	      fill: color.core.grayLighter
	    }
	  };
	})(SingleDatePicker);

/***/ },
/* 2977 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CalendarDay = __webpack_require__(471);
	
	Object.defineProperty(exports, 'CalendarDay', {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _interopRequireDefault(_CalendarDay)['default'];
	    }
	
	    return get;
	  }()
	});
	
	var _CalendarMonth = __webpack_require__(849);
	
	Object.defineProperty(exports, 'CalendarMonth', {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _interopRequireDefault(_CalendarMonth)['default'];
	    }
	
	    return get;
	  }()
	});
	
	var _CalendarMonthGrid = __webpack_require__(850);
	
	Object.defineProperty(exports, 'CalendarMonthGrid', {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _interopRequireDefault(_CalendarMonthGrid)['default'];
	    }
	
	    return get;
	  }()
	});
	
	var _DateRangePicker = __webpack_require__(2972);
	
	Object.defineProperty(exports, 'DateRangePicker', {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _interopRequireDefault(_DateRangePicker)['default'];
	    }
	
	    return get;
	  }()
	});
	
	var _DateRangePickerInput = __webpack_require__(852);
	
	Object.defineProperty(exports, 'DateRangePickerInput', {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _interopRequireDefault(_DateRangePickerInput)['default'];
	    }
	
	    return get;
	  }()
	});
	
	var _DateRangePickerInputController = __webpack_require__(853);
	
	Object.defineProperty(exports, 'DateRangePickerInputController', {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _interopRequireDefault(_DateRangePickerInputController)['default'];
	    }
	
	    return get;
	  }()
	});
	
	var _DateRangePickerShape = __webpack_require__(860);
	
	Object.defineProperty(exports, 'DateRangePickerShape', {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _interopRequireDefault(_DateRangePickerShape)['default'];
	    }
	
	    return get;
	  }()
	});
	
	var _DayPicker = __webpack_require__(472);
	
	Object.defineProperty(exports, 'DayPicker', {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _interopRequireDefault(_DayPicker)['default'];
	    }
	
	    return get;
	  }()
	});
	
	var _DayPickerRangeController = __webpack_require__(854);
	
	Object.defineProperty(exports, 'DayPickerRangeController', {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _interopRequireDefault(_DayPickerRangeController)['default'];
	    }
	
	    return get;
	  }()
	});
	
	var _DayPickerSingleDateController = __webpack_require__(855);
	
	Object.defineProperty(exports, 'DayPickerSingleDateController', {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _interopRequireDefault(_DayPickerSingleDateController)['default'];
	    }
	
	    return get;
	  }()
	});
	
	var _OutsideClickHandler = __webpack_require__(338);
	
	Object.defineProperty(exports, 'OutsideClickHandler', {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _interopRequireDefault(_OutsideClickHandler)['default'];
	    }
	
	    return get;
	  }()
	});
	
	var _SingleDatePicker = __webpack_require__(2976);
	
	Object.defineProperty(exports, 'SingleDatePicker', {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _interopRequireDefault(_SingleDatePicker)['default'];
	    }
	
	    return get;
	  }()
	});
	
	var _SingleDatePickerInput = __webpack_require__(858);
	
	Object.defineProperty(exports, 'SingleDatePickerInput', {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _interopRequireDefault(_SingleDatePickerInput)['default'];
	    }
	
	    return get;
	  }()
	});
	
	var _SingleDatePickerShape = __webpack_require__(863);
	
	Object.defineProperty(exports, 'SingleDatePickerShape', {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _interopRequireDefault(_SingleDatePickerShape)['default'];
	    }
	
	    return get;
	  }()
	});
	
	var _isInclusivelyAfterDay = __webpack_require__(213);
	
	Object.defineProperty(exports, 'isInclusivelyAfterDay', {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _interopRequireDefault(_isInclusivelyAfterDay)['default'];
	    }
	
	    return get;
	  }()
	});
	
	var _isInclusivelyBeforeDay = __webpack_require__(2984);
	
	Object.defineProperty(exports, 'isInclusivelyBeforeDay', {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _interopRequireDefault(_isInclusivelyBeforeDay)['default'];
	    }
	
	    return get;
	  }()
	});
	
	var _isNextDay = __webpack_require__(872);
	
	Object.defineProperty(exports, 'isNextDay', {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _interopRequireDefault(_isNextDay)['default'];
	    }
	
	    return get;
	  }()
	});
	
	var _isSameDay = __webpack_require__(214);
	
	Object.defineProperty(exports, 'isSameDay', {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _interopRequireDefault(_isSameDay)['default'];
	    }
	
	    return get;
	  }()
	});
	
	var _toISODateString = __webpack_require__(340);
	
	Object.defineProperty(exports, 'toISODateString', {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _interopRequireDefault(_toISODateString)['default'];
	    }
	
	    return get;
	  }()
	});
	
	var _toLocalizedDateString = __webpack_require__(475);
	
	Object.defineProperty(exports, 'toLocalizedDateString', {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _interopRequireDefault(_toLocalizedDateString)['default'];
	    }
	
	    return get;
	  }()
	});
	
	var _toMomentObject = __webpack_require__(215);
	
	Object.defineProperty(exports, 'toMomentObject', {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _interopRequireDefault(_toMomentObject)['default'];
	    }
	
	    return get;
	  }()
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/***/ },
/* 2978 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _registerCSSInterfaceWithDefaultTheme = __webpack_require__(2986);
	
	var _registerCSSInterfaceWithDefaultTheme2 = _interopRequireDefault(_registerCSSInterfaceWithDefaultTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	(0, _registerCSSInterfaceWithDefaultTheme2['default'])();

/***/ },
/* 2979 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = getActiveElement;
	function getActiveElement() {
	  return typeof document !== 'undefined' && document.activeElement;
	}

/***/ },
/* 2980 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = getCalendarMonthWeeks;
	
	var _moment = __webpack_require__(9);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _constants = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getCalendarMonthWeeks(month, enableOutsideDays) {
	  var firstDayOfWeek = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _moment2['default'].localeData().firstDayOfWeek();
	
	  if (!_moment2['default'].isMoment(month) || !month.isValid()) {
	    throw new TypeError('`month` must be a valid moment object');
	  }
	  if (_constants.WEEKDAYS.indexOf(firstDayOfWeek) === -1) {
	    throw new TypeError('`firstDayOfWeek` must be an integer between 0 and 6');
	  }
	
	  // set utc offset to get correct dates in future (when timezone changes)
	  var firstOfMonth = month.clone().startOf('month').hour(12);
	  var lastOfMonth = month.clone().endOf('month').hour(12);
	
	  // calculate the exact first and last days to fill the entire matrix
	  // (considering days outside month)
	  var prevDays = (firstOfMonth.day() + 7 - firstDayOfWeek) % 7;
	  var nextDays = (firstDayOfWeek + 6 - lastOfMonth.day()) % 7;
	  var firstDay = firstOfMonth.clone().subtract(prevDays, 'day');
	  var lastDay = lastOfMonth.clone().add(nextDays, 'day');
	
	  var totalDays = lastDay.diff(firstDay, 'days') + 1;
	
	  var currentDay = firstDay.clone();
	  var weeksInMonth = [];
	
	  for (var i = 0; i < totalDays; i += 1) {
	    if (i % 7 === 0) {
	      weeksInMonth.push([]);
	    }
	
	    var day = null;
	    if (i >= prevDays && i < totalDays - nextDays || enableOutsideDays) {
	      day = currentDay.clone();
	    }
	
	    weeksInMonth[weeksInMonth.length - 1].push(day);
	
	    currentDay.add(1, 'day');
	  }
	
	  return weeksInMonth;
	}

/***/ },
/* 2981 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = getPhrase;
	function getPhrase(phrase, args) {
	  if (typeof phrase === 'string') return phrase;
	
	  if (typeof phrase === 'function') {
	    return phrase(args);
	  }
	
	  return '';
	}

/***/ },
/* 2982 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = getSelectedDateOffset;
	var defaultModifier = function defaultModifier(day) {
	  return day;
	};
	
	function getSelectedDateOffset(fn, day) {
	  var modifier = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultModifier;
	
	  if (!fn) return day;
	  return modifier(fn(day.clone()));
	}

/***/ },
/* 2983 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = getTransformStyles;
	function getTransformStyles(transformValue) {
	  return {
	    transform: transformValue,
	    msTransform: transformValue,
	    MozTransform: transformValue,
	    WebkitTransform: transformValue
	  };
	}

/***/ },
/* 2984 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = isInclusivelyBeforeDay;
	
	var _moment = __webpack_require__(9);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _isAfterDay = __webpack_require__(262);
	
	var _isAfterDay2 = _interopRequireDefault(_isAfterDay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function isInclusivelyBeforeDay(a, b) {
	  if (!_moment2['default'].isMoment(a) || !_moment2['default'].isMoment(b)) return false;
	  return !(0, _isAfterDay2['default'])(a, b);
	}

/***/ },
/* 2985 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = isTransitionEndSupported;
	function isTransitionEndSupported() {
	  return !!(typeof window !== 'undefined' && 'TransitionEvent' in window);
	}

/***/ },
/* 2986 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = registerCSSInterfaceWithDefaultTheme;
	
	var _reactWithStylesInterfaceCss = __webpack_require__(3111);
	
	var _reactWithStylesInterfaceCss2 = _interopRequireDefault(_reactWithStylesInterfaceCss);
	
	var _registerInterfaceWithDefaultTheme = __webpack_require__(2987);
	
	var _registerInterfaceWithDefaultTheme2 = _interopRequireDefault(_registerInterfaceWithDefaultTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function registerCSSInterfaceWithDefaultTheme() {
	  (0, _registerInterfaceWithDefaultTheme2['default'])(_reactWithStylesInterfaceCss2['default']);
	}

/***/ },
/* 2987 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = registerInterfaceWithDefaultTheme;
	
	var _ThemedStyleSheet = __webpack_require__(918);
	
	var _ThemedStyleSheet2 = _interopRequireDefault(_ThemedStyleSheet);
	
	var _DefaultTheme = __webpack_require__(864);
	
	var _DefaultTheme2 = _interopRequireDefault(_DefaultTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function registerInterfaceWithDefaultTheme(reactWithStylesInterface) {
	  _ThemedStyleSheet2['default'].registerInterface(reactWithStylesInterface);
	  _ThemedStyleSheet2['default'].registerTheme(_DefaultTheme2['default']);
	}

/***/ },
/* 2988 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ },
/* 2989 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(44);
	
	var focusNode = __webpack_require__(705);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ },
/* 2990 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(219);
	var ExecutionEnvironment = __webpack_require__(53);
	var FallbackCompositionState = __webpack_require__(2997);
	var SyntheticCompositionEvent = __webpack_require__(3030);
	var SyntheticInputEvent = __webpack_require__(3033);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ },
/* 2991 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(873);
	var ExecutionEnvironment = __webpack_require__(53);
	var ReactInstrumentation = __webpack_require__(81);
	
	var camelizeStyleName = __webpack_require__(2767);
	var dangerousStyleValue = __webpack_require__(3039);
	var hyphenateStyleName = __webpack_require__(2774);
	var memoizeStringOnly = __webpack_require__(2778);
	var warning = __webpack_require__(26);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Style property values shouldn\'t contain a semicolon.%s ' + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var styleValue = styles[styleName];
	      if (false) {
	        warnValidStyle(styleName, styleValue, component);
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      if (false) {
	        warnValidStyle(styleName, styles[styleName], component);
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = CSSPropertyOperations;

/***/ },
/* 2992 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(218);
	var EventPropagators = __webpack_require__(219);
	var ExecutionEnvironment = __webpack_require__(53);
	var ReactDOMComponentTree = __webpack_require__(44);
	var ReactUpdates = __webpack_require__(89);
	var SyntheticEvent = __webpack_require__(111);
	
	var getEventTarget = __webpack_require__(488);
	var isEventSupported = __webpack_require__(490);
	var isTextInputElement = __webpack_require__(896);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	var activeElementValue = null;
	var activeElementValueProp = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	  // IE10+ fire input events to often, such when a placeholder
	  // changes or when an input with a placeholder is focused.
	  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 11);
	}
	
	/**
	 * (For IE <=11) Replacement getter/setter for the `value` property that gets
	 * set on the active element.
	 */
	var newValueProp = {
	  get: function () {
	    return activeElementValueProp.get.call(this);
	  },
	  set: function (val) {
	    // Cast to a string so we can do equality checks.
	    activeElementValue = '' + val;
	    activeElementValueProp.set.call(this, val);
	  }
	};
	
	/**
	 * (For IE <=11) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElementValue = target.value;
	  activeElementValueProp = Object.getOwnPropertyDescriptor(target.constructor.prototype, 'value');
	
	  // Not guarded in a canDefineProperty check: IE8 supports defineProperty only
	  // on DOM elements
	  Object.defineProperty(activeElement, 'value', newValueProp);
	  if (activeElement.attachEvent) {
	    activeElement.attachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.addEventListener('propertychange', handlePropertyChange, false);
	  }
	}
	
	/**
	 * (For IE <=11) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	
	  // delete restores the original property definition
	  delete activeElement.value;
	
	  if (activeElement.detachEvent) {
	    activeElement.detachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.removeEventListener('propertychange', handlePropertyChange, false);
	  }
	
	  activeElement = null;
	  activeElementInst = null;
	  activeElementValue = null;
	  activeElementValueProp = null;
	}
	
	/**
	 * (For IE <=11) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  var value = nativeEvent.srcElement.value;
	  if (value === activeElementValue) {
	    return;
	  }
	  activeElementValue = value;
	
	  manualDispatchChangeEvent(nativeEvent);
	}
	
	/**
	 * If a `change` event should be fired, returns the target's ID.
	 */
	function getTargetInstForInputEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topInput') {
	    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
	    // what we want so fall through here and trigger an abstract event
	    return targetInst;
	  }
	}
	
	function handleEventsForInputEventIE(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9-11, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventIE(topLevelType, targetInst) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    if (activeElement && activeElement.value !== activeElementValue) {
	      activeElementValue = activeElement.value;
	      return activeElementInst;
	    }
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  return elem.nodeName && elem.nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topClick') {
	    return targetInst;
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventIE;
	        handleEventFunc = handleEventsForInputEventIE;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst);
	      if (inst) {
	        var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, nativeEventTarget);
	        event.type = 'change';
	        EventPropagators.accumulateTwoPhaseDispatches(event);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	  }
	
	};
	
	module.exports = ChangeEventPlugin;

/***/ },
/* 2993 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(32);
	
	var DOMLazyTree = __webpack_require__(216);
	var ExecutionEnvironment = __webpack_require__(53);
	
	var createNodesFromMarkup = __webpack_require__(2770);
	var emptyFunction = __webpack_require__(80);
	var invariant = __webpack_require__(19);
	
	var Danger = {
	
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	
	};
	
	module.exports = Danger;

/***/ },
/* 2994 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ },
/* 2995 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(219);
	var ReactDOMComponentTree = __webpack_require__(44);
	var SyntheticMouseEvent = __webpack_require__(344);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ },
/* 2996 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Types of raw signals from the browser caught at the top level.
	 */
	var topLevelTypes = {
	  topAbort: null,
	  topAnimationEnd: null,
	  topAnimationIteration: null,
	  topAnimationStart: null,
	  topBlur: null,
	  topCanPlay: null,
	  topCanPlayThrough: null,
	  topChange: null,
	  topClick: null,
	  topCompositionEnd: null,
	  topCompositionStart: null,
	  topCompositionUpdate: null,
	  topContextMenu: null,
	  topCopy: null,
	  topCut: null,
	  topDoubleClick: null,
	  topDrag: null,
	  topDragEnd: null,
	  topDragEnter: null,
	  topDragExit: null,
	  topDragLeave: null,
	  topDragOver: null,
	  topDragStart: null,
	  topDrop: null,
	  topDurationChange: null,
	  topEmptied: null,
	  topEncrypted: null,
	  topEnded: null,
	  topError: null,
	  topFocus: null,
	  topInput: null,
	  topInvalid: null,
	  topKeyDown: null,
	  topKeyPress: null,
	  topKeyUp: null,
	  topLoad: null,
	  topLoadedData: null,
	  topLoadedMetadata: null,
	  topLoadStart: null,
	  topMouseDown: null,
	  topMouseMove: null,
	  topMouseOut: null,
	  topMouseOver: null,
	  topMouseUp: null,
	  topPaste: null,
	  topPause: null,
	  topPlay: null,
	  topPlaying: null,
	  topProgress: null,
	  topRateChange: null,
	  topReset: null,
	  topScroll: null,
	  topSeeked: null,
	  topSeeking: null,
	  topSelectionChange: null,
	  topStalled: null,
	  topSubmit: null,
	  topSuspend: null,
	  topTextInput: null,
	  topTimeUpdate: null,
	  topTouchCancel: null,
	  topTouchEnd: null,
	  topTouchMove: null,
	  topTouchStart: null,
	  topTransitionEnd: null,
	  topVolumeChange: null,
	  topWaiting: null,
	  topWheel: null
	};
	
	var EventConstants = {
	  topLevelTypes: topLevelTypes
	};
	
	module.exports = EventConstants;

/***/ },
/* 2997 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(29);
	
	var PooledClass = __webpack_require__(166);
	
	var getTextContentAccessor = __webpack_require__(894);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ },
/* 2998 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(217);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {}
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 2999 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(167);
	
	var instantiateReactComponent = __webpack_require__(489);
	var KeyEscapeUtils = __webpack_require__(479);
	var shouldUpdateReactComponent = __webpack_require__(491);
	var traverseAllChildren = __webpack_require__(898);
	var warning = __webpack_require__(26);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(498);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID // 0 in production and for roots
	  ) {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID // 0 in production and for roots
	  ) {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(164)))

/***/ },
/* 3000 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(476);
	var ReactDOMIDOperations = __webpack_require__(3005);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 3001 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(32),
	    _assign = __webpack_require__(29);
	
	var React = __webpack_require__(105);
	var ReactComponentEnvironment = __webpack_require__(481);
	var ReactCurrentOwner = __webpack_require__(113);
	var ReactErrorUtils = __webpack_require__(482);
	var ReactInstanceMap = __webpack_require__(220);
	var ReactInstrumentation = __webpack_require__(81);
	var ReactNodeTypes = __webpack_require__(888);
	var ReactReconciler = __webpack_require__(167);
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__(203);
	var invariant = __webpack_require__(19);
	var shallowEqual = __webpack_require__(252);
	var shouldUpdateReactComponent = __webpack_require__(491);
	var warning = __webpack_require__(26);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + 'up the same props that your component\'s constructor was passed.', componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'childContext');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	
	};
	
	module.exports = ReactCompositeComponent;

/***/ },
/* 3002 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(32),
	    _assign = __webpack_require__(29);
	
	var AutoFocusUtils = __webpack_require__(2989);
	var CSSPropertyOperations = __webpack_require__(2991);
	var DOMLazyTree = __webpack_require__(216);
	var DOMNamespaces = __webpack_require__(477);
	var DOMProperty = __webpack_require__(217);
	var DOMPropertyOperations = __webpack_require__(875);
	var EventPluginHub = __webpack_require__(218);
	var EventPluginRegistry = __webpack_require__(478);
	var ReactBrowserEventEmitter = __webpack_require__(343);
	var ReactDOMComponentFlags = __webpack_require__(877);
	var ReactDOMComponentTree = __webpack_require__(44);
	var ReactDOMInput = __webpack_require__(3006);
	var ReactDOMOption = __webpack_require__(3007);
	var ReactDOMSelect = __webpack_require__(879);
	var ReactDOMTextarea = __webpack_require__(3011);
	var ReactInstrumentation = __webpack_require__(81);
	var ReactMultiChild = __webpack_require__(3017);
	var ReactServerRenderingTransaction = __webpack_require__(889);
	
	var emptyFunction = __webpack_require__(80);
	var escapeTextContentForBrowser = __webpack_require__(346);
	var invariant = __webpack_require__(19);
	var isEventSupported = __webpack_require__(490);
	var shallowEqual = __webpack_require__(252);
	var validateDOMNesting = __webpack_require__(492);
	var warning = __webpack_require__(26);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { 'string': true, 'number': true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), 'This browser doesn\'t support the `onScroll` event') : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  'area': true,
	  'base': true,
	  'br': true,
	  'col': true,
	  'embed': true,
	  'hr': true,
	  'img': true,
	  'input': true,
	  'keygen': true,
	  'link': true,
	  'meta': true,
	  'param': true,
	  'source': true,
	  'track': true,
	  'wbr': true
	};
	
	var newlineEatingTags = {
	  'listing': true,
	  'pre': true,
	  'textarea': true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  'menuitem': true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	        DOMLazyTree.queueText(lazyTree, contentToUse);
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ },
/* 3003 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(29);
	
	var DOMLazyTree = __webpack_require__(216);
	var ReactDOMComponentTree = __webpack_require__(44);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ },
/* 3004 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ },
/* 3005 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(476);
	var ReactDOMComponentTree = __webpack_require__(44);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ },
/* 3006 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(32),
	    _assign = __webpack_require__(29);
	
	var DOMPropertyOperations = __webpack_require__(875);
	var LinkedValueUtils = __webpack_require__(480);
	var ReactDOMComponentTree = __webpack_require__(44);
	var ReactUpdates = __webpack_require__(89);
	
	var invariant = __webpack_require__(19);
	var warning = __webpack_require__(26);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	
	    if (false) {
	      inst._wrapperState.controlled = isControlled(props);
	    }
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        node.defaultValue = '' + props.defaultValue;
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ },
/* 3007 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(29);
	
	var React = __webpack_require__(105);
	var ReactDOMComponentTree = __webpack_require__(44);
	var ReactDOMSelect = __webpack_require__(879);
	
	var warning = __webpack_require__(26);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	
	};
	
	module.exports = ReactDOMOption;

/***/ },
/* 3008 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(53);
	
	var getNodeForCharacterOffset = __webpack_require__(3045);
	var getTextContentAccessor = __webpack_require__(894);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ },
/* 3009 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDefaultInjection = __webpack_require__(881);
	var ReactServerRendering = __webpack_require__(3023);
	var ReactVersion = __webpack_require__(890);
	
	ReactDefaultInjection.inject();
	
	var ReactDOMServer = {
	  renderToString: ReactServerRendering.renderToString,
	  renderToStaticMarkup: ReactServerRendering.renderToStaticMarkup,
	  version: ReactVersion
	};
	
	module.exports = ReactDOMServer;

/***/ },
/* 3010 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(32),
	    _assign = __webpack_require__(29);
	
	var DOMChildrenOperations = __webpack_require__(476);
	var DOMLazyTree = __webpack_require__(216);
	var ReactDOMComponentTree = __webpack_require__(44);
	
	var escapeTextContentForBrowser = __webpack_require__(346);
	var invariant = __webpack_require__(19);
	var validateDOMNesting = __webpack_require__(492);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	
	});
	
	module.exports = ReactDOMTextComponent;

/***/ },
/* 3011 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(32),
	    _assign = __webpack_require__(29);
	
	var LinkedValueUtils = __webpack_require__(480);
	var ReactDOMComponentTree = __webpack_require__(44);
	var ReactUpdates = __webpack_require__(89);
	
	var invariant = __webpack_require__(19);
	var warning = __webpack_require__(26);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Warning: node.value may be the empty string at this point (IE11) if placeholder is set.
	    node.value = node.textContent; // Detach value from defaultValue
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ },
/* 3012 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(32);
	
	var invariant = __webpack_require__(19);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ },
/* 3013 */
921,
/* 3014 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(218);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ },
/* 3015 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(29);
	
	var EventListener = __webpack_require__(704);
	var ExecutionEnvironment = __webpack_require__(53);
	var PooledClass = __webpack_require__(166);
	var ReactDOMComponentTree = __webpack_require__(44);
	var ReactUpdates = __webpack_require__(89);
	
	var getEventTarget = __webpack_require__(488);
	var getUnboundedScrollPosition = __webpack_require__(2772);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ },
/* 3016 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(217);
	var EventPluginHub = __webpack_require__(218);
	var EventPluginUtils = __webpack_require__(342);
	var ReactComponentEnvironment = __webpack_require__(481);
	var ReactEmptyComponent = __webpack_require__(882);
	var ReactBrowserEventEmitter = __webpack_require__(343);
	var ReactHostComponent = __webpack_require__(884);
	var ReactUpdates = __webpack_require__(89);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ },
/* 3017 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(32);
	
	var ReactComponentEnvironment = __webpack_require__(481);
	var ReactInstanceMap = __webpack_require__(220);
	var ReactInstrumentation = __webpack_require__(81);
	
	var ReactCurrentOwner = __webpack_require__(113);
	var ReactReconciler = __webpack_require__(167);
	var ReactChildReconciler = __webpack_require__(2999);
	
	var emptyFunction = __webpack_require__(80);
	var flattenChildren = __webpack_require__(3041);
	var invariant = __webpack_require__(19);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	
	  }
	
	};
	
	module.exports = ReactMultiChild;

/***/ },
/* 3018 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(32);
	
	var invariant = __webpack_require__(19);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	
	};
	
	module.exports = ReactOwner;

/***/ },
/* 3019 */
3119,
/* 3020 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(29);
	
	var CallbackQueue = __webpack_require__(874);
	var PooledClass = __webpack_require__(166);
	var ReactBrowserEventEmitter = __webpack_require__(343);
	var ReactInputSelection = __webpack_require__(885);
	var ReactInstrumentation = __webpack_require__(81);
	var Transaction = __webpack_require__(345);
	var ReactUpdateQueue = __webpack_require__(483);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ },
/* 3021 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(3018);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ },
/* 3022 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactServerBatchingStrategy = {
	  isBatchingUpdates: false,
	  batchedUpdates: function (callback) {
	    // Don't do anything here. During the server rendering we don't want to
	    // schedule any updates. We will simply ignore them.
	  }
	};
	
	module.exports = ReactServerBatchingStrategy;

/***/ },
/* 3023 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(32);
	
	var React = __webpack_require__(105);
	var ReactDOMContainerInfo = __webpack_require__(878);
	var ReactDefaultBatchingStrategy = __webpack_require__(880);
	var ReactInstrumentation = __webpack_require__(81);
	var ReactMarkupChecksum = __webpack_require__(886);
	var ReactReconciler = __webpack_require__(167);
	var ReactServerBatchingStrategy = __webpack_require__(3022);
	var ReactServerRenderingTransaction = __webpack_require__(889);
	var ReactUpdates = __webpack_require__(89);
	
	var emptyObject = __webpack_require__(203);
	var instantiateReactComponent = __webpack_require__(489);
	var invariant = __webpack_require__(19);
	
	var pendingTransactions = 0;
	
	/**
	 * @param {ReactElement} element
	 * @return {string} the HTML markup
	 */
	function renderToStringImpl(element, makeStaticMarkup) {
	  var transaction;
	  try {
	    ReactUpdates.injection.injectBatchingStrategy(ReactServerBatchingStrategy);
	
	    transaction = ReactServerRenderingTransaction.getPooled(makeStaticMarkup);
	
	    pendingTransactions++;
	
	    return transaction.perform(function () {
	      var componentInstance = instantiateReactComponent(element, true);
	      var markup = ReactReconciler.mountComponent(componentInstance, transaction, null, ReactDOMContainerInfo(), emptyObject, 0 /* parentDebugID */
	      );
	      if (false) {
	        ReactInstrumentation.debugTool.onUnmountComponent(componentInstance._debugID);
	      }
	      if (!makeStaticMarkup) {
	        markup = ReactMarkupChecksum.addChecksumToMarkup(markup);
	      }
	      return markup;
	    }, null);
	  } finally {
	    pendingTransactions--;
	    ReactServerRenderingTransaction.release(transaction);
	    // Revert to the DOM batching strategy since these two renderers
	    // currently share these stateful modules.
	    if (!pendingTransactions) {
	      ReactUpdates.injection.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	    }
	  }
	}
	
	/**
	 * Render a ReactElement to its initial HTML. This should only be used on the
	 * server.
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdomserver.rendertostring
	 */
	function renderToString(element) {
	  !React.isValidElement(element) ?  false ? invariant(false, 'renderToString(): You must pass a valid ReactElement.') : _prodInvariant('46') : void 0;
	  return renderToStringImpl(element, false);
	}
	
	/**
	 * Similar to renderToString, except this doesn't create extra DOM attributes
	 * such as data-react-id that React uses internally.
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdomserver.rendertostaticmarkup
	 */
	function renderToStaticMarkup(element) {
	  !React.isValidElement(element) ?  false ? invariant(false, 'renderToStaticMarkup(): You must pass a valid ReactElement.') : _prodInvariant('47') : void 0;
	  return renderToStringImpl(element, true);
	}
	
	module.exports = {
	  renderToString: renderToString,
	  renderToStaticMarkup: renderToStaticMarkup
	};

/***/ },
/* 3024 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(483);
	
	var warning = __webpack_require__(26);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ },
/* 3025 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ },
/* 3026 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(219);
	var ExecutionEnvironment = __webpack_require__(53);
	var ReactDOMComponentTree = __webpack_require__(44);
	var ReactInputSelection = __webpack_require__(885);
	var SyntheticEvent = __webpack_require__(111);
	
	var getActiveElement = __webpack_require__(706);
	var isTextInputElement = __webpack_require__(896);
	var shallowEqual = __webpack_require__(252);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ },
/* 3027 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(32);
	
	var EventListener = __webpack_require__(704);
	var EventPropagators = __webpack_require__(219);
	var ReactDOMComponentTree = __webpack_require__(44);
	var SyntheticAnimationEvent = __webpack_require__(3028);
	var SyntheticClipboardEvent = __webpack_require__(3029);
	var SyntheticEvent = __webpack_require__(111);
	var SyntheticFocusEvent = __webpack_require__(3032);
	var SyntheticKeyboardEvent = __webpack_require__(3034);
	var SyntheticMouseEvent = __webpack_require__(344);
	var SyntheticDragEvent = __webpack_require__(3031);
	var SyntheticTouchEvent = __webpack_require__(3035);
	var SyntheticTransitionEvent = __webpack_require__(3036);
	var SyntheticUIEvent = __webpack_require__(221);
	var SyntheticWheelEvent = __webpack_require__(3037);
	
	var emptyFunction = __webpack_require__(80);
	var getEventCharCode = __webpack_require__(486);
	var invariant = __webpack_require__(19);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	
	};
	
	module.exports = SimpleEventPlugin;

/***/ },
/* 3028 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(111);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ },
/* 3029 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(111);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ },
/* 3030 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(111);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ },
/* 3031 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(344);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ },
/* 3032 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(221);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ },
/* 3033 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(111);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ },
/* 3034 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(221);
	
	var getEventCharCode = __webpack_require__(486);
	var getEventKey = __webpack_require__(3042);
	var getEventModifierState = __webpack_require__(487);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ },
/* 3035 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(221);
	
	var getEventModifierState = __webpack_require__(487);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ },
/* 3036 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(111);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ },
/* 3037 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(344);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX :
	    // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY :
	    // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY :
	    // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ },
/* 3038 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ },
/* 3039 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(873);
	var warning = __webpack_require__(26);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ },
/* 3040 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(32);
	
	var ReactCurrentOwner = __webpack_require__(113);
	var ReactDOMComponentTree = __webpack_require__(44);
	var ReactInstanceMap = __webpack_require__(220);
	
	var getHostComponentFromComposite = __webpack_require__(893);
	var invariant = __webpack_require__(19);
	var warning = __webpack_require__(26);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ },
/* 3041 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(479);
	var traverseAllChildren = __webpack_require__(898);
	var warning = __webpack_require__(26);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(498);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(164)))

/***/ },
/* 3042 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(486);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  'Esc': 'Escape',
	  'Spacebar': ' ',
	  'Left': 'ArrowLeft',
	  'Up': 'ArrowUp',
	  'Right': 'ArrowRight',
	  'Down': 'ArrowDown',
	  'Del': 'Delete',
	  'Win': 'OS',
	  'Menu': 'ContextMenu',
	  'Apps': 'ContextMenu',
	  'Scroll': 'ScrollLock',
	  'MozPrintableKey': 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
	  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ },
/* 3043 */
925,
/* 3044 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ },
/* 3045 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ },
/* 3046 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(346);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 3047 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(887);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 3048 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(3009);


/***/ },
/* 3049 */
/***/ function(module, exports) {

	exports.__esModule = true;
	var TAG_NAMES = exports.TAG_NAMES = {
	    HTML: "htmlAttributes",
	    TITLE: "title",
	    BASE: "base",
	    META: "meta",
	    LINK: "link",
	    SCRIPT: "script",
	    NOSCRIPT: "noscript",
	    STYLE: "style"
	};
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    NAME: "name",
	    CHARSET: "charset",
	    HTTPEQUIV: "http-equiv",
	    REL: "rel",
	    HREF: "href",
	    PROPERTY: "property",
	    SRC: "src",
	    INNER_HTML: "innerHTML",
	    CSS_TEXT: "cssText"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    "charset": "charSet",
	    "http-equiv": "httpEquiv"
	};

/***/ },
/* 3050 */
/***/ function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PlainComponent = function (_React$Component) {
	    _inherits(PlainComponent, _React$Component);
	
	    function PlainComponent() {
	        _classCallCheck(this, PlainComponent);
	
	        return _possibleConstructorReturn(this, (PlainComponent.__proto__ || Object.getPrototypeOf(PlainComponent)).apply(this, arguments));
	    }
	
	    _createClass(PlainComponent, [{
	        key: "render",
	        value: function render() {
	            return null;
	        }
	    }]);
	
	    return PlainComponent;
	}(_react2.default.Component);
	
	exports.default = PlainComponent;
	module.exports = exports["default"];

/***/ },
/* 3051 */
/***/ function(module, exports, __webpack_require__) {

	!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.en=a())}(this,function(){"use strict";var e=[{locale:"en",pluralRuleFunction:function(e,a){var n=String(e).split("."),l=!n[1],o=Number(n[0])==e,t=o&&n[0].slice(-1),r=o&&n[0].slice(-2);return a?1==t&&11!=r?"one":2==t&&12!=r?"two":3==t&&13!=r?"few":"other":1==e&&l?"one":"other"},fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},minute:{displayName:"minute",relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}}}},{locale:"en-001",parentLocale:"en"},{locale:"en-150",parentLocale:"en-001"},{locale:"en-AG",parentLocale:"en-001"},{locale:"en-AI",parentLocale:"en-001"},{locale:"en-AS",parentLocale:"en"},{locale:"en-AT",parentLocale:"en-150"},{locale:"en-AU",parentLocale:"en-001"},{locale:"en-BB",parentLocale:"en-001"},{locale:"en-BE",parentLocale:"en-001"},{locale:"en-BI",parentLocale:"en"},{locale:"en-BM",parentLocale:"en-001"},{locale:"en-BS",parentLocale:"en-001"},{locale:"en-BW",parentLocale:"en-001"},{locale:"en-BZ",parentLocale:"en-001"},{locale:"en-CA",parentLocale:"en-001"},{locale:"en-CC",parentLocale:"en-001"},{locale:"en-CH",parentLocale:"en-150"},{locale:"en-CK",parentLocale:"en-001"},{locale:"en-CM",parentLocale:"en-001"},{locale:"en-CX",parentLocale:"en-001"},{locale:"en-CY",parentLocale:"en-001"},{locale:"en-DE",parentLocale:"en-150"},{locale:"en-DG",parentLocale:"en-001"},{locale:"en-DK",parentLocale:"en-150"},{locale:"en-DM",parentLocale:"en-001"},{locale:"en-Dsrt",pluralRuleFunction:function(e,a){return"other"},fields:{year:{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},month:{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},day:{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},hour:{displayName:"Hour",relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},minute:{displayName:"Minute",relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},second:{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}}}},{locale:"en-ER",parentLocale:"en-001"},{locale:"en-FI",parentLocale:"en-150"},{locale:"en-FJ",parentLocale:"en-001"},{locale:"en-FK",parentLocale:"en-001"},{locale:"en-FM",parentLocale:"en-001"},{locale:"en-GB",parentLocale:"en-001"},{locale:"en-GD",parentLocale:"en-001"},{locale:"en-GG",parentLocale:"en-001"},{locale:"en-GH",parentLocale:"en-001"},{locale:"en-GI",parentLocale:"en-001"},{locale:"en-GM",parentLocale:"en-001"},{locale:"en-GU",parentLocale:"en"},{locale:"en-GY",parentLocale:"en-001"},{locale:"en-HK",parentLocale:"en-001"},{locale:"en-IE",parentLocale:"en-001"},{locale:"en-IL",parentLocale:"en-001"},{locale:"en-IM",parentLocale:"en-001"},{locale:"en-IN",parentLocale:"en-001"},{locale:"en-IO",parentLocale:"en-001"},{locale:"en-JE",parentLocale:"en-001"},{locale:"en-JM",parentLocale:"en-001"},{locale:"en-KE",parentLocale:"en-001"},{locale:"en-KI",parentLocale:"en-001"},{locale:"en-KN",parentLocale:"en-001"},{locale:"en-KY",parentLocale:"en-001"},{locale:"en-LC",parentLocale:"en-001"},{locale:"en-LR",parentLocale:"en-001"},{locale:"en-LS",parentLocale:"en-001"},{locale:"en-MG",parentLocale:"en-001"},{locale:"en-MH",parentLocale:"en"},{locale:"en-MO",parentLocale:"en-001"},{locale:"en-MP",parentLocale:"en"},{locale:"en-MS",parentLocale:"en-001"},{locale:"en-MT",parentLocale:"en-001"},{locale:"en-MU",parentLocale:"en-001"},{locale:"en-MW",parentLocale:"en-001"},{locale:"en-MY",parentLocale:"en-001"},{locale:"en-NA",parentLocale:"en-001"},{locale:"en-NF",parentLocale:"en-001"},{locale:"en-NG",parentLocale:"en-001"},{locale:"en-NL",parentLocale:"en-150"},{locale:"en-NR",parentLocale:"en-001"},{locale:"en-NU",parentLocale:"en-001"},{locale:"en-NZ",parentLocale:"en-001"},{locale:"en-PG",parentLocale:"en-001"},{locale:"en-PH",parentLocale:"en-001"},{locale:"en-PK",parentLocale:"en-001"},{locale:"en-PN",parentLocale:"en-001"},{locale:"en-PR",parentLocale:"en"},{locale:"en-PW",parentLocale:"en-001"},{locale:"en-RW",parentLocale:"en-001"},{locale:"en-SB",parentLocale:"en-001"},{locale:"en-SC",parentLocale:"en-001"},{locale:"en-SD",parentLocale:"en-001"},{locale:"en-SE",parentLocale:"en-150"},{locale:"en-SG",parentLocale:"en-001"},{locale:"en-SH",parentLocale:"en-001"},{locale:"en-SI",parentLocale:"en-150"},{locale:"en-SL",parentLocale:"en-001"},{locale:"en-SS",parentLocale:"en-001"},{locale:"en-SX",parentLocale:"en-001"},{locale:"en-SZ",parentLocale:"en-001"},{locale:"en-Shaw",pluralRuleFunction:function(e,a){return"other"},fields:{year:{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},month:{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},day:{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},hour:{displayName:"Hour",relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},minute:{displayName:"Minute",relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},second:{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}}}},{locale:"en-TC",parentLocale:"en-001"},{locale:"en-TK",parentLocale:"en-001"},{locale:"en-TO",parentLocale:"en-001"},{locale:"en-TT",parentLocale:"en-001"},{locale:"en-TV",parentLocale:"en-001"},{locale:"en-TZ",parentLocale:"en-001"},{locale:"en-UG",parentLocale:"en-001"},{locale:"en-UM",parentLocale:"en"},{locale:"en-US",parentLocale:"en"},{locale:"en-VC",parentLocale:"en-001"},{locale:"en-VG",parentLocale:"en-001"},{locale:"en-VI",parentLocale:"en"},{locale:"en-VU",parentLocale:"en-001"},{locale:"en-WS",parentLocale:"en-001"},{locale:"en-ZA",parentLocale:"en-001"},{locale:"en-ZM",parentLocale:"en-001"},{locale:"en-ZW",parentLocale:"en-001"}];return e});

/***/ },
/* 3052 */
/***/ function(module, exports, __webpack_require__) {

	!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.es=a())}(this,function(){"use strict";var e=[{locale:"es",pluralRuleFunction:function(e,a){return a?"other":1==e?"one":"other"},fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-419",parentLocale:"es"},{locale:"es-AR",parentLocale:"es-419"},{locale:"es-BO",parentLocale:"es-419"},{locale:"es-CL",parentLocale:"es-419"},{locale:"es-CO",parentLocale:"es-419"},{locale:"es-CR",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-CU",parentLocale:"es-419"},{locale:"es-DO",parentLocale:"es-419",fields:{year:{displayName:"Año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"Mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"Día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"Minuto",relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"Segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-EA",parentLocale:"es"},{locale:"es-EC",parentLocale:"es-419"},{locale:"es-GQ",parentLocale:"es"},{locale:"es-GT",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-HN",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-IC",parentLocale:"es"},{locale:"es-MX",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el año próximo","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el mes próximo","-1":"el mes pasado"},relativeTime:{future:{one:"en {0} mes",other:"en {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-NI",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-PA",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-PE",parentLocale:"es-419"},{locale:"es-PH",parentLocale:"es"},{locale:"es-PR",parentLocale:"es-419"},{locale:"es-PY",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antes de ayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-SV",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-US",parentLocale:"es-419"},{locale:"es-UY",parentLocale:"es-419"},{locale:"es-VE",parentLocale:"es-419"}];return e});

/***/ },
/* 3053 */
/***/ function(module, exports, __webpack_require__) {

	!function(a,n){ true?module.exports=n():"function"==typeof define&&define.amd?define(n):(a.ReactIntlLocaleData=a.ReactIntlLocaleData||{},a.ReactIntlLocaleData.fil=n())}(this,function(){"use strict";var a=[{locale:"fil",pluralRuleFunction:function(a,n){var e=String(a).split("."),o=e[0],t=e[1]||"",s=!e[1],i=o.slice(-1),r=t.slice(-1);return n?1==a?"one":"other":s&&(1==o||2==o||3==o)||s&&4!=i&&6!=i&&9!=i||!s&&4!=r&&6!=r&&9!=r?"one":"other"},fields:{year:{displayName:"taon",relative:{0:"ngayong taon",1:"susunod na taon","-1":"nakaraang taon"},relativeTime:{future:{one:"sa {0} taon",other:"sa {0} (na) taon"},past:{one:"{0} taon ang nakalipas",other:"{0} (na) taon ang nakalipas"}}},month:{displayName:"buwan",relative:{0:"ngayong buwan",1:"susunod na buwan","-1":"nakaraang buwan"},relativeTime:{future:{one:"sa {0} buwan",other:"sa {0} (na) buwan"},past:{one:"{0} buwan ang nakalipas",other:"{0} (na) buwan ang nakalipas"}}},day:{displayName:"araw",relative:{0:"ngayong araw",1:"bukas",2:"Samakalawa","-2":"Araw bago ang kahapon","-1":"kahapon"},relativeTime:{future:{one:"sa {0} araw",other:"sa {0} (na) araw"},past:{one:"{0} araw ang nakalipas",other:"{0} (na) araw ang nakalipas"}}},hour:{displayName:"oras",relativeTime:{future:{one:"sa {0} oras",other:"sa {0} (na) oras"},past:{one:"{0} oras ang nakalipas",other:"{0} (na) oras ang nakalipas"}}},minute:{displayName:"minuto",relativeTime:{future:{one:"sa {0} minuto",other:"sa {0} (na) minuto"},past:{one:"{0} minuto ang nakalipas",other:"{0} (na) minuto ang nakalipas"}}},second:{displayName:"segundo",relative:{0:"ngayon"},relativeTime:{future:{one:"sa {0} segundo",other:"sa {0} (na) segundo"},past:{one:"{0} segundo ang nakalipas",other:"{0} (na) segundo ang nakalipas"}}}}}];return a});

/***/ },
/* 3054 */
/***/ function(module, exports, __webpack_require__) {

	!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.fr=a())}(this,function(){"use strict";var e=[{locale:"fr",pluralRuleFunction:function(e,a){return a?1==e?"one":"other":e>=0&&2>e?"one":"other"},fields:{year:{displayName:"année",relative:{0:"cette année",1:"l’année prochaine","-1":"l’année dernière"},relativeTime:{future:{one:"dans {0} an",other:"dans {0} ans"},past:{one:"il y a {0} an",other:"il y a {0} ans"}}},month:{displayName:"mois",relative:{0:"ce mois-ci",1:"le mois prochain","-1":"le mois dernier"},relativeTime:{future:{one:"dans {0} mois",other:"dans {0} mois"},past:{one:"il y a {0} mois",other:"il y a {0} mois"}}},day:{displayName:"jour",relative:{0:"aujourd’hui",1:"demain",2:"après-demain","-2":"avant-hier","-1":"hier"},relativeTime:{future:{one:"dans {0} jour",other:"dans {0} jours"},past:{one:"il y a {0} jour",other:"il y a {0} jours"}}},hour:{displayName:"heure",relativeTime:{future:{one:"dans {0} heure",other:"dans {0} heures"},past:{one:"il y a {0} heure",other:"il y a {0} heures"}}},minute:{displayName:"minute",relativeTime:{future:{one:"dans {0} minute",other:"dans {0} minutes"},past:{one:"il y a {0} minute",other:"il y a {0} minutes"}}},second:{displayName:"seconde",relative:{0:"maintenant"},relativeTime:{future:{one:"dans {0} seconde",other:"dans {0} secondes"},past:{one:"il y a {0} seconde",other:"il y a {0} secondes"}}}}},{locale:"fr-BE",parentLocale:"fr"},{locale:"fr-BF",parentLocale:"fr"},{locale:"fr-BI",parentLocale:"fr"},{locale:"fr-BJ",parentLocale:"fr"},{locale:"fr-BL",parentLocale:"fr"},{locale:"fr-CA",parentLocale:"fr",fields:{year:{displayName:"année",relative:{0:"cette année",1:"l’année prochaine","-1":"l’année dernière"},relativeTime:{future:{one:"Dans {0} an",other:"Dans {0} ans"},past:{one:"Il y a {0} an",other:"Il y a {0} ans"}}},month:{displayName:"mois",relative:{0:"ce mois-ci",1:"le mois prochain","-1":"le mois dernier"},relativeTime:{future:{one:"dans {0} mois",other:"dans {0} mois"},past:{one:"il y a {0} mois",other:"il y a {0} mois"}}},day:{displayName:"jour",relative:{0:"aujourd’hui",1:"demain",2:"après-demain","-2":"avant-hier","-1":"hier"},relativeTime:{future:{one:"dans {0} jour",other:"dans {0} jours"},past:{one:"il y a {0} jour",other:"il y a {0} jours"}}},hour:{displayName:"heure",relativeTime:{future:{one:"dans {0} heure",other:"dans {0} heures"},past:{one:"il y a {0} heure",other:"il y a {0} heures"}}},minute:{displayName:"minute",relativeTime:{future:{one:"Dans {0} minute",other:"Dans {0} minutes"},past:{one:"Il y a {0} minute",other:"Il y a {0} minutes"}}},second:{displayName:"seconde",relative:{0:"maintenant"},relativeTime:{future:{one:"dans {0} seconde",other:"dans {0} secondes"},past:{one:"il y a {0} seconde",other:"il y a {0} secondes"}}}}},{locale:"fr-CD",parentLocale:"fr"},{locale:"fr-CF",parentLocale:"fr"},{locale:"fr-CG",parentLocale:"fr"},{locale:"fr-CH",parentLocale:"fr"},{locale:"fr-CI",parentLocale:"fr"},{locale:"fr-CM",parentLocale:"fr"},{locale:"fr-DJ",parentLocale:"fr"},{locale:"fr-DZ",parentLocale:"fr"},{locale:"fr-GA",parentLocale:"fr"},{locale:"fr-GF",parentLocale:"fr"},{locale:"fr-GN",parentLocale:"fr"},{locale:"fr-GP",parentLocale:"fr"},{locale:"fr-GQ",parentLocale:"fr"},{locale:"fr-HT",parentLocale:"fr"},{locale:"fr-KM",parentLocale:"fr"},{locale:"fr-LU",parentLocale:"fr"},{locale:"fr-MA",parentLocale:"fr"},{locale:"fr-MC",parentLocale:"fr"},{locale:"fr-MF",parentLocale:"fr"},{locale:"fr-MG",parentLocale:"fr"},{locale:"fr-ML",parentLocale:"fr"},{locale:"fr-MQ",parentLocale:"fr"},{locale:"fr-MR",parentLocale:"fr"},{locale:"fr-MU",parentLocale:"fr"},{locale:"fr-NC",parentLocale:"fr"},{locale:"fr-NE",parentLocale:"fr"},{locale:"fr-PF",parentLocale:"fr"},{locale:"fr-PM",parentLocale:"fr"},{locale:"fr-RE",parentLocale:"fr"},{locale:"fr-RW",parentLocale:"fr"},{locale:"fr-SC",parentLocale:"fr"},{locale:"fr-SN",parentLocale:"fr"},{locale:"fr-SY",parentLocale:"fr"},{locale:"fr-TD",parentLocale:"fr"},{locale:"fr-TG",parentLocale:"fr"},{locale:"fr-TN",parentLocale:"fr"},{locale:"fr-VU",parentLocale:"fr"},{locale:"fr-WF",parentLocale:"fr"},{locale:"fr-YT",parentLocale:"fr"}];return e});

/***/ },
/* 3055 */
/***/ function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.ja=t())}(this,function(){"use strict";var e=[{locale:"ja",pluralRuleFunction:function(e,t){return"other"},fields:{year:{displayName:"年",relative:{0:"今年",1:"翌年","-1":"昨年"},relativeTime:{future:{other:"{0} 年後"},past:{other:"{0} 年前"}}},month:{displayName:"月",relative:{0:"今月",1:"翌月","-1":"先月"},relativeTime:{future:{other:"{0} か月後"},past:{other:"{0} か月前"}}},day:{displayName:"日",relative:{0:"今日",1:"明日",2:"明後日","-2":"一昨日","-1":"昨日"},relativeTime:{future:{other:"{0} 日後"},past:{other:"{0} 日前"}}},hour:{displayName:"時",relativeTime:{future:{other:"{0} 時間後"},past:{other:"{0} 時間前"}}},minute:{displayName:"分",relativeTime:{future:{other:"{0} 分後"},past:{other:"{0} 分前"}}},second:{displayName:"秒",relative:{0:"今すぐ"},relativeTime:{future:{other:"{0} 秒後"},past:{other:"{0} 秒前"}}}}}];return e});

/***/ },
/* 3056 */
/***/ function(module, exports, __webpack_require__) {

	!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.ru=a())}(this,function(){"use strict";var e=[{locale:"ru",pluralRuleFunction:function(e,a){var t=String(e).split("."),r=t[0],o=!t[1],n=r.slice(-1),l=r.slice(-2);return a?"other":o&&1==n&&11!=l?"one":o&&n>=2&&4>=n&&(12>l||l>14)?"few":o&&0==n||o&&n>=5&&9>=n||o&&l>=11&&14>=l?"many":"other"},fields:{year:{displayName:"год",relative:{0:"в этом году",1:"в следующем году","-1":"в прошлом году"},relativeTime:{future:{one:"через {0} год",few:"через {0} года",many:"через {0} лет",other:"через {0} года"},past:{one:"{0} год назад",few:"{0} года назад",many:"{0} лет назад",other:"{0} года назад"}}},month:{displayName:"месяц",relative:{0:"в этом месяце",1:"в следующем месяце","-1":"в прошлом месяце"},relativeTime:{future:{one:"через {0} месяц",few:"через {0} месяца",many:"через {0} месяцев",other:"через {0} месяца"},past:{one:"{0} месяц назад",few:"{0} месяца назад",many:"{0} месяцев назад",other:"{0} месяца назад"}}},day:{displayName:"день",relative:{0:"сегодня",1:"завтра",2:"послезавтра","-2":"позавчера","-1":"вчера"},relativeTime:{future:{one:"через {0} день",few:"через {0} дня",many:"через {0} дней",other:"через {0} дней"},past:{one:"{0} день назад",few:"{0} дня назад",many:"{0} дней назад",other:"{0} дня назад"}}},hour:{displayName:"час",relativeTime:{future:{one:"через {0} час",few:"через {0} часа",many:"через {0} часов",other:"через {0} часа"},past:{one:"{0} час назад",few:"{0} часа назад",many:"{0} часов назад",other:"{0} часа назад"}}},minute:{displayName:"минута",relativeTime:{future:{one:"через {0} минуту",few:"через {0} минуты",many:"через {0} минут",other:"через {0} минуты"},past:{one:"{0} минуту назад",few:"{0} минуты назад",many:"{0} минут назад",other:"{0} минуты назад"}}},second:{displayName:"секунда",relative:{0:"сейчас"},relativeTime:{future:{one:"через {0} секунду",few:"через {0} секунды",many:"через {0} секунд",other:"через {0} секунды"},past:{one:"{0} секунду назад",few:"{0} секунды назад",many:"{0} секунд назад",other:"{0} секунды назад"}}}}},{locale:"ru-BY",parentLocale:"ru"},{locale:"ru-KG",parentLocale:"ru"},{locale:"ru-KZ",parentLocale:"ru"},{locale:"ru-MD",parentLocale:"ru"},{locale:"ru-UA",parentLocale:"ru"}];return e});

/***/ },
/* 3057 */
/***/ function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.vi=t())}(this,function(){"use strict";var e=[{locale:"vi",pluralRuleFunction:function(e,t){return t&&1==e?"one":"other"},fields:{year:{displayName:"Năm",relative:{0:"năm nay",1:"năm sau","-1":"năm ngoái"},relativeTime:{future:{other:"sau {0} năm nữa"},past:{other:"{0} năm trước"}}},month:{displayName:"Tháng",relative:{0:"tháng này",1:"tháng sau","-1":"tháng trước"},relativeTime:{future:{other:"sau {0} tháng nữa"},past:{other:"{0} tháng trước"}}},day:{displayName:"Ngày",relative:{0:"Hôm nay",1:"Ngày mai",2:"Ngày kia","-2":"Hôm kia","-1":"Hôm qua"},relativeTime:{future:{other:"sau {0} ngày nữa"},past:{other:"{0} ngày trước"}}},hour:{displayName:"Giờ",relativeTime:{future:{other:"sau {0} giờ nữa"},past:{other:"{0} giờ trước"}}},minute:{displayName:"Phút",relativeTime:{future:{other:"sau {0} phút nữa"},past:{other:"{0} phút trước"}}},second:{displayName:"Giây",relative:{0:"bây giờ"},relativeTime:{future:{other:"sau {0} giây nữa"},past:{other:"{0} giây trước"}}}}}];return e});

/***/ },
/* 3058 */
/***/ function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.zh=t())}(this,function(){"use strict";var e=[{locale:"zh",pluralRuleFunction:function(e,t){return"other"},fields:{year:{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0}年后"},past:{other:"{0}年前"}}},month:{displayName:"月",relative:{0:"本月",1:"下个月","-1":"上个月"},relativeTime:{future:{other:"{0}个月后"},past:{other:"{0}个月前"}}},day:{displayName:"日",relative:{0:"今天",1:"明天",2:"后天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0}天后"},past:{other:"{0}天前"}}},hour:{displayName:"小时",relativeTime:{future:{other:"{0}小时后"},past:{other:"{0}小时前"}}},minute:{displayName:"分钟",relativeTime:{future:{other:"{0}分钟后"},past:{other:"{0}分钟前"}}},second:{displayName:"秒钟",relative:{0:"现在"},relativeTime:{future:{other:"{0}秒钟后"},past:{other:"{0}秒钟前"}}}}},{locale:"zh-Hans",parentLocale:"zh"},{locale:"zh-Hans-HK",parentLocale:"zh-Hans",fields:{year:{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0}年后"},past:{other:"{0}年前"}}},month:{displayName:"月",relative:{0:"本月",1:"下个月","-1":"上个月"},relativeTime:{future:{other:"{0}个月后"},past:{other:"{0}个月前"}}},day:{displayName:"日",relative:{0:"今天",1:"明天",2:"后天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0}天后"},past:{other:"{0}天前"}}},hour:{displayName:"小时",relativeTime:{future:{other:"{0}小时后"},past:{other:"{0}小时前"}}},minute:{displayName:"分钟",relativeTime:{future:{other:"{0}分钟后"},past:{other:"{0}分钟前"}}},second:{displayName:"秒钟",relative:{0:"现在"},relativeTime:{future:{other:"{0}秒后"},past:{other:"{0}秒前"}}}}},{locale:"zh-Hans-MO",parentLocale:"zh-Hans",fields:{year:{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0}年后"},past:{other:"{0}年前"}}},month:{displayName:"月",relative:{0:"本月",1:"下个月","-1":"上个月"},relativeTime:{future:{other:"{0}个月后"},past:{other:"{0}个月前"}}},day:{displayName:"日",relative:{0:"今天",1:"明天",2:"后天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0}天后"},past:{other:"{0}天前"}}},hour:{displayName:"小时",relativeTime:{future:{other:"{0}小时后"},past:{other:"{0}小时前"}}},minute:{displayName:"分钟",relativeTime:{future:{other:"{0}分钟后"},past:{other:"{0}分钟前"}}},second:{displayName:"秒钟",relative:{0:"现在"},relativeTime:{future:{other:"{0}秒后"},past:{other:"{0}秒前"}}}}},{locale:"zh-Hans-SG",parentLocale:"zh-Hans",fields:{year:{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0}年后"},past:{other:"{0}年前"}}},month:{displayName:"月",relative:{0:"本月",1:"下个月","-1":"上个月"},relativeTime:{future:{other:"{0}个月后"},past:{other:"{0}个月前"}}},day:{displayName:"日",relative:{0:"今天",1:"明天",2:"后天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0}天后"},past:{other:"{0}天前"}}},hour:{displayName:"小时",relativeTime:{future:{other:"{0}小时后"},past:{other:"{0}小时前"}}},minute:{displayName:"分钟",relativeTime:{future:{other:"{0}分钟后"},past:{other:"{0}分钟前"}}},second:{displayName:"秒钟",relative:{0:"现在"},relativeTime:{future:{other:"{0}秒后"},past:{other:"{0}秒前"}}}}},{locale:"zh-Hant",pluralRuleFunction:function(e,t){return"other"},fields:{year:{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0} 年後"},past:{other:"{0} 年前"}}},month:{displayName:"月",relative:{0:"本月",1:"下個月","-1":"上個月"},relativeTime:{future:{other:"{0} 個月後"},past:{other:"{0} 個月前"}}},day:{displayName:"日",relative:{0:"今天",1:"明天",2:"後天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0} 天後"},past:{other:"{0} 天前"}}},hour:{displayName:"小時",relativeTime:{future:{other:"{0} 小時後"},past:{other:"{0} 小時前"}}},minute:{displayName:"分鐘",relativeTime:{future:{other:"{0} 分鐘後"},past:{other:"{0} 分鐘前"}}},second:{displayName:"秒",relative:{0:"現在"},relativeTime:{future:{other:"{0} 秒後"},past:{other:"{0} 秒前"}}}}},{locale:"zh-Hant-HK",parentLocale:"zh-Hant",fields:{year:{displayName:"年",relative:{0:"今年",1:"下年","-1":"上年"},relativeTime:{future:{other:"{0} 年後"},past:{other:"{0} 年前"}}},month:{displayName:"月",relative:{0:"本月",1:"下個月","-1":"上個月"},relativeTime:{future:{other:"{0} 個月後"},past:{other:"{0} 個月前"}}},day:{displayName:"日",relative:{0:"今日",1:"明日",2:"後日","-2":"前日","-1":"昨日"},relativeTime:{future:{other:"{0} 日後"},past:{other:"{0} 日前"}}},hour:{displayName:"小時",relativeTime:{future:{other:"{0} 小時後"},past:{other:"{0} 小時前"}}},minute:{displayName:"分鐘",relativeTime:{future:{other:"{0} 分鐘後"},past:{other:"{0} 分鐘前"}}},second:{displayName:"秒",relative:{0:"現在"},relativeTime:{future:{other:"{0} 秒後"},past:{other:"{0} 秒前"}}}}},{locale:"zh-Hant-MO",parentLocale:"zh-Hant-HK"}];return e});

/***/ },
/* 3059 */
/***/ function(module, exports) {

	var messages = {
	  invalidPredicate: '`predicate` must be a function',
	  invalidPropValidator: '`propValidator` must be a function',
	  requiredCore: 'is marked as required',
	  invalidTypeCore: 'Invalid input type',
	  predicateFailureCore: 'Failed to succeed with predicate',
	  anonymousMessage: '<<anonymous>>',
	  baseInvalidMessage: 'Invalid ',
	};
	
	function constructPropValidatorVariations(propValidator) {
	  if (typeof propValidator !== 'function') {
	    throw new Error(messages.invalidPropValidator);
	  }
	
	  var requiredPropValidator = propValidator.bind(null, false, null);
	  requiredPropValidator.isRequired = propValidator.bind(null, true, null);
	
	  requiredPropValidator.withPredicate = function predicateApplication(predicate) {
	    if (typeof predicate !== 'function') {
	      throw new Error(messages.invalidPredicate);
	    }
	    var basePropValidator = propValidator.bind(null, false, predicate);
	    basePropValidator.isRequired = propValidator.bind(null, true, predicate);
	    return basePropValidator;
	  };
	
	  return requiredPropValidator;
	}
	
	function createInvalidRequiredErrorMessage(propName, componentName, value) {
	  return new Error(
	    'The prop `' + propName + '` ' + messages.requiredCore +
	    ' in `' + componentName + '`, but its value is `' + value + '`.'
	  );
	}
	
	function createMomentChecker(type, typeValidator, validator, momentType) {
	
	  function propValidator(
	    isRequired, // Bound parameter to indicate with the propType is required
	    predicate, // Bound parameter to allow user to add dynamic validation
	    props,
	    propName,
	    componentName,
	    location,
	    propFullName
	  ) {
	    var propValue = props[ propName ];
	    var propType = typeof propValue;
	
	    var isPropValueUndefined = typeof propValue === 'undefined';
	    var isPropValueNull = propValue === null;
	
	    if (isRequired) {
	      componentName = componentName ||  messages.anonymousMessage;
	      propFullName = propFullName || propName;
	      if (isPropValueUndefined) {
	        return createInvalidRequiredErrorMessage(propFullName, componentName, 'undefined');
	      } else if (isPropValueNull) {
	        return createInvalidRequiredErrorMessage(propFullName, componentName, 'null');
	      }
	    }
	
	    if (isPropValueUndefined || isPropValueNull) {
	      return null;
	    }
	
	    if (typeValidator && !typeValidator(propValue)) {
	      return new Error(
	        messages.invalidTypeCore + ': `' + propName + '` of type `' + propType + '` ' +
	        'supplied to `' + componentName + '`, expected `' + type + '`.'
	      );
	    }
	
	    if (! validator(propValue)) {
	      return new Error(
	        messages.baseInvalidMessage + location + ' `' + propName + '` of type `' + propType + '` ' +
	        'supplied to `' + componentName + '`, expected `' + momentType + '`.'
	      );
	    }
	
	    if (predicate && ! predicate(propValue)) {
	      var predicateName = predicate.name || messages.anonymousMessage;
	      return new Error(
	        messages.baseInvalidMessage + location + ' `' + propName + '` of type `' + propType + '` ' +
	        'supplied to `' + componentName + '`. ' + messages.predicateFailureCore + ' `' +
	        predicateName + '`.'
	      );
	    }
	
	    return null;
	
	  }
	
	  return constructPropValidatorVariations(propValidator);
	
	}
	
	module.exports = {
	  constructPropValidatorVariations: constructPropValidatorVariations,
	  createMomentChecker: createMomentChecker,
	  messages: messages,
	};


/***/ },
/* 3060 */
/***/ function(module, exports, __webpack_require__) {

	var moment = __webpack_require__(9);
	
	function isValidMoment(testMoment) {
	  if (typeof moment.isMoment === 'function' && !moment.isMoment(testMoment)) {
	    return false;
	  }
	
	  /* istanbul ignore else  */
	  if (typeof testMoment.isValid === 'function') {
	    // moment 1.7.0+
	    return testMoment.isValid();
	  }
	
	  /* istanbul ignore next */
	  return !isNaN(testMoment);
	}
	
	module.exports = {
	  isValidMoment : isValidMoment,
	};


/***/ },
/* 3061 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(104);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(27);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // This file is a fallback for a consumer who is not yet on React 16
	// as createPortal was introduced in React 16
	
	var Portal = function (_React$Component) {
	  _inherits(Portal, _React$Component);
	
	  function Portal() {
	    _classCallCheck(this, Portal);
	
	    return _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
	  }
	
	  _createClass(Portal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.renderPortal();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(props) {
	      this.renderPortal();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      _reactDom2.default.unmountComponentAtNode(this.defaultNode || this.props.node);
	      if (this.defaultNode) {
	        document.body.removeChild(this.defaultNode);
	      }
	      this.defaultNode = null;
	      this.portal = null;
	    }
	  }, {
	    key: 'renderPortal',
	    value: function renderPortal(props) {
	      if (!this.props.node && !this.defaultNode) {
	        this.defaultNode = document.createElement('div');
	        document.body.appendChild(this.defaultNode);
	      }
	
	      var children = this.props.children;
	      // https://gist.github.com/jimfb/d99e0678e9da715ccf6454961ef04d1b
	      if (typeof this.props.children.type === 'function') {
	        children = _react2.default.cloneElement(this.props.children);
	      }
	
	      this.portal = _reactDom2.default.unstable_renderSubtreeIntoContainer(this, children, this.props.node || this.defaultNode);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return Portal;
	}(_react2.default.Component);
	
	exports.default = Portal;
	
	
	Portal.propTypes = {
	  children: _propTypes2.default.node.isRequired,
	  node: _propTypes2.default.any
	};

/***/ },
/* 3062 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(27);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(104);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _utils = __webpack_require__(3064);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Portal = function (_React$Component) {
	  _inherits(Portal, _React$Component);
	
	  function Portal() {
	    _classCallCheck(this, Portal);
	
	    return _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
	  }
	
	  _createClass(Portal, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.defaultNode) {
	        document.body.removeChild(this.defaultNode);
	      }
	      this.defaultNode = null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!_utils.canUseDOM) {
	        return null;
	      }
	      if (!this.props.node && !this.defaultNode) {
	        this.defaultNode = document.createElement('div');
	        document.body.appendChild(this.defaultNode);
	      }
	      return _reactDom2.default.createPortal(this.props.children, this.props.node || this.defaultNode);
	    }
	  }]);
	
	  return Portal;
	}(_react2.default.Component);
	
	Portal.propTypes = {
	  children: _propTypes2.default.node.isRequired,
	  node: _propTypes2.default.any
	};
	
	exports.default = Portal;

/***/ },
/* 3063 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(27);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PortalCompat = __webpack_require__(900);
	
	var _PortalCompat2 = _interopRequireDefault(_PortalCompat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var KEYCODES = {
	  ESCAPE: 27
	};
	
	var PortalWithState = function (_React$Component) {
	  _inherits(PortalWithState, _React$Component);
	
	  function PortalWithState(props) {
	    _classCallCheck(this, PortalWithState);
	
	    var _this = _possibleConstructorReturn(this, (PortalWithState.__proto__ || Object.getPrototypeOf(PortalWithState)).call(this, props));
	
	    _this.portalNode = null;
	    _this.state = { active: !!props.defaultOpen };
	    _this.openPortal = _this.openPortal.bind(_this);
	    _this.closePortal = _this.closePortal.bind(_this);
	    _this.wrapWithPortal = _this.wrapWithPortal.bind(_this);
	    _this.handleOutsideMouseClick = _this.handleOutsideMouseClick.bind(_this);
	    _this.handleKeydown = _this.handleKeydown.bind(_this);
	    return _this;
	  }
	
	  _createClass(PortalWithState, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.closeOnEsc) {
	        document.addEventListener('keydown', this.handleKeydown);
	      }
	      if (this.props.closeOnOutsideClick) {
	        document.addEventListener('click', this.handleOutsideMouseClick);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.props.closeOnEsc) {
	        document.removeEventListener('keydown', this.handleKeydown);
	      }
	      if (this.props.closeOnOutsideClick) {
	        document.removeEventListener('click', this.handleOutsideMouseClick);
	      }
	    }
	  }, {
	    key: 'openPortal',
	    value: function openPortal(e) {
	      if (this.state.active) {
	        return;
	      }
	      if (e && e.nativeEvent) {
	        e.nativeEvent.stopImmediatePropagation();
	      }
	      this.setState({ active: true }, this.props.onOpen);
	    }
	  }, {
	    key: 'closePortal',
	    value: function closePortal() {
	      if (!this.state.active) {
	        return;
	      }
	      this.setState({ active: false }, this.props.onClose);
	    }
	  }, {
	    key: 'wrapWithPortal',
	    value: function wrapWithPortal(children) {
	      var _this2 = this;
	
	      if (!this.state.active) {
	        return null;
	      }
	      return _react2.default.createElement(
	        _PortalCompat2.default,
	        {
	          node: this.props.node,
	          key: 'react-portal',
	          ref: function ref(portalNode) {
	            return _this2.portalNode = portalNode;
	          }
	        },
	        children
	      );
	    }
	  }, {
	    key: 'handleOutsideMouseClick',
	    value: function handleOutsideMouseClick(e) {
	      if (!this.state.active) {
	        return;
	      }
	      var root = this.portalNode.props.node || this.portalNode.defaultNode;
	      if (!root || root.contains(e.target) || e.button && e.button !== 0) {
	        return;
	      }
	      this.closePortal();
	    }
	  }, {
	    key: 'handleKeydown',
	    value: function handleKeydown(e) {
	      if (e.keyCode === KEYCODES.ESCAPE && this.state.active) {
	        this.closePortal();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children({
	        openPortal: this.openPortal,
	        closePortal: this.closePortal,
	        portal: this.wrapWithPortal,
	        isOpen: this.state.active
	      });
	    }
	  }]);
	
	  return PortalWithState;
	}(_react2.default.Component);
	
	PortalWithState.propTypes = {
	  children: _propTypes2.default.func.isRequired,
	  defaultOpen: _propTypes2.default.bool,
	  node: _propTypes2.default.any,
	  openByClickOn: _propTypes2.default.element,
	  closeOnEsc: _propTypes2.default.bool,
	  closeOnOutsideClick: _propTypes2.default.bool,
	  onOpen: _propTypes2.default.func,
	  onClose: _propTypes2.default.func
	};
	
	PortalWithState.defaultProps = {
	  onOpen: function onOpen() {},
	  onClose: function onClose() {}
	};
	
	exports.default = PortalWithState;

/***/ },
/* 3064 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ },
/* 3065 */,
/* 3066 */,
/* 3067 */,
/* 3068 */,
/* 3069 */,
/* 3070 */,
/* 3071 */,
/* 3072 */,
/* 3073 */,
/* 3074 */
/***/ function(module, exports, __webpack_require__) {

	var canUseDOM = __webpack_require__(2191);
	var enquire = canUseDOM && __webpack_require__(2441);
	var json2mq = __webpack_require__(715);
	
	var ResponsiveMixin = {
	  media: function (query, handler) {
	    query = json2mq(query);
	    if (typeof handler === 'function') {
	      handler = {
	        match: handler
	      };
	    }
	    enquire.register(query, handler);
	
	    // Queue the handlers to unregister them at unmount  
	    if (! this._responsiveMediaHandlers) {
	      this._responsiveMediaHandlers = [];
	    }
	    this._responsiveMediaHandlers.push({query: query, handler: handler});
	  },
	  componentWillUnmount: function () {
	    if (this._responsiveMediaHandlers) {
	      this._responsiveMediaHandlers.forEach(function(obj) {
	        enquire.unregister(obj.query, obj.handler);
	      });
	    }
	  }
	};
	
	module.exports = ResponsiveMixin;

/***/ },
/* 3075 */,
/* 3076 */,
/* 3077 */,
/* 3078 */,
/* 3079 */,
/* 3080 */,
/* 3081 */,
/* 3082 */,
/* 3083 */,
/* 3084 */,
/* 3085 */,
/* 3086 */,
/* 3087 */,
/* 3088 */,
/* 3089 */,
/* 3090 */,
/* 3091 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fbjsLibExecutionEnvironment = __webpack_require__(53);
	
	var _fbjsLibExecutionEnvironment2 = _interopRequireDefault(_fbjsLibExecutionEnvironment);
	
	var _fbjsLibShallowEqual = __webpack_require__(252);
	
	var _fbjsLibShallowEqual2 = _interopRequireDefault(_fbjsLibShallowEqual);
	
	module.exports = function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = undefined;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = (function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        _Component.apply(this, arguments);
	      }
	
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may ony call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !_fbjsLibShallowEqual2['default'](nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return _react2['default'].createElement(WrappedComponent, this.props);
	      };
	
	      _createClass(SideEffect, null, [{
	        key: 'displayName',
	
	        // Try to use displayName of wrapped component
	        value: 'SideEffect(' + getDisplayName(WrappedComponent) + ')',
	
	        // Expose canUseDOM so tests can monkeypatch it
	        enumerable: true
	      }, {
	        key: 'canUseDOM',
	        value: _fbjsLibExecutionEnvironment2['default'].canUseDOM,
	        enumerable: true
	      }]);
	
	      return SideEffect;
	    })(_react.Component);
	
	    return SideEffect;
	  };
	};

/***/ },
/* 3092 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var PrevArrow = _react2['default'].createClass({
	  displayName: 'PrevArrow',
	
	  clickHandler: function clickHandler(options, e) {
	    e.preventDefault();
	    this.props.clickHandler(options, e);
	  },
	  render: function render() {
	    var prevClasses = { 'slick-prev': true };
	    var prevHandler = this.clickHandler.bind(this, { message: 'previous' });
	
	    if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
	      prevClasses['slick-disabled'] = true;
	      prevHandler = null;
	    }
	
	    var prevArrowProps = {
	      key: '0',
	      'data-role': 'none',
	      className: (0, _classnames2['default'])(prevClasses),
	      style: { display: 'block' },
	      onClick: prevHandler
	    };
	    var prevArrow;
	
	    if (this.props.prevArrow) {
	      prevArrow = _react2['default'].cloneElement(this.props.prevArrow, prevArrowProps);
	    } else {
	      prevArrow = _react2['default'].createElement(
	        'button',
	        _extends({ key: '0', type: 'button' }, prevArrowProps),
	        ' Previous'
	      );
	    }
	
	    return prevArrow;
	  }
	});
	
	exports.PrevArrow = PrevArrow;
	var NextArrow = _react2['default'].createClass({
	  displayName: 'NextArrow',
	
	  clickHandler: function clickHandler(options, e) {
	    e.preventDefault();
	    this.props.clickHandler(options, e);
	  },
	  render: function render() {
	    var nextClasses = { 'slick-next': true };
	    var nextHandler = this.clickHandler.bind(this, { message: 'next' });
	
	    if (!this.props.infinite) {
	      if (this.props.centerMode && this.props.currentSlide >= this.props.slideCount - 1) {
	        nextClasses['slick-disabled'] = true;
	        nextHandler = null;
	      } else {
	        if (this.props.currentSlide >= this.props.slideCount - this.props.slidesToShow) {
	          nextClasses['slick-disabled'] = true;
	          nextHandler = null;
	        }
	      }
	
	      if (this.props.slideCount <= this.props.slidesToShow) {
	        nextClasses['slick-disabled'] = true;
	        nextHandler = null;
	      }
	    }
	
	    var nextArrowProps = {
	      key: '1',
	      'data-role': 'none',
	      className: (0, _classnames2['default'])(nextClasses),
	      style: { display: 'block' },
	      onClick: nextHandler
	    };
	
	    var nextArrow;
	
	    if (this.props.nextArrow) {
	      nextArrow = _react2['default'].cloneElement(this.props.nextArrow, nextArrowProps);
	    } else {
	      nextArrow = _react2['default'].createElement(
	        'button',
	        _extends({ key: '1', type: 'button' }, nextArrowProps),
	        ' Next'
	      );
	    }
	
	    return nextArrow;
	  }
	});
	exports.NextArrow = NextArrow;

/***/ },
/* 3093 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var getDotCount = function getDotCount(spec) {
	  var dots;
	  dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
	  return dots;
	};
	
	var Dots = _react2['default'].createClass({
	  displayName: 'Dots',
	
	  clickHandler: function clickHandler(options, e) {
	    // In Autoplay the focus stays on clicked button even after transition
	    // to next slide. That only goes away by click somewhere outside
	    e.preventDefault();
	    this.props.clickHandler(options);
	  },
	  render: function render() {
	    var _this = this;
	
	    var dotCount = getDotCount({
	      slideCount: this.props.slideCount,
	      slidesToScroll: this.props.slidesToScroll
	    });
	
	    // Apply join & split to Array to pre-fill it for IE8
	    //
	    // Credit: http://stackoverflow.com/a/13735425/1849458
	    var dots = Array.apply(null, Array(dotCount + 1).join('0').split('')).map(function (x, i) {
	
	      var className = (0, _classnames2['default'])({
	        'slick-active': _this.props.currentSlide === i * _this.props.slidesToScroll
	      });
	
	      var dotOptions = {
	        message: 'dots',
	        index: i,
	        slidesToScroll: _this.props.slidesToScroll,
	        currentSlide: _this.props.currentSlide
	      };
	
	      return _react2['default'].createElement(
	        'li',
	        { key: i, className: className },
	        _react2['default'].createElement(
	          'button',
	          { onClick: _this.clickHandler.bind(_this, dotOptions) },
	          i + 1
	        )
	      );
	    });
	
	    return _react2['default'].createElement(
	      'ul',
	      { className: this.props.dotsClass, style: { display: 'block' } },
	      dots
	    );
	  }
	});
	exports.Dots = Dots;

/***/ },
/* 3094 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(3098);

/***/ },
/* 3095 */
/***/ function(module, exports) {

	"use strict";
	
	var initialState = {
	    animating: false,
	    dragging: false,
	    autoPlayTimer: null,
	    currentDirection: 0,
	    currentLeft: null,
	    currentSlide: 0,
	    direction: 1,
	    // listWidth: null,
	    // listHeight: null,
	    // loadIndex: 0,
	    slideCount: null,
	    slideWidth: null,
	    // sliding: false,
	    // slideOffset: 0,
	    swipeLeft: null,
	    touchObject: {
	        startX: 0,
	        startY: 0,
	        curX: 0,
	        curY: 0
	    },
	
	    lazyLoadedList: [],
	
	    // added for react
	    initialized: false,
	    edgeDragged: false,
	    swiped: false, // used by swipeEvent. differentites between touch and swipe.
	    trackStyle: {},
	    trackWidth: 0
	
	    // Removed
	    // transformsEnabled: false,
	    // $nextArrow: null,
	    // $prevArrow: null,
	    // $dots: null,
	    // $list: null,
	    // $slideTrack: null,
	    // $slides: null,
	};
	
	module.exports = initialState;

/***/ },
/* 3096 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mixinsEventHandlers = __webpack_require__(3097);
	
	var _mixinsEventHandlers2 = _interopRequireDefault(_mixinsEventHandlers);
	
	var _mixinsHelpers = __webpack_require__(916);
	
	var _mixinsHelpers2 = _interopRequireDefault(_mixinsHelpers);
	
	var _initialState = __webpack_require__(3095);
	
	var _initialState2 = _interopRequireDefault(_initialState);
	
	var _defaultProps = __webpack_require__(914);
	
	var _defaultProps2 = _interopRequireDefault(_defaultProps);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _track = __webpack_require__(3099);
	
	var _dots = __webpack_require__(3093);
	
	var _arrows = __webpack_require__(3092);
	
	var InnerSlider = _react2['default'].createClass({
	  displayName: 'InnerSlider',
	
	  mixins: [_mixinsHelpers2['default'], _mixinsEventHandlers2['default']],
	  getInitialState: function getInitialState() {
	    return _initialState2['default'];
	  },
	  getDefaultProps: function getDefaultProps() {
	    return _defaultProps2['default'];
	  },
	  componentWillMount: function componentWillMount() {
	    if (this.props.init) {
	      this.props.init();
	    }
	    this.setState({
	      mounted: true
	    });
	    var lazyLoadedList = [];
	    for (var i = 0; i < _react2['default'].Children.count(this.props.children); i++) {
	      if (i >= this.state.currentSlide && i < this.state.currentSlide + this.props.slidesToShow) {
	        lazyLoadedList.push(i);
	      }
	    }
	
	    if (this.props.lazyLoad && this.state.lazyLoadedList.length === 0) {
	      this.setState({
	        lazyLoadedList: lazyLoadedList
	      });
	    }
	  },
	  componentDidMount: function componentDidMount() {
	    // Hack for autoplay -- Inspect Later
	    this.initialize(this.props);
	    this.adaptHeight();
	    if (window.addEventListener) {
	      window.addEventListener('resize', this.onWindowResized);
	    } else {
	      window.attachEvent('onresize', this.onWindowResized);
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (window.addEventListener) {
	      window.removeEventListener('resize', this.onWindowResized);
	    } else {
	      window.detachEvent('onresize', this.onWindowResized);
	    }
	    if (this.state.autoPlayTimer) {
	      window.clearInterval(this.state.autoPlayTimer);
	    }
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (this.props.slickGoTo != nextProps.slickGoTo) {
	      this.changeSlide({
	        message: 'index',
	        index: nextProps.slickGoTo,
	        currentSlide: this.state.currentSlide
	      });
	    } else {
	      this.update(nextProps);
	    }
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    this.adaptHeight();
	  },
	  onWindowResized: function onWindowResized() {
	    this.update(this.props);
	  },
	  render: function render() {
	    var className = (0, _classnames2['default'])('slick-initialized', 'slick-slider', this.props.className);
	
	    var trackProps = {
	      fade: this.props.fade,
	      cssEase: this.props.cssEase,
	      speed: this.props.speed,
	      infinite: this.props.infinite,
	      centerMode: this.props.centerMode,
	      currentSlide: this.state.currentSlide,
	      lazyLoad: this.props.lazyLoad,
	      lazyLoadedList: this.state.lazyLoadedList,
	      rtl: this.props.rtl,
	      slideWidth: this.state.slideWidth,
	      slidesToShow: this.props.slidesToShow,
	      slideCount: this.state.slideCount,
	      trackStyle: this.state.trackStyle,
	      variableWidth: this.props.variableWidth
	    };
	
	    var dots;
	
	    if (this.props.dots === true && this.state.slideCount > this.props.slidesToShow) {
	      var dotProps = {
	        dotsClass: this.props.dotsClass,
	        slideCount: this.state.slideCount,
	        slidesToShow: this.props.slidesToShow,
	        currentSlide: this.state.currentSlide,
	        slidesToScroll: this.props.slidesToScroll,
	        clickHandler: this.changeSlide
	      };
	
	      dots = _react2['default'].createElement(_dots.Dots, dotProps);
	    }
	
	    var prevArrow, nextArrow;
	
	    var arrowProps = {
	      infinite: this.props.infinite,
	      centerMode: this.props.centerMode,
	      currentSlide: this.state.currentSlide,
	      slideCount: this.state.slideCount,
	      slidesToShow: this.props.slidesToShow,
	      prevArrow: this.props.prevArrow,
	      nextArrow: this.props.nextArrow,
	      clickHandler: this.changeSlide
	    };
	
	    if (this.props.arrows) {
	      prevArrow = _react2['default'].createElement(_arrows.PrevArrow, arrowProps);
	      nextArrow = _react2['default'].createElement(_arrows.NextArrow, arrowProps);
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      { className: className, onMouseEnter: this.onInnerSliderEnter, onMouseLeave: this.onInnerSliderLeave },
	      _react2['default'].createElement(
	        'div',
	        {
	          ref: 'list',
	          className: 'slick-list',
	          onMouseDown: this.swipeStart,
	          onMouseMove: this.state.dragging ? this.swipeMove : null,
	          onMouseUp: this.swipeEnd,
	          onMouseLeave: this.state.dragging ? this.swipeEnd : null,
	          onTouchStart: this.swipeStart,
	          onTouchMove: this.state.dragging ? this.swipeMove : null,
	          onTouchEnd: this.swipeEnd,
	          onTouchCancel: this.state.dragging ? this.swipeEnd : null },
	        _react2['default'].createElement(
	          _track.Track,
	          _extends({ ref: 'track' }, trackProps),
	          this.props.children
	        )
	      ),
	      prevArrow,
	      nextArrow,
	      dots
	    );
	  }
	});
	exports.InnerSlider = InnerSlider;

/***/ },
/* 3097 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _trackHelper = __webpack_require__(917);
	
	var _helpers = __webpack_require__(916);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _objectAssign = __webpack_require__(29);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var EventHandlers = {
	  // Event handler for previous and next
	  changeSlide: function changeSlide(options) {
	    var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
	    unevenOffset = this.state.slideCount % this.props.slidesToScroll !== 0;
	    indexOffset = unevenOffset ? 0 : (this.state.slideCount - this.state.currentSlide) % this.props.slidesToScroll;
	
	    if (options.message === 'previous') {
	      slideOffset = indexOffset === 0 ? this.props.slidesToScroll : this.props.slidesToShow - indexOffset;
	      targetSlide = this.state.currentSlide - slideOffset;
	      if (this.props.lazyLoad) {
	        previousInt = this.state.currentSlide - slideOffset;
	        targetSlide = previousInt === -1 ? this.state.slideCount - 1 : previousInt;
	      }
	    } else if (options.message === 'next') {
	      slideOffset = indexOffset === 0 ? this.props.slidesToScroll : indexOffset;
	      targetSlide = this.state.currentSlide + slideOffset;
	    } else if (options.message === 'dots') {
	      // Click on dots
	      targetSlide = options.index * options.slidesToScroll;
	      if (targetSlide === options.currentSlide) {
	        return;
	      }
	    } else if (options.message === 'index') {
	      targetSlide = options.index;
	      if (targetSlide === options.currentSlide) {
	        return;
	      }
	    }
	
	    this.slideHandler(targetSlide);
	  },
	  // Accessiblity handler for previous and next
	  keyHandler: function keyHandler(e) {},
	  // Focus on selecting a slide (click handler on track)
	  selectHandler: function selectHandler(e) {},
	  swipeStart: function swipeStart(e) {
	    var touches, posX, posY;
	
	    if (this.props.swipe === false || 'ontouchend' in document && this.props.swipe === false) {
	      return;
	    } else if (this.props.draggable === false && e.type.indexOf('mouse') !== -1) {
	      return;
	    }
	    posX = e.touches !== undefined ? e.touches[0].pageX : e.clientX;
	    posY = e.touches !== undefined ? e.touches[0].pageY : e.clientY;
	    this.setState({
	      dragging: true,
	      touchObject: {
	        startX: posX,
	        startY: posY,
	        curX: posX,
	        curY: posY
	      }
	    });
	  },
	  swipeMove: function swipeMove(e) {
	    if (!this.state.dragging) {
	      return;
	    }
	    if (this.state.animating) {
	      return;
	    }
	    var swipeLeft;
	    var curLeft, positionOffset;
	    var touchObject = this.state.touchObject;
	
	    curLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2['default'])({
	      slideIndex: this.state.currentSlide,
	      trackRef: this.refs.track
	    }, this.props, this.state));
	    touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
	    touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
	    touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
	
	    positionOffset = (this.props.rtl === false ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
	
	    var currentSlide = this.state.currentSlide;
	    var dotCount = Math.ceil(this.state.slideCount / this.props.slidesToScroll);
	    var swipeDirection = this.swipeDirection(this.state.touchObject);
	    var touchSwipeLength = touchObject.swipeLength;
	
	    if (this.props.infinite === false) {
	      if (currentSlide === 0 && swipeDirection === 'right' || currentSlide + 1 >= dotCount && swipeDirection === 'left') {
	        touchSwipeLength = touchObject.swipeLength * this.props.edgeFriction;
	
	        if (this.state.edgeDragged === false && this.props.edgeEvent) {
	          this.props.edgeEvent(swipeDirection);
	          this.setState({ edgeDragged: true });
	        }
	      }
	    }
	
	    if (this.state.swiped === false && this.props.swipeEvent) {
	      this.props.swipeEvent(swipeDirection);
	      this.setState({ swiped: true });
	    }
	
	    swipeLeft = curLeft + touchSwipeLength * positionOffset;
	    this.setState({
	      touchObject: touchObject,
	      swipeLeft: swipeLeft,
	      trackStyle: (0, _trackHelper.getTrackCSS)((0, _objectAssign2['default'])({ left: swipeLeft }, this.props, this.state))
	    });
	
	    if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
	      return;
	    }
	    if (touchObject.swipeLength > 4) {
	      e.preventDefault();
	    }
	  },
	  swipeEnd: function swipeEnd(e) {
	    if (!this.state.dragging) {
	      return;
	    }
	    var touchObject = this.state.touchObject;
	    var minSwipe = this.state.listWidth / this.props.touchThreshold;
	    var swipeDirection = this.swipeDirection(touchObject);
	
	    // reset the state of touch related state variables.
	    this.setState({
	      dragging: false,
	      edgeDragged: false,
	      swiped: false,
	      swipeLeft: null,
	      touchObject: {}
	    });
	    // Fix for #13
	    if (!touchObject.swipeLength) {
	      return;
	    }
	    if (touchObject.swipeLength > minSwipe) {
	      e.preventDefault();
	      if (swipeDirection === 'left') {
	        this.slideHandler(this.state.currentSlide + this.props.slidesToScroll);
	      } else if (swipeDirection === 'right') {
	        this.slideHandler(this.state.currentSlide - this.props.slidesToScroll);
	      } else {
	        this.slideHandler(this.state.currentSlide);
	      }
	    } else {
	      // Adjust the track back to it's original position.
	      var currentLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2['default'])({
	        slideIndex: this.state.currentSlide,
	        trackRef: this.refs.track
	      }, this.props, this.state));
	
	      this.setState({
	        trackStyle: (0, _trackHelper.getTrackAnimateCSS)((0, _objectAssign2['default'])({ left: currentLeft }, this.props, this.state))
	      });
	    }
	  },
	  onInnerSliderEnter: function onInnerSliderEnter(e) {
	    if (this.props.autoplay && this.props.pauseOnHover) {
	      this.pause();
	    }
	  },
	  onInnerSliderLeave: function onInnerSliderLeave(e) {
	    if (this.props.autoplay && this.props.pauseOnHover) {
	      this.autoPlay();
	    }
	  }
	};
	
	exports['default'] = EventHandlers;
	module.exports = exports['default'];

/***/ },
/* 3098 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _innerSlider = __webpack_require__(3096);
	
	var _objectAssign = __webpack_require__(29);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _json2mq = __webpack_require__(715);
	
	var _json2mq2 = _interopRequireDefault(_json2mq);
	
	var _reactResponsiveMixin = __webpack_require__(3074);
	
	var _reactResponsiveMixin2 = _interopRequireDefault(_reactResponsiveMixin);
	
	var _defaultProps = __webpack_require__(914);
	
	var _defaultProps2 = _interopRequireDefault(_defaultProps);
	
	var Slider = _react2['default'].createClass({
	  displayName: 'Slider',
	
	  mixins: [_reactResponsiveMixin2['default']],
	  getInitialState: function getInitialState() {
	    return {
	      breakpoint: null
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    var _this = this;
	
	    if (this.props.responsive) {
	      var breakpoints = this.props.responsive.map(function (breakpt) {
	        return breakpt.breakpoint;
	      });
	      breakpoints.sort(function (x, y) {
	        return x - y;
	      });
	
	      breakpoints.forEach(function (breakpoint, index) {
	        var bQuery;
	        if (index === 0) {
	          bQuery = (0, _json2mq2['default'])({ minWidth: 0, maxWidth: breakpoint });
	        } else {
	          bQuery = (0, _json2mq2['default'])({ minWidth: breakpoints[index - 1], maxWidth: breakpoint });
	        }
	        _this.media(bQuery, function () {
	          _this.setState({ breakpoint: breakpoint });
	        });
	      });
	
	      // Register media query for full screen. Need to support resize from small to large
	      var query = (0, _json2mq2['default'])({ minWidth: breakpoints.slice(-1)[0] });
	
	      this.media(query, function () {
	        _this.setState({ breakpoint: null });
	      });
	    }
	  },
	  render: function render() {
	    var _this2 = this;
	
	    var settings;
	    var newProps;
	    if (this.state.breakpoint) {
	      newProps = this.props.responsive.filter(function (resp) {
	        return resp.breakpoint === _this2.state.breakpoint;
	      });
	      settings = newProps[0].settings === 'unslick' ? 'unslick' : (0, _objectAssign2['default'])({}, this.props, newProps[0].settings);
	    } else {
	      settings = (0, _objectAssign2['default'])({}, _defaultProps2['default'], this.props);
	    }
	    if (settings === 'unslick') {
	      // if 'unslick' responsive breakpoint setting used, just return the <Slider> tag nested HTML
	      return _react2['default'].createElement(
	        'div',
	        null,
	        this.props.children
	      );
	    } else {
	      return _react2['default'].createElement(
	        _innerSlider.InnerSlider,
	        settings,
	        this.props.children
	      );
	    }
	  }
	});
	
	module.exports = Slider;

/***/ },
/* 3099 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(29);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var getSlideClasses = function getSlideClasses(spec) {
	  var slickActive, slickCenter, slickCloned;
	  var centerOffset, index;
	
	  if (spec.rtl) {
	    index = spec.slideCount - 1 - spec.index;
	  } else {
	    index = spec.index;
	  }
	
	  slickCloned = index < 0 || index >= spec.slideCount;
	  if (spec.centerMode) {
	    centerOffset = Math.floor(spec.slidesToShow / 2);
	    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
	    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
	      slickActive = true;
	    }
	  } else {
	    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
	  }
	  return (0, _classnames2['default'])({
	    'slick-slide': true,
	    'slick-active': slickActive,
	    'slick-center': slickCenter,
	    'slick-cloned': slickCloned
	  });
	};
	
	var getSlideStyle = function getSlideStyle(spec) {
	  var style = {};
	
	  if (spec.variableWidth === undefined || spec.variableWidth === false) {
	    style.width = spec.slideWidth;
	  }
	
	  if (spec.fade) {
	    style.position = 'relative';
	    style.left = -spec.index * spec.slideWidth;
	    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
	    style.transition = 'opacity ' + spec.speed + 'ms ' + spec.cssEase;
	    style.WebkitTransition = 'opacity ' + spec.speed + 'ms ' + spec.cssEase;
	  }
	
	  return style;
	};
	
	var getKey = function getKey(child, fallbackKey) {
	  // key could be a zero
	  return child.key === null || child.key === undefined ? fallbackKey : child.key;
	};
	
	var renderSlides = function renderSlides(spec) {
	  var key;
	  var slides = [];
	  var preCloneSlides = [];
	  var postCloneSlides = [];
	  var count = _react2['default'].Children.count(spec.children);
	  var child;
	
	  _react2['default'].Children.forEach(spec.children, function (elem, index) {
	    if (!spec.lazyLoad | (spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0)) {
	      child = elem;
	    } else {
	      child = _react2['default'].createElement('div', null);
	    }
	    var childStyle = getSlideStyle((0, _objectAssign2['default'])({}, spec, { index: index }));
	    var slickClasses = getSlideClasses((0, _objectAssign2['default'])({ index: index }, spec));
	    var cssClasses;
	
	    if (child.props.className) {
	      cssClasses = (0, _classnames2['default'])(slickClasses, child.props.className);
	    } else {
	      cssClasses = slickClasses;
	    }
	
	    slides.push(_react2['default'].cloneElement(child, {
	      key: 'original' + getKey(child, index),
	      'data-index': index,
	      className: cssClasses,
	      style: (0, _objectAssign2['default'])({}, child.props.style || {}, childStyle)
	    }));
	
	    // variableWidth doesn't wrap properly.
	    if (spec.infinite && spec.fade === false) {
	      var infiniteCount = spec.variableWidth ? spec.slidesToShow + 1 : spec.slidesToShow;
	
	      if (index >= count - infiniteCount) {
	        key = -(count - index);
	        preCloneSlides.push(_react2['default'].cloneElement(child, {
	          key: 'cloned' + getKey(child, key),
	          'data-index': key,
	          className: cssClasses,
	          style: (0, _objectAssign2['default'])({}, child.props.style || {}, childStyle)
	        }));
	      }
	
	      if (index < infiniteCount) {
	        key = count + index;
	        postCloneSlides.push(_react2['default'].cloneElement(child, {
	          key: 'cloned' + getKey(child, key),
	          'data-index': key,
	          className: cssClasses,
	          style: (0, _objectAssign2['default'])({}, child.props.style || {}, childStyle)
	        }));
	      }
	    }
	  });
	
	  if (spec.rtl) {
	    return preCloneSlides.concat(slides, postCloneSlides).reverse();
	  } else {
	    return preCloneSlides.concat(slides, postCloneSlides);
	  }
	};
	
	var Track = _react2['default'].createClass({
	  displayName: 'Track',
	
	  render: function render() {
	    var slides = renderSlides(this.props);
	    return _react2['default'].createElement(
	      'div',
	      { className: 'slick-track', style: this.props.trackStyle },
	      slides
	    );
	  }
	});
	exports.Track = Track;

/***/ },
/* 3100 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(1);
	
	var Swipeable = React.createClass({
	  displayName: 'Swipeable',
	
	  propTypes: {
	    onSwiped: React.PropTypes.func,
	    onSwiping: React.PropTypes.func,
	    onSwipingUp: React.PropTypes.func,
	    onSwipingRight: React.PropTypes.func,
	    onSwipingDown: React.PropTypes.func,
	    onSwipingLeft: React.PropTypes.func,
	    onSwipedUp: React.PropTypes.func,
	    onSwipedRight: React.PropTypes.func,
	    onSwipedDown: React.PropTypes.func,
	    onSwipedLeft: React.PropTypes.func,
	    flickThreshold: React.PropTypes.number,
	    delta: React.PropTypes.number,
	    preventDefaultTouchmoveEvent: React.PropTypes.bool,
	    stopPropagation: React.PropTypes.bool,
	    nodeName: React.PropTypes.string,
	    trackMouse: React.PropTypes.bool
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      x: null,
	      y: null,
	      swiping: false,
	      start: 0
	    };
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      flickThreshold: 0.6,
	      delta: 10,
	      preventDefaultTouchmoveEvent: true,
	      stopPropagation: false,
	      nodeName: 'div'
	    };
	  },
	
	  calculatePos: function calculatePos(e) {
	    var x = void 0,
	        y = void 0;
	    // If not a touch, determine point from mouse coordinates
	    if (e.changedTouches) {
	      x = e.changedTouches[0].clientX;
	      y = e.changedTouches[0].clientY;
	    } else {
	      x = e.clientX;
	      y = e.clientY;
	    }
	
	    var xd = this.state.x - x;
	    var yd = this.state.y - y;
	
	    var axd = Math.abs(xd);
	    var ayd = Math.abs(yd);
	
	    var time = Date.now() - this.state.start;
	    var velocity = Math.sqrt(axd * axd + ayd * ayd) / time;
	
	    return {
	      deltaX: xd,
	      deltaY: yd,
	      absX: axd,
	      absY: ayd,
	      velocity: velocity
	    };
	  },
	
	  eventStart: function eventStart(e) {
	    if (e.touches && e.touches.length > 1) {
	      return;
	    }
	    // If not a touch, determine point from mouse coordinates
	    var touches = e.touches;
	    if (!touches) {
	      touches = [{ clientX: e.clientX, clientY: e.clientY }];
	    }
	    if (this.props.stopPropagation) e.stopPropagation();
	
	    this.setState({
	      start: Date.now(),
	      x: touches[0].clientX,
	      y: touches[0].clientY,
	      swiping: false
	    });
	  },
	
	  eventMove: function eventMove(e) {
	    if (!this.state.x || !this.state.y || e.touches && e.touches.length > 1) {
	      return;
	    }
	
	    var cancelPageSwipe = false;
	    var pos = this.calculatePos(e);
	
	    if (pos.absX < this.props.delta && pos.absY < this.props.delta) {
	      return;
	    }
	
	    if (this.props.stopPropagation) e.stopPropagation();
	
	    if (this.props.onSwiping) {
	      this.props.onSwiping(e, pos.deltaX, pos.deltaY, pos.absX, pos.absY, pos.velocity);
	    }
	
	    if (pos.absX > pos.absY) {
	      if (pos.deltaX > 0) {
	        if (this.props.onSwipingLeft || this.props.onSwipedLeft) {
	          this.props.onSwipingLeft && this.props.onSwipingLeft(e, pos.absX);
	          cancelPageSwipe = true;
	        }
	      } else {
	        if (this.props.onSwipingRight || this.props.onSwipedRight) {
	          this.props.onSwipingRight && this.props.onSwipingRight(e, pos.absX);
	          cancelPageSwipe = true;
	        }
	      }
	    } else {
	      if (pos.deltaY > 0) {
	        if (this.props.onSwipingUp || this.props.onSwipedUp) {
	          this.props.onSwipingUp && this.props.onSwipingUp(e, pos.absY);
	          cancelPageSwipe = true;
	        }
	      } else {
	        if (this.props.onSwipingDown || this.props.onSwipedDown) {
	          this.props.onSwipingDown && this.props.onSwipingDown(e, pos.absY);
	          cancelPageSwipe = true;
	        }
	      }
	    }
	
	    this.setState({ swiping: true });
	
	    if (cancelPageSwipe && this.props.preventDefaultTouchmoveEvent) {
	      e.preventDefault();
	    }
	  },
	
	  eventEnd: function eventEnd(e) {
	    if (this.state.swiping) {
	      var pos = this.calculatePos(e);
	
	      if (this.props.stopPropagation) e.stopPropagation();
	
	      var isFlick = pos.velocity > this.props.flickThreshold;
	
	      this.props.onSwiped && this.props.onSwiped(e, pos.deltaX, pos.deltaY, isFlick, pos.velocity);
	
	      if (pos.absX > pos.absY) {
	        if (pos.deltaX > 0) {
	          this.props.onSwipedLeft && this.props.onSwipedLeft(e, pos.deltaX, isFlick);
	        } else {
	          this.props.onSwipedRight && this.props.onSwipedRight(e, pos.deltaX, isFlick);
	        }
	      } else {
	        if (pos.deltaY > 0) {
	          this.props.onSwipedUp && this.props.onSwipedUp(e, pos.deltaY, isFlick);
	        } else {
	          this.props.onSwipedDown && this.props.onSwipedDown(e, pos.deltaY, isFlick);
	        }
	      }
	    }
	
	    this.setState(this.getInitialState());
	  },
	
	  render: function render() {
	    var newProps = _extends({}, this.props, {
	      onTouchStart: this.eventStart,
	      onTouchMove: this.eventMove,
	      onTouchEnd: this.eventEnd,
	      onMouseDown: this.props.trackMouse && this.eventStart,
	      onMouseMove: this.props.trackMouse && this.eventMove,
	      onMouseUp: this.props.trackMouse && this.eventEnd
	    });
	
	    delete newProps.onSwiped;
	    delete newProps.onSwiping;
	    delete newProps.onSwipingUp;
	    delete newProps.onSwipingRight;
	    delete newProps.onSwipingDown;
	    delete newProps.onSwipingLeft;
	    delete newProps.onSwipedUp;
	    delete newProps.onSwipedRight;
	    delete newProps.onSwipedDown;
	    delete newProps.onSwipedLeft;
	    delete newProps.flickThreshold;
	    delete newProps.delta;
	    delete newProps.preventDefaultTouchmoveEvent;
	    delete newProps.stopPropagation;
	    delete newProps.nodeName;
	    delete newProps.children;
	    delete newProps.trackMouse;
	
	    return React.createElement(this.props.nodeName, newProps, this.props.children);
	  }
	});
	
	module.exports = Swipeable;

/***/ },
/* 3101 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule TapEventPlugin
	 * @typechecks static-only
	 */
	
	"use strict";
	
	var EventConstants = __webpack_require__(2996);
	var EventPluginUtils = __webpack_require__(342);
	var EventPropagators = __webpack_require__(219);
	var SyntheticUIEvent = __webpack_require__(221);
	var TouchEventUtils = __webpack_require__(3102);
	var ViewportMetrics = __webpack_require__(484);
	
	var keyOf = __webpack_require__(2777);
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var isStartish = EventPluginUtils.isStartish;
	var isEndish = EventPluginUtils.isEndish;
	
	var isTouch = function(topLevelType) {
	  var touchTypes = [
	    'topTouchCancel',
	    'topTouchEnd',
	    'topTouchStart',
	    'topTouchMove'
	  ];
	  return touchTypes.indexOf(topLevelType) >= 0;
	}
	
	/**
	 * Number of pixels that are tolerated in between a `touchStart` and `touchEnd`
	 * in order to still be considered a 'tap' event.
	 */
	var tapMoveThreshold = 10;
	var ignoreMouseThreshold = 750;
	var startCoords = {x: null, y: null};
	var lastTouchEvent = null;
	
	var Axis = {
	  x: {page: 'pageX', client: 'clientX', envScroll: 'currentPageScrollLeft'},
	  y: {page: 'pageY', client: 'clientY', envScroll: 'currentPageScrollTop'}
	};
	
	function getAxisCoordOfEvent(axis, nativeEvent) {
	  var singleTouch = TouchEventUtils.extractSingleTouch(nativeEvent);
	  if (singleTouch) {
	    return singleTouch[axis.page];
	  }
	  return axis.page in nativeEvent ?
	    nativeEvent[axis.page] :
	    nativeEvent[axis.client] + ViewportMetrics[axis.envScroll];
	}
	
	function getDistance(coords, nativeEvent) {
	  var pageX = getAxisCoordOfEvent(Axis.x, nativeEvent);
	  var pageY = getAxisCoordOfEvent(Axis.y, nativeEvent);
	  return Math.pow(
	    Math.pow(pageX - coords.x, 2) + Math.pow(pageY - coords.y, 2),
	    0.5
	  );
	}
	
	var touchEvents = [
	  'topTouchStart',
	  'topTouchCancel',
	  'topTouchEnd',
	  'topTouchMove',
	];
	
	var dependencies = [
	  'topMouseDown',
	  'topMouseMove',
	  'topMouseUp',
	].concat(touchEvents);
	
	var eventTypes = {
	  touchTap: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onTouchTap: null}),
	      captured: keyOf({onTouchTapCapture: null})
	    },
	    dependencies: dependencies
	  }
	};
	
	var now = (function() {
	  if (Date.now) {
	    return Date.now;
	  } else {
	    // IE8 support: http://stackoverflow.com/questions/9430357/please-explain-why-and-how-new-date-works-as-workaround-for-date-now-in
	    return function () {
	      return +new Date;
	    }
	  }
	})();
	
	function createTapEventPlugin(shouldRejectClick) {
	  return {
	
	    tapMoveThreshold: tapMoveThreshold,
	
	    ignoreMouseThreshold: ignoreMouseThreshold,
	
	    eventTypes: eventTypes,
	
	    /**
	     * @param {string} topLevelType Record from `EventConstants`.
	     * @param {DOMEventTarget} targetInst The listening component root node.
	     * @param {object} nativeEvent Native browser event.
	     * @return {*} An accumulation of synthetic events.
	     * @see {EventPluginHub.extractEvents}
	     */
	    extractEvents: function(
	      topLevelType,
	      targetInst,
	      nativeEvent,
	      nativeEventTarget
	    ) {
	
	      if (!isStartish(topLevelType) && !isEndish(topLevelType)) {
	        return null;
	      }
	
	      if (isTouch(topLevelType)) {
	        lastTouchEvent = now();
	      } else {
	        if (shouldRejectClick(lastTouchEvent, now())) {
	          return null;
	        }
	      }
	
	      var event = null;
	      var distance = getDistance(startCoords, nativeEvent);
	      if (isEndish(topLevelType) && distance < tapMoveThreshold) {
	        event = SyntheticUIEvent.getPooled(
	          eventTypes.touchTap,
	          targetInst,
	          nativeEvent,
	          nativeEventTarget
	        );
	      }
	      if (isStartish(topLevelType)) {
	        startCoords.x = getAxisCoordOfEvent(Axis.x, nativeEvent);
	        startCoords.y = getAxisCoordOfEvent(Axis.y, nativeEvent);
	      } else if (isEndish(topLevelType)) {
	        startCoords.x = 0;
	        startCoords.y = 0;
	      }
	      EventPropagators.accumulateTwoPhaseDispatches(event);
	      return event;
	    }
	
	  };
	}
	
	module.exports = createTapEventPlugin;


/***/ },
/* 3102 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule TouchEventUtils
	 */
	
	var TouchEventUtils = {
	  /**
	   * Utility function for common case of extracting out the primary touch from a
	   * touch event.
	   * - `touchEnd` events usually do not have the `touches` property.
	   *   http://stackoverflow.com/questions/3666929/
	   *   mobile-sarai-touchend-event-not-firing-when-last-touch-is-removed
	   *
	   * @param {Event} nativeEvent Native event that may or may not be a touch.
	   * @return {TouchesObject?} an object with pageX and pageY or null.
	   */
	  extractSingleTouch: function(nativeEvent) {
	    var touches = nativeEvent.touches;
	    var changedTouches = nativeEvent.changedTouches;
	    var hasTouches = touches && touches.length > 0;
	    var hasChangedTouches = changedTouches && changedTouches.length > 0;
	
	    return !hasTouches && hasChangedTouches ? changedTouches[0] :
	           hasTouches ? touches[0] :
	           nativeEvent;
	  }
	};
	
	module.exports = TouchEventUtils;


/***/ },
/* 3103 */
/***/ function(module, exports) {

	module.exports = function(lastTouchEvent, clickTimestamp) {
	  if (lastTouchEvent && (clickTimestamp - lastTouchEvent) < 750) {
	    return true;
	  }
	};


/***/ },
/* 3104 */
/***/ function(module, exports, __webpack_require__) {

	var invariant = __webpack_require__(19);
	var defaultClickRejectionStrategy = __webpack_require__(3103);
	
	var alreadyInjected = false;
	
	module.exports = function injectTapEventPlugin (strategyOverrides) {
	  strategyOverrides = strategyOverrides || {}
	  var shouldRejectClick = strategyOverrides.shouldRejectClick || defaultClickRejectionStrategy;
	
	  if (false) {
	    invariant(
	      !alreadyInjected,
	      'injectTapEventPlugin(): Can only be called once per application lifecycle.\n\n\
	It is recommended to call injectTapEventPlugin() just before you call \
	ReactDOM.render(). If you are using an external library which calls injectTapEventPlugin() \
	itself, please contact the maintainer as it shouldn\'t be called in library code and \
	should be injected by the application.'
	    )
	  }
	
	  alreadyInjected = true;
	
	  __webpack_require__(218).injection.injectEventPluginsByName({
	    'TapEventPlugin':       __webpack_require__(3101)(shouldRejectClick)
	  });
	};


/***/ },
/* 3105 */
/***/ function(module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var CHANNEL = exports.CHANNEL = '__direction__';
	
	var DIRECTIONS = exports.DIRECTIONS = {
	  LTR: 'ltr',
	  RTL: 'rtl'
	};

/***/ },
/* 3106 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(27);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _propTypes2['default'].shape({
	  getState: _propTypes2['default'].func,
	  setState: _propTypes2['default'].func,
	  subscribe: _propTypes2['default'].func
	});

/***/ },
/* 3107 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _arrayPrototype = __webpack_require__(1575);
	
	var _arrayPrototype2 = _interopRequireDefault(_arrayPrototype);
	
	var _globalCache = __webpack_require__(2780);
	
	var _globalCache2 = _interopRequireDefault(_globalCache);
	
	var _constants = __webpack_require__(3108);
	
	var _getClassName = __webpack_require__(3109);
	
	var _getClassName2 = _interopRequireDefault(_getClassName);
	
	var _separateStyles2 = __webpack_require__(3110);
	
	var _separateStyles3 = _interopRequireDefault(_separateStyles2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Function required as part of the react-with-styles interface. Parses the styles provided by
	 * react-with-styles to produce class names based on the style name and optionally the namespace if
	 * available.
	 *
	 * stylesObject {Object} The styles object passed to withStyles.
	 *
	 * Return an object mapping style names to class names.
	 */
	function create(stylesObject) {
	  var stylesToClasses = {};
	  var styleNames = Object.keys(stylesObject);
	  var sharedState = _globalCache2['default'].get(_constants.GLOBAL_CACHE_KEY) || {};
	  var _sharedState$namespac = sharedState.namespace,
	      namespace = _sharedState$namespac === undefined ? '' : _sharedState$namespac;
	
	  styleNames.forEach(function (styleName) {
	    var className = (0, _getClassName2['default'])(namespace, styleName);
	    stylesToClasses[styleName] = className;
	  });
	  return stylesToClasses;
	}
	
	/**
	 * Process styles to be consumed by a component.
	 *
	 * stylesArray {Array} Array of the following: values returned by create, plain JavaScript objects
	 * representing inline styles, or arrays thereof.
	 *
	 * Return an object with optional className and style properties to be spread on a component.
	 */
	function resolve(stylesArray) {
	  var flattenedStyles = (0, _arrayPrototype2['default'])(stylesArray, Infinity);
	
	  var _separateStyles = (0, _separateStyles3['default'])(flattenedStyles),
	      classNames = _separateStyles.classNames,
	      hasInlineStyles = _separateStyles.hasInlineStyles,
	      inlineStyles = _separateStyles.inlineStyles;
	
	  var specificClassNames = classNames.map(function (name, index) {
	    return String(name) + ' ' + String(name) + '_' + String(index + 1);
	  });
	  var className = specificClassNames.join(' ');
	
	  var result = { className: className };
	  if (hasInlineStyles) result.style = inlineStyles;
	  return result;
	}
	
	exports['default'] = { create: create, resolve: resolve };

/***/ },
/* 3108 */
/***/ function(module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var GLOBAL_CACHE_KEY = 'reactWithStylesInterfaceCSS';
	var MAX_SPECIFICITY = 20;
	
	exports.GLOBAL_CACHE_KEY = GLOBAL_CACHE_KEY;
	exports.MAX_SPECIFICITY = MAX_SPECIFICITY;

/***/ },
/* 3109 */
/***/ function(module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = getClassName;
	/**
	 * Construct a class name.
	 *
	 * namespace {String} Used to construct unique class names.
	 * styleName {String} Name identifying the specific style.
	 *
	 * Return the class name.
	 */
	function getClassName(namespace, styleName) {
	  var namespaceSegment = namespace.length > 0 ? String(namespace) + '__' : '';
	  return '' + namespaceSegment + String(styleName);
	}

/***/ },
/* 3110 */
/***/ function(module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// This function takes an array of styles and separates them into styles that
	// are handled by Aphrodite and inline styles.
	function separateStyles(stylesArray) {
	  var classNames = [];
	
	  // Since determining if an Object is empty requires collecting all of its
	  // keys, and we want the best performance in this code because we are in the
	  // render path, we are going to do a little bookkeeping ourselves.
	  var hasInlineStyles = false;
	  var inlineStyles = {};
	
	  // This is run on potentially every node in the tree when rendering, where
	  // performance is critical. Normally we would prefer using `forEach`, but
	  // old-fashioned for loops are faster so that's what we have chosen here.
	  for (var i = 0; i < stylesArray.length; i++) {
	    // eslint-disable-line no-plusplus
	    var style = stylesArray[i];
	
	    // If this  style is falsy, we just want to disregard it. This allows for
	    // syntax like:
	    //
	    //   css(isFoo && styles.foo)
	    if (style) {
	      if (typeof style === 'string') {
	        classNames.push(style);
	      } else {
	        Object.assign(inlineStyles, style);
	        hasInlineStyles = true;
	      }
	    }
	  }
	
	  return {
	    classNames: classNames,
	    hasInlineStyles: hasInlineStyles,
	    inlineStyles: inlineStyles
	  };
	}
	
	exports['default'] = separateStyles;

/***/ },
/* 3111 */
/***/ function(module, exports, __webpack_require__) {

	// eslint-disable-next-line import/no-unresolved
	module.exports = __webpack_require__(3107).default;


/***/ },
/* 3112 */,
/* 3113 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(29);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(105);
	
	var ReactTransitionGroup = __webpack_require__(3122);
	var ReactCSSTransitionGroupChild = __webpack_require__(3114);
	
	function createTransitionTimeoutPropValidator(transitionType) {
	  var timeoutPropName = 'transition' + transitionType + 'Timeout';
	  var enabledPropName = 'transition' + transitionType;
	
	  return function (props) {
	    // If the transition is enabled
	    if (props[enabledPropName]) {
	      // If no timeout duration is provided
	      if (props[timeoutPropName] == null) {
	        return new Error(timeoutPropName + ' wasn\'t supplied to ReactCSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');
	
	        // If the duration isn't a number
	      } else if (typeof props[timeoutPropName] !== 'number') {
	        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
	      }
	    }
	  };
	}
	
	/**
	 * An easy way to perform CSS transitions and animations when a React component
	 * enters or leaves the DOM.
	 * See https://facebook.github.io/react/docs/animation.html#high-level-api-reactcsstransitiongroup
	 */
	
	var ReactCSSTransitionGroup = function (_React$Component) {
	  _inherits(ReactCSSTransitionGroup, _React$Component);
	
	  function ReactCSSTransitionGroup() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ReactCSSTransitionGroup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._wrapChild = function (child) {
	      // We need to provide this childFactory so that
	      // ReactCSSTransitionGroupChild can receive updates to name, enter, and
	      // leave while it is leaving.
	      return React.createElement(ReactCSSTransitionGroupChild, {
	        name: _this.props.transitionName,
	        appear: _this.props.transitionAppear,
	        enter: _this.props.transitionEnter,
	        leave: _this.props.transitionLeave,
	        appearTimeout: _this.props.transitionAppearTimeout,
	        enterTimeout: _this.props.transitionEnterTimeout,
	        leaveTimeout: _this.props.transitionLeaveTimeout
	      }, child);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ReactCSSTransitionGroup.prototype.render = function render() {
	    return React.createElement(ReactTransitionGroup, _assign({}, this.props, { childFactory: this._wrapChild }));
	  };
	
	  return ReactCSSTransitionGroup;
	}(React.Component);
	
	ReactCSSTransitionGroup.displayName = 'ReactCSSTransitionGroup';
	ReactCSSTransitionGroup.propTypes = {
	  transitionName: ReactCSSTransitionGroupChild.propTypes.name,
	
	  transitionAppear: React.PropTypes.bool,
	  transitionEnter: React.PropTypes.bool,
	  transitionLeave: React.PropTypes.bool,
	  transitionAppearTimeout: createTransitionTimeoutPropValidator('Appear'),
	  transitionEnterTimeout: createTransitionTimeoutPropValidator('Enter'),
	  transitionLeaveTimeout: createTransitionTimeoutPropValidator('Leave')
	};
	ReactCSSTransitionGroup.defaultProps = {
	  transitionAppear: false,
	  transitionEnter: true,
	  transitionLeave: true
	};
	
	
	module.exports = ReactCSSTransitionGroup;

/***/ },
/* 3114 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(105);
	var ReactAddonsDOMDependencies = __webpack_require__(920);
	
	var CSSCore = __webpack_require__(2765);
	var ReactTransitionEvents = __webpack_require__(923);
	
	var onlyChild = __webpack_require__(926);
	
	var TICK = 17;
	
	var ReactCSSTransitionGroupChild = React.createClass({
	  displayName: 'ReactCSSTransitionGroupChild',
	
	  propTypes: {
	    name: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.shape({
	      enter: React.PropTypes.string,
	      leave: React.PropTypes.string,
	      active: React.PropTypes.string
	    }), React.PropTypes.shape({
	      enter: React.PropTypes.string,
	      enterActive: React.PropTypes.string,
	      leave: React.PropTypes.string,
	      leaveActive: React.PropTypes.string,
	      appear: React.PropTypes.string,
	      appearActive: React.PropTypes.string
	    })]).isRequired,
	
	    // Once we require timeouts to be specified, we can remove the
	    // boolean flags (appear etc.) and just accept a number
	    // or a bool for the timeout flags (appearTimeout etc.)
	    appear: React.PropTypes.bool,
	    enter: React.PropTypes.bool,
	    leave: React.PropTypes.bool,
	    appearTimeout: React.PropTypes.number,
	    enterTimeout: React.PropTypes.number,
	    leaveTimeout: React.PropTypes.number
	  },
	
	  transition: function (animationType, finishCallback, userSpecifiedDelay) {
	    var node = ReactAddonsDOMDependencies.getReactDOM().findDOMNode(this);
	
	    if (!node) {
	      if (finishCallback) {
	        finishCallback();
	      }
	      return;
	    }
	
	    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
	    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
	    var timeout = null;
	
	    var endListener = function (e) {
	      if (e && e.target !== node) {
	        return;
	      }
	
	      clearTimeout(timeout);
	
	      CSSCore.removeClass(node, className);
	      CSSCore.removeClass(node, activeClassName);
	
	      ReactTransitionEvents.removeEndEventListener(node, endListener);
	
	      // Usually this optional callback is used for informing an owner of
	      // a leave animation and telling it to remove the child.
	      if (finishCallback) {
	        finishCallback();
	      }
	    };
	
	    CSSCore.addClass(node, className);
	
	    // Need to do this to actually trigger a transition.
	    this.queueClassAndNode(activeClassName, node);
	
	    // If the user specified a timeout delay.
	    if (userSpecifiedDelay) {
	      // Clean-up the animation after the specified delay
	      timeout = setTimeout(endListener, userSpecifiedDelay);
	      this.transitionTimeouts.push(timeout);
	    } else {
	      // DEPRECATED: this listener will be removed in a future version of react
	      ReactTransitionEvents.addEndEventListener(node, endListener);
	    }
	  },
	
	  queueClassAndNode: function (className, node) {
	    this.classNameAndNodeQueue.push({
	      className: className,
	      node: node
	    });
	
	    if (!this.timeout) {
	      this.timeout = setTimeout(this.flushClassNameAndNodeQueue, TICK);
	    }
	  },
	
	  flushClassNameAndNodeQueue: function () {
	    if (this.isMounted()) {
	      this.classNameAndNodeQueue.forEach(function (obj) {
	        CSSCore.addClass(obj.node, obj.className);
	      });
	    }
	    this.classNameAndNodeQueue.length = 0;
	    this.timeout = null;
	  },
	
	  componentWillMount: function () {
	    this.classNameAndNodeQueue = [];
	    this.transitionTimeouts = [];
	  },
	
	  componentWillUnmount: function () {
	    if (this.timeout) {
	      clearTimeout(this.timeout);
	    }
	    this.transitionTimeouts.forEach(function (timeout) {
	      clearTimeout(timeout);
	    });
	
	    this.classNameAndNodeQueue.length = 0;
	  },
	
	  componentWillAppear: function (done) {
	    if (this.props.appear) {
	      this.transition('appear', done, this.props.appearTimeout);
	    } else {
	      done();
	    }
	  },
	
	  componentWillEnter: function (done) {
	    if (this.props.enter) {
	      this.transition('enter', done, this.props.enterTimeout);
	    } else {
	      done();
	    }
	  },
	
	  componentWillLeave: function (done) {
	    if (this.props.leave) {
	      this.transition('leave', done, this.props.leaveTimeout);
	    } else {
	      done();
	    }
	  },
	
	  render: function () {
	    return onlyChild(this.props.children);
	  }
	});
	
	module.exports = ReactCSSTransitionGroupChild;

/***/ },
/* 3115 */,
/* 3116 */,
/* 3117 */,
/* 3118 */,
/* 3119 */,
/* 3120 */,
/* 3121 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var flattenChildren = __webpack_require__(3124);
	
	var ReactTransitionChildMapping = {
	  /**
	   * Given `this.props.children`, return an object mapping key to child. Just
	   * simple syntactic sugar around flattenChildren().
	   *
	   * @param {*} children `this.props.children`
	   * @param {number=} selfDebugID Optional debugID of the current internal instance.
	   * @return {object} Mapping of key to child
	   */
	  getChildMapping: function (children, selfDebugID) {
	    if (!children) {
	      return children;
	    }
	
	    if (false) {
	      return flattenChildren(children, selfDebugID);
	    }
	
	    return flattenChildren(children);
	  },
	
	  /**
	   * When you're adding or removing children some may be added or removed in the
	   * same render pass. We want to show *both* since we want to simultaneously
	   * animate elements in and out. This function takes a previous set of keys
	   * and a new set of keys and merges them with its best guess of the correct
	   * ordering. In the future we may expose some of the utilities in
	   * ReactMultiChild to make this easy, but for now React itself does not
	   * directly have this concept of the union of prevChildren and nextChildren
	   * so we implement it here.
	   *
	   * @param {object} prev prev children as returned from
	   * `ReactTransitionChildMapping.getChildMapping()`.
	   * @param {object} next next children as returned from
	   * `ReactTransitionChildMapping.getChildMapping()`.
	   * @return {object} a key set that contains all keys in `prev` and all keys
	   * in `next` in a reasonable order.
	   */
	  mergeChildMappings: function (prev, next) {
	    prev = prev || {};
	    next = next || {};
	
	    function getValueForKey(key) {
	      if (next.hasOwnProperty(key)) {
	        return next[key];
	      } else {
	        return prev[key];
	      }
	    }
	
	    // For each key of `next`, the list of keys to insert before that key in
	    // the combined list
	    var nextKeysPending = {};
	
	    var pendingKeys = [];
	    for (var prevKey in prev) {
	      if (next.hasOwnProperty(prevKey)) {
	        if (pendingKeys.length) {
	          nextKeysPending[prevKey] = pendingKeys;
	          pendingKeys = [];
	        }
	      } else {
	        pendingKeys.push(prevKey);
	      }
	    }
	
	    var i;
	    var childMapping = {};
	    for (var nextKey in next) {
	      if (nextKeysPending.hasOwnProperty(nextKey)) {
	        for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	          var pendingNextKey = nextKeysPending[nextKey][i];
	          childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	        }
	      }
	      childMapping[nextKey] = getValueForKey(nextKey);
	    }
	
	    // Finally, add the keys which didn't appear before any key in `next`
	    for (i = 0; i < pendingKeys.length; i++) {
	      childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	    }
	
	    return childMapping;
	  }
	};
	
	module.exports = ReactTransitionChildMapping;

/***/ },
/* 3122 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(29);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(105);
	var ReactAddonsDOMDependencies = __webpack_require__(920);
	var ReactTransitionChildMapping = __webpack_require__(3121);
	
	var emptyFunction = __webpack_require__(80);
	
	/**
	 * A basis for animations. When children are declaratively added or removed,
	 * special lifecycle hooks are called.
	 * See https://facebook.github.io/react/docs/animation.html#low-level-api-reacttransitiongroup
	 */
	
	var ReactTransitionGroup = function (_React$Component) {
	  _inherits(ReactTransitionGroup, _React$Component);
	
	  function ReactTransitionGroup() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ReactTransitionGroup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      // TODO: can we get useful debug information to show at this point?
	      children: ReactTransitionChildMapping.getChildMapping(_this.props.children)
	    }, _this.performAppear = function (key) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      var component = _this.refs[key];
	
	      if (component.componentWillAppear) {
	        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key));
	      } else {
	        _this._handleDoneAppearing(key);
	      }
	    }, _this._handleDoneAppearing = function (key) {
	      var component = _this.refs[key];
	      if (component.componentDidAppear) {
	        component.componentDidAppear();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping;
	      if (false) {
	        currentChildMapping = ReactTransitionChildMapping.getChildMapping(_this.props.children, ReactAddonsDOMDependencies.getReactInstanceMap().get(_this)._debugID);
	      } else {
	        currentChildMapping = ReactTransitionChildMapping.getChildMapping(_this.props.children);
	      }
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully appeared. Remove it.
	        _this.performLeave(key);
	      }
	    }, _this.performEnter = function (key) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      var component = _this.refs[key];
	
	      if (component.componentWillEnter) {
	        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key));
	      } else {
	        _this._handleDoneEntering(key);
	      }
	    }, _this._handleDoneEntering = function (key) {
	      var component = _this.refs[key];
	      if (component.componentDidEnter) {
	        component.componentDidEnter();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping;
	      if (false) {
	        currentChildMapping = ReactTransitionChildMapping.getChildMapping(_this.props.children, ReactAddonsDOMDependencies.getReactInstanceMap().get(_this)._debugID);
	      } else {
	        currentChildMapping = ReactTransitionChildMapping.getChildMapping(_this.props.children);
	      }
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully entered. Remove it.
	        _this.performLeave(key);
	      }
	    }, _this.performLeave = function (key) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      var component = _this.refs[key];
	      if (component.componentWillLeave) {
	        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key));
	      } else {
	        // Note that this is somewhat dangerous b/c it calls setState()
	        // again, effectively mutating the component before all the work
	        // is done.
	        _this._handleDoneLeaving(key);
	      }
	    }, _this._handleDoneLeaving = function (key) {
	      var component = _this.refs[key];
	
	      if (component.componentDidLeave) {
	        component.componentDidLeave();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping;
	      if (false) {
	        currentChildMapping = ReactTransitionChildMapping.getChildMapping(_this.props.children, ReactAddonsDOMDependencies.getReactInstanceMap().get(_this)._debugID);
	      } else {
	        currentChildMapping = ReactTransitionChildMapping.getChildMapping(_this.props.children);
	      }
	
	      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
	        // This entered again before it fully left. Add it again.
	        _this.performEnter(key);
	      } else {
	        _this.setState(function (state) {
	          var newChildren = _assign({}, state.children);
	          delete newChildren[key];
	          return { children: newChildren };
	        });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ReactTransitionGroup.prototype.componentWillMount = function componentWillMount() {
	    this.currentlyTransitioningKeys = {};
	    this.keysToEnter = [];
	    this.keysToLeave = [];
	  };
	
	  ReactTransitionGroup.prototype.componentDidMount = function componentDidMount() {
	    var initialChildMapping = this.state.children;
	    for (var key in initialChildMapping) {
	      if (initialChildMapping[key]) {
	        this.performAppear(key);
	      }
	    }
	  };
	
	  ReactTransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var nextChildMapping;
	    if (false) {
	      nextChildMapping = ReactTransitionChildMapping.getChildMapping(nextProps.children, ReactAddonsDOMDependencies.getReactInstanceMap().get(this)._debugID);
	    } else {
	      nextChildMapping = ReactTransitionChildMapping.getChildMapping(nextProps.children);
	    }
	    var prevChildMapping = this.state.children;
	
	    this.setState({
	      children: ReactTransitionChildMapping.mergeChildMappings(prevChildMapping, nextChildMapping)
	    });
	
	    var key;
	
	    for (key in nextChildMapping) {
	      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
	      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
	        this.keysToEnter.push(key);
	      }
	    }
	
	    for (key in prevChildMapping) {
	      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(key);
	      if (prevChildMapping[key] && !hasNext && !this.currentlyTransitioningKeys[key]) {
	        this.keysToLeave.push(key);
	      }
	    }
	
	    // If we want to someday check for reordering, we could do it here.
	  };
	
	  ReactTransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
	    var keysToEnter = this.keysToEnter;
	    this.keysToEnter = [];
	    keysToEnter.forEach(this.performEnter);
	
	    var keysToLeave = this.keysToLeave;
	    this.keysToLeave = [];
	    keysToLeave.forEach(this.performLeave);
	  };
	
	  ReactTransitionGroup.prototype.render = function render() {
	    // TODO: we could get rid of the need for the wrapper node
	    // by cloning a single child
	    var childrenToRender = [];
	    for (var key in this.state.children) {
	      var child = this.state.children[key];
	      if (child) {
	        // You may need to apply reactive updates to a child as it is leaving.
	        // The normal React way to do it won't work since the child will have
	        // already been removed. In case you need this behavior you can provide
	        // a childFactory function to wrap every child, even the ones that are
	        // leaving.
	        childrenToRender.push(React.cloneElement(this.props.childFactory(child), { ref: key, key: key }));
	      }
	    }
	
	    // Do not forward ReactTransitionGroup props to primitive DOM nodes
	    var props = _assign({}, this.props);
	    delete props.transitionLeave;
	    delete props.transitionName;
	    delete props.transitionAppear;
	    delete props.transitionEnter;
	    delete props.childFactory;
	    delete props.transitionLeaveTimeout;
	    delete props.transitionEnterTimeout;
	    delete props.transitionAppearTimeout;
	    delete props.component;
	
	    return React.createElement(this.props.component, props, childrenToRender);
	  };
	
	  return ReactTransitionGroup;
	}(React.Component);
	
	ReactTransitionGroup.displayName = 'ReactTransitionGroup';
	ReactTransitionGroup.propTypes = {
	  component: React.PropTypes.any,
	  childFactory: React.PropTypes.func
	};
	ReactTransitionGroup.defaultProps = {
	  component: 'span',
	  childFactory: emptyFunction.thatReturnsArgument
	};
	
	
	module.exports = ReactTransitionGroup;

/***/ },
/* 3123 */,
/* 3124 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(919);
	var traverseAllChildren = __webpack_require__(927);
	var warning = __webpack_require__(26);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(498);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('./ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(164)))

/***/ },
/* 3125 */,
/* 3126 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = combineReducers;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	// TODO need to find a way to reference Redux's init for compatability
	var ActionTypes = { INIT: 'INIT' };
	var isImmutable = function isImmutable(obj) {
	  return _immutable2['default'].Iterable.isIterable(obj);
	};
	
	/* eslint-disable no-console */
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Reducer "' + key + '" returned undefined handling ' + actionName + '. ' + 'To ignore an action, you must explicitly return the previous state.';
	}
	
	function getUnexpectedStateKeyWarningMessage(inputState, outputState, action) {
	  var reducerKeys = Object.keys(outputState);
	  var argumentName = action && action.type === ActionTypes.INIT ? 'initialState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!isImmutable(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + ({}).toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = inputState.keySeq().filter(function (key) {
	    return reducerKeys.indexOf(key) < 0;
	  });
	
	  if (unexpectedKeys.size > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerSanity(reducers) {
	  reducers.keySeq().forEach(function (key) {
	    var reducer = reducers.get(key);
	    var initialState = reducer(undefined, { type: ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	
	function combineReducers(reducers) {
	  var finalReducers = isImmutable(reducers) ? reducers : _immutable2['default'].fromJS(reducers);
	  finalReducers = finalReducers.filter(function (v) {
	    return typeof v === 'function';
	  });
	  var sanityError;
	
	  try {
	    assertReducerSanity(finalReducers);
	  } catch (e) {
	    sanityError = e;
	  }
	
	  var defaultState = finalReducers.map(function (r) {
	    return undefined;
	  });
	
	  return function combination(state, action) {
	    if (state === undefined) state = defaultState;
	
	    if (sanityError) {
	      throw sanityError;
	    }
	
	    var dirty = false;
	    var finalState = finalReducers.map(function (reducer, key) {
	      var oldState = state.get(key);
	      var newState = reducer(oldState, action);
	      dirty = dirty || oldState !== newState;
	      if (typeof newState === 'undefined') {
	        throw new Error(getErrorMessage(key, action));
	      }
	      return newState;
	    });
	
	    if (false) {
	      var warningMessage = getUnexpectedStateKeyWarningMessage(state, finalState, action);
	      if (warningMessage) {
	        console.error(warningMessage);
	      }
	    }
	
	    return dirty ? finalState : state;
	  };
	}
	
	module.exports = exports['default'];

/***/ },
/* 3127 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = createReducer;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _immutable = __webpack_require__(7);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	/**
	 * Create a handler (action) map reducer for the given list of handlers
	 *
	 * @param  {object} initialState     The initial state of the reducer, expecting an Immutable.Iterable instance,
	 * otherwise given initialState is converted to immutable.
	 * @param  {object} handlers         A map of actions where key is action name and value is a reducer function
	 * @param  {boolean} enforceImmutable = true if to enforce immutable, in other words a TypeError is thrown in case
	 * a handler returned anything that is not an Immutable.Iterable type.
	 * @param  {function} constructor    A function to process non-immutable state, defaults to Immutable.fromJS.
	 * @return {object}                  The calculated next state
	 */
	
	function createReducer(initialState, handlers) {
	  var enforceImmutable = arguments.length <= 2 || arguments[2] === undefined ? true : arguments[2];
	  var constructor = arguments.length <= 3 || arguments[3] === undefined ? _immutable2['default'].fromJS.bind(_immutable2['default']) : arguments[3];
	
	  return function (state, action) {
	    if (state === undefined) state = initialState;
	
	    // convert the initial state to immutable
	    // This is useful in isomorphic apps where states were serialized
	    if (!_immutable2['default'].Iterable.isIterable(state)) {
	      state = constructor(state);
	    }
	
	    var handler = action && action.type ? handlers[action.type] : undefined;
	
	    if (!handler) {
	      return state;
	    }
	
	    state = handler(state, action);
	
	    if (enforceImmutable && !_immutable2['default'].Iterable.isIterable(state)) {
	      throw new TypeError('Reducers must return Immutable objects.');
	    }
	
	    return state;
	  };
	}
	
	module.exports = exports['default'];

/***/ },
/* 3128 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.combineEpics = undefined;
	
	var _merge = __webpack_require__(941);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	  Merges all epics into a single one.
	 */
	var combineEpics = exports.combineEpics = function combineEpics() {
	  for (var _len = arguments.length, epics = Array(_len), _key = 0; _key < _len; _key++) {
	    epics[_key] = arguments[_key];
	  }
	
	  return function () {
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    return _merge.merge.apply(undefined, _toConsumableArray(epics.map(function (epic) {
	      var output$ = epic.apply(undefined, args);
	      if (!output$) {
	        throw new TypeError('combineEpics: one of the provided Epics "' + (epic.name || '<anonymous>') + '" does not return a stream. Double check you\'re not missing a return statement!');
	      }
	      return output$;
	    })));
	  };
	};

/***/ },
/* 3129 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createEpicMiddleware = createEpicMiddleware;
	
	var _Subject = __webpack_require__(48);
	
	var _map = __webpack_require__(350);
	
	var _switchMap = __webpack_require__(950);
	
	var _ActionsObservable = __webpack_require__(928);
	
	var _EPIC_END = __webpack_require__(929);
	
	var defaultAdapter = {
	  input: function input(action$) {
	    return action$;
	  },
	  output: function output(action$) {
	    return action$;
	  }
	};
	
	var defaultOptions = {
	  adapter: defaultAdapter
	};
	
	function createEpicMiddleware(epic) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultOptions,
	      _ref$adapter = _ref.adapter,
	      adapter = _ref$adapter === undefined ? defaultAdapter : _ref$adapter;
	
	  if (typeof epic !== 'function') {
	    throw new TypeError('You must provide a root Epic to createEpicMiddleware');
	  }
	
	  var input$ = new _Subject.Subject();
	  var action$ = adapter.input(new _ActionsObservable.ActionsObservable(input$));
	  var epic$ = new _Subject.Subject();
	  var store = void 0;
	
	  var epicMiddleware = function epicMiddleware(_store) {
	    store = _store;
	
	    return function (next) {
	      var _context;
	
	      (_context = _map.map.call(epic$, function (epic) {
	        var output$ = epic(action$, store);
	        if (!output$) {
	          throw new TypeError('Your root Epic "' + (epic.name || '<anonymous>') + '" does not return a stream. Double check you\'re not missing a return statement!');
	        }
	        return output$;
	      }), _switchMap.switchMap).call(_context, function (output$) {
	        return adapter.output(output$);
	      }).subscribe(store.dispatch);
	
	      // Setup initial root epic
	      epic$.next(epic);
	
	      return function (action) {
	        var result = next(action);
	        input$.next(action);
	        return result;
	      };
	    };
	  };
	
	  epicMiddleware.replaceEpic = function (epic) {
	    // gives the previous root Epic a last chance
	    // to do some clean up
	    store.dispatch({ type: _EPIC_END.EPIC_END });
	    // switches to the new root Epic, synchronously terminating
	    // the previous one
	    epic$.next(epic);
	  };
	
	  return epicMiddleware;
	}

/***/ },
/* 3130 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createEpicMiddleware = __webpack_require__(3129);
	
	Object.defineProperty(exports, 'createEpicMiddleware', {
	  enumerable: true,
	  get: function get() {
	    return _createEpicMiddleware.createEpicMiddleware;
	  }
	});
	
	var _ActionsObservable = __webpack_require__(928);
	
	Object.defineProperty(exports, 'ActionsObservable', {
	  enumerable: true,
	  get: function get() {
	    return _ActionsObservable.ActionsObservable;
	  }
	});
	
	var _combineEpics = __webpack_require__(3128);
	
	Object.defineProperty(exports, 'combineEpics', {
	  enumerable: true,
	  get: function get() {
	    return _combineEpics.combineEpics;
	  }
	});
	
	var _EPIC_END = __webpack_require__(929);
	
	Object.defineProperty(exports, 'EPIC_END', {
	  enumerable: true,
	  get: function get() {
	    return _EPIC_END.EPIC_END;
	  }
	});

/***/ },
/* 3131 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function createThunkMiddleware(extraArgument) {
	  return function (_ref) {
	    var dispatch = _ref.dispatch,
	        getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        if (typeof action === 'function') {
	          return action(dispatch, getState, extraArgument);
	        }
	
	        return next(action);
	      };
	    };
	  };
	}
	
	var thunk = createThunkMiddleware();
	thunk.withExtraArgument = createThunkMiddleware;
	
	exports['default'] = thunk;

/***/ },
/* 3132 */,
/* 3133 */,
/* 3134 */,
/* 3135 */,
/* 3136 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Check if we're required to add a port number.
	 *
	 * @see https://url.spec.whatwg.org/#default-port
	 * @param {Number|String} port Port number we need to check
	 * @param {String} protocol Protocol we need to check against.
	 * @returns {Boolean} Is it a default port for the given protocol
	 * @api private
	 */
	module.exports = function required(port, protocol) {
	  protocol = protocol.split(':')[0];
	  port = +port;
	
	  if (!port) return false;
	
	  switch (protocol) {
	    case 'http':
	    case 'ws':
	    return port !== 80;
	
	    case 'https':
	    case 'wss':
	    return port !== 443;
	
	    case 'ftp':
	    return port !== 21;
	
	    case 'gopher':
	    return port !== 70;
	
	    case 'file':
	    return false;
	  }
	
	  return port !== 0;
	};


/***/ },
/* 3137 */,
/* 3138 */,
/* 3139 */,
/* 3140 */,
/* 3141 */,
/* 3142 */,
/* 3143 */,
/* 3144 */,
/* 3145 */,
/* 3146 */,
/* 3147 */,
/* 3148 */,
/* 3149 */,
/* 3150 */,
/* 3151 */,
/* 3152 */,
/* 3153 */,
/* 3154 */,
/* 3155 */,
/* 3156 */,
/* 3157 */,
/* 3158 */,
/* 3159 */,
/* 3160 */,
/* 3161 */,
/* 3162 */,
/* 3163 */,
/* 3164 */,
/* 3165 */,
/* 3166 */,
/* 3167 */,
/* 3168 */,
/* 3169 */,
/* 3170 */,
/* 3171 */,
/* 3172 */,
/* 3173 */,
/* 3174 */,
/* 3175 */,
/* 3176 */,
/* 3177 */,
/* 3178 */,
/* 3179 */,
/* 3180 */,
/* 3181 */,
/* 3182 */,
/* 3183 */,
/* 3184 */,
/* 3185 */,
/* 3186 */,
/* 3187 */,
/* 3188 */,
/* 3189 */,
/* 3190 */,
/* 3191 */,
/* 3192 */,
/* 3193 */,
/* 3194 */,
/* 3195 */,
/* 3196 */,
/* 3197 */,
/* 3198 */,
/* 3199 */,
/* 3200 */,
/* 3201 */,
/* 3202 */,
/* 3203 */,
/* 3204 */,
/* 3205 */,
/* 3206 */,
/* 3207 */,
/* 3208 */,
/* 3209 */,
/* 3210 */,
/* 3211 */,
/* 3212 */,
/* 3213 */,
/* 3214 */,
/* 3215 */,
/* 3216 */,
/* 3217 */,
/* 3218 */,
/* 3219 */,
/* 3220 */,
/* 3221 */,
/* 3222 */,
/* 3223 */,
/* 3224 */,
/* 3225 */,
/* 3226 */,
/* 3227 */,
/* 3228 */,
/* 3229 */,
/* 3230 */,
/* 3231 */,
/* 3232 */,
/* 3233 */,
/* 3234 */,
/* 3235 */,
/* 3236 */,
/* 3237 */,
/* 3238 */,
/* 3239 */,
/* 3240 */,
/* 3241 */,
/* 3242 */,
/* 3243 */,
/* 3244 */,
/* 3245 */,
/* 3246 */,
/* 3247 */,
/* 3248 */,
/* 3249 */,
/* 3250 */,
/* 3251 */,
/* 3252 */,
/* 3253 */,
/* 3254 */,
/* 3255 */,
/* 3256 */,
/* 3257 */,
/* 3258 */,
/* 3259 */,
/* 3260 */,
/* 3261 */,
/* 3262 */,
/* 3263 */,
/* 3264 */,
/* 3265 */,
/* 3266 */,
/* 3267 */,
/* 3268 */,
/* 3269 */,
/* 3270 */,
/* 3271 */,
/* 3272 */,
/* 3273 */,
/* 3274 */,
/* 3275 */,
/* 3276 */,
/* 3277 */,
/* 3278 */,
/* 3279 */,
/* 3280 */,
/* 3281 */,
/* 3282 */,
/* 3283 */,
/* 3284 */,
/* 3285 */,
/* 3286 */,
/* 3287 */,
/* 3288 */,
/* 3289 */,
/* 3290 */,
/* 3291 */,
/* 3292 */,
/* 3293 */,
/* 3294 */,
/* 3295 */,
/* 3296 */,
/* 3297 */,
/* 3298 */,
/* 3299 */,
/* 3300 */,
/* 3301 */,
/* 3302 */,
/* 3303 */,
/* 3304 */,
/* 3305 */,
/* 3306 */,
/* 3307 */,
/* 3308 */,
/* 3309 */,
/* 3310 */,
/* 3311 */,
/* 3312 */,
/* 3313 */,
/* 3314 */,
/* 3315 */,
/* 3316 */,
/* 3317 */,
/* 3318 */,
/* 3319 */,
/* 3320 */,
/* 3321 */,
/* 3322 */,
/* 3323 */,
/* 3324 */,
/* 3325 */,
/* 3326 */,
/* 3327 */,
/* 3328 */,
/* 3329 */,
/* 3330 */,
/* 3331 */,
/* 3332 */,
/* 3333 */,
/* 3334 */,
/* 3335 */,
/* 3336 */,
/* 3337 */,
/* 3338 */,
/* 3339 */,
/* 3340 */,
/* 3341 */,
/* 3342 */,
/* 3343 */,
/* 3344 */,
/* 3345 */,
/* 3346 */,
/* 3347 */,
/* 3348 */,
/* 3349 */,
/* 3350 */,
/* 3351 */,
/* 3352 */,
/* 3353 */,
/* 3354 */,
/* 3355 */,
/* 3356 */,
/* 3357 */,
/* 3358 */,
/* 3359 */,
/* 3360 */,
/* 3361 */,
/* 3362 */,
/* 3363 */,
/* 3364 */,
/* 3365 */,
/* 3366 */,
/* 3367 */,
/* 3368 */,
/* 3369 */,
/* 3370 */,
/* 3371 */,
/* 3372 */,
/* 3373 */,
/* 3374 */,
/* 3375 */,
/* 3376 */,
/* 3377 */,
/* 3378 */,
/* 3379 */,
/* 3380 */,
/* 3381 */,
/* 3382 */,
/* 3383 */,
/* 3384 */,
/* 3385 */,
/* 3386 */,
/* 3387 */,
/* 3388 */,
/* 3389 */,
/* 3390 */,
/* 3391 */,
/* 3392 */,
/* 3393 */,
/* 3394 */,
/* 3395 */,
/* 3396 */,
/* 3397 */,
/* 3398 */,
/* 3399 */,
/* 3400 */,
/* 3401 */,
/* 3402 */,
/* 3403 */,
/* 3404 */,
/* 3405 */,
/* 3406 */,
/* 3407 */,
/* 3408 */,
/* 3409 */,
/* 3410 */
/***/ function(module, exports) {

	module.exports = /([\u0061-\u007A\u00B5\u00DF-\u00F6\u00F8-\u00FF\u0101\u0103\u0105\u0107\u0109\u010B\u010D\u010F\u0111\u0113\u0115\u0117\u0119\u011B\u011D\u011F\u0121\u0123\u0125\u0127\u0129\u012B\u012D\u012F\u0131\u0133\u0135\u0137\u0138\u013A\u013C\u013E\u0140\u0142\u0144\u0146\u0148\u0149\u014B\u014D\u014F\u0151\u0153\u0155\u0157\u0159\u015B\u015D\u015F\u0161\u0163\u0165\u0167\u0169\u016B\u016D\u016F\u0171\u0173\u0175\u0177\u017A\u017C\u017E-\u0180\u0183\u0185\u0188\u018C\u018D\u0192\u0195\u0199-\u019B\u019E\u01A1\u01A3\u01A5\u01A8\u01AA\u01AB\u01AD\u01B0\u01B4\u01B6\u01B9\u01BA\u01BD-\u01BF\u01C6\u01C9\u01CC\u01CE\u01D0\u01D2\u01D4\u01D6\u01D8\u01DA\u01DC\u01DD\u01DF\u01E1\u01E3\u01E5\u01E7\u01E9\u01EB\u01ED\u01EF\u01F0\u01F3\u01F5\u01F9\u01FB\u01FD\u01FF\u0201\u0203\u0205\u0207\u0209\u020B\u020D\u020F\u0211\u0213\u0215\u0217\u0219\u021B\u021D\u021F\u0221\u0223\u0225\u0227\u0229\u022B\u022D\u022F\u0231\u0233-\u0239\u023C\u023F\u0240\u0242\u0247\u0249\u024B\u024D\u024F-\u0293\u0295-\u02AF\u0371\u0373\u0377\u037B-\u037D\u0390\u03AC-\u03CE\u03D0\u03D1\u03D5-\u03D7\u03D9\u03DB\u03DD\u03DF\u03E1\u03E3\u03E5\u03E7\u03E9\u03EB\u03ED\u03EF-\u03F3\u03F5\u03F8\u03FB\u03FC\u0430-\u045F\u0461\u0463\u0465\u0467\u0469\u046B\u046D\u046F\u0471\u0473\u0475\u0477\u0479\u047B\u047D\u047F\u0481\u048B\u048D\u048F\u0491\u0493\u0495\u0497\u0499\u049B\u049D\u049F\u04A1\u04A3\u04A5\u04A7\u04A9\u04AB\u04AD\u04AF\u04B1\u04B3\u04B5\u04B7\u04B9\u04BB\u04BD\u04BF\u04C2\u04C4\u04C6\u04C8\u04CA\u04CC\u04CE\u04CF\u04D1\u04D3\u04D5\u04D7\u04D9\u04DB\u04DD\u04DF\u04E1\u04E3\u04E5\u04E7\u04E9\u04EB\u04ED\u04EF\u04F1\u04F3\u04F5\u04F7\u04F9\u04FB\u04FD\u04FF\u0501\u0503\u0505\u0507\u0509\u050B\u050D\u050F\u0511\u0513\u0515\u0517\u0519\u051B\u051D\u051F\u0521\u0523\u0525\u0527\u0561-\u0587\u1D00-\u1D2B\u1D6B-\u1D77\u1D79-\u1D9A\u1E01\u1E03\u1E05\u1E07\u1E09\u1E0B\u1E0D\u1E0F\u1E11\u1E13\u1E15\u1E17\u1E19\u1E1B\u1E1D\u1E1F\u1E21\u1E23\u1E25\u1E27\u1E29\u1E2B\u1E2D\u1E2F\u1E31\u1E33\u1E35\u1E37\u1E39\u1E3B\u1E3D\u1E3F\u1E41\u1E43\u1E45\u1E47\u1E49\u1E4B\u1E4D\u1E4F\u1E51\u1E53\u1E55\u1E57\u1E59\u1E5B\u1E5D\u1E5F\u1E61\u1E63\u1E65\u1E67\u1E69\u1E6B\u1E6D\u1E6F\u1E71\u1E73\u1E75\u1E77\u1E79\u1E7B\u1E7D\u1E7F\u1E81\u1E83\u1E85\u1E87\u1E89\u1E8B\u1E8D\u1E8F\u1E91\u1E93\u1E95-\u1E9D\u1E9F\u1EA1\u1EA3\u1EA5\u1EA7\u1EA9\u1EAB\u1EAD\u1EAF\u1EB1\u1EB3\u1EB5\u1EB7\u1EB9\u1EBB\u1EBD\u1EBF\u1EC1\u1EC3\u1EC5\u1EC7\u1EC9\u1ECB\u1ECD\u1ECF\u1ED1\u1ED3\u1ED5\u1ED7\u1ED9\u1EDB\u1EDD\u1EDF\u1EE1\u1EE3\u1EE5\u1EE7\u1EE9\u1EEB\u1EED\u1EEF\u1EF1\u1EF3\u1EF5\u1EF7\u1EF9\u1EFB\u1EFD\u1EFF-\u1F07\u1F10-\u1F15\u1F20-\u1F27\u1F30-\u1F37\u1F40-\u1F45\u1F50-\u1F57\u1F60-\u1F67\u1F70-\u1F7D\u1F80-\u1F87\u1F90-\u1F97\u1FA0-\u1FA7\u1FB0-\u1FB4\u1FB6\u1FB7\u1FBE\u1FC2-\u1FC4\u1FC6\u1FC7\u1FD0-\u1FD3\u1FD6\u1FD7\u1FE0-\u1FE7\u1FF2-\u1FF4\u1FF6\u1FF7\u210A\u210E\u210F\u2113\u212F\u2134\u2139\u213C\u213D\u2146-\u2149\u214E\u2184\u2C30-\u2C5E\u2C61\u2C65\u2C66\u2C68\u2C6A\u2C6C\u2C71\u2C73\u2C74\u2C76-\u2C7B\u2C81\u2C83\u2C85\u2C87\u2C89\u2C8B\u2C8D\u2C8F\u2C91\u2C93\u2C95\u2C97\u2C99\u2C9B\u2C9D\u2C9F\u2CA1\u2CA3\u2CA5\u2CA7\u2CA9\u2CAB\u2CAD\u2CAF\u2CB1\u2CB3\u2CB5\u2CB7\u2CB9\u2CBB\u2CBD\u2CBF\u2CC1\u2CC3\u2CC5\u2CC7\u2CC9\u2CCB\u2CCD\u2CCF\u2CD1\u2CD3\u2CD5\u2CD7\u2CD9\u2CDB\u2CDD\u2CDF\u2CE1\u2CE3\u2CE4\u2CEC\u2CEE\u2CF3\u2D00-\u2D25\u2D27\u2D2D\uA641\uA643\uA645\uA647\uA649\uA64B\uA64D\uA64F\uA651\uA653\uA655\uA657\uA659\uA65B\uA65D\uA65F\uA661\uA663\uA665\uA667\uA669\uA66B\uA66D\uA681\uA683\uA685\uA687\uA689\uA68B\uA68D\uA68F\uA691\uA693\uA695\uA697\uA723\uA725\uA727\uA729\uA72B\uA72D\uA72F-\uA731\uA733\uA735\uA737\uA739\uA73B\uA73D\uA73F\uA741\uA743\uA745\uA747\uA749\uA74B\uA74D\uA74F\uA751\uA753\uA755\uA757\uA759\uA75B\uA75D\uA75F\uA761\uA763\uA765\uA767\uA769\uA76B\uA76D\uA76F\uA771-\uA778\uA77A\uA77C\uA77F\uA781\uA783\uA785\uA787\uA78C\uA78E\uA791\uA793\uA7A1\uA7A3\uA7A5\uA7A7\uA7A9\uA7FA\uFB00-\uFB06\uFB13-\uFB17\uFF41-\uFF5A])([\u0041-\u005A\u00C0-\u00D6\u00D8-\u00DE\u0100\u0102\u0104\u0106\u0108\u010A\u010C\u010E\u0110\u0112\u0114\u0116\u0118\u011A\u011C\u011E\u0120\u0122\u0124\u0126\u0128\u012A\u012C\u012E\u0130\u0132\u0134\u0136\u0139\u013B\u013D\u013F\u0141\u0143\u0145\u0147\u014A\u014C\u014E\u0150\u0152\u0154\u0156\u0158\u015A\u015C\u015E\u0160\u0162\u0164\u0166\u0168\u016A\u016C\u016E\u0170\u0172\u0174\u0176\u0178\u0179\u017B\u017D\u0181\u0182\u0184\u0186\u0187\u0189-\u018B\u018E-\u0191\u0193\u0194\u0196-\u0198\u019C\u019D\u019F\u01A0\u01A2\u01A4\u01A6\u01A7\u01A9\u01AC\u01AE\u01AF\u01B1-\u01B3\u01B5\u01B7\u01B8\u01BC\u01C4\u01C7\u01CA\u01CD\u01CF\u01D1\u01D3\u01D5\u01D7\u01D9\u01DB\u01DE\u01E0\u01E2\u01E4\u01E6\u01E8\u01EA\u01EC\u01EE\u01F1\u01F4\u01F6-\u01F8\u01FA\u01FC\u01FE\u0200\u0202\u0204\u0206\u0208\u020A\u020C\u020E\u0210\u0212\u0214\u0216\u0218\u021A\u021C\u021E\u0220\u0222\u0224\u0226\u0228\u022A\u022C\u022E\u0230\u0232\u023A\u023B\u023D\u023E\u0241\u0243-\u0246\u0248\u024A\u024C\u024E\u0370\u0372\u0376\u0386\u0388-\u038A\u038C\u038E\u038F\u0391-\u03A1\u03A3-\u03AB\u03CF\u03D2-\u03D4\u03D8\u03DA\u03DC\u03DE\u03E0\u03E2\u03E4\u03E6\u03E8\u03EA\u03EC\u03EE\u03F4\u03F7\u03F9\u03FA\u03FD-\u042F\u0460\u0462\u0464\u0466\u0468\u046A\u046C\u046E\u0470\u0472\u0474\u0476\u0478\u047A\u047C\u047E\u0480\u048A\u048C\u048E\u0490\u0492\u0494\u0496\u0498\u049A\u049C\u049E\u04A0\u04A2\u04A4\u04A6\u04A8\u04AA\u04AC\u04AE\u04B0\u04B2\u04B4\u04B6\u04B8\u04BA\u04BC\u04BE\u04C0\u04C1\u04C3\u04C5\u04C7\u04C9\u04CB\u04CD\u04D0\u04D2\u04D4\u04D6\u04D8\u04DA\u04DC\u04DE\u04E0\u04E2\u04E4\u04E6\u04E8\u04EA\u04EC\u04EE\u04F0\u04F2\u04F4\u04F6\u04F8\u04FA\u04FC\u04FE\u0500\u0502\u0504\u0506\u0508\u050A\u050C\u050E\u0510\u0512\u0514\u0516\u0518\u051A\u051C\u051E\u0520\u0522\u0524\u0526\u0531-\u0556\u10A0-\u10C5\u10C7\u10CD\u1E00\u1E02\u1E04\u1E06\u1E08\u1E0A\u1E0C\u1E0E\u1E10\u1E12\u1E14\u1E16\u1E18\u1E1A\u1E1C\u1E1E\u1E20\u1E22\u1E24\u1E26\u1E28\u1E2A\u1E2C\u1E2E\u1E30\u1E32\u1E34\u1E36\u1E38\u1E3A\u1E3C\u1E3E\u1E40\u1E42\u1E44\u1E46\u1E48\u1E4A\u1E4C\u1E4E\u1E50\u1E52\u1E54\u1E56\u1E58\u1E5A\u1E5C\u1E5E\u1E60\u1E62\u1E64\u1E66\u1E68\u1E6A\u1E6C\u1E6E\u1E70\u1E72\u1E74\u1E76\u1E78\u1E7A\u1E7C\u1E7E\u1E80\u1E82\u1E84\u1E86\u1E88\u1E8A\u1E8C\u1E8E\u1E90\u1E92\u1E94\u1E9E\u1EA0\u1EA2\u1EA4\u1EA6\u1EA8\u1EAA\u1EAC\u1EAE\u1EB0\u1EB2\u1EB4\u1EB6\u1EB8\u1EBA\u1EBC\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1EC8\u1ECA\u1ECC\u1ECE\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EDA\u1EDC\u1EDE\u1EE0\u1EE2\u1EE4\u1EE6\u1EE8\u1EEA\u1EEC\u1EEE\u1EF0\u1EF2\u1EF4\u1EF6\u1EF8\u1EFA\u1EFC\u1EFE\u1F08-\u1F0F\u1F18-\u1F1D\u1F28-\u1F2F\u1F38-\u1F3F\u1F48-\u1F4D\u1F59\u1F5B\u1F5D\u1F5F\u1F68-\u1F6F\u1FB8-\u1FBB\u1FC8-\u1FCB\u1FD8-\u1FDB\u1FE8-\u1FEC\u1FF8-\u1FFB\u2102\u2107\u210B-\u210D\u2110-\u2112\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u2130-\u2133\u213E\u213F\u2145\u2183\u2C00-\u2C2E\u2C60\u2C62-\u2C64\u2C67\u2C69\u2C6B\u2C6D-\u2C70\u2C72\u2C75\u2C7E-\u2C80\u2C82\u2C84\u2C86\u2C88\u2C8A\u2C8C\u2C8E\u2C90\u2C92\u2C94\u2C96\u2C98\u2C9A\u2C9C\u2C9E\u2CA0\u2CA2\u2CA4\u2CA6\u2CA8\u2CAA\u2CAC\u2CAE\u2CB0\u2CB2\u2CB4\u2CB6\u2CB8\u2CBA\u2CBC\u2CBE\u2CC0\u2CC2\u2CC4\u2CC6\u2CC8\u2CCA\u2CCC\u2CCE\u2CD0\u2CD2\u2CD4\u2CD6\u2CD8\u2CDA\u2CDC\u2CDE\u2CE0\u2CE2\u2CEB\u2CED\u2CF2\uA640\uA642\uA644\uA646\uA648\uA64A\uA64C\uA64E\uA650\uA652\uA654\uA656\uA658\uA65A\uA65C\uA65E\uA660\uA662\uA664\uA666\uA668\uA66A\uA66C\uA680\uA682\uA684\uA686\uA688\uA68A\uA68C\uA68E\uA690\uA692\uA694\uA696\uA722\uA724\uA726\uA728\uA72A\uA72C\uA72E\uA732\uA734\uA736\uA738\uA73A\uA73C\uA73E\uA740\uA742\uA744\uA746\uA748\uA74A\uA74C\uA74E\uA750\uA752\uA754\uA756\uA758\uA75A\uA75C\uA75E\uA760\uA762\uA764\uA766\uA768\uA76A\uA76C\uA76E\uA779\uA77B\uA77D\uA77E\uA780\uA782\uA784\uA786\uA78B\uA78D\uA790\uA792\uA7A0\uA7A2\uA7A4\uA7A6\uA7A8\uA7AA\uFF21-\uFF3A\u0030-\u0039\u00B2\u00B3\u00B9\u00BC-\u00BE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D66-\u0D75\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19])/g


/***/ },
/* 3411 */
/***/ function(module, exports) {

	module.exports = /[^\u0041-\u005A\u0061-\u007A\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC\u0030-\u0039\u00B2\u00B3\u00B9\u00BC-\u00BE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D66-\u0D75\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19]+/g


/***/ },
/* 3412 */
/***/ function(module, exports) {

	module.exports = /([\u0030-\u0039\u00B2\u00B3\u00B9\u00BC-\u00BE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D66-\u0D75\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19])([^\u0030-\u0039\u00B2\u00B3\u00B9\u00BC-\u00BE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D66-\u0D75\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19])/g


/***/ },
/* 3413 */,
/* 3414 */,
/* 3415 */
/***/ function(module, exports) {

	var camel2hyphen = function (str) {
	  return str
	          .replace(/[A-Z]/g, function (match) {
	            return '-' + match.toLowerCase();
	          })
	          .toLowerCase();
	};
	
	module.exports = camel2hyphen;

/***/ },
/* 3416 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var removeCallback = function removeCallback(_ref) {
	  var script = _ref.script,
	      callbackName = _ref.callbackName,
	      timeout = _ref.timeout;
	
	  if (script && script.parentNode) script.parentNode.removeChild(script);
	
	  delete window[callbackName];
	
	  clearTimeout(timeout); // clear timeout (for onerror event listener)
	};
	
	var jsonp = function jsonp(requestOrConfig) {
	  var end = function end() {
	    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    return function handler(callback) {
	      var _this = this;
	
	      var callbackParam = config.callbackParam || 'callback';
	      var callbackName = config.callbackName || 'superagentCallback' + (new Date().valueOf() + parseInt(Math.random() * 1000, 10));
	      var timeoutLimit = config.timeout || 1000;
	
	      var timeout = setTimeout(jsonp.errorWrapper.bind(this), timeoutLimit);
	
	      this._jsonp = {
	        callbackName: callbackName,
	        callback: callback,
	        timeout: timeout
	      };
	
	      window[callbackName] = jsonp.callbackWrapper.bind(this);
	
	      this._query.push(encodeURIComponent(callbackParam) + '=' + encodeURIComponent(callbackName));
	      var queryString = this._query.join('&');
	
	      var s = document.createElement('script');
	      {
	        var separator = this.url.indexOf('?') > -1 ? '&' : '?';
	        var url = this.url + separator + queryString;
	
	        s.src = url;
	
	        // Handle script load error #27
	        s.onerror = function (e) {
	          jsonp.errorWrapper.call(_this, e);
	        };
	      }
	
	      document.head.appendChild(s);
	      this._jsonp.script = s;
	
	      return this;
	    };
	  };
	
	  var reqFunc = function reqFunc(request) {
	    // In case this is in nodejs, run without modifying request
	    if (typeof window === 'undefined') return request;
	
	    request.end = end.call(request, requestOrConfig);
	    return request;
	  };
	
	  // if requestOrConfig is request
	  if (typeof requestOrConfig.end === 'function') {
	    return reqFunc(requestOrConfig);
	  }
	
	  return reqFunc;
	};
	
	jsonp.callbackWrapper = function callbackWrapper(body) {
	  var err = null;
	  var res = { body: body };
	
	  removeCallback(this._jsonp);
	
	  this._jsonp.callback.call(this, err, res);
	};
	
	jsonp.errorWrapper = function errorWrapper(error) {
	  var err = new Error('404 Not found');
	  if (error && error instanceof Event && error.type === 'error') {
	    err = new Error('Connection issue');
	  }
	
	  removeCallback(this._jsonp);
	
	  this._jsonp.callback.call(this, err, null);
	};
	
	// Prefer node/browserify style requires
	if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
	  module.exports = jsonp;
	} else if (true) {
	  !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return { jsonp: jsonp };
	  }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof window !== 'undefined') {
	  window.superagentJSONP = jsonp;
	}

/***/ },
/* 3417 */
/***/ function(module, exports, __webpack_require__) {

	var upperCase = __webpack_require__(172)
	var lowerCase = __webpack_require__(257)
	
	/**
	 * Swap the case of a string. Manually iterate over every character and check
	 * instead of replacing certain characters for better unicode support.
	 *
	 * @param  {String} str
	 * @param  {String} [locale]
	 * @return {String}
	 */
	module.exports = function (str, locale) {
	  if (str == null) {
	    return ''
	  }
	
	  var result = ''
	
	  for (var i = 0; i < str.length; i++) {
	    var c = str[i]
	    var u = upperCase(c, locale)
	
	    result += u === c ? lowerCase(c, locale) : u
	  }
	
	  return result
	}


/***/ },
/* 3418 */,
/* 3419 */,
/* 3420 */
/***/ function(module, exports, __webpack_require__) {

	var upperCase = __webpack_require__(172)
	var sentenceCase = __webpack_require__(171)
	
	/**
	 * Title case a string.
	 *
	 * @param  {String} string
	 * @param  {String} [locale]
	 * @return {String}
	 */
	module.exports = function (str, locale) {
	  return sentenceCase(str, locale).replace(/^.| ./g, function (m) {
	    return upperCase(m, locale)
	  })
	}


/***/ },
/* 3421 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 3422 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 3423 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 3424 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 3425 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJsAAADZCAIAAAC4k9W8AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAADBdJREFUeNrsnVtPFEsUhYdxVBDOKHIxII54yRhNiA/+/3+ATxpIMHgbYMQLHDiOOoB4VnqfU+l0d/X0par6ttYDGUgzU9Nf1a69d+2qntrc3GxRNVKbt4BEKRKlSJQiUYpESZQiUYpEKRKlSJREKRKlSJQiUYpESZQiUYpEKRKlSJREKRKlSJQiUYpESZQiUYpEKRKlSJREKRKlSJQiUYpEKRIlUYpEKRKlSJQiURKlSJQiUYpEKRIlUYpEKRKlSJQiURKlSJQiUYpEqeKIXrly5dq1a7y5hdyojo2G3rhxo9/vn52d/fO/8Jr8FMW/PM3NzeFGDYfDg4ODshMVofcteMJrEP3x4wfQfv/+HS+aRhG3AgjBTyha/ayOs68E3bp1C69///4tA7fedIWiyOUc1CnE7NzypOj+/PlTGFedIsbfzMyMe4oFE42ku7Kygl9l4FaLrthSoYivU3h7OqW6O3JfAnRhmTGUSbGSRHV0AVWN3aLo+h3UslGsBtHAmICWl5cd01UU8bMqs0CnVTUF6CqvykjIK8GiMqpV9M6cEn358qXZGUjoqpA3W0IjEPKb/cp+b+DRo0cOeonrMfrD0+fPn437F4GEhtxEXciLi/HptikW4rEXaXXDdOUu54/k/HRVQgP2WUX9ZoNFfIR/dq+k1e33+34Dgq+xs7OTn66NbIs/oWGWoo3M1+rqqrj3/qmq8p4RbOY3T366MzMztjOiRVFslq/rp2vVhYlpQLVWkKoUvWCI/O3JNt1KrwNWLx4N0zWSClCOcdVXczutWsjvZCanW4bkIommpgu3PHzNYDDA3Fwbin7VvHJMFx0iNq0lzhZrAUmUIlGKRKkK+7rwRdfX11UmvdKlgf6kx8nJidkq3CpFL5HrJFUp/NSlnUGU8eh/3TxQ+FlCukUV4laDKLCdnZ1F3pcA3WIXIFMt36K14/G4oUTB6dWrVxM3EagpymVZb6oSi/JsAymF1U27ZGavrDctxRIu0ZQur5t2ycxPd2dnJ8+offHiRZLOV/KFtlJn6o0vmWWeGpQZKP9CW5XWXrItmeWkWLmFtqqupgXoyo6wnLfev0uuuiszBRPF7Ij4JKfXKv8uVaJ5lLOc0e9bwTiryaJZROH7rHhqlXgzGiBJxTZaC2MgEzxGM16gwaPR6Pr16wEPeTgcNpSozmstfBqbmppaWFhAe2BC2u2I9QzjBcA1n0eL2owGYbQtLS3dvn2b82jGKRCzV7zX6qdrNRzUsZSgReYCMbbK/EqqK5CLuPDU3DEajknEcY1M2YS3K5miix5z7969QMO+ffume3OZJjFfSp9Dk2CHJeXb6XTwVouLi/v7++4XYcpldf10JybkwnQPDg4yoJ2engaAbrer/gKQqd5KNu0MBgM0ZnV1VbiiXz5+/Bh/zO+E1yQejdyXKG6nji5IpCWKt+33+/CDVJd6//595hEv2Wm0BF1EeiFeoG17e3skqqVrcHkygNPUeAJU2GS1//fOnTt4sb29TaLRity5loGuHydcHjhoBlfB5A3X19dlUoBpefjwYVMyDAjPM9/KAN3ksQ2cl16vZwmnEgw4zDi44vX8/LybLH/xWUAMFCMFKKnuFzxbQLWKU1lgdDW4S9LnmmJ1A9uwHZQowOTKi93d3SQ40TaJqfx2Fc3DfDmxJyHCgR0S89vQedRZAQpClPi3RVfDaIZrExk+ATNcWXHZxPLrBJ/LWZlZwUTH4zFuR6oCFCnnyZ8OxPtIfiDGMsNaTqxNQcvFA0KIohvuaC3m1MhdcnUjCpOF/tvyFaAEjFuYruKRM9kbEyOiMRh8qeykbGsENt2Si2SgHNjesljdtAUoOVP58WYcbCaeBKA+FHPk2tqa9APEoICqs8Aw8g0iGnPHk9NNXjkWY29hQnU4dV1nNBrhv4BW/l233UNiLdtQK5BhSJXsTWjqdeDh7ATueJLJGxe8efMGI1t8H4zUra2tyIthhEg0OEryH0L39etX3fQp2QAZdvv7+xNH/Ozs7E1P/mENrjAYkWYAREHa6mGuFT6HIUw34d4E3QoXRo/ca7wPDPjl5WXkZe12u9vtYjTj59WrVyOvQcCDhhUyTEu02zDPMqf/ELokF+swyAuMzjBOTJNCEW1Wyf0YbxnYIvP++Jp1Jtpy/hARnSFV63Row/HxsfwR5MBPRqQ4PsmFf4kkaju7Wy6r6+AhIjrvRuUFYRU7nQ6mRjQjj/+l88xt762rzG5DtQ885x3RdQ5FDs7O8+fPjXw7jHv3+9RKtNswZpnTQSpfDamJc2RyFfKAgvrsNjRFt+rP8KvVbsPt7e3MVg72XIaprJuSqCO68U95SGLldC6rjQrbxp1Tn5luK8duQ51Rhek20s7z83NJO+isRU2ebWij+4dT+UkWXnQ3VNK22XyZP3/+4N9PTk7Q4e7evStV+bouIsX4JJqUbhL/UxdUwDWT5bnkw/HE0+npqeSY0KvUJovDw0OOUUfCfY8kCgYqtRuj0WgkIMNv0uv1VOfQ5YZsb2prIlFdxhUMAFXq9sKzuNSJAaTOh1pbW1O7S3VHyOn2BJBo3lQObmvkGBoOhxhDyjACHkYbjCpwYrLUvWG73ZatS/LrYDDQDdBUVj2bGnp2Z+RAFPnLdyU2Ragag/PmzZvPnj1TOFWqJHIKd7CPuNNMojC8ut1nUpOtSo3ueIKVhr31j1SM8m63izHn911xmRTC6Qaog7xgQ4m2vF1ju7u7utgXUP3lgMue4sPlmEJA6QExhoFEDUhS/zoGQgj2c2VlJT6JgSvhT+kqFpScnarVXKItr25va2srZglaIl2YX0yW/mrh1v+L85LGSpLZkCrAGj5/tCSSXJ1U2MLAxiORkpf4AvwkgpHf2NiwPZU69XWfPn2KyQm2rvAnm3/69ElFMnCC3LRHLHmtxmhkIXwhxyciIHn37t2DBw8U1Ikj1Yhgom0XYRdmdZ2daaPT0dERfiqoiCkT7jzMKdv71Eoxj9o70yY5VLQBkwKC1IleqxHbq/apGV+KKZ1n5LjYE1Bxi+EfSXkRQsbFxUVwjd8PmlNyUI+Ep/Aq5ubmTK3O2iIaU+GXlq7tYs+WV2KPGAb3d35+Xj4UUQ1+lTnPUk/yJ5B7vR4aUGqiCSv8Uilc7KnOws3f4F+/fr19+xZBJ26uNFX2rkAyC+Abyflx+OiLiwspbVFnyWULbD58+CBuNt4EH2TqICuLVtfeA9YVXbPlgAhSZYk0sC1JzQIxnnOGs1fRS2B75eg62f1vxPY6mketPmA9T7Gnke2LsNKwSRn8KYxLqdw3aHsL8IysPmA9fEhv5GUYc7gmfOxmZpsBqLq8f7zg9yJwEturluQq7OtafVqEhLw6oma/CIZatrlQTqKQfauwvbrqpKpGLy6fFpHT9VO2XY5UkcgnyfFGYUnFGjpfu92enp4uBVH4fkkW/8bjcfJHUqY6d9dNb4t80gQcXYQ9aJvk/bOd6AioYk5mZ2dLQRQOoUxdCS1t2sjS+FEMySkm8bM+fvz45MkTaRvuQ4ZgRkKjloldNwVY3ZyPpEx17q49in7hepX3h62KLPx0puLP7syzjdDIubs5s1GqV11eXspTJ2LOSqk/UYORZapzd01RjLT8UlIUU0IW2bMLJqrsvlXNeQLgtGYwMqEB50VS/5kzwwqkAhB4n06nI3lB+K5SsZ08+FHOY84Vp6nNzc0WZU7379+XRAHMQMJEEsb0xsaGvH79+nXO5wu3ycCsYGwFif+8q3ipp5IcHR3lf1w0iRoW/CM1g8KWToSKC5TJ/fLlS/4GkKh5IXpRO5kWFhb6/X5k2ksOcFX5SPxLldZemqbhcAirK4eYiV8mxb1+V8ifcz48PMxfPUqidrW3twevVc2RMcsGZp/bRKIWBU7Hx8dLS0sYrOFHXmLGxdDE3Hl+fl7bDEP9BFoHnrrdrjqoruUlDk9PT218Iok60qknBx9EX7duIlESpUiUIlGKRCkSJVGKRCkSpUiUIlESpUiUIlGKRCkSJVGKRCkSpUiUIlESpUiUIlGKRCkSJVGKRCkSpUiUIlESpUiUIlGKRCkSpUiURCkSpUiUIlGKREmUIlGKRCkSpUiURCkSpUiUIlGKREmUIlGKRCkSpZLpXwEGAC0gM5UVa2aeAAAAAElFTkSuQmCC"

/***/ },
/* 3426 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJsAAADZCAIAAAC4k9W8AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABsBJREFUeNrsnV1rajkUQL1TqVg6UBi4UKFQKAh9K/T//wP71IeCr4JCoXDLlBaFwmzMnUzmePyI+do5rvVw8YJFzTon2dnZyfkxmUx60CH+oAkwChgFjAJGAaMYBYwCRgGjgFGMAkYBo4BRwChGAaOAUcAoYBSjgFHAKGAUMIpRwChgFDAKGMUoYBQwChgFjAJGMQoYBYwCRgGjGAWMAkYBo4BRjAJGAaOAUcAoRgGjgFHAKJQzenZ2dn5+TuMWaah+ii96cXExHo9Xq9Xf/yKv8Wct/rnm8vJSGmqxWMznc+1GDXL1/bVGXovRz89PUfvx8SEvTs2iNIUoFH/GYtLP6mf7ScLV1ZW8/v7+Njdut+0ai4acY1C/SLdztcba/fr6Mo5rtyj333A4zG+xsNFWu9fX1/Jfc+PWZdf0pcai/Jzi36evqnVMuzTsSs8stzIWqzS6za5ItfduKbtugKrNYh1GG/eE8PPnz8x2rUX5t5ZRoN+rjYZdG1VFmfKayaLtVGuMzrIafXp6ijsCGbt2yntcQqMx5Y/7k91o4O7uLsNVkvse/Vzz+voaPb5oJDRMI26b8sqb5dNTWywSsZfsdTftmlYOn8m5dm1CQ/pnO+uPO1mUj3BH9yp73fF47HYg8jOm02m43RTZFjehEddiiszXaDQy4b07VFUfGUmf+bbGtTscDlNnREtZPK1Y17WbNITZ8QXqWkGqafYit8ivNantVr0OWN98dNNulFSADYxrX83t9zqBG2QebldDchGj3nYlLN98z2w2k7G5MxZdOl45tm12KHPTTursUQuIUcAoYBQqjnUlFr29vbWZ9KpLA92kx/v7e9wq3JpmL63rJLUUfm5LO4tR5qO/L/NG4adCu6UKceswKtpWq1VruzTsll2A9Fq+lW+7XC5P1Kh4en5+3ruJwA5ROct6vUos9GwDUdHr+i6ZpSvr9bWocIlGXV7Xd8nMtTudTkPu2sfHx0MuPuULbaoz9dGXzI4eGmw3oH+hraa1l+OWzAItVrfQVutqWsOu2REW2PTuLrl6V2YKG5XRUeYngVGr+XNTJRpCYDmjG1tJ52wHi9MyKrHP9Zqe7s1ovhHyYrE4UaPbolb9w5jaTU59tVd9kc1olVpUZNQU4+9uJtdu5umg71Y1DXslyt+jm3MSE7i2pmw2tytFt+tbCawtQtbV67p29ybkNu3O5/MQtTc3N4dbVHtehN75aOu+RHnRuvRh7L69vYUYNR17jRbryzC4drMtT1Z67lJ9OaPWnWux7Hbg9KzyGYbBYHB02zXsBgYmLy8vUSyaa6tUTr98FnA8Hke5M8JbMERno7eIfn5jZb1uYxt2LTHI3niNcfR/qRmd58ppPm1MhdHlcikRrFcBiinnyTmXt0kPr1KVEzUqv382m7mZGtN2O+zaMS9pstcrhauqVEVLr+tbgJIile9lUe3qkNL5qFcBirUbWDnWune4CouVZRi8kr0pPr3I4H0qOaN0h9BtWqz0WO6Kz2HYtBu4N2GxWHTgcHVFuw1DAkX3ELqjCczysNvwN1U/RGTbjh12G/7XQPofIsJuwz3T0AN3G9p94EXGOS+L7DZ83tteRVL5XrG0nh6lO7sNo9g9brehqhMkOrXbMHDJ+uHhodI9o9XMRzft7i6dDcwzbPvz6E+sIMPQtNtjt2H3ckatqXx2G/a6cRprrLAoym7D4nCKXNfAKEYBo4BRwChgFKOAUShB1pzR/f19956BtJfMJ6xkNdpaCF/F8YnKLRYzus1u1c8SNByyb6fjRl0ynGmT1GLO56HWYXSHXW3FnnsPYO+m0R0Vfr7Np6HYM105Z4qqwSRGD6zw8+3iGsWednW6OotJL82EvW66B6xbu3HLAdNtjcrZwWQaR5M+YD2k2DOdxVIhXoHIKOkD1jcP6W19m0Re8h75xG5YVBTrJq3wM1PebUYjBg2qUiV6z+7UfDyx5trPOEYHg8FoNNr7NonUD99Q4HXubp6r7ejaT1s+vvedcgWrMCqhrBm6EgV+pY5iCImiS21KLNDrBj6S0uvc3ROxqGgcDdxGGOXc3cDJorbTAXVFRiEzS69zd2NZVHg64JFGJUbI8OUu14hg326wNaEhgZVJ/R+duLEirUWFh0X8mEwmPegQ1BlhFDAKGAWMAkYxChgFjAJGAaMYBYwCRgGjgFGMAkYBo4BRwChGAaOAUcAoYBSjgFHAKGAUMIpRwChgFDAKGAWMYhQwChgFjAJGMQoYBYwCRgGjGAWMAkYBo4BRjAJGAaOAUcAoRgGjgFHAKGAUo4BRwCjk4h8BBgBW+5e4bBJLsQAAAABJRU5ErkJggg=="

/***/ },
/* 3427 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 3428 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 3429 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 3430 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJsAAADZCAIAAAC4k9W8AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABElJREFUeNrs3V1LKlsYwPHjSw5IQpQEicG+CKGLIOg79WkruurCW6Fu2hAGmYbtMxiIZ5+tTDrOnrX8/S+66Emt9W89LzPOWLm5ufkHEVG1BIyCUTAKRsEoo2AUjIJRMMooGAWjYBSMMgpGwSgYBaOMglEwCkbBKKNgFIyCUTDKKBgFo2AUjIJRRsEoGAWjYJRRMApGwSgYZRSMglEwCkYZBaML/JjxrVCtVjs/P18vdHR09K1Qs9m8vLxcI3RxcZF+Lb/R2vX1db460xVJ//IkSV5eXrKE0tXv9XrNGWuEDg4OJpPJaDTKEkq/mYbSH1gjtLe3d3h4OBwOPz4+dsXol7P5Kiw6WBaar/4moUUHK0JzZ2uHqtVq+aXmZnTR2W8OloVeX18XV3+T0JeDlGWhSqWy6GztUPmlVnL5TKbj4+PT09M/htJ1aTQafwxNp9Pf1nHDUGGvlX7//v4+5s6oXq8vCy1b4q8MmW+osNda8RDTCxgFoztFfRtPOhgMFue5OOh2u0EcYdiK0VRnOmNEZjTtb2VdMIpyZt3/j4lJkgS3NIEWjiKMttvtk5OT4Jbm9vZW1gWjYBR/v46Ox+P4xtOdNvpzhrWWdcEoism6nU4nxHl0NVdXV7k/59PT0+Pjoz2Kwvfo44zS7gx1FIxCZwR7FLF0RtPp9O3tLbh1r9VqW3rXUj30f8lUZ7/fD+7XbrVavV5P1oXOSGcEe/Qvd0YF9Bo5Mh6PJ5NJ8EaL4evS3ZL/krkci5d11VGoo1vtdeeZyomX2Paot5/FZjTEY0NxZt1imE6n5d/E6fTCaFYCPcCr10VERst/AIFR7HYdTcvkipG00Wi02+2M7cn8qo3sj8prANt2+xZPZ5QkScbjGOmazo1mf1QoU7Wsq45CHc2LTqezOpsFeueE3d2j3toSm1FbUB1VR0Om2Wx2u90sPzkajQaDAaNlp1artVotezSkrLu610V4e3R1r5v9/Gh89/4t2ujz8/Mmh77mZ4n7/f6K0y/OjxZn9OuTWDZ/Hu8zMr0wClnXPLoTRtOVLf4+/ebRLRoN4lM0GC075tHYjJpH9br26HJyvIp7NS5Ps0ftUfMooyXBPCrr2qMxzqMFX3Xq+tGtz6PxTbGyrjoKdbSwXrfITzl9f3///PxkdIvs7++fnZ0V9nIPDw/zDqs1I8ujXD8aBqnO7NfkuH4UjOqMsCGFnXqyR2VdMAp1NM7pxTxqHpV1wag6CvMoZF0wCnXUPArzKNTR7fNrRmGvVa2WdOniybrD4fDu7s48KuvKumAU6ug3SJIkxHt6NhoNRpcujfvXy7qMglEwCkYRQa8b933icrlLQ2BG3dhc1mUUjIJRMApGGQWjYBSMglFGLQGjYBSMglEwyigYBaNgFIwyCkbBKBgFo4yCUTAKRsEoo2AUjIJRMMooGAWjYBSMMgpGwSgYBaNglFEwCkbBKP7DvwIMAEfG+3iTGmo+AAAAAElFTkSuQmCC"

/***/ },
/* 3431 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 3432 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 3433 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 3434 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 3435 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 3436 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJsAAADZCAIAAAC4k9W8AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAClRJREFUeNrsnetT2loUxX0jAaVqAwpiC5apo9P//5/wU6c+asf6QhEDoqACReldl9OemwvyUElycljrAwMlPsrPvffa+5wk49vb22OURprgR0CiFIlSJEqRKEWiJEqRKEWiFIlSJEqiFIlSJEqRKEWiJEqRKEWiFIlSJEqiFIlSJEqRKEWiJEqRKEWilOOa0v5/aJrm2tpa57+fnZ1dXV0xRvVRIBBg1tVKMzMzJEqiJEqiJOqeJ5yampiYIFGtNDs7S6IkSqIkSqKuKRQKkahWMgyDRHWzu/ol3lGf1M/NzZGoVlpYWCBRrRQOh5F7SVQfjY+Pv3v3jkS1UjQaJVGtFAwGdfJHJPqvYrEYiWqlSCSiTZiS6B+trq7CJZGoPjIMY2lpiUS1UjKZ1GAoSKK2z2JiIpVK+T33kmh77kVBJVGtFI1GTdMkUd0KKvoZEtVHKKUoqMFgkET10eTkZCaTmZ6eJlF9BJyACrQkqo+QeAHVXxu1SbSPQqFQOp32UZNKov0F3/vx40cS1UqLi4vPnlZMoj6WaZrxeJxEtdLKyor64yQSfZmSyaTiO81Gl2ij0XjFV4lxksonzEyNLNGLi4tCoRAIBGZnZ+fn52FoB7zWBtrTT58+7e/v1+t1ElVO9ZZub2/Pzs5AFGVyaWmp755sHJDJZAD18fGRWVdputls9uvXr8fHx33jD/gRqQqOk0i0Xb9//y4Wizs7O6enp71rLaqpgnseSLQrV8uywPXm5qbHYfC9cL8k6hs9PT0dHh6enJw0m80ekwelNnCTaH/BEu/t7T08PHQ7IJFIqNPPkOhAqtVqcLb5fL5Hk6rISiqJvqCyZlvqZn0VKagk+jIhTC8uLp59C43s/Pw8ifpPuVzu8vLy2bfW1tY871BJ9DU6Pz9HsCIPd+be5eVlEvWlUFARqZ1dDToZb3cQkujrhYJqWVYbVGRdbxfGSfSt6bcTKiyShxfvJdG3tjSAen19ba+paE89vFoHiQ6nT61UKvZ/NE3Tq4EDiQ5BT09PqKn2hRpUU6/OGCfR4ej+/r6toJKo71UoFB4eHmRBNQzDk2sAkOjQhKybz+d//fol/8WTXYMkOkyVy+WbmxuUVfHSkzEviQ5TqKPIvbVaTbwMhULuj3lJdMiq1+ulUkmEKXCGw2ES9X17ent7K7cSun/qP4k6EqZoZoTpdd/ukqgjYQqiojdljGqiarUqSqn7I3sSdao3FUNB9y+CT6KOCAGKMEXiHR8fd7mBIVEHSykaU6B1+TSKKX76DhGtVCpgCa/buR2JRP3aw1iWhZTb4wwLZl3/yWWcJKqhSJREKRKlSJQiUYpESZQiUYpEKRKlSJREKRKlSJQiUYpESZQiUYpEKRKlSJREKRKlSJQiUYpESZQiUYpEKRKlSJREKb2kyVn7hmFMTk4GAoFarSZOq5ZPSNQfCofD8/PzeBQsnz2m0WiMIFefEZ2enjZN8/3794PcJWe6JcaouiyXl5fBUsFbZ5MoWY4w0Wg0mkgkyFIHogjNVCo1NzdHSDoQhY8FTvcvfEmijgglc21tzeULJJKoU4rFYqurqy78IJcvwDiiRGGCXLvHrq5EJ0YTp8ZShShqp0M4i8Xi9fU1iboqwzBghZzLrkdHR3t7e223CE0mk57c10x/ovC0aFScc7ZitPvw8HBwcPDjx49qtfrHQUxNra+vb25uenJ3M52JItk6epsb+7C+XC7v7u6enJzIOxAGg8FMJrOxseH+7bD0JIpAcdoNdS6/FAqFnZ2dbDYrb0IYCoU+f/6MPOzJHUO1Ioru0+mZLYh2pvRms5nP5799+4ZH2cZEo9Gtra2VlRVfz6q8JIoP2p1bI3dbJX18fESkgqvdDMfj8S9fvsB7k+iLBUvizop075+CmtpmhpE2Pnz4AK5+NMNephfX1lUG+bsRZhh/ZIlEAt3UWOuWZzDD8MaIY1gqEu0v1+zl4Jmg3BJqAXKvuImdMMP39/fgend3x6zbx+i684NeeoPBYrHoXzM8NQpEX1GthRkGWjRX8MDCLUdburi4sCwLroox2i7XVj9e7b+kGQZav5hhL4nKwY2yROXveXx8DDMs/ZHKZthLorCXviAqf9sfLclfW5jhzc1NpSaIXhJ1bZELBXtYkymEKYIVIWufDDu3cOQzomgGnE688hSJ4Y4y2swwoHY7U2PknBF8o3Pf//LyUmbIIRJFxM/NzcEZoZORjledUbDHvwf+2BcXF4e+QtloNJAYkSHT6fQbiaJvQQgahoFHIMRj57fCj6vX6yT6Rz9//sxkMmjhhxX3V1dXCH2Rb8UN719ENBAIBG3qO1LAjzg9PeWE4T+hFB0cHKRSqTd2AmAJq5XL5ezhIuv04GMj2JzeOQOZtvpXsAK1Wk2p7kWJ7I94Ojw8RPrFp/kKi4GPuFAoWJbV6bNeEaNI12hIZF3EHwrIoR7jEfDwKL+nmlJoaRcRdnt7u7S0FI1Gkfr6Ho8PF8dXWuo2fhqEKCql/cvxJScnJ2g0xcujo6NSqTTmH6m1WI8MfNUSqlckEoEfEWVM3LEesYgoxCMiBulukFgZhCgSvt0VQzc3Nwh6MefDu0jjrg1DdCMqVWtpKKa3N9GFlvDu9+/f7f9+dnYWDofx94QIRi3Y39/3C1HNz8tE0AvTi/LcOTZCsUwmk2OtlVpU8bbSjnwrsjF8uGmaJKqKetjdRCIhY3d1dbUNOTKtHIAgTP2y/VN/ot0Sr5j7yJd4d2Vlpe1r8/m83Hyk1PCWRNuJiuUw8RxGTDyJxWJtHhtZF82MHN4ipklUUaLxeFzAg3OG0b2/vxdtjCirbUlbjoSWl5fhwElUOaJoitDyiudoPXEAnK14GWmps1GWC39oZhCsJKqQM0IgIt+KfUMITbSe4sn5+bk4DGHauQcfYSq+DzyzTNckqkSMoliK7biokQhQeZhlWeJIZGMc09kF2ZsZlXfcjxZR0EIFFS9heeSZh4KZzL0wvZ0Tibu7O1Rc8RxhOqzFIhJ9E1F7vu3cE1MqlcS0D0742at75HI54aFUbmb0J9psNiUneV6GDMc2ZbNZ8WRxcbFzpCCaGTGEQupW86oRI3F1Nvga+6gdL2WotalSqcjU+qxFqtVq8q8B7amC54ePb29vj42GEKMofiiHvXd+wxJvbW2JiSDYwzF1HrO+vi7W55HSd3d3ldpfP0JXUES27LGSau92pAeGjXp2S5joYsf+Xu+XWVd1wTSJtTzglN7YLgQlCqp4rtq2ehJ9XrJYovUU/ev/alVrg6C0SEpdLJZEn1e5XO427F1YWEChlatv8FxKXQqfRLtKVlO5Hg5jtbGxkU6n5RINcCq1tXNMm7uDOKFqtQpaYpKAiIxEIvZ9DmK+r+CmMhLtJbQuYtEUnlbihFvOZrN4S82rf5Jo/+kEwlSm2Xw+D5bqnBMx0hOGt2hmZgbV1IWT6RijLgkg/XJJV3pd3USiJEqRKEWiFIlSJEqiFIlSJEqRKEWiJEqRKEWiFIlSJEqiFIlSJEqRKEWio6Z/BBgAC869DsDjV+8AAAAASUVORK5CYII="

/***/ },
/* 3437 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 3438 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 3439 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJsAAADZCAIAAAC4k9W8AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAVdJREFUeNrs0UERAAAIwzDAv7SJwgJvLpXQdJLSo8YCoiIqoiIqokRFVERFVESJiqiIiqiIEhVRERVRESUqoiIqoiJKVERFVERFlKiIiqiIiqiIEhVRERVRESUqoiIqoiJKVERFVERFlKiIiqiIiihRERVRERVRoiIqoiIqoiJKVERFVERFlKiIiqiIiihRERVRERVRoiIqoiIqokRFVERFVESJiqiIiqiIiihRERVRERVRoiIqoiIqokRFVERFVESJiqiIiqiIEhVRERVRESUqoiIqoiJK1AKiIiqiIiqiREVUREVURImKqIiKqIgSFVERFVERJSqiIiqiIkpUREVUREWUqIiKqIiKqIgSFVERFVERJSqiIiqiIkpUREVUREWUqIiKqIiKKFERFVERFVGiIiqiIiqiIkpUREVUREWUqIiKqIiKKFERFVERFVGiIiqiIqpDK8AA9rQEFuZKcsgAAAAASUVORK5CYII="

/***/ },
/* 3440 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJsAAADZAgMAAABKn6p4AAAADFBMVEXMzMz4+Pjf39/r6+tGWSl3AAAB2klEQVRo3u3XoXKEMBAG4ABzAoHkEZCVeB4BkZKIE7F1yEpeAl9dX89L4Kv7FM3cLDNk2SQr25v9ze0d3+XYJTBzSiKRSCQSieSJ85qLOHEX965eOG7yxcpwsy8ahlt8Uebd9KjWrLOPqgsOfyEHp4dP0NwINzyq4ux0gxy0gRsZC+Qil8aVV2eg3E9uUcjBWNBgDLwLnIayPbUB73JuhHHmnINxphxMqs45mECVc/BJyZjLCOPMzdnB8unrBhe8z+0D+IFbbl9BY3Vyn74dbagiue+3FdpQZfI+Us1xvip1X2r/ao55Ju5z6+dxXJ8+8dxwvs8RDnWJ59DmP/qGQ83FoQlD6rjTZ1fFnVXnxJ0L3B51W+DamDMqSBdzOnS3mLOhq2POha6IuS10ZcQZhbLTTmO30s5i19POYdfRbsOuIZ1ROAXp9MVVpLPqEtK5q1spt11di5yBNnA65O4rtIFyQ876L46Eq5GbC2gDpUJu8FtjIVwZOm96o6jsgfOm0aRbA+dNNZKuDZz1xQfDzVdAuiHq+sAtzPUUb72J6e5MNzKdY7qN6RTPTUx3ZzrLdI7phoTrTm7hrWcUbz3NdJbpZqYbmO7nM5Gvv/H/6P87iUQikUgkkmfML56kvXJZerfGAAAAAElFTkSuQmCC"

/***/ },
/* 3441 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 3442 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAMAAAANIilAAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAM1BMVEUAAAAICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgAAABBZ7MZAAAAD3RSTlMARFV3M4i7It2ZEapm7syfo43yAAAAAWJLR0QAiAUdSAAAAAlwSFlzAAALEgAACxIB0t1+/AAAAX1JREFUSMftlklyxCAMRQ0yAsx0/9sm3cFMZhCVTarSf2fQswYQcBwf/QUxDm9xtgmeAkMhFCeVlEKFhxRICqrDQHqFXyJMBNe0SCpMpSbFg9oU32qcj9gyW2NThtKaMvN+utmHsk1yl1VzGjPam854h04xi0FJ80I8aBsnnD2Gsi4aNTYyjrvpPjxvq3q7IIXNNJaDLMazbKCeIS52QBY8XLNOMCNFPzk/TQy6cJSX66cMhsLerl3zM+Jxw2trqP+1kquKaybt0pGpkvTUdSoDvZdmK+W7RO43cBjBGrFKAhA1FWbFXDJgA1hVTcrB9GADvCqYj19YVBvuhm/hV42gU22dvi6fzrkO/O3uSr5EFUdIKz6G38HW7XvGCVGez304GOGbnnThqQF8K3eC3ofzuvN9mOdZtQurcv+pPVg1LchAeArsBXRbSFLg4dtCr+HxeSPdCnaTV8np5vD8LpM4g3H1mGIaXQ92KOg3SgtTj7hX3Xw54B/3+Uf/SV8MRDluKpkftAAAAABJRU5ErkJggg=="

/***/ },
/* 3443 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 3444 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 3445 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 3446 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAMAAAANIilAAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAM1BMVEUAAAAyMjgyMjgyMjgyMjgyMjgyMjgyMjgyMjgyMjgyMjgyMjgyMjgyMjgyMjgyMjgAAAC40UbsAAAAD3RSTlMAM2Z3qrvdVSIR7sxEmYicOsg7AAAAAWJLR0QAiAUdSAAAAAlwSFlzAAALEgAACxIB0t1+/AAAAYhJREFUSMftVstiwyAMA4whEAj//7dtty4xjjH0tkN1JcJPiRjzxRfGWAceQ2sN0UPc1onJ+dx67LDGL76JqHO629sQMImKTQMmpdbaJtiH7BJm3Nb8gAv8w4AVALC/0oncPuVc45nhRo/ClBtcX5vNWuhEB5TvI4la1TSulzp6FZ61XsmbQDIbJ5WjRI1kd3ZW8NWObG/EzdVOJSwzIgQWt0Dli8N2rEi3bgW8JBG+n1c9+DPTZ7ihPA7GdeQIUBGkpGj1c7p1gpfYNeZxH4PhepCQPYjMJ7IesQ6Jata7h6K4zgsg06I1C+hs9mnvUD7w92tQVf8wwf7yl+7qK2xRufa941Q56SLrzTn1QRRJRKFyixRklQxSeWUp7XS0SeQ45HYvySE2DEfUTtyBJkhWWxp0Yi9u73GdYbPl2hx/5pk/uu7w1EKJd+sTvHXhWT27chtIXKVm6SmZW8lvO2W1rbD9UDYwYeZD07hV/oFydWaC7RC7jlBmzL+VAMT3wgXEzwzpi/+KB+rlSXxURzOLAAAAAElFTkSuQmCC"

/***/ },
/* 3447 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 3448 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 3449 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAmCAYAAACoPemuAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAo5JREFUeNrcmGlrIkEQhstxjJrgfaMiiOT//5B81w8rCErEA43G+8r6NPQSlmSxnTYOW9D2GMU883Z11dsTeHl5+SUiKfFXTN3zS/48Yl5/6ePjQ41AIKCGxwg555e9DaiHhwdJJBLiuq4NxfaOjV85nU4Sj8fl+flZHh8f1Xuv4dhKClQjwuHwn2tfgOlAORthHYw8e3p68ryc1sEcx5FSqeQ/xYh0Oi3ValUOh4O/wIhisSjlclmOx+N9wXRRnc1mslwu1XWlUpFsNnsVnGtbqV6vp8Dy+bxSrF6vy263k/f3d5V/d01+1BsOh9JsNmW9Xkuj0ZBQKGRU326WY8FgULbbrbRaLVU6CoWCUQm5GZhWj53Zbrclk8kYdYWbgmk48otBV7hUtZuD6R07mUyM7JD7E2BaNWZyzzeKafdh0gl+DOxzEfYdmC965X8L5npNaAZN2oad9gymgTgZcfggIpHIfcGo3ABhBKnklo5r3sCAws/jFoD7Tk2+Z2JxPIHxD7Eu+KuvoObzuTKJOFdUfHt7U3XrWkDXRC2W7rtcAuD19VVisZhyrczA6VZk+tjAaCn/leBYGpRcLBZqcBO4WDbHdDo1ttcX68wds1xfBT2QQYPme8w418FgoABzuZwx2MWKsRwogekjj1AHL89yjcdj5VDJrf1+r+ZaraZuBDicrGmuGS2l9lXAoAoq6OKKYnzO5tBAqVRK5R2gpjlmvGX0nWsLAyB/Qz1UQ9VoNKreox55ds3jgquLzWcFuF6tVkq90WikFAWo3+9LMplUoKYty0oTB2yz2Uin01EAgAHJAQRlycdrwEK24PQyM7MhKC/MpoddmEj+oVh43Pk3JDnW7XavKq7nmP4WYADw5kaRvTtrVQAAAABJRU5ErkJggg=="

/***/ },
/* 3450 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 3451 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 3452 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAmCAIAAAAnX375AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABMtJREFUeNq811lTFFkQBWBoCxiEEVAUVJQtDODB//8nfIUgCGVxBQVBBGURZz76jGVNrziBcx86qqvz5sk8eTLv7d5nz571/L+r+CXrv36s8k3vj3X9kN+/f4fU19f3R33VarVEcHp6+vXr1/Pzc1/z8hogk9bw8PD4+PjIyEh/f3+DAbzPnz/v7u4eHh6y7ArcBfLi4mJgYODhw4fw8ubk5KRMqygKGd+8efN2fX369OnVq1dfvny5cePGf4SEd+vWrdnZWaiI3a0veN6XNrz7Fd7du3dxgIytrS1mHVCLDnijo6Pz8/M2440j4UcpDe4E8fr16w8fPkxNTd25c2dubg6379+/b4datBMLumy2Tcibm5uK1M5Find2dvbixQtqevDgwczMDOb39/dbbqm182KbUtm2sbFxFTXW6ku629vbvk5PTyO82k6dIFGKH1URMj7TfFdRP7OgKgRhT05OYutKkNiYmJjw8PbtW6hX7LYSFcybN2/kR+T03JxorbmK8hscHATWrhidV+SmRz3QcHOitebG1xge4H379u2XJlnVie0eQDZ7qDUzQ6sejo6OYt1SAp3xbDw+PvaMLbk2eKg1Cy8jDbGlDpFDUxmz7WAu6isjCaQm8dVMbi5N0VBIRvaUXkyDx48fa3a1Ebhpl1FXJYBTMhkaGlIRDDFbX19PlPFmV3w2QrIYGxszQdjZwKkHKWove+7fv28bGx5xLgLPf9YXMMTYYjwlLctGBt4/efKE8s2mUvlFiWdIav8yfIGDOTg4IKLnz5+nMMQMg6URk10I2NvbI1EParGwsGCvX+2KVqFyy5uJH9QifJJWiVfqqGRD1Gwk56zIjGUMe2VlhWvAfDH2Ph5iXy2ZsYCqDN4i3vHZrOZSLH6SMeucXHIKUtnEUea7d++ypaXKnIAiJoVLyNSjs+4xnOoyBhanvio/PvNrlNVuMSbGnZ2dS0iRdu02NqoCzIkBI5T4SjL0hTefIH3mbtDSiXBxWwt+18mZVLhLI1VPDzzDNm4QC1VwOCuZqK50fHHFgZJEaQRkJkve86KQ3qvux48fwTuFFB6Hzbekn03SuQbJMrwRbfgsf/ImTQwgc0cLyvjevXsao8EPqi7vY57Q1fVGmQqZL645vCdvrJKPN2mMaodo/+XlZaeY2pd+AnSZJaIQorYdII/rK80qSzCekck1pzhwSxJBQslZbRex4EYH2sWMGi47OCVxlC8uLrY8qkStivCiiHKsJJTM+vzEEkAezAoiqo51EPb+AxnVueO4PzagYl/7m5PpB5Vj6TP3aca0k4HuIVmSj1oy9lD6QYa5+HPgJRU3OTE+evTIaZDQ1IyR2YgW8XKd6Zqjm83Tp0/TrOGAMRv3wpcvX6oiblRaxFW8fzUJF8q7uroqZNaoF4EpFTIzvsEzU3UGXEhF0pyqpTOORMXkpauThnFVE70tNlZbv7fhz1753ypBlTzn0lyWLW/CbfhETyh1m3WjlP3a2ppW0aPSSCO1vYhwEcVX68pplJJfcyLmMwbEafrgM/NdaanaSzSEqi5X519dmYiQokmfLtCQ8mcmVbhmyKBWp4H6CWJpaUkVUV3Nsuj5PQs2+ago3TXU6DdCyoyYmy/7tZ7fuVqOs78FGADendGnR89aUwAAAABJRU5ErkJggg=="

/***/ },
/* 3453 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqCAYAAAGyxPnNAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo5OUQwQTk0ODdGNzkxMUUzOTJBQUQxMkFBRUMyNDc0QSIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo5OUQwQTk0OTdGNzkxMUUzOTJBQUQxMkFBRUMyNDc0QSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjk5RDBBOTQ2N0Y3OTExRTM5MkFBRDEyQUFFQzI0NzRBIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjk5RDBBOTQ3N0Y3OTExRTM5MkFBRDEyQUFFQzI0NzRBIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+owmDaAAABltJREFUeNpi/P//PwM2wAIi7s1332971tsBSZyRCUS+XPmEgfn/Pxsgsx0mA5Zg+M/g+JeRiRXIYoOKG4AlQlTTQZQbEP8C4hYgvsuIy3KAAMIqwfJ4nvP/KrEahn07LsPFmJ6serE3a3IOTMAAiNcwAV3h8oOJlREqWAvEuiw+6jkMHP9+M0DdXAXED7FaBBBAOJ2FM5xALmP49//onc1fHsTIxExlYGQ4BhTuBuIycJhADQYrfrLyxRkgxc7BwKDOxPCP+R8k5EqhGKwQbjIQmHqo5zHw/PvJgGQSCAQB8Tqo2B+S3AwQQEQrZiI6FMAhAPKBWD3DhWM3Yz9/+r4Ym81wE9NmFC9dfboTJWmhmPhq11vmXx9/7+L8xxD9i5HlJU43/nr/m4/hHwM/kA0K1wtIcjBfzgIbf8xNC2rPfwZQmHL/+/UfyWoYmx/sxtesvAzBqhkgRelIJj5CYn9kWSNkxLBC2BQmcAYpO7wC4glAfB+IO6gf4AABRFJ8k5qW4WH9m5H5WJVojRorw1+G08fu1ANjdSoOvd+A+CoQTwfirRiGAoEYkuP5/zExa/0Dsn4wg0qJ7+ygYEfS8wWIPwOxAhR7Q8WfALEs3PuP5zv/Z2SCpJr/f/+ffLz8uTmIz/b/78tA1YxgYDl0BMnQXiAugbJ/IpVPqBnuyYoXoqDoh0qYwyzAAYqhGAZ+QC2qQY/RN1BbUPA7Zi4JYDnFimZoB1TfPygfWFIwVANxLHqYwgHr/78M1TIBDGe55RjY//8B8b+gKfkHTeJLgDgOSXwmNDhWgsP0uLs2OOknKMUzcEIKSxhIBOJ5WILgGhBro5VNMFBEk3TKxEADABBAQ8elNDEUVIKDik5JiA3/GLqEcqe+ZRYMB3IP7912MYiJmQlb+ICS1XMg3gfEjdBsi5L3RZDz/n8GRpAFoHL4IRCL4nGQBBAbQnPXQiBOwOl9YGHCDsTAqpSZC1hivcVi2FNoCYUM4oGYB2uO+gespqJWthz++eU/GzBZMPkxcDkUyoX+Z0JN4zJQugWaPWEgAojnwFzKy8jMyADDrD9/mHL8+BbN/vN7JLD5xILH+/PRczjcpX9//ON/vuHVegZmoOGgMP3HEEJkJG9F48+AG/ps3UuQC+2B8SlIZDZAV3YLiE2QxVlAXgaC80DMh5mIicpuoNL/D7bqxBldJajYa5D2YWDCLIgY0UovNmhqYMSbo7iBTa4iuVCGdyzcxEYSLKJArVBeFvQC+gy3PEOtjB+ofiI1d/JDg9ENbiiocAYV0q9Y+ZAN/I8jorBVYrA67hETsoGg0p+Rgag0wArNRdjATZZVwsYMB3nVwAZiAe04NIIKlEVAfAqI5wKxMsgwIAa1FH1HeCFNE0MBAowmYTpkfD+iHYrc4BfD9MU/hp+MbEcmCGbcfMUinMwCLGUYgeUIMLXsPXP8zqKP778uBDYKqOGOu0DcD8RTCYXobzyG/MEi/4vKAQYqjKZAi9QiMqKeEVQ9sXD++noO2AxYA8Sr2YA098+vJ61+PVkk9euD0F8GYHMDP5gMrU/5oQ6qIuDRXmjpyYCtHsVeBgPjmenPn9+hyzss/3z6HYLUCQphYWQofcAuLABsEL0Dtraw1bfIoQ9rD36CFvlboF10XAEFavIdwHAosCWx4N+vfwJ/vvz9h1yXgdLjvz//b//7z6gFagKi9NaAfaB/DIzkRrUigdg8jDVEX2x5XfPz7S9RJhamR9CeG0ZbhECXEh9wAeJpULtAzU97IObCofYkEPuDxuqwOvT3pz8MTKwk515OItXpQzEucB6abncQW46+hlrOSAxm+/eH/xKX9J+vTOysTPjbMqCmxSYgvognPW6H5vi1QMxMlQIf1FgFdvwZchUiGKaJOzBw/P9NSMsWaHQaQD15AY9a0NDgXmytPhaCjQGgRzn+/WH4A+wCneOWY1ggYslwnVOSgevfL9jgKangGtTR+DIaKHRdgXgnVMwNp0NBzdRH7EIMU8UcwA78CywCQA4DeRXkSGi684UajA9YQMdpXkNHQZ4RUC8HTbdCSCH7Fz5qgu7AOmlfMM2JO9RwjajgC0kdUNcCiG/A+upEgFvg8W9Yn4YF2GG8wyGG4kBO/FHLRmKU80KTGqjQlwLiLOigFi8ePSuAuBCIVUbbo6MOHXUolQAAOukZp5KrvuwAAAAASUVORK5CYII="

/***/ },
/* 3454 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAmCAIAAAAnX375AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABMlJREFUeNq811lTVEkQBWBoGhjRERgRQUG2IMAH/v+f8BUxCBRUZJNNdkWc+egzXm/0Bk7g1EPHvXWz8mSdPJlV3fny5cuO/3dUf8n67x+jmOn8Me4e8vv375C6u7v/qI1KpZIIvnz5cn5+fnl56TWTdwCZbT148GBoaKi/v7+np6fOAN7x8fHu7u7R0RHLG4FvgLy6uurt7X327Bm8zFxcXBTbqlardtzX1/dXbXz+/PnDhw9nZ2ddXV3/ERLew4cPp6amoCJ2tzbgmS9sePcV3uPHj3GAjHfv3jFrg9rZSrH8DgwMzMzMWIw3joTfVCxJM+CxsbFHjx6ZWVtb29nZaYVabSUWdE1PT1smZC44beUiyfv69eubN2+o6enTp5OTk5g/ODhouqTSyotlUmXZ6urqbdRYqY319fWtrS2vExMT9l0up3aQKMWPrAgZnym+26ifWVAlgrBHRkawdStIbDx58sTDxsYG1FtWW4EK5uPHj/ZH5PTcuNFKYxbt7969e8BaJaP9iNzUqAcabtxopbHwFYYHeN++ffulTlZ2YrkHkI0eKo3M0KqHk5OTWDeVQHs8C09PTz1jy17rPFQahZeWhthCh8ihqdRfK5ir2khLAqlIvOrJjamp1iWSkTWFF93g+fPnOo7cCFy3S6srE8Apmdy/f19GMMTs7du3iTLerIrPekgWg4ODOgg7Czj1YIvKy5rR0VHL2PCIcxF4/rM2gCHGEu0p2zIsZGB+dnaW8j99+lQov1rgaZLKvwhf4GAODw+JaGVlJYkhZhgstZisQsDe3h6JepCLubk5a321KlqFyi1vOn5Qq+GTtAq8QkcFG6JmY3POCvNeGcN+9eoV14D5Ymw+HmJfTpm2gKo03mq847NRzYVYfLJj1jm57ClIRRFHmZubm1nSVGVOQBGTwjVk8tFe9xhOdhkDi1Ov0o/PfI2yWg3GxLi9vX0NKdIbq42NrABzYsAIJV5Jhr7w5hek39wNmjoRLm4rwb+xc2Yr3KWQyqcHnmFrN4iFKjicFUyURyq+esuGko3SCMh0lszzIpHmZXd/fx+8U0jicdh4S/pZJO1zkF2GN6INn8UnMyliAOk7StCOh4eHFUadH1Rd38c8oevGG2UypL+45vCefWOVfMykMMoVovwXFxedYnJf+AnQ9S4RhRC5bQN5WhspVrsE4xmZXHOKA7ckESSUnNVWEQtuVKBVzKjhuoKTEkf5/Px806NK1LIIL4oo2kpCSa/PJ5YA8qBXEFG5rYOw9l/IqM4dx/2xDhX7yl+fTD3IHEu/uU8zpp00dA/ZJfnIJePc9jKQoS/+bHjZipucGMfHx50GCU3OGOmNaBEv1+muObrZLCwspFjDAWM27oXv37+XRdzItIjLePX3WCxxJGTWeOc9gcPQ5/jNTVzWGfjk1aY5lUtnnLudmNJsl5aWOHzx4gV4eOXSr786F/+tElTBc27MRdoyE24TFnpCqdusG6XdLy8vKxU1+vr16xRSy4sIF1F8Oa+cRin5mhMxvzEgTt0Hn+nvUkvVJtGgoZc7UaXjLkY6IqRo0i+SIeXPTLJwx5BBLXcD+ROEXMoiqsu7rHb8ngHbTV9G6a4uR78R0s6IufGyX+n4naNpO/tHgAEAinTOMgeey4MAAAAASUVORK5CYII="

/***/ },
/* 3455 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAmCAYAAACoPemuAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABD9JREFUeNrMmIlO8zAQhLcl3Pd9UwTv/yY8AULcIMR936ToW/1TucENbfoXsBQldR17dnZ2106ysbFRtT/YyvZHWxI8p/+Apr9IkjDUASvnsVitVmtXqVSycrkx2WmaNjUuz4PlDGPR9v7+7oslSWLd3d21PhbPAqIfMD09PX7Xu022NObKaPv4+LDBwUGbmZnxOyy8vr7axcWFXV5eOjgAsHhXV5fNzs7a2NiYG/D29mZ3d3d2enrqz/xfRGNRUCyysrJifX19dn197X0jIyPePzAwYEdHR94HQ2tra/7f/f29PTw8+DuLi4s2Ojpq29vb9vLy0rRry3mgmBhQTLa7u2vPz8/O0OHhoZ2fn9v8/LxNTk5639LSkoMC6NXVlTOLIYyF6eXlZZ8n6/6WGcM1LAq4/f19m5iYsKGhIV+QO+55fHz0MU9PT84K7mVhAOM2jGMcRkxPTztA2CzMmCIKANBPgw0sph+wuBFAuBBQ9LPo1NSUBwm/uWMQTKOx/v7+9hn7rmkBAISL8bvRuLYzvxaDgd7eXn++vb2t5SeY4oI1IpT/6Idh3EaKUEpBbzAMe7zTdlTiNjSDhtDM8fGxawrtcB8eHnZgOzs7nhJubm7cjYj/5OTEwUgG9BMIGNoscw2jEgBYuLe350xVKhVnj4nn5uZcO4CFIdrBwYGDU3qAQXTJbwAR1czTLLBSsLtIQ6BMrEyOi4gqRSVMkFyVYDGCcSRVxgEM1xGVuDlMsN/ksWitrEsVLAIzuIQFZKkyPYzhIuUm/mecniV63L26uup9GIJLs6yxnkpersYYBCCsZ2HCXcKnkSJiLlEdVW2EIRbjQgY0JV8ZCdOkEVhGCgqcJAsovNPQURidRdIKhq2vr9dJRMxiPDrkmSD6whjWMQD0DBBLWEABR8hFgNGoHAJD9ifKxTC/8Qq6DeevA4ZucBPUI1hZxdXKziBvPwfzrNMoYX9JF6I4nKTdxnwwQc6TxgiQjpakZlnCjXiAVIM3iNJfB4b7uQggVYbx8fHWgIU60i7ifzRY4sKllCsAojEuuTcXmIozTRFZG5QUJ1bvYjTGAowkSylbWFjwWhwjIwkPHBRkJmDHgBZ4BrCKcqvCVyrQppG5YIq5SRXaKGivFgXGSwDirgOIdgat7ApCYLiQRUPGcB+ljqAAFGuqBIYRm2S3OmpMiGuxBLZaOILVuZFkzYKcCZiHQ4kilFzJXetFGctGEzrb3NwsnFgBg1FoCIYAACtUEKKUExX7OjQX03BDVYNeVb9ocmVhyhnAtra2HCynLgxGt5QmnQey26HczZHKUZFLh2B0hJ44Z3IBFkBnZ2cuFZ5jlaZjX3sETqlBeRKmcCeA+F9RmwXW0cwvvYZgcRvgcDH60lk068qOA4sdcgBECiJViLU88f/YRzyYI6Ert8Uw/NqHuwhLxT7c/fSn1z/7DfZTgAEASXQJQXoD7eMAAAAASUVORK5CYII="

/***/ },
/* 3456 */
3455,
/* 3457 */
/***/ function(module, exports) {

	module.exports = "data:image/gif;base64,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"

/***/ },
/* 3458 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var slashes = /^[A-Za-z][A-Za-z0-9+-.]*:\/\//;
	
	/**
	 * These properties should not be copied or inherited from. This is only needed
	 * for all non blob URL's as a blob URL does not include a hash, only the
	 * origin.
	 *
	 * @type {Object}
	 * @private
	 */
	var ignore = { hash: 1, query: 1 }
	  , URL;
	
	/**
	 * The location object differs when your code is loaded through a normal page,
	 * Worker or through a worker using a blob. And with the blobble begins the
	 * trouble as the location object will contain the URL of the blob, not the
	 * location of the page where our code is loaded in. The actual origin is
	 * encoded in the `pathname` so we can thankfully generate a good "default"
	 * location from it so we can generate proper relative URL's again.
	 *
	 * @param {Object|String} loc Optional default location object.
	 * @returns {Object} lolcation object.
	 * @api public
	 */
	module.exports = function lolcation(loc) {
	  loc = loc || global.location || {};
	  URL = URL || __webpack_require__(969);
	
	  var finaldestination = {}
	    , type = typeof loc
	    , key;
	
	  if ('blob:' === loc.protocol) {
	    finaldestination = new URL(unescape(loc.pathname), {});
	  } else if ('string' === type) {
	    finaldestination = new URL(loc, {});
	    for (key in ignore) delete finaldestination[key];
	  } else if ('object' === type) {
	    for (key in loc) {
	      if (key in ignore) continue;
	      finaldestination[key] = loc[key];
	    }
	
	    if (finaldestination.slashes === undefined) {
	      finaldestination.slashes = slashes.test(loc.href);
	    }
	  }
	
	  return finaldestination;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 3459 */,
/* 3460 */,
/* 3461 */,
/* 3462 */,
/* 3463 */,
/* 3464 */,
/* 3465 */,
/* 3466 */,
/* 3467 */,
/* 3468 */,
/* 3469 */,
/* 3470 */,
/* 3471 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/** @license MIT License (c) copyright 2010-2014 original author or authors */
	/** @author Brian Cavalier */
	/** @author John Hann */
	
	(function(define) { 'use strict';
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	
		return function liftAll(liftOne, combine, dst, src) {
			if(typeof combine === 'undefined') {
				combine = defaultCombine;
			}
	
			return Object.keys(src).reduce(function(dst, key) {
				var f = src[key];
				return typeof f === 'function' ? combine(dst, liftOne(f), key) : dst;
			}, typeof dst === 'undefined' ? defaultDst(src) : dst);
		};
	
		function defaultCombine(o, f, k) {
			o[k] = f;
			return o;
		}
	
		function defaultDst(src) {
			return typeof src === 'function' ? src.bind() : Object.create(src);
		}
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}(__webpack_require__(41)));


/***/ },
/* 3472 */,
/* 3473 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/** @license MIT License (c) copyright 2013 original author or authors */
	
	/**
	 * Collection of helpers for interfacing with node-style asynchronous functions
	 * using promises.
	 *
	 * @author Brian Cavalier
	 * @contributor Renato Zannon
	 */
	
	(function(define) {
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function(require) {
	
		var when = __webpack_require__(271);
		var _liftAll = __webpack_require__(3471);
		var setTimer = __webpack_require__(359).setTimer;
		var slice = Array.prototype.slice;
	
		var _apply = __webpack_require__(508)(when.Promise, dispatch);
	
		return {
			lift: lift,
			liftAll: liftAll,
			apply: apply,
			call: call,
			createCallback: createCallback,
			bindCallback: bindCallback,
			liftCallback: liftCallback
		};
	
		/**
		 * Takes a node-style async function and calls it immediately (with an optional
		 * array of arguments or promises for arguments). It returns a promise whose
		 * resolution depends on whether the async functions calls its callback with the
		 * conventional error argument or not.
		 *
		 * With this it becomes possible to leverage existing APIs while still reaping
		 * the benefits of promises.
		 *
		 * @example
		 *    function onlySmallNumbers(n, callback) {
		 *		if(n < 10) {
		 *			callback(null, n + 10);
		 *		} else {
		 *			callback(new Error("Calculation failed"));
		 *		}
		 *	}
		 *
		 *    var nodefn = require("when/node/function");
		 *
		 *    // Logs '15'
		 *    nodefn.apply(onlySmallNumbers, [5]).then(console.log, console.error);
		 *
		 *    // Logs 'Calculation failed'
		 *    nodefn.apply(onlySmallNumbers, [15]).then(console.log, console.error);
		 *
		 * @param {function} f node-style function that will be called
		 * @param {Array} [args] array of arguments to func
		 * @returns {Promise} promise for the value func passes to its callback
		 */
		function apply(f, args) {
			return _apply(f, this, args || []);
		}
	
		function dispatch(f, thisArg, args, h) {
			var cb = createCallback(h);
			try {
				switch(args.length) {
					case 2: f.call(thisArg, args[0], args[1], cb); break;
					case 1: f.call(thisArg, args[0], cb); break;
					case 0: f.call(thisArg, cb); break;
					default:
						args.push(cb);
						f.apply(thisArg, args);
				}
			} catch(e) {
				h.reject(e);
			}
		}
	
		/**
		 * Has the same behavior that {@link apply} has, with the difference that the
		 * arguments to the function are provided individually, while {@link apply} accepts
		 * a single array.
		 *
		 * @example
		 *    function sumSmallNumbers(x, y, callback) {
		 *		var result = x + y;
		 *		if(result < 10) {
		 *			callback(null, result);
		 *		} else {
		 *			callback(new Error("Calculation failed"));
		 *		}
		 *	}
		 *
		 *    // Logs '5'
		 *    nodefn.call(sumSmallNumbers, 2, 3).then(console.log, console.error);
		 *
		 *    // Logs 'Calculation failed'
		 *    nodefn.call(sumSmallNumbers, 5, 10).then(console.log, console.error);
		 *
		 * @param {function} f node-style function that will be called
		 * @param {...*} [args] arguments that will be forwarded to the function
		 * @returns {Promise} promise for the value func passes to its callback
		 */
		function call(f /*, args... */) {
			return _apply(f, this, slice.call(arguments, 1));
		}
	
		/**
		 * Takes a node-style function and returns new function that wraps the
		 * original and, instead of taking a callback, returns a promise. Also, it
		 * knows how to handle promises given as arguments, waiting for their
		 * resolution before executing.
		 *
		 * Upon execution, the orginal function is executed as well. If it passes
		 * a truthy value as the first argument to the callback, it will be
		 * interpreted as an error condition, and the promise will be rejected
		 * with it. Otherwise, the call is considered a resolution, and the promise
		 * is resolved with the callback's second argument.
		 *
		 * @example
		 *    var fs = require("fs"), nodefn = require("when/node/function");
		 *
		 *    var promiseRead = nodefn.lift(fs.readFile);
		 *
		 *    // The promise is resolved with the contents of the file if everything
		 *    // goes ok
		 *    promiseRead('exists.txt').then(console.log, console.error);
		 *
		 *    // And will be rejected if something doesn't work out
		 *    // (e.g. the files does not exist)
		 *    promiseRead('doesnt_exist.txt').then(console.log, console.error);
		 *
		 *
		 * @param {Function} f node-style function to be lifted
		 * @param {...*} [args] arguments to be prepended for the new function @deprecated
		 * @returns {Function} a promise-returning function
		 */
		function lift(f /*, args... */) {
			var args1 = arguments.length > 1 ? slice.call(arguments, 1) : [];
			return function() {
				// TODO: Simplify once partialing has been removed
				var l = args1.length;
				var al = arguments.length;
				var args = new Array(al + l);
				var i;
				for(i=0; i<l; ++i) {
					args[i] = args1[i];
				}
				for(i=0; i<al; ++i) {
					args[i+l] = arguments[i];
				}
				return _apply(f, this, args);
			};
		}
	
		/**
		 * Lift all the functions/methods on src
		 * @param {object|function} src source whose functions will be lifted
		 * @param {function?} combine optional function for customizing the lifting
		 *  process. It is passed dst, the lifted function, and the property name of
		 *  the original function on src.
		 * @param {(object|function)?} dst option destination host onto which to place lifted
		 *  functions. If not provided, liftAll returns a new object.
		 * @returns {*} If dst is provided, returns dst with lifted functions as
		 *  properties.  If dst not provided, returns a new object with lifted functions.
		 */
		function liftAll(src, combine, dst) {
			return _liftAll(lift, combine, dst, src);
		}
	
		/**
		 * Takes an object that responds to the resolver interface, and returns
		 * a function that will resolve or reject it depending on how it is called.
		 *
		 * @example
		 *	function callbackTakingFunction(callback) {
		 *		if(somethingWrongHappened) {
		 *			callback(error);
		 *		} else {
		 *			callback(null, interestingValue);
		 *		}
		 *	}
		 *
		 *	var when = require('when'), nodefn = require('when/node/function');
		 *
		 *	var deferred = when.defer();
		 *	callbackTakingFunction(nodefn.createCallback(deferred.resolver));
		 *
		 *	deferred.promise.then(function(interestingValue) {
		 *		// Use interestingValue
		 *	});
		 *
		 * @param {Resolver} resolver that will be 'attached' to the callback
		 * @returns {Function} a node-style callback function
		 */
		function createCallback(resolver) {
			return function(err, value) {
				if(err) {
					resolver.reject(err);
				} else if(arguments.length > 2) {
					resolver.resolve(slice.call(arguments, 1));
				} else {
					resolver.resolve(value);
				}
			};
		}
	
		/**
		 * Attaches a node-style callback to a promise, ensuring the callback is
		 * called for either fulfillment or rejection. Returns a promise with the same
		 * state as the passed-in promise.
		 *
		 * @example
		 *	var deferred = when.defer();
		 *
		 *	function callback(err, value) {
		 *		// Handle err or use value
		 *	}
		 *
		 *	bindCallback(deferred.promise, callback);
		 *
		 *	deferred.resolve('interesting value');
		 *
		 * @param {Promise} promise The promise to be attached to.
		 * @param {Function} callback The node-style callback to attach.
		 * @returns {Promise} A promise with the same state as the passed-in promise.
		 */
		function bindCallback(promise, callback) {
			promise = when(promise);
	
			if (callback) {
				promise.then(success, wrapped);
			}
	
			return promise;
	
			function success(value) {
				wrapped(null, value);
			}
	
			function wrapped(err, value) {
				setTimer(function () {
					callback(err, value);
				}, 0);
			}
		}
	
		/**
		 * Takes a node-style callback and returns new function that accepts a
		 * promise, calling the original callback when the promise is either
		 * fulfilled or rejected with the appropriate arguments.
		 *
		 * @example
		 *	var deferred = when.defer();
		 *
		 *	function callback(err, value) {
		 *		// Handle err or use value
		 *	}
		 *
		 *	var wrapped = liftCallback(callback);
		 *
		 *	// `wrapped` can now be passed around at will
		 *	wrapped(deferred.promise);
		 *
		 *	deferred.resolve('interesting value');
		 *
		 * @param {Function} callback The node-style callback to wrap.
		 * @returns {Function} The lifted, promise-accepting function.
		 */
		function liftCallback(callback) {
			return function(promise) {
				return bindCallback(promise, callback);
			};
		}
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	})(__webpack_require__(41));
	
	
	


/***/ },
/* 3474 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/** @license MIT License (c) copyright 2011-2013 original author or authors */
	
	/**
	 * sequence.js
	 *
	 * Run a set of task functions in sequence.  All tasks will
	 * receive the same args.
	 *
	 * @author Brian Cavalier
	 * @author John Hann
	 */
	
	(function(define) {
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function(require) {
	
		var when = __webpack_require__(271);
		var all = when.Promise.all;
		var slice = Array.prototype.slice;
	
		/**
		 * Run array of tasks in sequence with no overlap
		 * @param tasks {Array|Promise} array or promiseForArray of task functions
		 * @param [args] {*} arguments to be passed to all tasks
		 * @return {Promise} promise for an array containing
		 * the result of each task in the array position corresponding
		 * to position of the task in the tasks array
		 */
		return function sequence(tasks /*, args... */) {
			var results = [];
	
			return all(slice.call(arguments, 1)).then(function(args) {
				return when.reduce(tasks, function(results, task) {
					return when(task.apply(void 0, args), addResult);
				}, results);
			});
	
			function addResult(result) {
				results.push(result);
				return results;
			}
		};
	
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(__webpack_require__(41));
	
	


/***/ },
/* 3475 */
3479,
/* 3476 */
3479,
/* 3477 */
3479,
/* 3478 */
3479,
/* 3479 */,
/* 3480 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Down = __webpack_require__(__webpack_module_template_argument_0__);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Down).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 3481 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Left = __webpack_require__(__webpack_module_template_argument_0__);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Left).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 3482 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Right = __webpack_require__(__webpack_module_template_argument_0__);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Right).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 3483 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _InterlibraryLoans = __webpack_require__(__webpack_module_template_argument_0__);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_InterlibraryLoans).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 3484 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Search = __webpack_require__(__webpack_module_template_argument_0__);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Search).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 3485 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ShelfListItem = __webpack_require__(__webpack_module_template_argument_0__);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ShelfListItem).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 3486 */,
/* 3487 */,
/* 3488 */,
/* 3489 */,
/* 3490 */,
/* 3491 */,
/* 3492 */,
/* 3493 */,
/* 3494 */,
/* 3495 */,
/* 3496 */,
/* 3497 */,
/* 3498 */,
/* 3499 */,
/* 3500 */,
/* 3501 */,
/* 3502 */,
/* 3503 */,
/* 3504 */,
/* 3505 */,
/* 3506 */,
/* 3507 */,
/* 3508 */,
/* 3509 */,
/* 3510 */,
/* 3511 */,
/* 3512 */,
/* 3513 */,
/* 3514 */,
/* 3515 */,
/* 3516 */,
/* 3517 */,
/* 3518 */,
/* 3519 */,
/* 3520 */,
/* 3521 */,
/* 3522 */,
/* 3523 */,
/* 3524 */,
/* 3525 */,
/* 3526 */,
/* 3527 */,
/* 3528 */,
/* 3529 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	/* jslint esnext: true */
	
	"use strict";
	var src$core$$ = __webpack_require__(__webpack_module_template_argument_0__), src$en$$ = __webpack_require__(__webpack_module_template_argument_1__);
	
	src$core$$["default"].__addLocaleData(src$en$$["default"]);
	src$core$$["default"].defaultLocale = 'en';
	
	exports["default"] = src$core$$["default"];
	
	//# sourceMappingURL=main.js.map

/***/ }
]);


// WEBPACK FOOTER //
// app-4c925301b1528cac482f.js